var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../shared-utils/lib/distinct.js
var require_distinct = __commonJS({
  "../shared-utils/lib/distinct.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WithoutDistinct;
    (function(WithoutDistinct2) {
      function refuelAirplane(amount2) {
      }
      const amount = 5;
      refuelAirplane(amount);
    })(WithoutDistinct || (WithoutDistinct = {}));
    var WithDistinct;
    (function(WithDistinct2) {
      function refuelAirplane(amount2) {
      }
      const amount = 5;
      refuelAirplane(amount);
    })(WithDistinct || (WithDistinct = {}));
  }
});

// ../shared-utils/lib/is.js
var require_is = __commonJS({
  "../shared-utils/lib/is.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isNull = exports.isUndefined = exports.isSymbol = exports.isFunction = exports.isObject = exports.isString = exports.isNumber = exports.isBoolean = exports.isArray = exports.getPrimitiveType = void 0;
    var ARRAY = "Array";
    var OBJECT = "Object";
    var getPrimitiveType = (value) => Object.prototype.toString.call(value).slice(8, -1);
    exports.getPrimitiveType = getPrimitiveType;
    var makeIsPrimitive = (primitive) => (value) => (0, exports.getPrimitiveType)(value) === primitive;
    exports.isArray = makeIsPrimitive(ARRAY);
    var isBoolean2 = (x) => typeof x === "boolean";
    exports.isBoolean = isBoolean2;
    var isNumber3 = (x) => typeof x === "number";
    exports.isNumber = isNumber3;
    var isString2 = (x) => typeof x === "string";
    exports.isString = isString2;
    exports.isObject = makeIsPrimitive(OBJECT);
    var isFunction2 = (x) => typeof x === "function";
    exports.isFunction = isFunction2;
    var isSymbol2 = (x) => typeof x === "symbol";
    exports.isSymbol = isSymbol2;
    var isUndefined47 = (x) => x === void 0;
    exports.isUndefined = isUndefined47;
    var isNull2 = (x) => x === null;
    exports.isNull = isNull2;
  }
});

// ../shared-utils/lib/checkLength.js
var require_checkLength = __commonJS({
  "../shared-utils/lib/checkLength.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.checkLength = checkLength6;
    function checkLength6(n, array, message = "Incorrect array size") {
      if (array.length !== n) {
        throw new Error(`${message} (expected ${n}, got ${array.length})`);
      }
      return array;
    }
  }
});

// ../shared-utils/lib/checkMinLength.js
var require_checkMinLength = __commonJS({
  "../shared-utils/lib/checkMinLength.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.checkMinLength = checkMinLength8;
    function checkMinLength8(n, array, message = "Array size too small") {
      if (array.length < n) {
        throw new Error(`${message} (expected ${n}, got ${array.length})`);
      }
      return array;
    }
  }
});

// ../shared-utils/lib/enumerate.js
var require_enumerate = __commonJS({
  "../shared-utils/lib/enumerate.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.enumerate = enumerate3;
    function* enumerate3(wrap) {
      let i = 0;
      for (const x of wrap) {
        yield [i, x];
        i += 1;
      }
    }
  }
});

// ../shared-utils/lib/hasDefinedValues.js
var require_hasDefinedValues = __commonJS({
  "../shared-utils/lib/hasDefinedValues.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.hasDefinedValues = hasDefinedValues4;
    var is_1 = require_is();
    function hasDefinedValues4(obj) {
      return Object.values(obj).some((v) => !(0, is_1.isUndefined)(v));
    }
  }
});

// ../shared-utils/lib/toTitleCase.js
var require_toTitleCase = __commonJS({
  "../shared-utils/lib/toTitleCase.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.toTitleCase = toTitleCase2;
    function toTitleCase2(str) {
      return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }
  }
});

// ../shared-utils/lib/index.js
var require_lib = __commonJS({
  "../shared-utils/lib/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
          __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.noop = exports.memoize = exports.toPunctuatedPhoneFormat = exports.GDRIVE_REGEX = exports.URL_REGEX = exports.PHONE_REGEX = exports.EMAIL_REGEX = exports.toTitleCase = exports.isUndefined = void 0;
    exports.linJitter = linJitter2;
    exports.clamp = clamp2;
    exports.unreachable = unreachable7;
    exports.populated = populated3;
    exports.isObject = isObject2;
    exports.difference = difference;
    exports.isDefined = isDefined47;
    exports.expected = expected18;
    exports.orNull = orNull;
    exports.orUndefined = orUndefined21;
    exports.applyIfNonEmptyString = applyIfNonEmptyString4;
    exports.isNonEmptyString = isNonEmptyString2;
    exports.makeLookup = makeLookup5;
    require_distinct();
    var is_1 = require_is();
    __exportStar(require_checkLength(), exports);
    __exportStar(require_checkMinLength(), exports);
    __exportStar(require_enumerate(), exports);
    __exportStar(require_hasDefinedValues(), exports);
    var is_2 = require_is();
    Object.defineProperty(exports, "isUndefined", { enumerable: true, get: function() {
      return is_2.isUndefined;
    } });
    var toTitleCase_1 = require_toTitleCase();
    Object.defineProperty(exports, "toTitleCase", { enumerable: true, get: function() {
      return toTitleCase_1.toTitleCase;
    } });
    function linJitter2(low, high) {
      return low + Math.random() * (high - low);
    }
    function clamp2(value, lower, upper) {
      return Math.min(upper !== null && upper !== void 0 ? upper : Infinity, Math.max(value, lower !== null && lower !== void 0 ? lower : -Infinity));
    }
    function unreachable7(x) {
      console.log(x);
      throw new Error(`unexpected: ${x}`);
    }
    function populated3(x) {
      if (x !== null && typeof x === "object") {
        for (const key in x) {
          if (x[key] !== void 0) {
            return true;
          }
        }
      }
      return false;
    }
    function isObject2(x) {
      return typeof x === "object" && x !== null && !Array.isArray(x);
    }
    function difference(setA, setB) {
      const diff = new Set(setA);
      for (const elem of setB) {
        diff.delete(elem);
      }
      return diff;
    }
    function isDefined47(x) {
      return x !== void 0;
    }
    function expected18(x, message = "expected a defined value") {
      if (x === void 0 || x === null) {
        throw new Error(`${message} (got ${x})`);
      }
      return x;
    }
    exports.EMAIL_REGEX = /^[^@]*@.*\..*$/;
    exports.PHONE_REGEX = /^\+1[1-9]\d{1,14}$/;
    exports.URL_REGEX = /^https:\/\/.*$/;
    exports.GDRIVE_REGEX = /https:\/\/drive.google.com\/drive\/.+/;
    var toPunctuatedPhoneFormat2 = (num) => {
      const m = num === null || num === void 0 ? void 0 : num.match(/([0-9]{3})([0-9]{3})([0-9]{4})$/);
      return m ? `(${m[1]}) ${m[2]}-${m[3]}` : num;
    };
    exports.toPunctuatedPhoneFormat = toPunctuatedPhoneFormat2;
    function orNull(f) {
      return (x) => x !== null ? f(x) : null;
    }
    function orUndefined21(f) {
      return (x) => x !== void 0 ? f(x) : void 0;
    }
    function applyIfNonEmptyString4(f) {
      return orUndefined21((x) => x.trim() === "" ? void 0 : f(x));
    }
    function isNonEmptyString2(value) {
      return value !== null && value !== void 0 && value.trim() !== "";
    }
    var memoCache = {};
    var memoize = (callback, deps, uniqueKey) => {
      const depsMatch = deps.every((dep, idx) => {
        var _a;
        return dep === ((_a = memoCache[uniqueKey]) === null || _a === void 0 ? void 0 : _a.deps[idx]);
      }, true);
      if (depsMatch) {
        return memoCache[uniqueKey].value;
      }
      const value = callback();
      memoCache[uniqueKey] = {
        deps,
        value
      };
      return value;
    };
    exports.memoize = memoize;
    function makeLookup5({ cases, default: defaultValue, errorMsg }) {
      const entries = cases.flatMap((x) => {
        const [key, value] = x;
        if ((0, is_1.isArray)(key)) {
          return key.map((x2) => [x2, value]);
        }
        return [x];
      });
      const lookup = Object.fromEntries(entries);
      return (input) => {
        const result = lookup[input];
        if (isDefined47(result))
          return result;
        if (isDefined47(defaultValue))
          return defaultValue;
        if ((0, is_1.isString)(errorMsg)) {
          throw new Error(errorMsg);
        }
        const keys = Object.keys(lookup);
        const inputString = String(input);
        if ((0, is_1.isFunction)(errorMsg)) {
          throw new Error(errorMsg(inputString, keys));
        }
        const keysString = new Intl.ListFormat("en", { type: "disjunction" }).format(keys);
        throw new Error(`Invalid case: ${inputString}.
Expected one of: ${keysString}`);
      };
    }
    var noop2 = () => {
    };
    exports.noop = noop2;
  }
});

// ../shared-utils/lib/lens.js
var require_lens = __commonJS({
  "../shared-utils/lib/lens.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Iso = exports.Lens = void 0;
    exports.identityLens = identityLens;
    exports.propertyLens = propertyLens;
    exports.arrayLens = arrayLens;
    exports.arrayFindLens = arrayFindLens;
    exports.arrayFindDeleteLens = arrayFindDeleteLens;
    var FullLens = class _FullLens {
      /**
       * Constructs a new FullLens from the given getter and setter pair.
       */
      constructor(get, set) {
        this.get = get;
        this.set = set;
      }
      /**
       * Lenses can be concatenated/pipelined/composed/etc, whatever your
       * preferred terminology is. We "zoom in" with the first lens, and then
       * "zoom in" with the second lens. For example, suppose we have a
       * Map<string, Request>. We can concatenate a lens that zooms in on a
       * specific key of this map to a lens that zooms in on a property of Request
       * to get a lens that zooms in on that property within the whole map.
       *
       * This is probably the trickiest code in this whole file. If you understand
       * it, you understand lenses. If you really want to make sure you understand
       * it, delete the code below and see if you can implement it yourself. If
       * working with FullLens is too hard, try using the simpler Lens type first.
       *
       * This is defined as a class method to make it easier to concatenate
       * multiple lenses in a row.
       */
      concat(next) {
        return new _FullLens((s) => next.get(this.get(s)), (s, b) => this.set(s, next.set(this.get(s), b)));
      }
      /**
       * Converts a lens from a container S to an item A into a lens from arrays
       * of containers S to arrays of items A. When setting, the new array MUST be
       * the same length as the old one.
       */
      overArray() {
        return new _FullLens((ss) => ss.map(this.get), (ss, bs) => {
          if (ss.length !== bs.length) {
            const info = `got ${bs.length}, need ${ss.length}`;
            throw new Error(`FullLens.mapped() input wrong length (${info})`);
          }
          return ss.map((s, i) => this.set(s, bs[i]));
        });
      }
      /**
       * Applies a function to transform the value the lens points at.
       */
      map(obj, f) {
        return this.set(obj, f(this.get(obj)));
      }
      /**
       * Adapt this lens to a simplified version of the React useState-style API.
       * Returns a new value and setter callback.
       *
       *     const [house, setHouse] = useState(initHouse);
       *     const [addr, setAddr] = houseAddressLens.adaptReact(house, setHouse);
       */
      adaptReact(state, setState) {
        return [this.get(state), (next) => setState(this.set(state, next))];
      }
    };
    var Lens3 = class extends FullLens {
    };
    exports.Lens = Lens3;
    function identityLens() {
      return new Lens3((t) => t, (_13, t) => t);
    }
    function propertyLens(key) {
      return new Lens3((s) => s[key], (s, a) => Object.assign(Object.assign({}, s), { [key]: a }));
    }
    function arrayLens(...lenses) {
      return new FullLens((s) => lenses.map((lens2) => lens2.get(s)), (input, bs) => {
        if (bs.length != lenses.length) {
          const info = `got ${bs.length}, need ${lenses.length}`;
          throw new Error(`arrayLens().set() input wrong length (${info})`);
        }
        return bs.reduce((s, b, i) => lenses[i].set(s, b), input);
      });
    }
    function arrayFindLens(pred) {
      return new FullLens((s) => s.find(pred), (s, x) => {
        const idx = s.findIndex(pred);
        return idx === -1 ? [...s, x] : [...s.slice(0, idx), x, ...s.slice(idx + 1)];
      });
    }
    function arrayFindDeleteLens(pred) {
      return new Lens3((s) => s.find(pred), (s, x) => {
        if (x === void 0) {
          return s.filter((x2) => !pred(x2));
        }
        const idx = s.findIndex(pred);
        return idx === -1 ? [...s, x] : [...s.slice(0, idx), x, ...s.slice(idx + 1)];
      });
    }
    var Iso2 = class {
      constructor(fwd, inv) {
        this.fwd = fwd;
        this.inv = inv;
      }
      /**
       * Converts this isomorphism into a lens, which is useful for inserting an
       * isomorphism into Lens.concat()
       */
      toLens() {
        return new Lens3(this.fwd, (_13, t) => this.inv(t));
      }
    };
    exports.Iso = Iso2;
  }
});

// ../shared-utils/lib/enum.js
var require_enum = __commonJS({
  "../shared-utils/lib/enum.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AloftEnum = AloftEnum5;
    function AloftEnum5() {
      return (obj) => {
        const keys = Object.keys(obj);
        if (keys.length === 0) {
          throw new Error("AloftEnum requires at least one enum variant");
        }
        return Object.assign(Object.assign({}, obj), { _keys: keys, _values: Object.values(obj), _isKey: (s) => s in obj, _index: (key) => Object.keys(obj).findIndex((currKey) => key === currKey) });
      };
    }
  }
});

// ../../node_modules/fast-json-stable-stringify/index.js
var require_fast_json_stable_stringify = __commonJS({
  "../../node_modules/fast-json-stable-stringify/index.js"(exports, module) {
    "use strict";
    module.exports = function(data, opts) {
      if (!opts)
        opts = {};
      if (typeof opts === "function")
        opts = { cmp: opts };
      var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
      var cmp = opts.cmp && function(f) {
        return function(node) {
          return function(a, b) {
            var aobj = { key: a, value: node[a] };
            var bobj = { key: b, value: node[b] };
            return f(aobj, bobj);
          };
        };
      }(opts.cmp);
      var seen = [];
      return function stringify2(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") {
          node = node.toJSON();
        }
        if (node === void 0)
          return;
        if (typeof node == "number")
          return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object")
          return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
          out = "[";
          for (i = 0; i < node.length; i++) {
            if (i)
              out += ",";
            out += stringify2(node[i]) || "null";
          }
          return out + "]";
        }
        if (node === null)
          return "null";
        if (seen.indexOf(node) !== -1) {
          if (cycles)
            return JSON.stringify("__cycle__");
          throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for (i = 0; i < keys.length; i++) {
          var key = keys[i];
          var value = stringify2(node[key]);
          if (!value)
            continue;
          if (out)
            out += ",";
          out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
      }(data);
    };
  }
});

// ../../node_modules/pluralize/pluralize.js
var require_pluralize = __commonJS({
  "../../node_modules/pluralize/pluralize.js"(exports, module) {
    (function(root, pluralize2) {
      if (typeof __require === "function" && typeof exports === "object" && typeof module === "object") {
        module.exports = pluralize2();
      } else if (typeof define === "function" && define.amd) {
        define(function() {
          return pluralize2();
        });
      } else {
        root.pluralize = pluralize2();
      }
    })(exports, function() {
      var pluralRules = [];
      var singularRules = [];
      var uncountables = {};
      var irregularPlurals = {};
      var irregularSingles = {};
      function sanitizeRule(rule) {
        if (typeof rule === "string") {
          return new RegExp("^" + rule + "$", "i");
        }
        return rule;
      }
      function restoreCase(word, token) {
        if (word === token)
          return token;
        if (word === word.toLowerCase())
          return token.toLowerCase();
        if (word === word.toUpperCase())
          return token.toUpperCase();
        if (word[0] === word[0].toUpperCase()) {
          return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        }
        return token.toLowerCase();
      }
      function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function(match, index) {
          return args[index] || "";
        });
      }
      function replace(word, rule) {
        return word.replace(rule[0], function(match, index) {
          var result = interpolate(rule[1], arguments);
          if (match === "") {
            return restoreCase(word[index - 1], result);
          }
          return restoreCase(match, result);
        });
      }
      function sanitizeWord(token, word, rules) {
        if (!token.length || uncountables.hasOwnProperty(token)) {
          return word;
        }
        var len = rules.length;
        while (len--) {
          var rule = rules[len];
          if (rule[0].test(word))
            return replace(word, rule);
        }
        return word;
      }
      function replaceWord(replaceMap, keepMap, rules) {
        return function(word) {
          var token = word.toLowerCase();
          if (keepMap.hasOwnProperty(token)) {
            return restoreCase(word, token);
          }
          if (replaceMap.hasOwnProperty(token)) {
            return restoreCase(word, replaceMap[token]);
          }
          return sanitizeWord(token, word, rules);
        };
      }
      function checkWord(replaceMap, keepMap, rules, bool) {
        return function(word) {
          var token = word.toLowerCase();
          if (keepMap.hasOwnProperty(token))
            return true;
          if (replaceMap.hasOwnProperty(token))
            return false;
          return sanitizeWord(token, token, rules) === token;
        };
      }
      function pluralize2(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize2.singular(word) : pluralize2.plural(word);
        return (inclusive ? count + " " : "") + pluralized;
      }
      pluralize2.plural = replaceWord(
        irregularSingles,
        irregularPlurals,
        pluralRules
      );
      pluralize2.isPlural = checkWord(
        irregularSingles,
        irregularPlurals,
        pluralRules
      );
      pluralize2.singular = replaceWord(
        irregularPlurals,
        irregularSingles,
        singularRules
      );
      pluralize2.isSingular = checkWord(
        irregularPlurals,
        irregularSingles,
        singularRules
      );
      pluralize2.addPluralRule = function(rule, replacement) {
        pluralRules.push([sanitizeRule(rule), replacement]);
      };
      pluralize2.addSingularRule = function(rule, replacement) {
        singularRules.push([sanitizeRule(rule), replacement]);
      };
      pluralize2.addUncountableRule = function(word) {
        if (typeof word === "string") {
          uncountables[word.toLowerCase()] = true;
          return;
        }
        pluralize2.addPluralRule(word, "$0");
        pluralize2.addSingularRule(word, "$0");
      };
      pluralize2.addIrregularRule = function(single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
      };
      [
        // Pronouns.
        ["I", "we"],
        ["me", "us"],
        ["he", "they"],
        ["she", "they"],
        ["them", "them"],
        ["myself", "ourselves"],
        ["yourself", "yourselves"],
        ["itself", "themselves"],
        ["herself", "themselves"],
        ["himself", "themselves"],
        ["themself", "themselves"],
        ["is", "are"],
        ["was", "were"],
        ["has", "have"],
        ["this", "these"],
        ["that", "those"],
        // Words ending in with a consonant and `o`.
        ["echo", "echoes"],
        ["dingo", "dingoes"],
        ["volcano", "volcanoes"],
        ["tornado", "tornadoes"],
        ["torpedo", "torpedoes"],
        // Ends with `us`.
        ["genus", "genera"],
        ["viscus", "viscera"],
        // Ends with `ma`.
        ["stigma", "stigmata"],
        ["stoma", "stomata"],
        ["dogma", "dogmata"],
        ["lemma", "lemmata"],
        ["schema", "schemata"],
        ["anathema", "anathemata"],
        // Other irregular rules.
        ["ox", "oxen"],
        ["axe", "axes"],
        ["die", "dice"],
        ["yes", "yeses"],
        ["foot", "feet"],
        ["eave", "eaves"],
        ["goose", "geese"],
        ["tooth", "teeth"],
        ["quiz", "quizzes"],
        ["human", "humans"],
        ["proof", "proofs"],
        ["carve", "carves"],
        ["valve", "valves"],
        ["looey", "looies"],
        ["thief", "thieves"],
        ["groove", "grooves"],
        ["pickaxe", "pickaxes"],
        ["passerby", "passersby"]
      ].forEach(function(rule) {
        return pluralize2.addIrregularRule(rule[0], rule[1]);
      });
      [
        [/s?$/i, "s"],
        [/[^\u0000-\u007F]$/i, "$0"],
        [/([^aeiou]ese)$/i, "$1"],
        [/(ax|test)is$/i, "$1es"],
        [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
        [/(e[mn]u)s?$/i, "$1s"],
        [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
        [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
        [/(seraph|cherub)(?:im)?$/i, "$1im"],
        [/(her|at|gr)o$/i, "$1oes"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
        [/sis$/i, "ses"],
        [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
        [/([^aeiouy]|qu)y$/i, "$1ies"],
        [/([^ch][ieo][ln])ey$/i, "$1ies"],
        [/(x|ch|ss|sh|zz)$/i, "$1es"],
        [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
        [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
        [/(pe)(?:rson|ople)$/i, "$1ople"],
        [/(child)(?:ren)?$/i, "$1ren"],
        [/eaux$/i, "$0"],
        [/m[ae]n$/i, "men"],
        ["thou", "you"]
      ].forEach(function(rule) {
        return pluralize2.addPluralRule(rule[0], rule[1]);
      });
      [
        [/s$/i, ""],
        [/(ss)$/i, "$1"],
        [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
        [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
        [/ies$/i, "y"],
        [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
        [/\b(mon|smil)ies$/i, "$1ey"],
        [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
        [/(seraph|cherub)im$/i, "$1"],
        [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
        [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
        [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
        [/(test)(?:is|es)$/i, "$1is"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
        [/(alumn|alg|vertebr)ae$/i, "$1a"],
        [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
        [/(matr|append)ices$/i, "$1ix"],
        [/(pe)(rson|ople)$/i, "$1rson"],
        [/(child)ren$/i, "$1"],
        [/(eau)x?$/i, "$1"],
        [/men$/i, "man"]
      ].forEach(function(rule) {
        return pluralize2.addSingularRule(rule[0], rule[1]);
      });
      [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        // "chinese", "japanese"
        /deer$/i,
        // "deer", "reindeer"
        /fish$/i,
        // "fish", "blowfish", "angelfish"
        /measles$/i,
        /o[iu]s$/i,
        // "carnivorous"
        /pox$/i,
        // "chickpox", "smallpox"
        /sheep$/i
      ].forEach(pluralize2.addUncountableRule);
      return pluralize2;
    });
  }
});

// src/index.ts
var import_shared_utils118 = __toESM(require_lib(), 1);
var import_is4 = __toESM(require_is(), 1);
var lens = __toESM(require_lens(), 1);
import {
  AloftArea as AloftArea42,
  AloftCount as AloftCount14,
  AloftDate as AloftDate23,
  AloftObject,
  AloftPrice as AloftPrice70,
  AloftTime as AloftTime8
} from "@aloft/shared-objects";

// src/blob/index.ts
import { z } from "zod";

// src/AloftToolkitBlob.ts
var AloftToolkitBlob_exports = {};
__export(AloftToolkitBlob_exports, {
  BLOB_ID_REGEX: () => BLOB_ID_REGEX,
  equals: () => equals,
  fromMetadata: () => fromMetadata,
  getExtension: () => getExtension
});
var import_shared_utils = __toESM(require_lib(), 1);
var BLOB_ID_REGEX = /b-[0-9a-f]{40}/;
function fromMetadata(id, md) {
  return {
    $type: "AloftToolkitBlob",
    id,
    type: md.type,
    name: md.name,
    size: md.size,
    createdAt: md.createdAt,
    createdBy: md.createdBy,
    annotation: md.annotation
  };
}
function equals(a, b) {
  return a.id === b.id;
}
function getExtension(blob) {
  const parts = blob.name?.split(".") ?? [];
  return parts.length >= 2 ? (0, import_shared_utils.expected)(parts[parts.length - 1]).toLowerCase() : void 0;
}

// src/blob/index.ts
var schBlobID = z.string().regex(BLOB_ID_REGEX).brand("BlobID");
var schBlobRef = z.object({
  blobID: schBlobID,
  filename: z.string()
});
function isBlobID(id) {
  return BLOB_ID_REGEX.test(id);
}
function parseBlobID(id, errorMsg) {
  if (isBlobID(id)) {
    return id;
  } else {
    throw new Error(errorMsg ?? `not a valid blob ID: ${id}`);
  }
}
function blobIDToHash(id) {
  return parseBlobID(id).substring(2).toLowerCase();
}
function hashToBlobID(hash) {
  return parseBlobID(`b-${hash.toLowerCase()}`);
}

// src/AloftToolkitAccount.ts
var AloftToolkitAccount_exports = {};
__export(AloftToolkitAccount_exports, {
  equals: () => equals2,
  fromToolkitAccountID: () => fromToolkitAccountID,
  schAloftToolkitAccount: () => schAloftToolkitAccount,
  toToolkitAccountID: () => toToolkitAccountID
});
import _ from "lodash";
import { z as z3 } from "zod";

// src/types.ts
import { z as z2 } from "zod";
var schToolkitAccountID = z2.string();
var schToolkitOrderID = z2.string();
var schToolkitStudyID = z2.string();
var schLicenseID = z2.string();
var schPagination = z2.object({
  self: z2.string().optional(),
  next: z2.string().optional(),
  limit: z2.number().optional(),
  totalCount: z2.number().optional(),
  numResults: z2.number().optional()
});

// src/AloftToolkitAccount.ts
var schContents = z3.object({
  id: schToolkitAccountID
});
var schAloftToolkitAccount = z3.strictObject({
  $type: z3.literal("AloftToolkitAccount")
}).and(schContents);
var equals2 = _.isEqual;
var fromToolkitAccountID = (id) => ({
  $type: "AloftToolkitAccount",
  id
});
var toToolkitAccountID = (aloftToolkitAccount) => aloftToolkitAccount.id;

// src/api/toolkitSchemas.ts
var toolkitSchemas_exports = {};

// src/AloftEnum.ts
var import_enum = __toESM(require_enum(), 1);

// src/FormType.ts
var FormType = /* @__PURE__ */ ((FormType2) => {
  FormType2["fnma1004"] = "fnma-1004";
  FormType2["fnma1004c"] = "fnma-1004c";
  FormType2["fnma1025"] = "fnma-1025";
  FormType2["fnma2055"] = "fnma-2055";
  FormType2["gpResidential"] = "gp-residential";
  return FormType2;
})(FormType || {});

// src/address/types.ts
import { z as z5 } from "zod";

// src/propertydata/propertyIdentification.ts
import { schAloftPriceJSON } from "@aloft/shared-objects";
import { z as z4 } from "zod";
var schFilledAddress = z4.strictObject({
  AddressLineText: z4.string(),
  CityName: z4.string(),
  PostalCode: z4.string(),
  StateCode: z4.string(),
  unitNumber: z4.string().optional(),
  CountyName: z4.string().optional()
});
var schLatitudeLongitude = z4.object({
  latitude: z4.number(),
  longitude: z4.number()
});
var schHoaFeeFrequency = z4.enum([
  "Weekly",
  "Bi-Monthly",
  "Monthly",
  "Quarterly",
  "Semi-Annually",
  "Annually"
]);
var schZoningCompliance = z4.enum(["Legal", "Illegal", "Legal Nonconforming", "No Zoning"]);
var schPropertyInterest = z4.enum(["Fee Simple", "Leased Fee", "Leasehold", "Other"]);
var schPropertyIdentification = z4.object({
  address: schFilledAddress,
  coordinates: schLatitudeLongitude.optional(),
  zoning: z4.string().optional(),
  zoningCompliance: schZoningCompliance.optional(),
  legalDescription: z4.string().optional(),
  hoa: z4.string().optional(),
  hoaFeeAmount: schAloftPriceJSON.optional(),
  hoaFeeFrequency: schHoaFeeFrequency.optional(),
  parcelNumber: z4.string().optional(),
  pud: z4.boolean().optional(),
  propertyInterest: schPropertyInterest.optional(),
  propertyInterestOther: z4.string().optional()
});

// src/address/types.ts
var schAddress = schFilledAddress.partial();
var makeSchRequiredString = (fieldName) => z5.string().default("").transform((val) => val.trim()).pipe(z5.string().min(1, { message: `${fieldName} is required.` }));
var schAddressForm = z5.object({
  AddressLineText: makeSchRequiredString("Address"),
  CityName: makeSchRequiredString("City"),
  PostalCode: makeSchRequiredString("Zip"),
  StateCode: makeSchRequiredString("State"),
  unitNumber: z5.string().optional()
});

// src/address/addressToMultilineAddress.ts
function addressToMultilineAddress(address) {
  const unitSuffix = address?.unitNumber ? ` ${address.unitNumber}` : "";
  const firstLine = address?.AddressLineText ?? "Unknown Street Number and Name";
  const secondLine = `${address?.CityName ?? "Unknown City Name"}, ${address?.StateCode ?? "Unknown State"} ${address?.PostalCode ?? "Unknown Zip Code"}`;
  return [firstLine + unitSuffix, secondLine];
}

// src/address/addressToString.ts
var addressToString = (address) => addressToMultilineAddress(address).join(" ");

// src/address/stringToAddress.ts
var import_shared_utils2 = __toESM(require_lib(), 1);
function stringToAddress(addressString) {
  try {
    const parts = addressString.split(",").map((part) => part.trim()).filter((part) => part);
    switch (parts.length) {
      case 3:
        return shortArrayToAddress(parts);
      case 4:
        const hasExtraComma = parts[parts.length - 1]?.split(" ").length !== 1;
        if (hasExtraComma)
          return arrayToAddress(parts, true);
        else
          return arrayToAddress(parts);
      case 5:
        return arrayToExtendedAddress(parts);
      default:
        throw new Error("Unexpected address format");
    }
  } catch (ex) {
    throw new Error(`could not translate string address to Address: ${addressString}, ${ex}`);
  }
}
var shortArrayToAddress = (array) => {
  const [AddressLineText, CityName, field2] = (0, import_shared_utils2.checkMinLength)(3, array);
  const [StateCode, PostalCode] = field2.split(" ");
  if (StateCode.length > 2) {
    throw new Error("Unexpected address format");
  }
  return {
    AddressLineText,
    CityName,
    StateCode,
    PostalCode
  };
};
var arrayToAddress = (array, extraComma = false) => {
  const [field0, field1, field2, field3] = (0, import_shared_utils2.checkMinLength)(4, array);
  if (extraComma) {
    const [StateCode, PostalCode] = (0, import_shared_utils2.checkLength)(2, field3.split(" "));
    return {
      AddressLineText: `${field0} ${field1}`,
      CityName: field2,
      StateCode,
      PostalCode
    };
  }
  if (field2.length > 2) {
    throw new Error("Unexpected address format");
  }
  return {
    AddressLineText: field0,
    CityName: field1,
    StateCode: field2,
    PostalCode: field3
  };
};
var arrayToExtendedAddress = (array) => {
  const [streetAddress, extendedAddress, CityName, StateCode, PostalCode] = (0, import_shared_utils2.checkMinLength)(
    5,
    array
  );
  if (StateCode.length > 2) {
    throw new Error("Unexpected address format");
  }
  return {
    AddressLineText: `${streetAddress} ${extendedAddress}`.trim(),
    CityName,
    StateCode,
    PostalCode
  };
};

// src/adjust/AdjustmentDocument.ts
import { z as z23 } from "zod";

// src/toolkitProperty/ToolkitProperty.ts
import { z as z7 } from "zod";

// src/zod.ts
import { AloftArea, AloftCount, AloftDate, AloftPrice, AloftTime } from "@aloft/shared-objects";
import { z as z6 } from "zod";
var schAloftDate = AloftDate.schema;
var schAloftTime = AloftTime.schema;
var schAloftArea = AloftArea.schema;
var schAloftPrice = AloftPrice.schema;
var schAloftCount = AloftCount.schema;
var schFormNumberStringOnly = z6.string().transform((val, ctx) => {
  const parsed = +val.replace(/,/g, "").replace(/—|−/g, "-");
  if (Number.isNaN(parsed)) {
    ctx.addIssue({
      code: z6.ZodIssueCode.custom,
      message: "Not a number"
    });
    return z6.NEVER;
  }
  return parsed;
});
var schFormNumber = z6.union([z6.number(), schFormNumberStringOnly]);
var schEmptyString = z6.literal("");
var usPhoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
var schUSPhoneNumber = z6.string().regex(usPhoneRegex, "Invalid US phone number");
var schZipCode = z6.string().refine(
  (zipCode) => (
    // US zip codes are 5 digits or 9 digits with a hyphen in the middle
    /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode)
  ),
  {
    message: "Invalid US zip code"
  }
);
var schPositiveInt = schFormNumber.refine((val) => val % 1 === 0, "Not a whole number").refine((val) => val >= 0, "Not a positive number").brand("PositiveInt");
var schToolkitPropertyEnum = z6.string();
function zodLaunder(sch) {
  return z6.any().transform((arg, ctx) => {
    const res = sch.safeParse(arg);
    if (res.success)
      return res.data;
    for (const issue of res.error.issues) {
      ctx.addIssue(issue);
    }
    return z6.NEVER;
  });
}

// src/toolkitProperty/ToolkitProperty.ts
var schToolkitPropertyDynamicField = z7.discriminatedUnion("t", [
  z7.object({ t: z7.literal("string"), v: z7.string() }),
  z7.object({ t: z7.literal("boolean"), v: z7.boolean() }),
  z7.object({ t: z7.literal("number"), v: z7.number() }),
  z7.object({ t: z7.literal("enum"), v: schToolkitPropertyEnum }),
  z7.object({ t: z7.literal("price"), v: schAloftPrice }),
  z7.object({ t: z7.literal("date"), v: schAloftDate }),
  z7.object({ t: z7.literal("count"), v: schAloftCount }),
  z7.object({ t: z7.literal("area"), v: schAloftArea })
]);

// src/toolkitProperty/types.ts
import { z as z14 } from "zod";

// src/toolkitListingID/types.ts
import { z as z8 } from "zod";
var schToolkitListingID = z8.string().brand("ToolkitListingID");

// src/mls/MLS.ts
var import_enum2 = __toESM(require_enum(), 1);
import { z as z9 } from "zod";

// src/timezone.ts
import getTimezoneOffset from "date-fns-tz/getTimezoneOffset";
var TimeZone;
((TimeZone2) => {
  let TimeZones;
  ((TimeZones2) => {
    TimeZones2["US_PACIFIC"] = "America/Los_Angeles";
    TimeZones2["US_EASTERN"] = "America/New_York";
    TimeZones2["US_CENTRAL"] = "America/Chicago";
    TimeZones2["US_MOUNTAIN"] = "America/Denver";
    TimeZones2["US_PHOENIX"] = "America/Phoenix";
    TimeZones2["UTC"] = "Etc/UTC";
  })(TimeZones = TimeZone2.TimeZones || (TimeZone2.TimeZones = {}));
  TimeZone2.differenceInMinutes = (a, b, at = /* @__PURE__ */ new Date()) => (getTimezoneOffset(a, at) - getTimezoneOffset(b, at)) / 6e4;
})(TimeZone || (TimeZone = {}));

// src/mls/MLS.ts
var MLS = (0, import_enum2.AloftEnum)()({
  northwestmls: {
    resoID: "M00000650",
    constellation1ID: "NorthwestMLS",
    shortName: "NWMLS",
    longName: "Northwest Multiple Listing Service",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_PACIFIC,
    abodeMLSName: "Northwest MLS"
  },
  mlspin: {
    resoID: "M00000306",
    constellation1ID: "MLSPIN",
    shortName: "MLS PIN",
    longName: "Massachusetts MLS Property Information Network",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "MLS Property Information Network"
  },
  armls: {
    resoID: "M00000048",
    constellation1ID: "ArizonaRegional",
    shortName: "ARMLS",
    longName: "Arizona Regional Multiple Listing Service (ARMLS)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Arizona Regional MLS"
  },
  houston: {
    resoID: "M00000599",
    constellation1ID: "Houston",
    shortName: "HAR",
    longName: "Houston Association of Realtors",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Houston Association of Realtors MLS"
  },
  lasvegas: {
    resoID: "M00000466",
    constellation1ID: "LasVegas",
    shortName: "LVR",
    longName: "Las Vegas Realtors",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_PACIFIC,
    abodeMLSName: "Greater Las Vegas Association of Realtors"
  },
  sef: {
    resoID: "M00000151",
    constellation1ID: "SEF",
    shortName: "Miami Realtors MLS",
    longName: "Miami Realtors MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Miami Association of Realtors"
  },
  mlsnow: {
    resoID: "M00000830",
    constellation1ID: "MLSNow",
    shortName: "MLS Now",
    longName: "MLS Now",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "MLS Now (YES MLS)"
  },
  onekey: {
    resoID: "M00000489",
    constellation1ID: "OneKey",
    shortName: "OneKey",
    longName: "OneKey MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "One Key MLS"
  },
  stellarmls: {
    resoID: "M00000146",
    constellation1ID: "StellarMLS",
    shortName: "Stellar MLS",
    longName: "Stellar MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Stellar MLS"
  },
  crmls: {
    resoID: "M00000093",
    constellation1ID: "CRMLS",
    shortName: "CRMLS",
    longName: "California Regional Multiple Listing Service (CRMLS)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_PACIFIC,
    abodeMLSName: "California Regional Multiple Listing Service"
  },
  trianglemls: {
    resoID: "M00000389",
    constellation1ID: "TriangleMLS",
    shortName: "Triangle MLS",
    longName: "Triangle MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Triangle MLS"
  },
  canopymls: {
    resoID: "M00000391",
    constellation1ID: "CanopyMLS",
    shortName: "Canopy MLS",
    longName: "Canopy MLS (Canopy Realtor Association)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Canopy MLS"
  },
  recolorado: {
    resoID: "M00000116",
    constellation1ID: "REColorado",
    shortName: "REcolorado",
    longName: "REcolorado",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_MOUNTAIN,
    abodeMLSName: "REcolorado"
  },
  sanantonio: {
    resoID: "M00000616",
    constellation1ID: "SanAntonio",
    shortName: "SanAntonio",
    longName: "San Antonio Board of REALTORS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "San Antonio Board of Realtors"
  },
  mlsok: {
    resoID: "M00000519",
    constellation1ID: "MLSOK",
    shortName: "MLSOK",
    longName: "MLSOK",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS of Oklahoma"
  },
  centraltexas: {
    resoID: "M00000610",
    constellation1ID: "CentralTexas",
    shortName: "CTXMLS",
    longName: "Central Texas MLS (CTXMLS)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Central Texas MLS (Four River AOR)"
  },
  georgiamls: {
    resoID: "M00000188",
    constellation1ID: "GeorgiaMLS",
    shortName: "Georgia MLS",
    longName: "Georgia MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Georgia MLS"
  },
  nabor: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "NABOR",
    longName: "Naples Area Board of REALTORS",
    isActive: false
  },
  swmric: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "SWMRIC",
    longName: "Southwestern Michigan Association of REALTORS",
    isActive: false
  },
  rebny: {
    resoID: "T00000046",
    constellation1ID: "REBNY",
    shortName: "REBNY",
    longName: "Real Estate Board of New York (REBNY)",
    isActive: false,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Real Estate Board of NEW York 620A"
  },
  realtracs: {
    resoID: "M00000574",
    constellation1ID: "Realtracs",
    shortName: "Realtracs",
    longName: "Realtracs",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Middle Tennessee MLS - REALTRACS"
  },
  gsrein: {
    resoID: "M00000065",
    constellation1ID: "GSREIN",
    shortName: "GSREIN",
    longName: "Gulf South Real Estate Information Network",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Gulf South Real Estate Information Network (NEW Orleans)"
  },
  realmls: {
    resoID: "M00000141",
    constellation1ID: "RealMLS",
    shortName: "RealMLS",
    longName: "realMLS (Northeast Florida Multiple Listing Service)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Northeast Florida/Jacksonville"
  },
  irmls: {
    resoID: "M00000256",
    constellation1ID: "IRMLS",
    shortName: "IRMLS",
    longName: "Indiana Regional MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Indiana Regional MLS"
  },
  mlstechnology: {
    resoID: "M00000521",
    constellation1ID: "MLSTechnology",
    shortName: "MLS Technology",
    longName: "MLS Technology",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS Technology (Tulsa MLS)"
  },
  knoxville: {
    resoID: "M00000582",
    constellation1ID: "Knoxville",
    shortName: "Knoxville",
    longName: "Knoxville Area Association of REALTORS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Knoxville Area Association of Realtors"
  },
  mred: {
    resoID: "M00000243",
    constellation1ID: "MRED",
    shortName: "MRED",
    longName: "Midwest Real Estate Data (MRED)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Midwest Real Estate Data"
  },
  brightmls: {
    resoID: "M00000309",
    constellation1ID: "BrightMLS",
    shortName: "Bright MLS",
    longName: "Bright MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Bright MLS"
  },
  northcarolinaregional: {
    resoID: "M00000722",
    constellation1ID: "NorthCarolinaRegional",
    shortName: "NorthCarolinaRegional",
    longName: "North Carolina Regional MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "North Carolina Regional MLS"
  },
  austin: {
    resoID: "M00000589",
    constellation1ID: "Austin",
    shortName: "ACTRIS",
    longName: "Austin Central Texas Realty Information Service (ACTRIS)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Austin Board of Realtors"
  },
  metrolist: {
    resoID: "M00000091",
    constellation1ID: "Metrolist",
    shortName: "MetroList",
    longName: "MetroList",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_PACIFIC,
    abodeMLSName: "MetroList - Sacramento"
  },
  mlsunited: {
    resoID: "M00000070",
    constellation1ID: "MLSUnited",
    shortName: "MLS United",
    longName: "MLS United",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS United"
  },
  fmls: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "FMLS",
    longName: "First Multiple Listing Service",
    isActive: false
  },
  heartlandmls: {
    resoID: "M00000270",
    constellation1ID: "HeartlandMLS",
    shortName: "Heartland MLS",
    longName: "Heartland MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Heartland MLS"
  },
  gardenstatemls: {
    resoID: "M00000449",
    constellation1ID: "GardenStateMLS",
    shortName: "Garden State MLS",
    longName: "Garden State MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Garden State MLS"
  },
  ntreis: {
    resoID: "M00000594",
    constellation1ID: "NTREIS",
    shortName: "NTREIS",
    longName: "North Texas Real Estate Information Systems (NTREIS)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "North Texas Real Estate Information System"
  },
  mibor: {
    resoID: "M00000255",
    constellation1ID: "MIBOR",
    shortName: "MIBOR",
    longName: "MIBOR Broker Listing Cooperative",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Metropolitan Indiana Board of Realtors"
  },
  palmbeachfl: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "PalmBeachFL",
    longName: "Palm Beach Board of REALTORS",
    isActive: false
  },
  portlandor: {
    resoID: "M00000531",
    constellation1ID: "PortlandOR",
    shortName: "RMLS",
    longName: "Regional Multiple Listing Service (RMLS)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_PACIFIC,
    abodeMLSName: "Regional MLS of Oregon"
  },
  maris: {
    resoID: "M00000360",
    constellation1ID: "MARIS",
    shortName: "MARIS MLS",
    longName: "MARIS MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Mid America Regional Information System"
  },
  northstarmls: {
    resoID: "M00000345",
    constellation1ID: "NorthStarMLS",
    shortName: "NorthstarMLS",
    longName: "NorthstarMLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Northstar MLS"
  },
  westpenn: {
    resoID: "M00000549",
    constellation1ID: "WestPenn",
    shortName: "West Penn MultiList",
    longName: "West Penn MultiList",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "West Penn Multi List"
  },
  smartmls: {
    resoID: "M00000127",
    constellation1ID: "SmartMLS",
    shortName: "SmartMLS",
    longName: "SmartMLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "SMART MLS"
  },
  claw: {
    resoID: "M00000071",
    constellation1ID: "CLAW",
    shortName: "The MLS",
    longName: "The MLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_PACIFIC,
    abodeMLSName: "Combined L.A./Westside MLS, Inc."
  },
  beachesmls: {
    resoID: "M00000170",
    constellation1ID: "Beaches",
    shortName: "BeachesMLS",
    longName: "BeachesMLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Beaches MLS- FLEX MLS"
  },
  wasatch_front_regional_mls_utahrealestatecom: {
    resoID: "M00000628",
    constellation1ID: "UtahRealEstate",
    shortName: "UtahRealEstatecom",
    longName: "UtahRealEstatecom",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wasatch Front Regional MLS (UtahRealEstate.com)"
  },
  utahrealestate: {
    resoID: "M00000628",
    constellation1ID: "UtahRealEstate",
    shortName: "UtahRealEstatecom",
    longName: "UtahRealEstatecom",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wasatch Front Regional MLS (UtahRealEstate.com)"
  },
  realcomp: {
    resoID: "M00000316",
    constellation1ID: "Realcomp",
    shortName: "Realcom",
    longName: "Realcomp",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Realcomp MLS"
  },
  bridgemls: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "bridgeMLS",
    longName: "bridgeMLS",
    isActive: false
  },
  neren: {
    resoID: "M00000445",
    constellation1ID: "NEREN",
    shortName: "PrimeMLS",
    longName: "PrimeMLS",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "New England Real Estate Network"
  },
  brevard_county_mls: {
    resoID: "M00000150",
    constellation1ID: "BrevardMLS",
    longName: "Brevard County MLS (Melborne/Space Coast)",
    shortName: "Brevard County MLS (Melborne/Space Coast)",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Space Coast Association of Realtors MLS"
  },
  rmlsa: {
    resoID: "M00000852",
    constellation1ID: "RMLSA",
    longName: "RMLS Alliance (IL)",
    shortName: "RMLSA",
    isActive: true,
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "RMLS Alliance (Peoria Area Association of Reatlors)"
  },
  wyoming_mls: {
    isActive: true,
    resoID: "M00000679",
    constellation1ID: "WyomingMLS",
    longName: "Wyoming MLS",
    shortName: "Wyoming MLS",
    timeZone: TimeZone.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wyoming MLS"
  },
  florida_gulf_coast_mls: {
    isActive: true,
    resoID: "M00000130",
    constellation1ID: "FGCMLS",
    longName: "Florida Gulf Coast MLS",
    shortName: "Florida Gulf Coast MLS",
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "SWFL MLS/Florida Gulf Coast MLS (Royal Palm Coast AOR)"
  },
  des_moines: {
    isActive: true,
    resoID: "M00000204",
    constellation1ID: "DesMoines",
    longName: "Des Moines Area Association of REALTORS",
    shortName: "Des Moines",
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "Des Moines Area Association of Reatlors MLS"
  },
  centralpanhandle: {
    isActive: true,
    resoID: "M00000159",
    constellation1ID: "CentralPanhandle",
    longName: "Central Panhandle Association of REALTORS",
    shortName: "Central Panhandle",
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Central Panhandle AOR"
  },
  oklahoma_city_metropolitan_board_of_realtors_mlsok: {
    isActive: true,
    resoID: "M00000519",
    constellation1ID: "MLSOK",
    longName: "Oklahoma City Metropolitan Board of Realtors / MLSOK",
    shortName: "Oklahoma City Metropolitan Board of Realtors / MLSOK",
    timeZone: TimeZone.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS of Oklahoma"
  },
  emerald_coast_association_of_realtors: {
    isActive: true,
    resoID: "M00000138",
    constellation1ID: "EmeraldCoast",
    longName: "Emerald Coast Association of Realtors",
    shortName: "Emerald Coast Association of Realtors",
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Emerald Coast"
  },
  lexington_bluegrass_association_of_realtors: {
    isActive: true,
    resoID: "M00000288",
    constellation1ID: "LexingtonKY",
    longName: "Lexington Bluegrass Association of Realtors",
    shortName: "Lexington Bluegrass Association of Realtors",
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Lexington-Bluegrass Association of Realtors"
  },
  triad_multiple_listing_service: {
    isActive: true,
    resoID: "M00000400",
    constellation1ID: "TriadMLS",
    longName: "Triad Multiple Listing Service",
    shortName: "Triad Multiple Listing Service",
    timeZone: TimeZone.TimeZones.US_EASTERN,
    abodeMLSName: "Triad MLS"
  },
  tucson_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tucson Association of Realtors",
    shortName: "Tucson Association of Realtors"
  },
  tulare_county_association_of_realtors: {
    isActive: true,
    resoID: "M00000104",
    constellation1ID: void 0,
    longName: "Tulare County Association of Realtors",
    shortName: "Tulare County Association of Realtors",
    abodeMLSName: "Tulare County Association of Realtors MLS"
  },
  tuolumne_county_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tuolumne County Association of Realtors",
    shortName: "Tuolumne County Association of Realtors"
  },
  tuscaloosa: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tuscaloosa",
    shortName: "Tuscaloosa"
  },
  ulster_county_board_of_realtors: {
    isActive: true,
    resoID: "M00000479",
    constellation1ID: void 0,
    longName: "Ulster County Board of Realtors",
    shortName: "Ulster County Board of Realtors",
    abodeMLSName: "Hudson Valley Catskill Region MLS (Ulster County Board of Realtors)"
  },
  upper_peninsula_association_of_realtors: {
    isActive: true,
    resoID: "M00000324",
    constellation1ID: void 0,
    longName: "Upper Peninsula Association of REALTORS",
    shortName: "Upper Peninsula Association of REALTORS",
    abodeMLSName: "Upper Peninsula Association of Realtors"
  },
  upstate_new_york_real_estate_information_services: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Upstate New York Real Estate Information Services (UNYREIS)",
    shortName: "Upstate New York Real Estate Information Services (UNYREIS)"
  },
  vail_board_of_realtors: {
    isActive: true,
    resoID: "M00000114",
    constellation1ID: void 0,
    longName: "Vail Board of Realtors",
    shortName: "Vail Board of Realtors",
    abodeMLSName: "Vail Multi-List Services"
  },
  ventura_county_regional_data_share: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ventura County Regional Data Share",
    shortName: "Ventura County Regional Data Share"
  },
  waco_association_of_realtors: {
    isActive: true,
    resoID: "M00000594",
    constellation1ID: void 0,
    longName: "Waco Association of Realtors",
    shortName: "Waco Association of Realtors",
    abodeMLSName: "Waco Association of Realtors"
  },
  walker_co: {
    isActive: true,
    resoID: "M00000711",
    constellation1ID: void 0,
    longName: "Walker Co",
    shortName: "Walker Co",
    abodeMLSName: "Walker County Board of Realtors"
  },
  warren_county_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Warren County Board of REALTORS",
    shortName: "Warren County Board of REALTORS"
  },
  washington_county_board_of_realtors: {
    isActive: true,
    resoID: "M00000629",
    constellation1ID: void 0,
    longName: "Washington County Board of Realtors",
    shortName: "Washington County Board of Realtors",
    abodeMLSName: "Washington County Board of Realtors"
  },
  water_wonderland_mls: {
    isActive: true,
    resoID: "M00000317",
    constellation1ID: void 0,
    longName: "Water Wonderland MLS",
    shortName: "Water Wonderland MLS",
    abodeMLSName: "Water Wonderland Board of Realtors"
  },
  waterloo_cedar_falls_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Waterloo Cedar Falls Board of Realtors",
    shortName: "Waterloo Cedar Falls Board of Realtors"
  },
  west_branch_valley_association_of_realtors: {
    isActive: true,
    resoID: "M00000799",
    constellation1ID: void 0,
    longName: "West Branch Valley Association of Realtors",
    shortName: "West Branch Valley Association of Realtors",
    abodeMLSName: "West Branch Valley AOR"
  },
  west_central_association_of_realtors_sedaliawarsaw_mls: {
    isActive: true,
    resoID: "M00000735",
    constellation1ID: void 0,
    longName: "West Central Association of REALTORS (MO) - Sedalia/Warsaw MLS",
    shortName: "West Central Association of REALTORS (MO) - Sedalia/Warsaw MLS",
    abodeMLSName: "West Central Association of Realtors"
  },
  west_metro_board_of_realtors_ga: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "West Metro Board of Realtors, GA",
    shortName: "West Metro Board of Realtors, GA"
  },
  western_regional_information_systems_technology: {
    isActive: true,
    resoID: "M00000506",
    constellation1ID: void 0,
    longName: "Western Regional Information Systems & Technology",
    shortName: "Western Regional Information Systems & Technology",
    abodeMLSName: "Western Regional Information System & Technology"
  },
  western_upstate_multiple_listing_service: {
    isActive: true,
    resoID: "M00000556",
    constellation1ID: void 0,
    longName: "Western Upstate Multiple Listing Service",
    shortName: "Western Upstate Multiple Listing Service",
    abodeMLSName: "Western Upstate MLS"
  },
  white_mountain_assoc_of_realtors: {
    isActive: true,
    resoID: "M00000042",
    constellation1ID: void 0,
    longName: "White Mountain Assoc. of Realtors",
    shortName: "White Mountain Assoc. of Realtors",
    abodeMLSName: "White Mountain Association of Realtors MLS"
  },
  wichita_falls_association_of_realtors: {
    isActive: true,
    resoID: "M00000625",
    constellation1ID: void 0,
    longName: "Wichita Falls Association of REALTORS",
    shortName: "Wichita Falls Association of REALTORS",
    abodeMLSName: "Wichita Falls AOR"
  },
  willamette_valley_mls: {
    isActive: true,
    resoID: "M00000532",
    constellation1ID: void 0,
    longName: "Willamette Valley MLS",
    shortName: "Willamette Valley MLS",
    abodeMLSName: "Willamette Valley MLS"
  },
  williamsburg_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000858",
    constellation1ID: void 0,
    longName: "Williamsburg Area Association of Realtors",
    shortName: "Williamsburg Area Association of Realtors",
    abodeMLSName: "Williamsburg Board of Realtors"
  },
  yakima_association_of_realtors: {
    isActive: true,
    resoID: "M00000656",
    constellation1ID: void 0,
    longName: "Yakima Association of Realtors",
    shortName: "Yakima Association of Realtors",
    abodeMLSName: "Yakima Association of Realtors MLS"
  },
  yuma_mls: {
    isActive: true,
    resoID: "M00000050",
    constellation1ID: void 0,
    longName: "Yuma MLS",
    shortName: "Yuma MLS",
    abodeMLSName: "Yuma Association of Realtors MLS"
  },
  ack_association_of_realtors_northern_mi_mls: {
    isActive: true,
    resoID: "M00000315",
    constellation1ID: void 0,
    longName: "ACK Association of Realtors/Northern MI MLS",
    shortName: "ACK Association of Realtors/Northern MI MLS",
    abodeMLSName: "ACK Association of Realtors/Northern MI MLS"
  },
  adirondack_champlain_valley_mls: {
    isActive: true,
    resoID: "M00000483",
    constellation1ID: void 0,
    longName: "Adirondack-Champlain Valley MLS",
    shortName: "Adirondack-Champlain Valley MLS",
    abodeMLSName: "Adirondack-Champlain Valley MLS"
  },
  aiken_board_of_realtors: {
    isActive: true,
    resoID: "M00000555",
    constellation1ID: void 0,
    longName: "Aiken Board of Realtors",
    shortName: "Aiken Board of Realtors",
    abodeMLSName: "Aiken Board of Realtors"
  },
  alaska_mls: {
    isActive: true,
    resoID: "M00000001",
    constellation1ID: void 0,
    longName: "Alaska MLS",
    shortName: "Alaska MLS",
    abodeMLSName: "Alaska MLS"
  },
  albany_bor_southwest_ga_mls: {
    isActive: true,
    resoID: "M00000172",
    constellation1ID: void 0,
    longName: "Albany BOR/Southwest GA MLS",
    shortName: "Albany BOR/Southwest GA MLS",
    abodeMLSName: "Albany BOR/Southwest GA MLS"
  },
  allegheny_valley_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Allegheny Valley Board of REALTORS",
    shortName: "Allegheny Valley Board of REALTORS",
    abodeMLSName: void 0
  },
  amarillo_association_of_realtors: {
    isActive: true,
    resoID: "M00000588",
    constellation1ID: void 0,
    longName: "Amarillo Association of Realtors",
    shortName: "Amarillo Association of Realtors",
    abodeMLSName: "Amarillo Association of Realtors"
  },
  amelia_island_nassau_county_assoc_of_realtors: {
    isActive: true,
    resoID: "M00000136",
    constellation1ID: void 0,
    longName: "Amelia Island",
    shortName: "Amelia Island",
    abodeMLSName: "Amelia Island"
  },
  ann_arbor_area_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ann Arbor Area Board of Realtors",
    shortName: "Ann Arbor Area Board of Realtors",
    abodeMLSName: void 0
  },
  ashland_board_of_realtors_oh: {
    isActive: true,
    resoID: "M00000278",
    constellation1ID: void 0,
    longName: "Ashland Area AOR",
    shortName: "Ashland Area AOR",
    abodeMLSName: "Ashland Area AOR"
  },
  aspen_glenwood_springs_mls_co: {
    isActive: true,
    resoID: "M00000109",
    constellation1ID: void 0,
    longName: "Aspen/Glenwood Springs MLS",
    shortName: "Aspen/Glenwood Springs MLS",
    abodeMLSName: "Aspen/Glenwood Springs MLS"
  },
  athens_area_association_or_realtors_: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Athens Area Association or Realtors *",
    shortName: "Athens Area Association or Realtors *",
    abodeMLSName: void 0
  },
  athens_board_of_realtors_oh: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Athens Board of REALTORS, OH",
    shortName: "Athens Board of REALTORS, OH",
    abodeMLSName: void 0
  },
  badlands_board_of_realtors: {
    isActive: true,
    resoID: "M00000427",
    constellation1ID: void 0,
    longName: "Badlands Board of Realtors",
    shortName: "Badlands Board of Realtors",
    abodeMLSName: "Badlands Board of Realtors"
  },
  bagnell_dam_association_of_realtors: {
    isActive: true,
    resoID: "M00000355",
    constellation1ID: void 0,
    longName: "Bagnell Dam Association of Realtors",
    shortName: "Bagnell Dam Association of Realtors",
    abodeMLSName: "Bagnell Dam Association of Realtors"
  },
  bakersfield_association_of_realtors: {
    isActive: true,
    resoID: "M00000053",
    constellation1ID: void 0,
    longName: "Bakersfield Association of Realtors/Golden Empire MLS",
    shortName: "Bakersfield Association of Realtors/Golden Empire MLS",
    abodeMLSName: "Bakersfield Association of Realtors/Golden Empire MLS"
  },
  baldwin_county_association: {
    isActive: true,
    resoID: "M00000022",
    constellation1ID: void 0,
    longName: "Baldwin Realtors MLS",
    shortName: "Baldwin Realtors MLS",
    abodeMLSName: "Baldwin Realtors MLS"
  },
  bay_area_real_estate_information: {
    isActive: true,
    resoID: "M00000097",
    constellation1ID: void 0,
    longName: "Bay Area Real Estate Information Services",
    shortName: "Bay Area Real Estate Information Services",
    abodeMLSName: "Bay Area Real Estate Information Services"
  },
  bay_county: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Bay County (Panama City MLS)",
    shortName: "Bay County (Panama City MLS)",
    abodeMLSName: void 0
  },
  bay_east_aor_contra_costa_aor: {
    isActive: true,
    resoID: "M00000105",
    constellation1ID: void 0,
    longName: "Bay East AOR/Contra Costa AOR",
    shortName: "Bay East AOR/Contra Costa AOR",
    abodeMLSName: "Bay East AOR/Contra Costa AOR"
  },
  beaches_mls_matrix_mls: {
    isActive: true,
    resoID: "M00000170",
    constellation1ID: void 0,
    longName: "Beaches MLS- MATRIX MLS",
    shortName: "Beaches MLS- MATRIX MLS",
    abodeMLSName: "Beaches MLS- MATRIX MLS"
  },
  beaumont_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Beaumont Board of REALTORS",
    shortName: "Beaumont Board of REALTORS",
    abodeMLSName: void 0
  },
  berkshire_county_ma: {
    isActive: true,
    resoID: "M00000305",
    constellation1ID: void 0,
    longName: "Berkshire Realtors",
    shortName: "Berkshire Realtors",
    abodeMLSName: "Berkshire Realtors"
  },
  big_bear_mls_ca: {
    isActive: true,
    resoID: "M00000055",
    constellation1ID: void 0,
    longName: "Big Bear AOR",
    shortName: "Big Bear AOR",
    abodeMLSName: "Big Bear AOR"
  },
  billings_multiple_listing_service: {
    isActive: true,
    resoID: "M00000378",
    constellation1ID: void 0,
    longName: "Billings Association of Realtors",
    shortName: "Billings Association of Realtors",
    abodeMLSName: "Billings Association of Realtors"
  },
  birmingham: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Birmingham",
    shortName: "Birmingham",
    abodeMLSName: void 0
  },
  black_hills_association_of_realtors: {
    isActive: true,
    resoID: "M00000571",
    constellation1ID: void 0,
    longName: "Black Hills Association of Realtors",
    shortName: "Black Hills Association of Realtors",
    abodeMLSName: "Black Hills Association of Realtors"
  },
  bonita_springs_estero_association_of_realtors: {
    isActive: true,
    resoID: "M00000821",
    constellation1ID: void 0,
    longName: "Bonita Springs Association of Realtors MLS",
    shortName: "Bonita Springs Association of Realtors MLS",
    abodeMLSName: "Bonita Springs Association of Realtors MLS"
  },
  brooklyn_bor: {
    isActive: true,
    resoID: "M00000471",
    constellation1ID: void 0,
    longName: "Brooklyn BOR",
    shortName: "Brooklyn BOR",
    abodeMLSName: "Brooklyn BOR"
  },
  bryan_college_station_regional_aor_bryancollege_station_regional_mls: {
    isActive: true,
    resoID: "M00000592",
    constellation1ID: void 0,
    longName: "Bryan College Station Association of Realtors",
    shortName: "Bryan College Station Association of Realtors",
    abodeMLSName: "Bryan College Station Association of Realtors"
  },
  buffalo_niagara_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Buffalo Niagara Association of Realtors",
    shortName: "Buffalo Niagara Association of Realtors",
    abodeMLSName: void 0
  },
  burlingtonalamance_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Burlington/Alamance MLS",
    shortName: "Burlington/Alamance MLS",
    abodeMLSName: void 0
  },
  calaveras_county_association_of_realtors: {
    isActive: true,
    resoID: "M00000052",
    constellation1ID: void 0,
    longName: "Calaveras County Association of Realtors MLS",
    shortName: "Calaveras County Association of Realtors MLS",
    abodeMLSName: "Calaveras County Association of Realtors MLS"
  },
  california_desert_association_of_realtors: {
    isActive: true,
    resoID: "M00000093",
    constellation1ID: void 0,
    longName: "California Data Share",
    shortName: "California Data Share",
    abodeMLSName: "California Data Share"
  },
  campbell_county_board_of_realtors_northeast_wyoming_realtor_alliance: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Campbell County Board of Realtors / Northeast Wyoming REALTOR Alliance",
    shortName: "Campbell County Board of Realtors / Northeast Wyoming REALTOR Alliance",
    abodeMLSName: void 0
  },
  cape_cod_islands_association_of_realtors: {
    isActive: true,
    resoID: "M00000307",
    constellation1ID: void 0,
    longName: "Cape Cod and the Islands Association of Realtors",
    shortName: "Cape Cod and the Islands Association of Realtors",
    abodeMLSName: "Cape Cod and the Islands Association of Realtors"
  },
  cape_fear_realtors_multiple_listing_service: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Cape Fear REALTORS Multiple Listing Service (North Carolina Regional MLS)",
    shortName: "Cape Fear REALTORS Multiple Listing Service (North Carolina Regional MLS)",
    abodeMLSName: void 0
  },
  cape_may_county_association_of_realtors: {
    isActive: true,
    resoID: "M00000447",
    constellation1ID: void 0,
    longName: "Cape May County MLS",
    shortName: "Cape May County MLS",
    abodeMLSName: "Cape May County MLS"
  },
  carolina_smokies_aor: {
    isActive: true,
    resoID: "M00000395",
    constellation1ID: void 0,
    longName: "Carolina Smokies AOR",
    shortName: "Carolina Smokies AOR",
    abodeMLSName: "Carolina Smokies AOR"
  },
  carpet_capital_aor: {
    isActive: true,
    resoID: "M00000752",
    constellation1ID: void 0,
    longName: "Carpet Capital AOR",
    shortName: "Carpet Capital AOR",
    abodeMLSName: "Carpet Capital AOR"
  },
  cedar_rapids: {
    isActive: true,
    resoID: "M00000200",
    constellation1ID: void 0,
    longName: "Cedar Rapids AOR",
    shortName: "Cedar Rapids AOR",
    abodeMLSName: "Cedar Rapids AOR"
  },
  central_arizona_board_of_realtors: {
    isActive: true,
    resoID: "M00000043",
    constellation1ID: void 0,
    longName: "Central Arizona Association of Realtors MLS",
    shortName: "Central Arizona Association of Realtors MLS",
    abodeMLSName: "Central Arizona Association of Realtors MLS"
  },
  central_iowa_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central Iowa Board of Realtors",
    shortName: "Central Iowa Board of Realtors",
    abodeMLSName: void 0
  },
  central_ga_bor_mls: {
    isActive: true,
    resoID: "M00000190",
    constellation1ID: void 0,
    longName: "Central GA BOR MLS",
    shortName: "Central GA BOR MLS",
    abodeMLSName: "Central GA BOR MLS"
  },
  central_hill_country_association_of_realtors: {
    isActive: true,
    resoID: "M00000596",
    constellation1ID: void 0,
    longName: "Central Hill Country Association of Realtors",
    shortName: "Central Hill Country Association of Realtors",
    abodeMLSName: "Central Hill Country Association of Realtors"
  },
  central_jersey_mls: {
    isActive: true,
    resoID: "M00000450",
    constellation1ID: void 0,
    longName: "Central Jersey MLS",
    shortName: "Central Jersey MLS",
    abodeMLSName: "Central Jersey MLS"
  },
  central_new_york_information_services: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central New York Information Services (Jefferson Lewis Board of Realtors MLS)",
    shortName: "Central New York Information Services (Jefferson Lewis Board of Realtors MLS)",
    abodeMLSName: void 0
  },
  central_oregon_association_of_realtors: {
    isActive: true,
    resoID: "M00000525",
    constellation1ID: void 0,
    longName: "Central Oregon Association of Realtors",
    shortName: "Central Oregon Association of Realtors",
    abodeMLSName: "Central Oregon Association of Realtors"
  },
  central_susquehanna_valley_board_of_realtors: {
    isActive: true,
    resoID: "M00000538",
    constellation1ID: void 0,
    longName: "Central Susquehanna Valley BOR",
    shortName: "Central Susquehanna Valley BOR",
    abodeMLSName: "Central Susquehanna Valley BOR"
  },
  central_tennessee_west_aor: {
    isActive: true,
    resoID: "M00000581",
    constellation1ID: void 0,
    longName: "Central Tennessee West AOR",
    shortName: "Central Tennessee West AOR",
    abodeMLSName: "Central Tennessee West AOR"
  },
  central_virginia_regional_mls: {
    isActive: true,
    resoID: "M00000643",
    constellation1ID: void 0,
    longName: "Central Virginia Regional MLS",
    shortName: "Central Virginia Regional MLS",
    abodeMLSName: "Central Virginia Regional MLS"
  },
  central_wisconsin_multiple_listing_service: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central Wisconsin Multiple Listing Service",
    shortName: "Central Wisconsin Multiple Listing Service",
    abodeMLSName: void 0
  },
  centre_county_association_of_realtors_pa: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Centre County Association of Realtors, PA",
    shortName: "Centre County Association of Realtors, PA",
    abodeMLSName: void 0
  },
  centris: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Centris",
    shortName: "Centris",
    abodeMLSName: void 0
  },
  charleston_trident_mls_chs_regional: {
    isActive: true,
    resoID: "M00000558",
    constellation1ID: void 0,
    longName: "Charleston-Trident Association of Realtors",
    shortName: "Charleston-Trident Association of Realtors",
    abodeMLSName: "Charleston-Trident Association of Realtors"
  },
  charlottesville_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000633",
    constellation1ID: void 0,
    longName: "Charlottesville Association of Realtors",
    shortName: "Charlottesville Association of Realtors",
    abodeMLSName: "Charlottesville Association of Realtors"
  },
  chattanooga_association_of_realtors_tn: {
    isActive: true,
    resoID: "M00000575",
    constellation1ID: void 0,
    longName: "Chattanooga Association of Realtors, TN",
    shortName: "Chattanooga Association of Realtors, TN",
    abodeMLSName: "Greater Chattanooga AOR"
  },
  cheyenne_board_of_realtors: {
    isActive: true,
    resoID: "M00000675",
    constellation1ID: void 0,
    longName: "Cheyenne Board of Realtors",
    shortName: "Cheyenne Board of Realtors",
    abodeMLSName: "Cheyenne Board of Realtors"
  },
  classic_athens: {
    isActive: true,
    resoID: "M00000177",
    constellation1ID: void 0,
    longName: "Classic / Athens",
    shortName: "Classic / Athens",
    abodeMLSName: "Classic / Athens"
  },
  clatsop_mls_or_clatsop_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Clatsop MLS, OR / Clatsop Association of REALTORS",
    shortName: "Clatsop MLS, OR / Clatsop Association of REALTORS",
    abodeMLSName: void 0
  },
  coastal_carolinas_association_of_realtors_sc: {
    isActive: true,
    resoID: "M00000565",
    constellation1ID: void 0,
    longName: "Coastal Carolina AOR",
    shortName: "Coastal Carolina AOR",
    abodeMLSName: "Coastal Carolina AOR"
  },
  coeur_d_alene_association_of_realtors: {
    isActive: true,
    resoID: "M00000227",
    constellation1ID: void 0,
    longName: "Coeur d'Alene Association of Realtors",
    shortName: "Coeur d'Alene Association of Realtors",
    abodeMLSName: "Coeur d'Alene Association of Realtors"
  },
  colorado_real_estate_network: {
    isActive: true,
    resoID: "M00000684",
    constellation1ID: void 0,
    longName: "Colorado Real Estate Network",
    shortName: "Colorado Real Estate Network",
    abodeMLSName: "Colorado Real Estate Network"
  },
  columbia_board_of_realtors: {
    isActive: true,
    resoID: "M00000349",
    constellation1ID: void 0,
    longName: "Columbia Board of REALTORS",
    shortName: "Columbia Board of REALTORS",
    abodeMLSName: "Columbia Board of REALTORS"
  },
  columbia_county_northern_dutchess_mls: {
    isActive: true,
    resoID: "M00000476",
    constellation1ID: void 0,
    longName: "Columbia Greene North Dutchess MLS",
    shortName: "Columbia Greene North Dutchess MLS",
    abodeMLSName: "Columbia Greene North Dutchess MLS"
  },
  columbus_and_central_ohio_regional_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Columbus and Central Ohio Regional MLS",
    shortName: "Columbus and Central Ohio Regional MLS",
    abodeMLSName: void 0
  },
  columbus_board_of_realtors_ga: {
    isActive: true,
    resoID: "M00000753",
    constellation1ID: void 0,
    longName: "Columbus BOR",
    shortName: "Columbus BOR",
    abodeMLSName: "Columbus BOR"
  },
  columbus_ne_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Columbus NE Board of Realtors",
    shortName: "Columbus NE Board of Realtors",
    abodeMLSName: void 0
  },
  commercial_and_industrial_real_estate_brokers: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Commercial and Industrial Real Estate Brokers",
    shortName: "Commercial and Industrial Real Estate Brokers",
    abodeMLSName: void 0
  },
  consolidated_mls: {
    isActive: true,
    resoID: "M00000559",
    constellation1ID: void 0,
    longName: "Consolidated MLS",
    shortName: "Consolidated MLS",
    abodeMLSName: "Consolidated MLS"
  },
  cooperative_arkansas_realtors_mls: {
    isActive: true,
    resoID: "M00000031",
    constellation1ID: void 0,
    longName: "Cooperative Arkansas Realtors MLS",
    shortName: "Cooperative Arkansas Realtors MLS",
    abodeMLSName: "Cooperative Arkansas Realtors MLS"
  },
  corpus_christi_association_of_realtors_south_texas_mls: {
    isActive: true,
    resoID: "M00000593",
    constellation1ID: void 0,
    longName: "Corpus Christi Board of Realtors (South Texas MLS)",
    shortName: "Corpus Christi Board of Realtors (South Texas MLS)",
    abodeMLSName: "Corpus Christi Board of Realtors (South Texas MLS)"
  },
  darien_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Darien MLS",
    shortName: "Darien MLS",
    abodeMLSName: void 0
  },
  dayton_realtors: {
    isActive: true,
    resoID: "M00000496",
    constellation1ID: void 0,
    longName: "Dayton Area Board of Realtors",
    shortName: "Dayton Area Board of Realtors",
    abodeMLSName: "Dayton Area Board of Realtors"
  },
  daytona_beach_area_association: {
    isActive: true,
    resoID: "M00000140",
    constellation1ID: void 0,
    longName: "Daytona Beach Area Association of REALTORS",
    shortName: "Daytona Beach Area Association of REALTORS",
    abodeMLSName: "Daytona Beach Area Association of REALTORS"
  },
  desert_area_mls: {
    isActive: true,
    resoID: "M00000082",
    constellation1ID: void 0,
    longName: "Desert Area MLS",
    shortName: "Desert Area MLS",
    abodeMLSName: "Desert Area MLS"
  },
  door_county_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Door County Board of REALTORS",
    shortName: "Door County Board of REALTORS",
    abodeMLSName: void 0
  },
  dothan_mls: {
    isActive: true,
    resoID: "M00000013",
    constellation1ID: void 0,
    longName: "Dothan MLS",
    shortName: "Dothan MLS",
    abodeMLSName: "Southeast Alabama AOR/MLS (Dothan)"
  },
  east_alabama_board_of_realtors_al: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Alabama Board of REALTORS, AL",
    shortName: "East Alabama Board of REALTORS, AL",
    abodeMLSName: void 0
  },
  east_central_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Central Association of Realtors",
    shortName: "East Central Association of Realtors",
    abodeMLSName: void 0
  },
  east_central_iowa: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Central Iowa",
    shortName: "East Central Iowa",
    abodeMLSName: void 0
  },
  eastern_shore_aor: {
    isActive: true,
    resoID: "M00000631",
    constellation1ID: void 0,
    longName: "Eastern Shore AOR",
    shortName: "Eastern Shore AOR",
    abodeMLSName: "Eastern Shore AOR"
  },
  fargo_moorhead_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000428",
    constellation1ID: void 0,
    longName: "Fargo Morehead Area Association of Realtors",
    shortName: "Fargo Morehead Area Association of Realtors",
    abodeMLSName: "Fargo Morehead Area Association of Realtors"
  },
  fayetteville_association_of_realtors: {
    isActive: true,
    resoID: "M00000394",
    constellation1ID: void 0,
    longName: "Longleaf Pine REALTORS (Fayetteville)",
    shortName: "Longleaf Pine REALTORS (Fayetteville)",
    abodeMLSName: "Fayetteville Association of Realtors (Longleaf Pine REALTORS)"
  },
  firelands_association_of_realtors: {
    isActive: true,
    resoID: "M00000504",
    constellation1ID: void 0,
    longName: "Firelands Association of Realtors",
    shortName: "Firelands Association of Realtors",
    abodeMLSName: "Firelands Association of Realtors"
  },
  flint_hills_mls: {
    isActive: true,
    resoID: "M00000271",
    constellation1ID: void 0,
    longName: "Flint Hills AOR (aka Manhattan Area AOR)",
    shortName: "Flint Hills AOR (aka Manhattan Area AOR)",
    abodeMLSName: "Flint Hills AOR (aka Manhattan Area AOR)"
  },
  florida_keys_multiple_listing_service: {
    isActive: true,
    resoID: "M00000168",
    constellation1ID: void 0,
    longName: "Florida Keys MLS",
    shortName: "Florida Keys MLS",
    abodeMLSName: "Florida Keys MLS"
  },
  fort_smith_bor_dba_western_river_valley_bor: {
    isActive: true,
    resoID: "M00000853",
    constellation1ID: void 0,
    longName: "Fort Smith BOR dba Western River Valley BOR",
    shortName: "Fort Smith BOR dba Western River Valley BOR",
    abodeMLSName: "Fort Smith BOR dba Western River Valley BOR"
  },
  franklin_and_gulf_counties: {
    isActive: true,
    resoID: "M00000129",
    constellation1ID: void 0,
    longName: "Franklin and Gulf Counties",
    shortName: "Franklin and Gulf Counties",
    abodeMLSName: "Franklin and Gulf Counties"
  },
  freeport_galena: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Freeport Galena (Realtor Association of Northwestern Illinois)",
    shortName: "Freeport Galena (Realtor Association of Northwestern Illinois)",
    abodeMLSName: void 0
  },
  fresno_association_of_realtors: {
    isActive: true,
    resoID: "M00000060",
    constellation1ID: void 0,
    longName: "Fresno Association of REALTORS",
    shortName: "Fresno Association of REALTORS",
    abodeMLSName: "Fresno Association of REALTORS"
  },
  gallatin_association_of_realtors_big_sky_country_mls: {
    isActive: true,
    resoID: "M00000379",
    constellation1ID: void 0,
    longName: "Gallatin Association of Realtors (Big Sky Country MLS)",
    shortName: "Gallatin Association of Realtors (Big Sky Country MLS)",
    abodeMLSName: "Gallatin Association of Realtors (Big Sky Country MLS)"
  },
  galveston_association_of_realtors: {
    isActive: true,
    resoID: "M00000597",
    constellation1ID: void 0,
    longName: "Galveston Board of Realtors",
    shortName: "Galveston Board of Realtors",
    abodeMLSName: "Galveston Board of Realtors"
  },
  golden_isles_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Golden Isles Association of Realtors",
    shortName: "Golden Isles Association of Realtors",
    abodeMLSName: void 0
  },
  global_mls: {
    isActive: true,
    resoID: "M00000468",
    constellation1ID: void 0,
    longName: "Global MLS",
    shortName: "Global MLS",
    abodeMLSName: "Global MLS"
  },
  grand_forks_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000429",
    constellation1ID: void 0,
    longName: "Grand Forks Area Association of Realtors",
    shortName: "Grand Forks Area Association of Realtors",
    abodeMLSName: "Grand Forks Area Association of Realtors"
  },
  grand_island_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Grand Island Board of Realtors",
    shortName: "Grand Island Board of Realtors",
    abodeMLSName: void 0
  },
  grand_junction_area_realtor_association: {
    isActive: true,
    resoID: "M00000729",
    constellation1ID: void 0,
    longName: "Grand Junction Area Realtor Association",
    shortName: "Grand Junction Area Realtor Association",
    abodeMLSName: "Grand Junction Association of Realtors MLS"
  },
  great_north_mls: {
    isActive: true,
    resoID: "M00000107",
    constellation1ID: void 0,
    longName: "Great North MLS",
    shortName: "Great North MLS",
    abodeMLSName: "Great North MLS"
  },
  great_plains_mls_omaha: {
    isActive: true,
    resoID: "M00000441",
    constellation1ID: void 0,
    longName: "Great Plains Regional MLS",
    shortName: "Great Plains Regional MLS",
    abodeMLSName: "Great Plains Regional MLS"
  },
  greater_alabama_mls: {
    isActive: true,
    resoID: "M00000010",
    constellation1ID: void 0,
    longName: "Greater Alabama MLS",
    shortName: "Greater Alabama MLS",
    abodeMLSName: "Greater Alabama MLS"
  },
  greater_antelope_valley_association_of_realtors: {
    isActive: true,
    resoID: "M00000084",
    constellation1ID: void 0,
    longName: "Greater Antelope Valley Association of Realtors",
    shortName: "Greater Antelope Valley Association of Realtors",
    abodeMLSName: "Greater Antelope Valley Association of Realtors"
  },
  greater_augusta_association_of_realtors: {
    isActive: true,
    resoID: "M00000176",
    constellation1ID: void 0,
    longName: "Greater Augusta Board of Realtors MLS",
    shortName: "Greater Augusta Board of Realtors MLS",
    abodeMLSName: "Greater Augusta Board of Realtors MLS"
  },
  greater_baton_rouge_aor: {
    isActive: true,
    resoID: "M00000298",
    constellation1ID: void 0,
    longName: "Greater Baton Rouge Association of Realtors",
    shortName: "Greater Baton Rouge Association of Realtors",
    abodeMLSName: "Greater Baton Rouge Association of Realtors"
  },
  greater_binghamton_aor: {
    isActive: true,
    resoID: "M00000470",
    constellation1ID: void 0,
    longName: "Greater Binghamton AOR",
    shortName: "Greater Binghamton AOR",
    abodeMLSName: "Greater Binghamton AOR"
  },
  greater_capital_region_multiple_listing_service: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greater Capital Region Multiple Listing Service",
    shortName: "Greater Capital Region Multiple Listing Service"
  },
  greater_el_paso_association_of_realtors: {
    isActive: true,
    resoID: "M00000595",
    constellation1ID: void 0,
    longName: "Greater El Paso Association of Realtors",
    shortName: "Greater El Paso Association of Realtors",
    abodeMLSName: "Greater El Paso Association of Realtors"
  },
  greater_erie_board_of_realtors_oh: {
    isActive: true,
    resoID: "M00000540",
    constellation1ID: void 0,
    longName: "Greater Erie BOR",
    shortName: "Greater Erie BOR",
    abodeMLSName: "Greater Erie BOR"
  },
  greater_fairbanks_board_of_realtors_mls: {
    isActive: true,
    resoID: "M00000002",
    constellation1ID: void 0,
    longName: "Greater Fairbanks Board of Realtors MLS",
    shortName: "Greater Fairbanks Board of Realtors MLS",
    abodeMLSName: "Greater Fairbanks Board of Realtors MLS"
  },
  greater_greenville_association_mls: {
    isActive: true,
    resoID: "M00000365",
    constellation1ID: void 0,
    longName: "Greater Greenville Association of Realtors",
    shortName: "Greater Greenville Association of Realtors",
    abodeMLSName: "Greater Greenville Association of Realtors"
  },
  greater_lansing_association_of_realtors: {
    isActive: true,
    resoID: "M00000322",
    constellation1ID: void 0,
    longName: "Greater Lansing Association of Realtors",
    shortName: "Greater Lansing Association of Realtors",
    abodeMLSName: "Greater Lansing Association of Realtors"
  },
  greater_las_vegas_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greater Las Vegas Association of Realtors",
    shortName: "Greater Las Vegas Association of Realtors",
    abodeMLSName: void 0
  },
  greater_lehigh_association_of_realtors: {
    isActive: true,
    resoID: "M00000534",
    constellation1ID: void 0,
    longName: "Greater Lehigh Valley MLS",
    shortName: "Greater Lehigh Valley MLS",
    abodeMLSName: "Greater Lehigh Valley MLS"
  },
  greater_louisville_association_of_realtors: {
    isActive: true,
    resoID: "M00000290",
    constellation1ID: void 0,
    longName: "Greater Louisville Association of Realtors",
    shortName: "Greater Louisville Association of Realtors",
    abodeMLSName: "Greater Louisville Association of Realtors"
  },
  greater_mcallen_association_of_realtors: {
    isActive: true,
    resoID: "M00000608",
    constellation1ID: void 0,
    longName: "Greater McAllen Association of Realtors",
    shortName: "Greater McAllen Association of Realtors",
    abodeMLSName: "Greater McAllen Association of Realtors"
  },
  greater_northwest_indiana_association_of_realtors: {
    isActive: true,
    resoID: "M00000259",
    constellation1ID: void 0,
    longName: "Greater Northwest Indiana Association of Realtors",
    shortName: "Greater Northwest Indiana Association of Realtors",
    abodeMLSName: "Greater Northwest Indiana Association of Realtors"
  },
  greater_pocatello_association_on_realtors: {
    isActive: true,
    resoID: "M00000233",
    constellation1ID: void 0,
    longName: "Greater Pocatello Association on Realtors",
    shortName: "Greater Pocatello Association on Realtors",
    abodeMLSName: "Pocatello Board of Realtors"
  },
  greater_scranton_board_of_realtors: {
    isActive: true,
    resoID: "M00000536",
    constellation1ID: void 0,
    longName: "Greater Scranton Board of Realtors",
    shortName: "Greater Scranton Board of Realtors",
    abodeMLSName: "Greater Scranton Board of Realtors"
  },
  greater_southern_mls: {
    isActive: true,
    resoID: "M00000083",
    constellation1ID: void 0,
    longName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors",
    shortName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors",
    abodeMLSName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors"
  },
  greater_tyler_association_of_realtors: {
    isActive: true,
    resoID: "M00000621",
    constellation1ID: void 0,
    longName: "Greater Tyler Association of Realtors",
    shortName: "Greater Tyler Association of Realtors",
    abodeMLSName: "Greater Tyler Association of Realtors"
  },
  greenbrier_valley_board_of_realtors: {
    isActive: true,
    resoID: "M00000669",
    constellation1ID: void 0,
    longName: "Greenbrier Valley Board of Realtors",
    shortName: "Greenbrier Valley Board of Realtors",
    abodeMLSName: "Greenbrier Valley Board of Realtors"
  },
  greenwich_association_of_realtors: {
    isActive: true,
    resoID: "M00000125",
    constellation1ID: void 0,
    longName: "Greenwich Board of Realtors MLS",
    shortName: "Greenwich Board of Realtors MLS",
    abodeMLSName: "Greenwich Board of Realtors MLS"
  },
  greenwood_association: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greenwood Association",
    shortName: "Greenwood Association",
    abodeMLSName: void 0
  },
  harlingen_board_of_realtors_mls_rio_grande_valley_multiple_listing_service: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Harlingen Board of Realtors MLS / Rio Grande Valley Multiple Listing Service",
    shortName: "Harlingen Board of Realtors MLS / Rio Grande Valley Multiple Listing Service",
    abodeMLSName: void 0
  },
  hastings_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Hastings Board of Realtors",
    shortName: "Hastings Board of Realtors",
    abodeMLSName: void 0
  },
  gulf_coast_mls: {
    isActive: true,
    resoID: "M00000018",
    constellation1ID: void 0,
    longName: "Gulf Coast MLS",
    shortName: "Gulf Coast MLS",
    abodeMLSName: "Gulf Coast MLS"
  },
  hattiesburg_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000367",
    constellation1ID: void 0,
    longName: "Hattiesburg Area Association of Realtors",
    shortName: "Hattiesburg Area Association of Realtors",
    abodeMLSName: "Hattiesburg Area Association of Realtors"
  },
  hawaii_information_service_mls: {
    isActive: true,
    resoID: "M00000193",
    constellation1ID: void 0,
    longName: "Hawaii Information System",
    shortName: "Hawaii Information System",
    abodeMLSName: "Hawaii Information System"
  },
  heart_of_missouri_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Heart of Missouri Board of REALTORS",
    shortName: "Heart of Missouri Board of REALTORS",
    abodeMLSName: void 0
  },
  heart_of_iowa_association_of_realtors: {
    isActive: true,
    resoID: "M00000205",
    constellation1ID: void 0,
    longName: "Heart of Iowa Association of Realtors",
    shortName: "Heart of Iowa Association of Realtors",
    abodeMLSName: "Heart of Iowa Association of Realtors"
  },
  henderson_county_board_of_realtors: {
    isActive: true,
    resoID: "M00000740",
    constellation1ID: void 0,
    longName: "Henderson County BOR",
    shortName: "Henderson County BOR",
    abodeMLSName: "Henderson County BOR"
  },
  hernando_county_association_of_realtors: {
    isActive: true,
    resoID: "M00000131",
    constellation1ID: void 0,
    longName: "Hernando County Association of REALTORS/MLS",
    shortName: "Hernando County Association of REALTORS/MLS",
    abodeMLSName: "Hernando County Association of REALTORS/MLS"
  },
  hi_central_mls: {
    isActive: true,
    resoID: "M00000194",
    constellation1ID: void 0,
    longName: "Hi-Central MLS",
    shortName: "Hi-Central MLS",
    abodeMLSName: "Hi-Central MLS"
  },
  high_country_association_of_realtors: {
    isActive: true,
    resoID: "M00000387",
    constellation1ID: void 0,
    longName: "High Country AOR",
    shortName: "High Country AOR",
    abodeMLSName: "High Country AOR"
  },
  highland_lakes_association_of_realtors: {
    isActive: true,
    resoID: "M00000606",
    constellation1ID: void 0,
    longName: "Highland Lakes BOR",
    shortName: "Highland Lakes BOR",
    abodeMLSName: "Highland Lakes BOR"
  },
  highlands_cashiers_board_of_realtors: {
    isActive: true,
    resoID: "M00000390",
    constellation1ID: void 0,
    longName: "Highlands Cashiers Board of Realtors MLS",
    shortName: "Highlands Cashiers Board of Realtors MLS",
    abodeMLSName: "Highlands Cashiers Board of Realtors MLS"
  },
  hilton_head_mls_resides: {
    isActive: true,
    resoID: "M00000564",
    constellation1ID: void 0,
    longName: "Hilton Head Area Association of Realtors",
    shortName: "Hilton Head Area Association of Realtors",
    abodeMLSName: "Hilton Head Area Association of Realtors"
  },
  honolulu_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Honolulu Board of Realtors",
    shortName: "Honolulu Board of Realtors",
    abodeMLSName: void 0
  },
  hot_springs_mls: {
    isActive: true,
    resoID: "M00000029",
    constellation1ID: void 0,
    longName: "Hot Springs MLS",
    shortName: "Hot Springs MLS",
    abodeMLSName: "Hot Springs MLS"
  },
  hudson_county_mls: {
    isActive: true,
    resoID: "M00000784",
    constellation1ID: void 0,
    longName: "Hudson MLS",
    shortName: "Hudson MLS",
    abodeMLSName: "Hudson MLS"
  },
  humboldt_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Humboldt Association of Realtors",
    shortName: "Humboldt Association of Realtors",
    abodeMLSName: void 0
  },
  huntington_board_of_realtors: {
    isActive: true,
    resoID: "M00000668",
    constellation1ID: void 0,
    longName: "Huntington Board of Realtors",
    shortName: "Huntington Board of Realtors",
    abodeMLSName: "Huntington Board of Realtors"
  },
  idyllwild: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Idyllwild",
    shortName: "Idyllwild",
    abodeMLSName: void 0
  },
  imperial_county_aor: {
    isActive: true,
    resoID: "M00000058",
    constellation1ID: void 0,
    longName: "Imperial County AOR",
    shortName: "Imperial County AOR",
    abodeMLSName: "Imperial County AOR"
  },
  incline_village_board_of_realtors: {
    isActive: true,
    resoID: "M00000465",
    constellation1ID: void 0,
    longName: "Incline Village Board of Realtors",
    shortName: "Incline Village Board of Realtors",
    abodeMLSName: "Incline Village Board of Realtors"
  },
  indian_river_association_of_realtors_mls: {
    isActive: true,
    resoID: "M00000169",
    constellation1ID: void 0,
    longName: "Indian River Association of Realtors MLS",
    shortName: "Indian River Association of Realtors MLS",
    abodeMLSName: "Indian River Association of Realtors MLS"
  },
  intermountain_multiple_listing_service: {
    isActive: true,
    resoID: "M00000225",
    constellation1ID: void 0,
    longName: "Intermountain MLS",
    shortName: "Intermountain MLS",
    abodeMLSName: "Intermountain MLS"
  },
  iowa_city_area: {
    isActive: true,
    resoID: "M00000206",
    constellation1ID: void 0,
    longName: "Iowa City Area Association of Realtors",
    shortName: "Iowa City Area Association of Realtors",
    abodeMLSName: "Iowa City Area Association of Realtors"
  },
  iowa_great_lakes: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Iowa Great Lakes",
    shortName: "Iowa Great Lakes",
    abodeMLSName: void 0
  },
  ires_regional_mls_of_northern_colorado: {
    isActive: true,
    resoID: "M00000118",
    constellation1ID: void 0,
    longName: "IRES",
    shortName: "IRES",
    abodeMLSName: "IRES"
  },
  ithaca_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ithaca Board of Realtors",
    shortName: "Ithaca Board of Realtors",
    abodeMLSName: void 0
  },
  jasper_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Jasper Association of REALTORS",
    shortName: "Jasper Association of REALTORS",
    abodeMLSName: void 0
  },
  jefferson_city_area_board_of_realtors: {
    isActive: true,
    resoID: "M00000353",
    constellation1ID: void 0,
    longName: "Jefferson City Area Board of Realtors",
    shortName: "Jefferson City Area Board of Realtors",
    abodeMLSName: "Jefferson City Area Board of Realtors"
  },
  jonesboro_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Jonesboro Board of Realtors",
    shortName: "Jonesboro Board of Realtors",
    abodeMLSName: void 0
  },
  kanab_listing_service: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Kanab Listing Service",
    shortName: "Kanab Listing Service",
    abodeMLSName: void 0
  },
  kanawha_valley_board_of_realtors: {
    isActive: true,
    resoID: "M00000667",
    constellation1ID: void 0,
    longName: "Kanawha Valley Board of Realtors",
    shortName: "Kanawha Valley Board of Realtors",
    abodeMLSName: "Kanawha Valley Board of Realtors"
  },
  kerrville_bor: {
    isActive: true,
    resoID: "M00000600",
    constellation1ID: void 0,
    longName: "Kerrville BOR",
    shortName: "Kerrville BOR",
    abodeMLSName: "Kerrville BOR"
  },
  key_west_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Key West Association of Realtors",
    shortName: "Key West Association of Realtors",
    abodeMLSName: void 0
  },
  kings_county_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Kings County Board of Realtors",
    shortName: "Kings County Board of Realtors",
    abodeMLSName: void 0
  },
  lake_country_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Lake Country Board of Realtors",
    shortName: "Lake Country Board of Realtors",
    abodeMLSName: void 0
  },
  lake_havasu_mls: {
    isActive: true,
    resoID: "M00000832",
    constellation1ID: void 0,
    longName: "Lake Havasu AOR",
    shortName: "Lake Havasu AOR",
    abodeMLSName: "Lake Havasu AOR"
  },
  lake_martin: {
    isActive: true,
    resoID: "M00000004",
    constellation1ID: void 0,
    longName: "Lake Martin Area AOR",
    shortName: "Lake Martin Area AOR",
    abodeMLSName: "Lake Martin Area AOR"
  },
  lakeway_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000584",
    constellation1ID: void 0,
    longName: "Lakeway Area Association of Realtors",
    shortName: "Lakeway Area Association of Realtors",
    abodeMLSName: "Lakeway Area Association of Realtors"
  },
  laredo_bor: {
    isActive: true,
    resoID: "M00000603",
    constellation1ID: void 0,
    longName: "Laredo BOR",
    shortName: "Laredo BOR",
    abodeMLSName: "Laredo BOR"
  },
  lawrence_mls: {
    isActive: true,
    resoID: "M00000269",
    constellation1ID: void 0,
    longName: "Lawrence BOR",
    shortName: "Lawrence BOR",
    abodeMLSName: "Lawrence BOR"
  },
  lee_county_association: {
    isActive: true,
    resoID: "M00000008",
    constellation1ID: void 0,
    longName: "Lee County AOR MLS",
    shortName: "Lee County AOR MLS",
    abodeMLSName: "Lee County AOR MLS"
  },
  link_nantucket: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Link Nantucket",
    shortName: "Link Nantucket",
    abodeMLSName: void 0
  },
  lmperial_county: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "lmperial County",
    shortName: "lmperial County",
    abodeMLSName: void 0
  },
  longleaf_pine_realtors: {
    isActive: true,
    resoID: "M00000394",
    constellation1ID: void 0,
    longName: "Longleaf Pine REALTORS (Fayetteville)",
    shortName: "Longleaf Pine REALTORS (Fayetteville)",
    abodeMLSName: "Longleaf Pine REALTORS (Fayetteville)"
  },
  longview_association: {
    isActive: true,
    resoID: "M00000604",
    constellation1ID: void 0,
    longName: "Longview Association of Realtors",
    shortName: "Longview Association of Realtors",
    abodeMLSName: "Longview Association of Realtors"
  },
  low_country_mls: {
    isActive: true,
    resoID: "M00000557",
    constellation1ID: void 0,
    longName: "Low Country Regional MLS (Beaufort County Association of Realtors)",
    shortName: "Low Country Regional MLS (Beaufort County Association of Realtors)",
    abodeMLSName: "Low Country Regional MLS (Beaufort County Association of Realtors)"
  },
  lubbock_association_of_realtors: {
    isActive: true,
    resoID: "M00000811",
    constellation1ID: void 0,
    longName: "Lubbock Association of Realtors",
    shortName: "Lubbock Association of Realtors",
    abodeMLSName: "Lubbock Association of Realtors"
  },
  luzerne_county_association_of_realtors_greater_wilkes_barre_association_of_realtors: {
    isActive: true,
    resoID: "M00000545",
    constellation1ID: void 0,
    longName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)",
    shortName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)",
    abodeMLSName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)"
  },
  lynchburg_association_of_realtors: {
    isActive: true,
    resoID: "M00000641",
    constellation1ID: void 0,
    longName: "Lynchburg Board of Realtors",
    shortName: "Lynchburg Board of Realtors",
    abodeMLSName: "Lynchburg Board of Realtors"
  },
  maine_real_estate_information_system: {
    isActive: true,
    resoID: "M00000311",
    constellation1ID: void 0,
    longName: "Maine Listings",
    shortName: "Maine Listings",
    abodeMLSName: "Maine Listings"
  },
  mansfield_board_of_realtors_oh: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mansfield Board of Realtors , OH",
    shortName: "Mansfield Board of Realtors , OH",
    abodeMLSName: void 0
  },
  mammoth_lakes_board_of_realtors: {
    isActive: true,
    resoID: "M00000073",
    constellation1ID: void 0,
    longName: "Mammoth Lakes Board of Realtors",
    shortName: "Mammoth Lakes Board of Realtors",
    abodeMLSName: "Mammoth Lakes Board of Realtors"
  },
  marco_multi_list_mls: {
    isActive: true,
    resoID: "M00000148",
    constellation1ID: void 0,
    longName: "Marco Multi List",
    shortName: "Marco Multi List",
    abodeMLSName: "Marco Multi List, Inc."
  },
  mason_city_greater: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mason City, Greater",
    shortName: "Mason City, Greater",
    abodeMLSName: void 0
  },
  max_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Max MLS (bridge MLS)",
    shortName: "Max MLS (bridge MLS)",
    abodeMLSName: void 0
  },
  maui_board_of_reatlors: {
    isActive: true,
    resoID: "M00000195",
    constellation1ID: void 0,
    longName: "Maui Board of Reatlors",
    shortName: "Maui Board of Reatlors",
    abodeMLSName: "Maui Board of Reatlors"
  },
  memphis_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000583",
    constellation1ID: void 0,
    longName: "Memphis Area Association of Realtors",
    shortName: "Memphis Area Association of Realtors",
    abodeMLSName: "Memphis Area Association of Realtors"
  },
  mercer_tazewell_county_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mercer - Tazewell County Board of REALTORS",
    shortName: "Mercer - Tazewell County Board of REALTORS",
    abodeMLSName: void 0
  },
  metro_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Metro MLS",
    shortName: "Metro MLS",
    abodeMLSName: void 0
  },
  metropolitan_indianapolis_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Metropolitan Indianapolis Board of Realtors",
    shortName: "Metropolitan Indianapolis Board of Realtors",
    abodeMLSName: void 0
  },
  mi_realsource: {
    isActive: true,
    resoID: "M00000331",
    constellation1ID: void 0,
    longName: "MI RealSource",
    shortName: "MI RealSource",
    abodeMLSName: "MI RealSource"
  },
  michigan_regional_information_center: {
    isActive: true,
    resoID: "T00000006",
    constellation1ID: void 0,
    longName: "Michigan Regional Information Center",
    shortName: "Michigan Regional Information Center",
    abodeMLSName: "Michigan Regional Information Center"
  },
  mid_georgia_multiple_listing_service_ga: {
    isActive: true,
    resoID: "M00000184",
    constellation1ID: void 0,
    longName: "Middle Georgia MLS",
    shortName: "Middle Georgia MLS",
    abodeMLSName: "Middle Georgia MLS"
  },
  mid_ks_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mid KS MLS",
    shortName: "Mid KS MLS",
    abodeMLSName: void 0
  },
  midamerica_regional_information_systems: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "MidAmerica Regional Information Systems",
    shortName: "MidAmerica Regional Information Systems",
    abodeMLSName: void 0
  },
  middle_tennessee_regional_mls_realtracs: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Middle Tennessee Regional MLS / Realtracs",
    shortName: "Middle Tennessee Regional MLS / Realtracs",
    abodeMLSName: void 0
  },
  middlesex_county_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Middlesex County MLS (Central Jersey MLS)",
    shortName: "Middlesex County MLS (Central Jersey MLS)",
    abodeMLSName: void 0
  },
  midhudson_multiple_listing_service: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "MidHudson Multiple Listing Service",
    shortName: "MidHudson Multiple Listing Service",
    abodeMLSName: void 0
  },
  midwest_minnesota_regional_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Midwest Minnesota Regional MLS",
    shortName: "Midwest Minnesota Regional MLS",
    abodeMLSName: void 0
  },
  minot_board_of_realtors: {
    isActive: true,
    resoID: "M00000431",
    constellation1ID: void 0,
    longName: "Minot Board of Realtors",
    shortName: "Minot Board of Realtors",
    abodeMLSName: "Minot Board of Realtors"
  },
  mls_listings: {
    isActive: true,
    resoID: "M00000101",
    constellation1ID: void 0,
    longName: "MLS Listings",
    shortName: "MLS Listings",
    abodeMLSName: "MLS Listings"
  },
  mls_of_columbus_realtors: {
    isActive: true,
    resoID: "M00000495",
    constellation1ID: void 0,
    longName: "MLS of Columbus Realtors",
    shortName: "MLS of Columbus Realtors",
    abodeMLSName: "MLS of Columbus Realtors"
  },
  mls_of_greater_cincinnati: {
    isActive: true,
    resoID: "M00000494",
    constellation1ID: void 0,
    longName: "MLS of Greater Cincinnati",
    shortName: "MLS of Greater Cincinnati",
    abodeMLSName: "MLS of Greater Cincinnati"
  },
  mls_of_southern_arizona: {
    isActive: true,
    resoID: "M00000049",
    constellation1ID: void 0,
    longName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)",
    shortName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)",
    abodeMLSName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)"
  },
  mobile_area_asociation_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mobile Area Asociation of Realtors",
    shortName: "Mobile Area Asociation of Realtors",
    abodeMLSName: void 0
  },
  monmouthocean_multiple_listing_service: {
    isActive: true,
    resoID: "M00000452",
    constellation1ID: void 0,
    longName: "Monmouth County Board of Realtors",
    shortName: "Monmouth County Board of Realtors",
    abodeMLSName: "Monmouth County Board of Realtors"
  },
  montana_regional_mls: {
    isActive: true,
    resoID: "M00000383",
    constellation1ID: void 0,
    longName: "Montana Regional MLS",
    shortName: "Montana Regional MLS",
    abodeMLSName: "Montana Regional MLS"
  },
  montgomery_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000020",
    constellation1ID: void 0,
    longName: "Montgomery AreaAOR/MLS",
    shortName: "Montgomery AreaAOR/MLS",
    abodeMLSName: "Montgomery AreaAOR/MLS"
  },
  mount_rushmore_mls: {
    isActive: true,
    resoID: "M00000573",
    constellation1ID: void 0,
    longName: "Mount Rushmore AOR MLS",
    shortName: "Mount Rushmore AOR MLS",
    abodeMLSName: "Mount Rushmore AOR MLS"
  },
  mountain_central_association_of_realtors: {
    isActive: true,
    resoID: "M00000231",
    constellation1ID: void 0,
    longName: "Mountain Central AOR",
    shortName: "Mountain Central AOR",
    abodeMLSName: "Mountain Central AOR"
  },
  mountain_home_mls_north_central_bor: {
    isActive: true,
    resoID: "M00000033",
    constellation1ID: void 0,
    longName: "Mountain Home MLS/North Central BOR",
    shortName: "Mountain Home MLS/North Central BOR",
    abodeMLSName: "Mountain Home MLS/North Central BOR"
  },
  navarre_area_bor: {
    isActive: true,
    resoID: "M00000153",
    constellation1ID: void 0,
    longName: "Navarre Area BOR",
    shortName: "Navarre Area BOR",
    abodeMLSName: "Navarre Area BOR"
  },
  muscatine_county: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Muscatine County",
    shortName: "Muscatine County",
    abodeMLSName: void 0
  },
  new_canaan_board_of_realtors: {
    isActive: true,
    resoID: "M00000127",
    constellation1ID: void 0,
    longName: "NEW Canaan Association of Realtors MLS",
    shortName: "NEW Canaan Association of Realtors MLS",
    abodeMLSName: "NEW Canaan Association of Realtors MLS"
  },
  new_england_real_estate_network: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "New England Real Estate Network (NEREN)",
    shortName: "New England Real Estate Network (NEREN)",
    abodeMLSName: void 0
  },
  new_jersey_mls: {
    isActive: true,
    resoID: "M00000448",
    constellation1ID: void 0,
    longName: "New Jersey MLS",
    shortName: "New Jersey MLS",
    abodeMLSName: "New Jersey MLS"
  },
  new_mexico_mls: {
    isActive: true,
    resoID: "M00000462",
    constellation1ID: void 0,
    longName: "New Mexico MLS",
    shortName: "New Mexico MLS",
    abodeMLSName: "New Mexico MLS"
  },
  new_river_valley_association_of_realtors_va: {
    isActive: true,
    resoID: "M00000634",
    constellation1ID: void 0,
    longName: "New River Valley Association of Realtors",
    shortName: "New River Valley Association of Realtors",
    abodeMLSName: "New River Valley Association of Realtors"
  },
  new_york_state_alliance_of_mls: {
    isActive: true,
    resoID: "T00000077",
    constellation1ID: void 0,
    longName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)",
    shortName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)",
    abodeMLSName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)"
  },
  norfolk_ne_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Norfolk NE Board of Realtors",
    shortName: "Norfolk NE Board of Realtors",
    abodeMLSName: void 0
  },
  north_alabama_real_estate_information_services_al: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Alabama Real Estate Information Services, AL",
    shortName: "North Alabama Real Estate Information Services, AL",
    abodeMLSName: void 0
  },
  north_central_iowa_regional: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Central Iowa Regional",
    shortName: "North Central Iowa Regional",
    abodeMLSName: void 0
  },
  north_central_washington_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Central Washington Association of Realtors",
    shortName: "North Central Washington Association of Realtors",
    abodeMLSName: void 0
  },
  north_central_west_virginia: {
    isActive: true,
    resoID: "M00000666",
    constellation1ID: void 0,
    longName: "North Central West Virginia Real Estate",
    shortName: "North Central West Virginia Real Estate",
    abodeMLSName: "North Central West Virginia Real Estate"
  },
  northeast_ar_aor: {
    isActive: true,
    resoID: "M00000030",
    constellation1ID: void 0,
    longName: "Northeast AR AOR",
    shortName: "Northeast AR AOR",
    abodeMLSName: "Northeast AR AOR"
  },
  northeast_central_aor_mls: {
    isActive: true,
    resoID: "M00000771",
    constellation1ID: void 0,
    longName: "NorthEast Central AOR MLS",
    shortName: "NorthEast Central AOR MLS",
    abodeMLSName: "NorthEast Central AOR MLS"
  },
  northeast_florida_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northeast Florida MLS",
    shortName: "Northeast Florida MLS",
    abodeMLSName: void 0
  },
  northeast_georgia_board_of_realtors: {
    isActive: true,
    resoID: "M00000848",
    constellation1ID: void 0,
    longName: "Northeast Georgia BOR (NEGBOR)",
    shortName: "Northeast Georgia BOR (NEGBOR)",
    abodeMLSName: "Northeast Georgia BOR (NEGBOR)"
  },
  northeast_ia_regional_mls: {
    isActive: true,
    resoID: "M00000221",
    constellation1ID: void 0,
    longName: "Northeast IA Regional MLS",
    shortName: "Northeast IA Regional MLS",
    abodeMLSName: "Northeast IA Regional MLS"
  },
  northeast_louisiana_board_of_realtors: {
    isActive: true,
    resoID: "M00000303",
    constellation1ID: void 0,
    longName: "Northeast Louisiana Association of Realtors",
    shortName: "Northeast Louisiana Association of Realtors",
    abodeMLSName: "Northeast Louisiana Association of Realtors"
  },
  northeast_mississippi_board_of_realtors: {
    isActive: true,
    resoID: "M00000376",
    constellation1ID: void 0,
    longName: "Northeast Mississippi Board of Realtors",
    shortName: "Northeast Mississippi Board of Realtors",
    abodeMLSName: "Northeast Mississippi Board of Realtors"
  },
  northeast_oklahoma_aor: {
    isActive: true,
    resoID: "M00000515",
    constellation1ID: void 0,
    longName: "Northeast Oklahoma AOR",
    shortName: "Northeast Oklahoma AOR",
    abodeMLSName: "Northeast Oklahoma AOR"
  },
  northeast_wisconsin_association_of_realtors: {
    isActive: true,
    resoID: "M00000657",
    constellation1ID: void 0,
    longName: "Northeast Wisconsin Association of Realtors",
    shortName: "Northeast Wisconsin Association of Realtors",
    abodeMLSName: "Northeast Wisconsin Association of Realtors"
  },
  northern_arizona_assoc_of_realtors: {
    isActive: true,
    resoID: "M00000040",
    constellation1ID: void 0,
    longName: "Northern Arizona Assocation of Realtors MLS",
    shortName: "Northern Arizona Assocation of Realtors MLS",
    abodeMLSName: "Northern Arizona Assocation of Realtors MLS"
  },
  northern_great_lakes_mls: {
    isActive: true,
    resoID: "M00000330",
    constellation1ID: void 0,
    longName: "Northern Great Lakes Realtors MLS",
    shortName: "Northern Great Lakes Realtors MLS",
    abodeMLSName: "Northern Great Lakes Realtors MLS"
  },
  northern_jackson_county_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Jackson County MLS",
    shortName: "Northern Jackson County MLS",
    abodeMLSName: void 0
  },
  northern_kentucky_association_of_realtors: {
    isActive: true,
    resoID: "M00000284",
    constellation1ID: void 0,
    longName: "Northern Kentucky Association of Realtors",
    shortName: "Northern Kentucky Association of Realtors",
    abodeMLSName: "Northern Kentucky Association of Realtors"
  },
  northern_michigan_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Michigan MLS",
    shortName: "Northern Michigan MLS",
    abodeMLSName: void 0
  },
  northern_nevada_regional_mls: {
    isActive: true,
    resoID: "M00000467",
    constellation1ID: void 0,
    longName: "Northern Nevada Regional MLS",
    shortName: "Northern Nevada Regional MLS",
    abodeMLSName: "Northern Nevada Regional MLS"
  },
  northern_santa_barbara_county_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Santa Barbara County MLS",
    shortName: "Northern Santa Barbara County MLS",
    abodeMLSName: void 0
  },
  northwest_arkansas_board_of_realtors_mls: {
    isActive: true,
    resoID: "M00000035",
    constellation1ID: void 0,
    longName: "Northwest Arkansas Associaton of Realtors MLS",
    shortName: "Northwest Arkansas Associaton of Realtors MLS",
    abodeMLSName: "Northwest Arkansas Associaton of Realtors MLS"
  },
  northwest_association_ms: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northwest Association, MS (MLS United)",
    shortName: "Northwest Association, MS (MLS United)",
    abodeMLSName: void 0
  },
  northwest_illinois_alliance_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "NorthWest Illinois Alliance of REALTORS (formerly Rockford Area REALTORS )",
    shortName: "NorthWest Illinois Alliance of REALTORS (formerly Rockford Area REALTORS )",
    abodeMLSName: void 0
  },
  northwest_iowa_regional: {
    isActive: true,
    resoID: "M00000224",
    constellation1ID: void 0,
    longName: "Northwest IA Regionial BOR",
    shortName: "Northwest IA Regionial BOR",
    abodeMLSName: "Northwest IA Regionial BOR"
  },
  northwest_ohio_real_estate_information_systems: {
    isActive: true,
    resoID: "M00000505",
    constellation1ID: void 0,
    longName: "Northwest Ohio Real Estate Information System",
    shortName: "Northwest Ohio Real Estate Information System",
    abodeMLSName: "Northwest Ohio Real Estate Information System"
  },
  northwest_oklahoma_associaton_of_realtors: {
    isActive: true,
    resoID: "M00000514",
    constellation1ID: void 0,
    longName: "Northwest Oklahoma Associaton of Realtors",
    shortName: "Northwest Oklahoma Associaton of Realtors",
    abodeMLSName: "Northwest Oklahoma Associaton of Realtors"
  },
  northwest_wyoming_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northwest Wyoming Board of Realtors",
    shortName: "Northwest Wyoming Board of Realtors",
    abodeMLSName: void 0
  },
  northwoods_association_of_realtors: {
    isActive: true,
    resoID: "M00000663",
    constellation1ID: void 0,
    longName: "Northwoods Association of Realtors",
    shortName: "Northwoods Association of Realtors",
    abodeMLSName: "Northwoods Association of Realtors"
  },
  odessa_bor: {
    isActive: true,
    resoID: "M00000736",
    constellation1ID: void 0,
    longName: "Odessa BOR",
    shortName: "Odessa BOR",
    abodeMLSName: "Odessa BOR"
  },
  oregon_data_share: {
    isActive: true,
    resoID: "T00000038",
    constellation1ID: void 0,
    longName: "Oregon Data Share",
    shortName: "Oregon Data Share",
    abodeMLSName: "Oregon Data Share"
  },
  outer_banks_association_of_realtors: {
    isActive: true,
    resoID: "M00000409",
    constellation1ID: void 0,
    longName: "Outer Banks Association of Realtors",
    shortName: "Outer Banks Association of Realtors",
    abodeMLSName: "Outer Banks Association of Realtors"
  },
  ozark_gateway_association_of_realtors: {
    isActive: true,
    resoID: "M00000354",
    constellation1ID: void 0,
    longName: "Ozark Gateway AOR",
    shortName: "Ozark Gateway AOR",
    abodeMLSName: "Ozark Gateway AOR"
  },
  pacific_regional_mls: {
    isActive: true,
    resoID: "M00000648",
    constellation1ID: void 0,
    longName: "Pacific Regional MLS",
    shortName: "Pacific Regional MLS",
    abodeMLSName: "Pacific Regional MLS"
  },
  park_city_board_of_realtors: {
    isActive: true,
    resoID: "M00000627",
    constellation1ID: void 0,
    longName: "Park City Board Services",
    shortName: "Park City Board Services",
    abodeMLSName: "Park City Board Services"
  },
  pensacola_association_of_realtors: {
    isActive: true,
    resoID: "M00000161",
    constellation1ID: void 0,
    longName: "Pensacola Association of Realtors",
    shortName: "Pensacola Association of Realtors",
    abodeMLSName: "Pensacola Association of Realtors"
  },
  perchwell: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Perchwell (NYC)",
    shortName: "Perchwell (NYC)",
    abodeMLSName: void 0
  },
  permian_basin_board_of_realtors: {
    isActive: true,
    resoID: "M00000737",
    constellation1ID: void 0,
    longName: "Permian Basin Association of Realtors",
    shortName: "Permian Basin Association of Realtors",
    abodeMLSName: "Permian Basin Association of Realtors"
  },
  pike_wayne_association_of_realtors: {
    isActive: true,
    resoID: "M00000721",
    constellation1ID: void 0,
    longName: "Pike Wayne Association of Realtors",
    shortName: "Pike Wayne Association of Realtors",
    abodeMLSName: "Pike Wayne Association of Realtors"
  },
  pikes_peak_association_of_realtors: {
    isActive: true,
    resoID: "M00000111",
    constellation1ID: void 0,
    longName: "Pikes Peak REALTOR Services Corporation",
    shortName: "Pikes Peak REALTOR Services Corporation",
    abodeMLSName: "Pikes Peak REALTOR Services Corporation"
  },
  pinehurst_southern_pines_area_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Pinehurst Southern Pines Area Association of Realtors",
    shortName: "Pinehurst Southern Pines Area Association of Realtors",
    abodeMLSName: void 0
  },
  plumas_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Plumas Association of Realtors",
    shortName: "Plumas Association of Realtors",
    abodeMLSName: void 0
  },
  pocono_mountain_mls: {
    isActive: true,
    resoID: "M00000552",
    constellation1ID: void 0,
    longName: "Pocono Mountains Association of Realtors",
    shortName: "Pocono Mountains Association of Realtors",
    abodeMLSName: "Pocono Mountains Association of Realtors"
  },
  port_neches_port_arthur_and_nederland_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Port Neches Port Arthur and Nederland Board of REALTORS",
    shortName: "Port Neches Port Arthur and Nederland Board of REALTORS",
    abodeMLSName: void 0
  },
  prescott_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000044",
    constellation1ID: void 0,
    longName: "Presott Area Association of Realtors MLS",
    shortName: "Presott Area Association of Realtors MLS",
    abodeMLSName: "Presott Area Association of Realtors MLS"
  },
  pueblo_association: {
    isActive: true,
    resoID: "M00000120",
    constellation1ID: void 0,
    longName: "Pueblo Board of Realtors MLS",
    shortName: "Pueblo Board of Realtors MLS",
    abodeMLSName: "Pueblo Board of Realtors MLS"
  },
  quad_city_area: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Quad City Area",
    shortName: "Quad City Area",
    abodeMLSName: void 0
  },
  range_area_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Range Area MLS",
    shortName: "Range Area MLS",
    abodeMLSName: void 0
  },
  real_comp: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Real Comp",
    shortName: "Real Comp",
    abodeMLSName: void 0
  },
  real_estate_board_of_new_york_620a: {
    isActive: true,
    resoID: "T00000046",
    constellation1ID: void 0,
    longName: "Real Estate Board of NEW York 620A",
    shortName: "Real Estate Board of NEW York 620A",
    abodeMLSName: "Real Estate Board of NEW York 620A"
  },
  real_estate_information_network: {
    isActive: true,
    resoID: "M00000646",
    constellation1ID: void 0,
    longName: "Real Estate Information Network",
    shortName: "Real Estate Information Network",
    abodeMLSName: "Real Estate Information Network"
  },
  real_estate_information_services: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Real Estate Information Services (REALTOR Association of Southern Kentucky)",
    shortName: "Real Estate Information Services (REALTOR Association of Southern Kentucky)",
    abodeMLSName: void 0
  },
  realtor_association_of_citrus_county: {
    isActive: true,
    resoID: "M00000145",
    constellation1ID: void 0,
    longName: "Realtor Association of Citrus County",
    shortName: "Realtor Association of Citrus County",
    abodeMLSName: "Realtor Association of Citrus County"
  },
  realtor_association_of_franklin_and_southern_gulf_counties: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtor Association of Franklin and Southern Gulf Counties",
    shortName: "Realtor Association of Franklin and Southern Gulf Counties",
    abodeMLSName: void 0
  },
  realtor_association_of_the_greater_pee_dee_sc: {
    isActive: true,
    resoID: "M00000703",
    constellation1ID: void 0,
    longName: "Realtor Association of Greater Pee Dee",
    shortName: "Realtor Association of Greater Pee Dee",
    abodeMLSName: "Realtor Association of Greater Pee Dee"
  },
  realtor_association_of_martin_county_fl: {
    isActive: true,
    resoID: "M00000165",
    constellation1ID: void 0,
    longName: "Realtor Association of Martin County FL",
    shortName: "Realtor Association of Martin County FL",
    abodeMLSName: "Martin County Realtors of the Treasure coast Inc"
  },
  realtor_association_of_southern_kentucky: {
    isActive: true,
    resoID: "M00000281",
    constellation1ID: void 0,
    longName: "REALTOR Association of Southern Kentucky",
    shortName: "REALTOR Association of Southern Kentucky",
    abodeMLSName: "REALTOR Association of Southern Kentucky"
  },
  realtor_association_of_new_mexico: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtor Association of New Mexico",
    shortName: "Realtor Association of New Mexico",
    abodeMLSName: void 0
  },
  realtor_association_of_sioux_empire: {
    isActive: true,
    resoID: "M00000572",
    constellation1ID: void 0,
    longName: "Realtor Association of the Sioux Empire",
    shortName: "Realtor Association of the Sioux Empire",
    abodeMLSName: "Realtor Association of the Sioux Empire"
  },
  realtor_association_of_southern_minnesota: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "REALTOR Association of Southern Minnesota",
    shortName: "REALTOR Association of Southern Minnesota",
    abodeMLSName: void 0
  },
  realtors_association_greater_fort_myers_the_beach: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association Greater Fort Myers & The Beach",
    shortName: "Realtors Association Greater Fort Myers & The Beach",
    abodeMLSName: void 0
  },
  realtors_association_of_acadiana: {
    isActive: true,
    resoID: "M00000300",
    constellation1ID: void 0,
    longName: "Realtors Association of Acadiana",
    shortName: "Realtors Association of Acadiana",
    abodeMLSName: "Realtors Association of Acadiana"
  },
  realtors_association_of_indian_river_county: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association of Indian River County",
    shortName: "Realtors Association of Indian River County",
    abodeMLSName: void 0
  },
  realtors_association_of_maui: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association of Maui",
    shortName: "Realtors Association of Maui",
    abodeMLSName: void 0
  },
  realtors_association_of_northeast_wisconsin: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "REALTORS Association of Northeast Wisconsin",
    shortName: "REALTORS Association of Northeast Wisconsin",
    abodeMLSName: void 0
  },
  realtors_association_of_northwestern_wisconsin: {
    isActive: true,
    resoID: "M00000658",
    constellation1ID: void 0,
    longName: "Realtors Association of Northwest Wisconsin",
    shortName: "Realtors Association of Northwest Wisconsin",
    abodeMLSName: "Realtors Association of Northwest Wisconsin"
  },
  regional_multiple_listing_service_of_minnesota: {
    isActive: true,
    resoID: "M00000343",
    constellation1ID: void 0,
    longName: "Realtors Association of Southern MN",
    shortName: "Realtors Association of Southern MN",
    abodeMLSName: "Realtors Association of Southern MN"
  },
  rhode_island_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Rhode Island Association of Realtors (State-Wide MLS)",
    shortName: "Rhode Island Association of Realtors (State-Wide MLS)",
    abodeMLSName: void 0
  },
  rio_grande_valley_mls: {
    isActive: true,
    resoID: "M00000598",
    constellation1ID: void 0,
    longName: "Rio Grande Valley MLS",
    shortName: "Rio Grande Valley MLS",
    abodeMLSName: "Rio Grande Valley MLS"
  },
  river_counties_association_of_realtors: {
    isActive: true,
    resoID: "M00000577",
    constellation1ID: void 0,
    longName: "River Counties AOR",
    shortName: "River Counties AOR",
    abodeMLSName: "River Counties AOR"
  },
  roanoke_valley_association_of_realtors: {
    isActive: true,
    resoID: "M00000644",
    constellation1ID: void 0,
    longName: "Roanoke Valley Association of REALTORS",
    shortName: "Roanoke Valley Association of REALTORS",
    abodeMLSName: "Roanoke Valley Association of REALTORS"
  },
  rockford_area_association_of_realtors: {
    isActive: true,
    resoID: "M00000818",
    constellation1ID: void 0,
    longName: "Rockford Area Association of Realtors",
    shortName: "Rockford Area Association of Realtors",
    abodeMLSName: "Rockford Area Association of Realtors"
  },
  roswell_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Roswell Board of Realtors",
    shortName: "Roswell Board of Realtors",
    abodeMLSName: void 0
  },
  royal_gorge_association_of_realtors: {
    isActive: true,
    resoID: "M00000110",
    constellation1ID: void 0,
    longName: "Royal Gorge AOR",
    shortName: "Royal Gorge AOR",
    abodeMLSName: "Royal Gorge AOR"
  },
  ruidosolincoln_county_association_or_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ruidoso/Lincoln County Association or Realtors",
    shortName: "Ruidoso/Lincoln County Association or Realtors",
    abodeMLSName: void 0
  },
  saginaw_board_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Saginaw Board of Realtors",
    shortName: "Saginaw Board of Realtors",
    abodeMLSName: void 0
  },
  san_angelo_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "San Angelo Association of Realtors",
    shortName: "San Angelo Association of Realtors",
    abodeMLSName: void 0
  },
  san_diego_regional_mls: {
    isActive: true,
    resoID: "M00000846",
    constellation1ID: void 0,
    longName: "San Diego Regional MLS",
    shortName: "San Diego Regional MLS",
    abodeMLSName: "San Diego Regional MLS"
  },
  san_francisco_association_of_realtors: {
    isActive: true,
    resoID: "M00000094",
    constellation1ID: void 0,
    longName: "San Francisco Multiple Listing Service",
    shortName: "San Francisco Multiple Listing Service",
    abodeMLSName: "San Francisco Multiple Listing Service"
  },
  san_juan_county_board_of_realtors_inc: {
    isActive: true,
    resoID: "M00000785",
    constellation1ID: void 0,
    longName: "San Juan County Board of Realtors Inc.",
    shortName: "San Juan County Board of Realtors Inc.",
    abodeMLSName: "San Juan County Board of Realtors Inc."
  },
  sandicor: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Sandicor",
    shortName: "Sandicor",
    abodeMLSName: void 0
  },
  sanibel_captiva_islands_aor: {
    isActive: true,
    resoID: "M00000163",
    constellation1ID: void 0,
    longName: "Sanibel & Captiva Islands AOR",
    shortName: "Sanibel & Captiva Islands AOR",
    abodeMLSName: "Sanibel & Captiva Islands AOR"
  },
  santa_barbara_association_of_realtors: {
    isActive: true,
    resoID: "M00000096",
    constellation1ID: void 0,
    longName: "Santa Barbara Multiple Listing Service",
    shortName: "Santa Barbara Multiple Listing Service",
    abodeMLSName: "Santa Barbara Multiple Listing Service"
  },
  santa_fe_association_of_realtors: {
    isActive: true,
    resoID: "M00000461",
    constellation1ID: void 0,
    longName: "Santa Fe MLS",
    shortName: "Santa Fe MLS",
    abodeMLSName: "Santa Fe MLS"
  },
  santa_ynez_aor: {
    isActive: true,
    resoID: "M00000820",
    constellation1ID: void 0,
    longName: "Santa Ynez AOR (North Santa Barbara County MLS)",
    shortName: "Santa Ynez AOR (North Santa Barbara County MLS)",
    abodeMLSName: "Santa Ynez AOR (North Santa Barbara County MLS)"
  },
  savannah_board_of_realtors_ga: {
    isActive: true,
    resoID: "M00000751",
    constellation1ID: void 0,
    longName: "Savannah Multi-List",
    shortName: "Savannah Multi-List",
    abodeMLSName: "Savannah Multi-List"
  },
  sedona_verde_valley_association_of_realtors: {
    isActive: true,
    resoID: "M00000048",
    constellation1ID: void 0,
    longName: "Sedona-Verde Association of Realtors MLS",
    shortName: "Sedona-Verde Association of Realtors MLS",
    abodeMLSName: "Sedona-Verde Association of Realtors MLS"
  },
  selkirk_aor: {
    isActive: true,
    resoID: "M00000235",
    constellation1ID: void 0,
    longName: "Selkirk AOR",
    shortName: "Selkirk AOR",
    abodeMLSName: "Selkirk AOR"
  },
  shasta_association_of_realtors: {
    isActive: true,
    resoID: "M00000090",
    constellation1ID: void 0,
    longName: "Shasta Association of Realtors",
    shortName: "Shasta Association of Realtors",
    abodeMLSName: "Shasta Association of Realtors"
  },
  shoals: {
    isActive: true,
    resoID: "M00000012",
    constellation1ID: void 0,
    longName: "Shoals",
    shortName: "Shoals",
    abodeMLSName: "Strategic MLS:Cullman"
  },
  snake_river_mls: {
    isActive: true,
    resoID: "M00000228",
    constellation1ID: void 0,
    longName: "Snake River Association of Realtors",
    shortName: "Snake River Association of Realtors",
    abodeMLSName: "Snake River Association of Realtors"
  },
  south_carolina_statewide_commercial_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South Carolina Statewide Commercial MLS",
    shortName: "South Carolina Statewide Commercial MLS",
    abodeMLSName: void 0
  },
  south_central_association_of_realtors: {
    isActive: true,
    resoID: "M00000637",
    constellation1ID: void 0,
    longName: "South Central AOR MLS",
    shortName: "South Central AOR MLS",
    abodeMLSName: "South Central AOR MLS"
  },
  south_central_kansas_mls: {
    isActive: true,
    resoID: "M00000277",
    constellation1ID: void 0,
    longName: "South Central Kansas MLS",
    shortName: "South Central Kansas MLS",
    abodeMLSName: "South Central Kansas MLS"
  },
  south_central_kentucky_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South Central Kentucky Association of Realtors",
    shortName: "South Central Kentucky Association of Realtors",
    abodeMLSName: void 0
  },
  south_central_wisconsin_multiple_listing_service: {
    isActive: true,
    resoID: "M00000662",
    constellation1ID: void 0,
    longName: "South Central Wisconsin MLS",
    shortName: "South Central Wisconsin MLS",
    abodeMLSName: "South Central Wisconsin MLS"
  },
  south_east_ks_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South East KS MLS",
    shortName: "South East KS MLS",
    abodeMLSName: void 0
  },
  south_ga_mls: {
    isActive: true,
    resoID: "M00000756",
    constellation1ID: void 0,
    longName: "South GA MLS",
    shortName: "South GA MLS",
    abodeMLSName: "South GA MLS"
  },
  south_jersey_shore_regional_mls: {
    isActive: true,
    resoID: "M00000446",
    constellation1ID: void 0,
    longName: "South Jersey Shore Regional MLS",
    shortName: "South Jersey Shore Regional MLS",
    abodeMLSName: "South Jersey Shore Regional MLS"
  },
  south_lake_tahoe_association_of_realtors: {
    isActive: true,
    resoID: "M00000100",
    constellation1ID: void 0,
    longName: "South Tahoe Association of REALTORS",
    shortName: "South Tahoe Association of REALTORS",
    abodeMLSName: "South Tahoe Association of REALTORS"
  },
  southeast_alabama_aor_mls: {
    isActive: true,
    resoID: "M00000013",
    constellation1ID: void 0,
    longName: "Southeast Alabama AOR/MLS (Dothan)",
    shortName: "Southeast Alabama AOR/MLS (Dothan)",
    abodeMLSName: "Southeast Alabama AOR/MLS (Dothan)"
  },
  southeast_texas_bor: {
    isActive: true,
    resoID: "M00000591",
    constellation1ID: void 0,
    longName: "Southeast Texas BOR",
    shortName: "Southeast Texas BOR",
    abodeMLSName: "Southeast Texas BOR"
  },
  southeastern_indiana_board_of_realtors_in: {
    isActive: true,
    resoID: "M00000251",
    constellation1ID: void 0,
    longName: "Southeastern Indiana BOR",
    shortName: "Southeastern Indiana BOR",
    abodeMLSName: "Southeastern Indiana BOR"
  },
  southern_indiana_realtors_association: {
    isActive: true,
    resoID: "M00000252",
    constellation1ID: void 0,
    longName: "Southern Indiana Realtor Associaion",
    shortName: "Southern Indiana Realtor Associaion",
    abodeMLSName: "Southern Indiana Realtor Associaion"
  },
  southern_missouri_regional_mls: {
    isActive: true,
    resoID: "M00000748",
    constellation1ID: void 0,
    longName: "Southern Missouri Regional MLS",
    shortName: "Southern Missouri Regional MLS",
    abodeMLSName: "Southern Missouri Regional MLS"
  },
  southern_new_mexico_mls: {
    isActive: true,
    resoID: "M00000457",
    constellation1ID: void 0,
    longName: "Southern New Mexico MLS",
    shortName: "Southern New Mexico MLS",
    abodeMLSName: "Southern New Mexico MLS"
  },
  southern_oregon_mls: {
    isActive: true,
    resoID: "M00000530",
    constellation1ID: void 0,
    longName: "Southern Oregon MLS",
    shortName: "Southern Oregon MLS",
    abodeMLSName: "Southern Oregon MLS"
  },
  southwest_georgia_board_of_realtors: {
    isActive: true,
    resoID: "M00000179",
    constellation1ID: void 0,
    longName: "Southwest Georgia Board of Realtors",
    shortName: "Southwest Georgia Board of Realtors",
    abodeMLSName: "Southwest Georgia Board of Realtors"
  },
  southwest_mls: {
    isActive: true,
    resoID: "M00000456",
    constellation1ID: void 0,
    longName: "Southwest MLS",
    shortName: "Southwest MLS",
    abodeMLSName: "Southwest MLS"
  },
  southwest_virginia_association_of_realtors_va: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Southwest Virginia Association of Realtors, VA",
    shortName: "Southwest Virginia Association of Realtors, VA",
    abodeMLSName: void 0
  },
  southwestern_michigan_regional_information_center: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Southwestern Michigan Regional Information Center",
    shortName: "Southwestern Michigan Regional Information Center",
    abodeMLSName: void 0
  },
  spartanburg_board_of_realtors_multiple_listing_service_of_spartanburg: {
    isActive: true,
    resoID: "M00000568",
    constellation1ID: void 0,
    longName: "Spartanburg Board of Realtors / Multiple Listing Service of Spartanburg",
    shortName: "Spartanburg Board of Realtors / Multiple Listing Service of Spartanburg",
    abodeMLSName: "MLS of Spartanburg"
  },
  spokane_association_of_realtors: {
    isActive: true,
    resoID: "M00000653",
    constellation1ID: void 0,
    longName: "Spokane Association of Realtors",
    shortName: "Spokane Association of Realtors",
    abodeMLSName: "Spokane Association of Realtors"
  },
  st_augustine_st_johns_county_board_of_realtors: {
    isActive: true,
    resoID: "M00000164",
    constellation1ID: void 0,
    longName: "St. Augustine & St. Johns County BOR",
    shortName: "St. Augustine & St. Johns County BOR",
    abodeMLSName: "St. Augustine & St. Johns County BOR"
  },
  staten_island_bor: {
    isActive: true,
    resoID: "M00000487",
    constellation1ID: void 0,
    longName: "Staten Island BOR",
    shortName: "Staten Island BOR",
    abodeMLSName: "Staten Island BOR"
  },
  statewide_mls: {
    isActive: true,
    resoID: "M00000554",
    constellation1ID: void 0,
    longName: "Statewide MLS",
    shortName: "Statewide MLS",
    abodeMLSName: "Statewide MLS"
  },
  summit_mls: {
    isActive: true,
    resoID: "M00000113",
    constellation1ID: void 0,
    longName: "Summit County AOR",
    shortName: "Summit County AOR",
    abodeMLSName: "Summit County AOR"
  },
  sumter_association_of_realtors: {
    isActive: true,
    resoID: "M00000569",
    constellation1ID: void 0,
    longName: "Sumter Board of Realtors",
    shortName: "Sumter Board of Realtors",
    abodeMLSName: "Sumter Board of Realtors"
  },
  sun_valley_board_of_realtors: {
    isActive: true,
    resoID: "M00000229",
    constellation1ID: void 0,
    longName: "Sun Valley Board of Realtors",
    shortName: "Sun Valley Board of Realtors",
    abodeMLSName: "Sun Valley Board of Realtors"
  },
  sunflower_association_of_realtors: {
    isActive: true,
    resoID: "M00000276",
    constellation1ID: void 0,
    longName: "Sunflower Association of Realtors",
    shortName: "Sunflower Association of Realtors",
    abodeMLSName: "Sunflower Association of Realtors"
  },
  sunshine_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Sunshine MLS",
    shortName: "Sunshine MLS",
    abodeMLSName: void 0
  },
  tahoe_sierra_board_of_realtors: {
    isActive: true,
    resoID: "M00000079",
    constellation1ID: void 0,
    longName: "Tahoe - Sierra MLS",
    shortName: "Tahoe - Sierra MLS",
    abodeMLSName: "Tahoe - Sierra MLS"
  },
  tallahassee_board_of_realtors: {
    isActive: true,
    resoID: "M00000166",
    constellation1ID: void 0,
    longName: "Tallahassee Board of Realtors MLS",
    shortName: "Tallahassee Board of Realtors MLS",
    abodeMLSName: "Tallahassee Board of Realtors MLS"
  },
  taos_county_association_of_realtors_nm: {
    isActive: true,
    resoID: "M00000464",
    constellation1ID: void 0,
    longName: "Taos County Association of Realtors",
    shortName: "Taos County Association of Realtors",
    abodeMLSName: "Taos County Association of Realtors"
  },
  tehachapi_area_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tehachapi Area Association of Realtors",
    shortName: "Tehachapi Area Association of Realtors",
    abodeMLSName: void 0
  },
  telluride_association_of_realtors: {
    isActive: true,
    resoID: "M00000122",
    constellation1ID: void 0,
    longName: "Telluride AOR",
    shortName: "Telluride AOR",
    abodeMLSName: "Telluride AOR"
  },
  tennessee_virginia_regional_mls: {
    isActive: true,
    resoID: "M00000580",
    constellation1ID: void 0,
    longName: "Tennessee Virginia Regional MLS",
    shortName: "Tennessee Virginia Regional MLS",
    abodeMLSName: "Tennessee Virginia Regional MLS"
  },
  terra_haute_association_of_realtors: {
    isActive: true,
    resoID: "M00000261",
    constellation1ID: void 0,
    longName: "Terre Haute Area Association of Realtors",
    shortName: "Terre Haute Area Association of Realtors",
    abodeMLSName: "Terre Haute Area Association of Realtors"
  },
  teton_board_of_realtors: {
    isActive: true,
    resoID: "M00000678",
    constellation1ID: void 0,
    longName: "Teton County Board of Realtors",
    shortName: "Teton County Board of Realtors",
    abodeMLSName: "Teton County Board of Realtors"
  },
  the_heart_of_kentucky_association_of_realtors: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "The Heart Of Kentucky Association of Realtors",
    shortName: "The Heart Of Kentucky Association of Realtors",
    abodeMLSName: void 0
  },
  the_lake_superior_area_mls: {
    isActive: true,
    resoID: "M00000337",
    constellation1ID: void 0,
    longName: "The Lake Superior Area MLS",
    shortName: "The Lake Superior Area MLS",
    abodeMLSName: "Lake Superior Area of Realtors"
  },
  tri_city_association_of_realtors_pacific_regional_mls: {
    isActive: false,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tri City Association of Realtors / Pacific Regional MLS",
    shortName: "Tri City Association of Realtors / Pacific Regional MLS",
    abodeMLSName: void 0
  },
  valley_mls: {
    isActive: true,
    resoID: "M00000017",
    constellation1ID: void 0,
    longName: "Valley MLS",
    shortName: "Valley MLS",
    abodeMLSName: "Valley MLS"
  },
  west_alabama_mls: {
    isActive: true,
    resoID: "M00000024",
    constellation1ID: void 0,
    longName: "West Alabama MLS",
    shortName: "West Alabama MLS",
    abodeMLSName: "West Alabama MLS"
  },
  west_central_aor: {
    isActive: true,
    resoID: "M00000357",
    constellation1ID: void 0,
    longName: "West Central AOR",
    shortName: "West Central AOR",
    abodeMLSName: "West Central AOR"
  },
  western_arizona_real_estate_data_exchange: {
    isActive: true,
    resoID: "M00000039",
    constellation1ID: void 0,
    longName: "Western Arizona Real Estate Data Exchange",
    shortName: "Western Arizona Real Estate Data Exchange",
    abodeMLSName: "Western Arizona Real Estate Data Exchange"
  },
  western_kentucky_regional_mls: {
    isActive: true,
    resoID: "M00000280",
    constellation1ID: void 0,
    longName: "Western Kentucky Regional MLS (Pennyrile AOR)",
    shortName: "Western Kentucky Regional MLS (Pennyrile AOR)",
    abodeMLSName: "Western Kentucky Regional MLS (Pennyrile AOR)"
  }
});
var schMLSID = z9.enum([...MLS._keys]);

// src/mls/mlsOUIDs.ts
import { z as z10 } from "zod";
var schMLSOUID = z10.enum([
  "M00000315",
  "M00000483",
  "M00000555",
  "M00000001",
  "M00000172",
  "M00000588",
  "M00000136",
  "M00000048",
  "M00000278",
  "M00000109",
  "M00000589",
  "M00000427",
  "M00000355",
  "M00000053",
  "M00000022",
  "M00000097",
  "M00000105",
  "M00000170",
  "M00000170",
  "M00000305",
  "M00000055",
  "M00000378",
  "M00000571",
  "M00000821",
  "M00000309",
  "M00000471",
  "M00000592",
  "M00000052",
  "M00000093",
  "M00000093",
  "M00000391",
  "M00000307",
  "M00000447",
  "M00000395",
  "M00000752",
  "M00000200",
  "M00000043",
  "M00000190",
  "M00000596",
  "M00000450",
  "M00000525",
  "M00000159",
  "M00000538",
  "M00000581",
  "M00000610",
  "M00000643",
  "M00000558",
  "M00000633",
  "M00000675",
  "M00000177",
  "M00000565",
  "M00000227",
  "M00000684",
  "M00000349",
  "M00000476",
  "M00000753",
  "M00000071",
  "M00000559",
  "M00000031",
  "M00000593",
  "M00000496",
  "M00000140",
  "M00000204",
  "M00000082",
  "M00000631",
  "M00000138",
  "M00000428",
  "M00000504",
  "M00000271",
  "M00000168",
  "M00000853",
  "M00000129",
  "M00000060",
  "M00000379",
  "M00000597",
  "M00000449",
  "M00000188",
  "M00000468",
  "M00000429",
  "M00000729",
  "M00000107",
  "M00000441",
  "M00000010",
  "M00000084",
  "M00000176",
  "M00000298",
  "M00000470",
  "M00000575",
  "M00000595",
  "M00000540",
  "M00000002",
  "M00000365",
  "M00000322",
  "M00000466",
  "M00000534",
  "M00000290",
  "M00000608",
  "M00000259",
  "M00000536",
  "M00000083",
  "M00000621",
  "M00000669",
  "M00000125",
  "M00000018",
  "M00000065",
  "M00000367",
  "M00000193",
  "M00000205",
  "M00000270",
  "M00000740",
  "M00000131",
  "M00000194",
  "M00000387",
  "M00000606",
  "M00000390",
  "M00000564",
  "M00000029",
  "M00000599",
  "M00000784",
  "M00000479",
  "M00000668",
  "M00000058",
  "M00000465",
  "M00000169",
  "M00000256",
  "M00000225",
  "M00000206",
  "M00000118",
  "M00000353",
  "M00000667",
  "M00000600",
  "M00000582",
  "M00000832",
  "M00000004",
  "M00000337",
  "M00000584",
  "M00000603",
  "M00000269",
  "M00000008",
  "M00000288",
  "M00000394",
  "M00000604",
  "M00000557",
  "M00000811",
  "M00000545",
  "M00000641",
  "M00000311",
  "M00000073",
  "M00000148",
  "M00000165",
  "M00000195",
  "M00000583",
  "M00000091",
  "M00000255",
  "M00000331",
  "M00000151",
  "T00000006",
  "M00000360",
  "M00000184",
  "M00000574",
  "M00000243",
  "M00000431",
  "M00000101",
  "M00000830",
  "M00000495",
  "M00000494",
  "M00000519",
  "M00000049",
  "M00000568",
  "M00000306",
  "M00000521",
  "M00000070",
  "M00000452",
  "M00000383",
  "M00000020",
  "M00000573",
  "M00000231",
  "M00000033",
  "M00000153",
  "M00000127",
  "M00000445",
  "M00000448",
  "M00000462",
  "M00000634",
  "T00000077",
  "M00000722",
  "M00000666",
  "M00000594",
  "M00000030",
  "M00000771",
  "M00000141",
  "M00000848",
  "M00000221",
  "M00000303",
  "M00000376",
  "M00000515",
  "M00000657",
  "M00000040",
  "M00000330",
  "M00000284",
  "M00000467",
  "M00000345",
  "M00000035",
  "M00000224",
  "M00000650",
  "M00000505",
  "M00000514",
  "M00000663",
  "M00000736",
  "M00000489",
  "T00000038",
  "M00000409",
  "M00000354",
  "M00000648",
  "M00000627",
  "M00000161",
  "M00000737",
  "M00000721",
  "M00000111",
  "M00000233",
  "M00000552",
  "M00000044",
  "M00000120",
  "T00000046",
  "M00000646",
  "M00000316",
  "M00000145",
  "M00000703",
  "M00000281",
  "M00000572",
  "M00000300",
  "M00000658",
  "M00000343",
  "M00000116",
  "M00000531",
  "M00000598",
  "M00000577",
  "M00000852",
  "M00000644",
  "M00000818",
  "M00000110",
  "M00000616",
  "M00000846",
  "M00000094",
  "M00000785",
  "M00000163",
  "M00000096",
  "M00000461",
  "M00000820",
  "M00000751",
  "M00000048",
  "M00000235",
  "M00000090",
  "M00000127",
  "M00000228",
  "M00000637",
  "M00000277",
  "M00000662",
  "M00000756",
  "M00000446",
  "M00000100",
  "M00000013",
  "M00000591",
  "M00000251",
  "M00000252",
  "M00000748",
  "M00000457",
  "M00000530",
  "M00000179",
  "M00000456",
  "M00000150",
  "M00000653",
  "M00000164",
  "M00000487",
  "M00000554",
  "M00000146",
  "M00000012",
  "M00000113",
  "M00000569",
  "M00000229",
  "M00000276",
  "M00000130",
  "M00000079",
  "M00000166",
  "M00000464",
  "M00000122",
  "M00000580",
  "M00000261",
  "M00000678",
  "M00000400",
  "M00000389",
  "M00000104",
  "M00000324",
  "M00000114",
  "M00000017",
  "M00000594",
  "M00000711",
  "M00000628",
  "M00000629",
  "M00000317",
  "M00000024",
  "M00000799",
  "M00000357",
  "M00000735",
  "M00000549",
  "M00000039",
  "M00000280",
  "M00000506",
  "M00000556",
  "M00000042",
  "M00000625",
  "M00000532",
  "M00000858",
  "M00000679",
  "M00000656",
  "M00000050"
]);

// src/mls/isMLSID.ts
function isMLSID(x) {
  return typeof x === "string" && MLS._isKey(x);
}

// src/mls/isMLSOUID.ts
function isMLSOUID(x) {
  return schMLSOUID.safeParse(x).success;
}

// src/mls/mlsInfoByConstellation1ID.ts
var import_shared_utils4 = __toESM(require_lib(), 1);

// src/mls/mlsInfoByMLSID.ts
var import_shared_utils3 = __toESM(require_lib(), 1);
function mlsInfoByMLSID(mlsid) {
  return { mlsid, ...(0, import_shared_utils3.expected)(MLS[mlsid], `Invalid MLSID: ${mlsid}`) };
}

// src/mls/mlsInfoByConstellation1ID.ts
var _constellation1IDToMLSID = /* @__PURE__ */ new Map();
for (const mlsid of MLS._keys) {
  const { constellation1ID } = MLS[mlsid];
  if (constellation1ID !== void 0) {
    _constellation1IDToMLSID.set(constellation1ID, mlsid);
  }
}
function mlsInfoByConstellation1ID(id) {
  if ((0, import_shared_utils4.isUndefined)(id)) {
    return void 0;
  }
  const mlsid = _constellation1IDToMLSID.get(id);
  if (mlsid === void 0)
    return void 0;
  return mlsInfoByMLSID(mlsid);
}

// src/mls/getMLSNameBySource.ts
var import_shared_utils5 = __toESM(require_lib(), 1);
function getMLSNameBySource(mlsID, source) {
  if ([mlsID, source].some(import_shared_utils5.isUndefined)) {
    return void 0;
  }
  switch (source) {
    case "constellation1":
      const mlsInfo = mlsInfoByMLSID(mlsID);
      if (mlsInfo.isActive === false)
        return "OSN Unknown";
      return mlsInfo.constellation1ID;
    default:
      throw new Error(`Unrecognized source: ${source}`);
  }
}

// src/mls/mlsInfoByShortName.ts
var import_shared_utils6 = __toESM(require_lib(), 1);
var _shortNameToMLSID = /* @__PURE__ */ new Map();
for (const mlsid of MLS._keys) {
  const { shortName } = MLS[mlsid];
  if (shortName !== void 0) {
    _shortNameToMLSID.set(shortName.toLowerCase(), mlsid);
  }
}
function mlsInfoByShortName(id) {
  if ((0, import_shared_utils6.isUndefined)(id)) {
    return void 0;
  }
  const mlsid = _shortNameToMLSID.get(id.toLowerCase());
  if (mlsid === void 0)
    return void 0;
  return mlsInfoByMLSID(mlsid);
}

// src/mls/mlsInfoByAbodeName.ts
var import_shared_utils7 = __toESM(require_lib(), 1);
var _abodeNameToMLSID = /* @__PURE__ */ new Map();
for (const mlsid of MLS._keys) {
  const { abodeMLSName } = MLS[mlsid];
  if (abodeMLSName !== void 0) {
    _abodeNameToMLSID.set(abodeMLSName.toLowerCase(), mlsid);
  }
}
function mlsInfoByAbodeName(id) {
  if ((0, import_shared_utils7.isUndefined)(id)) {
    return void 0;
  }
  const mlsid = _abodeNameToMLSID.get(id.toLowerCase());
  if (mlsid === void 0)
    return void 0;
  return mlsInfoByMLSID(mlsid);
}

// src/mls/mlsOUIDByAbodeName.ts
var mlsOUIDByAbodeMLSName = (abodeMLSName) => {
  const mls = MLS._values.find((mls2) => mls2.abodeMLSName === abodeMLSName);
  return mls ? mls.resoID : void 0;
};

// src/mls/mlsOUIDByMLSID.ts
var import_shared_utils8 = __toESM(require_lib(), 1);
var mlsOUIDByMLSID = (mlsid) => {
  const mls = (0, import_shared_utils8.expected)(MLS[mlsid], `Invalid MLSID: ${mlsid}`);
  return mls.resoID;
};

// src/mls/mlsInfoByOUID.ts
var import_shared_utils9 = __toESM(require_lib(), 1);
function buildOUIDMap() {
  const map = /* @__PURE__ */ new Map();
  MLS._keys.forEach((mlsid) => {
    const { resoID } = MLS[mlsid];
    if (resoID) {
      map.set(resoID.toLowerCase(), mlsid);
    }
  });
  return map;
}
var _ouidToMLSID = buildOUIDMap();
function mlsInfoByOUID(ouid) {
  if ((0, import_shared_utils9.isUndefined)(ouid)) {
    return void 0;
  }
  const mlsid = _ouidToMLSID.get(ouid.toLowerCase());
  if (mlsid === void 0)
    return void 0;
  return mlsInfoByMLSID(mlsid);
}

// src/toolkitListingID/consts.ts
var TOOLKIT_LISTING_ID_PREFIX = "tkl:";

// src/toolkitListingID/parseToolkitListingID.ts
function convertMLSIDToOUID(mls) {
  const mlsInfo = MLS[mls];
  if (mlsInfo && typeof mlsInfo === "object" && "resoID" in mlsInfo) {
    const ouid = mlsInfo.resoID;
    return ouid;
  }
  return null;
}
function parseToolkitListingID(idInput) {
  if (!idInput?.startsWith(TOOLKIT_LISTING_ID_PREFIX))
    return null;
  const id = idInput.slice(TOOLKIT_LISTING_ID_PREFIX.length);
  const splitAt = id.indexOf(":");
  if (splitAt < 0)
    return null;
  let mls = id.slice(0, splitAt);
  const listingID = id.slice(splitAt + 1);
  if (!isMLSID(mls) && !isMLSOUID(mls))
    return null;
  const mlsOUID = convertMLSIDToOUID(mls);
  if (mlsOUID) {
    mls = mlsOUID;
  }
  return { mls, listingID };
}

// src/toolkitListingID/isToolkitListingID.ts
function isToolkitListingID(s) {
  return typeof s === "string" && parseToolkitListingID(s) !== null;
}

// src/toolkitListingID/expectToolkitListingID.ts
function expectToolkitListingID(s) {
  if (!isToolkitListingID(s))
    throw new Error(`Invalid ToolkitListingID: ${s}`);
  return s;
}

// src/toolkitListingID/formatToolkitListingID.ts
var import_shared_utils10 = __toESM(require_lib(), 1);
function formatToolkitListingID(id) {
  if ((0, import_shared_utils10.isUndefined)(id.mls)) {
    throw new Error("Listing is missing a valid MLS");
  }
  if ((0, import_shared_utils10.isUndefined)(id.listingID)) {
    throw new Error("Listing is missing a ListingID");
  }
  if (id.mls.includes(":")) {
    throw new Error(`Invalid MLS ID: ${id.mls}`);
  }
  return `${TOOLKIT_LISTING_ID_PREFIX}${id.mls}:${id.listingID}`;
}

// src/toolkitListingID/getToolkitListingID.ts
function getToolkitListingID({ mls, listingID }, allowAnyMls) {
  if (allowAnyMls && listingID !== void 0) {
    const unsupportedMls = mls;
    return listingID === void 0 ? void 0 : formatToolkitListingID({ mls: unsupportedMls, listingID });
  }
  return listingID === void 0 || !isMLSID(mls) || !isMLSOUID(mls) ? void 0 : formatToolkitListingID({ mls, listingID });
}

// src/toolkitListingID/schToolkitListingID.ts
import { z as z11 } from "zod";
var schToolkitListingID2 = z11.custom(
  isToolkitListingID,
  "invalid ToolkitListingID"
);

// src/toolkitRecordID/types.ts
import { z as z12 } from "zod";
var schToolkitRecordID = z12.string().brand("ToolkitRecordID");

// src/toolkitRecordID/parseToolkitRecordID.ts
var import_shared_utils11 = __toESM(require_lib(), 1);

// src/toolkitRecordID/consts.ts
var TOOLKIT_RECORD_ID_PREFIX = "tkp:";

// src/toolkitRecordID/partUnescape.ts
function partUnescape(s) {
  return s.replaceAll("~1", "/").replaceAll("~0", "~");
}

// src/toolkitRecordID/parseToolkitRecordID.ts
function parseToolkitRecordID(id) {
  if (!id.startsWith(TOOLKIT_RECORD_ID_PREFIX))
    return null;
  const parts = id.slice(TOOLKIT_RECORD_ID_PREFIX.length).split("/").map(partUnescape);
  if (parts[0] !== "order")
    return null;
  const orderID = parts[1];
  if (!(0, import_shared_utils11.isDefined)(orderID))
    return null;
  switch (parts[2]) {
    case "subject": {
      return { orderID, location: { t: "subject" } };
    }
    case "comp": {
      const attachmentID = parts[3];
      if (!(0, import_shared_utils11.isDefined)(attachmentID))
        return null;
      return { orderID, location: { t: "comp", attachmentID } };
    }
    case "dataset": {
      const datasetID = parts[3];
      const listingIDraw = parts[4];
      if (!(0, import_shared_utils11.isDefined)(datasetID))
        return null;
      if (!(0, import_shared_utils11.isDefined)(listingIDraw))
        return null;
      const listingID = expectToolkitListingID(listingIDraw);
      return { orderID, location: { t: "dataset", datasetID, listingID } };
    }
    default: {
      return null;
    }
  }
}

// src/toolkitRecordID/isToolkitRecordID.ts
function isToolkitRecordID(s) {
  return typeof s === "string" && parseToolkitRecordID(s) !== null;
}

// src/toolkitRecordID/expectToolkitRecordID.ts
function expectToolkitRecordID(s) {
  if (!isToolkitRecordID(s))
    throw new Error(`Invalid ToolkitRecordID: ${s}`);
  return s;
}

// src/toolkitRecordID/partEscape.ts
function partEscape(s) {
  return s.replaceAll("~", "~0").replaceAll("/", "~1");
}

// src/toolkitRecordID/formatToolkitRecordID.ts
function formatToolkitRecordID(id) {
  const parts = ["order", id.orderID];
  switch (id.location.t) {
    case "subject":
      parts.push("subject");
      break;
    case "comp":
      parts.push("comp");
      parts.push(id.location.attachmentID);
      break;
    case "dataset":
      parts.push("dataset");
      parts.push(id.location.datasetID);
      parts.push(id.location.listingID);
      break;
  }
  return `${TOOLKIT_RECORD_ID_PREFIX}${parts.map(partEscape).join("/")}`;
}

// src/toolkitRecordID/parseCompToolkitRecordID.ts
function parseCompToolkitRecordID(recordID) {
  const parts = parseToolkitRecordID(recordID);
  if (parts?.location.t !== "comp") {
    throw new Error(`Expected a component record ID, got ${recordID}`);
  }
  return parts.location;
}

// src/toolkitRecordID/schToolkitRecordID.ts
import { z as z13 } from "zod";
var schToolkitRecordID2 = z13.custom(
  isToolkitRecordID,
  "Invalid ToolkitRecordID"
);

// src/toolkitProperty/types.ts
var schToolkitProperty_ = z14.object({
  toolkitRecordID: schToolkitRecordID2,
  toolkitListingID: schToolkitListingID2,
  mls: z14.string(),
  address: schAddress,
  projectPhase: z14.string(),
  projectName: z14.string(),
  salePrice: schAloftPrice,
  listPrice: schAloftPrice,
  grossMonthlyRent: schAloftPrice,
  rentControl: z14.boolean(),
  dataSources: z14.string(),
  verificationSources: z14.string(),
  saleType: schToolkitPropertyEnum,
  financingType: z14.string(),
  financialConcessionAmount: schAloftPrice,
  listingStatus: schToolkitPropertyEnum,
  listDate: schAloftDate,
  contractDate: schAloftDate,
  closeDate: schAloftDate,
  withdrawalDate: schAloftDate,
  expirationDate: schAloftDate,
  leaseholdOrFeeSimple: schToolkitPropertyEnum,
  locationImpact: schToolkitPropertyEnum,
  locationFactorOne: schToolkitPropertyEnum,
  locationFactorTwo: schToolkitPropertyEnum,
  site: schAloftArea,
  viewImpact: schToolkitPropertyEnum,
  viewFactorOne: schToolkitPropertyEnum,
  viewFactorTwo: schToolkitPropertyEnum,
  designAttachmentType: schToolkitPropertyEnum,
  designNumberOfStories: z14.number(),
  designStyle: schToolkitPropertyEnum,
  quality: schToolkitPropertyEnum,
  age: z14.number(),
  yearBuilt: z14.number(),
  condition: schToolkitPropertyEnum,
  aboveGradeBedroomCount: schAloftCount,
  aboveGradeFullBathCount: schAloftCount,
  aboveGradeHalfBathCount: schAloftCount,
  aboveGradeThreeQuarterBathCount: schAloftCount,
  aboveGradeTotalRoomCount: schAloftCount,
  grossLivingArea: schAloftArea,
  grossBuildingArea: schAloftArea,
  totalBasementArea: schAloftArea,
  finishedBasementArea: schAloftArea,
  basementFinishedRoomCount: schAloftCount,
  basementDescription: z14.string(),
  belowGradeExteriorAccessType: schToolkitPropertyEnum,
  belowGradeRecRoomCount: schAloftCount,
  belowGradeBedroomCount: schAloftCount,
  belowGradeFullBathCount: z14.number(),
  belowGradeHalfBathCount: schAloftCount,
  belowGradeThreeQuarterBathCount: schAloftCount,
  belowGradeOtherRoomCount: schAloftCount,
  finishedRoomsBelowGrade: schAloftCount,
  heatingCooling: z14.string(),
  functionalUtility: schToolkitPropertyEnum,
  energyEfficientItems: z14.string(),
  attachedGarageParkingSpacesCount: schAloftCount,
  detachedGarageParkingSpacesCount: schAloftCount,
  builtInGarageParkingSpacesCount: schAloftCount,
  carportParkingSpacesCount: schAloftCount,
  drivewayParkingSpacesCount: schAloftCount,
  porchPatioDeck: z14.string(),
  hoaMonthlyAssessment: schAloftPrice,
  commonElementsAndRecFacilities: z14.string(),
  floorLocation: schToolkitPropertyEnum,
  dynamicFields: z14.record(
    z14.string(),
    z14.union([schToolkitPropertyDynamicField, z14.null(), z14.undefined()])
  ),
  propertyType: z14.string(),
  stucturalDesignDescription: schToolkitPropertyEnum,
  structureType: schToolkitPropertyEnum,
  storiesDescription: z14.string(),
  elementarySchool: z14.string(),
  mlsArea: z14.string(),
  listingID: z14.string(),
  marketingCommentary: z14.string(),
  images: z14.array(z14.object({ url: z14.string() })),
  daysOnMarket: schAloftCount,
  cumulativeDaysOnMarket: schAloftCount,
  longitude: z14.number(),
  latitude: z14.number(),
  architectureStyle: z14.string(),
  assesorsMapReferenceID: z14.string(),
  parcelID: z14.string(),
  censusTractID: z14.string(),
  zoningDescription: z14.string(),
  legalDescription: z14.string(),
  sewerType: z14.string(),
  annualTaxAmount: schAloftPrice,
  taxYear: z14.number(),
  ownerOccupied: z14.boolean(),
  cooling: z14.string(),
  greenEnergyEfficient: z14.string(),
  heating: z14.string(),
  poolFeatures: z14.string(),
  custom: z14.string(),
  additionalFeature1Title: z14.string(),
  additionalFeature1Description: z14.string(),
  additionalFeature2Title: z14.string(),
  additionalFeature2Description: z14.string(),
  additionalFeature3Title: z14.string(),
  additionalFeature3Description: z14.string()
}).partial();
var schToolkitProperty = zodLaunder(
  schToolkitProperty_.transform((x) => x)
);

// src/toolkitProperty/getToolkitPropertyFieldDisplay.ts
var displayStrings = {
  aboveGradeBedroomCount: "Beds",
  aboveGradeFullBathCount: "Baths",
  aboveGradeHalfBathCount: "Half Baths",
  address: "Address",
  age: "Age",
  yearBuilt: "Year Built",
  grossLivingArea: "GLA",
  site: "Lot Size",
  listDate: "List Date",
  listPrice: "List Price",
  closeDate: "Close Date",
  salePrice: "Sale Price",
  attachedGarageParkingSpacesCount: "Garage",
  listingStatus: "Status",
  listingID: "MLS #"
};
function getToolkitPropertyFieldDisplay(field) {
  return displayStrings[field] ?? field;
}

// src/toolkitProperty/identifyToolkitProperty.ts
function identifyToolkitProperty(prop, toolkitRecordID) {
  return {
    ...prop,
    toolkitRecordID
  };
}

// src/toolkitProperty/ToolkitPropertyRowMap.ts
var import_shared_utils29 = __toESM(require_lib(), 1);

// src/propertydata/transaction.ts
import { schAloftPriceJSON as schAloftPriceJSON2 } from "@aloft/shared-objects";
import { z as z17 } from "zod";

// src/syntax/fnma/types.ts
import { z as z15 } from "zod";
var ISO_MONTH_REGEX = /^([0-9]{4})-(1[0-2]|0[1-9])$/;
var schIsoMonth = z15.string().regex(ISO_MONTH_REGEX).brand("IsoMonth");
var valuesUadListingStatus = ["Active", "Contract", "Expired", "Withdrawn", "SettledSale"];
var statusOptions = valuesUadListingStatus.map((value) => ({
  key: value,
  label: value,
  value
}));
var schUadListingStatus = z15.enum([
  "Active",
  "Contract",
  "Expired",
  "Withdrawn",
  "SettledSale"
]);
var schComparableStatus = z15.object({
  listingStatus: schUadListingStatus.optional(),
  contractMonth: schIsoMonth.optional(),
  closeMonth: schIsoMonth.optional(),
  withdrawalMonth: schIsoMonth.optional(),
  expirationMonth: schIsoMonth.optional()
});
var schParkingSpaceNumber = z15.number().gte(0).brand("ParkingSpaceNumber");
var schCarStorage = z15.strictObject({
  attachedGarageSpaces: schParkingSpaceNumber,
  detachedGarageSpaces: schParkingSpaceNumber,
  builtInGarageSpaces: schParkingSpaceNumber,
  carportSpaces: schParkingSpaceNumber,
  drivewaySpaces: schParkingSpaceNumber
}).partial();
var schStoriesNum = z15.number().gte(1).multipleOf(0.01);
var schAttachmentType = z15.enum(["AT", "DT", "SD"]);
var schDesignStyle = z15.strictObject({
  attachmentType: schAttachmentType,
  stories: schStoriesNum,
  style: z15.string()
}).partial();
var schDataSource = z15.strictObject({
  mls: z15.string(),
  listingID: z15.string(),
  daysOnMarket: schPositiveInt
}).partial();
var schActualAge = z15.strictObject({
  age: schPositiveInt,
  isEstimation: z15.boolean()
}).partial();
var schBathroomCount = z15.strictObject({
  fullBaths: schPositiveInt,
  halfBaths: schPositiveInt
}).partial();
var schBasementAccessType = z15.enum(["wu", "wo", "in"]);
var schBasementLine1 = z15.strictObject({
  total: schAloftArea,
  finished: schAloftArea,
  accessType: schBasementAccessType
}).partial();
var schBasementLine2 = z15.strictObject({
  recRoomCount: schPositiveInt,
  bedroomCount: schPositiveInt,
  fullBathCount: schPositiveInt,
  halfBathCount: schPositiveInt,
  otherRoomCount: schPositiveInt
}).partial();

// src/termsOfSale.ts
var import_shared_utils12 = __toESM(require_lib(), 1);
import { z as z16 } from "zod";
var schTermsOfSale = z16.enum([
  "REO",
  "Short",
  "CrtOrd",
  "Estate",
  "Relo",
  "NonArm",
  "ArmLth",
  "Listing"
]);
var getTermsOfSaleDisplay = (0, import_shared_utils12.makeLookup)({
  cases: [
    ["REO", "REO Sale"],
    ["Short", "Short Sale"],
    ["CrtOrd", "Court-Ordered Sale"],
    ["Estate", "Estate Sale"],
    ["Relo", "Relocation Sale"],
    ["NonArm", "Non-Arm's Length Sale"],
    ["ArmLth", "Arm's Length Sale"],
    ["Listing", "Listing"]
  ]
});
var termsOfSaleOptions = schTermsOfSale.options.map((value) => ({
  key: value,
  value,
  label: getTermsOfSaleDisplay(value)
}));

// src/propertydata/transaction.ts
var schFinancingType = z17.enum(["Cash", "Conventional", "FHA", "Private", "USDA", "VA"]);
var schTransaction = z17.object({
  id: z17.string(),
  price: schAloftPriceJSON2,
  status: schUadListingStatus,
  contractDate: schIsoMonth,
  saleDate: schIsoMonth,
  expirationDate: schIsoMonth,
  withdrawalDate: schIsoMonth,
  mls: schMLSID,
  mlsListingID: z17.string(),
  originalListPrice: schAloftPriceJSON2,
  daysOnMarket: z17.number(),
  concessions: z17.string(),
  // TODO: Type as schConcessions
  termsOfSale: schTermsOfSale
}).partial();

// src/syntax/fnma/saleTypeSyntax.ts
import { z as z18 } from "zod";

// src/syntax/types.ts
var SyntaxError = class extends Error {
};
var SyntaxEncodeError = class extends SyntaxError {
};
var SyntaxDecodeError = class extends SyntaxError {
};

// src/syntax/fnma/makeEnumSyntax.ts
function makeEnumSyntax(label, map, opts = {}) {
  function normalizeDecoderKey(s) {
    return opts.caseSensitive ? s.trim() : s.trim().toLowerCase();
  }
  const encodeMap = map;
  const decodeMap = Object.fromEntries(
    Object.entries(map).map(([k, v]) => [normalizeDecoderKey(v), k])
  );
  return {
    encode(variant) {
      const encoded = encodeMap[variant];
      if (encoded === void 0) {
        if (!opts.allowOther) {
          throw new SyntaxEncodeError(`Unknown enum variant: ${variant}`);
        }
        return variant;
      }
      return encoded;
    },
    decode(variant) {
      const decoded = decodeMap[normalizeDecoderKey(variant)];
      if (decoded === void 0) {
        if (!opts.allowOther) {
          throw new SyntaxDecodeError(`Unknown value for ${label}: ${variant}`);
        }
        return variant;
      }
      return decoded;
    }
  };
}

// src/syntax/fnma/saleTypeSyntax.ts
var valuesSaleType = [
  "REOSale",
  "ShortSale",
  "CourtOrderedSale",
  "EstateSale",
  "RelocationSale",
  "NonArmsLengthSale",
  "ArmsLengthSale",
  "Listing"
];
var schSaleType = z18.enum(valuesSaleType);
var enumSyntax = makeEnumSyntax("sale type", {
  REOSale: "REO",
  ShortSale: "Short",
  CourtOrderedSale: "CrtOrd",
  EstateSale: "Estate",
  RelocationSale: "Relo",
  NonArmsLengthSale: "NonArm",
  ArmsLengthSale: "ArmLth",
  Listing: "Listing"
});
var encode = (params) => params.saleType === void 0 ? "" : enumSyntax.encode(params.saleType);
var decode = (input, _context) => {
  const str = input.trim();
  return { saleType: str === "" ? void 0 : schSaleType.parse(enumSyntax.decode(str)) };
};
var saleTypeSyntax = { encode, decode };

// src/syntax/fnma/index.ts
var fnma_exports = {};
__export(fnma_exports, {
  ISO_MONTH_REGEX: () => ISO_MONTH_REGEX,
  actualAgeSyntax: () => actualAgeSyntax,
  addressSyntax: () => addressSyntax,
  aloftDateToIsoMonth: () => aloftDateToIsoMonth,
  areaSyntax: () => areaSyntax,
  basementLine1Syntax: () => basementLine1Syntax,
  basementLine2Syntax: () => basementLine2Syntax,
  bathroomSyntax: () => bathroomSyntax,
  conditionSyntax: () => conditionSyntax,
  dataSourceSyntax: () => dataSourceSyntax,
  dateOfSaleSyntax: () => dateOfSaleSyntax,
  designSyntax: () => designSyntax,
  financialConcessionsSyntax: () => financialConcessionsSyntax,
  garageCarportSyntax: () => garageCarportSyntax,
  grossLivingAreaSyntax: () => grossLivingAreaSyntax,
  isoMonthToAloftDate: () => isoMonthToAloftDate,
  legacyBasementLine2Syntax: () => legacyBasementLine2Syntax,
  legacyDateOfSaleSyntax: () => legacyDateOfSaleSyntax,
  locationSyntax: () => locationSyntax,
  numberSyntax: () => numberSyntax,
  priceSyntax: () => priceSyntax,
  qualitySyntax: () => qualitySyntax,
  saleTypeSyntax: () => saleTypeSyntax,
  schActualAge: () => schActualAge,
  schAttachmentType: () => schAttachmentType,
  schBasementAccessType: () => schBasementAccessType,
  schBasementLine1: () => schBasementLine1,
  schBasementLine2: () => schBasementLine2,
  schBathroomCount: () => schBathroomCount,
  schCarStorage: () => schCarStorage,
  schComparableStatus: () => schComparableStatus,
  schDataSource: () => schDataSource,
  schDesignStyle: () => schDesignStyle,
  schIsoMonth: () => schIsoMonth,
  schParkingSpaceNumber: () => schParkingSpaceNumber,
  schStoriesNum: () => schStoriesNum,
  schUadListingStatus: () => schUadListingStatus,
  siteSyntax: () => siteSyntax,
  splitUndelimited: () => splitUndelimited,
  statusOptions: () => statusOptions,
  valuesSaleType: () => valuesSaleType,
  valuesUadListingStatus: () => valuesUadListingStatus,
  viewSyntax: () => viewSyntax
});

// src/syntax/fnma/addressSyntax.ts
var import_shared_utils14 = __toESM(require_lib(), 1);

// src/stateCodes.ts
var import_shared_utils13 = __toESM(require_lib(), 1);
import { z as z19 } from "zod";

// src/mapValues.ts
function mapValues(input, f) {
  const res = {};
  for (const [key, value] of Object.entries(input)) {
    res[key] = f(value, key);
  }
  return res;
}

// src/stateCodes.ts
var schStateCode = z19.enum([
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "VI",
  "WA",
  "WV",
  "WI",
  "WY"
]);
var stateCodeToStateName = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "Virgin Islands",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
};
var stateShortToLong = mapValues(stateCodeToStateName, (x) => x.toUpperCase());
var stateLongToShort = Object.fromEntries(
  Object.entries(stateShortToLong).map(([a, b]) => [b, a])
);
function normalizeToStateAbbr(state, acceptsPartial = false) {
  state = state.trim().toUpperCase();
  if (stateLongToShort.hasOwnProperty(state)) {
    return (0, import_shared_utils13.expected)(stateLongToShort[state]);
  } else if (stateShortToLong.hasOwnProperty(state)) {
    return state;
  } else {
    if (acceptsPartial)
      return "";
    throw new Error(`unknown state: ${state}`);
  }
}

// src/syntax/fnma/addressSyntax.ts
function encode2({
  AddressLineText,
  unitNumber,
  CityName,
  StateCode,
  PostalCode
}) {
  return {
    PropertyStreetAddress: `${AddressLineText}${(0, import_shared_utils14.isDefined)(unitNumber) ? " " + unitNumber : ""}`,
    PropertyCity: CityName,
    PropertyState: StateCode,
    PropertyPostalCode: PostalCode
  };
}
function decode2({
  PropertyStreetAddress,
  PropertyCity,
  PropertyState,
  PropertyPostalCode
}) {
  let StateCode = void 0;
  try {
    StateCode = (0, import_shared_utils14.orUndefined)(schStateCode.parse)(PropertyState);
  } catch (e) {
    console.warn(`Ignoring invalid state code: ${PropertyState}`);
  }
  return {
    AddressLineText: PropertyStreetAddress,
    CityName: PropertyCity,
    StateCode,
    PostalCode: PropertyPostalCode
  };
}
var addressSyntax = {
  encode: encode2,
  decode: decode2,
  emptyAnnotations: {
    PropertyStreetAddress: void 0,
    PropertyCity: void 0,
    PropertyState: void 0,
    PropertyPostalCode: void 0
  }
};

// src/syntax/fnma/areaSyntax.ts
var import_shared_utils15 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea2 } from "@aloft/shared-objects";
function encode3(area) {
  const sqfts = area.toSqFt().unitAmount;
  const acres = area.toAcre().unitAmount;
  if (acres < 1) {
    return `${sqfts.toFixed(0)} sf`;
  } else {
    return `${acres.toFixed(2)} ac`;
  }
}
function decode3(input) {
  const m = /^([0-9.,]+)\s*(\S+)$/i.exec(input.trim());
  if (m === null) {
    throw new SyntaxDecodeError(`Unknown area format: ${input}`);
  }
  let [, amount, unit] = (0, import_shared_utils15.checkLength)(3, m);
  amount = amount.replaceAll(",", "");
  switch (unit.toLowerCase()) {
    case "sf":
    case "sqft":
    case "ft2":
      return AloftArea2.fromNumber(parseFloat(amount), "sqft");
    case "ac":
    case "acre":
    case "acres":
      return AloftArea2.fromNumber(parseFloat(amount), "acre");
    default:
      throw new SyntaxDecodeError(`Unknown unit of area: ${unit}`);
  }
}
var areaSyntax = { encode: encode3, decode: decode3 };

// src/syntax/fnma/basementLine1Syntax.ts
var import_shared_utils16 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea3 } from "@aloft/shared-objects";
var BASEMENT_LINE_1_REGEX = new RegExp(/^((\d+)sf((\d+)sf)?)?(wo|wu|in)?$/);
function encode4({ total, finished, accessType }) {
  if ([total, finished, accessType].every(import_shared_utils16.isUndefined)) {
    return "";
  }
  return `${total ? Math.round(total.getUnitAmount("sqft")) : 0}sf${finished ? Math.round(finished.getUnitAmount("sqft")) + "sf" : ""}${accessType ? accessType : ""}`;
}
function decode4(input) {
  const str = input.trim();
  if (str === "") {
    return {};
  }
  const matches = str.match(BASEMENT_LINE_1_REGEX);
  if (!matches) {
    throw new SyntaxDecodeError(`Invalid Basement Line 1: ${input}`);
  }
  const totalStr = matches[2];
  const finishedStr = matches[4];
  const accessStr = matches[5];
  return {
    total: (0, import_shared_utils16.orUndefined)((area) => AloftArea3.fromString(area, "sqft"))(totalStr),
    finished: (0, import_shared_utils16.orUndefined)((area) => AloftArea3.fromString(area, "sqft"))(finishedStr),
    accessType: accessStr
  };
}
var basementLine1Syntax = {
  encode: encode4,
  decode: decode4
};

// src/syntax/fnma/basementLine2Syntax.ts
var import_shared_utils18 = __toESM(require_lib(), 1);

// src/syntax/fnma/splitUndelimited.ts
var import_shared_utils17 = __toESM(require_lib(), 1);
function* splitUndelimited(str) {
  const re = /\s*([0-9.]+)\s*([a-zA-Z]+)\s*/g;
  for (; ; ) {
    if (re.lastIndex === str.length) {
      return;
    }
    const m = re.exec(str);
    if (m === null) {
      throw new SyntaxDecodeError(`Invalid format: ${str}`);
    }
    const [, part1, part2] = (0, import_shared_utils17.checkLength)(3, m);
    yield [part1, part2];
  }
}

// src/syntax/fnma/basementLine2Syntax.ts
var BASEMENT_LINE_2_SYNTAX = new RegExp(/^(\d+(rr|br|o)|\d+\.\d+ba)*$/);
function encode5(input) {
  const parts = [];
  if (input.recRoomCount !== void 0) {
    parts.push(`${input.recRoomCount}rr`);
  }
  if (input.bedroomCount !== void 0) {
    parts.push(`${input.bedroomCount}br`);
  }
  if (input.fullBathCount !== void 0 || input.halfBathCount !== void 0) {
    const full = input.fullBathCount ?? 0;
    const half = input.halfBathCount ?? 0;
    parts.push(`${full}.${half}ba`);
  }
  if (input.otherRoomCount !== void 0) {
    parts.push(`${input.otherRoomCount}o`);
  }
  return parts.join("");
}
function decode5(input) {
  const str = input.trim().toLowerCase();
  const res = {};
  if (str === "") {
    return res;
  }
  if (!str.match(BASEMENT_LINE_2_SYNTAX)) {
    throw new SyntaxDecodeError(`Invalid Basement Line 2: ${input}`);
  }
  for (const [num, kind] of splitUndelimited(str)) {
    switch (kind) {
      case "rr":
        if (res.recRoomCount !== void 0)
          throw new SyntaxDecodeError('"rr" appears multiple times in input');
        res.recRoomCount = schPositiveInt.parse(num);
        break;
      case "br":
        if (res.bedroomCount !== void 0)
          throw new SyntaxDecodeError('"br" appears multiple times in input');
        res.bedroomCount = schPositiveInt.parse(num);
        break;
      case "ba":
        if (res.fullBathCount !== void 0 || res.halfBathCount !== void 0)
          throw new SyntaxDecodeError('"ba" appears multiple times in input');
        const [full, half] = (0, import_shared_utils18.checkMinLength)(2, num.split("."));
        res.fullBathCount = schPositiveInt.parse(full);
        res.halfBathCount = half === void 0 ? schPositiveInt.parse(0) : schPositiveInt.parse(half);
        break;
      case "o":
        if (res.otherRoomCount !== void 0)
          throw new SyntaxDecodeError('"o" appears multiple times in input');
        res.otherRoomCount = schPositiveInt.parse(num);
        break;
      default:
        throw new SyntaxDecodeError(`Unknown below grade room type: ${kind}`);
    }
  }
  return res;
}
var basementLine2Syntax = {
  encode: encode5,
  decode: decode5
};

// src/syntax/fnma/legacyBasementLine2Syntax.ts
var import_shared_utils19 = __toESM(require_lib(), 1);
import { AloftCount as AloftCount2 } from "@aloft/shared-objects";
function encode6(input) {
  const parts = [];
  if (input.belowGradeRecRoomCount !== void 0) {
    parts.push(`${input.belowGradeRecRoomCount.value}rr`);
  }
  if (input.belowGradeBedroomCount !== void 0) {
    parts.push(`${input.belowGradeBedroomCount.value}br`);
  }
  if (input.belowGradeFullBathCount !== void 0 || input.belowGradeHalfBathCount !== void 0) {
    const full = Math.round(input.belowGradeFullBathCount ?? 0);
    const half = input.belowGradeHalfBathCount?.value ?? 0;
    parts.push(`${full}.${half}ba`);
  }
  if (input.belowGradeOtherRoomCount !== void 0) {
    parts.push(`${input.belowGradeOtherRoomCount.value}o`);
  }
  return parts.join("");
}
function decode6(input) {
  const str = input.trim();
  const res = {
    belowGradeRecRoomCount: void 0,
    belowGradeBedroomCount: void 0,
    belowGradeFullBathCount: void 0,
    belowGradeHalfBathCount: void 0,
    belowGradeOtherRoomCount: void 0
  };
  if (str === "") {
    return res;
  }
  for (const [num, kind] of splitUndelimited(str)) {
    switch (kind.toLowerCase()) {
      case "rr":
        if (res.belowGradeRecRoomCount !== void 0)
          throw new SyntaxDecodeError('"rr" appears multiple times in input');
        res.belowGradeRecRoomCount = AloftCount2.fromNumber(parseInt(num));
        break;
      case "br":
        if (res.belowGradeBedroomCount !== void 0)
          throw new SyntaxDecodeError('"br" appears multiple times in input');
        res.belowGradeBedroomCount = AloftCount2.fromNumber(parseInt(num));
        break;
      case "ba":
        if (res.belowGradeFullBathCount !== void 0 || res.belowGradeHalfBathCount !== void 0)
          throw new SyntaxDecodeError('"ba" appears multiple times in input');
        const [full, half] = (0, import_shared_utils19.checkMinLength)(2, num.split("."));
        res.belowGradeFullBathCount = parseInt(full);
        res.belowGradeHalfBathCount = half === void 0 ? AloftCount2.zero : AloftCount2.fromNumber(parseInt(half));
        break;
      case "o":
        if (res.belowGradeOtherRoomCount !== void 0)
          throw new SyntaxDecodeError('"o" appears multiple times in input');
        res.belowGradeOtherRoomCount = AloftCount2.fromNumber(parseInt(num));
        break;
      default:
        throw new SyntaxDecodeError(`Unknown parking space type: ${kind}`);
    }
  }
  return res;
}
var legacyBasementLine2Syntax = {
  encode: encode6,
  decode: decode6
};

// src/syntax/fnma/bathroomSyntax.ts
var import_shared_utils20 = __toESM(require_lib(), 1);
var bathroomSyntax = {
  encode: (value) => {
    const full = value.fullBaths ?? 0;
    const half = value.halfBaths ?? 0;
    return `${full}.${half}`;
  },
  decode: (value) => {
    const [full, half] = value.trim().split(".").map((s) => s.trim());
    try {
      return {
        fullBaths: (0, import_shared_utils20.orUndefined)(schPositiveInt.parse)(full),
        halfBaths: (0, import_shared_utils20.orUndefined)(schPositiveInt.parse)(half)
      };
    } catch (e) {
      throw new SyntaxDecodeError(`Invalid bathroom count provided: ${value}`);
    }
  }
};

// src/syntax/fnma/conditionSyntax.ts
var validConditionCodes = /* @__PURE__ */ new Set(["C1", "C2", "C3", "C4", "C5", "C6"]);
var conditionSyntax = {
  encode(value) {
    return value.condition ?? "";
  },
  decode(value) {
    const str = value.trim().toUpperCase();
    if (str === "")
      return { condition: void 0 };
    if (!validConditionCodes.has(str)) {
      throw new SyntaxDecodeError(`Invalid quality code: ${str}`);
    }
    return { condition: str };
  }
};

// src/syntax/fnma/dataSourceSyntax.ts
var import_shared_utils21 = __toESM(require_lib(), 1);
var DATA_SOURCE_REGEX = new RegExp(/^[^;]*;\s*dom\s*(\d+|unk)$/);
var DOM_REGEX = new RegExp(/^dom (\d+|unk)$/);
function encode7({ mls, listingID, daysOnMarket }) {
  if ([mls, listingID, daysOnMarket].every(import_shared_utils21.isUndefined)) {
    return "";
  }
  return `${mls ?? ""}${listingID ? `#${listingID}` : ""}; DOM ${daysOnMarket ?? "Unk"}`;
}
function decode7(input) {
  if (input === "") {
    return {};
  }
  if (!input.trim().toLowerCase().match(DATA_SOURCE_REGEX)) {
    throw new SyntaxDecodeError(`Invalid data source: ${input}`);
  }
  const [mlsAndListingID, domString] = input.split(";");
  const [mls, listingID] = mlsAndListingID?.split("#") ?? [];
  let dom = void 0;
  const domMatches = domString?.trim().toLowerCase()?.match(DOM_REGEX);
  if (domMatches) {
    if (domMatches[1] !== "unk") {
      try {
        dom = schPositiveInt.parse(+domMatches[1]);
      } catch (e) {
        console.warn("Could not parse DOM", e);
      }
    }
  }
  return {
    mls: mls?.trim() === "" ? void 0 : mls?.trim(),
    listingID: parseListingID(listingID),
    daysOnMarket: dom
  };
}
function parseListingID(rawListingID) {
  const removedPrefix = rawListingID?.startsWith(":") ? rawListingID.slice(1) : rawListingID;
  const trimmed = removedPrefix?.trim();
  return trimmed === "" ? void 0 : trimmed;
}
var dataSourceSyntax = {
  encode: encode7,
  decode: decode7
};

// src/syntax/fnma/legacyDateOfSaleSyntax.ts
var import_shared_utils22 = __toESM(require_lib(), 1);
import { AloftDate as AloftDate2 } from "@aloft/shared-objects";
function encode8(params) {
  const { listingStatus, contractDate, closeDate, withdrawalDate, expirationDate } = params;
  if (listingStatus === void 0) {
    throw new SyntaxEncodeError("Listing status is required");
  }
  switch (listingStatus) {
    case "Active": {
      return "Active";
    }
    case "Expired": {
      if (expirationDate === void 0)
        throw new SyntaxEncodeError("Missing expiration date for expired listing");
      return "e" + dateMMYY.encode(expirationDate);
    }
    case "Withdrawn": {
      if (withdrawalDate === void 0)
        throw new SyntaxEncodeError("Missing withdrawal date for withdrawn listing");
      return "w" + dateMMYY.encode(withdrawalDate);
    }
    case "Contract": {
      if (contractDate === void 0)
        throw new SyntaxEncodeError("Missing contract date for contract listing");
      return "c" + dateMMYY.encode(contractDate);
    }
    case "SettledSale": {
      if (closeDate === void 0)
        throw new SyntaxEncodeError("Missing close date for settled listing");
      const closeDatePart = "s" + dateMMYY.encode(closeDate);
      const contractDatePart = contractDate === void 0 ? "Unk" : "c" + dateMMYY.encode(contractDate);
      return `${closeDatePart};${contractDatePart}`;
    }
    default: {
      throw new SyntaxEncodeError(`Unknown listing status: ${listingStatus}`);
    }
  }
}
function decode8(input, context) {
  const str = input.trim().toLowerCase();
  const res = {
    listingStatus: void 0,
    closeDate: void 0,
    contractDate: void 0,
    expirationDate: void 0,
    withdrawalDate: void 0
  };
  if (str === "") {
    return res;
  }
  if (str === "active") {
    res.listingStatus = "Active";
    return res;
  }
  const defaultContextDate = context?.closeDate ?? context?.contractDate ?? context?.expirationDate ?? context?.withdrawalDate;
  switch (str.charAt(0)) {
    case "e": {
      res.listingStatus = "Expired";
      res.expirationDate = dateMMYY.decode(
        str.slice(1),
        context?.expirationDate ?? defaultContextDate
      );
      break;
    }
    case "w": {
      res.listingStatus = "Withdrawn";
      res.withdrawalDate = dateMMYY.decode(
        str.slice(1),
        context?.withdrawalDate ?? defaultContextDate
      );
      break;
    }
    case "c": {
      res.listingStatus = "Contract";
      res.contractDate = dateMMYY.decode(str.slice(1), context?.contractDate ?? defaultContextDate);
      break;
    }
    case "s": {
      const parts = str.split(";").map((s) => s.trim());
      const [closeDatePart, contractDatePart] = (0, import_shared_utils22.checkMinLength)(1, parts);
      res.listingStatus = "SettledSale";
      res.closeDate = dateMMYY.decode(
        closeDatePart.slice(1),
        context?.closeDate ?? defaultContextDate
      );
      res.contractDate = contractDatePart === void 0 || contractDatePart === "unk" ? void 0 : dateMMYY.decode(contractDatePart.slice(1), context?.contractDate ?? defaultContextDate);
      break;
    }
    default: {
      throw new SyntaxDecodeError(`Invalid FNMA UAD date of sale string: ${str}`);
    }
  }
  return res;
}
var dateMMYY = {
  encode: (date) => {
    return date.format("MM/yy");
  },
  decode: (str, context) => {
    let m;
    m = /^([0-9]{2})\/([0-9]{2})$/.exec(str);
    if (m === null) {
      throw new SyntaxDecodeError(`${str}: Invalid date format, expected MM/YY`);
    }
    const [, monthStr, yearStr] = (0, import_shared_utils22.checkLength)(3, m);
    const month = parseInt(monthStr);
    const year = parseInt(yearStr);
    let contextYear = 1990;
    let contextDay = 1;
    if (context !== void 0) {
      m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(context.toIsoString());
      if (m !== null) {
        const [, contextYearStr, , contextDayStr] = (0, import_shared_utils22.checkLength)(4, m);
        contextYear = parseInt(contextYearStr);
        contextDay = parseInt(contextDayStr);
      } else {
      }
    }
    const year1900s = 1900 + year;
    const year2000s = 2e3 + year;
    const resultYear = Math.abs(year1900s - contextYear) < Math.abs(year2000s - contextYear) ? year1900s : year2000s;
    const resultMonth = month;
    const resultDay = contextDay;
    const resultYearStr = resultYear.toFixed(0).padStart(4, "0");
    const resultMonthStr = resultMonth.toFixed(0).padStart(2, "0");
    const resultDayStr = resultDay.toFixed(0).padStart(2, "0");
    const isoString = `${resultYearStr}-${resultMonthStr}-${resultDayStr}`;
    return AloftDate2.fromIsoString(isoString);
  }
};
var legacyDateOfSaleSyntax = {
  encode: encode8,
  decode: decode8
};

// src/syntax/fnma/designSyntax.ts
var import_shared_utils23 = __toESM(require_lib(), 1);
var DESIGN_STYLE_REGEX = new RegExp(/^(AT|DT|SD)?(\d|\d\.\d{1,2})?;(.+)?$/);
function encode9(params) {
  const fields = ["", ""];
  let stories = params.stories?.toFixed(2) ?? "";
  while (stories.endsWith("0"))
    stories = stories.slice(0, -1);
  if (stories.endsWith("."))
    stories = stories.slice(0, -1);
  fields[0] = `${params.attachmentType ?? ""}${stories}`;
  if (params.style !== void 0) {
    fields[1] = params.style;
  }
  return fields.join(";");
}
function decode9(input) {
  if (input === "") {
    return {
      attachmentType: void 0,
      stories: void 0,
      style: void 0
    };
  }
  const match = input.match(DESIGN_STYLE_REGEX);
  if (!match) {
    throw new SyntaxDecodeError(`Cannot decode design style: ${input}`);
  }
  return {
    attachmentType: (0, import_shared_utils23.orUndefined)(schAttachmentType.parse)(match[1]),
    stories: (0, import_shared_utils23.orUndefined)((num) => +num)(match[2]),
    style: match[3]
  };
}
var designSyntax = { encode: encode9, decode: decode9 };

// src/syntax/fnma/financialConcessionsSyntax.ts
import { AloftPrice as AloftPrice2 } from "@aloft/shared-objects";
var enumSyntax2 = makeEnumSyntax(
  "financing type",
  {
    Conventional: "Conv",
    FHA: "FHA",
    VA: "VA",
    Cash: "Cash",
    USDA: "USDA",
    Private: "Private"
  },
  { allowOther: true }
);
var encode10 = (params) => {
  const type = params.financingType === void 0 ? "" : enumSyntax2.encode(params.financingType);
  const amount = params.financialConcessionAmount?.toString(true) ?? "";
  const s = `${type};${amount}`;
  return s === ";" ? "" : s;
};
var decode10 = (input) => {
  let [field1, field2] = input.split(";").map((x) => x.trim());
  if (field1 === "Conv")
    field1 = "Conventional";
  if (!input.includes(";")) {
    if (schFinancingType.safeParse(field1).success) {
      return { financingType: schFinancingType.parse(field1) };
    }
    if (!Number.isNaN(Number(field1.replaceAll("$", "").replaceAll(",", "")))) {
      return { financialConcessionAmount: AloftPrice2.fromDollarLike(field1) };
    }
    return {};
  }
  const rawFinancingType = field1 === "" ? void 0 : field1;
  const rawConcessionAmount = field2 === "" ? void 0 : field2;
  return {
    financingType: rawFinancingType ? schFinancingType.parse(enumSyntax2.decode(rawFinancingType)) : void 0,
    financialConcessionAmount: rawConcessionAmount ? AloftPrice2.fromDollarLike(rawConcessionAmount, "usd") : void 0
  };
};
var financialConcessionsSyntax = { encode: encode10, decode: decode10 };

// src/syntax/fnma/garageCarportSyntax.ts
function encode11(input) {
  const parts = [];
  if (input.attachedGarageSpaces !== void 0) {
    parts.push(`${input.attachedGarageSpaces}ga`);
  }
  if (input.detachedGarageSpaces !== void 0) {
    parts.push(`${input.detachedGarageSpaces}gd`);
  }
  if (input.builtInGarageSpaces !== void 0) {
    parts.push(`${input.builtInGarageSpaces}gbi`);
  }
  if (input.carportSpaces !== void 0) {
    parts.push(`${input.carportSpaces}cp`);
  }
  if (input.drivewaySpaces !== void 0) {
    parts.push(`${input.drivewaySpaces}dw`);
  }
  return parts.length < 1 ? "None" : parts.join("");
}
function decode11(input) {
  const str = input.trim().toLowerCase();
  const res = {
    attachedGarageSpaces: void 0,
    detachedGarageSpaces: void 0,
    builtInGarageSpaces: void 0,
    carportSpaces: void 0,
    drivewaySpaces: void 0
  };
  if (str === "" || str === "none") {
    return res;
  }
  for (const [num, kind] of splitUndelimited(str)) {
    switch (kind) {
      case "ga":
        if (res.attachedGarageSpaces !== void 0)
          throw new SyntaxDecodeError('"ga" appears multiple times in input');
        res.attachedGarageSpaces = parseParkingSpaces(num);
        break;
      case "gd":
        if (res.detachedGarageSpaces !== void 0)
          throw new SyntaxDecodeError('"gd" appears multiple times in input');
        res.detachedGarageSpaces = parseParkingSpaces(num);
        break;
      case "gbi":
        if (res.builtInGarageSpaces !== void 0)
          throw new SyntaxDecodeError('"gbi" appears multiple times in input');
        res.builtInGarageSpaces = parseParkingSpaces(num);
        break;
      case "cp":
        if (res.carportSpaces !== void 0)
          throw new SyntaxDecodeError('"cp" appears multiple times in input');
        res.carportSpaces = parseParkingSpaces(num);
        break;
      case "dw":
        if (res.drivewaySpaces !== void 0)
          throw new SyntaxDecodeError('"dw" appears multiple times in input');
        res.drivewaySpaces = parseParkingSpaces(num);
        break;
      default:
        throw new SyntaxDecodeError(`Unknown parking space type: ${kind}`);
    }
  }
  return res;
}
var garageCarportSyntax = {
  encode: encode11,
  decode: decode11
};
function parseParkingSpaces(numSpaces) {
  if (isNaN(+numSpaces)) {
    console.warn(`${numSpaces} is not a n`);
    return void 0;
  }
  try {
    return schParkingSpaceNumber.parse(+numSpaces);
  } catch (e) {
    console.warn(`${numSpaces} does not match parking space schema`);
    return void 0;
  }
}

// src/syntax/fnma/locationSyntax.ts
var import_shared_utils24 = __toESM(require_lib(), 1);

// src/syntax/fnma/valueMarketabilityImpactTypeSyntax.ts
var valueMarketabilityImpactTypeSyntax = makeEnumSyntax("impact rating", {
  Neutral: "N",
  Beneficial: "B",
  Adverse: "A"
});

// src/syntax/fnma/locationSyntax.ts
var locationEnumSyntax = makeEnumSyntax(
  "location type",
  {
    Residential: "Res",
    Industrial: "Ind",
    Commercial: "Comm",
    BusyRoad: "BsyRd",
    WaterFront: "WtrFr",
    GolfCourse: "GlfCse",
    AdjacentToPark: "AdjPrk",
    AdjacentToPowerLines: "AdjPwr",
    Landfill: "Lndfl",
    PublicTransportation: "PubTrn"
  },
  { allowOther: true }
);
function encode12(params) {
  const fields = [];
  fields.push(
    params.locationImpact === void 0 ? "" : valueMarketabilityImpactTypeSyntax.encode(params.locationImpact)
  );
  if (params.locationFactorOne !== void 0) {
    fields.push(locationEnumSyntax.encode(params.locationFactorOne));
  }
  if (params.locationFactorTwo !== void 0) {
    fields.push(locationEnumSyntax.encode(params.locationFactorTwo));
  }
  while (fields.length > 0 && fields[0] !== "" && fields.length < 3)
    fields.push("");
  return fields.join(";");
}
function decode12(input) {
  const [impact, factor1, factor2] = (0, import_shared_utils24.checkMinLength)(1, input.trim().split(";"));
  return {
    locationImpact: impact === "" ? void 0 : valueMarketabilityImpactTypeSyntax.decode(impact),
    locationFactorOne: factor1 === void 0 || factor1 === "" ? void 0 : locationEnumSyntax.decode(factor1),
    locationFactorTwo: factor2 === void 0 || factor2 === "" ? void 0 : locationEnumSyntax.decode(factor2)
  };
}
var locationSyntax = { encode: encode12, decode: decode12 };

// src/syntax/fnma/qualitySyntax.ts
var validQualityCodes = /* @__PURE__ */ new Set(["Q1", "Q2", "Q3", "Q4", "Q5", "Q6"]);
var qualitySyntax = {
  encode(value) {
    return value.quality ?? "";
  },
  decode(value) {
    const str = value.trim().toUpperCase();
    if (str === "")
      return { quality: void 0 };
    if (!validQualityCodes.has(str)) {
      throw new SyntaxDecodeError(`Invalid quality code: ${str}`);
    }
    return { quality: str };
  }
};

// src/syntax/fnma/siteSyntax.ts
function encode13(params) {
  return params.site === void 0 ? "" : areaSyntax.encode(params.site);
}
function decode13(input) {
  return { site: input.trim() === "" ? void 0 : areaSyntax.decode(input) };
}
var siteSyntax = { encode: encode13, decode: decode13 };

// src/syntax/fnma/viewSyntax.ts
var import_shared_utils25 = __toESM(require_lib(), 1);
var viewEnumSyntax = makeEnumSyntax(
  "view type",
  {
    WaterView: "Wtr",
    PastoralView: "Pstrl",
    WoodsView: "Woods",
    ParkView: "Prk",
    GolfCourseView: "Glfvw",
    CitySkylineView: "CtySky",
    MountainView: "Mtn",
    ResidentialView: "Res",
    CityStreetView: "CtyStr",
    IndustrialView: "Ind",
    PowerLines: "PwrLn",
    LimitedSight: "LtdSght"
  },
  { allowOther: true }
);
function encode14(params) {
  const fields = [];
  fields.push(
    params.viewImpact === void 0 ? "" : valueMarketabilityImpactTypeSyntax.encode(params.viewImpact)
  );
  if (params.viewFactorOne !== void 0) {
    fields.push(viewEnumSyntax.encode(params.viewFactorOne));
  }
  if (params.viewFactorTwo !== void 0) {
    fields.push(viewEnumSyntax.encode(params.viewFactorTwo));
  }
  while (fields.length > 0 && fields[0] !== "" && fields.length < 3)
    fields.push("");
  return fields.join(";");
}
function decode14(input) {
  const [impact, factor1, factor2] = (0, import_shared_utils25.checkMinLength)(1, input.trim().split(";"));
  let viewImpact = void 0;
  try {
    viewImpact = impact === "" ? void 0 : valueMarketabilityImpactTypeSyntax.decode(impact);
  } catch (e) {
    console.error("Failed to parse view impact");
  }
  return {
    viewImpact,
    viewFactorOne: factor1 === void 0 || factor1 === "" ? void 0 : viewEnumSyntax.decode(factor1),
    viewFactorTwo: factor2 === void 0 || factor2 === "" ? void 0 : viewEnumSyntax.decode(factor2)
  };
}
var viewSyntax = { encode: encode14, decode: decode14 };

// src/syntax/fnma/dateOfSaleSyntax.ts
var import_shared_utils26 = __toESM(require_lib(), 1);
import { AloftDate as AloftDate3 } from "@aloft/shared-objects";
var DATE_OF_SALE_REGEX = new RegExp(
  /^(c|s|w|e)(([0-9]{2}\/[0-9]{2})?)(;(c([0-9]{2}\/[0-9]{2})|unk))?$/
);
var UAD_MONTH_REGEX = new RegExp(/^(1[0-2]|0[1-9])\/([0-9]{2})$/);
function encode15(params) {
  const { listingStatus, contractMonth, closeMonth, withdrawalMonth, expirationMonth } = params;
  if ([listingStatus, contractMonth, closeMonth, withdrawalMonth, expirationMonth].every(
    (field) => field === void 0
  )) {
    return "";
  }
  if (listingStatus === void 0) {
    throw new SyntaxEncodeError("Listing status is required");
  }
  switch (listingStatus) {
    case "Active": {
      return "Active";
    }
    case "Expired": {
      return "e" + monthOrEmptyString(expirationMonth);
    }
    case "Withdrawn": {
      return "w" + monthOrEmptyString(withdrawalMonth);
    }
    case "Contract": {
      return "c" + monthOrEmptyString(contractMonth);
    }
    case "SettledSale": {
      const closeDatePart = "s" + monthOrEmptyString(closeMonth);
      const contractDatePart = contractMonth === void 0 ? "Unk" : "c" + isoMonthToUadMonthString(contractMonth);
      return `${closeDatePart};${contractDatePart}`;
    }
    default: {
      throw new SyntaxEncodeError(`Unknown listing status: ${listingStatus}`);
    }
  }
}
function monthOrEmptyString(isoMonth) {
  return (0, import_shared_utils26.isUndefined)(isoMonth) ? "" : isoMonthToUadMonthString(isoMonth);
}
function decode15(input) {
  const str = input.trim().toLowerCase();
  const res = {
    listingStatus: void 0,
    closeMonth: void 0,
    contractMonth: void 0,
    expirationMonth: void 0,
    withdrawalMonth: void 0
  };
  if (str === "") {
    return res;
  }
  if (str === "active") {
    res.listingStatus = "Active";
    return res;
  }
  const matches = str.match(DATE_OF_SALE_REGEX);
  if (!matches) {
    throw new SyntaxDecodeError(`Invalid FNMA UAD date of sale string: ${str}`);
  }
  switch (matches[1]) {
    case "e": {
      res.listingStatus = "Expired";
      res.expirationMonth = (0, import_shared_utils26.orUndefined)(uadMonthStringToIsoMonth)(matches[3]);
      break;
    }
    case "w": {
      res.listingStatus = "Withdrawn";
      res.withdrawalMonth = (0, import_shared_utils26.orUndefined)(uadMonthStringToIsoMonth)(matches[3]);
      break;
    }
    case "c": {
      res.listingStatus = "Contract";
      res.contractMonth = (0, import_shared_utils26.orUndefined)(uadMonthStringToIsoMonth)(matches[3]);
      break;
    }
    case "s": {
      res.listingStatus = "SettledSale";
      res.closeMonth = (0, import_shared_utils26.orUndefined)(uadMonthStringToIsoMonth)(matches[3]);
      if (matches[5]) {
        res.contractMonth = (0, import_shared_utils26.orUndefined)(uadMonthStringToIsoMonth)(matches[6]);
      }
      break;
    }
    default: {
      throw new SyntaxDecodeError(`Invalid FNMA UAD date of sale string: ${str}`);
    }
  }
  return res;
}
function isoMonthToUadMonthString(isoMonth) {
  const matches = isoMonth.match(ISO_MONTH_REGEX);
  if (!matches) {
    throw Error(`Invalid ISO month provided: ${isoMonth}`);
  }
  return `${matches[2]}/${matches[1].slice(2)}`;
}
function uadMonthStringToIsoMonth(uadMonth) {
  if (uadMonth === "unk") {
    return void 0;
  }
  const matches = uadMonth.match(UAD_MONTH_REGEX);
  if (!matches) {
    console.error(`Invalid UAD month provided: ${uadMonth}`);
    return void 0;
  }
  const month = matches[1];
  const twoDigitYear = matches[2];
  const fullYear = +twoDigitYear >= 30 ? `19${twoDigitYear}` : `20${twoDigitYear}`;
  return schIsoMonth.parse(`${fullYear}-${month}`);
}
function isoMonthToAloftDate(isoMonth) {
  const matches = isoMonth.match(ISO_MONTH_REGEX);
  if (!matches) {
    throw Error(`Invalid ISO month provided: ${isoMonth}`);
  }
  return AloftDate3.fromIsoString(`${matches[1]}-${matches[2]}-01`);
}
function aloftDateToIsoMonth(date) {
  return date.format("yyyy-MM");
}
var dateOfSaleSyntax = {
  encode: encode15,
  decode: decode15
};

// src/syntax/fnma/grossLivingAreaSyntax.ts
import { AloftArea as AloftArea4 } from "@aloft/shared-objects";
function encode16(area) {
  return area.toSqFt().toSqFtValueStringRounded();
}
function decode16(input) {
  if (input === "") {
    return AloftArea4.zero;
  }
  try {
    return AloftArea4.fromNumber(schPositiveInt.parse(input), "sqft");
  } catch (e) {
    throw new SyntaxDecodeError(`Invalid GLA: ${input}`);
  }
}
var grossLivingAreaSyntax = { encode: encode16, decode: decode16 };

// src/syntax/fnma/actualAgeSyntax.ts
var import_shared_utils27 = __toESM(require_lib(), 1);
var ACTUAL_AGE_REGEX = new RegExp(/^(~?)(\d*)$/);
function encode17({ age, isEstimation }) {
  return `${isEstimation ? "~" : ""}${(0, import_shared_utils27.isDefined)(age) ? age : ""}`;
}
function decode17(input) {
  if (input === "") {
    return {};
  }
  const matches = input.match(ACTUAL_AGE_REGEX);
  if (!matches) {
    throw new SyntaxDecodeError(`Invalid actual age: ${input}`);
  }
  const estimationStr = matches[1];
  const ageStr = matches[2];
  const isEstimation = estimationStr === "~";
  const age = ageStr === "" ? void 0 : schPositiveInt.parse(+ageStr);
  return {
    age,
    isEstimation
  };
}
var actualAgeSyntax = { encode: encode17, decode: decode17 };

// src/syntax/fnma/priceSyntax.ts
import { AloftPrice as AloftPrice3 } from "@aloft/shared-objects";
function encode18(price) {
  return price?.toNumericPrice().toFixed(0) ?? "";
}
function decode18(input) {
  if (input === "") {
    return void 0;
  }
  try {
    return AloftPrice3.fromDollarLike(input);
  } catch (e) {
    throw new SyntaxDecodeError(`Invalid price: ${input}`);
  }
}
var priceSyntax = { encode: encode18, decode: decode18 };

// src/syntax/fnma/numberSyntax.ts
var import_shared_utils28 = __toESM(require_lib(), 1);
function encode19(num) {
  const str = num?.toString();
  return (0, import_shared_utils28.isUndefined)(str) ? "" : str;
}
function decode19(input) {
  const trimmed = input.trim();
  if (trimmed === "") {
    return void 0;
  }
  const num = +trimmed;
  if (isNaN(num)) {
    throw new SyntaxDecodeError(`Invalid number: ${input}`);
  }
  return num;
}
var numberSyntax = { encode: encode19, decode: decode19 };

// src/toolkitProperty/ToolkitPropertyEnum.ts
var ToolkitPropertyEnums = {
  StructuralDesignDescription: {
    values: [
      "Craftsman",
      "Mid Century",
      "Tudor",
      "Victorian",
      "Contemporary",
      "Traditional",
      "Bungalow",
      "Cape Code",
      "Modern"
    ],
    allowOther: true
  },
  ValueMarketabilityImpactType: {
    // only UAD
    values: ["Neutral", "Beneficial", "Adverse"],
    allowOther: false
  },
  BelowGradeExteriorAccessType: {
    values: ["WalkOut", "WalkUp", "InteriorOnly"],
    allowOther: false
  },
  StructuralDesignType: {
    // This one is a shot in the dark
    // /VALUATION_RESPONSE/PROPERTY/PROJECT[@_DesignType='Other' and @_DesignTypeOtherDescription='AttachedAndDetached']
    values: ["Attached", "Detached"],
    allowOther: true
  },
  ListingStatusType: {
    values: [
      "Active",
      "Expired",
      "Withdrawn",
      "Contract",
      "SettledSale",
      "Rented",
      "Backup",
      "ComingSoon",
      "Off-Market",
      "Deleted",
      "Cancelled",
      "Other",
      "Unknown",
      "Pending"
    ],
    allowOther: false
  },
  OverallConditionRatingCode: {
    values: ["C1", "C2", "C3", "C4", "C5", "C6"],
    allowOther: false
  },
  OverallQualityRatingCode: {
    values: ["Q1", "Q2", "Q3", "Q4", "Q5", "Q6"],
    allowOther: false
  },
  ViewType: {
    // TODO this also has a PDF view
    values: [
      "WaterView",
      "PastoralView",
      "WoodsView",
      "ParkView",
      "GolfCourseView",
      "CitySkylineView",
      "MountainView",
      "ResidentialView",
      "CityStreetView",
      "IndustrialView",
      "PowerLines",
      "LimitedSight"
    ],
    allowOther: true
  },
  LocationType: {
    // This also requires PDF Display values
    values: [
      "Residential",
      "Industrial",
      "Commercial",
      "BusyRoad",
      "WaterFront",
      "GolfCourse",
      "AdjacentToPark",
      "AdjacentToPowerLines",
      "Landfill",
      "PublicTransportation"
    ],
    allowOther: true
  },
  LeaseholdOrFeeSimple: { values: ["Leasehold", "FeeSimple"], allowOther: false },
  DesignAttachmentType: { values: ["Detached", "Attached", "SemiDetached"], allowOther: false }
};

// src/toolkitProperty/listingStatusEnum.ts
var import_enum3 = __toESM(require_enum(), 1);
var ListingStatuses = (0, import_enum3.AloftEnum)()({
  Active: "Active",
  Expired: "Expired",
  Withdrawn: "Withdrawn",
  Contract: "Contract",
  SettledSale: "SettledSale"
});
var ListingStatusOptions = {
  values: ListingStatuses._keys,
  allowOther: false
};

// src/toolkitProperty/ToolkitPropertyRowMap.ts
var ToolkitPropertyRowMap = {
  address: {
    label: "Address",
    type: "address",
    valueProps: {
      formatValue: (prop) => prop.address?.AddressLineText ?? ""
    }
  },
  projectPhase: {
    label: "Project Phase",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "projectPhase"
      }
    }
  },
  projectName: {
    label: "Project Name",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "projectName"
      }
    }
  },
  salePrice: {
    label: "Sale Price",
    type: "price",
    valueProps: {
      annotator: { t: "AloftPrice", optional: true, valueKey: "salePrice" },
      formatValue: (prop) => prop.salePrice?.toString(true) ?? ""
    }
  },
  listPrice: {
    label: "List Price",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: true,
        valueKey: "listPrice"
      }
    }
  },
  grossMonthlyRent: {
    label: "Gross Monthly Rent",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: true,
        valueKey: "grossMonthlyRent"
      }
    }
  },
  rentControl: {
    label: "Rent Control",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: true,
        valueKey: "rentControl"
      }
    }
  },
  dataSources: {
    label: "Data Source(s)",
    isHiddenForSubject: true,
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "dataSources"
      }
    }
  },
  verificationSources: {
    label: "Verification Source(s)",
    isHiddenForSubject: true,
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "verificationSources"
      }
    }
  },
  saleType: {
    label: "Terms of Sale",
    isHiddenForSubject: true,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "saleType",
        enum: { values: valuesSaleType, allowOther: false }
      }
    },
    adjustProps: {
      manualTerm: "saleTypeManual"
    }
  },
  financingType: {
    label: "Financing Type",
    isHiddenForSubject: true,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "financingType",
        enum: { values: schFinancingType.options, allowOther: true }
      }
    }
  },
  financialConcessionAmount: {
    label: "Concession Amount",
    isHiddenForSubject: true,
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: true,
        valueKey: "financialConcessionAmount"
      }
    }
  },
  listingStatus: {
    label: "Listing Status",
    isHiddenForSubject: true,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "listingStatus",
        enum: ListingStatusOptions
      }
    }
  },
  listDate: {
    label: "List Date",
    isHiddenForSubject: true,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: true,
        valueKey: "listDate"
      }
    }
  },
  contractDate: {
    label: "Contract Date",
    isHiddenForSubject: true,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: true,
        valueKey: "contractDate"
      }
    }
  },
  closeDate: {
    label: "Close Date",
    isHiddenForSubject: true,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: true,
        valueKey: "closeDate"
      }
    }
  },
  withdrawalDate: {
    label: "Withdrawal Date",
    isHiddenForSubject: true,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: true,
        valueKey: "withdrawalDate"
      }
    }
  },
  expirationDate: {
    label: "Expiration Date",
    isHiddenForSubject: true,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: true,
        valueKey: "expirationDate"
      }
    }
  },
  leaseholdOrFeeSimple: {
    label: "Leasehold/Fee Simple",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "leaseholdOrFeeSimple",
        enum: ToolkitPropertyEnums.LeaseholdOrFeeSimple
      }
    },
    adjustProps: {
      manualTerm: "leaseholdFeeSimpleManual"
    }
  },
  locationImpact: {
    label: "Location Impact",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "locationImpact",
        enum: ToolkitPropertyEnums.ValueMarketabilityImpactType
      }
    }
  },
  locationFactorOne: {
    label: "Location Factor 1",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "locationFactorOne",
        enum: ToolkitPropertyEnums.LocationType
      }
    }
  },
  locationFactorTwo: {
    label: "Location Factor 2 (Opt.)",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "locationFactorTwo",
        enum: ToolkitPropertyEnums.LocationType
      }
    }
  },
  site: {
    label: "Lot Size",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: true,
        valueKey: "site"
      }
    },
    adjustProps: {
      manualTerm: "siteManual",
      managedTerms: ["site"]
    }
  },
  viewImpact: {
    label: "View Impact",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "viewImpact",
        enum: ToolkitPropertyEnums.ValueMarketabilityImpactType
      }
    }
  },
  viewFactorOne: {
    label: "View Factor 1",
    type: "string",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "viewFactorOne",
        enum: ToolkitPropertyEnums.ViewType
      }
    }
  },
  viewFactorTwo: {
    label: "View Factor 2 (Opt.)",
    type: "string",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "viewFactorTwo",
        enum: ToolkitPropertyEnums.ViewType
      }
    }
  },
  designAttachmentType: {
    label: "Attachment Type",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "designAttachmentType",
        enum: ToolkitPropertyEnums.DesignAttachmentType
      }
    }
  },
  designNumberOfStories: {
    label: "# of Stories",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: true,
        valueKey: "designNumberOfStories"
      }
    }
  },
  designStyle: {
    label: "Design (Style)",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "designStyle"
      }
    }
  },
  quality: {
    label: "Quality",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "quality",
        enum: ToolkitPropertyEnums.OverallQualityRatingCode
      }
    },
    adjustProps: {
      manualTerm: "qualityManual",
      managedTerms: ["quality"]
    }
  },
  age: {
    label: "Actual Age",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: true,
        valueKey: "age"
      }
    },
    adjustProps: {
      manualTerm: "ageManual"
    }
  },
  yearBuilt: {
    label: "Year Built",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: true,
        valueKey: "yearBuilt"
      }
    }
  },
  condition: {
    label: "Condition",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "condition",
        enum: ToolkitPropertyEnums.OverallConditionRatingCode
      }
    },
    adjustProps: {
      manualTerm: "conditionManual",
      managedTerms: ["condition"]
    }
  },
  aboveGradeBedroomCount: {
    label: "Above Grade Bedroom Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "aboveGradeBedroomCount"
      }
    }
  },
  totalBathCount: {
    label: "Total Bathroom Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "totalBathCount"
      }
    }
  },
  aboveGradeFullBathCount: {
    label: "Above Grade Bathrooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "aboveGradeFullBathCount"
      }
    }
  },
  aboveGradeHalfBathCount: {
    label: "Above Grade 1/2 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "aboveGradeHalfBathCount"
      }
    }
  },
  aboveGradeThreeQuarterBathCount: {
    label: "Above Grade 3/4 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "aboveGradeThreeQuarterBathCount"
      }
    }
  },
  aboveGradeTotalRoomCount: {
    label: "Above Grade Room Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "aboveGradeTotalRoomCount"
      }
    }
  },
  grossLivingArea: {
    label: "Gross Living Area",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: true,
        valueKey: "grossLivingArea"
      }
    },
    adjustProps: {
      manualTerm: "grossLivingAreaManual",
      managedTerms: ["grossLivingArea"]
    }
  },
  grossBuildingArea: {
    label: "Gross Building Area",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: true,
        valueKey: "grossBuildingArea"
      }
    }
  },
  hasBasement: {
    label: "Has Basement",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: true,
        valueKey: "hasBasement"
      }
    }
  },
  totalBasementArea: {
    label: "Total Basement Sqft",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: true,
        valueKey: "totalBasementArea"
      }
    },
    adjustProps: {
      manualTerm: "totalBasementAreaManual",
      managedTerms: ["totalBasementArea"]
    }
  },
  finishedBasementArea: {
    label: "Finished Basement Sqft",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: true,
        valueKey: "finishedBasementArea"
      }
    }
  },
  basementFinishedRoomCount: {
    label: "Basement Finished Room Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "basementFinishedRoomCount"
      }
    }
  },
  basementDescription: {
    label: "Basement Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "basementDescription"
      }
    }
  },
  belowGradeExteriorAccessType: {
    label: "Basement Access",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "belowGradeExteriorAccessType",
        enum: ToolkitPropertyEnums.BelowGradeExteriorAccessType
      }
    }
  },
  belowGradeRecRoomCount: {
    label: "Below Grade Rec Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "belowGradeRecRoomCount"
      }
    }
  },
  belowGradeBedroomCount: {
    label: "Below Grade Bedrooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "belowGradeBedroomCount"
      }
    }
  },
  belowGradeFullBathCount: {
    label: "Below Grade Bathrooms",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: true,
        valueKey: "belowGradeFullBathCount"
      }
    }
  },
  belowGradeHalfBathCount: {
    label: "Below Grade 1/2 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "belowGradeHalfBathCount"
      }
    }
  },
  belowGradeThreeQuarterBathCount: {
    label: "Below Grade 3/4 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "belowGradeThreeQuarterBathCount"
      }
    }
  },
  belowGradeOtherRoomCount: {
    label: "Below Grade Other Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "belowGradeOtherRoomCount"
      }
    }
  },
  finishedRoomsBelowGrade: {
    label: "Below Grade Finished Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "finishedRoomsBelowGrade"
      }
    }
  },
  heatingCooling: {
    label: "Heating/Cooling",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "heatingCooling"
      }
    },
    adjustProps: {
      manualTerm: "heatingCoolingManual"
    }
  },
  functionalUtility: {
    label: "Functionality Utility",
    type: "enum",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "functionalUtility"
      }
    },
    adjustProps: {
      manualTerm: "functionalUtilityManual",
      managedTerms: ["functionalUtility"]
    }
  },
  energyEfficientItems: {
    label: "Energy Efficient Items",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "energyEfficientItems"
      }
    },
    adjustProps: {
      manualTerm: "energyEfficientItemsManual",
      managedTerms: ["energyEfficientItems"]
    }
  },
  attachedGarageParkingSpacesCount: {
    label: "Attached Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "attachedGarageParkingSpacesCount"
      }
    }
  },
  detachedGarageParkingSpacesCount: {
    label: "Detached Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "detachedGarageParkingSpacesCount"
      }
    }
  },
  builtInGarageParkingSpacesCount: {
    label: "Built-in Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "builtInGarageParkingSpacesCount"
      }
    }
  },
  carportParkingSpacesCount: {
    label: "Carport Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "carportParkingSpacesCount"
      }
    }
  },
  drivewayParkingSpacesCount: {
    label: "Driveway Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "drivewayParkingSpacesCount"
      }
    }
  },
  porchPatioDeck: {
    label: "Porch/Patio/Deck",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "porchPatioDeck"
      }
    },
    adjustProps: {
      manualTerm: "porchPatioDeckManual"
    }
  },
  hoaMonthlyAssessment: {
    label: "HOA Monthly Assessment",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: true,
        valueKey: "hoaMonthlyAssessment"
      }
    }
  },
  commonElementsAndRecFacilities: {
    label: "Common Elements and Rec Facilities",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "commonElementsAndRecFacilities"
      }
    }
  },
  floorLocation: {
    label: "Floor Location",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "floorLocation",
        enum: { values: [], allowOther: false }
      }
    }
  },
  propertyType: {
    label: "Property Type",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "propertyType"
      }
    }
  },
  propertySubtype: {
    label: "Property Subtype",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "propertySubtype"
      }
    }
  },
  stucturalDesignDescription: {
    label: "Structural Design",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "stucturalDesignDescription",
        enum: ToolkitPropertyEnums.StructuralDesignDescription
      }
    }
  },
  structureType: {
    label: "Structure Type",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: true,
        valueKey: "structureType",
        enum: ToolkitPropertyEnums.StructuralDesignType
      }
    }
  },
  storiesDescription: {
    label: "Stories Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "storiesDescription"
      }
    }
  },
  elementarySchool: {
    label: "Elementary School",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "elementarySchool"
      }
    }
  },
  mlsArea: {
    label: "MLS Area",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "mlsArea"
      }
    }
  },
  listingID: {
    label: "Listing ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "listingID"
      }
    }
  },
  marketingCommentary: {
    label: "Marketing Commentary",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "marketingCommentary"
      }
    }
  },
  daysOnMarket: {
    label: "Days on Market",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "daysOnMarket"
      }
    }
  },
  cumulativeDaysOnMarket: {
    label: "Cumulative Days on Market",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: true,
        valueKey: "cumulativeDaysOnMarket"
      }
    }
  },
  longitude: {
    label: "Longitude",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: true,
        valueKey: "longitude"
      }
    }
  },
  latitude: {
    label: "Latitude",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: true,
        valueKey: "latitude"
      }
    }
  },
  architectureStyle: {
    label: "Architectural Style",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "architectureStyle"
      }
    }
  },
  assesorsMapReferenceID: {
    label: "Assessors Map Reference ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "assesorsMapReferenceID"
      }
    }
  },
  parcelID: {
    label: "Parcel ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "parcelID"
      }
    }
  },
  censusTractID: {
    label: "Census Tract ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "censusTractID"
      }
    }
  },
  zoningDescription: {
    label: "Zoning Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "zoningDescription"
      }
    }
  },
  legalDescription: {
    label: "Legal Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "legalDescription"
      }
    }
  },
  sewerType: {
    label: "Sewer Type",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "sewerType"
      }
    }
  },
  annualTaxAmount: {
    label: "Annual Tax Amount",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: true,
        valueKey: "annualTaxAmount"
      }
    }
  },
  taxYear: {
    label: "Tax Year",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: true,
        valueKey: "taxYear"
      }
    }
  },
  ownerOccupied: {
    label: "Owner Occupied",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: true,
        valueKey: "ownerOccupied"
      }
    }
  },
  hasAttachment: {
    label: "Has Attachment",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: true,
        valueKey: "hasAttachment"
      }
    }
  },
  mls: {
    label: "MLS",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "mls"
      }
    }
  },
  additionalFeature1Title: {
    label: "Additional Feature 1 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "additionalFeature1Title"
      }
    }
  },
  additionalFeature1Description: {
    label: (prop) => prop.additionalFeature1Title ?? "Additional Feature 1",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "additionalFeature1Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature1Manual",
      managedTerms: ["additionalFeature1"]
    }
  },
  additionalFeature2Title: {
    label: "Additional Feature 2 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "additionalFeature2Title"
      }
    }
  },
  additionalFeature2Description: {
    label: (prop) => prop.additionalFeature2Title ?? "Additional Feature 2",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "additionalFeature2Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature2Manual",
      managedTerms: ["additionalFeature2"]
    }
  },
  additionalFeature3Title: {
    label: "Additional Feature 3 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "additionalFeature3Title"
      }
    }
  },
  additionalFeature3Description: {
    label: (prop) => prop.additionalFeature3Title ?? "Additional Feature 3",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "additionalFeature3Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature3Manual",
      managedTerms: ["additionalFeature3"]
    }
  },
  salesPricePerGrossLivingArea: {
    label: "Sale Price/GLA",
    type: "string",
    valueProps: {
      formatValue: (prop) => {
        const { salePrice } = prop;
        const livingArea = prop.grossLivingArea;
        if (salePrice === void 0 || livingArea === void 0) {
          return "";
        }
        return salePrice.div(livingArea.toSqFt().unitAmount).toString();
      }
    }
  },
  dateOfSale: {
    label: "Date of Sale",
    type: "string",
    isHiddenForSubject: true,
    valueProps: {
      formatValue: fnma_exports.legacyDateOfSaleSyntax.encode
    },
    adjustProps: {
      manualTerm: "dateOfSaleManual",
      managedTerms: ["dateOfSale", "listToSale"],
      isRequired: true
    }
  },
  location: {
    label: "Location",
    type: "string",
    valueProps: {
      formatValue: fnma_exports.locationSyntax.encode
    },
    adjustProps: {
      manualTerm: "locationManual",
      managedTerms: ["location"]
    }
  },
  view: {
    label: "View",
    type: "string",
    valueProps: {
      formatValue: fnma_exports.viewSyntax.encode
    },
    adjustProps: {
      manualTerm: "viewManual",
      managedTerms: ["view"]
    }
  },
  design: {
    label: "Design (Style)",
    type: "string",
    valueProps: {
      formatValue: (prop) => {
        const attachmentType = prop.designAttachmentType === "Attached" ? "AT" : prop.designAttachmentType === "Detached" ? "DT" : prop.designAttachmentType === "SemiDetached" ? "SD" : void 0;
        return fnma_exports.designSyntax.encode({
          attachmentType,
          stories: prop.designNumberOfStories,
          style: prop.designStyle
        });
      }
    },
    adjustProps: {
      manualTerm: "designManual",
      managedTerms: ["design", "designAttachmentType", "designNumberOfStories"]
    }
  },
  aboveGradeRoomCount: {
    label: "Above Grade Rooms",
    type: "string",
    valueProps: {
      formatValue: ({
        aboveGradeTotalRoomCount,
        aboveGradeBedroomCount,
        aboveGradeFullBathCount,
        aboveGradeHalfBathCount
      }) => {
        const total = aboveGradeTotalRoomCount?.value ?? 0;
        const beds = aboveGradeBedroomCount?.value ?? 0;
        const fullBaths = aboveGradeFullBathCount?.value ?? 0;
        const halfBaths = aboveGradeHalfBathCount?.value ?? 0;
        return `${total}r${beds}bd${fullBaths}.${halfBaths}ba`;
      }
    },
    adjustProps: {
      manualTerm: "aboveGradeRoomCountManual",
      managedTerms: [
        "aboveGradeBedroomCount",
        "aboveGradeFullBathCount",
        "aboveGradeHalfBathCount"
      ]
    }
  },
  belowGradeRoomCount: {
    label: "Below Grade Rooms",
    type: "string",
    valueProps: {
      formatValue: fnma_exports.legacyBasementLine2Syntax.encode
    },
    adjustProps: {
      manualTerm: "belowGradeRoomCountManual"
    }
  },
  garage: {
    label: "Garage/Carport",
    type: "string",
    valueProps: {
      formatValue: (prop) => fnma_exports.garageCarportSyntax.encode({
        attachedGarageSpaces: (0, import_shared_utils29.orUndefined)(schParkingSpaceNumber.parse)(
          prop.attachedGarageParkingSpacesCount?.toNumber()
        ),
        detachedGarageSpaces: (0, import_shared_utils29.orUndefined)(schParkingSpaceNumber.parse)(
          prop.detachedGarageParkingSpacesCount?.toNumber()
        ),
        builtInGarageSpaces: (0, import_shared_utils29.orUndefined)(schParkingSpaceNumber.parse)(
          prop.builtInGarageParkingSpacesCount?.toNumber()
        ),
        carportSpaces: (0, import_shared_utils29.orUndefined)(schParkingSpaceNumber.parse)(
          prop.carportParkingSpacesCount?.toNumber()
        ),
        drivewaySpaces: (0, import_shared_utils29.orUndefined)(schParkingSpaceNumber.parse)(
          prop.drivewayParkingSpacesCount?.toNumber()
        )
      })
    },
    adjustProps: {
      manualTerm: "garageManual",
      managedTerms: [
        "garageParkingSpacesCount",
        "carportParkingSpacesCount",
        "drivewayParkingSpacesCount"
      ]
    }
  },
  financialConcessions: {
    label: "Financial Concessions",
    type: "string",
    valueProps: {
      formatValue: ({ financingType, financialConcessionAmount }) => fnma_exports.financialConcessionsSyntax.encode({
        financingType: schFinancingType.parse(financingType),
        financialConcessionAmount
      })
    },
    adjustProps: {
      manualTerm: "financialConcessionsManual"
    }
  },
  cooling: {
    label: "Cooling",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "cooling"
      }
    }
  },
  greenEnergyEfficient: {
    label: "Energy Efficiency",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "greenEnergyEfficient"
      }
    }
  },
  heating: {
    label: "Heating",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "heating"
      }
    }
  },
  poolFeatures: {
    label: "Pool",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "poolFeatures"
      }
    }
  },
  custom: {
    label: "Custom",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: true,
        valueKey: "custom"
      }
    }
  }
};

// src/toolkitProperty/getDisplayValueFunc.ts
var import_shared_utils30 = __toESM(require_lib(), 1);
function getDisplayValueFunc(key) {
  const { valueProps } = ToolkitPropertyRowMap[key];
  const func = valueProps.formatValue ? valueProps.formatValue : (prop) => getDisplayValueFromAnnotator((0, import_shared_utils30.expected)(valueProps.annotator), prop) ?? "";
  return (prop) => {
    try {
      return func(prop);
    } catch (e) {
      if (e instanceof SyntaxEncodeError)
        return "";
      throw e;
    }
  };
}
var getDisplayValueFromAnnotator = (annotator, prop) => {
  const value = prop[annotator.valueKey];
  switch (annotator.t) {
    case "string":
      return value;
    case "number":
      return value?.toString();
    case "boolean":
      return (0, import_shared_utils30.orUndefined)(String)(value);
    case "ToolkitPropertyEnum":
      return value;
    case "AloftArea":
      return value?.toString();
    case "AloftCount":
      return value?.toString();
    case "AloftDate":
      return value?.format();
    case "AloftPrice":
      return value?.toString();
    case "AloftTime":
      return value?.toIsoString();
    default:
      throw new Error(
        `Unsupported annotator type: ${annotator.t}`
      );
  }
};

// src/toolkitProperty/getBathsString.ts
import { AloftCount as AloftCount3 } from "@aloft/shared-objects";
function getBathsString({
  aboveGradeFullBathCount,
  aboveGradeHalfBathCount,
  aboveGradeThreeQuarterBathCount
}) {
  const fullBaths = AloftCount3.add(
    aboveGradeFullBathCount ?? AloftCount3.zero,
    aboveGradeThreeQuarterBathCount ?? AloftCount3.zero
  ).value;
  const halfBaths = (aboveGradeHalfBathCount ?? AloftCount3.zero).value;
  return `${fullBaths}.${halfBaths}`;
}

// src/adjust/AdjustFeatures.ts
var import_shared_utils35 = __toESM(require_lib(), 1);
var import_enum4 = __toESM(require_enum(), 1);
import { AloftArea as AloftArea9, AloftCount as AloftCount8, AloftDate as AloftDate8, AloftPrice as AloftPrice8 } from "@aloft/shared-objects";
import { z as z21 } from "zod";

// src/assert.ts
var AssertionError = class extends Error {
};
function assert(value, message) {
  if (!value) {
    throw new AssertionError(message ?? `Assertion failed (got ${value})`);
  }
}

// src/dynamicScalar/types.ts
import { z as z20 } from "zod";
var schDynamicScalar = z20.union([
  z20.number(),
  schAloftArea,
  schAloftCount,
  schAloftDate,
  schAloftPrice,
  schAloftTime
]);

// src/dynamicScalar/dynamicScalarToString.ts
var import_shared_utils31 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea5, AloftCount as AloftCount4, AloftDate as AloftDate4, AloftPrice as AloftPrice4, AloftTime as AloftTime2 } from "@aloft/shared-objects";
function dynamicScalarToString(scalar) {
  if (scalar === null)
    return null;
  if (typeof scalar === "number")
    return `${scalar}`;
  if (scalar instanceof AloftArea5)
    return scalar.getSiteAreaString();
  if (scalar instanceof AloftCount4)
    return scalar.toString();
  if (scalar instanceof AloftDate4)
    return scalar.format("MM/dd/yyyy");
  if (scalar instanceof AloftPrice4)
    return scalar.toString(true);
  if (scalar instanceof AloftTime2)
    return scalar.formatTime();
  (0, import_shared_utils31.unreachable)(scalar);
}

// src/dynamicScalar/isDynamicScalar.ts
import { AloftArea as AloftArea6 } from "@aloft/shared-objects";
import { AloftCount as AloftCount5 } from "@aloft/shared-objects";
import { AloftDate as AloftDate5 } from "@aloft/shared-objects";
import { AloftPrice as AloftPrice5 } from "@aloft/shared-objects";
import { AloftTime as AloftTime3 } from "@aloft/shared-objects";
function isDynamicScalar(x) {
  if (x === null)
    return true;
  if (x === void 0)
    return true;
  if (typeof x === "number")
    return true;
  if (AloftArea6.isAloftArea(x))
    return true;
  if (AloftCount5.isAloftCount(x))
    return true;
  if (AloftDate5.isAloftDate(x))
    return true;
  if (AloftPrice5.isAloftPrice(x))
    return true;
  if (AloftTime3.isAloftTime(x))
    return true;
  return false;
}

// src/dynamicScalar/numberToScalar.ts
var import_shared_utils32 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea7, AloftCount as AloftCount6, AloftDate as AloftDate6, AloftPrice as AloftPrice6, AloftTime as AloftTime4 } from "@aloft/shared-objects";
function numberToScalar(num, template) {
  if (num === null)
    return null;
  if (typeof template === "number")
    return num;
  if (template instanceof AloftArea7)
    return AloftArea7.fromNumber(num, "sqft").toUnit(template.unit);
  if (template instanceof AloftCount6)
    return AloftCount6.fromNumber(num);
  if (template instanceof AloftDate6)
    return AloftDate6.fromNumericDate(num);
  if (template instanceof AloftPrice6)
    return AloftPrice6.fromNumericPrice(num, template.currency);
  if (template instanceof AloftTime4)
    return AloftTime4.fromUnix(num);
  return (0, import_shared_utils32.unreachable)(template);
}

// src/dynamicScalar/scalarNumberLens.ts
var import_lens = __toESM(require_lens(), 1);

// src/dynamicScalar/scalarToNumber.ts
var import_shared_utils33 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea8, AloftCount as AloftCount7, AloftDate as AloftDate7, AloftPrice as AloftPrice7, AloftTime as AloftTime5 } from "@aloft/shared-objects";
function scalarToNumber(scalar) {
  if (scalar === null)
    return null;
  if (typeof scalar === "number")
    return scalar;
  if (scalar instanceof AloftArea8)
    return scalar.toSqFt().unitAmount;
  if (scalar instanceof AloftCount7)
    return scalar.value;
  if (scalar instanceof AloftDate7)
    return scalar.toNumericDate();
  if (scalar instanceof AloftPrice7)
    return scalar.toNumericPrice();
  if (scalar instanceof AloftTime5)
    return scalar.toUnix();
  return (0, import_shared_utils33.unreachable)(scalar);
}

// src/dynamicScalar/scalarNumberLens.ts
var scalarNumberLens = new import_lens.Lens(
  (scl) => scalarToNumber(scl),
  (scl, num) => numberToScalar(num, scl)
);

// src/adjust/adjustRateToString.ts
var import_shared_utils34 = __toESM(require_lib(), 1);
function adjustRateToString(rate, unit = "unit") {
  switch (rate.t) {
    case "linear":
      return `${rate.slope.toString()} per ${unit}`;
    case "monthly":
      return `${(rate.percent * 100).toFixed(1)}% per month`;
    default:
      (0, import_shared_utils34.unreachable)(rate);
  }
}

// src/adjust/isAdjustValue.ts
function isAdjustValue(x) {
  return typeof x === "string" || isDynamicScalar(x);
}

// src/adjust/AdjustFeatures.ts
function defaultFeatureInfo(opts) {
  const { customRate, key, unit, rateToString, example, defaultGridValue } = opts;
  const info = ToolkitPropertyRowMap[key];
  return {
    customRate,
    propertyKeys: [key],
    getAnalysisValue(property) {
      const value = property === void 0 ? void 0 : property[info.valueProps.annotator?.valueKey];
      return isAdjustValue(value) ? value : void 0;
    },
    rateToString: rateToString ?? ((rate) => adjustRateToString(rate, unit)),
    unit,
    example,
    defaultGridValue
  };
}
var dateOfSale = {
  customRate: "percentPerMonth",
  propertyKeys: ["closeDate", "listingStatus"],
  getAnalysisValue(property, opts, context) {
    if (property === void 0)
      return void 0;
    const { listingStatus } = property;
    const field = context !== "comparable" ? "closeDate" : opts?.dateOfSaleVariant ?? "closeDate";
    const dateOfSale2 = property[field];
    if ((0, import_shared_utils35.isDefined)(listingStatus) && listingStatus === "SettledSale") {
      return dateOfSale2;
    }
    return void 0;
  },
  rateToString: dateOfSaleRateToString,
  example: AloftDate8.today()
};
var garageParkingSpacesCount = {
  propertyKeys: [
    "detachedGarageParkingSpacesCount",
    "attachedGarageParkingSpacesCount",
    "builtInGarageParkingSpacesCount"
  ],
  customRate: "dollarPerUnit",
  getAnalysisValue: (p) => AloftCount8.addWithNulls(
    p?.detachedGarageParkingSpacesCount ?? null,
    p?.attachedGarageParkingSpacesCount ?? null,
    p?.builtInGarageParkingSpacesCount ?? null
  ) ?? void 0,
  rateToString: (rate) => adjustRateToString(rate, "space"),
  unit: "space",
  example: AloftCount8.zero,
  defaultGridValue: AloftCount8.zero
};
var additionalFeature = {
  getAnalysisValue: () => void 0,
  rateToString: () => "n/a"
};
function dateOfSaleRateToString(rate) {
  if (rate.t === "linear") {
    const monthly = scalarNumberLens.map(rate.slope, (n) => n * 365 / 12);
    assert(monthly instanceof AloftPrice8);
    return adjustRateToString({ t: "linear", slope: monthly }, "month");
  }
  return adjustRateToString(rate, "day");
}
var AdjustFeatures = (0, import_enum4.AloftEnum)()({
  salePrice: defaultFeatureInfo({ key: "salePrice", example: AloftPrice8.zero }),
  dateOfSale,
  listToSale: defaultFeatureInfo({
    customRate: "listToSale",
    key: "listingStatus"
  }),
  site: defaultFeatureInfo({
    customRate: "dollarPerSqft",
    key: "site",
    unit: "sf",
    example: AloftArea9.zero
  }),
  designStyle: defaultFeatureInfo({ key: "designStyle" }),
  designAttachmentType: defaultFeatureInfo({ key: "designAttachmentType" }),
  designNumberOfStories: defaultFeatureInfo({
    customRate: "dollarPerUnit",
    key: "designNumberOfStories",
    unit: "story",
    example: 0
  }),
  grossLivingArea: defaultFeatureInfo({
    customRate: "dollarPerSqft",
    key: "grossLivingArea",
    unit: "sf",
    example: AloftArea9.zero
  }),
  aboveGradeBedroomCount: defaultFeatureInfo({
    customRate: "dollarPerUnit",
    key: "aboveGradeBedroomCount",
    unit: "bedroom",
    example: AloftCount8.zero,
    defaultGridValue: AloftCount8.zero
  }),
  aboveGradeFullBathCount: defaultFeatureInfo({
    customRate: "dollarPerUnit",
    key: "aboveGradeFullBathCount",
    unit: "bath",
    example: AloftCount8.zero,
    defaultGridValue: AloftCount8.zero
  }),
  aboveGradeHalfBathCount: defaultFeatureInfo({
    customRate: "dollarPerUnit",
    key: "aboveGradeHalfBathCount",
    unit: "half bath",
    example: AloftCount8.zero,
    defaultGridValue: AloftCount8.zero
  }),
  totalBasementArea: defaultFeatureInfo({
    customRate: "dollarPerSqft",
    key: "totalBasementArea",
    unit: "sf",
    example: AloftArea9.zero
  }),
  garageParkingSpacesCount,
  carportParkingSpacesCount: defaultFeatureInfo({
    customRate: "dollarPerUnit",
    key: "carportParkingSpacesCount",
    unit: "space",
    example: AloftCount8.zero,
    defaultGridValue: AloftCount8.zero
  }),
  drivewayParkingSpacesCount: defaultFeatureInfo({
    customRate: "dollarPerUnit",
    key: "drivewayParkingSpacesCount",
    unit: "space",
    example: AloftCount8.zero,
    defaultGridValue: AloftCount8.zero
  }),
  cooling: defaultFeatureInfo({ key: "cooling", unit: "cooling" }),
  greenEnergyEfficient: defaultFeatureInfo({
    key: "greenEnergyEfficient",
    unit: "energy efficiency"
  }),
  heating: defaultFeatureInfo({ key: "heating", unit: "heating" }),
  poolFeatures: defaultFeatureInfo({ key: "poolFeatures", unit: "pool" }),
  porchPatioDeck: defaultFeatureInfo({ key: "porchPatioDeck", unit: "patio/porch" }),
  additionalFeature,
  location: defaultFeatureInfo({ key: "locationFactorOne" })
});
var schAdjustFeatureKey = z21.enum(AdjustFeatures._keys);

// src/adjust/types.ts
import { z as z22 } from "zod";
var schAdjustValue = z22.union([z22.string(), schDynamicScalar]);
var schAdjustResultAbsolute = z22.object({
  t: z22.literal("absolute"),
  value: schAloftPrice
});
var schAdjustResultPercent = z22.object({
  t: z22.literal("percent"),
  value: z22.number()
});
var schAdjustResult = z22.discriminatedUnion("t", [
  schAdjustResultAbsolute,
  schAdjustResultPercent
]);
var schAdjustRate = z22.discriminatedUnion("t", [
  z22.object({ t: z22.literal("monthly"), percent: z22.number() }),
  z22.object({ t: z22.literal("linear"), slope: schAloftPrice })
]);
var schAdjustFeatureOptions = z22.object({
  // Date of sale variant only applies to comp values, not market values
  dateOfSaleVariant: z22.enum(["closeDate", "contractDate"])
}).partial();
var schAdjDocAnalysisKey = z22.string();
var schAdjustTermKey = z22.enum([
  "dateOfSaleManual",
  "dateOfSale",
  "listToSale",
  "siteManual",
  "site",
  "locationManual",
  "location",
  "viewManual",
  "view",
  "designManual",
  "design",
  "designAttachmentType",
  "designNumberOfStories",
  "qualityManual",
  "quality",
  "conditionManual",
  "condition",
  "grossLivingAreaManual",
  "grossLivingArea",
  "aboveGradeRoomCountManual",
  "aboveGradeBedroomCount",
  "aboveGradeFullBathCount",
  "aboveGradeHalfBathCount",
  "energyEfficientItemsManual",
  "energyEfficientItems",
  "totalBasementAreaManual",
  "totalBasementArea",
  "functionalUtilityManual",
  "functionalUtility",
  "garageManual",
  "garageParkingSpacesCount",
  "carportParkingSpacesCount",
  "drivewayParkingSpacesCount",
  "additionalFeature1Manual",
  "additionalFeature1",
  "additionalFeature2Manual",
  "additionalFeature2",
  "additionalFeature3Manual",
  "additionalFeature3",
  "saleTypeManual",
  "financialConcessionsManual",
  "leaseholdFeeSimpleManual",
  "ageManual",
  "belowGradeRoomCountManual",
  "heatingCoolingManual",
  "porchPatioDeckManual",
  "finishedBasementAreaManual",
  "basementAccessManual",
  "nonStandardGrossLivingAreaManual",
  "cooling",
  "greenEnergyEfficient",
  "heating",
  "pool",
  "porchPatioDeck"
]);
var schAdjustGroupedSchema = z22.object({
  group: z22.object({
    none: z22.object({}).optional(),
    monthly: z22.object({}).optional(),
    quarterly: z22.object({}).optional(),
    nmonth: z22.object({ months: z22.array(z22.number()) }).optional(),
    days: z22.object({ days: z22.array(z22.number()) }).optional(),
    increments: z22.object({ increments: z22.array(z22.number()) }).optional(),
    values: z22.object({ count: z22.number().optional() }).optional()
  }),
  dateOfSaleGroupedWindowed: z22.boolean().optional()
});
var schAdjustPairedSchema = z22.object({
  irregular: z22.boolean().optional()
});
var schAdjustPolynomialSchema = z22.object({
  degrees: z22.array(z22.number()),
  dateOfSaleLinearWindowed: z22.boolean().optional()
});
var schAdjustSchema = z22.object({
  grouped: schAdjustGroupedSchema.optional(),
  paired: schAdjustPairedSchema.optional(),
  polynomial: schAdjustPolynomialSchema.optional()
});

// src/adjust/AdjustmentDocument.ts
var schAdjDocAcrossTheBoardFormula = z23.discriminatedUnion("t", [
  z23.object({
    t: z23.literal("custom"),
    rate: schAdjustRate,
    featureOptions: schAdjustFeatureOptions.optional()
  }),
  z23.object({
    t: z23.literal("customListToSale"),
    ratio: z23.number(),
    featureOptions: schAdjustFeatureOptions.optional()
  }),
  z23.object({
    t: z23.literal("analysis"),
    analysis: schAdjDocAnalysisKey
  })
]);
var schAdjDocCompTermFormula = z23.discriminatedUnion("t", [
  z23.object({
    t: z23.literal("acrossTheBoard")
  }),
  z23.object({
    t: z23.literal("analysis"),
    analysis: schAdjDocAnalysisKey
  }),
  z23.object({
    t: z23.literal("irregularPaired"),
    analysis: schAdjDocAnalysisKey,
    direction: z23.enum(["superior", "inferior"])
  })
]);
var schAdjDocGroupSpec = z23.discriminatedUnion("t", [
  z23.object({ t: z23.literal("none") }),
  z23.object({ t: z23.literal("monthly") }),
  z23.object({ t: z23.literal("quarterly") }),
  z23.object({ t: z23.literal("nmonth"), months: z23.number() }),
  z23.object({ t: z23.literal("days"), days: z23.number() }),
  z23.object({ t: z23.literal("increments"), increment: z23.number() }),
  z23.object({ t: z23.literal("values"), values: z23.array(schAdjustValue) })
]);
var schAdjDocAnalysisFormulaGrouped = z23.object({
  t: z23.literal("grouped"),
  dataset: z23.string(),
  agg: z23.enum(["median", "mean"]),
  group: schAdjDocGroupSpec,
  adjustAs: z23.enum(["absolute", "percent"]).optional(),
  dateOfSaleGroupedWindowed: z23.boolean().optional(),
  windowSizeDays: z23.number().optional()
});
var schAdjDocAnalysisFormulaPaired = z23.object({
  t: z23.literal("paired"),
  dataset: z23.string(),
  p1: schToolkitProperty,
  p2: schToolkitProperty,
  adjustments: z23.record(schAdjustTermKey, schAloftPrice),
  adjustAs: z23.enum(["absolute", "percent"]).optional()
});
var schAdjDocAnalysisFormulaPolynomial = z23.object({
  t: z23.literal("polynomial"),
  dataset: z23.string(),
  degree: z23.number(),
  dateOfSaleLinearWindowed: z23.boolean().optional(),
  windowSizeDays: z23.number().optional()
});
var schAdjDocAnalysisFormula = z23.discriminatedUnion("t", [
  schAdjDocAnalysisFormulaGrouped,
  schAdjDocAnalysisFormulaPaired,
  schAdjDocAnalysisFormulaPolynomial
]);
var schAdjDocAcrossTheBoard = z23.object({
  lastChangedAt: schAloftTime,
  formula: schAdjDocAcrossTheBoardFormula,
  cachedRate: schAdjustRate.optional()
});
var schAdjDocCompTerm = z23.object({
  lastChangedAt: schAloftTime,
  adjustment: schAloftPrice.optional(),
  calculated: schAloftPrice.optional(),
  formula: schAdjDocCompTermFormula.optional()
});
var schAdjDocComparable = z23.object({
  terms: z23.record(schAdjustTermKey, schAdjDocCompTerm.optional())
});
var schAdjDocAnalysis = z23.object({
  createdAt: schAloftTime,
  lastChangedAt: schAloftTime,
  lastRanAt: schAloftTime.optional(),
  term: schAdjustTermKey.optional(),
  feature: schAdjustFeatureKey.optional(),
  featureOptions: schAdjustFeatureOptions.optional(),
  formula: schAdjDocAnalysisFormula,
  cachedRate: schAdjustRate.optional(),
  title: z23.string().optional(),
  addToCommentary: z23.boolean().optional()
});
var schAdjustmentsDocument = z23.object({
  version: z23.literal("1"),
  createdAt: schAloftTime,
  lastChangedAt: schAloftTime,
  effectiveDate: schAloftDate,
  roundToNearest: schAloftPrice.optional(),
  acrossTheBoard: z23.record(schAdjustTermKey, schAdjDocAcrossTheBoard),
  comps: z23.record(schToolkitRecordID2, schAdjDocComparable),
  compsOrder: z23.array(schToolkitRecordID2),
  analysis: z23.record(schAdjDocAnalysisKey, schAdjDocAnalysis)
});

// src/adjust/AdjustTerms.ts
var AdjustTerms = {
  dateOfSaleManual: { label: "Date of Sale", isManual: true },
  dateOfSale: {
    label: "Date of Sale",
    featureKey: "dateOfSale",
    adjustSchema: {
      grouped: {
        group: { days: { days: [30, 90] }, monthly: {}, quarterly: {} },
        dateOfSaleGroupedWindowed: true
      },
      polynomial: { degrees: [1, 2, 3], dateOfSaleLinearWindowed: true }
    }
  },
  listToSale: {
    label: "List to Sales Price",
    featureKey: "listToSale",
    adjustSchema: { grouped: { group: { none: {} } } }
  },
  siteManual: { label: "Site Size", isManual: true },
  site: {
    label: "Lot Size",
    featureKey: "site",
    adjustSchema: {
      polynomial: { degrees: [1] }
    }
  },
  locationManual: { label: "Location", isManual: true },
  location: {
    label: "Location",
    adjustSchema: { paired: { irregular: true } },
    featureKey: "location"
  },
  viewManual: { label: "View", isManual: true },
  view: { label: "View", adjustSchema: { paired: { irregular: true } } },
  designManual: { label: "Design/Style", isManual: true },
  design: {
    label: "Design/Style",
    featureKey: "designStyle",
    getPairedSaleDisplayValue: getDisplayValueFunc("designStyle"),
    adjustSchema: { paired: { irregular: true } }
  },
  designAttachmentType: {
    label: "Attachment Type",
    featureKey: "designAttachmentType",
    getPairedSaleDisplayValue: getDisplayValueFunc("designAttachmentType"),
    adjustSchema: {
      grouped: { group: { values: { count: 2 } } },
      paired: { irregular: true }
    }
  },
  designNumberOfStories: {
    label: "Number of Stories",
    featureKey: "designNumberOfStories",
    getPairedSaleDisplayValue: getDisplayValueFunc("designNumberOfStories"),
    adjustSchema: {
      polynomial: { degrees: [1, 2, 3] },
      grouped: { group: { values: { count: 2 } } },
      paired: {}
    }
  },
  qualityManual: { label: "Quality", isManual: true },
  quality: { label: "Quality", adjustSchema: { paired: { irregular: true } } },
  conditionManual: { label: "Condition", isManual: true },
  condition: { label: "Condition", adjustSchema: { paired: { irregular: true } } },
  grossLivingAreaManual: { label: "GLA", isManual: true },
  grossLivingArea: {
    label: "GLA",
    featureKey: "grossLivingArea",
    adjustSchema: {
      polynomial: { degrees: [1] }
    }
  },
  aboveGradeRoomCountManual: { label: "Above Grade Room Count", isManual: true },
  aboveGradeBedroomCount: {
    label: "Bedroom",
    featureKey: "aboveGradeBedroomCount",
    adjustSchema: {
      polynomial: { degrees: [1, 2, 3] },
      grouped: { group: { values: { count: 2 } } },
      paired: {}
    }
  },
  aboveGradeFullBathCount: {
    label: "Bathroom",
    featureKey: "aboveGradeFullBathCount",
    adjustSchema: {
      polynomial: { degrees: [1, 2, 3] },
      grouped: { group: { values: { count: 2 } } },
      paired: {}
    }
  },
  aboveGradeHalfBathCount: {
    label: "Half Bath",
    featureKey: "aboveGradeHalfBathCount",
    adjustSchema: {
      polynomial: { degrees: [1, 2, 3] },
      grouped: { group: { values: { count: 2 } } },
      paired: {}
    }
  },
  energyEfficientItemsManual: { label: "Energy Efficiency", isManual: true },
  energyEfficientItems: {
    label: "Energy Efficiency",
    adjustSchema: { paired: { irregular: true } }
  },
  totalBasementAreaManual: { label: "Basement Sqft", isManual: true },
  totalBasementArea: {
    label: "Basement Sf",
    featureKey: "totalBasementArea",
    adjustSchema: { paired: { irregular: true } }
  },
  functionalUtilityManual: { label: "Functional Utility", isManual: true },
  functionalUtility: {
    label: "Functional Utility",
    adjustSchema: { paired: { irregular: true } }
  },
  garageManual: { label: "Garage Space", isManual: true },
  garageParkingSpacesCount: {
    label: "Garage Space",
    featureKey: "garageParkingSpacesCount",
    adjustSchema: {
      polynomial: { degrees: [1, 2, 3] },
      grouped: { group: { values: { count: 2 } } },
      paired: {}
    }
  },
  carportParkingSpacesCount: {
    label: "Carport Space",
    featureKey: "carportParkingSpacesCount",
    adjustSchema: {}
  },
  drivewayParkingSpacesCount: {
    label: "Open Parking Space",
    featureKey: "drivewayParkingSpacesCount"
  },
  additionalFeature1Manual: { label: "Additional Feature", isManual: true },
  additionalFeature1: {
    label: "Additional Feature",
    featureKey: "additionalFeature",
    adjustSchema: { paired: { irregular: true } }
  },
  additionalFeature2Manual: { label: "Additional Feature", isManual: true },
  additionalFeature2: {
    label: "Additional Feature",
    featureKey: "additionalFeature",
    adjustSchema: { paired: { irregular: true } }
  },
  additionalFeature3Manual: { label: "Additional Feature", isManual: true },
  additionalFeature3: {
    label: "Additional Feature",
    featureKey: "additionalFeature",
    adjustSchema: { paired: { irregular: true } }
  },
  saleTypeManual: { label: "Sale Type", isManual: true },
  financialConcessionsManual: { label: "Financial Concessions", isManual: true },
  leaseholdFeeSimpleManual: { label: "Leasehold/Fee Simple", isManual: true },
  ageManual: { label: "Age", isManual: true },
  belowGradeRoomCountManual: { label: "Below Grade Room Count", isManual: true },
  heatingCoolingManual: { label: "Heating/Cooling", isManual: true },
  porchPatioDeckManual: { label: "Porch/Patio/Deck", isManual: true },
  /* these were not mentioned in the notion doc */
  finishedBasementAreaManual: { label: "Finished Basement Area", isManual: true },
  basementAccessManual: { label: "Basement Access", isManual: true },
  nonStandardGrossLivingAreaManual: { label: "Non-standard GLA", isManual: true },
  cooling: {
    label: "Cooling",
    featureKey: "cooling",
    getPairedSaleDisplayValue: getDisplayValueFunc("cooling"),
    adjustSchema: { paired: { irregular: true } }
  },
  greenEnergyEfficient: {
    label: "Energy Efficiency",
    featureKey: "greenEnergyEfficient",
    getPairedSaleDisplayValue: getDisplayValueFunc("greenEnergyEfficient"),
    adjustSchema: { paired: { irregular: true } }
  },
  heating: {
    label: "Heating",
    featureKey: "heating",
    getPairedSaleDisplayValue: getDisplayValueFunc("heating"),
    adjustSchema: { paired: { irregular: true } }
  },
  pool: {
    label: "Pool",
    featureKey: "poolFeatures",
    getPairedSaleDisplayValue: getDisplayValueFunc("poolFeatures"),
    adjustSchema: { paired: { irregular: true } }
  },
  porchPatioDeck: {
    label: "Patio/Porch",
    featureKey: "porchPatioDeck",
    getPairedSaleDisplayValue: getDisplayValueFunc("porchPatioDeck"),
    adjustSchema: { paired: { irregular: true } }
  }
};

// src/adjust/adjustTermToFeature.ts
function adjustTermToFeature(key) {
  return AdjustTerms[key].featureKey;
}

// src/alerts/alert.ts
import { z as z25 } from "zod";

// src/navigation/types.ts
import { z as z24 } from "zod";
var schNavigationAnchor = z24.enum([
  "market-condition",
  "prior-sales",
  "site-extraction",
  "depreciated-cost"
]);
var schQueryParams = z24.enum(["addComps"]);
var schOrderRouteItem = z24.enum(["paired-cost", "studies"]);
var schPairedCostRouteItem = z24.enum([
  "details",
  "features",
  "market",
  "analysis",
  "adjustments",
  "adjustments-grid",
  "commentary",
  "appraisify-commentary",
  "craftsman-cost-approach",
  "reconciliation"
]);
var schPairedCostRouteItemWithQuery = z24.string().refine(
  (val) => schPairedCostRouteItem.options.some((option) => {
    if (val === option)
      return true;
    if (val.startsWith(`${option}#`))
      return true;
    if (val.startsWith(`${option}?`)) {
      const queryString = val.split("?")[1] ?? "";
      const [key, value] = queryString.split("=");
      return key && value && schQueryParams.safeParse(key).success;
    }
    return false;
  })
).brand("PairedCostRouteItemWithQuery");
var schRouteItem = z24.union([schOrderRouteItem, schPairedCostRouteItem]);

// src/alerts/alert.ts
var schAlertSection = z25.enum(["adjustments", "comparable", "depreciatedCost"]);
var schAlertType = z25.enum([
  // Adjustments
  "allCompsAdjustedDown",
  "allCompsAdjustedUp",
  "bracketedMarketValue",
  "limitedAdjustedSalePriceRange",
  // Comparable
  "bracketedGLA",
  "bracketedSiteSize",
  "lessThanThreeSettledSales",
  "similarComparableToSubjectPriorSale",
  // Depreciated Cost
  "bracketedSiteToValueRatio",
  "effectiveAgeLowerThanActualAge",
  "inconsistentCompGlaAdjustment",
  "inconsistentCompSiteAdjustment",
  "largestSiteHasHighestValue",
  "limitedSiteToValueRatioRange",
  "negativeSiteValue",
  "smallestSiteHasLowestValue"
]);
var schAlertStatus = z25.enum(["active", "dismissed"]);
var schAlert = z25.object({
  type: schAlertType,
  status: schAlertStatus,
  message: z25.string(),
  propertyID: z25.string().optional(),
  fixingInfo: z25.object({
    tips: z25.string(),
    pairedCostRouteItem: schPairedCostRouteItem.or(schPairedCostRouteItemWithQuery)
  })
});
var nonDismissableAlertTypes = [];
var schAlertDeprecated = z25.object({
  status: z25.enum(["skipped", "passed", "failed"]),
  message: z25.string(),
  propertyID: z25.string().optional()
});

// src/alerts/consts.ts
var ALERT_SECTION_LABELS = {
  adjustments: "Adjustments Section",
  comparable: "Comparable Section",
  depreciatedCost: "Depreciated Cost Section"
};

// src/alternativeDataSources/zillow.ts
import { z as z26 } from "zod";
var schEmptyObject = z26.object({}).refine((obj) => Object.keys(obj).length === 0, {
  message: "Object must be empty"
});
var schRESOFacts = z26.object({
  // aboveGradeFinishedArea: z.nullable(z.unknown()),
  // accessibilityFeatures: z.nullable(z.unknown()),
  // additionalFeeInfo: z.nullable(z.unknown()),
  // additionalParcelsDescription: z.nullable(z.unknown()),
  appliances: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  architecturalStyle: z26.nullable(z26.string()),
  // associationAmenities: z.nullable(z.unknown()),
  associationFee: z26.nullable(z26.string()),
  // associationFee2: z.nullable(z.unknown()),
  // associationFeeIncludes: z.nullable(z.unknown()),
  associationName: z26.nullable(z26.string()),
  // associationName2: z.nullable(z.unknown()),
  // associationPhone: z.nullable(z.unknown()),
  // associationPhone2: z.nullable(z.unknown()),
  // associations: z.nullable(z.record(z.unknown())),
  // atAGlanceFacts: z.nullable(
  //     z.array(
  //         z
  //             .object({
  //                 factLabel: z.nullable(z.string()),
  //                 factValue: z.nullable(z.string()),
  //             })
  //             .partial()
  //     )
  // ),
  // attic: z.nullable(z.unknown()),
  // availabilityDate: z.nullable(z.unknown()),
  basement: z26.nullable(z26.string()),
  basementYN: z26.nullable(z26.boolean()),
  // bathrooms: z.nullable(z.number()),
  // bathroomsFloat: z.nullable(z.number()),
  bathroomsFull: z26.nullable(z26.number()),
  bathroomsHalf: z26.nullable(z26.number()),
  // bathroomsOneQuarter: z.nullable(z.unknown()),
  // bathroomsPartial: z.nullable(z.unknown()),
  bathroomsThreeQuarter: z26.nullable(z26.number()),
  // bedrooms: z.nullable(z.number()),
  // belowGradeFinishedArea: z.nullable(z.unknown()),
  // bodyType: z.nullable(z.unknown()),
  // builderModel: z.nullable(z.unknown()),
  // builderName: z.nullable(z.unknown()),
  // buildingArea: z.nullable(z.string()),
  // buildingAreaSource: z.nullable(z.unknown()),
  // buildingFeatures: z.nullable(z.unknown()),
  // buildingName: z.nullable(z.unknown()),
  // buyerAgencyCompensation: z.nullable(z.string()),
  // buyerAgencyCompensationType: z.nullable(z.string()),
  // canRaiseHorses: z.nullable(z.boolean()),
  carportParkingCapacity: z26.nullable(z26.number()),
  // cityRegion: z.nullable(z.string()),
  // commonWalls: z.nullable(z.unknown()),
  // communityFeatures: z.nullable(z.unknown()),
  // compensationBasedOn: z.nullable(z.unknown()),
  // constructionMaterials: z.nullable(z.array(z.string())),
  // contingency: z.nullable(z.unknown()),
  cooling: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // coveredParkingCapacity: z.nullable(z.unknown()),
  // cropsIncludedYN: z.nullable(z.unknown()),
  cumulativeDaysOnMarket: z26.nullable(z26.string()),
  // daysOnZillow: z.nullable(z.number()),
  // developmentStatus: z.nullable(z.unknown()),
  // doorFeatures: z.nullable(z.unknown()),
  // electric: z.nullable(z.array(z.string())),
  elementarySchool: z26.nullable(z26.string()),
  elementarySchoolDistrict: z26.nullable(z26.string()),
  // elevation: z.nullable(z.unknown()),
  // elevationUnits: z.nullable(z.string()),
  // entryLevel: z.nullable(z.unknown()),
  // entryLocation: z.nullable(z.unknown()),
  // exclusions: z.nullable(z.unknown()),
  exteriorFeatures: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // feesAndDues: z.nullable(z.unknown()),
  // fencing: z.nullable(z.unknown()),
  fireplaceFeatures: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  fireplaces: z26.nullable(z26.number()),
  flooring: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // foundationArea: z.nullable(z.unknown()),
  // foundationDetails: z.nullable(z.array(z.string())),
  frontageLength: z26.nullable(z26.string()),
  // frontageType: z.nullable(z.unknown()),
  // furnished: z.nullable(z.boolean()),
  garageParkingCapacity: z26.nullable(z26.number()),
  // gas: z.nullable(z.unknown()),
  // greenBuildingVerificationType: z.nullable(z.unknown()),
  // greenEnergyEfficient: z.nullable(z.unknown()),
  // greenEnergyGeneration: z.nullable(z.unknown()),
  // greenIndoorAirQuality: z.nullable(z.unknown()),
  // greenSustainability: z.nullable(z.unknown()),
  // greenWaterConservation: z.nullable(z.unknown()),
  // hasAdditionalParcels: z.nullable(z.boolean()),
  hasAssociation: z26.nullable(z26.boolean()),
  hasAttachedGarage: z26.nullable(z26.boolean()),
  // hasAttachedProperty: z.nullable(z.boolean()),
  hasCarport: z26.nullable(z26.boolean()),
  // hasCooling: z.nullable(z.boolean()),
  // hasElectricOnProperty: z.nullable(z.unknown()),
  hasFireplace: z26.nullable(z26.boolean()),
  hasGarage: z26.nullable(z26.boolean()),
  // hasHeating: z.nullable(z.boolean()),
  // hasHomeWarranty: z.nullable(z.boolean()),
  // hasLandLease: z.nullable(z.boolean()),
  hasOpenParking: z26.nullable(z26.boolean()),
  // hasPetsAllowed: z.nullable(z.unknown()),
  hasPrivatePool: z26.nullable(z26.boolean()),
  // hasRentControl: z.nullable(z.unknown()),
  hasSpa: z26.nullable(z26.boolean()),
  // hasView: z.nullable(z.boolean()),
  // hasWaterfrontView: z.nullable(z.unknown()),
  heating: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  highSchool: z26.nullable(z26.string()),
  highSchoolDistrict: z26.nullable(z26.string()),
  // hoaFee: z.nullable(z.unknown()),
  // hoaFeeTotal: z.nullable(z.unknown()),
  homeType: z26.nullable(z26.string()),
  // horseAmenities: z.nullable(z.unknown()),
  // horseYN: z.nullable(z.unknown()),
  // inclusions: z.nullable(z.array(z.string())),
  // incomeIncludes: z.nullable(z.unknown()),
  interiorFeatures: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // irrigationWaterRightsAcres: z.nullable(z.unknown()),
  // irrigationWaterRightsYN: z.nullable(z.boolean()),
  isNewConstruction: z26.nullable(z26.boolean()),
  // isSeniorCommunity: z.nullable(z.unknown()),
  // landLeaseAmount: z.nullable(z.unknown()),
  // landLeaseExpirationDate: z.nullable(z.unknown()),
  // laundryFeatures: z.nullable(z.unknown()),
  // levels: z.nullable(z.string()),
  // listAOR: z.nullable(z.unknown()),
  // listingId: z.nullable(z.unknown()),
  // listingTerms: z.nullable(z.string()),
  livingArea: z26.nullable(z26.string()),
  // livingAreaRange: z.nullable(z.unknown()),
  // livingAreaRangeUnits: z.nullable(z.unknown()),
  // livingQuarters: z.nullable(z.record(z.unknown())),
  lotFeatures: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  lotSize: z26.nullable(z26.string()),
  lotSizeDimensions: z26.nullable(z26.unknown()),
  // mainLevelBathrooms: z.nullable(z.number()),
  // mainLevelBedrooms: z.nullable(z.number()),
  // marketingType: z.nullable(z.unknown()),
  middleOrJuniorSchool: z26.nullable(z26.string()),
  middleOrJuniorSchoolDistrict: z26.nullable(z26.string()),
  // municipality: z.nullable(z.unknown()),
  // numberOfUnitsInCommunity: z.nullable(z.unknown()),
  // numberOfUnitsVacant: z.nullable(z.unknown()),
  // offerReviewDate: z.nullable(z.string()),
  onMarketDate: z26.nullable(z26.number()),
  // openParkingCapacity: z.nullable(z.unknown()),
  // otherEquipment: z.nullable(z.unknown()),
  // otherFacts: z.nullable(z.record(z.unknown())),
  // otherParking: z.nullable(z.unknown()),
  // otherStructures: z.nullable(z.unknown()),
  // ownership: z.nullable(z.unknown()),
  // ownershipType: z.nullable(z.unknown()),
  parcelNumber: z26.nullable(z26.string()),
  parkingCapacity: z26.nullable(z26.number()),
  parkingFeatures: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  patioAndPorchFeatures: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  poolFeatures: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // pricePerSquareFoot: z.nullable(z.number()),
  // propertyCondition: z.nullable(z.unknown()),
  propertySubType: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // roadSurfaceType: z.nullable(z.unknown()),
  roofType: z26.nullable(z26.string()),
  // rooms: z.nullable(
  //     z.array(
  //         z
  //             .object({
  //                 area: z.nullable(z.unknown()),
  //                 description: z.nullable(z.unknown()),
  //                 dimensions: z.nullable(z.unknown()),
  //                 features: z.nullable(z.unknown()),
  //                 level: z.nullable(z.unknown()),
  //                 roomArea: z.nullable(z.unknown()),
  //                 roomAreaSource: z.nullable(z.unknown()),
  //                 roomAreaUnits: z.nullable(z.unknown()),
  //                 roomDescription: z.nullable(z.unknown()),
  //                 roomDimensions: z.nullable(z.unknown()),
  //                 roomFeatures: z.nullable(z.unknown()),
  //                 roomLength: z.nullable(z.unknown()),
  //                 roomLengthWidthSource: z.nullable(z.unknown()),
  //                 roomLengthWidthUnits: z.nullable(z.unknown()),
  //                 roomLevel: z.nullable(z.string()),
  //                 roomType: z.nullable(z.string()),
  //                 roomWidth: z.nullable(z.unknown()),
  //             })
  //             .partial()
  //     )
  // ),
  // securityFeatures: z.nullable(z.unknown()),
  sewer: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  specialListingConditions: z26.nullable(z26.string()),
  stories: z26.nullable(z26.number()),
  structureType: z26.nullable(z26.string()),
  subdivisionName: z26.nullable(z26.string()),
  taxAnnualAmount: z26.nullable(z26.number()),
  taxLegalDescription: z26.nullable(z26.unknown()),
  topography: z26.nullable(z26.string()),
  // totalActualRent: z.nullable(z.number()),
  // totalBedrooms: z.nullable(z.unknown()),
  // totalRentableArea: z.nullable(z.unknown()),
  // totalUnits: z.nullable(z.unknown()),
  // unitsInCommunity: z.nullable(z.unknown()),
  // utilities: z.nullable(z.array(z.string())),
  // vegetation: z.nullable(z.array(z.string())),
  view: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // virtualTour: z.nullable(z.string()),
  waterSource: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // waterViewYN: z.nullable(z.boolean()),
  waterfrontFeatures: z26.nullable(z26.array(z26.string()).or(schEmptyObject)),
  // windowFeatures: z.nullable(z.array(z.string())),
  yearBuilt: z26.nullable(z26.number())
  // zoning: z.nullable(z.unknown()),
  // zoningDescription: z.nullable(z.string()),
}).partial();
var schAddress2 = z26.object({
  city: z26.string().nullable(),
  community: z26.string().nullable(),
  neighborhood: z26.string().nullable(),
  state: z26.string().nullable(),
  streetAddress: z26.string().nullable(),
  subdivision: z26.string().nullable(),
  zipcode: z26.string().nullable()
}).partial();
var schAttributionInfo = z26.object({
  // agentEmail: z.string().nullable(),
  // agentLicenseNumber: z.string().nullable(),
  agentName: z26.string().nullable(),
  agentPhoneNumber: z26.string().nullable(),
  // attributionTitle: z.string().nullable(),
  // brokerName: z.string().nullable(),
  // brokerPhoneNumber: z.string().nullable(),
  // buyerAgentMemberStateLicense: z.string().nullable(),
  // buyerAgentName: z.string().nullable(),
  // buyerBrokerageName: z.string().nullable(),
  // coAgentLicenseNumber: z.string().nullable(),
  // coAgentName: z.string().nullable(),
  // coAgentNumber: z.string().nullable(),
  infoString10: z26.string().nullable(),
  infoString16: z26.string().nullable(),
  infoString3: z26.string().nullable(),
  infoString5: z26.string().nullable(),
  lastChecked: z26.string().nullable(),
  lastUpdated: z26.string().nullable(),
  // listingAgents: z
  //     .array(
  //         z
  //             .object({
  //                 associatedAgentType: z.string().nullable(),
  //                 memberFullName: z.string().nullable(),
  //                 memberStateLicense: z.string().nullable(),
  //             })
  //             .partial()
  //     )
  //     .nullable(),
  // listingAgreement: z.string().nullable(),
  // listingOffices: z
  //     .array(
  //         z
  //             .object({
  //                 associatedOfficeType: z.string().nullable(),
  //                 officeName: z.string().nullable(),
  //             })
  //             .partial()
  //     )
  //     .nullable(),
  // mlsDisclaimer: z.string().nullable(),
  mlsId: z26.string().nullable(),
  mlsName: z26.string().nullable()
  // providerLogo: z.string().nullable(),
  // trueStatus: z.string().nullable(),
}).partial();
var schAttributeSource = z26.object({
  infoString1: z26.string().nullable(),
  infoString2: z26.string().nullable(),
  infoString3: z26.string().nullable()
}).partial();
var schPriceHistory = z26.object({
  attributeSource: schAttributeSource.nullable(),
  buyerAgent: z26.unknown().nullable(),
  date: z26.string().nullable(),
  event: z26.string().nullable(),
  postingIsRental: z26.boolean().nullable(),
  price: z26.number().nullable(),
  priceChangeRate: z26.number().nullable(),
  pricePerSquareFoot: z26.number().nullable(),
  sellerAgent: z26.unknown().nullable(),
  showCountyLink: z26.boolean().nullable(),
  source: z26.string().nullable(),
  time: z26.number().nullable()
}).partial();
var schZillowListing = z26.object({
  address: schAddress2.nullable(),
  annualHomeownersInsurance: z26.number().nullable(),
  attributionInfo: schAttributionInfo.nullable(),
  bathrooms: z26.number().nullable(),
  bedrooms: z26.number().nullable(),
  brokerId: z26.string().nullable(),
  brokerageName: z26.string().nullable(),
  building: z26.string().nullable(),
  buildingPermits: z26.string().nullable(),
  city: z26.string().nullable(),
  cityId: z26.number().nullable(),
  comingSoonOnMarketDate: z26.string().nullable(),
  // contact_recipients: z.array(schContactRecipient).nullable(),
  contingentListingType: z26.string().nullable(),
  country: z26.string().nullable(),
  county: z26.string().nullable(),
  countyFIPS: z26.string().nullable(),
  countyId: z26.number().nullable(),
  currency: z26.string().nullable(),
  datePosted: z26.string().nullable(),
  dateSold: z26.string().nullable(),
  description: z26.string().nullable(),
  favoriteCount: z26.number().nullable(),
  // homeFacts: z.unknown(),
  homeStatus: z26.string().nullable(),
  homeType: z26.string().nullable(),
  imgSrc: z26.string().nullable(),
  isListedByOwner: z26.string().nullable(),
  latitude: z26.number().nullable(),
  // listed_by: z
  //     .object({
  //         agent_reason: z.number().nullable(),
  //         badge_type: z.string().nullable(),
  //         business_name: z.string().nullable(),
  //         display_name: z.string().nullable(),
  //         image_url: z.string().nullable(),
  //         phone: schPhone.nullable(),
  //         profile_url: z.string().nullable(),
  //         rating_average: z.number().nullable(),
  //         recent_sales: z.number().nullable(),
  //         review_count: z.number().nullable(),
  //         zpro: z.boolean().nullable(),
  //         zuid: z.string().nullable(),
  //     })
  //     .nullable(),
  // listingProvider: z.string().nullable(),
  listingSubType: z26.object({
    is_FSBA: z26.boolean().nullable(),
    is_FSBO: z26.boolean().nullable(),
    is_bankOwned: z26.boolean().nullable(),
    is_comingSoon: z26.boolean().nullable(),
    is_forAuction: z26.boolean().nullable(),
    is_foreclosure: z26.boolean().nullable(),
    is_newHome: z26.boolean().nullable(),
    is_openHouse: z26.boolean().nullable().optional(),
    is_pending: z26.boolean().nullable()
  }).nullable(),
  livingArea: z26.number().nullable(),
  livingAreaUnits: z26.string().nullable(),
  livingAreaValue: z26.number().nullable(),
  longitude: z26.number().nullable(),
  mlsid: z26.string().nullable(),
  monthlyHoaFee: z26.number().nullable(),
  // mortgageRates: z
  //     .object({
  //         thirtyYearFixedRate: z.number().nullable(),
  //     })
  //     .nullable(),
  price: z26.number().nullable(),
  priceHistory: z26.array(schPriceHistory).or(z26.object({})).nullable(),
  propertyTaxRate: z26.number().nullable(),
  propertyTypeDimension: z26.string().nullable(),
  providerListingID: z26.string().nullable(),
  rentZestimate: z26.number().nullable(),
  resoFacts: schRESOFacts.nullable(),
  solarPotential: z26.string().nullable(),
  state: z26.string().nullable(),
  stateId: z26.number().nullable(),
  streetAddress: z26.string().nullable(),
  timeOnZillow: z26.string().nullable(),
  timeZone: z26.string().nullable(),
  url: z26.string().nullable(),
  yearBuilt: z26.number().nullable(),
  // zestimate: z.number().nullable(),
  // zestimateHighPercent: z.string().nullable(),
  // zestimateLowPercent: z.string().nullable(),
  zipcode: z26.string().nullable(),
  zpid: z26.number().nullable()
}).partial();
var schZillowPropertySearchResponse = z26.object({
  address: z26.string().nullable(),
  bathrooms: z26.number().nullable(),
  bedrooms: z26.number().nullable(),
  contingentListingType: z26.any().nullable(),
  country: z26.string().nullable(),
  currency: z26.string().nullable(),
  dateSold: z26.number().nullable(),
  hasImage: z26.boolean().nullable(),
  imgSrc: z26.string().nullable(),
  latitude: z26.number().nullable(),
  longitude: z26.number().nullable(),
  listingStatus: z26.string().nullable(),
  listingSubType: z26.any().nullable(),
  livingArea: z26.number().nullable(),
  lotAreaUnit: z26.string().nullable(),
  lotAreaValue: z26.number().nullable(),
  price: z26.number().nullable(),
  propertyType: z26.string().nullable(),
  zestimate: z26.number().nullable(),
  zpid: z26.string().nullable()
});
var schZillowSearchResponse = z26.object({
  currentPage: z26.number(),
  props: z26.array(schZillowPropertySearchResponse).optional(),
  resultsPerPage: z26.number(),
  totalPages: z26.number(),
  totalResultCount: z26.number()
});

// src/api/accounts/schemas.ts
import { z as z29 } from "zod";

// src/api/v2/subscriptions/index.ts
import { z as z27 } from "zod";
var schMcKissockOfferType = z27.enum(["trial", "bundle"]);
function isMcKissockOfferType(x) {
  return typeof x === "string" && (x === "trial" || x === "bundle");
}
var schPreviousSubscriptions = z27.object({
  id: z27.string(),
  type: z27.string(),
  endedAt: schAloftTime.optional()
});
var schActiveSubscription = z27.object({
  hasActiveSubscription: z27.literal(true),
  customerID: z27.string(),
  type: z27.literal("active"),
  nextPaymentDue: schAloftDate,
  previousSubscriptions: z27.array(schPreviousSubscriptions)
});
var schActiveTrial = z27.object({
  hasActiveSubscription: z27.literal(true),
  customerID: z27.string(),
  type: z27.literal("trialing"),
  trialEnd: schAloftDate,
  previousSubscriptions: z27.array(schPreviousSubscriptions),
  hasPaymentMethod: z27.boolean(),
  id: z27.string(),
  pendingSetupIntent: z27.string(),
  priceID: z27.string(),
  subscriptionItemID: z27.string()
});
var schInactiveSubscription = z27.object({
  hasActiveSubscription: z27.literal(false),
  customerID: z27.string(),
  previousSubscriptions: z27.array(schPreviousSubscriptions)
});
var schSubscriptionResponse = z27.union([
  schActiveSubscription,
  schActiveTrial,
  schInactiveSubscription
]);
var schCreateStripeCustomerSessionResponse = z27.object({
  clientSecret: z27.string()
});
var schCreateStripeSubscriptionRequest = z27.object({
  priceID: z27.string(),
  promotionCode: z27.string().optional(),
  addTrial: z27.boolean().optional(),
  mcKissockOffer: schMcKissockOfferType.optional()
});
var schCreateStripeSubscriptionResponse = z27.object({
  clientSecret: z27.string(),
  paymentIntentType: z27.enum(["setup", "payment"])
});
var schUpdateStripeBillingAddressRequest = z27.object({
  city: z27.string(),
  country: z27.string(),
  line1: z27.string(),
  line2: z27.string().optional(),
  postal_code: z27.string(),
  state: z27.string()
});
var schUpdateStripeBillingAddressResponse = z27.object({
  automaticTaxStatus: z27.enum(["supported", "unrecognized_location", "not_collecting", "failed"])
});
var schCalculateStripeSalesTaxRequest = z27.object({
  address: schUpdateStripeBillingAddressRequest,
  price: schAloftPrice
});
var schCalculateStripeSalesTaxResponse = z27.object({
  totalAmount: schAloftPrice,
  taxAmount: schAloftPrice
});
var schCalculateStripePricingBreakdownRequest = z27.object({
  priceID: z27.string(),
  isTrial: z27.boolean(),
  address: schUpdateStripeBillingAddressRequest.optional(),
  promotionCode: z27.string().optional()
});
var schCalculateStripePricingBreakdownResponse = z27.object({
  discount: z27.object({
    amount: schAloftPrice,
    percent: z27.number(),
    promotionCode: z27.string(),
    couponName: z27.string()
  }).or(z27.null()),
  // null if no promo code provided
  subtotalExcludingTax: schAloftPrice,
  tax: schAloftPrice.or(z27.null()),
  // null if no billing address provided (i.e., pricing breakdown calculated with promo code before billing address added)
  total: schAloftPrice,
  totalDueToday: schAloftPrice.or(z27.null())
  // null if not trial
});
var schValidatePromotionCodeRequest = z27.object({
  promotionCode: z27.string()
});
var schValidatePromotionCodeResponse = z27.object({
  isValid: z27.boolean()
});
var schConvertTrialRequest = z27.object({
  priceID: z27.string(),
  promotionCode: z27.string().optional()
});
var TRIAL_PERIOD_DAYS = 14;
var MCKISSOCK_TRIAL_PERIOD_DAYS = 60;

// src/api/accounts/ftux.ts
import { z as z28 } from "zod";
var AUTO_HELP_DRAWER_MAX = 1;
var DEFAULT_MIN = 1;
var schFTUXes = z28.object({
  "autoHelpDrawer-properties": z28.number().default(0),
  "autoHelpDrawer-market-conditions": z28.number().default(0),
  "autoHelpDrawer-replacement-cost": z28.number().default(0),
  "autoHelpDrawer-depreciation-and-site": z28.number().default(0),
  "autoHelpDrawer-summary": z28.number().default(0),
  "autoHelpDrawer-adjustments-summary": z28.number().default(0),
  "autoHelpDrawer-commentary-summary": z28.number().default(0),
  "autoHelpDrawer-cost-appr-summary": z28.number().default(0),
  "autoHelpDrawer-paired-sales-library": z28.number().default(0),
  "autoHelpDrawer-paired-sales-search-and-adjust": z28.number().default(0),
  "autoHelpDrawer-analysis": z28.number().default(0),
  "autoHelpDrawer-adjustments": z28.number().default(0),
  "autoHelpDrawer-commentary": z28.number().default(0),
  "autoHelpDrawer-craftsman-cost-approach": z28.number().default(0),
  replacementCostInputFocus: z28.number().default(0),
  analysisIntroTour: z28.number().default(0)
});
var ftuxMinDictionary = {
  "autoHelpDrawer-properties": DEFAULT_MIN,
  "autoHelpDrawer-market-conditions": DEFAULT_MIN,
  "autoHelpDrawer-replacement-cost": DEFAULT_MIN,
  "autoHelpDrawer-depreciation-and-site": DEFAULT_MIN,
  "autoHelpDrawer-summary": DEFAULT_MIN,
  "autoHelpDrawer-adjustments-summary": DEFAULT_MIN,
  "autoHelpDrawer-commentary-summary": DEFAULT_MIN,
  "autoHelpDrawer-cost-appr-summary": DEFAULT_MIN,
  "autoHelpDrawer-paired-sales-library": DEFAULT_MIN,
  "autoHelpDrawer-paired-sales-search-and-adjust": DEFAULT_MIN,
  "autoHelpDrawer-analysis": 2,
  "autoHelpDrawer-adjustments": DEFAULT_MIN,
  "autoHelpDrawer-commentary": DEFAULT_MIN,
  "autoHelpDrawer-craftsman-cost-approach": DEFAULT_MIN,
  replacementCostInputFocus: DEFAULT_MIN,
  analysisIntroTour: DEFAULT_MIN
};
var ftuxMaxDictionary = {
  "autoHelpDrawer-properties": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-market-conditions": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-replacement-cost": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-depreciation-and-site": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-summary": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-adjustments-summary": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-commentary-summary": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-cost-appr-summary": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-paired-sales-library": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-paired-sales-search-and-adjust": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-analysis": 2,
  "autoHelpDrawer-adjustments": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-commentary": AUTO_HELP_DRAWER_MAX,
  "autoHelpDrawer-craftsman-cost-approach": AUTO_HELP_DRAWER_MAX,
  replacementCostInputFocus: 2,
  analysisIntroTour: 1
};
var initialFTUXDictionary = {
  "autoHelpDrawer-properties": 0,
  "autoHelpDrawer-market-conditions": 0,
  "autoHelpDrawer-replacement-cost": 0,
  "autoHelpDrawer-depreciation-and-site": 0,
  "autoHelpDrawer-summary": 0,
  "autoHelpDrawer-adjustments-summary": 0,
  "autoHelpDrawer-commentary-summary": 0,
  "autoHelpDrawer-cost-appr-summary": 0,
  "autoHelpDrawer-paired-sales-library": 0,
  "autoHelpDrawer-paired-sales-search-and-adjust": 0,
  "autoHelpDrawer-analysis": 0,
  "autoHelpDrawer-adjustments": 0,
  "autoHelpDrawer-commentary": 0,
  "autoHelpDrawer-craftsman-cost-approach": 0,
  replacementCostInputFocus: 0,
  analysisIntroTour: 0
};

// src/api/accounts/schemas.ts
var schUserDefinedRoles = z29.enum([
  "appraiser",
  "trainee",
  "amc-professional",
  "loan-officer",
  "agent-broker",
  "trainer-educator",
  "gse-rep",
  "other"
]);
var userDefinedRoleToLabel = {
  appraiser: "Appraiser",
  trainee: "Appraiser Trainee",
  "amc-professional": "AMC Professional",
  "loan-officer": "Loan Officer",
  "agent-broker": "Agent / Broker",
  "trainer-educator": "Trainer / Educator",
  "gse-rep": "GSE Representative",
  other: "Other"
};
var schReportSoftware = z29.enum([
  "total",
  "aci",
  "appraise-it-pro",
  "nexus",
  "clickforms",
  "anow",
  "homeputer",
  "other"
]);
var schAppraiserLicense = z29.object({
  id: z29.string().optional(),
  state: schStateCode.optional()
}).optional();
var schAccountEmail = z29.string().email();
var schMcKissockAccountData = z29.object({
  type: schMcKissockOfferType,
  email: schAccountEmail
});
var schAccountBodyV1 = z29.object({
  version: z29.literal(1),
  address: schAddress.optional(),
  firstName: z29.string().optional(),
  lastName: z29.string().optional(),
  phone: z29.string().optional(),
  userDefinedRole: schUserDefinedRoles.optional(),
  company: z29.string().optional(),
  mlsIDs: z29.array(z29.string()).optional(),
  license: schAppraiserLicense,
  ftux: schFTUXes.optional(),
  signatureBlobId: z29.string().optional(),
  // ID of the signature blob in S3
  // Info used by onboarding
  bubbleUserID: z29.string().optional(),
  isOnboardingComplete: z29.boolean().optional(),
  referredBy: z29.string().optional(),
  preferredReportSoftware: schReportSoftware.optional(),
  mcKissockData: schMcKissockAccountData.optional()
});
var accountBodySchemaByVersion = {
  1: schAccountBodyV1
};
var schAccountBodyLatest = schAccountBodyV1;
var schUserType = z29.enum(["saas", "appraisify"]);
var schBackendAccount = z29.object({
  id: z29.string(),
  isArchived: z29.boolean().optional(),
  createdAt: schAloftTime,
  modifiedAt: schAloftTime,
  body: schAccountBodyLatest,
  isAdmin: z29.boolean(),
  email: schAccountEmail
});
var schAccount = schBackendAccount.extend({
  userType: schUserType
});
var schAccountGetResponse = schAccount;
var schAccountCreateRequest = schAccount.pick({
  body: true
});
var schAccountPatchRequest = schAccountBodyLatest.extend({
  version: z29.literal(1).optional()
});
var schAccountUpdateRequest = schAccount.pick({
  body: true,
  isArchived: true
});

// src/api/accounts/index.ts
var ACCOUNT_API = {
  GET: {
    REQUEST: {},
    RESPONSE: schAccountGetResponse
  },
  POST: {
    REQUEST: {
      BODY: schAccountCreateRequest
    },
    RESPONSE: schAccount
  },
  PUT: {
    REQUEST: {
      BODY: schAccountUpdateRequest
    },
    RESPONSE: schAccount
  },
  PATCH: {
    REQUEST: {
      BODY: schAccountPatchRequest
    },
    RESPONSE: schAccount
  }
};

// src/api/blob/index.ts
import { z as z30 } from "zod";
var BLOB_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z30.object({
        blobID: schBlobID
      })
    },
    RESPONSE: z30.unknown()
  }
  // TODO: add PUT as well
};
var BLOB_METADATA_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z30.object({
        blobID: schBlobID
      })
    },
    RESPONSE: z30.custom()
  }
};

// src/api/datasets/types.ts
import { z as z31 } from "zod";
var schDatasetSource = z31.enum(["custom", "constellation1", "abode"]);

// src/api/housingTrends/schemas.ts
import { z as z32 } from "zod";
var schMarketTrends = z32.object({
  zip: z32.string(),
  updated_date: z32.string(),
  monthly_trends: z32.object({
    historical_data: z32.array(
      z32.object({
        year: z32.number(),
        month: z32.number(),
        typicalHomeValue: schAloftPrice,
        numCloses: z32.number().optional(),
        sourceMLSes: schMLSID.array().optional(),
        medianListPrice: schAloftPrice.optional(),
        medianClosePriceOverListPrice: z32.number().optional(),
        medianDaysOnMarket: z32.number().optional()
      })
    ),
    one_month_projection: schAloftPrice.optional()
  })
});

// src/api/listings/api.ts
import { z as z38 } from "zod";

// src/api/listings/types.ts
var import_shared_utils36 = __toESM(require_lib(), 1);
var import_is = __toESM(require_is(), 1);
import { AloftArea as AloftArea10, AloftPrice as AloftPrice9 } from "@aloft/shared-objects";
import { z as z37 } from "zod";

// src/listing/constellationOne.ts
import { z as z36 } from "zod";

// src/listing/OriginatingSystemName.ts
import { z as z33 } from "zod";
var schOriginatingSystemName = z33.enum([
  "ARMLS",
  "ArizonaRegional",
  "Austin",
  "Beaches",
  "BrevardMLS",
  "BridgeMLS",
  "BrightMLS",
  "CanopyMLS",
  "CentralPanhandle",
  "CentralTexas",
  "CincyMLS",
  "CLAW",
  "CRMLS",
  "DesMoines",
  "EmeraldCoast",
  "FGCMLS",
  "FMLS",
  "GardenStateMLS",
  "GeorgiaMLS",
  "GSREIN",
  "HeartlandMLS",
  "Houston",
  "IRMLS",
  "Knoxville",
  "LasVegas",
  "LexingtonKY",
  "MARIS",
  "MIBOR",
  "Metrolist",
  "MLSNow",
  "MLSOK",
  "MLSUnited",
  "MLSPIN",
  "MLSTechnology",
  "MonmouthOceanMLS",
  "MRED",
  "NABOR",
  "NEREN",
  "NorthCarolinaRegional",
  "NorthStarMLS",
  "NorthwestMLS",
  "NTREIS",
  "OneKey",
  "PalmBeachFL",
  "PortlandOR",
  "Realcomp",
  "RealMLS",
  "Realtracs",
  "REBNY",
  "REColorado",
  "RMLSA",
  "SanAntonio",
  "SEF",
  "SmartMLS",
  "StellarMLS",
  "SWMRIC",
  "TriadMLS",
  "TriangleMLS",
  "UtahRealEstate",
  "WestPenn",
  "WyomingMLS"
]);

// src/listing/resoListing.ts
import { z as z35 } from "zod";

// src/listing/types.ts
import { z as z34 } from "zod";
var schListingSource = z34.literal("constellation1").or(z34.literal("abode"));
var schRESOMedia = z34.object({
  MediaURL: z34.string(),
  blobID: z34.string().optional()
});

// src/listing/resoListing.ts
var schRESOListing = z35.object({
  Air: z35.string(),
  Appliances: z35.array(z35.string()),
  ArchitecturalStyle: z35.array(z35.string()),
  AssociationFee: z35.number(),
  AssociationFeeFrequency: z35.string(),
  AssociationName: z35.string(),
  AssociationYN: z35.boolean(),
  Basement: z35.array(z35.string()),
  BasementYN: z35.boolean(),
  BathroomsFull: z35.number(),
  BathroomsHalf: z35.number(),
  BathroomsThreeQuarter: z35.number(),
  BathroomsTotalInteger: z35.number(),
  BedroomsTotal: z35.number(),
  BuyerFinancing: z35.array(z35.string()),
  City: z35.string(),
  CityRegion: z35.string(),
  CloseDate: z35.string(),
  ClosePrice: z35.number(),
  ConcessionsAmount: z35.number(),
  Cooling: z35.array(z35.string()),
  CountyOrParishFIPS: z35.string(),
  CountyOrParish: z35.string(),
  CumulativeDaysOnMarket: z35.number(),
  DaysOnMarket: z35.number(),
  Directions: z35.string(),
  DoorFeatures: z35.array(z35.string()),
  DoorsWindows: z35.string(),
  ElementarySchool: z35.string(),
  ExpirationDate: z35.string(),
  ExteriorFeatures: z35.array(z35.string()),
  FireplaceFeatures: z35.array(z35.string()),
  FireplacesTotal: z35.number(),
  FloorDescription: z35.string(),
  Flooring: z35.array(z35.string()),
  GarageSpaces: z35.number(),
  GarageYN: z35.boolean(),
  GreenEnergyEfficient: z35.array(z35.string()),
  HasAttachedGarage: z35.boolean().nullable(),
  HasView: z35.boolean(),
  Heating: z35.array(z35.string()),
  HighSchool: z35.string(),
  InteriorFeatures: z35.array(z35.string()),
  Latitude: z35.number(),
  Levels: z35.array(z35.string()),
  ListAgentFullName: z35.string(),
  ListAgentKey: z35.string(),
  ListAgentMlsID: z35.string(),
  ListAgentPhone: z35.string(),
  ListAgentPreferredPhone: z35.string(),
  ListingContractDate: z35.string(),
  ListingId: z35.string(),
  ListingTerms: z35.array(z35.string()),
  ListOfficeKey: z35.string(),
  ListOfficeMlsId: z35.string(),
  ListOfficeName: z35.string(),
  ListOfficePhone: z35.string(),
  ListPrice: z35.number(),
  LivingArea: z35.number(),
  Longitude: z35.number(),
  LotDescription: z35.string(),
  LotFeatures: z35.array(z35.string()),
  LotSizeAcres: z35.number(),
  LotSizeSquareFeet: z35.number(),
  Media: z35.array(schRESOMedia),
  MiddleOrJuniorSchool: z35.string(),
  MLSAreaMajor: z35.string(),
  MLSOUID: z35.string(),
  MLSName: z35.string(),
  // Technically not RESO field but OriginatingSystemName already taken by C1Listing
  MlsStatus: z35.string(),
  ModificationTimestamp: z35.string(),
  NeighborhoodName: z35.string(),
  NewConstructionYN: z35.boolean(),
  OnMarketDate: z35.string(),
  OnMarketTimestamp: z35.string(),
  OriginalListPrice: z35.number(),
  ParcelNumber: z35.string(),
  ParkingFeatures: z35.array(z35.string()),
  ParkingTotal: z35.number(),
  PatioAndPorchFeatures: z35.array(z35.string()),
  PendingTimestamp: z35.string(),
  PoolFeatures: z35.array(z35.string()),
  PostalCode: z35.string(),
  PoolPrivateYN: z35.boolean(),
  PropertyAttachedYN: z35.boolean(),
  PropertySubType: z35.string(),
  PropertyType: z35.string(),
  PublicRemarks: z35.string(),
  PurchaseContractDate: z35.string(),
  RentControlYN: z35.boolean(),
  Roof: z35.array(z35.string()),
  RoomsTotal: z35.number(),
  SchoolDistrict: z35.string(),
  Sewer: z35.array(z35.string()),
  SpaYN: z35.boolean(),
  SpecialListingConditions: z35.array(z35.string()),
  StandardStatus: z35.string(),
  StateOrProvince: z35.string(),
  Stories: z35.number(),
  StoriesTotal: z35.number(),
  StreetDirSuffix: z35.string(),
  StreetName: z35.string(),
  StreetNumber: z35.string(),
  StreetSuffix: z35.string(),
  StructureType: z35.array(z35.string()),
  SubdivisionName: z35.string(),
  TaxAnnualAmount: z35.number(),
  TaxLegalDescription: z35.string(),
  ToolkitListingID: schToolkitListingID,
  TaxYear: z35.number(),
  Topography: z35.string(),
  UnitNumber: z35.string(),
  UnparsedAddress: z35.string(),
  View: z35.array(z35.string()),
  WaterFrontYN: z35.boolean(),
  WaterFrontFeatures: z35.string(),
  WaterSource: z35.array(z35.string()),
  WithdrawnDate: z35.string(),
  YearBuilt: z35.number()
}).partial();

// src/listing/constellationOne.ts
var schConstellationOneListing = schRESOListing.extend({
  DerivedAssociationFeeMonthly: z36.number(),
  DerivedPendingTimestamp: z36.string(),
  DerivedOnMarketTimestamp: z36.string(),
  RawMlsStoriesTotal: z36.number(),
  RawMlsBathroomsTotal: z36.number(),
  OriginatingSystemName: schOriginatingSystemName,
  // Added by us
  LastSyncDate: z36.string()
}).partial();
var constellationOneExample = {
  Air: "",
  Appliances: [],
  ArchitecturalStyle: [],
  AssociationFee: 0,
  AssociationFeeFrequency: "",
  AssociationName: "",
  AssociationYN: false,
  Basement: [],
  BasementYN: false,
  BathroomsFull: 0,
  BathroomsHalf: 0,
  BathroomsThreeQuarter: 0,
  BathroomsTotalInteger: 0,
  BedroomsTotal: 0,
  BuyerFinancing: [],
  City: "",
  CityRegion: "",
  CloseDate: "",
  ClosePrice: 0,
  ConcessionsAmount: 0,
  Cooling: [],
  CountyOrParish: "",
  CountyOrParishFIPS: "",
  CumulativeDaysOnMarket: 0,
  DaysOnMarket: 0,
  Directions: "",
  DoorFeatures: [],
  DoorsWindows: "",
  ElementarySchool: "",
  ExpirationDate: "",
  ExteriorFeatures: [],
  FireplaceFeatures: [],
  FireplacesTotal: 0,
  FloorDescription: "",
  Flooring: [],
  GarageSpaces: 0,
  GarageYN: false,
  GreenEnergyEfficient: [],
  HasAttachedGarage: null,
  HasView: false,
  Heating: [],
  HighSchool: "",
  InteriorFeatures: [],
  Latitude: 0,
  Levels: [],
  ListAgentFullName: "",
  ListAgentKey: "",
  ListAgentMlsID: "",
  ListAgentPhone: "",
  ListAgentPreferredPhone: "",
  ListingContractDate: "",
  ListingId: "",
  ListingTerms: [],
  ListOfficeKey: "",
  ListOfficeMlsId: "",
  ListOfficeName: "",
  ListOfficePhone: "",
  ListPrice: 0,
  LivingArea: 0,
  Longitude: 0,
  LotDescription: "",
  LotFeatures: [],
  LotSizeAcres: 0,
  LotSizeSquareFeet: 0,
  MiddleOrJuniorSchool: "",
  MLSAreaMajor: "",
  MLSName: "",
  MlsStatus: "",
  ModificationTimestamp: "",
  NeighborhoodName: "",
  NewConstructionYN: false,
  OnMarketDate: "",
  OnMarketTimestamp: "",
  OriginalListPrice: 0,
  OriginatingSystemName: "NorthwestMLS",
  ParcelNumber: "",
  ParkingFeatures: [],
  ParkingTotal: 0,
  PatioAndPorchFeatures: [],
  PendingTimestamp: "",
  PoolFeatures: [],
  PoolPrivateYN: false,
  PostalCode: "",
  PropertyAttachedYN: false,
  PropertySubType: "",
  PropertyType: "",
  PublicRemarks: "",
  PurchaseContractDate: "",
  RentControlYN: false,
  Roof: [],
  RoomsTotal: 0,
  SchoolDistrict: "",
  Sewer: [""],
  SpaYN: false,
  SpecialListingConditions: [],
  StandardStatus: "",
  StateOrProvince: "",
  Stories: 0,
  StoriesTotal: 0,
  StreetDirSuffix: "",
  StreetName: "",
  StreetNumber: "",
  StreetSuffix: "",
  StructureType: [],
  SubdivisionName: "",
  TaxAnnualAmount: 0,
  TaxLegalDescription: "",
  TaxYear: 0,
  Topography: "",
  UnitNumber: "",
  UnparsedAddress: "",
  View: [],
  WaterFrontYN: false,
  WaterFrontFeatures: "",
  WaterSource: [],
  WithdrawnDate: "",
  YearBuilt: 0,
  DerivedAssociationFeeMonthly: 0,
  DerivedPendingTimestamp: "",
  DerivedOnMarketTimestamp: "",
  Media: [],
  RawMlsStoriesTotal: 0,
  RawMlsBathroomsTotal: 0,
  LastSyncDate: "",
  ToolkitListingID: "tkl:armls:12345",
  MLSOUID: ""
};
var CONSTELLATION_ONE_KEYS = Object.keys(constellationOneExample);

// src/api/listings/types.ts
var isUndefinedOrEmptyString = (x) => (0, import_is.isUndefined)(x) || x === "";
var removeClientFilterEmptyStrings = (x) => {
  if ((0, import_is.isUndefined)(x))
    return void 0;
  return {
    min: x.min === "" ? void 0 : x.min,
    max: x.max === "" ? void 0 : x.max,
    variance: x.variance === "" ? void 0 : x.variance,
    percentage: x.percentage === "" ? void 0 : x.percentage,
    exact: x.exact === "" ? void 0 : x.exact
  };
};
var removeEmptyStrings = (x) => {
  if ((0, import_is.isUndefined)(x))
    return void 0;
  if (isUndefinedOrEmptyString(x.min) && isUndefinedOrEmptyString(x.max))
    return void 0;
  return {
    min: x.min === "" ? void 0 : x.min,
    max: x.max === "" ? void 0 : x.max
  };
};
var percentage = z37.union([
  z37.number().min(0, { message: "must be greater than or equal to zero" }).max(100, { message: "Must be lesser than or equal to 100" }),
  z37.literal(""),
  z37.undefined()
]);
var numberOrEmpty = z37.union([
  z37.number().min(0, { message: "must be greater than or equal to zero" }),
  z37.literal(""),
  z37.undefined()
]);
var numberRange = z37.strictObject({
  min: numberOrEmpty.optional(),
  max: numberOrEmpty.optional()
}).optional().transform(removeEmptyStrings);
var clientNumberRange = z37.strictObject({
  min: numberOrEmpty.optional(),
  max: numberOrEmpty.optional(),
  variance: numberOrEmpty.optional(),
  exact: numberOrEmpty.optional(),
  percentage: percentage.optional()
}).optional().transform(removeClientFilterEmptyStrings);
var dateOrEmpty = z37.union([schAloftDate, z37.literal(""), z37.undefined()]);
var dateRange = z37.strictObject({
  min: dateOrEmpty.optional(),
  max: dateOrEmpty.optional()
}).optional().transform(removeEmptyStrings);
var clientDateRange = z37.strictObject({
  min: dateOrEmpty.optional(),
  max: dateOrEmpty.optional(),
  variance: numberOrEmpty.optional(),
  exact: numberOrEmpty.optional(),
  percentage: percentage.optional()
}).optional().transform(removeClientFilterEmptyStrings);
var priceOrEmpty = z37.union([
  schAloftPrice.transform((x, ctx) => {
    if ((0, import_shared_utils36.isDefined)(x) && AloftPrice9.isAloftPrice(x)) {
      if (x.unitAmount < 0) {
        ctx.addIssue({
          code: z37.ZodIssueCode.custom,
          message: "must be greater than or equal to zero",
          path: []
        });
      }
    }
    return x;
  }),
  z37.literal(""),
  z37.undefined()
]);
var priceRange = z37.strictObject({
  min: priceOrEmpty.optional(),
  max: priceOrEmpty.optional()
}).optional().transform(removeEmptyStrings);
var clientPriceRange = z37.strictObject({
  min: priceOrEmpty.optional(),
  max: priceOrEmpty.optional(),
  variance: numberOrEmpty.optional(),
  exact: numberOrEmpty.optional(),
  percentage: percentage.optional()
}).optional().transform(removeClientFilterEmptyStrings);
var areaOrEmpty = z37.union([
  schAloftArea.transform((x, ctx) => {
    if ((0, import_shared_utils36.isDefined)(x) && AloftArea10.isAloftArea(x)) {
      if (x.unitAmount < 0) {
        ctx.addIssue({
          code: z37.ZodIssueCode.custom,
          message: "must be greater than or equal to zero",
          path: []
        });
      }
    }
    return x;
  }),
  z37.literal(""),
  z37.undefined()
]);
var areaRange = z37.strictObject({
  min: areaOrEmpty.optional(),
  max: areaOrEmpty.optional(),
  variance: numberOrEmpty.optional(),
  exact: numberOrEmpty.optional(),
  percentage: percentage.optional()
}).optional().transform(removeEmptyStrings);
var clientAreaRange = z37.strictObject({
  min: areaOrEmpty.optional(),
  max: areaOrEmpty.optional(),
  variance: numberOrEmpty.optional(),
  exact: numberOrEmpty.optional(),
  percentage: percentage.optional()
}).optional().transform(removeClientFilterEmptyStrings);
var string = z37.string().optional().transform((x) => x === "" ? void 0 : x);
var booleanOrEmpty = z37.union([z37.boolean(), z37.literal("")]);
var boolean = booleanOrEmpty.optional().transform((x) => x === "" ? void 0 : x);
var schZipCode2 = numberOrEmpty.optional().transform((x, ctx) => {
  if (x === "")
    return void 0;
  if ((0, import_is.isNumber)(x)) {
    if (x.toString().length !== 5) {
      ctx.addIssue({
        code: z37.ZodIssueCode.custom,
        message: "must be 5 digits",
        path: []
      });
    }
  }
  return x;
});
var schMlsPropertyType = z37.enum([
  "Acreage",
  "Boat Dock",
  "Business Opportunity",
  "Commercial",
  "Commercial Land",
  "Commercial Lease",
  "Commercial Sale",
  "Condo",
  "Farm",
  "Lots and Land",
  "Manufactured Home",
  "Mixed Use",
  "Mobile Home",
  "Multifamily Property",
  "Rentals",
  "Residential",
  "Residential Income",
  "Residential Lease",
  "Timeshare"
]);
var schMLSStatuses = z37.enum(["Active", "Pending", "Sold"]);
var schGeoListingsFilters = z37.object({
  propertyType: schMlsPropertyType.optional(),
  propertySubType: string,
  saleDate: dateRange,
  salePrice: priceRange,
  gla: areaRange,
  lotSize: areaRange,
  zipCode: schZipCode2,
  yearBuilt: numberRange,
  bedrooms: numberRange,
  fullBaths: numberRange,
  threeQuarterBaths: numberRange,
  halfBaths: numberRange,
  totalBaths: numberRange,
  stories: numberRange,
  garageSpaces: numberRange,
  hasBasement: boolean,
  hasPool: boolean.optional(),
  style: string,
  view: string,
  attached: boolean,
  statuses: z37.array(schMLSStatuses).optional()
});
var schRecommendedCompsFilters = z37.object({
  propertySubType: string,
  saleDate: clientDateRange,
  salePrice: clientPriceRange,
  gla: clientAreaRange,
  lotSize: clientAreaRange,
  yearBuilt: clientNumberRange,
  bedrooms: clientNumberRange,
  fullBaths: clientNumberRange,
  stories: clientNumberRange,
  garageSpaces: clientNumberRange,
  hasBasement: boolean,
  hasPool: boolean.optional(),
  status: string
});
var schMatchCriteria = z37.enum([
  "lasting_range",
  "min_max_range",
  "percentage_range",
  "value_range",
  "exact"
]);
var schListingsFiltersMatchCriteria = z37.object({
  saleDate: z37.enum([schMatchCriteria.enum.lasting_range, schMatchCriteria.enum.min_max_range]).optional(),
  salePrice: z37.enum([schMatchCriteria.enum.min_max_range, schMatchCriteria.enum.percentage_range]).optional(),
  gla: z37.enum([schMatchCriteria.enum.min_max_range, schMatchCriteria.enum.percentage_range]).optional(),
  lotSize: z37.enum([schMatchCriteria.enum.min_max_range, schMatchCriteria.enum.percentage_range]).optional(),
  yearBuilt: z37.enum([
    schMatchCriteria.enum.exact,
    schMatchCriteria.enum.min_max_range,
    schMatchCriteria.enum.value_range
  ]).optional(),
  bedrooms: z37.enum([
    schMatchCriteria.enum.exact,
    schMatchCriteria.enum.min_max_range,
    schMatchCriteria.enum.value_range
  ]).optional(),
  fullBaths: z37.enum([
    schMatchCriteria.enum.exact,
    schMatchCriteria.enum.min_max_range,
    schMatchCriteria.enum.value_range
  ]).optional(),
  stories: z37.enum([
    schMatchCriteria.enum.exact,
    schMatchCriteria.enum.min_max_range,
    schMatchCriteria.enum.value_range
  ]).optional(),
  garageSpaces: z37.enum([
    schMatchCriteria.enum.exact,
    schMatchCriteria.enum.min_max_range,
    schMatchCriteria.enum.value_range
  ]).optional()
});
var schCompsListingsSearchCriteria = z37.object({
  filters: schRecommendedCompsFilters,
  coordinates: z37.array(
    z37.object({
      longitude: z37.number(),
      latitude: z37.number()
    })
  ),
  radius: z37.number().optional(),
  matchCriteria: schListingsFiltersMatchCriteria.optional()
});
var schRecommendedCompsStatistics = z37.object({
  listingsSoldCount: z37.number().optional(),
  listingsActiveCount: z37.number().optional(),
  listingsPendingCount: z37.number().optional(),
  last3MonthsListingsCount: z37.number().optional(),
  last6MonthsListingsCount: z37.number().optional(),
  last12MonthsListingsCount: z37.number().optional()
});
var schListingsSearchCriteria = z37.object({
  filters: schGeoListingsFilters,
  coordinates: z37.array(
    z37.object({
      longitude: z37.number(),
      latitude: z37.number()
    })
  ),
  radius: z37.number().optional()
});
var schListingsResult = z37.object({
  resultsCount: z37.number(),
  results: z37.array(schConstellationOneListing),
  statistics: schRecommendedCompsStatistics.optional(),
  source: schListingSource,
  searchCriteria: schCompsListingsSearchCriteria.optional()
});
var schListingsById = schListingsResult.extend({
  missingListingIDs: z37.array(z37.string())
});
var schListingByAddress = schListingsResult;
var schGeoListings = schListingsResult.extend({
  totalResultsCount: z37.number(),
  nextToken: z37.string().optional()
});

// src/api/listings/api.ts
var LISTINGS_API = {
  POST: {
    REQUEST: {
      BODY: z38.object({
        mlsOUID: z38.string(),
        listingIDs: z38.array(z38.string())
      })
    },
    RESPONSE: schListingsById
  }
};
var LISTING_BY_ADDRESS_API = {
  POST: {
    REQUEST: {
      BODY: schAddress
    },
    RESPONSE: schListingByAddress
  }
};
var LISTINGS_RADIUS_API = {
  POST: {
    REQUEST: {
      BODY: z38.object({
        longitude: z38.number(),
        latitude: z38.number(),
        radiusInMeters: z38.number(),
        filters: schGeoListingsFilters.optional(),
        nextToken: z38.string().optional(),
        top: z38.number().optional()
      })
    },
    RESPONSE: schGeoListings
  }
};
var LISTINGS_POLYGON_API = {
  POST: {
    REQUEST: {
      BODY: z38.object({
        coordinates: z38.array(
          z38.object({
            longitude: z38.number(),
            latitude: z38.number()
          })
        ),
        filters: schGeoListingsFilters.optional(),
        nextToken: z38.string().optional(),
        top: z38.number().optional()
      })
    },
    RESPONSE: schGeoListings
  }
};

// src/api/v2/analytics/types.ts
import { AloftDate as AloftDate9, AloftPrice as AloftPrice10, AloftTime as AloftTime6 } from "@aloft/shared-objects";
import { z as z39 } from "zod";
var dimension = (x) => x.array().optional();
var schMarketTrendsSource = z39.enum(["zillow", "mls"]);
var schMarketTrendsGeoName = z39.enum(["zip", "city", "county"]);
var schMarketTrendsPeriodName = z39.enum(["default", "closemonth", "rolling3month"]);
var schMarketTrendsSeriesResult = z39.object({
  meta: z39.object({
    source: schMarketTrendsSource,
    geoname: schMarketTrendsGeoName,
    geo: z39.string(),
    periodname: schMarketTrendsPeriodName,
    updated: AloftTime6.schema.optional()
  }),
  data: z39.object({
    start: AloftDate9.schema.array(),
    // inclusive
    end: AloftDate9.schema.array(),
    // exclusive
    latestmodificationtimestamp: dimension(AloftTime6.schema),
    originatingsystemnames: dimension(schMLSID.array()),
    numcloses: dimension(z39.number()),
    avgcloseprice: dimension(AloftPrice10.schema.nullable()),
    p50closeprice: dimension(AloftPrice10.schema.nullable()),
    avgclosepriceoverlistprice: dimension(z39.number().nullable()),
    p50closepriceoverlistprice: dimension(z39.number().nullable()),
    avgclosepricepersqft: dimension(AloftPrice10.schema.nullable()),
    p50closepricepersqft: dimension(AloftPrice10.schema.nullable()),
    avgdaysonmarketclosed: dimension(z39.number().nullable()),
    p50daysonmarketclosed: dimension(z39.number().nullable()),
    avglistprice: dimension(AloftPrice10.schema.nullable()),
    p50listprice: dimension(AloftPrice10.schema.nullable())
  })
});

// src/api/v2/imageAnalysis/index.ts
import { z as z83 } from "zod";

// src/imageAnalysis/types.ts
import { z as z40 } from "zod";
var schImageAnalysisListing = z40.object({
  imageURLs: z40.string().array()
});
var schImageAnalysisQuery = z40.object({
  listings: schImageAnalysisListing.array()
});
var schImageAnalysisResultContent = z40.object({
  floor_structure_class: z40.number(),
  floor_structure_commentary: z40.string(),
  wall_framing_and_exterior_finish_class: z40.number(),
  wall_framing_and_exterior_finish_commentary: z40.string(),
  roof_class: z40.number(),
  roof_commentary: z40.string(),
  floor_finish_class: z40.number(),
  floor_finish_commentary: z40.string(),
  interior_wall_and_ceiling_finish_class: z40.number(),
  interior_wall_and_ceiling_finish_commentary: z40.string(),
  interior_detail_class: z40.number(),
  interior_detail_commentary: z40.string(),
  bath_detail_class: z40.number(),
  bath_detail_commentary: z40.string(),
  kitchen_detail_class: z40.number(),
  kitchen_detail_commentary: z40.string(),
  plumbing_detail_class: z40.number(),
  plumbing_detail_commentary: z40.string(),
  special_features_class: z40.number(),
  special_features_commentary: z40.string(),
  electrical_system_class: z40.number(),
  electrical_system_commentary: z40.string(),
  overall_class: z40.number(),
  overall_commentary: z40.string(),
  uad_condition_rating: z40.string(),
  uad_condition_commentary: z40.string(),
  has_barn: z40.boolean(),
  has_carport: z40.boolean(),
  has_basement: z40.boolean(),
  has_deck: z40.boolean(),
  has_covered_porch: z40.boolean(),
  has_enclosed_patio: z40.boolean(),
  has_accessory_dwelling_unit: z40.boolean(),
  has_pool: z40.boolean(),
  has_shed: z40.boolean(),
  has_workshop: z40.boolean(),
  has_fireplace: z40.boolean()
}).partial();

// src/tkv2OrderAttachments/schemas/index.ts
import { z as z82 } from "zod";

// src/depreciationSettingsV2/types.ts
import { z as z41 } from "zod";
var schDepreciationSettingsV2 = z41.object({
  depreciateSeparately: z41.boolean().optional(),
  enableFunctionalDepreciation: z41.boolean().optional(),
  enableExternalDepreciation: z41.boolean().optional(),
  defaultEcoLife: z41.number().int().optional(),
  defaultEcoLifeManufactured: z41.number().int().optional(),
  defaultEcoLifeGarage: z41.number().int().optional(),
  defaultEcoLifeDetachedGarage: z41.number().int().optional(),
  defaultEcoLifeCarport: z41.number().int().optional(),
  defaultEcoLifePorch: z41.number().int().optional(),
  defaultEcoLifePatio: z41.number().int().optional(),
  defaultEcoLifeDeck: z41.number().int().optional(),
  defaultEcoLifeWorkshop: z41.number().int().optional(),
  defaultEcoLifeShed: z41.number().int().optional(),
  defaultEcoLifeBarn: z41.number().int().optional(),
  defaultEcoLifePool: z41.number().int().optional(),
  defaultEcoLifeSpa: z41.number().int().optional(),
  defaultEcoLifeADU: z41.number().int().optional(),
  defaultEcoLifeManualCost: z41.number().int().optional(),
  defaultEcoLifeFireplace: z41.number().int().optional()
});
var schDepreciationSettingsV2JSON = z41.object({
  depreciateSeparately: z41.boolean().optional(),
  enableFunctionalDepreciation: z41.boolean().optional(),
  enableExternalDepreciation: z41.boolean().optional(),
  defaultEcoLife: z41.number().int().optional(),
  defaultEcoLifeManufactured: z41.number().int().optional(),
  defaultEcoLifeGarage: z41.number().int().optional(),
  defaultEcoLifeDetachedGarage: z41.number().int().optional(),
  defaultEcoLifeCarport: z41.number().int().optional(),
  defaultEcoLifePorch: z41.number().int().optional(),
  defaultEcoLifePatio: z41.number().int().optional(),
  defaultEcoLifeDeck: z41.number().int().optional(),
  defaultEcoLifeWorkshop: z41.number().int().optional(),
  defaultEcoLifeShed: z41.number().int().optional(),
  defaultEcoLifeBarn: z41.number().int().optional(),
  defaultEcoLifePool: z41.number().int().optional(),
  defaultEcoLifeSpa: z41.number().int().optional(),
  defaultEcoLifeADU: z41.number().int().optional(),
  defaultEcoLifeManualCost: z41.number().int().optional(),
  defaultEcoLifeFireplace: z41.number().int().optional()
});
var defaultEcoLifeFields = Object.keys(schDepreciationSettingsV2JSON.shape).filter(
  (key) => key.startsWith("defaultEcoLife")
);

// src/marketAdjustments/schemas.ts
import { schAloftPriceJSON as schAloftPriceJSON3, schAloftTimeJSON } from "@aloft/shared-objects";
import { z as z42 } from "zod";
var schAnalysisPeriod = z42.union([z42.literal(6), z42.literal(12), z42.literal(24)]);
var schZillowData = z42.object({
  zip: z42.string(),
  updated_date: z42.string(),
  monthly_trends: z42.object({
    historical_data: z42.array(
      z42.object({
        year: z42.number(),
        month: z42.number(),
        typicalHomeValue: schAloftPriceJSON3,
        numCloses: z42.number().optional(),
        sourceMLSes: schMLSID.array().optional(),
        medianListPrice: schAloftPriceJSON3.optional(),
        medianClosePriceOverListPrice: z42.number().optional(),
        medianDaysOnMarket: z42.number().optional()
      })
    ),
    one_month_projection: schAloftPriceJSON3.optional()
  })
});
var schZillowState = z42.object({
  zip: z42.string(),
  analysisPeriod: schAnalysisPeriod,
  trends: z42.array(
    z42.object({
      data: schZillowData,
      timestamp: schAloftTimeJSON
    })
  )
});
var schCustomMonthlyRateState = z42.object({
  rate: z42.number()
});
var schCustomMonthlyPriceTrend = z42.object({
  month: schIsoMonth,
  value: schAloftPriceJSON3
});
var schCustomMonthlyPriceState = z42.object({
  type: z42.enum(["typicalHomeValue"]),
  analysisPeriod: schAnalysisPeriod,
  trendsAsPercentages: z42.boolean().optional().default(false),
  trends: z42.array(schCustomMonthlyPriceTrend)
});
var schDateOfSaleMethod = z42.enum([
  "none",
  "zillow",
  "customMonthlyRate",
  "customMonthlyPrice"
]);
function isDateOfSaleMethod(x) {
  return schDateOfSaleMethod.safeParse(x).success;
}
var schDateOfSaleCachedForm = z42.object({
  selectedMethod: schDateOfSaleMethod,
  methodState: z42.object({
    zillow: schZillowState.optional(),
    customMonthlyRate: schCustomMonthlyRateState,
    customMonthlyPrice: schCustomMonthlyPriceState
  })
});
var schCustomRatioState = z42.object({
  ratio: z42.number()
});
var schListToSaleMethod = z42.enum(["none", "customRatio"]);
function isListToSaleMethod(x) {
  return schListToSaleMethod.safeParse(x).success;
}
var schListToSaleCachedForm = z42.object({
  selectedMethod: schListToSaleMethod,
  methodState: z42.object({
    customRatio: schCustomRatioState
  }).partial()
});
var schMarketAdjustments = z42.object({
  version: z42.literal(1),
  /** The cached Date of Sale and List to Sale form data */
  cachedForms: z42.object({
    dateOfSale: schDateOfSaleCachedForm,
    listToSale: schListToSaleCachedForm
  }),
  commentary: z42.string().optional()
});

// src/propertydata/PropertyData.ts
import { z as z54 } from "zod";

// src/propertydata/editablePropertyData.ts
import { schAloftPriceJSON as schAloftPriceJSON6 } from "@aloft/shared-objects";
import { z as z51 } from "zod";

// src/propertydata/arv.ts
import { z as z48 } from "zod";

// src/propertydata/improvements.ts
import { schAloftAreaJSON as schAloftAreaJSON2, schAloftPriceJSON as schAloftPriceJSON4 } from "@aloft/shared-objects";
import { z as z47 } from "zod";

// src/autofill/defaults.ts
import { AloftArea as AloftArea11 } from "@aloft/shared-objects";

// src/propertydata/sourceType.ts
import { z as z43 } from "zod";
var mlsSource = ["abode_mls"];
var schMLSSource = z43.enum(mlsSource);
var publicRecordSource = ["abode_public_record"];
var schPublicRecordSource = z43.enum(publicRecordSource);
var otherSource = ["zillow", "xml", "custom", "none", "radar"];
var schOtherSource = z43.enum(otherSource);
var sources = [...mlsSource, ...publicRecordSource, ...otherSource];
var schSourceType = z43.enum(sources);

// src/autofill/defaults.ts
var DEFAULT_CORNERS = 6;
var DEFAULT_EFFECTIVE_AGE = 0;
var DEFAULT_CRAFTSMAN_QUALITY = 4;
var DEFAULT_CRAFTSMAN_QUALITY_MFR = 3;
var DEFAULT_CRAFTSMAN_QUALITY_MANUFACTURED = 3;
var DEFAULT_ADU_SIZE_SQFT = AloftArea11.fromNumber(500, "sqft");
var DEFAULT_ADU_QUALITY = 2;
var DEFAULT_ADU_FULL_BATHS = 0;
var DEFAULT_ADU_HALF_BATHS = 0;
var DEFAULT_ATTIC_QUALITY = 4;
var DEFAULT_ATTIC_QUALITY_MANUFACTURED = 5;
var DEFAULT_ATTIC_SIZE_SQFT = AloftArea11.fromNumber(500, "sqft");
var DEFAULT_BARN_SIZE_SQFT = AloftArea11.fromNumber(1e3, "sqft");
var DEFAULT_BARN_QUALITY = 2;
var DEFAULT_BASEMENT_TOTAL_SIZE_SQFT = AloftArea11.fromNumber(0, "sqft");
var DEFAULT_BASEMENT_FINISHED_SIZE_SQFT = AloftArea11.fromNumber(0, "sqft");
var DEFAULT_BASEMENT_FULL_BATHS = 0;
var DEFAULT_BASEMENT_HALF_BATHS = 0;
var DEFAULT_SPACE_SIZE_SQFT = AloftArea11.fromNumber(220, "sqft");
var DEFAULT_PARKING_QUALITY = 4;
var DEFAULT_PARKING_QUALITY_MANUFACTURED = 5;
var DEFAULT_CARPORT_SPACES = 2;
var DEFAULT_CARPORT_SIZE_SQFT = DEFAULT_SPACE_SIZE_SQFT.mul(DEFAULT_CARPORT_SPACES);
var DEFAULT_PORCH_PATIO_DECK_QUALITY = 4;
var DEFAULT_DECK_TYPE = "uncovered";
var DEFAULT_DECK_SIZE_SQFT = AloftArea11.fromNumber(200, "sqft");
var DEFAULT_FIREPLACE_TYPE = "masonry";
var DEFAULT_FIREPLACE_COUNT = 1;
var DEFAULT_GARAGE_SPACES = 2;
var DEFAULT_GARAGE_SIZE_SQFT = DEFAULT_SPACE_SIZE_SQFT.mul(DEFAULT_GARAGE_SPACES);
var DEFAULT_PATIO_TYPE = "uncovered";
var DEFAULT_PATIO_SIZE_SQFT = AloftArea11.fromNumber(200, "sqft");
var DEFAULT_POOL_AREA_SIZE_SQFT = AloftArea11.fromNumber(500, "sqft");
var DEFAULT_POOL_QUALITY = 3;
var DEFAULT_PORCH_TYPE = "uncovered";
var DEFAULT_PORCH_SIZE_SQFT = AloftArea11.fromNumber(200, "sqft");
var DEFAULT_SHED_SIZE_SQFT = AloftArea11.fromNumber(200, "sqft");
var DEFAULT_SHED_QUALITY = 2;
var DEFAULT_SPA_SIZE_SQFT = AloftArea11.fromNumber(64, "sqft");
var DEFAULT_SPA_QUALITY = 3;
var DEFAULT_WORKSHOP_SIZE_SQFT = AloftArea11.fromNumber(200, "sqft");
var DEFAULT_WORKSHOP_QUALITY = 2;
var DEFAULT_ECONOMIC_LIFE = 60;
var DEFAULT_ECONOMIC_LIFE_MANUFACTURED = 55;
var DEFAULT_MLS_SOURCE = schMLSSource.enum.abode_mls;
var DEFAULT_PUBLIC_RECORD_SOURCE = schPublicRecordSource.enum.abode_public_record;

// src/propertydata/features.ts
import { schAloftAreaJSON } from "@aloft/shared-objects";
import { z as z46 } from "zod";

// src/propertydata/propertyTypes.ts
import { z as z45 } from "zod";

// src/tkv2Property/types.ts
import { z as z44 } from "zod";
var schPropertyTypes = z44.enum([
  "singleFamilyResidence",
  "condominium",
  "duplex",
  "triplex",
  "quadruplex",
  "manufacturedHome",
  "mobileHome",
  "multiFamily",
  "townhouse",
  "apartments",
  "lotsLand"
]);
var schUad2022Annotations = z44.object({
  PropertyStreetAddress: z44.string(),
  PropertyCity: z44.string(),
  PropertyState: z44.string(),
  PropertyPostalCode: z44.string(),
  LatitudeNumber: z44.string(),
  LongitudeNumber: z44.string(),
  DataSourceDescription: z44.string(),
  DataSourceVerificationDescription: z44.string(),
  PropertySalesAmount: z44.string(),
  /** @deprecated - use SalesConcessions instead */
  SaleType: z44.string(),
  SalesConcessions: z44.string(),
  FinancingConcessions: z44.string(),
  DateOfSale: z44.string(),
  Location: z44.string(),
  PropertyRights: z44.string(),
  SiteArea: z44.string(),
  View: z44.string(),
  DesignStyle: z44.string(),
  Quality: z44.string(),
  Age: z44.string(),
  Condition: z44.string(),
  TotalRoomCount: z44.string(),
  TotalBedroomCount: z44.string(),
  TotalBathroomCount: z44.string(),
  BelowGradeRoomCount: z44.string(),
  GrossLivingArea: z44.string(),
  NumberOfUnits: z44.string(),
  BasementArea: z44.string(),
  BasementFinish: z44.string(),
  FunctionalUtility: z44.string(),
  HeatingCooling: z44.string(),
  EnergyEfficient: z44.string(),
  CarStorage: z44.string(),
  PorchDeck: z44.string(),
  OtherFeature1: z44.string(),
  OtherFeature2: z44.string(),
  OtherFeature3: z44.string()
}).partial();
var schUad2022Adjustments = z44.object({
  SalesConcessions: schAloftPrice,
  FinancingConcessions: schAloftPrice,
  DateOfSale: schAloftPrice,
  Location: schAloftPrice,
  PropertyRights: schAloftPrice,
  SiteArea: schAloftPrice,
  View: schAloftPrice,
  DesignStyle: schAloftPrice,
  Quality: schAloftPrice,
  Age: schAloftPrice,
  Condition: schAloftPrice,
  RoomAboveGradeLine1: schAloftPrice,
  RoomAboveGradeLine2: schAloftPrice,
  GrossLivingArea: schAloftPrice,
  NumberOfUnits: schAloftPrice,
  BasementArea: schAloftPrice,
  BasementFinish: schAloftPrice,
  FunctionalUtility: schAloftPrice,
  HeatingCooling: schAloftPrice,
  EnergyEfficient: schAloftPrice,
  CarStorage: schAloftPrice,
  PorchDeck: schAloftPrice,
  OtherFeature1: schAloftPrice,
  OtherFeature2: schAloftPrice,
  OtherFeature3: schAloftPrice
}).partial();
var schSalesCompGridData = z44.object({
  encoding: z44.literal("UAD_2022"),
  annotations: schUad2022Annotations,
  adjustments: schUad2022Adjustments.optional()
});
var schSalesCompGridEncoding = z44.literal("UAD_2022");
var schTkv2Version = z44.literal(1);
var schStructuredProperty = z44.strictObject({
  toolkitListingID: schToolkitListingID2,
  address: schAddress,
  latitude: z44.number(),
  longitude: z44.number(),
  dataSource: schDataSource,
  designStyle: schDesignStyle,
  carStorage: schCarStorage,
  status: schComparableStatus,
  siteArea: schAloftArea,
  actualAge: schActualAge,
  gla: schAloftArea,
  numberOfUnits: schPositiveInt,
  bedroomCount: schPositiveInt,
  bathroomCount: schBathroomCount,
  basementLine1: schBasementLine1,
  basementLine2: schBasementLine2,
  salePrice: schAloftPrice
}).partial();
var schStructuredPropertyFields = Object.keys(schStructuredProperty.shape);
var schBathroomCosts = z44.object({
  fullBathCost: schAloftPrice.optional(),
  halfBathCost: schAloftPrice.optional()
});

// src/propertydata/propertyTypes.ts
var mainPropertyTypeList = [
  schPropertyTypes.Values.singleFamilyResidence,
  schPropertyTypes.Values.manufacturedHome,
  schPropertyTypes.Values.multiFamily
];
var schMainPropertyType = z45.enum(mainPropertyTypeList);
var recommendedCompsPropertyTypesList = [
  schPropertyTypes.Values.singleFamilyResidence,
  schPropertyTypes.Values.manufacturedHome,
  schPropertyTypes.Values.multiFamily,
  schPropertyTypes.Values.condominium,
  schPropertyTypes.Values.townhouse,
  schPropertyTypes.Values.lotsLand
];
var schRecommendedCompsPropertyTypes = z45.enum(recommendedCompsPropertyTypesList);
function formatPropertyType(propertyType) {
  switch (propertyType) {
    case "singleFamilyResidence":
      return "Single Family Residence";
    case "multiFamily":
      return "Multi-Family";
    case "manufacturedHome":
      return "Manufactured Home";
    case "condominium":
      return "Condominium";
    case "townhouse":
      return "Townhouse";
    case "duplex":
      return "Duplex";
    case "triplex":
      return "Triplex";
    case "quadruplex":
      return "Quadruplex";
    case "mobileHome":
      return "Mobile Home";
    default:
      return "Unknown";
  }
}
function formatShortenedPropertyType(propertyType) {
  switch (propertyType) {
    case "singleFamilyResidence":
      return "SFR";
    case "multiFamily":
      return "MFR";
    case "manufacturedHome":
      return "MH";
    case "condominium":
      return "Condo";
    case "townhouse":
      return "TH";
    case "duplex":
      return "Duplex";
    case "triplex":
      return "Triplex";
    case "quadruplex":
      return "Quadruplex";
    case "mobileHome":
      return "Mobile Home";
    default:
      return void 0;
  }
}

// src/propertydata/features.ts
var additionalFeatureTypeList = [
  "basement",
  "garage",
  "attic",
  "shed",
  "workshop",
  "barn",
  "pool",
  "spa",
  "fireplaces",
  "adu"
];
var schAdditionalFeatureType = z46.enum([
  ...mainPropertyTypeList,
  ...additionalFeatureTypeList
]);
var schCorners = z46.union([z46.literal(4), z46.literal(6), z46.literal(8), z46.literal(10)]);
var schHeatingAndCoolingType = z46.enum(["none", "heating", "both"]).default("none");
var schThreeTierQualityScale = z46.number().min(1).max(3);
var schThreeTierQuality = schThreeTierQualityScale.int();
var schFiveTierQualityScale = z46.number().min(1).max(5);
var schFiveTierQuality = schFiveTierQualityScale.int();
var schSixTierQualityScale = z46.number().min(1).max(6);
var schSixTierQuality = schSixTierQualityScale.int();
var schCraftsmanSFRQualityClasses = schSixTierQualityScale.multipleOf(0.1);
var schSingleFamilyCraftsmanQuality = schSixTierQualityScale.multipleOf(0.1);
var schManufacturedCraftsmanQuality = schSixTierQualityScale.multipleOf(0.1);
var schMultiFamilyCraftsmanQuality = schSixTierQualityScale.multipleOf(0.1);
var schCraftsmanQuality = z46.union([
  schSingleFamilyCraftsmanQuality,
  schManufacturedCraftsmanQuality,
  schMultiFamilyCraftsmanQuality
]);
var schBasementFields = z46.object({
  hasFeature: z46.boolean().default(true),
  finishedArea: schAloftAreaJSON.optional(),
  totalArea: schAloftAreaJSON.optional(),
  fullBaths: schPositiveInt.optional(),
  halfBaths: schPositiveInt.optional()
});
var schParkingFields = z46.object({
  hasFeature: z46.boolean().default(true),
  area: schAloftAreaJSON.optional(),
  spaces: schPositiveInt.optional(),
  quality: schSixTierQuality.optional()
});
var schGarageTypes = z46.enum(["attached", "detached"]);
var schGarage = schParkingFields.extend({
  type: schGarageTypes.optional()
});
var schHasFeatureAreaAndQuality = z46.object({
  hasFeature: z46.boolean().default(true),
  area: schAloftAreaJSON.optional(),
  quality: schThreeTierQuality.optional()
});
var schHasFeatureAndArea = z46.object({
  hasFeature: z46.boolean().default(true),
  area: schAloftAreaJSON.optional()
});
var schAttic = schHasFeatureAndArea.extend({
  quality: schSixTierQuality.optional()
});
var schPorchPatioDeckSubtypes = z46.enum(["uncovered", "covered", "screen"]);
var schPorchPatioDeck = z46.object({
  hasFeature: z46.boolean().default(true),
  type: schPorchPatioDeckSubtypes.default("uncovered").optional(),
  area: schAloftAreaJSON.optional(),
  quality: schSixTierQuality.optional()
});
var schFireplaceTypes = z46.enum(["freestanding", "zeroClearance", "masonry"]);
var schFireplace = z46.object({
  hasFeature: z46.boolean().default(true),
  count: schPositiveInt.optional(),
  type: schFireplaceTypes.optional()
});
var schAdu = z46.object({
  hasFeature: z46.boolean().default(true),
  area: schAloftAreaJSON.optional(),
  halfBaths: schPositiveInt.optional(),
  fullBaths: schPositiveInt.optional(),
  quality: schSingleFamilyCraftsmanQuality.optional()
});

// src/propertydata/improvements.ts
var schImprovementFeatures = z47.object({
  corners: schCorners.default(DEFAULT_CORNERS),
  gla: schAloftAreaJSON2,
  bedrooms: schPositiveInt,
  fullBaths: schPositiveInt,
  halfBaths: schPositiveInt,
  heatingAndCooling: schHeatingAndCoolingType,
  effectiveAge: schPositiveInt,
  age: schPositiveInt,
  uadQuality: schSixTierQuality,
  uadCondition: schSixTierQuality,
  basement: schBasementFields,
  attic: schAttic,
  fireplace: schFireplace,
  // Garage's "type" field is left unchanged for backwards compatibility, but "garage" is now always attached
  garage: schGarage,
  detachedGarage: schGarage.extend({
    type: z47.literal("detached").optional().default("detached")
  }),
  carport: schParkingFields,
  shed: schHasFeatureAreaAndQuality,
  workshop: schHasFeatureAreaAndQuality,
  barn: schHasFeatureAreaAndQuality,
  pool: schHasFeatureAreaAndQuality,
  spa: schHasFeatureAreaAndQuality,
  adu: schAdu,
  porch: schPorchPatioDeck,
  patio: schPorchPatioDeck,
  deck: schPorchPatioDeck,
  coveredPorch: schHasFeatureAndArea,
  enclosedPatio: schHasFeatureAndArea,
  hasManualCost: z47.boolean().default(false),
  manualCost: schAloftPriceJSON4,
  manualCostDisplayName: z47.string(),
  featureGridDataSources: z47.string(),
  totalEconomicLife: schPositiveInt,
  externalDepreciation: schAloftPriceJSON4,
  functionalDepreciation: schAloftPriceJSON4,
  garageEffAge: schPositiveInt,
  garageEcoLife: schPositiveInt,
  detachedGarageEffAge: schPositiveInt,
  detachedGarageEcoLife: schPositiveInt,
  carportEffAge: schPositiveInt,
  carportEcoLife: schPositiveInt,
  porchEffAge: schPositiveInt,
  porchEcoLife: schPositiveInt,
  patioEffAge: schPositiveInt,
  patioEcoLife: schPositiveInt,
  deckEffAge: schPositiveInt,
  deckEcoLife: schPositiveInt,
  workshopEffAge: schPositiveInt,
  workshopEcoLife: schPositiveInt,
  shedEffAge: schPositiveInt,
  shedEcoLife: schPositiveInt,
  barnEffAge: schPositiveInt,
  barnEcoLife: schPositiveInt,
  poolEffAge: schPositiveInt,
  poolEcoLife: schPositiveInt,
  spaEffAge: schPositiveInt,
  spaEcoLife: schPositiveInt,
  aduEffAge: schPositiveInt,
  aduEcoLife: schPositiveInt,
  manualCostEffAge: schPositiveInt,
  manualCostEcoLife: schPositiveInt,
  fireplaceEffAge: schPositiveInt,
  fireplaceEcoLife: schPositiveInt
}).partial();
var schSingleFamilyResidenceFeatures = schImprovementFeatures.extend({
  propertyType: z47.literal(schMainPropertyType.Values.singleFamilyResidence),
  craftsmanQuality: schSingleFamilyCraftsmanQuality.optional()
});
var schManufacturedHomeFoundation = z47.enum(["pierAndBeam", "slab"]);
var schManufacturedHomeFoundationDisplay = z47.enum(["Pier and Beam", "Slab"]);
var schManufacturedHomeFeatures = schImprovementFeatures.extend({
  propertyType: z47.literal(schMainPropertyType.Values.manufacturedHome),
  foundation: schManufacturedHomeFoundation.optional(),
  craftsmanQuality: schManufacturedCraftsmanQuality.optional()
});
var schMultiFamilyFeatures = schImprovementFeatures.extend({
  propertyType: z47.literal(schMainPropertyType.Values.multiFamily),
  numberOfUnits: schPositiveInt.optional(),
  craftsmanQuality: schMultiFamilyCraftsmanQuality.optional()
});
var schImprovements = z47.union([
  schSingleFamilyResidenceFeatures,
  schManufacturedHomeFeatures,
  schMultiFamilyFeatures
]);

// src/propertydata/arv.ts
var schEditableArvSubjectData = z48.object({
  improvements: schImprovements
});

// src/propertydata/manualAdjustments.ts
import { schAloftPriceJSON as schAloftPriceJSON5 } from "@aloft/shared-objects";
import { z as z49 } from "zod";
var manualAdjustmentKeys = [
  "adu",
  "attic",
  "barn",
  "basement",
  "bathAboveGrade",
  "bathBelowGrade",
  "bedrooms",
  "concessions",
  "condition",
  "dateOfSale",
  "externalObsolescence",
  // TODO: Remove?
  "fireplace",
  "functionalUtility",
  // TODO: Remove?
  "gla",
  // TODO: Rename to mainDwelling so there's no 2 "GLA" options in the UI?
  "garageCarport",
  "manual",
  // TODO: Rename to manualCost
  "poolSpa",
  "porchPatioDeck",
  "quality",
  "shed",
  "site",
  "termsOfSale",
  "units",
  // TODO: Rename to numberOfUnits
  "workshop"
];
var schManualAdjustmentsKey = z49.enum(manualAdjustmentKeys);
var schManualAdjustments = z49.object(
  Object.fromEntries(manualAdjustmentKeys.map((key) => [key, schAloftPriceJSON5]))
).partial();

// src/propertydata/site.ts
import { schAloftAreaJSON as schAloftAreaJSON3 } from "@aloft/shared-objects";
import { z as z50 } from "zod";
var schSiteInfluence = z50.enum([
  "agricultural",
  "airport",
  "bodyOfWater",
  "busyRoadway",
  "commercialArea",
  "golfCourse",
  "greenSpace",
  "highDensityResidential",
  "highPressureGasLine",
  "historicDistrict",
  "industrialArea",
  "localDistributionLine",
  "oilOrGasWell",
  "overheadPowerLine",
  "park",
  "publicTransportationHub",
  "railLine",
  "residential",
  "school",
  "stormwaterRetention"
]);
var schSiteView = z50.enum([
  "bay",
  "canal",
  "cityStreet",
  "commercial",
  "cove",
  "creek",
  "golfCourse",
  "gulf",
  "highDensityResidential",
  "highway",
  "industrial",
  "lake",
  "marsh",
  "mountain",
  "ocean",
  "park",
  "parkingLot",
  "pastoral",
  "pond",
  "reservoir",
  "residential",
  "river",
  "school",
  "skyline",
  "sound",
  "trafficWallBarriers",
  "valley",
  "woods"
]);
var schSiteRating = z50.enum(["Beneficial", "Neutral", "Adverse"]);
var schSite = z50.object({
  area: schAloftAreaJSON3,
  influence: z50.string(),
  influenceRating: schSiteRating,
  location: z50.string(),
  notes: z50.string(),
  view: z50.string(),
  viewRating: schSiteRating,
  zoning: z50.string()
}).partial();

// src/propertydata/editablePropertyData.ts
var schSharedEditablePropertyData = z51.object({
  transaction: schTransaction,
  propertyIdentification: schPropertyIdentification,
  improvements: schImprovements,
  site: schSite
});
var schEditablePropertyData = schSharedEditablePropertyData.extend({
  manualAdjustments: schManualAdjustments
});
var schEditableSubjectData = schSharedEditablePropertyData.extend({
  opinionOfSiteValue: schAloftPriceJSON6.optional(),
  siteValueCommentary: z51.string().optional(),
  arv: schEditableArvSubjectData.optional()
});

// src/propertydata/readOnlyData.ts
import { z as z52 } from "zod";
var schBackupListingData = z52.object({
  version: z52.literal(1),
  listing: schRESOListing
});
var schReadOnlyData = z52.object({
  backupListingData: schBackupListingData
}).partial();

// src/propertydata/selectedSources.ts
import { z as z53 } from "zod";
var schSelectedSource = z53.object({
  source: schSourceType,
  justification: z53.string().optional(),
  conflictIsResolved: z53.boolean().optional()
});
var createSelectedSourceSchema = (obj) => {
  const shape = {};
  Object.keys(obj.shape).forEach((key) => {
    shape[key] = schSelectedSource.optional();
  });
  return z53.object(shape);
};
var schTransactionSelectedSources = createSelectedSourceSchema(schTransaction).partial();
var schFilledAddressSelectedSources = createSelectedSourceSchema(schFilledAddress).partial();
var schLatitudeLongitudeSelectedSources = createSelectedSourceSchema(schLatitudeLongitude).partial();
var schPropertyIdentificationSelectedSources = z53.object({
  address: schFilledAddressSelectedSources,
  coordinates: schLatitudeLongitudeSelectedSources,
  zoning: schSelectedSource,
  zoningCompliance: schSelectedSource,
  legalDescription: schSelectedSource,
  hoa: schSelectedSource,
  hoaFeeAmount: schSelectedSource,
  hoaFeeFrequency: schSelectedSource,
  parcelNumber: schSelectedSource,
  pud: schSelectedSource
}).partial();
var schHasFeatureAreaAndQualitySelectedSources = createSelectedSourceSchema(
  schHasFeatureAreaAndQuality
).partial();
var schAduSelectedSources = createSelectedSourceSchema(schAdu).partial();
var schAtticSelectedSources = createSelectedSourceSchema(schAttic).partial();
var schBasementFieldsSelectedSources = createSelectedSourceSchema(schBasementFields).partial();
var schFireplaceSelectedSources = createSelectedSourceSchema(schFireplace).partial();
var schParkingFieldsSelectedSources = createSelectedSourceSchema(schParkingFields).partial();
var schGarageSelectedSources = createSelectedSourceSchema(schGarage).partial();
var schPorchPatioDeckSelectedSources = createSelectedSourceSchema(schPorchPatioDeck).partial();
var schAutogeneratedImprovementsSelectedSources = createSelectedSourceSchema(schImprovementFeatures).partial();
var schImprovementsSelectedSources = z53.object({
  ...schAutogeneratedImprovementsSelectedSources.shape,
  adu: schAduSelectedSources,
  attic: schAtticSelectedSources,
  barn: schHasFeatureAreaAndQualitySelectedSources,
  basement: schBasementFieldsSelectedSources,
  carport: schParkingFieldsSelectedSources,
  deck: schPorchPatioDeckSelectedSources,
  fireplace: schFireplaceSelectedSources,
  garage: schGarageSelectedSources,
  detachedGarage: schGarageSelectedSources,
  patio: schPorchPatioDeckSelectedSources,
  pool: schHasFeatureAreaAndQualitySelectedSources,
  porch: schPorchPatioDeckSelectedSources,
  shed: schHasFeatureAreaAndQualitySelectedSources,
  spa: schHasFeatureAreaAndQualitySelectedSources,
  workshop: schHasFeatureAreaAndQualitySelectedSources,
  craftsmanQuality: schSelectedSource,
  foundation: schSelectedSource,
  numberOfUnits: schSelectedSource,
  propertyType: schSelectedSource
}).partial();
var schSiteSelectedSources = createSelectedSourceSchema(schSite).partial();
var schManualAdjustmentsSelectedSources = createSelectedSourceSchema(schManualAdjustments).partial();
var schEditableArvDataSelectedSources = z53.object({
  improvements: schImprovementsSelectedSources
}).partial();
var _schEditableDataSelectedSources = z53.object({
  transaction: schTransactionSelectedSources,
  propertyIdentification: schPropertyIdentificationSelectedSources,
  improvements: schImprovementsSelectedSources,
  site: schSiteSelectedSources,
  manualAdjustments: schManualAdjustmentsSelectedSources,
  arv: schEditableArvDataSelectedSources
}).partial();
var schEditableDataSelectedSources = zodLaunder(
  _schEditableDataSelectedSources
);
var schRESOListingSelectedSources = createSelectedSourceSchema(schRESOListing).partial();
var schBackupListingSelectedSources = z53.object({
  listing: schRESOListingSelectedSources
}).partial();
var schReadonlyDataSelectedSources = z53.object({
  backupListingData: schBackupListingSelectedSources
}).partial();
var _schSelectedSources = z53.object({
  editableData: schEditableDataSelectedSources,
  readonlyData: schReadonlyDataSelectedSources
}).partial();
var schSelectedSources = zodLaunder(_schSelectedSources);

// src/propertydata/PropertyData.ts
var schBasePropertyData = z54.object({
  $type: z54.literal("PropertyData"),
  version: z54.literal(1),
  readonlyData: schReadOnlyData,
  selectedSources: schSelectedSources.optional()
});
var schCompType = z54.enum(["arv", "aiv"]);
var _schPropertyData = schBasePropertyData.extend({
  editableData: schEditablePropertyData,
  compType: schCompType.optional()
});
var schPropertyDataWithOptionalReadonly = _schPropertyData.extend({
  readonlyData: schReadOnlyData.optional()
});
var schPropertyData = zodLaunder(_schPropertyData);
var _schSubjectData = schBasePropertyData.extend({
  editableData: schEditableSubjectData
});
var schSubjectData = zodLaunder(_schSubjectData);

// src/tkv2DepreciationAndSite/types.ts
import { z as z56 } from "zod";

// src/costData/schemas.ts
import { z as z55 } from "zod";
var schCDDwelling = z55.object({
  bedrooms: schAloftCount.optional(),
  bathroomsFull: schAloftCount,
  bathroomsHalf: schAloftCount,
  stories: z55.number(),
  gla: schAloftArea,
  quality: schToolkitPropertyEnum,
  nonStandardGLA: schAloftArea.optional(),
  multiUnitCount: schPositiveInt.optional()
});
var schCDPrimaryDwelling = schCDDwelling.partial();
var schEditableCDPrimaryDwelling = schCDPrimaryDwelling.pick({
  quality: true,
  nonStandardGLA: true,
  multiUnitCount: true
});
var schCDBasement = z55.strictObject({
  totalSqft: schAloftArea,
  finishedSqft: schAloftArea,
  access: z55.string(),
  quality: schToolkitPropertyEnum
}).partial();
var schEditableCDBasement = schCDBasement.pick({ quality: true });
var schEditableManualCost = z55.strictObject({
  label: z55.string(),
  feature: z55.string(),
  cost: schAloftPrice
}).partial();
var schCDAttic = z55.object({
  totalSqft: schAloftArea,
  quality: schToolkitPropertyEnum
}).partial();
var schBasicStructure = z55.object({
  totalSqft: schAloftArea,
  quality: schToolkitPropertyEnum
});
var schComplexStructure = z55.object({
  totalSqft: schAloftArea,
  percentInteriorFinished: z55.number(),
  electrical: z55.boolean(),
  subpanel: z55.boolean(),
  plumbingFixturesCount: schAloftCount,
  quality: schToolkitPropertyEnum
});
var schCDAttachedBuiltinGarage = schBasicStructure.extend({ attachedSpaceCount: schAloftCount, builtinSpaceCount: schAloftCount }).partial();
var schCDDetachedGarage = schBasicStructure.extend({ spaceCount: schAloftCount }).partial();
var schCDCarport = schBasicStructure.extend({ spaceCount: schAloftCount }).partial();
var schDeck = schBasicStructure.partial();
var schCoveredPatioOrGazebo = schBasicStructure.partial();
var schCDEnclosedPatio = schBasicStructure.extend({ linearFootage: schAloftCount }).partial();
var schCDPool = z55.strictObject({
  totalSqft: schAloftArea,
  quality: schToolkitPropertyEnum
}).partial();
var schCDAdu = schCDDwelling.pick({
  bathroomsFull: true,
  bathroomsHalf: true,
  stories: true,
  gla: true,
  quality: true
}).partial();
var schCDShed = schComplexStructure.partial();
var schCDWorkshop = schComplexStructure.partial();
var schCDBonusRoom = schComplexStructure.partial();
var schCDBarn = schComplexStructure.extend({
  isPoleBarn: z55.boolean(),
  hasExteriorWall: z55.boolean()
}).partial();
var schCDManufactured = z55.strictObject({
  sections: schAloftCount,
  gla: schAloftArea,
  bathroomsFull: schAloftCount,
  bathroomsHalf: schAloftCount,
  quality: schToolkitPropertyEnum,
  hasAC: z55.boolean(),
  hasClimatePkg: z55.boolean(),
  foundationType: z55.string(),
  fireplaces: schAloftCount,
  fireplaceType: schToolkitPropertyEnum,
  deliveryMileage: schAloftCount
}).partial();
var schStructureInput = z55.object({
  // FIXME: Rename this field to "siteBuiltDwelling"
  /**
   * Primary dwelling is a misnomer. This field actually corresponds to DC's
   * concept of "site-built dwelling". For manufactured properties, the
   * "primary" dwelling would be a manufactured dwelling
   */
  primaryDwelling: schCDPrimaryDwelling,
  basement: schCDBasement,
  attic: schCDAttic,
  attachedOrBuiltinGarage: schCDAttachedBuiltinGarage,
  detachedGarage: schCDDetachedGarage,
  carport: schCDCarport,
  deck: schDeck,
  coveredPatioOrGazebo: schCoveredPatioOrGazebo,
  enclosedPatio: schCDEnclosedPatio,
  pool: schCDPool,
  adu: schCDAdu,
  shed: schCDShed,
  workshop: schCDWorkshop,
  bonusRoom: schCDBonusRoom,
  barn: schCDBarn,
  manufactured: schCDManufactured
});
var schStructureType = schStructureInput.keyof();
var schDepreciationField = z55.object({
  lumpSum: schAloftPrice.optional(),
  percent: z55.number().int().gte(0).lte(100).optional(),
  effectiveAge: z55.number().optional(),
  ecoLifeYears: z55.number().optional()
});
var schDepreciation = z55.object({
  physicalDepreciation: z55.record(schStructureType, schDepreciationField),
  functionalObsolescence: schDepreciationField,
  externalDepreciation: schDepreciationField
});
var schCostDataInput = schStructureInput.extend({
  address: z55.string(),
  effectiveDate: schAloftDate,
  zip: z55.string(),
  // Not included in DwellingCost request
  depreciation: schDepreciation,
  manualCost: schEditableManualCost.optional()
});
var schDepreciationV1 = z55.object({
  effectiveAge: z55.number().optional(),
  ecoLifeYears: z55.number().optional(),
  functionalObsolescencePercent: z55.number().int().gte(0).lte(100).optional(),
  externalDepreciationPercent: z55.number().int().gte(0).lte(100).optional()
});
var schEditableCostDataInputV1 = schCostDataInput.extend({
  depreciation: schDepreciationV1,
  primaryDwelling: schEditableCDPrimaryDwelling,
  basement: schEditableCDBasement,
  manualCost: schEditableManualCost.optional()
});
var schEditableCostDataInputV2 = schCostDataInput.omit({ address: true, effectiveDate: true, zip: true }).extend({
  primaryDwelling: schEditableCDPrimaryDwelling,
  basement: schEditableCDBasement,
  manualCost: schEditableManualCost.optional()
});
var schDwellingCostInput = schCostDataInput.omit({ depreciation: true });
var schStructureCostData = z55.record(
  schStructureType,
  z55.object({ cost: schAloftPrice }).or(z55.undefined())
);
var schCostDataOutput = z55.record(
  schStructureType,
  z55.object({ costPerSqft: schAloftPrice }).or(z55.undefined())
);
var schPropertyCostDataDocument = z55.object({
  // used for making a cost data request (to DwellingCost)
  editableInput: schEditableCostDataInputV1,
  // Not included in DwellingCost response. Manually entered by appraiser.
  additionalFeaturesCost: schAloftPrice.optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: schAloftPrice.optional()
});
var schCostBackrefs = z55.object({
  backrefs: schCostDataInput.optional()
});
var schPropertyCostDataResponse = schPropertyCostDataDocument.merge(z55.object({ structureCosts: schCostDataOutput.or(z55.undefined()) })).merge(schCostBackrefs);
var schOrderCostDataAttachment = z55.record(z55.string(), schPropertyCostDataDocument);
var schOrderCostDataDocument = z55.record(z55.string(), schPropertyCostDataResponse);

// src/tkv2DepreciationAndSite/types.ts
var schTkv2DepreciationKey = schStructureType;
var schTkv2DepreciationSettings = z56.object({
  physicalDepreciationMode: z56.enum(["ageLifeMethod", "percent", "lumpSum"]),
  depreciateImprovementsSeparately: z56.boolean(),
  defaultEconomicLifePerImprovement: z56.record(schTkv2DepreciationKey, z56.number()),
  functionalObsolescenceMode: z56.enum(["percent", "lumpSum"]),
  externalObsolescenceMode: z56.enum(["percent", "lumpSum"])
});

// src/tkv2OrderFeatures/orderFeatures.ts
var import_shared_utils37 = __toESM(require_lib(), 1);
import { z as z57 } from "zod";
var orderFeature = [
  "adu",
  "attic",
  "barn",
  "basement",
  "carport",
  "deck",
  "fireplace",
  "garage",
  "detachedGarage",
  "manualCost",
  "patio",
  "pool",
  "porch",
  "shed",
  "spa",
  "workshop"
];
var schOrderFeature = z57.enum(orderFeature);
var schOrderFeatures = z57.object({
  version: z57.literal(1),
  features: z57.array(schOrderFeature)
});
var ORDER_FEATURES = {
  adu: {
    label: "ADU",
    hasFeature: ({ adu }) => (0, import_shared_utils37.isDefined)(adu) && (0, import_shared_utils37.hasDefinedValues)(adu)
  },
  attic: {
    label: "Attic",
    hasFeature: ({ attic }) => (0, import_shared_utils37.isDefined)(attic) && (0, import_shared_utils37.isDefined)(attic.area) && attic.area.unitAmount > 0
  },
  barn: {
    label: "Barn",
    hasFeature: ({ barn }) => (0, import_shared_utils37.isDefined)(barn) && barn.hasFeature && ((0, import_shared_utils37.isDefined)(barn.area) && barn.area.unitAmount > 0 || (0, import_shared_utils37.isDefined)(barn.quality))
  },
  basement: {
    label: "Basement",
    hasFeature: ({ basement }) => (0, import_shared_utils37.isDefined)(basement) && basement.hasFeature && ((0, import_shared_utils37.isDefined)(basement.finishedArea) || (0, import_shared_utils37.isDefined)(basement.totalArea))
  },
  carport: {
    label: "Carport",
    hasFeature: ({ carport }) => (0, import_shared_utils37.isDefined)(carport) && carport.hasFeature && (0, import_shared_utils37.isDefined)(carport.area) && carport.area.unitAmount > 0
  },
  deck: {
    label: "Deck",
    hasFeature: ({ deck }) => (0, import_shared_utils37.isDefined)(deck) && deck.hasFeature && (0, import_shared_utils37.isDefined)(deck.area) && deck.area.unitAmount > 0
  },
  fireplace: {
    label: "Fireplace",
    hasFeature: ({ fireplace }) => (0, import_shared_utils37.isDefined)(fireplace) && fireplace.hasFeature && (0, import_shared_utils37.isDefined)(fireplace.type) && (0, import_shared_utils37.isDefined)(fireplace.count) && fireplace.count > 0
  },
  garage: {
    label: "Attached Garage",
    hasFeature: ({ garage }) => (0, import_shared_utils37.isDefined)(garage) && garage.hasFeature && (0, import_shared_utils37.isDefined)(garage.area) && garage.area.unitAmount > 0
  },
  detachedGarage: {
    label: "Detached Garage",
    hasFeature: ({ detachedGarage }) => (0, import_shared_utils37.isDefined)(detachedGarage) && detachedGarage.hasFeature && (0, import_shared_utils37.isDefined)(detachedGarage.area) && detachedGarage.area.unitAmount > 0
  },
  manualCost: {
    label: "Manual Cost",
    hasFeature: ({ manualCost }) => (0, import_shared_utils37.isDefined)(manualCost) && manualCost.unitAmount > 0
  },
  patio: {
    label: "Patio",
    hasFeature: ({ patio }) => (0, import_shared_utils37.isDefined)(patio) && patio.hasFeature && (0, import_shared_utils37.isDefined)(patio.area) && patio.area.unitAmount > 0
  },
  pool: {
    label: "Pool",
    hasFeature: ({ pool }) => (0, import_shared_utils37.isDefined)(pool) && pool.hasFeature && (0, import_shared_utils37.isDefined)(pool.area) && pool.area.unitAmount > 0
  },
  porch: {
    label: "Porch",
    hasFeature: ({ porch }) => (0, import_shared_utils37.isDefined)(porch) && porch.hasFeature && (0, import_shared_utils37.isDefined)(porch.area) && porch.area.unitAmount > 0
  },
  shed: {
    label: "Shed",
    hasFeature: ({ shed }) => (0, import_shared_utils37.isDefined)(shed) && shed.hasFeature && ((0, import_shared_utils37.isDefined)(shed.area) && shed.area.unitAmount > 0 || (0, import_shared_utils37.isDefined)(shed.quality))
  },
  spa: {
    label: "Spa",
    hasFeature: ({ spa }) => (0, import_shared_utils37.isDefined)(spa) && spa.hasFeature && (0, import_shared_utils37.isDefined)(spa.area) && spa.area.unitAmount > 0
  },
  workshop: {
    label: "Workshop",
    hasFeature: ({ workshop }) => (0, import_shared_utils37.isDefined)(workshop) && workshop.hasFeature && ((0, import_shared_utils37.isDefined)(workshop.area) && workshop.area.unitAmount > 0 || (0, import_shared_utils37.isDefined)(workshop.quality))
  }
};

// src/tkv2PairedCost/types.ts
import { AloftPrice as AloftPrice11, schAloftPriceJSON as schAloftPriceJSON7 } from "@aloft/shared-objects";
import { z as z58 } from "zod";
var pairedCostAdjustmentTypeList = [
  "termsOfSale",
  "concessions",
  "dateOfSale",
  "site",
  "locationView",
  "quality",
  "condition",
  "mainDwelling",
  // Either GLA or GBA for multi-family
  "bathAboveGrade",
  "bathBelowGrade",
  "basement",
  "functionalUtility",
  "externalObsolescence",
  "garageCarport",
  "porchPatioDeck",
  "attic",
  "fireplace",
  "belowGradeANSI",
  "barn",
  "bonusRoom",
  "adu",
  "manufactured",
  "pool",
  "shed",
  "workshop",
  "foundation",
  "units",
  "manual"
];
var schPairedCostAdjustmentType = z58.enum([...pairedCostAdjustmentTypeList]);
var combinedManualAdjustmentTypes = Array.from(
  /* @__PURE__ */ new Set([...schPairedCostAdjustmentType.options, ...manualAdjustmentKeys])
);
var schCombinedManualAdjustmentType = z58.enum(
  combinedManualAdjustmentTypes
);
var schTkv2PairedCostSettings = z58.object({
  enableRounding: z58.boolean().optional(),
  enableThreshold: z58.boolean().optional(),
  rounding: z58.record(schCombinedManualAdjustmentType, AloftPrice11.schema.optional()),
  roundingDefault: AloftPrice11.schema,
  threshold: z58.record(schCombinedManualAdjustmentType, AloftPrice11.schema.optional()),
  thresholdDefault: AloftPrice11.schema,
  saveAsDefault: z58.boolean().optional()
});
var schPairedCostSettingsJSON = z58.object({
  enableRounding: z58.boolean().optional(),
  enableThreshold: z58.boolean().optional(),
  rounding: z58.record(schCombinedManualAdjustmentType, schAloftPriceJSON7),
  roundingDefault: schAloftPriceJSON7,
  threshold: z58.record(schCombinedManualAdjustmentType, schAloftPriceJSON7),
  thresholdDefault: schAloftPriceJSON7,
  saveAsDefault: z58.boolean().optional()
});

// src/tkv2Property/Tkv2Property.ts
var import_shared_utils53 = __toESM(require_lib(), 1);
var import_fast_json_stable_stringify = __toESM(require_fast_json_stable_stringify(), 1);
import { AloftArea as AloftArea16, AloftCount as AloftCount11, AloftPrice as AloftPrice16 } from "@aloft/shared-objects";
import _2 from "lodash";
import { z as z65 } from "zod";

// src/listing/utils/getLotAreaInSqft.ts
import { AloftArea as AloftArea12 } from "@aloft/shared-objects";
var getLotAreaInSqft = (listingData) => listingData.LotSizeSquareFeet ? AloftArea12.fromNumber(listingData.LotSizeSquareFeet, "sqft") : listingData.LotSizeAcres ? AloftArea12.fromNumber(listingData.LotSizeAcres, "acre").toSqFt() : void 0;

// src/listing/utils/getUADStatus.ts
function getUADStatus(listing) {
  const status = listing.StandardStatus;
  if (status === void 0)
    return void 0;
  switch (status.toLowerCase().trim()) {
    case "active":
    case "activeundercontract":
    case "active under contract":
    case "comingsoon":
    case "coming soon":
      return "Active";
    case "pending":
      return "Contract";
    case "withdrawn":
    case "hold":
      return "Withdrawn";
    case "sold":
    case "closed":
      return "SettledSale";
    case "canceled":
    case "delete":
    case "expired":
      return "Expired";
    default:
      return void 0;
  }
}

// src/listing/utils/getListingLotSizeSqft.ts
import { AloftArea as AloftArea13 } from "@aloft/shared-objects";
function getListingLotSizeSqft({
  LotSizeSquareFeet,
  LotSizeAcres
}) {
  if (LotSizeSquareFeet)
    return AloftArea13.fromNumber(LotSizeSquareFeet, "sqft");
  if (LotSizeAcres)
    return AloftArea13.fromNumber(LotSizeAcres, "acre");
  return void 0;
}

// src/listing/utils/toUADListingStatus.ts
function toUADListingStatus(status) {
  if (status === void 0)
    return void 0;
  switch (status.toLowerCase().trim()) {
    case "active":
    case "activeundercontract":
    case "active under contract":
    case "comingsoon":
    case "coming soon":
      return "Active";
    case "pending":
      return "Contract";
    case "withdrawn":
    case "hold":
      return "Withdrawn";
    case "sold":
    case "closed":
      return "SettledSale";
    case "canceled":
    case "delete":
    case "expired":
      return "Expired";
    default:
      return void 0;
  }
}

// src/listing/houseCanary.ts
import { z as z59 } from "zod";
var schPropertyDetailsAdvanced = z59.object({
  subject_address: z59.object({
    address_full: z59.string().nullable(),
    address_id: z59.number().nullable(),
    slug: z59.string().nullable(),
    block_id: z59.string().nullable(),
    city: z59.string().nullable(),
    fips: z59.string().nullable(),
    geo_precision: z59.string().nullable(),
    latitude: z59.number().nullable(),
    longitude: z59.number().nullable(),
    state: z59.string().nullable(),
    unit: z59.string().nullable(),
    address: z59.string().nullable(),
    zipcode: z59.string().nullable(),
    zipcode_plus4: z59.string().nullable(),
    msa: z59.string().nullable()
  }),
  public_records: z59.unknown(),
  hc: z59.object({
    architectural_style: z59.string().nullable(),
    attic: z59.unknown(),
    // TODO: figure out
    basement: z59.object({
      finished_pct: z59.number().nullable(),
      has: z59.boolean().nullable(),
      total_area: z59.number().nullable()
    }).nullable(),
    bathrooms: z59.object({
      full: z59.number().nullable(),
      partial: z59.number().nullable(),
      total: z59.number().nullable(),
      total_provided: z59.number().nullable(),
      total_projected: z59.number().nullable()
    }).nullable(),
    bedrooms: z59.number().nullable(),
    buildings: z59.string().nullable(),
    building_quality: z59.string().nullable(),
    construction_types: z59.array(z59.string()).nullable(),
    cooling: z59.array(z59.string()).nullable(),
    fireplace: z59.unknown().nullable(),
    // TODO: figure out
    fireplaces_total: z59.number().nullable(),
    heating: z59.array(z59.string()).nullable(),
    legal_description: z59.string().nullable(),
    living_area: z59.number().nullable(),
    living_area_above_grade: z59.number().nullable(),
    living_area_below_grade: z59.number().nullable(),
    lot_size: z59.number().nullable(),
    neighborhood: z59.unknown().nullable(),
    // TODO: figure out
    parcel_id: z59.string().nullable(),
    parking: z59.object({
      description: z59.string().nullable(),
      garage: z59.number().nullable(),
      total: z59.number().nullable()
    }).nullable(),
    pool: z59.boolean().nullable(),
    pool_community: z59.unknown().nullable(),
    // TODO: figure out
    property_type: z59.string().nullable(),
    property_type_description: z59.string().nullable(),
    roof_type: z59.unknown().nullable(),
    // TODO: figure out
    roof_material: z59.unknown().nullable(),
    // TODO: figure out
    rooms_total: z59.number().nullable(),
    sewer: z59.unknown().nullable(),
    // TODO: figure out
    sewer_public: z59.boolean().nullable(),
    solar_panels: z59.unknown().nullable(),
    // TODO: figure out
    stories: z59.number().nullable(),
    subdivision: z59.unknown().nullable(),
    // TODO: figure out
    units_total: z59.unknown().nullable(),
    // TODO: figure out
    walls_exterior_material: z59.string().nullable(),
    water: z59.unknown().nullable(),
    // TODO: figure out
    year_built: z59.number().nullable(),
    zoning: z59.object({
      code: z59.string().nullable(),
      description: z59.string().nullable()
    }).nullable(),
    condition_class: z59.number().nullable()
  }).nullable(),
  assessment: z59.object({
    apn: z59.string().nullable(),
    amount_annual: z59.number().nullable(),
    value_assessed: z59.number().nullable(),
    value_assessed_improvement: z59.number().nullable(),
    value_assessed_land: z59.number().nullable(),
    tax_year: z59.number().nullable(),
    year_assessed: z59.number().nullable()
  })
});
var schMlsTxs = z59.array(
  z59.object({
    "property/listing_status": z59.object({
      api_code_description: z59.string().nullable(),
      api_code: z59.number(),
      result: z59.object({
        listing_status: z59.string().nullable(),
        listing_date: z59.string().nullable(),
        listing_price: z59.number().nullable(),
        listing_status_date: z59.string().nullable(),
        has_price_considerations: z59.boolean().nullable()
      }).nullable()
    }),
    address_info: z59.object({
      city: z59.string().nullable(),
      county_fips: z59.string().nullable(),
      geo_precision: z59.string().nullable(),
      zipcode: z59.string().nullable(),
      address_full: z59.string().nullable(),
      slug: z59.string().nullable(),
      block_id: z59.string().nullable(),
      blockgroup_id: z59.string().nullable(),
      state: z59.string().nullable(),
      zipcode_plus4: z59.string().nullable(),
      address: z59.string().nullable(),
      lat: z59.number().nullable(),
      lng: z59.number().nullable(),
      unit: z59.string().nullable(),
      status: z59.unknown().nullable(),
      // TODO: figure out
      msa: z59.string().nullable(),
      metrodiv: z59.unknown().nullable()
      // TODO: figure out
    })
  })
);

// src/propertyTranslation/staticTranslators/helpers/getC1ContractDate.ts
var import_shared_utils39 = __toESM(require_lib(), 1);

// src/propertyTranslation/staticTranslators/helpers/dateFromString.ts
var import_shared_utils38 = __toESM(require_lib(), 1);
import { AloftDate as AloftDate10 } from "@aloft/shared-objects";
var dateFromString = (0, import_shared_utils38.applyIfNonEmptyString)((val) => AloftDate10.fromIsoString(val));

// src/propertyTranslation/staticTranslators/helpers/dateFromTimeString.ts
var import_is2 = __toESM(require_is(), 1);
import { AloftTime as AloftTime7 } from "@aloft/shared-objects";
var dateFromTimeString = (val, timeZone) => (0, import_is2.isUndefined)(val) || val === "" ? void 0 : AloftTime7.fromIsoString(val).toAloftDate(timeZone);

// src/propertyTranslation/staticTranslators/helpers/getC1ContractDate.ts
function getC1ContractDate(listing, allowNulls = false) {
  if (allowNulls && (0, import_shared_utils39.isUndefined)(listing.OriginatingSystemName)) {
    return;
  }
  const mls = mlsInfoByConstellation1ID(listing.OriginatingSystemName);
  let timeZone;
  if (mls === void 0 || mls.isActive === false || !mls.timeZone) {
    timeZone = TimeZone.TimeZones.US_PACIFIC;
  } else {
    timeZone = mls.timeZone;
  }
  return (
    // PurchaseContractDate is the most accurate, but has very low fill rate
    dateFromString(listing.PurchaseContractDate) ?? // Pending timestamp is the next best option as it's set by the MLS
    dateFromTimeString(listing.PendingTimestamp, timeZone) ?? // If neither of those options is available, fallback to C1's derived pending date
    dateFromTimeString(listing.DerivedPendingTimestamp, timeZone)
  );
}

// src/propertyTranslation/staticTranslators/helpers/getC1ListDate.ts
var import_shared_utils40 = __toESM(require_lib(), 1);
function getC1ListDate(listing, allowNulls = false) {
  if (allowNulls && (0, import_shared_utils40.isUndefined)(listing.OriginatingSystemName)) {
    return;
  }
  const mls = mlsInfoByConstellation1ID(listing.OriginatingSystemName);
  if (mls?.isActive === false)
    throw new Error(`Unsupported MLS ${mls.mlsid}`);
  return (
    // OnMarketDate
    dateFromString(listing.OnMarketDate) ?? // then OnMarketTimestamp
    dateFromTimeString(listing.OnMarketTimestamp, mls?.timeZone ?? TimeZone.TimeZones.US_EASTERN) ?? // then DerivedOnMarketTimestamp
    dateFromTimeString(
      listing.DerivedOnMarketTimestamp,
      mls?.timeZone ?? TimeZone.TimeZones.US_EASTERN
    )
  );
}

// src/propertyTranslation/staticTranslators/helpers/getC1FullBathroomCount.ts
var import_shared_utils41 = __toESM(require_lib(), 1);
function getC1FullBathroomCount(listingData) {
  if ((0, import_shared_utils41.isDefined)(listingData.BathroomsFull) || (0, import_shared_utils41.isDefined)(listingData.BathroomsThreeQuarter)) {
    return (listingData.BathroomsFull ?? 0) + (listingData.BathroomsThreeQuarter ?? 0);
  }
  const totalNumber = listingData.BathroomsTotalInteger;
  if (totalNumber !== void 0 && !Number.isNaN(totalNumber)) {
    return Math.floor(totalNumber);
  }
  return void 0;
}

// src/propertyTranslation/staticTranslators/helpers/getC1HalfBathroomCount.ts
var import_shared_utils42 = __toESM(require_lib(), 1);
function getC1HalfBathroomCount(listingData) {
  if (listingData.BathroomsHalf !== void 0) {
    return listingData.BathroomsHalf;
  }
  const bathroomTotalRep = listingData.BathroomsTotalInteger?.toString();
  if (bathroomTotalRep?.includes(".")) {
    return Number((0, import_shared_utils42.expected)(bathroomTotalRep).split(".")[1]);
  }
  return void 0;
}

// src/propertyTranslation/staticTranslators/3p/constellation1Runner.ts
var import_shared_utils47 = __toESM(require_lib(), 1);
import { AloftCount as AloftCount10, AloftPrice as AloftPrice13 } from "@aloft/shared-objects";

// src/propertyTranslation/staticTranslators/custom/resoListingRunner.ts
var import_shared_utils46 = __toESM(require_lib(), 1);
var import_is3 = __toESM(require_is(), 1);
import { AloftArea as AloftArea14, AloftCount as AloftCount9, AloftPrice as AloftPrice12 } from "@aloft/shared-objects";

// src/propertyTranslation/staticTranslators/ageFromNumber.ts
var import_shared_utils43 = __toESM(require_lib(), 1);

// src/propertyTranslation/staticTranslators/helpers/calculateAge.ts
function calculateAge(effectiveDate, yearBuilt) {
  return effectiveDate.getYear() - yearBuilt;
}

// src/propertyTranslation/staticTranslators/ageFromNumber.ts
var ageFromNumber = (effectiveDate) => (0, import_shared_utils43.orUndefined)((val) => calculateAge(effectiveDate, val));

// src/propertyTranslation/staticTranslators/helpers/stateFromString.ts
var import_shared_utils44 = __toESM(require_lib(), 1);
var stateFromString = (0, import_shared_utils44.applyIfNonEmptyString)((val) => normalizeToStateAbbr(val));

// src/propertyTranslation/staticTranslators/helpers/statusFromListing.ts
var import_shared_utils45 = __toESM(require_lib(), 1);
var listingStatusToUADStatus = (0, import_shared_utils45.makeLookup)({
  cases: [
    [["Active", "Active Under Contract", "Coming Soon"], "Active"],
    [["Canceled", "Delete", "Expired", "Incomplete"], "Expired"],
    [["Closed", "Sold"], "SettledSale"],
    [["Hold", "Withdrawn"], "Withdrawn"],
    ["Pending", "Contract"]
  ],
  default: "Expired"
  // TODO: Should we leave this or get rid of it?
});

// src/propertyTranslation/staticTranslators/matrix/normalizeView.ts
function normalizeView(view) {
  if (!view)
    return void 0;
  if (view.includes("Territorial"))
    return "Terrtrl";
  if (view.includes("City"))
    return "CtySky";
  if (view.includes("Partial"))
    return "Prtl";
  if (view.includes("Mountain") || view.includes("Mountain(s)"))
    return "Mtn";
  return view;
}

// src/propertyTranslation/staticTranslators/custom/resoListingRunner.ts
var countFromNumber = (n) => n === void 0 || n === null ? n : AloftCount9.fromNumber(Math.trunc(n));
var sqftAreaFromNumber = (n) => AloftArea14.fromNumber(n, "sqft");
var sqftAreaFromAcreNumber = (n) => AloftArea14.fromNumber(n, "acre")?.toSqFt();
var priceFromNumber = AloftPrice12.fromNumericPrice;
var stringFromArray = (0, import_shared_utils46.orUndefined)((val) => val.join(", "));
function decodeListingStatus(x) {
  if (typeof x !== "string")
    return void 0;
  return listingStatusToUADStatus(x);
}
var resoListingRunner = (effectiveDate, source, mls) => ({
  aboveGradeBedroomCount: countFromNumber(source.BedroomsTotal),
  aboveGradeFullBathCount: countFromNumber(source.BathroomsFull),
  aboveGradeHalfBathCount: countFromNumber(source.BathroomsHalf),
  aboveGradeThreeQuarterBathCount: countFromNumber(source.BathroomsThreeQuarter),
  aboveGradeTotalRoomCount: countFromNumber(source.RoomsTotal),
  address: summarizeAddress(source),
  annualTaxAmount: priceFromNumber(source.TaxAnnualAmount),
  architectureStyle: stringFromArray(source.ArchitecturalStyle),
  // Assigning all garage spaces to attached garage. As of 8/23 we have no use for trying to split them up.
  attachedGarageParkingSpacesCount: countFromNumber(source.GarageSpaces),
  age: ageFromNumber(effectiveDate)(source.YearBuilt),
  yearBuilt: source.YearBuilt,
  closeDate: dateFromString(source.CloseDate),
  contractDate: dateFromString(source.PurchaseContractDate),
  cumulativeDaysOnMarket: countFromNumber(source.CumulativeDaysOnMarket),
  daysOnMarket: countFromNumber(source.DaysOnMarket),
  designNumberOfStories: source.StoriesTotal,
  designStyle: source.ArchitecturalStyle?.[0],
  designAttachmentType: attachmentTypeFromSource(source),
  expirationDate: dateFromString(source.ExpirationDate),
  financingType: financingTypeFromSource(source),
  financialConcessionAmount: priceFromNumber(source.ConcessionsAmount),
  grossLivingArea: sqftAreaFromNumber(source.LivingArea),
  hasAttachment: source.PropertyAttachedYN,
  hasBasement: source.BasementYN,
  latitude: source.Latitude,
  legalDescription: source.TaxLegalDescription,
  listDate: dateFromString(source.OnMarketDate),
  listingID: source.ListingId,
  listingStatus: decodeListingStatus(source.StandardStatus),
  listPrice: priceFromNumber(source.ListPrice),
  longitude: source.Longitude,
  marketingCommentary: source.PublicRemarks,
  mls,
  parcelID: source.ParcelNumber,
  porchPatioDeck: porchPatioDeckFromSource(source),
  propertyType: source.PropertyType,
  propertySubtype: source.PropertySubType,
  rentControl: source.RentControlYN,
  salePrice: priceFromNumber(source.ClosePrice),
  saleType: saleTypeFromSource(source),
  site: sqftAreaFromNumber(source.LotSizeSquareFeet) ?? sqftAreaFromAcreNumber(source.LotSizeAcres),
  taxYear: source.TaxYear,
  viewFactorOne: normalizeView(source.View?.[0]),
  viewFactorTwo: normalizeView(source.View?.[1]),
  withdrawalDate: dateFromString(source.WithdrawnDate),
  cooling: stringFromArray(source.Cooling),
  greenEnergyEfficient: stringFromArray(source.GreenEnergyEfficient),
  heating: stringFromArray(source.Heating),
  poolFeatures: stringFromArray(source.PoolFeatures)
});
function summarizeAddress(source) {
  const addressLine = [
    source.StreetNumber,
    source.StreetName,
    source.StreetSuffix,
    source.StreetDirSuffix
  ].filter(import_shared_utils46.isDefined);
  return {
    AddressLineText: addressLine.join(" ").trim(),
    CityName: source.City,
    CountyName: source.CountyOrParish,
    StateCode: stateFromString(source.StateOrProvince),
    PostalCode: source.PostalCode,
    unitNumber: source.UnitNumber
  };
}
function saleTypeFromSource(source) {
  const specialListingConditions = source.SpecialListingConditions;
  if ((0, import_is3.isUndefined)(specialListingConditions) || specialListingConditions.length === 0) {
    return "ArmsLengthSale";
  }
  const condition = specialListingConditions[0];
  switch (condition) {
    case "Short Sale":
      return "ShortSale";
    case "Real Estate Owned":
      return "REOSale";
    default:
      return void 0;
  }
}
var financingTypeFromSource = (source) => {
  const buyerFinancing = source.BuyerFinancing;
  if (!buyerFinancing)
    return void 0;
  const financingType = buyerFinancing[0];
  if (!financingType)
    return void 0;
  const parsedFinancingType = schFinancingType.safeParse(financingType);
  if (parsedFinancingType.success)
    return parsedFinancingType.data;
  return void 0;
};
function porchPatioDeckFromSource(source) {
  const patioAndPorchFeatures = source.PatioAndPorchFeatures;
  if ((0, import_is3.isUndefined)(patioAndPorchFeatures) || patioAndPorchFeatures.length === 0) {
    return void 0;
  }
  return patioAndPorchFeatures.join(", ");
}
function attachmentTypeFromSource(source) {
  const rawAttachmentYN = source.PropertyAttachedYN;
  if ((0, import_is3.isUndefined)(rawAttachmentYN)) {
    return void 0;
  }
  return rawAttachmentYN ? "Attached" : "Detached";
}

// src/propertyTranslation/staticTranslators/3p/constellation1Runner.ts
var priceFromNumber2 = AloftPrice13.fromNumericPrice;
var constellation1Runner = (effectiveDate, source, mlsID) => {
  const resoProp = resoListingRunner(effectiveDate, source, mlsID);
  return {
    ...resoProp,
    contractDate: getC1ContractDate(source),
    listDate: getC1ListDate(source),
    images: imagesFromSource(source),
    hoaMonthlyAssessment: priceFromNumber2(source.DerivedAssociationFeeMonthly),
    totalBathCount: countFromNumber2(source.RawMlsBathroomsTotal),
    mls: mlsID
  };
};
function imagesFromSource(source) {
  const media = source.Media;
  if ((0, import_shared_utils47.isUndefined)(media) || media.length === 0) {
    return void 0;
  }
  return media.map((img) => {
    return { url: img.MediaURL };
  });
}
var countFromNumber2 = (n) => n === void 0 || n === null ? n : AloftCount10.fromNumber(Math.trunc(n));

// src/propertyTranslation/staticTranslators/toolkitPropertyRunnerFactory.ts
function toolkitPropertyRunnerFactory(source) {
  switch (source) {
    case "constellation1":
    case "abode":
      return constellation1Runner;
    case "custom":
      return resoListingRunner;
    default:
      throw Error("No known translation for source: " + source);
  }
}

// src/propertyTranslation/staticTranslators/helpers/getC1MonthFromDateString.ts
function getC1MonthFromDateString(date) {
  if (date === void 0)
    return void 0;
  const d = new Date(date);
  const month = d.getMonth() + 1;
  const year = d.getFullYear();
  return schIsoMonth.parse(`${year}-${month < 10 ? "0" : ""}${month}`);
}

// src/tkv2Property/replacementCost/lenses.ts
var import_shared_utils48 = __toESM(require_lib(), 1);
var L = __toESM(require_lens(), 1);
import { AloftArea as AloftArea15, AloftPrice as AloftPrice14 } from "@aloft/shared-objects";

// src/dropNaN.ts
function dropNaN(x) {
  return Number.isNaN(x) ? void 0 : x;
}

// src/tkv2Property/replacementCost/lenses.ts
var numberFieldIso = new L.Iso(
  (num) => num === void 0 ? void 0 : dropNaN(num),
  (num) => num === void 0 ? void 0 : dropNaN(num)
);
var positiveIntFieldIso = new L.Iso(
  numberFieldIso.fwd,
  (num) => num === void 0 || Number.isNaN(num) ? void 0 : schPositiveInt.parse(num)
);
var sqftFieldLens = new L.Lens(
  AloftArea15.sqftLensOpt.get,
  AloftArea15.sqftLensOpt.set
).concat(numberFieldIso.toLens());
var qualityFieldIso = numberFieldIso;
var booleanFieldIso = new L.Iso(
  (x) => x === true ? "Yes" : x === false ? "No" : void 0,
  (x) => x === "Yes" ? true : x === "No" ? false : void 0
);
var stringFieldIso = new L.Iso(
  // not technically an iso but what can you do
  (s) => s === void 0 ? void 0 : s,
  (s) => s === "" ? void 0 : s
);
var priceFieldLens = new L.Lens(
  AloftPrice14.dollarLensOpt.get,
  AloftPrice14.dollarLensOpt.set
).concat(numberFieldIso.toLens());
function makeEnumIso(opts) {
  return new L.Iso(
    (str) => str && opts.includes(str) ? str : void 0,
    (str) => str && opts.includes(str) ? str : void 0
  );
}
var foundationTypeEnumFieldIso = makeEnumIso([
  "Permanent or Concrete",
  "Non-Permanent"
]);
var fireplaceTypeEnumFieldIso = makeEnumIso(["Built-In", "Freestanding"]);
var basicStructureFieldLens = new L.Lens(
  (struct) => dropEmpty({
    totalSqft: sqftFieldLens.get(struct?.totalSqft),
    quality: qualityFieldIso.fwd(struct?.quality)
  }),
  (struct, fields) => dropEmpty({
    totalSqft: sqftFieldLens.set(struct?.totalSqft, fields?.totalSqft),
    quality: qualityFieldIso.fwd(fields?.quality)
  })
);
var complexStructureFieldLens = new L.Lens(
  (struct) => dropEmpty({
    totalSqft: sqftFieldLens.get(struct?.totalSqft),
    quality: qualityFieldIso.fwd(struct?.dwellingCostQuality),
    percentInteriorFinished: numberFieldIso.fwd(struct?.percentInteriorFinished),
    electrical: booleanFieldIso.fwd(struct?.electrical),
    subpanel: booleanFieldIso.fwd(struct?.subpanel),
    plumbingFixturesCount: numberFieldIso.fwd(struct?.plumbingFixturesCount)
  }),
  (struct, fields) => dropEmpty({
    totalSqft: sqftFieldLens.set(struct?.totalSqft, fields?.totalSqft),
    percentInteriorFinished: numberFieldIso.inv(fields?.percentInteriorFinished),
    electrical: booleanFieldIso.inv(fields?.electrical),
    subpanel: booleanFieldIso.inv(fields?.subpanel),
    plumbingFixturesCount: positiveIntFieldIso.inv(fields?.plumbingFixturesCount),
    dwellingCostQuality: qualityFieldIso.inv(fields?.quality)
  })
);
function dropEmpty(x) {
  return (0, import_shared_utils48.populated)(x) ? x : void 0;
}

// src/tkv2Property/replacementCost/getReplacementCostFields.ts
function getReplacementCostFields(prop) {
  const ext = prop._getCostDataExtension();
  const gla = prop.getStructuredData("gla");
  const bathrooms = prop.getStructuredData("bathroomCount");
  const basementLine1 = prop.getStructuredData("basementLine1");
  const basementLine2 = prop.getStructuredData("basementLine2");
  const designStyle = prop.getStructuredData("designStyle");
  const propertyType = prop.getPropertyType();
  const getSiteBuiltDwellingCostFields = () => {
    const primaryDwelling = {
      gla: sqftFieldLens.get(gla),
      quality: qualityFieldIso.fwd(ext?.primaryDwelling?.quality),
      stories: numberFieldIso.fwd(designStyle?.stories),
      aboveGradeBathsFull: positiveIntFieldIso.fwd(bathrooms?.fullBaths),
      aboveGradeBathsHalf: positiveIntFieldIso.fwd(bathrooms?.halfBaths),
      belowGradeBathsFull: positiveIntFieldIso.fwd(basementLine2?.fullBathCount),
      belowGradeBathsHalf: positiveIntFieldIso.fwd(basementLine2?.halfBathCount),
      nonStandardGLA: sqftFieldLens.get(ext?.primaryDwelling?.nonStandardGla),
      multiUnitCount: positiveIntFieldIso.fwd(ext?.primaryDwelling?.multiUnitCount)
    };
    switch (propertyType) {
      case "manufacturedHome":
        return void 0;
      case "multiFamily":
      case "singleFamilyResidence":
      default:
        return primaryDwelling;
    }
  };
  const getManufacturedDwellingCostFields = () => {
    const manufactured = {
      gla: sqftFieldLens.get(ext?.manufactured?.gla),
      quality: qualityFieldIso.fwd(ext?.manufactured?.dwellingCostQuality),
      sections: numberFieldIso.fwd(ext?.manufactured?.sections),
      bathroomsFull: positiveIntFieldIso.fwd(ext?.manufactured?.bathroomsFull),
      bathroomsHalf: positiveIntFieldIso.fwd(ext?.manufactured?.bathroomsHalf),
      hasAC: booleanFieldIso.fwd(ext?.manufactured?.hasAC),
      hasClimatePkg: booleanFieldIso.fwd(ext?.manufactured?.hasClimatePkg),
      foundationType: foundationTypeEnumFieldIso.fwd(ext?.manufactured?.foundationType),
      fireplaces: positiveIntFieldIso.fwd(ext?.manufactured?.fireplaces?.totalCount),
      fireplaceType: fireplaceTypeEnumFieldIso.fwd(ext?.manufactured?.fireplaces?.type),
      deliveryMileage: positiveIntFieldIso.fwd(ext?.manufactured?.deliveryMileage)
    };
    switch (propertyType) {
      case "manufacturedHome":
        return {
          ...manufactured,
          gla: sqftFieldLens.get(gla),
          bathroomsFull: positiveIntFieldIso.fwd(bathrooms?.fullBaths),
          bathroomsHalf: positiveIntFieldIso.fwd(bathrooms?.halfBaths)
        };
      case "multiFamily":
      case "singleFamilyResidence":
      default:
        return manufactured;
    }
  };
  return {
    // Primary Dwelling actually refers to site built dwelling here
    primaryDwelling: getSiteBuiltDwellingCostFields(),
    basement: {
      totalSqft: sqftFieldLens.get(basementLine1?.total),
      quality: qualityFieldIso.fwd(ext?.basement?.quality),
      finishedSqft: sqftFieldLens.get(basementLine1?.finished)
    },
    attachedOrBuiltinGarage: basicStructureFieldLens.get(ext?.attachedOrBuiltinGarage),
    detachedGarage: basicStructureFieldLens.get(ext?.detachedGarage),
    carport: basicStructureFieldLens.get(ext?.carport),
    deck: basicStructureFieldLens.get(ext?.deck),
    coveredPatioOrGazebo: basicStructureFieldLens.get(ext?.coveredPatioOrGazebo),
    enclosedPatio: {
      ...basicStructureFieldLens.get(ext?.enclosedPatio),
      linearFootage: positiveIntFieldIso.fwd(ext?.enclosedPatio?.linearFootage)
    },
    pool: basicStructureFieldLens.get(ext?.pool),
    adu: {
      gla: sqftFieldLens.get(ext?.adu?.gla),
      quality: qualityFieldIso.fwd(ext?.adu?.dwellingCostQuality),
      bathroomsFull: positiveIntFieldIso.fwd(ext?.adu?.bathroomsFull),
      bathroomsHalf: positiveIntFieldIso.fwd(ext?.adu?.bathroomsHalf),
      stories: numberFieldIso.fwd(ext?.adu?.stories)
    },
    attic: basicStructureFieldLens.get(ext?.attic),
    shed: complexStructureFieldLens.get(ext?.shed),
    workshop: complexStructureFieldLens.get(ext?.workshop),
    bonusRoom: complexStructureFieldLens.get(ext?.bonusRoom),
    barn: {
      ...complexStructureFieldLens.get(ext?.barn),
      isPoleBarn: booleanFieldIso.fwd(ext?.barn?.isPoleBarn),
      hasExteriorWall: booleanFieldIso.fwd(ext?.barn?.hasExteriorWall)
    },
    manufactured: getManufacturedDwellingCostFields(),
    manualCost: {
      label: stringFieldIso.fwd(ext?.manualCost?.label),
      feature: stringFieldIso.fwd(ext?.manualCost?.feature),
      cost: priceFieldLens.get(ext?.manualCost?.cost)
    }
  };
}

// src/tkv2Property/utils/getStructuredData.ts
var import_shared_utils49 = __toESM(require_lib(), 1);
function getStructuredData(field, salesCompGridData) {
  const { encoding, annotations } = salesCompGridData;
  if (encoding !== "UAD_2022") {
    throw Error(`Cannot retrieve data for encoding: ${encoding}`);
  }
  try {
    switch (field) {
      case "toolkitListingID":
        if ((0, import_shared_utils49.isUndefined)(annotations.DataSourceDescription)) {
          return void 0;
        }
        const { mls, listingID } = dataSourceSyntax.decode(annotations.DataSourceDescription);
        if ([mls, listingID].some(import_shared_utils49.isUndefined) || !isMLSID(mls) || !isMLSOUID(mls)) {
          return void 0;
        }
        return formatToolkitListingID({
          mls,
          listingID
        });
      case "address":
        return addressSyntax.decode(annotations);
      case "latitude":
        return (0, import_shared_utils49.orUndefined)(numberSyntax.decode)(
          annotations.LatitudeNumber
        );
      case "longitude":
        return (0, import_shared_utils49.orUndefined)(numberSyntax.decode)(
          annotations.LongitudeNumber
        );
      case "dataSource":
        return (0, import_shared_utils49.orUndefined)(dataSourceSyntax.decode)(
          annotations.DataSourceDescription
        );
      case "designStyle":
        return (0, import_shared_utils49.orUndefined)(designSyntax.decode)(annotations.DesignStyle);
      case "carStorage":
        return (0, import_shared_utils49.orUndefined)(garageCarportSyntax.decode)(
          annotations.CarStorage
        );
      case "status":
        return (0, import_shared_utils49.orUndefined)(dateOfSaleSyntax.decode)(
          annotations.DateOfSale
        );
      case "siteArea":
        return (0, import_shared_utils49.orUndefined)(siteSyntax.decode)(annotations.SiteArea)?.site;
      case "actualAge":
        return (0, import_shared_utils49.orUndefined)(actualAgeSyntax.decode)(annotations.Age);
      case "gla":
        return (0, import_shared_utils49.orUndefined)(grossLivingAreaSyntax.decode)(
          annotations.GrossLivingArea
        );
      case "bedroomCount":
        return (0, import_shared_utils49.orUndefined)(numberSyntax.decode)(
          annotations.TotalBedroomCount
        );
      case "bathroomCount":
        return (0, import_shared_utils49.orUndefined)(bathroomSyntax.decode)(
          annotations.TotalBathroomCount
        );
      case "basementLine1":
        return (0, import_shared_utils49.orUndefined)(basementLine1Syntax.decode)(
          annotations.BasementArea
        );
      case "basementLine2":
        return (0, import_shared_utils49.orUndefined)(basementLine2Syntax.decode)(
          annotations.BasementFinish
        );
      case "salePrice":
        return (0, import_shared_utils49.orUndefined)(priceSyntax.decode)(
          annotations.PropertySalesAmount
        );
      default:
        throw Error(`Getter not implemented for field: ${field}`);
    }
  } catch (e) {
    if (e instanceof SyntaxDecodeError) {
      return void 0;
    }
    throw e;
  }
}

// src/tkv2Property/utils/mergeStructuredDataField.ts
var import_shared_utils50 = __toESM(require_lib(), 1);
function mergeAnnotation(field, curr, incoming) {
  switch (field) {
    case "actualAge":
      const currAge = curr.getStructuredData(field);
      const incomingAge = incoming.getStructuredData(field);
      if (currAge === void 0 && incomingAge === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(actualAgeSyntax.encode)({
        age: incomingAge?.age ?? currAge?.age,
        isEstimation: incomingAge?.isEstimation ?? currAge?.isEstimation
      });
    case "gla":
      const currGla = curr.getStructuredData(field);
      const incomingGla = incoming.getStructuredData(field);
      return (0, import_shared_utils50.orUndefined)(grossLivingAreaSyntax.encode)(incomingGla ?? currGla);
    case "bedroomCount":
      const currBedroomCounts = curr.getStructuredData(field);
      const incomingBedroomCounts = incoming.getStructuredData(field);
      return (0, import_shared_utils50.orUndefined)(numberSyntax.encode)(incomingBedroomCounts ?? currBedroomCounts);
    case "bathroomCount":
      const currBathroomCounts = curr.getStructuredData(field);
      const incomingBathroomCounts = incoming.getStructuredData(field);
      if (currBathroomCounts === void 0 && incomingBathroomCounts === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(bathroomSyntax.encode)({
        fullBaths: incomingBathroomCounts?.fullBaths ?? currBathroomCounts?.fullBaths,
        halfBaths: incomingBathroomCounts?.halfBaths ?? currBathroomCounts?.halfBaths
      });
    case "basementLine1":
      const currBasementLine1 = curr.getStructuredData(field);
      const incomingBasementLine1 = incoming.getStructuredData(field);
      if (currBasementLine1 === void 0 && incomingBasementLine1 === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(basementLine1Syntax.encode)({
        total: incomingBasementLine1?.total ?? currBasementLine1?.total,
        finished: incomingBasementLine1?.finished ?? currBasementLine1?.finished
      });
    case "basementLine2":
      const currBasementLine2 = curr.getStructuredData(field);
      const incomingBasementLine2 = incoming.getStructuredData(field);
      if (currBasementLine2 === void 0 && incomingBasementLine2 === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(basementLine2Syntax.encode)({
        bedroomCount: incomingBasementLine2?.bedroomCount ?? currBasementLine2?.bedroomCount,
        fullBathCount: incomingBasementLine2?.fullBathCount ?? currBasementLine2?.fullBathCount,
        halfBathCount: incomingBasementLine2?.halfBathCount ?? currBasementLine2?.halfBathCount,
        otherRoomCount: incomingBasementLine2?.otherRoomCount ?? currBasementLine2?.otherRoomCount,
        recRoomCount: incomingBasementLine2?.recRoomCount ?? currBasementLine2?.recRoomCount
      });
    case "carStorage":
      const currCarStorage = curr.getStructuredData(field);
      const incomingCarStorage = incoming.getStructuredData(field);
      if (currCarStorage === void 0 && incomingCarStorage === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(garageCarportSyntax.encode)({
        attachedGarageSpaces: incomingCarStorage?.attachedGarageSpaces ?? currCarStorage?.attachedGarageSpaces,
        builtInGarageSpaces: incomingCarStorage?.builtInGarageSpaces ?? currCarStorage?.builtInGarageSpaces,
        detachedGarageSpaces: incomingCarStorage?.detachedGarageSpaces ?? currCarStorage?.detachedGarageSpaces,
        drivewaySpaces: incomingCarStorage?.drivewaySpaces ?? currCarStorage?.drivewaySpaces,
        carportSpaces: incomingCarStorage?.carportSpaces ?? currCarStorage?.carportSpaces
      });
    case "designStyle":
      const currDesignStyle = curr.getStructuredData(field);
      const incomingDesignStyle = incoming.getStructuredData(field);
      if (currDesignStyle === void 0 && incomingDesignStyle === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(designSyntax.encode)({
        attachmentType: incomingDesignStyle?.attachmentType ?? currDesignStyle?.attachmentType,
        style: incomingDesignStyle?.style ?? currDesignStyle?.style,
        stories: incomingDesignStyle?.stories ?? currDesignStyle?.stories
      });
    case "salePrice":
      const currSalePrice = curr.getStructuredData(field);
      const incomingSalePrice = incoming.getStructuredData(field);
      if (currSalePrice === void 0 && incomingSalePrice === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(priceSyntax.encode)(incomingSalePrice ?? currSalePrice);
    case "siteArea":
      const currSiteArea = curr.getStructuredData(field);
      const incomingSiteArea = incoming.getStructuredData(field);
      if (currSiteArea === void 0 && incomingSiteArea === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(siteSyntax.encode)({
        site: incomingSiteArea ?? currSiteArea
      });
    case "status":
      const currStatus = curr.getStructuredData(field);
      const incomingStatus = incoming.getStructuredData(field);
      if (currStatus === void 0 && incomingStatus === void 0) {
        return void 0;
      }
      return (0, import_shared_utils50.orUndefined)(dateOfSaleSyntax.encode)({
        contractMonth: incomingStatus?.contractMonth ?? currStatus?.contractMonth,
        closeMonth: incomingStatus?.closeMonth ?? currStatus?.closeMonth,
        expirationMonth: incomingStatus?.expirationMonth ?? currStatus?.expirationMonth,
        withdrawalMonth: incomingStatus?.withdrawalMonth ?? currStatus?.withdrawalMonth,
        listingStatus: incomingStatus?.listingStatus ?? currStatus?.listingStatus
      });
    default:
      throw new Error(`Unhandled field: ${field}`);
  }
}

// src/tkv2Property/utils/setStructuredData.ts
var import_shared_utils51 = __toESM(require_lib(), 1);
function setStructuredData(field, value, salesCompGridData) {
  const { encoding } = salesCompGridData;
  if (encoding !== "UAD_2022") {
    throw Error(`Cannot retrieve data for encoding: ${encoding}`);
  }
  let fieldName = void 0;
  let annotation = void 0;
  switch (field) {
    case "address":
      const address = value;
      const updatedUadAddressFields = (0, import_shared_utils51.isUndefined)(address) ? addressSyntax.emptyAnnotations : addressSyntax.encode(address);
      return {
        ...salesCompGridData,
        annotations: {
          ...salesCompGridData.annotations,
          ...updatedUadAddressFields
        }
      };
    case "latitude":
      fieldName = "LatitudeNumber";
      const latitude = value;
      annotation = (0, import_shared_utils51.orUndefined)(numberSyntax.encode)(latitude);
      break;
    case "longitude":
      fieldName = "LongitudeNumber";
      const longitude = value;
      annotation = (0, import_shared_utils51.orUndefined)(numberSyntax.encode)(longitude);
      break;
    case "dataSource":
      fieldName = "DataSourceDescription";
      const dataSource = value;
      annotation = (0, import_shared_utils51.orUndefined)(dataSourceSyntax.encode)(dataSource);
      break;
    case "designStyle":
      fieldName = "DesignStyle";
      const designStyle = value;
      annotation = (0, import_shared_utils51.orUndefined)(designSyntax.encode)(designStyle);
      break;
    case "carStorage":
      fieldName = "CarStorage";
      const carStorage = value;
      annotation = (0, import_shared_utils51.orUndefined)(garageCarportSyntax.encode)(carStorage);
      break;
    case "status":
      fieldName = "DateOfSale";
      const dateOfSale2 = value;
      annotation = (0, import_shared_utils51.orUndefined)(dateOfSaleSyntax.encode)(dateOfSale2);
      break;
    case "siteArea":
      fieldName = "SiteArea";
      const siteArea = value;
      annotation = (0, import_shared_utils51.orUndefined)((site) => siteSyntax.encode({ site }))(siteArea);
      break;
    case "actualAge":
      fieldName = "Age";
      const actualAge = value;
      annotation = (0, import_shared_utils51.orUndefined)(actualAgeSyntax.encode)(actualAge);
      break;
    case "gla":
      fieldName = "GrossLivingArea";
      const gla = value;
      annotation = (0, import_shared_utils51.orUndefined)(grossLivingAreaSyntax.encode)(gla);
      break;
    case "bedroomCount":
      fieldName = "TotalBedroomCount";
      const bedroomCount = value;
      annotation = (0, import_shared_utils51.orUndefined)(numberSyntax.encode)(bedroomCount);
      break;
    case "bathroomCount":
      fieldName = "TotalBathroomCount";
      const bathroomCount = value;
      annotation = (0, import_shared_utils51.orUndefined)(bathroomSyntax.encode)(bathroomCount);
      break;
    case "basementLine1":
      fieldName = "BasementArea";
      const basementLine1 = value;
      annotation = (0, import_shared_utils51.orUndefined)(basementLine1Syntax.encode)(basementLine1);
      break;
    case "basementLine2":
      fieldName = "BasementFinish";
      const basementLine2 = value;
      annotation = (0, import_shared_utils51.orUndefined)(basementLine2Syntax.encode)(basementLine2);
      break;
    case "salePrice":
      fieldName = "PropertySalesAmount";
      const salePrice = value;
      annotation = (0, import_shared_utils51.orUndefined)(priceSyntax.encode)(salePrice);
      break;
    default:
      throw Error(`Setter not implemented for field: ${field}`);
  }
  return {
    ...salesCompGridData,
    annotations: {
      ...salesCompGridData.annotations,
      [fieldName]: annotation
    }
  };
}

// src/tkv2Property/versions/toLatest.ts
var import_shared_utils52 = __toESM(require_lib(), 1);

// src/tkv2Property/versions/v2/v1tov2.ts
function v1tov2(json) {
  const { salesCompGridData, costDataExtension: cdOld, runCostExtension, propertyType } = json;
  const costDataExtension = {
    ...cdOld,
    depreciation: {
      physicalDepreciation: {
        primaryDwelling: {
          effectiveAge: cdOld.depreciation?.physicalDepreciation?.effectiveAge,
          ecoLifeYears: cdOld.depreciation?.physicalDepreciation?.economicLifeYears
        }
      },
      functionalObsolescence: {
        percent: cdOld.depreciation?.functionalObsolescencePercent
      },
      externalDepreciation: {
        percent: cdOld.depreciation?.externalDepreciationPercent
      }
    }
  };
  return {
    version: 2,
    salesCompGridData,
    costDataExtension,
    runCostExtension,
    propertyType
  };
}

// src/tkv2Property/versions/toLatest.ts
function toLatest(json) {
  let latest = json;
  switch (latest.version) {
    case 1:
      latest = v1tov2(latest);
    case 2:
      return latest;
    default:
      (0, import_shared_utils52.unreachable)(latest);
  }
}

// src/tkv2Property/versions/types.ts
import { z as z64 } from "zod";

// src/tkv2Property/versions/v1/costDataExtension.ts
import { AloftPrice as AloftPrice15 } from "@aloft/shared-objects";
import { z as z60 } from "zod";
var schDwellingCostQuality = z60.number().gte(1).lte(8).multipleOf(0.1);
var schBasicStructure2 = z60.strictObject({
  totalSqft: schAloftArea,
  quality: schDwellingCostQuality
}).partial();
var schComplexStructure2 = z60.strictObject({
  totalSqft: schAloftArea,
  percentInteriorFinished: z60.number(),
  electrical: z60.boolean(),
  subpanel: z60.boolean(),
  plumbingFixturesCount: schPositiveInt,
  dwellingCostQuality: schDwellingCostQuality
}).partial();
var schCDFoundationTypeEnum = z60.enum(["Permanent or Concrete", "Non-Permanent"]);
var schCDFireplaceTypeEnum = z60.enum(["Built-In", "Freestanding"]);
var schCDPrimaryDwelling2 = z60.strictObject({
  quality: schDwellingCostQuality,
  nonStandardGla: schAloftArea,
  multiUnitCount: schPositiveInt
}).partial();
var schCDBasement2 = z60.strictObject({
  quality: schDwellingCostQuality
}).partial();
var schCDAttic2 = z60.object({
  totalSqft: schAloftArea,
  quality: schDwellingCostQuality
}).partial();
var schCDAttachedBuiltinGarage2 = schBasicStructure2.partial();
var schCDDetachedGarage2 = schBasicStructure2.partial();
var schCDCarport2 = schBasicStructure2.partial();
var schCDDeck = schBasicStructure2.partial();
var schCDCoveredPatioOrGazebo = schBasicStructure2.partial();
var schCDEnclosedPatio2 = schBasicStructure2.extend({ linearFootage: schPositiveInt }).partial();
var schCDPool2 = schBasicStructure2.partial();
var schCDAdu2 = z60.strictObject({
  bathroomsFull: schPositiveInt,
  bathroomsHalf: schPositiveInt,
  stories: z60.number().gte(0).lte(4).multipleOf(0.5),
  gla: schAloftArea,
  dwellingCostQuality: schDwellingCostQuality
}).partial();
var schCDShed2 = schComplexStructure2.partial();
var schCDWorkshop2 = schComplexStructure2.partial();
var schCDBonusRoom2 = schComplexStructure2.partial();
var schCDBarn2 = schComplexStructure2.extend({
  isPoleBarn: z60.boolean(),
  hasExteriorWall: z60.boolean()
}).partial();
var schCDManufactured2 = z60.strictObject({
  sections: z60.number().gte(1).lte(4).int(),
  gla: schAloftArea,
  bathroomsFull: schPositiveInt,
  bathroomsHalf: schPositiveInt,
  dwellingCostQuality: schDwellingCostQuality,
  hasAC: z60.boolean(),
  hasClimatePkg: z60.boolean(),
  foundationType: schCDFoundationTypeEnum,
  fireplaces: z60.strictObject({
    totalCount: schPositiveInt,
    type: schCDFireplaceTypeEnum
  }).partial(),
  deliveryMileage: schPositiveInt
}).partial();
var schTkv2PropertyV1Depreciation = z60.strictObject({
  physicalDepreciation: z60.strictObject({
    effectiveAge: z60.number(),
    economicLifeYears: schPositiveInt
  }).partial(),
  functionalObsolescencePercent: z60.number().int().gte(0).lte(100),
  externalDepreciationPercent: z60.number().int().gte(0).lte(100)
}).partial();
var schManualCost = z60.strictObject({
  label: z60.string(),
  feature: z60.string(),
  cost: AloftPrice15.schema
}).partial();
var schTkv2PropertyV1CostDataExtension = z60.strictObject({
  primaryDwelling: schCDPrimaryDwelling2,
  basement: schCDBasement2,
  attic: schCDAttic2,
  attachedOrBuiltinGarage: schCDAttachedBuiltinGarage2,
  detachedGarage: schCDDetachedGarage2,
  carport: schCDCarport2,
  deck: schCDDeck,
  coveredPatioOrGazebo: schCDCoveredPatioOrGazebo,
  enclosedPatio: schCDEnclosedPatio2,
  pool: schCDPool2,
  adu: schCDAdu2,
  shed: schCDShed2,
  workshop: schCDWorkshop2,
  bonusRoom: schCDBonusRoom2,
  barn: schCDBarn2,
  manufactured: schCDManufactured2,
  // Not included in DwellingCost request
  /**
   * @deprecated Use manualCost instead
   */
  additionalFeaturesCost: schAloftPrice.optional(),
  manualCost: schManualCost,
  depreciation: schTkv2PropertyV1Depreciation,
  siteNotes: z60.string().optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: schAloftPrice.optional()
}).partial();

// src/tkv2Property/versions/v1/types.ts
import { z as z61 } from "zod";
var schRunCostResult = z61.object({
  output: schCostDataOutput,
  bathroomCosts: schBathroomCosts.optional()
});
var schRunCostExtension = schRunCostResult.extend({
  input: z61.unknown()
});
var schTkv2PropertyV1JSON = z61.object({
  version: z61.literal(1),
  salesCompGridData: schSalesCompGridData,
  costDataExtension: schTkv2PropertyV1CostDataExtension,
  runCostExtension: schRunCostExtension.optional(),
  propertyType: schPropertyTypes.optional()
});

// src/tkv2Property/versions/v2/types.ts
import { z as z63 } from "zod";

// src/tkv2Property/versions/v2/costDataExtension.ts
import { z as z62 } from "zod";
var schTkv2PropertyV2DepreciationField = z62.object({
  lumpSum: schAloftPrice.optional(),
  percent: z62.number().gte(0).lte(100).optional(),
  effectiveAge: z62.number().optional(),
  ecoLifeYears: z62.number().optional()
});
var schPhysicalDepreciation = z62.record(
  schStructureType,
  schTkv2PropertyV2DepreciationField
);
var schTkv2PropertyV2Depreciation = z62.strictObject({
  physicalDepreciation: schPhysicalDepreciation,
  functionalObsolescence: schTkv2PropertyV2DepreciationField,
  externalDepreciation: schTkv2PropertyV2DepreciationField
}).partial();
var schTkv2PropertyV2CostDataExtension = z62.strictObject({
  primaryDwelling: schCDPrimaryDwelling2,
  basement: schCDBasement2,
  attic: schCDAttic2,
  attachedOrBuiltinGarage: schCDAttachedBuiltinGarage2,
  detachedGarage: schCDDetachedGarage2,
  carport: schCDCarport2,
  deck: schCDDeck,
  coveredPatioOrGazebo: schCDCoveredPatioOrGazebo,
  enclosedPatio: schCDEnclosedPatio2,
  pool: schCDPool2,
  adu: schCDAdu2,
  shed: schCDShed2,
  workshop: schCDWorkshop2,
  bonusRoom: schCDBonusRoom2,
  barn: schCDBarn2,
  manufactured: schCDManufactured2,
  // Not included in DwellingCost request
  /**
   * @deprecated Use manualCost instead
   */
  additionalFeaturesCost: schAloftPrice.optional(),
  manualCost: schManualCost,
  depreciation: schTkv2PropertyV2Depreciation,
  notes: z62.string().optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: schAloftPrice.optional()
}).partial();

// src/tkv2Property/versions/v2/types.ts
var schTkv2PropertyV2JSON = z63.object({
  version: z63.literal(2),
  salesCompGridData: schSalesCompGridData,
  costDataExtension: schTkv2PropertyV2CostDataExtension,
  runCostExtension: schRunCostExtension.optional(),
  propertyType: schPropertyTypes.optional()
});

// src/tkv2Property/versions/types.ts
var schTkv2PropertyJSON = z64.discriminatedUnion("version", [
  schTkv2PropertyV1JSON,
  schTkv2PropertyV2JSON
]);

// src/tkv2Property/Tkv2Property.ts
var Tkv2Property = class _Tkv2Property {
  static LATEST_VERSION = 2;
  salesCompGridData;
  costDataExtension;
  runCostExtension;
  propertyType;
  constructor(props) {
    this.salesCompGridData = props.salesCompGridData;
    this.costDataExtension = props.costDataExtension;
    this.runCostExtension = props.runCostExtension;
    this.propertyType = props.propertyType;
  }
  equals(that) {
    if (!(that instanceof _Tkv2Property))
      return false;
    return _2.isEqual(this.salesCompGridData, that.salesCompGridData) && _2.isEqual(this.costDataExtension, that.costDataExtension) && _2.isEqual(this.runCostExtension, that.runCostExtension) && _2.isEqual(this.propertyType, that.propertyType);
  }
  // NOTE: toJSON() and schema.parse() should be inverses of each other! (modulo upgrades)
  toJSON() {
    return {
      version: _Tkv2Property.LATEST_VERSION,
      salesCompGridData: this.salesCompGridData,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    };
  }
  static schema = zodLaunder(
    z65.union([schTkv2PropertyJSON, z65.custom((x) => x instanceof _Tkv2Property)]).transform(
      (property) => property instanceof _Tkv2Property ? property : new _Tkv2Property(toLatest(property))
    )
  );
  static empty() {
    return new _Tkv2Property({
      salesCompGridData: { encoding: "UAD_2022", annotations: {} },
      costDataExtension: {},
      runCostExtension: void 0,
      propertyType: void 0
    });
  }
  static fromSalesCompGridData(salesCompGridData, propertyType) {
    return new _Tkv2Property({
      salesCompGridData,
      costDataExtension: {},
      runCostExtension: void 0,
      propertyType
    });
  }
  static fromPublicRecord(publicRecord, propertyType) {
    let property = new _Tkv2Property({
      propertyType,
      salesCompGridData: {
        encoding: "UAD_2022",
        annotations: {
          PropertyCity: publicRecord.PropertyAddressCity ?? void 0,
          PropertyState: publicRecord.PropertyAddressState ?? void 0,
          PropertyPostalCode: publicRecord.PropertyAddressZIP ?? void 0,
          PropertyStreetAddress: publicRecord.PropertyAddressFull ?? void 0,
          View: publicRecord.ViewDescription ?? void 0,
          DesignStyle: publicRecord.StructureStyle ?? void 0
        }
      },
      costDataExtension: {
        attachedOrBuiltinGarage: {
          totalSqft: publicRecord.ParkingGarageArea ?? void 0
        },
        carport: {
          totalSqft: publicRecord.ParkingCarportArea ?? void 0
        },
        deck: {
          totalSqft: publicRecord.DeckArea ?? void 0
        },
        coveredPatioOrGazebo: {
          totalSqft: publicRecord.PatioArea ?? void 0
        },
        attic: {
          totalSqft: publicRecord.RoomsAtticArea ?? void 0
        },
        adu: {
          gla: publicRecord.GuestHouseArea ?? void 0
        },
        shed: {
          totalSqft: publicRecord.ShedArea ?? void 0
        },
        pool: {
          totalSqft: publicRecord.PoolArea ?? void 0
        }
      },
      runCostExtension: void 0
    });
    const basementTotalArea = publicRecord.RoomsBasementArea ?? publicRecord.RoomsBasementAreaFinished ?? void 0;
    const stories = publicRecord.StoriesCount;
    const yearBuilt = publicRecord.YearBuilt;
    const parkingSpaces = publicRecord.ParkingSpaceCount;
    property = property.updateStructuredData("siteArea", publicRecord.AreaLotSF ?? void 0).updateStructuredData("gla", publicRecord.AreaBuilding ?? void 0).updateStructuredData("bedroomCount", encodePositiveInt(publicRecord.BedroomsCount)).updateStructuredData("bathroomCount", {
      fullBaths: encodePositiveInt(publicRecord.BathCount),
      halfBaths: encodePositiveInt(publicRecord.BathPartialCount)
    }).updateStructuredData("basementLine1", {
      total: basementTotalArea,
      finished: publicRecord.RoomsBasementAreaFinished ?? void 0
    });
    if (parkingSpaces !== null) {
      property = property.updateStructuredData("carStorage", {
        attachedGarageSpaces: publicRecord.ParkingGarage ? encodeParkingSpaceNumber(publicRecord.ParkingSpaceCount) : void 0,
        carportSpaces: publicRecord.ParkingCarport ? encodeParkingSpaceNumber(publicRecord.ParkingSpaceCount) : void 0
      });
    }
    if (stories !== null) {
      property = property.updateStructuredData("designStyle", {
        stories
      });
    }
    if (yearBuilt !== null) {
      property = property.updateStructuredData("actualAge", {
        age: schPositiveInt.parse((/* @__PURE__ */ new Date()).getFullYear() - yearBuilt)
      });
    }
    return property;
  }
  static fromMLSData(listingData, propertyType) {
    const { listingID, mls } = parseToolkitListingID((0, import_shared_utils53.expected)(listingData.ToolkitListingID));
    const property = new _Tkv2Property({
      propertyType,
      salesCompGridData: {
        encoding: "UAD_2022",
        annotations: {
          PropertyCity: listingData.City ?? void 0,
          PropertyState: listingData.StateOrProvince ?? void 0,
          PropertyPostalCode: listingData.PostalCode ?? void 0,
          PropertyStreetAddress: listingData.UnparsedAddress ?? void 0,
          View: listingData.View?.join(" ") ?? void 0,
          PorchDeck: listingData.PatioAndPorchFeatures?.join(" ") ?? void 0,
          LatitudeNumber: listingData.Latitude?.toString(),
          LongitudeNumber: listingData.Longitude?.toString()
        }
      },
      costDataExtension: {},
      runCostExtension: void 0
    });
    const halfBathCount = encodePositiveInt(getC1HalfBathroomCount(listingData));
    const fullBathCount = encodePositiveInt(getC1FullBathroomCount(listingData));
    const hasBathrooms = (0, import_shared_utils53.isDefined)(fullBathCount) || (0, import_shared_utils53.isDefined)(halfBathCount);
    const contractDate = getC1ContractDate(listingData);
    const contractMonth = contractDate?.getMonth();
    const contractYear = contractDate?.getYear();
    const contractMonthStructured = contractMonth !== void 0 && contractYear !== void 0 ? schIsoMonth.parse(`${contractYear}-${contractMonth < 10 ? "0" : ""}${contractMonth}`) : void 0;
    const listingStatus = toUADListingStatus(listingData.StandardStatus);
    let structuredProperty = property.updateStructuredData("dataSource", { mls, listingID }).updateStructuredData("designStyle", {
      stories: listingData.StoriesTotal,
      style: listingData.ArchitecturalStyle?.join(" ")
    }).updateStructuredData(
      "salePrice",
      listingData.ClosePrice ? AloftPrice16.fromNumericPrice(listingData.ClosePrice) : AloftPrice16.fromNumericPrice(listingData.ListPrice)
    ).updateStructuredData("siteArea", getListingLotSizeSqft(listingData)).updateStructuredData(
      "gla",
      listingData.LivingArea ? AloftArea16.fromNumber(listingData.LivingArea, "sqft") : void 0
    ).updateStructuredData("bedroomCount", encodePositiveInt(listingData.BedroomsTotal)).updateStructuredData("actualAge", {
      age: listingData.YearBuilt ? schPositiveInt.parse((/* @__PURE__ */ new Date()).getFullYear() - listingData.YearBuilt) : void 0
    });
    if (hasBathrooms) {
      structuredProperty = structuredProperty.updateStructuredData("bathroomCount", {
        fullBaths: fullBathCount,
        halfBaths: halfBathCount
      });
    }
    if (listingData.GarageSpaces) {
      structuredProperty = structuredProperty.updateStructuredData("carStorage", {
        attachedGarageSpaces: encodeParkingSpaceNumber(listingData.GarageSpaces)
      });
    }
    if (listingStatus) {
      structuredProperty = structuredProperty.updateStructuredData("status", {
        listingStatus,
        contractMonth: contractMonthStructured,
        closeMonth: getC1MonthFromDateString(listingData.CloseDate),
        expirationMonth: getC1MonthFromDateString(listingData.ExpirationDate),
        withdrawalMonth: getC1MonthFromDateString(listingData.WithdrawnDate)
      });
    }
    return structuredProperty;
  }
  /**
   * Pulls the property data from that and overlays it on top of the current
   * tkv2 property. Does not support merging runCostExtension today.
   * Remember: That overrides this where both values are available!
   */
  mergeWith(that) {
    return new _Tkv2Property({
      salesCompGridData: {
        encoding: that.salesCompGridData.encoding ?? this.salesCompGridData.encoding,
        annotations: {
          // These are simply strings so spreading is valid here
          ...this.salesCompGridData.annotations,
          ...that.salesCompGridData.annotations,
          Age: mergeAnnotation("actualAge", this, that),
          GrossLivingArea: mergeAnnotation("gla", this, that),
          TotalBedroomCount: mergeAnnotation("bedroomCount", this, that),
          TotalBathroomCount: mergeAnnotation("bathroomCount", this, that),
          BasementArea: mergeAnnotation("basementLine1", this, that),
          BasementFinish: mergeAnnotation("basementLine2", this, that),
          CarStorage: mergeAnnotation("carStorage", this, that),
          DesignStyle: mergeAnnotation("designStyle", this, that),
          PropertySalesAmount: mergeAnnotation("salePrice", this, that),
          SiteArea: mergeAnnotation("siteArea", this, that),
          DateOfSale: mergeAnnotation("status", this, that)
        }
      },
      costDataExtension: {
        primaryDwelling: {
          ...this.costDataExtension.primaryDwelling,
          ...that.costDataExtension.primaryDwelling
        },
        adu: {
          ...this.costDataExtension.adu,
          ...that.costDataExtension.adu
        },
        basement: {
          ...this.costDataExtension.basement,
          ...that.costDataExtension.basement
        },
        attic: {
          ...this.costDataExtension.attic,
          ...that.costDataExtension.attic
        },
        attachedOrBuiltinGarage: {
          ...this.costDataExtension.attachedOrBuiltinGarage,
          ...that.costDataExtension.attachedOrBuiltinGarage
        },
        detachedGarage: {
          ...this.costDataExtension.detachedGarage,
          ...that.costDataExtension.detachedGarage
        },
        carport: {
          ...this.costDataExtension.carport,
          ...that.costDataExtension.carport
        },
        deck: {
          ...this.costDataExtension.deck,
          ...that.costDataExtension.deck
        },
        coveredPatioOrGazebo: {
          ...this.costDataExtension.coveredPatioOrGazebo,
          ...that.costDataExtension.coveredPatioOrGazebo
        },
        enclosedPatio: {
          ...this.costDataExtension.enclosedPatio,
          ...that.costDataExtension.enclosedPatio
        },
        pool: {
          ...this.costDataExtension.pool,
          ...that.costDataExtension.pool
        },
        shed: {
          ...this.costDataExtension.shed,
          ...that.costDataExtension.shed
        },
        workshop: {
          ...this.costDataExtension.workshop,
          ...that.costDataExtension.workshop
        },
        bonusRoom: {
          ...this.costDataExtension.bonusRoom,
          ...that.costDataExtension.bonusRoom
        },
        barn: {
          ...this.costDataExtension.barn,
          ...that.costDataExtension.barn
        },
        manufactured: {
          ...this.costDataExtension.manufactured,
          ...that.costDataExtension.manufactured
        },
        depreciation: {
          ...this.costDataExtension.depreciation,
          ...that.costDataExtension.depreciation
        },
        manualCost: {
          ...this.costDataExtension.manualCost,
          ...that.costDataExtension.manualCost
        },
        siteCost: that.costDataExtension.siteCost ?? this.costDataExtension.siteCost,
        notes: that.costDataExtension.notes ?? this.costDataExtension.notes
      },
      runCostExtension: that.runCostExtension ?? this.runCostExtension,
      propertyType: that.propertyType ?? this.propertyType
    });
  }
  /**
   * Returns an updated version of the current Tkv2Property by copying
   * everything from the given property that is allowed to be updated directly
   * via the API.
   */
  updateAPIWritable(that) {
    return new _Tkv2Property({
      salesCompGridData: that.salesCompGridData,
      costDataExtension: that.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: that.propertyType
    });
  }
  getGridField(field) {
    const { encoding } = this.salesCompGridData;
    if (encoding !== "UAD_2022") {
      throw Error(`Cannot get UAD field for property with encoding: ${encoding}`);
    }
    return this.salesCompGridData.annotations[field];
  }
  /**
   * Returns a new Tkv2Property with one field updated. Original property is
   * unchanged.
   */
  updateGridField(field, value) {
    const { encoding } = this.salesCompGridData;
    if (encoding !== "UAD_2022") {
      throw Error(`Cannot set UAD field for property with encoding: ${encoding}`);
    }
    return new _Tkv2Property({
      salesCompGridData: {
        ...this.salesCompGridData,
        annotations: {
          ...this.salesCompGridData.annotations,
          [field]: value
        }
      },
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getAdjustment(field) {
    const { encoding } = this.salesCompGridData;
    if (encoding !== "UAD_2022") {
      throw Error(`Cannot get UAD adjustment for property with encoding: ${encoding}`);
    }
    return this.salesCompGridData.adjustments?.[field];
  }
  /**
   * Returns a new Tkv2Property with one adjustment updated. Original property is
   * unchanged.
   */
  updateAdjustment(field, value) {
    const { encoding } = this.salesCompGridData;
    if (encoding !== "UAD_2022") {
      throw Error(`Cannot set UAD adjustment for property with encoding: ${encoding}`);
    }
    return new _Tkv2Property({
      salesCompGridData: {
        ...this.salesCompGridData,
        adjustments: {
          ...this.salesCompGridData.adjustments,
          [field]: value
        }
      },
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getStructuredData(field) {
    return getStructuredData(field, this.salesCompGridData);
  }
  /**
   * Returns a new Tkv2Property with updated structured data. Original
   * property is unchanged
   */
  updateStructuredData(field, value) {
    const updatedGridData = setStructuredData(field, value, this.salesCompGridData);
    return new _Tkv2Property({
      salesCompGridData: updatedGridData,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  /** get SalesCompGridData */
  getSalesCompGridData() {
    return this.salesCompGridData;
  }
  /** Update SalesCompGridData */
  updateSalesCompGridData(salesCompGridData) {
    return new _Tkv2Property({
      salesCompGridData,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getEditableCostData() {
    const ext = this.costDataExtension;
    return {
      primaryDwelling: {
        quality: encodeExtQuality(ext.primaryDwelling?.quality),
        nonStandardGLA: ext.primaryDwelling?.nonStandardGla,
        multiUnitCount: ext.primaryDwelling?.multiUnitCount
      },
      basement: {
        quality: encodeExtQuality(ext.basement?.quality)
      },
      attic: {
        quality: encodeExtQuality(ext.attic?.quality),
        totalSqft: ext.attic?.totalSqft
      },
      attachedOrBuiltinGarage: encodeExtBasicStructure(ext.attachedOrBuiltinGarage),
      detachedGarage: encodeExtBasicStructure(ext.detachedGarage),
      carport: encodeExtBasicStructure(ext.carport),
      deck: encodeExtBasicStructure(ext.deck),
      coveredPatioOrGazebo: encodeExtBasicStructure(ext.coveredPatioOrGazebo),
      enclosedPatio: {
        ...encodeExtBasicStructure(ext.enclosedPatio),
        linearFootage: AloftCount11.fromNumber(ext.enclosedPatio?.linearFootage)
      },
      pool: encodeExtBasicStructure(ext.pool),
      adu: {
        bathroomsFull: AloftCount11.fromNumber(ext.adu?.bathroomsFull),
        bathroomsHalf: AloftCount11.fromNumber(ext.adu?.bathroomsHalf),
        stories: ext.adu?.stories,
        gla: ext.adu?.gla,
        quality: encodeExtQuality(ext.adu?.dwellingCostQuality)
      },
      shed: encodeExtComplexStructure(ext.shed),
      workshop: encodeExtComplexStructure(ext.workshop),
      bonusRoom: encodeExtComplexStructure(ext.bonusRoom),
      barn: {
        ...encodeExtComplexStructure(ext.barn),
        isPoleBarn: ext.barn?.isPoleBarn,
        hasExteriorWall: ext.barn?.hasExteriorWall
      },
      manufactured: {
        sections: AloftCount11.fromNumber(ext.manufactured?.sections),
        gla: ext.manufactured?.gla,
        bathroomsFull: AloftCount11.fromNumber(ext.manufactured?.bathroomsFull),
        bathroomsHalf: AloftCount11.fromNumber(ext.manufactured?.bathroomsHalf),
        quality: encodeExtQuality(ext.manufactured?.dwellingCostQuality),
        hasAC: ext.manufactured?.hasAC,
        hasClimatePkg: ext.manufactured?.hasClimatePkg,
        foundationType: ext.manufactured?.foundationType,
        fireplaces: AloftCount11.fromNumber(ext.manufactured?.fireplaces?.totalCount),
        fireplaceType: ext.manufactured?.fireplaces?.type,
        deliveryMileage: AloftCount11.fromNumber(ext.manufactured?.deliveryMileage)
      },
      depreciation: {
        physicalDepreciation: ext.depreciation?.physicalDepreciation ?? {},
        functionalObsolescence: ext.depreciation?.functionalObsolescence ?? {},
        externalDepreciation: ext.depreciation?.externalDepreciation ?? {}
      },
      manualCost: {
        label: ext.manualCost?.label,
        feature: ext.manualCost?.feature,
        cost: ext.manualCost?.cost
      }
    };
  }
  updateEditableCostData(cd) {
    const ext = {
      ...this.costDataExtension,
      primaryDwelling: {
        quality: decodeExtQuality(cd.primaryDwelling.quality),
        nonStandardGla: cd.primaryDwelling.nonStandardGLA,
        multiUnitCount: cd.primaryDwelling.multiUnitCount
      },
      basement: {
        quality: decodeExtQuality(cd.basement.quality)
      },
      attic: {
        quality: decodeExtQuality(cd.attic.quality),
        totalSqft: cd.attic.totalSqft
      },
      attachedOrBuiltinGarage: decodeExtBasicStructure(cd.attachedOrBuiltinGarage),
      detachedGarage: decodeExtBasicStructure(cd.detachedGarage),
      carport: decodeExtBasicStructure(cd.carport),
      deck: decodeExtBasicStructure(cd.deck),
      coveredPatioOrGazebo: decodeExtBasicStructure(cd.coveredPatioOrGazebo),
      enclosedPatio: {
        ...decodeExtBasicStructure(cd.enclosedPatio),
        linearFootage: schPositiveInt.optional().parse(cd.enclosedPatio.linearFootage?.toNumber())
      },
      pool: decodeExtBasicStructure(cd.pool),
      adu: {
        bathroomsFull: schPositiveInt.optional().parse(cd.adu?.bathroomsFull?.toNumber()),
        bathroomsHalf: schPositiveInt.optional().parse(cd.adu?.bathroomsHalf?.toNumber()),
        stories: cd.adu?.stories,
        gla: cd.adu?.gla,
        dwellingCostQuality: decodeExtQuality(cd.adu?.quality)
      },
      shed: decodeExtComplexStructure(cd.shed),
      workshop: decodeExtComplexStructure(cd.workshop),
      bonusRoom: decodeExtComplexStructure(cd.bonusRoom),
      barn: {
        ...decodeExtComplexStructure(cd.barn),
        isPoleBarn: cd.barn?.isPoleBarn,
        hasExteriorWall: cd.barn?.hasExteriorWall
      },
      manufactured: {
        sections: cd.manufactured?.sections?.toNumber(),
        gla: cd.manufactured?.gla,
        bathroomsFull: schPositiveInt.optional().parse(cd.manufactured?.bathroomsFull?.toNumber()),
        bathroomsHalf: schPositiveInt.optional().parse(cd.manufactured?.bathroomsHalf?.toNumber()),
        dwellingCostQuality: decodeExtQuality(cd.manufactured?.quality),
        hasAC: cd.manufactured?.hasAC,
        hasClimatePkg: cd.manufactured?.hasClimatePkg,
        foundationType: schCDFoundationTypeEnum.optional().parse(cd.manufactured?.foundationType),
        fireplaces: schCDManufactured2.shape.fireplaces.parse({
          totalCount: schPositiveInt.optional().parse(cd.manufactured?.fireplaces?.toNumber()),
          type: cd.manufactured?.fireplaceType
        }),
        deliveryMileage: schPositiveInt.optional().parse(cd.manufactured?.deliveryMileage?.toNumber())
      },
      depreciation: {
        physicalDepreciation: cd.depreciation?.physicalDepreciation,
        functionalObsolescence: cd.depreciation?.functionalObsolescence,
        externalDepreciation: cd.depreciation?.externalDepreciation
      }
    };
    return new _Tkv2Property({
      salesCompGridData: this.salesCompGridData,
      costDataExtension: ext,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getCostPerSqft(structureType) {
    return this._getRunCostExtension()?.output[structureType]?.costPerSqft;
  }
  getDwellingCostQuality(structureType) {
    return this.getEditableCostData()[structureType]?.quality;
  }
  /** INTERNAL */
  _getRunCostExtension() {
    return this.runCostExtension;
  }
  /** INTERNAL */
  _updateRunCostExtension(next) {
    return new _Tkv2Property({
      salesCompGridData: this.salesCompGridData,
      costDataExtension: this.costDataExtension,
      runCostExtension: next,
      propertyType: this.propertyType
    });
  }
  /** INTERNAL */
  _getCostDataExtension() {
    return this.costDataExtension;
  }
  getPropertyType() {
    return this.propertyType;
  }
  getReplacementCostFields() {
    return getReplacementCostFields(this);
  }
  getCostDataInput(effectiveDate) {
    const editableInput = this.getEditableCostData();
    const bedroomCount = this.getStructuredData("bedroomCount");
    const bathroomCount = this.getStructuredData("bathroomCount");
    const basementLine2 = this.getStructuredData("basementLine2");
    const carStorage = this.getStructuredData("carStorage");
    const propertType = this.getPropertyType();
    return {
      ...editableInput,
      address: this.getGridField("PropertyStreetAddress") ?? "",
      effectiveDate,
      zip: this.getGridField("PropertyPostalCode") ?? "",
      primaryDwelling: propertType === "manufacturedHome" ? {} : {
        ...editableInput.primaryDwelling,
        bedrooms: AloftCount11.fromNumber(bedroomCount),
        bathroomsFull: AloftCount11.addWithNulls(
          AloftCount11.fromNumber(bathroomCount?.fullBaths),
          AloftCount11.fromNumber(basementLine2?.fullBathCount)
        ) ?? void 0,
        bathroomsHalf: AloftCount11.addWithNulls(
          AloftCount11.fromNumber(bathroomCount?.halfBaths),
          AloftCount11.fromNumber(basementLine2?.halfBathCount)
        ) ?? void 0,
        stories: this.getStructuredData("designStyle")?.stories,
        gla: this.getStructuredData("gla")
      },
      manufactured: propertType === "manufacturedHome" ? {
        ...editableInput.manufactured,
        bathroomsFull: AloftCount11.addWithNulls(
          AloftCount11.fromNumber(bathroomCount?.fullBaths),
          AloftCount11.fromNumber(basementLine2?.fullBathCount)
        ) ?? void 0,
        bathroomsHalf: AloftCount11.addWithNulls(
          AloftCount11.fromNumber(bathroomCount?.halfBaths),
          AloftCount11.fromNumber(basementLine2?.halfBathCount)
        ) ?? void 0
      } : editableInput.manufactured,
      basement: {
        ...editableInput.basement,
        totalSqft: this.getStructuredData("basementLine1")?.total,
        finishedSqft: this.getStructuredData("basementLine1")?.finished
      },
      attachedOrBuiltinGarage: {
        ...editableInput.attachedOrBuiltinGarage,
        attachedSpaceCount: parkingSpaceNumberToAloftCount(carStorage?.attachedGarageSpaces),
        builtinSpaceCount: parkingSpaceNumberToAloftCount(carStorage?.builtInGarageSpaces)
      },
      detachedGarage: {
        ...editableInput.detachedGarage,
        spaceCount: parkingSpaceNumberToAloftCount(carStorage?.detachedGarageSpaces)
      },
      carport: {
        ...editableInput.carport,
        spaceCount: parkingSpaceNumberToAloftCount(carStorage?.carportSpaces)
      }
    };
  }
  isCostDataStale(effectiveDate) {
    const wantInput = filterNonDwellingCostInput(this.getCostDataInput(effectiveDate));
    const usedInput = filterNonDwellingCostInput(this._getRunCostExtension()?.input);
    return usedInput === void 0 || (0, import_fast_json_stable_stringify.default)(wantInput) !== (0, import_fast_json_stable_stringify.default)(usedInput);
  }
  getBathroomCosts() {
    return this.runCostExtension?.bathroomCosts;
  }
  getBathroomCounts() {
    const aboveGradeBathCounts = this.getStructuredData("bathroomCount");
    const belowGradeBathCounts = this.getStructuredData("basementLine2");
    return {
      aboveGrade: {
        fullBaths: aboveGradeBathCounts?.fullBaths ?? schPositiveInt.parse(0),
        halfBaths: aboveGradeBathCounts?.halfBaths ?? schPositiveInt.parse(0)
      },
      belowGrade: {
        fullBaths: belowGradeBathCounts?.fullBathCount ?? schPositiveInt.parse(0),
        halfBaths: belowGradeBathCounts?.halfBathCount ?? schPositiveInt.parse(0)
      }
    };
  }
  getGarageStallCount() {
    const carStorage = this.getStructuredData("carStorage");
    if ((0, import_shared_utils53.isUndefined)(carStorage)) {
      return 0;
    }
    return (carStorage.attachedGarageSpaces ?? 0) + (carStorage.builtInGarageSpaces ?? 0) + (carStorage.detachedGarageSpaces ?? 0) + (carStorage.carportSpaces ?? 0);
  }
};
function filterNonDwellingCostInput(input) {
  if ((0, import_shared_utils53.isUndefined)(input)) {
    return void 0;
  }
  const { depreciation, manualCost, ...filteredInput } = input;
  return filteredInput;
}
var schTkv2Property = Tkv2Property.schema;
function encodeExtBasicStructure(ext) {
  if (ext === void 0)
    return {};
  return {
    quality: encodeExtQuality(ext.quality),
    totalSqft: ext.totalSqft
  };
}
function decodeExtBasicStructure(cd) {
  return {
    quality: decodeExtQuality(cd.quality),
    totalSqft: cd.totalSqft
  };
}
function encodeExtComplexStructure(ext) {
  return {
    totalSqft: ext?.totalSqft,
    percentInteriorFinished: ext?.percentInteriorFinished,
    electrical: ext?.electrical,
    subpanel: ext?.subpanel,
    plumbingFixturesCount: AloftCount11.fromNumber(ext?.plumbingFixturesCount),
    quality: encodeExtQuality(ext?.dwellingCostQuality)
  };
}
function decodeExtComplexStructure(cd) {
  return {
    totalSqft: cd.totalSqft,
    percentInteriorFinished: cd.percentInteriorFinished,
    electrical: cd.electrical,
    subpanel: cd.subpanel,
    plumbingFixturesCount: schPositiveInt.optional().parse(cd.plumbingFixturesCount?.toNumber()),
    dwellingCostQuality: decodeExtQuality(cd.quality)
  };
}
function encodeExtQuality(quality) {
  if (quality === void 0)
    return void 0;
  return `${quality}`;
}
function decodeExtQuality(quality) {
  if (quality === void 0)
    return void 0;
  const m = quality.match(/^([.0-9]+)$/);
  if (m === null)
    throw new SyntaxDecodeError(`cannot parse quality: ${quality}`);
  return schDwellingCostQuality.parse(parseFloat((0, import_shared_utils53.expected)(m[1])));
}
function parkingSpaceNumberToAloftCount(spaces) {
  if ((0, import_shared_utils53.isUndefined)(spaces)) {
    return void 0;
  }
  return AloftCount11.fromNumber(Math.floor(spaces));
}
function encodePositiveInt(n) {
  if (n === null || n === void 0)
    return void 0;
  const parsed = schPositiveInt.safeParse(n);
  if (parsed.success) {
    return parsed.data;
  }
  console.warn(`Expected integer but received: ${n}`);
  return void 0;
}
function encodeParkingSpaceNumber(x) {
  try {
    return schParkingSpaceNumber.parse(x);
  } catch {
    return void 0;
  }
}

// src/tkv2Property/compRecommendation/types.ts
import { z as z66 } from "zod";
var schCompRecommendationC1 = z66.union([
  z66.object({
    status: z66.literal("found"),
    output: schListingsResult
  }),
  z66.object({
    status: z66.literal("not_found"),
    output: z66.object({
      searchCriteria: schCompsListingsSearchCriteria.optional()
    }).optional()
  }),
  z66.object({
    status: z66.literal("error"),
    message: z66.string(),
    output: z66.object({
      searchCriteria: schCompsListingsSearchCriteria.optional()
    }).optional()
  })
]);
var schCompRecommendationZillow = z66.union([
  z66.object({
    status: z66.literal("found"),
    output: z66.object({
      results: z66.array(schZillowPropertySearchResponse),
      resultsCount: z66.number(),
      searchCriteria: schCompsListingsSearchCriteria.optional()
    })
  }),
  z66.object({
    status: z66.literal("not_found"),
    output: z66.object({
      searchCriteria: schCompsListingsSearchCriteria.optional()
    }).optional()
  }),
  z66.object({
    status: z66.literal("error"),
    message: z66.string(),
    output: z66.object({
      searchCriteria: schCompsListingsSearchCriteria
    }).optional()
  })
]);
var schCompRecommendationV2 = z66.union([
  z66.object({
    version: z66.literal(2),
    source: z66.literal("constellation1"),
    input: z66.any(),
    body: schCompRecommendationC1
  }),
  z66.object({
    version: z66.literal(2),
    source: z66.literal("z"),
    input: z66.any(),
    body: schCompRecommendationZillow
  }),
  z66.object({
    version: z66.literal(2),
    source: z66.literal("abode"),
    input: z66.any(),
    body: schCompRecommendationC1
  })
]);
var schCompRecommendationOutput = schCompRecommendationV2;

// src/tkv2Property/vacantLandSales/types.ts
import { z as z67 } from "zod";
var schVacantLandSalesC1 = z67.union([
  z67.object({
    status: z67.literal("found"),
    output: schListingsResult
  }),
  z67.object({
    status: z67.literal("not_found")
  }),
  z67.object({
    status: z67.literal("error"),
    message: z67.string()
  })
]);
var schVacantLandSalesV1 = z67.object({
  version: z67.literal(1),
  source: schListingSource,
  input: z67.any(),
  body: schVacantLandSalesC1
});

// src/tkv2ReplacementCost/types.ts
import { AloftArea as AloftArea17 } from "@aloft/shared-objects";
import { z as z68 } from "zod";
var schTkv2ReplacementCostSettings = z68.object({
  copyPrimaryDwellingQualityToOthers: z68.boolean(),
  uadQualityMapping: z68.object({
    q1: z68.number(),
    q2: z68.number(),
    q3: z68.number(),
    q4: z68.number(),
    q5: z68.number(),
    q6: z68.number()
  }),
  garageCarportAreaPerStall: AloftArea17.schema
});

// src/tkv2OrderAttachments/schemas/additionalFeatures.ts
import { z as z69 } from "zod";
var additionalFeatures = z69.object({
  featureOneName: z69.string().optional(),
  featureTwoName: z69.string().optional(),
  featureThreeName: z69.string().optional()
});

// src/tkv2OrderAttachments/schemas/alerts.ts
import { z as z70 } from "zod";
var schAlerts = z70.object({
  dismissedAlerts: z70.array(schAlertType)
});

// src/tkv2OrderAttachments/schemas/commentary.ts
import { z as z71 } from "zod";
var schAlertsCommentary = z71.object(
  Object.fromEntries(schAlertType.options.map((k) => [k, z71.string()]))
).partial();
var marketConditionsCommentaryFilterTypes = ["Zip Code", "City", "County"];
var schMarketConditionsCommentaryFilterType = z71.enum(
  marketConditionsCommentaryFilterTypes
);
var estimatedDemandSupplyOptions = ["Shortage", "In Balance", "Over Supply"];
var schEstimatedDemandSupply = z71.enum(estimatedDemandSupplyOptions);
var estimatedExposureTimeOptions = [
  "Less than 30 days",
  "30 - 60 days",
  "60 - 90 days",
  "90 - 120 days",
  "120 - 150 days",
  "150 - 180 days",
  "More than 180 days"
];
var schEstimatedExposureTime = z71.enum(estimatedExposureTimeOptions);
var schMarketConditionsV2Commentary = z71.object({
  commentary: z71.string().optional(),
  filter: z71.object({
    type: schMarketConditionsCommentaryFilterType.default("Zip Code"),
    value: z71.string().optional()
  }),
  estimatedDemandSupply: schEstimatedDemandSupply.default("Shortage"),
  estimatedExposureTime: schEstimatedExposureTime.default("Less than 30 days")
  // data: z.object({}), // TODO: shape?
});
var schPriorSalesCommentary = z71.object({
  commentary: z71.string()
}).partial();
var schSiteExtractionCommentary = z71.object({
  commentary: z71.string()
}).partial();
var schDepreciatedCostCommentary = z71.object({
  glaCommentary: z71.string(),
  bathCommentary: z71.string(),
  basementCommentary: z71.string(),
  qualityCommentary: z71.string(),
  conditionCommentary: z71.string(),
  garageCarportCommentary: z71.string(),
  porchPatioDeckCommentary: z71.string(),
  aduCommentary: z71.string(),
  poolCommentary: z71.string(),
  shedCommentary: z71.string()
}).partial();
var schReconciliationCommentary = z71.object({
  reconciliationCommentary: z71.string(),
  highestAndBestUseCommentary: z71.string(),
  certificationCommentary: z71.string(),
  revisionCommentary: z71.string(),
  alternativeComparablesCommentary: z71.array(z71.string()),
  roiCommentary: z71.string(),
  feasibilityCommentary: z71.string()
}).partial();
var schCommentary = z71.object({
  alerts: schAlertsCommentary.optional(),
  depreciatedCost: schDepreciatedCostCommentary,
  marketConditionsV2: schMarketConditionsV2Commentary,
  priorSales: schPriorSalesCommentary,
  reconciliation: schReconciliationCommentary,
  siteExtraction: schSiteExtractionCommentary,
  /** @deprecated */
  isMarketConditionsCommentaryOmit: z71.boolean(),
  /** @deprecated */
  marketConditions: z71.string(),
  /** @deprecated */
  isSiteCommentaryOmit: z71.boolean(),
  /** @deprecated */
  siteAdjustments: z71.string(),
  /** @deprecated */
  isImprovementsCommentaryOmit: z71.boolean(),
  /** @deprecated */
  improvementsAdjustments: z71.string(),
  /** @deprecated */
  isGlaCommentaryOmit: z71.boolean(),
  /** @deprecated */
  glaAdjustment: z71.string(),
  /** @deprecated */
  isQualityCommentaryOmit: z71.boolean(),
  /** @deprecated */
  qualityAdjustment: z71.string(),
  /** @deprecated */
  isConditionCommentaryOmit: z71.boolean(),
  /** @deprecated */
  conditionAdjustment: z71.string(),
  /** @deprecated */
  isAtticCommentaryOmit: z71.boolean(),
  /** @deprecated */
  atticAdjustment: z71.string(),
  /** @deprecated */
  isBasementCommentaryOmit: z71.boolean(),
  /** @deprecated */
  basementAdjustment: z71.string(),
  /** @deprecated */
  isBelowGradeCommentaryOmit: z71.boolean(),
  /** @deprecated */
  belowGradeAdjustment: z71.string(),
  /** @deprecated */
  isParkingCommentaryOmit: z71.boolean(),
  /** @deprecated */
  parkingAdjustment: z71.string(),
  /** @deprecated */
  isPatioDeckCommentaryOmit: z71.boolean(),
  /** @deprecated */
  patioDeckAdjustment: z71.string(),
  /** @deprecated */
  isPoolCommentaryOmit: z71.boolean(),
  /** @deprecated */
  poolAdjustment: z71.string(),
  /** @deprecated */
  isGuestHouseCommentaryOmit: z71.boolean(),
  /** @deprecated */
  guestHouseAdjustment: z71.string(),
  /** @deprecated */
  isShedCommentaryOmit: z71.boolean(),
  /** @deprecated */
  shedAdjustment: z71.string(),
  /** @deprecated */
  isWorkshopCommentaryOmit: z71.boolean(),
  /** @deprecated */
  workshopAdjustment: z71.string(),
  /** @deprecated */
  isBonusRoomCommentaryOmit: z71.boolean(),
  /** @deprecated */
  bonusRoomAdjustment: z71.string(),
  /** @deprecated */
  isBarnCommentaryOmit: z71.boolean(),
  /** @deprecated */
  barnAdjustment: z71.string(),
  /** @deprecated */
  isManufacturedDwellingCommentaryOmit: z71.boolean(),
  /** @deprecated */
  manufacturedDwellingAdjustment: z71.string(),
  /** @deprecated */
  isManualCostCommentaryOmit: z71.boolean(),
  /** @deprecated */
  manualCostAdjustment: z71.string(),
  /** @deprecated */
  isCostApproachCommentaryOmit: z71.boolean(),
  /** @deprecated */
  costApproach: z71.string()
}).partial();
var schCommentaryV2 = schCommentary.pick({
  marketConditionsV2: true,
  priorSales: true,
  siteExtraction: true,
  depreciatedCost: true,
  reconciliation: true,
  alerts: true
});

// src/tkv2OrderAttachments/schemas/compSequence.ts
import { z as z72 } from "zod";
var compSequence = z72.object({
  sequence: z72.array(z72.string())
});

// src/tkv2OrderAttachments/schemas/imageAnalysis.ts
import { z as z73 } from "zod";
var imageAnalysis = z73.object({
  propertyID: z73.string(),
  imageURLs: z73.string().array(),
  result: schImageAnalysisResultContent
});

// src/tkv2OrderAttachments/schemas/marketConditions.ts
import { z as z76 } from "zod";

// src/tkv2MarketConditions/types.ts
import { z as z75 } from "zod";

// src/marketConditions/schemas.ts
import { z as z74 } from "zod";
var schAbodeAggregateGeoType = z74.enum([
  "zip",
  "state",
  "county",
  "city",
  "mls_source"
]);
var schMonthlyAbodeAggregate = z74.object({
  month: z74.string(),
  geo_type: schAbodeAggregateGeoType,
  geo_id: z74.string(),
  total_comparable_sales: z74.number().nullable(),
  total_active_properties: z74.number().nullable().optional(),
  absorption_rate: z74.number().nullable(),
  months_supply: z74.number().nullable(),
  median_days_on_market: z74.number().nullable(),
  median_sale_price: schAloftPrice.nullable(),
  median_list_price: schAloftPrice.nullable().optional()
});
var schAbodeAggregateMarketConditions = z74.object({
  geoType: schAbodeAggregateGeoType,
  geoId: z74.string(),
  monthlyData: z74.array(schMonthlyAbodeAggregate)
});

// src/tkv2MarketConditions/types.ts
var schAdjustSourcePercentage = z75.object({
  t: z75.literal("percent"),
  value: z75.number()
});
var schManualAdjustment = z75.object({
  source: z75.literal("customPrice"),
  adjustmentAmount: schAloftPrice
});
var schCustomRateAdjustment = z75.object({
  source: z75.literal("customRate"),
  adjustmentAmount: schAloftPrice,
  adjustmentSource: schAdjustSourcePercentage
});
var schCustomListToSaleRatioAdjustment = z75.object({
  source: z75.literal("customListToSale"),
  adjustmentAmount: schAloftPrice,
  adjustmentPercent: schAdjustSourcePercentage
});
var schDateOfSaleAdjustment = z75.discriminatedUnion("source", [
  schManualAdjustment,
  schCustomListToSaleRatioAdjustment,
  schCustomRateAdjustment
]);
var schMarketConditionsAdjustments = z75.strictObject({
  termsOfSale: schManualAdjustment,
  concessions: schManualAdjustment,
  dateOfSale: schDateOfSaleAdjustment
}).partial();
var schZillowDateOfSaleMethod = z75.object({
  zip: z75.string(),
  analysisPeriodMonths: z75.union([z75.literal(6), z75.literal(12), z75.literal(24)]),
  trends: z75.array(
    z75.object({
      data: schMarketTrends,
      timestamp: schAloftTime
    })
  )
});
var schMLSDataDateOfSaleMethod = z75.object({
  zip: z75.string(),
  analysisPeriodMonths: z75.union([z75.literal(6), z75.literal(12), z75.literal(24)]),
  trends: z75.array(
    z75.object({
      data: schMarketTrends,
      timestamp: schAloftTime
    })
  )
});
var schAvgPricePerMonthTrend = z75.object({
  year: z75.number(),
  month: z75.number(),
  typicalHomeValue: schAloftPrice
});
var schAvgPricePerMonthDateOfSaleMethod = z75.object({
  analysisPeriodMonths: z75.union([z75.literal(6), z75.literal(12), z75.literal(24)]),
  trends: z75.array(schAvgPricePerMonthTrend)
});
var schMarketTrendsDateOfSaleMethod = z75.object({
  series: schMarketTrendsSeriesResult,
  using: z75.enum(["p50closeprice", "p50closepricepersqft"])
  // subset of series.data keys
});
var schDateOfSaleAdjustmentMethods = z75.object({
  zillow: schZillowDateOfSaleMethod,
  mlsData: schMLSDataDateOfSaleMethod,
  marketTrends: schMarketTrendsDateOfSaleMethod,
  customRate: z75.object({
    rate: z75.number()
  }),
  customAvgPricePerMonth: schAvgPricePerMonthDateOfSaleMethod
}).partial();
var schListToSaleAdjustmentMethods = z75.object({
  customRatio: z75.object({
    ratio: z75.number()
  })
}).partial();
var schMarketConditionsCachedState = z75.object({
  dateOfSaleAdjustment: z75.object({
    selectedMethod: z75.enum([
      "zillow",
      "mlsData",
      "marketTrends",
      "customRate",
      "customAvgPricePerMonth"
    ]),
    methods: schDateOfSaleAdjustmentMethods
  }).partial(),
  listToSaleAdjustment: z75.object({
    selectedMethod: z75.enum(["customRatio"]),
    methods: schListToSaleAdjustmentMethods
  }).partial().optional(),
  marketAggregateData: z75.array(schAbodeAggregateMarketConditions).optional()
});

// src/tkv2OrderAttachments/schemas/marketConditions.ts
var marketConditions = z76.object({
  version: z76.literal(1),
  // compID mapping to adjustment info
  comps: z76.record(schMarketConditionsAdjustments).optional(),
  cachedState: schMarketConditionsCachedState
});

// src/tkv2OrderAttachments/schemas/priorSales.ts
import { z as z77 } from "zod";
var schPriorSales = z77.array(schConstellationOneListing);
var schPriorSalesEntities = z77.record(z77.string(), schPriorSales);
var schTkV2PriorSales = z77.object({
  version: z77.literal(1),
  priorSales: schPriorSalesEntities
});

// src/tkv2OrderAttachments/schemas/reconciliation.ts
import { schAloftPriceJSON as schAloftPriceJSON8 } from "@aloft/shared-objects";
import { z as z78 } from "zod";
var schReconciliation = z78.object({
  includeTotalCostToCure: z78.boolean().default(true),
  totalCostToCure: schAloftPriceJSON8.optional(),
  opinionOfMarketValue: schAloftPriceJSON8.optional(),
  includeOpinionOfAfterRepairValue: z78.boolean().default(false),
  opinionOfAfterRepairValue: schAloftPriceJSON8.optional(),
  totalRenovationBudget: schAloftPriceJSON8.optional(),
  includeTotalRenovationBudget: z78.boolean().default(false)
});

// src/tkv2OrderAttachments/schemas/report.ts
import { z as z79 } from "zod";
var schReport = z79.object({
  id: z79.string()
  // The S3 blob ID of the report PDF
});

// src/tkv2OrderAttachments/schemas/signature.ts
import { z as z80 } from "zod";
var schSignature = z80.object({
  signatureId: z80.string(),
  // The S3 blob ID of the signature image
  stateSealId: z80.string().optional()
  // The S3 blob ID of the state seal image, if applicable
});

// src/tkv2OrderAttachments/schemas/xml.ts
import { z as z81 } from "zod";
var xml = z81.object({
  id: z81.string()
});

// src/tkv2OrderAttachments/schemas/index.ts
var tkv2OrderAttachmentSchemas = {
  // Keep this alphabetized
  additionalFeatures,
  alerts: schAlerts,
  commentary: schCommentary,
  comp: schTkv2Property,
  compData: schPropertyData,
  compRecommendation: schCompRecommendationOutput,
  compSequence,
  depreciationSettings: schTkv2DepreciationSettings,
  depreciationSettingsV2: schDepreciationSettingsV2,
  imageAnalysis,
  marketAdjustments: schMarketAdjustments,
  marketConditions,
  orderFeatures: schOrderFeatures,
  pairedCostSettings: schTkv2PairedCostSettings,
  priorSales: schTkV2PriorSales,
  reconciliation: schReconciliation,
  replacementCostSettings: schTkv2ReplacementCostSettings,
  report: schReport,
  signature: schSignature,
  subject: schTkv2Property,
  subjectData: schSubjectData,
  vacantLandSales: schVacantLandSalesV1,
  xml
};
var ORDER_ATTACHMENT_CLONING_IGNORE_TYPES = [
  "xml",
  "signature",
  "report",
  "compSequence"
];
function isOrderAttachmentInstance(att, type) {
  return att.type === type && tkv2OrderAttachmentSchemas[type].safeParse(att.body).success;
}
function isOrderAttachmentType(type) {
  return type in tkv2OrderAttachmentSchemas;
}
var schTkv2OrderAttachment = z82.object({
  id: z82.string(),
  orderID: z82.string(),
  type: z82.string(),
  body: z82.unknown()
}).transform((obj, ctx) => {
  if (!isOrderAttachmentType(obj.type)) {
    ctx.addIssue({
      code: z82.ZodIssueCode.invalid_enum_value,
      message: "Invalid attachment type",
      fatal: true,
      received: obj.type,
      options: Object.keys(tkv2OrderAttachmentSchemas)
    });
    return z82.NEVER;
  }
  const res = tkv2OrderAttachmentSchemas[obj.type].safeParse(obj.body);
  if (!res.success) {
    ctx.addIssue({
      code: z82.ZodIssueCode.invalid_union,
      message: `Invalid attachment body for ${obj.type}`,
      fatal: true,
      unionErrors: [res.error]
    });
    return z82.NEVER;
  }
  return {
    id: obj.id,
    orderID: obj.orderID,
    type: obj.type,
    body: res.data
  };
});
var memo = {};
function schTkv2OrderAttachmentInstance(type) {
  const res = memo[type] ?? schTkv2OrderAttachment.refine((att) => att.type === type, {
    message: `Attachment is not of type ${type}`
  });
  memo[type] = res;
  return res;
}

// src/api/v2/imageAnalysis/index.ts
var IMAGE_ANALYSIS_API = {
  POST: {
    REQUEST: {
      BODY: schImageAnalysisQuery
    },
    RESPONSE: z83.object({
      content: schImageAnalysisResultContent
    })
  }
};
var PROPERTY_IMAGE_ANALYSIS_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z83.object({ orderID: schToolkitOrderID, propertyID: z83.string() })
    },
    RESPONSE: z83.object({
      content: schTkv2OrderAttachmentInstance("imageAnalysis")
    })
  }
};

// src/api/v2/orderAttachments/api.ts
var api_exports = {};
__export(api_exports, {
  ADDITIONAL_FEATURES: () => ADDITIONAL_FEATURES,
  ALERTS_API: () => ALERTS_API,
  COMMENTARY: () => COMMENTARY,
  COMPS: () => COMPS,
  COMP_DATA: () => COMP_DATA,
  COMP_IMAGES: () => COMP_IMAGES,
  COMP_PROPERTY_DATA: () => COMP_PROPERTY_DATA,
  COMP_RECOMMENDATION: () => COMP_RECOMMENDATION,
  COMP_SEQUENCE: () => COMP_SEQUENCE,
  MARKET_ADJUSTMENTS: () => MARKET_ADJUSTMENTS,
  MARKET_CONDITIONS: () => MARKET_CONDITIONS,
  ORDER_FEATURES_API: () => ORDER_FEATURES_API,
  PRIOR_SALES: () => PRIOR_SALES,
  RECONCILIATION: () => RECONCILIATION,
  REPORT: () => REPORT,
  REPORT_SIGNATURE: () => REPORT_SIGNATURE,
  SUBJECT: () => SUBJECT,
  SUBJECT_DATA: () => SUBJECT_DATA,
  SUBJECT_PROPERTY_DATA: () => SUBJECT_PROPERTY_DATA,
  VACANT_LAND_SALES: () => VACANT_LAND_SALES,
  XML: () => XML
});
import { z as z86 } from "zod";

// src/propertydata/utils/getAbbreviatedCarportGarage.ts
var import_shared_utils54 = __toESM(require_lib(), 1);
var getAbbreviatedCarportGarage = (improvements) => {
  const features = [
    { feature: improvements?.carport, suffix: "C" },
    { feature: improvements?.detachedGarage, suffix: "DG" },
    { feature: improvements?.garage, suffix: "AG" }
  ].filter(({ feature }) => (0, import_shared_utils54.isDefined)(feature) && (0, import_shared_utils54.isDefined)(feature.spaces) && feature.hasFeature && (feature.area?.unitAmount || 0) > 0).map(({ feature, suffix }) => `${feature.spaces} ${suffix}`);
  if (features.length === 0)
    return void 0;
  return features.join("; ");
};

// src/autofill/utils/editableArvDataFromAllSources.ts
function editableArvDataFromAllSources(aivEditableData) {
  const aivImprovements = aivEditableData.improvements;
  const aivEffectiveAge = aivImprovements.effectiveAge ?? 0;
  const arvEffectiveAge = Math.max(0, aivEffectiveAge - 10);
  const arvImprovements = {
    ...aivImprovements,
    effectiveAge: schPositiveInt.parse(arvEffectiveAge)
  };
  return {
    ...aivEditableData,
    improvements: arvImprovements
  };
}

// src/propertydata/utils/propertyDataToSubjectData.ts
var propertyDataToSubjectData = (propertyData, includeArv) => {
  let parsedSelectedSources = {};
  const { selectedSources } = propertyData;
  if (selectedSources) {
    const readonlyData = schReadonlyDataSelectedSources.strip().parse(selectedSources.readonlyData);
    parsedSelectedSources = { readonlyData };
    const { editableData } = selectedSources;
    if (editableData) {
      const transaction = schTransactionSelectedSources.strip().parse(editableData.transaction);
      const propertyIdentification = schPropertyIdentificationSelectedSources.strip().parse(editableData.propertyIdentification);
      const improvements = schImprovementsSelectedSources.strip().parse(editableData.improvements);
      const site = schSiteSelectedSources.strip().parse(editableData.site);
      const manualAdjustments = schManualAdjustmentsSelectedSources.strip().parse(editableData.manualAdjustments);
      parsedSelectedSources.editableData = {
        transaction,
        propertyIdentification,
        improvements,
        site,
        manualAdjustments
      };
    }
  }
  const subjectData = {
    $type: "PropertyData",
    version: 1,
    // Strip extra fields
    // We need to strip each field one by one since schSubjectData and schSelectedSources are wrapped by zodLaunder
    readonlyData: schReadOnlyData.strip().parse(propertyData.readonlyData),
    editableData: schEditablePropertyData.strip().parse(propertyData.editableData),
    selectedSources: parsedSelectedSources
  };
  const parsedSubjectData = schSubjectData.parse(subjectData);
  if (includeArv) {
    const arvSubjectData = editableArvDataFromAllSources(parsedSubjectData.editableData);
    parsedSubjectData.editableData.arv = {
      improvements: arvSubjectData.improvements
    };
  }
  return parsedSubjectData;
};

// src/propertydata/utils/getFoundationDisplay.ts
var getFoundationDisplay = (foundation) => {
  switch (foundation) {
    case "pierAndBeam":
      return "Pier and Beam";
    case "slab":
      return "Slab";
    default:
      return void 0;
  }
};

// src/propertydata/utils/getSiteDisplay.ts
var import_shared_utils55 = __toESM(require_lib(), 1);
import _3 from "lodash";
var PLACEHOLDER = "-";
var propertyToDisplay = (property) => property?.trim().length === 0 ? void 0 : property;
var propertyWithRatingToDisplay = (property, rating) => {
  const ratingDisplay = rating?.substring(0, 1).toUpperCase();
  const propertyDisplay = propertyToDisplay(property);
  if (!propertyDisplay && !ratingDisplay)
    return void 0;
  return [ratingDisplay, propertyDisplay].filter(import_shared_utils55.isDefined).join(";");
};
var getSiteDisplay = (site, costPerSf) => {
  const area = (0, import_shared_utils55.orUndefined)(schAloftArea.parse)(site?.area)?.getSiteAreaString();
  const influence = propertyWithRatingToDisplay(
    _3.startCase(site?.influence),
    site?.influenceRating
  );
  const view = propertyWithRatingToDisplay(_3.startCase(site?.view), site?.viewRating);
  const notes = propertyToDisplay(site?.notes);
  return {
    area: area ?? PLACEHOLDER,
    costPerSf: `${costPerSf ?? PLACEHOLDER}/sf`,
    influence: influence ?? PLACEHOLDER,
    notes: notes ?? PLACEHOLDER,
    view: view ?? PLACEHOLDER
  };
};

// src/propertydata/utils/propertyHasCustomManualAdjustments.ts
var import_shared_utils56 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice17 } from "@aloft/shared-objects";
var propertyHasCustomManualAdjustments = (manualAdjustments) => manualAdjustmentKeys.some((key) => {
  const customManualAdjustment = manualAdjustments?.[key];
  if (customManualAdjustment && ["concessions", "termsOfSale"].includes(key)) {
    return !schAloftPrice.parse(customManualAdjustment).equals(AloftPrice17.zero);
  }
  return (0, import_shared_utils56.isDefined)(customManualAdjustment);
});

// src/propertydata/utils/getDefaultCraftsmanQuality.ts
var getDefaultCraftsmanQuality = (propertyType) => {
  switch (propertyType) {
    case "multiFamily":
      return parseFloat(String(DEFAULT_CRAFTSMAN_QUALITY_MFR));
    case "manufacturedHome":
      return parseFloat(String(DEFAULT_CRAFTSMAN_QUALITY_MANUFACTURED));
    default:
      return parseFloat(String(DEFAULT_CRAFTSMAN_QUALITY));
  }
};

// src/propertydata/xmlPropertyResult.ts
import { schAloftAreaJSON as schAloftAreaJSON4, schAloftPriceJSON as schAloftPriceJSON9 } from "@aloft/shared-objects";
import { z as z84 } from "zod";
var schAdditionalFeature = z84.object({
  label: z84.string(),
  value: z84.string()
});
var schXMLPropertyResult = z84.object({
  address: schAddress,
  age: schPositiveInt,
  gla: schAloftAreaJSON4,
  numberOfUnits: schPositiveInt,
  fullBaths: schPositiveInt,
  halfBaths: schPositiveInt,
  basement: schBasementFields,
  garageSpaces: schParkingSpaceNumber,
  carportSpaces: schParkingSpaceNumber,
  status: fnma_exports.schUadListingStatus,
  foundation: schManufacturedHomeFoundation,
  price: schAloftPriceJSON9,
  saleDate: schIsoMonth,
  contractDate: schIsoMonth,
  daysOnMarket: z84.number(),
  latitude: z84.number(),
  longitude: z84.number(),
  mls: schMLSID,
  mlsListingID: z84.string(),
  siteArea: schAloftAreaJSON4,
  location: z84.string(),
  view: z84.string(),
  termsOfSale: schTermsOfSale,
  concessions: z84.string(),
  quality: z84.number(),
  condition: z84.number(),
  propertyType: schMainPropertyType,
  porchPatioDeck: z84.string(),
  additionalFeature1: schAdditionalFeature,
  additionalFeature2: schAdditionalFeature,
  additionalFeature3: schAdditionalFeature
}).partial();

// src/api/v2/types.ts
var orderIDPathParam = { orderID: schToolkitOrderID };

// src/api/v2/orderAttachments/types.ts
import { z as z85 } from "zod";

// src/tkv2Property/utils/getPropertyTypeSet.ts
var import_shared_utils57 = __toESM(require_lib(), 1);
function getPropertyTypeSet(subject, comps, compSeq) {
  const subjectPropertyType = subject.getPropertyType();
  const compsPropertyType = compSeq.map((compID) => comps[compID]).filter(import_shared_utils57.isDefined).map((comp) => comp.getPropertyType());
  const propertyTypeSet = new Set([subjectPropertyType, ...compsPropertyType].filter(import_shared_utils57.isDefined));
  return propertyTypeSet;
}

// src/api/v2/orderAttachments/types.ts
var schGetCompsResponse = z85.object({
  sequence: z85.array(z85.string()),
  comps: z85.record(schTkv2Property)
});
var schPostCompsBody = z85.object({
  comps: z85.array(schTkv2Property)
});
var schPostCompsResponse = z85.object({
  sequence: z85.array(z85.string()),
  comps: z85.record(schTkv2Property)
});
var schPostXMLAttachmentBody = z85.object({
  id: z85.string()
});
var schPostXMLAttachmentResponse = z85.object({
  id: z85.string()
});
var schAllCompDataResponse = z85.object({
  sequence: z85.array(z85.string()),
  comps: z85.record(schPropertyData)
});
var schCreateCompDataRequest = z85.object({
  comps: z85.array(schPropertyData)
});
var schUniqueOrderAttachmentType = z85.enum([
  "additionalFeatures",
  "alerts",
  "commentary",
  "compRecommendation",
  "compSequence",
  "depreciationSettings",
  "depreciationSettingsV2",
  "marketAdjustments",
  "marketConditions",
  "orderFeatures",
  "pairedCostSettings",
  "priorSales",
  "reconciliation",
  "replacementCostSettings",
  "report",
  "signature",
  "subject",
  "subjectData",
  "vacantLandSales"
]);
var UNIQUE_ORDER_ATTACHMENT_TYPES = schUniqueOrderAttachmentType.options;

// src/api/v2/orderAttachments/api.ts
var COMP_SEQUENCE = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("compSequence")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.compSequence
    },
    RESPONSE: schTkv2OrderAttachmentInstance("compSequence")
  }
};
var SUBJECT = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("subject")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: schTkv2Property
    },
    RESPONSE: schTkv2OrderAttachmentInstance("subject")
  }
};
var SUBJECT_DATA = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schSubjectData
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: schEditableSubjectData
    },
    RESPONSE: schSubjectData
  }
};
var SUBJECT_PROPERTY_DATA = {
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: schSubjectData
    },
    RESPONSE: schSubjectData
  }
};
var COMPS = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schGetCompsResponse
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: schPostCompsBody
    },
    RESPONSE: schPostCompsResponse
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object({
        ...orderIDPathParam,
        compID: z86.string()
      }),
      BODY: schTkv2Property
    },
    RESPONSE: schTkv2Property
  }
};
var COMP_DATA = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schAllCompDataResponse
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: schCreateCompDataRequest
    },
    RESPONSE: schAllCompDataResponse
  }
};
var COMP_PROPERTY_DATA = {
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object({
        ...orderIDPathParam,
        compID: z86.string()
      }),
      BODY: schPropertyData
    },
    RESPONSE: schPropertyData
  }
};
var MARKET_ADJUSTMENTS = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("marketAdjustments")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.marketAdjustments
    },
    RESPONSE: schTkv2OrderAttachmentInstance("marketAdjustments")
  }
};
var MARKET_CONDITIONS = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("marketConditions")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.marketConditions
    },
    RESPONSE: schTkv2OrderAttachmentInstance("marketConditions")
  }
};
var XML = {
  POST: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: schPostXMLAttachmentBody
    },
    RESPONSE: schPostXMLAttachmentResponse
  }
};
var ADDITIONAL_FEATURES = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("additionalFeatures")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.additionalFeatures
    },
    RESPONSE: schTkv2OrderAttachmentInstance("additionalFeatures")
  }
};
var ORDER_FEATURES_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("orderFeatures")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.orderFeatures
    },
    RESPONSE: schTkv2OrderAttachmentInstance("orderFeatures")
  }
};
var ALERTS_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("alerts")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.alerts
    },
    RESPONSE: schTkv2OrderAttachmentInstance("alerts")
  }
};
var PRIOR_SALES = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("priorSales")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.priorSales
    },
    RESPONSE: schTkv2OrderAttachmentInstance("priorSales")
  }
};
var COMMENTARY = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("commentary")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.commentary
    },
    RESPONSE: schTkv2OrderAttachmentInstance("commentary")
  }
};
var RECONCILIATION = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: schTkv2OrderAttachmentInstance("reconciliation")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: tkv2OrderAttachmentSchemas.reconciliation
    },
    RESPONSE: schTkv2OrderAttachmentInstance("reconciliation")
  }
};
var compRecommendation = z86.object({
  body: tkv2OrderAttachmentSchemas.compRecommendation
});
var COMP_RECOMMENDATION = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: z86.object({
      body: tkv2OrderAttachmentSchemas.compRecommendation
    })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      QUERY_PARAMS: z86.object({ source: z86.enum(["constellation1", "z"]) }),
      BODY: schCompsListingsSearchCriteria
    },
    RESPONSE: compRecommendation
  }
};
var COMP_IMAGES = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object({ id: z86.string() })
    },
    RESPONSE: z86.object({ id: z86.string(), images: z86.array(z86.string()) })
  }
};
var VACANT_LAND_SALES = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: z86.object({ body: tkv2OrderAttachmentSchemas.vacantLandSales })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: z86.object({ body: tkv2OrderAttachmentSchemas.vacantLandSales })
  }
};
var REPORT_SIGNATURE = {
  POST: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: z86.object({
        signatureBlobId: z86.string(),
        stateSealBlobId: z86.string().optional(),
        storeSignatureBlobId: z86.boolean().optional().default(false)
      })
    }
  }
};
var REPORT = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam)
    },
    RESPONSE: z86.object({
      body: schTkv2OrderAttachmentInstance("report")
    })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: z86.object(orderIDPathParam),
      BODY: z86.object({
        reportBlobId: z86.string()
      })
    }
  }
};

// src/api/v2/geocoding/api.ts
var api_exports2 = {};
__export(api_exports2, {
  COORDINATES_FOR_ADDRESSES: () => COORDINATES_FOR_ADDRESSES
});
import { z as z87 } from "zod";
var COORDINATES_FOR_ADDRESSES = {
  GET: {
    REQUEST: {
      QUERY_PARAMS: z87.object({
        addresses: z87.array(z87.string())
      })
    },
    RESPONSE: z87.array(
      z87.object({ address: z87.string(), lat: z87.number().optional(), lng: z87.number().optional() })
    )
  }
};

// src/api/v2/mls/types.ts
import { z as z88 } from "zod";
var schLookbackCutoffIsoString = z88.string();
var schMLSApiResponse = z88.object({
  listings: z88.array(schConstellationOneListing),
  source: schMLSSource
});

// src/api/v2/mls/api.ts
var TKV2_MLS_API = {
  GET: {
    REQUEST: {
      QUERY_PARAMS: schFilledAddress.extend({
        lookbackCutoff: schLookbackCutoffIsoString.optional()
      })
    },
    RESPONSE: schMLSApiResponse
  }
};

// src/api/v2/orders/index.ts
import { z as z92 } from "zod";

// src/craftsman/costDataset/schemas.ts
import { z as z89 } from "zod";
var schZipCode3 = z89.string();
var schZipMultiplier = z89.record(schZipCode3, z89.number());
var schHistoricalIndex = z89.record(z89.string(), z89.number());
var schVariableCostData = z89.object({
  variable: z89.array(z89.number())
});
var schFixedCostData = z89.object({
  fixed: z89.array(z89.number())
});
var schVarFixedCostData = z89.intersection(schVariableCostData, schFixedCostData);
var schSingleFamilyCost = z89.object({
  sixCorners: schVarFixedCostData
});
var schMultiFamilyCost = z89.object({
  twoOrThreeUnits: schVarFixedCostData,
  fourToNineUnits: schVarFixedCostData
});
var schManufacturedCost = schVarFixedCostData;
var schBathCost = z89.object({
  fullBaths: z89.array(z89.number()),
  halfBaths: z89.array(z89.number())
});
var schBasementCost = z89.object({
  totalArea: z89.object({
    variable: z89.array(z89.number())
  }),
  finishedArea: z89.object({
    variable: z89.array(z89.number())
  })
});
var schGarageCost = z89.object({
  detached: schVarFixedCostData,
  attached: schVarFixedCostData
});
var schCarportCost = schVariableCostData;
var schPoolCost = z89.object({
  fixed: z89.array(z89.number()),
  variable240To480: z89.array(z89.number()),
  variableOver480: z89.array(z89.number())
});
var schSpaCost = z89.object({
  fixed: z89.array(z89.number()),
  variableOver70: z89.array(z89.number())
});
var schShedCost = schVarFixedCostData;
var schWorkshopCost = schVarFixedCostData;
var schBarnCost = schVarFixedCostData;
var schAtticCost = schVariableCostData;
var schPorchCost = z89.object({
  uncovered: z89.object({
    variable: z89.array(z89.number())
  }),
  covered: z89.object({
    variable: z89.array(z89.number())
  }),
  screen: z89.object({
    variable: z89.array(z89.number())
  })
});
var schPatioCost = z89.object({
  uncovered: z89.object({
    variable: z89.array(z89.number())
  }),
  covered: z89.object({
    variable: z89.array(z89.number())
  }),
  screen: z89.object({
    variable: z89.array(z89.number())
  })
});
var schDeckCost = z89.object({
  uncovered: z89.object({
    variable: z89.array(z89.number())
  }),
  covered: z89.object({
    variable: z89.array(z89.number())
  }),
  screen: z89.object({
    variable: z89.array(z89.number())
  })
});
var schFireplaceCost = z89.object({
  freestanding: z89.number(),
  zeroClearance: z89.number(),
  masonry: z89.number()
});
var schManufacturedBathCost = z89.object({
  fullBaths: z89.array(z89.number()),
  halfBaths: z89.array(z89.number())
});
var schFoundationCost = z89.object({
  slab: z89.object({
    variable: z89.number()
  })
});
var schCraftsmanCostData = z89.object({
  singleFamily: schSingleFamilyCost,
  multiFamily: schMultiFamilyCost,
  manufactured: schManufacturedCost,
  bathrooms: schBathCost,
  basement: schBasementCost,
  attic: schAtticCost,
  garage: schGarageCost,
  carport: schCarportCost,
  heating: z89.number(),
  heatingAndCooling: z89.number(),
  pool: schPoolCost,
  spa: schSpaCost,
  shed: schShedCost,
  workshop: schWorkshopCost,
  barn: schBarnCost,
  porch: schPorchCost,
  patio: schPatioCost,
  deck: schDeckCost,
  fireplace: schFireplaceCost,
  manufacturedBaths: schManufacturedBathCost,
  foundation: schFoundationCost
});
var schCraftsmanCostDatasetVersion = z89.enum(["2024.1", "2025.1", "2026.1"]);
var schCraftsmanCostDataset = z89.object({
  version: schCraftsmanCostDatasetVersion,
  zipMultiplier: schZipMultiplier,
  costData: schCraftsmanCostData,
  historicalIndex: schHistoricalIndex
});

// src/craftsman/index.ts
var import_shared_utils65 = __toESM(require_lib(), 1);
import { AloftDate as AloftDate14 } from "@aloft/shared-objects";

// src/craftsman/adjustment/index.ts
var import_shared_utils60 = __toESM(require_lib(), 1);

// src/craftsman/adjustment/1.0/index.ts
var import_shared_utils59 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea18, AloftPrice as AloftPrice19 } from "@aloft/shared-objects";

// src/craftsman/adjustment/utils.ts
var import_shared_utils58 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice18 } from "@aloft/shared-objects";
import _4 from "lodash";
function calculateBasicAdjustment({
  subjectCost,
  compCost,
  subjectDepreciationRatio,
  compDepreciationRatio
}) {
  const subjectDepreciatedCost = subjectCost.mul(1 - subjectDepreciationRatio);
  const compDepreciatedCost = compCost.mul(1 - compDepreciationRatio);
  if (subjectDepreciatedCost.equals(compDepreciatedCost)) {
    return { adjustment: void 0 };
  }
  const adjustment = subjectDepreciatedCost.sub(compDepreciatedCost);
  return { adjustment };
}
function makeBasicAdjustmentFunction(costFunction) {
  return (calculator) => {
    return ({
      subject,
      comp,
      depreciationRatio,
      compDepreciationRatio
    }) => {
      if (_4.isEqual(subject, comp) && depreciationRatio === compDepreciationRatio) {
        return { adjustment: void 0 };
      }
      const fn = calculator[costFunction];
      const subjectCost = (0, import_shared_utils58.isDefined)(subject) ? fn(subject).totalCost : AloftPrice18.zero;
      const compCost = (0, import_shared_utils58.isDefined)(comp) ? fn(comp).totalCost : AloftPrice18.zero;
      return calculateBasicAdjustment({
        subjectCost,
        compCost,
        subjectDepreciationRatio: depreciationRatio,
        compDepreciationRatio
      });
    };
  };
}
function calculateScalarAdjustment({
  subjectVariableCost,
  unit,
  subjectAmount,
  compAmount,
  subjectDepreciationRatio
}) {
  const scalar = subjectVariableCost.mul(1 - subjectDepreciationRatio);
  const diff = subjectAmount - compAmount;
  const adjustment = diff === 0 ? void 0 : scalar.mul(diff);
  return { adjustment, scalar, unit };
}
function makeScalarAdjustmentFunction(costFunction, unitExtraction, unit) {
  return (calculator) => {
    return ({
      subject,
      comp,
      depreciationRatio
    }) => {
      const fn = calculator[costFunction];
      const subjectVariableCost = fn(subject).variable;
      if ((0, import_shared_utils58.isUndefined)(subjectVariableCost)) {
        throw new Error(`Unable to get cost for subject GLA to calculate adjustment`);
      }
      const subjectAmount = unitExtraction(subject);
      const compAmount = unitExtraction(comp);
      return calculateScalarAdjustment({
        subjectVariableCost,
        unit,
        subjectAmount,
        compAmount,
        subjectDepreciationRatio: depreciationRatio
      });
    };
  };
}

// src/craftsman/adjustment/1.0/index.ts
var CraftsmanAdjustmentsCalcV1 = {
  version: "1.0",
  getSFRGLAAdj: (calculator) => (
    // this cannot use the makeScalarAdjustmentFunction because we have to
    // pick the correct cost function based on property type. Otherwise it
    // is the same as all of the other scalar adjustments.
    ({ subject, comp, depreciationRatio }) => {
      const variableCost = subject.propertyType === "manufacturedHome" ? calculator.getManufacturedCost(subject).variable : calculator.getSFRCost(subject).variable;
      if ((0, import_shared_utils59.isUndefined)(variableCost)) {
        throw new Error(`Unable to get cost for subject GLA to calculate adjustment`);
      }
      return calculateScalarAdjustment({
        subjectVariableCost: variableCost,
        unit: "sqft",
        subjectAmount: subject.sqft.getUnitAmount("sqft"),
        compAmount: comp.sqft.getUnitAmount("sqft"),
        subjectDepreciationRatio: depreciationRatio
      });
    }
  ),
  getMultiFamilyGBAAdj: makeScalarAdjustmentFunction(
    "getMultiFamilyCost",
    getMultiFamilyGBAUnits,
    "sqft"
  ),
  getManufacturedGLAAdj: makeScalarAdjustmentFunction(
    "getManufacturedCost",
    getSqftUnits,
    "sqft"
  ),
  getFullBathsAdj: makeScalarAdjustmentFunction("getFullBathroomsCost", getFullBathUnits, "unit"),
  getHalfBathsAdj: makeScalarAdjustmentFunction("getHalfBathroomsCost", getHalfBathUnits, "unit"),
  getMultiFamilyUnitsAdj: (calculator) => (
    // this cannot use make scalar adjustment function because it uses fixed
    // rather than variable cost otherwise it is the same as all of the
    // other scalar adjustments.
    ({ subject, comp, depreciationRatio }) => {
      const subjectVariableCost = calculator.getMultiFamilyCost(subject).fixed?.div(subject.units);
      if ((0, import_shared_utils59.isUndefined)(subjectVariableCost)) {
        throw new Error(`Unable to get cost for subject units to calculate adjustment`);
      }
      const { units: subjectAmount } = subject;
      const { units: compAmount } = comp;
      return calculateScalarAdjustment({
        subjectVariableCost,
        unit: "unit",
        subjectAmount,
        compAmount,
        subjectDepreciationRatio: depreciationRatio
      });
    }
  ),
  getTotalBasementAreaAdj: makeScalarAdjustmentFunction(
    "getTotalBasementAreaCost",
    getTotalArea,
    "sqft"
  ),
  getFinishedBasementAreaAdj: makeScalarAdjustmentFunction(
    "getFinishedBasementAreaCost",
    getFinishedArea,
    "sqft"
  ),
  getFoundationAdj: makeScalarAdjustmentFunction("getFoundationCost", getFoundationUnits, "sqft"),
  // Grouped Adjustments (these are special ✨)
  getConditionAdj: () => ({ depreciationRatio, compDepreciationRatio, comp }) => {
    const { replacementCostNew } = comp;
    const depreciationDiff = compDepreciationRatio - depreciationRatio;
    const adjustment = depreciationDiff === 0 ? void 0 : replacementCostNew.mul(depreciationDiff);
    return { adjustment };
  },
  getQualityAdj: (calculator) => ({ subject, comp, depreciationRatio }) => {
    const { propertyType, quality } = subject;
    const { dwelling, basement, bathrooms, propertyType: compPropertyType } = comp;
    const compZipCode = compPropertyType === "manufacturedHome" ? comp.zipCode : comp.dwelling.zipCode;
    const defaultFoundation = {
      foundationType: "pierAndBeam",
      sqft: AloftArea18.zero,
      zipCode: compZipCode
    };
    const subjectFoundation = propertyType === "manufacturedHome" ? subject.foundation : defaultFoundation;
    const compFoundation = compPropertyType === "manufacturedHome" ? comp.foundation : defaultFoundation;
    const { quality: compQuality } = dwelling;
    const dwellingCostAtSubjectQuality = compPropertyType !== propertyType && compPropertyType === "singleFamilyResidence" ? _getMainDwellingCostWithQuality(
      quality,
      {
        propertyType: "manufacturedHome",
        zipCode: compZipCode,
        dwelling: {
          quality,
          sqft: dwelling.sqft
        },
        basement,
        bathrooms,
        foundation: subjectFoundation
      },
      calculator
    ) : _getMainDwellingCostWithQuality(quality, comp, calculator);
    const { totalArea, finishedArea } = basement;
    const { totalCost: totalBasementAreaCostAtSubjectQuality } = calculator.getTotalBasementAreaCost({
      totalArea,
      quality,
      propertyType,
      zipCode: basement.zipCode
    });
    const { totalCost: finishedBasementAreaCostAtSubjectQuality } = calculator.getFinishedBasementAreaCost({
      finishedArea,
      quality,
      propertyType,
      zipCode: basement.zipCode
    });
    const { fullBaths, halfBaths } = bathrooms;
    const { totalCost: fullBathCostAtSubjectQuality } = calculator.getFullBathroomsCost({
      fullBaths,
      quality,
      propertyType,
      zipCode: bathrooms.zipCode
    });
    const { totalCost: halfBathCostAtSubjectQuality } = calculator.getHalfBathroomsCost({
      halfBaths,
      quality,
      propertyType,
      zipCode: bathrooms.zipCode
    });
    const { totalCost: foundationAtSubjectQuality } = calculator.getFoundationCost(subjectFoundation);
    const costNewAtSubjectQuality = AloftPrice19.add(
      dwellingCostAtSubjectQuality,
      totalBasementAreaCostAtSubjectQuality,
      finishedBasementAreaCostAtSubjectQuality,
      fullBathCostAtSubjectQuality,
      halfBathCostAtSubjectQuality,
      foundationAtSubjectQuality
    );
    const dwellingCostAtCompQuality = _getMainDwellingCostWithQuality(
      compQuality,
      comp,
      calculator
    );
    const { totalCost: totalBasementAreaCostAtCompQuality } = calculator.getTotalBasementAreaCost(
      {
        totalArea,
        quality: compQuality,
        propertyType: compPropertyType,
        zipCode: basement.zipCode
      }
    );
    const { totalCost: finishedBasementAreaCostAtCompQuality } = calculator.getFinishedBasementAreaCost({
      finishedArea,
      quality: compQuality,
      propertyType: compPropertyType,
      zipCode: basement.zipCode
    });
    const { totalCost: fullBathCostAtCompQuality } = calculator.getFullBathroomsCost({
      fullBaths,
      quality: compQuality,
      propertyType: compPropertyType,
      zipCode: bathrooms.zipCode
    });
    const { totalCost: halfBathCostAtCompQuality } = calculator.getHalfBathroomsCost({
      halfBaths,
      quality: compQuality,
      propertyType: compPropertyType,
      zipCode: bathrooms.zipCode
    });
    const { totalCost: foundationAtCompQuality } = calculator.getFoundationCost(compFoundation);
    const costNewAtCompQuality = AloftPrice19.add(
      dwellingCostAtCompQuality,
      totalBasementAreaCostAtCompQuality,
      finishedBasementAreaCostAtCompQuality,
      fullBathCostAtCompQuality,
      halfBathCostAtCompQuality,
      foundationAtCompQuality
    );
    const differenceInCost = costNewAtSubjectQuality.sub(costNewAtCompQuality);
    const remainingEcoLife = Math.round((1 - depreciationRatio) * 1e3) / 1e3;
    const adjustment = differenceInCost.equals(AloftPrice19.zero) ? void 0 : differenceInCost.mul(remainingEcoLife);
    return {
      adjustment,
      costNewAtSubjectQuality,
      costNewAtCompQuality,
      differenceInCost,
      remainingEcoLife,
      compQuality
    };
  },
  // Additional Structures
  getGarageAdj: makeBasicAdjustmentFunction("getGarageCost"),
  getCarportAdj: makeBasicAdjustmentFunction("getCarportCost"),
  getPoolAdj: makeBasicAdjustmentFunction("getPoolCost"),
  getSpaAdj: makeBasicAdjustmentFunction("getSpaCost"),
  getBarnAdj: makeBasicAdjustmentFunction("getBarnCost"),
  getShedAdj: makeBasicAdjustmentFunction("getShedCost"),
  getWorkshopAdj: makeBasicAdjustmentFunction("getWorkshopCost"),
  getPorchAdj: makeBasicAdjustmentFunction("getPorchCost"),
  getPatioAdj: makeBasicAdjustmentFunction("getPatioCost"),
  getDeckAdj: makeBasicAdjustmentFunction("getDeckCost"),
  getFireplaceAdj: makeBasicAdjustmentFunction("getFireplaceCost"),
  getAtticAdj: makeBasicAdjustmentFunction("getAtticCost"),
  getADUAdj: makeBasicAdjustmentFunction("getADUCost")
};
function _getMainDwellingCostWithQuality(quality, costProps, calculator) {
  const { propertyType } = costProps;
  switch (propertyType) {
    case "singleFamilyResidence":
      return calculator.getSFRCost({ ...costProps.dwelling, quality }).totalCost;
    case "multiFamily":
      return calculator.getMultiFamilyCost({ ...costProps.dwelling, quality }).totalCost;
    case "manufacturedHome":
      return calculator.getManufacturedCost({ ...costProps.dwelling, quality }).totalCost;
    default:
      throw new Error(`Property type ${propertyType} not supported`);
  }
}
function getMultiFamilyGBAUnits(props) {
  const { avgUnitSqft, units } = props ?? {};
  return avgUnitSqft?.mul(units)?.getUnitAmount("sqft") ?? 0;
}
function getSqftUnits(props) {
  const { sqft } = props ?? {};
  return sqft?.getUnitAmount("sqft") ?? 0;
}
function getFoundationUnits(props) {
  const { sqft, foundationType } = props ?? {};
  return foundationType === "slab" ? sqft?.getUnitAmount("sqft") : 0;
}
function getFullBathUnits(props) {
  const { fullBaths } = props ?? {};
  return fullBaths ?? 0;
}
function getHalfBathUnits(props) {
  const { halfBaths } = props ?? {};
  return halfBaths ?? 0;
}
function getTotalArea(props) {
  const { totalArea } = props ?? {};
  return totalArea?.getUnitAmount("sqft") ?? 0;
}
function getFinishedArea(props) {
  const { finishedArea } = props ?? {};
  return finishedArea?.getUnitAmount("sqft") ?? 0;
}

// src/craftsman/adjustment/types.ts
import { z as z90 } from "zod";
var schCraftsmanAdjustmentsCalcVersion = z90.literal("1.0");

// src/craftsman/adjustment/index.ts
var CraftsmanAdjustmentCalculators = [
  CraftsmanAdjustmentsCalcV1
];
function getCraftsmanAdjustmentCalcInternal(version) {
  const calculator = CraftsmanAdjustmentCalculators.find(
    (calculator2) => calculator2.version === version
  );
  if ((0, import_shared_utils60.isUndefined)(calculator)) {
    throw new Error(`Craftsman Adjustment Calculator with version ${version} was not found`);
  }
  return calculator;
}

// src/craftsman/calculator/index.ts
var import_shared_utils64 = __toESM(require_lib(), 1);

// src/craftsman/calculator/1.0/index.ts
var import_shared_utils63 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea20, AloftPrice as AloftPrice21 } from "@aloft/shared-objects";

// src/craftsman/costDataset/index.ts
var import_shared_utils61 = __toESM(require_lib(), 1);

// src/craftsman/costDataset/2024.1/areaModifiers.ts
var CRAFTSMAN_ZIP_MODIFIER_2024 = {
  "10001": 28,
  "10002": 28,
  "10003": 31,
  "10004": 14,
  "10005": 14,
  "10006": 14,
  "10007": 25,
  "10008": 25,
  "10009": 29,
  "10010": 31,
  "10011": 31,
  "10012": 39,
  "10013": 25,
  "10014": 31,
  "10016": 31,
  "10017": 31,
  "10018": 31,
  "10019": 31,
  "10020": 31,
  "10021": 40,
  "10022": 33,
  "10023": 31,
  "10024": 39,
  "10025": 31,
  "10026": 28,
  "10027": 28,
  "10028": 40,
  "10029": 31,
  "10030": 31,
  "10031": 31,
  "10032": 13,
  "10033": 13,
  "10034": 13,
  "10035": 28,
  "10036": 31,
  "10037": 28,
  "10038": 14,
  "10039": 13,
  "10040": 13,
  "10041": 14,
  "10044": 28,
  "10045": 14,
  "10055": 33,
  "10060": 28,
  "10065": 40,
  "10069": 31,
  "10075": 40,
  "10090": 31,
  "10095": 28,
  "10098": 25,
  "10099": 28,
  "10101": 31,
  "10103": 31,
  "10104": 31,
  "10105": 33,
  "10106": 31,
  "10107": 31,
  "10108": 31,
  "10110": 29,
  "10111": 31,
  "10112": 31,
  "10113": 31,
  "10115": 28,
  "10116": 28,
  "10118": 28,
  "10119": 28,
  "10120": 28,
  "10121": 28,
  "10122": 28,
  "10123": 28,
  "10128": 40,
  "10129": 31,
  "10150": 33,
  "10151": 31,
  "10152": 33,
  "10153": 33,
  "10154": 33,
  "10155": 33,
  "10156": 31,
  "10158": 33,
  "10159": 31,
  "10161": 31,
  "10162": 40,
  "10163": 33,
  "10165": 31,
  "10166": 31,
  "10167": 31,
  "10168": 31,
  "10169": 31,
  "10170": 31,
  "10171": 33,
  "10172": 31,
  "10173": 31,
  "10174": 31,
  "10175": 31,
  "10176": 31,
  "10177": 31,
  "10178": 31,
  "10185": 31,
  "10199": 29,
  "10242": 25,
  "10249": 25,
  "10268": 14,
  "10270": 14,
  "10271": 14,
  "10272": 31,
  "10274": 14,
  "10276": 31,
  "10278": 25,
  "10279": 25,
  "10280": 17,
  "10281": 25,
  "10282": 25,
  "10301": 9,
  "10302": 9,
  "10303": 9,
  "10304": 9,
  "10305": 9,
  "10306": 9,
  "10307": 16,
  "10308": 9,
  "10309": 12,
  "10310": 9,
  "10311": 9,
  "10312": 9,
  "10313": 9,
  "10314": 9,
  "10451": 13,
  "10452": 13,
  "10453": 13,
  "10454": 13,
  "10455": 13,
  "10456": 13,
  "10457": 13,
  "10458": 13,
  "10459": 13,
  "10460": 13,
  "10461": 13,
  "10462": 13,
  "10463": 13,
  "10464": 15,
  "10465": 13,
  "10466": 13,
  "10467": 13,
  "10468": 13,
  "10469": 13,
  "10470": 13,
  "10471": 13,
  "10472": 13,
  "10473": 13,
  "10474": 13,
  "10475": 13,
  "10501": 8,
  "10502": 14,
  "10503": 14,
  "10504": 23,
  "10505": 8,
  "10506": 16,
  "10507": 8,
  "10509": 5,
  "10510": 14,
  "10511": 9,
  "10512": 5,
  "10514": 23,
  "10516": 6,
  "10517": 4,
  "10518": 8,
  "10519": 5,
  "10520": 12,
  "10521": 8,
  "10522": 14,
  "10523": 12,
  "10524": 13,
  "10526": 8,
  "10527": 8,
  "10528": 14,
  "10530": 12,
  "10532": 14,
  "10533": 14,
  "10535": 4,
  "10536": 10,
  "10537": 4,
  "10538": 17,
  "10540": 6,
  "10541": 5,
  "10542": 5,
  "10543": 14,
  "10545": 12,
  "10546": 14,
  "10547": 4,
  "10548": 8,
  "10549": 14,
  "10550": 13,
  "10551": 13,
  "10552": 13,
  "10553": 13,
  "10560": 8,
  "10562": 12,
  "10566": 6,
  "10567": 6,
  "10570": 14,
  "10573": 14,
  "10576": 13,
  "10577": 23,
  "10578": 6,
  "10579": 6,
  "10580": 23,
  "10583": 14,
  "10587": 8,
  "10588": 6,
  "10589": 6,
  "10590": 13,
  "10591": 14,
  "10594": 14,
  "10595": 14,
  "10596": 9,
  "10597": 17,
  "10598": 5,
  "10601": 11,
  "10602": 11,
  "10603": 11,
  "10604": 14,
  "10605": 14,
  "10606": 12,
  "10607": 12,
  "10610": 12,
  "10701": 13,
  "10702": 13,
  "10703": 13,
  "10704": 13,
  "10705": 13,
  "10706": 13,
  "10707": 14,
  "10708": 13,
  "10709": 14,
  "10710": 12,
  "10801": 13,
  "10802": 13,
  "10803": 15,
  "10804": 14,
  "10805": 13,
  "10901": 9,
  "10910": 1,
  "10911": 16,
  "10912": 1,
  "10913": 12,
  "10914": 1,
  "10915": 1,
  "10916": 1,
  "10917": 1,
  "10918": 1,
  "10919": 1,
  "10920": 9,
  "10921": 1,
  "10922": 4,
  "10923": 9,
  "10924": 1,
  "10925": 1,
  "10926": 1,
  "10927": 9,
  "10928": 4,
  "10930": 1,
  "10931": 9,
  "10932": 0,
  "10933": 1,
  "10940": 0,
  "10941": 0,
  "10949": 1,
  "10950": 1,
  "10952": 9,
  "10953": 1,
  "10954": 9,
  "10956": 12,
  "10958": 1,
  "10959": 1,
  "10960": 9,
  "10962": 9,
  "10963": 1,
  "10964": 14,
  "10965": 9,
  "10968": 14,
  "10969": 1,
  "10970": 9,
  "10973": 1,
  "10974": 9,
  "10975": 7,
  "10976": 12,
  "10977": 9,
  "10979": 1,
  "10980": 9,
  "10981": 1,
  "10982": 9,
  "10983": 9,
  "10984": 9,
  "10985": 16,
  "10986": 16,
  "10987": 19,
  "10988": 1,
  "10989": 9,
  "10990": 1,
  "10992": 1,
  "10993": 9,
  "10994": 12,
  "10996": 4,
  "10997": 4,
  "10998": 1,
  "11001": 13,
  "11002": 13,
  "11003": 13,
  "11004": 13,
  "11005": 16,
  "11010": 13,
  "11020": 16,
  "11021": 16,
  "11022": 16,
  "11023": 24,
  "11024": 24,
  "11026": 16,
  "11027": 24,
  "11030": 23,
  "11040": 15,
  "11042": 16,
  "11050": 15,
  "11096": 13,
  "11101": 29,
  "11102": 31,
  "11103": 31,
  "11104": 29,
  "11105": 31,
  "11106": 29,
  "11109": 29,
  "11201": 4,
  "11202": 4,
  "11203": 4,
  "11204": 7,
  "11205": 4,
  "11206": 4,
  "11207": 4,
  "11208": 13,
  "11209": 8,
  "11210": 4,
  "11211": 29,
  "11212": 4,
  "11213": 4,
  "11214": 7,
  "11215": 7,
  "11216": 4,
  "11217": 8,
  "11218": 4,
  "11219": 7,
  "11220": 4,
  "11221": 4,
  "11222": 29,
  "11223": 7,
  "11224": 4,
  "11225": 4,
  "11226": 4,
  "11228": 8,
  "11229": 4,
  "11230": 7,
  "11231": 6,
  "11232": 4,
  "11233": 4,
  "11234": 4,
  "11235": 4,
  "11236": 4,
  "11237": 4,
  "11238": 4,
  "11239": 4,
  "11240": 7,
  "11241": 4,
  "11242": 4,
  "11243": 8,
  "11247": 4,
  "11249": 28,
  "11252": 8,
  "11256": 13,
  "11351": 13,
  "11352": 14,
  "11354": 13,
  "11355": 14,
  "11356": 13,
  "11357": 16,
  "11358": 16,
  "11359": 14,
  "11360": 14,
  "11361": 16,
  "11362": 14,
  "11363": 16,
  "11364": 14,
  "11365": 16,
  "11366": 16,
  "11367": 14,
  "11368": 14,
  "11369": 13,
  "11370": 31,
  "11371": 14,
  "11372": 13,
  "11373": 14,
  "11374": 13,
  "11375": 13,
  "11377": 29,
  "11378": 14,
  "11379": 16,
  "11380": 13,
  "11385": 14,
  "11386": 14,
  "11411": 13,
  "11412": 13,
  "11413": 13,
  "11414": 16,
  "11415": 14,
  "11416": 14,
  "11417": 14,
  "11418": 14,
  "11419": 14,
  "11420": 13,
  "11421": 13,
  "11422": 14,
  "11423": 14,
  "11424": 14,
  "11426": 14,
  "11427": 14,
  "11428": 13,
  "11429": 13,
  "11430": 13,
  "11431": 14,
  "11432": 14,
  "11433": 13,
  "11434": 13,
  "11435": 13,
  "11436": 13,
  "11501": 13,
  "11507": 15,
  "11509": 17,
  "11510": 13,
  "11514": 13,
  "11516": 16,
  "11518": 13,
  "11520": 12,
  "11530": 13,
  "11531": 17,
  "11542": 13,
  "11545": 15,
  "11547": 15,
  "11548": 17,
  "11550": 12,
  "11551": 12,
  "11552": 13,
  "11553": 12,
  "11554": 13,
  "11556": 12,
  "11557": 15,
  "11558": 13,
  "11559": 24,
  "11560": 15,
  "11561": 13,
  "11563": 13,
  "11565": 13,
  "11566": 15,
  "11568": 23,
  "11569": 17,
  "11570": 15,
  "11571": 15,
  "11572": 15,
  "11575": 12,
  "11576": 15,
  "11577": 17,
  "11579": 15,
  "11580": 13,
  "11581": 14,
  "11582": 13,
  "11590": 13,
  "11596": 15,
  "11598": 16,
  "11599": 17,
  "11690": 14,
  "11691": 14,
  "11692": 13,
  "11693": 4,
  "11694": 7,
  "11695": 4,
  "11697": 4,
  "11701": 12,
  "11702": 13,
  "11703": 12,
  "11704": 12,
  "11705": 10,
  "11706": 13,
  "11707": 13,
  "11708": 12,
  "11709": 15,
  "11710": 13,
  "11713": 10,
  "11714": 13,
  "11715": 10,
  "11716": 10,
  "11717": 10,
  "11718": 11,
  "11719": 10,
  "11720": 10,
  "11721": 15,
  "11722": 10,
  "11724": 15,
  "11725": 11,
  "11726": 12,
  "11727": 10,
  "11729": 12,
  "11730": 10,
  "11731": 11,
  "11732": 15,
  "11733": 12,
  "11735": 12,
  "11737": 12,
  "11738": 10,
  "11739": 10,
  "11740": 13,
  "11741": 10,
  "11742": 10,
  "11743": 15,
  "11746": 13,
  "11747": 15,
  "11749": 11,
  "11751": 10,
  "11752": 10,
  "11753": 15,
  "11754": 11,
  "11755": 10,
  "11756": 12,
  "11757": 12,
  "11758": 13,
  "11760": 11,
  "11762": 13,
  "11763": 10,
  "11764": 10,
  "11765": 23,
  "11766": 10,
  "11767": 11,
  "11768": 13,
  "11769": 11,
  "11770": 13,
  "11771": 15,
  "11772": 10,
  "11776": 10,
  "11777": 10,
  "11778": 10,
  "11779": 10,
  "11780": 11,
  "11782": 11,
  "11783": 13,
  "11784": 10,
  "11786": 10,
  "11787": 11,
  "11788": 11,
  "11789": 10,
  "11790": 10,
  "11791": 15,
  "11792": 10,
  "11793": 13,
  "11795": 13,
  "11796": 10,
  "11797": 15,
  "11798": 12,
  "11801": 13,
  "11802": 13,
  "11803": 15,
  "11804": 13,
  "11901": 9,
  "11930": 8,
  "11931": 10,
  "11932": 16,
  "11933": 9,
  "11934": 10,
  "11935": 9,
  "11937": 5,
  "11939": 5,
  "11940": 10,
  "11941": 10,
  "11942": 10,
  "11944": 5,
  "11946": 12,
  "11947": 10,
  "11948": 10,
  "11949": 10,
  "11950": 9,
  "11951": 9,
  "11952": 10,
  "11953": 9,
  "11954": 8,
  "11955": 10,
  "11956": 9,
  "11957": 8,
  "11958": 9,
  "11959": 21,
  "11960": 10,
  "11961": 9,
  "11962": 16,
  "11963": 8,
  "11964": 5,
  "11965": 8,
  "11967": 9,
  "11968": 12,
  "11969": 8,
  "11970": 10,
  "11971": 5,
  "11972": 10,
  "11973": 9,
  "11975": 16,
  "11976": 20,
  "11977": 12,
  "11978": 12,
  "11980": 9,
  "12007": -8,
  "12008": 3,
  "12009": 11,
  "12010": -10,
  "12015": -4,
  "12016": -10,
  "12017": -4,
  "12018": 6,
  "12019": 4,
  "12020": 7,
  "12022": 4,
  "12023": 2,
  "12024": 5,
  "12025": -4,
  "12027": 4,
  "12028": 4,
  "12029": 0,
  "12031": -10,
  "12032": -4,
  "12033": 16,
  "12035": 2,
  "12036": 2,
  "12037": -4,
  "12040": 4,
  "12041": 15,
  "12042": -8,
  "12043": 2,
  "12045": 15,
  "12046": -8,
  "12047": 4,
  "12050": -4,
  "12051": -8,
  "12052": 4,
  "12053": 3,
  "12054": 17,
  "12055": -8,
  "12056": 3,
  "12057": 4,
  "12058": -8,
  "12059": 14,
  "12060": -4,
  "12061": 5,
  "12062": 5,
  "12063": 5,
  "12064": 2,
  "12065": 11,
  "12066": -10,
  "12067": 15,
  "12068": -10,
  "12069": -10,
  "12070": -10,
  "12071": 2,
  "12072": -10,
  "12073": 2,
  "12074": 7,
  "12075": -4,
  "12076": 2,
  "12077": 24,
  "12078": -6,
  "12082": 4,
  "12083": -8,
  "12084": 24,
  "12085": 11,
  "12086": -5,
  "12087": -8,
  "12089": 4,
  "12090": 4,
  "12092": 2,
  "12093": 2,
  "12094": 4,
  "12095": -6,
  "12106": -2,
  "12107": 2,
  "12108": -16,
  "12110": 23,
  "12115": 5,
  "12116": -7,
  "12117": -4,
  "12118": 6,
  "12120": -8,
  "12121": 4,
  "12122": 2,
  "12123": 5,
  "12124": 15,
  "12125": 0,
  "12128": 24,
  "12130": -4,
  "12131": 2,
  "12132": -4,
  "12133": 4,
  "12134": -4,
  "12136": 5,
  "12137": 3,
  "12138": 4,
  "12139": -15,
  "12140": 4,
  "12141": 3,
  "12143": 15,
  "12144": 15,
  "12147": 3,
  "12148": 11,
  "12149": 2,
  "12150": 3,
  "12151": 7,
  "12153": 4,
  "12154": 5,
  "12155": -7,
  "12156": 16,
  "12157": 2,
  "12158": 15,
  "12159": 24,
  "12160": 2,
  "12161": 15,
  "12164": -16,
  "12165": -4,
  "12166": -10,
  "12167": 2,
  "12168": 5,
  "12169": 5,
  "12170": 6,
  "12172": -4,
  "12173": -4,
  "12174": -4,
  "12175": 2,
  "12176": -8,
  "12177": -10,
  "12180": 4,
  "12181": 4,
  "12182": 4,
  "12183": 4,
  "12184": -4,
  "12185": 4,
  "12186": 16,
  "12187": 2,
  "12188": 4,
  "12189": 4,
  "12190": -16,
  "12192": -8,
  "12193": 15,
  "12194": 2,
  "12195": 0,
  "12196": 13,
  "12197": 2,
  "12198": 5,
  "12201": 15,
  "12202": 15,
  "12203": 15,
  "12204": 15,
  "12205": 15,
  "12206": 15,
  "12207": 15,
  "12208": 15,
  "12209": 15,
  "12210": 15,
  "12211": 24,
  "12212": 15,
  "12220": 24,
  "12223": 15,
  "12224": 15,
  "12225": 15,
  "12226": 15,
  "12247": 15,
  "12260": 15,
  "12301": 3,
  "12302": 3,
  "12303": 3,
  "12304": 2,
  "12305": 3,
  "12306": 3,
  "12307": 2,
  "12308": 2,
  "12309": 11,
  "12325": 3,
  "12401": -1,
  "12402": -1,
  "12404": 0,
  "12405": -8,
  "12406": 1,
  "12407": -8,
  "12409": 0,
  "12410": -1,
  "12411": -1,
  "12412": 0,
  "12413": -8,
  "12414": -8,
  "12416": 0,
  "12417": -1,
  "12418": -8,
  "12419": -1,
  "12420": -1,
  "12421": 1,
  "12422": -8,
  "12423": -8,
  "12424": -8,
  "12427": -8,
  "12428": 16,
  "12429": 0,
  "12430": 1,
  "12431": -8,
  "12432": -1,
  "12433": 0,
  "12434": 3,
  "12435": 17,
  "12436": -8,
  "12438": 1,
  "12439": -8,
  "12440": 0,
  "12441": -1,
  "12442": -8,
  "12443": 0,
  "12444": -8,
  "12446": -1,
  "12448": 0,
  "12449": -1,
  "12450": -8,
  "12451": -8,
  "12452": -8,
  "12453": -8,
  "12454": -8,
  "12455": 1,
  "12456": -1,
  "12457": 0,
  "12458": -1,
  "12459": 2,
  "12460": -8,
  "12461": 0,
  "12463": -8,
  "12464": 0,
  "12465": -1,
  "12466": -1,
  "12468": -8,
  "12469": -8,
  "12470": -8,
  "12471": -1,
  "12472": -1,
  "12473": -8,
  "12474": 1,
  "12475": -1,
  "12477": -8,
  "12480": -8,
  "12481": 0,
  "12482": -8,
  "12483": -1,
  "12484": 0,
  "12485": -8,
  "12486": -1,
  "12487": 0,
  "12489": -1,
  "12490": -8,
  "12491": 0,
  "12492": -8,
  "12493": 0,
  "12494": 0,
  "12495": 0,
  "12496": -8,
  "12498": 0,
  "12501": 5,
  "12502": -3,
  "12503": -3,
  "12504": 10,
  "12506": 5,
  "12507": 0,
  "12508": 4,
  "12510": 5,
  "12511": 4,
  "12512": 4,
  "12513": -4,
  "12514": 5,
  "12515": 0,
  "12516": -4,
  "12517": -4,
  "12518": 1,
  "12520": 1,
  "12521": -4,
  "12522": 5,
  "12523": -3,
  "12524": 4,
  "12525": 0,
  "12526": -3,
  "12527": 4,
  "12528": 5,
  "12529": -4,
  "12530": -4,
  "12531": 5,
  "12533": 5,
  "12534": -4,
  "12537": 5,
  "12538": 5,
  "12540": 5,
  "12541": -3,
  "12542": 5,
  "12543": 0,
  "12544": -4,
  "12545": 5,
  "12546": -3,
  "12547": 5,
  "12548": 0,
  "12549": 1,
  "12550": 1,
  "12551": 1,
  "12552": 1,
  "12553": 1,
  "12555": 1,
  "12561": 0,
  "12563": 5,
  "12564": 5,
  "12565": -4,
  "12566": 1,
  "12567": -3,
  "12568": 5,
  "12569": 5,
  "12570": 5,
  "12571": 0,
  "12572": 0,
  "12574": -1,
  "12575": 1,
  "12577": 1,
  "12578": 5,
  "12580": 5,
  "12581": 5,
  "12582": 5,
  "12583": -8,
  "12584": 1,
  "12585": 5,
  "12586": 1,
  "12588": -1,
  "12589": 1,
  "12590": 5,
  "12592": 5,
  "12593": -4,
  "12594": 6,
  "12601": 5,
  "12602": 5,
  "12603": 5,
  "12701": 16,
  "12719": -10,
  "12720": 16,
  "12721": 0,
  "12722": 17,
  "12723": 15,
  "12724": 16,
  "12725": 17,
  "12726": 16,
  "12727": 15,
  "12729": 0,
  "12732": 15,
  "12733": 16,
  "12734": 16,
  "12736": 16,
  "12737": 16,
  "12738": 16,
  "12740": 17,
  "12741": 15,
  "12742": 16,
  "12743": 17,
  "12745": 15,
  "12746": 0,
  "12747": 16,
  "12748": 16,
  "12749": 16,
  "12750": 15,
  "12751": 16,
  "12752": 15,
  "12754": 16,
  "12758": 17,
  "12759": 16,
  "12760": 15,
  "12762": 16,
  "12763": 16,
  "12764": 15,
  "12765": 17,
  "12766": 15,
  "12767": 16,
  "12768": 17,
  "12769": -1,
  "12770": 16,
  "12771": 0,
  "12775": 16,
  "12776": 0,
  "12777": 16,
  "12778": 16,
  "12779": 16,
  "12780": 16,
  "12781": 16,
  "12783": 16,
  "12784": 27,
  "12785": 16,
  "12786": 16,
  "12787": 16,
  "12788": 17,
  "12789": 16,
  "12790": 16,
  "12791": 15,
  "12792": -10,
  "12801": 0,
  "12803": 0,
  "12804": 2,
  "12808": 2,
  "12809": 0,
  "12810": 1,
  "12811": 1,
  "12812": -16,
  "12814": 2,
  "12815": 1,
  "12816": 2,
  "12817": 1,
  "12819": 13,
  "12820": 10,
  "12821": 0,
  "12822": 4,
  "12823": 1,
  "12824": 2,
  "12827": 0,
  "12828": 0,
  "12831": 7,
  "12832": 0,
  "12833": 7,
  "12834": 2,
  "12835": 1,
  "12836": 1,
  "12837": 0,
  "12838": 0,
  "12839": 0,
  "12841": 13,
  "12842": -16,
  "12843": 1,
  "12844": 10,
  "12845": 2,
  "12846": 1,
  "12847": -16,
  "12848": 2,
  "12849": 0,
  "12850": 7,
  "12851": 1,
  "12852": -7,
  "12853": 1,
  "12854": 0,
  "12855": -5,
  "12856": -15,
  "12857": 1,
  "12858": -7,
  "12859": 6,
  "12860": 1,
  "12861": 1,
  "12862": 1,
  "12863": 7,
  "12864": -16,
  "12865": 0,
  "12866": 15,
  "12870": -7,
  "12871": 6,
  "12872": -7,
  "12873": 0,
  "12874": 13,
  "12878": 1,
  "12879": -7,
  "12883": -7,
  "12884": 6,
  "12885": 1,
  "12886": 1,
  "12887": 0,
  "12901": 11,
  "12903": 11,
  "12910": 11,
  "12911": 11,
  "12912": 11,
  "12913": -6,
  "12914": -6,
  "12915": -6,
  "12916": -6,
  "12917": -6,
  "12918": 11,
  "12919": -6,
  "12920": -6,
  "12921": -6,
  "12922": -3,
  "12923": 11,
  "12924": 4,
  "12926": -6,
  "12927": -1,
  "12928": -5,
  "12929": 11,
  "12930": -6,
  "12932": -5,
  "12933": 11,
  "12934": 11,
  "12935": 11,
  "12936": -5,
  "12937": -6,
  "12939": -6,
  "12941": -5,
  "12942": -5,
  "12943": -5,
  "12944": 4,
  "12945": -6,
  "12946": -5,
  "12949": -6,
  "12950": -5,
  "12952": 11,
  "12953": -6,
  "12955": 11,
  "12956": -5,
  "12957": -6,
  "12958": 11,
  "12959": 11,
  "12960": -5,
  "12961": -5,
  "12962": 11,
  "12964": -5,
  "12965": -6,
  "12966": -6,
  "12967": -6,
  "12969": -6,
  "12970": -6,
  "12972": 11,
  "12973": -6,
  "12974": -5,
  "12975": 11,
  "12976": -6,
  "12977": -6,
  "12978": 11,
  "12979": -6,
  "12980": -6,
  "12981": 11,
  "12983": -6,
  "12985": 11,
  "12986": -6,
  "12987": -5,
  "12989": -6,
  "12992": 11,
  "12993": -5,
  "12995": -6,
  "12996": 4,
  "12997": -5,
  "12998": -5,
  "13020": 0,
  "13021": -5,
  "13022": -5,
  "13026": -1,
  "13027": 5,
  "13028": 3,
  "13029": 5,
  "13030": 5,
  "13031": 5,
  "13032": -2,
  "13033": -5,
  "13034": -5,
  "13035": 6,
  "13036": 3,
  "13037": -2,
  "13039": 5,
  "13040": -1,
  "13041": 5,
  "13042": 5,
  "13043": -2,
  "13044": 3,
  "13045": -1,
  "13051": -2,
  "13052": -1,
  "13053": -7,
  "13054": -5,
  "13056": -1,
  "13057": 5,
  "13060": -5,
  "13061": -2,
  "13062": -7,
  "13063": -2,
  "13064": 2,
  "13065": -1,
  "13066": 13,
  "13068": -7,
  "13069": 3,
  "13071": -7,
  "13072": -2,
  "13073": -7,
  "13074": 2,
  "13076": 3,
  "13077": -1,
  "13078": 13,
  "13080": -5,
  "13081": -1,
  "13082": 5,
  "13083": 3,
  "13084": 5,
  "13087": -1,
  "13088": 5,
  "13089": 5,
  "13090": 5,
  "13092": -7,
  "13093": 3,
  "13101": -1,
  "13102": -7,
  "13103": 3,
  "13104": 13,
  "13107": 3,
  "13108": 5,
  "13110": 5,
  "13111": 2,
  "13112": 5,
  "13113": -5,
  "13114": 3,
  "13115": 3,
  "13116": 5,
  "13117": -5,
  "13118": -5,
  "13119": -5,
  "13120": 5,
  "13121": 3,
  "13122": -2,
  "13123": -5,
  "13124": -1,
  "13126": 3,
  "13131": 3,
  "13132": 3,
  "13134": -2,
  "13135": 3,
  "13136": -1,
  "13137": 5,
  "13138": -2,
  "13139": -5,
  "13140": -5,
  "13141": -1,
  "13142": 3,
  "13143": -5,
  "13144": 2,
  "13145": 3,
  "13146": -5,
  "13147": -5,
  "13148": -1,
  "13152": 4,
  "13153": -5,
  "13154": -5,
  "13155": -8,
  "13156": 2,
  "13157": -5,
  "13158": -1,
  "13159": 0,
  "13160": -1,
  "13162": -5,
  "13163": -2,
  "13164": 5,
  "13165": -2,
  "13166": -5,
  "13167": 3,
  "13201": 5,
  "13202": 5,
  "13203": 5,
  "13204": 5,
  "13205": 5,
  "13206": 5,
  "13207": 5,
  "13208": 5,
  "13209": 5,
  "13210": 5,
  "13211": 5,
  "13212": 5,
  "13214": 5,
  "13215": 13,
  "13217": 5,
  "13218": 5,
  "13219": 5,
  "13220": 5,
  "13221": 5,
  "13224": 5,
  "13235": 5,
  "13261": 5,
  "13290": 5,
  "13301": -5,
  "13302": 2,
  "13303": -5,
  "13304": 3,
  "13305": -2,
  "13308": -5,
  "13309": -2,
  "13310": -3,
  "13312": -2,
  "13313": -7,
  "13314": -3,
  "13315": -7,
  "13316": -5,
  "13317": -10,
  "13318": -5,
  "13319": -5,
  "13320": 2,
  "13321": -5,
  "13322": -5,
  "13323": -5,
  "13324": 2,
  "13325": -2,
  "13326": 2,
  "13327": -2,
  "13328": -3,
  "13329": 2,
  "13331": -8,
  "13332": -3,
  "13333": -7,
  "13334": -3,
  "13335": -7,
  "13337": 2,
  "13338": -5,
  "13339": -10,
  "13340": 2,
  "13341": -5,
  "13342": -6,
  "13343": -2,
  "13345": -2,
  "13346": -1,
  "13348": -6,
  "13350": 2,
  "13352": 3,
  "13353": -16,
  "13354": -5,
  "13355": -3,
  "13357": 2,
  "13360": -8,
  "13361": 2,
  "13362": -3,
  "13363": -5,
  "13364": -3,
  "13365": 2,
  "13367": -2,
  "13368": -3,
  "13401": -5,
  "13402": -3,
  "13403": -5,
  "13404": -2,
  "13406": 2,
  "13407": 2,
  "13408": -2,
  "13409": -2,
  "13410": -10,
  "13411": -7,
  "13413": -4,
  "13415": -6,
  "13416": 2,
  "13417": -5,
  "13418": -3,
  "13420": -8,
  "13421": -2,
  "13424": -5,
  "13425": -3,
  "13426": 2,
  "13428": -10,
  "13431": 2,
  "13433": -3,
  "13435": 2,
  "13436": -8,
  "13437": -3,
  "13438": 2,
  "13439": -7,
  "13440": -5,
  "13441": -5,
  "13442": -5,
  "13450": -7,
  "13452": -10,
  "13454": 2,
  "13455": -3,
  "13456": -5,
  "13457": 2,
  "13459": 2,
  "13460": -8,
  "13461": 0,
  "13464": -8,
  "13465": -3,
  "13468": -7,
  "13469": -5,
  "13470": 2,
  "13471": -5,
  "13472": -8,
  "13473": -2,
  "13475": 2,
  "13476": -5,
  "13477": -2,
  "13478": -5,
  "13479": -4,
  "13480": -3,
  "13482": -7,
  "13483": 2,
  "13484": -3,
  "13485": -7,
  "13486": -5,
  "13488": -7,
  "13489": -5,
  "13490": -5,
  "13491": -7,
  "13492": -5,
  "13493": 2,
  "13494": -5,
  "13495": -5,
  "13501": -5,
  "13502": -5,
  "13503": -5,
  "13504": -5,
  "13505": -5,
  "13601": -3,
  "13602": -3,
  "13603": -3,
  "13605": -3,
  "13606": -3,
  "13607": -3,
  "13608": -3,
  "13611": -3,
  "13612": -3,
  "13613": 0,
  "13614": -3,
  "13615": -3,
  "13616": -3,
  "13617": 0,
  "13618": -3,
  "13619": -3,
  "13620": -2,
  "13621": 0,
  "13622": -3,
  "13623": -3,
  "13624": -3,
  "13625": 0,
  "13626": -2,
  "13627": -3,
  "13628": -3,
  "13630": -3,
  "13631": -3,
  "13632": -3,
  "13633": -3,
  "13634": -3,
  "13635": -3,
  "13636": 3,
  "13637": -3,
  "13638": -3,
  "13639": -3,
  "13640": 6,
  "13641": 6,
  "13642": -3,
  "13643": -3,
  "13645": -3,
  "13646": -3,
  "13647": 0,
  "13648": -3,
  "13649": 0,
  "13650": -3,
  "13651": -3,
  "13652": -3,
  "13654": -3,
  "13655": -6,
  "13656": -3,
  "13657": -3,
  "13658": 0,
  "13659": -3,
  "13660": 0,
  "13661": 3,
  "13662": 0,
  "13664": -3,
  "13665": -3,
  "13666": -3,
  "13667": 0,
  "13668": 0,
  "13669": -3,
  "13670": -3,
  "13671": -3,
  "13672": 0,
  "13673": -3,
  "13674": 3,
  "13675": -3,
  "13676": 0,
  "13677": 0,
  "13678": 0,
  "13679": -3,
  "13680": -3,
  "13681": -3,
  "13682": -3,
  "13683": -6,
  "13684": -3,
  "13685": -3,
  "13687": 0,
  "13690": -3,
  "13691": -3,
  "13692": 6,
  "13693": -3,
  "13694": 0,
  "13695": -3,
  "13696": 0,
  "13697": 0,
  "13730": -8,
  "13731": 1,
  "13732": -8,
  "13733": -8,
  "13734": -8,
  "13736": -8,
  "13737": -8,
  "13738": -1,
  "13739": 0,
  "13740": 0,
  "13743": -8,
  "13744": 1,
  "13745": 1,
  "13746": 1,
  "13747": -7,
  "13748": 1,
  "13749": 1,
  "13750": -7,
  "13751": -1,
  "13752": 0,
  "13753": 0,
  "13754": 1,
  "13755": -1,
  "13756": -1,
  "13757": -1,
  "13758": -8,
  "13760": 1,
  "13761": 1,
  "13762": 1,
  "13763": 1,
  "13774": -1,
  "13775": 0,
  "13776": -8,
  "13777": 0,
  "13778": -8,
  "13780": -8,
  "13782": 0,
  "13783": -1,
  "13784": -1,
  "13786": 2,
  "13787": 0,
  "13788": 0,
  "13790": 1,
  "13794": -1,
  "13795": 1,
  "13796": -7,
  "13797": 0,
  "13801": -8,
  "13802": 1,
  "13803": -1,
  "13804": 0,
  "13806": -1,
  "13807": -7,
  "13808": -7,
  "13809": -8,
  "13810": -6,
  "13811": -8,
  "13812": -8,
  "13813": 1,
  "13814": -8,
  "13815": -8,
  "13820": -7,
  "13825": -6,
  "13826": 1,
  "13827": -8,
  "13830": -8,
  "13832": -8,
  "13833": 1,
  "13834": -7,
  "13835": -1,
  "13837": -1,
  "13838": -8,
  "13839": 0,
  "13840": -8,
  "13841": -8,
  "13842": 0,
  "13843": -8,
  "13844": -8,
  "13845": -8,
  "13846": 0,
  "13847": -1,
  "13848": 1,
  "13849": -8,
  "13850": 1,
  "13851": 1,
  "13856": -1,
  "13859": -1,
  "13860": -1,
  "13861": -6,
  "13862": 1,
  "13863": -1,
  "13864": -9,
  "13865": 1,
  "13901": 1,
  "13902": 1,
  "13903": 1,
  "13904": 1,
  "13905": 1,
  "14001": -6,
  "14004": 1,
  "14005": -6,
  "14006": 0,
  "14008": -6,
  "14009": -10,
  "14010": 0,
  "14011": -10,
  "14012": -8,
  "14013": -6,
  "14020": -6,
  "14021": -6,
  "14024": -10,
  "14025": 1,
  "14026": 1,
  "14027": 0,
  "14028": -6,
  "14029": -10,
  "14030": -10,
  "14031": 9,
  "14032": 9,
  "14033": 1,
  "14034": -2,
  "14035": -2,
  "14036": -6,
  "14037": -10,
  "14038": 1,
  "14039": -10,
  "14040": -6,
  "14041": -2,
  "14042": -2,
  "14043": 0,
  "14047": 0,
  "14048": -5,
  "14051": 2,
  "14052": 2,
  "14054": -6,
  "14055": -2,
  "14056": -6,
  "14057": 1,
  "14058": -6,
  "14059": 9,
  "14060": -10,
  "14061": 0,
  "14062": -5,
  "14063": 3,
  "14065": -10,
  "14066": -10,
  "14067": -6,
  "14068": 2,
  "14069": 1,
  "14070": -2,
  "14072": 2,
  "14075": 1,
  "14080": -9,
  "14081": 0,
  "14082": -9,
  "14083": -10,
  "14085": 1,
  "14086": 1,
  "14091": 0,
  "14092": -6,
  "14094": -6,
  "14095": -6,
  "14098": -8,
  "14101": -2,
  "14102": 1,
  "14103": -8,
  "14105": -8,
  "14107": -6,
  "14108": -6,
  "14109": -6,
  "14110": 1,
  "14111": 0,
  "14112": 0,
  "14113": -10,
  "14120": -6,
  "14125": -6,
  "14126": -6,
  "14127": 9,
  "14129": -5,
  "14130": -10,
  "14131": -6,
  "14132": -6,
  "14133": -10,
  "14134": -10,
  "14135": -5,
  "14136": -5,
  "14138": -5,
  "14139": 1,
  "14140": 9,
  "14141": -2,
  "14143": -6,
  "14144": -6,
  "14145": -9,
  "14150": -6,
  "14151": -6,
  "14166": -5,
  "14167": -10,
  "14168": -5,
  "14169": 1,
  "14170": 1,
  "14171": -2,
  "14172": -6,
  "14173": -10,
  "14174": -6,
  "14201": 0,
  "14202": 9,
  "14203": 0,
  "14204": 0,
  "14205": 9,
  "14206": 0,
  "14207": 0,
  "14208": 0,
  "14209": 0,
  "14210": 0,
  "14211": 0,
  "14212": 0,
  "14213": 0,
  "14214": 0,
  "14215": 0,
  "14216": 0,
  "14217": 0,
  "14218": 1,
  "14219": 0,
  "14220": 0,
  "14221": 1,
  "14222": 1,
  "14223": 0,
  "14224": 1,
  "14225": 0,
  "14226": 1,
  "14227": 0,
  "14228": -6,
  "14231": 1,
  "14240": 0,
  "14280": 9,
  "14301": -6,
  "14302": -6,
  "14303": -6,
  "14304": -6,
  "14305": -6,
  "14410": 1,
  "14411": -8,
  "14413": -5,
  "14414": 2,
  "14415": -8,
  "14416": -6,
  "14418": -7,
  "14420": -8,
  "14422": -6,
  "14423": 2,
  "14424": 6,
  "14425": 6,
  "14427": -10,
  "14428": 1,
  "14429": -8,
  "14430": -8,
  "14432": 5,
  "14433": -5,
  "14435": 2,
  "14437": 2,
  "14441": -8,
  "14443": 6,
  "14445": 0,
  "14449": -5,
  "14450": 9,
  "14452": -8,
  "14453": 9,
  "14454": 2,
  "14456": -1,
  "14461": 6,
  "14462": 2,
  "14463": 6,
  "14464": -8,
  "14466": 2,
  "14467": 1,
  "14468": 1,
  "14469": 6,
  "14470": -8,
  "14471": 2,
  "14472": 9,
  "14475": 6,
  "14476": -8,
  "14477": -8,
  "14478": 1,
  "14479": -8,
  "14480": 2,
  "14481": 2,
  "14482": -6,
  "14485": 2,
  "14486": 2,
  "14487": 2,
  "14488": 2,
  "14489": -5,
  "14502": -5,
  "14504": 5,
  "14505": -5,
  "14506": 9,
  "14507": -8,
  "14508": -8,
  "14510": 2,
  "14511": 2,
  "14512": -7,
  "14513": -5,
  "14514": 1,
  "14515": 1,
  "14516": -5,
  "14517": 2,
  "14518": -5,
  "14519": -5,
  "14520": -5,
  "14521": -1,
  "14522": -5,
  "14525": -6,
  "14526": 2,
  "14527": -7,
  "14529": 2,
  "14530": -10,
  "14532": -5,
  "14533": 2,
  "14534": 9,
  "14536": -10,
  "14537": -5,
  "14538": -5,
  "14539": 2,
  "14541": -1,
  "14542": -5,
  "14543": 9,
  "14544": 6,
  "14545": 2,
  "14546": 1,
  "14547": 5,
  "14548": 5,
  "14549": -10,
  "14550": -10,
  "14551": -5,
  "14555": -5,
  "14556": 2,
  "14557": -6,
  "14558": 2,
  "14559": 1,
  "14560": 2,
  "14561": 6,
  "14563": -5,
  "14564": 14,
  "14568": -5,
  "14569": -10,
  "14571": -8,
  "14572": 2,
  "14580": 1,
  "14585": 5,
  "14586": 1,
  "14588": -1,
  "14589": -5,
  "14590": -5,
  "14591": -10,
  "14592": 2,
  "14602": 0,
  "14603": 9,
  "14604": 9,
  "14605": 0,
  "14606": 0,
  "14607": 2,
  "14608": 0,
  "14609": 0,
  "14610": 1,
  "14611": 0,
  "14612": 1,
  "14613": 0,
  "14614": 9,
  "14615": 0,
  "14616": 0,
  "14617": 0,
  "14618": 9,
  "14619": 0,
  "14620": 0,
  "14621": 0,
  "14622": 1,
  "14623": 1,
  "14624": 1,
  "14625": 2,
  "14626": 1,
  "14627": 0,
  "14692": 1,
  "14701": -5,
  "14702": -5,
  "14706": -2,
  "14707": -5,
  "14708": -5,
  "14709": -5,
  "14710": -5,
  "14711": -5,
  "14712": 3,
  "14714": -5,
  "14715": -5,
  "14716": -5,
  "14717": -5,
  "14718": -5,
  "14719": -2,
  "14720": 3,
  "14721": -5,
  "14722": -5,
  "14723": -5,
  "14724": -7,
  "14726": -5,
  "14727": -5,
  "14728": 3,
  "14729": -2,
  "14730": -2,
  "14731": 6,
  "14732": -5,
  "14733": -5,
  "14735": -5,
  "14736": -7,
  "14737": -2,
  "14738": -5,
  "14739": -5,
  "14740": -5,
  "14741": -2,
  "14742": 3,
  "14743": -2,
  "14744": -5,
  "14745": -5,
  "14747": -5,
  "14748": -3,
  "14750": 3,
  "14751": -5,
  "14752": -5,
  "14753": -3,
  "14754": -5,
  "14755": -2,
  "14756": 3,
  "14757": -5,
  "14758": -5,
  "14760": -2,
  "14766": -2,
  "14767": -5,
  "14769": -5,
  "14770": -5,
  "14772": -2,
  "14774": -5,
  "14775": -5,
  "14777": -5,
  "14778": -2,
  "14779": -3,
  "14781": -5,
  "14782": -5,
  "14783": -2,
  "14784": -5,
  "14785": 3,
  "14786": -5,
  "14787": -5,
  "14788": -2,
  "14801": -12,
  "14802": -3,
  "14803": -3,
  "14804": -5,
  "14805": -2,
  "14806": -5,
  "14807": -12,
  "14808": 2,
  "14809": -12,
  "14810": -12,
  "14812": -2,
  "14813": -5,
  "14814": 5,
  "14815": -2,
  "14816": -3,
  "14817": -7,
  "14818": -2,
  "14819": -13,
  "14820": -12,
  "14821": -12,
  "14822": -5,
  "14823": -13,
  "14824": -3,
  "14825": -3,
  "14826": -12,
  "14827": -12,
  "14830": -3,
  "14836": 2,
  "14837": -8,
  "14838": -3,
  "14839": -13,
  "14840": -8,
  "14841": 7,
  "14842": -8,
  "14843": -13,
  "14845": -1,
  "14846": -10,
  "14847": -1,
  "14850": 1,
  "14851": 1,
  "14852": 1,
  "14853": 1,
  "14854": -7,
  "14855": -13,
  "14856": -12,
  "14857": 7,
  "14858": -3,
  "14859": -8,
  "14860": -8,
  "14861": -3,
  "14863": -7,
  "14864": -2,
  "14865": -2,
  "14867": -7,
  "14869": -2,
  "14870": -12,
  "14871": -3,
  "14872": -3,
  "14873": -8,
  "14874": -8,
  "14876": -2,
  "14877": -5,
  "14878": -2,
  "14879": -12,
  "14880": -5,
  "14881": 2,
  "14882": -7,
  "14883": -8,
  "14884": -5,
  "14885": -12,
  "14886": -7,
  "14887": -2,
  "14889": -3,
  "14891": -2,
  "14892": -8,
  "14893": -8,
  "14894": -3,
  "14895": -5,
  "14897": -5,
  "14898": -12,
  "14901": -4,
  "14902": -4,
  "14903": -3,
  "14904": -4,
  "14905": -1,
  "14925": -4,
  "15001": 2,
  "15003": 2,
  "15004": -6,
  "15005": 2,
  "15006": 3,
  "15007": 3,
  "15009": 12,
  "15010": 4,
  "15012": -7,
  "15014": 3,
  "15015": 11,
  "15017": 3,
  "15018": -4,
  "15019": -7,
  "15020": 2,
  "15021": -6,
  "15022": 3,
  "15024": 3,
  "15025": 3,
  "15026": -6,
  "15027": 2,
  "15028": -4,
  "15030": 3,
  "15031": 3,
  "15032": 3,
  "15033": 2,
  "15034": 3,
  "15035": 3,
  "15037": 3,
  "15038": 2,
  "15042": 2,
  "15043": 12,
  "15044": 10,
  "15045": 3,
  "15046": 2,
  "15047": 3,
  "15049": 3,
  "15050": -6,
  "15051": 3,
  "15052": 3,
  "15053": -7,
  "15054": -7,
  "15055": 3,
  "15056": 2,
  "15057": 3,
  "15059": 3,
  "15060": 3,
  "15061": 2,
  "15062": 2,
  "15063": 3,
  "15064": 3,
  "15065": -3,
  "15066": 2,
  "15067": 2,
  "15068": 3,
  "15071": 3,
  "15072": -7,
  "15074": 2,
  "15075": 3,
  "15076": 3,
  "15077": 3,
  "15078": -7,
  "15081": 2,
  "15082": 3,
  "15083": -3,
  "15084": 3,
  "15085": -3,
  "15086": 9,
  "15087": 2,
  "15088": 3,
  "15089": -3,
  "15090": 12,
  "15091": 3,
  "15095": 11,
  "15101": 3,
  "15102": 3,
  "15104": 3,
  "15106": 3,
  "15108": 3,
  "15110": 3,
  "15112": 3,
  "15116": 3,
  "15120": 3,
  "15122": 3,
  "15123": 3,
  "15126": 3,
  "15127": 12,
  "15129": 3,
  "15131": 3,
  "15132": 3,
  "15133": 3,
  "15134": 3,
  "15135": 3,
  "15136": 3,
  "15137": 3,
  "15139": 3,
  "15140": 3,
  "15142": 12,
  "15143": 11,
  "15144": 3,
  "15145": 3,
  "15146": 3,
  "15147": 3,
  "15148": 3,
  "15201": 3,
  "15202": 3,
  "15203": 3,
  "15204": 3,
  "15205": 3,
  "15206": 3,
  "15207": 3,
  "15208": 3,
  "15209": 3,
  "15210": 3,
  "15211": 3,
  "15212": 3,
  "15213": 3,
  "15214": 3,
  "15215": 3,
  "15216": 3,
  "15217": 3,
  "15218": 3,
  "15219": 3,
  "15220": 3,
  "15221": 3,
  "15222": 3,
  "15223": 3,
  "15224": 3,
  "15225": 3,
  "15226": 3,
  "15227": 3,
  "15228": 10,
  "15229": 3,
  "15230": 3,
  "15231": 3,
  "15232": 12,
  "15233": 3,
  "15234": 3,
  "15235": 3,
  "15236": 3,
  "15237": 3,
  "15238": 12,
  "15239": 3,
  "15240": 3,
  "15241": 3,
  "15242": 3,
  "15243": 3,
  "15244": 3,
  "15250": 3,
  "15251": 3,
  "15253": 3,
  "15260": 3,
  "15264": 3,
  "15272": 3,
  "15274": 3,
  "15275": 3,
  "15276": 3,
  "15290": 3,
  "15295": 3,
  "15301": 3,
  "15310": 3,
  "15311": 12,
  "15312": 6,
  "15313": 3,
  "15314": 3,
  "15315": -5,
  "15316": -3,
  "15317": 10,
  "15320": -3,
  "15321": 3,
  "15322": -3,
  "15323": -3,
  "15324": 2,
  "15325": -3,
  "15327": -5,
  "15329": 12,
  "15330": 3,
  "15331": 2,
  "15332": 3,
  "15333": -3,
  "15334": -3,
  "15336": 3,
  "15337": -2,
  "15338": -3,
  "15339": 3,
  "15340": 12,
  "15341": -2,
  "15342": 3,
  "15344": -2,
  "15345": 2,
  "15346": -3,
  "15347": 3,
  "15348": -3,
  "15349": -5,
  "15350": 2,
  "15351": -7,
  "15352": 3,
  "15353": -3,
  "15357": -3,
  "15358": 2,
  "15359": -2,
  "15360": 3,
  "15361": 2,
  "15362": -3,
  "15363": 3,
  "15364": -2,
  "15365": -3,
  "15366": 3,
  "15367": 11,
  "15368": 2,
  "15370": -2,
  "15376": -3,
  "15377": -1,
  "15378": 3,
  "15379": 3,
  "15380": 2,
  "15401": -7,
  "15410": -7,
  "15411": -10,
  "15412": -6,
  "15413": -7,
  "15415": -7,
  "15416": -6,
  "15417": -7,
  "15419": -6,
  "15420": -7,
  "15421": -6,
  "15422": -7,
  "15423": 3,
  "15424": -10,
  "15425": -6,
  "15427": 2,
  "15428": -7,
  "15429": -7,
  "15430": -7,
  "15431": -7,
  "15432": -7,
  "15433": -6,
  "15434": -7,
  "15435": -7,
  "15436": -7,
  "15437": -6,
  "15438": -6,
  "15439": -7,
  "15440": -6,
  "15442": -7,
  "15443": -7,
  "15444": -7,
  "15445": -6,
  "15446": 2,
  "15447": -7,
  "15448": -7,
  "15449": -7,
  "15450": -6,
  "15451": -7,
  "15454": -7,
  "15455": -7,
  "15456": -7,
  "15458": -7,
  "15459": -10,
  "15460": -3,
  "15461": -7,
  "15462": -7,
  "15463": -7,
  "15464": -6,
  "15465": -7,
  "15466": -7,
  "15467": -3,
  "15468": -7,
  "15469": 2,
  "15470": -6,
  "15472": -7,
  "15473": -6,
  "15474": -5,
  "15475": -7,
  "15476": -7,
  "15477": -7,
  "15478": -6,
  "15479": -6,
  "15480": -7,
  "15482": -7,
  "15483": -6,
  "15484": -7,
  "15485": -9,
  "15486": -6,
  "15488": -7,
  "15489": -7,
  "15490": -6,
  "15492": -6,
  "15501": -9,
  "15502": -9,
  "15520": -9,
  "15521": -1,
  "15522": -1,
  "15530": -9,
  "15531": -10,
  "15532": -9,
  "15533": -2,
  "15534": -1,
  "15535": -1,
  "15536": -1,
  "15537": -1,
  "15538": -9,
  "15539": -1,
  "15540": -9,
  "15541": -9,
  "15542": -9,
  "15544": -10,
  "15545": -1,
  "15546": -10,
  "15547": -9,
  "15548": -7,
  "15549": -9,
  "15550": -1,
  "15551": -9,
  "15552": -9,
  "15553": -9,
  "15554": -1,
  "15555": -9,
  "15557": -9,
  "15558": -1,
  "15559": -1,
  "15560": -9,
  "15561": -9,
  "15562": -1,
  "15563": -7,
  "15564": -1,
  "15565": -1,
  "15601": -3,
  "15610": -1,
  "15611": -3,
  "15612": -3,
  "15613": -3,
  "15615": -3,
  "15616": -3,
  "15617": -3,
  "15618": -3,
  "15619": -3,
  "15620": -3,
  "15621": -3,
  "15622": -1,
  "15623": -3,
  "15624": -3,
  "15625": -4,
  "15626": -3,
  "15627": -3,
  "15628": -3,
  "15629": -4,
  "15631": -7,
  "15632": -3,
  "15633": -3,
  "15634": -3,
  "15635": -3,
  "15636": 5,
  "15637": -3,
  "15638": 5,
  "15639": -3,
  "15640": -3,
  "15641": -3,
  "15642": -3,
  "15644": -3,
  "15646": -9,
  "15647": -4,
  "15650": -3,
  "15655": -9,
  "15656": -3,
  "15658": 5,
  "15660": -3,
  "15661": -3,
  "15662": -3,
  "15663": -3,
  "15664": -3,
  "15665": -3,
  "15666": -3,
  "15668": 5,
  "15670": -3,
  "15671": -3,
  "15672": -3,
  "15673": -3,
  "15674": -3,
  "15675": -3,
  "15676": -1,
  "15677": -1,
  "15678": -4,
  "15679": -3,
  "15680": -4,
  "15681": -3,
  "15682": -3,
  "15683": -6,
  "15684": -4,
  "15685": -3,
  "15686": -3,
  "15687": -9,
  "15688": -3,
  "15689": -3,
  "15690": -4,
  "15691": -3,
  "15692": -3,
  "15693": 5,
  "15695": -3,
  "15696": -3,
  "15697": -3,
  "15698": -4,
  "15701": -9,
  "15710": -10,
  "15711": -10,
  "15712": -9,
  "15713": -10,
  "15714": -7,
  "15715": -10,
  "15716": -10,
  "15717": -9,
  "15720": -9,
  "15721": -8,
  "15722": -7,
  "15723": -10,
  "15724": -9,
  "15725": -9,
  "15727": -10,
  "15728": -10,
  "15729": -10,
  "15730": -10,
  "15731": -10,
  "15732": -10,
  "15733": -10,
  "15734": -10,
  "15736": -3,
  "15737": -7,
  "15738": -7,
  "15739": -10,
  "15740": -10,
  "15741": -9,
  "15742": -9,
  "15744": -10,
  "15745": -10,
  "15746": -9,
  "15747": -9,
  "15748": -9,
  "15750": -10,
  "15752": -10,
  "15753": -8,
  "15754": -10,
  "15756": -10,
  "15757": -8,
  "15758": -11,
  "15759": -9,
  "15760": -7,
  "15761": -10,
  "15762": -7,
  "15763": -11,
  "15764": -10,
  "15765": -9,
  "15767": -10,
  "15770": -10,
  "15771": -9,
  "15772": -10,
  "15773": -7,
  "15774": -9,
  "15775": -7,
  "15776": -11,
  "15777": -10,
  "15778": -11,
  "15779": -7,
  "15780": -10,
  "15781": -10,
  "15783": -10,
  "15784": -11,
  "15801": -10,
  "15821": -19,
  "15822": -2,
  "15823": -5,
  "15824": -5,
  "15825": -10,
  "15827": -2,
  "15828": -15,
  "15829": -10,
  "15831": -2,
  "15832": -19,
  "15834": -19,
  "15840": -10,
  "15841": -3,
  "15845": -5,
  "15846": -2,
  "15847": -10,
  "15848": -8,
  "15849": -5,
  "15851": -10,
  "15853": -5,
  "15856": -8,
  "15857": -2,
  "15860": -15,
  "15861": -19,
  "15863": -10,
  "15864": -11,
  "15865": -10,
  "15866": -10,
  "15868": -3,
  "15870": -5,
  "15901": -7,
  "15902": -7,
  "15904": -7,
  "15905": -7,
  "15906": -7,
  "15907": -7,
  "15909": -7,
  "15915": -7,
  "15920": -7,
  "15921": -7,
  "15922": -7,
  "15923": -9,
  "15924": -1,
  "15925": -7,
  "15926": -10,
  "15927": -7,
  "15928": 2,
  "15929": -7,
  "15930": -7,
  "15931": -7,
  "15934": -7,
  "15935": -9,
  "15936": -10,
  "15937": -10,
  "15938": -7,
  "15940": 2,
  "15942": -7,
  "15943": -7,
  "15944": -7,
  "15945": -7,
  "15946": -7,
  "15948": -7,
  "15949": -10,
  "15951": -7,
  "15952": -7,
  "15953": 2,
  "15954": -7,
  "15955": -7,
  "15956": -7,
  "15957": -7,
  "15958": -7,
  "15959": 2,
  "15960": -7,
  "15961": -7,
  "15962": -7,
  "15963": -7,
  "16001": 0,
  "16002": 0,
  "16003": 0,
  "16020": 0,
  "16021": 0,
  "16022": -1,
  "16023": 0,
  "16024": 0,
  "16025": 0,
  "16027": 0,
  "16028": -5,
  "16029": 0,
  "16030": -14,
  "16033": 0,
  "16034": 0,
  "16035": 0,
  "16036": -6,
  "16037": 0,
  "16038": 0,
  "16039": 0,
  "16040": 0,
  "16041": 0,
  "16045": 0,
  "16046": 8,
  "16048": 0,
  "16049": -5,
  "16050": 0,
  "16051": -1,
  "16052": 0,
  "16053": 0,
  "16054": -6,
  "16055": -3,
  "16056": 0,
  "16057": 0,
  "16058": -6,
  "16059": 0,
  "16061": 0,
  "16063": 2,
  "16066": 9,
  "16101": -1,
  "16102": -1,
  "16103": -1,
  "16105": -1,
  "16107": -1,
  "16108": -1,
  "16110": -10,
  "16111": -10,
  "16112": -1,
  "16113": -4,
  "16114": -6,
  "16115": 2,
  "16116": -1,
  "16117": -1,
  "16120": -1,
  "16121": -6,
  "16123": 2,
  "16124": -6,
  "16125": -6,
  "16127": -6,
  "16130": -6,
  "16131": -6,
  "16132": -1,
  "16133": -6,
  "16134": -6,
  "16136": 2,
  "16137": -6,
  "16140": -3,
  "16141": -1,
  "16142": 8,
  "16143": -1,
  "16145": -6,
  "16146": -6,
  "16148": -4,
  "16150": -6,
  "16151": -6,
  "16153": -6,
  "16154": -6,
  "16155": -3,
  "16156": -1,
  "16157": -1,
  "16159": -6,
  "16160": -1,
  "16161": -6,
  "16201": -3,
  "16210": -4,
  "16211": -10,
  "16212": -4,
  "16213": -6,
  "16214": -5,
  "16217": -15,
  "16218": -3,
  "16220": -15,
  "16221": -5,
  "16222": -3,
  "16223": -4,
  "16224": -5,
  "16225": -5,
  "16226": -4,
  "16228": -4,
  "16229": -3,
  "16230": -6,
  "16232": -5,
  "16233": -15,
  "16234": -5,
  "16235": 3,
  "16236": -4,
  "16238": -4,
  "16239": -15,
  "16240": -11,
  "16242": -5,
  "16244": -4,
  "16245": -6,
  "16246": -10,
  "16248": -6,
  "16249": -3,
  "16250": -10,
  "16253": -4,
  "16254": -5,
  "16255": -5,
  "16256": -10,
  "16257": 3,
  "16258": -5,
  "16259": -4,
  "16260": -15,
  "16261": -4,
  "16262": -3,
  "16263": -3,
  "16301": -14,
  "16311": -13,
  "16312": -12,
  "16313": -12,
  "16314": -10,
  "16316": -10,
  "16317": -14,
  "16319": -13,
  "16321": -15,
  "16322": -15,
  "16323": -14,
  "16326": 3,
  "16327": -10,
  "16328": -13,
  "16329": -12,
  "16331": -13,
  "16332": -15,
  "16333": -13,
  "16334": 3,
  "16335": -10,
  "16340": -12,
  "16341": -15,
  "16342": -14,
  "16343": -14,
  "16344": -14,
  "16345": -4,
  "16346": -13,
  "16347": -15,
  "16350": -12,
  "16351": -12,
  "16352": -12,
  "16353": -15,
  "16354": -13,
  "16360": -10,
  "16361": -15,
  "16362": -14,
  "16364": -13,
  "16365": -12,
  "16370": -15,
  "16371": -12,
  "16372": -14,
  "16373": -5,
  "16374": -13,
  "16375": -5,
  "16401": -7,
  "16402": -12,
  "16403": -10,
  "16404": -10,
  "16405": -12,
  "16406": -10,
  "16407": -12,
  "16410": -7,
  "16411": -7,
  "16412": -7,
  "16413": -12,
  "16415": -5,
  "16416": -13,
  "16417": -7,
  "16420": -13,
  "16421": -7,
  "16422": -11,
  "16423": -7,
  "16424": -10,
  "16426": -7,
  "16427": -7,
  "16428": -7,
  "16430": -7,
  "16432": -10,
  "16433": -10,
  "16434": -12,
  "16435": -10,
  "16436": -12,
  "16438": -7,
  "16440": -7,
  "16441": -7,
  "16442": -7,
  "16443": -7,
  "16501": 2,
  "16502": -7,
  "16503": -7,
  "16504": -7,
  "16505": -7,
  "16506": -7,
  "16507": -7,
  "16508": -7,
  "16509": -7,
  "16510": -7,
  "16511": -7,
  "16512": -7,
  "16514": -7,
  "16515": -7,
  "16541": 2,
  "16544": -7,
  "16546": -7,
  "16550": -7,
  "16563": -7,
  "16565": -7,
  "16601": -8,
  "16602": -8,
  "16603": -8,
  "16611": -6,
  "16613": -8,
  "16616": -8,
  "16617": -8,
  "16619": -8,
  "16620": -8,
  "16621": -6,
  "16622": -6,
  "16623": -6,
  "16624": 2,
  "16625": -8,
  "16627": -8,
  "16629": -8,
  "16630": -7,
  "16631": -8,
  "16633": -1,
  "16634": -6,
  "16635": -7,
  "16636": -8,
  "16637": -8,
  "16638": -6,
  "16639": -8,
  "16640": -8,
  "16641": -8,
  "16644": -8,
  "16645": -8,
  "16646": -7,
  "16647": 2,
  "16648": 0,
  "16650": -1,
  "16651": -8,
  "16652": -6,
  "16655": -1,
  "16656": -8,
  "16657": -5,
  "16659": -1,
  "16660": 2,
  "16661": -8,
  "16662": -7,
  "16663": -8,
  "16664": 7,
  "16665": -8,
  "16666": -5,
  "16667": -1,
  "16668": -7,
  "16669": -6,
  "16670": -1,
  "16671": -8,
  "16672": -1,
  "16673": -8,
  "16674": -6,
  "16675": -7,
  "16677": 2,
  "16678": -6,
  "16679": -1,
  "16680": -8,
  "16681": -8,
  "16682": -8,
  "16683": -6,
  "16684": -8,
  "16685": 2,
  "16686": -8,
  "16689": -2,
  "16691": -2,
  "16692": -8,
  "16693": -8,
  "16694": -2,
  "16695": -1,
  "16701": -8,
  "16720": -19,
  "16724": -8,
  "16725": -8,
  "16726": -8,
  "16727": -8,
  "16728": -6,
  "16729": -8,
  "16730": -8,
  "16731": -8,
  "16732": -8,
  "16733": -8,
  "16734": -6,
  "16735": -5,
  "16738": -8,
  "16740": -8,
  "16743": -8,
  "16744": -8,
  "16745": -8,
  "16746": -4,
  "16748": -4,
  "16749": -8,
  "16750": -8,
  "16801": 10,
  "16802": 2,
  "16803": 10,
  "16804": 10,
  "16805": 10,
  "16820": -4,
  "16821": -5,
  "16822": -7,
  "16823": 2,
  "16825": -5,
  "16826": -4,
  "16827": 10,
  "16828": 4,
  "16829": 2,
  "16830": -5,
  "16832": 2,
  "16833": -8,
  "16834": 2,
  "16835": 2,
  "16836": -5,
  "16837": -8,
  "16838": -8,
  "16839": 2,
  "16840": -5,
  "16841": -4,
  "16843": -8,
  "16844": 2,
  "16845": -19,
  "16847": -5,
  "16848": -4,
  "16849": 2,
  "16850": -5,
  "16851": 10,
  "16852": 2,
  "16853": 2,
  "16854": 2,
  "16855": -5,
  "16856": 2,
  "16858": -5,
  "16859": 2,
  "16860": -5,
  "16861": -8,
  "16863": -8,
  "16864": -4,
  "16865": 10,
  "16866": -5,
  "16868": 10,
  "16870": 10,
  "16871": -19,
  "16872": -7,
  "16873": -5,
  "16874": 2,
  "16875": 2,
  "16876": -5,
  "16877": 4,
  "16878": -5,
  "16879": 2,
  "16881": -5,
  "16882": -3,
  "16901": -6,
  "16910": -6,
  "16911": -7,
  "16912": -7,
  "16914": -6,
  "16915": -4,
  "16917": -7,
  "16920": -8,
  "16921": -7,
  "16922": -4,
  "16923": -4,
  "16925": -3,
  "16926": -6,
  "16927": -4,
  "16928": -7,
  "16929": -7,
  "16930": -7,
  "16932": -7,
  "16933": -6,
  "16935": -7,
  "16936": -3,
  "16937": -4,
  "16938": -7,
  "16939": -7,
  "16940": -7,
  "16941": -4,
  "16942": -7,
  "16943": -4,
  "16945": -6,
  "16946": -7,
  "16947": -6,
  "16948": -4,
  "16950": -7,
  "17001": 3,
  "17002": -2,
  "17003": -3,
  "17004": -2,
  "17005": -6,
  "17006": -10,
  "17007": 11,
  "17009": -2,
  "17010": 6,
  "17011": 3,
  "17013": 2,
  "17014": -6,
  "17015": 2,
  "17016": -3,
  "17017": -6,
  "17018": 2,
  "17019": 11,
  "17020": -9,
  "17021": -3,
  "17022": 2,
  "17023": 2,
  "17024": -6,
  "17025": 2,
  "17026": -3,
  "17027": 0,
  "17028": 3,
  "17029": -2,
  "17030": -7,
  "17032": 2,
  "17033": 11,
  "17034": 2,
  "17035": -3,
  "17036": 11,
  "17037": -10,
  "17038": -3,
  "17039": -3,
  "17040": -6,
  "17041": -3,
  "17042": -3,
  "17043": 2,
  "17044": -2,
  "17045": -6,
  "17046": -3,
  "17047": -6,
  "17048": -7,
  "17049": -10,
  "17050": 1,
  "17051": -2,
  "17052": -6,
  "17053": 2,
  "17054": -2,
  "17055": 1,
  "17056": -10,
  "17057": 2,
  "17058": -10,
  "17059": -10,
  "17060": -3,
  "17061": -9,
  "17062": -9,
  "17063": -2,
  "17064": 6,
  "17065": 2,
  "17066": -3,
  "17067": -3,
  "17068": -6,
  "17069": -9,
  "17070": 2,
  "17071": -10,
  "17072": 2,
  "17073": -3,
  "17074": -7,
  "17075": -4,
  "17076": -1,
  "17077": -3,
  "17078": -1,
  "17080": -6,
  "17081": 2,
  "17082": -10,
  "17083": -3,
  "17084": -2,
  "17085": -3,
  "17086": -6,
  "17087": -3,
  "17088": -1,
  "17090": -7,
  "17093": 2,
  "17094": -10,
  "17097": 2,
  "17098": -3,
  "17099": -2,
  "17101": 2,
  "17102": 2,
  "17103": 2,
  "17104": 2,
  "17105": 2,
  "17106": 2,
  "17108": 2,
  "17109": 2,
  "17110": 2,
  "17111": 2,
  "17112": 3,
  "17113": 2,
  "17129": 2,
  "17201": -5,
  "17202": -5,
  "17210": -4,
  "17211": -1,
  "17212": -1,
  "17213": -4,
  "17214": -4,
  "17215": -1,
  "17217": -4,
  "17219": -4,
  "17220": -4,
  "17221": -5,
  "17222": -5,
  "17223": -1,
  "17224": -1,
  "17225": -4,
  "17228": -1,
  "17229": -1,
  "17231": -5,
  "17232": -4,
  "17233": -1,
  "17235": -5,
  "17236": -1,
  "17237": -5,
  "17238": -1,
  "17239": -5,
  "17240": -4,
  "17241": 2,
  "17243": -6,
  "17244": -4,
  "17246": -4,
  "17247": -5,
  "17249": -6,
  "17250": -4,
  "17251": -4,
  "17252": -5,
  "17253": -6,
  "17254": -5,
  "17255": -4,
  "17256": -4,
  "17257": -4,
  "17260": -6,
  "17261": -5,
  "17262": -4,
  "17263": -4,
  "17264": -6,
  "17265": -5,
  "17266": -4,
  "17267": -1,
  "17268": -5,
  "17270": -5,
  "17271": -4,
  "17272": -5,
  "17301": 1,
  "17302": 1,
  "17303": 3,
  "17304": 3,
  "17306": 3,
  "17307": 3,
  "17309": 3,
  "17310": 2,
  "17311": 3,
  "17312": 3,
  "17313": 3,
  "17314": 1,
  "17315": 3,
  "17316": 1,
  "17317": 3,
  "17318": 3,
  "17319": 3,
  "17320": 3,
  "17321": 3,
  "17322": 3,
  "17323": 11,
  "17324": 3,
  "17325": 3,
  "17327": 3,
  "17329": 3,
  "17331": 1,
  "17337": 3,
  "17339": 4,
  "17340": 1,
  "17342": 3,
  "17343": 3,
  "17344": 1,
  "17345": 3,
  "17347": 3,
  "17349": 3,
  "17350": 1,
  "17352": 3,
  "17353": 2,
  "17354": 3,
  "17355": 3,
  "17356": 3,
  "17358": 3,
  "17360": 3,
  "17361": 3,
  "17362": 3,
  "17363": 3,
  "17364": 3,
  "17365": 3,
  "17366": 3,
  "17368": 3,
  "17370": 3,
  "17371": 3,
  "17372": 3,
  "17375": 3,
  "17401": 2,
  "17402": 3,
  "17403": 3,
  "17404": 3,
  "17405": 3,
  "17406": 3,
  "17407": 3,
  "17408": 3,
  "17501": 1,
  "17502": 3,
  "17503": 2,
  "17504": 1,
  "17505": 3,
  "17506": 2,
  "17507": 1,
  "17508": 3,
  "17509": 2,
  "17512": 1,
  "17516": 2,
  "17517": 1,
  "17518": 2,
  "17519": 1,
  "17520": 1,
  "17521": 2,
  "17522": 1,
  "17527": 2,
  "17528": 1,
  "17529": 2,
  "17532": 2,
  "17533": -1,
  "17534": 2,
  "17535": 2,
  "17536": 2,
  "17537": 2,
  "17538": 2,
  "17540": 2,
  "17543": 2,
  "17545": 2,
  "17547": 3,
  "17549": 1,
  "17550": 3,
  "17551": 2,
  "17552": 1,
  "17554": 1,
  "17555": 1,
  "17557": 2,
  "17560": 1,
  "17562": 2,
  "17563": 1,
  "17564": 2,
  "17565": 2,
  "17566": 2,
  "17567": 1,
  "17568": 1,
  "17569": 1,
  "17570": 1,
  "17572": 2,
  "17573": 2,
  "17575": 2,
  "17576": 2,
  "17578": 2,
  "17579": 2,
  "17580": 3,
  "17581": 1,
  "17582": 2,
  "17583": 2,
  "17584": 2,
  "17585": 2,
  "17601": 2,
  "17602": 1,
  "17603": 1,
  "17604": 2,
  "17605": 1,
  "17606": 2,
  "17607": 1,
  "17608": 1,
  "17611": 1,
  "17701": -5,
  "17702": -5,
  "17703": -5,
  "17720": -5,
  "17721": -7,
  "17723": -7,
  "17724": -6,
  "17726": -7,
  "17727": -7,
  "17728": -5,
  "17729": -4,
  "17730": -5,
  "17731": -2,
  "17735": -6,
  "17737": -5,
  "17738": -7,
  "17739": -7,
  "17740": -5,
  "17742": -9,
  "17744": -5,
  "17745": -7,
  "17747": -7,
  "17748": 2,
  "17749": -8,
  "17750": -7,
  "17751": -7,
  "17752": -5,
  "17754": -5,
  "17756": -5,
  "17758": -10,
  "17760": -7,
  "17762": -5,
  "17763": -5,
  "17764": -5,
  "17765": -7,
  "17767": -7,
  "17768": -10,
  "17769": -7,
  "17771": -5,
  "17772": -8,
  "17773": -7,
  "17774": -10,
  "17776": -7,
  "17777": -8,
  "17778": -19,
  "17779": -7,
  "17801": -7,
  "17810": -5,
  "17812": -3,
  "17813": -5,
  "17814": -1,
  "17815": -1,
  "17820": -1,
  "17821": -8,
  "17823": -7,
  "17824": -7,
  "17827": -5,
  "17829": -3,
  "17830": -6,
  "17831": -5,
  "17832": -8,
  "17833": -5,
  "17834": -8,
  "17835": -3,
  "17836": -7,
  "17837": 6,
  "17839": -1,
  "17840": -2,
  "17841": -9,
  "17842": -5,
  "17843": -3,
  "17844": -3,
  "17845": -3,
  "17846": -1,
  "17847": -3,
  "17850": -3,
  "17851": -2,
  "17853": -6,
  "17855": -3,
  "17856": -2,
  "17857": -7,
  "17858": -1,
  "17859": -1,
  "17860": -7,
  "17861": -5,
  "17862": -5,
  "17864": -6,
  "17865": -8,
  "17866": -8,
  "17867": -7,
  "17868": -8,
  "17870": -5,
  "17872": -8,
  "17876": -7,
  "17877": -7,
  "17878": -1,
  "17880": -3,
  "17881": -7,
  "17882": -5,
  "17883": -3,
  "17884": -8,
  "17885": -3,
  "17886": -3,
  "17887": -3,
  "17888": -2,
  "17889": -3,
  "17901": -2,
  "17920": -2,
  "17921": -2,
  "17922": -2,
  "17923": -2,
  "17925": -3,
  "17929": -2,
  "17930": -3,
  "17931": -2,
  "17933": -2,
  "17934": -2,
  "17935": -2,
  "17936": -2,
  "17938": -2,
  "17941": -7,
  "17942": -2,
  "17943": -2,
  "17944": -2,
  "17945": -2,
  "17946": -2,
  "17948": -2,
  "17949": -2,
  "17951": -2,
  "17952": -3,
  "17953": -3,
  "17954": -2,
  "17957": -3,
  "17959": -3,
  "17960": -2,
  "17961": -2,
  "17963": -2,
  "17964": -7,
  "17965": -3,
  "17966": -2,
  "17967": -2,
  "17968": -7,
  "17970": -2,
  "17972": -2,
  "17974": -2,
  "17976": -2,
  "17978": -7,
  "17979": -2,
  "17980": -3,
  "17981": -2,
  "17982": -3,
  "17983": -7,
  "17985": -1,
  "18001": 3,
  "18002": 3,
  "18010": 4,
  "18011": 3,
  "18012": -7,
  "18013": 4,
  "18014": 4,
  "18015": 4,
  "18016": 4,
  "18017": 4,
  "18018": 4,
  "18020": 4,
  "18030": -7,
  "18031": 3,
  "18032": 3,
  "18034": 4,
  "18035": 5,
  "18036": 4,
  "18037": 3,
  "18038": 4,
  "18039": 4,
  "18040": 4,
  "18041": 3,
  "18042": 4,
  "18043": 4,
  "18044": 4,
  "18045": 4,
  "18046": 3,
  "18049": 3,
  "18050": 4,
  "18051": 12,
  "18052": 3,
  "18053": 4,
  "18054": 13,
  "18055": 4,
  "18056": 1,
  "18058": -6,
  "18059": 4,
  "18060": 4,
  "18062": 3,
  "18063": 4,
  "18064": 4,
  "18065": 4,
  "18066": 3,
  "18067": 3,
  "18068": 4,
  "18069": 5,
  "18070": 3,
  "18071": -7,
  "18072": 4,
  "18073": 3,
  "18074": 13,
  "18076": 3,
  "18077": 4,
  "18078": 4,
  "18079": -7,
  "18080": 3,
  "18081": 4,
  "18083": 4,
  "18084": 13,
  "18085": 4,
  "18086": 3,
  "18087": 3,
  "18088": -7,
  "18091": -6,
  "18092": 4,
  "18101": 3,
  "18102": 3,
  "18103": 3,
  "18104": 3,
  "18105": 3,
  "18106": 3,
  "18109": 3,
  "18195": 3,
  "18201": -3,
  "18202": -3,
  "18210": -8,
  "18211": -7,
  "18212": -7,
  "18214": -2,
  "18216": -8,
  "18218": -7,
  "18219": -3,
  "18220": -2,
  "18221": -4,
  "18222": -3,
  "18223": -3,
  "18224": -4,
  "18225": -3,
  "18229": -7,
  "18230": -8,
  "18231": -8,
  "18232": -7,
  "18234": -4,
  "18235": -7,
  "18237": -8,
  "18239": -4,
  "18240": -7,
  "18241": -1,
  "18242": -2,
  "18244": -7,
  "18245": -2,
  "18246": -1,
  "18247": -3,
  "18248": -2,
  "18249": -3,
  "18250": -7,
  "18251": -3,
  "18252": -1,
  "18254": -8,
  "18255": -8,
  "18256": -1,
  "18301": -6,
  "18302": -6,
  "18320": -6,
  "18321": -6,
  "18322": -6,
  "18323": 1,
  "18324": -10,
  "18325": 4,
  "18326": -7,
  "18327": -6,
  "18328": -10,
  "18330": -6,
  "18331": -6,
  "18332": -7,
  "18333": -6,
  "18334": -8,
  "18335": -6,
  "18336": -10,
  "18337": -10,
  "18340": -10,
  "18341": -6,
  "18342": 1,
  "18343": -6,
  "18344": -7,
  "18346": -7,
  "18347": -8,
  "18348": -7,
  "18349": 1,
  "18350": -7,
  "18351": -6,
  "18352": -6,
  "18353": -6,
  "18354": -6,
  "18355": -7,
  "18356": -5,
  "18357": 4,
  "18360": -6,
  "18370": 1,
  "18371": -10,
  "18372": -6,
  "18373": -10,
  "18403": 1,
  "18405": -2,
  "18407": -3,
  "18410": 2,
  "18411": 2,
  "18413": -5,
  "18414": 2,
  "18415": -2,
  "18416": 2,
  "18417": -3,
  "18419": -3,
  "18420": 2,
  "18421": -3,
  "18424": 1,
  "18425": -10,
  "18426": -10,
  "18427": -2,
  "18428": -3,
  "18430": -5,
  "18431": -3,
  "18433": 1,
  "18434": 1,
  "18435": -10,
  "18436": -2,
  "18437": 5,
  "18438": -3,
  "18439": -3,
  "18440": 2,
  "18441": -5,
  "18443": -2,
  "18444": 2,
  "18445": -7,
  "18446": -5,
  "18447": 1,
  "18449": 3,
  "18451": -2,
  "18452": 1,
  "18453": -2,
  "18454": -3,
  "18455": -3,
  "18456": -3,
  "18457": -10,
  "18458": -10,
  "18459": -3,
  "18460": -7,
  "18461": -5,
  "18462": -5,
  "18463": -10,
  "18464": -10,
  "18465": 3,
  "18466": -7,
  "18469": -2,
  "18470": -5,
  "18471": 10,
  "18472": -3,
  "18473": -3,
  "18501": 1,
  "18502": 1,
  "18503": 1,
  "18504": 1,
  "18505": 1,
  "18507": 1,
  "18508": 1,
  "18509": 1,
  "18510": 1,
  "18512": 1,
  "18515": 1,
  "18517": 1,
  "18518": 1,
  "18519": 1,
  "18540": 1,
  "18601": -1,
  "18602": -3,
  "18603": -1,
  "18610": -8,
  "18611": -1,
  "18612": -3,
  "18614": -10,
  "18615": -3,
  "18616": -10,
  "18617": -4,
  "18618": -3,
  "18619": -10,
  "18621": -4,
  "18622": -3,
  "18623": -3,
  "18624": 1,
  "18625": -3,
  "18626": -10,
  "18627": -3,
  "18628": -11,
  "18629": -4,
  "18630": -3,
  "18631": -1,
  "18632": -11,
  "18634": -4,
  "18635": -1,
  "18636": -4,
  "18640": 1,
  "18641": 1,
  "18642": 1,
  "18643": 1,
  "18644": -3,
  "18651": -4,
  "18653": 2,
  "18654": -3,
  "18655": -3,
  "18656": -3,
  "18657": -3,
  "18660": -4,
  "18661": -3,
  "18701": -3,
  "18702": -3,
  "18703": -3,
  "18704": -3,
  "18705": -3,
  "18706": -4,
  "18707": -3,
  "18708": -3,
  "18709": -3,
  "18710": -3,
  "18711": -3,
  "18773": -3,
  "18801": -5,
  "18810": -6,
  "18812": 9,
  "18813": -5,
  "18814": -6,
  "18815": -6,
  "18816": -5,
  "18817": -6,
  "18818": -5,
  "18820": -5,
  "18821": -5,
  "18822": -5,
  "18823": -5,
  "18824": -5,
  "18825": -4,
  "18826": -5,
  "18827": -5,
  "18828": -4,
  "18829": -6,
  "18830": -8,
  "18831": -5,
  "18832": -6,
  "18833": -10,
  "18834": -5,
  "18837": -6,
  "18840": -6,
  "18842": -5,
  "18843": -5,
  "18844": -5,
  "18845": -6,
  "18846": -4,
  "18847": -5,
  "18848": -6,
  "18850": -6,
  "18851": -8,
  "18853": -6,
  "18854": -6,
  "18901": 6,
  "18902": 6,
  "18910": 8,
  "18911": 14,
  "18912": 6,
  "18913": 10,
  "18914": 6,
  "18915": 12,
  "18916": 7,
  "18917": 7,
  "18918": 13,
  "18920": 18,
  "18921": 5,
  "18922": 6,
  "18923": 7,
  "18924": 13,
  "18925": 6,
  "18926": 9,
  "18927": 14,
  "18928": 10,
  "18929": 6,
  "18930": 5,
  "18931": 10,
  "18932": 12,
  "18933": 10,
  "18934": 6,
  "18935": 3,
  "18936": 12,
  "18938": 10,
  "18940": 6,
  "18942": 8,
  "18943": 10,
  "18944": 14,
  "18946": 10,
  "18947": 9,
  "18949": 7,
  "18950": 9,
  "18951": 4,
  "18953": 5,
  "18954": 6,
  "18955": 4,
  "18956": 10,
  "18957": 13,
  "18958": 13,
  "18960": 14,
  "18962": 14,
  "18963": 10,
  "18964": 13,
  "18966": 6,
  "18968": 3,
  "18969": 13,
  "18970": 3,
  "18971": 3,
  "18972": 5,
  "18974": 6,
  "18976": 6,
  "18977": 10,
  "18979": 13,
  "18980": 10,
  "18981": 4,
  "19001": 11,
  "19002": 12,
  "19003": 8,
  "19004": 11,
  "19006": 6,
  "19007": 9,
  "19008": 9,
  "19009": 16,
  "19010": 12,
  "19012": 11,
  "19013": 10,
  "19014": 10,
  "19015": 10,
  "19016": 10,
  "19017": 11,
  "19018": 8,
  "19019": 5,
  "19020": 6,
  "19021": 9,
  "19022": 8,
  "19023": 8,
  "19025": 12,
  "19026": 8,
  "19027": 11,
  "19028": 9,
  "19029": 8,
  "19030": 11,
  "19031": 12,
  "19032": 8,
  "19033": 8,
  "19034": 12,
  "19035": 22,
  "19036": 8,
  "19037": 11,
  "19038": 11,
  "19039": 13,
  "19040": 5,
  "19041": 19,
  "19043": 8,
  "19044": 5,
  "19046": 11,
  "19047": 6,
  "19050": 8,
  "19052": 10,
  "19053": 6,
  "19054": 11,
  "19055": 11,
  "19056": 6,
  "19057": 11,
  "19058": 11,
  "19060": 10,
  "19061": 10,
  "19063": 11,
  "19064": 8,
  "19065": 11,
  "19066": 22,
  "19067": 11,
  "19070": 8,
  "19072": 11,
  "19073": 9,
  "19074": 8,
  "19075": 12,
  "19076": 8,
  "19078": 8,
  "19079": 8,
  "19081": 9,
  "19082": 8,
  "19083": 9,
  "19085": 20,
  "19086": 11,
  "19087": 12,
  "19090": 5,
  "19094": 8,
  "19095": 11,
  "19096": 9,
  "19101": 11,
  "19102": 11,
  "19103": 11,
  "19104": 11,
  "19105": 11,
  "19106": 19,
  "19107": 11,
  "19108": 11,
  "19109": 11,
  "19110": 11,
  "19111": 11,
  "19112": 10,
  "19113": 8,
  "19114": 11,
  "19115": 11,
  "19116": 5,
  "19118": 11,
  "19119": 11,
  "19120": 11,
  "19121": 11,
  "19122": 11,
  "19123": 11,
  "19124": 11,
  "19125": 11,
  "19126": 11,
  "19127": 11,
  "19128": 11,
  "19129": 11,
  "19130": 11,
  "19131": 11,
  "19132": 11,
  "19133": 11,
  "19134": 11,
  "19135": 11,
  "19136": 11,
  "19137": 11,
  "19138": 11,
  "19139": 11,
  "19140": 11,
  "19141": 11,
  "19142": 8,
  "19143": 11,
  "19144": 11,
  "19145": 10,
  "19146": 10,
  "19147": 10,
  "19148": 10,
  "19149": 11,
  "19150": 11,
  "19151": 11,
  "19152": 11,
  "19153": 8,
  "19154": 11,
  "19155": 11,
  "19160": 11,
  "19176": 11,
  "19190": 11,
  "19301": 7,
  "19310": 7,
  "19311": 11,
  "19312": 12,
  "19316": 6,
  "19317": 8,
  "19318": 10,
  "19319": 13,
  "19320": 9,
  "19330": 9,
  "19331": 11,
  "19333": 9,
  "19335": 8,
  "19341": 8,
  "19342": 11,
  "19343": 15,
  "19344": 6,
  "19345": 8,
  "19346": 9,
  "19347": 8,
  "19348": 8,
  "19350": 16,
  "19351": 9,
  "19352": 9,
  "19353": 8,
  "19354": 15,
  "19355": 8,
  "19357": 8,
  "19358": 9,
  "19360": 9,
  "19362": 8,
  "19363": 8,
  "19365": 7,
  "19366": 8,
  "19367": 7,
  "19369": 7,
  "19371": 6,
  "19372": 8,
  "19373": 11,
  "19374": 9,
  "19375": 8,
  "19376": 6,
  "19380": 8,
  "19381": 8,
  "19382": 8,
  "19390": 10,
  "19395": 13,
  "19397": 13,
  "19398": 8,
  "19399": 8,
  "19401": 12,
  "19403": 12,
  "19404": 12,
  "19405": 12,
  "19406": 12,
  "19407": 12,
  "19408": 12,
  "19409": 12,
  "19420": 12,
  "19421": 17,
  "19422": 12,
  "19423": 12,
  "19425": 17,
  "19426": 12,
  "19428": 12,
  "19430": 12,
  "19432": 8,
  "19435": 13,
  "19436": 12,
  "19437": 22,
  "19438": 12,
  "19440": 12,
  "19442": 17,
  "19443": 12,
  "19444": 12,
  "19446": 12,
  "19450": 12,
  "19451": 12,
  "19453": 12,
  "19454": 12,
  "19456": 12,
  "19457": 12,
  "19460": 12,
  "19462": 12,
  "19464": 1,
  "19465": 6,
  "19468": 12,
  "19470": 6,
  "19472": 12,
  "19473": 14,
  "19474": 12,
  "19475": 12,
  "19477": 12,
  "19478": 13,
  "19480": 15,
  "19481": 7,
  "19482": 12,
  "19484": 12,
  "19485": 12,
  "19486": 12,
  "19490": 12,
  "19492": 13,
  "19501": 1,
  "19503": 3,
  "19504": 3,
  "19505": 1,
  "19506": 1,
  "19507": -1,
  "19508": 1,
  "19510": 1,
  "19511": 1,
  "19512": 1,
  "19516": 1,
  "19518": 1,
  "19519": 1,
  "19520": 6,
  "19522": 1,
  "19523": 1,
  "19525": 1,
  "19526": 1,
  "19529": 3,
  "19530": 1,
  "19533": 1,
  "19534": 1,
  "19535": 1,
  "19536": 1,
  "19538": 3,
  "19539": 3,
  "19540": 1,
  "19541": 1,
  "19542": 1,
  "19543": 1,
  "19544": -3,
  "19545": 1,
  "19547": 1,
  "19548": 1,
  "19549": -3,
  "19550": -3,
  "19551": 1,
  "19554": 1,
  "19555": 1,
  "19559": -2,
  "19560": 1,
  "19562": 3,
  "19564": 1,
  "19565": 1,
  "19567": -3,
  "19601": 1,
  "19602": 1,
  "19603": 1,
  "19604": 1,
  "19605": 1,
  "19606": 1,
  "19607": 1,
  "19608": 1,
  "19609": 1,
  "19610": 1,
  "19611": 1,
  "19612": 1,
  "19701": 8,
  "19702": 8,
  "19703": 6,
  "19706": 8,
  "19707": 6,
  "19708": 9,
  "19709": 9,
  "19710": 17,
  "19711": 8,
  "19713": 8,
  "19714": 8,
  "19715": 8,
  "19716": 8,
  "19717": 8,
  "19720": 6,
  "19730": 8,
  "19731": 8,
  "19732": 9,
  "19733": 8,
  "19734": 2,
  "19735": 10,
  "19736": 10,
  "19801": 6,
  "19802": 6,
  "19803": 6,
  "19804": 6,
  "19805": 6,
  "19806": 6,
  "19807": 10,
  "19808": 6,
  "19809": 6,
  "19810": 6,
  "19850": 6,
  "19880": 6,
  "19899": 6,
  "19901": 2,
  "19902": 2,
  "19903": 2,
  "19904": 2,
  "19905": 2,
  "19906": 2,
  "19930": 7,
  "19931": -2,
  "19933": -2,
  "19934": 2,
  "19936": 2,
  "19938": 2,
  "19939": -2,
  "19940": -2,
  "19941": -2,
  "19943": 2,
  "19944": 9,
  "19945": -2,
  "19946": 2,
  "19947": -2,
  "19950": -2,
  "19951": -2,
  "19952": 2,
  "19953": 2,
  "19954": 2,
  "19955": 2,
  "19956": -2,
  "19958": -2,
  "19960": -2,
  "19961": 2,
  "19962": 2,
  "19963": 2,
  "19964": 2,
  "19966": -2,
  "19967": -2,
  "19968": -2,
  "19969": -2,
  "19970": -2,
  "19971": 0,
  "19973": -2,
  "19975": -2,
  "19977": 2,
  "19979": 2,
  "19980": 2,
  "20001": 12,
  "20002": 12,
  "20003": 12,
  "20004": 12,
  "20005": 12,
  "20006": 12,
  "20007": 35,
  "20008": 22,
  "20009": 12,
  "20010": 12,
  "20011": 12,
  "20012": 12,
  "20013": 12,
  "20015": 22,
  "20016": 28,
  "20017": 12,
  "20018": 12,
  "20019": 12,
  "20020": 12,
  "20022": 12,
  "20023": 12,
  "20024": 12,
  "20026": 12,
  "20027": 35,
  "20029": 12,
  "20030": 12,
  "20032": 12,
  "20033": 12,
  "20035": 12,
  "20036": 12,
  "20037": 12,
  "20038": 12,
  "20039": 12,
  "20040": 12,
  "20041": 35,
  "20043": 12,
  "20044": 12,
  "20045": 12,
  "20050": 12,
  "20056": 12,
  "20088": 22,
  "20090": 12,
  "20091": 12,
  "20105": 13,
  "20106": -8,
  "20108": 1,
  "20109": 1,
  "20110": 1,
  "20111": 1,
  "20112": 6,
  "20113": 1,
  "20115": 1,
  "20116": 1,
  "20117": 22,
  "20118": 11,
  "20119": 1,
  "20120": 1,
  "20121": 1,
  "20122": 1,
  "20124": 3,
  "20128": -8,
  "20129": 10,
  "20130": -4,
  "20131": 10,
  "20132": 10,
  "20134": 10,
  "20135": -4,
  "20136": 1,
  "20137": 1,
  "20138": 1,
  "20139": 0,
  "20140": 1,
  "20141": 10,
  "20142": 10,
  "20143": 3,
  "20144": -2,
  "20146": 10,
  "20147": 11,
  "20148": 13,
  "20151": 1,
  "20152": 1,
  "20153": 1,
  "20155": 1,
  "20156": 1,
  "20158": 10,
  "20159": 10,
  "20160": 10,
  "20163": 10,
  "20164": 10,
  "20165": 11,
  "20166": 10,
  "20167": 10,
  "20168": 1,
  "20169": 1,
  "20170": 1,
  "20171": 1,
  "20172": 1,
  "20175": 10,
  "20176": 10,
  "20177": 10,
  "20178": 10,
  "20180": 10,
  "20181": 2,
  "20182": 2,
  "20184": 7,
  "20185": 7,
  "20186": 1,
  "20187": 1,
  "20188": 1,
  "20189": 10,
  "20190": 1,
  "20191": 1,
  "20194": 3,
  "20195": 1,
  "20197": 21,
  "20198": 1,
  "20260": 12,
  "20374": 12,
  "20376": 12,
  "20388": 12,
  "20391": 12,
  "20398": 12,
  "20500": 12,
  "20601": 2,
  "20602": 2,
  "20603": 2,
  "20604": 2,
  "20606": 3,
  "20607": 13,
  "20608": 4,
  "20609": 3,
  "20610": 4,
  "20611": 2,
  "20612": 4,
  "20613": 2,
  "20615": 4,
  "20616": 2,
  "20617": 2,
  "20618": -8,
  "20619": 3,
  "20620": 3,
  "20621": 3,
  "20622": 2,
  "20623": 8,
  "20624": 3,
  "20625": -9,
  "20626": -8,
  "20627": 3,
  "20628": 7,
  "20629": 4,
  "20630": 12,
  "20632": 2,
  "20634": 3,
  "20635": 3,
  "20636": 3,
  "20637": 2,
  "20639": 4,
  "20640": 2,
  "20643": 2,
  "20645": 0,
  "20646": 2,
  "20650": 3,
  "20653": 3,
  "20656": 3,
  "20657": 3,
  "20658": 2,
  "20659": 3,
  "20660": 3,
  "20661": 2,
  "20662": -5,
  "20664": 2,
  "20667": 3,
  "20670": 3,
  "20674": 3,
  "20675": 2,
  "20676": 4,
  "20677": 3,
  "20678": 4,
  "20680": 3,
  "20682": 2,
  "20684": 3,
  "20685": 4,
  "20686": 3,
  "20687": 3,
  "20688": 3,
  "20689": 4,
  "20690": 12,
  "20692": 3,
  "20693": 2,
  "20695": 2,
  "20701": 9,
  "20703": 8,
  "20704": 8,
  "20705": 8,
  "20706": 8,
  "20707": 11,
  "20708": 11,
  "20709": 11,
  "20710": 8,
  "20711": 8,
  "20712": 12,
  "20714": 4,
  "20715": 8,
  "20716": 8,
  "20717": 8,
  "20718": 8,
  "20719": 8,
  "20720": 8,
  "20721": 9,
  "20722": 12,
  "20723": 11,
  "20724": 11,
  "20725": 11,
  "20726": 11,
  "20731": 8,
  "20732": 4,
  "20733": 9,
  "20735": 8,
  "20736": 4,
  "20737": 8,
  "20738": 8,
  "20740": 8,
  "20741": 8,
  "20743": 8,
  "20744": 13,
  "20745": 12,
  "20746": 8,
  "20747": 8,
  "20748": 8,
  "20749": 13,
  "20750": 12,
  "20751": 9,
  "20752": 8,
  "20753": 8,
  "20754": 9,
  "20755": 7,
  "20757": 8,
  "20758": 4,
  "20759": 22,
  "20762": 8,
  "20763": 9,
  "20764": 9,
  "20765": 10,
  "20768": 8,
  "20769": 8,
  "20770": 8,
  "20772": 8,
  "20773": 8,
  "20774": 8,
  "20775": 8,
  "20776": 10,
  "20777": 22,
  "20778": 10,
  "20779": 4,
  "20781": 8,
  "20782": 12,
  "20783": 12,
  "20784": 8,
  "20785": 8,
  "20787": 12,
  "20788": 12,
  "20791": 8,
  "20792": 8,
  "20794": 9,
  "20812": 15,
  "20813": 22,
  "20814": 14,
  "20815": 22,
  "20816": 35,
  "20817": 21,
  "20818": 15,
  "20824": 22,
  "20825": 22,
  "20827": 21,
  "20830": 10,
  "20832": 10,
  "20833": 14,
  "20837": 10,
  "20838": 16,
  "20839": 10,
  "20841": 21,
  "20842": 16,
  "20847": 10,
  "20848": 10,
  "20849": 10,
  "20850": 10,
  "20851": 10,
  "20852": 10,
  "20853": 10,
  "20854": 21,
  "20855": 10,
  "20859": 21,
  "20860": 10,
  "20861": 14,
  "20862": 22,
  "20866": 11,
  "20868": 12,
  "20871": 5,
  "20872": 10,
  "20874": 9,
  "20875": 9,
  "20876": 10,
  "20877": 10,
  "20878": 10,
  "20879": 10,
  "20880": 10,
  "20882": 14,
  "20883": 10,
  "20884": 10,
  "20885": 10,
  "20886": 10,
  "20891": 10,
  "20895": 10,
  "20896": 21,
  "20898": 10,
  "20901": 10,
  "20902": 10,
  "20903": 12,
  "20904": 10,
  "20905": 10,
  "20906": 10,
  "20907": 12,
  "20908": 10,
  "20910": 12,
  "20911": 12,
  "20912": 12,
  "20913": 12,
  "20914": 10,
  "20915": 10,
  "20916": 10,
  "20918": 10,
  "21001": 2,
  "21005": 1,
  "21009": 0,
  "21010": 0,
  "21012": 9,
  "21013": 4,
  "21014": 0,
  "21015": 0,
  "21017": 0,
  "21018": 0,
  "21020": -1,
  "21022": 6,
  "21023": 6,
  "21027": 6,
  "21028": 0,
  "21029": 20,
  "21030": 6,
  "21031": 6,
  "21032": 10,
  "21034": 2,
  "21035": 20,
  "21036": 20,
  "21037": 9,
  "21040": 0,
  "21041": 13,
  "21042": 13,
  "21043": 13,
  "21044": 9,
  "21045": 9,
  "21046": 9,
  "21047": 0,
  "21048": -1,
  "21050": 0,
  "21051": 0,
  "21052": 6,
  "21053": 11,
  "21054": 9,
  "21056": 20,
  "21057": 8,
  "21060": 7,
  "21061": 7,
  "21071": 3,
  "21074": -1,
  "21075": 9,
  "21076": 9,
  "21077": 7,
  "21078": 2,
  "21082": 0,
  "21084": 0,
  "21085": 0,
  "21087": 0,
  "21088": 3,
  "21090": 6,
  "21092": 8,
  "21093": 6,
  "21094": 6,
  "21102": 11,
  "21104": 9,
  "21105": 3,
  "21106": 9,
  "21108": 10,
  "21111": 17,
  "21113": 9,
  "21114": 9,
  "21117": 6,
  "21120": 11,
  "21122": 9,
  "21123": 9,
  "21128": 6,
  "21130": 0,
  "21131": 17,
  "21132": 7,
  "21133": 6,
  "21136": -1,
  "21139": 6,
  "21140": 10,
  "21144": 7,
  "21146": 10,
  "21150": 9,
  "21152": 6,
  "21153": 6,
  "21154": 8,
  "21155": -1,
  "21156": 0,
  "21157": 1,
  "21158": 1,
  "21160": 0,
  "21161": 7,
  "21162": 6,
  "21163": 9,
  "21201": 6,
  "21202": 5,
  "21203": 5,
  "21204": 6,
  "21205": 5,
  "21206": 6,
  "21207": 6,
  "21208": 6,
  "21209": 6,
  "21210": 6,
  "21211": 5,
  "21212": 6,
  "21213": 5,
  "21214": 6,
  "21215": 6,
  "21216": 5,
  "21217": 5,
  "21218": 6,
  "21219": 6,
  "21220": 6,
  "21221": 6,
  "21222": 6,
  "21223": 5,
  "21224": 5,
  "21225": 6,
  "21226": 6,
  "21227": 6,
  "21228": 6,
  "21229": 5,
  "21230": 6,
  "21231": 6,
  "21233": 5,
  "21234": 6,
  "21236": 6,
  "21237": 6,
  "21239": 6,
  "21240": 7,
  "21244": 6,
  "21270": 6,
  "21281": 5,
  "21282": 6,
  "21284": 6,
  "21285": 6,
  "21286": 6,
  "21297": 5,
  "21401": 10,
  "21402": 13,
  "21403": 10,
  "21404": 10,
  "21405": 13,
  "21409": 13,
  "21501": -1,
  "21502": -1,
  "21503": -1,
  "21504": -1,
  "21505": -1,
  "21520": -10,
  "21521": -1,
  "21522": -10,
  "21523": -10,
  "21524": 0,
  "21528": -1,
  "21529": -1,
  "21530": -1,
  "21531": -10,
  "21532": -1,
  "21536": -10,
  "21538": -10,
  "21539": -1,
  "21540": -10,
  "21541": -2,
  "21542": -1,
  "21543": 0,
  "21545": -1,
  "21550": -10,
  "21555": -1,
  "21556": -1,
  "21557": 0,
  "21560": -1,
  "21561": -10,
  "21562": -10,
  "21601": -3,
  "21607": -5,
  "21609": -3,
  "21610": -4,
  "21612": -3,
  "21613": -8,
  "21617": -3,
  "21619": -3,
  "21620": -4,
  "21622": -8,
  "21623": -4,
  "21624": -3,
  "21625": -3,
  "21626": -8,
  "21627": -8,
  "21628": -6,
  "21629": -4,
  "21631": -8,
  "21632": -4,
  "21634": -8,
  "21635": -5,
  "21636": -4,
  "21638": -3,
  "21639": -4,
  "21640": 2,
  "21641": -4,
  "21643": -9,
  "21644": -5,
  "21645": 3,
  "21647": -3,
  "21648": -8,
  "21649": 2,
  "21650": -5,
  "21651": -5,
  "21652": -3,
  "21653": -3,
  "21654": 1,
  "21655": -3,
  "21656": -4,
  "21657": -4,
  "21658": -3,
  "21659": -9,
  "21660": -4,
  "21661": -3,
  "21662": -3,
  "21663": -3,
  "21664": -8,
  "21665": -3,
  "21666": -3,
  "21667": -4,
  "21668": -5,
  "21669": 4,
  "21670": 2,
  "21671": -3,
  "21672": -8,
  "21673": -3,
  "21675": -8,
  "21676": -3,
  "21677": -8,
  "21678": -7,
  "21679": -4,
  "21701": 5,
  "21702": 4,
  "21703": 4,
  "21704": 5,
  "21705": 4,
  "21710": 5,
  "21711": -6,
  "21713": -4,
  "21714": 5,
  "21715": 5,
  "21716": 4,
  "21717": 5,
  "21718": 5,
  "21719": -6,
  "21720": -4,
  "21721": -5,
  "21722": -5,
  "21723": 20,
  "21727": 4,
  "21733": -4,
  "21734": -6,
  "21737": 20,
  "21738": 20,
  "21740": -6,
  "21741": -6,
  "21742": -5,
  "21747": -6,
  "21750": -6,
  "21754": 5,
  "21755": 5,
  "21756": 3,
  "21757": 5,
  "21758": 4,
  "21759": 5,
  "21762": 4,
  "21765": 11,
  "21766": 0,
  "21767": -5,
  "21769": 5,
  "21770": 5,
  "21771": 1,
  "21773": 5,
  "21774": 5,
  "21775": 5,
  "21776": 1,
  "21777": 4,
  "21778": 5,
  "21779": 4,
  "21780": 12,
  "21781": -4,
  "21782": -5,
  "21783": -4,
  "21784": 20,
  "21787": 1,
  "21788": 4,
  "21790": 5,
  "21791": 1,
  "21792": 4,
  "21793": 4,
  "21794": 20,
  "21795": -5,
  "21797": 11,
  "21798": 5,
  "21801": -4,
  "21802": -4,
  "21803": -4,
  "21804": -4,
  "21810": -4,
  "21811": -10,
  "21813": -10,
  "21814": -10,
  "21817": -12,
  "21821": -10,
  "21822": -5,
  "21824": -12,
  "21826": -5,
  "21829": -10,
  "21830": -4,
  "21835": -8,
  "21836": -4,
  "21837": -5,
  "21838": -12,
  "21840": -10,
  "21841": -10,
  "21842": -10,
  "21843": -10,
  "21849": -5,
  "21850": -10,
  "21851": -12,
  "21852": -10,
  "21853": -12,
  "21856": -4,
  "21857": -12,
  "21861": -5,
  "21862": -10,
  "21863": -10,
  "21864": -10,
  "21865": -4,
  "21866": -12,
  "21867": -10,
  "21869": -8,
  "21871": -10,
  "21872": -10,
  "21874": -10,
  "21875": -5,
  "21901": 2,
  "21902": 2,
  "21903": 2,
  "21904": 2,
  "21911": 2,
  "21912": -3,
  "21913": -4,
  "21914": 2,
  "21915": 8,
  "21916": 8,
  "21917": 2,
  "21918": 2,
  "21919": -4,
  "21920": 8,
  "21921": 8,
  "21922": 8,
  "21930": -4,
  "22003": 11,
  "22009": 11,
  "22015": 11,
  "22025": 1,
  "22026": 5,
  "22027": 22,
  "22030": 1,
  "22031": 11,
  "22032": 1,
  "22033": 1,
  "22034": 11,
  "22035": 1,
  "22036": 11,
  "22038": 1,
  "22039": 12,
  "22040": 11,
  "22041": 24,
  "22042": 11,
  "22043": 11,
  "22044": 11,
  "22046": 11,
  "22060": 13,
  "22066": 12,
  "22067": 22,
  "22079": 11,
  "22081": 22,
  "22101": 22,
  "22102": 22,
  "22103": 22,
  "22106": 22,
  "22116": 11,
  "22121": 13,
  "22122": 13,
  "22124": 5,
  "22125": 5,
  "22134": -5,
  "22150": 11,
  "22151": 11,
  "22152": 11,
  "22153": 11,
  "22172": 5,
  "22180": 11,
  "22181": 3,
  "22182": 15,
  "22183": 11,
  "22191": 5,
  "22192": 5,
  "22193": 5,
  "22194": 5,
  "22195": 5,
  "22199": 11,
  "22201": 24,
  "22202": 14,
  "22203": 24,
  "22204": 24,
  "22205": 24,
  "22206": 13,
  "22207": 26,
  "22209": 24,
  "22210": 24,
  "22211": 24,
  "22213": 11,
  "22214": 14,
  "22215": 14,
  "22216": 24,
  "22219": 24,
  "22301": 14,
  "22302": 14,
  "22303": 13,
  "22304": 13,
  "22305": 14,
  "22306": 13,
  "22307": 14,
  "22308": 14,
  "22309": 13,
  "22310": 13,
  "22311": 14,
  "22312": 14,
  "22313": 11,
  "22314": 14,
  "22315": 13,
  "22320": 14,
  "22331": 14,
  "22332": 14,
  "22401": 5,
  "22402": -5,
  "22403": 5,
  "22404": 5,
  "22405": 5,
  "22406": -5,
  "22407": -5,
  "22408": 5,
  "22427": -3,
  "22430": 5,
  "22432": 1,
  "22433": -4,
  "22435": 2,
  "22436": -14,
  "22437": -10,
  "22438": -13,
  "22442": 2,
  "22443": -9,
  "22446": 5,
  "22448": -5,
  "22451": -6,
  "22454": 1,
  "22456": 1,
  "22460": 1,
  "22463": -5,
  "22469": 2,
  "22471": -5,
  "22472": 2,
  "22473": 1,
  "22476": -13,
  "22480": -9,
  "22481": -6,
  "22482": -9,
  "22485": -6,
  "22488": 2,
  "22501": -3,
  "22503": 2,
  "22504": -9,
  "22507": 2,
  "22508": -4,
  "22509": -13,
  "22511": 1,
  "22513": -9,
  "22514": -3,
  "22517": -9,
  "22520": -9,
  "22523": -9,
  "22524": 2,
  "22526": -5,
  "22528": 2,
  "22529": 2,
  "22530": 1,
  "22534": -5,
  "22535": -6,
  "22538": -6,
  "22539": 1,
  "22542": -8,
  "22544": -13,
  "22545": -5,
  "22546": -3,
  "22547": -6,
  "22548": 12,
  "22551": -5,
  "22552": -3,
  "22553": -5,
  "22554": -5,
  "22555": -5,
  "22556": -5,
  "22558": -9,
  "22560": -14,
  "22565": -3,
  "22567": -8,
  "22570": 2,
  "22572": 2,
  "22576": -9,
  "22577": 2,
  "22578": -9,
  "22579": 3,
  "22580": -3,
  "22581": -9,
  "22601": -3,
  "22602": -3,
  "22603": -3,
  "22604": -3,
  "22610": -5,
  "22611": -4,
  "22620": -4,
  "22622": -3,
  "22623": -5,
  "22624": -4,
  "22625": 3,
  "22626": -9,
  "22627": -8,
  "22630": -5,
  "22637": -5,
  "22639": 4,
  "22640": -5,
  "22641": -5,
  "22642": -5,
  "22643": 6,
  "22644": -9,
  "22645": -7,
  "22646": -4,
  "22649": -7,
  "22650": -8,
  "22652": -7,
  "22654": -8,
  "22655": -3,
  "22656": -4,
  "22657": -8,
  "22660": -9,
  "22663": -4,
  "22664": -8,
  "22701": -4,
  "22709": -8,
  "22711": -8,
  "22712": 0,
  "22713": -8,
  "22714": -4,
  "22715": -8,
  "22716": -8,
  "22718": -3,
  "22719": -9,
  "22720": -5,
  "22721": -8,
  "22722": -8,
  "22723": -10,
  "22724": 1,
  "22725": -8,
  "22726": -4,
  "22727": -8,
  "22728": 0,
  "22729": -4,
  "22730": -8,
  "22731": -8,
  "22732": -8,
  "22733": -8,
  "22734": -4,
  "22735": -8,
  "22736": 5,
  "22737": -4,
  "22738": -8,
  "22739": -5,
  "22740": -8,
  "22741": -3,
  "22742": -5,
  "22743": -9,
  "22746": -8,
  "22747": 1,
  "22748": -10,
  "22749": -7,
  "22801": 0,
  "22802": -5,
  "22803": 0,
  "22810": -7,
  "22811": -7,
  "22812": 0,
  "22815": -5,
  "22820": -6,
  "22821": 0,
  "22824": -7,
  "22827": -10,
  "22830": -5,
  "22831": 0,
  "22832": -5,
  "22833": -5,
  "22834": -5,
  "22835": -12,
  "22840": -5,
  "22841": 0,
  "22842": -7,
  "22843": -4,
  "22844": -12,
  "22845": -7,
  "22846": 0,
  "22847": -12,
  "22848": 0,
  "22849": -13,
  "22850": -5,
  "22851": -13,
  "22853": -5,
  "22901": 1,
  "22902": 1,
  "22903": 1,
  "22904": 1,
  "22905": 1,
  "22906": 1,
  "22911": 1,
  "22920": -10,
  "22922": -11,
  "22923": -10,
  "22924": 1,
  "22931": -10,
  "22932": 1,
  "22935": -10,
  "22936": 1,
  "22937": -10,
  "22938": -10,
  "22939": -4,
  "22940": -10,
  "22942": -8,
  "22943": 1,
  "22945": 1,
  "22946": 1,
  "22947": 1,
  "22948": -8,
  "22949": -10,
  "22952": -4,
  "22957": -8,
  "22958": -10,
  "22959": 1,
  "22960": -8,
  "22963": 9,
  "22964": -11,
  "22965": -10,
  "22967": -10,
  "22968": -10,
  "22969": -11,
  "22971": -10,
  "22972": -8,
  "22973": -10,
  "22974": 9,
  "22976": -10,
  "22980": -4,
  "22987": 1,
  "22989": -8,
  "23001": -7,
  "23002": -8,
  "23003": -6,
  "23004": -14,
  "23005": -1,
  "23009": -6,
  "23011": 1,
  "23014": 0,
  "23015": -5,
  "23018": -6,
  "23021": -11,
  "23022": 9,
  "23023": -10,
  "23024": -5,
  "23025": -12,
  "23027": -14,
  "23030": -5,
  "23031": -6,
  "23032": -7,
  "23035": -11,
  "23038": 9,
  "23039": 0,
  "23040": -14,
  "23043": -11,
  "23045": -11,
  "23047": 0,
  "23050": -11,
  "23055": 9,
  "23056": -12,
  "23058": -1,
  "23059": 1,
  "23060": -1,
  "23061": -6,
  "23062": -1,
  "23063": 0,
  "23064": -12,
  "23065": -1,
  "23066": -11,
  "23067": -1,
  "23068": -11,
  "23069": -1,
  "23070": -6,
  "23071": -6,
  "23072": -6,
  "23075": 0,
  "23076": -11,
  "23079": -9,
  "23081": -4,
  "23083": -8,
  "23084": 1,
  "23085": -10,
  "23086": -6,
  "23089": 1,
  "23090": 5,
  "23091": -10,
  "23092": -7,
  "23093": 1,
  "23101": -1,
  "23102": 0,
  "23103": 8,
  "23105": -6,
  "23106": -6,
  "23107": -7,
  "23108": -10,
  "23109": -12,
  "23110": -10,
  "23111": 0,
  "23112": 10,
  "23113": 10,
  "23114": 10,
  "23115": -10,
  "23116": 0,
  "23117": -1,
  "23119": -11,
  "23120": 0,
  "23123": -14,
  "23124": 1,
  "23125": -11,
  "23126": -14,
  "23127": 5,
  "23128": -11,
  "23129": 8,
  "23130": -12,
  "23131": 4,
  "23138": -11,
  "23139": -1,
  "23140": 0,
  "23141": 0,
  "23146": 0,
  "23147": -5,
  "23148": -14,
  "23149": -7,
  "23150": 0,
  "23153": -1,
  "23154": -7,
  "23155": -7,
  "23156": -10,
  "23160": 0,
  "23161": -10,
  "23162": 0,
  "23163": -11,
  "23168": 5,
  "23169": -6,
  "23170": 1,
  "23175": -6,
  "23176": -6,
  "23177": -6,
  "23178": -7,
  "23180": -9,
  "23181": -10,
  "23183": 4,
  "23184": 4,
  "23185": -4,
  "23187": -4,
  "23188": 5,
  "23190": -10,
  "23192": 0,
  "23218": 0,
  "23219": 0,
  "23220": 0,
  "23221": 3,
  "23222": 2,
  "23223": 0,
  "23224": 0,
  "23225": 0,
  "23226": 3,
  "23227": 2,
  "23228": 2,
  "23229": 3,
  "23230": 2,
  "23231": 0,
  "23232": 0,
  "23233": 3,
  "23234": 10,
  "23235": 0,
  "23236": 10,
  "23237": 10,
  "23238": 3,
  "23240": 0,
  "23241": 2,
  "23242": 3,
  "23250": 0,
  "23255": 3,
  "23260": 0,
  "23261": 0,
  "23284": 0,
  "23285": 0,
  "23294": 2,
  "23298": 0,
  "23301": -8,
  "23302": -8,
  "23303": -8,
  "23304": 3,
  "23306": -10,
  "23307": -11,
  "23308": -9,
  "23310": -10,
  "23313": -10,
  "23314": 3,
  "23315": -17,
  "23316": -11,
  "23320": 1,
  "23321": -2,
  "23322": 1,
  "23323": 1,
  "23324": 1,
  "23325": 1,
  "23327": 1,
  "23328": 1,
  "23336": -8,
  "23337": -8,
  "23341": -9,
  "23345": -10,
  "23347": -11,
  "23350": -11,
  "23354": -2,
  "23356": -8,
  "23357": -9,
  "23358": -9,
  "23359": -8,
  "23389": -9,
  "23395": -9,
  "23396": -9,
  "23397": -9,
  "23398": -11,
  "23399": -9,
  "23401": -9,
  "23404": -9,
  "23405": -10,
  "23407": -8,
  "23408": -11,
  "23409": -9,
  "23410": -9,
  "23412": -8,
  "23413": -11,
  "23414": -8,
  "23415": -9,
  "23416": -9,
  "23417": -8,
  "23418": -8,
  "23419": -11,
  "23420": -9,
  "23421": -9,
  "23422": -9,
  "23423": -9,
  "23424": 3,
  "23426": -9,
  "23427": -9,
  "23429": -11,
  "23430": -9,
  "23431": -9,
  "23432": 0,
  "23433": 7,
  "23434": -1,
  "23435": -2,
  "23436": -2,
  "23437": -17,
  "23438": -1,
  "23439": -1,
  "23440": -9,
  "23441": -8,
  "23442": -9,
  "23443": -11,
  "23450": 1,
  "23451": 9,
  "23452": 1,
  "23453": 1,
  "23454": 1,
  "23455": 1,
  "23456": 1,
  "23457": 2,
  "23458": 9,
  "23459": 9,
  "23460": 1,
  "23461": 9,
  "23462": 1,
  "23464": 1,
  "23466": 1,
  "23467": 1,
  "23471": 1,
  "23480": -8,
  "23482": -11,
  "23483": -9,
  "23486": -11,
  "23487": -9,
  "23488": -9,
  "23501": 0,
  "23502": 0,
  "23503": 0,
  "23504": 0,
  "23505": 0,
  "23506": 0,
  "23507": 9,
  "23508": 1,
  "23509": 0,
  "23510": 9,
  "23511": 0,
  "23513": 0,
  "23514": 9,
  "23517": 1,
  "23518": 0,
  "23519": 0,
  "23520": 9,
  "23521": 1,
  "23523": 0,
  "23541": 0,
  "23601": 3,
  "23602": 3,
  "23603": -2,
  "23604": -1,
  "23605": -1,
  "23606": 3,
  "23607": -1,
  "23608": -1,
  "23609": -1,
  "23612": 3,
  "23651": -1,
  "23661": -1,
  "23662": 4,
  "23663": -1,
  "23664": -1,
  "23665": -1,
  "23666": -1,
  "23669": -1,
  "23670": -1,
  "23690": -2,
  "23691": -2,
  "23692": -1,
  "23693": -4,
  "23694": -2,
  "23696": -1,
  "23701": -2,
  "23702": -2,
  "23703": -2,
  "23704": -2,
  "23705": -2,
  "23707": -2,
  "23708": -2,
  "23709": -2,
  "23801": -6,
  "23803": -1,
  "23804": -1,
  "23805": -1,
  "23821": -11,
  "23822": -6,
  "23824": -4,
  "23827": -6,
  "23828": -7,
  "23829": -6,
  "23830": 10,
  "23831": -4,
  "23832": 10,
  "23833": -6,
  "23834": -5,
  "23836": -5,
  "23837": -6,
  "23838": 17,
  "23839": -10,
  "23840": -6,
  "23841": -6,
  "23842": 6,
  "23843": -11,
  "23844": -9,
  "23845": -13,
  "23846": -11,
  "23847": -7,
  "23850": -6,
  "23851": -17,
  "23856": -7,
  "23857": -2,
  "23860": 6,
  "23866": -9,
  "23867": -7,
  "23868": -2,
  "23872": -6,
  "23873": -12,
  "23874": -6,
  "23875": 6,
  "23876": -11,
  "23878": -6,
  "23879": -7,
  "23881": -12,
  "23882": 9,
  "23883": -11,
  "23884": 10,
  "23885": -6,
  "23887": -2,
  "23888": -10,
  "23889": -11,
  "23890": 9,
  "23893": -11,
  "23894": -6,
  "23897": 10,
  "23898": -7,
  "23899": -12,
  "23901": -1,
  "23915": -12,
  "23917": -12,
  "23919": -13,
  "23920": -12,
  "23921": -14,
  "23922": -4,
  "23923": -14,
  "23924": -14,
  "23927": -11,
  "23930": -5,
  "23934": -14,
  "23936": -14,
  "23937": -15,
  "23938": -8,
  "23939": -9,
  "23941": -15,
  "23942": -3,
  "23943": 8,
  "23944": -8,
  "23947": -8,
  "23950": -12,
  "23952": -7,
  "23954": -1,
  "23955": -5,
  "23958": -9,
  "23959": -15,
  "23960": -1,
  "23962": -15,
  "23963": -8,
  "23964": -16,
  "23966": -1,
  "23967": -15,
  "23968": -14,
  "23970": -14,
  "23974": -8,
  "23976": -16,
  "24001": 2,
  "24002": 2,
  "24003": 2,
  "24004": 2,
  "24005": 2,
  "24006": 2,
  "24007": 2,
  "24008": 2,
  "24009": 2,
  "24010": 2,
  "24011": 2,
  "24012": 3,
  "24013": 2,
  "24014": 3,
  "24015": -4,
  "24016": 2,
  "24017": 2,
  "24018": 4,
  "24019": 3,
  "24020": 4,
  "24022": 2,
  "24023": 2,
  "24024": 2,
  "24025": 2,
  "24026": 2,
  "24027": 2,
  "24028": 2,
  "24029": 2,
  "24030": 2,
  "24031": 2,
  "24032": 2,
  "24033": 2,
  "24034": 2,
  "24035": 2,
  "24036": 2,
  "24037": 2,
  "24038": 2,
  "24053": -10,
  "24054": -11,
  "24055": -11,
  "24058": -8,
  "24059": 4,
  "24060": 3,
  "24062": 3,
  "24063": 3,
  "24064": -4,
  "24065": -10,
  "24066": -5,
  "24067": -10,
  "24068": -5,
  "24069": -11,
  "24070": -6,
  "24072": -14,
  "24073": -5,
  "24076": -14,
  "24077": 11,
  "24078": -11,
  "24079": -14,
  "24082": -13,
  "24083": 3,
  "24084": -8,
  "24085": -5,
  "24086": -6,
  "24087": -6,
  "24088": -10,
  "24089": -11,
  "24090": -4,
  "24091": -14,
  "24092": -10,
  "24093": -8,
  "24095": -8,
  "24101": 3,
  "24102": -10,
  "24104": 0,
  "24105": -8,
  "24111": 3,
  "24112": -11,
  "24113": -11,
  "24114": -11,
  "24115": -11,
  "24120": -14,
  "24121": 0,
  "24122": -5,
  "24124": -8,
  "24126": -8,
  "24127": -14,
  "24128": -5,
  "24129": -8,
  "24130": -5,
  "24131": -14,
  "24132": -7,
  "24133": -14,
  "24134": -8,
  "24136": -6,
  "24137": -8,
  "24138": -14,
  "24139": -9,
  "24141": -7,
  "24142": -8,
  "24143": -7,
  "24146": -10,
  "24147": -8,
  "24148": -11,
  "24149": -14,
  "24150": -8,
  "24151": -10,
  "24153": -4,
  "24161": -8,
  "24162": -6,
  "24165": -11,
  "24167": -8,
  "24168": -11,
  "24171": -14,
  "24174": -9,
  "24175": 3,
  "24176": -2,
  "24177": -14,
  "24178": -5,
  "24179": 3,
  "24184": -10,
  "24185": -14,
  "24201": -7,
  "24202": -7,
  "24203": -7,
  "24209": -7,
  "24210": 1,
  "24211": 1,
  "24212": 1,
  "24215": -3,
  "24216": -4,
  "24217": -3,
  "24218": -15,
  "24219": -3,
  "24220": -3,
  "24221": -16,
  "24224": -12,
  "24225": -12,
  "24226": -3,
  "24228": -3,
  "24230": -4,
  "24236": -7,
  "24237": -3,
  "24239": -7,
  "24243": -15,
  "24244": -17,
  "24245": -3,
  "24246": -3,
  "24248": -9,
  "24250": -17,
  "24251": -16,
  "24256": -3,
  "24258": -2,
  "24260": -12,
  "24263": -15,
  "24265": -16,
  "24266": -12,
  "24269": -3,
  "24270": -12,
  "24271": -16,
  "24272": -3,
  "24273": -3,
  "24277": -15,
  "24279": -3,
  "24280": -3,
  "24281": -27,
  "24282": -16,
  "24283": -12,
  "24290": -9,
  "24292": -7,
  "24293": -3,
  "24301": -8,
  "24311": -3,
  "24312": -11,
  "24313": -8,
  "24314": -2,
  "24315": -2,
  "24316": -9,
  "24317": -10,
  "24318": -9,
  "24319": -7,
  "24322": -1,
  "24323": -3,
  "24324": -7,
  "24325": -11,
  "24326": -20,
  "24327": -7,
  "24328": -10,
  "24330": -18,
  "24333": -10,
  "24340": -7,
  "24343": -10,
  "24347": -8,
  "24348": -20,
  "24350": -1,
  "24351": -10,
  "24352": -10,
  "24354": -9,
  "24360": -2,
  "24361": -7,
  "24363": -20,
  "24366": -2,
  "24368": -3,
  "24370": -7,
  "24374": -3,
  "24375": -20,
  "24377": -9,
  "24378": -20,
  "24380": -14,
  "24381": -10,
  "24382": -3,
  "24401": -4,
  "24402": -4,
  "24411": -5,
  "24412": 2,
  "24413": -18,
  "24415": -7,
  "24416": -14,
  "24421": -4,
  "24422": -11,
  "24426": -8,
  "24430": -5,
  "24431": -5,
  "24432": -17,
  "24433": -17,
  "24435": -7,
  "24437": -4,
  "24438": -11,
  "24439": -7,
  "24440": -5,
  "24441": 0,
  "24442": -18,
  "24445": 2,
  "24448": -11,
  "24450": 1,
  "24457": -11,
  "24458": -17,
  "24459": -4,
  "24460": 2,
  "24463": -4,
  "24464": -11,
  "24465": -17,
  "24467": -4,
  "24468": -17,
  "24469": -4,
  "24471": 0,
  "24472": -10,
  "24473": 1,
  "24474": -11,
  "24476": -11,
  "24477": -4,
  "24479": -4,
  "24482": -4,
  "24483": -14,
  "24484": -18,
  "24485": -18,
  "24486": 0,
  "24487": -18,
  "24501": -3,
  "24502": -2,
  "24503": 6,
  "24504": -3,
  "24505": -3,
  "24506": -3,
  "24517": -7,
  "24520": -5,
  "24521": -5,
  "24522": -8,
  "24523": -22,
  "24526": -14,
  "24527": -8,
  "24528": -7,
  "24529": -5,
  "24530": -8,
  "24531": -8,
  "24533": -5,
  "24534": -15,
  "24535": -5,
  "24536": -2,
  "24538": -8,
  "24539": -5,
  "24540": -8,
  "24541": -8,
  "24543": -8,
  "24549": -8,
  "24550": -7,
  "24551": 6,
  "24553": -8,
  "24554": -7,
  "24555": -14,
  "24556": -14,
  "24557": -8,
  "24558": -5,
  "24562": -10,
  "24563": -7,
  "24565": -9,
  "24566": -8,
  "24569": -7,
  "24570": -14,
  "24571": -7,
  "24572": -2,
  "24574": 6,
  "24576": -7,
  "24577": -4,
  "24578": -14,
  "24579": -14,
  "24580": -5,
  "24581": -12,
  "24586": -8,
  "24588": -7,
  "24589": -5,
  "24590": 9,
  "24592": -5,
  "24593": -8,
  "24594": -5,
  "24595": -5,
  "24597": -5,
  "24598": -5,
  "24599": -15,
  "24601": -9,
  "24602": -9,
  "24603": -7,
  "24604": -9,
  "24605": -9,
  "24606": -9,
  "24607": -3,
  "24608": -9,
  "24609": -9,
  "24612": -9,
  "24613": -9,
  "24614": -7,
  "24619": -9,
  "24620": -7,
  "24622": -9,
  "24624": -7,
  "24627": -3,
  "24628": -7,
  "24630": -9,
  "24631": -7,
  "24634": -7,
  "24635": -9,
  "24637": -9,
  "24639": -7,
  "24640": -9,
  "24641": -9,
  "24646": -7,
  "24647": -7,
  "24649": -7,
  "24651": -9,
  "24656": -7,
  "24657": -7,
  "24658": -7,
  "24701": -9,
  "24712": -9,
  "24714": -8,
  "24715": -9,
  "24716": -10,
  "24719": -8,
  "24724": -10,
  "24726": -10,
  "24729": -8,
  "24731": -9,
  "24732": -9,
  "24733": -8,
  "24736": -8,
  "24737": -9,
  "24738": -9,
  "24739": -9,
  "24740": -9,
  "24747": -8,
  "24751": -10,
  "24801": -10,
  "24808": -10,
  "24811": -7,
  "24813": -9,
  "24815": -9,
  "24816": -10,
  "24817": -7,
  "24818": -10,
  "24822": -10,
  "24823": -10,
  "24826": -9,
  "24827": -10,
  "24828": -10,
  "24829": -10,
  "24830": -9,
  "24831": -10,
  "24834": -10,
  "24836": -9,
  "24839": -10,
  "24842": -10,
  "24843": -10,
  "24844": -10,
  "24845": -10,
  "24846": -9,
  "24847": -10,
  "24848": -9,
  "24849": -9,
  "24850": -7,
  "24851": -10,
  "24853": -10,
  "24854": -10,
  "24855": -8,
  "24857": -10,
  "24859": -10,
  "24860": -10,
  "24861": -10,
  "24862": -7,
  "24866": -9,
  "24867": -10,
  "24868": -8,
  "24869": -10,
  "24870": -10,
  "24871": -9,
  "24872": -7,
  "24873": -9,
  "24874": -10,
  "24878": -10,
  "24879": -7,
  "24880": -10,
  "24881": -10,
  "24882": -10,
  "24884": -9,
  "24887": -9,
  "24888": -10,
  "24892": -9,
  "24894": -9,
  "24895": -10,
  "24898": -10,
  "24901": -15,
  "24902": -15,
  "24910": 3,
  "24915": -18,
  "24916": -15,
  "24918": -15,
  "24920": -18,
  "24924": -19,
  "24925": -15,
  "24927": -19,
  "24931": -15,
  "24934": -18,
  "24935": 3,
  "24938": -15,
  "24941": -14,
  "24943": 3,
  "24944": -18,
  "24945": -15,
  "24946": -19,
  "24951": 3,
  "24954": -19,
  "24957": -15,
  "24962": 3,
  "24963": -15,
  "24966": -15,
  "24970": -15,
  "24974": -15,
  "24976": -15,
  "24977": -15,
  "24981": 3,
  "24983": -15,
  "24984": -14,
  "24985": 3,
  "24986": -8,
  "24991": -15,
  "24993": -15,
  "25002": -13,
  "25003": 2,
  "25005": -14,
  "25007": -6,
  "25008": -6,
  "25009": -5,
  "25011": 10,
  "25015": 2,
  "25019": -14,
  "25021": -5,
  "25022": -10,
  "25024": -5,
  "25025": 2,
  "25026": 2,
  "25028": -5,
  "25030": -6,
  "25031": -13,
  "25033": 7,
  "25035": 2,
  "25036": -13,
  "25039": 2,
  "25040": -13,
  "25043": -14,
  "25044": -6,
  "25045": -14,
  "25047": -12,
  "25048": -5,
  "25049": -5,
  "25051": -5,
  "25053": -5,
  "25054": 2,
  "25057": -13,
  "25059": -14,
  "25060": -5,
  "25061": 2,
  "25062": -6,
  "25063": -14,
  "25064": 2,
  "25067": 2,
  "25070": 8,
  "25071": 2,
  "25075": 2,
  "25076": -12,
  "25079": -14,
  "25081": -5,
  "25082": 14,
  "25083": -13,
  "25085": -13,
  "25086": 2,
  "25088": -6,
  "25090": -13,
  "25093": -5,
  "25102": -13,
  "25103": -13,
  "25106": -1,
  "25107": 2,
  "25108": -5,
  "25109": 7,
  "25110": 2,
  "25111": -14,
  "25112": 2,
  "25113": -14,
  "25114": -5,
  "25115": -13,
  "25118": -13,
  "25119": -13,
  "25121": -11,
  "25123": 1,
  "25124": 7,
  "25125": -14,
  "25126": -13,
  "25130": -5,
  "25132": 2,
  "25133": -14,
  "25134": 2,
  "25136": -13,
  "25139": -13,
  "25140": -6,
  "25141": -14,
  "25142": -5,
  "25143": 7,
  "25148": -5,
  "25149": -5,
  "25152": -13,
  "25154": -5,
  "25156": 2,
  "25159": 7,
  "25160": -14,
  "25161": -13,
  "25162": 2,
  "25164": -14,
  "25165": -5,
  "25168": 7,
  "25169": -5,
  "25173": -13,
  "25174": -6,
  "25177": 7,
  "25180": -5,
  "25181": -5,
  "25183": -12,
  "25186": -13,
  "25187": 5,
  "25193": -5,
  "25201": 2,
  "25202": 7,
  "25203": -5,
  "25204": -5,
  "25205": -5,
  "25206": -5,
  "25208": -5,
  "25209": -5,
  "25211": -14,
  "25213": 15,
  "25214": 2,
  "25231": -9,
  "25234": 18,
  "25235": 20,
  "25239": -1,
  "25241": 1,
  "25243": -9,
  "25244": 1,
  "25245": 1,
  "25247": -1,
  "25248": -9,
  "25251": -10,
  "25252": -1,
  "25253": -1,
  "25259": -10,
  "25260": -1,
  "25261": 18,
  "25262": -1,
  "25264": -1,
  "25265": -1,
  "25266": -14,
  "25267": 18,
  "25268": 20,
  "25270": -15,
  "25271": 1,
  "25275": -1,
  "25276": -9,
  "25285": -14,
  "25286": -10,
  "25287": -1,
  "25301": 10,
  "25302": 2,
  "25303": 10,
  "25304": 10,
  "25305": 2,
  "25306": 2,
  "25309": 2,
  "25311": 2,
  "25312": 2,
  "25313": 15,
  "25314": 10,
  "25315": 2,
  "25320": 2,
  "25321": 10,
  "25322": 10,
  "25323": 10,
  "25324": 10,
  "25325": 10,
  "25326": 10,
  "25327": 10,
  "25328": 10,
  "25329": 10,
  "25330": 10,
  "25331": 10,
  "25332": 10,
  "25333": 10,
  "25334": 10,
  "25335": 10,
  "25336": 10,
  "25337": 10,
  "25338": 10,
  "25339": 10,
  "25350": 10,
  "25356": 15,
  "25357": 2,
  "25358": 2,
  "25360": 2,
  "25361": 2,
  "25362": 2,
  "25364": 10,
  "25365": 2,
  "25375": 10,
  "25387": 10,
  "25389": 10,
  "25401": -5,
  "25402": -5,
  "25403": -5,
  "25404": -5,
  "25405": -5,
  "25410": 4,
  "25411": -5,
  "25413": -5,
  "25414": -3,
  "25419": -5,
  "25420": -5,
  "25421": -5,
  "25422": -7,
  "25423": -3,
  "25425": 4,
  "25427": -5,
  "25428": -5,
  "25430": -4,
  "25431": -17,
  "25432": -3,
  "25434": -7,
  "25437": -17,
  "25438": -4,
  "25440": -5,
  "25441": -3,
  "25442": 4,
  "25443": 4,
  "25444": -16,
  "25446": -4,
  "25501": 2,
  "25502": 5,
  "25503": 5,
  "25504": 3,
  "25505": -11,
  "25506": 0,
  "25507": 5,
  "25508": -11,
  "25510": 7,
  "25511": -6,
  "25512": -6,
  "25514": -6,
  "25515": 5,
  "25517": -6,
  "25520": -6,
  "25521": 2,
  "25523": 0,
  "25524": 0,
  "25526": 15,
  "25529": -5,
  "25530": -3,
  "25534": 0,
  "25535": -6,
  "25537": -6,
  "25540": 0,
  "25541": -6,
  "25544": 9,
  "25545": 3,
  "25547": -12,
  "25550": -1,
  "25555": -6,
  "25557": 0,
  "25559": -6,
  "25560": 15,
  "25562": -6,
  "25564": 2,
  "25565": 2,
  "25567": 2,
  "25569": 15,
  "25570": -6,
  "25571": 0,
  "25572": 2,
  "25573": 2,
  "25601": -12,
  "25606": -12,
  "25607": -11,
  "25608": -8,
  "25611": -12,
  "25612": -10,
  "25614": -11,
  "25617": -12,
  "25621": -10,
  "25624": -11,
  "25625": -12,
  "25628": -12,
  "25630": -12,
  "25632": -12,
  "25634": -12,
  "25635": -11,
  "25637": -11,
  "25638": -12,
  "25639": -11,
  "25644": -12,
  "25646": -11,
  "25647": -12,
  "25649": -12,
  "25650": -12,
  "25651": -8,
  "25652": -12,
  "25653": -12,
  "25654": -12,
  "25661": -11,
  "25665": -11,
  "25666": -11,
  "25667": -10,
  "25669": -7,
  "25670": -10,
  "25671": -11,
  "25672": -9,
  "25674": -10,
  "25676": -10,
  "25678": -10,
  "25685": -10,
  "25686": -10,
  "25688": -11,
  "25690": -10,
  "25691": -11,
  "25692": -10,
  "25696": -10,
  "25699": -7,
  "25701": -4,
  "25702": -6,
  "25703": -6,
  "25704": -6,
  "25705": -4,
  "25706": -4,
  "25707": -4,
  "25708": -6,
  "25709": -6,
  "25710": -6,
  "25711": -4,
  "25712": -4,
  "25713": -4,
  "25714": -4,
  "25715": -4,
  "25716": -4,
  "25717": -6,
  "25718": -6,
  "25719": -6,
  "25720": -4,
  "25721": -6,
  "25722": -6,
  "25723": -6,
  "25724": -6,
  "25725": -4,
  "25726": -4,
  "25727": -4,
  "25728": -4,
  "25729": -4,
  "25770": -6,
  "25771": -6,
  "25772": -4,
  "25773": -4,
  "25774": -4,
  "25775": -4,
  "25776": -4,
  "25777": -6,
  "25778": -4,
  "25779": -6,
  "25801": -5,
  "25802": -5,
  "25810": -10,
  "25811": -10,
  "25812": -13,
  "25813": 3,
  "25817": -5,
  "25818": 3,
  "25820": -7,
  "25823": -6,
  "25825": -5,
  "25826": -10,
  "25827": -6,
  "25831": -13,
  "25832": 3,
  "25833": -13,
  "25836": -6,
  "25837": -13,
  "25839": -5,
  "25840": -13,
  "25841": -6,
  "25843": 3,
  "25844": -5,
  "25845": -10,
  "25846": -6,
  "25848": -10,
  "25849": -6,
  "25851": -6,
  "25853": -6,
  "25854": -13,
  "25855": -13,
  "25857": -6,
  "25860": 3,
  "25862": -13,
  "25864": -13,
  "25865": -5,
  "25866": -13,
  "25868": -13,
  "25870": -10,
  "25871": -6,
  "25873": -6,
  "25875": -10,
  "25876": -10,
  "25878": -6,
  "25879": -13,
  "25880": -6,
  "25882": -10,
  "25901": -13,
  "25902": -6,
  "25904": -13,
  "25906": -6,
  "25907": -6,
  "25908": -6,
  "25909": 3,
  "25911": -6,
  "25913": -10,
  "25915": -6,
  "25916": -10,
  "25917": -13,
  "25918": -5,
  "25919": -5,
  "25920": -6,
  "25921": -6,
  "25922": -9,
  "25926": -5,
  "25927": 3,
  "25928": -10,
  "25932": -5,
  "25936": -13,
  "25938": -13,
  "25942": -13,
  "25943": -10,
  "25951": 3,
  "25958": -14,
  "25962": -14,
  "25965": 13,
  "25966": 4,
  "25969": 5,
  "25971": -9,
  "25972": -14,
  "25976": 4,
  "25977": 4,
  "25978": 3,
  "25979": 3,
  "25981": -6,
  "25984": -14,
  "25985": 4,
  "25986": 13,
  "25989": 13,
  "26003": -3,
  "26030": -3,
  "26031": -3,
  "26032": -3,
  "26033": 2,
  "26034": -7,
  "26035": -7,
  "26036": -3,
  "26037": -2,
  "26038": 12,
  "26039": 3,
  "26040": 2,
  "26041": 3,
  "26047": -7,
  "26050": -7,
  "26055": 1,
  "26056": -7,
  "26058": -3,
  "26059": -3,
  "26060": -3,
  "26062": -7,
  "26070": -2,
  "26074": -3,
  "26075": -3,
  "26101": -3,
  "26102": -3,
  "26103": -3,
  "26104": -3,
  "26105": -2,
  "26133": -3,
  "26134": 4,
  "26136": 18,
  "26137": 18,
  "26138": -15,
  "26141": 18,
  "26142": -4,
  "26143": -15,
  "26146": 3,
  "26147": 18,
  "26148": -15,
  "26149": 1,
  "26150": -3,
  "26151": 18,
  "26152": -15,
  "26155": 1,
  "26159": 1,
  "26160": -15,
  "26161": -6,
  "26162": 0,
  "26164": -1,
  "26167": 0,
  "26169": -15,
  "26170": 4,
  "26175": -4,
  "26178": -6,
  "26180": -3,
  "26181": 5,
  "26184": -3,
  "26187": 7,
  "26201": -6,
  "26202": -6,
  "26203": -11,
  "26205": -6,
  "26206": -11,
  "26208": -6,
  "26209": -19,
  "26210": -6,
  "26215": -7,
  "26217": -11,
  "26218": -7,
  "26219": -7,
  "26222": -5,
  "26224": -15,
  "26228": -7,
  "26229": -3,
  "26230": -11,
  "26234": -7,
  "26236": -7,
  "26237": -7,
  "26238": -6,
  "26241": -15,
  "26250": -15,
  "26253": -15,
  "26254": -14,
  "26257": -15,
  "26259": -15,
  "26260": -6,
  "26261": -6,
  "26263": -6,
  "26264": -18,
  "26266": -11,
  "26267": -4,
  "26268": -14,
  "26269": -15,
  "26270": -21,
  "26271": -15,
  "26273": -12,
  "26275": -15,
  "26276": -15,
  "26278": -15,
  "26280": -15,
  "26282": -11,
  "26283": -15,
  "26285": -15,
  "26287": -15,
  "26288": -11,
  "26289": -15,
  "26291": -19,
  "26292": -6,
  "26293": -15,
  "26294": -19,
  "26296": -21,
  "26298": -11,
  "26301": 0,
  "26302": -1,
  "26320": 13,
  "26321": -3,
  "26323": -1,
  "26325": -19,
  "26327": -6,
  "26330": 8,
  "26335": -19,
  "26337": -5,
  "26338": -3,
  "26339": 12,
  "26342": -19,
  "26343": -7,
  "26346": -5,
  "26347": -9,
  "26348": 0,
  "26349": -9,
  "26351": -19,
  "26354": -8,
  "26361": -1,
  "26362": -6,
  "26366": 0,
  "26369": -1,
  "26372": -3,
  "26374": -9,
  "26376": -9,
  "26377": 0,
  "26378": -3,
  "26384": -19,
  "26385": 0,
  "26386": -1,
  "26404": -1,
  "26405": -9,
  "26408": 8,
  "26410": -10,
  "26411": 13,
  "26412": -4,
  "26415": -5,
  "26416": -8,
  "26419": 0,
  "26421": -5,
  "26422": 0,
  "26424": -9,
  "26425": -15,
  "26426": 13,
  "26430": -19,
  "26431": -1,
  "26434": 13,
  "26435": -9,
  "26436": 12,
  "26437": 0,
  "26438": -1,
  "26440": -9,
  "26443": -18,
  "26444": -10,
  "26447": -4,
  "26448": -1,
  "26451": 0,
  "26452": -3,
  "26456": 12,
  "26461": 0,
  "26463": -9,
  "26501": 4,
  "26502": -5,
  "26504": 4,
  "26505": 4,
  "26506": -5,
  "26507": 4,
  "26508": -5,
  "26519": -10,
  "26520": -10,
  "26521": -9,
  "26524": -10,
  "26525": -10,
  "26527": -5,
  "26531": -5,
  "26534": -5,
  "26537": -10,
  "26541": -5,
  "26542": -10,
  "26543": -5,
  "26544": -5,
  "26546": -5,
  "26547": -10,
  "26554": -9,
  "26555": -9,
  "26559": -9,
  "26560": -9,
  "26561": 0,
  "26562": 1,
  "26563": -9,
  "26566": -9,
  "26568": -9,
  "26570": -9,
  "26571": -9,
  "26572": -9,
  "26574": -9,
  "26575": 0,
  "26576": -9,
  "26578": -9,
  "26581": 0,
  "26582": -9,
  "26585": -9,
  "26586": -9,
  "26587": -9,
  "26588": -9,
  "26590": -9,
  "26591": -9,
  "26601": -8,
  "26610": -6,
  "26611": -19,
  "26615": -19,
  "26617": -14,
  "26619": -10,
  "26621": -7,
  "26623": -8,
  "26624": -8,
  "26627": -9,
  "26629": -8,
  "26631": -10,
  "26636": -8,
  "26638": -8,
  "26651": -6,
  "26656": -13,
  "26660": -6,
  "26662": -5,
  "26667": -6,
  "26671": -6,
  "26675": -6,
  "26676": -6,
  "26678": -6,
  "26679": -6,
  "26680": -13,
  "26681": -6,
  "26684": -6,
  "26690": -13,
  "26691": -6,
  "26704": -17,
  "26705": -10,
  "26707": -6,
  "26710": -9,
  "26711": -16,
  "26714": -16,
  "26716": -10,
  "26717": -10,
  "26719": 0,
  "26720": -6,
  "26722": -1,
  "26726": -9,
  "26731": -6,
  "26739": -6,
  "26743": -9,
  "26750": -9,
  "26753": -1,
  "26755": -17,
  "26757": -17,
  "26761": -17,
  "26763": -17,
  "26764": -10,
  "26767": -1,
  "26801": -16,
  "26802": -19,
  "26804": -19,
  "26807": -19,
  "26808": -16,
  "26810": -16,
  "26812": -16,
  "26814": -19,
  "26815": -19,
  "26817": -16,
  "26818": -16,
  "26823": -17,
  "26833": -6,
  "26836": -16,
  "26838": -13,
  "26845": -15,
  "26847": -6,
  "26851": -15,
  "26852": -9,
  "26855": -6,
  "26865": -16,
  "26866": -21,
  "26884": -21,
  "26886": -21,
  "27006": 6,
  "27007": -1,
  "27009": -2,
  "27010": -1,
  "27011": -7,
  "27012": 6,
  "27013": -1,
  "27014": -8,
  "27016": -11,
  "27017": -1,
  "27018": -7,
  "27019": -10,
  "27020": -7,
  "27021": -11,
  "27022": -11,
  "27023": 6,
  "27024": -1,
  "27025": -4,
  "27027": -4,
  "27028": -7,
  "27030": -1,
  "27031": -1,
  "27040": -1,
  "27041": -1,
  "27042": -11,
  "27043": -2,
  "27045": -2,
  "27046": -11,
  "27047": -1,
  "27048": -4,
  "27049": -1,
  "27050": -2,
  "27051": -3,
  "27052": -11,
  "27053": -11,
  "27054": -8,
  "27055": -7,
  "27101": -3,
  "27102": -3,
  "27103": -2,
  "27104": 6,
  "27105": -3,
  "27106": 6,
  "27107": -3,
  "27108": -3,
  "27109": 6,
  "27113": -3,
  "27114": -3,
  "27115": -3,
  "27116": -3,
  "27117": -3,
  "27120": -3,
  "27127": -2,
  "27130": -2,
  "27201": 3,
  "27202": -6,
  "27203": -3,
  "27204": -3,
  "27205": -3,
  "27207": -5,
  "27208": -5,
  "27209": 11,
  "27212": -7,
  "27213": -4,
  "27214": 2,
  "27215": 3,
  "27216": 3,
  "27217": -6,
  "27228": -3,
  "27229": 11,
  "27230": -4,
  "27231": -2,
  "27233": 2,
  "27235": 10,
  "27237": -5,
  "27239": -8,
  "27242": -6,
  "27243": -1,
  "27244": -5,
  "27247": 11,
  "27248": -4,
  "27249": -5,
  "27252": -4,
  "27253": -5,
  "27256": -5,
  "27258": -6,
  "27259": -5,
  "27260": 2,
  "27261": 2,
  "27262": 2,
  "27263": 2,
  "27264": 2,
  "27265": 3,
  "27278": 0,
  "27281": -6,
  "27282": 10,
  "27283": 2,
  "27284": -1,
  "27285": -1,
  "27288": -6,
  "27289": -6,
  "27291": 2,
  "27292": -8,
  "27293": -8,
  "27295": -7,
  "27298": -6,
  "27299": -9,
  "27301": 2,
  "27302": -5,
  "27305": -7,
  "27306": 12,
  "27310": 11,
  "27311": -7,
  "27312": -3,
  "27313": 2,
  "27314": -6,
  "27315": -7,
  "27316": -4,
  "27317": -4,
  "27320": -4,
  "27323": -4,
  "27325": -5,
  "27326": -6,
  "27330": -6,
  "27331": -6,
  "27332": -6,
  "27340": -5,
  "27341": 11,
  "27342": -6,
  "27343": -6,
  "27344": -5,
  "27349": -5,
  "27350": -4,
  "27351": -7,
  "27355": -4,
  "27356": 11,
  "27357": 2,
  "27358": 2,
  "27359": -5,
  "27360": -8,
  "27361": -8,
  "27370": -3,
  "27371": 12,
  "27373": -3,
  "27374": -8,
  "27375": -4,
  "27376": 3,
  "27377": -5,
  "27379": -7,
  "27401": 2,
  "27402": 2,
  "27403": 2,
  "27404": 2,
  "27405": 2,
  "27406": 2,
  "27407": 2,
  "27408": 2,
  "27409": 2,
  "27410": 4,
  "27415": -6,
  "27416": 2,
  "27417": 2,
  "27419": 2,
  "27420": 2,
  "27425": 2,
  "27427": 2,
  "27429": 2,
  "27435": 2,
  "27438": 2,
  "27455": 2,
  "27495": 2,
  "27501": -5,
  "27502": 7,
  "27503": 4,
  "27504": -2,
  "27505": -7,
  "27506": -6,
  "27507": -9,
  "27508": -4,
  "27509": -9,
  "27510": 0,
  "27511": 7,
  "27512": 7,
  "27513": 8,
  "27514": 8,
  "27515": 8,
  "27516": 0,
  "27517": 8,
  "27518": 7,
  "27519": 8,
  "27520": -2,
  "27521": -7,
  "27522": -9,
  "27523": 7,
  "27524": -4,
  "27525": -4,
  "27526": -5,
  "27527": -2,
  "27528": -2,
  "27529": 7,
  "27530": -4,
  "27531": -4,
  "27532": 4,
  "27533": 4,
  "27534": 4,
  "27536": -6,
  "27537": -6,
  "27539": 7,
  "27540": 7,
  "27541": -4,
  "27542": -3,
  "27543": -7,
  "27544": -6,
  "27545": 7,
  "27546": -7,
  "27549": -6,
  "27551": -13,
  "27552": -7,
  "27553": -7,
  "27555": -4,
  "27556": -6,
  "27557": -1,
  "27559": -4,
  "27560": 15,
  "27562": 7,
  "27563": -13,
  "27564": -9,
  "27565": -9,
  "27568": -4,
  "27569": -4,
  "27570": -13,
  "27571": -4,
  "27572": -4,
  "27573": -6,
  "27574": -6,
  "27576": -4,
  "27577": 4,
  "27581": -9,
  "27582": -6,
  "27583": -4,
  "27584": -6,
  "27586": -13,
  "27587": -4,
  "27588": -4,
  "27589": -13,
  "27591": 7,
  "27592": -5,
  "27593": -4,
  "27594": -13,
  "27596": -4,
  "27597": -4,
  "27601": 7,
  "27602": 7,
  "27603": 7,
  "27604": 7,
  "27605": 8,
  "27606": 7,
  "27607": 8,
  "27608": 16,
  "27609": 7,
  "27610": 7,
  "27611": 7,
  "27612": 8,
  "27613": 8,
  "27614": 18,
  "27615": 8,
  "27616": 7,
  "27617": 7,
  "27619": 7,
  "27620": 7,
  "27621": 7,
  "27622": 8,
  "27623": 15,
  "27624": 7,
  "27625": 7,
  "27626": 7,
  "27627": 7,
  "27628": 16,
  "27629": 7,
  "27636": 8,
  "27650": 8,
  "27658": 7,
  "27661": 7,
  "27675": 8,
  "27676": 7,
  "27701": 3,
  "27702": 3,
  "27703": 3,
  "27704": 3,
  "27705": 4,
  "27706": 12,
  "27707": 4,
  "27709": 3,
  "27712": 4,
  "27713": 4,
  "27715": 4,
  "27717": 4,
  "27722": 3,
  "27801": -9,
  "27802": -2,
  "27803": -1,
  "27804": -1,
  "27805": -7,
  "27806": -13,
  "27807": -2,
  "27808": -2,
  "27809": -2,
  "27810": -3,
  "27811": -8,
  "27812": -7,
  "27813": -3,
  "27814": -3,
  "27816": -2,
  "27817": -2,
  "27818": -11,
  "27819": -9,
  "27820": 0,
  "27821": -3,
  "27822": -2,
  "27823": -6,
  "27824": -17,
  "27825": -7,
  "27826": -17,
  "27827": -3,
  "27828": -8,
  "27829": -8,
  "27830": -3,
  "27831": 0,
  "27832": 0,
  "27833": -3,
  "27834": -3,
  "27835": -3,
  "27836": -3,
  "27837": -3,
  "27839": -6,
  "27840": -7,
  "27841": -7,
  "27842": -4,
  "27843": -9,
  "27844": -13,
  "27845": 0,
  "27846": -7,
  "27847": -12,
  "27849": -7,
  "27850": -4,
  "27851": -3,
  "27852": -9,
  "27853": 0,
  "27855": -11,
  "27856": -2,
  "27857": -7,
  "27858": 5,
  "27860": -12,
  "27861": -7,
  "27862": -11,
  "27863": -4,
  "27864": -9,
  "27865": -2,
  "27866": 0,
  "27867": -11,
  "27868": -2,
  "27869": 0,
  "27870": -6,
  "27871": -7,
  "27872": -12,
  "27873": -2,
  "27874": -9,
  "27875": -17,
  "27876": 0,
  "27877": -7,
  "27878": -2,
  "27879": 5,
  "27880": -2,
  "27881": -9,
  "27882": -2,
  "27883": -3,
  "27884": -3,
  "27885": -16,
  "27886": -9,
  "27887": -6,
  "27888": -8,
  "27889": -2,
  "27890": -6,
  "27891": -9,
  "27892": -7,
  "27893": -2,
  "27894": -2,
  "27895": 6,
  "27896": 6,
  "27897": -11,
  "27906": -5,
  "27907": -5,
  "27909": -5,
  "27910": -11,
  "27915": -6,
  "27916": -7,
  "27917": -7,
  "27919": -7,
  "27920": 1,
  "27921": -8,
  "27922": -11,
  "27923": -7,
  "27924": -9,
  "27925": -14,
  "27926": -1,
  "27927": -7,
  "27928": -14,
  "27929": -7,
  "27930": -7,
  "27932": -9,
  "27935": -11,
  "27936": -8,
  "27937": -17,
  "27938": -10,
  "27939": -7,
  "27941": -7,
  "27942": -11,
  "27943": -8,
  "27944": -7,
  "27946": -7,
  "27947": -7,
  "27948": -7,
  "27949": 2,
  "27950": -7,
  "27953": -7,
  "27954": -7,
  "27956": -7,
  "27957": -10,
  "27958": -8,
  "27959": -6,
  "27960": -8,
  "27962": -12,
  "27964": -7,
  "27965": -7,
  "27966": -7,
  "27967": -11,
  "27968": -7,
  "27969": -11,
  "27970": -12,
  "27972": -6,
  "27973": -8,
  "27974": -8,
  "27976": -10,
  "27978": -7,
  "27979": -7,
  "27980": -9,
  "27981": -7,
  "27982": -7,
  "27983": -7,
  "27985": -7,
  "27986": -11,
  "28001": -3,
  "28002": -3,
  "28006": -2,
  "28007": -9,
  "28009": -3,
  "28010": -1,
  "28012": -2,
  "28016": -3,
  "28017": -7,
  "28018": -2,
  "28019": -2,
  "28020": -7,
  "28021": -6,
  "28023": -3,
  "28024": -2,
  "28025": -1,
  "28026": -1,
  "28027": -1,
  "28031": 14,
  "28032": -3,
  "28033": -2,
  "28034": -2,
  "28035": 6,
  "28036": 6,
  "28037": 7,
  "28038": -7,
  "28039": -4,
  "28040": -2,
  "28041": -3,
  "28042": -7,
  "28043": -2,
  "28052": -3,
  "28053": -3,
  "28054": -2,
  "28055": -3,
  "28056": -2,
  "28070": 8,
  "28071": -3,
  "28072": -3,
  "28073": -7,
  "28074": -2,
  "28075": 8,
  "28076": -2,
  "28077": -2,
  "28078": 8,
  "28079": 8,
  "28080": -2,
  "28081": -2,
  "28082": -2,
  "28083": -2,
  "28086": -6,
  "28088": -3,
  "28089": -7,
  "28090": -7,
  "28091": -9,
  "28092": -2,
  "28093": -2,
  "28097": -3,
  "28098": -3,
  "28101": -2,
  "28102": -10,
  "28103": 7,
  "28104": 8,
  "28105": 8,
  "28106": 8,
  "28107": -1,
  "28108": 15,
  "28109": -4,
  "28110": 7,
  "28111": 7,
  "28112": 7,
  "28114": -2,
  "28115": -1,
  "28117": -1,
  "28119": -9,
  "28120": -2,
  "28123": 7,
  "28124": 1,
  "28125": -1,
  "28126": 7,
  "28127": -3,
  "28128": -3,
  "28129": -3,
  "28130": 7,
  "28133": -9,
  "28134": 7,
  "28135": -9,
  "28136": -7,
  "28137": -4,
  "28138": -3,
  "28139": -2,
  "28144": -3,
  "28145": -3,
  "28146": -3,
  "28147": -3,
  "28150": -6,
  "28151": -6,
  "28152": -7,
  "28159": -4,
  "28160": -2,
  "28163": -3,
  "28164": -2,
  "28166": -1,
  "28167": -2,
  "28168": -1,
  "28169": -7,
  "28170": -9,
  "28173": 15,
  "28174": 7,
  "28201": 19,
  "28202": 8,
  "28203": 8,
  "28204": 8,
  "28205": 7,
  "28206": 7,
  "28207": 19,
  "28208": 7,
  "28209": 8,
  "28210": 8,
  "28211": 8,
  "28212": 7,
  "28213": 7,
  "28214": 7,
  "28215": 7,
  "28216": 7,
  "28217": 7,
  "28218": 7,
  "28219": 7,
  "28220": 8,
  "28221": 8,
  "28222": 19,
  "28223": 8,
  "28224": 8,
  "28226": 8,
  "28227": 7,
  "28229": 7,
  "28230": 8,
  "28231": 19,
  "28232": 8,
  "28233": 8,
  "28234": 8,
  "28235": 8,
  "28236": -2,
  "28237": 8,
  "28241": 8,
  "28244": 8,
  "28246": 8,
  "28247": 8,
  "28254": 7,
  "28256": 7,
  "28260": 8,
  "28262": 8,
  "28265": 8,
  "28266": 8,
  "28269": 8,
  "28270": 8,
  "28271": 8,
  "28272": 8,
  "28273": 8,
  "28275": 8,
  "28277": 8,
  "28278": 8,
  "28280": 8,
  "28281": 8,
  "28282": 8,
  "28284": 8,
  "28285": 8,
  "28287": 8,
  "28297": 7,
  "28299": 8,
  "28301": -1,
  "28302": -1,
  "28303": 0,
  "28304": -1,
  "28305": 8,
  "28306": -1,
  "28307": -1,
  "28308": 8,
  "28309": 8,
  "28311": 0,
  "28312": -1,
  "28314": 0,
  "28315": -6,
  "28318": -12,
  "28319": -18,
  "28320": -9,
  "28323": -7,
  "28325": -11,
  "28326": -7,
  "28327": -5,
  "28328": -12,
  "28329": -12,
  "28330": -6,
  "28331": -1,
  "28332": -9,
  "28333": -4,
  "28334": -7,
  "28335": -7,
  "28337": -9,
  "28338": -6,
  "28339": -7,
  "28340": -4,
  "28341": -11,
  "28342": -6,
  "28343": -13,
  "28344": -6,
  "28345": -6,
  "28347": -6,
  "28348": -1,
  "28349": -11,
  "28350": -6,
  "28351": -13,
  "28352": -13,
  "28353": -13,
  "28355": -6,
  "28356": -7,
  "28357": -9,
  "28358": -4,
  "28359": -4,
  "28360": -4,
  "28362": -18,
  "28363": -13,
  "28364": -13,
  "28365": -4,
  "28366": -12,
  "28367": -6,
  "28368": -7,
  "28369": -4,
  "28370": 3,
  "28371": -1,
  "28372": -4,
  "28373": -5,
  "28374": 3,
  "28375": -4,
  "28376": -9,
  "28377": -9,
  "28378": -8,
  "28379": -6,
  "28380": -6,
  "28382": -12,
  "28383": -4,
  "28384": -4,
  "28385": -12,
  "28386": -9,
  "28387": 3,
  "28388": 3,
  "28390": -1,
  "28391": -1,
  "28392": -9,
  "28393": -12,
  "28394": -5,
  "28395": -1,
  "28396": -13,
  "28398": -11,
  "28399": -9,
  "28401": 0,
  "28402": 0,
  "28403": 1,
  "28404": -3,
  "28405": 1,
  "28406": 1,
  "28407": 1,
  "28408": 0,
  "28409": 1,
  "28411": 0,
  "28412": 1,
  "28420": -4,
  "28421": -8,
  "28422": -3,
  "28423": -4,
  "28424": -10,
  "28425": -8,
  "28428": 1,
  "28429": 0,
  "28430": -10,
  "28431": -10,
  "28432": -10,
  "28433": -9,
  "28434": -8,
  "28435": -8,
  "28436": -9,
  "28438": -10,
  "28439": -18,
  "28441": -12,
  "28442": -9,
  "28443": -7,
  "28444": -8,
  "28445": -6,
  "28447": -8,
  "28448": -8,
  "28449": 1,
  "28450": -9,
  "28451": 0,
  "28452": -4,
  "28453": -11,
  "28454": -7,
  "28455": -10,
  "28456": -9,
  "28457": -8,
  "28458": -11,
  "28459": -3,
  "28460": -6,
  "28461": -3,
  "28462": -3,
  "28463": -10,
  "28464": -11,
  "28465": -3,
  "28466": -11,
  "28467": -4,
  "28468": 5,
  "28469": -3,
  "28470": -3,
  "28472": -10,
  "28478": -8,
  "28479": 0,
  "28480": 11,
  "28501": -5,
  "28502": -5,
  "28503": -5,
  "28504": -5,
  "28508": -5,
  "28509": -13,
  "28510": -13,
  "28511": -10,
  "28512": -1,
  "28513": -3,
  "28515": -13,
  "28516": -10,
  "28518": -11,
  "28519": -7,
  "28520": -10,
  "28521": -11,
  "28522": -15,
  "28523": -14,
  "28524": -10,
  "28525": -5,
  "28526": -5,
  "28527": -7,
  "28528": -10,
  "28529": -14,
  "28530": -4,
  "28531": -10,
  "28532": -10,
  "28533": -10,
  "28537": -13,
  "28538": -8,
  "28539": -7,
  "28540": -6,
  "28541": -6,
  "28542": -7,
  "28543": -7,
  "28544": -7,
  "28545": -7,
  "28546": -6,
  "28547": -7,
  "28551": -5,
  "28552": -13,
  "28553": -8,
  "28554": -8,
  "28555": -15,
  "28556": -14,
  "28557": -10,
  "28560": -7,
  "28561": -7,
  "28562": -7,
  "28563": -7,
  "28564": -7,
  "28570": -10,
  "28571": -5,
  "28572": -5,
  "28573": -15,
  "28574": -15,
  "28575": -10,
  "28577": -10,
  "28578": -4,
  "28579": -10,
  "28580": -9,
  "28581": -10,
  "28582": -6,
  "28583": -13,
  "28584": -6,
  "28585": -15,
  "28586": -7,
  "28587": -13,
  "28589": -10,
  "28590": -3,
  "28594": -1,
  "28601": -2,
  "28602": -2,
  "28603": -2,
  "28604": -10,
  "28605": -3,
  "28606": -11,
  "28607": -12,
  "28609": -2,
  "28610": -3,
  "28611": -11,
  "28612": -10,
  "28613": -2,
  "28615": -6,
  "28616": -10,
  "28617": -6,
  "28618": -12,
  "28619": -10,
  "28621": -15,
  "28622": -10,
  "28623": -15,
  "28624": -11,
  "28625": 1,
  "28626": -6,
  "28627": -16,
  "28628": -10,
  "28629": -6,
  "28630": -8,
  "28631": 2,
  "28634": -7,
  "28635": -11,
  "28636": -12,
  "28637": -3,
  "28638": -10,
  "28640": -6,
  "28641": -11,
  "28642": -7,
  "28643": -5,
  "28644": -16,
  "28645": -10,
  "28646": -10,
  "28647": -10,
  "28649": -11,
  "28650": -1,
  "28651": -10,
  "28652": -11,
  "28653": -10,
  "28654": -11,
  "28655": -10,
  "28657": -11,
  "28658": -2,
  "28659": -11,
  "28660": 1,
  "28661": -10,
  "28662": -10,
  "28663": -16,
  "28664": -11,
  "28665": -11,
  "28666": -2,
  "28667": -8,
  "28668": -7,
  "28669": -11,
  "28670": -9,
  "28671": -10,
  "28672": -6,
  "28673": 9,
  "28675": -16,
  "28676": -15,
  "28677": 1,
  "28678": -12,
  "28679": -12,
  "28680": -10,
  "28681": -12,
  "28682": 7,
  "28683": -15,
  "28684": -6,
  "28685": -11,
  "28687": 1,
  "28688": 1,
  "28689": -6,
  "28690": -10,
  "28691": -10,
  "28692": -12,
  "28693": -5,
  "28694": -6,
  "28697": -10,
  "28698": -4,
  "28699": -12,
  "28701": -8,
  "28702": 0,
  "28704": -1,
  "28705": -8,
  "28707": -8,
  "28708": -9,
  "28709": -7,
  "28710": -1,
  "28711": -1,
  "28712": -9,
  "28713": -2,
  "28714": -7,
  "28715": -1,
  "28716": -8,
  "28717": -6,
  "28718": -9,
  "28719": -1,
  "28720": -1,
  "28721": 1,
  "28722": 3,
  "28723": -8,
  "28724": -5,
  "28725": -8,
  "28726": -5,
  "28727": -5,
  "28728": -1,
  "28729": -5,
  "28730": -1,
  "28731": -5,
  "28732": -5,
  "28733": -2,
  "28734": -11,
  "28735": -1,
  "28736": 1,
  "28737": -10,
  "28738": -8,
  "28739": -5,
  "28740": -7,
  "28741": -2,
  "28742": -5,
  "28743": -9,
  "28744": -11,
  "28745": 1,
  "28746": -4,
  "28747": -9,
  "28748": -1,
  "28749": -1,
  "28750": 3,
  "28751": -7,
  "28752": -10,
  "28753": -9,
  "28754": -8,
  "28755": -7,
  "28756": -4,
  "28757": 8,
  "28758": -5,
  "28759": -5,
  "28760": -5,
  "28761": -10,
  "28762": -9,
  "28763": -11,
  "28765": -8,
  "28766": -9,
  "28768": -9,
  "28770": -1,
  "28771": -2,
  "28772": -9,
  "28773": -4,
  "28774": 0,
  "28775": -11,
  "28776": -1,
  "28777": -8,
  "28778": -1,
  "28779": -8,
  "28781": -2,
  "28782": 3,
  "28783": -8,
  "28784": -5,
  "28785": 1,
  "28786": -8,
  "28787": -1,
  "28788": -8,
  "28789": -1,
  "28790": -5,
  "28791": -5,
  "28792": -5,
  "28793": -5,
  "28801": -1,
  "28802": -1,
  "28803": -1,
  "28804": 8,
  "28805": -1,
  "28806": -1,
  "28810": -1,
  "28813": -1,
  "28814": 8,
  "28815": -1,
  "28816": -1,
  "28901": -2,
  "28902": -12,
  "28903": -12,
  "28904": 4,
  "28905": -12,
  "28906": -12,
  "28909": 4,
  "29001": -15,
  "29002": -4,
  "29003": -18,
  "29006": -12,
  "29009": -11,
  "29010": -18,
  "29014": -5,
  "29015": -7,
  "29016": 3,
  "29018": -3,
  "29020": -2,
  "29021": -2,
  "29030": -7,
  "29031": -7,
  "29032": -11,
  "29033": 1,
  "29036": 5,
  "29037": -8,
  "29038": -18,
  "29039": -1,
  "29040": -3,
  "29041": -15,
  "29042": -18,
  "29044": -6,
  "29045": 1,
  "29046": -18,
  "29047": -2,
  "29048": -15,
  "29051": -15,
  "29052": -6,
  "29053": -4,
  "29054": -4,
  "29055": -5,
  "29056": -5,
  "29058": -5,
  "29059": -6,
  "29061": 1,
  "29062": -11,
  "29063": -4,
  "29065": -6,
  "29067": -5,
  "29069": -17,
  "29070": -4,
  "29071": 5,
  "29072": 5,
  "29073": -4,
  "29074": -10,
  "29075": -6,
  "29078": -10,
  "29079": -5,
  "29080": -18,
  "29081": -18,
  "29082": -21,
  "29101": -16,
  "29102": -15,
  "29104": -3,
  "29105": -13,
  "29107": -1,
  "29108": -5,
  "29111": -15,
  "29112": -6,
  "29113": -18,
  "29114": -5,
  "29115": -1,
  "29116": -1,
  "29118": -1,
  "29122": -5,
  "29123": -4,
  "29125": -15,
  "29126": -5,
  "29127": -5,
  "29128": -11,
  "29129": -12,
  "29130": -6,
  "29132": -7,
  "29133": -1,
  "29135": -6,
  "29137": -5,
  "29138": -12,
  "29142": -2,
  "29143": -15,
  "29145": -5,
  "29146": -5,
  "29147": 1,
  "29148": -15,
  "29150": -2,
  "29151": -2,
  "29152": -3,
  "29153": -2,
  "29154": 6,
  "29160": -6,
  "29161": -5,
  "29162": -15,
  "29163": -15,
  "29164": 9,
  "29166": -13,
  "29168": -2,
  "29169": 1,
  "29170": -4,
  "29171": 1,
  "29172": -4,
  "29175": -10,
  "29177": 5,
  "29178": -7,
  "29180": -6,
  "29201": 1,
  "29202": 3,
  "29203": 1,
  "29204": 1,
  "29205": 3,
  "29206": 9,
  "29207": 9,
  "29209": 1,
  "29210": 1,
  "29211": 5,
  "29212": -2,
  "29221": 1,
  "29222": 1,
  "29223": 1,
  "29224": 1,
  "29228": -4,
  "29229": 9,
  "29230": 1,
  "29240": 1,
  "29250": 3,
  "29260": 9,
  "29290": 1,
  "29292": -4,
  "29301": -2,
  "29302": 0,
  "29303": -2,
  "29304": -2,
  "29305": -2,
  "29306": -2,
  "29307": -1,
  "29316": -2,
  "29318": -2,
  "29320": -2,
  "29321": -7,
  "29322": -2,
  "29323": -2,
  "29324": 0,
  "29325": -9,
  "29329": 0,
  "29330": -1,
  "29331": -9,
  "29332": -9,
  "29333": 0,
  "29334": -2,
  "29335": -9,
  "29336": -2,
  "29338": -2,
  "29340": -1,
  "29341": -1,
  "29342": -1,
  "29346": -1,
  "29348": -2,
  "29349": -2,
  "29351": -9,
  "29353": -7,
  "29355": -6,
  "29356": -2,
  "29360": -9,
  "29364": -7,
  "29365": -2,
  "29368": -1,
  "29369": 6,
  "29370": -9,
  "29372": -1,
  "29373": -1,
  "29374": -7,
  "29375": -2,
  "29376": -2,
  "29377": -2,
  "29378": -2,
  "29379": -7,
  "29384": -9,
  "29385": -2,
  "29386": -1,
  "29388": -2,
  "29401": 18,
  "29402": 18,
  "29403": 7,
  "29404": 4,
  "29405": 4,
  "29406": 4,
  "29407": 7,
  "29410": -1,
  "29412": 7,
  "29413": 18,
  "29414": 7,
  "29415": -1,
  "29416": 4,
  "29417": 7,
  "29418": 4,
  "29419": 4,
  "29420": 4,
  "29422": 9,
  "29423": 4,
  "29426": -5,
  "29429": -1,
  "29430": -2,
  "29431": -1,
  "29432": -21,
  "29433": -9,
  "29434": -2,
  "29435": -5,
  "29436": -1,
  "29437": -5,
  "29438": 7,
  "29439": 9,
  "29440": -6,
  "29442": -6,
  "29445": -1,
  "29446": -7,
  "29447": -6,
  "29448": -6,
  "29449": 7,
  "29450": -1,
  "29451": 9,
  "29452": -9,
  "29453": -8,
  "29455": 7,
  "29456": -1,
  "29457": 7,
  "29458": -8,
  "29461": -1,
  "29464": 7,
  "29465": 7,
  "29466": 7,
  "29468": -16,
  "29469": 7,
  "29470": 4,
  "29471": -3,
  "29472": -5,
  "29474": -9,
  "29475": -9,
  "29476": -1,
  "29477": -6,
  "29479": -1,
  "29481": -9,
  "29482": 18,
  "29483": -5,
  "29484": -5,
  "29485": -4,
  "29487": 7,
  "29488": -9,
  "29492": 13,
  "29493": -9,
  "29501": 3,
  "29502": 3,
  "29503": 3,
  "29504": 3,
  "29505": 3,
  "29506": -5,
  "29510": -10,
  "29511": -6,
  "29512": -10,
  "29516": -10,
  "29518": -5,
  "29519": -7,
  "29520": -16,
  "29525": -10,
  "29526": -5,
  "29527": -5,
  "29528": -5,
  "29530": -5,
  "29532": -5,
  "29536": -18,
  "29540": -5,
  "29541": 3,
  "29543": -18,
  "29544": -6,
  "29545": -6,
  "29546": -7,
  "29547": -18,
  "29550": -5,
  "29551": -5,
  "29554": -10,
  "29555": -10,
  "29556": -10,
  "29560": -5,
  "29563": -18,
  "29564": -11,
  "29565": -18,
  "29566": -5,
  "29567": -18,
  "29568": -5,
  "29569": -5,
  "29570": -10,
  "29571": -7,
  "29572": 4,
  "29573": -18,
  "29574": -7,
  "29575": -5,
  "29576": -6,
  "29577": -5,
  "29578": -5,
  "29579": -5,
  "29580": -11,
  "29581": -6,
  "29582": -4,
  "29583": -5,
  "29584": -16,
  "29585": 3,
  "29587": -5,
  "29588": -5,
  "29589": -7,
  "29590": -11,
  "29591": -5,
  "29592": -18,
  "29593": -5,
  "29594": -10,
  "29596": -10,
  "29597": -4,
  "29598": -4,
  "29601": 6,
  "29602": 6,
  "29603": 6,
  "29604": 6,
  "29605": 6,
  "29606": 6,
  "29607": 6,
  "29608": 6,
  "29609": 6,
  "29610": 6,
  "29611": 6,
  "29612": 6,
  "29615": 6,
  "29616": 6,
  "29617": 6,
  "29620": -13,
  "29621": -6,
  "29622": -6,
  "29623": -6,
  "29624": -6,
  "29625": -6,
  "29626": -6,
  "29627": -6,
  "29628": -13,
  "29630": -9,
  "29631": -1,
  "29633": -9,
  "29635": -8,
  "29636": 6,
  "29638": -9,
  "29639": -13,
  "29640": -8,
  "29641": -8,
  "29642": -8,
  "29643": -9,
  "29644": 6,
  "29645": -8,
  "29646": -9,
  "29648": -9,
  "29649": -9,
  "29650": 6,
  "29651": 6,
  "29652": 6,
  "29653": -9,
  "29654": -6,
  "29655": -13,
  "29656": -6,
  "29657": -8,
  "29658": -9,
  "29659": -13,
  "29661": 6,
  "29662": 6,
  "29664": -9,
  "29665": -9,
  "29666": -8,
  "29667": -9,
  "29669": -6,
  "29670": -6,
  "29671": -8,
  "29672": -9,
  "29673": 6,
  "29675": -9,
  "29676": -1,
  "29677": -6,
  "29678": -9,
  "29679": -9,
  "29680": 6,
  "29681": 6,
  "29682": -9,
  "29683": 6,
  "29684": -6,
  "29685": -8,
  "29686": -1,
  "29687": 6,
  "29688": 6,
  "29689": -6,
  "29690": 6,
  "29691": -9,
  "29692": -9,
  "29693": -9,
  "29696": -9,
  "29697": -6,
  "29702": 0,
  "29703": 0,
  "29704": -1,
  "29706": -1,
  "29707": -1,
  "29708": -1,
  "29709": -16,
  "29710": 0,
  "29712": -1,
  "29714": -5,
  "29715": -1,
  "29716": -1,
  "29717": 0,
  "29718": -16,
  "29720": -5,
  "29721": -5,
  "29724": -1,
  "29726": -1,
  "29727": -16,
  "29728": -16,
  "29729": -1,
  "29730": -1,
  "29731": -1,
  "29732": -1,
  "29734": -1,
  "29741": -16,
  "29742": -6,
  "29743": 0,
  "29744": -1,
  "29745": -1,
  "29801": 9,
  "29802": 9,
  "29803": 17,
  "29804": 8,
  "29805": 9,
  "29809": 9,
  "29810": -4,
  "29812": -4,
  "29813": -4,
  "29816": 8,
  "29817": -5,
  "29819": -9,
  "29821": -5,
  "29822": -6,
  "29824": -8,
  "29826": -5,
  "29827": -4,
  "29828": 8,
  "29829": 9,
  "29831": -6,
  "29832": -8,
  "29834": 8,
  "29835": -11,
  "29836": -5,
  "29838": -3,
  "29839": 8,
  "29840": -11,
  "29841": -6,
  "29842": -6,
  "29843": -18,
  "29844": -11,
  "29845": -12,
  "29846": -18,
  "29847": -8,
  "29848": -11,
  "29849": -18,
  "29850": 9,
  "29851": 8,
  "29853": -5,
  "29856": 8,
  "29860": -6,
  "29861": -6,
  "29901": -2,
  "29902": -2,
  "29903": -2,
  "29904": -2,
  "29905": -2,
  "29906": -2,
  "29907": -2,
  "29909": 6,
  "29910": 6,
  "29911": -4,
  "29912": 2,
  "29913": -5,
  "29914": -2,
  "29915": 6,
  "29916": -5,
  "29918": -5,
  "29920": -2,
  "29921": -5,
  "29922": -5,
  "29923": -4,
  "29924": -5,
  "29925": 8,
  "29926": 6,
  "29927": 2,
  "29928": 8,
  "29929": -9,
  "29931": -2,
  "29932": -4,
  "29933": -9,
  "29934": -5,
  "29935": -2,
  "29936": 2,
  "29938": 8,
  "29939": -5,
  "29940": -2,
  "29941": -2,
  "29943": 2,
  "29944": -5,
  "29945": -8,
  "30002": 8,
  "30003": 5,
  "30004": 5,
  "30005": 15,
  "30006": 8,
  "30007": 8,
  "30008": 9,
  "30009": 15,
  "30010": 5,
  "30011": 3,
  "30012": 5,
  "30013": 5,
  "30014": -1,
  "30015": -1,
  "30016": -1,
  "30017": 5,
  "30018": -1,
  "30019": 11,
  "30021": 8,
  "30022": 5,
  "30023": 15,
  "30024": 5,
  "30025": 2,
  "30026": 5,
  "30028": 7,
  "30029": 5,
  "30030": 8,
  "30031": 8,
  "30032": 7,
  "30033": 8,
  "30034": 8,
  "30035": 8,
  "30036": 8,
  "30037": 8,
  "30038": 5,
  "30039": 5,
  "30040": 7,
  "30041": 7,
  "30042": 5,
  "30043": 5,
  "30044": 5,
  "30045": 5,
  "30046": 5,
  "30047": 5,
  "30048": 5,
  "30049": 5,
  "30052": 2,
  "30054": -1,
  "30055": -1,
  "30056": -8,
  "30058": 5,
  "30060": 8,
  "30061": 8,
  "30062": 9,
  "30064": 9,
  "30065": 5,
  "30066": 9,
  "30067": 9,
  "30068": 9,
  "30070": -1,
  "30071": 5,
  "30072": 8,
  "30074": 5,
  "30075": 5,
  "30076": 9,
  "30077": 5,
  "30078": 5,
  "30079": 7,
  "30080": 9,
  "30081": 9,
  "30082": 9,
  "30083": 8,
  "30084": 8,
  "30085": 8,
  "30086": 8,
  "30087": 8,
  "30088": 8,
  "30090": 8,
  "30091": 5,
  "30092": 5,
  "30093": 5,
  "30094": 5,
  "30095": 5,
  "30096": 5,
  "30097": 7,
  "30101": 9,
  "30102": 5,
  "30103": -6,
  "30104": 2,
  "30105": -7,
  "30106": 9,
  "30107": -3,
  "30108": -2,
  "30109": -2,
  "30110": -4,
  "30111": -2,
  "30112": -2,
  "30113": -4,
  "30114": 5,
  "30115": 5,
  "30116": 0,
  "30117": -2,
  "30120": -1,
  "30121": -2,
  "30122": -1,
  "30123": -2,
  "30124": -1,
  "30125": 0,
  "30126": 9,
  "30127": -3,
  "30129": -6,
  "30132": -3,
  "30133": -1,
  "30134": -1,
  "30135": -1,
  "30137": -2,
  "30138": 0,
  "30139": -5,
  "30140": -4,
  "30141": -3,
  "30142": 5,
  "30143": -3,
  "30144": 9,
  "30145": -2,
  "30146": 5,
  "30147": -6,
  "30148": -5,
  "30149": -6,
  "30150": -4,
  "30151": -3,
  "30152": 9,
  "30153": 2,
  "30154": -1,
  "30156": 9,
  "30157": -3,
  "30160": 9,
  "30161": -6,
  "30162": -6,
  "30163": -6,
  "30164": -6,
  "30165": -6,
  "30168": -2,
  "30169": 5,
  "30170": -6,
  "30171": -2,
  "30172": -6,
  "30173": -4,
  "30175": -4,
  "30176": -4,
  "30177": -5,
  "30178": -2,
  "30179": -2,
  "30180": -2,
  "30182": -4,
  "30183": 5,
  "30184": -1,
  "30185": 0,
  "30187": -1,
  "30188": 5,
  "30189": 5,
  "30204": -4,
  "30205": 7,
  "30206": -5,
  "30212": -3,
  "30213": 7,
  "30214": 7,
  "30215": 7,
  "30216": 4,
  "30217": -6,
  "30218": -3,
  "30219": -6,
  "30220": 1,
  "30222": -4,
  "30223": -3,
  "30224": -3,
  "30228": 1,
  "30229": 7,
  "30230": 2,
  "30233": 4,
  "30234": 6,
  "30236": 1,
  "30237": 1,
  "30238": 7,
  "30240": 11,
  "30241": 2,
  "30248": 6,
  "30250": 1,
  "30251": 1,
  "30252": 1,
  "30253": 1,
  "30256": -6,
  "30257": -4,
  "30258": -7,
  "30259": 2,
  "30260": 1,
  "30261": 2,
  "30263": 2,
  "30264": 2,
  "30265": 2,
  "30266": -4,
  "30268": 1,
  "30269": 7,
  "30271": 2,
  "30272": 16,
  "30273": 1,
  "30274": 7,
  "30275": 1,
  "30276": 7,
  "30277": 2,
  "30281": 1,
  "30284": 1,
  "30285": -6,
  "30286": -6,
  "30287": 7,
  "30288": 16,
  "30289": 7,
  "30290": 7,
  "30291": 7,
  "30292": -5,
  "30293": -5,
  "30294": 8,
  "30295": -6,
  "30296": 7,
  "30297": 16,
  "30298": 16,
  "30301": 28,
  "30302": 17,
  "30303": 17,
  "30304": 16,
  "30305": 28,
  "30306": 28,
  "30307": 25,
  "30308": 17,
  "30309": 25,
  "30310": 16,
  "30311": 16,
  "30312": 17,
  "30313": 17,
  "30314": 16,
  "30315": 16,
  "30316": 16,
  "30317": 8,
  "30318": 16,
  "30319": 16,
  "30320": 16,
  "30321": 17,
  "30324": 18,
  "30325": 16,
  "30326": 28,
  "30327": 28,
  "30328": 17,
  "30329": 8,
  "30331": 17,
  "30333": 28,
  "30334": 16,
  "30336": 16,
  "30337": 16,
  "30338": 16,
  "30339": 20,
  "30340": 8,
  "30341": 8,
  "30342": 28,
  "30343": 17,
  "30344": 16,
  "30345": 9,
  "30346": 8,
  "30347": 8,
  "30348": 28,
  "30349": 16,
  "30350": 18,
  "30353": 17,
  "30354": 16,
  "30355": 28,
  "30356": 16,
  "30357": 25,
  "30358": 17,
  "30359": 8,
  "30360": 8,
  "30361": 25,
  "30362": 8,
  "30363": 28,
  "30364": 16,
  "30366": 8,
  "30369": 16,
  "30370": 17,
  "30371": 16,
  "30374": 7,
  "30376": 18,
  "30377": 16,
  "30378": 16,
  "30379": 17,
  "30392": 17,
  "30394": 17,
  "30401": -16,
  "30410": -13,
  "30411": -13,
  "30412": -13,
  "30413": -11,
  "30414": -6,
  "30415": -7,
  "30417": -6,
  "30420": -11,
  "30421": -9,
  "30423": -6,
  "30424": -7,
  "30425": -11,
  "30426": 47,
  "30427": -9,
  "30428": -13,
  "30429": -6,
  "30434": -11,
  "30436": -11,
  "30438": -9,
  "30439": -11,
  "30441": -16,
  "30442": -11,
  "30445": -13,
  "30446": -13,
  "30447": -16,
  "30448": -16,
  "30449": -13,
  "30450": -7,
  "30451": -7,
  "30452": -7,
  "30453": -9,
  "30454": -8,
  "30455": -13,
  "30456": 46,
  "30457": -13,
  "30458": -7,
  "30459": -7,
  "30461": -7,
  "30464": -11,
  "30467": -13,
  "30470": -13,
  "30471": -11,
  "30473": -13,
  "30474": -11,
  "30475": -11,
  "30477": -12,
  "30501": 0,
  "30502": 0,
  "30503": 0,
  "30504": 0,
  "30506": 8,
  "30507": -1,
  "30510": -9,
  "30511": -10,
  "30512": -12,
  "30513": -1,
  "30514": -12,
  "30515": 7,
  "30516": -13,
  "30517": 3,
  "30518": 7,
  "30519": 13,
  "30520": -8,
  "30521": -8,
  "30522": -4,
  "30523": -10,
  "30525": -12,
  "30527": -5,
  "30528": -5,
  "30529": 0,
  "30530": 0,
  "30531": -10,
  "30533": -4,
  "30534": -5,
  "30535": -10,
  "30536": -2,
  "30537": -4,
  "30538": -8,
  "30539": -2,
  "30540": -2,
  "30541": -1,
  "30542": 0,
  "30543": -9,
  "30544": -10,
  "30545": -5,
  "30546": -4,
  "30547": -9,
  "30548": 3,
  "30549": 0,
  "30552": -12,
  "30553": -9,
  "30554": -9,
  "30555": -2,
  "30557": -8,
  "30558": -9,
  "30559": -1,
  "30560": -1,
  "30562": -13,
  "30563": -10,
  "30564": -4,
  "30565": 0,
  "30566": 0,
  "30567": 1,
  "30568": -12,
  "30571": -5,
  "30572": -11,
  "30573": -12,
  "30575": 1,
  "30576": -12,
  "30577": -8,
  "30580": -10,
  "30581": -12,
  "30582": -12,
  "30598": -8,
  "30601": 4,
  "30603": 4,
  "30604": 4,
  "30605": 4,
  "30606": 5,
  "30607": 4,
  "30608": 4,
  "30612": 5,
  "30619": -7,
  "30620": 3,
  "30621": -1,
  "30622": -1,
  "30623": 1,
  "30624": -15,
  "30625": -1,
  "30627": -14,
  "30628": -5,
  "30629": -5,
  "30630": -7,
  "30631": -7,
  "30633": -5,
  "30634": -15,
  "30635": -15,
  "30638": -1,
  "30639": -8,
  "30641": 1,
  "30642": -7,
  "30643": -13,
  "30645": -1,
  "30646": -5,
  "30647": -5,
  "30648": -7,
  "30650": -2,
  "30655": 2,
  "30656": 2,
  "30660": 7,
  "30662": -8,
  "30663": -1,
  "30664": -7,
  "30665": -7,
  "30666": 2,
  "30667": -7,
  "30668": 7,
  "30669": -7,
  "30671": -7,
  "30673": 7,
  "30677": 8,
  "30678": -7,
  "30680": 3,
  "30683": 4,
  "30701": -6,
  "30703": -6,
  "30705": -13,
  "30707": -9,
  "30708": -13,
  "30710": -5,
  "30711": -13,
  "30719": -5,
  "30720": -5,
  "30721": -5,
  "30722": -5,
  "30724": -13,
  "30725": -9,
  "30726": -9,
  "30728": -9,
  "30730": -8,
  "30731": -7,
  "30732": -6,
  "30733": -6,
  "30734": -6,
  "30735": -6,
  "30736": -9,
  "30738": -9,
  "30739": -9,
  "30740": -5,
  "30741": -9,
  "30742": -9,
  "30746": -6,
  "30747": -7,
  "30750": -1,
  "30751": -13,
  "30752": -9,
  "30753": -7,
  "30755": -5,
  "30756": -5,
  "30757": -9,
  "30802": -4,
  "30803": -12,
  "30805": -6,
  "30806": -8,
  "30807": -11,
  "30808": -8,
  "30809": 3,
  "30810": -11,
  "30811": 47,
  "30812": -6,
  "30813": -5,
  "30814": -5,
  "30815": -6,
  "30816": 47,
  "30817": -8,
  "30818": -12,
  "30819": -11,
  "30820": -11,
  "30821": -11,
  "30822": -11,
  "30823": -11,
  "30824": -8,
  "30828": -11,
  "30830": 47,
  "30833": -11,
  "30901": -7,
  "30903": -7,
  "30904": -6,
  "30905": -5,
  "30906": -6,
  "30907": 3,
  "30909": 2,
  "30912": -7,
  "30913": 3,
  "30914": -6,
  "30916": -6,
  "30917": 3,
  "30919": 2,
  "31001": -25,
  "31002": -19,
  "31003": -10,
  "31004": -8,
  "31005": 2,
  "31006": -8,
  "31007": -1,
  "31008": -1,
  "31009": -14,
  "31010": -1,
  "31011": -14,
  "31012": -14,
  "31013": -7,
  "31014": -14,
  "31015": -1,
  "31016": -6,
  "31017": -10,
  "31018": -13,
  "31019": -8,
  "31020": -3,
  "31021": -8,
  "31022": -8,
  "31023": -14,
  "31024": 1,
  "31025": -7,
  "31027": -8,
  "31028": -6,
  "31029": -8,
  "31030": -2,
  "31031": -10,
  "31032": -4,
  "31033": -5,
  "31034": -8,
  "31035": -14,
  "31036": -14,
  "31037": -12,
  "31038": -9,
  "31039": -8,
  "31040": -8,
  "31041": -1,
  "31042": -10,
  "31044": -10,
  "31045": -11,
  "31046": -8,
  "31047": 2,
  "31049": -19,
  "31050": -14,
  "31051": -2,
  "31052": -2,
  "31054": -10,
  "31055": -12,
  "31057": -1,
  "31058": -17,
  "31059": -8,
  "31060": -12,
  "31061": -8,
  "31063": -1,
  "31064": -9,
  "31065": -8,
  "31066": -2,
  "31067": -14,
  "31068": -1,
  "31069": -6,
  "31070": -2,
  "31071": -25,
  "31072": -25,
  "31075": -8,
  "31076": -8,
  "31077": -14,
  "31078": -14,
  "31079": -25,
  "31081": -8,
  "31082": -14,
  "31083": -12,
  "31084": -25,
  "31085": -8,
  "31086": -6,
  "31087": -8,
  "31088": -6,
  "31089": -14,
  "31090": -10,
  "31091": -1,
  "31092": -2,
  "31093": -7,
  "31094": -14,
  "31095": -7,
  "31096": -19,
  "31097": -6,
  "31098": -7,
  "31099": -7,
  "31106": 28,
  "31107": 25,
  "31119": 28,
  "31126": 28,
  "31131": 17,
  "31139": 17,
  "31141": 16,
  "31145": 9,
  "31146": 8,
  "31150": 18,
  "31156": 17,
  "31201": -3,
  "31202": -3,
  "31203": -3,
  "31204": -3,
  "31205": 5,
  "31206": -3,
  "31208": -3,
  "31209": -3,
  "31210": 5,
  "31211": -3,
  "31212": -3,
  "31216": 5,
  "31217": -3,
  "31220": 5,
  "31221": 5,
  "31297": -3,
  "31301": 23,
  "31302": -1,
  "31303": -8,
  "31304": 2,
  "31305": -8,
  "31307": -1,
  "31308": -1,
  "31309": 23,
  "31310": 23,
  "31312": -8,
  "31313": 23,
  "31314": 23,
  "31315": 23,
  "31316": -22,
  "31318": -1,
  "31319": -8,
  "31320": 23,
  "31321": -1,
  "31322": 0,
  "31323": 23,
  "31324": -1,
  "31326": -8,
  "31327": -8,
  "31328": 8,
  "31329": -8,
  "31331": -8,
  "31333": 23,
  "31401": -1,
  "31402": -1,
  "31403": 0,
  "31404": -1,
  "31405": 0,
  "31406": 0,
  "31407": -1,
  "31408": -1,
  "31409": 0,
  "31410": 0,
  "31411": 10,
  "31412": -1,
  "31414": -1,
  "31415": -1,
  "31416": 0,
  "31418": -1,
  "31419": 0,
  "31420": 0,
  "31421": -1,
  "31501": -9,
  "31502": -9,
  "31503": -9,
  "31510": 12,
  "31512": -11,
  "31513": 12,
  "31515": 12,
  "31516": -10,
  "31518": -10,
  "31519": -11,
  "31520": -9,
  "31521": -9,
  "31522": 0,
  "31523": -9,
  "31525": -9,
  "31527": 0,
  "31532": -22,
  "31533": -11,
  "31534": -11,
  "31535": -11,
  "31537": -18,
  "31539": -22,
  "31542": -10,
  "31543": -10,
  "31544": -12,
  "31545": -6,
  "31546": -6,
  "31547": -4,
  "31548": -4,
  "31549": -22,
  "31550": -9,
  "31551": -10,
  "31552": -9,
  "31553": -10,
  "31554": -11,
  "31555": -6,
  "31556": -10,
  "31557": -10,
  "31558": -4,
  "31560": -6,
  "31561": 0,
  "31562": -18,
  "31563": 12,
  "31564": -9,
  "31565": -8,
  "31566": -10,
  "31567": -11,
  "31568": -8,
  "31569": -4,
  "31598": -6,
  "31601": -2,
  "31602": -2,
  "31603": -2,
  "31604": -2,
  "31605": -2,
  "31606": -2,
  "31620": -7,
  "31622": -14,
  "31623": -17,
  "31624": -11,
  "31625": -12,
  "31626": -11,
  "31627": -7,
  "31629": -11,
  "31630": -17,
  "31631": -17,
  "31632": 5,
  "31634": -17,
  "31635": -16,
  "31636": -2,
  "31637": -7,
  "31638": -11,
  "31639": -13,
  "31641": -16,
  "31642": -11,
  "31643": -11,
  "31645": -16,
  "31647": -7,
  "31648": -2,
  "31649": -16,
  "31650": -11,
  "31701": -4,
  "31702": 4,
  "31703": -4,
  "31705": -4,
  "31706": -4,
  "31707": 4,
  "31708": -4,
  "31709": -15,
  "31711": -15,
  "31712": -2,
  "31714": -12,
  "31716": -11,
  "31719": -15,
  "31720": -11,
  "31721": 4,
  "31722": -12,
  "31727": -5,
  "31730": -12,
  "31733": -5,
  "31735": 7,
  "31738": -12,
  "31739": -11,
  "31743": -15,
  "31744": -12,
  "31747": -12,
  "31749": -6,
  "31750": -10,
  "31753": -4,
  "31756": -4,
  "31757": -11,
  "31758": -11,
  "31760": -5,
  "31763": 0,
  "31764": -15,
  "31765": -12,
  "31768": -12,
  "31769": -10,
  "31771": -12,
  "31772": -8,
  "31773": -11,
  "31774": -10,
  "31775": -6,
  "31776": -12,
  "31778": -11,
  "31779": -11,
  "31780": -15,
  "31781": -14,
  "31782": -13,
  "31783": -12,
  "31784": -11,
  "31787": -15,
  "31788": -12,
  "31789": -13,
  "31790": -12,
  "31791": -13,
  "31792": -11,
  "31793": -5,
  "31794": -5,
  "31795": -5,
  "31796": -1,
  "31798": -10,
  "31799": -11,
  "31801": -16,
  "31803": -17,
  "31804": 1,
  "31805": -17,
  "31806": -1,
  "31807": -8,
  "31808": 1,
  "31810": -16,
  "31811": -6,
  "31812": -14,
  "31814": -17,
  "31815": -3,
  "31816": -4,
  "31820": 3,
  "31821": -17,
  "31822": -8,
  "31823": -8,
  "31824": -3,
  "31825": -17,
  "31826": -14,
  "31827": -14,
  "31829": 3,
  "31830": -4,
  "31831": -14,
  "31832": -4,
  "31833": -11,
  "31836": -14,
  "31901": -5,
  "31902": -5,
  "31903": -6,
  "31904": -5,
  "31905": -6,
  "31906": -5,
  "31907": -5,
  "31908": -5,
  "31909": -5,
  "31914": -5,
  "31917": -5,
  "31995": -5,
  "32003": 0,
  "32004": 0,
  "32006": 0,
  "32007": -13,
  "32008": -8,
  "32009": -8,
  "32011": -9,
  "32013": -20,
  "32024": -11,
  "32025": -11,
  "32030": -7,
  "32033": -1,
  "32034": -9,
  "32035": -9,
  "32038": -9,
  "32040": -8,
  "32041": -9,
  "32042": -9,
  "32043": -7,
  "32044": -9,
  "32046": -9,
  "32050": -7,
  "32052": -8,
  "32053": -13,
  "32054": -9,
  "32055": -10,
  "32056": -11,
  "32058": -9,
  "32059": -13,
  "32060": -20,
  "32061": -9,
  "32062": -20,
  "32063": -8,
  "32064": -20,
  "32065": -7,
  "32066": -20,
  "32067": -7,
  "32068": -7,
  "32071": -8,
  "32072": -10,
  "32073": 0,
  "32079": -7,
  "32080": -1,
  "32081": 9,
  "32082": 9,
  "32083": -10,
  "32084": 1,
  "32085": -1,
  "32086": -1,
  "32087": -10,
  "32091": -9,
  "32092": -1,
  "32094": -7,
  "32095": -1,
  "32096": -11,
  "32097": -9,
  "32102": -6,
  "32105": -6,
  "32110": -11,
  "32111": -8,
  "32112": -13,
  "32113": -8,
  "32114": -6,
  "32115": -6,
  "32116": -6,
  "32117": -6,
  "32118": -6,
  "32119": -6,
  "32120": -6,
  "32121": -6,
  "32122": -6,
  "32123": -6,
  "32124": 3,
  "32125": -6,
  "32126": -6,
  "32127": -6,
  "32128": 3,
  "32129": -6,
  "32130": -6,
  "32131": -12,
  "32132": -6,
  "32133": -8,
  "32134": -13,
  "32135": -10,
  "32136": -11,
  "32137": -10,
  "32138": -12,
  "32139": -13,
  "32140": -12,
  "32141": -6,
  "32142": -11,
  "32143": -11,
  "32145": -12,
  "32147": -13,
  "32148": -13,
  "32149": -13,
  "32157": -13,
  "32158": 9,
  "32159": 9,
  "32160": -9,
  "32162": 9,
  "32163": 9,
  "32164": -11,
  "32168": -6,
  "32169": 3,
  "32170": -6,
  "32173": -6,
  "32174": -6,
  "32175": -11,
  "32176": -11,
  "32177": -13,
  "32178": -13,
  "32179": -8,
  "32180": -6,
  "32181": -13,
  "32182": -14,
  "32183": -8,
  "32185": -12,
  "32187": -13,
  "32189": -13,
  "32190": -11,
  "32192": -8,
  "32193": -13,
  "32195": -8,
  "32201": 0,
  "32202": 0,
  "32203": 0,
  "32204": 0,
  "32205": 0,
  "32206": 0,
  "32207": 0,
  "32208": 0,
  "32209": 0,
  "32210": 0,
  "32211": 0,
  "32212": 0,
  "32215": -7,
  "32216": 0,
  "32217": 0,
  "32218": 0,
  "32219": 0,
  "32220": 0,
  "32221": 0,
  "32222": 0,
  "32223": 0,
  "32224": 0,
  "32225": 0,
  "32226": 0,
  "32227": 0,
  "32228": 0,
  "32229": 0,
  "32230": 0,
  "32231": 0,
  "32232": 0,
  "32233": 0,
  "32234": -9,
  "32235": 0,
  "32236": 0,
  "32237": 0,
  "32238": 0,
  "32239": 0,
  "32240": 0,
  "32241": 0,
  "32244": 0,
  "32245": 9,
  "32246": 0,
  "32247": 0,
  "32250": 0,
  "32254": 0,
  "32255": 0,
  "32256": 9,
  "32257": 0,
  "32258": 0,
  "32259": 1,
  "32260": 1,
  "32266": 2,
  "32277": 0,
  "32301": -5,
  "32302": -5,
  "32303": -5,
  "32304": -5,
  "32305": -10,
  "32308": 3,
  "32309": -11,
  "32310": -5,
  "32311": -3,
  "32312": 3,
  "32314": -5,
  "32315": -5,
  "32316": -5,
  "32317": 3,
  "32318": -5,
  "32320": -17,
  "32321": -6,
  "32322": -16,
  "32323": -16,
  "32324": -3,
  "32326": -10,
  "32327": -10,
  "32328": -17,
  "32329": -17,
  "32330": -3,
  "32331": -13,
  "32332": -3,
  "32333": -3,
  "32334": -7,
  "32335": -14,
  "32336": -11,
  "32337": -11,
  "32340": -13,
  "32341": -13,
  "32343": -3,
  "32344": -11,
  "32345": -11,
  "32346": -9,
  "32347": -4,
  "32348": -4,
  "32350": -13,
  "32351": -3,
  "32352": -3,
  "32353": -3,
  "32355": -10,
  "32356": -4,
  "32357": -4,
  "32358": -10,
  "32359": -15,
  "32360": -6,
  "32361": -11,
  "32362": -3,
  "32401": -7,
  "32402": -6,
  "32403": 2,
  "32404": -6,
  "32405": -6,
  "32406": -6,
  "32407": -6,
  "32408": -6,
  "32409": -6,
  "32410": -5,
  "32411": -6,
  "32412": -7,
  "32413": -6,
  "32417": -6,
  "32420": -8,
  "32421": -13,
  "32422": 4,
  "32423": -7,
  "32424": -13,
  "32425": -16,
  "32426": -8,
  "32427": -16,
  "32428": -13,
  "32430": -13,
  "32431": -7,
  "32432": -8,
  "32433": -5,
  "32434": -5,
  "32435": -5,
  "32437": -13,
  "32438": -13,
  "32439": -5,
  "32440": -16,
  "32442": -7,
  "32443": -7,
  "32444": -6,
  "32445": -7,
  "32446": -6,
  "32447": -6,
  "32448": -7,
  "32449": -13,
  "32452": -16,
  "32455": 4,
  "32456": -13,
  "32457": -13,
  "32459": -5,
  "32460": -7,
  "32461": -6,
  "32462": -13,
  "32463": -13,
  "32464": -16,
  "32465": -14,
  "32466": -7,
  "32501": -5,
  "32502": -5,
  "32503": -5,
  "32504": -5,
  "32505": -5,
  "32506": -5,
  "32507": -5,
  "32508": -5,
  "32513": -5,
  "32514": -5,
  "32516": -5,
  "32522": -5,
  "32523": -5,
  "32524": -5,
  "32526": -5,
  "32530": -7,
  "32531": -8,
  "32533": -5,
  "32534": -5,
  "32535": -7,
  "32536": -8,
  "32537": -8,
  "32538": -8,
  "32539": -8,
  "32540": 1,
  "32541": 1,
  "32542": -8,
  "32544": -8,
  "32547": -8,
  "32548": -8,
  "32549": -8,
  "32550": 1,
  "32560": -5,
  "32561": 4,
  "32562": -5,
  "32563": -7,
  "32564": -8,
  "32565": -7,
  "32566": -7,
  "32567": -8,
  "32568": -5,
  "32569": -8,
  "32570": -7,
  "32571": -6,
  "32572": -7,
  "32577": -5,
  "32578": -8,
  "32579": -8,
  "32580": -8,
  "32583": -7,
  "32588": -8,
  "32590": -5,
  "32591": -5,
  "32592": -5,
  "32601": -7,
  "32602": 2,
  "32603": 2,
  "32604": 2,
  "32605": 2,
  "32606": 2,
  "32607": 2,
  "32608": -4,
  "32609": -6,
  "32613": -6,
  "32614": -4,
  "32615": -7,
  "32616": -7,
  "32617": -8,
  "32618": -6,
  "32619": -10,
  "32621": -12,
  "32622": -9,
  "32625": -12,
  "32626": -12,
  "32627": -6,
  "32628": -15,
  "32631": -9,
  "32633": -6,
  "32634": -8,
  "32635": -6,
  "32639": -13,
  "32640": -12,
  "32641": -6,
  "32643": -9,
  "32644": -12,
  "32648": -14,
  "32653": -6,
  "32654": -7,
  "32655": -9,
  "32656": -9,
  "32658": -6,
  "32662": -7,
  "32663": -8,
  "32664": -6,
  "32666": -9,
  "32667": -6,
  "32668": -8,
  "32669": -6,
  "32680": -15,
  "32681": -7,
  "32683": -12,
  "32686": -8,
  "32692": -6,
  "32693": -10,
  "32694": -9,
  "32696": -12,
  "32697": -10,
  "32701": 0,
  "32702": -3,
  "32703": 2,
  "32704": 2,
  "32706": -6,
  "32707": 0,
  "32708": 0,
  "32709": -1,
  "32710": 2,
  "32712": 0,
  "32713": 0,
  "32714": 0,
  "32715": 0,
  "32716": 0,
  "32718": 0,
  "32719": 0,
  "32720": -6,
  "32721": -6,
  "32722": -6,
  "32724": -6,
  "32725": -6,
  "32726": -1,
  "32727": -1,
  "32728": -6,
  "32730": 0,
  "32732": 7,
  "32733": 0,
  "32735": -3,
  "32736": -1,
  "32738": -6,
  "32739": -6,
  "32744": -6,
  "32745": 0,
  "32746": 0,
  "32747": 0,
  "32750": 0,
  "32751": 2,
  "32752": 2,
  "32753": 0,
  "32754": -1,
  "32756": -1,
  "32757": -1,
  "32759": -6,
  "32762": 0,
  "32763": -6,
  "32764": -6,
  "32765": 0,
  "32766": 0,
  "32767": -3,
  "32768": -1,
  "32771": 0,
  "32772": 0,
  "32773": 0,
  "32774": -6,
  "32775": -6,
  "32776": -1,
  "32777": -1,
  "32778": -1,
  "32779": 2,
  "32780": -3,
  "32781": -3,
  "32782": -1,
  "32783": -3,
  "32784": -3,
  "32789": 11,
  "32790": 11,
  "32791": 2,
  "32792": 0,
  "32793": 2,
  "32794": 2,
  "32795": 0,
  "32796": -1,
  "32798": -1,
  "32799": 2,
  "32801": 3,
  "32802": 3,
  "32803": 2,
  "32804": 2,
  "32805": 2,
  "32806": 2,
  "32807": 2,
  "32808": 2,
  "32809": 2,
  "32810": 2,
  "32811": 2,
  "32812": 2,
  "32814": 2,
  "32815": -3,
  "32817": 0,
  "32818": 2,
  "32819": 3,
  "32820": 0,
  "32821": 2,
  "32822": 2,
  "32824": 2,
  "32825": 2,
  "32826": 0,
  "32827": 2,
  "32828": 2,
  "32829": 2,
  "32830": 11,
  "32831": 2,
  "32832": -6,
  "32833": -1,
  "32834": 0,
  "32835": 2,
  "32836": 11,
  "32837": 2,
  "32839": 2,
  "32853": 2,
  "32854": 2,
  "32855": 2,
  "32856": 2,
  "32857": 2,
  "32858": 2,
  "32859": 2,
  "32860": 2,
  "32861": 2,
  "32862": 3,
  "32867": 0,
  "32868": 2,
  "32869": 2,
  "32872": 3,
  "32877": 3,
  "32878": 2,
  "32901": -2,
  "32902": -2,
  "32903": -2,
  "32904": -2,
  "32905": -2,
  "32906": -2,
  "32907": -2,
  "32908": -2,
  "32909": -2,
  "32910": -2,
  "32911": -2,
  "32912": -2,
  "32920": -2,
  "32922": -3,
  "32923": -2,
  "32924": -2,
  "32925": -2,
  "32926": -3,
  "32927": -3,
  "32931": -2,
  "32932": -2,
  "32934": -2,
  "32935": -2,
  "32936": -2,
  "32937": -2,
  "32940": -2,
  "32941": -2,
  "32948": -7,
  "32949": -5,
  "32950": -2,
  "32951": 6,
  "32952": -2,
  "32953": 6,
  "32954": -2,
  "32955": -2,
  "32956": -2,
  "32957": -7,
  "32958": -7,
  "32959": -3,
  "32960": -8,
  "32961": -8,
  "32962": -8,
  "32963": 3,
  "32964": -8,
  "32965": -8,
  "32966": -8,
  "32967": -7,
  "32968": -8,
  "32969": -8,
  "32970": -7,
  "32971": -7,
  "32976": -7,
  "32978": -7,
  "33001": -4,
  "33002": 1,
  "33004": 3,
  "33008": 3,
  "33009": 3,
  "33010": 1,
  "33011": 1,
  "33012": 1,
  "33013": 1,
  "33014": 1,
  "33015": 1,
  "33016": 0,
  "33017": 1,
  "33018": 1,
  "33019": 3,
  "33020": 3,
  "33021": 3,
  "33022": 3,
  "33023": 3,
  "33024": 3,
  "33025": 3,
  "33026": 3,
  "33027": 2,
  "33028": 3,
  "33029": 3,
  "33030": 0,
  "33031": 1,
  "33032": 0,
  "33033": 0,
  "33034": 0,
  "33035": 0,
  "33036": 7,
  "33037": 1,
  "33040": -3,
  "33041": -3,
  "33042": -3,
  "33043": -4,
  "33045": -3,
  "33050": -4,
  "33051": -4,
  "33052": -4,
  "33054": 0,
  "33055": 0,
  "33056": 2,
  "33060": 3,
  "33061": 3,
  "33062": 3,
  "33063": 3,
  "33064": 3,
  "33065": 3,
  "33066": 3,
  "33067": 5,
  "33068": 3,
  "33069": 3,
  "33070": -4,
  "33071": 3,
  "33072": 3,
  "33073": 3,
  "33074": 3,
  "33075": 3,
  "33076": 3,
  "33077": 3,
  "33081": 3,
  "33082": 3,
  "33083": 3,
  "33084": 3,
  "33090": 0,
  "33092": 0,
  "33093": 3,
  "33097": 3,
  "33101": 0,
  "33102": 0,
  "33109": 0,
  "33111": 1,
  "33114": 1,
  "33116": 1,
  "33119": 1,
  "33122": 0,
  "33124": 2,
  "33125": 1,
  "33126": 0,
  "33127": 0,
  "33128": 0,
  "33129": 1,
  "33130": 0,
  "33131": 1,
  "33132": 1,
  "33133": 2,
  "33134": 1,
  "33135": 1,
  "33136": 0,
  "33137": 0,
  "33138": 1,
  "33139": 1,
  "33140": 1,
  "33141": 1,
  "33142": 0,
  "33143": 1,
  "33144": 1,
  "33145": 1,
  "33146": 11,
  "33147": 0,
  "33149": 11,
  "33150": 0,
  "33151": 0,
  "33152": 0,
  "33153": 1,
  "33154": 1,
  "33155": 1,
  "33156": 11,
  "33157": 1,
  "33158": 11,
  "33159": 0,
  "33160": 2,
  "33161": 1,
  "33162": 0,
  "33163": 3,
  "33164": 0,
  "33165": 1,
  "33166": 1,
  "33167": 0,
  "33168": 0,
  "33169": 3,
  "33170": 1,
  "33172": 0,
  "33173": 1,
  "33174": 1,
  "33175": 1,
  "33176": 1,
  "33177": 0,
  "33178": 1,
  "33179": 2,
  "33180": 3,
  "33181": 1,
  "33182": 1,
  "33183": 0,
  "33184": 1,
  "33185": 1,
  "33186": 1,
  "33187": 1,
  "33189": 0,
  "33190": 0,
  "33193": 1,
  "33194": 1,
  "33196": 1,
  "33197": 1,
  "33222": 2,
  "33231": 0,
  "33233": 2,
  "33234": 1,
  "33238": 1,
  "33239": 1,
  "33242": 0,
  "33243": 1,
  "33245": 1,
  "33247": 0,
  "33255": 1,
  "33256": 11,
  "33257": 1,
  "33261": 1,
  "33265": 1,
  "33266": 1,
  "33269": 3,
  "33280": 2,
  "33283": 1,
  "33296": 1,
  "33299": 0,
  "33301": 14,
  "33302": 3,
  "33303": 3,
  "33304": 3,
  "33305": 3,
  "33306": 3,
  "33307": 3,
  "33308": 3,
  "33309": 3,
  "33310": 3,
  "33311": 3,
  "33312": 3,
  "33313": 3,
  "33314": 3,
  "33315": 3,
  "33316": 14,
  "33317": 3,
  "33318": 3,
  "33319": 3,
  "33320": 3,
  "33321": 3,
  "33322": 3,
  "33323": 3,
  "33324": 3,
  "33325": 3,
  "33326": 3,
  "33327": 14,
  "33328": 3,
  "33329": 3,
  "33330": 3,
  "33331": 5,
  "33332": 14,
  "33334": 3,
  "33335": 3,
  "33338": 3,
  "33339": 3,
  "33340": 3,
  "33345": 3,
  "33346": 14,
  "33348": 3,
  "33349": 3,
  "33351": 3,
  "33355": 3,
  "33359": 3,
  "33388": 3,
  "33394": 14,
  "33401": 1,
  "33402": 1,
  "33403": 1,
  "33404": 1,
  "33405": 1,
  "33406": 1,
  "33407": 1,
  "33408": 1,
  "33409": 1,
  "33410": 1,
  "33411": 1,
  "33412": 1,
  "33413": 1,
  "33414": 1,
  "33415": 1,
  "33416": 1,
  "33417": 1,
  "33418": 1,
  "33419": 1,
  "33420": 1,
  "33421": 1,
  "33422": 1,
  "33424": 2,
  "33425": 3,
  "33426": 2,
  "33427": 3,
  "33428": 3,
  "33429": 3,
  "33430": 1,
  "33431": 3,
  "33432": 3,
  "33433": 3,
  "33434": 3,
  "33435": 2,
  "33436": 2,
  "33437": 3,
  "33438": 1,
  "33439": 1,
  "33440": -7,
  "33441": 3,
  "33442": 3,
  "33443": 3,
  "33444": 2,
  "33445": 2,
  "33446": 2,
  "33448": 2,
  "33449": 1,
  "33454": 1,
  "33455": -5,
  "33458": -4,
  "33459": -6,
  "33460": 1,
  "33461": 1,
  "33462": 1,
  "33463": 1,
  "33465": 1,
  "33466": 1,
  "33467": 1,
  "33468": -4,
  "33469": -4,
  "33470": 1,
  "33471": -3,
  "33472": 1,
  "33473": 3,
  "33474": 2,
  "33475": -5,
  "33476": 1,
  "33477": -4,
  "33478": -4,
  "33480": 12,
  "33481": 3,
  "33482": 2,
  "33483": 3,
  "33484": 2,
  "33486": 3,
  "33487": 3,
  "33488": 3,
  "33493": -6,
  "33496": 11,
  "33497": 3,
  "33498": 3,
  "33503": 2,
  "33508": 2,
  "33509": 2,
  "33510": 2,
  "33511": 2,
  "33513": 0,
  "33514": 1,
  "33521": 0,
  "33523": -11,
  "33524": -8,
  "33525": -7,
  "33526": -11,
  "33527": 2,
  "33530": 2,
  "33534": 2,
  "33537": -11,
  "33538": 0,
  "33539": -7,
  "33540": -8,
  "33541": -8,
  "33542": -8,
  "33543": -6,
  "33544": -7,
  "33545": -6,
  "33547": 10,
  "33548": -6,
  "33549": -6,
  "33550": 2,
  "33556": 2,
  "33558": -6,
  "33559": 10,
  "33563": 1,
  "33564": 1,
  "33565": 1,
  "33566": 1,
  "33567": 1,
  "33568": 2,
  "33569": 2,
  "33570": -3,
  "33571": -3,
  "33572": 2,
  "33573": 2,
  "33574": -7,
  "33575": -3,
  "33576": -7,
  "33578": 2,
  "33579": 2,
  "33583": 2,
  "33584": 2,
  "33585": 1,
  "33586": -3,
  "33587": 2,
  "33592": 2,
  "33593": -11,
  "33594": 2,
  "33595": 2,
  "33596": 2,
  "33597": 0,
  "33598": 2,
  "33601": 2,
  "33602": 2,
  "33603": 2,
  "33604": 2,
  "33605": 2,
  "33606": 10,
  "33607": 2,
  "33608": 2,
  "33609": 2,
  "33610": 2,
  "33611": 2,
  "33612": 2,
  "33613": 2,
  "33614": 2,
  "33615": 2,
  "33616": 2,
  "33617": 2,
  "33618": 2,
  "33619": 2,
  "33621": 2,
  "33622": 2,
  "33623": 2,
  "33624": 2,
  "33625": 2,
  "33626": 4,
  "33629": 10,
  "33630": 2,
  "33631": 2,
  "33634": 2,
  "33635": -4,
  "33637": 2,
  "33646": 2,
  "33647": 10,
  "33672": 2,
  "33673": 2,
  "33674": 2,
  "33675": -6,
  "33677": 2,
  "33679": 2,
  "33680": 2,
  "33681": 2,
  "33682": 2,
  "33684": 2,
  "33685": 2,
  "33686": 2,
  "33687": 2,
  "33688": 2,
  "33689": 2,
  "33690": 2,
  "33694": 2,
  "33701": -4,
  "33702": -4,
  "33703": -4,
  "33704": -4,
  "33705": -4,
  "33706": 4,
  "33707": -4,
  "33708": -4,
  "33709": -5,
  "33710": -4,
  "33711": -4,
  "33712": -4,
  "33713": -4,
  "33714": -5,
  "33715": 4,
  "33716": -5,
  "33730": -3,
  "33731": -4,
  "33732": -4,
  "33733": -4,
  "33734": -4,
  "33736": 4,
  "33737": -4,
  "33738": -4,
  "33740": 4,
  "33741": 4,
  "33742": -4,
  "33743": -4,
  "33744": -4,
  "33747": -4,
  "33755": -4,
  "33756": -4,
  "33757": -4,
  "33758": -4,
  "33759": -4,
  "33760": -4,
  "33761": -4,
  "33762": -4,
  "33763": -4,
  "33764": -4,
  "33765": -4,
  "33766": -4,
  "33767": 5,
  "33770": -4,
  "33771": -4,
  "33772": -4,
  "33773": -4,
  "33774": -4,
  "33775": -4,
  "33776": -3,
  "33777": -4,
  "33778": -4,
  "33779": -4,
  "33780": -5,
  "33781": -5,
  "33782": -4,
  "33784": -5,
  "33785": -2,
  "33786": 7,
  "33801": -5,
  "33802": -5,
  "33803": -4,
  "33804": -5,
  "33805": -5,
  "33806": -4,
  "33807": -4,
  "33809": -4,
  "33810": -4,
  "33811": -4,
  "33812": -4,
  "33813": 4,
  "33815": -5,
  "33820": -5,
  "33823": -5,
  "33825": -12,
  "33826": -12,
  "33827": -5,
  "33830": -5,
  "33831": -5,
  "33834": -15,
  "33835": -5,
  "33836": -5,
  "33837": -5,
  "33838": -5,
  "33839": -5,
  "33840": -5,
  "33841": -15,
  "33843": -5,
  "33844": -5,
  "33845": -5,
  "33846": 4,
  "33847": -5,
  "33848": -8,
  "33849": -4,
  "33850": -5,
  "33851": -5,
  "33852": -9,
  "33853": -5,
  "33854": -5,
  "33855": -5,
  "33856": -5,
  "33857": -12,
  "33858": -8,
  "33859": -5,
  "33860": -5,
  "33862": -9,
  "33863": -5,
  "33865": -11,
  "33867": -5,
  "33868": -5,
  "33870": -12,
  "33871": -12,
  "33872": -11,
  "33873": -15,
  "33875": -11,
  "33876": -12,
  "33877": -5,
  "33880": -5,
  "33881": -5,
  "33882": 4,
  "33883": -5,
  "33884": 4,
  "33885": -5,
  "33890": -15,
  "33896": -5,
  "33897": -5,
  "33898": -5,
  "33900": -4,
  "33901": -4,
  "33902": -4,
  "33903": -3,
  "33904": -2,
  "33905": -4,
  "33906": -4,
  "33907": -4,
  "33908": -2,
  "33909": -3,
  "33910": -2,
  "33911": -2,
  "33912": -4,
  "33913": 4,
  "33914": -2,
  "33915": -3,
  "33916": -4,
  "33917": -4,
  "33918": -3,
  "33919": -4,
  "33920": -4,
  "33921": 8,
  "33922": -2,
  "33924": 9,
  "33927": -3,
  "33928": -4,
  "33929": -4,
  "33930": -4,
  "33931": 4,
  "33932": 4,
  "33935": -4,
  "33936": -4,
  "33938": -3,
  "33944": -3,
  "33945": -2,
  "33946": -3,
  "33947": -3,
  "33948": -3,
  "33949": -3,
  "33950": -3,
  "33951": -3,
  "33952": -3,
  "33953": -3,
  "33954": -3,
  "33955": -3,
  "33956": -3,
  "33957": 0,
  "33960": -3,
  "33966": -4,
  "33967": -4,
  "33970": -4,
  "33971": -4,
  "33972": -4,
  "33973": -4,
  "33974": -4,
  "33975": -7,
  "33976": -4,
  "33980": -3,
  "33981": -3,
  "33982": -3,
  "33983": -3,
  "33990": -3,
  "33991": -2,
  "33993": -3,
  "33994": -4,
  "34101": 11,
  "34102": 11,
  "34103": 1,
  "34104": 0,
  "34105": 0,
  "34106": 11,
  "34107": 0,
  "34108": 0,
  "34109": 0,
  "34110": 0,
  "34112": 0,
  "34113": 0,
  "34114": -1,
  "34116": 0,
  "34117": 0,
  "34119": 0,
  "34120": 0,
  "34133": 0,
  "34134": 0,
  "34135": 0,
  "34136": 0,
  "34137": 0,
  "34138": 0,
  "34139": 0,
  "34140": 0,
  "34141": 0,
  "34142": -1,
  "34143": -1,
  "34145": 0,
  "34146": 0,
  "34201": 8,
  "34202": -2,
  "34203": -3,
  "34204": -3,
  "34205": -3,
  "34206": -3,
  "34207": -3,
  "34208": -3,
  "34209": -3,
  "34210": -3,
  "34211": -2,
  "34212": -2,
  "34215": -3,
  "34216": -2,
  "34217": -3,
  "34218": -3,
  "34219": -3,
  "34220": -3,
  "34221": -3,
  "34222": -3,
  "34223": 0,
  "34224": -3,
  "34228": 8,
  "34229": -1,
  "34230": -2,
  "34231": -1,
  "34232": -2,
  "34233": -1,
  "34234": -3,
  "34235": -2,
  "34236": -2,
  "34237": -3,
  "34238": -1,
  "34239": -2,
  "34240": -1,
  "34241": -1,
  "34242": 9,
  "34243": -2,
  "34250": -3,
  "34251": -1,
  "34260": -2,
  "34264": -3,
  "34265": -11,
  "34266": -11,
  "34267": -11,
  "34268": -11,
  "34269": -11,
  "34270": -2,
  "34272": -1,
  "34274": -1,
  "34275": -1,
  "34276": -2,
  "34277": -1,
  "34278": -2,
  "34280": -3,
  "34281": -3,
  "34282": -3,
  "34284": -2,
  "34285": -1,
  "34286": -3,
  "34287": -3,
  "34288": -3,
  "34289": -3,
  "34290": -3,
  "34291": -3,
  "34292": -2,
  "34293": -2,
  "34295": -3,
  "34420": -8,
  "34421": -8,
  "34423": -10,
  "34428": -10,
  "34429": -10,
  "34430": -9,
  "34431": -10,
  "34432": -9,
  "34433": -10,
  "34434": -10,
  "34436": 0,
  "34442": -10,
  "34445": -10,
  "34446": -10,
  "34447": -10,
  "34448": -10,
  "34449": -13,
  "34450": -10,
  "34451": -10,
  "34452": -10,
  "34453": -10,
  "34460": -10,
  "34461": -9,
  "34464": -10,
  "34465": -10,
  "34470": -8,
  "34471": 1,
  "34472": -8,
  "34473": -8,
  "34474": -8,
  "34475": -8,
  "34476": -6,
  "34477": -8,
  "34478": -8,
  "34479": -8,
  "34480": -7,
  "34481": -8,
  "34482": -8,
  "34483": -8,
  "34484": 1,
  "34487": -10,
  "34488": -8,
  "34489": -8,
  "34491": -8,
  "34492": -8,
  "34498": -10,
  "34601": -10,
  "34602": -10,
  "34603": -10,
  "34604": -10,
  "34605": -10,
  "34606": -10,
  "34607": -9,
  "34608": -10,
  "34609": -10,
  "34610": -7,
  "34611": -10,
  "34613": -10,
  "34614": -11,
  "34636": 0,
  "34637": -6,
  "34638": -6,
  "34639": -6,
  "34652": -6,
  "34653": -6,
  "34654": -6,
  "34655": -6,
  "34656": -6,
  "34660": -3,
  "34661": 0,
  "34667": -6,
  "34668": -6,
  "34669": -6,
  "34673": -6,
  "34674": -6,
  "34677": -4,
  "34679": -9,
  "34680": -6,
  "34681": 5,
  "34682": -3,
  "34683": -3,
  "34684": -4,
  "34685": 5,
  "34688": 5,
  "34689": -6,
  "34690": -6,
  "34691": -6,
  "34692": -6,
  "34695": -4,
  "34697": -4,
  "34698": -4,
  "34705": -1,
  "34711": -1,
  "34712": -1,
  "34713": -1,
  "34714": -1,
  "34715": -1,
  "34729": -1,
  "34731": -3,
  "34734": 2,
  "34736": -1,
  "34737": -1,
  "34739": -7,
  "34740": 2,
  "34741": -6,
  "34742": -6,
  "34743": -6,
  "34744": -6,
  "34745": -6,
  "34746": -6,
  "34747": 3,
  "34748": -3,
  "34749": -3,
  "34753": -1,
  "34755": -1,
  "34756": -1,
  "34758": -6,
  "34759": -6,
  "34760": 2,
  "34761": 2,
  "34762": 0,
  "34769": -6,
  "34770": -6,
  "34771": -6,
  "34772": -6,
  "34773": -2,
  "34777": 2,
  "34778": 2,
  "34785": 0,
  "34786": 13,
  "34787": 2,
  "34788": -3,
  "34789": -3,
  "34797": -1,
  "34945": -9,
  "34946": -10,
  "34947": -9,
  "34948": -10,
  "34949": -9,
  "34950": -10,
  "34951": -8,
  "34952": -8,
  "34953": -8,
  "34954": -10,
  "34956": -5,
  "34957": -5,
  "34958": -4,
  "34972": -12,
  "34973": -12,
  "34974": -12,
  "34979": -10,
  "34981": -9,
  "34982": -9,
  "34983": -8,
  "34984": -8,
  "34985": -8,
  "34986": -6,
  "34987": -7,
  "34988": -7,
  "34990": 4,
  "34991": -5,
  "34992": -5,
  "34994": -5,
  "34995": -5,
  "34996": -4,
  "34997": -5,
  "35004": -5,
  "35005": 4,
  "35006": -4,
  "35007": 0,
  "35010": -10,
  "35011": -10,
  "35013": -12,
  "35014": -8,
  "35015": 4,
  "35016": -7,
  "35019": -7,
  "35020": 4,
  "35021": 4,
  "35022": 4,
  "35023": 4,
  "35031": -12,
  "35032": -8,
  "35033": -6,
  "35034": 6,
  "35035": 5,
  "35036": 4,
  "35038": -6,
  "35040": 0,
  "35041": 4,
  "35042": 6,
  "35043": 8,
  "35044": -8,
  "35045": -8,
  "35046": -8,
  "35048": 4,
  "35049": -12,
  "35051": 0,
  "35052": -6,
  "35053": -7,
  "35054": -5,
  "35055": -7,
  "35056": -7,
  "35057": -7,
  "35058": -7,
  "35060": 4,
  "35061": 4,
  "35062": -6,
  "35063": -6,
  "35064": 4,
  "35068": 4,
  "35070": -9,
  "35071": 4,
  "35072": -14,
  "35073": 4,
  "35074": 8,
  "35077": -9,
  "35078": -8,
  "35079": -12,
  "35080": 0,
  "35082": 1,
  "35083": -7,
  "35085": -9,
  "35087": -7,
  "35089": -10,
  "35091": 4,
  "35094": 4,
  "35096": -6,
  "35097": -12,
  "35098": -7,
  "35111": 5,
  "35112": -6,
  "35114": 0,
  "35115": 0,
  "35116": 4,
  "35117": 4,
  "35118": 4,
  "35119": 4,
  "35120": -6,
  "35121": -12,
  "35123": 4,
  "35124": 0,
  "35125": 3,
  "35126": 4,
  "35127": 4,
  "35128": -5,
  "35130": -6,
  "35131": -6,
  "35133": -12,
  "35135": 3,
  "35136": -4,
  "35137": 0,
  "35139": 4,
  "35142": 6,
  "35143": 0,
  "35144": 0,
  "35146": -5,
  "35147": 0,
  "35148": -6,
  "35149": -8,
  "35150": -8,
  "35151": -8,
  "35160": -8,
  "35161": -8,
  "35171": -9,
  "35172": -12,
  "35173": -5,
  "35175": -7,
  "35176": -6,
  "35178": -8,
  "35179": -7,
  "35180": -12,
  "35181": 4,
  "35182": -5,
  "35183": -9,
  "35184": 8,
  "35185": 0,
  "35186": 0,
  "35187": 0,
  "35188": 6,
  "35201": 4,
  "35202": 4,
  "35203": 4,
  "35204": 4,
  "35205": 4,
  "35206": 4,
  "35207": 4,
  "35208": 4,
  "35209": 6,
  "35210": 4,
  "35211": 4,
  "35212": 4,
  "35213": 13,
  "35214": 4,
  "35215": 4,
  "35216": 13,
  "35217": 4,
  "35218": 4,
  "35219": 6,
  "35220": 4,
  "35221": 4,
  "35222": 4,
  "35223": 15,
  "35224": 4,
  "35226": 6,
  "35228": 4,
  "35231": 4,
  "35232": 4,
  "35233": 4,
  "35234": 4,
  "35235": 4,
  "35236": 8,
  "35237": 4,
  "35238": 4,
  "35242": 8,
  "35243": 13,
  "35244": 8,
  "35253": 15,
  "35255": 4,
  "35259": 4,
  "35260": 6,
  "35261": 4,
  "35266": 6,
  "35283": 4,
  "35401": -4,
  "35402": -4,
  "35403": -4,
  "35404": -4,
  "35405": 4,
  "35406": 4,
  "35407": 4,
  "35440": 5,
  "35441": -6,
  "35442": -10,
  "35443": -1,
  "35444": 5,
  "35446": -4,
  "35447": -10,
  "35448": -1,
  "35449": -3,
  "35452": 4,
  "35453": -3,
  "35456": -4,
  "35457": -4,
  "35458": -4,
  "35459": 11,
  "35460": 11,
  "35461": -10,
  "35462": -1,
  "35463": -4,
  "35464": -1,
  "35466": -10,
  "35468": 6,
  "35469": -1,
  "35470": 11,
  "35471": -10,
  "35473": -4,
  "35474": -6,
  "35475": 4,
  "35476": 4,
  "35477": -1,
  "35478": -4,
  "35480": -1,
  "35481": -10,
  "35482": 4,
  "35485": -4,
  "35486": -4,
  "35490": 5,
  "35491": -1,
  "35501": -6,
  "35502": -6,
  "35503": -6,
  "35504": -6,
  "35540": -6,
  "35541": -6,
  "35542": -8,
  "35543": -17,
  "35544": -12,
  "35545": -8,
  "35546": 4,
  "35548": -17,
  "35549": -4,
  "35550": -6,
  "35551": -7,
  "35552": -17,
  "35553": -6,
  "35554": -8,
  "35555": -8,
  "35559": -8,
  "35560": -6,
  "35563": -16,
  "35564": -17,
  "35565": -7,
  "35570": -17,
  "35571": -12,
  "35572": -6,
  "35573": -4,
  "35574": -8,
  "35575": -6,
  "35576": -12,
  "35577": -6,
  "35578": -8,
  "35579": -4,
  "35580": -6,
  "35581": -12,
  "35582": -12,
  "35584": -6,
  "35585": -12,
  "35586": -12,
  "35587": -6,
  "35592": -12,
  "35593": -12,
  "35594": -8,
  "35601": -1,
  "35602": -1,
  "35603": -1,
  "35609": -1,
  "35610": -2,
  "35611": -2,
  "35612": -2,
  "35613": -2,
  "35614": -2,
  "35615": 8,
  "35616": -2,
  "35617": 2,
  "35618": -7,
  "35619": -1,
  "35620": -2,
  "35621": -7,
  "35622": -1,
  "35630": -6,
  "35631": -6,
  "35633": -6,
  "35634": -6,
  "35640": -1,
  "35643": -7,
  "35645": 2,
  "35646": -2,
  "35647": -2,
  "35648": -6,
  "35649": 8,
  "35650": -7,
  "35651": -7,
  "35652": 2,
  "35653": -12,
  "35654": -12,
  "35660": -2,
  "35661": 6,
  "35662": -2,
  "35670": -1,
  "35671": -2,
  "35672": -7,
  "35673": -6,
  "35674": -2,
  "35677": -2,
  "35739": -2,
  "35740": 4,
  "35741": 8,
  "35742": 0,
  "35744": -11,
  "35745": -11,
  "35746": -11,
  "35747": -7,
  "35748": 0,
  "35749": 0,
  "35750": 0,
  "35751": -1,
  "35752": -11,
  "35754": 0,
  "35755": -7,
  "35756": -1,
  "35757": 0,
  "35758": 8,
  "35759": 0,
  "35760": -7,
  "35761": 0,
  "35762": 0,
  "35763": 8,
  "35764": -1,
  "35765": -11,
  "35766": -11,
  "35767": 0,
  "35768": -11,
  "35769": -10,
  "35771": -6,
  "35772": -11,
  "35773": 0,
  "35774": -11,
  "35775": -1,
  "35776": -7,
  "35801": 8,
  "35802": 8,
  "35803": 0,
  "35804": 8,
  "35805": -1,
  "35806": 8,
  "35807": -1,
  "35808": -1,
  "35809": 8,
  "35810": 0,
  "35811": 0,
  "35812": 0,
  "35813": 8,
  "35814": -1,
  "35815": 8,
  "35816": 0,
  "35824": 8,
  "35901": -10,
  "35902": -10,
  "35903": -10,
  "35904": -10,
  "35905": -9,
  "35906": -1,
  "35907": -9,
  "35950": -9,
  "35951": -9,
  "35952": -13,
  "35953": -6,
  "35954": -10,
  "35956": -9,
  "35957": -9,
  "35958": 4,
  "35959": -7,
  "35960": -7,
  "35961": -8,
  "35962": -9,
  "35963": -8,
  "35964": -9,
  "35966": -11,
  "35967": -8,
  "35968": -8,
  "35971": -8,
  "35972": -9,
  "35973": -8,
  "35974": -8,
  "35975": -10,
  "35976": -7,
  "35978": -7,
  "35979": 4,
  "35980": -9,
  "35981": -11,
  "35983": -8,
  "35984": -6,
  "35986": -8,
  "35987": -9,
  "35988": -8,
  "35989": -8,
  "35990": -13,
  "36003": -2,
  "36005": -9,
  "36006": -1,
  "36008": -1,
  "36009": -12,
  "36010": -9,
  "36013": -1,
  "36015": -8,
  "36016": -4,
  "36017": -4,
  "36020": -4,
  "36022": -1,
  "36023": -4,
  "36024": -4,
  "36025": -4,
  "36026": -3,
  "36027": -3,
  "36028": -9,
  "36029": -1,
  "36030": -7,
  "36031": 0,
  "36032": -14,
  "36033": -8,
  "36034": -12,
  "36035": -12,
  "36036": -9,
  "36037": -7,
  "36038": -9,
  "36039": -1,
  "36040": -14,
  "36041": -12,
  "36042": -12,
  "36043": -1,
  "36045": -4,
  "36046": -14,
  "36047": -15,
  "36048": -4,
  "36049": -12,
  "36051": -1,
  "36052": -1,
  "36053": -3,
  "36054": -1,
  "36057": 8,
  "36061": -9,
  "36062": -12,
  "36064": 8,
  "36065": -9,
  "36066": 1,
  "36067": -1,
  "36068": 1,
  "36069": -14,
  "36071": -12,
  "36072": -3,
  "36075": -4,
  "36078": -4,
  "36079": -9,
  "36080": -2,
  "36081": -9,
  "36083": -4,
  "36087": -4,
  "36088": -4,
  "36089": -8,
  "36091": -1,
  "36092": 5,
  "36093": -4,
  "36101": -1,
  "36102": -1,
  "36103": -1,
  "36104": -1,
  "36105": -1,
  "36106": 8,
  "36107": -1,
  "36108": -1,
  "36109": -1,
  "36110": -1,
  "36111": 8,
  "36112": -1,
  "36113": -1,
  "36114": -1,
  "36115": -1,
  "36116": -1,
  "36117": 8,
  "36119": -1,
  "36120": -1,
  "36121": 8,
  "36123": -1,
  "36124": 8,
  "36125": -1,
  "36201": -5,
  "36202": -5,
  "36203": -5,
  "36204": -5,
  "36205": -5,
  "36206": -5,
  "36207": -5,
  "36210": -5,
  "36250": -5,
  "36251": -14,
  "36253": -5,
  "36254": -5,
  "36255": -14,
  "36256": -12,
  "36257": -5,
  "36258": -14,
  "36260": -5,
  "36261": 14,
  "36262": 14,
  "36263": 14,
  "36264": 14,
  "36265": -5,
  "36266": -14,
  "36267": -12,
  "36268": -8,
  "36269": 14,
  "36271": -5,
  "36272": -8,
  "36273": 15,
  "36274": -12,
  "36275": -8,
  "36276": -12,
  "36277": -5,
  "36278": -12,
  "36279": -5,
  "36280": -13,
  "36301": -6,
  "36302": 2,
  "36303": 2,
  "36304": 2,
  "36305": 2,
  "36310": -4,
  "36311": -4,
  "36312": -6,
  "36313": -17,
  "36314": -16,
  "36316": -16,
  "36317": -4,
  "36318": -16,
  "36319": -4,
  "36320": -6,
  "36321": -6,
  "36322": -4,
  "36323": -10,
  "36330": -1,
  "36331": -1,
  "36340": -17,
  "36343": -7,
  "36344": -17,
  "36345": -3,
  "36346": -10,
  "36349": -6,
  "36350": -4,
  "36351": -10,
  "36352": -4,
  "36353": -4,
  "36360": -4,
  "36361": -4,
  "36362": 5,
  "36370": -6,
  "36371": -4,
  "36373": -4,
  "36374": -4,
  "36375": -6,
  "36376": -6,
  "36401": -12,
  "36420": -9,
  "36421": -9,
  "36425": -7,
  "36426": -12,
  "36427": -12,
  "36429": -12,
  "36432": -12,
  "36435": -10,
  "36436": -7,
  "36439": -7,
  "36441": -9,
  "36442": -9,
  "36444": -7,
  "36445": -7,
  "36446": -7,
  "36449": -7,
  "36451": -7,
  "36453": -9,
  "36454": -12,
  "36455": -9,
  "36456": -8,
  "36457": -7,
  "36458": -7,
  "36460": -7,
  "36461": -7,
  "36467": -9,
  "36470": -7,
  "36471": -7,
  "36473": -12,
  "36474": -9,
  "36475": -7,
  "36476": -9,
  "36477": -16,
  "36480": -7,
  "36481": -10,
  "36482": -7,
  "36483": -9,
  "36501": -7,
  "36502": -9,
  "36503": -9,
  "36504": -9,
  "36505": -2,
  "36507": -3,
  "36509": -3,
  "36511": -3,
  "36512": 6,
  "36513": -2,
  "36515": 6,
  "36518": 6,
  "36521": -2,
  "36522": 6,
  "36523": -2,
  "36524": -7,
  "36525": -2,
  "36526": -3,
  "36527": -3,
  "36528": 4,
  "36529": 6,
  "36530": -3,
  "36532": -3,
  "36533": -3,
  "36535": -3,
  "36536": -3,
  "36538": -7,
  "36539": 6,
  "36540": -7,
  "36541": -3,
  "36542": 6,
  "36543": -9,
  "36544": -2,
  "36545": -7,
  "36547": 6,
  "36548": -7,
  "36549": -5,
  "36550": 6,
  "36551": -3,
  "36553": 6,
  "36555": -3,
  "36556": 6,
  "36558": -12,
  "36559": 7,
  "36560": 6,
  "36561": 4,
  "36562": -9,
  "36564": 7,
  "36567": -3,
  "36568": -3,
  "36569": 6,
  "36571": -2,
  "36572": -2,
  "36574": -5,
  "36575": -2,
  "36576": -3,
  "36577": -3,
  "36578": -3,
  "36579": 6,
  "36580": -3,
  "36581": 6,
  "36582": -2,
  "36583": 6,
  "36584": 6,
  "36585": 6,
  "36587": -2,
  "36590": -2,
  "36601": -2,
  "36602": -2,
  "36603": -2,
  "36604": -2,
  "36605": -2,
  "36606": -2,
  "36607": -2,
  "36608": -2,
  "36609": -2,
  "36610": -2,
  "36611": -2,
  "36612": -2,
  "36613": -2,
  "36615": -2,
  "36616": -2,
  "36617": -2,
  "36618": -2,
  "36619": -2,
  "36633": -2,
  "36640": -2,
  "36641": -2,
  "36652": -2,
  "36660": -2,
  "36663": -2,
  "36670": -2,
  "36671": -2,
  "36685": -2,
  "36689": -2,
  "36691": -2,
  "36693": -2,
  "36695": -2,
  "36701": -6,
  "36702": -6,
  "36703": -7,
  "36720": -10,
  "36721": -10,
  "36722": -10,
  "36723": -10,
  "36726": -10,
  "36727": 0,
  "36728": -10,
  "36732": -4,
  "36736": -4,
  "36738": -5,
  "36740": -6,
  "36741": -15,
  "36742": -4,
  "36744": -6,
  "36745": -4,
  "36748": -4,
  "36749": -6,
  "36750": -8,
  "36751": -10,
  "36752": -14,
  "36753": -7,
  "36754": -5,
  "36756": -9,
  "36758": -8,
  "36759": -6,
  "36761": -15,
  "36762": 0,
  "36763": -4,
  "36764": -4,
  "36765": -9,
  "36766": -8,
  "36767": -6,
  "36768": -8,
  "36769": -10,
  "36773": -6,
  "36775": -6,
  "36776": -6,
  "36782": -4,
  "36783": -4,
  "36784": -6,
  "36785": -14,
  "36786": -10,
  "36790": -8,
  "36792": -9,
  "36793": 6,
  "36801": -5,
  "36802": -5,
  "36803": -5,
  "36804": -5,
  "36830": 5,
  "36831": 5,
  "36832": 5,
  "36850": -11,
  "36851": -8,
  "36852": -6,
  "36853": -10,
  "36854": -11,
  "36855": -11,
  "36856": -7,
  "36858": -6,
  "36859": -8,
  "36860": -6,
  "36861": -10,
  "36862": -11,
  "36863": -11,
  "36865": -4,
  "36866": -4,
  "36867": -5,
  "36868": -7,
  "36869": -7,
  "36870": -5,
  "36871": -8,
  "36872": -11,
  "36874": -5,
  "36875": -7,
  "36877": -5,
  "36879": -4,
  "36901": 11,
  "36904": 0,
  "36907": 11,
  "36908": 0,
  "36910": 1,
  "36912": 1,
  "36913": -1,
  "36915": -1,
  "36916": 1,
  "36919": -1,
  "36921": -1,
  "36922": 11,
  "36925": 11,
  "37010": 7,
  "37011": 7,
  "37012": -11,
  "37013": 7,
  "37014": 9,
  "37015": -2,
  "37016": -12,
  "37018": -5,
  "37019": -3,
  "37020": 1,
  "37022": -11,
  "37023": 9,
  "37024": 20,
  "37025": -4,
  "37026": -12,
  "37027": 20,
  "37028": 8,
  "37029": -4,
  "37030": -4,
  "37031": -11,
  "37032": 7,
  "37033": -10,
  "37034": 1,
  "37035": -3,
  "37036": -5,
  "37037": 1,
  "37040": -2,
  "37041": -2,
  "37042": -2,
  "37043": -2,
  "37046": 20,
  "37047": -3,
  "37048": 5,
  "37049": -1,
  "37050": 8,
  "37051": -5,
  "37052": -2,
  "37055": -5,
  "37056": -5,
  "37057": -11,
  "37058": 9,
  "37059": -11,
  "37060": 1,
  "37061": 8,
  "37062": 12,
  "37063": 1,
  "37064": 13,
  "37065": 13,
  "37066": 5,
  "37067": 20,
  "37068": 20,
  "37069": 20,
  "37070": -1,
  "37071": 2,
  "37072": -1,
  "37073": -1,
  "37074": -11,
  "37075": 5,
  "37076": 7,
  "37077": 5,
  "37078": 0,
  "37079": -2,
  "37080": -2,
  "37082": -2,
  "37083": -11,
  "37085": 1,
  "37086": 1,
  "37087": 2,
  "37088": 2,
  "37090": 3,
  "37091": -3,
  "37095": -11,
  "37096": -10,
  "37097": -10,
  "37098": -4,
  "37101": 0,
  "37110": -5,
  "37111": -5,
  "37115": 7,
  "37116": 7,
  "37118": -4,
  "37119": 5,
  "37121": 2,
  "37122": 2,
  "37127": 1,
  "37128": 1,
  "37129": 1,
  "37130": 1,
  "37133": 1,
  "37134": -7,
  "37135": 12,
  "37136": 2,
  "37137": -4,
  "37138": 7,
  "37140": -5,
  "37141": -1,
  "37142": -2,
  "37143": -2,
  "37144": -2,
  "37145": -4,
  "37146": 6,
  "37148": 5,
  "37149": -12,
  "37150": -16,
  "37151": -4,
  "37152": -1,
  "37153": 1,
  "37160": 1,
  "37162": 1,
  "37165": -5,
  "37166": -11,
  "37167": 1,
  "37171": -2,
  "37172": -1,
  "37174": 5,
  "37175": 8,
  "37178": 8,
  "37179": 12,
  "37180": 1,
  "37181": -5,
  "37183": 1,
  "37184": 2,
  "37185": 0,
  "37186": -11,
  "37187": -4,
  "37188": 5,
  "37189": 7,
  "37190": -12,
  "37191": -2,
  "37201": 7,
  "37202": 7,
  "37203": 7,
  "37204": 9,
  "37205": 16,
  "37206": 7,
  "37207": 7,
  "37208": 7,
  "37209": 7,
  "37210": 7,
  "37211": 7,
  "37212": 9,
  "37213": 7,
  "37214": 7,
  "37215": 18,
  "37216": 7,
  "37217": 7,
  "37218": 7,
  "37219": 7,
  "37220": 16,
  "37221": 12,
  "37222": 7,
  "37224": 7,
  "37227": 7,
  "37228": 7,
  "37229": 7,
  "37230": 7,
  "37238": 7,
  "37244": 7,
  "37301": -10,
  "37302": 16,
  "37303": -2,
  "37304": 8,
  "37305": -10,
  "37306": -8,
  "37307": -11,
  "37308": 8,
  "37309": -2,
  "37310": 8,
  "37311": 8,
  "37312": 8,
  "37313": -10,
  "37314": -2,
  "37315": 4,
  "37316": -10,
  "37317": -10,
  "37318": -8,
  "37320": 8,
  "37321": 8,
  "37322": 8,
  "37323": 8,
  "37324": -8,
  "37325": -11,
  "37326": -11,
  "37327": -10,
  "37328": -2,
  "37329": -2,
  "37330": -7,
  "37331": -2,
  "37332": 7,
  "37333": -11,
  "37334": -2,
  "37335": -2,
  "37336": 8,
  "37337": -7,
  "37338": 8,
  "37339": -10,
  "37340": 4,
  "37341": 3,
  "37342": -5,
  "37343": 3,
  "37345": -7,
  "37347": 5,
  "37348": -2,
  "37349": -5,
  "37350": 13,
  "37351": 2,
  "37352": -8,
  "37353": 8,
  "37354": -2,
  "37355": -5,
  "37356": -9,
  "37357": -5,
  "37359": -8,
  "37360": -5,
  "37361": -10,
  "37362": -10,
  "37363": 4,
  "37364": 8,
  "37365": -10,
  "37366": -10,
  "37367": -11,
  "37369": -11,
  "37370": -2,
  "37371": -2,
  "37373": 8,
  "37374": 4,
  "37375": -8,
  "37376": -8,
  "37377": 11,
  "37378": -5,
  "37379": 3,
  "37380": 5,
  "37381": 8,
  "37382": -5,
  "37384": 3,
  "37385": -2,
  "37387": -10,
  "37388": -5,
  "37389": -7,
  "37391": -11,
  "37394": -5,
  "37396": 3,
  "37397": 4,
  "37398": -7,
  "37401": 2,
  "37402": 3,
  "37403": 2,
  "37404": 2,
  "37405": 3,
  "37406": 2,
  "37407": 2,
  "37408": 2,
  "37409": 2,
  "37410": 2,
  "37411": 3,
  "37412": 3,
  "37414": 3,
  "37415": 3,
  "37416": 3,
  "37419": 3,
  "37421": 4,
  "37422": 11,
  "37424": 4,
  "37450": 3,
  "37601": -6,
  "37602": -6,
  "37604": -6,
  "37605": -6,
  "37614": -6,
  "37615": 2,
  "37616": -6,
  "37617": 6,
  "37618": -3,
  "37620": -3,
  "37621": -3,
  "37625": -3,
  "37640": -6,
  "37641": -6,
  "37642": 1,
  "37643": -6,
  "37644": -6,
  "37645": 1,
  "37650": -6,
  "37656": 1,
  "37657": -7,
  "37658": -7,
  "37659": -6,
  "37660": 6,
  "37662": 6,
  "37663": 6,
  "37664": 6,
  "37665": -2,
  "37680": -11,
  "37681": -6,
  "37682": -6,
  "37683": -12,
  "37684": -6,
  "37686": -2,
  "37687": -7,
  "37688": -11,
  "37690": -6,
  "37691": -11,
  "37692": -6,
  "37694": -6,
  "37701": -5,
  "37705": -7,
  "37707": -9,
  "37708": -3,
  "37709": -8,
  "37710": 6,
  "37711": 5,
  "37713": -13,
  "37714": -11,
  "37715": -12,
  "37716": 7,
  "37717": 7,
  "37719": 7,
  "37721": -8,
  "37722": -13,
  "37723": -7,
  "37724": -9,
  "37725": -3,
  "37726": -8,
  "37727": -12,
  "37729": -11,
  "37730": -12,
  "37731": -7,
  "37732": -11,
  "37733": -13,
  "37737": -5,
  "37738": 5,
  "37742": -4,
  "37743": -6,
  "37744": -6,
  "37745": -6,
  "37748": -8,
  "37752": -9,
  "37753": -12,
  "37754": 0,
  "37755": -11,
  "37756": -11,
  "37757": -11,
  "37760": -5,
  "37762": -11,
  "37763": -6,
  "37764": -3,
  "37765": -28,
  "37766": -11,
  "37769": 7,
  "37770": -8,
  "37771": -4,
  "37772": -4,
  "37773": -9,
  "37774": -4,
  "37777": -5,
  "37778": -3,
  "37779": -8,
  "37801": -5,
  "37802": -5,
  "37803": -5,
  "37804": -5,
  "37806": -8,
  "37807": 2,
  "37809": -7,
  "37810": -3,
  "37811": -3,
  "37813": -3,
  "37814": -3,
  "37815": -3,
  "37816": -3,
  "37818": -7,
  "37819": -11,
  "37820": -5,
  "37821": -13,
  "37822": -13,
  "37824": -9,
  "37825": -9,
  "37826": -2,
  "37828": 15,
  "37829": -8,
  "37830": 7,
  "37831": 7,
  "37840": 7,
  "37841": -11,
  "37843": -12,
  "37845": 15,
  "37846": -6,
  "37847": -11,
  "37848": -8,
  "37849": 0,
  "37851": -12,
  "37852": -11,
  "37853": -5,
  "37854": -7,
  "37857": 1,
  "37860": 5,
  "37861": -5,
  "37862": -3,
  "37863": -2,
  "37864": -2,
  "37865": -3,
  "37866": -8,
  "37867": -9,
  "37868": -2,
  "37869": -27,
  "37870": -9,
  "37871": 0,
  "37872": -8,
  "37873": -6,
  "37874": -2,
  "37876": -3,
  "37877": -3,
  "37878": -5,
  "37879": -9,
  "37880": -9,
  "37881": -28,
  "37882": -4,
  "37885": -2,
  "37886": -5,
  "37887": -8,
  "37888": -5,
  "37890": -3,
  "37891": 5,
  "37892": -11,
  "37901": 0,
  "37902": 9,
  "37909": 1,
  "37912": 0,
  "37914": 0,
  "37915": 0,
  "37916": 0,
  "37917": 0,
  "37918": 0,
  "37919": 9,
  "37920": 0,
  "37921": 0,
  "37922": 9,
  "37923": 9,
  "37924": 0,
  "37927": 0,
  "37928": 0,
  "37929": 9,
  "37930": 9,
  "37931": 2,
  "37932": 9,
  "37933": 9,
  "37934": 9,
  "37938": 2,
  "37939": 9,
  "37940": 0,
  "37950": 1,
  "38001": -6,
  "38002": -1,
  "38004": -3,
  "38006": -6,
  "38007": -8,
  "38008": -5,
  "38010": 5,
  "38011": -3,
  "38012": 17,
  "38014": -1,
  "38015": -3,
  "38016": 12,
  "38017": 12,
  "38018": 12,
  "38019": -3,
  "38021": -6,
  "38023": -3,
  "38024": -7,
  "38025": -7,
  "38027": 12,
  "38028": 5,
  "38029": 3,
  "38030": 2,
  "38034": -6,
  "38036": -3,
  "38037": 1,
  "38039": -5,
  "38040": 1,
  "38041": 1,
  "38042": -5,
  "38044": -5,
  "38045": 5,
  "38046": -3,
  "38047": -7,
  "38048": 5,
  "38049": -3,
  "38050": -6,
  "38052": -5,
  "38053": -3,
  "38054": -3,
  "38057": -3,
  "38058": -3,
  "38059": -7,
  "38060": -3,
  "38061": -9,
  "38063": 2,
  "38066": -3,
  "38067": -5,
  "38068": 5,
  "38069": 17,
  "38070": -7,
  "38071": -3,
  "38075": -5,
  "38076": 5,
  "38077": -8,
  "38079": -7,
  "38080": -8,
  "38083": -3,
  "38088": 12,
  "38101": 3,
  "38103": 12,
  "38104": 3,
  "38105": 3,
  "38106": 3,
  "38107": 3,
  "38108": 3,
  "38109": 3,
  "38111": 3,
  "38112": 3,
  "38113": 3,
  "38114": 3,
  "38115": 3,
  "38116": 3,
  "38117": 3,
  "38118": 3,
  "38119": 5,
  "38120": 12,
  "38122": 3,
  "38124": 3,
  "38125": 3,
  "38126": 3,
  "38127": 3,
  "38128": 3,
  "38130": 3,
  "38131": 3,
  "38132": 3,
  "38133": 3,
  "38134": 3,
  "38135": 3,
  "38137": 12,
  "38138": 3,
  "38139": 12,
  "38141": 3,
  "38157": 12,
  "38167": 3,
  "38168": 3,
  "38173": 12,
  "38174": 3,
  "38175": 3,
  "38177": 3,
  "38181": 3,
  "38182": 3,
  "38183": 12,
  "38184": 3,
  "38186": 3,
  "38187": 5,
  "38190": 3,
  "38201": -2,
  "38220": -9,
  "38221": -7,
  "38222": 4,
  "38223": 4,
  "38224": 4,
  "38225": -17,
  "38226": -18,
  "38229": -18,
  "38230": -18,
  "38231": 4,
  "38232": -7,
  "38233": -6,
  "38235": -3,
  "38236": 4,
  "38237": -16,
  "38240": -7,
  "38241": -17,
  "38242": 4,
  "38251": 3,
  "38253": -6,
  "38254": -7,
  "38255": -18,
  "38256": 4,
  "38257": -6,
  "38258": -3,
  "38259": -6,
  "38260": -6,
  "38261": -6,
  "38271": -6,
  "38281": -6,
  "38301": 0,
  "38302": 0,
  "38303": 0,
  "38305": 8,
  "38308": 0,
  "38310": -12,
  "38311": -10,
  "38313": 0,
  "38314": 0,
  "38315": -9,
  "38316": -9,
  "38317": -7,
  "38318": -3,
  "38320": -6,
  "38321": -3,
  "38324": -3,
  "38326": -13,
  "38327": -13,
  "38328": -10,
  "38329": -10,
  "38330": -9,
  "38331": -6,
  "38332": -10,
  "38333": -7,
  "38334": 3,
  "38336": -6,
  "38337": -6,
  "38338": -9,
  "38339": -9,
  "38340": 3,
  "38341": -7,
  "38342": -7,
  "38343": -9,
  "38344": -2,
  "38345": -9,
  "38346": -9,
  "38347": 4,
  "38348": -3,
  "38351": -9,
  "38352": 8,
  "38355": 8,
  "38356": 0,
  "38357": -9,
  "38358": -9,
  "38359": 3,
  "38361": -13,
  "38362": 8,
  "38363": -10,
  "38365": -12,
  "38366": 3,
  "38367": -8,
  "38368": -10,
  "38369": -9,
  "38370": -13,
  "38371": -10,
  "38372": -13,
  "38374": -10,
  "38375": -9,
  "38376": -12,
  "38377": 0,
  "38378": 1,
  "38379": -9,
  "38380": -10,
  "38381": -5,
  "38382": -9,
  "38387": -2,
  "38388": -9,
  "38389": -9,
  "38390": -3,
  "38391": 0,
  "38392": 17,
  "38393": -8,
  "38401": 4,
  "38402": 4,
  "38425": -19,
  "38449": -9,
  "38450": -19,
  "38451": 4,
  "38452": -19,
  "38453": -9,
  "38454": -4,
  "38455": -9,
  "38456": -8,
  "38457": -9,
  "38459": -9,
  "38460": -10,
  "38461": -13,
  "38462": -14,
  "38463": -6,
  "38464": -8,
  "38468": -8,
  "38469": -9,
  "38471": -20,
  "38472": -8,
  "38473": -10,
  "38474": 4,
  "38475": -13,
  "38476": -4,
  "38477": -9,
  "38478": -9,
  "38481": -6,
  "38482": 4,
  "38483": -14,
  "38485": -19,
  "38486": -9,
  "38487": -13,
  "38488": -2,
  "38501": -4,
  "38502": -4,
  "38503": -4,
  "38504": -13,
  "38506": -4,
  "38541": -17,
  "38542": 8,
  "38543": 8,
  "38544": -4,
  "38545": -16,
  "38547": -4,
  "38548": -4,
  "38549": 9,
  "38550": -5,
  "38551": -16,
  "38552": -4,
  "38553": -12,
  "38554": 8,
  "38555": -7,
  "38556": -12,
  "38557": 1,
  "38558": -7,
  "38559": -14,
  "38560": -4,
  "38562": -16,
  "38563": -4,
  "38564": -4,
  "38565": -12,
  "38567": -4,
  "38568": 10,
  "38569": -9,
  "38570": 9,
  "38571": 1,
  "38572": 1,
  "38573": 9,
  "38574": -5,
  "38575": -16,
  "38577": -12,
  "38578": -7,
  "38579": -14,
  "38580": 9,
  "38581": -5,
  "38582": -11,
  "38583": -14,
  "38585": -12,
  "38587": -14,
  "38588": -16,
  "38589": -13,
  "38601": 32,
  "38602": 0,
  "38603": -4,
  "38606": -4,
  "38609": -7,
  "38610": -4,
  "38611": 32,
  "38614": -7,
  "38617": -7,
  "38618": 0,
  "38619": -1,
  "38620": -4,
  "38621": -4,
  "38622": -4,
  "38623": -4,
  "38625": -5,
  "38626": 10,
  "38627": -5,
  "38628": -4,
  "38629": -3,
  "38630": -7,
  "38631": -7,
  "38632": 6,
  "38633": -5,
  "38634": 32,
  "38635": 32,
  "38637": 6,
  "38638": 0,
  "38639": -7,
  "38641": 14,
  "38642": 32,
  "38643": -7,
  "38644": -7,
  "38645": -7,
  "38646": -7,
  "38647": 4,
  "38649": 32,
  "38650": -5,
  "38651": 6,
  "38652": -5,
  "38654": 6,
  "38655": -1,
  "38658": -4,
  "38659": 32,
  "38661": 32,
  "38663": -3,
  "38664": 9,
  "38665": 10,
  "38666": -4,
  "38668": 0,
  "38669": -7,
  "38670": -4,
  "38671": 6,
  "38672": 6,
  "38673": -1,
  "38674": -3,
  "38675": -1,
  "38676": 10,
  "38677": -1,
  "38679": 32,
  "38680": 14,
  "38683": -3,
  "38685": 32,
  "38701": -8,
  "38702": -9,
  "38703": -9,
  "38704": -9,
  "38720": -7,
  "38721": -20,
  "38722": -9,
  "38723": -8,
  "38725": -3,
  "38726": -4,
  "38730": 5,
  "38731": -20,
  "38732": -2,
  "38733": -4,
  "38736": -4,
  "38737": -3,
  "38738": -4,
  "38739": -7,
  "38740": -2,
  "38744": -20,
  "38745": -20,
  "38746": -3,
  "38748": -9,
  "38749": -4,
  "38751": -4,
  "38753": -13,
  "38754": -13,
  "38756": -8,
  "38759": -3,
  "38760": -9,
  "38761": -4,
  "38762": -3,
  "38764": -4,
  "38765": -20,
  "38767": -7,
  "38768": -7,
  "38769": -3,
  "38771": -4,
  "38772": -9,
  "38773": -4,
  "38774": -3,
  "38776": -8,
  "38778": -4,
  "38780": -8,
  "38781": -3,
  "38782": -9,
  "38801": 8,
  "38802": 1,
  "38803": 1,
  "38804": 1,
  "38820": -6,
  "38821": 4,
  "38824": -2,
  "38825": 4,
  "38826": 8,
  "38827": 4,
  "38828": -5,
  "38829": -2,
  "38833": 4,
  "38834": 3,
  "38835": 3,
  "38838": 4,
  "38839": -3,
  "38841": -6,
  "38843": -4,
  "38844": -6,
  "38846": 3,
  "38847": 4,
  "38848": 5,
  "38849": -1,
  "38850": -7,
  "38851": -7,
  "38852": 4,
  "38855": -4,
  "38856": -2,
  "38857": -1,
  "38858": 4,
  "38859": -3,
  "38860": -8,
  "38862": -1,
  "38863": -6,
  "38864": -6,
  "38865": 3,
  "38866": 1,
  "38868": -1,
  "38869": -6,
  "38870": 4,
  "38871": -6,
  "38873": 4,
  "38874": -6,
  "38875": -7,
  "38876": -4,
  "38877": -7,
  "38878": -3,
  "38879": -1,
  "38880": -2,
  "38901": -3,
  "38902": -3,
  "38913": -3,
  "38914": -3,
  "38915": -3,
  "38916": -3,
  "38917": -4,
  "38920": -4,
  "38921": -4,
  "38922": 0,
  "38923": -4,
  "38924": -5,
  "38925": 1,
  "38926": -3,
  "38927": -4,
  "38928": -4,
  "38929": -3,
  "38930": 2,
  "38935": 2,
  "38940": -4,
  "38941": 2,
  "38943": -4,
  "38944": 1,
  "38945": 2,
  "38946": 1,
  "38947": -4,
  "38948": 0,
  "38949": -1,
  "38950": 2,
  "38951": -3,
  "38952": 1,
  "38953": -3,
  "38954": 1,
  "38955": -3,
  "38957": -7,
  "38958": -4,
  "38959": 1,
  "38960": -3,
  "38961": 0,
  "38962": -4,
  "38963": -7,
  "38964": -7,
  "38965": 0,
  "38966": -7,
  "38967": 1,
  "39038": -13,
  "39039": -1,
  "39040": -1,
  "39041": 0,
  "39042": 13,
  "39043": 13,
  "39044": -1,
  "39045": 6,
  "39046": 7,
  "39047": 13,
  "39051": -4,
  "39054": -20,
  "39056": 8,
  "39057": 0,
  "39059": -1,
  "39060": 0,
  "39061": -20,
  "39062": -1,
  "39063": -5,
  "39066": 1,
  "39067": -4,
  "39069": -1,
  "39071": 7,
  "39072": 7,
  "39073": 5,
  "39074": 1,
  "39077": -1,
  "39078": -1,
  "39079": -5,
  "39080": 1,
  "39081": -1,
  "39082": -1,
  "39083": -1,
  "39086": -1,
  "39087": 1,
  "39088": -20,
  "39090": -4,
  "39092": 1,
  "39094": 1,
  "39095": -5,
  "39096": -1,
  "39097": -14,
  "39098": 1,
  "39107": -5,
  "39108": -8,
  "39109": 5,
  "39110": 15,
  "39111": -1,
  "39113": -20,
  "39114": -1,
  "39115": -13,
  "39116": 0,
  "39117": 1,
  "39119": -5,
  "39120": -1,
  "39121": -1,
  "39122": -1,
  "39130": 15,
  "39140": -1,
  "39144": -1,
  "39145": 5,
  "39146": -5,
  "39148": -1,
  "39149": -1,
  "39150": 0,
  "39151": 8,
  "39152": 1,
  "39153": 0,
  "39154": 8,
  "39156": 1,
  "39157": 15,
  "39158": 15,
  "39159": -20,
  "39160": -5,
  "39161": 7,
  "39162": -1,
  "39163": 7,
  "39165": -1,
  "39166": -13,
  "39167": 5,
  "39168": 0,
  "39169": -5,
  "39170": 8,
  "39171": 6,
  "39173": -1,
  "39174": -1,
  "39175": -1,
  "39176": 1,
  "39177": -20,
  "39179": 7,
  "39180": 1,
  "39181": 1,
  "39182": 1,
  "39183": 1,
  "39189": 1,
  "39190": -1,
  "39191": -1,
  "39192": -5,
  "39193": 5,
  "39194": -1,
  "39201": -1,
  "39202": 8,
  "39203": -1,
  "39204": 0,
  "39205": 8,
  "39206": 0,
  "39207": -1,
  "39208": 5,
  "39209": 0,
  "39211": 13,
  "39212": 0,
  "39213": 0,
  "39215": -1,
  "39216": 8,
  "39218": 0,
  "39225": -1,
  "39232": -1,
  "39236": 13,
  "39269": -1,
  "39272": 0,
  "39282": 0,
  "39283": 0,
  "39284": 0,
  "39286": 0,
  "39288": 8,
  "39289": 8,
  "39296": 8,
  "39298": -1,
  "39301": -3,
  "39302": -4,
  "39303": 5,
  "39304": -3,
  "39305": 5,
  "39307": -4,
  "39320": 5,
  "39322": -5,
  "39323": 0,
  "39324": -5,
  "39325": -3,
  "39326": 17,
  "39327": 0,
  "39328": 17,
  "39330": 8,
  "39332": 0,
  "39335": -2,
  "39336": 0,
  "39337": 5,
  "39338": -1,
  "39339": -8,
  "39341": 0,
  "39342": 5,
  "39345": 0,
  "39346": -9,
  "39347": 9,
  "39348": -1,
  "39350": 5,
  "39352": 17,
  "39354": 17,
  "39355": 8,
  "39356": -1,
  "39358": 17,
  "39359": 1,
  "39360": 8,
  "39361": 0,
  "39362": -5,
  "39363": 8,
  "39364": -2,
  "39365": 5,
  "39366": -1,
  "39367": -5,
  "39401": 2,
  "39402": 10,
  "39403": 2,
  "39404": 10,
  "39421": 8,
  "39422": -1,
  "39423": -9,
  "39425": -8,
  "39426": 2,
  "39427": 8,
  "39428": -5,
  "39429": 15,
  "39436": 1,
  "39437": 1,
  "39439": -1,
  "39440": 1,
  "39441": 0,
  "39442": 0,
  "39443": 0,
  "39451": 0,
  "39452": 1,
  "39455": -2,
  "39456": -9,
  "39457": 2,
  "39459": 1,
  "39460": -1,
  "39461": -9,
  "39462": -9,
  "39463": 2,
  "39464": 1,
  "39465": 2,
  "39466": 2,
  "39470": 1,
  "39474": 8,
  "39475": 6,
  "39476": -9,
  "39477": 0,
  "39478": 14,
  "39479": -4,
  "39480": 1,
  "39481": -1,
  "39482": -2,
  "39483": 14,
  "39501": 1,
  "39502": 1,
  "39503": 1,
  "39505": 1,
  "39506": 2,
  "39507": 2,
  "39520": 3,
  "39521": 3,
  "39525": 12,
  "39530": 2,
  "39531": 2,
  "39532": 2,
  "39533": 2,
  "39534": 2,
  "39535": 2,
  "39540": 2,
  "39552": 3,
  "39553": 3,
  "39555": 3,
  "39556": 3,
  "39558": 3,
  "39560": 1,
  "39561": -3,
  "39562": 3,
  "39563": 3,
  "39564": 5,
  "39565": 5,
  "39566": 5,
  "39567": 3,
  "39568": 3,
  "39569": 3,
  "39571": 3,
  "39572": 3,
  "39573": -3,
  "39574": 1,
  "39576": 3,
  "39577": -4,
  "39581": 3,
  "39601": -4,
  "39602": -4,
  "39603": -4,
  "39629": -4,
  "39630": -7,
  "39631": -3,
  "39632": -6,
  "39633": -6,
  "39635": -6,
  "39638": -6,
  "39641": 2,
  "39643": 14,
  "39645": -6,
  "39647": -4,
  "39648": -6,
  "39649": -8,
  "39652": -7,
  "39653": -6,
  "39654": 2,
  "39656": 9,
  "39657": -6,
  "39661": 0,
  "39662": 2,
  "39663": 2,
  "39664": -6,
  "39665": 2,
  "39666": -8,
  "39667": -8,
  "39668": -4,
  "39669": -3,
  "39701": 6,
  "39702": 6,
  "39703": 6,
  "39704": 6,
  "39705": 6,
  "39730": 5,
  "39735": -7,
  "39736": -5,
  "39737": -3,
  "39739": 0,
  "39740": 6,
  "39741": -4,
  "39743": 0,
  "39744": -3,
  "39745": -7,
  "39746": 5,
  "39747": 0,
  "39750": -1,
  "39751": -1,
  "39752": -1,
  "39753": 6,
  "39754": -4,
  "39755": -5,
  "39756": 5,
  "39759": -5,
  "39760": -5,
  "39762": -5,
  "39766": 6,
  "39767": 1,
  "39769": -5,
  "39771": -3,
  "39772": -7,
  "39773": -4,
  "39776": -7,
  "39813": 4,
  "39815": -11,
  "39817": -11,
  "39818": -11,
  "39819": -11,
  "39823": -12,
  "39824": -4,
  "39825": -12,
  "39826": -15,
  "39827": -11,
  "39828": -11,
  "39829": -11,
  "39832": -12,
  "39834": -11,
  "39836": -3,
  "39837": -12,
  "39840": -4,
  "39841": -12,
  "39842": -15,
  "39845": -12,
  "39846": -4,
  "39851": -3,
  "39852": -11,
  "39854": -17,
  "39859": -12,
  "39861": -12,
  "39862": 4,
  "39866": 4,
  "39867": -3,
  "39870": -12,
  "39877": -4,
  "39885": 0,
  "39886": -4,
  "39897": -11,
  "40003": -1,
  "40004": -2,
  "40006": 1,
  "40007": -11,
  "40008": -10,
  "40009": -9,
  "40010": 6,
  "40011": -11,
  "40012": -10,
  "40013": -2,
  "40014": 6,
  "40018": 6,
  "40019": -11,
  "40020": -9,
  "40022": -1,
  "40023": -1,
  "40025": 6,
  "40026": 6,
  "40027": 6,
  "40031": -3,
  "40033": -2,
  "40036": 18,
  "40037": -3,
  "40040": -2,
  "40041": 6,
  "40045": -9,
  "40046": -9,
  "40047": -4,
  "40048": -2,
  "40049": -3,
  "40050": -11,
  "40051": -11,
  "40052": -11,
  "40055": 1,
  "40056": -3,
  "40057": -11,
  "40058": -11,
  "40059": 6,
  "40060": -11,
  "40061": -2,
  "40062": -11,
  "40063": -2,
  "40065": -4,
  "40066": -4,
  "40067": -4,
  "40068": -11,
  "40069": -2,
  "40070": -11,
  "40071": -9,
  "40075": -11,
  "40076": -3,
  "40077": -3,
  "40078": -2,
  "40104": 2,
  "40107": -3,
  "40108": 1,
  "40109": -4,
  "40110": -4,
  "40111": -6,
  "40115": -13,
  "40117": 2,
  "40118": 4,
  "40119": -13,
  "40121": 1,
  "40129": -4,
  "40140": -13,
  "40142": 2,
  "40143": -13,
  "40144": -13,
  "40145": -13,
  "40146": -13,
  "40150": -4,
  "40152": -13,
  "40153": -13,
  "40155": 1,
  "40157": 2,
  "40159": -2,
  "40160": -2,
  "40161": -13,
  "40162": -2,
  "40165": -4,
  "40170": -13,
  "40171": -13,
  "40175": -2,
  "40176": -13,
  "40177": 1,
  "40178": -13,
  "40201": 4,
  "40202": 4,
  "40203": 4,
  "40204": 4,
  "40205": 4,
  "40206": 4,
  "40207": 6,
  "40208": 4,
  "40209": 4,
  "40210": 4,
  "40211": 4,
  "40212": -1,
  "40213": 4,
  "40214": 4,
  "40215": 4,
  "40216": 4,
  "40217": 4,
  "40218": 4,
  "40219": 4,
  "40220": 4,
  "40221": 4,
  "40222": 13,
  "40223": 4,
  "40224": 4,
  "40228": 4,
  "40229": -4,
  "40231": 4,
  "40232": 4,
  "40233": 13,
  "40241": 6,
  "40242": 13,
  "40243": 4,
  "40245": 6,
  "40250": 4,
  "40251": 4,
  "40252": 13,
  "40253": 4,
  "40255": 4,
  "40256": 4,
  "40257": 4,
  "40258": 4,
  "40259": 4,
  "40261": 4,
  "40268": 4,
  "40269": 4,
  "40270": 4,
  "40272": 4,
  "40285": 4,
  "40290": 4,
  "40291": 4,
  "40295": 4,
  "40298": 4,
  "40299": 4,
  "40310": -8,
  "40311": -4,
  "40312": -11,
  "40313": -8,
  "40316": -17,
  "40317": -9,
  "40319": -8,
  "40322": -17,
  "40324": 2,
  "40328": -9,
  "40330": -8,
  "40334": -7,
  "40336": -11,
  "40337": -7,
  "40339": -4,
  "40340": -4,
  "40342": -7,
  "40346": -17,
  "40347": -5,
  "40348": -4,
  "40350": -4,
  "40351": -9,
  "40353": -7,
  "40355": 19,
  "40356": -4,
  "40357": -3,
  "40358": -8,
  "40359": 19,
  "40360": -7,
  "40361": -3,
  "40362": -3,
  "40363": -10,
  "40366": -7,
  "40370": 2,
  "40371": -8,
  "40372": -8,
  "40374": -7,
  "40376": -17,
  "40379": 2,
  "40380": -11,
  "40383": -5,
  "40385": -11,
  "40387": -16,
  "40390": -4,
  "40391": -2,
  "40392": -2,
  "40402": -17,
  "40403": -1,
  "40405": -1,
  "40409": 1,
  "40410": -5,
  "40419": 1,
  "40422": -9,
  "40423": -9,
  "40434": -17,
  "40437": 1,
  "40440": -9,
  "40442": 0,
  "40444": -5,
  "40445": -17,
  "40447": -17,
  "40448": 1,
  "40452": -9,
  "40456": -17,
  "40460": -17,
  "40461": -5,
  "40464": -9,
  "40468": -9,
  "40472": -11,
  "40473": -17,
  "40475": -1,
  "40476": -1,
  "40481": -17,
  "40484": 1,
  "40486": -17,
  "40488": -17,
  "40489": 1,
  "40492": -17,
  "40495": -11,
  "40502": 11,
  "40503": 4,
  "40504": 3,
  "40505": 3,
  "40507": 11,
  "40508": 3,
  "40509": 11,
  "40510": 11,
  "40511": 3,
  "40512": 3,
  "40513": 11,
  "40514": 11,
  "40515": 11,
  "40516": 11,
  "40517": 3,
  "40522": 11,
  "40523": 3,
  "40524": 4,
  "40533": 3,
  "40544": 3,
  "40555": 11,
  "40574": 3,
  "40575": 3,
  "40576": 3,
  "40577": 3,
  "40578": 3,
  "40579": 3,
  "40580": 3,
  "40581": 3,
  "40582": 3,
  "40583": 3,
  "40588": 11,
  "40591": 11,
  "40601": -1,
  "40602": -1,
  "40603": -1,
  "40604": -1,
  "40701": -11,
  "40702": -11,
  "40724": 0,
  "40729": 0,
  "40730": -12,
  "40734": -9,
  "40737": -1,
  "40740": -1,
  "40741": 0,
  "40742": 0,
  "40743": 0,
  "40744": 0,
  "40745": 0,
  "40755": 0,
  "40759": -12,
  "40763": -12,
  "40769": -12,
  "40771": -11,
  "40801": -16,
  "40803": -16,
  "40806": -15,
  "40807": -15,
  "40808": -16,
  "40810": -16,
  "40813": -7,
  "40815": -16,
  "40816": -16,
  "40818": -15,
  "40819": -16,
  "40820": -16,
  "40823": -16,
  "40824": -16,
  "40826": -16,
  "40827": -16,
  "40828": -16,
  "40829": -15,
  "40830": -16,
  "40831": -15,
  "40840": -16,
  "40843": -16,
  "40844": -9,
  "40845": -7,
  "40847": -16,
  "40849": -16,
  "40854": -15,
  "40855": -16,
  "40856": -7,
  "40858": -16,
  "40862": -16,
  "40863": -7,
  "40865": -15,
  "40868": -9,
  "40870": -16,
  "40873": -15,
  "40874": -16,
  "40902": -8,
  "40903": -9,
  "40906": -9,
  "40913": -15,
  "40914": -8,
  "40915": -9,
  "40921": -7,
  "40923": -9,
  "40927": -15,
  "40930": -9,
  "40931": -8,
  "40932": -8,
  "40935": -9,
  "40939": -7,
  "40940": -8,
  "40941": -8,
  "40943": -9,
  "40944": -8,
  "40946": -9,
  "40949": -9,
  "40951": -8,
  "40953": -9,
  "40955": -9,
  "40958": -7,
  "40962": -8,
  "40964": -7,
  "40965": -7,
  "40972": -8,
  "40977": -7,
  "40979": -9,
  "40981": -9,
  "40982": -9,
  "40983": -8,
  "40988": -7,
  "40995": -9,
  "40997": -9,
  "41001": 10,
  "41002": -13,
  "41003": 15,
  "41004": -13,
  "41005": 5,
  "41006": -13,
  "41007": -3,
  "41008": 1,
  "41010": 19,
  "41011": 10,
  "41012": 10,
  "41014": 10,
  "41015": 10,
  "41016": 10,
  "41017": 10,
  "41018": 10,
  "41022": 4,
  "41030": 4,
  "41031": 15,
  "41033": 10,
  "41034": 4,
  "41035": 18,
  "41037": 5,
  "41039": 5,
  "41040": -13,
  "41041": 5,
  "41042": 4,
  "41043": -13,
  "41044": -13,
  "41045": 1,
  "41046": 18,
  "41048": 5,
  "41049": 5,
  "41051": 10,
  "41052": 18,
  "41053": 10,
  "41054": 18,
  "41055": 5,
  "41056": 4,
  "41059": 10,
  "41061": -13,
  "41062": 4,
  "41063": 10,
  "41064": -4,
  "41065": 3,
  "41071": 10,
  "41072": 10,
  "41073": 2,
  "41074": 2,
  "41075": 10,
  "41076": 10,
  "41080": 5,
  "41081": 3,
  "41083": 18,
  "41085": 10,
  "41086": 18,
  "41091": 13,
  "41092": 4,
  "41093": 3,
  "41094": 5,
  "41095": 4,
  "41096": 4,
  "41097": 18,
  "41098": -11,
  "41101": -3,
  "41102": -3,
  "41105": -3,
  "41121": -3,
  "41124": -8,
  "41128": -9,
  "41129": -3,
  "41132": -4,
  "41135": -9,
  "41139": -3,
  "41141": -4,
  "41142": -9,
  "41143": -9,
  "41144": -3,
  "41146": -9,
  "41149": -16,
  "41159": -16,
  "41160": -8,
  "41164": -9,
  "41166": -4,
  "41168": -4,
  "41169": -3,
  "41171": -16,
  "41173": -9,
  "41174": -4,
  "41175": -4,
  "41179": -4,
  "41180": -8,
  "41181": -9,
  "41183": -3,
  "41189": -4,
  "41201": -15,
  "41203": -15,
  "41204": -15,
  "41214": -15,
  "41216": -14,
  "41219": -15,
  "41222": -15,
  "41224": -14,
  "41226": -16,
  "41230": -7,
  "41231": -10,
  "41232": -15,
  "41234": -14,
  "41238": -15,
  "41240": -14,
  "41250": -14,
  "41254": -15,
  "41255": -15,
  "41256": -14,
  "41257": -14,
  "41260": -14,
  "41262": -15,
  "41263": -14,
  "41264": -15,
  "41265": -14,
  "41267": -15,
  "41268": -14,
  "41271": -15,
  "41274": -15,
  "41301": -17,
  "41307": -7,
  "41310": -9,
  "41311": -17,
  "41313": -17,
  "41314": -8,
  "41317": -8,
  "41332": -19,
  "41333": -17,
  "41338": -8,
  "41339": -7,
  "41347": -17,
  "41348": -8,
  "41351": -8,
  "41352": -19,
  "41360": -17,
  "41362": -17,
  "41364": -8,
  "41365": -16,
  "41366": -9,
  "41367": -9,
  "41368": -17,
  "41385": -7,
  "41386": -17,
  "41390": -7,
  "41397": -17,
  "41408": -19,
  "41413": -16,
  "41421": -16,
  "41425": -16,
  "41426": -15,
  "41451": -16,
  "41459": -15,
  "41464": -7,
  "41465": -15,
  "41472": -16,
  "41477": -16,
  "41501": -11,
  "41502": -11,
  "41503": -10,
  "41512": -3,
  "41513": -11,
  "41514": -2,
  "41517": -16,
  "41519": -10,
  "41520": -10,
  "41522": -11,
  "41524": -11,
  "41526": -11,
  "41527": -10,
  "41528": -9,
  "41531": -10,
  "41534": -3,
  "41535": -10,
  "41537": -16,
  "41538": -10,
  "41539": -11,
  "41540": -11,
  "41542": -3,
  "41543": -11,
  "41544": -10,
  "41547": -9,
  "41548": -11,
  "41549": -10,
  "41553": -11,
  "41554": -11,
  "41555": -11,
  "41557": -11,
  "41558": -10,
  "41559": -11,
  "41560": -10,
  "41561": -11,
  "41562": -11,
  "41563": -3,
  "41564": -12,
  "41566": -11,
  "41567": -11,
  "41568": -7,
  "41571": -12,
  "41572": -6,
  "41601": -7,
  "41602": -14,
  "41603": 2,
  "41604": -6,
  "41605": -6,
  "41606": -10,
  "41607": -5,
  "41612": -16,
  "41615": -6,
  "41616": -7,
  "41619": -6,
  "41621": -7,
  "41622": -6,
  "41630": -6,
  "41631": -6,
  "41632": -7,
  "41635": -7,
  "41636": -6,
  "41640": -6,
  "41642": -6,
  "41643": -6,
  "41645": -6,
  "41647": -6,
  "41649": -7,
  "41650": -10,
  "41651": -6,
  "41653": -6,
  "41655": -7,
  "41659": -6,
  "41660": -6,
  "41663": -6,
  "41666": -6,
  "41667": -16,
  "41669": -10,
  "41701": -8,
  "41702": -9,
  "41712": -10,
  "41713": -9,
  "41714": -9,
  "41719": -9,
  "41721": -7,
  "41722": -8,
  "41723": -9,
  "41725": -10,
  "41727": -8,
  "41729": -8,
  "41731": -9,
  "41735": -16,
  "41736": -8,
  "41739": -10,
  "41740": -10,
  "41743": -10,
  "41745": -8,
  "41746": -9,
  "41747": -10,
  "41749": -9,
  "41751": -8,
  "41754": -8,
  "41759": -10,
  "41760": -9,
  "41762": -9,
  "41763": -16,
  "41764": -9,
  "41766": -9,
  "41772": -10,
  "41773": -8,
  "41774": -8,
  "41775": -9,
  "41776": -9,
  "41777": -9,
  "41778": -9,
  "41804": -16,
  "41810": -16,
  "41812": -16,
  "41815": -16,
  "41817": -10,
  "41819": -16,
  "41821": -16,
  "41822": -10,
  "41824": -15,
  "41825": -16,
  "41826": -15,
  "41828": -10,
  "41831": -10,
  "41832": -16,
  "41833": -16,
  "41834": -10,
  "41835": -16,
  "41836": -10,
  "41837": -16,
  "41838": -16,
  "41839": -10,
  "41840": -16,
  "41843": -10,
  "41844": -10,
  "41845": -15,
  "41847": -10,
  "41848": -16,
  "41849": -16,
  "41855": -16,
  "41858": -16,
  "41859": -10,
  "41861": -10,
  "41862": -10,
  "42001": 8,
  "42002": 8,
  "42003": -1,
  "42020": -11,
  "42021": 0,
  "42022": 3,
  "42023": 0,
  "42024": 3,
  "42025": 8,
  "42027": 0,
  "42028": -11,
  "42029": 8,
  "42031": -19,
  "42032": 0,
  "42033": -16,
  "42035": 0,
  "42036": -12,
  "42037": 2,
  "42038": -10,
  "42039": 0,
  "42040": -12,
  "42041": -19,
  "42044": 16,
  "42045": -11,
  "42047": 1,
  "42048": 8,
  "42049": -12,
  "42050": -19,
  "42051": -12,
  "42053": 3,
  "42054": -3,
  "42055": -10,
  "42056": 3,
  "42058": -1,
  "42060": 3,
  "42061": 0,
  "42063": -12,
  "42064": -16,
  "42066": -12,
  "42069": 0,
  "42070": 0,
  "42071": -11,
  "42076": -12,
  "42078": -11,
  "42079": -12,
  "42081": 1,
  "42082": 8,
  "42083": 2,
  "42084": -16,
  "42085": -19,
  "42086": -1,
  "42087": 3,
  "42088": -11,
  "42101": -4,
  "42102": -2,
  "42103": -2,
  "42104": -2,
  "42120": -11,
  "42122": -2,
  "42123": -11,
  "42124": -3,
  "42127": -8,
  "42128": -2,
  "42129": -4,
  "42130": -3,
  "42131": -7,
  "42133": -11,
  "42134": 26,
  "42135": 26,
  "42140": -3,
  "42141": -7,
  "42142": -7,
  "42151": -16,
  "42152": -4,
  "42153": -11,
  "42154": -4,
  "42156": -11,
  "42157": -7,
  "42159": -2,
  "42160": -8,
  "42163": -8,
  "42164": -11,
  "42166": -3,
  "42167": -2,
  "42170": 26,
  "42171": -5,
  "42201": -13,
  "42202": -2,
  "42204": -4,
  "42206": -11,
  "42207": -7,
  "42210": -7,
  "42211": -17,
  "42214": -6,
  "42215": -18,
  "42216": -5,
  "42217": -7,
  "42219": -13,
  "42220": -5,
  "42221": -6,
  "42223": -2,
  "42232": 2,
  "42234": -4,
  "42236": -5,
  "42240": -6,
  "42241": -6,
  "42252": -7,
  "42254": -7,
  "42256": -12,
  "42259": -7,
  "42261": -13,
  "42262": -2,
  "42265": -4,
  "42266": -6,
  "42273": -13,
  "42274": -4,
  "42275": -7,
  "42276": -12,
  "42280": -5,
  "42283": -11,
  "42285": -8,
  "42286": -4,
  "42287": -13,
  "42288": -13,
  "42301": -8,
  "42302": -8,
  "42303": -8,
  "42304": -8,
  "42320": -10,
  "42321": 4,
  "42322": -13,
  "42323": 4,
  "42324": 4,
  "42325": 5,
  "42326": 4,
  "42327": -13,
  "42328": -10,
  "42330": 5,
  "42332": 4,
  "42333": -10,
  "42334": -8,
  "42337": 4,
  "42338": -10,
  "42339": 4,
  "42343": -14,
  "42344": 4,
  "42345": 4,
  "42347": -10,
  "42348": -6,
  "42349": -10,
  "42350": -14,
  "42351": -8,
  "42352": -13,
  "42354": -10,
  "42355": -8,
  "42356": -13,
  "42361": -10,
  "42364": -5,
  "42366": -6,
  "42367": 4,
  "42368": -5,
  "42369": -10,
  "42370": -5,
  "42371": -14,
  "42372": -13,
  "42374": 5,
  "42375": -8,
  "42376": -13,
  "42377": -8,
  "42378": -5,
  "42402": 0,
  "42403": -16,
  "42404": -2,
  "42406": 0,
  "42408": -6,
  "42409": -2,
  "42410": -6,
  "42411": -14,
  "42413": 3,
  "42419": 1,
  "42420": 1,
  "42431": -6,
  "42436": -2,
  "42437": -6,
  "42440": -6,
  "42441": -6,
  "42442": -6,
  "42444": -2,
  "42445": -14,
  "42450": -2,
  "42451": -1,
  "42452": 8,
  "42453": -6,
  "42455": -2,
  "42456": -2,
  "42457": 0,
  "42458": 0,
  "42459": -6,
  "42460": -16,
  "42461": 0,
  "42462": 0,
  "42463": -2,
  "42464": -6,
  "42501": -9,
  "42502": -9,
  "42503": -9,
  "42516": -9,
  "42518": -10,
  "42519": -11,
  "42528": -9,
  "42533": -9,
  "42539": -9,
  "42541": -9,
  "42544": -9,
  "42553": -9,
  "42558": -11,
  "42564": -9,
  "42565": -9,
  "42566": -9,
  "42567": -9,
  "42602": -15,
  "42603": -15,
  "42629": -4,
  "42631": -11,
  "42633": -16,
  "42634": -12,
  "42635": -11,
  "42638": -11,
  "42642": -3,
  "42647": -16,
  "42649": -11,
  "42653": -11,
  "42701": -2,
  "42702": -2,
  "42712": -10,
  "42713": -11,
  "42715": -11,
  "42716": -11,
  "42717": -8,
  "42718": -11,
  "42719": -11,
  "42720": -11,
  "42721": -10,
  "42722": -6,
  "42724": -2,
  "42726": -10,
  "42728": -11,
  "42729": -7,
  "42731": -8,
  "42732": -2,
  "42733": -9,
  "42740": -2,
  "42741": -11,
  "42742": -3,
  "42743": -6,
  "42746": -6,
  "42748": -11,
  "42749": -8,
  "42753": -11,
  "42754": -10,
  "42755": -10,
  "42757": -11,
  "42758": -11,
  "42759": -7,
  "42762": -10,
  "42764": -11,
  "42765": -7,
  "42776": -11,
  "42782": -6,
  "42784": -11,
  "42788": -2,
  "43001": 8,
  "43002": 7,
  "43003": 5,
  "43004": 7,
  "43005": 1,
  "43006": -4,
  "43007": 0,
  "43008": -1,
  "43009": -10,
  "43010": -10,
  "43011": 1,
  "43013": 0,
  "43014": 0,
  "43015": 6,
  "43016": 14,
  "43017": 16,
  "43018": -1,
  "43019": 1,
  "43021": 14,
  "43022": 1,
  "43023": 8,
  "43025": 0,
  "43026": 7,
  "43027": 1,
  "43028": 1,
  "43029": 9,
  "43030": 0,
  "43031": 2,
  "43032": 5,
  "43033": 0,
  "43035": 14,
  "43036": 1,
  "43037": 1,
  "43040": 2,
  "43044": -10,
  "43045": 0,
  "43046": 0,
  "43047": -10,
  "43048": 1,
  "43050": 1,
  "43054": 16,
  "43055": 0,
  "43056": 0,
  "43058": 0,
  "43060": 0,
  "43061": 2,
  "43062": 2,
  "43064": 2,
  "43065": 14,
  "43066": 6,
  "43067": 2,
  "43068": 7,
  "43070": -10,
  "43071": 0,
  "43072": -10,
  "43073": 7,
  "43074": 6,
  "43076": 0,
  "43077": 1,
  "43078": -10,
  "43080": 1,
  "43081": 7,
  "43082": 7,
  "43083": -10,
  "43084": 0,
  "43085": 7,
  "43086": 7,
  "43101": -9,
  "43102": 1,
  "43103": 3,
  "43105": 8,
  "43106": -2,
  "43107": 27,
  "43109": 7,
  "43110": -1,
  "43111": -10,
  "43112": 8,
  "43113": 1,
  "43115": 1,
  "43116": 0,
  "43117": 1,
  "43119": 7,
  "43123": 7,
  "43125": 7,
  "43126": -4,
  "43127": -10,
  "43128": -2,
  "43130": -1,
  "43135": -9,
  "43136": -1,
  "43137": 7,
  "43138": -9,
  "43140": -5,
  "43142": -2,
  "43143": -1,
  "43144": -9,
  "43145": -1,
  "43146": 1,
  "43147": -1,
  "43148": -1,
  "43149": -9,
  "43150": 27,
  "43151": -2,
  "43152": -6,
  "43153": -2,
  "43154": 9,
  "43155": -9,
  "43156": 1,
  "43157": -1,
  "43158": -9,
  "43160": -2,
  "43162": -4,
  "43163": 27,
  "43164": 0,
  "43194": 7,
  "43201": 7,
  "43202": 7,
  "43203": 7,
  "43204": 7,
  "43205": 7,
  "43206": 7,
  "43207": 7,
  "43209": 7,
  "43210": 7,
  "43211": 7,
  "43212": 7,
  "43213": 7,
  "43214": 7,
  "43215": 7,
  "43216": 7,
  "43217": 7,
  "43218": 7,
  "43219": 7,
  "43220": 7,
  "43221": 7,
  "43222": 7,
  "43223": 7,
  "43224": 7,
  "43226": 7,
  "43227": 7,
  "43228": 7,
  "43229": 7,
  "43230": 7,
  "43231": 7,
  "43232": 7,
  "43234": 7,
  "43235": 7,
  "43236": 7,
  "43240": 6,
  "43301": -3,
  "43302": -3,
  "43306": -3,
  "43310": -6,
  "43311": -6,
  "43314": -3,
  "43315": -9,
  "43316": 5,
  "43317": -9,
  "43318": -6,
  "43319": 0,
  "43320": -9,
  "43321": -9,
  "43322": -3,
  "43323": 3,
  "43324": -6,
  "43325": -10,
  "43326": -15,
  "43330": 2,
  "43331": -6,
  "43332": -4,
  "43333": -6,
  "43334": -9,
  "43335": -3,
  "43336": 0,
  "43337": -3,
  "43338": -9,
  "43340": -15,
  "43341": -3,
  "43342": -2,
  "43343": -6,
  "43344": -6,
  "43345": -15,
  "43346": -6,
  "43347": -6,
  "43348": -6,
  "43349": 6,
  "43350": -9,
  "43351": 4,
  "43356": -2,
  "43357": -10,
  "43358": -6,
  "43359": 2,
  "43360": -6,
  "43402": 17,
  "43406": 8,
  "43407": 0,
  "43408": -2,
  "43410": 0,
  "43412": -2,
  "43413": 8,
  "43414": 9,
  "43416": -2,
  "43420": 0,
  "43430": 6,
  "43431": 0,
  "43432": -2,
  "43433": -2,
  "43434": 2,
  "43435": 1,
  "43436": 7,
  "43437": 8,
  "43438": -5,
  "43439": -2,
  "43440": -5,
  "43441": 9,
  "43442": 1,
  "43443": 9,
  "43445": -2,
  "43446": 7,
  "43447": 2,
  "43449": -2,
  "43450": 9,
  "43451": 9,
  "43452": -2,
  "43456": 7,
  "43457": 8,
  "43458": -2,
  "43460": 2,
  "43462": 8,
  "43463": 9,
  "43464": 0,
  "43465": 2,
  "43466": 8,
  "43467": 8,
  "43468": 2,
  "43469": 9,
  "43501": -4,
  "43502": 14,
  "43504": 2,
  "43505": -3,
  "43506": -3,
  "43510": 6,
  "43511": 6,
  "43512": -10,
  "43515": 11,
  "43516": 6,
  "43517": -3,
  "43518": -3,
  "43519": -1,
  "43520": -12,
  "43521": 11,
  "43522": 9,
  "43523": 6,
  "43524": 6,
  "43525": 9,
  "43526": -12,
  "43527": 6,
  "43528": 2,
  "43529": 3,
  "43530": -10,
  "43531": -4,
  "43532": 6,
  "43533": 11,
  "43534": 6,
  "43535": 6,
  "43536": -12,
  "43537": 2,
  "43540": 11,
  "43541": 6,
  "43542": 3,
  "43543": -3,
  "43545": 6,
  "43547": 6,
  "43548": 6,
  "43549": -12,
  "43550": 6,
  "43551": 3,
  "43552": 3,
  "43553": 13,
  "43554": -3,
  "43555": 6,
  "43556": -12,
  "43557": -1,
  "43558": 11,
  "43560": 4,
  "43565": 8,
  "43566": 17,
  "43567": 14,
  "43569": 8,
  "43570": -1,
  "43571": 17,
  "43601": 2,
  "43603": 2,
  "43604": 2,
  "43605": 2,
  "43606": 2,
  "43607": 2,
  "43608": 2,
  "43609": 2,
  "43610": 2,
  "43611": 2,
  "43612": 2,
  "43613": 2,
  "43614": 2,
  "43615": 2,
  "43616": 2,
  "43617": 11,
  "43618": 2,
  "43619": 2,
  "43620": 2,
  "43623": 2,
  "43635": 2,
  "43697": 2,
  "43699": 2,
  "43701": -5,
  "43702": -5,
  "43711": -8,
  "43713": -3,
  "43716": -4,
  "43717": -8,
  "43718": -3,
  "43719": -3,
  "43720": -5,
  "43721": 0,
  "43722": -2,
  "43723": -2,
  "43724": -8,
  "43725": -2,
  "43727": -5,
  "43728": -5,
  "43730": 27,
  "43731": 27,
  "43732": -8,
  "43733": -2,
  "43734": -5,
  "43735": 26,
  "43736": -2,
  "43738": 26,
  "43739": 0,
  "43740": -5,
  "43746": -5,
  "43747": -4,
  "43748": 27,
  "43749": -2,
  "43750": -2,
  "43752": -4,
  "43754": -4,
  "43755": -2,
  "43756": -5,
  "43757": -4,
  "43758": -5,
  "43759": -3,
  "43760": 27,
  "43761": 27,
  "43762": -1,
  "43764": 27,
  "43766": 27,
  "43767": -5,
  "43768": -2,
  "43771": -5,
  "43772": -2,
  "43773": -2,
  "43777": 26,
  "43778": 6,
  "43779": -8,
  "43780": -2,
  "43782": 27,
  "43783": 27,
  "43786": -4,
  "43787": -5,
  "43788": -8,
  "43789": -4,
  "43791": 26,
  "43793": -4,
  "43802": -5,
  "43803": -6,
  "43804": -4,
  "43805": -8,
  "43811": -8,
  "43812": -8,
  "43821": -5,
  "43822": -5,
  "43824": -9,
  "43828": -8,
  "43830": -5,
  "43832": -6,
  "43836": -9,
  "43837": -6,
  "43840": -6,
  "43842": -9,
  "43843": 1,
  "43844": -8,
  "43845": -9,
  "43901": -3,
  "43902": -3,
  "43903": -6,
  "43905": -3,
  "43906": -3,
  "43907": 0,
  "43908": -6,
  "43909": -3,
  "43910": -2,
  "43912": -3,
  "43913": -3,
  "43914": -4,
  "43915": -4,
  "43916": -3,
  "43917": -3,
  "43920": -7,
  "43925": -2,
  "43926": -7,
  "43927": 6,
  "43928": -3,
  "43930": -6,
  "43931": -4,
  "43932": -7,
  "43933": -3,
  "43934": -3,
  "43935": -3,
  "43937": -3,
  "43938": -2,
  "43939": -3,
  "43940": -3,
  "43941": -3,
  "43942": 3,
  "43943": -3,
  "43944": -2,
  "43945": -6,
  "43946": -4,
  "43947": 3,
  "43948": -3,
  "43950": 6,
  "43951": -3,
  "43952": -2,
  "43953": -2,
  "43961": -7,
  "43962": -6,
  "43963": -3,
  "43964": -7,
  "43967": -3,
  "43968": -7,
  "43970": -2,
  "43971": -3,
  "43972": -3,
  "43973": 0,
  "43974": -3,
  "43976": -2,
  "43977": -1,
  "43981": -1,
  "43983": 0,
  "43984": 0,
  "43985": -1,
  "43986": 0,
  "43988": 0,
  "44001": -5,
  "44003": -6,
  "44004": -6,
  "44005": -6,
  "44010": -6,
  "44011": 4,
  "44012": -4,
  "44017": 4,
  "44021": 5,
  "44022": 5,
  "44023": 7,
  "44024": -4,
  "44026": -4,
  "44028": -4,
  "44030": -6,
  "44032": -6,
  "44033": 5,
  "44035": -5,
  "44036": -5,
  "44039": -4,
  "44040": 7,
  "44041": -6,
  "44044": -4,
  "44045": -3,
  "44046": 5,
  "44047": -6,
  "44048": -6,
  "44049": -5,
  "44050": -4,
  "44052": -5,
  "44053": -5,
  "44054": -5,
  "44055": -5,
  "44056": 6,
  "44057": -3,
  "44060": -3,
  "44061": -3,
  "44062": -4,
  "44064": -2,
  "44065": -4,
  "44067": 4,
  "44068": -6,
  "44070": -4,
  "44072": -4,
  "44074": -4,
  "44076": -6,
  "44077": -3,
  "44080": -4,
  "44081": -3,
  "44082": -6,
  "44084": -6,
  "44085": -6,
  "44086": -3,
  "44087": 1,
  "44088": -3,
  "44089": -5,
  "44090": -4,
  "44092": -3,
  "44093": -6,
  "44094": -3,
  "44095": -3,
  "44096": -3,
  "44097": -3,
  "44099": -4,
  "44101": 3,
  "44102": 3,
  "44103": 3,
  "44104": 3,
  "44105": 3,
  "44106": 3,
  "44107": 4,
  "44108": 3,
  "44109": 3,
  "44110": 3,
  "44111": 3,
  "44112": 3,
  "44113": 3,
  "44114": 3,
  "44115": 3,
  "44116": 4,
  "44117": 3,
  "44118": 4,
  "44119": 3,
  "44120": 3,
  "44121": 3,
  "44122": 4,
  "44123": 3,
  "44124": 3,
  "44125": 3,
  "44126": 4,
  "44127": 3,
  "44128": 3,
  "44129": 3,
  "44130": 4,
  "44131": 4,
  "44132": -3,
  "44133": 4,
  "44134": 4,
  "44135": 3,
  "44136": 4,
  "44137": 3,
  "44138": -4,
  "44139": 4,
  "44140": -4,
  "44141": 4,
  "44142": 4,
  "44143": 4,
  "44144": 3,
  "44145": 4,
  "44146": 3,
  "44147": 4,
  "44149": 4,
  "44181": 3,
  "44199": 3,
  "44201": 1,
  "44202": 1,
  "44203": 1,
  "44210": 10,
  "44211": 1,
  "44212": 4,
  "44214": -4,
  "44215": 3,
  "44216": 1,
  "44217": 3,
  "44221": 1,
  "44222": 1,
  "44223": 1,
  "44224": 3,
  "44230": 1,
  "44231": -2,
  "44232": -1,
  "44233": 12,
  "44234": -2,
  "44235": 4,
  "44236": 12,
  "44240": 1,
  "44241": 1,
  "44243": 1,
  "44250": 1,
  "44251": 4,
  "44253": 4,
  "44254": 4,
  "44255": 1,
  "44256": 4,
  "44258": 4,
  "44260": 3,
  "44262": 3,
  "44264": 1,
  "44265": 3,
  "44266": 0,
  "44270": 1,
  "44272": 1,
  "44273": 4,
  "44274": 3,
  "44275": 4,
  "44276": -4,
  "44278": 1,
  "44280": 4,
  "44281": 3,
  "44282": 3,
  "44285": -2,
  "44286": 10,
  "44287": -4,
  "44288": -2,
  "44301": 1,
  "44302": 1,
  "44303": 1,
  "44304": 1,
  "44305": 1,
  "44306": 1,
  "44307": 1,
  "44308": 1,
  "44309": 1,
  "44310": 1,
  "44311": 1,
  "44312": 1,
  "44313": 10,
  "44314": 1,
  "44319": 1,
  "44320": 1,
  "44321": 2,
  "44322": 1,
  "44333": 10,
  "44334": 1,
  "44372": 10,
  "44401": -2,
  "44402": -5,
  "44403": -6,
  "44404": -6,
  "44405": -3,
  "44406": 6,
  "44408": -7,
  "44410": -5,
  "44411": 0,
  "44412": -2,
  "44413": -7,
  "44415": -7,
  "44416": -2,
  "44417": -5,
  "44418": 3,
  "44420": -6,
  "44422": -7,
  "44423": -7,
  "44424": 3,
  "44425": -3,
  "44427": -6,
  "44428": -6,
  "44429": -2,
  "44430": -6,
  "44431": -7,
  "44432": -7,
  "44436": -3,
  "44437": -6,
  "44438": -6,
  "44439": -4,
  "44440": -6,
  "44441": -7,
  "44442": -3,
  "44443": -3,
  "44444": -6,
  "44445": -7,
  "44446": -6,
  "44449": -2,
  "44450": -6,
  "44451": -2,
  "44452": -3,
  "44453": -6,
  "44454": -3,
  "44455": -7,
  "44460": -7,
  "44470": -5,
  "44471": -3,
  "44473": -6,
  "44481": -6,
  "44482": -6,
  "44483": -6,
  "44484": -6,
  "44485": -6,
  "44490": -7,
  "44491": -5,
  "44492": -7,
  "44493": -7,
  "44501": -3,
  "44502": -3,
  "44503": -3,
  "44504": -3,
  "44505": -3,
  "44506": -3,
  "44507": -3,
  "44509": -3,
  "44510": -3,
  "44511": -3,
  "44512": -3,
  "44513": -3,
  "44514": -3,
  "44515": -3,
  "44601": -1,
  "44606": -3,
  "44607": -6,
  "44608": -6,
  "44609": -7,
  "44610": -3,
  "44611": -4,
  "44612": -5,
  "44613": 0,
  "44614": 0,
  "44615": -6,
  "44617": -3,
  "44618": -3,
  "44619": 2,
  "44620": -6,
  "44621": -7,
  "44622": -6,
  "44624": -6,
  "44625": -6,
  "44626": -1,
  "44627": -3,
  "44628": -4,
  "44629": -6,
  "44630": -1,
  "44631": -6,
  "44632": 0,
  "44633": -3,
  "44634": -6,
  "44636": -3,
  "44637": -4,
  "44638": -4,
  "44639": -1,
  "44640": 0,
  "44641": -1,
  "44643": -6,
  "44644": -6,
  "44645": -3,
  "44646": 0,
  "44647": 0,
  "44648": 0,
  "44650": -1,
  "44651": 3,
  "44652": -1,
  "44653": -7,
  "44654": -3,
  "44656": -1,
  "44657": -6,
  "44659": -3,
  "44660": -3,
  "44661": -4,
  "44662": 0,
  "44663": -6,
  "44665": -6,
  "44666": 0,
  "44667": -3,
  "44669": -1,
  "44670": -1,
  "44671": -1,
  "44672": -7,
  "44675": -6,
  "44676": -4,
  "44677": -3,
  "44678": -7,
  "44679": 0,
  "44680": -6,
  "44681": -5,
  "44682": -6,
  "44683": -7,
  "44685": -1,
  "44687": -3,
  "44688": -6,
  "44689": -6,
  "44690": 5,
  "44691": -3,
  "44693": 0,
  "44695": -1,
  "44697": 2,
  "44699": 0,
  "44701": -1,
  "44702": -1,
  "44703": -1,
  "44704": -1,
  "44705": -1,
  "44706": -1,
  "44707": -1,
  "44708": -1,
  "44709": -1,
  "44710": -1,
  "44711": -1,
  "44714": -1,
  "44718": 7,
  "44720": 7,
  "44721": -1,
  "44730": -1,
  "44735": 7,
  "44802": 4,
  "44804": 3,
  "44805": -1,
  "44807": 3,
  "44809": 2,
  "44811": 3,
  "44813": -2,
  "44814": -5,
  "44815": 2,
  "44816": -5,
  "44817": 3,
  "44818": 0,
  "44820": -10,
  "44822": 1,
  "44824": -5,
  "44825": -10,
  "44826": 3,
  "44827": -10,
  "44828": 3,
  "44830": 2,
  "44833": -10,
  "44836": 0,
  "44837": 3,
  "44838": -2,
  "44839": -5,
  "44840": 1,
  "44841": 2,
  "44842": -1,
  "44843": 6,
  "44844": 5,
  "44845": 3,
  "44846": -5,
  "44847": 3,
  "44848": -1,
  "44849": 3,
  "44850": 3,
  "44851": 3,
  "44853": 2,
  "44854": -10,
  "44855": 3,
  "44856": -10,
  "44857": 3,
  "44859": 7,
  "44860": 3,
  "44861": 2,
  "44862": -3,
  "44864": -1,
  "44865": 3,
  "44866": 1,
  "44867": 0,
  "44870": -5,
  "44871": -5,
  "44874": -2,
  "44875": -2,
  "44878": -2,
  "44880": -1,
  "44881": -10,
  "44882": 3,
  "44883": 2,
  "44887": -10,
  "44889": 4,
  "44890": 3,
  "44901": 6,
  "44902": -3,
  "44903": -2,
  "44904": 6,
  "44905": -3,
  "44906": -3,
  "44907": -2,
  "45001": 2,
  "45002": 3,
  "45003": -8,
  "45004": 2,
  "45005": 2,
  "45011": 2,
  "45012": 2,
  "45013": 2,
  "45014": 2,
  "45015": 2,
  "45018": 2,
  "45030": 2,
  "45032": -2,
  "45033": 2,
  "45034": 11,
  "45036": 2,
  "45039": 2,
  "45040": 4,
  "45041": 2,
  "45042": 2,
  "45044": 2,
  "45050": 2,
  "45051": 2,
  "45052": 3,
  "45053": 10,
  "45054": 2,
  "45055": 2,
  "45056": 2,
  "45061": 10,
  "45062": 2,
  "45063": 10,
  "45064": 2,
  "45065": 2,
  "45066": 11,
  "45067": 2,
  "45068": 2,
  "45069": 10,
  "45070": 2,
  "45071": 10,
  "45101": -2,
  "45102": -3,
  "45103": -3,
  "45105": 3,
  "45106": -3,
  "45107": -2,
  "45110": -4,
  "45111": 2,
  "45112": -5,
  "45113": -2,
  "45114": -2,
  "45115": -2,
  "45118": -3,
  "45119": -5,
  "45120": -5,
  "45121": -5,
  "45122": -3,
  "45123": -5,
  "45130": -5,
  "45131": -5,
  "45132": -4,
  "45133": -4,
  "45135": -4,
  "45138": -1,
  "45140": 3,
  "45142": -4,
  "45144": 3,
  "45145": -3,
  "45146": -2,
  "45147": 2,
  "45148": -2,
  "45150": -3,
  "45152": 2,
  "45153": -3,
  "45154": -5,
  "45155": -5,
  "45156": -3,
  "45157": -3,
  "45158": -3,
  "45159": -2,
  "45160": -3,
  "45162": 2,
  "45164": -2,
  "45166": -1,
  "45167": -5,
  "45168": -5,
  "45169": -1,
  "45171": -5,
  "45172": -5,
  "45174": 5,
  "45176": -3,
  "45177": -1,
  "45201": 11,
  "45202": 11,
  "45203": 3,
  "45204": 2,
  "45205": 2,
  "45206": 2,
  "45207": 2,
  "45208": 11,
  "45209": 3,
  "45211": 2,
  "45212": 2,
  "45213": 2,
  "45214": 2,
  "45215": 2,
  "45216": 2,
  "45217": 2,
  "45218": 2,
  "45219": 2,
  "45220": 4,
  "45222": 2,
  "45223": 2,
  "45224": 2,
  "45225": 2,
  "45226": 11,
  "45227": 2,
  "45228": 3,
  "45229": 2,
  "45230": 3,
  "45231": 2,
  "45232": 2,
  "45233": 4,
  "45234": 4,
  "45235": 4,
  "45236": 3,
  "45237": 2,
  "45238": 2,
  "45239": 2,
  "45240": 2,
  "45241": 4,
  "45242": 11,
  "45243": 11,
  "45244": -3,
  "45245": -3,
  "45246": 2,
  "45247": 3,
  "45248": 3,
  "45249": 11,
  "45250": 2,
  "45251": 2,
  "45252": 10,
  "45253": 2,
  "45254": 11,
  "45255": -3,
  "45258": 2,
  "45262": 2,
  "45275": 2,
  "45280": 2,
  "45301": -3,
  "45302": 2,
  "45303": -7,
  "45304": -7,
  "45305": -3,
  "45306": -3,
  "45307": -2,
  "45308": -7,
  "45309": 0,
  "45310": -7,
  "45311": -8,
  "45312": 3,
  "45314": 4,
  "45315": 0,
  "45316": -7,
  "45317": -10,
  "45318": -6,
  "45319": -5,
  "45320": -8,
  "45321": -9,
  "45322": 0,
  "45323": -5,
  "45324": -4,
  "45325": 1,
  "45326": -6,
  "45327": 1,
  "45328": -7,
  "45330": -8,
  "45331": -7,
  "45332": -7,
  "45333": 1,
  "45334": 1,
  "45335": -3,
  "45336": -3,
  "45337": -6,
  "45338": -8,
  "45339": -6,
  "45340": 2,
  "45341": -6,
  "45342": 0,
  "45343": 0,
  "45344": -6,
  "45345": -1,
  "45346": -7,
  "45347": -9,
  "45348": -7,
  "45349": -7,
  "45350": -7,
  "45351": -7,
  "45352": -7,
  "45353": 1,
  "45354": -6,
  "45356": -5,
  "45358": -7,
  "45359": -6,
  "45360": 1,
  "45361": -6,
  "45362": -7,
  "45363": 1,
  "45365": 1,
  "45368": -7,
  "45369": -7,
  "45370": 8,
  "45371": -4,
  "45372": -7,
  "45373": -4,
  "45377": 0,
  "45378": -9,
  "45380": -7,
  "45381": -8,
  "45382": -9,
  "45383": -6,
  "45384": 5,
  "45385": -4,
  "45387": 5,
  "45388": 9,
  "45389": -6,
  "45390": -7,
  "45400": -1,
  "45401": -1,
  "45402": 0,
  "45403": -1,
  "45404": -1,
  "45405": -1,
  "45406": -1,
  "45408": -1,
  "45409": 0,
  "45410": -1,
  "45413": -1,
  "45414": -1,
  "45415": 0,
  "45416": -1,
  "45417": -1,
  "45418": -1,
  "45419": 0,
  "45420": -1,
  "45422": 0,
  "45423": 0,
  "45424": 1,
  "45426": -1,
  "45427": -1,
  "45428": -1,
  "45429": 0,
  "45430": -5,
  "45431": -1,
  "45432": -1,
  "45433": -3,
  "45434": -2,
  "45435": -1,
  "45437": -1,
  "45439": -1,
  "45440": 0,
  "45441": 8,
  "45449": -1,
  "45458": 8,
  "45459": 8,
  "45469": 0,
  "45475": 8,
  "45479": 0,
  "45490": 0,
  "45501": -7,
  "45502": -7,
  "45503": -7,
  "45504": -7,
  "45505": -7,
  "45506": -7,
  "45601": -6,
  "45612": -6,
  "45613": 4,
  "45614": -11,
  "45616": -3,
  "45617": -6,
  "45618": -3,
  "45619": -6,
  "45620": -10,
  "45621": 9,
  "45622": -7,
  "45623": -11,
  "45624": -4,
  "45628": -6,
  "45629": -5,
  "45630": -5,
  "45631": -11,
  "45633": -9,
  "45634": -7,
  "45636": -5,
  "45638": -2,
  "45640": 10,
  "45642": 4,
  "45643": -11,
  "45644": -6,
  "45645": -2,
  "45646": 3,
  "45647": -6,
  "45648": -5,
  "45650": -3,
  "45651": -6,
  "45652": -5,
  "45653": -3,
  "45654": -7,
  "45656": 8,
  "45657": -3,
  "45658": -11,
  "45659": -3,
  "45660": -3,
  "45661": 4,
  "45662": -5,
  "45663": -5,
  "45669": 3,
  "45671": 4,
  "45672": -7,
  "45673": -6,
  "45674": -3,
  "45675": -2,
  "45677": -5,
  "45678": -2,
  "45679": -2,
  "45680": -3,
  "45681": -6,
  "45682": -5,
  "45683": 4,
  "45684": -3,
  "45685": -3,
  "45686": -12,
  "45687": -5,
  "45688": -3,
  "45690": 6,
  "45692": 9,
  "45693": -3,
  "45694": -3,
  "45695": -7,
  "45696": -2,
  "45697": -5,
  "45698": -7,
  "45701": -2,
  "45710": -2,
  "45711": -10,
  "45712": 5,
  "45713": -6,
  "45714": -3,
  "45715": -5,
  "45716": -9,
  "45717": -9,
  "45719": -11,
  "45720": -11,
  "45721": -5,
  "45723": -10,
  "45724": -6,
  "45727": -8,
  "45729": 5,
  "45732": -9,
  "45734": -4,
  "45735": -10,
  "45739": -10,
  "45740": -11,
  "45741": -11,
  "45742": -3,
  "45743": -11,
  "45744": -2,
  "45745": -6,
  "45746": -8,
  "45750": 0,
  "45760": -11,
  "45761": -11,
  "45764": -9,
  "45766": -9,
  "45767": -4,
  "45768": -2,
  "45769": -11,
  "45770": -1,
  "45771": -11,
  "45772": -11,
  "45773": 0,
  "45775": -11,
  "45776": -10,
  "45777": -10,
  "45778": -10,
  "45779": -11,
  "45780": -2,
  "45782": -11,
  "45783": -11,
  "45784": 5,
  "45786": -2,
  "45787": 7,
  "45788": -2,
  "45789": -3,
  "45801": -1,
  "45802": -1,
  "45804": -2,
  "45805": -1,
  "45806": -1,
  "45807": -1,
  "45808": -2,
  "45809": -1,
  "45810": -15,
  "45812": -15,
  "45813": -10,
  "45814": 1,
  "45815": -5,
  "45816": 1,
  "45817": -1,
  "45819": -3,
  "45820": -1,
  "45821": -10,
  "45822": -7,
  "45826": 1,
  "45827": -8,
  "45828": -7,
  "45830": -8,
  "45831": -8,
  "45832": -13,
  "45833": -13,
  "45835": -15,
  "45836": -15,
  "45837": -9,
  "45838": -13,
  "45839": 4,
  "45840": 4,
  "45841": 1,
  "45843": -15,
  "45844": -8,
  "45845": 9,
  "45846": 1,
  "45848": -8,
  "45849": -11,
  "45850": -1,
  "45851": -10,
  "45853": -8,
  "45854": -1,
  "45855": -11,
  "45856": -5,
  "45858": 3,
  "45859": -16,
  "45860": 1,
  "45861": -11,
  "45862": -7,
  "45863": -13,
  "45864": 6,
  "45865": 9,
  "45866": -7,
  "45867": 1,
  "45868": 1,
  "45869": -2,
  "45870": -6,
  "45871": -3,
  "45872": 3,
  "45873": -11,
  "45874": -13,
  "45875": -8,
  "45876": -8,
  "45877": -8,
  "45879": -10,
  "45880": -10,
  "45881": 1,
  "45882": -7,
  "45883": -6,
  "45884": -3,
  "45885": -3,
  "45886": -13,
  "45887": -3,
  "45888": -3,
  "45889": 12,
  "45890": 3,
  "45891": -13,
  "45893": -1,
  "45894": -13,
  "45895": -3,
  "45896": -1,
  "45897": -16,
  "45898": -8,
  "45899": -8,
  "46001": -3,
  "46011": -2,
  "46012": -3,
  "46013": -3,
  "46014": -3,
  "46015": -3,
  "46016": -3,
  "46017": -3,
  "46018": -3,
  "46030": -4,
  "46031": -4,
  "46032": 14,
  "46033": 14,
  "46034": 4,
  "46035": 3,
  "46036": -5,
  "46037": 6,
  "46038": 6,
  "46039": 3,
  "46040": -4,
  "46041": 3,
  "46044": -3,
  "46045": 5,
  "46047": -4,
  "46048": -4,
  "46049": -4,
  "46050": 3,
  "46051": -3,
  "46052": 1,
  "46055": -2,
  "46056": -8,
  "46057": 3,
  "46058": 3,
  "46060": 12,
  "46061": 12,
  "46062": 12,
  "46063": -3,
  "46064": 6,
  "46065": -5,
  "46067": -6,
  "46068": -4,
  "46069": 5,
  "46070": -8,
  "46071": 1,
  "46072": -4,
  "46074": 6,
  "46075": 2,
  "46076": -4,
  "46077": 10,
  "46082": 14,
  "46102": 1,
  "46103": 0,
  "46104": -1,
  "46105": -5,
  "46106": -1,
  "46107": 8,
  "46110": -1,
  "46111": 1,
  "46112": 1,
  "46113": 1,
  "46115": -2,
  "46117": -4,
  "46118": 0,
  "46120": -4,
  "46121": -4,
  "46122": 1,
  "46123": 1,
  "46124": -3,
  "46125": 2,
  "46126": -2,
  "46127": -2,
  "46128": -5,
  "46129": -2,
  "46130": -2,
  "46131": -1,
  "46133": -19,
  "46135": 2,
  "46140": -2,
  "46142": 0,
  "46143": 0,
  "46144": -1,
  "46146": -1,
  "46147": 1,
  "46148": -8,
  "46149": 0,
  "46150": -1,
  "46151": 3,
  "46154": -2,
  "46155": -3,
  "46156": -1,
  "46157": 1,
  "46158": 1,
  "46160": -10,
  "46161": -2,
  "46162": -1,
  "46163": -2,
  "46164": -10,
  "46165": 0,
  "46166": 2,
  "46167": 1,
  "46168": 1,
  "46170": 2,
  "46171": -6,
  "46172": -5,
  "46173": -3,
  "46175": -13,
  "46176": -2,
  "46180": -5,
  "46181": 9,
  "46182": -2,
  "46183": 1,
  "46184": -1,
  "46186": 4,
  "46201": 8,
  "46202": 8,
  "46203": 8,
  "46204": 8,
  "46205": 8,
  "46206": 8,
  "46207": 8,
  "46208": 8,
  "46214": 8,
  "46216": 8,
  "46217": 8,
  "46218": 8,
  "46219": 8,
  "46220": 8,
  "46221": 8,
  "46222": 8,
  "46224": 8,
  "46225": 8,
  "46226": 8,
  "46227": 8,
  "46228": 8,
  "46229": 8,
  "46230": 8,
  "46231": 0,
  "46234": 0,
  "46235": 8,
  "46236": -2,
  "46237": 8,
  "46239": 8,
  "46240": 8,
  "46241": 8,
  "46242": 8,
  "46244": 8,
  "46247": 8,
  "46250": 6,
  "46251": 8,
  "46253": 8,
  "46254": 8,
  "46256": 6,
  "46259": 0,
  "46260": 8,
  "46268": 8,
  "46278": 8,
  "46280": 6,
  "46282": 8,
  "46290": 16,
  "46301": 9,
  "46302": 6,
  "46303": 4,
  "46304": 6,
  "46307": 4,
  "46308": 4,
  "46310": -3,
  "46311": 5,
  "46312": 5,
  "46319": 4,
  "46320": 5,
  "46321": 5,
  "46322": 5,
  "46323": 5,
  "46324": 5,
  "46325": 5,
  "46327": 5,
  "46340": -10,
  "46341": 6,
  "46342": 4,
  "46345": 0,
  "46346": 0,
  "46347": 6,
  "46348": -10,
  "46349": -12,
  "46350": 1,
  "46352": 1,
  "46355": 6,
  "46356": 4,
  "46360": 0,
  "46361": 0,
  "46365": 1,
  "46366": -10,
  "46368": 6,
  "46371": 1,
  "46372": -2,
  "46373": 6,
  "46374": -10,
  "46375": 4,
  "46376": -13,
  "46377": -3,
  "46379": -12,
  "46380": -10,
  "46381": -2,
  "46382": 1,
  "46383": 6,
  "46384": 6,
  "46385": 6,
  "46390": 6,
  "46391": 0,
  "46392": -3,
  "46393": 6,
  "46394": 5,
  "46401": 4,
  "46402": 4,
  "46403": 4,
  "46404": 4,
  "46405": 4,
  "46406": 4,
  "46407": 4,
  "46408": 4,
  "46409": 4,
  "46410": 4,
  "46411": 4,
  "46501": -8,
  "46502": -7,
  "46504": -7,
  "46506": -8,
  "46507": 1,
  "46508": -6,
  "46510": -6,
  "46511": -8,
  "46513": -8,
  "46514": 0,
  "46515": 0,
  "46516": 0,
  "46517": 0,
  "46524": -7,
  "46526": 1,
  "46527": 1,
  "46528": 1,
  "46530": 7,
  "46531": -10,
  "46532": -10,
  "46534": -10,
  "46536": -1,
  "46537": -8,
  "46538": -6,
  "46539": -6,
  "46540": 10,
  "46542": -6,
  "46543": 3,
  "46544": -1,
  "46545": -1,
  "46546": -1,
  "46550": 1,
  "46552": -1,
  "46553": 1,
  "46554": -1,
  "46555": -6,
  "46556": -1,
  "46561": -1,
  "46562": -6,
  "46563": -8,
  "46565": 4,
  "46567": -6,
  "46570": -7,
  "46571": -3,
  "46572": -8,
  "46573": 1,
  "46574": -8,
  "46580": -6,
  "46581": -6,
  "46582": -6,
  "46590": -6,
  "46595": -1,
  "46601": -1,
  "46613": -1,
  "46614": -1,
  "46615": -1,
  "46616": -1,
  "46617": -1,
  "46619": -1,
  "46624": -1,
  "46628": -1,
  "46634": -1,
  "46635": -1,
  "46637": -1,
  "46660": -1,
  "46680": -1,
  "46701": -7,
  "46702": 1,
  "46703": -7,
  "46704": 8,
  "46705": -7,
  "46706": -7,
  "46710": -7,
  "46711": -8,
  "46713": 1,
  "46714": -7,
  "46721": -7,
  "46723": -3,
  "46725": -3,
  "46730": -7,
  "46731": -6,
  "46732": -6,
  "46733": -8,
  "46737": -7,
  "46738": -7,
  "46740": -8,
  "46741": -1,
  "46742": -7,
  "46743": -7,
  "46745": -1,
  "46746": -4,
  "46747": -7,
  "46748": -1,
  "46750": 1,
  "46755": -7,
  "46759": -8,
  "46760": -6,
  "46761": -4,
  "46763": -7,
  "46764": -3,
  "46765": 8,
  "46766": -7,
  "46767": -6,
  "46769": -8,
  "46770": 1,
  "46771": -4,
  "46772": -8,
  "46773": -1,
  "46774": -1,
  "46776": -6,
  "46777": -7,
  "46778": -8,
  "46779": -7,
  "46780": -8,
  "46781": -7,
  "46782": -8,
  "46783": 1,
  "46784": -6,
  "46785": -7,
  "46786": -4,
  "46787": -3,
  "46788": 2,
  "46789": -7,
  "46791": -7,
  "46792": 1,
  "46793": -7,
  "46794": -6,
  "46795": -4,
  "46796": -7,
  "46797": -1,
  "46798": -1,
  "46799": 1,
  "46801": -1,
  "46802": -1,
  "46803": -1,
  "46804": 0,
  "46805": -1,
  "46806": -1,
  "46807": -1,
  "46808": -1,
  "46809": -1,
  "46814": -1,
  "46815": -1,
  "46816": -1,
  "46818": -1,
  "46819": -1,
  "46825": -1,
  "46835": -1,
  "46845": 8,
  "46850": -1,
  "46851": -1,
  "46852": -1,
  "46853": -1,
  "46854": -1,
  "46855": -1,
  "46856": -1,
  "46857": -1,
  "46858": -1,
  "46859": -1,
  "46860": -1,
  "46861": -1,
  "46862": -1,
  "46863": -1,
  "46864": -1,
  "46865": -1,
  "46866": -1,
  "46867": -1,
  "46868": -1,
  "46869": -1,
  "46885": -1,
  "46895": -1,
  "46896": -1,
  "46898": -3,
  "46899": -1,
  "46901": -4,
  "46902": -4,
  "46903": -4,
  "46904": 0,
  "46910": -1,
  "46911": -6,
  "46912": -1,
  "46913": -4,
  "46914": -5,
  "46915": -6,
  "46916": -6,
  "46917": -6,
  "46919": -8,
  "46920": -6,
  "46921": -5,
  "46922": -10,
  "46923": -5,
  "46926": -5,
  "46928": -8,
  "46929": -6,
  "46930": -9,
  "46931": -2,
  "46932": -4,
  "46933": -8,
  "46935": -1,
  "46936": 4,
  "46937": -4,
  "46938": -8,
  "46939": -1,
  "46940": -7,
  "46941": -6,
  "46942": 7,
  "46943": -6,
  "46945": -10,
  "46946": -6,
  "46947": 0,
  "46950": 0,
  "46951": -1,
  "46952": -7,
  "46953": -8,
  "46957": 10,
  "46958": -5,
  "46959": -5,
  "46960": -10,
  "46961": -6,
  "46962": -6,
  "46965": -4,
  "46967": 0,
  "46968": -10,
  "46970": -6,
  "46971": -5,
  "46974": -5,
  "46975": -1,
  "46977": -5,
  "46978": 0,
  "46979": -3,
  "46980": -6,
  "46982": -5,
  "46984": -7,
  "46985": -13,
  "46986": -7,
  "46987": -8,
  "46988": 0,
  "46989": 11,
  "46990": -6,
  "46991": -8,
  "46992": -5,
  "46994": 0,
  "46995": -3,
  "46996": -12,
  "46998": 0,
  "47001": -3,
  "47003": -13,
  "47006": -7,
  "47010": -13,
  "47011": -9,
  "47012": -7,
  "47016": -7,
  "47017": -7,
  "47018": -3,
  "47019": 6,
  "47020": -3,
  "47021": -7,
  "47022": -2,
  "47023": -7,
  "47024": -7,
  "47025": -2,
  "47030": -7,
  "47031": -7,
  "47032": -3,
  "47033": -7,
  "47034": -8,
  "47035": -7,
  "47036": -6,
  "47037": -8,
  "47038": -3,
  "47039": -7,
  "47040": -3,
  "47041": -7,
  "47042": -7,
  "47043": -9,
  "47060": -3,
  "47102": -12,
  "47104": -9,
  "47106": -1,
  "47107": -7,
  "47108": -7,
  "47110": -12,
  "47111": -4,
  "47112": -11,
  "47114": -12,
  "47115": -15,
  "47116": -15,
  "47117": -12,
  "47118": -15,
  "47119": 7,
  "47120": -7,
  "47122": 7,
  "47123": -15,
  "47124": 7,
  "47125": -15,
  "47126": -12,
  "47129": -1,
  "47130": -4,
  "47131": -4,
  "47135": 2,
  "47136": -10,
  "47137": -15,
  "47138": -12,
  "47139": -12,
  "47140": -15,
  "47141": -3,
  "47142": -12,
  "47143": -3,
  "47145": -15,
  "47146": 7,
  "47147": -9,
  "47150": -1,
  "47151": -1,
  "47160": -12,
  "47161": -12,
  "47162": -9,
  "47163": -3,
  "47164": -7,
  "47165": 7,
  "47166": -12,
  "47167": -7,
  "47170": -12,
  "47172": -3,
  "47174": -16,
  "47175": -15,
  "47177": -12,
  "47201": -2,
  "47202": -2,
  "47203": -1,
  "47220": -2,
  "47223": -2,
  "47224": -9,
  "47225": -6,
  "47226": -3,
  "47227": -2,
  "47228": -2,
  "47229": -12,
  "47230": -12,
  "47231": -9,
  "47232": -2,
  "47234": -10,
  "47235": -2,
  "47236": -2,
  "47240": -10,
  "47243": -9,
  "47244": -3,
  "47245": -1,
  "47246": -3,
  "47247": -3,
  "47249": -5,
  "47250": -9,
  "47260": -2,
  "47261": -10,
  "47263": -10,
  "47264": -5,
  "47265": -1,
  "47270": -12,
  "47272": -10,
  "47273": -1,
  "47274": -2,
  "47280": -2,
  "47281": -2,
  "47282": -2,
  "47283": -9,
  "47302": -6,
  "47303": -5,
  "47304": -5,
  "47305": -6,
  "47307": -6,
  "47308": -6,
  "47320": -5,
  "47322": -2,
  "47324": -10,
  "47325": -18,
  "47326": -10,
  "47327": -11,
  "47330": -11,
  "47331": -18,
  "47334": -3,
  "47335": -11,
  "47336": 11,
  "47337": -8,
  "47338": 11,
  "47339": -11,
  "47340": 2,
  "47341": -11,
  "47342": -5,
  "47344": -8,
  "47345": -11,
  "47346": -11,
  "47348": 11,
  "47351": -8,
  "47352": -8,
  "47353": -13,
  "47354": -8,
  "47355": 2,
  "47356": -7,
  "47357": -19,
  "47358": -11,
  "47359": 11,
  "47360": -8,
  "47361": -8,
  "47362": -8,
  "47366": -8,
  "47367": 1,
  "47368": -5,
  "47369": -10,
  "47370": -11,
  "47371": -10,
  "47373": -10,
  "47374": -10,
  "47375": -10,
  "47380": 1,
  "47381": -10,
  "47382": 1,
  "47383": -5,
  "47384": -7,
  "47385": -8,
  "47386": 1,
  "47387": -8,
  "47388": -8,
  "47390": 2,
  "47392": -12,
  "47393": -11,
  "47394": 2,
  "47396": 3,
  "47401": 9,
  "47402": 9,
  "47403": 0,
  "47404": 0,
  "47405": 9,
  "47406": 9,
  "47407": 9,
  "47408": 9,
  "47420": -5,
  "47421": -5,
  "47424": -10,
  "47426": 9,
  "47427": -12,
  "47429": 0,
  "47430": -5,
  "47431": -10,
  "47432": -6,
  "47433": -11,
  "47434": -5,
  "47435": -10,
  "47436": -5,
  "47437": -5,
  "47438": -10,
  "47439": -10,
  "47441": -12,
  "47443": -10,
  "47445": -12,
  "47446": -5,
  "47448": -3,
  "47449": -10,
  "47451": -5,
  "47452": -6,
  "47453": -12,
  "47454": -7,
  "47455": -12,
  "47456": -10,
  "47457": -10,
  "47458": 9,
  "47459": 0,
  "47460": -10,
  "47462": -5,
  "47463": 0,
  "47464": -11,
  "47465": -10,
  "47467": -5,
  "47468": -10,
  "47469": -6,
  "47470": -5,
  "47471": -10,
  "47501": -5,
  "47512": -1,
  "47513": -7,
  "47514": -3,
  "47515": -3,
  "47516": -1,
  "47519": -12,
  "47520": -3,
  "47521": 2,
  "47522": -12,
  "47523": -9,
  "47524": -7,
  "47525": -3,
  "47527": -5,
  "47528": -7,
  "47529": -5,
  "47531": -3,
  "47532": -5,
  "47535": -1,
  "47536": -4,
  "47537": -5,
  "47541": -7,
  "47542": -7,
  "47545": -7,
  "47546": 1,
  "47547": 1,
  "47550": -1,
  "47551": -3,
  "47552": -9,
  "47553": -12,
  "47556": -4,
  "47557": 0,
  "47558": -5,
  "47561": -1,
  "47562": -12,
  "47564": -11,
  "47567": -11,
  "47568": -5,
  "47573": -1,
  "47574": -4,
  "47575": 2,
  "47576": -16,
  "47577": -5,
  "47578": -10,
  "47579": -1,
  "47580": -7,
  "47581": -12,
  "47584": -11,
  "47585": -11,
  "47586": -3,
  "47588": -3,
  "47590": -11,
  "47591": 0,
  "47596": -5,
  "47597": 0,
  "47598": -11,
  "47601": -2,
  "47610": -2,
  "47611": -9,
  "47612": -6,
  "47613": -2,
  "47614": -10,
  "47615": -9,
  "47616": 2,
  "47617": -2,
  "47618": 7,
  "47619": -2,
  "47620": 11,
  "47629": 6,
  "47630": 6,
  "47631": 2,
  "47633": 2,
  "47634": -2,
  "47635": -8,
  "47637": -10,
  "47638": 11,
  "47639": 2,
  "47640": -7,
  "47647": -6,
  "47648": -6,
  "47649": -6,
  "47654": -7,
  "47660": -11,
  "47665": -6,
  "47666": -7,
  "47670": -6,
  "47683": -7,
  "47701": 7,
  "47702": -2,
  "47703": -2,
  "47704": -2,
  "47705": -2,
  "47706": -2,
  "47708": 7,
  "47710": -1,
  "47711": -1,
  "47712": -1,
  "47713": -2,
  "47714": -1,
  "47715": 7,
  "47716": 7,
  "47719": -1,
  "47720": 0,
  "47724": -1,
  "47725": -2,
  "47728": -1,
  "47730": 7,
  "47731": 7,
  "47732": 7,
  "47733": 7,
  "47734": 7,
  "47735": 7,
  "47736": -2,
  "47737": 7,
  "47801": -4,
  "47802": -3,
  "47803": -3,
  "47804": -3,
  "47805": -3,
  "47807": -4,
  "47808": -3,
  "47830": 12,
  "47831": 11,
  "47832": -13,
  "47833": -14,
  "47834": -14,
  "47836": -13,
  "47837": -14,
  "47838": -10,
  "47840": -12,
  "47841": -14,
  "47842": 11,
  "47845": -10,
  "47846": -12,
  "47847": 11,
  "47848": -10,
  "47849": -9,
  "47850": -10,
  "47851": -3,
  "47852": -10,
  "47853": -14,
  "47854": 11,
  "47855": -11,
  "47857": -14,
  "47858": -2,
  "47859": -13,
  "47860": 12,
  "47861": -10,
  "47862": 11,
  "47863": -3,
  "47865": -10,
  "47866": -10,
  "47868": -12,
  "47869": -3,
  "47870": -3,
  "47871": -3,
  "47872": 11,
  "47874": -13,
  "47875": 11,
  "47876": -3,
  "47878": -14,
  "47879": -10,
  "47880": -3,
  "47881": -14,
  "47882": -10,
  "47884": 11,
  "47885": -4,
  "47901": 0,
  "47902": 0,
  "47903": 0,
  "47904": 0,
  "47905": 0,
  "47906": 9,
  "47907": 0,
  "47909": 0,
  "47916": -3,
  "47917": -6,
  "47918": -7,
  "47920": 9,
  "47921": -6,
  "47922": -13,
  "47923": 8,
  "47924": 0,
  "47925": 7,
  "47926": 7,
  "47928": 11,
  "47929": 8,
  "47930": 3,
  "47932": -11,
  "47933": -2,
  "47940": -2,
  "47941": 0,
  "47942": -6,
  "47943": 6,
  "47944": -6,
  "47946": -12,
  "47948": -6,
  "47949": -11,
  "47950": 7,
  "47951": -13,
  "47952": -12,
  "47954": -2,
  "47955": -2,
  "47957": -13,
  "47958": -11,
  "47959": 7,
  "47960": 8,
  "47962": -5,
  "47963": -13,
  "47964": -13,
  "47965": -3,
  "47966": 11,
  "47967": -2,
  "47968": -2,
  "47969": -11,
  "47970": -5,
  "47971": -6,
  "47974": -10,
  "47975": -5,
  "47977": -5,
  "47978": -2,
  "47980": 7,
  "47981": 9,
  "47982": -4,
  "47983": 0,
  "47984": -6,
  "47986": -6,
  "47987": -11,
  "47988": -3,
  "47989": -13,
  "47990": -3,
  "47991": -7,
  "47992": 0,
  "47993": -7,
  "47994": -11,
  "47995": 8,
  "47996": 9,
  "47997": 8,
  "48001": -1,
  "48002": 8,
  "48003": -5,
  "48004": -1,
  "48005": -2,
  "48006": -1,
  "48007": 9,
  "48009": 13,
  "48012": 13,
  "48014": -4,
  "48015": 2,
  "48017": 9,
  "48021": 2,
  "48022": -1,
  "48023": -1,
  "48025": 11,
  "48026": 2,
  "48027": -1,
  "48028": 3,
  "48030": 6,
  "48032": -1,
  "48033": 9,
  "48034": 9,
  "48035": 2,
  "48036": 2,
  "48037": 9,
  "48038": 3,
  "48039": -1,
  "48040": -1,
  "48041": -1,
  "48042": 3,
  "48043": 2,
  "48044": 3,
  "48045": 3,
  "48046": 2,
  "48047": 3,
  "48048": 4,
  "48049": -1,
  "48050": 3,
  "48051": 3,
  "48054": 8,
  "48059": -1,
  "48060": -1,
  "48061": -1,
  "48062": -1,
  "48063": -1,
  "48064": -1,
  "48065": 3,
  "48066": 2,
  "48067": 6,
  "48068": 6,
  "48069": 15,
  "48070": 17,
  "48071": 2,
  "48072": 9,
  "48073": 9,
  "48074": -1,
  "48075": 7,
  "48076": 9,
  "48079": -1,
  "48080": 2,
  "48081": 2,
  "48082": 2,
  "48083": 3,
  "48084": 9,
  "48085": 9,
  "48086": 9,
  "48088": 2,
  "48089": 2,
  "48090": 2,
  "48091": 2,
  "48092": 2,
  "48093": 2,
  "48094": 3,
  "48095": 3,
  "48096": 3,
  "48097": -10,
  "48098": 9,
  "48099": 3,
  "48101": 9,
  "48103": 5,
  "48104": 5,
  "48105": 13,
  "48106": 5,
  "48107": 5,
  "48108": 5,
  "48109": 13,
  "48110": 0,
  "48111": 5,
  "48112": 5,
  "48113": 5,
  "48114": 4,
  "48115": 5,
  "48116": 4,
  "48117": 2,
  "48118": 5,
  "48120": 9,
  "48121": 9,
  "48122": 9,
  "48123": 9,
  "48124": 9,
  "48125": 9,
  "48126": 9,
  "48127": 9,
  "48128": 9,
  "48130": 6,
  "48131": 0,
  "48133": 0,
  "48134": 2,
  "48135": 9,
  "48136": 9,
  "48137": 3,
  "48138": 17,
  "48139": 3,
  "48140": 2,
  "48141": 9,
  "48143": 4,
  "48144": 3,
  "48145": 1,
  "48146": 9,
  "48150": 9,
  "48151": 9,
  "48152": 9,
  "48153": 9,
  "48154": 9,
  "48157": 0,
  "48158": 5,
  "48159": 3,
  "48160": 5,
  "48161": 0,
  "48162": 2,
  "48164": 3,
  "48165": 3,
  "48166": 2,
  "48167": 20,
  "48168": 20,
  "48169": 4,
  "48170": 10,
  "48173": 2,
  "48174": 9,
  "48175": 20,
  "48176": 5,
  "48177": 3,
  "48178": 4,
  "48179": 2,
  "48180": 9,
  "48182": 3,
  "48183": 9,
  "48184": 9,
  "48185": 9,
  "48186": 9,
  "48187": 9,
  "48188": 9,
  "48189": 3,
  "48190": 5,
  "48191": 5,
  "48192": 9,
  "48193": 9,
  "48195": 9,
  "48197": 5,
  "48198": 5,
  "48201": 6,
  "48202": 6,
  "48203": 6,
  "48204": 6,
  "48205": 2,
  "48206": 6,
  "48207": 6,
  "48208": 6,
  "48209": 9,
  "48210": 6,
  "48211": 6,
  "48212": 6,
  "48213": 6,
  "48214": 6,
  "48215": 6,
  "48216": 6,
  "48217": 9,
  "48218": 6,
  "48219": 9,
  "48220": 6,
  "48221": 6,
  "48223": 9,
  "48224": 2,
  "48225": 2,
  "48226": 6,
  "48227": 6,
  "48228": 9,
  "48229": 9,
  "48230": 11,
  "48231": 6,
  "48232": 6,
  "48233": 6,
  "48234": 6,
  "48235": 6,
  "48236": 11,
  "48237": 6,
  "48238": 6,
  "48239": 9,
  "48240": 9,
  "48242": 9,
  "48243": 6,
  "48244": 6,
  "48301": 20,
  "48302": 20,
  "48303": 20,
  "48304": 20,
  "48306": 20,
  "48307": 3,
  "48308": 3,
  "48309": 9,
  "48310": 3,
  "48311": 3,
  "48312": 3,
  "48313": 3,
  "48314": 3,
  "48315": 3,
  "48316": 3,
  "48317": 3,
  "48318": 3,
  "48320": 9,
  "48321": 9,
  "48322": 9,
  "48323": 11,
  "48324": 9,
  "48325": 9,
  "48326": 9,
  "48327": 9,
  "48328": 9,
  "48329": 9,
  "48330": 9,
  "48331": 9,
  "48332": 9,
  "48333": 9,
  "48334": 9,
  "48335": 9,
  "48336": 12,
  "48340": 9,
  "48341": 9,
  "48342": 9,
  "48343": 9,
  "48346": 9,
  "48347": 9,
  "48348": 9,
  "48350": 9,
  "48353": 1,
  "48356": 9,
  "48357": 0,
  "48359": 9,
  "48360": 9,
  "48361": 9,
  "48362": 9,
  "48363": 9,
  "48366": -5,
  "48367": -5,
  "48370": 9,
  "48371": 9,
  "48374": 20,
  "48375": 9,
  "48376": 9,
  "48377": 9,
  "48380": 1,
  "48381": 1,
  "48382": 9,
  "48383": 9,
  "48386": 9,
  "48387": 9,
  "48390": 9,
  "48391": 9,
  "48393": 9,
  "48401": -10,
  "48410": -11,
  "48411": 10,
  "48412": -5,
  "48413": -14,
  "48414": -9,
  "48415": -2,
  "48416": -10,
  "48417": -2,
  "48418": -9,
  "48419": -10,
  "48420": 2,
  "48421": -5,
  "48422": -10,
  "48423": 2,
  "48426": -11,
  "48427": -11,
  "48428": -5,
  "48429": -9,
  "48430": 10,
  "48432": -14,
  "48433": 2,
  "48434": -11,
  "48435": -5,
  "48436": -9,
  "48437": 2,
  "48438": 10,
  "48439": 2,
  "48440": -6,
  "48441": -13,
  "48442": 2,
  "48444": -5,
  "48445": -14,
  "48446": -5,
  "48449": -9,
  "48450": -10,
  "48451": 3,
  "48453": -10,
  "48454": -10,
  "48455": -5,
  "48456": -11,
  "48457": -3,
  "48458": 1,
  "48460": -9,
  "48461": -5,
  "48462": 2,
  "48463": 2,
  "48464": -5,
  "48465": -11,
  "48466": -10,
  "48467": -14,
  "48468": -14,
  "48469": -10,
  "48470": -13,
  "48471": -11,
  "48472": -11,
  "48473": 2,
  "48475": -14,
  "48476": -9,
  "48480": 2,
  "48501": 2,
  "48502": 1,
  "48503": 1,
  "48504": 1,
  "48505": 1,
  "48506": 1,
  "48507": 1,
  "48509": 2,
  "48519": 1,
  "48529": 1,
  "48531": 1,
  "48532": 2,
  "48601": -3,
  "48602": -3,
  "48603": -2,
  "48604": -3,
  "48605": -2,
  "48606": -3,
  "48607": -3,
  "48608": -2,
  "48609": -2,
  "48610": -11,
  "48611": -3,
  "48612": -6,
  "48613": -6,
  "48614": -15,
  "48615": -13,
  "48616": -2,
  "48617": -1,
  "48618": -2,
  "48619": -1,
  "48620": -1,
  "48621": -1,
  "48622": -1,
  "48623": 1,
  "48624": -6,
  "48625": -1,
  "48626": -2,
  "48627": -7,
  "48628": -1,
  "48629": -7,
  "48630": -7,
  "48631": -5,
  "48632": -1,
  "48633": -1,
  "48634": -5,
  "48635": -11,
  "48636": -1,
  "48637": -13,
  "48638": -2,
  "48640": -1,
  "48641": -1,
  "48642": -1,
  "48647": -1,
  "48649": -9,
  "48650": -5,
  "48651": -7,
  "48652": -6,
  "48653": -7,
  "48654": -11,
  "48655": -2,
  "48656": -7,
  "48657": -1,
  "48658": -15,
  "48659": -13,
  "48661": -11,
  "48662": -13,
  "48701": -14,
  "48703": -15,
  "48705": -16,
  "48706": -5,
  "48707": -5,
  "48708": -5,
  "48720": -14,
  "48721": -8,
  "48722": -2,
  "48723": -13,
  "48724": -3,
  "48725": -14,
  "48726": -13,
  "48727": -14,
  "48728": -16,
  "48729": -13,
  "48730": -10,
  "48731": -14,
  "48732": -5,
  "48733": -14,
  "48734": 6,
  "48735": -14,
  "48736": -14,
  "48737": -17,
  "48738": -8,
  "48739": -10,
  "48740": -16,
  "48741": -14,
  "48742": -16,
  "48743": -13,
  "48744": -14,
  "48745": -16,
  "48746": -14,
  "48747": -5,
  "48748": -10,
  "48749": -15,
  "48750": -10,
  "48754": -14,
  "48755": -14,
  "48756": -11,
  "48757": -13,
  "48758": -13,
  "48759": -14,
  "48760": -14,
  "48761": -13,
  "48762": -16,
  "48763": -10,
  "48764": -10,
  "48765": -15,
  "48766": -15,
  "48767": -13,
  "48768": -14,
  "48769": -14,
  "48770": -15,
  "48801": -13,
  "48804": -2,
  "48805": 19,
  "48806": -12,
  "48807": -13,
  "48808": -2,
  "48809": -5,
  "48811": -15,
  "48812": -6,
  "48813": 0,
  "48815": -5,
  "48816": -9,
  "48817": -9,
  "48818": -6,
  "48819": 10,
  "48820": 4,
  "48821": 0,
  "48822": -2,
  "48823": 10,
  "48824": 8,
  "48825": 10,
  "48826": 10,
  "48827": 0,
  "48829": -6,
  "48830": -13,
  "48831": -2,
  "48832": -13,
  "48833": -12,
  "48834": -5,
  "48835": -5,
  "48836": 3,
  "48837": 0,
  "48838": -8,
  "48840": 10,
  "48841": -9,
  "48842": 8,
  "48843": 3,
  "48844": 3,
  "48845": -6,
  "48846": -5,
  "48847": -13,
  "48848": -2,
  "48849": -5,
  "48850": -8,
  "48851": -6,
  "48852": -8,
  "48853": -3,
  "48854": 8,
  "48855": 3,
  "48856": -13,
  "48857": -5,
  "48858": -2,
  "48860": -6,
  "48861": 0,
  "48862": -13,
  "48863": 3,
  "48864": 19,
  "48865": -5,
  "48866": -2,
  "48867": -5,
  "48870": -5,
  "48871": -12,
  "48872": -5,
  "48873": -6,
  "48874": -13,
  "48875": -6,
  "48876": 0,
  "48877": -13,
  "48878": -2,
  "48879": -2,
  "48880": -13,
  "48881": -5,
  "48882": -5,
  "48883": -2,
  "48884": -8,
  "48885": -8,
  "48886": -8,
  "48887": -5,
  "48888": -8,
  "48889": -13,
  "48890": 0,
  "48891": -6,
  "48892": 10,
  "48893": -2,
  "48894": -5,
  "48895": 10,
  "48896": -2,
  "48897": -8,
  "48901": 8,
  "48906": 7,
  "48908": 8,
  "48909": 8,
  "48910": 7,
  "48911": 8,
  "48912": 7,
  "48915": 7,
  "48917": 8,
  "48924": 7,
  "48933": 8,
  "49001": 3,
  "49002": 3,
  "49003": 11,
  "49004": 3,
  "49005": 2,
  "49006": 3,
  "49007": 3,
  "49008": 3,
  "49009": 11,
  "49010": 0,
  "49011": -10,
  "49012": 11,
  "49013": -9,
  "49014": -1,
  "49015": -1,
  "49016": -1,
  "49017": -1,
  "49018": -1,
  "49019": 3,
  "49020": -1,
  "49021": -1,
  "49022": -5,
  "49023": -4,
  "49024": 3,
  "49026": -8,
  "49027": -9,
  "49028": -10,
  "49029": -1,
  "49030": -4,
  "49031": -8,
  "49032": -4,
  "49033": 8,
  "49034": 2,
  "49035": -8,
  "49036": -9,
  "49037": -1,
  "49038": -9,
  "49039": -9,
  "49040": -4,
  "49041": 2,
  "49042": -4,
  "49043": -9,
  "49045": -9,
  "49046": -8,
  "49047": -9,
  "49048": 2,
  "49050": -8,
  "49051": -1,
  "49052": 2,
  "49053": 3,
  "49055": -8,
  "49056": -8,
  "49057": -9,
  "49058": -8,
  "49060": 1,
  "49061": -8,
  "49062": -8,
  "49063": -8,
  "49064": -9,
  "49065": -8,
  "49066": -4,
  "49067": -7,
  "49068": -1,
  "49070": -2,
  "49071": 3,
  "49072": -4,
  "49073": -8,
  "49074": 2,
  "49075": -4,
  "49076": 0,
  "49077": 11,
  "49078": -2,
  "49079": -8,
  "49080": 3,
  "49081": 3,
  "49082": -9,
  "49083": 11,
  "49084": -9,
  "49085": -4,
  "49087": 3,
  "49088": 3,
  "49089": -10,
  "49090": -9,
  "49091": -3,
  "49092": -10,
  "49093": -4,
  "49094": -10,
  "49095": -8,
  "49096": 0,
  "49097": 3,
  "49098": -9,
  "49099": -3,
  "49101": -4,
  "49102": -4,
  "49103": -4,
  "49106": -4,
  "49107": -4,
  "49111": -4,
  "49112": -8,
  "49113": -4,
  "49115": 5,
  "49116": 7,
  "49117": 9,
  "49119": -4,
  "49120": -1,
  "49125": -4,
  "49126": -5,
  "49127": -4,
  "49128": -3,
  "49129": -4,
  "49130": 9,
  "49201": 0,
  "49202": -1,
  "49203": -1,
  "49204": 0,
  "49220": -8,
  "49221": -8,
  "49224": -1,
  "49227": -12,
  "49228": -8,
  "49229": -6,
  "49230": 0,
  "49232": -12,
  "49233": 8,
  "49234": 8,
  "49235": -8,
  "49236": -6,
  "49237": 0,
  "49238": -8,
  "49239": -12,
  "49240": 8,
  "49241": 0,
  "49242": -12,
  "49245": -1,
  "49246": 0,
  "49247": -12,
  "49248": -8,
  "49249": 0,
  "49250": -12,
  "49251": 8,
  "49252": -12,
  "49253": -8,
  "49254": 0,
  "49255": -12,
  "49256": 11,
  "49257": 0,
  "49258": -12,
  "49259": 0,
  "49261": 0,
  "49262": -12,
  "49263": -1,
  "49264": 8,
  "49265": 0,
  "49266": -12,
  "49267": 2,
  "49268": -8,
  "49269": 0,
  "49270": 1,
  "49271": -12,
  "49272": 0,
  "49274": -12,
  "49276": 2,
  "49277": 0,
  "49279": -8,
  "49281": 8,
  "49282": 0,
  "49283": 0,
  "49284": -1,
  "49285": 1,
  "49286": -6,
  "49287": -7,
  "49288": -12,
  "49289": -8,
  "49301": 11,
  "49302": 11,
  "49303": -10,
  "49304": -11,
  "49305": -12,
  "49306": 2,
  "49307": -14,
  "49309": -11,
  "49310": -2,
  "49311": -1,
  "49312": -10,
  "49314": 0,
  "49315": 2,
  "49316": 4,
  "49317": 2,
  "49318": 2,
  "49319": 2,
  "49320": -13,
  "49321": 2,
  "49322": -8,
  "49323": 0,
  "49325": -7,
  "49326": -7,
  "49327": -10,
  "49328": 0,
  "49329": -8,
  "49330": 2,
  "49331": 2,
  "49332": -13,
  "49333": -7,
  "49335": -1,
  "49336": -13,
  "49337": -10,
  "49338": -14,
  "49339": -7,
  "49340": -2,
  "49341": 2,
  "49342": -13,
  "49343": -7,
  "49344": -7,
  "49345": 2,
  "49346": -12,
  "49347": -8,
  "49348": -1,
  "49349": -10,
  "49401": -2,
  "49402": -11,
  "49403": 2,
  "49404": -2,
  "49405": -11,
  "49406": 0,
  "49408": 0,
  "49409": 8,
  "49410": -11,
  "49411": -11,
  "49412": -10,
  "49415": 0,
  "49416": 0,
  "49417": 5,
  "49418": 2,
  "49419": 0,
  "49420": -11,
  "49421": -11,
  "49422": -2,
  "49423": -2,
  "49424": -1,
  "49425": -1,
  "49426": -2,
  "49427": -2,
  "49428": -2,
  "49429": -2,
  "49430": -2,
  "49431": -11,
  "49434": 9,
  "49435": 2,
  "49436": -11,
  "49437": 0,
  "49440": -1,
  "49441": -1,
  "49442": -1,
  "49443": -1,
  "49444": -1,
  "49445": 0,
  "49446": -11,
  "49448": 5,
  "49449": -11,
  "49450": 0,
  "49451": 0,
  "49452": -11,
  "49453": 0,
  "49454": -11,
  "49455": -11,
  "49456": 8,
  "49457": 0,
  "49458": -11,
  "49459": -11,
  "49460": -1,
  "49461": 1,
  "49463": 1,
  "49464": -1,
  "49468": 2,
  "49501": 2,
  "49503": 2,
  "49504": 2,
  "49505": 2,
  "49506": 2,
  "49507": 2,
  "49508": 2,
  "49509": 2,
  "49510": 2,
  "49512": 2,
  "49514": 2,
  "49515": 2,
  "49516": 11,
  "49518": 2,
  "49519": 2,
  "49523": 2,
  "49525": 2,
  "49528": 2,
  "49534": 2,
  "49544": 2,
  "49546": 11,
  "49548": 2,
  "49588": 2,
  "49599": 2,
  "49601": -9,
  "49610": 12,
  "49611": -7,
  "49612": -7,
  "49613": -13,
  "49614": -13,
  "49615": -7,
  "49616": -10,
  "49617": -8,
  "49618": -12,
  "49619": -14,
  "49620": 2,
  "49621": -7,
  "49622": -7,
  "49623": -11,
  "49625": -14,
  "49626": -14,
  "49627": -7,
  "49628": -8,
  "49629": 2,
  "49630": -8,
  "49631": 21,
  "49632": -13,
  "49633": 8,
  "49634": -14,
  "49635": -8,
  "49636": 1,
  "49637": 2,
  "49638": -12,
  "49639": 19,
  "49640": -8,
  "49642": -11,
  "49643": -9,
  "49644": -14,
  "49645": -14,
  "49646": 8,
  "49648": 2,
  "49649": 4,
  "49650": -1,
  "49651": -12,
  "49653": 1,
  "49654": 1,
  "49655": 22,
  "49656": -11,
  "49657": -12,
  "49659": -7,
  "49660": -14,
  "49663": -9,
  "49664": -7,
  "49665": 21,
  "49666": 4,
  "49667": -12,
  "49668": -12,
  "49670": 2,
  "49673": 2,
  "49674": 2,
  "49675": -13,
  "49676": 8,
  "49677": 19,
  "49679": 21,
  "49680": 8,
  "49682": 2,
  "49683": -10,
  "49684": 4,
  "49685": 2,
  "49686": 4,
  "49688": 22,
  "49689": -14,
  "49690": 12,
  "49696": 4,
  "49701": -10,
  "49705": 2,
  "49706": -4,
  "49707": -9,
  "49709": -1,
  "49710": 2,
  "49711": -4,
  "49712": -7,
  "49713": -7,
  "49715": 3,
  "49716": -4,
  "49717": -4,
  "49718": -4,
  "49719": 3,
  "49720": -7,
  "49721": 2,
  "49722": -4,
  "49723": 4,
  "49724": 3,
  "49725": 3,
  "49726": 3,
  "49727": -7,
  "49728": -12,
  "49729": -7,
  "49730": -7,
  "49733": -13,
  "49734": 6,
  "49735": 6,
  "49736": 3,
  "49737": 4,
  "49738": -13,
  "49740": 4,
  "49743": -13,
  "49744": -9,
  "49745": 3,
  "49746": -9,
  "49747": -16,
  "49748": -12,
  "49749": 2,
  "49751": 6,
  "49752": -11,
  "49753": -9,
  "49755": -4,
  "49756": -1,
  "49757": -2,
  "49759": -13,
  "49760": -10,
  "49761": 2,
  "49762": -11,
  "49764": 4,
  "49765": -14,
  "49766": -9,
  "49768": -12,
  "49769": -4,
  "49770": -4,
  "49774": 3,
  "49775": 11,
  "49776": -15,
  "49777": 0,
  "49779": -14,
  "49780": -11,
  "49781": -10,
  "49782": -11,
  "49783": 2,
  "49788": 2,
  "49790": -11,
  "49791": 2,
  "49792": 2,
  "49793": -10,
  "49795": 6,
  "49796": -7,
  "49797": -13,
  "49799": 2,
  "49801": 6,
  "49802": 6,
  "49805": -13,
  "49806": -12,
  "49807": -7,
  "49808": -6,
  "49812": -7,
  "49814": -6,
  "49815": 6,
  "49816": -12,
  "49817": -11,
  "49818": -9,
  "49819": 6,
  "49820": -11,
  "49821": -7,
  "49822": -12,
  "49825": -12,
  "49826": -12,
  "49827": -12,
  "49829": -9,
  "49831": 6,
  "49833": -6,
  "49834": 6,
  "49835": -9,
  "49836": -11,
  "49837": -9,
  "49838": -11,
  "49839": -12,
  "49840": -11,
  "49841": -6,
  "49845": -7,
  "49847": -7,
  "49848": -7,
  "49849": -6,
  "49852": 6,
  "49853": -12,
  "49854": -11,
  "49855": -6,
  "49858": -7,
  "49861": -6,
  "49862": -12,
  "49863": -7,
  "49864": -9,
  "49865": -6,
  "49866": -6,
  "49868": -12,
  "49870": 6,
  "49871": -6,
  "49872": -9,
  "49873": 6,
  "49874": -7,
  "49876": 6,
  "49877": 6,
  "49878": -9,
  "49879": -6,
  "49880": -9,
  "49881": 6,
  "49883": -12,
  "49884": -12,
  "49885": -6,
  "49886": -7,
  "49887": -7,
  "49891": -12,
  "49892": 6,
  "49893": -7,
  "49894": -9,
  "49895": -12,
  "49896": -7,
  "49901": -13,
  "49902": -10,
  "49903": -10,
  "49905": -6,
  "49908": -6,
  "49910": -15,
  "49911": -9,
  "49912": -15,
  "49913": -6,
  "49915": -10,
  "49916": -5,
  "49917": -13,
  "49918": -12,
  "49919": -6,
  "49920": -9,
  "49921": -6,
  "49922": -5,
  "49925": -15,
  "49927": -10,
  "49929": -15,
  "49930": -5,
  "49931": -5,
  "49934": -6,
  "49935": -10,
  "49938": -11,
  "49942": -13,
  "49945": -6,
  "49946": -6,
  "49947": -8,
  "49948": -15,
  "49950": -13,
  "49952": -14,
  "49953": -16,
  "49955": -6,
  "49958": -5,
  "49959": -9,
  "49960": -15,
  "49961": -10,
  "49962": -6,
  "49963": -6,
  "49964": -10,
  "49965": -6,
  "49967": -15,
  "49968": -9,
  "49969": 2,
  "49970": -6,
  "49971": -16,
  "50001": -1,
  "50002": 3,
  "50003": -4,
  "50005": 2,
  "50006": -6,
  "50007": 12,
  "50008": -12,
  "50009": 3,
  "50010": 9,
  "50014": 9,
  "50020": -6,
  "50021": 12,
  "50022": -6,
  "50023": 12,
  "50025": -10,
  "50026": -3,
  "50027": -8,
  "50028": -4,
  "50029": -3,
  "50031": -4,
  "50032": 3,
  "50033": -10,
  "50034": -6,
  "50035": 3,
  "50036": -4,
  "50037": -4,
  "50038": -4,
  "50039": -4,
  "50040": -4,
  "50041": 2,
  "50042": -10,
  "50043": -6,
  "50044": 1,
  "50046": 0,
  "50047": -1,
  "50048": 3,
  "50049": -9,
  "50050": -2,
  "50051": 2,
  "50052": -12,
  "50054": -4,
  "50055": 0,
  "50056": 0,
  "50057": -3,
  "50058": -10,
  "50059": -2,
  "50060": -10,
  "50061": 12,
  "50062": -3,
  "50063": -4,
  "50064": -2,
  "50065": -12,
  "50066": -4,
  "50067": -12,
  "50068": -9,
  "50069": -4,
  "50070": -10,
  "50071": -6,
  "50072": -10,
  "50073": 3,
  "50074": -4,
  "50075": -7,
  "50076": -10,
  "50078": 0,
  "50099": -4,
  "50101": -6,
  "50102": -8,
  "50103": -12,
  "50104": -8,
  "50105": 0,
  "50106": 1,
  "50107": -2,
  "50108": -12,
  "50109": 5,
  "50110": -10,
  "50111": 3,
  "50112": 1,
  "50115": -3,
  "50116": 1,
  "50117": -10,
  "50118": -1,
  "50119": -4,
  "50120": 1,
  "50122": -6,
  "50123": -10,
  "50124": 0,
  "50125": -1,
  "50126": -6,
  "50127": -4,
  "50128": -2,
  "50129": -2,
  "50130": -7,
  "50131": 12,
  "50132": -7,
  "50133": -12,
  "50134": 0,
  "50135": -4,
  "50136": -7,
  "50137": -4,
  "50138": -3,
  "50139": -9,
  "50140": -12,
  "50141": 1,
  "50142": 2,
  "50143": -9,
  "50144": -12,
  "50145": -1,
  "50146": -3,
  "50147": -12,
  "50148": 2,
  "50149": -4,
  "50150": 1,
  "50151": -9,
  "50152": -4,
  "50153": 1,
  "50154": 0,
  "50155": -10,
  "50156": -4,
  "50157": 3,
  "50158": 2,
  "50160": -1,
  "50161": 0,
  "50162": 1,
  "50163": -3,
  "50164": 3,
  "50165": -10,
  "50166": -1,
  "50167": -4,
  "50168": -4,
  "50169": 3,
  "50170": -4,
  "50171": 3,
  "50173": -2,
  "50174": -14,
  "50201": 0,
  "50206": -6,
  "50207": -9,
  "50208": -4,
  "50210": -14,
  "50211": -1,
  "50212": -4,
  "50213": -14,
  "50214": -3,
  "50216": -3,
  "50217": -2,
  "50218": -10,
  "50219": -2,
  "50220": -4,
  "50222": -10,
  "50223": -4,
  "50225": -3,
  "50226": 3,
  "50227": 2,
  "50228": -4,
  "50229": -1,
  "50230": -8,
  "50231": -7,
  "50232": -4,
  "50233": -4,
  "50234": 1,
  "50235": -2,
  "50236": 0,
  "50237": 12,
  "50238": -9,
  "50239": 1,
  "50240": -2,
  "50241": -2,
  "50242": 1,
  "50243": 0,
  "50244": 0,
  "50246": -7,
  "50247": 1,
  "50248": 0,
  "50249": -7,
  "50250": 3,
  "50251": -4,
  "50252": -1,
  "50254": -4,
  "50255": -8,
  "50256": -3,
  "50257": -14,
  "50258": 2,
  "50259": 2,
  "50261": -10,
  "50262": -12,
  "50263": 5,
  "50264": -15,
  "50265": 12,
  "50266": 12,
  "50268": -8,
  "50269": 2,
  "50271": -6,
  "50272": -10,
  "50273": -10,
  "50274": -6,
  "50275": -14,
  "50276": -4,
  "50277": -3,
  "50278": 0,
  "50301": 3,
  "50302": 3,
  "50303": 3,
  "50304": 3,
  "50305": 3,
  "50306": 3,
  "50307": 3,
  "50308": 3,
  "50309": 3,
  "50310": 3,
  "50311": 3,
  "50312": 3,
  "50313": 3,
  "50314": 3,
  "50315": 3,
  "50316": 3,
  "50317": 3,
  "50318": 3,
  "50319": 3,
  "50320": 3,
  "50321": 12,
  "50322": 12,
  "50323": 12,
  "50324": 3,
  "50325": 12,
  "50327": 3,
  "50333": 3,
  "50340": 3,
  "50393": 3,
  "50394": 3,
  "50395": 3,
  "50401": -2,
  "50402": -2,
  "50420": 3,
  "50421": -6,
  "50423": -8,
  "50424": -5,
  "50426": -5,
  "50427": 3,
  "50428": 7,
  "50430": -8,
  "50431": 2,
  "50432": -8,
  "50433": 3,
  "50434": -9,
  "50435": -3,
  "50436": -5,
  "50438": -8,
  "50439": -8,
  "50440": -9,
  "50441": 3,
  "50444": -9,
  "50446": -9,
  "50447": -8,
  "50448": -9,
  "50449": 0,
  "50450": -5,
  "50451": -4,
  "50452": 3,
  "50453": -5,
  "50454": -5,
  "50455": -5,
  "50456": -9,
  "50457": -8,
  "50458": -3,
  "50459": -9,
  "50460": 4,
  "50461": -5,
  "50464": -9,
  "50465": -9,
  "50466": -5,
  "50467": -9,
  "50468": -3,
  "50469": -2,
  "50470": -6,
  "50471": -3,
  "50472": -5,
  "50473": -5,
  "50475": 3,
  "50476": -5,
  "50477": -2,
  "50478": -5,
  "50479": -2,
  "50480": -4,
  "50481": -5,
  "50482": 0,
  "50483": -4,
  "50484": -5,
  "50501": -1,
  "50510": 3,
  "50511": -4,
  "50514": -13,
  "50515": -6,
  "50516": -9,
  "50517": -4,
  "50518": -1,
  "50519": -9,
  "50520": -9,
  "50521": -1,
  "50522": -4,
  "50523": -1,
  "50524": -1,
  "50525": -6,
  "50527": -5,
  "50528": -5,
  "50529": -9,
  "50530": -1,
  "50531": -13,
  "50532": -1,
  "50533": -6,
  "50535": -10,
  "50536": -5,
  "50538": -13,
  "50539": -4,
  "50540": -10,
  "50541": -9,
  "50542": -6,
  "50543": -1,
  "50544": -1,
  "50545": -8,
  "50546": -10,
  "50548": -9,
  "50551": -13,
  "50552": -13,
  "50554": -9,
  "50556": -4,
  "50557": -1,
  "50558": -8,
  "50559": -4,
  "50560": -8,
  "50561": -13,
  "50562": -6,
  "50563": -13,
  "50565": 3,
  "50566": -1,
  "50567": -10,
  "50568": 3,
  "50569": -1,
  "50570": -9,
  "50571": -9,
  "50573": -10,
  "50574": -9,
  "50575": -13,
  "50576": 3,
  "50577": -8,
  "50578": -4,
  "50579": -13,
  "50581": -10,
  "50582": -9,
  "50583": -10,
  "50585": 3,
  "50586": -13,
  "50588": 3,
  "50590": -4,
  "50591": -9,
  "50592": 3,
  "50593": -10,
  "50594": -1,
  "50595": -7,
  "50597": -5,
  "50598": -4,
  "50599": -7,
  "50601": -6,
  "50602": 3,
  "50603": -9,
  "50604": 3,
  "50605": 2,
  "50606": 0,
  "50607": -11,
  "50608": 3,
  "50609": 12,
  "50611": 3,
  "50612": 5,
  "50613": 8,
  "50616": -3,
  "50619": 3,
  "50620": -3,
  "50621": 12,
  "50622": 1,
  "50623": -3,
  "50624": 20,
  "50625": 3,
  "50626": -3,
  "50627": -6,
  "50628": -5,
  "50629": -10,
  "50630": -9,
  "50631": -7,
  "50632": -2,
  "50633": 3,
  "50634": -3,
  "50635": -2,
  "50636": 3,
  "50638": 12,
  "50641": -11,
  "50642": 12,
  "50643": 5,
  "50644": -11,
  "50645": -9,
  "50647": 1,
  "50648": -10,
  "50649": 3,
  "50650": -11,
  "50651": -3,
  "50652": 11,
  "50653": -3,
  "50654": -8,
  "50655": 0,
  "50657": 12,
  "50658": -9,
  "50659": -9,
  "50660": 3,
  "50661": -9,
  "50662": 0,
  "50664": 0,
  "50665": 3,
  "50666": -7,
  "50667": -3,
  "50668": -9,
  "50669": 12,
  "50670": 5,
  "50671": -11,
  "50672": -6,
  "50673": 3,
  "50674": -9,
  "50675": -4,
  "50676": -7,
  "50677": 1,
  "50680": 12,
  "50681": 0,
  "50682": -11,
  "50701": -3,
  "50702": -3,
  "50703": -3,
  "50704": -3,
  "50706": -3,
  "50707": -3,
  "50801": -4,
  "50830": -4,
  "50831": -4,
  "50833": -17,
  "50835": -17,
  "50836": -17,
  "50837": 3,
  "50839": -8,
  "50840": -17,
  "50841": -17,
  "50842": -4,
  "50843": -6,
  "50845": -4,
  "50846": 3,
  "50847": -8,
  "50848": -17,
  "50849": 3,
  "50851": -17,
  "50853": -6,
  "50854": -12,
  "50857": -8,
  "50858": 3,
  "50859": -4,
  "50860": -17,
  "50861": -4,
  "50862": -17,
  "50863": -4,
  "50864": -8,
  "51001": -8,
  "51002": 3,
  "51003": -1,
  "51004": -3,
  "51005": -6,
  "51006": 2,
  "51007": 6,
  "51008": -8,
  "51009": -6,
  "51010": -9,
  "51011": -1,
  "51012": -6,
  "51014": -6,
  "51015": 6,
  "51016": 2,
  "51018": 2,
  "51019": 2,
  "51020": 2,
  "51022": -8,
  "51023": -1,
  "51024": 0,
  "51025": 2,
  "51026": -3,
  "51027": -1,
  "51028": -8,
  "51029": -6,
  "51030": 6,
  "51031": -7,
  "51033": 3,
  "51034": -9,
  "51035": -6,
  "51036": -1,
  "51037": -6,
  "51038": -8,
  "51039": -1,
  "51040": -9,
  "51041": 7,
  "51044": -9,
  "51045": -8,
  "51046": -8,
  "51047": -6,
  "51048": -6,
  "51049": -6,
  "51050": -8,
  "51051": -10,
  "51052": -1,
  "51053": -10,
  "51054": 6,
  "51055": -3,
  "51056": -9,
  "51058": -9,
  "51060": -9,
  "51061": -6,
  "51062": 0,
  "51063": -9,
  "51101": -3,
  "51102": 6,
  "51103": -3,
  "51104": 6,
  "51105": -3,
  "51106": -3,
  "51108": -3,
  "51109": -3,
  "51111": -3,
  "51201": -7,
  "51230": -11,
  "51231": -8,
  "51232": -11,
  "51234": 0,
  "51235": -11,
  "51237": -11,
  "51238": -8,
  "51239": 0,
  "51240": -4,
  "51241": -10,
  "51242": -11,
  "51243": -11,
  "51244": 0,
  "51245": -8,
  "51246": -11,
  "51247": 0,
  "51248": -7,
  "51249": -10,
  "51250": 7,
  "51301": -6,
  "51331": -8,
  "51333": -6,
  "51334": -13,
  "51338": -6,
  "51340": -6,
  "51341": -7,
  "51342": -14,
  "51343": -7,
  "51345": -11,
  "51346": -8,
  "51347": -8,
  "51350": -11,
  "51351": -7,
  "51354": -11,
  "51355": 1,
  "51357": -6,
  "51358": -5,
  "51360": 1,
  "51363": -8,
  "51364": -8,
  "51365": -14,
  "51366": -6,
  "51401": -10,
  "51430": -10,
  "51431": 2,
  "51432": -11,
  "51433": -10,
  "51436": -11,
  "51439": -6,
  "51440": -11,
  "51441": -6,
  "51442": -5,
  "51443": -10,
  "51444": -11,
  "51445": 2,
  "51446": -12,
  "51447": -12,
  "51448": -6,
  "51449": -13,
  "51450": -10,
  "51451": -11,
  "51452": -11,
  "51453": -13,
  "51454": -6,
  "51455": -11,
  "51458": -10,
  "51459": -2,
  "51460": -6,
  "51461": -6,
  "51462": -2,
  "51463": -10,
  "51465": -6,
  "51466": -10,
  "51467": -11,
  "51501": -2,
  "51502": -2,
  "51503": 6,
  "51510": -2,
  "51520": -6,
  "51521": -11,
  "51523": -9,
  "51525": -2,
  "51526": 6,
  "51527": -12,
  "51528": -6,
  "51529": -9,
  "51530": -11,
  "51531": -9,
  "51532": -8,
  "51533": -8,
  "51534": 2,
  "51535": -6,
  "51536": -2,
  "51537": -11,
  "51540": -6,
  "51541": -6,
  "51542": 6,
  "51543": -10,
  "51544": -6,
  "51545": -9,
  "51546": -9,
  "51548": 6,
  "51549": -6,
  "51550": -9,
  "51551": -6,
  "51552": -6,
  "51553": 0,
  "51554": 2,
  "51555": -9,
  "51556": -8,
  "51557": -8,
  "51558": -9,
  "51559": -2,
  "51560": -2,
  "51561": -6,
  "51562": -12,
  "51563": -9,
  "51564": -8,
  "51565": -11,
  "51566": -8,
  "51570": -11,
  "51571": -6,
  "51572": -9,
  "51573": -8,
  "51575": -2,
  "51576": 6,
  "51577": -5,
  "51578": -12,
  "51579": -9,
  "51591": -8,
  "51593": -11,
  "51601": -13,
  "51630": -13,
  "51631": -13,
  "51632": -13,
  "51636": -13,
  "51637": -13,
  "51638": -13,
  "51639": -17,
  "51640": -17,
  "51645": -16,
  "51646": -17,
  "51647": -13,
  "51648": -16,
  "51649": -17,
  "51650": -17,
  "51651": -13,
  "51652": -17,
  "51653": -6,
  "51654": -17,
  "51656": -13,
  "52001": -2,
  "52002": 7,
  "52003": -1,
  "52004": -2,
  "52030": -10,
  "52031": -10,
  "52032": -1,
  "52033": -1,
  "52035": 2,
  "52036": -7,
  "52037": -6,
  "52038": -8,
  "52039": 7,
  "52040": -7,
  "52041": -7,
  "52042": 2,
  "52043": 2,
  "52044": 2,
  "52045": -2,
  "52046": -1,
  "52047": 2,
  "52048": 2,
  "52049": 2,
  "52050": -7,
  "52052": 2,
  "52053": -1,
  "52054": -1,
  "52056": -2,
  "52057": -7,
  "52060": -10,
  "52064": -10,
  "52065": -7,
  "52066": -2,
  "52068": 7,
  "52069": -10,
  "52070": -6,
  "52071": -10,
  "52072": 2,
  "52073": -1,
  "52074": -10,
  "52075": -10,
  "52076": 2,
  "52077": 1,
  "52078": -7,
  "52079": -2,
  "52101": 1,
  "52132": 0,
  "52133": 1,
  "52134": -5,
  "52135": 0,
  "52136": -5,
  "52140": -9,
  "52141": 0,
  "52142": 0,
  "52144": 0,
  "52146": -13,
  "52147": 0,
  "52149": 1,
  "52151": -9,
  "52154": -9,
  "52155": -5,
  "52156": -9,
  "52157": 2,
  "52158": 2,
  "52159": -9,
  "52160": -9,
  "52161": 0,
  "52162": -9,
  "52163": -5,
  "52164": 0,
  "52165": 1,
  "52166": 0,
  "52168": 0,
  "52169": 0,
  "52170": -9,
  "52171": -11,
  "52172": -9,
  "52175": 0,
  "52201": -5,
  "52202": 2,
  "52203": -6,
  "52205": -1,
  "52206": -5,
  "52207": -10,
  "52208": -5,
  "52209": -5,
  "52210": -11,
  "52211": 2,
  "52212": -1,
  "52213": 2,
  "52214": 2,
  "52215": -3,
  "52216": -8,
  "52217": -4,
  "52218": -7,
  "52219": -1,
  "52220": -6,
  "52221": 2,
  "52222": 3,
  "52223": -7,
  "52224": -4,
  "52225": -4,
  "52227": 2,
  "52228": 2,
  "52229": -6,
  "52231": -7,
  "52232": 2,
  "52233": 2,
  "52235": -5,
  "52236": 3,
  "52237": -7,
  "52240": 8,
  "52241": 8,
  "52242": 8,
  "52244": 8,
  "52245": 8,
  "52246": 8,
  "52247": -3,
  "52248": -7,
  "52249": -5,
  "52251": -7,
  "52252": -1,
  "52253": -9,
  "52254": -11,
  "52255": -10,
  "52257": -5,
  "52301": -6,
  "52302": 2,
  "52305": -1,
  "52306": -8,
  "52307": -6,
  "52308": -6,
  "52309": -10,
  "52310": -1,
  "52312": -1,
  "52313": -6,
  "52314": 2,
  "52315": -5,
  "52316": -5,
  "52317": 0,
  "52318": -5,
  "52319": 8,
  "52320": -1,
  "52321": -1,
  "52322": 8,
  "52323": -2,
  "52324": 2,
  "52325": -5,
  "52326": -10,
  "52327": -5,
  "52328": 11,
  "52329": -9,
  "52330": -7,
  "52332": -5,
  "52333": 8,
  "52334": -6,
  "52335": -7,
  "52336": 2,
  "52337": -8,
  "52338": 7,
  "52339": -4,
  "52340": 8,
  "52341": 4,
  "52342": -4,
  "52344": -9,
  "52345": -5,
  "52346": -5,
  "52347": -6,
  "52348": -4,
  "52349": -5,
  "52350": 2,
  "52351": -5,
  "52352": -9,
  "52353": -5,
  "52354": -5,
  "52355": -7,
  "52356": -5,
  "52358": 0,
  "52359": -6,
  "52361": -5,
  "52362": -1,
  "52401": 2,
  "52402": 2,
  "52403": 2,
  "52404": 2,
  "52405": 2,
  "52406": 2,
  "52407": 2,
  "52408": 2,
  "52409": 2,
  "52410": 2,
  "52411": 11,
  "52501": -1,
  "52530": -1,
  "52531": 1,
  "52533": -6,
  "52534": -9,
  "52535": -15,
  "52536": -2,
  "52537": -5,
  "52540": -6,
  "52542": -15,
  "52543": -7,
  "52544": -9,
  "52548": -1,
  "52549": -9,
  "52550": -8,
  "52551": -15,
  "52552": -5,
  "52553": -9,
  "52554": -1,
  "52555": -9,
  "52556": -6,
  "52560": -5,
  "52561": -7,
  "52562": -7,
  "52563": -7,
  "52565": -15,
  "52566": -1,
  "52567": -6,
  "52568": -7,
  "52569": 1,
  "52570": -15,
  "52571": -9,
  "52572": -9,
  "52573": -15,
  "52574": -9,
  "52576": -7,
  "52577": -9,
  "52580": -6,
  "52581": -9,
  "52583": -9,
  "52584": -6,
  "52585": -6,
  "52586": -7,
  "52588": -15,
  "52590": -9,
  "52591": -7,
  "52593": -9,
  "52594": -9,
  "52595": -9,
  "52601": -4,
  "52619": -1,
  "52620": -15,
  "52621": -5,
  "52623": -2,
  "52624": -1,
  "52625": -1,
  "52626": -15,
  "52627": -1,
  "52630": -15,
  "52631": -7,
  "52632": -5,
  "52635": -7,
  "52637": -3,
  "52638": -4,
  "52639": -1,
  "52640": -9,
  "52641": -7,
  "52642": -7,
  "52644": -7,
  "52645": -7,
  "52646": -11,
  "52647": -7,
  "52648": -7,
  "52649": -7,
  "52650": 5,
  "52651": -15,
  "52652": -7,
  "52653": -10,
  "52654": -7,
  "52655": -3,
  "52656": -1,
  "52657": -7,
  "52658": -3,
  "52659": -9,
  "52660": -2,
  "52701": -7,
  "52720": -4,
  "52721": -9,
  "52722": 17,
  "52726": 4,
  "52727": -6,
  "52728": 3,
  "52729": -6,
  "52730": -7,
  "52731": -6,
  "52732": -7,
  "52733": -7,
  "52737": -9,
  "52738": -9,
  "52739": -9,
  "52742": -6,
  "52745": 3,
  "52746": 3,
  "52747": -6,
  "52748": 4,
  "52749": 4,
  "52750": -6,
  "52751": -7,
  "52752": -9,
  "52753": 17,
  "52754": -9,
  "52755": 0,
  "52756": -5,
  "52757": -6,
  "52758": -7,
  "52759": 4,
  "52760": -4,
  "52761": -6,
  "52765": -1,
  "52766": -4,
  "52767": 9,
  "52768": 3,
  "52769": 3,
  "52771": -7,
  "52772": -8,
  "52773": 3,
  "52774": -7,
  "52776": -4,
  "52777": -10,
  "52778": -6,
  "52801": 2,
  "52802": 2,
  "52803": 3,
  "52804": 2,
  "52805": 3,
  "52806": 3,
  "52807": 11,
  "52808": 2,
  "52809": 2,
  "53001": -1,
  "53002": -2,
  "53003": 11,
  "53004": -1,
  "53005": 7,
  "53006": 12,
  "53007": 7,
  "53008": 7,
  "53010": 4,
  "53011": -1,
  "53012": -2,
  "53013": -1,
  "53014": -1,
  "53015": 0,
  "53016": 11,
  "53017": -1,
  "53018": 17,
  "53019": 3,
  "53020": -1,
  "53021": 0,
  "53022": -3,
  "53023": -1,
  "53024": -2,
  "53026": -1,
  "53027": -2,
  "53029": 9,
  "53031": -1,
  "53032": 11,
  "53033": -1,
  "53034": 11,
  "53035": 11,
  "53036": 1,
  "53037": -3,
  "53038": 1,
  "53039": 11,
  "53040": -3,
  "53042": -1,
  "53044": -1,
  "53045": 9,
  "53046": 8,
  "53047": 1,
  "53048": 3,
  "53049": 4,
  "53050": 10,
  "53051": 7,
  "53052": 7,
  "53056": 9,
  "53057": 3,
  "53058": 17,
  "53059": 11,
  "53060": 0,
  "53061": -2,
  "53063": 0,
  "53064": 9,
  "53065": 4,
  "53066": 9,
  "53069": 17,
  "53070": -1,
  "53072": 9,
  "53073": -1,
  "53074": -2,
  "53075": -1,
  "53076": -1,
  "53078": -2,
  "53079": 3,
  "53080": -2,
  "53081": -1,
  "53082": -1,
  "53083": -1,
  "53085": -1,
  "53086": -1,
  "53088": -1,
  "53089": 9,
  "53090": -3,
  "53091": -2,
  "53092": 7,
  "53093": -1,
  "53094": 1,
  "53095": -3,
  "53097": 7,
  "53098": 11,
  "53099": 11,
  "53101": -1,
  "53102": -2,
  "53103": 9,
  "53104": -1,
  "53105": -5,
  "53108": 2,
  "53109": -2,
  "53110": 7,
  "53114": -5,
  "53115": -5,
  "53118": 9,
  "53119": 9,
  "53120": -4,
  "53121": -3,
  "53122": 15,
  "53125": 2,
  "53126": 10,
  "53127": 9,
  "53128": -5,
  "53129": 7,
  "53130": 7,
  "53132": 7,
  "53137": 1,
  "53138": 3,
  "53139": 3,
  "53140": -2,
  "53141": -2,
  "53142": -2,
  "53143": -2,
  "53144": -2,
  "53146": 8,
  "53147": -5,
  "53148": -4,
  "53149": 9,
  "53150": 9,
  "53151": 9,
  "53152": -2,
  "53153": 9,
  "53154": 2,
  "53156": 1,
  "53157": -5,
  "53158": -2,
  "53159": -5,
  "53167": 3,
  "53168": -2,
  "53170": -2,
  "53171": -2,
  "53172": 7,
  "53176": -4,
  "53177": 2,
  "53178": 1,
  "53179": -2,
  "53181": -1,
  "53182": 2,
  "53183": 9,
  "53184": -6,
  "53185": 3,
  "53186": 8,
  "53187": 8,
  "53188": 8,
  "53189": 8,
  "53190": 1,
  "53191": 2,
  "53192": -2,
  "53194": -1,
  "53195": -6,
  "53199": -2,
  "53201": 15,
  "53202": 7,
  "53203": 15,
  "53204": 6,
  "53205": 6,
  "53206": 6,
  "53207": 7,
  "53208": 6,
  "53209": 6,
  "53210": 6,
  "53211": 7,
  "53212": 6,
  "53213": 7,
  "53214": 6,
  "53215": 6,
  "53216": 6,
  "53217": 7,
  "53218": 6,
  "53219": 7,
  "53220": 7,
  "53221": 7,
  "53222": 7,
  "53223": 6,
  "53224": 7,
  "53225": 7,
  "53226": 7,
  "53227": 7,
  "53228": 7,
  "53233": 6,
  "53234": 7,
  "53235": 7,
  "53237": 7,
  "53244": 7,
  "53401": 2,
  "53402": 2,
  "53403": 2,
  "53404": 1,
  "53405": 2,
  "53406": 2,
  "53408": 2,
  "53501": 9,
  "53502": -6,
  "53503": -3,
  "53504": 2,
  "53505": 11,
  "53506": -9,
  "53507": -3,
  "53508": -4,
  "53510": 1,
  "53511": 9,
  "53512": 9,
  "53515": 7,
  "53516": 2,
  "53517": -3,
  "53518": -10,
  "53520": -7,
  "53521": -4,
  "53522": -7,
  "53523": 2,
  "53525": 9,
  "53526": -5,
  "53527": 7,
  "53528": 7,
  "53529": 7,
  "53530": 1,
  "53531": 7,
  "53532": 7,
  "53533": -3,
  "53534": 11,
  "53535": -5,
  "53536": 11,
  "53537": 11,
  "53538": 1,
  "53540": -9,
  "53541": 1,
  "53542": 11,
  "53543": -5,
  "53544": -3,
  "53545": 11,
  "53546": 11,
  "53547": 11,
  "53548": 11,
  "53549": 1,
  "53550": -7,
  "53551": 1,
  "53553": -5,
  "53554": -8,
  "53555": 0,
  "53556": -9,
  "53557": 11,
  "53558": 7,
  "53559": 2,
  "53560": 3,
  "53561": 3,
  "53562": 15,
  "53563": 11,
  "53565": -4,
  "53566": -7,
  "53569": -8,
  "53570": -5,
  "53571": 0,
  "53572": 7,
  "53573": -10,
  "53574": -4,
  "53575": 7,
  "53576": 11,
  "53577": 3,
  "53578": 3,
  "53579": 11,
  "53580": -8,
  "53581": -10,
  "53582": -3,
  "53583": 3,
  "53584": -9,
  "53585": -6,
  "53586": 1,
  "53587": 1,
  "53588": -3,
  "53589": 7,
  "53590": 7,
  "53593": 15,
  "53594": 1,
  "53597": 15,
  "53598": 7,
  "53599": 2,
  "53701": 7,
  "53703": 7,
  "53704": 7,
  "53705": 15,
  "53706": 7,
  "53707": 7,
  "53708": 7,
  "53711": 7,
  "53713": 7,
  "53714": 7,
  "53715": 7,
  "53716": 7,
  "53717": 16,
  "53718": 7,
  "53719": 7,
  "53725": 7,
  "53726": 7,
  "53744": 7,
  "53801": 2,
  "53802": -8,
  "53803": 1,
  "53804": -8,
  "53805": -13,
  "53806": -8,
  "53807": 1,
  "53808": -2,
  "53809": -8,
  "53810": 2,
  "53811": -2,
  "53812": -2,
  "53813": -8,
  "53816": -8,
  "53817": -8,
  "53818": -8,
  "53820": -8,
  "53821": -13,
  "53824": -2,
  "53825": -8,
  "53826": -13,
  "53827": -13,
  "53901": 0,
  "53910": -12,
  "53911": 0,
  "53913": 3,
  "53916": 11,
  "53919": 4,
  "53920": -9,
  "53922": 18,
  "53923": 0,
  "53924": -10,
  "53925": 0,
  "53926": 4,
  "53927": -14,
  "53928": 0,
  "53929": -10,
  "53930": -9,
  "53931": 4,
  "53932": 0,
  "53933": 10,
  "53934": -14,
  "53935": 6,
  "53936": -12,
  "53937": -9,
  "53939": 4,
  "53940": 3,
  "53941": 3,
  "53942": -10,
  "53943": 3,
  "53944": -8,
  "53946": 4,
  "53947": 3,
  "53948": -10,
  "53949": -11,
  "53950": -10,
  "53951": 3,
  "53952": -9,
  "53953": -9,
  "53954": 0,
  "53955": 0,
  "53956": 0,
  "53959": 3,
  "53960": 0,
  "53961": 3,
  "53962": -10,
  "53963": 3,
  "53964": -12,
  "53965": 3,
  "53968": -10,
  "53969": 0,
  "54001": -3,
  "54002": 1,
  "54003": -1,
  "54004": -6,
  "54005": -4,
  "54006": -3,
  "54007": 1,
  "54009": -3,
  "54010": -2,
  "54011": -2,
  "54013": 1,
  "54014": -2,
  "54015": 1,
  "54016": 8,
  "54017": 1,
  "54020": -3,
  "54021": -1,
  "54022": -1,
  "54023": 2,
  "54024": -3,
  "54025": 2,
  "54026": 1,
  "54027": 10,
  "54028": 9,
  "54082": 8,
  "54101": -8,
  "54102": -7,
  "54103": -16,
  "54104": -7,
  "54106": 6,
  "54107": -7,
  "54110": -1,
  "54111": -8,
  "54112": -8,
  "54113": 6,
  "54114": -7,
  "54115": 3,
  "54119": -16,
  "54120": -16,
  "54121": -16,
  "54123": -1,
  "54124": -8,
  "54125": -17,
  "54126": 3,
  "54127": -8,
  "54128": -7,
  "54129": -1,
  "54130": 6,
  "54131": 6,
  "54135": -7,
  "54136": 5,
  "54137": -8,
  "54138": -8,
  "54139": -8,
  "54140": 6,
  "54141": 4,
  "54143": -1,
  "54149": -8,
  "54150": -8,
  "54151": -16,
  "54152": 5,
  "54153": -8,
  "54154": -8,
  "54155": 3,
  "54156": -7,
  "54157": -7,
  "54159": -7,
  "54160": -1,
  "54161": -8,
  "54162": 3,
  "54165": 6,
  "54166": -7,
  "54169": 8,
  "54170": 6,
  "54171": 3,
  "54173": 4,
  "54174": -8,
  "54175": -17,
  "54177": -7,
  "54180": 6,
  "54182": -7,
  "54201": -3,
  "54202": 8,
  "54204": -2,
  "54205": -2,
  "54207": 1,
  "54208": 3,
  "54209": 8,
  "54210": 8,
  "54211": 8,
  "54212": 8,
  "54213": -3,
  "54214": 1,
  "54215": 1,
  "54216": -3,
  "54217": -2,
  "54220": 0,
  "54221": 0,
  "54226": -3,
  "54227": 1,
  "54228": 1,
  "54229": -2,
  "54230": 1,
  "54232": 0,
  "54234": 8,
  "54235": 0,
  "54240": -3,
  "54241": 0,
  "54245": 0,
  "54246": 0,
  "54247": 1,
  "54301": 3,
  "54302": 3,
  "54303": 3,
  "54304": 3,
  "54305": 3,
  "54306": 3,
  "54307": 3,
  "54308": 3,
  "54311": 3,
  "54313": 3,
  "54324": 3,
  "54401": 0,
  "54402": -1,
  "54403": 0,
  "54405": 1,
  "54406": -4,
  "54407": -4,
  "54408": -8,
  "54409": -8,
  "54410": -3,
  "54411": 0,
  "54412": -3,
  "54413": -3,
  "54414": -8,
  "54415": -3,
  "54416": -7,
  "54417": -1,
  "54418": -8,
  "54420": 0,
  "54421": 0,
  "54422": 1,
  "54423": -2,
  "54424": -8,
  "54425": 1,
  "54426": 0,
  "54427": -7,
  "54428": -8,
  "54429": -7,
  "54430": -8,
  "54432": -7,
  "54433": 0,
  "54434": -3,
  "54435": -7,
  "54436": 0,
  "54437": 0,
  "54439": 0,
  "54440": 0,
  "54441": -3,
  "54442": -7,
  "54443": -4,
  "54446": 0,
  "54447": 0,
  "54448": 0,
  "54449": -3,
  "54450": -8,
  "54451": 1,
  "54452": -7,
  "54454": -3,
  "54455": 0,
  "54456": 0,
  "54457": -3,
  "54458": -4,
  "54459": -7,
  "54460": 0,
  "54462": -8,
  "54463": -8,
  "54464": -8,
  "54465": -8,
  "54466": -3,
  "54467": -4,
  "54469": -3,
  "54470": 1,
  "54471": 2,
  "54473": -4,
  "54474": 0,
  "54475": -3,
  "54476": 0,
  "54479": 0,
  "54480": 1,
  "54481": -4,
  "54482": -4,
  "54484": 0,
  "54485": -8,
  "54486": -7,
  "54487": -7,
  "54488": 0,
  "54489": -3,
  "54490": 1,
  "54491": -8,
  "54493": 0,
  "54494": -3,
  "54495": -3,
  "54498": 0,
  "54499": -7,
  "54501": -2,
  "54511": -17,
  "54512": 4,
  "54513": -7,
  "54514": -10,
  "54515": -7,
  "54517": -4,
  "54519": 4,
  "54520": -17,
  "54521": 2,
  "54524": -7,
  "54525": -11,
  "54526": -3,
  "54527": -4,
  "54529": -2,
  "54530": -7,
  "54531": 6,
  "54532": -7,
  "54534": -11,
  "54536": -11,
  "54537": -7,
  "54538": 11,
  "54539": -2,
  "54540": 11,
  "54541": -17,
  "54542": -16,
  "54543": -2,
  "54545": 11,
  "54546": -4,
  "54547": -10,
  "54548": 11,
  "54550": -11,
  "54552": -7,
  "54554": 2,
  "54555": -7,
  "54556": -7,
  "54557": 11,
  "54558": 11,
  "54559": -4,
  "54560": 2,
  "54561": 4,
  "54562": 6,
  "54563": -3,
  "54564": -7,
  "54565": -11,
  "54566": -17,
  "54568": 2,
  "54601": 0,
  "54602": 0,
  "54603": 0,
  "54610": -9,
  "54611": 12,
  "54612": -8,
  "54613": -13,
  "54614": 0,
  "54615": 12,
  "54616": -8,
  "54618": -10,
  "54619": -9,
  "54620": -1,
  "54621": -9,
  "54622": -8,
  "54623": 0,
  "54624": -13,
  "54625": -8,
  "54626": -13,
  "54627": -8,
  "54628": -13,
  "54629": -9,
  "54630": -8,
  "54631": -13,
  "54632": -9,
  "54634": -10,
  "54635": 13,
  "54636": 9,
  "54637": -10,
  "54638": -1,
  "54639": -9,
  "54640": -14,
  "54641": -1,
  "54642": 12,
  "54643": 12,
  "54644": 0,
  "54645": -14,
  "54646": -10,
  "54648": -1,
  "54649": -10,
  "54650": 9,
  "54651": -1,
  "54652": -9,
  "54653": 0,
  "54654": -14,
  "54655": -9,
  "54656": -1,
  "54657": -13,
  "54658": 9,
  "54659": -8,
  "54660": -1,
  "54661": 0,
  "54662": -1,
  "54664": -9,
  "54665": -9,
  "54666": -1,
  "54667": -9,
  "54669": 2,
  "54670": -1,
  "54701": 8,
  "54702": 0,
  "54703": 0,
  "54720": 0,
  "54721": 1,
  "54722": 0,
  "54723": -1,
  "54724": 1,
  "54725": 1,
  "54726": 1,
  "54727": 1,
  "54728": -6,
  "54729": 1,
  "54730": 1,
  "54731": -3,
  "54732": 0,
  "54733": -7,
  "54734": 1,
  "54735": 1,
  "54736": 1,
  "54737": 1,
  "54738": 2,
  "54739": 3,
  "54740": 1,
  "54741": 12,
  "54742": 0,
  "54743": -9,
  "54745": -3,
  "54746": 12,
  "54747": -8,
  "54748": 1,
  "54749": 1,
  "54750": -1,
  "54751": 1,
  "54754": 12,
  "54755": -9,
  "54756": 0,
  "54757": 1,
  "54758": -7,
  "54759": 1,
  "54760": -7,
  "54761": 1,
  "54762": -6,
  "54763": 1,
  "54764": -9,
  "54765": 1,
  "54766": -3,
  "54767": -2,
  "54768": 0,
  "54769": 10,
  "54770": -7,
  "54771": 0,
  "54772": 1,
  "54773": -8,
  "54801": -9,
  "54805": -7,
  "54806": -3,
  "54810": -3,
  "54812": -6,
  "54813": -6,
  "54814": -2,
  "54816": -2,
  "54817": -6,
  "54818": -6,
  "54819": -3,
  "54820": -2,
  "54821": -4,
  "54822": -6,
  "54824": -3,
  "54826": -4,
  "54827": -2,
  "54828": -11,
  "54829": -6,
  "54830": -8,
  "54832": -2,
  "54834": -10,
  "54835": -11,
  "54836": 20,
  "54837": -6,
  "54838": 20,
  "54839": -3,
  "54840": -6,
  "54841": -7,
  "54842": 20,
  "54843": -11,
  "54844": -2,
  "54845": -9,
  "54846": -4,
  "54847": -2,
  "54848": -3,
  "54849": 20,
  "54850": 6,
  "54853": -3,
  "54854": 19,
  "54855": -4,
  "54856": -2,
  "54857": -6,
  "54858": -3,
  "54859": -12,
  "54861": -4,
  "54862": -11,
  "54864": 20,
  "54865": -3,
  "54867": -11,
  "54868": -6,
  "54870": -7,
  "54871": -9,
  "54872": -8,
  "54873": 20,
  "54874": 20,
  "54875": -12,
  "54876": -11,
  "54880": 19,
  "54888": -12,
  "54889": -4,
  "54890": -12,
  "54891": -2,
  "54893": -8,
  "54895": -3,
  "54896": -10,
  "54901": 7,
  "54902": 16,
  "54903": 7,
  "54904": 16,
  "54909": -13,
  "54911": 5,
  "54912": 6,
  "54913": 6,
  "54914": 6,
  "54915": 5,
  "54921": -4,
  "54922": -7,
  "54923": 4,
  "54926": -7,
  "54927": 7,
  "54928": -7,
  "54929": -7,
  "54930": -14,
  "54931": 6,
  "54932": 4,
  "54933": -7,
  "54934": 7,
  "54935": 3,
  "54936": 3,
  "54937": 3,
  "54940": -6,
  "54941": 5,
  "54942": 13,
  "54943": -14,
  "54944": 6,
  "54945": -7,
  "54946": -7,
  "54947": 10,
  "54948": -7,
  "54949": -7,
  "54950": -7,
  "54952": 5,
  "54956": 8,
  "54957": 8,
  "54960": -13,
  "54961": -7,
  "54962": -7,
  "54963": 7,
  "54964": 8,
  "54965": -13,
  "54966": -13,
  "54967": -13,
  "54968": 4,
  "54969": -6,
  "54970": -13,
  "54971": 4,
  "54974": 3,
  "54976": -13,
  "54977": -6,
  "54978": -7,
  "54979": 3,
  "54980": 7,
  "54981": -7,
  "54982": -13,
  "54983": -7,
  "54984": -13,
  "54985": 7,
  "54986": 8,
  "55001": 16,
  "55002": 8,
  "55003": 7,
  "55005": -5,
  "55006": -7,
  "55007": -9,
  "55008": -5,
  "55009": 4,
  "55010": 13,
  "55011": 8,
  "55012": 8,
  "55013": 8,
  "55014": 8,
  "55016": 13,
  "55017": -7,
  "55018": 0,
  "55019": 0,
  "55020": 11,
  "55021": 0,
  "55024": 13,
  "55025": 8,
  "55026": -12,
  "55027": 4,
  "55029": -5,
  "55030": 10,
  "55031": 13,
  "55032": 8,
  "55033": 13,
  "55036": 10,
  "55037": -9,
  "55038": 8,
  "55040": -5,
  "55041": -12,
  "55042": 16,
  "55043": 8,
  "55044": 13,
  "55045": 8,
  "55046": 0,
  "55047": 16,
  "55049": -1,
  "55051": 10,
  "55052": 0,
  "55053": 8,
  "55054": 11,
  "55055": 13,
  "55056": 8,
  "55057": 0,
  "55060": -1,
  "55063": 10,
  "55065": 13,
  "55066": 4,
  "55067": 10,
  "55068": 13,
  "55069": 8,
  "55070": -5,
  "55071": 13,
  "55072": -9,
  "55073": 10,
  "55074": 8,
  "55075": 14,
  "55076": 13,
  "55077": 13,
  "55078": 8,
  "55079": 8,
  "55080": -6,
  "55082": 8,
  "55083": 8,
  "55084": 8,
  "55085": 13,
  "55087": 0,
  "55088": 12,
  "55089": 4,
  "55090": 7,
  "55092": 8,
  "55101": 14,
  "55102": 14,
  "55103": 14,
  "55104": 14,
  "55105": 15,
  "55106": 14,
  "55107": 14,
  "55108": 15,
  "55109": 14,
  "55110": 8,
  "55111": 14,
  "55112": 15,
  "55113": 15,
  "55114": 15,
  "55115": 16,
  "55116": 15,
  "55117": 14,
  "55118": 15,
  "55119": 14,
  "55120": 15,
  "55121": 13,
  "55122": 13,
  "55123": 15,
  "55124": 13,
  "55125": 16,
  "55126": 15,
  "55127": 15,
  "55128": 8,
  "55129": 16,
  "55130": 14,
  "55150": 14,
  "55164": 14,
  "55165": 14,
  "55166": 14,
  "55172": 14,
  "55175": 14,
  "55301": 7,
  "55302": 7,
  "55303": 8,
  "55304": 8,
  "55305": 13,
  "55306": 13,
  "55307": -6,
  "55308": 11,
  "55309": 11,
  "55310": -8,
  "55311": 13,
  "55312": 0,
  "55313": 14,
  "55314": -8,
  "55315": 11,
  "55316": 8,
  "55317": 9,
  "55318": 7,
  "55319": 11,
  "55320": 4,
  "55321": 5,
  "55322": 7,
  "55323": 15,
  "55324": -5,
  "55325": -5,
  "55327": 8,
  "55328": 7,
  "55329": -5,
  "55330": 3,
  "55331": 15,
  "55332": -8,
  "55333": -8,
  "55334": -6,
  "55335": -6,
  "55336": 0,
  "55337": 13,
  "55338": -6,
  "55339": 7,
  "55340": 22,
  "55341": 7,
  "55342": -8,
  "55343": 13,
  "55344": 13,
  "55345": 13,
  "55346": 13,
  "55347": 20,
  "55348": 7,
  "55349": 5,
  "55350": -1,
  "55352": 11,
  "55353": -5,
  "55354": 0,
  "55355": -5,
  "55356": 15,
  "55357": 15,
  "55358": 6,
  "55359": 7,
  "55360": 7,
  "55361": 7,
  "55362": 11,
  "55363": 7,
  "55364": 7,
  "55365": 11,
  "55366": -6,
  "55367": 7,
  "55368": 7,
  "55369": 8,
  "55370": 0,
  "55371": 2,
  "55372": 11,
  "55373": 7,
  "55374": 8,
  "55375": 7,
  "55376": 7,
  "55377": 11,
  "55378": 11,
  "55379": 11,
  "55380": 4,
  "55381": -1,
  "55382": 6,
  "55383": 7,
  "55384": 7,
  "55385": -1,
  "55386": 7,
  "55387": 7,
  "55388": 7,
  "55389": -5,
  "55390": 14,
  "55391": 24,
  "55392": 24,
  "55393": 7,
  "55394": 7,
  "55395": 0,
  "55396": -6,
  "55397": 7,
  "55398": 11,
  "55399": 7,
  "55401": 13,
  "55402": 13,
  "55403": 15,
  "55404": 13,
  "55405": 13,
  "55406": 15,
  "55407": 13,
  "55408": 13,
  "55409": 13,
  "55410": 13,
  "55411": 13,
  "55412": 13,
  "55413": 13,
  "55414": 15,
  "55415": 13,
  "55416": 13,
  "55417": 13,
  "55418": 13,
  "55419": 13,
  "55420": 13,
  "55421": 13,
  "55422": 13,
  "55423": 13,
  "55424": 22,
  "55425": 13,
  "55426": 13,
  "55427": 13,
  "55428": 13,
  "55429": 13,
  "55430": 13,
  "55431": 13,
  "55432": 8,
  "55433": 8,
  "55434": 8,
  "55435": 13,
  "55436": 22,
  "55437": 13,
  "55438": 13,
  "55439": 24,
  "55440": 13,
  "55441": 13,
  "55442": 15,
  "55443": 13,
  "55444": 8,
  "55445": 8,
  "55446": 22,
  "55447": 13,
  "55448": 8,
  "55449": 8,
  "55450": 13,
  "55454": 13,
  "55455": 13,
  "55458": 13,
  "55459": 13,
  "55460": 13,
  "55470": 13,
  "55473": 13,
  "55480": 13,
  "55550": 7,
  "55551": 7,
  "55552": 7,
  "55553": 7,
  "55554": 7,
  "55555": 7,
  "55556": 7,
  "55557": 7,
  "55559": 7,
  "55560": 7,
  "55561": 11,
  "55562": 7,
  "55563": 11,
  "55564": 7,
  "55565": 11,
  "55566": 7,
  "55567": 7,
  "55568": 7,
  "55569": 8,
  "55570": 7,
  "55571": 7,
  "55572": 7,
  "55573": 7,
  "55574": 7,
  "55575": 5,
  "55576": 7,
  "55577": 7,
  "55578": 7,
  "55579": 7,
  "55580": 11,
  "55581": 11,
  "55582": 11,
  "55583": 7,
  "55584": 11,
  "55585": 11,
  "55586": 11,
  "55587": 11,
  "55588": 11,
  "55589": 11,
  "55590": 11,
  "55591": 11,
  "55592": 7,
  "55593": 7,
  "55594": 7,
  "55595": 15,
  "55596": 15,
  "55597": 15,
  "55598": 15,
  "55599": 15,
  "55601": 4,
  "55602": 4,
  "55603": -14,
  "55604": -13,
  "55605": -14,
  "55606": -13,
  "55607": 4,
  "55609": 12,
  "55612": -5,
  "55613": -5,
  "55614": -14,
  "55615": -5,
  "55616": 4,
  "55701": 10,
  "55702": 10,
  "55703": 4,
  "55704": -10,
  "55705": 4,
  "55706": 4,
  "55707": 9,
  "55708": 4,
  "55709": 2,
  "55710": 4,
  "55711": 10,
  "55712": -9,
  "55713": 4,
  "55716": 2,
  "55717": 4,
  "55718": 9,
  "55719": 4,
  "55720": 10,
  "55721": 2,
  "55722": 2,
  "55723": 4,
  "55724": 4,
  "55725": 8,
  "55726": 10,
  "55730": 2,
  "55731": 4,
  "55732": 4,
  "55733": 10,
  "55734": 4,
  "55735": -9,
  "55736": 9,
  "55738": 4,
  "55741": 4,
  "55742": 2,
  "55744": 2,
  "55746": 4,
  "55747": 4,
  "55748": -12,
  "55749": 9,
  "55750": 4,
  "55751": 4,
  "55752": -12,
  "55753": 2,
  "55756": -9,
  "55757": 8,
  "55758": 4,
  "55760": -11,
  "55763": 4,
  "55764": 2,
  "55765": 4,
  "55766": 4,
  "55767": 9,
  "55768": 4,
  "55769": 2,
  "55771": -1,
  "55772": -1,
  "55775": 2,
  "55777": 4,
  "55779": 10,
  "55780": 9,
  "55781": 11,
  "55782": 4,
  "55783": -9,
  "55784": 2,
  "55785": -12,
  "55786": 2,
  "55787": -12,
  "55790": 5,
  "55791": 10,
  "55792": 4,
  "55793": 2,
  "55795": -10,
  "55796": 4,
  "55797": 9,
  "55798": 10,
  "55801": 4,
  "55802": 9,
  "55803": 4,
  "55804": 10,
  "55805": 9,
  "55806": 9,
  "55807": 9,
  "55808": 19,
  "55810": 10,
  "55811": 10,
  "55812": 10,
  "55814": 10,
  "55815": 9,
  "55816": 9,
  "55901": 4,
  "55902": 12,
  "55903": 12,
  "55904": 4,
  "55906": 5,
  "55909": -3,
  "55910": -4,
  "55912": -3,
  "55917": -1,
  "55918": -3,
  "55919": -3,
  "55920": 7,
  "55921": -3,
  "55922": -5,
  "55923": -3,
  "55924": 6,
  "55925": 0,
  "55926": -2,
  "55927": 6,
  "55929": 4,
  "55931": -3,
  "55932": -12,
  "55933": -3,
  "55934": 4,
  "55935": -3,
  "55936": -3,
  "55939": -4,
  "55940": 6,
  "55941": -3,
  "55942": -6,
  "55943": -3,
  "55944": 6,
  "55945": -12,
  "55946": 0,
  "55947": 9,
  "55949": -3,
  "55950": -3,
  "55951": -3,
  "55952": -4,
  "55953": -3,
  "55954": -5,
  "55955": 6,
  "55956": 4,
  "55957": -12,
  "55959": 3,
  "55960": 12,
  "55961": -3,
  "55962": -5,
  "55963": 7,
  "55964": -12,
  "55965": -4,
  "55967": 4,
  "55968": -12,
  "55969": -4,
  "55970": -3,
  "55971": -6,
  "55972": -4,
  "55973": -2,
  "55974": -4,
  "55975": -4,
  "55976": 4,
  "55977": -3,
  "55979": -4,
  "55981": -12,
  "55982": -3,
  "55983": 4,
  "55985": 6,
  "55987": -6,
  "55988": -6,
  "55990": -4,
  "55991": -12,
  "55992": 4,
  "56001": 3,
  "56002": 3,
  "56003": 3,
  "56006": 3,
  "56007": 4,
  "56009": 4,
  "56010": 2,
  "56011": 11,
  "56013": -9,
  "56014": -9,
  "56016": 4,
  "56017": 1,
  "56019": 7,
  "56020": 4,
  "56021": 2,
  "56022": -4,
  "56023": -9,
  "56024": 3,
  "56025": -9,
  "56026": -1,
  "56027": -9,
  "56028": 1,
  "56029": 4,
  "56030": 7,
  "56031": -6,
  "56032": 4,
  "56033": -9,
  "56034": 3,
  "56035": 4,
  "56036": 4,
  "56037": 3,
  "56039": -6,
  "56041": 7,
  "56042": 4,
  "56043": 4,
  "56044": -6,
  "56045": 4,
  "56046": -1,
  "56047": -9,
  "56048": -7,
  "56050": 2,
  "56051": -9,
  "56052": 1,
  "56054": -6,
  "56055": 3,
  "56056": -4,
  "56057": 1,
  "56058": 1,
  "56060": -4,
  "56062": -4,
  "56063": 1,
  "56065": 2,
  "56068": -9,
  "56069": 1,
  "56071": 11,
  "56072": -7,
  "56073": 7,
  "56074": 2,
  "56075": -6,
  "56078": -7,
  "56080": 3,
  "56081": -4,
  "56082": 2,
  "56083": -8,
  "56084": 7,
  "56085": 7,
  "56087": 7,
  "56088": -6,
  "56089": 4,
  "56090": 2,
  "56091": -7,
  "56093": -7,
  "56096": 1,
  "56097": -9,
  "56098": -9,
  "56101": -5,
  "56110": -6,
  "56111": -11,
  "56113": -8,
  "56114": -14,
  "56115": -4,
  "56116": -10,
  "56117": -7,
  "56118": -5,
  "56119": -6,
  "56120": -5,
  "56121": -7,
  "56122": -13,
  "56123": -6,
  "56125": -6,
  "56127": -7,
  "56128": -1,
  "56129": -10,
  "56131": -13,
  "56132": -4,
  "56134": -10,
  "56136": -8,
  "56137": -11,
  "56138": -10,
  "56139": -2,
  "56140": -2,
  "56141": -14,
  "56142": -8,
  "56143": -10,
  "56144": -2,
  "56145": -6,
  "56146": -10,
  "56147": -10,
  "56149": -8,
  "56150": -10,
  "56151": -14,
  "56152": -8,
  "56153": -10,
  "56155": -7,
  "56156": -10,
  "56157": -4,
  "56158": -10,
  "56159": -6,
  "56160": -5,
  "56161": -11,
  "56162": -4,
  "56164": -1,
  "56165": -6,
  "56166": -8,
  "56167": -10,
  "56168": -6,
  "56169": -4,
  "56170": -2,
  "56171": -6,
  "56172": -13,
  "56173": -10,
  "56174": -6,
  "56175": -4,
  "56176": -7,
  "56177": -2,
  "56178": -7,
  "56180": -8,
  "56181": -7,
  "56183": -6,
  "56185": -7,
  "56186": -2,
  "56187": -6,
  "56201": 0,
  "56207": 12,
  "56208": -10,
  "56209": 0,
  "56210": 2,
  "56211": -9,
  "56212": -9,
  "56214": 0,
  "56215": -10,
  "56216": 0,
  "56218": 0,
  "56219": -9,
  "56220": -10,
  "56221": 12,
  "56222": 3,
  "56223": 0,
  "56224": -9,
  "56225": 2,
  "56226": -10,
  "56227": 2,
  "56228": -5,
  "56229": 2,
  "56230": -8,
  "56231": -10,
  "56232": -8,
  "56235": 12,
  "56236": -9,
  "56237": -8,
  "56239": -4,
  "56240": 2,
  "56241": 0,
  "56243": -5,
  "56244": 12,
  "56245": 0,
  "56248": -10,
  "56249": -10,
  "56251": 0,
  "56252": 0,
  "56253": 0,
  "56255": -8,
  "56256": -9,
  "56257": -8,
  "56258": 4,
  "56260": 3,
  "56262": -10,
  "56263": -4,
  "56264": 0,
  "56265": 3,
  "56266": -8,
  "56267": 12,
  "56270": -8,
  "56271": -10,
  "56273": 0,
  "56274": -10,
  "56276": 2,
  "56277": -8,
  "56278": 2,
  "56279": 0,
  "56280": -7,
  "56281": 0,
  "56282": 0,
  "56283": -8,
  "56284": 0,
  "56285": 3,
  "56287": -9,
  "56288": 8,
  "56289": 0,
  "56291": 0,
  "56292": -8,
  "56293": -8,
  "56294": -8,
  "56295": 3,
  "56296": -9,
  "56297": -1,
  "56301": 6,
  "56302": 6,
  "56303": 6,
  "56304": 6,
  "56307": 6,
  "56308": 0,
  "56309": -9,
  "56310": 6,
  "56311": -9,
  "56312": 0,
  "56313": -4,
  "56314": -7,
  "56315": 0,
  "56316": -9,
  "56317": -7,
  "56318": -10,
  "56319": 0,
  "56320": 6,
  "56321": 6,
  "56323": 11,
  "56324": -9,
  "56325": 6,
  "56326": 0,
  "56327": 0,
  "56328": -8,
  "56329": 6,
  "56330": -4,
  "56331": 6,
  "56332": 0,
  "56333": 6,
  "56334": -9,
  "56335": 6,
  "56336": -10,
  "56338": -4,
  "56339": -9,
  "56340": 6,
  "56341": 0,
  "56342": 10,
  "56343": 0,
  "56344": -7,
  "56345": -7,
  "56347": -10,
  "56349": -9,
  "56350": -9,
  "56352": 6,
  "56353": -4,
  "56354": 0,
  "56355": 0,
  "56356": 6,
  "56357": 6,
  "56358": 10,
  "56359": -4,
  "56360": 0,
  "56361": 0,
  "56362": 6,
  "56363": -4,
  "56364": -7,
  "56367": 6,
  "56368": 6,
  "56369": 6,
  "56371": 6,
  "56373": -7,
  "56374": 6,
  "56375": 6,
  "56376": 6,
  "56377": 6,
  "56378": -10,
  "56379": 6,
  "56381": -9,
  "56382": -7,
  "56384": -7,
  "56385": -9,
  "56386": -4,
  "56387": 6,
  "56388": 6,
  "56389": 0,
  "56397": 6,
  "56398": 6,
  "56401": 1,
  "56425": 1,
  "56430": 1,
  "56431": -11,
  "56433": -6,
  "56434": -2,
  "56435": -8,
  "56436": 2,
  "56437": -10,
  "56438": -10,
  "56440": -10,
  "56441": 1,
  "56442": 9,
  "56443": -10,
  "56444": 1,
  "56446": -10,
  "56447": 1,
  "56448": -7,
  "56449": -7,
  "56450": 1,
  "56452": 1,
  "56453": -10,
  "56455": 1,
  "56456": 1,
  "56458": -6,
  "56459": 9,
  "56461": -6,
  "56464": -2,
  "56465": 1,
  "56466": -2,
  "56467": 2,
  "56468": 9,
  "56469": -11,
  "56470": -6,
  "56472": 1,
  "56473": 1,
  "56474": -8,
  "56475": -7,
  "56477": -2,
  "56478": -2,
  "56479": -2,
  "56481": -2,
  "56482": -2,
  "56484": 1,
  "56501": -5,
  "56502": -5,
  "56510": -20,
  "56511": -5,
  "56514": -4,
  "56515": -4,
  "56516": 14,
  "56517": 5,
  "56518": -2,
  "56519": -20,
  "56520": -14,
  "56521": -5,
  "56522": -14,
  "56523": 5,
  "56524": -5,
  "56525": -4,
  "56527": -2,
  "56528": -5,
  "56529": -4,
  "56531": -9,
  "56533": -15,
  "56534": -5,
  "56535": 5,
  "56536": -4,
  "56537": -5,
  "56538": -5,
  "56540": 5,
  "56541": -20,
  "56542": 6,
  "56543": -15,
  "56544": -5,
  "56545": -20,
  "56546": -19,
  "56547": -4,
  "56548": -20,
  "56549": -4,
  "56550": -20,
  "56551": -2,
  "56552": -4,
  "56553": -14,
  "56554": -5,
  "56556": 15,
  "56557": 14,
  "56560": -4,
  "56561": -4,
  "56562": -4,
  "56563": -4,
  "56565": -10,
  "56566": 14,
  "56567": -2,
  "56568": -20,
  "56569": -5,
  "56570": -5,
  "56571": -4,
  "56572": -5,
  "56573": -5,
  "56574": -20,
  "56575": -5,
  "56576": -4,
  "56577": -5,
  "56578": -5,
  "56579": -15,
  "56580": -4,
  "56581": -20,
  "56583": -9,
  "56584": -20,
  "56585": -20,
  "56586": -5,
  "56587": -5,
  "56588": -4,
  "56589": 14,
  "56590": -10,
  "56591": -5,
  "56592": 15,
  "56593": -5,
  "56594": -14,
  "56601": 1,
  "56619": 1,
  "56621": 5,
  "56623": 0,
  "56626": -8,
  "56627": -1,
  "56628": 2,
  "56629": 0,
  "56630": 1,
  "56631": 2,
  "56633": 1,
  "56634": 1,
  "56636": 2,
  "56637": 2,
  "56639": 2,
  "56641": -8,
  "56644": 6,
  "56646": 5,
  "56647": 10,
  "56649": -1,
  "56650": 1,
  "56651": 14,
  "56652": 1,
  "56653": -1,
  "56654": -1,
  "56655": -8,
  "56657": 2,
  "56658": -1,
  "56659": 2,
  "56660": 0,
  "56661": 0,
  "56662": 0,
  "56663": 0,
  "56666": 1,
  "56667": 1,
  "56668": -1,
  "56669": 0,
  "56670": 1,
  "56671": 1,
  "56672": -8,
  "56673": -17,
  "56676": 5,
  "56678": 5,
  "56679": -1,
  "56680": 2,
  "56681": 0,
  "56682": -17,
  "56683": 10,
  "56684": 5,
  "56685": 1,
  "56686": -18,
  "56687": 1,
  "56688": 2,
  "56701": -6,
  "56710": 3,
  "56711": -9,
  "56713": 7,
  "56714": -17,
  "56715": -7,
  "56716": 5,
  "56720": -15,
  "56721": 12,
  "56722": 12,
  "56723": 13,
  "56724": -17,
  "56725": -6,
  "56726": -17,
  "56727": -6,
  "56728": -15,
  "56729": -15,
  "56731": -15,
  "56732": 7,
  "56733": -15,
  "56734": -15,
  "56735": -15,
  "56736": 13,
  "56737": 7,
  "56738": 7,
  "56740": -15,
  "56741": -9,
  "56742": -7,
  "56744": 3,
  "56748": -7,
  "56750": 5,
  "56751": -16,
  "56754": -6,
  "56755": -15,
  "56756": -17,
  "56757": 7,
  "56758": 7,
  "56759": -17,
  "56760": 7,
  "56761": -17,
  "56762": 7,
  "56763": -17,
  "57001": -1,
  "57002": -9,
  "57003": 9,
  "57004": -8,
  "57005": 9,
  "57006": -8,
  "57010": -1,
  "57012": -6,
  "57013": -4,
  "57014": -8,
  "57015": -12,
  "57016": -3,
  "57017": 0,
  "57018": -3,
  "57020": 9,
  "57021": -12,
  "57022": 8,
  "57024": -1,
  "57025": -1,
  "57026": -9,
  "57027": 5,
  "57028": 0,
  "57029": -4,
  "57030": 9,
  "57031": -10,
  "57032": 5,
  "57033": 9,
  "57034": -4,
  "57035": -3,
  "57036": -12,
  "57037": -8,
  "57038": -1,
  "57039": -4,
  "57040": -8,
  "57041": -3,
  "57042": -3,
  "57043": -12,
  "57045": -4,
  "57046": -8,
  "57047": -7,
  "57048": -6,
  "57049": 6,
  "57050": -3,
  "57051": -6,
  "57052": -4,
  "57053": -12,
  "57054": -3,
  "57055": 9,
  "57057": -4,
  "57058": -6,
  "57059": -7,
  "57061": -9,
  "57062": -7,
  "57063": -7,
  "57064": 4,
  "57065": 0,
  "57066": -7,
  "57067": -8,
  "57068": 2,
  "57069": -10,
  "57070": -12,
  "57071": -9,
  "57072": -8,
  "57073": -9,
  "57075": -3,
  "57076": -9,
  "57077": -3,
  "57078": -8,
  "57101": 1,
  "57103": 9,
  "57104": 1,
  "57105": 9,
  "57106": 9,
  "57107": 0,
  "57108": 9,
  "57109": 9,
  "57110": 9,
  "57117": 1,
  "57118": 1,
  "57201": -3,
  "57212": -6,
  "57213": -9,
  "57214": -7,
  "57216": 3,
  "57217": -12,
  "57218": -10,
  "57219": -8,
  "57220": -9,
  "57221": -6,
  "57223": -6,
  "57224": -18,
  "57225": -12,
  "57226": -10,
  "57227": 3,
  "57231": -6,
  "57232": -12,
  "57233": -6,
  "57234": -7,
  "57235": -3,
  "57236": -12,
  "57237": -10,
  "57238": -9,
  "57239": -8,
  "57241": -6,
  "57242": -6,
  "57243": -4,
  "57245": -3,
  "57246": -5,
  "57247": -12,
  "57248": -7,
  "57249": -6,
  "57251": -6,
  "57252": -5,
  "57255": -19,
  "57256": -4,
  "57257": -19,
  "57258": -12,
  "57259": -5,
  "57260": -9,
  "57261": -8,
  "57262": -19,
  "57263": -4,
  "57264": -5,
  "57265": -5,
  "57266": -19,
  "57268": -10,
  "57269": -4,
  "57270": -12,
  "57271": -12,
  "57272": -4,
  "57273": -8,
  "57274": -8,
  "57276": -9,
  "57278": -12,
  "57279": -6,
  "57301": -1,
  "57311": -11,
  "57312": -5,
  "57313": -6,
  "57314": -7,
  "57315": -7,
  "57317": -7,
  "57319": -7,
  "57321": -9,
  "57322": -12,
  "57323": -9,
  "57324": -5,
  "57325": -15,
  "57328": -6,
  "57329": -7,
  "57330": -6,
  "57331": -1,
  "57332": -11,
  "57334": -1,
  "57335": -7,
  "57337": -9,
  "57339": -20,
  "57340": -11,
  "57341": -15,
  "57342": -7,
  "57344": -6,
  "57345": -9,
  "57346": -9,
  "57348": -5,
  "57349": -9,
  "57350": -5,
  "57353": -6,
  "57354": -4,
  "57355": -15,
  "57356": -7,
  "57358": -7,
  "57359": -7,
  "57361": -7,
  "57362": -13,
  "57363": -2,
  "57364": -6,
  "57365": -15,
  "57366": -4,
  "57367": -5,
  "57368": -9,
  "57369": -15,
  "57370": -15,
  "57371": -9,
  "57373": -13,
  "57374": -11,
  "57375": -9,
  "57376": -4,
  "57379": -5,
  "57380": -7,
  "57381": -13,
  "57382": -9,
  "57383": -9,
  "57384": -5,
  "57385": -7,
  "57386": -5,
  "57401": -6,
  "57402": -6,
  "57420": -4,
  "57421": -12,
  "57422": -8,
  "57424": -12,
  "57426": -6,
  "57427": -5,
  "57428": -4,
  "57429": -12,
  "57430": -12,
  "57432": -6,
  "57433": -6,
  "57434": -12,
  "57435": -4,
  "57436": -12,
  "57437": -19,
  "57438": -4,
  "57439": -6,
  "57440": -12,
  "57441": -11,
  "57442": -3,
  "57445": -6,
  "57446": -11,
  "57448": -19,
  "57449": -11,
  "57450": -4,
  "57451": -4,
  "57452": -4,
  "57454": -12,
  "57455": -10,
  "57456": -6,
  "57457": -19,
  "57460": -6,
  "57461": -12,
  "57465": -12,
  "57466": -4,
  "57467": -13,
  "57468": -9,
  "57469": -12,
  "57470": -12,
  "57471": -4,
  "57472": -13,
  "57473": -4,
  "57474": -6,
  "57475": -4,
  "57476": -12,
  "57477": -12,
  "57479": -6,
  "57481": -6,
  "57501": -3,
  "57520": -4,
  "57521": -19,
  "57522": -4,
  "57523": -11,
  "57528": -11,
  "57529": -11,
  "57531": -6,
  "57532": -6,
  "57533": -11,
  "57534": -20,
  "57536": -9,
  "57537": -6,
  "57538": -7,
  "57540": -9,
  "57541": -11,
  "57543": -19,
  "57544": -20,
  "57547": -19,
  "57548": -20,
  "57551": -16,
  "57552": -17,
  "57553": -17,
  "57555": -14,
  "57559": -6,
  "57560": -14,
  "57562": -17,
  "57563": -14,
  "57564": -3,
  "57566": -14,
  "57567": -17,
  "57568": -21,
  "57569": -20,
  "57570": -14,
  "57571": -7,
  "57572": -15,
  "57574": -16,
  "57576": -21,
  "57577": -19,
  "57579": -14,
  "57580": -11,
  "57584": -12,
  "57585": -12,
  "57601": -13,
  "57620": -14,
  "57621": -8,
  "57622": -8,
  "57623": -13,
  "57625": -13,
  "57626": -14,
  "57630": -13,
  "57631": -13,
  "57632": -14,
  "57633": -13,
  "57634": -14,
  "57636": -13,
  "57638": 18,
  "57639": -8,
  "57640": -14,
  "57641": -8,
  "57642": -8,
  "57644": -14,
  "57645": -8,
  "57646": -14,
  "57648": -14,
  "57649": -14,
  "57650": -8,
  "57651": -8,
  "57652": -13,
  "57656": -13,
  "57657": -13,
  "57658": -14,
  "57659": -8,
  "57660": -8,
  "57661": -13,
  "57701": -5,
  "57702": -5,
  "57703": -5,
  "57706": -5,
  "57709": -5,
  "57714": -16,
  "57716": -18,
  "57717": -14,
  "57718": -5,
  "57719": -5,
  "57720": -8,
  "57722": -12,
  "57724": -8,
  "57725": -5,
  "57730": -14,
  "57732": -8,
  "57735": -12,
  "57737": 0,
  "57738": -14,
  "57741": -8,
  "57744": -5,
  "57745": -7,
  "57747": -12,
  "57748": 2,
  "57750": -19,
  "57751": -14,
  "57752": -18,
  "57754": -8,
  "57755": 1,
  "57756": -18,
  "57758": -8,
  "57759": -7,
  "57760": -14,
  "57761": -5,
  "57762": -14,
  "57763": -12,
  "57764": -18,
  "57766": -12,
  "57767": -19,
  "57769": -5,
  "57770": -18,
  "57772": -18,
  "57773": -14,
  "57775": -19,
  "57776": -8,
  "57779": -8,
  "57780": -18,
  "57782": -12,
  "57783": -7,
  "57785": -8,
  "57787": -8,
  "57788": -14,
  "57790": -19,
  "57791": -19,
  "57792": 2,
  "57793": -8,
  "57794": -18,
  "58001": -15,
  "58002": 2,
  "58004": 2,
  "58005": 2,
  "58006": 2,
  "58007": 2,
  "58008": -6,
  "58009": 1,
  "58011": 2,
  "58012": 2,
  "58013": 0,
  "58015": -4,
  "58016": 7,
  "58017": -1,
  "58018": -6,
  "58021": 3,
  "58027": -4,
  "58029": 2,
  "58030": -7,
  "58031": -4,
  "58032": 0,
  "58033": -4,
  "58035": 1,
  "58036": 2,
  "58038": 1,
  "58040": 0,
  "58041": -7,
  "58042": 10,
  "58043": 0,
  "58045": 1,
  "58046": 7,
  "58047": 10,
  "58048": 1,
  "58049": -4,
  "58051": 2,
  "58052": 2,
  "58053": -6,
  "58054": -4,
  "58056": 7,
  "58057": -4,
  "58058": -7,
  "58059": 2,
  "58060": 0,
  "58061": -6,
  "58062": -4,
  "58063": -4,
  "58064": 7,
  "58065": 7,
  "58067": 0,
  "58068": -4,
  "58069": 0,
  "58071": -4,
  "58072": -4,
  "58074": -14,
  "58075": -14,
  "58077": -6,
  "58078": 10,
  "58079": 2,
  "58081": -6,
  "58102": 3,
  "58103": 3,
  "58104": 10,
  "58105": 3,
  "58106": 3,
  "58107": 10,
  "58108": 3,
  "58109": 10,
  "58201": 12,
  "58202": 5,
  "58203": 5,
  "58204": 3,
  "58205": 3,
  "58206": 12,
  "58208": 12,
  "58210": -7,
  "58212": -4,
  "58214": 3,
  "58216": 4,
  "58218": 1,
  "58219": 1,
  "58220": 5,
  "58222": 5,
  "58223": 1,
  "58224": -7,
  "58225": 5,
  "58227": -7,
  "58228": 3,
  "58229": -7,
  "58230": 7,
  "58231": -7,
  "58233": -7,
  "58235": 3,
  "58236": 13,
  "58237": -6,
  "58238": 5,
  "58239": -7,
  "58240": 8,
  "58241": 5,
  "58243": -7,
  "58244": -7,
  "58249": -6,
  "58250": -7,
  "58251": 3,
  "58254": -4,
  "58255": -6,
  "58256": 3,
  "58257": 1,
  "58258": 3,
  "58259": -4,
  "58260": -7,
  "58261": -6,
  "58262": 4,
  "58265": 4,
  "58266": -3,
  "58267": 3,
  "58269": -7,
  "58270": -6,
  "58271": 5,
  "58272": -4,
  "58273": -7,
  "58274": 1,
  "58275": 1,
  "58276": 4,
  "58277": 7,
  "58278": 12,
  "58281": -7,
  "58282": 4,
  "58301": -11,
  "58310": -14,
  "58311": -7,
  "58313": -3,
  "58316": -14,
  "58317": -14,
  "58318": -11,
  "58321": -12,
  "58323": -7,
  "58324": -11,
  "58325": 6,
  "58327": -11,
  "58329": -14,
  "58330": -12,
  "58331": -7,
  "58332": -3,
  "58335": -18,
  "58338": -7,
  "58339": -14,
  "58341": -9,
  "58343": -3,
  "58344": -3,
  "58345": -12,
  "58346": 5,
  "58348": 4,
  "58351": 5,
  "58352": -7,
  "58353": -14,
  "58355": -7,
  "58356": -18,
  "58357": 5,
  "58361": -4,
  "58362": -12,
  "58363": -14,
  "58365": -14,
  "58366": -14,
  "58367": -13,
  "58368": -2,
  "58369": -13,
  "58370": -18,
  "58372": -7,
  "58374": -18,
  "58377": -12,
  "58379": -18,
  "58380": -4,
  "58381": -18,
  "58382": -12,
  "58384": -14,
  "58385": -3,
  "58386": -3,
  "58401": 4,
  "58402": 4,
  "58413": -16,
  "58415": -12,
  "58416": -21,
  "58418": -10,
  "58420": 4,
  "58421": -7,
  "58422": -9,
  "58423": -10,
  "58424": 4,
  "58425": -21,
  "58426": -7,
  "58428": -12,
  "58429": -21,
  "58430": -9,
  "58431": -13,
  "58433": -12,
  "58436": -11,
  "58438": -10,
  "58439": -9,
  "58440": -16,
  "58441": -11,
  "58442": 4,
  "58443": -7,
  "58444": -10,
  "58445": -7,
  "58448": -21,
  "58451": -10,
  "58452": -21,
  "58454": -13,
  "58455": -7,
  "58456": -13,
  "58458": -12,
  "58460": -16,
  "58461": -4,
  "58463": -4,
  "58464": -7,
  "58466": -4,
  "58467": 4,
  "58472": -12,
  "58474": -11,
  "58475": -12,
  "58476": 4,
  "58477": -2,
  "58478": -12,
  "58479": -4,
  "58480": -4,
  "58481": -4,
  "58482": -12,
  "58483": -12,
  "58484": -21,
  "58486": -10,
  "58487": -12,
  "58488": -12,
  "58490": -4,
  "58492": -21,
  "58494": -2,
  "58495": -16,
  "58496": 4,
  "58497": 4,
  "58501": 7,
  "58502": 7,
  "58503": 7,
  "58504": 7,
  "58505": 7,
  "58506": 7,
  "58507": 7,
  "58520": -5,
  "58521": 7,
  "58523": 16,
  "58524": -2,
  "58528": -8,
  "58529": -5,
  "58530": -2,
  "58531": -4,
  "58532": -12,
  "58533": -8,
  "58535": -5,
  "58538": -8,
  "58540": -4,
  "58541": 14,
  "58542": -16,
  "58544": -2,
  "58545": 14,
  "58549": -2,
  "58552": -8,
  "58554": 7,
  "58558": 7,
  "58559": -4,
  "58560": -2,
  "58561": -16,
  "58562": -8,
  "58563": -5,
  "58564": -8,
  "58565": -4,
  "58566": 4,
  "58568": -8,
  "58569": -8,
  "58570": -8,
  "58571": 14,
  "58572": -2,
  "58573": -8,
  "58575": -4,
  "58576": -4,
  "58577": 5,
  "58579": -2,
  "58580": 14,
  "58581": -16,
  "58601": 19,
  "58602": 19,
  "58620": -11,
  "58621": 1,
  "58622": 10,
  "58623": -11,
  "58625": 14,
  "58626": 10,
  "58627": 10,
  "58630": 12,
  "58631": -8,
  "58632": 1,
  "58634": 1,
  "58636": 14,
  "58638": 10,
  "58639": 18,
  "58640": 10,
  "58641": 19,
  "58642": 12,
  "58643": -11,
  "58644": 14,
  "58645": 1,
  "58646": 18,
  "58647": 10,
  "58649": 18,
  "58650": 18,
  "58651": -11,
  "58652": 10,
  "58653": -11,
  "58654": 0,
  "58655": 10,
  "58656": 10,
  "58701": 8,
  "58702": 8,
  "58703": 8,
  "58704": 8,
  "58705": 8,
  "58710": -3,
  "58711": -2,
  "58712": -12,
  "58713": -11,
  "58716": -2,
  "58718": -1,
  "58721": -3,
  "58722": 8,
  "58723": -4,
  "58725": -2,
  "58727": -3,
  "58730": -3,
  "58731": -12,
  "58733": -1,
  "58734": -2,
  "58735": -4,
  "58736": -12,
  "58737": -3,
  "58740": -1,
  "58741": -12,
  "58744": -12,
  "58746": -1,
  "58748": -11,
  "58750": -1,
  "58752": -3,
  "58755": -3,
  "58756": -1,
  "58757": 6,
  "58758": -9,
  "58759": -4,
  "58760": -2,
  "58761": -1,
  "58762": -11,
  "58763": 6,
  "58765": -3,
  "58768": -3,
  "58769": 6,
  "58770": 6,
  "58771": 5,
  "58772": -3,
  "58773": -3,
  "58775": -4,
  "58776": 6,
  "58778": -2,
  "58779": -4,
  "58781": -1,
  "58782": -1,
  "58783": -11,
  "58784": 6,
  "58785": 8,
  "58787": -2,
  "58788": -12,
  "58789": -11,
  "58790": -12,
  "58792": -12,
  "58793": -11,
  "58794": 17,
  "58795": 16,
  "58801": 17,
  "58802": 17,
  "58830": 16,
  "58831": 17,
  "58833": 16,
  "58835": 17,
  "58838": 17,
  "58843": 17,
  "58844": 16,
  "58845": 16,
  "58847": 6,
  "58849": 17,
  "58852": 17,
  "58853": 17,
  "58854": 17,
  "58856": 17,
  "59001": -11,
  "59002": 3,
  "59003": -10,
  "59006": 3,
  "59007": -11,
  "59008": -11,
  "59010": -15,
  "59011": -12,
  "59012": -10,
  "59013": -11,
  "59014": -11,
  "59015": 3,
  "59016": 2,
  "59018": -6,
  "59019": -11,
  "59020": -11,
  "59022": 2,
  "59024": 3,
  "59025": -10,
  "59026": -11,
  "59027": 2,
  "59028": -11,
  "59029": -11,
  "59030": -6,
  "59031": 3,
  "59032": -3,
  "59033": -12,
  "59034": 3,
  "59035": 3,
  "59036": 0,
  "59037": 3,
  "59038": -15,
  "59039": -13,
  "59041": -11,
  "59043": -10,
  "59044": 3,
  "59046": 3,
  "59047": -6,
  "59050": 3,
  "59052": -1,
  "59053": -1,
  "59054": -15,
  "59055": -12,
  "59057": 3,
  "59058": -3,
  "59059": -14,
  "59061": -12,
  "59062": -10,
  "59063": -11,
  "59064": 3,
  "59065": -6,
  "59066": -11,
  "59067": -12,
  "59068": -11,
  "59069": -12,
  "59070": -11,
  "59071": -11,
  "59072": -14,
  "59073": -14,
  "59074": 0,
  "59075": 3,
  "59076": -10,
  "59077": -6,
  "59078": 0,
  "59079": 3,
  "59081": -11,
  "59082": -1,
  "59083": -13,
  "59084": -3,
  "59085": -1,
  "59086": -6,
  "59087": -3,
  "59088": 3,
  "59089": 3,
  "59101": 3,
  "59102": 3,
  "59103": 3,
  "59104": 3,
  "59105": 3,
  "59106": 3,
  "59107": 3,
  "59108": 3,
  "59201": -17,
  "59211": -17,
  "59212": 0,
  "59213": -9,
  "59214": -15,
  "59215": -15,
  "59217": 0,
  "59218": -17,
  "59219": 16,
  "59221": 0,
  "59222": -17,
  "59223": -10,
  "59225": -11,
  "59226": -18,
  "59230": -10,
  "59231": -11,
  "59240": -11,
  "59241": -11,
  "59242": -9,
  "59243": 0,
  "59244": -11,
  "59247": -18,
  "59248": -11,
  "59250": -11,
  "59252": -17,
  "59253": -11,
  "59254": -17,
  "59255": -17,
  "59256": -17,
  "59257": -18,
  "59258": -17,
  "59259": 0,
  "59260": -11,
  "59261": -11,
  "59262": 0,
  "59263": -17,
  "59270": 0,
  "59273": -11,
  "59274": -15,
  "59275": 16,
  "59276": -18,
  "59301": -9,
  "59311": -13,
  "59312": -9,
  "59313": 0,
  "59314": -10,
  "59315": -11,
  "59316": -7,
  "59317": -9,
  "59318": -11,
  "59319": -13,
  "59322": -14,
  "59323": -9,
  "59324": 0,
  "59326": -5,
  "59327": -9,
  "59330": -11,
  "59332": -7,
  "59333": -9,
  "59336": 1,
  "59337": -15,
  "59338": -9,
  "59339": -11,
  "59341": -5,
  "59343": -9,
  "59344": 0,
  "59345": -9,
  "59347": -9,
  "59349": -6,
  "59351": -9,
  "59353": 1,
  "59354": 0,
  "59401": -3,
  "59402": -3,
  "59403": -3,
  "59404": -3,
  "59405": -3,
  "59406": -3,
  "59410": -14,
  "59411": -7,
  "59412": -3,
  "59414": -3,
  "59416": -14,
  "59417": -7,
  "59418": -1,
  "59419": -5,
  "59420": -14,
  "59421": -3,
  "59422": -14,
  "59424": 8,
  "59425": -12,
  "59427": -7,
  "59430": -1,
  "59432": -12,
  "59433": -14,
  "59434": -6,
  "59435": -12,
  "59436": -13,
  "59440": -3,
  "59441": -2,
  "59442": -14,
  "59443": -13,
  "59444": -12,
  "59446": -14,
  "59447": -1,
  "59448": -7,
  "59450": -13,
  "59451": -3,
  "59452": -1,
  "59453": -1,
  "59454": -12,
  "59456": -12,
  "59457": -3,
  "59460": -14,
  "59461": -5,
  "59462": -1,
  "59463": 0,
  "59464": -3,
  "59465": 0,
  "59466": -12,
  "59467": -12,
  "59468": -3,
  "59469": -1,
  "59471": -3,
  "59472": -3,
  "59474": -12,
  "59477": -14,
  "59479": -1,
  "59480": -3,
  "59482": -7,
  "59483": -3,
  "59484": -7,
  "59485": -3,
  "59486": -12,
  "59487": -3,
  "59489": -3,
  "59501": -5,
  "59520": -14,
  "59521": -5,
  "59522": -5,
  "59523": -14,
  "59524": -11,
  "59525": -5,
  "59526": -14,
  "59527": -14,
  "59528": -5,
  "59529": -14,
  "59530": -5,
  "59531": -5,
  "59532": -5,
  "59535": -14,
  "59537": -11,
  "59538": -11,
  "59540": -5,
  "59542": -14,
  "59544": -11,
  "59545": -5,
  "59546": -14,
  "59547": -14,
  "59601": -3,
  "59602": -3,
  "59604": -3,
  "59620": -3,
  "59624": -3,
  "59626": -3,
  "59631": -8,
  "59632": -9,
  "59633": -3,
  "59634": 5,
  "59635": -3,
  "59636": -3,
  "59638": -8,
  "59639": -12,
  "59640": -3,
  "59641": -10,
  "59642": -10,
  "59643": -10,
  "59644": -10,
  "59645": -10,
  "59647": -10,
  "59648": -3,
  "59701": -5,
  "59702": -5,
  "59703": -5,
  "59710": -2,
  "59711": -4,
  "59713": -13,
  "59714": 2,
  "59715": 2,
  "59716": 2,
  "59717": 2,
  "59718": 2,
  "59719": 2,
  "59720": -3,
  "59721": -7,
  "59722": -13,
  "59724": -11,
  "59725": -10,
  "59727": -5,
  "59728": -13,
  "59729": -1,
  "59730": 3,
  "59731": -13,
  "59732": -5,
  "59733": -11,
  "59735": -2,
  "59736": -10,
  "59739": -11,
  "59740": 6,
  "59741": 10,
  "59743": -5,
  "59745": 6,
  "59746": -1,
  "59747": -3,
  "59748": -5,
  "59749": -2,
  "59750": -5,
  "59751": -5,
  "59752": 2,
  "59754": -2,
  "59755": -2,
  "59756": -4,
  "59758": -12,
  "59759": -8,
  "59760": 2,
  "59761": -10,
  "59762": -4,
  "59771": 2,
  "59772": 2,
  "59801": 0,
  "59802": 0,
  "59803": 0,
  "59804": 0,
  "59806": 0,
  "59807": 0,
  "59808": 0,
  "59820": 0,
  "59821": 0,
  "59823": 0,
  "59824": -10,
  "59825": 0,
  "59826": -10,
  "59827": -9,
  "59828": -9,
  "59829": -9,
  "59830": -6,
  "59831": -11,
  "59832": -8,
  "59833": 0,
  "59834": 0,
  "59835": -9,
  "59837": -8,
  "59840": -9,
  "59841": -9,
  "59842": -6,
  "59843": -12,
  "59844": -8,
  "59845": -6,
  "59846": -11,
  "59847": 0,
  "59848": -6,
  "59851": 0,
  "59853": -8,
  "59854": -12,
  "59855": -11,
  "59856": -6,
  "59858": -8,
  "59859": -6,
  "59860": -10,
  "59863": -11,
  "59864": -11,
  "59865": -11,
  "59866": -11,
  "59867": -6,
  "59868": 0,
  "59870": -9,
  "59871": -9,
  "59872": -11,
  "59873": -6,
  "59874": -7,
  "59875": -9,
  "59901": -4,
  "59903": -4,
  "59904": -4,
  "59910": -10,
  "59911": -10,
  "59912": -4,
  "59913": -4,
  "59914": -2,
  "59915": -10,
  "59916": -3,
  "59917": -8,
  "59918": -7,
  "59919": -4,
  "59920": -3,
  "59921": -3,
  "59922": -3,
  "59923": -8,
  "59925": -3,
  "59926": -4,
  "59927": -4,
  "59928": -3,
  "59929": -11,
  "59930": -8,
  "59931": -2,
  "59932": -3,
  "59933": -7,
  "59934": -7,
  "59935": -8,
  "59936": -3,
  "59937": -3,
  "60001": 10,
  "60002": -1,
  "60004": 10,
  "60005": 15,
  "60006": 10,
  "60007": 15,
  "60008": 14,
  "60009": 15,
  "60010": 21,
  "60011": 10,
  "60012": 10,
  "60013": 10,
  "60014": 10,
  "60015": 11,
  "60016": 15,
  "60017": 15,
  "60018": 15,
  "60020": 9,
  "60021": 10,
  "60022": 21,
  "60025": 15,
  "60026": 15,
  "60029": 19,
  "60030": 9,
  "60031": 9,
  "60033": 3,
  "60034": 10,
  "60035": 12,
  "60037": 20,
  "60039": 10,
  "60040": 9,
  "60041": 9,
  "60042": 10,
  "60043": 26,
  "60044": 12,
  "60045": 20,
  "60046": 9,
  "60047": 11,
  "60048": 9,
  "60050": 9,
  "60051": 9,
  "60053": 15,
  "60056": 15,
  "60060": 9,
  "60061": 9,
  "60062": 13,
  "60064": 9,
  "60065": 20,
  "60067": 10,
  "60068": 15,
  "60069": 12,
  "60070": 10,
  "60071": 18,
  "60072": 9,
  "60073": 9,
  "60074": 9,
  "60075": 9,
  "60076": 15,
  "60077": 15,
  "60078": 10,
  "60079": 9,
  "60081": 9,
  "60082": 13,
  "60083": 9,
  "60084": 9,
  "60085": 9,
  "60087": 9,
  "60088": 8,
  "60089": 9,
  "60090": 10,
  "60091": 18,
  "60092": 10,
  "60093": 26,
  "60094": 15,
  "60095": 14,
  "60096": -1,
  "60097": 10,
  "60098": 10,
  "60099": 9,
  "60101": 14,
  "60102": 10,
  "60103": 9,
  "60104": 14,
  "60106": 15,
  "60107": 9,
  "60108": 15,
  "60109": 10,
  "60110": 10,
  "60111": 17,
  "60112": 16,
  "60113": 15,
  "60115": 16,
  "60118": 10,
  "60119": 10,
  "60120": 9,
  "60121": 9,
  "60123": 9,
  "60124": 9,
  "60126": 15,
  "60129": 16,
  "60130": 15,
  "60131": 15,
  "60133": 9,
  "60134": 10,
  "60135": 16,
  "60136": 10,
  "60137": 15,
  "60138": 15,
  "60139": 14,
  "60140": 10,
  "60141": 14,
  "60142": 10,
  "60143": 15,
  "60144": 10,
  "60145": 13,
  "60146": 5,
  "60147": 10,
  "60148": 14,
  "60150": 16,
  "60151": 24,
  "60152": 5,
  "60153": 14,
  "60154": 15,
  "60155": 14,
  "60156": 10,
  "60157": 15,
  "60159": 14,
  "60160": 15,
  "60161": 15,
  "60162": 15,
  "60163": 15,
  "60164": 15,
  "60165": 15,
  "60168": 14,
  "60169": 14,
  "60170": 9,
  "60171": 15,
  "60172": 14,
  "60173": 14,
  "60174": 10,
  "60175": 20,
  "60176": 15,
  "60177": 9,
  "60178": 16,
  "60180": 10,
  "60181": 15,
  "60183": 20,
  "60184": 21,
  "60185": 9,
  "60186": 9,
  "60187": 15,
  "60188": 14,
  "60189": 15,
  "60190": 15,
  "60191": 15,
  "60192": 15,
  "60193": 14,
  "60194": 14,
  "60195": 15,
  "60197": 14,
  "60199": 14,
  "60201": 15,
  "60202": 15,
  "60203": 15,
  "60204": 15,
  "60301": 15,
  "60302": 15,
  "60303": 15,
  "60304": 15,
  "60305": 26,
  "60401": 10,
  "60402": 15,
  "60403": 15,
  "60404": 11,
  "60406": 12,
  "60407": 25,
  "60408": 26,
  "60409": 5,
  "60410": 11,
  "60411": 5,
  "60412": 5,
  "60415": 14,
  "60416": 26,
  "60417": 6,
  "60419": 5,
  "60420": -3,
  "60421": 11,
  "60422": 13,
  "60423": 11,
  "60424": 25,
  "60425": 5,
  "60426": 5,
  "60428": 5,
  "60429": 5,
  "60430": 5,
  "60431": 11,
  "60432": 11,
  "60433": 11,
  "60434": 11,
  "60435": 11,
  "60436": 11,
  "60437": 26,
  "60438": 5,
  "60439": 14,
  "60440": 14,
  "60441": 11,
  "60442": 11,
  "60443": 10,
  "60444": 26,
  "60445": 13,
  "60446": 11,
  "60447": 26,
  "60448": 11,
  "60449": 11,
  "60450": 26,
  "60451": 11,
  "60452": 10,
  "60453": 15,
  "60454": 15,
  "60455": 15,
  "60456": 14,
  "60457": 15,
  "60458": 15,
  "60459": 15,
  "60460": -3,
  "60461": 14,
  "60462": 11,
  "60463": 15,
  "60464": 15,
  "60465": 15,
  "60466": 5,
  "60467": 20,
  "60468": 10,
  "60469": 12,
  "60470": 5,
  "60471": 10,
  "60472": 12,
  "60473": 5,
  "60474": 25,
  "60475": 5,
  "60476": 5,
  "60477": 11,
  "60478": 9,
  "60479": 26,
  "60480": 15,
  "60481": 26,
  "60482": 15,
  "60484": 5,
  "60487": 11,
  "60490": 14,
  "60491": 11,
  "60499": 15,
  "60501": 14,
  "60502": 14,
  "60503": 14,
  "60504": 14,
  "60505": 4,
  "60506": 4,
  "60507": 9,
  "60510": 10,
  "60511": 4,
  "60512": 4,
  "60513": 15,
  "60514": 15,
  "60515": 14,
  "60516": 15,
  "60517": 14,
  "60518": 6,
  "60519": 14,
  "60520": 24,
  "60521": 15,
  "60522": 26,
  "60523": 15,
  "60525": 15,
  "60526": 15,
  "60527": 26,
  "60530": 16,
  "60531": 5,
  "60532": 14,
  "60534": 15,
  "60536": 4,
  "60537": 4,
  "60538": 4,
  "60539": 9,
  "60540": 16,
  "60541": 4,
  "60542": 9,
  "60543": 4,
  "60544": 11,
  "60545": 4,
  "60546": 15,
  "60548": 4,
  "60549": 6,
  "60550": 16,
  "60551": 4,
  "60552": 6,
  "60553": 16,
  "60554": 4,
  "60555": 14,
  "60556": 16,
  "60557": 6,
  "60558": 26,
  "60559": 15,
  "60560": 4,
  "60561": 16,
  "60563": 14,
  "60564": 23,
  "60565": 16,
  "60566": 16,
  "60567": 14,
  "60585": 11,
  "60586": 11,
  "60598": 14,
  "60599": 4,
  "60601": 15,
  "60602": 15,
  "60603": 15,
  "60604": 15,
  "60605": 15,
  "60606": 15,
  "60607": 15,
  "60608": 15,
  "60609": 14,
  "60610": 15,
  "60611": 15,
  "60612": 15,
  "60613": 15,
  "60614": 26,
  "60615": 15,
  "60616": 15,
  "60617": 12,
  "60618": 15,
  "60619": 14,
  "60620": 14,
  "60621": 14,
  "60622": 15,
  "60623": 14,
  "60624": 14,
  "60625": 15,
  "60626": 15,
  "60628": 12,
  "60629": 14,
  "60630": 15,
  "60631": 15,
  "60632": 15,
  "60633": 5,
  "60634": 15,
  "60636": 14,
  "60637": 14,
  "60638": 15,
  "60639": 15,
  "60640": 15,
  "60641": 15,
  "60642": 15,
  "60643": 14,
  "60644": 14,
  "60645": 15,
  "60646": 15,
  "60647": 15,
  "60649": 14,
  "60651": 14,
  "60652": 14,
  "60653": 15,
  "60654": 15,
  "60655": 15,
  "60656": 15,
  "60657": 16,
  "60659": 15,
  "60660": 15,
  "60661": 15,
  "60664": 15,
  "60666": 15,
  "60680": 15,
  "60681": 15,
  "60690": 15,
  "60691": 15,
  "60699": 15,
  "60701": 15,
  "60706": 15,
  "60707": 15,
  "60712": 15,
  "60714": 15,
  "60803": 15,
  "60804": 14,
  "60805": 15,
  "60827": 12,
  "60901": 1,
  "60910": 1,
  "60911": 1,
  "60912": 1,
  "60913": 10,
  "60914": 1,
  "60915": 1,
  "60917": 1,
  "60918": -1,
  "60919": -3,
  "60920": -3,
  "60921": -3,
  "60922": 1,
  "60924": 2,
  "60926": 0,
  "60927": 1,
  "60928": 1,
  "60929": -3,
  "60930": 1,
  "60931": 0,
  "60932": -3,
  "60933": -2,
  "60934": -3,
  "60935": 25,
  "60936": -2,
  "60938": 0,
  "60939": 0,
  "60940": 10,
  "60941": 1,
  "60942": -4,
  "60944": 1,
  "60945": 0,
  "60946": -3,
  "60948": 8,
  "60949": -1,
  "60950": 1,
  "60951": 1,
  "60952": -2,
  "60953": 0,
  "60954": 1,
  "60955": 1,
  "60956": 1,
  "60957": -1,
  "60958": 10,
  "60959": -3,
  "60960": -1,
  "60961": 25,
  "60962": -2,
  "60963": -4,
  "60964": 1,
  "60966": 0,
  "60967": 0,
  "60968": -3,
  "60969": 1,
  "60970": 0,
  "60973": 0,
  "60974": 0,
  "61001": 4,
  "61006": -11,
  "61007": 13,
  "61008": 3,
  "61010": 3,
  "61011": 12,
  "61012": 3,
  "61013": 12,
  "61014": -10,
  "61015": 2,
  "61016": 3,
  "61018": 13,
  "61019": 12,
  "61020": 2,
  "61021": -13,
  "61024": 4,
  "61025": -1,
  "61027": 13,
  "61028": -4,
  "61030": 2,
  "61031": -11,
  "61032": 12,
  "61036": 4,
  "61037": 2,
  "61038": 12,
  "61039": 13,
  "61041": -5,
  "61042": -11,
  "61043": 2,
  "61044": 13,
  "61046": -10,
  "61047": 2,
  "61048": 13,
  "61049": 2,
  "61050": 12,
  "61051": -10,
  "61052": 4,
  "61053": -10,
  "61054": 2,
  "61057": -11,
  "61059": -5,
  "61060": 12,
  "61061": 2,
  "61062": 13,
  "61063": 4,
  "61064": 2,
  "61065": 3,
  "61067": 13,
  "61068": 3,
  "61070": 13,
  "61071": 2,
  "61072": 4,
  "61073": 4,
  "61074": -10,
  "61075": -4,
  "61077": 10,
  "61078": -10,
  "61079": 4,
  "61080": 9,
  "61081": 2,
  "61084": 2,
  "61085": -5,
  "61087": -5,
  "61088": 4,
  "61089": 12,
  "61091": -13,
  "61101": 4,
  "61102": 4,
  "61103": 4,
  "61104": 4,
  "61105": 4,
  "61106": 4,
  "61107": 4,
  "61108": 4,
  "61109": 4,
  "61110": 4,
  "61111": 4,
  "61112": 3,
  "61114": 4,
  "61115": 4,
  "61125": 4,
  "61126": 4,
  "61130": 4,
  "61131": 4,
  "61132": 4,
  "61201": 9,
  "61204": 9,
  "61230": 2,
  "61231": -1,
  "61232": 9,
  "61233": 4,
  "61234": 4,
  "61235": 4,
  "61236": 9,
  "61237": 7,
  "61238": 4,
  "61239": 9,
  "61240": 17,
  "61241": 9,
  "61242": 9,
  "61243": 3,
  "61244": 9,
  "61250": 2,
  "61251": 2,
  "61252": 2,
  "61254": 12,
  "61256": 9,
  "61257": 5,
  "61258": 2,
  "61259": 7,
  "61260": -2,
  "61261": 2,
  "61262": 6,
  "61263": -2,
  "61264": 9,
  "61265": 9,
  "61266": 9,
  "61270": 3,
  "61272": -2,
  "61273": 10,
  "61274": 5,
  "61275": 17,
  "61276": -2,
  "61277": 2,
  "61278": 17,
  "61279": 0,
  "61281": 9,
  "61282": 9,
  "61283": 2,
  "61284": 17,
  "61285": -10,
  "61301": 6,
  "61310": -11,
  "61311": -1,
  "61312": 0,
  "61313": -1,
  "61314": -2,
  "61315": -3,
  "61316": 4,
  "61317": 0,
  "61318": -11,
  "61319": -1,
  "61320": 6,
  "61321": -2,
  "61322": -3,
  "61323": -2,
  "61324": -11,
  "61325": 5,
  "61326": -2,
  "61327": -2,
  "61328": 0,
  "61329": 0,
  "61330": 0,
  "61331": -11,
  "61332": 4,
  "61333": -1,
  "61334": -3,
  "61335": -3,
  "61336": -3,
  "61337": 0,
  "61338": -2,
  "61340": -2,
  "61341": 5,
  "61342": 6,
  "61344": 4,
  "61345": -6,
  "61346": -2,
  "61348": 6,
  "61349": 0,
  "61350": 6,
  "61353": 16,
  "61354": 6,
  "61356": -2,
  "61358": -2,
  "61359": 0,
  "61360": 26,
  "61361": -2,
  "61362": -2,
  "61363": 4,
  "61364": 6,
  "61367": -11,
  "61368": -2,
  "61369": -3,
  "61370": 4,
  "61371": 6,
  "61372": 6,
  "61373": 6,
  "61374": 0,
  "61375": -3,
  "61376": -2,
  "61377": -3,
  "61378": -10,
  "61379": -2,
  "61401": -6,
  "61402": -6,
  "61410": -6,
  "61411": -8,
  "61412": -2,
  "61413": 4,
  "61414": -6,
  "61415": -10,
  "61416": -5,
  "61417": -14,
  "61418": -14,
  "61419": 4,
  "61420": -4,
  "61421": -6,
  "61422": -4,
  "61423": -14,
  "61424": -6,
  "61425": -14,
  "61426": -7,
  "61427": -10,
  "61428": -6,
  "61430": -6,
  "61431": -10,
  "61432": -10,
  "61433": -10,
  "61434": 4,
  "61435": -14,
  "61436": -6,
  "61437": -14,
  "61438": -4,
  "61439": -6,
  "61440": -4,
  "61441": -10,
  "61442": -2,
  "61443": -6,
  "61447": -14,
  "61448": -6,
  "61449": -6,
  "61450": -5,
  "61451": -6,
  "61452": -8,
  "61453": -14,
  "61454": -14,
  "61455": -4,
  "61458": -6,
  "61459": -10,
  "61460": -14,
  "61462": -14,
  "61465": -1,
  "61466": -6,
  "61467": -6,
  "61468": 4,
  "61469": -14,
  "61470": -5,
  "61471": -14,
  "61472": -5,
  "61473": -14,
  "61474": -6,
  "61475": -4,
  "61476": -2,
  "61477": -10,
  "61478": -14,
  "61479": -6,
  "61480": -14,
  "61482": -4,
  "61483": -6,
  "61484": -8,
  "61485": -6,
  "61486": -2,
  "61488": -6,
  "61489": -6,
  "61490": 4,
  "61491": -6,
  "61501": -8,
  "61516": 7,
  "61517": 4,
  "61519": -10,
  "61520": 3,
  "61523": 3,
  "61524": -10,
  "61525": 11,
  "61526": 11,
  "61528": 11,
  "61529": 3,
  "61530": 6,
  "61531": -10,
  "61532": -12,
  "61533": 3,
  "61534": 0,
  "61535": 8,
  "61536": 3,
  "61537": -3,
  "61539": 0,
  "61540": -3,
  "61541": -4,
  "61542": -12,
  "61543": -12,
  "61544": -10,
  "61545": 6,
  "61546": -12,
  "61547": 11,
  "61548": 14,
  "61550": 8,
  "61552": 3,
  "61553": -10,
  "61554": 0,
  "61555": 0,
  "61559": -6,
  "61560": -2,
  "61561": 6,
  "61562": 3,
  "61563": -10,
  "61564": 0,
  "61565": -3,
  "61567": -12,
  "61568": 8,
  "61569": 3,
  "61570": -3,
  "61571": 0,
  "61572": -6,
  "61601": 3,
  "61602": 3,
  "61603": 3,
  "61604": 3,
  "61605": 2,
  "61606": 3,
  "61607": 3,
  "61610": 0,
  "61611": 3,
  "61612": 3,
  "61614": 3,
  "61615": 4,
  "61616": 3,
  "61650": 8,
  "61651": 3,
  "61652": 3,
  "61653": 3,
  "61654": 3,
  "61655": 3,
  "61656": 3,
  "61701": 2,
  "61702": 4,
  "61704": 11,
  "61705": 11,
  "61720": 0,
  "61721": -5,
  "61722": 2,
  "61723": -5,
  "61724": 2,
  "61725": 9,
  "61726": -1,
  "61727": 3,
  "61728": 3,
  "61729": 9,
  "61730": 3,
  "61731": 0,
  "61732": 3,
  "61733": 0,
  "61734": 0,
  "61735": 5,
  "61736": 3,
  "61737": 2,
  "61738": 7,
  "61739": -1,
  "61740": -1,
  "61741": -1,
  "61742": 9,
  "61743": -2,
  "61744": 3,
  "61745": 5,
  "61747": 0,
  "61748": 4,
  "61749": 2,
  "61750": 2,
  "61751": -5,
  "61752": 3,
  "61753": 3,
  "61754": 5,
  "61755": 8,
  "61756": 2,
  "61758": 11,
  "61759": 1,
  "61760": 7,
  "61761": 3,
  "61764": -1,
  "61769": -3,
  "61770": -1,
  "61771": 7,
  "61772": 2,
  "61773": -1,
  "61774": 2,
  "61775": 0,
  "61776": 3,
  "61777": 5,
  "61778": 5,
  "61801": 5,
  "61802": 3,
  "61803": 5,
  "61810": 0,
  "61811": -4,
  "61812": -4,
  "61813": -9,
  "61814": -4,
  "61815": 2,
  "61816": 0,
  "61817": -3,
  "61818": -9,
  "61820": 2,
  "61821": 3,
  "61822": 11,
  "61824": 2,
  "61825": 2,
  "61826": 11,
  "61830": -8,
  "61831": -3,
  "61832": -4,
  "61833": -4,
  "61834": -4,
  "61839": -8,
  "61840": 3,
  "61841": -4,
  "61842": 4,
  "61843": 3,
  "61844": -4,
  "61845": -1,
  "61846": -4,
  "61847": 3,
  "61848": -4,
  "61849": 3,
  "61850": -4,
  "61851": -8,
  "61852": 0,
  "61853": 3,
  "61854": -7,
  "61855": -9,
  "61856": -7,
  "61857": -4,
  "61858": -4,
  "61859": 3,
  "61862": 3,
  "61863": -1,
  "61864": 12,
  "61865": -4,
  "61866": 3,
  "61870": 11,
  "61871": 3,
  "61872": -8,
  "61873": 12,
  "61874": 11,
  "61875": 3,
  "61876": -5,
  "61877": 4,
  "61878": 3,
  "61880": 3,
  "61882": 2,
  "61883": -4,
  "61884": -6,
  "61910": -1,
  "61911": 2,
  "61912": -4,
  "61913": -1,
  "61914": 2,
  "61917": -6,
  "61919": 0,
  "61920": 0,
  "61924": -6,
  "61925": -3,
  "61928": 2,
  "61929": 2,
  "61930": 0,
  "61931": -3,
  "61932": -5,
  "61933": -6,
  "61936": 2,
  "61937": 2,
  "61938": -4,
  "61940": -5,
  "61941": 0,
  "61942": 0,
  "61943": 0,
  "61944": -6,
  "61949": -6,
  "61951": 3,
  "61953": 0,
  "61955": -6,
  "61956": 0,
  "61957": -13,
  "62001": 3,
  "62002": 2,
  "62006": 3,
  "62009": -6,
  "62010": 2,
  "62011": -12,
  "62012": -9,
  "62013": 3,
  "62014": -6,
  "62015": -8,
  "62016": -15,
  "62017": -8,
  "62018": 2,
  "62019": -4,
  "62021": 11,
  "62022": -8,
  "62023": -6,
  "62024": 2,
  "62025": 3,
  "62027": -12,
  "62028": -8,
  "62030": -10,
  "62031": -7,
  "62032": -8,
  "62033": -6,
  "62034": 4,
  "62035": -8,
  "62036": 3,
  "62037": -7,
  "62040": 2,
  "62044": -15,
  "62045": 3,
  "62046": 2,
  "62047": -7,
  "62048": 2,
  "62049": -8,
  "62050": -15,
  "62051": -7,
  "62052": -9,
  "62053": -12,
  "62054": -9,
  "62056": -8,
  "62058": 2,
  "62059": 0,
  "62060": 2,
  "62061": 2,
  "62062": 2,
  "62063": -9,
  "62065": -12,
  "62067": 2,
  "62069": -6,
  "62070": -2,
  "62071": 0,
  "62074": -4,
  "62075": -7,
  "62076": -10,
  "62077": -5,
  "62078": -15,
  "62079": -1,
  "62080": -13,
  "62081": -15,
  "62082": -15,
  "62083": -10,
  "62084": 2,
  "62085": -6,
  "62086": -4,
  "62087": 2,
  "62088": -6,
  "62089": -8,
  "62090": 2,
  "62091": -8,
  "62092": -15,
  "62093": -6,
  "62094": -8,
  "62095": 2,
  "62097": 3,
  "62098": -15,
  "62201": 0,
  "62202": 0,
  "62203": 0,
  "62204": 0,
  "62205": 0,
  "62206": 0,
  "62207": 0,
  "62208": 1,
  "62214": -5,
  "62215": -1,
  "62216": -1,
  "62217": -4,
  "62218": 0,
  "62219": -1,
  "62220": 1,
  "62221": 1,
  "62222": 1,
  "62223": 1,
  "62225": 1,
  "62226": 1,
  "62230": 0,
  "62231": -1,
  "62232": 0,
  "62233": -4,
  "62234": 2,
  "62236": 11,
  "62237": -4,
  "62238": -3,
  "62239": 0,
  "62240": 8,
  "62241": -4,
  "62242": -4,
  "62243": 9,
  "62244": 11,
  "62245": 0,
  "62246": -4,
  "62247": -13,
  "62248": 3,
  "62249": 5,
  "62250": -1,
  "62252": -1,
  "62253": -4,
  "62254": 2,
  "62255": -4,
  "62256": 11,
  "62257": -4,
  "62258": 1,
  "62259": -4,
  "62260": 9,
  "62261": -4,
  "62262": -4,
  "62263": -6,
  "62264": 3,
  "62265": -1,
  "62266": -1,
  "62268": -5,
  "62269": 9,
  "62271": -5,
  "62272": -4,
  "62273": -4,
  "62274": -8,
  "62275": -4,
  "62277": -4,
  "62278": 4,
  "62279": -4,
  "62280": -4,
  "62281": 12,
  "62282": -4,
  "62284": -3,
  "62285": 9,
  "62286": -4,
  "62288": -4,
  "62289": 1,
  "62292": -4,
  "62293": 7,
  "62294": 3,
  "62295": 11,
  "62297": -4,
  "62298": 11,
  "62301": -5,
  "62305": -5,
  "62306": -5,
  "62311": -5,
  "62312": -16,
  "62313": -5,
  "62314": -18,
  "62316": -5,
  "62319": -8,
  "62320": -7,
  "62321": -5,
  "62323": -14,
  "62324": -14,
  "62325": -7,
  "62326": -4,
  "62329": -5,
  "62330": -5,
  "62334": -5,
  "62336": -5,
  "62338": -7,
  "62339": -7,
  "62340": -17,
  "62341": -5,
  "62343": -6,
  "62344": -8,
  "62345": -16,
  "62346": -14,
  "62347": -7,
  "62348": -7,
  "62349": -7,
  "62351": -7,
  "62352": -3,
  "62353": -14,
  "62354": -5,
  "62355": -16,
  "62356": -16,
  "62357": -17,
  "62358": -5,
  "62359": -6,
  "62360": -6,
  "62361": -3,
  "62362": -14,
  "62363": -16,
  "62365": -6,
  "62366": -16,
  "62367": -5,
  "62370": -16,
  "62373": -5,
  "62374": -4,
  "62375": -14,
  "62376": -6,
  "62378": -14,
  "62379": -5,
  "62380": -5,
  "62401": -5,
  "62410": 11,
  "62411": -6,
  "62413": 13,
  "62414": -6,
  "62417": -10,
  "62418": -13,
  "62419": -14,
  "62420": -6,
  "62421": -15,
  "62422": -13,
  "62423": 5,
  "62424": 8,
  "62425": -15,
  "62426": -6,
  "62427": -10,
  "62428": 8,
  "62431": -13,
  "62432": 8,
  "62433": 13,
  "62434": -12,
  "62435": -4,
  "62436": 8,
  "62438": -13,
  "62439": -10,
  "62440": -4,
  "62441": -6,
  "62442": -6,
  "62443": -6,
  "62444": -13,
  "62445": -6,
  "62446": -14,
  "62447": -4,
  "62448": 8,
  "62449": 13,
  "62450": -14,
  "62451": 13,
  "62452": -14,
  "62454": 13,
  "62458": -13,
  "62459": 8,
  "62460": -7,
  "62461": -5,
  "62462": -4,
  "62463": -13,
  "62464": 13,
  "62465": -13,
  "62466": -10,
  "62467": 3,
  "62468": -4,
  "62469": -3,
  "62471": -13,
  "62473": -6,
  "62474": -6,
  "62475": -15,
  "62476": -7,
  "62477": -6,
  "62478": 12,
  "62479": 8,
  "62480": 8,
  "62481": 8,
  "62501": -3,
  "62510": -10,
  "62512": -7,
  "62513": -3,
  "62514": -3,
  "62515": 0,
  "62517": -10,
  "62518": -7,
  "62519": -6,
  "62520": 8,
  "62521": -3,
  "62522": -3,
  "62523": -3,
  "62524": 5,
  "62525": -3,
  "62526": -3,
  "62530": 0,
  "62531": -9,
  "62532": -4,
  "62533": -7,
  "62534": -13,
  "62535": 5,
  "62536": 8,
  "62537": -3,
  "62538": -7,
  "62539": -3,
  "62540": -9,
  "62541": -6,
  "62543": -3,
  "62544": -3,
  "62545": 0,
  "62546": -9,
  "62547": -3,
  "62548": -7,
  "62549": -3,
  "62550": -10,
  "62551": -3,
  "62553": -13,
  "62554": -3,
  "62555": -10,
  "62556": -9,
  "62557": -10,
  "62558": 0,
  "62560": -7,
  "62561": 0,
  "62563": 8,
  "62565": -13,
  "62567": -10,
  "62568": -9,
  "62570": -9,
  "62571": -13,
  "62572": -8,
  "62573": -3,
  "62601": -6,
  "62610": -3,
  "62611": -9,
  "62612": -9,
  "62613": 0,
  "62615": 0,
  "62617": -9,
  "62618": -9,
  "62621": -2,
  "62622": -9,
  "62624": -8,
  "62625": 0,
  "62626": -6,
  "62627": -9,
  "62628": -2,
  "62629": 8,
  "62630": -6,
  "62631": -6,
  "62633": -12,
  "62634": -6,
  "62635": -6,
  "62638": -6,
  "62639": -8,
  "62640": -5,
  "62642": -9,
  "62643": -6,
  "62644": -12,
  "62649": -6,
  "62650": -6,
  "62651": -6,
  "62655": -12,
  "62656": -6,
  "62659": -7,
  "62660": -9,
  "62661": 0,
  "62662": 0,
  "62663": -2,
  "62664": -12,
  "62665": -2,
  "62666": -6,
  "62667": -5,
  "62668": -6,
  "62670": 0,
  "62671": -6,
  "62672": -5,
  "62673": -9,
  "62674": -5,
  "62675": -7,
  "62677": -9,
  "62681": -8,
  "62682": -6,
  "62683": -5,
  "62684": 8,
  "62685": -6,
  "62688": -9,
  "62689": 0,
  "62690": 0,
  "62691": -9,
  "62692": -6,
  "62693": 0,
  "62694": -3,
  "62695": -6,
  "62701": 0,
  "62702": 0,
  "62703": 0,
  "62704": 0,
  "62705": 0,
  "62707": 0,
  "62708": 0,
  "62711": 0,
  "62712": 0,
  "62791": 0,
  "62794": 0,
  "62801": -6,
  "62803": -6,
  "62805": -12,
  "62806": -6,
  "62807": -6,
  "62808": -6,
  "62809": -14,
  "62810": -5,
  "62811": 11,
  "62812": -9,
  "62814": -6,
  "62815": -7,
  "62816": -5,
  "62817": -13,
  "62818": -7,
  "62819": -9,
  "62820": -17,
  "62821": 2,
  "62822": -9,
  "62823": -14,
  "62824": -12,
  "62825": -9,
  "62827": 2,
  "62828": -13,
  "62829": -12,
  "62830": -5,
  "62831": -6,
  "62832": -8,
  "62833": -16,
  "62834": -26,
  "62835": -13,
  "62836": -9,
  "62837": -14,
  "62838": -13,
  "62839": -12,
  "62840": -9,
  "62841": -6,
  "62842": -14,
  "62843": -17,
  "62844": -7,
  "62846": -5,
  "62848": -6,
  "62849": -6,
  "62850": -14,
  "62851": -14,
  "62852": 11,
  "62853": -6,
  "62854": -6,
  "62855": -7,
  "62856": -9,
  "62857": -13,
  "62858": -12,
  "62859": -13,
  "62860": -12,
  "62861": 2,
  "62862": 2,
  "62863": 11,
  "62864": -5,
  "62865": -9,
  "62866": -5,
  "62867": -26,
  "62868": -14,
  "62869": -26,
  "62870": -6,
  "62871": -26,
  "62872": -5,
  "62874": -9,
  "62875": -6,
  "62876": -6,
  "62877": -6,
  "62878": -12,
  "62879": -12,
  "62880": -13,
  "62881": -6,
  "62882": -6,
  "62883": -8,
  "62884": -9,
  "62885": -13,
  "62886": -14,
  "62887": -13,
  "62888": -8,
  "62889": -5,
  "62890": -9,
  "62891": -9,
  "62892": -6,
  "62893": -6,
  "62894": -5,
  "62895": -14,
  "62896": -9,
  "62897": -9,
  "62898": -5,
  "62899": -12,
  "62901": -2,
  "62902": -2,
  "62903": -2,
  "62905": -11,
  "62906": -11,
  "62907": -3,
  "62908": -8,
  "62909": -9,
  "62910": -1,
  "62912": -9,
  "62914": 3,
  "62915": -6,
  "62916": -8,
  "62917": -2,
  "62918": -6,
  "62919": -16,
  "62920": -11,
  "62921": -6,
  "62922": -9,
  "62923": -11,
  "62924": -3,
  "62926": -11,
  "62927": -8,
  "62928": -27,
  "62930": -2,
  "62931": -16,
  "62932": -3,
  "62933": -6,
  "62934": -26,
  "62935": -2,
  "62938": -27,
  "62939": -9,
  "62940": -3,
  "62941": -8,
  "62942": -3,
  "62943": -8,
  "62946": -2,
  "62947": -27,
  "62948": -6,
  "62949": -3,
  "62950": -3,
  "62951": -6,
  "62952": -11,
  "62953": -8,
  "62954": -26,
  "62955": -27,
  "62956": -8,
  "62957": -11,
  "62958": -11,
  "62959": -6,
  "62960": -8,
  "62961": -11,
  "62962": 3,
  "62963": 3,
  "62964": 3,
  "62965": -2,
  "62966": -3,
  "62967": -9,
  "62969": -11,
  "62970": 3,
  "62971": -3,
  "62972": -9,
  "62973": -12,
  "62974": -6,
  "62975": -3,
  "62976": 3,
  "62977": -2,
  "62979": -26,
  "62982": -27,
  "62983": -9,
  "62984": -27,
  "62985": -27,
  "62987": -2,
  "62988": -11,
  "62990": -11,
  "62992": -12,
  "62993": -11,
  "62994": -3,
  "62995": -9,
  "62996": 3,
  "62997": -4,
  "62998": -11,
  "62999": -9,
  "63001": -2,
  "63005": 14,
  "63006": 18,
  "63010": -4,
  "63011": 10,
  "63012": -4,
  "63013": -5,
  "63014": -5,
  "63015": -2,
  "63016": -4,
  "63017": 18,
  "63019": -4,
  "63020": -4,
  "63021": 10,
  "63022": 10,
  "63023": -4,
  "63024": 10,
  "63025": -2,
  "63026": 7,
  "63028": -4,
  "63030": -17,
  "63031": 9,
  "63032": 9,
  "63033": 8,
  "63034": 16,
  "63036": -5,
  "63037": -12,
  "63038": 12,
  "63039": -6,
  "63040": 18,
  "63041": -4,
  "63042": 9,
  "63043": 10,
  "63044": 10,
  "63045": 10,
  "63047": -4,
  "63048": -4,
  "63049": -4,
  "63050": -4,
  "63051": -4,
  "63052": -4,
  "63053": -4,
  "63055": -5,
  "63056": -5,
  "63057": -4,
  "63060": -4,
  "63061": -4,
  "63065": -4,
  "63066": -4,
  "63068": -5,
  "63069": -5,
  "63070": -4,
  "63071": -18,
  "63072": -5,
  "63073": -5,
  "63074": 9,
  "63077": -6,
  "63079": -9,
  "63080": -9,
  "63084": -5,
  "63087": -5,
  "63088": 7,
  "63089": -5,
  "63090": -5,
  "63091": -13,
  "63101": 8,
  "63102": 8,
  "63103": 7,
  "63104": 8,
  "63105": 16,
  "63106": 7,
  "63107": 7,
  "63108": 8,
  "63109": 8,
  "63110": 8,
  "63111": 7,
  "63112": 8,
  "63113": 7,
  "63114": 7,
  "63115": 7,
  "63116": 8,
  "63117": 7,
  "63118": 7,
  "63119": 7,
  "63120": 7,
  "63121": 7,
  "63122": 7,
  "63123": 8,
  "63124": 18,
  "63125": 8,
  "63126": 7,
  "63127": 7,
  "63128": 7,
  "63129": 8,
  "63130": 7,
  "63131": 16,
  "63132": 7,
  "63133": 7,
  "63134": 7,
  "63135": 7,
  "63136": 8,
  "63137": 8,
  "63138": 2,
  "63139": 8,
  "63140": 7,
  "63141": 18,
  "63143": 7,
  "63144": 7,
  "63145": 7,
  "63146": 10,
  "63147": 7,
  "63151": 8,
  "63155": 7,
  "63156": 8,
  "63157": 8,
  "63158": 8,
  "63163": 7,
  "63166": 7,
  "63169": 8,
  "63177": 7,
  "63178": 7,
  "63179": 7,
  "63188": 8,
  "63301": 3,
  "63302": 3,
  "63303": 3,
  "63304": 3,
  "63330": 3,
  "63332": -5,
  "63333": -4,
  "63334": -2,
  "63336": -2,
  "63338": 3,
  "63339": -2,
  "63341": 12,
  "63342": -5,
  "63343": 3,
  "63344": -2,
  "63345": -6,
  "63346": 3,
  "63347": 3,
  "63348": -5,
  "63349": 3,
  "63350": -4,
  "63351": -4,
  "63352": -6,
  "63353": -2,
  "63357": -5,
  "63359": -4,
  "63361": -3,
  "63362": 3,
  "63363": -4,
  "63365": 12,
  "63366": 3,
  "63367": 3,
  "63368": 3,
  "63369": 3,
  "63370": 3,
  "63373": -8,
  "63376": 3,
  "63377": 3,
  "63378": -5,
  "63379": 3,
  "63381": -4,
  "63382": -4,
  "63383": -5,
  "63384": -4,
  "63385": 3,
  "63386": 2,
  "63387": 3,
  "63388": -5,
  "63389": 3,
  "63390": -5,
  "63401": -6,
  "63430": -13,
  "63431": -9,
  "63432": -13,
  "63433": -2,
  "63434": -10,
  "63435": -9,
  "63436": -4,
  "63437": -10,
  "63438": -9,
  "63439": -10,
  "63440": -8,
  "63441": -4,
  "63442": -13,
  "63443": -17,
  "63445": -13,
  "63446": -13,
  "63447": -9,
  "63448": -9,
  "63450": -8,
  "63451": -10,
  "63452": -9,
  "63453": -13,
  "63454": -9,
  "63456": -4,
  "63457": -8,
  "63458": -13,
  "63459": -4,
  "63460": -13,
  "63461": -5,
  "63462": -4,
  "63463": -6,
  "63464": -13,
  "63465": -13,
  "63466": -13,
  "63467": -4,
  "63468": -10,
  "63469": -10,
  "63471": -6,
  "63472": -13,
  "63473": -13,
  "63474": -13,
  "63501": -7,
  "63530": -13,
  "63531": -13,
  "63532": -13,
  "63533": -7,
  "63534": -13,
  "63535": -12,
  "63536": -11,
  "63537": -13,
  "63538": -13,
  "63539": -13,
  "63540": -7,
  "63541": -12,
  "63543": -13,
  "63544": -7,
  "63545": -17,
  "63546": -11,
  "63547": -13,
  "63548": -10,
  "63549": -7,
  "63551": -12,
  "63552": -13,
  "63555": -10,
  "63556": -17,
  "63557": -5,
  "63558": -13,
  "63559": -7,
  "63560": -19,
  "63561": -12,
  "63563": -13,
  "63565": -19,
  "63566": -5,
  "63567": -12,
  "63601": -6,
  "63620": -19,
  "63621": -19,
  "63622": -17,
  "63623": -20,
  "63624": -6,
  "63625": -19,
  "63626": -18,
  "63627": 0,
  "63628": -5,
  "63629": -16,
  "63630": -18,
  "63631": -17,
  "63632": -15,
  "63633": -20,
  "63636": -18,
  "63637": -6,
  "63638": -4,
  "63640": -5,
  "63645": -15,
  "63648": -7,
  "63650": -19,
  "63651": -5,
  "63653": -6,
  "63654": -19,
  "63655": -15,
  "63656": -6,
  "63660": -18,
  "63662": -13,
  "63663": -19,
  "63664": -18,
  "63665": -19,
  "63666": -4,
  "63670": -2,
  "63673": -2,
  "63674": -18,
  "63675": -19,
  "63701": 5,
  "63702": 5,
  "63703": -4,
  "63730": -12,
  "63732": -2,
  "63735": -5,
  "63736": -5,
  "63737": -2,
  "63738": -2,
  "63739": 5,
  "63740": -5,
  "63742": -5,
  "63743": -2,
  "63744": -5,
  "63745": -5,
  "63746": -2,
  "63747": -2,
  "63748": -2,
  "63750": -12,
  "63751": -13,
  "63752": 5,
  "63755": 5,
  "63758": -5,
  "63760": -12,
  "63763": 7,
  "63764": -13,
  "63766": -4,
  "63767": -4,
  "63769": -3,
  "63770": -2,
  "63771": -5,
  "63774": -5,
  "63775": -2,
  "63776": -2,
  "63779": 5,
  "63780": -3,
  "63781": -12,
  "63782": -12,
  "63783": -2,
  "63784": -4,
  "63785": -13,
  "63787": -12,
  "63801": -3,
  "63820": -5,
  "63821": -9,
  "63822": -2,
  "63823": -5,
  "63824": -5,
  "63825": -2,
  "63826": -8,
  "63827": 24,
  "63828": -13,
  "63829": -9,
  "63830": -8,
  "63833": -12,
  "63834": -5,
  "63837": 23,
  "63839": 8,
  "63840": -7,
  "63841": -2,
  "63845": -13,
  "63846": -2,
  "63847": 23,
  "63848": 24,
  "63849": 24,
  "63850": -2,
  "63851": 24,
  "63852": 24,
  "63853": 8,
  "63855": 8,
  "63857": 24,
  "63860": -13,
  "63862": -12,
  "63863": -12,
  "63866": -13,
  "63867": -13,
  "63868": -2,
  "63869": -13,
  "63870": -12,
  "63873": -12,
  "63874": -13,
  "63875": 24,
  "63876": 24,
  "63877": 24,
  "63878": -13,
  "63879": 24,
  "63880": 24,
  "63881": -13,
  "63882": -5,
  "63901": -8,
  "63902": -8,
  "63931": -18,
  "63932": -8,
  "63933": 24,
  "63934": -18,
  "63935": -18,
  "63936": -2,
  "63937": -4,
  "63938": -12,
  "63939": -18,
  "63940": -8,
  "63941": -4,
  "63942": -18,
  "63943": -4,
  "63944": -17,
  "63945": -8,
  "63950": -18,
  "63951": -17,
  "63952": -18,
  "63953": -18,
  "63954": -8,
  "63955": -18,
  "63956": -9,
  "63957": -17,
  "63960": -2,
  "63961": -8,
  "63962": -8,
  "63963": -18,
  "63964": -18,
  "63965": -4,
  "63966": -17,
  "63967": -17,
  "64001": -10,
  "64011": -10,
  "64012": 1,
  "64013": 7,
  "64014": 7,
  "64015": 7,
  "64016": 7,
  "64017": -9,
  "64018": 6,
  "64019": -8,
  "64020": -10,
  "64021": -10,
  "64022": -10,
  "64024": -9,
  "64028": 6,
  "64029": 7,
  "64030": 7,
  "64034": 0,
  "64035": -9,
  "64036": -9,
  "64037": -10,
  "64040": -8,
  "64048": -6,
  "64050": 7,
  "64051": 7,
  "64052": 7,
  "64053": 7,
  "64054": 7,
  "64055": 7,
  "64056": 7,
  "64057": 7,
  "64058": 0,
  "64060": 1,
  "64061": 0,
  "64062": -9,
  "64063": 7,
  "64064": 15,
  "64066": -9,
  "64067": -10,
  "64068": 1,
  "64069": 1,
  "64070": 0,
  "64071": -10,
  "64072": 0,
  "64073": -9,
  "64074": -9,
  "64075": 7,
  "64076": -9,
  "64077": -9,
  "64078": 2,
  "64079": 6,
  "64080": 0,
  "64081": 7,
  "64082": 8,
  "64083": 0,
  "64084": -9,
  "64085": -9,
  "64086": 7,
  "64088": -9,
  "64089": 6,
  "64090": -1,
  "64092": 5,
  "64093": -8,
  "64096": 2,
  "64097": -10,
  "64098": 6,
  "64101": 7,
  "64102": 7,
  "64105": 7,
  "64106": 7,
  "64108": 7,
  "64109": 7,
  "64110": 7,
  "64111": 7,
  "64112": 15,
  "64113": 15,
  "64114": 7,
  "64116": 1,
  "64117": 0,
  "64118": -1,
  "64119": 1,
  "64120": 7,
  "64121": 7,
  "64123": 7,
  "64124": 7,
  "64125": 7,
  "64126": 7,
  "64127": 7,
  "64128": 7,
  "64129": 7,
  "64130": 7,
  "64131": 7,
  "64132": 7,
  "64133": 7,
  "64134": 7,
  "64136": 7,
  "64137": 7,
  "64138": 7,
  "64139": 15,
  "64141": 7,
  "64145": 6,
  "64146": 7,
  "64147": 15,
  "64148": 7,
  "64149": 15,
  "64150": 4,
  "64151": 4,
  "64152": 5,
  "64153": 7,
  "64154": 5,
  "64155": -1,
  "64156": 0,
  "64157": 1,
  "64158": 9,
  "64161": 0,
  "64163": 6,
  "64164": 5,
  "64165": -1,
  "64166": 9,
  "64167": 9,
  "64168": 4,
  "64171": 7,
  "64172": 7,
  "64179": 7,
  "64188": 7,
  "64190": 5,
  "64191": 7,
  "64192": 7,
  "64195": 7,
  "64196": 7,
  "64199": 7,
  "64401": 20,
  "64402": -14,
  "64420": -15,
  "64421": -7,
  "64422": -3,
  "64423": -6,
  "64424": -23,
  "64426": -24,
  "64427": -7,
  "64428": -15,
  "64429": -7,
  "64430": -3,
  "64431": -14,
  "64432": -14,
  "64433": -15,
  "64434": -14,
  "64436": 2,
  "64437": -15,
  "64438": -15,
  "64439": 20,
  "64440": 11,
  "64441": -14,
  "64442": -24,
  "64443": 20,
  "64444": 6,
  "64445": -15,
  "64446": -15,
  "64448": 20,
  "64449": -7,
  "64451": -15,
  "64453": -15,
  "64454": 1,
  "64455": -15,
  "64456": -15,
  "64457": -15,
  "64458": -15,
  "64459": -7,
  "64461": -15,
  "64463": -14,
  "64465": 1,
  "64466": -15,
  "64467": -24,
  "64468": -6,
  "64469": -3,
  "64470": -15,
  "64471": -24,
  "64473": -15,
  "64474": -7,
  "64475": -15,
  "64476": -14,
  "64477": 1,
  "64479": -14,
  "64480": -7,
  "64481": -24,
  "64482": -17,
  "64483": -7,
  "64484": -10,
  "64485": -5,
  "64486": -15,
  "64487": -15,
  "64489": -15,
  "64490": -3,
  "64491": -15,
  "64492": -7,
  "64493": -7,
  "64494": -7,
  "64496": -17,
  "64497": -3,
  "64498": -13,
  "64499": -15,
  "64501": 11,
  "64502": 11,
  "64503": 11,
  "64504": 11,
  "64505": 11,
  "64506": 20,
  "64507": 11,
  "64508": 20,
  "64601": -7,
  "64620": -1,
  "64622": 2,
  "64623": 3,
  "64624": -6,
  "64625": -7,
  "64628": -5,
  "64630": -17,
  "64631": -5,
  "64632": -15,
  "64633": 2,
  "64635": -7,
  "64636": -2,
  "64637": -6,
  "64638": -6,
  "64639": 3,
  "64640": -1,
  "64641": -16,
  "64642": -16,
  "64643": 3,
  "64644": -6,
  "64645": -19,
  "64646": -20,
  "64647": -2,
  "64648": -1,
  "64649": -6,
  "64650": -6,
  "64651": -5,
  "64652": -16,
  "64653": -5,
  "64654": -1,
  "64655": -14,
  "64656": -7,
  "64657": -15,
  "64658": -11,
  "64659": -5,
  "64660": -11,
  "64661": -14,
  "64664": -7,
  "64667": -14,
  "64668": 2,
  "64670": -1,
  "64671": -6,
  "64672": -14,
  "64673": -15,
  "64674": -5,
  "64676": -11,
  "64679": -16,
  "64680": 2,
  "64681": -5,
  "64682": 2,
  "64683": -16,
  "64686": -7,
  "64688": -7,
  "64689": -2,
  "64701": 2,
  "64720": -7,
  "64722": -7,
  "64723": -7,
  "64724": -16,
  "64725": 1,
  "64726": -1,
  "64728": -8,
  "64730": -7,
  "64733": -8,
  "64734": 2,
  "64735": -1,
  "64738": -18,
  "64739": 1,
  "64740": -1,
  "64741": 0,
  "64742": 1,
  "64743": -1,
  "64744": -6,
  "64745": -7,
  "64746": 1,
  "64747": 2,
  "64748": -12,
  "64750": -8,
  "64752": -7,
  "64755": -13,
  "64756": -6,
  "64759": -13,
  "64761": -8,
  "64762": -13,
  "64763": -18,
  "64765": -7,
  "64766": -6,
  "64767": -8,
  "64769": -13,
  "64770": 1,
  "64771": -8,
  "64772": -8,
  "64776": -18,
  "64778": -7,
  "64779": -7,
  "64780": -16,
  "64781": -18,
  "64783": -8,
  "64784": -13,
  "64788": 1,
  "64790": -8,
  "64801": -3,
  "64802": -2,
  "64803": -2,
  "64804": -2,
  "64830": -3,
  "64831": -14,
  "64832": -3,
  "64833": -3,
  "64834": -2,
  "64835": -3,
  "64836": -3,
  "64840": -10,
  "64841": -3,
  "64842": -10,
  "64843": -15,
  "64844": -10,
  "64847": -14,
  "64848": -9,
  "64849": -4,
  "64850": -10,
  "64853": -10,
  "64854": -14,
  "64855": -3,
  "64856": -14,
  "64857": -3,
  "64858": -10,
  "64859": -3,
  "64861": -14,
  "64862": -3,
  "64863": -14,
  "64864": -2,
  "64865": -10,
  "64866": -10,
  "64867": -15,
  "64868": -14,
  "64869": -3,
  "64870": -3,
  "64873": 0,
  "64874": -12,
  "65001": -4,
  "65010": 8,
  "65011": -10,
  "65013": -4,
  "65014": -13,
  "65016": -3,
  "65017": -10,
  "65018": -1,
  "65020": 3,
  "65023": 2,
  "65024": -4,
  "65025": -2,
  "65026": -10,
  "65032": -9,
  "65034": -2,
  "65035": -3,
  "65036": -13,
  "65037": -9,
  "65038": -9,
  "65039": 10,
  "65040": -9,
  "65041": -12,
  "65042": -1,
  "65043": 2,
  "65046": -2,
  "65047": -9,
  "65048": -4,
  "65049": 13,
  "65050": -1,
  "65051": -3,
  "65052": 5,
  "65053": 10,
  "65054": -3,
  "65055": -1,
  "65058": -9,
  "65059": -5,
  "65061": -4,
  "65062": -4,
  "65063": -5,
  "65064": -9,
  "65065": 13,
  "65066": -13,
  "65067": -5,
  "65068": -1,
  "65069": -3,
  "65072": -1,
  "65074": -1,
  "65075": -9,
  "65076": -1,
  "65077": -6,
  "65078": -10,
  "65079": 13,
  "65080": -5,
  "65081": -2,
  "65082": -10,
  "65083": -10,
  "65084": -10,
  "65085": -3,
  "65101": 2,
  "65102": 2,
  "65109": 2,
  "65110": 2,
  "65201": 0,
  "65202": 0,
  "65203": 8,
  "65205": 0,
  "65230": -12,
  "65231": -5,
  "65232": -6,
  "65233": -8,
  "65236": -11,
  "65237": -8,
  "65239": 3,
  "65240": 0,
  "65243": 3,
  "65244": 3,
  "65246": -11,
  "65247": 3,
  "65248": -12,
  "65250": -12,
  "65251": -5,
  "65254": -12,
  "65255": 0,
  "65256": -12,
  "65257": 3,
  "65258": -17,
  "65259": 3,
  "65260": 3,
  "65261": -11,
  "65262": 3,
  "65263": -17,
  "65264": -5,
  "65265": -6,
  "65270": 3,
  "65274": -12,
  "65275": -17,
  "65276": -8,
  "65278": 3,
  "65279": 0,
  "65280": -6,
  "65281": -11,
  "65282": -5,
  "65283": -17,
  "65284": 0,
  "65285": -5,
  "65286": -11,
  "65287": 0,
  "65301": -8,
  "65302": -8,
  "65305": -8,
  "65320": -10,
  "65321": -11,
  "65322": -8,
  "65323": -1,
  "65324": 13,
  "65325": -10,
  "65326": -10,
  "65327": -10,
  "65329": -8,
  "65330": -10,
  "65332": -8,
  "65333": -8,
  "65334": -8,
  "65335": -10,
  "65336": -8,
  "65337": -8,
  "65338": -10,
  "65339": -10,
  "65340": -10,
  "65344": -10,
  "65345": -10,
  "65347": -10,
  "65348": -8,
  "65349": -10,
  "65350": -8,
  "65351": -10,
  "65354": -8,
  "65355": -11,
  "65360": -1,
  "65401": -6,
  "65402": -6,
  "65436": -8,
  "65438": -19,
  "65439": -16,
  "65440": -16,
  "65441": -9,
  "65443": -14,
  "65444": -15,
  "65446": -12,
  "65449": -9,
  "65452": -14,
  "65453": -9,
  "65456": -12,
  "65457": -14,
  "65459": -14,
  "65461": -8,
  "65462": -8,
  "65463": -6,
  "65464": -6,
  "65466": -4,
  "65468": -14,
  "65470": -5,
  "65473": -15,
  "65479": -14,
  "65483": -14,
  "65484": -15,
  "65486": -10,
  "65501": -14,
  "65529": -6,
  "65532": -6,
  "65534": -15,
  "65535": -9,
  "65536": -5,
  "65541": -14,
  "65542": -15,
  "65543": -13,
  "65546": -19,
  "65548": -17,
  "65550": -6,
  "65552": -14,
  "65555": -15,
  "65556": -15,
  "65557": -15,
  "65559": -6,
  "65560": -13,
  "65564": -15,
  "65565": -9,
  "65566": -16,
  "65567": -15,
  "65570": -15,
  "65571": -15,
  "65580": -6,
  "65582": -6,
  "65583": -15,
  "65584": -15,
  "65586": -9,
  "65588": -4,
  "65589": -14,
  "65590": -14,
  "65591": 3,
  "65601": -13,
  "65603": -12,
  "65604": -5,
  "65605": -9,
  "65606": -19,
  "65607": -5,
  "65608": -17,
  "65609": -19,
  "65610": -8,
  "65611": -12,
  "65612": -5,
  "65613": -13,
  "65614": -10,
  "65615": -10,
  "65616": -10,
  "65617": -13,
  "65618": -18,
  "65619": -5,
  "65620": -6,
  "65622": -14,
  "65623": -12,
  "65624": -13,
  "65625": -12,
  "65626": -19,
  "65627": -11,
  "65629": -6,
  "65630": -2,
  "65631": -6,
  "65632": -6,
  "65633": -13,
  "65634": -20,
  "65635": -12,
  "65636": -11,
  "65637": -17,
  "65638": -17,
  "65640": -14,
  "65641": -12,
  "65644": -14,
  "65645": -13,
  "65646": -12,
  "65647": -12,
  "65648": -5,
  "65649": -14,
  "65650": -20,
  "65652": 3,
  "65653": -9,
  "65654": -9,
  "65655": -19,
  "65656": -13,
  "65657": -11,
  "65658": -10,
  "65660": -13,
  "65661": -12,
  "65662": -5,
  "65663": -13,
  "65664": -8,
  "65666": -19,
  "65667": -13,
  "65668": -20,
  "65669": -6,
  "65672": -10,
  "65673": -10,
  "65674": -14,
  "65675": -13,
  "65676": -18,
  "65679": -10,
  "65680": -11,
  "65681": -12,
  "65682": -12,
  "65685": -14,
  "65686": -4,
  "65688": -19,
  "65689": -15,
  "65690": -19,
  "65692": -19,
  "65701": -17,
  "65702": -17,
  "65704": -13,
  "65705": -8,
  "65706": -11,
  "65707": -9,
  "65708": -7,
  "65710": -13,
  "65711": -13,
  "65712": -8,
  "65713": -11,
  "65714": -4,
  "65715": -19,
  "65717": -13,
  "65720": -6,
  "65721": -6,
  "65722": -6,
  "65723": -9,
  "65724": -20,
  "65725": -13,
  "65726": -10,
  "65727": -20,
  "65728": -6,
  "65729": -18,
  "65730": -14,
  "65731": -9,
  "65732": -20,
  "65733": -11,
  "65734": -12,
  "65735": -20,
  "65737": -13,
  "65738": -5,
  "65739": -2,
  "65740": -11,
  "65741": -18,
  "65742": 3,
  "65744": -10,
  "65745": -12,
  "65746": -11,
  "65747": -12,
  "65752": -12,
  "65753": -6,
  "65754": -4,
  "65755": -17,
  "65756": -9,
  "65757": -11,
  "65759": -11,
  "65760": -18,
  "65761": -19,
  "65762": -18,
  "65764": -14,
  "65765": 3,
  "65766": -19,
  "65767": -20,
  "65768": -17,
  "65769": -8,
  "65770": -13,
  "65771": -10,
  "65772": -12,
  "65773": -18,
  "65774": -20,
  "65775": -17,
  "65776": -17,
  "65777": -17,
  "65778": -19,
  "65779": -20,
  "65781": -5,
  "65783": -14,
  "65784": -19,
  "65785": -5,
  "65786": 3,
  "65787": 3,
  "65788": -16,
  "65789": -17,
  "65790": -17,
  "65791": -19,
  "65793": -17,
  "65801": 3,
  "65802": -6,
  "65803": -5,
  "65804": -4,
  "65805": -5,
  "65806": -6,
  "65807": -5,
  "65808": -4,
  "65809": 3,
  "65810": 3,
  "65814": -6,
  "65817": -5,
  "66002": -11,
  "66006": 2,
  "66007": -2,
  "66008": 0,
  "66010": -2,
  "66012": 4,
  "66013": 6,
  "66014": -2,
  "66015": -15,
  "66016": -10,
  "66017": 0,
  "66018": 6,
  "66019": 6,
  "66020": -2,
  "66021": -1,
  "66023": -11,
  "66024": 11,
  "66025": 2,
  "66026": -1,
  "66027": -2,
  "66030": 6,
  "66031": 6,
  "66032": -15,
  "66033": -15,
  "66035": -1,
  "66036": -1,
  "66039": -15,
  "66040": -2,
  "66041": -11,
  "66042": 0,
  "66043": -2,
  "66044": 2,
  "66046": 2,
  "66047": 11,
  "66048": -2,
  "66049": 11,
  "66050": 2,
  "66051": 6,
  "66052": 2,
  "66053": -1,
  "66054": 3,
  "66056": -2,
  "66058": -11,
  "66060": -11,
  "66061": 6,
  "66062": 6,
  "66063": 6,
  "66064": -1,
  "66066": 5,
  "66067": 0,
  "66070": 3,
  "66071": -1,
  "66072": -2,
  "66073": 5,
  "66075": -2,
  "66076": 0,
  "66077": -11,
  "66078": 0,
  "66079": 0,
  "66080": 0,
  "66083": -1,
  "66085": 6,
  "66086": -1,
  "66087": 0,
  "66088": 3,
  "66090": 11,
  "66091": -15,
  "66092": 0,
  "66093": -12,
  "66094": -15,
  "66095": 0,
  "66097": 3,
  "66101": 3,
  "66102": 3,
  "66103": 5,
  "66104": 3,
  "66105": 3,
  "66106": 4,
  "66109": 4,
  "66110": 3,
  "66111": 4,
  "66112": 4,
  "66113": 3,
  "66115": 3,
  "66117": 3,
  "66118": 3,
  "66119": 3,
  "66201": 6,
  "66202": 4,
  "66203": 4,
  "66204": 3,
  "66205": 5,
  "66206": 12,
  "66207": 12,
  "66208": 5,
  "66209": 15,
  "66210": 6,
  "66211": 17,
  "66212": 6,
  "66213": 7,
  "66214": 3,
  "66215": 6,
  "66216": 3,
  "66217": 11,
  "66218": 6,
  "66219": 6,
  "66220": 15,
  "66221": 17,
  "66222": 4,
  "66223": 6,
  "66224": 15,
  "66225": 7,
  "66226": 6,
  "66227": 6,
  "66250": 6,
  "66282": 6,
  "66283": 6,
  "66285": 4,
  "66286": 6,
  "66401": -10,
  "66402": -2,
  "66403": -12,
  "66404": -12,
  "66406": -10,
  "66407": -3,
  "66408": -12,
  "66409": 6,
  "66411": -12,
  "66412": -10,
  "66413": -15,
  "66414": -15,
  "66415": -12,
  "66416": -14,
  "66417": -12,
  "66418": -14,
  "66419": -13,
  "66420": -2,
  "66422": -3,
  "66423": -10,
  "66424": -18,
  "66425": -18,
  "66426": -3,
  "66427": -12,
  "66428": -12,
  "66429": -2,
  "66431": -10,
  "66432": -14,
  "66434": -18,
  "66436": -13,
  "66438": -10,
  "66439": -18,
  "66440": -13,
  "66441": -6,
  "66442": -6,
  "66449": -3,
  "66451": -15,
  "66501": -10,
  "66502": -3,
  "66503": 5,
  "66505": -3,
  "66506": -3,
  "66507": -10,
  "66508": -10,
  "66509": -13,
  "66510": -15,
  "66512": 3,
  "66514": -5,
  "66515": -18,
  "66516": -14,
  "66517": -6,
  "66518": -10,
  "66520": -3,
  "66521": -3,
  "66522": -12,
  "66523": -15,
  "66524": -13,
  "66526": -10,
  "66527": -18,
  "66528": -13,
  "66531": -3,
  "66532": -18,
  "66533": -2,
  "66534": -11,
  "66535": -3,
  "66536": -3,
  "66537": -15,
  "66538": -11,
  "66539": 6,
  "66540": -13,
  "66541": -10,
  "66542": 6,
  "66543": -15,
  "66544": -12,
  "66546": 6,
  "66547": -3,
  "66548": -12,
  "66549": -3,
  "66550": -12,
  "66552": -14,
  "66554": -3,
  "66601": -3,
  "66603": -3,
  "66604": -3,
  "66605": -3,
  "66606": -3,
  "66607": -3,
  "66608": -3,
  "66609": -3,
  "66610": 6,
  "66611": -2,
  "66612": -3,
  "66614": -2,
  "66615": 6,
  "66616": -3,
  "66617": -2,
  "66618": 6,
  "66619": -3,
  "66621": -3,
  "66647": -3,
  "66667": -3,
  "66675": -3,
  "66683": -3,
  "66701": -9,
  "66710": -3,
  "66711": -9,
  "66712": -8,
  "66713": -3,
  "66714": -3,
  "66716": -12,
  "66717": -3,
  "66720": -14,
  "66724": -8,
  "66725": -3,
  "66728": -3,
  "66732": -12,
  "66733": -14,
  "66734": -8,
  "66735": -8,
  "66736": -3,
  "66738": -7,
  "66739": -3,
  "66740": -14,
  "66741": 0,
  "66742": -10,
  "66743": -8,
  "66746": -9,
  "66748": -12,
  "66749": -10,
  "66751": -10,
  "66753": -8,
  "66754": -7,
  "66755": -10,
  "66756": -8,
  "66757": -3,
  "66758": -10,
  "66759": -3,
  "66760": 0,
  "66761": -10,
  "66762": -8,
  "66763": -8,
  "66767": -2,
  "66769": -9,
  "66770": -3,
  "66771": -14,
  "66772": -12,
  "66773": -3,
  "66775": -14,
  "66776": -14,
  "66777": -9,
  "66778": -3,
  "66779": -9,
  "66780": -14,
  "66781": -3,
  "66782": -3,
  "66783": -10,
  "66801": -10,
  "66830": -10,
  "66833": -10,
  "66834": -13,
  "66835": -10,
  "66838": -13,
  "66839": -15,
  "66840": -4,
  "66842": -20,
  "66843": -20,
  "66845": -20,
  "66846": -13,
  "66849": -13,
  "66850": -20,
  "66851": -6,
  "66852": -15,
  "66853": -9,
  "66854": -15,
  "66855": -15,
  "66856": -14,
  "66857": -12,
  "66858": -6,
  "66859": -6,
  "66860": -9,
  "66861": -6,
  "66862": -20,
  "66863": -9,
  "66864": -10,
  "66865": -9,
  "66866": -6,
  "66868": -10,
  "66869": -20,
  "66870": -9,
  "66871": -12,
  "66872": -13,
  "66873": -13,
  "66901": -12,
  "66930": 3,
  "66932": -8,
  "66933": -13,
  "66935": 3,
  "66936": -15,
  "66937": -12,
  "66938": -12,
  "66939": 3,
  "66940": 3,
  "66941": -9,
  "66942": 3,
  "66943": -12,
  "66944": -12,
  "66945": -11,
  "66946": -12,
  "66948": -12,
  "66949": -9,
  "66951": -9,
  "66952": -8,
  "66953": -12,
  "66955": -7,
  "66956": -9,
  "66958": -12,
  "66959": 3,
  "66960": 3,
  "66961": -12,
  "66962": -12,
  "66963": -9,
  "66964": 3,
  "66966": 3,
  "66967": -8,
  "66968": -12,
  "66970": -15,
  "67001": 4,
  "67002": 5,
  "67003": -9,
  "67004": -8,
  "67005": -2,
  "67008": -2,
  "67009": -8,
  "67010": -3,
  "67012": -4,
  "67013": -7,
  "67016": -5,
  "67017": -3,
  "67018": -9,
  "67019": -2,
  "67020": -5,
  "67021": -12,
  "67022": -7,
  "67023": -2,
  "67024": -2,
  "67025": -1,
  "67026": -3,
  "67028": -12,
  "67029": -13,
  "67030": 4,
  "67031": -7,
  "67035": -2,
  "67036": -8,
  "67037": 4,
  "67038": -2,
  "67039": -3,
  "67041": -5,
  "67042": -4,
  "67045": -9,
  "67047": -9,
  "67049": -8,
  "67050": -3,
  "67051": -2,
  "67052": 4,
  "67053": -5,
  "67054": -13,
  "67055": 4,
  "67056": -5,
  "67057": -8,
  "67058": -8,
  "67059": -12,
  "67060": -4,
  "67061": -8,
  "67062": -4,
  "67063": -6,
  "67065": -7,
  "67066": -12,
  "67067": -4,
  "67068": -2,
  "67070": -8,
  "67071": -7,
  "67072": -4,
  "67073": -6,
  "67074": -4,
  "67101": -4,
  "67102": -1,
  "67103": -7,
  "67104": -8,
  "67105": -7,
  "67106": 7,
  "67107": -5,
  "67108": -4,
  "67109": -13,
  "67110": -4,
  "67111": -2,
  "67112": -7,
  "67114": -5,
  "67117": -5,
  "67118": -1,
  "67119": -2,
  "67120": -6,
  "67122": -9,
  "67123": -4,
  "67124": -12,
  "67127": -13,
  "67131": -2,
  "67132": -4,
  "67133": -3,
  "67134": -12,
  "67135": -5,
  "67137": -9,
  "67138": -8,
  "67140": -7,
  "67142": -2,
  "67143": -13,
  "67144": -4,
  "67146": -1,
  "67147": -3,
  "67149": -4,
  "67150": -10,
  "67151": -5,
  "67152": -7,
  "67154": -5,
  "67155": -12,
  "67156": -2,
  "67159": -2,
  "67201": -4,
  "67202": -4,
  "67203": -4,
  "67204": -4,
  "67205": 4,
  "67206": 4,
  "67207": -4,
  "67208": -4,
  "67209": -3,
  "67210": -4,
  "67211": -4,
  "67212": -3,
  "67213": -4,
  "67214": -4,
  "67215": -4,
  "67216": -4,
  "67217": -4,
  "67218": -4,
  "67219": -4,
  "67220": -3,
  "67221": -4,
  "67223": 4,
  "67226": 4,
  "67227": -4,
  "67228": 4,
  "67230": 4,
  "67232": 4,
  "67235": 4,
  "67275": -3,
  "67276": -3,
  "67277": -3,
  "67278": -4,
  "67301": -3,
  "67330": -11,
  "67332": -11,
  "67333": -2,
  "67334": -7,
  "67335": -3,
  "67336": -11,
  "67337": -3,
  "67340": -2,
  "67341": -11,
  "67342": -11,
  "67344": -2,
  "67345": -3,
  "67346": -2,
  "67347": -2,
  "67349": -9,
  "67351": -3,
  "67352": -3,
  "67353": -3,
  "67354": -12,
  "67355": -2,
  "67356": -11,
  "67357": -11,
  "67360": -7,
  "67361": -2,
  "67363": -3,
  "67364": -2,
  "67401": -8,
  "67402": -8,
  "67410": -11,
  "67416": -8,
  "67417": -14,
  "67418": 1,
  "67420": -9,
  "67422": -22,
  "67423": 1,
  "67425": -8,
  "67427": -10,
  "67428": -2,
  "67430": -9,
  "67431": -11,
  "67432": -18,
  "67436": -23,
  "67437": -8,
  "67438": -6,
  "67439": -13,
  "67441": -11,
  "67442": -8,
  "67443": -2,
  "67444": -10,
  "67445": -14,
  "67446": -9,
  "67447": -18,
  "67448": -8,
  "67449": -13,
  "67450": -13,
  "67451": -10,
  "67452": 1,
  "67454": -13,
  "67455": 1,
  "67456": -2,
  "67457": -10,
  "67458": -18,
  "67459": -13,
  "67460": -2,
  "67464": -13,
  "67466": -14,
  "67467": -22,
  "67468": -18,
  "67470": -8,
  "67473": -9,
  "67474": -8,
  "67475": -6,
  "67476": -2,
  "67478": -9,
  "67480": -8,
  "67481": 1,
  "67482": -11,
  "67483": -6,
  "67484": -22,
  "67485": -9,
  "67487": -18,
  "67490": -13,
  "67491": -3,
  "67492": -11,
  "67501": -9,
  "67502": -9,
  "67504": -9,
  "67505": -9,
  "67510": -9,
  "67511": -7,
  "67512": -10,
  "67513": -15,
  "67514": -9,
  "67515": -15,
  "67516": -15,
  "67518": -15,
  "67519": -13,
  "67520": -15,
  "67521": -15,
  "67522": -9,
  "67523": -11,
  "67524": -10,
  "67525": -7,
  "67526": -7,
  "67529": -11,
  "67530": -7,
  "67543": -9,
  "67544": -7,
  "67545": -7,
  "67546": -2,
  "67547": -13,
  "67548": -15,
  "67550": -11,
  "67552": -13,
  "67553": -15,
  "67554": -10,
  "67556": -15,
  "67557": -13,
  "67559": -15,
  "67560": -15,
  "67561": -9,
  "67563": -13,
  "67564": -7,
  "67565": -15,
  "67566": -9,
  "67567": -11,
  "67568": -9,
  "67570": -9,
  "67572": -15,
  "67573": -10,
  "67574": -13,
  "67575": -15,
  "67576": -11,
  "67578": -12,
  "67579": -10,
  "67581": -9,
  "67583": -12,
  "67584": -15,
  "67585": -9,
  "67601": -9,
  "67621": -9,
  "67622": -13,
  "67623": -9,
  "67625": -17,
  "67626": -8,
  "67627": -9,
  "67628": -8,
  "67629": -13,
  "67631": -17,
  "67632": -17,
  "67634": -8,
  "67635": -14,
  "67637": -17,
  "67638": -8,
  "67639": -9,
  "67640": -8,
  "67642": -17,
  "67643": -13,
  "67644": -9,
  "67645": -13,
  "67646": -9,
  "67647": -8,
  "67648": -8,
  "67649": -8,
  "67650": -14,
  "67651": -9,
  "67653": -13,
  "67654": -13,
  "67656": -17,
  "67657": -17,
  "67658": -8,
  "67659": -17,
  "67660": -14,
  "67661": -8,
  "67663": -9,
  "67664": -9,
  "67665": -8,
  "67667": -15,
  "67669": -10,
  "67671": -9,
  "67672": -17,
  "67673": -8,
  "67674": -9,
  "67675": -9,
  "67701": -4,
  "67730": -9,
  "67731": -3,
  "67732": -4,
  "67733": -12,
  "67734": -4,
  "67735": -12,
  "67736": -14,
  "67737": -14,
  "67738": -14,
  "67739": -9,
  "67740": -14,
  "67741": -12,
  "67743": -4,
  "67744": -9,
  "67745": -9,
  "67747": -6,
  "67748": -5,
  "67749": -12,
  "67751": -14,
  "67752": -14,
  "67753": -6,
  "67756": -3,
  "67757": -6,
  "67758": -14,
  "67761": -14,
  "67762": -14,
  "67764": -6,
  "67801": -10,
  "67831": -13,
  "67834": -11,
  "67835": 3,
  "67836": -18,
  "67837": -8,
  "67838": -7,
  "67839": -11,
  "67840": -13,
  "67841": 2,
  "67842": -11,
  "67843": -10,
  "67844": -11,
  "67846": -7,
  "67849": -13,
  "67850": -11,
  "67851": -7,
  "67853": 2,
  "67854": -10,
  "67855": -14,
  "67857": -14,
  "67859": -10,
  "67860": -7,
  "67861": -11,
  "67862": -13,
  "67863": -10,
  "67864": -11,
  "67865": -11,
  "67867": 10,
  "67868": -8,
  "67869": -10,
  "67870": -8,
  "67871": -10,
  "67876": -10,
  "67877": -8,
  "67878": -17,
  "67879": -17,
  "67880": -14,
  "67882": -10,
  "67901": -14,
  "67905": -14,
  "67950": -14,
  "67951": -14,
  "67952": -14,
  "67953": -15,
  "67954": -14,
  "68001": -3,
  "68002": -1,
  "68003": -3,
  "68004": -11,
  "68005": 0,
  "68007": 0,
  "68008": -1,
  "68009": -1,
  "68010": 1,
  "68014": -2,
  "68015": -5,
  "68016": -8,
  "68017": -2,
  "68018": -3,
  "68019": -17,
  "68020": -18,
  "68022": 1,
  "68023": 1,
  "68025": -5,
  "68026": -5,
  "68028": 1,
  "68029": -1,
  "68030": -1,
  "68031": -5,
  "68033": -2,
  "68034": -1,
  "68036": -4,
  "68037": -8,
  "68038": -18,
  "68039": -11,
  "68040": -2,
  "68041": -3,
  "68042": -2,
  "68044": -5,
  "68045": -18,
  "68046": 1,
  "68047": -11,
  "68048": -9,
  "68050": -2,
  "68055": -11,
  "68056": 1,
  "68057": -5,
  "68058": -8,
  "68059": 1,
  "68061": -17,
  "68062": -11,
  "68063": -17,
  "68064": -1,
  "68065": -2,
  "68066": -2,
  "68067": -11,
  "68068": -1,
  "68069": 1,
  "68070": -2,
  "68071": -11,
  "68072": -5,
  "68073": -3,
  "68101": 8,
  "68102": 8,
  "68103": 8,
  "68104": 0,
  "68105": 0,
  "68106": 0,
  "68107": 1,
  "68108": -1,
  "68109": -1,
  "68110": -1,
  "68111": 0,
  "68112": 0,
  "68113": 0,
  "68114": 0,
  "68116": 9,
  "68117": 0,
  "68118": 9,
  "68119": -1,
  "68120": 1,
  "68122": 0,
  "68123": 1,
  "68124": 0,
  "68127": 0,
  "68128": 1,
  "68130": 1,
  "68131": 0,
  "68132": 0,
  "68133": 9,
  "68134": 0,
  "68135": 9,
  "68136": 9,
  "68137": 0,
  "68138": 1,
  "68139": 0,
  "68142": 0,
  "68144": 0,
  "68145": 8,
  "68147": 1,
  "68152": 0,
  "68154": 1,
  "68155": 0,
  "68157": 1,
  "68164": 0,
  "68301": -13,
  "68303": -12,
  "68304": -8,
  "68305": -13,
  "68307": -5,
  "68309": -12,
  "68310": -12,
  "68313": -6,
  "68314": -6,
  "68315": -12,
  "68316": -8,
  "68317": -2,
  "68318": -12,
  "68319": -8,
  "68320": -13,
  "68321": -13,
  "68322": -12,
  "68323": -14,
  "68324": -13,
  "68325": -12,
  "68326": -12,
  "68327": -12,
  "68328": -11,
  "68329": -13,
  "68330": -6,
  "68331": -12,
  "68332": -13,
  "68333": -11,
  "68335": -12,
  "68336": 7,
  "68337": -17,
  "68338": -7,
  "68339": 7,
  "68340": -12,
  "68341": -11,
  "68342": -6,
  "68343": -11,
  "68344": -13,
  "68345": -15,
  "68346": -5,
  "68347": -2,
  "68348": -13,
  "68349": -8,
  "68350": -7,
  "68351": 4,
  "68352": -6,
  "68354": 4,
  "68355": -17,
  "68357": -12,
  "68358": 7,
  "68359": -11,
  "68360": -6,
  "68361": 4,
  "68362": -12,
  "68364": -6,
  "68365": 4,
  "68366": -2,
  "68367": -10,
  "68368": -11,
  "68370": -12,
  "68371": -8,
  "68372": -2,
  "68375": -12,
  "68376": -15,
  "68377": -6,
  "68378": -13,
  "68379": -13,
  "68380": -14,
  "68381": -12,
  "68382": -6,
  "68401": -8,
  "68402": 7,
  "68403": -8,
  "68404": 7,
  "68405": -6,
  "68406": 4,
  "68407": -8,
  "68409": -9,
  "68410": -6,
  "68413": -8,
  "68414": -15,
  "68415": -12,
  "68416": 4,
  "68417": -6,
  "68418": -5,
  "68419": -2,
  "68420": -14,
  "68421": -15,
  "68422": -12,
  "68423": 3,
  "68424": -6,
  "68428": 7,
  "68429": -12,
  "68430": 7,
  "68431": -15,
  "68433": -17,
  "68434": -6,
  "68436": 4,
  "68437": -17,
  "68438": 7,
  "68439": -6,
  "68440": -7,
  "68441": -13,
  "68442": -17,
  "68443": -13,
  "68444": 4,
  "68445": -11,
  "68446": -5,
  "68447": -14,
  "68448": -6,
  "68450": -13,
  "68452": -4,
  "68453": 4,
  "68454": -5,
  "68455": -1,
  "68456": -6,
  "68457": -17,
  "68458": -12,
  "68460": -8,
  "68461": 7,
  "68462": -2,
  "68463": -8,
  "68464": -11,
  "68465": -11,
  "68466": -12,
  "68467": -8,
  "68501": -2,
  "68502": -2,
  "68503": -2,
  "68504": -2,
  "68505": -2,
  "68506": 0,
  "68507": -2,
  "68508": -2,
  "68509": -2,
  "68510": -2,
  "68512": 7,
  "68514": 7,
  "68516": 7,
  "68517": 7,
  "68520": 7,
  "68521": -2,
  "68522": -2,
  "68523": 7,
  "68524": -2,
  "68526": 7,
  "68527": 7,
  "68528": -2,
  "68529": -2,
  "68531": -2,
  "68532": 7,
  "68542": -2,
  "68583": -2,
  "68588": -2,
  "68601": 1,
  "68602": 1,
  "68620": -6,
  "68621": -5,
  "68622": -14,
  "68623": -15,
  "68624": 1,
  "68626": -2,
  "68627": -6,
  "68628": 17,
  "68629": 0,
  "68631": 1,
  "68632": 1,
  "68633": -10,
  "68634": 1,
  "68635": -6,
  "68636": -4,
  "68637": -13,
  "68638": -15,
  "68640": -15,
  "68641": -10,
  "68642": 1,
  "68643": 1,
  "68644": -6,
  "68647": 1,
  "68648": -5,
  "68649": -5,
  "68651": -10,
  "68652": -7,
  "68653": 1,
  "68654": -11,
  "68655": -6,
  "68658": -10,
  "68659": -4,
  "68660": -6,
  "68661": 1,
  "68662": -10,
  "68663": -10,
  "68664": -10,
  "68665": -12,
  "68666": -10,
  "68667": -10,
  "68669": -6,
  "68701": -7,
  "68702": -7,
  "68710": 4,
  "68711": -7,
  "68713": -7,
  "68714": -15,
  "68715": -7,
  "68716": -11,
  "68717": -13,
  "68718": -15,
  "68719": -21,
  "68720": -4,
  "68722": -21,
  "68723": -15,
  "68724": -15,
  "68725": -7,
  "68726": -4,
  "68727": -13,
  "68728": 4,
  "68729": -15,
  "68730": -13,
  "68731": -1,
  "68732": 4,
  "68733": -11,
  "68734": -7,
  "68735": -4,
  "68736": -13,
  "68738": -7,
  "68739": -13,
  "68740": -15,
  "68741": -1,
  "68742": -7,
  "68743": 1,
  "68745": 4,
  "68746": -21,
  "68747": -8,
  "68748": -7,
  "68749": -8,
  "68751": 4,
  "68752": -7,
  "68753": -15,
  "68755": -21,
  "68756": -4,
  "68757": 4,
  "68758": -7,
  "68759": -15,
  "68760": -14,
  "68761": -5,
  "68763": -7,
  "68764": -4,
  "68765": -8,
  "68766": -7,
  "68767": -8,
  "68768": -15,
  "68769": -8,
  "68770": 4,
  "68771": -8,
  "68773": -5,
  "68774": -13,
  "68776": -1,
  "68777": -21,
  "68778": -15,
  "68779": -7,
  "68780": -5,
  "68781": -4,
  "68783": -15,
  "68784": -15,
  "68785": 4,
  "68786": -8,
  "68787": -15,
  "68788": -11,
  "68789": -15,
  "68790": -15,
  "68791": -11,
  "68792": -13,
  "68801": -6,
  "68802": -6,
  "68803": -6,
  "68810": -6,
  "68812": -5,
  "68813": -17,
  "68814": -15,
  "68815": -14,
  "68816": 17,
  "68817": -15,
  "68818": -4,
  "68820": -14,
  "68821": -17,
  "68822": -14,
  "68823": -17,
  "68824": -6,
  "68825": -8,
  "68826": 17,
  "68827": 17,
  "68828": -14,
  "68831": -6,
  "68832": -6,
  "68833": -15,
  "68834": -8,
  "68835": -12,
  "68836": -6,
  "68837": -14,
  "68838": -14,
  "68840": -5,
  "68841": -4,
  "68842": -12,
  "68843": -4,
  "68844": -14,
  "68845": -3,
  "68846": 17,
  "68847": -5,
  "68848": -5,
  "68850": -8,
  "68852": -15,
  "68853": -14,
  "68854": 17,
  "68855": -15,
  "68856": -14,
  "68858": -5,
  "68859": -13,
  "68860": -8,
  "68861": -6,
  "68862": -14,
  "68863": -8,
  "68864": 17,
  "68865": -4,
  "68866": -5,
  "68869": -14,
  "68870": -5,
  "68871": -14,
  "68872": -6,
  "68873": -12,
  "68874": -18,
  "68875": -13,
  "68876": -5,
  "68878": -8,
  "68879": -18,
  "68881": -14,
  "68882": -13,
  "68883": -6,
  "68901": -3,
  "68902": -3,
  "68920": -6,
  "68922": -9,
  "68923": -6,
  "68924": -15,
  "68925": -3,
  "68926": -10,
  "68927": -6,
  "68928": -4,
  "68929": -16,
  "68930": -3,
  "68932": -16,
  "68933": -3,
  "68934": -4,
  "68935": -3,
  "68936": -10,
  "68937": -8,
  "68938": -3,
  "68939": -16,
  "68940": -6,
  "68941": -3,
  "68942": -15,
  "68943": -15,
  "68944": -4,
  "68945": -15,
  "68946": -9,
  "68947": -15,
  "68948": -10,
  "68949": -6,
  "68950": -3,
  "68952": -16,
  "68954": -3,
  "68955": -3,
  "68956": -3,
  "68957": -15,
  "68958": -6,
  "68959": -15,
  "68960": -16,
  "68961": -15,
  "68964": -15,
  "68966": -10,
  "68967": -9,
  "68969": -6,
  "68970": -15,
  "68971": -6,
  "68972": -16,
  "68973": -3,
  "68974": -15,
  "68975": -3,
  "68976": -8,
  "68977": -10,
  "68978": -15,
  "68979": -3,
  "68980": -4,
  "68981": -16,
  "68982": -6,
  "69001": -12,
  "69020": -12,
  "69021": -16,
  "69022": -9,
  "69023": -16,
  "69024": -15,
  "69025": -12,
  "69026": -12,
  "69027": -15,
  "69028": -8,
  "69029": -8,
  "69030": -16,
  "69032": -15,
  "69033": -15,
  "69034": -12,
  "69036": -12,
  "69037": -15,
  "69038": -8,
  "69039": -12,
  "69040": -15,
  "69041": -16,
  "69042": -12,
  "69043": -15,
  "69044": -15,
  "69045": -16,
  "69046": -10,
  "69101": -8,
  "69103": -8,
  "69120": -8,
  "69121": -20,
  "69122": -17,
  "69123": -8,
  "69125": -19,
  "69127": -17,
  "69128": -14,
  "69129": -12,
  "69130": -8,
  "69131": -12,
  "69132": -7,
  "69133": -14,
  "69134": -6,
  "69135": -16,
  "69138": -8,
  "69140": -6,
  "69141": -12,
  "69142": -15,
  "69143": -8,
  "69144": -17,
  "69145": -14,
  "69146": -17,
  "69147": -17,
  "69148": -19,
  "69149": -12,
  "69150": -6,
  "69151": -8,
  "69152": -21,
  "69153": -17,
  "69154": -12,
  "69155": -17,
  "69156": -12,
  "69157": -15,
  "69161": -13,
  "69162": -12,
  "69163": -8,
  "69165": -8,
  "69166": -16,
  "69167": -8,
  "69168": -6,
  "69169": -6,
  "69170": -7,
  "69171": -8,
  "69201": -14,
  "69210": -15,
  "69211": -13,
  "69212": -14,
  "69214": -15,
  "69216": -14,
  "69217": -15,
  "69218": -16,
  "69219": -14,
  "69220": -16,
  "69221": -16,
  "69301": -8,
  "69331": -19,
  "69333": -20,
  "69334": -19,
  "69335": -8,
  "69336": -19,
  "69337": -15,
  "69339": -15,
  "69340": -8,
  "69341": -1,
  "69343": -8,
  "69345": -1,
  "69346": -15,
  "69347": -8,
  "69348": -9,
  "69350": -21,
  "69351": -8,
  "69352": -1,
  "69353": -1,
  "69354": -15,
  "69355": -1,
  "69356": -1,
  "69357": -1,
  "69358": -1,
  "69360": -8,
  "69361": -1,
  "69363": -1,
  "69365": -18,
  "69366": -21,
  "69367": -15,
  "70001": 6,
  "70002": 14,
  "70003": 6,
  "70004": 7,
  "70005": 14,
  "70006": 7,
  "70009": 14,
  "70010": 14,
  "70011": 14,
  "70030": 33,
  "70031": 34,
  "70032": 7,
  "70033": 6,
  "70036": 5,
  "70037": 6,
  "70038": 11,
  "70039": 33,
  "70040": 6,
  "70041": 11,
  "70043": 6,
  "70044": 6,
  "70047": 34,
  "70049": 12,
  "70050": 11,
  "70051": 11,
  "70052": 6,
  "70053": 7,
  "70054": 7,
  "70055": 14,
  "70056": 7,
  "70057": 33,
  "70058": 5,
  "70059": 7,
  "70062": 5,
  "70063": 5,
  "70064": 6,
  "70065": 6,
  "70067": 5,
  "70068": 12,
  "70069": 12,
  "70070": 34,
  "70071": 6,
  "70072": 5,
  "70073": 5,
  "70075": 6,
  "70076": 11,
  "70078": 34,
  "70079": 33,
  "70080": 33,
  "70081": 11,
  "70082": 11,
  "70083": 11,
  "70084": 12,
  "70085": 6,
  "70086": 6,
  "70087": 33,
  "70090": 6,
  "70091": 11,
  "70092": 6,
  "70093": 6,
  "70094": 7,
  "70096": 5,
  "70097": 6,
  "70112": 8,
  "70113": 7,
  "70114": 7,
  "70115": 7,
  "70116": 7,
  "70117": 7,
  "70118": 6,
  "70119": 7,
  "70121": 5,
  "70122": 7,
  "70123": 7,
  "70124": 16,
  "70125": 6,
  "70126": 7,
  "70127": 7,
  "70128": 7,
  "70129": 6,
  "70130": 16,
  "70131": 8,
  "70139": 8,
  "70140": 8,
  "70141": 5,
  "70145": 7,
  "70146": 7,
  "70149": 7,
  "70150": 7,
  "70151": 7,
  "70152": 7,
  "70153": 7,
  "70156": 7,
  "70157": 7,
  "70158": 7,
  "70160": 7,
  "70161": 7,
  "70163": 8,
  "70170": 8,
  "70172": 8,
  "70174": 7,
  "70175": 7,
  "70176": 16,
  "70177": 7,
  "70178": 6,
  "70179": 7,
  "70181": 7,
  "70182": 7,
  "70183": 7,
  "70184": 16,
  "70185": 6,
  "70186": 7,
  "70187": 7,
  "70189": 6,
  "70190": 16,
  "70301": 6,
  "70302": 6,
  "70339": 5,
  "70340": 6,
  "70341": 4,
  "70342": 6,
  "70343": 5,
  "70344": 10,
  "70345": 5,
  "70346": 14,
  "70352": 11,
  "70353": 10,
  "70354": 5,
  "70355": 5,
  "70356": 11,
  "70357": 5,
  "70358": 11,
  "70359": 11,
  "70360": 19,
  "70361": 19,
  "70363": 11,
  "70364": 11,
  "70371": 33,
  "70372": 4,
  "70373": 5,
  "70374": 5,
  "70375": 5,
  "70377": 5,
  "70380": 6,
  "70381": 6,
  "70390": 4,
  "70391": 4,
  "70392": 6,
  "70393": 5,
  "70394": 5,
  "70395": 11,
  "70397": 11,
  "70401": 4,
  "70403": 4,
  "70404": 4,
  "70420": 5,
  "70421": 4,
  "70422": 4,
  "70426": -2,
  "70427": -1,
  "70429": -1,
  "70431": 5,
  "70433": 5,
  "70434": 5,
  "70435": 5,
  "70436": 4,
  "70437": 4,
  "70438": 0,
  "70441": -2,
  "70442": 4,
  "70443": 4,
  "70444": 4,
  "70445": 5,
  "70446": 4,
  "70447": 5,
  "70448": 7,
  "70449": 14,
  "70450": 0,
  "70451": 4,
  "70452": 5,
  "70453": 9,
  "70454": 4,
  "70455": 4,
  "70456": 4,
  "70457": 5,
  "70458": 5,
  "70459": 5,
  "70460": 5,
  "70461": 5,
  "70462": 9,
  "70463": 5,
  "70464": 4,
  "70465": 4,
  "70466": 4,
  "70467": -2,
  "70469": 5,
  "70470": 13,
  "70471": 13,
  "70500": 7,
  "70501": 7,
  "70502": 7,
  "70503": 15,
  "70505": 8,
  "70506": 8,
  "70507": 7,
  "70508": 15,
  "70509": 7,
  "70510": 6,
  "70511": 6,
  "70512": 12,
  "70513": 6,
  "70514": 7,
  "70515": -3,
  "70516": 6,
  "70517": 0,
  "70518": 8,
  "70519": 8,
  "70520": 7,
  "70521": 0,
  "70522": 7,
  "70523": 7,
  "70524": -6,
  "70525": 12,
  "70526": 6,
  "70527": 6,
  "70528": 6,
  "70529": 7,
  "70531": 6,
  "70532": -15,
  "70533": 6,
  "70534": 6,
  "70535": -6,
  "70537": -3,
  "70538": 7,
  "70540": 7,
  "70541": 12,
  "70542": 6,
  "70543": 6,
  "70544": 6,
  "70546": -4,
  "70548": 6,
  "70549": -5,
  "70550": 12,
  "70551": 12,
  "70552": 6,
  "70554": -6,
  "70555": 7,
  "70556": -3,
  "70558": 7,
  "70559": 6,
  "70560": 6,
  "70562": 6,
  "70563": 6,
  "70569": 6,
  "70570": 12,
  "70571": 12,
  "70575": 6,
  "70576": -8,
  "70577": 12,
  "70578": 6,
  "70580": -6,
  "70581": -4,
  "70582": 0,
  "70583": 7,
  "70584": 12,
  "70585": -6,
  "70586": -6,
  "70589": 12,
  "70591": -4,
  "70592": 15,
  "70593": 7,
  "70595": 7,
  "70596": 7,
  "70598": 15,
  "70601": 0,
  "70602": 0,
  "70605": 0,
  "70606": 8,
  "70607": 0,
  "70611": 8,
  "70612": 0,
  "70615": -1,
  "70616": 0,
  "70629": 0,
  "70630": 4,
  "70631": 4,
  "70632": 4,
  "70633": 0,
  "70634": -9,
  "70637": -22,
  "70638": -22,
  "70639": -12,
  "70640": -12,
  "70643": 4,
  "70644": -22,
  "70645": 4,
  "70646": -12,
  "70647": -11,
  "70648": -22,
  "70650": -12,
  "70651": -22,
  "70652": -9,
  "70653": -9,
  "70654": -22,
  "70655": -22,
  "70656": -22,
  "70657": -1,
  "70658": -1,
  "70659": -9,
  "70660": -9,
  "70661": -1,
  "70662": -22,
  "70663": 0,
  "70664": 0,
  "70665": 0,
  "70668": -1,
  "70669": 0,
  "70704": 14,
  "70706": 9,
  "70707": 14,
  "70710": 12,
  "70711": 4,
  "70712": 52,
  "70714": 14,
  "70715": -5,
  "70718": 14,
  "70719": 12,
  "70721": 13,
  "70722": 9,
  "70723": 7,
  "70725": 14,
  "70726": 9,
  "70727": 9,
  "70728": 14,
  "70729": -5,
  "70730": -2,
  "70732": -4,
  "70733": 14,
  "70734": 13,
  "70736": -5,
  "70737": 14,
  "70738": 14,
  "70739": 14,
  "70740": 11,
  "70743": 6,
  "70744": 9,
  "70747": 51,
  "70748": -2,
  "70749": -4,
  "70750": -4,
  "70752": -5,
  "70753": 51,
  "70754": 9,
  "70755": -4,
  "70756": -4,
  "70757": -4,
  "70759": -4,
  "70760": -4,
  "70761": -2,
  "70762": 4,
  "70763": 6,
  "70764": 12,
  "70765": 12,
  "70767": 12,
  "70769": 14,
  "70770": 14,
  "70772": 11,
  "70773": -4,
  "70774": 14,
  "70775": 52,
  "70776": 14,
  "70777": 14,
  "70778": 14,
  "70780": 12,
  "70782": 52,
  "70783": -4,
  "70784": 52,
  "70785": 9,
  "70786": 9,
  "70787": 51,
  "70788": 12,
  "70789": -2,
  "70791": 14,
  "70792": 6,
  "70801": 22,
  "70802": 13,
  "70804": 13,
  "70805": 13,
  "70806": 14,
  "70807": 13,
  "70808": 22,
  "70809": 15,
  "70810": 22,
  "70811": 14,
  "70812": 14,
  "70814": 14,
  "70815": 14,
  "70816": 14,
  "70817": 22,
  "70818": 14,
  "70819": 14,
  "70820": 20,
  "70821": 14,
  "70825": 14,
  "70826": 15,
  "70827": 14,
  "70831": 22,
  "70835": 14,
  "70836": 22,
  "70837": 13,
  "70873": 14,
  "70874": 14,
  "70879": 22,
  "70884": 22,
  "70892": 13,
  "70893": 22,
  "70894": 22,
  "70895": 14,
  "70896": 22,
  "70898": 22,
  "71001": -9,
  "71002": 0,
  "71003": 58,
  "71004": -6,
  "71006": 2,
  "71007": 2,
  "71008": -15,
  "71009": -6,
  "71016": -15,
  "71018": -5,
  "71019": 0,
  "71021": -5,
  "71023": -5,
  "71024": -15,
  "71027": -3,
  "71028": -15,
  "71029": -7,
  "71030": -3,
  "71031": -14,
  "71032": -3,
  "71033": -5,
  "71034": 0,
  "71037": 2,
  "71038": 58,
  "71039": -15,
  "71040": 58,
  "71043": -7,
  "71044": -9,
  "71045": -15,
  "71046": -3,
  "71047": -6,
  "71048": 58,
  "71049": -3,
  "71050": -3,
  "71051": 0,
  "71052": -3,
  "71055": -5,
  "71058": -5,
  "71060": -6,
  "71061": -6,
  "71063": -1,
  "71064": -7,
  "71065": -10,
  "71066": -13,
  "71067": 2,
  "71068": 0,
  "71069": -10,
  "71070": -15,
  "71071": -5,
  "71072": -5,
  "71073": -5,
  "71075": -5,
  "71078": -3,
  "71079": 58,
  "71080": -15,
  "71082": -6,
  "71101": -6,
  "71102": -6,
  "71103": -6,
  "71104": -6,
  "71105": 3,
  "71106": 2,
  "71107": -6,
  "71108": -6,
  "71109": -6,
  "71110": 2,
  "71111": 2,
  "71112": -5,
  "71113": -5,
  "71115": 3,
  "71118": -5,
  "71119": -5,
  "71120": -6,
  "71129": -6,
  "71130": -6,
  "71133": -6,
  "71134": -6,
  "71135": 3,
  "71136": 2,
  "71137": -6,
  "71138": -5,
  "71148": -6,
  "71149": -6,
  "71150": -6,
  "71161": -6,
  "71162": -6,
  "71163": -6,
  "71164": -6,
  "71165": -6,
  "71166": -6,
  "71171": -6,
  "71172": 2,
  "71201": 0,
  "71202": -9,
  "71203": 0,
  "71207": 0,
  "71210": 0,
  "71211": -9,
  "71213": 0,
  "71217": 0,
  "71218": -8,
  "71219": -8,
  "71220": -11,
  "71221": -11,
  "71222": 2,
  "71223": -11,
  "71225": 0,
  "71226": -9,
  "71227": -9,
  "71229": -11,
  "71230": -20,
  "71232": -8,
  "71233": -21,
  "71234": 2,
  "71235": -9,
  "71237": -10,
  "71238": -7,
  "71240": -9,
  "71241": 2,
  "71242": -10,
  "71243": -20,
  "71245": 0,
  "71247": -15,
  "71249": -20,
  "71250": -10,
  "71251": -13,
  "71253": -10,
  "71254": -22,
  "71256": 1,
  "71259": -8,
  "71260": 1,
  "71261": -11,
  "71263": -10,
  "71264": -8,
  "71266": -10,
  "71268": -9,
  "71269": -8,
  "71270": 0,
  "71273": 0,
  "71275": -9,
  "71276": -22,
  "71277": 2,
  "71279": -8,
  "71280": 0,
  "71281": 0,
  "71282": -21,
  "71284": -21,
  "71286": -22,
  "71291": 0,
  "71292": -9,
  "71294": 0,
  "71295": -20,
  "71301": 3,
  "71302": 3,
  "71303": 11,
  "71306": 3,
  "71307": 3,
  "71309": 3,
  "71315": 3,
  "71316": -4,
  "71320": -6,
  "71322": -6,
  "71323": 3,
  "71324": -20,
  "71325": -6,
  "71326": -12,
  "71327": -6,
  "71328": 4,
  "71329": -6,
  "71330": -6,
  "71331": -6,
  "71333": -6,
  "71334": -12,
  "71336": -20,
  "71339": -6,
  "71340": -10,
  "71341": -6,
  "71342": -17,
  "71343": -11,
  "71345": 5,
  "71346": 3,
  "71348": 3,
  "71350": -6,
  "71351": -6,
  "71353": -11,
  "71354": -12,
  "71355": -6,
  "71356": -6,
  "71357": -21,
  "71358": 5,
  "71360": 3,
  "71361": 3,
  "71362": -6,
  "71363": -17,
  "71365": 3,
  "71366": -19,
  "71367": -14,
  "71368": -20,
  "71369": -6,
  "71371": -17,
  "71373": -12,
  "71375": -12,
  "71377": -11,
  "71378": -20,
  "71401": -11,
  "71403": -12,
  "71404": -14,
  "71405": 3,
  "71406": -10,
  "71407": 1,
  "71409": 3,
  "71410": -14,
  "71411": -12,
  "71414": -13,
  "71415": -17,
  "71416": -13,
  "71417": 1,
  "71418": -19,
  "71419": -10,
  "71422": -14,
  "71423": 1,
  "71424": 3,
  "71425": -10,
  "71426": -11,
  "71427": 0,
  "71428": -4,
  "71429": -11,
  "71430": 3,
  "71431": 3,
  "71432": -18,
  "71433": 3,
  "71434": -13,
  "71435": -10,
  "71438": 3,
  "71439": -12,
  "71440": -14,
  "71441": -10,
  "71443": -12,
  "71446": -12,
  "71447": 1,
  "71448": 3,
  "71449": -11,
  "71450": -10,
  "71452": -13,
  "71454": -13,
  "71455": 0,
  "71456": -13,
  "71457": -11,
  "71458": -11,
  "71459": -9,
  "71460": -10,
  "71461": -12,
  "71462": -10,
  "71463": -22,
  "71465": -17,
  "71466": 3,
  "71467": 1,
  "71468": -13,
  "71469": -10,
  "71471": -13,
  "71472": 3,
  "71473": -14,
  "71474": -12,
  "71475": -12,
  "71477": 3,
  "71479": -18,
  "71480": -18,
  "71483": -14,
  "71485": 11,
  "71486": -10,
  "71496": -12,
  "71601": -11,
  "71602": -11,
  "71603": -11,
  "71611": -11,
  "71612": -11,
  "71613": -11,
  "71630": -13,
  "71631": -18,
  "71635": -6,
  "71638": -10,
  "71639": -12,
  "71640": -10,
  "71642": -7,
  "71643": -8,
  "71644": -8,
  "71646": -6,
  "71647": -18,
  "71651": -17,
  "71652": 10,
  "71653": -12,
  "71654": -12,
  "71655": -10,
  "71656": -10,
  "71657": -10,
  "71658": -6,
  "71659": -8,
  "71660": -18,
  "71661": -6,
  "71662": -12,
  "71663": -6,
  "71665": -11,
  "71666": -13,
  "71667": -8,
  "71670": -13,
  "71671": -18,
  "71674": -4,
  "71675": -10,
  "71676": -6,
  "71677": -13,
  "71678": -8,
  "71701": -9,
  "71711": -9,
  "71720": -16,
  "71721": -10,
  "71722": -9,
  "71724": -4,
  "71725": 10,
  "71726": -9,
  "71728": -10,
  "71730": -4,
  "71731": -4,
  "71740": -13,
  "71742": 10,
  "71743": -10,
  "71744": -16,
  "71745": -16,
  "71747": 1,
  "71748": 10,
  "71749": -4,
  "71750": -4,
  "71751": -9,
  "71752": -14,
  "71753": -13,
  "71754": -13,
  "71758": -9,
  "71759": -4,
  "71762": -4,
  "71763": 10,
  "71764": -14,
  "71765": -4,
  "71766": -16,
  "71768": -4,
  "71770": -14,
  "71772": -10,
  "71801": -14,
  "71802": -14,
  "71820": 1,
  "71822": -7,
  "71823": -7,
  "71825": -15,
  "71826": -9,
  "71827": -9,
  "71828": -14,
  "71831": -15,
  "71832": -5,
  "71833": -5,
  "71834": -10,
  "71835": -15,
  "71836": -7,
  "71837": -9,
  "71838": -15,
  "71839": -9,
  "71840": -1,
  "71841": -6,
  "71842": -5,
  "71845": -9,
  "71846": -6,
  "71847": -15,
  "71851": -13,
  "71852": -5,
  "71853": -10,
  "71854": -1,
  "71855": -15,
  "71857": -15,
  "71858": -14,
  "71859": -15,
  "71860": -9,
  "71861": -9,
  "71862": -15,
  "71864": -14,
  "71865": -7,
  "71866": -5,
  "71901": -11,
  "71902": -11,
  "71903": -11,
  "71909": -9,
  "71910": -9,
  "71913": -11,
  "71914": -11,
  "71920": -20,
  "71921": -20,
  "71922": -10,
  "71923": -1,
  "71929": -8,
  "71932": -10,
  "71933": -18,
  "71935": -19,
  "71937": -11,
  "71940": -20,
  "71941": -15,
  "71942": -15,
  "71943": -20,
  "71944": -6,
  "71945": -10,
  "71949": -11,
  "71950": -20,
  "71951": -11,
  "71952": -12,
  "71953": -10,
  "71956": -11,
  "71957": -19,
  "71958": -20,
  "71959": -13,
  "71960": -19,
  "71961": -19,
  "71962": -10,
  "71964": -11,
  "71965": -19,
  "71966": -19,
  "71968": -11,
  "71969": -19,
  "71970": -19,
  "71971": -13,
  "71972": -11,
  "71973": -11,
  "72001": -14,
  "72002": -7,
  "72003": -8,
  "72004": -12,
  "72005": -9,
  "72006": -20,
  "72007": -9,
  "72010": -9,
  "72011": -7,
  "72012": -9,
  "72013": -16,
  "72014": -9,
  "72015": -7,
  "72016": 0,
  "72017": -16,
  "72018": -7,
  "72019": -7,
  "72020": -7,
  "72021": -14,
  "72022": -6,
  "72023": -2,
  "72024": -11,
  "72025": -14,
  "72026": 0,
  "72027": -1,
  "72028": -16,
  "72029": -15,
  "72030": -1,
  "72031": -16,
  "72032": -8,
  "72033": -8,
  "72034": -8,
  "72036": -20,
  "72037": -11,
  "72038": 0,
  "72039": -8,
  "72040": -16,
  "72041": -16,
  "72042": -8,
  "72043": -9,
  "72044": -11,
  "72045": -10,
  "72046": -10,
  "72047": -8,
  "72048": -8,
  "72051": -20,
  "72052": -9,
  "72053": -3,
  "72055": -8,
  "72057": -3,
  "72058": -8,
  "72059": -20,
  "72060": -9,
  "72061": -8,
  "72063": -1,
  "72064": -16,
  "72065": -1,
  "72066": -11,
  "72067": -11,
  "72068": -9,
  "72069": -15,
  "72070": -14,
  "72072": -12,
  "72073": -8,
  "72074": -20,
  "72075": -9,
  "72076": -3,
  "72078": -3,
  "72079": -3,
  "72080": -1,
  "72081": -9,
  "72082": -9,
  "72083": -10,
  "72084": -3,
  "72085": -9,
  "72086": -11,
  "72087": -7,
  "72088": -16,
  "72089": -6,
  "72101": -19,
  "72102": -9,
  "72103": -1,
  "72104": -15,
  "72105": -15,
  "72106": -8,
  "72107": -8,
  "72108": -14,
  "72110": -2,
  "72111": -10,
  "72112": -9,
  "72113": -1,
  "72114": -2,
  "72115": -2,
  "72116": 7,
  "72117": -2,
  "72118": -2,
  "72119": -2,
  "72120": -2,
  "72121": -9,
  "72122": -7,
  "72123": -19,
  "72124": 7,
  "72125": -14,
  "72126": -14,
  "72127": -2,
  "72128": -2,
  "72129": -2,
  "72130": -11,
  "72131": -11,
  "72132": -3,
  "72133": -8,
  "72134": -14,
  "72135": 0,
  "72136": -9,
  "72137": -11,
  "72139": -9,
  "72140": -8,
  "72141": -16,
  "72142": -10,
  "72143": -7,
  "72145": -7,
  "72150": -3,
  "72152": -11,
  "72153": -16,
  "72156": -2,
  "72157": -1,
  "72158": -7,
  "72160": -8,
  "72164": -1,
  "72165": -7,
  "72166": -12,
  "72167": -7,
  "72168": -12,
  "72169": -19,
  "72170": -8,
  "72173": -8,
  "72175": -12,
  "72176": -11,
  "72178": -9,
  "72179": -11,
  "72180": -1,
  "72181": -8,
  "72182": -12,
  "72183": -1,
  "72190": 7,
  "72201": -3,
  "72202": -1,
  "72203": -1,
  "72204": -1,
  "72205": -1,
  "72206": -1,
  "72207": 0,
  "72209": -1,
  "72210": -1,
  "72211": -1,
  "72212": 7,
  "72214": -2,
  "72215": -1,
  "72216": -2,
  "72217": 0,
  "72219": -1,
  "72221": 7,
  "72222": -1,
  "72223": -3,
  "72225": -1,
  "72227": 0,
  "72231": -3,
  "72260": -3,
  "72295": -3,
  "72301": -4,
  "72303": -4,
  "72310": 8,
  "72311": -15,
  "72312": -20,
  "72313": 6,
  "72315": 8,
  "72316": 8,
  "72319": 8,
  "72320": -9,
  "72321": 16,
  "72322": -8,
  "72324": -16,
  "72325": -4,
  "72326": -8,
  "72327": -4,
  "72328": -20,
  "72329": 7,
  "72330": 6,
  "72331": -4,
  "72332": -4,
  "72333": -20,
  "72335": -8,
  "72336": -8,
  "72338": 6,
  "72339": -4,
  "72340": -9,
  "72341": -9,
  "72342": -20,
  "72346": -4,
  "72347": -16,
  "72348": -9,
  "72350": 6,
  "72351": 8,
  "72352": -9,
  "72353": -20,
  "72354": -12,
  "72355": -9,
  "72358": 8,
  "72359": -9,
  "72360": -9,
  "72364": 4,
  "72365": -12,
  "72366": -20,
  "72367": -20,
  "72368": -9,
  "72369": -20,
  "72370": 8,
  "72372": -9,
  "72373": -17,
  "72374": -20,
  "72376": -4,
  "72377": -12,
  "72379": -12,
  "72383": -20,
  "72384": -4,
  "72386": -14,
  "72387": -17,
  "72389": -20,
  "72390": -20,
  "72391": 6,
  "72392": -15,
  "72394": -9,
  "72395": 7,
  "72396": -17,
  "72401": 6,
  "72402": 6,
  "72403": 6,
  "72404": 6,
  "72410": 5,
  "72411": -3,
  "72412": -9,
  "72413": -19,
  "72414": -3,
  "72415": 5,
  "72416": -3,
  "72417": -3,
  "72419": 8,
  "72421": 4,
  "72422": -12,
  "72424": -20,
  "72425": -9,
  "72426": 8,
  "72427": 4,
  "72428": 7,
  "72429": -9,
  "72430": -12,
  "72431": -9,
  "72432": -12,
  "72433": 5,
  "72434": 5,
  "72435": -12,
  "72436": -9,
  "72437": -3,
  "72438": 8,
  "72439": -7,
  "72440": 5,
  "72441": -12,
  "72442": 8,
  "72443": -9,
  "72444": -19,
  "72445": 5,
  "72447": -9,
  "72449": -20,
  "72450": -9,
  "72451": -9,
  "72453": -9,
  "72454": -12,
  "72455": -19,
  "72456": -12,
  "72457": 5,
  "72458": 5,
  "72459": -12,
  "72460": -19,
  "72461": -12,
  "72462": -20,
  "72464": -12,
  "72465": -3,
  "72466": 5,
  "72467": 6,
  "72469": 5,
  "72470": -12,
  "72471": -9,
  "72472": -12,
  "72473": -9,
  "72474": -7,
  "72475": -9,
  "72476": 5,
  "72478": -19,
  "72479": -12,
  "72482": -12,
  "72501": -4,
  "72503": -4,
  "72512": -11,
  "72513": -12,
  "72515": -7,
  "72517": -15,
  "72519": -7,
  "72520": -11,
  "72521": -4,
  "72522": -4,
  "72523": -4,
  "72524": -9,
  "72525": -12,
  "72526": -4,
  "72527": -4,
  "72528": -12,
  "72529": -12,
  "72530": -11,
  "72531": -7,
  "72532": -12,
  "72533": -20,
  "72534": -4,
  "72536": -15,
  "72537": -14,
  "72538": -14,
  "72539": -2,
  "72540": -20,
  "72542": -12,
  "72543": -11,
  "72544": -14,
  "72546": -11,
  "72550": -3,
  "72553": -5,
  "72554": -11,
  "72555": -3,
  "72556": -15,
  "72560": -20,
  "72561": -15,
  "72562": -4,
  "72564": -9,
  "72565": -15,
  "72566": -14,
  "72567": -20,
  "72568": -5,
  "72569": -12,
  "72571": -4,
  "72572": 5,
  "72573": -15,
  "72575": -4,
  "72576": -11,
  "72577": -14,
  "72578": -9,
  "72579": -4,
  "72581": -11,
  "72583": -9,
  "72584": -15,
  "72585": -7,
  "72587": -15,
  "72601": -8,
  "72602": -8,
  "72611": -8,
  "72613": -10,
  "72615": -8,
  "72616": -10,
  "72617": -20,
  "72619": -14,
  "72623": -14,
  "72624": -16,
  "72626": -14,
  "72628": -15,
  "72629": -16,
  "72630": -9,
  "72631": -8,
  "72632": -1,
  "72633": -8,
  "72634": -14,
  "72635": -14,
  "72636": -15,
  "72638": -10,
  "72639": -20,
  "72640": -15,
  "72641": -15,
  "72642": -14,
  "72644": -9,
  "72645": -16,
  "72648": -16,
  "72650": -16,
  "72651": -14,
  "72653": -14,
  "72654": -14,
  "72655": -15,
  "72657": -20,
  "72658": -12,
  "72659": -12,
  "72660": -10,
  "72661": -19,
  "72662": -8,
  "72663": -20,
  "72666": -15,
  "72668": -8,
  "72669": -8,
  "72670": -16,
  "72672": -14,
  "72675": -15,
  "72677": -14,
  "72679": -16,
  "72680": -20,
  "72682": -8,
  "72683": -15,
  "72685": -16,
  "72686": -16,
  "72687": -14,
  "72701": 7,
  "72702": 7,
  "72703": 7,
  "72704": -1,
  "72711": -5,
  "72712": -4,
  "72714": -4,
  "72715": 4,
  "72717": -2,
  "72718": -4,
  "72719": -5,
  "72721": 1,
  "72722": -5,
  "72727": -8,
  "72728": -1,
  "72729": -7,
  "72730": -1,
  "72732": -5,
  "72733": -5,
  "72734": -5,
  "72735": -8,
  "72736": -5,
  "72737": 7,
  "72738": -8,
  "72739": 4,
  "72740": -8,
  "72741": 7,
  "72742": -8,
  "72744": -2,
  "72745": -5,
  "72747": -5,
  "72749": -2,
  "72751": -5,
  "72752": -8,
  "72753": -2,
  "72756": -5,
  "72757": -4,
  "72758": -4,
  "72760": -8,
  "72761": -5,
  "72762": -1,
  "72764": -2,
  "72765": -2,
  "72766": -2,
  "72768": -5,
  "72769": -2,
  "72770": -1,
  "72773": -8,
  "72774": -2,
  "72776": -8,
  "72801": 1,
  "72802": 1,
  "72811": 1,
  "72812": 1,
  "72820": -16,
  "72821": -16,
  "72823": 1,
  "72824": -12,
  "72826": -10,
  "72827": -14,
  "72828": -12,
  "72829": 1,
  "72830": -17,
  "72832": -17,
  "72833": -12,
  "72834": 1,
  "72835": -17,
  "72837": 1,
  "72838": -14,
  "72839": -16,
  "72840": -17,
  "72841": -14,
  "72842": -10,
  "72843": 1,
  "72845": -16,
  "72846": -16,
  "72847": 1,
  "72851": -17,
  "72852": -16,
  "72853": 0,
  "72854": -16,
  "72855": -9,
  "72856": -15,
  "72857": -12,
  "72858": 1,
  "72860": -12,
  "72863": -17,
  "72865": -8,
  "72901": -10,
  "72902": -10,
  "72903": -1,
  "72904": -10,
  "72906": -1,
  "72908": -1,
  "72913": -10,
  "72914": -10,
  "72916": -1,
  "72917": -1,
  "72918": -1,
  "72921": 1,
  "72923": -10,
  "72926": -14,
  "72927": -9,
  "72928": -9,
  "72930": -16,
  "72932": -8,
  "72933": -16,
  "72934": -8,
  "72935": 1,
  "72936": -1,
  "72937": -10,
  "72938": -10,
  "72940": -10,
  "72941": -8,
  "72943": -9,
  "72944": -14,
  "72945": -10,
  "72946": -8,
  "72947": -16,
  "72948": -8,
  "72949": -16,
  "72950": -14,
  "72951": -9,
  "72952": -8,
  "72955": -8,
  "72956": -8,
  "72957": -8,
  "72958": -14,
  "72959": -2,
  "73001": 4,
  "73002": -7,
  "73003": -2,
  "73004": -7,
  "73005": 4,
  "73006": 4,
  "73007": -2,
  "73008": -2,
  "73009": 4,
  "73010": -8,
  "73011": -7,
  "73012": -2,
  "73013": -2,
  "73014": -8,
  "73015": 4,
  "73016": -8,
  "73017": -8,
  "73018": -7,
  "73020": -2,
  "73021": -5,
  "73022": -8,
  "73023": -7,
  "73024": -6,
  "73025": -2,
  "73026": -4,
  "73027": -8,
  "73028": -9,
  "73029": 4,
  "73030": -7,
  "73031": -8,
  "73032": -10,
  "73033": 4,
  "73034": 6,
  "73036": -8,
  "73038": 4,
  "73039": 1,
  "73040": -6,
  "73041": -19,
  "73042": 4,
  "73043": -6,
  "73044": -8,
  "73045": 5,
  "73047": 5,
  "73048": -10,
  "73049": -2,
  "73050": -8,
  "73051": -8,
  "73052": -8,
  "73053": 5,
  "73054": 9,
  "73055": -7,
  "73056": -8,
  "73057": 0,
  "73058": -8,
  "73059": -8,
  "73061": -10,
  "73062": -19,
  "73063": -8,
  "73064": -8,
  "73065": -4,
  "73066": -2,
  "73067": -8,
  "73068": -4,
  "73069": -4,
  "73070": -4,
  "73071": -4,
  "73072": 4,
  "73073": -8,
  "73074": 1,
  "73075": 1,
  "73077": -10,
  "73078": -8,
  "73079": -8,
  "73080": -8,
  "73082": -8,
  "73083": 6,
  "73084": -2,
  "73085": -8,
  "73086": -7,
  "73089": -8,
  "73090": -8,
  "73092": -7,
  "73093": -8,
  "73094": 4,
  "73095": -8,
  "73096": -9,
  "73097": -2,
  "73098": 0,
  "73099": -8,
  "73101": -2,
  "73102": -2,
  "73103": -2,
  "73104": -2,
  "73105": -2,
  "73106": -2,
  "73107": -2,
  "73108": -3,
  "73109": -2,
  "73110": -2,
  "73111": -2,
  "73112": -2,
  "73113": -2,
  "73114": -2,
  "73115": -2,
  "73116": -2,
  "73117": -2,
  "73118": -2,
  "73119": -2,
  "73120": -2,
  "73121": -2,
  "73122": -2,
  "73123": -2,
  "73124": -2,
  "73125": -2,
  "73126": -2,
  "73127": -2,
  "73128": -2,
  "73129": -3,
  "73130": -2,
  "73131": 6,
  "73132": -2,
  "73134": 6,
  "73135": -2,
  "73136": 6,
  "73137": -2,
  "73139": -2,
  "73140": -2,
  "73141": -2,
  "73142": -2,
  "73143": -2,
  "73144": -2,
  "73145": -2,
  "73146": -2,
  "73147": -2,
  "73148": -3,
  "73149": -2,
  "73150": -2,
  "73151": 6,
  "73152": -2,
  "73153": -1,
  "73154": -2,
  "73155": -2,
  "73156": -2,
  "73157": -2,
  "73159": -2,
  "73160": -2,
  "73162": -2,
  "73163": -2,
  "73164": -2,
  "73165": 4,
  "73167": -2,
  "73169": -2,
  "73170": -2,
  "73172": -2,
  "73173": 6,
  "73178": -2,
  "73179": -2,
  "73189": -2,
  "73195": -2,
  "73401": -6,
  "73402": -6,
  "73403": -6,
  "73425": -7,
  "73430": -9,
  "73432": -9,
  "73433": 0,
  "73434": 1,
  "73435": -6,
  "73436": -10,
  "73437": -6,
  "73438": -6,
  "73439": -7,
  "73440": -7,
  "73441": -8,
  "73442": -13,
  "73443": -6,
  "73444": 0,
  "73446": -7,
  "73447": -10,
  "73448": -10,
  "73449": -9,
  "73450": -10,
  "73453": -8,
  "73455": -10,
  "73456": -14,
  "73458": -6,
  "73459": -10,
  "73460": -9,
  "73461": -10,
  "73463": -6,
  "73481": -6,
  "73487": 0,
  "73488": 8,
  "73491": -7,
  "73501": -11,
  "73502": -11,
  "73503": -3,
  "73505": -10,
  "73506": -10,
  "73507": -11,
  "73520": -13,
  "73521": -14,
  "73522": -14,
  "73523": -14,
  "73526": -14,
  "73527": -11,
  "73528": -8,
  "73529": -7,
  "73530": -10,
  "73531": -9,
  "73532": -14,
  "73533": -7,
  "73534": -7,
  "73537": -15,
  "73538": -11,
  "73539": -15,
  "73540": -11,
  "73541": -11,
  "73542": -12,
  "73543": -11,
  "73544": -15,
  "73546": -9,
  "73547": -15,
  "73548": -9,
  "73549": -18,
  "73550": -15,
  "73551": -9,
  "73552": -11,
  "73553": 0,
  "73554": -15,
  "73555": -19,
  "73556": -15,
  "73557": -3,
  "73558": -11,
  "73559": -19,
  "73560": -15,
  "73561": -14,
  "73562": -9,
  "73564": -19,
  "73565": -14,
  "73566": -19,
  "73567": -12,
  "73568": -9,
  "73569": -14,
  "73570": -19,
  "73571": -15,
  "73572": -8,
  "73573": -14,
  "73601": -10,
  "73620": -11,
  "73622": -6,
  "73624": -6,
  "73625": -11,
  "73626": -5,
  "73627": -5,
  "73628": -9,
  "73632": -6,
  "73638": -10,
  "73639": -11,
  "73641": -6,
  "73642": -9,
  "73644": -4,
  "73645": -5,
  "73646": -7,
  "73647": -6,
  "73648": -4,
  "73650": -9,
  "73651": -19,
  "73654": -10,
  "73655": -15,
  "73658": -7,
  "73659": -16,
  "73660": -9,
  "73661": -6,
  "73662": -5,
  "73663": -16,
  "73664": -6,
  "73666": -5,
  "73667": -16,
  "73668": -5,
  "73669": -11,
  "73673": -15,
  "73701": -8,
  "73702": -8,
  "73703": 1,
  "73705": -8,
  "73706": 1,
  "73716": -10,
  "73717": -18,
  "73718": -10,
  "73719": 1,
  "73720": 1,
  "73722": 2,
  "73724": -7,
  "73726": 2,
  "73727": -8,
  "73728": 2,
  "73729": -10,
  "73730": -8,
  "73731": -18,
  "73733": -8,
  "73734": 2,
  "73735": -7,
  "73736": -8,
  "73737": -10,
  "73738": -8,
  "73739": 2,
  "73741": 2,
  "73742": 2,
  "73743": -8,
  "73744": -7,
  "73746": -18,
  "73747": -10,
  "73749": 2,
  "73750": 4,
  "73753": -7,
  "73754": -8,
  "73755": -10,
  "73756": 2,
  "73757": -2,
  "73758": 1,
  "73759": -3,
  "73760": -10,
  "73761": 2,
  "73762": -8,
  "73763": -7,
  "73764": -7,
  "73766": -8,
  "73768": -10,
  "73770": -7,
  "73771": 2,
  "73772": -7,
  "73773": -8,
  "73801": -9,
  "73802": -9,
  "73832": -20,
  "73834": -13,
  "73835": -16,
  "73838": -16,
  "73840": -20,
  "73841": -9,
  "73842": -18,
  "73843": -20,
  "73844": -13,
  "73848": -13,
  "73851": -12,
  "73852": -9,
  "73853": -16,
  "73855": -13,
  "73857": -9,
  "73858": -20,
  "73859": -16,
  "73860": -18,
  "73901": 8,
  "73931": -7,
  "73932": -7,
  "73933": -6,
  "73937": -6,
  "73938": -8,
  "73939": -20,
  "73942": 8,
  "73944": -7,
  "73945": 8,
  "73946": -10,
  "73947": -20,
  "73949": -20,
  "73950": -7,
  "73951": -8,
  "74001": -7,
  "74002": -7,
  "74003": -7,
  "74005": -7,
  "74006": -7,
  "74008": 0,
  "74010": -3,
  "74011": 0,
  "74012": -1,
  "74013": -1,
  "74014": 10,
  "74015": -6,
  "74016": -6,
  "74017": -6,
  "74018": -6,
  "74019": -6,
  "74020": -11,
  "74021": -6,
  "74022": -7,
  "74023": -6,
  "74026": 8,
  "74027": -16,
  "74028": -5,
  "74029": -7,
  "74030": -4,
  "74031": -6,
  "74032": -4,
  "74033": -2,
  "74034": -12,
  "74035": -7,
  "74036": 1,
  "74037": 0,
  "74038": -12,
  "74039": -3,
  "74041": -3,
  "74042": -16,
  "74043": 0,
  "74044": -3,
  "74045": -12,
  "74046": -5,
  "74047": -7,
  "74048": -16,
  "74050": -2,
  "74051": -7,
  "74052": -12,
  "74053": -6,
  "74054": -12,
  "74055": 3,
  "74056": -7,
  "74058": -12,
  "74059": -5,
  "74060": -12,
  "74061": -7,
  "74062": -6,
  "74063": -2,
  "74066": -3,
  "74067": -3,
  "74068": -4,
  "74070": -2,
  "74071": -4,
  "74072": -17,
  "74073": -2,
  "74074": 3,
  "74075": 3,
  "74076": 3,
  "74079": 8,
  "74080": -6,
  "74081": -12,
  "74082": -7,
  "74083": -16,
  "74084": -7,
  "74085": -12,
  "74101": -2,
  "74102": 3,
  "74103": 7,
  "74104": -2,
  "74105": 0,
  "74106": -2,
  "74107": -2,
  "74108": -2,
  "74110": -2,
  "74112": -2,
  "74114": -2,
  "74115": -2,
  "74116": -2,
  "74117": -2,
  "74119": -2,
  "74120": 7,
  "74121": 7,
  "74126": -2,
  "74127": -2,
  "74128": -2,
  "74129": -2,
  "74130": -2,
  "74131": -2,
  "74132": 0,
  "74133": 7,
  "74134": -2,
  "74135": 7,
  "74136": 7,
  "74137": 7,
  "74145": -2,
  "74146": -2,
  "74147": -2,
  "74148": -2,
  "74149": -2,
  "74150": -2,
  "74152": -2,
  "74153": 7,
  "74155": -2,
  "74156": -2,
  "74157": -2,
  "74158": -2,
  "74159": -2,
  "74169": -2,
  "74170": 7,
  "74172": 7,
  "74301": -9,
  "74330": -1,
  "74331": -6,
  "74332": -9,
  "74333": -9,
  "74335": -14,
  "74337": -1,
  "74338": -7,
  "74339": -14,
  "74340": -6,
  "74342": -6,
  "74343": -14,
  "74344": 1,
  "74345": 1,
  "74346": -6,
  "74347": -7,
  "74349": -7,
  "74350": -6,
  "74352": -1,
  "74354": -14,
  "74355": -14,
  "74358": -14,
  "74359": -7,
  "74360": -14,
  "74361": -1,
  "74362": -1,
  "74363": -14,
  "74364": 0,
  "74365": -1,
  "74366": -1,
  "74367": -6,
  "74368": -7,
  "74369": -9,
  "74370": -14,
  "74401": -7,
  "74402": -7,
  "74403": -6,
  "74421": -7,
  "74422": -8,
  "74423": -7,
  "74425": -14,
  "74426": -14,
  "74427": -12,
  "74428": -14,
  "74429": 1,
  "74430": -5,
  "74431": -8,
  "74432": -13,
  "74434": -6,
  "74435": -7,
  "74436": 1,
  "74437": -8,
  "74438": -14,
  "74439": -7,
  "74440": -14,
  "74441": -11,
  "74442": -6,
  "74444": -11,
  "74445": -7,
  "74446": -7,
  "74447": -8,
  "74450": -6,
  "74451": -10,
  "74452": -11,
  "74454": 1,
  "74455": -14,
  "74456": -8,
  "74457": -13,
  "74458": 1,
  "74459": -14,
  "74460": -8,
  "74461": -14,
  "74462": -13,
  "74463": -7,
  "74464": -11,
  "74465": -11,
  "74467": 1,
  "74468": -7,
  "74469": -7,
  "74470": -14,
  "74471": -12,
  "74472": -14,
  "74477": 1,
  "74501": -6,
  "74502": -6,
  "74521": -8,
  "74522": -6,
  "74523": -11,
  "74525": -16,
  "74528": -6,
  "74529": -5,
  "74530": -10,
  "74531": -8,
  "74533": -16,
  "74534": 3,
  "74535": 3,
  "74536": -12,
  "74538": 3,
  "74540": -13,
  "74542": -16,
  "74543": -13,
  "74545": -7,
  "74546": -5,
  "74547": -5,
  "74549": -12,
  "74552": -13,
  "74553": -6,
  "74554": -6,
  "74555": -16,
  "74556": 3,
  "74557": -13,
  "74558": -12,
  "74559": -7,
  "74560": -7,
  "74561": -14,
  "74562": -13,
  "74563": -7,
  "74565": -6,
  "74567": -13,
  "74569": -16,
  "74570": -13,
  "74571": -7,
  "74572": 3,
  "74574": -7,
  "74576": 3,
  "74577": -13,
  "74578": -7,
  "74601": -3,
  "74602": -3,
  "74604": 6,
  "74630": -10,
  "74631": -3,
  "74632": -3,
  "74633": -7,
  "74636": -3,
  "74637": -7,
  "74640": -8,
  "74641": -2,
  "74643": -3,
  "74644": -10,
  "74646": 6,
  "74647": -2,
  "74650": -12,
  "74651": -10,
  "74652": -7,
  "74653": -3,
  "74701": -9,
  "74702": -9,
  "74720": -9,
  "74721": -9,
  "74722": -12,
  "74723": -9,
  "74724": -8,
  "74726": -9,
  "74727": -11,
  "74728": -8,
  "74729": -9,
  "74730": -9,
  "74731": -8,
  "74733": -9,
  "74734": -8,
  "74735": -11,
  "74736": -8,
  "74737": -8,
  "74738": -12,
  "74740": -8,
  "74741": -9,
  "74743": -11,
  "74745": -8,
  "74747": -10,
  "74748": -10,
  "74750": -8,
  "74752": -12,
  "74753": -6,
  "74754": -8,
  "74755": -8,
  "74756": -11,
  "74759": -12,
  "74760": -11,
  "74761": -11,
  "74764": -8,
  "74766": -8,
  "74801": -12,
  "74802": -12,
  "74804": -4,
  "74818": -8,
  "74820": -8,
  "74821": -8,
  "74824": 8,
  "74825": -8,
  "74826": -12,
  "74827": -13,
  "74829": -10,
  "74830": -8,
  "74831": 0,
  "74832": 8,
  "74833": -10,
  "74834": 9,
  "74836": -10,
  "74837": -10,
  "74839": -10,
  "74840": -12,
  "74842": -8,
  "74843": -7,
  "74844": -9,
  "74845": -16,
  "74848": -13,
  "74849": -8,
  "74850": -13,
  "74851": -12,
  "74852": -12,
  "74854": -8,
  "74855": 8,
  "74856": -10,
  "74857": 2,
  "74859": -10,
  "74860": -10,
  "74864": 8,
  "74865": -8,
  "74866": -8,
  "74867": -9,
  "74868": -8,
  "74869": 8,
  "74871": -8,
  "74872": -8,
  "74873": -12,
  "74875": 8,
  "74878": -12,
  "74880": -10,
  "74881": 8,
  "74883": -13,
  "74884": -8,
  "74901": -10,
  "74902": -10,
  "74930": -13,
  "74931": -14,
  "74932": -13,
  "74935": -13,
  "74936": -14,
  "74937": -13,
  "74939": -13,
  "74940": -13,
  "74941": -14,
  "74942": -7,
  "74943": -14,
  "74944": -14,
  "74945": -14,
  "74946": -10,
  "74947": -13,
  "74948": -14,
  "74949": -13,
  "74951": -13,
  "74953": -13,
  "74954": -10,
  "74955": -14,
  "74956": -13,
  "74957": -11,
  "74959": -10,
  "74960": -13,
  "74962": -14,
  "74963": -11,
  "74964": -13,
  "74965": -13,
  "74966": -13,
  "75001": 10,
  "75002": 10,
  "75006": 10,
  "75007": 6,
  "75009": 11,
  "75010": 6,
  "75011": 10,
  "75013": 11,
  "75014": 10,
  "75015": 10,
  "75016": 10,
  "75017": 10,
  "75019": 6,
  "75020": -2,
  "75021": -2,
  "75022": 14,
  "75023": 11,
  "75024": 11,
  "75025": 11,
  "75026": 11,
  "75027": 14,
  "75028": 7,
  "75029": 6,
  "75030": 4,
  "75032": 4,
  "75034": 12,
  "75035": 11,
  "75038": 10,
  "75039": 21,
  "75040": 4,
  "75041": 10,
  "75042": 10,
  "75043": 4,
  "75044": 10,
  "75045": 10,
  "75046": 4,
  "75047": 10,
  "75048": 4,
  "75049": 4,
  "75050": 10,
  "75051": 10,
  "75052": 9,
  "75053": 10,
  "75054": 10,
  "75056": 6,
  "75057": 6,
  "75058": -2,
  "75060": 10,
  "75061": 10,
  "75062": 10,
  "75063": 10,
  "75065": 6,
  "75067": 7,
  "75068": 6,
  "75069": 10,
  "75070": 12,
  "75071": 10,
  "75074": 10,
  "75075": 11,
  "75076": -1,
  "75077": 6,
  "75078": 11,
  "75080": 10,
  "75081": 10,
  "75082": 11,
  "75083": 10,
  "75085": 10,
  "75086": 10,
  "75087": 4,
  "75088": 4,
  "75089": 4,
  "75090": -2,
  "75091": -2,
  "75092": -2,
  "75093": 14,
  "75094": 11,
  "75097": 11,
  "75098": 4,
  "75101": -1,
  "75102": -5,
  "75103": -5,
  "75104": 0,
  "75105": -3,
  "75106": 0,
  "75109": -3,
  "75110": -3,
  "75114": -2,
  "75115": 10,
  "75116": 10,
  "75117": -5,
  "75118": -2,
  "75119": -1,
  "75120": -1,
  "75121": -5,
  "75123": 10,
  "75124": -7,
  "75125": -1,
  "75126": 4,
  "75127": -5,
  "75132": 4,
  "75134": 10,
  "75135": -4,
  "75137": 10,
  "75138": 10,
  "75140": -5,
  "75141": 10,
  "75142": -2,
  "75143": -7,
  "75144": -4,
  "75146": -1,
  "75147": -7,
  "75148": -7,
  "75149": 10,
  "75150": 10,
  "75151": -3,
  "75152": -1,
  "75153": -3,
  "75154": -1,
  "75155": -3,
  "75156": -7,
  "75157": -2,
  "75158": -2,
  "75159": -2,
  "75160": -2,
  "75161": -2,
  "75163": -7,
  "75164": 4,
  "75165": 0,
  "75166": 4,
  "75167": 0,
  "75168": -1,
  "75169": -5,
  "75172": 10,
  "75173": 4,
  "75180": 10,
  "75181": 10,
  "75182": 4,
  "75185": 10,
  "75187": 10,
  "75189": 4,
  "75201": 20,
  "75202": 10,
  "75203": 10,
  "75204": 10,
  "75205": 20,
  "75206": 10,
  "75207": 10,
  "75208": 10,
  "75209": 10,
  "75210": 10,
  "75211": 10,
  "75212": 10,
  "75214": 10,
  "75215": 10,
  "75216": 10,
  "75217": 10,
  "75218": 10,
  "75219": 10,
  "75220": 10,
  "75221": 10,
  "75222": 10,
  "75223": 10,
  "75224": 10,
  "75225": 20,
  "75226": 20,
  "75227": 10,
  "75228": 10,
  "75229": 10,
  "75230": 18,
  "75231": 10,
  "75232": 10,
  "75233": 10,
  "75234": 10,
  "75235": 10,
  "75236": 10,
  "75237": 10,
  "75238": 10,
  "75240": 10,
  "75241": 10,
  "75242": 10,
  "75243": 10,
  "75244": 10,
  "75245": 10,
  "75246": 10,
  "75247": 10,
  "75248": 10,
  "75249": 10,
  "75250": 20,
  "75251": 10,
  "75252": 11,
  "75253": 10,
  "75254": 10,
  "75258": 10,
  "75260": 10,
  "75261": 10,
  "75262": 10,
  "75263": 10,
  "75264": 10,
  "75265": 10,
  "75266": 10,
  "75267": 10,
  "75270": 10,
  "75287": 10,
  "75313": 20,
  "75315": 10,
  "75334": 10,
  "75336": 10,
  "75339": 10,
  "75340": 10,
  "75342": 10,
  "75343": 10,
  "75344": 10,
  "75354": 10,
  "75355": 10,
  "75356": 10,
  "75357": 10,
  "75359": 10,
  "75360": 10,
  "75367": 18,
  "75370": 10,
  "75371": 10,
  "75372": 10,
  "75374": 10,
  "75376": 10,
  "75378": 10,
  "75379": 11,
  "75380": 10,
  "75381": 10,
  "75382": 10,
  "75398": 10,
  "75401": -5,
  "75402": -4,
  "75403": -5,
  "75404": -5,
  "75407": 10,
  "75409": 9,
  "75410": -5,
  "75411": 5,
  "75412": 3,
  "75413": -5,
  "75414": -2,
  "75415": -5,
  "75416": -3,
  "75417": 3,
  "75418": -5,
  "75420": -8,
  "75421": -3,
  "75422": -5,
  "75423": -5,
  "75424": 9,
  "75425": -1,
  "75426": 3,
  "75428": -5,
  "75429": -5,
  "75431": -8,
  "75432": -9,
  "75433": -8,
  "75434": -3,
  "75435": -3,
  "75436": 3,
  "75437": -8,
  "75438": -5,
  "75439": -5,
  "75440": -5,
  "75441": -3,
  "75442": -5,
  "75443": -3,
  "75444": -5,
  "75446": -5,
  "75447": -3,
  "75448": -9,
  "75449": -5,
  "75450": 5,
  "75451": 5,
  "75452": -4,
  "75453": -5,
  "75454": 9,
  "75455": -1,
  "75456": -1,
  "75457": -12,
  "75458": -5,
  "75459": -2,
  "75460": -3,
  "75461": -3,
  "75462": 5,
  "75468": -3,
  "75469": -5,
  "75470": -4,
  "75471": -12,
  "75472": -6,
  "75473": 5,
  "75474": -4,
  "75475": -5,
  "75476": -3,
  "75477": -4,
  "75478": -12,
  "75479": -5,
  "75480": -3,
  "75481": -8,
  "75482": -7,
  "75483": -7,
  "75485": 9,
  "75486": -1,
  "75487": -1,
  "75488": -5,
  "75489": -2,
  "75490": -4,
  "75491": -4,
  "75492": -3,
  "75493": -12,
  "75494": 0,
  "75495": 7,
  "75496": -5,
  "75497": 0,
  "75501": -8,
  "75503": 0,
  "75504": -8,
  "75505": -8,
  "75550": 3,
  "75551": -10,
  "75554": 3,
  "75555": -10,
  "75556": -10,
  "75558": 7,
  "75559": -8,
  "75560": -10,
  "75561": -8,
  "75562": -10,
  "75563": -10,
  "75564": 0,
  "75565": -11,
  "75566": -10,
  "75567": -8,
  "75568": 6,
  "75569": -8,
  "75570": -8,
  "75571": 6,
  "75572": -10,
  "75573": -8,
  "75574": -8,
  "75601": -4,
  "75602": -5,
  "75603": -5,
  "75604": -4,
  "75605": 4,
  "75606": -4,
  "75607": 4,
  "75608": -4,
  "75615": -5,
  "75630": -4,
  "75631": 2,
  "75633": 2,
  "75636": 7,
  "75637": -9,
  "75638": 6,
  "75639": 2,
  "75640": -2,
  "75641": -5,
  "75642": 2,
  "75643": 2,
  "75644": -2,
  "75645": -2,
  "75647": -4,
  "75650": 1,
  "75651": -4,
  "75652": -8,
  "75653": -8,
  "75654": -8,
  "75656": 7,
  "75657": 0,
  "75658": -8,
  "75659": 0,
  "75660": 4,
  "75661": 0,
  "75662": -4,
  "75663": -4,
  "75666": -4,
  "75667": -8,
  "75668": 7,
  "75669": -9,
  "75670": 0,
  "75671": 0,
  "75672": 0,
  "75680": -8,
  "75681": -9,
  "75682": -8,
  "75683": -2,
  "75684": -8,
  "75685": 0,
  "75686": 5,
  "75687": -8,
  "75688": 8,
  "75689": -8,
  "75691": 4,
  "75692": 0,
  "75693": 4,
  "75694": 0,
  "75701": -5,
  "75702": -6,
  "75703": 3,
  "75704": -6,
  "75705": -6,
  "75706": -6,
  "75707": -4,
  "75708": -6,
  "75709": -5,
  "75710": -6,
  "75711": -6,
  "75712": -5,
  "75713": -5,
  "75750": -6,
  "75751": -7,
  "75752": -7,
  "75754": -5,
  "75755": -2,
  "75756": -6,
  "75757": 3,
  "75758": -6,
  "75759": -8,
  "75760": -8,
  "75762": 3,
  "75763": -3,
  "75764": -8,
  "75765": 0,
  "75766": -8,
  "75770": -7,
  "75771": 3,
  "75772": -8,
  "75773": 0,
  "75778": -7,
  "75779": -3,
  "75780": -8,
  "75782": -3,
  "75783": 0,
  "75784": -8,
  "75785": -8,
  "75788": -8,
  "75789": -8,
  "75790": -5,
  "75791": 3,
  "75792": -6,
  "75801": -3,
  "75802": -3,
  "75803": -3,
  "75831": 1,
  "75832": -3,
  "75833": 1,
  "75834": -7,
  "75835": -4,
  "75838": -12,
  "75839": -3,
  "75840": -11,
  "75844": -4,
  "75845": -8,
  "75846": 1,
  "75847": -4,
  "75848": -13,
  "75849": -4,
  "75850": 1,
  "75851": -4,
  "75852": -11,
  "75853": -3,
  "75855": -3,
  "75856": -4,
  "75858": -4,
  "75859": -4,
  "75860": -12,
  "75861": -3,
  "75862": -8,
  "75865": -8,
  "75901": -6,
  "75902": -6,
  "75903": -6,
  "75904": -6,
  "75915": -6,
  "75925": -8,
  "75926": -7,
  "75928": -5,
  "75929": 6,
  "75930": 6,
  "75931": 6,
  "75932": 7,
  "75933": -6,
  "75934": -3,
  "75935": -4,
  "75936": -1,
  "75937": -9,
  "75938": -1,
  "75939": -3,
  "75941": -7,
  "75942": -1,
  "75943": -7,
  "75944": -7,
  "75946": -8,
  "75948": 6,
  "75949": -7,
  "75951": -5,
  "75954": -4,
  "75956": -6,
  "75958": -6,
  "75959": 6,
  "75960": -3,
  "75961": -6,
  "75963": -6,
  "75964": -8,
  "75965": -6,
  "75966": -5,
  "75968": 6,
  "75969": -6,
  "75972": -4,
  "75973": -4,
  "75974": -5,
  "75975": -5,
  "75976": -8,
  "75977": 6,
  "75978": -8,
  "75979": -1,
  "75980": -7,
  "76001": 9,
  "76002": 9,
  "76003": 9,
  "76004": 8,
  "76005": 8,
  "76006": 17,
  "76007": 8,
  "76008": 9,
  "76009": 0,
  "76010": 8,
  "76011": 8,
  "76012": 10,
  "76013": 9,
  "76014": 9,
  "76015": 9,
  "76016": 9,
  "76017": 9,
  "76018": 9,
  "76020": 0,
  "76021": 9,
  "76022": 9,
  "76023": -2,
  "76028": 0,
  "76031": -1,
  "76033": -1,
  "76034": 9,
  "76035": -3,
  "76036": -1,
  "76039": 8,
  "76040": 8,
  "76041": -1,
  "76043": 16,
  "76044": 0,
  "76048": -3,
  "76049": -2,
  "76050": 1,
  "76051": 6,
  "76052": 16,
  "76053": 9,
  "76054": 17,
  "76055": 2,
  "76058": -1,
  "76059": -1,
  "76060": 9,
  "76061": 1,
  "76063": 9,
  "76064": 0,
  "76065": 0,
  "76066": 0,
  "76067": -10,
  "76068": -10,
  "76070": 16,
  "76071": -2,
  "76073": -2,
  "76077": 16,
  "76078": 0,
  "76082": 0,
  "76084": 0,
  "76085": 1,
  "76086": 1,
  "76087": 1,
  "76088": 1,
  "76092": 17,
  "76093": -1,
  "76094": 9,
  "76095": 9,
  "76096": 9,
  "76097": 0,
  "76098": 0,
  "76099": 6,
  "76101": 7,
  "76102": 7,
  "76103": 7,
  "76104": 7,
  "76105": 7,
  "76106": 7,
  "76107": 7,
  "76108": 7,
  "76109": 16,
  "76110": 7,
  "76111": 7,
  "76112": 8,
  "76113": 7,
  "76114": 7,
  "76115": 7,
  "76116": 8,
  "76117": 7,
  "76118": 8,
  "76119": 7,
  "76120": 9,
  "76121": 8,
  "76123": 8,
  "76124": 8,
  "76126": 8,
  "76127": 7,
  "76131": 8,
  "76132": 16,
  "76133": 7,
  "76134": 7,
  "76135": 7,
  "76136": 8,
  "76137": 8,
  "76140": 7,
  "76147": 7,
  "76148": 7,
  "76150": 7,
  "76155": 8,
  "76161": 7,
  "76162": 7,
  "76163": 7,
  "76164": 7,
  "76177": 16,
  "76179": 8,
  "76180": 8,
  "76181": 8,
  "76182": 9,
  "76185": 8,
  "76201": 6,
  "76202": 6,
  "76203": 6,
  "76204": 6,
  "76205": 6,
  "76206": 6,
  "76207": 6,
  "76208": 6,
  "76209": 6,
  "76210": 6,
  "76225": 0,
  "76226": 14,
  "76227": 6,
  "76228": -6,
  "76230": -4,
  "76233": -2,
  "76234": 0,
  "76238": -5,
  "76239": -2,
  "76240": -5,
  "76241": -5,
  "76244": 16,
  "76245": -2,
  "76246": 0,
  "76247": 6,
  "76248": 16,
  "76249": 6,
  "76250": -5,
  "76251": -2,
  "76252": -5,
  "76253": -5,
  "76255": -4,
  "76258": 6,
  "76259": 6,
  "76261": -6,
  "76262": 7,
  "76263": -5,
  "76264": -2,
  "76265": -2,
  "76266": 6,
  "76267": 0,
  "76268": -2,
  "76270": -2,
  "76271": -6,
  "76272": -5,
  "76273": -6,
  "76301": -10,
  "76302": -9,
  "76305": -10,
  "76306": -10,
  "76307": -10,
  "76308": -1,
  "76309": -10,
  "76310": -2,
  "76311": -10,
  "76351": -16,
  "76352": -6,
  "76354": -10,
  "76357": -6,
  "76360": -10,
  "76363": -15,
  "76364": -10,
  "76365": -6,
  "76366": -16,
  "76367": -10,
  "76369": -15,
  "76370": -5,
  "76371": -13,
  "76372": -5,
  "76373": -10,
  "76374": -5,
  "76377": -6,
  "76379": -15,
  "76380": -15,
  "76384": -15,
  "76385": -15,
  "76388": -13,
  "76389": -14,
  "76401": -4,
  "76424": -10,
  "76426": 0,
  "76427": -4,
  "76429": -10,
  "76430": -10,
  "76431": 0,
  "76432": -13,
  "76433": -4,
  "76435": -4,
  "76436": -9,
  "76437": -4,
  "76439": 0,
  "76442": -15,
  "76443": 13,
  "76444": -15,
  "76445": -3,
  "76446": -4,
  "76448": -3,
  "76449": -10,
  "76450": -4,
  "76452": -15,
  "76453": -10,
  "76454": -4,
  "76455": -15,
  "76457": -9,
  "76458": -4,
  "76459": -4,
  "76460": -3,
  "76461": -4,
  "76462": -3,
  "76463": -10,
  "76464": 13,
  "76465": -4,
  "76466": -4,
  "76467": -4,
  "76468": -15,
  "76469": 14,
  "76470": -4,
  "76471": -4,
  "76472": -10,
  "76474": -15,
  "76475": -10,
  "76476": -3,
  "76481": -4,
  "76483": -15,
  "76484": -10,
  "76485": 1,
  "76486": -3,
  "76487": 0,
  "76490": 0,
  "76491": -10,
  "76501": -2,
  "76502": 7,
  "76503": 7,
  "76504": -2,
  "76505": -2,
  "76511": -2,
  "76513": 0,
  "76518": -2,
  "76519": -2,
  "76520": -2,
  "76522": -7,
  "76523": -2,
  "76524": -6,
  "76525": -9,
  "76526": -8,
  "76527": 4,
  "76528": -7,
  "76530": 4,
  "76531": 0,
  "76533": -2,
  "76534": -2,
  "76537": 4,
  "76538": -8,
  "76539": -12,
  "76540": -2,
  "76541": -2,
  "76542": -2,
  "76543": -2,
  "76544": -7,
  "76547": -2,
  "76548": -2,
  "76549": -2,
  "76550": -12,
  "76554": -2,
  "76556": -2,
  "76557": -2,
  "76558": -8,
  "76559": -2,
  "76561": -8,
  "76564": 0,
  "76565": 0,
  "76566": -7,
  "76567": -1,
  "76569": -1,
  "76570": -9,
  "76571": 7,
  "76573": 4,
  "76574": 6,
  "76577": -1,
  "76578": 1,
  "76579": 0,
  "76621": 0,
  "76622": 0,
  "76623": -1,
  "76624": -6,
  "76626": -5,
  "76627": 0,
  "76628": 0,
  "76629": -9,
  "76630": -6,
  "76631": 0,
  "76632": -10,
  "76633": 3,
  "76634": 8,
  "76635": -13,
  "76636": 2,
  "76637": 8,
  "76638": 3,
  "76639": -5,
  "76640": -6,
  "76641": -5,
  "76642": -12,
  "76643": 3,
  "76644": 0,
  "76645": 0,
  "76648": 0,
  "76649": 8,
  "76650": 0,
  "76651": -1,
  "76652": 15,
  "76653": -12,
  "76654": -6,
  "76655": 3,
  "76656": -1,
  "76657": -6,
  "76660": 0,
  "76661": -10,
  "76664": -12,
  "76665": 8,
  "76666": 0,
  "76667": -12,
  "76670": 0,
  "76671": 8,
  "76673": -6,
  "76676": 0,
  "76678": -12,
  "76679": -5,
  "76680": -10,
  "76681": -5,
  "76682": -10,
  "76684": -6,
  "76685": -10,
  "76686": -12,
  "76687": -12,
  "76689": 8,
  "76690": 15,
  "76691": 0,
  "76692": 0,
  "76693": -12,
  "76701": -6,
  "76702": -6,
  "76703": -6,
  "76704": -6,
  "76705": -6,
  "76706": -6,
  "76707": -6,
  "76708": -6,
  "76710": -4,
  "76711": -6,
  "76712": 3,
  "76714": -4,
  "76715": -6,
  "76716": -6,
  "76798": -6,
  "76801": -13,
  "76802": -13,
  "76803": -13,
  "76804": -12,
  "76820": -1,
  "76821": 0,
  "76823": -14,
  "76824": -16,
  "76825": -4,
  "76827": -12,
  "76828": -9,
  "76831": -1,
  "76832": -15,
  "76834": -9,
  "76836": -4,
  "76837": -6,
  "76841": -6,
  "76842": -9,
  "76844": -17,
  "76845": -1,
  "76848": -6,
  "76849": -14,
  "76852": -4,
  "76853": -12,
  "76854": -14,
  "76855": -8,
  "76856": -10,
  "76857": -14,
  "76858": -13,
  "76859": -6,
  "76861": -8,
  "76862": -12,
  "76864": -17,
  "76865": 0,
  "76866": 0,
  "76869": -1,
  "76870": -17,
  "76871": -16,
  "76872": -12,
  "76873": -8,
  "76874": -14,
  "76875": 0,
  "76877": -16,
  "76878": -8,
  "76880": -17,
  "76882": -9,
  "76883": -14,
  "76884": -9,
  "76885": -15,
  "76886": 0,
  "76887": -1,
  "76888": -9,
  "76890": -13,
  "76901": -8,
  "76902": -8,
  "76903": -8,
  "76904": -8,
  "76905": -8,
  "76906": -8,
  "76908": 0,
  "76930": -8,
  "76932": 1,
  "76933": -16,
  "76934": -8,
  "76935": -8,
  "76936": -1,
  "76937": -8,
  "76939": 0,
  "76940": -8,
  "76941": -8,
  "76943": -1,
  "76945": -16,
  "76949": -16,
  "76950": -1,
  "76951": -16,
  "76953": -15,
  "76955": -8,
  "76957": 0,
  "76958": -15,
  "77001": 8,
  "77002": 9,
  "77003": 8,
  "77004": 9,
  "77005": 19,
  "77006": 17,
  "77007": 9,
  "77008": 9,
  "77009": 9,
  "77010": 9,
  "77011": 8,
  "77012": 8,
  "77013": 9,
  "77014": 9,
  "77015": 9,
  "77016": 8,
  "77017": 9,
  "77018": 9,
  "77019": 19,
  "77020": 8,
  "77021": 9,
  "77022": 9,
  "77023": 9,
  "77024": 19,
  "77025": 9,
  "77026": 8,
  "77027": 19,
  "77028": 8,
  "77029": 9,
  "77030": 19,
  "77031": 14,
  "77032": 9,
  "77033": 8,
  "77034": 9,
  "77035": 9,
  "77036": 9,
  "77037": 9,
  "77038": 9,
  "77039": 9,
  "77040": 9,
  "77041": 9,
  "77042": 9,
  "77043": 9,
  "77044": 9,
  "77045": 9,
  "77046": 17,
  "77047": 9,
  "77048": 9,
  "77049": 9,
  "77050": 9,
  "77051": 8,
  "77052": 9,
  "77053": 14,
  "77054": 9,
  "77055": 9,
  "77056": 19,
  "77057": 9,
  "77058": 13,
  "77059": 14,
  "77060": 9,
  "77061": 9,
  "77062": 5,
  "77063": 9,
  "77064": 9,
  "77065": 9,
  "77066": 9,
  "77067": 9,
  "77068": 9,
  "77069": 9,
  "77070": 9,
  "77071": 14,
  "77072": 14,
  "77073": 9,
  "77074": 9,
  "77075": 9,
  "77076": 9,
  "77077": 14,
  "77078": 9,
  "77079": 17,
  "77080": 9,
  "77081": 9,
  "77082": 14,
  "77083": 14,
  "77084": 14,
  "77085": 14,
  "77086": 9,
  "77087": 9,
  "77088": 9,
  "77089": 9,
  "77090": 9,
  "77091": 9,
  "77092": 9,
  "77093": 8,
  "77094": 15,
  "77095": 9,
  "77096": 9,
  "77097": 9,
  "77098": 17,
  "77099": 14,
  "77201": 9,
  "77202": 9,
  "77203": 9,
  "77205": 9,
  "77206": 9,
  "77207": 9,
  "77208": 9,
  "77210": 9,
  "77213": 9,
  "77215": 9,
  "77217": 9,
  "77218": 14,
  "77219": 19,
  "77220": 8,
  "77221": 9,
  "77222": 9,
  "77223": 9,
  "77224": 19,
  "77225": 19,
  "77226": 8,
  "77227": 19,
  "77228": 9,
  "77229": 8,
  "77230": 9,
  "77231": 9,
  "77233": 8,
  "77234": 9,
  "77235": 9,
  "77236": 9,
  "77237": 9,
  "77238": 9,
  "77240": 9,
  "77241": 9,
  "77242": 9,
  "77243": 9,
  "77244": 17,
  "77245": 9,
  "77246": 9,
  "77247": 9,
  "77248": 9,
  "77249": 9,
  "77250": 9,
  "77251": 9,
  "77252": 9,
  "77253": 9,
  "77254": 17,
  "77255": 9,
  "77256": 19,
  "77257": 9,
  "77258": 13,
  "77259": 5,
  "77260": 9,
  "77261": 9,
  "77262": 9,
  "77263": 9,
  "77265": 19,
  "77266": 17,
  "77267": 9,
  "77268": 9,
  "77269": 9,
  "77270": 9,
  "77271": 14,
  "77272": 14,
  "77273": 9,
  "77274": 9,
  "77275": 9,
  "77276": 9,
  "77277": 19,
  "77278": 9,
  "77279": 19,
  "77280": 9,
  "77282": 14,
  "77284": 9,
  "77285": 9,
  "77286": 9,
  "77287": 9,
  "77288": 9,
  "77289": 14,
  "77290": 9,
  "77291": 9,
  "77292": 9,
  "77293": 8,
  "77294": 9,
  "77296": 9,
  "77301": 2,
  "77302": 2,
  "77303": 2,
  "77304": 3,
  "77305": 2,
  "77306": 2,
  "77315": 9,
  "77316": 2,
  "77318": 3,
  "77320": -3,
  "77325": 9,
  "77326": -3,
  "77327": -11,
  "77328": -11,
  "77331": -11,
  "77332": -3,
  "77333": -2,
  "77334": -3,
  "77335": -3,
  "77336": 3,
  "77337": 3,
  "77338": 9,
  "77339": 9,
  "77340": -3,
  "77342": -3,
  "77345": 5,
  "77346": 9,
  "77347": 9,
  "77350": -3,
  "77351": -3,
  "77353": 0,
  "77354": 2,
  "77355": 0,
  "77356": 11,
  "77357": 2,
  "77358": -3,
  "77359": -3,
  "77360": -3,
  "77362": 2,
  "77363": -2,
  "77364": -11,
  "77365": 2,
  "77367": -3,
  "77368": 3,
  "77369": -3,
  "77371": -11,
  "77372": 2,
  "77373": 2,
  "77374": 2,
  "77375": 3,
  "77376": 2,
  "77377": 3,
  "77378": 2,
  "77379": 3,
  "77380": 3,
  "77381": 11,
  "77382": 11,
  "77383": 2,
  "77384": 11,
  "77385": 2,
  "77386": 3,
  "77387": 2,
  "77388": 3,
  "77389": 3,
  "77391": 3,
  "77393": 11,
  "77396": 9,
  "77401": 17,
  "77402": 9,
  "77404": 11,
  "77406": 14,
  "77407": 14,
  "77410": 1,
  "77411": 14,
  "77412": 0,
  "77413": 15,
  "77414": 12,
  "77415": 11,
  "77417": 14,
  "77418": 3,
  "77419": 12,
  "77420": -8,
  "77422": 11,
  "77423": 1,
  "77426": 3,
  "77428": 12,
  "77429": 1,
  "77430": 13,
  "77431": 12,
  "77432": -9,
  "77433": 1,
  "77434": -2,
  "77435": -8,
  "77436": -9,
  "77437": -9,
  "77440": 12,
  "77441": 15,
  "77442": -2,
  "77443": -9,
  "77444": 14,
  "77445": 2,
  "77446": 0,
  "77447": 0,
  "77448": -8,
  "77449": 14,
  "77450": 14,
  "77451": -9,
  "77452": 3,
  "77453": -8,
  "77454": -1,
  "77455": 2,
  "77456": 12,
  "77457": 12,
  "77458": 12,
  "77459": 14,
  "77460": -2,
  "77461": 14,
  "77463": 11,
  "77464": 14,
  "77465": 12,
  "77466": 1,
  "77467": -1,
  "77468": -8,
  "77469": 14,
  "77470": -3,
  "77471": 14,
  "77473": 2,
  "77474": 2,
  "77475": -3,
  "77476": 2,
  "77477": 14,
  "77478": 14,
  "77479": 15,
  "77480": 11,
  "77481": 14,
  "77482": 13,
  "77483": 12,
  "77484": 0,
  "77485": 2,
  "77486": 13,
  "77487": 14,
  "77488": -8,
  "77489": 14,
  "77491": 14,
  "77492": 14,
  "77493": 14,
  "77494": 14,
  "77496": 14,
  "77497": 14,
  "77498": 14,
  "77501": 8,
  "77502": 9,
  "77503": 8,
  "77504": 9,
  "77505": 8,
  "77506": 8,
  "77507": 5,
  "77508": 8,
  "77510": 5,
  "77511": 11,
  "77512": 11,
  "77514": 14,
  "77515": 11,
  "77516": 11,
  "77517": 5,
  "77518": 5,
  "77519": 2,
  "77520": 14,
  "77521": 14,
  "77522": 14,
  "77523": 14,
  "77530": 7,
  "77531": 11,
  "77532": 8,
  "77533": 2,
  "77534": 11,
  "77535": 3,
  "77536": 8,
  "77538": 14,
  "77539": 5,
  "77541": 12,
  "77542": 12,
  "77545": 14,
  "77546": 13,
  "77547": 8,
  "77549": 13,
  "77550": 6,
  "77551": 6,
  "77552": 6,
  "77553": 14,
  "77554": 14,
  "77560": 14,
  "77561": 2,
  "77562": 8,
  "77563": 5,
  "77564": 2,
  "77565": 13,
  "77566": 12,
  "77568": 5,
  "77571": 5,
  "77572": 5,
  "77573": 6,
  "77574": 6,
  "77575": 2,
  "77577": 11,
  "77578": 13,
  "77580": 14,
  "77581": 9,
  "77582": 2,
  "77583": 13,
  "77584": 9,
  "77585": 4,
  "77586": 7,
  "77587": 9,
  "77588": 9,
  "77590": 5,
  "77591": 5,
  "77592": 5,
  "77597": 14,
  "77598": 5,
  "77611": 3,
  "77612": 4,
  "77613": 8,
  "77614": -6,
  "77615": 4,
  "77616": -6,
  "77617": 15,
  "77619": 8,
  "77622": 8,
  "77623": 15,
  "77624": -1,
  "77625": 5,
  "77626": 4,
  "77627": 8,
  "77629": 8,
  "77630": 3,
  "77631": 3,
  "77632": 4,
  "77639": 3,
  "77640": 7,
  "77641": 7,
  "77642": 7,
  "77643": 7,
  "77650": 6,
  "77651": 9,
  "77655": 7,
  "77656": 5,
  "77657": 6,
  "77659": 6,
  "77660": -6,
  "77661": 14,
  "77662": 4,
  "77663": 13,
  "77664": -1,
  "77665": 14,
  "77670": 4,
  "77701": 8,
  "77702": 17,
  "77703": 8,
  "77704": 8,
  "77705": 8,
  "77706": 17,
  "77707": 8,
  "77708": 8,
  "77709": 8,
  "77710": 8,
  "77713": 8,
  "77720": 8,
  "77725": 8,
  "77726": 17,
  "77801": 6,
  "77802": 6,
  "77803": -3,
  "77805": 6,
  "77806": -3,
  "77807": -2,
  "77808": -3,
  "77830": 1,
  "77831": -10,
  "77833": -3,
  "77834": -3,
  "77835": -3,
  "77836": 1,
  "77837": -2,
  "77838": 1,
  "77840": -1,
  "77841": 8,
  "77842": -1,
  "77844": -1,
  "77845": 8,
  "77850": 1,
  "77852": 1,
  "77853": 11,
  "77855": 1,
  "77856": 1,
  "77857": -2,
  "77859": -3,
  "77861": -10,
  "77862": 6,
  "77863": 2,
  "77864": -12,
  "77865": 1,
  "77866": 1,
  "77867": -3,
  "77868": 1,
  "77870": 1,
  "77871": -10,
  "77872": -12,
  "77873": -2,
  "77875": 1,
  "77876": 1,
  "77878": 3,
  "77879": 2,
  "77880": -3,
  "77881": 8,
  "77882": 6,
  "77901": 3,
  "77902": 3,
  "77903": 3,
  "77904": 0,
  "77905": -7,
  "77950": 3,
  "77951": -2,
  "77954": -8,
  "77957": 1,
  "77960": 3,
  "77961": 1,
  "77962": 1,
  "77963": 3,
  "77964": 2,
  "77967": 2,
  "77968": -2,
  "77969": 1,
  "77970": 1,
  "77971": 1,
  "77973": -7,
  "77974": -7,
  "77975": 2,
  "77976": 0,
  "77977": -2,
  "77978": 3,
  "77979": 3,
  "77982": 3,
  "77983": 3,
  "77984": 2,
  "77986": 2,
  "77987": 2,
  "77988": -2,
  "77989": -8,
  "77990": 3,
  "77991": 1,
  "77993": 3,
  "77994": -8,
  "77995": 2,
  "78001": 9,
  "78002": 1,
  "78003": -10,
  "78004": 4,
  "78005": 1,
  "78006": 10,
  "78007": -10,
  "78008": -3,
  "78009": -7,
  "78010": -5,
  "78011": -3,
  "78012": -3,
  "78013": 2,
  "78014": 6,
  "78015": 2,
  "78016": -7,
  "78017": 6,
  "78019": -13,
  "78021": 6,
  "78022": -10,
  "78023": 1,
  "78024": -5,
  "78025": -5,
  "78026": -3,
  "78027": 4,
  "78028": -5,
  "78029": -5,
  "78039": -7,
  "78040": -12,
  "78041": -4,
  "78042": -12,
  "78043": -12,
  "78044": -12,
  "78045": -4,
  "78046": -12,
  "78050": -3,
  "78052": -7,
  "78054": 1,
  "78055": -5,
  "78056": -10,
  "78057": 1,
  "78058": -5,
  "78059": -7,
  "78060": -10,
  "78061": 6,
  "78062": -3,
  "78063": -10,
  "78064": -3,
  "78065": 1,
  "78066": -7,
  "78067": -7,
  "78069": 1,
  "78070": -1,
  "78071": -10,
  "78072": -10,
  "78073": 1,
  "78074": 2,
  "78075": -10,
  "78076": -7,
  "78101": -10,
  "78102": 1,
  "78104": 1,
  "78107": 0,
  "78108": -1,
  "78109": 1,
  "78111": -11,
  "78112": -10,
  "78113": -12,
  "78114": -10,
  "78115": -2,
  "78116": -11,
  "78117": -12,
  "78118": -12,
  "78119": -12,
  "78121": -9,
  "78122": -10,
  "78123": -2,
  "78124": -2,
  "78125": 0,
  "78130": -1,
  "78131": -1,
  "78132": -1,
  "78133": -1,
  "78140": -10,
  "78141": -12,
  "78142": 0,
  "78143": -10,
  "78144": -12,
  "78145": -11,
  "78146": 0,
  "78147": -10,
  "78148": 1,
  "78150": 1,
  "78151": -12,
  "78152": -3,
  "78154": -1,
  "78155": -3,
  "78156": -3,
  "78159": -10,
  "78160": -10,
  "78161": -10,
  "78162": 0,
  "78163": 6,
  "78164": -8,
  "78201": 1,
  "78202": 1,
  "78203": 1,
  "78204": 1,
  "78205": 2,
  "78206": 2,
  "78207": 0,
  "78208": 1,
  "78209": 1,
  "78210": 1,
  "78211": 1,
  "78212": 1,
  "78213": 1,
  "78214": 1,
  "78215": 1,
  "78216": 1,
  "78217": 1,
  "78218": 1,
  "78219": 1,
  "78220": 1,
  "78221": 1,
  "78222": 1,
  "78223": 1,
  "78224": 1,
  "78225": 1,
  "78226": 1,
  "78227": 1,
  "78228": 1,
  "78229": 1,
  "78230": 1,
  "78231": 1,
  "78232": 1,
  "78233": 1,
  "78234": 1,
  "78235": 1,
  "78236": 1,
  "78237": 1,
  "78238": 1,
  "78239": 1,
  "78240": 1,
  "78241": 1,
  "78242": 1,
  "78243": 1,
  "78244": 1,
  "78245": 1,
  "78246": 1,
  "78247": 1,
  "78248": 9,
  "78249": 1,
  "78250": 1,
  "78251": 1,
  "78252": 1,
  "78253": 1,
  "78254": 2,
  "78255": 10,
  "78256": 9,
  "78257": 12,
  "78258": 9,
  "78259": 1,
  "78260": -2,
  "78261": 6,
  "78262": 1,
  "78263": 1,
  "78264": 1,
  "78265": 1,
  "78266": 8,
  "78268": 1,
  "78269": 1,
  "78270": 1,
  "78278": 1,
  "78279": 1,
  "78280": 1,
  "78283": 1,
  "78284": 1,
  "78285": 0,
  "78286": 1,
  "78291": 2,
  "78292": 2,
  "78293": 2,
  "78294": 2,
  "78295": 2,
  "78296": 2,
  "78297": 2,
  "78298": 1,
  "78299": 2,
  "78330": -11,
  "78332": -11,
  "78333": -11,
  "78335": -8,
  "78336": -8,
  "78338": -3,
  "78339": 2,
  "78340": -8,
  "78341": -11,
  "78342": -11,
  "78343": -8,
  "78344": -13,
  "78347": 15,
  "78349": -11,
  "78350": -10,
  "78351": -8,
  "78352": 3,
  "78353": -12,
  "78355": -8,
  "78357": -11,
  "78358": -8,
  "78359": 2,
  "78360": -8,
  "78361": -8,
  "78362": -7,
  "78363": -7,
  "78364": -7,
  "78368": 0,
  "78369": -13,
  "78370": 3,
  "78371": -13,
  "78372": -10,
  "78373": 1,
  "78374": 11,
  "78375": -8,
  "78376": -10,
  "78377": -8,
  "78379": -8,
  "78380": 6,
  "78381": -7,
  "78382": -7,
  "78383": -10,
  "78384": -11,
  "78385": -8,
  "78387": 2,
  "78389": 0,
  "78390": 2,
  "78391": 1,
  "78393": -8,
  "78401": 6,
  "78402": 7,
  "78403": 6,
  "78404": 7,
  "78405": 6,
  "78406": 6,
  "78407": 6,
  "78408": 6,
  "78409": 6,
  "78410": 7,
  "78411": 7,
  "78412": 7,
  "78413": 15,
  "78414": 15,
  "78415": 7,
  "78416": 6,
  "78417": 6,
  "78418": 7,
  "78419": 7,
  "78426": 7,
  "78427": 6,
  "78460": 7,
  "78463": 7,
  "78465": 6,
  "78466": 7,
  "78467": 6,
  "78468": 7,
  "78469": 6,
  "78470": 6,
  "78471": 6,
  "78472": 15,
  "78473": 6,
  "78474": 6,
  "78475": 6,
  "78476": 6,
  "78477": 6,
  "78478": 6,
  "78480": 6,
  "78501": -10,
  "78502": -10,
  "78503": -11,
  "78504": -2,
  "78505": -10,
  "78516": -11,
  "78520": -9,
  "78521": -10,
  "78522": -9,
  "78523": -9,
  "78526": -10,
  "78535": -1,
  "78536": 2,
  "78537": -11,
  "78538": -12,
  "78539": -11,
  "78540": -11,
  "78541": -11,
  "78542": -11,
  "78543": -11,
  "78545": 1,
  "78547": 1,
  "78548": 1,
  "78549": -12,
  "78550": -1,
  "78551": -7,
  "78552": -7,
  "78553": -1,
  "78557": -10,
  "78558": -12,
  "78559": -9,
  "78560": -11,
  "78561": -12,
  "78562": -12,
  "78563": -11,
  "78564": -7,
  "78565": -11,
  "78566": -9,
  "78567": -10,
  "78568": -9,
  "78569": -12,
  "78570": -11,
  "78572": -11,
  "78573": -11,
  "78574": -11,
  "78575": -9,
  "78576": -11,
  "78577": -11,
  "78578": -9,
  "78579": -11,
  "78580": -12,
  "78582": 1,
  "78583": -9,
  "78584": 1,
  "78585": 1,
  "78586": -1,
  "78588": 2,
  "78589": -11,
  "78590": -12,
  "78591": 2,
  "78592": -9,
  "78593": -12,
  "78594": -12,
  "78595": 1,
  "78596": -11,
  "78597": -1,
  "78598": -12,
  "78599": -11,
  "78602": -1,
  "78604": -8,
  "78605": -5,
  "78606": 7,
  "78607": -7,
  "78608": -12,
  "78609": -7,
  "78610": -1,
  "78611": -5,
  "78612": -1,
  "78613": 6,
  "78614": -9,
  "78615": 1,
  "78616": -7,
  "78617": 9,
  "78618": -9,
  "78619": -1,
  "78620": 8,
  "78621": -1,
  "78622": -7,
  "78623": -2,
  "78624": -4,
  "78626": 6,
  "78627": 6,
  "78628": 6,
  "78629": -10,
  "78630": 6,
  "78631": -5,
  "78632": -7,
  "78633": 4,
  "78634": 6,
  "78635": 6,
  "78636": 8,
  "78638": -7,
  "78639": -5,
  "78640": -1,
  "78641": 6,
  "78642": 6,
  "78643": -7,
  "78644": -7,
  "78645": 9,
  "78646": 6,
  "78648": -7,
  "78650": -1,
  "78651": 9,
  "78652": 1,
  "78653": 9,
  "78654": -3,
  "78655": -7,
  "78656": -7,
  "78657": -3,
  "78658": -8,
  "78659": 11,
  "78660": 6,
  "78661": -7,
  "78662": -1,
  "78663": 8,
  "78664": 6,
  "78665": 6,
  "78666": -1,
  "78667": -1,
  "78669": 9,
  "78670": -7,
  "78671": 7,
  "78672": -7,
  "78673": 4,
  "78674": 6,
  "78675": -3,
  "78676": 8,
  "78677": -9,
  "78680": 6,
  "78681": 6,
  "78683": 6,
  "78691": 6,
  "78701": 10,
  "78702": 9,
  "78703": 20,
  "78704": 9,
  "78705": 9,
  "78708": 9,
  "78709": 10,
  "78710": 9,
  "78711": 10,
  "78712": 9,
  "78713": 9,
  "78714": 10,
  "78715": 9,
  "78716": 18,
  "78717": 6,
  "78718": 9,
  "78719": 9,
  "78720": 10,
  "78721": 9,
  "78722": 9,
  "78723": 9,
  "78724": 9,
  "78725": 9,
  "78726": 11,
  "78727": 9,
  "78728": 6,
  "78729": 9,
  "78730": 20,
  "78731": 18,
  "78732": 10,
  "78733": 18,
  "78734": 10,
  "78735": 10,
  "78736": 9,
  "78737": 9,
  "78738": 20,
  "78739": 10,
  "78741": 9,
  "78742": 9,
  "78744": 9,
  "78745": 9,
  "78746": 20,
  "78747": 9,
  "78748": 9,
  "78749": 9,
  "78750": 10,
  "78751": 9,
  "78752": 9,
  "78753": 9,
  "78754": 9,
  "78755": 18,
  "78756": 10,
  "78757": 9,
  "78758": 9,
  "78759": 10,
  "78760": 9,
  "78761": 9,
  "78762": 9,
  "78763": 20,
  "78764": 6,
  "78765": 9,
  "78766": 9,
  "78767": 10,
  "78768": 10,
  "78769": 10,
  "78799": 10,
  "78801": -14,
  "78802": -14,
  "78827": 9,
  "78828": -20,
  "78829": 6,
  "78830": 9,
  "78832": -12,
  "78833": -20,
  "78834": 9,
  "78836": 9,
  "78837": -12,
  "78838": -14,
  "78839": 9,
  "78840": -12,
  "78841": -12,
  "78842": -12,
  "78843": -12,
  "78850": -7,
  "78851": 1,
  "78852": -11,
  "78853": -11,
  "78860": -12,
  "78861": -7,
  "78870": -14,
  "78871": -12,
  "78872": -14,
  "78873": -20,
  "78877": -11,
  "78879": -20,
  "78880": -21,
  "78881": -14,
  "78883": -10,
  "78884": -10,
  "78885": -20,
  "78886": -7,
  "78931": 3,
  "78932": -3,
  "78933": 3,
  "78934": 0,
  "78935": 0,
  "78938": -3,
  "78940": -3,
  "78941": -5,
  "78942": 11,
  "78943": 0,
  "78944": -3,
  "78945": -3,
  "78946": 11,
  "78947": 11,
  "78948": 9,
  "78949": -3,
  "78950": 3,
  "78951": -4,
  "78952": -3,
  "78953": -2,
  "78954": -3,
  "78956": -4,
  "78957": -1,
  "78959": -10,
  "78960": 11,
  "78961": -3,
  "78962": -2,
  "78963": -3,
  "79001": -7,
  "79002": -6,
  "79003": -13,
  "79005": -7,
  "79007": 6,
  "79008": 6,
  "79009": -15,
  "79010": -7,
  "79011": -13,
  "79012": 6,
  "79013": 0,
  "79014": -12,
  "79015": -3,
  "79018": -6,
  "79019": -3,
  "79021": -5,
  "79022": -5,
  "79024": -7,
  "79025": -5,
  "79027": -16,
  "79029": 0,
  "79031": 0,
  "79032": -5,
  "79033": -7,
  "79034": -7,
  "79035": -7,
  "79036": 6,
  "79039": 4,
  "79040": 8,
  "79041": -5,
  "79042": -18,
  "79043": -16,
  "79044": -6,
  "79045": -8,
  "79046": -13,
  "79051": -11,
  "79052": -18,
  "79053": -15,
  "79054": -6,
  "79056": -13,
  "79057": -6,
  "79058": -8,
  "79059": -6,
  "79061": -12,
  "79062": 6,
  "79063": -16,
  "79064": 0,
  "79065": -6,
  "79066": -6,
  "79068": 4,
  "79070": -7,
  "79072": -5,
  "79073": -5,
  "79077": 3,
  "79078": 6,
  "79079": -12,
  "79080": 6,
  "79081": 8,
  "79082": 0,
  "79083": 6,
  "79084": -20,
  "79085": -8,
  "79086": 0,
  "79087": -6,
  "79088": -18,
  "79091": -3,
  "79092": -7,
  "79093": -7,
  "79094": -18,
  "79095": 3,
  "79096": -13,
  "79097": 4,
  "79098": -3,
  "79101": -5,
  "79102": -5,
  "79103": -5,
  "79104": -5,
  "79105": -3,
  "79106": -5,
  "79107": -5,
  "79108": -5,
  "79109": -3,
  "79110": -3,
  "79111": -5,
  "79114": -3,
  "79116": -5,
  "79117": -5,
  "79118": -3,
  "79119": 6,
  "79120": -5,
  "79121": 4,
  "79124": 4,
  "79159": 6,
  "79189": -5,
  "79201": 3,
  "79220": -6,
  "79221": -17,
  "79223": -7,
  "79225": 2,
  "79226": -12,
  "79227": -7,
  "79229": -6,
  "79230": 3,
  "79231": -17,
  "79233": -17,
  "79234": -17,
  "79235": -17,
  "79236": -6,
  "79237": -12,
  "79239": -12,
  "79240": -12,
  "79241": -17,
  "79243": -17,
  "79244": -17,
  "79245": -12,
  "79247": -15,
  "79248": -7,
  "79250": -5,
  "79251": -12,
  "79252": 2,
  "79255": -17,
  "79256": -17,
  "79257": -17,
  "79258": -17,
  "79259": 3,
  "79261": -17,
  "79311": -5,
  "79312": 0,
  "79313": -2,
  "79314": -2,
  "79316": -13,
  "79320": -15,
  "79322": -17,
  "79323": 5,
  "79324": -15,
  "79325": -15,
  "79326": 0,
  "79329": -5,
  "79330": -10,
  "79331": -4,
  "79336": -2,
  "79338": -2,
  "79339": 0,
  "79342": -13,
  "79343": -6,
  "79344": -15,
  "79345": -13,
  "79346": -2,
  "79347": -15,
  "79350": -6,
  "79351": -4,
  "79353": -2,
  "79355": 5,
  "79356": -10,
  "79357": -6,
  "79358": -2,
  "79359": 0,
  "79360": 0,
  "79363": -5,
  "79364": -6,
  "79366": -5,
  "79367": -2,
  "79369": 0,
  "79370": -10,
  "79371": 0,
  "79372": -2,
  "79373": -6,
  "79376": 5,
  "79377": -4,
  "79378": -13,
  "79379": -2,
  "79380": -2,
  "79381": -6,
  "79382": -6,
  "79383": -6,
  "79401": -6,
  "79402": -6,
  "79403": -6,
  "79404": -6,
  "79405": -6,
  "79406": -5,
  "79407": -5,
  "79408": -6,
  "79409": -6,
  "79410": -5,
  "79411": -6,
  "79412": -6,
  "79413": -5,
  "79414": -5,
  "79415": -6,
  "79416": -5,
  "79423": -5,
  "79424": -5,
  "79452": -6,
  "79453": -6,
  "79464": -5,
  "79490": -6,
  "79493": -5,
  "79499": -6,
  "79501": -13,
  "79502": -12,
  "79503": -13,
  "79504": 14,
  "79505": -13,
  "79506": -16,
  "79508": 2,
  "79510": 14,
  "79511": 2,
  "79512": -6,
  "79516": -5,
  "79517": 15,
  "79518": -12,
  "79519": -9,
  "79520": -13,
  "79521": -13,
  "79525": -13,
  "79526": -5,
  "79527": -5,
  "79528": -12,
  "79529": -13,
  "79530": -7,
  "79532": 3,
  "79533": -13,
  "79534": -13,
  "79535": 4,
  "79536": -7,
  "79537": 4,
  "79538": -9,
  "79539": -13,
  "79540": -12,
  "79541": -6,
  "79543": 3,
  "79544": -13,
  "79545": 3,
  "79546": -12,
  "79547": -13,
  "79548": -13,
  "79549": -6,
  "79550": -6,
  "79553": -13,
  "79556": 3,
  "79560": -13,
  "79561": 3,
  "79562": 2,
  "79563": -7,
  "79565": 2,
  "79566": 0,
  "79567": 0,
  "79601": -6,
  "79602": -6,
  "79603": -7,
  "79604": -7,
  "79605": -6,
  "79606": 2,
  "79607": -7,
  "79608": -6,
  "79701": 10,
  "79702": 10,
  "79703": 10,
  "79704": 10,
  "79705": 19,
  "79706": 10,
  "79707": 19,
  "79708": 19,
  "79710": 19,
  "79711": 10,
  "79712": 10,
  "79713": -3,
  "79714": 15,
  "79718": 24,
  "79719": 24,
  "79720": -3,
  "79721": -4,
  "79730": 11,
  "79731": 8,
  "79733": 2,
  "79734": -8,
  "79735": 2,
  "79738": 15,
  "79739": 2,
  "79740": 1,
  "79741": 8,
  "79742": 11,
  "79743": 7,
  "79744": 1,
  "79745": 11,
  "79748": 0,
  "79749": 0,
  "79752": 1,
  "79754": 24,
  "79755": 1,
  "79756": 11,
  "79758": 8,
  "79759": 8,
  "79760": 8,
  "79761": 8,
  "79762": 8,
  "79763": 8,
  "79764": 8,
  "79765": 8,
  "79766": 8,
  "79768": 8,
  "79769": 8,
  "79770": 24,
  "79772": 24,
  "79776": 8,
  "79777": 11,
  "79778": 1,
  "79780": 24,
  "79781": 1,
  "79782": 0,
  "79783": 8,
  "79785": 24,
  "79786": 24,
  "79788": 11,
  "79789": 11,
  "79821": -8,
  "79830": -12,
  "79831": -12,
  "79834": -12,
  "79835": -8,
  "79836": -8,
  "79837": -8,
  "79838": -8,
  "79839": -8,
  "79842": -12,
  "79843": -8,
  "79845": -9,
  "79846": -8,
  "79847": -8,
  "79848": 1,
  "79849": -8,
  "79851": -8,
  "79852": -12,
  "79853": -8,
  "79854": -8,
  "79855": 25,
  "79901": -8,
  "79902": -8,
  "79903": -8,
  "79904": -8,
  "79905": -8,
  "79906": -8,
  "79907": -8,
  "79908": -8,
  "79910": -8,
  "79911": 0,
  "79912": 0,
  "79913": 0,
  "79914": -8,
  "79915": -8,
  "79916": -8,
  "79917": -8,
  "79918": -8,
  "79920": -8,
  "79922": 0,
  "79923": -8,
  "79924": -8,
  "79925": -8,
  "79926": -8,
  "79927": -8,
  "79928": -8,
  "79929": -8,
  "79930": -8,
  "79931": -8,
  "79932": -8,
  "79934": -8,
  "79935": -8,
  "79936": -8,
  "79937": -8,
  "79938": -8,
  "79940": -8,
  "79941": -8,
  "79942": -8,
  "79943": -8,
  "79944": -8,
  "79945": -8,
  "79946": -8,
  "79947": -8,
  "79948": -8,
  "79949": -8,
  "79950": -8,
  "79951": -8,
  "79952": -8,
  "79953": -8,
  "79954": -8,
  "79955": -8,
  "79990": -8,
  "79995": -8,
  "79996": -8,
  "79997": -8,
  "79998": -8,
  "79999": -8,
  "80001": 8,
  "80002": 8,
  "80003": 8,
  "80004": 8,
  "80005": 8,
  "80006": 8,
  "80007": 10,
  "80010": 14,
  "80011": 10,
  "80012": 10,
  "80013": 10,
  "80014": 10,
  "80015": 11,
  "80016": 21,
  "80017": 10,
  "80018": 10,
  "80019": 8,
  "80020": 8,
  "80021": 8,
  "80022": 8,
  "80023": 8,
  "80024": 8,
  "80025": 7,
  "80026": 5,
  "80027": 5,
  "80030": 14,
  "80031": 8,
  "80033": 8,
  "80034": 8,
  "80035": 8,
  "80036": 8,
  "80037": 8,
  "80038": 8,
  "80040": 10,
  "80041": 10,
  "80042": 10,
  "80044": 10,
  "80045": 14,
  "80046": 11,
  "80047": 10,
  "80101": -1,
  "80102": 10,
  "80103": -1,
  "80104": 11,
  "80105": -1,
  "80106": 11,
  "80107": 11,
  "80108": 11,
  "80109": 11,
  "80110": 14,
  "80111": 21,
  "80112": 11,
  "80113": 14,
  "80116": 22,
  "80117": 0,
  "80118": 22,
  "80120": 14,
  "80121": 11,
  "80122": 11,
  "80123": 8,
  "80124": 15,
  "80125": 11,
  "80126": 11,
  "80127": 8,
  "80128": 8,
  "80129": 11,
  "80130": 15,
  "80131": 11,
  "80132": 11,
  "80133": 2,
  "80134": 11,
  "80135": 11,
  "80136": 10,
  "80137": 11,
  "80138": 11,
  "80150": 14,
  "80151": 14,
  "80155": 11,
  "80160": 14,
  "80161": 11,
  "80162": 8,
  "80163": 11,
  "80201": 8,
  "80202": 18,
  "80203": 14,
  "80204": 14,
  "80205": 14,
  "80206": 18,
  "80207": 14,
  "80209": 18,
  "80210": 14,
  "80211": 14,
  "80212": 14,
  "80214": 8,
  "80215": 8,
  "80216": 14,
  "80217": 18,
  "80218": 14,
  "80219": 14,
  "80220": 14,
  "80221": 14,
  "80222": 14,
  "80223": 14,
  "80224": 14,
  "80225": 8,
  "80226": 8,
  "80227": 8,
  "80228": 8,
  "80229": 8,
  "80230": 14,
  "80231": 10,
  "80232": 8,
  "80233": 8,
  "80234": 8,
  "80235": 8,
  "80236": 14,
  "80237": 11,
  "80238": 14,
  "80239": 8,
  "80241": 8,
  "80246": 14,
  "80247": 10,
  "80248": 18,
  "80249": 8,
  "80250": 14,
  "80260": 8,
  "80264": 14,
  "80265": 18,
  "80266": 18,
  "80290": 18,
  "80293": 18,
  "80294": 18,
  "80295": 18,
  "80299": 18,
  "80301": 5,
  "80302": 7,
  "80303": 7,
  "80304": 7,
  "80305": 7,
  "80306": 7,
  "80307": 7,
  "80308": -6,
  "80401": 8,
  "80402": 8,
  "80403": 10,
  "80420": -6,
  "80421": -6,
  "80422": -6,
  "80423": 4,
  "80424": 10,
  "80425": 11,
  "80426": 4,
  "80427": -6,
  "80428": 2,
  "80429": -6,
  "80430": 0,
  "80432": -5,
  "80433": 8,
  "80434": 0,
  "80435": 8,
  "80436": -6,
  "80437": 18,
  "80438": -6,
  "80439": 18,
  "80440": -5,
  "80442": 3,
  "80443": 10,
  "80444": -5,
  "80446": 3,
  "80447": 3,
  "80448": -6,
  "80449": -5,
  "80451": 2,
  "80452": -5,
  "80453": 8,
  "80454": 8,
  "80455": 5,
  "80456": -5,
  "80457": 8,
  "80459": 2,
  "80461": -6,
  "80463": 15,
  "80465": 8,
  "80466": -6,
  "80467": 0,
  "80468": 3,
  "80469": 0,
  "80470": -5,
  "80471": -6,
  "80473": 3,
  "80474": -6,
  "80475": -6,
  "80476": -6,
  "80477": 3,
  "80478": 3,
  "80479": 11,
  "80480": 2,
  "80481": 5,
  "80482": -4,
  "80483": 0,
  "80487": 3,
  "80488": 3,
  "80497": 8,
  "80498": 2,
  "80501": 4,
  "80502": 7,
  "80503": 5,
  "80504": 9,
  "80510": 5,
  "80511": 5,
  "80512": 3,
  "80513": 5,
  "80514": 4,
  "80515": 3,
  "80516": 5,
  "80517": 5,
  "80520": 4,
  "80521": 3,
  "80522": 3,
  "80524": 3,
  "80525": 3,
  "80526": 3,
  "80527": 3,
  "80528": 3,
  "80530": 4,
  "80532": 11,
  "80533": 5,
  "80534": 5,
  "80535": 3,
  "80536": 3,
  "80537": 3,
  "80538": 3,
  "80539": 3,
  "80540": 5,
  "80541": 11,
  "80542": 4,
  "80543": 5,
  "80544": 5,
  "80545": 3,
  "80546": 11,
  "80547": 3,
  "80549": 3,
  "80550": 11,
  "80601": 8,
  "80602": 8,
  "80603": 16,
  "80610": 3,
  "80611": 11,
  "80612": -1,
  "80614": 8,
  "80615": 11,
  "80620": 3,
  "80621": 8,
  "80622": 11,
  "80623": 3,
  "80624": 11,
  "80631": 3,
  "80632": 3,
  "80633": 3,
  "80634": 5,
  "80640": 8,
  "80642": 16,
  "80643": 11,
  "80644": 5,
  "80645": 5,
  "80646": 11,
  "80648": 3,
  "80649": 3,
  "80650": 3,
  "80651": 11,
  "80652": 3,
  "80653": 3,
  "80654": 3,
  "80701": 3,
  "80705": 3,
  "80720": 3,
  "80721": -15,
  "80722": -5,
  "80723": 3,
  "80726": -6,
  "80727": -9,
  "80728": -5,
  "80729": -1,
  "80731": -15,
  "80732": -1,
  "80733": 3,
  "80734": -15,
  "80735": -7,
  "80736": -5,
  "80737": -10,
  "80740": 3,
  "80741": -5,
  "80742": 3,
  "80743": -8,
  "80744": -9,
  "80745": -5,
  "80746": -15,
  "80747": -6,
  "80749": -9,
  "80750": 3,
  "80751": -5,
  "80754": -5,
  "80755": -9,
  "80757": 3,
  "80758": -8,
  "80759": -8,
  "80801": 3,
  "80802": -9,
  "80804": -14,
  "80805": -8,
  "80807": -8,
  "80808": -1,
  "80809": -11,
  "80810": -9,
  "80812": -7,
  "80813": -11,
  "80814": -11,
  "80815": -8,
  "80816": -11,
  "80817": 2,
  "80818": -14,
  "80819": -11,
  "80820": 0,
  "80821": -14,
  "80822": -7,
  "80823": -15,
  "80824": -7,
  "80825": -9,
  "80827": -5,
  "80828": -14,
  "80829": 2,
  "80830": -13,
  "80831": 2,
  "80832": -1,
  "80833": -1,
  "80834": -8,
  "80835": -1,
  "80836": -8,
  "80840": 11,
  "80841": 2,
  "80860": -12,
  "80861": -8,
  "80862": -13,
  "80863": -11,
  "80864": 2,
  "80866": -11,
  "80901": 2,
  "80902": 2,
  "80903": 2,
  "80904": 2,
  "80905": 2,
  "80906": 2,
  "80907": 2,
  "80908": 11,
  "80909": 2,
  "80910": 2,
  "80911": 2,
  "80912": 11,
  "80913": 2,
  "80914": 2,
  "80915": 2,
  "80916": 2,
  "80917": 2,
  "80918": 2,
  "80919": 2,
  "80920": 2,
  "80921": 11,
  "80922": 2,
  "80923": 2,
  "80924": 2,
  "80925": 2,
  "80926": 2,
  "80927": 2,
  "80928": 2,
  "80929": 2,
  "80930": 2,
  "80931": 2,
  "80932": 2,
  "80933": -11,
  "80934": 2,
  "80935": 2,
  "80936": 2,
  "80937": 2,
  "80938": 2,
  "80939": 2,
  "80949": 2,
  "80951": 2,
  "80960": 2,
  "80962": 2,
  "80970": 2,
  "81001": -1,
  "81002": -1,
  "81003": -1,
  "81004": -1,
  "81005": -1,
  "81006": 1,
  "81007": 8,
  "81008": -1,
  "81019": -2,
  "81020": -12,
  "81021": -11,
  "81022": -1,
  "81023": 8,
  "81024": -4,
  "81025": -1,
  "81027": -12,
  "81029": -10,
  "81030": -11,
  "81033": -11,
  "81036": -18,
  "81038": -11,
  "81039": -11,
  "81040": -10,
  "81041": -18,
  "81043": -18,
  "81044": -18,
  "81045": -11,
  "81046": -12,
  "81047": -18,
  "81049": -12,
  "81050": -11,
  "81052": -17,
  "81054": -11,
  "81055": -2,
  "81057": -17,
  "81058": -11,
  "81059": -12,
  "81062": -11,
  "81063": -11,
  "81064": -10,
  "81067": -11,
  "81069": -2,
  "81071": -18,
  "81073": -10,
  "81076": -11,
  "81077": -11,
  "81081": -12,
  "81082": -12,
  "81084": -10,
  "81087": -10,
  "81089": -10,
  "81090": -10,
  "81091": -10,
  "81092": -17,
  "81101": -2,
  "81120": -10,
  "81121": -8,
  "81122": -4,
  "81123": -3,
  "81124": -12,
  "81125": -12,
  "81126": -2,
  "81127": 3,
  "81128": -7,
  "81129": -10,
  "81130": -14,
  "81131": -12,
  "81132": -12,
  "81133": -2,
  "81135": -12,
  "81136": -2,
  "81137": -3,
  "81138": -12,
  "81140": -12,
  "81141": -10,
  "81143": -12,
  "81144": -12,
  "81146": -2,
  "81147": -8,
  "81148": -10,
  "81149": -12,
  "81151": -12,
  "81152": -12,
  "81154": -3,
  "81155": -10,
  "81157": -8,
  "81201": 0,
  "81210": 7,
  "81211": 0,
  "81212": -3,
  "81215": -3,
  "81220": -4,
  "81221": -4,
  "81222": -10,
  "81223": -3,
  "81224": -2,
  "81225": -4,
  "81226": -4,
  "81227": 0,
  "81228": -6,
  "81230": 0,
  "81232": -3,
  "81233": 0,
  "81235": -14,
  "81236": 0,
  "81237": 0,
  "81239": 0,
  "81240": -3,
  "81241": 0,
  "81242": 0,
  "81243": -2,
  "81244": -4,
  "81247": -1,
  "81248": 0,
  "81251": -6,
  "81252": -4,
  "81253": -4,
  "81301": -4,
  "81302": -4,
  "81303": -4,
  "81320": -6,
  "81321": -11,
  "81323": -11,
  "81324": -6,
  "81325": -6,
  "81326": -4,
  "81327": -11,
  "81328": -11,
  "81329": -4,
  "81330": -11,
  "81331": -11,
  "81332": -12,
  "81334": -11,
  "81335": -11,
  "81401": -5,
  "81402": -5,
  "81403": -5,
  "81410": -6,
  "81411": 0,
  "81413": -6,
  "81414": -6,
  "81415": -6,
  "81416": -6,
  "81418": -6,
  "81419": -6,
  "81420": -6,
  "81422": 0,
  "81423": 0,
  "81424": 0,
  "81425": -5,
  "81426": -10,
  "81427": -4,
  "81428": -6,
  "81429": 0,
  "81430": 7,
  "81431": 0,
  "81432": -4,
  "81433": -12,
  "81434": 13,
  "81435": -2,
  "81501": -2,
  "81502": -2,
  "81503": -2,
  "81504": -2,
  "81505": -2,
  "81506": -2,
  "81507": -2,
  "81520": -2,
  "81521": -2,
  "81522": -2,
  "81523": -2,
  "81524": -2,
  "81525": -2,
  "81526": -2,
  "81527": -2,
  "81601": 2,
  "81602": 2,
  "81610": -6,
  "81611": 25,
  "81612": 25,
  "81615": 25,
  "81620": 7,
  "81621": 18,
  "81623": 16,
  "81624": 2,
  "81625": -2,
  "81626": -2,
  "81630": -2,
  "81631": 7,
  "81632": 7,
  "81633": -2,
  "81635": 2,
  "81636": 2,
  "81637": 3,
  "81638": 2,
  "81639": 0,
  "81640": -2,
  "81641": -6,
  "81642": 26,
  "81643": -2,
  "81645": 10,
  "81646": -6,
  "81647": 2,
  "81648": -6,
  "81649": 10,
  "81650": 2,
  "81652": 2,
  "81653": -2,
  "81654": 25,
  "81655": 8,
  "81656": 14,
  "81657": 10,
  "81658": 7,
  "82001": -1,
  "82003": -1,
  "82005": -1,
  "82007": -1,
  "82009": -1,
  "82050": -1,
  "82051": -6,
  "82052": -6,
  "82053": -1,
  "82054": -1,
  "82055": -6,
  "82058": -8,
  "82059": -1,
  "82060": 7,
  "82061": -6,
  "82063": -5,
  "82070": -6,
  "82071": -6,
  "82072": -5,
  "82073": -6,
  "82081": -1,
  "82082": -1,
  "82083": -6,
  "82084": -6,
  "82190": 13,
  "82201": -7,
  "82210": -7,
  "82212": -15,
  "82213": -8,
  "82214": -7,
  "82215": -7,
  "82217": -15,
  "82218": -15,
  "82219": -15,
  "82221": -15,
  "82222": -9,
  "82223": -4,
  "82224": -7,
  "82225": -9,
  "82227": -9,
  "82229": -7,
  "82240": -15,
  "82242": -9,
  "82243": -4,
  "82244": -4,
  "82301": 6,
  "82310": -8,
  "82321": -2,
  "82322": 6,
  "82323": -2,
  "82324": 6,
  "82325": 8,
  "82327": 6,
  "82329": -6,
  "82331": 8,
  "82332": -2,
  "82334": 6,
  "82335": 6,
  "82336": 7,
  "82401": -7,
  "82410": -5,
  "82411": -5,
  "82412": -11,
  "82414": -11,
  "82420": -5,
  "82421": -11,
  "82422": -5,
  "82423": -12,
  "82426": -5,
  "82428": -6,
  "82430": -13,
  "82431": -5,
  "82432": -5,
  "82433": -11,
  "82434": -5,
  "82435": -11,
  "82440": -11,
  "82441": -5,
  "82442": -7,
  "82443": -13,
  "82450": -11,
  "82501": -8,
  "82510": -9,
  "82512": -8,
  "82513": 2,
  "82514": -9,
  "82515": -9,
  "82516": -8,
  "82520": -8,
  "82523": -8,
  "82524": -8,
  "82601": -1,
  "82602": -2,
  "82604": -2,
  "82605": -1,
  "82609": -1,
  "82615": 6,
  "82620": -1,
  "82630": -13,
  "82633": -8,
  "82635": -2,
  "82636": -1,
  "82637": 0,
  "82638": -13,
  "82639": -12,
  "82640": -12,
  "82642": -13,
  "82643": -2,
  "82644": -2,
  "82646": -1,
  "82648": -1,
  "82649": -9,
  "82701": -14,
  "82710": -2,
  "82711": -10,
  "82712": -6,
  "82714": 1,
  "82715": -10,
  "82716": 2,
  "82717": 2,
  "82718": 2,
  "82720": -10,
  "82721": -10,
  "82723": -10,
  "82725": 2,
  "82727": 2,
  "82729": -10,
  "82730": -10,
  "82731": -10,
  "82732": 2,
  "82801": -6,
  "82831": -7,
  "82832": -4,
  "82833": -4,
  "82834": -12,
  "82835": -6,
  "82836": -6,
  "82837": 4,
  "82838": -6,
  "82839": -6,
  "82840": -12,
  "82842": -6,
  "82844": 5,
  "82845": -6,
  "82901": 8,
  "82902": 8,
  "82922": 2,
  "82923": -7,
  "82925": -7,
  "82929": 4,
  "82930": 4,
  "82931": 4,
  "82932": 8,
  "82933": 4,
  "82934": 4,
  "82935": 8,
  "82936": 5,
  "82937": 4,
  "82938": 5,
  "82939": 4,
  "82941": -7,
  "82942": 7,
  "82943": 8,
  "82944": 4,
  "82945": 7,
  "83001": 6,
  "83002": 6,
  "83011": 13,
  "83012": 13,
  "83013": 13,
  "83014": 13,
  "83025": 13,
  "83101": -8,
  "83110": -16,
  "83111": 0,
  "83112": 0,
  "83113": -8,
  "83114": -7,
  "83115": -7,
  "83116": -8,
  "83118": 0,
  "83119": -16,
  "83120": 0,
  "83121": -8,
  "83122": 0,
  "83123": -7,
  "83124": 4,
  "83126": -8,
  "83127": 0,
  "83128": 0,
  "83201": -8,
  "83202": -8,
  "83203": -8,
  "83204": -8,
  "83205": -9,
  "83206": -8,
  "83210": -7,
  "83211": -7,
  "83212": -8,
  "83213": 8,
  "83214": -9,
  "83215": 8,
  "83217": 0,
  "83218": -11,
  "83220": -17,
  "83221": -11,
  "83223": -17,
  "83226": -12,
  "83227": -12,
  "83228": -10,
  "83229": 2,
  "83230": 0,
  "83232": -10,
  "83233": -17,
  "83234": -19,
  "83235": -10,
  "83236": -11,
  "83237": -10,
  "83238": -17,
  "83239": -17,
  "83241": 0,
  "83243": -19,
  "83244": 8,
  "83245": -8,
  "83246": 0,
  "83250": -8,
  "83251": -14,
  "83252": -18,
  "83253": -14,
  "83254": -17,
  "83255": 8,
  "83256": -11,
  "83261": -17,
  "83262": -10,
  "83263": -10,
  "83271": -7,
  "83272": -16,
  "83274": -8,
  "83276": 0,
  "83277": -11,
  "83278": -12,
  "83281": -10,
  "83283": -10,
  "83285": 0,
  "83286": -10,
  "83287": -16,
  "83301": -10,
  "83302": -9,
  "83303": -10,
  "83311": -9,
  "83312": -10,
  "83313": -7,
  "83314": -8,
  "83316": -9,
  "83318": -10,
  "83320": -7,
  "83321": -9,
  "83322": -3,
  "83323": -5,
  "83324": -4,
  "83325": -3,
  "83327": -3,
  "83328": -9,
  "83330": -8,
  "83332": -8,
  "83333": -5,
  "83334": -3,
  "83335": -3,
  "83336": -5,
  "83337": -3,
  "83338": -3,
  "83340": 5,
  "83341": -10,
  "83342": -10,
  "83343": -5,
  "83344": -3,
  "83346": -10,
  "83347": -5,
  "83348": 4,
  "83349": -4,
  "83350": -5,
  "83352": -4,
  "83353": -5,
  "83354": -5,
  "83355": -8,
  "83401": -8,
  "83402": -8,
  "83403": -8,
  "83404": -8,
  "83405": -8,
  "83406": -8,
  "83414": 13,
  "83420": -13,
  "83421": -13,
  "83422": -7,
  "83423": -12,
  "83424": -7,
  "83425": -12,
  "83427": -8,
  "83428": -7,
  "83429": -12,
  "83431": -12,
  "83433": -13,
  "83434": -12,
  "83435": -12,
  "83436": -13,
  "83438": -13,
  "83440": -13,
  "83442": -13,
  "83443": -8,
  "83444": -12,
  "83445": -13,
  "83446": -13,
  "83448": -13,
  "83449": -7,
  "83450": -12,
  "83451": -14,
  "83452": -7,
  "83454": -8,
  "83455": -7,
  "83462": -9,
  "83463": -10,
  "83464": -11,
  "83465": -1,
  "83466": -9,
  "83467": -10,
  "83468": -9,
  "83469": 2,
  "83501": -6,
  "83520": -13,
  "83522": -13,
  "83523": -13,
  "83524": -6,
  "83525": -12,
  "83526": -13,
  "83530": -12,
  "83531": -12,
  "83533": -13,
  "83535": -6,
  "83536": -12,
  "83537": -10,
  "83539": -12,
  "83540": -6,
  "83541": -6,
  "83542": -12,
  "83543": -13,
  "83544": -13,
  "83545": -13,
  "83546": -9,
  "83547": -11,
  "83548": -13,
  "83549": -11,
  "83552": -12,
  "83553": -9,
  "83554": -12,
  "83555": -13,
  "83601": -3,
  "83602": -13,
  "83604": -13,
  "83605": -7,
  "83606": -7,
  "83607": -7,
  "83610": -7,
  "83611": -10,
  "83612": -11,
  "83615": -10,
  "83616": 1,
  "83617": -12,
  "83619": -12,
  "83622": -13,
  "83623": -3,
  "83624": -13,
  "83626": -7,
  "83627": -3,
  "83628": -7,
  "83629": -12,
  "83630": -7,
  "83631": -13,
  "83632": -6,
  "83633": -8,
  "83634": 0,
  "83635": -10,
  "83636": -12,
  "83637": -13,
  "83638": -10,
  "83639": -7,
  "83641": -7,
  "83642": 1,
  "83643": -11,
  "83644": -7,
  "83645": -7,
  "83646": 1,
  "83647": -3,
  "83648": -3,
  "83650": -13,
  "83651": -7,
  "83652": -7,
  "83653": -7,
  "83654": -11,
  "83655": -12,
  "83656": -7,
  "83657": -12,
  "83660": -12,
  "83661": -12,
  "83666": -14,
  "83669": -7,
  "83670": -12,
  "83671": -12,
  "83672": -7,
  "83676": -7,
  "83677": -11,
  "83680": 1,
  "83686": -7,
  "83687": -7,
  "83701": 1,
  "83702": 1,
  "83703": 1,
  "83704": 1,
  "83705": 1,
  "83706": 1,
  "83707": 1,
  "83708": 1,
  "83709": 1,
  "83711": 1,
  "83712": 1,
  "83713": 1,
  "83714": 1,
  "83715": 1,
  "83716": 1,
  "83717": 1,
  "83719": 1,
  "83799": 1,
  "83801": -5,
  "83802": -9,
  "83803": -5,
  "83804": -5,
  "83805": -11,
  "83806": -11,
  "83808": -9,
  "83809": -8,
  "83810": -5,
  "83811": -8,
  "83812": -14,
  "83813": -8,
  "83814": -5,
  "83815": -5,
  "83816": -5,
  "83821": 0,
  "83822": -8,
  "83823": -10,
  "83824": -14,
  "83825": 0,
  "83826": -11,
  "83827": -10,
  "83830": -14,
  "83832": -6,
  "83833": 4,
  "83834": -10,
  "83835": -5,
  "83836": 0,
  "83837": -9,
  "83839": -9,
  "83840": -9,
  "83841": -8,
  "83842": -5,
  "83843": -10,
  "83845": -11,
  "83846": -9,
  "83847": -11,
  "83848": -13,
  "83849": -9,
  "83850": -9,
  "83851": -14,
  "83852": -9,
  "83853": -11,
  "83854": -5,
  "83855": -10,
  "83856": -8,
  "83857": -10,
  "83858": -5,
  "83860": 0,
  "83861": -14,
  "83864": -9,
  "83865": -8,
  "83866": -14,
  "83867": -9,
  "83868": -9,
  "83869": -5,
  "83870": -14,
  "83871": -10,
  "83872": -10,
  "83873": -9,
  "83874": -9,
  "83876": -3,
  "83877": -5,
  "84001": -5,
  "84002": -3,
  "84003": 2,
  "84004": 15,
  "84005": 0,
  "84006": 4,
  "84007": -5,
  "84008": -3,
  "84010": -1,
  "84011": -1,
  "84013": 0,
  "84014": -1,
  "84015": 1,
  "84016": 1,
  "84017": -1,
  "84018": -6,
  "84020": 4,
  "84021": -5,
  "84022": -6,
  "84023": -3,
  "84024": -1,
  "84025": -2,
  "84026": -3,
  "84027": 1,
  "84028": -10,
  "84029": 4,
  "84031": -5,
  "84032": 1,
  "84033": -5,
  "84034": -6,
  "84035": -3,
  "84036": -1,
  "84037": -2,
  "84038": -10,
  "84039": -3,
  "84040": -2,
  "84041": -2,
  "84042": 0,
  "84043": 1,
  "84044": 4,
  "84045": 0,
  "84046": -3,
  "84047": 4,
  "84049": 2,
  "84050": -5,
  "84051": -5,
  "84052": -5,
  "84053": -5,
  "84054": -1,
  "84055": -1,
  "84056": 1,
  "84057": 0,
  "84058": 0,
  "84059": 0,
  "84060": 12,
  "84061": -1,
  "84062": 0,
  "84063": -4,
  "84064": -10,
  "84065": 4,
  "84066": -5,
  "84067": 1,
  "84068": 10,
  "84069": -6,
  "84070": 4,
  "84071": -6,
  "84072": -5,
  "84073": -5,
  "84074": 4,
  "84075": -2,
  "84076": -3,
  "84078": -3,
  "84079": -3,
  "84080": -5,
  "84081": 4,
  "84082": 1,
  "84083": -7,
  "84084": 4,
  "84085": -3,
  "84086": -10,
  "84087": -1,
  "84088": 4,
  "84089": 1,
  "84090": 4,
  "84091": 4,
  "84092": 4,
  "84093": 4,
  "84094": 4,
  "84095": 4,
  "84096": 4,
  "84097": 0,
  "84098": 10,
  "84101": 4,
  "84102": 4,
  "84103": 4,
  "84104": 4,
  "84105": 4,
  "84106": 4,
  "84107": 4,
  "84108": 4,
  "84109": 4,
  "84110": 4,
  "84111": 4,
  "84112": 4,
  "84113": 4,
  "84114": 4,
  "84115": 4,
  "84116": 4,
  "84117": 4,
  "84118": 4,
  "84119": 4,
  "84120": 4,
  "84121": 4,
  "84122": 4,
  "84123": 4,
  "84124": 4,
  "84125": 4,
  "84126": 4,
  "84127": 4,
  "84128": 4,
  "84130": 4,
  "84131": 4,
  "84133": 4,
  "84138": 4,
  "84144": 4,
  "84145": 4,
  "84147": 4,
  "84151": 4,
  "84152": 4,
  "84157": 4,
  "84158": 4,
  "84165": 4,
  "84170": 4,
  "84171": 4,
  "84180": 4,
  "84301": -10,
  "84302": 0,
  "84304": -10,
  "84305": -10,
  "84306": 1,
  "84307": 2,
  "84308": -10,
  "84309": -9,
  "84310": 2,
  "84311": -10,
  "84312": -10,
  "84313": 3,
  "84314": -10,
  "84315": 1,
  "84316": 2,
  "84317": 2,
  "84318": -10,
  "84319": -10,
  "84320": -10,
  "84321": -10,
  "84323": -10,
  "84324": 0,
  "84325": -9,
  "84326": -10,
  "84327": -10,
  "84328": -9,
  "84329": 2,
  "84330": -10,
  "84331": -10,
  "84332": -10,
  "84333": -10,
  "84334": -10,
  "84335": -10,
  "84336": 2,
  "84337": 2,
  "84338": -10,
  "84339": -10,
  "84340": 0,
  "84341": -10,
  "84401": 0,
  "84402": 0,
  "84403": 0,
  "84404": 0,
  "84405": 0,
  "84409": 0,
  "84412": 1,
  "84414": 1,
  "84415": 0,
  "84501": -10,
  "84510": -14,
  "84511": -14,
  "84512": -14,
  "84513": -9,
  "84515": -12,
  "84516": -9,
  "84518": -9,
  "84520": -6,
  "84521": -9,
  "84522": -10,
  "84523": -9,
  "84525": -10,
  "84526": -6,
  "84528": -10,
  "84529": -6,
  "84530": -11,
  "84531": -14,
  "84532": -11,
  "84533": -7,
  "84534": -14,
  "84535": -14,
  "84536": -13,
  "84537": -9,
  "84539": -6,
  "84540": -12,
  "84542": -6,
  "84601": 0,
  "84602": 0,
  "84603": 0,
  "84604": 8,
  "84605": 0,
  "84606": 0,
  "84620": -13,
  "84621": -11,
  "84622": -11,
  "84623": -11,
  "84624": 0,
  "84626": 0,
  "84627": -11,
  "84628": 0,
  "84629": -11,
  "84630": -11,
  "84631": -13,
  "84632": -11,
  "84633": 0,
  "84634": -11,
  "84635": 0,
  "84636": -14,
  "84637": 0,
  "84638": -5,
  "84639": -11,
  "84640": -5,
  "84642": -11,
  "84643": -11,
  "84644": 0,
  "84645": 1,
  "84646": -11,
  "84647": -11,
  "84648": -5,
  "84649": -5,
  "84651": 1,
  "84652": -11,
  "84653": 8,
  "84654": -13,
  "84655": 1,
  "84656": -11,
  "84657": -13,
  "84660": 1,
  "84662": -11,
  "84663": 8,
  "84664": 8,
  "84665": -11,
  "84667": -11,
  "84701": -13,
  "84710": -10,
  "84711": -13,
  "84712": -4,
  "84713": -10,
  "84714": -8,
  "84715": -6,
  "84716": -7,
  "84718": -4,
  "84719": -8,
  "84720": -8,
  "84721": -8,
  "84722": -8,
  "84723": -4,
  "84724": -13,
  "84725": -9,
  "84726": -4,
  "84728": 0,
  "84729": -10,
  "84730": -13,
  "84731": -10,
  "84732": -4,
  "84733": -8,
  "84734": -7,
  "84735": -10,
  "84736": -4,
  "84737": -8,
  "84738": -8,
  "84739": -13,
  "84740": -4,
  "84741": -10,
  "84742": -8,
  "84743": -4,
  "84744": -13,
  "84745": -8,
  "84746": -8,
  "84747": -6,
  "84749": -6,
  "84750": -13,
  "84751": -11,
  "84752": -10,
  "84753": -8,
  "84754": -13,
  "84755": -10,
  "84756": -8,
  "84757": -8,
  "84758": -10,
  "84759": -4,
  "84760": -8,
  "84761": -8,
  "84762": -10,
  "84763": -8,
  "84764": -4,
  "84765": -8,
  "84766": -13,
  "84767": -8,
  "84770": -8,
  "84771": -8,
  "84772": -8,
  "84773": 2,
  "84774": -8,
  "84775": 2,
  "84776": -4,
  "84779": -8,
  "84780": -8,
  "84781": -8,
  "84782": -8,
  "84783": -8,
  "84784": -8,
  "84790": -8,
  "84791": -8,
  "85001": 6,
  "85002": 6,
  "85003": 14,
  "85004": 6,
  "85005": 6,
  "85006": 6,
  "85007": 6,
  "85008": 6,
  "85009": 6,
  "85010": 6,
  "85011": 6,
  "85012": 6,
  "85013": 7,
  "85014": 6,
  "85015": 6,
  "85016": 7,
  "85017": 6,
  "85018": 14,
  "85019": 6,
  "85020": 7,
  "85021": 7,
  "85022": 7,
  "85023": 7,
  "85024": 7,
  "85025": 6,
  "85026": 6,
  "85027": 8,
  "85028": 14,
  "85029": 6,
  "85030": 14,
  "85031": 6,
  "85032": 7,
  "85033": 6,
  "85034": 7,
  "85035": 6,
  "85036": 6,
  "85037": 6,
  "85038": 6,
  "85039": 6,
  "85040": 7,
  "85041": 6,
  "85042": 7,
  "85043": 6,
  "85044": 7,
  "85045": 15,
  "85046": 7,
  "85048": 8,
  "85050": 7,
  "85051": 6,
  "85053": 6,
  "85054": 8,
  "85055": 6,
  "85060": 14,
  "85061": 6,
  "85062": 6,
  "85063": 6,
  "85064": 7,
  "85065": 7,
  "85066": 7,
  "85067": 7,
  "85068": 7,
  "85069": 7,
  "85070": 8,
  "85071": 6,
  "85072": 6,
  "85073": 6,
  "85074": 6,
  "85075": 6,
  "85076": 7,
  "85078": 7,
  "85079": 6,
  "85080": 7,
  "85082": 6,
  "85083": 6,
  "85085": 8,
  "85086": 8,
  "85087": 7,
  "85117": 1,
  "85118": 1,
  "85119": 1,
  "85120": 1,
  "85121": 1,
  "85122": 1,
  "85123": 1,
  "85127": 1,
  "85128": 1,
  "85130": 0,
  "85131": 0,
  "85132": 0,
  "85135": 0,
  "85137": 0,
  "85138": 1,
  "85139": 1,
  "85140": 1,
  "85141": 0,
  "85142": 1,
  "85143": 1,
  "85145": 0,
  "85147": 0,
  "85172": 1,
  "85173": -10,
  "85178": 1,
  "85190": 1,
  "85191": 1,
  "85192": 1,
  "85193": -11,
  "85194": 0,
  "85201": 7,
  "85202": 7,
  "85203": 7,
  "85204": 7,
  "85205": 7,
  "85206": 7,
  "85207": 7,
  "85208": 7,
  "85209": 7,
  "85210": 7,
  "85211": 7,
  "85212": 7,
  "85213": 7,
  "85214": 7,
  "85215": 7,
  "85216": 7,
  "85217": 1,
  "85218": 1,
  "85219": 1,
  "85220": 6,
  "85221": 1,
  "85222": 0,
  "85223": 1,
  "85224": 7,
  "85225": 7,
  "85226": 7,
  "85227": 1,
  "85228": 0,
  "85230": 0,
  "85231": 0,
  "85232": 0,
  "85233": 7,
  "85234": 7,
  "85235": 0,
  "85236": 7,
  "85237": 0,
  "85238": 1,
  "85239": 7,
  "85240": 1,
  "85241": 0,
  "85242": 1,
  "85243": 1,
  "85244": 7,
  "85245": 0,
  "85246": 7,
  "85247": 0,
  "85248": 7,
  "85249": 7,
  "85250": 7,
  "85251": 7,
  "85252": 7,
  "85253": 18,
  "85254": 8,
  "85255": 10,
  "85256": 6,
  "85257": 7,
  "85258": 8,
  "85259": 10,
  "85260": 8,
  "85261": 7,
  "85262": 11,
  "85263": 10,
  "85264": 7,
  "85266": 7,
  "85267": 8,
  "85268": 8,
  "85269": 8,
  "85271": 7,
  "85272": 1,
  "85273": -10,
  "85274": 7,
  "85275": 7,
  "85277": 7,
  "85278": 6,
  "85280": 7,
  "85281": 7,
  "85282": 7,
  "85283": 7,
  "85284": 15,
  "85285": 7,
  "85286": 7,
  "85290": 10,
  "85291": 0,
  "85292": 0,
  "85293": 1,
  "85294": 0,
  "85295": 7,
  "85296": 7,
  "85297": 7,
  "85298": 7,
  "85299": 7,
  "85301": 6,
  "85302": 6,
  "85303": 6,
  "85304": 7,
  "85305": 6,
  "85306": 6,
  "85307": 6,
  "85308": 7,
  "85309": 8,
  "85310": 8,
  "85311": 6,
  "85312": 6,
  "85318": 7,
  "85320": 16,
  "85321": 1,
  "85322": 6,
  "85323": 7,
  "85324": -4,
  "85325": 15,
  "85326": 6,
  "85327": 8,
  "85328": 15,
  "85329": 6,
  "85331": 8,
  "85332": -6,
  "85333": -10,
  "85334": 15,
  "85335": 6,
  "85336": -10,
  "85337": 6,
  "85338": 8,
  "85339": 7,
  "85340": 8,
  "85341": 1,
  "85342": 6,
  "85343": 6,
  "85344": 15,
  "85345": 6,
  "85346": 15,
  "85347": -10,
  "85348": 16,
  "85349": -10,
  "85350": -10,
  "85351": 6,
  "85352": -10,
  "85353": 6,
  "85354": 6,
  "85355": 14,
  "85356": -10,
  "85357": 16,
  "85358": 7,
  "85359": 15,
  "85360": -6,
  "85361": 6,
  "85362": -6,
  "85363": 6,
  "85364": -10,
  "85365": -10,
  "85366": -10,
  "85367": -10,
  "85369": -10,
  "85371": 15,
  "85372": 6,
  "85373": 7,
  "85374": 7,
  "85375": 7,
  "85376": 7,
  "85377": 11,
  "85378": 7,
  "85379": 6,
  "85380": 7,
  "85381": 7,
  "85382": 6,
  "85383": 7,
  "85385": 6,
  "85387": 7,
  "85388": 6,
  "85390": 7,
  "85392": 6,
  "85395": 8,
  "85396": 8,
  "85501": -10,
  "85502": -10,
  "85530": -10,
  "85531": -10,
  "85532": -10,
  "85533": 17,
  "85534": 17,
  "85535": -10,
  "85536": -10,
  "85539": -10,
  "85540": 17,
  "85541": -9,
  "85542": -10,
  "85543": -10,
  "85544": -7,
  "85545": -10,
  "85546": -10,
  "85547": -9,
  "85548": -10,
  "85550": -10,
  "85551": -10,
  "85552": -10,
  "85553": -9,
  "85554": -9,
  "85601": -11,
  "85602": -8,
  "85603": -8,
  "85605": -10,
  "85606": -8,
  "85607": -8,
  "85608": -8,
  "85609": -8,
  "85610": -8,
  "85611": -10,
  "85613": -8,
  "85614": -4,
  "85615": -7,
  "85616": -8,
  "85617": -8,
  "85618": -5,
  "85619": 7,
  "85620": -8,
  "85621": -11,
  "85622": -4,
  "85623": -4,
  "85624": -10,
  "85625": -8,
  "85626": -8,
  "85627": -6,
  "85628": -11,
  "85629": -4,
  "85630": -8,
  "85631": -5,
  "85632": -8,
  "85633": -10,
  "85634": -5,
  "85635": -8,
  "85636": -7,
  "85637": -2,
  "85638": -8,
  "85639": -5,
  "85640": -11,
  "85641": -4,
  "85643": -10,
  "85644": -10,
  "85645": -11,
  "85646": -10,
  "85648": -10,
  "85650": -7,
  "85652": -4,
  "85653": -4,
  "85654": -4,
  "85655": -8,
  "85658": -4,
  "85662": -11,
  "85670": -8,
  "85671": -8,
  "85701": -4,
  "85702": -4,
  "85703": -5,
  "85704": -4,
  "85705": -5,
  "85706": -5,
  "85707": -5,
  "85708": -5,
  "85710": -4,
  "85711": -4,
  "85712": -4,
  "85713": -4,
  "85714": -5,
  "85715": 4,
  "85716": -4,
  "85717": -4,
  "85718": 4,
  "85719": -4,
  "85720": -5,
  "85722": -4,
  "85725": -5,
  "85726": -4,
  "85728": 4,
  "85730": -4,
  "85731": -4,
  "85732": -4,
  "85733": -4,
  "85734": -5,
  "85735": -11,
  "85736": -10,
  "85737": -3,
  "85738": -4,
  "85739": 4,
  "85740": -4,
  "85741": -4,
  "85742": -4,
  "85743": -4,
  "85745": -4,
  "85746": -4,
  "85747": -4,
  "85748": -4,
  "85749": 4,
  "85750": 4,
  "85751": -4,
  "85752": -4,
  "85754": -4,
  "85755": -3,
  "85756": -4,
  "85757": -4,
  "85901": -9,
  "85902": -9,
  "85911": -10,
  "85912": -9,
  "85920": 18,
  "85922": 18,
  "85923": -9,
  "85924": -8,
  "85925": 18,
  "85926": -10,
  "85927": 18,
  "85928": -9,
  "85929": -9,
  "85930": 17,
  "85931": -3,
  "85932": 18,
  "85933": -9,
  "85934": -9,
  "85935": -9,
  "85936": -10,
  "85937": -8,
  "85938": 18,
  "85939": -8,
  "85940": -9,
  "85941": -10,
  "85942": -8,
  "86001": -4,
  "86002": -5,
  "86003": -5,
  "86004": -5,
  "86015": -4,
  "86016": -6,
  "86017": -4,
  "86018": -5,
  "86020": -6,
  "86021": -6,
  "86022": -5,
  "86023": -5,
  "86024": -4,
  "86025": -8,
  "86028": -8,
  "86029": -8,
  "86030": -8,
  "86031": -8,
  "86032": -8,
  "86033": -10,
  "86034": -8,
  "86035": -5,
  "86036": -5,
  "86038": -4,
  "86039": -8,
  "86040": -5,
  "86042": -8,
  "86043": -8,
  "86044": -5,
  "86045": -5,
  "86046": -5,
  "86047": -8,
  "86052": -5,
  "86053": -5,
  "86054": -5,
  "86301": -4,
  "86302": -4,
  "86303": 4,
  "86304": -4,
  "86305": 4,
  "86312": -4,
  "86313": 4,
  "86314": -4,
  "86315": 4,
  "86320": -4,
  "86321": -6,
  "86322": -4,
  "86323": -4,
  "86324": -4,
  "86325": -4,
  "86326": -4,
  "86327": -4,
  "86329": -4,
  "86330": -4,
  "86331": -4,
  "86332": -6,
  "86333": -4,
  "86334": -4,
  "86335": -4,
  "86336": 4,
  "86337": -6,
  "86338": 4,
  "86339": 4,
  "86340": 4,
  "86341": 4,
  "86342": -4,
  "86343": -6,
  "86351": 4,
  "86401": -7,
  "86402": -7,
  "86403": 15,
  "86404": 17,
  "86405": 15,
  "86406": 17,
  "86409": -7,
  "86411": -7,
  "86412": -7,
  "86413": -7,
  "86426": -7,
  "86427": -7,
  "86429": -6,
  "86430": -7,
  "86431": -7,
  "86432": 7,
  "86433": -7,
  "86434": -7,
  "86435": -5,
  "86436": -7,
  "86437": -7,
  "86438": -7,
  "86439": -6,
  "86440": -7,
  "86441": -7,
  "86442": -7,
  "86443": -7,
  "86444": -7,
  "86445": -7,
  "86446": -7,
  "86502": -10,
  "86503": -10,
  "86504": -10,
  "86505": -10,
  "86506": -10,
  "86507": -10,
  "86508": -10,
  "86510": -8,
  "86511": -10,
  "86512": -10,
  "86514": -11,
  "86515": -10,
  "86520": -10,
  "86535": -10,
  "86538": -10,
  "86540": -10,
  "86544": -11,
  "86545": -10,
  "86547": -10,
  "86556": -10,
  "87001": -1,
  "87002": 1,
  "87004": -1,
  "87005": -9,
  "87006": 2,
  "87007": -9,
  "87008": 7,
  "87009": -14,
  "87010": -7,
  "87011": -14,
  "87012": 3,
  "87013": 5,
  "87014": -9,
  "87015": -1,
  "87016": -14,
  "87017": 3,
  "87018": 3,
  "87020": -9,
  "87021": -9,
  "87022": 1,
  "87023": 2,
  "87024": 5,
  "87025": 5,
  "87026": 1,
  "87027": 3,
  "87028": -14,
  "87029": 3,
  "87031": 1,
  "87032": -14,
  "87034": -9,
  "87035": -14,
  "87036": -14,
  "87037": 1,
  "87038": -9,
  "87040": 1,
  "87041": 8,
  "87042": 2,
  "87043": 7,
  "87044": 6,
  "87045": -9,
  "87046": 3,
  "87047": -1,
  "87048": 7,
  "87049": -9,
  "87051": -9,
  "87052": -7,
  "87053": 5,
  "87056": -7,
  "87059": 0,
  "87060": 10,
  "87061": -14,
  "87062": 1,
  "87063": -14,
  "87064": 8,
  "87068": 1,
  "87070": -14,
  "87072": 8,
  "87083": 8,
  "87101": -1,
  "87102": -1,
  "87103": 7,
  "87104": -1,
  "87105": -1,
  "87106": -1,
  "87107": -1,
  "87108": -1,
  "87109": -1,
  "87110": -1,
  "87111": 0,
  "87112": -1,
  "87113": -1,
  "87114": -1,
  "87115": -1,
  "87116": -1,
  "87119": -1,
  "87120": -1,
  "87121": -1,
  "87122": 7,
  "87123": -1,
  "87124": -1,
  "87125": -1,
  "87144": 7,
  "87153": -1,
  "87154": 0,
  "87174": -1,
  "87176": 0,
  "87181": -1,
  "87184": -1,
  "87185": -1,
  "87187": -1,
  "87190": -1,
  "87191": 0,
  "87192": -1,
  "87193": -1,
  "87194": -1,
  "87195": -1,
  "87196": -1,
  "87197": -1,
  "87198": -1,
  "87199": -1,
  "87301": -12,
  "87305": -12,
  "87310": -12,
  "87311": -12,
  "87312": -11,
  "87313": -12,
  "87315": -9,
  "87316": -12,
  "87317": -12,
  "87319": -12,
  "87320": -12,
  "87321": -9,
  "87322": -12,
  "87323": -12,
  "87325": -12,
  "87326": -12,
  "87327": -12,
  "87328": -12,
  "87347": -12,
  "87357": -9,
  "87364": 1,
  "87365": -12,
  "87375": -12,
  "87401": 2,
  "87402": 2,
  "87410": 1,
  "87412": 1,
  "87413": 1,
  "87415": 2,
  "87416": 1,
  "87417": 1,
  "87418": 2,
  "87419": 1,
  "87420": 1,
  "87421": 1,
  "87455": 1,
  "87461": 1,
  "87499": 2,
  "87501": -7,
  "87502": -7,
  "87504": -7,
  "87505": -7,
  "87506": -7,
  "87507": -7,
  "87508": -7,
  "87510": 8,
  "87511": 8,
  "87512": -6,
  "87513": -6,
  "87514": -6,
  "87515": 3,
  "87516": 8,
  "87517": -6,
  "87518": 3,
  "87519": -6,
  "87520": 3,
  "87521": -6,
  "87522": 8,
  "87523": 8,
  "87524": -6,
  "87525": -6,
  "87527": -6,
  "87528": 3,
  "87529": -6,
  "87530": 3,
  "87531": 8,
  "87532": 8,
  "87533": 8,
  "87535": -7,
  "87537": 8,
  "87538": -9,
  "87539": -6,
  "87540": -6,
  "87543": -6,
  "87544": 8,
  "87548": 8,
  "87549": -6,
  "87551": 3,
  "87552": -7,
  "87553": -6,
  "87554": -6,
  "87556": -6,
  "87557": -6,
  "87558": -6,
  "87560": -9,
  "87562": -7,
  "87564": -6,
  "87565": -9,
  "87566": 8,
  "87567": 8,
  "87569": -9,
  "87571": -6,
  "87573": -6,
  "87574": -7,
  "87575": 3,
  "87576": -6,
  "87577": -6,
  "87578": 8,
  "87579": -6,
  "87580": -6,
  "87581": -6,
  "87582": 8,
  "87583": -9,
  "87592": -7,
  "87594": -7,
  "87701": -9,
  "87710": -6,
  "87711": -9,
  "87712": -9,
  "87713": -6,
  "87714": -14,
  "87715": -6,
  "87718": -6,
  "87722": -9,
  "87723": -6,
  "87724": -9,
  "87728": -14,
  "87729": -14,
  "87730": -21,
  "87731": -9,
  "87732": -6,
  "87733": -21,
  "87734": -9,
  "87735": -9,
  "87736": -9,
  "87740": -15,
  "87742": -9,
  "87743": -21,
  "87745": -9,
  "87746": -21,
  "87747": -14,
  "87749": -14,
  "87750": 2,
  "87752": -14,
  "87753": -9,
  "87801": -14,
  "87820": -18,
  "87821": -19,
  "87823": -14,
  "87824": -20,
  "87825": -14,
  "87827": -19,
  "87828": -14,
  "87829": -19,
  "87830": -20,
  "87831": -14,
  "87832": -14,
  "87901": -9,
  "87930": -9,
  "87931": -9,
  "87933": -9,
  "87935": -9,
  "87936": -9,
  "87937": -9,
  "87939": -9,
  "87940": -9,
  "87941": -9,
  "87942": -9,
  "87943": -9,
  "88001": -10,
  "88002": -10,
  "88003": -10,
  "88004": -10,
  "88005": -10,
  "88006": -10,
  "88007": -10,
  "88008": -8,
  "88009": -13,
  "88011": -10,
  "88012": -10,
  "88013": -10,
  "88020": -13,
  "88021": -8,
  "88022": -13,
  "88023": -13,
  "88024": -10,
  "88025": 17,
  "88026": -13,
  "88027": -10,
  "88028": 17,
  "88029": 8,
  "88030": 8,
  "88031": 8,
  "88032": -10,
  "88033": -1,
  "88034": -12,
  "88036": -13,
  "88038": -12,
  "88039": -20,
  "88040": 8,
  "88041": -12,
  "88042": -9,
  "88043": -13,
  "88044": -10,
  "88045": -13,
  "88046": -10,
  "88047": -10,
  "88048": -10,
  "88049": -12,
  "88051": 26,
  "88052": -10,
  "88053": -12,
  "88054": -9,
  "88055": 17,
  "88056": -8,
  "88058": -10,
  "88061": -12,
  "88062": -12,
  "88063": -8,
  "88065": -12,
  "88072": -10,
  "88081": -8,
  "88101": -13,
  "88102": -13,
  "88103": -13,
  "88112": -13,
  "88113": -14,
  "88114": -17,
  "88115": -16,
  "88116": -16,
  "88118": -16,
  "88119": -21,
  "88120": -16,
  "88121": -16,
  "88122": -17,
  "88123": -16,
  "88124": -14,
  "88125": -16,
  "88126": -15,
  "88130": -17,
  "88132": -16,
  "88133": -14,
  "88134": -17,
  "88135": -13,
  "88136": -9,
  "88201": -11,
  "88202": -11,
  "88203": -11,
  "88210": 5,
  "88211": 5,
  "88213": 0,
  "88220": 5,
  "88221": 5,
  "88230": -11,
  "88231": 2,
  "88232": -12,
  "88240": 2,
  "88241": 2,
  "88242": 2,
  "88250": 6,
  "88252": 2,
  "88253": -11,
  "88254": 5,
  "88255": 5,
  "88256": 5,
  "88260": 2,
  "88262": 3,
  "88263": 5,
  "88264": 5,
  "88265": 2,
  "88267": 5,
  "88268": 16,
  "88301": -14,
  "88310": -11,
  "88311": -11,
  "88312": -15,
  "88314": -11,
  "88316": -15,
  "88317": -10,
  "88318": -14,
  "88321": -14,
  "88323": -15,
  "88324": -15,
  "88325": -11,
  "88330": -11,
  "88336": -15,
  "88337": -10,
  "88338": -15,
  "88339": -10,
  "88340": -15,
  "88341": -15,
  "88342": -10,
  "88343": -11,
  "88344": -10,
  "88345": -15,
  "88346": -15,
  "88347": -10,
  "88348": -15,
  "88349": -10,
  "88350": -10,
  "88351": -15,
  "88352": -11,
  "88353": -21,
  "88354": -10,
  "88355": -15,
  "88401": -16,
  "88410": -6,
  "88411": -16,
  "88414": -16,
  "88415": -5,
  "88416": -14,
  "88417": -21,
  "88418": -16,
  "88419": -16,
  "88421": -9,
  "88422": -21,
  "88424": -12,
  "88426": -16,
  "88427": -16,
  "88430": -7,
  "88431": -13,
  "88433": -16,
  "88434": -16,
  "88435": -21,
  "88436": -5,
  "88439": 2,
  "88510": -8,
  "88511": -8,
  "88512": -8,
  "88513": -8,
  "88514": -8,
  "88515": -8,
  "88516": -8,
  "88517": -8,
  "88518": -8,
  "88519": -8,
  "88520": -8,
  "88521": -8,
  "88523": -8,
  "88524": -8,
  "88525": -8,
  "88526": -8,
  "88527": -8,
  "88528": -8,
  "88529": -8,
  "88530": -8,
  "88531": -8,
  "88532": -8,
  "88533": -8,
  "88534": -8,
  "88535": -8,
  "88536": -8,
  "88538": -8,
  "88539": -8,
  "88540": -8,
  "88541": -8,
  "88542": -8,
  "88543": -8,
  "88544": -8,
  "88545": -8,
  "88546": -8,
  "88547": -8,
  "88548": -8,
  "88549": -8,
  "88550": -8,
  "88553": -8,
  "88554": -8,
  "88555": -8,
  "88556": -8,
  "88557": -8,
  "88558": -8,
  "88559": -8,
  "88560": -8,
  "88561": -8,
  "88562": -8,
  "88563": -8,
  "88565": -8,
  "88566": -8,
  "88567": -8,
  "88568": -8,
  "88569": -8,
  "88570": -8,
  "88571": -8,
  "88572": -8,
  "88573": -8,
  "88574": -8,
  "88575": -8,
  "88576": -8,
  "88577": -8,
  "88578": -8,
  "88579": -8,
  "88580": -8,
  "88581": -8,
  "88582": -8,
  "88583": -8,
  "88584": -8,
  "88585": -8,
  "88586": -8,
  "88587": -8,
  "88588": -8,
  "88589": -8,
  "88590": -8,
  "88595": -8,
  "89001": -6,
  "89002": 7,
  "89003": -6,
  "89004": 7,
  "89005": 7,
  "89006": 7,
  "89007": 7,
  "89008": -2,
  "89009": 7,
  "89010": -2,
  "89011": 18,
  "89012": 7,
  "89013": -2,
  "89014": 7,
  "89015": 7,
  "89016": 18,
  "89017": -6,
  "89018": 7,
  "89019": 7,
  "89020": 7,
  "89021": 7,
  "89022": -6,
  "89023": 7,
  "89024": 7,
  "89025": 7,
  "89027": 7,
  "89028": 7,
  "89029": 7,
  "89030": 7,
  "89031": 7,
  "89032": 7,
  "89033": 7,
  "89034": -2,
  "89036": 7,
  "89037": 7,
  "89039": 7,
  "89040": 7,
  "89041": 7,
  "89042": -2,
  "89043": -2,
  "89044": 7,
  "89045": -6,
  "89046": 7,
  "89047": -2,
  "89048": 7,
  "89049": -6,
  "89052": 7,
  "89053": 7,
  "89054": 7,
  "89060": 7,
  "89061": 7,
  "89067": 7,
  "89074": 7,
  "89077": 7,
  "89081": 7,
  "89084": 7,
  "89085": 7,
  "89086": 7,
  "89087": 7,
  "89101": 7,
  "89102": 7,
  "89103": 7,
  "89104": 7,
  "89105": 7,
  "89106": 7,
  "89107": 7,
  "89108": 7,
  "89109": 7,
  "89110": 7,
  "89111": 7,
  "89112": 7,
  "89113": 7,
  "89114": 7,
  "89115": 7,
  "89116": 7,
  "89117": 7,
  "89118": 7,
  "89119": 7,
  "89120": 7,
  "89121": 7,
  "89122": 7,
  "89123": 7,
  "89124": 7,
  "89125": 7,
  "89126": 7,
  "89127": 7,
  "89128": 7,
  "89129": 7,
  "89130": 7,
  "89131": 7,
  "89132": 7,
  "89133": 7,
  "89134": 7,
  "89135": 7,
  "89136": 7,
  "89137": 7,
  "89138": 7,
  "89139": 7,
  "89140": 7,
  "89141": 7,
  "89142": 7,
  "89143": 7,
  "89144": 7,
  "89145": 7,
  "89146": 7,
  "89147": 7,
  "89148": 11,
  "89149": 7,
  "89154": 7,
  "89156": 7,
  "89157": 7,
  "89160": 7,
  "89161": 7,
  "89162": 7,
  "89165": 7,
  "89166": 7,
  "89169": 7,
  "89170": 7,
  "89173": 7,
  "89178": 11,
  "89179": 7,
  "89180": 7,
  "89183": 7,
  "89185": 7,
  "89191": 7,
  "89193": 7,
  "89199": 7,
  "89301": -2,
  "89310": -5,
  "89311": 7,
  "89314": -2,
  "89315": -2,
  "89316": -1,
  "89317": -2,
  "89318": -2,
  "89319": -2,
  "89402": 13,
  "89403": 19,
  "89404": -2,
  "89405": -5,
  "89406": 8,
  "89407": 8,
  "89408": 8,
  "89409": -5,
  "89410": -1,
  "89411": 10,
  "89412": -5,
  "89413": 13,
  "89414": -1,
  "89415": -5,
  "89418": -5,
  "89419": -4,
  "89420": -4,
  "89421": -3,
  "89422": -5,
  "89423": -1,
  "89424": 5,
  "89425": -2,
  "89426": -1,
  "89427": -5,
  "89428": 19,
  "89429": 2,
  "89430": -1,
  "89431": 5,
  "89432": 5,
  "89433": 5,
  "89434": 5,
  "89435": 5,
  "89436": 5,
  "89438": -1,
  "89439": 5,
  "89440": 19,
  "89441": 19,
  "89442": 5,
  "89444": -1,
  "89445": -1,
  "89446": -1,
  "89447": 2,
  "89448": 3,
  "89449": -1,
  "89450": 13,
  "89451": 13,
  "89452": 13,
  "89460": -1,
  "89501": 5,
  "89502": 19,
  "89503": 5,
  "89504": 5,
  "89505": 5,
  "89506": 5,
  "89507": 5,
  "89508": 5,
  "89509": 5,
  "89510": 5,
  "89511": 19,
  "89512": 5,
  "89513": 5,
  "89515": 19,
  "89519": 19,
  "89520": 19,
  "89521": 19,
  "89523": 5,
  "89533": 5,
  "89570": 19,
  "89701": 2,
  "89702": 2,
  "89703": 2,
  "89704": 2,
  "89705": 2,
  "89706": 2,
  "89721": -1,
  "89801": 12,
  "89802": 12,
  "89803": 12,
  "89815": 12,
  "89820": -5,
  "89821": 12,
  "89822": 11,
  "89823": 11,
  "89824": 11,
  "89825": 2,
  "89826": 2,
  "89828": 12,
  "89830": 11,
  "89831": 11,
  "89832": 11,
  "89833": 12,
  "89834": 11,
  "89835": 11,
  "89883": 11,
  "90001": 8,
  "90002": 8,
  "90003": 8,
  "90004": 11,
  "90005": 11,
  "90006": 8,
  "90007": 9,
  "90008": 11,
  "90009": 11,
  "90010": 11,
  "90011": 8,
  "90012": 8,
  "90013": 8,
  "90014": 8,
  "90015": 8,
  "90016": 8,
  "90017": 11,
  "90018": 8,
  "90019": 11,
  "90020": 9,
  "90021": 11,
  "90022": 9,
  "90023": 9,
  "90024": 13,
  "90025": 11,
  "90026": 9,
  "90027": 11,
  "90028": 9,
  "90029": 9,
  "90030": 8,
  "90031": 8,
  "90032": 8,
  "90033": 8,
  "90034": 11,
  "90035": 11,
  "90036": 11,
  "90037": 8,
  "90038": 9,
  "90039": 11,
  "90040": 11,
  "90041": 9,
  "90042": 8,
  "90043": 8,
  "90044": 8,
  "90045": 11,
  "90046": 11,
  "90047": 8,
  "90048": 11,
  "90049": 20,
  "90050": 8,
  "90051": 8,
  "90052": 8,
  "90053": 8,
  "90054": 8,
  "90055": 8,
  "90056": 11,
  "90057": 8,
  "90058": 8,
  "90059": 8,
  "90060": 11,
  "90061": 8,
  "90062": 8,
  "90063": 8,
  "90064": 11,
  "90065": 9,
  "90066": 11,
  "90067": 11,
  "90068": 11,
  "90069": 11,
  "90070": 11,
  "90071": 11,
  "90072": 9,
  "90073": 11,
  "90075": 9,
  "90076": 11,
  "90077": 20,
  "90078": 9,
  "90079": 8,
  "90080": 11,
  "90081": 11,
  "90082": 8,
  "90083": 11,
  "90086": 8,
  "90087": 8,
  "90091": 9,
  "90093": 9,
  "90094": 11,
  "90099": 8,
  "90101": 9,
  "90201": 8,
  "90202": 8,
  "90209": 13,
  "90210": 20,
  "90211": 13,
  "90212": 20,
  "90213": 20,
  "90220": 8,
  "90221": 8,
  "90222": 8,
  "90223": 8,
  "90224": 9,
  "90230": 11,
  "90231": 11,
  "90232": 11,
  "90233": 11,
  "90239": 9,
  "90240": 11,
  "90241": 9,
  "90242": 9,
  "90245": 11,
  "90247": 8,
  "90248": 8,
  "90249": 9,
  "90250": 9,
  "90251": 9,
  "90254": 13,
  "90255": 8,
  "90260": 9,
  "90261": 9,
  "90262": 8,
  "90263": 15,
  "90264": 15,
  "90265": 15,
  "90266": 20,
  "90267": 13,
  "90270": 8,
  "90272": 20,
  "90274": 20,
  "90275": 20,
  "90277": 11,
  "90278": 11,
  "90280": 8,
  "90290": 11,
  "90291": 11,
  "90292": 11,
  "90293": 11,
  "90294": 11,
  "90295": 11,
  "90296": 11,
  "90301": 8,
  "90302": 8,
  "90303": 8,
  "90304": 8,
  "90305": 9,
  "90306": 8,
  "90307": 8,
  "90308": 8,
  "90309": 8,
  "90310": 8,
  "90311": 8,
  "90312": 8,
  "90401": 11,
  "90402": 20,
  "90403": 11,
  "90404": 11,
  "90405": 11,
  "90406": 11,
  "90407": 11,
  "90408": 11,
  "90409": 11,
  "90410": 11,
  "90411": 11,
  "90501": 11,
  "90502": 9,
  "90503": 11,
  "90504": 11,
  "90505": 11,
  "90506": 11,
  "90507": 11,
  "90508": 11,
  "90509": 11,
  "90510": 11,
  "90601": 9,
  "90602": 9,
  "90603": 14,
  "90604": 13,
  "90605": 8,
  "90606": 9,
  "90607": 9,
  "90608": 9,
  "90609": 9,
  "90610": 9,
  "90620": 14,
  "90621": 13,
  "90622": 14,
  "90623": 16,
  "90624": 14,
  "90630": 16,
  "90631": 14,
  "90632": 14,
  "90633": 14,
  "90637": 14,
  "90638": 14,
  "90640": 9,
  "90650": 8,
  "90651": 8,
  "90652": 9,
  "90660": 9,
  "90661": 9,
  "90662": 11,
  "90670": 9,
  "90671": 9,
  "90680": 13,
  "90701": 14,
  "90702": 14,
  "90703": 16,
  "90704": 16,
  "90706": 9,
  "90707": 9,
  "90710": 9,
  "90711": 9,
  "90712": 9,
  "90713": 14,
  "90714": 9,
  "90715": 14,
  "90716": 9,
  "90717": 11,
  "90720": 16,
  "90721": 16,
  "90723": 8,
  "90731": 16,
  "90732": 11,
  "90733": 16,
  "90734": 11,
  "90740": 13,
  "90742": 24,
  "90743": 24,
  "90744": 8,
  "90745": 9,
  "90746": 9,
  "90748": 8,
  "90749": 9,
  "90755": 13,
  "90801": 13,
  "90802": 13,
  "90803": 16,
  "90804": 16,
  "90805": 8,
  "90806": 14,
  "90807": 9,
  "90808": 16,
  "90809": 16,
  "90810": 8,
  "90813": 13,
  "90814": 16,
  "90815": 16,
  "90822": 8,
  "90831": 13,
  "90832": 13,
  "90833": 13,
  "90834": 13,
  "90835": 13,
  "90853": 16,
  "91001": 11,
  "91003": 11,
  "91006": 11,
  "91007": 11,
  "91008": 9,
  "91009": 9,
  "91010": 9,
  "91011": 20,
  "91012": 20,
  "91016": 9,
  "91017": 9,
  "91020": 11,
  "91021": 11,
  "91023": 11,
  "91024": 13,
  "91025": 13,
  "91030": 13,
  "91031": 13,
  "91040": 9,
  "91041": 9,
  "91042": 9,
  "91043": 9,
  "91046": 11,
  "91066": 11,
  "91077": 11,
  "91101": 9,
  "91102": 9,
  "91103": 9,
  "91104": 11,
  "91105": 20,
  "91106": 11,
  "91107": 11,
  "91108": 20,
  "91109": 9,
  "91114": 11,
  "91115": 20,
  "91116": 11,
  "91117": 11,
  "91118": 11,
  "91201": 11,
  "91202": 11,
  "91203": 9,
  "91204": 9,
  "91205": 9,
  "91206": 11,
  "91207": 20,
  "91208": 13,
  "91209": 9,
  "91210": 9,
  "91214": 11,
  "91221": 11,
  "91222": 9,
  "91224": 11,
  "91225": 9,
  "91226": 11,
  "91301": 7,
  "91302": 8,
  "91303": 8,
  "91304": 9,
  "91305": 8,
  "91306": 9,
  "91307": 7,
  "91308": 8,
  "91309": 9,
  "91310": 4,
  "91311": 11,
  "91313": 11,
  "91316": 11,
  "91319": 4,
  "91320": 4,
  "91321": 9,
  "91322": 9,
  "91324": 11,
  "91325": 11,
  "91326": 11,
  "91327": 11,
  "91328": 8,
  "91331": 8,
  "91333": 8,
  "91334": 8,
  "91335": 8,
  "91337": 8,
  "91340": 8,
  "91341": 8,
  "91342": 8,
  "91343": 9,
  "91344": 11,
  "91345": 8,
  "91346": 8,
  "91350": 16,
  "91351": 9,
  "91352": 8,
  "91353": 8,
  "91354": 7,
  "91355": 11,
  "91356": 11,
  "91357": 11,
  "91358": 7,
  "91359": 7,
  "91360": 7,
  "91361": 15,
  "91362": 7,
  "91364": 11,
  "91365": 11,
  "91367": 11,
  "91372": 8,
  "91376": 7,
  "91377": 7,
  "91380": 16,
  "91381": 7,
  "91382": 9,
  "91383": 9,
  "91384": 4,
  "91385": 11,
  "91386": 9,
  "91387": 9,
  "91390": 16,
  "91392": 8,
  "91393": 9,
  "91394": 11,
  "91395": 8,
  "91396": 9,
  "91401": 11,
  "91402": 8,
  "91403": 11,
  "91404": 11,
  "91405": 8,
  "91406": 8,
  "91407": 8,
  "91408": 11,
  "91409": 8,
  "91410": 8,
  "91411": 9,
  "91412": 8,
  "91413": 11,
  "91416": 11,
  "91423": 11,
  "91426": 11,
  "91436": 9,
  "91501": 11,
  "91502": 9,
  "91503": 9,
  "91504": 11,
  "91505": 9,
  "91506": 11,
  "91507": 9,
  "91508": 11,
  "91510": 9,
  "91601": 9,
  "91602": 11,
  "91603": 9,
  "91604": 11,
  "91605": 8,
  "91606": 8,
  "91607": 11,
  "91608": 11,
  "91609": 8,
  "91610": 11,
  "91614": 11,
  "91615": 8,
  "91616": 8,
  "91617": 11,
  "91618": 11,
  "91701": 20,
  "91702": 8,
  "91706": 8,
  "91708": 13,
  "91709": 13,
  "91710": 13,
  "91711": 16,
  "91714": 8,
  "91715": 9,
  "91716": 9,
  "91722": 9,
  "91723": 9,
  "91724": 9,
  "91729": 13,
  "91730": 13,
  "91731": 8,
  "91732": 8,
  "91733": 8,
  "91734": 8,
  "91737": 20,
  "91739": 12,
  "91740": 9,
  "91741": 11,
  "91743": 13,
  "91744": 8,
  "91745": 9,
  "91746": 8,
  "91747": 8,
  "91748": 14,
  "91749": 8,
  "91750": 9,
  "91752": 13,
  "91754": 9,
  "91755": 9,
  "91758": 13,
  "91759": 18,
  "91761": 13,
  "91762": 13,
  "91763": 13,
  "91764": 13,
  "91765": 16,
  "91766": 13,
  "91767": 13,
  "91768": 13,
  "91769": 13,
  "91770": 9,
  "91773": 9,
  "91775": 11,
  "91776": 9,
  "91778": 9,
  "91780": 9,
  "91784": 24,
  "91785": 13,
  "91786": 13,
  "91788": 16,
  "91789": 16,
  "91790": 9,
  "91791": 9,
  "91792": 8,
  "91793": 9,
  "91801": 9,
  "91802": 9,
  "91803": 9,
  "91804": 9,
  "91896": 9,
  "91899": 9,
  "91901": 11,
  "91902": 12,
  "91903": 11,
  "91905": 8,
  "91906": 8,
  "91908": 12,
  "91909": 9,
  "91910": 9,
  "91911": 9,
  "91912": 9,
  "91913": 9,
  "91914": 9,
  "91915": 9,
  "91916": 8,
  "91917": 9,
  "91921": 9,
  "91931": 8,
  "91932": 9,
  "91933": 9,
  "91934": -1,
  "91935": 11,
  "91941": 11,
  "91942": 9,
  "91943": 9,
  "91944": 11,
  "91945": 8,
  "91946": 8,
  "91947": 9,
  "91948": 8,
  "91950": 9,
  "91951": 9,
  "91962": 11,
  "91963": 9,
  "91976": 11,
  "91977": 8,
  "91978": 8,
  "91979": 8,
  "91980": 9,
  "92003": 11,
  "92004": 0,
  "92007": 11,
  "92008": 9,
  "92009": 11,
  "92010": 11,
  "92011": 9,
  "92013": 9,
  "92014": 20,
  "92018": 9,
  "92019": 11,
  "92020": 9,
  "92021": 9,
  "92022": 8,
  "92023": 11,
  "92024": 11,
  "92025": 8,
  "92026": 8,
  "92027": 8,
  "92028": 9,
  "92029": 11,
  "92030": 8,
  "92033": 8,
  "92036": 8,
  "92037": 20,
  "92038": 20,
  "92039": 20,
  "92040": 9,
  "92046": 8,
  "92049": 8,
  "92051": 8,
  "92052": 8,
  "92054": 8,
  "92055": 8,
  "92056": 8,
  "92057": 8,
  "92058": 8,
  "92059": 8,
  "92060": 8,
  "92061": 8,
  "92064": 9,
  "92065": 9,
  "92066": 8,
  "92067": 20,
  "92068": 8,
  "92069": 8,
  "92070": 8,
  "92071": 9,
  "92072": 9,
  "92074": 9,
  "92075": 11,
  "92078": 8,
  "92079": 8,
  "92081": 8,
  "92082": 9,
  "92083": 8,
  "92084": 8,
  "92085": 8,
  "92086": 2,
  "92088": 9,
  "92091": 11,
  "92101": 11,
  "92102": 9,
  "92103": 11,
  "92104": 9,
  "92105": 8,
  "92106": 13,
  "92107": 12,
  "92108": 8,
  "92109": 11,
  "92110": 11,
  "92111": 9,
  "92112": 11,
  "92113": 8,
  "92114": 9,
  "92115": 9,
  "92116": 9,
  "92117": 9,
  "92118": 20,
  "92119": 9,
  "92120": 11,
  "92121": 11,
  "92122": 11,
  "92123": 9,
  "92124": 11,
  "92126": 9,
  "92127": 9,
  "92128": 9,
  "92129": 11,
  "92130": 20,
  "92131": 11,
  "92135": 20,
  "92137": 11,
  "92138": 11,
  "92139": 9,
  "92142": 11,
  "92143": 9,
  "92149": 9,
  "92150": 9,
  "92153": 9,
  "92154": 9,
  "92159": 9,
  "92160": 11,
  "92162": 9,
  "92163": 11,
  "92164": 9,
  "92165": 8,
  "92166": 13,
  "92167": 12,
  "92168": 8,
  "92169": 11,
  "92170": 8,
  "92171": 9,
  "92172": 11,
  "92173": 9,
  "92174": 9,
  "92175": 9,
  "92176": 9,
  "92177": 9,
  "92178": 20,
  "92179": 9,
  "92186": 11,
  "92190": 11,
  "92191": 11,
  "92192": 11,
  "92193": 9,
  "92194": 9,
  "92195": 8,
  "92196": 9,
  "92197": 9,
  "92198": 9,
  "92199": 9,
  "92201": 3,
  "92202": 3,
  "92203": 2,
  "92210": 14,
  "92211": 3,
  "92220": 0,
  "92222": -10,
  "92223": 0,
  "92225": 15,
  "92226": 15,
  "92227": -3,
  "92230": 2,
  "92231": -1,
  "92232": -1,
  "92233": -3,
  "92234": 2,
  "92235": 2,
  "92236": 2,
  "92239": -1,
  "92240": 2,
  "92241": 2,
  "92242": 15,
  "92243": -3,
  "92244": -3,
  "92247": 3,
  "92248": 3,
  "92249": -3,
  "92250": -3,
  "92251": 6,
  "92252": 2,
  "92253": 3,
  "92254": 2,
  "92255": 3,
  "92256": 2,
  "92257": -1,
  "92258": 2,
  "92259": -1,
  "92260": 3,
  "92261": 3,
  "92262": 2,
  "92263": 2,
  "92264": 4,
  "92266": 15,
  "92267": 15,
  "92268": 7,
  "92270": 4,
  "92273": -3,
  "92274": 2,
  "92275": 2,
  "92276": 2,
  "92277": 2,
  "92278": 2,
  "92280": 15,
  "92281": -3,
  "92282": 2,
  "92283": -10,
  "92284": 2,
  "92285": 7,
  "92286": 2,
  "92292": 4,
  "92301": 6,
  "92304": 7,
  "92305": 6,
  "92307": 6,
  "92308": 5,
  "92309": 7,
  "92310": 5,
  "92311": 5,
  "92312": 5,
  "92313": 6,
  "92314": 5,
  "92315": 6,
  "92316": 6,
  "92317": 14,
  "92318": 5,
  "92320": 0,
  "92321": 6,
  "92322": 6,
  "92323": 7,
  "92324": 6,
  "92325": 6,
  "92326": 14,
  "92327": 5,
  "92328": 4,
  "92329": 6,
  "92331": 6,
  "92332": 7,
  "92333": 8,
  "92334": 6,
  "92335": 6,
  "92336": 6,
  "92337": 13,
  "92338": 7,
  "92339": 1,
  "92340": 5,
  "92341": 6,
  "92342": 5,
  "92344": 5,
  "92345": 5,
  "92346": 6,
  "92347": 6,
  "92352": 14,
  "92354": 6,
  "92356": 5,
  "92358": 6,
  "92359": 6,
  "92363": 7,
  "92364": 7,
  "92365": 5,
  "92366": 7,
  "92368": 5,
  "92369": 6,
  "92371": 5,
  "92372": 6,
  "92373": 6,
  "92374": 6,
  "92375": 6,
  "92376": 6,
  "92377": 6,
  "92378": 6,
  "92382": 6,
  "92384": 18,
  "92385": 6,
  "92386": 6,
  "92389": 7,
  "92391": 6,
  "92392": 6,
  "92393": 6,
  "92394": 5,
  "92395": 6,
  "92397": 6,
  "92398": 5,
  "92399": 1,
  "92401": 5,
  "92402": 6,
  "92403": 5,
  "92404": 5,
  "92405": 5,
  "92406": 5,
  "92407": 6,
  "92408": 5,
  "92410": 5,
  "92411": 5,
  "92412": 5,
  "92413": 5,
  "92423": 5,
  "92427": 6,
  "92501": 13,
  "92502": 13,
  "92503": 13,
  "92504": 13,
  "92505": 13,
  "92506": 14,
  "92507": 2,
  "92508": 3,
  "92509": 13,
  "92513": 13,
  "92514": 13,
  "92515": 13,
  "92516": 14,
  "92517": 13,
  "92518": 3,
  "92519": 13,
  "92530": 13,
  "92531": 13,
  "92532": 3,
  "92536": 2,
  "92539": 2,
  "92543": 0,
  "92544": 0,
  "92545": 0,
  "92546": 0,
  "92548": 0,
  "92549": 11,
  "92551": 2,
  "92552": 2,
  "92553": 2,
  "92554": 2,
  "92555": 2,
  "92556": 2,
  "92557": 2,
  "92561": 3,
  "92562": 3,
  "92563": 2,
  "92564": 2,
  "92567": 0,
  "92570": 2,
  "92571": 2,
  "92572": 2,
  "92581": 0,
  "92582": 0,
  "92583": 0,
  "92584": 2,
  "92585": 0,
  "92586": 0,
  "92587": 3,
  "92589": 3,
  "92590": 14,
  "92591": 3,
  "92592": 3,
  "92593": 3,
  "92595": 2,
  "92596": 8,
  "92602": 16,
  "92603": 16,
  "92604": 16,
  "92605": 16,
  "92606": 16,
  "92607": 16,
  "92609": 16,
  "92610": 16,
  "92612": 16,
  "92614": 16,
  "92615": 16,
  "92616": 16,
  "92617": 16,
  "92618": 16,
  "92619": 13,
  "92620": 16,
  "92623": 16,
  "92624": 16,
  "92625": 24,
  "92626": 16,
  "92627": 16,
  "92628": 16,
  "92629": 16,
  "92630": 16,
  "92637": 13,
  "92646": 16,
  "92647": 16,
  "92648": 17,
  "92649": 16,
  "92650": 16,
  "92651": 17,
  "92652": 17,
  "92653": 13,
  "92654": 13,
  "92655": 13,
  "92656": 15,
  "92657": 24,
  "92658": 16,
  "92659": 24,
  "92660": 16,
  "92661": 24,
  "92662": 24,
  "92663": 24,
  "92672": 16,
  "92673": 16,
  "92674": 16,
  "92675": 16,
  "92676": 16,
  "92677": 16,
  "92678": 16,
  "92679": 16,
  "92683": 14,
  "92684": 14,
  "92685": 14,
  "92688": 15,
  "92690": 16,
  "92691": 16,
  "92692": 16,
  "92693": 16,
  "92694": 16,
  "92701": 13,
  "92702": 13,
  "92703": 13,
  "92704": 13,
  "92705": 16,
  "92706": 14,
  "92707": 13,
  "92708": 16,
  "92711": 17,
  "92712": 13,
  "92728": 13,
  "92735": 13,
  "92780": 16,
  "92781": 16,
  "92782": 16,
  "92799": 13,
  "92801": 13,
  "92802": 13,
  "92803": 13,
  "92804": 14,
  "92805": 13,
  "92806": 14,
  "92807": 16,
  "92808": 16,
  "92809": 13,
  "92811": 16,
  "92812": 13,
  "92814": 14,
  "92815": 13,
  "92816": 14,
  "92817": 16,
  "92821": 16,
  "92822": 16,
  "92823": 16,
  "92825": 13,
  "92831": 16,
  "92832": 13,
  "92833": 14,
  "92834": 16,
  "92835": 16,
  "92836": 16,
  "92837": 14,
  "92838": 16,
  "92840": 13,
  "92841": 14,
  "92842": 13,
  "92843": 13,
  "92844": 13,
  "92845": 16,
  "92846": 16,
  "92856": 16,
  "92857": 14,
  "92859": 16,
  "92860": 15,
  "92861": 24,
  "92862": 16,
  "92863": 16,
  "92864": 16,
  "92865": 14,
  "92866": 16,
  "92867": 16,
  "92868": 13,
  "92869": 16,
  "92870": 16,
  "92871": 16,
  "92877": 14,
  "92878": 13,
  "92879": 13,
  "92880": 14,
  "92881": 15,
  "92882": 14,
  "92883": 14,
  "92885": 16,
  "92886": 16,
  "92887": 24,
  "92899": 14,
  "93001": 4,
  "93002": 4,
  "93003": 4,
  "93004": 4,
  "93005": 4,
  "93006": 4,
  "93007": 4,
  "93010": 4,
  "93011": 4,
  "93012": 4,
  "93013": 7,
  "93014": 7,
  "93015": 4,
  "93016": 4,
  "93020": 4,
  "93021": 4,
  "93022": 4,
  "93023": 4,
  "93024": 4,
  "93030": 4,
  "93031": 4,
  "93032": 4,
  "93033": 4,
  "93034": 4,
  "93035": 4,
  "93036": 4,
  "93040": 4,
  "93041": 4,
  "93044": 4,
  "93060": 4,
  "93061": 4,
  "93062": 7,
  "93063": 4,
  "93065": 7,
  "93066": 15,
  "93067": 5,
  "93094": 7,
  "93101": 5,
  "93102": 5,
  "93103": 5,
  "93105": 5,
  "93107": 5,
  "93108": 13,
  "93109": 5,
  "93110": 5,
  "93111": 5,
  "93116": 5,
  "93117": 5,
  "93118": 5,
  "93120": 5,
  "93121": 5,
  "93130": 5,
  "93140": 5,
  "93150": 13,
  "93160": 5,
  "93190": 5,
  "93201": 1,
  "93202": 2,
  "93203": 4,
  "93204": 3,
  "93205": 4,
  "93206": 4,
  "93207": -2,
  "93208": -1,
  "93210": 3,
  "93212": 2,
  "93215": -1,
  "93216": -1,
  "93218": -1,
  "93219": -2,
  "93220": 4,
  "93221": -1,
  "93222": 3,
  "93223": -1,
  "93224": 1,
  "93225": 3,
  "93226": 4,
  "93227": -1,
  "93230": 2,
  "93232": 2,
  "93234": 2,
  "93235": -1,
  "93237": -1,
  "93238": 4,
  "93239": 1,
  "93240": 4,
  "93241": 4,
  "93242": 4,
  "93243": 4,
  "93244": -1,
  "93245": 10,
  "93247": -1,
  "93249": 3,
  "93250": -1,
  "93251": 1,
  "93252": 4,
  "93254": 2,
  "93255": 4,
  "93256": -1,
  "93257": -1,
  "93258": -2,
  "93260": 4,
  "93261": -2,
  "93262": -1,
  "93263": 4,
  "93265": 7,
  "93266": 1,
  "93267": -2,
  "93268": 4,
  "93270": -1,
  "93271": -1,
  "93272": -1,
  "93274": -1,
  "93275": -1,
  "93276": 4,
  "93277": -1,
  "93278": -1,
  "93279": -1,
  "93280": 4,
  "93282": 1,
  "93283": 4,
  "93285": 4,
  "93286": -1,
  "93287": 13,
  "93290": -1,
  "93291": -1,
  "93292": -1,
  "93301": 5,
  "93302": 5,
  "93303": 5,
  "93304": 4,
  "93305": 4,
  "93306": 4,
  "93307": 4,
  "93308": 5,
  "93309": 5,
  "93311": 5,
  "93312": 6,
  "93313": 5,
  "93314": 6,
  "93380": 5,
  "93383": 5,
  "93384": 5,
  "93385": 4,
  "93386": 4,
  "93387": 4,
  "93388": 5,
  "93389": 5,
  "93390": 4,
  "93401": 3,
  "93402": 2,
  "93403": 3,
  "93405": 3,
  "93406": 3,
  "93407": 3,
  "93410": 3,
  "93412": 2,
  "93420": 3,
  "93421": 3,
  "93422": 2,
  "93423": 2,
  "93424": 5,
  "93426": 3,
  "93427": 2,
  "93428": 13,
  "93429": 1,
  "93430": 5,
  "93432": 2,
  "93433": 2,
  "93434": 1,
  "93435": 13,
  "93436": 1,
  "93437": 1,
  "93438": 1,
  "93440": 2,
  "93441": 4,
  "93442": 3,
  "93443": 3,
  "93444": 4,
  "93445": 2,
  "93446": 3,
  "93447": 3,
  "93448": 3,
  "93449": 3,
  "93450": 2,
  "93451": 3,
  "93452": 5,
  "93453": 2,
  "93454": 2,
  "93455": 2,
  "93456": 2,
  "93457": 2,
  "93458": 2,
  "93460": 5,
  "93461": 2,
  "93463": 4,
  "93464": 4,
  "93465": 3,
  "93475": 2,
  "93483": 2,
  "93501": 4,
  "93502": 4,
  "93504": 4,
  "93505": 4,
  "93510": 16,
  "93512": -2,
  "93513": 3,
  "93514": -1,
  "93515": -1,
  "93516": 6,
  "93517": -1,
  "93518": 5,
  "93519": 4,
  "93522": 4,
  "93523": 4,
  "93526": 2,
  "93527": 4,
  "93528": 4,
  "93529": 0,
  "93530": 2,
  "93531": 13,
  "93532": 7,
  "93534": 7,
  "93535": 7,
  "93536": 7,
  "93539": 7,
  "93541": -2,
  "93542": 4,
  "93543": 7,
  "93544": 7,
  "93545": 2,
  "93546": 7,
  "93549": 2,
  "93550": 7,
  "93551": 7,
  "93552": 7,
  "93553": 7,
  "93554": 4,
  "93555": 4,
  "93556": 4,
  "93558": 4,
  "93560": 4,
  "93561": 5,
  "93562": 2,
  "93563": 7,
  "93581": 5,
  "93584": 7,
  "93586": 7,
  "93590": 7,
  "93591": 7,
  "93592": 2,
  "93596": 6,
  "93601": -2,
  "93602": -1,
  "93603": -1,
  "93604": -1,
  "93605": -1,
  "93606": 3,
  "93607": 3,
  "93608": 3,
  "93609": 3,
  "93610": -2,
  "93611": 3,
  "93612": 3,
  "93613": 3,
  "93614": -1,
  "93615": -1,
  "93616": 3,
  "93618": -1,
  "93619": 3,
  "93620": -5,
  "93621": -1,
  "93622": -5,
  "93623": 9,
  "93624": 3,
  "93625": 3,
  "93626": -1,
  "93627": 14,
  "93628": -1,
  "93630": 3,
  "93631": 4,
  "93633": -1,
  "93634": -2,
  "93635": -4,
  "93636": -2,
  "93637": -2,
  "93638": -2,
  "93639": -1,
  "93640": 3,
  "93641": -1,
  "93642": -2,
  "93643": -1,
  "93644": -2,
  "93645": 0,
  "93646": -1,
  "93647": -1,
  "93648": 3,
  "93649": -1,
  "93650": 3,
  "93651": -1,
  "93652": 3,
  "93653": -1,
  "93654": 4,
  "93656": 3,
  "93657": 3,
  "93660": 3,
  "93661": -5,
  "93662": 3,
  "93664": 7,
  "93665": -5,
  "93666": -1,
  "93667": -1,
  "93668": 3,
  "93669": -1,
  "93670": -1,
  "93673": -1,
  "93675": -1,
  "93701": 3,
  "93702": 3,
  "93703": 3,
  "93704": 3,
  "93705": 3,
  "93706": 3,
  "93707": 3,
  "93708": 3,
  "93709": 3,
  "93710": 3,
  "93711": 3,
  "93712": 3,
  "93714": 3,
  "93715": 3,
  "93716": 3,
  "93717": 3,
  "93718": 3,
  "93720": 3,
  "93721": 3,
  "93722": 3,
  "93723": 3,
  "93725": 3,
  "93726": 3,
  "93727": 3,
  "93728": 3,
  "93729": 3,
  "93730": 3,
  "93744": 3,
  "93745": 3,
  "93747": 3,
  "93755": 3,
  "93771": 3,
  "93772": 3,
  "93773": 3,
  "93774": 3,
  "93775": 3,
  "93776": 3,
  "93777": 3,
  "93778": 3,
  "93779": 3,
  "93790": 3,
  "93791": 3,
  "93792": 3,
  "93793": 3,
  "93794": 3,
  "93901": 5,
  "93902": 5,
  "93905": 5,
  "93906": 5,
  "93907": 4,
  "93908": 17,
  "93912": 4,
  "93915": 5,
  "93920": 9,
  "93921": 8,
  "93922": 8,
  "93923": 8,
  "93924": 8,
  "93925": 8,
  "93926": 5,
  "93927": 5,
  "93928": 6,
  "93930": 5,
  "93932": 6,
  "93933": 5,
  "93940": 8,
  "93942": 8,
  "93943": 6,
  "93944": 6,
  "93950": 8,
  "93953": 8,
  "93954": 5,
  "93955": 6,
  "93960": 5,
  "93962": 5,
  "94002": 24,
  "94005": 29,
  "94010": 32,
  "94011": 32,
  "94014": 29,
  "94015": 29,
  "94016": 29,
  "94017": 29,
  "94018": 24,
  "94019": 24,
  "94020": 28,
  "94021": 24,
  "94022": 30,
  "94023": 30,
  "94024": 37,
  "94025": 24,
  "94026": 24,
  "94027": 25,
  "94028": 25,
  "94030": 24,
  "94035": 28,
  "94037": 24,
  "94038": 24,
  "94039": 28,
  "94040": 28,
  "94041": 28,
  "94042": 28,
  "94043": 28,
  "94044": 24,
  "94060": 24,
  "94061": 24,
  "94062": 24,
  "94063": 24,
  "94064": 24,
  "94065": 24,
  "94066": 24,
  "94070": 24,
  "94074": 24,
  "94080": 29,
  "94083": 29,
  "94085": 28,
  "94086": 28,
  "94087": 28,
  "94088": 28,
  "94089": 25,
  "94101": 29,
  "94102": 29,
  "94103": 29,
  "94104": 29,
  "94105": 29,
  "94107": 29,
  "94108": 29,
  "94109": 29,
  "94110": 29,
  "94111": 29,
  "94112": 29,
  "94114": 29,
  "94115": 29,
  "94116": 29,
  "94117": 29,
  "94118": 29,
  "94119": 29,
  "94120": 29,
  "94121": 29,
  "94122": 29,
  "94123": 37,
  "94124": 28,
  "94125": 28,
  "94126": 29,
  "94127": 29,
  "94128": 24,
  "94129": 37,
  "94130": 29,
  "94131": 29,
  "94132": 29,
  "94133": 29,
  "94134": 29,
  "94140": 29,
  "94141": 29,
  "94142": 29,
  "94146": 29,
  "94147": 37,
  "94158": 29,
  "94159": 29,
  "94164": 29,
  "94172": 29,
  "94188": 28,
  "94203": 8,
  "94204": 8,
  "94205": 8,
  "94206": 8,
  "94207": 8,
  "94208": 8,
  "94209": 8,
  "94211": 8,
  "94229": 8,
  "94230": 8,
  "94232": 9,
  "94234": 8,
  "94235": 8,
  "94236": 8,
  "94237": 8,
  "94239": 9,
  "94240": 8,
  "94244": 8,
  "94245": 8,
  "94246": 8,
  "94247": 8,
  "94248": 8,
  "94249": 9,
  "94250": 8,
  "94252": 8,
  "94254": 8,
  "94256": 8,
  "94257": 8,
  "94258": 8,
  "94259": 9,
  "94261": 8,
  "94262": 8,
  "94263": 8,
  "94267": 8,
  "94268": 8,
  "94269": 9,
  "94271": 8,
  "94273": 8,
  "94274": 8,
  "94277": 8,
  "94278": 9,
  "94279": 8,
  "94280": 8,
  "94282": 8,
  "94283": 8,
  "94284": 9,
  "94285": 9,
  "94286": 9,
  "94287": 8,
  "94288": 8,
  "94289": 8,
  "94290": 9,
  "94291": 9,
  "94293": 9,
  "94294": 9,
  "94295": 8,
  "94296": 8,
  "94297": 9,
  "94298": 8,
  "94301": 25,
  "94302": 25,
  "94303": 24,
  "94304": 25,
  "94305": 24,
  "94306": 24,
  "94309": 24,
  "94401": 25,
  "94402": 24,
  "94403": 24,
  "94404": 24,
  "94501": 22,
  "94502": 23,
  "94503": 18,
  "94505": 17,
  "94506": 30,
  "94507": 28,
  "94508": 14,
  "94509": 18,
  "94510": 18,
  "94511": 7,
  "94512": 28,
  "94513": 25,
  "94514": 17,
  "94515": 10,
  "94516": 22,
  "94517": 20,
  "94518": 18,
  "94519": 17,
  "94520": 17,
  "94521": 18,
  "94522": 17,
  "94523": 20,
  "94524": 17,
  "94525": 17,
  "94526": 22,
  "94527": 17,
  "94528": 22,
  "94530": 29,
  "94531": 18,
  "94533": 18,
  "94534": 18,
  "94535": 18,
  "94536": 22,
  "94537": 22,
  "94538": 22,
  "94539": 28,
  "94540": 20,
  "94541": 20,
  "94542": 22,
  "94543": 20,
  "94544": 20,
  "94545": 20,
  "94546": 22,
  "94547": 18,
  "94548": 17,
  "94549": 22,
  "94550": 21,
  "94551": 21,
  "94552": 22,
  "94553": 17,
  "94555": 22,
  "94556": 20,
  "94557": 20,
  "94558": 12,
  "94559": 11,
  "94560": 22,
  "94561": 17,
  "94562": 12,
  "94563": 28,
  "94564": 17,
  "94565": 17,
  "94566": 22,
  "94567": 11,
  "94568": 22,
  "94569": 19,
  "94570": 18,
  "94571": 18,
  "94572": 17,
  "94573": 16,
  "94574": 16,
  "94575": 20,
  "94576": 16,
  "94577": 20,
  "94578": 19,
  "94579": 20,
  "94580": 20,
  "94581": 11,
  "94582": 22,
  "94583": 22,
  "94585": 18,
  "94586": 22,
  "94587": 22,
  "94588": 22,
  "94589": 18,
  "94590": 18,
  "94591": 18,
  "94592": 19,
  "94595": 20,
  "94596": 20,
  "94597": 20,
  "94598": 20,
  "94599": 12,
  "94601": 19,
  "94602": 22,
  "94603": 19,
  "94604": 26,
  "94605": 19,
  "94606": 19,
  "94607": 26,
  "94608": 26,
  "94609": 26,
  "94610": 22,
  "94611": 22,
  "94612": 26,
  "94613": 22,
  "94614": 19,
  "94615": 26,
  "94617": 19,
  "94618": 22,
  "94619": 22,
  "94620": 19,
  "94621": 19,
  "94623": 26,
  "94624": 19,
  "94661": 22,
  "94662": 26,
  "94701": 29,
  "94702": 26,
  "94703": 29,
  "94704": 20,
  "94705": 22,
  "94706": 29,
  "94707": 20,
  "94708": 20,
  "94709": 20,
  "94710": 26,
  "94712": 20,
  "94801": 13,
  "94802": 13,
  "94803": 18,
  "94804": 26,
  "94805": 26,
  "94806": 13,
  "94807": 26,
  "94808": 26,
  "94820": 18,
  "94850": 13,
  "94901": 16,
  "94903": 16,
  "94904": 16,
  "94912": 16,
  "94913": 16,
  "94914": 16,
  "94915": 16,
  "94920": 24,
  "94922": 12,
  "94923": 12,
  "94924": 16,
  "94925": 16,
  "94927": 10,
  "94928": 10,
  "94929": 12,
  "94930": 16,
  "94931": 9,
  "94933": 16,
  "94937": 16,
  "94938": 15,
  "94939": 16,
  "94940": 21,
  "94941": 16,
  "94942": 16,
  "94945": 16,
  "94946": 24,
  "94947": 16,
  "94948": 16,
  "94949": 16,
  "94950": 16,
  "94951": 12,
  "94952": 12,
  "94953": 9,
  "94954": 9,
  "94955": 9,
  "94956": 16,
  "94957": 16,
  "94960": 16,
  "94963": 16,
  "94964": 24,
  "94965": 29,
  "94966": 29,
  "94970": 24,
  "94971": 12,
  "94972": 21,
  "94973": 16,
  "94974": 16,
  "94975": 12,
  "94976": 16,
  "94977": 16,
  "94978": 16,
  "94979": 16,
  "94999": 12,
  "95001": 6,
  "95002": 26,
  "95003": 6,
  "95004": 6,
  "95005": 6,
  "95006": 6,
  "95007": 6,
  "95008": 28,
  "95009": 28,
  "95010": 6,
  "95011": 28,
  "95012": 3,
  "95013": 28,
  "95014": 29,
  "95015": 29,
  "95017": 6,
  "95018": 6,
  "95019": 3,
  "95020": 6,
  "95021": 6,
  "95023": 6,
  "95024": 6,
  "95026": 28,
  "95030": 28,
  "95031": 28,
  "95032": 30,
  "95033": 30,
  "95035": 28,
  "95036": 30,
  "95037": 28,
  "95038": 7,
  "95039": 3,
  "95041": 3,
  "95042": 29,
  "95043": 6,
  "95044": 28,
  "95045": 6,
  "95046": 7,
  "95050": 28,
  "95051": 28,
  "95052": 28,
  "95054": 28,
  "95055": 28,
  "95056": 28,
  "95060": 6,
  "95061": 7,
  "95062": 6,
  "95063": 6,
  "95064": 6,
  "95065": 7,
  "95066": 6,
  "95067": 7,
  "95070": 37,
  "95071": 37,
  "95073": 6,
  "95075": 6,
  "95076": 3,
  "95077": 4,
  "95101": 28,
  "95103": 28,
  "95106": 37,
  "95108": 37,
  "95109": 37,
  "95110": 28,
  "95111": 28,
  "95112": 28,
  "95113": 37,
  "95115": 28,
  "95116": 28,
  "95117": 28,
  "95118": 28,
  "95119": 28,
  "95120": 29,
  "95121": 28,
  "95122": 28,
  "95123": 28,
  "95124": 28,
  "95125": 28,
  "95126": 28,
  "95127": 28,
  "95128": 28,
  "95129": 29,
  "95130": 28,
  "95131": 28,
  "95132": 28,
  "95133": 28,
  "95134": 25,
  "95135": 28,
  "95136": 28,
  "95138": 28,
  "95139": 28,
  "95140": 28,
  "95141": 28,
  "95148": 28,
  "95150": 28,
  "95151": 28,
  "95152": 28,
  "95153": 28,
  "95154": 28,
  "95155": 28,
  "95156": 28,
  "95157": 28,
  "95158": 28,
  "95159": 28,
  "95160": 29,
  "95161": 28,
  "95164": 25,
  "95170": 29,
  "95172": 37,
  "95173": 37,
  "95201": 7,
  "95202": 7,
  "95203": 6,
  "95204": 7,
  "95205": 7,
  "95206": 7,
  "95207": 7,
  "95208": 7,
  "95209": 7,
  "95210": 7,
  "95212": 7,
  "95213": 7,
  "95215": 7,
  "95219": 7,
  "95220": 7,
  "95221": 2,
  "95222": 3,
  "95223": 2,
  "95224": 2,
  "95225": 2,
  "95226": -1,
  "95227": 18,
  "95228": 3,
  "95229": 4,
  "95230": 3,
  "95231": 7,
  "95232": -1,
  "95233": 4,
  "95234": 7,
  "95236": 7,
  "95237": 7,
  "95240": 7,
  "95241": 7,
  "95242": 7,
  "95245": 3,
  "95246": 3,
  "95247": 4,
  "95248": 3,
  "95249": 2,
  "95250": 3,
  "95251": 3,
  "95252": 3,
  "95253": 7,
  "95254": -1,
  "95255": -1,
  "95257": -1,
  "95258": 7,
  "95267": 7,
  "95269": 7,
  "95301": -5,
  "95303": 4,
  "95304": 7,
  "95305": 3,
  "95306": -1,
  "95307": 3,
  "95309": 3,
  "95310": 3,
  "95311": -1,
  "95312": -5,
  "95313": 4,
  "95314": 4,
  "95315": -4,
  "95316": 3,
  "95317": -5,
  "95318": -2,
  "95319": 3,
  "95320": 3,
  "95321": 4,
  "95322": -4,
  "95323": 3,
  "95324": 3,
  "95325": -2,
  "95326": 3,
  "95327": 3,
  "95328": 3,
  "95329": 4,
  "95330": 7,
  "95333": -1,
  "95334": -4,
  "95335": 3,
  "95336": 7,
  "95337": 7,
  "95338": -1,
  "95340": -5,
  "95341": -5,
  "95343": -5,
  "95344": -5,
  "95345": -1,
  "95346": 3,
  "95347": 3,
  "95348": -5,
  "95350": 3,
  "95351": 3,
  "95352": 3,
  "95353": 3,
  "95354": 3,
  "95355": 3,
  "95356": 3,
  "95357": 3,
  "95358": 3,
  "95360": -4,
  "95361": 3,
  "95363": 3,
  "95364": 4,
  "95365": -5,
  "95366": 3,
  "95367": 3,
  "95368": 3,
  "95369": -5,
  "95370": 3,
  "95372": 3,
  "95373": 3,
  "95374": -4,
  "95375": 3,
  "95376": 7,
  "95377": 7,
  "95378": 17,
  "95379": 3,
  "95380": 3,
  "95381": 3,
  "95382": 3,
  "95383": 4,
  "95385": 3,
  "95386": 3,
  "95387": 3,
  "95388": -5,
  "95389": 7,
  "95391": 17,
  "95401": 10,
  "95402": 10,
  "95403": 10,
  "95404": 12,
  "95405": 10,
  "95406": 10,
  "95407": 10,
  "95409": 10,
  "95410": 0,
  "95412": 10,
  "95415": 0,
  "95416": 13,
  "95417": -1,
  "95418": 0,
  "95419": 9,
  "95420": 0,
  "95421": 10,
  "95422": -4,
  "95423": -4,
  "95424": -4,
  "95425": -3,
  "95426": -4,
  "95427": 0,
  "95428": -1,
  "95429": 0,
  "95430": 12,
  "95431": 14,
  "95432": 11,
  "95433": 13,
  "95435": -4,
  "95436": 10,
  "95437": 0,
  "95439": 10,
  "95441": 12,
  "95442": 14,
  "95443": -4,
  "95444": 9,
  "95445": 0,
  "95446": 10,
  "95448": 12,
  "95449": -4,
  "95450": 12,
  "95451": -4,
  "95452": 12,
  "95453": -4,
  "95454": -1,
  "95456": 0,
  "95457": -4,
  "95458": -4,
  "95459": 0,
  "95460": 3,
  "95461": -4,
  "95462": 9,
  "95463": 0,
  "95464": -4,
  "95465": 12,
  "95466": 3,
  "95467": -4,
  "95468": 0,
  "95469": 0,
  "95470": 0,
  "95471": 9,
  "95472": 12,
  "95473": 12,
  "95476": 13,
  "95480": 21,
  "95481": 0,
  "95482": 0,
  "95485": -4,
  "95486": 9,
  "95487": 13,
  "95488": 10,
  "95490": 0,
  "95492": 10,
  "95493": -4,
  "95494": -3,
  "95497": 12,
  "95501": 2,
  "95502": 2,
  "95503": 2,
  "95511": 6,
  "95514": 2,
  "95518": 2,
  "95519": 2,
  "95521": 2,
  "95524": 2,
  "95525": 2,
  "95526": 6,
  "95527": 6,
  "95528": 2,
  "95531": -9,
  "95534": 2,
  "95536": 2,
  "95537": 2,
  "95538": -9,
  "95540": 2,
  "95542": 2,
  "95543": -9,
  "95545": 2,
  "95546": 2,
  "95547": 2,
  "95548": -9,
  "95549": 2,
  "95550": 13,
  "95551": 2,
  "95552": 6,
  "95553": 2,
  "95554": 2,
  "95555": -9,
  "95556": -9,
  "95558": 2,
  "95559": 2,
  "95560": 2,
  "95562": 2,
  "95563": 2,
  "95564": 2,
  "95565": 2,
  "95567": -9,
  "95568": -8,
  "95569": 2,
  "95570": 2,
  "95571": 2,
  "95573": 2,
  "95585": -1,
  "95587": -1,
  "95589": 2,
  "95595": 6,
  "95601": -1,
  "95602": 17,
  "95603": 9,
  "95604": 9,
  "95605": 8,
  "95606": 15,
  "95607": 15,
  "95608": 8,
  "95609": 8,
  "95610": 8,
  "95611": 8,
  "95612": 9,
  "95613": 8,
  "95614": 9,
  "95615": 9,
  "95616": 15,
  "95617": 15,
  "95618": 15,
  "95619": 5,
  "95620": 15,
  "95621": 8,
  "95623": 5,
  "95624": 10,
  "95625": 18,
  "95626": 8,
  "95627": 14,
  "95628": 9,
  "95629": -1,
  "95630": 9,
  "95631": 8,
  "95632": 9,
  "95633": 8,
  "95634": 8,
  "95635": 8,
  "95636": 5,
  "95637": -1,
  "95638": 9,
  "95639": 8,
  "95640": -1,
  "95641": 7,
  "95642": -1,
  "95644": -1,
  "95645": 15,
  "95646": -1,
  "95648": 8,
  "95650": 9,
  "95651": 8,
  "95652": 8,
  "95653": 14,
  "95654": -1,
  "95655": 8,
  "95656": -1,
  "95658": 17,
  "95659": 1,
  "95660": 8,
  "95661": 9,
  "95662": 8,
  "95663": 10,
  "95664": 9,
  "95665": -1,
  "95666": -1,
  "95667": 5,
  "95668": 1,
  "95669": -1,
  "95670": 8,
  "95672": 9,
  "95673": 8,
  "95674": 0,
  "95675": -1,
  "95676": 0,
  "95677": 8,
  "95678": 8,
  "95679": 15,
  "95680": 8,
  "95681": 1,
  "95682": -1,
  "95683": 9,
  "95684": 5,
  "95685": -1,
  "95686": 7,
  "95687": 18,
  "95688": 18,
  "95689": -1,
  "95690": 8,
  "95691": 8,
  "95692": 1,
  "95693": 10,
  "95694": 15,
  "95695": 15,
  "95696": 18,
  "95697": 15,
  "95698": 15,
  "95699": -1,
  "95701": 4,
  "95703": 10,
  "95709": 5,
  "95712": 4,
  "95713": 8,
  "95714": 5,
  "95715": 5,
  "95717": 4,
  "95720": 5,
  "95721": -1,
  "95722": 17,
  "95724": -5,
  "95726": 5,
  "95728": -5,
  "95735": 8,
  "95736": 8,
  "95741": 8,
  "95742": 8,
  "95746": 19,
  "95747": 9,
  "95757": 8,
  "95758": 8,
  "95759": 8,
  "95762": 17,
  "95763": 9,
  "95765": 9,
  "95776": 15,
  "95798": 8,
  "95799": 8,
  "95811": 8,
  "95812": 8,
  "95813": 8,
  "95814": 8,
  "95815": 8,
  "95816": 9,
  "95817": 8,
  "95818": 9,
  "95819": 9,
  "95820": 8,
  "95821": 8,
  "95822": 8,
  "95823": 8,
  "95824": 8,
  "95825": 8,
  "95826": 8,
  "95827": 8,
  "95828": 8,
  "95829": 8,
  "95830": 17,
  "95831": 9,
  "95832": 8,
  "95833": 8,
  "95834": 8,
  "95835": 9,
  "95836": 9,
  "95837": 26,
  "95838": 8,
  "95841": 8,
  "95842": 8,
  "95843": 8,
  "95851": 8,
  "95852": 8,
  "95853": 8,
  "95860": 8,
  "95864": 9,
  "95865": 8,
  "95866": 8,
  "95899": 8,
  "95901": 1,
  "95903": 1,
  "95910": -5,
  "95912": -2,
  "95913": -3,
  "95914": 1,
  "95915": -4,
  "95916": 1,
  "95917": 1,
  "95918": 1,
  "95919": 1,
  "95920": -1,
  "95922": 4,
  "95923": -4,
  "95924": 4,
  "95925": 1,
  "95926": 2,
  "95927": 2,
  "95928": 2,
  "95930": 1,
  "95932": -2,
  "95934": -4,
  "95935": 1,
  "95936": -5,
  "95937": -2,
  "95938": 10,
  "95939": -3,
  "95940": 1,
  "95941": 1,
  "95942": 10,
  "95943": -3,
  "95944": -5,
  "95945": 4,
  "95946": 3,
  "95947": -4,
  "95948": 1,
  "95949": 8,
  "95950": 0,
  "95951": -3,
  "95953": 0,
  "95954": 1,
  "95955": -2,
  "95956": -4,
  "95957": 0,
  "95958": 1,
  "95959": 5,
  "95960": 4,
  "95961": 0,
  "95962": 1,
  "95963": -3,
  "95965": 1,
  "95966": 1,
  "95967": 1,
  "95968": 1,
  "95969": 1,
  "95970": 0,
  "95971": -4,
  "95972": 1,
  "95973": 2,
  "95974": 1,
  "95975": 1,
  "95977": 1,
  "95978": 1,
  "95979": -2,
  "95980": 1,
  "95981": 1,
  "95982": 0,
  "95983": -4,
  "95984": -4,
  "95986": 3,
  "95987": -2,
  "95988": -3,
  "95991": 0,
  "95992": 0,
  "95993": 0,
  "96001": 3,
  "96002": 3,
  "96003": 3,
  "96006": 18,
  "96007": 3,
  "96008": 3,
  "96009": 18,
  "96010": 6,
  "96011": 3,
  "96013": 3,
  "96014": -3,
  "96015": 17,
  "96016": 3,
  "96017": 3,
  "96019": 3,
  "96020": -4,
  "96021": 22,
  "96022": 22,
  "96023": -3,
  "96024": 6,
  "96025": -3,
  "96027": -2,
  "96028": 3,
  "96029": -3,
  "96031": 6,
  "96032": -2,
  "96033": 6,
  "96034": -3,
  "96035": 22,
  "96037": -2,
  "96038": -2,
  "96039": -9,
  "96040": 3,
  "96041": 6,
  "96044": -3,
  "96046": 6,
  "96047": 6,
  "96048": 6,
  "96049": 3,
  "96050": -2,
  "96051": 3,
  "96052": 6,
  "96054": 18,
  "96055": 22,
  "96056": 18,
  "96057": -3,
  "96058": -3,
  "96059": 3,
  "96061": -2,
  "96062": 3,
  "96063": 22,
  "96064": -3,
  "96065": 3,
  "96067": -3,
  "96068": 18,
  "96069": 3,
  "96070": 3,
  "96071": 3,
  "96073": 3,
  "96074": -3,
  "96075": 21,
  "96076": 6,
  "96078": 22,
  "96079": 3,
  "96080": 22,
  "96084": 3,
  "96085": -2,
  "96086": -7,
  "96087": 3,
  "96088": 3,
  "96089": 3,
  "96090": 22,
  "96091": 6,
  "96092": 22,
  "96093": 6,
  "96094": -2,
  "96095": 6,
  "96096": 3,
  "96097": -2,
  "96099": 3,
  "96101": 17,
  "96103": -5,
  "96104": 18,
  "96105": 5,
  "96106": -5,
  "96107": -1,
  "96108": 20,
  "96109": 5,
  "96110": 18,
  "96111": 2,
  "96112": 18,
  "96113": -4,
  "96114": -9,
  "96115": 18,
  "96116": 18,
  "96117": -9,
  "96118": -5,
  "96119": -10,
  "96120": -1,
  "96121": -3,
  "96122": -5,
  "96123": -9,
  "96124": -5,
  "96125": -5,
  "96126": -5,
  "96127": -10,
  "96128": -9,
  "96129": -5,
  "96130": -10,
  "96132": -10,
  "96133": -1,
  "96134": 18,
  "96135": -5,
  "96136": -10,
  "96137": -4,
  "96140": 4,
  "96141": 6,
  "96142": 2,
  "96143": 2,
  "96145": 6,
  "96146": 6,
  "96148": 2,
  "96150": -1,
  "96151": -1,
  "96152": -1,
  "96154": -1,
  "96155": 2,
  "96156": -1,
  "96157": -1,
  "96158": -1,
  "96160": -5,
  "96161": -5,
  "96162": -5,
  "96701": 23,
  "96703": 13,
  "96704": 11,
  "96705": 14,
  "96706": 21,
  "96707": 21,
  "96708": 18,
  "96709": 21,
  "96710": 13,
  "96712": 21,
  "96713": 18,
  "96714": 16,
  "96715": 14,
  "96716": 14,
  "96717": 21,
  "96718": 10,
  "96719": 11,
  "96720": 10,
  "96721": 10,
  "96722": 16,
  "96725": 11,
  "96726": 11,
  "96727": 10,
  "96728": 13,
  "96729": 15,
  "96730": 23,
  "96731": 21,
  "96732": 15,
  "96733": 15,
  "96734": 23,
  "96737": 10,
  "96738": 11,
  "96739": 11,
  "96740": 11,
  "96741": 16,
  "96742": 15,
  "96743": 11,
  "96744": 23,
  "96745": 11,
  "96746": 14,
  "96747": 13,
  "96748": 15,
  "96749": 10,
  "96750": 11,
  "96751": 13,
  "96752": 14,
  "96753": 15,
  "96754": 14,
  "96755": 11,
  "96756": 16,
  "96757": 15,
  "96759": 20,
  "96760": 10,
  "96761": 18,
  "96762": 23,
  "96763": 15,
  "96764": 10,
  "96765": 16,
  "96766": 14,
  "96767": 18,
  "96768": 18,
  "96769": 24,
  "96770": 15,
  "96771": 10,
  "96772": 10,
  "96773": 11,
  "96774": 10,
  "96776": 10,
  "96777": 10,
  "96778": 10,
  "96779": 15,
  "96780": 11,
  "96781": 13,
  "96782": 23,
  "96783": 10,
  "96784": 19,
  "96785": 10,
  "96786": 21,
  "96788": 18,
  "96789": 23,
  "96790": 19,
  "96791": 21,
  "96792": 20,
  "96793": 15,
  "96795": 21,
  "96796": 24,
  "96797": 21,
  "96801": 23,
  "96802": 21,
  "96803": 21,
  "96804": 21,
  "96805": 21,
  "96806": 21,
  "96807": 21,
  "96808": 21,
  "96809": 21,
  "96810": 21,
  "96811": 23,
  "96812": 21,
  "96813": 21,
  "96814": 21,
  "96815": 21,
  "96816": 24,
  "96817": 23,
  "96818": 21,
  "96819": 23,
  "96820": 23,
  "96821": 31,
  "96822": 23,
  "96823": 21,
  "96824": 31,
  "96825": 23,
  "96826": 21,
  "96827": 21,
  "96828": 21,
  "96830": 21,
  "96836": 21,
  "96837": 21,
  "96838": 23,
  "96839": 23,
  "96850": 21,
  "96853": 21,
  "96854": 21,
  "96857": 21,
  "96858": 23,
  "96859": 23,
  "96860": 21,
  "96861": 23,
  "96863": 23,
  "96898": 21,
  "97001": -4,
  "97002": 6,
  "97004": 7,
  "97005": 12,
  "97006": 12,
  "97007": 12,
  "97008": 12,
  "97009": 7,
  "97010": 16,
  "97011": 6,
  "97013": 6,
  "97014": -5,
  "97015": 6,
  "97016": 6,
  "97017": 7,
  "97018": 6,
  "97019": 16,
  "97020": 6,
  "97021": -5,
  "97022": 7,
  "97023": 6,
  "97024": 16,
  "97026": 3,
  "97027": 6,
  "97028": -2,
  "97029": 13,
  "97030": 16,
  "97031": -4,
  "97032": 2,
  "97033": 13,
  "97034": 27,
  "97035": 17,
  "97036": 27,
  "97037": -4,
  "97038": 6,
  "97039": 13,
  "97040": -4,
  "97041": -4,
  "97042": 7,
  "97044": -4,
  "97045": 6,
  "97048": 6,
  "97049": -4,
  "97050": 13,
  "97051": 6,
  "97053": 6,
  "97054": 6,
  "97055": 6,
  "97056": 6,
  "97057": -4,
  "97058": -5,
  "97060": 16,
  "97062": 12,
  "97063": -4,
  "97064": 6,
  "97065": 13,
  "97067": -4,
  "97068": 8,
  "97070": 7,
  "97071": 2,
  "97075": 12,
  "97076": 12,
  "97080": 16,
  "97086": 6,
  "97089": 7,
  "97101": 0,
  "97102": 6,
  "97103": -3,
  "97106": 12,
  "97107": 3,
  "97108": 4,
  "97109": 12,
  "97110": 6,
  "97111": 0,
  "97112": 5,
  "97113": 12,
  "97114": 0,
  "97115": 0,
  "97116": 12,
  "97117": 12,
  "97118": 3,
  "97119": 12,
  "97121": -3,
  "97122": 3,
  "97123": 12,
  "97124": 12,
  "97125": 12,
  "97127": 0,
  "97128": 0,
  "97130": 4,
  "97131": 4,
  "97132": 12,
  "97133": 13,
  "97134": 15,
  "97135": 5,
  "97136": 4,
  "97137": 0,
  "97138": -3,
  "97140": 12,
  "97141": 3,
  "97143": 15,
  "97144": 6,
  "97145": 8,
  "97146": -3,
  "97147": 4,
  "97148": 9,
  "97149": 3,
  "97201": 27,
  "97202": 16,
  "97203": 16,
  "97204": 18,
  "97205": 17,
  "97206": 16,
  "97207": 17,
  "97208": 16,
  "97209": 17,
  "97210": 27,
  "97211": 16,
  "97212": 17,
  "97213": 16,
  "97214": 16,
  "97215": 16,
  "97216": 16,
  "97217": 16,
  "97218": 16,
  "97219": 17,
  "97220": 16,
  "97221": 18,
  "97222": 16,
  "97223": 12,
  "97224": 12,
  "97225": 12,
  "97227": 16,
  "97228": 17,
  "97229": 13,
  "97230": 16,
  "97231": 20,
  "97232": 17,
  "97233": 16,
  "97236": 16,
  "97238": 16,
  "97239": 27,
  "97240": 16,
  "97242": 16,
  "97258": 18,
  "97266": 16,
  "97267": 16,
  "97268": 16,
  "97269": 16,
  "97280": 17,
  "97281": 12,
  "97282": 16,
  "97283": 17,
  "97286": 16,
  "97290": 16,
  "97291": 27,
  "97292": 16,
  "97293": 16,
  "97294": 16,
  "97296": 13,
  "97298": 12,
  "97299": 17,
  "97301": 2,
  "97302": 3,
  "97303": 2,
  "97304": 3,
  "97305": 2,
  "97306": 3,
  "97307": 2,
  "97308": 2,
  "97309": 2,
  "97317": 2,
  "97321": 1,
  "97322": 1,
  "97324": 1,
  "97325": 2,
  "97326": 1,
  "97327": 1,
  "97329": 1,
  "97330": 1,
  "97331": 1,
  "97333": 1,
  "97335": 1,
  "97336": 1,
  "97338": 0,
  "97339": 1,
  "97341": -5,
  "97342": 1,
  "97343": -5,
  "97344": -1,
  "97345": 1,
  "97346": 1,
  "97347": 0,
  "97348": 1,
  "97350": 1,
  "97351": -1,
  "97352": 3,
  "97355": 1,
  "97357": -5,
  "97358": 3,
  "97360": 1,
  "97361": 0,
  "97362": 2,
  "97364": -5,
  "97365": -5,
  "97366": -5,
  "97367": -5,
  "97368": -6,
  "97369": -5,
  "97370": 1,
  "97371": 0,
  "97373": 2,
  "97374": 1,
  "97375": 3,
  "97376": -5,
  "97377": 9,
  "97378": 0,
  "97380": -5,
  "97381": 3,
  "97383": 3,
  "97384": 3,
  "97385": 3,
  "97386": 1,
  "97388": -5,
  "97389": 1,
  "97390": 3,
  "97391": -5,
  "97392": 3,
  "97394": -5,
  "97396": 0,
  "97401": 2,
  "97402": 2,
  "97403": 3,
  "97404": 2,
  "97405": 2,
  "97406": 3,
  "97407": -2,
  "97408": 2,
  "97409": 2,
  "97410": -7,
  "97411": -2,
  "97412": 1,
  "97413": 1,
  "97414": -2,
  "97415": -5,
  "97416": -5,
  "97417": -5,
  "97419": 10,
  "97420": -2,
  "97423": -2,
  "97424": 1,
  "97425": 3,
  "97426": 1,
  "97427": 0,
  "97429": -5,
  "97430": 1,
  "97431": 1,
  "97432": -5,
  "97434": 1,
  "97435": 2,
  "97436": -5,
  "97437": 3,
  "97438": 1,
  "97439": -5,
  "97440": 2,
  "97441": -2,
  "97442": -8,
  "97443": -5,
  "97444": -5,
  "97446": 2,
  "97447": -5,
  "97448": 2,
  "97449": -2,
  "97450": 0,
  "97451": 2,
  "97452": 1,
  "97453": 2,
  "97454": 1,
  "97455": 1,
  "97456": 1,
  "97457": -5,
  "97458": -2,
  "97459": -2,
  "97461": 10,
  "97462": -5,
  "97463": 0,
  "97464": -5,
  "97465": -6,
  "97466": -2,
  "97467": -2,
  "97469": -5,
  "97470": -5,
  "97471": -5,
  "97473": -2,
  "97476": -6,
  "97477": 1,
  "97478": 1,
  "97479": -5,
  "97480": 2,
  "97481": -5,
  "97482": 1,
  "97484": -1,
  "97486": -5,
  "97487": 2,
  "97488": 1,
  "97489": 1,
  "97490": 2,
  "97491": -5,
  "97492": 0,
  "97493": -2,
  "97494": -5,
  "97495": -5,
  "97496": -5,
  "97497": -8,
  "97498": -5,
  "97499": -5,
  "97501": -1,
  "97502": -1,
  "97503": -1,
  "97504": 0,
  "97520": 8,
  "97522": -1,
  "97523": -8,
  "97524": -1,
  "97525": -1,
  "97526": -7,
  "97527": -7,
  "97528": -7,
  "97530": 8,
  "97531": -8,
  "97532": -7,
  "97533": -7,
  "97534": -8,
  "97535": -1,
  "97536": -1,
  "97537": -7,
  "97538": -8,
  "97539": -1,
  "97540": 0,
  "97541": -1,
  "97543": -7,
  "97544": -7,
  "97601": -6,
  "97602": -6,
  "97603": -6,
  "97604": -6,
  "97620": -7,
  "97621": -6,
  "97622": -6,
  "97623": -6,
  "97624": -6,
  "97625": -6,
  "97626": -6,
  "97627": -6,
  "97630": -7,
  "97632": -6,
  "97633": -6,
  "97634": -6,
  "97635": -7,
  "97636": -7,
  "97637": -7,
  "97638": -7,
  "97639": -6,
  "97640": -7,
  "97641": -7,
  "97701": 3,
  "97702": 3,
  "97707": 3,
  "97708": 3,
  "97709": 3,
  "97710": -8,
  "97711": -4,
  "97712": 13,
  "97720": -18,
  "97721": 4,
  "97722": 4,
  "97730": 4,
  "97731": -7,
  "97732": -4,
  "97733": 2,
  "97734": -5,
  "97735": -8,
  "97736": 0,
  "97737": 2,
  "97738": -18,
  "97739": 2,
  "97741": -5,
  "97750": 13,
  "97751": 13,
  "97752": 24,
  "97753": 3,
  "97754": 13,
  "97756": 3,
  "97758": 12,
  "97759": -5,
  "97760": -5,
  "97761": -4,
  "97801": -1,
  "97810": -2,
  "97812": 14,
  "97813": -2,
  "97814": -13,
  "97817": -18,
  "97818": 21,
  "97819": -13,
  "97820": -17,
  "97823": 21,
  "97824": 1,
  "97825": -17,
  "97826": -2,
  "97827": -7,
  "97828": -6,
  "97830": 21,
  "97833": -12,
  "97834": -13,
  "97835": -1,
  "97836": 21,
  "97837": -13,
  "97838": -1,
  "97839": 21,
  "97840": -12,
  "97841": -7,
  "97842": 1,
  "97843": 21,
  "97844": 6,
  "97845": -17,
  "97846": -6,
  "97848": -17,
  "97850": -6,
  "97856": -17,
  "97857": -7,
  "97859": -2,
  "97861": 14,
  "97862": -5,
  "97864": -17,
  "97865": -17,
  "97867": -7,
  "97868": -2,
  "97869": -18,
  "97870": -13,
  "97873": -18,
  "97874": -17,
  "97875": -2,
  "97876": 1,
  "97877": -12,
  "97880": -2,
  "97882": 6,
  "97883": -7,
  "97884": -13,
  "97885": -7,
  "97886": -2,
  "97901": -4,
  "97902": -4,
  "97903": -13,
  "97904": -18,
  "97905": -13,
  "97906": -4,
  "97907": -7,
  "97908": -13,
  "97909": -13,
  "97910": -4,
  "97911": -4,
  "97913": -12,
  "97914": -12,
  "97917": -4,
  "97918": -12,
  "97920": 7,
  "98001": 7,
  "98002": 8,
  "98003": 7,
  "98004": 18,
  "98005": 18,
  "98006": 18,
  "98007": 16,
  "98008": 16,
  "98009": 18,
  "98010": 16,
  "98011": 16,
  "98012": 6,
  "98013": 26,
  "98014": 16,
  "98015": 18,
  "98019": 16,
  "98020": 8,
  "98021": 6,
  "98022": 7,
  "98023": 7,
  "98024": 16,
  "98025": 16,
  "98026": 6,
  "98027": 18,
  "98028": 18,
  "98029": 18,
  "98030": 16,
  "98031": 16,
  "98032": 15,
  "98033": 18,
  "98034": 16,
  "98035": 16,
  "98036": 5,
  "98037": 5,
  "98038": 16,
  "98039": 27,
  "98040": 27,
  "98041": 16,
  "98042": 16,
  "98043": 5,
  "98045": 16,
  "98046": 5,
  "98047": 7,
  "98050": 16,
  "98051": 16,
  "98052": 16,
  "98053": 18,
  "98054": 7,
  "98055": 15,
  "98056": 16,
  "98057": 15,
  "98058": 16,
  "98059": 16,
  "98061": 12,
  "98062": 16,
  "98063": 7,
  "98064": 15,
  "98065": 16,
  "98068": 1,
  "98070": 26,
  "98071": 8,
  "98072": 8,
  "98073": 16,
  "98074": 18,
  "98075": 18,
  "98077": 8,
  "98082": 6,
  "98083": 18,
  "98087": 5,
  "98089": 15,
  "98092": 8,
  "98093": 7,
  "98101": 18,
  "98102": 18,
  "98103": 18,
  "98104": 27,
  "98105": 20,
  "98106": 15,
  "98107": 18,
  "98108": 15,
  "98109": 18,
  "98110": 12,
  "98111": 18,
  "98112": 27,
  "98113": 18,
  "98114": 16,
  "98115": 18,
  "98116": 18,
  "98117": 18,
  "98118": 16,
  "98119": 20,
  "98121": 18,
  "98122": 18,
  "98124": 16,
  "98125": 16,
  "98126": 16,
  "98127": 27,
  "98131": 15,
  "98132": 15,
  "98133": 16,
  "98134": 16,
  "98136": 18,
  "98138": 15,
  "98139": 6,
  "98141": 18,
  "98144": 16,
  "98145": 20,
  "98146": 16,
  "98148": 15,
  "98154": 18,
  "98155": 16,
  "98158": 15,
  "98160": 4,
  "98161": 18,
  "98164": 18,
  "98165": 16,
  "98166": 16,
  "98168": 15,
  "98171": 27,
  "98174": 27,
  "98175": 16,
  "98177": 4,
  "98178": 15,
  "98188": 15,
  "98194": 27,
  "98198": 15,
  "98199": 6,
  "98201": 5,
  "98203": 5,
  "98204": 5,
  "98205": 5,
  "98206": 5,
  "98208": 5,
  "98213": 5,
  "98220": 12,
  "98221": -7,
  "98222": 4,
  "98223": 5,
  "98224": 5,
  "98225": 12,
  "98226": 12,
  "98227": 12,
  "98228": 12,
  "98229": 12,
  "98230": 12,
  "98231": 12,
  "98232": 8,
  "98233": 8,
  "98235": 7,
  "98236": 6,
  "98237": 8,
  "98238": 8,
  "98239": -4,
  "98240": 12,
  "98241": 5,
  "98243": 4,
  "98244": 12,
  "98245": -7,
  "98247": 12,
  "98248": 12,
  "98249": -4,
  "98250": -4,
  "98251": 5,
  "98252": 5,
  "98253": -3,
  "98255": 8,
  "98256": 5,
  "98257": 8,
  "98258": 5,
  "98259": -4,
  "98260": -3,
  "98261": -7,
  "98262": 12,
  "98263": 8,
  "98264": 12,
  "98266": 12,
  "98267": 8,
  "98270": 5,
  "98271": 5,
  "98272": 5,
  "98273": 8,
  "98274": 8,
  "98275": 7,
  "98276": 12,
  "98277": -4,
  "98279": -4,
  "98280": 4,
  "98281": -7,
  "98282": -3,
  "98283": 8,
  "98284": 8,
  "98286": 4,
  "98287": -4,
  "98288": 15,
  "98290": 6,
  "98291": 6,
  "98292": -4,
  "98293": 5,
  "98294": 5,
  "98295": 12,
  "98296": 7,
  "98297": -7,
  "98303": 7,
  "98304": -3,
  "98305": -5,
  "98310": 1,
  "98311": 1,
  "98312": 1,
  "98315": 12,
  "98320": 1,
  "98321": 7,
  "98322": 1,
  "98323": 7,
  "98324": -7,
  "98325": -4,
  "98326": -5,
  "98327": 16,
  "98328": 7,
  "98329": 1,
  "98330": -3,
  "98331": -5,
  "98332": 7,
  "98333": 17,
  "98335": 8,
  "98336": -3,
  "98337": 1,
  "98338": 7,
  "98339": -4,
  "98340": -4,
  "98342": 2,
  "98343": -7,
  "98344": 7,
  "98345": 12,
  "98346": 2,
  "98348": 7,
  "98349": -12,
  "98350": -5,
  "98351": -12,
  "98353": 2,
  "98354": 7,
  "98355": -3,
  "98356": -3,
  "98357": -5,
  "98358": 5,
  "98359": 1,
  "98360": 7,
  "98361": -4,
  "98362": -7,
  "98363": -7,
  "98364": 12,
  "98365": -3,
  "98366": 1,
  "98367": 1,
  "98368": -4,
  "98370": 2,
  "98371": 7,
  "98372": 7,
  "98373": 7,
  "98374": 7,
  "98375": 7,
  "98376": -7,
  "98377": -3,
  "98378": 1,
  "98380": 1,
  "98381": -5,
  "98382": -7,
  "98383": 2,
  "98384": 2,
  "98385": 7,
  "98386": 2,
  "98387": 7,
  "98388": 7,
  "98390": 7,
  "98391": 7,
  "98392": 1,
  "98393": 1,
  "98394": -12,
  "98395": 1,
  "98396": 7,
  "98397": -3,
  "98398": -3,
  "98401": 7,
  "98402": 7,
  "98403": 15,
  "98404": 6,
  "98405": 6,
  "98406": 7,
  "98407": 7,
  "98408": 6,
  "98409": 6,
  "98411": 6,
  "98412": 7,
  "98413": 6,
  "98415": 7,
  "98417": 6,
  "98418": 6,
  "98419": 6,
  "98421": 6,
  "98422": 7,
  "98424": 7,
  "98433": 6,
  "98438": 7,
  "98439": 6,
  "98442": 7,
  "98443": 7,
  "98444": 7,
  "98445": 7,
  "98446": 7,
  "98448": 7,
  "98464": 7,
  "98465": 7,
  "98466": 7,
  "98467": 7,
  "98490": 7,
  "98492": 6,
  "98496": 7,
  "98497": 7,
  "98498": 7,
  "98499": 7,
  "98501": 9,
  "98502": 16,
  "98503": 7,
  "98506": 7,
  "98507": 9,
  "98508": 9,
  "98509": 7,
  "98511": 9,
  "98512": 7,
  "98513": 7,
  "98516": 9,
  "98520": 1,
  "98522": -11,
  "98524": -12,
  "98526": 1,
  "98527": -11,
  "98528": -13,
  "98530": 7,
  "98531": -3,
  "98532": -3,
  "98533": -3,
  "98535": 1,
  "98536": 1,
  "98537": 1,
  "98538": -3,
  "98539": -11,
  "98540": 7,
  "98541": 2,
  "98542": -3,
  "98544": -3,
  "98546": -4,
  "98547": -11,
  "98548": -13,
  "98550": 1,
  "98552": 2,
  "98554": -11,
  "98555": -13,
  "98556": 7,
  "98557": -12,
  "98558": 7,
  "98559": 2,
  "98560": -12,
  "98561": -11,
  "98562": 2,
  "98563": 2,
  "98564": -3,
  "98565": -3,
  "98566": 1,
  "98568": 7,
  "98569": 2,
  "98570": -3,
  "98571": 1,
  "98572": -11,
  "98575": 2,
  "98576": 7,
  "98577": -11,
  "98579": 7,
  "98580": 7,
  "98581": 7,
  "98582": -3,
  "98583": 2,
  "98584": -12,
  "98585": -3,
  "98586": -11,
  "98587": 1,
  "98588": -13,
  "98589": 7,
  "98590": -10,
  "98591": -3,
  "98592": -4,
  "98593": 8,
  "98595": 2,
  "98596": -3,
  "98597": 7,
  "98601": 5,
  "98602": -9,
  "98603": 8,
  "98604": 5,
  "98605": -9,
  "98606": 14,
  "98607": 5,
  "98609": 8,
  "98610": 5,
  "98611": 7,
  "98612": 8,
  "98613": -9,
  "98614": -10,
  "98616": 7,
  "98617": -9,
  "98619": -9,
  "98620": -9,
  "98621": -10,
  "98622": 5,
  "98623": -8,
  "98624": -10,
  "98625": 8,
  "98626": 7,
  "98628": -9,
  "98629": 5,
  "98631": -10,
  "98632": 7,
  "98635": -9,
  "98637": -10,
  "98638": -10,
  "98639": 5,
  "98640": -1,
  "98641": -1,
  "98642": 7,
  "98643": -10,
  "98644": -10,
  "98645": 8,
  "98647": -11,
  "98648": 5,
  "98649": 8,
  "98650": -8,
  "98651": -8,
  "98660": 5,
  "98661": 5,
  "98662": 5,
  "98663": 5,
  "98664": 5,
  "98665": 5,
  "98666": 5,
  "98668": 5,
  "98670": -9,
  "98671": 5,
  "98672": -8,
  "98673": -10,
  "98674": 8,
  "98675": 5,
  "98682": 5,
  "98683": 5,
  "98684": 5,
  "98685": 5,
  "98686": 5,
  "98687": 5,
  "98801": 6,
  "98802": 6,
  "98807": 6,
  "98811": 5,
  "98812": -12,
  "98813": -5,
  "98814": -11,
  "98815": 7,
  "98816": 4,
  "98817": -5,
  "98819": -11,
  "98821": 5,
  "98822": 5,
  "98823": 5,
  "98824": 5,
  "98826": 14,
  "98827": -12,
  "98828": 5,
  "98829": -12,
  "98830": -5,
  "98831": -3,
  "98832": 6,
  "98833": -11,
  "98834": -4,
  "98836": 5,
  "98837": 6,
  "98840": -12,
  "98841": -12,
  "98843": -5,
  "98844": -12,
  "98845": -5,
  "98846": -12,
  "98847": 14,
  "98848": 5,
  "98849": -12,
  "98850": -5,
  "98851": 5,
  "98852": -11,
  "98853": 6,
  "98855": -12,
  "98856": -11,
  "98857": -8,
  "98858": -5,
  "98859": -12,
  "98860": 6,
  "98862": -11,
  "98901": -7,
  "98902": -7,
  "98903": -7,
  "98904": -7,
  "98907": -7,
  "98908": -6,
  "98909": -7,
  "98920": -7,
  "98921": -7,
  "98922": 1,
  "98923": -7,
  "98925": 0,
  "98926": -1,
  "98929": -7,
  "98930": 7,
  "98932": -7,
  "98933": -7,
  "98934": -1,
  "98935": 7,
  "98936": -7,
  "98937": -7,
  "98938": -7,
  "98939": -7,
  "98940": -1,
  "98941": -1,
  "98942": -6,
  "98943": -1,
  "98944": -7,
  "98946": -1,
  "98947": -7,
  "98948": -7,
  "98950": 14,
  "98951": -7,
  "98952": -7,
  "98953": -7,
  "99001": -1,
  "99003": 1,
  "99004": 0,
  "99005": 8,
  "99006": 0,
  "99008": -1,
  "99009": 0,
  "99011": -1,
  "99012": 0,
  "99013": 0,
  "99014": -1,
  "99016": 0,
  "99017": -7,
  "99018": -6,
  "99019": 8,
  "99020": -1,
  "99021": 0,
  "99022": -1,
  "99023": 8,
  "99025": 0,
  "99026": 8,
  "99027": 0,
  "99029": 0,
  "99030": 0,
  "99031": 0,
  "99032": -2,
  "99033": -7,
  "99034": 0,
  "99036": 8,
  "99037": 8,
  "99039": -6,
  "99040": -2,
  "99101": -10,
  "99102": -6,
  "99103": -2,
  "99104": -7,
  "99105": -9,
  "99107": -10,
  "99109": -10,
  "99110": 0,
  "99111": -6,
  "99113": 0,
  "99114": -10,
  "99115": -5,
  "99116": -1,
  "99117": -2,
  "99118": -12,
  "99119": -13,
  "99121": -12,
  "99122": -1,
  "99123": -2,
  "99124": -2,
  "99125": -7,
  "99126": -10,
  "99128": -7,
  "99129": -1,
  "99130": -6,
  "99131": -10,
  "99133": -2,
  "99134": -2,
  "99135": 5,
  "99136": -7,
  "99137": -10,
  "99138": -12,
  "99139": -13,
  "99140": -12,
  "99141": -10,
  "99143": -7,
  "99144": -2,
  "99146": -12,
  "99147": -2,
  "99148": -10,
  "99149": -7,
  "99150": -12,
  "99151": -10,
  "99152": -13,
  "99153": -13,
  "99154": -2,
  "99155": -12,
  "99156": -13,
  "99157": -10,
  "99158": -6,
  "99159": -2,
  "99160": -12,
  "99161": -6,
  "99163": -4,
  "99166": -12,
  "99167": -10,
  "99169": -9,
  "99170": -6,
  "99171": -6,
  "99173": -10,
  "99174": -6,
  "99176": -7,
  "99179": 0,
  "99180": -13,
  "99181": -10,
  "99185": -1,
  "99201": -1,
  "99202": 0,
  "99203": 0,
  "99204": 0,
  "99205": 0,
  "99206": 0,
  "99207": -1,
  "99208": 0,
  "99209": 0,
  "99210": 0,
  "99211": 0,
  "99212": 0,
  "99213": 0,
  "99214": 0,
  "99215": 0,
  "99216": 0,
  "99217": -1,
  "99218": 1,
  "99219": 0,
  "99220": 0,
  "99223": 8,
  "99224": -1,
  "99228": 8,
  "99301": -5,
  "99302": -5,
  "99320": 7,
  "99321": 7,
  "99322": -9,
  "99323": 7,
  "99324": -5,
  "99326": -5,
  "99328": 17,
  "99329": -5,
  "99330": -5,
  "99333": -9,
  "99335": -9,
  "99336": 7,
  "99337": 7,
  "99338": 7,
  "99341": -9,
  "99343": -4,
  "99344": -8,
  "99345": 7,
  "99346": 7,
  "99347": 17,
  "99348": 17,
  "99349": -7,
  "99350": 7,
  "99352": 15,
  "99353": 15,
  "99354": 15,
  "99356": -9,
  "99357": 5,
  "99359": 16,
  "99360": -5,
  "99361": 17,
  "99362": -5,
  "99363": -5,
  "99371": -9,
  "99401": -1,
  "99402": 0,
  "99403": 0,
  "99501": 22,
  "99502": 22,
  "99503": 22,
  "99504": 22,
  "99505": 22,
  "99506": 22,
  "99507": 22,
  "99508": 22,
  "99509": 22,
  "99510": 22,
  "99511": 23,
  "99513": 22,
  "99514": 22,
  "99515": 23,
  "99516": 30,
  "99517": 22,
  "99518": 22,
  "99519": 22,
  "99520": 22,
  "99521": 22,
  "99522": 22,
  "99523": 22,
  "99524": 22,
  "99529": 22,
  "99530": 22,
  "99540": 23,
  "99545": -7,
  "99546": 20,
  "99547": 20,
  "99548": -7,
  "99549": -7,
  "99550": 18,
  "99551": -7,
  "99552": -7,
  "99553": 20,
  "99554": 25,
  "99555": -7,
  "99556": 11,
  "99557": -7,
  "99558": -7,
  "99559": -7,
  "99561": 2,
  "99563": -7,
  "99564": -7,
  "99565": -7,
  "99566": 31,
  "99567": 23,
  "99568": 11,
  "99569": -7,
  "99571": -7,
  "99572": 19,
  "99573": 31,
  "99574": 21,
  "99575": -7,
  "99576": -7,
  "99577": 23,
  "99578": -7,
  "99579": -7,
  "99580": -7,
  "99581": 25,
  "99583": 1,
  "99585": -7,
  "99586": 22,
  "99587": 30,
  "99588": 31,
  "99589": -7,
  "99590": -7,
  "99591": 20,
  "99599": 22,
  "99602": -7,
  "99603": 11,
  "99604": -7,
  "99605": 22,
  "99606": -7,
  "99607": -7,
  "99608": 27,
  "99609": -7,
  "99610": 11,
  "99611": 11,
  "99612": -7,
  "99613": -7,
  "99614": -7,
  "99615": 20,
  "99619": 20,
  "99620": 25,
  "99621": -7,
  "99622": -7,
  "99624": 18,
  "99625": -6,
  "99626": -7,
  "99627": 2,
  "99628": -7,
  "99629": 19,
  "99630": -7,
  "99631": 22,
  "99632": -7,
  "99633": -7,
  "99634": -7,
  "99635": 11,
  "99636": -7,
  "99637": -7,
  "99638": 20,
  "99639": 11,
  "99640": -7,
  "99641": -7,
  "99643": 18,
  "99644": 18,
  "99645": 19,
  "99647": -7,
  "99648": -7,
  "99649": -7,
  "99650": -7,
  "99651": -7,
  "99652": 19,
  "99653": 4,
  "99654": 19,
  "99655": -7,
  "99656": -7,
  "99657": -7,
  "99658": -7,
  "99659": 25,
  "99660": 20,
  "99661": -7,
  "99662": -7,
  "99663": 11,
  "99664": 11,
  "99665": -7,
  "99666": 25,
  "99667": 28,
  "99668": -7,
  "99669": 11,
  "99670": -7,
  "99671": 25,
  "99672": 11,
  "99674": 19,
  "99675": 2,
  "99676": 19,
  "99677": 31,
  "99678": -7,
  "99679": -7,
  "99680": -7,
  "99681": -7,
  "99682": 21,
  "99683": 30,
  "99684": 25,
  "99685": 21,
  "99686": 31,
  "99687": 19,
  "99688": 30,
  "99689": 15,
  "99690": -7,
  "99691": 2,
  "99692": 28,
  "99693": 21,
  "99694": 19,
  "99695": 22,
  "99697": 18,
  "99701": 28,
  "99702": 28,
  "99703": 28,
  "99704": 23,
  "99705": 28,
  "99706": 28,
  "99707": 28,
  "99708": 28,
  "99709": 28,
  "99710": 28,
  "99711": 28,
  "99712": 28,
  "99714": 28,
  "99716": 28,
  "99720": 2,
  "99721": 2,
  "99722": 28,
  "99723": 52,
  "99724": 28,
  "99725": 28,
  "99726": 2,
  "99727": 52,
  "99729": 23,
  "99730": 28,
  "99731": 22,
  "99732": 22,
  "99733": 28,
  "99734": 52,
  "99736": 51,
  "99737": 22,
  "99738": 22,
  "99739": 25,
  "99740": 28,
  "99741": 1,
  "99742": 25,
  "99743": 2,
  "99744": 23,
  "99745": 1,
  "99746": 2,
  "99747": 28,
  "99748": 25,
  "99749": 52,
  "99750": 52,
  "99751": 52,
  "99752": 52,
  "99753": 25,
  "99754": 51,
  "99755": 2,
  "99756": 2,
  "99757": 2,
  "99758": 28,
  "99759": 52,
  "99760": 23,
  "99761": 52,
  "99762": 25,
  "99763": 52,
  "99764": 22,
  "99765": 25,
  "99766": 52,
  "99767": 2,
  "99768": 2,
  "99769": 25,
  "99770": 52,
  "99771": 25,
  "99772": 25,
  "99773": 52,
  "99774": 28,
  "99775": 28,
  "99776": 21,
  "99777": 2,
  "99778": 25,
  "99780": 22,
  "99781": 28,
  "99782": 52,
  "99783": 25,
  "99784": 25,
  "99785": 25,
  "99786": 52,
  "99788": 28,
  "99789": 52,
  "99790": 28,
  "99791": 52,
  "99801": 26,
  "99802": 26,
  "99803": 26,
  "99811": 26,
  "99820": 36,
  "99821": 26,
  "99824": 26,
  "99825": 17,
  "99826": 17,
  "99827": 15,
  "99829": 17,
  "99830": 36,
  "99832": 17,
  "99833": 38,
  "99835": 45,
  "99836": 38,
  "99840": 15,
  "99841": 17,
  "99850": 26,
  "99901": 16,
  "99903": 16,
  "99918": 16,
  "99919": 16,
  "99921": 16,
  "99922": 16,
  "99923": 15,
  "99925": 15,
  "99926": 16,
  "99927": 36,
  "99928": 16,
  "99929": 16,
  "99950": 16,
  "01001": 5,
  "01002": 11,
  "01003": 11,
  "01004": 11,
  "01005": 9,
  "01007": 2,
  "01008": 6,
  "01009": 5,
  "01010": 5,
  "01011": -1,
  "01012": 3,
  "01013": 5,
  "01014": 5,
  "01020": 5,
  "01021": 5,
  "01022": 7,
  "01026": 1,
  "01027": 3,
  "01028": 7,
  "01029": 1,
  "01030": 0,
  "01031": 10,
  "01032": 3,
  "01033": 3,
  "01034": 8,
  "01035": 5,
  "01036": 7,
  "01037": 10,
  "01038": 12,
  "01039": 3,
  "01040": 7,
  "01041": 7,
  "01050": 3,
  "01053": 3,
  "01054": 18,
  "01056": 7,
  "01057": 7,
  "01059": 12,
  "01060": 3,
  "01061": 3,
  "01062": 3,
  "01066": 3,
  "01068": 10,
  "01069": 7,
  "01070": 0,
  "01071": 8,
  "01072": 9,
  "01073": 4,
  "01074": 10,
  "01075": 2,
  "01077": 8,
  "01079": 7,
  "01080": 7,
  "01081": 7,
  "01082": 7,
  "01083": 7,
  "01084": 3,
  "01085": 8,
  "01086": 8,
  "01088": 3,
  "01089": 7,
  "01090": 7,
  "01092": 7,
  "01093": 9,
  "01094": 10,
  "01095": 8,
  "01096": 3,
  "01097": 8,
  "01098": 3,
  "01101": 7,
  "01102": 7,
  "01103": 7,
  "01104": 7,
  "01105": 7,
  "01106": 16,
  "01107": 7,
  "01108": 7,
  "01109": 7,
  "01115": 7,
  "01116": 7,
  "01118": 7,
  "01119": 7,
  "01128": 7,
  "01129": 7,
  "01138": 7,
  "01139": 7,
  "01144": 7,
  "01151": 7,
  "01152": 7,
  "01201": 0,
  "01202": 0,
  "01203": 0,
  "01220": 0,
  "01222": 0,
  "01223": 0,
  "01224": 0,
  "01225": 0,
  "01226": 0,
  "01227": 0,
  "01229": 0,
  "01230": 0,
  "01235": 0,
  "01236": 0,
  "01237": 0,
  "01238": 0,
  "01240": 0,
  "01242": 0,
  "01243": 0,
  "01244": 1,
  "01245": 8,
  "01247": -1,
  "01252": 0,
  "01253": 1,
  "01254": 2,
  "01255": 1,
  "01256": 0,
  "01257": 0,
  "01258": 8,
  "01259": 0,
  "01260": 8,
  "01262": 8,
  "01264": 8,
  "01266": 2,
  "01267": 0,
  "01270": 0,
  "01301": 9,
  "01302": 9,
  "01330": 9,
  "01331": 8,
  "01337": 9,
  "01338": 9,
  "01339": 8,
  "01340": 9,
  "01341": 11,
  "01342": 9,
  "01343": 0,
  "01344": 9,
  "01346": 9,
  "01347": 9,
  "01349": 9,
  "01350": 8,
  "01351": 9,
  "01354": 9,
  "01355": 9,
  "01360": 9,
  "01364": 8,
  "01366": 10,
  "01367": 8,
  "01368": 9,
  "01370": 9,
  "01373": 9,
  "01375": 3,
  "01376": 9,
  "01378": 9,
  "01379": 9,
  "01380": 9,
  "01420": 10,
  "01430": 10,
  "01431": 10,
  "01432": 17,
  "01434": 17,
  "01436": 10,
  "01438": 9,
  "01440": 10,
  "01450": 28,
  "01451": 19,
  "01452": 10,
  "01453": 10,
  "01460": 17,
  "01462": 18,
  "01463": 7,
  "01464": 10,
  "01467": 21,
  "01468": 10,
  "01469": 18,
  "01472": 10,
  "01473": 10,
  "01474": 18,
  "01475": 10,
  "01477": 10,
  "01501": 10,
  "01503": 18,
  "01504": 7,
  "01505": 10,
  "01506": 10,
  "01507": 10,
  "01508": 10,
  "01509": 10,
  "01510": 10,
  "01515": 10,
  "01516": 10,
  "01517": 10,
  "01518": 10,
  "01519": 10,
  "01520": 10,
  "01521": 7,
  "01522": 10,
  "01523": 10,
  "01524": 10,
  "01525": 10,
  "01526": 10,
  "01527": 10,
  "01529": 7,
  "01531": 10,
  "01532": 11,
  "01534": 10,
  "01535": 10,
  "01536": 10,
  "01537": 10,
  "01538": 7,
  "01540": 10,
  "01541": 10,
  "01542": 10,
  "01543": 10,
  "01545": 10,
  "01550": 10,
  "01560": 10,
  "01561": 10,
  "01562": 10,
  "01564": 10,
  "01566": 10,
  "01568": 18,
  "01569": 7,
  "01570": 10,
  "01571": 10,
  "01581": 18,
  "01583": 10,
  "01585": 10,
  "01586": 10,
  "01588": 10,
  "01590": 10,
  "01601": 10,
  "01602": 10,
  "01603": 10,
  "01604": 10,
  "01605": 10,
  "01606": 10,
  "01607": 10,
  "01608": 10,
  "01609": 10,
  "01610": 10,
  "01611": 10,
  "01612": 10,
  "01613": 10,
  "01614": 10,
  "01615": 10,
  "01655": 10,
  "01701": 17,
  "01702": 17,
  "01703": 17,
  "01704": 17,
  "01705": 17,
  "01718": 17,
  "01719": 19,
  "01720": 20,
  "01721": 19,
  "01730": 20,
  "01731": 20,
  "01740": 13,
  "01741": 28,
  "01742": 20,
  "01745": 17,
  "01746": 20,
  "01747": 7,
  "01748": 21,
  "01749": 10,
  "01752": 10,
  "01754": 17,
  "01756": 8,
  "01757": 18,
  "01760": 19,
  "01770": 22,
  "01772": 21,
  "01773": 22,
  "01775": 19,
  "01776": 20,
  "01778": 20,
  "01784": 21,
  "01801": 18,
  "01803": 17,
  "01810": 22,
  "01821": 17,
  "01822": 17,
  "01824": 17,
  "01826": 17,
  "01827": 18,
  "01830": 12,
  "01831": 12,
  "01832": 12,
  "01833": 12,
  "01834": 12,
  "01835": 12,
  "01840": 12,
  "01841": 12,
  "01842": 12,
  "01843": 12,
  "01844": 12,
  "01845": 14,
  "01850": 17,
  "01851": 17,
  "01852": 17,
  "01853": 17,
  "01854": 17,
  "01860": 12,
  "01862": 17,
  "01863": 17,
  "01864": 12,
  "01865": 17,
  "01866": 17,
  "01867": 17,
  "01876": 17,
  "01879": 17,
  "01880": 12,
  "01885": 14,
  "01886": 19,
  "01887": 17,
  "01888": 18,
  "01890": 20,
  "01901": 29,
  "01902": 29,
  "01903": 29,
  "01904": 12,
  "01905": 28,
  "01906": 29,
  "01907": 12,
  "01908": 31,
  "01913": 12,
  "01915": 12,
  "01921": 22,
  "01922": 14,
  "01923": 12,
  "01929": 12,
  "01930": 12,
  "01931": 12,
  "01936": 15,
  "01937": 14,
  "01938": 12,
  "01940": 14,
  "01944": 23,
  "01945": 16,
  "01949": 14,
  "01950": 12,
  "01951": 13,
  "01952": 8,
  "01960": 12,
  "01961": 12,
  "01965": 12,
  "01966": 13,
  "01969": 14,
  "01970": 12,
  "01971": 12,
  "01982": 15,
  "01983": 16,
  "01984": 23,
  "01985": 15,
  "02018": 19,
  "02019": 7,
  "02020": 13,
  "02021": 19,
  "02025": 33,
  "02026": 20,
  "02027": 20,
  "02030": 30,
  "02031": 19,
  "02032": 19,
  "02035": 19,
  "02038": 18,
  "02040": 17,
  "02041": 13,
  "02043": 39,
  "02045": 33,
  "02047": 13,
  "02048": 19,
  "02050": 13,
  "02051": 13,
  "02052": 22,
  "02053": 20,
  "02054": 18,
  "02055": 17,
  "02056": 27,
  "02059": 24,
  "02060": 20,
  "02061": 24,
  "02062": 20,
  "02065": 13,
  "02066": 17,
  "02067": 21,
  "02070": 20,
  "02071": 28,
  "02072": 19,
  "02081": 19,
  "02090": 22,
  "02093": 20,
  "02108": 31,
  "02109": 29,
  "02110": 40,
  "02111": 31,
  "02112": 40,
  "02113": 29,
  "02114": 31,
  "02115": 31,
  "02116": 40,
  "02117": 31,
  "02118": 31,
  "02119": 29,
  "02120": 29,
  "02121": 29,
  "02122": 29,
  "02123": 31,
  "02124": 29,
  "02125": 29,
  "02126": 29,
  "02127": 29,
  "02128": 29,
  "02129": 29,
  "02130": 29,
  "02131": 29,
  "02132": 20,
  "02133": 40,
  "02134": 29,
  "02135": 31,
  "02136": 19,
  "02137": 19,
  "02138": 32,
  "02139": 31,
  "02140": 31,
  "02141": 29,
  "02142": 29,
  "02143": 29,
  "02144": 31,
  "02145": 29,
  "02148": 29,
  "02149": 29,
  "02150": 29,
  "02151": 29,
  "02152": 29,
  "02153": 29,
  "02155": 29,
  "02156": 29,
  "02163": 32,
  "02169": 29,
  "02170": 29,
  "02171": 29,
  "02176": 29,
  "02180": 17,
  "02184": 19,
  "02185": 19,
  "02186": 22,
  "02187": 22,
  "02188": 19,
  "02189": 28,
  "02190": 19,
  "02191": 29,
  "02196": 31,
  "02199": 40,
  "02203": 31,
  "02205": 31,
  "02210": 31,
  "02215": 29,
  "02222": 31,
  "02228": 40,
  "02238": 32,
  "02269": 29,
  "02283": 31,
  "02284": 31,
  "02298": 40,
  "02301": 18,
  "02302": 18,
  "02303": 18,
  "02304": 18,
  "02305": 18,
  "02322": 18,
  "02324": 13,
  "02327": 13,
  "02330": 13,
  "02331": 24,
  "02332": 24,
  "02333": 13,
  "02334": 19,
  "02337": 13,
  "02338": 13,
  "02339": 13,
  "02341": 13,
  "02343": 18,
  "02345": 13,
  "02346": 13,
  "02347": 8,
  "02350": 13,
  "02351": 13,
  "02355": 13,
  "02356": 19,
  "02358": 13,
  "02359": 13,
  "02360": 13,
  "02361": 13,
  "02362": 13,
  "02364": 13,
  "02366": 13,
  "02367": 13,
  "02368": 18,
  "02370": 13,
  "02375": 19,
  "02379": 13,
  "02381": 13,
  "02382": 13,
  "02420": 20,
  "02421": 20,
  "02445": 40,
  "02446": 31,
  "02447": 31,
  "02451": 17,
  "02452": 19,
  "02453": 17,
  "02454": 17,
  "02455": 40,
  "02456": 31,
  "02457": 30,
  "02458": 31,
  "02459": 31,
  "02460": 31,
  "02461": 31,
  "02462": 20,
  "02464": 31,
  "02465": 20,
  "02466": 20,
  "02467": 40,
  "02468": 33,
  "02471": 31,
  "02472": 31,
  "02474": 20,
  "02475": 20,
  "02476": 20,
  "02478": 31,
  "02479": 31,
  "02481": 30,
  "02482": 22,
  "02492": 22,
  "02493": 28,
  "02494": 22,
  "02495": 31,
  "02532": 7,
  "02534": 7,
  "02535": 23,
  "02536": 13,
  "02537": 7,
  "02538": 13,
  "02539": 16,
  "02540": 14,
  "02541": 14,
  "02542": 7,
  "02543": 15,
  "02552": 23,
  "02553": 7,
  "02554": 24,
  "02556": 14,
  "02557": 16,
  "02558": 13,
  "02559": 7,
  "02561": 7,
  "02562": 7,
  "02563": 7,
  "02564": 24,
  "02565": 14,
  "02568": 16,
  "02571": 13,
  "02573": 16,
  "02574": 14,
  "02575": 16,
  "02576": 12,
  "02584": 24,
  "02601": 7,
  "02630": 7,
  "02631": 7,
  "02632": 7,
  "02633": 7,
  "02634": 7,
  "02635": 7,
  "02636": 17,
  "02637": 7,
  "02638": 7,
  "02639": 7,
  "02641": 7,
  "02642": 7,
  "02643": 9,
  "02644": 7,
  "02645": 7,
  "02646": 7,
  "02647": 17,
  "02648": 7,
  "02649": 7,
  "02650": 9,
  "02651": 7,
  "02652": 7,
  "02653": 9,
  "02655": 7,
  "02657": 9,
  "02659": 7,
  "02660": 7,
  "02661": 9,
  "02662": 9,
  "02663": 7,
  "02664": 7,
  "02666": 9,
  "02667": 7,
  "02668": 7,
  "02669": 9,
  "02670": 7,
  "02671": 7,
  "02672": 17,
  "02673": 6,
  "02675": 7,
  "02702": 9,
  "02703": 9,
  "02712": 9,
  "02713": 15,
  "02714": 8,
  "02715": 9,
  "02717": 8,
  "02718": 9,
  "02719": 8,
  "02720": 8,
  "02721": 8,
  "02722": 8,
  "02723": 8,
  "02724": 8,
  "02725": 8,
  "02726": 9,
  "02738": 8,
  "02739": 8,
  "02740": 8,
  "02741": 8,
  "02742": 8,
  "02743": 8,
  "02744": 8,
  "02745": 8,
  "02746": 8,
  "02747": 8,
  "02748": 8,
  "02760": 19,
  "02761": 19,
  "02762": 19,
  "02763": 9,
  "02764": 9,
  "02766": 9,
  "02767": 9,
  "02768": 9,
  "02769": 8,
  "02770": 8,
  "02771": 7,
  "02777": 8,
  "02779": 9,
  "02780": 8,
  "02790": 9,
  "02791": 9,
  "02801": 10,
  "02802": 7,
  "02804": 6,
  "02806": -1,
  "02807": 9,
  "02808": 6,
  "02809": 0,
  "02812": 6,
  "02813": 6,
  "02814": 7,
  "02815": 4,
  "02816": 4,
  "02817": 4,
  "02818": 5,
  "02822": 6,
  "02823": 4,
  "02824": 7,
  "02825": 4,
  "02826": 7,
  "02827": 4,
  "02828": 7,
  "02829": 7,
  "02830": 7,
  "02831": 4,
  "02832": 6,
  "02833": 6,
  "02835": 10,
  "02836": 6,
  "02837": 10,
  "02838": 7,
  "02839": 6,
  "02840": 1,
  "02841": 2,
  "02842": 2,
  "02852": 4,
  "02854": 6,
  "02857": 8,
  "02858": 7,
  "02859": 7,
  "02860": 6,
  "02861": 6,
  "02862": 6,
  "02863": 6,
  "02864": 6,
  "02865": 7,
  "02871": 2,
  "02872": 2,
  "02873": 6,
  "02874": 6,
  "02875": 6,
  "02876": 7,
  "02877": 6,
  "02878": 2,
  "02879": 6,
  "02880": 6,
  "02881": 8,
  "02882": 6,
  "02883": 6,
  "02885": -1,
  "02886": 4,
  "02887": 4,
  "02888": 3,
  "02889": 3,
  "02891": 6,
  "02892": 6,
  "02893": 3,
  "02894": 6,
  "02895": 6,
  "02896": 7,
  "02898": 6,
  "02901": 6,
  "02903": 6,
  "02904": 6,
  "02905": 6,
  "02906": 15,
  "02907": 6,
  "02908": 6,
  "02909": 6,
  "02910": 6,
  "02911": 6,
  "02914": 6,
  "02915": 6,
  "02916": 6,
  "02917": 6,
  "02919": 7,
  "02920": 4,
  "02921": 4,
  "02940": 6,
  "03031": 7,
  "03032": 7,
  "03033": 7,
  "03034": 7,
  "03036": 8,
  "03037": 8,
  "03038": 7,
  "03040": 7,
  "03041": 7,
  "03042": 8,
  "03043": 2,
  "03044": 8,
  "03045": 7,
  "03046": 7,
  "03047": 7,
  "03048": 6,
  "03049": 11,
  "03051": 7,
  "03052": 7,
  "03053": 7,
  "03054": 7,
  "03055": 7,
  "03057": 7,
  "03060": 7,
  "03061": 7,
  "03062": 7,
  "03063": 7,
  "03064": 7,
  "03070": 7,
  "03071": 7,
  "03073": 7,
  "03076": 7,
  "03077": 7,
  "03079": 7,
  "03082": 7,
  "03084": 7,
  "03086": 7,
  "03087": 7,
  "03101": 7,
  "03102": 7,
  "03103": 7,
  "03104": 7,
  "03105": 7,
  "03106": 7,
  "03108": 7,
  "03109": 7,
  "03110": 15,
  "03215": -3,
  "03216": 6,
  "03217": 6,
  "03218": 6,
  "03220": 6,
  "03221": -3,
  "03222": 6,
  "03223": -3,
  "03224": 6,
  "03225": 1,
  "03226": 14,
  "03227": 5,
  "03229": 6,
  "03230": 6,
  "03231": 6,
  "03233": -3,
  "03234": 6,
  "03235": 6,
  "03237": 6,
  "03238": -3,
  "03240": -4,
  "03241": -2,
  "03242": 6,
  "03243": 7,
  "03244": 6,
  "03245": 14,
  "03246": 6,
  "03247": 6,
  "03249": 6,
  "03251": -3,
  "03252": 6,
  "03253": 6,
  "03254": 5,
  "03255": -3,
  "03256": 6,
  "03257": 6,
  "03258": 6,
  "03259": 5,
  "03260": 6,
  "03261": 1,
  "03262": -3,
  "03263": 6,
  "03264": -3,
  "03266": -3,
  "03268": 6,
  "03269": 6,
  "03272": -3,
  "03273": 6,
  "03274": -3,
  "03275": 6,
  "03276": 6,
  "03278": 6,
  "03279": -3,
  "03280": -3,
  "03281": 6,
  "03282": -3,
  "03284": -3,
  "03285": -3,
  "03287": 6,
  "03289": 6,
  "03290": 7,
  "03291": 2,
  "03293": -3,
  "03301": 6,
  "03302": 6,
  "03303": 6,
  "03304": 6,
  "03307": 6,
  "03431": 2,
  "03440": 2,
  "03441": 2,
  "03442": 2,
  "03443": 3,
  "03444": 11,
  "03445": 2,
  "03446": 2,
  "03447": 2,
  "03448": 2,
  "03449": 3,
  "03450": 2,
  "03451": 2,
  "03452": 2,
  "03455": 2,
  "03456": 2,
  "03457": 2,
  "03458": 2,
  "03461": 2,
  "03462": 2,
  "03464": 2,
  "03465": 2,
  "03466": 3,
  "03467": 2,
  "03468": 2,
  "03469": 2,
  "03470": 2,
  "03561": -5,
  "03570": 12,
  "03574": -3,
  "03575": 13,
  "03576": 13,
  "03579": 13,
  "03580": -2,
  "03581": 13,
  "03582": 12,
  "03583": 13,
  "03584": 13,
  "03585": -5,
  "03586": -5,
  "03588": 13,
  "03589": 13,
  "03590": 12,
  "03592": 13,
  "03593": 12,
  "03595": 13,
  "03597": 13,
  "03598": 13,
  "03601": -4,
  "03602": -3,
  "03603": -4,
  "03604": -4,
  "03605": -3,
  "03607": -3,
  "03608": 2,
  "03609": -4,
  "03740": -2,
  "03741": -2,
  "03743": -3,
  "03745": -3,
  "03746": -3,
  "03748": -3,
  "03749": -3,
  "03750": 7,
  "03751": -3,
  "03752": -3,
  "03753": -3,
  "03754": -3,
  "03755": 7,
  "03756": -3,
  "03765": -1,
  "03766": -3,
  "03768": 0,
  "03769": 0,
  "03770": -3,
  "03771": -5,
  "03773": -3,
  "03774": -2,
  "03777": -1,
  "03779": -1,
  "03780": -2,
  "03781": -3,
  "03782": -3,
  "03784": -3,
  "03785": -2,
  "03801": 3,
  "03802": 3,
  "03804": 3,
  "03805": 2,
  "03809": 6,
  "03810": 6,
  "03811": 7,
  "03812": -4,
  "03813": -3,
  "03814": -4,
  "03815": 2,
  "03816": 14,
  "03817": -4,
  "03818": -4,
  "03819": 7,
  "03820": 2,
  "03821": 2,
  "03823": 2,
  "03824": 3,
  "03825": 2,
  "03826": 7,
  "03827": 8,
  "03830": -4,
  "03832": -3,
  "03833": 8,
  "03835": 1,
  "03836": -3,
  "03837": 6,
  "03838": -3,
  "03839": 1,
  "03840": 8,
  "03841": 7,
  "03842": 8,
  "03843": 8,
  "03844": 8,
  "03845": -3,
  "03846": 5,
  "03847": -3,
  "03848": 7,
  "03849": -4,
  "03850": 6,
  "03851": 1,
  "03852": 1,
  "03853": 14,
  "03854": 14,
  "03855": 6,
  "03856": 8,
  "03857": 8,
  "03858": 7,
  "03859": 7,
  "03860": -4,
  "03861": 7,
  "03862": 8,
  "03864": -4,
  "03865": 7,
  "03866": 1,
  "03867": 1,
  "03868": 1,
  "03869": 2,
  "03870": 11,
  "03871": 11,
  "03872": -4,
  "03873": 7,
  "03874": 8,
  "03875": -4,
  "03878": 1,
  "03882": -4,
  "03883": -4,
  "03884": 2,
  "03885": 8,
  "03886": -4,
  "03887": 1,
  "03890": -4,
  "03894": 8,
  "03896": 8,
  "03897": 5,
  "03901": 1,
  "03902": 0,
  "03903": 3,
  "03904": 3,
  "03905": 3,
  "03906": -2,
  "03907": 0,
  "03908": 2,
  "03909": 3,
  "03910": 3,
  "03911": 3,
  "04001": -1,
  "04002": -2,
  "04003": 12,
  "04004": 3,
  "04005": -1,
  "04006": -1,
  "04007": -1,
  "04008": -3,
  "04009": -6,
  "04010": -6,
  "04011": -3,
  "04013": 3,
  "04014": 0,
  "04015": 2,
  "04016": -6,
  "04017": 3,
  "04019": 3,
  "04020": -1,
  "04021": 3,
  "04022": -6,
  "04024": 3,
  "04027": 1,
  "04028": -2,
  "04029": 3,
  "04030": -1,
  "04032": 3,
  "04037": -6,
  "04038": 3,
  "04039": 3,
  "04040": -6,
  "04041": 3,
  "04042": -1,
  "04043": 0,
  "04046": 0,
  "04047": -1,
  "04048": -1,
  "04049": 3,
  "04050": 12,
  "04051": -6,
  "04054": 0,
  "04055": 2,
  "04056": -4,
  "04057": -6,
  "04061": -1,
  "04062": 3,
  "04063": -1,
  "04064": -1,
  "04066": -1,
  "04068": -1,
  "04069": 10,
  "04070": 3,
  "04071": 3,
  "04072": -1,
  "04073": -2,
  "04074": 3,
  "04076": -2,
  "04077": 3,
  "04078": 3,
  "04079": -1,
  "04082": 3,
  "04083": -2,
  "04084": 3,
  "04085": 3,
  "04086": -3,
  "04087": -2,
  "04088": -6,
  "04090": 0,
  "04091": 3,
  "04092": 3,
  "04093": 3,
  "04094": 0,
  "04095": -4,
  "04096": 3,
  "04097": 3,
  "04098": 3,
  "04101": 3,
  "04102": 3,
  "04103": 3,
  "04104": 3,
  "04105": 12,
  "04106": 3,
  "04107": 3,
  "04108": 3,
  "04109": 3,
  "04110": 14,
  "04112": 3,
  "04116": 3,
  "04210": -2,
  "04211": -2,
  "04212": -2,
  "04216": -6,
  "04217": -6,
  "04219": -6,
  "04220": -2,
  "04221": -2,
  "04222": 10,
  "04223": -2,
  "04224": -6,
  "04225": -7,
  "04226": -6,
  "04227": -7,
  "04228": -2,
  "04230": -2,
  "04231": -6,
  "04234": -7,
  "04236": -2,
  "04237": -6,
  "04238": -2,
  "04239": -2,
  "04240": -2,
  "04241": -2,
  "04243": -2,
  "04250": -2,
  "04252": -3,
  "04253": -2,
  "04254": -2,
  "04255": -6,
  "04256": -2,
  "04257": -6,
  "04258": -2,
  "04259": -2,
  "04260": 2,
  "04261": -5,
  "04262": -1,
  "04263": -2,
  "04265": -2,
  "04266": -2,
  "04267": -6,
  "04268": -6,
  "04270": -2,
  "04271": -6,
  "04274": -2,
  "04275": -6,
  "04276": -6,
  "04280": -2,
  "04281": -6,
  "04282": -2,
  "04284": -1,
  "04285": -6,
  "04286": -6,
  "04287": 2,
  "04288": -2,
  "04289": -6,
  "04290": -6,
  "04291": -2,
  "04292": -6,
  "04294": -7,
  "04330": -1,
  "04332": -1,
  "04338": -1,
  "04341": -1,
  "04342": -3,
  "04343": -1,
  "04344": -1,
  "04345": -2,
  "04346": -2,
  "04347": -1,
  "04348": -7,
  "04349": -1,
  "04350": -2,
  "04351": -1,
  "04352": -1,
  "04353": -7,
  "04354": -9,
  "04355": -1,
  "04357": -3,
  "04358": -1,
  "04359": -1,
  "04360": -1,
  "04363": -1,
  "04364": -1,
  "04401": -2,
  "04402": -2,
  "04406": -5,
  "04408": -7,
  "04410": -2,
  "04411": -2,
  "04412": -7,
  "04413": -11,
  "04414": -5,
  "04415": -5,
  "04416": -9,
  "04417": -3,
  "04418": -3,
  "04419": -9,
  "04421": 0,
  "04422": -2,
  "04424": -11,
  "04426": -2,
  "04427": -2,
  "04428": -7,
  "04429": -7,
  "04430": -3,
  "04431": -7,
  "04434": -9,
  "04435": -3,
  "04438": -9,
  "04441": -4,
  "04442": -5,
  "04443": -5,
  "04444": -9,
  "04448": -3,
  "04449": -2,
  "04450": -2,
  "04451": -3,
  "04453": -3,
  "04454": -11,
  "04455": -3,
  "04456": -2,
  "04457": -3,
  "04459": -3,
  "04460": -3,
  "04461": -2,
  "04462": -5,
  "04463": -3,
  "04464": -5,
  "04468": -2,
  "04471": -10,
  "04472": -7,
  "04473": -2,
  "04474": -7,
  "04475": -3,
  "04476": -7,
  "04478": -4,
  "04479": -2,
  "04481": -2,
  "04485": -4,
  "04487": -3,
  "04488": -2,
  "04489": -2,
  "04490": -11,
  "04491": -11,
  "04492": -11,
  "04493": -3,
  "04495": -3,
  "04496": -9,
  "04497": -3,
  "04530": -3,
  "04535": -7,
  "04537": -7,
  "04538": -7,
  "04539": -7,
  "04541": 2,
  "04543": 2,
  "04544": 2,
  "04547": -6,
  "04548": -1,
  "04549": -7,
  "04551": -5,
  "04553": -5,
  "04554": 2,
  "04555": -7,
  "04556": -7,
  "04558": 2,
  "04562": -1,
  "04563": -6,
  "04564": -5,
  "04565": -1,
  "04568": 2,
  "04570": 7,
  "04571": -7,
  "04572": -5,
  "04573": 2,
  "04574": -6,
  "04575": -7,
  "04576": 7,
  "04578": -7,
  "04579": -3,
  "04605": -7,
  "04606": -11,
  "04607": -7,
  "04609": -7,
  "04611": -11,
  "04612": -7,
  "04613": -7,
  "04614": -7,
  "04616": -7,
  "04617": -7,
  "04619": -11,
  "04622": -11,
  "04623": -11,
  "04624": -7,
  "04625": -6,
  "04626": -11,
  "04627": -7,
  "04628": -11,
  "04629": -7,
  "04630": -11,
  "04631": -11,
  "04634": -7,
  "04635": -7,
  "04637": -11,
  "04640": -7,
  "04642": -9,
  "04643": -11,
  "04644": -7,
  "04645": -6,
  "04646": -7,
  "04648": -11,
  "04649": -11,
  "04650": -7,
  "04652": -11,
  "04653": -7,
  "04654": -11,
  "04655": -11,
  "04657": -11,
  "04658": -7,
  "04660": -7,
  "04662": 1,
  "04664": -7,
  "04666": -11,
  "04667": -11,
  "04668": -11,
  "04669": -7,
  "04671": -11,
  "04672": -7,
  "04673": -7,
  "04674": -7,
  "04675": -7,
  "04676": -7,
  "04677": -7,
  "04679": -7,
  "04680": -7,
  "04681": -6,
  "04683": -7,
  "04684": -7,
  "04685": -7,
  "04686": -11,
  "04691": -11,
  "04693": -7,
  "04694": -11,
  "04730": -10,
  "04732": -10,
  "04733": -2,
  "04734": -10,
  "04735": -10,
  "04736": -10,
  "04737": -10,
  "04738": -10,
  "04739": -9,
  "04740": -10,
  "04741": -10,
  "04742": -10,
  "04743": -10,
  "04744": -10,
  "04745": -10,
  "04746": -10,
  "04747": -10,
  "04750": -10,
  "04756": -10,
  "04757": -10,
  "04758": -10,
  "04760": -10,
  "04761": -10,
  "04762": -10,
  "04763": -10,
  "04764": -10,
  "04765": -10,
  "04766": -10,
  "04768": -9,
  "04769": -10,
  "04772": -9,
  "04773": -9,
  "04774": -10,
  "04775": -10,
  "04776": -3,
  "04777": -5,
  "04779": -9,
  "04780": -10,
  "04781": -10,
  "04783": -9,
  "04785": -10,
  "04786": -10,
  "04787": -10,
  "04841": -6,
  "04843": -6,
  "04846": -6,
  "04847": -6,
  "04848": -9,
  "04849": -9,
  "04850": -9,
  "04851": -6,
  "04852": -5,
  "04853": -6,
  "04854": -6,
  "04855": -6,
  "04856": -6,
  "04858": -6,
  "04859": -6,
  "04860": -4,
  "04861": -6,
  "04862": -6,
  "04863": -6,
  "04864": -6,
  "04865": -6,
  "04901": -1,
  "04903": -1,
  "04910": -9,
  "04911": -7,
  "04912": -2,
  "04915": -9,
  "04917": -1,
  "04918": -1,
  "04920": -2,
  "04921": -9,
  "04922": -9,
  "04923": -2,
  "04924": -1,
  "04925": -2,
  "04926": -1,
  "04927": -1,
  "04928": -2,
  "04929": -9,
  "04930": -2,
  "04932": -9,
  "04933": -9,
  "04935": -1,
  "04936": -6,
  "04937": -1,
  "04938": -7,
  "04939": -3,
  "04940": -1,
  "04941": -9,
  "04942": -2,
  "04943": -2,
  "04944": -1,
  "04945": -2,
  "04947": -6,
  "04949": -9,
  "04950": -2,
  "04951": -9,
  "04952": -9,
  "04953": -9,
  "04954": -7,
  "04955": -1,
  "04956": -7,
  "04957": -2,
  "04958": -2,
  "04961": -2,
  "04962": -1,
  "04963": -1,
  "04964": -6,
  "04965": -9,
  "04966": -7,
  "04967": -9,
  "04969": -9,
  "04970": -6,
  "04971": -2,
  "04972": -9,
  "04973": -9,
  "04974": -9,
  "04975": -1,
  "04976": -2,
  "04978": -1,
  "04979": -2,
  "04981": -9,
  "04982": -6,
  "04983": -7,
  "04984": -7,
  "04985": -2,
  "04986": -9,
  "04987": -9,
  "04988": -9,
  "04989": -1,
  "04992": -7,
  "05001": -3,
  "05030": -3,
  "05031": 4,
  "05032": -2,
  "05033": -3,
  "05034": -4,
  "05035": -4,
  "05036": -3,
  "05037": -4,
  "05038": -3,
  "05039": -3,
  "05040": -4,
  "05041": -3,
  "05042": -5,
  "05043": -4,
  "05045": -3,
  "05046": -5,
  "05047": -3,
  "05048": -3,
  "05049": -3,
  "05050": -6,
  "05051": -3,
  "05052": -3,
  "05053": 4,
  "05054": -3,
  "05055": 6,
  "05056": -4,
  "05058": -3,
  "05059": -4,
  "05060": -3,
  "05061": -3,
  "05062": -4,
  "05065": -3,
  "05067": -3,
  "05068": -3,
  "05069": -6,
  "05070": 5,
  "05071": 5,
  "05072": 5,
  "05073": -4,
  "05074": 5,
  "05075": -2,
  "05076": -4,
  "05077": -3,
  "05079": -4,
  "05081": -3,
  "05083": -4,
  "05084": -2,
  "05085": -3,
  "05086": -4,
  "05088": -3,
  "05089": -3,
  "05091": -4,
  "05101": -4,
  "05141": -4,
  "05142": -4,
  "05143": -5,
  "05144": -5,
  "05146": -5,
  "05148": -5,
  "05149": -4,
  "05150": -4,
  "05151": -4,
  "05152": -9,
  "05153": -4,
  "05154": -4,
  "05155": -5,
  "05156": -3,
  "05158": -4,
  "05159": -4,
  "05161": -4,
  "05201": -8,
  "05250": -8,
  "05251": -8,
  "05252": -9,
  "05253": -8,
  "05254": 0,
  "05255": -8,
  "05257": -8,
  "05260": -8,
  "05261": -8,
  "05262": 0,
  "05301": -1,
  "05302": -3,
  "05303": -3,
  "05304": -3,
  "05340": -8,
  "05341": -4,
  "05342": -4,
  "05343": -5,
  "05344": -1,
  "05345": -3,
  "05346": -4,
  "05350": -8,
  "05351": -3,
  "05352": -8,
  "05353": -3,
  "05354": 9,
  "05355": -4,
  "05356": -4,
  "05357": -3,
  "05358": -4,
  "05359": -5,
  "05360": -5,
  "05361": -4,
  "05362": -3,
  "05363": -4,
  "05401": 5,
  "05402": 6,
  "05403": 6,
  "05404": 5,
  "05406": 5,
  "05407": 6,
  "05408": 6,
  "05440": -6,
  "05441": -5,
  "05442": -4,
  "05443": -4,
  "05444": -3,
  "05445": 13,
  "05446": 5,
  "05447": -6,
  "05448": -5,
  "05449": 5,
  "05450": -5,
  "05451": 6,
  "05452": 6,
  "05453": 6,
  "05454": -5,
  "05455": -5,
  "05456": -4,
  "05457": -5,
  "05458": -4,
  "05459": -5,
  "05460": -5,
  "05461": 5,
  "05462": 5,
  "05463": -5,
  "05464": -3,
  "05465": 6,
  "05466": 5,
  "05468": 5,
  "05469": -4,
  "05470": -5,
  "05471": -5,
  "05472": -4,
  "05473": -4,
  "05474": 3,
  "05476": -6,
  "05477": 5,
  "05478": -5,
  "05481": -5,
  "05482": 13,
  "05483": -5,
  "05485": -5,
  "05486": 3,
  "05487": -4,
  "05488": -5,
  "05489": 13,
  "05490": 13,
  "05491": -4,
  "05492": -3,
  "05494": 5,
  "05495": 13,
  "05601": -2,
  "05602": -2,
  "05640": -1,
  "05641": -2,
  "05647": -5,
  "05648": -2,
  "05649": -2,
  "05650": -3,
  "05651": -2,
  "05652": -4,
  "05653": -4,
  "05654": -3,
  "05655": -3,
  "05656": -3,
  "05657": -3,
  "05658": -2,
  "05660": 6,
  "05661": -3,
  "05662": 5,
  "05663": -2,
  "05664": -3,
  "05665": -4,
  "05666": -2,
  "05667": -2,
  "05669": -3,
  "05670": -2,
  "05672": 5,
  "05673": 6,
  "05674": 4,
  "05675": -3,
  "05676": -2,
  "05677": -1,
  "05678": -3,
  "05679": -2,
  "05680": -3,
  "05681": -4,
  "05682": -2,
  "05701": -7,
  "05702": -7,
  "05730": -7,
  "05731": -7,
  "05732": -7,
  "05733": -7,
  "05734": -4,
  "05735": -7,
  "05736": -7,
  "05737": -7,
  "05738": -7,
  "05739": -7,
  "05740": -4,
  "05741": -7,
  "05742": -7,
  "05743": -7,
  "05744": -7,
  "05745": -7,
  "05746": -7,
  "05747": -5,
  "05748": -5,
  "05750": -7,
  "05751": -5,
  "05753": -4,
  "05757": -7,
  "05758": -4,
  "05759": -7,
  "05760": -6,
  "05761": 1,
  "05762": -7,
  "05763": -7,
  "05764": -7,
  "05765": -7,
  "05766": -4,
  "05767": -4,
  "05768": 0,
  "05769": -4,
  "05770": -4,
  "05772": -7,
  "05773": -7,
  "05774": -7,
  "05775": 1,
  "05776": 0,
  "05777": -7,
  "05778": -4,
  "05819": -6,
  "05820": -5,
  "05821": -5,
  "05822": -5,
  "05823": -5,
  "05824": -6,
  "05825": -5,
  "05826": -4,
  "05827": -4,
  "05828": -5,
  "05829": -5,
  "05830": -5,
  "05832": -5,
  "05833": -5,
  "05836": -6,
  "05837": -6,
  "05838": -6,
  "05839": -5,
  "05840": -6,
  "05841": 3,
  "05842": -6,
  "05843": -6,
  "05845": -5,
  "05846": -5,
  "05847": -5,
  "05848": -6,
  "05849": -6,
  "05850": -6,
  "05851": -6,
  "05853": -5,
  "05855": -5,
  "05857": -5,
  "05858": -6,
  "05859": -5,
  "05860": -5,
  "05861": -6,
  "05862": -5,
  "05863": -6,
  "05866": -6,
  "05867": -6,
  "05868": -5,
  "05871": -5,
  "05872": -5,
  "05873": -5,
  "05874": -4,
  "05875": -5,
  "05901": -5,
  "05902": -6,
  "05903": -5,
  "05904": -6,
  "05905": -6,
  "05906": -6,
  "05907": -5,
  "06001": 19,
  "06002": 11,
  "06010": 11,
  "06011": 11,
  "06013": 11,
  "06016": 4,
  "06018": 8,
  "06019": 11,
  "06020": 11,
  "06021": 9,
  "06022": 19,
  "06023": 20,
  "06024": 8,
  "06025": 11,
  "06026": 11,
  "06027": 12,
  "06028": 11,
  "06029": 4,
  "06031": 8,
  "06032": 11,
  "06033": 11,
  "06034": 11,
  "06035": 12,
  "06037": 11,
  "06039": 17,
  "06040": 11,
  "06042": 11,
  "06043": 4,
  "06045": 11,
  "06050": 10,
  "06051": 10,
  "06052": 11,
  "06053": 11,
  "06057": 8,
  "06058": 9,
  "06059": 19,
  "06060": 17,
  "06061": 8,
  "06062": 11,
  "06063": 12,
  "06064": 11,
  "06065": 9,
  "06066": 4,
  "06067": 11,
  "06068": 16,
  "06069": 8,
  "06070": 12,
  "06071": 15,
  "06072": 15,
  "06073": 20,
  "06074": 11,
  "06075": 4,
  "06076": 4,
  "06077": 4,
  "06078": 8,
  "06079": 16,
  "06081": 11,
  "06082": 7,
  "06083": 7,
  "06084": 4,
  "06085": 11,
  "06088": 11,
  "06089": 11,
  "06090": 20,
  "06091": 12,
  "06092": 19,
  "06093": 8,
  "06094": 8,
  "06095": 11,
  "06096": 11,
  "06098": 8,
  "06101": 10,
  "06102": 11,
  "06103": 11,
  "06104": 10,
  "06105": 11,
  "06106": 10,
  "06107": 11,
  "06108": 11,
  "06109": 11,
  "06110": 11,
  "06111": 11,
  "06112": 10,
  "06114": 11,
  "06115": 11,
  "06117": 11,
  "06118": 11,
  "06119": 11,
  "06120": 10,
  "06123": 11,
  "06126": 11,
  "06127": 11,
  "06128": 11,
  "06129": 11,
  "06131": 11,
  "06132": 11,
  "06133": 10,
  "06134": 11,
  "06137": 8,
  "06138": 11,
  "06140": 10,
  "06141": 10,
  "06142": 11,
  "06143": 10,
  "06144": 10,
  "06145": 10,
  "06146": 10,
  "06147": 10,
  "06152": 10,
  "06199": 11,
  "06226": 4,
  "06230": 1,
  "06231": 5,
  "06232": 4,
  "06233": 0,
  "06234": 1,
  "06235": 0,
  "06237": 5,
  "06238": 4,
  "06239": 0,
  "06241": 0,
  "06242": 1,
  "06243": 0,
  "06244": 1,
  "06245": 1,
  "06246": 1,
  "06247": 1,
  "06248": 4,
  "06249": 6,
  "06250": 5,
  "06251": 5,
  "06254": 6,
  "06255": 1,
  "06256": 0,
  "06258": 1,
  "06259": 1,
  "06260": 0,
  "06262": 1,
  "06263": 0,
  "06264": 1,
  "06265": 4,
  "06266": 0,
  "06267": 1,
  "06268": 6,
  "06277": 1,
  "06278": 4,
  "06279": 4,
  "06280": 0,
  "06281": 1,
  "06282": 1,
  "06320": 5,
  "06330": 6,
  "06331": 1,
  "06332": 0,
  "06333": 5,
  "06334": 6,
  "06335": 5,
  "06336": 14,
  "06338": 6,
  "06339": 6,
  "06340": 5,
  "06349": 5,
  "06350": 6,
  "06351": 5,
  "06353": 5,
  "06354": 0,
  "06355": 5,
  "06357": 5,
  "06359": 6,
  "06360": 5,
  "06365": 6,
  "06370": 5,
  "06371": 5,
  "06372": 5,
  "06373": 0,
  "06374": 0,
  "06375": 5,
  "06376": 5,
  "06377": 0,
  "06378": 5,
  "06379": 5,
  "06380": 5,
  "06382": 5,
  "06383": 5,
  "06384": 5,
  "06385": 5,
  "06387": 0,
  "06388": 5,
  "06389": 6,
  "06390": 5,
  "06401": 7,
  "06403": 7,
  "06404": 9,
  "06405": 8,
  "06409": 5,
  "06410": 16,
  "06412": 14,
  "06413": 16,
  "06414": 13,
  "06415": 6,
  "06416": 11,
  "06417": 14,
  "06418": 7,
  "06419": 16,
  "06420": 14,
  "06422": 16,
  "06423": 14,
  "06424": 13,
  "06426": 5,
  "06437": 8,
  "06438": 14,
  "06439": 14,
  "06440": 13,
  "06441": 16,
  "06442": 5,
  "06443": 8,
  "06444": 8,
  "06447": 13,
  "06450": 8,
  "06451": 7,
  "06455": 16,
  "06456": 13,
  "06457": 11,
  "06460": 8,
  "06461": 8,
  "06467": 8,
  "06468": 9,
  "06469": 14,
  "06470": 13,
  "06471": 8,
  "06472": 8,
  "06473": 8,
  "06474": 5,
  "06475": 5,
  "06477": 8,
  "06478": 8,
  "06479": 8,
  "06480": 13,
  "06481": 9,
  "06482": 10,
  "06483": 7,
  "06484": 8,
  "06487": 7,
  "06488": 7,
  "06489": 11,
  "06491": 9,
  "06492": 8,
  "06497": 9,
  "06498": 5,
  "06501": 10,
  "06502": 10,
  "06503": 10,
  "06504": 7,
  "06505": 10,
  "06506": 10,
  "06507": 10,
  "06508": 10,
  "06509": 7,
  "06510": 10,
  "06511": 7,
  "06512": 7,
  "06513": 7,
  "06514": 7,
  "06515": 7,
  "06516": 7,
  "06517": 7,
  "06518": 8,
  "06519": 7,
  "06520": 10,
  "06521": 10,
  "06524": 8,
  "06525": 12,
  "06530": 7,
  "06531": 7,
  "06532": 7,
  "06533": 7,
  "06534": 7,
  "06535": 7,
  "06536": 7,
  "06601": 9,
  "06602": 9,
  "06604": 9,
  "06605": 9,
  "06606": 9,
  "06607": 9,
  "06608": 9,
  "06610": 9,
  "06611": 9,
  "06612": 9,
  "06614": 9,
  "06615": 9,
  "06650": 9,
  "06702": 7,
  "06703": 7,
  "06704": 7,
  "06705": 7,
  "06706": 7,
  "06708": 7,
  "06710": 7,
  "06712": 7,
  "06716": 7,
  "06720": 7,
  "06721": 7,
  "06722": 7,
  "06723": 7,
  "06724": 7,
  "06725": 7,
  "06726": 7,
  "06750": 8,
  "06751": 8,
  "06752": 12,
  "06753": 8,
  "06754": 8,
  "06755": 9,
  "06756": 8,
  "06757": 9,
  "06758": 8,
  "06759": 8,
  "06762": 7,
  "06763": 8,
  "06770": 7,
  "06776": 9,
  "06777": 8,
  "06778": 8,
  "06779": 8,
  "06781": 8,
  "06782": 8,
  "06783": 12,
  "06784": 9,
  "06785": 9,
  "06786": 8,
  "06787": 8,
  "06790": 8,
  "06791": 8,
  "06793": 19,
  "06794": 19,
  "06795": 8,
  "06796": 8,
  "06798": 8,
  "06801": 10,
  "06804": 10,
  "06807": 13,
  "06810": 10,
  "06811": 10,
  "06812": 10,
  "06813": 10,
  "06820": 21,
  "06824": 9,
  "06825": 9,
  "06829": 13,
  "06830": 21,
  "06831": 23,
  "06836": 21,
  "06838": 21,
  "06840": 21,
  "06850": 10,
  "06851": 10,
  "06852": 10,
  "06853": 13,
  "06854": 10,
  "06855": 13,
  "06856": 10,
  "06870": 14,
  "06875": 13,
  "06876": 13,
  "06877": 14,
  "06878": 21,
  "06880": 21,
  "06881": 21,
  "06883": 21,
  "06890": 21,
  "06896": 13,
  "06897": 21,
  "06901": 10,
  "06902": 10,
  "06903": 13,
  "06904": 10,
  "06905": 13,
  "06906": 10,
  "06907": 13,
  "06910": 10,
  "06911": 14,
  "06912": 10,
  "07001": 12,
  "07002": 14,
  "07003": 10,
  "07004": 11,
  "07005": 14,
  "07006": 13,
  "07007": 13,
  "07008": 12,
  "07009": 10,
  "07010": 14,
  "07011": 9,
  "07012": 10,
  "07013": 8,
  "07014": 10,
  "07015": 9,
  "07016": 12,
  "07017": 10,
  "07018": 10,
  "07019": 10,
  "07020": 14,
  "07021": 21,
  "07022": 14,
  "07023": 12,
  "07024": 10,
  "07026": 9,
  "07027": 12,
  "07028": 10,
  "07029": 10,
  "07030": 14,
  "07031": 14,
  "07032": 14,
  "07033": 11,
  "07034": 13,
  "07035": 8,
  "07036": 12,
  "07039": 13,
  "07040": 10,
  "07041": 14,
  "07042": 10,
  "07043": 13,
  "07044": 10,
  "07045": 16,
  "07046": 25,
  "07047": 14,
  "07050": 10,
  "07051": 10,
  "07052": 10,
  "07054": 14,
  "07055": 9,
  "07057": 10,
  "07058": 16,
  "07059": 18,
  "07060": 11,
  "07061": 11,
  "07062": 11,
  "07063": 13,
  "07064": 12,
  "07065": 12,
  "07066": 12,
  "07067": 12,
  "07068": 13,
  "07069": 11,
  "07070": 14,
  "07071": 14,
  "07072": 10,
  "07073": 14,
  "07074": 9,
  "07075": 10,
  "07076": 12,
  "07077": 12,
  "07078": 22,
  "07079": 10,
  "07080": 13,
  "07081": 12,
  "07082": 11,
  "07083": 11,
  "07086": 14,
  "07087": 14,
  "07088": 11,
  "07090": 14,
  "07091": 14,
  "07092": 14,
  "07093": 14,
  "07094": 14,
  "07095": 13,
  "07096": 14,
  "07101": 10,
  "07102": 10,
  "07103": 10,
  "07104": 10,
  "07105": 14,
  "07106": 10,
  "07107": 10,
  "07108": 10,
  "07109": 10,
  "07110": 10,
  "07111": 10,
  "07112": 10,
  "07114": 10,
  "07201": 12,
  "07202": 12,
  "07203": 11,
  "07204": 11,
  "07205": 11,
  "07206": 12,
  "07207": 11,
  "07208": 11,
  "07302": 14,
  "07303": 14,
  "07304": 14,
  "07305": 14,
  "07306": 14,
  "07307": 14,
  "07308": 14,
  "07309": 14,
  "07310": 14,
  "07311": 14,
  "07401": 11,
  "07403": 8,
  "07405": 8,
  "07407": 10,
  "07410": 10,
  "07416": 4,
  "07417": 19,
  "07418": 4,
  "07419": 4,
  "07420": 8,
  "07421": 4,
  "07422": 4,
  "07423": 13,
  "07424": 8,
  "07428": 3,
  "07430": 12,
  "07432": 8,
  "07435": 5,
  "07436": 8,
  "07438": 5,
  "07439": 4,
  "07440": 8,
  "07442": 8,
  "07444": 8,
  "07446": 12,
  "07450": 12,
  "07451": 12,
  "07452": 12,
  "07456": 8,
  "07457": 8,
  "07458": 20,
  "07460": 4,
  "07461": 4,
  "07462": 3,
  "07463": 10,
  "07465": 8,
  "07470": 11,
  "07474": 11,
  "07480": 8,
  "07481": 12,
  "07495": 12,
  "07501": 11,
  "07502": 8,
  "07503": 8,
  "07504": 8,
  "07505": 11,
  "07506": 8,
  "07507": 11,
  "07508": 8,
  "07509": 8,
  "07510": 8,
  "07511": 8,
  "07512": 8,
  "07513": 8,
  "07514": 8,
  "07522": 8,
  "07524": 8,
  "07533": 8,
  "07538": 8,
  "07543": 8,
  "07544": 8,
  "07601": 9,
  "07602": 9,
  "07603": 9,
  "07604": 10,
  "07605": 12,
  "07606": 10,
  "07607": 10,
  "07608": 10,
  "07620": 21,
  "07621": 10,
  "07624": 13,
  "07626": 13,
  "07627": 13,
  "07628": 10,
  "07630": 10,
  "07631": 10,
  "07632": 24,
  "07640": 13,
  "07641": 13,
  "07642": 13,
  "07643": 10,
  "07644": 10,
  "07645": 12,
  "07646": 10,
  "07647": 10,
  "07648": 13,
  "07649": 13,
  "07650": 10,
  "07652": 12,
  "07653": 12,
  "07656": 12,
  "07657": 14,
  "07660": 10,
  "07661": 10,
  "07662": 10,
  "07663": 10,
  "07666": 10,
  "07670": 13,
  "07675": 13,
  "07676": 13,
  "07677": 12,
  "07701": 12,
  "07702": 12,
  "07703": 11,
  "07704": 22,
  "07710": 11,
  "07711": 14,
  "07712": 11,
  "07716": 12,
  "07717": 15,
  "07718": 11,
  "07719": 11,
  "07720": 11,
  "07721": 13,
  "07722": 22,
  "07723": 22,
  "07724": 11,
  "07726": 9,
  "07727": 11,
  "07728": 11,
  "07730": 11,
  "07731": 11,
  "07732": 11,
  "07733": 23,
  "07734": 11,
  "07735": 13,
  "07737": 11,
  "07738": 15,
  "07739": 22,
  "07740": 11,
  "07746": 14,
  "07747": 13,
  "07748": 12,
  "07750": 15,
  "07751": 15,
  "07752": 11,
  "07753": 11,
  "07754": 11,
  "07755": 11,
  "07756": 11,
  "07757": 11,
  "07758": 11,
  "07760": 22,
  "07762": 14,
  "07763": 9,
  "07764": 11,
  "07765": 15,
  "07799": 12,
  "07801": 13,
  "07802": 16,
  "07803": 13,
  "07806": 13,
  "07820": 2,
  "07821": 5,
  "07822": 5,
  "07823": 2,
  "07825": 3,
  "07826": 4,
  "07827": 4,
  "07828": 14,
  "07829": 2,
  "07830": 25,
  "07831": 4,
  "07832": 3,
  "07833": 2,
  "07834": 14,
  "07836": 14,
  "07837": 13,
  "07838": 2,
  "07839": 2,
  "07840": 2,
  "07842": 13,
  "07843": 13,
  "07844": 3,
  "07845": 14,
  "07846": 2,
  "07847": 13,
  "07848": 5,
  "07849": 13,
  "07850": 13,
  "07851": -10,
  "07852": 13,
  "07853": 6,
  "07855": 4,
  "07856": 14,
  "07857": 13,
  "07860": 4,
  "07863": 2,
  "07865": 2,
  "07866": 13,
  "07869": 16,
  "07870": 6,
  "07871": 5,
  "07874": 13,
  "07875": 4,
  "07876": 14,
  "07877": 4,
  "07878": 14,
  "07879": 5,
  "07880": 2,
  "07881": 4,
  "07882": 2,
  "07885": 13,
  "07901": 22,
  "07902": 22,
  "07920": 16,
  "07921": 14,
  "07922": 14,
  "07924": 18,
  "07926": 16,
  "07927": 14,
  "07928": 14,
  "07930": 18,
  "07931": 25,
  "07932": 16,
  "07933": 14,
  "07934": 25,
  "07935": 16,
  "07936": 16,
  "07938": 16,
  "07939": 16,
  "07940": 16,
  "07945": 25,
  "07946": 16,
  "07950": 16,
  "07960": 16,
  "07961": 16,
  "07962": 16,
  "07963": 16,
  "07970": 16,
  "07974": 14,
  "07976": 25,
  "07977": 16,
  "07978": 14,
  "07979": 18,
  "07980": 16,
  "07981": 16,
  "07999": 14,
  "08001": 19,
  "08002": 7,
  "08003": 15,
  "08004": 7,
  "08005": 2,
  "08006": 5,
  "08007": 7,
  "08008": 3,
  "08009": 7,
  "08010": 8,
  "08011": 9,
  "08012": 4,
  "08014": 6,
  "08015": 9,
  "08016": 9,
  "08018": 9,
  "08019": 11,
  "08020": 4,
  "08021": 6,
  "08022": 9,
  "08023": 6,
  "08025": 13,
  "08026": 7,
  "08027": 4,
  "08028": 6,
  "08029": 7,
  "08030": 6,
  "08031": 6,
  "08032": 4,
  "08033": 15,
  "08034": 7,
  "08035": 7,
  "08036": 7,
  "08037": 6,
  "08038": 18,
  "08039": 19,
  "08041": 9,
  "08042": 9,
  "08043": 8,
  "08045": 7,
  "08046": 8,
  "08048": 8,
  "08049": 6,
  "08050": 2,
  "08051": 4,
  "08052": 7,
  "08053": 7,
  "08054": 8,
  "08055": 17,
  "08056": 4,
  "08057": 7,
  "08059": 6,
  "08060": 9,
  "08061": 4,
  "08062": 6,
  "08063": 6,
  "08064": 9,
  "08065": 7,
  "08066": 4,
  "08067": 19,
  "08068": 9,
  "08069": 19,
  "08070": 6,
  "08071": 4,
  "08072": 18,
  "08073": 8,
  "08074": 13,
  "08075": 8,
  "08076": 7,
  "08077": 7,
  "08078": 7,
  "08079": 18,
  "08080": 4,
  "08081": 4,
  "08083": 7,
  "08084": 7,
  "08085": 19,
  "08086": 4,
  "08087": 6,
  "08088": 8,
  "08089": 9,
  "08090": 4,
  "08091": 7,
  "08092": 0,
  "08093": 6,
  "08094": 6,
  "08095": 6,
  "08096": 4,
  "08097": 4,
  "08098": 20,
  "08099": 6,
  "08101": 6,
  "08102": 6,
  "08103": 6,
  "08104": 6,
  "08105": 6,
  "08106": 7,
  "08107": 6,
  "08108": 7,
  "08109": 7,
  "08110": 6,
  "08201": 6,
  "08202": 8,
  "08203": 6,
  "08204": -4,
  "08205": 6,
  "08210": -4,
  "08212": 7,
  "08213": 6,
  "08214": -4,
  "08215": 6,
  "08217": 6,
  "08218": -4,
  "08219": -4,
  "08220": 6,
  "08221": 6,
  "08223": 6,
  "08224": 6,
  "08225": 6,
  "08226": 6,
  "08230": -4,
  "08231": 6,
  "08232": 6,
  "08234": 6,
  "08240": 6,
  "08241": 6,
  "08242": -4,
  "08243": -3,
  "08244": 6,
  "08245": -4,
  "08246": -4,
  "08247": 7,
  "08248": 0,
  "08250": -4,
  "08251": -4,
  "08252": -4,
  "08260": -4,
  "08270": -4,
  "08302": 6,
  "08310": 7,
  "08311": 6,
  "08312": 6,
  "08313": 20,
  "08314": 7,
  "08315": 7,
  "08316": 7,
  "08317": 8,
  "08318": 7,
  "08319": 6,
  "08320": 6,
  "08321": 7,
  "08322": 6,
  "08323": 7,
  "08324": 7,
  "08326": 7,
  "08327": 7,
  "08328": 8,
  "08329": 8,
  "08330": 6,
  "08332": 7,
  "08340": 16,
  "08341": 8,
  "08342": 8,
  "08343": 8,
  "08344": 8,
  "08345": 7,
  "08346": 6,
  "08347": 8,
  "08348": 7,
  "08349": 7,
  "08350": 8,
  "08352": 8,
  "08353": 6,
  "08360": 7,
  "08361": 7,
  "08362": 8,
  "08401": 6,
  "08402": 6,
  "08403": 6,
  "08404": 6,
  "08406": 6,
  "08501": 11,
  "08502": 22,
  "08504": 22,
  "08505": 11,
  "08510": 22,
  "08511": 9,
  "08512": 11,
  "08514": 22,
  "08515": 11,
  "08518": 11,
  "08520": 11,
  "08525": 12,
  "08526": 11,
  "08527": 2,
  "08528": 11,
  "08530": 13,
  "08533": 11,
  "08534": 12,
  "08535": 22,
  "08536": 11,
  "08540": 11,
  "08542": 11,
  "08543": 22,
  "08550": 22,
  "08551": 15,
  "08553": 12,
  "08554": 11,
  "08555": 11,
  "08556": 13,
  "08557": 13,
  "08558": 22,
  "08559": 13,
  "08560": 11,
  "08561": 11,
  "08562": 9,
  "08601": 11,
  "08602": 11,
  "08603": 11,
  "08604": 11,
  "08605": 11,
  "08606": 11,
  "08607": 11,
  "08608": 11,
  "08609": 11,
  "08610": 11,
  "08611": 11,
  "08618": 11,
  "08619": 11,
  "08620": 11,
  "08625": 11,
  "08628": 11,
  "08629": 11,
  "08638": 11,
  "08640": 9,
  "08641": 9,
  "08648": 11,
  "08650": 11,
  "08690": 11,
  "08691": 11,
  "08701": 2,
  "08720": 14,
  "08721": 2,
  "08722": 2,
  "08723": 2,
  "08724": 2,
  "08730": 13,
  "08731": 2,
  "08732": 2,
  "08733": 2,
  "08734": 2,
  "08735": 2,
  "08736": 13,
  "08738": 13,
  "08739": 2,
  "08740": 2,
  "08741": 2,
  "08742": 2,
  "08750": 22,
  "08751": 2,
  "08752": 2,
  "08753": 2,
  "08754": 2,
  "08755": 2,
  "08756": 2,
  "08757": 2,
  "08758": 2,
  "08759": 1,
  "08801": 25,
  "08802": 16,
  "08803": 15,
  "08804": 3,
  "08805": 13,
  "08807": 14,
  "08808": 2,
  "08809": 15,
  "08810": 11,
  "08812": 13,
  "08816": 14,
  "08817": 13,
  "08818": 13,
  "08820": 14,
  "08821": 11,
  "08822": 13,
  "08823": 11,
  "08824": 11,
  "08825": 15,
  "08826": 4,
  "08827": 16,
  "08828": 11,
  "08829": 14,
  "08830": 12,
  "08831": 11,
  "08832": 13,
  "08833": 25,
  "08834": 15,
  "08835": 11,
  "08836": 16,
  "08837": 13,
  "08840": 13,
  "08844": 22,
  "08846": 13,
  "08848": 15,
  "08850": 13,
  "08852": 11,
  "08853": 15,
  "08854": 13,
  "08855": 13,
  "08857": 13,
  "08858": 25,
  "08859": 13,
  "08861": 13,
  "08862": 13,
  "08863": 13,
  "08865": 3,
  "08867": 25,
  "08868": 25,
  "08869": 11,
  "08870": 15,
  "08871": 13,
  "08872": 13,
  "08873": 13,
  "08875": 13,
  "08876": 11,
  "08879": 13,
  "08880": 13,
  "08882": 13,
  "08884": 11,
  "08885": 13,
  "08886": 3,
  "08887": 13,
  "08888": 15,
  "08889": 15,
  "08890": 11,
  "08899": 13,
  "08901": 13,
  "08902": 11,
  "08903": 13,
  "08904": 13,
  "08906": 13
};

// src/craftsman/costDataset/2024.1/historicalCostIndex.ts
var CRAFTSMAN_2024_HISTORICAL_COST_INDEX = {
  "1957": 13.02,
  "1958": 12.98,
  "1959": 12.43,
  "1960": 12.25,
  "1961": 12.02,
  "1962": 11.88,
  "1963": 11.66,
  "1964": 11.25,
  "1965": 11.01,
  "1966": 10.53,
  "1967": 10.02,
  "1968": 9.47,
  "1969": 9.12,
  "1970": 8.67,
  "1971": 7.47,
  "1972": 7.49,
  "1973": 6.91,
  "1974": 6.46,
  "1975": 6.07,
  "1976": 5.85,
  "1977": 5.43,
  "1978": 4.99,
  "1979": 4.57,
  "1980": 4.1,
  "1981": 3.92,
  "1982": 3.78,
  "1983": 3.61,
  "1984": 3.34,
  "1985": 3.24,
  "1986": 3.19,
  "1987": 3.13,
  "1988": 3.1,
  "1989": 3.04,
  "1990": 2.82,
  "1991": 2.67,
  "1992": 2.66,
  "1993": 2.62,
  "1994": 2.52,
  "1995": 2.37,
  "1996": 2.32,
  "1997": 2.27,
  "1998": 2.17,
  "1999": 2.15,
  "2000": 2.07,
  "2001": 1.99,
  "2002": 1.97,
  "2003": 1.95,
  "2004": 1.9,
  "2005": 1.71,
  "2006": 1.53,
  "2007": 1.42,
  "2008": 1.36,
  "2009": 1.36,
  "2010": 1.35,
  "2011": 1.37,
  "2012": 1.32,
  "2013": 1.25,
  "2014": 1.23,
  "2015": 1.22,
  "2016": 1.23,
  "2017": 1.24,
  "2018": 1.13,
  "2019": 1.08,
  "2020": 1.1,
  "2021": 1.09,
  "2022": 1.01,
  "2023": 0.92,
  "2024": 1
};

// src/craftsman/costDataset/2024.1/index.ts
var CRAFTSMAN_COST_DATASET_2024 = {
  version: "2024.1",
  zipMultiplier: CRAFTSMAN_ZIP_MODIFIER_2024,
  costData: {
    singleFamily: {
      sixCorners: {
        variable: [
          381.47,
          371.79,
          362.12,
          352.44,
          342.76,
          333.08,
          313.21,
          293.35,
          273.49,
          253.62,
          233.76,
          221.61,
          209.45,
          197.3,
          185.14,
          172.99,
          168.79,
          164.59,
          160.39,
          156.2,
          152,
          147.75,
          143.51,
          139.26,
          135.02,
          130.77,
          127.35,
          123.93,
          120.5,
          117.08,
          113.66,
          111.52,
          109.38,
          107.24,
          105.11,
          102.97,
          101.04,
          99.12,
          97.2,
          95.27,
          93.35,
          91.04,
          88.73,
          86.42,
          84.11,
          81.8,
          80.43,
          79.07,
          77.7,
          76.34,
          74.97
        ],
        fixed: [
          148034,
          143566,
          139098,
          134631,
          130163,
          125696,
          116961,
          108227,
          99493,
          90759,
          82025,
          76479,
          70932,
          65386,
          59839,
          54293,
          52431,
          50569,
          48707,
          46845,
          44983,
          43414,
          41845,
          40276,
          38707,
          37138,
          35881,
          34623,
          33366,
          32109,
          30851,
          30130,
          29409,
          28688,
          27967,
          27246,
          26623,
          25999,
          25376,
          24753,
          24129,
          23003,
          21876,
          20749,
          19622,
          18495,
          17809,
          17122,
          16435,
          15748,
          15061
        ]
      }
    },
    multiFamily: {
      twoOrThreeUnits: {
        variable: [
          173.56,
          169.45,
          165.35,
          161.24,
          157.14,
          153.03,
          149.35,
          145.68,
          142,
          138.32,
          134.65,
          132.47,
          130.29,
          128.11,
          125.94,
          123.76,
          121.75,
          119.74,
          117.73,
          115.72,
          113.72,
          112.07,
          110.42,
          108.77,
          107.12,
          105.47,
          103.95,
          102.43,
          100.9,
          99.38,
          97.86,
          96.46,
          95.06,
          93.66,
          92.27,
          90.87,
          89.56,
          88.26,
          86.96,
          85.66,
          84.35,
          84.35,
          84.35,
          84.35,
          84.35,
          84.35,
          84.35,
          84.35,
          84.35,
          84.35,
          84.35
        ],
        fixed: [
          12518,
          12114,
          11709,
          11305,
          10900,
          10496,
          10182,
          9868,
          9555,
          9241,
          8928,
          8737,
          8547,
          8356,
          8166,
          7975,
          7830,
          7684,
          7539,
          7393,
          7247,
          6994,
          6741,
          6488,
          6235,
          5981,
          5747,
          5513,
          5280,
          5046,
          4812,
          4591,
          4369,
          4148,
          3927,
          3706,
          3512,
          3318,
          3124,
          2929,
          2735
        ]
      },
      fourToNineUnits: {
        variable: [157.42, 138.05, 120.81, 110.5, 101.1, 93.35, 86.24, 79.55, 73.51],
        fixed: [24513, 21475, 18785, 17210, 15715, 14498, 13373, 12417, 11412]
      }
    },
    manufactured: {
      variable: [
        136.04,
        134.15,
        132.26,
        130.37,
        128.47,
        126.58,
        123.78,
        120.97,
        118.17,
        115.36,
        112.56,
        110.18,
        107.8,
        105.42,
        103.04,
        100.67,
        98.16,
        95.65,
        93.15,
        90.64,
        88.13,
        86.69,
        85.25,
        83.81,
        82.37,
        80.93,
        79.5,
        78.08,
        76.65,
        75.23,
        73.81,
        72.66,
        71.5,
        70.35,
        69.2,
        68.05,
        67.02,
        66,
        64.97,
        63.95,
        62.92
      ],
      fixed: [
        11614,
        11623,
        11633,
        11642,
        11652,
        11662,
        12117,
        12571,
        13025,
        13480,
        13934,
        14178,
        14423,
        14667,
        14911,
        15155,
        15630,
        16105,
        16580,
        17055,
        17530,
        17456,
        17382,
        17308,
        17234,
        17160,
        17055,
        16950,
        16845,
        16740,
        16636,
        16547,
        16458,
        16370,
        16281,
        16193,
        16008,
        15823,
        15638,
        15454,
        15269
      ]
    },
    bathrooms: {
      fullBaths: [
        17321,
        17086,
        16851,
        16616,
        16381,
        16146,
        15911,
        15676,
        15441,
        15206,
        14971,
        14811,
        14650,
        14490,
        14329,
        14169,
        14008,
        13848,
        13687,
        13527,
        13366,
        13125,
        12883,
        12642,
        12400,
        12159,
        11917,
        11676,
        11434,
        11193,
        10951,
        10793,
        10636,
        10478,
        10321,
        10163,
        10005,
        9848,
        9690,
        9533,
        9375,
        9375,
        9375,
        9375,
        9375,
        9375,
        9375,
        9375,
        9375,
        9375,
        9375
      ],
      halfBaths: [
        9378,
        9195,
        9012,
        8829,
        8646,
        8463,
        8279,
        8096,
        7913,
        7730,
        7547,
        7431,
        7314,
        7198,
        7081,
        6965,
        6849,
        6732,
        6616,
        6499,
        6383,
        6277,
        6170,
        6064,
        5957,
        5851,
        5745,
        5638,
        5532,
        5425,
        5319,
        5237,
        5155,
        5074,
        4992,
        4910,
        4828,
        4746,
        4665,
        4583,
        4501,
        4501,
        4501,
        4501,
        4501,
        4501,
        4501,
        4501,
        4501,
        4501,
        4501
      ]
    },
    basement: {
      totalArea: {
        variable: [
          49,
          48.42,
          47.84,
          47.26,
          46.68,
          46.1,
          45.52,
          44.94,
          44.36,
          43.78,
          43.2,
          42.62,
          42.04,
          41.46,
          40.88,
          40.3,
          39.72,
          39.14,
          38.56,
          37.98,
          37.4,
          36.82,
          36.24,
          35.66,
          35.08,
          34.5,
          33.92,
          33.34,
          32.76,
          32.18,
          31.6,
          31.02,
          30.44,
          29.86,
          29.28,
          28.7,
          28.12,
          27.54,
          26.96,
          26.38,
          25.8,
          25.22,
          24.64,
          24.06,
          23.48,
          22.9,
          22.32,
          21.74,
          21.16,
          20.58,
          20
        ]
      },
      finishedArea: {
        variable: [
          108.6,
          105.8,
          103,
          100.2,
          97.4,
          94.59,
          88.84,
          83.09,
          77.34,
          71.59,
          65.84,
          62.33,
          58.81,
          55.29,
          51.77,
          48.25,
          47.04,
          45.82,
          44.61,
          43.39,
          42.18,
          40.95,
          39.72,
          38.49,
          37.26,
          36.03,
          35.04,
          34.05,
          33.06,
          32.07,
          31.08,
          30.46,
          29.84,
          29.22,
          28.6,
          27.98,
          27.43,
          26.87,
          26.31,
          25.76,
          25.2,
          24.53,
          23.86,
          23.19,
          22.53,
          21.86,
          21.46,
          21.07,
          20.67,
          20.28,
          19.88
        ]
      }
    },
    attic: {
      variable: [
        125.06,
        121.83,
        118.61,
        115.38,
        112.16,
        108.93,
        102.31,
        95.69,
        89.07,
        82.44,
        75.82,
        71.77,
        67.72,
        63.67,
        59.62,
        55.57,
        54.17,
        52.77,
        51.37,
        49.97,
        48.57,
        47.15,
        45.74,
        44.32,
        42.91,
        41.49,
        40.35,
        39.21,
        38.07,
        36.93,
        35.79,
        35.08,
        34.36,
        33.65,
        32.94,
        32.23,
        31.58,
        30.94,
        30.3,
        29.66,
        29.02,
        28.25,
        27.48,
        26.71,
        25.94,
        25.17,
        24.71,
        24.26,
        23.8,
        23.35,
        22.89
      ]
    },
    garage: {
      detached: {
        variable: [
          117.28,
          114.2,
          111.12,
          108.04,
          104.96,
          101.88,
          96.84,
          91.81,
          86.77,
          81.73,
          76.69,
          73.76,
          70.83,
          67.9,
          64.97,
          62.04,
          59.95,
          57.85,
          55.76,
          53.67,
          51.58,
          50.46,
          49.33,
          48.21,
          47.09,
          45.97,
          44.88,
          43.79,
          42.69,
          41.6,
          40.51,
          39.93,
          39.35,
          38.78,
          38.2,
          37.62,
          36.74,
          35.86,
          34.98,
          34.1,
          33.22,
          32.37,
          31.51,
          30.65,
          29.79,
          28.94,
          28.28,
          27.63,
          26.98,
          26.32,
          25.67
        ],
        fixed: [
          19854,
          19284,
          18714,
          18144,
          17574,
          17004,
          16125,
          15246,
          14366,
          13487,
          12608,
          12119,
          11630,
          11140,
          10651,
          10162,
          9805,
          9448,
          9091,
          8734,
          8377,
          8179,
          7981,
          7784,
          7586,
          7388,
          7216,
          7043,
          6871,
          6698,
          6525,
          6412,
          6300,
          6187,
          6074,
          5961,
          5955,
          5948,
          5942,
          5935,
          5929,
          5717,
          5506,
          5295,
          5084,
          4873,
          4733,
          4594,
          4454,
          4314,
          4175
        ]
      },
      attached: {
        // TODO: This is the same as detached - Need to get attached garage data from Craftsman
        variable: [
          117.28,
          114.2,
          111.12,
          108.04,
          104.96,
          101.88,
          96.84,
          91.81,
          86.77,
          81.73,
          76.69,
          73.76,
          70.83,
          67.9,
          64.97,
          62.04,
          59.95,
          57.85,
          55.76,
          53.67,
          51.58,
          50.46,
          49.33,
          48.21,
          47.09,
          45.97,
          44.88,
          43.79,
          42.69,
          41.6,
          40.51,
          39.93,
          39.35,
          38.78,
          38.2,
          37.62,
          36.74,
          35.86,
          34.98,
          34.1,
          33.22,
          32.37,
          31.51,
          30.65,
          29.79,
          28.94,
          28.28,
          27.63,
          26.98,
          26.32,
          25.67
        ],
        fixed: [
          19854,
          19284,
          18714,
          18144,
          17574,
          17004,
          16125,
          15246,
          14366,
          13487,
          12608,
          12119,
          11630,
          11140,
          10651,
          10162,
          9805,
          9448,
          9091,
          8734,
          8377,
          8179,
          7981,
          7784,
          7586,
          7388,
          7216,
          7043,
          6871,
          6698,
          6525,
          6412,
          6300,
          6187,
          6074,
          5961,
          5955,
          5948,
          5942,
          5935,
          5929,
          5717,
          5506,
          5295,
          5084,
          4873,
          4733,
          4594,
          4454,
          4314,
          4175
        ]
      }
    },
    carport: {
      variable: [
        60.19,
        58.61,
        57.03,
        55.45,
        53.87,
        52.29,
        49.7,
        47.11,
        44.53,
        41.94,
        39.36,
        37.85,
        36.35,
        34.85,
        33.34,
        31.84,
        30.76,
        29.69,
        28.62,
        27.54,
        26.47,
        25.89,
        25.32,
        24.74,
        24.17,
        23.59,
        23.03,
        22.47,
        21.91,
        21.35,
        20.79,
        20.49,
        20.2,
        19.9,
        19.6,
        19.31,
        18.86,
        18.4,
        17.95,
        17.5,
        17.05,
        16.61,
        16.17,
        15.73,
        15.29,
        14.85,
        14.51,
        14.18,
        13.84,
        13.51,
        13.17
      ]
    },
    heating: 5.97,
    heatingAndCooling: 7.01,
    pool: {
      fixed: [36950, 23094, 17321],
      variable240To480: [92.93, 58.08, 43.56],
      variableOver480: [65.05, 40.66, 30.49]
    },
    spa: {
      fixed: [19399, 12124, 9093],
      variableOver70: [48.79, 30.49, 22.87]
    },
    shed: {
      variable: [24.18, 18.93, 12.54],
      fixed: [1222, 1002, 738]
    },
    workshop: {
      variable: [30.86, 24.89, 19.74],
      fixed: [21556, 16321, 12738]
    },
    barn: {
      variable: [33.79, 25.37, 16.92],
      fixed: [34370, 22914, 11545]
    },
    patio: {
      uncovered: {
        variable: [
          38.1,
          37.51,
          36.91,
          36.32,
          35.72,
          35.13,
          34.53,
          33.94,
          33.34,
          32.75,
          32.15,
          31.56,
          30.96,
          30.37,
          29.78,
          29.18,
          28.59,
          27.99,
          27.4,
          26.8,
          26.21,
          25.61,
          25.02,
          24.42,
          23.83,
          23.24,
          22.64,
          22.05,
          21.45,
          20.86,
          20.26,
          19.67,
          19.07,
          18.48,
          17.88,
          17.29,
          16.69,
          16.1,
          15.51,
          14.91,
          14.32,
          13.72,
          13.13,
          12.53,
          11.94,
          11.34,
          10.75,
          10.15,
          9.56,
          8.96,
          8.37
        ]
      },
      covered: {
        variable: [
          58.59,
          57.78,
          56.97,
          56.16,
          55.35,
          54.54,
          53.73,
          52.92,
          52.11,
          51.3,
          50.49,
          49.68,
          48.87,
          48.05,
          47.24,
          46.43,
          45.62,
          44.81,
          44,
          43.19,
          42.38,
          41.57,
          40.76,
          39.95,
          39.14,
          38.33,
          37.52,
          36.71,
          35.9,
          35.09,
          34.28,
          33.47,
          32.66,
          31.85,
          31.04,
          30.23,
          29.42,
          28.61,
          27.79,
          26.98,
          26.17,
          25.36,
          24.55,
          23.74,
          22.93,
          22.12,
          21.31,
          20.5,
          19.69,
          18.88,
          18.07
        ]
      },
      screen: {
        variable: [
          120,
          118.98,
          117.96,
          116.94,
          115.92,
          114.9,
          113.88,
          112.86,
          111.84,
          110.82,
          109.8,
          108.78,
          107.76,
          106.74,
          105.72,
          104.7,
          103.68,
          102.66,
          101.64,
          100.62,
          99.6,
          98.58,
          97.56,
          96.54,
          95.52,
          94.5,
          93.48,
          92.46,
          91.44,
          90.42,
          89.4,
          88.38,
          87.36,
          86.34,
          85.32,
          84.3,
          83.28,
          82.26,
          81.24,
          80.22,
          79.2,
          78.18,
          77.16,
          76.14,
          75.12,
          74.1,
          73.08,
          72.06,
          71.04,
          70.02,
          69
        ]
      }
    },
    // TODO: document this better than just this link: https://docs.google.com/spreadsheets/d/1fcAyR4_DvEej8TOOs9XFybuEFRSmNhNQbzfuq36Ys8g
    deck: {
      uncovered: {
        variable: [
          44.2,
          43.82,
          43.44,
          43.07,
          42.69,
          42.31,
          41.93,
          41.55,
          41.18,
          40.8,
          40.42,
          40.04,
          39.66,
          39.29,
          38.91,
          38.53,
          38.15,
          37.77,
          37.4,
          37.02,
          36.64,
          36.26,
          35.88,
          35.51,
          35.13,
          34.75,
          34.37,
          33.99,
          33.62,
          33.24,
          32.86,
          32.48,
          32.1,
          31.73,
          31.35,
          30.97,
          30.59,
          30.21,
          29.84,
          29.46,
          29.08,
          28.7,
          28.32,
          27.95,
          27.57,
          27.19,
          26.81,
          26.43,
          26.06,
          25.68,
          25.3
        ]
      },
      covered: {
        variable: [
          64.69,
          64.1,
          63.5,
          62.91,
          62.31,
          61.72,
          61.13,
          60.53,
          59.94,
          59.35,
          58.75,
          58.16,
          57.56,
          56.97,
          56.38,
          55.78,
          55.19,
          54.6,
          54,
          53.41,
          52.81,
          52.22,
          51.63,
          51.03,
          50.44,
          49.85,
          49.25,
          48.66,
          48.06,
          47.47,
          46.88,
          46.28,
          45.69,
          45.09,
          44.5,
          43.91,
          43.31,
          42.72,
          42.13,
          41.53,
          40.94,
          40.34,
          39.75,
          39.16,
          38.56,
          37.97,
          37.38,
          36.78,
          36.19,
          35.59,
          35
        ]
      },
      screen: {
        variable: [
          120,
          118.98,
          117.96,
          116.94,
          115.92,
          114.9,
          113.88,
          112.86,
          111.84,
          110.82,
          109.8,
          108.78,
          107.76,
          106.74,
          105.72,
          104.7,
          103.68,
          102.66,
          101.64,
          100.62,
          99.6,
          98.58,
          97.56,
          96.54,
          95.52,
          94.5,
          93.48,
          92.46,
          91.44,
          90.42,
          89.4,
          88.38,
          87.36,
          86.34,
          85.32,
          84.3,
          83.28,
          82.26,
          81.24,
          80.22,
          79.2,
          78.18,
          77.16,
          76.14,
          75.12,
          74.1,
          73.08,
          72.06,
          71.04,
          70.02,
          69
        ]
      }
    },
    porch: {
      uncovered: {
        variable: [
          44.2,
          43.82,
          43.44,
          43.07,
          42.69,
          42.31,
          41.93,
          41.55,
          41.18,
          40.8,
          40.42,
          40.04,
          39.66,
          39.29,
          38.91,
          38.53,
          38.15,
          37.77,
          37.4,
          37.02,
          36.64,
          36.26,
          35.88,
          35.51,
          35.13,
          34.75,
          34.37,
          33.99,
          33.62,
          33.24,
          32.86,
          32.48,
          32.1,
          31.73,
          31.35,
          30.97,
          30.59,
          30.21,
          29.84,
          29.46,
          29.08,
          28.7,
          28.32,
          27.95,
          27.57,
          27.19,
          26.81,
          26.43,
          26.06,
          25.68,
          25.3
        ]
      },
      covered: {
        variable: [
          64.69,
          64.1,
          63.5,
          62.91,
          62.31,
          61.72,
          61.13,
          60.53,
          59.94,
          59.35,
          58.75,
          58.16,
          57.56,
          56.97,
          56.38,
          55.78,
          55.19,
          54.6,
          54,
          53.41,
          52.81,
          52.22,
          51.63,
          51.03,
          50.44,
          49.85,
          49.25,
          48.66,
          48.06,
          47.47,
          46.88,
          46.28,
          45.69,
          45.09,
          44.5,
          43.91,
          43.31,
          42.72,
          42.13,
          41.53,
          40.94,
          40.34,
          39.75,
          39.16,
          38.56,
          37.97,
          37.38,
          36.78,
          36.19,
          35.59,
          35
        ]
      },
      screen: {
        variable: [
          120,
          118.98,
          117.96,
          116.94,
          115.92,
          114.9,
          113.88,
          112.86,
          111.84,
          110.82,
          109.8,
          108.78,
          107.76,
          106.74,
          105.72,
          104.7,
          103.68,
          102.66,
          101.64,
          100.62,
          99.6,
          98.58,
          97.56,
          96.54,
          95.52,
          94.5,
          93.48,
          92.46,
          91.44,
          90.42,
          89.4,
          88.38,
          87.36,
          86.34,
          85.32,
          84.3,
          83.28,
          82.26,
          81.24,
          80.22,
          79.2,
          78.18,
          77.16,
          76.14,
          75.12,
          74.1,
          73.08,
          72.06,
          71.04,
          70.02,
          69
        ]
      }
    },
    fireplace: {
      freestanding: 2498,
      zeroClearance: 3320,
      masonry: 12815
    },
    manufacturedBaths: {
      fullBaths: [3375],
      halfBaths: [1795]
    },
    foundation: {
      slab: {
        variable: 16.5
      }
    }
  },
  historicalIndex: CRAFTSMAN_2024_HISTORICAL_COST_INDEX
};

// src/craftsman/costDataset/2025.1/areaModifiers.ts
var CRAFTSMAN_ZIP_MODIFIER_2025 = {
  "01001": 6,
  "01002": 19,
  "01003": 19,
  "01004": 19,
  "01005": 10,
  "01007": 10,
  "01008": 7,
  "01009": 6,
  "01010": 6,
  "01011": 2,
  "01012": 11,
  "01013": 6,
  "01014": 6,
  "01020": 6,
  "01021": 6,
  "01022": 6,
  "01026": 3,
  "01027": 11,
  "01028": 6,
  "01029": 2,
  "01030": 7,
  "01031": 10,
  "01032": 11,
  "01033": 10,
  "01034": 7,
  "01035": 12,
  "01036": 6,
  "01037": 10,
  "01038": 19,
  "01039": 11,
  "01040": 6,
  "01041": 6,
  "01050": 11,
  "01053": 11,
  "01054": 19,
  "01056": 6,
  "01057": 6,
  "01059": 19,
  "01060": 11,
  "01061": 11,
  "01062": 11,
  "01066": 11,
  "01068": 10,
  "01069": 6,
  "01070": 2,
  "01071": 7,
  "01072": 11,
  "01073": 11,
  "01074": 10,
  "01075": 10,
  "01077": 7,
  "01079": 6,
  "01080": 6,
  "01081": 6,
  "01082": 6,
  "01083": 6,
  "01084": 11,
  "01085": 7,
  "01086": 7,
  "01088": 11,
  "01089": 6,
  "01090": 6,
  "01092": 6,
  "01093": 11,
  "01094": 10,
  "01095": 8,
  "01096": 11,
  "01097": 7,
  "01098": 11,
  "01101": 6,
  "01102": 6,
  "01103": 6,
  "01104": 6,
  "01105": 6,
  "01106": 15,
  "01107": 6,
  "01108": 6,
  "01109": 6,
  "01115": 6,
  "01116": 6,
  "01118": 6,
  "01119": 6,
  "01128": 6,
  "01129": 6,
  "01138": 6,
  "01139": 6,
  "01144": 6,
  "01151": 6,
  "01152": 6,
  "01201": 2,
  "01202": 2,
  "01203": 2,
  "01220": 1,
  "01222": 2,
  "01223": 2,
  "01224": 2,
  "01225": 2,
  "01226": 2,
  "01227": 2,
  "01229": 2,
  "01230": 2,
  "01235": 2,
  "01236": 2,
  "01237": 2,
  "01238": 2,
  "01240": 2,
  "01242": 2,
  "01243": 2,
  "01244": 3,
  "01245": 10,
  "01247": 1,
  "01252": 2,
  "01253": 2,
  "01254": 3,
  "01255": 2,
  "01256": 2,
  "01257": 2,
  "01258": 10,
  "01259": 2,
  "01260": 10,
  "01262": 10,
  "01264": 10,
  "01266": 3,
  "01267": 2,
  "01270": 2,
  "01301": 11,
  "01302": 11,
  "01330": 11,
  "01331": 10,
  "01337": 11,
  "01338": 11,
  "01339": 10,
  "01340": 11,
  "01341": 12,
  "01342": 11,
  "01343": 2,
  "01344": 10,
  "01346": 11,
  "01347": 10,
  "01349": 10,
  "01350": 9,
  "01351": 11,
  "01354": 11,
  "01355": 11,
  "01360": 11,
  "01364": 10,
  "01366": 12,
  "01367": 10,
  "01368": 10,
  "01370": 11,
  "01373": 11,
  "01375": 11,
  "01376": 11,
  "01378": 10,
  "01379": 10,
  "01380": 10,
  "01420": 10,
  "01430": 10,
  "01431": 10,
  "01432": 15,
  "01434": 15,
  "01436": 10,
  "01438": 10,
  "01440": 10,
  "01450": 27,
  "01451": 18,
  "01452": 10,
  "01453": 10,
  "01460": 16,
  "01462": 19,
  "01463": 7,
  "01464": 10,
  "01467": 22,
  "01468": 10,
  "01469": 19,
  "01472": 10,
  "01473": 10,
  "01474": 19,
  "01475": 10,
  "01477": 10,
  "01501": 10,
  "01503": 19,
  "01504": 7,
  "01505": 11,
  "01506": 10,
  "01507": 10,
  "01508": 10,
  "01509": 10,
  "01510": 10,
  "01515": 10,
  "01516": 10,
  "01517": 11,
  "01518": 10,
  "01519": 11,
  "01520": 10,
  "01521": 6,
  "01522": 10,
  "01523": 10,
  "01524": 10,
  "01525": 10,
  "01526": 10,
  "01527": 10,
  "01529": 7,
  "01531": 10,
  "01532": 12,
  "01534": 10,
  "01535": 10,
  "01536": 10,
  "01537": 10,
  "01538": 7,
  "01540": 10,
  "01541": 11,
  "01542": 10,
  "01543": 10,
  "01545": 11,
  "01550": 10,
  "01560": 10,
  "01561": 10,
  "01562": 10,
  "01564": 11,
  "01566": 10,
  "01568": 19,
  "01569": 7,
  "01570": 10,
  "01571": 10,
  "01581": 19,
  "01583": 10,
  "01585": 10,
  "01586": 10,
  "01588": 10,
  "01590": 11,
  "01601": 11,
  "01602": 10,
  "01603": 10,
  "01604": 10,
  "01605": 10,
  "01606": 10,
  "01607": 10,
  "01608": 10,
  "01609": 11,
  "01610": 10,
  "01611": 10,
  "01612": 11,
  "01613": 10,
  "01614": 10,
  "01615": 11,
  "01655": 10,
  "01701": 16,
  "01702": 16,
  "01703": 16,
  "01704": 16,
  "01705": 16,
  "01718": 16,
  "01719": 18,
  "01720": 19,
  "01721": 19,
  "01730": 19,
  "01731": 19,
  "01740": 13,
  "01741": 27,
  "01742": 19,
  "01745": 16,
  "01746": 20,
  "01747": 7,
  "01748": 21,
  "01749": 11,
  "01752": 11,
  "01754": 16,
  "01756": 9,
  "01757": 18,
  "01760": 19,
  "01770": 21,
  "01772": 21,
  "01773": 20,
  "01775": 18,
  "01776": 19,
  "01778": 19,
  "01784": 21,
  "01801": 16,
  "01803": 16,
  "01810": 21,
  "01821": 16,
  "01822": 16,
  "01824": 15,
  "01826": 15,
  "01827": 18,
  "01830": 11,
  "01831": 11,
  "01832": 11,
  "01833": 11,
  "01834": 11,
  "01835": 11,
  "01840": 11,
  "01841": 11,
  "01842": 11,
  "01843": 11,
  "01844": 11,
  "01845": 13,
  "01850": 15,
  "01851": 15,
  "01852": 15,
  "01853": 15,
  "01854": 15,
  "01860": 11,
  "01862": 16,
  "01863": 15,
  "01864": 11,
  "01865": 16,
  "01866": 16,
  "01867": 16,
  "01876": 16,
  "01879": 16,
  "01880": 11,
  "01885": 13,
  "01886": 18,
  "01887": 16,
  "01888": 16,
  "01890": 19,
  "01901": 47,
  "01902": 47,
  "01903": 47,
  "01904": 11,
  "01905": 47,
  "01906": 47,
  "01907": 11,
  "01908": 49,
  "01913": 11,
  "01915": 11,
  "01921": 21,
  "01922": 13,
  "01923": 11,
  "01929": 11,
  "01930": 11,
  "01931": 11,
  "01936": 14,
  "01937": 13,
  "01938": 11,
  "01940": 13,
  "01944": 23,
  "01945": 15,
  "01949": 13,
  "01950": 11,
  "01951": 12,
  "01952": 10,
  "01960": 11,
  "01961": 11,
  "01965": 11,
  "01966": 12,
  "01969": 13,
  "01970": 11,
  "01971": 11,
  "01982": 14,
  "01983": 15,
  "01984": 22,
  "01985": 15,
  "02018": 19,
  "02019": 7,
  "02020": 13,
  "02021": 19,
  "02025": 51,
  "02026": 19,
  "02027": 19,
  "02030": 30,
  "02031": 19,
  "02032": 19,
  "02035": 19,
  "02038": 18,
  "02040": 16,
  "02041": 13,
  "02043": 58,
  "02045": 51,
  "02047": 13,
  "02048": 19,
  "02050": 13,
  "02051": 13,
  "02052": 21,
  "02053": 20,
  "02054": 18,
  "02055": 16,
  "02056": 26,
  "02059": 23,
  "02060": 19,
  "02061": 23,
  "02062": 19,
  "02065": 13,
  "02066": 16,
  "02067": 21,
  "02070": 20,
  "02071": 27,
  "02072": 19,
  "02081": 19,
  "02090": 21,
  "02093": 20,
  "02108": 50,
  "02109": 48,
  "02110": 58,
  "02111": 50,
  "02112": 58,
  "02113": 48,
  "02114": 50,
  "02115": 50,
  "02116": 58,
  "02117": 50,
  "02118": 50,
  "02119": 47,
  "02120": 48,
  "02121": 47,
  "02122": 47,
  "02123": 50,
  "02124": 47,
  "02125": 47,
  "02126": 47,
  "02127": 48,
  "02128": 47,
  "02129": 48,
  "02130": 48,
  "02131": 48,
  "02132": 19,
  "02133": 58,
  "02134": 48,
  "02135": 50,
  "02136": 19,
  "02137": 19,
  "02138": 50,
  "02139": 50,
  "02140": 50,
  "02141": 48,
  "02142": 48,
  "02143": 48,
  "02144": 50,
  "02145": 48,
  "02148": 47,
  "02149": 47,
  "02150": 47,
  "02151": 47,
  "02152": 48,
  "02153": 48,
  "02155": 48,
  "02156": 48,
  "02163": 50,
  "02169": 47,
  "02170": 47,
  "02171": 47,
  "02176": 47,
  "02180": 16,
  "02184": 19,
  "02185": 19,
  "02186": 21,
  "02187": 21,
  "02188": 19,
  "02189": 47,
  "02190": 19,
  "02191": 47,
  "02196": 50,
  "02199": 58,
  "02203": 50,
  "02205": 50,
  "02210": 50,
  "02215": 47,
  "02222": 50,
  "02228": 58,
  "02238": 50,
  "02269": 47,
  "02283": 50,
  "02284": 50,
  "02298": 58,
  "02301": 18,
  "02302": 18,
  "02303": 18,
  "02304": 18,
  "02305": 18,
  "02322": 18,
  "02324": 13,
  "02327": 13,
  "02330": 12,
  "02331": 23,
  "02332": 23,
  "02333": 13,
  "02334": 19,
  "02337": 13,
  "02338": 12,
  "02339": 13,
  "02341": 13,
  "02343": 18,
  "02345": 13,
  "02346": 12,
  "02347": 9,
  "02350": 12,
  "02351": 13,
  "02355": 12,
  "02356": 19,
  "02358": 13,
  "02359": 13,
  "02360": 13,
  "02361": 13,
  "02362": 13,
  "02364": 13,
  "02366": 12,
  "02367": 13,
  "02368": 18,
  "02370": 12,
  "02375": 19,
  "02379": 13,
  "02381": 13,
  "02382": 12,
  "02420": 19,
  "02421": 19,
  "02445": 58,
  "02446": 50,
  "02447": 50,
  "02451": 16,
  "02452": 18,
  "02453": 16,
  "02454": 16,
  "02455": 58,
  "02456": 50,
  "02457": 30,
  "02458": 50,
  "02459": 50,
  "02460": 50,
  "02461": 50,
  "02462": 19,
  "02464": 49,
  "02465": 19,
  "02466": 19,
  "02467": 58,
  "02468": 51,
  "02471": 49,
  "02472": 49,
  "02474": 19,
  "02475": 19,
  "02476": 19,
  "02478": 50,
  "02479": 50,
  "02481": 30,
  "02482": 21,
  "02492": 21,
  "02493": 27,
  "02494": 21,
  "02495": 50,
  "02532": 5,
  "02534": 5,
  "02535": 20,
  "02536": 10,
  "02537": 5,
  "02538": 12,
  "02539": 13,
  "02540": 10,
  "02541": 10,
  "02542": 5,
  "02543": 12,
  "02552": 20,
  "02553": 5,
  "02554": 21,
  "02556": 10,
  "02557": 13,
  "02558": 12,
  "02559": 5,
  "02561": 5,
  "02562": 5,
  "02563": 5,
  "02564": 21,
  "02565": 10,
  "02568": 13,
  "02571": 12,
  "02573": 13,
  "02574": 10,
  "02575": 13,
  "02576": 12,
  "02584": 21,
  "02601": 5,
  "02630": 6,
  "02631": 5,
  "02632": 5,
  "02633": 5,
  "02634": 5,
  "02635": 5,
  "02636": 16,
  "02637": 6,
  "02638": 5,
  "02639": 5,
  "02641": 5,
  "02642": 5,
  "02643": 8,
  "02644": 5,
  "02645": 5,
  "02646": 5,
  "02647": 16,
  "02648": 5,
  "02649": 5,
  "02650": 8,
  "02651": 5,
  "02652": 5,
  "02653": 8,
  "02655": 5,
  "02657": 8,
  "02659": 5,
  "02660": 5,
  "02661": 8,
  "02662": 8,
  "02663": 5,
  "02664": 5,
  "02666": 8,
  "02667": 5,
  "02668": 6,
  "02669": 8,
  "02670": 5,
  "02671": 5,
  "02672": 16,
  "02673": 5,
  "02675": 5,
  "02702": 9,
  "02703": 9,
  "02712": 9,
  "02713": 12,
  "02714": 9,
  "02715": 9,
  "02717": 9,
  "02718": 9,
  "02719": 9,
  "02720": 9,
  "02721": 9,
  "02722": 9,
  "02723": 9,
  "02724": 9,
  "02725": 9,
  "02726": 9,
  "02738": 9,
  "02739": 9,
  "02740": 9,
  "02741": 9,
  "02742": 9,
  "02743": 9,
  "02744": 9,
  "02745": 9,
  "02746": 9,
  "02747": 9,
  "02748": 9,
  "02760": 19,
  "02761": 19,
  "02762": 19,
  "02763": 9,
  "02764": 9,
  "02766": 9,
  "02767": 9,
  "02768": 9,
  "02769": 17,
  "02770": 9,
  "02771": 7,
  "02777": 9,
  "02779": 9,
  "02780": 9,
  "02790": 9,
  "02791": 9,
  "02801": 11,
  "02802": 7,
  "02804": 6,
  "02806": 2,
  "02807": 9,
  "02808": 5,
  "02809": 2,
  "02812": 6,
  "02813": 5,
  "02814": 7,
  "02815": 2,
  "02816": 2,
  "02817": 2,
  "02818": 3,
  "02822": 6,
  "02823": 2,
  "02824": 7,
  "02825": 2,
  "02826": 7,
  "02827": 2,
  "02828": 7,
  "02829": 7,
  "02830": 7,
  "02831": 2,
  "02832": 6,
  "02833": 6,
  "02835": 10,
  "02836": 6,
  "02837": 11,
  "02838": 7,
  "02839": 7,
  "02840": 2,
  "02841": 2,
  "02842": 2,
  "02852": 2,
  "02854": 6,
  "02857": 9,
  "02858": 7,
  "02859": 7,
  "02860": 7,
  "02861": 7,
  "02862": 7,
  "02863": 7,
  "02864": 7,
  "02865": 7,
  "02871": 2,
  "02872": 2,
  "02873": 6,
  "02874": 6,
  "02875": 6,
  "02876": 7,
  "02877": 6,
  "02878": 2,
  "02879": 6,
  "02880": 6,
  "02881": 7,
  "02882": 6,
  "02883": 6,
  "02885": 9,
  "02886": 2,
  "02887": 2,
  "02888": 1,
  "02889": 1,
  "02891": 5,
  "02892": 6,
  "02893": 1,
  "02894": 5,
  "02895": 7,
  "02896": 7,
  "02898": 6,
  "02901": 7,
  "02903": 7,
  "02904": 7,
  "02905": 7,
  "02906": 16,
  "02907": 7,
  "02908": 7,
  "02909": 7,
  "02910": 7,
  "02911": 7,
  "02914": 7,
  "02915": 7,
  "02916": 7,
  "02917": 7,
  "02919": 7,
  "02920": 2,
  "02921": 2,
  "02940": 7,
  "03031": 7,
  "03032": 7,
  "03033": 7,
  "03034": 9,
  "03036": 10,
  "03037": 9,
  "03038": 9,
  "03040": 9,
  "03041": 9,
  "03042": 10,
  "03043": 7,
  "03044": 10,
  "03045": 7,
  "03046": 7,
  "03047": 7,
  "03048": 6,
  "03049": 11,
  "03051": 7,
  "03052": 7,
  "03053": 7,
  "03054": 7,
  "03055": 7,
  "03057": 7,
  "03060": 7,
  "03061": 7,
  "03062": 7,
  "03063": 7,
  "03064": 7,
  "03070": 7,
  "03071": 7,
  "03073": 9,
  "03076": 7,
  "03077": 9,
  "03079": 9,
  "03082": 7,
  "03084": 7,
  "03086": 7,
  "03087": 9,
  "03101": 7,
  "03102": 7,
  "03103": 7,
  "03104": 7,
  "03105": 7,
  "03106": 7,
  "03108": 7,
  "03109": 7,
  "03110": 15,
  "03215": -4,
  "03216": 5,
  "03217": 4,
  "03218": 4,
  "03220": 4,
  "03221": -6,
  "03222": 4,
  "03223": -4,
  "03224": 5,
  "03225": -1,
  "03226": 13,
  "03227": 4,
  "03229": 5,
  "03230": 5,
  "03231": 5,
  "03233": -5,
  "03234": 5,
  "03235": 5,
  "03237": 4,
  "03238": -4,
  "03240": -6,
  "03241": -4,
  "03242": 5,
  "03243": 5,
  "03244": 5,
  "03245": 13,
  "03246": 4,
  "03247": 4,
  "03249": 4,
  "03251": -4,
  "03252": 4,
  "03253": 5,
  "03254": 4,
  "03255": -6,
  "03256": 5,
  "03257": 3,
  "03258": 5,
  "03259": 4,
  "03260": 5,
  "03261": -1,
  "03262": -4,
  "03263": 4,
  "03264": -4,
  "03266": -4,
  "03268": 5,
  "03269": 5,
  "03272": -6,
  "03273": 5,
  "03274": -4,
  "03275": 5,
  "03276": 4,
  "03278": 5,
  "03279": -4,
  "03280": -6,
  "03281": 5,
  "03282": -4,
  "03284": -6,
  "03285": -4,
  "03287": 5,
  "03289": 4,
  "03290": 9,
  "03291": 0,
  "03293": -4,
  "03301": 5,
  "03302": 5,
  "03303": 5,
  "03304": 5,
  "03307": 5,
  "03431": 6,
  "03440": 7,
  "03441": 7,
  "03442": 7,
  "03443": 8,
  "03444": 15,
  "03445": 6,
  "03446": 7,
  "03447": 6,
  "03448": 6,
  "03449": 8,
  "03450": 7,
  "03451": 7,
  "03452": 7,
  "03455": 6,
  "03456": 7,
  "03457": 7,
  "03458": 7,
  "03461": 7,
  "03462": 7,
  "03464": 7,
  "03465": 6,
  "03466": 8,
  "03467": 7,
  "03468": 7,
  "03469": 7,
  "03470": 6,
  "03561": -4,
  "03570": 15,
  "03574": -4,
  "03575": 15,
  "03576": 15,
  "03579": 15,
  "03580": -4,
  "03581": 15,
  "03582": 15,
  "03583": 15,
  "03584": 15,
  "03585": -4,
  "03586": -4,
  "03588": 15,
  "03589": 15,
  "03590": 15,
  "03592": 15,
  "03593": 15,
  "03595": 15,
  "03597": 15,
  "03598": 15,
  "03601": -6,
  "03602": -6,
  "03603": -6,
  "03604": -6,
  "03605": -6,
  "03607": -6,
  "03608": 7,
  "03609": -6,
  "03740": -3,
  "03741": -3,
  "03743": -6,
  "03745": -6,
  "03746": -6,
  "03748": -6,
  "03749": -6,
  "03750": 5,
  "03751": -5,
  "03752": -6,
  "03753": -5,
  "03754": -6,
  "03755": 5,
  "03756": -6,
  "03765": -3,
  "03766": -6,
  "03768": -2,
  "03769": -2,
  "03770": -6,
  "03771": -4,
  "03773": -6,
  "03774": -3,
  "03777": -3,
  "03779": -3,
  "03780": -3,
  "03781": -6,
  "03782": -6,
  "03784": -6,
  "03785": -3,
  "03801": 1,
  "03802": 1,
  "03804": 1,
  "03805": 0,
  "03809": 5,
  "03810": 5,
  "03811": 9,
  "03812": -5,
  "03813": -4,
  "03814": -5,
  "03815": 0,
  "03816": 13,
  "03817": -5,
  "03818": -5,
  "03819": 9,
  "03820": 0,
  "03821": 0,
  "03823": 0,
  "03824": 1,
  "03825": 0,
  "03826": 9,
  "03827": 10,
  "03830": -5,
  "03832": -4,
  "03833": 10,
  "03835": -1,
  "03836": -4,
  "03837": 5,
  "03838": -4,
  "03839": -1,
  "03840": 10,
  "03841": 9,
  "03842": 10,
  "03843": 10,
  "03844": 10,
  "03845": -4,
  "03846": 4,
  "03847": -4,
  "03848": 9,
  "03849": -5,
  "03850": 5,
  "03851": -1,
  "03852": -1,
  "03853": 13,
  "03854": 12,
  "03855": 5,
  "03856": 10,
  "03857": 10,
  "03858": 9,
  "03859": 9,
  "03860": -5,
  "03861": 9,
  "03862": 10,
  "03864": -5,
  "03865": 9,
  "03866": -1,
  "03867": -1,
  "03868": -1,
  "03869": 0,
  "03870": 13,
  "03871": 13,
  "03872": -5,
  "03873": 9,
  "03874": 10,
  "03875": -5,
  "03878": -1,
  "03882": -5,
  "03883": -5,
  "03884": 0,
  "03885": 10,
  "03886": -5,
  "03887": -1,
  "03890": -5,
  "03894": 6,
  "03896": 6,
  "03897": 4,
  "03901": -1,
  "03902": 0,
  "03903": 1,
  "03904": 1,
  "03905": 1,
  "03906": -1,
  "03907": 1,
  "03908": 0,
  "03909": 1,
  "03910": 1,
  "03911": 1,
  "04001": -1,
  "04002": -1,
  "04003": 13,
  "04004": 4,
  "04005": 0,
  "04006": 0,
  "04007": 0,
  "04008": 3,
  "04009": -5,
  "04010": -5,
  "04011": 3,
  "04013": 4,
  "04014": 0,
  "04015": 3,
  "04016": -5,
  "04017": 4,
  "04019": 4,
  "04020": 0,
  "04021": 4,
  "04022": -5,
  "04024": 4,
  "04027": -1,
  "04028": -1,
  "04029": 4,
  "04030": 0,
  "04032": 4,
  "04037": -5,
  "04038": 4,
  "04039": 4,
  "04040": -5,
  "04041": 4,
  "04042": 0,
  "04043": 0,
  "04046": 0,
  "04047": 0,
  "04048": 0,
  "04049": 4,
  "04050": 13,
  "04051": -5,
  "04054": 0,
  "04055": 3,
  "04056": -5,
  "04057": -5,
  "04061": 0,
  "04062": 4,
  "04063": 0,
  "04064": 0,
  "04066": 4,
  "04068": 0,
  "04069": 11,
  "04070": 4,
  "04071": 4,
  "04072": 0,
  "04073": -1,
  "04074": 4,
  "04076": -1,
  "04077": 4,
  "04078": 4,
  "04079": 4,
  "04082": 4,
  "04083": -1,
  "04084": 4,
  "04085": 4,
  "04086": 3,
  "04087": -1,
  "04088": -5,
  "04090": 0,
  "04091": 4,
  "04092": 4,
  "04093": 4,
  "04094": 0,
  "04095": -5,
  "04096": 4,
  "04097": 4,
  "04098": 4,
  "04101": 4,
  "04102": 4,
  "04103": 4,
  "04104": 4,
  "04105": 13,
  "04106": 4,
  "04107": 4,
  "04108": 4,
  "04109": 4,
  "04110": 15,
  "04112": 4,
  "04116": 4,
  "04210": -1,
  "04211": -1,
  "04212": -1,
  "04216": -5,
  "04217": -5,
  "04219": -5,
  "04220": -1,
  "04221": -1,
  "04222": 11,
  "04223": -1,
  "04224": -5,
  "04225": -8,
  "04226": -5,
  "04227": -8,
  "04228": 0,
  "04230": -1,
  "04231": -5,
  "04234": -8,
  "04236": -1,
  "04237": -5,
  "04238": -1,
  "04239": 0,
  "04240": -1,
  "04241": -1,
  "04243": -1,
  "04250": -1,
  "04252": 3,
  "04253": -1,
  "04254": 0,
  "04255": -5,
  "04256": -1,
  "04257": -5,
  "04258": -1,
  "04259": -1,
  "04260": 3,
  "04261": -4,
  "04262": 0,
  "04263": -1,
  "04265": -1,
  "04266": -1,
  "04267": -5,
  "04268": -5,
  "04270": -1,
  "04271": -5,
  "04274": -1,
  "04275": -7,
  "04276": -5,
  "04280": -1,
  "04281": -5,
  "04282": -1,
  "04284": 0,
  "04285": -7,
  "04286": -5,
  "04287": 3,
  "04288": -1,
  "04289": -5,
  "04290": -5,
  "04291": -1,
  "04292": -5,
  "04294": -8,
  "04330": 0,
  "04332": 0,
  "04338": 0,
  "04341": 0,
  "04342": 3,
  "04343": 0,
  "04344": 0,
  "04345": 0,
  "04346": 0,
  "04347": 0,
  "04348": -7,
  "04349": 0,
  "04350": -1,
  "04351": 0,
  "04352": 0,
  "04353": -7,
  "04354": -8,
  "04355": 0,
  "04357": 3,
  "04358": 0,
  "04359": 0,
  "04360": 0,
  "04363": 0,
  "04364": 0,
  "04401": -2,
  "04402": -2,
  "04406": -8,
  "04408": -7,
  "04410": -2,
  "04411": -2,
  "04412": -7,
  "04413": -10,
  "04414": -8,
  "04415": -8,
  "04416": -8,
  "04417": -3,
  "04418": -3,
  "04419": -8,
  "04421": 1,
  "04422": -2,
  "04424": -10,
  "04426": -2,
  "04427": -2,
  "04428": -7,
  "04429": -7,
  "04430": -3,
  "04431": -7,
  "04434": -8,
  "04435": -3,
  "04438": -8,
  "04441": -7,
  "04442": -8,
  "04443": -8,
  "04444": -8,
  "04448": -3,
  "04449": -2,
  "04450": -2,
  "04451": -3,
  "04453": -3,
  "04454": -10,
  "04455": -3,
  "04456": -2,
  "04457": -3,
  "04459": -3,
  "04460": -3,
  "04461": -2,
  "04462": -8,
  "04463": -3,
  "04464": -8,
  "04468": -2,
  "04471": -9,
  "04472": -7,
  "04473": -2,
  "04474": -7,
  "04475": -3,
  "04476": -7,
  "04478": -7,
  "04479": 5,
  "04481": -2,
  "04485": -7,
  "04487": -3,
  "04488": -2,
  "04489": -2,
  "04490": -10,
  "04491": -10,
  "04492": -10,
  "04493": -3,
  "04495": -3,
  "04496": -8,
  "04497": -3,
  "04530": 3,
  "04535": -7,
  "04537": -7,
  "04538": -7,
  "04539": -7,
  "04541": 1,
  "04543": 1,
  "04544": 1,
  "04547": -8,
  "04548": 4,
  "04549": -7,
  "04551": -6,
  "04553": -6,
  "04554": 1,
  "04555": -7,
  "04556": -7,
  "04558": 1,
  "04562": 4,
  "04563": -8,
  "04564": -6,
  "04565": 4,
  "04568": 1,
  "04570": 13,
  "04571": -7,
  "04572": -6,
  "04573": 1,
  "04574": -8,
  "04575": -7,
  "04576": 13,
  "04578": -7,
  "04579": 3,
  "04605": -7,
  "04606": -10,
  "04607": -7,
  "04609": -7,
  "04611": -10,
  "04612": -7,
  "04613": -7,
  "04614": -7,
  "04616": -7,
  "04617": -7,
  "04619": -10,
  "04622": -10,
  "04623": -10,
  "04624": -7,
  "04625": -6,
  "04626": -10,
  "04627": -7,
  "04628": -10,
  "04629": -7,
  "04630": -10,
  "04631": -10,
  "04634": -7,
  "04635": -7,
  "04637": -10,
  "04640": -7,
  "04642": -8,
  "04643": -10,
  "04644": -7,
  "04645": -8,
  "04646": -7,
  "04648": -10,
  "04649": -10,
  "04650": -7,
  "04652": -10,
  "04653": -7,
  "04654": -10,
  "04655": -10,
  "04657": -10,
  "04658": -7,
  "04660": -7,
  "04662": 1,
  "04664": -7,
  "04666": -10,
  "04667": -10,
  "04668": -10,
  "04669": -7,
  "04671": -10,
  "04672": -7,
  "04673": -7,
  "04674": -7,
  "04675": -7,
  "04676": -7,
  "04677": -7,
  "04679": -7,
  "04680": -7,
  "04681": -8,
  "04683": -7,
  "04684": -7,
  "04685": -7,
  "04686": -10,
  "04691": -10,
  "04693": -7,
  "04694": -10,
  "04730": -9,
  "04732": -9,
  "04733": -2,
  "04734": -9,
  "04735": -9,
  "04736": -9,
  "04737": -9,
  "04738": -9,
  "04739": -8,
  "04740": -9,
  "04741": -9,
  "04742": -9,
  "04743": -9,
  "04744": -9,
  "04745": -9,
  "04746": -9,
  "04747": -9,
  "04750": -9,
  "04756": -9,
  "04757": -9,
  "04758": -9,
  "04760": -9,
  "04761": -9,
  "04762": -9,
  "04763": -9,
  "04764": -9,
  "04765": -9,
  "04766": -9,
  "04768": -8,
  "04769": -9,
  "04772": -8,
  "04773": -8,
  "04774": -9,
  "04775": -9,
  "04776": -3,
  "04777": -8,
  "04779": -8,
  "04780": -9,
  "04781": -9,
  "04783": -8,
  "04785": -9,
  "04786": -9,
  "04787": -9,
  "04841": -8,
  "04843": -8,
  "04846": -8,
  "04847": -8,
  "04848": -8,
  "04849": -8,
  "04850": -8,
  "04851": -8,
  "04852": -6,
  "04853": -8,
  "04854": -8,
  "04855": -8,
  "04856": -8,
  "04858": -8,
  "04859": -8,
  "04860": -6,
  "04861": -8,
  "04862": -8,
  "04863": -8,
  "04864": -8,
  "04865": -8,
  "04901": 0,
  "04903": 0,
  "04910": -8,
  "04911": -8,
  "04912": 5,
  "04915": -8,
  "04917": 0,
  "04918": 0,
  "04920": 5,
  "04921": -8,
  "04922": -8,
  "04923": 5,
  "04924": 0,
  "04925": 5,
  "04926": 0,
  "04927": 0,
  "04928": -2,
  "04929": -8,
  "04930": 5,
  "04932": -8,
  "04933": -8,
  "04935": 0,
  "04936": -7,
  "04937": 0,
  "04938": -8,
  "04939": -3,
  "04940": 0,
  "04941": -8,
  "04942": 5,
  "04943": 5,
  "04944": 0,
  "04945": 5,
  "04947": -7,
  "04949": -8,
  "04950": 5,
  "04951": -8,
  "04952": -8,
  "04953": -8,
  "04954": -8,
  "04955": 0,
  "04956": -8,
  "04957": 0,
  "04958": 5,
  "04961": 5,
  "04962": 0,
  "04963": 0,
  "04964": -7,
  "04965": -8,
  "04966": -8,
  "04967": -8,
  "04969": -8,
  "04970": -7,
  "04971": 5,
  "04972": -8,
  "04973": -8,
  "04974": -8,
  "04975": 0,
  "04976": 5,
  "04978": 0,
  "04979": 5,
  "04981": -8,
  "04982": -7,
  "04983": -8,
  "04984": -8,
  "04985": 5,
  "04986": -8,
  "04987": -8,
  "04988": -8,
  "04989": 0,
  "04992": -8,
  "05001": -2,
  "05030": -2,
  "05031": 5,
  "05032": -1,
  "05033": -3,
  "05034": -3,
  "05035": -3,
  "05036": -3,
  "05037": -3,
  "05038": -3,
  "05039": -3,
  "05040": -4,
  "05041": -3,
  "05042": -4,
  "05043": -4,
  "05045": -3,
  "05046": -4,
  "05047": -2,
  "05048": -2,
  "05049": -2,
  "05050": -5,
  "05051": -3,
  "05052": -2,
  "05053": 5,
  "05054": -3,
  "05055": 7,
  "05056": -3,
  "05058": -3,
  "05059": -3,
  "05060": -3,
  "05061": -3,
  "05062": -3,
  "05065": -3,
  "05067": -2,
  "05068": -3,
  "05069": -5,
  "05070": 5,
  "05071": 6,
  "05072": 5,
  "05073": -3,
  "05074": 5,
  "05075": -2,
  "05076": -4,
  "05077": -3,
  "05079": -4,
  "05081": -3,
  "05083": -4,
  "05084": -1,
  "05085": -3,
  "05086": -4,
  "05088": -2,
  "05089": -2,
  "05091": -3,
  "05101": -2,
  "05141": -2,
  "05142": -3,
  "05143": -3,
  "05144": -3,
  "05146": -3,
  "05148": -3,
  "05149": -3,
  "05150": -3,
  "05151": -3,
  "05152": -8,
  "05153": -3,
  "05154": -2,
  "05155": -3,
  "05156": -6,
  "05158": -2,
  "05159": -2,
  "05161": -3,
  "05201": -7,
  "05250": -7,
  "05251": -7,
  "05252": -8,
  "05253": -7,
  "05254": 1,
  "05255": -7,
  "05257": -7,
  "05260": -7,
  "05261": -7,
  "05262": 1,
  "05301": 0,
  "05302": -1,
  "05303": -1,
  "05304": -1,
  "05340": -7,
  "05341": -2,
  "05342": -2,
  "05343": -3,
  "05344": 0,
  "05345": -1,
  "05346": -2,
  "05350": -7,
  "05351": -1,
  "05352": -7,
  "05353": -1,
  "05354": 11,
  "05355": -2,
  "05356": -2,
  "05357": -1,
  "05358": -2,
  "05359": -3,
  "05360": -3,
  "05361": -2,
  "05362": -1,
  "05363": -2,
  "05401": 4,
  "05402": 5,
  "05403": 5,
  "05404": 4,
  "05406": 4,
  "05407": 5,
  "05408": 5,
  "05440": -7,
  "05441": -4,
  "05442": -4,
  "05443": -2,
  "05444": -4,
  "05445": 12,
  "05446": 4,
  "05447": -5,
  "05448": -4,
  "05449": 4,
  "05450": -4,
  "05451": 5,
  "05452": 5,
  "05453": 5,
  "05454": -4,
  "05455": -4,
  "05456": -2,
  "05457": -4,
  "05458": -6,
  "05459": -4,
  "05460": -4,
  "05461": 4,
  "05462": 4,
  "05463": -7,
  "05464": -4,
  "05465": 5,
  "05466": 4,
  "05468": 4,
  "05469": -2,
  "05470": -5,
  "05471": -5,
  "05472": -2,
  "05473": -2,
  "05474": 1,
  "05476": -5,
  "05477": 4,
  "05478": -4,
  "05481": -4,
  "05482": 12,
  "05483": -4,
  "05485": -4,
  "05486": 1,
  "05487": -2,
  "05488": -4,
  "05489": 12,
  "05490": 12,
  "05491": -2,
  "05492": -4,
  "05494": 4,
  "05495": 12,
  "05601": 2,
  "05602": 2,
  "05640": 3,
  "05641": 2,
  "05647": -4,
  "05648": 2,
  "05649": 2,
  "05650": 2,
  "05651": 2,
  "05652": -4,
  "05653": -4,
  "05654": 2,
  "05655": -4,
  "05656": -4,
  "05657": -4,
  "05658": 2,
  "05660": 10,
  "05661": -4,
  "05662": 5,
  "05663": 2,
  "05664": 2,
  "05665": -4,
  "05666": 2,
  "05667": 2,
  "05669": 2,
  "05670": 2,
  "05672": 5,
  "05673": 11,
  "05674": 6,
  "05675": -3,
  "05676": 2,
  "05677": 3,
  "05678": 2,
  "05679": 2,
  "05680": -4,
  "05681": -4,
  "05682": 2,
  "05701": -5,
  "05702": -5,
  "05730": -4,
  "05731": -4,
  "05732": -4,
  "05733": -5,
  "05734": -2,
  "05735": -5,
  "05736": -5,
  "05737": -4,
  "05738": -4,
  "05739": -5,
  "05740": -2,
  "05741": -5,
  "05742": -4,
  "05743": -4,
  "05744": -5,
  "05745": -5,
  "05746": -5,
  "05747": -3,
  "05748": -3,
  "05750": -4,
  "05751": -3,
  "05753": -2,
  "05757": -4,
  "05758": -3,
  "05759": -5,
  "05760": -4,
  "05761": 4,
  "05762": -4,
  "05763": -4,
  "05764": -5,
  "05765": -5,
  "05766": -2,
  "05767": -2,
  "05768": 3,
  "05769": -2,
  "05770": -2,
  "05772": -4,
  "05773": -5,
  "05774": -5,
  "05775": 4,
  "05776": 3,
  "05777": -5,
  "05778": -2,
  "05819": -5,
  "05820": -5,
  "05821": -4,
  "05822": -5,
  "05823": -5,
  "05824": -5,
  "05825": -5,
  "05826": -4,
  "05827": -4,
  "05828": -4,
  "05829": -5,
  "05830": -5,
  "05832": -4,
  "05833": -5,
  "05836": -5,
  "05837": -5,
  "05838": -5,
  "05839": -5,
  "05840": -5,
  "05841": 4,
  "05842": -5,
  "05843": -5,
  "05845": -5,
  "05846": -5,
  "05847": -5,
  "05848": -5,
  "05849": -5,
  "05850": -5,
  "05851": -5,
  "05853": -5,
  "05855": -5,
  "05857": -5,
  "05858": -5,
  "05859": -5,
  "05860": -5,
  "05861": -5,
  "05862": -4,
  "05863": -5,
  "05866": -5,
  "05867": -5,
  "05868": -5,
  "05871": -4,
  "05872": -5,
  "05873": -4,
  "05874": -5,
  "05875": -5,
  "05901": -5,
  "05902": -7,
  "05903": -5,
  "05904": -5,
  "05905": -5,
  "05906": -5,
  "05907": -5,
  "06001": 22,
  "06002": 13,
  "06010": 13,
  "06011": 13,
  "06013": 13,
  "06016": 11,
  "06018": 12,
  "06019": 13,
  "06020": 13,
  "06021": 13,
  "06022": 22,
  "06023": 22,
  "06024": 12,
  "06025": 13,
  "06026": 13,
  "06027": 14,
  "06028": 13,
  "06029": 11,
  "06031": 12,
  "06032": 13,
  "06033": 13,
  "06034": 13,
  "06035": 14,
  "06037": 14,
  "06039": 21,
  "06040": 13,
  "06042": 13,
  "06043": 11,
  "06045": 13,
  "06050": 13,
  "06051": 13,
  "06052": 14,
  "06053": 13,
  "06057": 12,
  "06058": 13,
  "06059": 22,
  "06060": 16,
  "06061": 12,
  "06062": 14,
  "06063": 14,
  "06064": 13,
  "06065": 13,
  "06066": 11,
  "06067": 13,
  "06068": 20,
  "06069": 12,
  "06070": 15,
  "06071": 14,
  "06072": 14,
  "06073": 22,
  "06074": 13,
  "06075": 11,
  "06076": 11,
  "06077": 11,
  "06078": 8,
  "06079": 20,
  "06081": 13,
  "06082": 6,
  "06083": 6,
  "06084": 11,
  "06085": 13,
  "06088": 13,
  "06089": 13,
  "06090": 23,
  "06091": 14,
  "06092": 22,
  "06093": 8,
  "06094": 12,
  "06095": 13,
  "06096": 13,
  "06098": 12,
  "06101": 13,
  "06102": 13,
  "06103": 13,
  "06104": 13,
  "06105": 13,
  "06106": 13,
  "06107": 13,
  "06108": 13,
  "06109": 13,
  "06110": 13,
  "06111": 13,
  "06112": 13,
  "06114": 13,
  "06115": 13,
  "06117": 13,
  "06118": 13,
  "06119": 13,
  "06120": 13,
  "06123": 13,
  "06126": 13,
  "06127": 13,
  "06128": 13,
  "06129": 13,
  "06131": 13,
  "06132": 13,
  "06133": 13,
  "06134": 13,
  "06137": 12,
  "06138": 13,
  "06140": 13,
  "06141": 13,
  "06142": 13,
  "06143": 13,
  "06144": 13,
  "06145": 13,
  "06146": 13,
  "06147": 13,
  "06152": 13,
  "06199": 13,
  "06226": 11,
  "06230": 4,
  "06231": 11,
  "06232": 11,
  "06233": 4,
  "06234": 4,
  "06235": 4,
  "06237": 11,
  "06238": 11,
  "06239": 4,
  "06241": 4,
  "06242": 4,
  "06243": 4,
  "06244": 4,
  "06245": 4,
  "06246": 4,
  "06247": 4,
  "06248": 11,
  "06249": 8,
  "06250": 11,
  "06251": 11,
  "06254": 8,
  "06255": 4,
  "06256": 4,
  "06258": 4,
  "06259": 4,
  "06260": 4,
  "06262": 4,
  "06263": 4,
  "06264": 4,
  "06265": 11,
  "06266": 4,
  "06267": 4,
  "06268": 13,
  "06277": 4,
  "06278": 11,
  "06279": 11,
  "06280": 4,
  "06281": 4,
  "06282": 4,
  "06320": 8,
  "06330": 8,
  "06331": 4,
  "06332": 4,
  "06333": 8,
  "06334": 8,
  "06335": 8,
  "06336": 17,
  "06338": 8,
  "06339": 8,
  "06340": 8,
  "06349": 8,
  "06350": 8,
  "06351": 8,
  "06353": 8,
  "06354": 4,
  "06355": 8,
  "06357": 8,
  "06359": 8,
  "06360": 8,
  "06365": 8,
  "06370": 8,
  "06371": 8,
  "06372": 8,
  "06373": 4,
  "06374": 4,
  "06375": 8,
  "06376": 8,
  "06377": 4,
  "06378": 8,
  "06379": 8,
  "06380": 8,
  "06382": 8,
  "06383": 8,
  "06384": 8,
  "06385": 8,
  "06387": 4,
  "06388": 8,
  "06389": 8,
  "06390": 8,
  "06401": 11,
  "06403": 11,
  "06404": 14,
  "06405": 12,
  "06409": 8,
  "06410": 20,
  "06412": 17,
  "06413": 20,
  "06414": 15,
  "06415": 8,
  "06416": 14,
  "06417": 17,
  "06418": 11,
  "06419": 20,
  "06420": 17,
  "06422": 20,
  "06423": 17,
  "06424": 15,
  "06426": 8,
  "06437": 12,
  "06438": 17,
  "06439": 17,
  "06440": 17,
  "06441": 20,
  "06442": 8,
  "06443": 12,
  "06444": 12,
  "06447": 20,
  "06450": 12,
  "06451": 11,
  "06455": 20,
  "06456": 15,
  "06457": 14,
  "06460": 12,
  "06461": 12,
  "06467": 12,
  "06468": 14,
  "06469": 17,
  "06470": 17,
  "06471": 12,
  "06472": 12,
  "06473": 12,
  "06474": 11,
  "06475": 8,
  "06477": 12,
  "06478": 12,
  "06479": 12,
  "06480": 15,
  "06481": 13,
  "06482": 14,
  "06483": 11,
  "06484": 12,
  "06487": 11,
  "06488": 11,
  "06489": 14,
  "06491": 14,
  "06492": 12,
  "06497": 14,
  "06498": 8,
  "06501": 14,
  "06502": 14,
  "06503": 14,
  "06504": 11,
  "06505": 14,
  "06506": 14,
  "06507": 14,
  "06508": 14,
  "06509": 11,
  "06510": 14,
  "06511": 11,
  "06512": 11,
  "06513": 11,
  "06514": 11,
  "06515": 11,
  "06516": 11,
  "06517": 11,
  "06518": 11,
  "06519": 11,
  "06520": 14,
  "06521": 14,
  "06524": 12,
  "06525": 15,
  "06530": 11,
  "06531": 11,
  "06532": 11,
  "06533": 11,
  "06534": 11,
  "06535": 11,
  "06536": 11,
  "06601": 13,
  "06602": 13,
  "06604": 13,
  "06605": 13,
  "06606": 13,
  "06607": 13,
  "06608": 13,
  "06610": 13,
  "06611": 14,
  "06612": 13,
  "06614": 14,
  "06615": 14,
  "06650": 13,
  "06702": 11,
  "06703": 11,
  "06704": 11,
  "06705": 11,
  "06706": 11,
  "06708": 11,
  "06710": 11,
  "06712": 11,
  "06716": 11,
  "06720": 11,
  "06721": 11,
  "06722": 11,
  "06723": 11,
  "06724": 11,
  "06725": 11,
  "06726": 11,
  "06750": 12,
  "06751": 12,
  "06752": 16,
  "06753": 12,
  "06754": 12,
  "06755": 13,
  "06756": 12,
  "06757": 13,
  "06758": 12,
  "06759": 12,
  "06762": 11,
  "06763": 12,
  "06770": 11,
  "06776": 13,
  "06777": 12,
  "06778": 12,
  "06779": 12,
  "06781": 12,
  "06782": 12,
  "06783": 16,
  "06784": 14,
  "06785": 13,
  "06786": 12,
  "06787": 12,
  "06790": 12,
  "06791": 12,
  "06793": 23,
  "06794": 23,
  "06795": 12,
  "06796": 12,
  "06798": 12,
  "06801": 14,
  "06804": 14,
  "06807": 17,
  "06810": 14,
  "06811": 14,
  "06812": 14,
  "06813": 14,
  "06820": 26,
  "06824": 13,
  "06825": 13,
  "06829": 17,
  "06830": 26,
  "06831": 21,
  "06836": 26,
  "06838": 26,
  "06840": 26,
  "06850": 15,
  "06851": 15,
  "06852": 15,
  "06853": 17,
  "06854": 15,
  "06855": 17,
  "06856": 15,
  "06870": 19,
  "06875": 17,
  "06876": 17,
  "06877": 19,
  "06878": 26,
  "06880": 26,
  "06881": 26,
  "06883": 26,
  "06890": 26,
  "06896": 17,
  "06897": 26,
  "06901": 14,
  "06902": 14,
  "06903": 17,
  "06904": 14,
  "06905": 17,
  "06906": 15,
  "06907": 17,
  "06910": 15,
  "06911": 19,
  "06912": 14,
  "07001": 9,
  "07002": 14,
  "07003": 8,
  "07004": 10,
  "07005": 13,
  "07006": 11,
  "07007": 11,
  "07008": 9,
  "07009": 8,
  "07010": 14,
  "07011": 8,
  "07012": 8,
  "07013": 8,
  "07014": 8,
  "07015": 8,
  "07016": 9,
  "07017": 8,
  "07018": 8,
  "07019": 8,
  "07020": 14,
  "07021": 19,
  "07022": 14,
  "07023": 9,
  "07024": 9,
  "07026": 8,
  "07027": 9,
  "07028": 8,
  "07029": 8,
  "07030": 14,
  "07031": 14,
  "07032": 14,
  "07033": 9,
  "07034": 13,
  "07035": 8,
  "07036": 9,
  "07039": 11,
  "07040": 8,
  "07041": 12,
  "07042": 8,
  "07043": 11,
  "07044": 8,
  "07045": 16,
  "07046": 24,
  "07047": 14,
  "07050": 8,
  "07051": 8,
  "07052": 8,
  "07054": 13,
  "07055": 8,
  "07057": 9,
  "07058": 16,
  "07059": 16,
  "07060": 9,
  "07061": 9,
  "07062": 9,
  "07063": 12,
  "07064": 9,
  "07065": 9,
  "07066": 9,
  "07067": 9,
  "07068": 11,
  "07069": 9,
  "07070": 14,
  "07071": 14,
  "07072": 9,
  "07073": 14,
  "07074": 8,
  "07075": 9,
  "07076": 9,
  "07077": 9,
  "07078": 20,
  "07079": 8,
  "07080": 12,
  "07081": 9,
  "07082": 10,
  "07083": 9,
  "07086": 14,
  "07087": 14,
  "07088": 9,
  "07090": 12,
  "07091": 12,
  "07092": 12,
  "07093": 14,
  "07094": 14,
  "07095": 13,
  "07096": 14,
  "07101": 8,
  "07102": 8,
  "07103": 8,
  "07104": 8,
  "07105": 14,
  "07106": 8,
  "07107": 8,
  "07108": 8,
  "07109": 8,
  "07110": 8,
  "07111": 8,
  "07112": 8,
  "07114": 8,
  "07201": 9,
  "07202": 9,
  "07203": 9,
  "07204": 9,
  "07205": 9,
  "07206": 9,
  "07207": 9,
  "07208": 9,
  "07302": 14,
  "07303": 14,
  "07304": 14,
  "07305": 14,
  "07306": 14,
  "07307": 14,
  "07308": 14,
  "07309": 14,
  "07310": 14,
  "07311": 14,
  "07401": 11,
  "07403": 7,
  "07405": 8,
  "07407": 9,
  "07410": 9,
  "07416": 4,
  "07417": 19,
  "07418": 3,
  "07419": 4,
  "07420": 7,
  "07421": 3,
  "07422": 3,
  "07423": 12,
  "07424": 8,
  "07428": 3,
  "07430": 8,
  "07432": 8,
  "07435": 4,
  "07436": 8,
  "07438": 4,
  "07439": 4,
  "07440": 8,
  "07442": 7,
  "07444": 8,
  "07446": 8,
  "07450": 11,
  "07451": 11,
  "07452": 11,
  "07456": 8,
  "07457": 8,
  "07458": 16,
  "07460": 4,
  "07461": 3,
  "07462": 3,
  "07463": 9,
  "07465": 8,
  "07470": 10,
  "07474": 10,
  "07480": 7,
  "07481": 12,
  "07495": 8,
  "07501": 10,
  "07502": 7,
  "07503": 7,
  "07504": 7,
  "07505": 10,
  "07506": 8,
  "07507": 10,
  "07508": 8,
  "07509": 7,
  "07510": 7,
  "07511": 8,
  "07512": 8,
  "07513": 7,
  "07514": 7,
  "07522": 7,
  "07524": 7,
  "07533": 7,
  "07538": 8,
  "07543": 7,
  "07544": 7,
  "07601": 8,
  "07602": 8,
  "07603": 8,
  "07604": 9,
  "07605": 11,
  "07606": 9,
  "07607": 9,
  "07608": 9,
  "07620": 20,
  "07621": 9,
  "07624": 12,
  "07626": 12,
  "07627": 12,
  "07628": 9,
  "07630": 9,
  "07631": 9,
  "07632": 22,
  "07640": 12,
  "07641": 12,
  "07642": 12,
  "07643": 9,
  "07644": 9,
  "07645": 8,
  "07646": 9,
  "07647": 9,
  "07648": 12,
  "07649": 12,
  "07650": 9,
  "07652": 11,
  "07653": 11,
  "07656": 8,
  "07657": 14,
  "07660": 9,
  "07661": 9,
  "07662": 9,
  "07663": 9,
  "07666": 9,
  "07670": 12,
  "07675": 12,
  "07676": 12,
  "07677": 8,
  "07701": 9,
  "07702": 9,
  "07703": 8,
  "07704": 19,
  "07710": 8,
  "07711": 11,
  "07712": 8,
  "07716": 9,
  "07717": 12,
  "07718": 8,
  "07719": 8,
  "07720": 8,
  "07721": 13,
  "07722": 19,
  "07723": 19,
  "07724": 8,
  "07726": 6,
  "07727": 8,
  "07728": 8,
  "07730": 8,
  "07731": 8,
  "07732": 8,
  "07733": 20,
  "07734": 8,
  "07735": 13,
  "07737": 8,
  "07738": 12,
  "07739": 19,
  "07740": 8,
  "07746": 11,
  "07747": 13,
  "07748": 9,
  "07750": 12,
  "07751": 12,
  "07752": 8,
  "07753": 8,
  "07754": 8,
  "07755": 8,
  "07756": 8,
  "07757": 8,
  "07758": 8,
  "07760": 19,
  "07762": 11,
  "07763": 6,
  "07764": 8,
  "07765": 12,
  "07799": 9,
  "07801": 13,
  "07802": 16,
  "07803": 13,
  "07806": 13,
  "07820": 0,
  "07821": 4,
  "07822": 4,
  "07823": 0,
  "07825": 0,
  "07826": 4,
  "07827": 3,
  "07828": 13,
  "07829": 0,
  "07830": 19,
  "07831": 1,
  "07832": 0,
  "07833": 0,
  "07834": 13,
  "07836": 13,
  "07837": 13,
  "07838": 0,
  "07839": 0,
  "07840": 0,
  "07842": 13,
  "07843": 13,
  "07844": 0,
  "07845": 13,
  "07846": 0,
  "07847": 13,
  "07848": 4,
  "07849": 13,
  "07850": 13,
  "07851": -10,
  "07852": 13,
  "07853": 3,
  "07855": 4,
  "07856": 13,
  "07857": 13,
  "07860": 4,
  "07863": 0,
  "07865": 0,
  "07866": 13,
  "07869": 16,
  "07870": 3,
  "07871": 4,
  "07874": 13,
  "07875": 4,
  "07876": 13,
  "07877": 4,
  "07878": 13,
  "07879": 4,
  "07880": 0,
  "07881": 4,
  "07882": 0,
  "07885": 13,
  "07901": 20,
  "07902": 20,
  "07920": 14,
  "07921": 12,
  "07922": 12,
  "07924": 17,
  "07926": 16,
  "07927": 13,
  "07928": 12,
  "07930": 17,
  "07931": 23,
  "07932": 16,
  "07933": 12,
  "07934": 23,
  "07935": 16,
  "07936": 16,
  "07938": 14,
  "07939": 14,
  "07940": 16,
  "07945": 24,
  "07946": 14,
  "07950": 16,
  "07960": 16,
  "07961": 16,
  "07962": 16,
  "07963": 16,
  "07970": 16,
  "07974": 12,
  "07976": 24,
  "07977": 14,
  "07978": 12,
  "07979": 16,
  "07980": 14,
  "07981": 16,
  "07999": 13,
  "08001": 5,
  "08002": 3,
  "08003": 12,
  "08004": 3,
  "08005": 1,
  "08006": 3,
  "08007": 3,
  "08008": 2,
  "08009": 3,
  "08010": 5,
  "08011": 5,
  "08012": 4,
  "08014": 6,
  "08015": 5,
  "08016": 5,
  "08018": 6,
  "08019": 8,
  "08020": 4,
  "08021": 3,
  "08022": 5,
  "08023": 6,
  "08025": 13,
  "08026": 3,
  "08027": 4,
  "08028": 6,
  "08029": 3,
  "08030": 3,
  "08031": 3,
  "08032": 4,
  "08033": 12,
  "08034": 3,
  "08035": 3,
  "08036": 4,
  "08037": 4,
  "08038": 4,
  "08039": 5,
  "08041": 5,
  "08042": 5,
  "08043": 5,
  "08045": 3,
  "08046": 5,
  "08048": 5,
  "08049": 3,
  "08050": 1,
  "08051": 4,
  "08052": 3,
  "08053": 3,
  "08054": 5,
  "08055": 13,
  "08056": 4,
  "08057": 3,
  "08059": 3,
  "08060": 5,
  "08061": 4,
  "08062": 6,
  "08063": 3,
  "08064": 5,
  "08065": 3,
  "08066": 4,
  "08067": 5,
  "08068": 5,
  "08069": 5,
  "08070": 6,
  "08071": 4,
  "08072": 4,
  "08073": 5,
  "08074": 13,
  "08075": 5,
  "08076": 3,
  "08077": 3,
  "08078": 3,
  "08079": 4,
  "08080": 4,
  "08081": 4,
  "08083": 3,
  "08084": 3,
  "08085": 5,
  "08086": 4,
  "08087": 4,
  "08088": 5,
  "08089": 6,
  "08090": 4,
  "08091": 3,
  "08092": -1,
  "08093": 3,
  "08094": 6,
  "08095": 6,
  "08096": 4,
  "08097": 4,
  "08098": 6,
  "08099": 3,
  "08101": 3,
  "08102": 3,
  "08103": 3,
  "08104": 3,
  "08105": 3,
  "08106": 3,
  "08107": 3,
  "08108": 3,
  "08109": 3,
  "08110": 3,
  "08201": 4,
  "08202": 6,
  "08203": 4,
  "08204": -6,
  "08205": 4,
  "08210": -6,
  "08212": 5,
  "08213": 4,
  "08214": -6,
  "08215": 4,
  "08217": 4,
  "08218": -6,
  "08219": -6,
  "08220": 4,
  "08221": 4,
  "08223": 4,
  "08224": 4,
  "08225": 4,
  "08226": 4,
  "08230": -6,
  "08231": 4,
  "08232": 4,
  "08234": 4,
  "08240": 4,
  "08241": 4,
  "08242": -6,
  "08243": -5,
  "08244": 4,
  "08245": -6,
  "08246": -6,
  "08247": 5,
  "08248": -2,
  "08250": -6,
  "08251": -6,
  "08252": -6,
  "08260": -6,
  "08270": -6,
  "08302": 2,
  "08310": 3,
  "08311": 2,
  "08312": 6,
  "08313": 7,
  "08314": 3,
  "08315": 3,
  "08316": 3,
  "08317": 6,
  "08318": 3,
  "08319": 4,
  "08320": 2,
  "08321": 3,
  "08322": 6,
  "08323": 3,
  "08324": 3,
  "08326": 3,
  "08327": 3,
  "08328": 4,
  "08329": 4,
  "08330": 4,
  "08332": 3,
  "08340": 12,
  "08341": 4,
  "08342": 4,
  "08343": 8,
  "08344": 4,
  "08345": 3,
  "08346": 4,
  "08347": 4,
  "08348": 3,
  "08349": 3,
  "08350": 4,
  "08352": 4,
  "08353": 2,
  "08360": 3,
  "08361": 3,
  "08362": 4,
  "08401": 4,
  "08402": 4,
  "08403": 4,
  "08404": 4,
  "08406": 4,
  "08501": 12,
  "08502": 20,
  "08504": 23,
  "08505": 12,
  "08510": 23,
  "08511": 5,
  "08512": 12,
  "08514": 23,
  "08515": 12,
  "08518": 12,
  "08520": 12,
  "08525": 13,
  "08526": 12,
  "08527": 1,
  "08528": 12,
  "08530": 6,
  "08533": 12,
  "08534": 13,
  "08535": 23,
  "08536": 12,
  "08540": 12,
  "08542": 12,
  "08543": 23,
  "08550": 23,
  "08551": 9,
  "08553": 13,
  "08554": 12,
  "08555": 12,
  "08556": 7,
  "08557": 7,
  "08558": 23,
  "08559": 7,
  "08560": 12,
  "08561": 12,
  "08562": 5,
  "08601": 12,
  "08602": 12,
  "08603": 12,
  "08604": 12,
  "08605": 12,
  "08606": 12,
  "08607": 12,
  "08608": 12,
  "08609": 12,
  "08610": 12,
  "08611": 12,
  "08618": 12,
  "08619": 12,
  "08620": 12,
  "08625": 12,
  "08628": 12,
  "08629": 12,
  "08638": 12,
  "08640": 5,
  "08641": 5,
  "08648": 12,
  "08650": 12,
  "08690": 12,
  "08691": 12,
  "08701": 1,
  "08720": 11,
  "08721": 1,
  "08722": 1,
  "08723": 1,
  "08724": 1,
  "08730": 11,
  "08731": 1,
  "08732": 1,
  "08733": 1,
  "08734": 1,
  "08735": 1,
  "08736": 11,
  "08738": 11,
  "08739": 1,
  "08740": 1,
  "08741": 1,
  "08742": 1,
  "08750": 19,
  "08751": 1,
  "08752": 1,
  "08753": 1,
  "08754": 1,
  "08755": 1,
  "08756": 1,
  "08757": 1,
  "08758": 1,
  "08759": 0,
  "08801": 19,
  "08802": 9,
  "08803": 8,
  "08804": 0,
  "08805": 12,
  "08807": 12,
  "08808": 0,
  "08809": 8,
  "08810": 10,
  "08812": 12,
  "08816": 14,
  "08817": 13,
  "08818": 13,
  "08820": 14,
  "08821": 9,
  "08822": 7,
  "08823": 9,
  "08824": 9,
  "08825": 8,
  "08826": 1,
  "08827": 9,
  "08828": 10,
  "08829": 8,
  "08830": 9,
  "08831": 10,
  "08832": 13,
  "08833": 19,
  "08834": 8,
  "08835": 9,
  "08836": 14,
  "08837": 13,
  "08840": 13,
  "08844": 20,
  "08846": 12,
  "08848": 8,
  "08850": 13,
  "08852": 10,
  "08853": 13,
  "08854": 12,
  "08855": 13,
  "08857": 13,
  "08858": 19,
  "08859": 13,
  "08861": 13,
  "08862": 13,
  "08863": 13,
  "08865": 0,
  "08867": 19,
  "08868": 19,
  "08869": 9,
  "08870": 9,
  "08871": 13,
  "08872": 13,
  "08873": 12,
  "08875": 13,
  "08876": 9,
  "08879": 13,
  "08880": 12,
  "08882": 13,
  "08884": 10,
  "08885": 6,
  "08886": 0,
  "08887": 6,
  "08888": 9,
  "08889": 9,
  "08890": 9,
  "08899": 13,
  "08901": 13,
  "08902": 10,
  "08903": 13,
  "08904": 13,
  "08906": 13,
  "10001": 31,
  "10002": 31,
  "10003": 34,
  "10004": 14,
  "10005": 14,
  "10006": 14,
  "10007": 25,
  "10008": 25,
  "10009": 32,
  "10010": 34,
  "10011": 34,
  "10012": 42,
  "10013": 25,
  "10014": 34,
  "10016": 34,
  "10017": 34,
  "10018": 34,
  "10019": 34,
  "10020": 34,
  "10021": 43,
  "10022": 36,
  "10023": 34,
  "10024": 42,
  "10025": 34,
  "10026": 31,
  "10027": 31,
  "10028": 43,
  "10029": 34,
  "10030": 34,
  "10031": 34,
  "10032": 10,
  "10033": 10,
  "10034": 10,
  "10035": 31,
  "10036": 34,
  "10037": 31,
  "10038": 14,
  "10039": 10,
  "10040": 10,
  "10041": 14,
  "10044": 31,
  "10045": 14,
  "10055": 36,
  "10060": 31,
  "10065": 43,
  "10069": 34,
  "10075": 43,
  "10090": 34,
  "10095": 31,
  "10098": 25,
  "10099": 31,
  "10101": 34,
  "10103": 34,
  "10104": 34,
  "10105": 36,
  "10106": 34,
  "10107": 34,
  "10108": 34,
  "10110": 32,
  "10111": 34,
  "10112": 34,
  "10113": 34,
  "10115": 31,
  "10116": 31,
  "10118": 31,
  "10119": 31,
  "10120": 31,
  "10121": 31,
  "10122": 31,
  "10123": 31,
  "10128": 43,
  "10129": 34,
  "10150": 36,
  "10151": 34,
  "10152": 36,
  "10153": 36,
  "10154": 36,
  "10155": 36,
  "10156": 34,
  "10158": 36,
  "10159": 34,
  "10161": 34,
  "10162": 43,
  "10163": 36,
  "10165": 34,
  "10166": 34,
  "10167": 34,
  "10168": 34,
  "10169": 34,
  "10170": 34,
  "10171": 36,
  "10172": 34,
  "10173": 34,
  "10174": 34,
  "10175": 34,
  "10176": 34,
  "10177": 34,
  "10178": 34,
  "10185": 34,
  "10199": 32,
  "10242": 25,
  "10249": 25,
  "10268": 14,
  "10270": 14,
  "10271": 14,
  "10272": 34,
  "10274": 14,
  "10276": 34,
  "10278": 25,
  "10279": 25,
  "10280": 17,
  "10281": 25,
  "10282": 25,
  "10301": 8,
  "10302": 8,
  "10303": 8,
  "10304": 8,
  "10305": 8,
  "10306": 8,
  "10307": 16,
  "10308": 8,
  "10309": 10,
  "10310": 8,
  "10311": 8,
  "10312": 8,
  "10313": 8,
  "10314": 8,
  "10451": 10,
  "10452": 10,
  "10453": 10,
  "10454": 10,
  "10455": 10,
  "10456": 10,
  "10457": 10,
  "10458": 10,
  "10459": 10,
  "10460": 11,
  "10461": 11,
  "10462": 10,
  "10463": 10,
  "10464": 13,
  "10465": 11,
  "10466": 10,
  "10467": 10,
  "10468": 10,
  "10469": 10,
  "10470": 10,
  "10471": 10,
  "10472": 11,
  "10473": 11,
  "10474": 10,
  "10475": 10,
  "10501": 6,
  "10502": 13,
  "10503": 13,
  "10504": 21,
  "10505": 6,
  "10506": 14,
  "10507": 6,
  "10509": 3,
  "10510": 13,
  "10511": 5,
  "10512": 3,
  "10514": 21,
  "10516": 4,
  "10517": 2,
  "10518": 6,
  "10519": 3,
  "10520": 8,
  "10521": 4,
  "10522": 13,
  "10523": 10,
  "10524": 11,
  "10526": 6,
  "10527": 6,
  "10528": 13,
  "10530": 10,
  "10532": 13,
  "10533": 13,
  "10535": 2,
  "10536": 8,
  "10537": 2,
  "10538": 15,
  "10540": 4,
  "10541": 3,
  "10542": 3,
  "10543": 13,
  "10545": 10,
  "10546": 13,
  "10547": 2,
  "10548": 4,
  "10549": 13,
  "10550": 10,
  "10551": 11,
  "10552": 11,
  "10553": 11,
  "10560": 6,
  "10562": 10,
  "10566": 4,
  "10567": 4,
  "10570": 13,
  "10573": 13,
  "10576": 17,
  "10577": 21,
  "10578": 4,
  "10579": 4,
  "10580": 21,
  "10583": 13,
  "10587": 6,
  "10588": 4,
  "10589": 4,
  "10590": 17,
  "10591": 13,
  "10594": 13,
  "10595": 13,
  "10596": 5,
  "10597": 15,
  "10598": 3,
  "10601": 10,
  "10602": 10,
  "10603": 10,
  "10604": 13,
  "10605": 13,
  "10606": 10,
  "10607": 10,
  "10610": 10,
  "10701": 10,
  "10702": 10,
  "10703": 10,
  "10704": 11,
  "10705": 10,
  "10706": 10,
  "10707": 13,
  "10708": 11,
  "10709": 13,
  "10710": 10,
  "10801": 11,
  "10802": 11,
  "10803": 13,
  "10804": 13,
  "10805": 10,
  "10901": 5,
  "10910": 0,
  "10911": 12,
  "10912": 0,
  "10913": 8,
  "10914": 0,
  "10915": 0,
  "10916": 0,
  "10917": 0,
  "10918": 0,
  "10919": 0,
  "10920": 5,
  "10921": 0,
  "10922": 2,
  "10923": 5,
  "10924": 0,
  "10925": 0,
  "10926": 0,
  "10927": 5,
  "10928": 2,
  "10930": 0,
  "10931": 5,
  "10932": -1,
  "10933": 0,
  "10940": -1,
  "10941": -1,
  "10949": 0,
  "10950": 0,
  "10952": 5,
  "10953": 0,
  "10954": 5,
  "10956": 8,
  "10958": 0,
  "10959": 0,
  "10960": 5,
  "10962": 5,
  "10963": 0,
  "10964": 13,
  "10965": 5,
  "10968": 13,
  "10969": 0,
  "10970": 5,
  "10973": 0,
  "10974": 5,
  "10975": 3,
  "10976": 10,
  "10977": 5,
  "10979": 0,
  "10980": 5,
  "10981": 0,
  "10982": 5,
  "10983": 5,
  "10984": 5,
  "10985": 9,
  "10986": 12,
  "10987": 14,
  "10988": 0,
  "10989": 5,
  "10990": 0,
  "10992": 0,
  "10993": 5,
  "10994": 8,
  "10996": 2,
  "10997": 2,
  "10998": 0,
  "11001": 12,
  "11002": 12,
  "11003": 12,
  "11004": 12,
  "11005": 13,
  "11010": 12,
  "11020": 13,
  "11021": 13,
  "11022": 13,
  "11023": 22,
  "11024": 22,
  "11026": 13,
  "11027": 22,
  "11030": 23,
  "11040": 14,
  "11042": 13,
  "11050": 14,
  "11096": 10,
  "11101": 32,
  "11102": 34,
  "11103": 34,
  "11104": 32,
  "11105": 34,
  "11106": 32,
  "11109": 32,
  "11201": 3,
  "11202": 3,
  "11203": 3,
  "11204": 5,
  "11205": 2,
  "11206": 2,
  "11207": 2,
  "11208": 10,
  "11209": 6,
  "11210": 3,
  "11211": 32,
  "11212": 2,
  "11213": 3,
  "11214": 5,
  "11215": 5,
  "11216": 3,
  "11217": 6,
  "11218": 3,
  "11219": 5,
  "11220": 3,
  "11221": 3,
  "11222": 32,
  "11223": 5,
  "11224": 2,
  "11225": 3,
  "11226": 3,
  "11228": 6,
  "11229": 3,
  "11230": 5,
  "11231": 4,
  "11232": 2,
  "11233": 2,
  "11234": 3,
  "11235": 3,
  "11236": 3,
  "11237": 2,
  "11238": 3,
  "11239": 2,
  "11240": 5,
  "11241": 3,
  "11242": 3,
  "11243": 6,
  "11247": 3,
  "11249": 31,
  "11252": 6,
  "11256": 10,
  "11351": 11,
  "11352": 11,
  "11354": 10,
  "11355": 11,
  "11356": 11,
  "11357": 13,
  "11358": 13,
  "11359": 11,
  "11360": 11,
  "11361": 13,
  "11362": 11,
  "11363": 13,
  "11364": 11,
  "11365": 13,
  "11366": 13,
  "11367": 11,
  "11368": 11,
  "11369": 10,
  "11370": 34,
  "11371": 11,
  "11372": 10,
  "11373": 11,
  "11374": 10,
  "11375": 10,
  "11377": 32,
  "11378": 11,
  "11379": 13,
  "11380": 10,
  "11385": 11,
  "11386": 11,
  "11411": 10,
  "11412": 10,
  "11413": 10,
  "11414": 13,
  "11415": 11,
  "11416": 11,
  "11417": 11,
  "11418": 11,
  "11419": 11,
  "11420": 10,
  "11421": 10,
  "11422": 11,
  "11423": 11,
  "11424": 11,
  "11426": 11,
  "11427": 11,
  "11428": 10,
  "11429": 10,
  "11430": 10,
  "11431": 11,
  "11432": 11,
  "11433": 10,
  "11434": 10,
  "11435": 10,
  "11436": 10,
  "11501": 12,
  "11507": 14,
  "11509": 15,
  "11510": 12,
  "11514": 12,
  "11516": 13,
  "11518": 12,
  "11520": 12,
  "11530": 12,
  "11531": 16,
  "11542": 12,
  "11545": 14,
  "11547": 14,
  "11548": 16,
  "11550": 12,
  "11551": 12,
  "11552": 12,
  "11553": 12,
  "11554": 12,
  "11556": 12,
  "11557": 14,
  "11558": 12,
  "11559": 22,
  "11560": 14,
  "11561": 12,
  "11563": 12,
  "11565": 12,
  "11566": 14,
  "11568": 23,
  "11569": 16,
  "11570": 14,
  "11571": 14,
  "11572": 14,
  "11575": 12,
  "11576": 14,
  "11577": 16,
  "11579": 14,
  "11580": 12,
  "11581": 11,
  "11582": 12,
  "11590": 12,
  "11596": 14,
  "11598": 13,
  "11599": 16,
  "11690": 11,
  "11691": 11,
  "11692": 10,
  "11693": 2,
  "11694": 5,
  "11695": 3,
  "11697": 3,
  "11701": 12,
  "11702": 12,
  "11703": 12,
  "11704": 12,
  "11705": 8,
  "11706": 12,
  "11707": 12,
  "11708": 12,
  "11709": 14,
  "11710": 12,
  "11713": 8,
  "11714": 12,
  "11715": 8,
  "11716": 9,
  "11717": 9,
  "11718": 9,
  "11719": 8,
  "11720": 8,
  "11721": 14,
  "11722": 9,
  "11724": 14,
  "11725": 9,
  "11726": 12,
  "11727": 8,
  "11729": 12,
  "11730": 9,
  "11731": 9,
  "11732": 14,
  "11733": 11,
  "11735": 12,
  "11737": 12,
  "11738": 8,
  "11739": 9,
  "11740": 12,
  "11741": 8,
  "11742": 8,
  "11743": 14,
  "11746": 12,
  "11747": 14,
  "11749": 9,
  "11751": 9,
  "11752": 9,
  "11753": 14,
  "11754": 9,
  "11755": 8,
  "11756": 12,
  "11757": 12,
  "11758": 12,
  "11760": 9,
  "11762": 12,
  "11763": 8,
  "11764": 8,
  "11765": 23,
  "11766": 8,
  "11767": 9,
  "11768": 12,
  "11769": 9,
  "11770": 12,
  "11771": 14,
  "11772": 8,
  "11776": 8,
  "11777": 8,
  "11778": 8,
  "11779": 9,
  "11780": 9,
  "11782": 9,
  "11783": 12,
  "11784": 8,
  "11786": 8,
  "11787": 9,
  "11788": 9,
  "11789": 8,
  "11790": 8,
  "11791": 14,
  "11792": 8,
  "11793": 12,
  "11795": 12,
  "11796": 9,
  "11797": 14,
  "11798": 12,
  "11801": 12,
  "11802": 12,
  "11803": 14,
  "11804": 12,
  "11901": 8,
  "11930": 11,
  "11931": 8,
  "11932": 19,
  "11933": 8,
  "11934": 8,
  "11935": 8,
  "11937": 8,
  "11939": 8,
  "11940": 8,
  "11941": 8,
  "11942": 8,
  "11944": 8,
  "11946": 11,
  "11947": 8,
  "11948": 8,
  "11949": 8,
  "11950": 8,
  "11951": 8,
  "11952": 8,
  "11953": 8,
  "11954": 11,
  "11955": 8,
  "11956": 8,
  "11957": 10,
  "11958": 8,
  "11959": 19,
  "11960": 8,
  "11961": 8,
  "11962": 19,
  "11963": 11,
  "11964": 8,
  "11965": 11,
  "11967": 8,
  "11968": 11,
  "11969": 11,
  "11970": 8,
  "11971": 8,
  "11972": 8,
  "11973": 8,
  "11975": 19,
  "11976": 19,
  "11977": 11,
  "11978": 11,
  "11980": 8,
  "12007": -8,
  "12008": 0,
  "12009": 8,
  "12010": -8,
  "12015": -5,
  "12016": -8,
  "12017": -5,
  "12018": 7,
  "12019": 1,
  "12020": 8,
  "12022": 5,
  "12023": 1,
  "12024": 4,
  "12025": 1,
  "12027": 1,
  "12028": 5,
  "12029": 2,
  "12031": -8,
  "12032": 1,
  "12033": 16,
  "12035": 0,
  "12036": 0,
  "12037": -5,
  "12040": 5,
  "12041": 16,
  "12042": -8,
  "12043": 1,
  "12045": 16,
  "12046": -8,
  "12047": 5,
  "12050": -5,
  "12051": -8,
  "12052": 5,
  "12053": 0,
  "12054": 17,
  "12055": -8,
  "12056": 0,
  "12057": 5,
  "12058": -8,
  "12059": 15,
  "12060": -5,
  "12061": 7,
  "12062": 6,
  "12063": 6,
  "12064": 0,
  "12065": 8,
  "12066": -8,
  "12067": 16,
  "12068": -8,
  "12069": -8,
  "12070": -8,
  "12071": 1,
  "12072": -8,
  "12073": 1,
  "12074": 8,
  "12075": -5,
  "12076": 0,
  "12077": 24,
  "12078": -1,
  "12082": 5,
  "12083": -8,
  "12084": 24,
  "12085": 8,
  "12086": -1,
  "12087": -8,
  "12089": 5,
  "12090": 5,
  "12092": 0,
  "12093": 0,
  "12094": 5,
  "12095": -1,
  "12106": -3,
  "12107": 1,
  "12108": -16,
  "12110": 24,
  "12115": 4,
  "12116": -6,
  "12117": 1,
  "12118": 8,
  "12120": -8,
  "12121": 5,
  "12122": 0,
  "12123": 6,
  "12124": 16,
  "12125": 2,
  "12128": 24,
  "12130": -5,
  "12131": 0,
  "12132": -5,
  "12133": 5,
  "12134": 1,
  "12136": 4,
  "12137": 0,
  "12138": 5,
  "12139": -16,
  "12140": 5,
  "12141": 0,
  "12143": 16,
  "12144": 16,
  "12147": 2,
  "12148": 8,
  "12149": 0,
  "12150": 0,
  "12151": 8,
  "12153": 5,
  "12154": 7,
  "12155": -6,
  "12156": 16,
  "12157": 1,
  "12158": 16,
  "12159": 24,
  "12160": 1,
  "12161": 16,
  "12164": -16,
  "12165": -5,
  "12166": -8,
  "12167": 0,
  "12168": 6,
  "12169": 5,
  "12170": 8,
  "12172": -5,
  "12173": -5,
  "12174": -5,
  "12175": 1,
  "12176": -8,
  "12177": -8,
  "12180": 5,
  "12181": 5,
  "12182": 5,
  "12183": 5,
  "12184": -5,
  "12185": 5,
  "12186": 16,
  "12187": 0,
  "12188": 5,
  "12189": 5,
  "12190": -16,
  "12192": -8,
  "12193": 16,
  "12194": 1,
  "12195": 2,
  "12196": 14,
  "12197": 0,
  "12198": 6,
  "12201": 16,
  "12202": 16,
  "12203": 16,
  "12204": 16,
  "12205": 16,
  "12206": 16,
  "12207": 16,
  "12208": 16,
  "12209": 16,
  "12210": 16,
  "12211": 24,
  "12212": 16,
  "12220": 24,
  "12223": 16,
  "12224": 16,
  "12225": 16,
  "12226": 16,
  "12247": 16,
  "12260": 16,
  "12301": 0,
  "12302": 0,
  "12303": 0,
  "12304": -1,
  "12305": 0,
  "12306": 0,
  "12307": -1,
  "12308": -1,
  "12309": 8,
  "12325": 0,
  "12401": 0,
  "12402": 0,
  "12404": 1,
  "12405": -8,
  "12406": -1,
  "12407": -8,
  "12409": 1,
  "12410": 0,
  "12411": 0,
  "12412": 1,
  "12413": -8,
  "12414": -8,
  "12416": 1,
  "12417": 0,
  "12418": -8,
  "12419": 0,
  "12420": 0,
  "12421": -1,
  "12422": -8,
  "12423": -8,
  "12424": -8,
  "12427": -8,
  "12428": 9,
  "12429": 1,
  "12430": -1,
  "12431": -8,
  "12432": 0,
  "12433": 1,
  "12434": 2,
  "12435": 9,
  "12436": -8,
  "12438": -1,
  "12439": -8,
  "12440": 1,
  "12441": 0,
  "12442": -8,
  "12443": 1,
  "12444": -8,
  "12446": 0,
  "12448": 1,
  "12449": 0,
  "12450": -8,
  "12451": -8,
  "12452": -8,
  "12453": -8,
  "12454": -8,
  "12455": -1,
  "12456": 0,
  "12457": 1,
  "12458": 0,
  "12459": -1,
  "12460": -8,
  "12461": 1,
  "12463": -8,
  "12464": 1,
  "12465": 0,
  "12466": 0,
  "12468": -8,
  "12469": -8,
  "12470": -8,
  "12471": 0,
  "12472": 0,
  "12473": -8,
  "12474": -1,
  "12475": 0,
  "12477": -8,
  "12480": -8,
  "12481": 1,
  "12482": -8,
  "12483": 0,
  "12484": 1,
  "12485": -8,
  "12486": 0,
  "12487": 1,
  "12489": 0,
  "12490": -8,
  "12491": 0,
  "12492": -8,
  "12493": 1,
  "12494": 1,
  "12495": 1,
  "12496": -8,
  "12498": 1,
  "12501": 5,
  "12502": -4,
  "12503": -4,
  "12504": 11,
  "12506": 5,
  "12507": 1,
  "12508": 2,
  "12510": 5,
  "12511": 2,
  "12512": 2,
  "12513": -5,
  "12514": 5,
  "12515": 1,
  "12516": -5,
  "12517": -5,
  "12518": 0,
  "12520": 0,
  "12521": -5,
  "12522": 5,
  "12523": -4,
  "12524": 2,
  "12525": 1,
  "12526": -4,
  "12527": 2,
  "12528": 5,
  "12529": -5,
  "12530": -5,
  "12531": 3,
  "12533": 5,
  "12534": -5,
  "12537": 5,
  "12538": 5,
  "12540": 5,
  "12541": -4,
  "12542": 5,
  "12543": -1,
  "12544": -5,
  "12545": 5,
  "12546": -4,
  "12547": 5,
  "12548": 1,
  "12549": 0,
  "12550": 0,
  "12551": 0,
  "12552": 0,
  "12553": 0,
  "12555": 0,
  "12561": 1,
  "12563": 3,
  "12564": 3,
  "12565": -5,
  "12566": 0,
  "12567": -4,
  "12568": 5,
  "12569": 5,
  "12570": 5,
  "12571": 1,
  "12572": 1,
  "12574": 0,
  "12575": 0,
  "12577": 0,
  "12578": 5,
  "12580": 5,
  "12581": 5,
  "12582": 3,
  "12583": -8,
  "12584": 0,
  "12585": 5,
  "12586": 0,
  "12588": 0,
  "12589": 0,
  "12590": 5,
  "12592": 5,
  "12593": -5,
  "12594": 6,
  "12601": 5,
  "12602": 5,
  "12603": 5,
  "12701": 9,
  "12719": -10,
  "12720": 9,
  "12721": -1,
  "12722": 9,
  "12723": 8,
  "12724": 9,
  "12725": 9,
  "12726": 9,
  "12727": 8,
  "12729": -1,
  "12732": 8,
  "12733": 9,
  "12734": 9,
  "12736": 9,
  "12737": 9,
  "12738": 9,
  "12740": 10,
  "12741": 8,
  "12742": 9,
  "12743": 9,
  "12745": 8,
  "12746": -1,
  "12747": 9,
  "12748": 9,
  "12749": 9,
  "12750": 8,
  "12751": 9,
  "12752": 8,
  "12754": 9,
  "12758": 9,
  "12759": 9,
  "12760": 8,
  "12762": 9,
  "12763": 9,
  "12764": 8,
  "12765": 9,
  "12766": 8,
  "12767": 9,
  "12768": 10,
  "12769": 0,
  "12770": 9,
  "12771": -1,
  "12775": 9,
  "12776": -3,
  "12777": 9,
  "12778": 9,
  "12779": 9,
  "12780": 9,
  "12781": 9,
  "12783": 9,
  "12784": 20,
  "12785": 9,
  "12786": 9,
  "12787": 9,
  "12788": 9,
  "12789": 9,
  "12790": 9,
  "12791": 8,
  "12792": -10,
  "12801": 3,
  "12803": 3,
  "12804": 0,
  "12808": 0,
  "12809": 3,
  "12810": 0,
  "12811": 0,
  "12812": -16,
  "12814": 0,
  "12815": 0,
  "12816": 5,
  "12817": 0,
  "12819": 11,
  "12820": 9,
  "12821": 3,
  "12822": 6,
  "12823": 4,
  "12824": 0,
  "12827": 3,
  "12828": 3,
  "12831": 8,
  "12832": 3,
  "12833": 8,
  "12834": 5,
  "12835": 0,
  "12836": 0,
  "12837": 3,
  "12838": 3,
  "12839": 3,
  "12841": 11,
  "12842": -16,
  "12843": 0,
  "12844": 9,
  "12845": 0,
  "12846": 0,
  "12847": -16,
  "12848": 5,
  "12849": 3,
  "12850": 8,
  "12851": 0,
  "12852": 16,
  "12853": 0,
  "12854": 3,
  "12855": 18,
  "12856": -16,
  "12857": 0,
  "12858": 16,
  "12859": 8,
  "12860": 0,
  "12861": 0,
  "12862": 0,
  "12863": 8,
  "12864": -16,
  "12865": 3,
  "12866": 17,
  "12870": 16,
  "12871": 8,
  "12872": 16,
  "12873": 3,
  "12874": 11,
  "12878": 0,
  "12879": 16,
  "12883": 16,
  "12884": 8,
  "12885": 0,
  "12886": 0,
  "12887": 3,
  "12901": -2,
  "12903": -2,
  "12910": -2,
  "12911": -2,
  "12912": -2,
  "12913": -6,
  "12914": -6,
  "12915": -6,
  "12916": -6,
  "12917": -6,
  "12918": -2,
  "12919": -7,
  "12920": -6,
  "12921": -7,
  "12922": -3,
  "12923": -2,
  "12924": 3,
  "12926": -6,
  "12927": -1,
  "12928": -3,
  "12929": -2,
  "12930": -6,
  "12932": 18,
  "12933": -2,
  "12934": -2,
  "12935": -2,
  "12936": 18,
  "12937": -6,
  "12939": -6,
  "12941": 18,
  "12942": 19,
  "12943": 19,
  "12944": 3,
  "12945": -6,
  "12946": 19,
  "12949": -6,
  "12950": 18,
  "12952": -2,
  "12953": -6,
  "12955": -2,
  "12956": 18,
  "12957": -6,
  "12958": -2,
  "12959": -2,
  "12960": 18,
  "12961": 18,
  "12962": -2,
  "12964": 19,
  "12965": -6,
  "12966": -6,
  "12967": -6,
  "12969": -6,
  "12970": -6,
  "12972": -2,
  "12973": -6,
  "12974": -3,
  "12975": -2,
  "12976": -6,
  "12977": -6,
  "12978": -2,
  "12979": -7,
  "12980": -6,
  "12981": -2,
  "12983": -6,
  "12985": -2,
  "12986": -6,
  "12987": 18,
  "12989": -6,
  "12992": -2,
  "12993": 18,
  "12995": -6,
  "12996": 3,
  "12997": 18,
  "12998": 18,
  "13020": -3,
  "13021": 4,
  "13022": 4,
  "13026": -3,
  "13027": 7,
  "13028": 3,
  "13029": 7,
  "13030": 6,
  "13031": 7,
  "13032": -7,
  "13033": 4,
  "13034": 4,
  "13035": 1,
  "13036": 3,
  "13037": -7,
  "13039": 7,
  "13040": -4,
  "13041": 7,
  "13042": 6,
  "13043": -7,
  "13044": 3,
  "13045": -3,
  "13051": -7,
  "13052": -3,
  "13053": -5,
  "13054": -5,
  "13056": -3,
  "13057": 6,
  "13060": 4,
  "13061": -7,
  "13062": -5,
  "13063": -7,
  "13064": 2,
  "13065": -3,
  "13066": 15,
  "13068": -5,
  "13069": 3,
  "13071": -6,
  "13072": -7,
  "13073": -5,
  "13074": 2,
  "13076": 3,
  "13077": -3,
  "13078": 15,
  "13080": 4,
  "13081": -3,
  "13082": 6,
  "13083": 3,
  "13084": 7,
  "13087": -3,
  "13088": 6,
  "13089": 7,
  "13090": 7,
  "13092": -5,
  "13093": 3,
  "13101": -3,
  "13102": -5,
  "13103": 3,
  "13104": 15,
  "13107": 3,
  "13108": 7,
  "13110": 7,
  "13111": 2,
  "13112": 6,
  "13113": 4,
  "13114": 3,
  "13115": 3,
  "13116": 6,
  "13117": 3,
  "13118": 4,
  "13119": 4,
  "13120": 7,
  "13121": 3,
  "13122": -7,
  "13123": -5,
  "13124": -3,
  "13126": 3,
  "13131": 3,
  "13132": 3,
  "13134": -7,
  "13135": 3,
  "13136": -3,
  "13137": 6,
  "13138": -7,
  "13139": 4,
  "13140": 3,
  "13141": -3,
  "13142": 3,
  "13143": -5,
  "13144": 2,
  "13145": 3,
  "13146": 3,
  "13147": 4,
  "13148": -3,
  "13152": 12,
  "13153": 4,
  "13154": 3,
  "13155": -8,
  "13156": 2,
  "13157": -5,
  "13158": -3,
  "13159": -3,
  "13160": -3,
  "13162": -5,
  "13163": -7,
  "13164": 7,
  "13165": -3,
  "13166": 4,
  "13167": 3,
  "13201": 6,
  "13202": 6,
  "13203": 6,
  "13204": 6,
  "13205": 6,
  "13206": 6,
  "13207": 6,
  "13208": 6,
  "13209": 6,
  "13210": 6,
  "13211": 6,
  "13212": 6,
  "13214": 7,
  "13215": 15,
  "13217": 6,
  "13218": 6,
  "13219": 7,
  "13220": 6,
  "13221": 6,
  "13224": 7,
  "13235": 6,
  "13261": 6,
  "13290": 6,
  "13301": -5,
  "13302": 2,
  "13303": -5,
  "13304": 3,
  "13305": -7,
  "13308": -5,
  "13309": -7,
  "13310": -8,
  "13312": -7,
  "13313": -6,
  "13314": -8,
  "13315": -6,
  "13316": -5,
  "13317": -8,
  "13318": -5,
  "13319": -5,
  "13320": 0,
  "13321": -5,
  "13322": -5,
  "13323": -5,
  "13324": 1,
  "13325": -7,
  "13326": 3,
  "13327": -7,
  "13328": -8,
  "13329": 1,
  "13331": -8,
  "13332": -8,
  "13333": -6,
  "13334": -8,
  "13335": -6,
  "13337": 3,
  "13338": -5,
  "13339": -8,
  "13340": 1,
  "13341": -5,
  "13342": -5,
  "13343": -7,
  "13345": -7,
  "13346": -6,
  "13348": -5,
  "13350": 1,
  "13352": 3,
  "13353": -17,
  "13354": -5,
  "13355": -8,
  "13357": 1,
  "13360": -8,
  "13361": 3,
  "13362": -8,
  "13363": -5,
  "13364": -8,
  "13365": 1,
  "13367": -7,
  "13368": -7,
  "13401": -5,
  "13402": -8,
  "13403": -5,
  "13404": -7,
  "13406": 1,
  "13407": 1,
  "13408": -7,
  "13409": -7,
  "13410": -9,
  "13411": -6,
  "13413": -4,
  "13415": -5,
  "13416": 1,
  "13417": -5,
  "13418": -8,
  "13420": -8,
  "13421": -7,
  "13424": -5,
  "13425": -8,
  "13426": 2,
  "13428": -8,
  "13431": 2,
  "13433": -7,
  "13435": 2,
  "13436": -9,
  "13437": -7,
  "13438": 2,
  "13439": -6,
  "13440": -5,
  "13441": -5,
  "13442": -5,
  "13450": -6,
  "13452": -9,
  "13454": 1,
  "13455": -8,
  "13456": -5,
  "13457": 3,
  "13459": 0,
  "13460": -9,
  "13461": -6,
  "13464": -9,
  "13465": -8,
  "13468": -6,
  "13469": -5,
  "13470": 1,
  "13471": -5,
  "13472": -8,
  "13473": -7,
  "13475": 3,
  "13476": -5,
  "13477": -7,
  "13478": -5,
  "13479": -4,
  "13480": -8,
  "13482": -6,
  "13483": 2,
  "13484": -8,
  "13485": -6,
  "13486": -5,
  "13488": -6,
  "13489": -5,
  "13490": -5,
  "13491": -6,
  "13492": -5,
  "13493": 2,
  "13494": -5,
  "13495": -5,
  "13501": -5,
  "13502": -5,
  "13503": -5,
  "13504": -5,
  "13505": -5,
  "13601": -4,
  "13602": -4,
  "13603": -4,
  "13605": -4,
  "13606": -4,
  "13607": -4,
  "13608": -4,
  "13611": -4,
  "13612": -4,
  "13613": -1,
  "13614": -3,
  "13615": -4,
  "13616": -4,
  "13617": -1,
  "13618": -4,
  "13619": -4,
  "13620": -7,
  "13621": -1,
  "13622": -4,
  "13623": -3,
  "13624": -4,
  "13625": -1,
  "13626": -7,
  "13627": -4,
  "13628": -4,
  "13630": -3,
  "13631": -4,
  "13632": -4,
  "13633": -3,
  "13634": -4,
  "13635": -3,
  "13636": 3,
  "13637": -4,
  "13638": -4,
  "13639": -3,
  "13640": 5,
  "13641": 5,
  "13642": -3,
  "13643": -4,
  "13645": -3,
  "13646": -3,
  "13647": -1,
  "13648": -7,
  "13649": -1,
  "13650": -4,
  "13651": -4,
  "13652": -3,
  "13654": -3,
  "13655": -6,
  "13656": -4,
  "13657": -4,
  "13658": -1,
  "13659": -4,
  "13660": -1,
  "13661": 3,
  "13662": -1,
  "13664": -3,
  "13665": -7,
  "13666": -3,
  "13667": -1,
  "13668": -1,
  "13669": -3,
  "13670": -3,
  "13671": -4,
  "13672": -1,
  "13673": -4,
  "13674": 3,
  "13675": -4,
  "13676": -1,
  "13677": -1,
  "13678": -1,
  "13679": -4,
  "13680": -3,
  "13681": -3,
  "13682": -4,
  "13683": -6,
  "13684": -3,
  "13685": -4,
  "13687": -1,
  "13690": -3,
  "13691": -4,
  "13692": 5,
  "13693": -4,
  "13694": -1,
  "13695": -3,
  "13696": -1,
  "13697": -1,
  "13730": -9,
  "13731": -1,
  "13732": -9,
  "13733": -9,
  "13734": -9,
  "13736": -9,
  "13737": -9,
  "13738": -3,
  "13739": -3,
  "13740": -2,
  "13743": -9,
  "13744": 3,
  "13745": 3,
  "13746": 3,
  "13747": -6,
  "13748": 3,
  "13749": 3,
  "13750": -6,
  "13751": -3,
  "13752": -3,
  "13753": -3,
  "13754": 3,
  "13755": -3,
  "13756": -3,
  "13757": -3,
  "13758": -9,
  "13760": 3,
  "13761": 3,
  "13762": 3,
  "13763": 3,
  "13774": -3,
  "13775": -3,
  "13776": -8,
  "13777": 3,
  "13778": -8,
  "13780": -9,
  "13782": -3,
  "13783": -3,
  "13784": -4,
  "13786": 0,
  "13787": 3,
  "13788": -3,
  "13790": 3,
  "13794": -4,
  "13795": 3,
  "13796": -6,
  "13797": 3,
  "13801": -9,
  "13802": 3,
  "13803": -4,
  "13804": -3,
  "13806": -3,
  "13807": -6,
  "13808": -6,
  "13809": -9,
  "13810": -5,
  "13811": -9,
  "13812": -9,
  "13813": 3,
  "13814": -9,
  "13815": -9,
  "13820": -6,
  "13825": -5,
  "13826": 3,
  "13827": -9,
  "13830": -9,
  "13832": -8,
  "13833": 3,
  "13834": -6,
  "13835": -4,
  "13837": -3,
  "13838": -9,
  "13839": -3,
  "13840": -9,
  "13841": -9,
  "13842": -2,
  "13843": -9,
  "13844": -9,
  "13845": -9,
  "13846": -3,
  "13847": -3,
  "13848": 3,
  "13849": -8,
  "13850": 3,
  "13851": 3,
  "13856": -3,
  "13859": -3,
  "13860": -3,
  "13861": -5,
  "13862": 3,
  "13863": -4,
  "13864": -10,
  "13865": 3,
  "13901": 3,
  "13902": 3,
  "13903": 3,
  "13904": 3,
  "13905": 3,
  "14001": -7,
  "14004": 2,
  "14005": -8,
  "14006": 2,
  "14008": -7,
  "14009": -10,
  "14010": 2,
  "14011": -10,
  "14012": -7,
  "14013": -8,
  "14020": -8,
  "14021": -8,
  "14024": -10,
  "14025": 2,
  "14026": 2,
  "14027": 2,
  "14028": -7,
  "14029": -10,
  "14030": -10,
  "14031": 10,
  "14032": 10,
  "14033": 2,
  "14034": -3,
  "14035": -3,
  "14036": -8,
  "14037": -10,
  "14038": 2,
  "14039": -10,
  "14040": -7,
  "14041": -3,
  "14042": -3,
  "14043": 2,
  "14047": 2,
  "14048": -8,
  "14051": 2,
  "14052": 3,
  "14054": -7,
  "14055": -2,
  "14056": -8,
  "14057": 2,
  "14058": -8,
  "14059": 10,
  "14060": -10,
  "14061": 2,
  "14062": -8,
  "14063": 1,
  "14065": -10,
  "14066": -10,
  "14067": -7,
  "14068": 2,
  "14069": 2,
  "14070": -3,
  "14072": 2,
  "14075": 2,
  "14080": -9,
  "14081": 2,
  "14082": -9,
  "14083": -10,
  "14085": 2,
  "14086": 2,
  "14091": 2,
  "14092": -6,
  "14094": -7,
  "14095": -7,
  "14098": -7,
  "14101": -3,
  "14102": 2,
  "14103": -7,
  "14105": -7,
  "14107": -6,
  "14108": -7,
  "14109": -7,
  "14110": 2,
  "14111": 2,
  "14112": 2,
  "14113": -10,
  "14120": -6,
  "14125": -8,
  "14126": -7,
  "14127": 10,
  "14129": -8,
  "14130": -10,
  "14131": -6,
  "14132": -6,
  "14133": -10,
  "14134": -10,
  "14135": -8,
  "14136": -8,
  "14138": -8,
  "14139": 2,
  "14140": 10,
  "14141": -3,
  "14143": -7,
  "14144": -6,
  "14145": -9,
  "14150": -7,
  "14151": -7,
  "14166": -8,
  "14167": -10,
  "14168": -8,
  "14169": 2,
  "14170": 2,
  "14171": -3,
  "14172": -6,
  "14173": -10,
  "14174": -6,
  "14201": 2,
  "14202": 10,
  "14203": 2,
  "14204": 2,
  "14205": 10,
  "14206": 2,
  "14207": 2,
  "14208": 2,
  "14209": 2,
  "14210": 2,
  "14211": 2,
  "14212": 2,
  "14213": 2,
  "14214": 2,
  "14215": 2,
  "14216": 2,
  "14217": 2,
  "14218": 2,
  "14219": 2,
  "14220": 2,
  "14221": 2,
  "14222": 2,
  "14223": 2,
  "14224": 2,
  "14225": 2,
  "14226": 2,
  "14227": 2,
  "14228": -6,
  "14231": 2,
  "14240": 2,
  "14280": 10,
  "14301": -7,
  "14302": -7,
  "14303": -7,
  "14304": -7,
  "14305": -7,
  "14410": 3,
  "14411": -7,
  "14413": -5,
  "14414": 2,
  "14415": -8,
  "14416": -7,
  "14418": -7,
  "14420": -7,
  "14422": -7,
  "14423": 2,
  "14424": 19,
  "14425": 19,
  "14427": -10,
  "14428": 3,
  "14429": -7,
  "14430": -7,
  "14432": 19,
  "14433": -5,
  "14435": 2,
  "14437": 2,
  "14441": -8,
  "14443": 19,
  "14445": 2,
  "14449": -5,
  "14450": 12,
  "14452": -7,
  "14453": 12,
  "14454": 2,
  "14456": -3,
  "14461": 19,
  "14462": 2,
  "14463": 19,
  "14464": -7,
  "14466": 2,
  "14467": 3,
  "14468": 3,
  "14469": 19,
  "14470": -7,
  "14471": 2,
  "14472": 12,
  "14475": 19,
  "14476": -7,
  "14477": -7,
  "14478": 1,
  "14479": -7,
  "14480": 2,
  "14481": 2,
  "14482": -7,
  "14485": 2,
  "14486": 2,
  "14487": 2,
  "14488": 2,
  "14489": -5,
  "14502": -5,
  "14504": 19,
  "14505": -5,
  "14506": 12,
  "14507": -8,
  "14508": -7,
  "14510": 2,
  "14511": 2,
  "14512": -7,
  "14513": -5,
  "14514": 3,
  "14515": 3,
  "14516": -5,
  "14517": 2,
  "14518": -5,
  "14519": -5,
  "14520": -5,
  "14521": -3,
  "14522": -5,
  "14525": -8,
  "14526": 5,
  "14527": -7,
  "14529": 2,
  "14530": -10,
  "14532": -5,
  "14533": 2,
  "14534": 12,
  "14536": -10,
  "14537": -5,
  "14538": -5,
  "14539": 2,
  "14541": -3,
  "14542": -5,
  "14543": 12,
  "14544": 19,
  "14545": 2,
  "14546": 3,
  "14547": 19,
  "14548": 19,
  "14549": -10,
  "14550": -10,
  "14551": -5,
  "14555": -5,
  "14556": 2,
  "14557": -7,
  "14558": 2,
  "14559": 3,
  "14560": 2,
  "14561": 19,
  "14563": -5,
  "14564": 28,
  "14568": -5,
  "14569": -10,
  "14571": -7,
  "14572": 2,
  "14580": 3,
  "14585": 19,
  "14586": 3,
  "14588": -3,
  "14589": -5,
  "14590": -5,
  "14591": -10,
  "14592": 2,
  "14602": 2,
  "14603": 12,
  "14604": 12,
  "14605": 2,
  "14606": 2,
  "14607": 5,
  "14608": 2,
  "14609": 2,
  "14610": 3,
  "14611": 2,
  "14612": 3,
  "14613": 2,
  "14614": 12,
  "14615": 2,
  "14616": 2,
  "14617": 2,
  "14618": 12,
  "14619": 2,
  "14620": 2,
  "14621": 2,
  "14622": 3,
  "14623": 3,
  "14624": 3,
  "14625": 5,
  "14626": 3,
  "14627": 2,
  "14692": 3,
  "14701": -8,
  "14702": -8,
  "14706": -3,
  "14707": -5,
  "14708": -5,
  "14709": -4,
  "14710": -8,
  "14711": -4,
  "14712": 1,
  "14714": -4,
  "14715": -5,
  "14716": -8,
  "14717": -4,
  "14718": -8,
  "14719": -3,
  "14720": 1,
  "14721": -5,
  "14722": -8,
  "14723": -8,
  "14724": -6,
  "14726": -8,
  "14727": -4,
  "14728": 1,
  "14729": -3,
  "14730": -3,
  "14731": 6,
  "14732": -8,
  "14733": -8,
  "14735": -4,
  "14736": -6,
  "14737": -3,
  "14738": -8,
  "14739": -5,
  "14740": -8,
  "14741": -3,
  "14742": 1,
  "14743": -3,
  "14744": -4,
  "14745": -4,
  "14747": -8,
  "14748": -3,
  "14750": 1,
  "14751": -8,
  "14752": -8,
  "14753": -3,
  "14754": -5,
  "14755": -3,
  "14756": 1,
  "14757": -8,
  "14758": -8,
  "14760": -3,
  "14766": -3,
  "14767": -8,
  "14769": -8,
  "14770": -4,
  "14772": -3,
  "14774": -5,
  "14775": -8,
  "14777": -4,
  "14778": -3,
  "14779": -3,
  "14781": -8,
  "14782": -8,
  "14783": -3,
  "14784": -8,
  "14785": 1,
  "14786": -5,
  "14787": -8,
  "14788": -3,
  "14801": -9,
  "14802": -3,
  "14803": -3,
  "14804": -4,
  "14805": -2,
  "14806": -5,
  "14807": -9,
  "14808": 2,
  "14809": -9,
  "14810": -9,
  "14812": -3,
  "14813": -4,
  "14814": 8,
  "14815": -2,
  "14816": 0,
  "14817": -5,
  "14818": -2,
  "14819": -10,
  "14820": -9,
  "14821": -9,
  "14822": -4,
  "14823": -10,
  "14824": 0,
  "14825": 0,
  "14826": -9,
  "14827": -9,
  "14830": 0,
  "14836": 2,
  "14837": -8,
  "14838": 0,
  "14839": -10,
  "14840": -8,
  "14841": 6,
  "14842": -8,
  "14843": -10,
  "14845": 1,
  "14846": -10,
  "14847": -3,
  "14850": 3,
  "14851": 3,
  "14852": 3,
  "14853": 3,
  "14854": -5,
  "14855": -10,
  "14856": -9,
  "14857": 6,
  "14858": 0,
  "14859": -9,
  "14860": -8,
  "14861": 0,
  "14863": -5,
  "14864": -3,
  "14865": -2,
  "14867": -6,
  "14869": -2,
  "14870": -9,
  "14871": 0,
  "14872": 0,
  "14873": -8,
  "14874": -8,
  "14876": -2,
  "14877": -5,
  "14878": -2,
  "14879": -9,
  "14880": -5,
  "14881": 3,
  "14882": -5,
  "14883": -9,
  "14884": -4,
  "14885": -9,
  "14886": -5,
  "14887": -2,
  "14889": 0,
  "14891": -2,
  "14892": -9,
  "14893": -8,
  "14894": 0,
  "14895": -5,
  "14897": -5,
  "14898": -9,
  "14901": -1,
  "14902": -1,
  "14903": 0,
  "14904": -1,
  "14905": 1,
  "14925": -1,
  "15001": 5,
  "15003": 5,
  "15004": -2,
  "15005": 5,
  "15006": 6,
  "15007": 6,
  "15009": 14,
  "15010": 6,
  "15012": -8,
  "15014": 6,
  "15015": 13,
  "15017": 6,
  "15018": -5,
  "15019": -3,
  "15020": 3,
  "15021": -2,
  "15022": 3,
  "15024": 6,
  "15025": 6,
  "15026": -2,
  "15027": 5,
  "15028": -5,
  "15030": 6,
  "15031": 3,
  "15032": 6,
  "15033": 3,
  "15034": 6,
  "15035": 6,
  "15037": 6,
  "15038": 3,
  "15042": 5,
  "15043": 14,
  "15044": 13,
  "15045": 6,
  "15046": 5,
  "15047": 6,
  "15049": 6,
  "15050": -2,
  "15051": 6,
  "15052": 5,
  "15053": -3,
  "15054": -3,
  "15055": 3,
  "15056": 4,
  "15057": 3,
  "15059": 5,
  "15060": 4,
  "15061": 5,
  "15062": 3,
  "15063": 3,
  "15064": 6,
  "15065": -6,
  "15066": 5,
  "15067": 3,
  "15068": 6,
  "15071": 6,
  "15072": -8,
  "15074": 5,
  "15075": 6,
  "15076": 6,
  "15077": 5,
  "15078": -3,
  "15081": 5,
  "15082": 6,
  "15083": -4,
  "15084": 6,
  "15085": -4,
  "15086": 12,
  "15087": 3,
  "15088": 6,
  "15089": -4,
  "15090": 15,
  "15091": 6,
  "15095": 13,
  "15101": 6,
  "15102": 6,
  "15104": 6,
  "15106": 6,
  "15108": 6,
  "15110": 6,
  "15112": 6,
  "15116": 6,
  "15120": 6,
  "15122": 6,
  "15123": 6,
  "15126": 6,
  "15127": 15,
  "15129": 3,
  "15131": 6,
  "15132": 6,
  "15133": 6,
  "15134": 6,
  "15135": 6,
  "15136": 6,
  "15137": 6,
  "15139": 6,
  "15140": 6,
  "15142": 15,
  "15143": 13,
  "15144": 6,
  "15145": 6,
  "15146": 6,
  "15147": 6,
  "15148": 6,
  "15201": 6,
  "15202": 6,
  "15203": 6,
  "15204": 6,
  "15205": 6,
  "15206": 6,
  "15207": 6,
  "15208": 6,
  "15209": 6,
  "15210": 6,
  "15211": 6,
  "15212": 6,
  "15213": 6,
  "15214": 6,
  "15215": 6,
  "15216": 6,
  "15217": 6,
  "15218": 6,
  "15219": 6,
  "15220": 6,
  "15221": 6,
  "15222": 6,
  "15223": 6,
  "15224": 6,
  "15225": 6,
  "15226": 6,
  "15227": 6,
  "15228": 13,
  "15229": 6,
  "15230": 6,
  "15231": 6,
  "15232": 15,
  "15233": 6,
  "15234": 6,
  "15235": 6,
  "15236": 6,
  "15237": 6,
  "15238": 15,
  "15239": 6,
  "15240": 6,
  "15241": 6,
  "15242": 6,
  "15243": 6,
  "15244": 6,
  "15250": 6,
  "15251": 6,
  "15253": 6,
  "15260": 6,
  "15264": 6,
  "15272": 6,
  "15274": 6,
  "15275": 6,
  "15276": 6,
  "15290": 6,
  "15295": 6,
  "15301": 3,
  "15310": 15,
  "15311": 12,
  "15312": 4,
  "15313": 3,
  "15314": 3,
  "15315": -4,
  "15316": -4,
  "15317": 10,
  "15320": -4,
  "15321": 3,
  "15322": -5,
  "15323": -5,
  "15324": 3,
  "15325": -5,
  "15327": -4,
  "15329": 12,
  "15330": 3,
  "15331": 3,
  "15332": 3,
  "15333": -4,
  "15334": -4,
  "15336": 3,
  "15337": -3,
  "15338": -5,
  "15339": 3,
  "15340": 12,
  "15341": -3,
  "15342": 3,
  "15344": -3,
  "15345": 3,
  "15346": -4,
  "15347": 3,
  "15348": -5,
  "15349": -4,
  "15350": 3,
  "15351": -8,
  "15352": 15,
  "15353": -4,
  "15357": -4,
  "15358": 3,
  "15359": -3,
  "15360": 3,
  "15361": 3,
  "15362": -4,
  "15363": 3,
  "15364": -3,
  "15365": -5,
  "15366": 3,
  "15367": 12,
  "15368": 3,
  "15370": -3,
  "15376": -5,
  "15377": -4,
  "15378": 4,
  "15379": 4,
  "15380": 15,
  "15401": -8,
  "15410": -8,
  "15411": -8,
  "15412": -8,
  "15413": -8,
  "15415": -8,
  "15416": -8,
  "15417": -8,
  "15419": -8,
  "15420": -8,
  "15421": -7,
  "15422": -8,
  "15423": 3,
  "15424": -8,
  "15425": -8,
  "15427": 3,
  "15428": -8,
  "15429": -8,
  "15430": -8,
  "15431": -8,
  "15432": -8,
  "15433": -8,
  "15434": -8,
  "15435": -8,
  "15436": -8,
  "15437": -7,
  "15438": -8,
  "15439": -8,
  "15440": -7,
  "15442": -8,
  "15443": -8,
  "15444": -8,
  "15445": -8,
  "15446": 1,
  "15447": -8,
  "15448": -8,
  "15449": -8,
  "15450": -8,
  "15451": -8,
  "15454": -8,
  "15455": -8,
  "15456": -8,
  "15458": -8,
  "15459": -8,
  "15460": -5,
  "15461": -8,
  "15462": -8,
  "15463": -8,
  "15464": -8,
  "15465": -8,
  "15466": -8,
  "15467": -5,
  "15468": -8,
  "15469": 1,
  "15470": -7,
  "15472": -8,
  "15473": -8,
  "15474": -4,
  "15475": -8,
  "15476": -8,
  "15477": -8,
  "15478": -8,
  "15479": -8,
  "15480": -8,
  "15482": -8,
  "15483": -8,
  "15484": -8,
  "15485": -8,
  "15486": -8,
  "15488": -8,
  "15489": -8,
  "15490": -8,
  "15492": -8,
  "15501": -8,
  "15502": -8,
  "15520": -8,
  "15521": -7,
  "15522": -6,
  "15530": -8,
  "15531": -8,
  "15532": -8,
  "15533": -2,
  "15534": -7,
  "15535": -6,
  "15536": 0,
  "15537": -7,
  "15538": -8,
  "15539": -7,
  "15540": -8,
  "15541": -8,
  "15542": -8,
  "15544": -8,
  "15545": -9,
  "15546": -8,
  "15547": -8,
  "15548": -5,
  "15549": -8,
  "15550": -7,
  "15551": -8,
  "15552": -8,
  "15553": -8,
  "15554": -7,
  "15555": -8,
  "15557": -8,
  "15558": -9,
  "15559": -7,
  "15560": -8,
  "15561": -8,
  "15562": -9,
  "15563": -5,
  "15564": -9,
  "15565": -9,
  "15601": -4,
  "15610": -2,
  "15611": -4,
  "15612": -4,
  "15613": -6,
  "15615": -4,
  "15616": -4,
  "15617": -4,
  "15618": -4,
  "15619": -4,
  "15620": -4,
  "15621": -4,
  "15622": 1,
  "15623": -4,
  "15624": -4,
  "15625": -5,
  "15626": -4,
  "15627": -4,
  "15628": -4,
  "15629": -6,
  "15631": -8,
  "15632": -4,
  "15633": -4,
  "15634": -4,
  "15635": -4,
  "15636": 5,
  "15637": -4,
  "15638": 5,
  "15639": -4,
  "15640": -4,
  "15641": -6,
  "15642": -4,
  "15644": -4,
  "15646": -8,
  "15647": -5,
  "15650": -4,
  "15655": -8,
  "15656": -6,
  "15658": 5,
  "15660": -4,
  "15661": -4,
  "15662": -4,
  "15663": -4,
  "15664": -4,
  "15665": -4,
  "15666": -4,
  "15668": 5,
  "15670": -4,
  "15671": -4,
  "15672": -4,
  "15673": -6,
  "15674": -4,
  "15675": -4,
  "15676": -2,
  "15677": 1,
  "15678": -5,
  "15679": -4,
  "15680": -5,
  "15681": -4,
  "15682": -6,
  "15683": -8,
  "15684": -5,
  "15685": -4,
  "15686": -6,
  "15687": -8,
  "15688": -4,
  "15689": -4,
  "15690": -6,
  "15691": -4,
  "15692": -4,
  "15693": 5,
  "15695": -4,
  "15696": -4,
  "15697": -4,
  "15698": -5,
  "15701": -11,
  "15710": -11,
  "15711": -10,
  "15712": -11,
  "15713": -11,
  "15714": -5,
  "15715": -10,
  "15716": -11,
  "15717": -11,
  "15720": -11,
  "15721": -9,
  "15722": -5,
  "15723": -11,
  "15724": -11,
  "15725": -11,
  "15727": -11,
  "15728": -11,
  "15729": -11,
  "15730": -10,
  "15731": -11,
  "15732": -11,
  "15733": -10,
  "15734": -11,
  "15736": -6,
  "15737": -5,
  "15738": -5,
  "15739": -11,
  "15740": -10,
  "15741": -11,
  "15742": -11,
  "15744": -10,
  "15745": -11,
  "15746": -11,
  "15747": -11,
  "15748": -11,
  "15750": -11,
  "15752": -11,
  "15753": -9,
  "15754": -11,
  "15756": -11,
  "15757": -9,
  "15758": -11,
  "15759": -11,
  "15760": -5,
  "15761": -11,
  "15762": -5,
  "15763": -11,
  "15764": -10,
  "15765": -11,
  "15767": -10,
  "15770": -10,
  "15771": -11,
  "15772": -10,
  "15773": -5,
  "15774": -11,
  "15775": -5,
  "15776": -11,
  "15777": -11,
  "15778": -11,
  "15779": -9,
  "15780": -10,
  "15781": -10,
  "15783": -11,
  "15784": -11,
  "15801": -10,
  "15821": -20,
  "15822": -5,
  "15823": -9,
  "15824": -9,
  "15825": -10,
  "15827": -5,
  "15828": -10,
  "15829": -10,
  "15831": -5,
  "15832": -20,
  "15834": -20,
  "15840": -10,
  "15841": -6,
  "15845": -9,
  "15846": -5,
  "15847": -10,
  "15848": -9,
  "15849": -5,
  "15851": -10,
  "15853": -9,
  "15856": -9,
  "15857": -5,
  "15860": -10,
  "15861": -20,
  "15863": -10,
  "15864": -11,
  "15865": -10,
  "15866": -10,
  "15868": -6,
  "15870": -9,
  "15901": -5,
  "15902": -5,
  "15904": -5,
  "15905": -5,
  "15906": -5,
  "15907": -5,
  "15909": -5,
  "15915": -5,
  "15920": -5,
  "15921": -5,
  "15922": -5,
  "15923": -11,
  "15924": -7,
  "15925": -5,
  "15926": -8,
  "15927": -5,
  "15928": 4,
  "15929": -5,
  "15930": -5,
  "15931": -5,
  "15934": -5,
  "15935": -8,
  "15936": -8,
  "15937": -8,
  "15938": -5,
  "15940": 4,
  "15942": -5,
  "15943": -5,
  "15944": -5,
  "15945": -5,
  "15946": -5,
  "15948": -5,
  "15949": -11,
  "15951": -5,
  "15952": -5,
  "15953": 4,
  "15954": -5,
  "15955": -5,
  "15956": -5,
  "15957": -5,
  "15958": -5,
  "15959": 4,
  "15960": -5,
  "15961": -5,
  "15962": -5,
  "15963": -5,
  "16001": -2,
  "16002": -2,
  "16003": -2,
  "16020": -2,
  "16021": -2,
  "16022": -2,
  "16023": -2,
  "16024": -2,
  "16025": -2,
  "16027": -2,
  "16028": -7,
  "16029": -2,
  "16030": -13,
  "16033": -2,
  "16034": -2,
  "16035": -2,
  "16036": -7,
  "16037": -2,
  "16038": -2,
  "16039": -2,
  "16040": -2,
  "16041": -2,
  "16045": -2,
  "16046": 7,
  "16048": -2,
  "16049": -7,
  "16050": -2,
  "16051": 0,
  "16052": -2,
  "16053": -2,
  "16054": -7,
  "16055": -6,
  "16056": -2,
  "16057": -2,
  "16058": -7,
  "16059": -2,
  "16061": -2,
  "16063": 5,
  "16066": 12,
  "16101": -1,
  "16102": -1,
  "16103": -1,
  "16105": 0,
  "16107": -1,
  "16108": -1,
  "16110": -9,
  "16111": -9,
  "16112": -1,
  "16113": -5,
  "16114": -6,
  "16115": 5,
  "16116": -1,
  "16117": 0,
  "16120": 0,
  "16121": -7,
  "16123": 5,
  "16124": -6,
  "16125": -6,
  "16127": -6,
  "16130": -6,
  "16131": -6,
  "16132": -1,
  "16133": -6,
  "16134": -6,
  "16136": 4,
  "16137": -6,
  "16140": -2,
  "16141": -1,
  "16142": 8,
  "16143": 0,
  "16145": -6,
  "16146": -7,
  "16148": -5,
  "16150": -6,
  "16151": -7,
  "16153": -6,
  "16154": -6,
  "16155": -2,
  "16156": 0,
  "16157": 0,
  "16159": -6,
  "16160": -1,
  "16161": -7,
  "16201": -6,
  "16210": -6,
  "16211": -11,
  "16212": -6,
  "16213": -7,
  "16214": -7,
  "16217": -7,
  "16218": -6,
  "16220": -7,
  "16221": -7,
  "16222": -6,
  "16223": -6,
  "16224": -7,
  "16225": -7,
  "16226": -6,
  "16228": -6,
  "16229": -6,
  "16230": -7,
  "16232": -7,
  "16233": -7,
  "16234": -7,
  "16235": 2,
  "16236": -6,
  "16238": -6,
  "16239": -14,
  "16240": -11,
  "16242": -7,
  "16244": -6,
  "16245": -7,
  "16246": -11,
  "16248": -7,
  "16249": -6,
  "16250": -11,
  "16253": -6,
  "16254": -7,
  "16255": -7,
  "16256": -11,
  "16257": 2,
  "16258": -7,
  "16259": -6,
  "16260": -7,
  "16261": -6,
  "16262": -6,
  "16263": -6,
  "16301": -13,
  "16311": -12,
  "16312": -14,
  "16313": -14,
  "16314": -9,
  "16316": -9,
  "16317": -13,
  "16319": -12,
  "16321": -14,
  "16322": -13,
  "16323": -13,
  "16326": 2,
  "16327": -9,
  "16328": -12,
  "16329": -14,
  "16331": -12,
  "16332": -7,
  "16333": -14,
  "16334": 2,
  "16335": -9,
  "16340": -14,
  "16341": -12,
  "16342": -13,
  "16343": -13,
  "16344": -13,
  "16345": -5,
  "16346": -12,
  "16347": -14,
  "16350": -14,
  "16351": -14,
  "16352": -14,
  "16353": -12,
  "16354": -12,
  "16360": -9,
  "16361": -7,
  "16362": -13,
  "16364": -12,
  "16365": -14,
  "16370": -12,
  "16371": -14,
  "16372": -13,
  "16373": -7,
  "16374": -12,
  "16375": -7,
  "16401": -6,
  "16402": -14,
  "16403": -9,
  "16404": -9,
  "16405": -14,
  "16406": -9,
  "16407": -14,
  "16410": -6,
  "16411": -6,
  "16412": -6,
  "16413": -14,
  "16415": -4,
  "16416": -14,
  "16417": -6,
  "16420": -14,
  "16421": -6,
  "16422": -10,
  "16423": -6,
  "16424": -9,
  "16426": -6,
  "16427": -6,
  "16428": -6,
  "16430": -6,
  "16432": -9,
  "16433": -9,
  "16434": -14,
  "16435": -9,
  "16436": -14,
  "16438": -6,
  "16440": -6,
  "16441": -6,
  "16442": -6,
  "16443": -6,
  "16501": 3,
  "16502": -6,
  "16503": -6,
  "16504": -6,
  "16505": -6,
  "16506": -6,
  "16507": -6,
  "16508": -6,
  "16509": -6,
  "16510": -6,
  "16511": -6,
  "16512": -6,
  "16514": -6,
  "16515": -6,
  "16541": 3,
  "16544": -6,
  "16546": -6,
  "16550": -6,
  "16563": -6,
  "16565": -6,
  "16601": -6,
  "16602": -6,
  "16603": -6,
  "16611": -4,
  "16613": -6,
  "16616": -9,
  "16617": -6,
  "16619": -6,
  "16620": -9,
  "16621": -4,
  "16622": -4,
  "16623": -4,
  "16624": 4,
  "16625": -6,
  "16627": -9,
  "16629": -6,
  "16630": -5,
  "16631": -6,
  "16633": -7,
  "16634": -5,
  "16635": -5,
  "16636": -6,
  "16637": -6,
  "16638": -5,
  "16639": -6,
  "16640": -6,
  "16641": -6,
  "16644": -6,
  "16645": -9,
  "16646": -5,
  "16647": 4,
  "16648": 2,
  "16650": -7,
  "16651": -9,
  "16652": -4,
  "16655": -7,
  "16656": -9,
  "16657": -3,
  "16659": -7,
  "16660": 4,
  "16661": -9,
  "16662": -5,
  "16663": -9,
  "16664": 2,
  "16665": -6,
  "16666": -5,
  "16667": -7,
  "16668": -5,
  "16669": -4,
  "16670": -6,
  "16671": -9,
  "16672": -7,
  "16673": -6,
  "16674": -5,
  "16675": -5,
  "16677": 1,
  "16678": -5,
  "16679": -7,
  "16680": -9,
  "16681": -9,
  "16682": -6,
  "16683": -4,
  "16684": -6,
  "16685": 4,
  "16686": -6,
  "16689": -1,
  "16691": -2,
  "16692": -9,
  "16693": -6,
  "16694": -2,
  "16695": -6,
  "16701": -10,
  "16720": -20,
  "16724": -10,
  "16725": -10,
  "16726": -10,
  "16727": -10,
  "16728": -9,
  "16729": -10,
  "16730": -10,
  "16731": -10,
  "16732": -10,
  "16733": -10,
  "16734": -9,
  "16735": -9,
  "16738": -10,
  "16740": -10,
  "16743": -10,
  "16744": -10,
  "16745": -10,
  "16746": -9,
  "16748": -9,
  "16749": -10,
  "16750": -10,
  "16801": 10,
  "16802": 1,
  "16803": 10,
  "16804": 10,
  "16805": 10,
  "16820": -6,
  "16821": -5,
  "16822": -8,
  "16823": 1,
  "16825": -6,
  "16826": -6,
  "16827": 10,
  "16828": 3,
  "16829": 1,
  "16830": -5,
  "16832": 1,
  "16833": -9,
  "16834": 1,
  "16835": 1,
  "16836": -5,
  "16837": -9,
  "16838": -9,
  "16839": 1,
  "16840": -5,
  "16841": -6,
  "16843": -9,
  "16844": 1,
  "16845": -20,
  "16847": -5,
  "16848": -6,
  "16849": 1,
  "16850": -5,
  "16851": 10,
  "16852": 1,
  "16853": 1,
  "16854": 1,
  "16855": -5,
  "16856": 1,
  "16858": -5,
  "16859": 1,
  "16860": -5,
  "16861": -9,
  "16863": -9,
  "16864": -6,
  "16865": 10,
  "16866": -5,
  "16868": 10,
  "16870": 10,
  "16871": -20,
  "16872": -8,
  "16873": -5,
  "16874": 1,
  "16875": 1,
  "16876": -6,
  "16877": 3,
  "16878": -5,
  "16879": 1,
  "16881": -5,
  "16882": -4,
  "16901": -7,
  "16910": -8,
  "16911": -8,
  "16912": -8,
  "16914": -8,
  "16915": -9,
  "16917": -8,
  "16920": -9,
  "16921": -8,
  "16922": -9,
  "16923": -9,
  "16925": 0,
  "16926": -8,
  "16927": -9,
  "16928": -8,
  "16929": -8,
  "16930": -8,
  "16932": -8,
  "16933": -7,
  "16935": -8,
  "16936": 0,
  "16937": -9,
  "16938": -8,
  "16939": -8,
  "16940": -8,
  "16941": -9,
  "16942": -8,
  "16943": -9,
  "16945": -8,
  "16946": -8,
  "16947": -8,
  "16948": -9,
  "16950": -8,
  "17001": 7,
  "17002": -4,
  "17003": -2,
  "17004": -4,
  "17005": -9,
  "17006": -10,
  "17007": 11,
  "17009": -4,
  "17010": 7,
  "17011": 7,
  "17013": 2,
  "17014": -9,
  "17015": 3,
  "17016": -2,
  "17017": -9,
  "17018": 6,
  "17019": 11,
  "17020": -9,
  "17021": -6,
  "17022": 6,
  "17023": 6,
  "17024": -6,
  "17025": 6,
  "17026": -2,
  "17027": 1,
  "17028": 7,
  "17029": -4,
  "17030": -8,
  "17032": 6,
  "17033": 15,
  "17034": 6,
  "17035": -6,
  "17036": 15,
  "17037": -10,
  "17038": -2,
  "17039": -2,
  "17040": -6,
  "17041": -2,
  "17042": -2,
  "17043": 6,
  "17044": -4,
  "17045": -9,
  "17046": -2,
  "17047": -6,
  "17048": -8,
  "17049": -10,
  "17050": 2,
  "17051": -4,
  "17052": -5,
  "17053": 6,
  "17054": -4,
  "17055": 2,
  "17056": -10,
  "17057": 6,
  "17058": -10,
  "17059": -10,
  "17060": -2,
  "17061": -9,
  "17062": -9,
  "17063": -4,
  "17064": 7,
  "17065": 3,
  "17066": -2,
  "17067": -2,
  "17068": -6,
  "17069": -9,
  "17070": 6,
  "17071": -10,
  "17072": 6,
  "17073": -2,
  "17074": -6,
  "17075": -2,
  "17076": -1,
  "17077": -2,
  "17078": 0,
  "17080": -9,
  "17081": 2,
  "17082": -10,
  "17083": -2,
  "17084": -4,
  "17085": -2,
  "17086": -9,
  "17087": -2,
  "17088": 0,
  "17090": -6,
  "17093": 6,
  "17094": -10,
  "17097": 6,
  "17098": -2,
  "17099": -4,
  "17101": 6,
  "17102": 6,
  "17103": 6,
  "17104": 6,
  "17105": 6,
  "17106": 6,
  "17108": 6,
  "17109": 6,
  "17110": 6,
  "17111": 6,
  "17112": 7,
  "17113": 6,
  "17129": 6,
  "17201": -5,
  "17202": -5,
  "17210": -3,
  "17211": -6,
  "17212": 0,
  "17213": -3,
  "17214": -4,
  "17215": 0,
  "17217": -3,
  "17219": -3,
  "17220": -3,
  "17221": -5,
  "17222": -5,
  "17223": 0,
  "17224": 0,
  "17225": -4,
  "17228": 0,
  "17229": 0,
  "17231": -5,
  "17232": -4,
  "17233": 0,
  "17235": -5,
  "17236": 0,
  "17237": -5,
  "17238": 0,
  "17239": -5,
  "17240": -4,
  "17241": 3,
  "17243": -5,
  "17244": -4,
  "17246": -4,
  "17247": -5,
  "17249": -5,
  "17250": -4,
  "17251": -4,
  "17252": -5,
  "17253": -5,
  "17254": -5,
  "17255": -3,
  "17256": -4,
  "17257": -4,
  "17260": -5,
  "17261": -5,
  "17262": -4,
  "17263": -4,
  "17264": -5,
  "17265": -5,
  "17266": -4,
  "17267": 0,
  "17268": -5,
  "17270": -5,
  "17271": -4,
  "17272": -5,
  "17301": -3,
  "17302": 1,
  "17303": 0,
  "17304": 0,
  "17306": 0,
  "17307": 0,
  "17309": 3,
  "17310": -1,
  "17311": 2,
  "17312": 2,
  "17313": 2,
  "17314": 1,
  "17315": 2,
  "17316": -3,
  "17317": 2,
  "17318": 2,
  "17319": 7,
  "17320": 0,
  "17321": 3,
  "17322": 2,
  "17323": 11,
  "17324": 0,
  "17325": 0,
  "17327": 2,
  "17329": 3,
  "17331": -3,
  "17337": 0,
  "17339": 8,
  "17340": -3,
  "17342": 2,
  "17343": 0,
  "17344": -3,
  "17345": 2,
  "17347": 2,
  "17349": 3,
  "17350": -3,
  "17352": 2,
  "17353": -1,
  "17354": 2,
  "17355": 2,
  "17356": 2,
  "17358": 2,
  "17360": 2,
  "17361": 2,
  "17362": 2,
  "17363": 3,
  "17364": 2,
  "17365": 2,
  "17366": 2,
  "17368": 2,
  "17370": 2,
  "17371": 2,
  "17372": 0,
  "17375": 0,
  "17401": 2,
  "17402": 2,
  "17403": 2,
  "17404": 2,
  "17405": 2,
  "17406": 2,
  "17407": 2,
  "17408": 2,
  "17501": 1,
  "17502": 2,
  "17503": 1,
  "17504": 1,
  "17505": 3,
  "17506": 1,
  "17507": 0,
  "17508": 3,
  "17509": 1,
  "17512": 1,
  "17516": 1,
  "17517": 0,
  "17518": 1,
  "17519": 0,
  "17520": 1,
  "17521": 1,
  "17522": 1,
  "17527": 1,
  "17528": 0,
  "17529": 1,
  "17532": 1,
  "17533": 0,
  "17534": 1,
  "17535": 1,
  "17536": 1,
  "17537": 1,
  "17538": 1,
  "17540": 1,
  "17543": 1,
  "17545": 1,
  "17547": 2,
  "17549": 0,
  "17550": 2,
  "17551": 1,
  "17552": 1,
  "17554": 1,
  "17555": 0,
  "17557": 1,
  "17560": 1,
  "17562": 1,
  "17563": 1,
  "17564": 1,
  "17565": 1,
  "17566": 1,
  "17567": 0,
  "17568": 1,
  "17569": 1,
  "17570": 0,
  "17572": 1,
  "17573": 1,
  "17575": 1,
  "17576": 1,
  "17578": 1,
  "17579": 1,
  "17580": 3,
  "17581": 0,
  "17582": 1,
  "17583": 1,
  "17584": 1,
  "17585": 1,
  "17601": 1,
  "17602": 1,
  "17603": 1,
  "17604": 1,
  "17605": 1,
  "17606": 1,
  "17607": 1,
  "17608": 1,
  "17611": 1,
  "17701": -5,
  "17702": -5,
  "17703": -5,
  "17720": -5,
  "17721": -8,
  "17723": -9,
  "17724": -8,
  "17726": -8,
  "17727": -8,
  "17728": -5,
  "17729": -9,
  "17730": -5,
  "17731": -2,
  "17735": -8,
  "17737": -5,
  "17738": -8,
  "17739": -9,
  "17740": -5,
  "17742": -4,
  "17744": -5,
  "17745": -8,
  "17747": -8,
  "17748": 0,
  "17749": -4,
  "17750": -8,
  "17751": -8,
  "17752": -5,
  "17754": -4,
  "17756": -5,
  "17758": -11,
  "17760": -8,
  "17762": -5,
  "17763": -5,
  "17764": -6,
  "17765": -8,
  "17767": -9,
  "17768": -11,
  "17769": -8,
  "17771": -5,
  "17772": -4,
  "17773": -8,
  "17774": -11,
  "17776": -8,
  "17777": -4,
  "17778": -20,
  "17779": -8,
  "17801": -8,
  "17810": -5,
  "17812": -6,
  "17813": -9,
  "17814": -4,
  "17815": -4,
  "17820": -4,
  "17821": -4,
  "17823": -8,
  "17824": -8,
  "17827": -9,
  "17829": -4,
  "17830": -9,
  "17831": -9,
  "17832": -8,
  "17833": -9,
  "17834": -8,
  "17835": -4,
  "17836": -8,
  "17837": 5,
  "17839": -4,
  "17840": -4,
  "17841": -9,
  "17842": -9,
  "17843": -6,
  "17844": -4,
  "17845": -4,
  "17846": -4,
  "17847": -4,
  "17850": -4,
  "17851": -4,
  "17853": -9,
  "17855": -4,
  "17856": -3,
  "17857": -8,
  "17858": -4,
  "17859": -4,
  "17860": -7,
  "17861": -9,
  "17862": -9,
  "17864": -9,
  "17865": -4,
  "17866": -8,
  "17867": -8,
  "17868": -3,
  "17870": -9,
  "17872": -8,
  "17876": -8,
  "17877": -7,
  "17878": -4,
  "17880": -4,
  "17881": -8,
  "17882": -9,
  "17883": -4,
  "17884": -4,
  "17885": -6,
  "17886": -4,
  "17887": -4,
  "17888": -4,
  "17889": -4,
  "17901": -4,
  "17920": -4,
  "17921": -4,
  "17922": -4,
  "17923": -4,
  "17925": -5,
  "17929": -4,
  "17930": -5,
  "17931": -4,
  "17933": -4,
  "17934": -4,
  "17935": -4,
  "17936": -4,
  "17938": -4,
  "17941": -8,
  "17942": -4,
  "17943": -4,
  "17944": -4,
  "17945": -4,
  "17946": -4,
  "17948": -4,
  "17949": -4,
  "17951": -4,
  "17952": -5,
  "17953": -5,
  "17954": -4,
  "17957": -2,
  "17959": -5,
  "17960": -4,
  "17961": -4,
  "17963": -4,
  "17964": -8,
  "17965": -5,
  "17966": -4,
  "17967": -4,
  "17968": -8,
  "17970": -4,
  "17972": -4,
  "17974": -4,
  "17976": -4,
  "17978": -8,
  "17979": -4,
  "17980": -2,
  "17981": -4,
  "17982": -5,
  "17983": -8,
  "17985": -4,
  "18001": 4,
  "18002": 4,
  "18010": 3,
  "18011": 4,
  "18012": -8,
  "18013": 3,
  "18014": 3,
  "18015": 5,
  "18016": 5,
  "18017": 5,
  "18018": 5,
  "18020": 5,
  "18030": -8,
  "18031": 4,
  "18032": 4,
  "18034": 5,
  "18035": 6,
  "18036": 5,
  "18037": 4,
  "18038": 3,
  "18039": 3,
  "18040": 3,
  "18041": 4,
  "18042": 3,
  "18043": 3,
  "18044": 3,
  "18045": 3,
  "18046": 4,
  "18049": 4,
  "18050": 3,
  "18051": 12,
  "18052": 4,
  "18053": 5,
  "18054": 12,
  "18055": 3,
  "18056": 1,
  "18058": -7,
  "18059": 5,
  "18060": 5,
  "18062": 4,
  "18063": 3,
  "18064": 3,
  "18065": 5,
  "18066": 4,
  "18067": 4,
  "18068": 5,
  "18069": 6,
  "18070": 4,
  "18071": -8,
  "18072": 3,
  "18073": 4,
  "18074": 12,
  "18076": 4,
  "18077": 3,
  "18078": 5,
  "18079": -8,
  "18080": 4,
  "18081": 3,
  "18083": 3,
  "18084": 12,
  "18085": 3,
  "18086": 4,
  "18087": 4,
  "18088": -8,
  "18091": -8,
  "18092": 5,
  "18101": 4,
  "18102": 4,
  "18103": 4,
  "18104": 4,
  "18105": 4,
  "18106": 4,
  "18109": 4,
  "18195": 4,
  "18201": -3,
  "18202": -3,
  "18210": -8,
  "18211": -8,
  "18212": -8,
  "18214": -4,
  "18216": -9,
  "18218": -8,
  "18219": -3,
  "18220": -4,
  "18221": -3,
  "18222": -3,
  "18223": -3,
  "18224": -3,
  "18225": -3,
  "18229": -8,
  "18230": -9,
  "18231": -9,
  "18232": -8,
  "18234": -3,
  "18235": -8,
  "18237": -9,
  "18239": -3,
  "18240": -8,
  "18241": -4,
  "18242": -4,
  "18244": -8,
  "18245": -4,
  "18246": -4,
  "18247": -3,
  "18248": -4,
  "18249": -3,
  "18250": -8,
  "18251": -3,
  "18252": -3,
  "18254": -9,
  "18255": -8,
  "18256": -4,
  "18301": -8,
  "18302": -8,
  "18320": -8,
  "18321": -8,
  "18322": -8,
  "18323": 0,
  "18324": -10,
  "18325": 2,
  "18326": -8,
  "18327": -8,
  "18328": -10,
  "18330": -8,
  "18331": -8,
  "18332": -8,
  "18333": -8,
  "18334": -9,
  "18335": -8,
  "18336": -10,
  "18337": -10,
  "18340": -10,
  "18341": -8,
  "18342": 0,
  "18343": -8,
  "18344": -8,
  "18346": -9,
  "18347": -9,
  "18348": -8,
  "18349": 0,
  "18350": -8,
  "18351": -8,
  "18352": -8,
  "18353": -8,
  "18354": -8,
  "18355": -8,
  "18356": -7,
  "18357": 2,
  "18360": -8,
  "18370": 0,
  "18371": -10,
  "18372": -8,
  "18373": -10,
  "18403": 0,
  "18405": -4,
  "18407": -4,
  "18410": 0,
  "18411": 0,
  "18413": -6,
  "18414": 0,
  "18415": -4,
  "18416": 0,
  "18417": -4,
  "18419": -4,
  "18420": 0,
  "18421": -4,
  "18424": 0,
  "18425": -10,
  "18426": -10,
  "18427": -4,
  "18428": -4,
  "18430": -6,
  "18431": -4,
  "18433": 0,
  "18434": 0,
  "18435": -10,
  "18436": -4,
  "18437": 4,
  "18438": -4,
  "18439": -4,
  "18440": 0,
  "18441": -6,
  "18443": -4,
  "18444": 0,
  "18445": -8,
  "18446": -6,
  "18447": 0,
  "18449": 2,
  "18451": -4,
  "18452": 0,
  "18453": -4,
  "18454": -4,
  "18455": -5,
  "18456": -4,
  "18457": -10,
  "18458": -10,
  "18459": -4,
  "18460": -8,
  "18461": -7,
  "18462": -7,
  "18463": -10,
  "18464": -10,
  "18465": 2,
  "18466": -9,
  "18469": -4,
  "18470": -6,
  "18471": 8,
  "18472": -4,
  "18473": -4,
  "18501": 0,
  "18502": 0,
  "18503": 0,
  "18504": 0,
  "18505": 0,
  "18507": 0,
  "18508": 0,
  "18509": 0,
  "18510": 0,
  "18512": 0,
  "18515": 0,
  "18517": 0,
  "18518": 0,
  "18519": 0,
  "18540": 0,
  "18601": -4,
  "18602": -3,
  "18603": -4,
  "18610": -9,
  "18611": -4,
  "18612": -3,
  "18614": -11,
  "18615": -4,
  "18616": -11,
  "18617": -3,
  "18618": -3,
  "18619": -11,
  "18621": -3,
  "18622": -3,
  "18623": -4,
  "18624": 0,
  "18625": -4,
  "18626": -10,
  "18627": -3,
  "18628": -11,
  "18629": -5,
  "18630": -4,
  "18631": -4,
  "18632": -11,
  "18634": -3,
  "18635": -4,
  "18636": -5,
  "18640": -1,
  "18641": 0,
  "18642": -1,
  "18643": -1,
  "18644": -3,
  "18651": -3,
  "18653": 0,
  "18654": -3,
  "18655": -3,
  "18656": -3,
  "18657": -4,
  "18660": -3,
  "18661": -3,
  "18701": -3,
  "18702": -3,
  "18703": -3,
  "18704": -3,
  "18705": -3,
  "18706": -3,
  "18707": -3,
  "18708": -3,
  "18709": -3,
  "18710": -3,
  "18711": -3,
  "18773": -3,
  "18801": -7,
  "18810": -8,
  "18812": 12,
  "18813": -7,
  "18814": -8,
  "18815": -8,
  "18816": -7,
  "18817": -8,
  "18818": -7,
  "18820": -7,
  "18821": -7,
  "18822": -7,
  "18823": -7,
  "18824": -6,
  "18825": -5,
  "18826": -7,
  "18827": -7,
  "18828": -5,
  "18829": -8,
  "18830": -9,
  "18831": -7,
  "18832": -8,
  "18833": -11,
  "18834": -7,
  "18837": -8,
  "18840": -8,
  "18842": -6,
  "18843": -7,
  "18844": -6,
  "18845": -8,
  "18846": -5,
  "18847": -7,
  "18848": -8,
  "18850": -8,
  "18851": -9,
  "18853": -8,
  "18854": -8,
  "18901": 4,
  "18902": 4,
  "18910": 6,
  "18911": 13,
  "18912": 4,
  "18913": 8,
  "18914": 4,
  "18915": 11,
  "18916": 6,
  "18917": 6,
  "18918": 12,
  "18920": 16,
  "18921": 4,
  "18922": 4,
  "18923": 6,
  "18924": 12,
  "18925": 4,
  "18926": 7,
  "18927": 13,
  "18928": 8,
  "18929": 4,
  "18930": 4,
  "18931": 8,
  "18932": 11,
  "18933": 8,
  "18934": 4,
  "18935": 4,
  "18936": 11,
  "18938": 8,
  "18940": 4,
  "18942": 6,
  "18943": 8,
  "18944": 13,
  "18946": 8,
  "18947": 7,
  "18949": 6,
  "18950": 7,
  "18951": 5,
  "18953": 3,
  "18954": 4,
  "18955": 5,
  "18956": 8,
  "18957": 12,
  "18958": 12,
  "18960": 13,
  "18962": 13,
  "18963": 8,
  "18964": 12,
  "18966": 4,
  "18968": 4,
  "18969": 12,
  "18970": 4,
  "18971": 4,
  "18972": 3,
  "18974": 4,
  "18976": 4,
  "18977": 8,
  "18979": 12,
  "18980": 8,
  "18981": 5,
  "19001": 10,
  "19002": 11,
  "19003": 7,
  "19004": 11,
  "19006": 4,
  "19007": 5,
  "19008": 7,
  "19009": 14,
  "19010": 11,
  "19012": 10,
  "19013": 8,
  "19014": 8,
  "19015": 8,
  "19016": 8,
  "19017": 9,
  "19018": 7,
  "19019": 3,
  "19020": 4,
  "19021": 5,
  "19022": 6,
  "19023": 7,
  "19025": 11,
  "19026": 7,
  "19027": 10,
  "19028": 7,
  "19029": 6,
  "19030": 12,
  "19031": 11,
  "19032": 6,
  "19033": 7,
  "19034": 11,
  "19035": 22,
  "19036": 6,
  "19037": 9,
  "19038": 10,
  "19039": 11,
  "19040": 3,
  "19041": 17,
  "19043": 7,
  "19044": 3,
  "19046": 11,
  "19047": 4,
  "19050": 7,
  "19052": 8,
  "19053": 4,
  "19054": 12,
  "19055": 12,
  "19056": 4,
  "19057": 12,
  "19058": 12,
  "19060": 8,
  "19061": 8,
  "19063": 9,
  "19064": 7,
  "19065": 9,
  "19066": 21,
  "19067": 12,
  "19070": 7,
  "19072": 11,
  "19073": 7,
  "19074": 7,
  "19075": 11,
  "19076": 7,
  "19078": 7,
  "19079": 6,
  "19081": 7,
  "19082": 7,
  "19083": 7,
  "19085": 18,
  "19086": 9,
  "19087": 11,
  "19090": 3,
  "19094": 7,
  "19095": 11,
  "19096": 7,
  "19101": 10,
  "19102": 10,
  "19103": 10,
  "19104": 10,
  "19105": 10,
  "19106": 19,
  "19107": 10,
  "19108": 11,
  "19109": 10,
  "19110": 10,
  "19111": 10,
  "19112": 10,
  "19113": 6,
  "19114": 10,
  "19115": 10,
  "19116": 3,
  "19118": 11,
  "19119": 11,
  "19120": 10,
  "19121": 10,
  "19122": 10,
  "19123": 10,
  "19124": 10,
  "19125": 10,
  "19126": 10,
  "19127": 10,
  "19128": 10,
  "19129": 10,
  "19130": 10,
  "19131": 10,
  "19132": 10,
  "19133": 10,
  "19134": 10,
  "19135": 10,
  "19136": 10,
  "19137": 10,
  "19138": 10,
  "19139": 10,
  "19140": 10,
  "19141": 10,
  "19142": 6,
  "19143": 10,
  "19144": 10,
  "19145": 10,
  "19146": 10,
  "19147": 10,
  "19148": 10,
  "19149": 10,
  "19150": 10,
  "19151": 10,
  "19152": 10,
  "19153": 6,
  "19154": 10,
  "19155": 10,
  "19160": 10,
  "19176": 10,
  "19190": 10,
  "19301": 8,
  "19310": 9,
  "19311": 12,
  "19312": 11,
  "19316": 8,
  "19317": 10,
  "19318": 11,
  "19319": 11,
  "19320": 11,
  "19330": 11,
  "19331": 9,
  "19333": 7,
  "19335": 10,
  "19341": 10,
  "19342": 9,
  "19343": 16,
  "19344": 8,
  "19345": 10,
  "19346": 9,
  "19347": 10,
  "19348": 10,
  "19350": 16,
  "19351": 9,
  "19352": 9,
  "19353": 10,
  "19354": 16,
  "19355": 10,
  "19357": 10,
  "19358": 11,
  "19360": 9,
  "19362": 8,
  "19363": 8,
  "19365": 9,
  "19366": 10,
  "19367": 9,
  "19369": 8,
  "19371": 8,
  "19372": 9,
  "19373": 9,
  "19374": 11,
  "19375": 10,
  "19376": 8,
  "19380": 10,
  "19381": 10,
  "19382": 10,
  "19390": 11,
  "19395": 11,
  "19397": 11,
  "19398": 10,
  "19399": 10,
  "19401": 11,
  "19403": 11,
  "19404": 11,
  "19405": 11,
  "19406": 11,
  "19407": 11,
  "19408": 11,
  "19409": 11,
  "19420": 11,
  "19421": 18,
  "19422": 11,
  "19423": 11,
  "19425": 18,
  "19426": 11,
  "19428": 11,
  "19430": 11,
  "19432": 10,
  "19435": 12,
  "19436": 11,
  "19437": 22,
  "19438": 11,
  "19440": 11,
  "19442": 18,
  "19443": 11,
  "19444": 11,
  "19446": 11,
  "19450": 11,
  "19451": 11,
  "19453": 11,
  "19454": 11,
  "19456": 11,
  "19457": 11,
  "19460": 11,
  "19462": 11,
  "19464": 1,
  "19465": 8,
  "19468": 11,
  "19470": 8,
  "19472": 11,
  "19473": 13,
  "19474": 11,
  "19475": 11,
  "19477": 11,
  "19478": 12,
  "19480": 16,
  "19481": 8,
  "19482": 11,
  "19484": 11,
  "19485": 11,
  "19486": 11,
  "19490": 11,
  "19492": 12,
  "19501": 1,
  "19503": 4,
  "19504": 4,
  "19505": 1,
  "19506": 1,
  "19507": 0,
  "19508": 1,
  "19510": 1,
  "19511": 1,
  "19512": 1,
  "19516": 1,
  "19518": 1,
  "19519": 1,
  "19520": 8,
  "19522": 1,
  "19523": 1,
  "19525": 1,
  "19526": 1,
  "19529": 4,
  "19530": 1,
  "19533": 1,
  "19534": 1,
  "19535": 1,
  "19536": 1,
  "19538": 4,
  "19539": 4,
  "19540": 1,
  "19541": 1,
  "19542": 1,
  "19543": 1,
  "19544": -2,
  "19545": 1,
  "19547": 1,
  "19548": 1,
  "19549": -5,
  "19550": -2,
  "19551": 1,
  "19554": 1,
  "19555": 1,
  "19559": -4,
  "19560": 1,
  "19562": 4,
  "19564": 1,
  "19565": 1,
  "19567": -2,
  "19601": 1,
  "19602": 1,
  "19603": 1,
  "19604": 1,
  "19605": 1,
  "19606": 1,
  "19607": 1,
  "19608": 1,
  "19609": 1,
  "19610": 1,
  "19611": 1,
  "19612": 1,
  "19701": 8,
  "19702": 8,
  "19703": 6,
  "19706": 8,
  "19707": 6,
  "19708": 9,
  "19709": 9,
  "19710": 17,
  "19711": 8,
  "19713": 8,
  "19714": 8,
  "19715": 8,
  "19716": 8,
  "19717": 8,
  "19720": 6,
  "19730": 8,
  "19731": 8,
  "19732": 9,
  "19733": 8,
  "19734": 3,
  "19735": 10,
  "19736": 10,
  "19801": 6,
  "19802": 6,
  "19803": 6,
  "19804": 6,
  "19805": 6,
  "19806": 6,
  "19807": 10,
  "19808": 6,
  "19809": 6,
  "19810": 6,
  "19850": 6,
  "19880": 6,
  "19899": 6,
  "19901": 3,
  "19902": 3,
  "19903": 3,
  "19904": 3,
  "19905": 3,
  "19906": 3,
  "19930": 5,
  "19931": -3,
  "19933": -4,
  "19934": 3,
  "19936": 3,
  "19938": 3,
  "19939": -3,
  "19940": -4,
  "19941": -4,
  "19943": 3,
  "19944": 8,
  "19945": -4,
  "19946": 3,
  "19947": -4,
  "19950": -3,
  "19951": -3,
  "19952": 3,
  "19953": 3,
  "19954": 3,
  "19955": 3,
  "19956": -4,
  "19958": -3,
  "19960": -4,
  "19961": 3,
  "19962": 3,
  "19963": 3,
  "19964": 3,
  "19966": -4,
  "19967": -3,
  "19968": -3,
  "19969": -3,
  "19970": -3,
  "19971": -2,
  "19973": -3,
  "19975": -3,
  "19977": 3,
  "19979": 3,
  "19980": 3,
  "20001": 12,
  "20002": 12,
  "20003": 12,
  "20004": 12,
  "20005": 12,
  "20006": 12,
  "20007": 46,
  "20008": 22,
  "20009": 12,
  "20010": 12,
  "20011": 12,
  "20012": 12,
  "20013": 12,
  "20015": 22,
  "20016": 39,
  "20017": 12,
  "20018": 12,
  "20019": 12,
  "20020": 12,
  "20022": 12,
  "20023": 12,
  "20024": 12,
  "20026": 12,
  "20027": 46,
  "20029": 12,
  "20030": 12,
  "20032": 12,
  "20033": 12,
  "20035": 12,
  "20036": 12,
  "20037": 12,
  "20038": 12,
  "20039": 12,
  "20040": 12,
  "20041": 46,
  "20043": 12,
  "20044": 12,
  "20045": 12,
  "20050": 12,
  "20056": 12,
  "20088": 22,
  "20090": 12,
  "20091": 12,
  "20105": 17,
  "20106": -8,
  "20108": -2,
  "20109": -2,
  "20110": -2,
  "20111": -2,
  "20112": 5,
  "20113": -2,
  "20115": 1,
  "20116": 1,
  "20117": 26,
  "20118": 15,
  "20119": 1,
  "20120": -1,
  "20121": -2,
  "20122": -1,
  "20124": 1,
  "20128": -8,
  "20129": 14,
  "20130": -4,
  "20131": 14,
  "20132": 14,
  "20134": 14,
  "20135": -4,
  "20136": -1,
  "20137": 1,
  "20138": 1,
  "20139": 0,
  "20140": 1,
  "20141": 14,
  "20142": 14,
  "20143": 1,
  "20144": -2,
  "20146": 14,
  "20147": 15,
  "20148": 17,
  "20151": 3,
  "20152": -1,
  "20153": 3,
  "20155": -1,
  "20156": -1,
  "20158": 14,
  "20159": 14,
  "20160": 14,
  "20163": 14,
  "20164": 14,
  "20165": 15,
  "20166": 14,
  "20167": 14,
  "20168": -1,
  "20169": 1,
  "20170": 3,
  "20171": 3,
  "20172": 3,
  "20175": 14,
  "20176": 14,
  "20177": 14,
  "20178": 14,
  "20180": 14,
  "20181": 0,
  "20182": 0,
  "20184": 7,
  "20185": 7,
  "20186": 1,
  "20187": 1,
  "20188": 1,
  "20189": 14,
  "20190": 2,
  "20191": 3,
  "20194": 5,
  "20195": 2,
  "20197": 25,
  "20198": 1,
  "20260": 12,
  "20374": 12,
  "20376": 12,
  "20388": 12,
  "20391": 12,
  "20398": 12,
  "20500": 12,
  "20601": 1,
  "20602": 1,
  "20603": 1,
  "20604": 1,
  "20606": 3,
  "20607": 13,
  "20608": 6,
  "20609": 4,
  "20610": 6,
  "20611": 1,
  "20612": 6,
  "20613": 1,
  "20615": 6,
  "20616": 1,
  "20617": 1,
  "20618": -9,
  "20619": 4,
  "20620": 4,
  "20621": 4,
  "20622": 1,
  "20623": 9,
  "20624": 3,
  "20625": -9,
  "20626": -9,
  "20627": 4,
  "20628": 8,
  "20629": 4,
  "20630": 12,
  "20632": 1,
  "20634": 4,
  "20635": 4,
  "20636": 4,
  "20637": 1,
  "20639": 7,
  "20640": 1,
  "20643": 1,
  "20645": 0,
  "20646": 1,
  "20650": 4,
  "20653": 4,
  "20656": 3,
  "20657": 4,
  "20658": 1,
  "20659": 4,
  "20660": 3,
  "20661": 1,
  "20662": -4,
  "20664": 1,
  "20667": 4,
  "20670": 4,
  "20674": 4,
  "20675": 1,
  "20676": 7,
  "20677": 2,
  "20678": 6,
  "20680": 4,
  "20682": 1,
  "20684": 4,
  "20685": 6,
  "20686": 4,
  "20687": 4,
  "20688": 4,
  "20689": 7,
  "20690": 12,
  "20692": 4,
  "20693": 1,
  "20695": 1,
  "20701": 9,
  "20703": 9,
  "20704": 9,
  "20705": 9,
  "20706": 9,
  "20707": 11,
  "20708": 11,
  "20709": 11,
  "20710": 9,
  "20711": 9,
  "20712": 12,
  "20714": 6,
  "20715": 9,
  "20716": 9,
  "20717": 9,
  "20718": 9,
  "20719": 9,
  "20720": 9,
  "20721": 9,
  "20722": 12,
  "20723": 11,
  "20724": 11,
  "20725": 11,
  "20726": 11,
  "20731": 9,
  "20732": 6,
  "20733": 8,
  "20735": 9,
  "20736": 7,
  "20737": 9,
  "20738": 9,
  "20740": 9,
  "20741": 9,
  "20743": 9,
  "20744": 13,
  "20745": 12,
  "20746": 9,
  "20747": 9,
  "20748": 9,
  "20749": 13,
  "20750": 12,
  "20751": 8,
  "20752": 9,
  "20753": 9,
  "20754": 9,
  "20755": 6,
  "20757": 9,
  "20758": 7,
  "20759": 22,
  "20762": 9,
  "20763": 9,
  "20764": 8,
  "20765": 9,
  "20768": 9,
  "20769": 9,
  "20770": 9,
  "20772": 9,
  "20773": 9,
  "20774": 9,
  "20775": 9,
  "20776": 9,
  "20777": 22,
  "20778": 9,
  "20779": 7,
  "20781": 9,
  "20782": 12,
  "20783": 12,
  "20784": 9,
  "20785": 9,
  "20787": 12,
  "20788": 12,
  "20791": 9,
  "20792": 9,
  "20794": 9,
  "20812": 15,
  "20813": 22,
  "20814": 13,
  "20815": 22,
  "20816": 46,
  "20817": 21,
  "20818": 15,
  "20824": 22,
  "20825": 22,
  "20827": 21,
  "20830": 10,
  "20832": 10,
  "20833": 13,
  "20837": 9,
  "20838": 17,
  "20839": 9,
  "20841": 20,
  "20842": 17,
  "20847": 10,
  "20848": 9,
  "20849": 10,
  "20850": 10,
  "20851": 9,
  "20852": 10,
  "20853": 9,
  "20854": 21,
  "20855": 10,
  "20859": 21,
  "20860": 9,
  "20861": 13,
  "20862": 22,
  "20866": 11,
  "20868": 12,
  "20871": 6,
  "20872": 9,
  "20874": 9,
  "20875": 9,
  "20876": 9,
  "20877": 9,
  "20878": 10,
  "20879": 9,
  "20880": 10,
  "20882": 13,
  "20883": 9,
  "20884": 9,
  "20885": 10,
  "20886": 9,
  "20891": 10,
  "20895": 10,
  "20896": 20,
  "20898": 9,
  "20901": 9,
  "20902": 9,
  "20903": 12,
  "20904": 9,
  "20905": 10,
  "20906": 9,
  "20907": 12,
  "20908": 9,
  "20910": 12,
  "20911": 12,
  "20912": 12,
  "20913": 12,
  "20914": 9,
  "20915": 9,
  "20916": 9,
  "20918": 9,
  "21001": 2,
  "21005": 1,
  "21009": 0,
  "21010": 0,
  "21012": 8,
  "21013": 4,
  "21014": 0,
  "21015": 0,
  "21017": 0,
  "21018": 0,
  "21020": -2,
  "21022": 5,
  "21023": 5,
  "21027": 5,
  "21028": 0,
  "21029": 20,
  "21030": 5,
  "21031": 5,
  "21032": 9,
  "21034": 2,
  "21035": 19,
  "21036": 20,
  "21037": 8,
  "21040": 0,
  "21041": 13,
  "21042": 13,
  "21043": 13,
  "21044": 9,
  "21045": 9,
  "21046": 9,
  "21047": 0,
  "21048": -2,
  "21050": 0,
  "21051": 0,
  "21052": 7,
  "21053": 11,
  "21054": 8,
  "21056": 19,
  "21057": 7,
  "21060": 6,
  "21061": 6,
  "21071": 2,
  "21074": -2,
  "21075": 9,
  "21076": 9,
  "21077": 6,
  "21078": 2,
  "21082": 0,
  "21084": 0,
  "21085": 0,
  "21087": 0,
  "21088": 3,
  "21090": 7,
  "21092": 7,
  "21093": 5,
  "21094": 5,
  "21102": 11,
  "21104": 9,
  "21105": 2,
  "21106": 8,
  "21108": 9,
  "21111": 16,
  "21113": 8,
  "21114": 8,
  "21117": 5,
  "21120": 11,
  "21122": 8,
  "21123": 8,
  "21128": 5,
  "21130": 0,
  "21131": 16,
  "21132": 7,
  "21133": 5,
  "21136": -2,
  "21139": 5,
  "21140": 9,
  "21144": 6,
  "21146": 9,
  "21150": 9,
  "21152": 5,
  "21153": 5,
  "21154": 8,
  "21155": -2,
  "21156": 0,
  "21157": 0,
  "21158": 0,
  "21160": 0,
  "21161": 7,
  "21162": 5,
  "21163": 9,
  "21201": 7,
  "21202": 7,
  "21203": 7,
  "21204": 5,
  "21205": 7,
  "21206": 5,
  "21207": 7,
  "21208": 5,
  "21209": 5,
  "21210": 5,
  "21211": 7,
  "21212": 5,
  "21213": 7,
  "21214": 5,
  "21215": 5,
  "21216": 7,
  "21217": 7,
  "21218": 7,
  "21219": 7,
  "21220": 5,
  "21221": 7,
  "21222": 7,
  "21223": 7,
  "21224": 7,
  "21225": 7,
  "21226": 7,
  "21227": 7,
  "21228": 5,
  "21229": 7,
  "21230": 7,
  "21231": 7,
  "21233": 7,
  "21234": 5,
  "21236": 5,
  "21237": 7,
  "21239": 5,
  "21240": 6,
  "21244": 5,
  "21270": 5,
  "21281": 7,
  "21282": 5,
  "21284": 5,
  "21285": 5,
  "21286": 5,
  "21297": 7,
  "21401": 9,
  "21402": 12,
  "21403": 9,
  "21404": 9,
  "21405": 12,
  "21409": 12,
  "21501": -9,
  "21502": -9,
  "21503": -9,
  "21504": -9,
  "21505": -9,
  "21520": -8,
  "21521": -9,
  "21522": -8,
  "21523": -8,
  "21524": -8,
  "21528": -9,
  "21529": -9,
  "21530": -9,
  "21531": -8,
  "21532": -9,
  "21536": -8,
  "21538": -8,
  "21539": -9,
  "21540": -8,
  "21541": 0,
  "21542": -9,
  "21543": -8,
  "21545": -9,
  "21550": -8,
  "21555": -9,
  "21556": -9,
  "21557": -8,
  "21560": -9,
  "21561": -8,
  "21562": -8,
  "21601": -4,
  "21607": -5,
  "21609": -1,
  "21610": -5,
  "21612": -4,
  "21613": -6,
  "21617": -6,
  "21619": -6,
  "21620": -5,
  "21622": -6,
  "21623": -7,
  "21624": -4,
  "21625": -1,
  "21626": -6,
  "21627": -6,
  "21628": -6,
  "21629": -2,
  "21631": -6,
  "21632": -2,
  "21634": -6,
  "21635": -5,
  "21636": -2,
  "21638": -6,
  "21639": -2,
  "21640": 3,
  "21641": -2,
  "21643": -7,
  "21644": -5,
  "21645": 3,
  "21647": -4,
  "21648": -6,
  "21649": 3,
  "21650": -5,
  "21651": -5,
  "21652": -4,
  "21653": -4,
  "21654": -1,
  "21655": -1,
  "21656": -7,
  "21657": -2,
  "21658": -6,
  "21659": -7,
  "21660": -2,
  "21661": -6,
  "21662": -4,
  "21663": -4,
  "21664": -6,
  "21665": -4,
  "21666": -6,
  "21667": -5,
  "21668": -5,
  "21669": 6,
  "21670": 3,
  "21671": -4,
  "21672": -6,
  "21673": -4,
  "21675": -6,
  "21676": -4,
  "21677": -6,
  "21678": -7,
  "21679": -2,
  "21701": 6,
  "21702": 6,
  "21703": 6,
  "21704": 6,
  "21705": 6,
  "21710": 6,
  "21711": -5,
  "21713": -4,
  "21714": 6,
  "21715": 6,
  "21716": 6,
  "21717": 6,
  "21718": 6,
  "21719": -5,
  "21720": -4,
  "21721": -5,
  "21722": -5,
  "21723": 20,
  "21727": 6,
  "21733": -4,
  "21734": -5,
  "21737": 20,
  "21738": 20,
  "21740": -5,
  "21741": -5,
  "21742": -5,
  "21747": -5,
  "21750": -5,
  "21754": 6,
  "21755": 6,
  "21756": 3,
  "21757": 6,
  "21758": 6,
  "21759": 6,
  "21762": 6,
  "21765": 11,
  "21766": -8,
  "21767": -5,
  "21769": 6,
  "21770": 6,
  "21771": 0,
  "21773": 6,
  "21774": 6,
  "21775": 6,
  "21776": 0,
  "21777": 6,
  "21778": 6,
  "21779": 6,
  "21780": 13,
  "21781": -4,
  "21782": -5,
  "21783": -4,
  "21784": 20,
  "21787": 0,
  "21788": 6,
  "21790": 6,
  "21791": 0,
  "21792": 6,
  "21793": 6,
  "21794": 20,
  "21795": -5,
  "21797": 11,
  "21798": 6,
  "21801": -5,
  "21802": -5,
  "21803": -5,
  "21804": -5,
  "21810": -5,
  "21811": -8,
  "21813": -8,
  "21814": -10,
  "21817": -11,
  "21821": -10,
  "21822": -5,
  "21824": -12,
  "21826": -5,
  "21829": -9,
  "21830": -5,
  "21835": -6,
  "21836": -4,
  "21837": -5,
  "21838": -11,
  "21840": -10,
  "21841": -9,
  "21842": -8,
  "21843": -8,
  "21849": -5,
  "21850": -9,
  "21851": -11,
  "21852": -9,
  "21853": -11,
  "21856": -4,
  "21857": -11,
  "21861": -5,
  "21862": -9,
  "21863": -8,
  "21864": -9,
  "21865": -4,
  "21866": -12,
  "21867": -10,
  "21869": -6,
  "21871": -10,
  "21872": -9,
  "21874": -9,
  "21875": -5,
  "21901": 2,
  "21902": 2,
  "21903": 2,
  "21904": 2,
  "21911": 2,
  "21912": -3,
  "21913": -5,
  "21914": 2,
  "21915": 8,
  "21916": 8,
  "21917": 2,
  "21918": 2,
  "21919": -5,
  "21920": 8,
  "21921": 8,
  "21922": 8,
  "21930": -5,
  "22003": 18,
  "22009": 18,
  "22015": 18,
  "22025": 1,
  "22026": 5,
  "22027": 22,
  "22030": 3,
  "22031": 18,
  "22032": 3,
  "22033": 3,
  "22034": 18,
  "22035": 3,
  "22036": 18,
  "22038": 3,
  "22039": 13,
  "22040": 11,
  "22041": 34,
  "22042": 11,
  "22043": 11,
  "22044": 11,
  "22046": 11,
  "22060": 13,
  "22066": 13,
  "22067": 22,
  "22079": 18,
  "22081": 22,
  "22101": 22,
  "22102": 22,
  "22103": 22,
  "22106": 22,
  "22116": 18,
  "22121": 13,
  "22122": 13,
  "22124": 6,
  "22125": 5,
  "22134": -7,
  "22150": 18,
  "22151": 18,
  "22152": 18,
  "22153": 18,
  "22172": 4,
  "22180": 18,
  "22181": 5,
  "22182": 15,
  "22183": 18,
  "22191": 5,
  "22192": 5,
  "22193": 5,
  "22194": 5,
  "22195": 5,
  "22199": 18,
  "22201": 35,
  "22202": 14,
  "22203": 35,
  "22204": 34,
  "22205": 35,
  "22206": 13,
  "22207": 37,
  "22209": 34,
  "22210": 35,
  "22211": 34,
  "22213": 11,
  "22214": 14,
  "22215": 14,
  "22216": 34,
  "22219": 34,
  "22301": 14,
  "22302": 14,
  "22303": 13,
  "22304": 13,
  "22305": 14,
  "22306": 13,
  "22307": 14,
  "22308": 14,
  "22309": 13,
  "22310": 13,
  "22311": 14,
  "22312": 14,
  "22313": 18,
  "22314": 14,
  "22315": 13,
  "22320": 14,
  "22331": 14,
  "22332": 14,
  "22401": 7,
  "22402": -5,
  "22403": 7,
  "22404": 7,
  "22405": 7,
  "22406": -6,
  "22407": -5,
  "22408": 7,
  "22427": -5,
  "22430": 7,
  "22432": -11,
  "22433": -3,
  "22435": -3,
  "22436": -14,
  "22437": -10,
  "22438": -13,
  "22442": -3,
  "22443": -9,
  "22446": 7,
  "22448": -4,
  "22451": -4,
  "22454": -4,
  "22456": -11,
  "22460": -4,
  "22463": -6,
  "22469": -3,
  "22471": -6,
  "22472": -3,
  "22473": -11,
  "22476": -13,
  "22480": -10,
  "22481": -4,
  "22482": -10,
  "22485": -4,
  "22488": -3,
  "22501": -5,
  "22503": 1,
  "22504": -10,
  "22507": 1,
  "22508": -5,
  "22509": -13,
  "22511": -11,
  "22513": -10,
  "22514": -5,
  "22517": -10,
  "22520": -9,
  "22523": -10,
  "22524": -3,
  "22526": -4,
  "22528": 1,
  "22529": -3,
  "22530": -11,
  "22534": -5,
  "22535": -4,
  "22538": -4,
  "22539": -11,
  "22542": -7,
  "22544": -12,
  "22545": -6,
  "22546": -5,
  "22547": -4,
  "22548": 7,
  "22551": -5,
  "22552": -5,
  "22553": -5,
  "22554": -6,
  "22555": -6,
  "22556": -6,
  "22558": -9,
  "22560": -14,
  "22565": -5,
  "22567": -7,
  "22570": -3,
  "22572": -3,
  "22576": -10,
  "22577": -3,
  "22578": -10,
  "22579": -9,
  "22580": -5,
  "22581": -9,
  "22601": -3,
  "22602": -3,
  "22603": -3,
  "22604": -3,
  "22610": -5,
  "22611": -4,
  "22620": -4,
  "22622": -3,
  "22623": -4,
  "22624": -4,
  "22625": 3,
  "22626": -9,
  "22627": -8,
  "22630": -5,
  "22637": -5,
  "22639": 4,
  "22640": -4,
  "22641": -5,
  "22642": -5,
  "22643": 6,
  "22644": -8,
  "22645": -6,
  "22646": -4,
  "22649": -6,
  "22650": -8,
  "22652": -6,
  "22654": -7,
  "22655": -3,
  "22656": -4,
  "22657": -7,
  "22660": -8,
  "22663": -4,
  "22664": -7,
  "22701": -3,
  "22709": -6,
  "22711": -7,
  "22712": 0,
  "22713": -8,
  "22714": -3,
  "22715": -6,
  "22716": -8,
  "22718": -3,
  "22719": -7,
  "22720": -6,
  "22721": -6,
  "22722": -6,
  "22723": -9,
  "22724": 1,
  "22725": -6,
  "22726": -3,
  "22727": -6,
  "22728": 0,
  "22729": -3,
  "22730": -7,
  "22731": -6,
  "22732": -6,
  "22733": -7,
  "22734": -3,
  "22735": -6,
  "22736": 8,
  "22737": -3,
  "22738": -6,
  "22739": -6,
  "22740": -8,
  "22741": -3,
  "22742": -6,
  "22743": -7,
  "22746": -8,
  "22747": 1,
  "22748": -9,
  "22749": -7,
  "22801": 1,
  "22802": -3,
  "22803": 1,
  "22810": -6,
  "22811": -6,
  "22812": 1,
  "22815": -3,
  "22820": -3,
  "22821": 1,
  "22824": -6,
  "22827": -9,
  "22830": -3,
  "22831": 1,
  "22832": -3,
  "22833": -3,
  "22834": -3,
  "22835": -11,
  "22840": -3,
  "22841": 1,
  "22842": -6,
  "22843": -4,
  "22844": -11,
  "22845": -6,
  "22846": 1,
  "22847": -11,
  "22848": 1,
  "22849": -11,
  "22850": -3,
  "22851": -11,
  "22853": -3,
  "22901": 2,
  "22902": 2,
  "22903": 2,
  "22904": 2,
  "22905": 2,
  "22906": 2,
  "22911": 2,
  "22920": -12,
  "22922": -13,
  "22923": -9,
  "22924": 2,
  "22931": -12,
  "22932": 2,
  "22935": -9,
  "22936": 2,
  "22937": -12,
  "22938": -12,
  "22939": -4,
  "22940": -9,
  "22942": -7,
  "22943": 2,
  "22945": 2,
  "22946": 2,
  "22947": 2,
  "22948": -7,
  "22949": -12,
  "22952": -4,
  "22957": -7,
  "22958": -12,
  "22959": 2,
  "22960": -7,
  "22963": 2,
  "22964": -13,
  "22965": -9,
  "22967": -12,
  "22968": -9,
  "22969": -12,
  "22971": -12,
  "22972": -7,
  "22973": -9,
  "22974": 2,
  "22976": -12,
  "22980": -4,
  "22987": 2,
  "22989": -7,
  "23001": -7,
  "23002": -9,
  "23003": -6,
  "23004": -15,
  "23005": 0,
  "23009": -7,
  "23011": -2,
  "23014": -1,
  "23015": -5,
  "23018": -6,
  "23021": -11,
  "23022": 1,
  "23023": -10,
  "23024": -5,
  "23025": -11,
  "23027": -12,
  "23030": -4,
  "23031": -6,
  "23032": -7,
  "23035": -11,
  "23038": 1,
  "23039": -1,
  "23040": -12,
  "23043": -11,
  "23045": -11,
  "23047": 0,
  "23050": -11,
  "23055": 2,
  "23056": -11,
  "23058": 0,
  "23059": 2,
  "23060": 0,
  "23061": -6,
  "23062": -3,
  "23063": -1,
  "23064": -11,
  "23065": -2,
  "23066": -11,
  "23067": -2,
  "23068": -11,
  "23069": 0,
  "23070": -6,
  "23071": -6,
  "23072": -6,
  "23075": 4,
  "23076": -11,
  "23079": -10,
  "23081": -1,
  "23083": -9,
  "23084": -2,
  "23085": -10,
  "23086": -7,
  "23089": -2,
  "23090": 1,
  "23091": -10,
  "23092": -7,
  "23093": -2,
  "23101": -4,
  "23102": -1,
  "23103": 7,
  "23105": -7,
  "23106": -7,
  "23107": -7,
  "23108": -10,
  "23109": -11,
  "23110": -10,
  "23111": 0,
  "23112": 6,
  "23113": 6,
  "23114": 6,
  "23115": -10,
  "23116": 0,
  "23117": -2,
  "23119": -11,
  "23120": -4,
  "23123": -12,
  "23124": -2,
  "23125": -11,
  "23126": -14,
  "23127": 1,
  "23128": -11,
  "23129": 7,
  "23130": -11,
  "23131": 4,
  "23138": -11,
  "23139": -4,
  "23140": -2,
  "23141": -2,
  "23146": -1,
  "23147": -4,
  "23148": -14,
  "23149": -7,
  "23150": 4,
  "23153": -2,
  "23154": -7,
  "23155": -7,
  "23156": -10,
  "23160": -1,
  "23161": -10,
  "23162": 0,
  "23163": -11,
  "23168": 1,
  "23169": -6,
  "23170": -2,
  "23175": -6,
  "23176": -6,
  "23177": -7,
  "23178": -7,
  "23180": -10,
  "23181": -10,
  "23183": 4,
  "23184": 4,
  "23185": -1,
  "23187": -1,
  "23188": 1,
  "23190": -10,
  "23192": -1,
  "23218": 4,
  "23219": 4,
  "23220": 4,
  "23221": 8,
  "23222": 8,
  "23223": 4,
  "23224": 4,
  "23225": 4,
  "23226": 8,
  "23227": 8,
  "23228": 8,
  "23229": 8,
  "23230": 8,
  "23231": 4,
  "23232": 4,
  "23233": 8,
  "23234": 6,
  "23235": 4,
  "23236": 6,
  "23237": 6,
  "23238": 8,
  "23240": 4,
  "23241": 8,
  "23242": 8,
  "23250": 4,
  "23255": 8,
  "23260": 4,
  "23261": 4,
  "23284": 4,
  "23285": 4,
  "23294": 8,
  "23298": 4,
  "23301": -10,
  "23302": -10,
  "23303": -10,
  "23304": 6,
  "23306": -9,
  "23307": -9,
  "23308": -10,
  "23310": -9,
  "23313": -9,
  "23314": 6,
  "23315": -7,
  "23316": -9,
  "23320": 1,
  "23321": 0,
  "23322": 1,
  "23323": 1,
  "23324": 1,
  "23325": 1,
  "23327": 1,
  "23328": 1,
  "23336": -10,
  "23337": -10,
  "23341": -10,
  "23345": -9,
  "23347": -9,
  "23350": -9,
  "23354": 0,
  "23356": -10,
  "23357": -10,
  "23358": -10,
  "23359": -10,
  "23389": -10,
  "23395": -10,
  "23396": -10,
  "23397": -7,
  "23398": -9,
  "23399": -10,
  "23401": -10,
  "23404": -10,
  "23405": -9,
  "23407": -10,
  "23408": -9,
  "23409": -10,
  "23410": -10,
  "23412": -10,
  "23413": -9,
  "23414": -10,
  "23415": -10,
  "23416": -10,
  "23417": -10,
  "23418": -10,
  "23419": -9,
  "23420": -10,
  "23421": -10,
  "23422": -10,
  "23423": -10,
  "23424": 6,
  "23426": -10,
  "23427": -10,
  "23429": -9,
  "23430": -8,
  "23431": -8,
  "23432": 1,
  "23433": 8,
  "23434": 1,
  "23435": 0,
  "23436": 0,
  "23437": 1,
  "23438": 1,
  "23439": 1,
  "23440": -10,
  "23441": -10,
  "23442": -10,
  "23443": -9,
  "23450": 1,
  "23451": 10,
  "23452": 1,
  "23453": 1,
  "23454": 2,
  "23455": 2,
  "23456": 1,
  "23457": 3,
  "23458": 10,
  "23459": 10,
  "23460": 2,
  "23461": 10,
  "23462": 1,
  "23464": 1,
  "23466": 1,
  "23467": 1,
  "23471": 2,
  "23480": -10,
  "23482": -9,
  "23483": -10,
  "23486": -9,
  "23487": -7,
  "23488": -10,
  "23501": 1,
  "23502": 1,
  "23503": 1,
  "23504": 1,
  "23505": 1,
  "23506": 1,
  "23507": 10,
  "23508": 2,
  "23509": 1,
  "23510": 10,
  "23511": 1,
  "23513": 1,
  "23514": 10,
  "23517": 2,
  "23518": 1,
  "23519": 1,
  "23520": 10,
  "23521": 2,
  "23523": 1,
  "23541": 1,
  "23601": 5,
  "23602": 6,
  "23603": -3,
  "23604": 0,
  "23605": 0,
  "23606": 6,
  "23607": 0,
  "23608": -3,
  "23609": 0,
  "23612": 6,
  "23651": 0,
  "23661": 0,
  "23662": 3,
  "23663": 0,
  "23664": 0,
  "23665": 0,
  "23666": 0,
  "23669": 0,
  "23670": 0,
  "23690": -3,
  "23691": -3,
  "23692": -3,
  "23693": -5,
  "23694": -3,
  "23696": -3,
  "23701": -1,
  "23702": -1,
  "23703": -1,
  "23704": -1,
  "23705": -1,
  "23707": -1,
  "23708": -1,
  "23709": -1,
  "23801": -8,
  "23803": -8,
  "23804": -8,
  "23805": -8,
  "23821": -11,
  "23822": -7,
  "23824": 2,
  "23827": -7,
  "23828": -7,
  "23829": -6,
  "23830": 5,
  "23831": -6,
  "23832": 6,
  "23833": -7,
  "23834": -8,
  "23836": -8,
  "23837": -6,
  "23838": 13,
  "23839": -10,
  "23840": -7,
  "23841": -7,
  "23842": 3,
  "23843": -11,
  "23844": -9,
  "23845": -9,
  "23846": -11,
  "23847": 2,
  "23850": -7,
  "23851": -6,
  "23856": 2,
  "23857": -2,
  "23860": 3,
  "23866": -7,
  "23867": 2,
  "23868": -2,
  "23872": -7,
  "23873": -12,
  "23874": -6,
  "23875": 3,
  "23876": -11,
  "23878": -6,
  "23879": 2,
  "23881": -12,
  "23882": 5,
  "23883": -11,
  "23884": 5,
  "23885": -7,
  "23887": -2,
  "23888": -10,
  "23889": -11,
  "23890": 5,
  "23893": -11,
  "23894": -7,
  "23897": 5,
  "23898": -6,
  "23899": -12,
  "23901": -2,
  "23915": -7,
  "23917": -7,
  "23919": -9,
  "23920": -12,
  "23921": -14,
  "23922": 2,
  "23923": -17,
  "23924": -8,
  "23927": -5,
  "23930": 1,
  "23934": -17,
  "23936": -15,
  "23937": -17,
  "23938": -3,
  "23939": -10,
  "23941": -17,
  "23942": -4,
  "23943": 6,
  "23944": -3,
  "23947": -3,
  "23950": -12,
  "23952": -3,
  "23954": -2,
  "23955": 1,
  "23958": -10,
  "23959": -17,
  "23960": -2,
  "23962": -17,
  "23963": -10,
  "23964": -18,
  "23966": -2,
  "23967": -17,
  "23968": -8,
  "23970": -8,
  "23974": -3,
  "23976": -18,
  "24001": 0,
  "24002": 0,
  "24003": 0,
  "24004": 0,
  "24005": 0,
  "24006": 0,
  "24007": 0,
  "24008": 0,
  "24009": 0,
  "24010": 0,
  "24011": 0,
  "24012": 1,
  "24013": 0,
  "24014": 1,
  "24015": -3,
  "24016": 0,
  "24017": 0,
  "24018": 5,
  "24019": 1,
  "24020": 5,
  "24022": 0,
  "24023": 0,
  "24024": 0,
  "24025": 0,
  "24026": 0,
  "24027": 0,
  "24028": 0,
  "24029": 0,
  "24030": 0,
  "24031": 0,
  "24032": 0,
  "24033": 0,
  "24034": 0,
  "24035": 0,
  "24036": 0,
  "24037": 0,
  "24038": 0,
  "24053": -9,
  "24054": -9,
  "24055": -9,
  "24058": -9,
  "24059": 5,
  "24060": 4,
  "24062": 4,
  "24063": 4,
  "24064": -2,
  "24065": -8,
  "24066": -3,
  "24067": -8,
  "24068": -4,
  "24069": -9,
  "24070": -5,
  "24072": -13,
  "24073": -4,
  "24076": -13,
  "24077": 9,
  "24078": -9,
  "24079": -14,
  "24082": -12,
  "24083": 5,
  "24084": -9,
  "24085": -3,
  "24086": 32,
  "24087": -5,
  "24088": -8,
  "24089": -10,
  "24090": -2,
  "24091": -14,
  "24092": -8,
  "24093": 32,
  "24095": -5,
  "24101": 1,
  "24102": -9,
  "24104": 3,
  "24105": -9,
  "24111": 4,
  "24112": -9,
  "24113": -9,
  "24114": -9,
  "24115": -9,
  "24120": -13,
  "24121": 3,
  "24122": -3,
  "24124": 32,
  "24126": -9,
  "24127": -13,
  "24128": -4,
  "24129": -9,
  "24130": -3,
  "24131": -14,
  "24132": -8,
  "24133": -13,
  "24134": 32,
  "24136": 32,
  "24137": -9,
  "24138": -13,
  "24139": -10,
  "24141": -8,
  "24142": -9,
  "24143": -8,
  "24146": -8,
  "24147": 32,
  "24148": -9,
  "24149": -13,
  "24150": 32,
  "24151": -8,
  "24153": -3,
  "24161": -9,
  "24162": -5,
  "24165": -9,
  "24167": 32,
  "24168": -10,
  "24171": -13,
  "24174": -6,
  "24175": 5,
  "24176": 0,
  "24177": -13,
  "24178": -3,
  "24179": 1,
  "24184": -8,
  "24185": -14,
  "24201": -8,
  "24202": -8,
  "24203": -8,
  "24209": -8,
  "24210": 1,
  "24211": 1,
  "24212": 1,
  "24215": -10,
  "24216": -10,
  "24217": -6,
  "24218": -12,
  "24219": -10,
  "24220": -6,
  "24221": -13,
  "24224": -9,
  "24225": -9,
  "24226": -6,
  "24228": -6,
  "24230": -11,
  "24236": -8,
  "24237": -6,
  "24239": -8,
  "24243": -12,
  "24244": -13,
  "24245": -10,
  "24246": -10,
  "24248": -13,
  "24250": -13,
  "24251": -12,
  "24256": -6,
  "24258": -1,
  "24260": -9,
  "24263": -12,
  "24265": -13,
  "24266": -9,
  "24269": -6,
  "24270": -9,
  "24271": -12,
  "24272": -6,
  "24273": -10,
  "24277": -12,
  "24279": -10,
  "24280": -1,
  "24281": -24,
  "24282": -13,
  "24283": -9,
  "24290": -5,
  "24292": -12,
  "24293": -10,
  "24301": -9,
  "24311": -12,
  "24312": -10,
  "24313": -9,
  "24314": -8,
  "24315": -8,
  "24316": -12,
  "24317": -9,
  "24318": -12,
  "24319": -12,
  "24322": -6,
  "24323": -8,
  "24324": -8,
  "24325": -10,
  "24326": -17,
  "24327": -8,
  "24328": -9,
  "24330": -16,
  "24333": -9,
  "24340": -8,
  "24343": -9,
  "24347": -9,
  "24348": -17,
  "24350": -6,
  "24351": -9,
  "24352": -9,
  "24354": -12,
  "24360": -8,
  "24361": -8,
  "24363": -17,
  "24366": -8,
  "24368": -8,
  "24370": -12,
  "24374": -8,
  "24375": -12,
  "24377": -12,
  "24378": -12,
  "24380": -14,
  "24381": -9,
  "24382": -8,
  "24401": -4,
  "24402": -4,
  "24411": -4,
  "24412": 2,
  "24413": -13,
  "24415": -8,
  "24416": -12,
  "24421": -4,
  "24422": 2,
  "24426": -3,
  "24430": -4,
  "24431": -4,
  "24432": -12,
  "24433": -12,
  "24435": -8,
  "24437": -4,
  "24438": 2,
  "24439": -8,
  "24440": -4,
  "24441": 1,
  "24442": -13,
  "24445": 2,
  "24448": 2,
  "24450": 10,
  "24457": 2,
  "24458": -12,
  "24459": -4,
  "24460": 2,
  "24463": -4,
  "24464": -13,
  "24465": -12,
  "24467": -4,
  "24468": -12,
  "24469": -4,
  "24471": 1,
  "24472": -12,
  "24473": 1,
  "24474": 2,
  "24476": -13,
  "24477": -4,
  "24479": -4,
  "24482": -4,
  "24483": -12,
  "24484": -13,
  "24485": -13,
  "24486": 1,
  "24487": -13,
  "24501": 1,
  "24502": 2,
  "24503": 10,
  "24504": 1,
  "24505": 1,
  "24506": 1,
  "24517": -6,
  "24520": -1,
  "24521": -7,
  "24522": -10,
  "24523": -21,
  "24526": -12,
  "24527": -9,
  "24528": -6,
  "24529": -1,
  "24530": -9,
  "24531": -9,
  "24533": -7,
  "24534": -18,
  "24535": -1,
  "24536": 2,
  "24538": -10,
  "24539": -1,
  "24540": -9,
  "24541": -9,
  "24543": -9,
  "24549": -9,
  "24550": -6,
  "24551": 10,
  "24553": -10,
  "24554": -6,
  "24555": -12,
  "24556": -12,
  "24557": -9,
  "24558": -1,
  "24562": -12,
  "24563": -6,
  "24565": -10,
  "24566": -9,
  "24569": -6,
  "24570": -12,
  "24571": -6,
  "24572": 2,
  "24574": 10,
  "24576": -6,
  "24577": 0,
  "24578": 1,
  "24579": -13,
  "24580": -1,
  "24581": -13,
  "24586": -9,
  "24588": -6,
  "24589": -1,
  "24590": 2,
  "24592": -1,
  "24593": -10,
  "24594": -1,
  "24595": -7,
  "24597": -1,
  "24598": -1,
  "24599": -15,
  "24601": -10,
  "24602": -10,
  "24603": -8,
  "24604": -10,
  "24605": -9,
  "24606": -10,
  "24607": -6,
  "24608": -9,
  "24609": -9,
  "24612": -9,
  "24613": -9,
  "24614": -8,
  "24619": -10,
  "24620": -8,
  "24622": -9,
  "24624": -8,
  "24627": -6,
  "24628": -9,
  "24630": -9,
  "24631": -8,
  "24634": -8,
  "24635": -9,
  "24637": -9,
  "24639": -8,
  "24640": -9,
  "24641": -9,
  "24646": -8,
  "24647": -8,
  "24649": -8,
  "24651": -9,
  "24656": -8,
  "24657": -8,
  "24658": -8,
  "24701": -9,
  "24712": -9,
  "24714": -8,
  "24715": -10,
  "24716": -13,
  "24719": -8,
  "24724": -10,
  "24726": -13,
  "24729": -8,
  "24731": -9,
  "24732": -9,
  "24733": -8,
  "24736": -8,
  "24737": -9,
  "24738": -9,
  "24739": -9,
  "24740": -9,
  "24747": -8,
  "24751": -10,
  "24801": -13,
  "24808": -10,
  "24811": -8,
  "24813": -10,
  "24815": -10,
  "24816": -13,
  "24817": -9,
  "24818": -13,
  "24822": -13,
  "24823": -13,
  "24826": -10,
  "24827": -13,
  "24828": -13,
  "24829": -13,
  "24830": -10,
  "24831": -10,
  "24834": -13,
  "24836": -10,
  "24839": -13,
  "24842": -13,
  "24843": -13,
  "24844": -13,
  "24845": -13,
  "24846": -11,
  "24847": -13,
  "24848": -10,
  "24849": -12,
  "24850": -9,
  "24851": -13,
  "24853": -13,
  "24854": -13,
  "24855": -8,
  "24857": -13,
  "24859": -13,
  "24860": -13,
  "24861": -10,
  "24862": -8,
  "24866": -10,
  "24867": -13,
  "24868": -8,
  "24869": -13,
  "24870": -13,
  "24871": -10,
  "24872": -9,
  "24873": -10,
  "24874": -13,
  "24878": -13,
  "24879": -9,
  "24880": -13,
  "24881": -13,
  "24882": -13,
  "24884": -10,
  "24887": -10,
  "24888": -13,
  "24892": -10,
  "24894": -9,
  "24895": -13,
  "24898": -13,
  "24901": -14,
  "24902": -14,
  "24910": -12,
  "24915": -17,
  "24916": -14,
  "24918": -13,
  "24920": -13,
  "24924": -19,
  "24925": -14,
  "24927": -19,
  "24931": -14,
  "24934": -17,
  "24935": -12,
  "24938": -14,
  "24941": -14,
  "24943": -12,
  "24944": -17,
  "24945": -13,
  "24946": -19,
  "24951": -12,
  "24954": -19,
  "24957": -14,
  "24962": -12,
  "24963": 32,
  "24966": -14,
  "24970": -14,
  "24974": -13,
  "24976": -13,
  "24977": -14,
  "24981": -12,
  "24983": -13,
  "24984": -14,
  "24985": -12,
  "24986": -14,
  "24991": -14,
  "24993": -13,
  "25002": -13,
  "25003": 3,
  "25005": -14,
  "25007": -7,
  "25008": -7,
  "25009": -4,
  "25011": 11,
  "25015": 3,
  "25019": -15,
  "25021": -4,
  "25022": -9,
  "25024": -4,
  "25025": 3,
  "25026": 3,
  "25028": -4,
  "25030": -6,
  "25031": -13,
  "25033": 2,
  "25035": 2,
  "25036": -13,
  "25039": 2,
  "25040": -12,
  "25043": -15,
  "25044": -7,
  "25045": -14,
  "25047": -11,
  "25048": -4,
  "25049": -4,
  "25051": -4,
  "25053": -4,
  "25054": 2,
  "25057": -13,
  "25059": -15,
  "25060": -4,
  "25061": 2,
  "25062": -7,
  "25063": -15,
  "25064": 3,
  "25067": 2,
  "25070": 3,
  "25071": 3,
  "25075": 2,
  "25076": -11,
  "25079": -14,
  "25081": -4,
  "25082": 8,
  "25083": -13,
  "25085": -13,
  "25086": 2,
  "25088": -6,
  "25090": -13,
  "25093": -4,
  "25102": -13,
  "25103": -13,
  "25106": -9,
  "25107": 2,
  "25108": -4,
  "25109": 2,
  "25110": 3,
  "25111": -15,
  "25112": 3,
  "25113": -15,
  "25114": -4,
  "25115": -12,
  "25118": -13,
  "25119": -13,
  "25121": -10,
  "25123": -6,
  "25124": 2,
  "25125": -15,
  "25126": -12,
  "25130": -4,
  "25132": 2,
  "25133": -15,
  "25134": 2,
  "25136": -13,
  "25139": -13,
  "25140": -7,
  "25141": -15,
  "25142": -4,
  "25143": 2,
  "25148": -4,
  "25149": -4,
  "25152": -13,
  "25154": -4,
  "25156": 3,
  "25159": 2,
  "25160": -15,
  "25161": -13,
  "25162": 3,
  "25164": -14,
  "25165": -4,
  "25168": 2,
  "25169": -4,
  "25173": -12,
  "25174": -7,
  "25177": 2,
  "25180": -7,
  "25181": -4,
  "25183": -11,
  "25186": -13,
  "25187": 0,
  "25193": -4,
  "25201": 3,
  "25202": 2,
  "25203": -4,
  "25204": -4,
  "25205": -4,
  "25206": -4,
  "25208": -4,
  "25209": -4,
  "25211": -15,
  "25213": 10,
  "25214": 2,
  "25231": -9,
  "25234": 14,
  "25235": 17,
  "25239": -8,
  "25241": -6,
  "25243": -10,
  "25244": -6,
  "25245": -6,
  "25247": -9,
  "25248": -9,
  "25251": -10,
  "25252": -9,
  "25253": -9,
  "25259": -10,
  "25260": -9,
  "25261": 14,
  "25262": -8,
  "25264": -9,
  "25265": -9,
  "25266": -15,
  "25267": 14,
  "25268": 17,
  "25270": -18,
  "25271": -6,
  "25275": -9,
  "25276": -9,
  "25285": -14,
  "25286": -10,
  "25287": -9,
  "25301": 11,
  "25302": 3,
  "25303": 11,
  "25304": 11,
  "25305": 3,
  "25306": 3,
  "25309": 3,
  "25311": 3,
  "25312": 3,
  "25313": 10,
  "25314": 11,
  "25315": 2,
  "25320": 3,
  "25321": 11,
  "25322": 11,
  "25323": 11,
  "25324": 11,
  "25325": 11,
  "25326": 11,
  "25327": 11,
  "25328": 11,
  "25329": 11,
  "25330": 11,
  "25331": 11,
  "25332": 11,
  "25333": 11,
  "25334": 11,
  "25335": 11,
  "25336": 11,
  "25337": 11,
  "25338": 11,
  "25339": 11,
  "25350": 11,
  "25356": 10,
  "25357": 3,
  "25358": 3,
  "25360": 3,
  "25361": 3,
  "25362": 3,
  "25364": 11,
  "25365": 2,
  "25375": 11,
  "25387": 11,
  "25389": 11,
  "25401": -5,
  "25402": -5,
  "25403": -5,
  "25404": -5,
  "25405": -5,
  "25410": 4,
  "25411": -6,
  "25413": -5,
  "25414": -4,
  "25419": -5,
  "25420": -5,
  "25421": -5,
  "25422": -8,
  "25423": -4,
  "25425": 4,
  "25427": -5,
  "25428": -5,
  "25430": -5,
  "25431": -12,
  "25432": -4,
  "25434": -8,
  "25437": -12,
  "25438": -5,
  "25440": -5,
  "25441": -3,
  "25442": 4,
  "25443": 4,
  "25444": -12,
  "25446": -4,
  "25501": 2,
  "25502": 0,
  "25503": 0,
  "25504": 4,
  "25505": -10,
  "25506": 0,
  "25507": 5,
  "25508": -10,
  "25510": 1,
  "25511": -8,
  "25512": -8,
  "25514": -8,
  "25515": 0,
  "25517": -8,
  "25520": -5,
  "25521": 2,
  "25523": 0,
  "25524": 0,
  "25526": 10,
  "25529": -4,
  "25530": -4,
  "25534": 0,
  "25535": -8,
  "25537": -5,
  "25540": 0,
  "25541": -5,
  "25544": 9,
  "25545": 4,
  "25547": -11,
  "25550": -8,
  "25555": -8,
  "25557": 0,
  "25559": -5,
  "25560": 10,
  "25562": -8,
  "25564": 2,
  "25565": 2,
  "25567": 2,
  "25569": 10,
  "25570": -8,
  "25571": 0,
  "25572": 2,
  "25573": 2,
  "25601": -11,
  "25606": -11,
  "25607": -10,
  "25608": -10,
  "25611": -11,
  "25612": -9,
  "25614": -10,
  "25617": -11,
  "25621": -13,
  "25624": -10,
  "25625": -11,
  "25628": -11,
  "25630": -11,
  "25632": -11,
  "25634": -11,
  "25635": -10,
  "25637": -10,
  "25638": -11,
  "25639": -10,
  "25644": -11,
  "25646": -11,
  "25647": -11,
  "25649": -11,
  "25650": -11,
  "25651": -10,
  "25652": -11,
  "25653": -11,
  "25654": -11,
  "25661": -13,
  "25665": -13,
  "25666": -13,
  "25667": -12,
  "25669": -8,
  "25670": -12,
  "25671": -13,
  "25672": -11,
  "25674": -12,
  "25676": -12,
  "25678": -12,
  "25685": -12,
  "25686": -12,
  "25688": -13,
  "25690": -12,
  "25691": -13,
  "25692": -12,
  "25696": -12,
  "25699": -8,
  "25701": -3,
  "25702": -5,
  "25703": -5,
  "25704": -5,
  "25705": -3,
  "25706": -3,
  "25707": -3,
  "25708": -5,
  "25709": -5,
  "25710": -5,
  "25711": -3,
  "25712": -3,
  "25713": -3,
  "25714": -3,
  "25715": -3,
  "25716": -3,
  "25717": -5,
  "25718": -5,
  "25719": -5,
  "25720": -3,
  "25721": -5,
  "25722": -5,
  "25723": -5,
  "25724": -5,
  "25725": -3,
  "25726": -3,
  "25727": -3,
  "25728": -3,
  "25729": -3,
  "25770": -5,
  "25771": -5,
  "25772": -3,
  "25773": -3,
  "25774": -3,
  "25775": -3,
  "25776": -3,
  "25777": -5,
  "25778": -3,
  "25779": -5,
  "25801": -7,
  "25802": -7,
  "25810": -13,
  "25811": -13,
  "25812": -13,
  "25813": 1,
  "25817": -7,
  "25818": 1,
  "25820": -8,
  "25823": -7,
  "25825": -7,
  "25826": -13,
  "25827": -7,
  "25831": -13,
  "25832": 1,
  "25833": -13,
  "25836": -7,
  "25837": -13,
  "25839": -7,
  "25840": -12,
  "25841": -7,
  "25843": 1,
  "25844": -7,
  "25845": -13,
  "25846": -7,
  "25848": -13,
  "25849": -7,
  "25851": -7,
  "25853": -7,
  "25854": -12,
  "25855": -12,
  "25857": -7,
  "25860": 1,
  "25862": -12,
  "25864": -13,
  "25865": -7,
  "25866": -13,
  "25868": -13,
  "25870": -13,
  "25871": -7,
  "25873": -7,
  "25875": -13,
  "25876": -13,
  "25878": -7,
  "25879": -13,
  "25880": -7,
  "25882": -13,
  "25901": -13,
  "25902": -7,
  "25904": -13,
  "25906": -7,
  "25907": -7,
  "25908": -7,
  "25909": 1,
  "25911": -7,
  "25913": -13,
  "25915": -7,
  "25916": -13,
  "25917": -13,
  "25918": -7,
  "25919": -7,
  "25920": -7,
  "25921": -7,
  "25922": -9,
  "25926": -7,
  "25927": 1,
  "25928": -13,
  "25932": -7,
  "25936": -13,
  "25938": -13,
  "25942": -13,
  "25943": -13,
  "25951": -12,
  "25958": -13,
  "25962": -13,
  "25965": -2,
  "25966": -11,
  "25969": -10,
  "25971": -9,
  "25972": -13,
  "25976": -11,
  "25977": -11,
  "25978": -12,
  "25979": -12,
  "25981": 9,
  "25984": -13,
  "25985": -11,
  "25986": -2,
  "25989": -2,
  "26003": -5,
  "26030": -3,
  "26031": -6,
  "26032": -3,
  "26033": 15,
  "26034": -3,
  "26035": -3,
  "26036": -5,
  "26037": -3,
  "26038": 24,
  "26039": 15,
  "26040": 15,
  "26041": 15,
  "26047": -3,
  "26050": -3,
  "26055": -4,
  "26056": -3,
  "26058": -6,
  "26059": -5,
  "26060": -5,
  "26062": -3,
  "26070": -3,
  "26074": -5,
  "26075": -6,
  "26101": -8,
  "26102": -8,
  "26103": -8,
  "26104": -8,
  "26105": -7,
  "26133": -8,
  "26134": -4,
  "26136": 14,
  "26137": 14,
  "26138": -18,
  "26141": 14,
  "26142": -9,
  "26143": -18,
  "26146": -14,
  "26147": 14,
  "26148": -18,
  "26149": -13,
  "26150": -8,
  "26151": 14,
  "26152": -18,
  "26155": -4,
  "26159": -13,
  "26160": -18,
  "26161": -3,
  "26162": -5,
  "26164": -8,
  "26167": -5,
  "26169": -18,
  "26170": -2,
  "26175": -13,
  "26178": -3,
  "26180": -8,
  "26181": 0,
  "26184": -8,
  "26187": 5,
  "26201": -5,
  "26202": 9,
  "26203": -7,
  "26205": 9,
  "26206": -7,
  "26208": 9,
  "26209": -18,
  "26210": -6,
  "26215": -6,
  "26217": -7,
  "26218": -6,
  "26219": -6,
  "26222": -4,
  "26224": -16,
  "26228": -6,
  "26229": -4,
  "26230": -7,
  "26234": -6,
  "26236": -6,
  "26237": -6,
  "26238": -6,
  "26241": -16,
  "26250": -16,
  "26253": -16,
  "26254": -16,
  "26257": -16,
  "26259": -16,
  "26260": -6,
  "26261": 9,
  "26263": -6,
  "26264": -13,
  "26266": -7,
  "26267": -4,
  "26268": -16,
  "26269": -16,
  "26270": -21,
  "26271": -16,
  "26273": -14,
  "26275": -16,
  "26276": -16,
  "26278": -16,
  "26280": -16,
  "26282": -7,
  "26283": -16,
  "26285": -16,
  "26287": -16,
  "26288": -7,
  "26289": -16,
  "26291": -18,
  "26292": -6,
  "26293": -16,
  "26294": -19,
  "26296": -21,
  "26298": -7,
  "26301": 5,
  "26302": 5,
  "26320": -13,
  "26321": -4,
  "26323": 5,
  "26325": -23,
  "26327": -3,
  "26330": 14,
  "26335": -23,
  "26337": -3,
  "26338": -5,
  "26339": 7,
  "26342": -23,
  "26343": -6,
  "26346": -3,
  "26347": -13,
  "26348": -5,
  "26349": -13,
  "26351": -23,
  "26354": -13,
  "26361": 5,
  "26362": -3,
  "26366": 5,
  "26369": 5,
  "26372": -4,
  "26374": -13,
  "26376": -14,
  "26377": -5,
  "26378": -4,
  "26384": -23,
  "26385": 6,
  "26386": 5,
  "26404": 5,
  "26405": -13,
  "26408": 14,
  "26410": -4,
  "26411": 7,
  "26412": -5,
  "26415": -3,
  "26416": -13,
  "26419": -5,
  "26421": -3,
  "26422": 5,
  "26424": -13,
  "26425": -16,
  "26426": 7,
  "26430": -23,
  "26431": 5,
  "26434": -13,
  "26435": -13,
  "26436": 7,
  "26437": -5,
  "26438": 5,
  "26440": -13,
  "26443": -23,
  "26444": -4,
  "26447": -5,
  "26448": 5,
  "26451": 6,
  "26452": -4,
  "26456": 7,
  "26461": 5,
  "26463": -8,
  "26501": 5,
  "26502": -4,
  "26504": 5,
  "26505": 5,
  "26506": -4,
  "26507": 5,
  "26508": -4,
  "26519": -4,
  "26520": -4,
  "26521": -8,
  "26524": -4,
  "26525": -4,
  "26527": -4,
  "26531": -4,
  "26534": -4,
  "26537": -4,
  "26541": -4,
  "26542": -4,
  "26543": -4,
  "26544": -4,
  "26546": -4,
  "26547": -4,
  "26554": -8,
  "26555": -8,
  "26559": -8,
  "26560": -8,
  "26561": -5,
  "26562": -4,
  "26563": -8,
  "26566": -8,
  "26568": -8,
  "26570": -8,
  "26571": -8,
  "26572": -8,
  "26574": -8,
  "26575": -5,
  "26576": -8,
  "26578": -8,
  "26581": -5,
  "26582": -8,
  "26585": -8,
  "26586": -8,
  "26587": -8,
  "26588": -8,
  "26590": -8,
  "26591": -8,
  "26601": -12,
  "26610": 9,
  "26611": -23,
  "26615": -23,
  "26617": -15,
  "26619": -15,
  "26621": -12,
  "26623": -12,
  "26624": -12,
  "26627": -14,
  "26629": -12,
  "26631": -15,
  "26636": -12,
  "26638": -12,
  "26651": 10,
  "26656": -13,
  "26660": 9,
  "26662": 11,
  "26667": 10,
  "26671": 9,
  "26675": 10,
  "26676": 9,
  "26678": 10,
  "26679": 10,
  "26680": -13,
  "26681": 9,
  "26684": 9,
  "26690": -13,
  "26691": 9,
  "26704": -12,
  "26705": -4,
  "26707": -6,
  "26710": -7,
  "26711": -12,
  "26714": -12,
  "26716": -4,
  "26717": -8,
  "26719": -8,
  "26720": -6,
  "26722": -9,
  "26726": -7,
  "26731": -6,
  "26739": -6,
  "26743": -7,
  "26750": -7,
  "26753": -9,
  "26755": -12,
  "26757": -12,
  "26761": -12,
  "26763": -12,
  "26764": -4,
  "26767": -9,
  "26801": -14,
  "26802": -18,
  "26804": -18,
  "26807": -18,
  "26808": -12,
  "26810": -14,
  "26812": -14,
  "26814": -18,
  "26815": -18,
  "26817": -12,
  "26818": -14,
  "26823": -12,
  "26833": -6,
  "26836": -14,
  "26838": -12,
  "26845": -14,
  "26847": -6,
  "26851": -14,
  "26852": -7,
  "26855": -6,
  "26865": -12,
  "26866": -21,
  "26884": -20,
  "26886": -21,
  "27006": 9,
  "27007": -2,
  "27009": 1,
  "27010": 2,
  "27011": -6,
  "27012": 9,
  "27013": -1,
  "27014": -9,
  "27016": -8,
  "27017": -2,
  "27018": -6,
  "27019": -8,
  "27020": -6,
  "27021": -8,
  "27022": -8,
  "27023": 9,
  "27024": -2,
  "27025": -5,
  "27027": -5,
  "27028": -7,
  "27030": -2,
  "27031": -2,
  "27040": 2,
  "27041": -2,
  "27042": -8,
  "27043": 1,
  "27045": 1,
  "27046": -8,
  "27047": -2,
  "27048": -5,
  "27049": -2,
  "27050": 1,
  "27051": 0,
  "27052": -8,
  "27053": -8,
  "27054": -8,
  "27055": -6,
  "27101": 0,
  "27102": 0,
  "27103": 1,
  "27104": 9,
  "27105": 0,
  "27106": 9,
  "27107": 0,
  "27108": 0,
  "27109": 9,
  "27113": 0,
  "27114": 0,
  "27115": 0,
  "27116": 0,
  "27117": 0,
  "27120": 0,
  "27127": 0,
  "27130": 1,
  "27201": 3,
  "27202": -6,
  "27203": 0,
  "27204": 0,
  "27205": 0,
  "27207": -6,
  "27208": -6,
  "27209": -5,
  "27212": -7,
  "27213": -4,
  "27214": 2,
  "27215": 3,
  "27216": 3,
  "27217": -6,
  "27228": -4,
  "27229": -5,
  "27230": 0,
  "27231": -1,
  "27233": 3,
  "27235": 11,
  "27237": -5,
  "27239": -8,
  "27242": -3,
  "27243": 0,
  "27244": -6,
  "27247": -5,
  "27248": 0,
  "27249": -6,
  "27252": -4,
  "27253": -6,
  "27256": -5,
  "27258": -6,
  "27259": -3,
  "27260": 3,
  "27261": 3,
  "27262": 3,
  "27263": 2,
  "27264": 3,
  "27265": 4,
  "27278": 0,
  "27281": -3,
  "27282": 11,
  "27283": 3,
  "27284": 2,
  "27285": 2,
  "27288": -6,
  "27289": -6,
  "27291": 2,
  "27292": -8,
  "27293": -8,
  "27295": -7,
  "27298": -6,
  "27299": -9,
  "27301": 3,
  "27302": -6,
  "27305": -7,
  "27306": -5,
  "27310": 11,
  "27311": -7,
  "27312": -4,
  "27313": 3,
  "27314": -6,
  "27315": -7,
  "27316": 0,
  "27317": 0,
  "27320": -5,
  "27323": -5,
  "27325": -3,
  "27326": -6,
  "27330": -6,
  "27331": -6,
  "27332": -6,
  "27340": -6,
  "27341": -5,
  "27342": -6,
  "27343": -7,
  "27344": -6,
  "27349": -6,
  "27350": 0,
  "27351": -7,
  "27355": -1,
  "27356": -5,
  "27357": 2,
  "27358": 3,
  "27359": -6,
  "27360": -8,
  "27361": -8,
  "27370": 0,
  "27371": -5,
  "27373": 0,
  "27374": -8,
  "27375": -5,
  "27376": 5,
  "27377": -6,
  "27379": -7,
  "27401": 2,
  "27402": 2,
  "27403": 3,
  "27404": 3,
  "27405": 2,
  "27406": 2,
  "27407": 3,
  "27408": 3,
  "27409": 2,
  "27410": 4,
  "27415": -6,
  "27416": 2,
  "27417": 2,
  "27419": 3,
  "27420": 3,
  "27425": 2,
  "27427": 2,
  "27429": 3,
  "27435": 3,
  "27438": 3,
  "27455": 3,
  "27495": 2,
  "27501": -4,
  "27502": 11,
  "27503": 8,
  "27504": -4,
  "27505": -7,
  "27506": -6,
  "27507": -6,
  "27508": -4,
  "27509": -6,
  "27510": 0,
  "27511": 11,
  "27512": 11,
  "27513": 11,
  "27514": 9,
  "27515": 9,
  "27516": 0,
  "27517": 9,
  "27518": 11,
  "27519": 11,
  "27520": -4,
  "27521": -6,
  "27522": -6,
  "27523": 11,
  "27524": -6,
  "27525": -4,
  "27526": -4,
  "27527": -4,
  "27528": -4,
  "27529": 11,
  "27530": -4,
  "27531": -4,
  "27532": 4,
  "27533": 4,
  "27534": 4,
  "27536": -8,
  "27537": -8,
  "27539": 11,
  "27540": 11,
  "27541": -5,
  "27542": -4,
  "27543": -6,
  "27544": -8,
  "27545": 11,
  "27546": -6,
  "27549": -6,
  "27551": -9,
  "27552": -6,
  "27553": -9,
  "27555": -6,
  "27556": -8,
  "27557": -2,
  "27559": -4,
  "27560": 19,
  "27562": 11,
  "27563": -9,
  "27564": -6,
  "27565": -6,
  "27568": -6,
  "27569": -4,
  "27570": -9,
  "27571": -4,
  "27572": -5,
  "27573": -7,
  "27574": -7,
  "27576": -6,
  "27577": 2,
  "27581": -6,
  "27582": -8,
  "27583": -5,
  "27584": -8,
  "27586": -9,
  "27587": -4,
  "27588": -4,
  "27589": -9,
  "27591": 11,
  "27592": -4,
  "27593": -6,
  "27594": -9,
  "27596": -4,
  "27597": -4,
  "27601": 11,
  "27602": 11,
  "27603": 11,
  "27604": 11,
  "27605": 11,
  "27606": 11,
  "27607": 11,
  "27608": 19,
  "27609": 11,
  "27610": 11,
  "27611": 11,
  "27612": 11,
  "27613": 11,
  "27614": 22,
  "27615": 11,
  "27616": 11,
  "27617": 11,
  "27619": 11,
  "27620": 11,
  "27621": 11,
  "27622": 11,
  "27623": 19,
  "27624": 11,
  "27625": 11,
  "27626": 11,
  "27627": 11,
  "27628": 19,
  "27629": 11,
  "27636": 11,
  "27650": 11,
  "27658": 11,
  "27661": 11,
  "27675": 11,
  "27676": 11,
  "27701": 7,
  "27702": 7,
  "27703": 7,
  "27704": 7,
  "27705": 8,
  "27706": 15,
  "27707": 8,
  "27709": 7,
  "27712": 8,
  "27713": 8,
  "27715": 8,
  "27717": 8,
  "27722": 7,
  "27801": -11,
  "27802": -2,
  "27803": -1,
  "27804": -1,
  "27805": -10,
  "27806": -15,
  "27807": -3,
  "27808": -2,
  "27809": -2,
  "27810": -3,
  "27811": -7,
  "27812": -9,
  "27813": -4,
  "27814": -3,
  "27816": -2,
  "27817": -2,
  "27818": -10,
  "27819": -11,
  "27820": 3,
  "27821": -3,
  "27822": -3,
  "27823": -6,
  "27824": -15,
  "27825": -10,
  "27826": -15,
  "27827": -3,
  "27828": -7,
  "27829": -8,
  "27830": -4,
  "27831": 2,
  "27832": 2,
  "27833": -3,
  "27834": -3,
  "27835": -3,
  "27836": -3,
  "27837": -3,
  "27839": -6,
  "27840": -10,
  "27841": -9,
  "27842": -1,
  "27843": -11,
  "27844": -10,
  "27845": 2,
  "27846": -10,
  "27847": -11,
  "27849": -10,
  "27850": -1,
  "27851": -4,
  "27852": -11,
  "27853": 3,
  "27855": -10,
  "27856": -2,
  "27857": -9,
  "27858": 6,
  "27860": -12,
  "27861": -10,
  "27862": -10,
  "27863": -4,
  "27864": -11,
  "27865": -2,
  "27866": 2,
  "27867": -10,
  "27868": -2,
  "27869": 2,
  "27870": -6,
  "27871": -10,
  "27872": -11,
  "27873": -3,
  "27874": -11,
  "27875": -15,
  "27876": 2,
  "27877": -7,
  "27878": -2,
  "27879": 6,
  "27880": -3,
  "27881": -11,
  "27882": -2,
  "27883": -4,
  "27884": -3,
  "27885": -14,
  "27886": -11,
  "27887": -6,
  "27888": -7,
  "27889": -2,
  "27890": -6,
  "27891": -11,
  "27892": -9,
  "27893": -3,
  "27894": -3,
  "27895": 5,
  "27896": 5,
  "27897": -10,
  "27906": -7,
  "27907": -7,
  "27909": -7,
  "27910": -10,
  "27915": -6,
  "27916": -8,
  "27917": -8,
  "27919": -3,
  "27920": 1,
  "27921": -10,
  "27922": -10,
  "27923": -8,
  "27924": -12,
  "27925": -11,
  "27926": 1,
  "27927": -8,
  "27928": -11,
  "27929": -8,
  "27930": -2,
  "27932": -11,
  "27935": -10,
  "27936": -6,
  "27937": -10,
  "27938": -9,
  "27939": -8,
  "27941": -7,
  "27942": -10,
  "27943": -6,
  "27944": -2,
  "27946": -2,
  "27947": -8,
  "27948": -7,
  "27949": 1,
  "27950": -8,
  "27953": -7,
  "27954": -7,
  "27956": -8,
  "27957": -12,
  "27958": -10,
  "27959": -7,
  "27960": -6,
  "27962": -12,
  "27964": -7,
  "27965": -8,
  "27966": -8,
  "27967": -10,
  "27968": -7,
  "27969": -10,
  "27970": -12,
  "27972": -7,
  "27973": -10,
  "27974": -10,
  "27976": -11,
  "27978": -7,
  "27979": -3,
  "27980": -12,
  "27981": -7,
  "27982": -7,
  "27983": -10,
  "27985": -3,
  "27986": -10,
  "28001": -4,
  "28002": -4,
  "28006": -2,
  "28007": -10,
  "28009": -4,
  "28010": -1,
  "28012": -2,
  "28016": -2,
  "28017": 2,
  "28018": -3,
  "28019": -3,
  "28020": 2,
  "28021": 3,
  "28023": -6,
  "28024": -3,
  "28025": 0,
  "28026": 0,
  "28027": 0,
  "28031": 18,
  "28032": -2,
  "28033": -2,
  "28034": -2,
  "28035": 7,
  "28036": 7,
  "28037": 6,
  "28038": 2,
  "28039": -7,
  "28040": -3,
  "28041": -6,
  "28042": 2,
  "28043": -3,
  "28052": -2,
  "28053": -2,
  "28054": -2,
  "28055": -2,
  "28056": -2,
  "28070": 11,
  "28071": -6,
  "28072": -6,
  "28073": 2,
  "28074": -3,
  "28075": 9,
  "28076": -3,
  "28077": -3,
  "28078": 11,
  "28079": 8,
  "28080": -2,
  "28081": -2,
  "28082": -2,
  "28083": -2,
  "28086": 3,
  "28088": -6,
  "28089": 2,
  "28090": 2,
  "28091": -10,
  "28092": -2,
  "28093": -2,
  "28097": -4,
  "28098": -2,
  "28101": -2,
  "28102": -11,
  "28103": 7,
  "28104": 11,
  "28105": 11,
  "28106": 11,
  "28107": 0,
  "28108": 14,
  "28109": -5,
  "28110": 7,
  "28111": 7,
  "28112": 7,
  "28114": -3,
  "28115": -1,
  "28117": -1,
  "28119": -10,
  "28120": -2,
  "28123": 8,
  "28124": 2,
  "28125": -1,
  "28126": 11,
  "28127": -4,
  "28128": -4,
  "28129": -4,
  "28130": 11,
  "28133": -10,
  "28134": 11,
  "28135": -10,
  "28136": 2,
  "28137": -5,
  "28138": -6,
  "28139": -3,
  "28144": -6,
  "28145": -6,
  "28146": -6,
  "28147": -6,
  "28150": 3,
  "28151": 3,
  "28152": 2,
  "28159": -7,
  "28160": -3,
  "28163": -4,
  "28164": -2,
  "28166": -1,
  "28167": -2,
  "28168": -2,
  "28169": 2,
  "28170": -10,
  "28173": 14,
  "28174": 7,
  "28201": 22,
  "28202": 11,
  "28203": 11,
  "28204": 11,
  "28205": 11,
  "28206": 11,
  "28207": 22,
  "28208": 11,
  "28209": 11,
  "28210": 11,
  "28211": 11,
  "28212": 11,
  "28213": 11,
  "28214": 11,
  "28215": 11,
  "28216": 11,
  "28217": 11,
  "28218": 11,
  "28219": 11,
  "28220": 11,
  "28221": 11,
  "28222": 22,
  "28223": 11,
  "28224": 11,
  "28226": 11,
  "28227": 11,
  "28229": 11,
  "28230": 11,
  "28231": 22,
  "28232": 11,
  "28233": 11,
  "28234": 11,
  "28235": 11,
  "28236": -2,
  "28237": 11,
  "28241": 11,
  "28244": 11,
  "28246": 11,
  "28247": 11,
  "28254": 11,
  "28256": 11,
  "28260": 11,
  "28262": 11,
  "28265": 11,
  "28266": 11,
  "28269": 11,
  "28270": 11,
  "28271": 11,
  "28272": 11,
  "28273": 11,
  "28275": 11,
  "28277": 11,
  "28278": 11,
  "28280": 11,
  "28281": 11,
  "28282": 11,
  "28284": 11,
  "28285": 11,
  "28287": 11,
  "28297": 11,
  "28299": 11,
  "28301": 0,
  "28302": 0,
  "28303": 1,
  "28304": 0,
  "28305": 9,
  "28306": 0,
  "28307": 0,
  "28308": 9,
  "28309": 9,
  "28311": 1,
  "28312": 0,
  "28314": 1,
  "28315": -3,
  "28318": -10,
  "28319": -16,
  "28320": -8,
  "28323": -6,
  "28325": -10,
  "28326": -7,
  "28327": -3,
  "28328": -10,
  "28329": -10,
  "28330": -6,
  "28331": 0,
  "28332": -8,
  "28333": -4,
  "28334": -6,
  "28335": -6,
  "28337": -8,
  "28338": -6,
  "28339": -6,
  "28340": -9,
  "28341": -10,
  "28342": -6,
  "28343": -10,
  "28344": -6,
  "28345": -6,
  "28347": -6,
  "28348": 0,
  "28349": -10,
  "28350": -3,
  "28351": -10,
  "28352": -10,
  "28353": -10,
  "28355": -6,
  "28356": -6,
  "28357": -9,
  "28358": -9,
  "28359": -9,
  "28360": -9,
  "28362": -16,
  "28363": -10,
  "28364": -10,
  "28365": -4,
  "28366": -10,
  "28367": -6,
  "28368": -7,
  "28369": -9,
  "28370": 5,
  "28371": 0,
  "28372": -9,
  "28373": -3,
  "28374": 5,
  "28375": -9,
  "28376": -9,
  "28377": -9,
  "28378": -8,
  "28379": -6,
  "28380": -6,
  "28382": -10,
  "28383": -10,
  "28384": -9,
  "28385": -10,
  "28386": -9,
  "28387": 5,
  "28388": 5,
  "28390": 0,
  "28391": 0,
  "28392": -8,
  "28393": -10,
  "28394": -3,
  "28395": 0,
  "28396": -10,
  "28398": -10,
  "28399": -8,
  "28401": 0,
  "28402": 0,
  "28403": 0,
  "28404": -4,
  "28405": 0,
  "28406": 0,
  "28407": 0,
  "28408": 0,
  "28409": 0,
  "28411": 0,
  "28412": 0,
  "28420": -5,
  "28421": -6,
  "28422": -4,
  "28423": -5,
  "28424": -7,
  "28425": -6,
  "28428": 0,
  "28429": 0,
  "28430": -7,
  "28431": -7,
  "28432": -7,
  "28433": -8,
  "28434": -7,
  "28435": -6,
  "28436": -6,
  "28438": -7,
  "28439": -15,
  "28441": -10,
  "28442": -6,
  "28443": -6,
  "28444": -7,
  "28445": -7,
  "28447": -6,
  "28448": -7,
  "28449": 0,
  "28450": -6,
  "28451": 0,
  "28452": -5,
  "28453": -10,
  "28454": -7,
  "28455": -7,
  "28456": -6,
  "28457": -6,
  "28458": -10,
  "28459": -4,
  "28460": -7,
  "28461": -4,
  "28462": -4,
  "28463": -7,
  "28464": -10,
  "28465": -4,
  "28466": -10,
  "28467": -5,
  "28468": 4,
  "28469": -4,
  "28470": -4,
  "28472": -7,
  "28478": -6,
  "28479": 0,
  "28480": 10,
  "28501": -6,
  "28502": -6,
  "28503": -6,
  "28504": -6,
  "28508": -6,
  "28509": -15,
  "28510": -15,
  "28511": -11,
  "28512": -2,
  "28513": -3,
  "28515": -15,
  "28516": -10,
  "28518": -10,
  "28519": -9,
  "28520": -11,
  "28521": -10,
  "28522": -14,
  "28523": -13,
  "28524": -11,
  "28525": -6,
  "28526": -6,
  "28527": -8,
  "28528": -10,
  "28529": -16,
  "28530": -5,
  "28531": -10,
  "28532": -10,
  "28533": -10,
  "28537": -15,
  "28538": -7,
  "28539": -7,
  "28540": -7,
  "28541": -7,
  "28542": -7,
  "28543": -7,
  "28544": -7,
  "28545": -7,
  "28546": -7,
  "28547": -7,
  "28551": -6,
  "28552": -15,
  "28553": -9,
  "28554": -7,
  "28555": -14,
  "28556": -16,
  "28557": -10,
  "28560": -9,
  "28561": -9,
  "28562": -9,
  "28563": -9,
  "28564": -9,
  "28570": -10,
  "28571": -7,
  "28572": -6,
  "28573": -14,
  "28574": -14,
  "28575": -10,
  "28577": -10,
  "28578": -4,
  "28579": -10,
  "28580": -8,
  "28581": -11,
  "28582": -7,
  "28583": -15,
  "28584": -7,
  "28585": -14,
  "28586": -8,
  "28587": -15,
  "28589": -10,
  "28590": -3,
  "28594": -2,
  "28601": -1,
  "28602": -1,
  "28603": -1,
  "28604": -9,
  "28605": -3,
  "28606": -11,
  "28607": -11,
  "28609": -1,
  "28610": -1,
  "28611": -10,
  "28612": -12,
  "28613": -1,
  "28615": -6,
  "28616": -9,
  "28617": -6,
  "28618": -11,
  "28619": -12,
  "28621": -13,
  "28622": -9,
  "28623": -13,
  "28624": -11,
  "28625": 1,
  "28626": -6,
  "28627": -14,
  "28628": -11,
  "28629": -6,
  "28630": -7,
  "28631": 2,
  "28634": -7,
  "28635": -11,
  "28636": -13,
  "28637": -1,
  "28638": -9,
  "28640": -6,
  "28641": -10,
  "28642": -6,
  "28643": -5,
  "28644": -15,
  "28645": -9,
  "28646": -9,
  "28647": -9,
  "28649": -11,
  "28650": -2,
  "28651": -10,
  "28652": -10,
  "28653": -9,
  "28654": -11,
  "28655": -11,
  "28657": -10,
  "28658": -1,
  "28659": -11,
  "28660": 1,
  "28661": -9,
  "28662": -9,
  "28663": -14,
  "28664": -10,
  "28665": -11,
  "28666": -1,
  "28667": -7,
  "28668": -6,
  "28669": -11,
  "28670": -9,
  "28671": -11,
  "28672": -6,
  "28673": 9,
  "28675": -15,
  "28676": -13,
  "28677": 1,
  "28678": -13,
  "28679": -11,
  "28680": -11,
  "28681": -13,
  "28682": 8,
  "28683": -13,
  "28684": -6,
  "28685": -11,
  "28687": 1,
  "28688": 1,
  "28689": -6,
  "28690": -11,
  "28691": -9,
  "28692": -11,
  "28693": -5,
  "28694": -6,
  "28697": -10,
  "28698": -3,
  "28699": -13,
  "28701": -10,
  "28702": -10,
  "28704": 0,
  "28705": -13,
  "28707": -8,
  "28708": -9,
  "28709": -9,
  "28710": 0,
  "28711": 0,
  "28712": -8,
  "28713": -12,
  "28714": -9,
  "28715": 0,
  "28716": -9,
  "28717": -6,
  "28718": -8,
  "28719": -11,
  "28720": 0,
  "28721": 0,
  "28722": -1,
  "28723": -8,
  "28724": -5,
  "28725": -8,
  "28726": -6,
  "28727": -5,
  "28728": 0,
  "28729": -5,
  "28730": 0,
  "28731": -5,
  "28732": -5,
  "28733": -7,
  "28734": -11,
  "28735": 0,
  "28736": 1,
  "28737": -11,
  "28738": -9,
  "28739": -5,
  "28740": -9,
  "28741": -2,
  "28742": -5,
  "28743": -10,
  "28744": -11,
  "28745": 0,
  "28746": -8,
  "28747": -8,
  "28748": 0,
  "28749": -4,
  "28750": -1,
  "28751": -8,
  "28752": -11,
  "28753": -10,
  "28754": -10,
  "28755": -9,
  "28756": -9,
  "28757": 9,
  "28758": -6,
  "28759": -5,
  "28760": -6,
  "28761": -11,
  "28762": -10,
  "28763": -11,
  "28765": -13,
  "28766": -8,
  "28768": -8,
  "28770": 0,
  "28771": -7,
  "28772": -9,
  "28773": -8,
  "28774": 0,
  "28775": -11,
  "28776": 0,
  "28777": -13,
  "28778": 0,
  "28779": -8,
  "28781": -7,
  "28782": -1,
  "28783": -8,
  "28784": -6,
  "28785": 0,
  "28786": -9,
  "28787": 0,
  "28788": -8,
  "28789": -11,
  "28790": -6,
  "28791": -5,
  "28792": -5,
  "28793": -5,
  "28801": 0,
  "28802": 0,
  "28803": 0,
  "28804": 9,
  "28805": 0,
  "28806": 0,
  "28810": 0,
  "28813": 0,
  "28814": 9,
  "28815": 0,
  "28816": 0,
  "28901": -7,
  "28902": -11,
  "28903": -11,
  "28904": 2,
  "28905": -11,
  "28906": -11,
  "28909": 2,
  "29001": -13,
  "29002": -1,
  "29003": -17,
  "29006": -8,
  "29009": -9,
  "29010": -15,
  "29014": 1,
  "29015": -6,
  "29016": 3,
  "29018": 6,
  "29020": -1,
  "29021": -1,
  "29030": -6,
  "29031": -8,
  "29032": -9,
  "29033": 1,
  "29036": 8,
  "29037": -5,
  "29038": -17,
  "29039": 7,
  "29040": -1,
  "29041": -13,
  "29042": -17,
  "29044": -5,
  "29045": 1,
  "29046": -15,
  "29047": 7,
  "29048": -13,
  "29051": -13,
  "29052": -5,
  "29053": -1,
  "29054": -1,
  "29055": 1,
  "29056": -4,
  "29058": 2,
  "29059": -5,
  "29061": 1,
  "29062": -10,
  "29063": -1,
  "29065": -7,
  "29067": 2,
  "29069": -14,
  "29070": -1,
  "29071": 8,
  "29072": 8,
  "29073": -1,
  "29074": -8,
  "29075": -7,
  "29078": -8,
  "29079": -5,
  "29080": -15,
  "29081": -16,
  "29082": -19,
  "29101": -15,
  "29102": -13,
  "29104": -1,
  "29105": -9,
  "29107": 7,
  "29108": -6,
  "29111": -13,
  "29112": -5,
  "29113": -17,
  "29114": -4,
  "29115": 8,
  "29116": 8,
  "29118": 8,
  "29122": -6,
  "29123": -1,
  "29125": -13,
  "29126": -6,
  "29127": -6,
  "29128": -10,
  "29129": -8,
  "29130": -6,
  "29132": -6,
  "29133": 7,
  "29135": -5,
  "29137": -1,
  "29138": -8,
  "29142": 7,
  "29143": -13,
  "29145": -6,
  "29146": -1,
  "29147": 1,
  "29148": -13,
  "29150": -1,
  "29151": -1,
  "29152": -1,
  "29153": -1,
  "29154": 8,
  "29160": -5,
  "29161": -4,
  "29162": -13,
  "29163": -14,
  "29164": 9,
  "29166": -9,
  "29168": -1,
  "29169": 1,
  "29170": -1,
  "29171": 1,
  "29172": -1,
  "29175": -9,
  "29177": 8,
  "29178": -8,
  "29180": -6,
  "29201": 1,
  "29202": 3,
  "29203": 1,
  "29204": 1,
  "29205": 3,
  "29206": 10,
  "29207": 10,
  "29209": 1,
  "29210": 1,
  "29211": 8,
  "29212": 1,
  "29221": 1,
  "29222": 1,
  "29223": 1,
  "29224": 1,
  "29228": -1,
  "29229": 10,
  "29230": 1,
  "29240": 1,
  "29250": 3,
  "29260": 10,
  "29290": 1,
  "29292": -1,
  "29301": -2,
  "29302": -2,
  "29303": -2,
  "29304": -2,
  "29305": -2,
  "29306": -2,
  "29307": -3,
  "29316": -2,
  "29318": -2,
  "29320": -2,
  "29321": -8,
  "29322": -2,
  "29323": -2,
  "29324": -2,
  "29325": -7,
  "29329": -2,
  "29330": -3,
  "29331": -7,
  "29332": -6,
  "29333": -2,
  "29334": -2,
  "29335": -7,
  "29336": -2,
  "29338": -2,
  "29340": -3,
  "29341": -3,
  "29342": -3,
  "29346": -1,
  "29348": -2,
  "29349": -2,
  "29351": -7,
  "29353": -8,
  "29355": -8,
  "29356": -2,
  "29360": -7,
  "29364": -8,
  "29365": -2,
  "29368": -3,
  "29369": 6,
  "29370": -7,
  "29372": -3,
  "29373": -3,
  "29374": -8,
  "29375": -2,
  "29376": -2,
  "29377": -2,
  "29378": -2,
  "29379": -8,
  "29384": -6,
  "29385": -2,
  "29386": -3,
  "29388": -2,
  "29401": 20,
  "29402": 20,
  "29403": 8,
  "29404": 6,
  "29405": 6,
  "29406": 6,
  "29407": 9,
  "29410": -1,
  "29412": 9,
  "29413": 20,
  "29414": 9,
  "29415": -1,
  "29416": 6,
  "29417": 9,
  "29418": 6,
  "29419": 6,
  "29420": 6,
  "29422": 11,
  "29423": 6,
  "29426": -5,
  "29429": -1,
  "29430": -2,
  "29431": -1,
  "29432": -19,
  "29433": -8,
  "29434": -2,
  "29435": -5,
  "29436": -1,
  "29437": -5,
  "29438": 9,
  "29439": 11,
  "29440": -6,
  "29442": -6,
  "29445": -1,
  "29446": -6,
  "29447": -5,
  "29448": -5,
  "29449": 8,
  "29450": -1,
  "29451": 11,
  "29452": -8,
  "29453": -8,
  "29455": 8,
  "29456": -1,
  "29457": 8,
  "29458": -7,
  "29461": -1,
  "29464": 9,
  "29465": 9,
  "29466": 9,
  "29468": -14,
  "29469": 7,
  "29470": 6,
  "29471": 6,
  "29472": -5,
  "29474": -8,
  "29475": -8,
  "29476": -1,
  "29477": -5,
  "29479": -1,
  "29481": -9,
  "29482": 20,
  "29483": -5,
  "29484": -5,
  "29485": -3,
  "29487": 8,
  "29488": -8,
  "29492": 15,
  "29493": -8,
  "29501": 4,
  "29502": 4,
  "29503": 4,
  "29504": 4,
  "29505": 4,
  "29506": -4,
  "29510": -10,
  "29511": -7,
  "29512": -8,
  "29516": -9,
  "29518": -4,
  "29519": -8,
  "29520": -15,
  "29525": -8,
  "29526": -4,
  "29527": -4,
  "29528": -4,
  "29530": -4,
  "29532": -5,
  "29536": -15,
  "29540": -5,
  "29541": 4,
  "29543": -15,
  "29544": -7,
  "29545": -7,
  "29546": -7,
  "29547": -15,
  "29550": -5,
  "29551": -5,
  "29554": -10,
  "29555": -10,
  "29556": -10,
  "29560": -4,
  "29563": -15,
  "29564": -11,
  "29565": -15,
  "29566": -4,
  "29567": -15,
  "29568": -4,
  "29569": -4,
  "29570": -8,
  "29571": -7,
  "29572": 4,
  "29573": -15,
  "29574": -7,
  "29575": -4,
  "29576": -6,
  "29577": -4,
  "29578": -4,
  "29579": -4,
  "29580": -11,
  "29581": -7,
  "29582": -4,
  "29583": -4,
  "29584": -15,
  "29585": 3,
  "29587": -4,
  "29588": -4,
  "29589": -7,
  "29590": -11,
  "29591": -4,
  "29592": -15,
  "29593": -5,
  "29594": -9,
  "29596": -8,
  "29597": -4,
  "29598": -4,
  "29601": 10,
  "29602": 10,
  "29603": 10,
  "29604": 10,
  "29605": 10,
  "29606": 10,
  "29607": 10,
  "29608": 10,
  "29609": 10,
  "29610": 10,
  "29611": 9,
  "29612": 10,
  "29615": 10,
  "29616": 10,
  "29617": 10,
  "29620": -13,
  "29621": -6,
  "29622": -7,
  "29623": -7,
  "29624": -7,
  "29625": -7,
  "29626": -7,
  "29627": -7,
  "29628": -13,
  "29630": -9,
  "29631": 0,
  "29633": -8,
  "29635": -7,
  "29636": 10,
  "29638": -7,
  "29639": -13,
  "29640": -7,
  "29641": -7,
  "29642": -7,
  "29643": -8,
  "29644": 10,
  "29645": -6,
  "29646": -6,
  "29648": -6,
  "29649": -5,
  "29650": 10,
  "29651": 10,
  "29652": 10,
  "29653": -6,
  "29654": -7,
  "29655": -13,
  "29656": -7,
  "29657": -8,
  "29658": -8,
  "29659": -13,
  "29661": 9,
  "29662": 10,
  "29664": -8,
  "29665": -8,
  "29666": -4,
  "29667": -9,
  "29669": -7,
  "29670": -7,
  "29671": -7,
  "29672": -8,
  "29673": 10,
  "29675": -8,
  "29676": 0,
  "29677": -6,
  "29678": -8,
  "29679": -8,
  "29680": 10,
  "29681": 10,
  "29682": -9,
  "29683": 9,
  "29684": -7,
  "29685": -7,
  "29686": 0,
  "29687": 10,
  "29688": 10,
  "29689": -7,
  "29690": 10,
  "29691": -8,
  "29692": -7,
  "29693": -8,
  "29696": -8,
  "29697": -7,
  "29702": -2,
  "29703": 5,
  "29704": 5,
  "29706": -1,
  "29707": 5,
  "29708": 5,
  "29709": -15,
  "29710": 5,
  "29712": -1,
  "29714": 2,
  "29715": 5,
  "29716": 5,
  "29717": -2,
  "29718": -15,
  "29720": 2,
  "29721": 2,
  "29724": -1,
  "29726": 5,
  "29727": -15,
  "29728": -15,
  "29729": -1,
  "29730": 5,
  "29731": 5,
  "29732": 5,
  "29734": 5,
  "29741": -15,
  "29742": -7,
  "29743": -2,
  "29744": 5,
  "29745": 5,
  "29801": 9,
  "29802": 9,
  "29803": 17,
  "29804": 8,
  "29805": 9,
  "29809": 9,
  "29810": -7,
  "29812": -1,
  "29813": -1,
  "29816": 8,
  "29817": -1,
  "29819": -6,
  "29821": -6,
  "29822": -6,
  "29824": -5,
  "29826": -1,
  "29827": -7,
  "29828": 8,
  "29829": 9,
  "29831": -6,
  "29832": -5,
  "29834": 8,
  "29835": -2,
  "29836": -7,
  "29838": 7,
  "29839": 8,
  "29840": -2,
  "29841": -6,
  "29842": -6,
  "29843": -17,
  "29844": -2,
  "29845": -3,
  "29846": -7,
  "29847": -5,
  "29848": -2,
  "29849": -7,
  "29850": 9,
  "29851": 8,
  "29853": -1,
  "29856": 8,
  "29860": -6,
  "29861": -6,
  "29901": -1,
  "29902": -2,
  "29903": -2,
  "29904": -2,
  "29905": -2,
  "29906": -1,
  "29907": -1,
  "29909": 7,
  "29910": 7,
  "29911": -7,
  "29912": -1,
  "29913": -8,
  "29914": -2,
  "29915": 7,
  "29916": -8,
  "29918": -8,
  "29920": -1,
  "29921": -8,
  "29922": -8,
  "29923": -7,
  "29924": -8,
  "29925": 9,
  "29926": 7,
  "29927": -1,
  "29928": 9,
  "29929": -9,
  "29931": -2,
  "29932": -7,
  "29933": -9,
  "29934": -8,
  "29935": -2,
  "29936": -1,
  "29938": 9,
  "29939": -8,
  "29940": -2,
  "29941": -2,
  "29943": -1,
  "29944": -8,
  "29945": -8,
  "30002": 12,
  "30003": 11,
  "30004": 6,
  "30005": 14,
  "30006": 12,
  "30007": 12,
  "30008": 13,
  "30009": 14,
  "30010": 7,
  "30011": 1,
  "30012": 11,
  "30013": 12,
  "30014": 0,
  "30015": 0,
  "30016": 1,
  "30017": 7,
  "30018": 0,
  "30019": 9,
  "30021": 12,
  "30022": 7,
  "30023": 14,
  "30024": 7,
  "30025": 1,
  "30026": 7,
  "30028": 5,
  "30029": 7,
  "30030": 12,
  "30031": 12,
  "30032": 12,
  "30033": 12,
  "30034": 12,
  "30035": 12,
  "30036": 12,
  "30037": 12,
  "30038": 12,
  "30039": 7,
  "30040": 5,
  "30041": 5,
  "30042": 7,
  "30043": 7,
  "30044": 7,
  "30045": 7,
  "30046": 7,
  "30047": 7,
  "30048": 7,
  "30049": 7,
  "30052": 2,
  "30054": 0,
  "30055": 0,
  "30056": -8,
  "30058": 12,
  "30060": 12,
  "30061": 12,
  "30062": 13,
  "30064": 13,
  "30065": 6,
  "30066": 13,
  "30067": 13,
  "30068": 13,
  "30070": 0,
  "30071": 7,
  "30072": 12,
  "30074": 12,
  "30075": 6,
  "30076": 13,
  "30077": 6,
  "30078": 7,
  "30079": 12,
  "30080": 13,
  "30081": 13,
  "30082": 13,
  "30083": 12,
  "30084": 12,
  "30085": 12,
  "30086": 12,
  "30087": 12,
  "30088": 12,
  "30090": 12,
  "30091": 7,
  "30092": 7,
  "30093": 7,
  "30094": 12,
  "30095": 7,
  "30096": 7,
  "30097": 9,
  "30101": 13,
  "30102": 6,
  "30103": -8,
  "30104": -2,
  "30105": -7,
  "30106": 13,
  "30107": -4,
  "30108": 7,
  "30109": 7,
  "30110": -4,
  "30111": 6,
  "30112": 7,
  "30113": -4,
  "30114": 6,
  "30115": 6,
  "30116": 9,
  "30117": 7,
  "30120": 2,
  "30121": 1,
  "30122": 6,
  "30123": 1,
  "30124": -5,
  "30125": -4,
  "30126": 13,
  "30127": -4,
  "30129": -8,
  "30132": -5,
  "30133": 6,
  "30134": 6,
  "30135": 6,
  "30137": 1,
  "30138": -4,
  "30139": -7,
  "30140": -4,
  "30141": -4,
  "30142": 6,
  "30143": -4,
  "30144": 13,
  "30145": 1,
  "30146": 6,
  "30147": -8,
  "30148": 21,
  "30149": -8,
  "30150": -4,
  "30151": -4,
  "30152": 13,
  "30153": -2,
  "30154": 6,
  "30156": 13,
  "30157": -4,
  "30160": 13,
  "30161": -8,
  "30162": -8,
  "30163": -8,
  "30164": -8,
  "30165": -8,
  "30168": 6,
  "30169": 6,
  "30170": 0,
  "30171": 1,
  "30172": -8,
  "30173": -5,
  "30175": -5,
  "30176": -4,
  "30177": 21,
  "30178": 1,
  "30179": -2,
  "30180": 6,
  "30182": -4,
  "30183": 6,
  "30184": 2,
  "30185": 9,
  "30187": 6,
  "30188": 6,
  "30189": 6,
  "30204": -5,
  "30205": 8,
  "30206": -5,
  "30212": -6,
  "30213": 8,
  "30214": 8,
  "30215": 8,
  "30216": 3,
  "30217": 0,
  "30218": -3,
  "30219": 0,
  "30220": -1,
  "30222": -4,
  "30223": -6,
  "30224": -5,
  "30228": 9,
  "30229": 8,
  "30230": -1,
  "30233": 3,
  "30234": 4,
  "30236": 9,
  "30237": 9,
  "30238": 8,
  "30240": 8,
  "30241": -1,
  "30248": 5,
  "30250": 9,
  "30251": -1,
  "30252": 9,
  "30253": 9,
  "30256": -6,
  "30257": -4,
  "30258": -7,
  "30259": -1,
  "30260": 8,
  "30261": -1,
  "30263": -1,
  "30264": -1,
  "30265": -1,
  "30266": -4,
  "30268": -1,
  "30269": 8,
  "30271": -1,
  "30272": 21,
  "30273": 8,
  "30274": 8,
  "30275": -1,
  "30276": 8,
  "30277": -1,
  "30281": 9,
  "30284": 9,
  "30285": -4,
  "30286": -4,
  "30287": 8,
  "30288": 21,
  "30289": 8,
  "30290": 8,
  "30291": 8,
  "30292": -5,
  "30293": -5,
  "30294": 12,
  "30295": -6,
  "30296": 8,
  "30297": 21,
  "30298": 21,
  "30301": 32,
  "30302": 21,
  "30303": 21,
  "30304": 21,
  "30305": 32,
  "30306": 32,
  "30307": 30,
  "30308": 21,
  "30309": 30,
  "30310": 21,
  "30311": 21,
  "30312": 21,
  "30313": 21,
  "30314": 21,
  "30315": 21,
  "30316": 21,
  "30317": 12,
  "30318": 21,
  "30319": 21,
  "30320": 21,
  "30321": 21,
  "30324": 23,
  "30325": 21,
  "30326": 32,
  "30327": 32,
  "30328": 21,
  "30329": 12,
  "30331": 21,
  "30333": 32,
  "30334": 21,
  "30336": 21,
  "30337": 21,
  "30338": 21,
  "30339": 23,
  "30340": 12,
  "30341": 12,
  "30342": 32,
  "30343": 21,
  "30344": 21,
  "30345": 14,
  "30346": 12,
  "30347": 12,
  "30348": 32,
  "30349": 21,
  "30350": 23,
  "30353": 21,
  "30354": 21,
  "30355": 32,
  "30356": 21,
  "30357": 30,
  "30358": 21,
  "30359": 12,
  "30360": 12,
  "30361": 30,
  "30362": 12,
  "30363": 32,
  "30364": 21,
  "30366": 12,
  "30369": 21,
  "30370": 21,
  "30371": 21,
  "30374": 8,
  "30376": 23,
  "30377": 21,
  "30378": 21,
  "30379": 21,
  "30392": 21,
  "30394": 21,
  "30401": -14,
  "30410": -14,
  "30411": -21,
  "30412": -13,
  "30413": -11,
  "30414": -8,
  "30415": -6,
  "30417": -8,
  "30420": -10,
  "30421": -9,
  "30423": -8,
  "30424": -6,
  "30425": -14,
  "30426": 6,
  "30427": -9,
  "30428": -21,
  "30429": -8,
  "30434": -11,
  "30436": -6,
  "30438": -9,
  "30439": -10,
  "30441": -14,
  "30442": 6,
  "30445": -14,
  "30446": -12,
  "30447": -6,
  "30448": -14,
  "30449": -12,
  "30450": -6,
  "30451": -6,
  "30452": -6,
  "30453": -9,
  "30454": -6,
  "30455": -12,
  "30456": 6,
  "30457": -6,
  "30458": -6,
  "30459": -6,
  "30461": -6,
  "30464": -11,
  "30467": -12,
  "30470": -6,
  "30471": -14,
  "30473": -13,
  "30474": -6,
  "30475": -6,
  "30477": -11,
  "30501": 2,
  "30502": 2,
  "30503": 2,
  "30504": 2,
  "30506": 10,
  "30507": 1,
  "30510": -7,
  "30511": -9,
  "30512": -11,
  "30513": 8,
  "30514": -11,
  "30515": 5,
  "30516": -13,
  "30517": 1,
  "30518": 5,
  "30519": 15,
  "30520": -9,
  "30521": -9,
  "30522": -5,
  "30523": -9,
  "30525": -11,
  "30527": 1,
  "30528": 1,
  "30529": 2,
  "30530": 2,
  "30531": -9,
  "30533": -2,
  "30534": 22,
  "30535": -9,
  "30536": 2,
  "30537": -3,
  "30538": -8,
  "30539": 2,
  "30540": 2,
  "30541": 8,
  "30542": 2,
  "30543": -7,
  "30544": -9,
  "30545": 1,
  "30546": 13,
  "30547": -7,
  "30548": 1,
  "30549": 2,
  "30552": -11,
  "30553": -10,
  "30554": -7,
  "30555": 7,
  "30557": -8,
  "30558": -7,
  "30559": 8,
  "30560": 8,
  "30562": -11,
  "30563": -9,
  "30564": -2,
  "30565": 2,
  "30566": 2,
  "30567": 3,
  "30568": -11,
  "30571": 1,
  "30572": -10,
  "30573": -11,
  "30575": 3,
  "30576": -11,
  "30577": -8,
  "30580": -9,
  "30581": -11,
  "30582": 5,
  "30598": -8,
  "30601": 9,
  "30603": 9,
  "30604": 9,
  "30605": 10,
  "30606": 11,
  "30607": 9,
  "30608": 9,
  "30612": 11,
  "30619": -9,
  "30620": 1,
  "30621": 0,
  "30622": 0,
  "30623": 0,
  "30624": -13,
  "30625": -1,
  "30627": -12,
  "30628": -6,
  "30629": -6,
  "30630": -9,
  "30631": -8,
  "30633": -6,
  "30634": -13,
  "30635": -13,
  "30638": 0,
  "30639": -9,
  "30641": 0,
  "30642": -8,
  "30643": -13,
  "30645": 0,
  "30646": -6,
  "30647": -6,
  "30648": -9,
  "30650": -2,
  "30655": 1,
  "30656": 1,
  "30660": 5,
  "30662": -9,
  "30663": -1,
  "30664": -8,
  "30665": -8,
  "30666": 0,
  "30667": -9,
  "30668": 5,
  "30669": -8,
  "30671": -9,
  "30673": 5,
  "30677": 8,
  "30678": -8,
  "30680": 1,
  "30683": 9,
  "30701": -8,
  "30703": -8,
  "30705": -14,
  "30707": -10,
  "30708": -14,
  "30710": -5,
  "30711": -14,
  "30719": -5,
  "30720": -5,
  "30721": -5,
  "30722": -5,
  "30724": -14,
  "30725": -10,
  "30726": 4,
  "30728": -10,
  "30730": -9,
  "30731": -8,
  "30732": -8,
  "30733": -8,
  "30734": -8,
  "30735": -8,
  "30736": -10,
  "30738": -15,
  "30739": -10,
  "30740": -5,
  "30741": 4,
  "30742": -10,
  "30746": -8,
  "30747": -8,
  "30750": -6,
  "30751": -14,
  "30752": -15,
  "30753": -8,
  "30755": -5,
  "30756": -5,
  "30757": -15,
  "30802": -5,
  "30803": -11,
  "30805": -6,
  "30806": -9,
  "30807": -16,
  "30808": -9,
  "30809": 2,
  "30810": -16,
  "30811": 6,
  "30812": -6,
  "30813": -6,
  "30814": -6,
  "30815": -6,
  "30816": 6,
  "30817": -5,
  "30818": -11,
  "30819": -16,
  "30820": -16,
  "30821": -16,
  "30822": 6,
  "30823": -11,
  "30824": -9,
  "30828": -16,
  "30830": 6,
  "30833": -11,
  "30901": -7,
  "30903": -7,
  "30904": -6,
  "30905": -5,
  "30906": -6,
  "30907": 2,
  "30909": 2,
  "30912": -7,
  "30913": 2,
  "30914": -6,
  "30916": -6,
  "30917": 2,
  "30919": 2,
  "31001": -22,
  "31002": -6,
  "31003": -7,
  "31004": -8,
  "31005": 5,
  "31006": -13,
  "31007": -5,
  "31008": 0,
  "31009": -14,
  "31010": -2,
  "31011": -14,
  "31012": -7,
  "31013": -3,
  "31014": -7,
  "31015": -2,
  "31016": -4,
  "31017": -7,
  "31018": -6,
  "31019": -8,
  "31020": 1,
  "31021": -8,
  "31022": -8,
  "31023": -14,
  "31024": -8,
  "31025": -3,
  "31027": -8,
  "31028": -3,
  "31029": -8,
  "31030": 0,
  "31031": -9,
  "31032": -7,
  "31033": -8,
  "31034": -10,
  "31035": -7,
  "31036": -10,
  "31037": -7,
  "31038": -9,
  "31039": -13,
  "31040": -8,
  "31041": -5,
  "31042": -9,
  "31044": -7,
  "31045": -16,
  "31046": -8,
  "31047": 5,
  "31049": -19,
  "31050": 0,
  "31051": -3,
  "31052": 2,
  "31054": -9,
  "31055": -7,
  "31057": -5,
  "31058": -18,
  "31059": -10,
  "31060": -7,
  "31061": -10,
  "31063": -5,
  "31064": -9,
  "31065": -8,
  "31066": 2,
  "31067": -7,
  "31068": -5,
  "31069": -3,
  "31070": -3,
  "31071": -10,
  "31072": -22,
  "31075": -8,
  "31076": -13,
  "31077": -14,
  "31078": 0,
  "31079": -22,
  "31081": -12,
  "31082": -7,
  "31083": -7,
  "31084": -22,
  "31085": -8,
  "31086": -4,
  "31087": -10,
  "31088": -3,
  "31089": -7,
  "31090": -9,
  "31091": -10,
  "31092": -3,
  "31093": -3,
  "31094": -7,
  "31095": -3,
  "31096": -19,
  "31097": -4,
  "31098": -3,
  "31099": -3,
  "31106": 32,
  "31107": 30,
  "31119": 32,
  "31126": 32,
  "31131": 21,
  "31139": 21,
  "31141": 21,
  "31145": 14,
  "31146": 12,
  "31150": 23,
  "31156": 21,
  "31201": 1,
  "31202": 1,
  "31203": 1,
  "31204": 1,
  "31205": 9,
  "31206": 1,
  "31208": 1,
  "31209": 1,
  "31210": 9,
  "31211": 1,
  "31212": 1,
  "31216": 9,
  "31217": 1,
  "31220": 9,
  "31221": 9,
  "31297": 1,
  "31301": -9,
  "31302": 5,
  "31303": -7,
  "31304": 6,
  "31305": -5,
  "31307": 5,
  "31308": 5,
  "31309": -9,
  "31310": -9,
  "31312": -6,
  "31313": -9,
  "31314": -9,
  "31315": -9,
  "31316": -20,
  "31318": 5,
  "31319": -5,
  "31320": -9,
  "31321": 5,
  "31322": 1,
  "31323": -9,
  "31324": 5,
  "31326": -6,
  "31327": -5,
  "31328": 9,
  "31329": -7,
  "31331": -5,
  "31333": -9,
  "31401": 0,
  "31402": 5,
  "31403": 1,
  "31404": 0,
  "31405": 1,
  "31406": 1,
  "31407": 0,
  "31408": 0,
  "31409": 1,
  "31410": 1,
  "31411": 11,
  "31412": 0,
  "31414": 0,
  "31415": 0,
  "31416": 1,
  "31418": 0,
  "31419": 1,
  "31420": 1,
  "31421": 0,
  "31501": -9,
  "31502": -9,
  "31503": -9,
  "31510": 13,
  "31512": -12,
  "31513": 13,
  "31515": 13,
  "31516": -9,
  "31518": -9,
  "31519": -12,
  "31520": -8,
  "31521": -8,
  "31522": 1,
  "31523": -8,
  "31525": -8,
  "31527": 1,
  "31532": -19,
  "31533": -12,
  "31534": -12,
  "31535": -12,
  "31537": -14,
  "31539": -19,
  "31542": -10,
  "31543": -10,
  "31544": -7,
  "31545": -8,
  "31546": -8,
  "31547": -7,
  "31548": -7,
  "31549": -19,
  "31550": -9,
  "31551": -9,
  "31552": -9,
  "31553": -10,
  "31554": -12,
  "31555": -8,
  "31556": -9,
  "31557": -9,
  "31558": -7,
  "31560": -8,
  "31561": 1,
  "31562": -14,
  "31563": 13,
  "31564": -9,
  "31565": -8,
  "31566": -10,
  "31567": -12,
  "31568": -8,
  "31569": -7,
  "31598": -8,
  "31601": -3,
  "31602": -2,
  "31603": -2,
  "31604": -2,
  "31605": -2,
  "31606": -3,
  "31620": -9,
  "31622": -14,
  "31623": -16,
  "31624": -14,
  "31625": -11,
  "31626": -5,
  "31627": -9,
  "31629": -9,
  "31630": -16,
  "31631": -16,
  "31632": 4,
  "31634": -16,
  "31635": -11,
  "31636": -3,
  "31637": -9,
  "31638": -9,
  "31639": -14,
  "31641": -11,
  "31642": -14,
  "31643": -9,
  "31645": -11,
  "31647": -9,
  "31648": -3,
  "31649": -11,
  "31650": -14,
  "31701": -2,
  "31702": 6,
  "31703": -2,
  "31705": -2,
  "31706": -2,
  "31707": 6,
  "31708": -2,
  "31709": -13,
  "31711": -14,
  "31712": -3,
  "31714": -6,
  "31716": -10,
  "31719": -13,
  "31720": -9,
  "31721": 6,
  "31722": -8,
  "31727": -3,
  "31730": -11,
  "31733": -3,
  "31735": 6,
  "31738": -6,
  "31739": -10,
  "31743": -14,
  "31744": -8,
  "31747": -8,
  "31749": -4,
  "31750": -9,
  "31753": 0,
  "31756": 0,
  "31757": -5,
  "31758": -5,
  "31760": -3,
  "31763": 0,
  "31764": -14,
  "31765": -11,
  "31768": -8,
  "31769": -9,
  "31771": -8,
  "31772": -8,
  "31773": -5,
  "31774": -9,
  "31775": -4,
  "31776": -8,
  "31778": -9,
  "31779": -10,
  "31780": -14,
  "31781": -11,
  "31782": -11,
  "31783": -6,
  "31784": -10,
  "31787": -13,
  "31788": -8,
  "31789": -11,
  "31790": -6,
  "31791": -11,
  "31792": -5,
  "31793": -3,
  "31794": -3,
  "31795": -3,
  "31796": -2,
  "31798": -9,
  "31799": -5,
  "31801": -17,
  "31803": -18,
  "31804": 0,
  "31805": -20,
  "31806": -5,
  "31807": -9,
  "31808": 0,
  "31810": -17,
  "31811": -7,
  "31812": -15,
  "31814": -20,
  "31815": -20,
  "31816": -4,
  "31820": 4,
  "31821": -20,
  "31822": -9,
  "31823": -9,
  "31824": -20,
  "31825": -20,
  "31826": -15,
  "31827": -15,
  "31829": 4,
  "31830": -4,
  "31831": -15,
  "31832": -21,
  "31833": -8,
  "31836": -15,
  "31901": -5,
  "31902": -5,
  "31903": -5,
  "31904": -5,
  "31905": -5,
  "31906": -5,
  "31907": -5,
  "31908": -5,
  "31909": -5,
  "31914": -5,
  "31917": -5,
  "31995": -5,
  "32003": 4,
  "32004": 4,
  "32006": 4,
  "32007": -11,
  "32008": -8,
  "32009": -10,
  "32011": -8,
  "32013": -19,
  "32024": -10,
  "32025": -10,
  "32030": -7,
  "32033": 1,
  "32034": -8,
  "32035": -8,
  "32038": -9,
  "32040": -10,
  "32041": -8,
  "32042": -7,
  "32043": -7,
  "32044": -8,
  "32046": -8,
  "32050": -7,
  "32052": -8,
  "32053": -12,
  "32054": -8,
  "32055": -9,
  "32056": -10,
  "32058": -7,
  "32059": -12,
  "32060": -19,
  "32061": -8,
  "32062": -19,
  "32063": -10,
  "32064": -19,
  "32065": -7,
  "32066": -19,
  "32067": -7,
  "32068": -7,
  "32071": -8,
  "32072": -9,
  "32073": 4,
  "32079": -7,
  "32080": 1,
  "32081": 12,
  "32082": 12,
  "32083": -8,
  "32084": 3,
  "32085": 1,
  "32086": 1,
  "32087": -9,
  "32091": -7,
  "32092": 1,
  "32094": -8,
  "32095": 1,
  "32096": -10,
  "32097": -8,
  "32102": -7,
  "32105": -7,
  "32110": -10,
  "32111": -7,
  "32112": -12,
  "32113": -7,
  "32114": -8,
  "32115": -8,
  "32116": -7,
  "32117": -8,
  "32118": -7,
  "32119": -7,
  "32120": -8,
  "32121": -8,
  "32122": -7,
  "32123": -7,
  "32124": 1,
  "32125": -8,
  "32126": -7,
  "32127": -7,
  "32128": 1,
  "32129": -7,
  "32130": -7,
  "32131": -11,
  "32132": -7,
  "32133": -7,
  "32134": -12,
  "32135": -8,
  "32136": -10,
  "32137": -8,
  "32138": -11,
  "32139": -12,
  "32140": -11,
  "32141": -7,
  "32142": -10,
  "32143": -10,
  "32145": -10,
  "32147": -11,
  "32148": -11,
  "32149": -11,
  "32157": -12,
  "32158": 8,
  "32159": 8,
  "32160": -7,
  "32162": 8,
  "32163": 8,
  "32164": -10,
  "32168": -7,
  "32169": 1,
  "32170": -7,
  "32173": -7,
  "32174": -7,
  "32175": -10,
  "32176": -10,
  "32177": -11,
  "32178": -11,
  "32179": -7,
  "32180": -7,
  "32181": -12,
  "32182": -12,
  "32183": -7,
  "32185": -11,
  "32187": -12,
  "32189": -12,
  "32190": -10,
  "32192": -7,
  "32193": -12,
  "32195": -7,
  "32201": 4,
  "32202": 3,
  "32203": 4,
  "32204": 4,
  "32205": 4,
  "32206": 3,
  "32207": 4,
  "32208": 3,
  "32209": 3,
  "32210": 4,
  "32211": 4,
  "32212": 4,
  "32215": -7,
  "32216": 4,
  "32217": 4,
  "32218": 4,
  "32219": 4,
  "32220": 4,
  "32221": 4,
  "32222": 4,
  "32223": 4,
  "32224": 4,
  "32225": 4,
  "32226": 4,
  "32227": 3,
  "32228": 3,
  "32229": 4,
  "32230": 4,
  "32231": 4,
  "32232": 4,
  "32233": 4,
  "32234": -10,
  "32235": 4,
  "32236": 4,
  "32237": 4,
  "32238": 4,
  "32239": 4,
  "32240": 4,
  "32241": 4,
  "32244": 4,
  "32245": 12,
  "32246": 4,
  "32247": 4,
  "32250": 4,
  "32254": 3,
  "32255": 4,
  "32256": 12,
  "32257": 4,
  "32258": 4,
  "32259": 2,
  "32260": 2,
  "32266": 5,
  "32277": 4,
  "32301": -4,
  "32302": -4,
  "32303": -4,
  "32304": -4,
  "32305": -10,
  "32308": 4,
  "32309": -10,
  "32310": -4,
  "32311": -3,
  "32312": 4,
  "32314": -4,
  "32315": -4,
  "32316": -4,
  "32317": 4,
  "32318": -4,
  "32320": -16,
  "32321": -5,
  "32322": -15,
  "32323": -15,
  "32324": -3,
  "32326": -10,
  "32327": -10,
  "32328": -16,
  "32329": -16,
  "32330": -3,
  "32331": -12,
  "32332": -3,
  "32333": -3,
  "32334": -6,
  "32335": -14,
  "32336": -10,
  "32337": -10,
  "32340": -12,
  "32341": -12,
  "32343": -3,
  "32344": -10,
  "32345": -10,
  "32346": -9,
  "32347": -1,
  "32348": -1,
  "32350": -12,
  "32351": -3,
  "32352": -3,
  "32353": -3,
  "32355": -10,
  "32356": -1,
  "32357": -1,
  "32358": -10,
  "32359": -13,
  "32360": -5,
  "32361": -10,
  "32362": -3,
  "32401": -7,
  "32402": -6,
  "32403": 2,
  "32404": -6,
  "32405": -6,
  "32406": -6,
  "32407": -6,
  "32408": -6,
  "32409": -6,
  "32410": -5,
  "32411": -6,
  "32412": -7,
  "32413": -6,
  "32417": -6,
  "32420": -7,
  "32421": -13,
  "32422": 3,
  "32423": -6,
  "32424": -13,
  "32425": -16,
  "32426": -6,
  "32427": -16,
  "32428": -13,
  "32430": -13,
  "32431": -6,
  "32432": -6,
  "32433": -6,
  "32434": -6,
  "32435": -6,
  "32437": -13,
  "32438": -13,
  "32439": -5,
  "32440": -16,
  "32442": -6,
  "32443": -6,
  "32444": -6,
  "32445": -6,
  "32446": -4,
  "32447": -4,
  "32448": -6,
  "32449": -13,
  "32452": -16,
  "32455": 3,
  "32456": -13,
  "32457": -13,
  "32459": -5,
  "32460": -6,
  "32461": -6,
  "32462": -13,
  "32463": -13,
  "32464": -16,
  "32465": -14,
  "32466": -7,
  "32501": -4,
  "32502": -4,
  "32503": -4,
  "32504": -4,
  "32505": -4,
  "32506": -4,
  "32507": -4,
  "32508": -4,
  "32513": -4,
  "32514": -4,
  "32516": -4,
  "32522": -4,
  "32523": -4,
  "32524": -4,
  "32526": -4,
  "32530": -7,
  "32531": -7,
  "32533": -4,
  "32534": -4,
  "32535": -7,
  "32536": -7,
  "32537": -7,
  "32538": -7,
  "32539": -7,
  "32540": 2,
  "32541": 2,
  "32542": -7,
  "32544": -7,
  "32547": -7,
  "32548": -7,
  "32549": -7,
  "32550": 2,
  "32560": -4,
  "32561": 5,
  "32562": -4,
  "32563": -7,
  "32564": -7,
  "32565": -7,
  "32566": -7,
  "32567": -7,
  "32568": -4,
  "32569": -7,
  "32570": -7,
  "32571": -7,
  "32572": -7,
  "32577": -4,
  "32578": -7,
  "32579": -7,
  "32580": -7,
  "32583": -7,
  "32588": -7,
  "32590": -4,
  "32591": -4,
  "32592": -4,
  "32601": -6,
  "32602": 3,
  "32603": 3,
  "32604": 3,
  "32605": 3,
  "32606": 3,
  "32607": 3,
  "32608": -4,
  "32609": -6,
  "32613": -6,
  "32614": -4,
  "32615": -6,
  "32616": -6,
  "32617": -7,
  "32618": -6,
  "32619": -9,
  "32621": -12,
  "32622": -8,
  "32625": -12,
  "32626": -12,
  "32627": -6,
  "32628": -13,
  "32631": -7,
  "32633": -6,
  "32634": -7,
  "32635": -6,
  "32639": -13,
  "32640": -11,
  "32641": -6,
  "32643": -9,
  "32644": -12,
  "32648": -13,
  "32653": -6,
  "32654": -6,
  "32655": -9,
  "32656": -7,
  "32658": -6,
  "32662": -6,
  "32663": -7,
  "32664": -6,
  "32666": -7,
  "32667": -6,
  "32668": -7,
  "32669": -6,
  "32680": -13,
  "32681": -7,
  "32683": -12,
  "32686": -7,
  "32692": -4,
  "32693": -9,
  "32694": -7,
  "32696": -12,
  "32697": -8,
  "32701": 2,
  "32702": -2,
  "32703": 5,
  "32704": 5,
  "32706": -7,
  "32707": 2,
  "32708": 2,
  "32709": 0,
  "32710": 5,
  "32712": 2,
  "32713": 2,
  "32714": 2,
  "32715": 2,
  "32716": 2,
  "32718": 2,
  "32719": 2,
  "32720": -7,
  "32721": -7,
  "32722": -7,
  "32724": -7,
  "32725": -7,
  "32726": 0,
  "32727": 0,
  "32728": -7,
  "32730": 2,
  "32732": 9,
  "32733": 2,
  "32735": -2,
  "32736": 0,
  "32738": -7,
  "32739": -7,
  "32744": -7,
  "32745": 2,
  "32746": 2,
  "32747": 2,
  "32750": 2,
  "32751": 5,
  "32752": 3,
  "32753": 2,
  "32754": 0,
  "32756": 0,
  "32757": 0,
  "32759": -8,
  "32762": 2,
  "32763": -7,
  "32764": -8,
  "32765": 2,
  "32766": 2,
  "32767": -2,
  "32768": -1,
  "32771": 2,
  "32772": 1,
  "32773": 1,
  "32774": -7,
  "32775": -8,
  "32776": 0,
  "32777": 0,
  "32778": -1,
  "32779": 3,
  "32780": -2,
  "32781": -2,
  "32782": 0,
  "32783": -2,
  "32784": -2,
  "32789": 13,
  "32790": 13,
  "32791": 3,
  "32792": 2,
  "32793": 5,
  "32794": 5,
  "32795": 2,
  "32796": 0,
  "32798": -1,
  "32799": 5,
  "32801": 5,
  "32802": 5,
  "32803": 5,
  "32804": 5,
  "32805": 4,
  "32806": 5,
  "32807": 5,
  "32808": 5,
  "32809": 5,
  "32810": 5,
  "32811": 4,
  "32812": 5,
  "32814": 5,
  "32815": -2,
  "32817": 2,
  "32818": 5,
  "32819": 5,
  "32820": 1,
  "32821": 5,
  "32822": 5,
  "32824": 5,
  "32825": 5,
  "32826": 2,
  "32827": 5,
  "32828": 5,
  "32829": 5,
  "32830": 13,
  "32831": 4,
  "32832": -5,
  "32833": 1,
  "32834": 2,
  "32835": 5,
  "32836": 13,
  "32837": 5,
  "32839": 5,
  "32853": 5,
  "32854": 5,
  "32855": 4,
  "32856": 5,
  "32857": 5,
  "32858": 5,
  "32859": 5,
  "32860": 5,
  "32861": 4,
  "32862": 5,
  "32867": 2,
  "32868": 5,
  "32869": 5,
  "32872": 5,
  "32877": 5,
  "32878": 5,
  "32901": -1,
  "32902": -1,
  "32903": -1,
  "32904": -1,
  "32905": -1,
  "32906": -1,
  "32907": -1,
  "32908": -1,
  "32909": -1,
  "32910": -1,
  "32911": -1,
  "32912": -1,
  "32920": -1,
  "32922": -2,
  "32923": -1,
  "32924": -1,
  "32925": -1,
  "32926": -2,
  "32927": -2,
  "32931": -1,
  "32932": -1,
  "32934": -1,
  "32935": -1,
  "32936": -1,
  "32937": -1,
  "32940": -1,
  "32941": -1,
  "32948": -6,
  "32949": -5,
  "32950": -1,
  "32951": 7,
  "32952": -1,
  "32953": 7,
  "32954": -1,
  "32955": -1,
  "32956": -1,
  "32957": -6,
  "32958": -6,
  "32959": -2,
  "32960": -7,
  "32961": -7,
  "32962": -7,
  "32963": 4,
  "32964": -7,
  "32965": -7,
  "32966": -7,
  "32967": -6,
  "32968": -7,
  "32969": -7,
  "32970": -7,
  "32971": -7,
  "32976": -7,
  "32978": -6,
  "33001": -4,
  "33002": 5,
  "33004": 5,
  "33008": 5,
  "33009": 5,
  "33010": 5,
  "33011": 5,
  "33012": 5,
  "33013": 5,
  "33014": 5,
  "33015": 5,
  "33016": 4,
  "33017": 5,
  "33018": 5,
  "33019": 5,
  "33020": 5,
  "33021": 5,
  "33022": 5,
  "33023": 5,
  "33024": 5,
  "33025": 5,
  "33026": 5,
  "33027": 4,
  "33028": 5,
  "33029": 5,
  "33030": 4,
  "33031": 5,
  "33032": 4,
  "33033": 4,
  "33034": 4,
  "33035": 4,
  "33036": 7,
  "33037": 5,
  "33040": -3,
  "33041": -3,
  "33042": -3,
  "33043": -4,
  "33045": -3,
  "33050": -4,
  "33051": -4,
  "33052": -4,
  "33054": 4,
  "33055": 4,
  "33056": 4,
  "33060": 5,
  "33061": 5,
  "33062": 5,
  "33063": 5,
  "33064": 5,
  "33065": 5,
  "33066": 5,
  "33067": 7,
  "33068": 5,
  "33069": 5,
  "33070": -4,
  "33071": 5,
  "33072": 5,
  "33073": 5,
  "33074": 5,
  "33075": 5,
  "33076": 5,
  "33077": 5,
  "33081": 5,
  "33082": 5,
  "33083": 5,
  "33084": 5,
  "33090": 4,
  "33092": 4,
  "33093": 5,
  "33097": 5,
  "33101": 4,
  "33102": 4,
  "33109": 4,
  "33111": 5,
  "33114": 5,
  "33116": 5,
  "33119": 5,
  "33122": 4,
  "33124": 6,
  "33125": 5,
  "33126": 4,
  "33127": 4,
  "33128": 4,
  "33129": 5,
  "33130": 4,
  "33131": 5,
  "33132": 5,
  "33133": 6,
  "33134": 5,
  "33135": 5,
  "33136": 4,
  "33137": 4,
  "33138": 5,
  "33139": 5,
  "33140": 5,
  "33141": 5,
  "33142": 4,
  "33143": 5,
  "33144": 5,
  "33145": 5,
  "33146": 16,
  "33147": 4,
  "33149": 16,
  "33150": 4,
  "33151": 4,
  "33152": 4,
  "33153": 5,
  "33154": 5,
  "33155": 5,
  "33156": 16,
  "33157": 5,
  "33158": 16,
  "33159": 4,
  "33160": 4,
  "33161": 5,
  "33162": 4,
  "33163": 5,
  "33164": 4,
  "33165": 5,
  "33166": 5,
  "33167": 4,
  "33168": 4,
  "33169": 5,
  "33170": 5,
  "33172": 4,
  "33173": 5,
  "33174": 5,
  "33175": 5,
  "33176": 5,
  "33177": 4,
  "33178": 5,
  "33179": 4,
  "33180": 5,
  "33181": 5,
  "33182": 5,
  "33183": 4,
  "33184": 5,
  "33185": 5,
  "33186": 5,
  "33187": 5,
  "33189": 4,
  "33190": 4,
  "33193": 5,
  "33194": 5,
  "33196": 5,
  "33197": 5,
  "33222": 6,
  "33231": 4,
  "33233": 6,
  "33234": 5,
  "33238": 5,
  "33239": 5,
  "33242": 4,
  "33243": 5,
  "33245": 5,
  "33247": 4,
  "33255": 5,
  "33256": 16,
  "33257": 5,
  "33261": 5,
  "33265": 5,
  "33266": 5,
  "33269": 5,
  "33280": 4,
  "33283": 5,
  "33296": 5,
  "33299": 4,
  "33301": 16,
  "33302": 5,
  "33303": 5,
  "33304": 5,
  "33305": 5,
  "33306": 5,
  "33307": 5,
  "33308": 5,
  "33309": 5,
  "33310": 5,
  "33311": 5,
  "33312": 5,
  "33313": 5,
  "33314": 5,
  "33315": 5,
  "33316": 16,
  "33317": 5,
  "33318": 5,
  "33319": 5,
  "33320": 5,
  "33321": 5,
  "33322": 5,
  "33323": 5,
  "33324": 5,
  "33325": 5,
  "33326": 5,
  "33327": 16,
  "33328": 5,
  "33329": 5,
  "33330": 5,
  "33331": 6,
  "33332": 16,
  "33334": 5,
  "33335": 5,
  "33338": 5,
  "33339": 5,
  "33340": 5,
  "33345": 5,
  "33346": 16,
  "33348": 5,
  "33349": 5,
  "33351": 5,
  "33355": 5,
  "33359": 5,
  "33388": 5,
  "33394": 16,
  "33401": 4,
  "33402": 4,
  "33403": 4,
  "33404": 4,
  "33405": 4,
  "33406": 4,
  "33407": 4,
  "33408": 4,
  "33409": 4,
  "33410": 4,
  "33411": 4,
  "33412": 4,
  "33413": 4,
  "33414": 4,
  "33415": 4,
  "33416": 4,
  "33417": 4,
  "33418": 4,
  "33419": 4,
  "33420": 4,
  "33421": 4,
  "33422": 4,
  "33424": 5,
  "33425": 6,
  "33426": 5,
  "33427": 5,
  "33428": 5,
  "33429": 5,
  "33430": 4,
  "33431": 5,
  "33432": 5,
  "33433": 5,
  "33434": 5,
  "33435": 5,
  "33436": 5,
  "33437": 6,
  "33438": 4,
  "33439": 4,
  "33440": -7,
  "33441": 5,
  "33442": 5,
  "33443": 5,
  "33444": 5,
  "33445": 5,
  "33446": 5,
  "33448": 5,
  "33449": 4,
  "33454": 4,
  "33455": -5,
  "33458": -4,
  "33459": -6,
  "33460": 4,
  "33461": 4,
  "33462": 4,
  "33463": 4,
  "33465": 4,
  "33466": 4,
  "33467": 4,
  "33468": -4,
  "33469": -4,
  "33470": 4,
  "33471": -8,
  "33472": 4,
  "33473": 6,
  "33474": 5,
  "33475": -5,
  "33476": 4,
  "33477": -4,
  "33478": -4,
  "33480": 15,
  "33481": 5,
  "33482": 5,
  "33483": 6,
  "33484": 5,
  "33486": 5,
  "33487": 6,
  "33488": 5,
  "33493": -6,
  "33496": 14,
  "33497": 5,
  "33498": 6,
  "33503": 4,
  "33508": 4,
  "33509": 4,
  "33510": 4,
  "33511": 4,
  "33513": -1,
  "33514": 0,
  "33521": -1,
  "33523": -9,
  "33524": -7,
  "33525": -6,
  "33526": -9,
  "33527": 4,
  "33530": 5,
  "33534": 4,
  "33537": -9,
  "33538": -1,
  "33539": -6,
  "33540": -7,
  "33541": -7,
  "33542": -7,
  "33543": -5,
  "33544": -6,
  "33545": -5,
  "33547": 12,
  "33548": -5,
  "33549": -5,
  "33550": 4,
  "33556": 3,
  "33558": -5,
  "33559": 13,
  "33563": 4,
  "33564": 4,
  "33565": 4,
  "33566": 4,
  "33567": 4,
  "33568": 4,
  "33569": 4,
  "33570": -2,
  "33571": -2,
  "33572": 5,
  "33573": 4,
  "33574": -6,
  "33575": -2,
  "33576": -6,
  "33578": 4,
  "33579": 4,
  "33583": 4,
  "33584": 4,
  "33585": 0,
  "33586": -2,
  "33587": 4,
  "33592": 4,
  "33593": -9,
  "33594": 5,
  "33595": 4,
  "33596": 5,
  "33597": -1,
  "33598": 4,
  "33601": 4,
  "33602": 4,
  "33603": 4,
  "33604": 4,
  "33605": 4,
  "33606": 13,
  "33607": 4,
  "33608": 4,
  "33609": 5,
  "33610": 4,
  "33611": 4,
  "33612": 4,
  "33613": 4,
  "33614": 4,
  "33615": 4,
  "33616": 4,
  "33617": 4,
  "33618": 5,
  "33619": 4,
  "33621": 4,
  "33622": 4,
  "33623": 4,
  "33624": 5,
  "33625": 4,
  "33626": 5,
  "33629": 13,
  "33630": 4,
  "33631": 5,
  "33634": 4,
  "33635": -4,
  "33637": 4,
  "33646": 4,
  "33647": 13,
  "33672": 4,
  "33673": 4,
  "33674": 4,
  "33675": -5,
  "33677": 4,
  "33679": 5,
  "33680": 4,
  "33681": 4,
  "33682": 4,
  "33684": 4,
  "33685": 4,
  "33686": 4,
  "33687": 4,
  "33688": 5,
  "33689": 4,
  "33690": 5,
  "33694": 5,
  "33701": -4,
  "33702": -4,
  "33703": -4,
  "33704": -4,
  "33705": -4,
  "33706": 5,
  "33707": -4,
  "33708": -4,
  "33709": -4,
  "33710": -4,
  "33711": -4,
  "33712": -4,
  "33713": -4,
  "33714": -4,
  "33715": 5,
  "33716": -4,
  "33730": -3,
  "33731": -4,
  "33732": -4,
  "33733": -4,
  "33734": -4,
  "33736": 5,
  "33737": -4,
  "33738": -4,
  "33740": 5,
  "33741": 5,
  "33742": -4,
  "33743": -4,
  "33744": -4,
  "33747": -4,
  "33755": -3,
  "33756": -3,
  "33757": -3,
  "33758": -3,
  "33759": -3,
  "33760": -3,
  "33761": -3,
  "33762": -4,
  "33763": -3,
  "33764": -3,
  "33765": -3,
  "33766": -3,
  "33767": 5,
  "33770": -3,
  "33771": -3,
  "33772": -4,
  "33773": -3,
  "33774": -3,
  "33775": -4,
  "33776": -3,
  "33777": -4,
  "33778": -3,
  "33779": -3,
  "33780": -4,
  "33781": -4,
  "33782": -4,
  "33784": -4,
  "33785": -2,
  "33786": 8,
  "33801": -4,
  "33802": -4,
  "33803": -4,
  "33804": -4,
  "33805": -4,
  "33806": -4,
  "33807": -4,
  "33809": -4,
  "33810": -4,
  "33811": -4,
  "33812": -4,
  "33813": 5,
  "33815": -4,
  "33820": -5,
  "33823": -4,
  "33825": -11,
  "33826": -11,
  "33827": -4,
  "33830": -5,
  "33831": -5,
  "33834": -12,
  "33835": -5,
  "33836": -5,
  "33837": -4,
  "33838": -4,
  "33839": -5,
  "33840": -4,
  "33841": -12,
  "33843": -5,
  "33844": -5,
  "33845": -5,
  "33846": 5,
  "33847": -5,
  "33848": -7,
  "33849": -4,
  "33850": -4,
  "33851": -4,
  "33852": -8,
  "33853": -5,
  "33854": -5,
  "33855": -5,
  "33856": -5,
  "33857": -11,
  "33858": -7,
  "33859": -5,
  "33860": -4,
  "33862": -8,
  "33863": -5,
  "33865": -9,
  "33867": -5,
  "33868": -4,
  "33870": -11,
  "33871": -11,
  "33872": -11,
  "33873": -12,
  "33875": -11,
  "33876": -11,
  "33877": -5,
  "33880": -5,
  "33881": -5,
  "33882": 4,
  "33883": -5,
  "33884": 4,
  "33885": -5,
  "33890": -12,
  "33896": -4,
  "33897": -4,
  "33898": -5,
  "33900": -3,
  "33901": -3,
  "33902": -3,
  "33903": -1,
  "33904": -1,
  "33905": -3,
  "33906": -3,
  "33907": -3,
  "33908": -1,
  "33909": -1,
  "33910": -1,
  "33911": -1,
  "33912": -2,
  "33913": 6,
  "33914": -1,
  "33915": -1,
  "33916": -3,
  "33917": -3,
  "33918": -1,
  "33919": -3,
  "33920": -3,
  "33921": 6,
  "33922": -1,
  "33924": 10,
  "33927": -5,
  "33928": -3,
  "33929": -3,
  "33930": -3,
  "33931": 6,
  "33932": 6,
  "33935": -3,
  "33936": -3,
  "33938": -5,
  "33944": -9,
  "33945": -1,
  "33946": -5,
  "33947": -5,
  "33948": -5,
  "33949": -5,
  "33950": -5,
  "33951": -5,
  "33952": -5,
  "33953": -5,
  "33954": -5,
  "33955": -5,
  "33956": -1,
  "33957": 1,
  "33960": -8,
  "33966": -3,
  "33967": -3,
  "33970": -3,
  "33971": -3,
  "33972": -3,
  "33973": -3,
  "33974": -3,
  "33975": -7,
  "33976": -3,
  "33980": -5,
  "33981": -5,
  "33982": -5,
  "33983": -5,
  "33990": -1,
  "33991": -1,
  "33993": -1,
  "33994": -3,
  "34101": 11,
  "34102": 11,
  "34103": 2,
  "34104": 1,
  "34105": 1,
  "34106": 11,
  "34107": 1,
  "34108": 1,
  "34109": 1,
  "34110": 1,
  "34112": 1,
  "34113": 1,
  "34114": 0,
  "34116": 1,
  "34117": 1,
  "34119": 1,
  "34120": 1,
  "34133": 1,
  "34134": 1,
  "34135": 1,
  "34136": 1,
  "34137": 1,
  "34138": 1,
  "34139": 1,
  "34140": 1,
  "34141": 1,
  "34142": 0,
  "34143": 0,
  "34145": 1,
  "34146": 1,
  "34201": 9,
  "34202": -1,
  "34203": -2,
  "34204": -2,
  "34205": -2,
  "34206": -2,
  "34207": -2,
  "34208": -2,
  "34209": -2,
  "34210": -2,
  "34211": -1,
  "34212": -1,
  "34215": -2,
  "34216": -1,
  "34217": -2,
  "34218": -2,
  "34219": -2,
  "34220": -2,
  "34221": -2,
  "34222": -2,
  "34223": 1,
  "34224": -5,
  "34228": 9,
  "34229": 0,
  "34230": -1,
  "34231": 0,
  "34232": -1,
  "34233": 0,
  "34234": -2,
  "34235": -1,
  "34236": -1,
  "34237": -2,
  "34238": 0,
  "34239": -1,
  "34240": 0,
  "34241": 0,
  "34242": 10,
  "34243": -1,
  "34250": -2,
  "34251": 0,
  "34260": -1,
  "34264": -2,
  "34265": -9,
  "34266": -9,
  "34267": -9,
  "34268": -9,
  "34269": -9,
  "34270": -1,
  "34272": 0,
  "34274": 0,
  "34275": 0,
  "34276": -1,
  "34277": 0,
  "34278": -1,
  "34280": -2,
  "34281": -2,
  "34282": -2,
  "34284": -1,
  "34285": 0,
  "34286": -5,
  "34287": -5,
  "34288": -5,
  "34289": -5,
  "34290": -5,
  "34291": -5,
  "34292": -1,
  "34293": -1,
  "34295": -5,
  "34420": -7,
  "34421": -7,
  "34423": -9,
  "34428": -10,
  "34429": -9,
  "34430": -8,
  "34431": -10,
  "34432": -8,
  "34433": -10,
  "34434": -10,
  "34436": -1,
  "34442": -10,
  "34445": -10,
  "34446": -9,
  "34447": -10,
  "34448": -10,
  "34449": -13,
  "34450": -10,
  "34451": -10,
  "34452": -10,
  "34453": -10,
  "34460": -10,
  "34461": -8,
  "34464": -10,
  "34465": -10,
  "34470": -7,
  "34471": 2,
  "34472": -7,
  "34473": -7,
  "34474": -7,
  "34475": -7,
  "34476": -5,
  "34477": -7,
  "34478": -7,
  "34479": -7,
  "34480": -6,
  "34481": -7,
  "34482": -7,
  "34483": -7,
  "34484": 0,
  "34487": -10,
  "34488": -7,
  "34489": -7,
  "34491": -7,
  "34492": -7,
  "34498": -9,
  "34601": -8,
  "34602": -9,
  "34603": -8,
  "34604": -8,
  "34605": -8,
  "34606": -8,
  "34607": -8,
  "34608": -8,
  "34609": -8,
  "34610": -6,
  "34611": -8,
  "34613": -8,
  "34614": -9,
  "34636": -1,
  "34637": -5,
  "34638": -5,
  "34639": -5,
  "34652": -5,
  "34653": -5,
  "34654": -5,
  "34655": -5,
  "34656": -5,
  "34660": -3,
  "34661": -1,
  "34667": -5,
  "34668": -5,
  "34669": -5,
  "34673": -5,
  "34674": -5,
  "34677": -3,
  "34679": -8,
  "34680": -5,
  "34681": 5,
  "34682": -3,
  "34683": -3,
  "34684": -3,
  "34685": 5,
  "34688": 5,
  "34689": -5,
  "34690": -5,
  "34691": -5,
  "34692": -5,
  "34695": -3,
  "34697": -3,
  "34698": -3,
  "34705": -1,
  "34711": 0,
  "34712": 0,
  "34713": 0,
  "34714": 0,
  "34715": 0,
  "34729": 0,
  "34731": -2,
  "34734": 5,
  "34736": 0,
  "34737": 0,
  "34739": -6,
  "34740": 5,
  "34741": -5,
  "34742": -5,
  "34743": -5,
  "34744": -5,
  "34745": -5,
  "34746": -5,
  "34747": 4,
  "34748": -2,
  "34749": -2,
  "34753": -1,
  "34755": 0,
  "34756": 0,
  "34758": -5,
  "34759": -5,
  "34760": 5,
  "34761": 5,
  "34762": -1,
  "34769": -5,
  "34770": -5,
  "34771": -5,
  "34772": -5,
  "34773": -1,
  "34777": 5,
  "34778": 5,
  "34785": -1,
  "34786": 15,
  "34787": 5,
  "34788": -2,
  "34789": -2,
  "34797": 0,
  "34945": -9,
  "34946": -10,
  "34947": -9,
  "34948": -10,
  "34949": -9,
  "34950": -10,
  "34951": -7,
  "34952": -7,
  "34953": -7,
  "34954": -10,
  "34956": -5,
  "34957": -5,
  "34958": -4,
  "34972": -11,
  "34973": -11,
  "34974": -11,
  "34979": -10,
  "34981": -9,
  "34982": -9,
  "34983": -7,
  "34984": -7,
  "34985": -7,
  "34986": -6,
  "34987": -7,
  "34988": -7,
  "34990": 4,
  "34991": -5,
  "34992": -5,
  "34994": -5,
  "34995": -5,
  "34996": -4,
  "34997": -5,
  "35004": -4,
  "35005": 5,
  "35006": -4,
  "35007": -1,
  "35010": -9,
  "35011": -9,
  "35013": -10,
  "35014": -7,
  "35015": 5,
  "35016": -6,
  "35019": -7,
  "35020": 5,
  "35021": 5,
  "35022": 5,
  "35023": 5,
  "35031": -10,
  "35032": -7,
  "35033": -3,
  "35034": 6,
  "35035": 4,
  "35036": 5,
  "35038": -3,
  "35040": -1,
  "35041": 5,
  "35042": 6,
  "35043": 7,
  "35044": -7,
  "35045": -5,
  "35046": -5,
  "35048": 5,
  "35049": -10,
  "35051": -1,
  "35052": -5,
  "35053": -7,
  "35054": -4,
  "35055": -7,
  "35056": -7,
  "35057": -7,
  "35058": -7,
  "35060": 5,
  "35061": 5,
  "35062": -3,
  "35063": -3,
  "35064": 5,
  "35068": 5,
  "35070": -9,
  "35071": 5,
  "35072": -14,
  "35073": 5,
  "35074": 7,
  "35077": -9,
  "35078": -7,
  "35079": -10,
  "35080": -1,
  "35082": -5,
  "35083": -7,
  "35085": -7,
  "35087": -7,
  "35089": -9,
  "35091": 5,
  "35094": 5,
  "35096": -5,
  "35097": -10,
  "35098": -7,
  "35111": 4,
  "35112": -5,
  "35114": -1,
  "35115": -1,
  "35116": 5,
  "35117": 5,
  "35118": 5,
  "35119": 5,
  "35120": -5,
  "35121": -10,
  "35123": 5,
  "35124": -1,
  "35125": 4,
  "35126": 5,
  "35127": 5,
  "35128": -4,
  "35130": -3,
  "35131": -5,
  "35133": -10,
  "35135": 4,
  "35136": -12,
  "35137": -1,
  "35139": 5,
  "35142": 7,
  "35143": -1,
  "35144": -1,
  "35146": -4,
  "35147": -1,
  "35148": -3,
  "35149": -7,
  "35150": -7,
  "35151": -7,
  "35160": -7,
  "35161": -7,
  "35171": -7,
  "35172": -10,
  "35173": -4,
  "35175": -6,
  "35176": -5,
  "35178": -7,
  "35179": -7,
  "35180": -10,
  "35181": 5,
  "35182": -4,
  "35183": -14,
  "35184": 7,
  "35185": -1,
  "35186": -1,
  "35187": -1,
  "35188": 6,
  "35201": 5,
  "35202": 5,
  "35203": 5,
  "35204": 5,
  "35205": 5,
  "35206": 5,
  "35207": 5,
  "35208": 5,
  "35209": 7,
  "35210": 5,
  "35211": 5,
  "35212": 5,
  "35213": 14,
  "35214": 5,
  "35215": 5,
  "35216": 14,
  "35217": 5,
  "35218": 5,
  "35219": 7,
  "35220": 5,
  "35221": 5,
  "35222": 5,
  "35223": 16,
  "35224": 5,
  "35226": 7,
  "35228": 5,
  "35231": 5,
  "35232": 5,
  "35233": 5,
  "35234": 5,
  "35235": 5,
  "35236": 7,
  "35237": 5,
  "35238": 5,
  "35242": 7,
  "35243": 14,
  "35244": 7,
  "35253": 16,
  "35255": 5,
  "35259": 5,
  "35260": 7,
  "35261": 5,
  "35266": 7,
  "35283": 5,
  "35401": -4,
  "35402": -4,
  "35403": -4,
  "35404": -4,
  "35405": 4,
  "35406": 4,
  "35407": 4,
  "35440": 4,
  "35441": -9,
  "35442": -2,
  "35443": -5,
  "35444": 4,
  "35446": -4,
  "35447": -2,
  "35448": -5,
  "35449": -3,
  "35452": 4,
  "35453": -3,
  "35456": -4,
  "35457": -4,
  "35458": -4,
  "35459": 1,
  "35460": 0,
  "35461": -2,
  "35462": -5,
  "35463": -4,
  "35464": -5,
  "35466": -2,
  "35468": 6,
  "35469": -5,
  "35470": 1,
  "35471": -2,
  "35473": -4,
  "35474": -9,
  "35475": 4,
  "35476": 4,
  "35477": -5,
  "35478": -4,
  "35480": -5,
  "35481": -2,
  "35482": 4,
  "35485": -4,
  "35486": -4,
  "35490": 4,
  "35491": -5,
  "35501": -3,
  "35502": -3,
  "35503": -3,
  "35504": -3,
  "35540": -7,
  "35541": -7,
  "35542": -9,
  "35543": -14,
  "35544": 0,
  "35545": -9,
  "35546": 4,
  "35548": -14,
  "35549": -1,
  "35550": -3,
  "35551": -7,
  "35552": -14,
  "35553": -7,
  "35554": -9,
  "35555": -9,
  "35559": -9,
  "35560": -3,
  "35563": -13,
  "35564": -14,
  "35565": -7,
  "35570": -14,
  "35571": -13,
  "35572": -7,
  "35573": -1,
  "35574": -9,
  "35575": -7,
  "35576": 0,
  "35577": -7,
  "35578": -8,
  "35579": -1,
  "35580": -3,
  "35581": -13,
  "35582": -13,
  "35584": -3,
  "35585": -13,
  "35586": 0,
  "35587": -3,
  "35592": 0,
  "35593": -13,
  "35594": -9,
  "35601": 0,
  "35602": 1,
  "35603": 1,
  "35609": 0,
  "35610": 3,
  "35611": 3,
  "35612": 3,
  "35613": 3,
  "35614": 3,
  "35615": 9,
  "35616": -3,
  "35617": 4,
  "35618": -6,
  "35619": 0,
  "35620": 3,
  "35621": -7,
  "35622": 0,
  "35630": -5,
  "35631": -5,
  "35633": -5,
  "35634": -5,
  "35640": 1,
  "35643": -6,
  "35645": 4,
  "35646": -3,
  "35647": 3,
  "35648": -5,
  "35649": 9,
  "35650": -6,
  "35651": -6,
  "35652": 4,
  "35653": -13,
  "35654": -13,
  "35660": -3,
  "35661": 5,
  "35662": -3,
  "35670": 0,
  "35671": 3,
  "35672": -6,
  "35673": -5,
  "35674": -3,
  "35677": -3,
  "35739": 3,
  "35740": 13,
  "35741": 9,
  "35742": 0,
  "35744": -9,
  "35745": -9,
  "35746": -9,
  "35747": -6,
  "35748": 0,
  "35749": 0,
  "35750": 0,
  "35751": 0,
  "35752": -9,
  "35754": 0,
  "35755": -6,
  "35756": 1,
  "35757": 0,
  "35758": 9,
  "35759": 0,
  "35760": -6,
  "35761": 0,
  "35762": 0,
  "35763": 9,
  "35764": 0,
  "35765": -9,
  "35766": -9,
  "35767": 0,
  "35768": -9,
  "35769": -8,
  "35771": -3,
  "35772": -9,
  "35773": 0,
  "35774": -9,
  "35775": 0,
  "35776": -6,
  "35801": 9,
  "35802": 9,
  "35803": 0,
  "35804": 9,
  "35805": 0,
  "35806": 9,
  "35807": 0,
  "35808": 0,
  "35809": 9,
  "35810": 0,
  "35811": 0,
  "35812": 0,
  "35813": 9,
  "35814": 0,
  "35815": 9,
  "35816": 0,
  "35824": 9,
  "35901": -7,
  "35902": -7,
  "35903": -7,
  "35904": -7,
  "35905": -7,
  "35906": 2,
  "35907": -7,
  "35950": -8,
  "35951": -8,
  "35952": -11,
  "35953": -5,
  "35954": -7,
  "35956": -7,
  "35957": -8,
  "35958": 13,
  "35959": -11,
  "35960": -11,
  "35961": -5,
  "35962": -8,
  "35963": -5,
  "35964": -8,
  "35966": -9,
  "35967": -5,
  "35968": -5,
  "35971": -5,
  "35972": -7,
  "35973": -12,
  "35974": -5,
  "35975": -9,
  "35976": -7,
  "35978": -4,
  "35979": 13,
  "35980": -8,
  "35981": -9,
  "35983": -12,
  "35984": -3,
  "35986": -5,
  "35987": -7,
  "35988": -5,
  "35989": -5,
  "35990": -11,
  "36003": -7,
  "36005": -9,
  "36006": -6,
  "36008": -6,
  "36009": -10,
  "36010": -10,
  "36013": 1,
  "36015": -8,
  "36016": 6,
  "36017": 6,
  "36020": -4,
  "36022": -6,
  "36023": 2,
  "36024": -4,
  "36025": -4,
  "36026": -2,
  "36027": 7,
  "36028": -10,
  "36029": 2,
  "36030": -7,
  "36031": 2,
  "36032": -13,
  "36033": -8,
  "36034": -11,
  "36035": -10,
  "36036": -9,
  "36037": -7,
  "36038": -10,
  "36039": 1,
  "36040": -13,
  "36041": -10,
  "36042": -11,
  "36043": 1,
  "36045": 2,
  "36046": -13,
  "36047": -13,
  "36048": 6,
  "36049": -10,
  "36051": -6,
  "36052": 1,
  "36053": 7,
  "36054": -6,
  "36057": 9,
  "36061": -9,
  "36062": -10,
  "36064": 9,
  "36065": -9,
  "36066": -4,
  "36067": -6,
  "36068": -4,
  "36069": -13,
  "36071": -10,
  "36072": 7,
  "36075": 2,
  "36078": 2,
  "36079": -9,
  "36080": -2,
  "36081": -9,
  "36083": 3,
  "36087": 3,
  "36088": 3,
  "36089": 3,
  "36091": -6,
  "36092": 5,
  "36093": -4,
  "36101": 1,
  "36102": 1,
  "36103": 1,
  "36104": 1,
  "36105": 1,
  "36106": 9,
  "36107": 1,
  "36108": 1,
  "36109": 1,
  "36110": 1,
  "36111": 9,
  "36112": 1,
  "36113": 1,
  "36114": 1,
  "36115": 1,
  "36116": 1,
  "36117": 9,
  "36119": 1,
  "36120": 1,
  "36121": 9,
  "36123": 1,
  "36124": 9,
  "36125": 1,
  "36201": -3,
  "36202": -3,
  "36203": -3,
  "36204": -3,
  "36205": -3,
  "36206": -3,
  "36207": -3,
  "36210": -3,
  "36250": -3,
  "36251": -9,
  "36253": -3,
  "36254": -3,
  "36255": -8,
  "36256": -11,
  "36257": -3,
  "36258": -9,
  "36260": -3,
  "36261": -7,
  "36262": -7,
  "36263": -7,
  "36264": -7,
  "36265": -3,
  "36266": -9,
  "36267": -6,
  "36268": -7,
  "36269": -7,
  "36271": -3,
  "36272": -12,
  "36273": -7,
  "36274": -9,
  "36275": -12,
  "36276": -10,
  "36277": -3,
  "36278": -10,
  "36279": -3,
  "36280": -10,
  "36301": -5,
  "36302": 4,
  "36303": 4,
  "36304": 4,
  "36305": 4,
  "36310": 1,
  "36311": -7,
  "36312": -5,
  "36313": -14,
  "36314": -13,
  "36316": -13,
  "36317": -6,
  "36318": -13,
  "36319": 1,
  "36320": -5,
  "36321": -5,
  "36322": -6,
  "36323": -9,
  "36330": 0,
  "36331": 0,
  "36340": -14,
  "36343": -5,
  "36344": -14,
  "36345": 3,
  "36346": -9,
  "36349": -5,
  "36350": -6,
  "36351": -9,
  "36352": -6,
  "36353": 1,
  "36360": -6,
  "36361": -6,
  "36362": 2,
  "36370": -5,
  "36371": -6,
  "36373": 1,
  "36374": -6,
  "36375": -5,
  "36376": -5,
  "36401": -12,
  "36420": -10,
  "36421": -10,
  "36425": -1,
  "36426": -12,
  "36427": -12,
  "36429": -12,
  "36432": -12,
  "36435": -10,
  "36436": -6,
  "36439": -1,
  "36441": -6,
  "36442": -10,
  "36444": -1,
  "36445": -1,
  "36446": -6,
  "36449": -1,
  "36451": -6,
  "36453": -9,
  "36454": -12,
  "36455": -10,
  "36456": -8,
  "36457": -1,
  "36458": -1,
  "36460": -1,
  "36461": -1,
  "36467": -9,
  "36470": -1,
  "36471": -1,
  "36473": -12,
  "36474": -10,
  "36475": -1,
  "36476": -10,
  "36477": -13,
  "36480": -1,
  "36481": -10,
  "36482": -6,
  "36483": -10,
  "36501": -6,
  "36502": -7,
  "36503": -7,
  "36504": -7,
  "36505": 0,
  "36507": -1,
  "36509": -2,
  "36511": -1,
  "36512": 3,
  "36513": 0,
  "36515": 3,
  "36518": 3,
  "36521": 0,
  "36522": 3,
  "36523": -1,
  "36524": -6,
  "36525": 0,
  "36526": -1,
  "36527": -1,
  "36528": 6,
  "36529": 3,
  "36530": -1,
  "36532": -1,
  "36533": -1,
  "36535": -1,
  "36536": -1,
  "36538": -6,
  "36539": 3,
  "36540": -1,
  "36541": 0,
  "36542": 8,
  "36543": -7,
  "36544": -1,
  "36545": -6,
  "36547": 8,
  "36548": -6,
  "36549": -4,
  "36550": 3,
  "36551": -1,
  "36553": 3,
  "36555": -1,
  "36556": 3,
  "36558": -9,
  "36559": 9,
  "36560": 3,
  "36561": 5,
  "36562": -7,
  "36564": 9,
  "36567": -1,
  "36568": 0,
  "36569": 3,
  "36571": 0,
  "36572": 0,
  "36574": -4,
  "36575": 0,
  "36576": -1,
  "36577": -1,
  "36578": -1,
  "36579": 3,
  "36580": -1,
  "36581": 3,
  "36582": 0,
  "36583": 3,
  "36584": 3,
  "36585": 3,
  "36587": 0,
  "36590": 0,
  "36601": 0,
  "36602": 0,
  "36603": -1,
  "36604": 0,
  "36605": -1,
  "36606": 0,
  "36607": -1,
  "36608": 0,
  "36609": 0,
  "36610": -1,
  "36611": 0,
  "36612": -1,
  "36613": -1,
  "36615": -1,
  "36616": 0,
  "36617": -1,
  "36618": 0,
  "36619": 0,
  "36633": 0,
  "36640": 0,
  "36641": 0,
  "36652": 0,
  "36660": 0,
  "36663": -1,
  "36670": -1,
  "36671": -1,
  "36685": 0,
  "36689": 0,
  "36691": 0,
  "36693": 0,
  "36695": 0,
  "36701": -4,
  "36702": -4,
  "36703": -4,
  "36720": -9,
  "36721": -9,
  "36722": -9,
  "36723": -9,
  "36726": -9,
  "36727": 3,
  "36728": -10,
  "36732": -3,
  "36736": -3,
  "36738": -4,
  "36740": -9,
  "36741": -13,
  "36742": -3,
  "36744": -9,
  "36745": -3,
  "36748": -3,
  "36749": -4,
  "36750": -5,
  "36751": -10,
  "36752": -13,
  "36753": -1,
  "36754": -4,
  "36756": -13,
  "36758": -6,
  "36759": -3,
  "36761": -13,
  "36762": 3,
  "36763": -3,
  "36764": -4,
  "36765": -13,
  "36766": -8,
  "36767": -4,
  "36768": -8,
  "36769": -10,
  "36773": -4,
  "36775": -4,
  "36776": -9,
  "36782": -4,
  "36783": -3,
  "36784": -5,
  "36785": -13,
  "36786": -13,
  "36790": -5,
  "36792": -7,
  "36793": 6,
  "36801": -3,
  "36802": -3,
  "36803": -3,
  "36804": -3,
  "36830": 7,
  "36831": 7,
  "36832": 7,
  "36850": -10,
  "36851": -6,
  "36852": -3,
  "36853": -9,
  "36854": -8,
  "36855": -8,
  "36856": -5,
  "36858": -4,
  "36859": -6,
  "36860": -5,
  "36861": -9,
  "36862": -8,
  "36863": -8,
  "36865": -2,
  "36866": 3,
  "36867": -5,
  "36868": -5,
  "36869": -5,
  "36870": -5,
  "36871": -6,
  "36872": -8,
  "36874": -3,
  "36875": -5,
  "36877": -5,
  "36879": -1,
  "36901": 0,
  "36904": 3,
  "36907": 0,
  "36908": 3,
  "36910": 4,
  "36912": 4,
  "36913": 2,
  "36915": 2,
  "36916": 4,
  "36919": 2,
  "36921": 2,
  "36922": 0,
  "36925": 1,
  "37010": 7,
  "37011": 8,
  "37012": -11,
  "37013": 8,
  "37014": 9,
  "37015": -3,
  "37016": -13,
  "37018": 2,
  "37019": 1,
  "37020": 0,
  "37022": -12,
  "37023": 16,
  "37024": 21,
  "37025": -6,
  "37026": -13,
  "37027": 21,
  "37028": 15,
  "37029": -6,
  "37030": -2,
  "37031": -12,
  "37032": 7,
  "37033": -13,
  "37034": 0,
  "37035": -4,
  "37036": -7,
  "37037": 1,
  "37040": -3,
  "37041": -3,
  "37042": -3,
  "37043": -3,
  "37046": 21,
  "37047": 1,
  "37048": 6,
  "37049": 0,
  "37050": 15,
  "37051": -7,
  "37052": -3,
  "37055": -7,
  "37056": -7,
  "37057": -12,
  "37058": 16,
  "37059": -11,
  "37060": 1,
  "37061": 15,
  "37062": 12,
  "37063": 1,
  "37064": 14,
  "37065": 14,
  "37066": 6,
  "37067": 21,
  "37068": 21,
  "37069": 21,
  "37070": 0,
  "37071": 0,
  "37072": 0,
  "37073": 0,
  "37074": -12,
  "37075": 6,
  "37076": 8,
  "37077": 6,
  "37078": -3,
  "37079": -3,
  "37080": -3,
  "37082": -3,
  "37083": -12,
  "37085": 1,
  "37086": 1,
  "37087": 0,
  "37088": 0,
  "37090": 0,
  "37091": 1,
  "37095": -11,
  "37096": -13,
  "37097": -13,
  "37098": -6,
  "37101": -3,
  "37110": -9,
  "37111": -9,
  "37115": 8,
  "37116": 8,
  "37118": -5,
  "37119": 6,
  "37121": 0,
  "37122": 0,
  "37127": 1,
  "37128": 1,
  "37129": 1,
  "37130": 1,
  "37133": 1,
  "37134": -8,
  "37135": 12,
  "37136": 0,
  "37137": -6,
  "37138": 8,
  "37140": -7,
  "37141": 0,
  "37142": -3,
  "37143": -3,
  "37144": 0,
  "37145": -2,
  "37146": 5,
  "37148": 6,
  "37149": -13,
  "37150": -12,
  "37151": -2,
  "37152": 0,
  "37153": 1,
  "37160": 0,
  "37162": 0,
  "37165": -7,
  "37166": -11,
  "37167": 1,
  "37171": -3,
  "37172": 0,
  "37174": 2,
  "37175": 15,
  "37178": 15,
  "37179": 12,
  "37180": 0,
  "37181": -7,
  "37183": 0,
  "37184": 0,
  "37185": -3,
  "37186": -12,
  "37187": -6,
  "37188": 6,
  "37189": 8,
  "37190": -13,
  "37191": -3,
  "37201": 8,
  "37202": 8,
  "37203": 8,
  "37204": 9,
  "37205": 16,
  "37206": 8,
  "37207": 8,
  "37208": 7,
  "37209": 8,
  "37210": 8,
  "37211": 8,
  "37212": 9,
  "37213": 8,
  "37214": 8,
  "37215": 19,
  "37216": 8,
  "37217": 8,
  "37218": 8,
  "37219": 8,
  "37220": 16,
  "37221": 12,
  "37222": 8,
  "37224": 8,
  "37227": 8,
  "37228": 7,
  "37229": 8,
  "37230": 8,
  "37238": 8,
  "37244": 8,
  "37301": -8,
  "37302": 9,
  "37303": -5,
  "37304": -2,
  "37305": -8,
  "37306": -9,
  "37307": -13,
  "37308": 1,
  "37309": -5,
  "37310": 1,
  "37311": 1,
  "37312": 1,
  "37313": -8,
  "37314": -12,
  "37315": 6,
  "37316": -12,
  "37317": -12,
  "37318": -9,
  "37320": 1,
  "37321": -2,
  "37322": -2,
  "37323": 1,
  "37324": -9,
  "37325": -13,
  "37326": -13,
  "37327": -14,
  "37328": -1,
  "37329": -5,
  "37330": -8,
  "37331": -5,
  "37332": -2,
  "37333": -13,
  "37334": -1,
  "37335": -1,
  "37336": 1,
  "37337": -9,
  "37338": -2,
  "37339": -8,
  "37340": 13,
  "37341": 5,
  "37342": 2,
  "37343": 5,
  "37345": -8,
  "37347": 13,
  "37348": -1,
  "37349": 2,
  "37350": 15,
  "37351": 4,
  "37352": -8,
  "37353": 1,
  "37354": -12,
  "37355": 2,
  "37356": -8,
  "37357": -9,
  "37359": -9,
  "37360": 2,
  "37361": -12,
  "37362": -12,
  "37363": 6,
  "37364": 1,
  "37365": -15,
  "37366": -8,
  "37367": -13,
  "37369": -13,
  "37370": -5,
  "37371": -5,
  "37373": -2,
  "37374": 13,
  "37375": -9,
  "37376": -9,
  "37377": 13,
  "37378": -9,
  "37379": 5,
  "37380": 13,
  "37381": -2,
  "37382": -9,
  "37384": 5,
  "37385": -12,
  "37387": -8,
  "37388": 2,
  "37389": -8,
  "37391": -13,
  "37394": -9,
  "37396": 5,
  "37397": 13,
  "37398": -8,
  "37401": 4,
  "37402": 5,
  "37403": 4,
  "37404": 4,
  "37405": 5,
  "37406": 4,
  "37407": 4,
  "37408": 4,
  "37409": 4,
  "37410": 4,
  "37411": 5,
  "37412": 5,
  "37414": 5,
  "37415": 5,
  "37416": 5,
  "37419": 5,
  "37421": 6,
  "37422": 13,
  "37424": 6,
  "37450": 5,
  "37601": -8,
  "37602": -8,
  "37604": -8,
  "37605": -8,
  "37614": -8,
  "37615": 1,
  "37616": -6,
  "37617": 7,
  "37618": -2,
  "37620": -2,
  "37621": -2,
  "37625": -2,
  "37640": -8,
  "37641": -6,
  "37642": 11,
  "37643": -8,
  "37644": -8,
  "37645": 11,
  "37650": -8,
  "37656": 0,
  "37657": -7,
  "37658": -8,
  "37659": -8,
  "37660": 7,
  "37662": 7,
  "37663": 8,
  "37664": 7,
  "37665": -1,
  "37680": -11,
  "37681": -8,
  "37682": -8,
  "37683": -11,
  "37684": -8,
  "37686": 0,
  "37687": -8,
  "37688": -11,
  "37690": -8,
  "37691": -11,
  "37692": -8,
  "37694": -8,
  "37701": -5,
  "37705": -7,
  "37707": -13,
  "37708": -2,
  "37709": -8,
  "37710": -1,
  "37711": 6,
  "37713": -14,
  "37714": -12,
  "37715": -14,
  "37716": 0,
  "37717": 0,
  "37719": 0,
  "37721": -8,
  "37722": -15,
  "37723": -9,
  "37724": -13,
  "37725": -9,
  "37726": -12,
  "37727": -14,
  "37729": -12,
  "37730": -14,
  "37731": 3,
  "37732": -12,
  "37733": -16,
  "37737": -5,
  "37738": 0,
  "37742": -7,
  "37743": -6,
  "37744": -6,
  "37745": -6,
  "37748": -12,
  "37752": -13,
  "37753": -14,
  "37754": 0,
  "37755": -12,
  "37756": -12,
  "37757": -12,
  "37760": -9,
  "37762": -13,
  "37763": -9,
  "37764": -9,
  "37765": -25,
  "37766": -12,
  "37769": 0,
  "37770": -12,
  "37771": -7,
  "37772": -7,
  "37773": -13,
  "37774": -7,
  "37777": -5,
  "37778": -2,
  "37779": -8,
  "37801": -5,
  "37802": -5,
  "37803": -5,
  "37804": -5,
  "37806": -8,
  "37807": 2,
  "37809": -7,
  "37810": -2,
  "37811": -2,
  "37813": -2,
  "37814": -2,
  "37815": -2,
  "37816": -2,
  "37818": -7,
  "37819": -13,
  "37820": -9,
  "37821": -15,
  "37822": -15,
  "37824": -13,
  "37825": -13,
  "37826": -5,
  "37828": 8,
  "37829": -12,
  "37830": 0,
  "37831": 0,
  "37840": 0,
  "37841": -12,
  "37843": -14,
  "37845": 8,
  "37846": -9,
  "37847": -13,
  "37848": -8,
  "37849": 0,
  "37851": -14,
  "37852": -12,
  "37853": -5,
  "37854": -9,
  "37857": 11,
  "37860": 6,
  "37861": -9,
  "37862": -9,
  "37863": -7,
  "37864": -7,
  "37865": -9,
  "37866": -8,
  "37867": -13,
  "37868": -7,
  "37869": -24,
  "37870": -13,
  "37871": 0,
  "37872": -12,
  "37873": 4,
  "37874": -12,
  "37876": -9,
  "37877": -2,
  "37878": -5,
  "37879": -13,
  "37880": -15,
  "37881": -25,
  "37882": -4,
  "37885": -12,
  "37886": -5,
  "37887": -12,
  "37888": -9,
  "37890": -2,
  "37891": 6,
  "37892": -12,
  "37901": 0,
  "37902": 9,
  "37909": 1,
  "37912": 0,
  "37914": 0,
  "37915": 0,
  "37916": 0,
  "37917": 0,
  "37918": 0,
  "37919": 9,
  "37920": 0,
  "37921": 0,
  "37922": 9,
  "37923": 9,
  "37924": 0,
  "37927": 0,
  "37928": 0,
  "37929": 9,
  "37930": 9,
  "37931": 2,
  "37932": 9,
  "37933": 9,
  "37934": 9,
  "37938": 2,
  "37939": 9,
  "37940": 0,
  "37950": 1,
  "38001": 10,
  "38002": -2,
  "38004": -4,
  "38006": 10,
  "38007": -5,
  "38008": -3,
  "38010": 4,
  "38011": -4,
  "38012": 17,
  "38014": -2,
  "38015": -4,
  "38016": 12,
  "38017": 12,
  "38018": 12,
  "38019": -4,
  "38021": 9,
  "38023": -4,
  "38024": -5,
  "38025": -5,
  "38027": 12,
  "38028": 4,
  "38029": 4,
  "38030": 2,
  "38034": 9,
  "38036": -4,
  "38037": 1,
  "38039": -4,
  "38040": 1,
  "38041": 1,
  "38042": -4,
  "38044": -4,
  "38045": 4,
  "38046": -4,
  "38047": -5,
  "38048": 4,
  "38049": -4,
  "38050": 9,
  "38052": -3,
  "38053": -4,
  "38054": -4,
  "38057": -4,
  "38058": -4,
  "38059": -5,
  "38060": -4,
  "38061": -13,
  "38063": 2,
  "38066": -4,
  "38067": -3,
  "38068": 4,
  "38069": 16,
  "38070": -5,
  "38071": -4,
  "38075": -4,
  "38076": 4,
  "38077": -5,
  "38079": -8,
  "38080": -5,
  "38083": -4,
  "38088": 12,
  "38101": 3,
  "38103": 12,
  "38104": 4,
  "38105": 3,
  "38106": 3,
  "38107": 4,
  "38108": 3,
  "38109": 4,
  "38111": 4,
  "38112": 4,
  "38113": 4,
  "38114": 3,
  "38115": 4,
  "38116": 4,
  "38117": 4,
  "38118": 4,
  "38119": 5,
  "38120": 12,
  "38122": 4,
  "38124": 4,
  "38125": 4,
  "38126": 3,
  "38127": 4,
  "38128": 4,
  "38130": 4,
  "38131": 4,
  "38132": 3,
  "38133": 4,
  "38134": 4,
  "38135": 4,
  "38137": 12,
  "38138": 4,
  "38139": 12,
  "38141": 4,
  "38157": 12,
  "38167": 4,
  "38168": 4,
  "38173": 12,
  "38174": 4,
  "38175": 4,
  "38177": 4,
  "38181": 4,
  "38182": 4,
  "38183": 12,
  "38184": 4,
  "38186": 4,
  "38187": 5,
  "38190": 4,
  "38201": -3,
  "38220": -7,
  "38221": -8,
  "38222": -12,
  "38223": -12,
  "38224": -12,
  "38225": -16,
  "38226": -17,
  "38229": -17,
  "38230": -17,
  "38231": -12,
  "38232": -8,
  "38233": -8,
  "38235": -3,
  "38236": -12,
  "38237": -15,
  "38240": -8,
  "38241": -16,
  "38242": -12,
  "38251": -13,
  "38253": -8,
  "38254": -8,
  "38255": -17,
  "38256": -12,
  "38257": -8,
  "38258": -3,
  "38259": -8,
  "38260": -8,
  "38261": -8,
  "38271": -8,
  "38281": -8,
  "38301": 7,
  "38302": 7,
  "38303": 7,
  "38305": 15,
  "38308": 7,
  "38310": -12,
  "38311": -3,
  "38313": 7,
  "38314": 7,
  "38315": -13,
  "38316": -7,
  "38317": -8,
  "38318": -3,
  "38320": -7,
  "38321": -3,
  "38324": -3,
  "38326": -13,
  "38327": -13,
  "38328": -3,
  "38329": -4,
  "38330": -7,
  "38331": 9,
  "38332": -8,
  "38333": -8,
  "38334": -7,
  "38336": 10,
  "38337": 10,
  "38338": -7,
  "38339": -13,
  "38340": -7,
  "38341": -8,
  "38342": -8,
  "38343": -7,
  "38344": -3,
  "38345": -7,
  "38346": -7,
  "38347": -6,
  "38348": -3,
  "38351": -7,
  "38352": 15,
  "38355": 15,
  "38356": 7,
  "38357": -13,
  "38358": -7,
  "38359": -8,
  "38361": -13,
  "38362": 15,
  "38363": -4,
  "38365": -12,
  "38366": -7,
  "38367": -12,
  "38368": -8,
  "38369": -7,
  "38370": -13,
  "38371": -8,
  "38372": -13,
  "38374": -3,
  "38375": -13,
  "38376": -12,
  "38377": 7,
  "38378": 8,
  "38379": -13,
  "38380": -4,
  "38381": -3,
  "38382": -7,
  "38387": -3,
  "38388": -7,
  "38389": -7,
  "38390": -3,
  "38391": 6,
  "38392": 16,
  "38393": -12,
  "38401": 0,
  "38402": 0,
  "38425": -17,
  "38449": -10,
  "38450": -17,
  "38451": 1,
  "38452": -17,
  "38453": -10,
  "38454": -6,
  "38455": -10,
  "38456": -7,
  "38457": -8,
  "38459": -10,
  "38460": -11,
  "38461": -11,
  "38462": -13,
  "38463": -5,
  "38464": -7,
  "38468": -7,
  "38469": -8,
  "38471": -18,
  "38472": -9,
  "38473": -11,
  "38474": 0,
  "38475": -13,
  "38476": -6,
  "38477": -10,
  "38478": -10,
  "38481": -5,
  "38482": 0,
  "38483": -13,
  "38485": -17,
  "38486": -8,
  "38487": -11,
  "38488": -1,
  "38501": -5,
  "38502": -5,
  "38503": -5,
  "38504": -16,
  "38506": -5,
  "38541": -8,
  "38542": -8,
  "38543": -8,
  "38544": -5,
  "38545": -5,
  "38547": -2,
  "38548": -2,
  "38549": -8,
  "38550": -9,
  "38551": -7,
  "38552": -2,
  "38553": -15,
  "38554": -8,
  "38555": -9,
  "38556": -15,
  "38557": -1,
  "38558": -9,
  "38559": -15,
  "38560": -2,
  "38562": -5,
  "38563": -2,
  "38564": -2,
  "38565": -15,
  "38567": -2,
  "38568": -7,
  "38569": -9,
  "38570": -8,
  "38571": -1,
  "38572": -1,
  "38573": -8,
  "38574": -6,
  "38575": -7,
  "38577": -15,
  "38578": -9,
  "38579": -15,
  "38580": -8,
  "38581": -9,
  "38582": -11,
  "38583": -15,
  "38585": -13,
  "38587": -15,
  "38588": -2,
  "38589": -16,
  "38601": -1,
  "38602": -2,
  "38603": -3,
  "38606": -5,
  "38609": -3,
  "38610": -3,
  "38611": -1,
  "38614": -3,
  "38617": -3,
  "38618": -2,
  "38619": -3,
  "38620": -5,
  "38621": -5,
  "38622": -5,
  "38623": -5,
  "38625": -3,
  "38626": -1,
  "38627": -7,
  "38628": -6,
  "38629": -3,
  "38630": -3,
  "38631": -3,
  "38632": 1,
  "38633": -3,
  "38634": -1,
  "38635": -1,
  "38637": 1,
  "38638": -2,
  "38639": -3,
  "38641": 9,
  "38642": -1,
  "38643": -3,
  "38644": -3,
  "38645": -3,
  "38646": -3,
  "38647": 3,
  "38649": -1,
  "38650": -3,
  "38651": 1,
  "38652": -7,
  "38654": 1,
  "38655": 0,
  "38658": -5,
  "38659": -1,
  "38661": -1,
  "38663": -3,
  "38664": -1,
  "38665": 0,
  "38666": -5,
  "38668": -2,
  "38669": -3,
  "38670": -5,
  "38671": 1,
  "38672": 1,
  "38673": 0,
  "38674": -3,
  "38675": 0,
  "38676": -1,
  "38677": 0,
  "38679": -1,
  "38680": 9,
  "38683": -3,
  "38685": -1,
  "38701": -6,
  "38702": -7,
  "38703": -7,
  "38704": -7,
  "38720": -3,
  "38721": -19,
  "38722": -7,
  "38723": -6,
  "38725": -3,
  "38726": -4,
  "38730": 5,
  "38731": -19,
  "38732": -2,
  "38733": -4,
  "38736": -3,
  "38737": -3,
  "38738": -4,
  "38739": -3,
  "38740": -2,
  "38744": -19,
  "38745": -18,
  "38746": -3,
  "38748": -7,
  "38749": -3,
  "38751": -3,
  "38753": -13,
  "38754": -13,
  "38756": -6,
  "38759": -3,
  "38760": -7,
  "38761": -4,
  "38762": -3,
  "38764": -4,
  "38765": -19,
  "38767": -3,
  "38768": -3,
  "38769": -3,
  "38771": -4,
  "38772": -7,
  "38773": -4,
  "38774": -3,
  "38776": -6,
  "38778": -4,
  "38780": -6,
  "38781": -3,
  "38782": -7,
  "38801": 8,
  "38802": 1,
  "38803": 1,
  "38804": 1,
  "38820": -7,
  "38821": 11,
  "38824": -2,
  "38825": 11,
  "38826": 8,
  "38827": -8,
  "38828": -7,
  "38829": -2,
  "38833": -8,
  "38834": -1,
  "38835": -1,
  "38838": -8,
  "38839": 2,
  "38841": -7,
  "38843": 8,
  "38844": 6,
  "38846": -1,
  "38847": -8,
  "38848": 12,
  "38849": 0,
  "38850": -6,
  "38851": -6,
  "38852": -8,
  "38855": 8,
  "38856": -2,
  "38857": 0,
  "38858": 11,
  "38859": -3,
  "38860": -7,
  "38862": 0,
  "38863": -7,
  "38864": -7,
  "38865": -1,
  "38866": 1,
  "38868": 0,
  "38869": -7,
  "38870": 11,
  "38871": -7,
  "38873": -8,
  "38874": -7,
  "38875": -6,
  "38876": 8,
  "38877": -6,
  "38878": 2,
  "38879": 0,
  "38880": -2,
  "38901": -4,
  "38902": -4,
  "38913": 2,
  "38914": 2,
  "38915": 2,
  "38916": 2,
  "38917": 1,
  "38920": -5,
  "38921": -5,
  "38922": -1,
  "38923": 0,
  "38924": -6,
  "38925": -2,
  "38926": -4,
  "38927": -5,
  "38928": -5,
  "38929": -4,
  "38930": 2,
  "38935": 2,
  "38940": -5,
  "38941": 2,
  "38943": 1,
  "38944": 1,
  "38945": 2,
  "38946": 1,
  "38947": 1,
  "38948": -1,
  "38949": 0,
  "38950": 2,
  "38951": 2,
  "38952": 1,
  "38953": -4,
  "38954": 1,
  "38955": 2,
  "38957": -3,
  "38958": -5,
  "38959": 1,
  "38960": -4,
  "38961": -1,
  "38962": -5,
  "38963": -3,
  "38964": -3,
  "38965": -1,
  "38966": -3,
  "38967": -2,
  "39038": -13,
  "39039": -1,
  "39040": -1,
  "39041": 3,
  "39042": 13,
  "39043": 13,
  "39044": 0,
  "39045": 7,
  "39046": 8,
  "39047": 13,
  "39051": 4,
  "39054": -19,
  "39056": 12,
  "39057": 1,
  "39059": -2,
  "39060": 3,
  "39061": -19,
  "39062": 0,
  "39063": -6,
  "39066": 1,
  "39067": 4,
  "39069": -3,
  "39071": 8,
  "39072": 8,
  "39073": 4,
  "39074": -3,
  "39077": -2,
  "39078": -3,
  "39079": -6,
  "39080": -3,
  "39081": -3,
  "39082": 0,
  "39083": -2,
  "39086": -3,
  "39087": -3,
  "39088": -18,
  "39090": 4,
  "39092": -3,
  "39094": -3,
  "39095": -6,
  "39096": -3,
  "39097": -14,
  "39098": -2,
  "39107": 3,
  "39108": 20,
  "39109": 38,
  "39110": 16,
  "39111": 0,
  "39113": -19,
  "39114": 0,
  "39115": -13,
  "39116": -6,
  "39117": -2,
  "39119": -4,
  "39120": -3,
  "39121": -3,
  "39122": -3,
  "39130": 16,
  "39140": 0,
  "39144": -3,
  "39145": 4,
  "39146": -6,
  "39148": 0,
  "39149": 0,
  "39150": 1,
  "39151": 9,
  "39152": -2,
  "39153": -6,
  "39154": 12,
  "39156": 1,
  "39157": 16,
  "39158": 16,
  "39159": -19,
  "39160": 3,
  "39161": 8,
  "39162": -1,
  "39163": 8,
  "39165": -3,
  "39166": -13,
  "39167": 4,
  "39168": -6,
  "39169": -6,
  "39170": 12,
  "39171": 7,
  "39173": -1,
  "39174": 2,
  "39175": -2,
  "39176": -2,
  "39177": -18,
  "39179": 8,
  "39180": 1,
  "39181": 1,
  "39182": 1,
  "39183": 1,
  "39189": -2,
  "39190": -3,
  "39191": -2,
  "39192": 3,
  "39193": 4,
  "39194": -1,
  "39201": 2,
  "39202": 12,
  "39203": 2,
  "39204": 3,
  "39205": 12,
  "39206": 3,
  "39207": 2,
  "39208": 4,
  "39209": 3,
  "39211": 13,
  "39212": 3,
  "39213": 3,
  "39215": 2,
  "39216": 12,
  "39218": 3,
  "39225": 2,
  "39232": 2,
  "39236": 13,
  "39269": 2,
  "39272": 3,
  "39282": 3,
  "39283": 3,
  "39284": 3,
  "39286": 3,
  "39288": 12,
  "39289": 12,
  "39296": 12,
  "39298": 2,
  "39301": -3,
  "39302": -3,
  "39303": 6,
  "39304": -3,
  "39305": 6,
  "39307": -3,
  "39320": 6,
  "39322": -3,
  "39323": 0,
  "39324": -3,
  "39325": -3,
  "39326": 1,
  "39327": 1,
  "39328": 1,
  "39330": 10,
  "39332": 1,
  "39335": -1,
  "39336": 0,
  "39337": 38,
  "39338": 2,
  "39339": -5,
  "39341": -4,
  "39342": 6,
  "39345": 1,
  "39346": -6,
  "39347": 10,
  "39348": 2,
  "39350": 38,
  "39352": 1,
  "39354": 1,
  "39355": 10,
  "39356": 3,
  "39358": 1,
  "39359": -2,
  "39360": 10,
  "39361": -5,
  "39362": -3,
  "39363": 10,
  "39364": -1,
  "39365": 38,
  "39366": 2,
  "39367": -3,
  "39401": 1,
  "39402": 10,
  "39403": 1,
  "39404": 10,
  "39421": 10,
  "39422": 2,
  "39423": -10,
  "39425": -9,
  "39426": 3,
  "39427": 10,
  "39428": -4,
  "39429": 13,
  "39436": 2,
  "39437": 2,
  "39439": 2,
  "39440": 2,
  "39441": 1,
  "39442": 1,
  "39443": 1,
  "39451": 2,
  "39452": 3,
  "39455": -1,
  "39456": -10,
  "39457": 3,
  "39459": 2,
  "39460": 2,
  "39461": -10,
  "39462": -10,
  "39463": 3,
  "39464": 2,
  "39465": 1,
  "39466": 3,
  "39470": 2,
  "39474": 10,
  "39475": 7,
  "39476": -10,
  "39477": 1,
  "39478": 12,
  "39479": -4,
  "39480": 2,
  "39481": 2,
  "39482": -1,
  "39483": 12,
  "39501": 1,
  "39502": 1,
  "39503": 2,
  "39505": 2,
  "39506": 2,
  "39507": 2,
  "39520": 1,
  "39521": 1,
  "39525": 9,
  "39530": 2,
  "39531": 3,
  "39532": 2,
  "39533": 2,
  "39534": 2,
  "39535": 3,
  "39540": 2,
  "39552": 6,
  "39553": 7,
  "39555": 6,
  "39556": 1,
  "39558": 1,
  "39560": 2,
  "39561": -2,
  "39562": 6,
  "39563": 6,
  "39564": 8,
  "39565": 8,
  "39566": 8,
  "39567": 6,
  "39568": 7,
  "39569": 7,
  "39571": 1,
  "39572": 1,
  "39573": -2,
  "39574": 2,
  "39576": 1,
  "39577": -3,
  "39581": 6,
  "39601": 2,
  "39602": 2,
  "39603": 2,
  "39629": 2,
  "39630": -10,
  "39631": 0,
  "39632": -7,
  "39633": -8,
  "39635": -7,
  "39638": -8,
  "39641": 1,
  "39643": 12,
  "39645": -8,
  "39647": 2,
  "39648": -7,
  "39649": -9,
  "39652": -7,
  "39653": -8,
  "39654": 1,
  "39656": 10,
  "39657": -7,
  "39661": -1,
  "39662": 1,
  "39663": 1,
  "39664": -8,
  "39665": 1,
  "39666": -8,
  "39667": -8,
  "39668": 1,
  "39669": 0,
  "39701": 10,
  "39702": 10,
  "39703": 10,
  "39704": 10,
  "39705": 10,
  "39730": 12,
  "39735": 21,
  "39736": -5,
  "39737": -2,
  "39739": -4,
  "39740": 10,
  "39741": -4,
  "39743": -4,
  "39744": -2,
  "39745": 21,
  "39746": 12,
  "39747": -2,
  "39750": 0,
  "39751": 0,
  "39752": 0,
  "39753": 10,
  "39754": -4,
  "39755": -5,
  "39756": 12,
  "39759": -5,
  "39760": -5,
  "39762": -5,
  "39766": 10,
  "39767": -2,
  "39769": -5,
  "39771": -2,
  "39772": 21,
  "39773": -4,
  "39776": -6,
  "39813": 6,
  "39815": -5,
  "39817": -10,
  "39818": -10,
  "39819": -10,
  "39823": -11,
  "39824": -21,
  "39825": -11,
  "39826": -13,
  "39827": -5,
  "39828": -5,
  "39829": -5,
  "39832": -11,
  "39834": -5,
  "39836": -20,
  "39837": -11,
  "39840": -21,
  "39841": -11,
  "39842": -13,
  "39845": -11,
  "39846": -21,
  "39851": -20,
  "39852": -10,
  "39854": -20,
  "39859": -11,
  "39861": -11,
  "39862": 6,
  "39866": 6,
  "39867": -20,
  "39870": -11,
  "39877": -21,
  "39885": 0,
  "39886": -21,
  "39897": -5,
  "40003": -2,
  "40004": 0,
  "40006": -9,
  "40007": -10,
  "40008": -10,
  "40009": -11,
  "40010": 5,
  "40011": -10,
  "40012": -10,
  "40013": 0,
  "40014": 5,
  "40018": 5,
  "40019": -10,
  "40020": -10,
  "40022": -1,
  "40023": -1,
  "40025": 5,
  "40026": 5,
  "40027": 5,
  "40031": -3,
  "40033": -8,
  "40036": 1,
  "40037": -10,
  "40040": -6,
  "40041": 9,
  "40045": -11,
  "40046": -10,
  "40047": 1,
  "40048": 0,
  "40049": -10,
  "40050": -10,
  "40051": -7,
  "40052": -7,
  "40055": -9,
  "40056": -3,
  "40057": -10,
  "40058": -10,
  "40059": 5,
  "40060": -10,
  "40061": -6,
  "40062": -10,
  "40063": -8,
  "40065": -6,
  "40066": -6,
  "40067": -6,
  "40068": -10,
  "40069": -6,
  "40070": -10,
  "40071": -10,
  "40075": -10,
  "40076": -5,
  "40077": -3,
  "40078": -6,
  "40104": -2,
  "40107": -1,
  "40108": -2,
  "40109": 1,
  "40110": 1,
  "40111": -3,
  "40115": -12,
  "40117": -2,
  "40118": 7,
  "40119": -12,
  "40121": -2,
  "40129": 1,
  "40140": -12,
  "40142": -2,
  "40143": -12,
  "40144": -12,
  "40145": -12,
  "40146": -12,
  "40150": 1,
  "40152": -12,
  "40153": -12,
  "40155": -2,
  "40157": -2,
  "40159": 11,
  "40160": 11,
  "40161": -11,
  "40162": 12,
  "40165": 1,
  "40170": -12,
  "40171": -12,
  "40175": 11,
  "40176": -11,
  "40177": -2,
  "40178": -12,
  "40201": 7,
  "40202": 8,
  "40203": 7,
  "40204": 8,
  "40205": 8,
  "40206": 8,
  "40207": 9,
  "40208": 7,
  "40209": 7,
  "40210": 7,
  "40211": 7,
  "40212": -2,
  "40213": 7,
  "40214": 8,
  "40215": 7,
  "40216": 8,
  "40217": 8,
  "40218": 8,
  "40219": 8,
  "40220": 8,
  "40221": 7,
  "40222": 16,
  "40223": 8,
  "40224": 8,
  "40228": 8,
  "40229": 1,
  "40231": 7,
  "40232": 7,
  "40233": 16,
  "40241": 5,
  "40242": 16,
  "40243": 8,
  "40245": 5,
  "40250": 8,
  "40251": 7,
  "40252": 16,
  "40253": 8,
  "40255": 8,
  "40256": 8,
  "40257": 8,
  "40258": 8,
  "40259": 8,
  "40261": 8,
  "40268": 8,
  "40269": 8,
  "40270": 8,
  "40272": 8,
  "40285": 7,
  "40290": 7,
  "40291": 8,
  "40295": 8,
  "40298": 8,
  "40299": 8,
  "40310": -8,
  "40311": -4,
  "40312": -17,
  "40313": -7,
  "40316": -7,
  "40317": -8,
  "40319": -7,
  "40322": -7,
  "40324": -4,
  "40328": -8,
  "40330": -8,
  "40334": -6,
  "40336": -17,
  "40337": -6,
  "40339": -3,
  "40340": -3,
  "40342": -7,
  "40346": -7,
  "40347": -6,
  "40348": -4,
  "40350": -4,
  "40351": -8,
  "40353": -6,
  "40355": 2,
  "40356": -3,
  "40357": -3,
  "40358": -7,
  "40359": 2,
  "40360": -6,
  "40361": -3,
  "40362": -3,
  "40363": -9,
  "40366": -6,
  "40370": -4,
  "40371": -7,
  "40372": -8,
  "40374": -6,
  "40376": -5,
  "40379": -4,
  "40380": -17,
  "40383": -6,
  "40385": -17,
  "40387": -6,
  "40390": -3,
  "40391": -3,
  "40392": -3,
  "40402": -12,
  "40403": 7,
  "40405": 7,
  "40409": -3,
  "40410": -5,
  "40419": -3,
  "40422": -8,
  "40423": -8,
  "40434": -12,
  "40437": -3,
  "40440": -8,
  "40442": -3,
  "40444": -5,
  "40445": -12,
  "40447": -12,
  "40448": -3,
  "40452": -8,
  "40456": -12,
  "40460": -12,
  "40461": -5,
  "40464": -9,
  "40468": -8,
  "40472": -17,
  "40473": -12,
  "40475": 7,
  "40476": 7,
  "40481": -12,
  "40484": -3,
  "40486": -12,
  "40488": -12,
  "40489": -3,
  "40492": -12,
  "40495": -17,
  "40502": 12,
  "40503": 5,
  "40504": 3,
  "40505": 3,
  "40507": 12,
  "40508": 3,
  "40509": 12,
  "40510": 12,
  "40511": 3,
  "40512": 3,
  "40513": 12,
  "40514": 12,
  "40515": 12,
  "40516": 12,
  "40517": 3,
  "40522": 12,
  "40523": 3,
  "40524": 5,
  "40533": 3,
  "40544": 3,
  "40555": 12,
  "40574": 3,
  "40575": 3,
  "40576": 3,
  "40577": 3,
  "40578": 3,
  "40579": 3,
  "40580": 3,
  "40581": 3,
  "40582": 3,
  "40583": 3,
  "40588": 12,
  "40591": 12,
  "40601": -2,
  "40602": -2,
  "40603": -2,
  "40604": -2,
  "40701": -12,
  "40702": -12,
  "40724": -3,
  "40729": -3,
  "40730": -12,
  "40734": -9,
  "40737": -4,
  "40740": -4,
  "40741": -3,
  "40742": -3,
  "40743": -3,
  "40744": -3,
  "40745": -3,
  "40755": -3,
  "40759": -12,
  "40763": -12,
  "40769": -12,
  "40771": -12,
  "40801": -19,
  "40803": -19,
  "40806": -18,
  "40807": -16,
  "40808": -19,
  "40810": -19,
  "40813": -6,
  "40815": -19,
  "40816": -19,
  "40818": -18,
  "40819": -19,
  "40820": -19,
  "40823": -19,
  "40824": -19,
  "40826": -17,
  "40827": -19,
  "40828": -19,
  "40829": -18,
  "40830": -19,
  "40831": -18,
  "40840": -19,
  "40843": -19,
  "40844": -9,
  "40845": -6,
  "40847": -19,
  "40849": -19,
  "40854": -18,
  "40855": -17,
  "40856": -6,
  "40858": -19,
  "40862": -17,
  "40863": -6,
  "40865": -18,
  "40868": -9,
  "40870": -19,
  "40873": -18,
  "40874": -19,
  "40902": -7,
  "40903": -9,
  "40906": -9,
  "40913": -18,
  "40914": -11,
  "40915": -9,
  "40921": -6,
  "40923": -9,
  "40927": -18,
  "40930": -9,
  "40931": -11,
  "40932": -11,
  "40935": -9,
  "40939": -6,
  "40940": -7,
  "40941": -11,
  "40943": -9,
  "40944": -11,
  "40946": -9,
  "40949": -9,
  "40951": -11,
  "40953": -9,
  "40955": -9,
  "40958": -6,
  "40962": -11,
  "40964": -6,
  "40965": -6,
  "40972": -11,
  "40977": -6,
  "40979": -12,
  "40981": -9,
  "40982": -9,
  "40983": -11,
  "40988": -6,
  "40995": -9,
  "40997": -9,
  "41001": 2,
  "41002": -14,
  "41003": -3,
  "41004": -14,
  "41005": 2,
  "41006": -14,
  "41007": -2,
  "41008": -9,
  "41010": 2,
  "41011": 1,
  "41012": 1,
  "41014": 1,
  "41015": 2,
  "41016": 1,
  "41017": 2,
  "41018": 1,
  "41022": 2,
  "41030": 2,
  "41031": -3,
  "41033": 1,
  "41034": 2,
  "41035": 1,
  "41037": -4,
  "41039": -4,
  "41040": -14,
  "41041": 3,
  "41042": 2,
  "41043": -14,
  "41044": -14,
  "41045": -9,
  "41046": 1,
  "41048": 2,
  "41049": -6,
  "41051": 2,
  "41052": 1,
  "41053": 2,
  "41054": 1,
  "41055": 3,
  "41056": 2,
  "41059": 1,
  "41061": -14,
  "41062": 2,
  "41063": 2,
  "41064": -4,
  "41065": -5,
  "41071": 1,
  "41072": 1,
  "41073": 5,
  "41074": 5,
  "41075": 1,
  "41076": 2,
  "41080": 2,
  "41081": -5,
  "41083": 1,
  "41085": 1,
  "41086": 1,
  "41091": 10,
  "41092": 2,
  "41093": -5,
  "41094": 2,
  "41095": 2,
  "41096": 2,
  "41097": 1,
  "41098": -10,
  "41101": -4,
  "41102": -4,
  "41105": -4,
  "41121": -4,
  "41124": -14,
  "41128": -9,
  "41129": -4,
  "41132": -4,
  "41135": -9,
  "41139": -4,
  "41141": -6,
  "41142": -9,
  "41143": -9,
  "41144": -4,
  "41146": -9,
  "41149": -16,
  "41159": -16,
  "41160": -14,
  "41164": -9,
  "41166": -6,
  "41168": -4,
  "41169": -4,
  "41171": -16,
  "41173": -9,
  "41174": -6,
  "41175": -5,
  "41179": -6,
  "41180": -14,
  "41181": -9,
  "41183": -4,
  "41189": -5,
  "41201": -11,
  "41203": -9,
  "41204": -11,
  "41214": -9,
  "41216": -10,
  "41219": -11,
  "41222": -11,
  "41224": -8,
  "41226": -16,
  "41230": -14,
  "41231": -8,
  "41232": -11,
  "41234": -10,
  "41238": -11,
  "41240": -10,
  "41250": -8,
  "41254": -9,
  "41255": -11,
  "41256": -10,
  "41257": -10,
  "41260": -10,
  "41262": -9,
  "41263": -10,
  "41264": -11,
  "41265": -10,
  "41267": -9,
  "41268": -10,
  "41271": -11,
  "41274": -11,
  "41301": -5,
  "41307": -6,
  "41310": -9,
  "41311": -5,
  "41313": -5,
  "41314": -5,
  "41317": -8,
  "41332": -9,
  "41333": -5,
  "41338": -5,
  "41339": -6,
  "41347": -5,
  "41348": -8,
  "41351": -11,
  "41352": -9,
  "41360": -5,
  "41362": -5,
  "41364": -5,
  "41365": -4,
  "41366": -9,
  "41367": -9,
  "41368": -5,
  "41385": -6,
  "41386": -12,
  "41390": -6,
  "41397": -5,
  "41408": -9,
  "41413": -16,
  "41421": -16,
  "41425": -13,
  "41426": -11,
  "41451": -16,
  "41459": -11,
  "41464": -10,
  "41465": -11,
  "41472": -16,
  "41477": -16,
  "41501": -11,
  "41502": -11,
  "41503": -12,
  "41512": -6,
  "41513": -11,
  "41514": -4,
  "41517": -17,
  "41519": -12,
  "41520": -10,
  "41522": -11,
  "41524": -11,
  "41526": -11,
  "41527": -12,
  "41528": -11,
  "41531": -12,
  "41534": -6,
  "41535": -12,
  "41537": -17,
  "41538": -10,
  "41539": -11,
  "41540": -11,
  "41542": -6,
  "41543": -13,
  "41544": -12,
  "41547": -11,
  "41548": -11,
  "41549": -10,
  "41553": -11,
  "41554": -11,
  "41555": -13,
  "41557": -11,
  "41558": -12,
  "41559": -11,
  "41560": -10,
  "41561": -11,
  "41562": -11,
  "41563": -6,
  "41564": -12,
  "41566": -11,
  "41567": -11,
  "41568": -8,
  "41571": -12,
  "41572": -9,
  "41601": -10,
  "41602": -10,
  "41603": -1,
  "41604": -9,
  "41605": -9,
  "41606": -14,
  "41607": -8,
  "41612": -17,
  "41615": -9,
  "41616": -10,
  "41619": -9,
  "41621": -10,
  "41622": -9,
  "41630": -9,
  "41631": -9,
  "41632": -10,
  "41635": -10,
  "41636": -9,
  "41640": -9,
  "41642": -9,
  "41643": -9,
  "41645": -9,
  "41647": -9,
  "41649": -10,
  "41650": -14,
  "41651": -9,
  "41653": -9,
  "41655": -10,
  "41659": -9,
  "41660": -9,
  "41663": -9,
  "41666": -9,
  "41667": -17,
  "41669": -14,
  "41701": -9,
  "41702": -9,
  "41712": -13,
  "41713": -9,
  "41714": -9,
  "41719": -9,
  "41721": -6,
  "41722": -9,
  "41723": -9,
  "41725": -13,
  "41727": -9,
  "41729": -9,
  "41731": -9,
  "41735": -19,
  "41736": -9,
  "41739": -13,
  "41740": -14,
  "41743": -13,
  "41745": -9,
  "41746": -9,
  "41747": -13,
  "41749": -9,
  "41751": -9,
  "41754": -9,
  "41759": -14,
  "41760": -9,
  "41762": -9,
  "41763": -19,
  "41764": -9,
  "41766": -9,
  "41772": -14,
  "41773": -9,
  "41774": -9,
  "41775": -9,
  "41776": -9,
  "41777": -9,
  "41778": -9,
  "41804": -17,
  "41810": -17,
  "41812": -17,
  "41815": -17,
  "41817": -14,
  "41819": -19,
  "41821": -17,
  "41822": -13,
  "41824": -16,
  "41825": -17,
  "41826": -16,
  "41828": -14,
  "41831": -13,
  "41832": -17,
  "41833": -17,
  "41834": -14,
  "41835": -17,
  "41836": -14,
  "41837": -17,
  "41838": -17,
  "41839": -13,
  "41840": -17,
  "41843": -14,
  "41844": -14,
  "41845": -16,
  "41847": -14,
  "41848": -17,
  "41849": -17,
  "41855": -17,
  "41858": -17,
  "41859": -13,
  "41861": -14,
  "41862": -14,
  "42001": 5,
  "42002": 5,
  "42003": -3,
  "42020": -13,
  "42021": -5,
  "42022": -3,
  "42023": -5,
  "42024": -3,
  "42025": 12,
  "42027": -3,
  "42028": -8,
  "42029": 12,
  "42031": -18,
  "42032": -5,
  "42033": -19,
  "42035": -5,
  "42036": -13,
  "42037": 7,
  "42038": -8,
  "42039": -5,
  "42040": -10,
  "42041": -18,
  "42044": 20,
  "42045": -8,
  "42047": 6,
  "42048": 12,
  "42049": -13,
  "42050": -18,
  "42051": -10,
  "42053": -3,
  "42054": -1,
  "42055": -8,
  "42056": -3,
  "42058": -3,
  "42060": -3,
  "42061": -5,
  "42063": -10,
  "42064": -19,
  "42066": -10,
  "42069": -3,
  "42070": -5,
  "42071": -13,
  "42076": -13,
  "42078": -8,
  "42079": -10,
  "42081": 6,
  "42082": 12,
  "42083": 7,
  "42084": -20,
  "42085": -18,
  "42086": -3,
  "42087": -3,
  "42088": -9,
  "42101": 0,
  "42102": 2,
  "42103": 2,
  "42104": 2,
  "42120": -9,
  "42122": 2,
  "42123": -9,
  "42124": -7,
  "42127": -7,
  "42128": 2,
  "42129": -8,
  "42130": -7,
  "42131": -5,
  "42133": -9,
  "42134": -3,
  "42135": -3,
  "42140": 0,
  "42141": -5,
  "42142": -5,
  "42151": 0,
  "42152": -8,
  "42153": -9,
  "42154": -8,
  "42156": -9,
  "42157": -5,
  "42159": 2,
  "42160": -7,
  "42163": -7,
  "42164": -9,
  "42166": -7,
  "42167": 0,
  "42170": -4,
  "42171": -7,
  "42201": -12,
  "42202": -2,
  "42204": 2,
  "42206": -10,
  "42207": -8,
  "42210": -8,
  "42211": -14,
  "42214": -8,
  "42215": -15,
  "42216": 1,
  "42217": 0,
  "42219": -12,
  "42220": 1,
  "42221": 1,
  "42223": -3,
  "42232": 9,
  "42234": 2,
  "42236": 2,
  "42240": 1,
  "42241": 1,
  "42252": -8,
  "42254": 0,
  "42256": -11,
  "42259": -8,
  "42261": -12,
  "42262": -3,
  "42265": 2,
  "42266": 1,
  "42273": -12,
  "42274": 0,
  "42275": -8,
  "42276": -11,
  "42280": 1,
  "42283": -10,
  "42285": -9,
  "42286": 2,
  "42287": -12,
  "42288": -12,
  "42301": -9,
  "42302": -9,
  "42303": -9,
  "42304": -9,
  "42320": -9,
  "42321": 9,
  "42322": -12,
  "42323": 9,
  "42324": 9,
  "42325": 10,
  "42326": 9,
  "42327": -12,
  "42328": -9,
  "42330": 10,
  "42332": 9,
  "42333": -9,
  "42334": -9,
  "42337": 9,
  "42338": -9,
  "42339": 9,
  "42343": -12,
  "42344": 9,
  "42345": 9,
  "42347": -9,
  "42348": -7,
  "42349": -9,
  "42350": -12,
  "42351": -9,
  "42352": -12,
  "42354": -9,
  "42355": -9,
  "42356": -12,
  "42361": -9,
  "42364": -2,
  "42366": -7,
  "42367": 9,
  "42368": -2,
  "42369": -9,
  "42370": -2,
  "42371": -12,
  "42372": -12,
  "42374": 10,
  "42375": -9,
  "42376": -12,
  "42377": -9,
  "42378": -2,
  "42402": -2,
  "42403": -20,
  "42404": 3,
  "42406": -2,
  "42408": -18,
  "42409": 3,
  "42410": -18,
  "42411": -14,
  "42413": -9,
  "42419": 0,
  "42420": 0,
  "42431": -18,
  "42436": 3,
  "42437": -7,
  "42440": -18,
  "42441": -18,
  "42442": -18,
  "42444": 3,
  "42445": -14,
  "42450": 2,
  "42451": -3,
  "42452": 6,
  "42453": -18,
  "42455": 3,
  "42456": 3,
  "42457": -2,
  "42458": -2,
  "42459": -7,
  "42460": -20,
  "42461": -2,
  "42462": -2,
  "42463": 2,
  "42464": -18,
  "42501": -9,
  "42502": -9,
  "42503": -9,
  "42516": -9,
  "42518": -10,
  "42519": -10,
  "42528": -12,
  "42533": -9,
  "42539": -12,
  "42541": -12,
  "42544": -9,
  "42553": -9,
  "42558": -10,
  "42564": -9,
  "42565": -11,
  "42566": -12,
  "42567": -9,
  "42602": -12,
  "42603": -12,
  "42629": -8,
  "42631": -12,
  "42633": -13,
  "42634": -12,
  "42635": -12,
  "42638": -12,
  "42642": -7,
  "42647": -13,
  "42649": -12,
  "42653": -12,
  "42701": 12,
  "42702": 12,
  "42712": 0,
  "42713": -7,
  "42715": -12,
  "42716": -7,
  "42717": 17,
  "42718": -10,
  "42719": -10,
  "42720": -12,
  "42721": 0,
  "42722": -8,
  "42724": 11,
  "42726": 0,
  "42728": -12,
  "42729": -8,
  "42731": 18,
  "42732": 11,
  "42733": -11,
  "42740": 12,
  "42741": -12,
  "42742": -7,
  "42743": -8,
  "42746": -8,
  "42748": -7,
  "42749": -7,
  "42753": -12,
  "42754": 0,
  "42755": 0,
  "42757": -7,
  "42758": -10,
  "42759": 18,
  "42762": 0,
  "42764": -7,
  "42765": -8,
  "42776": -7,
  "42782": -8,
  "42784": -7,
  "42788": 11,
  "43001": 10,
  "43002": 8,
  "43003": 11,
  "43004": 9,
  "43005": 3,
  "43006": -8,
  "43007": 3,
  "43008": 1,
  "43009": -8,
  "43010": -8,
  "43011": 3,
  "43013": 2,
  "43014": 2,
  "43015": 12,
  "43016": 20,
  "43017": 17,
  "43018": -2,
  "43019": 3,
  "43021": 20,
  "43022": 3,
  "43023": 10,
  "43025": 2,
  "43026": 9,
  "43027": 3,
  "43028": 3,
  "43029": 11,
  "43030": 2,
  "43031": 3,
  "43032": 11,
  "43033": 2,
  "43035": 20,
  "43036": 4,
  "43037": 3,
  "43040": 4,
  "43044": -8,
  "43045": 3,
  "43046": -1,
  "43047": -8,
  "43048": 3,
  "43050": 3,
  "43054": 17,
  "43055": 2,
  "43056": 2,
  "43058": 2,
  "43060": 3,
  "43061": 4,
  "43062": 3,
  "43064": 4,
  "43065": 20,
  "43066": 12,
  "43067": 4,
  "43068": 9,
  "43070": -8,
  "43071": 2,
  "43072": -8,
  "43073": 9,
  "43074": 12,
  "43076": 2,
  "43077": 4,
  "43078": -8,
  "43080": 3,
  "43081": 9,
  "43082": 9,
  "43083": -8,
  "43084": 3,
  "43085": 9,
  "43086": 9,
  "43101": -10,
  "43102": 0,
  "43103": -2,
  "43105": 7,
  "43106": -1,
  "43107": 21,
  "43109": 8,
  "43110": -2,
  "43111": -11,
  "43112": 7,
  "43113": -3,
  "43115": -3,
  "43116": -4,
  "43117": -3,
  "43119": 9,
  "43123": 9,
  "43125": 9,
  "43126": -1,
  "43127": -11,
  "43128": -1,
  "43130": -2,
  "43135": -10,
  "43136": -2,
  "43137": 8,
  "43138": -10,
  "43140": -3,
  "43142": -1,
  "43143": 0,
  "43144": -8,
  "43145": 0,
  "43146": -3,
  "43147": -2,
  "43148": -2,
  "43149": -10,
  "43150": 21,
  "43151": -1,
  "43152": -10,
  "43153": -1,
  "43154": 5,
  "43155": -10,
  "43156": -3,
  "43157": -2,
  "43158": -10,
  "43160": -1,
  "43162": -1,
  "43163": 21,
  "43164": -4,
  "43194": 8,
  "43201": 8,
  "43202": 9,
  "43203": 8,
  "43204": 8,
  "43205": 8,
  "43206": 8,
  "43207": 8,
  "43209": 9,
  "43210": 9,
  "43211": 8,
  "43212": 9,
  "43213": 8,
  "43214": 9,
  "43215": 9,
  "43216": 8,
  "43217": 8,
  "43218": 9,
  "43219": 8,
  "43220": 9,
  "43221": 9,
  "43222": 8,
  "43223": 8,
  "43224": 8,
  "43226": 9,
  "43227": 8,
  "43228": 8,
  "43229": 8,
  "43230": 9,
  "43231": 9,
  "43232": 8,
  "43234": 9,
  "43235": 9,
  "43236": 8,
  "43240": 12,
  "43301": -7,
  "43302": -7,
  "43306": -7,
  "43310": -3,
  "43311": -3,
  "43314": -7,
  "43315": -9,
  "43316": 4,
  "43317": -9,
  "43318": -3,
  "43319": 3,
  "43320": -9,
  "43321": -9,
  "43322": -7,
  "43323": 2,
  "43324": -3,
  "43325": -8,
  "43326": -13,
  "43330": 2,
  "43331": -3,
  "43332": -8,
  "43333": -3,
  "43334": -9,
  "43335": -7,
  "43336": 3,
  "43337": -7,
  "43338": -9,
  "43340": -13,
  "43341": -7,
  "43342": -6,
  "43343": -3,
  "43344": -3,
  "43345": -13,
  "43346": -3,
  "43347": -3,
  "43348": -3,
  "43349": 5,
  "43350": -9,
  "43351": 3,
  "43356": -6,
  "43357": -8,
  "43358": -3,
  "43359": 2,
  "43360": -3,
  "43402": 26,
  "43406": 17,
  "43407": -1,
  "43408": -3,
  "43410": -1,
  "43412": -3,
  "43413": 17,
  "43414": 18,
  "43416": -3,
  "43420": -1,
  "43430": 15,
  "43431": -1,
  "43432": -3,
  "43433": -3,
  "43434": 6,
  "43435": 0,
  "43436": 6,
  "43437": 17,
  "43438": -6,
  "43439": -3,
  "43440": -7,
  "43441": 18,
  "43442": 0,
  "43443": 18,
  "43445": -3,
  "43446": 6,
  "43447": 6,
  "43449": -3,
  "43450": 18,
  "43451": 18,
  "43452": -3,
  "43456": 6,
  "43457": 17,
  "43458": -3,
  "43460": 6,
  "43462": 17,
  "43463": 18,
  "43464": -1,
  "43465": 6,
  "43466": 17,
  "43467": 17,
  "43468": 6,
  "43469": 18,
  "43501": -6,
  "43502": 15,
  "43504": 6,
  "43505": -5,
  "43506": -5,
  "43510": 7,
  "43511": 8,
  "43512": -6,
  "43515": 13,
  "43516": 7,
  "43517": -5,
  "43518": -5,
  "43519": -3,
  "43520": -8,
  "43521": 13,
  "43522": 18,
  "43523": 7,
  "43524": 7,
  "43525": 18,
  "43526": -8,
  "43527": 7,
  "43528": 6,
  "43529": -1,
  "43530": -6,
  "43531": -6,
  "43532": 7,
  "43533": 13,
  "43534": 7,
  "43535": 7,
  "43536": -8,
  "43537": 6,
  "43540": 13,
  "43541": 7,
  "43542": 7,
  "43543": -5,
  "43545": 7,
  "43547": 8,
  "43548": 7,
  "43549": -8,
  "43550": 7,
  "43551": 7,
  "43552": 7,
  "43553": 15,
  "43554": -5,
  "43555": 7,
  "43556": -8,
  "43557": -3,
  "43558": 13,
  "43560": 8,
  "43565": 17,
  "43566": 26,
  "43567": 15,
  "43569": 17,
  "43570": -3,
  "43571": 26,
  "43601": 6,
  "43603": 6,
  "43604": 6,
  "43605": 6,
  "43606": 6,
  "43607": 6,
  "43608": 6,
  "43609": 6,
  "43610": 6,
  "43611": 6,
  "43612": 6,
  "43613": 6,
  "43614": 6,
  "43615": 6,
  "43616": 6,
  "43617": 15,
  "43618": 6,
  "43619": 6,
  "43620": 6,
  "43623": 6,
  "43635": 6,
  "43697": 6,
  "43699": 6,
  "43701": -7,
  "43702": -7,
  "43711": -5,
  "43713": -7,
  "43716": -7,
  "43717": -5,
  "43718": -7,
  "43719": -7,
  "43720": -7,
  "43721": 2,
  "43722": -3,
  "43723": -3,
  "43724": -5,
  "43725": -3,
  "43727": -7,
  "43728": -8,
  "43730": 21,
  "43731": 21,
  "43732": -5,
  "43733": -3,
  "43734": -7,
  "43735": 20,
  "43736": -3,
  "43738": 20,
  "43739": 2,
  "43740": -7,
  "43746": -7,
  "43747": -7,
  "43748": 21,
  "43749": -3,
  "43750": -3,
  "43752": -5,
  "43754": -5,
  "43755": -3,
  "43756": -8,
  "43757": -7,
  "43758": -8,
  "43759": -7,
  "43760": 21,
  "43761": 21,
  "43762": -2,
  "43764": 21,
  "43766": 21,
  "43767": -7,
  "43768": -3,
  "43771": -7,
  "43772": -3,
  "43773": -3,
  "43777": 20,
  "43778": 5,
  "43779": -5,
  "43780": -3,
  "43782": 21,
  "43783": 21,
  "43786": -5,
  "43787": -8,
  "43788": -5,
  "43789": -5,
  "43791": 20,
  "43793": -5,
  "43802": -7,
  "43803": -5,
  "43804": -8,
  "43805": -7,
  "43811": -7,
  "43812": -7,
  "43821": -7,
  "43822": -7,
  "43824": -8,
  "43828": -7,
  "43830": -7,
  "43832": -5,
  "43836": -8,
  "43837": -5,
  "43840": -5,
  "43842": -8,
  "43843": 3,
  "43844": -7,
  "43845": -8,
  "43901": -5,
  "43902": -7,
  "43903": -8,
  "43905": -7,
  "43906": -5,
  "43907": -4,
  "43908": -9,
  "43909": -7,
  "43910": -4,
  "43912": -6,
  "43913": -5,
  "43914": -4,
  "43915": -4,
  "43916": -6,
  "43917": -6,
  "43920": -3,
  "43925": -4,
  "43926": -3,
  "43927": 2,
  "43928": -7,
  "43930": -5,
  "43931": -6,
  "43932": -3,
  "43933": -7,
  "43934": -5,
  "43935": -5,
  "43937": -7,
  "43938": -4,
  "43939": -6,
  "43940": -7,
  "43941": -5,
  "43942": 15,
  "43943": -5,
  "43944": -4,
  "43945": -5,
  "43946": -6,
  "43947": 15,
  "43948": -5,
  "43950": 2,
  "43951": -7,
  "43952": -4,
  "43953": -4,
  "43961": -3,
  "43962": -5,
  "43963": -5,
  "43964": -3,
  "43967": -7,
  "43968": -3,
  "43970": -4,
  "43971": -5,
  "43972": -7,
  "43973": -4,
  "43974": -7,
  "43976": -4,
  "43977": -4,
  "43981": -4,
  "43983": -4,
  "43984": -4,
  "43985": -4,
  "43986": -4,
  "43988": -4,
  "44001": -4,
  "44003": -7,
  "44004": -6,
  "44005": -6,
  "44010": -6,
  "44011": 5,
  "44012": -4,
  "44017": 4,
  "44021": 6,
  "44022": 6,
  "44023": 8,
  "44024": -3,
  "44026": -3,
  "44028": -4,
  "44030": -6,
  "44032": -7,
  "44033": 6,
  "44035": -4,
  "44036": -4,
  "44039": -4,
  "44040": 8,
  "44041": -7,
  "44044": -4,
  "44045": -1,
  "44046": 6,
  "44047": -6,
  "44048": -6,
  "44049": -4,
  "44050": -4,
  "44052": -4,
  "44053": -4,
  "44054": -4,
  "44055": -4,
  "44056": 6,
  "44057": -2,
  "44060": -1,
  "44061": -1,
  "44062": -3,
  "44064": -1,
  "44065": -3,
  "44067": 4,
  "44068": -6,
  "44070": -4,
  "44072": -3,
  "44074": -4,
  "44076": -7,
  "44077": -1,
  "44080": -3,
  "44081": -1,
  "44082": -6,
  "44084": -6,
  "44085": -6,
  "44086": -1,
  "44087": 0,
  "44088": -2,
  "44089": -4,
  "44090": -4,
  "44092": -1,
  "44093": -7,
  "44094": -1,
  "44095": -2,
  "44096": -1,
  "44097": -2,
  "44099": -3,
  "44101": 3,
  "44102": 3,
  "44103": 3,
  "44104": 3,
  "44105": 3,
  "44106": 3,
  "44107": 4,
  "44108": 3,
  "44109": 3,
  "44110": 3,
  "44111": 3,
  "44112": 3,
  "44113": 3,
  "44114": 3,
  "44115": 3,
  "44116": 4,
  "44117": 3,
  "44118": 4,
  "44119": 3,
  "44120": 3,
  "44121": 3,
  "44122": 4,
  "44123": 3,
  "44124": 3,
  "44125": 3,
  "44126": 4,
  "44127": 3,
  "44128": 3,
  "44129": 3,
  "44130": 4,
  "44131": 4,
  "44132": -2,
  "44133": 4,
  "44134": 4,
  "44135": 3,
  "44136": 4,
  "44137": 3,
  "44138": -4,
  "44139": 4,
  "44140": -4,
  "44141": 4,
  "44142": 4,
  "44143": 4,
  "44144": 3,
  "44145": 5,
  "44146": 3,
  "44147": 4,
  "44149": 4,
  "44181": 3,
  "44199": 3,
  "44201": 0,
  "44202": 0,
  "44203": 4,
  "44210": 12,
  "44211": 0,
  "44212": 7,
  "44214": -7,
  "44215": 6,
  "44216": 4,
  "44217": 6,
  "44221": 4,
  "44222": 4,
  "44223": 4,
  "44224": 6,
  "44230": 4,
  "44231": -2,
  "44232": 1,
  "44233": 14,
  "44234": 0,
  "44235": 7,
  "44236": 15,
  "44240": 0,
  "44241": 0,
  "44243": 0,
  "44250": 4,
  "44251": 6,
  "44253": 7,
  "44254": 6,
  "44255": 0,
  "44256": 6,
  "44258": 7,
  "44260": 6,
  "44262": 6,
  "44264": 4,
  "44265": 6,
  "44266": 0,
  "44270": 4,
  "44272": 0,
  "44273": 6,
  "44274": 6,
  "44275": 7,
  "44276": -7,
  "44278": 4,
  "44280": 7,
  "44281": 6,
  "44282": 6,
  "44285": -2,
  "44286": 12,
  "44287": -7,
  "44288": -3,
  "44301": 4,
  "44302": 4,
  "44303": 4,
  "44304": 4,
  "44305": 4,
  "44306": 4,
  "44307": 3,
  "44308": 4,
  "44309": 4,
  "44310": 4,
  "44311": 3,
  "44312": 4,
  "44313": 12,
  "44314": 4,
  "44319": 4,
  "44320": 4,
  "44321": 4,
  "44322": 4,
  "44333": 12,
  "44334": 4,
  "44372": 12,
  "44401": -1,
  "44402": -4,
  "44403": -4,
  "44404": -6,
  "44405": -2,
  "44406": 7,
  "44408": -6,
  "44410": -4,
  "44411": 0,
  "44412": -2,
  "44413": -6,
  "44415": -6,
  "44416": -1,
  "44417": -4,
  "44418": 4,
  "44420": -4,
  "44422": -6,
  "44423": -6,
  "44424": 4,
  "44425": -2,
  "44427": -5,
  "44428": -4,
  "44429": -3,
  "44430": -4,
  "44431": -6,
  "44432": -6,
  "44436": -2,
  "44437": -4,
  "44438": -4,
  "44439": -3,
  "44440": -4,
  "44441": -6,
  "44442": -2,
  "44443": -2,
  "44444": -4,
  "44445": -6,
  "44446": -4,
  "44449": -2,
  "44450": -4,
  "44451": -1,
  "44452": -2,
  "44453": -6,
  "44454": -2,
  "44455": -6,
  "44460": -6,
  "44470": -4,
  "44471": -2,
  "44473": -4,
  "44481": -4,
  "44482": -4,
  "44483": -4,
  "44484": -4,
  "44485": -4,
  "44490": -6,
  "44491": -4,
  "44492": -6,
  "44493": -6,
  "44501": -2,
  "44502": -2,
  "44503": -2,
  "44504": -2,
  "44505": -2,
  "44506": -2,
  "44507": -2,
  "44509": -2,
  "44510": -2,
  "44511": -2,
  "44512": -2,
  "44513": -2,
  "44514": -2,
  "44515": -2,
  "44601": 0,
  "44606": -7,
  "44607": -5,
  "44608": -5,
  "44609": -6,
  "44610": -7,
  "44611": -8,
  "44612": -5,
  "44613": 1,
  "44614": 2,
  "44615": -8,
  "44617": -7,
  "44618": -6,
  "44619": 3,
  "44620": -8,
  "44621": -6,
  "44622": -5,
  "44624": -5,
  "44625": -9,
  "44626": 1,
  "44627": -7,
  "44628": -8,
  "44629": -5,
  "44630": 1,
  "44631": -8,
  "44632": 2,
  "44633": -7,
  "44634": -8,
  "44636": -7,
  "44637": -8,
  "44638": -8,
  "44639": -4,
  "44640": 0,
  "44641": 1,
  "44643": -9,
  "44644": -8,
  "44645": -6,
  "44646": 2,
  "44647": 1,
  "44648": 1,
  "44650": 0,
  "44651": 0,
  "44652": 1,
  "44653": -6,
  "44654": -7,
  "44656": 0,
  "44657": -9,
  "44659": -7,
  "44660": -7,
  "44661": -8,
  "44662": 1,
  "44663": -5,
  "44665": -8,
  "44666": 2,
  "44667": -7,
  "44669": 1,
  "44670": 0,
  "44671": 0,
  "44672": -6,
  "44675": -9,
  "44676": -8,
  "44677": -6,
  "44678": -6,
  "44679": -4,
  "44680": -5,
  "44681": -5,
  "44682": -5,
  "44683": -6,
  "44685": 1,
  "44687": -7,
  "44688": -9,
  "44689": -5,
  "44690": 1,
  "44691": -6,
  "44693": -4,
  "44695": -4,
  "44697": 2,
  "44699": -4,
  "44701": 0,
  "44702": 0,
  "44703": 0,
  "44704": 0,
  "44705": 0,
  "44706": 0,
  "44707": 0,
  "44708": 1,
  "44709": 1,
  "44710": 0,
  "44711": 1,
  "44714": 0,
  "44718": 9,
  "44720": 9,
  "44721": 1,
  "44730": 1,
  "44735": 9,
  "44802": -1,
  "44804": -1,
  "44805": -2,
  "44807": -1,
  "44809": -4,
  "44811": -1,
  "44813": -3,
  "44814": -7,
  "44815": -5,
  "44816": -4,
  "44817": -1,
  "44818": -6,
  "44820": -8,
  "44822": 3,
  "44824": -7,
  "44825": -8,
  "44826": -1,
  "44827": -8,
  "44828": -1,
  "44830": -5,
  "44833": -8,
  "44836": -1,
  "44837": -1,
  "44838": -3,
  "44839": -7,
  "44840": 0,
  "44841": -5,
  "44842": -2,
  "44843": 5,
  "44844": 4,
  "44845": 2,
  "44846": -6,
  "44847": -1,
  "44848": -2,
  "44849": 2,
  "44850": -1,
  "44851": -1,
  "44853": -4,
  "44854": -8,
  "44855": -1,
  "44856": -8,
  "44857": -1,
  "44859": 7,
  "44860": 2,
  "44861": -5,
  "44862": -4,
  "44864": -2,
  "44865": -1,
  "44866": 0,
  "44867": -6,
  "44870": -7,
  "44871": -7,
  "44874": -3,
  "44875": -3,
  "44878": -3,
  "44880": -2,
  "44881": -8,
  "44882": 2,
  "44883": -5,
  "44887": -8,
  "44889": 0,
  "44890": -1,
  "44901": 5,
  "44902": -4,
  "44903": -3,
  "44904": 5,
  "44905": -4,
  "44906": -4,
  "44907": -3,
  "45001": 5,
  "45002": 5,
  "45003": -9,
  "45004": 5,
  "45005": 2,
  "45011": 5,
  "45012": 5,
  "45013": 4,
  "45014": 4,
  "45015": 4,
  "45018": 5,
  "45030": 4,
  "45032": -4,
  "45033": 5,
  "45034": 11,
  "45036": 2,
  "45039": 2,
  "45040": 4,
  "45041": 5,
  "45042": 5,
  "45044": 4,
  "45050": 2,
  "45051": 5,
  "45052": 5,
  "45053": 13,
  "45054": 2,
  "45055": 4,
  "45056": 5,
  "45061": 12,
  "45062": 4,
  "45063": 13,
  "45064": 5,
  "45065": 2,
  "45066": 11,
  "45067": 5,
  "45068": 2,
  "45069": 13,
  "45070": 4,
  "45071": 13,
  "45101": -6,
  "45102": -2,
  "45103": -2,
  "45105": 1,
  "45106": -2,
  "45107": -4,
  "45110": -5,
  "45111": 5,
  "45112": -6,
  "45113": -3,
  "45114": -4,
  "45115": -6,
  "45118": -2,
  "45119": -6,
  "45120": -6,
  "45121": -6,
  "45122": -2,
  "45123": -6,
  "45130": -6,
  "45131": -6,
  "45132": -5,
  "45133": -5,
  "45135": -5,
  "45138": 0,
  "45140": 3,
  "45142": -5,
  "45144": 1,
  "45145": -2,
  "45146": -4,
  "45147": 5,
  "45148": -4,
  "45150": -2,
  "45152": 2,
  "45153": -2,
  "45154": -6,
  "45155": -6,
  "45156": -2,
  "45157": -2,
  "45158": -2,
  "45159": -3,
  "45160": -2,
  "45162": 2,
  "45164": -3,
  "45166": 0,
  "45167": -6,
  "45168": -6,
  "45169": 0,
  "45171": -6,
  "45172": -6,
  "45174": 6,
  "45176": -2,
  "45177": -3,
  "45201": 13,
  "45202": 13,
  "45203": 5,
  "45204": 5,
  "45205": 5,
  "45206": 5,
  "45207": 5,
  "45208": 13,
  "45209": 5,
  "45211": 5,
  "45212": 5,
  "45213": 5,
  "45214": 5,
  "45215": 5,
  "45216": 5,
  "45217": 5,
  "45218": 5,
  "45219": 5,
  "45220": 6,
  "45222": 5,
  "45223": 5,
  "45224": 5,
  "45225": 5,
  "45226": 13,
  "45227": 5,
  "45228": 5,
  "45229": 5,
  "45230": 5,
  "45231": 5,
  "45232": 5,
  "45233": 6,
  "45234": 6,
  "45235": 6,
  "45236": 5,
  "45237": 5,
  "45238": 5,
  "45239": 5,
  "45240": 4,
  "45241": 6,
  "45242": 13,
  "45243": 13,
  "45244": -2,
  "45245": -2,
  "45246": 4,
  "45247": 5,
  "45248": 5,
  "45249": 13,
  "45250": 5,
  "45251": 5,
  "45252": 12,
  "45253": 5,
  "45254": 13,
  "45255": -2,
  "45258": 5,
  "45262": 5,
  "45275": 5,
  "45280": 5,
  "45301": 0,
  "45302": 0,
  "45303": -9,
  "45304": -9,
  "45305": 0,
  "45306": -6,
  "45307": -3,
  "45308": -9,
  "45309": 2,
  "45310": -6,
  "45311": -9,
  "45312": 5,
  "45314": 7,
  "45315": 2,
  "45316": -7,
  "45317": -8,
  "45318": -3,
  "45319": -5,
  "45320": -9,
  "45321": -10,
  "45322": 2,
  "45323": -5,
  "45324": 0,
  "45325": 3,
  "45326": -3,
  "45327": 3,
  "45328": -9,
  "45330": -9,
  "45331": -9,
  "45332": -9,
  "45333": -1,
  "45334": -2,
  "45335": 0,
  "45336": -6,
  "45337": -3,
  "45338": -9,
  "45339": -3,
  "45340": 0,
  "45341": -5,
  "45342": 2,
  "45343": 2,
  "45344": -5,
  "45345": 2,
  "45346": -9,
  "45347": -10,
  "45348": -6,
  "45349": -7,
  "45350": -6,
  "45351": -6,
  "45352": -9,
  "45353": -2,
  "45354": -4,
  "45356": -2,
  "45358": -9,
  "45359": -3,
  "45360": -2,
  "45361": -3,
  "45362": -9,
  "45363": -1,
  "45365": -1,
  "45368": -6,
  "45369": -6,
  "45370": 11,
  "45371": -2,
  "45372": -6,
  "45373": -2,
  "45377": 2,
  "45378": -10,
  "45380": -8,
  "45381": -9,
  "45382": -10,
  "45383": -3,
  "45384": 9,
  "45385": 0,
  "45387": 9,
  "45388": 7,
  "45389": -4,
  "45390": -9,
  "45400": 2,
  "45401": 2,
  "45402": 2,
  "45403": 2,
  "45404": 2,
  "45405": 2,
  "45406": 2,
  "45408": 2,
  "45409": 2,
  "45410": 2,
  "45413": 2,
  "45414": 2,
  "45415": 2,
  "45416": 2,
  "45417": 2,
  "45418": 2,
  "45419": 2,
  "45420": 2,
  "45422": 2,
  "45423": 2,
  "45424": 3,
  "45426": 2,
  "45427": 2,
  "45428": 2,
  "45429": 2,
  "45430": -1,
  "45431": 2,
  "45432": 2,
  "45433": 0,
  "45434": 2,
  "45435": 2,
  "45437": 2,
  "45439": 2,
  "45440": 2,
  "45441": 11,
  "45449": 2,
  "45458": 11,
  "45459": 11,
  "45469": 2,
  "45475": 11,
  "45479": 2,
  "45490": 2,
  "45501": -6,
  "45502": -6,
  "45503": -7,
  "45504": -6,
  "45505": -7,
  "45506": -7,
  "45601": -3,
  "45612": -3,
  "45613": -2,
  "45614": -10,
  "45616": -7,
  "45617": -3,
  "45618": -7,
  "45619": -5,
  "45620": -13,
  "45621": 4,
  "45622": -10,
  "45623": -10,
  "45624": -5,
  "45628": -3,
  "45629": -6,
  "45630": -6,
  "45631": -10,
  "45633": -10,
  "45634": -10,
  "45636": -6,
  "45638": -4,
  "45640": 5,
  "45642": -2,
  "45643": -10,
  "45644": -3,
  "45645": -4,
  "45646": -2,
  "45647": -3,
  "45648": -6,
  "45650": -7,
  "45651": -10,
  "45652": -6,
  "45653": -4,
  "45654": -10,
  "45656": 3,
  "45657": -7,
  "45658": -10,
  "45659": -4,
  "45660": -7,
  "45661": -2,
  "45662": -6,
  "45663": -6,
  "45669": 4,
  "45671": -2,
  "45672": -10,
  "45673": -4,
  "45674": -2,
  "45675": -4,
  "45677": -6,
  "45678": -4,
  "45679": -6,
  "45680": -4,
  "45681": -3,
  "45682": -6,
  "45683": -2,
  "45684": -7,
  "45685": -2,
  "45686": -11,
  "45687": -6,
  "45688": -4,
  "45690": 0,
  "45692": 4,
  "45693": -7,
  "45694": -4,
  "45695": -10,
  "45696": -4,
  "45697": -6,
  "45698": -10,
  "45701": -1,
  "45710": -1,
  "45711": -9,
  "45712": 4,
  "45713": -9,
  "45714": -8,
  "45715": -8,
  "45716": -8,
  "45717": -8,
  "45719": -10,
  "45720": -14,
  "45721": -8,
  "45723": -13,
  "45724": -9,
  "45727": -5,
  "45729": 4,
  "45732": -8,
  "45734": -5,
  "45735": -9,
  "45739": -13,
  "45740": -10,
  "45741": -14,
  "45742": -8,
  "45743": -14,
  "45744": -4,
  "45745": -3,
  "45746": -5,
  "45750": -2,
  "45760": -14,
  "45761": -10,
  "45764": -8,
  "45766": -8,
  "45767": -4,
  "45768": -4,
  "45769": -14,
  "45770": -9,
  "45771": -14,
  "45772": -14,
  "45773": -2,
  "45775": -14,
  "45776": -13,
  "45777": -9,
  "45778": -9,
  "45779": -14,
  "45780": -1,
  "45782": -10,
  "45783": -14,
  "45784": 4,
  "45786": -4,
  "45787": 5,
  "45788": -4,
  "45789": -4,
  "45801": -5,
  "45802": -5,
  "45804": -5,
  "45805": -5,
  "45806": -5,
  "45807": -5,
  "45808": -5,
  "45809": -5,
  "45810": -13,
  "45812": -13,
  "45813": -10,
  "45814": -4,
  "45815": -5,
  "45816": -4,
  "45817": -4,
  "45819": -6,
  "45820": -5,
  "45821": -10,
  "45822": -6,
  "45826": 3,
  "45827": -8,
  "45828": -6,
  "45830": -8,
  "45831": -8,
  "45832": -10,
  "45833": -11,
  "45835": -13,
  "45836": -13,
  "45837": -9,
  "45838": -11,
  "45839": -1,
  "45840": -1,
  "45841": -4,
  "45843": -13,
  "45844": -8,
  "45845": 7,
  "45846": 3,
  "45848": -8,
  "45849": -11,
  "45850": -5,
  "45851": -10,
  "45853": -8,
  "45854": -5,
  "45855": -11,
  "45856": -5,
  "45858": -1,
  "45859": -13,
  "45860": 3,
  "45861": -11,
  "45862": -6,
  "45863": -11,
  "45864": 7,
  "45865": 7,
  "45866": -6,
  "45867": -4,
  "45868": -4,
  "45869": -4,
  "45870": -3,
  "45871": -6,
  "45872": -1,
  "45873": -11,
  "45874": -11,
  "45875": -8,
  "45876": -8,
  "45877": -8,
  "45879": -10,
  "45880": -10,
  "45881": -4,
  "45882": -6,
  "45883": -4,
  "45884": -6,
  "45885": -6,
  "45886": -11,
  "45887": -6,
  "45888": -6,
  "45889": 7,
  "45890": -1,
  "45891": -11,
  "45893": -5,
  "45894": -11,
  "45895": -6,
  "45896": -5,
  "45897": -13,
  "45898": -9,
  "45899": -9,
  "46001": -3,
  "46011": -3,
  "46012": -3,
  "46013": -3,
  "46014": -3,
  "46015": -3,
  "46016": -3,
  "46017": -3,
  "46018": -3,
  "46030": -5,
  "46031": -5,
  "46032": 16,
  "46033": 16,
  "46034": 7,
  "46035": -5,
  "46036": -6,
  "46037": 8,
  "46038": 8,
  "46039": -5,
  "46040": -4,
  "46041": -4,
  "46044": -3,
  "46045": 4,
  "46047": -5,
  "46048": -4,
  "46049": -5,
  "46050": -5,
  "46051": -3,
  "46052": 3,
  "46055": -2,
  "46056": -10,
  "46057": -5,
  "46058": -4,
  "46060": 15,
  "46061": 15,
  "46062": 15,
  "46063": -3,
  "46064": 5,
  "46065": 0,
  "46067": -1,
  "46068": -5,
  "46069": 8,
  "46070": -9,
  "46071": 3,
  "46072": -5,
  "46074": 8,
  "46075": 4,
  "46076": -5,
  "46077": 12,
  "46082": 16,
  "46102": 3,
  "46103": 4,
  "46104": -2,
  "46105": -5,
  "46106": 1,
  "46107": 9,
  "46110": -3,
  "46111": -1,
  "46112": 5,
  "46113": -1,
  "46115": -3,
  "46117": -4,
  "46118": 4,
  "46120": -4,
  "46121": -5,
  "46122": 5,
  "46123": 5,
  "46124": -4,
  "46125": 1,
  "46126": -4,
  "46127": -3,
  "46128": -5,
  "46129": -2,
  "46130": -2,
  "46131": 1,
  "46133": -19,
  "46135": 2,
  "46140": -2,
  "46142": 1,
  "46143": 1,
  "46144": -2,
  "46146": -2,
  "46147": 3,
  "46148": -10,
  "46149": 4,
  "46150": -2,
  "46151": 2,
  "46154": -2,
  "46155": -4,
  "46156": -2,
  "46157": -1,
  "46158": -1,
  "46160": -9,
  "46161": -4,
  "46162": 1,
  "46163": -2,
  "46164": -9,
  "46165": 4,
  "46166": 1,
  "46167": 5,
  "46168": 5,
  "46170": 2,
  "46171": -5,
  "46172": -5,
  "46173": -4,
  "46175": -11,
  "46176": -4,
  "46180": -5,
  "46181": 10,
  "46182": -4,
  "46183": -1,
  "46184": 1,
  "46186": 4,
  "46201": 9,
  "46202": 9,
  "46203": 9,
  "46204": 10,
  "46205": 9,
  "46206": 9,
  "46207": 9,
  "46208": 9,
  "46214": 9,
  "46216": 10,
  "46217": 9,
  "46218": 9,
  "46219": 9,
  "46220": 10,
  "46221": 9,
  "46222": 9,
  "46224": 9,
  "46225": 9,
  "46226": 9,
  "46227": 9,
  "46228": 10,
  "46229": 9,
  "46230": 10,
  "46231": 4,
  "46234": 4,
  "46235": 10,
  "46236": -2,
  "46237": 9,
  "46239": 10,
  "46240": 10,
  "46241": 9,
  "46242": 9,
  "46244": 10,
  "46247": 9,
  "46250": 8,
  "46251": 9,
  "46253": 9,
  "46254": 9,
  "46256": 8,
  "46259": 1,
  "46260": 10,
  "46268": 10,
  "46278": 10,
  "46280": 8,
  "46282": 10,
  "46290": 19,
  "46301": 6,
  "46302": 3,
  "46303": 4,
  "46304": 3,
  "46307": 4,
  "46308": 4,
  "46310": -1,
  "46311": 5,
  "46312": 5,
  "46319": 4,
  "46320": 5,
  "46321": 5,
  "46322": 5,
  "46323": 5,
  "46324": 5,
  "46325": 5,
  "46327": 5,
  "46340": -10,
  "46341": 3,
  "46342": 4,
  "46345": -2,
  "46346": -2,
  "46347": 3,
  "46348": -10,
  "46349": -8,
  "46350": -2,
  "46352": -2,
  "46355": 3,
  "46356": 4,
  "46360": -2,
  "46361": -2,
  "46365": -2,
  "46366": -10,
  "46368": 3,
  "46371": -2,
  "46372": 0,
  "46373": 6,
  "46374": -10,
  "46375": 4,
  "46376": -8,
  "46377": -1,
  "46379": -8,
  "46380": -10,
  "46381": 0,
  "46382": -2,
  "46383": 3,
  "46384": 3,
  "46385": 3,
  "46390": 3,
  "46391": -2,
  "46392": -1,
  "46393": 3,
  "46394": 5,
  "46401": 4,
  "46402": 4,
  "46403": 4,
  "46404": 4,
  "46405": 4,
  "46406": 4,
  "46407": 4,
  "46408": 4,
  "46409": 4,
  "46410": 4,
  "46411": 4,
  "46501": -9,
  "46502": -8,
  "46504": -7,
  "46506": -8,
  "46507": -2,
  "46508": -7,
  "46510": -7,
  "46511": -9,
  "46513": -9,
  "46514": -2,
  "46515": -2,
  "46516": -2,
  "46517": -2,
  "46524": -7,
  "46526": -1,
  "46527": -1,
  "46528": -1,
  "46530": 7,
  "46531": -10,
  "46532": -10,
  "46534": -10,
  "46536": -1,
  "46537": -9,
  "46538": -6,
  "46539": -7,
  "46540": 8,
  "46542": -7,
  "46543": 1,
  "46544": -2,
  "46545": -2,
  "46546": -2,
  "46550": -1,
  "46552": -1,
  "46553": -1,
  "46554": -1,
  "46555": -7,
  "46556": -2,
  "46561": -1,
  "46562": -7,
  "46563": -9,
  "46565": 3,
  "46567": -6,
  "46570": -7,
  "46571": -4,
  "46572": -9,
  "46573": -2,
  "46574": -9,
  "46580": -7,
  "46581": -7,
  "46582": -7,
  "46590": -7,
  "46595": -2,
  "46601": -2,
  "46613": -2,
  "46614": -1,
  "46615": -2,
  "46616": -2,
  "46617": -2,
  "46619": -2,
  "46624": -2,
  "46628": -2,
  "46634": -2,
  "46635": -1,
  "46637": -1,
  "46660": -1,
  "46680": -1,
  "46701": -5,
  "46702": -7,
  "46703": -8,
  "46704": 14,
  "46705": -8,
  "46706": -8,
  "46710": -5,
  "46711": -8,
  "46713": -7,
  "46714": 0,
  "46721": -8,
  "46723": -4,
  "46725": -4,
  "46730": -8,
  "46731": 1,
  "46732": -4,
  "46733": -8,
  "46737": -8,
  "46738": -8,
  "46740": -8,
  "46741": 5,
  "46742": -8,
  "46743": -8,
  "46745": 5,
  "46746": -6,
  "46747": -8,
  "46748": 5,
  "46750": -7,
  "46755": -5,
  "46759": -1,
  "46760": -4,
  "46761": -6,
  "46763": -8,
  "46764": -4,
  "46765": 14,
  "46766": 0,
  "46767": -4,
  "46769": -8,
  "46770": -7,
  "46771": -6,
  "46772": -8,
  "46773": 5,
  "46774": 5,
  "46776": -7,
  "46777": 0,
  "46778": -1,
  "46779": -8,
  "46780": -8,
  "46781": 0,
  "46782": -8,
  "46783": -7,
  "46784": -4,
  "46785": -8,
  "46786": -5,
  "46787": -4,
  "46788": 0,
  "46789": -8,
  "46791": 0,
  "46792": -7,
  "46793": -8,
  "46794": -4,
  "46795": -5,
  "46796": -5,
  "46797": 5,
  "46798": 5,
  "46799": -7,
  "46801": 5,
  "46802": 5,
  "46803": 5,
  "46804": 6,
  "46805": 5,
  "46806": 5,
  "46807": 5,
  "46808": 5,
  "46809": 5,
  "46814": 5,
  "46815": 5,
  "46816": 5,
  "46818": 5,
  "46819": 5,
  "46825": 5,
  "46835": 5,
  "46845": 14,
  "46850": 5,
  "46851": 5,
  "46852": 5,
  "46853": 5,
  "46854": 5,
  "46855": 5,
  "46856": 5,
  "46857": 5,
  "46858": 5,
  "46859": 5,
  "46860": 5,
  "46861": 5,
  "46862": 5,
  "46863": 5,
  "46864": 5,
  "46865": 5,
  "46866": 5,
  "46867": 5,
  "46868": 5,
  "46869": 5,
  "46885": 5,
  "46895": 5,
  "46896": 5,
  "46898": -4,
  "46899": 5,
  "46901": 6,
  "46902": 6,
  "46903": 6,
  "46904": 2,
  "46910": -9,
  "46911": 2,
  "46912": -9,
  "46913": 1,
  "46914": 2,
  "46915": -1,
  "46916": -1,
  "46917": -1,
  "46919": -8,
  "46920": -1,
  "46921": 2,
  "46922": -10,
  "46923": 0,
  "46926": 2,
  "46928": -9,
  "46929": -1,
  "46930": -10,
  "46931": -10,
  "46932": 6,
  "46933": -9,
  "46935": -9,
  "46936": 14,
  "46937": -5,
  "46938": -9,
  "46939": -9,
  "46940": -8,
  "46941": -8,
  "46942": -11,
  "46943": -8,
  "46945": -10,
  "46946": -8,
  "46947": 2,
  "46950": 2,
  "46951": -9,
  "46952": -8,
  "46953": -8,
  "46957": 1,
  "46958": 2,
  "46959": 5,
  "46960": -10,
  "46961": 2,
  "46962": -8,
  "46965": 6,
  "46967": 2,
  "46968": -10,
  "46970": 2,
  "46971": 2,
  "46974": -7,
  "46975": -9,
  "46977": 0,
  "46978": 2,
  "46979": 7,
  "46980": -8,
  "46982": -7,
  "46984": -8,
  "46985": -14,
  "46986": -8,
  "46987": -8,
  "46988": 2,
  "46989": 2,
  "46990": -8,
  "46991": -9,
  "46992": -7,
  "46994": 2,
  "46995": 7,
  "46996": -14,
  "46998": 2,
  "47001": -10,
  "47003": -11,
  "47006": -8,
  "47010": -11,
  "47011": -10,
  "47012": -7,
  "47016": -7,
  "47017": -10,
  "47018": -10,
  "47019": -1,
  "47020": -10,
  "47021": -8,
  "47022": -5,
  "47023": -8,
  "47024": -7,
  "47025": 5,
  "47030": -7,
  "47031": -8,
  "47032": -8,
  "47033": -8,
  "47034": -8,
  "47035": -7,
  "47036": -7,
  "47037": -8,
  "47038": -10,
  "47039": -8,
  "47040": -10,
  "47041": -8,
  "47042": -8,
  "47043": -10,
  "47060": -7,
  "47102": -12,
  "47104": -11,
  "47106": -2,
  "47107": -11,
  "47108": -11,
  "47110": -12,
  "47111": -5,
  "47112": -12,
  "47114": -12,
  "47115": -16,
  "47116": -16,
  "47117": -12,
  "47118": -16,
  "47119": 6,
  "47120": -11,
  "47122": 6,
  "47123": -16,
  "47124": 6,
  "47125": -16,
  "47126": -12,
  "47129": -2,
  "47130": -5,
  "47131": -5,
  "47135": -2,
  "47136": -10,
  "47137": -16,
  "47138": -12,
  "47139": -12,
  "47140": -16,
  "47141": -4,
  "47142": -12,
  "47143": -4,
  "47145": -16,
  "47146": 6,
  "47147": -11,
  "47150": -2,
  "47151": -2,
  "47160": -12,
  "47161": -12,
  "47162": -11,
  "47163": -4,
  "47164": -11,
  "47165": 6,
  "47166": -12,
  "47167": -11,
  "47170": -12,
  "47172": -4,
  "47174": -16,
  "47175": -16,
  "47177": -12,
  "47201": -3,
  "47202": -3,
  "47203": -1,
  "47220": -5,
  "47223": -5,
  "47224": -10,
  "47225": -7,
  "47226": -3,
  "47227": -5,
  "47228": -5,
  "47229": -12,
  "47230": -12,
  "47231": -11,
  "47232": -3,
  "47234": -11,
  "47235": -5,
  "47236": -3,
  "47240": -11,
  "47243": -11,
  "47244": -4,
  "47245": -4,
  "47246": -4,
  "47247": -3,
  "47249": -5,
  "47250": -11,
  "47260": -5,
  "47261": -11,
  "47263": -12,
  "47264": -5,
  "47265": -4,
  "47270": -12,
  "47272": -11,
  "47273": -4,
  "47274": -5,
  "47280": -3,
  "47281": -5,
  "47282": -5,
  "47283": -10,
  "47302": -6,
  "47303": -6,
  "47304": -6,
  "47305": -6,
  "47307": -6,
  "47308": -6,
  "47320": -6,
  "47322": -3,
  "47324": -9,
  "47325": -18,
  "47326": -11,
  "47327": -10,
  "47330": -10,
  "47331": -18,
  "47334": -3,
  "47335": -10,
  "47336": 2,
  "47337": -10,
  "47338": 2,
  "47339": -10,
  "47340": -1,
  "47341": -10,
  "47342": -6,
  "47344": -10,
  "47345": -10,
  "47346": -10,
  "47348": 2,
  "47351": -10,
  "47352": -10,
  "47353": -11,
  "47354": -10,
  "47355": -1,
  "47356": -10,
  "47357": -19,
  "47358": -10,
  "47359": 2,
  "47360": -10,
  "47361": -10,
  "47362": -10,
  "47366": -10,
  "47367": -2,
  "47368": -6,
  "47369": -12,
  "47370": -10,
  "47371": -11,
  "47373": -11,
  "47374": -9,
  "47375": -9,
  "47380": -2,
  "47381": -12,
  "47382": -2,
  "47383": -6,
  "47384": -10,
  "47385": -10,
  "47386": -2,
  "47387": -10,
  "47388": -10,
  "47390": -1,
  "47392": -10,
  "47393": -10,
  "47394": -1,
  "47396": 3,
  "47401": 7,
  "47402": 7,
  "47403": -2,
  "47404": -2,
  "47405": 7,
  "47406": 7,
  "47407": 7,
  "47408": 7,
  "47420": -5,
  "47421": -5,
  "47424": -8,
  "47426": 7,
  "47427": -10,
  "47429": -2,
  "47430": -5,
  "47431": -10,
  "47432": 6,
  "47433": -10,
  "47434": -5,
  "47435": -9,
  "47436": -5,
  "47437": -6,
  "47438": -13,
  "47439": -8,
  "47441": -10,
  "47443": -8,
  "47445": -10,
  "47446": -5,
  "47448": -2,
  "47449": -8,
  "47451": -5,
  "47452": 6,
  "47453": -12,
  "47454": 5,
  "47455": -10,
  "47456": -10,
  "47457": -8,
  "47458": 7,
  "47459": -2,
  "47460": -10,
  "47462": -5,
  "47463": -2,
  "47464": -10,
  "47465": -8,
  "47467": -5,
  "47468": -9,
  "47469": 6,
  "47470": -6,
  "47471": -8,
  "47501": -6,
  "47512": -3,
  "47513": -7,
  "47514": -1,
  "47515": -1,
  "47516": -3,
  "47519": -12,
  "47520": -1,
  "47521": 2,
  "47522": -13,
  "47523": -9,
  "47524": -7,
  "47525": -1,
  "47527": -5,
  "47528": -9,
  "47529": -6,
  "47531": -1,
  "47532": -5,
  "47535": -3,
  "47536": -2,
  "47537": -5,
  "47541": -7,
  "47542": -7,
  "47545": -7,
  "47546": 1,
  "47547": 1,
  "47550": -1,
  "47551": -1,
  "47552": -9,
  "47553": -13,
  "47556": -2,
  "47557": -2,
  "47558": -6,
  "47561": -3,
  "47562": -12,
  "47564": -8,
  "47567": -8,
  "47568": -6,
  "47573": -3,
  "47574": -2,
  "47575": 2,
  "47576": -16,
  "47577": -5,
  "47578": -8,
  "47579": -1,
  "47580": -7,
  "47581": -13,
  "47584": -8,
  "47585": -9,
  "47586": -1,
  "47588": -1,
  "47590": -8,
  "47591": -2,
  "47596": -6,
  "47597": -2,
  "47598": -8,
  "47601": -1,
  "47610": -1,
  "47611": -9,
  "47612": -7,
  "47613": -1,
  "47614": -10,
  "47615": -9,
  "47616": -7,
  "47617": -1,
  "47618": 6,
  "47619": -1,
  "47620": 1,
  "47629": 7,
  "47630": 7,
  "47631": -7,
  "47633": -7,
  "47634": -1,
  "47635": -9,
  "47637": -10,
  "47638": 1,
  "47639": 2,
  "47640": -7,
  "47647": -7,
  "47648": -7,
  "47649": -7,
  "47654": -7,
  "47660": -8,
  "47665": -7,
  "47666": -7,
  "47670": -7,
  "47683": -7,
  "47701": 6,
  "47702": -3,
  "47703": -3,
  "47704": -3,
  "47705": -3,
  "47706": -3,
  "47708": 6,
  "47710": -3,
  "47711": -3,
  "47712": -3,
  "47713": -3,
  "47714": -3,
  "47715": 6,
  "47716": 6,
  "47719": -3,
  "47720": -1,
  "47724": -3,
  "47725": -3,
  "47728": -3,
  "47730": 6,
  "47731": 6,
  "47732": 6,
  "47733": 6,
  "47734": 6,
  "47735": 6,
  "47736": -3,
  "47737": 6,
  "47801": 5,
  "47802": 6,
  "47803": 6,
  "47804": 6,
  "47805": 6,
  "47807": 5,
  "47808": 6,
  "47830": 3,
  "47831": 2,
  "47832": -11,
  "47833": -14,
  "47834": -14,
  "47836": -11,
  "47837": -14,
  "47838": -13,
  "47840": -12,
  "47841": -14,
  "47842": 2,
  "47845": -13,
  "47846": -12,
  "47847": 2,
  "47848": -13,
  "47849": -11,
  "47850": -13,
  "47851": 6,
  "47852": -13,
  "47853": -14,
  "47854": 2,
  "47855": -13,
  "47857": -14,
  "47858": -4,
  "47859": -11,
  "47860": 3,
  "47861": -13,
  "47862": 2,
  "47863": 6,
  "47865": -13,
  "47866": -13,
  "47868": -12,
  "47869": 6,
  "47870": 6,
  "47871": 6,
  "47872": 2,
  "47874": -11,
  "47875": 2,
  "47876": 6,
  "47878": -14,
  "47879": -13,
  "47880": 6,
  "47881": -14,
  "47882": -13,
  "47884": 2,
  "47885": 5,
  "47901": 1,
  "47902": 0,
  "47903": 0,
  "47904": 0,
  "47905": 1,
  "47906": 9,
  "47907": 1,
  "47909": 1,
  "47916": -5,
  "47917": -11,
  "47918": -7,
  "47920": 9,
  "47921": -11,
  "47922": -8,
  "47923": -11,
  "47924": 0,
  "47925": -11,
  "47926": -11,
  "47928": 2,
  "47929": -11,
  "47930": -4,
  "47932": -11,
  "47933": -4,
  "47940": -4,
  "47941": 1,
  "47942": -11,
  "47943": 9,
  "47944": -11,
  "47946": -14,
  "47948": -11,
  "47949": -11,
  "47950": -11,
  "47951": -8,
  "47952": -12,
  "47954": -4,
  "47955": -4,
  "47957": -15,
  "47958": -11,
  "47959": -11,
  "47960": -11,
  "47962": -11,
  "47963": -8,
  "47964": -8,
  "47965": -5,
  "47966": 1,
  "47967": -4,
  "47968": -4,
  "47969": -11,
  "47970": -11,
  "47971": -11,
  "47974": -10,
  "47975": -11,
  "47977": -11,
  "47978": 0,
  "47980": -11,
  "47981": 9,
  "47982": -4,
  "47983": 0,
  "47984": -11,
  "47986": -11,
  "47987": -11,
  "47988": -5,
  "47989": -11,
  "47990": -5,
  "47991": -7,
  "47992": 1,
  "47993": -7,
  "47994": -11,
  "47995": -11,
  "47996": 9,
  "47997": -11,
  "48001": -1,
  "48002": 7,
  "48003": -3,
  "48004": -2,
  "48005": -3,
  "48006": -1,
  "48007": 13,
  "48009": 17,
  "48012": 17,
  "48014": -2,
  "48015": 3,
  "48017": 13,
  "48021": 3,
  "48022": -1,
  "48023": -2,
  "48025": 15,
  "48026": 3,
  "48027": -1,
  "48028": 4,
  "48030": 7,
  "48032": -1,
  "48033": 13,
  "48034": 13,
  "48035": 3,
  "48036": 3,
  "48037": 13,
  "48038": 4,
  "48039": -1,
  "48040": -1,
  "48041": -1,
  "48042": 4,
  "48043": 3,
  "48044": 4,
  "48045": 4,
  "48046": 3,
  "48047": 4,
  "48048": 4,
  "48049": -1,
  "48050": 4,
  "48051": 4,
  "48054": 7,
  "48059": -1,
  "48060": -1,
  "48061": -1,
  "48062": -1,
  "48063": -1,
  "48064": -1,
  "48065": 4,
  "48066": 3,
  "48067": 7,
  "48068": 7,
  "48069": 15,
  "48070": 21,
  "48071": 3,
  "48072": 13,
  "48073": 13,
  "48074": -1,
  "48075": 7,
  "48076": 13,
  "48079": -1,
  "48080": 3,
  "48081": 3,
  "48082": 3,
  "48083": 4,
  "48084": 13,
  "48085": 13,
  "48086": 13,
  "48088": 3,
  "48089": 3,
  "48090": 3,
  "48091": 3,
  "48092": 3,
  "48093": 3,
  "48094": 4,
  "48095": 4,
  "48096": 4,
  "48097": -9,
  "48098": 13,
  "48099": 4,
  "48101": 9,
  "48103": 3,
  "48104": 3,
  "48105": 11,
  "48106": 3,
  "48107": 3,
  "48108": 3,
  "48109": 11,
  "48110": 3,
  "48111": 3,
  "48112": 3,
  "48113": 3,
  "48114": 2,
  "48115": 3,
  "48116": 2,
  "48117": 5,
  "48118": 3,
  "48120": 9,
  "48121": 9,
  "48122": 9,
  "48123": 9,
  "48124": 9,
  "48125": 9,
  "48126": 9,
  "48127": 9,
  "48128": 9,
  "48130": 5,
  "48131": 3,
  "48133": 3,
  "48134": 5,
  "48135": 9,
  "48136": 9,
  "48137": 1,
  "48138": 18,
  "48139": 1,
  "48140": 5,
  "48141": 9,
  "48143": 2,
  "48144": 7,
  "48145": 4,
  "48146": 9,
  "48150": 9,
  "48151": 10,
  "48152": 10,
  "48153": 9,
  "48154": 10,
  "48157": 3,
  "48158": 3,
  "48159": 6,
  "48160": 3,
  "48161": 3,
  "48162": 5,
  "48164": 6,
  "48165": 1,
  "48166": 5,
  "48167": 24,
  "48168": 24,
  "48169": 2,
  "48170": 11,
  "48173": 5,
  "48174": 9,
  "48175": 24,
  "48176": 3,
  "48177": 7,
  "48178": 2,
  "48179": 5,
  "48180": 9,
  "48182": 7,
  "48183": 9,
  "48184": 9,
  "48185": 9,
  "48186": 9,
  "48187": 10,
  "48188": 10,
  "48189": 1,
  "48190": 3,
  "48191": 3,
  "48192": 9,
  "48193": 9,
  "48195": 9,
  "48197": 3,
  "48198": 3,
  "48201": 7,
  "48202": 7,
  "48203": 7,
  "48204": 7,
  "48205": 3,
  "48206": 7,
  "48207": 7,
  "48208": 7,
  "48209": 9,
  "48210": 7,
  "48211": 7,
  "48212": 7,
  "48213": 7,
  "48214": 7,
  "48215": 7,
  "48216": 7,
  "48217": 9,
  "48218": 7,
  "48219": 9,
  "48220": 7,
  "48221": 7,
  "48223": 9,
  "48224": 3,
  "48225": 3,
  "48226": 7,
  "48227": 7,
  "48228": 9,
  "48229": 9,
  "48230": 12,
  "48231": 7,
  "48232": 7,
  "48233": 7,
  "48234": 7,
  "48235": 7,
  "48236": 12,
  "48237": 7,
  "48238": 7,
  "48239": 9,
  "48240": 9,
  "48242": 9,
  "48243": 7,
  "48244": 7,
  "48301": 24,
  "48302": 24,
  "48303": 24,
  "48304": 24,
  "48306": 24,
  "48307": 4,
  "48308": 4,
  "48309": 13,
  "48310": 4,
  "48311": 4,
  "48312": 4,
  "48313": 4,
  "48314": 4,
  "48315": 4,
  "48316": 4,
  "48317": 4,
  "48318": 4,
  "48320": 13,
  "48321": 13,
  "48322": 13,
  "48323": 15,
  "48324": 13,
  "48325": 13,
  "48326": 13,
  "48327": 13,
  "48328": 13,
  "48329": 13,
  "48330": 13,
  "48331": 13,
  "48332": 13,
  "48333": 13,
  "48334": 13,
  "48335": 13,
  "48336": 16,
  "48340": 13,
  "48341": 13,
  "48342": 13,
  "48343": 13,
  "48346": 13,
  "48347": 13,
  "48348": 13,
  "48350": 13,
  "48353": -2,
  "48356": 13,
  "48357": -2,
  "48359": 13,
  "48360": 13,
  "48361": 13,
  "48362": 13,
  "48363": 13,
  "48366": -3,
  "48367": -3,
  "48370": 13,
  "48371": 13,
  "48374": 24,
  "48375": 13,
  "48376": 13,
  "48377": 13,
  "48380": -2,
  "48381": -2,
  "48382": 13,
  "48383": 13,
  "48386": 13,
  "48387": 13,
  "48390": 13,
  "48391": 13,
  "48393": 13,
  "48401": -9,
  "48410": -9,
  "48411": 11,
  "48412": -4,
  "48413": -13,
  "48414": -8,
  "48415": 1,
  "48416": -9,
  "48417": 1,
  "48418": -8,
  "48419": -9,
  "48420": 2,
  "48421": -4,
  "48422": -9,
  "48423": 2,
  "48426": -10,
  "48427": -9,
  "48428": -3,
  "48429": -8,
  "48430": 11,
  "48432": -13,
  "48433": 2,
  "48434": -9,
  "48435": -4,
  "48436": -8,
  "48437": 2,
  "48438": 11,
  "48439": 2,
  "48440": -5,
  "48441": -13,
  "48442": 2,
  "48444": -4,
  "48445": -13,
  "48446": -4,
  "48449": -9,
  "48450": -9,
  "48451": 4,
  "48453": -9,
  "48454": -9,
  "48455": -3,
  "48456": -9,
  "48457": 0,
  "48458": 2,
  "48460": -8,
  "48461": -4,
  "48462": 3,
  "48463": 2,
  "48464": -4,
  "48465": -9,
  "48466": -9,
  "48467": -13,
  "48468": -13,
  "48469": -9,
  "48470": -13,
  "48471": -9,
  "48472": -9,
  "48473": 2,
  "48475": -13,
  "48476": -9,
  "48480": 2,
  "48501": 2,
  "48502": 2,
  "48503": 2,
  "48504": 2,
  "48505": 2,
  "48506": 2,
  "48507": 2,
  "48509": 2,
  "48519": 2,
  "48529": 2,
  "48531": 2,
  "48532": 2,
  "48601": 0,
  "48602": 0,
  "48603": 1,
  "48604": 0,
  "48605": 1,
  "48606": 0,
  "48607": 0,
  "48608": 1,
  "48609": 1,
  "48610": -11,
  "48611": -5,
  "48612": -5,
  "48613": -6,
  "48614": -15,
  "48615": -13,
  "48616": 1,
  "48617": -8,
  "48618": -1,
  "48619": -8,
  "48620": -1,
  "48621": -8,
  "48622": -8,
  "48623": 3,
  "48624": -5,
  "48625": -8,
  "48626": 1,
  "48627": -7,
  "48628": -1,
  "48629": -7,
  "48630": -7,
  "48631": -7,
  "48632": -8,
  "48633": -8,
  "48634": -7,
  "48635": -11,
  "48636": -8,
  "48637": -12,
  "48638": 1,
  "48640": -1,
  "48641": -1,
  "48642": -1,
  "48647": -8,
  "48649": -8,
  "48650": -7,
  "48651": -7,
  "48652": -5,
  "48653": -7,
  "48654": -11,
  "48655": 1,
  "48656": -7,
  "48657": -1,
  "48658": -15,
  "48659": -13,
  "48661": -11,
  "48662": -13,
  "48701": -13,
  "48703": -14,
  "48705": -14,
  "48706": -7,
  "48707": -7,
  "48708": -8,
  "48720": -14,
  "48721": -5,
  "48722": 1,
  "48723": -13,
  "48724": 0,
  "48725": -13,
  "48726": -13,
  "48727": -13,
  "48728": -14,
  "48729": -13,
  "48730": -12,
  "48731": -14,
  "48732": -7,
  "48733": -13,
  "48734": 9,
  "48735": -14,
  "48736": -13,
  "48737": -14,
  "48738": -5,
  "48739": -12,
  "48740": -14,
  "48741": -13,
  "48742": -14,
  "48743": -13,
  "48744": -13,
  "48745": -14,
  "48746": -13,
  "48747": -7,
  "48748": -12,
  "48749": -15,
  "48750": -12,
  "48754": -14,
  "48755": -13,
  "48756": -11,
  "48757": -13,
  "48758": -13,
  "48759": -13,
  "48760": -13,
  "48761": -13,
  "48762": -14,
  "48763": -12,
  "48764": -12,
  "48765": -15,
  "48766": -15,
  "48767": -13,
  "48768": -14,
  "48769": -14,
  "48770": -15,
  "48801": -12,
  "48804": -1,
  "48805": 16,
  "48806": -12,
  "48807": -12,
  "48808": -2,
  "48809": -7,
  "48811": -14,
  "48812": -6,
  "48813": 1,
  "48815": -6,
  "48816": -8,
  "48817": -8,
  "48818": -6,
  "48819": 7,
  "48820": 4,
  "48821": 1,
  "48822": -2,
  "48823": 7,
  "48824": 4,
  "48825": 7,
  "48826": 7,
  "48827": 1,
  "48829": -6,
  "48830": -13,
  "48831": -2,
  "48832": -12,
  "48833": -12,
  "48834": -7,
  "48835": -5,
  "48836": 1,
  "48837": 1,
  "48838": -8,
  "48840": 7,
  "48841": -8,
  "48842": 4,
  "48843": 1,
  "48844": 1,
  "48845": -7,
  "48846": -7,
  "48847": -12,
  "48848": -2,
  "48849": -6,
  "48850": -8,
  "48851": -7,
  "48852": -8,
  "48853": -3,
  "48854": 4,
  "48855": 1,
  "48856": -12,
  "48857": -5,
  "48858": -1,
  "48860": -7,
  "48861": 1,
  "48862": -12,
  "48863": 1,
  "48864": 16,
  "48865": -7,
  "48866": -2,
  "48867": -5,
  "48870": -7,
  "48871": -12,
  "48872": -5,
  "48873": -7,
  "48874": -12,
  "48875": -7,
  "48876": 1,
  "48877": -13,
  "48878": -1,
  "48879": -2,
  "48880": -13,
  "48881": -6,
  "48882": -5,
  "48883": -1,
  "48884": -8,
  "48885": -8,
  "48886": -8,
  "48887": -7,
  "48888": -8,
  "48889": -13,
  "48890": 1,
  "48891": -6,
  "48892": 7,
  "48893": -1,
  "48894": -5,
  "48895": 7,
  "48896": -1,
  "48897": -7,
  "48901": 4,
  "48906": 4,
  "48908": 4,
  "48909": 4,
  "48910": 4,
  "48911": 4,
  "48912": 4,
  "48915": 4,
  "48917": 4,
  "48924": 4,
  "48933": 4,
  "49001": 3,
  "49002": 3,
  "49003": 11,
  "49004": 3,
  "49005": 2,
  "49006": 3,
  "49007": 3,
  "49008": 3,
  "49009": 11,
  "49010": -1,
  "49011": -12,
  "49012": 11,
  "49013": -8,
  "49014": 0,
  "49015": 0,
  "49016": 0,
  "49017": 0,
  "49018": 0,
  "49019": 3,
  "49020": 0,
  "49021": 0,
  "49022": 0,
  "49023": 0,
  "49024": 3,
  "49026": -6,
  "49027": -8,
  "49028": -12,
  "49029": 0,
  "49030": -3,
  "49031": -9,
  "49032": -3,
  "49033": 9,
  "49034": 2,
  "49035": -7,
  "49036": -12,
  "49037": 0,
  "49038": -7,
  "49039": -7,
  "49040": -3,
  "49041": 2,
  "49042": -3,
  "49043": -8,
  "49045": -8,
  "49046": -7,
  "49047": -10,
  "49048": 2,
  "49050": -7,
  "49051": 0,
  "49052": 2,
  "49053": 3,
  "49055": -6,
  "49056": -7,
  "49057": -8,
  "49058": -7,
  "49060": 1,
  "49061": -9,
  "49062": -6,
  "49063": -7,
  "49064": -7,
  "49065": -6,
  "49066": -3,
  "49067": -8,
  "49068": 0,
  "49070": -2,
  "49071": 3,
  "49072": -3,
  "49073": -7,
  "49074": 2,
  "49075": -3,
  "49076": 1,
  "49077": 11,
  "49078": -2,
  "49079": -6,
  "49080": 3,
  "49081": 3,
  "49082": -12,
  "49083": 11,
  "49084": -7,
  "49085": 0,
  "49087": 3,
  "49088": 3,
  "49089": -12,
  "49090": -7,
  "49091": -2,
  "49092": -12,
  "49093": -3,
  "49094": -12,
  "49095": -9,
  "49096": 1,
  "49097": 3,
  "49098": -8,
  "49099": -2,
  "49101": 0,
  "49102": 0,
  "49103": 0,
  "49106": 0,
  "49107": 0,
  "49111": 0,
  "49112": -9,
  "49113": 0,
  "49115": 9,
  "49116": 11,
  "49117": 6,
  "49119": 0,
  "49120": -2,
  "49125": 0,
  "49126": 0,
  "49127": 0,
  "49128": 1,
  "49129": 0,
  "49130": 6,
  "49201": 0,
  "49202": -1,
  "49203": -1,
  "49204": 0,
  "49220": 0,
  "49221": 0,
  "49224": 0,
  "49227": -12,
  "49228": 0,
  "49229": 2,
  "49230": 0,
  "49232": -12,
  "49233": 8,
  "49234": 8,
  "49235": 0,
  "49236": 2,
  "49237": 0,
  "49238": 0,
  "49239": -12,
  "49240": 8,
  "49241": 0,
  "49242": -13,
  "49245": 0,
  "49246": 0,
  "49247": -12,
  "49248": 0,
  "49249": 0,
  "49250": -13,
  "49251": 4,
  "49252": -13,
  "49253": 0,
  "49254": 0,
  "49255": -13,
  "49256": 13,
  "49257": 0,
  "49258": -13,
  "49259": 0,
  "49261": 0,
  "49262": -13,
  "49263": -1,
  "49264": 4,
  "49265": 8,
  "49266": -12,
  "49267": 6,
  "49268": 0,
  "49269": 0,
  "49270": 4,
  "49271": -13,
  "49272": 0,
  "49274": -13,
  "49276": 6,
  "49277": 0,
  "49279": 0,
  "49281": 8,
  "49282": 0,
  "49283": 0,
  "49284": 1,
  "49285": -2,
  "49286": 2,
  "49287": 1,
  "49288": -13,
  "49289": 0,
  "49301": 13,
  "49302": 13,
  "49303": -10,
  "49304": -15,
  "49305": -13,
  "49306": 4,
  "49307": -15,
  "49309": -15,
  "49310": -1,
  "49311": -1,
  "49312": -10,
  "49314": -1,
  "49315": 4,
  "49316": 6,
  "49317": 4,
  "49318": 4,
  "49319": 4,
  "49320": -14,
  "49321": 4,
  "49322": -8,
  "49323": -1,
  "49325": -6,
  "49326": -7,
  "49327": -10,
  "49328": -1,
  "49329": -8,
  "49330": 4,
  "49331": 4,
  "49332": -14,
  "49333": -6,
  "49335": -1,
  "49336": -14,
  "49337": -10,
  "49338": -15,
  "49339": -7,
  "49340": -1,
  "49341": 4,
  "49342": -14,
  "49343": -7,
  "49344": -7,
  "49345": 4,
  "49346": -14,
  "49347": -8,
  "49348": -1,
  "49349": -10,
  "49401": -3,
  "49402": -15,
  "49403": 4,
  "49404": -3,
  "49405": -9,
  "49406": 0,
  "49408": -1,
  "49409": 10,
  "49410": -9,
  "49411": -9,
  "49412": -10,
  "49415": 2,
  "49416": -1,
  "49417": 4,
  "49418": 4,
  "49419": 0,
  "49420": -11,
  "49421": -11,
  "49422": -2,
  "49423": -2,
  "49424": -2,
  "49425": 1,
  "49426": -3,
  "49427": -3,
  "49428": -3,
  "49429": -3,
  "49430": -3,
  "49431": -9,
  "49434": 9,
  "49435": 4,
  "49436": -10,
  "49437": 2,
  "49440": 1,
  "49441": 1,
  "49442": 1,
  "49443": 1,
  "49444": 1,
  "49445": 2,
  "49446": -11,
  "49448": 4,
  "49449": -10,
  "49450": -1,
  "49451": 2,
  "49452": -11,
  "49453": 0,
  "49454": -9,
  "49455": -11,
  "49456": 10,
  "49457": 2,
  "49458": -9,
  "49459": -11,
  "49460": -2,
  "49461": 3,
  "49463": 3,
  "49464": -2,
  "49468": 4,
  "49501": 4,
  "49503": 4,
  "49504": 4,
  "49505": 4,
  "49506": 4,
  "49507": 4,
  "49508": 4,
  "49509": 4,
  "49510": 4,
  "49512": 4,
  "49514": 4,
  "49515": 4,
  "49516": 13,
  "49518": 4,
  "49519": 4,
  "49523": 4,
  "49525": 4,
  "49528": 4,
  "49534": 4,
  "49544": 4,
  "49546": 13,
  "49548": 4,
  "49588": 4,
  "49599": 4,
  "49601": -10,
  "49610": 5,
  "49611": -8,
  "49612": -8,
  "49613": -11,
  "49614": -11,
  "49615": -8,
  "49616": -8,
  "49617": -6,
  "49618": -12,
  "49619": -11,
  "49620": -6,
  "49621": -6,
  "49622": -8,
  "49623": -15,
  "49625": -11,
  "49626": -11,
  "49627": -8,
  "49628": -6,
  "49629": 1,
  "49630": -6,
  "49631": 11,
  "49632": -12,
  "49633": 3,
  "49634": -11,
  "49635": -6,
  "49636": 2,
  "49637": -6,
  "49638": -12,
  "49639": 9,
  "49640": -6,
  "49642": -15,
  "49643": -7,
  "49644": -11,
  "49645": -11,
  "49646": 3,
  "49648": 1,
  "49649": -4,
  "49650": 1,
  "49651": -11,
  "49653": 2,
  "49654": 2,
  "49655": 12,
  "49656": -15,
  "49657": -11,
  "49659": -8,
  "49660": -11,
  "49663": -10,
  "49664": -6,
  "49665": 11,
  "49666": -4,
  "49667": -11,
  "49668": -12,
  "49670": 3,
  "49673": 1,
  "49674": 3,
  "49675": -11,
  "49676": 3,
  "49677": 9,
  "49679": 11,
  "49680": 3,
  "49682": 3,
  "49683": -8,
  "49684": -4,
  "49685": -6,
  "49686": -4,
  "49688": 12,
  "49689": -11,
  "49690": 5,
  "49696": -4,
  "49701": -10,
  "49705": -1,
  "49706": -4,
  "49707": -12,
  "49709": -13,
  "49710": 4,
  "49711": -4,
  "49712": -7,
  "49713": -7,
  "49715": 5,
  "49716": -4,
  "49717": -4,
  "49718": -4,
  "49719": 5,
  "49720": -7,
  "49721": 0,
  "49722": -4,
  "49723": 4,
  "49724": 5,
  "49725": 5,
  "49726": 5,
  "49727": -7,
  "49728": -9,
  "49729": -7,
  "49730": -8,
  "49733": -11,
  "49734": -1,
  "49735": -1,
  "49736": 5,
  "49737": 4,
  "49738": -11,
  "49740": 4,
  "49743": -13,
  "49744": -12,
  "49745": 5,
  "49746": -12,
  "49747": -14,
  "49748": -9,
  "49749": 0,
  "49751": -1,
  "49752": -8,
  "49753": -12,
  "49755": -4,
  "49756": -8,
  "49757": -1,
  "49759": -13,
  "49760": -10,
  "49761": 0,
  "49762": -11,
  "49764": 4,
  "49765": -13,
  "49766": -12,
  "49768": -9,
  "49769": -4,
  "49770": -4,
  "49774": 5,
  "49775": 8,
  "49776": -15,
  "49777": -3,
  "49779": -13,
  "49780": -10,
  "49781": -10,
  "49782": -10,
  "49783": 4,
  "49788": 4,
  "49790": -8,
  "49791": -1,
  "49792": -1,
  "49793": -10,
  "49795": -1,
  "49796": -7,
  "49797": -11,
  "49799": 0,
  "49801": 10,
  "49802": 10,
  "49805": -5,
  "49806": -7,
  "49807": -9,
  "49808": -6,
  "49812": -9,
  "49814": -6,
  "49815": 10,
  "49816": -8,
  "49817": -11,
  "49818": -9,
  "49819": 10,
  "49820": -11,
  "49821": -9,
  "49822": -8,
  "49825": -7,
  "49826": -8,
  "49827": -9,
  "49829": -9,
  "49831": 10,
  "49833": -6,
  "49834": 10,
  "49835": -9,
  "49836": -11,
  "49837": -9,
  "49838": -11,
  "49839": -9,
  "49840": -11,
  "49841": -6,
  "49845": -9,
  "49847": -9,
  "49848": -9,
  "49849": -6,
  "49852": 10,
  "49853": -9,
  "49854": -11,
  "49855": -6,
  "49858": -9,
  "49861": -9,
  "49862": -8,
  "49863": -9,
  "49864": -9,
  "49865": -6,
  "49866": -6,
  "49868": -9,
  "49870": 10,
  "49871": -6,
  "49872": -9,
  "49873": 10,
  "49874": -9,
  "49876": 10,
  "49877": 10,
  "49878": -9,
  "49879": -6,
  "49880": -9,
  "49881": 10,
  "49883": -9,
  "49884": -8,
  "49885": -6,
  "49886": -9,
  "49887": -9,
  "49891": -8,
  "49892": 10,
  "49893": -9,
  "49894": -9,
  "49895": -8,
  "49896": -9,
  "49901": -5,
  "49902": -8,
  "49903": -8,
  "49905": -9,
  "49908": -9,
  "49910": -16,
  "49911": -12,
  "49912": -16,
  "49913": -9,
  "49915": -8,
  "49916": -9,
  "49917": -5,
  "49918": -4,
  "49919": -9,
  "49920": -7,
  "49921": -9,
  "49922": -9,
  "49925": -16,
  "49927": -8,
  "49929": -16,
  "49930": -9,
  "49931": -9,
  "49934": -9,
  "49935": -8,
  "49938": -13,
  "49942": -5,
  "49945": -9,
  "49946": -9,
  "49947": -11,
  "49948": -16,
  "49950": -5,
  "49952": -16,
  "49953": -17,
  "49955": -9,
  "49958": -9,
  "49959": -12,
  "49960": -16,
  "49961": -8,
  "49962": -9,
  "49963": -9,
  "49964": -8,
  "49965": -9,
  "49967": -16,
  "49968": -12,
  "49969": -5,
  "49970": -9,
  "49971": -17,
  "50001": -4,
  "50002": 5,
  "50003": -4,
  "50005": 3,
  "50006": -5,
  "50007": 13,
  "50008": -16,
  "50009": 5,
  "50010": 6,
  "50014": 6,
  "50020": -6,
  "50021": 13,
  "50022": -6,
  "50023": 13,
  "50025": -8,
  "50026": -8,
  "50027": -7,
  "50028": -2,
  "50029": -8,
  "50031": 0,
  "50032": 4,
  "50033": -12,
  "50034": -9,
  "50035": 5,
  "50036": 0,
  "50037": 0,
  "50038": -4,
  "50039": -4,
  "50040": 0,
  "50041": 5,
  "50042": -8,
  "50043": -5,
  "50044": -3,
  "50046": -2,
  "50047": -4,
  "50048": 5,
  "50049": -8,
  "50050": -11,
  "50051": 3,
  "50052": -16,
  "50054": -2,
  "50055": -2,
  "50056": -2,
  "50057": -2,
  "50058": -11,
  "50059": -11,
  "50060": -9,
  "50061": 13,
  "50062": -2,
  "50063": -4,
  "50064": -11,
  "50065": -16,
  "50066": -4,
  "50067": -16,
  "50068": -8,
  "50069": -4,
  "50070": -11,
  "50071": -7,
  "50072": -11,
  "50073": 5,
  "50074": 2,
  "50075": -10,
  "50076": -8,
  "50078": 1,
  "50099": 0,
  "50101": -7,
  "50102": -6,
  "50103": -16,
  "50104": -12,
  "50105": -2,
  "50106": 2,
  "50107": -11,
  "50108": -16,
  "50109": 5,
  "50110": -8,
  "50111": 5,
  "50112": -1,
  "50115": -8,
  "50116": -4,
  "50117": -8,
  "50118": -4,
  "50119": -2,
  "50120": 2,
  "50122": -5,
  "50123": -9,
  "50124": -2,
  "50125": -4,
  "50126": -5,
  "50127": -2,
  "50128": -10,
  "50129": -10,
  "50130": -10,
  "50131": 13,
  "50132": -10,
  "50133": 2,
  "50134": -2,
  "50135": -2,
  "50136": -12,
  "50137": -2,
  "50138": -2,
  "50139": -8,
  "50140": -16,
  "50141": 2,
  "50142": 3,
  "50143": -8,
  "50144": -16,
  "50145": -4,
  "50146": -8,
  "50147": -16,
  "50148": 3,
  "50149": -12,
  "50150": -4,
  "50151": -8,
  "50152": 0,
  "50153": -1,
  "50154": -2,
  "50155": -12,
  "50156": 0,
  "50157": 1,
  "50158": 3,
  "50160": -4,
  "50161": -2,
  "50162": 2,
  "50163": -2,
  "50164": 5,
  "50165": -9,
  "50166": -4,
  "50167": -4,
  "50168": -2,
  "50169": 5,
  "50170": -2,
  "50171": 1,
  "50173": -3,
  "50174": -17,
  "50201": -2,
  "50206": -5,
  "50207": -8,
  "50208": -2,
  "50210": -17,
  "50211": -4,
  "50212": 0,
  "50213": -17,
  "50214": -2,
  "50216": -8,
  "50217": -11,
  "50218": -12,
  "50219": 0,
  "50220": -4,
  "50222": -11,
  "50223": 0,
  "50225": -2,
  "50226": 5,
  "50227": 5,
  "50228": -2,
  "50229": -4,
  "50230": -6,
  "50231": -10,
  "50232": -2,
  "50233": -4,
  "50234": 2,
  "50235": -11,
  "50236": -2,
  "50237": 13,
  "50238": -8,
  "50239": 2,
  "50240": -5,
  "50241": -5,
  "50242": -1,
  "50243": -2,
  "50244": -2,
  "50246": -10,
  "50247": 2,
  "50248": -2,
  "50249": -10,
  "50250": 5,
  "50251": -2,
  "50252": -4,
  "50254": -12,
  "50255": -12,
  "50256": -2,
  "50257": -17,
  "50258": 3,
  "50259": 3,
  "50261": -11,
  "50262": -16,
  "50263": 5,
  "50264": -18,
  "50265": 13,
  "50266": 13,
  "50268": -12,
  "50269": 3,
  "50271": -9,
  "50272": -9,
  "50273": -11,
  "50274": -6,
  "50275": -17,
  "50276": -4,
  "50277": -8,
  "50278": -2,
  "50301": 4,
  "50302": 4,
  "50303": 4,
  "50304": 4,
  "50305": 4,
  "50306": 4,
  "50307": 5,
  "50308": 5,
  "50309": 5,
  "50310": 5,
  "50311": 5,
  "50312": 5,
  "50313": 5,
  "50314": 4,
  "50315": 5,
  "50316": 5,
  "50317": 5,
  "50318": 5,
  "50319": 5,
  "50320": 5,
  "50321": 13,
  "50322": 13,
  "50323": 13,
  "50324": 5,
  "50325": 13,
  "50327": 5,
  "50333": 5,
  "50340": 5,
  "50393": 5,
  "50394": 5,
  "50395": 4,
  "50401": 0,
  "50402": 0,
  "50420": 6,
  "50421": -7,
  "50423": -8,
  "50424": -1,
  "50426": -6,
  "50427": 6,
  "50428": 9,
  "50430": -8,
  "50431": 5,
  "50432": -8,
  "50433": 6,
  "50434": -6,
  "50435": 1,
  "50436": -1,
  "50438": -8,
  "50439": -8,
  "50440": -6,
  "50441": 6,
  "50444": -6,
  "50446": -6,
  "50447": -8,
  "50448": -6,
  "50449": 2,
  "50450": -1,
  "50451": -6,
  "50452": 6,
  "50453": -1,
  "50454": -6,
  "50455": -6,
  "50456": -6,
  "50457": -8,
  "50458": 1,
  "50459": -6,
  "50460": 3,
  "50461": -6,
  "50464": -6,
  "50465": -4,
  "50466": -8,
  "50467": -6,
  "50468": 1,
  "50469": 0,
  "50470": -7,
  "50471": 1,
  "50472": -6,
  "50473": -1,
  "50475": 6,
  "50476": -6,
  "50477": 0,
  "50478": -1,
  "50479": 0,
  "50480": -6,
  "50481": -6,
  "50482": 2,
  "50483": -6,
  "50484": -1,
  "50501": -3,
  "50510": 6,
  "50511": -6,
  "50514": -15,
  "50515": -4,
  "50516": -8,
  "50517": -6,
  "50518": -3,
  "50519": -8,
  "50520": -8,
  "50521": -3,
  "50522": -6,
  "50523": -3,
  "50524": -3,
  "50525": -7,
  "50527": -4,
  "50528": -4,
  "50529": -8,
  "50530": -3,
  "50531": -15,
  "50532": -3,
  "50533": -7,
  "50535": -12,
  "50536": -4,
  "50538": -15,
  "50539": -7,
  "50540": -13,
  "50541": -13,
  "50542": -7,
  "50543": -3,
  "50544": -3,
  "50545": -7,
  "50546": -13,
  "50548": -8,
  "50551": -15,
  "50552": -15,
  "50554": -13,
  "50556": -6,
  "50557": -3,
  "50558": -7,
  "50559": -7,
  "50560": -7,
  "50561": -15,
  "50562": -4,
  "50563": -14,
  "50565": 6,
  "50566": -3,
  "50567": -12,
  "50568": 6,
  "50569": -3,
  "50570": -8,
  "50571": -13,
  "50573": -13,
  "50574": -13,
  "50575": -15,
  "50576": 6,
  "50577": -7,
  "50578": -7,
  "50579": -14,
  "50581": -13,
  "50582": -8,
  "50583": -12,
  "50585": 6,
  "50586": -15,
  "50588": 6,
  "50590": -6,
  "50591": -8,
  "50592": 6,
  "50593": -13,
  "50594": -3,
  "50595": -10,
  "50597": -4,
  "50598": -6,
  "50599": -8,
  "50601": -5,
  "50602": -10,
  "50603": -6,
  "50604": -10,
  "50605": 5,
  "50606": 0,
  "50607": -13,
  "50608": -10,
  "50609": 4,
  "50611": -10,
  "50612": 5,
  "50613": 7,
  "50616": 1,
  "50619": -10,
  "50620": 1,
  "50621": 4,
  "50622": 0,
  "50623": -3,
  "50624": 12,
  "50625": -10,
  "50626": -3,
  "50627": -5,
  "50628": -8,
  "50629": -12,
  "50630": -6,
  "50631": -9,
  "50632": -3,
  "50633": 6,
  "50634": -3,
  "50635": -3,
  "50636": -10,
  "50638": 4,
  "50641": -13,
  "50642": 4,
  "50643": 5,
  "50644": -13,
  "50645": -6,
  "50647": 0,
  "50648": -12,
  "50649": -10,
  "50650": -13,
  "50651": -3,
  "50652": 3,
  "50653": 1,
  "50654": -8,
  "50655": 0,
  "50657": 4,
  "50658": -6,
  "50659": -6,
  "50660": -10,
  "50661": -6,
  "50662": 0,
  "50664": 0,
  "50665": -10,
  "50666": -9,
  "50667": -3,
  "50668": -10,
  "50669": 4,
  "50670": -8,
  "50671": -13,
  "50672": -5,
  "50673": -10,
  "50674": -11,
  "50675": -5,
  "50676": -9,
  "50677": 0,
  "50680": 4,
  "50681": 0,
  "50682": -13,
  "50701": -3,
  "50702": -3,
  "50703": -3,
  "50704": -3,
  "50706": -3,
  "50707": -3,
  "50801": -12,
  "50830": -12,
  "50831": -12,
  "50833": -16,
  "50835": 2,
  "50836": -16,
  "50837": 4,
  "50839": -8,
  "50840": -16,
  "50841": -16,
  "50842": -12,
  "50843": -6,
  "50845": 2,
  "50846": 4,
  "50847": -8,
  "50848": -16,
  "50849": 5,
  "50851": -16,
  "50853": -6,
  "50854": 2,
  "50857": -8,
  "50858": 4,
  "50859": -12,
  "50860": 2,
  "50861": -12,
  "50862": -16,
  "50863": 2,
  "50864": -8,
  "51001": -8,
  "51002": 6,
  "51003": -3,
  "51004": -3,
  "51005": -8,
  "51006": -4,
  "51007": 6,
  "51008": -8,
  "51009": -8,
  "51010": 8,
  "51011": -3,
  "51012": -8,
  "51014": -8,
  "51015": 6,
  "51016": -4,
  "51018": -4,
  "51019": -4,
  "51020": -4,
  "51022": -12,
  "51023": -3,
  "51024": 0,
  "51025": -4,
  "51026": -3,
  "51027": -3,
  "51028": -8,
  "51029": -8,
  "51030": 6,
  "51031": -6,
  "51033": 6,
  "51034": 8,
  "51035": -8,
  "51036": -3,
  "51037": -8,
  "51038": -8,
  "51039": -1,
  "51040": 8,
  "51041": 6,
  "51044": 8,
  "51045": -8,
  "51046": -12,
  "51047": -5,
  "51048": -8,
  "51049": -8,
  "51050": -8,
  "51051": 7,
  "51052": -1,
  "51053": -12,
  "51054": 6,
  "51055": -3,
  "51056": 8,
  "51058": -12,
  "51060": 8,
  "51061": -8,
  "51062": 0,
  "51063": 8,
  "51101": -3,
  "51102": 6,
  "51103": -3,
  "51104": 6,
  "51105": -3,
  "51106": -3,
  "51108": -3,
  "51109": -3,
  "51111": -3,
  "51201": -10,
  "51230": -12,
  "51231": -12,
  "51232": -12,
  "51234": -1,
  "51235": -12,
  "51237": -12,
  "51238": -12,
  "51239": -1,
  "51240": -1,
  "51241": -10,
  "51242": -12,
  "51243": -12,
  "51244": -1,
  "51245": -12,
  "51246": -12,
  "51247": -1,
  "51248": -10,
  "51249": -12,
  "51250": 6,
  "51301": -5,
  "51331": -7,
  "51333": -5,
  "51334": -15,
  "51338": -5,
  "51340": -5,
  "51341": -6,
  "51342": -16,
  "51343": -6,
  "51345": -12,
  "51346": -12,
  "51347": -7,
  "51350": -12,
  "51351": -6,
  "51354": -12,
  "51355": 1,
  "51357": -5,
  "51358": -4,
  "51360": 1,
  "51363": -8,
  "51364": -8,
  "51365": -16,
  "51366": -5,
  "51401": -11,
  "51430": -11,
  "51431": -4,
  "51432": -12,
  "51433": -12,
  "51436": -12,
  "51439": 9,
  "51440": -12,
  "51441": 9,
  "51442": 10,
  "51443": -11,
  "51444": -12,
  "51445": -4,
  "51446": -12,
  "51447": -12,
  "51448": 9,
  "51449": -14,
  "51450": -12,
  "51451": -12,
  "51452": -12,
  "51453": -15,
  "51454": 9,
  "51455": -12,
  "51458": -12,
  "51459": -11,
  "51460": 9,
  "51461": 9,
  "51462": -11,
  "51463": -11,
  "51465": 9,
  "51466": -12,
  "51467": -12,
  "51501": -5,
  "51502": -5,
  "51503": 4,
  "51510": -5,
  "51520": 9,
  "51521": -12,
  "51523": 8,
  "51525": -4,
  "51526": 4,
  "51527": -12,
  "51528": 9,
  "51529": -10,
  "51530": -12,
  "51531": -7,
  "51532": -8,
  "51533": -8,
  "51534": 2,
  "51535": -6,
  "51536": -4,
  "51537": -12,
  "51540": -6,
  "51541": -6,
  "51542": 4,
  "51543": -8,
  "51544": -6,
  "51545": -10,
  "51546": -10,
  "51548": 4,
  "51549": -6,
  "51550": -10,
  "51551": -6,
  "51552": -6,
  "51553": -3,
  "51554": 2,
  "51555": -10,
  "51556": -9,
  "51557": -9,
  "51558": 8,
  "51559": -4,
  "51560": -4,
  "51561": -6,
  "51562": -12,
  "51563": -10,
  "51564": -9,
  "51565": -12,
  "51566": -8,
  "51570": -12,
  "51571": -6,
  "51572": 8,
  "51573": -8,
  "51575": -4,
  "51576": 4,
  "51577": -6,
  "51578": -12,
  "51579": -10,
  "51591": -8,
  "51593": -12,
  "51601": -14,
  "51630": -14,
  "51631": -14,
  "51632": -14,
  "51636": -14,
  "51637": -14,
  "51638": -14,
  "51639": -16,
  "51640": -16,
  "51645": -15,
  "51646": -16,
  "51647": -14,
  "51648": -15,
  "51649": -16,
  "51650": -16,
  "51651": -14,
  "51652": -16,
  "51653": -6,
  "51654": -16,
  "51656": -14,
  "52001": -1,
  "52002": 7,
  "52003": -1,
  "52004": -1,
  "52030": -13,
  "52031": -12,
  "52032": -1,
  "52033": -7,
  "52035": -2,
  "52036": -8,
  "52037": -5,
  "52038": -8,
  "52039": 7,
  "52040": -7,
  "52041": -8,
  "52042": -2,
  "52043": -2,
  "52044": -2,
  "52045": -1,
  "52046": -1,
  "52047": -2,
  "52048": -2,
  "52049": -2,
  "52050": -8,
  "52052": -2,
  "52053": -1,
  "52054": -1,
  "52056": -1,
  "52057": -7,
  "52060": -13,
  "52064": -13,
  "52065": -7,
  "52066": -1,
  "52068": 7,
  "52069": -13,
  "52070": -5,
  "52071": -13,
  "52072": -2,
  "52073": -1,
  "52074": -12,
  "52075": -13,
  "52076": -2,
  "52077": -3,
  "52078": -7,
  "52079": -4,
  "52101": -5,
  "52132": -6,
  "52133": -5,
  "52134": -8,
  "52135": 0,
  "52136": -8,
  "52140": -11,
  "52141": 0,
  "52142": 0,
  "52144": -6,
  "52146": -13,
  "52147": 0,
  "52149": -5,
  "52151": -10,
  "52154": -6,
  "52155": -8,
  "52156": -10,
  "52157": -2,
  "52158": -2,
  "52159": -10,
  "52160": -11,
  "52161": -6,
  "52162": -10,
  "52163": -8,
  "52164": 0,
  "52165": -5,
  "52166": -6,
  "52168": -6,
  "52169": 0,
  "52170": -10,
  "52171": -9,
  "52172": -10,
  "52175": 0,
  "52201": -7,
  "52202": 1,
  "52203": -4,
  "52205": -7,
  "52206": 3,
  "52207": -13,
  "52208": 2,
  "52209": 3,
  "52210": -13,
  "52211": -1,
  "52212": -8,
  "52213": 1,
  "52214": 1,
  "52215": -4,
  "52216": -7,
  "52217": -5,
  "52218": -7,
  "52219": -8,
  "52220": -4,
  "52221": -1,
  "52222": 1,
  "52223": -7,
  "52224": -5,
  "52225": -5,
  "52227": 1,
  "52228": 1,
  "52229": 1,
  "52231": -11,
  "52232": -1,
  "52233": 1,
  "52235": -7,
  "52236": 6,
  "52237": -7,
  "52240": 7,
  "52241": 7,
  "52242": 7,
  "52244": 7,
  "52245": 7,
  "52246": 7,
  "52247": -5,
  "52248": -11,
  "52249": 3,
  "52251": -4,
  "52252": -7,
  "52253": -8,
  "52254": -13,
  "52255": -9,
  "52257": 3,
  "52301": -4,
  "52302": 1,
  "52305": -7,
  "52306": -7,
  "52307": -4,
  "52308": -3,
  "52309": -13,
  "52310": -7,
  "52312": -8,
  "52313": 1,
  "52314": 1,
  "52315": 3,
  "52316": -3,
  "52317": -2,
  "52318": 3,
  "52319": 7,
  "52320": -7,
  "52321": -8,
  "52322": 7,
  "52323": -8,
  "52324": 1,
  "52325": -3,
  "52326": -12,
  "52327": -7,
  "52328": 10,
  "52329": -11,
  "52330": -7,
  "52332": 3,
  "52333": 7,
  "52334": -4,
  "52335": -11,
  "52336": 1,
  "52337": -7,
  "52338": 6,
  "52339": -5,
  "52340": 7,
  "52341": 3,
  "52342": -5,
  "52344": -11,
  "52345": 3,
  "52346": 3,
  "52347": -4,
  "52348": -5,
  "52349": 3,
  "52350": 1,
  "52351": 3,
  "52352": -11,
  "52353": -7,
  "52354": 3,
  "52355": -11,
  "52356": -7,
  "52358": -2,
  "52359": -7,
  "52361": -3,
  "52362": -8,
  "52401": 1,
  "52402": 1,
  "52403": 1,
  "52404": 1,
  "52405": 1,
  "52406": 1,
  "52407": 1,
  "52408": 1,
  "52409": 1,
  "52410": 1,
  "52411": 10,
  "52501": -4,
  "52530": -4,
  "52531": -3,
  "52533": -8,
  "52534": -8,
  "52535": -14,
  "52536": -5,
  "52537": -13,
  "52540": -8,
  "52542": -14,
  "52543": -6,
  "52544": -11,
  "52548": -4,
  "52549": -11,
  "52550": -12,
  "52551": -14,
  "52552": -13,
  "52553": -8,
  "52554": -4,
  "52555": -11,
  "52556": -8,
  "52560": -13,
  "52561": -6,
  "52562": -11,
  "52563": -11,
  "52565": -14,
  "52566": -4,
  "52567": -8,
  "52568": -11,
  "52569": -3,
  "52570": -14,
  "52571": -11,
  "52572": -11,
  "52573": -14,
  "52574": -11,
  "52576": -11,
  "52577": -8,
  "52580": -8,
  "52581": -11,
  "52583": -11,
  "52584": -13,
  "52585": -8,
  "52586": -11,
  "52588": -14,
  "52590": -11,
  "52591": -11,
  "52593": -11,
  "52594": -11,
  "52595": -8,
  "52601": -5,
  "52619": 4,
  "52620": -14,
  "52621": -7,
  "52623": -3,
  "52624": 4,
  "52625": 4,
  "52626": -14,
  "52627": 4,
  "52630": -14,
  "52631": -8,
  "52632": -6,
  "52635": -8,
  "52637": -5,
  "52638": -5,
  "52639": 4,
  "52640": -11,
  "52641": -8,
  "52642": -8,
  "52644": -8,
  "52645": -8,
  "52646": -13,
  "52647": -8,
  "52648": -8,
  "52649": -8,
  "52650": 3,
  "52651": -14,
  "52652": -8,
  "52653": -12,
  "52654": -8,
  "52655": -5,
  "52656": 4,
  "52657": -8,
  "52658": -5,
  "52659": -11,
  "52660": -3,
  "52701": -5,
  "52720": -6,
  "52721": -9,
  "52722": 9,
  "52726": 4,
  "52727": -5,
  "52728": 2,
  "52729": -5,
  "52730": -5,
  "52731": -5,
  "52732": -5,
  "52733": -5,
  "52737": -11,
  "52738": -11,
  "52739": -11,
  "52742": -5,
  "52745": 2,
  "52746": 2,
  "52747": -8,
  "52748": 4,
  "52749": 3,
  "52750": -5,
  "52751": -5,
  "52752": -11,
  "52753": 9,
  "52754": -11,
  "52755": -2,
  "52756": -3,
  "52757": -5,
  "52758": -5,
  "52759": 4,
  "52760": -6,
  "52761": -8,
  "52765": 0,
  "52766": -6,
  "52767": 0,
  "52768": 3,
  "52769": 2,
  "52771": -5,
  "52772": -7,
  "52773": 2,
  "52774": -5,
  "52776": -6,
  "52777": -9,
  "52778": -8,
  "52801": 2,
  "52802": 2,
  "52803": 2,
  "52804": 2,
  "52805": 2,
  "52806": 2,
  "52807": 11,
  "52808": 2,
  "52809": 2,
  "53001": -1,
  "53002": 1,
  "53003": 13,
  "53004": -4,
  "53005": 7,
  "53006": 11,
  "53007": 7,
  "53008": 7,
  "53010": 3,
  "53011": -1,
  "53012": -4,
  "53013": 0,
  "53014": -2,
  "53015": -7,
  "53016": 13,
  "53017": 1,
  "53018": 16,
  "53019": 2,
  "53020": 0,
  "53021": -3,
  "53022": -1,
  "53023": -1,
  "53024": -4,
  "53026": -1,
  "53027": 1,
  "53029": 8,
  "53031": -1,
  "53032": 13,
  "53033": 1,
  "53034": 13,
  "53035": 13,
  "53036": 1,
  "53037": -1,
  "53038": 1,
  "53039": 13,
  "53040": -1,
  "53042": -1,
  "53044": 0,
  "53045": 8,
  "53046": 7,
  "53047": 1,
  "53048": 2,
  "53049": 3,
  "53050": 11,
  "53051": 6,
  "53052": 6,
  "53056": 8,
  "53057": 2,
  "53058": 16,
  "53059": 13,
  "53060": -3,
  "53061": -3,
  "53063": -7,
  "53064": 8,
  "53065": 3,
  "53066": 8,
  "53069": 16,
  "53070": -1,
  "53072": 8,
  "53073": -1,
  "53074": -4,
  "53075": 0,
  "53076": 1,
  "53078": 1,
  "53079": 2,
  "53080": -4,
  "53081": -1,
  "53082": 0,
  "53083": -1,
  "53085": -1,
  "53086": 1,
  "53088": -3,
  "53089": 8,
  "53090": -1,
  "53091": 1,
  "53092": 4,
  "53093": -1,
  "53094": 1,
  "53095": -1,
  "53097": 4,
  "53098": 13,
  "53099": 13,
  "53101": 0,
  "53102": 0,
  "53103": 8,
  "53104": 0,
  "53105": -3,
  "53108": 0,
  "53109": 0,
  "53110": 7,
  "53114": -3,
  "53115": -3,
  "53118": 8,
  "53119": 8,
  "53120": -2,
  "53121": -1,
  "53122": 15,
  "53125": 4,
  "53126": 9,
  "53127": 8,
  "53128": -3,
  "53129": 7,
  "53130": 7,
  "53132": 7,
  "53137": 1,
  "53138": 2,
  "53139": 2,
  "53140": 0,
  "53141": 0,
  "53142": 0,
  "53143": 0,
  "53144": 0,
  "53146": 7,
  "53147": -3,
  "53148": -2,
  "53149": 8,
  "53150": 8,
  "53151": 9,
  "53152": 0,
  "53153": 8,
  "53154": 1,
  "53156": 1,
  "53157": -3,
  "53158": 0,
  "53159": -3,
  "53167": 2,
  "53168": 0,
  "53170": 0,
  "53171": 0,
  "53172": 7,
  "53176": -2,
  "53177": 0,
  "53178": 1,
  "53179": 0,
  "53181": 0,
  "53182": 0,
  "53183": 8,
  "53184": -4,
  "53185": 2,
  "53186": 7,
  "53187": 7,
  "53188": 7,
  "53189": 7,
  "53190": 1,
  "53191": 4,
  "53192": 0,
  "53194": 0,
  "53195": -4,
  "53199": 0,
  "53201": 15,
  "53202": 7,
  "53203": 15,
  "53204": 6,
  "53205": 6,
  "53206": 6,
  "53207": 7,
  "53208": 6,
  "53209": 6,
  "53210": 6,
  "53211": 7,
  "53212": 6,
  "53213": 7,
  "53214": 6,
  "53215": 6,
  "53216": 6,
  "53217": 7,
  "53218": 6,
  "53219": 7,
  "53220": 7,
  "53221": 7,
  "53222": 7,
  "53223": 6,
  "53224": 7,
  "53225": 6,
  "53226": 7,
  "53227": 7,
  "53228": 7,
  "53233": 6,
  "53234": 7,
  "53235": 7,
  "53237": 7,
  "53244": 7,
  "53401": 0,
  "53402": 0,
  "53403": 0,
  "53404": 0,
  "53405": 0,
  "53406": 0,
  "53408": 0,
  "53501": 4,
  "53502": -7,
  "53503": -4,
  "53504": -2,
  "53505": 6,
  "53506": -9,
  "53507": -3,
  "53508": -5,
  "53510": -3,
  "53511": 4,
  "53512": 4,
  "53515": 7,
  "53516": -2,
  "53517": -3,
  "53518": -11,
  "53520": -8,
  "53521": -5,
  "53522": -8,
  "53523": 2,
  "53525": 5,
  "53526": -5,
  "53527": 7,
  "53528": 7,
  "53529": 7,
  "53530": -3,
  "53531": 7,
  "53532": 7,
  "53533": -4,
  "53534": 6,
  "53535": -5,
  "53536": 6,
  "53537": 6,
  "53538": 1,
  "53540": -9,
  "53541": -3,
  "53542": 6,
  "53543": -5,
  "53544": -4,
  "53545": 6,
  "53546": 6,
  "53547": 6,
  "53548": 6,
  "53549": 1,
  "53550": -8,
  "53551": 1,
  "53553": -5,
  "53554": -10,
  "53555": -2,
  "53556": -9,
  "53557": 13,
  "53558": 7,
  "53559": 2,
  "53560": 3,
  "53561": 3,
  "53562": 15,
  "53563": 6,
  "53565": -5,
  "53566": -8,
  "53569": -10,
  "53570": -6,
  "53571": -2,
  "53572": 7,
  "53573": -11,
  "53574": -5,
  "53575": 7,
  "53576": 6,
  "53577": 2,
  "53578": 3,
  "53579": 13,
  "53580": -10,
  "53581": -11,
  "53582": -4,
  "53583": 2,
  "53584": -9,
  "53585": -4,
  "53586": -3,
  "53587": -3,
  "53588": -4,
  "53589": 7,
  "53590": 7,
  "53593": 15,
  "53594": 1,
  "53597": 15,
  "53598": 7,
  "53599": -2,
  "53701": 7,
  "53703": 7,
  "53704": 6,
  "53705": 15,
  "53706": 6,
  "53707": 6,
  "53708": 6,
  "53711": 7,
  "53713": 6,
  "53714": 6,
  "53715": 6,
  "53716": 6,
  "53717": 15,
  "53718": 6,
  "53719": 7,
  "53725": 6,
  "53726": 6,
  "53744": 6,
  "53801": -2,
  "53802": -10,
  "53803": -3,
  "53804": -10,
  "53805": -13,
  "53806": -10,
  "53807": -3,
  "53808": -1,
  "53809": -10,
  "53810": -2,
  "53811": -1,
  "53812": -1,
  "53813": -10,
  "53816": -10,
  "53817": -10,
  "53818": -10,
  "53820": -10,
  "53821": -13,
  "53824": -1,
  "53825": -10,
  "53826": -13,
  "53827": -13,
  "53901": -2,
  "53910": -12,
  "53911": -2,
  "53913": 2,
  "53916": 13,
  "53919": -8,
  "53920": -13,
  "53922": 20,
  "53923": -2,
  "53924": -11,
  "53925": -2,
  "53926": -8,
  "53927": -13,
  "53928": -2,
  "53929": -9,
  "53930": -13,
  "53931": -8,
  "53932": -2,
  "53933": 11,
  "53934": -13,
  "53935": -6,
  "53936": -12,
  "53937": -9,
  "53939": -8,
  "53940": 2,
  "53941": 2,
  "53942": -11,
  "53943": 2,
  "53944": -8,
  "53946": -8,
  "53947": -8,
  "53948": -9,
  "53949": -15,
  "53950": -9,
  "53951": 2,
  "53952": -13,
  "53953": -13,
  "53954": -2,
  "53955": -2,
  "53956": -2,
  "53959": 2,
  "53960": -2,
  "53961": 2,
  "53962": -9,
  "53963": 2,
  "53964": -12,
  "53965": 2,
  "53968": -9,
  "53969": -2,
  "54001": -6,
  "54002": -1,
  "54003": -2,
  "54004": -4,
  "54005": -7,
  "54006": -6,
  "54007": -1,
  "54009": -6,
  "54010": -2,
  "54011": -2,
  "54013": -1,
  "54014": -2,
  "54015": -1,
  "54016": 8,
  "54017": -1,
  "54020": -6,
  "54021": -2,
  "54022": -2,
  "54023": -1,
  "54024": -6,
  "54025": 0,
  "54026": -1,
  "54027": 7,
  "54028": 7,
  "54082": 8,
  "54101": -10,
  "54102": -9,
  "54103": -13,
  "54104": -9,
  "54106": 10,
  "54107": -4,
  "54110": -3,
  "54111": -10,
  "54112": -10,
  "54113": 10,
  "54114": -9,
  "54115": 4,
  "54119": -13,
  "54120": -13,
  "54121": -13,
  "54123": -3,
  "54124": -10,
  "54125": -13,
  "54126": 4,
  "54127": -10,
  "54128": -4,
  "54129": -2,
  "54130": 10,
  "54131": 10,
  "54135": -4,
  "54136": 9,
  "54137": -10,
  "54138": -10,
  "54139": -10,
  "54140": 10,
  "54141": 5,
  "54143": -2,
  "54149": -10,
  "54150": -4,
  "54151": -13,
  "54152": 9,
  "54153": -10,
  "54154": -10,
  "54155": 4,
  "54156": -9,
  "54157": -9,
  "54159": -9,
  "54160": -3,
  "54161": -10,
  "54162": 4,
  "54165": 10,
  "54166": -4,
  "54169": 6,
  "54170": 10,
  "54171": 4,
  "54173": 5,
  "54174": -10,
  "54175": -17,
  "54177": -9,
  "54180": 10,
  "54182": -4,
  "54201": -6,
  "54202": 7,
  "54204": -5,
  "54205": -5,
  "54207": -6,
  "54208": 4,
  "54209": 7,
  "54210": 7,
  "54211": 7,
  "54212": 7,
  "54213": -6,
  "54214": -6,
  "54215": -6,
  "54216": -6,
  "54217": -5,
  "54220": -7,
  "54221": -7,
  "54226": -6,
  "54227": -6,
  "54228": -6,
  "54229": -5,
  "54230": -6,
  "54232": -7,
  "54234": 7,
  "54235": -1,
  "54240": -6,
  "54241": -7,
  "54245": -7,
  "54246": -1,
  "54247": -6,
  "54301": 4,
  "54302": 3,
  "54303": 3,
  "54304": 4,
  "54305": 4,
  "54306": 3,
  "54307": 4,
  "54308": 4,
  "54311": 4,
  "54313": 4,
  "54324": 4,
  "54401": -1,
  "54402": -2,
  "54403": -1,
  "54405": -2,
  "54406": -4,
  "54407": -4,
  "54408": -9,
  "54409": -9,
  "54410": -3,
  "54411": -1,
  "54412": -3,
  "54413": -3,
  "54414": -9,
  "54415": -3,
  "54416": -4,
  "54417": -2,
  "54418": -9,
  "54420": -7,
  "54421": -7,
  "54422": -2,
  "54423": -3,
  "54424": -9,
  "54425": -2,
  "54426": -1,
  "54427": -4,
  "54428": -9,
  "54429": -4,
  "54430": -9,
  "54432": -4,
  "54433": -3,
  "54434": -8,
  "54435": -7,
  "54436": -7,
  "54437": -7,
  "54439": -3,
  "54440": -1,
  "54441": -3,
  "54442": -7,
  "54443": -4,
  "54446": -7,
  "54447": -3,
  "54448": -1,
  "54449": -3,
  "54450": -9,
  "54451": -2,
  "54452": -7,
  "54454": -3,
  "54455": -1,
  "54456": -8,
  "54457": -3,
  "54458": -4,
  "54459": -6,
  "54460": -7,
  "54462": -9,
  "54463": -9,
  "54464": -9,
  "54465": -9,
  "54466": -3,
  "54467": -4,
  "54469": -3,
  "54470": -2,
  "54471": 1,
  "54473": -4,
  "54474": -1,
  "54475": -3,
  "54476": -1,
  "54479": -7,
  "54480": -2,
  "54481": -4,
  "54482": -4,
  "54484": -1,
  "54485": -9,
  "54486": -4,
  "54487": -7,
  "54488": -7,
  "54489": -3,
  "54490": -2,
  "54491": -9,
  "54493": -7,
  "54494": -3,
  "54495": -3,
  "54498": -7,
  "54499": -4,
  "54501": -5,
  "54511": -17,
  "54512": -4,
  "54513": -6,
  "54514": -12,
  "54515": -6,
  "54517": -7,
  "54519": -4,
  "54520": -17,
  "54521": -5,
  "54524": -6,
  "54525": -13,
  "54526": -8,
  "54527": -8,
  "54529": -5,
  "54530": -6,
  "54531": 3,
  "54532": -7,
  "54534": -13,
  "54536": -13,
  "54537": -6,
  "54538": 3,
  "54539": -5,
  "54540": 3,
  "54541": -17,
  "54542": -13,
  "54543": -5,
  "54545": 3,
  "54546": -8,
  "54547": -12,
  "54548": 3,
  "54550": -13,
  "54552": -6,
  "54554": -5,
  "54555": -6,
  "54556": -6,
  "54557": 3,
  "54558": 3,
  "54559": -8,
  "54560": -5,
  "54561": -4,
  "54562": 3,
  "54563": -8,
  "54564": -6,
  "54565": -13,
  "54566": -17,
  "54568": -5,
  "54601": 1,
  "54602": 1,
  "54603": 1,
  "54610": -12,
  "54611": 6,
  "54612": -11,
  "54613": -13,
  "54614": 1,
  "54615": 6,
  "54616": -11,
  "54618": -9,
  "54619": -10,
  "54620": -1,
  "54621": -10,
  "54622": -11,
  "54623": 1,
  "54624": -13,
  "54625": -11,
  "54626": -13,
  "54627": -11,
  "54628": -13,
  "54629": -12,
  "54630": -11,
  "54631": -13,
  "54632": -10,
  "54634": -11,
  "54635": 7,
  "54636": 9,
  "54637": -10,
  "54638": -1,
  "54639": -10,
  "54640": -14,
  "54641": -1,
  "54642": 6,
  "54643": 6,
  "54644": 1,
  "54645": -14,
  "54646": -9,
  "54648": -1,
  "54649": -9,
  "54650": 9,
  "54651": -1,
  "54652": -10,
  "54653": 1,
  "54654": -14,
  "54655": -10,
  "54656": -1,
  "54657": -13,
  "54658": 9,
  "54659": -12,
  "54660": -1,
  "54661": 1,
  "54662": -1,
  "54664": -10,
  "54665": -10,
  "54666": -1,
  "54667": -10,
  "54669": 2,
  "54670": -1,
  "54701": 7,
  "54702": -1,
  "54703": -1,
  "54720": -1,
  "54721": -1,
  "54722": -1,
  "54723": -2,
  "54724": 1,
  "54725": -2,
  "54726": 1,
  "54727": 1,
  "54728": -4,
  "54729": 1,
  "54730": -2,
  "54731": -8,
  "54732": 0,
  "54733": -5,
  "54734": -2,
  "54735": -1,
  "54736": -1,
  "54737": -1,
  "54738": 0,
  "54739": 0,
  "54740": -1,
  "54741": 6,
  "54742": -1,
  "54743": -12,
  "54745": -7,
  "54746": 6,
  "54747": -11,
  "54748": 1,
  "54749": -2,
  "54750": -2,
  "54751": -2,
  "54754": 6,
  "54755": -12,
  "54756": -1,
  "54757": 1,
  "54758": -11,
  "54759": 0,
  "54760": -11,
  "54761": -1,
  "54762": -4,
  "54763": -2,
  "54764": -12,
  "54765": -2,
  "54766": -8,
  "54767": -3,
  "54768": 0,
  "54769": 8,
  "54770": -11,
  "54771": -8,
  "54772": -2,
  "54773": -11,
  "54801": -12,
  "54805": -5,
  "54806": 0,
  "54810": -6,
  "54812": -4,
  "54813": -4,
  "54814": 1,
  "54816": 1,
  "54817": -4,
  "54818": -4,
  "54819": -8,
  "54820": 1,
  "54821": -7,
  "54822": -4,
  "54824": -6,
  "54826": -7,
  "54827": 1,
  "54828": -12,
  "54829": -4,
  "54830": -12,
  "54832": 1,
  "54834": -11,
  "54835": -12,
  "54836": 4,
  "54837": -10,
  "54838": 4,
  "54839": 0,
  "54840": -10,
  "54841": -5,
  "54842": 4,
  "54843": -12,
  "54844": 1,
  "54845": -12,
  "54846": -8,
  "54847": 1,
  "54848": -8,
  "54849": 4,
  "54850": 9,
  "54853": -6,
  "54854": 4,
  "54855": -8,
  "54856": 1,
  "54857": -4,
  "54858": -6,
  "54859": -14,
  "54861": -8,
  "54862": -12,
  "54864": 4,
  "54865": 0,
  "54867": -12,
  "54868": -4,
  "54870": -5,
  "54871": -12,
  "54872": -12,
  "54873": 4,
  "54874": 4,
  "54875": -14,
  "54876": -12,
  "54880": 4,
  "54888": -14,
  "54889": -7,
  "54890": -14,
  "54891": 1,
  "54893": -12,
  "54895": -8,
  "54896": -11,
  "54901": 6,
  "54902": 15,
  "54903": 6,
  "54904": 15,
  "54909": -14,
  "54911": 9,
  "54912": 10,
  "54913": 10,
  "54914": 10,
  "54915": 9,
  "54921": -4,
  "54922": -9,
  "54923": -8,
  "54926": -4,
  "54927": 6,
  "54928": -4,
  "54929": -4,
  "54930": -13,
  "54931": 10,
  "54932": 3,
  "54933": -4,
  "54934": 6,
  "54935": 2,
  "54936": 2,
  "54937": 2,
  "54940": -8,
  "54941": -7,
  "54942": 18,
  "54943": -13,
  "54944": 10,
  "54945": -9,
  "54946": -9,
  "54947": 9,
  "54948": -4,
  "54949": -9,
  "54950": -4,
  "54952": 9,
  "54956": 7,
  "54957": 7,
  "54960": -14,
  "54961": -9,
  "54962": -9,
  "54963": 6,
  "54964": 7,
  "54965": -14,
  "54966": -14,
  "54967": -14,
  "54968": -8,
  "54969": -8,
  "54970": -14,
  "54971": -8,
  "54974": 2,
  "54976": -14,
  "54977": -8,
  "54978": -4,
  "54979": 2,
  "54980": 6,
  "54981": -9,
  "54982": -14,
  "54983": -9,
  "54984": -14,
  "54985": 6,
  "54986": 7,
  "55001": 17,
  "55002": 0,
  "55003": 8,
  "55005": 30,
  "55006": 29,
  "55007": -9,
  "55008": 30,
  "55009": 1,
  "55010": 25,
  "55011": 7,
  "55012": 0,
  "55013": 0,
  "55014": 7,
  "55016": 26,
  "55017": 29,
  "55018": -2,
  "55019": -2,
  "55020": 9,
  "55021": -2,
  "55024": 26,
  "55025": 0,
  "55026": -11,
  "55027": 1,
  "55029": 30,
  "55030": -1,
  "55031": 26,
  "55032": -1,
  "55033": 26,
  "55036": -1,
  "55037": -9,
  "55038": 8,
  "55040": 30,
  "55041": -11,
  "55042": 17,
  "55043": 8,
  "55044": 26,
  "55045": 0,
  "55046": -2,
  "55047": 17,
  "55049": 0,
  "55051": -1,
  "55052": -2,
  "55053": 6,
  "55054": 9,
  "55055": 25,
  "55056": -1,
  "55057": -2,
  "55060": 0,
  "55063": -1,
  "55065": 26,
  "55066": 1,
  "55067": -1,
  "55068": 26,
  "55069": -1,
  "55070": 30,
  "55071": 25,
  "55072": -9,
  "55073": 1,
  "55074": 0,
  "55075": 16,
  "55076": 25,
  "55077": 26,
  "55078": 0,
  "55079": 0,
  "55080": 29,
  "55082": 8,
  "55083": 8,
  "55084": -1,
  "55085": 25,
  "55087": -2,
  "55088": 9,
  "55089": 1,
  "55090": 8,
  "55092": 0,
  "55101": 16,
  "55102": 16,
  "55103": 16,
  "55104": 16,
  "55105": 17,
  "55106": 16,
  "55107": 16,
  "55108": 17,
  "55109": 16,
  "55110": 8,
  "55111": 16,
  "55112": 17,
  "55113": 17,
  "55114": 17,
  "55115": 17,
  "55116": 17,
  "55117": 16,
  "55118": 17,
  "55119": 16,
  "55120": 27,
  "55121": 26,
  "55122": 26,
  "55123": 27,
  "55124": 26,
  "55125": 17,
  "55126": 17,
  "55127": 17,
  "55128": 8,
  "55129": 17,
  "55130": 16,
  "55150": 16,
  "55164": 16,
  "55165": 16,
  "55166": 16,
  "55172": 16,
  "55175": 16,
  "55301": 3,
  "55302": 3,
  "55303": 7,
  "55304": 7,
  "55305": 20,
  "55306": 26,
  "55307": -7,
  "55308": 8,
  "55309": 8,
  "55310": -10,
  "55311": 20,
  "55312": -1,
  "55313": 10,
  "55314": -10,
  "55315": 9,
  "55316": 7,
  "55317": 11,
  "55318": 9,
  "55319": 8,
  "55320": 1,
  "55321": 2,
  "55322": 9,
  "55323": 21,
  "55324": -5,
  "55325": -5,
  "55327": 7,
  "55328": 3,
  "55329": -5,
  "55330": 0,
  "55331": 18,
  "55332": -10,
  "55333": -10,
  "55334": -7,
  "55335": -7,
  "55336": -1,
  "55337": 26,
  "55338": -7,
  "55339": 9,
  "55340": 28,
  "55341": 3,
  "55342": -10,
  "55343": 20,
  "55344": 20,
  "55345": 20,
  "55346": 20,
  "55347": 17,
  "55348": 9,
  "55349": 2,
  "55350": -2,
  "55352": 9,
  "55353": -5,
  "55354": -1,
  "55355": -5,
  "55356": 21,
  "55357": 11,
  "55358": 2,
  "55359": 9,
  "55360": 9,
  "55361": 9,
  "55362": 8,
  "55363": 3,
  "55364": 9,
  "55365": 8,
  "55366": -7,
  "55367": 9,
  "55368": 9,
  "55369": 7,
  "55370": -1,
  "55371": -1,
  "55372": 9,
  "55373": 3,
  "55374": 7,
  "55375": 9,
  "55376": 3,
  "55377": 8,
  "55378": 9,
  "55379": 9,
  "55380": 1,
  "55381": -2,
  "55382": 2,
  "55383": 9,
  "55384": 9,
  "55385": -2,
  "55386": 9,
  "55387": 9,
  "55388": 9,
  "55389": -5,
  "55390": 10,
  "55391": 31,
  "55392": 31,
  "55393": 9,
  "55394": 9,
  "55395": -1,
  "55396": -7,
  "55397": 9,
  "55398": 8,
  "55399": 9,
  "55401": 20,
  "55402": 20,
  "55403": 21,
  "55404": 20,
  "55405": 20,
  "55406": 17,
  "55407": 20,
  "55408": 20,
  "55409": 20,
  "55410": 20,
  "55411": 19,
  "55412": 19,
  "55413": 20,
  "55414": 17,
  "55415": 20,
  "55416": 20,
  "55417": 20,
  "55418": 20,
  "55419": 20,
  "55420": 26,
  "55421": 20,
  "55422": 20,
  "55423": 20,
  "55424": 28,
  "55425": 26,
  "55426": 20,
  "55427": 20,
  "55428": 20,
  "55429": 20,
  "55430": 20,
  "55431": 20,
  "55432": 7,
  "55433": 7,
  "55434": 7,
  "55435": 20,
  "55436": 28,
  "55437": 20,
  "55438": 20,
  "55439": 31,
  "55440": 20,
  "55441": 20,
  "55442": 21,
  "55443": 20,
  "55444": 7,
  "55445": 7,
  "55446": 28,
  "55447": 20,
  "55448": 7,
  "55449": 7,
  "55450": 20,
  "55454": 20,
  "55455": 20,
  "55458": 20,
  "55459": 20,
  "55460": 20,
  "55470": 20,
  "55473": 20,
  "55480": 20,
  "55550": 9,
  "55551": 9,
  "55552": 9,
  "55553": 9,
  "55554": 9,
  "55555": 9,
  "55556": 9,
  "55557": 9,
  "55559": 9,
  "55560": 9,
  "55561": 8,
  "55562": 9,
  "55563": 8,
  "55564": 9,
  "55565": 8,
  "55566": 9,
  "55567": 9,
  "55568": 9,
  "55569": 7,
  "55570": 9,
  "55571": 9,
  "55572": 9,
  "55573": 9,
  "55574": 9,
  "55575": 2,
  "55576": 9,
  "55577": 9,
  "55578": 9,
  "55579": 9,
  "55580": 8,
  "55581": 8,
  "55582": 8,
  "55583": 9,
  "55584": 8,
  "55585": 8,
  "55586": 8,
  "55587": 8,
  "55588": 8,
  "55589": 8,
  "55590": 8,
  "55591": 8,
  "55592": 9,
  "55593": 9,
  "55594": 9,
  "55595": 11,
  "55596": 11,
  "55597": 11,
  "55598": 11,
  "55599": 11,
  "55601": 3,
  "55602": 3,
  "55603": -13,
  "55604": -12,
  "55605": -13,
  "55606": -12,
  "55607": 3,
  "55609": 12,
  "55612": -4,
  "55613": -4,
  "55614": -13,
  "55615": -4,
  "55616": 4,
  "55701": 11,
  "55702": 11,
  "55703": 3,
  "55704": -9,
  "55705": 3,
  "55706": 3,
  "55707": 10,
  "55708": 3,
  "55709": 0,
  "55710": 4,
  "55711": 11,
  "55712": -9,
  "55713": 3,
  "55716": 0,
  "55717": 4,
  "55718": 10,
  "55719": 3,
  "55720": 11,
  "55721": 1,
  "55722": 0,
  "55723": 4,
  "55724": 4,
  "55725": 24,
  "55726": 11,
  "55730": 1,
  "55731": 4,
  "55732": 3,
  "55733": 11,
  "55734": 3,
  "55735": -9,
  "55736": 10,
  "55738": 3,
  "55741": 3,
  "55742": 0,
  "55744": 1,
  "55746": 3,
  "55747": 3,
  "55748": -9,
  "55749": 10,
  "55750": 3,
  "55751": 3,
  "55752": -9,
  "55753": 0,
  "55756": -9,
  "55757": 9,
  "55758": 3,
  "55760": -9,
  "55763": 3,
  "55764": 0,
  "55765": 3,
  "55766": 4,
  "55767": 10,
  "55768": 3,
  "55769": 0,
  "55771": 15,
  "55772": 15,
  "55775": 1,
  "55777": 3,
  "55779": 11,
  "55780": 10,
  "55781": 9,
  "55782": 3,
  "55783": -9,
  "55784": 1,
  "55785": -9,
  "55786": 0,
  "55787": -9,
  "55790": 5,
  "55791": 11,
  "55792": 3,
  "55793": 0,
  "55795": -9,
  "55796": 3,
  "55797": 10,
  "55798": 11,
  "55801": 4,
  "55802": 10,
  "55803": 4,
  "55804": 11,
  "55805": 10,
  "55806": 10,
  "55807": 10,
  "55808": 4,
  "55810": 11,
  "55811": 11,
  "55812": 11,
  "55814": 11,
  "55815": 10,
  "55816": 10,
  "55901": 5,
  "55902": 13,
  "55903": 13,
  "55904": 5,
  "55906": 6,
  "55909": -2,
  "55910": -3,
  "55912": -2,
  "55917": -1,
  "55918": -2,
  "55919": -2,
  "55920": 8,
  "55921": -2,
  "55922": -10,
  "55923": -8,
  "55924": 6,
  "55925": 1,
  "55926": -2,
  "55927": 6,
  "55929": 5,
  "55931": -2,
  "55932": -11,
  "55933": -2,
  "55934": 5,
  "55935": -8,
  "55936": -2,
  "55939": -9,
  "55940": 7,
  "55941": -2,
  "55942": -5,
  "55943": -2,
  "55944": 7,
  "55945": -11,
  "55946": -2,
  "55947": 9,
  "55949": -9,
  "55950": -2,
  "55951": -2,
  "55952": -3,
  "55953": -2,
  "55954": -10,
  "55955": 7,
  "55956": 1,
  "55957": -11,
  "55959": 4,
  "55960": 13,
  "55961": -2,
  "55962": -10,
  "55963": 8,
  "55964": -12,
  "55965": -9,
  "55967": 5,
  "55968": -11,
  "55969": -3,
  "55970": -2,
  "55971": -5,
  "55972": -3,
  "55973": -1,
  "55974": -3,
  "55975": -9,
  "55976": 5,
  "55977": -2,
  "55979": -3,
  "55981": -11,
  "55982": -2,
  "55983": 1,
  "55985": 6,
  "55987": -5,
  "55988": -5,
  "55990": -9,
  "55991": -11,
  "55992": 1,
  "56001": 2,
  "56002": 2,
  "56003": 2,
  "56006": 2,
  "56007": 0,
  "56009": 0,
  "56010": 1,
  "56011": 9,
  "56013": -4,
  "56014": -4,
  "56016": 0,
  "56017": -3,
  "56019": -6,
  "56020": 0,
  "56021": -3,
  "56022": -4,
  "56023": -4,
  "56024": 2,
  "56025": -4,
  "56026": -1,
  "56027": -4,
  "56028": -3,
  "56029": 0,
  "56030": -5,
  "56031": -6,
  "56032": 0,
  "56033": -4,
  "56034": 2,
  "56035": 0,
  "56036": 0,
  "56037": 2,
  "56039": -6,
  "56041": -6,
  "56042": 0,
  "56043": 0,
  "56044": -7,
  "56045": 0,
  "56046": -1,
  "56047": -4,
  "56048": -7,
  "56050": -3,
  "56051": -4,
  "56052": -3,
  "56054": -7,
  "56055": 2,
  "56056": -4,
  "56057": -3,
  "56058": -3,
  "56060": -4,
  "56062": -4,
  "56063": -3,
  "56065": 1,
  "56068": -4,
  "56069": -3,
  "56071": 9,
  "56072": -7,
  "56073": -5,
  "56074": -3,
  "56075": -6,
  "56078": -7,
  "56080": 2,
  "56081": -4,
  "56082": -3,
  "56083": -6,
  "56084": -5,
  "56085": -6,
  "56087": -6,
  "56088": -6,
  "56089": 0,
  "56090": 1,
  "56091": -7,
  "56093": -7,
  "56096": -3,
  "56097": -4,
  "56098": -4,
  "56101": -7,
  "56110": -8,
  "56111": -7,
  "56113": -5,
  "56114": -12,
  "56115": -8,
  "56116": -11,
  "56117": -8,
  "56118": -7,
  "56119": -8,
  "56120": -4,
  "56121": -7,
  "56122": -12,
  "56123": -7,
  "56125": -7,
  "56127": -7,
  "56128": -6,
  "56129": -11,
  "56131": -12,
  "56132": -7,
  "56134": -11,
  "56136": -5,
  "56137": -7,
  "56138": -11,
  "56139": -7,
  "56140": -7,
  "56141": -12,
  "56142": -5,
  "56143": -6,
  "56144": -7,
  "56145": -7,
  "56146": -11,
  "56147": -11,
  "56149": -5,
  "56150": -6,
  "56151": -12,
  "56152": -7,
  "56153": -11,
  "56155": -8,
  "56156": -11,
  "56157": -7,
  "56158": -11,
  "56159": -7,
  "56160": -4,
  "56161": -7,
  "56162": -4,
  "56164": -6,
  "56165": -8,
  "56166": -7,
  "56167": -6,
  "56168": -8,
  "56169": -7,
  "56170": -7,
  "56171": -6,
  "56172": -12,
  "56173": -11,
  "56174": -7,
  "56175": -8,
  "56176": -7,
  "56177": -7,
  "56178": -5,
  "56180": -7,
  "56181": -7,
  "56183": -7,
  "56185": -8,
  "56186": -7,
  "56187": -8,
  "56201": -1,
  "56207": 1,
  "56208": -11,
  "56209": -1,
  "56210": -8,
  "56211": -15,
  "56212": -11,
  "56214": -2,
  "56215": -10,
  "56216": -1,
  "56218": -1,
  "56219": -15,
  "56220": -15,
  "56221": 1,
  "56222": 13,
  "56223": -2,
  "56224": -7,
  "56225": -8,
  "56226": -10,
  "56227": -8,
  "56228": -5,
  "56229": 0,
  "56230": -10,
  "56231": -10,
  "56232": -11,
  "56235": 1,
  "56236": -15,
  "56237": -7,
  "56239": -7,
  "56240": -8,
  "56241": -2,
  "56243": -5,
  "56244": 1,
  "56245": -2,
  "56248": -12,
  "56249": -10,
  "56251": -1,
  "56252": -1,
  "56253": -1,
  "56255": -7,
  "56256": -11,
  "56257": -11,
  "56258": 1,
  "56260": 13,
  "56262": -11,
  "56263": -7,
  "56264": -1,
  "56265": 13,
  "56266": -7,
  "56267": 1,
  "56270": -10,
  "56271": -10,
  "56273": -1,
  "56274": -12,
  "56276": -8,
  "56277": -10,
  "56278": -8,
  "56279": -1,
  "56280": -5,
  "56281": -1,
  "56282": -1,
  "56283": -7,
  "56284": -1,
  "56285": 12,
  "56287": -7,
  "56288": 8,
  "56289": -1,
  "56291": -1,
  "56292": -7,
  "56293": -6,
  "56294": -7,
  "56295": 12,
  "56296": -15,
  "56297": -2,
  "56301": 4,
  "56302": 4,
  "56303": 4,
  "56304": 4,
  "56307": 21,
  "56308": 0,
  "56309": -11,
  "56310": 21,
  "56311": -11,
  "56312": -1,
  "56313": -1,
  "56314": -7,
  "56315": 0,
  "56316": -8,
  "56317": -7,
  "56318": -12,
  "56319": 0,
  "56320": 21,
  "56321": 21,
  "56323": 1,
  "56324": -11,
  "56325": 21,
  "56326": 0,
  "56327": 0,
  "56328": -8,
  "56329": 4,
  "56330": 0,
  "56331": 21,
  "56332": 0,
  "56333": 4,
  "56334": -8,
  "56335": 21,
  "56336": -12,
  "56338": 0,
  "56339": -11,
  "56340": 21,
  "56341": 0,
  "56342": -1,
  "56343": 0,
  "56344": -7,
  "56345": -7,
  "56347": -12,
  "56349": -8,
  "56350": -9,
  "56352": 21,
  "56353": 0,
  "56354": 0,
  "56355": 0,
  "56356": 20,
  "56357": 4,
  "56358": -1,
  "56359": 0,
  "56360": 0,
  "56361": 0,
  "56362": 21,
  "56363": 0,
  "56364": -7,
  "56367": 4,
  "56368": 21,
  "56369": 21,
  "56371": 21,
  "56373": -7,
  "56374": 21,
  "56375": 4,
  "56376": 21,
  "56377": 4,
  "56378": -12,
  "56379": 4,
  "56381": -8,
  "56382": -7,
  "56384": -7,
  "56385": -8,
  "56386": 0,
  "56387": 4,
  "56388": 4,
  "56389": 0,
  "56397": 4,
  "56398": 4,
  "56401": 0,
  "56425": 0,
  "56430": 0,
  "56431": -9,
  "56433": -10,
  "56434": -2,
  "56435": -8,
  "56436": -1,
  "56437": -12,
  "56438": -12,
  "56440": -12,
  "56441": 0,
  "56442": 9,
  "56443": -12,
  "56444": 0,
  "56446": -12,
  "56447": 0,
  "56448": -7,
  "56449": -7,
  "56450": 0,
  "56452": 1,
  "56453": -12,
  "56455": 0,
  "56456": 0,
  "56458": -10,
  "56459": 9,
  "56461": -10,
  "56464": -2,
  "56465": 1,
  "56466": -2,
  "56467": -1,
  "56468": 9,
  "56469": -9,
  "56470": -10,
  "56472": 1,
  "56473": 0,
  "56474": -8,
  "56475": -7,
  "56477": -2,
  "56478": -2,
  "56479": -2,
  "56481": -2,
  "56482": -2,
  "56484": 1,
  "56501": -6,
  "56502": -6,
  "56510": -17,
  "56511": -6,
  "56514": -1,
  "56515": -6,
  "56516": 31,
  "56517": 2,
  "56518": -2,
  "56519": -17,
  "56520": -13,
  "56521": -6,
  "56522": -13,
  "56523": 2,
  "56524": -8,
  "56525": -1,
  "56527": -2,
  "56528": -8,
  "56529": -1,
  "56531": -11,
  "56533": -13,
  "56534": -8,
  "56535": 2,
  "56536": -1,
  "56537": -8,
  "56538": -8,
  "56540": 2,
  "56541": -17,
  "56542": 14,
  "56543": -13,
  "56544": -6,
  "56545": -17,
  "56546": -16,
  "56547": -1,
  "56548": -17,
  "56549": -1,
  "56550": -17,
  "56551": -2,
  "56552": -2,
  "56553": -13,
  "56554": -6,
  "56556": 32,
  "56557": 31,
  "56560": -1,
  "56561": -1,
  "56562": -1,
  "56563": -1,
  "56565": -12,
  "56566": 31,
  "56567": -2,
  "56568": -17,
  "56569": -6,
  "56570": -6,
  "56571": -6,
  "56572": -8,
  "56573": -8,
  "56574": -17,
  "56575": -6,
  "56576": -6,
  "56577": -6,
  "56578": -6,
  "56579": -13,
  "56580": -1,
  "56581": -17,
  "56583": -15,
  "56584": -17,
  "56585": -17,
  "56586": -8,
  "56587": -8,
  "56588": -6,
  "56589": 31,
  "56590": -12,
  "56591": -6,
  "56592": 32,
  "56593": -6,
  "56594": -13,
  "56601": -1,
  "56619": -1,
  "56621": 13,
  "56623": 16,
  "56626": -8,
  "56627": 15,
  "56628": 0,
  "56629": 16,
  "56630": 0,
  "56631": 1,
  "56633": -1,
  "56634": 0,
  "56636": 0,
  "56637": 1,
  "56639": 1,
  "56641": -8,
  "56644": 14,
  "56646": 13,
  "56647": 8,
  "56649": 15,
  "56650": 0,
  "56651": 31,
  "56652": 0,
  "56653": 15,
  "56654": 15,
  "56655": -8,
  "56657": 0,
  "56658": 15,
  "56659": 0,
  "56660": -1,
  "56661": -1,
  "56662": 0,
  "56663": -1,
  "56666": -1,
  "56667": 0,
  "56668": 15,
  "56669": 16,
  "56670": 0,
  "56671": 0,
  "56672": -8,
  "56673": -14,
  "56676": 13,
  "56678": 13,
  "56679": 15,
  "56680": 0,
  "56681": -1,
  "56682": -14,
  "56683": 8,
  "56684": 13,
  "56685": 0,
  "56686": -15,
  "56687": -1,
  "56688": 0,
  "56701": -5,
  "56710": -1,
  "56711": -6,
  "56713": -3,
  "56714": -14,
  "56715": -6,
  "56716": 2,
  "56720": -13,
  "56721": 8,
  "56722": 8,
  "56723": 10,
  "56724": -14,
  "56725": -5,
  "56726": -14,
  "56727": -5,
  "56728": -12,
  "56729": -13,
  "56731": -13,
  "56732": -3,
  "56733": -13,
  "56734": -13,
  "56735": -13,
  "56736": 10,
  "56737": -3,
  "56738": -3,
  "56740": -13,
  "56741": -6,
  "56742": -6,
  "56744": -1,
  "56748": -6,
  "56750": 2,
  "56751": -13,
  "56754": -5,
  "56755": -13,
  "56756": -14,
  "56757": -3,
  "56758": -3,
  "56759": -14,
  "56760": -3,
  "56761": -14,
  "56762": -3,
  "56763": -14,
  "57001": 1,
  "57002": -6,
  "57003": 12,
  "57004": -8,
  "57005": 12,
  "57006": -5,
  "57010": 1,
  "57012": -6,
  "57013": -1,
  "57014": -8,
  "57015": -12,
  "57016": 0,
  "57017": -6,
  "57018": 0,
  "57020": 12,
  "57021": -12,
  "57022": 2,
  "57024": -6,
  "57025": 1,
  "57026": -6,
  "57027": 8,
  "57028": -6,
  "57029": -5,
  "57030": 12,
  "57031": -9,
  "57032": 8,
  "57033": 12,
  "57034": -1,
  "57035": 0,
  "57036": -12,
  "57037": -7,
  "57038": 1,
  "57039": -1,
  "57040": -7,
  "57041": 0,
  "57042": 0,
  "57043": -12,
  "57045": -6,
  "57046": -6,
  "57047": -6,
  "57048": -6,
  "57049": 6,
  "57050": 0,
  "57051": -13,
  "57052": -6,
  "57053": -12,
  "57054": 0,
  "57055": 12,
  "57057": -1,
  "57058": -6,
  "57059": -13,
  "57061": -7,
  "57062": -12,
  "57063": -12,
  "57064": 7,
  "57065": -6,
  "57066": -13,
  "57067": -7,
  "57068": 5,
  "57069": -9,
  "57070": -12,
  "57071": -6,
  "57072": -6,
  "57073": -8,
  "57075": 0,
  "57076": -11,
  "57077": 0,
  "57078": -6,
  "57101": 4,
  "57103": 12,
  "57104": 4,
  "57105": 12,
  "57106": 12,
  "57107": 3,
  "57108": 12,
  "57109": 12,
  "57110": 12,
  "57117": 4,
  "57118": 4,
  "57201": 0,
  "57212": -13,
  "57213": -15,
  "57214": -8,
  "57216": -8,
  "57217": -9,
  "57218": -15,
  "57219": -12,
  "57220": -6,
  "57221": -13,
  "57223": -8,
  "57224": -12,
  "57225": -9,
  "57226": -15,
  "57227": -8,
  "57231": -13,
  "57232": -8,
  "57233": -13,
  "57234": -8,
  "57235": 0,
  "57236": -9,
  "57237": -15,
  "57238": -15,
  "57239": -12,
  "57241": -8,
  "57242": -8,
  "57243": -1,
  "57245": 0,
  "57246": -5,
  "57247": -8,
  "57248": -8,
  "57249": -13,
  "57251": -5,
  "57252": -5,
  "57255": -13,
  "57256": -1,
  "57257": -13,
  "57258": -9,
  "57259": -5,
  "57260": -14,
  "57261": -12,
  "57262": -13,
  "57263": -1,
  "57264": -5,
  "57265": -5,
  "57266": -13,
  "57268": -15,
  "57269": -1,
  "57270": -8,
  "57271": -9,
  "57272": -1,
  "57273": -12,
  "57274": -12,
  "57276": -6,
  "57278": -9,
  "57279": -5,
  "57301": -4,
  "57311": -11,
  "57312": -7,
  "57313": -7,
  "57314": -7,
  "57315": -13,
  "57317": -7,
  "57319": -6,
  "57321": -11,
  "57322": -9,
  "57323": -11,
  "57324": -7,
  "57325": -15,
  "57328": -7,
  "57329": -13,
  "57330": -7,
  "57331": -4,
  "57332": -12,
  "57334": -4,
  "57335": -7,
  "57337": -11,
  "57339": -19,
  "57340": -11,
  "57341": -16,
  "57342": -7,
  "57344": -7,
  "57345": -8,
  "57346": -8,
  "57348": -7,
  "57349": -11,
  "57350": -6,
  "57353": -13,
  "57354": -6,
  "57355": -16,
  "57356": -7,
  "57358": -7,
  "57359": -7,
  "57361": -7,
  "57362": -9,
  "57363": -5,
  "57364": -7,
  "57365": -15,
  "57366": -5,
  "57367": -5,
  "57368": -15,
  "57369": -15,
  "57370": -16,
  "57371": -8,
  "57373": -9,
  "57374": -11,
  "57375": -15,
  "57376": -6,
  "57379": -7,
  "57380": -7,
  "57381": -9,
  "57382": -15,
  "57383": -15,
  "57384": -7,
  "57385": -7,
  "57386": -7,
  "57401": -6,
  "57402": -6,
  "57420": -8,
  "57421": -8,
  "57422": -12,
  "57424": -9,
  "57426": -6,
  "57427": -6,
  "57428": -9,
  "57429": -9,
  "57430": -8,
  "57432": -6,
  "57433": -6,
  "57434": -9,
  "57435": -9,
  "57436": -9,
  "57437": -15,
  "57438": -8,
  "57439": -6,
  "57440": -9,
  "57441": -9,
  "57442": -3,
  "57445": -6,
  "57446": -9,
  "57448": -15,
  "57449": -9,
  "57450": -8,
  "57451": -8,
  "57452": -9,
  "57454": -8,
  "57455": -9,
  "57456": -6,
  "57457": -15,
  "57460": -6,
  "57461": -9,
  "57465": -9,
  "57466": -9,
  "57467": -9,
  "57468": -13,
  "57469": -9,
  "57470": -9,
  "57471": -9,
  "57472": -8,
  "57473": -8,
  "57474": -6,
  "57475": -8,
  "57476": -9,
  "57477": -9,
  "57479": -6,
  "57481": -6,
  "57501": -3,
  "57520": -4,
  "57521": -22,
  "57522": -4,
  "57523": -15,
  "57528": -15,
  "57529": -15,
  "57531": -8,
  "57532": -8,
  "57533": -15,
  "57534": -19,
  "57536": -8,
  "57537": -8,
  "57538": -7,
  "57540": -8,
  "57541": -15,
  "57543": -22,
  "57544": -19,
  "57547": -22,
  "57548": -19,
  "57551": -16,
  "57552": -16,
  "57553": -16,
  "57555": -6,
  "57559": -8,
  "57560": -6,
  "57562": -16,
  "57563": -6,
  "57564": -3,
  "57566": -6,
  "57567": -16,
  "57568": -19,
  "57569": -19,
  "57570": -6,
  "57571": -7,
  "57572": -7,
  "57574": -16,
  "57576": -19,
  "57577": -22,
  "57579": -6,
  "57580": -15,
  "57584": -15,
  "57585": -15,
  "57601": -12,
  "57620": -10,
  "57621": -12,
  "57622": -7,
  "57623": -12,
  "57625": -8,
  "57626": -10,
  "57630": -12,
  "57631": -12,
  "57632": -15,
  "57633": -12,
  "57634": -10,
  "57636": -12,
  "57638": -2,
  "57639": -12,
  "57640": -9,
  "57641": -12,
  "57642": -12,
  "57644": -10,
  "57645": -12,
  "57646": -15,
  "57648": -12,
  "57649": -10,
  "57650": -10,
  "57651": -10,
  "57652": -12,
  "57656": -12,
  "57657": -12,
  "57658": -12,
  "57659": -12,
  "57660": -12,
  "57661": -12,
  "57701": -2,
  "57702": -1,
  "57703": -2,
  "57706": -2,
  "57709": -1,
  "57714": -16,
  "57716": -17,
  "57717": -14,
  "57718": -2,
  "57719": -2,
  "57720": -10,
  "57722": -6,
  "57724": -10,
  "57725": -1,
  "57730": -12,
  "57732": -8,
  "57735": -6,
  "57737": 2,
  "57738": -13,
  "57741": -8,
  "57744": -1,
  "57745": -7,
  "57747": -6,
  "57748": 4,
  "57750": -22,
  "57751": -12,
  "57752": -17,
  "57754": -8,
  "57755": -2,
  "57756": -17,
  "57758": -7,
  "57759": -7,
  "57760": -14,
  "57761": -2,
  "57762": -14,
  "57763": -6,
  "57764": -17,
  "57766": -6,
  "57767": -22,
  "57769": -1,
  "57770": -17,
  "57772": -17,
  "57773": -13,
  "57775": -22,
  "57776": -10,
  "57779": -8,
  "57780": -17,
  "57782": -6,
  "57783": -7,
  "57785": -8,
  "57787": -7,
  "57788": -14,
  "57790": -22,
  "57791": -22,
  "57792": 4,
  "57793": -8,
  "57794": -17,
  "58001": -13,
  "58002": 3,
  "58004": 3,
  "58005": 3,
  "58006": 3,
  "58007": 3,
  "58008": -7,
  "58009": 0,
  "58011": 3,
  "58012": 3,
  "58013": -3,
  "58015": -1,
  "58016": -2,
  "58017": -3,
  "58018": -6,
  "58021": 4,
  "58027": -3,
  "58029": 3,
  "58030": -7,
  "58031": -3,
  "58032": -3,
  "58033": -3,
  "58035": 0,
  "58036": 3,
  "58038": 0,
  "58040": -3,
  "58041": -7,
  "58042": 11,
  "58043": -3,
  "58045": 0,
  "58046": -2,
  "58047": 11,
  "58048": 0,
  "58049": -8,
  "58051": 3,
  "58052": 3,
  "58053": -7,
  "58054": -3,
  "58056": -2,
  "58057": -3,
  "58058": -7,
  "58059": 3,
  "58060": -3,
  "58061": -7,
  "58062": -3,
  "58063": -8,
  "58064": -2,
  "58065": -2,
  "58067": -3,
  "58068": -3,
  "58069": -3,
  "58071": -8,
  "58072": -8,
  "58074": -13,
  "58075": -13,
  "58077": -6,
  "58078": 11,
  "58079": 3,
  "58081": -7,
  "58102": 4,
  "58103": 4,
  "58104": 11,
  "58105": 4,
  "58106": 4,
  "58107": 11,
  "58108": 4,
  "58109": 11,
  "58201": 8,
  "58202": 1,
  "58203": 1,
  "58204": -1,
  "58205": -1,
  "58206": 8,
  "58208": 8,
  "58210": -8,
  "58212": -7,
  "58214": -1,
  "58216": -7,
  "58218": 0,
  "58219": 0,
  "58220": -6,
  "58222": -6,
  "58223": 0,
  "58224": -8,
  "58225": -6,
  "58227": -8,
  "58228": -1,
  "58229": -19,
  "58230": -2,
  "58231": -8,
  "58233": -8,
  "58235": -1,
  "58236": 2,
  "58237": -7,
  "58238": -6,
  "58239": -19,
  "58240": -2,
  "58241": -6,
  "58243": -8,
  "58244": -8,
  "58249": -18,
  "58250": -8,
  "58251": -1,
  "58254": -7,
  "58255": -18,
  "58256": -1,
  "58257": 0,
  "58258": -1,
  "58259": -7,
  "58260": -19,
  "58261": -7,
  "58262": -7,
  "58265": -7,
  "58266": -6,
  "58267": -1,
  "58269": -19,
  "58270": -7,
  "58271": -6,
  "58272": -7,
  "58273": -8,
  "58274": 0,
  "58275": 0,
  "58276": -7,
  "58277": -2,
  "58278": 8,
  "58281": -19,
  "58282": -7,
  "58301": -8,
  "58310": -17,
  "58311": -19,
  "58313": -5,
  "58316": -17,
  "58317": -17,
  "58318": -11,
  "58321": -9,
  "58323": -19,
  "58324": -8,
  "58325": -4,
  "58327": -8,
  "58329": -17,
  "58330": -9,
  "58331": -19,
  "58332": -5,
  "58335": -19,
  "58338": -19,
  "58339": -17,
  "58341": -19,
  "58343": -5,
  "58344": -6,
  "58345": -9,
  "58346": -4,
  "58348": -5,
  "58351": -4,
  "58352": -19,
  "58353": -17,
  "58355": -19,
  "58356": -19,
  "58357": -4,
  "58361": -7,
  "58362": -9,
  "58363": -17,
  "58365": -17,
  "58366": -17,
  "58367": -17,
  "58368": -5,
  "58369": -17,
  "58370": -19,
  "58372": -19,
  "58374": -19,
  "58377": -9,
  "58379": -19,
  "58380": -7,
  "58381": -19,
  "58382": -9,
  "58384": -18,
  "58385": -5,
  "58386": -5,
  "58401": 1,
  "58402": 1,
  "58413": -10,
  "58415": -15,
  "58416": -7,
  "58418": -19,
  "58420": 1,
  "58421": -11,
  "58422": -19,
  "58423": -19,
  "58424": 1,
  "58425": -2,
  "58426": -11,
  "58428": -14,
  "58429": -8,
  "58430": -19,
  "58431": -15,
  "58433": -15,
  "58436": -9,
  "58438": -19,
  "58439": -8,
  "58440": -15,
  "58441": -9,
  "58442": 1,
  "58443": -11,
  "58444": -19,
  "58445": -11,
  "58448": -2,
  "58451": -19,
  "58452": -7,
  "58454": -15,
  "58455": -11,
  "58456": -15,
  "58458": -15,
  "58460": -15,
  "58461": -8,
  "58463": 0,
  "58464": -11,
  "58466": -8,
  "58467": 1,
  "58472": -15,
  "58474": -9,
  "58475": -15,
  "58476": 1,
  "58477": -1,
  "58478": -15,
  "58479": -8,
  "58480": -8,
  "58481": -8,
  "58482": -14,
  "58483": -15,
  "58484": -11,
  "58486": -19,
  "58487": -15,
  "58488": -15,
  "58490": -3,
  "58492": 1,
  "58494": -2,
  "58495": -15,
  "58496": 1,
  "58497": 1,
  "58501": 7,
  "58502": 7,
  "58503": 7,
  "58504": 7,
  "58505": 7,
  "58506": 7,
  "58507": 7,
  "58520": -8,
  "58521": 7,
  "58523": 13,
  "58524": -1,
  "58528": -1,
  "58529": -8,
  "58530": -1,
  "58531": 0,
  "58532": -14,
  "58533": -11,
  "58535": -7,
  "58538": -10,
  "58540": 0,
  "58541": 10,
  "58542": -2,
  "58544": -2,
  "58545": 11,
  "58549": -1,
  "58552": -1,
  "58554": 7,
  "58558": 7,
  "58559": 0,
  "58560": -1,
  "58561": -14,
  "58562": -11,
  "58563": -7,
  "58564": -10,
  "58565": 0,
  "58566": 1,
  "58568": -10,
  "58569": -10,
  "58570": -1,
  "58571": -1,
  "58572": -1,
  "58573": -1,
  "58575": 0,
  "58576": 0,
  "58577": 8,
  "58579": -1,
  "58580": 10,
  "58581": -10,
  "58601": 13,
  "58602": 13,
  "58620": -4,
  "58621": -9,
  "58622": -3,
  "58623": -1,
  "58625": 10,
  "58626": 4,
  "58627": -3,
  "58630": 6,
  "58631": -10,
  "58632": -9,
  "58634": -3,
  "58636": 10,
  "58638": 4,
  "58639": -1,
  "58640": -3,
  "58641": 13,
  "58642": 6,
  "58643": -1,
  "58644": 10,
  "58645": -3,
  "58646": -2,
  "58647": 4,
  "58649": -2,
  "58650": -2,
  "58651": -1,
  "58652": 4,
  "58653": -1,
  "58654": -9,
  "58655": 4,
  "58656": 4,
  "58701": 4,
  "58702": 4,
  "58703": 4,
  "58704": 4,
  "58705": 4,
  "58710": -5,
  "58711": -11,
  "58712": -9,
  "58713": -11,
  "58716": 2,
  "58718": -4,
  "58721": 6,
  "58722": 4,
  "58723": 0,
  "58725": -5,
  "58727": 6,
  "58730": 6,
  "58731": -9,
  "58733": -4,
  "58734": -3,
  "58735": 0,
  "58736": -9,
  "58737": 6,
  "58740": -4,
  "58741": -9,
  "58744": -9,
  "58746": 6,
  "58748": -11,
  "58750": -4,
  "58752": 6,
  "58755": 6,
  "58756": -4,
  "58757": -3,
  "58758": -19,
  "58759": 0,
  "58760": -11,
  "58761": -11,
  "58762": -11,
  "58763": -3,
  "58765": 6,
  "58768": 0,
  "58769": -3,
  "58770": -3,
  "58771": -3,
  "58772": 6,
  "58773": 6,
  "58775": 0,
  "58776": -3,
  "58778": 2,
  "58779": 0,
  "58781": -4,
  "58782": 6,
  "58783": -11,
  "58784": -3,
  "58785": 4,
  "58787": 6,
  "58788": -9,
  "58789": -11,
  "58790": -9,
  "58792": -9,
  "58793": -11,
  "58794": 16,
  "58795": 15,
  "58801": 16,
  "58802": 16,
  "58830": 15,
  "58831": 16,
  "58833": 15,
  "58835": 16,
  "58838": 16,
  "58843": 16,
  "58844": 15,
  "58845": 15,
  "58847": -3,
  "58849": 16,
  "58852": 16,
  "58853": 16,
  "58854": 16,
  "58856": 16,
  "59001": -10,
  "59002": 0,
  "59003": -12,
  "59006": 0,
  "59007": -10,
  "59008": -10,
  "59010": -17,
  "59011": -12,
  "59012": -12,
  "59013": -10,
  "59014": -10,
  "59015": 0,
  "59016": -1,
  "59018": -5,
  "59019": -10,
  "59020": -10,
  "59022": -1,
  "59024": 0,
  "59025": -12,
  "59026": -10,
  "59027": 6,
  "59028": -10,
  "59029": -10,
  "59030": -5,
  "59031": 0,
  "59032": -9,
  "59033": -12,
  "59034": 0,
  "59035": 0,
  "59036": -8,
  "59037": 0,
  "59038": -17,
  "59039": -15,
  "59041": -10,
  "59043": -12,
  "59044": 0,
  "59046": 0,
  "59047": -5,
  "59050": 0,
  "59052": -1,
  "59053": -8,
  "59054": -17,
  "59055": -12,
  "59057": 0,
  "59058": -5,
  "59059": -16,
  "59061": -12,
  "59062": -12,
  "59063": -10,
  "59064": 0,
  "59065": -5,
  "59066": -10,
  "59067": -12,
  "59068": -10,
  "59069": -12,
  "59070": -10,
  "59071": -10,
  "59072": -16,
  "59073": -16,
  "59074": -8,
  "59075": 0,
  "59076": -12,
  "59077": -8,
  "59078": -8,
  "59079": 0,
  "59081": -10,
  "59082": -1,
  "59083": -15,
  "59084": -9,
  "59085": -8,
  "59086": -5,
  "59087": -5,
  "59088": 0,
  "59089": 0,
  "59101": 0,
  "59102": 0,
  "59103": 0,
  "59104": 0,
  "59105": 0,
  "59106": 0,
  "59107": 0,
  "59108": 0,
  "59201": -19,
  "59211": -20,
  "59212": -4,
  "59213": -11,
  "59214": -16,
  "59215": -16,
  "59217": -4,
  "59218": -20,
  "59219": 15,
  "59221": -4,
  "59222": -20,
  "59223": -10,
  "59225": -11,
  "59226": -20,
  "59230": -10,
  "59231": -11,
  "59240": -11,
  "59241": -11,
  "59242": -11,
  "59243": -4,
  "59244": -11,
  "59247": -20,
  "59248": -11,
  "59250": -11,
  "59252": -20,
  "59253": -11,
  "59254": -20,
  "59255": -20,
  "59256": -20,
  "59257": -20,
  "59258": -20,
  "59259": -4,
  "59260": -11,
  "59261": -11,
  "59262": -4,
  "59263": -20,
  "59270": -4,
  "59273": -11,
  "59274": -16,
  "59275": 15,
  "59276": -20,
  "59301": -12,
  "59311": -14,
  "59312": -12,
  "59313": -2,
  "59314": -13,
  "59315": -12,
  "59316": -10,
  "59317": -12,
  "59318": -10,
  "59319": -14,
  "59322": -15,
  "59323": -12,
  "59324": -2,
  "59326": -15,
  "59327": -12,
  "59330": -12,
  "59332": -10,
  "59333": -12,
  "59336": 0,
  "59337": -16,
  "59338": -12,
  "59339": -12,
  "59341": -15,
  "59343": -12,
  "59344": -2,
  "59345": -12,
  "59347": -12,
  "59349": -15,
  "59351": -12,
  "59353": -9,
  "59354": -1,
  "59401": -2,
  "59402": -2,
  "59403": -1,
  "59404": -1,
  "59405": -1,
  "59406": -1,
  "59410": -12,
  "59411": -6,
  "59412": -2,
  "59414": -2,
  "59416": -12,
  "59417": -10,
  "59418": -8,
  "59419": -4,
  "59420": -3,
  "59421": -1,
  "59422": -12,
  "59424": 10,
  "59425": -10,
  "59427": 39,
  "59430": 2,
  "59432": -10,
  "59433": -12,
  "59434": -10,
  "59435": 39,
  "59436": -12,
  "59440": -2,
  "59441": -8,
  "59442": -3,
  "59443": -12,
  "59444": 39,
  "59446": -3,
  "59447": 2,
  "59448": -10,
  "59450": -3,
  "59451": -9,
  "59452": 2,
  "59453": -8,
  "59454": 39,
  "59456": -10,
  "59457": -9,
  "59460": -3,
  "59461": 39,
  "59462": 2,
  "59463": 2,
  "59464": -9,
  "59465": 2,
  "59466": 39,
  "59467": -10,
  "59468": -1,
  "59469": 2,
  "59471": -9,
  "59472": -2,
  "59474": 39,
  "59477": -12,
  "59479": 2,
  "59480": -2,
  "59482": 39,
  "59483": -1,
  "59484": 39,
  "59485": -1,
  "59486": -10,
  "59487": -1,
  "59489": -9,
  "59501": -4,
  "59520": -3,
  "59521": -4,
  "59522": 39,
  "59523": -14,
  "59524": -11,
  "59525": -4,
  "59526": -14,
  "59527": -14,
  "59528": -4,
  "59529": -14,
  "59530": -4,
  "59531": -4,
  "59532": -4,
  "59535": -14,
  "59537": -11,
  "59538": -11,
  "59540": -4,
  "59542": -14,
  "59544": -11,
  "59545": 39,
  "59546": -14,
  "59547": -14,
  "59601": -3,
  "59602": -3,
  "59604": -3,
  "59620": -3,
  "59624": -3,
  "59626": -3,
  "59631": -8,
  "59632": -9,
  "59633": -3,
  "59634": 5,
  "59635": -3,
  "59636": -3,
  "59638": -9,
  "59639": -10,
  "59640": -3,
  "59641": -8,
  "59642": -8,
  "59643": -8,
  "59644": -9,
  "59645": -9,
  "59647": -9,
  "59648": -3,
  "59701": -7,
  "59702": -7,
  "59703": -7,
  "59710": -2,
  "59711": -2,
  "59713": -3,
  "59714": 6,
  "59715": 6,
  "59716": 6,
  "59717": 6,
  "59718": 6,
  "59719": 6,
  "59720": -3,
  "59721": -8,
  "59722": -2,
  "59724": -8,
  "59725": -6,
  "59727": -7,
  "59728": -3,
  "59729": -1,
  "59730": 8,
  "59731": -11,
  "59732": -7,
  "59733": -9,
  "59735": -2,
  "59736": -6,
  "59739": -8,
  "59740": 6,
  "59741": 14,
  "59743": -7,
  "59745": 6,
  "59746": 3,
  "59747": -3,
  "59748": -7,
  "59749": -2,
  "59750": -7,
  "59751": -7,
  "59752": 6,
  "59754": -2,
  "59755": -2,
  "59756": -2,
  "59758": -13,
  "59759": -8,
  "59760": 6,
  "59761": -6,
  "59762": -2,
  "59771": 6,
  "59772": 6,
  "59801": 0,
  "59802": 0,
  "59803": 0,
  "59804": 0,
  "59806": -1,
  "59807": 0,
  "59808": 0,
  "59820": 0,
  "59821": -1,
  "59823": 0,
  "59824": -11,
  "59825": -1,
  "59826": -11,
  "59827": -8,
  "59828": -8,
  "59829": -8,
  "59830": -5,
  "59831": -12,
  "59832": -11,
  "59833": 0,
  "59834": 0,
  "59835": -8,
  "59837": -11,
  "59840": -8,
  "59841": -8,
  "59842": -5,
  "59843": -10,
  "59844": -11,
  "59845": -5,
  "59846": -14,
  "59847": 0,
  "59848": -5,
  "59851": -1,
  "59853": -11,
  "59854": 0,
  "59855": -12,
  "59856": -5,
  "59858": -11,
  "59859": -5,
  "59860": -11,
  "59863": -12,
  "59864": -12,
  "59865": -12,
  "59866": -14,
  "59867": -5,
  "59868": -1,
  "59870": -8,
  "59871": -8,
  "59872": -14,
  "59873": -5,
  "59874": -6,
  "59875": -8,
  "59901": -5,
  "59903": -5,
  "59904": -5,
  "59910": -11,
  "59911": -11,
  "59912": -5,
  "59913": -5,
  "59914": -3,
  "59915": -11,
  "59916": -4,
  "59917": -11,
  "59918": -10,
  "59919": -5,
  "59920": -4,
  "59921": -4,
  "59922": -4,
  "59923": -11,
  "59925": -4,
  "59926": -5,
  "59927": -5,
  "59928": -4,
  "59929": -12,
  "59930": -11,
  "59931": -3,
  "59932": -4,
  "59933": -10,
  "59934": -10,
  "59935": -11,
  "59936": -4,
  "59937": -4,
  "60001": 6,
  "60002": 0,
  "60004": 10,
  "60005": 17,
  "60006": 9,
  "60007": 16,
  "60008": 16,
  "60009": 16,
  "60010": 20,
  "60011": 6,
  "60012": 7,
  "60013": 7,
  "60014": 6,
  "60015": 11,
  "60016": 15,
  "60017": 15,
  "60018": 15,
  "60020": 6,
  "60021": 6,
  "60022": 21,
  "60025": 16,
  "60026": 16,
  "60029": 20,
  "60030": 8,
  "60031": 8,
  "60033": 2,
  "60034": 6,
  "60035": 11,
  "60037": 19,
  "60039": 6,
  "60040": 8,
  "60041": 8,
  "60042": 6,
  "60043": 27,
  "60044": 11,
  "60045": 19,
  "60046": 8,
  "60047": 11,
  "60048": 8,
  "60050": 6,
  "60051": 6,
  "60053": 16,
  "60056": 17,
  "60060": 8,
  "60061": 8,
  "60062": 12,
  "60064": 8,
  "60065": 19,
  "60067": 9,
  "60068": 15,
  "60069": 11,
  "60070": 9,
  "60071": 14,
  "60072": 6,
  "60073": 8,
  "60074": 8,
  "60075": 8,
  "60076": 16,
  "60077": 15,
  "60078": 9,
  "60079": 8,
  "60081": 6,
  "60082": 12,
  "60083": 8,
  "60084": 8,
  "60085": 8,
  "60087": 8,
  "60088": 8,
  "60089": 8,
  "60090": 9,
  "60091": 18,
  "60092": 9,
  "60093": 27,
  "60094": 17,
  "60095": 16,
  "60096": 0,
  "60097": 6,
  "60098": 6,
  "60099": 8,
  "60101": 16,
  "60102": 6,
  "60103": 7,
  "60104": 15,
  "60106": 17,
  "60107": 7,
  "60108": 17,
  "60109": 8,
  "60110": 6,
  "60111": 9,
  "60112": 8,
  "60113": 8,
  "60115": 8,
  "60118": 8,
  "60119": 8,
  "60120": 7,
  "60121": 7,
  "60123": 7,
  "60124": 7,
  "60126": 17,
  "60129": 8,
  "60130": 15,
  "60131": 15,
  "60133": 7,
  "60134": 8,
  "60135": 8,
  "60136": 8,
  "60137": 17,
  "60138": 17,
  "60139": 16,
  "60140": 8,
  "60141": 15,
  "60142": 7,
  "60143": 17,
  "60144": 8,
  "60145": 12,
  "60146": 4,
  "60147": 8,
  "60148": 16,
  "60150": 8,
  "60151": 17,
  "60152": 3,
  "60153": 15,
  "60154": 15,
  "60155": 15,
  "60156": 6,
  "60157": 17,
  "60159": 16,
  "60160": 15,
  "60161": 15,
  "60162": 15,
  "60163": 15,
  "60164": 15,
  "60165": 15,
  "60168": 16,
  "60169": 16,
  "60170": 7,
  "60171": 15,
  "60172": 16,
  "60173": 16,
  "60174": 8,
  "60175": 18,
  "60176": 15,
  "60177": 7,
  "60178": 8,
  "60180": 7,
  "60181": 17,
  "60183": 18,
  "60184": 19,
  "60185": 7,
  "60186": 7,
  "60187": 17,
  "60188": 16,
  "60189": 17,
  "60190": 17,
  "60191": 17,
  "60192": 17,
  "60193": 16,
  "60194": 16,
  "60195": 17,
  "60197": 16,
  "60199": 16,
  "60201": 16,
  "60202": 15,
  "60203": 16,
  "60204": 16,
  "60301": 15,
  "60302": 15,
  "60303": 15,
  "60304": 15,
  "60305": 26,
  "60401": 8,
  "60402": 15,
  "60403": 15,
  "60404": 9,
  "60406": 13,
  "60407": 13,
  "60408": 14,
  "60409": 5,
  "60410": 9,
  "60411": 5,
  "60412": 5,
  "60415": 15,
  "60416": 14,
  "60417": 6,
  "60419": 5,
  "60420": -2,
  "60421": 9,
  "60422": 13,
  "60423": 9,
  "60424": 13,
  "60425": 5,
  "60426": 5,
  "60428": 5,
  "60429": 5,
  "60430": 5,
  "60431": 9,
  "60432": 8,
  "60433": 8,
  "60434": 8,
  "60435": 8,
  "60436": 8,
  "60437": 14,
  "60438": 5,
  "60439": 16,
  "60440": 16,
  "60441": 9,
  "60442": 9,
  "60443": 7,
  "60444": 14,
  "60445": 13,
  "60446": 9,
  "60447": 14,
  "60448": 9,
  "60449": 9,
  "60450": 14,
  "60451": 9,
  "60452": 7,
  "60453": 15,
  "60454": 15,
  "60455": 15,
  "60456": 15,
  "60457": 15,
  "60458": 15,
  "60459": 15,
  "60460": -2,
  "60461": 14,
  "60462": 9,
  "60463": 15,
  "60464": 15,
  "60465": 15,
  "60466": 5,
  "60467": 17,
  "60468": 8,
  "60469": 13,
  "60470": 6,
  "60471": 7,
  "60472": 13,
  "60473": 5,
  "60474": 13,
  "60475": 5,
  "60476": 5,
  "60477": 9,
  "60478": 7,
  "60479": 14,
  "60480": 15,
  "60481": 14,
  "60482": 15,
  "60484": 5,
  "60487": 9,
  "60490": 16,
  "60491": 9,
  "60499": 15,
  "60501": 15,
  "60502": 16,
  "60503": 16,
  "60504": 16,
  "60505": 0,
  "60506": 0,
  "60507": 7,
  "60510": 8,
  "60511": 0,
  "60512": 0,
  "60513": 15,
  "60514": 17,
  "60515": 16,
  "60516": 17,
  "60517": 16,
  "60518": 6,
  "60519": 16,
  "60520": 16,
  "60521": 17,
  "60522": 28,
  "60523": 17,
  "60525": 15,
  "60526": 15,
  "60527": 28,
  "60530": 8,
  "60531": 0,
  "60532": 16,
  "60534": 15,
  "60536": 0,
  "60537": 0,
  "60538": 0,
  "60539": 7,
  "60540": 18,
  "60541": 0,
  "60542": 7,
  "60543": 0,
  "60544": 9,
  "60545": 0,
  "60546": 15,
  "60548": 0,
  "60549": 6,
  "60550": 8,
  "60551": 0,
  "60552": 1,
  "60553": 8,
  "60554": 0,
  "60555": 16,
  "60556": 8,
  "60557": 6,
  "60558": 26,
  "60559": 17,
  "60560": 0,
  "60561": 18,
  "60563": 16,
  "60564": 25,
  "60565": 18,
  "60566": 18,
  "60567": 16,
  "60585": 9,
  "60586": 9,
  "60598": 16,
  "60599": 0,
  "60601": 15,
  "60602": 15,
  "60603": 15,
  "60604": 15,
  "60605": 15,
  "60606": 15,
  "60607": 15,
  "60608": 15,
  "60609": 15,
  "60610": 15,
  "60611": 15,
  "60612": 15,
  "60613": 16,
  "60614": 26,
  "60615": 15,
  "60616": 15,
  "60617": 13,
  "60618": 16,
  "60619": 15,
  "60620": 15,
  "60621": 15,
  "60622": 15,
  "60623": 15,
  "60624": 15,
  "60625": 16,
  "60626": 15,
  "60628": 13,
  "60629": 15,
  "60630": 15,
  "60631": 16,
  "60632": 15,
  "60633": 5,
  "60634": 15,
  "60636": 15,
  "60637": 15,
  "60638": 15,
  "60639": 15,
  "60640": 15,
  "60641": 15,
  "60642": 15,
  "60643": 15,
  "60644": 15,
  "60645": 15,
  "60646": 16,
  "60647": 15,
  "60649": 15,
  "60651": 15,
  "60652": 15,
  "60653": 15,
  "60654": 15,
  "60655": 15,
  "60656": 15,
  "60657": 17,
  "60659": 16,
  "60660": 15,
  "60661": 15,
  "60664": 15,
  "60666": 15,
  "60680": 15,
  "60681": 15,
  "60690": 15,
  "60691": 15,
  "60699": 15,
  "60701": 16,
  "60706": 16,
  "60707": 15,
  "60712": 16,
  "60714": 16,
  "60803": 15,
  "60804": 15,
  "60805": 15,
  "60827": 13,
  "60901": 0,
  "60910": -1,
  "60911": -5,
  "60912": -1,
  "60913": 8,
  "60914": 0,
  "60915": 0,
  "60917": 0,
  "60918": 1,
  "60919": -2,
  "60920": -3,
  "60921": -1,
  "60922": 0,
  "60924": -4,
  "60926": -5,
  "60927": -5,
  "60928": -5,
  "60929": -3,
  "60930": -5,
  "60931": -5,
  "60932": -4,
  "60933": 0,
  "60934": -2,
  "60935": 13,
  "60936": 0,
  "60938": -5,
  "60939": -5,
  "60940": 8,
  "60941": 0,
  "60942": -4,
  "60944": 0,
  "60945": -5,
  "60946": -2,
  "60948": 9,
  "60949": 0,
  "60950": 0,
  "60951": -5,
  "60952": 0,
  "60953": -5,
  "60954": 0,
  "60955": -5,
  "60956": -5,
  "60957": 1,
  "60958": 8,
  "60959": -1,
  "60960": 0,
  "60961": 13,
  "60962": 0,
  "60963": -4,
  "60964": 0,
  "60966": -5,
  "60967": -5,
  "60968": -1,
  "60969": 0,
  "60970": -5,
  "60973": -5,
  "60974": -5,
  "61001": 1,
  "61006": -10,
  "61007": 10,
  "61008": 2,
  "61010": -3,
  "61011": 10,
  "61012": 1,
  "61013": 10,
  "61014": -14,
  "61015": -4,
  "61016": 2,
  "61018": 10,
  "61019": 10,
  "61020": -4,
  "61021": -11,
  "61024": 4,
  "61025": -1,
  "61027": 10,
  "61028": -7,
  "61030": -4,
  "61031": -10,
  "61032": 10,
  "61036": 1,
  "61037": -3,
  "61038": 10,
  "61039": 10,
  "61041": -8,
  "61042": -10,
  "61043": -4,
  "61044": 10,
  "61046": -13,
  "61047": -4,
  "61048": 10,
  "61049": -4,
  "61050": 10,
  "61051": -14,
  "61052": 5,
  "61053": -13,
  "61054": -4,
  "61057": -10,
  "61059": -8,
  "61060": 10,
  "61061": -4,
  "61062": 10,
  "61063": 5,
  "61064": -4,
  "61065": 2,
  "61067": 10,
  "61068": -3,
  "61070": 10,
  "61071": -3,
  "61072": 4,
  "61073": 4,
  "61074": -13,
  "61075": -7,
  "61077": 4,
  "61078": -13,
  "61079": 4,
  "61080": 5,
  "61081": -3,
  "61084": -4,
  "61085": -8,
  "61087": -8,
  "61088": 5,
  "61089": 9,
  "61091": -11,
  "61101": 4,
  "61102": 4,
  "61103": 4,
  "61104": 4,
  "61105": 4,
  "61106": 4,
  "61107": 5,
  "61108": 5,
  "61109": 5,
  "61110": 4,
  "61111": 5,
  "61112": 2,
  "61114": 5,
  "61115": 5,
  "61125": 5,
  "61126": 5,
  "61130": 5,
  "61131": 5,
  "61132": 5,
  "61201": 0,
  "61204": 0,
  "61230": -3,
  "61231": -14,
  "61232": 0,
  "61233": 4,
  "61234": 4,
  "61235": 4,
  "61236": 0,
  "61237": -6,
  "61238": 4,
  "61239": 0,
  "61240": 9,
  "61241": 0,
  "61242": 1,
  "61243": -2,
  "61244": 0,
  "61250": -3,
  "61251": -3,
  "61252": -3,
  "61254": 12,
  "61256": 1,
  "61257": 5,
  "61258": -3,
  "61259": -6,
  "61260": -15,
  "61261": -3,
  "61262": 6,
  "61263": -15,
  "61264": 0,
  "61265": 0,
  "61266": 0,
  "61270": -2,
  "61272": -15,
  "61273": 2,
  "61274": 5,
  "61275": 9,
  "61276": -15,
  "61277": -3,
  "61278": 9,
  "61279": -13,
  "61281": 1,
  "61282": 0,
  "61283": -3,
  "61284": 8,
  "61285": -13,
  "61301": 6,
  "61310": -10,
  "61311": 0,
  "61312": -4,
  "61313": 0,
  "61314": -6,
  "61315": -6,
  "61316": 4,
  "61317": -4,
  "61318": -10,
  "61319": 0,
  "61320": 6,
  "61321": -5,
  "61322": -6,
  "61323": -6,
  "61324": -10,
  "61325": 6,
  "61326": -6,
  "61327": -6,
  "61328": -4,
  "61329": -4,
  "61330": -4,
  "61331": -10,
  "61332": 4,
  "61333": 0,
  "61334": -7,
  "61335": -7,
  "61336": -7,
  "61337": -4,
  "61338": -6,
  "61340": -6,
  "61341": 6,
  "61342": 6,
  "61344": 4,
  "61345": -5,
  "61346": -6,
  "61348": 6,
  "61349": -4,
  "61350": 6,
  "61353": 8,
  "61354": 6,
  "61356": -6,
  "61358": -5,
  "61359": -4,
  "61360": 14,
  "61361": -6,
  "61362": -6,
  "61363": 4,
  "61364": 6,
  "61367": -10,
  "61368": -6,
  "61369": -7,
  "61370": 4,
  "61371": 6,
  "61372": 6,
  "61373": 7,
  "61374": -4,
  "61375": -7,
  "61376": -6,
  "61377": -7,
  "61378": -10,
  "61379": -6,
  "61401": -5,
  "61402": -5,
  "61410": -5,
  "61411": -16,
  "61412": -15,
  "61413": 4,
  "61414": -5,
  "61415": -9,
  "61416": 12,
  "61417": -14,
  "61418": -16,
  "61419": 4,
  "61420": 12,
  "61421": -5,
  "61422": 12,
  "61423": -14,
  "61424": -5,
  "61425": -16,
  "61426": -5,
  "61427": -9,
  "61428": -5,
  "61430": -5,
  "61431": -9,
  "61432": -9,
  "61433": -9,
  "61434": 4,
  "61435": -14,
  "61436": -5,
  "61437": -16,
  "61438": 12,
  "61439": -5,
  "61440": 12,
  "61441": -9,
  "61442": -15,
  "61443": -5,
  "61447": -15,
  "61448": -5,
  "61449": -5,
  "61450": -6,
  "61451": -5,
  "61452": -16,
  "61453": -15,
  "61454": -16,
  "61455": 12,
  "61458": -5,
  "61459": -9,
  "61460": -16,
  "61462": -15,
  "61465": -14,
  "61466": -5,
  "61467": -5,
  "61468": 4,
  "61469": -16,
  "61470": 12,
  "61471": -16,
  "61472": -4,
  "61473": -15,
  "61474": -5,
  "61475": 12,
  "61476": -15,
  "61477": -9,
  "61478": -15,
  "61479": -5,
  "61480": -16,
  "61482": 12,
  "61483": -5,
  "61484": -16,
  "61485": -5,
  "61486": -15,
  "61488": -5,
  "61489": -5,
  "61490": 4,
  "61491": -5,
  "61501": -16,
  "61516": 2,
  "61517": 7,
  "61519": -10,
  "61520": 5,
  "61523": 5,
  "61524": -9,
  "61525": 14,
  "61526": 14,
  "61528": 14,
  "61529": 5,
  "61530": 0,
  "61531": -9,
  "61532": -12,
  "61533": 5,
  "61534": 2,
  "61535": 10,
  "61536": 5,
  "61537": -7,
  "61539": 2,
  "61540": -7,
  "61541": -8,
  "61542": -12,
  "61543": -12,
  "61544": -9,
  "61545": 0,
  "61546": -12,
  "61547": 14,
  "61548": 9,
  "61550": 10,
  "61552": 5,
  "61553": -9,
  "61554": 2,
  "61555": 2,
  "61559": -5,
  "61560": -5,
  "61561": 0,
  "61562": 5,
  "61563": -10,
  "61564": 2,
  "61565": -7,
  "61567": -12,
  "61568": 10,
  "61569": 5,
  "61570": -7,
  "61571": 2,
  "61572": -5,
  "61601": 5,
  "61602": 5,
  "61603": 5,
  "61604": 5,
  "61605": 5,
  "61606": 5,
  "61607": 5,
  "61610": 2,
  "61611": 5,
  "61612": 5,
  "61614": 5,
  "61615": 7,
  "61616": 5,
  "61650": 10,
  "61651": 5,
  "61652": 5,
  "61653": 5,
  "61654": 5,
  "61655": 5,
  "61656": 5,
  "61701": -2,
  "61702": 0,
  "61704": 7,
  "61705": 7,
  "61720": 1,
  "61721": -9,
  "61722": -2,
  "61723": -9,
  "61724": -2,
  "61725": 3,
  "61726": 0,
  "61727": -4,
  "61728": -1,
  "61729": 3,
  "61730": -1,
  "61731": 1,
  "61732": -1,
  "61733": 2,
  "61734": 2,
  "61735": -2,
  "61736": -1,
  "61737": -2,
  "61738": 2,
  "61739": 0,
  "61740": 0,
  "61741": 0,
  "61742": 3,
  "61743": -1,
  "61744": -1,
  "61745": -2,
  "61747": 2,
  "61748": 0,
  "61749": -4,
  "61750": -4,
  "61751": -9,
  "61752": -1,
  "61753": -1,
  "61754": -2,
  "61755": 10,
  "61756": -4,
  "61758": 7,
  "61759": 3,
  "61760": 2,
  "61761": -1,
  "61764": 0,
  "61769": -3,
  "61770": 1,
  "61771": 2,
  "61772": -2,
  "61773": 1,
  "61774": -2,
  "61775": 1,
  "61776": -1,
  "61777": -2,
  "61778": -2,
  "61801": 1,
  "61802": 0,
  "61803": 1,
  "61810": -3,
  "61811": -4,
  "61812": -4,
  "61813": -10,
  "61814": -4,
  "61815": -2,
  "61816": -2,
  "61817": -4,
  "61818": -10,
  "61820": -2,
  "61821": -1,
  "61822": 8,
  "61824": -2,
  "61825": -2,
  "61826": 8,
  "61830": -9,
  "61831": -4,
  "61832": -4,
  "61833": -4,
  "61834": -4,
  "61839": -9,
  "61840": -1,
  "61841": -4,
  "61842": -3,
  "61843": -1,
  "61844": -4,
  "61845": 0,
  "61846": -4,
  "61847": 0,
  "61848": -4,
  "61849": 0,
  "61850": -4,
  "61851": -9,
  "61852": -3,
  "61853": -1,
  "61854": -8,
  "61855": -10,
  "61856": -8,
  "61857": -4,
  "61858": -4,
  "61859": 0,
  "61862": 0,
  "61863": -3,
  "61864": 8,
  "61865": -4,
  "61866": 0,
  "61870": 2,
  "61871": 0,
  "61872": -9,
  "61873": 8,
  "61874": 8,
  "61875": -1,
  "61876": -7,
  "61877": 1,
  "61878": 0,
  "61880": -1,
  "61882": -4,
  "61883": -4,
  "61884": -7,
  "61910": -3,
  "61911": -3,
  "61912": -6,
  "61913": -3,
  "61914": -3,
  "61917": -9,
  "61919": -2,
  "61920": -3,
  "61924": -9,
  "61925": -1,
  "61928": -3,
  "61929": -3,
  "61930": -3,
  "61931": -5,
  "61932": -7,
  "61933": -9,
  "61936": -3,
  "61937": -3,
  "61938": -6,
  "61940": -7,
  "61941": -3,
  "61942": -3,
  "61943": -3,
  "61944": -9,
  "61949": -9,
  "61951": -2,
  "61953": -3,
  "61955": -9,
  "61956": -3,
  "61957": -13,
  "62001": 3,
  "62002": 2,
  "62006": -5,
  "62009": -7,
  "62010": 2,
  "62011": -12,
  "62012": -9,
  "62013": 3,
  "62014": -7,
  "62015": -11,
  "62016": -14,
  "62017": -11,
  "62018": 2,
  "62019": -12,
  "62021": 11,
  "62022": -8,
  "62023": -7,
  "62024": 2,
  "62025": 3,
  "62027": -5,
  "62028": -8,
  "62030": -9,
  "62031": -5,
  "62032": -11,
  "62033": -7,
  "62034": 4,
  "62035": -8,
  "62036": 3,
  "62037": -6,
  "62040": 2,
  "62044": -14,
  "62045": -5,
  "62046": 2,
  "62047": -5,
  "62048": 2,
  "62049": -11,
  "62050": -15,
  "62051": -10,
  "62052": -9,
  "62053": -5,
  "62054": -9,
  "62056": -11,
  "62058": 2,
  "62059": -2,
  "62060": 2,
  "62061": 2,
  "62062": 2,
  "62063": -9,
  "62065": -5,
  "62067": 2,
  "62069": -7,
  "62070": -5,
  "62071": -2,
  "62074": -12,
  "62075": -10,
  "62076": -9,
  "62077": -13,
  "62078": -15,
  "62079": 0,
  "62080": -13,
  "62081": -14,
  "62082": -14,
  "62083": -9,
  "62084": 2,
  "62085": -7,
  "62086": -12,
  "62087": 2,
  "62088": -7,
  "62089": -11,
  "62090": 1,
  "62091": -11,
  "62092": -14,
  "62093": -7,
  "62094": -10,
  "62095": 2,
  "62097": 3,
  "62098": -14,
  "62201": -2,
  "62202": -2,
  "62203": -1,
  "62204": -2,
  "62205": -1,
  "62206": -1,
  "62207": -2,
  "62208": 0,
  "62214": 8,
  "62215": -4,
  "62216": -4,
  "62217": -7,
  "62218": -3,
  "62219": -4,
  "62220": 0,
  "62221": 0,
  "62222": 0,
  "62223": 0,
  "62225": -1,
  "62226": 0,
  "62230": -3,
  "62231": -4,
  "62232": -1,
  "62233": -7,
  "62234": 2,
  "62236": 8,
  "62237": -7,
  "62238": -5,
  "62239": -1,
  "62240": 9,
  "62241": -7,
  "62242": -7,
  "62243": 8,
  "62244": 8,
  "62245": -3,
  "62246": -12,
  "62247": -12,
  "62248": 0,
  "62249": -3,
  "62250": -4,
  "62252": -4,
  "62253": -12,
  "62254": 1,
  "62255": -7,
  "62256": 8,
  "62257": -7,
  "62258": 0,
  "62259": -7,
  "62260": 8,
  "62261": -7,
  "62262": -12,
  "62263": 8,
  "62264": 0,
  "62265": -4,
  "62266": -4,
  "62268": 8,
  "62269": 8,
  "62271": 8,
  "62272": -7,
  "62273": -12,
  "62274": -6,
  "62275": -12,
  "62277": -7,
  "62278": 1,
  "62279": -7,
  "62280": -7,
  "62281": 11,
  "62282": -7,
  "62284": -11,
  "62285": 8,
  "62286": -7,
  "62288": -7,
  "62289": -1,
  "62292": -7,
  "62293": 4,
  "62294": 3,
  "62295": 8,
  "62297": -7,
  "62298": 8,
  "62301": -7,
  "62305": -7,
  "62306": -7,
  "62311": -6,
  "62312": -14,
  "62313": -6,
  "62314": -15,
  "62316": -6,
  "62319": -16,
  "62320": -8,
  "62321": -6,
  "62323": -12,
  "62324": -12,
  "62325": -8,
  "62326": 12,
  "62329": -6,
  "62330": -6,
  "62334": -6,
  "62336": -6,
  "62338": -8,
  "62339": -8,
  "62340": -15,
  "62341": -6,
  "62343": -5,
  "62344": -16,
  "62345": -14,
  "62346": -11,
  "62347": -8,
  "62348": -8,
  "62349": -8,
  "62351": -8,
  "62352": -10,
  "62353": -11,
  "62354": -6,
  "62355": -14,
  "62356": -14,
  "62357": -15,
  "62358": -6,
  "62359": -8,
  "62360": -7,
  "62361": -10,
  "62362": -12,
  "62363": -14,
  "62365": -7,
  "62366": -14,
  "62367": 12,
  "62370": -14,
  "62373": -6,
  "62374": 12,
  "62375": -11,
  "62376": -7,
  "62378": -11,
  "62379": -6,
  "62380": -6,
  "62401": -3,
  "62410": 0,
  "62411": -4,
  "62413": -2,
  "62414": -4,
  "62417": -9,
  "62418": -13,
  "62419": -14,
  "62420": -6,
  "62421": -15,
  "62422": -13,
  "62423": 14,
  "62424": -8,
  "62425": -15,
  "62426": -5,
  "62427": -9,
  "62428": -8,
  "62431": -13,
  "62432": -8,
  "62433": -2,
  "62434": -14,
  "62435": -6,
  "62436": -8,
  "62438": -13,
  "62439": -9,
  "62440": -6,
  "62441": -6,
  "62442": -6,
  "62443": -4,
  "62444": -13,
  "62445": -4,
  "62446": -15,
  "62447": -6,
  "62448": -8,
  "62449": -2,
  "62450": -14,
  "62451": -2,
  "62452": -14,
  "62454": -2,
  "62458": -13,
  "62459": -8,
  "62460": -9,
  "62461": -3,
  "62462": -2,
  "62463": -13,
  "62464": -2,
  "62465": -13,
  "62466": -9,
  "62467": 5,
  "62468": -6,
  "62469": -5,
  "62471": -12,
  "62473": -4,
  "62474": -6,
  "62475": -15,
  "62476": 0,
  "62477": -6,
  "62478": -2,
  "62479": -8,
  "62480": -8,
  "62481": -8,
  "62501": -1,
  "62510": -9,
  "62512": -11,
  "62513": -1,
  "62514": -1,
  "62515": 0,
  "62517": -8,
  "62518": -11,
  "62519": -10,
  "62520": 8,
  "62521": -1,
  "62522": -1,
  "62523": -1,
  "62524": 8,
  "62525": -1,
  "62526": -1,
  "62530": 0,
  "62531": -8,
  "62532": -1,
  "62533": -10,
  "62534": -13,
  "62535": 8,
  "62536": 8,
  "62537": -1,
  "62538": -10,
  "62539": -1,
  "62540": -8,
  "62541": -10,
  "62543": -1,
  "62544": -1,
  "62545": 0,
  "62546": -8,
  "62547": -1,
  "62548": -11,
  "62549": 0,
  "62550": -9,
  "62551": -1,
  "62553": -13,
  "62554": 0,
  "62555": -9,
  "62556": -8,
  "62557": -9,
  "62558": 0,
  "62560": -10,
  "62561": 0,
  "62563": 8,
  "62565": -13,
  "62567": -9,
  "62568": -8,
  "62570": -8,
  "62571": -13,
  "62572": -10,
  "62573": 0,
  "62601": -8,
  "62610": -9,
  "62611": -11,
  "62612": -11,
  "62613": 0,
  "62615": 0,
  "62617": -11,
  "62618": -11,
  "62621": -9,
  "62622": -11,
  "62624": -16,
  "62625": 0,
  "62626": -7,
  "62627": -11,
  "62628": -9,
  "62629": 8,
  "62630": -7,
  "62631": -8,
  "62633": -12,
  "62634": -10,
  "62635": -10,
  "62638": -8,
  "62639": -16,
  "62640": -6,
  "62642": -10,
  "62643": -10,
  "62644": -12,
  "62649": -7,
  "62650": -8,
  "62651": -8,
  "62655": -12,
  "62656": -10,
  "62659": -9,
  "62660": -11,
  "62661": 0,
  "62662": 0,
  "62663": -9,
  "62664": -12,
  "62665": -9,
  "62666": -10,
  "62667": -6,
  "62668": -8,
  "62670": 0,
  "62671": -10,
  "62672": -6,
  "62673": -10,
  "62674": -6,
  "62675": -9,
  "62677": -10,
  "62681": -16,
  "62682": -10,
  "62683": -6,
  "62684": 8,
  "62685": -7,
  "62688": -10,
  "62689": 0,
  "62690": 0,
  "62691": -11,
  "62692": -8,
  "62693": 0,
  "62694": -9,
  "62695": -8,
  "62701": 0,
  "62702": 0,
  "62703": 0,
  "62704": 0,
  "62705": 0,
  "62707": 0,
  "62708": 0,
  "62711": 0,
  "62712": 0,
  "62791": 0,
  "62794": 0,
  "62801": -8,
  "62803": 8,
  "62805": -9,
  "62806": 1,
  "62807": -8,
  "62808": 8,
  "62809": -15,
  "62810": -3,
  "62811": 0,
  "62812": -9,
  "62814": -3,
  "62815": 0,
  "62816": -3,
  "62817": -10,
  "62818": 0,
  "62819": -9,
  "62820": -15,
  "62821": -8,
  "62822": -9,
  "62823": -15,
  "62824": -14,
  "62825": -9,
  "62827": -8,
  "62828": -10,
  "62829": -9,
  "62830": -3,
  "62831": 8,
  "62832": -6,
  "62833": -14,
  "62834": -20,
  "62835": -10,
  "62836": -9,
  "62837": -15,
  "62838": -13,
  "62839": -13,
  "62840": -9,
  "62841": -6,
  "62842": -15,
  "62843": -15,
  "62844": 0,
  "62846": -3,
  "62848": 8,
  "62849": -8,
  "62850": -14,
  "62851": -14,
  "62852": 0,
  "62853": -8,
  "62854": -8,
  "62855": 0,
  "62856": -9,
  "62857": -13,
  "62858": -14,
  "62859": -10,
  "62860": -9,
  "62861": -8,
  "62862": -8,
  "62863": 0,
  "62864": -3,
  "62865": -9,
  "62866": -3,
  "62867": -20,
  "62868": -14,
  "62869": -20,
  "62870": -8,
  "62871": -20,
  "62872": -3,
  "62874": -9,
  "62875": -8,
  "62876": 8,
  "62877": 8,
  "62878": -14,
  "62879": -14,
  "62880": -12,
  "62881": -8,
  "62882": -8,
  "62883": -6,
  "62884": -9,
  "62885": -12,
  "62886": -15,
  "62887": -10,
  "62888": -6,
  "62889": -3,
  "62890": -9,
  "62891": -9,
  "62892": -8,
  "62893": -8,
  "62894": -3,
  "62895": -15,
  "62896": -9,
  "62897": -9,
  "62898": -2,
  "62899": -13,
  "62901": -4,
  "62902": -4,
  "62903": -4,
  "62905": -13,
  "62906": -13,
  "62907": -5,
  "62908": -12,
  "62909": -6,
  "62910": -3,
  "62912": -6,
  "62914": -3,
  "62915": -6,
  "62916": -6,
  "62917": -2,
  "62918": -6,
  "62919": -19,
  "62920": -13,
  "62921": -6,
  "62922": -6,
  "62923": -13,
  "62924": -5,
  "62926": -13,
  "62927": -6,
  "62928": -25,
  "62930": -2,
  "62931": -19,
  "62932": -5,
  "62933": -6,
  "62934": -20,
  "62935": -2,
  "62938": -25,
  "62939": -6,
  "62940": -5,
  "62941": -11,
  "62942": -5,
  "62943": -11,
  "62946": -2,
  "62947": -25,
  "62948": -6,
  "62949": -5,
  "62950": -5,
  "62951": -6,
  "62952": -13,
  "62953": -11,
  "62954": -20,
  "62955": -26,
  "62956": -12,
  "62957": -13,
  "62958": -12,
  "62959": -6,
  "62960": -11,
  "62961": -13,
  "62962": -3,
  "62963": -3,
  "62964": -3,
  "62965": -2,
  "62966": -5,
  "62967": -6,
  "62969": -13,
  "62970": -3,
  "62971": -5,
  "62972": -6,
  "62973": -13,
  "62974": -6,
  "62975": -5,
  "62976": -3,
  "62977": -2,
  "62979": -20,
  "62982": -26,
  "62983": -9,
  "62984": -21,
  "62985": -25,
  "62987": -2,
  "62988": -13,
  "62990": -13,
  "62992": -13,
  "62993": -13,
  "62994": -5,
  "62995": -6,
  "62996": -3,
  "62997": -7,
  "62998": -13,
  "62999": -9,
  "63001": -1,
  "63005": 14,
  "63006": 21,
  "63010": -3,
  "63011": 12,
  "63012": -3,
  "63013": -5,
  "63014": -6,
  "63015": -1,
  "63016": -3,
  "63017": 21,
  "63019": -3,
  "63020": -3,
  "63021": 12,
  "63022": 12,
  "63023": -3,
  "63024": 12,
  "63025": -1,
  "63026": 9,
  "63028": -3,
  "63030": -18,
  "63031": 12,
  "63032": 12,
  "63033": 10,
  "63034": 18,
  "63036": -5,
  "63037": -14,
  "63038": 12,
  "63039": -6,
  "63040": 20,
  "63041": -3,
  "63042": 12,
  "63043": 12,
  "63044": 12,
  "63045": 12,
  "63047": -3,
  "63048": -3,
  "63049": -3,
  "63050": -3,
  "63051": -3,
  "63052": -3,
  "63053": -3,
  "63055": -5,
  "63056": -5,
  "63057": -3,
  "63060": -3,
  "63061": -3,
  "63065": -3,
  "63066": -3,
  "63068": -5,
  "63069": -5,
  "63070": -3,
  "63071": -19,
  "63072": -5,
  "63073": -5,
  "63074": 12,
  "63077": -6,
  "63079": -12,
  "63080": -12,
  "63084": -5,
  "63087": -5,
  "63088": 9,
  "63089": -5,
  "63090": -5,
  "63091": -14,
  "63101": 9,
  "63102": 9,
  "63103": 8,
  "63104": 9,
  "63105": 18,
  "63106": 8,
  "63107": 8,
  "63108": 9,
  "63109": 9,
  "63110": 9,
  "63111": 8,
  "63112": 9,
  "63113": 8,
  "63114": 9,
  "63115": 8,
  "63116": 9,
  "63117": 9,
  "63118": 8,
  "63119": 9,
  "63120": 8,
  "63121": 9,
  "63122": 9,
  "63123": 9,
  "63124": 20,
  "63125": 9,
  "63126": 9,
  "63127": 9,
  "63128": 9,
  "63129": 9,
  "63130": 9,
  "63131": 18,
  "63132": 9,
  "63133": 9,
  "63134": 9,
  "63135": 9,
  "63136": 9,
  "63137": 9,
  "63138": 2,
  "63139": 9,
  "63140": 9,
  "63141": 21,
  "63143": 9,
  "63144": 9,
  "63145": 9,
  "63146": 12,
  "63147": 8,
  "63151": 9,
  "63155": 8,
  "63156": 9,
  "63157": 9,
  "63158": 9,
  "63163": 8,
  "63166": 8,
  "63169": 9,
  "63177": 8,
  "63178": 8,
  "63179": 8,
  "63188": 9,
  "63301": 3,
  "63302": 3,
  "63303": 3,
  "63304": 3,
  "63330": 3,
  "63332": -5,
  "63333": -7,
  "63334": -5,
  "63336": -5,
  "63338": 3,
  "63339": -5,
  "63341": 12,
  "63342": -5,
  "63343": 3,
  "63344": -5,
  "63345": -6,
  "63346": 3,
  "63347": 3,
  "63348": -6,
  "63349": 3,
  "63350": -7,
  "63351": -7,
  "63352": -6,
  "63353": -5,
  "63357": -6,
  "63359": -7,
  "63361": -7,
  "63362": 3,
  "63363": -7,
  "63365": 12,
  "63366": 3,
  "63367": 3,
  "63368": 3,
  "63369": 3,
  "63370": 3,
  "63373": -8,
  "63376": 3,
  "63377": 3,
  "63378": -6,
  "63379": 3,
  "63381": -7,
  "63382": -9,
  "63383": -6,
  "63384": -7,
  "63385": 3,
  "63386": 2,
  "63387": 3,
  "63388": 1,
  "63389": 3,
  "63390": -6,
  "63401": -5,
  "63430": -15,
  "63431": -9,
  "63432": -15,
  "63433": -5,
  "63434": -10,
  "63435": -10,
  "63436": -9,
  "63437": -10,
  "63438": -10,
  "63439": -10,
  "63440": -9,
  "63441": -9,
  "63442": -15,
  "63443": -15,
  "63445": -15,
  "63446": -27,
  "63447": -10,
  "63448": -10,
  "63450": -8,
  "63451": -10,
  "63452": -10,
  "63453": -15,
  "63454": -10,
  "63456": -9,
  "63457": -9,
  "63458": -27,
  "63459": -9,
  "63460": -27,
  "63461": -4,
  "63462": -9,
  "63463": -5,
  "63464": -27,
  "63465": -15,
  "63466": -15,
  "63467": -9,
  "63468": -10,
  "63469": -10,
  "63471": -5,
  "63472": -15,
  "63473": -15,
  "63474": -15,
  "63501": -2,
  "63530": -13,
  "63531": -27,
  "63532": -13,
  "63533": -2,
  "63534": -13,
  "63535": -14,
  "63536": -13,
  "63537": -27,
  "63538": -13,
  "63539": -13,
  "63540": -2,
  "63541": -14,
  "63543": -15,
  "63544": -2,
  "63545": -19,
  "63546": -2,
  "63547": -27,
  "63548": -13,
  "63549": -2,
  "63551": -11,
  "63552": -13,
  "63555": -14,
  "63556": -19,
  "63557": -7,
  "63558": -13,
  "63559": -2,
  "63560": -21,
  "63561": -4,
  "63563": -27,
  "63565": -21,
  "63566": -7,
  "63567": -4,
  "63601": -6,
  "63620": -19,
  "63621": -19,
  "63622": -18,
  "63623": -20,
  "63624": -6,
  "63625": -20,
  "63626": -19,
  "63627": -3,
  "63628": -5,
  "63629": -16,
  "63630": -19,
  "63631": -18,
  "63632": -14,
  "63633": -20,
  "63636": -20,
  "63637": -6,
  "63638": -11,
  "63640": -5,
  "63645": -14,
  "63648": -7,
  "63650": -19,
  "63651": -5,
  "63653": -6,
  "63654": -19,
  "63655": -14,
  "63656": -6,
  "63660": -19,
  "63662": -14,
  "63663": -19,
  "63664": -19,
  "63665": -19,
  "63666": -11,
  "63670": -4,
  "63673": -4,
  "63674": -19,
  "63675": -19,
  "63701": 2,
  "63702": 2,
  "63703": -6,
  "63730": -13,
  "63732": -3,
  "63735": -11,
  "63736": -12,
  "63737": -3,
  "63738": -3,
  "63739": 2,
  "63740": -12,
  "63742": -12,
  "63743": -4,
  "63744": -12,
  "63745": -12,
  "63746": -3,
  "63747": -3,
  "63748": -3,
  "63750": -14,
  "63751": -14,
  "63752": 2,
  "63755": 2,
  "63758": -11,
  "63760": -14,
  "63763": 6,
  "63764": -14,
  "63766": -6,
  "63767": -11,
  "63769": -6,
  "63770": -4,
  "63771": -12,
  "63774": -12,
  "63775": -3,
  "63776": -3,
  "63779": 2,
  "63780": -6,
  "63781": -14,
  "63782": -13,
  "63783": -4,
  "63784": -11,
  "63785": -14,
  "63787": -13,
  "63801": -9,
  "63820": -11,
  "63821": -8,
  "63822": -3,
  "63823": -11,
  "63824": -11,
  "63825": -3,
  "63826": -5,
  "63827": -6,
  "63828": -12,
  "63829": -7,
  "63830": -5,
  "63833": -12,
  "63834": -11,
  "63837": -7,
  "63839": 5,
  "63840": -5,
  "63841": -3,
  "63845": -12,
  "63846": -3,
  "63847": -7,
  "63848": -6,
  "63849": -6,
  "63850": -3,
  "63851": -6,
  "63852": -6,
  "63853": 5,
  "63855": 5,
  "63857": -6,
  "63860": -12,
  "63862": -12,
  "63863": -12,
  "63866": -12,
  "63867": -12,
  "63868": -3,
  "63869": -12,
  "63870": -12,
  "63873": -12,
  "63874": -12,
  "63875": -6,
  "63876": -6,
  "63877": -6,
  "63878": -12,
  "63879": -6,
  "63880": -6,
  "63881": -12,
  "63882": -11,
  "63901": -8,
  "63902": -8,
  "63931": -17,
  "63932": -8,
  "63933": -6,
  "63934": -20,
  "63935": -17,
  "63936": -3,
  "63937": -11,
  "63938": -16,
  "63939": -17,
  "63940": -8,
  "63941": -11,
  "63942": -17,
  "63943": -11,
  "63944": -19,
  "63945": -8,
  "63950": -20,
  "63951": -19,
  "63952": -19,
  "63953": -17,
  "63954": -9,
  "63955": -17,
  "63956": -10,
  "63957": -19,
  "63960": -3,
  "63961": -8,
  "63962": -8,
  "63963": -19,
  "63964": -20,
  "63965": -11,
  "63966": -19,
  "63967": -19,
  "64001": -8,
  "64011": -8,
  "64012": -3,
  "64013": 10,
  "64014": 10,
  "64015": 10,
  "64016": 10,
  "64017": -10,
  "64018": 14,
  "64019": -9,
  "64020": -8,
  "64021": -8,
  "64022": -8,
  "64024": -10,
  "64028": 14,
  "64029": 10,
  "64030": 10,
  "64034": -4,
  "64035": -10,
  "64036": -10,
  "64037": -8,
  "64040": -9,
  "64048": -7,
  "64050": 10,
  "64051": 10,
  "64052": 10,
  "64053": 10,
  "64054": 10,
  "64055": 10,
  "64056": 10,
  "64057": 10,
  "64058": 5,
  "64060": 6,
  "64061": -4,
  "64062": -10,
  "64063": 10,
  "64064": 18,
  "64066": -10,
  "64067": -8,
  "64068": 6,
  "64069": 6,
  "64070": -4,
  "64071": -8,
  "64072": 5,
  "64073": -10,
  "64074": -7,
  "64075": 10,
  "64076": -7,
  "64077": -10,
  "64078": -3,
  "64079": 14,
  "64080": -4,
  "64081": 10,
  "64082": 4,
  "64083": -4,
  "64084": -10,
  "64085": -10,
  "64086": 10,
  "64088": -10,
  "64089": 14,
  "64090": -5,
  "64092": 13,
  "64093": -9,
  "64096": -2,
  "64097": -8,
  "64098": 14,
  "64101": 10,
  "64102": 10,
  "64105": 10,
  "64106": 10,
  "64108": 10,
  "64109": 10,
  "64110": 10,
  "64111": 10,
  "64112": 18,
  "64113": 18,
  "64114": 10,
  "64116": 6,
  "64117": 5,
  "64118": 4,
  "64119": 6,
  "64120": 10,
  "64121": 10,
  "64123": 10,
  "64124": 10,
  "64125": 10,
  "64126": 10,
  "64127": 10,
  "64128": 10,
  "64129": 10,
  "64130": 10,
  "64131": 10,
  "64132": 10,
  "64133": 10,
  "64134": 10,
  "64136": 10,
  "64137": 10,
  "64138": 10,
  "64139": 18,
  "64141": 10,
  "64145": 9,
  "64146": 10,
  "64147": 18,
  "64148": 10,
  "64149": 18,
  "64150": 2,
  "64151": 2,
  "64152": 13,
  "64153": 15,
  "64154": 13,
  "64155": 4,
  "64156": 5,
  "64157": 6,
  "64158": 14,
  "64161": 5,
  "64163": 14,
  "64164": 13,
  "64165": 4,
  "64166": 14,
  "64167": 14,
  "64168": 2,
  "64171": 10,
  "64172": 10,
  "64179": 10,
  "64188": 10,
  "64190": 13,
  "64191": 10,
  "64192": 10,
  "64195": 15,
  "64196": 10,
  "64199": 10,
  "64401": 12,
  "64402": -9,
  "64420": -9,
  "64421": -8,
  "64422": -9,
  "64423": -5,
  "64424": -20,
  "64426": -21,
  "64427": -9,
  "64428": -14,
  "64429": -8,
  "64430": -9,
  "64431": -14,
  "64432": -14,
  "64433": -14,
  "64434": -14,
  "64436": 0,
  "64437": -16,
  "64438": -9,
  "64439": 12,
  "64440": 4,
  "64441": -9,
  "64442": -21,
  "64443": 12,
  "64444": 14,
  "64445": -14,
  "64446": -16,
  "64448": 12,
  "64449": -9,
  "64451": -16,
  "64453": -9,
  "64454": 1,
  "64455": -16,
  "64456": -9,
  "64457": -9,
  "64458": -12,
  "64459": -8,
  "64461": -14,
  "64463": -9,
  "64465": 1,
  "64466": -16,
  "64467": -21,
  "64468": -5,
  "64469": -9,
  "64470": -16,
  "64471": -21,
  "64473": -16,
  "64474": -8,
  "64475": -14,
  "64476": -14,
  "64477": 1,
  "64479": -14,
  "64480": -8,
  "64481": -21,
  "64482": -16,
  "64483": -8,
  "64484": -7,
  "64485": -6,
  "64486": -14,
  "64487": -14,
  "64489": -9,
  "64490": -9,
  "64491": -16,
  "64492": -7,
  "64493": -8,
  "64494": -8,
  "64496": -16,
  "64497": -9,
  "64498": -14,
  "64499": -9,
  "64501": 4,
  "64502": 4,
  "64503": 4,
  "64504": 4,
  "64505": 4,
  "64506": 12,
  "64507": 4,
  "64508": 12,
  "64601": 5,
  "64620": -4,
  "64622": -2,
  "64623": 0,
  "64624": -7,
  "64625": -8,
  "64628": -7,
  "64630": -19,
  "64631": -7,
  "64632": -15,
  "64633": -2,
  "64635": 4,
  "64636": -4,
  "64637": -7,
  "64638": 5,
  "64639": 0,
  "64640": -4,
  "64641": -15,
  "64642": -15,
  "64643": 0,
  "64644": -7,
  "64645": -21,
  "64646": -21,
  "64647": -4,
  "64648": -4,
  "64649": -7,
  "64650": -7,
  "64651": -7,
  "64652": -15,
  "64653": -7,
  "64654": -4,
  "64655": -14,
  "64656": 4,
  "64657": -9,
  "64658": -14,
  "64659": -7,
  "64660": -14,
  "64661": -14,
  "64664": 4,
  "64667": -14,
  "64668": -2,
  "64670": -4,
  "64671": -7,
  "64672": -14,
  "64673": -15,
  "64674": -7,
  "64676": -14,
  "64679": -15,
  "64680": -2,
  "64681": -7,
  "64682": -2,
  "64683": -15,
  "64686": 4,
  "64688": 4,
  "64689": -4,
  "64701": -3,
  "64720": -6,
  "64722": -6,
  "64723": -6,
  "64724": -6,
  "64725": -3,
  "64726": -5,
  "64728": -11,
  "64730": -6,
  "64733": -9,
  "64734": -3,
  "64735": -5,
  "64738": -8,
  "64739": -4,
  "64740": -5,
  "64741": -3,
  "64742": -3,
  "64743": -5,
  "64744": -8,
  "64745": -6,
  "64746": -3,
  "64747": -3,
  "64748": -9,
  "64750": -11,
  "64752": -6,
  "64755": -13,
  "64756": -8,
  "64759": -13,
  "64761": -9,
  "64762": -13,
  "64763": -6,
  "64765": -6,
  "64766": -8,
  "64767": -11,
  "64769": -13,
  "64770": -4,
  "64771": -11,
  "64772": -11,
  "64776": -17,
  "64778": -10,
  "64779": -6,
  "64780": -6,
  "64781": -8,
  "64783": -11,
  "64784": -13,
  "64788": -4,
  "64790": -11,
  "64801": -5,
  "64802": -3,
  "64803": -3,
  "64804": -3,
  "64830": -5,
  "64831": -12,
  "64832": -5,
  "64833": -5,
  "64834": -3,
  "64835": -5,
  "64836": -5,
  "64840": -7,
  "64841": -5,
  "64842": -7,
  "64843": -13,
  "64844": -7,
  "64847": -13,
  "64848": -8,
  "64849": -5,
  "64850": -7,
  "64853": -7,
  "64854": -12,
  "64855": -4,
  "64856": -12,
  "64857": -5,
  "64858": -7,
  "64859": -5,
  "64861": -12,
  "64862": -5,
  "64863": -12,
  "64864": -3,
  "64865": -7,
  "64866": -7,
  "64867": -13,
  "64868": -12,
  "64869": -5,
  "64870": -4,
  "64873": 1,
  "64874": -10,
  "65001": -7,
  "65010": 7,
  "65011": -11,
  "65013": -7,
  "65014": -14,
  "65016": -6,
  "65017": -10,
  "65018": -5,
  "65020": -9,
  "65023": 2,
  "65024": -7,
  "65025": -6,
  "65026": -10,
  "65032": -10,
  "65034": -6,
  "65035": -6,
  "65036": -14,
  "65037": -10,
  "65038": -10,
  "65039": 10,
  "65040": -10,
  "65041": -14,
  "65042": -5,
  "65043": 2,
  "65046": -6,
  "65047": -10,
  "65048": -7,
  "65049": 1,
  "65050": -5,
  "65051": -6,
  "65052": -7,
  "65053": 10,
  "65054": -6,
  "65055": -5,
  "65058": -10,
  "65059": 1,
  "65061": -6,
  "65062": -6,
  "65063": 1,
  "65064": -10,
  "65065": 1,
  "65066": -14,
  "65067": 0,
  "65068": -5,
  "65069": -6,
  "65072": -2,
  "65074": -5,
  "65075": -10,
  "65076": -5,
  "65077": 0,
  "65078": -11,
  "65079": 1,
  "65080": 1,
  "65081": -6,
  "65082": -10,
  "65083": -10,
  "65084": -11,
  "65085": -6,
  "65101": 2,
  "65102": 2,
  "65109": 2,
  "65110": 2,
  "65201": -1,
  "65202": -1,
  "65203": 7,
  "65205": -1,
  "65230": -14,
  "65231": 1,
  "65232": -6,
  "65233": -7,
  "65236": -14,
  "65237": -8,
  "65239": -7,
  "65240": -1,
  "65243": -7,
  "65244": -7,
  "65246": -14,
  "65247": -7,
  "65248": -14,
  "65250": -14,
  "65251": 1,
  "65254": -14,
  "65255": -1,
  "65256": -14,
  "65257": -7,
  "65258": -15,
  "65259": -7,
  "65260": -7,
  "65261": -14,
  "65262": 8,
  "65263": -15,
  "65264": -5,
  "65265": -6,
  "65270": -7,
  "65274": -14,
  "65275": -15,
  "65276": -8,
  "65278": -7,
  "65279": -1,
  "65280": -6,
  "65281": -14,
  "65282": -5,
  "65283": -15,
  "65284": -1,
  "65285": -5,
  "65286": -14,
  "65287": -1,
  "65301": -7,
  "65302": -7,
  "65305": -9,
  "65320": -7,
  "65321": -8,
  "65322": -8,
  "65323": -5,
  "65324": 1,
  "65325": -10,
  "65326": -10,
  "65327": -8,
  "65329": -6,
  "65330": -7,
  "65332": -7,
  "65333": -7,
  "65334": -6,
  "65335": -10,
  "65336": -9,
  "65337": -7,
  "65338": -10,
  "65339": -7,
  "65340": -7,
  "65344": -7,
  "65345": -10,
  "65347": -7,
  "65348": -8,
  "65349": -7,
  "65350": -7,
  "65351": -7,
  "65354": -8,
  "65355": -11,
  "65360": -5,
  "65401": -9,
  "65402": -9,
  "65436": -11,
  "65438": -12,
  "65439": -16,
  "65440": -16,
  "65441": -12,
  "65443": -12,
  "65444": -14,
  "65446": -14,
  "65449": -11,
  "65452": -12,
  "65453": -12,
  "65456": -14,
  "65457": -12,
  "65459": -12,
  "65461": -11,
  "65462": -11,
  "65463": -7,
  "65464": -5,
  "65466": -11,
  "65468": -13,
  "65470": -7,
  "65473": -13,
  "65479": -13,
  "65483": -13,
  "65484": -14,
  "65486": -10,
  "65501": -14,
  "65529": -9,
  "65532": -9,
  "65534": -14,
  "65535": -12,
  "65536": -7,
  "65541": -14,
  "65542": -14,
  "65543": -15,
  "65546": -12,
  "65548": -16,
  "65550": -9,
  "65552": -13,
  "65555": -14,
  "65556": -14,
  "65557": -14,
  "65559": -9,
  "65560": -13,
  "65564": -14,
  "65565": -12,
  "65566": -16,
  "65567": -14,
  "65570": -14,
  "65571": -14,
  "65580": -9,
  "65582": -9,
  "65583": -13,
  "65584": -13,
  "65586": -12,
  "65588": -11,
  "65589": -13,
  "65590": -14,
  "65591": -9,
  "65601": -13,
  "65603": -9,
  "65604": -5,
  "65605": -8,
  "65606": -12,
  "65607": -8,
  "65608": -19,
  "65609": -19,
  "65610": -7,
  "65611": -11,
  "65612": -5,
  "65613": -13,
  "65614": -10,
  "65615": -10,
  "65616": -10,
  "65617": -13,
  "65618": -18,
  "65619": -5,
  "65620": -8,
  "65622": -13,
  "65623": -10,
  "65624": -12,
  "65625": -10,
  "65626": -19,
  "65627": -10,
  "65629": -8,
  "65630": -1,
  "65631": -8,
  "65632": -7,
  "65633": -12,
  "65634": -16,
  "65635": -8,
  "65636": -13,
  "65637": -16,
  "65638": -19,
  "65640": -13,
  "65641": -10,
  "65644": -13,
  "65645": -13,
  "65646": -8,
  "65647": -10,
  "65648": -5,
  "65649": -13,
  "65650": -16,
  "65652": 0,
  "65653": -8,
  "65654": -8,
  "65655": -19,
  "65656": -12,
  "65657": -10,
  "65658": -12,
  "65660": -14,
  "65661": -8,
  "65662": -7,
  "65663": -13,
  "65664": -7,
  "65666": -19,
  "65667": -14,
  "65668": -17,
  "65669": -8,
  "65672": -10,
  "65673": -10,
  "65674": -13,
  "65675": -13,
  "65676": -18,
  "65679": -10,
  "65680": -10,
  "65681": -11,
  "65682": -9,
  "65685": -14,
  "65686": -4,
  "65688": -12,
  "65689": -14,
  "65690": -12,
  "65692": -12,
  "65701": -19,
  "65702": -19,
  "65704": -15,
  "65705": -7,
  "65706": -13,
  "65707": -8,
  "65708": -6,
  "65710": -13,
  "65711": -14,
  "65712": -7,
  "65713": -13,
  "65714": -7,
  "65715": -19,
  "65717": -15,
  "65720": -8,
  "65721": -8,
  "65722": -7,
  "65723": -8,
  "65724": -17,
  "65725": -13,
  "65726": -10,
  "65727": -17,
  "65728": -9,
  "65729": -18,
  "65730": -13,
  "65731": -8,
  "65732": -16,
  "65733": -10,
  "65734": -10,
  "65735": -17,
  "65737": -12,
  "65738": -5,
  "65739": -1,
  "65740": -10,
  "65741": -18,
  "65742": 0,
  "65744": -10,
  "65745": -10,
  "65746": -13,
  "65747": -12,
  "65752": -9,
  "65753": -8,
  "65754": -7,
  "65755": -19,
  "65756": -8,
  "65757": -13,
  "65759": -10,
  "65760": -18,
  "65761": -19,
  "65762": -18,
  "65764": -14,
  "65765": 3,
  "65766": -19,
  "65767": -17,
  "65768": -19,
  "65769": -7,
  "65770": -13,
  "65771": -10,
  "65772": -10,
  "65773": -18,
  "65774": -17,
  "65775": -16,
  "65776": -16,
  "65777": -16,
  "65778": -12,
  "65779": -17,
  "65781": -5,
  "65783": -14,
  "65784": -19,
  "65785": -8,
  "65786": -9,
  "65787": -9,
  "65788": -15,
  "65789": -16,
  "65790": -16,
  "65791": -12,
  "65793": -16,
  "65801": 3,
  "65802": -6,
  "65803": -5,
  "65804": -4,
  "65805": -5,
  "65806": -6,
  "65807": -5,
  "65808": -4,
  "65809": 3,
  "65810": 3,
  "65814": -6,
  "65817": -5,
  "66002": -7,
  "66006": 0,
  "66007": -7,
  "66008": -1,
  "66010": -5,
  "66012": 2,
  "66013": 9,
  "66014": -5,
  "66015": -14,
  "66016": -7,
  "66017": -1,
  "66018": 9,
  "66019": 9,
  "66020": -7,
  "66021": -1,
  "66023": -7,
  "66024": 3,
  "66025": 0,
  "66026": -1,
  "66027": -7,
  "66030": 9,
  "66031": 9,
  "66032": -14,
  "66033": -13,
  "66035": -2,
  "66036": -1,
  "66039": -13,
  "66040": -5,
  "66041": -7,
  "66042": 1,
  "66043": -7,
  "66044": 0,
  "66046": 0,
  "66047": 9,
  "66048": -7,
  "66049": 9,
  "66050": 0,
  "66051": 9,
  "66052": 0,
  "66053": -1,
  "66054": 0,
  "66056": -5,
  "66058": -7,
  "66060": -7,
  "66061": 9,
  "66062": 9,
  "66063": 9,
  "66064": -1,
  "66066": 1,
  "66067": 0,
  "66070": -1,
  "66071": -1,
  "66072": -5,
  "66073": 1,
  "66075": -5,
  "66076": 0,
  "66077": -7,
  "66078": 0,
  "66079": 1,
  "66080": 0,
  "66083": -1,
  "66085": 9,
  "66086": -5,
  "66087": -1,
  "66088": -1,
  "66090": 4,
  "66091": -14,
  "66092": 1,
  "66093": -13,
  "66094": -16,
  "66095": 0,
  "66097": 0,
  "66101": 2,
  "66102": 2,
  "66103": 4,
  "66104": 2,
  "66105": 2,
  "66106": 2,
  "66109": 2,
  "66110": 2,
  "66111": 2,
  "66112": 2,
  "66113": 2,
  "66115": 2,
  "66117": 2,
  "66118": 2,
  "66119": 2,
  "66201": 9,
  "66202": 2,
  "66203": 2,
  "66204": 6,
  "66205": 4,
  "66206": 16,
  "66207": 16,
  "66208": 4,
  "66209": 17,
  "66210": 9,
  "66211": 20,
  "66212": 9,
  "66213": 10,
  "66214": 6,
  "66215": 9,
  "66216": 6,
  "66217": 15,
  "66218": 9,
  "66219": 9,
  "66220": 18,
  "66221": 20,
  "66222": 2,
  "66223": 9,
  "66224": 18,
  "66225": 10,
  "66226": 9,
  "66227": 9,
  "66250": 9,
  "66282": 9,
  "66283": 9,
  "66285": 2,
  "66286": 9,
  "66401": -15,
  "66402": -2,
  "66403": -11,
  "66404": -10,
  "66406": -10,
  "66407": -9,
  "66408": -10,
  "66409": 6,
  "66411": -11,
  "66412": -9,
  "66413": -14,
  "66414": -13,
  "66415": -10,
  "66416": -12,
  "66417": -10,
  "66418": -12,
  "66419": -12,
  "66420": -2,
  "66422": -9,
  "66423": -15,
  "66424": -18,
  "66425": -18,
  "66426": -9,
  "66427": -11,
  "66428": -10,
  "66429": -2,
  "66431": -15,
  "66432": -12,
  "66434": -18,
  "66436": -12,
  "66438": -10,
  "66439": -18,
  "66440": -12,
  "66441": -4,
  "66442": -4,
  "66449": -3,
  "66451": -14,
  "66501": -15,
  "66502": -3,
  "66503": 5,
  "66505": -3,
  "66506": -3,
  "66507": -15,
  "66508": -9,
  "66509": -12,
  "66510": -14,
  "66512": -1,
  "66514": -3,
  "66515": -18,
  "66516": -12,
  "66517": -4,
  "66518": -9,
  "66520": -3,
  "66521": -9,
  "66522": -10,
  "66523": -13,
  "66524": -11,
  "66526": -15,
  "66527": -18,
  "66528": -12,
  "66531": -3,
  "66532": -18,
  "66533": -2,
  "66534": -10,
  "66535": -9,
  "66536": -8,
  "66537": -14,
  "66538": -10,
  "66539": 6,
  "66540": -12,
  "66541": -10,
  "66542": 6,
  "66543": -13,
  "66544": -11,
  "66546": 6,
  "66547": -8,
  "66548": -11,
  "66549": -9,
  "66550": -10,
  "66552": -12,
  "66554": -3,
  "66601": -2,
  "66603": -2,
  "66604": -2,
  "66605": -2,
  "66606": -2,
  "66607": -2,
  "66608": -2,
  "66609": -2,
  "66610": 6,
  "66611": -2,
  "66612": -2,
  "66614": -2,
  "66615": 6,
  "66616": -2,
  "66617": -2,
  "66618": 6,
  "66619": -2,
  "66621": -2,
  "66647": -2,
  "66667": -2,
  "66675": -2,
  "66683": -2,
  "66701": 0,
  "66710": 3,
  "66711": -11,
  "66712": -10,
  "66713": 1,
  "66714": 2,
  "66716": -13,
  "66717": 3,
  "66720": -15,
  "66724": -10,
  "66725": 1,
  "66728": 1,
  "66732": -12,
  "66733": -15,
  "66734": -10,
  "66735": -10,
  "66736": 3,
  "66738": 2,
  "66739": 1,
  "66740": -15,
  "66741": 9,
  "66742": -11,
  "66743": -10,
  "66746": 0,
  "66748": -12,
  "66749": -11,
  "66751": -10,
  "66753": -10,
  "66754": 2,
  "66755": -10,
  "66756": -10,
  "66757": 3,
  "66758": -11,
  "66759": 3,
  "66760": -2,
  "66761": -11,
  "66762": -10,
  "66763": -10,
  "66767": -5,
  "66769": 0,
  "66770": 1,
  "66771": -15,
  "66772": -12,
  "66773": 1,
  "66775": -15,
  "66776": -15,
  "66777": -8,
  "66778": 1,
  "66779": 0,
  "66780": -15,
  "66781": 1,
  "66782": 1,
  "66783": -11,
  "66801": -10,
  "66830": -10,
  "66833": -10,
  "66834": -15,
  "66835": -10,
  "66838": -14,
  "66839": -15,
  "66840": -5,
  "66842": -14,
  "66843": -14,
  "66845": -14,
  "66846": -15,
  "66849": -15,
  "66850": -14,
  "66851": -13,
  "66852": -15,
  "66853": -8,
  "66854": -15,
  "66855": -15,
  "66856": -14,
  "66857": -13,
  "66858": -13,
  "66859": -13,
  "66860": -9,
  "66861": -13,
  "66862": -14,
  "66863": -8,
  "66864": -10,
  "66865": -10,
  "66866": -13,
  "66868": -10,
  "66869": -15,
  "66870": -8,
  "66871": -13,
  "66872": -15,
  "66873": -14,
  "66901": -14,
  "66930": -18,
  "66932": -20,
  "66933": -15,
  "66935": -18,
  "66936": -20,
  "66937": -13,
  "66938": -14,
  "66939": -18,
  "66940": -18,
  "66941": -20,
  "66942": -18,
  "66943": -13,
  "66944": -13,
  "66945": -12,
  "66946": -13,
  "66948": -14,
  "66949": -11,
  "66951": -15,
  "66952": -20,
  "66953": -13,
  "66955": -7,
  "66956": -11,
  "66958": -13,
  "66959": -18,
  "66960": -18,
  "66961": -14,
  "66962": -13,
  "66963": -11,
  "66964": -18,
  "66966": -18,
  "66967": 8,
  "66968": -13,
  "66970": -13,
  "67001": 5,
  "67002": 3,
  "67003": -4,
  "67004": -4,
  "67005": -6,
  "67008": -6,
  "67009": -4,
  "67010": -5,
  "67012": -5,
  "67013": -11,
  "67016": -6,
  "67017": -5,
  "67018": -4,
  "67019": -6,
  "67020": -6,
  "67021": -8,
  "67022": -12,
  "67023": -6,
  "67024": -6,
  "67025": -5,
  "67026": -2,
  "67028": -8,
  "67029": -15,
  "67030": 5,
  "67031": -12,
  "67035": -5,
  "67036": -4,
  "67037": 5,
  "67038": -6,
  "67039": -5,
  "67041": -6,
  "67042": -5,
  "67045": -8,
  "67047": -8,
  "67049": -3,
  "67050": -2,
  "67051": -6,
  "67052": 5,
  "67053": -6,
  "67054": -21,
  "67055": 5,
  "67056": -6,
  "67057": -11,
  "67058": -4,
  "67059": -8,
  "67060": -3,
  "67061": -11,
  "67062": -5,
  "67063": -12,
  "67065": -10,
  "67066": -8,
  "67067": -4,
  "67068": -5,
  "67070": -11,
  "67071": -10,
  "67072": -5,
  "67073": -13,
  "67074": -5,
  "67101": -3,
  "67102": -5,
  "67103": -11,
  "67104": -11,
  "67105": -12,
  "67106": 3,
  "67107": -6,
  "67108": -3,
  "67109": -21,
  "67110": -3,
  "67111": -5,
  "67112": -10,
  "67114": -6,
  "67117": -6,
  "67118": -5,
  "67119": -6,
  "67120": -10,
  "67122": -8,
  "67123": -5,
  "67124": -8,
  "67127": -15,
  "67131": -6,
  "67132": -5,
  "67133": -2,
  "67134": -8,
  "67135": -6,
  "67137": -8,
  "67138": -11,
  "67140": -12,
  "67142": -5,
  "67143": -9,
  "67144": -5,
  "67146": -5,
  "67147": -2,
  "67149": -3,
  "67150": -5,
  "67151": -6,
  "67152": -12,
  "67154": -6,
  "67155": -8,
  "67156": -6,
  "67159": -5,
  "67201": -4,
  "67202": -4,
  "67203": -4,
  "67204": -3,
  "67205": 5,
  "67206": 5,
  "67207": -3,
  "67208": -3,
  "67209": -2,
  "67210": -3,
  "67211": -4,
  "67212": -2,
  "67213": -4,
  "67214": -4,
  "67215": -3,
  "67216": -4,
  "67217": -4,
  "67218": -4,
  "67219": -4,
  "67220": -2,
  "67221": -3,
  "67223": 5,
  "67226": 5,
  "67227": -3,
  "67228": 5,
  "67230": 5,
  "67232": 5,
  "67235": 5,
  "67275": -2,
  "67276": -2,
  "67277": -2,
  "67278": -4,
  "67301": -4,
  "67330": -11,
  "67332": -11,
  "67333": -3,
  "67334": -9,
  "67335": -4,
  "67336": -11,
  "67337": -4,
  "67340": -3,
  "67341": -11,
  "67342": -11,
  "67344": -3,
  "67345": 3,
  "67346": -6,
  "67347": -3,
  "67349": -8,
  "67351": -4,
  "67352": 3,
  "67353": 3,
  "67354": -11,
  "67355": -3,
  "67356": -11,
  "67357": -11,
  "67360": -9,
  "67361": -3,
  "67363": -4,
  "67364": -3,
  "67401": -8,
  "67402": -8,
  "67410": -10,
  "67416": -8,
  "67417": -16,
  "67418": -7,
  "67420": -10,
  "67422": -19,
  "67423": -7,
  "67425": -8,
  "67427": -3,
  "67428": -2,
  "67430": -10,
  "67431": -10,
  "67432": -16,
  "67436": -21,
  "67437": -10,
  "67438": -13,
  "67439": -7,
  "67441": -10,
  "67442": -8,
  "67443": -2,
  "67444": -3,
  "67445": -16,
  "67446": -11,
  "67447": -16,
  "67448": -8,
  "67449": -15,
  "67450": -7,
  "67451": -10,
  "67452": -7,
  "67454": -7,
  "67455": -7,
  "67456": -2,
  "67457": -3,
  "67458": -16,
  "67459": -7,
  "67460": -2,
  "67464": -7,
  "67466": -16,
  "67467": -20,
  "67468": -16,
  "67470": -8,
  "67473": -11,
  "67474": -10,
  "67475": -13,
  "67476": -2,
  "67478": -11,
  "67480": -8,
  "67481": -7,
  "67482": -10,
  "67483": -13,
  "67484": -20,
  "67485": -11,
  "67487": -16,
  "67490": -7,
  "67491": -3,
  "67492": -10,
  "67501": -10,
  "67502": -10,
  "67504": -10,
  "67505": -10,
  "67510": -10,
  "67511": 1,
  "67512": -3,
  "67513": -13,
  "67514": -10,
  "67515": -15,
  "67516": -15,
  "67518": -15,
  "67519": -21,
  "67520": -13,
  "67521": -15,
  "67522": -10,
  "67523": -6,
  "67524": -3,
  "67525": 1,
  "67526": 1,
  "67529": -6,
  "67530": 1,
  "67543": -10,
  "67544": 1,
  "67545": 1,
  "67546": -2,
  "67547": -21,
  "67548": -13,
  "67550": -6,
  "67552": -21,
  "67553": -13,
  "67554": -3,
  "67556": -13,
  "67557": -21,
  "67559": -13,
  "67560": -15,
  "67561": -10,
  "67563": -21,
  "67564": 1,
  "67565": -13,
  "67566": -10,
  "67567": -6,
  "67568": -10,
  "67570": -10,
  "67572": -15,
  "67573": -3,
  "67574": -21,
  "67575": -13,
  "67576": -6,
  "67578": -8,
  "67579": -3,
  "67581": -10,
  "67583": -8,
  "67584": -15,
  "67585": -10,
  "67601": -8,
  "67621": -15,
  "67622": -15,
  "67623": -11,
  "67625": -17,
  "67626": -12,
  "67627": -9,
  "67628": -9,
  "67629": -15,
  "67631": -17,
  "67632": -17,
  "67634": -12,
  "67635": -16,
  "67637": -17,
  "67638": -10,
  "67639": -15,
  "67640": -12,
  "67642": -17,
  "67643": -15,
  "67644": -15,
  "67645": -15,
  "67646": -15,
  "67647": -17,
  "67648": -12,
  "67649": -12,
  "67650": -16,
  "67651": -11,
  "67653": -15,
  "67654": -14,
  "67656": -17,
  "67657": -17,
  "67658": -12,
  "67659": -17,
  "67660": -13,
  "67661": -14,
  "67663": -9,
  "67664": -15,
  "67665": -12,
  "67667": -13,
  "67669": -16,
  "67671": -9,
  "67672": -17,
  "67673": -12,
  "67674": -9,
  "67675": -11,
  "67701": -5,
  "67730": -9,
  "67731": -9,
  "67732": -5,
  "67733": -13,
  "67734": -5,
  "67735": -13,
  "67736": -14,
  "67737": -14,
  "67738": -14,
  "67739": -9,
  "67740": -16,
  "67741": -13,
  "67743": -5,
  "67744": -9,
  "67745": -9,
  "67747": -7,
  "67748": -6,
  "67749": -12,
  "67751": -14,
  "67752": -14,
  "67753": -7,
  "67756": -12,
  "67757": -7,
  "67758": -14,
  "67761": -14,
  "67762": -14,
  "67764": -7,
  "67801": -8,
  "67831": -15,
  "67834": -9,
  "67835": 3,
  "67836": -19,
  "67837": -13,
  "67838": -6,
  "67839": -13,
  "67840": -15,
  "67841": 2,
  "67842": -9,
  "67843": -8,
  "67844": -4,
  "67846": -6,
  "67849": -21,
  "67850": -13,
  "67851": -6,
  "67853": 2,
  "67854": -8,
  "67855": -13,
  "67857": -13,
  "67859": -4,
  "67860": -6,
  "67861": -13,
  "67862": -13,
  "67863": -12,
  "67864": -4,
  "67865": -9,
  "67867": 10,
  "67868": -7,
  "67869": -3,
  "67870": -12,
  "67871": -12,
  "67876": -8,
  "67877": -12,
  "67878": -18,
  "67879": -18,
  "67880": -13,
  "67882": -8,
  "67901": -8,
  "67905": -8,
  "67950": -8,
  "67951": -8,
  "67952": -8,
  "67953": -8,
  "67954": -8,
  "68001": -5,
  "68002": -3,
  "68003": -5,
  "68004": -11,
  "68005": -1,
  "68007": 2,
  "68008": -3,
  "68009": -3,
  "68010": 3,
  "68014": -4,
  "68015": -4,
  "68016": -12,
  "68017": -4,
  "68018": -5,
  "68019": -16,
  "68020": -17,
  "68022": 3,
  "68023": -1,
  "68025": -4,
  "68026": -4,
  "68028": 0,
  "68029": -3,
  "68030": -2,
  "68031": -4,
  "68033": -4,
  "68034": -3,
  "68036": -3,
  "68037": -12,
  "68038": -17,
  "68039": -11,
  "68040": -4,
  "68041": -5,
  "68042": -4,
  "68044": -4,
  "68045": -17,
  "68046": 0,
  "68047": -8,
  "68048": -12,
  "68050": -4,
  "68055": -8,
  "68056": 0,
  "68057": -4,
  "68058": -12,
  "68059": 0,
  "68061": -16,
  "68062": -8,
  "68063": -16,
  "68064": -3,
  "68065": -4,
  "68066": -4,
  "68067": -8,
  "68068": -3,
  "68069": 3,
  "68070": -4,
  "68071": -8,
  "68072": -4,
  "68073": -5,
  "68101": 10,
  "68102": 10,
  "68103": 10,
  "68104": 2,
  "68105": 2,
  "68106": 2,
  "68107": 0,
  "68108": 1,
  "68109": 1,
  "68110": 1,
  "68111": 2,
  "68112": 2,
  "68113": -1,
  "68114": 2,
  "68116": 11,
  "68117": 2,
  "68118": 11,
  "68119": 1,
  "68120": 3,
  "68122": 2,
  "68123": 0,
  "68124": 2,
  "68127": 2,
  "68128": 0,
  "68130": 3,
  "68131": 2,
  "68132": 2,
  "68133": 8,
  "68134": 2,
  "68135": 11,
  "68136": 8,
  "68137": 2,
  "68138": 0,
  "68139": 2,
  "68142": 2,
  "68144": 2,
  "68145": 10,
  "68147": 0,
  "68152": 2,
  "68154": 3,
  "68155": 2,
  "68157": 0,
  "68164": 2,
  "68301": -14,
  "68303": -15,
  "68304": -11,
  "68305": -15,
  "68307": -8,
  "68309": -12,
  "68310": -11,
  "68313": -8,
  "68314": -8,
  "68315": -15,
  "68316": -8,
  "68317": -2,
  "68318": -11,
  "68319": -8,
  "68320": -15,
  "68321": -15,
  "68322": -15,
  "68323": -14,
  "68324": -14,
  "68325": -15,
  "68326": -15,
  "68327": -15,
  "68328": -11,
  "68329": -14,
  "68330": -8,
  "68331": -11,
  "68332": -14,
  "68333": -11,
  "68335": -15,
  "68336": 6,
  "68337": -15,
  "68338": -7,
  "68339": 6,
  "68340": -15,
  "68341": -11,
  "68342": -7,
  "68343": -11,
  "68344": -14,
  "68345": -13,
  "68346": -8,
  "68347": -2,
  "68348": -14,
  "68349": -11,
  "68350": -7,
  "68351": 5,
  "68352": -7,
  "68354": 5,
  "68355": -15,
  "68357": -11,
  "68358": 6,
  "68359": -11,
  "68360": -8,
  "68361": 5,
  "68362": -15,
  "68364": -8,
  "68365": 4,
  "68366": -2,
  "68367": -12,
  "68368": -11,
  "68370": -15,
  "68371": -8,
  "68372": -2,
  "68375": -15,
  "68376": -13,
  "68377": -7,
  "68378": -15,
  "68379": -15,
  "68380": -14,
  "68381": -11,
  "68382": -8,
  "68401": -8,
  "68402": 6,
  "68403": -12,
  "68404": 6,
  "68405": -8,
  "68406": 5,
  "68407": -11,
  "68409": -12,
  "68410": -9,
  "68413": -12,
  "68414": -17,
  "68415": -11,
  "68416": 4,
  "68417": -8,
  "68418": -8,
  "68419": -2,
  "68420": -14,
  "68421": -16,
  "68422": -11,
  "68423": 0,
  "68424": -7,
  "68428": 6,
  "68429": -15,
  "68430": 6,
  "68431": -16,
  "68433": -15,
  "68434": -8,
  "68436": 5,
  "68437": -15,
  "68438": 6,
  "68439": -8,
  "68440": -7,
  "68441": -14,
  "68442": -15,
  "68443": -14,
  "68444": 5,
  "68445": -11,
  "68446": -8,
  "68447": -14,
  "68448": -8,
  "68450": -14,
  "68452": -8,
  "68453": 4,
  "68454": -8,
  "68455": -4,
  "68456": -8,
  "68457": -15,
  "68458": -12,
  "68460": -8,
  "68461": 6,
  "68462": -2,
  "68463": -12,
  "68464": -11,
  "68465": -11,
  "68466": -11,
  "68467": -8,
  "68501": -2,
  "68502": -2,
  "68503": -2,
  "68504": -2,
  "68505": -2,
  "68506": -1,
  "68507": -2,
  "68508": -2,
  "68509": -2,
  "68510": -2,
  "68512": 6,
  "68514": 6,
  "68516": 6,
  "68517": 6,
  "68520": 6,
  "68521": -2,
  "68522": -2,
  "68523": 6,
  "68524": -2,
  "68526": 6,
  "68527": 6,
  "68528": -2,
  "68529": -2,
  "68531": -2,
  "68532": 6,
  "68542": -2,
  "68583": -2,
  "68588": -2,
  "68601": -3,
  "68602": -3,
  "68620": -4,
  "68621": -4,
  "68622": -16,
  "68623": -13,
  "68624": -3,
  "68626": -4,
  "68627": -4,
  "68628": 25,
  "68629": -4,
  "68631": -3,
  "68632": -3,
  "68633": -10,
  "68634": -3,
  "68635": -8,
  "68636": -8,
  "68637": -15,
  "68638": -13,
  "68640": -13,
  "68641": -10,
  "68642": -3,
  "68643": -3,
  "68644": -4,
  "68647": -3,
  "68648": -4,
  "68649": -4,
  "68651": -12,
  "68652": -5,
  "68653": -3,
  "68654": -12,
  "68655": -4,
  "68658": -12,
  "68659": -3,
  "68660": -4,
  "68661": -3,
  "68662": -12,
  "68663": -12,
  "68664": -11,
  "68665": -14,
  "68666": -12,
  "68667": -12,
  "68669": -8,
  "68701": -6,
  "68702": -6,
  "68710": -2,
  "68711": -10,
  "68713": -10,
  "68714": -15,
  "68715": -6,
  "68716": -11,
  "68717": -13,
  "68718": -14,
  "68719": -19,
  "68720": -8,
  "68722": -19,
  "68723": -12,
  "68724": -14,
  "68725": -10,
  "68726": -8,
  "68727": -13,
  "68728": -12,
  "68729": -14,
  "68730": -13,
  "68731": -2,
  "68732": -12,
  "68733": -8,
  "68734": -10,
  "68735": -8,
  "68736": -13,
  "68738": -6,
  "68739": -13,
  "68740": -12,
  "68741": -2,
  "68742": -11,
  "68743": 0,
  "68745": -13,
  "68746": -19,
  "68747": -9,
  "68748": -6,
  "68749": -9,
  "68751": -13,
  "68752": -6,
  "68753": -15,
  "68755": -19,
  "68756": -8,
  "68757": -13,
  "68758": -5,
  "68759": -15,
  "68760": -13,
  "68761": -9,
  "68763": -10,
  "68764": -8,
  "68765": -9,
  "68766": -10,
  "68767": -9,
  "68768": -12,
  "68769": -9,
  "68770": -2,
  "68771": -9,
  "68773": -9,
  "68774": -13,
  "68776": -2,
  "68777": -19,
  "68778": -15,
  "68779": -6,
  "68780": -9,
  "68781": -8,
  "68783": -14,
  "68784": -12,
  "68785": -2,
  "68786": -9,
  "68787": -12,
  "68788": -11,
  "68789": -15,
  "68790": -12,
  "68791": -11,
  "68792": -13,
  "68801": -7,
  "68802": -7,
  "68803": -7,
  "68810": -7,
  "68812": -5,
  "68813": -17,
  "68814": -11,
  "68815": -10,
  "68816": 25,
  "68817": -11,
  "68818": -6,
  "68820": -7,
  "68821": -17,
  "68822": -10,
  "68823": -17,
  "68824": -7,
  "68825": -9,
  "68826": 25,
  "68827": 25,
  "68828": -11,
  "68831": -7,
  "68832": -7,
  "68833": -15,
  "68834": -9,
  "68835": -14,
  "68836": -7,
  "68837": -10,
  "68838": -7,
  "68840": -5,
  "68841": -6,
  "68842": -14,
  "68843": -6,
  "68844": -5,
  "68845": -3,
  "68846": 25,
  "68847": -5,
  "68848": -5,
  "68850": -9,
  "68852": -6,
  "68853": -10,
  "68854": 25,
  "68855": -6,
  "68856": -11,
  "68858": -5,
  "68859": -15,
  "68860": -9,
  "68861": -6,
  "68862": -10,
  "68863": -9,
  "68864": 25,
  "68865": -6,
  "68866": -5,
  "68869": -5,
  "68870": -5,
  "68871": -5,
  "68872": -7,
  "68873": -14,
  "68874": -17,
  "68875": -15,
  "68876": -5,
  "68878": -9,
  "68879": -17,
  "68881": -10,
  "68882": -15,
  "68883": -7,
  "68901": -4,
  "68902": -4,
  "68920": -17,
  "68922": -1,
  "68923": -7,
  "68924": -15,
  "68925": -4,
  "68926": -2,
  "68927": -7,
  "68928": -20,
  "68929": 7,
  "68930": -19,
  "68932": 7,
  "68933": -7,
  "68934": -8,
  "68935": -7,
  "68936": -2,
  "68937": -9,
  "68938": -7,
  "68939": 7,
  "68940": -7,
  "68941": -4,
  "68942": -20,
  "68943": -13,
  "68944": -8,
  "68945": -15,
  "68946": -1,
  "68947": 8,
  "68948": -2,
  "68949": -7,
  "68950": -4,
  "68952": -20,
  "68954": -7,
  "68955": -4,
  "68956": -4,
  "68957": -20,
  "68958": -7,
  "68959": -15,
  "68960": 7,
  "68961": -13,
  "68964": -13,
  "68966": -18,
  "68967": -17,
  "68969": -7,
  "68970": -20,
  "68971": -17,
  "68972": 7,
  "68973": -4,
  "68974": -13,
  "68975": -7,
  "68976": -9,
  "68977": -18,
  "68978": -13,
  "68979": -7,
  "68980": -8,
  "68981": 7,
  "68982": -7,
  "69001": -12,
  "69020": -12,
  "69021": -14,
  "69022": -1,
  "69023": -14,
  "69024": -14,
  "69025": -12,
  "69026": -12,
  "69027": -14,
  "69028": -9,
  "69029": -9,
  "69030": -14,
  "69032": -14,
  "69033": -14,
  "69034": -12,
  "69036": -12,
  "69037": -13,
  "69038": 5,
  "69039": -12,
  "69040": -14,
  "69041": -14,
  "69042": -12,
  "69043": -14,
  "69044": -14,
  "69045": -14,
  "69046": -2,
  "69101": 5,
  "69103": 5,
  "69120": 5,
  "69121": -12,
  "69122": -16,
  "69123": 5,
  "69125": -19,
  "69127": -16,
  "69128": -20,
  "69129": -10,
  "69130": -9,
  "69131": -10,
  "69132": 6,
  "69133": -20,
  "69134": -7,
  "69135": -16,
  "69138": -9,
  "69140": -7,
  "69141": -10,
  "69142": -15,
  "69143": 5,
  "69144": -16,
  "69145": -20,
  "69146": -16,
  "69147": -16,
  "69148": -18,
  "69149": -10,
  "69150": -7,
  "69151": 5,
  "69152": -13,
  "69153": -16,
  "69154": -10,
  "69155": -16,
  "69156": -10,
  "69157": -15,
  "69161": -13,
  "69162": -10,
  "69163": 5,
  "69165": 5,
  "69166": -16,
  "69167": 5,
  "69168": -7,
  "69169": -7,
  "69170": 6,
  "69171": -9,
  "69201": -6,
  "69210": -15,
  "69211": -13,
  "69212": -6,
  "69214": -15,
  "69216": -6,
  "69217": -15,
  "69218": -16,
  "69219": -6,
  "69220": -16,
  "69221": -16,
  "69301": -6,
  "69331": -18,
  "69333": -13,
  "69334": -18,
  "69335": -8,
  "69336": -18,
  "69337": -15,
  "69339": -15,
  "69340": -8,
  "69341": 1,
  "69343": -15,
  "69345": 1,
  "69346": -15,
  "69347": -15,
  "69348": -8,
  "69350": -13,
  "69351": -8,
  "69352": 1,
  "69353": 1,
  "69354": -15,
  "69355": 1,
  "69356": 1,
  "69357": 1,
  "69358": 1,
  "69360": -15,
  "69361": 1,
  "69363": 1,
  "69365": -17,
  "69366": -13,
  "69367": -15,
  "70001": 8,
  "70002": 16,
  "70003": 8,
  "70004": 9,
  "70005": 16,
  "70006": 9,
  "70009": 16,
  "70010": 16,
  "70011": 16,
  "70030": 54,
  "70031": 55,
  "70032": 15,
  "70033": 8,
  "70036": 7,
  "70037": 4,
  "70038": 22,
  "70039": 54,
  "70040": 4,
  "70041": 22,
  "70043": 4,
  "70044": 4,
  "70047": 55,
  "70049": 54,
  "70050": 22,
  "70051": 8,
  "70052": 8,
  "70053": 15,
  "70054": 15,
  "70055": 16,
  "70056": 15,
  "70057": 54,
  "70058": 7,
  "70059": 15,
  "70062": 7,
  "70063": 7,
  "70064": 8,
  "70065": 8,
  "70067": 7,
  "70068": 54,
  "70069": 54,
  "70070": 55,
  "70071": 8,
  "70072": 7,
  "70073": 7,
  "70075": 4,
  "70076": 8,
  "70078": 55,
  "70079": 54,
  "70080": 54,
  "70081": 22,
  "70082": 22,
  "70083": 22,
  "70084": 9,
  "70085": 4,
  "70086": 8,
  "70087": 54,
  "70090": 8,
  "70091": 22,
  "70092": 4,
  "70093": 4,
  "70094": 9,
  "70096": 7,
  "70097": 4,
  "70112": 16,
  "70113": 15,
  "70114": 15,
  "70115": 9,
  "70116": 15,
  "70117": 15,
  "70118": 8,
  "70119": 15,
  "70121": 7,
  "70122": 15,
  "70123": 9,
  "70124": 24,
  "70125": 8,
  "70126": 15,
  "70127": 15,
  "70128": 15,
  "70129": 4,
  "70130": 24,
  "70131": 16,
  "70139": 16,
  "70140": 16,
  "70141": 7,
  "70145": 15,
  "70146": 15,
  "70149": 15,
  "70150": 15,
  "70151": 15,
  "70152": 15,
  "70153": 15,
  "70156": 15,
  "70157": 15,
  "70158": 15,
  "70160": 15,
  "70161": 15,
  "70163": 16,
  "70170": 16,
  "70172": 16,
  "70174": 15,
  "70175": 9,
  "70176": 24,
  "70177": 15,
  "70178": 8,
  "70179": 15,
  "70181": 15,
  "70182": 15,
  "70183": 9,
  "70184": 24,
  "70185": 8,
  "70186": 15,
  "70187": 15,
  "70189": 4,
  "70190": 24,
  "70301": 8,
  "70302": 8,
  "70339": 8,
  "70340": 7,
  "70341": 7,
  "70342": 7,
  "70343": 9,
  "70344": 7,
  "70345": 9,
  "70346": 17,
  "70352": 7,
  "70353": 7,
  "70354": 9,
  "70355": 9,
  "70356": 7,
  "70357": 9,
  "70358": 21,
  "70359": 7,
  "70360": 16,
  "70361": 16,
  "70363": 7,
  "70364": 7,
  "70371": 54,
  "70372": 7,
  "70373": 9,
  "70374": 9,
  "70375": 9,
  "70377": 9,
  "70380": 7,
  "70381": 7,
  "70390": 7,
  "70391": 7,
  "70392": 7,
  "70393": 8,
  "70394": 9,
  "70395": 7,
  "70397": 7,
  "70401": 3,
  "70403": 3,
  "70404": 3,
  "70420": 5,
  "70421": 3,
  "70422": 3,
  "70426": -6,
  "70427": -5,
  "70429": -5,
  "70431": 5,
  "70433": 5,
  "70434": 5,
  "70435": 5,
  "70436": 3,
  "70437": 3,
  "70438": -4,
  "70441": 8,
  "70442": 3,
  "70443": 3,
  "70444": 3,
  "70445": 5,
  "70446": 3,
  "70447": 5,
  "70448": 7,
  "70449": 17,
  "70450": -4,
  "70451": 3,
  "70452": 5,
  "70453": 5,
  "70454": 3,
  "70455": 3,
  "70456": 3,
  "70457": 5,
  "70458": 5,
  "70459": 5,
  "70460": 5,
  "70461": 5,
  "70462": 5,
  "70463": 5,
  "70464": 4,
  "70465": 3,
  "70466": 3,
  "70467": -6,
  "70469": 5,
  "70470": 13,
  "70471": 13,
  "70500": 7,
  "70501": 7,
  "70502": 7,
  "70503": 16,
  "70505": 9,
  "70506": 9,
  "70507": 8,
  "70508": 16,
  "70509": 7,
  "70510": 1,
  "70511": 1,
  "70512": 2,
  "70513": 7,
  "70514": 8,
  "70515": -4,
  "70516": 5,
  "70517": 1,
  "70518": 9,
  "70519": 9,
  "70520": 8,
  "70521": 1,
  "70522": 8,
  "70523": 8,
  "70524": -4,
  "70525": 1,
  "70526": 5,
  "70527": 5,
  "70528": 7,
  "70529": 7,
  "70531": 5,
  "70532": -10,
  "70533": 2,
  "70534": 5,
  "70535": -4,
  "70537": -4,
  "70538": 8,
  "70540": 8,
  "70541": 1,
  "70542": 1,
  "70543": 5,
  "70544": 7,
  "70546": -5,
  "70548": 1,
  "70549": -6,
  "70550": 1,
  "70551": 1,
  "70552": 7,
  "70554": -4,
  "70555": 8,
  "70556": -4,
  "70558": 8,
  "70559": 5,
  "70560": 7,
  "70562": 7,
  "70563": 7,
  "70569": 7,
  "70570": 1,
  "70571": 1,
  "70575": 1,
  "70576": -5,
  "70577": 1,
  "70578": 5,
  "70580": -4,
  "70581": -5,
  "70582": 1,
  "70583": 7,
  "70584": 2,
  "70585": -4,
  "70586": -4,
  "70589": 1,
  "70591": -5,
  "70592": 16,
  "70593": 7,
  "70595": 7,
  "70596": 7,
  "70598": 16,
  "70601": 0,
  "70602": 0,
  "70605": 0,
  "70606": 9,
  "70607": 0,
  "70611": 9,
  "70612": 0,
  "70615": 0,
  "70616": 0,
  "70629": 0,
  "70630": 5,
  "70631": 4,
  "70632": 4,
  "70633": 0,
  "70634": -7,
  "70637": -16,
  "70638": -17,
  "70639": -9,
  "70640": -13,
  "70643": 5,
  "70644": -17,
  "70645": 4,
  "70646": -13,
  "70647": -12,
  "70648": -16,
  "70650": -13,
  "70651": -17,
  "70652": -8,
  "70653": -8,
  "70654": -17,
  "70655": -17,
  "70656": -17,
  "70657": 0,
  "70658": 0,
  "70659": -8,
  "70660": -8,
  "70661": 0,
  "70662": -17,
  "70663": 0,
  "70664": 0,
  "70665": 0,
  "70668": 0,
  "70669": 0,
  "70704": 19,
  "70706": 5,
  "70707": 17,
  "70710": 17,
  "70711": 3,
  "70712": 20,
  "70714": 19,
  "70715": -7,
  "70718": 17,
  "70719": 14,
  "70721": 16,
  "70722": 5,
  "70723": 9,
  "70725": 17,
  "70726": 5,
  "70727": 5,
  "70728": 17,
  "70729": -7,
  "70730": 8,
  "70732": -6,
  "70733": 17,
  "70734": 16,
  "70736": -7,
  "70737": 17,
  "70738": 17,
  "70739": 19,
  "70740": 14,
  "70743": 8,
  "70744": 5,
  "70747": 20,
  "70748": 8,
  "70749": -6,
  "70750": -6,
  "70752": -7,
  "70753": 20,
  "70754": 5,
  "70755": -6,
  "70756": -6,
  "70757": -6,
  "70759": -6,
  "70760": -6,
  "70761": 8,
  "70762": 2,
  "70763": 8,
  "70764": 17,
  "70765": 17,
  "70767": 14,
  "70769": 17,
  "70770": 19,
  "70772": 14,
  "70773": -6,
  "70774": 17,
  "70775": 20,
  "70776": 17,
  "70777": 19,
  "70778": 17,
  "70780": 17,
  "70782": 20,
  "70783": -6,
  "70784": 20,
  "70785": 5,
  "70786": 5,
  "70787": 20,
  "70788": 17,
  "70789": 8,
  "70791": 19,
  "70792": 8,
  "70801": 28,
  "70802": 19,
  "70804": 19,
  "70805": 19,
  "70806": 19,
  "70807": 19,
  "70808": 28,
  "70809": 21,
  "70810": 28,
  "70811": 19,
  "70812": 19,
  "70814": 19,
  "70815": 19,
  "70816": 19,
  "70817": 28,
  "70818": 19,
  "70819": 19,
  "70820": 23,
  "70821": 19,
  "70825": 19,
  "70826": 21,
  "70827": 19,
  "70831": 28,
  "70835": 19,
  "70836": 28,
  "70837": 19,
  "70873": 19,
  "70874": 19,
  "70879": 28,
  "70884": 28,
  "70892": 19,
  "70893": 28,
  "70894": 28,
  "70895": 19,
  "70896": 28,
  "70898": 28,
  "71001": -10,
  "71002": -7,
  "71003": 14,
  "71004": -6,
  "71006": 2,
  "71007": 2,
  "71008": -13,
  "71009": -6,
  "71016": -13,
  "71018": -3,
  "71019": -7,
  "71021": -3,
  "71023": -3,
  "71024": -13,
  "71027": 1,
  "71028": -14,
  "71029": -6,
  "71030": 1,
  "71031": -16,
  "71032": 1,
  "71033": -5,
  "71034": -7,
  "71037": 2,
  "71038": 14,
  "71039": -13,
  "71040": 14,
  "71043": -7,
  "71044": -10,
  "71045": -13,
  "71046": 1,
  "71047": -6,
  "71048": 14,
  "71049": 0,
  "71050": 1,
  "71051": -7,
  "71052": 0,
  "71055": -3,
  "71058": -3,
  "71060": -6,
  "71061": -6,
  "71063": -7,
  "71064": -6,
  "71065": -13,
  "71066": -11,
  "71067": 2,
  "71068": -7,
  "71069": -11,
  "71070": -14,
  "71071": -3,
  "71072": -3,
  "71073": -3,
  "71075": -3,
  "71078": 1,
  "71079": 14,
  "71080": -14,
  "71082": -6,
  "71101": -6,
  "71102": -6,
  "71103": -6,
  "71104": -6,
  "71105": 3,
  "71106": 2,
  "71107": -6,
  "71108": -6,
  "71109": -6,
  "71110": 2,
  "71111": 2,
  "71112": -5,
  "71113": -5,
  "71115": 3,
  "71118": -5,
  "71119": -5,
  "71120": -6,
  "71129": -6,
  "71130": -6,
  "71133": -6,
  "71134": -6,
  "71135": 3,
  "71136": 2,
  "71137": -6,
  "71138": -5,
  "71148": -6,
  "71149": -6,
  "71150": -6,
  "71161": -6,
  "71162": -6,
  "71163": -6,
  "71164": -6,
  "71165": -6,
  "71166": -6,
  "71171": -6,
  "71172": 2,
  "71201": 1,
  "71202": -8,
  "71203": 1,
  "71207": 1,
  "71210": 1,
  "71211": -8,
  "71213": 1,
  "71217": 1,
  "71218": -11,
  "71219": -11,
  "71220": -12,
  "71221": -12,
  "71222": -10,
  "71223": -13,
  "71225": 1,
  "71226": -20,
  "71227": -10,
  "71229": -13,
  "71230": -19,
  "71232": -11,
  "71233": -20,
  "71234": -10,
  "71235": -10,
  "71237": -12,
  "71238": -6,
  "71240": -8,
  "71241": -10,
  "71242": -12,
  "71243": -19,
  "71245": -1,
  "71247": -14,
  "71249": -19,
  "71250": -12,
  "71251": -15,
  "71253": -12,
  "71254": -20,
  "71256": -10,
  "71259": -11,
  "71260": -10,
  "71261": -13,
  "71263": -12,
  "71264": -11,
  "71266": -12,
  "71268": -10,
  "71269": -11,
  "71270": -1,
  "71273": -1,
  "71275": -10,
  "71276": -20,
  "71277": -10,
  "71279": -11,
  "71280": 1,
  "71281": 1,
  "71282": -20,
  "71284": -20,
  "71286": -20,
  "71291": 1,
  "71292": -8,
  "71294": 1,
  "71295": -19,
  "71301": -3,
  "71302": -3,
  "71303": 6,
  "71306": -3,
  "71307": -3,
  "71309": -3,
  "71315": -3,
  "71316": -7,
  "71320": -9,
  "71322": -9,
  "71323": -3,
  "71324": -19,
  "71325": -9,
  "71326": -14,
  "71327": -9,
  "71328": -1,
  "71329": -9,
  "71330": -9,
  "71331": -9,
  "71333": -9,
  "71334": -14,
  "71336": -19,
  "71339": -9,
  "71340": -10,
  "71341": -9,
  "71342": -16,
  "71343": -11,
  "71345": -6,
  "71346": -3,
  "71348": -3,
  "71350": -9,
  "71351": -9,
  "71353": -13,
  "71354": -14,
  "71355": -9,
  "71356": -9,
  "71357": -20,
  "71358": -6,
  "71360": -3,
  "71361": -3,
  "71362": -9,
  "71363": -16,
  "71365": -3,
  "71366": -19,
  "71367": -12,
  "71368": -19,
  "71369": -9,
  "71371": -16,
  "71373": -14,
  "71375": -14,
  "71377": -11,
  "71378": -19,
  "71401": -11,
  "71403": -9,
  "71404": -16,
  "71405": -3,
  "71406": -13,
  "71407": 0,
  "71409": -3,
  "71410": -16,
  "71411": -11,
  "71414": -11,
  "71415": -20,
  "71416": -12,
  "71417": 0,
  "71418": -19,
  "71419": -13,
  "71422": -16,
  "71423": 0,
  "71424": -3,
  "71425": -10,
  "71426": -13,
  "71427": 0,
  "71428": -3,
  "71429": -13,
  "71430": -3,
  "71431": -3,
  "71432": -16,
  "71433": -3,
  "71434": -12,
  "71435": -10,
  "71438": -3,
  "71439": -9,
  "71440": -16,
  "71441": -10,
  "71443": -9,
  "71446": -9,
  "71447": 0,
  "71448": -3,
  "71449": -13,
  "71450": -13,
  "71452": -11,
  "71454": -11,
  "71455": 0,
  "71456": -11,
  "71457": -10,
  "71458": -10,
  "71459": -8,
  "71460": -13,
  "71461": -9,
  "71462": -13,
  "71463": -17,
  "71465": -16,
  "71466": -3,
  "71467": 0,
  "71468": -11,
  "71469": -13,
  "71471": -11,
  "71472": -3,
  "71473": -16,
  "71474": -9,
  "71475": -9,
  "71477": -3,
  "71479": -16,
  "71480": -16,
  "71483": -16,
  "71485": 6,
  "71486": -13,
  "71496": -9,
  "71601": -14,
  "71602": -14,
  "71603": -14,
  "71611": -14,
  "71612": -14,
  "71613": -14,
  "71630": -15,
  "71631": -20,
  "71635": -4,
  "71638": -10,
  "71639": -15,
  "71640": -12,
  "71642": -6,
  "71643": -9,
  "71644": -9,
  "71646": -4,
  "71647": -20,
  "71651": -19,
  "71652": -16,
  "71653": -15,
  "71654": -15,
  "71655": -10,
  "71656": -10,
  "71657": -10,
  "71658": -5,
  "71659": -9,
  "71660": -20,
  "71661": -5,
  "71662": -15,
  "71663": -5,
  "71665": -14,
  "71666": -15,
  "71667": -9,
  "71670": -15,
  "71671": -20,
  "71674": -6,
  "71675": -10,
  "71676": -5,
  "71677": -15,
  "71678": -9,
  "71701": -11,
  "71711": -11,
  "71720": -10,
  "71721": -5,
  "71722": -11,
  "71724": 0,
  "71725": -16,
  "71726": -11,
  "71728": -5,
  "71730": 1,
  "71731": 1,
  "71740": -13,
  "71742": -15,
  "71743": -5,
  "71744": -10,
  "71745": -10,
  "71747": -10,
  "71748": -15,
  "71749": 0,
  "71750": 0,
  "71751": -11,
  "71752": -15,
  "71753": -14,
  "71754": -14,
  "71758": -11,
  "71759": 0,
  "71762": 1,
  "71763": -15,
  "71764": -15,
  "71765": 0,
  "71766": -10,
  "71768": 1,
  "71770": -15,
  "71772": -5,
  "71801": -13,
  "71802": -13,
  "71820": 1,
  "71822": -7,
  "71823": -8,
  "71825": -13,
  "71826": -10,
  "71827": -10,
  "71828": -15,
  "71831": -13,
  "71832": -4,
  "71833": 8,
  "71834": -11,
  "71835": -13,
  "71836": -8,
  "71837": -11,
  "71838": -13,
  "71839": -10,
  "71840": -3,
  "71841": -5,
  "71842": -4,
  "71845": -10,
  "71846": -5,
  "71847": -13,
  "71851": -1,
  "71852": 8,
  "71853": -11,
  "71854": -3,
  "71855": -13,
  "71857": -13,
  "71858": -15,
  "71859": -13,
  "71860": -10,
  "71861": -10,
  "71862": -13,
  "71864": -15,
  "71865": -8,
  "71866": -4,
  "71901": -12,
  "71902": -12,
  "71903": -12,
  "71909": -10,
  "71910": -10,
  "71913": -12,
  "71914": -12,
  "71920": -21,
  "71921": -21,
  "71922": -5,
  "71923": 3,
  "71929": -4,
  "71932": -10,
  "71933": -17,
  "71935": -18,
  "71937": -11,
  "71940": -21,
  "71941": -15,
  "71942": -15,
  "71943": -21,
  "71944": -5,
  "71945": -10,
  "71949": -12,
  "71950": -21,
  "71951": -12,
  "71952": -13,
  "71953": -10,
  "71956": -12,
  "71957": -18,
  "71958": -21,
  "71959": -1,
  "71960": -18,
  "71961": -18,
  "71962": -5,
  "71964": -12,
  "71965": -18,
  "71966": -18,
  "71968": -12,
  "71969": -18,
  "71970": -18,
  "71971": -1,
  "71972": -11,
  "71973": -11,
  "72001": -12,
  "72002": -7,
  "72003": -11,
  "72004": -14,
  "72005": -4,
  "72006": -15,
  "72007": -6,
  "72010": -10,
  "72011": -7,
  "72012": -10,
  "72013": -13,
  "72014": -4,
  "72015": -7,
  "72016": 0,
  "72017": -12,
  "72018": -7,
  "72019": -7,
  "72020": -2,
  "72021": -19,
  "72022": -6,
  "72023": 1,
  "72024": -8,
  "72025": -12,
  "72026": -2,
  "72027": -1,
  "72028": -13,
  "72029": -20,
  "72030": -1,
  "72031": -13,
  "72032": -5,
  "72033": -5,
  "72034": -5,
  "72036": -15,
  "72037": -8,
  "72038": -2,
  "72039": -5,
  "72040": -12,
  "72041": -12,
  "72042": -11,
  "72043": -4,
  "72044": -11,
  "72045": -7,
  "72046": -7,
  "72047": -6,
  "72048": -11,
  "72051": -21,
  "72052": -11,
  "72053": -2,
  "72055": -11,
  "72057": 4,
  "72058": -5,
  "72059": -15,
  "72060": -10,
  "72061": -5,
  "72063": -1,
  "72064": -12,
  "72065": -1,
  "72066": -8,
  "72067": -11,
  "72068": -11,
  "72069": -20,
  "72070": -12,
  "72072": -9,
  "72073": -11,
  "72074": -15,
  "72075": -4,
  "72076": -2,
  "72078": -2,
  "72079": 4,
  "72080": -1,
  "72081": -10,
  "72082": -11,
  "72083": -7,
  "72084": 4,
  "72085": -10,
  "72086": -8,
  "72087": -7,
  "72088": -13,
  "72089": -6,
  "72101": -14,
  "72102": -10,
  "72103": -1,
  "72104": -15,
  "72105": -15,
  "72106": -5,
  "72107": -6,
  "72108": -19,
  "72110": -2,
  "72111": -7,
  "72112": -4,
  "72113": 0,
  "72114": -2,
  "72115": -2,
  "72116": 7,
  "72117": -2,
  "72118": -2,
  "72119": -2,
  "72120": -2,
  "72121": -10,
  "72122": -7,
  "72123": -14,
  "72124": 7,
  "72125": -12,
  "72126": -12,
  "72127": -2,
  "72128": 5,
  "72129": 5,
  "72130": -11,
  "72131": -11,
  "72132": 4,
  "72133": -9,
  "72134": -19,
  "72135": 0,
  "72136": -10,
  "72137": -11,
  "72139": -10,
  "72140": -11,
  "72141": -14,
  "72142": -7,
  "72143": -9,
  "72145": -9,
  "72150": 4,
  "72152": -14,
  "72153": -13,
  "72156": -2,
  "72157": -1,
  "72158": -7,
  "72160": -9,
  "72164": -1,
  "72165": -2,
  "72166": -15,
  "72167": -7,
  "72168": -14,
  "72169": -14,
  "72170": -11,
  "72173": -5,
  "72175": -14,
  "72176": -8,
  "72178": -11,
  "72179": -11,
  "72180": -1,
  "72181": -6,
  "72182": -14,
  "72183": -1,
  "72190": 7,
  "72201": -2,
  "72202": -1,
  "72203": -1,
  "72204": -1,
  "72205": 0,
  "72206": -1,
  "72207": 1,
  "72209": -1,
  "72210": -1,
  "72211": 0,
  "72212": 8,
  "72214": -2,
  "72215": 0,
  "72216": -2,
  "72217": 1,
  "72219": -1,
  "72221": 8,
  "72222": -1,
  "72223": -2,
  "72225": 0,
  "72227": 1,
  "72231": -2,
  "72260": -2,
  "72295": -2,
  "72301": 0,
  "72303": 0,
  "72310": 5,
  "72311": -20,
  "72312": -19,
  "72313": 4,
  "72315": 5,
  "72316": 5,
  "72319": 5,
  "72320": -13,
  "72321": 14,
  "72322": -13,
  "72324": -13,
  "72325": 0,
  "72326": -13,
  "72327": 0,
  "72328": -19,
  "72329": 4,
  "72330": 4,
  "72331": -1,
  "72332": -1,
  "72333": -19,
  "72335": -13,
  "72336": -13,
  "72338": 4,
  "72339": -1,
  "72340": -13,
  "72341": -13,
  "72342": -19,
  "72346": -1,
  "72347": -13,
  "72348": -13,
  "72350": 4,
  "72351": 5,
  "72352": -13,
  "72353": -19,
  "72354": -13,
  "72355": -13,
  "72358": 5,
  "72359": -13,
  "72360": -13,
  "72364": 8,
  "72365": -13,
  "72366": -19,
  "72367": -19,
  "72368": -13,
  "72369": -19,
  "72370": 5,
  "72372": -13,
  "72373": -15,
  "72374": -19,
  "72376": -1,
  "72377": -13,
  "72379": -15,
  "72383": -19,
  "72384": -1,
  "72386": -15,
  "72387": -14,
  "72389": -19,
  "72390": -19,
  "72391": 4,
  "72392": -20,
  "72394": -13,
  "72395": 4,
  "72396": -14,
  "72401": 2,
  "72402": 2,
  "72403": 2,
  "72404": 2,
  "72410": 0,
  "72411": -7,
  "72412": -8,
  "72413": -18,
  "72414": -7,
  "72415": 0,
  "72416": -7,
  "72417": -7,
  "72419": 5,
  "72421": -1,
  "72422": -16,
  "72424": -19,
  "72425": -7,
  "72426": 5,
  "72427": -1,
  "72428": 5,
  "72429": -4,
  "72430": -17,
  "72431": -4,
  "72432": -13,
  "72433": 0,
  "72434": 0,
  "72435": -17,
  "72436": -7,
  "72437": -7,
  "72438": 5,
  "72439": -6,
  "72440": 0,
  "72441": -17,
  "72442": 5,
  "72443": -7,
  "72444": -18,
  "72445": 0,
  "72447": -7,
  "72449": -19,
  "72450": -7,
  "72451": -7,
  "72453": -8,
  "72454": -16,
  "72455": -18,
  "72456": -16,
  "72457": 0,
  "72458": 0,
  "72459": -11,
  "72460": -18,
  "72461": -16,
  "72462": -19,
  "72464": -16,
  "72465": -7,
  "72466": 0,
  "72467": 2,
  "72469": 0,
  "72470": -16,
  "72471": -4,
  "72472": -13,
  "72473": -4,
  "72474": -6,
  "72475": -4,
  "72476": 0,
  "72478": -18,
  "72479": -13,
  "72482": -11,
  "72501": -9,
  "72503": -9,
  "72512": -13,
  "72513": -11,
  "72515": -4,
  "72517": -13,
  "72519": -4,
  "72520": -13,
  "72521": -9,
  "72522": -9,
  "72523": -8,
  "72524": -4,
  "72525": -11,
  "72526": -9,
  "72527": -9,
  "72528": -11,
  "72529": -11,
  "72530": -11,
  "72531": -4,
  "72532": -11,
  "72533": -20,
  "72534": -8,
  "72536": -13,
  "72537": -13,
  "72538": -14,
  "72539": -4,
  "72540": -21,
  "72542": -11,
  "72543": -11,
  "72544": -13,
  "72546": -11,
  "72550": -8,
  "72553": -9,
  "72554": -11,
  "72555": -8,
  "72556": -13,
  "72560": -20,
  "72561": -13,
  "72562": -9,
  "72564": -4,
  "72565": -13,
  "72566": -12,
  "72567": -21,
  "72568": -10,
  "72569": -11,
  "72571": -9,
  "72572": 0,
  "72573": -13,
  "72575": -9,
  "72576": -13,
  "72577": -11,
  "72578": -11,
  "72579": -9,
  "72581": -11,
  "72583": -11,
  "72584": -13,
  "72585": -4,
  "72587": -13,
  "72601": -13,
  "72602": -13,
  "72611": -12,
  "72613": -12,
  "72615": -13,
  "72616": -12,
  "72617": -21,
  "72619": -13,
  "72623": -13,
  "72624": -14,
  "72626": -13,
  "72628": -13,
  "72629": -14,
  "72630": -10,
  "72631": -10,
  "72632": -4,
  "72633": -14,
  "72634": -13,
  "72635": -14,
  "72636": -13,
  "72638": -12,
  "72639": -21,
  "72640": -13,
  "72641": -13,
  "72642": -13,
  "72644": -10,
  "72645": -14,
  "72648": -14,
  "72650": -14,
  "72651": -14,
  "72653": -13,
  "72654": -13,
  "72655": -13,
  "72657": -21,
  "72658": -11,
  "72659": -11,
  "72660": -12,
  "72661": -19,
  "72662": -12,
  "72663": -21,
  "72666": -13,
  "72668": -18,
  "72669": -14,
  "72670": -14,
  "72672": -13,
  "72675": -13,
  "72677": -13,
  "72679": -14,
  "72680": -21,
  "72682": -14,
  "72683": -13,
  "72685": -14,
  "72686": -14,
  "72687": -13,
  "72701": 9,
  "72702": 9,
  "72703": 9,
  "72704": 1,
  "72711": -4,
  "72712": -4,
  "72714": -4,
  "72715": 4,
  "72717": 1,
  "72718": -4,
  "72719": -4,
  "72721": 2,
  "72722": -4,
  "72727": -6,
  "72728": 2,
  "72729": -8,
  "72730": 1,
  "72732": -4,
  "72733": -4,
  "72734": -4,
  "72735": -7,
  "72736": -4,
  "72737": 9,
  "72738": -7,
  "72739": 4,
  "72740": -7,
  "72741": 9,
  "72742": -6,
  "72744": 1,
  "72745": -4,
  "72747": -4,
  "72749": 1,
  "72751": -4,
  "72752": -6,
  "72753": 1,
  "72756": -4,
  "72757": -4,
  "72758": -4,
  "72760": -6,
  "72761": -4,
  "72762": 2,
  "72764": 0,
  "72765": 0,
  "72766": 0,
  "72768": -4,
  "72769": 1,
  "72770": 2,
  "72773": -6,
  "72774": 1,
  "72776": -6,
  "72801": -2,
  "72802": -2,
  "72811": -2,
  "72812": -2,
  "72820": -14,
  "72821": -14,
  "72823": -2,
  "72824": -11,
  "72826": -9,
  "72827": -14,
  "72828": -12,
  "72829": -2,
  "72830": -15,
  "72832": -15,
  "72833": -11,
  "72834": -2,
  "72835": -15,
  "72837": -2,
  "72838": -13,
  "72839": -14,
  "72840": -15,
  "72841": -13,
  "72842": -9,
  "72843": -2,
  "72845": -13,
  "72846": -14,
  "72847": -2,
  "72851": -15,
  "72852": -14,
  "72853": -2,
  "72854": -14,
  "72855": -9,
  "72856": -13,
  "72857": -12,
  "72858": -2,
  "72860": -12,
  "72863": -15,
  "72865": -7,
  "72901": -9,
  "72902": -9,
  "72903": -1,
  "72904": -9,
  "72906": -1,
  "72908": -1,
  "72913": -9,
  "72914": -9,
  "72916": -1,
  "72917": -1,
  "72918": -1,
  "72921": -1,
  "72923": -9,
  "72926": -13,
  "72927": -9,
  "72928": -9,
  "72930": -14,
  "72932": -9,
  "72933": -14,
  "72934": -9,
  "72935": -1,
  "72936": -1,
  "72937": -9,
  "72938": -9,
  "72940": -9,
  "72941": -8,
  "72943": -9,
  "72944": -13,
  "72945": -10,
  "72946": -9,
  "72947": -14,
  "72948": -9,
  "72949": -14,
  "72950": -13,
  "72951": -9,
  "72952": -9,
  "72955": -9,
  "72956": -9,
  "72957": -9,
  "72958": -13,
  "72959": 1,
  "73001": 0,
  "73002": -6,
  "73003": -1,
  "73004": -6,
  "73005": 0,
  "73006": 0,
  "73007": -2,
  "73008": -2,
  "73009": 0,
  "73010": -6,
  "73011": -6,
  "73012": -1,
  "73013": -1,
  "73014": -9,
  "73015": 0,
  "73016": -8,
  "73017": -7,
  "73018": -6,
  "73020": -2,
  "73021": -6,
  "73022": -9,
  "73023": -6,
  "73024": -7,
  "73025": -1,
  "73026": -5,
  "73027": -8,
  "73028": -9,
  "73029": 0,
  "73030": -6,
  "73031": -6,
  "73032": -8,
  "73033": 0,
  "73034": 7,
  "73036": -9,
  "73038": 0,
  "73039": -1,
  "73040": -12,
  "73041": -18,
  "73042": 0,
  "73043": -12,
  "73044": -8,
  "73045": 6,
  "73047": 0,
  "73048": -8,
  "73049": -2,
  "73050": -8,
  "73051": -6,
  "73052": -7,
  "73053": 0,
  "73054": -1,
  "73055": -7,
  "73056": -8,
  "73057": -2,
  "73058": -8,
  "73059": -9,
  "73061": -7,
  "73062": -18,
  "73063": -8,
  "73064": -9,
  "73065": -5,
  "73066": -2,
  "73067": -7,
  "73068": -5,
  "73069": -5,
  "73070": -5,
  "73071": -5,
  "73072": 3,
  "73073": -8,
  "73074": -1,
  "73075": -1,
  "73077": -7,
  "73078": -9,
  "73079": -7,
  "73080": -6,
  "73082": -7,
  "73083": 7,
  "73084": -2,
  "73085": -9,
  "73086": -6,
  "73089": -7,
  "73090": -9,
  "73092": -6,
  "73093": -6,
  "73094": 0,
  "73095": -6,
  "73096": -6,
  "73097": -2,
  "73098": -2,
  "73099": -9,
  "73101": -2,
  "73102": -2,
  "73103": -2,
  "73104": -2,
  "73105": -2,
  "73106": -2,
  "73107": -2,
  "73108": -2,
  "73109": -2,
  "73110": -2,
  "73111": -2,
  "73112": -2,
  "73113": -2,
  "73114": -2,
  "73115": -2,
  "73116": -1,
  "73117": -2,
  "73118": -2,
  "73119": -2,
  "73120": -2,
  "73121": -2,
  "73122": -2,
  "73123": -2,
  "73124": -2,
  "73125": -2,
  "73126": -2,
  "73127": -2,
  "73128": -2,
  "73129": -2,
  "73130": -2,
  "73131": 7,
  "73132": -2,
  "73134": 7,
  "73135": -2,
  "73136": 7,
  "73137": -2,
  "73139": -2,
  "73140": -2,
  "73141": -2,
  "73142": -1,
  "73143": -2,
  "73144": -2,
  "73145": -2,
  "73146": -2,
  "73147": -2,
  "73148": -2,
  "73149": -2,
  "73150": -1,
  "73151": 7,
  "73152": -2,
  "73153": 0,
  "73154": -2,
  "73155": -2,
  "73156": -2,
  "73157": -2,
  "73159": -2,
  "73160": -2,
  "73162": -1,
  "73163": -2,
  "73164": -2,
  "73165": 3,
  "73167": -2,
  "73169": -2,
  "73170": -2,
  "73172": -2,
  "73173": 7,
  "73178": -1,
  "73179": -2,
  "73189": -2,
  "73195": -2,
  "73401": -9,
  "73402": -9,
  "73403": -9,
  "73425": -7,
  "73430": -12,
  "73432": -8,
  "73433": -2,
  "73434": -1,
  "73435": -8,
  "73436": -8,
  "73437": -8,
  "73438": -8,
  "73439": -8,
  "73440": -8,
  "73441": -11,
  "73442": -11,
  "73443": -9,
  "73444": -2,
  "73446": -8,
  "73447": -9,
  "73448": -13,
  "73449": -2,
  "73450": -9,
  "73453": -11,
  "73455": -9,
  "73456": -11,
  "73458": -9,
  "73459": -13,
  "73460": -8,
  "73461": -9,
  "73463": -9,
  "73481": -8,
  "73487": -2,
  "73488": 6,
  "73491": -7,
  "73501": -8,
  "73502": -8,
  "73503": 0,
  "73505": -7,
  "73506": -7,
  "73507": -8,
  "73520": -11,
  "73521": -18,
  "73522": -18,
  "73523": -18,
  "73526": -18,
  "73527": -8,
  "73528": -8,
  "73529": -7,
  "73530": -9,
  "73531": -8,
  "73532": -18,
  "73533": -7,
  "73534": -7,
  "73537": -18,
  "73538": -8,
  "73539": -18,
  "73540": -8,
  "73541": -8,
  "73542": -9,
  "73543": -8,
  "73544": -18,
  "73546": -9,
  "73547": -18,
  "73548": -8,
  "73549": -17,
  "73550": -18,
  "73551": -8,
  "73552": -8,
  "73553": 0,
  "73554": -18,
  "73555": -18,
  "73556": -18,
  "73557": 0,
  "73558": -8,
  "73559": -18,
  "73560": -18,
  "73561": -11,
  "73562": -9,
  "73564": -18,
  "73565": -11,
  "73566": -18,
  "73567": -9,
  "73568": -8,
  "73569": -11,
  "73570": -18,
  "73571": -18,
  "73572": -8,
  "73573": -11,
  "73601": -8,
  "73620": -8,
  "73622": -7,
  "73624": -7,
  "73625": -8,
  "73626": -6,
  "73627": -6,
  "73628": -11,
  "73632": -7,
  "73638": -12,
  "73639": -9,
  "73641": -7,
  "73642": -11,
  "73644": -5,
  "73645": -6,
  "73646": -13,
  "73647": -7,
  "73648": -5,
  "73650": -11,
  "73651": -18,
  "73654": -12,
  "73655": -18,
  "73658": -13,
  "73659": -14,
  "73660": -11,
  "73661": -7,
  "73662": -6,
  "73663": -14,
  "73664": -7,
  "73666": -6,
  "73667": -14,
  "73668": -6,
  "73669": -9,
  "73673": -18,
  "73701": -8,
  "73702": -8,
  "73703": 1,
  "73705": -8,
  "73706": 1,
  "73716": -13,
  "73717": -17,
  "73718": -13,
  "73719": 0,
  "73720": 1,
  "73722": 0,
  "73724": -13,
  "73726": 0,
  "73727": -8,
  "73728": 0,
  "73729": -13,
  "73730": -8,
  "73731": -17,
  "73733": -8,
  "73734": -5,
  "73735": -7,
  "73736": -8,
  "73737": -13,
  "73738": -8,
  "73739": 0,
  "73741": 0,
  "73742": -5,
  "73743": -8,
  "73744": -13,
  "73746": -17,
  "73747": -13,
  "73749": 0,
  "73750": -4,
  "73753": -7,
  "73754": -8,
  "73755": -13,
  "73756": -5,
  "73757": 1,
  "73758": 0,
  "73759": -5,
  "73760": -12,
  "73761": 0,
  "73762": -9,
  "73763": -13,
  "73764": -13,
  "73766": -8,
  "73768": -13,
  "73770": -13,
  "73771": 0,
  "73772": -13,
  "73773": -8,
  "73801": -9,
  "73802": -9,
  "73832": -19,
  "73834": -15,
  "73835": -14,
  "73838": -14,
  "73840": -19,
  "73841": -9,
  "73842": -17,
  "73843": -19,
  "73844": -15,
  "73848": -15,
  "73851": -14,
  "73852": -9,
  "73853": -14,
  "73855": -15,
  "73857": -9,
  "73858": -19,
  "73859": -14,
  "73860": -17,
  "73901": -5,
  "73931": -7,
  "73932": -7,
  "73933": -5,
  "73937": -5,
  "73938": -7,
  "73939": -10,
  "73942": -5,
  "73944": -8,
  "73945": -5,
  "73946": -13,
  "73947": -11,
  "73949": -10,
  "73950": -7,
  "73951": -7,
  "74001": -10,
  "74002": -10,
  "74003": -9,
  "74005": -9,
  "74006": -8,
  "74008": 0,
  "74010": -5,
  "74011": 0,
  "74012": 0,
  "74013": 0,
  "74014": 6,
  "74015": -5,
  "74016": -5,
  "74017": -5,
  "74018": -5,
  "74019": -5,
  "74020": -12,
  "74021": -5,
  "74022": -9,
  "74023": -3,
  "74026": -2,
  "74027": -14,
  "74028": -7,
  "74029": -9,
  "74030": -6,
  "74031": -5,
  "74032": -1,
  "74033": -1,
  "74034": -12,
  "74035": -10,
  "74036": -2,
  "74037": 0,
  "74038": -12,
  "74039": -5,
  "74041": -5,
  "74042": -14,
  "74043": 0,
  "74044": -5,
  "74045": -12,
  "74046": -7,
  "74047": -9,
  "74048": -14,
  "74050": -2,
  "74051": -9,
  "74052": -12,
  "74053": -5,
  "74054": -12,
  "74055": 4,
  "74056": -10,
  "74058": -12,
  "74059": -2,
  "74060": -12,
  "74061": -8,
  "74062": -3,
  "74063": -1,
  "74066": -5,
  "74067": -5,
  "74068": -6,
  "74070": -1,
  "74071": -6,
  "74072": -15,
  "74073": -1,
  "74074": 6,
  "74075": 6,
  "74076": 6,
  "74079": -2,
  "74080": -5,
  "74081": -12,
  "74082": -8,
  "74083": -14,
  "74084": -10,
  "74085": -12,
  "74101": -1,
  "74102": 4,
  "74103": 7,
  "74104": -1,
  "74105": 0,
  "74106": -2,
  "74107": -1,
  "74108": -1,
  "74110": -2,
  "74112": -1,
  "74114": -1,
  "74115": -2,
  "74116": -1,
  "74117": -1,
  "74119": -1,
  "74120": 7,
  "74121": 7,
  "74126": -2,
  "74127": -1,
  "74128": -1,
  "74129": -1,
  "74130": -2,
  "74131": -2,
  "74132": 0,
  "74133": 7,
  "74134": -1,
  "74135": 7,
  "74136": 7,
  "74137": 7,
  "74145": -1,
  "74146": -1,
  "74147": -1,
  "74148": -2,
  "74149": -1,
  "74150": -1,
  "74152": -1,
  "74153": 7,
  "74155": -1,
  "74156": -2,
  "74157": -2,
  "74158": -2,
  "74159": -1,
  "74169": -1,
  "74170": 7,
  "74172": 7,
  "74301": -10,
  "74330": -1,
  "74331": -6,
  "74332": -10,
  "74333": -10,
  "74335": -15,
  "74337": -1,
  "74338": -7,
  "74339": -15,
  "74340": -6,
  "74342": -6,
  "74343": -15,
  "74344": 1,
  "74345": 1,
  "74346": -6,
  "74347": -7,
  "74349": -7,
  "74350": -6,
  "74352": -1,
  "74354": -15,
  "74355": -15,
  "74358": -15,
  "74359": -7,
  "74360": -15,
  "74361": -1,
  "74362": -1,
  "74363": -15,
  "74364": 0,
  "74365": -1,
  "74366": -1,
  "74367": -6,
  "74368": -7,
  "74369": -10,
  "74370": -15,
  "74401": -9,
  "74402": -9,
  "74403": -8,
  "74421": -9,
  "74422": -9,
  "74423": -9,
  "74425": -13,
  "74426": -13,
  "74427": -9,
  "74428": -13,
  "74429": -2,
  "74430": -7,
  "74431": -9,
  "74432": -13,
  "74434": -8,
  "74435": -9,
  "74436": -3,
  "74437": -9,
  "74438": -13,
  "74439": -9,
  "74440": -10,
  "74441": -9,
  "74442": -8,
  "74444": -9,
  "74445": -9,
  "74446": -9,
  "74447": -9,
  "74450": -8,
  "74451": -8,
  "74452": -9,
  "74454": -3,
  "74455": -10,
  "74456": -9,
  "74457": -13,
  "74458": -3,
  "74459": -13,
  "74460": -9,
  "74461": -13,
  "74462": -10,
  "74463": -9,
  "74464": -8,
  "74465": -8,
  "74467": -2,
  "74468": -9,
  "74469": -9,
  "74470": -10,
  "74471": -9,
  "74472": -10,
  "74477": -2,
  "74501": -8,
  "74502": -8,
  "74521": -6,
  "74522": -8,
  "74523": -7,
  "74525": -18,
  "74528": -8,
  "74529": -7,
  "74530": -9,
  "74531": -9,
  "74533": -18,
  "74534": 7,
  "74535": 7,
  "74536": -13,
  "74538": 6,
  "74540": -14,
  "74542": -18,
  "74543": -14,
  "74545": -5,
  "74546": -7,
  "74547": -7,
  "74549": -13,
  "74552": -10,
  "74553": -8,
  "74554": -8,
  "74555": -18,
  "74556": 6,
  "74557": -14,
  "74558": -13,
  "74559": -5,
  "74560": -9,
  "74561": -10,
  "74562": -14,
  "74563": -5,
  "74565": -8,
  "74567": -14,
  "74569": -18,
  "74570": -9,
  "74571": -5,
  "74572": 6,
  "74574": -5,
  "74576": 7,
  "74577": -15,
  "74578": -5,
  "74601": -5,
  "74602": -5,
  "74604": 3,
  "74630": -7,
  "74631": -5,
  "74632": -5,
  "74633": -10,
  "74636": -5,
  "74637": -10,
  "74640": -8,
  "74641": -5,
  "74643": -5,
  "74644": -7,
  "74646": 3,
  "74647": -5,
  "74650": -12,
  "74651": -7,
  "74652": -10,
  "74653": -5,
  "74701": -2,
  "74702": -2,
  "74720": -2,
  "74721": -2,
  "74722": -13,
  "74723": -2,
  "74724": -6,
  "74726": -2,
  "74727": -7,
  "74728": -6,
  "74729": -2,
  "74730": -2,
  "74731": -9,
  "74733": -2,
  "74734": -6,
  "74735": -7,
  "74736": -6,
  "74737": -6,
  "74738": -8,
  "74740": -6,
  "74741": -2,
  "74743": -7,
  "74745": -6,
  "74747": -2,
  "74748": -9,
  "74750": -6,
  "74752": -13,
  "74753": -7,
  "74754": -6,
  "74755": -6,
  "74756": -7,
  "74759": -8,
  "74760": -7,
  "74761": -7,
  "74764": -6,
  "74766": -6,
  "74801": -12,
  "74802": -12,
  "74804": -4,
  "74818": -12,
  "74820": -9,
  "74821": -9,
  "74824": -2,
  "74825": -9,
  "74826": -12,
  "74827": -9,
  "74829": -8,
  "74830": -13,
  "74831": -2,
  "74832": -2,
  "74833": -8,
  "74834": -1,
  "74836": -9,
  "74837": -8,
  "74839": -8,
  "74840": -12,
  "74842": -9,
  "74843": -7,
  "74844": -10,
  "74845": -15,
  "74848": -9,
  "74849": -12,
  "74850": -9,
  "74851": -12,
  "74852": -12,
  "74854": -13,
  "74855": -2,
  "74856": -9,
  "74857": 1,
  "74859": -8,
  "74860": -8,
  "74864": -2,
  "74865": -9,
  "74866": -13,
  "74867": -10,
  "74868": -12,
  "74869": -2,
  "74871": -9,
  "74872": -9,
  "74873": -12,
  "74875": -2,
  "74878": -12,
  "74880": -8,
  "74881": -2,
  "74883": -9,
  "74884": -13,
  "74901": -9,
  "74902": -9,
  "74930": -14,
  "74931": -13,
  "74932": -14,
  "74935": -15,
  "74936": -13,
  "74937": -15,
  "74939": -15,
  "74940": -14,
  "74941": -10,
  "74942": -5,
  "74943": -10,
  "74944": -10,
  "74945": -14,
  "74946": -10,
  "74947": -15,
  "74948": -13,
  "74949": -15,
  "74951": -15,
  "74953": -14,
  "74954": -9,
  "74955": -13,
  "74956": -14,
  "74957": -11,
  "74959": -9,
  "74960": -13,
  "74962": -13,
  "74963": -11,
  "74964": -13,
  "74965": -13,
  "74966": -14,
  "75001": 11,
  "75002": 11,
  "75006": 11,
  "75007": 6,
  "75009": 12,
  "75010": 6,
  "75011": 11,
  "75013": 12,
  "75014": 11,
  "75015": 11,
  "75016": 11,
  "75017": 11,
  "75019": 6,
  "75020": -4,
  "75021": -4,
  "75022": 15,
  "75023": 12,
  "75024": 12,
  "75025": 12,
  "75026": 12,
  "75027": 15,
  "75028": 7,
  "75029": 6,
  "75030": 1,
  "75032": 2,
  "75034": 13,
  "75035": 12,
  "75038": 11,
  "75039": 22,
  "75040": 1,
  "75041": 11,
  "75042": 11,
  "75043": 1,
  "75044": 11,
  "75045": 11,
  "75046": 1,
  "75047": 11,
  "75048": 1,
  "75049": 1,
  "75050": 11,
  "75051": 11,
  "75052": 8,
  "75053": 11,
  "75054": 11,
  "75056": 6,
  "75057": 6,
  "75058": -3,
  "75060": 11,
  "75061": 11,
  "75062": 11,
  "75063": 11,
  "75065": 6,
  "75067": 7,
  "75068": 6,
  "75069": 11,
  "75070": 13,
  "75071": 11,
  "75074": 11,
  "75075": 12,
  "75076": -2,
  "75077": 6,
  "75078": 12,
  "75080": 11,
  "75081": 11,
  "75082": 12,
  "75083": 11,
  "75085": 11,
  "75086": 11,
  "75087": 2,
  "75088": 1,
  "75089": 1,
  "75090": -4,
  "75091": -4,
  "75092": -3,
  "75093": 15,
  "75094": 12,
  "75097": 12,
  "75098": 1,
  "75101": -1,
  "75102": -7,
  "75103": -6,
  "75104": -1,
  "75105": -6,
  "75106": -1,
  "75109": -6,
  "75110": -6,
  "75114": -5,
  "75115": 11,
  "75116": 11,
  "75117": -6,
  "75118": -5,
  "75119": -1,
  "75120": -1,
  "75121": -4,
  "75123": 11,
  "75124": -8,
  "75125": -1,
  "75126": 1,
  "75127": -7,
  "75132": 1,
  "75134": 11,
  "75135": -3,
  "75137": 11,
  "75138": 11,
  "75140": -7,
  "75141": 11,
  "75142": -5,
  "75143": -8,
  "75144": -6,
  "75146": -1,
  "75147": -9,
  "75148": -9,
  "75149": 11,
  "75150": 11,
  "75151": -6,
  "75152": -1,
  "75153": -6,
  "75154": -1,
  "75155": -6,
  "75156": -9,
  "75157": -5,
  "75158": -5,
  "75159": -5,
  "75160": -5,
  "75161": -5,
  "75163": -8,
  "75164": 1,
  "75165": -1,
  "75166": 1,
  "75167": -1,
  "75168": -1,
  "75169": -6,
  "75172": 11,
  "75173": 1,
  "75180": 11,
  "75181": 11,
  "75182": 2,
  "75185": 11,
  "75187": 11,
  "75189": 1,
  "75201": 21,
  "75202": 11,
  "75203": 11,
  "75204": 11,
  "75205": 21,
  "75206": 11,
  "75207": 11,
  "75208": 11,
  "75209": 11,
  "75210": 11,
  "75211": 11,
  "75212": 11,
  "75214": 11,
  "75215": 11,
  "75216": 11,
  "75217": 11,
  "75218": 11,
  "75219": 11,
  "75220": 11,
  "75221": 11,
  "75222": 11,
  "75223": 11,
  "75224": 11,
  "75225": 21,
  "75226": 21,
  "75227": 11,
  "75228": 11,
  "75229": 11,
  "75230": 19,
  "75231": 11,
  "75232": 11,
  "75233": 11,
  "75234": 11,
  "75235": 11,
  "75236": 11,
  "75237": 11,
  "75238": 11,
  "75240": 11,
  "75241": 11,
  "75242": 11,
  "75243": 11,
  "75244": 11,
  "75245": 11,
  "75246": 11,
  "75247": 11,
  "75248": 11,
  "75249": 11,
  "75250": 21,
  "75251": 11,
  "75252": 12,
  "75253": 11,
  "75254": 11,
  "75258": 11,
  "75260": 11,
  "75261": 11,
  "75262": 11,
  "75263": 11,
  "75264": 11,
  "75265": 11,
  "75266": 11,
  "75267": 11,
  "75270": 11,
  "75287": 11,
  "75313": 21,
  "75315": 11,
  "75334": 11,
  "75336": 11,
  "75339": 11,
  "75340": 11,
  "75342": 11,
  "75343": 11,
  "75344": 11,
  "75354": 11,
  "75355": 11,
  "75356": 11,
  "75357": 11,
  "75359": 11,
  "75360": 11,
  "75367": 19,
  "75370": 11,
  "75371": 11,
  "75372": 11,
  "75374": 11,
  "75376": 11,
  "75378": 11,
  "75379": 12,
  "75380": 11,
  "75381": 11,
  "75382": 11,
  "75398": 11,
  "75401": -4,
  "75402": -3,
  "75403": -4,
  "75404": -4,
  "75407": 11,
  "75409": 10,
  "75410": -8,
  "75411": 6,
  "75412": -2,
  "75413": -7,
  "75414": -3,
  "75415": -7,
  "75416": -2,
  "75417": -2,
  "75418": -7,
  "75420": -9,
  "75421": -2,
  "75422": -4,
  "75423": -4,
  "75424": 10,
  "75425": -1,
  "75426": -2,
  "75428": -4,
  "75429": -4,
  "75431": -9,
  "75432": -10,
  "75433": -9,
  "75434": -2,
  "75435": -2,
  "75436": -2,
  "75437": -9,
  "75438": -7,
  "75439": -7,
  "75440": -8,
  "75441": -2,
  "75442": -4,
  "75443": -5,
  "75444": -8,
  "75446": -7,
  "75447": -5,
  "75448": -10,
  "75449": -7,
  "75450": 6,
  "75451": -4,
  "75452": -6,
  "75453": -8,
  "75454": 10,
  "75455": -1,
  "75456": -1,
  "75457": -13,
  "75458": -4,
  "75459": -3,
  "75460": -2,
  "75461": -2,
  "75462": 6,
  "75468": -2,
  "75469": -7,
  "75470": -3,
  "75471": -13,
  "75472": -8,
  "75473": 6,
  "75474": -3,
  "75475": -7,
  "75476": -5,
  "75477": -3,
  "75478": -14,
  "75479": -7,
  "75480": -5,
  "75481": -9,
  "75482": -8,
  "75483": -8,
  "75485": 10,
  "75486": -1,
  "75487": -2,
  "75488": -7,
  "75489": -3,
  "75490": -6,
  "75491": -6,
  "75492": -5,
  "75493": -14,
  "75494": 1,
  "75495": 5,
  "75496": -7,
  "75497": 1,
  "75501": -9,
  "75503": -1,
  "75504": -9,
  "75505": -9,
  "75550": -2,
  "75551": -7,
  "75554": -2,
  "75555": -8,
  "75556": -7,
  "75558": 6,
  "75559": -9,
  "75560": -8,
  "75561": -9,
  "75562": -8,
  "75563": -8,
  "75564": -4,
  "75565": -8,
  "75566": -8,
  "75567": -9,
  "75568": -8,
  "75569": -9,
  "75570": -9,
  "75571": -8,
  "75572": -8,
  "75573": -9,
  "75574": -9,
  "75601": -6,
  "75602": -7,
  "75603": -7,
  "75604": -6,
  "75605": 2,
  "75606": -6,
  "75607": 2,
  "75608": -6,
  "75615": -7,
  "75630": -8,
  "75631": 2,
  "75633": 2,
  "75636": -8,
  "75637": -9,
  "75638": -8,
  "75639": 2,
  "75640": -3,
  "75641": -7,
  "75642": 2,
  "75643": 2,
  "75644": -3,
  "75645": -3,
  "75647": -6,
  "75650": -3,
  "75651": -8,
  "75652": -5,
  "75653": -5,
  "75654": -5,
  "75656": -8,
  "75657": -4,
  "75658": -8,
  "75659": -4,
  "75660": 2,
  "75661": -4,
  "75662": -6,
  "75663": -6,
  "75666": -6,
  "75667": -8,
  "75668": -8,
  "75669": -9,
  "75670": -4,
  "75671": -4,
  "75672": -4,
  "75680": -5,
  "75681": -9,
  "75682": -8,
  "75683": -3,
  "75684": -8,
  "75685": -4,
  "75686": -4,
  "75687": -8,
  "75688": 4,
  "75689": -8,
  "75691": 3,
  "75692": -4,
  "75693": 2,
  "75694": -4,
  "75701": -6,
  "75702": -6,
  "75703": 2,
  "75704": -6,
  "75705": -6,
  "75706": -6,
  "75707": -5,
  "75708": -6,
  "75709": -6,
  "75710": -6,
  "75711": -6,
  "75712": -6,
  "75713": -6,
  "75750": -6,
  "75751": -8,
  "75752": -8,
  "75754": -7,
  "75755": -3,
  "75756": -6,
  "75757": 2,
  "75758": -6,
  "75759": -5,
  "75760": -7,
  "75762": 2,
  "75763": -6,
  "75764": -5,
  "75765": 1,
  "75766": -5,
  "75770": -9,
  "75771": 2,
  "75772": -5,
  "75773": 1,
  "75778": -9,
  "75779": -6,
  "75780": -5,
  "75782": -6,
  "75783": 1,
  "75784": -5,
  "75785": -5,
  "75788": -5,
  "75789": -5,
  "75790": -6,
  "75791": 2,
  "75792": -6,
  "75801": -6,
  "75802": -6,
  "75803": -6,
  "75831": -3,
  "75832": -6,
  "75833": -3,
  "75834": -5,
  "75835": -5,
  "75838": -14,
  "75839": -6,
  "75840": -13,
  "75844": -4,
  "75845": -10,
  "75846": -2,
  "75847": -4,
  "75848": -14,
  "75849": -4,
  "75850": -3,
  "75851": -5,
  "75852": -10,
  "75853": -6,
  "75855": -6,
  "75856": -5,
  "75858": -4,
  "75859": -5,
  "75860": -14,
  "75861": -6,
  "75862": -10,
  "75865": -10,
  "75901": -4,
  "75902": -4,
  "75903": -4,
  "75904": -4,
  "75915": -4,
  "75925": -5,
  "75926": -5,
  "75928": -2,
  "75929": -7,
  "75930": -7,
  "75931": -14,
  "75932": -13,
  "75933": -3,
  "75934": -4,
  "75935": -8,
  "75936": -1,
  "75937": -8,
  "75938": -1,
  "75939": -4,
  "75941": -5,
  "75942": -1,
  "75943": -7,
  "75944": -8,
  "75946": -7,
  "75948": -13,
  "75949": -5,
  "75951": -2,
  "75954": -8,
  "75956": -3,
  "75958": -5,
  "75959": -13,
  "75960": -4,
  "75961": -5,
  "75963": -5,
  "75964": -7,
  "75965": -5,
  "75966": -2,
  "75968": -14,
  "75969": -4,
  "75972": -7,
  "75973": -8,
  "75974": -9,
  "75975": -9,
  "75976": -7,
  "75977": -13,
  "75978": -7,
  "75979": -1,
  "75980": -5,
  "76001": 8,
  "76002": 8,
  "76003": 8,
  "76004": 7,
  "76005": 7,
  "76006": 16,
  "76007": 7,
  "76008": 8,
  "76009": 1,
  "76010": 7,
  "76011": 7,
  "76012": 9,
  "76013": 8,
  "76014": 7,
  "76015": 8,
  "76016": 8,
  "76017": 8,
  "76018": 8,
  "76020": 0,
  "76021": 8,
  "76022": 8,
  "76023": -2,
  "76028": 0,
  "76031": 0,
  "76033": 0,
  "76034": 8,
  "76035": -3,
  "76036": 0,
  "76039": 7,
  "76040": 7,
  "76041": -1,
  "76043": 14,
  "76044": 0,
  "76048": -3,
  "76049": -2,
  "76050": 1,
  "76051": 6,
  "76052": 15,
  "76053": 8,
  "76054": 16,
  "76055": 1,
  "76058": 0,
  "76059": 0,
  "76060": 8,
  "76061": 1,
  "76063": 8,
  "76064": -1,
  "76065": -1,
  "76066": 0,
  "76067": -11,
  "76068": -11,
  "76070": 14,
  "76071": -3,
  "76073": -2,
  "76077": 14,
  "76078": -1,
  "76082": 0,
  "76084": 1,
  "76085": 0,
  "76086": 0,
  "76087": 0,
  "76088": 0,
  "76092": 17,
  "76093": 0,
  "76094": 8,
  "76095": 8,
  "76096": 8,
  "76097": 0,
  "76098": 0,
  "76099": 6,
  "76101": 6,
  "76102": 6,
  "76103": 6,
  "76104": 6,
  "76105": 6,
  "76106": 6,
  "76107": 6,
  "76108": 6,
  "76109": 15,
  "76110": 6,
  "76111": 6,
  "76112": 7,
  "76113": 6,
  "76114": 6,
  "76115": 6,
  "76116": 7,
  "76117": 6,
  "76118": 7,
  "76119": 6,
  "76120": 8,
  "76121": 7,
  "76123": 7,
  "76124": 7,
  "76126": 7,
  "76127": 6,
  "76131": 7,
  "76132": 15,
  "76133": 6,
  "76134": 6,
  "76135": 6,
  "76136": 7,
  "76137": 7,
  "76140": 6,
  "76147": 6,
  "76148": 6,
  "76150": 6,
  "76155": 7,
  "76161": 6,
  "76162": 6,
  "76163": 6,
  "76164": 6,
  "76177": 15,
  "76179": 7,
  "76180": 7,
  "76181": 7,
  "76182": 8,
  "76185": 7,
  "76201": 6,
  "76202": 6,
  "76203": 6,
  "76204": 6,
  "76205": 6,
  "76206": 6,
  "76207": 6,
  "76208": 6,
  "76209": 6,
  "76210": 6,
  "76225": -1,
  "76226": 15,
  "76227": 6,
  "76228": -10,
  "76230": -6,
  "76233": -3,
  "76234": -1,
  "76238": -6,
  "76239": -5,
  "76240": -6,
  "76241": -6,
  "76244": 15,
  "76245": -4,
  "76246": -1,
  "76247": 6,
  "76248": 15,
  "76249": 6,
  "76250": -6,
  "76251": -5,
  "76252": -6,
  "76253": -6,
  "76255": -6,
  "76258": 6,
  "76259": 6,
  "76261": -10,
  "76262": 7,
  "76263": -6,
  "76264": -3,
  "76265": -5,
  "76266": 6,
  "76267": -1,
  "76268": -4,
  "76270": -5,
  "76271": -7,
  "76272": -6,
  "76273": -7,
  "76301": -9,
  "76302": -8,
  "76305": -9,
  "76306": -9,
  "76307": -9,
  "76308": 0,
  "76309": -9,
  "76310": -1,
  "76311": -9,
  "76351": -12,
  "76352": -10,
  "76354": -9,
  "76357": -10,
  "76360": -9,
  "76363": -15,
  "76364": -9,
  "76365": -10,
  "76366": -12,
  "76367": -9,
  "76369": -11,
  "76370": 13,
  "76371": -13,
  "76372": 13,
  "76373": -9,
  "76374": 13,
  "76377": -10,
  "76379": -11,
  "76380": -15,
  "76384": -15,
  "76385": -15,
  "76388": -13,
  "76389": -10,
  "76401": -6,
  "76424": -8,
  "76426": -1,
  "76427": -5,
  "76429": -8,
  "76430": -2,
  "76431": -1,
  "76432": -12,
  "76433": -6,
  "76435": -9,
  "76436": -4,
  "76437": -9,
  "76439": 0,
  "76442": -16,
  "76443": 1,
  "76444": -16,
  "76445": -8,
  "76446": -6,
  "76448": -8,
  "76449": -11,
  "76450": 14,
  "76452": -16,
  "76453": -11,
  "76454": -9,
  "76455": -16,
  "76457": -4,
  "76458": -5,
  "76459": -5,
  "76460": 15,
  "76461": -6,
  "76462": -3,
  "76463": -11,
  "76464": -2,
  "76465": -6,
  "76466": -9,
  "76467": -6,
  "76468": -16,
  "76469": 1,
  "76470": -9,
  "76471": -9,
  "76472": -11,
  "76474": -16,
  "76475": -11,
  "76476": -3,
  "76481": 14,
  "76483": -15,
  "76484": -11,
  "76485": 0,
  "76486": -5,
  "76487": 0,
  "76490": 0,
  "76491": -8,
  "76501": 2,
  "76502": 10,
  "76503": 10,
  "76504": 2,
  "76505": 2,
  "76511": 2,
  "76513": 3,
  "76518": 2,
  "76519": 2,
  "76520": 2,
  "76522": -8,
  "76523": 2,
  "76524": -6,
  "76525": -4,
  "76526": -9,
  "76527": 4,
  "76528": -8,
  "76530": 4,
  "76531": 5,
  "76533": 2,
  "76534": 2,
  "76537": 4,
  "76538": -3,
  "76539": -11,
  "76540": 1,
  "76541": 1,
  "76542": 2,
  "76543": 2,
  "76544": -8,
  "76547": 1,
  "76548": 1,
  "76549": 1,
  "76550": -11,
  "76554": 2,
  "76556": 2,
  "76557": 2,
  "76558": -9,
  "76559": 1,
  "76561": -9,
  "76564": 3,
  "76565": 5,
  "76566": -8,
  "76567": 2,
  "76569": 2,
  "76570": -9,
  "76571": 10,
  "76573": 4,
  "76574": 6,
  "76577": 2,
  "76578": 4,
  "76579": 3,
  "76621": -1,
  "76622": -1,
  "76623": -1,
  "76624": -6,
  "76626": -7,
  "76627": -1,
  "76628": -1,
  "76629": -7,
  "76630": -6,
  "76631": -1,
  "76632": -9,
  "76633": 2,
  "76634": 14,
  "76635": -11,
  "76636": 1,
  "76637": 14,
  "76638": 2,
  "76639": -7,
  "76640": -6,
  "76641": -7,
  "76642": -11,
  "76643": 2,
  "76644": -1,
  "76645": -1,
  "76648": -1,
  "76649": 14,
  "76650": -1,
  "76651": -1,
  "76652": 13,
  "76653": -11,
  "76654": -6,
  "76655": 2,
  "76656": 2,
  "76657": -6,
  "76660": -1,
  "76661": -9,
  "76664": -11,
  "76665": 14,
  "76666": -1,
  "76667": -11,
  "76670": -1,
  "76671": 14,
  "76673": -6,
  "76676": -1,
  "76678": -11,
  "76679": -7,
  "76680": -10,
  "76681": -7,
  "76682": -9,
  "76684": -6,
  "76685": -9,
  "76686": -11,
  "76687": -11,
  "76689": 14,
  "76690": 12,
  "76691": -1,
  "76692": -1,
  "76693": -11,
  "76701": -7,
  "76702": -7,
  "76703": -7,
  "76704": -7,
  "76705": -7,
  "76706": -6,
  "76707": -7,
  "76708": -6,
  "76710": -5,
  "76711": -7,
  "76712": 2,
  "76714": -5,
  "76715": -6,
  "76716": -6,
  "76798": -6,
  "76801": -12,
  "76802": -12,
  "76803": -12,
  "76804": -11,
  "76820": -2,
  "76821": 88,
  "76823": -12,
  "76824": -13,
  "76825": -10,
  "76827": -11,
  "76828": -9,
  "76831": -2,
  "76832": -13,
  "76834": -9,
  "76836": -10,
  "76837": -7,
  "76841": -7,
  "76842": -10,
  "76844": -16,
  "76845": -1,
  "76848": -7,
  "76849": -4,
  "76852": -10,
  "76853": -11,
  "76854": -4,
  "76855": -8,
  "76856": -11,
  "76857": -12,
  "76858": -19,
  "76859": -7,
  "76861": -7,
  "76862": -18,
  "76864": -15,
  "76865": 88,
  "76866": 89,
  "76869": -2,
  "76870": -16,
  "76871": -13,
  "76872": -18,
  "76873": -8,
  "76874": -4,
  "76875": 89,
  "76877": -13,
  "76878": -8,
  "76880": -16,
  "76882": -9,
  "76883": -4,
  "76884": -9,
  "76885": -13,
  "76886": 1,
  "76887": -2,
  "76888": -9,
  "76890": -12,
  "76901": -8,
  "76902": -8,
  "76903": -8,
  "76904": -8,
  "76905": -8,
  "76906": -8,
  "76908": 1,
  "76930": 13,
  "76932": 2,
  "76933": -1,
  "76934": -8,
  "76935": 13,
  "76936": 13,
  "76937": -8,
  "76939": 1,
  "76940": -8,
  "76941": -7,
  "76943": 2,
  "76945": -1,
  "76949": -1,
  "76950": 2,
  "76951": -1,
  "76953": 0,
  "76955": -7,
  "76957": 1,
  "76958": 0,
  "77001": 11,
  "77002": 12,
  "77003": 11,
  "77004": 12,
  "77005": 23,
  "77006": 20,
  "77007": 12,
  "77008": 12,
  "77009": 12,
  "77010": 12,
  "77011": 11,
  "77012": 11,
  "77013": 12,
  "77014": 12,
  "77015": 12,
  "77016": 11,
  "77017": 12,
  "77018": 12,
  "77019": 23,
  "77020": 11,
  "77021": 12,
  "77022": 12,
  "77023": 12,
  "77024": 23,
  "77025": 12,
  "77026": 11,
  "77027": 23,
  "77028": 11,
  "77029": 12,
  "77030": 23,
  "77031": 27,
  "77032": 12,
  "77033": 11,
  "77034": 12,
  "77035": 12,
  "77036": 12,
  "77037": 12,
  "77038": 12,
  "77039": 12,
  "77040": 12,
  "77041": 12,
  "77042": 12,
  "77043": 12,
  "77044": 12,
  "77045": 12,
  "77046": 20,
  "77047": 12,
  "77048": 12,
  "77049": 12,
  "77050": 12,
  "77051": 11,
  "77052": 12,
  "77053": 27,
  "77054": 12,
  "77055": 12,
  "77056": 23,
  "77057": 12,
  "77058": 13,
  "77059": 14,
  "77060": 12,
  "77061": 12,
  "77062": 5,
  "77063": 12,
  "77064": 12,
  "77065": 12,
  "77066": 12,
  "77067": 12,
  "77068": 12,
  "77069": 12,
  "77070": 12,
  "77071": 27,
  "77072": 27,
  "77073": 12,
  "77074": 12,
  "77075": 12,
  "77076": 12,
  "77077": 27,
  "77078": 12,
  "77079": 20,
  "77080": 12,
  "77081": 12,
  "77082": 27,
  "77083": 27,
  "77084": 27,
  "77085": 27,
  "77086": 12,
  "77087": 12,
  "77088": 12,
  "77089": 12,
  "77090": 12,
  "77091": 12,
  "77092": 12,
  "77093": 11,
  "77094": 29,
  "77095": 12,
  "77096": 12,
  "77097": 12,
  "77098": 20,
  "77099": 27,
  "77201": 12,
  "77202": 12,
  "77203": 12,
  "77205": 12,
  "77206": 12,
  "77207": 12,
  "77208": 12,
  "77210": 12,
  "77213": 12,
  "77215": 12,
  "77217": 12,
  "77218": 27,
  "77219": 23,
  "77220": 11,
  "77221": 12,
  "77222": 12,
  "77223": 12,
  "77224": 23,
  "77225": 23,
  "77226": 11,
  "77227": 23,
  "77228": 12,
  "77229": 11,
  "77230": 12,
  "77231": 12,
  "77233": 11,
  "77234": 12,
  "77235": 12,
  "77236": 12,
  "77237": 12,
  "77238": 12,
  "77240": 12,
  "77241": 12,
  "77242": 12,
  "77243": 12,
  "77244": 20,
  "77245": 12,
  "77246": 12,
  "77247": 12,
  "77248": 12,
  "77249": 12,
  "77250": 12,
  "77251": 12,
  "77252": 12,
  "77253": 12,
  "77254": 20,
  "77255": 12,
  "77256": 23,
  "77257": 12,
  "77258": 13,
  "77259": 5,
  "77260": 12,
  "77261": 12,
  "77262": 12,
  "77263": 12,
  "77265": 23,
  "77266": 20,
  "77267": 12,
  "77268": 12,
  "77269": 12,
  "77270": 12,
  "77271": 27,
  "77272": 27,
  "77273": 12,
  "77274": 12,
  "77275": 12,
  "77276": 12,
  "77277": 23,
  "77278": 12,
  "77279": 23,
  "77280": 12,
  "77282": 27,
  "77284": 12,
  "77285": 12,
  "77286": 12,
  "77287": 12,
  "77288": 12,
  "77289": 14,
  "77290": 12,
  "77291": 12,
  "77292": 12,
  "77293": 11,
  "77294": 12,
  "77296": 12,
  "77301": 5,
  "77302": 5,
  "77303": 5,
  "77304": 6,
  "77305": 5,
  "77306": 5,
  "77315": 12,
  "77316": 5,
  "77318": 6,
  "77320": -2,
  "77325": 12,
  "77326": -4,
  "77327": -12,
  "77328": -12,
  "77331": -12,
  "77332": -4,
  "77333": -2,
  "77334": -2,
  "77335": -4,
  "77336": 2,
  "77337": 6,
  "77338": 12,
  "77339": 12,
  "77340": -2,
  "77342": -2,
  "77345": 5,
  "77346": 12,
  "77347": 12,
  "77350": -4,
  "77351": -4,
  "77353": -4,
  "77354": 5,
  "77355": -4,
  "77356": 14,
  "77357": 5,
  "77358": -2,
  "77359": -2,
  "77360": -4,
  "77362": 5,
  "77363": -2,
  "77364": -12,
  "77365": 5,
  "77367": -2,
  "77368": 2,
  "77369": -4,
  "77371": -12,
  "77372": 5,
  "77373": 5,
  "77374": 2,
  "77375": 6,
  "77376": 2,
  "77377": 6,
  "77378": 5,
  "77379": 6,
  "77380": 6,
  "77381": 14,
  "77382": 14,
  "77383": 5,
  "77384": 14,
  "77385": 5,
  "77386": 6,
  "77387": 5,
  "77388": 6,
  "77389": 6,
  "77391": 6,
  "77393": 14,
  "77396": 12,
  "77401": 20,
  "77402": 12,
  "77404": 1,
  "77406": 27,
  "77407": 27,
  "77410": -3,
  "77411": 27,
  "77412": 0,
  "77413": 29,
  "77414": 2,
  "77415": 1,
  "77417": 27,
  "77418": 4,
  "77419": 1,
  "77420": -8,
  "77422": 9,
  "77423": -3,
  "77426": 4,
  "77428": 2,
  "77429": -3,
  "77430": 11,
  "77431": 10,
  "77432": -9,
  "77433": -3,
  "77434": -2,
  "77435": -8,
  "77436": -8,
  "77437": -8,
  "77440": 2,
  "77441": 29,
  "77442": -2,
  "77443": -8,
  "77444": 27,
  "77445": -2,
  "77446": -4,
  "77447": -4,
  "77448": -8,
  "77449": 27,
  "77450": 27,
  "77451": -8,
  "77452": 4,
  "77453": -8,
  "77454": -1,
  "77455": -3,
  "77456": 1,
  "77457": 1,
  "77458": 1,
  "77459": 27,
  "77460": -2,
  "77461": 27,
  "77463": 9,
  "77464": 27,
  "77465": 1,
  "77466": -3,
  "77467": 0,
  "77468": -8,
  "77469": 27,
  "77470": -3,
  "77471": 27,
  "77473": 3,
  "77474": 3,
  "77475": -3,
  "77476": 3,
  "77477": 27,
  "77478": 27,
  "77479": 29,
  "77480": 9,
  "77481": 27,
  "77482": 2,
  "77483": 1,
  "77484": -4,
  "77485": 3,
  "77486": 11,
  "77487": 27,
  "77488": -8,
  "77489": 27,
  "77491": 27,
  "77492": 27,
  "77493": 27,
  "77494": 27,
  "77496": 27,
  "77497": 27,
  "77498": 27,
  "77501": 11,
  "77502": 12,
  "77503": 11,
  "77504": 12,
  "77505": 11,
  "77506": 11,
  "77507": 5,
  "77508": 11,
  "77510": 5,
  "77511": 9,
  "77512": 9,
  "77514": 6,
  "77515": 9,
  "77516": 9,
  "77517": 5,
  "77518": 5,
  "77519": 2,
  "77520": 6,
  "77521": 6,
  "77522": 6,
  "77523": 6,
  "77530": 10,
  "77531": 9,
  "77532": 11,
  "77533": 2,
  "77534": 9,
  "77535": 2,
  "77536": 11,
  "77538": 6,
  "77539": 5,
  "77541": 10,
  "77542": 10,
  "77545": 27,
  "77546": 13,
  "77547": 11,
  "77549": 13,
  "77550": 6,
  "77551": 6,
  "77552": 6,
  "77553": 14,
  "77554": 14,
  "77560": 6,
  "77561": 2,
  "77562": 11,
  "77563": 5,
  "77564": 2,
  "77565": 13,
  "77566": 9,
  "77568": 5,
  "77571": 5,
  "77572": 5,
  "77573": 6,
  "77574": 6,
  "77575": 2,
  "77577": 9,
  "77578": 11,
  "77580": 6,
  "77581": 12,
  "77582": 2,
  "77583": 11,
  "77584": 12,
  "77585": 2,
  "77586": 7,
  "77587": 12,
  "77588": 12,
  "77590": 5,
  "77591": 5,
  "77592": 5,
  "77597": 6,
  "77598": 5,
  "77611": 1,
  "77612": 2,
  "77613": 7,
  "77614": -3,
  "77615": 2,
  "77616": -3,
  "77617": 7,
  "77619": 7,
  "77622": 7,
  "77623": 7,
  "77624": -1,
  "77625": 3,
  "77626": 2,
  "77627": 7,
  "77629": 7,
  "77630": 1,
  "77631": 1,
  "77632": 2,
  "77639": 1,
  "77640": 6,
  "77641": 6,
  "77642": 6,
  "77643": 6,
  "77650": 6,
  "77651": 8,
  "77655": 6,
  "77656": 3,
  "77657": 4,
  "77659": 4,
  "77660": -3,
  "77661": 6,
  "77662": 2,
  "77663": 12,
  "77664": -1,
  "77665": 6,
  "77670": 2,
  "77701": 7,
  "77702": 16,
  "77703": 7,
  "77704": 7,
  "77705": 7,
  "77706": 16,
  "77707": 7,
  "77708": 7,
  "77709": 7,
  "77710": 7,
  "77713": 7,
  "77720": 7,
  "77725": 7,
  "77726": 16,
  "77801": 2,
  "77802": 4,
  "77803": -5,
  "77805": 4,
  "77806": -5,
  "77807": -6,
  "77808": -5,
  "77830": 0,
  "77831": -10,
  "77833": -5,
  "77834": -5,
  "77835": -5,
  "77836": 3,
  "77837": -7,
  "77838": 3,
  "77840": -3,
  "77841": 6,
  "77842": -3,
  "77844": -3,
  "77845": 6,
  "77850": -2,
  "77852": 3,
  "77853": 7,
  "77855": -2,
  "77856": -6,
  "77857": -7,
  "77859": -7,
  "77861": -10,
  "77862": 4,
  "77863": 4,
  "77864": -12,
  "77865": -3,
  "77866": 0,
  "77867": -5,
  "77868": 0,
  "77870": -6,
  "77871": -10,
  "77872": -11,
  "77873": -2,
  "77875": 0,
  "77876": 0,
  "77878": 5,
  "77879": 4,
  "77880": -5,
  "77881": 6,
  "77882": 2,
  "77901": -3,
  "77902": -4,
  "77903": -4,
  "77904": 5,
  "77905": -3,
  "77950": 0,
  "77951": 3,
  "77954": -3,
  "77957": -4,
  "77960": -4,
  "77961": -4,
  "77962": -4,
  "77963": -4,
  "77964": 4,
  "77967": 3,
  "77968": 4,
  "77969": -4,
  "77970": -4,
  "77971": -4,
  "77973": -3,
  "77974": -3,
  "77975": 3,
  "77976": 5,
  "77977": 3,
  "77978": 0,
  "77979": 0,
  "77982": 0,
  "77983": 0,
  "77984": 4,
  "77986": 4,
  "77987": 3,
  "77988": 3,
  "77989": -3,
  "77990": 0,
  "77991": -4,
  "77993": -4,
  "77994": -3,
  "77995": 3,
  "78001": 1,
  "78002": 2,
  "78003": -10,
  "78004": 5,
  "78005": 2,
  "78006": 11,
  "78007": -8,
  "78008": -1,
  "78009": -7,
  "78010": -5,
  "78011": -1,
  "78012": -1,
  "78013": 2,
  "78014": 8,
  "78015": 3,
  "78016": -7,
  "78017": 7,
  "78019": -13,
  "78021": 7,
  "78022": -8,
  "78023": 3,
  "78024": -5,
  "78025": -5,
  "78026": -1,
  "78027": 5,
  "78028": -5,
  "78029": -5,
  "78039": -7,
  "78040": -12,
  "78041": -4,
  "78042": -12,
  "78043": -12,
  "78044": -12,
  "78045": -4,
  "78046": -12,
  "78050": -1,
  "78052": -7,
  "78054": 2,
  "78055": -5,
  "78056": -10,
  "78057": 2,
  "78058": -5,
  "78059": -7,
  "78060": -8,
  "78061": 8,
  "78062": -1,
  "78063": -10,
  "78064": -1,
  "78065": 2,
  "78066": -7,
  "78067": -8,
  "78069": 2,
  "78070": 0,
  "78071": -8,
  "78072": -8,
  "78073": 2,
  "78074": 3,
  "78075": -8,
  "78076": -8,
  "78101": -8,
  "78102": -2,
  "78104": -2,
  "78107": -3,
  "78108": 0,
  "78109": 2,
  "78111": -4,
  "78112": -8,
  "78113": -4,
  "78114": -8,
  "78115": -2,
  "78116": -4,
  "78117": -4,
  "78118": -4,
  "78119": -4,
  "78121": -7,
  "78122": -11,
  "78123": -2,
  "78124": -2,
  "78125": -3,
  "78130": 0,
  "78131": 0,
  "78132": 0,
  "78133": 0,
  "78140": -11,
  "78141": -4,
  "78142": -3,
  "78143": -8,
  "78144": -5,
  "78145": -4,
  "78146": -3,
  "78147": -8,
  "78148": 2,
  "78150": 2,
  "78151": -4,
  "78152": -3,
  "78154": 0,
  "78155": -3,
  "78156": -3,
  "78159": -11,
  "78160": -8,
  "78161": -8,
  "78162": -3,
  "78163": 7,
  "78164": -3,
  "78201": 2,
  "78202": 2,
  "78203": 2,
  "78204": 2,
  "78205": 4,
  "78206": 4,
  "78207": 2,
  "78208": 2,
  "78209": 3,
  "78210": 2,
  "78211": 2,
  "78212": 2,
  "78213": 2,
  "78214": 2,
  "78215": 2,
  "78216": 2,
  "78217": 2,
  "78218": 2,
  "78219": 2,
  "78220": 2,
  "78221": 2,
  "78222": 2,
  "78223": 2,
  "78224": 2,
  "78225": 2,
  "78226": 2,
  "78227": 2,
  "78228": 2,
  "78229": 2,
  "78230": 2,
  "78231": 2,
  "78232": 2,
  "78233": 2,
  "78234": 2,
  "78235": 2,
  "78236": 2,
  "78237": 2,
  "78238": 2,
  "78239": 2,
  "78240": 2,
  "78241": 2,
  "78242": 2,
  "78243": 2,
  "78244": 2,
  "78245": 2,
  "78246": 2,
  "78247": 2,
  "78248": 11,
  "78249": 2,
  "78250": 2,
  "78251": 2,
  "78252": 2,
  "78253": 2,
  "78254": 4,
  "78255": 11,
  "78256": 11,
  "78257": 13,
  "78258": 11,
  "78259": 3,
  "78260": -1,
  "78261": 7,
  "78262": 2,
  "78263": 2,
  "78264": 2,
  "78265": 2,
  "78266": 8,
  "78268": 2,
  "78269": 2,
  "78270": 2,
  "78278": 2,
  "78279": 2,
  "78280": 2,
  "78283": 2,
  "78284": 2,
  "78285": 2,
  "78286": 2,
  "78291": 4,
  "78292": 4,
  "78293": 4,
  "78294": 4,
  "78295": 4,
  "78296": 4,
  "78297": 4,
  "78298": 2,
  "78299": 4,
  "78330": -12,
  "78332": -12,
  "78333": -12,
  "78335": -9,
  "78336": -9,
  "78338": -8,
  "78339": 1,
  "78340": -9,
  "78341": -12,
  "78342": -12,
  "78343": -12,
  "78344": -8,
  "78347": 17,
  "78349": -12,
  "78350": -8,
  "78351": -12,
  "78352": 2,
  "78353": -17,
  "78355": -16,
  "78357": -12,
  "78358": -9,
  "78359": 1,
  "78360": -8,
  "78361": -8,
  "78362": -9,
  "78363": -11,
  "78364": -11,
  "78368": -3,
  "78369": -13,
  "78370": 2,
  "78371": -8,
  "78372": -11,
  "78373": -1,
  "78374": 10,
  "78375": -12,
  "78376": -7,
  "78377": -7,
  "78379": -12,
  "78380": 8,
  "78381": -9,
  "78382": -9,
  "78383": -8,
  "78384": -12,
  "78385": -12,
  "78387": 1,
  "78389": -3,
  "78390": 1,
  "78391": -2,
  "78393": -7,
  "78401": 8,
  "78402": 8,
  "78403": 8,
  "78404": 8,
  "78405": 8,
  "78406": 8,
  "78407": 8,
  "78408": 8,
  "78409": 8,
  "78410": 8,
  "78411": 8,
  "78412": 8,
  "78413": 17,
  "78414": 16,
  "78415": 8,
  "78416": 8,
  "78417": 8,
  "78418": 8,
  "78419": 8,
  "78426": 8,
  "78427": 8,
  "78460": 8,
  "78463": 8,
  "78465": 8,
  "78466": 8,
  "78467": 8,
  "78468": 8,
  "78469": 8,
  "78470": 8,
  "78471": 8,
  "78472": 17,
  "78473": 8,
  "78474": 8,
  "78475": 8,
  "78476": 8,
  "78477": 8,
  "78478": 8,
  "78480": 8,
  "78501": -10,
  "78502": -10,
  "78503": -11,
  "78504": -2,
  "78505": -10,
  "78516": -11,
  "78520": -12,
  "78521": -12,
  "78522": -12,
  "78523": -12,
  "78526": -12,
  "78535": -3,
  "78536": 4,
  "78537": -11,
  "78538": -12,
  "78539": -11,
  "78540": -11,
  "78541": -11,
  "78542": -11,
  "78543": -11,
  "78545": 4,
  "78547": 3,
  "78548": 3,
  "78549": -17,
  "78550": -3,
  "78551": -10,
  "78552": -10,
  "78553": -3,
  "78557": -10,
  "78558": -12,
  "78559": -12,
  "78560": -11,
  "78561": -17,
  "78562": -12,
  "78563": -11,
  "78564": -8,
  "78565": -11,
  "78566": -12,
  "78567": -12,
  "78568": -12,
  "78569": -17,
  "78570": -11,
  "78572": -11,
  "78573": -11,
  "78574": -11,
  "78575": -12,
  "78576": -11,
  "78577": -11,
  "78578": -12,
  "78579": -11,
  "78580": -17,
  "78582": 4,
  "78583": -12,
  "78584": 3,
  "78585": 4,
  "78586": -3,
  "78588": 4,
  "78589": -11,
  "78590": -17,
  "78591": 4,
  "78592": -12,
  "78593": -17,
  "78594": -17,
  "78595": 4,
  "78596": -11,
  "78597": -3,
  "78598": -17,
  "78599": -11,
  "78602": 3,
  "78604": -9,
  "78605": -6,
  "78606": 4,
  "78607": -7,
  "78608": -11,
  "78609": -7,
  "78610": 0,
  "78611": -6,
  "78612": 3,
  "78613": 6,
  "78614": -10,
  "78615": 4,
  "78616": 2,
  "78617": 11,
  "78618": -10,
  "78619": 0,
  "78620": 5,
  "78621": 3,
  "78622": 1,
  "78623": -1,
  "78624": -5,
  "78626": 6,
  "78627": 6,
  "78628": 6,
  "78629": -11,
  "78630": 6,
  "78631": -5,
  "78632": 2,
  "78633": 4,
  "78634": 6,
  "78635": 3,
  "78636": 5,
  "78638": 1,
  "78639": -5,
  "78640": 0,
  "78641": 6,
  "78642": 6,
  "78643": -7,
  "78644": 1,
  "78645": 11,
  "78646": 6,
  "78648": 1,
  "78650": 3,
  "78651": 11,
  "78652": 1,
  "78653": 11,
  "78654": -4,
  "78655": 2,
  "78656": 2,
  "78657": -4,
  "78658": -9,
  "78659": 7,
  "78660": 6,
  "78661": 1,
  "78662": 3,
  "78663": 5,
  "78664": 6,
  "78665": 6,
  "78666": 0,
  "78667": 0,
  "78669": 11,
  "78670": 1,
  "78671": 4,
  "78672": -7,
  "78673": 4,
  "78674": 6,
  "78675": -4,
  "78676": 8,
  "78677": -10,
  "78680": 6,
  "78681": 6,
  "78683": 6,
  "78691": 6,
  "78701": 12,
  "78702": 11,
  "78703": 22,
  "78704": 11,
  "78705": 11,
  "78708": 11,
  "78709": 12,
  "78710": 11,
  "78711": 12,
  "78712": 11,
  "78713": 11,
  "78714": 12,
  "78715": 11,
  "78716": 20,
  "78717": 6,
  "78718": 11,
  "78719": 11,
  "78720": 12,
  "78721": 11,
  "78722": 11,
  "78723": 11,
  "78724": 11,
  "78725": 11,
  "78726": 13,
  "78727": 11,
  "78728": 6,
  "78729": 11,
  "78730": 22,
  "78731": 20,
  "78732": 12,
  "78733": 20,
  "78734": 12,
  "78735": 12,
  "78736": 11,
  "78737": 11,
  "78738": 22,
  "78739": 12,
  "78741": 11,
  "78742": 11,
  "78744": 11,
  "78745": 11,
  "78746": 22,
  "78747": 11,
  "78748": 11,
  "78749": 11,
  "78750": 12,
  "78751": 11,
  "78752": 11,
  "78753": 11,
  "78754": 11,
  "78755": 20,
  "78756": 12,
  "78757": 11,
  "78758": 11,
  "78759": 12,
  "78760": 11,
  "78761": 11,
  "78762": 11,
  "78763": 22,
  "78764": 6,
  "78765": 11,
  "78766": 11,
  "78767": 12,
  "78768": 12,
  "78769": 12,
  "78799": 12,
  "78801": -13,
  "78802": -13,
  "78827": 1,
  "78828": -17,
  "78829": 7,
  "78830": 1,
  "78832": -12,
  "78833": -17,
  "78834": 1,
  "78836": 1,
  "78837": -12,
  "78838": -13,
  "78839": 1,
  "78840": -12,
  "78841": -12,
  "78842": -12,
  "78843": -12,
  "78850": -7,
  "78851": 1,
  "78852": -6,
  "78853": -6,
  "78860": -6,
  "78861": -7,
  "78870": -13,
  "78871": -12,
  "78872": -13,
  "78873": -17,
  "78877": -6,
  "78879": -17,
  "78880": -18,
  "78881": -13,
  "78883": -10,
  "78884": -10,
  "78885": -17,
  "78886": -7,
  "78931": 4,
  "78932": -5,
  "78933": 4,
  "78934": 0,
  "78935": 0,
  "78938": 12,
  "78940": 12,
  "78941": 10,
  "78942": 7,
  "78943": 0,
  "78944": -5,
  "78945": 12,
  "78946": 7,
  "78947": 7,
  "78948": 5,
  "78949": 12,
  "78950": 4,
  "78951": 11,
  "78952": 12,
  "78953": 1,
  "78954": -5,
  "78956": 11,
  "78957": 3,
  "78959": -11,
  "78960": 7,
  "78961": -5,
  "78962": -2,
  "78963": 12,
  "79001": -6,
  "79002": -5,
  "79003": -14,
  "79005": -8,
  "79007": 1,
  "79008": 1,
  "79009": -12,
  "79010": -6,
  "79011": -14,
  "79012": 5,
  "79013": -2,
  "79014": -14,
  "79015": -3,
  "79018": 3,
  "79019": -2,
  "79021": -11,
  "79022": -4,
  "79024": -8,
  "79025": -4,
  "79027": -14,
  "79029": -1,
  "79031": 15,
  "79032": -11,
  "79033": -8,
  "79034": -8,
  "79035": -6,
  "79036": 1,
  "79039": 9,
  "79040": -5,
  "79041": -11,
  "79042": -16,
  "79043": -15,
  "79044": 3,
  "79045": -6,
  "79046": -14,
  "79051": -2,
  "79052": -17,
  "79053": -12,
  "79054": -5,
  "79056": -14,
  "79057": -5,
  "79058": -6,
  "79059": -5,
  "79061": -9,
  "79062": 1,
  "79063": -14,
  "79064": 15,
  "79065": -5,
  "79066": -5,
  "79068": 9,
  "79070": -8,
  "79072": -11,
  "79073": -11,
  "79077": 0,
  "79078": 1,
  "79079": -9,
  "79080": 1,
  "79081": -6,
  "79082": 15,
  "79083": 1,
  "79084": -11,
  "79085": -6,
  "79086": -2,
  "79087": -5,
  "79088": -17,
  "79091": -3,
  "79092": -6,
  "79093": -8,
  "79094": -16,
  "79095": 0,
  "79096": -9,
  "79097": 9,
  "79098": -3,
  "79101": -6,
  "79102": -5,
  "79103": -5,
  "79104": -6,
  "79105": -3,
  "79106": -5,
  "79107": -6,
  "79108": -5,
  "79109": -4,
  "79110": -3,
  "79111": -5,
  "79114": -4,
  "79116": -5,
  "79117": -6,
  "79118": -3,
  "79119": 5,
  "79120": -6,
  "79121": 3,
  "79124": 3,
  "79159": 5,
  "79189": -5,
  "79201": 0,
  "79220": 38,
  "79221": -15,
  "79223": 37,
  "79225": -1,
  "79226": -17,
  "79227": 37,
  "79229": 38,
  "79230": 0,
  "79231": -15,
  "79233": -15,
  "79234": -15,
  "79235": -15,
  "79236": 38,
  "79237": -17,
  "79239": -17,
  "79240": -17,
  "79241": -15,
  "79243": -15,
  "79244": -15,
  "79245": -17,
  "79247": -15,
  "79248": 37,
  "79250": -11,
  "79251": -17,
  "79252": -1,
  "79255": -15,
  "79256": -15,
  "79257": -15,
  "79258": -15,
  "79259": 0,
  "79261": -15,
  "79311": -11,
  "79312": 15,
  "79313": -1,
  "79314": -1,
  "79316": -15,
  "79320": -12,
  "79322": -15,
  "79323": 10,
  "79324": -12,
  "79325": -12,
  "79326": 15,
  "79329": -3,
  "79330": -4,
  "79331": -7,
  "79336": -1,
  "79338": -1,
  "79339": 15,
  "79342": -15,
  "79343": -4,
  "79344": -12,
  "79345": -15,
  "79346": -1,
  "79347": -12,
  "79350": -4,
  "79351": -7,
  "79353": 0,
  "79355": 10,
  "79356": -4,
  "79357": -4,
  "79358": -1,
  "79359": 0,
  "79360": 0,
  "79363": -3,
  "79364": -4,
  "79366": -3,
  "79367": -1,
  "79369": 15,
  "79370": -11,
  "79371": 15,
  "79372": -1,
  "79373": -4,
  "79376": 10,
  "79377": -7,
  "79378": -15,
  "79379": -1,
  "79380": -1,
  "79381": -4,
  "79382": -4,
  "79383": -4,
  "79401": -4,
  "79402": -4,
  "79403": -4,
  "79404": -4,
  "79405": -4,
  "79406": -3,
  "79407": -3,
  "79408": -4,
  "79409": -4,
  "79410": -3,
  "79411": -4,
  "79412": -4,
  "79413": -3,
  "79414": -3,
  "79415": -4,
  "79416": -3,
  "79423": -3,
  "79424": -3,
  "79452": -4,
  "79453": -4,
  "79464": -3,
  "79490": -4,
  "79493": -3,
  "79499": -4,
  "79501": -11,
  "79502": -12,
  "79503": -11,
  "79504": 1,
  "79505": -13,
  "79506": -1,
  "79508": 3,
  "79510": 1,
  "79511": 1,
  "79512": -3,
  "79516": -3,
  "79517": 30,
  "79518": -12,
  "79519": -9,
  "79520": -11,
  "79521": -13,
  "79525": -10,
  "79526": -3,
  "79527": -2,
  "79528": -12,
  "79529": -13,
  "79530": -5,
  "79532": -1,
  "79533": -2,
  "79534": -11,
  "79535": 0,
  "79536": -5,
  "79537": 0,
  "79538": -9,
  "79539": -13,
  "79540": -12,
  "79541": -5,
  "79543": -1,
  "79544": -13,
  "79545": -1,
  "79546": -12,
  "79547": -13,
  "79548": -13,
  "79549": -3,
  "79550": -3,
  "79553": -11,
  "79556": -1,
  "79560": -11,
  "79561": -1,
  "79562": 3,
  "79563": -5,
  "79565": 1,
  "79566": 88,
  "79567": 88,
  "79601": -5,
  "79602": -5,
  "79603": -5,
  "79604": -5,
  "79605": -5,
  "79606": 3,
  "79607": -5,
  "79608": -5,
  "79701": 9,
  "79702": 9,
  "79703": 10,
  "79704": 10,
  "79705": 18,
  "79706": 9,
  "79707": 18,
  "79708": 18,
  "79710": 18,
  "79711": 9,
  "79712": 10,
  "79713": -6,
  "79714": 8,
  "79718": 18,
  "79719": 18,
  "79720": -6,
  "79721": -7,
  "79730": 5,
  "79731": 11,
  "79733": 1,
  "79734": -14,
  "79735": -1,
  "79738": 30,
  "79739": 2,
  "79740": -2,
  "79741": 7,
  "79742": 5,
  "79743": 10,
  "79744": 2,
  "79745": 5,
  "79748": -2,
  "79749": -2,
  "79752": 2,
  "79754": 18,
  "79755": 2,
  "79756": 5,
  "79758": 7,
  "79759": 7,
  "79760": 7,
  "79761": 7,
  "79762": 7,
  "79763": 7,
  "79764": 7,
  "79765": 7,
  "79766": 7,
  "79768": 7,
  "79769": 7,
  "79770": 18,
  "79772": 18,
  "79776": 7,
  "79777": 5,
  "79778": 2,
  "79780": 18,
  "79781": 1,
  "79782": -2,
  "79783": 7,
  "79785": 18,
  "79786": 18,
  "79788": 5,
  "79789": 5,
  "79821": -8,
  "79830": -9,
  "79831": -9,
  "79834": -9,
  "79835": -8,
  "79836": -8,
  "79837": -8,
  "79838": -8,
  "79839": -8,
  "79842": -9,
  "79843": -14,
  "79845": -14,
  "79846": -14,
  "79847": -8,
  "79848": 0,
  "79849": -8,
  "79851": -8,
  "79852": -9,
  "79853": -8,
  "79854": -13,
  "79855": 19,
  "79901": -8,
  "79902": -8,
  "79903": -8,
  "79904": -8,
  "79905": -8,
  "79906": -8,
  "79907": -8,
  "79908": -8,
  "79910": -8,
  "79911": 0,
  "79912": 0,
  "79913": 0,
  "79914": -8,
  "79915": -8,
  "79916": -8,
  "79917": -8,
  "79918": -8,
  "79920": -8,
  "79922": 0,
  "79923": -8,
  "79924": -8,
  "79925": -8,
  "79926": -8,
  "79927": -8,
  "79928": -8,
  "79929": -8,
  "79930": -8,
  "79931": -8,
  "79932": -8,
  "79934": -8,
  "79935": -8,
  "79936": -8,
  "79937": -8,
  "79938": -8,
  "79940": -8,
  "79941": -8,
  "79942": -8,
  "79943": -8,
  "79944": -8,
  "79945": -8,
  "79946": -8,
  "79947": -8,
  "79948": -8,
  "79949": -8,
  "79950": -8,
  "79951": -8,
  "79952": -8,
  "79953": -8,
  "79954": -8,
  "79955": -8,
  "79990": -8,
  "79995": -8,
  "79996": -8,
  "79997": -8,
  "79998": -8,
  "79999": -8,
  "80001": 8,
  "80002": 8,
  "80003": 8,
  "80004": 8,
  "80005": 8,
  "80006": 8,
  "80007": 11,
  "80010": 13,
  "80011": 13,
  "80012": 13,
  "80013": 13,
  "80014": 13,
  "80015": 14,
  "80016": 24,
  "80017": 13,
  "80018": 13,
  "80019": 7,
  "80020": 8,
  "80021": 8,
  "80022": 7,
  "80023": 8,
  "80024": 7,
  "80025": 8,
  "80026": 5,
  "80027": 5,
  "80030": 13,
  "80031": 7,
  "80033": 8,
  "80034": 8,
  "80035": 7,
  "80036": 7,
  "80037": 7,
  "80038": 8,
  "80040": 13,
  "80041": 13,
  "80042": 13,
  "80044": 13,
  "80045": 13,
  "80046": 14,
  "80047": 13,
  "80101": -4,
  "80102": 13,
  "80103": -4,
  "80104": 13,
  "80105": -4,
  "80106": 10,
  "80107": 13,
  "80108": 13,
  "80109": 13,
  "80110": 13,
  "80111": 24,
  "80112": 14,
  "80113": 13,
  "80116": 23,
  "80117": -3,
  "80118": 23,
  "80120": 13,
  "80121": 14,
  "80122": 14,
  "80123": 8,
  "80124": 16,
  "80125": 13,
  "80126": 13,
  "80127": 8,
  "80128": 8,
  "80129": 13,
  "80130": 16,
  "80131": 13,
  "80132": 10,
  "80133": 1,
  "80134": 13,
  "80135": 12,
  "80136": 13,
  "80137": 14,
  "80138": 13,
  "80150": 13,
  "80151": 13,
  "80155": 14,
  "80160": 13,
  "80161": 14,
  "80162": 8,
  "80163": 13,
  "80201": 8,
  "80202": 17,
  "80203": 13,
  "80204": 13,
  "80205": 13,
  "80206": 17,
  "80207": 13,
  "80209": 17,
  "80210": 14,
  "80211": 13,
  "80212": 13,
  "80214": 8,
  "80215": 8,
  "80216": 13,
  "80217": 17,
  "80218": 14,
  "80219": 13,
  "80220": 14,
  "80221": 13,
  "80222": 13,
  "80223": 13,
  "80224": 13,
  "80225": 8,
  "80226": 8,
  "80227": 8,
  "80228": 8,
  "80229": 7,
  "80230": 14,
  "80231": 13,
  "80232": 8,
  "80233": 7,
  "80234": 7,
  "80235": 8,
  "80236": 13,
  "80237": 14,
  "80238": 13,
  "80239": 7,
  "80241": 8,
  "80246": 13,
  "80247": 13,
  "80248": 17,
  "80249": 7,
  "80250": 14,
  "80260": 7,
  "80264": 13,
  "80265": 17,
  "80266": 17,
  "80290": 17,
  "80293": 17,
  "80294": 17,
  "80295": 17,
  "80299": 17,
  "80301": 5,
  "80302": 8,
  "80303": 8,
  "80304": 8,
  "80305": 8,
  "80306": 8,
  "80307": 8,
  "80308": -4,
  "80401": 8,
  "80402": 8,
  "80403": 11,
  "80420": -1,
  "80421": -5,
  "80422": -4,
  "80423": 5,
  "80424": 5,
  "80425": 12,
  "80426": 6,
  "80427": -4,
  "80428": 1,
  "80429": -1,
  "80430": -1,
  "80432": -6,
  "80433": 8,
  "80434": -1,
  "80435": 3,
  "80436": -5,
  "80437": 19,
  "80438": -5,
  "80439": 19,
  "80440": -6,
  "80442": -1,
  "80443": 5,
  "80444": -5,
  "80446": -1,
  "80447": -1,
  "80448": -5,
  "80449": -6,
  "80451": -1,
  "80452": -5,
  "80453": 8,
  "80454": 8,
  "80455": 5,
  "80456": -6,
  "80457": 8,
  "80459": -1,
  "80461": -1,
  "80463": 17,
  "80465": 8,
  "80466": -4,
  "80467": -1,
  "80468": -1,
  "80469": -1,
  "80470": -5,
  "80471": -4,
  "80473": -1,
  "80474": -4,
  "80475": -5,
  "80476": -5,
  "80477": 2,
  "80478": -1,
  "80479": 11,
  "80480": -1,
  "80481": 5,
  "80482": -2,
  "80483": -1,
  "80487": 2,
  "80488": 2,
  "80497": 3,
  "80498": -1,
  "80501": 5,
  "80502": 8,
  "80503": 5,
  "80504": 9,
  "80510": 5,
  "80511": 4,
  "80512": 2,
  "80513": 5,
  "80514": 5,
  "80515": 2,
  "80516": 5,
  "80517": 4,
  "80520": 5,
  "80521": 2,
  "80522": 2,
  "80524": 2,
  "80525": 2,
  "80526": 2,
  "80527": 2,
  "80528": 2,
  "80530": 5,
  "80532": 10,
  "80533": 5,
  "80534": 5,
  "80535": 2,
  "80536": 3,
  "80537": 2,
  "80538": 2,
  "80539": 2,
  "80540": 5,
  "80541": 10,
  "80542": 5,
  "80543": 6,
  "80544": 5,
  "80545": 2,
  "80546": 13,
  "80547": 2,
  "80549": 2,
  "80550": 13,
  "80601": 7,
  "80602": 8,
  "80603": 16,
  "80610": 4,
  "80611": 13,
  "80612": 0,
  "80614": 8,
  "80615": 13,
  "80620": 4,
  "80621": 7,
  "80622": 13,
  "80623": 4,
  "80624": 13,
  "80631": 4,
  "80632": 4,
  "80633": 4,
  "80634": 6,
  "80640": 8,
  "80642": 16,
  "80643": 13,
  "80644": 6,
  "80645": 6,
  "80646": 13,
  "80648": 4,
  "80649": -1,
  "80650": 4,
  "80651": 13,
  "80652": -1,
  "80653": -1,
  "80654": -1,
  "80701": -1,
  "80705": -1,
  "80720": -1,
  "80721": -15,
  "80722": -9,
  "80723": -1,
  "80726": -10,
  "80727": -8,
  "80728": -9,
  "80729": 0,
  "80731": -15,
  "80732": 0,
  "80733": -1,
  "80734": -15,
  "80735": -6,
  "80736": -9,
  "80737": -12,
  "80740": -1,
  "80741": -9,
  "80742": -1,
  "80743": -8,
  "80744": -11,
  "80745": -9,
  "80746": -15,
  "80747": -10,
  "80749": -11,
  "80750": -1,
  "80751": -9,
  "80754": -9,
  "80755": -8,
  "80757": -1,
  "80758": -8,
  "80759": -8,
  "80801": -1,
  "80802": -10,
  "80804": -15,
  "80805": -9,
  "80807": -9,
  "80808": -4,
  "80809": -9,
  "80810": -10,
  "80812": -9,
  "80813": -9,
  "80814": -9,
  "80815": -9,
  "80816": -9,
  "80817": 1,
  "80818": -15,
  "80819": -9,
  "80820": 3,
  "80821": -15,
  "80822": -9,
  "80823": -16,
  "80824": -9,
  "80825": -10,
  "80827": -6,
  "80828": -15,
  "80829": 1,
  "80830": -15,
  "80831": 1,
  "80832": -4,
  "80833": -4,
  "80834": -9,
  "80835": -4,
  "80836": -9,
  "80840": 10,
  "80841": 1,
  "80860": -10,
  "80861": -9,
  "80862": -15,
  "80863": -9,
  "80864": 1,
  "80866": -9,
  "80901": 1,
  "80902": 1,
  "80903": 1,
  "80904": 1,
  "80905": 1,
  "80906": 1,
  "80907": 1,
  "80908": 10,
  "80909": 1,
  "80910": 1,
  "80911": 1,
  "80912": 10,
  "80913": 1,
  "80914": 1,
  "80915": 1,
  "80916": 1,
  "80917": 1,
  "80918": 1,
  "80919": 1,
  "80920": 1,
  "80921": 10,
  "80922": 1,
  "80923": 1,
  "80924": 1,
  "80925": 1,
  "80926": 1,
  "80927": 1,
  "80928": 1,
  "80929": 1,
  "80930": 1,
  "80931": 1,
  "80932": 1,
  "80933": -9,
  "80934": 1,
  "80935": 1,
  "80936": 1,
  "80937": 1,
  "80938": 1,
  "80939": 1,
  "80949": 1,
  "80951": 1,
  "80960": 1,
  "80962": 1,
  "80970": 1,
  "81001": -1,
  "81002": -1,
  "81003": -1,
  "81004": -1,
  "81005": -1,
  "81006": 1,
  "81007": 8,
  "81008": -1,
  "81019": -1,
  "81020": -14,
  "81021": -12,
  "81022": -1,
  "81023": 8,
  "81024": -5,
  "81025": -1,
  "81027": -14,
  "81029": -13,
  "81030": -12,
  "81033": -12,
  "81036": -19,
  "81038": -12,
  "81039": -12,
  "81040": -10,
  "81041": -19,
  "81043": -19,
  "81044": -19,
  "81045": -12,
  "81046": -14,
  "81047": -19,
  "81049": -14,
  "81050": -12,
  "81052": -18,
  "81054": -12,
  "81055": -1,
  "81057": -18,
  "81058": -12,
  "81059": -14,
  "81062": -12,
  "81063": -12,
  "81064": -13,
  "81067": -12,
  "81069": -1,
  "81071": -19,
  "81073": -13,
  "81076": -12,
  "81077": -12,
  "81081": -14,
  "81082": -14,
  "81084": -12,
  "81087": -13,
  "81089": -10,
  "81090": -13,
  "81091": -10,
  "81092": -18,
  "81101": 0,
  "81120": -9,
  "81121": 0,
  "81122": -1,
  "81123": -1,
  "81124": -11,
  "81125": -13,
  "81126": 0,
  "81127": 11,
  "81128": 1,
  "81129": -9,
  "81130": -18,
  "81131": -12,
  "81132": -13,
  "81133": 0,
  "81135": -13,
  "81136": 0,
  "81137": 0,
  "81138": -10,
  "81140": -10,
  "81141": -9,
  "81143": -16,
  "81144": -13,
  "81146": 0,
  "81147": 0,
  "81148": -9,
  "81149": -16,
  "81151": -11,
  "81152": -10,
  "81154": -5,
  "81155": -14,
  "81157": 0,
  "81201": 3,
  "81210": 6,
  "81211": 3,
  "81212": -4,
  "81215": -4,
  "81220": -4,
  "81221": -6,
  "81222": -10,
  "81223": -4,
  "81224": -3,
  "81225": -5,
  "81226": -6,
  "81227": 3,
  "81228": -1,
  "81230": 3,
  "81232": -4,
  "81233": 3,
  "81235": -18,
  "81236": 3,
  "81237": 3,
  "81239": 3,
  "81240": -4,
  "81241": 3,
  "81242": 3,
  "81243": -3,
  "81244": -6,
  "81247": 2,
  "81248": 3,
  "81251": -1,
  "81252": -3,
  "81253": -3,
  "81301": -1,
  "81302": -1,
  "81303": -1,
  "81320": -12,
  "81321": -14,
  "81323": -14,
  "81324": -12,
  "81325": -12,
  "81326": -1,
  "81327": -14,
  "81328": -14,
  "81329": -1,
  "81330": -14,
  "81331": -14,
  "81332": -1,
  "81334": -14,
  "81335": -14,
  "81401": -5,
  "81402": -5,
  "81403": -5,
  "81410": -7,
  "81411": -1,
  "81413": -7,
  "81414": -7,
  "81415": -7,
  "81416": -7,
  "81418": -7,
  "81419": -7,
  "81420": -7,
  "81422": -1,
  "81423": -1,
  "81424": -1,
  "81425": -5,
  "81426": -2,
  "81427": -4,
  "81428": -7,
  "81429": -1,
  "81430": 7,
  "81431": -1,
  "81432": -4,
  "81433": -18,
  "81434": 15,
  "81435": 7,
  "81501": 1,
  "81502": 1,
  "81503": 1,
  "81504": 1,
  "81505": 1,
  "81506": 1,
  "81507": 1,
  "81520": 1,
  "81521": 1,
  "81522": 1,
  "81523": 1,
  "81524": 1,
  "81525": 1,
  "81526": 1,
  "81527": 1,
  "81601": 0,
  "81602": 0,
  "81610": -5,
  "81611": 26,
  "81612": 26,
  "81615": 26,
  "81620": 8,
  "81621": 20,
  "81623": 18,
  "81624": 0,
  "81625": -5,
  "81626": -5,
  "81630": 1,
  "81631": 8,
  "81632": 8,
  "81633": -5,
  "81635": 0,
  "81636": 0,
  "81637": 5,
  "81638": 1,
  "81639": -1,
  "81640": -5,
  "81641": -5,
  "81642": 28,
  "81643": 1,
  "81645": 5,
  "81646": -7,
  "81647": 0,
  "81648": -5,
  "81649": 5,
  "81650": 0,
  "81652": 0,
  "81653": -5,
  "81654": 26,
  "81655": 10,
  "81656": 16,
  "81657": 5,
  "81658": 8,
  "82001": 1,
  "82003": 1,
  "82005": 1,
  "82007": 0,
  "82009": 1,
  "82050": 0,
  "82051": -7,
  "82052": -7,
  "82053": 0,
  "82054": 1,
  "82055": -7,
  "82058": -8,
  "82059": 0,
  "82060": 8,
  "82061": -7,
  "82063": -6,
  "82070": -7,
  "82071": -7,
  "82072": -6,
  "82073": -7,
  "82081": 1,
  "82082": 0,
  "82083": -7,
  "82084": -7,
  "82190": 12,
  "82201": -8,
  "82210": -8,
  "82212": -13,
  "82213": -9,
  "82214": -8,
  "82215": -8,
  "82217": -13,
  "82218": -13,
  "82219": -13,
  "82221": -13,
  "82222": 7,
  "82223": -3,
  "82224": 9,
  "82225": -14,
  "82227": 7,
  "82229": 9,
  "82240": -13,
  "82242": -14,
  "82243": -3,
  "82244": -3,
  "82301": -1,
  "82310": -10,
  "82321": -4,
  "82322": -1,
  "82323": -4,
  "82324": 0,
  "82325": 2,
  "82327": -1,
  "82329": -7,
  "82331": 2,
  "82332": -4,
  "82334": -1,
  "82335": 0,
  "82336": 0,
  "82401": -10,
  "82410": -8,
  "82411": -8,
  "82412": -10,
  "82414": -10,
  "82420": -8,
  "82421": -10,
  "82422": -8,
  "82423": -11,
  "82426": -8,
  "82428": -9,
  "82430": -13,
  "82431": -8,
  "82432": -8,
  "82433": -10,
  "82434": -8,
  "82435": -10,
  "82440": -10,
  "82441": -8,
  "82442": -10,
  "82443": -13,
  "82450": -10,
  "82501": -10,
  "82510": -10,
  "82512": -10,
  "82513": 1,
  "82514": -10,
  "82515": -10,
  "82516": -10,
  "82520": -10,
  "82523": -10,
  "82524": -10,
  "82601": 2,
  "82602": 2,
  "82604": 2,
  "82605": 2,
  "82609": 2,
  "82615": -1,
  "82620": 2,
  "82630": -13,
  "82633": -9,
  "82635": 2,
  "82636": 2,
  "82637": 8,
  "82638": -13,
  "82639": -11,
  "82640": -12,
  "82642": -13,
  "82643": 2,
  "82644": 2,
  "82646": 2,
  "82648": 2,
  "82649": -10,
  "82701": -13,
  "82710": -2,
  "82711": -10,
  "82712": -6,
  "82714": 1,
  "82715": -10,
  "82716": -1,
  "82717": -1,
  "82718": -1,
  "82720": -10,
  "82721": -10,
  "82723": -10,
  "82725": -1,
  "82727": -1,
  "82729": -10,
  "82730": -10,
  "82731": -10,
  "82732": -1,
  "82801": -6,
  "82831": -6,
  "82832": -4,
  "82833": -4,
  "82834": -11,
  "82835": -6,
  "82836": -6,
  "82837": 5,
  "82838": -6,
  "82839": -6,
  "82840": -11,
  "82842": -6,
  "82844": 5,
  "82845": -6,
  "82901": 1,
  "82902": 1,
  "82922": 1,
  "82923": -9,
  "82925": -9,
  "82929": -1,
  "82930": 0,
  "82931": 0,
  "82932": 1,
  "82933": 0,
  "82934": -1,
  "82935": 1,
  "82936": 0,
  "82937": 0,
  "82938": 0,
  "82939": 0,
  "82941": -9,
  "82942": 0,
  "82943": 0,
  "82944": 0,
  "82945": 0,
  "83001": 5,
  "83002": 5,
  "83011": 12,
  "83012": 12,
  "83013": 12,
  "83014": 12,
  "83025": 12,
  "83101": -8,
  "83110": -18,
  "83111": -3,
  "83112": -3,
  "83113": -9,
  "83114": -7,
  "83115": -9,
  "83116": -8,
  "83118": -3,
  "83119": -18,
  "83120": -3,
  "83121": -8,
  "83122": -3,
  "83123": -8,
  "83124": -1,
  "83126": -8,
  "83127": -3,
  "83128": -3,
  "83201": -8,
  "83202": -8,
  "83203": -8,
  "83204": -8,
  "83205": -8,
  "83206": -8,
  "83210": -8,
  "83211": -8,
  "83212": -8,
  "83213": 6,
  "83214": -8,
  "83215": 6,
  "83217": -3,
  "83218": -12,
  "83220": -19,
  "83221": -12,
  "83223": -19,
  "83226": -15,
  "83227": -15,
  "83228": -8,
  "83229": 1,
  "83230": -3,
  "83232": -8,
  "83233": -19,
  "83234": -17,
  "83235": -10,
  "83236": -12,
  "83237": -7,
  "83238": -19,
  "83239": -19,
  "83241": -3,
  "83243": -17,
  "83244": 6,
  "83245": -8,
  "83246": -3,
  "83250": -8,
  "83251": -16,
  "83252": -17,
  "83253": -16,
  "83254": -19,
  "83255": 6,
  "83256": -12,
  "83261": -19,
  "83262": -11,
  "83263": -8,
  "83271": -8,
  "83272": -17,
  "83274": -6,
  "83276": -3,
  "83277": -12,
  "83278": -14,
  "83281": -8,
  "83283": -8,
  "83285": -3,
  "83286": -7,
  "83287": -17,
  "83301": -9,
  "83302": -8,
  "83303": -9,
  "83311": -9,
  "83312": -10,
  "83313": -6,
  "83314": -9,
  "83316": -8,
  "83318": -10,
  "83320": -6,
  "83321": -8,
  "83322": -4,
  "83323": -7,
  "83324": 4,
  "83325": -6,
  "83327": -4,
  "83328": -8,
  "83330": -9,
  "83332": -9,
  "83333": -4,
  "83334": -6,
  "83335": -6,
  "83336": -7,
  "83337": -4,
  "83338": -6,
  "83340": 6,
  "83341": -9,
  "83342": -10,
  "83343": -7,
  "83344": -6,
  "83346": -10,
  "83347": -7,
  "83348": 5,
  "83349": 4,
  "83350": -7,
  "83352": 4,
  "83353": -4,
  "83354": -4,
  "83355": -9,
  "83401": -6,
  "83402": -5,
  "83403": -5,
  "83404": -5,
  "83405": -5,
  "83406": -5,
  "83414": 12,
  "83420": -14,
  "83421": -14,
  "83422": -7,
  "83423": -11,
  "83424": -7,
  "83425": -11,
  "83427": -6,
  "83428": -7,
  "83429": -13,
  "83431": -11,
  "83433": -14,
  "83434": -11,
  "83435": -11,
  "83436": -13,
  "83438": -14,
  "83440": -13,
  "83442": -13,
  "83443": -6,
  "83444": -11,
  "83445": -14,
  "83446": -14,
  "83448": -13,
  "83449": -7,
  "83450": -11,
  "83451": -13,
  "83452": -7,
  "83454": -6,
  "83455": -7,
  "83462": -10,
  "83463": -10,
  "83464": -12,
  "83465": -2,
  "83466": -10,
  "83467": -10,
  "83468": -10,
  "83469": 1,
  "83501": -4,
  "83520": -12,
  "83522": -11,
  "83523": -12,
  "83524": -4,
  "83525": -12,
  "83526": -11,
  "83530": -12,
  "83531": -12,
  "83533": -11,
  "83535": -4,
  "83536": -11,
  "83537": -11,
  "83539": -12,
  "83540": -4,
  "83541": -4,
  "83542": -12,
  "83543": -12,
  "83544": -11,
  "83545": -11,
  "83546": -9,
  "83547": -13,
  "83548": -12,
  "83549": -13,
  "83552": -12,
  "83553": -9,
  "83554": -12,
  "83555": -11,
  "83601": -5,
  "83602": -7,
  "83604": -14,
  "83605": -7,
  "83606": -7,
  "83607": -8,
  "83610": -8,
  "83611": -9,
  "83612": -13,
  "83615": -9,
  "83616": 2,
  "83617": -11,
  "83619": -7,
  "83622": -7,
  "83623": -8,
  "83624": -14,
  "83626": -8,
  "83627": -8,
  "83628": -8,
  "83629": -10,
  "83630": -8,
  "83631": -7,
  "83632": -7,
  "83633": -9,
  "83634": 1,
  "83635": -8,
  "83636": -11,
  "83637": -7,
  "83638": -8,
  "83639": -8,
  "83641": -7,
  "83642": 1,
  "83643": -13,
  "83644": -7,
  "83645": -8,
  "83646": 1,
  "83647": -8,
  "83648": -8,
  "83650": -14,
  "83651": -8,
  "83652": -7,
  "83653": -8,
  "83654": -13,
  "83655": -7,
  "83656": -8,
  "83657": -10,
  "83660": -7,
  "83661": -7,
  "83666": -8,
  "83669": -7,
  "83670": -10,
  "83671": -13,
  "83672": -8,
  "83676": -8,
  "83677": -9,
  "83680": 1,
  "83686": -7,
  "83687": -8,
  "83701": 1,
  "83702": 2,
  "83703": 1,
  "83704": 1,
  "83705": 1,
  "83706": 1,
  "83707": 2,
  "83708": 2,
  "83709": 1,
  "83711": 1,
  "83712": 2,
  "83713": 1,
  "83714": 1,
  "83715": 1,
  "83716": 2,
  "83717": 1,
  "83719": 1,
  "83799": 2,
  "83801": -6,
  "83802": -7,
  "83803": -6,
  "83804": -6,
  "83805": -11,
  "83806": -12,
  "83808": -7,
  "83809": -8,
  "83810": -6,
  "83811": -8,
  "83812": -14,
  "83813": -8,
  "83814": -6,
  "83815": -6,
  "83816": -6,
  "83821": 0,
  "83822": -8,
  "83823": -11,
  "83824": -14,
  "83825": 0,
  "83826": -11,
  "83827": -10,
  "83830": -14,
  "83832": -4,
  "83833": 3,
  "83834": -11,
  "83835": -6,
  "83836": 0,
  "83837": -7,
  "83839": -7,
  "83840": -9,
  "83841": -8,
  "83842": -5,
  "83843": -11,
  "83845": -11,
  "83846": -7,
  "83847": -11,
  "83848": -15,
  "83849": -7,
  "83850": -7,
  "83851": -14,
  "83852": -9,
  "83853": -11,
  "83854": -6,
  "83855": -11,
  "83856": -8,
  "83857": -11,
  "83858": -6,
  "83860": 0,
  "83861": -14,
  "83864": -9,
  "83865": -8,
  "83866": -14,
  "83867": -7,
  "83868": -7,
  "83869": -6,
  "83870": -14,
  "83871": -11,
  "83872": -11,
  "83873": -7,
  "83874": -7,
  "83876": -4,
  "83877": -6,
  "84001": -3,
  "84002": -1,
  "84003": 6,
  "84004": 16,
  "84005": 2,
  "84006": 5,
  "84007": -3,
  "84008": -3,
  "84010": -1,
  "84011": -1,
  "84013": 2,
  "84014": -1,
  "84015": -1,
  "84016": -1,
  "84017": -1,
  "84018": -6,
  "84020": 5,
  "84021": -4,
  "84022": -5,
  "84023": -2,
  "84024": -1,
  "84025": -2,
  "84026": -3,
  "84027": 5,
  "84028": -10,
  "84029": 5,
  "84031": -3,
  "84032": 5,
  "84033": -5,
  "84034": -6,
  "84035": -3,
  "84036": -1,
  "84037": -2,
  "84038": -10,
  "84039": -3,
  "84040": -2,
  "84041": -2,
  "84042": 3,
  "84043": 5,
  "84044": 5,
  "84045": 2,
  "84046": -3,
  "84047": 5,
  "84049": 6,
  "84050": -6,
  "84051": -3,
  "84052": -3,
  "84053": -3,
  "84054": -1,
  "84055": 0,
  "84056": -1,
  "84057": 2,
  "84058": 2,
  "84059": 2,
  "84060": 16,
  "84061": 0,
  "84062": 2,
  "84063": -3,
  "84064": -10,
  "84065": 5,
  "84066": -3,
  "84067": -1,
  "84068": 10,
  "84069": -5,
  "84070": 5,
  "84071": -5,
  "84072": -3,
  "84073": -4,
  "84074": 5,
  "84075": -2,
  "84076": -3,
  "84078": -3,
  "84079": -3,
  "84080": -8,
  "84081": 5,
  "84082": 5,
  "84083": -6,
  "84084": 5,
  "84085": -3,
  "84086": -10,
  "84087": -1,
  "84088": 5,
  "84089": -1,
  "84090": 5,
  "84091": 5,
  "84092": 5,
  "84093": 5,
  "84094": 5,
  "84095": 5,
  "84096": 5,
  "84097": 2,
  "84098": 10,
  "84101": 5,
  "84102": 5,
  "84103": 5,
  "84104": 5,
  "84105": 5,
  "84106": 5,
  "84107": 5,
  "84108": 5,
  "84109": 5,
  "84110": 5,
  "84111": 5,
  "84112": 5,
  "84113": 5,
  "84114": 5,
  "84115": 5,
  "84116": 5,
  "84117": 5,
  "84118": 5,
  "84119": 5,
  "84120": 5,
  "84121": 5,
  "84122": 5,
  "84123": 5,
  "84124": 5,
  "84125": 5,
  "84126": 5,
  "84127": 5,
  "84128": 5,
  "84130": 5,
  "84131": 5,
  "84133": 5,
  "84138": 5,
  "84144": 5,
  "84145": 5,
  "84147": 5,
  "84151": 5,
  "84152": 5,
  "84157": 5,
  "84158": 5,
  "84165": 5,
  "84170": 5,
  "84171": 5,
  "84180": 5,
  "84301": -8,
  "84302": -2,
  "84304": -8,
  "84305": -8,
  "84306": 3,
  "84307": -3,
  "84308": -8,
  "84309": -8,
  "84310": 0,
  "84311": -8,
  "84312": -8,
  "84313": -2,
  "84314": -8,
  "84315": -1,
  "84316": -3,
  "84317": 0,
  "84318": -8,
  "84319": -8,
  "84320": -8,
  "84321": -8,
  "84323": -8,
  "84324": -2,
  "84325": -8,
  "84326": -8,
  "84327": -8,
  "84328": -8,
  "84329": -3,
  "84330": -8,
  "84331": -8,
  "84332": -8,
  "84333": -8,
  "84334": -8,
  "84335": -8,
  "84336": -3,
  "84337": -3,
  "84338": -8,
  "84339": -8,
  "84340": -2,
  "84341": -8,
  "84401": -2,
  "84402": -2,
  "84403": -2,
  "84404": -2,
  "84405": -2,
  "84409": -2,
  "84412": -2,
  "84414": -2,
  "84415": -2,
  "84501": -2,
  "84510": -14,
  "84511": -13,
  "84512": -14,
  "84513": -1,
  "84515": -9,
  "84516": -1,
  "84518": -1,
  "84520": -5,
  "84521": -1,
  "84522": -2,
  "84523": -1,
  "84525": -2,
  "84526": -5,
  "84528": -2,
  "84529": -5,
  "84530": -9,
  "84531": -14,
  "84532": -9,
  "84533": -8,
  "84534": -14,
  "84535": -13,
  "84536": -13,
  "84537": -1,
  "84539": -5,
  "84540": -9,
  "84542": -4,
  "84601": 2,
  "84602": 2,
  "84603": 2,
  "84604": 10,
  "84605": 2,
  "84606": 2,
  "84620": -12,
  "84621": -12,
  "84622": -12,
  "84623": -12,
  "84624": -4,
  "84626": 2,
  "84627": -12,
  "84628": 2,
  "84629": -12,
  "84630": -12,
  "84631": -12,
  "84632": -12,
  "84633": 2,
  "84634": -12,
  "84635": -5,
  "84636": -13,
  "84637": -4,
  "84638": -8,
  "84639": -12,
  "84640": -8,
  "84642": -12,
  "84643": -12,
  "84644": -4,
  "84645": 4,
  "84646": -12,
  "84647": -12,
  "84648": -8,
  "84649": -8,
  "84651": 4,
  "84652": -12,
  "84653": 10,
  "84654": -12,
  "84655": 4,
  "84656": -12,
  "84657": -12,
  "84660": 4,
  "84662": -12,
  "84663": 10,
  "84664": 10,
  "84665": -12,
  "84667": -12,
  "84701": -12,
  "84710": -12,
  "84711": -12,
  "84712": -4,
  "84713": -12,
  "84714": -8,
  "84715": -8,
  "84716": -8,
  "84718": -4,
  "84719": -8,
  "84720": -8,
  "84721": -8,
  "84722": -9,
  "84723": -4,
  "84724": -12,
  "84725": -9,
  "84726": -4,
  "84728": -5,
  "84729": -12,
  "84730": -12,
  "84731": -12,
  "84732": -5,
  "84733": -9,
  "84734": -8,
  "84735": -12,
  "84736": -4,
  "84737": -9,
  "84738": -9,
  "84739": -12,
  "84740": -5,
  "84741": -12,
  "84742": -9,
  "84743": -5,
  "84744": -12,
  "84745": -9,
  "84746": -9,
  "84747": -8,
  "84749": -8,
  "84750": -12,
  "84751": -12,
  "84752": -12,
  "84753": -8,
  "84754": -12,
  "84755": -12,
  "84756": -8,
  "84757": -9,
  "84758": -12,
  "84759": -4,
  "84760": -8,
  "84761": -8,
  "84762": -12,
  "84763": -9,
  "84764": -4,
  "84765": -9,
  "84766": -12,
  "84767": -9,
  "84770": -9,
  "84771": -9,
  "84772": -8,
  "84773": 1,
  "84774": -9,
  "84775": 1,
  "84776": -4,
  "84779": -9,
  "84780": -9,
  "84781": -9,
  "84782": -9,
  "84783": -9,
  "84784": -9,
  "84790": -9,
  "84791": -9,
  "85001": 7,
  "85002": 7,
  "85003": 15,
  "85004": 7,
  "85005": 7,
  "85006": 7,
  "85007": 7,
  "85008": 7,
  "85009": 7,
  "85010": 7,
  "85011": 7,
  "85012": 7,
  "85013": 7,
  "85014": 7,
  "85015": 7,
  "85016": 7,
  "85017": 7,
  "85018": 15,
  "85019": 7,
  "85020": 7,
  "85021": 7,
  "85022": 7,
  "85023": 7,
  "85024": 7,
  "85025": 7,
  "85026": 7,
  "85027": 8,
  "85028": 15,
  "85029": 7,
  "85030": 15,
  "85031": 7,
  "85032": 8,
  "85033": 7,
  "85034": 7,
  "85035": 7,
  "85036": 7,
  "85037": 7,
  "85038": 7,
  "85039": 7,
  "85040": 7,
  "85041": 7,
  "85042": 7,
  "85043": 7,
  "85044": 8,
  "85045": 16,
  "85046": 8,
  "85048": 9,
  "85050": 8,
  "85051": 7,
  "85053": 7,
  "85054": 8,
  "85055": 7,
  "85060": 15,
  "85061": 7,
  "85062": 7,
  "85063": 7,
  "85064": 7,
  "85065": 7,
  "85066": 7,
  "85067": 7,
  "85068": 7,
  "85069": 7,
  "85070": 9,
  "85071": 7,
  "85072": 7,
  "85073": 7,
  "85074": 7,
  "85075": 7,
  "85076": 8,
  "85078": 8,
  "85079": 7,
  "85080": 7,
  "85082": 7,
  "85083": 7,
  "85085": 8,
  "85086": 8,
  "85087": 8,
  "85117": 0,
  "85118": 0,
  "85119": 0,
  "85120": 0,
  "85121": 0,
  "85122": 0,
  "85123": 0,
  "85127": 0,
  "85128": 0,
  "85130": -1,
  "85131": -1,
  "85132": -1,
  "85135": -1,
  "85137": -1,
  "85138": 0,
  "85139": 0,
  "85140": 0,
  "85141": -1,
  "85142": 0,
  "85143": 0,
  "85145": -1,
  "85147": -1,
  "85172": 0,
  "85173": -9,
  "85178": 0,
  "85190": 0,
  "85191": 0,
  "85192": 0,
  "85193": -14,
  "85194": -1,
  "85201": 7,
  "85202": 7,
  "85203": 7,
  "85204": 7,
  "85205": 7,
  "85206": 7,
  "85207": 7,
  "85208": 7,
  "85209": 7,
  "85210": 7,
  "85211": 7,
  "85212": 7,
  "85213": 7,
  "85214": 7,
  "85215": 7,
  "85216": 7,
  "85217": 0,
  "85218": 0,
  "85219": 0,
  "85220": 7,
  "85221": 0,
  "85222": -1,
  "85223": -1,
  "85224": 8,
  "85225": 7,
  "85226": 8,
  "85227": 0,
  "85228": -1,
  "85230": -1,
  "85231": -1,
  "85232": -1,
  "85233": 7,
  "85234": 7,
  "85235": -1,
  "85236": 7,
  "85237": -1,
  "85238": 0,
  "85239": 7,
  "85240": 0,
  "85241": -1,
  "85242": 0,
  "85243": 0,
  "85244": 7,
  "85245": -1,
  "85246": 8,
  "85247": -1,
  "85248": 8,
  "85249": 7,
  "85250": 8,
  "85251": 8,
  "85252": 8,
  "85253": 19,
  "85254": 8,
  "85255": 11,
  "85256": 7,
  "85257": 7,
  "85258": 8,
  "85259": 11,
  "85260": 8,
  "85261": 8,
  "85262": 12,
  "85263": 11,
  "85264": 8,
  "85266": 8,
  "85267": 8,
  "85268": 8,
  "85269": 8,
  "85271": 7,
  "85272": 0,
  "85273": -9,
  "85274": 7,
  "85275": 7,
  "85277": 7,
  "85278": 7,
  "85280": 7,
  "85281": 7,
  "85282": 7,
  "85283": 8,
  "85284": 16,
  "85285": 7,
  "85286": 8,
  "85290": 11,
  "85291": -1,
  "85292": -1,
  "85293": 0,
  "85294": -1,
  "85295": 7,
  "85296": 7,
  "85297": 7,
  "85298": 7,
  "85299": 7,
  "85301": 7,
  "85302": 7,
  "85303": 7,
  "85304": 7,
  "85305": 7,
  "85306": 7,
  "85307": 7,
  "85308": 7,
  "85309": 8,
  "85310": 8,
  "85311": 7,
  "85312": 7,
  "85318": 7,
  "85320": 0,
  "85321": 0,
  "85322": 7,
  "85323": 7,
  "85324": -7,
  "85325": -1,
  "85326": 7,
  "85327": 8,
  "85328": -2,
  "85329": 7,
  "85331": 8,
  "85332": -8,
  "85333": -11,
  "85334": -2,
  "85335": 7,
  "85336": -10,
  "85337": 7,
  "85338": 8,
  "85339": 7,
  "85340": 8,
  "85341": 0,
  "85342": 7,
  "85343": 7,
  "85344": -1,
  "85345": 7,
  "85346": -2,
  "85347": -10,
  "85348": 0,
  "85349": -10,
  "85350": -10,
  "85351": 7,
  "85352": -10,
  "85353": 7,
  "85354": 7,
  "85355": 15,
  "85356": -10,
  "85357": 0,
  "85358": 7,
  "85359": -2,
  "85360": -8,
  "85361": 7,
  "85362": -8,
  "85363": 7,
  "85364": -10,
  "85365": -10,
  "85366": -10,
  "85367": -10,
  "85369": -10,
  "85371": -1,
  "85372": 7,
  "85373": 7,
  "85374": 7,
  "85375": 7,
  "85376": 7,
  "85377": 12,
  "85378": 7,
  "85379": 7,
  "85380": 7,
  "85381": 7,
  "85382": 7,
  "85383": 7,
  "85385": 7,
  "85387": 7,
  "85388": 7,
  "85390": 7,
  "85392": 7,
  "85395": 8,
  "85396": 8,
  "85501": -9,
  "85502": -9,
  "85530": -10,
  "85531": -9,
  "85532": -9,
  "85533": -3,
  "85534": -3,
  "85535": -10,
  "85536": -9,
  "85539": -9,
  "85540": -3,
  "85541": -8,
  "85542": -9,
  "85543": -10,
  "85544": -7,
  "85545": -9,
  "85546": -10,
  "85547": -8,
  "85548": -10,
  "85550": -9,
  "85551": -10,
  "85552": -10,
  "85553": -8,
  "85554": -8,
  "85601": -12,
  "85602": -10,
  "85603": -10,
  "85605": -10,
  "85606": -10,
  "85607": -10,
  "85608": -10,
  "85609": -10,
  "85610": -10,
  "85611": -11,
  "85613": -10,
  "85614": -6,
  "85615": -9,
  "85616": -10,
  "85617": -10,
  "85618": -6,
  "85619": 5,
  "85620": -10,
  "85621": -12,
  "85622": -6,
  "85623": -6,
  "85624": -11,
  "85625": -10,
  "85626": -10,
  "85627": -8,
  "85628": -12,
  "85629": -6,
  "85630": -10,
  "85631": -6,
  "85632": -10,
  "85633": -11,
  "85634": -6,
  "85635": -10,
  "85636": -9,
  "85637": -3,
  "85638": -10,
  "85639": -6,
  "85640": -12,
  "85641": -6,
  "85643": -10,
  "85644": -10,
  "85645": -12,
  "85646": -11,
  "85648": -11,
  "85650": -9,
  "85652": -6,
  "85653": -6,
  "85654": -6,
  "85655": -10,
  "85658": -6,
  "85662": -12,
  "85670": -10,
  "85671": -10,
  "85701": -6,
  "85702": -6,
  "85703": -6,
  "85704": -6,
  "85705": -6,
  "85706": -6,
  "85707": -6,
  "85708": -6,
  "85710": -6,
  "85711": -6,
  "85712": -6,
  "85713": -6,
  "85714": -6,
  "85715": 3,
  "85716": -6,
  "85717": -6,
  "85718": 3,
  "85719": -6,
  "85720": -6,
  "85722": -6,
  "85725": -6,
  "85726": -6,
  "85728": 3,
  "85730": -6,
  "85731": -6,
  "85732": -6,
  "85733": -6,
  "85734": -6,
  "85735": -12,
  "85736": -11,
  "85737": -4,
  "85738": -6,
  "85739": 3,
  "85740": -6,
  "85741": -6,
  "85742": -6,
  "85743": -6,
  "85745": -6,
  "85746": -6,
  "85747": -6,
  "85748": -6,
  "85749": 3,
  "85750": 3,
  "85751": -6,
  "85752": -6,
  "85754": -6,
  "85755": -4,
  "85756": -6,
  "85757": -6,
  "85901": -8,
  "85902": -8,
  "85911": -9,
  "85912": -8,
  "85920": -2,
  "85922": -2,
  "85923": -8,
  "85924": -10,
  "85925": -2,
  "85926": -9,
  "85927": -2,
  "85928": -8,
  "85929": -9,
  "85930": -3,
  "85931": -6,
  "85932": -2,
  "85933": -8,
  "85934": -8,
  "85935": -9,
  "85936": -16,
  "85937": -10,
  "85938": -2,
  "85939": -10,
  "85940": -8,
  "85941": -9,
  "85942": -10,
  "86001": -5,
  "86002": -7,
  "86003": -7,
  "86004": -7,
  "86015": -5,
  "86016": -7,
  "86017": -7,
  "86018": -7,
  "86020": -7,
  "86021": -5,
  "86022": -7,
  "86023": -7,
  "86024": -7,
  "86025": -10,
  "86028": -10,
  "86029": -10,
  "86030": -10,
  "86031": -10,
  "86032": -10,
  "86033": -16,
  "86034": -10,
  "86035": -7,
  "86036": -7,
  "86038": -7,
  "86039": -10,
  "86040": -7,
  "86042": -10,
  "86043": -10,
  "86044": -7,
  "86045": -7,
  "86046": -7,
  "86047": -10,
  "86052": -7,
  "86053": -7,
  "86054": -7,
  "86301": -7,
  "86302": -7,
  "86303": 1,
  "86304": -7,
  "86305": 1,
  "86312": -7,
  "86313": 1,
  "86314": -7,
  "86315": 1,
  "86320": -7,
  "86321": -8,
  "86322": -7,
  "86323": -7,
  "86324": -7,
  "86325": -7,
  "86326": -7,
  "86327": -7,
  "86329": -7,
  "86330": -7,
  "86331": -7,
  "86332": -8,
  "86333": -7,
  "86334": -7,
  "86335": -7,
  "86336": 1,
  "86337": -8,
  "86338": 1,
  "86339": 1,
  "86340": 1,
  "86341": 1,
  "86342": -7,
  "86343": -8,
  "86351": 1,
  "86401": -8,
  "86402": -8,
  "86403": -1,
  "86404": 1,
  "86405": -1,
  "86406": 1,
  "86409": -8,
  "86411": -8,
  "86412": -8,
  "86413": -8,
  "86426": -8,
  "86427": -8,
  "86429": -8,
  "86430": -8,
  "86431": -8,
  "86432": -5,
  "86433": -8,
  "86434": -8,
  "86435": -7,
  "86436": -8,
  "86437": -8,
  "86438": -8,
  "86439": -8,
  "86440": -8,
  "86441": -8,
  "86442": -8,
  "86443": -8,
  "86444": -8,
  "86445": -8,
  "86446": -8,
  "86502": -16,
  "86503": -16,
  "86504": -17,
  "86505": -17,
  "86506": -16,
  "86507": -17,
  "86508": -17,
  "86510": -10,
  "86511": -17,
  "86512": -16,
  "86514": -14,
  "86515": -17,
  "86520": -16,
  "86535": -16,
  "86538": -17,
  "86540": -17,
  "86544": -14,
  "86545": -16,
  "86547": -16,
  "86556": -17,
  "87001": -1,
  "87002": 3,
  "87004": -1,
  "87005": -9,
  "87006": 3,
  "87007": -9,
  "87008": 7,
  "87009": -15,
  "87010": -7,
  "87011": -14,
  "87012": -3,
  "87013": 1,
  "87014": -9,
  "87015": -1,
  "87016": -15,
  "87017": -3,
  "87018": -3,
  "87020": -9,
  "87021": -9,
  "87022": 3,
  "87023": 3,
  "87024": 1,
  "87025": 1,
  "87026": 3,
  "87027": -3,
  "87028": -17,
  "87029": -3,
  "87031": 3,
  "87032": -15,
  "87034": -9,
  "87035": -15,
  "87036": -15,
  "87037": 0,
  "87038": -9,
  "87040": 3,
  "87041": 12,
  "87042": 3,
  "87043": 7,
  "87044": 2,
  "87045": -9,
  "87046": -3,
  "87047": -1,
  "87048": 7,
  "87049": -9,
  "87051": -9,
  "87052": -8,
  "87053": 1,
  "87056": -7,
  "87059": 0,
  "87060": 11,
  "87061": -15,
  "87062": 3,
  "87063": -15,
  "87064": 12,
  "87068": 3,
  "87070": -15,
  "87072": 12,
  "87083": 12,
  "87101": -1,
  "87102": -1,
  "87103": 7,
  "87104": -1,
  "87105": -1,
  "87106": -1,
  "87107": -1,
  "87108": -1,
  "87109": -1,
  "87110": -1,
  "87111": 0,
  "87112": -1,
  "87113": -1,
  "87114": -1,
  "87115": -1,
  "87116": -1,
  "87119": -1,
  "87120": -1,
  "87121": -1,
  "87122": 7,
  "87123": -1,
  "87124": -1,
  "87125": -1,
  "87144": 7,
  "87153": -1,
  "87154": 0,
  "87174": -1,
  "87176": 0,
  "87181": -1,
  "87184": -1,
  "87185": -1,
  "87187": -1,
  "87190": -1,
  "87191": 0,
  "87192": -1,
  "87193": -1,
  "87194": -1,
  "87195": -1,
  "87196": -1,
  "87197": -1,
  "87198": -1,
  "87199": -1,
  "87301": -11,
  "87305": -11,
  "87310": -11,
  "87311": -11,
  "87312": -10,
  "87313": -11,
  "87315": -9,
  "87316": -11,
  "87317": -11,
  "87319": -11,
  "87320": -11,
  "87321": -9,
  "87322": -11,
  "87323": -11,
  "87325": -11,
  "87326": -11,
  "87327": -11,
  "87328": -11,
  "87347": -11,
  "87357": -9,
  "87364": 0,
  "87365": -11,
  "87375": -11,
  "87401": 1,
  "87402": 1,
  "87410": 1,
  "87412": 1,
  "87413": 1,
  "87415": 1,
  "87416": 0,
  "87417": 0,
  "87418": 1,
  "87419": 1,
  "87420": 0,
  "87421": 0,
  "87455": 0,
  "87461": 0,
  "87499": 1,
  "87501": -7,
  "87502": -7,
  "87504": -7,
  "87505": -7,
  "87506": -7,
  "87507": -7,
  "87508": -7,
  "87510": 12,
  "87511": 12,
  "87512": -4,
  "87513": -4,
  "87514": -4,
  "87515": -3,
  "87516": 12,
  "87517": -4,
  "87518": -3,
  "87519": -4,
  "87520": -3,
  "87521": -4,
  "87522": 12,
  "87523": 12,
  "87524": -4,
  "87525": -4,
  "87527": -4,
  "87528": -3,
  "87529": -4,
  "87530": -3,
  "87531": 12,
  "87532": 12,
  "87533": 12,
  "87535": -8,
  "87537": 12,
  "87538": -9,
  "87539": -4,
  "87540": -6,
  "87543": -4,
  "87544": 12,
  "87548": 12,
  "87549": -4,
  "87551": -3,
  "87552": -7,
  "87553": -4,
  "87554": -4,
  "87556": -4,
  "87557": -4,
  "87558": -4,
  "87560": -9,
  "87562": -8,
  "87564": -4,
  "87565": -9,
  "87566": 12,
  "87567": 12,
  "87569": -9,
  "87571": -4,
  "87573": -6,
  "87574": -7,
  "87575": -3,
  "87576": -4,
  "87577": -4,
  "87578": 12,
  "87579": -4,
  "87580": -4,
  "87581": -4,
  "87582": 12,
  "87583": -9,
  "87592": -7,
  "87594": -7,
  "87701": -9,
  "87710": -4,
  "87711": -9,
  "87712": -9,
  "87713": -4,
  "87714": -13,
  "87715": -4,
  "87718": -4,
  "87722": -9,
  "87723": -4,
  "87724": -9,
  "87728": -13,
  "87729": -13,
  "87730": -7,
  "87731": -9,
  "87732": -4,
  "87733": -7,
  "87734": -9,
  "87735": -9,
  "87736": -9,
  "87740": -14,
  "87742": -9,
  "87743": -7,
  "87745": -9,
  "87746": -7,
  "87747": -13,
  "87749": -13,
  "87750": 2,
  "87752": -13,
  "87753": -9,
  "87801": -17,
  "87820": -16,
  "87821": -17,
  "87823": -17,
  "87824": -18,
  "87825": -17,
  "87827": -17,
  "87828": -17,
  "87829": -17,
  "87830": -18,
  "87831": -17,
  "87832": -17,
  "87901": -5,
  "87930": -5,
  "87931": -4,
  "87933": -5,
  "87935": -4,
  "87936": -5,
  "87937": -5,
  "87939": -4,
  "87940": -5,
  "87941": -5,
  "87942": -5,
  "87943": -4,
  "88001": -9,
  "88002": -8,
  "88003": -9,
  "88004": -8,
  "88005": -8,
  "88006": -9,
  "88007": -8,
  "88008": -8,
  "88009": -9,
  "88011": -8,
  "88012": -8,
  "88013": -9,
  "88020": -9,
  "88021": -8,
  "88022": -9,
  "88023": -9,
  "88024": -9,
  "88025": -3,
  "88026": -9,
  "88027": -9,
  "88028": -3,
  "88029": 9,
  "88030": 9,
  "88031": 9,
  "88032": -8,
  "88033": 0,
  "88034": -8,
  "88036": -9,
  "88038": -8,
  "88039": -18,
  "88040": 9,
  "88041": -8,
  "88042": -5,
  "88043": -9,
  "88044": -9,
  "88045": -9,
  "88046": -8,
  "88047": -8,
  "88048": -9,
  "88049": -8,
  "88051": 6,
  "88052": -9,
  "88053": -8,
  "88054": -5,
  "88055": -3,
  "88056": -10,
  "88058": -9,
  "88061": -8,
  "88062": -8,
  "88063": -8,
  "88065": -8,
  "88072": -8,
  "88081": -8,
  "88101": -11,
  "88102": -11,
  "88103": -11,
  "88112": -11,
  "88113": -12,
  "88114": -19,
  "88115": -19,
  "88116": -19,
  "88118": -19,
  "88119": -18,
  "88120": -16,
  "88121": -16,
  "88122": -19,
  "88123": -19,
  "88124": -12,
  "88125": -19,
  "88126": -17,
  "88130": -19,
  "88132": -19,
  "88133": -12,
  "88134": -19,
  "88135": -11,
  "88136": -7,
  "88201": -11,
  "88202": -11,
  "88203": -11,
  "88210": 3,
  "88211": 3,
  "88213": 0,
  "88220": 3,
  "88221": 3,
  "88230": -11,
  "88231": 1,
  "88232": -12,
  "88240": 1,
  "88241": 1,
  "88242": 1,
  "88250": 4,
  "88252": 1,
  "88253": -11,
  "88254": 4,
  "88255": 3,
  "88256": 3,
  "88260": 1,
  "88262": 1,
  "88263": 3,
  "88264": 3,
  "88265": 1,
  "88267": 10,
  "88268": 14,
  "88301": -14,
  "88310": -11,
  "88311": -11,
  "88312": -15,
  "88314": -11,
  "88316": -15,
  "88317": -10,
  "88318": -14,
  "88321": -15,
  "88323": -15,
  "88324": -15,
  "88325": -11,
  "88330": -11,
  "88336": -15,
  "88337": -10,
  "88338": -15,
  "88339": -10,
  "88340": -15,
  "88341": -15,
  "88342": -8,
  "88343": -11,
  "88344": -10,
  "88345": -15,
  "88346": -15,
  "88347": -10,
  "88348": -15,
  "88349": -10,
  "88350": -10,
  "88351": -15,
  "88352": -11,
  "88353": -18,
  "88354": -10,
  "88355": -15,
  "88401": -16,
  "88410": 3,
  "88411": -16,
  "88414": -15,
  "88415": -4,
  "88416": -14,
  "88417": -18,
  "88418": -15,
  "88419": -15,
  "88421": -9,
  "88422": -7,
  "88424": -14,
  "88426": -16,
  "88427": -16,
  "88430": 2,
  "88431": -13,
  "88433": -16,
  "88434": -16,
  "88435": -18,
  "88436": -4,
  "88439": 2,
  "88510": -8,
  "88511": -8,
  "88512": -8,
  "88513": -8,
  "88514": -8,
  "88515": -8,
  "88516": -8,
  "88517": -8,
  "88518": -8,
  "88519": -8,
  "88520": -8,
  "88521": -8,
  "88523": -8,
  "88524": -8,
  "88525": -8,
  "88526": -8,
  "88527": -8,
  "88528": -8,
  "88529": -8,
  "88530": -8,
  "88531": -8,
  "88532": -8,
  "88533": -8,
  "88534": -8,
  "88535": -8,
  "88536": -8,
  "88538": -8,
  "88539": -8,
  "88540": -8,
  "88541": -8,
  "88542": -8,
  "88543": -8,
  "88544": -8,
  "88545": -8,
  "88546": -8,
  "88547": -8,
  "88548": -8,
  "88549": -8,
  "88550": -8,
  "88553": -8,
  "88554": -8,
  "88555": -8,
  "88556": -8,
  "88557": -8,
  "88558": -8,
  "88559": -8,
  "88560": -8,
  "88561": -8,
  "88562": -8,
  "88563": -8,
  "88565": -8,
  "88566": -8,
  "88567": -8,
  "88568": -8,
  "88569": -8,
  "88570": -8,
  "88571": -8,
  "88572": -8,
  "88573": -8,
  "88574": -8,
  "88575": -8,
  "88576": -8,
  "88577": -8,
  "88578": -8,
  "88579": -8,
  "88580": -8,
  "88581": -8,
  "88582": -8,
  "88583": -8,
  "88584": -8,
  "88585": -8,
  "88586": -8,
  "88587": -8,
  "88588": -8,
  "88589": -8,
  "88590": -8,
  "88595": -8,
  "89001": -5,
  "89002": 6,
  "89003": -8,
  "89004": 6,
  "89005": 6,
  "89006": 6,
  "89007": 6,
  "89008": -5,
  "89009": 6,
  "89010": -7,
  "89011": 16,
  "89012": 6,
  "89013": -6,
  "89014": 6,
  "89015": 6,
  "89016": 16,
  "89017": -5,
  "89018": 5,
  "89019": 5,
  "89020": 5,
  "89021": 6,
  "89022": -8,
  "89023": 5,
  "89024": 6,
  "89025": 5,
  "89027": 6,
  "89028": 6,
  "89029": 6,
  "89030": 5,
  "89031": 6,
  "89032": 6,
  "89033": 6,
  "89034": -5,
  "89036": 5,
  "89037": 5,
  "89039": 5,
  "89040": 5,
  "89041": 5,
  "89042": -5,
  "89043": -5,
  "89044": 6,
  "89045": -8,
  "89046": 5,
  "89047": -7,
  "89048": 5,
  "89049": -8,
  "89052": 6,
  "89053": 6,
  "89054": 6,
  "89060": 5,
  "89061": 5,
  "89067": 5,
  "89074": 6,
  "89077": 6,
  "89081": 6,
  "89084": 6,
  "89085": 6,
  "89086": 6,
  "89087": 6,
  "89101": 5,
  "89102": 6,
  "89103": 5,
  "89104": 5,
  "89105": 6,
  "89106": 5,
  "89107": 6,
  "89108": 6,
  "89109": 6,
  "89110": 5,
  "89111": 6,
  "89112": 5,
  "89113": 6,
  "89114": 6,
  "89115": 5,
  "89116": 5,
  "89117": 6,
  "89118": 6,
  "89119": 6,
  "89120": 6,
  "89121": 5,
  "89122": 5,
  "89123": 6,
  "89124": 6,
  "89125": 5,
  "89126": 6,
  "89127": 5,
  "89128": 6,
  "89129": 6,
  "89130": 6,
  "89131": 6,
  "89132": 6,
  "89133": 6,
  "89134": 6,
  "89135": 6,
  "89136": 5,
  "89137": 6,
  "89138": 6,
  "89139": 6,
  "89140": 6,
  "89141": 6,
  "89142": 6,
  "89143": 6,
  "89144": 6,
  "89145": 6,
  "89146": 6,
  "89147": 6,
  "89148": 10,
  "89149": 6,
  "89154": 6,
  "89156": 6,
  "89157": 5,
  "89160": 6,
  "89161": 6,
  "89162": 5,
  "89165": 6,
  "89166": 6,
  "89169": 6,
  "89170": 6,
  "89173": 5,
  "89178": 10,
  "89179": 6,
  "89180": 5,
  "89183": 5,
  "89185": 5,
  "89191": 5,
  "89193": 6,
  "89199": 5,
  "89301": -1,
  "89310": -4,
  "89311": 8,
  "89314": -1,
  "89315": -1,
  "89316": -4,
  "89317": -1,
  "89318": -1,
  "89319": -1,
  "89402": 13,
  "89403": 13,
  "89404": -2,
  "89405": 3,
  "89406": 3,
  "89407": 3,
  "89408": 3,
  "89409": -9,
  "89410": -2,
  "89411": 9,
  "89412": 3,
  "89413": 13,
  "89414": -1,
  "89415": -9,
  "89418": -2,
  "89419": 3,
  "89420": -8,
  "89421": -3,
  "89422": -9,
  "89423": -2,
  "89424": 4,
  "89425": -2,
  "89426": -1,
  "89427": -9,
  "89428": 13,
  "89429": -3,
  "89430": -2,
  "89431": 4,
  "89432": 4,
  "89433": 4,
  "89434": 4,
  "89435": 4,
  "89436": 4,
  "89438": -1,
  "89439": 4,
  "89440": 13,
  "89441": 13,
  "89442": 4,
  "89444": -2,
  "89445": -1,
  "89446": -1,
  "89447": -3,
  "89448": 2,
  "89449": -2,
  "89450": 13,
  "89451": 13,
  "89452": 13,
  "89460": -2,
  "89501": 4,
  "89502": 13,
  "89503": 4,
  "89504": 4,
  "89505": 4,
  "89506": 4,
  "89507": 4,
  "89508": 4,
  "89509": 4,
  "89510": 4,
  "89511": 13,
  "89512": 4,
  "89513": 4,
  "89515": 13,
  "89519": 13,
  "89520": 13,
  "89521": 13,
  "89523": 4,
  "89533": 4,
  "89570": 13,
  "89701": 2,
  "89702": 2,
  "89703": 2,
  "89704": 2,
  "89705": 2,
  "89706": 2,
  "89721": -2,
  "89801": 5,
  "89802": 5,
  "89803": 5,
  "89815": 5,
  "89820": -4,
  "89821": -4,
  "89822": 4,
  "89823": 4,
  "89824": 4,
  "89825": 3,
  "89826": 3,
  "89828": 5,
  "89830": 4,
  "89831": 4,
  "89832": 4,
  "89833": 5,
  "89834": 4,
  "89835": 4,
  "89883": 4,
  "90001": 9,
  "90002": 9,
  "90003": 9,
  "90004": 12,
  "90005": 12,
  "90006": 9,
  "90007": 9,
  "90008": 12,
  "90009": 12,
  "90010": 12,
  "90011": 9,
  "90012": 9,
  "90013": 9,
  "90014": 9,
  "90015": 9,
  "90016": 9,
  "90017": 12,
  "90018": 9,
  "90019": 12,
  "90020": 9,
  "90021": 12,
  "90022": 9,
  "90023": 9,
  "90024": 13,
  "90025": 12,
  "90026": 9,
  "90027": 12,
  "90028": 9,
  "90029": 9,
  "90030": 9,
  "90031": 9,
  "90032": 9,
  "90033": 9,
  "90034": 12,
  "90035": 12,
  "90036": 12,
  "90037": 9,
  "90038": 9,
  "90039": 12,
  "90040": 12,
  "90041": 9,
  "90042": 9,
  "90043": 9,
  "90044": 9,
  "90045": 12,
  "90046": 12,
  "90047": 9,
  "90048": 12,
  "90049": 20,
  "90050": 9,
  "90051": 9,
  "90052": 9,
  "90053": 9,
  "90054": 9,
  "90055": 9,
  "90056": 12,
  "90057": 9,
  "90058": 9,
  "90059": 9,
  "90060": 12,
  "90061": 9,
  "90062": 9,
  "90063": 9,
  "90064": 12,
  "90065": 9,
  "90066": 12,
  "90067": 12,
  "90068": 12,
  "90069": 12,
  "90070": 12,
  "90071": 12,
  "90072": 9,
  "90073": 12,
  "90075": 9,
  "90076": 12,
  "90077": 20,
  "90078": 9,
  "90079": 9,
  "90080": 12,
  "90081": 12,
  "90082": 9,
  "90083": 12,
  "90086": 9,
  "90087": 9,
  "90091": 9,
  "90093": 9,
  "90094": 12,
  "90099": 9,
  "90101": 9,
  "90201": 9,
  "90202": 9,
  "90209": 13,
  "90210": 20,
  "90211": 13,
  "90212": 20,
  "90213": 20,
  "90220": 9,
  "90221": 9,
  "90222": 9,
  "90223": 9,
  "90224": 9,
  "90230": 12,
  "90231": 12,
  "90232": 12,
  "90233": 12,
  "90239": 9,
  "90240": 12,
  "90241": 9,
  "90242": 9,
  "90245": 12,
  "90247": 9,
  "90248": 9,
  "90249": 9,
  "90250": 9,
  "90251": 9,
  "90254": 13,
  "90255": 9,
  "90260": 9,
  "90261": 9,
  "90262": 9,
  "90263": 14,
  "90264": 14,
  "90265": 14,
  "90266": 20,
  "90267": 13,
  "90270": 9,
  "90272": 20,
  "90274": 20,
  "90275": 20,
  "90277": 12,
  "90278": 12,
  "90280": 9,
  "90290": 12,
  "90291": 12,
  "90292": 12,
  "90293": 12,
  "90294": 12,
  "90295": 12,
  "90296": 12,
  "90301": 9,
  "90302": 9,
  "90303": 9,
  "90304": 9,
  "90305": 9,
  "90306": 9,
  "90307": 9,
  "90308": 9,
  "90309": 9,
  "90310": 9,
  "90311": 9,
  "90312": 9,
  "90401": 12,
  "90402": 20,
  "90403": 12,
  "90404": 12,
  "90405": 12,
  "90406": 12,
  "90407": 12,
  "90408": 12,
  "90409": 12,
  "90410": 12,
  "90411": 12,
  "90501": 12,
  "90502": 9,
  "90503": 12,
  "90504": 12,
  "90505": 12,
  "90506": 12,
  "90507": 12,
  "90508": 12,
  "90509": 12,
  "90510": 12,
  "90601": 9,
  "90602": 9,
  "90603": 14,
  "90604": 13,
  "90605": 9,
  "90606": 9,
  "90607": 9,
  "90608": 9,
  "90609": 9,
  "90610": 9,
  "90620": 14,
  "90621": 13,
  "90622": 14,
  "90623": 16,
  "90624": 14,
  "90630": 16,
  "90631": 14,
  "90632": 14,
  "90633": 14,
  "90637": 14,
  "90638": 14,
  "90640": 9,
  "90650": 9,
  "90651": 9,
  "90652": 9,
  "90660": 9,
  "90661": 9,
  "90662": 12,
  "90670": 9,
  "90671": 9,
  "90680": 13,
  "90701": 14,
  "90702": 14,
  "90703": 16,
  "90704": 16,
  "90706": 9,
  "90707": 9,
  "90710": 9,
  "90711": 9,
  "90712": 9,
  "90713": 14,
  "90714": 9,
  "90715": 14,
  "90716": 9,
  "90717": 12,
  "90720": 16,
  "90721": 16,
  "90723": 9,
  "90731": 16,
  "90732": 12,
  "90733": 16,
  "90734": 12,
  "90740": 13,
  "90742": 25,
  "90743": 25,
  "90744": 9,
  "90745": 9,
  "90746": 9,
  "90748": 9,
  "90749": 9,
  "90755": 13,
  "90801": 13,
  "90802": 13,
  "90803": 16,
  "90804": 16,
  "90805": 9,
  "90806": 14,
  "90807": 9,
  "90808": 16,
  "90809": 16,
  "90810": 9,
  "90813": 13,
  "90814": 16,
  "90815": 16,
  "90822": 9,
  "90831": 13,
  "90832": 13,
  "90833": 13,
  "90834": 13,
  "90835": 13,
  "90853": 16,
  "91001": 12,
  "91003": 12,
  "91006": 12,
  "91007": 12,
  "91008": 9,
  "91009": 9,
  "91010": 9,
  "91011": 20,
  "91012": 20,
  "91016": 9,
  "91017": 9,
  "91020": 12,
  "91021": 12,
  "91023": 12,
  "91024": 13,
  "91025": 13,
  "91030": 13,
  "91031": 13,
  "91040": 9,
  "91041": 9,
  "91042": 9,
  "91043": 9,
  "91046": 12,
  "91066": 12,
  "91077": 12,
  "91101": 9,
  "91102": 9,
  "91103": 9,
  "91104": 12,
  "91105": 20,
  "91106": 12,
  "91107": 12,
  "91108": 20,
  "91109": 9,
  "91114": 12,
  "91115": 20,
  "91116": 12,
  "91117": 12,
  "91118": 12,
  "91201": 12,
  "91202": 12,
  "91203": 9,
  "91204": 9,
  "91205": 9,
  "91206": 12,
  "91207": 20,
  "91208": 13,
  "91209": 9,
  "91210": 9,
  "91214": 12,
  "91221": 12,
  "91222": 9,
  "91224": 12,
  "91225": 9,
  "91226": 12,
  "91301": 5,
  "91302": 7,
  "91303": 9,
  "91304": 9,
  "91305": 9,
  "91306": 9,
  "91307": 5,
  "91308": 9,
  "91309": 9,
  "91310": 3,
  "91311": 12,
  "91313": 12,
  "91316": 12,
  "91319": 3,
  "91320": 3,
  "91321": 9,
  "91322": 9,
  "91324": 12,
  "91325": 12,
  "91326": 12,
  "91327": 12,
  "91328": 9,
  "91331": 9,
  "91333": 9,
  "91334": 9,
  "91335": 9,
  "91337": 9,
  "91340": 9,
  "91341": 9,
  "91342": 9,
  "91343": 9,
  "91344": 12,
  "91345": 9,
  "91346": 9,
  "91350": 16,
  "91351": 9,
  "91352": 9,
  "91353": 9,
  "91354": 5,
  "91355": 12,
  "91356": 12,
  "91357": 12,
  "91358": 5,
  "91359": 5,
  "91360": 5,
  "91361": 14,
  "91362": 5,
  "91364": 12,
  "91365": 12,
  "91367": 12,
  "91372": 7,
  "91376": 5,
  "91377": 5,
  "91380": 16,
  "91381": 5,
  "91382": 9,
  "91383": 9,
  "91384": 3,
  "91385": 12,
  "91386": 9,
  "91387": 9,
  "91390": 16,
  "91392": 9,
  "91393": 9,
  "91394": 12,
  "91395": 9,
  "91396": 9,
  "91401": 12,
  "91402": 9,
  "91403": 12,
  "91404": 12,
  "91405": 9,
  "91406": 9,
  "91407": 9,
  "91408": 12,
  "91409": 9,
  "91410": 9,
  "91411": 9,
  "91412": 9,
  "91413": 12,
  "91416": 12,
  "91423": 12,
  "91426": 12,
  "91436": 9,
  "91501": 12,
  "91502": 9,
  "91503": 9,
  "91504": 12,
  "91505": 9,
  "91506": 12,
  "91507": 9,
  "91508": 12,
  "91510": 9,
  "91601": 9,
  "91602": 12,
  "91603": 9,
  "91604": 12,
  "91605": 9,
  "91606": 9,
  "91607": 12,
  "91608": 12,
  "91609": 9,
  "91610": 12,
  "91614": 12,
  "91615": 9,
  "91616": 9,
  "91617": 12,
  "91618": 12,
  "91701": 21,
  "91702": 9,
  "91706": 9,
  "91708": 13,
  "91709": 13,
  "91710": 13,
  "91711": 16,
  "91714": 9,
  "91715": 9,
  "91716": 9,
  "91722": 9,
  "91723": 9,
  "91724": 9,
  "91729": 13,
  "91730": 13,
  "91731": 9,
  "91732": 9,
  "91733": 9,
  "91734": 9,
  "91737": 21,
  "91739": 12,
  "91740": 9,
  "91741": 12,
  "91743": 13,
  "91744": 9,
  "91745": 9,
  "91746": 9,
  "91747": 9,
  "91748": 14,
  "91749": 9,
  "91750": 9,
  "91752": 13,
  "91754": 9,
  "91755": 9,
  "91758": 13,
  "91759": 19,
  "91761": 13,
  "91762": 13,
  "91763": 13,
  "91764": 13,
  "91765": 16,
  "91766": 13,
  "91767": 13,
  "91768": 13,
  "91769": 13,
  "91770": 9,
  "91773": 9,
  "91775": 12,
  "91776": 9,
  "91778": 9,
  "91780": 9,
  "91784": 24,
  "91785": 13,
  "91786": 13,
  "91788": 16,
  "91789": 16,
  "91790": 9,
  "91791": 9,
  "91792": 9,
  "91793": 9,
  "91801": 9,
  "91802": 9,
  "91803": 9,
  "91804": 9,
  "91896": 9,
  "91899": 9,
  "91901": 11,
  "91902": 12,
  "91903": 11,
  "91905": 8,
  "91906": 8,
  "91908": 12,
  "91909": 9,
  "91910": 9,
  "91911": 9,
  "91912": 9,
  "91913": 9,
  "91914": 9,
  "91915": 9,
  "91916": 8,
  "91917": 9,
  "91921": 9,
  "91931": 8,
  "91932": 9,
  "91933": 9,
  "91934": -1,
  "91935": 11,
  "91941": 11,
  "91942": 9,
  "91943": 9,
  "91944": 11,
  "91945": 8,
  "91946": 8,
  "91947": 9,
  "91948": 8,
  "91950": 9,
  "91951": 9,
  "91962": 11,
  "91963": 9,
  "91976": 11,
  "91977": 8,
  "91978": 8,
  "91979": 8,
  "91980": 9,
  "92003": 11,
  "92004": 0,
  "92007": 11,
  "92008": 9,
  "92009": 11,
  "92010": 11,
  "92011": 9,
  "92013": 9,
  "92014": 20,
  "92018": 9,
  "92019": 11,
  "92020": 9,
  "92021": 9,
  "92022": 8,
  "92023": 11,
  "92024": 11,
  "92025": 8,
  "92026": 8,
  "92027": 8,
  "92028": 9,
  "92029": 11,
  "92030": 8,
  "92033": 8,
  "92036": 8,
  "92037": 20,
  "92038": 20,
  "92039": 20,
  "92040": 9,
  "92046": 8,
  "92049": 8,
  "92051": 8,
  "92052": 8,
  "92054": 8,
  "92055": 8,
  "92056": 8,
  "92057": 8,
  "92058": 8,
  "92059": 8,
  "92060": 8,
  "92061": 8,
  "92064": 9,
  "92065": 9,
  "92066": 8,
  "92067": 20,
  "92068": 8,
  "92069": 8,
  "92070": 8,
  "92071": 9,
  "92072": 9,
  "92074": 9,
  "92075": 11,
  "92078": 8,
  "92079": 8,
  "92081": 8,
  "92082": 9,
  "92083": 8,
  "92084": 8,
  "92085": 8,
  "92086": 2,
  "92088": 9,
  "92091": 11,
  "92101": 11,
  "92102": 9,
  "92103": 11,
  "92104": 9,
  "92105": 8,
  "92106": 13,
  "92107": 12,
  "92108": 8,
  "92109": 11,
  "92110": 11,
  "92111": 9,
  "92112": 11,
  "92113": 8,
  "92114": 9,
  "92115": 9,
  "92116": 9,
  "92117": 9,
  "92118": 20,
  "92119": 9,
  "92120": 11,
  "92121": 11,
  "92122": 11,
  "92123": 9,
  "92124": 11,
  "92126": 9,
  "92127": 9,
  "92128": 9,
  "92129": 11,
  "92130": 20,
  "92131": 11,
  "92135": 20,
  "92137": 11,
  "92138": 11,
  "92139": 9,
  "92142": 11,
  "92143": 9,
  "92149": 9,
  "92150": 9,
  "92153": 9,
  "92154": 9,
  "92159": 9,
  "92160": 11,
  "92162": 9,
  "92163": 11,
  "92164": 9,
  "92165": 8,
  "92166": 13,
  "92167": 12,
  "92168": 8,
  "92169": 11,
  "92170": 8,
  "92171": 9,
  "92172": 11,
  "92173": 9,
  "92174": 9,
  "92175": 9,
  "92176": 9,
  "92177": 9,
  "92178": 20,
  "92179": 9,
  "92186": 11,
  "92190": 11,
  "92191": 11,
  "92192": 11,
  "92193": 9,
  "92194": 9,
  "92195": 8,
  "92196": 9,
  "92197": 9,
  "92198": 9,
  "92199": 9,
  "92201": 2,
  "92202": 2,
  "92203": 2,
  "92210": 13,
  "92211": 2,
  "92220": -1,
  "92222": -10,
  "92223": -1,
  "92225": -1,
  "92226": -1,
  "92227": -3,
  "92230": 1,
  "92231": -1,
  "92232": -1,
  "92233": -3,
  "92234": 2,
  "92235": 2,
  "92236": 2,
  "92239": -1,
  "92240": 1,
  "92241": 1,
  "92242": -1,
  "92243": -3,
  "92244": -3,
  "92247": 2,
  "92248": 2,
  "92249": -3,
  "92250": -3,
  "92251": 6,
  "92252": 1,
  "92253": 2,
  "92254": 2,
  "92255": 2,
  "92256": 1,
  "92257": -1,
  "92258": 1,
  "92259": -1,
  "92260": 2,
  "92261": 2,
  "92262": 2,
  "92263": 2,
  "92264": 3,
  "92266": -2,
  "92267": -1,
  "92268": 4,
  "92270": 3,
  "92273": -3,
  "92274": 2,
  "92275": 2,
  "92276": 2,
  "92277": 2,
  "92278": 2,
  "92280": -1,
  "92281": -3,
  "92282": 2,
  "92283": -10,
  "92284": 2,
  "92285": 3,
  "92286": 2,
  "92292": 3,
  "92301": 3,
  "92304": 4,
  "92305": 3,
  "92307": 3,
  "92308": 2,
  "92309": 5,
  "92310": 2,
  "92311": 2,
  "92312": 2,
  "92313": 3,
  "92314": 2,
  "92315": 3,
  "92316": 3,
  "92317": 11,
  "92318": 2,
  "92320": -1,
  "92321": 3,
  "92322": 3,
  "92323": 6,
  "92324": 3,
  "92325": 3,
  "92326": 11,
  "92327": 2,
  "92328": 2,
  "92329": 3,
  "92331": 3,
  "92332": 5,
  "92333": 4,
  "92334": 3,
  "92335": 3,
  "92336": 3,
  "92337": 13,
  "92338": 4,
  "92339": 0,
  "92340": 2,
  "92341": 3,
  "92342": 2,
  "92344": 2,
  "92345": 2,
  "92346": 3,
  "92347": 3,
  "92352": 11,
  "92354": 3,
  "92356": 2,
  "92358": 3,
  "92359": 3,
  "92363": 5,
  "92364": 5,
  "92365": 2,
  "92366": 5,
  "92368": 2,
  "92369": 3,
  "92371": 2,
  "92372": 3,
  "92373": 3,
  "92374": 3,
  "92375": 3,
  "92376": 3,
  "92377": 3,
  "92378": 3,
  "92382": 3,
  "92384": 16,
  "92385": 3,
  "92386": 3,
  "92389": 5,
  "92391": 3,
  "92392": 3,
  "92393": 3,
  "92394": 2,
  "92395": 3,
  "92397": 3,
  "92398": 2,
  "92399": 0,
  "92401": 2,
  "92402": 3,
  "92403": 2,
  "92404": 2,
  "92405": 2,
  "92406": 2,
  "92407": 3,
  "92408": 2,
  "92410": 2,
  "92411": 2,
  "92412": 2,
  "92413": 2,
  "92423": 2,
  "92427": 3,
  "92501": 13,
  "92502": 13,
  "92503": 13,
  "92504": 13,
  "92505": 13,
  "92506": 14,
  "92507": 2,
  "92508": 2,
  "92509": 13,
  "92513": 13,
  "92514": 13,
  "92515": 13,
  "92516": 14,
  "92517": 13,
  "92518": 2,
  "92519": 13,
  "92530": 13,
  "92531": 13,
  "92532": 2,
  "92536": 2,
  "92539": 2,
  "92543": -1,
  "92544": -1,
  "92545": -1,
  "92546": -1,
  "92548": -1,
  "92549": 10,
  "92551": 2,
  "92552": 2,
  "92553": 2,
  "92554": 2,
  "92555": 2,
  "92556": 2,
  "92557": 2,
  "92561": 2,
  "92562": 2,
  "92563": 2,
  "92564": 2,
  "92567": -1,
  "92570": 2,
  "92571": 2,
  "92572": 2,
  "92581": -1,
  "92582": -1,
  "92583": -1,
  "92584": 2,
  "92585": -1,
  "92586": -1,
  "92587": 2,
  "92589": 2,
  "92590": 13,
  "92591": 2,
  "92592": 2,
  "92593": 2,
  "92595": 2,
  "92596": 7,
  "92602": 16,
  "92603": 16,
  "92604": 16,
  "92605": 16,
  "92606": 16,
  "92607": 16,
  "92609": 16,
  "92610": 16,
  "92612": 16,
  "92614": 16,
  "92615": 16,
  "92616": 16,
  "92617": 16,
  "92618": 16,
  "92619": 13,
  "92620": 16,
  "92623": 16,
  "92624": 16,
  "92625": 25,
  "92626": 16,
  "92627": 16,
  "92628": 16,
  "92629": 16,
  "92630": 16,
  "92637": 13,
  "92646": 16,
  "92647": 16,
  "92648": 18,
  "92649": 16,
  "92650": 16,
  "92651": 18,
  "92652": 18,
  "92653": 13,
  "92654": 13,
  "92655": 13,
  "92656": 16,
  "92657": 25,
  "92658": 16,
  "92659": 25,
  "92660": 16,
  "92661": 25,
  "92662": 25,
  "92663": 25,
  "92672": 16,
  "92673": 16,
  "92674": 16,
  "92675": 16,
  "92676": 16,
  "92677": 16,
  "92678": 16,
  "92679": 16,
  "92683": 14,
  "92684": 14,
  "92685": 14,
  "92688": 16,
  "92690": 16,
  "92691": 16,
  "92692": 16,
  "92693": 16,
  "92694": 16,
  "92701": 13,
  "92702": 13,
  "92703": 13,
  "92704": 13,
  "92705": 16,
  "92706": 14,
  "92707": 13,
  "92708": 16,
  "92711": 18,
  "92712": 13,
  "92728": 13,
  "92735": 13,
  "92780": 16,
  "92781": 16,
  "92782": 16,
  "92799": 13,
  "92801": 13,
  "92802": 13,
  "92803": 13,
  "92804": 14,
  "92805": 13,
  "92806": 14,
  "92807": 16,
  "92808": 16,
  "92809": 13,
  "92811": 16,
  "92812": 13,
  "92814": 14,
  "92815": 13,
  "92816": 14,
  "92817": 16,
  "92821": 16,
  "92822": 16,
  "92823": 16,
  "92825": 13,
  "92831": 16,
  "92832": 13,
  "92833": 14,
  "92834": 16,
  "92835": 16,
  "92836": 16,
  "92837": 14,
  "92838": 16,
  "92840": 13,
  "92841": 14,
  "92842": 13,
  "92843": 13,
  "92844": 13,
  "92845": 16,
  "92846": 16,
  "92856": 16,
  "92857": 14,
  "92859": 16,
  "92860": 15,
  "92861": 25,
  "92862": 16,
  "92863": 16,
  "92864": 16,
  "92865": 14,
  "92866": 16,
  "92867": 16,
  "92868": 13,
  "92869": 16,
  "92870": 16,
  "92871": 16,
  "92877": 14,
  "92878": 13,
  "92879": 13,
  "92880": 14,
  "92881": 15,
  "92882": 14,
  "92883": 14,
  "92885": 16,
  "92886": 16,
  "92887": 25,
  "92899": 14,
  "93001": 2,
  "93002": 2,
  "93003": 3,
  "93004": 3,
  "93005": 3,
  "93006": 2,
  "93007": 3,
  "93010": 3,
  "93011": 3,
  "93012": 3,
  "93013": 5,
  "93014": 5,
  "93015": 2,
  "93016": 2,
  "93020": 3,
  "93021": 3,
  "93022": 2,
  "93023": 3,
  "93024": 3,
  "93030": 2,
  "93031": 2,
  "93032": 2,
  "93033": 2,
  "93034": 2,
  "93035": 3,
  "93036": 2,
  "93040": 2,
  "93041": 2,
  "93044": 2,
  "93060": 2,
  "93061": 2,
  "93062": 5,
  "93063": 3,
  "93065": 5,
  "93066": 14,
  "93067": 4,
  "93094": 5,
  "93101": 4,
  "93102": 4,
  "93103": 4,
  "93105": 4,
  "93107": 4,
  "93108": 12,
  "93109": 4,
  "93110": 4,
  "93111": 4,
  "93116": 4,
  "93117": 4,
  "93118": 4,
  "93120": 4,
  "93121": 4,
  "93130": 4,
  "93140": 4,
  "93150": 12,
  "93160": 4,
  "93190": 4,
  "93201": -4,
  "93202": -4,
  "93203": 3,
  "93204": -3,
  "93205": 3,
  "93206": 3,
  "93207": -5,
  "93208": -4,
  "93210": -3,
  "93212": -4,
  "93215": -4,
  "93216": -4,
  "93218": -4,
  "93219": -5,
  "93220": 3,
  "93221": -4,
  "93222": 2,
  "93223": -4,
  "93224": 0,
  "93225": 2,
  "93226": 3,
  "93227": -4,
  "93230": -3,
  "93232": -4,
  "93234": -4,
  "93235": -4,
  "93237": -4,
  "93238": 3,
  "93239": -4,
  "93240": 3,
  "93241": 3,
  "93242": 3,
  "93243": 3,
  "93244": -4,
  "93245": 5,
  "93247": -4,
  "93249": -3,
  "93250": -4,
  "93251": 0,
  "93252": 3,
  "93254": 1,
  "93255": 3,
  "93256": -4,
  "93257": -4,
  "93258": -5,
  "93260": 3,
  "93261": -5,
  "93262": -4,
  "93263": 3,
  "93265": 4,
  "93266": -4,
  "93267": -5,
  "93268": 3,
  "93270": -4,
  "93271": -4,
  "93272": -4,
  "93274": -4,
  "93275": -4,
  "93276": 3,
  "93277": -4,
  "93278": -4,
  "93279": -4,
  "93280": 3,
  "93282": -4,
  "93283": 3,
  "93285": 2,
  "93286": -4,
  "93287": 11,
  "93290": -4,
  "93291": -4,
  "93292": -4,
  "93301": 3,
  "93302": 3,
  "93303": 3,
  "93304": 3,
  "93305": 3,
  "93306": 3,
  "93307": 3,
  "93308": 3,
  "93309": 3,
  "93311": 3,
  "93312": 4,
  "93313": 3,
  "93314": 4,
  "93380": 3,
  "93383": 3,
  "93384": 3,
  "93385": 3,
  "93386": 3,
  "93387": 3,
  "93388": 3,
  "93389": 3,
  "93390": 3,
  "93401": 2,
  "93402": 2,
  "93403": 2,
  "93405": 2,
  "93406": 2,
  "93407": 2,
  "93410": 2,
  "93412": 2,
  "93420": 2,
  "93421": 2,
  "93422": 2,
  "93423": 2,
  "93424": 4,
  "93426": 2,
  "93427": 1,
  "93428": 12,
  "93429": 1,
  "93430": 4,
  "93432": 2,
  "93433": 2,
  "93434": 1,
  "93435": 12,
  "93436": 1,
  "93437": 1,
  "93438": 1,
  "93440": 1,
  "93441": 3,
  "93442": 2,
  "93443": 2,
  "93444": 3,
  "93445": 2,
  "93446": 2,
  "93447": 2,
  "93448": 2,
  "93449": 2,
  "93450": 2,
  "93451": 2,
  "93452": 4,
  "93453": 2,
  "93454": 1,
  "93455": 1,
  "93456": 2,
  "93457": 1,
  "93458": 2,
  "93460": 3,
  "93461": 2,
  "93463": 3,
  "93464": 3,
  "93465": 2,
  "93475": 2,
  "93483": 2,
  "93501": 3,
  "93502": 3,
  "93504": 3,
  "93505": 3,
  "93510": 16,
  "93512": -6,
  "93513": 0,
  "93514": -5,
  "93515": -5,
  "93516": 3,
  "93517": -5,
  "93518": 3,
  "93519": 3,
  "93522": 3,
  "93523": 2,
  "93526": -1,
  "93527": 2,
  "93528": 2,
  "93529": -4,
  "93530": -1,
  "93531": 11,
  "93532": 8,
  "93534": 8,
  "93535": 8,
  "93536": 8,
  "93539": 8,
  "93541": -6,
  "93542": 2,
  "93543": 8,
  "93544": 8,
  "93545": -1,
  "93546": 3,
  "93549": -1,
  "93550": 8,
  "93551": 8,
  "93552": 8,
  "93553": 8,
  "93554": 2,
  "93555": 3,
  "93556": 3,
  "93558": 2,
  "93560": 3,
  "93561": 3,
  "93562": -1,
  "93563": 8,
  "93581": 3,
  "93584": 8,
  "93586": 8,
  "93590": 8,
  "93591": 8,
  "93592": -1,
  "93596": 3,
  "93601": -4,
  "93602": -3,
  "93603": -4,
  "93604": -3,
  "93605": -3,
  "93606": 2,
  "93607": 3,
  "93608": 2,
  "93609": 3,
  "93610": -4,
  "93611": 3,
  "93612": 3,
  "93613": 3,
  "93614": -3,
  "93615": -4,
  "93616": 2,
  "93618": -4,
  "93619": 3,
  "93620": -6,
  "93621": -4,
  "93622": -6,
  "93623": 7,
  "93624": 3,
  "93625": 3,
  "93626": -3,
  "93627": 14,
  "93628": -4,
  "93630": 2,
  "93631": 3,
  "93633": -4,
  "93634": -6,
  "93635": -5,
  "93636": -4,
  "93637": -4,
  "93638": -4,
  "93639": -3,
  "93640": 2,
  "93641": -4,
  "93642": -6,
  "93643": -3,
  "93644": -4,
  "93645": -2,
  "93646": -4,
  "93647": -4,
  "93648": 2,
  "93649": -3,
  "93650": 2,
  "93651": -3,
  "93652": 3,
  "93653": -3,
  "93654": 3,
  "93656": 3,
  "93657": 3,
  "93660": 3,
  "93661": -6,
  "93662": 3,
  "93664": 5,
  "93665": -6,
  "93666": -4,
  "93667": -3,
  "93668": 2,
  "93669": -3,
  "93670": -4,
  "93673": -4,
  "93675": -4,
  "93701": 2,
  "93702": 2,
  "93703": 2,
  "93704": 3,
  "93705": 2,
  "93706": 2,
  "93707": 2,
  "93708": 2,
  "93709": 2,
  "93710": 3,
  "93711": 3,
  "93712": 2,
  "93714": 2,
  "93715": 2,
  "93716": 2,
  "93717": 2,
  "93718": 2,
  "93720": 3,
  "93721": 2,
  "93722": 3,
  "93723": 3,
  "93725": 2,
  "93726": 3,
  "93727": 3,
  "93728": 2,
  "93729": 3,
  "93730": 3,
  "93744": 2,
  "93745": 2,
  "93747": 3,
  "93755": 3,
  "93771": 2,
  "93772": 2,
  "93773": 2,
  "93774": 2,
  "93775": 2,
  "93776": 2,
  "93777": 2,
  "93778": 2,
  "93779": 2,
  "93790": 2,
  "93791": 2,
  "93792": 2,
  "93793": 2,
  "93794": 2,
  "93901": 2,
  "93902": 2,
  "93905": 2,
  "93906": 2,
  "93907": 3,
  "93908": 13,
  "93912": 3,
  "93915": 2,
  "93920": 5,
  "93921": 5,
  "93922": 5,
  "93923": 5,
  "93924": 5,
  "93925": 5,
  "93926": 2,
  "93927": 2,
  "93928": 3,
  "93930": 2,
  "93932": 3,
  "93933": 2,
  "93940": 5,
  "93942": 5,
  "93943": 3,
  "93944": 3,
  "93950": 5,
  "93953": 5,
  "93954": 2,
  "93955": 3,
  "93960": 2,
  "93962": 2,
  "94002": 21,
  "94005": 30,
  "94010": 29,
  "94011": 29,
  "94014": 30,
  "94015": 30,
  "94016": 30,
  "94017": 30,
  "94018": 21,
  "94019": 21,
  "94020": 26,
  "94021": 21,
  "94022": 28,
  "94023": 28,
  "94024": 34,
  "94025": 21,
  "94026": 21,
  "94027": 23,
  "94028": 23,
  "94030": 21,
  "94035": 26,
  "94037": 21,
  "94038": 21,
  "94039": 26,
  "94040": 26,
  "94041": 26,
  "94042": 26,
  "94043": 26,
  "94044": 21,
  "94060": 21,
  "94061": 21,
  "94062": 21,
  "94063": 21,
  "94064": 21,
  "94065": 21,
  "94066": 21,
  "94070": 21,
  "94074": 21,
  "94080": 30,
  "94083": 30,
  "94085": 26,
  "94086": 26,
  "94087": 26,
  "94088": 26,
  "94089": 23,
  "94101": 30,
  "94102": 30,
  "94103": 30,
  "94104": 30,
  "94105": 30,
  "94107": 30,
  "94108": 30,
  "94109": 30,
  "94110": 30,
  "94111": 30,
  "94112": 30,
  "94114": 30,
  "94115": 30,
  "94116": 30,
  "94117": 30,
  "94118": 30,
  "94119": 30,
  "94120": 30,
  "94121": 30,
  "94122": 30,
  "94123": 38,
  "94124": 29,
  "94125": 29,
  "94126": 30,
  "94127": 30,
  "94128": 21,
  "94129": 38,
  "94130": 30,
  "94131": 30,
  "94132": 30,
  "94133": 30,
  "94134": 30,
  "94140": 30,
  "94141": 30,
  "94142": 30,
  "94146": 30,
  "94147": 38,
  "94158": 30,
  "94159": 30,
  "94164": 30,
  "94172": 30,
  "94188": 29,
  "94203": 7,
  "94204": 7,
  "94205": 7,
  "94206": 7,
  "94207": 7,
  "94208": 7,
  "94209": 7,
  "94211": 7,
  "94229": 7,
  "94230": 7,
  "94232": 8,
  "94234": 7,
  "94235": 7,
  "94236": 7,
  "94237": 7,
  "94239": 8,
  "94240": 7,
  "94244": 7,
  "94245": 7,
  "94246": 7,
  "94247": 7,
  "94248": 7,
  "94249": 8,
  "94250": 7,
  "94252": 7,
  "94254": 7,
  "94256": 7,
  "94257": 7,
  "94258": 7,
  "94259": 8,
  "94261": 7,
  "94262": 7,
  "94263": 7,
  "94267": 7,
  "94268": 7,
  "94269": 8,
  "94271": 7,
  "94273": 7,
  "94274": 7,
  "94277": 7,
  "94278": 8,
  "94279": 7,
  "94280": 7,
  "94282": 7,
  "94283": 7,
  "94284": 8,
  "94285": 8,
  "94286": 8,
  "94287": 7,
  "94288": 7,
  "94289": 7,
  "94290": 8,
  "94291": 8,
  "94293": 8,
  "94294": 8,
  "94295": 7,
  "94296": 7,
  "94297": 8,
  "94298": 7,
  "94301": 23,
  "94302": 23,
  "94303": 21,
  "94304": 23,
  "94305": 21,
  "94306": 21,
  "94309": 21,
  "94401": 23,
  "94402": 21,
  "94403": 21,
  "94404": 21,
  "94501": 21,
  "94502": 23,
  "94503": 15,
  "94505": 16,
  "94506": 29,
  "94507": 28,
  "94508": 14,
  "94509": 18,
  "94510": 18,
  "94511": 5,
  "94512": 26,
  "94513": 25,
  "94514": 16,
  "94515": 6,
  "94516": 21,
  "94517": 20,
  "94518": 18,
  "94519": 17,
  "94520": 17,
  "94521": 18,
  "94522": 17,
  "94523": 20,
  "94524": 17,
  "94525": 17,
  "94526": 21,
  "94527": 17,
  "94528": 21,
  "94530": 30,
  "94531": 18,
  "94533": 15,
  "94534": 15,
  "94535": 15,
  "94536": 21,
  "94537": 21,
  "94538": 21,
  "94539": 26,
  "94540": 19,
  "94541": 19,
  "94542": 21,
  "94543": 19,
  "94544": 19,
  "94545": 19,
  "94546": 21,
  "94547": 18,
  "94548": 17,
  "94549": 22,
  "94550": 20,
  "94551": 20,
  "94552": 21,
  "94553": 17,
  "94555": 21,
  "94556": 20,
  "94557": 19,
  "94558": 11,
  "94559": 11,
  "94560": 21,
  "94561": 17,
  "94562": 11,
  "94563": 28,
  "94564": 17,
  "94565": 17,
  "94566": 21,
  "94567": 11,
  "94568": 21,
  "94569": 19,
  "94570": 18,
  "94571": 15,
  "94572": 17,
  "94573": 15,
  "94574": 15,
  "94575": 20,
  "94576": 15,
  "94577": 19,
  "94578": 18,
  "94579": 19,
  "94580": 19,
  "94581": 11,
  "94582": 21,
  "94583": 21,
  "94585": 15,
  "94586": 21,
  "94587": 21,
  "94588": 21,
  "94589": 15,
  "94590": 15,
  "94591": 15,
  "94592": 17,
  "94595": 20,
  "94596": 20,
  "94597": 20,
  "94598": 20,
  "94599": 11,
  "94601": 18,
  "94602": 21,
  "94603": 18,
  "94604": 27,
  "94605": 18,
  "94606": 18,
  "94607": 27,
  "94608": 27,
  "94609": 27,
  "94610": 21,
  "94611": 21,
  "94612": 27,
  "94613": 21,
  "94614": 18,
  "94615": 27,
  "94617": 18,
  "94618": 21,
  "94619": 21,
  "94620": 18,
  "94621": 18,
  "94623": 27,
  "94624": 18,
  "94661": 21,
  "94662": 27,
  "94701": 30,
  "94702": 27,
  "94703": 30,
  "94704": 20,
  "94705": 22,
  "94706": 30,
  "94707": 20,
  "94708": 20,
  "94709": 20,
  "94710": 27,
  "94712": 20,
  "94801": 10,
  "94802": 10,
  "94803": 18,
  "94804": 27,
  "94805": 27,
  "94806": 10,
  "94807": 27,
  "94808": 27,
  "94820": 18,
  "94850": 10,
  "94901": 13,
  "94903": 13,
  "94904": 14,
  "94912": 13,
  "94913": 13,
  "94914": 14,
  "94915": 13,
  "94920": 22,
  "94922": 8,
  "94923": 8,
  "94924": 13,
  "94925": 13,
  "94927": 6,
  "94928": 6,
  "94929": 8,
  "94930": 13,
  "94931": 6,
  "94933": 13,
  "94937": 13,
  "94938": 13,
  "94939": 13,
  "94940": 17,
  "94941": 13,
  "94942": 13,
  "94945": 13,
  "94946": 22,
  "94947": 13,
  "94948": 13,
  "94949": 13,
  "94950": 13,
  "94951": 8,
  "94952": 8,
  "94953": 6,
  "94954": 6,
  "94955": 6,
  "94956": 13,
  "94957": 14,
  "94960": 13,
  "94963": 13,
  "94964": 22,
  "94965": 30,
  "94966": 30,
  "94970": 22,
  "94971": 8,
  "94972": 17,
  "94973": 13,
  "94974": 14,
  "94975": 8,
  "94976": 13,
  "94977": 13,
  "94978": 13,
  "94979": 13,
  "94999": 8,
  "95001": 4,
  "95002": 24,
  "95003": 4,
  "95004": 4,
  "95005": 4,
  "95006": 4,
  "95007": 4,
  "95008": 26,
  "95009": 26,
  "95010": 4,
  "95011": 26,
  "95012": 1,
  "95013": 26,
  "95014": 26,
  "95015": 26,
  "95017": 4,
  "95018": 4,
  "95019": 1,
  "95020": 4,
  "95021": 4,
  "95023": 5,
  "95024": 5,
  "95026": 26,
  "95030": 26,
  "95031": 26,
  "95032": 28,
  "95033": 28,
  "95035": 26,
  "95036": 28,
  "95037": 26,
  "95038": 4,
  "95039": 1,
  "95041": 1,
  "95042": 26,
  "95043": 5,
  "95044": 26,
  "95045": 5,
  "95046": 4,
  "95050": 26,
  "95051": 26,
  "95052": 26,
  "95054": 26,
  "95055": 26,
  "95056": 26,
  "95060": 4,
  "95061": 4,
  "95062": 4,
  "95063": 4,
  "95064": 4,
  "95065": 4,
  "95066": 4,
  "95067": 4,
  "95070": 34,
  "95071": 34,
  "95073": 4,
  "95075": 5,
  "95076": 1,
  "95077": 2,
  "95101": 26,
  "95103": 26,
  "95106": 34,
  "95108": 34,
  "95109": 34,
  "95110": 26,
  "95111": 25,
  "95112": 26,
  "95113": 34,
  "95115": 26,
  "95116": 25,
  "95117": 26,
  "95118": 26,
  "95119": 26,
  "95120": 26,
  "95121": 26,
  "95122": 26,
  "95123": 26,
  "95124": 26,
  "95125": 26,
  "95126": 26,
  "95127": 26,
  "95128": 26,
  "95129": 26,
  "95130": 26,
  "95131": 26,
  "95132": 26,
  "95133": 26,
  "95134": 23,
  "95135": 26,
  "95136": 26,
  "95138": 26,
  "95139": 26,
  "95140": 26,
  "95141": 26,
  "95148": 26,
  "95150": 26,
  "95151": 26,
  "95152": 26,
  "95153": 26,
  "95154": 26,
  "95155": 26,
  "95156": 25,
  "95157": 26,
  "95158": 26,
  "95159": 26,
  "95160": 26,
  "95161": 26,
  "95164": 23,
  "95170": 26,
  "95172": 34,
  "95173": 34,
  "95201": 5,
  "95202": 5,
  "95203": 5,
  "95204": 5,
  "95205": 5,
  "95206": 5,
  "95207": 5,
  "95208": 5,
  "95209": 5,
  "95210": 5,
  "95212": 5,
  "95213": 5,
  "95215": 5,
  "95219": 5,
  "95220": 6,
  "95221": -2,
  "95222": -2,
  "95223": -2,
  "95224": -2,
  "95225": -2,
  "95226": -4,
  "95227": 16,
  "95228": -2,
  "95229": -1,
  "95230": 2,
  "95231": 5,
  "95232": -4,
  "95233": -1,
  "95234": 5,
  "95236": 6,
  "95237": 6,
  "95240": 5,
  "95241": 6,
  "95242": 6,
  "95245": -2,
  "95246": -2,
  "95247": -1,
  "95248": -2,
  "95249": -2,
  "95250": -2,
  "95251": -2,
  "95252": -2,
  "95253": 5,
  "95254": -4,
  "95255": -4,
  "95257": -4,
  "95258": 6,
  "95267": 5,
  "95269": 5,
  "95301": -6,
  "95303": 3,
  "95304": 5,
  "95305": 0,
  "95306": -4,
  "95307": 1,
  "95309": 1,
  "95310": 1,
  "95311": -4,
  "95312": -6,
  "95313": 3,
  "95314": 2,
  "95315": -5,
  "95316": 1,
  "95317": -6,
  "95318": -4,
  "95319": 1,
  "95320": 2,
  "95321": 2,
  "95322": -5,
  "95323": 2,
  "95324": 1,
  "95325": -4,
  "95326": 1,
  "95327": 1,
  "95328": 1,
  "95329": 2,
  "95330": 5,
  "95333": -3,
  "95334": -5,
  "95335": 1,
  "95336": 5,
  "95337": 5,
  "95338": -4,
  "95340": -6,
  "95341": -6,
  "95343": -6,
  "95344": -6,
  "95345": -4,
  "95346": 1,
  "95347": 0,
  "95348": -6,
  "95350": 1,
  "95351": 1,
  "95352": 1,
  "95353": 1,
  "95354": 1,
  "95355": 1,
  "95356": 1,
  "95357": 1,
  "95358": 1,
  "95360": -5,
  "95361": 1,
  "95363": 1,
  "95364": 2,
  "95365": -6,
  "95366": 2,
  "95367": 1,
  "95368": 1,
  "95369": -6,
  "95370": 1,
  "95372": 1,
  "95373": 1,
  "95374": -4,
  "95375": 1,
  "95376": 5,
  "95377": 5,
  "95378": 16,
  "95379": 1,
  "95380": 1,
  "95381": 1,
  "95382": 2,
  "95383": 2,
  "95385": 1,
  "95386": 1,
  "95387": 1,
  "95388": -6,
  "95389": 4,
  "95391": 16,
  "95401": 6,
  "95402": 6,
  "95403": 6,
  "95404": 8,
  "95405": 6,
  "95406": 6,
  "95407": 6,
  "95409": 6,
  "95410": -1,
  "95412": 6,
  "95415": -2,
  "95416": 13,
  "95417": -2,
  "95418": -2,
  "95419": 6,
  "95420": -1,
  "95421": 6,
  "95422": -4,
  "95423": -4,
  "95424": -4,
  "95425": -3,
  "95426": -4,
  "95427": -1,
  "95428": -2,
  "95429": -2,
  "95430": 8,
  "95431": 14,
  "95432": 10,
  "95433": 13,
  "95435": -4,
  "95436": 6,
  "95437": -2,
  "95439": 6,
  "95441": 8,
  "95442": 14,
  "95443": -4,
  "95444": 6,
  "95445": -1,
  "95446": 6,
  "95448": 8,
  "95449": -4,
  "95450": 8,
  "95451": -4,
  "95452": 8,
  "95453": -4,
  "95454": -2,
  "95456": -1,
  "95457": -4,
  "95458": -4,
  "95459": -1,
  "95460": 1,
  "95461": -4,
  "95462": 6,
  "95463": -1,
  "95464": -4,
  "95465": 8,
  "95466": 1,
  "95467": -4,
  "95468": -1,
  "95469": -2,
  "95470": -1,
  "95471": 6,
  "95472": 8,
  "95473": 8,
  "95476": 13,
  "95480": 17,
  "95481": -2,
  "95482": -2,
  "95485": -4,
  "95486": 6,
  "95487": 13,
  "95488": 9,
  "95490": -2,
  "95492": 6,
  "95493": -4,
  "95494": -3,
  "95497": 8,
  "95501": 0,
  "95502": 0,
  "95503": 0,
  "95511": 5,
  "95514": 0,
  "95518": 0,
  "95519": 0,
  "95521": 0,
  "95524": 0,
  "95525": 0,
  "95526": 5,
  "95527": 5,
  "95528": 0,
  "95531": -9,
  "95534": 0,
  "95536": 0,
  "95537": 0,
  "95538": -9,
  "95540": 0,
  "95542": 0,
  "95543": -9,
  "95545": 0,
  "95546": 0,
  "95547": 0,
  "95548": -9,
  "95549": 0,
  "95550": 10,
  "95551": 0,
  "95552": 5,
  "95553": 0,
  "95554": 0,
  "95555": -9,
  "95556": -9,
  "95558": 0,
  "95559": 0,
  "95560": 0,
  "95562": 0,
  "95563": 0,
  "95564": 0,
  "95565": 0,
  "95567": -9,
  "95568": -8,
  "95569": 0,
  "95570": 0,
  "95571": 0,
  "95573": 0,
  "95585": -2,
  "95587": -3,
  "95589": 0,
  "95595": 5,
  "95601": -4,
  "95602": 16,
  "95603": 8,
  "95604": 8,
  "95605": 7,
  "95606": 16,
  "95607": 16,
  "95608": 7,
  "95609": 7,
  "95610": 7,
  "95611": 7,
  "95612": 8,
  "95613": 8,
  "95614": 8,
  "95615": 8,
  "95616": 16,
  "95617": 16,
  "95618": 16,
  "95619": 4,
  "95620": 16,
  "95621": 7,
  "95623": 4,
  "95624": 9,
  "95625": 15,
  "95626": 7,
  "95627": 15,
  "95628": 8,
  "95629": -4,
  "95630": 8,
  "95631": 8,
  "95632": 8,
  "95633": 8,
  "95634": 8,
  "95635": 8,
  "95636": 4,
  "95637": -1,
  "95638": 8,
  "95639": 7,
  "95640": -4,
  "95641": 5,
  "95642": -4,
  "95644": -4,
  "95645": 16,
  "95646": -2,
  "95648": 8,
  "95650": 8,
  "95651": 8,
  "95652": 7,
  "95653": 15,
  "95654": -4,
  "95655": 7,
  "95656": -4,
  "95658": 16,
  "95659": -4,
  "95660": 7,
  "95661": 8,
  "95662": 7,
  "95663": 9,
  "95664": 8,
  "95665": -4,
  "95666": -4,
  "95667": 4,
  "95668": -4,
  "95669": -4,
  "95670": 7,
  "95672": 8,
  "95673": 7,
  "95674": -4,
  "95675": -4,
  "95676": -4,
  "95677": 7,
  "95678": 7,
  "95679": 16,
  "95680": 7,
  "95681": 1,
  "95682": -4,
  "95683": 8,
  "95684": 4,
  "95685": -4,
  "95686": 5,
  "95687": 15,
  "95688": 16,
  "95689": -4,
  "95690": 7,
  "95691": 7,
  "95692": 1,
  "95693": 9,
  "95694": 16,
  "95695": 16,
  "95696": 15,
  "95697": 16,
  "95698": 16,
  "95699": -4,
  "95701": 5,
  "95703": 9,
  "95709": 4,
  "95712": 5,
  "95713": 8,
  "95714": 6,
  "95715": 6,
  "95717": 5,
  "95720": 5,
  "95721": -2,
  "95722": 16,
  "95724": 5,
  "95726": 4,
  "95728": 5,
  "95735": 7,
  "95736": 7,
  "95741": 7,
  "95742": 7,
  "95746": 18,
  "95747": 8,
  "95757": 7,
  "95758": 7,
  "95759": 7,
  "95762": 15,
  "95763": 8,
  "95765": 8,
  "95776": 16,
  "95798": 7,
  "95799": 7,
  "95811": 7,
  "95812": 7,
  "95813": 7,
  "95814": 7,
  "95815": 7,
  "95816": 8,
  "95817": 7,
  "95818": 8,
  "95819": 8,
  "95820": 7,
  "95821": 7,
  "95822": 7,
  "95823": 7,
  "95824": 7,
  "95825": 7,
  "95826": 7,
  "95827": 7,
  "95828": 7,
  "95829": 7,
  "95830": 15,
  "95831": 8,
  "95832": 7,
  "95833": 7,
  "95834": 7,
  "95835": 8,
  "95836": 8,
  "95837": 27,
  "95838": 7,
  "95841": 7,
  "95842": 7,
  "95843": 7,
  "95851": 7,
  "95852": 7,
  "95853": 7,
  "95860": 7,
  "95864": 8,
  "95865": 7,
  "95866": 7,
  "95899": 7,
  "95901": 0,
  "95903": 0,
  "95910": 5,
  "95912": -2,
  "95913": -7,
  "95914": 1,
  "95915": -6,
  "95916": 2,
  "95917": 1,
  "95918": 1,
  "95919": 1,
  "95920": -2,
  "95922": 5,
  "95923": -6,
  "95924": 5,
  "95925": 1,
  "95926": 2,
  "95927": 2,
  "95928": 2,
  "95930": 2,
  "95932": -2,
  "95934": -6,
  "95935": 1,
  "95936": 5,
  "95937": -2,
  "95938": 11,
  "95939": -8,
  "95940": 2,
  "95941": 2,
  "95942": 10,
  "95943": -7,
  "95944": 5,
  "95945": 5,
  "95946": 2,
  "95947": -6,
  "95948": 1,
  "95949": 8,
  "95950": -4,
  "95951": -8,
  "95953": -5,
  "95954": 2,
  "95955": -3,
  "95956": -6,
  "95957": -5,
  "95958": 2,
  "95959": 6,
  "95960": 5,
  "95961": -5,
  "95962": 1,
  "95963": -7,
  "95965": 1,
  "95966": 2,
  "95967": 2,
  "95968": 1,
  "95969": 2,
  "95970": 0,
  "95971": -6,
  "95972": 1,
  "95973": 2,
  "95974": 2,
  "95975": 1,
  "95977": 1,
  "95978": 2,
  "95979": -2,
  "95980": 2,
  "95981": 2,
  "95982": -4,
  "95983": -6,
  "95984": -6,
  "95986": 4,
  "95987": -2,
  "95988": -7,
  "95991": -5,
  "95992": -5,
  "95993": -4,
  "96001": -3,
  "96002": -3,
  "96003": -3,
  "96006": -7,
  "96007": -3,
  "96008": -3,
  "96009": -7,
  "96010": 5,
  "96011": -3,
  "96013": -3,
  "96014": -3,
  "96015": -7,
  "96016": -3,
  "96017": -3,
  "96019": -3,
  "96020": -6,
  "96021": 12,
  "96022": 12,
  "96023": -2,
  "96024": 5,
  "96025": -3,
  "96027": -2,
  "96028": -3,
  "96029": -7,
  "96031": 5,
  "96032": -2,
  "96033": 5,
  "96034": -2,
  "96035": 12,
  "96037": -2,
  "96038": -2,
  "96039": -9,
  "96040": -3,
  "96041": 5,
  "96044": -2,
  "96046": 5,
  "96047": 5,
  "96048": 5,
  "96049": -3,
  "96050": -2,
  "96051": -3,
  "96052": 5,
  "96054": -7,
  "96055": 12,
  "96056": -7,
  "96057": -3,
  "96058": -2,
  "96059": -3,
  "96061": -4,
  "96062": -2,
  "96063": 12,
  "96064": -2,
  "96065": -3,
  "96067": -3,
  "96068": -7,
  "96069": -3,
  "96070": -3,
  "96071": -3,
  "96073": -3,
  "96074": -8,
  "96075": 11,
  "96076": 5,
  "96078": 12,
  "96079": -3,
  "96080": 12,
  "96084": -3,
  "96085": -2,
  "96086": -7,
  "96087": -3,
  "96088": -3,
  "96089": -3,
  "96090": 12,
  "96091": 5,
  "96092": 12,
  "96093": 5,
  "96094": -2,
  "96095": 5,
  "96096": -3,
  "96097": -2,
  "96099": -3,
  "96101": -7,
  "96103": -5,
  "96104": -7,
  "96105": 4,
  "96106": -5,
  "96107": -2,
  "96108": -4,
  "96109": 4,
  "96110": -6,
  "96111": 2,
  "96112": -6,
  "96113": -6,
  "96114": -5,
  "96115": -6,
  "96116": -6,
  "96117": -5,
  "96118": 4,
  "96119": -7,
  "96120": -2,
  "96121": -5,
  "96122": -5,
  "96123": -6,
  "96124": -5,
  "96125": 5,
  "96126": 5,
  "96127": -6,
  "96128": -5,
  "96129": -5,
  "96130": -6,
  "96132": -7,
  "96133": -2,
  "96134": -6,
  "96135": 4,
  "96136": -6,
  "96137": -6,
  "96140": 5,
  "96141": 6,
  "96142": 2,
  "96143": 2,
  "96145": 6,
  "96146": 6,
  "96148": 2,
  "96150": -2,
  "96151": -2,
  "96152": -2,
  "96154": -2,
  "96155": 2,
  "96156": -2,
  "96157": -2,
  "96158": -2,
  "96160": 2,
  "96161": 2,
  "96162": 5,
  "96701": 23,
  "96703": 15,
  "96704": 12,
  "96705": 15,
  "96706": 21,
  "96707": 21,
  "96708": 20,
  "96709": 21,
  "96710": 15,
  "96712": 21,
  "96713": 20,
  "96714": 18,
  "96715": 15,
  "96716": 15,
  "96717": 21,
  "96718": 12,
  "96719": 12,
  "96720": 12,
  "96721": 12,
  "96722": 18,
  "96725": 12,
  "96726": 12,
  "96727": 12,
  "96728": 15,
  "96729": 17,
  "96730": 23,
  "96731": 21,
  "96732": 18,
  "96733": 18,
  "96734": 23,
  "96737": 12,
  "96738": 12,
  "96739": 12,
  "96740": 12,
  "96741": 18,
  "96742": 17,
  "96743": 12,
  "96744": 23,
  "96745": 12,
  "96746": 15,
  "96747": 15,
  "96748": 17,
  "96749": 12,
  "96750": 12,
  "96751": 15,
  "96752": 15,
  "96753": 18,
  "96754": 15,
  "96755": 12,
  "96756": 18,
  "96757": 17,
  "96759": 20,
  "96760": 12,
  "96761": 20,
  "96762": 23,
  "96763": 17,
  "96764": 12,
  "96765": 18,
  "96766": 15,
  "96767": 20,
  "96768": 20,
  "96769": 26,
  "96770": 18,
  "96771": 12,
  "96772": 12,
  "96773": 12,
  "96774": 12,
  "96776": 12,
  "96777": 12,
  "96778": 12,
  "96779": 18,
  "96780": 12,
  "96781": 15,
  "96782": 23,
  "96783": 12,
  "96784": 22,
  "96785": 12,
  "96786": 21,
  "96788": 20,
  "96789": 23,
  "96790": 22,
  "96791": 21,
  "96792": 20,
  "96793": 18,
  "96795": 21,
  "96796": 26,
  "96797": 21,
  "96801": 23,
  "96802": 21,
  "96803": 21,
  "96804": 21,
  "96805": 21,
  "96806": 21,
  "96807": 21,
  "96808": 21,
  "96809": 21,
  "96810": 21,
  "96811": 23,
  "96812": 21,
  "96813": 21,
  "96814": 21,
  "96815": 21,
  "96816": 25,
  "96817": 23,
  "96818": 21,
  "96819": 23,
  "96820": 23,
  "96821": 32,
  "96822": 23,
  "96823": 21,
  "96824": 32,
  "96825": 23,
  "96826": 21,
  "96827": 21,
  "96828": 21,
  "96830": 21,
  "96836": 21,
  "96837": 21,
  "96838": 23,
  "96839": 23,
  "96850": 21,
  "96853": 21,
  "96854": 21,
  "96857": 21,
  "96858": 23,
  "96859": 23,
  "96860": 21,
  "96861": 23,
  "96863": 23,
  "96898": 21,
  "97001": -9,
  "97002": 6,
  "97004": 7,
  "97005": 10,
  "97006": 10,
  "97007": 10,
  "97008": 10,
  "97009": 7,
  "97010": 18,
  "97011": 6,
  "97013": 6,
  "97014": -5,
  "97015": 6,
  "97016": -2,
  "97017": 7,
  "97018": -1,
  "97019": 18,
  "97020": 6,
  "97021": 0,
  "97022": 7,
  "97023": 6,
  "97024": 18,
  "97026": 2,
  "97027": 6,
  "97028": -2,
  "97029": 23,
  "97030": 18,
  "97031": -4,
  "97032": 1,
  "97033": 23,
  "97034": 29,
  "97035": 19,
  "97036": 29,
  "97037": 0,
  "97038": 6,
  "97039": 23,
  "97040": -4,
  "97041": -4,
  "97042": 7,
  "97044": -4,
  "97045": 6,
  "97048": -1,
  "97049": -4,
  "97050": 23,
  "97051": -1,
  "97053": -1,
  "97054": -1,
  "97055": 6,
  "97056": -1,
  "97057": -9,
  "97058": 0,
  "97060": 18,
  "97062": 11,
  "97063": 0,
  "97064": -1,
  "97065": 23,
  "97067": -4,
  "97068": 8,
  "97070": 7,
  "97071": 1,
  "97075": 10,
  "97076": 10,
  "97080": 18,
  "97086": 6,
  "97089": 7,
  "97101": -1,
  "97102": 6,
  "97103": -3,
  "97106": 11,
  "97107": -5,
  "97108": -4,
  "97109": 11,
  "97110": 6,
  "97111": -1,
  "97112": -3,
  "97113": 10,
  "97114": -1,
  "97115": -1,
  "97116": 10,
  "97117": 11,
  "97118": -5,
  "97119": 11,
  "97121": -2,
  "97122": -5,
  "97123": 10,
  "97124": 10,
  "97125": 11,
  "97127": -1,
  "97128": -1,
  "97130": -4,
  "97131": -4,
  "97132": 10,
  "97133": 12,
  "97134": 6,
  "97135": -3,
  "97136": -4,
  "97137": -1,
  "97138": -2,
  "97140": 11,
  "97141": -5,
  "97143": 6,
  "97144": -1,
  "97145": 9,
  "97146": -3,
  "97147": -4,
  "97148": 8,
  "97149": 1,
  "97201": 29,
  "97202": 18,
  "97203": 18,
  "97204": 20,
  "97205": 19,
  "97206": 18,
  "97207": 19,
  "97208": 18,
  "97209": 19,
  "97210": 29,
  "97211": 18,
  "97212": 19,
  "97213": 18,
  "97214": 18,
  "97215": 18,
  "97216": 18,
  "97217": 18,
  "97218": 18,
  "97219": 19,
  "97220": 18,
  "97221": 20,
  "97222": 18,
  "97223": 10,
  "97224": 10,
  "97225": 11,
  "97227": 18,
  "97228": 19,
  "97229": 12,
  "97230": 18,
  "97231": 19,
  "97232": 19,
  "97233": 18,
  "97236": 18,
  "97238": 18,
  "97239": 29,
  "97240": 18,
  "97242": 18,
  "97258": 20,
  "97266": 18,
  "97267": 18,
  "97268": 18,
  "97269": 18,
  "97280": 19,
  "97281": 10,
  "97282": 18,
  "97283": 19,
  "97286": 18,
  "97290": 18,
  "97291": 29,
  "97292": 18,
  "97293": 18,
  "97294": 18,
  "97296": 12,
  "97298": 11,
  "97299": 19,
  "97301": 1,
  "97302": 2,
  "97303": 1,
  "97304": 2,
  "97305": 1,
  "97306": 2,
  "97307": 1,
  "97308": 1,
  "97309": 1,
  "97317": 1,
  "97321": -1,
  "97322": -1,
  "97324": -1,
  "97325": 1,
  "97326": 0,
  "97327": 0,
  "97329": 0,
  "97330": 0,
  "97331": -1,
  "97333": -1,
  "97335": 0,
  "97336": 0,
  "97338": -4,
  "97339": -1,
  "97341": -7,
  "97342": 0,
  "97343": -7,
  "97344": -5,
  "97345": 0,
  "97346": 0,
  "97347": -4,
  "97348": -1,
  "97350": 0,
  "97351": -5,
  "97352": 2,
  "97355": 0,
  "97357": -7,
  "97358": 2,
  "97360": 0,
  "97361": -4,
  "97362": 1,
  "97364": -7,
  "97365": -7,
  "97366": -7,
  "97367": -7,
  "97368": -8,
  "97369": -7,
  "97370": -1,
  "97371": -4,
  "97373": 1,
  "97374": 0,
  "97375": 2,
  "97376": -7,
  "97377": 8,
  "97378": -4,
  "97380": -7,
  "97381": 2,
  "97383": 2,
  "97384": 2,
  "97385": 2,
  "97386": 0,
  "97388": -7,
  "97389": -1,
  "97390": 1,
  "97391": -7,
  "97392": 2,
  "97394": -7,
  "97396": -1,
  "97401": -1,
  "97402": -1,
  "97403": 0,
  "97404": -1,
  "97405": -1,
  "97406": 0,
  "97407": -2,
  "97408": -1,
  "97409": -1,
  "97410": -8,
  "97411": -2,
  "97412": -1,
  "97413": 0,
  "97414": -3,
  "97415": -8,
  "97416": -4,
  "97417": -5,
  "97419": 7,
  "97420": -3,
  "97423": -2,
  "97424": -2,
  "97425": 1,
  "97426": -2,
  "97427": -2,
  "97429": -5,
  "97430": -1,
  "97431": -2,
  "97432": -5,
  "97434": -2,
  "97435": -1,
  "97436": -4,
  "97437": 0,
  "97438": -2,
  "97439": -7,
  "97440": -1,
  "97441": -3,
  "97442": -8,
  "97443": -5,
  "97444": -8,
  "97446": -1,
  "97447": -5,
  "97448": -1,
  "97449": -3,
  "97450": -1,
  "97451": -1,
  "97452": -2,
  "97453": -1,
  "97454": -2,
  "97455": -2,
  "97456": -1,
  "97457": -5,
  "97458": -2,
  "97459": -2,
  "97461": 7,
  "97462": -4,
  "97463": -2,
  "97464": -8,
  "97465": -9,
  "97466": -3,
  "97467": -3,
  "97469": -5,
  "97470": -4,
  "97471": -4,
  "97473": -2,
  "97476": -9,
  "97477": -2,
  "97478": -2,
  "97479": -5,
  "97480": -1,
  "97481": -5,
  "97482": -2,
  "97484": -1,
  "97486": -4,
  "97487": -1,
  "97488": 0,
  "97489": -2,
  "97490": -1,
  "97491": -8,
  "97492": -2,
  "97493": -2,
  "97494": -4,
  "97495": -4,
  "97496": -5,
  "97497": -8,
  "97498": -7,
  "97499": -5,
  "97501": -1,
  "97502": 0,
  "97503": -1,
  "97504": 1,
  "97520": 9,
  "97522": -1,
  "97523": -8,
  "97524": 0,
  "97525": 0,
  "97526": -8,
  "97527": -8,
  "97528": -8,
  "97530": 8,
  "97531": -8,
  "97532": -8,
  "97533": -8,
  "97534": -8,
  "97535": -1,
  "97536": -1,
  "97537": -8,
  "97538": -8,
  "97539": 0,
  "97540": 0,
  "97541": 0,
  "97543": -8,
  "97544": -8,
  "97601": -5,
  "97602": -5,
  "97603": -5,
  "97604": -5,
  "97620": -10,
  "97621": -5,
  "97622": -5,
  "97623": -5,
  "97624": -5,
  "97625": -5,
  "97626": -5,
  "97627": -5,
  "97630": -11,
  "97632": -5,
  "97633": -5,
  "97634": -5,
  "97635": -11,
  "97636": -11,
  "97637": -10,
  "97638": -11,
  "97639": -5,
  "97640": -10,
  "97641": -11,
  "97701": 1,
  "97702": 1,
  "97707": 1,
  "97708": 1,
  "97709": 1,
  "97710": -12,
  "97711": -9,
  "97712": 9,
  "97720": -15,
  "97721": -8,
  "97722": -8,
  "97730": -1,
  "97731": -6,
  "97732": -16,
  "97733": 0,
  "97734": -10,
  "97735": -11,
  "97736": -4,
  "97737": 0,
  "97738": -15,
  "97739": 0,
  "97741": -9,
  "97750": 9,
  "97751": 9,
  "97752": 20,
  "97753": 1,
  "97754": 9,
  "97756": 1,
  "97758": 8,
  "97759": -9,
  "97760": -9,
  "97761": -9,
  "97801": -4,
  "97810": -5,
  "97812": 24,
  "97813": -5,
  "97814": -15,
  "97817": -15,
  "97818": 19,
  "97819": -15,
  "97820": -15,
  "97823": 19,
  "97824": 0,
  "97825": -14,
  "97826": -5,
  "97827": -8,
  "97828": -10,
  "97830": 19,
  "97833": -14,
  "97834": -14,
  "97835": -4,
  "97836": 19,
  "97837": -14,
  "97838": -4,
  "97839": 19,
  "97840": -14,
  "97841": -8,
  "97842": -3,
  "97843": 19,
  "97844": 8,
  "97845": -15,
  "97846": -10,
  "97848": -15,
  "97850": -7,
  "97856": -15,
  "97857": -11,
  "97859": -5,
  "97861": 24,
  "97862": -8,
  "97864": -14,
  "97865": -15,
  "97867": -8,
  "97868": -5,
  "97869": -15,
  "97870": -15,
  "97873": -15,
  "97874": -14,
  "97875": -5,
  "97876": 0,
  "97877": -14,
  "97880": -5,
  "97882": 8,
  "97883": -8,
  "97884": -14,
  "97885": -12,
  "97886": -5,
  "97901": -16,
  "97902": -16,
  "97903": -15,
  "97904": -15,
  "97905": -15,
  "97906": -16,
  "97907": -8,
  "97908": -14,
  "97909": -15,
  "97910": -16,
  "97911": -16,
  "97913": -7,
  "97914": -7,
  "97917": -16,
  "97918": -7,
  "97920": -5,
  "98001": 6,
  "98002": 7,
  "98003": 6,
  "98004": 18,
  "98005": 18,
  "98006": 18,
  "98007": 15,
  "98008": 15,
  "98009": 18,
  "98010": 15,
  "98011": 15,
  "98012": 4,
  "98013": 26,
  "98014": 15,
  "98015": 18,
  "98019": 15,
  "98020": 7,
  "98021": 4,
  "98022": 6,
  "98023": 6,
  "98024": 15,
  "98025": 15,
  "98026": 4,
  "98027": 18,
  "98028": 18,
  "98029": 18,
  "98030": 15,
  "98031": 15,
  "98032": 15,
  "98033": 18,
  "98034": 15,
  "98035": 15,
  "98036": 4,
  "98037": 4,
  "98038": 15,
  "98039": 26,
  "98040": 26,
  "98041": 15,
  "98042": 15,
  "98043": 4,
  "98045": 15,
  "98046": 4,
  "98047": 6,
  "98050": 15,
  "98051": 15,
  "98052": 15,
  "98053": 18,
  "98054": 6,
  "98055": 15,
  "98056": 15,
  "98057": 15,
  "98058": 15,
  "98059": 15,
  "98061": 10,
  "98062": 15,
  "98063": 6,
  "98064": 15,
  "98065": 15,
  "98068": 1,
  "98070": 26,
  "98071": 7,
  "98072": 7,
  "98073": 15,
  "98074": 18,
  "98075": 18,
  "98077": 7,
  "98082": 4,
  "98083": 18,
  "98087": 4,
  "98089": 15,
  "98092": 7,
  "98093": 6,
  "98101": 18,
  "98102": 18,
  "98103": 18,
  "98104": 26,
  "98105": 19,
  "98106": 15,
  "98107": 18,
  "98108": 15,
  "98109": 18,
  "98110": 10,
  "98111": 18,
  "98112": 26,
  "98113": 18,
  "98114": 15,
  "98115": 18,
  "98116": 18,
  "98117": 18,
  "98118": 15,
  "98119": 19,
  "98121": 18,
  "98122": 18,
  "98124": 15,
  "98125": 15,
  "98126": 15,
  "98127": 26,
  "98131": 15,
  "98132": 15,
  "98133": 15,
  "98134": 15,
  "98136": 18,
  "98138": 15,
  "98139": 4,
  "98141": 18,
  "98144": 15,
  "98145": 19,
  "98146": 15,
  "98148": 15,
  "98154": 18,
  "98155": 15,
  "98158": 15,
  "98160": 3,
  "98161": 18,
  "98164": 18,
  "98165": 15,
  "98166": 15,
  "98168": 15,
  "98171": 26,
  "98174": 26,
  "98175": 15,
  "98177": 3,
  "98178": 15,
  "98188": 15,
  "98194": 26,
  "98198": 15,
  "98199": 4,
  "98201": 4,
  "98203": 4,
  "98204": 4,
  "98205": 4,
  "98206": 4,
  "98208": 4,
  "98213": 4,
  "98220": 7,
  "98221": -9,
  "98222": 2,
  "98223": 4,
  "98224": 4,
  "98225": 7,
  "98226": 7,
  "98227": 7,
  "98228": 7,
  "98229": 7,
  "98230": 7,
  "98231": 7,
  "98232": 7,
  "98233": 7,
  "98235": 7,
  "98236": 4,
  "98237": 7,
  "98238": 8,
  "98239": -6,
  "98240": 7,
  "98241": 4,
  "98243": 2,
  "98244": 7,
  "98245": -9,
  "98247": 7,
  "98248": 7,
  "98249": -6,
  "98250": -6,
  "98251": 4,
  "98252": 4,
  "98253": -5,
  "98255": 7,
  "98256": 4,
  "98257": 7,
  "98258": 4,
  "98259": -6,
  "98260": -5,
  "98261": -9,
  "98262": 7,
  "98263": 7,
  "98264": 7,
  "98266": 7,
  "98267": 7,
  "98270": 4,
  "98271": 4,
  "98272": 4,
  "98273": 7,
  "98274": 7,
  "98275": 5,
  "98276": 7,
  "98277": -6,
  "98279": -6,
  "98280": 2,
  "98281": -9,
  "98282": -5,
  "98283": 7,
  "98284": 7,
  "98286": 2,
  "98287": -6,
  "98288": 15,
  "98290": 4,
  "98291": 4,
  "98292": -6,
  "98293": 4,
  "98294": 4,
  "98295": 7,
  "98296": 5,
  "98297": -9,
  "98303": 6,
  "98304": -4,
  "98305": -7,
  "98310": -1,
  "98311": -1,
  "98312": -1,
  "98315": 10,
  "98320": -1,
  "98321": 6,
  "98322": -1,
  "98323": 6,
  "98324": -8,
  "98325": -6,
  "98326": -7,
  "98327": 15,
  "98328": 6,
  "98329": -1,
  "98330": -4,
  "98331": -7,
  "98332": 6,
  "98333": 16,
  "98335": 7,
  "98336": -4,
  "98337": -1,
  "98338": 6,
  "98339": -6,
  "98340": -6,
  "98342": 0,
  "98343": -8,
  "98344": 6,
  "98345": 10,
  "98346": 0,
  "98348": 6,
  "98349": -12,
  "98350": -7,
  "98351": -12,
  "98353": 0,
  "98354": 6,
  "98355": -4,
  "98356": -4,
  "98357": -7,
  "98358": 3,
  "98359": -1,
  "98360": 6,
  "98361": 2,
  "98362": -8,
  "98363": -8,
  "98364": 10,
  "98365": -5,
  "98366": -1,
  "98367": -1,
  "98368": -6,
  "98370": 0,
  "98371": 6,
  "98372": 6,
  "98373": 6,
  "98374": 6,
  "98375": 6,
  "98376": -8,
  "98377": -5,
  "98378": -1,
  "98380": -1,
  "98381": -6,
  "98382": -8,
  "98383": 0,
  "98384": 0,
  "98385": 6,
  "98386": 0,
  "98387": 6,
  "98388": 6,
  "98390": 6,
  "98391": 6,
  "98392": -1,
  "98393": -1,
  "98394": -12,
  "98395": -1,
  "98396": 6,
  "98397": -4,
  "98398": -4,
  "98401": 6,
  "98402": 6,
  "98403": 14,
  "98404": 5,
  "98405": 5,
  "98406": 6,
  "98407": 6,
  "98408": 5,
  "98409": 5,
  "98411": 5,
  "98412": 6,
  "98413": 5,
  "98415": 6,
  "98417": 5,
  "98418": 5,
  "98419": 5,
  "98421": 5,
  "98422": 6,
  "98424": 6,
  "98433": 5,
  "98438": 6,
  "98439": 5,
  "98442": 6,
  "98443": 6,
  "98444": 6,
  "98445": 6,
  "98446": 6,
  "98448": 6,
  "98464": 6,
  "98465": 6,
  "98466": 6,
  "98467": 6,
  "98490": 6,
  "98492": 5,
  "98496": 6,
  "98497": 6,
  "98498": 6,
  "98499": 6,
  "98501": 8,
  "98502": 15,
  "98503": 7,
  "98506": 7,
  "98507": 8,
  "98508": 8,
  "98509": 7,
  "98511": 8,
  "98512": 7,
  "98513": 7,
  "98516": 8,
  "98520": 1,
  "98522": -11,
  "98524": -12,
  "98526": 1,
  "98527": -11,
  "98528": -12,
  "98530": 6,
  "98531": -4,
  "98532": -4,
  "98533": -4,
  "98535": 1,
  "98536": 1,
  "98537": 1,
  "98538": -4,
  "98539": -11,
  "98540": 7,
  "98541": 1,
  "98542": -4,
  "98544": -4,
  "98546": -3,
  "98547": -11,
  "98548": -12,
  "98550": 1,
  "98552": 1,
  "98554": -11,
  "98555": -12,
  "98556": 7,
  "98557": -12,
  "98558": 7,
  "98559": 1,
  "98560": -12,
  "98561": -11,
  "98562": 1,
  "98563": 1,
  "98564": -4,
  "98565": -5,
  "98566": 1,
  "98568": 7,
  "98569": 1,
  "98570": -4,
  "98571": 1,
  "98572": -11,
  "98575": 1,
  "98576": 7,
  "98577": -11,
  "98579": 7,
  "98580": 6,
  "98581": 8,
  "98582": -4,
  "98583": 1,
  "98584": -12,
  "98585": -4,
  "98586": -11,
  "98587": 1,
  "98588": -12,
  "98589": 7,
  "98590": -11,
  "98591": -4,
  "98592": -3,
  "98593": 9,
  "98595": 1,
  "98596": -4,
  "98597": 7,
  "98601": 6,
  "98602": -11,
  "98603": 9,
  "98604": 6,
  "98605": 2,
  "98606": 14,
  "98607": 6,
  "98609": 9,
  "98610": 2,
  "98611": 8,
  "98612": 9,
  "98613": -11,
  "98614": -11,
  "98616": 2,
  "98617": -11,
  "98619": -11,
  "98620": -11,
  "98621": -11,
  "98622": 6,
  "98623": 3,
  "98624": -11,
  "98625": 9,
  "98626": 8,
  "98628": -11,
  "98629": 6,
  "98631": -11,
  "98632": 8,
  "98635": -11,
  "98637": -11,
  "98638": -11,
  "98639": 2,
  "98640": -2,
  "98641": -2,
  "98642": 7,
  "98643": -11,
  "98644": -11,
  "98645": 9,
  "98647": -11,
  "98648": 2,
  "98649": 9,
  "98650": 3,
  "98651": 3,
  "98660": 5,
  "98661": 5,
  "98662": 6,
  "98663": 5,
  "98664": 6,
  "98665": 6,
  "98666": 6,
  "98668": 6,
  "98670": -11,
  "98671": 6,
  "98672": 3,
  "98673": -12,
  "98674": 9,
  "98675": 6,
  "98682": 6,
  "98683": 6,
  "98684": 6,
  "98685": 6,
  "98686": 6,
  "98687": 6,
  "98801": 7,
  "98802": 7,
  "98807": 7,
  "98811": 7,
  "98812": -15,
  "98813": -9,
  "98814": -14,
  "98815": 8,
  "98816": 0,
  "98817": -8,
  "98819": -14,
  "98821": 6,
  "98822": 7,
  "98823": 5,
  "98824": 5,
  "98826": 15,
  "98827": -14,
  "98828": 7,
  "98829": -15,
  "98830": -8,
  "98831": -7,
  "98832": 5,
  "98833": -14,
  "98834": -7,
  "98836": 7,
  "98837": 6,
  "98840": -15,
  "98841": -15,
  "98843": -8,
  "98844": -17,
  "98845": -8,
  "98846": -15,
  "98847": 15,
  "98848": 5,
  "98849": -15,
  "98850": -8,
  "98851": 5,
  "98852": -14,
  "98853": 5,
  "98855": -15,
  "98856": -14,
  "98857": -13,
  "98858": -8,
  "98859": -17,
  "98860": 5,
  "98862": -14,
  "98901": -8,
  "98902": -8,
  "98903": -8,
  "98904": -8,
  "98907": -8,
  "98908": -8,
  "98909": -8,
  "98920": -8,
  "98921": -8,
  "98922": 1,
  "98923": -8,
  "98925": 1,
  "98926": 0,
  "98929": -8,
  "98930": 9,
  "98932": -8,
  "98933": -8,
  "98934": 0,
  "98935": 9,
  "98936": -8,
  "98937": -8,
  "98938": -8,
  "98939": -8,
  "98940": 0,
  "98941": 0,
  "98942": -8,
  "98943": 0,
  "98944": -8,
  "98946": 0,
  "98947": -8,
  "98948": -8,
  "98950": 13,
  "98951": -8,
  "98952": -8,
  "98953": -8,
  "99001": -2,
  "99003": 0,
  "99004": -2,
  "99005": 7,
  "99006": -2,
  "99008": -5,
  "99009": -2,
  "99011": -2,
  "99012": -2,
  "99013": -2,
  "99014": -2,
  "99016": -2,
  "99017": -6,
  "99018": -6,
  "99019": 7,
  "99020": -2,
  "99021": -2,
  "99022": -2,
  "99023": 7,
  "99025": -2,
  "99026": 7,
  "99027": -2,
  "99029": -2,
  "99030": -2,
  "99031": -2,
  "99032": -5,
  "99033": -6,
  "99034": -2,
  "99036": 7,
  "99037": 7,
  "99039": -6,
  "99040": -5,
  "99101": -13,
  "99102": -6,
  "99103": -5,
  "99104": -6,
  "99105": -14,
  "99107": -13,
  "99109": -13,
  "99110": -2,
  "99111": -6,
  "99113": 1,
  "99114": -13,
  "99115": -8,
  "99116": -5,
  "99117": -5,
  "99118": -17,
  "99119": -15,
  "99121": -17,
  "99122": -5,
  "99123": -5,
  "99124": -5,
  "99125": -6,
  "99126": -13,
  "99128": -6,
  "99129": -5,
  "99130": -6,
  "99131": -13,
  "99133": -5,
  "99134": -5,
  "99135": 4,
  "99136": -6,
  "99137": -13,
  "99138": -17,
  "99139": -15,
  "99140": -18,
  "99141": -13,
  "99143": -6,
  "99144": -5,
  "99146": -17,
  "99147": -5,
  "99148": -13,
  "99149": -6,
  "99150": -18,
  "99151": -13,
  "99152": -15,
  "99153": -15,
  "99154": -5,
  "99155": -15,
  "99156": -15,
  "99157": -13,
  "99158": -6,
  "99159": -5,
  "99160": -18,
  "99161": -6,
  "99163": -4,
  "99166": -17,
  "99167": -13,
  "99169": -14,
  "99170": -6,
  "99171": -6,
  "99173": -13,
  "99174": -6,
  "99176": -6,
  "99179": 1,
  "99180": -15,
  "99181": -13,
  "99185": -5,
  "99201": -2,
  "99202": -2,
  "99203": -2,
  "99204": -2,
  "99205": -2,
  "99206": -2,
  "99207": -2,
  "99208": -2,
  "99209": -2,
  "99210": -2,
  "99211": -2,
  "99212": -2,
  "99213": -2,
  "99214": -2,
  "99215": -2,
  "99216": -2,
  "99217": -2,
  "99218": 0,
  "99219": -2,
  "99220": -2,
  "99223": 7,
  "99224": -2,
  "99228": 7,
  "99301": -5,
  "99302": -5,
  "99320": 9,
  "99321": 6,
  "99322": -11,
  "99323": 9,
  "99324": -8,
  "99326": -5,
  "99328": 27,
  "99329": -8,
  "99330": -5,
  "99333": -14,
  "99335": -14,
  "99336": 9,
  "99337": 9,
  "99338": 9,
  "99341": -14,
  "99343": -4,
  "99344": -13,
  "99345": 9,
  "99346": 9,
  "99347": 27,
  "99348": 27,
  "99349": -8,
  "99350": 9,
  "99352": 17,
  "99353": 17,
  "99354": 17,
  "99356": -11,
  "99357": 5,
  "99359": 27,
  "99360": -8,
  "99361": 27,
  "99362": -8,
  "99363": -8,
  "99371": -14,
  "99401": 1,
  "99402": 1,
  "99403": 1,
  "99501": 21,
  "99502": 21,
  "99503": 21,
  "99504": 21,
  "99505": 21,
  "99506": 21,
  "99507": 21,
  "99508": 21,
  "99509": 21,
  "99510": 21,
  "99511": 22,
  "99513": 21,
  "99514": 21,
  "99515": 22,
  "99516": 29,
  "99517": 21,
  "99518": 21,
  "99519": 21,
  "99520": 21,
  "99521": 21,
  "99522": 21,
  "99523": 21,
  "99524": 21,
  "99529": 21,
  "99530": 21,
  "99540": 22,
  "99545": -7,
  "99546": 18,
  "99547": 18,
  "99548": 13,
  "99549": 13,
  "99550": 13,
  "99551": -7,
  "99552": -7,
  "99553": 18,
  "99554": 10,
  "99555": -7,
  "99556": 4,
  "99557": -7,
  "99558": -8,
  "99559": -7,
  "99561": 1,
  "99563": -7,
  "99564": 13,
  "99565": 13,
  "99566": 27,
  "99567": 22,
  "99568": 4,
  "99569": -7,
  "99571": -7,
  "99572": 12,
  "99573": 27,
  "99574": 20,
  "99575": -7,
  "99576": -7,
  "99577": 22,
  "99578": -8,
  "99579": 13,
  "99580": -7,
  "99581": 10,
  "99583": 27,
  "99585": -7,
  "99586": 17,
  "99587": 29,
  "99588": 27,
  "99589": -8,
  "99590": -8,
  "99591": 18,
  "99599": 21,
  "99602": -8,
  "99603": 4,
  "99604": -7,
  "99605": 21,
  "99606": 4,
  "99607": -7,
  "99608": 21,
  "99609": -7,
  "99610": 4,
  "99611": 4,
  "99612": -7,
  "99613": 13,
  "99614": -8,
  "99615": 14,
  "99619": 14,
  "99620": 10,
  "99621": -7,
  "99622": -8,
  "99624": 13,
  "99625": 5,
  "99626": -7,
  "99627": -5,
  "99628": -7,
  "99629": 20,
  "99630": -7,
  "99631": 21,
  "99632": -7,
  "99633": 13,
  "99634": -7,
  "99635": 4,
  "99636": -7,
  "99637": -7,
  "99638": 18,
  "99639": 4,
  "99640": 4,
  "99641": -8,
  "99643": 13,
  "99644": 13,
  "99645": 20,
  "99647": 4,
  "99648": 13,
  "99649": 13,
  "99650": -8,
  "99651": -7,
  "99652": 20,
  "99653": 15,
  "99654": 20,
  "99655": -8,
  "99656": -7,
  "99657": -7,
  "99658": -7,
  "99659": 10,
  "99660": 18,
  "99661": 13,
  "99662": -8,
  "99663": 4,
  "99664": 4,
  "99665": -7,
  "99666": 10,
  "99667": 28,
  "99668": -7,
  "99669": 4,
  "99670": 13,
  "99671": 10,
  "99672": 4,
  "99674": 20,
  "99675": -5,
  "99676": 20,
  "99677": 27,
  "99678": -7,
  "99679": -8,
  "99680": -8,
  "99681": -7,
  "99682": 20,
  "99683": 29,
  "99684": 10,
  "99685": 20,
  "99686": 27,
  "99687": 20,
  "99688": 29,
  "99689": 12,
  "99690": -7,
  "99691": -5,
  "99692": 27,
  "99693": 20,
  "99694": 20,
  "99695": 21,
  "99697": 13,
  "99701": 28,
  "99702": 28,
  "99703": 28,
  "99704": 5,
  "99705": 28,
  "99706": 28,
  "99707": 28,
  "99708": 28,
  "99709": 28,
  "99710": 28,
  "99711": 28,
  "99712": 28,
  "99714": 28,
  "99716": 28,
  "99720": -5,
  "99721": 58,
  "99722": 28,
  "99723": 58,
  "99724": 28,
  "99725": 28,
  "99726": -5,
  "99727": 18,
  "99729": 5,
  "99730": 28,
  "99731": 17,
  "99732": 17,
  "99733": 28,
  "99734": 58,
  "99736": 17,
  "99737": 17,
  "99738": 17,
  "99739": 10,
  "99740": 28,
  "99741": -5,
  "99742": 10,
  "99743": -5,
  "99744": 5,
  "99745": -5,
  "99746": -5,
  "99747": 58,
  "99748": 10,
  "99749": 18,
  "99750": 18,
  "99751": 18,
  "99752": 18,
  "99753": 10,
  "99754": 17,
  "99755": -5,
  "99756": -5,
  "99757": -5,
  "99758": 28,
  "99759": 18,
  "99760": 5,
  "99761": 18,
  "99762": 10,
  "99763": 18,
  "99764": 17,
  "99765": 10,
  "99766": 18,
  "99767": -5,
  "99768": -5,
  "99769": 10,
  "99770": 18,
  "99771": 10,
  "99772": 10,
  "99773": 18,
  "99774": 27,
  "99775": 28,
  "99776": 17,
  "99777": -5,
  "99778": 10,
  "99780": 17,
  "99781": 28,
  "99782": 58,
  "99783": 10,
  "99784": 10,
  "99785": 10,
  "99786": 18,
  "99788": 28,
  "99789": 58,
  "99790": 28,
  "99791": 58,
  "99801": 24,
  "99802": 24,
  "99803": 24,
  "99811": 24,
  "99820": 16,
  "99821": 24,
  "99824": 24,
  "99825": 15,
  "99826": 15,
  "99827": 12,
  "99829": 15,
  "99830": 16,
  "99832": 15,
  "99833": 17,
  "99835": 24,
  "99836": 17,
  "99840": 12,
  "99841": 15,
  "99850": 24,
  "99901": 3,
  "99903": 3,
  "99918": 3,
  "99919": 3,
  "99921": 3,
  "99922": 3,
  "99923": 2,
  "99925": 2,
  "99926": 3,
  "99927": 16,
  "99928": 3,
  "99929": 3,
  "99950": 3
};

// src/craftsman/costDataset/2025.1/historicalCostIndex.ts
var CRAFTSMAN_2025_HISTORICAL_COST_INDEX = {
  "1959": 13.05,
  "1960": 12.86,
  "1961": 12.62,
  "1962": 12.47,
  "1963": 12.24,
  "1964": 11.82,
  "1965": 11.56,
  "1966": 11.06,
  "1967": 10.52,
  "1968": 9.95,
  "1969": 9.57,
  "1970": 9.11,
  "1971": 7.84,
  "1972": 7.86,
  "1973": 7.26,
  "1974": 6.78,
  "1975": 6.38,
  "1976": 6.14,
  "1977": 5.71,
  "1978": 5.24,
  "1979": 4.8,
  "1980": 4.3,
  "1981": 4.11,
  "1982": 3.97,
  "1983": 3.79,
  "1984": 3.51,
  "1985": 3.4,
  "1986": 3.35,
  "1987": 3.28,
  "1988": 3.25,
  "1989": 3.19,
  "1990": 2.96,
  "1991": 2.81,
  "1992": 2.79,
  "1993": 2.75,
  "1994": 2.65,
  "1995": 2.49,
  "1996": 2.43,
  "1997": 2.38,
  "1998": 2.27,
  "1999": 2.25,
  "2000": 2.18,
  "2001": 2.09,
  "2002": 2.07,
  "2003": 2.05,
  "2004": 2,
  "2005": 1.8,
  "2006": 1.6,
  "2007": 1.49,
  "2008": 1.42,
  "2009": 1.42,
  "2010": 1.41,
  "2011": 1.43,
  "2012": 1.38,
  "2013": 1.32,
  "2014": 1.3,
  "2015": 1.29,
  "2016": 1.3,
  "2017": 1.31,
  "2018": 1.19,
  "2019": 1.14,
  "2020": 1.16,
  "2021": 1.15,
  "2022": 1.06,
  "2023": 0.97,
  "2024": 1.05,
  "2025": 1
};

// src/craftsman/costDataset/2025.1/index.ts
var CRAFTSMAN_COST_DATASET_2025 = {
  version: "2025.1",
  zipMultiplier: CRAFTSMAN_ZIP_MODIFIER_2025,
  costData: {
    singleFamily: {
      sixCorners: {
        variable: [
          400.54,
          390.38,
          380.22,
          370.05,
          359.89,
          349.73,
          328.87,
          308.01,
          287.16,
          266.3,
          245.44,
          232.68,
          219.92,
          207.16,
          194.39,
          181.63,
          177.22,
          172.82,
          168.41,
          164,
          159.59,
          155.14,
          150.68,
          146.22,
          141.76,
          137.3,
          133.71,
          130.12,
          126.52,
          122.93,
          119.34,
          117.09,
          114.85,
          112.6,
          110.36,
          108.11,
          106.09,
          104.07,
          102.05,
          100.03,
          98.01,
          95.59,
          93.16,
          90.74,
          88.31,
          85.88,
          84.45,
          83.02,
          81.58,
          80.15,
          78.72
        ],
        fixed: [
          155435,
          150745,
          146054,
          141363,
          136672,
          131981,
          122810,
          113639,
          104468,
          95297,
          86126,
          80303,
          74480,
          68657,
          62834,
          57011,
          55056,
          53100,
          51144,
          49189,
          47233,
          45586,
          43938,
          42290,
          40643,
          38995,
          37675,
          36355,
          35036,
          33716,
          32396,
          31639,
          30881,
          30124,
          29366,
          28609,
          27953,
          27298,
          26642,
          25987,
          25331,
          24149,
          22966,
          21784,
          20601,
          19419,
          18698,
          17977,
          17256,
          16535,
          15815
        ]
      }
    },
    multiFamily: {
      twoOrThreeUnits: {
        variable: [
          182.23,
          177.92,
          173.61,
          169.3,
          164.99,
          160.68,
          156.82,
          152.96,
          149.1,
          145.23,
          141.37,
          139.09,
          136.8,
          134.52,
          132.23,
          129.95,
          127.84,
          125.73,
          123.62,
          121.51,
          119.4,
          117.67,
          115.94,
          114.2,
          112.47,
          110.74,
          109.14,
          107.54,
          105.95,
          104.35,
          102.75,
          101.28,
          99.81,
          98.34,
          96.87,
          95.41,
          94.04,
          92.67,
          91.3,
          89.93,
          88.56
        ],
        fixed: [
          13146,
          12721,
          12296,
          11870,
          11445,
          11020,
          10691,
          10362,
          10033,
          9704,
          9375,
          9174,
          8974,
          8773,
          8572,
          8372,
          8219,
          8067,
          7914,
          7762,
          7609,
          7343,
          7077,
          6811,
          6545,
          6279,
          6033,
          5788,
          5543,
          5297,
          5052,
          4820,
          4588,
          4355,
          4123,
          3891,
          3688,
          3484,
          3281,
          3077,
          2874
        ]
      },
      fourToNineUnits: {
        variable: [],
        fixed: []
      }
    },
    manufactured: {
      variable: [
        138.76,
        136.83,
        134.9,
        132.97,
        131.04,
        129.11,
        126.25,
        123.39,
        120.53,
        117.67,
        114.81,
        112.38,
        109.96,
        107.53,
        105.11,
        102.68,
        100.12,
        97.57,
        95.01,
        92.46,
        89.9,
        88.43,
        86.96,
        85.49,
        84.02,
        82.54,
        81.09,
        79.64,
        78.19,
        76.74,
        75.28,
        74.11,
        72.93,
        71.76,
        70.59,
        69.41,
        68.36,
        67.32,
        66.27,
        65.22,
        64.18
      ],
      fixed: [
        11984,
        11993,
        12003,
        12013,
        12023,
        12032,
        12495,
        12958,
        13421,
        13884,
        14347,
        14596,
        14845,
        15094,
        15343,
        15592,
        16077,
        16561,
        17045,
        17529,
        18013,
        17938,
        17863,
        17788,
        17714,
        17639,
        17532,
        17424,
        17317,
        17210,
        17103,
        17012,
        16922,
        16832,
        16742,
        16652,
        16464,
        16276,
        16087,
        15899,
        15711
      ]
    },
    bathrooms: {
      fullBaths: [
        18187,
        17940,
        17694,
        17447,
        17200,
        16954,
        16707,
        16460,
        16213,
        15967,
        15720,
        15551,
        15383,
        15214,
        15046,
        14877,
        14708,
        14540,
        14371,
        14203,
        14034,
        13780,
        13527,
        13273,
        13020,
        12766,
        12512,
        12259,
        12005,
        11752,
        11498,
        11333,
        11167,
        11002,
        10836,
        10671,
        10506,
        10340,
        10175,
        10009,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844
      ],
      halfBaths: [
        9846,
        9654,
        9462,
        9269,
        9077,
        8885,
        8693,
        8501,
        8308,
        8116,
        7924,
        7802,
        7680,
        7557,
        7435,
        7313,
        7191,
        7069,
        6946,
        6824,
        6702,
        6590,
        6478,
        6367,
        6255,
        6143,
        6031,
        5919,
        5808,
        5696,
        5584,
        5498,
        5412,
        5327,
        5241,
        5155,
        5069,
        4983,
        4898,
        4812,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726
      ]
    },
    basement: {
      totalArea: {
        variable: [
          54,
          53.36,
          52.72,
          52.08,
          51.44,
          50.8,
          50.16,
          49.52,
          48.88,
          48.24,
          47.6,
          46.96,
          46.32,
          45.68,
          45.04,
          44.4,
          43.76,
          43.12,
          42.48,
          41.84,
          41.2,
          40.56,
          39.92,
          39.28,
          38.64,
          38,
          37.36,
          36.72,
          36.08,
          35.44,
          34.8,
          34.16,
          33.52,
          32.88,
          32.24,
          31.6,
          30.96,
          30.32,
          29.68,
          29.04,
          28.4,
          27.76,
          27.12,
          26.48,
          25.84,
          25.2,
          24.56,
          23.92,
          23.28,
          22.64,
          22
        ]
      },
      finishedArea: {
        variable: [
          121.1,
          117.97,
          114.85,
          111.72,
          108.6,
          105.48,
          99.07,
          92.65,
          86.24,
          79.83,
          73.42,
          69.5,
          65.57,
          61.65,
          57.73,
          53.8,
          52.45,
          51.09,
          49.74,
          48.38,
          47.03,
          45.66,
          44.29,
          42.92,
          41.55,
          40.18,
          39.07,
          37.97,
          36.86,
          35.76,
          34.66,
          33.97,
          33.27,
          32.58,
          31.89,
          31.2,
          30.58,
          29.96,
          29.34,
          28.72,
          28.1,
          27.35,
          26.61,
          25.86,
          25.12,
          24.37,
          23.93,
          23.49,
          23.05,
          22.61,
          22.17
        ]
      }
    },
    attic: {
      variable: [
        131.31,
        127.93,
        124.54,
        121.15,
        117.76,
        114.38,
        107.42,
        100.47,
        93.52,
        86.57,
        79.61,
        75.36,
        71.11,
        66.85,
        62.6,
        58.34,
        56.87,
        55.41,
        53.94,
        52.47,
        51,
        49.51,
        48.03,
        46.54,
        45.05,
        43.57,
        42.37,
        41.17,
        39.97,
        38.78,
        37.58,
        36.83,
        36.08,
        35.33,
        34.59,
        33.84,
        33.16,
        32.49,
        31.82,
        31.14,
        30.47,
        29.66,
        28.85,
        28.05,
        27.24,
        26.43,
        25.95,
        25.47,
        24.99,
        24.52,
        24.04
      ]
    },
    garage: {
      detached: {
        variable: [
          123.15,
          119.91,
          116.68,
          113.45,
          110.21,
          106.98,
          101.69,
          96.4,
          91.11,
          85.82,
          80.53,
          77.45,
          74.37,
          71.29,
          68.22,
          65.14,
          62.94,
          60.75,
          58.55,
          56.35,
          54.16,
          52.98,
          51.8,
          50.63,
          49.45,
          48.27,
          47.12,
          45.98,
          44.83,
          43.68,
          42.54,
          41.93,
          41.32,
          40.72,
          40.11,
          39.5,
          38.58,
          37.65,
          36.73,
          35.81,
          34.88,
          33.98,
          33.08,
          32.18,
          31.28,
          30.38,
          29.7,
          29.01,
          28.32,
          27.64,
          26.95
        ],
        fixed: [
          20847,
          20248,
          19649,
          19050,
          18451,
          17852,
          16929,
          16006,
          15084,
          14161,
          13238,
          12725,
          12211,
          11697,
          11184,
          10670,
          10295,
          9920,
          9546,
          9171,
          8796,
          8589,
          8381,
          8173,
          7965,
          7758,
          7577,
          7395,
          7214,
          7033,
          6852,
          6733,
          6615,
          6496,
          6377,
          6259,
          6252,
          6246,
          6239,
          6233,
          6226,
          6004,
          5782,
          5560,
          5338,
          5116,
          4970,
          4824,
          4678,
          4532,
          4385
        ]
      },
      attached: {
        // TODO: This is the same as detached - Need to get attached garage data from Craftsman
        variable: [
          123.15,
          119.91,
          116.68,
          113.45,
          110.21,
          106.98,
          101.69,
          96.4,
          91.11,
          85.82,
          80.53,
          77.45,
          74.37,
          71.29,
          68.22,
          65.14,
          62.94,
          60.75,
          58.55,
          56.35,
          54.16,
          52.98,
          51.8,
          50.63,
          49.45,
          48.27,
          47.12,
          45.98,
          44.83,
          43.68,
          42.54,
          41.93,
          41.32,
          40.72,
          40.11,
          39.5,
          38.58,
          37.65,
          36.73,
          35.81,
          34.88,
          33.98,
          33.08,
          32.18,
          31.28,
          30.38,
          29.7,
          29.01,
          28.32,
          27.64,
          26.95
        ],
        fixed: [
          20847,
          20248,
          19649,
          19050,
          18451,
          17852,
          16929,
          16006,
          15084,
          14161,
          13238,
          12725,
          12211,
          11697,
          11184,
          10670,
          10295,
          9920,
          9546,
          9171,
          8796,
          8589,
          8381,
          8173,
          7965,
          7758,
          7577,
          7395,
          7214,
          7033,
          6852,
          6733,
          6615,
          6496,
          6377,
          6259,
          6252,
          6246,
          6239,
          6233,
          6226,
          6004,
          5782,
          5560,
          5338,
          5116,
          4970,
          4824,
          4678,
          4532,
          4385
        ]
      }
    },
    carport: {
      variable: [
        60.19,
        58.61,
        57.03,
        55.45,
        53.87,
        52.29,
        49.71,
        47.12,
        44.53,
        41.95,
        39.36,
        37.86,
        36.35,
        34.85,
        33.34,
        31.84,
        30.77,
        29.69,
        28.62,
        27.55,
        26.47,
        25.9,
        25.32,
        24.75,
        24.17,
        23.59,
        23.03,
        22.47,
        21.91,
        21.35,
        20.79,
        20.5,
        20.2,
        19.9,
        19.61,
        19.31,
        18.86,
        18.41,
        17.95,
        17.5,
        17.05,
        16.61,
        16.17,
        15.73,
        15.29,
        14.85,
        14.52,
        14.18,
        13.84,
        13.51,
        13.17
      ]
    },
    heating: 0,
    // Heating was not defined for 2025; we are not actually using it any more.
    heatingAndCooling: 0,
    // Heating and cooling was not defined for 2025; we are not actually using it any more.
    pool: {
      fixed: [37929, 23706, 17779],
      variable240To480: [95.49, 59.68, 44.76],
      variableOver480: [66.84, 41.78, 31.33]
    },
    spa: {
      fixed: [19913, 12446, 9334],
      variableOver70: [50.13, 31.33, 23.5]
    },
    shed: {
      variable: [25.38, 19.88, 13.17],
      fixed: [1283, 1053, 775]
    },
    workshop: {
      variable: [32.4, 26.14, 20.73],
      fixed: [22640, 17136, 13371]
    },
    barn: {
      variable: [35.48, 26.64, 17.77],
      fixed: [36092, 24059, 12127]
    },
    patio: {
      uncovered: {
        variable: [
          40.01,
          39.39,
          38.76,
          38.14,
          37.51,
          36.89,
          36.26,
          35.64,
          35.01,
          34.39,
          33.76,
          33.14,
          32.51,
          31.89,
          31.27,
          30.64,
          30.02,
          29.39,
          28.77,
          28.14,
          27.52,
          26.89,
          26.27,
          25.64,
          25.02,
          24.4,
          23.77,
          23.15,
          22.52,
          21.9,
          21.27,
          20.65,
          20.02,
          19.4,
          18.77,
          18.15,
          17.52,
          16.9,
          16.28,
          15.65,
          15.03,
          14.4,
          13.78,
          13.15,
          12.53,
          11.9,
          11.28,
          10.65,
          10.03,
          9.4,
          8.78
        ]
      },
      covered: {
        variable: [
          60.5,
          59.66,
          58.82,
          57.98,
          57.14,
          56.3,
          55.46,
          54.62,
          53.78,
          52.94,
          52.1,
          51.26,
          50.42,
          49.57,
          48.73,
          47.89,
          47.05,
          46.21,
          45.37,
          44.53,
          43.69,
          42.85,
          42.01,
          41.17,
          40.33,
          39.49,
          38.65,
          37.81,
          36.97,
          36.13,
          35.29,
          34.45,
          33.61,
          32.77,
          31.93,
          31.09,
          30.25,
          29.41,
          28.56,
          27.72,
          26.88,
          26.04,
          25.2,
          24.36,
          23.52,
          22.68,
          21.84,
          21,
          20.16,
          19.32,
          18.48
        ]
      },
      screen: {
        variable: [
          124,
          122.94,
          121.88,
          120.82,
          119.76,
          118.7,
          117.64,
          116.58,
          115.52,
          114.46,
          113.4,
          112.34,
          111.28,
          110.22,
          109.16,
          108.1,
          107.04,
          105.98,
          104.92,
          103.86,
          102.8,
          101.74,
          100.68,
          99.62,
          98.56,
          97.5,
          96.44,
          95.38,
          94.32,
          93.26,
          92.2,
          91.14,
          90.08,
          89.02,
          87.96,
          86.9,
          85.84,
          84.78,
          83.72,
          82.66,
          81.6,
          80.54,
          79.48,
          78.42,
          77.36,
          76.3,
          75.24,
          74.18,
          73.12,
          72.06,
          71
        ]
      }
    },
    // TODO: document this better than just this link: https://docs.google.com/spreadsheets/d/1fcAyR4_DvEej8TOOs9XFybuEFRSmNhNQbzfuq36Ys8g
    deck: {
      uncovered: {
        variable: [
          46.4,
          46,
          45.61,
          45.21,
          44.81,
          44.42,
          44.02,
          43.62,
          43.23,
          42.83,
          42.43,
          42.04,
          41.64,
          41.24,
          40.85,
          40.45,
          40.05,
          39.66,
          39.26,
          38.86,
          38.47,
          38.07,
          37.67,
          37.28,
          36.88,
          36.49,
          36.09,
          35.69,
          35.3,
          34.9,
          34.5,
          34.11,
          33.71,
          33.31,
          32.92,
          32.52,
          32.12,
          31.73,
          31.33,
          30.93,
          30.54,
          30.14,
          29.74,
          29.35,
          28.95,
          28.55,
          28.16,
          27.76,
          27.36,
          26.97,
          26.57
        ]
      },
      covered: {
        variable: [
          66.89,
          66.28,
          65.67,
          65.05,
          64.44,
          63.83,
          63.22,
          62.6,
          61.99,
          61.38,
          60.77,
          60.15,
          59.54,
          58.93,
          58.32,
          57.7,
          57.09,
          56.48,
          55.87,
          55.25,
          54.64,
          54.03,
          53.42,
          52.8,
          52.19,
          51.58,
          50.97,
          50.36,
          49.74,
          49.13,
          48.52,
          47.91,
          47.29,
          46.68,
          46.07,
          45.46,
          44.84,
          44.23,
          43.62,
          43.01,
          42.39,
          41.78,
          41.17,
          40.56,
          39.94,
          39.33,
          38.72,
          38.11,
          37.49,
          36.88,
          36.27
        ]
      },
      screen: {
        variable: [
          124,
          122.94,
          121.88,
          120.82,
          119.76,
          118.7,
          117.64,
          116.58,
          115.52,
          114.46,
          113.4,
          112.34,
          111.28,
          110.22,
          109.16,
          108.1,
          107.04,
          105.98,
          104.92,
          103.86,
          102.8,
          101.74,
          100.68,
          99.62,
          98.56,
          97.5,
          96.44,
          95.38,
          94.32,
          93.26,
          92.2,
          91.14,
          90.08,
          89.02,
          87.96,
          86.9,
          85.84,
          84.78,
          83.72,
          82.66,
          81.6,
          80.54,
          79.48,
          78.42,
          77.36,
          76.3,
          75.24,
          74.18,
          73.12,
          72.06,
          71
        ]
      }
    },
    porch: {
      uncovered: {
        variable: [
          46.4,
          46,
          45.61,
          45.21,
          44.81,
          44.42,
          44.02,
          43.62,
          43.23,
          42.83,
          42.43,
          42.04,
          41.64,
          41.24,
          40.85,
          40.45,
          40.05,
          39.66,
          39.26,
          38.86,
          38.47,
          38.07,
          37.67,
          37.28,
          36.88,
          36.49,
          36.09,
          35.69,
          35.3,
          34.9,
          34.5,
          34.11,
          33.71,
          33.31,
          32.92,
          32.52,
          32.12,
          31.73,
          31.33,
          30.93,
          30.54,
          30.14,
          29.74,
          29.35,
          28.95,
          28.55,
          28.16,
          27.76,
          27.36,
          26.97,
          26.57
        ]
      },
      covered: {
        variable: [
          66.89,
          66.28,
          65.67,
          65.05,
          64.44,
          63.83,
          63.22,
          62.6,
          61.99,
          61.38,
          60.77,
          60.15,
          59.54,
          58.93,
          58.32,
          57.7,
          57.09,
          56.48,
          55.87,
          55.25,
          54.64,
          54.03,
          53.42,
          52.8,
          52.19,
          51.58,
          50.97,
          50.36,
          49.74,
          49.13,
          48.52,
          47.91,
          47.29,
          46.68,
          46.07,
          45.46,
          44.84,
          44.23,
          43.62,
          43.01,
          42.39,
          41.78,
          41.17,
          40.56,
          39.94,
          39.33,
          38.72,
          38.11,
          37.49,
          36.88,
          36.27
        ]
      },
      screen: {
        variable: [
          124,
          122.94,
          121.88,
          120.82,
          119.76,
          118.7,
          117.64,
          116.58,
          115.52,
          114.46,
          113.4,
          112.34,
          111.28,
          110.22,
          109.16,
          108.1,
          107.04,
          105.98,
          104.92,
          103.86,
          102.8,
          101.74,
          100.68,
          99.62,
          98.56,
          97.5,
          96.44,
          95.38,
          94.32,
          93.26,
          92.2,
          91.14,
          90.08,
          89.02,
          87.96,
          86.9,
          85.84,
          84.78,
          83.72,
          82.66,
          81.6,
          80.54,
          79.48,
          78.42,
          77.36,
          76.3,
          75.24,
          74.18,
          73.12,
          72.06,
          71
        ]
      }
    },
    fireplace: {
      freestanding: 2498,
      zeroClearance: 3320,
      masonry: 12815
    },
    manufacturedBaths: {
      fullBaths: [3375],
      halfBaths: [1795]
    },
    foundation: {
      slab: {
        variable: 16.5
      }
    }
  },
  historicalIndex: CRAFTSMAN_2025_HISTORICAL_COST_INDEX
};

// src/craftsman/costDataset/2026.1/areaModifiers.ts
var CRAFTSMAN_ZIP_MODIFIER_2026 = {
  "01001": 7.76,
  "01002": 11.4,
  "01003": 11.4,
  "01004": 11.4,
  "01005": 11.56,
  "01007": 2.36,
  "01008": 8.8,
  "01009": 7.76,
  "01010": 8.28,
  "01011": 1.9,
  "01012": 2.91,
  "01013": 8.28,
  "01014": 8.28,
  "01020": 8.28,
  "01021": 8.28,
  "01022": 8.28,
  "01026": 2.45,
  "01027": 2.91,
  "01028": 8.28,
  "01029": 1.9,
  "01030": 8.8,
  "01031": 11.56,
  "01032": 2.91,
  "01033": 2.36,
  "01034": 8.8,
  "01035": 4.5,
  "01036": 8.28,
  "01037": 11.56,
  "01038": 11.4,
  "01039": 2.91,
  "01040": 8.28,
  "01041": 8.28,
  "01050": 2.91,
  "01053": 2.91,
  "01054": 4.96,
  "01056": 8.28,
  "01057": 8.28,
  "01059": 11.4,
  "01060": 2.91,
  "01061": 2.91,
  "01062": 2.91,
  "01066": 2.91,
  "01068": 11.56,
  "01069": 7.76,
  "01070": 1.38,
  "01071": 8.8,
  "01072": -3.53,
  "01073": 3.43,
  "01074": 11.56,
  "01075": 1.84,
  "01077": 8.8,
  "01079": 7.76,
  "01080": 7.76,
  "01081": 7.76,
  "01082": 7.76,
  "01083": 7.76,
  "01084": 2.91,
  "01085": 8.8,
  "01086": 8.8,
  "01088": 2.91,
  "01089": 7.76,
  "01090": 7.76,
  "01092": 7.76,
  "01093": -3.53,
  "01094": 11.56,
  "01095": 9.35,
  "01096": 2.91,
  "01097": 8.8,
  "01098": 2.91,
  "01101": 7.76,
  "01102": 7.76,
  "01103": 7.76,
  "01104": 7.76,
  "01105": 7.76,
  "01106": 16.77,
  "01107": 7.76,
  "01108": 7.76,
  "01109": 7.76,
  "01115": 7.76,
  "01116": 8.28,
  "01118": 7.76,
  "01119": 7.76,
  "01128": 7.76,
  "01129": 7.76,
  "01138": 7.76,
  "01139": 7.76,
  "01144": 7.76,
  "01151": 7.76,
  "01152": 7.76,
  "01201": 1.38,
  "01202": 1.38,
  "01203": 1.38,
  "01220": 0.86,
  "01222": 1.38,
  "01223": 1.38,
  "01224": 1.38,
  "01225": 1.38,
  "01226": 1.38,
  "01227": 1.38,
  "01229": 1.38,
  "01230": 1.38,
  "01235": 1.38,
  "01236": 1.38,
  "01237": 1.38,
  "01238": 1.38,
  "01240": 1.38,
  "01242": 1.38,
  "01243": 1.38,
  "01244": 2.45,
  "01245": 9.87,
  "01247": 0.86,
  "01252": 1.38,
  "01253": 1.9,
  "01254": 2.97,
  "01255": 1.9,
  "01256": 1.38,
  "01257": 1.38,
  "01258": 9.87,
  "01259": 1.38,
  "01260": 9.87,
  "01262": 9.87,
  "01264": 9.87,
  "01266": 2.97,
  "01267": 1.38,
  "01270": 1.38,
  "01301": -3.53,
  "01302": -3.53,
  "01330": -3.53,
  "01331": -4.6,
  "01337": -3.53,
  "01338": -3.53,
  "01339": -4.6,
  "01340": -3.53,
  "01341": -1.94,
  "01342": -3.53,
  "01343": 1.38,
  "01344": -4.08,
  "01346": -3.53,
  "01347": -4.08,
  "01349": -4.08,
  "01350": -5.12,
  "01351": -3.53,
  "01354": -3.53,
  "01355": -3.53,
  "01360": -3.53,
  "01364": -4.6,
  "01366": -2.49,
  "01367": -4.6,
  "01368": -4.08,
  "01370": -3.53,
  "01373": -3.53,
  "01375": 2.91,
  "01376": -4.08,
  "01378": -4.08,
  "01379": -4.08,
  "01380": -4.08,
  "01420": 11.56,
  "01430": 11.56,
  "01431": 11.56,
  "01432": 18,
  "01434": 18,
  "01436": 11.56,
  "01438": 11.04,
  "01440": 11.04,
  "01450": 29.34,
  "01451": 20.85,
  "01452": 11.56,
  "01453": 11.56,
  "01460": 18.55,
  "01462": 20.05,
  "01463": 13.03,
  "01464": 11.56,
  "01467": 22.9,
  "01468": 11.56,
  "01469": 20.05,
  "01472": 11.56,
  "01473": 11.56,
  "01474": 20.05,
  "01475": 11.56,
  "01477": 11.56,
  "01501": 11.56,
  "01503": 20.05,
  "01504": 4.66,
  "01505": 12.11,
  "01506": 11.56,
  "01507": 11.56,
  "01508": 11.56,
  "01509": 11.56,
  "01510": 11.56,
  "01515": 11.56,
  "01516": 11.56,
  "01517": 12.11,
  "01518": 11.56,
  "01519": 12.11,
  "01520": 11.56,
  "01521": 7.76,
  "01522": 11.56,
  "01523": 11.56,
  "01524": 11.56,
  "01525": 11.56,
  "01526": 11.56,
  "01527": 11.56,
  "01529": 4.66,
  "01531": 11.56,
  "01532": 13.15,
  "01534": 11.56,
  "01535": 11.56,
  "01536": 11.56,
  "01537": 11.56,
  "01538": 4.66,
  "01540": 11.56,
  "01541": 12.11,
  "01542": 11.56,
  "01543": 11.56,
  "01545": 12.11,
  "01550": 11.56,
  "01560": 11.56,
  "01561": 11.56,
  "01562": 11.56,
  "01564": 12.11,
  "01566": 11.56,
  "01568": 20.05,
  "01569": 4.66,
  "01570": 11.56,
  "01571": 11.56,
  "01581": 20.05,
  "01583": 11.56,
  "01585": 11.56,
  "01586": 11.56,
  "01588": 11.56,
  "01590": 12.11,
  "01601": 12.11,
  "01602": 11.56,
  "01603": 11.56,
  "01604": 11.56,
  "01605": 11.56,
  "01606": 11.56,
  "01607": 11.56,
  "01608": 11.56,
  "01609": 12.11,
  "01610": 11.56,
  "01611": 11.56,
  "01612": 12.11,
  "01613": 11.56,
  "01614": 11.56,
  "01615": 12.11,
  "01655": 11.56,
  "01701": 18.55,
  "01702": 18.55,
  "01703": 18.55,
  "01704": 18.55,
  "01705": 18.55,
  "01718": 18,
  "01719": 20.85,
  "01720": 21.37,
  "01721": 19.01,
  "01730": 21.37,
  "01731": 21.37,
  "01740": 14.41,
  "01741": 29.34,
  "01742": 21.37,
  "01745": 18.55,
  "01746": 20.05,
  "01747": 4.66,
  "01748": 22.35,
  "01749": 11.56,
  "01752": 12.11,
  "01754": 18.55,
  "01756": 6.25,
  "01757": 18.46,
  "01760": 19.01,
  "01770": 21.83,
  "01772": 22.35,
  "01773": 22.96,
  "01775": 20.85,
  "01776": 21.37,
  "01778": 21.37,
  "01784": 22.35,
  "01801": 19.07,
  "01803": 18.55,
  "01810": 23.27,
  "01821": 18.55,
  "01822": 18.55,
  "01824": 18,
  "01826": 18,
  "01827": 23.82,
  "01830": 12.48,
  "01831": 12.48,
  "01832": 12.48,
  "01833": 12.48,
  "01834": 12.48,
  "01835": 12.48,
  "01840": 12.48,
  "01841": 12.48,
  "01842": 12.48,
  "01843": 12.48,
  "01844": 12.48,
  "01845": 15.33,
  "01850": 18,
  "01851": 18,
  "01852": 18,
  "01853": 18,
  "01854": 18,
  "01860": 12.48,
  "01862": 18.55,
  "01863": 18,
  "01864": 12.48,
  "01865": 18.55,
  "01866": 18.55,
  "01867": 18.55,
  "01876": 18.55,
  "01879": 18.55,
  "01880": 13.03,
  "01885": 15.33,
  "01886": 20.85,
  "01887": 18.55,
  "01888": 19.07,
  "01890": 21.37,
  "01901": 30.42,
  "01902": 30.42,
  "01903": 30.42,
  "01904": 13.03,
  "01905": 30.42,
  "01906": 30.97,
  "01907": 13.03,
  "01908": 33.27,
  "01913": 12.48,
  "01915": 13.03,
  "01921": 23.27,
  "01922": 15.33,
  "01923": 13.03,
  "01929": 13.03,
  "01930": 13.03,
  "01931": 13.03,
  "01936": 15.85,
  "01937": 15.33,
  "01938": 13.03,
  "01940": 15.33,
  "01944": 24.34,
  "01945": 16.92,
  "01949": 15.33,
  "01950": 13.03,
  "01951": 13.55,
  "01952": 12.11,
  "01960": 13.03,
  "01961": 13.03,
  "01965": 13.03,
  "01966": 13.55,
  "01969": 15.33,
  "01970": 13.03,
  "01971": 13.03,
  "01982": 15.85,
  "01983": 16.92,
  "01984": 23.82,
  "01985": 16.37,
  "02018": 19.01,
  "02019": 4.66,
  "02020": 15.33,
  "02021": 19.01,
  "02025": 35.38,
  "02026": 19.53,
  "02027": 19.53,
  "02030": 30.32,
  "02031": 19.01,
  "02032": 19.01,
  "02035": 19.01,
  "02038": 18.46,
  "02040": 19.22,
  "02041": 15.33,
  "02043": 41.76,
  "02045": 35.38,
  "02047": 15.33,
  "02048": 19.01,
  "02050": 15.33,
  "02051": 15.33,
  "02052": 21.83,
  "02053": 20.05,
  "02054": 18.46,
  "02055": 19.22,
  "02056": 26.95,
  "02059": 26.12,
  "02060": 19.53,
  "02061": 26.12,
  "02062": 19.53,
  "02065": 15.33,
  "02066": 19.22,
  "02067": 21.31,
  "02070": 20.05,
  "02071": 27.5,
  "02072": 19.01,
  "02081": 19.01,
  "02090": 21.83,
  "02093": 20.05,
  "02108": 33.79,
  "02109": 31.49,
  "02110": 42.28,
  "02111": 33.79,
  "02112": 42.28,
  "02113": 31.49,
  "02114": 33.79,
  "02115": 33.79,
  "02116": 42.28,
  "02117": 33.79,
  "02118": 33.79,
  "02119": 30.97,
  "02120": 31.49,
  "02121": 30.97,
  "02122": 30.97,
  "02123": 33.79,
  "02124": 30.97,
  "02125": 30.97,
  "02126": 30.97,
  "02127": 31.49,
  "02128": 30.97,
  "02129": 31.49,
  "02130": 31.49,
  "02131": 31.49,
  "02132": 19.53,
  "02133": 42.28,
  "02134": 31.49,
  "02135": 33.79,
  "02136": 19.01,
  "02137": 19.01,
  "02138": 34.31,
  "02139": 33.79,
  "02140": 33.79,
  "02141": 31.49,
  "02142": 31.49,
  "02143": 31.49,
  "02144": 33.79,
  "02145": 31.49,
  "02148": 30.97,
  "02149": 30.97,
  "02150": 30.97,
  "02151": 30.97,
  "02152": 31.49,
  "02153": 31.49,
  "02155": 31.49,
  "02156": 31.49,
  "02163": 34.31,
  "02169": 30.97,
  "02170": 30.97,
  "02171": 30.97,
  "02176": 30.97,
  "02180": 18.55,
  "02184": 19.01,
  "02185": 19.01,
  "02186": 21.83,
  "02187": 21.83,
  "02188": 19.01,
  "02189": 30.42,
  "02190": 19.01,
  "02191": 30.97,
  "02196": 33.79,
  "02199": 42.28,
  "02203": 33.79,
  "02205": 33.79,
  "02210": 33.79,
  "02215": 30.97,
  "02222": 33.79,
  "02228": 42.28,
  "02238": 34.31,
  "02269": 30.97,
  "02283": 33.79,
  "02284": 33.79,
  "02298": 42.28,
  "02301": 18.46,
  "02302": 18.46,
  "02303": 18.46,
  "02304": 18.46,
  "02305": 18.46,
  "02322": 18.46,
  "02324": 15.33,
  "02327": 15.33,
  "02330": 14.78,
  "02331": 26.12,
  "02332": 26.12,
  "02333": 15.33,
  "02334": 19.01,
  "02337": 15.33,
  "02338": 14.78,
  "02339": 15.33,
  "02341": 15.33,
  "02343": 18.46,
  "02345": 15.33,
  "02346": 14.78,
  "02347": 8.34,
  "02350": 14.78,
  "02351": 15.33,
  "02355": 14.78,
  "02356": 19.01,
  "02358": 15.33,
  "02359": 15.33,
  "02360": 15.33,
  "02361": 15.33,
  "02362": 15.33,
  "02364": 15.33,
  "02366": 14.78,
  "02367": 15.33,
  "02368": 18.46,
  "02370": 14.78,
  "02375": 19.01,
  "02379": 15.33,
  "02381": 15.33,
  "02382": 14.78,
  "02420": 21.37,
  "02421": 21.37,
  "02445": 42.28,
  "02446": 33.79,
  "02447": 33.79,
  "02451": 18.55,
  "02452": 20.85,
  "02453": 18.55,
  "02454": 18.55,
  "02455": 42.28,
  "02456": 33.79,
  "02457": 30.32,
  "02458": 33.79,
  "02459": 33.79,
  "02460": 33.79,
  "02461": 33.79,
  "02462": 21.37,
  "02464": 33.27,
  "02465": 21.37,
  "02466": 21.37,
  "02467": 42.28,
  "02468": 35.38,
  "02471": 33.27,
  "02472": 33.27,
  "02474": 21.37,
  "02475": 21.37,
  "02476": 21.37,
  "02478": 33.79,
  "02479": 33.79,
  "02481": 30.32,
  "02482": 21.83,
  "02492": 21.83,
  "02493": 29.86,
  "02494": 21.83,
  "02495": 33.79,
  "02532": 6.13,
  "02534": 6.13,
  "02535": 24.65,
  "02536": 14.41,
  "02537": 6.13,
  "02538": 14.78,
  "02539": 17.23,
  "02540": 14.93,
  "02541": 14.93,
  "02542": 6.13,
  "02543": 16.71,
  "02552": 24.65,
  "02553": 6.13,
  "02554": 28.88,
  "02556": 14.93,
  "02557": 17.23,
  "02558": 14.78,
  "02559": 6.13,
  "02561": 6.13,
  "02562": 6.13,
  "02563": 6.13,
  "02564": 28.88,
  "02565": 14.93,
  "02568": 17.23,
  "02571": 14.78,
  "02573": 17.23,
  "02574": 14.93,
  "02575": 17.75,
  "02576": 14.26,
  "02584": 28.88,
  "02601": 6.13,
  "02630": 6.65,
  "02631": 6.13,
  "02632": 6.13,
  "02633": 6.13,
  "02634": 6.13,
  "02635": 6.13,
  "02636": 16.92,
  "02637": 6.65,
  "02638": 6.13,
  "02639": 6.13,
  "02641": 6.13,
  "02642": 6.13,
  "02643": 8.43,
  "02644": 6.13,
  "02645": 6.13,
  "02646": 6.13,
  "02647": 16.92,
  "02648": 6.13,
  "02649": 6.13,
  "02650": 8.43,
  "02651": 6.13,
  "02652": 6.13,
  "02653": 8.43,
  "02655": 6.13,
  "02657": 8.43,
  "02659": 6.13,
  "02660": 6.13,
  "02661": 8.95,
  "02662": 8.43,
  "02663": 6.13,
  "02664": 6.13,
  "02666": 8.95,
  "02667": 6.13,
  "02668": 6.65,
  "02669": 8.95,
  "02670": 6.13,
  "02671": 6.13,
  "02672": 16.92,
  "02673": 5.58,
  "02675": 6.13,
  "02702": 8.89,
  "02703": 8.89,
  "02712": 8.89,
  "02713": 16.71,
  "02714": 8.34,
  "02715": 8.89,
  "02717": 8.34,
  "02718": 8.89,
  "02719": 8.34,
  "02720": 8.34,
  "02721": 8.34,
  "02722": 8.34,
  "02723": 8.34,
  "02724": 8.34,
  "02725": 8.34,
  "02726": 8.89,
  "02738": 8.34,
  "02739": 8.34,
  "02740": 7.82,
  "02741": 7.82,
  "02742": 7.82,
  "02743": 8.34,
  "02744": 8.34,
  "02745": 8.34,
  "02746": 8.34,
  "02747": 8.34,
  "02748": 8.34,
  "02760": 19.01,
  "02761": 19.01,
  "02762": 19.01,
  "02763": 8.89,
  "02764": 8.89,
  "02766": 8.89,
  "02767": 8.89,
  "02768": 8.89,
  "02769": 16.83,
  "02770": 8.34,
  "02771": 4.66,
  "02777": 8.34,
  "02779": 8.89,
  "02780": 8.34,
  "02790": 8.89,
  "02791": 8.89,
  "02801": 10.02,
  "02802": 4.66,
  "02804": 3.74,
  "02806": 2.36,
  "02807": 7.11,
  "02808": 3.22,
  "02809": 1.53,
  "02812": 3.74,
  "02813": 3.22,
  "02814": 4.66,
  "02815": 2.36,
  "02816": 2.36,
  "02817": 2.36,
  "02818": 3.95,
  "02822": 3.74,
  "02823": 2.36,
  "02824": 4.66,
  "02825": 2.36,
  "02826": 4.66,
  "02827": 2.36,
  "02828": 4.66,
  "02829": 4.66,
  "02830": 4.66,
  "02831": 2.36,
  "02832": 3.74,
  "02833": 3.74,
  "02835": 9.47,
  "02836": 3.74,
  "02837": 10.02,
  "02838": 4.66,
  "02839": 4.14,
  "02840": 0.98,
  "02841": 1.53,
  "02842": 1.53,
  "02852": 2.36,
  "02854": 3.74,
  "02857": 5.73,
  "02858": 4.66,
  "02859": 4.66,
  "02860": 4.14,
  "02861": 4.14,
  "02862": 4.14,
  "02863": 4.14,
  "02864": 4.14,
  "02865": 4.66,
  "02871": 1.53,
  "02872": 1.53,
  "02873": 3.74,
  "02874": 3.74,
  "02875": 3.74,
  "02876": 4.66,
  "02877": 3.74,
  "02878": 1.53,
  "02879": 3.74,
  "02880": 3.74,
  "02881": 5.33,
  "02882": 3.74,
  "02883": 3.74,
  "02885": 8.34,
  "02886": 2.36,
  "02887": 2.36,
  "02888": 1.84,
  "02889": 1.84,
  "02891": 3.22,
  "02892": 3.74,
  "02893": 1.84,
  "02894": 3.22,
  "02895": 4.14,
  "02896": 4.66,
  "02898": 3.74,
  "02901": 4.14,
  "02903": 4.14,
  "02904": 4.14,
  "02905": 4.14,
  "02906": 13.15,
  "02907": 4.14,
  "02908": 4.14,
  "02909": 4.14,
  "02910": 4.14,
  "02911": 4.14,
  "02914": 4.14,
  "02915": 4.14,
  "02916": 4.14,
  "02917": 4.14,
  "02919": 4.66,
  "02920": 2.36,
  "02921": 2.36,
  "02940": 4.14,
  "03031": 13.03,
  "03032": 12.48,
  "03033": 13.03,
  "03034": 11.56,
  "03036": 12.11,
  "03037": 11.56,
  "03038": 11.56,
  "03040": 11.56,
  "03041": 11.56,
  "03042": 12.11,
  "03043": 2.36,
  "03044": 12.11,
  "03045": 12.48,
  "03046": 12.48,
  "03047": 12.48,
  "03048": 11.96,
  "03049": 16.92,
  "03051": 13.03,
  "03052": 13.03,
  "03053": 12.48,
  "03054": 13.03,
  "03055": 12.48,
  "03057": 13.03,
  "03060": 12.48,
  "03061": 12.48,
  "03062": 13.03,
  "03063": 12.48,
  "03064": 13.03,
  "03070": 12.48,
  "03071": 12.48,
  "03073": 11.56,
  "03076": 12.48,
  "03077": 11.56,
  "03079": 11.56,
  "03082": 12.48,
  "03084": 12.48,
  "03086": 13.03,
  "03087": 11.56,
  "03101": 12.48,
  "03102": 12.48,
  "03103": 12.48,
  "03104": 12.48,
  "03105": 12.48,
  "03106": 12.48,
  "03108": 12.48,
  "03109": 12.48,
  "03110": 20.97,
  "03215": 0,
  "03216": 10.64,
  "03217": 14.66,
  "03218": 14.66,
  "03220": 14.66,
  "03221": -4.54,
  "03222": 14.66,
  "03223": 1.32,
  "03224": 10.64,
  "03225": 6.38,
  "03226": 23.15,
  "03227": 7.97,
  "03229": 10.64,
  "03230": 10.64,
  "03231": 10.64,
  "03233": -3.99,
  "03234": 10.64,
  "03235": 10.64,
  "03237": 14.66,
  "03238": 1.32,
  "03240": -5.06,
  "03241": 1.84,
  "03242": 10.64,
  "03243": 15.7,
  "03244": 10.64,
  "03245": 23.15,
  "03246": 14.66,
  "03247": 14.66,
  "03249": 14.66,
  "03251": 1.32,
  "03252": 14.66,
  "03253": 15.18,
  "03254": 7.97,
  "03255": -4.54,
  "03256": 15.18,
  "03257": 3.95,
  "03258": 10.64,
  "03259": 7.97,
  "03260": 10.64,
  "03261": 6.38,
  "03262": 1.32,
  "03263": 14.66,
  "03264": 1.32,
  "03266": 1.32,
  "03268": 10.64,
  "03269": 15.18,
  "03272": -4.54,
  "03273": 10.64,
  "03274": 1.32,
  "03275": 10.64,
  "03276": 14.66,
  "03278": 10.64,
  "03279": 1.32,
  "03280": -4.54,
  "03281": 10.64,
  "03282": 1.32,
  "03284": -4.54,
  "03285": 1.32,
  "03287": 10.64,
  "03289": 14.66,
  "03290": 11.04,
  "03291": 6.9,
  "03293": 1.32,
  "03301": 10.64,
  "03302": 10.64,
  "03303": 10.64,
  "03304": 11.19,
  "03307": 10.64,
  "03431": 1.84,
  "03440": 2.36,
  "03441": 2.36,
  "03442": 2.36,
  "03443": 2.91,
  "03444": 10.85,
  "03445": 1.84,
  "03446": 2.36,
  "03447": 1.84,
  "03448": 1.84,
  "03449": 2.91,
  "03450": 2.36,
  "03451": 2.36,
  "03452": 2.36,
  "03455": 1.84,
  "03456": 2.36,
  "03457": 2.36,
  "03458": 2.36,
  "03461": 2.36,
  "03462": 2.36,
  "03464": 2.36,
  "03465": 1.84,
  "03466": 2.91,
  "03467": 2.36,
  "03468": 2.36,
  "03469": 2.36,
  "03470": 1.84,
  "03561": -3.07,
  "03570": 6.29,
  "03574": 1.32,
  "03575": 6.84,
  "03576": 6.84,
  "03579": 6.84,
  "03580": 1.84,
  "03581": 6.84,
  "03582": 6.29,
  "03583": 6.84,
  "03584": 6.84,
  "03585": -3.07,
  "03586": -3.07,
  "03588": 6.84,
  "03589": 6.84,
  "03590": 6.29,
  "03592": 6.84,
  "03593": 6.29,
  "03595": 6.84,
  "03597": 6.84,
  "03598": 6.84,
  "03601": -5.06,
  "03602": -4.54,
  "03603": -5.06,
  "03604": -5.06,
  "03605": -4.54,
  "03607": -4.54,
  "03608": 2.36,
  "03609": -5.06,
  "03740": 2.36,
  "03741": 2.36,
  "03743": -5.06,
  "03745": -4.54,
  "03746": -4.54,
  "03748": -4.54,
  "03749": -4.54,
  "03750": 10.85,
  "03751": -3.99,
  "03752": -4.54,
  "03753": -3.99,
  "03754": -4.54,
  "03755": 10.85,
  "03756": -4.54,
  "03765": 2.91,
  "03766": -4.54,
  "03768": 3.95,
  "03769": 3.95,
  "03770": -4.54,
  "03771": -3.07,
  "03773": -4.54,
  "03774": 2.36,
  "03777": 2.91,
  "03779": 2.91,
  "03780": 2.36,
  "03781": -4.54,
  "03782": -4.54,
  "03784": -4.54,
  "03785": 2.36,
  "03801": 7.97,
  "03802": 7.97,
  "03804": 7.97,
  "03805": 6.9,
  "03809": 15.18,
  "03810": 15.18,
  "03811": 11.56,
  "03812": -0.52,
  "03813": 0,
  "03814": -0.52,
  "03815": 6.9,
  "03816": 23.15,
  "03817": -0.52,
  "03818": -0.52,
  "03819": 11.56,
  "03820": 6.9,
  "03821": 6.9,
  "03823": 6.9,
  "03824": 7.97,
  "03825": 6.9,
  "03826": 11.56,
  "03827": 12.63,
  "03830": -0.52,
  "03832": 0,
  "03833": 12.11,
  "03835": 6.38,
  "03836": 0,
  "03837": 15.18,
  "03838": 0,
  "03839": 6.38,
  "03840": 12.63,
  "03841": 11.56,
  "03842": 12.11,
  "03843": 12.11,
  "03844": 12.63,
  "03845": 0,
  "03846": 7.97,
  "03847": 0,
  "03848": 11.56,
  "03849": -0.52,
  "03850": 15.18,
  "03851": 6.38,
  "03852": 6.38,
  "03853": 23.15,
  "03854": 18.76,
  "03855": 15.18,
  "03856": 12.63,
  "03857": 12.11,
  "03858": 11.56,
  "03859": 11.56,
  "03860": -0.52,
  "03861": 11.04,
  "03862": 12.11,
  "03864": -0.52,
  "03865": 11.56,
  "03866": 6.38,
  "03867": 6.38,
  "03868": 6.38,
  "03869": 6.9,
  "03870": 14.93,
  "03871": 14.93,
  "03872": -0.52,
  "03873": 11.56,
  "03874": 12.11,
  "03875": -0.52,
  "03878": 6.38,
  "03882": -0.52,
  "03883": -0.52,
  "03884": 6.9,
  "03885": 12.63,
  "03886": -0.52,
  "03887": 6.38,
  "03890": -0.52,
  "03894": 16.25,
  "03896": 16.25,
  "03897": 7.97,
  "03901": 6.38,
  "03902": -0.31,
  "03903": 7.97,
  "03904": 7.97,
  "03905": 7.97,
  "03906": -1.9,
  "03907": 0.21,
  "03908": 6.9,
  "03909": 7.97,
  "03910": 7.97,
  "03911": 7.97,
  "04001": -1.38,
  "04002": -1.9,
  "04003": 12.78,
  "04004": 3.74,
  "04005": -0.86,
  "04006": -0.86,
  "04007": -0.86,
  "04008": -3.28,
  "04009": -6.5,
  "04010": -6.5,
  "04011": -3.28,
  "04013": 4.29,
  "04014": -0.31,
  "04015": 2.7,
  "04016": -6.5,
  "04017": 4.29,
  "04019": 4.29,
  "04020": -0.86,
  "04021": 4.29,
  "04022": -6.5,
  "04024": 3.74,
  "04027": 6.38,
  "04028": -1.9,
  "04029": 3.74,
  "04030": -0.86,
  "04032": 4.29,
  "04037": -6.5,
  "04038": 4.29,
  "04039": 3.74,
  "04040": -6.5,
  "04041": 3.74,
  "04042": -0.86,
  "04043": -0.31,
  "04046": -0.31,
  "04047": -0.86,
  "04048": -0.86,
  "04049": 3.74,
  "04050": 12.78,
  "04051": -6.5,
  "04054": -0.31,
  "04055": 2.7,
  "04056": -0.52,
  "04057": -6.5,
  "04061": -0.86,
  "04062": 3.74,
  "04063": -0.86,
  "04064": -0.86,
  "04066": -1.69,
  "04068": -0.86,
  "04069": 11.19,
  "04070": 4.29,
  "04071": 4.29,
  "04072": -0.86,
  "04073": -1.9,
  "04074": 4.29,
  "04076": -1.9,
  "04077": 4.29,
  "04078": 4.29,
  "04079": -1.69,
  "04082": 4.29,
  "04083": -1.9,
  "04084": 4.29,
  "04085": 3.74,
  "04086": -3.28,
  "04087": -1.9,
  "04088": -6.5,
  "04090": -0.31,
  "04091": 3.74,
  "04092": 3.74,
  "04093": 3.74,
  "04094": -0.31,
  "04095": -0.52,
  "04096": 4.29,
  "04097": 4.29,
  "04098": 3.74,
  "04101": 3.74,
  "04102": 4.29,
  "04103": 4.29,
  "04104": 3.74,
  "04105": 12.78,
  "04106": 3.74,
  "04107": 4.29,
  "04108": 4.29,
  "04109": 4.29,
  "04110": 15.08,
  "04112": 4.29,
  "04116": 3.74,
  "04210": -1.44,
  "04211": -1.44,
  "04212": -1.44,
  "04216": -6.5,
  "04217": -6.5,
  "04219": -6.5,
  "04220": -1.44,
  "04221": -1.44,
  "04222": 11.19,
  "04223": -1.44,
  "04224": -6.5,
  "04225": -8.89,
  "04226": -6.5,
  "04227": -8.89,
  "04228": 0.77,
  "04230": -1.44,
  "04231": -6.5,
  "04234": -8.89,
  "04236": -1.44,
  "04237": -6.5,
  "04238": -1.44,
  "04239": 0.77,
  "04240": -1.44,
  "04241": -1.44,
  "04243": -1.44,
  "04250": -1.44,
  "04252": -3.28,
  "04253": -1.44,
  "04254": 0.77,
  "04255": -6.5,
  "04256": -1.44,
  "04257": -7.05,
  "04258": -1.44,
  "04259": -1.44,
  "04260": 3.22,
  "04261": -5.98,
  "04262": 1.32,
  "04263": -1.44,
  "04265": -1.44,
  "04266": -1.44,
  "04267": -6.5,
  "04268": -6.5,
  "04270": -1.44,
  "04271": -6.5,
  "04274": -1.44,
  "04275": -8.34,
  "04276": -6.5,
  "04280": -1.44,
  "04281": -6.5,
  "04282": -1.44,
  "04284": 1.32,
  "04285": -8.34,
  "04286": -6.5,
  "04287": 2.7,
  "04288": -1.44,
  "04289": -6.5,
  "04290": -6.5,
  "04291": -1.44,
  "04292": -6.5,
  "04294": -8.89,
  "04330": 1.32,
  "04332": 1.32,
  "04338": 1.32,
  "04341": 1.32,
  "04342": -3.28,
  "04343": 1.32,
  "04344": 1.32,
  "04345": 0.77,
  "04346": 0.77,
  "04347": 1.32,
  "04348": -7.88,
  "04349": 1.32,
  "04350": -1.44,
  "04351": 1.32,
  "04352": 1.32,
  "04353": -7.88,
  "04354": -8.8,
  "04355": 1.32,
  "04357": -3.28,
  "04358": 1.32,
  "04359": 1.32,
  "04360": 1.32,
  "04363": 1.32,
  "04364": 1.32,
  "04401": 0.4,
  "04402": 0.4,
  "04406": -11.65,
  "04408": -6.96,
  "04410": 0.4,
  "04411": 0.4,
  "04412": -6.96,
  "04413": -8.89,
  "04414": -11.65,
  "04415": -11.65,
  "04416": -8.8,
  "04417": -0.15,
  "04418": -0.15,
  "04419": -8.8,
  "04421": -0.31,
  "04422": 0.4,
  "04424": -8.89,
  "04426": 0.4,
  "04427": 0.4,
  "04428": -6.96,
  "04429": -6.96,
  "04430": -0.15,
  "04431": -6.96,
  "04434": -8.8,
  "04435": -0.15,
  "04438": -8.8,
  "04441": -11.1,
  "04442": -11.65,
  "04443": -11.65,
  "04444": -8.8,
  "04448": -0.15,
  "04449": 0.37,
  "04450": 0.37,
  "04451": -0.15,
  "04453": -0.15,
  "04454": -8.89,
  "04455": -0.15,
  "04456": 0.4,
  "04457": -0.15,
  "04459": -0.15,
  "04460": -0.15,
  "04461": 0.4,
  "04462": -11.65,
  "04463": -0.15,
  "04464": -11.65,
  "04468": 0.4,
  "04471": -8.89,
  "04472": -6.96,
  "04473": 0.4,
  "04474": -6.96,
  "04475": -0.15,
  "04476": -6.96,
  "04478": -11.1,
  "04479": 0.86,
  "04481": 0.4,
  "04485": -11.1,
  "04487": -0.15,
  "04488": 0.4,
  "04489": 0.4,
  "04490": -8.89,
  "04491": -8.89,
  "04492": -8.89,
  "04493": -0.15,
  "04495": -0.15,
  "04496": -8.8,
  "04497": -0.15,
  "04530": -3.28,
  "04535": -7.88,
  "04537": -7.88,
  "04538": -7.88,
  "04539": -7.88,
  "04541": 0.61,
  "04543": 0.61,
  "04544": 0.61,
  "04547": -5.58,
  "04548": -1.69,
  "04549": -7.88,
  "04551": -6.29,
  "04553": -6.29,
  "04554": 0.61,
  "04555": -7.88,
  "04556": -7.88,
  "04558": 0.61,
  "04562": -1.69,
  "04563": -5.58,
  "04564": -6.29,
  "04565": -1.69,
  "04568": 0.61,
  "04570": 6.8,
  "04571": -7.88,
  "04572": -6.29,
  "04573": 0.61,
  "04574": -5.58,
  "04575": -7.88,
  "04576": 6.8,
  "04578": -7.88,
  "04579": -3.28,
  "04605": -6.96,
  "04606": -8.34,
  "04607": -6.96,
  "04609": -6.96,
  "04611": -8.34,
  "04612": -6.96,
  "04613": -6.96,
  "04614": -6.96,
  "04616": -6.96,
  "04617": -6.96,
  "04619": -8.89,
  "04622": -8.89,
  "04623": -8.89,
  "04624": -6.96,
  "04625": -5.37,
  "04626": -8.34,
  "04627": -6.96,
  "04628": -8.89,
  "04629": -6.96,
  "04630": -8.34,
  "04631": -8.89,
  "04634": -6.96,
  "04635": -6.96,
  "04637": -8.89,
  "04640": -6.96,
  "04642": -8.8,
  "04643": -8.89,
  "04644": -6.96,
  "04645": -5.58,
  "04646": -6.96,
  "04648": -8.34,
  "04649": -8.34,
  "04650": -6.96,
  "04652": -8.89,
  "04653": -6.96,
  "04654": -8.34,
  "04655": -8.34,
  "04657": -8.34,
  "04658": -6.96,
  "04660": -6.96,
  "04662": 1.53,
  "04664": -6.96,
  "04666": -8.89,
  "04667": -8.89,
  "04668": -8.89,
  "04669": -6.96,
  "04671": -8.89,
  "04672": -6.96,
  "04673": -6.96,
  "04674": -6.96,
  "04675": -6.96,
  "04676": -6.96,
  "04677": -6.96,
  "04679": -6.96,
  "04680": -6.96,
  "04681": -5.58,
  "04683": -6.96,
  "04684": -6.96,
  "04685": -6.96,
  "04686": -8.34,
  "04691": -8.34,
  "04693": -6.96,
  "04694": -8.89,
  "04730": -8.89,
  "04732": -8.89,
  "04733": 0.4,
  "04734": -8.89,
  "04735": -8.89,
  "04736": -8.89,
  "04737": -8.89,
  "04738": -8.89,
  "04739": -8.34,
  "04740": -8.89,
  "04741": -8.89,
  "04742": -8.89,
  "04743": -8.89,
  "04744": -8.89,
  "04745": -8.89,
  "04746": -8.89,
  "04747": -8.89,
  "04750": -8.89,
  "04756": -8.89,
  "04757": -8.89,
  "04758": -8.89,
  "04760": -8.89,
  "04761": -8.89,
  "04762": -8.89,
  "04763": -8.89,
  "04764": -8.89,
  "04765": -8.89,
  "04766": -8.89,
  "04768": -8.34,
  "04769": -8.89,
  "04772": -8.34,
  "04773": -8.34,
  "04774": -8.89,
  "04775": -8.89,
  "04776": -0.15,
  "04777": -11.65,
  "04779": -8.34,
  "04780": -8.89,
  "04781": -8.89,
  "04783": -8.34,
  "04785": -8.89,
  "04786": -8.89,
  "04787": -8.89,
  "04841": -5.58,
  "04843": -5.58,
  "04846": -5.58,
  "04847": -5.58,
  "04848": -8.8,
  "04849": -8.8,
  "04850": -8.8,
  "04851": -5.58,
  "04852": -6.29,
  "04853": -5.58,
  "04854": -5.58,
  "04855": -5.58,
  "04856": -5.58,
  "04858": -5.58,
  "04859": -5.58,
  "04860": -3.99,
  "04861": -5.58,
  "04862": -5.58,
  "04863": -5.58,
  "04864": -5.58,
  "04865": -5.58,
  "04901": 1.32,
  "04903": 1.32,
  "04910": -8.8,
  "04911": -8.89,
  "04912": 0.31,
  "04915": -8.8,
  "04917": 1.32,
  "04918": 1.32,
  "04920": 0.31,
  "04921": -8.8,
  "04922": -9.35,
  "04923": 0.31,
  "04924": 1.32,
  "04925": 0.86,
  "04926": 1.32,
  "04927": 1.32,
  "04928": 0.4,
  "04929": -9.35,
  "04930": 0.31,
  "04932": -8.8,
  "04933": -8.8,
  "04935": 1.32,
  "04936": -8.34,
  "04937": 1.32,
  "04938": -8.89,
  "04939": -0.15,
  "04940": 1.32,
  "04941": -8.8,
  "04942": 0.31,
  "04943": 0.31,
  "04944": 1.32,
  "04945": 0.31,
  "04947": -8.34,
  "04949": -8.8,
  "04950": 0.86,
  "04951": -8.8,
  "04952": -8.8,
  "04953": -8.8,
  "04954": -8.89,
  "04955": 1.32,
  "04956": -8.89,
  "04957": 0.77,
  "04958": 0.31,
  "04961": 0.31,
  "04962": 1.32,
  "04963": 1.32,
  "04964": -8.34,
  "04965": -9.35,
  "04966": -8.89,
  "04967": -9.35,
  "04969": -8.8,
  "04970": -8.34,
  "04971": 0.31,
  "04972": -8.8,
  "04973": -8.8,
  "04974": -8.8,
  "04975": 1.32,
  "04976": 0.86,
  "04978": 1.32,
  "04979": 0.31,
  "04981": -8.8,
  "04982": -8.34,
  "04983": -8.89,
  "04984": -8.89,
  "04985": 0.31,
  "04986": -8.8,
  "04987": -8.8,
  "04988": -8.8,
  "04989": 1.32,
  "04992": -8.89,
  "05001": -1.32,
  "05030": -1.32,
  "05031": 5.58,
  "05032": -0.77,
  "05033": 8.89,
  "05034": -2.36,
  "05035": -2.91,
  "05036": 8.89,
  "05037": -2.36,
  "05038": 8.89,
  "05039": 8.89,
  "05040": 8.34,
  "05041": 8.89,
  "05042": -3.07,
  "05043": 8.34,
  "05045": 8.89,
  "05046": -3.07,
  "05047": -1.32,
  "05048": -1.32,
  "05049": -1.32,
  "05050": -3.62,
  "05051": 8.89,
  "05052": -1.32,
  "05053": 5.58,
  "05054": 8.89,
  "05055": 7.17,
  "05056": -2.36,
  "05058": 8.89,
  "05059": -2.36,
  "05060": 8.89,
  "05061": 8.89,
  "05062": -2.36,
  "05065": 8.89,
  "05067": -1.32,
  "05068": 8.89,
  "05069": -3.62,
  "05070": 17.38,
  "05071": 6.13,
  "05072": 16.83,
  "05073": -2.36,
  "05074": 17.38,
  "05075": 9.93,
  "05076": 8.34,
  "05077": 8.89,
  "05079": 8.34,
  "05081": 8.89,
  "05083": 8.34,
  "05084": -0.77,
  "05085": 8.89,
  "05086": 8.34,
  "05088": -1.32,
  "05089": -1.32,
  "05091": -2.36,
  "05101": -1.38,
  "05141": -1.38,
  "05142": -2.91,
  "05143": -2.45,
  "05144": -2.45,
  "05146": -1.9,
  "05148": -1.9,
  "05149": -2.36,
  "05150": -2.91,
  "05151": -2.91,
  "05152": -8.43,
  "05153": -2.36,
  "05154": -1.38,
  "05155": -1.9,
  "05156": -4.54,
  "05158": -1.38,
  "05159": -1.38,
  "05161": -2.36,
  "05201": -7.88,
  "05250": -7.88,
  "05251": -7.88,
  "05252": -8.43,
  "05253": -7.88,
  "05254": 0.61,
  "05255": -7.88,
  "05257": -7.36,
  "05260": -7.88,
  "05261": -7.88,
  "05262": 0.61,
  "05301": 1.28,
  "05302": -0.31,
  "05303": -0.31,
  "05304": -0.31,
  "05340": -7.88,
  "05341": -1.38,
  "05342": -1.38,
  "05343": -1.9,
  "05344": 1.28,
  "05345": -0.31,
  "05346": -0.86,
  "05350": -7.88,
  "05351": -0.31,
  "05352": -7.36,
  "05353": -0.31,
  "05354": -3.53,
  "05355": -1.38,
  "05356": -1.38,
  "05357": -0.31,
  "05358": -1.38,
  "05359": -1.9,
  "05360": -1.9,
  "05361": -1.38,
  "05362": -0.31,
  "05363": -1.38,
  "05401": 5.21,
  "05402": 6.25,
  "05403": 6.25,
  "05404": 5.21,
  "05406": 5.21,
  "05407": 6.25,
  "05408": 6.25,
  "05440": -7.3,
  "05441": -2.15,
  "05442": -1.78,
  "05443": -3.53,
  "05444": -1.23,
  "05445": 13.7,
  "05446": 5.21,
  "05447": -2.7,
  "05448": -2.15,
  "05449": 5.21,
  "05450": -2.15,
  "05451": 6.25,
  "05452": 6.25,
  "05453": 6.25,
  "05454": -2.15,
  "05455": -2.15,
  "05456": -3.53,
  "05457": -2.15,
  "05458": -5.71,
  "05459": -2.15,
  "05460": -2.15,
  "05461": 5.21,
  "05462": 5.21,
  "05463": -6.75,
  "05464": -1.23,
  "05465": 6.25,
  "05466": 5.21,
  "05468": 5.21,
  "05469": -3.53,
  "05470": -3.16,
  "05471": -3.16,
  "05472": -3.53,
  "05473": -3.53,
  "05474": 1.19,
  "05476": -2.7,
  "05477": 5.21,
  "05478": -2.15,
  "05481": -2.15,
  "05482": 13.7,
  "05483": -2.15,
  "05485": -2.15,
  "05486": 1.19,
  "05487": -3.53,
  "05488": -2.15,
  "05489": 13.7,
  "05490": 13.7,
  "05491": -3.53,
  "05492": -1.23,
  "05494": 5.21,
  "05495": 13.7,
  "05601": -1.69,
  "05602": -1.69,
  "05640": -0.65,
  "05641": -1.69,
  "05647": -3.07,
  "05648": -1.69,
  "05649": -2.24,
  "05650": -2.24,
  "05651": -1.69,
  "05652": -1.78,
  "05653": -1.78,
  "05654": -2.24,
  "05655": -1.23,
  "05656": -1.78,
  "05657": -1.23,
  "05658": -1.69,
  "05660": 6.25,
  "05661": -1.23,
  "05662": 7.26,
  "05663": -1.69,
  "05664": -2.24,
  "05665": -1.78,
  "05666": -1.69,
  "05667": -1.69,
  "05669": -2.24,
  "05670": -1.69,
  "05672": 7.26,
  "05673": 6.8,
  "05674": 4.96,
  "05675": 8.89,
  "05676": -1.69,
  "05677": -0.65,
  "05678": -2.24,
  "05679": -1.69,
  "05680": -1.78,
  "05681": -1.78,
  "05682": -1.69,
  "05701": -6.13,
  "05702": -6.13,
  "05730": -5.58,
  "05731": -5.58,
  "05732": -5.58,
  "05733": -6.13,
  "05734": -3.53,
  "05735": -6.13,
  "05736": -6.13,
  "05737": -5.58,
  "05738": -5.58,
  "05739": -6.13,
  "05740": -3.53,
  "05741": -6.13,
  "05742": -5.58,
  "05743": -5.58,
  "05744": -6.13,
  "05745": -6.13,
  "05746": -6.13,
  "05747": -4.08,
  "05748": -4.08,
  "05750": -5.58,
  "05751": -4.54,
  "05753": -3.53,
  "05757": -5.58,
  "05758": -2.91,
  "05759": -6.13,
  "05760": -5.12,
  "05761": 2.24,
  "05762": -5.58,
  "05763": -5.58,
  "05764": -6.13,
  "05765": -6.13,
  "05766": -3.53,
  "05767": -3.53,
  "05768": 1.69,
  "05769": -3.53,
  "05770": -3.53,
  "05772": -5.58,
  "05773": -6.13,
  "05774": -6.13,
  "05775": 2.24,
  "05776": 1.69,
  "05777": -6.13,
  "05778": -3.53,
  "05819": -3.62,
  "05820": -3.16,
  "05821": -3.07,
  "05822": -3.16,
  "05823": -3.16,
  "05824": -3.62,
  "05825": -3.16,
  "05826": -1.78,
  "05827": -1.78,
  "05828": -3.07,
  "05829": -3.16,
  "05830": -3.16,
  "05832": -3.07,
  "05833": -3.16,
  "05836": -3.62,
  "05837": -3.62,
  "05838": -3.62,
  "05839": -3.16,
  "05840": -3.62,
  "05841": 5.42,
  "05842": -3.62,
  "05843": -3.62,
  "05845": -3.16,
  "05846": -3.16,
  "05847": -3.16,
  "05848": -3.62,
  "05849": -3.62,
  "05850": -3.62,
  "05851": -3.62,
  "05853": -3.16,
  "05855": -3.16,
  "05857": -3.16,
  "05858": -3.62,
  "05859": -3.16,
  "05860": -3.16,
  "05861": -3.62,
  "05862": -3.07,
  "05863": -3.62,
  "05866": -3.62,
  "05867": -3.62,
  "05868": -3.16,
  "05871": -3.07,
  "05872": -3.16,
  "05873": -3.07,
  "05874": -2.61,
  "05875": -3.16,
  "05901": -3.16,
  "05902": -4.2,
  "05903": -3.16,
  "05904": -3.62,
  "05905": -3.62,
  "05906": -3.62,
  "05907": -3.16,
  "06001": 15.39,
  "06002": 6.9,
  "06010": 6.9,
  "06011": 6.9,
  "06013": 6.9,
  "06016": 4.6,
  "06018": 5.52,
  "06019": 6.9,
  "06020": 6.9,
  "06021": 6.59,
  "06022": 15.39,
  "06023": 15.91,
  "06024": 6.04,
  "06025": 6.9,
  "06026": 6.9,
  "06027": 7.97,
  "06028": 6.9,
  "06029": 4.6,
  "06031": 5.52,
  "06032": 6.9,
  "06033": 6.9,
  "06034": 6.9,
  "06035": 7.97,
  "06037": 7.42,
  "06039": 14.53,
  "06040": 6.9,
  "06042": 6.9,
  "06043": 4.6,
  "06045": 6.9,
  "06050": 6.38,
  "06051": 6.38,
  "06052": 7.42,
  "06053": 6.38,
  "06057": 5.52,
  "06058": 6.59,
  "06059": 15.39,
  "06060": 17.84,
  "06061": 6.04,
  "06062": 7.42,
  "06063": 7.97,
  "06064": 6.9,
  "06065": 6.59,
  "06066": 4.6,
  "06067": 6.9,
  "06068": 14.01,
  "06069": 6.04,
  "06070": 8.49,
  "06071": 16.25,
  "06072": 16.25,
  "06073": 15.91,
  "06074": 6.9,
  "06075": 4.6,
  "06076": 4.6,
  "06077": 4.6,
  "06078": 9.35,
  "06079": 14.01,
  "06081": 6.9,
  "06082": 8.28,
  "06083": 8.28,
  "06084": 4.6,
  "06085": 6.9,
  "06088": 6.9,
  "06089": 6.9,
  "06090": 16.46,
  "06091": 7.97,
  "06092": 15.39,
  "06093": 9.35,
  "06094": 6.04,
  "06095": 6.9,
  "06096": 6.9,
  "06098": 6.04,
  "06101": 6.38,
  "06102": 6.9,
  "06103": 6.9,
  "06104": 6.38,
  "06105": 6.9,
  "06106": 6.38,
  "06107": 6.9,
  "06108": 6.9,
  "06109": 6.9,
  "06110": 6.9,
  "06111": 6.9,
  "06112": 6.38,
  "06114": 6.9,
  "06115": 6.9,
  "06117": 6.9,
  "06118": 6.9,
  "06119": 6.9,
  "06120": 6.38,
  "06123": 6.9,
  "06126": 6.9,
  "06127": 6.9,
  "06128": 6.9,
  "06129": 6.9,
  "06131": 6.9,
  "06132": 6.9,
  "06133": 6.38,
  "06134": 6.9,
  "06137": 5.12,
  "06138": 6.9,
  "06140": 6.38,
  "06141": 6.38,
  "06142": 6.9,
  "06143": 6.38,
  "06144": 6.38,
  "06145": 6.38,
  "06146": 6.38,
  "06147": 6.38,
  "06152": 6.38,
  "06199": 6.9,
  "06226": 4.6,
  "06230": -1.78,
  "06231": 5.12,
  "06232": 4.6,
  "06233": -2.3,
  "06234": -2.3,
  "06235": -2.3,
  "06237": 5.12,
  "06238": 4.6,
  "06239": -2.3,
  "06241": -2.3,
  "06242": -1.78,
  "06243": -2.3,
  "06244": -1.78,
  "06245": -1.78,
  "06246": -1.78,
  "06247": -1.78,
  "06248": 4.6,
  "06249": 2.36,
  "06250": 5.12,
  "06251": 5.12,
  "06254": 2.36,
  "06255": -1.78,
  "06256": -2.3,
  "06258": -1.78,
  "06259": -1.78,
  "06260": -2.3,
  "06262": -1.78,
  "06263": -2.3,
  "06264": -1.78,
  "06265": 4.6,
  "06266": -2.3,
  "06267": -1.78,
  "06268": 6.71,
  "06277": -2.3,
  "06278": 4.6,
  "06279": 4.6,
  "06280": -2.3,
  "06281": -1.78,
  "06282": -1.78,
  "06320": 1.84,
  "06330": 2.36,
  "06331": -2.3,
  "06332": -2.3,
  "06333": 1.84,
  "06334": 2.36,
  "06335": 1.84,
  "06336": 10.85,
  "06338": 2.36,
  "06339": 2.36,
  "06340": 1.84,
  "06349": 1.84,
  "06350": 2.36,
  "06351": 1.84,
  "06353": 1.84,
  "06354": -2.3,
  "06355": 1.84,
  "06357": 1.84,
  "06359": 2.36,
  "06360": 1.84,
  "06365": 2.36,
  "06370": 1.84,
  "06371": 1.84,
  "06372": 1.84,
  "06373": -2.3,
  "06374": -2.3,
  "06375": 1.84,
  "06376": 1.84,
  "06377": -2.3,
  "06378": 1.84,
  "06379": 1.84,
  "06380": 1.84,
  "06382": 1.84,
  "06383": 1.84,
  "06384": 1.84,
  "06385": 1.84,
  "06387": -2.3,
  "06388": 1.84,
  "06389": 2.36,
  "06390": 1.84,
  "06401": 4.6,
  "06403": 4.6,
  "06404": 7.42,
  "06405": 5.12,
  "06409": 1.84,
  "06410": 13.61,
  "06412": 10.85,
  "06413": 13.61,
  "06414": 9.01,
  "06415": 2.36,
  "06416": 7.42,
  "06417": 10.85,
  "06418": 4.6,
  "06419": 13.61,
  "06420": 10.85,
  "06422": 13.61,
  "06423": 10.85,
  "06424": 9.01,
  "06426": 1.84,
  "06437": 5.12,
  "06438": 10.85,
  "06439": 10.85,
  "06440": 10.79,
  "06441": 13.61,
  "06442": 1.84,
  "06443": 5.12,
  "06444": 5.12,
  "06447": 13.61,
  "06450": 5.12,
  "06451": 4.6,
  "06455": 13.61,
  "06456": 9.01,
  "06457": 7.42,
  "06460": 5.12,
  "06461": 5.12,
  "06467": 5.12,
  "06468": 7.42,
  "06469": 10.85,
  "06470": 10.79,
  "06471": 5.12,
  "06472": 5.67,
  "06473": 5.12,
  "06474": 5.12,
  "06475": 1.84,
  "06477": 5.12,
  "06478": 5.12,
  "06479": 5.12,
  "06480": 9.01,
  "06481": 6.71,
  "06482": 7.97,
  "06483": 4.6,
  "06484": 5.12,
  "06487": 4.6,
  "06488": 4.6,
  "06489": 7.42,
  "06491": 7.42,
  "06492": 5.12,
  "06497": 7.42,
  "06498": 1.84,
  "06501": 7.42,
  "06502": 7.42,
  "06503": 7.42,
  "06504": 4.6,
  "06505": 7.42,
  "06506": 7.42,
  "06507": 7.42,
  "06508": 7.42,
  "06509": 4.6,
  "06510": 7.42,
  "06511": 4.6,
  "06512": 4.6,
  "06513": 4.6,
  "06514": 4.6,
  "06515": 4.6,
  "06516": 4.6,
  "06517": 4.6,
  "06518": 4.6,
  "06519": 4.6,
  "06520": 7.42,
  "06521": 7.42,
  "06524": 5.12,
  "06525": 9.01,
  "06530": 4.6,
  "06531": 4.6,
  "06532": 4.6,
  "06533": 4.6,
  "06534": 4.6,
  "06535": 4.6,
  "06536": 4.6,
  "06601": 6.9,
  "06602": 6.9,
  "06604": 6.9,
  "06605": 6.9,
  "06606": 6.9,
  "06607": 6.9,
  "06608": 6.9,
  "06610": 6.9,
  "06611": 7.42,
  "06612": 6.9,
  "06614": 7.42,
  "06615": 6.9,
  "06650": 6.9,
  "06702": 4.6,
  "06703": 4.6,
  "06704": 4.6,
  "06705": 4.6,
  "06706": 4.6,
  "06708": 4.6,
  "06710": 4.6,
  "06712": 4.6,
  "06716": 4.6,
  "06720": 4.6,
  "06721": 4.6,
  "06722": 4.6,
  "06723": 4.6,
  "06724": 4.6,
  "06725": 4.6,
  "06726": 4.6,
  "06750": 5.52,
  "06751": 6.04,
  "06752": 9.41,
  "06753": 6.04,
  "06754": 6.04,
  "06755": 6.59,
  "06756": 6.04,
  "06757": 6.59,
  "06758": 5.52,
  "06759": 5.52,
  "06762": 4.6,
  "06763": 5.52,
  "06770": 4.6,
  "06776": 6.59,
  "06777": 6.04,
  "06778": 5.52,
  "06779": 5.52,
  "06781": 5.52,
  "06782": 5.52,
  "06783": 9.41,
  "06784": 7.11,
  "06785": 6.59,
  "06786": 5.52,
  "06787": 5.52,
  "06790": 5.52,
  "06791": 5.52,
  "06793": 16.31,
  "06794": 16.31,
  "06795": 5.52,
  "06796": 6.04,
  "06798": 6.04,
  "06801": 7.97,
  "06804": 7.97,
  "06807": 10.79,
  "06810": 7.97,
  "06811": 7.97,
  "06812": 7.97,
  "06813": 7.97,
  "06820": 19.28,
  "06824": 6.9,
  "06825": 6.9,
  "06829": 10.79,
  "06830": 19.28,
  "06831": 20.66,
  "06836": 19.28,
  "06838": 19.28,
  "06840": 19.28,
  "06850": 8.49,
  "06851": 8.49,
  "06852": 8.49,
  "06853": 10.79,
  "06854": 8.49,
  "06855": 10.79,
  "06856": 8.49,
  "06870": 12.38,
  "06875": 10.79,
  "06876": 10.79,
  "06877": 12.38,
  "06878": 19.28,
  "06880": 19.28,
  "06881": 19.28,
  "06883": 19.28,
  "06890": 19.28,
  "06896": 10.79,
  "06897": 19.28,
  "06901": 7.97,
  "06902": 7.97,
  "06903": 10.79,
  "06904": 7.97,
  "06905": 10.79,
  "06906": 8.49,
  "06907": 10.79,
  "06910": 8.49,
  "06911": 12.38,
  "06912": 7.97,
  "07001": 9.35,
  "07002": 10.73,
  "07003": 8.8,
  "07004": 9.35,
  "07005": 12.11,
  "07006": 11.65,
  "07007": 11.65,
  "07008": 9.35,
  "07009": 9.35,
  "07010": 10.73,
  "07011": 8.8,
  "07012": 9.35,
  "07013": 7.05,
  "07014": 8.8,
  "07015": 8.8,
  "07016": 9.35,
  "07017": 8.8,
  "07018": 8.8,
  "07019": 8.8,
  "07020": 10.73,
  "07021": 20.14,
  "07022": 10.73,
  "07023": 9.35,
  "07024": 9.35,
  "07026": 8.8,
  "07027": 9.35,
  "07028": 9.35,
  "07029": 8.8,
  "07030": 10.73,
  "07031": 10.73,
  "07032": 10.18,
  "07033": 8.8,
  "07034": 11.56,
  "07035": 7.05,
  "07036": 9.35,
  "07039": 11.65,
  "07040": 9.35,
  "07041": 11.65,
  "07042": 9.35,
  "07043": 11.65,
  "07044": 9.35,
  "07045": 14.41,
  "07046": 22.9,
  "07047": 10.18,
  "07050": 8.8,
  "07051": 8.8,
  "07052": 9.35,
  "07054": 12.11,
  "07055": 8.8,
  "07057": 9.35,
  "07058": 14.41,
  "07059": 17.38,
  "07060": 8.8,
  "07061": 8.8,
  "07062": 8.8,
  "07063": 12.94,
  "07064": 9.35,
  "07065": 9.35,
  "07066": 9.35,
  "07067": 9.35,
  "07068": 11.65,
  "07069": 8.8,
  "07070": 10.73,
  "07071": 10.73,
  "07072": 9.35,
  "07073": 10.73,
  "07074": 8.8,
  "07075": 9.35,
  "07076": 9.35,
  "07077": 9.35,
  "07078": 20.14,
  "07079": 9.35,
  "07080": 14.32,
  "07081": 9.35,
  "07082": 9.35,
  "07083": 8.8,
  "07086": 10.73,
  "07087": 10.73,
  "07088": 8.8,
  "07090": 11.65,
  "07091": 11.65,
  "07092": 11.65,
  "07093": 10.18,
  "07094": 10.73,
  "07095": 14.87,
  "07096": 10.73,
  "07101": 8.8,
  "07102": 8.8,
  "07103": 8.8,
  "07104": 8.8,
  "07105": 10.73,
  "07106": 8.8,
  "07107": 8.8,
  "07108": 8.8,
  "07109": 8.8,
  "07110": 9.35,
  "07111": 8.8,
  "07112": 8.8,
  "07114": 8.8,
  "07201": 9.35,
  "07202": 9.35,
  "07203": 8.8,
  "07204": 8.8,
  "07205": 8.8,
  "07206": 9.35,
  "07207": 8.8,
  "07208": 8.8,
  "07302": 10.73,
  "07303": 10.73,
  "07304": 10.18,
  "07305": 10.18,
  "07306": 10.18,
  "07307": 10.18,
  "07308": 10.18,
  "07309": 10.18,
  "07310": 10.73,
  "07311": 10.73,
  "07401": 9.87,
  "07403": 6.5,
  "07405": 7.05,
  "07407": 9.35,
  "07410": 9.35,
  "07416": 3.28,
  "07417": 17.84,
  "07418": 2.76,
  "07419": 3.28,
  "07420": 6.5,
  "07421": 2.76,
  "07422": 2.76,
  "07423": 12.17,
  "07424": 7.05,
  "07428": 2.24,
  "07430": 7.11,
  "07432": 7.05,
  "07435": 3.83,
  "07436": 7.05,
  "07438": 3.83,
  "07439": 3.28,
  "07440": 7.05,
  "07442": 6.5,
  "07444": 7.05,
  "07446": 7.11,
  "07450": 11.65,
  "07451": 11.65,
  "07452": 11.65,
  "07456": 7.05,
  "07457": 7.05,
  "07458": 15.6,
  "07460": 3.28,
  "07461": 2.76,
  "07462": 2.24,
  "07463": 9.87,
  "07465": 7.05,
  "07470": 9.35,
  "07474": 9.35,
  "07480": 6.5,
  "07481": 10.94,
  "07495": 7.11,
  "07501": 9.35,
  "07502": 6.5,
  "07503": 6.5,
  "07504": 6.5,
  "07505": 9.35,
  "07506": 7.05,
  "07507": 9.35,
  "07508": 7.05,
  "07509": 6.5,
  "07510": 6.5,
  "07511": 7.05,
  "07512": 7.05,
  "07513": 6.5,
  "07514": 6.5,
  "07522": 6.5,
  "07524": 6.5,
  "07533": 6.5,
  "07538": 7.05,
  "07543": 6.5,
  "07544": 6.5,
  "07601": 8.8,
  "07602": 8.8,
  "07603": 8.8,
  "07604": 9.35,
  "07605": 11.65,
  "07606": 9.35,
  "07607": 9.35,
  "07608": 9.35,
  "07620": 20.66,
  "07621": 9.35,
  "07624": 12.17,
  "07626": 12.17,
  "07627": 12.17,
  "07628": 9.35,
  "07630": 9.87,
  "07631": 9.35,
  "07632": 22.5,
  "07640": 12.17,
  "07641": 12.17,
  "07642": 12.17,
  "07643": 9.35,
  "07644": 9.35,
  "07645": 7.11,
  "07646": 9.35,
  "07647": 9.87,
  "07648": 12.17,
  "07649": 12.17,
  "07650": 9.35,
  "07652": 11.65,
  "07653": 11.65,
  "07656": 7.11,
  "07657": 10.73,
  "07660": 9.35,
  "07661": 9.35,
  "07662": 9.35,
  "07663": 9.35,
  "07666": 9.35,
  "07670": 12.17,
  "07675": 12.17,
  "07676": 12.17,
  "07677": 7.11,
  "07701": 11.71,
  "07702": 11.71,
  "07703": 11.19,
  "07704": 21.98,
  "07710": 11.19,
  "07711": 14.01,
  "07712": 11.19,
  "07716": 11.71,
  "07717": 15.08,
  "07718": 11.19,
  "07719": 11.19,
  "07720": 11.19,
  "07721": 14.87,
  "07722": 21.98,
  "07723": 21.98,
  "07724": 11.19,
  "07726": 8.53,
  "07727": 11.19,
  "07728": 11.19,
  "07730": 11.19,
  "07731": 11.19,
  "07732": 11.19,
  "07733": 22.5,
  "07734": 11.19,
  "07735": 14.87,
  "07737": 11.19,
  "07738": 15.08,
  "07739": 21.98,
  "07740": 11.19,
  "07746": 14.01,
  "07747": 14.87,
  "07748": 11.71,
  "07750": 15.08,
  "07751": 15.08,
  "07752": 11.19,
  "07753": 11.19,
  "07754": 11.19,
  "07755": 11.19,
  "07756": 11.19,
  "07757": 11.19,
  "07758": 11.19,
  "07760": 21.98,
  "07762": 14.01,
  "07763": 8.53,
  "07764": 11.19,
  "07765": 15.08,
  "07799": 11.71,
  "07801": 11.56,
  "07802": 14.41,
  "07803": 11.56,
  "07806": 11.56,
  "07820": 1.38,
  "07821": 3.83,
  "07822": 3.83,
  "07823": 1.38,
  "07825": 1.38,
  "07826": 3.28,
  "07827": 2.76,
  "07828": 12.11,
  "07829": 1.38,
  "07830": 24.59,
  "07831": 2.97,
  "07832": 1.38,
  "07833": 1.38,
  "07834": 12.11,
  "07836": 12.11,
  "07837": 11.56,
  "07838": 1.38,
  "07839": 1.38,
  "07840": 1.38,
  "07842": 11.56,
  "07843": 11.56,
  "07844": 1.38,
  "07845": 12.11,
  "07846": 1.38,
  "07847": 11.56,
  "07848": 3.83,
  "07849": 11.56,
  "07850": 11.56,
  "07851": -12.02,
  "07852": 11.56,
  "07853": 4.75,
  "07855": 3.28,
  "07856": 12.11,
  "07857": 11.56,
  "07860": 3.28,
  "07863": 1.38,
  "07865": 1.38,
  "07866": 11.56,
  "07869": 14.41,
  "07870": 4.75,
  "07871": 3.83,
  "07874": 11.56,
  "07875": 3.28,
  "07876": 12.11,
  "07877": 3.28,
  "07878": 12.11,
  "07879": 3.83,
  "07880": 1.38,
  "07881": 3.28,
  "07882": 1.38,
  "07885": 11.56,
  "07901": 20.14,
  "07902": 20.14,
  "07920": 15.79,
  "07921": 13.49,
  "07922": 11.65,
  "07924": 16,
  "07926": 14.41,
  "07927": 12.11,
  "07928": 11.65,
  "07930": 16,
  "07931": 24.28,
  "07932": 14.41,
  "07933": 11.65,
  "07934": 24.28,
  "07935": 14.41,
  "07936": 14.41,
  "07938": 15.79,
  "07939": 15.79,
  "07940": 14.41,
  "07945": 22.9,
  "07946": 15.79,
  "07950": 14.41,
  "07960": 14.41,
  "07961": 14.41,
  "07962": 14.41,
  "07963": 14.41,
  "07970": 14.41,
  "07974": 11.65,
  "07976": 22.9,
  "07977": 15.79,
  "07978": 13.49,
  "07979": 17.38,
  "07980": 15.79,
  "07981": 14.41,
  "07999": 12.11,
  "08001": 6.75,
  "08002": 5.71,
  "08003": 14.2,
  "08004": 5.71,
  "08005": 0.61,
  "08006": 3.43,
  "08007": 5.71,
  "08008": 1.84,
  "08009": 5.71,
  "08010": 7.09,
  "08011": 7.61,
  "08012": 5.71,
  "08014": 7.3,
  "08015": 7.61,
  "08016": 7.61,
  "08018": 7.82,
  "08019": 10.27,
  "08020": 5.71,
  "08021": 5.16,
  "08022": 7.61,
  "08023": 3.62,
  "08025": 14.2,
  "08026": 5.71,
  "08027": 5.71,
  "08028": 7.82,
  "08029": 5.71,
  "08030": 5.16,
  "08031": 5.16,
  "08032": 5.71,
  "08033": 14.2,
  "08034": 5.71,
  "08035": 5.71,
  "08036": 6.54,
  "08037": 4.6,
  "08038": 14.51,
  "08039": 7.3,
  "08041": 7.61,
  "08042": 7.61,
  "08043": 7.3,
  "08045": 5.71,
  "08046": 7.09,
  "08048": 7.09,
  "08049": 5.16,
  "08050": 0.61,
  "08051": 5.71,
  "08052": 5.71,
  "08053": 5.71,
  "08054": 7.09,
  "08055": 15.58,
  "08056": 5.71,
  "08057": 5.71,
  "08059": 5.16,
  "08060": 7.61,
  "08061": 5.71,
  "08062": 7.3,
  "08063": 5.16,
  "08064": 7.61,
  "08065": 5.71,
  "08066": 5.71,
  "08067": 3.62,
  "08068": 7.61,
  "08069": 3.62,
  "08070": 3.62,
  "08071": 5.71,
  "08072": 14.51,
  "08073": 7.09,
  "08074": 14.2,
  "08075": 7.09,
  "08076": 5.71,
  "08077": 5.71,
  "08078": 5.71,
  "08079": 14.51,
  "08080": 5.71,
  "08081": 5.71,
  "08083": 5.71,
  "08084": 5.71,
  "08085": 7.3,
  "08086": 5.71,
  "08087": 4.08,
  "08088": 7.09,
  "08089": 7.82,
  "08090": 5.71,
  "08091": 5.71,
  "08092": -0.98,
  "08093": 5.16,
  "08094": 7.82,
  "08095": 7.3,
  "08096": 5.71,
  "08097": 5.71,
  "08098": 7.82,
  "08099": 5.16,
  "08101": 5.16,
  "08102": 5.16,
  "08103": 5.16,
  "08104": 5.16,
  "08105": 5.16,
  "08106": 5.71,
  "08107": 5.16,
  "08108": 5.71,
  "08109": 5.71,
  "08110": 5.16,
  "08201": 4.08,
  "08202": 7.11,
  "08203": 4.08,
  "08204": -4.2,
  "08205": 4.08,
  "08210": -4.2,
  "08212": 6.59,
  "08213": 4.08,
  "08214": -4.2,
  "08215": 4.08,
  "08217": 4.6,
  "08218": -4.2,
  "08219": -4.2,
  "08220": 4.6,
  "08221": 4.6,
  "08223": 4.6,
  "08224": 4.08,
  "08225": 4.08,
  "08226": 4.6,
  "08230": -4.2,
  "08231": 4.08,
  "08232": 4.08,
  "08234": 4.08,
  "08240": 4.08,
  "08241": 4.6,
  "08242": -4.2,
  "08243": -3.68,
  "08244": 4.08,
  "08245": -4.2,
  "08246": -4.2,
  "08247": 6.59,
  "08248": -0.31,
  "08250": -4.2,
  "08251": -4.2,
  "08252": -4.75,
  "08260": -4.2,
  "08270": -4.2,
  "08302": 14.51,
  "08310": 15.58,
  "08311": 14.51,
  "08312": 7.82,
  "08313": 16.62,
  "08314": 15.58,
  "08315": 15.58,
  "08316": 15.58,
  "08317": 6.19,
  "08318": 15.03,
  "08319": 4.08,
  "08320": 14.51,
  "08321": 15.03,
  "08322": 7.82,
  "08323": 15.03,
  "08324": 15.58,
  "08326": 15.58,
  "08327": 15.58,
  "08328": 16.1,
  "08329": 16.1,
  "08330": 4.6,
  "08332": 15.58,
  "08340": 24.59,
  "08341": 16.1,
  "08342": 16.1,
  "08343": 9.41,
  "08344": 16.1,
  "08345": 15.58,
  "08346": 4.08,
  "08347": 16.1,
  "08348": 15.58,
  "08349": 15.58,
  "08350": 16.1,
  "08352": 16.1,
  "08353": 14.51,
  "08360": 15.58,
  "08361": 15.58,
  "08362": 16.1,
  "08401": 4.08,
  "08402": 4.6,
  "08403": 4.6,
  "08404": 4.08,
  "08406": 4.08,
  "08501": 8.07,
  "08502": 21.62,
  "08504": 18.86,
  "08505": 8.07,
  "08510": 18.86,
  "08511": 7.61,
  "08512": 8.07,
  "08514": 18.86,
  "08515": 8.07,
  "08518": 8.07,
  "08520": 8.07,
  "08525": 8.59,
  "08526": 8.07,
  "08527": 0.61,
  "08528": 8.07,
  "08530": 12.21,
  "08533": 8.07,
  "08534": 8.59,
  "08535": 18.86,
  "08536": 8.07,
  "08540": 8.07,
  "08542": 8.07,
  "08543": 18.86,
  "08550": 18.86,
  "08551": 15.03,
  "08553": 8.59,
  "08554": 8.07,
  "08555": 8.07,
  "08556": 12.73,
  "08557": 12.73,
  "08558": 18.86,
  "08559": 12.73,
  "08560": 8.07,
  "08561": 8.07,
  "08562": 7.61,
  "08601": 8.07,
  "08602": 8.07,
  "08603": 8.07,
  "08604": 8.07,
  "08605": 8.07,
  "08606": 8.07,
  "08607": 8.07,
  "08608": 8.07,
  "08609": 8.07,
  "08610": 8.07,
  "08611": 8.07,
  "08618": 8.07,
  "08619": 8.07,
  "08620": 8.07,
  "08625": 8.07,
  "08628": 8.07,
  "08629": 8.07,
  "08638": 8.07,
  "08640": 7.61,
  "08641": 7.61,
  "08648": 8.07,
  "08650": 8.07,
  "08690": 8.07,
  "08691": 8.07,
  "08701": 0.61,
  "08720": 14.01,
  "08721": 0.61,
  "08722": 0.61,
  "08723": 0.61,
  "08724": 0.61,
  "08730": 13.49,
  "08731": 0.61,
  "08732": 0.61,
  "08733": 0.61,
  "08734": 0.61,
  "08735": 0.61,
  "08736": 13.49,
  "08738": 11.4,
  "08739": 0.61,
  "08740": 0.61,
  "08741": 0.61,
  "08742": 0.61,
  "08750": 21.98,
  "08751": 0.61,
  "08752": 0.61,
  "08753": 0.61,
  "08754": 0.61,
  "08755": 0.61,
  "08756": 0.61,
  "08757": 0.61,
  "08758": 0.61,
  "08759": 0.06,
  "08801": 24.59,
  "08802": 15.39,
  "08803": 14.32,
  "08804": 1.38,
  "08805": 12.94,
  "08807": 13.49,
  "08808": 1.38,
  "08809": 14.32,
  "08810": 12.21,
  "08812": 12.94,
  "08816": 15.39,
  "08817": 14.87,
  "08818": 14.87,
  "08820": 15.39,
  "08821": 10.83,
  "08822": 12.73,
  "08823": 10.83,
  "08824": 10.83,
  "08825": 14.32,
  "08826": 2.97,
  "08827": 15.39,
  "08828": 12.21,
  "08829": 13.8,
  "08830": 9.35,
  "08831": 12.21,
  "08832": 14.87,
  "08833": 24.59,
  "08834": 14.32,
  "08835": 10.83,
  "08836": 15.79,
  "08837": 14.87,
  "08840": 14.87,
  "08844": 21.62,
  "08846": 12.94,
  "08848": 14.32,
  "08850": 14.87,
  "08852": 12.21,
  "08853": 14.72,
  "08854": 14.32,
  "08855": 14.87,
  "08857": 14.87,
  "08858": 24.59,
  "08859": 14.87,
  "08861": 14.87,
  "08862": 14.87,
  "08863": 14.87,
  "08865": 1.9,
  "08867": 24.59,
  "08868": 24.59,
  "08869": 10.83,
  "08870": 15.03,
  "08871": 14.87,
  "08872": 14.87,
  "08873": 12.94,
  "08875": 14.87,
  "08876": 10.83,
  "08879": 14.87,
  "08880": 12.94,
  "08882": 14.87,
  "08884": 12.21,
  "08885": 12.21,
  "08886": 1.9,
  "08887": 12.21,
  "08888": 15.03,
  "08889": 15.03,
  "08890": 10.83,
  "08899": 14.87,
  "08901": 14.87,
  "08902": 12.21,
  "08903": 14.87,
  "08904": 14.87,
  "08906": 14.87,
  "10001": 27.66,
  "10002": 28.21,
  "10003": 30.51,
  "10004": 10.18,
  "10005": 10.73,
  "10006": 10.73,
  "10007": 21.52,
  "10008": 21.52,
  "10009": 28.73,
  "10010": 31.03,
  "10011": 30.51,
  "10012": 39,
  "10013": 21.52,
  "10014": 30.51,
  "10016": 31.03,
  "10017": 31.03,
  "10018": 30.51,
  "10019": 30.51,
  "10020": 31.03,
  "10021": 39.52,
  "10022": 32.62,
  "10023": 30.51,
  "10024": 39,
  "10025": 31.03,
  "10026": 28.21,
  "10027": 28.21,
  "10028": 39.52,
  "10029": 31.03,
  "10030": 31.03,
  "10031": 31.03,
  "10032": 11.19,
  "10033": 11.19,
  "10034": 11.19,
  "10035": 28.21,
  "10036": 30.51,
  "10037": 28.21,
  "10038": 10.18,
  "10039": 11.19,
  "10040": 11.19,
  "10041": 10.73,
  "10044": 28.21,
  "10045": 10.73,
  "10055": 32.62,
  "10060": 27.66,
  "10065": 39.52,
  "10069": 30.51,
  "10075": 39.52,
  "10090": 30.51,
  "10095": 27.66,
  "10098": 21.52,
  "10099": 27.66,
  "10101": 30.51,
  "10103": 31.03,
  "10104": 30.51,
  "10105": 32.62,
  "10106": 30.51,
  "10107": 30.51,
  "10108": 30.51,
  "10110": 28.73,
  "10111": 31.03,
  "10112": 30.51,
  "10113": 30.51,
  "10115": 28.21,
  "10116": 28.21,
  "10118": 27.66,
  "10119": 27.66,
  "10120": 27.66,
  "10121": 27.66,
  "10122": 27.66,
  "10123": 27.66,
  "10128": 39.52,
  "10129": 30.51,
  "10150": 32.62,
  "10151": 30.51,
  "10152": 32.62,
  "10153": 32.62,
  "10154": 32.62,
  "10155": 32.62,
  "10156": 31.03,
  "10158": 32.62,
  "10159": 31.03,
  "10161": 30.51,
  "10162": 39.52,
  "10163": 32.62,
  "10165": 31.03,
  "10166": 31.03,
  "10167": 31.03,
  "10168": 31.03,
  "10169": 31.03,
  "10170": 31.03,
  "10171": 32.62,
  "10172": 31.03,
  "10173": 31.03,
  "10174": 31.03,
  "10175": 30.51,
  "10176": 31.03,
  "10177": 31.03,
  "10178": 31.03,
  "10185": 30.51,
  "10199": 28.73,
  "10242": 21.52,
  "10249": 21.52,
  "10268": 10.73,
  "10270": 10.18,
  "10271": 10.18,
  "10272": 30.51,
  "10274": 10.73,
  "10276": 30.51,
  "10278": 21.52,
  "10279": 21.52,
  "10280": 13.03,
  "10281": 21.52,
  "10282": 21.52,
  "10301": 6.19,
  "10302": 5.67,
  "10303": 5.67,
  "10304": 6.19,
  "10305": 6.19,
  "10306": 6.19,
  "10307": 17.69,
  "10308": 6.19,
  "10309": 8.49,
  "10310": 6.19,
  "10311": 6.19,
  "10312": 6.19,
  "10313": 6.19,
  "10314": 6.19,
  "10451": 11.19,
  "10452": 11.19,
  "10453": 11.19,
  "10454": 11.19,
  "10455": 11.19,
  "10456": 11.19,
  "10457": 11.19,
  "10458": 11.19,
  "10459": 11.19,
  "10460": 11.71,
  "10461": 11.71,
  "10462": 11.19,
  "10463": 11.19,
  "10464": 14.01,
  "10465": 11.71,
  "10466": 11.19,
  "10467": 11.19,
  "10468": 11.19,
  "10469": 11.19,
  "10470": 11.19,
  "10471": 11.19,
  "10472": 11.71,
  "10473": 11.71,
  "10474": 11.19,
  "10475": 11.19,
  "10501": 8.49,
  "10502": 12.17,
  "10503": 12.17,
  "10504": 20.66,
  "10505": 8.49,
  "10506": 13.76,
  "10507": 8.49,
  "10509": 5.67,
  "10510": 12.17,
  "10511": 4.81,
  "10512": 5.67,
  "10514": 20.66,
  "10516": 6.19,
  "10517": 4.6,
  "10518": 8.49,
  "10519": 5.67,
  "10520": 7.11,
  "10521": 3.22,
  "10522": 12.17,
  "10523": 9.87,
  "10524": 13.09,
  "10526": 8.49,
  "10527": 8.49,
  "10528": 12.17,
  "10530": 9.87,
  "10532": 12.17,
  "10533": 12.17,
  "10535": 4.6,
  "10536": 10.08,
  "10537": 4.6,
  "10538": 15.6,
  "10540": 6.19,
  "10541": 5.67,
  "10542": 5.67,
  "10543": 12.17,
  "10545": 9.87,
  "10546": 12.17,
  "10547": 4.6,
  "10548": 3.22,
  "10549": 12.17,
  "10550": 11.19,
  "10551": 11.71,
  "10552": 11.71,
  "10553": 11.71,
  "10560": 8.49,
  "10562": 9.87,
  "10566": 6.19,
  "10567": 6.19,
  "10570": 12.17,
  "10573": 12.17,
  "10576": 10.79,
  "10577": 20.66,
  "10578": 6.19,
  "10579": 6.19,
  "10580": 20.66,
  "10583": 12.17,
  "10587": 8.49,
  "10588": 6.19,
  "10589": 6.19,
  "10590": 10.79,
  "10591": 12.17,
  "10594": 12.17,
  "10595": 12.17,
  "10596": 4.81,
  "10597": 16.98,
  "10598": 5.67,
  "10601": 9.35,
  "10602": 9.35,
  "10603": 9.35,
  "10604": 12.17,
  "10605": 12.17,
  "10606": 9.87,
  "10607": 9.87,
  "10610": 9.87,
  "10701": 11.19,
  "10702": 11.19,
  "10703": 11.19,
  "10704": 11.71,
  "10705": 11.19,
  "10706": 11.19,
  "10707": 12.17,
  "10708": 11.71,
  "10709": 12.17,
  "10710": 9.87,
  "10801": 11.71,
  "10802": 11.71,
  "10803": 14.01,
  "10804": 12.17,
  "10805": 11.19,
  "10901": 4.29,
  "10910": 0,
  "10911": 11.71,
  "10912": 0,
  "10913": 7.11,
  "10914": 0,
  "10915": 0,
  "10916": 0,
  "10917": 0,
  "10918": 0,
  "10919": 0,
  "10920": 4.81,
  "10921": 0,
  "10922": 4.6,
  "10923": 4.29,
  "10924": 0,
  "10925": 0,
  "10926": 0,
  "10927": 4.29,
  "10928": 4.6,
  "10930": 0,
  "10931": 4.29,
  "10932": -0.52,
  "10933": 0,
  "10940": -0.52,
  "10941": -0.52,
  "10949": 0,
  "10950": 0,
  "10952": 4.81,
  "10953": 0,
  "10954": 4.81,
  "10956": 7.11,
  "10958": 0,
  "10959": 0,
  "10960": 4.81,
  "10962": 4.81,
  "10963": 0,
  "10964": 12.17,
  "10965": 4.81,
  "10968": 12.17,
  "10969": 0,
  "10970": 4.29,
  "10973": 0,
  "10974": 4.29,
  "10975": 2.7,
  "10976": 9.87,
  "10977": 4.29,
  "10979": 0,
  "10980": 4.81,
  "10981": 0,
  "10982": 4.81,
  "10983": 4.81,
  "10984": 4.81,
  "10985": 18.34,
  "10986": 11.71,
  "10987": 14.01,
  "10988": 0,
  "10989": 4.29,
  "10990": 0,
  "10992": 0,
  "10993": 4.29,
  "10994": 7.11,
  "10996": 4.6,
  "10997": 4.6,
  "10998": 0,
  "11001": 9.87,
  "11002": 9.87,
  "11003": 9.87,
  "11004": 9.87,
  "11005": 13.09,
  "11010": 9.87,
  "11020": 13.09,
  "11021": 13.09,
  "11022": 13.09,
  "11023": 21.58,
  "11024": 21.58,
  "11026": 13.09,
  "11027": 21.58,
  "11030": 20.66,
  "11040": 12.17,
  "11042": 13.09,
  "11050": 12.17,
  "11096": 10.27,
  "11101": 28.73,
  "11102": 31.03,
  "11103": 31.03,
  "11104": 28.73,
  "11105": 31.03,
  "11106": 28.73,
  "11109": 28.73,
  "11201": 0.21,
  "11202": 0.21,
  "11203": 0.21,
  "11204": 2.51,
  "11205": -0.31,
  "11206": -0.31,
  "11207": -0.31,
  "11208": 10.27,
  "11209": 3.58,
  "11210": 0.21,
  "11211": 28.73,
  "11212": -0.31,
  "11213": 0.21,
  "11214": 0.21,
  "11215": 2.51,
  "11216": 0.21,
  "11217": 4.1,
  "11218": 0.21,
  "11219": 2.51,
  "11220": 0.21,
  "11221": 0.21,
  "11222": 28.73,
  "11223": 2.51,
  "11224": -0.31,
  "11225": 0.21,
  "11226": 0.21,
  "11228": 3.58,
  "11229": 0.21,
  "11230": 2.51,
  "11231": 1.99,
  "11232": -0.31,
  "11233": -0.31,
  "11234": 0.21,
  "11235": 0.21,
  "11236": 0.21,
  "11237": -0.31,
  "11238": 0.21,
  "11239": -0.31,
  "11240": 2.51,
  "11241": 0.21,
  "11242": 0.21,
  "11243": 4.1,
  "11247": 0.21,
  "11249": 27.66,
  "11252": 3.58,
  "11256": 10.27,
  "11351": 11.71,
  "11352": 10.79,
  "11354": 10.27,
  "11355": 10.79,
  "11356": 11.71,
  "11357": 13.09,
  "11358": 13.09,
  "11359": 10.79,
  "11360": 10.79,
  "11361": 13.09,
  "11362": 10.79,
  "11363": 13.09,
  "11364": 10.79,
  "11365": 13.09,
  "11366": 13.09,
  "11367": 10.79,
  "11368": 10.79,
  "11369": 10.27,
  "11370": 31.03,
  "11371": 10.79,
  "11372": 10.27,
  "11373": 10.79,
  "11374": 10.27,
  "11375": 10.27,
  "11377": 28.73,
  "11378": 10.79,
  "11379": 13.09,
  "11380": 10.27,
  "11385": 10.79,
  "11386": 10.79,
  "11411": 10.27,
  "11412": 10.27,
  "11413": 10.27,
  "11414": 13.09,
  "11415": 10.79,
  "11416": 10.79,
  "11417": 10.79,
  "11418": 10.79,
  "11419": 10.79,
  "11420": 10.27,
  "11421": 10.27,
  "11422": 10.79,
  "11423": 10.79,
  "11424": 10.79,
  "11426": 10.79,
  "11427": 10.79,
  "11428": 10.27,
  "11429": 10.27,
  "11430": 10.27,
  "11431": 10.79,
  "11432": 10.79,
  "11433": 10.27,
  "11434": 10.27,
  "11435": 10.27,
  "11436": 10.27,
  "11501": 9.87,
  "11507": 12.17,
  "11509": 14.68,
  "11510": 9.87,
  "11514": 9.87,
  "11516": 13.09,
  "11518": 9.87,
  "11520": 9.35,
  "11530": 9.87,
  "11531": 13.76,
  "11542": 9.87,
  "11545": 12.17,
  "11547": 12.17,
  "11548": 13.76,
  "11550": 9.35,
  "11551": 9.35,
  "11552": 9.87,
  "11553": 9.35,
  "11554": 9.87,
  "11556": 9.35,
  "11557": 12.17,
  "11558": 9.87,
  "11559": 21.58,
  "11560": 12.17,
  "11561": 9.87,
  "11563": 9.87,
  "11565": 9.87,
  "11566": 12.17,
  "11568": 20.66,
  "11569": 13.76,
  "11570": 12.17,
  "11571": 12.17,
  "11572": 12.17,
  "11575": 9.35,
  "11576": 12.17,
  "11577": 13.76,
  "11579": 12.17,
  "11580": 9.87,
  "11581": 10.79,
  "11582": 9.87,
  "11590": 9.87,
  "11596": 12.17,
  "11598": 13.09,
  "11599": 13.76,
  "11690": 10.79,
  "11691": 10.79,
  "11692": 10.27,
  "11693": -0.31,
  "11694": 2.51,
  "11695": 0.21,
  "11697": 0.21,
  "11701": 9.35,
  "11702": 9.87,
  "11703": 9.35,
  "11704": 9.35,
  "11705": 8.34,
  "11706": 11.71,
  "11707": 9.87,
  "11708": 9.35,
  "11709": 12.17,
  "11710": 9.87,
  "11713": 8.34,
  "11714": 9.87,
  "11715": 8.34,
  "11716": 8.89,
  "11717": 8.89,
  "11718": 9.41,
  "11719": 8.34,
  "11720": 8.34,
  "11721": 12.17,
  "11722": 8.89,
  "11724": 12.17,
  "11725": 9.41,
  "11726": 9.35,
  "11727": 8.34,
  "11729": 9.35,
  "11730": 8.89,
  "11731": 9.41,
  "11732": 12.17,
  "11733": 10.64,
  "11735": 9.35,
  "11737": 9.35,
  "11738": 8.34,
  "11739": 8.89,
  "11740": 9.87,
  "11741": 8.34,
  "11742": 8.34,
  "11743": 12.17,
  "11746": 9.87,
  "11747": 12.17,
  "11749": 9.41,
  "11751": 8.89,
  "11752": 8.89,
  "11753": 12.17,
  "11754": 9.41,
  "11755": 8.34,
  "11756": 9.35,
  "11757": 9.35,
  "11758": 9.87,
  "11760": 9.41,
  "11762": 9.87,
  "11763": 8.34,
  "11764": 8.34,
  "11765": 20.66,
  "11766": 8.34,
  "11767": 9.41,
  "11768": 11.71,
  "11769": 9.41,
  "11770": 11.71,
  "11771": 12.17,
  "11772": 8.34,
  "11776": 8.34,
  "11777": 8.34,
  "11778": 8.34,
  "11779": 8.89,
  "11780": 9.41,
  "11782": 9.41,
  "11783": 9.87,
  "11784": 8.34,
  "11786": 8.34,
  "11787": 9.41,
  "11788": 9.41,
  "11789": 8.34,
  "11790": 8.34,
  "11791": 12.17,
  "11792": 8.34,
  "11793": 9.87,
  "11795": 9.87,
  "11796": 8.89,
  "11797": 12.17,
  "11798": 9.35,
  "11801": 9.87,
  "11802": 9.87,
  "11803": 12.17,
  "11804": 9.87,
  "11901": 7.82,
  "11930": 4.66,
  "11931": 8.34,
  "11932": 12.63,
  "11933": 7.82,
  "11934": 8.34,
  "11935": 7.82,
  "11937": 1.84,
  "11939": 1.84,
  "11940": 8.34,
  "11941": 8.34,
  "11942": 8.34,
  "11944": 1.84,
  "11946": 10.64,
  "11947": 8.34,
  "11948": 8.34,
  "11949": 8.34,
  "11950": 7.82,
  "11951": 7.82,
  "11952": 8.34,
  "11953": 7.82,
  "11954": 4.66,
  "11955": 8.34,
  "11956": 7.82,
  "11957": 4.14,
  "11958": 7.82,
  "11959": 19.13,
  "11960": 8.34,
  "11961": 7.82,
  "11962": 12.63,
  "11963": 4.66,
  "11964": 1.84,
  "11965": 4.66,
  "11967": 7.82,
  "11968": 10.64,
  "11969": 4.66,
  "11970": 8.34,
  "11971": 1.84,
  "11972": 8.34,
  "11973": 7.82,
  "11975": 12.63,
  "11976": 18.61,
  "11977": 10.64,
  "11978": 10.64,
  "11980": 7.82,
  "12007": -10.12,
  "12008": -1.07,
  "12009": 6.9,
  "12010": -11.71,
  "12015": -4.6,
  "12016": -11.71,
  "12017": -4.6,
  "12018": 8.43,
  "12019": 0,
  "12020": 11.65,
  "12022": 6.84,
  "12023": 4.45,
  "12024": 3.89,
  "12025": -4.54,
  "12027": 0,
  "12028": 6.84,
  "12029": 1.38,
  "12031": -11.71,
  "12032": -4.54,
  "12033": 13.34,
  "12035": 3.93,
  "12036": 3.93,
  "12037": -4.6,
  "12040": 6.84,
  "12041": 13.34,
  "12042": -10.12,
  "12043": 4.45,
  "12045": 13.34,
  "12046": -10.12,
  "12047": 6.84,
  "12050": -4.6,
  "12051": -10.12,
  "12052": 6.84,
  "12053": -1.07,
  "12054": 14.93,
  "12055": -10.12,
  "12056": -1.07,
  "12057": 6.84,
  "12058": -10.12,
  "12059": 12.27,
  "12060": -4.6,
  "12061": 7.88,
  "12062": 7.36,
  "12063": 7.36,
  "12064": 3.93,
  "12065": 7.42,
  "12066": -11.71,
  "12067": 13.34,
  "12068": -11.71,
  "12069": -11.71,
  "12070": -11.71,
  "12071": 4.45,
  "12072": -11.71,
  "12073": 4.45,
  "12074": 11.65,
  "12075": -4.6,
  "12076": 3.93,
  "12077": 21.83,
  "12078": -6.65,
  "12082": 6.84,
  "12083": -10.12,
  "12084": 21.83,
  "12085": 6.9,
  "12086": -6.13,
  "12087": -9.6,
  "12089": 6.84,
  "12090": 6.84,
  "12092": 3.93,
  "12093": 3.93,
  "12094": 6.84,
  "12095": -6.65,
  "12106": -3.01,
  "12107": 4.45,
  "12108": -19.01,
  "12110": 21.31,
  "12115": 3.89,
  "12116": -8.55,
  "12117": -4.54,
  "12118": 11.1,
  "12120": -10.12,
  "12121": 6.84,
  "12122": 3.93,
  "12123": 7.36,
  "12124": 13.34,
  "12125": 1.38,
  "12128": 21.83,
  "12130": -4.6,
  "12131": 3.93,
  "12132": -4.6,
  "12133": 6.84,
  "12134": -4.54,
  "12136": 3.89,
  "12137": -1.07,
  "12138": 6.84,
  "12139": -18.46,
  "12140": 6.84,
  "12141": -1.07,
  "12143": 13.34,
  "12144": 13.34,
  "12147": 5.52,
  "12148": 7.42,
  "12149": 3.93,
  "12150": -1.07,
  "12151": 11.65,
  "12153": 6.84,
  "12154": 10.06,
  "12155": -8.55,
  "12156": 13.86,
  "12157": 4.45,
  "12158": 13.34,
  "12159": 21.83,
  "12160": 4.45,
  "12161": 13.34,
  "12164": -19.01,
  "12165": -4.6,
  "12166": -11.71,
  "12167": 3.93,
  "12168": 7.36,
  "12169": 6.84,
  "12170": 11.1,
  "12172": -4.6,
  "12173": -4.6,
  "12174": -4.6,
  "12175": 4.45,
  "12176": -10.12,
  "12177": -11.71,
  "12180": 6.84,
  "12181": 6.84,
  "12182": 6.84,
  "12183": 6.84,
  "12184": -4.6,
  "12185": 6.84,
  "12186": 13.86,
  "12187": 3.93,
  "12188": 6.84,
  "12189": 6.84,
  "12190": -19.01,
  "12192": -10.12,
  "12193": 13.34,
  "12194": 4.45,
  "12195": 1.38,
  "12196": 15.33,
  "12197": 3.93,
  "12198": 7.36,
  "12201": 13.34,
  "12202": 13.34,
  "12203": 13.34,
  "12204": 13.34,
  "12205": 13.34,
  "12206": 13.34,
  "12207": 13.34,
  "12208": 13.34,
  "12209": 13.34,
  "12210": 13.34,
  "12211": 21.83,
  "12212": 13.34,
  "12220": 21.83,
  "12223": 13.34,
  "12224": 13.34,
  "12225": 13.34,
  "12226": 13.34,
  "12247": 13.34,
  "12260": 13.34,
  "12301": -1.07,
  "12302": -1.07,
  "12303": -1.07,
  "12304": -1.59,
  "12305": -1.07,
  "12306": -1.07,
  "12307": -1.59,
  "12308": -1.59,
  "12309": 7.42,
  "12325": -1.07,
  "12401": 1.84,
  "12402": 1.84,
  "12404": 2.36,
  "12405": -10.12,
  "12406": 3.68,
  "12407": -10.12,
  "12409": 2.36,
  "12410": 1.84,
  "12411": 1.84,
  "12412": 2.36,
  "12413": -10.12,
  "12414": -10.12,
  "12416": 2.36,
  "12417": 1.84,
  "12418": -10.12,
  "12419": 1.84,
  "12420": 1.84,
  "12421": 3.68,
  "12422": -10.12,
  "12423": -10.12,
  "12424": -9.6,
  "12427": -10.12,
  "12428": 18.34,
  "12429": 1.84,
  "12430": 3.68,
  "12431": -10.12,
  "12432": 1.84,
  "12433": 2.36,
  "12434": 5.52,
  "12435": 18.86,
  "12436": -10.12,
  "12438": 3.68,
  "12439": -9.6,
  "12440": 2.36,
  "12441": 1.84,
  "12442": -9.6,
  "12443": 2.36,
  "12444": -10.12,
  "12446": 1.84,
  "12448": 2.36,
  "12449": 1.84,
  "12450": -10.12,
  "12451": -10.12,
  "12452": -10.12,
  "12453": -10.12,
  "12454": -10.12,
  "12455": 3.68,
  "12456": 1.84,
  "12457": 2.36,
  "12458": 1.84,
  "12459": 4.2,
  "12460": -10.12,
  "12461": 2.36,
  "12463": -10.12,
  "12464": 2.36,
  "12465": 1.84,
  "12466": 1.84,
  "12468": -10.12,
  "12469": -10.12,
  "12470": -10.12,
  "12471": 1.84,
  "12472": 1.84,
  "12473": -10.12,
  "12474": 3.68,
  "12475": 1.84,
  "12477": -10.12,
  "12480": -10.12,
  "12481": 1.84,
  "12482": -10.12,
  "12483": 1.84,
  "12484": 2.36,
  "12485": -10.12,
  "12486": 1.84,
  "12487": 1.84,
  "12489": 1.84,
  "12490": -10.12,
  "12491": 1.84,
  "12492": -10.12,
  "12493": 2.36,
  "12494": 2.36,
  "12495": 2.36,
  "12496": -9.6,
  "12498": 2.36,
  "12501": 7.42,
  "12502": -4.08,
  "12503": -4.08,
  "12504": 13.15,
  "12506": 7.42,
  "12507": 2.36,
  "12508": 4.6,
  "12510": 7.42,
  "12511": 4.6,
  "12512": 4.6,
  "12513": -4.6,
  "12514": 7.42,
  "12515": 2.36,
  "12516": -4.6,
  "12517": -4.6,
  "12518": 0,
  "12520": 0,
  "12521": -4.6,
  "12522": 7.42,
  "12523": -4.08,
  "12524": 4.6,
  "12525": 2.36,
  "12526": -4.08,
  "12527": 4.6,
  "12528": 7.42,
  "12529": -4.6,
  "12530": -4.6,
  "12531": 5.67,
  "12533": 7.42,
  "12534": -4.6,
  "12537": 7.42,
  "12538": 7.42,
  "12540": 7.42,
  "12541": -4.08,
  "12542": 6.9,
  "12543": -0.52,
  "12544": -5.12,
  "12545": 7.42,
  "12546": -4.08,
  "12547": 7.42,
  "12548": 2.36,
  "12549": 0,
  "12550": 0,
  "12551": 0,
  "12552": 0,
  "12553": 0,
  "12555": 0,
  "12561": 2.36,
  "12563": 5.67,
  "12564": 5.67,
  "12565": -5.12,
  "12566": 0,
  "12567": -4.08,
  "12568": 6.9,
  "12569": 7.42,
  "12570": 7.42,
  "12571": 2.36,
  "12572": 2.36,
  "12574": 1.84,
  "12575": 0,
  "12577": 0,
  "12578": 7.42,
  "12580": 7.42,
  "12581": 7.42,
  "12582": 5.12,
  "12583": -9.6,
  "12584": 0,
  "12585": 7.42,
  "12586": 0,
  "12588": 1.84,
  "12589": 0,
  "12590": 7.42,
  "12592": 7.42,
  "12593": -4.6,
  "12594": 7.97,
  "12601": 7.42,
  "12602": 7.42,
  "12603": 7.42,
  "12701": 18.34,
  "12719": -12.02,
  "12720": 18.34,
  "12721": -0.52,
  "12722": 18.86,
  "12723": 17.79,
  "12724": 18.34,
  "12725": 18.86,
  "12726": 18.34,
  "12727": 17.79,
  "12729": -0.52,
  "12732": 17.79,
  "12733": 18.34,
  "12734": 18.34,
  "12736": 18.34,
  "12737": 18.34,
  "12738": 18.34,
  "12740": 19.38,
  "12741": 17.79,
  "12742": 18.34,
  "12743": 18.86,
  "12745": 17.79,
  "12746": -0.52,
  "12747": 18.34,
  "12748": 18.34,
  "12749": 18.34,
  "12750": 17.79,
  "12751": 18.34,
  "12752": 17.79,
  "12754": 18.34,
  "12758": 18.86,
  "12759": 18.34,
  "12760": 17.79,
  "12762": 18.34,
  "12763": 18.34,
  "12764": 17.79,
  "12765": 18.86,
  "12766": 17.79,
  "12767": 18.34,
  "12768": 19.38,
  "12769": 1.84,
  "12770": 18.34,
  "12771": -0.52,
  "12775": 18.34,
  "12776": 2.09,
  "12777": 18.34,
  "12778": 18.34,
  "12779": 18.34,
  "12780": 18.34,
  "12781": 18.34,
  "12783": 18.34,
  "12784": 29.65,
  "12785": 18.34,
  "12786": 18.34,
  "12787": 18.34,
  "12788": 18.86,
  "12789": 18.34,
  "12790": 18.34,
  "12791": 17.79,
  "12792": -12.57,
  "12801": 1.69,
  "12803": 1.69,
  "12804": -0.52,
  "12808": -0.52,
  "12809": 1.69,
  "12810": -1.07,
  "12811": -1.07,
  "12812": -19.01,
  "12814": -0.52,
  "12815": -1.07,
  "12816": 3.28,
  "12817": -1.07,
  "12819": 10.27,
  "12820": 7.97,
  "12821": 1.69,
  "12822": 9.51,
  "12823": 2.24,
  "12824": -0.52,
  "12827": 1.69,
  "12828": 1.69,
  "12831": 11.65,
  "12832": 1.69,
  "12833": 11.65,
  "12834": 3.83,
  "12835": -1.07,
  "12836": -1.07,
  "12837": 1.69,
  "12838": 1.69,
  "12839": 1.69,
  "12841": 10.27,
  "12842": -19.01,
  "12843": -1.07,
  "12844": 7.97,
  "12845": -0.52,
  "12846": -1.07,
  "12847": -19.01,
  "12848": 3.83,
  "12849": 1.69,
  "12850": 11.65,
  "12851": -1.07,
  "12852": 11.81,
  "12853": -1.07,
  "12854": 1.69,
  "12855": 13.4,
  "12856": -18.46,
  "12857": -1.07,
  "12858": 11.81,
  "12859": 11.1,
  "12860": -1.07,
  "12861": -1.07,
  "12862": -1.07,
  "12863": 11.65,
  "12864": -19.01,
  "12865": 1.69,
  "12866": 20.14,
  "12870": 11.81,
  "12871": 11.1,
  "12872": 11.81,
  "12873": 1.69,
  "12874": 10.27,
  "12878": -1.07,
  "12879": 11.81,
  "12883": 11.81,
  "12884": 11.1,
  "12885": -1.07,
  "12886": -1.07,
  "12887": 1.69,
  "12901": -2.24,
  "12903": -2.24,
  "12910": -2.24,
  "12911": -2.24,
  "12912": -2.24,
  "12913": -6.38,
  "12914": -6.38,
  "12915": -6.38,
  "12916": -6.38,
  "12917": -6.38,
  "12918": -2.24,
  "12919": -7.3,
  "12920": -6.38,
  "12921": -7.3,
  "12922": -2.97,
  "12923": -2.24,
  "12924": 4.66,
  "12926": -6.38,
  "12927": -1.38,
  "12928": -4.08,
  "12929": -2.24,
  "12930": -6.38,
  "12932": 13.4,
  "12933": -2.24,
  "12934": -2.24,
  "12935": -2.24,
  "12936": 13.4,
  "12937": -6.38,
  "12939": -6.38,
  "12941": 13.4,
  "12942": 13.95,
  "12943": 13.95,
  "12944": 4.66,
  "12945": -6.38,
  "12946": 13.95,
  "12949": -6.38,
  "12950": 13.4,
  "12952": -2.24,
  "12953": -6.38,
  "12955": -2.24,
  "12956": 13.4,
  "12957": -6.38,
  "12958": -2.24,
  "12959": -2.24,
  "12960": 13.4,
  "12961": 13.4,
  "12962": -2.24,
  "12964": 13.95,
  "12965": -6.38,
  "12966": -6.38,
  "12967": -6.38,
  "12969": -6.38,
  "12970": -6.38,
  "12972": -2.24,
  "12973": -6.38,
  "12974": -4.08,
  "12975": -2.24,
  "12976": -6.38,
  "12977": -6.38,
  "12978": -2.24,
  "12979": -7.3,
  "12980": -6.38,
  "12981": -2.24,
  "12983": -6.38,
  "12985": -2.24,
  "12986": -6.38,
  "12987": 13.4,
  "12989": -6.38,
  "12992": -2.24,
  "12993": 13.4,
  "12995": -6.38,
  "12996": 4.66,
  "12997": 13.4,
  "12998": 13.4,
  "13020": -0.61,
  "13021": 2.09,
  "13022": 2.09,
  "13026": -2.51,
  "13027": 6.29,
  "13028": -2.97,
  "13029": 6.29,
  "13030": 5.77,
  "13031": 6.29,
  "13032": -4.81,
  "13033": 2.09,
  "13034": 2.09,
  "13035": 3.68,
  "13036": -2.97,
  "13037": -4.81,
  "13039": 6.29,
  "13040": -1.65,
  "13041": 6.29,
  "13042": 5.77,
  "13043": -4.81,
  "13044": -2.97,
  "13045": -1.13,
  "13051": -4.29,
  "13052": -1.13,
  "13053": -6.65,
  "13054": -2.51,
  "13056": -1.13,
  "13057": 5.77,
  "13060": 2.09,
  "13061": -4.29,
  "13062": -6.65,
  "13063": -4.29,
  "13064": -3.49,
  "13065": -2.51,
  "13066": 14.26,
  "13068": -6.65,
  "13069": -2.97,
  "13071": -7.17,
  "13072": -4.81,
  "13073": -6.65,
  "13074": -3.49,
  "13076": -2.97,
  "13077": -1.13,
  "13078": 14.26,
  "13080": 2.09,
  "13081": -2.51,
  "13082": 5.77,
  "13083": -2.97,
  "13084": 6.29,
  "13087": -1.13,
  "13088": 5.77,
  "13089": 6.29,
  "13090": 6.29,
  "13092": -6.65,
  "13093": -2.97,
  "13101": -1.13,
  "13102": -6.65,
  "13103": -2.97,
  "13104": 14.26,
  "13107": -2.97,
  "13108": 6.29,
  "13110": 6.29,
  "13111": -3.49,
  "13112": 5.77,
  "13113": 2.09,
  "13114": -2.97,
  "13115": -2.97,
  "13116": 5.77,
  "13117": 1.57,
  "13118": 2.09,
  "13119": 2.09,
  "13120": 6.29,
  "13121": -2.97,
  "13122": -4.29,
  "13123": -2.51,
  "13124": -1.13,
  "13126": -2.97,
  "13131": -2.97,
  "13132": -2.97,
  "13134": -4.81,
  "13135": -2.97,
  "13136": -1.13,
  "13137": 5.77,
  "13138": -4.29,
  "13139": 2.09,
  "13140": 1.57,
  "13141": -1.13,
  "13142": -2.97,
  "13143": -6.71,
  "13144": -3.49,
  "13145": -2.97,
  "13146": 1.57,
  "13147": 2.09,
  "13148": -2.51,
  "13152": 10.58,
  "13153": 2.09,
  "13154": 1.57,
  "13155": -8.49,
  "13156": -3.49,
  "13157": -2.51,
  "13158": -1.13,
  "13159": -0.61,
  "13160": -2.51,
  "13162": -2.51,
  "13163": -4.81,
  "13164": 6.29,
  "13165": -3.03,
  "13166": 2.09,
  "13167": -2.97,
  "13201": 5.77,
  "13202": 5.77,
  "13203": 5.77,
  "13204": 5.77,
  "13205": 5.77,
  "13206": 5.77,
  "13207": 5.77,
  "13208": 5.77,
  "13209": 5.77,
  "13210": 5.77,
  "13211": 5.77,
  "13212": 5.77,
  "13214": 6.29,
  "13215": 14.26,
  "13217": 5.77,
  "13218": 5.77,
  "13219": 6.29,
  "13220": 5.77,
  "13221": 5.77,
  "13224": 6.29,
  "13235": 5.77,
  "13261": 5.77,
  "13290": 5.77,
  "13301": -3.03,
  "13302": -3.49,
  "13303": -2.51,
  "13304": 4.08,
  "13305": -7.57,
  "13308": -2.51,
  "13309": -7.57,
  "13310": -5.33,
  "13312": -7.57,
  "13313": -8.55,
  "13314": -5.33,
  "13315": -8.55,
  "13316": -2.51,
  "13317": -11.71,
  "13318": -3.03,
  "13319": -3.03,
  "13320": 3.93,
  "13321": -2.51,
  "13322": -3.03,
  "13323": -2.51,
  "13324": 2.49,
  "13325": -7.57,
  "13326": -0.06,
  "13327": -7.57,
  "13328": -5.33,
  "13329": 2.49,
  "13331": -11.04,
  "13332": -5.33,
  "13333": -8.55,
  "13334": -5.33,
  "13335": -8.55,
  "13337": -0.06,
  "13338": -3.03,
  "13339": -11.71,
  "13340": 2.49,
  "13341": -2.51,
  "13342": -8.03,
  "13343": -7.57,
  "13345": -7.57,
  "13346": -3.74,
  "13348": -8.03,
  "13350": 2.49,
  "13352": 4.08,
  "13353": -19.53,
  "13354": -2.51,
  "13355": -5.33,
  "13357": 2.49,
  "13360": -11.04,
  "13361": -0.06,
  "13362": -5.33,
  "13363": -2.51,
  "13364": -5.33,
  "13365": 2.49,
  "13367": -7.57,
  "13368": -8.09,
  "13401": -2.51,
  "13402": -5.33,
  "13403": -2.51,
  "13404": -7.57,
  "13406": 2.49,
  "13407": 2.49,
  "13408": -4.81,
  "13409": -4.81,
  "13410": -12.23,
  "13411": -8.55,
  "13413": -1.44,
  "13415": -8.03,
  "13416": 2.49,
  "13417": -3.03,
  "13418": -5.33,
  "13420": -11.04,
  "13421": -4.81,
  "13424": -2.51,
  "13425": -5.33,
  "13426": -3.49,
  "13428": -11.71,
  "13431": 3.01,
  "13433": -8.09,
  "13435": 3.01,
  "13436": -11.56,
  "13437": -8.09,
  "13438": 3.01,
  "13439": -8.55,
  "13440": -2.51,
  "13441": -2.51,
  "13442": -2.51,
  "13450": -8.55,
  "13452": -12.23,
  "13454": 2.49,
  "13455": -5.33,
  "13456": -2.51,
  "13457": -0.06,
  "13459": 3.93,
  "13460": -9.01,
  "13461": -3.22,
  "13464": -9.01,
  "13465": -5.33,
  "13468": -8.55,
  "13469": -2.51,
  "13470": 2.49,
  "13471": -3.03,
  "13472": -11.04,
  "13473": -7.57,
  "13475": -0.06,
  "13476": -2.51,
  "13477": -4.81,
  "13478": -2.51,
  "13479": -1.44,
  "13480": -5.33,
  "13482": -8.55,
  "13483": -3.49,
  "13484": -5.33,
  "13485": -8.55,
  "13486": -2.51,
  "13488": -8.55,
  "13489": -2.51,
  "13490": -2.51,
  "13491": -8.55,
  "13492": -2.51,
  "13493": -3.49,
  "13494": -2.51,
  "13495": -3.03,
  "13501": -3.03,
  "13502": -3.03,
  "13503": -3.03,
  "13504": -3.03,
  "13505": -3.03,
  "13601": -2.97,
  "13602": -2.97,
  "13603": -3.49,
  "13605": -2.97,
  "13606": -2.97,
  "13607": -2.97,
  "13608": -3.49,
  "13611": -2.97,
  "13612": -2.97,
  "13613": -0.86,
  "13614": -3.49,
  "13615": -2.97,
  "13616": -2.97,
  "13617": -0.86,
  "13618": -2.97,
  "13619": -2.97,
  "13620": -7.57,
  "13621": -0.86,
  "13622": -2.97,
  "13623": -3.49,
  "13624": -2.97,
  "13625": -0.86,
  "13626": -7.57,
  "13627": -2.97,
  "13628": -2.97,
  "13630": -3.49,
  "13631": -2.97,
  "13632": -2.97,
  "13633": -3.49,
  "13634": -2.97,
  "13635": -3.49,
  "13636": -2.97,
  "13637": -2.97,
  "13638": -2.97,
  "13639": -3.49,
  "13640": 5.52,
  "13641": 5.52,
  "13642": -3.49,
  "13643": -2.97,
  "13645": -3.49,
  "13646": -3.49,
  "13647": -0.86,
  "13648": -8.09,
  "13649": -0.86,
  "13650": -2.97,
  "13651": -2.97,
  "13652": -3.49,
  "13654": -3.49,
  "13655": -6.38,
  "13656": -3.49,
  "13657": -2.97,
  "13658": -0.86,
  "13659": -3.49,
  "13660": -0.86,
  "13661": -2.97,
  "13662": -0.86,
  "13664": -3.49,
  "13665": -8.09,
  "13666": -3.49,
  "13667": -0.86,
  "13668": -0.86,
  "13669": -3.49,
  "13670": -3.49,
  "13671": -3.49,
  "13672": -0.86,
  "13673": -2.97,
  "13674": -2.97,
  "13675": -2.97,
  "13676": -0.86,
  "13677": -0.86,
  "13678": -0.86,
  "13679": -2.97,
  "13680": -3.49,
  "13681": -3.49,
  "13682": -2.97,
  "13683": -6.38,
  "13684": -3.49,
  "13685": -2.97,
  "13687": -0.86,
  "13690": -3.49,
  "13691": -3.49,
  "13692": 5.52,
  "13693": -2.97,
  "13694": -0.86,
  "13695": -3.49,
  "13696": -0.86,
  "13697": -0.86,
  "13730": -9.01,
  "13731": 3.68,
  "13732": -8.03,
  "13733": -9.01,
  "13734": -8.55,
  "13736": -8.03,
  "13737": -8.03,
  "13738": -1.13,
  "13739": 2.09,
  "13740": 2.61,
  "13743": -8.55,
  "13744": 5.77,
  "13745": 5.77,
  "13746": 5.77,
  "13747": -8.55,
  "13748": 5.77,
  "13749": 5.77,
  "13750": -8.55,
  "13751": 1.57,
  "13752": 2.09,
  "13753": 2.09,
  "13754": 5.77,
  "13755": 1.57,
  "13756": 1.57,
  "13757": 1.57,
  "13758": -9.01,
  "13760": 5.77,
  "13761": 5.77,
  "13762": 5.77,
  "13763": 5.77,
  "13774": 1.57,
  "13775": 2.09,
  "13776": -8.49,
  "13777": 5.25,
  "13778": -8.49,
  "13780": -9.01,
  "13782": 2.09,
  "13783": 1.57,
  "13784": -1.65,
  "13786": 3.93,
  "13787": 5.25,
  "13788": 2.09,
  "13790": 5.77,
  "13794": -1.65,
  "13795": 5.77,
  "13796": -8.55,
  "13797": 5.25,
  "13801": -9.01,
  "13802": 5.77,
  "13803": -1.65,
  "13804": 2.09,
  "13806": 1.57,
  "13807": -8.55,
  "13808": -8.55,
  "13809": -9.01,
  "13810": -8.03,
  "13811": -8.03,
  "13812": -8.55,
  "13813": 5.77,
  "13814": -9.01,
  "13815": -9.01,
  "13820": -8.55,
  "13825": -8.03,
  "13826": 5.77,
  "13827": -8.03,
  "13830": -9.01,
  "13832": -8.49,
  "13833": 5.77,
  "13834": -8.55,
  "13835": -1.65,
  "13837": 1.57,
  "13838": -9.01,
  "13839": 2.09,
  "13840": -8.55,
  "13841": -9.01,
  "13842": 2.61,
  "13843": -9.01,
  "13844": -9.01,
  "13845": -8.55,
  "13846": 2.09,
  "13847": 1.57,
  "13848": 5.77,
  "13849": -8.49,
  "13850": 5.77,
  "13851": 5.77,
  "13856": 1.57,
  "13859": 1.57,
  "13860": 1.57,
  "13861": -8.03,
  "13862": 5.77,
  "13863": -1.65,
  "13864": -9.1,
  "13865": 5.77,
  "13901": 5.77,
  "13902": 5.77,
  "13903": 5.77,
  "13904": 5.77,
  "13905": 5.77,
  "14001": -5.73,
  "14004": 3.01,
  "14005": -6.25,
  "14006": 2.49,
  "14008": -3.95,
  "14009": -11.31,
  "14010": 2.49,
  "14011": -11.31,
  "14012": -4.41,
  "14013": -6.25,
  "14020": -6.25,
  "14021": -6.25,
  "14024": -11.31,
  "14025": 3.01,
  "14026": 3.01,
  "14027": 2.49,
  "14028": -3.95,
  "14029": -11.31,
  "14030": -11.31,
  "14031": 10.98,
  "14032": 10.98,
  "14033": 3.01,
  "14034": -0.27,
  "14035": -0.27,
  "14036": -6.25,
  "14037": -11.31,
  "14038": 3.01,
  "14039": -11.31,
  "14040": -5.73,
  "14041": -0.27,
  "14042": -0.27,
  "14043": 2.49,
  "14047": 2.49,
  "14048": -7.63,
  "14051": 4.54,
  "14052": 4.08,
  "14054": -5.73,
  "14055": 0.25,
  "14056": -6.25,
  "14057": 3.01,
  "14058": -6.25,
  "14059": 10.98,
  "14060": -11.31,
  "14061": 2.49,
  "14062": -7.63,
  "14063": 0.86,
  "14065": -11.31,
  "14066": -11.31,
  "14067": -3.95,
  "14068": 4.54,
  "14069": 3.01,
  "14070": -0.27,
  "14072": 4.54,
  "14075": 3.01,
  "14080": -10.79,
  "14081": 2.49,
  "14082": -10.79,
  "14083": -11.31,
  "14085": 3.01,
  "14086": 3.01,
  "14091": 2.49,
  "14092": -3.43,
  "14094": -3.95,
  "14095": -3.95,
  "14098": -4.41,
  "14101": -0.27,
  "14102": 3.01,
  "14103": -4.41,
  "14105": -4.41,
  "14107": -3.43,
  "14108": -3.95,
  "14109": -3.95,
  "14110": 3.01,
  "14111": 2.49,
  "14112": 2.49,
  "14113": -11.31,
  "14120": -3.43,
  "14125": -6.25,
  "14126": -3.95,
  "14127": 10.98,
  "14129": -7.63,
  "14130": -11.31,
  "14131": -3.43,
  "14132": -3.43,
  "14133": -11.31,
  "14134": -11.31,
  "14135": -7.63,
  "14136": -7.63,
  "14138": -7.63,
  "14139": 3.01,
  "14140": 10.98,
  "14141": -0.27,
  "14143": -5.73,
  "14144": -3.43,
  "14145": -10.79,
  "14150": -3.95,
  "14151": -3.95,
  "14166": -7.63,
  "14167": -11.31,
  "14168": -7.63,
  "14169": 3.01,
  "14170": 3.01,
  "14171": -0.27,
  "14172": -3.43,
  "14173": -11.31,
  "14174": -3.43,
  "14201": 2.49,
  "14202": 10.98,
  "14203": 2.49,
  "14204": 2.49,
  "14205": 10.98,
  "14206": 2.49,
  "14207": 2.49,
  "14208": 2.49,
  "14209": 2.49,
  "14210": 2.49,
  "14211": 2.49,
  "14212": 2.49,
  "14213": 2.49,
  "14214": 2.49,
  "14215": 2.49,
  "14216": 2.49,
  "14217": 2.49,
  "14218": 3.01,
  "14219": 2.49,
  "14220": 2.49,
  "14221": 3.01,
  "14222": 3.01,
  "14223": 2.49,
  "14224": 3.01,
  "14225": 2.49,
  "14226": 3.01,
  "14227": 2.49,
  "14228": -3.43,
  "14231": 3.01,
  "14240": 2.49,
  "14280": 10.98,
  "14301": -3.95,
  "14302": -3.95,
  "14303": -3.95,
  "14304": -3.95,
  "14305": -3.95,
  "14410": 1.17,
  "14411": -4.41,
  "14413": -6.71,
  "14414": 5.77,
  "14415": -7.17,
  "14416": -5.73,
  "14418": -6.65,
  "14420": -3.89,
  "14422": -5.73,
  "14423": 5.77,
  "14424": 9.45,
  "14425": 9.45,
  "14427": -11.31,
  "14428": 1.17,
  "14429": -4.41,
  "14430": -3.89,
  "14432": 8.93,
  "14433": -6.71,
  "14435": 5.77,
  "14437": 5.25,
  "14441": -7.17,
  "14443": 9.45,
  "14445": 0.65,
  "14449": -6.19,
  "14450": 9.66,
  "14452": -4.41,
  "14453": 9.66,
  "14454": 5.77,
  "14456": -2.51,
  "14461": 9.45,
  "14462": 5.77,
  "14463": 9.45,
  "14464": -3.89,
  "14466": 5.77,
  "14467": 1.17,
  "14468": 1.17,
  "14469": 9.45,
  "14470": -4.41,
  "14471": 5.77,
  "14472": 9.66,
  "14475": 9.45,
  "14476": -3.89,
  "14477": -3.89,
  "14478": 1.84,
  "14479": -4.41,
  "14480": 5.77,
  "14481": 5.25,
  "14482": -5.73,
  "14485": 5.77,
  "14486": 5.77,
  "14487": 5.77,
  "14488": 5.77,
  "14489": -6.71,
  "14502": -6.19,
  "14504": 8.93,
  "14505": -6.19,
  "14506": 9.66,
  "14507": -7.17,
  "14508": -3.89,
  "14510": 5.25,
  "14511": 5.77,
  "14512": -6.65,
  "14513": -6.71,
  "14514": 1.17,
  "14515": 1.17,
  "14516": -6.19,
  "14517": 5.25,
  "14518": -6.19,
  "14519": -6.19,
  "14520": -6.19,
  "14521": -2.51,
  "14522": -6.19,
  "14525": -6.25,
  "14526": 2.76,
  "14527": -6.65,
  "14529": 5.25,
  "14530": -11.31,
  "14532": -6.19,
  "14533": 5.77,
  "14534": 9.66,
  "14536": -11.31,
  "14537": -6.71,
  "14538": -6.19,
  "14539": 5.77,
  "14541": -2.51,
  "14542": -6.19,
  "14543": 9.66,
  "14544": 9.45,
  "14545": 5.25,
  "14546": 1.17,
  "14547": 8.93,
  "14548": 8.93,
  "14549": -11.31,
  "14550": -11.31,
  "14551": -6.71,
  "14555": -6.19,
  "14556": 5.25,
  "14557": -5.73,
  "14558": 5.77,
  "14559": 1.17,
  "14560": 5.25,
  "14561": 9.45,
  "14563": -6.19,
  "14564": 17.94,
  "14568": -6.19,
  "14569": -11.31,
  "14571": -4.41,
  "14572": 5.25,
  "14580": 1.17,
  "14585": 8.93,
  "14586": 1.17,
  "14588": -2.51,
  "14589": -6.19,
  "14590": -6.71,
  "14591": -11.31,
  "14592": 5.77,
  "14602": 0.65,
  "14603": 9.66,
  "14604": 9.66,
  "14605": 0.65,
  "14606": 0.65,
  "14607": 2.76,
  "14608": 0.65,
  "14609": 0.65,
  "14610": 1.17,
  "14611": 0.65,
  "14612": 1.17,
  "14613": 0.65,
  "14614": 9.66,
  "14615": 0.65,
  "14616": 0.65,
  "14617": 0.65,
  "14618": 9.66,
  "14619": 0.65,
  "14620": 0.65,
  "14621": 0.65,
  "14622": 1.17,
  "14623": 1.17,
  "14624": 1.17,
  "14625": 2.76,
  "14626": 1.17,
  "14627": 0.65,
  "14692": 1.17,
  "14701": -7.63,
  "14702": -7.63,
  "14706": -0.27,
  "14707": -3.12,
  "14708": -3.12,
  "14709": -2.57,
  "14710": -7.63,
  "14711": -2.57,
  "14712": 0.86,
  "14714": -2.57,
  "14715": -3.12,
  "14716": -7.63,
  "14717": -2.57,
  "14718": -7.63,
  "14719": -0.27,
  "14720": 0.86,
  "14721": -3.12,
  "14722": -7.63,
  "14723": -7.63,
  "14724": -6.71,
  "14726": -7.63,
  "14727": -2.57,
  "14728": 0.86,
  "14729": -0.27,
  "14730": -0.27,
  "14731": 8.22,
  "14732": -7.63,
  "14733": -7.63,
  "14735": -2.57,
  "14736": -6.19,
  "14737": -0.27,
  "14738": -7.63,
  "14739": -3.12,
  "14740": -7.63,
  "14741": -0.27,
  "14742": 0.86,
  "14743": -0.27,
  "14744": -2.57,
  "14745": -2.57,
  "14747": -7.63,
  "14748": -0.82,
  "14750": 0.86,
  "14751": -7.63,
  "14752": -7.63,
  "14753": -0.82,
  "14754": -3.12,
  "14755": -0.27,
  "14756": 0.86,
  "14757": -7.63,
  "14758": -7.63,
  "14760": -0.27,
  "14766": -0.27,
  "14767": -7.63,
  "14769": -7.63,
  "14770": -2.57,
  "14772": -0.27,
  "14774": -3.12,
  "14775": -7.63,
  "14777": -2.57,
  "14778": -0.27,
  "14779": -0.82,
  "14781": -7.63,
  "14782": -7.63,
  "14783": -0.27,
  "14784": -7.63,
  "14785": 0.86,
  "14786": -3.12,
  "14787": -7.63,
  "14788": -0.27,
  "14801": -13.61,
  "14802": -0.98,
  "14803": -0.98,
  "14804": -2.57,
  "14805": -1.65,
  "14806": -3.12,
  "14807": -13.61,
  "14808": 5.25,
  "14809": -13.61,
  "14810": -13.61,
  "14812": -2.2,
  "14813": -2.57,
  "14814": 8.22,
  "14815": -1.65,
  "14816": -0.27,
  "14817": -6.65,
  "14818": -1.65,
  "14819": -14.16,
  "14820": -13.61,
  "14821": -13.61,
  "14822": -2.57,
  "14823": -14.16,
  "14824": -0.27,
  "14825": -0.27,
  "14826": -13.61,
  "14827": -13.61,
  "14830": -0.27,
  "14836": 5.25,
  "14837": -7.17,
  "14838": -0.27,
  "14839": -14.16,
  "14840": -7.17,
  "14841": 6.84,
  "14842": -7.17,
  "14843": -14.16,
  "14845": 1.32,
  "14846": -11.31,
  "14847": -2.51,
  "14850": 1.32,
  "14851": 1.32,
  "14852": 1.32,
  "14853": 1.32,
  "14854": -6.65,
  "14855": -14.16,
  "14856": -13.61,
  "14857": 6.84,
  "14858": -0.27,
  "14859": -8.55,
  "14860": -7.17,
  "14861": -0.27,
  "14863": -6.65,
  "14864": -2.2,
  "14865": -1.65,
  "14867": -7.17,
  "14869": -1.65,
  "14870": -13.61,
  "14871": -0.27,
  "14872": -0.27,
  "14873": -7.17,
  "14874": -7.17,
  "14876": -1.65,
  "14877": -3.12,
  "14878": -1.65,
  "14879": -13.61,
  "14880": -3.12,
  "14881": 1.84,
  "14882": -6.65,
  "14883": -8.55,
  "14884": -2.57,
  "14885": -13.61,
  "14886": -6.65,
  "14887": -1.65,
  "14889": -0.27,
  "14891": -1.65,
  "14892": -8.55,
  "14893": -7.17,
  "14894": -0.27,
  "14895": -3.12,
  "14897": -3.12,
  "14898": -13.61,
  "14901": -0.82,
  "14902": -0.82,
  "14903": -0.27,
  "14904": -0.82,
  "14905": 1.32,
  "14925": -0.82,
  "15001": -1.65,
  "15003": -1.65,
  "15004": -6.13,
  "15005": -1.65,
  "15006": 3.41,
  "15007": 3.41,
  "15009": 7.36,
  "15010": -0.61,
  "15012": -8.64,
  "15014": 2.86,
  "15015": 6.84,
  "15017": 3.41,
  "15018": -2.2,
  "15019": -6.65,
  "15020": 1.02,
  "15021": -6.13,
  "15022": 1.57,
  "15024": 3.41,
  "15025": 3.41,
  "15026": -6.13,
  "15027": -1.65,
  "15028": -2.2,
  "15030": 2.86,
  "15031": 1.57,
  "15032": 3.41,
  "15033": 1.02,
  "15034": 2.86,
  "15035": 3.41,
  "15037": 3.41,
  "15038": 1.02,
  "15042": -1.65,
  "15043": 7.36,
  "15044": 10.31,
  "15045": 2.86,
  "15046": -1.65,
  "15047": 3.41,
  "15049": 3.41,
  "15050": -6.13,
  "15051": 3.41,
  "15052": -1.13,
  "15053": -6.65,
  "15054": -6.65,
  "15055": 1.57,
  "15056": -2.2,
  "15057": 1.57,
  "15059": -1.13,
  "15060": 2.09,
  "15061": -1.65,
  "15062": 1.02,
  "15063": 1.57,
  "15064": 2.86,
  "15065": -3.49,
  "15066": -1.65,
  "15067": 1.02,
  "15068": 3.41,
  "15071": 3.41,
  "15072": -8.64,
  "15074": -1.65,
  "15075": 3.41,
  "15076": 3.41,
  "15077": -1.13,
  "15078": -6.65,
  "15081": -1.65,
  "15082": 3.41,
  "15083": -1.65,
  "15084": 3.41,
  "15085": -1.65,
  "15086": 5.25,
  "15087": 1.02,
  "15088": 2.86,
  "15089": -1.65,
  "15090": 11.9,
  "15091": 3.41,
  "15095": 6.84,
  "15101": 3.41,
  "15102": 3.41,
  "15104": 2.86,
  "15106": 3.41,
  "15108": 3.41,
  "15110": 2.86,
  "15112": 2.86,
  "15116": 3.41,
  "15120": 3.41,
  "15122": 3.41,
  "15123": 3.41,
  "15126": 3.41,
  "15127": 11.9,
  "15129": 1.57,
  "15131": 3.41,
  "15132": 2.86,
  "15133": 2.86,
  "15134": 2.86,
  "15135": 3.41,
  "15136": 3.41,
  "15137": 2.86,
  "15139": 3.41,
  "15140": 2.86,
  "15142": 11.9,
  "15143": 6.84,
  "15144": 3.41,
  "15145": 2.86,
  "15146": 3.41,
  "15147": 3.41,
  "15148": 2.86,
  "15201": 2.86,
  "15202": 3.41,
  "15203": 3.41,
  "15204": 2.86,
  "15205": 3.41,
  "15206": 3.41,
  "15207": 2.86,
  "15208": 2.86,
  "15209": 3.41,
  "15210": 2.86,
  "15211": 3.41,
  "15212": 2.86,
  "15213": 3.41,
  "15214": 3.41,
  "15215": 3.41,
  "15216": 3.41,
  "15217": 3.41,
  "15218": 3.41,
  "15219": 2.86,
  "15220": 3.41,
  "15221": 3.41,
  "15222": 3.41,
  "15223": 2.86,
  "15224": 2.86,
  "15225": 3.41,
  "15226": 3.41,
  "15227": 3.41,
  "15228": 10.31,
  "15229": 3.41,
  "15230": 3.41,
  "15231": 3.41,
  "15232": 11.9,
  "15233": 3.41,
  "15234": 3.41,
  "15235": 2.86,
  "15236": 3.41,
  "15237": 3.41,
  "15238": 11.9,
  "15239": 3.41,
  "15240": 3.41,
  "15241": 3.41,
  "15242": 3.41,
  "15243": 3.41,
  "15244": 3.41,
  "15250": 3.41,
  "15251": 3.41,
  "15253": 3.41,
  "15260": 3.41,
  "15264": 3.41,
  "15272": 3.41,
  "15274": 3.41,
  "15275": 3.41,
  "15276": 3.41,
  "15290": 3.41,
  "15295": 3.41,
  "15301": 1.57,
  "15310": -0.21,
  "15311": 10.58,
  "15312": 8.74,
  "15313": 1.57,
  "15314": 1.57,
  "15315": -4.41,
  "15316": -4.41,
  "15317": 8.47,
  "15320": -4.41,
  "15321": 1.57,
  "15322": -4.96,
  "15323": -5.73,
  "15324": 1.02,
  "15325": -4.96,
  "15327": -4.41,
  "15329": 10.58,
  "15330": 1.57,
  "15331": 1.02,
  "15332": 1.57,
  "15333": -4.41,
  "15334": -4.41,
  "15336": 1.57,
  "15337": -3.89,
  "15338": -4.96,
  "15339": 1.57,
  "15340": 10.58,
  "15341": -3.89,
  "15342": 1.57,
  "15344": -3.89,
  "15345": 1.02,
  "15346": -4.41,
  "15347": 1.57,
  "15348": -4.96,
  "15349": -3.89,
  "15350": 1.02,
  "15351": -8.64,
  "15352": -0.21,
  "15353": -4.41,
  "15357": -4.41,
  "15358": 1.02,
  "15359": -3.89,
  "15360": 1.57,
  "15361": 1.02,
  "15362": -4.41,
  "15363": 1.57,
  "15364": -3.89,
  "15365": -5.73,
  "15366": 1.57,
  "15367": 10.06,
  "15368": 1.02,
  "15370": -3.89,
  "15376": -5.73,
  "15377": -4.14,
  "15378": 2.09,
  "15379": 2.09,
  "15380": -0.73,
  "15401": -8.64,
  "15410": -8.64,
  "15411": -10.39,
  "15412": -8.09,
  "15413": -8.64,
  "15415": -8.64,
  "15416": -8.09,
  "15417": -8.64,
  "15419": -8.09,
  "15420": -8.64,
  "15421": -7.57,
  "15422": -8.64,
  "15423": 1.57,
  "15424": -10.39,
  "15425": -8.09,
  "15427": 1.02,
  "15428": -8.64,
  "15429": -8.64,
  "15430": -8.64,
  "15431": -8.64,
  "15432": -8.64,
  "15433": -8.09,
  "15434": -8.64,
  "15435": -8.64,
  "15436": -8.64,
  "15437": -7.57,
  "15438": -8.09,
  "15439": -8.64,
  "15440": -7.57,
  "15442": -8.64,
  "15443": -8.64,
  "15444": -8.64,
  "15445": -8.09,
  "15446": 0.4,
  "15447": -8.64,
  "15448": -8.64,
  "15449": -8.64,
  "15450": -8.09,
  "15451": -8.64,
  "15454": -8.64,
  "15455": -8.64,
  "15456": -8.64,
  "15458": -8.64,
  "15459": -10.39,
  "15460": -4.96,
  "15461": -8.64,
  "15462": -8.64,
  "15463": -8.64,
  "15464": -8.09,
  "15465": -8.64,
  "15466": -8.64,
  "15467": -4.96,
  "15468": -8.64,
  "15469": 0.4,
  "15470": -7.57,
  "15472": -8.64,
  "15473": -8.09,
  "15474": -4.41,
  "15475": -8.64,
  "15476": -8.64,
  "15477": -8.64,
  "15478": -8.09,
  "15479": -8.09,
  "15480": -8.64,
  "15482": -8.64,
  "15483": -8.09,
  "15484": -8.64,
  "15485": -7.63,
  "15486": -8.09,
  "15488": -8.64,
  "15489": -8.64,
  "15490": -8.09,
  "15492": -8.09,
  "15501": -7.63,
  "15502": -7.63,
  "15520": -7.63,
  "15521": -2.11,
  "15522": -1.59,
  "15530": -7.63,
  "15531": -8.18,
  "15532": -7.63,
  "15533": -1.19,
  "15534": -2.11,
  "15535": -1.59,
  "15536": 0.4,
  "15537": -2.11,
  "15538": -7.63,
  "15539": -2.11,
  "15540": -7.63,
  "15541": -7.63,
  "15542": -7.63,
  "15544": -8.18,
  "15545": -5.33,
  "15546": -8.18,
  "15547": -7.63,
  "15548": -9.01,
  "15549": -7.63,
  "15550": -2.11,
  "15551": -7.63,
  "15552": -7.63,
  "15553": -7.63,
  "15554": -2.11,
  "15555": -7.63,
  "15557": -7.63,
  "15558": -5.33,
  "15559": -2.11,
  "15560": -7.63,
  "15561": -7.63,
  "15562": -5.33,
  "15563": -9.01,
  "15564": -5.33,
  "15565": -5.33,
  "15601": -1.65,
  "15610": -0.06,
  "15611": -1.65,
  "15612": -1.65,
  "15613": -3.49,
  "15615": -1.65,
  "15616": -1.65,
  "15617": -1.65,
  "15618": -1.65,
  "15619": -1.65,
  "15620": -1.65,
  "15621": -1.65,
  "15622": 0.86,
  "15623": -1.65,
  "15624": -1.65,
  "15625": -2.2,
  "15626": -1.65,
  "15627": -1.65,
  "15628": -1.65,
  "15629": -4.04,
  "15631": -8.64,
  "15632": -1.65,
  "15633": -1.65,
  "15634": -1.65,
  "15635": -1.65,
  "15636": 6.84,
  "15637": -1.65,
  "15638": 6.84,
  "15639": -1.65,
  "15640": -1.65,
  "15641": -3.49,
  "15642": -1.65,
  "15644": -1.65,
  "15646": -7.63,
  "15647": -2.2,
  "15650": -1.65,
  "15655": -7.63,
  "15656": -3.49,
  "15658": 6.84,
  "15660": -1.65,
  "15661": -1.65,
  "15662": -1.65,
  "15663": -1.65,
  "15664": -1.65,
  "15665": -1.65,
  "15666": -1.65,
  "15668": 6.84,
  "15670": -1.65,
  "15671": -1.65,
  "15672": -1.65,
  "15673": -3.49,
  "15674": -1.65,
  "15675": -1.65,
  "15676": -0.06,
  "15677": 0.86,
  "15678": -2.2,
  "15679": -1.65,
  "15680": -2.2,
  "15681": -1.65,
  "15682": -3.49,
  "15683": -8.09,
  "15684": -2.2,
  "15685": -1.65,
  "15686": -3.49,
  "15687": -7.63,
  "15688": -1.65,
  "15689": -1.65,
  "15690": -4.04,
  "15691": -1.65,
  "15692": -1.65,
  "15693": 6.84,
  "15695": -1.65,
  "15696": -1.65,
  "15697": -1.65,
  "15698": -2.2,
  "15701": -9.47,
  "15710": -10.02,
  "15711": -10.39,
  "15712": -9.47,
  "15713": -10.02,
  "15714": -9.01,
  "15715": -10.39,
  "15716": -10.02,
  "15717": -9.47,
  "15720": -9.47,
  "15721": -7.17,
  "15722": -9.01,
  "15723": -10.02,
  "15724": -9.47,
  "15725": -9.47,
  "15727": -10.02,
  "15728": -10.02,
  "15729": -10.02,
  "15730": -10.39,
  "15731": -10.02,
  "15732": -10.02,
  "15733": -10.39,
  "15734": -10.02,
  "15736": -3.49,
  "15737": -9.01,
  "15738": -9.01,
  "15739": -10.02,
  "15740": -10.39,
  "15741": -9.47,
  "15742": -9.47,
  "15744": -10.39,
  "15745": -10.02,
  "15746": -9.47,
  "15747": -9.47,
  "15748": -9.47,
  "15750": -10.02,
  "15752": -10.02,
  "15753": -7.17,
  "15754": -10.02,
  "15756": -10.02,
  "15757": -7.17,
  "15758": -10.94,
  "15759": -9.47,
  "15760": -9.01,
  "15761": -10.02,
  "15762": -9.01,
  "15763": -10.94,
  "15764": -10.39,
  "15765": -9.47,
  "15767": -10.39,
  "15770": -10.39,
  "15771": -9.47,
  "15772": -10.39,
  "15773": -9.01,
  "15774": -9.47,
  "15775": -9.01,
  "15776": -10.94,
  "15777": -10.02,
  "15778": -10.94,
  "15779": -7.88,
  "15780": -10.39,
  "15781": -10.39,
  "15783": -10.02,
  "15784": -10.94,
  "15801": -9.87,
  "15821": -19.63,
  "15822": -0.31,
  "15823": -3.49,
  "15824": -3.49,
  "15825": -10.39,
  "15827": -0.31,
  "15828": -10.39,
  "15829": -10.39,
  "15831": -0.31,
  "15832": -20.18,
  "15834": -19.63,
  "15840": -10.39,
  "15841": -0.86,
  "15845": -3.49,
  "15846": -0.31,
  "15847": -10.39,
  "15848": -7.17,
  "15849": -3.99,
  "15851": -10.39,
  "15853": -3.49,
  "15856": -7.17,
  "15857": -0.31,
  "15860": -10.39,
  "15861": -19.63,
  "15863": -10.39,
  "15864": -10.94,
  "15865": -10.39,
  "15866": -10.39,
  "15868": -0.86,
  "15870": -3.49,
  "15901": -9.56,
  "15902": -9.56,
  "15904": -9.01,
  "15905": -9.01,
  "15906": -9.56,
  "15907": -9.56,
  "15909": -9.01,
  "15915": -9.01,
  "15920": -9.01,
  "15921": -9.56,
  "15922": -9.56,
  "15923": -9.47,
  "15924": -2.11,
  "15925": -9.01,
  "15926": -8.18,
  "15927": -9.56,
  "15928": -0.52,
  "15929": -9.01,
  "15930": -9.56,
  "15931": -9.01,
  "15934": -9.01,
  "15935": -7.63,
  "15936": -8.18,
  "15937": -8.18,
  "15938": -9.01,
  "15940": -0.52,
  "15942": -9.01,
  "15943": -9.56,
  "15944": -9.01,
  "15945": -9.56,
  "15946": -9.01,
  "15948": -9.01,
  "15949": -10.02,
  "15951": -9.56,
  "15952": -9.01,
  "15953": -0.52,
  "15954": -9.01,
  "15955": -9.56,
  "15956": -9.56,
  "15957": -9.56,
  "15958": -9.01,
  "15959": -0.52,
  "15960": -9.56,
  "15961": -9.01,
  "15962": -9.01,
  "15963": -9.01,
  "16001": 1.11,
  "16002": 1.11,
  "16003": 1.11,
  "16020": 1.11,
  "16021": 1.11,
  "16022": 0.56,
  "16023": 1.11,
  "16024": 1.11,
  "16025": 1.11,
  "16027": 1.11,
  "16028": -5.79,
  "16029": 1.11,
  "16030": -14.62,
  "16033": 1.11,
  "16034": 1.11,
  "16035": 1.11,
  "16036": -6.34,
  "16037": 1.11,
  "16038": 1.11,
  "16039": 1.11,
  "16040": 1.11,
  "16041": 1.11,
  "16045": 1.11,
  "16046": 9.6,
  "16048": 1.11,
  "16049": -5.79,
  "16050": 1.11,
  "16051": -1.19,
  "16052": 1.11,
  "16053": 1.11,
  "16054": -6.34,
  "16055": -3.49,
  "16056": 1.11,
  "16057": 1.11,
  "16058": -6.34,
  "16059": 1.11,
  "16061": 1.11,
  "16063": -1.65,
  "16066": 5.25,
  "16101": -1.74,
  "16102": -1.74,
  "16103": -1.74,
  "16105": -1.19,
  "16107": -1.74,
  "16108": -1.74,
  "16110": -10.79,
  "16111": -11.31,
  "16112": -1.74,
  "16113": -5.12,
  "16114": -6.71,
  "16115": -1.65,
  "16116": -1.74,
  "16117": -1.19,
  "16120": -1.19,
  "16121": -7.26,
  "16123": -1.65,
  "16124": -6.71,
  "16125": -6.71,
  "16127": -6.71,
  "16130": -6.71,
  "16131": -6.71,
  "16132": -1.74,
  "16133": -6.71,
  "16134": -6.71,
  "16136": -2.2,
  "16137": -6.71,
  "16140": 2.03,
  "16141": -1.74,
  "16142": 7.3,
  "16143": -1.19,
  "16145": -6.71,
  "16146": -7.26,
  "16148": -5.12,
  "16150": -6.71,
  "16151": -7.26,
  "16153": -6.71,
  "16154": -6.71,
  "16155": 2.03,
  "16156": -1.19,
  "16157": -1.19,
  "16159": -6.71,
  "16160": -1.74,
  "16161": -7.26,
  "16201": -3.49,
  "16210": -4.04,
  "16211": -10.02,
  "16212": -4.04,
  "16213": -6.34,
  "16214": -5.79,
  "16217": -5.79,
  "16218": -3.49,
  "16220": -5.79,
  "16221": -5.79,
  "16222": -3.49,
  "16223": -4.04,
  "16224": -5.79,
  "16225": -5.79,
  "16226": -4.04,
  "16228": -4.04,
  "16229": -3.49,
  "16230": -6.34,
  "16232": -5.79,
  "16233": -5.79,
  "16234": -5.79,
  "16235": 2.7,
  "16236": -4.04,
  "16238": -4.04,
  "16239": -11.77,
  "16240": -10.94,
  "16242": -5.79,
  "16244": -4.04,
  "16245": -6.34,
  "16246": -10.02,
  "16248": -6.34,
  "16249": -3.49,
  "16250": -10.02,
  "16253": -4.04,
  "16254": -5.79,
  "16255": -5.79,
  "16256": -10.02,
  "16257": 2.7,
  "16258": -5.79,
  "16259": -4.04,
  "16260": -5.79,
  "16261": -4.04,
  "16262": -3.49,
  "16263": -3.49,
  "16301": -14.62,
  "16311": -14.07,
  "16312": -11.77,
  "16313": -11.77,
  "16314": -11.31,
  "16316": -11.31,
  "16317": -14.62,
  "16319": -14.07,
  "16321": -11.77,
  "16322": -14.62,
  "16323": -14.62,
  "16326": 2.7,
  "16327": -10.79,
  "16328": -14.07,
  "16329": -11.77,
  "16331": -14.07,
  "16332": -5.79,
  "16333": -12.32,
  "16334": 2.7,
  "16335": -10.79,
  "16340": -11.77,
  "16341": -14.07,
  "16342": -14.62,
  "16343": -14.62,
  "16344": -14.62,
  "16345": -3.28,
  "16346": -14.07,
  "16347": -11.77,
  "16350": -11.77,
  "16351": -11.77,
  "16352": -11.77,
  "16353": -14.07,
  "16354": -14.07,
  "16360": -10.79,
  "16361": -5.79,
  "16362": -14.62,
  "16364": -14.07,
  "16365": -11.77,
  "16370": -14.07,
  "16371": -11.77,
  "16372": -14.62,
  "16373": -5.79,
  "16374": -14.07,
  "16375": -5.79,
  "16401": -6.19,
  "16402": -11.77,
  "16403": -10.79,
  "16404": -10.79,
  "16405": -11.77,
  "16406": -10.79,
  "16407": -11.77,
  "16410": -6.19,
  "16411": -6.19,
  "16412": -6.19,
  "16413": -11.77,
  "16415": -4.6,
  "16416": -12.32,
  "16417": -6.19,
  "16420": -12.32,
  "16421": -6.19,
  "16422": -11.86,
  "16423": -6.19,
  "16424": -11.31,
  "16426": -6.19,
  "16427": -6.19,
  "16428": -6.19,
  "16430": -6.19,
  "16432": -11.31,
  "16433": -10.79,
  "16434": -11.77,
  "16435": -10.79,
  "16436": -11.77,
  "16438": -6.71,
  "16440": -6.19,
  "16441": -6.19,
  "16442": -6.19,
  "16443": -6.19,
  "16501": 2.3,
  "16502": -6.71,
  "16503": -6.71,
  "16504": -6.19,
  "16505": -6.19,
  "16506": -6.19,
  "16507": -6.71,
  "16508": -6.19,
  "16509": -6.19,
  "16510": -6.19,
  "16511": -6.19,
  "16512": -6.19,
  "16514": -6.19,
  "16515": -6.19,
  "16541": 2.3,
  "16544": -6.71,
  "16546": -6.19,
  "16550": -6.71,
  "16563": -6.19,
  "16565": -6.19,
  "16601": -9.47,
  "16602": -9.47,
  "16603": -9.47,
  "16611": -6.65,
  "16613": -8.95,
  "16616": -7.17,
  "16617": -9.47,
  "16619": -9.47,
  "16620": -7.17,
  "16621": -6.65,
  "16622": -6.65,
  "16623": -6.65,
  "16624": -0.52,
  "16625": -9.47,
  "16627": -7.17,
  "16629": -8.95,
  "16630": -9.01,
  "16631": -8.95,
  "16633": -2.11,
  "16634": -7.17,
  "16635": -7.88,
  "16636": -8.95,
  "16637": -9.47,
  "16638": -7.17,
  "16639": -9.47,
  "16640": -9.47,
  "16641": -9.47,
  "16644": -9.47,
  "16645": -7.17,
  "16646": -9.01,
  "16647": 1.32,
  "16648": -0.98,
  "16650": -2.11,
  "16651": -7.17,
  "16652": -6.65,
  "16655": -2.11,
  "16656": -7.17,
  "16657": -5.58,
  "16659": -2.11,
  "16660": 1.32,
  "16661": -7.17,
  "16662": -7.88,
  "16663": -7.17,
  "16664": 6.38,
  "16665": -9.47,
  "16666": -3.99,
  "16667": -2.11,
  "16668": -9.01,
  "16669": -6.65,
  "16670": -1.59,
  "16671": -7.17,
  "16672": -2.11,
  "16673": -8.95,
  "16674": -7.17,
  "16675": -9.01,
  "16677": -1.23,
  "16678": -7.17,
  "16679": -2.11,
  "16680": -7.17,
  "16681": -7.17,
  "16682": -9.47,
  "16683": -6.65,
  "16684": -9.47,
  "16685": 1.32,
  "16686": -8.95,
  "16689": -0.67,
  "16691": -1.19,
  "16692": -7.17,
  "16693": -9.47,
  "16694": -1.19,
  "16695": -1.59,
  "16701": -8.09,
  "16720": -19.63,
  "16724": -8.64,
  "16725": -8.64,
  "16726": -8.64,
  "16727": -8.09,
  "16728": -4.04,
  "16729": -8.09,
  "16730": -8.64,
  "16731": -8.09,
  "16732": -8.09,
  "16733": -8.64,
  "16734": -4.04,
  "16735": -3.49,
  "16738": -8.64,
  "16740": -8.09,
  "16743": -8.09,
  "16744": -8.09,
  "16745": -8.64,
  "16746": -8.09,
  "16748": -8.09,
  "16749": -8.09,
  "16750": -8.09,
  "16801": 7.26,
  "16802": -1.23,
  "16803": 7.26,
  "16804": 7.26,
  "16805": 7.26,
  "16820": -6.29,
  "16821": -3.99,
  "16822": -8.95,
  "16823": -1.23,
  "16825": -4.54,
  "16826": -6.29,
  "16827": 7.26,
  "16828": 0.36,
  "16829": -1.23,
  "16830": -3.99,
  "16832": -1.23,
  "16833": -7.17,
  "16834": -1.23,
  "16835": -1.23,
  "16836": -3.99,
  "16837": -7.17,
  "16838": -7.17,
  "16839": -1.23,
  "16840": -3.99,
  "16841": -6.29,
  "16843": -7.17,
  "16844": -1.23,
  "16845": -19.63,
  "16847": -3.99,
  "16848": -6.29,
  "16849": -1.23,
  "16850": -3.99,
  "16851": 7.26,
  "16852": -1.23,
  "16853": -1.23,
  "16854": -1.23,
  "16855": -3.99,
  "16856": -1.23,
  "16858": -3.99,
  "16859": -1.23,
  "16860": -3.99,
  "16861": -7.17,
  "16863": -7.17,
  "16864": -6.29,
  "16865": 7.26,
  "16866": -3.99,
  "16868": 7.26,
  "16870": 7.26,
  "16871": -19.63,
  "16872": -8.95,
  "16873": -3.99,
  "16874": -1.23,
  "16875": -1.23,
  "16876": -4.54,
  "16877": 0.36,
  "16878": -3.99,
  "16879": -1.23,
  "16881": -3.99,
  "16882": -5.27,
  "16901": -6.96,
  "16910": -8.03,
  "16911": -8.55,
  "16912": -8.03,
  "16914": -8.55,
  "16915": -7.57,
  "16917": -8.55,
  "16920": -9.1,
  "16921": -8.03,
  "16922": -7.57,
  "16923": -8.09,
  "16925": -0.27,
  "16926": -8.55,
  "16927": -8.09,
  "16928": -8.55,
  "16929": -8.55,
  "16930": -8.03,
  "16932": -8.55,
  "16933": -6.96,
  "16935": -8.55,
  "16936": -0.27,
  "16937": -8.09,
  "16938": -8.03,
  "16939": -8.55,
  "16940": -8.55,
  "16941": -8.09,
  "16942": -8.55,
  "16943": -8.09,
  "16945": -8.55,
  "16946": -8.55,
  "16947": -8.55,
  "16948": -8.09,
  "16950": -8.55,
  "17001": 2.09,
  "17002": -4.91,
  "17003": -1.59,
  "17004": -4.91,
  "17005": -5.33,
  "17006": -9.2,
  "17007": 8.49,
  "17009": -4.91,
  "17010": 6.9,
  "17011": 2.09,
  "17013": 0,
  "17014": -5.33,
  "17015": 0.52,
  "17016": -1.59,
  "17017": -5.33,
  "17018": 1.57,
  "17019": 8.49,
  "17020": -7.63,
  "17021": -5.98,
  "17022": 1.57,
  "17023": 1.57,
  "17024": -5,
  "17025": 1.57,
  "17026": -1.59,
  "17027": -1.59,
  "17028": 2.09,
  "17029": -4.91,
  "17030": -8.49,
  "17032": 1.57,
  "17033": 10.06,
  "17034": 1.57,
  "17035": -5.98,
  "17036": 10.06,
  "17037": -9.2,
  "17038": -1.59,
  "17039": -1.59,
  "17040": -5,
  "17041": -1.59,
  "17042": -1.59,
  "17043": 1.57,
  "17044": -4.91,
  "17045": -5.33,
  "17046": -1.59,
  "17047": -5,
  "17048": -8.49,
  "17049": -9.2,
  "17050": -0.52,
  "17051": -4.91,
  "17052": -7.17,
  "17053": 1.57,
  "17054": -4.91,
  "17055": -0.52,
  "17056": -9.2,
  "17057": 1.57,
  "17058": -9.2,
  "17059": -9.2,
  "17060": -3.99,
  "17061": -7.63,
  "17062": -7.63,
  "17063": -4.91,
  "17064": 6.9,
  "17065": 0.52,
  "17066": -3.99,
  "17067": -1.59,
  "17068": -5,
  "17069": -7.63,
  "17070": 1.57,
  "17071": -9.2,
  "17072": 1.57,
  "17073": -1.59,
  "17074": -5.52,
  "17075": -4.54,
  "17076": -0.19,
  "17077": -1.59,
  "17078": 0,
  "17080": -5.33,
  "17081": 0,
  "17082": -9.2,
  "17083": -1.59,
  "17084": -4.91,
  "17085": -1.59,
  "17086": -5.33,
  "17087": -1.59,
  "17088": 0,
  "17090": -5.52,
  "17093": 1.57,
  "17094": -9.2,
  "17097": 1.57,
  "17098": -1.59,
  "17099": -4.91,
  "17101": 1.57,
  "17102": 1.57,
  "17103": 1.57,
  "17104": 1.57,
  "17105": 1.57,
  "17106": 1.57,
  "17108": 1.57,
  "17109": 1.57,
  "17110": 1.57,
  "17111": 1.57,
  "17112": 2.09,
  "17113": 1.57,
  "17129": 1.57,
  "17201": -2.82,
  "17202": -2.82,
  "17210": -5.06,
  "17211": -1.59,
  "17212": 0.4,
  "17213": -5.06,
  "17214": -2.3,
  "17215": 0.4,
  "17217": -5.06,
  "17219": -5.06,
  "17220": -5.06,
  "17221": -2.82,
  "17222": -2.82,
  "17223": 0.4,
  "17224": 0.4,
  "17225": -2.3,
  "17228": 0.4,
  "17229": 0.4,
  "17231": -2.82,
  "17232": -2.3,
  "17233": 0.4,
  "17235": -2.82,
  "17236": 0.4,
  "17237": -2.82,
  "17238": 0.4,
  "17239": -2.82,
  "17240": -1.78,
  "17241": 0.52,
  "17243": -7.17,
  "17244": -2.3,
  "17246": -2.3,
  "17247": -2.82,
  "17249": -7.17,
  "17250": -2.3,
  "17251": -2.3,
  "17252": -2.82,
  "17253": -7.17,
  "17254": -2.82,
  "17255": -5.06,
  "17256": -2.3,
  "17257": -2.3,
  "17260": -7.17,
  "17261": -2.82,
  "17262": -2.3,
  "17263": -2.3,
  "17264": -7.17,
  "17265": -2.82,
  "17266": -2.3,
  "17267": 0.4,
  "17268": -2.82,
  "17270": -2.82,
  "17271": -2.3,
  "17272": -2.82,
  "17301": 1.11,
  "17302": 0.25,
  "17303": 3.74,
  "17304": 3.22,
  "17306": 3.22,
  "17307": 3.74,
  "17309": 3.93,
  "17310": 2.7,
  "17311": 3.41,
  "17312": 3.41,
  "17313": 3.41,
  "17314": 0.25,
  "17315": 3.41,
  "17316": 1.11,
  "17317": 3.41,
  "17318": 3.41,
  "17319": 2.09,
  "17320": 3.22,
  "17321": 3.93,
  "17322": 3.41,
  "17323": 8.49,
  "17324": 3.74,
  "17325": 3.74,
  "17327": 3.41,
  "17329": 3.93,
  "17331": 1.11,
  "17337": 3.74,
  "17339": 3.16,
  "17340": 1.11,
  "17342": 3.41,
  "17343": 3.74,
  "17344": 1.11,
  "17345": 3.41,
  "17347": 3.41,
  "17349": 3.93,
  "17350": 1.11,
  "17352": 3.41,
  "17353": 2.7,
  "17354": 3.41,
  "17355": 3.41,
  "17356": 3.41,
  "17358": 3.41,
  "17360": 3.41,
  "17361": 3.41,
  "17362": 3.41,
  "17363": 3.93,
  "17364": 3.41,
  "17365": 3.41,
  "17366": 3.41,
  "17368": 3.41,
  "17370": 3.41,
  "17371": 3.41,
  "17372": 3.74,
  "17375": 3.74,
  "17401": 2.86,
  "17402": 3.41,
  "17403": 3.41,
  "17404": 3.41,
  "17405": 3.41,
  "17406": 3.41,
  "17407": 3.41,
  "17408": 3.41,
  "17501": 0.25,
  "17502": 3.41,
  "17503": 0.77,
  "17504": 0.25,
  "17505": 2.36,
  "17506": 0.77,
  "17507": -0.27,
  "17508": 2.36,
  "17509": 0.77,
  "17512": 0.25,
  "17516": 0.77,
  "17517": -0.27,
  "17518": 0.77,
  "17519": -0.27,
  "17520": 0.25,
  "17521": 0.77,
  "17522": 0.25,
  "17527": 0.77,
  "17528": -0.27,
  "17529": 0.77,
  "17532": 0.77,
  "17533": 0,
  "17534": 0.77,
  "17535": 0.77,
  "17536": 0.77,
  "17537": 0.77,
  "17538": 0.77,
  "17540": 0.77,
  "17543": 0.77,
  "17545": 0.77,
  "17547": 3.41,
  "17549": -0.27,
  "17550": 3.41,
  "17551": 0.77,
  "17552": 0.25,
  "17554": 0.25,
  "17555": -0.27,
  "17557": 0.77,
  "17560": 0.25,
  "17562": 0.77,
  "17563": 0.25,
  "17564": 0.77,
  "17565": 0.77,
  "17566": 0.77,
  "17567": -0.27,
  "17568": 0.25,
  "17569": 0.65,
  "17570": -0.27,
  "17572": 0.77,
  "17573": 0.77,
  "17575": 0.77,
  "17576": 0.77,
  "17578": 0.77,
  "17579": 0.77,
  "17580": 2.36,
  "17581": -0.27,
  "17582": 0.77,
  "17583": 0.77,
  "17584": 0.77,
  "17585": 0.77,
  "17601": 0.77,
  "17602": 0.25,
  "17603": 0.25,
  "17604": 0.77,
  "17605": 0.25,
  "17606": 0.77,
  "17607": 0.25,
  "17608": 0.25,
  "17611": 0.25,
  "17701": -6.19,
  "17702": -6.19,
  "17703": -6.19,
  "17720": -6.19,
  "17721": -8.95,
  "17723": -9.47,
  "17724": -8.03,
  "17726": -8.95,
  "17727": -8.03,
  "17728": -6.19,
  "17729": -7.57,
  "17730": -6.19,
  "17731": -5.52,
  "17735": -8.03,
  "17737": -6.19,
  "17738": -8.95,
  "17739": -9.47,
  "17740": -6.19,
  "17742": -13.15,
  "17744": -6.19,
  "17745": -8.95,
  "17747": -8.95,
  "17748": -0.46,
  "17749": -12.63,
  "17750": -8.95,
  "17751": -8.95,
  "17752": -6.19,
  "17754": -5.67,
  "17756": -6.19,
  "17758": -14.01,
  "17760": -8.95,
  "17762": -6.19,
  "17763": -6.19,
  "17764": -6.84,
  "17765": -8.03,
  "17767": -9.47,
  "17768": -14.01,
  "17769": -8.95,
  "17771": -6.19,
  "17772": -12.63,
  "17773": -8.95,
  "17774": -14.01,
  "17776": -8.95,
  "17777": -12.63,
  "17778": -19.63,
  "17779": -8.95,
  "17801": -8.49,
  "17810": -6.19,
  "17812": -2.15,
  "17813": -4.81,
  "17814": -5.73,
  "17815": -5.73,
  "17820": -5.73,
  "17821": -12.63,
  "17823": -8.49,
  "17824": -8.49,
  "17827": -4.81,
  "17829": -5.27,
  "17830": -5.33,
  "17831": -4.81,
  "17832": -9.01,
  "17833": -4.81,
  "17834": -9.01,
  "17835": -5.27,
  "17836": -8.49,
  "17837": 3.22,
  "17839": -5.73,
  "17840": -3.95,
  "17841": -8.13,
  "17842": -4.81,
  "17843": -2.15,
  "17844": -5.27,
  "17845": -5.27,
  "17846": -5.73,
  "17847": -5.27,
  "17850": -5.79,
  "17851": -3.95,
  "17853": -5.33,
  "17855": -5.27,
  "17856": -4.75,
  "17857": -8.49,
  "17858": -5.73,
  "17859": -5.73,
  "17860": -7.97,
  "17861": -4.81,
  "17862": -4.81,
  "17864": -5.33,
  "17865": -12.63,
  "17866": -9.01,
  "17867": -8.49,
  "17868": -12.11,
  "17870": -4.81,
  "17872": -9.01,
  "17876": -8.49,
  "17877": -7.97,
  "17878": -5.73,
  "17880": -5.27,
  "17881": -8.49,
  "17882": -4.81,
  "17883": -5.27,
  "17884": -12.63,
  "17885": -2.15,
  "17886": -5.27,
  "17887": -5.79,
  "17888": -3.43,
  "17889": -5.79,
  "17901": -3.43,
  "17920": -3.43,
  "17921": -3.43,
  "17922": -3.95,
  "17923": -3.95,
  "17925": -4.5,
  "17929": -3.43,
  "17930": -4.5,
  "17931": -3.43,
  "17933": -3.43,
  "17934": -3.95,
  "17935": -3.95,
  "17936": -3.43,
  "17938": -3.43,
  "17941": -8.49,
  "17942": -3.95,
  "17943": -3.43,
  "17944": -3.95,
  "17945": -3.95,
  "17946": -3.95,
  "17948": -3.95,
  "17949": -3.95,
  "17951": -3.43,
  "17952": -4.5,
  "17953": -4.5,
  "17954": -3.95,
  "17957": -2.11,
  "17959": -4.5,
  "17960": -3.95,
  "17961": -3.95,
  "17963": -3.43,
  "17964": -8.49,
  "17965": -4.5,
  "17966": -3.43,
  "17967": -3.43,
  "17968": -8.49,
  "17970": -3.95,
  "17972": -3.43,
  "17974": -3.43,
  "17976": -3.95,
  "17978": -8.49,
  "17979": -3.43,
  "17980": -2.11,
  "17981": -3.95,
  "17982": -4.5,
  "17983": -8.49,
  "17985": -5.73,
  "18001": 1.69,
  "18002": 1.69,
  "18010": 4.14,
  "18011": 1.69,
  "18012": -8.43,
  "18013": 4.14,
  "18014": 4.14,
  "18015": 2.76,
  "18016": 2.76,
  "18017": 2.76,
  "18018": 2.76,
  "18020": 2.76,
  "18030": -8.43,
  "18031": 1.69,
  "18032": 1.69,
  "18034": 2.24,
  "18035": 3.28,
  "18036": 2.24,
  "18037": 1.69,
  "18038": 4.14,
  "18039": 4.14,
  "18040": 4.14,
  "18041": 1.69,
  "18042": 4.14,
  "18043": 4.14,
  "18044": 4.14,
  "18045": 4.14,
  "18046": 1.69,
  "18049": 1.69,
  "18050": 4.14,
  "18051": 10.18,
  "18052": 1.69,
  "18053": 2.24,
  "18054": 15.58,
  "18055": 4.14,
  "18056": 0.65,
  "18058": -7.36,
  "18059": 2.24,
  "18060": 2.24,
  "18062": 1.69,
  "18063": 4.14,
  "18064": 4.14,
  "18065": 2.24,
  "18066": 1.69,
  "18067": 1.69,
  "18068": 2.24,
  "18069": 3.28,
  "18070": 1.69,
  "18071": -8.43,
  "18072": 4.14,
  "18073": 1.69,
  "18074": 15.58,
  "18076": 1.69,
  "18077": 4.14,
  "18078": 2.24,
  "18079": -8.43,
  "18080": 1.69,
  "18081": 4.14,
  "18083": 4.14,
  "18084": 15.58,
  "18085": 4.14,
  "18086": 1.69,
  "18087": 1.69,
  "18088": -8.43,
  "18091": -7.36,
  "18092": 2.24,
  "18101": 1.69,
  "18102": 1.69,
  "18103": 1.69,
  "18104": 1.69,
  "18105": 1.69,
  "18106": 1.69,
  "18109": 1.69,
  "18195": 1.69,
  "18201": -2.05,
  "18202": -2.05,
  "18210": -8.95,
  "18211": -8.43,
  "18212": -8.43,
  "18214": -3.95,
  "18216": -9.47,
  "18218": -8.43,
  "18219": -2.05,
  "18220": -3.95,
  "18221": -2.57,
  "18222": -2.05,
  "18223": -2.05,
  "18224": -2.57,
  "18225": -2.05,
  "18229": -8.43,
  "18230": -9.47,
  "18231": -9.47,
  "18232": -8.43,
  "18234": -2.57,
  "18235": -8.43,
  "18237": -9.47,
  "18239": -2.57,
  "18240": -8.43,
  "18241": -5.73,
  "18242": -3.95,
  "18244": -8.43,
  "18245": -3.43,
  "18246": -5.73,
  "18247": -2.05,
  "18248": -3.95,
  "18249": -2.05,
  "18250": -8.43,
  "18251": -2.05,
  "18252": -2.91,
  "18254": -9.47,
  "18255": -8.95,
  "18256": -5.73,
  "18301": -7.36,
  "18302": -7.36,
  "18320": -7.36,
  "18321": -7.36,
  "18322": -7.36,
  "18323": 0.06,
  "18324": -12.57,
  "18325": 2.36,
  "18326": -7.88,
  "18327": -7.36,
  "18328": -12.57,
  "18330": -7.36,
  "18331": -7.36,
  "18332": -7.88,
  "18333": -7.36,
  "18334": -8.95,
  "18335": -7.36,
  "18336": -12.02,
  "18337": -12.02,
  "18340": -12.02,
  "18341": -7.36,
  "18342": 0.06,
  "18343": -7.36,
  "18344": -7.88,
  "18346": -8.43,
  "18347": -8.95,
  "18348": -7.88,
  "18349": 0.06,
  "18350": -7.88,
  "18351": -7.36,
  "18352": -7.36,
  "18353": -7.36,
  "18354": -7.36,
  "18355": -7.88,
  "18356": -6.84,
  "18357": 2.36,
  "18360": -7.36,
  "18370": 0.06,
  "18371": -12.57,
  "18372": -7.36,
  "18373": -12.57,
  "18403": -1.07,
  "18405": -4.2,
  "18407": -4.75,
  "18410": -0.52,
  "18411": -0.52,
  "18413": -1.07,
  "18414": -0.52,
  "18415": -4.2,
  "18416": -0.52,
  "18417": -4.75,
  "18419": -4.29,
  "18420": -0.52,
  "18421": -4.75,
  "18424": -1.07,
  "18425": -12.57,
  "18426": -12.57,
  "18427": -4.2,
  "18428": -4.75,
  "18430": -1.07,
  "18431": -4.75,
  "18433": -1.07,
  "18434": -1.07,
  "18435": -12.57,
  "18436": -4.2,
  "18437": 3.22,
  "18438": -4.75,
  "18439": -4.75,
  "18440": -0.52,
  "18441": -1.07,
  "18443": -4.2,
  "18444": -0.52,
  "18445": -7.88,
  "18446": -1.07,
  "18447": -1.07,
  "18449": 6.9,
  "18451": -4.2,
  "18452": -1.07,
  "18453": -4.2,
  "18454": -4.75,
  "18455": -5.27,
  "18456": -4.75,
  "18457": -12.57,
  "18458": -12.02,
  "18459": -4.75,
  "18460": -7.88,
  "18461": -1.59,
  "18462": -1.59,
  "18463": -12.57,
  "18464": -12.02,
  "18465": 6.9,
  "18466": -8.43,
  "18469": -4.2,
  "18470": -1.07,
  "18471": 7.42,
  "18472": -4.75,
  "18473": -4.75,
  "18501": -1.07,
  "18502": -1.07,
  "18503": -1.07,
  "18504": -1.07,
  "18505": -1.07,
  "18507": -1.07,
  "18508": -1.07,
  "18509": -1.07,
  "18510": -1.07,
  "18512": -1.07,
  "18515": -1.07,
  "18517": -1.07,
  "18518": -1.07,
  "18519": -1.07,
  "18540": -1.07,
  "18601": -5.73,
  "18602": -2.05,
  "18603": -5.73,
  "18610": -8.95,
  "18611": -5.73,
  "18612": -2.05,
  "18614": -14.01,
  "18615": -4.29,
  "18616": -14.01,
  "18617": -2.57,
  "18618": -2.05,
  "18619": -14.01,
  "18621": -2.57,
  "18622": -2.05,
  "18623": -4.29,
  "18624": -0.46,
  "18625": -4.29,
  "18626": -13.49,
  "18627": -2.05,
  "18628": -14.53,
  "18629": -4.81,
  "18630": -4.29,
  "18631": -5.73,
  "18632": -14.53,
  "18634": -2.57,
  "18635": -5.73,
  "18636": -4.81,
  "18640": -1.59,
  "18641": -1.07,
  "18642": -1.59,
  "18643": -1.59,
  "18644": -2.05,
  "18651": -2.57,
  "18653": -0.52,
  "18654": -2.05,
  "18655": -2.05,
  "18656": -2.05,
  "18657": -4.29,
  "18660": -2.57,
  "18661": -2.05,
  "18701": -2.05,
  "18702": -2.05,
  "18703": -2.05,
  "18704": -2.05,
  "18705": -2.05,
  "18706": -2.57,
  "18707": -2.05,
  "18708": -2.05,
  "18709": -2.05,
  "18710": -2.05,
  "18711": -2.05,
  "18773": -2.05,
  "18801": -1.59,
  "18810": -8.55,
  "18812": 14.26,
  "18813": -1.59,
  "18814": -8.55,
  "18815": -8.03,
  "18816": -1.59,
  "18817": -8.55,
  "18818": -1.59,
  "18820": -1.59,
  "18821": -1.59,
  "18822": -1.59,
  "18823": -1.59,
  "18824": -1.07,
  "18825": 0,
  "18826": -1.59,
  "18827": -1.59,
  "18828": 0,
  "18829": -8.03,
  "18830": -8.03,
  "18831": -6.96,
  "18832": -8.55,
  "18833": -14.01,
  "18834": -1.59,
  "18837": -8.03,
  "18840": -8.55,
  "18842": -1.07,
  "18843": -1.59,
  "18844": -1.07,
  "18845": -8.03,
  "18846": -4.81,
  "18847": -1.59,
  "18848": -8.55,
  "18850": -8.55,
  "18851": -8.03,
  "18853": -8.03,
  "18854": -8.55,
  "18901": 4.91,
  "18902": 4.91,
  "18910": 6.5,
  "18911": 16.1,
  "18912": 4.91,
  "18913": 8.28,
  "18914": 4.39,
  "18915": 14.51,
  "18916": 5.98,
  "18917": 5.98,
  "18918": 15.03,
  "18920": 16.77,
  "18921": 4.66,
  "18922": 4.91,
  "18923": 5.98,
  "18924": 15.03,
  "18925": 4.91,
  "18926": 7.57,
  "18927": 16.1,
  "18928": 8.28,
  "18929": 4.39,
  "18930": 4.66,
  "18931": 8.28,
  "18932": 14.51,
  "18933": 8.28,
  "18934": 4.91,
  "18935": 1.69,
  "18936": 14.51,
  "18938": 8.28,
  "18940": 4.39,
  "18942": 6.5,
  "18943": 8.28,
  "18944": 16.1,
  "18946": 8.28,
  "18947": 7.57,
  "18949": 5.98,
  "18950": 7.57,
  "18951": 2.76,
  "18953": 4.14,
  "18954": 4.39,
  "18955": 2.76,
  "18956": 8.28,
  "18957": 15.03,
  "18958": 15.03,
  "18960": 16.1,
  "18962": 16.1,
  "18963": 8.28,
  "18964": 15.58,
  "18966": 4.39,
  "18968": 1.69,
  "18969": 15.03,
  "18970": 1.69,
  "18971": 1.69,
  "18972": 4.14,
  "18974": 4.39,
  "18976": 4.39,
  "18977": 8.28,
  "18979": 15.58,
  "18980": 8.28,
  "18981": 2.24,
  "19001": 10.77,
  "19002": 14.51,
  "19003": 7.09,
  "19004": 11.29,
  "19006": 4.39,
  "19007": 7.61,
  "19008": 7.61,
  "19009": 14.66,
  "19010": 10.98,
  "19012": 10.77,
  "19013": 8.68,
  "19014": 8.68,
  "19015": 8.68,
  "19016": 8.68,
  "19017": 9.2,
  "19018": 7.09,
  "19019": 3.87,
  "19020": 4.39,
  "19021": 7.61,
  "19022": 6.54,
  "19023": 7.09,
  "19025": 14.51,
  "19026": 7.09,
  "19027": 10.77,
  "19028": 7.61,
  "19029": 6.54,
  "19030": 8.07,
  "19031": 14.51,
  "19032": 6.54,
  "19033": 7.09,
  "19034": 14.51,
  "19035": 22.08,
  "19036": 6.54,
  "19037": 9.2,
  "19038": 10.77,
  "19039": 11.5,
  "19040": 3.87,
  "19041": 17.88,
  "19043": 7.09,
  "19044": 3.87,
  "19046": 11.29,
  "19047": 4.39,
  "19050": 7.09,
  "19052": 8.68,
  "19053": 4.39,
  "19054": 8.07,
  "19055": 8.07,
  "19056": 4.39,
  "19057": 8.07,
  "19058": 8.07,
  "19060": 8.68,
  "19061": 8.68,
  "19063": 9.2,
  "19064": 7.09,
  "19065": 9.2,
  "19066": 21.56,
  "19067": 8.07,
  "19070": 7.09,
  "19072": 11.29,
  "19073": 7.61,
  "19074": 7.09,
  "19075": 14.51,
  "19076": 7.09,
  "19078": 7.09,
  "19079": 6.54,
  "19081": 7.61,
  "19082": 7.09,
  "19083": 7.61,
  "19085": 18.4,
  "19086": 9.2,
  "19087": 14.51,
  "19090": 3.87,
  "19094": 7.09,
  "19095": 11.29,
  "19096": 7.61,
  "19101": 10.77,
  "19102": 10.77,
  "19103": 10.77,
  "19104": 10.77,
  "19105": 10.77,
  "19106": 19.26,
  "19107": 10.77,
  "19108": 11.29,
  "19109": 10.77,
  "19110": 10.77,
  "19111": 10.77,
  "19112": 10.22,
  "19113": 6.54,
  "19114": 10.77,
  "19115": 10.77,
  "19116": 3.87,
  "19118": 11.29,
  "19119": 11.29,
  "19120": 10.77,
  "19121": 10.77,
  "19122": 10.77,
  "19123": 10.77,
  "19124": 10.77,
  "19125": 10.77,
  "19126": 10.77,
  "19127": 10.77,
  "19128": 10.77,
  "19129": 10.77,
  "19130": 10.77,
  "19131": 10.77,
  "19132": 10.77,
  "19133": 10.77,
  "19134": 10.77,
  "19135": 10.77,
  "19136": 10.77,
  "19137": 10.77,
  "19138": 10.77,
  "19139": 10.77,
  "19140": 10.77,
  "19141": 10.77,
  "19142": 6.54,
  "19143": 10.77,
  "19144": 10.77,
  "19145": 10.22,
  "19146": 10.22,
  "19147": 10.22,
  "19148": 10.22,
  "19149": 10.77,
  "19150": 10.77,
  "19151": 10.77,
  "19152": 10.77,
  "19153": 6.54,
  "19154": 10.77,
  "19155": 10.77,
  "19160": 10.77,
  "19176": 10.77,
  "19190": 10.77,
  "19301": 7.15,
  "19310": 7.67,
  "19311": 11.4,
  "19312": 10.98,
  "19316": 6.63,
  "19317": 8.74,
  "19318": 9.81,
  "19319": 11.5,
  "19320": 9.81,
  "19330": 9.81,
  "19331": 9.2,
  "19333": 7.61,
  "19335": 8.74,
  "19341": 8.74,
  "19342": 9.2,
  "19343": 15.12,
  "19344": 6.63,
  "19345": 8.74,
  "19346": 6.8,
  "19347": 8.74,
  "19348": 8.74,
  "19350": 13.7,
  "19351": 6.8,
  "19352": 6.8,
  "19353": 8.74,
  "19354": 15.12,
  "19355": 8.74,
  "19357": 8.74,
  "19358": 9.81,
  "19360": 6.8,
  "19362": 5.21,
  "19363": 5.21,
  "19365": 7.67,
  "19366": 8.74,
  "19367": 7.67,
  "19369": 7.15,
  "19371": 6.63,
  "19372": 8.22,
  "19373": 9.2,
  "19374": 9.81,
  "19375": 8.74,
  "19376": 6.63,
  "19380": 8.74,
  "19381": 8.74,
  "19382": 8.74,
  "19390": 9.81,
  "19395": 11.5,
  "19397": 11.5,
  "19398": 8.74,
  "19399": 8.74,
  "19401": 13.99,
  "19403": 13.99,
  "19404": 13.99,
  "19405": 13.99,
  "19406": 14.51,
  "19407": 13.99,
  "19408": 13.99,
  "19409": 13.99,
  "19420": 14.51,
  "19421": 17.42,
  "19422": 14.51,
  "19423": 13.99,
  "19425": 17.42,
  "19426": 14.51,
  "19428": 13.99,
  "19430": 13.99,
  "19432": 8.74,
  "19435": 15.58,
  "19436": 14.51,
  "19437": 24.78,
  "19438": 14.51,
  "19440": 13.99,
  "19442": 17.42,
  "19443": 14.51,
  "19444": 14.51,
  "19446": 14.51,
  "19450": 14.51,
  "19451": 14.51,
  "19453": 13.99,
  "19454": 14.51,
  "19456": 13.99,
  "19457": 13.99,
  "19460": 13.99,
  "19462": 14.51,
  "19464": 0.65,
  "19465": 6.63,
  "19468": 13.99,
  "19470": 6.63,
  "19472": 13.99,
  "19473": 16.62,
  "19474": 13.99,
  "19475": 13.99,
  "19477": 14.51,
  "19478": 15.03,
  "19480": 15.12,
  "19481": 7.15,
  "19482": 13.99,
  "19484": 14.51,
  "19485": 14.51,
  "19486": 14.51,
  "19490": 13.99,
  "19492": 15.03,
  "19501": 0.65,
  "19503": 1.69,
  "19504": 1.69,
  "19505": 0.65,
  "19506": 0.65,
  "19507": 0,
  "19508": 0.65,
  "19510": 0.65,
  "19511": 0.65,
  "19512": 0.65,
  "19516": 0.65,
  "19518": 0.1,
  "19519": 0.1,
  "19520": 6.63,
  "19522": 0.65,
  "19523": 0.1,
  "19525": 0.65,
  "19526": 0.1,
  "19529": 1.69,
  "19530": 0.65,
  "19533": 0.65,
  "19534": 0.65,
  "19535": 0.65,
  "19536": 0.1,
  "19538": 1.69,
  "19539": 1.69,
  "19540": 0.1,
  "19541": 0.65,
  "19542": 0.65,
  "19543": 0.65,
  "19544": -1.59,
  "19545": 0.65,
  "19547": 0.65,
  "19548": 0.65,
  "19549": -4.5,
  "19550": -1.59,
  "19551": 0.65,
  "19554": 0.1,
  "19555": 0.65,
  "19559": -3.43,
  "19560": 0.1,
  "19562": 1.69,
  "19564": 0.65,
  "19565": 0.65,
  "19567": -1.59,
  "19601": 0.1,
  "19602": 0.1,
  "19603": 0.65,
  "19604": 0.1,
  "19605": 0.65,
  "19606": 0.65,
  "19607": 0.1,
  "19608": 0.65,
  "19609": 0.1,
  "19610": 0.65,
  "19611": 0.1,
  "19612": 0.1,
  "19701": 5.21,
  "19702": 5.21,
  "19703": 3.62,
  "19706": 5.21,
  "19707": 4.14,
  "19708": 6.8,
  "19709": 6.8,
  "19710": 14.93,
  "19711": 5.73,
  "19713": 5.21,
  "19714": 5.73,
  "19715": 5.73,
  "19716": 5.73,
  "19717": 5.73,
  "19720": 3.62,
  "19730": 5.21,
  "19731": 5.21,
  "19732": 6.44,
  "19733": 5.73,
  "19734": 3.28,
  "19735": 8.03,
  "19736": 8.03,
  "19801": 3.62,
  "19802": 3.62,
  "19803": 4.14,
  "19804": 3.62,
  "19805": 3.62,
  "19806": 4.14,
  "19807": 8.03,
  "19808": 4.14,
  "19809": 4.14,
  "19810": 4.14,
  "19850": 3.62,
  "19880": 3.62,
  "19899": 3.62,
  "19901": 3.28,
  "19902": 3.28,
  "19903": 3.28,
  "19904": 3.28,
  "19905": 3.28,
  "19906": 3.28,
  "19930": 5.33,
  "19931": -3.16,
  "19933": -3.68,
  "19934": 3.28,
  "19936": 3.28,
  "19938": 3.28,
  "19939": -3.16,
  "19940": -3.68,
  "19941": -3.68,
  "19943": 3.28,
  "19944": 7.63,
  "19945": -3.68,
  "19946": 2.76,
  "19947": -3.68,
  "19950": -3.16,
  "19951": -3.16,
  "19952": 3.28,
  "19953": 3.28,
  "19954": 3.28,
  "19955": 2.76,
  "19956": -3.68,
  "19958": -3.16,
  "19960": -3.68,
  "19961": 3.28,
  "19962": 3.28,
  "19963": 3.28,
  "19964": 3.28,
  "19966": -3.68,
  "19967": -3.16,
  "19968": -3.16,
  "19969": -3.16,
  "19970": -3.16,
  "19971": -1.57,
  "19973": -3.16,
  "19975": -3.16,
  "19977": 3.28,
  "19979": 3.28,
  "19980": 3.28,
  "20001": 13.49,
  "20002": 13.49,
  "20003": 13.49,
  "20004": 13.49,
  "20005": 13.49,
  "20006": 13.49,
  "20007": 33.54,
  "20008": 24.28,
  "20009": 14.01,
  "20010": 13.49,
  "20011": 13.49,
  "20012": 14.01,
  "20013": 13.49,
  "20015": 24.28,
  "20016": 26.64,
  "20017": 13.49,
  "20018": 13.49,
  "20019": 13.49,
  "20020": 13.49,
  "20022": 13.49,
  "20023": 13.49,
  "20024": 13.49,
  "20026": 13.49,
  "20027": 33.54,
  "20029": 13.49,
  "20030": 13.49,
  "20032": 13.49,
  "20033": 13.49,
  "20035": 13.49,
  "20036": 13.49,
  "20037": 13.49,
  "20038": 13.49,
  "20039": 13.49,
  "20040": 14.01,
  "20041": 33.54,
  "20043": 13.49,
  "20044": 13.49,
  "20045": 13.49,
  "20050": 13.49,
  "20056": 13.49,
  "20088": 24.28,
  "20090": 13.49,
  "20091": 13.49,
  "20105": 14.93,
  "20106": -4.91,
  "20108": -1.23,
  "20109": -1.23,
  "20110": -1.23,
  "20111": -1.23,
  "20112": 3.89,
  "20113": -1.23,
  "20115": 1.59,
  "20116": 1.59,
  "20117": 23.42,
  "20118": 12.63,
  "20119": 1.07,
  "20120": -0.71,
  "20121": -1.23,
  "20122": -0.71,
  "20124": 1.59,
  "20128": -4.91,
  "20129": 11.56,
  "20130": 0.15,
  "20131": 12.11,
  "20132": 12.11,
  "20134": 12.11,
  "20135": 0.15,
  "20136": -0.71,
  "20137": 1.59,
  "20138": 1.07,
  "20139": 0.52,
  "20140": 1.07,
  "20141": 12.11,
  "20142": 12.11,
  "20143": 1.59,
  "20144": -2.55,
  "20146": 12.11,
  "20147": 12.63,
  "20148": 14.93,
  "20151": 2.51,
  "20152": -0.71,
  "20153": 2.51,
  "20155": -0.71,
  "20156": -0.71,
  "20158": 12.11,
  "20159": 12.11,
  "20160": 12.11,
  "20163": 12.11,
  "20164": 12.11,
  "20165": 12.63,
  "20166": 12.11,
  "20167": 12.11,
  "20168": -0.71,
  "20169": 1.59,
  "20170": 2.51,
  "20171": 2.51,
  "20172": 2.51,
  "20175": 12.11,
  "20176": 12.11,
  "20177": 12.11,
  "20178": 12.11,
  "20180": 12.11,
  "20181": 0.36,
  "20182": 0.36,
  "20184": 10.94,
  "20185": 10.94,
  "20186": 1.07,
  "20187": 1.07,
  "20188": 1.07,
  "20189": 12.11,
  "20190": 1.99,
  "20191": 2.51,
  "20194": 4.81,
  "20195": 1.99,
  "20197": 22.9,
  "20198": 1.59,
  "20260": 13.49,
  "20374": 13.49,
  "20376": 13.49,
  "20388": 13.49,
  "20391": 13.49,
  "20398": 13.49,
  "20500": 13.49,
  "20601": 1.99,
  "20602": 1.99,
  "20603": 1.99,
  "20604": 1.99,
  "20606": 1.44,
  "20607": 12.11,
  "20608": 5.21,
  "20609": 1.99,
  "20610": 5.21,
  "20611": 1.99,
  "20612": 5.21,
  "20613": 1.99,
  "20615": 5.21,
  "20616": 1.99,
  "20617": 1.99,
  "20618": -7.21,
  "20619": 1.99,
  "20620": 1.99,
  "20621": 1.99,
  "20622": 1.99,
  "20623": 7.51,
  "20624": 1.44,
  "20625": -7.76,
  "20626": -7.21,
  "20627": 1.99,
  "20628": 5.88,
  "20629": 2.51,
  "20630": 10.48,
  "20632": 1.99,
  "20634": 1.99,
  "20635": 1.99,
  "20636": 1.99,
  "20637": 1.99,
  "20639": 5.73,
  "20640": 1.99,
  "20643": 1.99,
  "20645": 1.28,
  "20646": 1.99,
  "20650": 1.99,
  "20653": 1.99,
  "20656": 1.44,
  "20657": 1.99,
  "20658": 1.99,
  "20659": 1.99,
  "20660": 1.44,
  "20661": 1.99,
  "20662": -1.23,
  "20664": 1.99,
  "20667": 1.99,
  "20670": 1.99,
  "20674": 1.99,
  "20675": 1.99,
  "20676": 5.73,
  "20677": 2.51,
  "20678": 5.21,
  "20680": 1.99,
  "20682": 1.99,
  "20684": 1.99,
  "20685": 5.21,
  "20686": 1.99,
  "20687": 1.99,
  "20688": 1.99,
  "20689": 5.73,
  "20690": 10.48,
  "20692": 1.99,
  "20693": 1.99,
  "20695": 1.99,
  "20701": 11.81,
  "20703": 7.51,
  "20704": 7.51,
  "20705": 7.51,
  "20706": 7.51,
  "20707": 13.95,
  "20708": 13.95,
  "20709": 13.95,
  "20710": 7.51,
  "20711": 7.51,
  "20712": 13.49,
  "20714": 5.21,
  "20715": 7.51,
  "20716": 7.51,
  "20717": 7.51,
  "20718": 7.51,
  "20719": 7.51,
  "20720": 7.51,
  "20721": 8.03,
  "20722": 13.49,
  "20723": 13.95,
  "20724": 13.95,
  "20725": 13.95,
  "20726": 13.95,
  "20731": 7.51,
  "20732": 5.21,
  "20733": 6.59,
  "20735": 7.51,
  "20736": 5.73,
  "20737": 7.51,
  "20738": 7.51,
  "20740": 7.51,
  "20741": 7.51,
  "20743": 7.51,
  "20744": 12.11,
  "20745": 13.49,
  "20746": 7.51,
  "20747": 7.51,
  "20748": 7.51,
  "20749": 12.11,
  "20750": 13.49,
  "20751": 6.59,
  "20752": 7.51,
  "20753": 7.51,
  "20754": 8.03,
  "20755": 4.45,
  "20757": 7.51,
  "20758": 5.73,
  "20759": 24.74,
  "20762": 7.51,
  "20763": 11.81,
  "20764": 6.59,
  "20765": 7.11,
  "20768": 7.51,
  "20769": 7.51,
  "20770": 7.51,
  "20772": 7.51,
  "20773": 7.51,
  "20774": 7.51,
  "20775": 7.51,
  "20776": 7.11,
  "20777": 24.74,
  "20778": 7.11,
  "20779": 5.73,
  "20781": 7.51,
  "20782": 13.49,
  "20783": 13.49,
  "20784": 7.51,
  "20785": 7.51,
  "20787": 13.49,
  "20788": 13.49,
  "20791": 7.51,
  "20792": 7.51,
  "20794": 11.81,
  "20812": 57.46,
  "20813": 24.28,
  "20814": 12.32,
  "20815": 24.28,
  "20816": 33.54,
  "20817": 19.74,
  "20818": 57.46,
  "20824": 24.28,
  "20825": 24.28,
  "20827": 19.74,
  "20830": 8.95,
  "20832": 8.95,
  "20833": 12.32,
  "20837": 8.43,
  "20838": 14.16,
  "20839": 8.43,
  "20841": 19.22,
  "20842": 14.16,
  "20847": 8.95,
  "20848": 8.43,
  "20849": 8.95,
  "20850": 8.95,
  "20851": 8.43,
  "20852": 8.95,
  "20853": 8.43,
  "20854": 19.74,
  "20855": 8.95,
  "20859": 19.74,
  "20860": 8.43,
  "20861": 12.32,
  "20862": 24.74,
  "20866": 13.95,
  "20868": 14.47,
  "20871": 3.37,
  "20872": 8.43,
  "20874": 7.88,
  "20875": 7.88,
  "20876": 8.43,
  "20877": 8.43,
  "20878": 8.95,
  "20879": 8.43,
  "20880": 8.95,
  "20882": 12.32,
  "20883": 8.43,
  "20884": 8.43,
  "20885": 8.95,
  "20886": 8.43,
  "20891": 8.95,
  "20895": 8.95,
  "20896": 19.22,
  "20898": 8.43,
  "20901": 8.43,
  "20902": 8.43,
  "20903": 13.49,
  "20904": 8.43,
  "20905": 8.95,
  "20906": 8.43,
  "20907": 13.49,
  "20908": 8.43,
  "20910": 13.49,
  "20911": 13.49,
  "20912": 13.49,
  "20913": 13.49,
  "20914": 8.43,
  "20915": 8.43,
  "20916": 8.43,
  "20918": 8.43,
  "21001": 2.45,
  "21005": 1.9,
  "21009": 0.31,
  "21010": 0.31,
  "21012": 6.59,
  "21013": 4.2,
  "21014": 0.31,
  "21015": 0.31,
  "21017": 0.31,
  "21018": 0.31,
  "21020": -1.99,
  "21022": 4.45,
  "21023": 4.45,
  "21027": 4.45,
  "21028": 0.31,
  "21029": 22.6,
  "21030": 4.45,
  "21031": 4.45,
  "21032": 7.11,
  "21034": 2.45,
  "21035": 17.38,
  "21036": 22.6,
  "21037": 6.59,
  "21040": 0.31,
  "21041": 15.7,
  "21042": 15.7,
  "21043": 15.7,
  "21044": 11.81,
  "21045": 11.81,
  "21046": 11.81,
  "21047": 0.31,
  "21048": -1.99,
  "21050": 0.31,
  "21051": 0.31,
  "21052": 3.53,
  "21053": 11.9,
  "21054": 6.59,
  "21056": 17.38,
  "21057": 6.04,
  "21060": 4.45,
  "21061": 4.45,
  "21071": 1.9,
  "21074": -1.99,
  "21075": 11.81,
  "21076": 11.81,
  "21077": 4.45,
  "21078": 0.15,
  "21082": 0.31,
  "21084": 0.31,
  "21085": 0.31,
  "21087": 0.31,
  "21088": 3.93,
  "21090": 3.53,
  "21092": 6.04,
  "21093": 4.45,
  "21094": 4.45,
  "21102": 11.9,
  "21104": 11.81,
  "21105": 3.41,
  "21106": 6.59,
  "21108": 7.11,
  "21111": 15.24,
  "21113": 6.59,
  "21114": 6.59,
  "21117": 4.45,
  "21120": 11.9,
  "21122": 6.59,
  "21123": 6.59,
  "21128": 4.45,
  "21130": 0.31,
  "21131": 15.24,
  "21132": 7.76,
  "21133": 4.45,
  "21136": -1.99,
  "21139": 4.45,
  "21140": 7.11,
  "21144": 4.45,
  "21146": 7.11,
  "21150": 11.81,
  "21152": 4.45,
  "21153": 4.45,
  "21154": 8.8,
  "21155": -1.99,
  "21156": 0.31,
  "21157": 0.15,
  "21158": -0.4,
  "21160": 0.31,
  "21161": 7.76,
  "21162": 4.45,
  "21163": 11.81,
  "21201": 3.53,
  "21202": 3.01,
  "21203": 3.01,
  "21204": 4.45,
  "21205": 3.01,
  "21206": 4.45,
  "21207": 3.53,
  "21208": 4.45,
  "21209": 4.45,
  "21210": 4.45,
  "21211": 3.01,
  "21212": 4.45,
  "21213": 3.01,
  "21214": 4.45,
  "21215": 3.93,
  "21216": 3.01,
  "21217": 3.01,
  "21218": 3.01,
  "21219": 3.53,
  "21220": 4.45,
  "21221": 3.53,
  "21222": 3.53,
  "21223": 3.01,
  "21224": 3.01,
  "21225": 3.53,
  "21226": 3.53,
  "21227": 3.53,
  "21228": 4.45,
  "21229": 3.01,
  "21230": 3.53,
  "21231": 3.53,
  "21233": 3.01,
  "21234": 4.45,
  "21236": 4.45,
  "21237": 3.53,
  "21239": 4.45,
  "21240": 4.45,
  "21244": 3.93,
  "21270": 3.93,
  "21281": 3.01,
  "21282": 4.45,
  "21284": 4.45,
  "21285": 4.45,
  "21286": 4.45,
  "21297": 3.01,
  "21401": 7.11,
  "21402": 10.48,
  "21403": 7.11,
  "21404": 7.11,
  "21405": 10.48,
  "21409": 10.48,
  "21501": -5.33,
  "21502": -5.33,
  "21503": -5.33,
  "21504": -5.33,
  "21505": -5.33,
  "21520": -9.87,
  "21521": -5.33,
  "21522": -10.39,
  "21523": -10.39,
  "21524": -4.81,
  "21528": -5.33,
  "21529": -5.33,
  "21530": -5.33,
  "21531": -10.39,
  "21532": -5.33,
  "21536": -9.87,
  "21538": -10.39,
  "21539": -5.33,
  "21540": -10.39,
  "21541": -1.9,
  "21542": -5.33,
  "21543": -4.81,
  "21545": -5.33,
  "21550": -9.87,
  "21555": -5.33,
  "21556": -5.33,
  "21557": -4.81,
  "21560": -5.33,
  "21561": -9.87,
  "21562": -10.39,
  "21601": -4.91,
  "21607": -5,
  "21609": -0.31,
  "21610": -4.45,
  "21612": -4.91,
  "21613": -7.67,
  "21617": -2.61,
  "21619": -2.61,
  "21620": -4.45,
  "21622": -7.67,
  "21623": -3.16,
  "21624": -4.39,
  "21625": -0.31,
  "21626": -7.67,
  "21627": -7.67,
  "21628": -5.52,
  "21629": -0.86,
  "21631": -7.67,
  "21632": -1.38,
  "21634": -7.67,
  "21635": -5,
  "21636": -0.86,
  "21638": -2.09,
  "21639": -0.86,
  "21640": 2.76,
  "21641": -0.86,
  "21643": -8.74,
  "21644": -5,
  "21645": 3.49,
  "21647": -4.91,
  "21648": -7.67,
  "21649": 2.76,
  "21650": -5,
  "21651": -5,
  "21652": -4.91,
  "21653": -4.39,
  "21654": -1.02,
  "21655": -0.31,
  "21656": -3.16,
  "21657": -0.86,
  "21658": -2.09,
  "21659": -8.74,
  "21660": -0.86,
  "21661": -2.61,
  "21662": -4.39,
  "21663": -4.39,
  "21664": -7.67,
  "21665": -4.39,
  "21666": -2.61,
  "21667": -4.45,
  "21668": -5,
  "21669": 5.21,
  "21670": 2.76,
  "21671": -4.91,
  "21672": -7.67,
  "21673": -4.91,
  "21675": -7.67,
  "21676": -4.91,
  "21677": -7.67,
  "21678": -6.59,
  "21679": -0.86,
  "21701": 3.37,
  "21702": 2.82,
  "21703": 2.82,
  "21704": 3.37,
  "21705": 2.82,
  "21710": 3.37,
  "21711": -5.12,
  "21713": -3.53,
  "21714": 3.37,
  "21715": 3.37,
  "21716": 2.82,
  "21717": 3.37,
  "21718": 3.37,
  "21719": -5.12,
  "21720": -3.53,
  "21721": -4.6,
  "21722": -4.6,
  "21723": 22.6,
  "21727": 2.82,
  "21733": -3.53,
  "21734": -5.12,
  "21737": 22.6,
  "21738": 22.6,
  "21740": -5.12,
  "21741": -5.12,
  "21742": -4.6,
  "21747": -5.12,
  "21750": -5.12,
  "21754": 3.37,
  "21755": 3.37,
  "21756": 3.37,
  "21757": 3.37,
  "21758": 2.82,
  "21759": 3.37,
  "21762": 2.82,
  "21765": 13.95,
  "21766": -4.81,
  "21767": -4.6,
  "21769": 3.37,
  "21770": 3.37,
  "21771": 0.15,
  "21773": 3.37,
  "21774": 3.37,
  "21775": 3.37,
  "21776": 0.15,
  "21777": 2.82,
  "21778": 3.37,
  "21779": 2.82,
  "21780": 10.27,
  "21781": -3.53,
  "21782": -4.6,
  "21783": -3.53,
  "21784": 22.6,
  "21787": -0.4,
  "21788": 2.82,
  "21790": 3.37,
  "21791": 0.15,
  "21792": 2.82,
  "21793": 2.82,
  "21794": 22.6,
  "21795": -4.6,
  "21797": 13.95,
  "21798": 3.37,
  "21801": -4.54,
  "21802": -5.06,
  "21803": -4.54,
  "21804": -5.06,
  "21810": -4.54,
  "21811": -8.22,
  "21813": -8.22,
  "21814": -3.99,
  "21817": -5.06,
  "21821": -3.99,
  "21822": -5.06,
  "21824": -5.58,
  "21826": -5.06,
  "21829": -8.74,
  "21830": -4.54,
  "21835": -7.67,
  "21836": -3.99,
  "21837": -5.06,
  "21838": -5.06,
  "21840": -3.99,
  "21841": -8.74,
  "21842": -8.22,
  "21843": -8.22,
  "21849": -5.06,
  "21850": -8.74,
  "21851": -5.06,
  "21852": -8.74,
  "21853": -5.06,
  "21856": -3.99,
  "21857": -5.06,
  "21861": -5.06,
  "21862": -8.74,
  "21863": -8.22,
  "21864": -8.74,
  "21865": -3.99,
  "21866": -5.58,
  "21867": -3.99,
  "21869": -7.67,
  "21871": -3.99,
  "21872": -8.74,
  "21874": -8.74,
  "21875": -5.06,
  "21901": 0.15,
  "21902": 0.15,
  "21903": 0.15,
  "21904": 0.15,
  "21911": 0.15,
  "21912": 1.74,
  "21913": 0.15,
  "21914": 0.15,
  "21915": 0.15,
  "21916": 0.15,
  "21917": 0.15,
  "21918": 2.45,
  "21919": 0.15,
  "21920": 0.15,
  "21921": 0.15,
  "21922": 0.15,
  "21930": -4.45,
  "22003": 13.09,
  "22009": 13.09,
  "22015": 13.09,
  "22025": 1.59,
  "22026": 3.37,
  "22027": 64.36,
  "22030": 2.51,
  "22031": 13.09,
  "22032": 2.51,
  "22033": 2.51,
  "22034": 13.09,
  "22035": 2.51,
  "22036": 13.09,
  "22038": 2.51,
  "22039": 13.3,
  "22040": 53.57,
  "22041": 22.23,
  "22042": 53.05,
  "22043": 53.57,
  "22044": 53.57,
  "22046": 53.57,
  "22060": 12.11,
  "22066": 13.3,
  "22067": 64.36,
  "22079": 12.57,
  "22081": 64.36,
  "22101": 64.36,
  "22102": 64.36,
  "22103": 64.36,
  "22106": 64.36,
  "22116": 13.09,
  "22121": 12.11,
  "22122": 12.11,
  "22124": 6.4,
  "22125": 3.37,
  "22134": -9.14,
  "22150": 12.57,
  "22151": 13.09,
  "22152": 13.09,
  "22153": 13.09,
  "22172": 2.82,
  "22180": 13.09,
  "22181": 4.81,
  "22182": 57.46,
  "22183": 13.09,
  "22191": 3.37,
  "22192": 3.37,
  "22193": 3.37,
  "22194": 3.37,
  "22195": 3.37,
  "22199": 12.57,
  "22201": 22.75,
  "22202": 12.63,
  "22203": 22.75,
  "22204": 22.23,
  "22205": 22.75,
  "22206": 12.11,
  "22207": 25.05,
  "22209": 22.23,
  "22210": 22.75,
  "22211": 22.23,
  "22213": 53.57,
  "22214": 12.63,
  "22215": 12.63,
  "22216": 22.23,
  "22219": 22.23,
  "22301": 12.63,
  "22302": 12.63,
  "22303": 12.11,
  "22304": 12.11,
  "22305": 12.63,
  "22306": 12.11,
  "22307": 12.63,
  "22308": 12.63,
  "22309": 12.11,
  "22310": 12.11,
  "22311": 12.63,
  "22312": 12.63,
  "22313": 12.57,
  "22314": 12.63,
  "22315": 12.11,
  "22320": 12.63,
  "22331": 12.63,
  "22332": 12.63,
  "22401": 4.66,
  "22402": 1.9,
  "22403": 4.66,
  "22404": 4.66,
  "22405": 4.66,
  "22406": -8.59,
  "22407": 1.9,
  "22408": 4.66,
  "22427": -3.16,
  "22430": 4.66,
  "22432": -10.12,
  "22433": -3.62,
  "22435": -0.4,
  "22436": -13.86,
  "22437": -6.5,
  "22438": -12.82,
  "22442": -0.4,
  "22443": -7.76,
  "22446": 4.66,
  "22448": -1.23,
  "22451": -1.78,
  "22454": -1.44,
  "22456": -10.12,
  "22460": -1.44,
  "22463": -8.59,
  "22469": -0.4,
  "22471": -8.59,
  "22472": -0.4,
  "22473": -10.12,
  "22476": -12.82,
  "22480": 0,
  "22481": -1.78,
  "22482": 0,
  "22485": -1.78,
  "22488": -0.4,
  "22501": -3.16,
  "22503": 10.79,
  "22504": -0.52,
  "22507": 10.79,
  "22508": 1.9,
  "22509": -12.82,
  "22511": -9.6,
  "22513": 0,
  "22514": -3.16,
  "22517": 0,
  "22520": -7.76,
  "22523": -0.52,
  "22524": -0.4,
  "22526": -1.23,
  "22528": 10.79,
  "22529": -0.4,
  "22530": -10.12,
  "22534": 1.9,
  "22535": -1.78,
  "22538": -1.78,
  "22539": -10.12,
  "22542": -9.6,
  "22544": -12.27,
  "22545": -8.59,
  "22546": -3.16,
  "22547": -1.78,
  "22548": 9.35,
  "22551": 1.9,
  "22552": -3.16,
  "22553": 1.9,
  "22554": -8.59,
  "22555": -8.59,
  "22556": -8.59,
  "22558": -7.76,
  "22560": -13.86,
  "22565": -3.16,
  "22567": -9.6,
  "22570": -0.4,
  "22572": -0.4,
  "22576": 0,
  "22577": -0.4,
  "22578": 0,
  "22579": -8.53,
  "22580": -3.16,
  "22581": -7.76,
  "22601": -4.6,
  "22602": -4.6,
  "22603": -4.6,
  "22604": -4.6,
  "22610": -5.92,
  "22611": -0.37,
  "22620": -0.4,
  "22622": -4.6,
  "22623": -5.37,
  "22624": -5.12,
  "22625": 1.78,
  "22626": -10.39,
  "22627": -4.91,
  "22630": -5.92,
  "22637": -6.19,
  "22639": 3.12,
  "22640": -5.37,
  "22641": -6.19,
  "22642": -5.92,
  "22643": 5.42,
  "22644": -9.87,
  "22645": -6.96,
  "22646": -0.4,
  "22649": -6.96,
  "22650": -5.46,
  "22652": -7.76,
  "22654": -8.8,
  "22655": -4.6,
  "22656": -5.12,
  "22657": -8.03,
  "22660": -9.87,
  "22663": -0.4,
  "22664": -8.8,
  "22701": -3.62,
  "22709": -8.68,
  "22711": -9.2,
  "22712": 0.52,
  "22713": -5.46,
  "22714": -3.62,
  "22715": -8.68,
  "22716": -4.91,
  "22718": -3.07,
  "22719": -9.2,
  "22720": -8.59,
  "22721": -8.68,
  "22722": -8.68,
  "22723": -11.9,
  "22724": 1.07,
  "22725": -8.68,
  "22726": -3.62,
  "22727": -8.68,
  "22728": 0.52,
  "22729": -3.62,
  "22730": -10.12,
  "22731": -8.68,
  "22732": -8.68,
  "22733": -9.6,
  "22734": -3.62,
  "22735": -8.68,
  "22736": 5.21,
  "22737": -3.62,
  "22738": -8.68,
  "22739": -8.59,
  "22740": -5.46,
  "22741": -3.07,
  "22742": -8.59,
  "22743": -9.2,
  "22746": -4.91,
  "22747": 3.58,
  "22748": -11.9,
  "22749": -3.87,
  "22801": -3.16,
  "22802": -4.54,
  "22803": -3.16,
  "22810": -7.76,
  "22811": -8.28,
  "22812": -3.16,
  "22815": -4.54,
  "22820": -5.06,
  "22821": -3.16,
  "22824": -7.76,
  "22827": -11.9,
  "22830": -4.54,
  "22831": -3.16,
  "22832": -4.54,
  "22833": -4.54,
  "22834": -4.54,
  "22835": -12.36,
  "22840": -4.54,
  "22841": -3.16,
  "22842": -7.76,
  "22843": -1.78,
  "22844": -12.36,
  "22845": -7.76,
  "22846": -3.16,
  "22847": -12.36,
  "22848": -3.16,
  "22849": -12.88,
  "22850": -4.54,
  "22851": -12.88,
  "22853": -4.54,
  "22901": 3.28,
  "22902": 3.28,
  "22903": 1.44,
  "22904": 3.28,
  "22905": 3.28,
  "22906": 3.28,
  "22911": 3.28,
  "22920": -12.82,
  "22922": -13.86,
  "22923": -11.9,
  "22924": 1.44,
  "22931": -12.82,
  "22932": 1.44,
  "22935": -11.9,
  "22936": 3.28,
  "22937": -12.82,
  "22938": -12.82,
  "22939": -1.78,
  "22940": -11.9,
  "22942": -9.6,
  "22943": 1.44,
  "22945": 1.44,
  "22946": 1.44,
  "22947": 3.28,
  "22948": -10.12,
  "22949": -12.82,
  "22952": -1.78,
  "22957": -9.6,
  "22958": -12.82,
  "22959": 1.44,
  "22960": -9.6,
  "22963": 2.82,
  "22964": -13.86,
  "22965": -11.9,
  "22967": -12.82,
  "22968": -11.9,
  "22969": -13.34,
  "22971": -12.82,
  "22972": -9.6,
  "22973": -11.9,
  "22974": 2.82,
  "22976": -12.82,
  "22980": -1.78,
  "22987": 1.44,
  "22989": -9.6,
  "23001": -3.28,
  "23002": -9.72,
  "23003": -2.76,
  "23004": -16.56,
  "23005": 4.54,
  "23009": -6.04,
  "23011": 13.8,
  "23014": 13.8,
  "23015": 1.9,
  "23018": -2.76,
  "23021": -10.58,
  "23022": 2.3,
  "23023": -6.5,
  "23024": 1.9,
  "23025": -11.1,
  "23027": -14.72,
  "23030": -1.59,
  "23031": -6.9,
  "23032": -7.42,
  "23035": -10.58,
  "23038": 2.3,
  "23039": 13.8,
  "23040": -14.72,
  "23043": -10.58,
  "23045": -10.58,
  "23047": 5.06,
  "23050": -10.58,
  "23055": 2.82,
  "23056": -11.1,
  "23058": 4.54,
  "23059": 6.13,
  "23060": 4.54,
  "23061": -2.76,
  "23062": -4.14,
  "23063": 13.8,
  "23064": -11.1,
  "23065": 13.28,
  "23066": -10.58,
  "23067": 13.28,
  "23068": -10.58,
  "23069": 4.54,
  "23070": -6.9,
  "23071": -6.9,
  "23072": -2.76,
  "23075": 8.22,
  "23076": -10.58,
  "23079": -0.52,
  "23081": -2.3,
  "23083": -9.72,
  "23084": -2.24,
  "23085": -6.5,
  "23086": -6.04,
  "23089": 13.8,
  "23090": -1.38,
  "23091": -6.5,
  "23092": -7.42,
  "23093": -2.24,
  "23101": -1.9,
  "23102": 13.8,
  "23103": 21.77,
  "23105": -7.63,
  "23106": -6.04,
  "23107": -3.28,
  "23108": -6.5,
  "23109": -11.1,
  "23110": -6.5,
  "23111": 5.06,
  "23112": 1.78,
  "23113": 2.3,
  "23114": 1.78,
  "23115": -6.5,
  "23116": 5.06,
  "23117": 13.28,
  "23119": -10.58,
  "23120": -1.38,
  "23123": -14.72,
  "23124": 13.8,
  "23125": -10.58,
  "23126": -13.86,
  "23127": -1.38,
  "23128": -10.58,
  "23129": 21.77,
  "23130": -11.1,
  "23131": 8.03,
  "23138": -10.58,
  "23139": -1.9,
  "23140": 13.28,
  "23141": 13.28,
  "23146": 13.8,
  "23147": -1.59,
  "23148": -13.86,
  "23149": -7.42,
  "23150": 8.22,
  "23153": 13.28,
  "23154": -3.28,
  "23155": -3.28,
  "23156": -6.5,
  "23160": 13.8,
  "23161": -6.5,
  "23162": 5.06,
  "23163": -10.58,
  "23168": -1.38,
  "23169": -6.9,
  "23170": -2.24,
  "23175": -6.9,
  "23176": -6.9,
  "23177": -6.04,
  "23178": -3.28,
  "23180": 0,
  "23181": -6.5,
  "23183": 8.03,
  "23184": 8.03,
  "23185": -2.3,
  "23187": -2.3,
  "23188": -1.38,
  "23190": -6.5,
  "23192": 13.8,
  "23218": 8.22,
  "23219": 8.22,
  "23220": 8.22,
  "23221": 2.3,
  "23222": 1.78,
  "23223": 8.22,
  "23224": 8.22,
  "23225": 8.22,
  "23226": 2.3,
  "23227": 1.78,
  "23228": 1.78,
  "23229": 2.3,
  "23230": 1.78,
  "23231": 8.22,
  "23232": 8.22,
  "23233": 2.3,
  "23234": 1.78,
  "23235": 8.22,
  "23236": 1.78,
  "23237": 1.78,
  "23238": 2.3,
  "23240": 8.22,
  "23241": 1.78,
  "23242": 2.3,
  "23250": 8.22,
  "23255": 2.3,
  "23260": 8.22,
  "23261": 8.22,
  "23284": 8.22,
  "23285": 8.22,
  "23294": 1.78,
  "23298": 8.22,
  "23301": -10.12,
  "23302": -10.12,
  "23303": -10.12,
  "23304": 3.22,
  "23306": -11.5,
  "23307": -12.02,
  "23308": -10.64,
  "23310": -11.5,
  "23313": -11.5,
  "23314": 3.22,
  "23315": -2.7,
  "23316": -12.02,
  "23320": 2.7,
  "23321": 3.62,
  "23322": 2.7,
  "23323": 2.15,
  "23324": 2.15,
  "23325": 2.7,
  "23327": 2.7,
  "23328": 2.7,
  "23336": -10.12,
  "23337": -10.12,
  "23341": -10.64,
  "23345": -11.5,
  "23347": -12.02,
  "23350": -12.02,
  "23354": -3.01,
  "23356": -10.12,
  "23357": -10.64,
  "23358": -10.64,
  "23359": -10.12,
  "23389": -10.64,
  "23395": -10.64,
  "23396": -10.64,
  "23397": -2.7,
  "23398": -12.02,
  "23399": -10.64,
  "23401": -10.64,
  "23404": -10.64,
  "23405": -11.5,
  "23407": -10.12,
  "23408": -12.02,
  "23409": -10.64,
  "23410": -10.64,
  "23412": -10.12,
  "23413": -12.02,
  "23414": -10.12,
  "23415": -10.64,
  "23416": -10.64,
  "23417": -10.12,
  "23418": -10.12,
  "23419": -12.02,
  "23420": -10.64,
  "23421": -10.64,
  "23422": -10.64,
  "23423": -10.64,
  "23424": 3.22,
  "23426": -10.64,
  "23427": -10.64,
  "23429": -12.02,
  "23430": -3.22,
  "23431": -3.22,
  "23432": 5.79,
  "23433": 12.11,
  "23434": 5.58,
  "23435": 3.62,
  "23436": 3.62,
  "23437": 5.58,
  "23438": 5.58,
  "23439": 5.58,
  "23440": -10.64,
  "23441": -10.12,
  "23442": -10.64,
  "23443": -12.02,
  "23450": 0.52,
  "23451": 9.01,
  "23452": 0.52,
  "23453": 0.52,
  "23454": 1.07,
  "23455": 1.07,
  "23456": 0.52,
  "23457": 2.11,
  "23458": 9.01,
  "23459": 9.01,
  "23460": 1.07,
  "23461": 9.01,
  "23462": 0.52,
  "23464": 0.52,
  "23466": 0.52,
  "23467": 0.52,
  "23471": 1.07,
  "23480": -10.12,
  "23482": -12.02,
  "23483": -10.64,
  "23486": -12.02,
  "23487": -2.7,
  "23488": -10.64,
  "23501": 6.38,
  "23502": 6.38,
  "23503": 6.38,
  "23504": 6.38,
  "23505": 6.38,
  "23506": 6.38,
  "23507": 14.87,
  "23508": 6.9,
  "23509": 6.38,
  "23510": 14.87,
  "23511": 6.38,
  "23513": 6.38,
  "23514": 14.87,
  "23517": 6.9,
  "23518": 6.38,
  "23519": 6.38,
  "23520": 14.87,
  "23521": 6.9,
  "23523": 6.38,
  "23541": 6.38,
  "23601": 2.7,
  "23602": 3.22,
  "23603": -4.66,
  "23604": 1.32,
  "23605": 1.84,
  "23606": 3.22,
  "23607": 1.32,
  "23608": -4.14,
  "23609": 1.32,
  "23612": 3.22,
  "23651": 1.84,
  "23661": 1.84,
  "23662": 0.67,
  "23663": 1.84,
  "23664": 1.84,
  "23665": 1.84,
  "23666": 1.84,
  "23669": 1.84,
  "23670": 1.84,
  "23690": -4.66,
  "23691": -4.66,
  "23692": -4.14,
  "23693": -7.82,
  "23694": -4.66,
  "23696": -4.14,
  "23701": 3.07,
  "23702": 3.07,
  "23703": 3.07,
  "23704": 3.07,
  "23705": 3.07,
  "23707": 3.07,
  "23708": 3.07,
  "23709": 3.07,
  "23801": -7.17,
  "23803": -6.65,
  "23804": -6.65,
  "23805": -6.65,
  "23821": -0.67,
  "23822": -7.11,
  "23824": -10.33,
  "23827": -7.82,
  "23828": -7.82,
  "23829": -7.3,
  "23830": 15.89,
  "23831": -5.06,
  "23832": 1.78,
  "23833": -7.11,
  "23834": -6.65,
  "23836": -6.65,
  "23837": -7.3,
  "23838": 9.2,
  "23839": -9.66,
  "23840": -7.11,
  "23841": -7.11,
  "23842": -9.87,
  "23843": -0.67,
  "23844": -9.93,
  "23845": -15.7,
  "23846": -10.18,
  "23847": -3.95,
  "23850": -7.63,
  "23851": -7.3,
  "23856": -3.95,
  "23857": 8.89,
  "23860": -9.87,
  "23866": -2.7,
  "23867": -3.95,
  "23868": 8.89,
  "23872": -7.11,
  "23873": -1.19,
  "23874": -7.3,
  "23875": -9.87,
  "23876": -0.67,
  "23878": -7.3,
  "23879": -3.95,
  "23881": -11.25,
  "23882": 15.37,
  "23883": -10.18,
  "23884": 15.89,
  "23885": -7.11,
  "23887": 8.89,
  "23888": -9.66,
  "23889": -0.67,
  "23890": 15.37,
  "23893": -0.15,
  "23894": -7.11,
  "23897": 15.89,
  "23898": -1.11,
  "23899": -11.25,
  "23901": 0.86,
  "23915": -7.42,
  "23917": -7.42,
  "23919": -15.7,
  "23920": -1.19,
  "23921": -16.56,
  "23922": -10.33,
  "23923": -16.16,
  "23924": -9.01,
  "23927": -6.38,
  "23930": -10.85,
  "23934": -16.16,
  "23936": -16.56,
  "23937": -16.71,
  "23938": -0.73,
  "23939": -8.43,
  "23941": -16.71,
  "23942": -0.73,
  "23943": 9.35,
  "23944": -0.73,
  "23947": -0.73,
  "23950": -1.19,
  "23952": -0.21,
  "23954": 0.86,
  "23955": -10.85,
  "23958": -8.43,
  "23959": -16.71,
  "23960": 0.86,
  "23962": -16.71,
  "23963": -7.88,
  "23964": -17.75,
  "23966": 0.86,
  "23967": -16.71,
  "23968": -9.01,
  "23970": -8.49,
  "23974": -0.73,
  "23976": -17.75,
  "24001": -1.07,
  "24002": -1.07,
  "24003": -1.07,
  "24004": -1.07,
  "24005": -1.07,
  "24006": -1.07,
  "24007": -1.07,
  "24008": -1.07,
  "24009": -1.07,
  "24010": -1.07,
  "24011": -1.07,
  "24012": -0.52,
  "24013": -1.07,
  "24014": -0.52,
  "24015": -0.98,
  "24016": -1.07,
  "24017": -1.07,
  "24018": 6.96,
  "24019": -0.52,
  "24020": 6.96,
  "24022": -1.07,
  "24023": -1.07,
  "24024": -1.07,
  "24025": -1.07,
  "24026": -1.07,
  "24027": -1.07,
  "24028": -1.07,
  "24029": -1.07,
  "24030": -1.07,
  "24031": -1.07,
  "24032": -1.07,
  "24033": -1.07,
  "24034": -1.07,
  "24035": -1.07,
  "24036": -1.07,
  "24037": -1.07,
  "24038": -1.07,
  "24053": -11.04,
  "24054": -12.63,
  "24055": -12.63,
  "24058": -11.19,
  "24059": 6.96,
  "24060": 1.44,
  "24062": 1.44,
  "24063": 1.44,
  "24064": -4.08,
  "24065": -7.42,
  "24066": -5.12,
  "24067": -7.42,
  "24068": -6.5,
  "24069": -12.63,
  "24070": 6.96,
  "24072": -10.64,
  "24073": -6.5,
  "24076": -16.1,
  "24077": 7.42,
  "24078": -12.63,
  "24079": -11.19,
  "24082": -15.58,
  "24083": 2.82,
  "24084": -11.19,
  "24085": -5.67,
  "24086": -7.05,
  "24087": -7.05,
  "24088": -7.42,
  "24089": -13.15,
  "24090": -4.08,
  "24091": -11.19,
  "24092": -7.42,
  "24093": -11.19,
  "24095": -6.96,
  "24101": -0.52,
  "24102": -12.11,
  "24104": 0.98,
  "24105": -11.19,
  "24111": 1.44,
  "24112": -12.63,
  "24113": -12.63,
  "24114": -12.63,
  "24115": -12.63,
  "24120": -16.1,
  "24121": 0.98,
  "24122": -5.12,
  "24124": -11.19,
  "24126": -11.19,
  "24127": -5.12,
  "24128": -6.5,
  "24129": -11.19,
  "24130": -5.67,
  "24131": -5.67,
  "24132": -10.64,
  "24133": -16.1,
  "24134": -11.19,
  "24136": -7.05,
  "24137": -9.87,
  "24138": -10.64,
  "24139": -10.39,
  "24141": -10.64,
  "24142": -11.19,
  "24143": -10.64,
  "24146": -7.42,
  "24147": -11.19,
  "24148": -12.63,
  "24149": -10.64,
  "24150": -11.19,
  "24151": -7.97,
  "24153": -0.98,
  "24161": -9.87,
  "24162": -7.05,
  "24165": -12.63,
  "24167": -11.19,
  "24168": -13.15,
  "24171": -16.1,
  "24174": -7.51,
  "24175": 2.82,
  "24176": 0.52,
  "24177": -16.1,
  "24178": -5.12,
  "24179": -0.52,
  "24184": -7.42,
  "24185": -11.19,
  "24201": -8.03,
  "24202": -8.03,
  "24203": -8.03,
  "24209": -8.03,
  "24210": 0.46,
  "24211": 0.46,
  "24212": 0.46,
  "24215": -13.86,
  "24216": -14.41,
  "24217": -4.35,
  "24218": -2.82,
  "24219": -13.86,
  "24220": -4.35,
  "24221": -3.37,
  "24224": -8.49,
  "24225": -8.49,
  "24226": -4.35,
  "24228": -4.35,
  "24230": -14.93,
  "24236": -8.03,
  "24237": -4.87,
  "24239": -11.71,
  "24243": -2.82,
  "24244": -15.7,
  "24245": -13.86,
  "24246": -13.86,
  "24248": 13.19,
  "24250": -15.7,
  "24251": -14.66,
  "24256": -4.35,
  "24258": 1.32,
  "24260": -8.49,
  "24263": -2.82,
  "24265": -3.37,
  "24266": -8.49,
  "24269": -4.87,
  "24270": -8.49,
  "24271": -14.66,
  "24272": -4.35,
  "24273": -13.86,
  "24277": -2.82,
  "24279": -13.86,
  "24280": 0,
  "24281": 6.38,
  "24282": -3.37,
  "24283": -8.49,
  "24290": -7.76,
  "24292": -7.57,
  "24293": -13.86,
  "24301": -11.19,
  "24311": -7.57,
  "24312": -12.11,
  "24313": -11.19,
  "24314": -6.13,
  "24315": -6.13,
  "24316": -7.57,
  "24317": -11.04,
  "24318": -7.57,
  "24319": -7.57,
  "24322": -5.06,
  "24323": -6.65,
  "24324": -10.64,
  "24325": -12.11,
  "24326": -18.15,
  "24327": -8.03,
  "24328": -11.04,
  "24330": -17.08,
  "24333": -11.04,
  "24340": -8.03,
  "24343": -11.04,
  "24347": -11.19,
  "24348": -18.15,
  "24350": -5.06,
  "24351": -11.04,
  "24352": -11.04,
  "24354": -7.57,
  "24360": -6.13,
  "24361": -8.03,
  "24363": -18.15,
  "24366": -6.13,
  "24368": -6.65,
  "24370": -7.57,
  "24374": -6.65,
  "24375": -7.57,
  "24377": -7.57,
  "24378": -7.57,
  "24380": -11.19,
  "24381": -11.04,
  "24382": -6.65,
  "24401": -1.78,
  "24402": -1.78,
  "24411": -2.3,
  "24412": -10.18,
  "24413": -14.26,
  "24415": -8.8,
  "24416": -10.18,
  "24421": -1.78,
  "24422": -10.73,
  "24426": -5.67,
  "24430": -2.3,
  "24431": -2.3,
  "24432": -13.74,
  "24433": -13.74,
  "24435": -8.8,
  "24437": -1.78,
  "24438": -10.73,
  "24439": -8.8,
  "24440": -2.3,
  "24441": -3.16,
  "24442": -14.26,
  "24445": -10.73,
  "24448": -10.73,
  "24450": 19.93,
  "24457": -10.73,
  "24458": -13.74,
  "24459": -1.78,
  "24460": -10.18,
  "24463": -1.78,
  "24464": -13.86,
  "24465": -13.74,
  "24467": -1.78,
  "24468": -13.74,
  "24469": -1.78,
  "24471": -3.16,
  "24472": -12.82,
  "24473": -0.31,
  "24474": -10.73,
  "24476": -13.86,
  "24477": -1.78,
  "24479": -1.78,
  "24482": -1.78,
  "24483": -10.18,
  "24484": -14.78,
  "24485": -14.26,
  "24486": -3.16,
  "24487": -14.78,
  "24501": 12.27,
  "24502": 12.82,
  "24503": 21.31,
  "24504": 12.27,
  "24505": 12.27,
  "24506": 12.27,
  "24517": -3.74,
  "24520": -5.73,
  "24521": -7.88,
  "24522": -7.88,
  "24523": -24.9,
  "24526": -10.18,
  "24527": -9.87,
  "24528": -4.29,
  "24529": -5.73,
  "24530": -9.87,
  "24531": -9.87,
  "24533": -7.88,
  "24534": -17.23,
  "24535": -5.73,
  "24536": 12.82,
  "24538": -7.88,
  "24539": -6.25,
  "24540": -9.87,
  "24541": -9.87,
  "24543": -9.87,
  "24549": -9.87,
  "24550": -3.74,
  "24551": 21.31,
  "24553": -7.88,
  "24554": -3.74,
  "24555": -10.18,
  "24556": -16.41,
  "24557": -9.87,
  "24558": -5.73,
  "24562": -12.82,
  "24563": -3.74,
  "24565": -10.39,
  "24566": -9.87,
  "24569": -3.74,
  "24570": -16.41,
  "24571": -3.74,
  "24572": 12.82,
  "24574": 21.31,
  "24576": -4.29,
  "24577": -4.66,
  "24578": 11.44,
  "24579": -10.73,
  "24580": -5.73,
  "24581": -14.41,
  "24586": -9.87,
  "24588": -3.74,
  "24589": -5.73,
  "24590": 2.82,
  "24592": -5.73,
  "24593": -7.88,
  "24594": -5.73,
  "24595": -7.88,
  "24597": -6.25,
  "24598": -5.73,
  "24599": -17.08,
  "24601": -11.31,
  "24602": -11.31,
  "24603": -11.71,
  "24604": -11.31,
  "24605": -10.79,
  "24606": -11.31,
  "24607": -4.35,
  "24608": -10.79,
  "24609": -10.79,
  "24612": -10.79,
  "24613": -10.79,
  "24614": -11.71,
  "24619": -11.31,
  "24620": -11.71,
  "24622": -10.79,
  "24624": -11.71,
  "24627": -4.35,
  "24628": -12.23,
  "24630": -10.79,
  "24631": -11.71,
  "24634": -11.71,
  "24635": -10.79,
  "24637": -10.79,
  "24639": -11.71,
  "24640": -10.79,
  "24641": -10.79,
  "24646": -11.71,
  "24647": -11.71,
  "24649": -11.71,
  "24651": -10.79,
  "24656": -11.71,
  "24657": -11.71,
  "24658": -11.71,
  "24701": -9.35,
  "24712": -9.35,
  "24714": -8.28,
  "24715": -9.87,
  "24716": -16.56,
  "24719": -8.28,
  "24724": -10.39,
  "24726": -16.56,
  "24729": -8.28,
  "24731": -9.35,
  "24732": -9.35,
  "24733": -8.28,
  "24736": -8.28,
  "24737": -9.35,
  "24738": -9.35,
  "24739": -9.35,
  "24740": -9.35,
  "24747": -8.28,
  "24751": -10.39,
  "24801": -16.56,
  "24808": -10.39,
  "24811": -11.71,
  "24813": -11.31,
  "24815": -11.31,
  "24816": -16.56,
  "24817": -12.23,
  "24818": -16.56,
  "24822": -16.56,
  "24823": -16.56,
  "24826": -11.31,
  "24827": -16.56,
  "24828": -16.56,
  "24829": -16.56,
  "24830": -11.31,
  "24831": -10.39,
  "24834": -16.56,
  "24836": -11.31,
  "24839": -16.56,
  "24842": -16.56,
  "24843": -16.56,
  "24844": -16.56,
  "24845": -16.56,
  "24846": -12.42,
  "24847": -16.56,
  "24848": -11.31,
  "24849": -14.97,
  "24850": -12.23,
  "24851": -16.56,
  "24853": -16.56,
  "24854": -16.56,
  "24855": -8.28,
  "24857": -16.56,
  "24859": -16.56,
  "24860": -16.56,
  "24861": -10.39,
  "24862": -11.71,
  "24866": -11.31,
  "24867": -16.56,
  "24868": -8.28,
  "24869": -16.56,
  "24870": -16.56,
  "24871": -11.31,
  "24872": -12.23,
  "24873": -11.31,
  "24874": -16.56,
  "24878": -16.56,
  "24879": -12.23,
  "24880": -16.56,
  "24881": -16.56,
  "24882": -16.56,
  "24884": -11.31,
  "24887": -9.87,
  "24888": -16.56,
  "24892": -11.31,
  "24894": -10.79,
  "24895": -16.56,
  "24898": -16.56,
  "24901": -17.08,
  "24902": -17.08,
  "24910": -13.03,
  "24915": -17.02,
  "24916": -17.63,
  "24918": -11.19,
  "24920": -14.26,
  "24924": -18.09,
  "24925": -17.63,
  "24927": -18.09,
  "24931": -17.63,
  "24934": -16.5,
  "24935": -13.03,
  "24938": -17.63,
  "24941": -11.19,
  "24943": -13.03,
  "24944": -16.5,
  "24945": -11.19,
  "24946": -18.09,
  "24951": -13.03,
  "24954": -18.09,
  "24957": -17.63,
  "24962": -13.03,
  "24963": -11.19,
  "24966": -17.63,
  "24970": -17.63,
  "24974": -11.19,
  "24976": -11.19,
  "24977": -17.08,
  "24981": -13.03,
  "24983": -11.19,
  "24984": -11.19,
  "24985": -13.03,
  "24986": -17.63,
  "24991": -17.63,
  "24993": -11.19,
  "25002": -15.64,
  "25003": 5.58,
  "25005": -18.34,
  "25007": -7.36,
  "25008": -7.36,
  "25009": -9.66,
  "25011": 13.55,
  "25015": 5.58,
  "25019": -18.86,
  "25021": -9.66,
  "25022": -12.67,
  "25024": -9.66,
  "25025": 5.58,
  "25026": 5.58,
  "25028": -9.66,
  "25030": -10.37,
  "25031": -15.64,
  "25033": 6.04,
  "25035": 5.06,
  "25036": -15.64,
  "25039": 5.06,
  "25040": -15.12,
  "25043": -18.86,
  "25044": -7.36,
  "25045": -18.86,
  "25047": -14.26,
  "25048": -9.66,
  "25049": -9.66,
  "25051": -9.66,
  "25053": -9.14,
  "25054": 5.06,
  "25057": -15.64,
  "25059": -18.86,
  "25060": -9.66,
  "25061": 5.06,
  "25062": -7.36,
  "25063": -18.86,
  "25064": 5.58,
  "25067": 5.06,
  "25070": 7.11,
  "25071": 5.58,
  "25075": 5.06,
  "25076": -14.26,
  "25079": -18.86,
  "25081": -9.14,
  "25082": 12.42,
  "25083": -15.64,
  "25085": -15.64,
  "25086": 5.06,
  "25088": -10.37,
  "25090": -15.64,
  "25093": -9.66,
  "25102": -15.64,
  "25103": -15.64,
  "25106": -12.69,
  "25107": 5.06,
  "25108": -9.14,
  "25109": 6.04,
  "25110": 5.58,
  "25111": -18.86,
  "25112": 5.58,
  "25113": -18.86,
  "25114": -9.66,
  "25115": -15.12,
  "25118": -15.64,
  "25119": -15.64,
  "25121": -14.26,
  "25123": -10.58,
  "25124": 6.04,
  "25125": -18.86,
  "25126": -15.12,
  "25130": -9.66,
  "25132": 5.06,
  "25133": -18.86,
  "25134": 5.06,
  "25136": -15.64,
  "25139": -15.64,
  "25140": -7.36,
  "25141": -18.86,
  "25142": -9.66,
  "25143": 6.04,
  "25148": -9.66,
  "25149": -9.66,
  "25152": -15.64,
  "25154": -9.66,
  "25156": 5.58,
  "25159": 6.04,
  "25160": -18.86,
  "25161": -15.64,
  "25162": 5.58,
  "25164": -18.34,
  "25165": -9.66,
  "25168": 6.04,
  "25169": -9.66,
  "25173": -15.12,
  "25174": -7.36,
  "25177": 6.04,
  "25180": -6.84,
  "25181": -9.66,
  "25183": -14.26,
  "25186": -15.64,
  "25187": 3.93,
  "25193": -9.66,
  "25201": 5.06,
  "25202": 6.04,
  "25203": -9.66,
  "25204": -9.66,
  "25205": -9.14,
  "25206": -9.66,
  "25208": -9.66,
  "25209": -9.66,
  "25211": -18.86,
  "25213": 14.01,
  "25214": 5.06,
  "25231": -7.76,
  "25234": 7.09,
  "25235": 9.2,
  "25239": -12.17,
  "25241": -10.06,
  "25243": -8.28,
  "25244": -10.58,
  "25245": -10.06,
  "25247": -12.69,
  "25248": -7.76,
  "25251": -8.28,
  "25252": -12.69,
  "25253": -12.69,
  "25259": -8.28,
  "25260": -12.69,
  "25261": 7.09,
  "25262": -12.17,
  "25264": -12.69,
  "25265": -12.69,
  "25266": -18.86,
  "25267": 7.09,
  "25268": 9.2,
  "25270": -17.23,
  "25271": -10.06,
  "25275": -12.69,
  "25276": -7.76,
  "25285": -18.34,
  "25286": -8.28,
  "25287": -12.69,
  "25301": 13.55,
  "25302": 5.58,
  "25303": 13.55,
  "25304": 13.55,
  "25305": 5.58,
  "25306": 5.06,
  "25309": 5.58,
  "25311": 5.58,
  "25312": 5.58,
  "25313": 14.01,
  "25314": 13.55,
  "25315": 5.06,
  "25320": 5.58,
  "25321": 13.55,
  "25322": 13.55,
  "25323": 13.55,
  "25324": 13.55,
  "25325": 13.55,
  "25326": 13.55,
  "25327": 13.55,
  "25328": 13.55,
  "25329": 13.55,
  "25330": 13.55,
  "25331": 13.55,
  "25332": 13.55,
  "25333": 13.55,
  "25334": 13.55,
  "25335": 13.55,
  "25336": 13.55,
  "25337": 13.55,
  "25338": 13.55,
  "25339": 13.55,
  "25350": 13.55,
  "25356": 14.01,
  "25357": 5.58,
  "25358": 5.58,
  "25360": 5.58,
  "25361": 5.58,
  "25362": 5.58,
  "25364": 13.55,
  "25365": 5.06,
  "25375": 13.55,
  "25387": 13.55,
  "25389": 13.55,
  "25401": -6.96,
  "25402": -6.96,
  "25403": -6.96,
  "25404": -6.96,
  "25405": -6.96,
  "25410": 3.83,
  "25411": -12.48,
  "25413": -6.96,
  "25414": -3.62,
  "25419": -4.6,
  "25420": -6.96,
  "25421": -6.96,
  "25422": -14.07,
  "25423": -3.62,
  "25425": 3.83,
  "25427": -6.96,
  "25428": -6.96,
  "25430": -4.66,
  "25431": -14.07,
  "25432": -3.62,
  "25434": -14.07,
  "25437": -14.07,
  "25438": -4.66,
  "25440": -6.96,
  "25441": -3.07,
  "25442": 3.83,
  "25443": 3.83,
  "25444": -13.55,
  "25446": -4.14,
  "25501": 1.38,
  "25502": 3.93,
  "25503": 3.93,
  "25504": 7.82,
  "25505": -13.74,
  "25506": -0.73,
  "25507": 6.44,
  "25508": -13.74,
  "25510": 5.52,
  "25511": -2.97,
  "25512": -2.97,
  "25514": -2.97,
  "25515": 3.93,
  "25517": -2.97,
  "25520": -0.67,
  "25521": 1.38,
  "25523": -0.21,
  "25524": -0.21,
  "25526": 14.01,
  "25529": -9.66,
  "25530": -2.05,
  "25534": -0.21,
  "25535": -2.97,
  "25537": -0.67,
  "25540": -0.73,
  "25541": -0.67,
  "25544": 8.28,
  "25545": 7.82,
  "25547": -14.26,
  "25550": -12.17,
  "25555": -2.97,
  "25557": -0.73,
  "25559": -0.67,
  "25560": 14.01,
  "25562": -2.97,
  "25564": 1.38,
  "25565": 1.38,
  "25567": 1.9,
  "25569": 14.01,
  "25570": -2.97,
  "25571": -0.21,
  "25572": 1.38,
  "25573": 1.38,
  "25601": -14.26,
  "25606": -14.26,
  "25607": -14.26,
  "25608": -11.9,
  "25611": -14.26,
  "25612": -12.67,
  "25614": -14.26,
  "25617": -14.26,
  "25621": -16.56,
  "25624": -14.26,
  "25625": -14.26,
  "25628": -14.26,
  "25630": -14.26,
  "25632": -14.26,
  "25634": -14.26,
  "25635": -13.74,
  "25637": -14.26,
  "25638": -14.26,
  "25639": -14.26,
  "25644": -14.26,
  "25646": -14.26,
  "25647": -14.26,
  "25649": -14.26,
  "25650": -14.26,
  "25651": -11.9,
  "25652": -14.26,
  "25653": -14.26,
  "25654": -14.26,
  "25661": -14.53,
  "25665": -14.53,
  "25666": -14.53,
  "25667": -14.01,
  "25669": -3.49,
  "25670": -14.01,
  "25671": -14.53,
  "25672": -12.42,
  "25674": -14.01,
  "25676": -14.01,
  "25678": -14.01,
  "25685": -14.01,
  "25686": -14.01,
  "25688": -14.53,
  "25690": -14.01,
  "25691": -14.53,
  "25692": -14.01,
  "25696": -14.01,
  "25699": -3.49,
  "25701": 0.92,
  "25702": -0.67,
  "25703": -1.19,
  "25704": -0.67,
  "25705": 0.92,
  "25706": 0.92,
  "25707": 0.92,
  "25708": -1.19,
  "25709": -1.19,
  "25710": -1.19,
  "25711": 0.92,
  "25712": 0.92,
  "25713": 0.92,
  "25714": 0.92,
  "25715": 0.92,
  "25716": 0.92,
  "25717": -1.19,
  "25718": -1.19,
  "25719": -1.19,
  "25720": 0.92,
  "25721": -1.19,
  "25722": -1.19,
  "25723": -1.19,
  "25724": -1.19,
  "25725": 0.92,
  "25726": 0.92,
  "25727": 0.92,
  "25728": 0.92,
  "25729": 0.92,
  "25770": -0.67,
  "25771": -0.67,
  "25772": 0.92,
  "25773": 0.92,
  "25774": 0.92,
  "25775": 0.92,
  "25776": 0.92,
  "25777": -0.67,
  "25778": 0.92,
  "25779": -0.67,
  "25801": -6.84,
  "25802": -6.84,
  "25810": -16.56,
  "25811": -16.56,
  "25812": -15.64,
  "25813": 1.13,
  "25817": -6.84,
  "25818": 1.13,
  "25820": -7.76,
  "25823": -7.36,
  "25825": -6.84,
  "25826": -16.56,
  "25827": -7.36,
  "25831": -15.64,
  "25832": 1.13,
  "25833": -15.64,
  "25836": -7.36,
  "25837": -15.64,
  "25839": -6.84,
  "25840": -15.12,
  "25841": -6.69,
  "25843": 1.13,
  "25844": -6.84,
  "25845": -16.56,
  "25846": -7.36,
  "25848": -16.56,
  "25849": -7.36,
  "25851": -7.36,
  "25853": -7.36,
  "25854": -15.12,
  "25855": -15.12,
  "25857": -7.36,
  "25860": 1.13,
  "25862": -15.12,
  "25864": -15.64,
  "25865": -7.36,
  "25866": -15.64,
  "25868": -15.64,
  "25870": -16.04,
  "25871": -7.36,
  "25873": -7.36,
  "25875": -16.56,
  "25876": -16.04,
  "25878": -7.36,
  "25879": -15.64,
  "25880": -7.36,
  "25882": -16.56,
  "25901": -15.64,
  "25902": -7.36,
  "25904": -15.64,
  "25906": -7.36,
  "25907": -7.36,
  "25908": -7.36,
  "25909": 1.13,
  "25911": -7.36,
  "25913": -16.56,
  "25915": -7.36,
  "25916": -16.56,
  "25917": -15.64,
  "25918": -6.84,
  "25919": -6.84,
  "25920": -7.36,
  "25921": -7.36,
  "25922": -9.35,
  "25926": -6.84,
  "25927": 1.13,
  "25928": -16.56,
  "25932": -7.36,
  "25936": -15.64,
  "25938": -15.64,
  "25942": -15.64,
  "25943": -16.56,
  "25951": -13.03,
  "25958": -16.56,
  "25962": -16.56,
  "25965": -3.47,
  "25966": -11.96,
  "25969": -11.44,
  "25971": -9.35,
  "25972": -16.56,
  "25976": -11.96,
  "25977": -11.96,
  "25978": -13.03,
  "25979": -13.03,
  "25981": -7.82,
  "25984": -16.56,
  "25985": -11.96,
  "25986": -3.47,
  "25989": -3.47,
  "26003": -5.73,
  "26030": -6.25,
  "26031": -6.25,
  "26032": -5.73,
  "26033": -0.73,
  "26034": -6.65,
  "26035": -6.65,
  "26036": -5.73,
  "26037": 0.25,
  "26038": 8.28,
  "26039": -0.21,
  "26040": -0.73,
  "26041": -0.21,
  "26047": -6.65,
  "26050": -6.65,
  "26055": -6.19,
  "26056": -6.65,
  "26058": -6.25,
  "26059": -5.73,
  "26060": -5.73,
  "26062": -6.65,
  "26070": 0.25,
  "26074": -5.73,
  "26075": -6.25,
  "26101": -8.49,
  "26102": -8.49,
  "26103": -8.49,
  "26104": -8.49,
  "26105": -7.42,
  "26133": -8.49,
  "26134": -4.75,
  "26136": 7.09,
  "26137": 7.09,
  "26138": -17.75,
  "26141": 7.09,
  "26142": -9.01,
  "26143": -17.75,
  "26146": -7.11,
  "26147": 7.09,
  "26148": -17.75,
  "26149": -5.67,
  "26150": -8.49,
  "26151": 7.09,
  "26152": -17.23,
  "26155": -6.19,
  "26159": -5.67,
  "26160": -17.75,
  "26161": -7.63,
  "26162": -6.71,
  "26164": -12.17,
  "26167": -6.71,
  "26169": -17.23,
  "26170": -6.59,
  "26175": -5.67,
  "26178": -7.63,
  "26180": -8.49,
  "26181": -0.52,
  "26184": -7.97,
  "26187": 3.74,
  "26201": -8.89,
  "26202": -7.82,
  "26203": -14.72,
  "26205": -7.82,
  "26206": -14.72,
  "26208": -7.82,
  "26209": -17.54,
  "26210": -9.41,
  "26215": -9.93,
  "26217": -14.72,
  "26218": -9.93,
  "26219": -9.93,
  "26222": -7.82,
  "26224": -13.61,
  "26228": -9.93,
  "26229": -6.13,
  "26230": -14.72,
  "26234": -9.93,
  "26236": -9.93,
  "26237": -9.93,
  "26238": -9.41,
  "26241": -13.61,
  "26250": -13.61,
  "26253": -13.61,
  "26254": -13.09,
  "26257": -13.61,
  "26259": -13.61,
  "26260": -6.25,
  "26261": -7.82,
  "26263": -6.25,
  "26264": -14.26,
  "26266": -14.72,
  "26267": -7.3,
  "26268": -13.09,
  "26269": -13.61,
  "26270": -23.27,
  "26271": -13.61,
  "26273": -10.98,
  "26275": -13.61,
  "26276": -13.61,
  "26278": -13.61,
  "26280": -13.61,
  "26282": -14.72,
  "26283": -13.61,
  "26285": -13.61,
  "26287": -13.61,
  "26288": -14.72,
  "26289": -13.61,
  "26291": -17.54,
  "26292": -6.25,
  "26293": -13.61,
  "26294": -18.09,
  "26296": -23.27,
  "26298": -14.72,
  "26301": -1.59,
  "26302": -2.11,
  "26320": 8.59,
  "26321": -6.13,
  "26323": -2.11,
  "26325": -30.17,
  "26327": -7.63,
  "26330": 6.9,
  "26335": -30.17,
  "26337": -7.11,
  "26338": -6.65,
  "26339": 8.07,
  "26342": -30.17,
  "26343": -9.93,
  "26346": -7.11,
  "26347": -16.37,
  "26348": -6.71,
  "26349": -16.37,
  "26351": -30.17,
  "26354": -15.85,
  "26361": -2.11,
  "26362": -7.63,
  "26366": -1.59,
  "26369": -2.11,
  "26372": -6.13,
  "26374": -16.37,
  "26376": -5.73,
  "26377": -6.71,
  "26378": -6.13,
  "26384": -30.17,
  "26385": -1.07,
  "26386": -2.11,
  "26404": -2.11,
  "26405": -16.37,
  "26408": 6.9,
  "26410": -4.41,
  "26411": 8.59,
  "26412": -7.17,
  "26415": -7.11,
  "26416": -15.85,
  "26419": -6.71,
  "26421": -7.11,
  "26422": -1.59,
  "26424": -16.37,
  "26425": -13.61,
  "26426": 8.59,
  "26430": -30.17,
  "26431": -2.11,
  "26434": 8.59,
  "26435": -16.37,
  "26436": 8.07,
  "26437": -6.71,
  "26438": -2.11,
  "26440": -16.37,
  "26443": -29.65,
  "26444": -4.41,
  "26447": -7.17,
  "26448": -2.11,
  "26451": -1.07,
  "26452": -6.13,
  "26456": 8.07,
  "26461": -1.59,
  "26463": -2.57,
  "26501": 4.6,
  "26502": -3.89,
  "26504": 4.6,
  "26505": 4.6,
  "26506": -3.89,
  "26507": 4.6,
  "26508": -3.89,
  "26519": -4.41,
  "26520": -4.41,
  "26521": -2.05,
  "26524": -4.41,
  "26525": -4.41,
  "26527": -4.41,
  "26531": -3.89,
  "26534": -4.41,
  "26537": -4.41,
  "26541": -4.41,
  "26542": -4.41,
  "26543": -4.41,
  "26544": -4.41,
  "26546": -4.41,
  "26547": -4.41,
  "26554": -2.05,
  "26555": -2.05,
  "26559": -2.05,
  "26560": -2.05,
  "26561": -6.71,
  "26562": -6.19,
  "26563": -2.57,
  "26566": -2.05,
  "26568": -2.57,
  "26570": -2.57,
  "26571": -2.57,
  "26572": -2.05,
  "26574": -2.57,
  "26575": -6.71,
  "26576": -2.05,
  "26578": -2.05,
  "26581": -6.71,
  "26582": -2.57,
  "26585": -2.57,
  "26586": -2.57,
  "26587": -2.05,
  "26588": -2.57,
  "26590": -2.05,
  "26591": -2.57,
  "26601": -4.14,
  "26610": -7.82,
  "26611": -30.17,
  "26615": -30.17,
  "26617": -18.86,
  "26619": -6.25,
  "26621": -3.62,
  "26623": -4.14,
  "26624": -4.14,
  "26627": -5.73,
  "26629": -4.14,
  "26631": -6.25,
  "26636": -4.14,
  "26638": -4.14,
  "26651": -7.3,
  "26656": -15.64,
  "26660": -7.82,
  "26662": -6.23,
  "26667": -7.3,
  "26671": -7.82,
  "26675": -7.3,
  "26676": -7.82,
  "26678": -7.3,
  "26679": -7.3,
  "26680": -15.64,
  "26681": -7.82,
  "26684": -7.82,
  "26690": -15.64,
  "26691": -7.82,
  "26704": -14.07,
  "26705": -4.41,
  "26707": -6.25,
  "26710": -4.87,
  "26711": -13.55,
  "26714": -13.55,
  "26716": -4.41,
  "26717": -10.39,
  "26719": -4.81,
  "26720": -6.25,
  "26722": -5.33,
  "26726": -4.87,
  "26731": -6.25,
  "26739": -6.25,
  "26743": -4.87,
  "26750": -4.87,
  "26753": -5.33,
  "26755": -14.07,
  "26757": -14.07,
  "26761": -14.07,
  "26763": -14.07,
  "26764": -4.41,
  "26767": -5.33,
  "26801": -14.99,
  "26802": -21.16,
  "26804": -21.16,
  "26807": -21.16,
  "26808": -13.55,
  "26810": -14.99,
  "26812": -14.99,
  "26814": -21.16,
  "26815": -21.16,
  "26817": -13.55,
  "26818": -14.99,
  "26823": -14.07,
  "26833": -6.25,
  "26836": -14.99,
  "26838": -14.78,
  "26845": -14.47,
  "26847": -6.25,
  "26851": -14.47,
  "26852": -4.87,
  "26855": -6.25,
  "26865": -13.55,
  "26866": -23.27,
  "26884": -22.75,
  "26886": -23.27,
  "27006": 12.17,
  "27007": -0.46,
  "27009": 4.2,
  "27010": 5.27,
  "27011": -4.6,
  "27012": 12.17,
  "27013": -0.61,
  "27014": -7.11,
  "27016": -6.9,
  "27017": -0.46,
  "27018": -4.6,
  "27019": -6.9,
  "27020": -4.6,
  "27021": -6.9,
  "27022": -6.9,
  "27023": 12.17,
  "27024": -0.46,
  "27025": -5.52,
  "27027": -5.52,
  "27028": -5.52,
  "27030": -0.46,
  "27031": -0.46,
  "27040": 5.27,
  "27041": -0.46,
  "27042": -6.9,
  "27043": 4.2,
  "27045": 4.2,
  "27046": -6.9,
  "27047": -0.46,
  "27048": -5.52,
  "27049": -0.46,
  "27050": 4.2,
  "27051": 3.68,
  "27052": -6.9,
  "27053": -6.9,
  "27054": -6.59,
  "27055": -4.6,
  "27101": 3.68,
  "27102": 3.68,
  "27103": 4.2,
  "27104": 12.17,
  "27105": 3.68,
  "27106": 12.17,
  "27107": 3.68,
  "27108": 3.68,
  "27109": 12.17,
  "27113": 3.68,
  "27114": 3.68,
  "27115": 3.68,
  "27116": 3.68,
  "27117": 3.68,
  "27120": 3.68,
  "27127": 3.68,
  "27130": 4.2,
  "27201": 3.43,
  "27202": -5.58,
  "27203": 4.2,
  "27204": 4.2,
  "27205": 4.2,
  "27207": -6.96,
  "27208": -6.96,
  "27209": -1.38,
  "27212": -10.33,
  "27213": -5.37,
  "27214": 3.22,
  "27215": 3.43,
  "27216": 3.43,
  "27217": -5.58,
  "27228": -4.85,
  "27229": -1.38,
  "27230": 3.68,
  "27231": -0.46,
  "27233": 3.22,
  "27235": 11.71,
  "27237": -6.75,
  "27239": -5.98,
  "27242": -6.5,
  "27243": 0.61,
  "27244": -5.06,
  "27247": -1.38,
  "27248": 3.68,
  "27249": -5.06,
  "27252": -5.37,
  "27253": -5.06,
  "27256": -6.75,
  "27258": -5.58,
  "27259": -5.98,
  "27260": 3.74,
  "27261": 3.74,
  "27262": 3.74,
  "27263": 3.22,
  "27264": 3.74,
  "27265": 4.81,
  "27278": 1.13,
  "27281": -6.5,
  "27282": 11.71,
  "27283": 3.74,
  "27284": 5.27,
  "27285": 5.27,
  "27288": -7.11,
  "27289": -7.11,
  "27291": 0.46,
  "27292": -5.98,
  "27293": -5.98,
  "27295": -5.46,
  "27298": -5.58,
  "27299": -7.57,
  "27301": 3.74,
  "27302": -5.06,
  "27305": -10.33,
  "27306": -0.86,
  "27310": 12.23,
  "27311": -10.33,
  "27312": -4.85,
  "27313": 3.74,
  "27314": -9.26,
  "27315": -10.33,
  "27316": 3.68,
  "27317": 3.68,
  "27320": -5.52,
  "27323": -5.52,
  "27325": -5.98,
  "27326": -7.11,
  "27330": -7.82,
  "27331": -7.82,
  "27332": -7.82,
  "27340": -5.06,
  "27341": -1.38,
  "27342": -5.58,
  "27343": -8.03,
  "27344": -6.96,
  "27349": -5.06,
  "27350": 3.68,
  "27351": -5.46,
  "27355": 3.16,
  "27356": -1.38,
  "27357": 3.22,
  "27358": 3.74,
  "27359": -5.06,
  "27360": -5.98,
  "27361": -5.98,
  "27370": 4.2,
  "27371": -0.86,
  "27373": 3.68,
  "27374": -5.98,
  "27375": -5.52,
  "27376": 1.99,
  "27377": -5.06,
  "27379": -10.33,
  "27401": 3.22,
  "27402": 3.22,
  "27403": 3.74,
  "27404": 3.74,
  "27405": 3.22,
  "27406": 3.22,
  "27407": 3.74,
  "27408": 3.74,
  "27409": 3.22,
  "27410": 5.33,
  "27415": -5.58,
  "27416": 3.22,
  "27417": 3.22,
  "27419": 3.74,
  "27420": 3.74,
  "27425": 3.22,
  "27427": 3.22,
  "27429": 3.74,
  "27435": 3.74,
  "27438": 3.74,
  "27455": 3.74,
  "27495": 3.22,
  "27501": -3.07,
  "27502": 6.13,
  "27503": 6.13,
  "27504": -4.45,
  "27505": -8.34,
  "27506": -4.14,
  "27507": -6.84,
  "27508": -3.53,
  "27509": -6.84,
  "27510": 1.13,
  "27511": 6.13,
  "27512": 6.13,
  "27513": 6.65,
  "27514": 9.62,
  "27515": 9.62,
  "27516": 1.13,
  "27517": 9.62,
  "27518": 6.13,
  "27519": 6.65,
  "27520": -4.45,
  "27521": -4.66,
  "27522": -6.84,
  "27523": 6.13,
  "27524": -6.04,
  "27525": -3.53,
  "27526": -3.07,
  "27527": -4.45,
  "27528": -4.45,
  "27529": 6.13,
  "27530": 1.78,
  "27531": 1.78,
  "27532": 9.72,
  "27533": 9.72,
  "27534": 9.72,
  "27536": -7.76,
  "27537": -7.76,
  "27539": 6.13,
  "27540": 6.13,
  "27541": -5.92,
  "27542": 1.69,
  "27543": -4.66,
  "27544": -7.21,
  "27545": 6.13,
  "27546": -4.66,
  "27549": -5.12,
  "27551": -15.7,
  "27552": -4.66,
  "27553": -8.8,
  "27555": -6.59,
  "27556": -7.76,
  "27557": 3.83,
  "27559": -5.37,
  "27560": 14.07,
  "27562": 6.13,
  "27563": -15.7,
  "27564": -6.84,
  "27565": -6.84,
  "27568": -6.59,
  "27569": 1.23,
  "27570": -15.7,
  "27571": -3.53,
  "27572": -5.92,
  "27573": -8.03,
  "27574": -8.03,
  "27576": -6.04,
  "27577": 1.9,
  "27581": -6.84,
  "27582": -7.76,
  "27583": -5.92,
  "27584": -7.76,
  "27586": -15.7,
  "27587": -3.53,
  "27588": -3.53,
  "27589": -15.7,
  "27591": 6.13,
  "27592": -3.07,
  "27593": -6.04,
  "27594": -15.7,
  "27596": -3.53,
  "27597": -3.53,
  "27601": 6.13,
  "27602": 6.13,
  "27603": 6.13,
  "27604": 6.13,
  "27605": 6.65,
  "27606": 6.13,
  "27607": 6.65,
  "27608": 14.62,
  "27609": 6.13,
  "27610": 6.13,
  "27611": 6.13,
  "27612": 6.65,
  "27613": 6.65,
  "27614": 16.92,
  "27615": 6.65,
  "27616": 6.13,
  "27617": 6.13,
  "27619": 6.13,
  "27620": 6.13,
  "27621": 6.13,
  "27622": 6.65,
  "27623": 14.07,
  "27624": 6.13,
  "27625": 6.13,
  "27626": 6.13,
  "27627": 6.13,
  "27628": 14.62,
  "27629": 6.13,
  "27636": 6.65,
  "27650": 6.65,
  "27658": 6.13,
  "27661": 6.13,
  "27675": 6.65,
  "27676": 6.13,
  "27701": 5.58,
  "27702": 5.58,
  "27703": 5.58,
  "27704": 5.58,
  "27705": 6.13,
  "27706": 14.07,
  "27707": 6.13,
  "27709": 5.58,
  "27712": 6.13,
  "27713": 6.13,
  "27715": 6.13,
  "27717": 6.13,
  "27722": 5.58,
  "27801": -9.26,
  "27802": -3.74,
  "27803": -3.22,
  "27804": -3.22,
  "27805": -6.04,
  "27806": -14.32,
  "27807": 2.24,
  "27808": 2.76,
  "27809": -3.74,
  "27810": 2.24,
  "27811": -8.28,
  "27812": -5.52,
  "27813": 1.69,
  "27814": 2.24,
  "27816": -3.74,
  "27817": 2.76,
  "27818": -4.14,
  "27819": -9.26,
  "27820": -2.3,
  "27821": 2.24,
  "27822": 2.24,
  "27823": -5.12,
  "27824": -18.92,
  "27825": -6.04,
  "27826": -18.92,
  "27827": -2.76,
  "27828": -8.28,
  "27829": -8.8,
  "27830": 1.69,
  "27831": -2.82,
  "27832": -2.82,
  "27833": -2.76,
  "27834": -2.76,
  "27835": -2.76,
  "27836": -2.76,
  "27837": -2.76,
  "27839": -5.12,
  "27840": -6.04,
  "27841": -5.52,
  "27842": -7.21,
  "27843": -9.26,
  "27844": -16.25,
  "27845": -2.82,
  "27846": -6.04,
  "27847": -5.21,
  "27849": -6.04,
  "27850": -7.21,
  "27851": 1.69,
  "27852": -9.26,
  "27853": -2.3,
  "27855": -4.14,
  "27856": -3.74,
  "27857": -5.52,
  "27858": 5.73,
  "27860": -13.86,
  "27861": -6.04,
  "27862": -4.14,
  "27863": 1.78,
  "27864": -9.26,
  "27865": 2.76,
  "27866": -2.82,
  "27867": -4.66,
  "27868": -3.74,
  "27869": -2.82,
  "27870": -5.12,
  "27871": -6.04,
  "27872": -5.21,
  "27873": 2.24,
  "27874": -9.26,
  "27875": -18.92,
  "27876": -2.82,
  "27877": -7.82,
  "27878": -3.74,
  "27879": 5.73,
  "27880": 2.24,
  "27881": -9.26,
  "27882": -3.74,
  "27883": 1.69,
  "27884": -2.76,
  "27885": -18.4,
  "27886": -9.26,
  "27887": -5.12,
  "27888": -8.28,
  "27889": 2.76,
  "27890": -5.12,
  "27891": -9.26,
  "27892": -5.52,
  "27893": 2.24,
  "27894": 2.24,
  "27895": 10.73,
  "27896": 10.73,
  "27897": -4.66,
  "27906": -5.92,
  "27907": -5.92,
  "27909": -5.92,
  "27910": -4.14,
  "27915": -6.23,
  "27916": -6.84,
  "27917": -6.84,
  "27919": -9.2,
  "27920": 0.67,
  "27921": -10.52,
  "27922": -4.14,
  "27923": -6.84,
  "27924": -8.28,
  "27925": -15.64,
  "27926": 5.58,
  "27927": -6.84,
  "27928": -16.16,
  "27929": -6.84,
  "27930": -8.68,
  "27932": -7.76,
  "27935": -4.14,
  "27936": -9.91,
  "27937": -4.14,
  "27938": -3.62,
  "27939": -6.84,
  "27941": -7.3,
  "27942": -4.14,
  "27943": -9.91,
  "27944": -8.68,
  "27946": -8.68,
  "27947": -6.84,
  "27948": -7.3,
  "27949": 1.19,
  "27950": -6.84,
  "27953": -7.3,
  "27954": -7.3,
  "27956": -6.84,
  "27957": -8.8,
  "27958": -10.52,
  "27959": -6.75,
  "27960": -10.43,
  "27962": -13.34,
  "27964": -7.3,
  "27965": -6.84,
  "27966": -6.84,
  "27967": -4.14,
  "27968": -7.3,
  "27969": -4.14,
  "27970": -13.34,
  "27972": -6.75,
  "27973": -10.52,
  "27974": -10.52,
  "27976": -12.11,
  "27978": -7.3,
  "27979": -9.2,
  "27980": -8.28,
  "27981": -7.3,
  "27982": -7.3,
  "27983": -6.04,
  "27985": -9.2,
  "27986": -4.14,
  "28001": -2.7,
  "28002": -2.7,
  "28006": -0.92,
  "28007": -8.68,
  "28009": -2.7,
  "28010": -0.61,
  "28012": -0.46,
  "28016": -0.98,
  "28017": -2.82,
  "28018": 0.77,
  "28019": 0.77,
  "28020": -2.82,
  "28021": -2.3,
  "28023": -1.99,
  "28024": 0.77,
  "28025": -1.32,
  "28026": -1.32,
  "28027": -1.32,
  "28031": 13.86,
  "28032": -0.98,
  "28033": -0.92,
  "28034": -0.46,
  "28035": 5.58,
  "28036": 5.58,
  "28037": 7.57,
  "28038": -2.82,
  "28039": -2.51,
  "28040": 0.77,
  "28041": -1.99,
  "28042": -3.37,
  "28043": 0.77,
  "28052": -0.98,
  "28053": -0.98,
  "28054": -0.46,
  "28055": -0.98,
  "28056": -0.46,
  "28070": 7.51,
  "28071": -2.51,
  "28072": -1.99,
  "28073": -2.82,
  "28074": 0.77,
  "28075": 7.17,
  "28076": 0.77,
  "28077": -1.44,
  "28078": 7.51,
  "28079": 6.07,
  "28080": -0.92,
  "28081": -2.91,
  "28082": -2.91,
  "28083": -2.91,
  "28086": -2.3,
  "28088": -1.99,
  "28089": -2.82,
  "28090": -3.37,
  "28091": -8.68,
  "28092": -0.92,
  "28093": -0.92,
  "28097": -2.7,
  "28098": -0.98,
  "28101": -0.46,
  "28102": -10.27,
  "28103": 6.04,
  "28104": 7.51,
  "28105": 7.51,
  "28106": 7.51,
  "28107": -1.32,
  "28108": 13.49,
  "28109": -3.22,
  "28110": 6.04,
  "28111": 6.04,
  "28112": 6.04,
  "28114": 0.77,
  "28115": -0.61,
  "28117": -0.61,
  "28119": -8.68,
  "28120": -0.46,
  "28123": 7.88,
  "28124": 0.27,
  "28125": -0.61,
  "28126": 6.96,
  "28127": -2.7,
  "28128": -2.7,
  "28129": -2.7,
  "28130": 6.96,
  "28133": -8.68,
  "28134": 6.96,
  "28135": -8.68,
  "28136": -3.37,
  "28137": -3.22,
  "28138": -1.99,
  "28139": 0.77,
  "28144": -1.99,
  "28145": -1.99,
  "28146": -1.99,
  "28147": -1.99,
  "28150": -2.3,
  "28151": -2.3,
  "28152": -2.82,
  "28159": -2.51,
  "28160": 0.77,
  "28163": -2.7,
  "28164": -0.46,
  "28166": -0.61,
  "28167": 1.32,
  "28168": -0.4,
  "28169": -2.82,
  "28170": -8.68,
  "28173": 13.49,
  "28174": 6.04,
  "28201": 18.3,
  "28202": 7.51,
  "28203": 7.51,
  "28204": 7.51,
  "28205": 6.96,
  "28206": 6.96,
  "28207": 18.3,
  "28208": 6.96,
  "28209": 7.51,
  "28210": 7.51,
  "28211": 7.51,
  "28212": 6.96,
  "28213": 6.96,
  "28214": 6.96,
  "28215": 6.96,
  "28216": 6.96,
  "28217": 6.96,
  "28218": 6.96,
  "28219": 6.96,
  "28220": 7.51,
  "28221": 7.51,
  "28222": 18.3,
  "28223": 7.51,
  "28224": 7.51,
  "28226": 7.51,
  "28227": 6.96,
  "28229": 6.96,
  "28230": 7.51,
  "28231": 18.3,
  "28232": 7.51,
  "28233": 7.51,
  "28234": 7.51,
  "28235": 7.51,
  "28236": -0.46,
  "28237": 7.51,
  "28241": 7.51,
  "28244": 7.51,
  "28246": 7.51,
  "28247": 7.51,
  "28254": 6.96,
  "28256": 6.96,
  "28260": 7.51,
  "28262": 7.51,
  "28265": 7.51,
  "28266": 7.51,
  "28269": 7.51,
  "28270": 7.51,
  "28271": 7.51,
  "28272": 7.51,
  "28273": 7.51,
  "28275": 7.51,
  "28277": 7.51,
  "28278": 7.51,
  "28280": 7.51,
  "28281": 7.51,
  "28282": 7.51,
  "28284": 7.51,
  "28285": 7.51,
  "28287": 7.51,
  "28297": 6.96,
  "28299": 7.51,
  "28301": -2.36,
  "28302": -2.36,
  "28303": -1.84,
  "28304": -2.36,
  "28305": 6.13,
  "28306": -2.36,
  "28307": -2.36,
  "28308": 6.13,
  "28309": 6.13,
  "28311": -1.84,
  "28312": -2.36,
  "28314": -1.84,
  "28315": -6.5,
  "28318": -10.64,
  "28319": -18.09,
  "28320": -12.02,
  "28323": -4.66,
  "28325": -12.57,
  "28326": -8.34,
  "28327": -5.98,
  "28328": -11.19,
  "28329": -11.19,
  "28330": -3.37,
  "28331": -2.36,
  "28332": -12.02,
  "28333": 1.23,
  "28334": -4.66,
  "28335": -4.66,
  "28337": -12.02,
  "28338": -2.82,
  "28339": -4.66,
  "28340": -11.1,
  "28341": -12.57,
  "28342": -4.14,
  "28343": -11.1,
  "28344": -4.14,
  "28345": -2.82,
  "28347": -2.82,
  "28348": -2.36,
  "28349": -12.57,
  "28350": -6.5,
  "28351": -11.1,
  "28352": -11.1,
  "28353": -11.1,
  "28355": -7.82,
  "28356": -4.66,
  "28357": -10.64,
  "28358": -11.1,
  "28359": -11.1,
  "28360": -11.1,
  "28362": -18.09,
  "28363": -11.1,
  "28364": -11.1,
  "28365": 1.23,
  "28366": -10.64,
  "28367": -2.82,
  "28368": -8.34,
  "28369": -11.1,
  "28370": 1.99,
  "28371": -2.36,
  "28372": -11.1,
  "28373": -5.98,
  "28374": 1.99,
  "28375": -11.1,
  "28376": -10.64,
  "28377": -10.64,
  "28378": -10.12,
  "28379": -2.82,
  "28380": -2.82,
  "28382": -10.64,
  "28383": -11.65,
  "28384": -11.1,
  "28385": -10.64,
  "28386": -10.64,
  "28387": 1.99,
  "28388": 1.99,
  "28390": -2.36,
  "28391": -2.36,
  "28392": -12.02,
  "28393": -11.19,
  "28394": -5.98,
  "28395": -2.36,
  "28396": -11.1,
  "28398": -12.57,
  "28399": -12.02,
  "28401": 0.06,
  "28402": 0.06,
  "28403": 0.61,
  "28404": -1.23,
  "28405": 0.61,
  "28406": 0.61,
  "28407": 0.61,
  "28408": 0.06,
  "28409": 0.61,
  "28411": 0.06,
  "28412": 0.61,
  "28420": -2.3,
  "28421": -6.38,
  "28422": -1.78,
  "28423": -2.3,
  "28424": -9.2,
  "28425": -6.38,
  "28428": 0.61,
  "28429": 0.06,
  "28430": -9.2,
  "28431": -9.2,
  "28432": -9.2,
  "28433": -12.02,
  "28434": -10.98,
  "28435": -6.38,
  "28436": -8.68,
  "28438": -9.72,
  "28439": -17.54,
  "28441": -10.64,
  "28442": -8.68,
  "28443": -5.83,
  "28444": -10.98,
  "28445": -5.58,
  "28447": -6.38,
  "28448": -10.98,
  "28449": 0.61,
  "28450": -8.68,
  "28451": 0.06,
  "28452": -2.3,
  "28453": -12.57,
  "28454": -6.13,
  "28455": -9.2,
  "28456": -8.68,
  "28457": -6.38,
  "28458": -12.57,
  "28459": -1.78,
  "28460": -5.58,
  "28461": -1.23,
  "28462": -1.78,
  "28463": -9.2,
  "28464": -12.57,
  "28465": -1.23,
  "28466": -12.57,
  "28467": -2.3,
  "28468": 6.19,
  "28469": -1.78,
  "28470": -1.78,
  "28472": -9.2,
  "28478": -6.38,
  "28479": 0.06,
  "28480": 10.85,
  "28501": 3.16,
  "28502": 2.61,
  "28503": 2.61,
  "28504": 2.61,
  "28508": 2.61,
  "28509": -14.32,
  "28510": -14.32,
  "28511": -11.19,
  "28512": -2.15,
  "28513": -2.76,
  "28515": -14.32,
  "28516": -10.64,
  "28518": -12.57,
  "28519": -7.88,
  "28520": -11.19,
  "28521": -12.57,
  "28522": -18.55,
  "28523": -17.48,
  "28524": -11.19,
  "28525": 2.61,
  "28526": 3.16,
  "28527": -7.36,
  "28528": -10.64,
  "28529": -14.87,
  "28530": 3.68,
  "28531": -10.64,
  "28532": -10.64,
  "28533": -10.64,
  "28537": -14.32,
  "28538": -8.28,
  "28539": -6.13,
  "28540": -5.58,
  "28541": -5.58,
  "28542": -6.13,
  "28543": -6.13,
  "28544": -6.13,
  "28545": -6.13,
  "28546": -5.58,
  "28547": -6.13,
  "28551": 2.61,
  "28552": -14.32,
  "28553": -9.05,
  "28554": -8.28,
  "28555": -18.55,
  "28556": -14.87,
  "28557": -10.64,
  "28560": -7.88,
  "28561": -7.88,
  "28562": -7.88,
  "28563": -7.88,
  "28564": -7.88,
  "28570": -10.64,
  "28571": -5.83,
  "28572": 2.61,
  "28573": -18.55,
  "28574": -18.55,
  "28575": -10.64,
  "28577": -10.64,
  "28578": 1.23,
  "28579": -10.64,
  "28580": -9.35,
  "28581": -11.19,
  "28582": -5.58,
  "28583": -14.32,
  "28584": -5.58,
  "28585": -18.55,
  "28586": -7.36,
  "28587": -14.32,
  "28589": -10.64,
  "28590": -2.76,
  "28594": -2.15,
  "28601": 0.98,
  "28602": 0.98,
  "28603": 0.98,
  "28604": -8.43,
  "28605": -2.24,
  "28606": -10.33,
  "28607": -10.73,
  "28609": 0.98,
  "28610": 0.46,
  "28611": -8.95,
  "28612": -10.27,
  "28613": 0.98,
  "28615": 12.21,
  "28616": -8.43,
  "28617": 12.21,
  "28618": -10.73,
  "28619": -10.27,
  "28621": -12.88,
  "28622": -7.88,
  "28623": -12.88,
  "28624": -10.33,
  "28625": 0.98,
  "28626": 12.73,
  "28627": -13.95,
  "28628": -9.72,
  "28629": 12.73,
  "28630": -7.76,
  "28631": 20.7,
  "28634": -5.52,
  "28635": -10.33,
  "28636": -10.58,
  "28637": 0.46,
  "28638": -9.87,
  "28640": 12.73,
  "28641": -8.95,
  "28642": -4.6,
  "28643": 13.8,
  "28644": -14.47,
  "28645": -9.87,
  "28646": -8.43,
  "28647": -7.88,
  "28649": -10.33,
  "28650": -0.4,
  "28651": -9.81,
  "28652": -8.95,
  "28653": -8.43,
  "28654": -10.33,
  "28655": -9.72,
  "28657": -8.95,
  "28658": 0.98,
  "28659": -10.33,
  "28660": 0.98,
  "28661": -9.87,
  "28662": -7.88,
  "28663": -13.95,
  "28664": -8.95,
  "28665": -10.33,
  "28666": 0.98,
  "28667": -7.76,
  "28668": -5.46,
  "28669": -10.33,
  "28670": -8.74,
  "28671": -9.72,
  "28672": 12.21,
  "28673": 9.47,
  "28675": -14.47,
  "28676": -12.88,
  "28677": 0.98,
  "28678": -10.58,
  "28679": -10.73,
  "28680": -9.72,
  "28681": -10.58,
  "28682": 7.88,
  "28683": -12.88,
  "28684": 12.21,
  "28685": -10.33,
  "28687": 0.98,
  "28688": 0.98,
  "28689": -4.08,
  "28690": -9.72,
  "28691": -8.43,
  "28692": -10.73,
  "28693": 13.8,
  "28694": 12.73,
  "28697": -9.81,
  "28698": -2.76,
  "28699": -10.58,
  "28701": -6.84,
  "28702": -10.52,
  "28704": -2.7,
  "28705": -13.03,
  "28707": -7.82,
  "28708": -10.12,
  "28709": -8.28,
  "28710": -2.7,
  "28711": -2.7,
  "28712": -9.6,
  "28713": -12.11,
  "28714": -8.28,
  "28715": -3.22,
  "28716": -5.06,
  "28717": -5.71,
  "28718": -9.6,
  "28719": -11.04,
  "28720": -2.7,
  "28721": 3.95,
  "28722": 11.56,
  "28723": -7.3,
  "28724": -2.7,
  "28725": -7.3,
  "28726": -3.22,
  "28727": -2.7,
  "28728": -3.22,
  "28729": -2.7,
  "28730": -2.7,
  "28731": -2.7,
  "28732": -2.7,
  "28733": -4.75,
  "28734": -11.04,
  "28735": -2.7,
  "28736": 1.19,
  "28737": -5.21,
  "28738": -5.06,
  "28739": -2.7,
  "28740": -8.28,
  "28741": -2.03,
  "28742": -2.7,
  "28743": -7.36,
  "28744": -11.04,
  "28745": 3.95,
  "28746": 4.66,
  "28747": -9.6,
  "28748": -3.22,
  "28749": -3.99,
  "28750": 11.56,
  "28751": -4.54,
  "28752": -5.21,
  "28753": -7.36,
  "28754": -6.84,
  "28755": -8.28,
  "28756": 4.14,
  "28757": 5.79,
  "28758": -3.22,
  "28759": -2.7,
  "28760": -3.22,
  "28761": -5.21,
  "28762": -4.14,
  "28763": -11.59,
  "28765": -13.03,
  "28766": -9.6,
  "28768": -9.6,
  "28770": -2.7,
  "28771": -4.75,
  "28772": -10.12,
  "28773": 4.66,
  "28774": -1.11,
  "28775": -11.59,
  "28776": -2.7,
  "28777": -12.48,
  "28778": -3.22,
  "28779": -7.82,
  "28781": -4.75,
  "28782": 11.56,
  "28783": -7.3,
  "28784": -3.22,
  "28785": 3.95,
  "28786": -5.06,
  "28787": -2.7,
  "28788": -7.82,
  "28789": -11.04,
  "28790": -3.22,
  "28791": -2.7,
  "28792": -2.7,
  "28793": -2.7,
  "28801": -2.7,
  "28802": -2.7,
  "28803": -2.7,
  "28804": 5.79,
  "28805": -2.7,
  "28806": -3.22,
  "28810": -3.22,
  "28813": -2.7,
  "28814": 5.79,
  "28815": -2.7,
  "28816": -3.22,
  "28901": -4.75,
  "28902": -11.65,
  "28903": -11.65,
  "28904": -11.19,
  "28905": -11.65,
  "28906": -11.65,
  "28909": -11.19,
  "29001": -14.87,
  "29002": -1.84,
  "29003": -18.86,
  "29006": -12.36,
  "29009": -11.65,
  "29010": -15.85,
  "29014": -3.37,
  "29015": -13.4,
  "29016": 3.43,
  "29018": 3.01,
  "29020": -3.16,
  "29021": -3.16,
  "29030": -6.13,
  "29031": -10.73,
  "29032": -11.65,
  "29033": 1.84,
  "29036": 6.65,
  "29037": -5.06,
  "29038": -18.86,
  "29039": 4.08,
  "29040": 1.63,
  "29041": -14.87,
  "29042": -18.86,
  "29044": -5.06,
  "29045": 1.84,
  "29046": -15.85,
  "29047": 3.53,
  "29048": -14.87,
  "29051": -14.87,
  "29052": -5.06,
  "29053": -1.84,
  "29054": -1.84,
  "29055": -3.37,
  "29056": 3.16,
  "29058": -2.82,
  "29059": -4.87,
  "29061": 1.84,
  "29062": -12.17,
  "29063": -1.84,
  "29065": -6.5,
  "29067": -2.82,
  "29069": -14.78,
  "29070": -1.84,
  "29071": 6.65,
  "29072": 6.65,
  "29073": -1.84,
  "29074": -10.58,
  "29075": -6.5,
  "29078": -10.58,
  "29079": -8.34,
  "29080": -15.85,
  "29081": -18.34,
  "29082": -20.97,
  "29101": -10.18,
  "29102": -14.87,
  "29104": 1.63,
  "29105": -12.88,
  "29107": 4.08,
  "29108": -5.98,
  "29111": -14.87,
  "29112": -5.06,
  "29113": -18.86,
  "29114": 3.16,
  "29115": 4.6,
  "29116": 4.6,
  "29118": 4.6,
  "29122": -5.98,
  "29123": -1.84,
  "29125": -14.87,
  "29126": -5.98,
  "29127": -5.98,
  "29128": -12.17,
  "29129": -12.36,
  "29130": -12.88,
  "29132": -13.4,
  "29133": 4.08,
  "29135": -5.58,
  "29137": -0.92,
  "29138": -12.36,
  "29142": 3.53,
  "29143": -14.87,
  "29145": -5.98,
  "29146": -0.92,
  "29147": 1.84,
  "29148": -14.87,
  "29150": 2.15,
  "29151": 2.15,
  "29152": 1.63,
  "29153": 2.15,
  "29154": 10.64,
  "29160": -5.06,
  "29161": 3.16,
  "29162": -14.87,
  "29163": -15.39,
  "29164": 6.04,
  "29166": -12.88,
  "29168": 2.15,
  "29169": 1.84,
  "29170": -1.84,
  "29171": 1.84,
  "29172": -1.84,
  "29175": -11.1,
  "29177": 6.65,
  "29178": -10.73,
  "29180": -12.88,
  "29201": 1.84,
  "29202": 3.43,
  "29203": 1.84,
  "29204": 1.84,
  "29205": 3.43,
  "29206": 10.33,
  "29207": 10.33,
  "29209": 1.84,
  "29210": 1.84,
  "29211": 6.65,
  "29212": -0.25,
  "29221": 1.84,
  "29222": 1.84,
  "29223": 1.84,
  "29224": 1.84,
  "29228": -1.84,
  "29229": 10.33,
  "29230": 1.84,
  "29240": 1.84,
  "29250": 3.43,
  "29260": 10.33,
  "29290": 1.84,
  "29292": -1.84,
  "29301": 0.4,
  "29302": -0.06,
  "29303": 0.4,
  "29304": -0.15,
  "29305": -0.15,
  "29306": -0.15,
  "29307": -0.61,
  "29316": 0.4,
  "29318": -0.15,
  "29320": -0.15,
  "29321": -10.73,
  "29322": 0.4,
  "29323": -0.15,
  "29324": -0.06,
  "29325": -4.75,
  "29329": -0.06,
  "29330": -0.61,
  "29331": -4.75,
  "29332": -6.13,
  "29333": -0.06,
  "29334": 0.4,
  "29335": -4.75,
  "29336": -0.15,
  "29338": 0.4,
  "29340": -0.61,
  "29341": -0.61,
  "29342": -0.61,
  "29346": 1.44,
  "29348": 0.4,
  "29349": 0.4,
  "29351": -4.75,
  "29353": -10.73,
  "29355": -7.05,
  "29356": 0.4,
  "29360": -4.75,
  "29364": -10.73,
  "29365": -0.15,
  "29368": -0.61,
  "29369": 8.34,
  "29370": -4.75,
  "29372": -0.61,
  "29373": -0.61,
  "29374": -10.73,
  "29375": -0.15,
  "29376": 0.4,
  "29377": -0.15,
  "29378": -0.15,
  "29379": -10.73,
  "29384": -6.13,
  "29385": -0.15,
  "29386": -0.61,
  "29388": -0.15,
  "29401": 16.46,
  "29402": 16.46,
  "29403": 5.12,
  "29404": 3.01,
  "29405": 3.01,
  "29406": 3.01,
  "29407": 5.67,
  "29410": 6.23,
  "29412": 5.67,
  "29413": 16.46,
  "29414": 5.67,
  "29415": 6.23,
  "29416": 3.01,
  "29417": 5.67,
  "29418": 3.01,
  "29419": 3.01,
  "29420": 3.01,
  "29422": 7.97,
  "29423": 3.01,
  "29426": -4.35,
  "29429": 6.23,
  "29430": 5.71,
  "29431": 6.23,
  "29432": -20.97,
  "29433": -6.65,
  "29434": 5.71,
  "29435": -4.35,
  "29436": 6.23,
  "29437": -4.35,
  "29438": 5.67,
  "29439": 7.97,
  "29440": -4.6,
  "29442": -4.6,
  "29445": 6.23,
  "29446": -4.54,
  "29447": -4.87,
  "29448": -4.87,
  "29449": 5.12,
  "29450": 6.23,
  "29451": 7.97,
  "29452": -6.65,
  "29453": -6.71,
  "29455": 5.12,
  "29456": 6.23,
  "29457": 5.12,
  "29458": -6.19,
  "29461": 6.23,
  "29464": 5.67,
  "29465": 5.67,
  "29466": 5.67,
  "29468": -15.91,
  "29469": 14.72,
  "29470": 3.01,
  "29471": 2.49,
  "29472": -4.35,
  "29474": -6.65,
  "29475": -6.65,
  "29476": 6.23,
  "29477": -4.87,
  "29479": 6.23,
  "29481": -7.17,
  "29482": 16.46,
  "29483": -4.35,
  "29484": -4.35,
  "29485": -2.76,
  "29487": 5.12,
  "29488": -6.65,
  "29492": 11.5,
  "29493": -6.65,
  "29501": 11.65,
  "29502": 11.65,
  "29503": 11.65,
  "29504": 11.65,
  "29505": 11.65,
  "29506": 3.16,
  "29510": -7.36,
  "29511": -5.06,
  "29512": -4.2,
  "29516": -4.75,
  "29518": 3.16,
  "29519": -6.13,
  "29520": -10.18,
  "29525": -4.2,
  "29526": -4.6,
  "29527": -4.6,
  "29528": -4.6,
  "29530": 3.16,
  "29532": -8.34,
  "29536": -17.54,
  "29540": -8.34,
  "29541": 11.65,
  "29543": -17.54,
  "29544": -5.06,
  "29545": -5.06,
  "29546": -5.58,
  "29547": -17.54,
  "29550": -8.34,
  "29551": -8.34,
  "29554": -7.88,
  "29555": -7.88,
  "29556": -7.88,
  "29560": 3.16,
  "29563": -17.54,
  "29564": -8.95,
  "29565": -17.54,
  "29566": -4.6,
  "29567": -17.54,
  "29568": -4.6,
  "29569": -4.6,
  "29570": -4.2,
  "29571": -5.58,
  "29572": 3.89,
  "29573": -17.54,
  "29574": -5.58,
  "29575": -4.6,
  "29576": -4.6,
  "29577": -4.6,
  "29578": -4.6,
  "29579": -4.6,
  "29580": -8.43,
  "29581": -5.06,
  "29582": -4.6,
  "29583": 3.16,
  "29584": -10.73,
  "29585": 3.89,
  "29587": -4.6,
  "29588": -4.6,
  "29589": -5.58,
  "29590": -8.95,
  "29591": 3.16,
  "29592": -17.54,
  "29593": -8.34,
  "29594": -4.75,
  "29596": -4.2,
  "29597": -4.6,
  "29598": -4.6,
  "29601": 7.42,
  "29602": 7.42,
  "29603": 7.42,
  "29604": 7.42,
  "29605": 7.42,
  "29606": 7.42,
  "29607": 7.42,
  "29608": 7.42,
  "29609": 7.42,
  "29610": 7.42,
  "29611": 6.9,
  "29612": 7.42,
  "29615": 7.42,
  "29616": 7.42,
  "29617": 7.42,
  "29620": -14.41,
  "29621": -2.82,
  "29622": -3.37,
  "29623": -3.37,
  "29624": -3.37,
  "29625": -3.37,
  "29626": -3.37,
  "29627": -3.37,
  "29628": -14.41,
  "29630": -9.35,
  "29631": -0.4,
  "29633": -8.89,
  "29635": -7.76,
  "29636": 7.42,
  "29638": -4.75,
  "29639": -14.41,
  "29640": -7.76,
  "29641": -7.76,
  "29642": -7.76,
  "29643": -8.89,
  "29644": 7.42,
  "29645": -3.68,
  "29646": -6.13,
  "29648": -6.13,
  "29649": -5.58,
  "29650": 7.42,
  "29651": 7.42,
  "29652": 7.42,
  "29653": -6.13,
  "29654": -3.37,
  "29655": -14.41,
  "29656": -3.37,
  "29657": -8.28,
  "29658": -8.34,
  "29659": -14.41,
  "29661": 6.9,
  "29662": 7.42,
  "29664": -8.34,
  "29665": -8.89,
  "29666": -4.54,
  "29667": -9.35,
  "29669": -3.37,
  "29670": -3.37,
  "29671": -7.76,
  "29672": -8.89,
  "29673": 7.42,
  "29675": -8.89,
  "29676": -0.4,
  "29677": -2.82,
  "29678": -8.89,
  "29679": -8.89,
  "29680": 7.42,
  "29681": 7.42,
  "29682": -9.35,
  "29683": 6.9,
  "29684": -3.37,
  "29685": -7.76,
  "29686": -0.4,
  "29687": 7.42,
  "29688": 7.42,
  "29689": -3.37,
  "29690": 7.42,
  "29691": -8.89,
  "29692": -4.75,
  "29693": -8.89,
  "29696": -8.89,
  "29697": -3.37,
  "29702": -0.06,
  "29703": -1.84,
  "29704": -2.36,
  "29706": 2.7,
  "29707": -2.36,
  "29708": -2.36,
  "29709": -10.18,
  "29710": -1.84,
  "29712": 2.7,
  "29714": -2.82,
  "29715": -2.36,
  "29716": -2.36,
  "29717": -0.06,
  "29718": -10.73,
  "29720": -2.82,
  "29721": -2.82,
  "29724": 2.7,
  "29726": -2.36,
  "29727": -10.73,
  "29728": -10.18,
  "29729": 2.7,
  "29730": -2.36,
  "29731": -2.36,
  "29732": -2.36,
  "29734": -2.36,
  "29741": -10.73,
  "29742": -10.18,
  "29743": -0.06,
  "29744": -2.36,
  "29745": -2.36,
  "29801": 6.04,
  "29802": 6.04,
  "29803": 14.01,
  "29804": 5.52,
  "29805": 6.04,
  "29809": 6.04,
  "29810": -0.92,
  "29812": -0.92,
  "29813": -0.92,
  "29816": 5.52,
  "29817": -0.92,
  "29819": -6.13,
  "29821": -4.29,
  "29822": -5.67,
  "29824": -3.16,
  "29826": -0.92,
  "29827": -0.92,
  "29828": 5.52,
  "29829": 6.04,
  "29831": -5.67,
  "29832": -3.16,
  "29834": 5.52,
  "29835": -16.25,
  "29836": -0.92,
  "29838": -7.76,
  "29839": 5.52,
  "29840": -16.25,
  "29841": -5.67,
  "29842": -5.67,
  "29843": -18.86,
  "29844": -16.25,
  "29845": -16.77,
  "29846": -0.92,
  "29847": -3.16,
  "29848": -16.25,
  "29849": -0.92,
  "29850": 6.04,
  "29851": 5.52,
  "29853": -0.92,
  "29856": 5.52,
  "29860": -5.67,
  "29861": -5.67,
  "29901": -0.52,
  "29902": -1.07,
  "29903": -1.07,
  "29904": -1.07,
  "29905": -1.07,
  "29906": -0.52,
  "29907": -0.52,
  "29909": 7.42,
  "29910": 7.42,
  "29911": -1.84,
  "29912": 0.31,
  "29913": -2.91,
  "29914": -1.07,
  "29915": 7.42,
  "29916": -2.91,
  "29918": -2.91,
  "29920": -0.52,
  "29921": -2.91,
  "29922": -2.91,
  "29923": -1.84,
  "29924": -2.91,
  "29925": 9.72,
  "29926": 7.42,
  "29927": 0.31,
  "29928": 9.72,
  "29929": -7.17,
  "29931": -1.07,
  "29932": -1.84,
  "29933": -7.17,
  "29934": -2.91,
  "29935": -1.07,
  "29936": 0.31,
  "29938": 9.72,
  "29939": -2.91,
  "29940": -1.07,
  "29941": -1.07,
  "29943": 0.31,
  "29944": -2.91,
  "29945": -6.13,
  "30002": 9.35,
  "30003": 5.58,
  "30004": 6.59,
  "30005": 16,
  "30006": 13.4,
  "30007": 13.4,
  "30008": 13.95,
  "30009": 16,
  "30010": 6.13,
  "30011": 10.18,
  "30012": 5.58,
  "30013": 6.13,
  "30014": -0.4,
  "30015": -0.4,
  "30016": 0.15,
  "30017": 6.13,
  "30018": -0.4,
  "30019": 18.15,
  "30021": 9.35,
  "30022": 6.13,
  "30023": 16,
  "30024": 6.13,
  "30025": 4.2,
  "30026": 6.13,
  "30028": 7.51,
  "30029": 6.13,
  "30030": 9.35,
  "30031": 9.35,
  "30032": 8.8,
  "30033": 9.35,
  "30034": 9.35,
  "30035": 9.35,
  "30036": 9.35,
  "30037": 9.35,
  "30038": 6.13,
  "30039": 6.13,
  "30040": 7.51,
  "30041": 7.51,
  "30042": 6.13,
  "30043": 6.13,
  "30044": 6.13,
  "30045": 6.13,
  "30046": 6.13,
  "30047": 6.13,
  "30048": 6.13,
  "30049": 6.13,
  "30052": 4.75,
  "30054": -0.4,
  "30055": -0.92,
  "30056": -8.28,
  "30058": 6.13,
  "30060": 13.4,
  "30061": 13.4,
  "30062": 13.95,
  "30064": 13.95,
  "30065": 6.59,
  "30066": 13.95,
  "30067": 13.95,
  "30068": 13.95,
  "30070": -0.4,
  "30071": 6.13,
  "30072": 9.35,
  "30074": 6.13,
  "30075": 6.59,
  "30076": 13.95,
  "30077": 6.59,
  "30078": 6.13,
  "30079": 8.8,
  "30080": 13.95,
  "30081": 13.95,
  "30082": 13.95,
  "30083": 9.35,
  "30084": 9.35,
  "30085": 9.35,
  "30086": 9.35,
  "30087": 9.35,
  "30088": 9.35,
  "30090": 13.4,
  "30091": 6.13,
  "30092": 6.13,
  "30093": 6.13,
  "30094": 6.13,
  "30095": 6.13,
  "30096": 6.13,
  "30097": 7.72,
  "30101": 13.95,
  "30102": 6.59,
  "30103": -2.82,
  "30104": 4.2,
  "30105": -9.72,
  "30106": 13.95,
  "30107": -4.45,
  "30108": 5.77,
  "30109": 5.77,
  "30110": -4.35,
  "30111": 2.36,
  "30112": 5.77,
  "30113": -4.35,
  "30114": 6.59,
  "30115": 6.59,
  "30116": 7.88,
  "30117": 5.77,
  "30120": 3.37,
  "30121": 2.82,
  "30122": 2.91,
  "30123": 2.82,
  "30124": 1.57,
  "30125": 2.09,
  "30126": 13.95,
  "30127": -2.61,
  "30129": -9.47,
  "30132": -3.16,
  "30133": 2.91,
  "30134": 2.91,
  "30135": 2.91,
  "30137": 2.82,
  "30138": 2.09,
  "30139": -1.78,
  "30140": -4.35,
  "30141": -2.61,
  "30142": 6.59,
  "30143": -4.45,
  "30144": 13.95,
  "30145": 2.82,
  "30146": 6.59,
  "30147": -9.47,
  "30148": -2.7,
  "30149": -9.47,
  "30150": -4.35,
  "30151": -4.45,
  "30152": 13.95,
  "30153": 4.2,
  "30154": 2.91,
  "30156": 13.95,
  "30157": -2.61,
  "30160": 13.95,
  "30161": -9.47,
  "30162": -9.47,
  "30163": -9.47,
  "30164": -9.47,
  "30165": -9.47,
  "30168": 2.36,
  "30169": 6.59,
  "30170": -2.51,
  "30171": 2.82,
  "30172": -2.82,
  "30173": -6.84,
  "30175": -5,
  "30176": -4.35,
  "30177": -2.7,
  "30178": 2.82,
  "30179": -2.24,
  "30180": 2.36,
  "30182": -4.35,
  "30183": 6.59,
  "30184": 3.37,
  "30185": 7.88,
  "30187": 2.91,
  "30188": 6.59,
  "30189": 6.59,
  "30204": -4.81,
  "30205": 7.05,
  "30206": 1.99,
  "30212": -3.62,
  "30213": 7.05,
  "30214": 7.05,
  "30215": 7.05,
  "30216": -7.51,
  "30217": -1.99,
  "30218": 18,
  "30219": -1.99,
  "30220": 6.5,
  "30222": 16.96,
  "30223": -3.62,
  "30224": -3.07,
  "30228": -0.77,
  "30229": 7.05,
  "30230": 4.91,
  "30233": -7.51,
  "30234": -5.92,
  "30236": 5.67,
  "30237": 5.67,
  "30238": 5.12,
  "30240": 13.4,
  "30241": 4.91,
  "30248": -5.37,
  "30250": -0.77,
  "30251": 6.5,
  "30252": -0.77,
  "30253": -0.77,
  "30256": 0.92,
  "30257": -4.29,
  "30258": 0.4,
  "30259": 7.05,
  "30260": 5.12,
  "30261": 4.91,
  "30263": 7.05,
  "30264": 7.05,
  "30265": 7.05,
  "30266": -4.29,
  "30268": 6.5,
  "30269": 7.05,
  "30271": 7.05,
  "30272": 5.12,
  "30273": 5.12,
  "30274": 5.12,
  "30275": 6.5,
  "30276": 7.05,
  "30277": 7.05,
  "30281": -0.77,
  "30284": -0.77,
  "30285": 1.63,
  "30286": 1.63,
  "30287": 5.12,
  "30288": 5.12,
  "30289": 7.05,
  "30290": 7.05,
  "30291": 5.12,
  "30292": 1.99,
  "30293": 16.41,
  "30294": 5.67,
  "30295": 0.92,
  "30296": 5.67,
  "30297": 5.12,
  "30298": 5.12,
  "30301": 27.96,
  "30302": 17.17,
  "30303": 17.17,
  "30304": 5.12,
  "30305": 27.96,
  "30306": 27.96,
  "30307": 25.66,
  "30308": 17.17,
  "30309": 25.66,
  "30310": 16.62,
  "30311": 16.62,
  "30312": 17.17,
  "30313": 17.17,
  "30314": 16.62,
  "30315": 16.62,
  "30316": 16.62,
  "30317": 9.35,
  "30318": 16.62,
  "30319": 17.84,
  "30320": 5.15,
  "30321": 17.17,
  "30324": 18.76,
  "30325": 16.62,
  "30326": 27.96,
  "30327": 27.96,
  "30328": 22.44,
  "30329": 9.35,
  "30331": 17.17,
  "30333": 27.96,
  "30334": 16.62,
  "30336": 16.62,
  "30337": 5.15,
  "30338": 17.84,
  "30339": 24.74,
  "30340": 9.35,
  "30341": 9.35,
  "30342": 27.96,
  "30343": 17.17,
  "30344": 16.62,
  "30345": 10.94,
  "30346": 9.35,
  "30347": 9.35,
  "30348": 27.96,
  "30349": 5.12,
  "30350": 20.14,
  "30353": 17.17,
  "30354": 5.12,
  "30355": 27.96,
  "30356": 17.84,
  "30357": 25.66,
  "30358": 22.44,
  "30359": 9.35,
  "30360": 9.35,
  "30361": 25.66,
  "30362": 9.35,
  "30363": 27.96,
  "30364": 16.62,
  "30366": 9.35,
  "30369": 16.62,
  "30370": 17.17,
  "30371": 16.62,
  "30374": 5.12,
  "30376": 18.76,
  "30377": 16.62,
  "30378": 16.62,
  "30379": 17.17,
  "30392": 17.17,
  "30394": 17.17,
  "30401": -11.65,
  "30410": -3.43,
  "30411": -28.27,
  "30412": -2.91,
  "30413": -8.89,
  "30414": -4.75,
  "30415": 9.05,
  "30417": -4.75,
  "30420": -9.35,
  "30421": -10.27,
  "30423": -4.75,
  "30424": 9.6,
  "30425": -12.11,
  "30426": -4.29,
  "30427": -10.27,
  "30428": -28.27,
  "30429": -4.75,
  "30434": -9.41,
  "30436": 36.19,
  "30438": -10.27,
  "30439": -9.35,
  "30441": -11.65,
  "30442": -12.11,
  "30445": -3.43,
  "30446": -12.57,
  "30447": -7.05,
  "30448": -12.17,
  "30449": -12.57,
  "30450": 9.05,
  "30451": 9.05,
  "30452": 9.05,
  "30453": -10.27,
  "30454": -7.57,
  "30455": -13.09,
  "30456": -4.81,
  "30457": -7.57,
  "30458": 9.6,
  "30459": 9.6,
  "30461": 9.6,
  "30464": -9.87,
  "30467": -12.57,
  "30470": -7.57,
  "30471": -12.11,
  "30473": -2.91,
  "30474": 36.19,
  "30475": 36.19,
  "30477": -9.41,
  "30501": 1.44,
  "30502": 1.44,
  "30503": 1.44,
  "30504": 1.44,
  "30506": 9.41,
  "30507": 0.92,
  "30510": -6.9,
  "30511": -10.58,
  "30512": -13.86,
  "30513": 3.62,
  "30514": -13.86,
  "30515": 7.51,
  "30516": -6.13,
  "30517": 10.18,
  "30518": 7.51,
  "30519": 13.55,
  "30520": -5.98,
  "30521": -5.98,
  "30522": -5,
  "30523": -10.58,
  "30525": -11.56,
  "30527": -7.3,
  "30528": -7.3,
  "30529": 2.3,
  "30530": 2.3,
  "30531": -10.58,
  "30533": 5.12,
  "30534": -2.15,
  "30535": -10.58,
  "30536": -2.82,
  "30537": -3.62,
  "30538": -9.81,
  "30539": -2.82,
  "30540": -2.82,
  "30541": 3.62,
  "30542": 1.44,
  "30543": -6.9,
  "30544": -10.58,
  "30545": -7.3,
  "30546": 12.48,
  "30547": -6.9,
  "30548": 10.18,
  "30549": 2.3,
  "30552": -11.56,
  "30553": -7.05,
  "30554": -6.9,
  "30555": 3.07,
  "30557": -9.81,
  "30558": -6.9,
  "30559": 3.62,
  "30560": 3.62,
  "30562": -12.11,
  "30563": -10.58,
  "30564": 5.12,
  "30565": 2.3,
  "30566": 1.44,
  "30567": 2.3,
  "30568": -11.56,
  "30571": -7.3,
  "30572": -12.82,
  "30573": -11.56,
  "30575": 2.3,
  "30576": -11.56,
  "30577": -9.81,
  "30580": -11.1,
  "30581": -11.56,
  "30582": 4.54,
  "30598": -9.81,
  "30601": 5.52,
  "30603": 5.52,
  "30604": 5.52,
  "30605": 6.04,
  "30606": 7.11,
  "30607": 5.52,
  "30608": 5.52,
  "30612": 7.11,
  "30619": -9.6,
  "30620": 10.18,
  "30621": 0.52,
  "30622": 0.52,
  "30623": 3.68,
  "30624": -17.17,
  "30625": 5.58,
  "30627": -16.1,
  "30628": -6.44,
  "30629": -6.44,
  "30630": -10.12,
  "30631": -8.28,
  "30633": -6.44,
  "30634": -17.17,
  "30635": -17.17,
  "30638": 0,
  "30639": -5.98,
  "30641": 3.68,
  "30642": -8.28,
  "30643": -6.13,
  "30645": 0.52,
  "30646": -6.44,
  "30647": -6.44,
  "30648": -10.12,
  "30650": 5.06,
  "30655": 4.2,
  "30656": 4.2,
  "30660": 5.06,
  "30662": -5.98,
  "30663": 5.58,
  "30664": -8.28,
  "30665": -8.28,
  "30666": 9.66,
  "30667": -10.12,
  "30668": 5.06,
  "30669": -8.28,
  "30671": -10.12,
  "30673": 5.06,
  "30677": 8.49,
  "30678": -8.28,
  "30680": 9.66,
  "30683": 5.52,
  "30701": -2.82,
  "30703": -2.82,
  "30705": -17.08,
  "30707": -1.9,
  "30708": -17.63,
  "30710": -5.58,
  "30711": -17.08,
  "30719": -5.58,
  "30720": -5.58,
  "30721": -5.58,
  "30722": -5.58,
  "30724": -17.63,
  "30725": -1.9,
  "30726": 5.37,
  "30728": -1.9,
  "30730": -11.31,
  "30731": -10.27,
  "30732": -2.82,
  "30733": -2.82,
  "30734": -2.82,
  "30735": -2.82,
  "30736": -1.9,
  "30738": -11.1,
  "30739": -1.9,
  "30740": -5.58,
  "30741": 5.37,
  "30742": -1.9,
  "30746": -2.82,
  "30747": -10.27,
  "30750": -2.61,
  "30751": -17.63,
  "30752": -11.1,
  "30753": -10.27,
  "30755": -5.58,
  "30756": -5.58,
  "30757": -11.1,
  "30802": -2.7,
  "30803": 0.71,
  "30805": -5.67,
  "30806": -12.11,
  "30807": -0.67,
  "30808": -12.11,
  "30809": 4.2,
  "30810": 1.23,
  "30811": -4.29,
  "30812": -5.67,
  "30813": -4.29,
  "30814": -4.29,
  "30815": -5.67,
  "30816": -4.29,
  "30817": -8.43,
  "30818": -9.41,
  "30819": -0.67,
  "30820": 1.23,
  "30821": -0.67,
  "30822": -12.11,
  "30823": 1.23,
  "30824": -12.11,
  "30828": -0.15,
  "30830": -4.29,
  "30833": -8.89,
  "30901": -6.19,
  "30903": -6.19,
  "30904": -5.67,
  "30905": -4.08,
  "30906": -5.67,
  "30907": 4.2,
  "30909": 2.82,
  "30912": -6.19,
  "30913": 4.2,
  "30914": -5.67,
  "30916": -5.67,
  "30917": 4.2,
  "30919": 2.82,
  "31001": -23.67,
  "31002": -7.57,
  "31003": -9.87,
  "31004": -7.05,
  "31005": 2.3,
  "31006": -5.73,
  "31007": -4.29,
  "31008": -3.83,
  "31009": -11.71,
  "31010": -2.91,
  "31011": -11.71,
  "31012": -11.71,
  "31013": -6.19,
  "31014": -8.95,
  "31015": -2.91,
  "31016": 1.63,
  "31017": -9.87,
  "31018": -5.21,
  "31019": -6.19,
  "31020": 2.55,
  "31021": -6.19,
  "31022": -6.19,
  "31023": -11.71,
  "31024": -3.83,
  "31025": -6.19,
  "31027": -6.19,
  "31028": -5.67,
  "31029": -7.05,
  "31030": -4.35,
  "31031": -9.87,
  "31032": -1.53,
  "31033": -2.05,
  "31034": -11.71,
  "31035": -5.73,
  "31036": -8.95,
  "31037": -1.13,
  "31038": -9.87,
  "31039": -5.73,
  "31040": -6.19,
  "31041": -4.81,
  "31042": -9.87,
  "31044": -9.87,
  "31045": 0.71,
  "31046": -7.05,
  "31047": 2.3,
  "31049": -22.29,
  "31050": -4.35,
  "31051": -3.43,
  "31052": 4.14,
  "31054": -9.87,
  "31055": -1.13,
  "31057": -4.81,
  "31058": -13.03,
  "31059": -11.71,
  "31060": -1.13,
  "31061": -11.71,
  "31063": -4.81,
  "31064": -9.35,
  "31065": -6.19,
  "31066": 4.14,
  "31067": -5.73,
  "31068": -4.81,
  "31069": -5.67,
  "31070": -3.43,
  "31071": -8.95,
  "31072": -23.67,
  "31075": -6.19,
  "31076": -5.73,
  "31077": -11.71,
  "31078": -4.35,
  "31079": -23.67,
  "31081": -5.21,
  "31082": -5.73,
  "31083": -1.13,
  "31084": -23.67,
  "31085": -8.28,
  "31086": 1.63,
  "31087": -11.71,
  "31088": -5.67,
  "31089": -5.73,
  "31090": -9.87,
  "31091": -8.95,
  "31092": -3.43,
  "31093": -6.19,
  "31094": -5.73,
  "31095": -6.19,
  "31096": -22.29,
  "31097": 1.63,
  "31098": -6.19,
  "31099": -6.19,
  "31106": 27.96,
  "31107": 25.66,
  "31119": 27.96,
  "31126": 27.96,
  "31131": 17.17,
  "31139": 17.17,
  "31141": 16.62,
  "31145": 10.94,
  "31146": 9.35,
  "31150": 20.14,
  "31156": 22.44,
  "31201": 2.55,
  "31202": 2.55,
  "31203": 2.55,
  "31204": 2.55,
  "31205": 11.04,
  "31206": 2.55,
  "31208": 2.55,
  "31209": 2.55,
  "31210": 11.04,
  "31211": 3.07,
  "31212": 2.55,
  "31216": 11.04,
  "31217": 2.55,
  "31220": 11.04,
  "31221": 11.04,
  "31297": 2.55,
  "31301": 36.65,
  "31302": 0.77,
  "31303": -6.13,
  "31304": 18.92,
  "31305": 8.13,
  "31307": 0.77,
  "31308": 0.77,
  "31309": 36.65,
  "31310": 36.65,
  "31312": -5.61,
  "31313": 36.65,
  "31314": 36.65,
  "31315": 36.65,
  "31316": -20.39,
  "31318": 0.77,
  "31319": 8.13,
  "31320": 36.65,
  "31321": 0.77,
  "31322": -0.06,
  "31323": 36.65,
  "31324": 1.32,
  "31326": -5.58,
  "31327": 7.61,
  "31328": 7.88,
  "31329": -6.13,
  "31331": 8.13,
  "31333": 36.65,
  "31401": -0.61,
  "31402": 0.77,
  "31403": -0.06,
  "31404": -0.61,
  "31405": -0.06,
  "31406": -0.06,
  "31407": -0.61,
  "31408": -0.61,
  "31409": -0.06,
  "31410": -0.06,
  "31411": 10.18,
  "31412": -0.61,
  "31414": -0.61,
  "31415": -0.61,
  "31416": -0.06,
  "31418": -0.61,
  "31419": -0.06,
  "31420": -0.06,
  "31421": -0.61,
  "31501": -11.19,
  "31502": -11.19,
  "31503": -11.19,
  "31510": 0.31,
  "31512": -13.09,
  "31513": 3.53,
  "31515": 3.53,
  "31516": -13.03,
  "31518": -13.03,
  "31519": -13.09,
  "31520": -7.51,
  "31521": -7.51,
  "31522": 1.53,
  "31523": -7.51,
  "31525": -7.51,
  "31527": 1.53,
  "31532": -19.93,
  "31533": -13.09,
  "31534": -13.09,
  "31535": -13.09,
  "31537": -13.49,
  "31539": -19.93,
  "31542": -9.35,
  "31543": -9.35,
  "31544": -1.13,
  "31545": -9.35,
  "31546": -9.35,
  "31547": -2.36,
  "31548": -2.36,
  "31549": -20.45,
  "31550": -11.19,
  "31551": -13.03,
  "31552": -11.19,
  "31553": -9.35,
  "31554": -0.21,
  "31555": -9.35,
  "31556": -13.03,
  "31557": -13.03,
  "31558": -2.36,
  "31560": -9.35,
  "31561": 1.53,
  "31562": -13.49,
  "31563": 3.53,
  "31564": -11.19,
  "31565": -6.96,
  "31566": -9.35,
  "31567": -13.09,
  "31568": -6.96,
  "31569": -2.36,
  "31598": -9.35,
  "31601": -2.3,
  "31602": -1.78,
  "31603": -1.78,
  "31604": -1.78,
  "31605": -1.78,
  "31606": -2.3,
  "31620": -13.09,
  "31622": -17.23,
  "31623": -4.29,
  "31624": -13.55,
  "31625": -12.17,
  "31626": -4.14,
  "31627": -13.09,
  "31629": -10.58,
  "31630": -4.29,
  "31631": -4.29,
  "31632": 4.6,
  "31634": -4.29,
  "31635": -14.93,
  "31636": -2.3,
  "31637": -13.09,
  "31638": -10.58,
  "31639": -16.71,
  "31641": -14.93,
  "31642": -13.55,
  "31643": -10.58,
  "31645": -14.93,
  "31647": -13.09,
  "31648": -10.58,
  "31649": -14.93,
  "31650": -13.55,
  "31701": -9.87,
  "31702": -1.38,
  "31703": -9.87,
  "31705": -9.87,
  "31706": -9.87,
  "31707": -1.38,
  "31708": -9.87,
  "31709": -12.11,
  "31711": -12.63,
  "31712": -3.43,
  "31714": -4.35,
  "31716": -6.59,
  "31719": -12.11,
  "31720": -10.58,
  "31721": -1.38,
  "31722": -7.97,
  "31727": -0.61,
  "31730": -7.11,
  "31733": -0.61,
  "31735": 5.06,
  "31738": -5.21,
  "31739": -6.59,
  "31743": -12.63,
  "31744": -7.97,
  "31747": -7.97,
  "31749": -1.13,
  "31750": -8.49,
  "31753": 0,
  "31756": 0,
  "31757": -4.14,
  "31758": -4.14,
  "31760": -0.61,
  "31763": -1.38,
  "31764": -12.63,
  "31765": -7.11,
  "31768": -7.97,
  "31769": 18.65,
  "31771": -8.49,
  "31772": -9.87,
  "31773": -4.14,
  "31774": 18.65,
  "31775": -1.13,
  "31776": -7.97,
  "31778": -10.58,
  "31779": -6.59,
  "31780": -12.63,
  "31781": -13.55,
  "31782": -13.03,
  "31783": -4.35,
  "31784": -6.59,
  "31787": -12.11,
  "31788": -7.97,
  "31789": -13.03,
  "31790": -4.35,
  "31791": -13.03,
  "31792": -4.14,
  "31793": -0.61,
  "31794": -0.61,
  "31795": -0.61,
  "31796": -2.91,
  "31798": 18.65,
  "31799": -4.14,
  "31801": -12.48,
  "31803": -13.03,
  "31804": -2.15,
  "31805": -13.03,
  "31806": -4.81,
  "31807": -10.64,
  "31808": -2.15,
  "31810": -12.48,
  "31811": -9.05,
  "31812": -16.25,
  "31814": -13.03,
  "31815": -7.97,
  "31816": 16.96,
  "31820": 5.21,
  "31821": -13.03,
  "31822": -10.64,
  "31823": -10.64,
  "31824": -13.49,
  "31825": -13.03,
  "31826": -15.7,
  "31827": -16.25,
  "31829": 5.21,
  "31830": 16.96,
  "31831": -15.7,
  "31832": -8.49,
  "31833": -7.97,
  "31836": -16.25,
  "31901": -3.28,
  "31902": -3.28,
  "31903": -3.83,
  "31904": -3.28,
  "31905": -3.83,
  "31906": -3.28,
  "31907": -3.28,
  "31908": -3.28,
  "31909": -3.28,
  "31914": -3.28,
  "31917": -3.28,
  "31995": -3.28,
  "32003": 0.86,
  "32004": 0.86,
  "32006": 0.86,
  "32007": -14.41,
  "32008": -1.99,
  "32009": -10.64,
  "32011": -9.72,
  "32013": -19.38,
  "32024": -11.19,
  "32025": -11.19,
  "32030": -7.88,
  "32033": -1.44,
  "32034": -9.72,
  "32035": -9.72,
  "32038": -10.18,
  "32040": -10.64,
  "32041": -9.72,
  "32042": -8.8,
  "32043": -7.88,
  "32044": -9.35,
  "32046": -9.72,
  "32050": -7.88,
  "32052": -11.65,
  "32053": -16.1,
  "32054": -8.8,
  "32055": -10.64,
  "32056": -11.19,
  "32058": -8.8,
  "32059": -16.1,
  "32060": -19.38,
  "32061": -8.8,
  "32062": -19.93,
  "32063": -10.64,
  "32064": -19.93,
  "32065": -7.88,
  "32066": -19.38,
  "32067": -7.88,
  "32068": -7.88,
  "32071": -1.99,
  "32072": -10.64,
  "32073": 0.86,
  "32079": -7.88,
  "32080": -1.44,
  "32081": 9.35,
  "32082": 9.35,
  "32083": -9.35,
  "32084": 0.15,
  "32085": -1.44,
  "32086": -1.44,
  "32087": -10.64,
  "32091": -8.8,
  "32092": -1.44,
  "32094": -1.44,
  "32095": -1.44,
  "32096": -11.65,
  "32097": -9.72,
  "32102": -8.89,
  "32105": -8.89,
  "32110": -13.49,
  "32111": -9.87,
  "32112": -14.93,
  "32113": -9.87,
  "32114": -9.41,
  "32115": -9.41,
  "32116": -8.89,
  "32117": -9.41,
  "32118": -8.89,
  "32119": -8.89,
  "32120": -9.41,
  "32121": -9.41,
  "32122": -8.89,
  "32123": -8.89,
  "32124": -0.4,
  "32125": -9.41,
  "32126": -8.89,
  "32127": -8.89,
  "32128": -0.4,
  "32129": -8.89,
  "32130": -8.89,
  "32131": -13.86,
  "32132": -8.89,
  "32133": -9.87,
  "32134": -14.93,
  "32135": -11.9,
  "32136": -13.49,
  "32137": -11.9,
  "32138": -13.86,
  "32139": -14.93,
  "32140": -13.86,
  "32141": -8.89,
  "32142": -13.49,
  "32143": -13.49,
  "32145": -14.01,
  "32147": -14.41,
  "32148": -14.41,
  "32149": -14.41,
  "32157": -14.93,
  "32158": 3.68,
  "32159": 3.68,
  "32160": -8.8,
  "32162": 3.68,
  "32163": 3.68,
  "32164": -13.49,
  "32168": -8.89,
  "32169": -0.4,
  "32170": -8.89,
  "32173": -8.89,
  "32174": -8.89,
  "32175": -13.49,
  "32176": -13.49,
  "32177": -14.41,
  "32178": -14.41,
  "32179": -9.87,
  "32180": -8.89,
  "32181": -14.93,
  "32182": -15.45,
  "32183": -9.87,
  "32185": -13.86,
  "32187": -14.93,
  "32189": -14.93,
  "32190": -13.49,
  "32192": -9.87,
  "32193": -14.93,
  "32195": -9.87,
  "32201": 0.86,
  "32202": 0.31,
  "32203": 0.86,
  "32204": 0.86,
  "32205": 0.86,
  "32206": 0.31,
  "32207": 0.86,
  "32208": 0.31,
  "32209": 0.31,
  "32210": 0.86,
  "32211": 0.86,
  "32212": 0.86,
  "32215": -7.88,
  "32216": 0.86,
  "32217": 0.86,
  "32218": 0.86,
  "32219": 0.86,
  "32220": 0.86,
  "32221": 0.86,
  "32222": 0.86,
  "32223": 0.86,
  "32224": 0.86,
  "32225": 0.86,
  "32226": 0.86,
  "32227": 0.31,
  "32228": 0.31,
  "32229": 0.86,
  "32230": 0.86,
  "32231": 0.86,
  "32232": 0.86,
  "32233": 0.86,
  "32234": -11.19,
  "32235": 0.86,
  "32236": 0.86,
  "32237": 0.86,
  "32238": 0.86,
  "32239": 0.86,
  "32240": 0.86,
  "32241": 0.86,
  "32244": 0.86,
  "32245": 9.35,
  "32246": 0.86,
  "32247": 0.86,
  "32250": 0.86,
  "32254": 0.31,
  "32255": 0.86,
  "32256": 9.35,
  "32257": 0.86,
  "32258": 0.86,
  "32259": 0.61,
  "32260": 0.61,
  "32266": 2.45,
  "32277": 0.86,
  "32301": -5.06,
  "32302": -5.06,
  "32303": -4.54,
  "32304": -5.06,
  "32305": -11.96,
  "32308": 3.43,
  "32309": -11.5,
  "32310": -5.06,
  "32311": -3.47,
  "32312": 3.43,
  "32314": -5.06,
  "32315": -4.54,
  "32316": -5.06,
  "32317": 3.43,
  "32318": -5.06,
  "32320": -16.71,
  "32321": -3.22,
  "32322": -15.64,
  "32323": -15.64,
  "32324": -4.14,
  "32326": -11.96,
  "32327": -11.96,
  "32328": -16.71,
  "32329": -16.71,
  "32330": -4.14,
  "32331": -16.1,
  "32332": -4.14,
  "32333": -4.14,
  "32334": -3.74,
  "32335": -13.55,
  "32336": -11.5,
  "32337": -11.5,
  "32340": -16.1,
  "32341": -16.1,
  "32343": -4.14,
  "32344": -11.5,
  "32345": -11.5,
  "32346": -11.44,
  "32347": -5.98,
  "32348": -5.98,
  "32350": -16.1,
  "32351": -4.14,
  "32352": -4.14,
  "32353": -4.14,
  "32355": -11.96,
  "32356": -6.5,
  "32357": -5.98,
  "32358": -11.96,
  "32359": -16.71,
  "32360": -3.22,
  "32361": -11.5,
  "32362": -3.47,
  "32401": -8.49,
  "32402": -7.97,
  "32403": 0.52,
  "32404": -7.97,
  "32405": -7.97,
  "32406": -7.97,
  "32407": -7.97,
  "32408": -7.97,
  "32409": -7.97,
  "32410": -4.54,
  "32411": -7.97,
  "32412": -8.49,
  "32413": -7.97,
  "32417": -7.97,
  "32420": -8.95,
  "32421": -16.31,
  "32422": 3.83,
  "32423": -7.88,
  "32424": -16.31,
  "32425": -16.62,
  "32426": -8.43,
  "32427": -17.17,
  "32428": -15.79,
  "32430": -16.31,
  "32431": -7.88,
  "32432": -8.43,
  "32433": -5.21,
  "32434": -5.21,
  "32435": -5.21,
  "32437": -16.31,
  "32438": -16.31,
  "32439": -4.66,
  "32440": -16.62,
  "32442": -7.88,
  "32443": -7.88,
  "32444": -7.97,
  "32445": -7.88,
  "32446": -6.29,
  "32447": -6.29,
  "32448": -7.88,
  "32449": -16.31,
  "32452": -16.62,
  "32455": 3.83,
  "32456": -13.03,
  "32457": -13.03,
  "32459": -4.66,
  "32460": -7.88,
  "32461": -7.97,
  "32462": -16.31,
  "32463": -16.31,
  "32464": -17.17,
  "32465": -13.55,
  "32466": -8.49,
  "32501": -5.12,
  "32502": -5.12,
  "32503": -4.6,
  "32504": -4.6,
  "32505": -5.12,
  "32506": -4.6,
  "32507": -4.6,
  "32508": -5.12,
  "32513": -4.6,
  "32514": -4.6,
  "32516": -4.6,
  "32522": -5.12,
  "32523": -4.6,
  "32524": -4.6,
  "32526": -4.6,
  "32530": -7.88,
  "32531": -8.34,
  "32533": -4.6,
  "32534": -5.12,
  "32535": -7.88,
  "32536": -8.34,
  "32537": -8.34,
  "32538": -8.89,
  "32539": -8.34,
  "32540": 0.15,
  "32541": 0.15,
  "32542": -8.89,
  "32544": -8.34,
  "32547": -8.34,
  "32548": -8.34,
  "32549": -8.34,
  "32550": 0.15,
  "32560": -4.6,
  "32561": 3.89,
  "32562": -5.12,
  "32563": -7.88,
  "32564": -8.89,
  "32565": -7.88,
  "32566": -7.88,
  "32567": -8.89,
  "32568": -5.12,
  "32569": -8.34,
  "32570": -7.88,
  "32571": -7.36,
  "32572": -7.88,
  "32577": -4.6,
  "32578": -8.34,
  "32579": -8.34,
  "32580": -8.34,
  "32583": -7.88,
  "32588": -8.34,
  "32590": -5.12,
  "32591": -5.12,
  "32592": -5.12,
  "32601": -6.13,
  "32602": 2.91,
  "32603": 2.91,
  "32604": 2.91,
  "32605": 2.91,
  "32606": 2.91,
  "32607": 2.91,
  "32608": -3.99,
  "32609": -5.58,
  "32613": -5.58,
  "32614": -3.99,
  "32615": -6.13,
  "32616": -6.13,
  "32617": -9.87,
  "32618": -5.58,
  "32619": -10.73,
  "32621": -13.03,
  "32622": -8.8,
  "32625": -12.48,
  "32626": -13.03,
  "32627": -5.58,
  "32628": -16.71,
  "32631": -8.8,
  "32633": -5.58,
  "32634": -9.87,
  "32635": -5.58,
  "32639": -13.55,
  "32640": -13.86,
  "32641": -5.58,
  "32643": -10.18,
  "32644": -13.03,
  "32648": -16.16,
  "32653": -5.58,
  "32654": -6.13,
  "32655": -10.18,
  "32656": -8.8,
  "32658": -5.58,
  "32662": -6.13,
  "32663": -9.87,
  "32664": -5.58,
  "32666": -8.8,
  "32667": -5.58,
  "32668": -9.87,
  "32669": -5.58,
  "32680": -16.71,
  "32681": -6.65,
  "32683": -13.03,
  "32686": -9.87,
  "32692": -7.67,
  "32693": -10.73,
  "32694": -8.8,
  "32696": -12.48,
  "32697": -9.35,
  "32701": 0,
  "32702": 0.71,
  "32703": 0.92,
  "32704": 0.92,
  "32706": -8.89,
  "32707": 0,
  "32708": 0,
  "32709": -1.59,
  "32710": 0.92,
  "32712": 0,
  "32713": 0,
  "32714": 0,
  "32715": 0,
  "32716": 0,
  "32718": 0,
  "32719": 0,
  "32720": -8.89,
  "32721": -8.89,
  "32722": -8.89,
  "32724": -8.89,
  "32725": -8.89,
  "32726": 2.3,
  "32727": 2.3,
  "32728": -8.89,
  "32730": 0,
  "32732": 6.9,
  "32733": 0,
  "32735": 0.71,
  "32736": 2.3,
  "32738": -8.89,
  "32739": -8.89,
  "32744": -8.89,
  "32745": 0,
  "32746": 0,
  "32747": 0,
  "32750": 0,
  "32751": 0.92,
  "32752": 1.59,
  "32753": 0,
  "32754": -1.59,
  "32756": 2.3,
  "32757": 2.3,
  "32759": -9.41,
  "32762": 0,
  "32763": -8.89,
  "32764": -9.41,
  "32765": 0,
  "32766": 0,
  "32767": 0.71,
  "32768": 1.78,
  "32771": 0,
  "32772": -0.52,
  "32773": -0.52,
  "32774": -8.89,
  "32775": -9.41,
  "32776": 2.3,
  "32777": 2.3,
  "32778": 1.78,
  "32779": 1.59,
  "32780": -3.89,
  "32781": -3.89,
  "32782": -1.59,
  "32783": -3.89,
  "32784": 0.71,
  "32789": 9.41,
  "32790": 9.41,
  "32791": 1.59,
  "32792": 0,
  "32793": 0.92,
  "32794": 0.92,
  "32795": 0,
  "32796": -1.59,
  "32798": 1.78,
  "32799": 0.92,
  "32801": 0.92,
  "32802": 0.92,
  "32803": 0.92,
  "32804": 0.92,
  "32805": 0.4,
  "32806": 0.92,
  "32807": 0.92,
  "32808": 0.92,
  "32809": 0.92,
  "32810": 0.92,
  "32811": 0.4,
  "32812": 0.92,
  "32814": 0.92,
  "32815": -3.89,
  "32817": 0,
  "32818": 0.92,
  "32819": 0.92,
  "32820": -0.52,
  "32821": 0.92,
  "32822": 0.92,
  "32824": 0.92,
  "32825": 0.92,
  "32826": 0,
  "32827": 0.92,
  "32828": 0.92,
  "32829": 0.92,
  "32830": 9.41,
  "32831": 0.4,
  "32832": -7.36,
  "32833": -1.07,
  "32834": 0,
  "32835": 0.92,
  "32836": 9.41,
  "32837": 0.92,
  "32839": 0.92,
  "32853": 0.92,
  "32854": 0.92,
  "32855": 0.4,
  "32856": 0.92,
  "32857": 0.92,
  "32858": 0.92,
  "32859": 0.92,
  "32860": 0.92,
  "32861": 0.4,
  "32862": 0.92,
  "32867": 0,
  "32868": 0.92,
  "32869": 0.92,
  "32872": 0.92,
  "32877": 0.92,
  "32878": 0.92,
  "32901": -3.37,
  "32902": -3.37,
  "32903": -2.82,
  "32904": -3.37,
  "32905": -3.37,
  "32906": -3.37,
  "32907": -3.37,
  "32908": -3.37,
  "32909": -3.37,
  "32910": -3.37,
  "32911": -3.37,
  "32912": -3.37,
  "32920": -3.37,
  "32922": -3.89,
  "32923": -2.82,
  "32924": -2.82,
  "32925": -3.37,
  "32926": -3.89,
  "32927": -3.89,
  "32931": -3.37,
  "32932": -3.37,
  "32934": -2.82,
  "32935": -3.37,
  "32936": -3.37,
  "32937": -3.37,
  "32940": -2.82,
  "32941": -3.37,
  "32948": -9.35,
  "32949": -7.76,
  "32950": -3.37,
  "32951": 5.12,
  "32952": -2.82,
  "32953": 4.6,
  "32954": -2.82,
  "32955": -3.37,
  "32956": -3.37,
  "32957": -9.35,
  "32958": -9.35,
  "32959": -3.89,
  "32960": -10.39,
  "32961": -10.39,
  "32962": -10.39,
  "32963": 0.4,
  "32964": -10.39,
  "32965": -10.39,
  "32966": -10.39,
  "32967": -9.35,
  "32968": -10.39,
  "32969": -10.39,
  "32970": -9.87,
  "32971": -9.87,
  "32976": -9.87,
  "32978": -9.35,
  "33001": -3.99,
  "33002": -2.15,
  "33004": 1.99,
  "33008": 1.99,
  "33009": 1.99,
  "33010": -2.15,
  "33011": -2.15,
  "33012": -2.15,
  "33013": -2.15,
  "33014": -2.15,
  "33015": -2.15,
  "33016": -2.7,
  "33017": -2.15,
  "33018": -2.15,
  "33019": 2.51,
  "33020": 1.99,
  "33021": 1.99,
  "33022": 1.99,
  "33023": 1.99,
  "33024": 1.99,
  "33025": 1.99,
  "33026": 1.99,
  "33027": 1.44,
  "33028": 2.51,
  "33029": 2.51,
  "33030": -2.7,
  "33031": -2.15,
  "33032": -2.7,
  "33033": -2.7,
  "33034": -2.7,
  "33035": -2.7,
  "33036": 6.8,
  "33037": -2.15,
  "33040": -3.47,
  "33041": -3.47,
  "33042": -3.47,
  "33043": -3.99,
  "33045": -3.47,
  "33050": -3.99,
  "33051": -3.99,
  "33052": -3.99,
  "33054": -2.7,
  "33055": -2.7,
  "33056": 1.44,
  "33060": 1.99,
  "33061": 1.99,
  "33062": 1.99,
  "33063": 1.99,
  "33064": 1.99,
  "33065": 2.51,
  "33066": 1.99,
  "33067": 4.1,
  "33068": 1.99,
  "33069": 1.99,
  "33070": -3.99,
  "33071": 2.51,
  "33072": 1.99,
  "33073": 2.51,
  "33074": 1.99,
  "33075": 2.51,
  "33076": 2.51,
  "33077": 2.51,
  "33081": 1.99,
  "33082": 1.99,
  "33083": 1.99,
  "33084": 1.99,
  "33090": -2.7,
  "33092": -2.7,
  "33093": 1.99,
  "33097": 1.99,
  "33101": -2.7,
  "33102": -2.7,
  "33109": -2.7,
  "33111": -2.15,
  "33114": -2.15,
  "33116": -2.15,
  "33119": -2.15,
  "33122": -2.7,
  "33124": -0.56,
  "33125": -2.15,
  "33126": -2.7,
  "33127": -2.7,
  "33128": -2.7,
  "33129": -2.15,
  "33130": -2.7,
  "33131": -2.15,
  "33132": -2.15,
  "33133": -0.56,
  "33134": -2.15,
  "33135": -2.15,
  "33136": -2.7,
  "33137": -2.7,
  "33138": -2.15,
  "33139": -2.15,
  "33140": -2.15,
  "33141": -2.15,
  "33142": -2.7,
  "33143": -2.15,
  "33144": -2.15,
  "33145": -2.15,
  "33146": 8.64,
  "33147": -2.7,
  "33149": 8.64,
  "33150": -2.7,
  "33151": -2.7,
  "33152": -2.7,
  "33153": -2.15,
  "33154": -2.15,
  "33155": -2.15,
  "33156": 8.64,
  "33157": -2.15,
  "33158": 8.64,
  "33159": -2.7,
  "33160": 1.44,
  "33161": -2.15,
  "33162": -2.7,
  "33163": 1.99,
  "33164": -2.7,
  "33165": -2.15,
  "33166": -2.15,
  "33167": -2.7,
  "33168": -2.7,
  "33169": 1.99,
  "33170": -2.15,
  "33172": -2.7,
  "33173": -2.15,
  "33174": -2.15,
  "33175": -2.15,
  "33176": -2.15,
  "33177": -2.7,
  "33178": -2.15,
  "33179": 1.44,
  "33180": 1.99,
  "33181": -2.15,
  "33182": -2.15,
  "33183": -2.7,
  "33184": -2.15,
  "33185": -2.15,
  "33186": -2.15,
  "33187": -2.15,
  "33189": -2.7,
  "33190": -2.7,
  "33193": -2.15,
  "33194": -2.15,
  "33196": -2.15,
  "33197": -2.15,
  "33222": -0.56,
  "33231": -2.7,
  "33233": -0.56,
  "33234": -2.15,
  "33238": -2.15,
  "33239": -2.15,
  "33242": -2.7,
  "33243": -2.15,
  "33245": -2.15,
  "33247": -2.7,
  "33255": -2.15,
  "33256": 8.64,
  "33257": -2.15,
  "33261": -2.15,
  "33265": -2.15,
  "33266": -2.15,
  "33269": 1.99,
  "33280": 1.44,
  "33283": -2.15,
  "33296": -2.15,
  "33299": -2.7,
  "33301": 12.78,
  "33302": 1.99,
  "33303": 2.51,
  "33304": 1.99,
  "33305": 1.99,
  "33306": 2.51,
  "33307": 1.99,
  "33308": 2.51,
  "33309": 1.99,
  "33310": 1.99,
  "33311": 1.99,
  "33312": 1.99,
  "33313": 1.99,
  "33314": 1.99,
  "33315": 1.99,
  "33316": 12.78,
  "33317": 1.99,
  "33318": 1.99,
  "33319": 1.99,
  "33320": 1.99,
  "33321": 1.99,
  "33322": 1.99,
  "33323": 1.99,
  "33324": 1.99,
  "33325": 1.99,
  "33326": 1.99,
  "33327": 12.78,
  "33328": 1.99,
  "33329": 1.99,
  "33330": 2.51,
  "33331": 3.58,
  "33332": 12.78,
  "33334": 1.99,
  "33335": 1.99,
  "33338": 1.99,
  "33339": 2.51,
  "33340": 1.99,
  "33345": 1.99,
  "33346": 12.78,
  "33348": 2.51,
  "33349": 1.99,
  "33351": 1.99,
  "33355": 1.99,
  "33359": 1.99,
  "33388": 1.99,
  "33394": 12.78,
  "33401": 2.24,
  "33402": 2.24,
  "33403": 2.24,
  "33404": 2.24,
  "33405": 2.76,
  "33406": 2.76,
  "33407": 2.24,
  "33408": 2.76,
  "33409": 2.24,
  "33410": 2.76,
  "33411": 2.76,
  "33412": 2.76,
  "33413": 2.76,
  "33414": 2.76,
  "33415": 2.24,
  "33416": 2.76,
  "33417": 2.24,
  "33418": 2.76,
  "33419": 2.24,
  "33420": 2.76,
  "33421": 2.76,
  "33422": 2.24,
  "33424": 3.83,
  "33425": 4.35,
  "33426": 3.83,
  "33427": 2.51,
  "33428": 1.99,
  "33429": 2.51,
  "33430": 2.24,
  "33431": 2.51,
  "33432": 2.51,
  "33433": 2.51,
  "33434": 1.99,
  "33435": 3.83,
  "33436": 3.83,
  "33437": 4.35,
  "33438": 2.24,
  "33439": 2.24,
  "33440": -6.19,
  "33441": 1.99,
  "33442": 1.99,
  "33443": 2.51,
  "33444": 3.83,
  "33445": 3.83,
  "33446": 3.83,
  "33448": 3.83,
  "33449": 2.76,
  "33454": 2.76,
  "33455": -6.04,
  "33458": -5.52,
  "33459": -5.12,
  "33460": 2.24,
  "33461": 2.24,
  "33462": 2.24,
  "33463": 2.24,
  "33465": 2.24,
  "33466": 2.24,
  "33467": 2.76,
  "33468": -5.52,
  "33469": -5.52,
  "33470": 2.76,
  "33471": -11.71,
  "33472": 2.76,
  "33473": 4.35,
  "33474": 3.83,
  "33475": -6.04,
  "33476": 2.24,
  "33477": -5.52,
  "33478": -5.52,
  "33480": 13.55,
  "33481": 2.51,
  "33482": 3.83,
  "33483": 4.35,
  "33484": 3.83,
  "33486": 2.51,
  "33487": 4.35,
  "33488": 2.51,
  "33493": -5.12,
  "33496": 12.84,
  "33497": 1.99,
  "33498": 4.35,
  "33503": 2.24,
  "33508": 2.24,
  "33509": 2.24,
  "33510": 2.24,
  "33511": 2.24,
  "33513": -4.81,
  "33514": -3.74,
  "33521": -4.81,
  "33523": -11.25,
  "33524": -8.95,
  "33525": -8.43,
  "33526": -11.25,
  "33527": 2.24,
  "33530": 2.76,
  "33534": 2.24,
  "33537": -11.25,
  "33538": -4.81,
  "33539": -7.88,
  "33540": -8.95,
  "33541": -8.95,
  "33542": -8.95,
  "33543": -7.36,
  "33544": -7.88,
  "33545": -7.36,
  "33547": 10.18,
  "33548": -7.36,
  "33549": -7.36,
  "33550": 2.24,
  "33556": 0.61,
  "33558": -7.36,
  "33559": 10.73,
  "33563": 1.69,
  "33564": 1.69,
  "33565": 1.69,
  "33566": 1.69,
  "33567": 1.69,
  "33568": 2.24,
  "33569": 2.24,
  "33570": -4.29,
  "33571": -4.29,
  "33572": 2.76,
  "33573": 2.24,
  "33574": -7.88,
  "33575": -4.29,
  "33576": -7.88,
  "33578": 2.24,
  "33579": 2.24,
  "33583": 2.24,
  "33584": 2.24,
  "33585": -3.74,
  "33586": -4.29,
  "33587": 2.24,
  "33592": 2.24,
  "33593": -11.25,
  "33594": 2.76,
  "33595": 2.24,
  "33596": 2.76,
  "33597": -4.81,
  "33598": 2.24,
  "33601": 2.24,
  "33602": 2.24,
  "33603": 2.24,
  "33604": 2.24,
  "33605": 2.24,
  "33606": 10.73,
  "33607": 2.24,
  "33608": 2.24,
  "33609": 2.76,
  "33610": 2.24,
  "33611": 2.24,
  "33612": 2.24,
  "33613": 2.24,
  "33614": 2.24,
  "33615": 2.24,
  "33616": 2.24,
  "33617": 2.24,
  "33618": 2.76,
  "33619": 2.24,
  "33621": 2.24,
  "33622": 2.24,
  "33623": 2.24,
  "33624": 2.76,
  "33625": 2.24,
  "33626": 3.83,
  "33629": 10.73,
  "33630": 2.24,
  "33631": 2.76,
  "33634": 2.24,
  "33635": -4.66,
  "33637": 2.24,
  "33646": 2.24,
  "33647": 10.73,
  "33672": 2.24,
  "33673": 2.24,
  "33674": 2.24,
  "33675": -7.36,
  "33677": 2.24,
  "33679": 2.76,
  "33680": 2.24,
  "33681": 2.24,
  "33682": 2.24,
  "33684": 2.24,
  "33685": 2.24,
  "33686": 2.24,
  "33687": 2.24,
  "33688": 2.76,
  "33689": 2.24,
  "33690": 2.76,
  "33694": 2.76,
  "33701": -4.66,
  "33702": -4.66,
  "33703": -4.66,
  "33704": -4.66,
  "33705": -4.66,
  "33706": 3.83,
  "33707": -4.66,
  "33708": -4.66,
  "33709": -5.21,
  "33710": -4.66,
  "33711": -4.66,
  "33712": -4.66,
  "33713": -4.66,
  "33714": -5.21,
  "33715": 3.83,
  "33716": -5.21,
  "33730": -3.62,
  "33731": -4.66,
  "33732": -4.66,
  "33733": -4.66,
  "33734": -4.66,
  "33736": 3.83,
  "33737": -4.66,
  "33738": -4.66,
  "33740": 3.83,
  "33741": 3.83,
  "33742": -4.66,
  "33743": -4.66,
  "33744": -4.66,
  "33747": -4.66,
  "33755": -4.14,
  "33756": -4.14,
  "33757": -4.14,
  "33758": -4.14,
  "33759": -4.14,
  "33760": -4.14,
  "33761": -4.14,
  "33762": -4.66,
  "33763": -4.14,
  "33764": -4.14,
  "33765": -4.14,
  "33766": -4.14,
  "33767": 4.35,
  "33770": -4.14,
  "33771": -4.14,
  "33772": -4.66,
  "33773": -4.14,
  "33774": -4.14,
  "33775": -4.66,
  "33776": -3.62,
  "33777": -4.66,
  "33778": -4.14,
  "33779": -4.14,
  "33780": -5.21,
  "33781": -5.21,
  "33782": -4.66,
  "33784": -5.21,
  "33785": -2.55,
  "33786": 6.65,
  "33801": -5.27,
  "33802": -5.27,
  "33803": -4.75,
  "33804": -5.27,
  "33805": -5.27,
  "33806": -4.75,
  "33807": -4.75,
  "33809": -4.75,
  "33810": -4.75,
  "33811": -4.75,
  "33812": -4.75,
  "33813": 3.74,
  "33815": -5.27,
  "33820": -5.79,
  "33823": -5.27,
  "33825": -14.07,
  "33826": -14.07,
  "33827": -5.27,
  "33830": -5.79,
  "33831": -5.79,
  "33834": -13.61,
  "33835": -5.79,
  "33836": -5.79,
  "33837": -5.27,
  "33838": -5.27,
  "33839": -5.79,
  "33840": -5.27,
  "33841": -13.61,
  "33843": -5.79,
  "33844": -5.79,
  "33845": -5.79,
  "33846": 3.74,
  "33847": -5.79,
  "33848": -9.47,
  "33849": -4.75,
  "33850": -5.27,
  "33851": -5.27,
  "33852": -10.89,
  "33853": -5.79,
  "33854": -5.79,
  "33855": -5.79,
  "33856": -5.79,
  "33857": -11.1,
  "33858": -9.47,
  "33859": -5.79,
  "33860": -5.27,
  "33862": -10.89,
  "33863": -5.79,
  "33865": -10.43,
  "33867": -5.79,
  "33868": -5.27,
  "33870": -14.07,
  "33871": -14.07,
  "33872": -13.55,
  "33873": -13.61,
  "33875": -13.55,
  "33876": -14.07,
  "33877": -5.79,
  "33880": -5.79,
  "33881": -5.79,
  "33882": 3.22,
  "33883": -5.79,
  "33884": 3.22,
  "33885": -5.79,
  "33890": -13.61,
  "33896": -5.27,
  "33897": -5.27,
  "33898": -5.79,
  "33900": -6.65,
  "33901": -6.65,
  "33902": -6.65,
  "33903": -5.06,
  "33904": -4.54,
  "33905": -6.65,
  "33906": -6.65,
  "33907": -6.65,
  "33908": -4.54,
  "33909": -5.06,
  "33910": -4.54,
  "33911": -4.54,
  "33912": -6.13,
  "33913": 1.84,
  "33914": -4.54,
  "33915": -5.06,
  "33916": -6.65,
  "33917": -6.65,
  "33918": -5.06,
  "33919": -6.65,
  "33920": -6.65,
  "33921": 4.1,
  "33922": -5.06,
  "33924": 6.25,
  "33927": -6.69,
  "33928": -6.65,
  "33929": -6.65,
  "33930": -6.65,
  "33931": 1.84,
  "33932": 1.84,
  "33935": -6.65,
  "33936": -6.65,
  "33938": -7.21,
  "33944": -12.23,
  "33945": -5.06,
  "33946": -6.69,
  "33947": -6.69,
  "33948": -7.21,
  "33949": -7.21,
  "33950": -6.69,
  "33951": -7.21,
  "33952": -7.21,
  "33953": -6.69,
  "33954": -6.69,
  "33955": -6.69,
  "33956": -5.06,
  "33957": -2.24,
  "33960": -11.71,
  "33966": -6.65,
  "33967": -6.65,
  "33970": -6.65,
  "33971": -6.65,
  "33972": -6.65,
  "33973": -6.65,
  "33974": -6.65,
  "33975": -6.19,
  "33976": -6.65,
  "33980": -7.21,
  "33981": -7.21,
  "33982": -7.21,
  "33983": -6.69,
  "33990": -5.06,
  "33991": -4.54,
  "33993": -5.06,
  "33994": -6.65,
  "34101": 8.7,
  "34102": 8.7,
  "34103": -0.5,
  "34104": -2.09,
  "34105": -2.09,
  "34106": 8.7,
  "34107": -2.09,
  "34108": -2.09,
  "34109": -2.09,
  "34110": -2.09,
  "34112": -2.09,
  "34113": -2.09,
  "34114": -2.61,
  "34116": -2.09,
  "34117": -2.09,
  "34119": -2.09,
  "34120": -2.09,
  "34133": -2.09,
  "34134": -2.09,
  "34135": -2.09,
  "34136": -2.09,
  "34137": -2.09,
  "34138": -2.09,
  "34139": -2.09,
  "34140": -2.09,
  "34141": -2.09,
  "34142": -2.61,
  "34143": -2.61,
  "34145": -2.09,
  "34146": -2.09,
  "34201": 7.57,
  "34202": -3.22,
  "34203": -3.74,
  "34204": -3.74,
  "34205": -3.74,
  "34206": -3.74,
  "34207": -4.29,
  "34208": -3.74,
  "34209": -3.74,
  "34210": -3.74,
  "34211": -3.22,
  "34212": -3.22,
  "34215": -3.74,
  "34216": -3.22,
  "34217": -3.74,
  "34218": -3.74,
  "34219": -3.74,
  "34220": -3.74,
  "34221": -3.74,
  "34222": -4.29,
  "34223": -1.69,
  "34224": -7.21,
  "34228": 7.05,
  "34229": -2.76,
  "34230": -3.22,
  "34231": -2.76,
  "34232": -3.28,
  "34233": -2.76,
  "34234": -3.74,
  "34235": -3.22,
  "34236": -3.22,
  "34237": -3.74,
  "34238": -2.76,
  "34239": -3.22,
  "34240": -2.76,
  "34241": -2.76,
  "34242": 8.03,
  "34243": -3.22,
  "34250": -3.74,
  "34251": -2.76,
  "34260": -3.22,
  "34264": -3.74,
  "34265": -9.97,
  "34266": -9.97,
  "34267": -9.97,
  "34268": -9.97,
  "34269": -9.97,
  "34270": -3.22,
  "34272": -2.76,
  "34274": -2.76,
  "34275": -2.76,
  "34276": -3.22,
  "34277": -2.76,
  "34278": -3.22,
  "34280": -3.74,
  "34281": -3.74,
  "34282": -4.29,
  "34284": -3.28,
  "34285": -2.76,
  "34286": -6.69,
  "34287": -6.69,
  "34288": -6.69,
  "34289": -6.69,
  "34290": -7.21,
  "34291": -7.21,
  "34292": -3.28,
  "34293": -3.28,
  "34295": -7.21,
  "34420": -9.87,
  "34421": -9.87,
  "34423": -11.65,
  "34428": -12.17,
  "34429": -11.65,
  "34430": -10.58,
  "34431": -12.17,
  "34432": -10.58,
  "34433": -12.17,
  "34434": -12.17,
  "34436": -4.81,
  "34442": -12.17,
  "34445": -12.17,
  "34446": -11.65,
  "34447": -12.17,
  "34448": -12.17,
  "34449": -13.55,
  "34450": -12.17,
  "34451": -12.17,
  "34452": -12.17,
  "34453": -12.17,
  "34460": -12.17,
  "34461": -10.58,
  "34464": -12.17,
  "34465": -12.17,
  "34470": -9.87,
  "34471": -1.38,
  "34472": -9.87,
  "34473": -9.87,
  "34474": -9.87,
  "34475": -9.87,
  "34476": -8.28,
  "34477": -9.87,
  "34478": -9.87,
  "34479": -9.87,
  "34480": -9.35,
  "34481": -9.87,
  "34482": -9.87,
  "34483": -9.87,
  "34484": -4.29,
  "34487": -12.17,
  "34488": -10.39,
  "34489": -10.39,
  "34491": -9.87,
  "34492": -9.87,
  "34498": -11.65,
  "34601": -10.18,
  "34602": -10.73,
  "34603": -10.18,
  "34604": -10.18,
  "34605": -10.18,
  "34606": -10.18,
  "34607": -9.66,
  "34608": -10.18,
  "34609": -10.18,
  "34610": -7.88,
  "34611": -10.18,
  "34613": -10.18,
  "34614": -11.25,
  "34636": -5.33,
  "34637": -7.36,
  "34638": -7.36,
  "34639": -7.36,
  "34652": -7.36,
  "34653": -7.36,
  "34654": -7.36,
  "34655": -7.36,
  "34656": -7.36,
  "34660": -3.62,
  "34661": -5.33,
  "34667": -7.36,
  "34668": -7.36,
  "34669": -7.36,
  "34673": -7.36,
  "34674": -7.36,
  "34677": -4.14,
  "34679": -10.18,
  "34680": -7.36,
  "34681": 4.35,
  "34682": -3.62,
  "34683": -3.62,
  "34684": -4.14,
  "34685": 4.35,
  "34688": 4.35,
  "34689": -7.36,
  "34690": -7.36,
  "34691": -7.36,
  "34692": -7.36,
  "34695": -4.14,
  "34697": -4.14,
  "34698": -4.14,
  "34705": 1.78,
  "34711": 2.3,
  "34712": 2.3,
  "34713": 2.3,
  "34714": 2.3,
  "34715": 2.3,
  "34729": 2.3,
  "34731": 0.71,
  "34734": 0.92,
  "34736": 2.3,
  "34737": 2.3,
  "34739": -8.43,
  "34740": 0.92,
  "34741": -7.88,
  "34742": -7.36,
  "34743": -7.36,
  "34744": -7.36,
  "34745": -7.88,
  "34746": -7.36,
  "34747": 1.13,
  "34748": 0.71,
  "34749": 0.71,
  "34753": 1.78,
  "34755": 2.3,
  "34756": 2.3,
  "34758": -7.88,
  "34759": -7.88,
  "34760": 0.92,
  "34761": 0.92,
  "34762": -4.81,
  "34769": -7.36,
  "34770": -7.36,
  "34771": -7.36,
  "34772": -7.36,
  "34773": -3.37,
  "34777": 0.92,
  "34778": 0.92,
  "34785": -4.81,
  "34786": 11.71,
  "34787": 0.92,
  "34788": 0.71,
  "34789": 0.71,
  "34797": 2.3,
  "34945": -10.85,
  "34946": -11.4,
  "34947": -10.85,
  "34948": -11.4,
  "34949": -10.85,
  "34950": -11.4,
  "34951": -10.39,
  "34952": -9.26,
  "34953": -9.26,
  "34954": -11.4,
  "34956": -6.04,
  "34957": -6.04,
  "34958": -5.52,
  "34972": -11.1,
  "34973": -11.1,
  "34974": -11.1,
  "34979": -11.4,
  "34981": -10.85,
  "34982": -10.85,
  "34983": -9.26,
  "34984": -9.26,
  "34985": -9.26,
  "34986": -7.67,
  "34987": -8.74,
  "34988": -8.74,
  "34990": 2.45,
  "34991": -6.04,
  "34992": -6.04,
  "34994": -6.04,
  "34995": -6.04,
  "34996": -5.52,
  "34997": -6.04,
  "35004": -6.19,
  "35005": 8.07,
  "35006": -3.22,
  "35007": 1.17,
  "35010": -10.52,
  "35011": -10.52,
  "35013": -5.33,
  "35014": -7.17,
  "35015": 8.07,
  "35016": -3.68,
  "35019": -5.06,
  "35020": 7.55,
  "35021": 7.55,
  "35022": 8.07,
  "35023": 8.07,
  "35031": -5.33,
  "35032": -7.17,
  "35033": -6.71,
  "35034": 5.06,
  "35035": 3.47,
  "35036": 7.55,
  "35038": -6.71,
  "35040": 1.17,
  "35041": 7.55,
  "35042": 5.06,
  "35043": 9.66,
  "35044": -7.17,
  "35045": 11.44,
  "35046": 11.44,
  "35048": 8.07,
  "35049": -4.81,
  "35051": 1.17,
  "35052": -6.71,
  "35053": -5.06,
  "35054": -6.19,
  "35055": -5.06,
  "35056": -5.06,
  "35057": -5.06,
  "35058": -5.06,
  "35060": 7.55,
  "35061": 7.55,
  "35062": -6.71,
  "35063": -6.71,
  "35064": 7.55,
  "35068": 8.07,
  "35070": -7.17,
  "35071": 8.07,
  "35072": -14.53,
  "35073": 7.55,
  "35074": 6.65,
  "35077": -7.17,
  "35078": -7.17,
  "35079": -5.33,
  "35080": 1.17,
  "35082": -5.52,
  "35083": -5.06,
  "35085": 9.85,
  "35087": -4.2,
  "35089": -10.52,
  "35091": 8.07,
  "35094": 8.07,
  "35096": -6.71,
  "35097": -4.81,
  "35098": -5.58,
  "35111": 3.47,
  "35112": -6.71,
  "35114": 1.17,
  "35115": 1.17,
  "35116": 8.07,
  "35117": 8.07,
  "35118": 7.55,
  "35119": 7.55,
  "35120": -6.71,
  "35121": -5.33,
  "35123": 8.07,
  "35124": 1.17,
  "35125": 2.3,
  "35126": 8.07,
  "35127": 8.07,
  "35128": -6.19,
  "35130": -6.71,
  "35131": -6.71,
  "35133": -4.81,
  "35135": 2.3,
  "35136": -12.94,
  "35137": 1.17,
  "35139": 7.55,
  "35142": 9.66,
  "35143": 1.17,
  "35144": 1.17,
  "35146": -6.19,
  "35147": 1.17,
  "35148": -6.71,
  "35149": -7.17,
  "35150": -7.17,
  "35151": -7.17,
  "35160": -7.17,
  "35161": -7.17,
  "35171": 9.85,
  "35172": -5.33,
  "35173": -6.19,
  "35175": -3.68,
  "35176": -6.71,
  "35178": -7.17,
  "35179": -5.06,
  "35180": -4.81,
  "35181": 7.55,
  "35182": -6.19,
  "35183": -14.53,
  "35184": 6.65,
  "35185": 1.17,
  "35186": 1.17,
  "35187": 1.17,
  "35188": 5.06,
  "35201": 8.07,
  "35202": 8.07,
  "35203": 8.07,
  "35204": 7.55,
  "35205": 8.07,
  "35206": 7.55,
  "35207": 7.55,
  "35208": 7.55,
  "35209": 9.66,
  "35210": 8.07,
  "35211": 7.55,
  "35212": 7.55,
  "35213": 16.56,
  "35214": 8.07,
  "35215": 8.07,
  "35216": 16.56,
  "35217": 7.55,
  "35218": 7.55,
  "35219": 9.66,
  "35220": 7.55,
  "35221": 7.55,
  "35222": 8.07,
  "35223": 18.86,
  "35224": 7.55,
  "35226": 9.66,
  "35228": 7.55,
  "35231": 8.07,
  "35232": 7.55,
  "35233": 8.07,
  "35234": 7.55,
  "35235": 8.07,
  "35236": 9.66,
  "35237": 8.07,
  "35238": 8.07,
  "35242": 9.66,
  "35243": 16.56,
  "35244": 9.66,
  "35253": 18.86,
  "35255": 8.07,
  "35259": 8.07,
  "35260": 9.66,
  "35261": 7.55,
  "35266": 9.66,
  "35283": 8.07,
  "35401": -3.22,
  "35402": -3.22,
  "35403": -3.22,
  "35404": -3.22,
  "35405": 5.27,
  "35406": 5.27,
  "35407": 5.27,
  "35440": 3.47,
  "35441": -5.98,
  "35442": -3.22,
  "35443": 5.46,
  "35444": 3.47,
  "35446": -3.22,
  "35447": -3.22,
  "35448": 5.98,
  "35449": -1.63,
  "35452": 5.27,
  "35453": -1.63,
  "35456": -3.22,
  "35457": -3.22,
  "35458": -3.22,
  "35459": -5.98,
  "35460": -6.5,
  "35461": -3.22,
  "35462": 5.98,
  "35463": -3.22,
  "35464": 5.46,
  "35466": -3.22,
  "35468": 5.06,
  "35469": 5.46,
  "35470": -5.98,
  "35471": -3.22,
  "35473": -3.22,
  "35474": -5.98,
  "35475": 5.27,
  "35476": 5.27,
  "35477": 5.46,
  "35478": -3.22,
  "35480": 5.46,
  "35481": -3.22,
  "35482": 5.27,
  "35485": -3.22,
  "35486": -3.22,
  "35490": 3.47,
  "35491": 5.98,
  "35501": -6.71,
  "35502": -6.71,
  "35503": -6.71,
  "35504": -6.19,
  "35540": -10.18,
  "35541": -10.18,
  "35542": -11.96,
  "35543": -16.71,
  "35544": -15.64,
  "35545": -11.96,
  "35546": 5.27,
  "35548": -17.23,
  "35549": -4.6,
  "35550": -6.71,
  "35551": -10.73,
  "35552": -16.71,
  "35553": -10.18,
  "35554": -11.96,
  "35555": -11.96,
  "35559": -11.96,
  "35560": -6.71,
  "35563": -15.64,
  "35564": -16.71,
  "35565": -10.73,
  "35570": -16.71,
  "35571": -13.03,
  "35572": -10.18,
  "35573": -4.6,
  "35574": -11.96,
  "35575": -10.18,
  "35576": -15.64,
  "35577": -10.18,
  "35578": -11.77,
  "35579": -4.6,
  "35580": -6.71,
  "35581": -13.03,
  "35582": -13.03,
  "35584": -6.71,
  "35585": -13.03,
  "35586": -15.64,
  "35587": -6.71,
  "35592": -15.64,
  "35593": -13.03,
  "35594": -11.96,
  "35601": -0.06,
  "35602": 0.46,
  "35603": 0.46,
  "35609": -0.06,
  "35610": -1.9,
  "35611": -1.9,
  "35612": -1.9,
  "35613": -1.38,
  "35614": -1.9,
  "35615": 9.87,
  "35616": -5.21,
  "35617": 9.72,
  "35618": 0.4,
  "35619": -0.06,
  "35620": -1.9,
  "35621": -5.58,
  "35622": -0.06,
  "35630": 1.23,
  "35631": 1.23,
  "35633": 1.23,
  "35634": 1.23,
  "35640": 0.46,
  "35643": 0.4,
  "35645": 9.72,
  "35646": -5.21,
  "35647": -1.9,
  "35648": 1.23,
  "35649": 9.87,
  "35650": 0.4,
  "35651": -0.15,
  "35652": 9.72,
  "35653": -13.03,
  "35654": -13.03,
  "35660": -5.21,
  "35661": 3.28,
  "35662": -5.21,
  "35670": -0.06,
  "35671": -1.9,
  "35672": -0.15,
  "35673": 0.92,
  "35674": -5.21,
  "35677": -5.21,
  "35739": -1.38,
  "35740": 21.47,
  "35741": 9.87,
  "35742": 1.38,
  "35744": -9.26,
  "35745": -9.26,
  "35746": -9.26,
  "35747": -3.68,
  "35748": 1.38,
  "35749": 1.38,
  "35750": 1.38,
  "35751": 0.86,
  "35752": -9.26,
  "35754": 1.38,
  "35755": -3.68,
  "35756": 0.46,
  "35757": 1.38,
  "35758": 9.87,
  "35759": 1.38,
  "35760": -3.68,
  "35761": 1.38,
  "35762": 1.38,
  "35763": 9.87,
  "35764": 0.86,
  "35765": -9.81,
  "35766": -9.26,
  "35767": 1.38,
  "35768": -9.26,
  "35769": -8.74,
  "35771": 2.7,
  "35772": -9.81,
  "35773": 1.38,
  "35774": -9.26,
  "35775": -0.06,
  "35776": -3.68,
  "35801": 9.87,
  "35802": 9.87,
  "35803": 1.38,
  "35804": 9.87,
  "35805": 0.86,
  "35806": 9.87,
  "35807": 0.86,
  "35808": 0.86,
  "35809": 9.87,
  "35810": 1.38,
  "35811": 1.38,
  "35812": 1.38,
  "35813": 9.87,
  "35814": 0.86,
  "35815": 9.87,
  "35816": 1.38,
  "35824": 9.87,
  "35901": -6.8,
  "35902": -6.8,
  "35903": -6.8,
  "35904": -6.8,
  "35905": -6.25,
  "35906": 2.24,
  "35907": -6.25,
  "35950": -5.79,
  "35951": -5.79,
  "35952": -5.88,
  "35953": -6.71,
  "35954": -6.8,
  "35956": -6.25,
  "35957": -5.79,
  "35958": 21.47,
  "35959": -3.49,
  "35960": -3.49,
  "35961": 0.56,
  "35962": -5.79,
  "35963": 1.11,
  "35964": -5.79,
  "35966": -9.81,
  "35967": 1.11,
  "35968": 1.11,
  "35971": 0.56,
  "35972": -6.25,
  "35973": -4.04,
  "35974": 1.11,
  "35975": -6.34,
  "35976": -4.2,
  "35978": 2.15,
  "35979": 21.47,
  "35980": -5.79,
  "35981": -9.81,
  "35983": -4.04,
  "35984": 2.7,
  "35986": 1.11,
  "35987": -6.25,
  "35988": 0.56,
  "35989": 1.11,
  "35990": -5.88,
  "36003": -5.67,
  "36005": -10.64,
  "36006": -5.12,
  "36008": -5.12,
  "36009": -1.44,
  "36010": -11.19,
  "36013": 1.32,
  "36015": -7.51,
  "36016": -5.67,
  "36017": -5.67,
  "36020": -5.58,
  "36022": -5.12,
  "36023": 14.2,
  "36024": -5.58,
  "36025": -5.58,
  "36026": -3.07,
  "36027": -5.12,
  "36028": -8.89,
  "36029": 14.2,
  "36030": -6.96,
  "36031": 14.72,
  "36032": -12.94,
  "36033": -7.51,
  "36034": -1.99,
  "36035": -1.44,
  "36036": -10.64,
  "36037": -6.96,
  "36038": -8.89,
  "36039": 13.65,
  "36040": -12.94,
  "36041": -1.44,
  "36042": -1.99,
  "36043": 1.32,
  "36045": 14.2,
  "36046": -12.94,
  "36047": -13.49,
  "36048": -5.67,
  "36049": -1.44,
  "36051": -5.12,
  "36052": 1.32,
  "36053": -4.6,
  "36054": -5.12,
  "36057": 9.81,
  "36061": -10.64,
  "36062": -1.44,
  "36064": 9.81,
  "36065": -10.64,
  "36066": -3.53,
  "36067": -5.12,
  "36068": -3.53,
  "36069": -12.94,
  "36071": -1.44,
  "36072": -5.12,
  "36075": 14.2,
  "36078": 14.2,
  "36079": -10.64,
  "36080": -3.99,
  "36081": -10.64,
  "36083": 15.24,
  "36087": 15.24,
  "36088": 15.24,
  "36089": 15.24,
  "36091": -5.12,
  "36092": 2.91,
  "36093": -5.58,
  "36101": 1.32,
  "36102": 1.32,
  "36103": 1.32,
  "36104": 1.32,
  "36105": 1.32,
  "36106": 9.81,
  "36107": 1.32,
  "36108": 1.32,
  "36109": 1.32,
  "36110": 1.32,
  "36111": 9.81,
  "36112": 1.32,
  "36113": 1.32,
  "36114": 1.32,
  "36115": 1.32,
  "36116": 1.32,
  "36117": 9.81,
  "36119": 1.32,
  "36120": 1.32,
  "36121": 9.81,
  "36123": 1.32,
  "36124": 9.81,
  "36125": 1.32,
  "36201": -2.11,
  "36202": -2.11,
  "36203": -1.59,
  "36204": -2.11,
  "36205": -2.11,
  "36206": -2.11,
  "36207": -1.59,
  "36210": -1.59,
  "36250": -1.59,
  "36251": -12.23,
  "36253": -2.11,
  "36254": -1.59,
  "36255": -11.71,
  "36256": -12.63,
  "36257": -1.59,
  "36258": -12.23,
  "36260": -2.11,
  "36261": 3.87,
  "36262": 3.87,
  "36263": 3.87,
  "36264": 3.87,
  "36265": -1.59,
  "36266": -12.23,
  "36267": -10.12,
  "36268": -7.17,
  "36269": 3.87,
  "36271": -2.11,
  "36272": -4.04,
  "36273": 4.39,
  "36274": -11.65,
  "36275": -4.04,
  "36276": -12.17,
  "36277": -1.59,
  "36278": -12.17,
  "36279": -2.11,
  "36280": -12.69,
  "36301": -3.28,
  "36302": 5.21,
  "36303": 5.21,
  "36304": 5.21,
  "36305": 5.21,
  "36310": -4.66,
  "36311": -6.59,
  "36312": -3.28,
  "36313": -14.87,
  "36314": -14.32,
  "36316": -14.32,
  "36317": -6.04,
  "36318": -14.32,
  "36319": -4.66,
  "36320": -3.28,
  "36321": -3.28,
  "36322": -6.04,
  "36323": -10.64,
  "36330": -2.15,
  "36331": -2.15,
  "36340": -14.87,
  "36343": -3.83,
  "36344": -14.87,
  "36345": -3.07,
  "36346": -11.19,
  "36349": -3.28,
  "36350": -6.04,
  "36351": -10.64,
  "36352": -6.04,
  "36353": -4.66,
  "36360": -6.04,
  "36361": -6.04,
  "36362": 2.45,
  "36370": -3.28,
  "36371": -6.04,
  "36373": -4.66,
  "36374": -6.04,
  "36375": -3.28,
  "36376": -3.28,
  "36401": -15.24,
  "36420": -8.89,
  "36421": -8.89,
  "36425": -6.59,
  "36426": -15.24,
  "36427": -15.24,
  "36429": -15.24,
  "36432": -15.24,
  "36435": -10.27,
  "36436": -6.13,
  "36439": -6.59,
  "36441": -2.36,
  "36442": -8.89,
  "36444": -6.59,
  "36445": -6.59,
  "36446": -6.13,
  "36449": -6.59,
  "36451": -6.13,
  "36453": -8.34,
  "36454": -15.24,
  "36455": -8.89,
  "36456": -7.51,
  "36457": -6.59,
  "36458": -6.59,
  "36460": -6.04,
  "36461": -6.04,
  "36467": -8.34,
  "36470": -6.04,
  "36471": -6.59,
  "36473": -15.24,
  "36474": -8.89,
  "36475": -6.04,
  "36476": -8.89,
  "36477": -14.32,
  "36480": -6.59,
  "36481": -10.27,
  "36482": -6.13,
  "36483": -8.89,
  "36501": -6.13,
  "36502": -2.91,
  "36503": -2.91,
  "36504": -2.91,
  "36505": 1.32,
  "36507": -0.52,
  "36509": -0.27,
  "36511": -0.52,
  "36512": -0.61,
  "36513": 1.32,
  "36515": -0.61,
  "36518": -0.61,
  "36521": 1.32,
  "36522": -0.61,
  "36523": 0.77,
  "36524": -6.13,
  "36525": 1.32,
  "36526": -0.52,
  "36527": -0.52,
  "36528": 6.9,
  "36529": -0.61,
  "36530": 0,
  "36532": -0.52,
  "36533": -0.52,
  "36535": 0,
  "36536": 0,
  "36538": -6.13,
  "36539": -0.61,
  "36540": -6.59,
  "36541": -3.89,
  "36542": 8.49,
  "36543": -2.91,
  "36544": 0.77,
  "36545": -6.13,
  "36547": 8.49,
  "36548": -6.13,
  "36549": -4.6,
  "36550": -0.61,
  "36551": -0.52,
  "36553": -0.61,
  "36555": 0,
  "36556": -0.61,
  "36558": -8.09,
  "36559": 9.72,
  "36560": -0.61,
  "36561": 3.89,
  "36562": -2.91,
  "36564": 9.72,
  "36567": 0,
  "36568": -3.89,
  "36569": -0.61,
  "36571": 1.32,
  "36572": 1.32,
  "36574": -4.6,
  "36575": 1.32,
  "36576": -0.52,
  "36577": -0.52,
  "36578": -0.52,
  "36579": -0.61,
  "36580": -0.52,
  "36581": -0.61,
  "36582": 1.32,
  "36583": -0.61,
  "36584": -0.61,
  "36585": -0.61,
  "36587": 1.32,
  "36590": 1.32,
  "36601": 1.32,
  "36602": 1.32,
  "36603": 0.77,
  "36604": 1.32,
  "36605": 0.77,
  "36606": 1.32,
  "36607": 0.77,
  "36608": 1.32,
  "36609": 1.32,
  "36610": 0.77,
  "36611": 1.32,
  "36612": 0.77,
  "36613": 0.77,
  "36615": 0.77,
  "36616": 1.32,
  "36617": 0.77,
  "36618": 1.32,
  "36619": 1.32,
  "36633": 1.32,
  "36640": 1.32,
  "36641": 1.32,
  "36652": 1.32,
  "36660": 1.32,
  "36663": 0.77,
  "36670": 0.77,
  "36671": 0.77,
  "36685": 1.32,
  "36689": 1.32,
  "36691": 1.32,
  "36693": 1.32,
  "36695": 1.32,
  "36701": 1.32,
  "36702": 1.32,
  "36703": 0.77,
  "36720": -9.72,
  "36721": -9.72,
  "36722": -9.72,
  "36723": -9.72,
  "36726": -9.72,
  "36727": -6.13,
  "36728": -10.27,
  "36732": -2.3,
  "36736": -2.3,
  "36738": -2.82,
  "36740": -5.98,
  "36741": -13.49,
  "36742": -2.3,
  "36744": -5.98,
  "36745": -2.3,
  "36748": -2.3,
  "36749": 1.32,
  "36750": 11.44,
  "36751": -10.27,
  "36752": -12.94,
  "36753": -6.59,
  "36754": -2.82,
  "36756": -6.9,
  "36758": 10.89,
  "36759": 1.84,
  "36761": -13.49,
  "36762": -6.13,
  "36763": -2.3,
  "36764": -2.82,
  "36765": -6.9,
  "36766": -7.51,
  "36767": 1.32,
  "36768": -7.51,
  "36769": -10.27,
  "36773": 1.32,
  "36775": 1.32,
  "36776": -5.98,
  "36782": -2.82,
  "36783": -2.3,
  "36784": -5.06,
  "36785": -12.94,
  "36786": -7.42,
  "36790": 11.44,
  "36792": 9.85,
  "36793": 5.06,
  "36801": -1.53,
  "36802": -1.53,
  "36803": -1.53,
  "36804": -1.53,
  "36830": 8.55,
  "36831": 8.55,
  "36832": 8.55,
  "36850": -11.04,
  "36851": -5.67,
  "36852": -2.05,
  "36853": -10.52,
  "36854": -7.97,
  "36855": -7.97,
  "36856": -5.12,
  "36858": -4.08,
  "36859": -5.67,
  "36860": -4.6,
  "36861": -10.52,
  "36862": -7.97,
  "36863": -7.97,
  "36865": -0.46,
  "36866": 15.24,
  "36867": -3.28,
  "36868": -5.12,
  "36869": -5.12,
  "36870": -3.28,
  "36871": -5.67,
  "36872": -7.97,
  "36874": -1.53,
  "36875": -5.12,
  "36877": -3.28,
  "36879": 0.06,
  "36901": -6.5,
  "36904": -2.97,
  "36907": -6.5,
  "36908": -7.57,
  "36910": -2.3,
  "36912": -5.98,
  "36913": -3.49,
  "36915": -3.49,
  "36916": -2.82,
  "36919": -8.09,
  "36921": -3.49,
  "36922": -6.5,
  "36925": -5.98,
  "37010": 7.05,
  "37011": 10.64,
  "37012": -13.28,
  "37013": 10.64,
  "37014": 11.77,
  "37015": 1.9,
  "37016": -14.2,
  "37018": -2.7,
  "37019": -5.46,
  "37020": 3.28,
  "37022": -11.9,
  "37023": 5,
  "37024": 18.67,
  "37025": -2.24,
  "37026": -14.2,
  "37027": 18.67,
  "37028": -17.63,
  "37029": 3.28,
  "37030": -5,
  "37031": -11.9,
  "37032": 7.05,
  "37033": -7.97,
  "37034": 3.28,
  "37035": 0.86,
  "37036": 2.24,
  "37037": 3.83,
  "37040": 5,
  "37041": 5,
  "37042": 5,
  "37043": 5,
  "37046": 18.67,
  "37047": -5.46,
  "37048": 6.5,
  "37049": -0.4,
  "37050": 4.45,
  "37051": 2.24,
  "37052": 5,
  "37055": 2.24,
  "37056": 2.24,
  "37057": -11.9,
  "37058": -12.48,
  "37059": -13.28,
  "37060": 3.83,
  "37061": 11.81,
  "37062": 10.18,
  "37063": 3.83,
  "37064": 11.77,
  "37065": 11.77,
  "37066": 6.5,
  "37067": 18.67,
  "37068": 18.67,
  "37069": 18.67,
  "37070": -0.4,
  "37071": 7.88,
  "37072": -0.4,
  "37073": -0.4,
  "37074": -12.42,
  "37075": 6.5,
  "37076": 10.64,
  "37077": 6.5,
  "37078": 12.36,
  "37079": 5,
  "37080": 1.9,
  "37082": 1.9,
  "37083": -12.42,
  "37085": 3.83,
  "37086": 3.28,
  "37087": 7.88,
  "37088": 7.88,
  "37090": 8.43,
  "37091": -5.46,
  "37095": -13.28,
  "37096": -7.97,
  "37097": -7.97,
  "37098": -2.76,
  "37101": 12.36,
  "37110": -7.3,
  "37111": -7.3,
  "37115": 10.64,
  "37116": 10.64,
  "37118": -5.71,
  "37119": 6.5,
  "37121": 7.88,
  "37122": 7.88,
  "37127": 3.83,
  "37128": 3.83,
  "37129": 3.83,
  "37130": 3.28,
  "37133": 3.28,
  "37134": -10.73,
  "37135": 10.18,
  "37136": 7.88,
  "37137": -2.76,
  "37138": 10.64,
  "37140": -3.28,
  "37141": -0.4,
  "37142": 4.45,
  "37143": 1.9,
  "37144": 3.74,
  "37145": -5,
  "37146": 9.35,
  "37148": 6.5,
  "37149": -14.2,
  "37150": -11.9,
  "37151": -5,
  "37152": -0.4,
  "37153": 3.83,
  "37160": 3.28,
  "37162": 3.28,
  "37165": 2.24,
  "37166": -13.28,
  "37167": 3.83,
  "37171": 5,
  "37172": -0.4,
  "37174": -0.19,
  "37175": 11.81,
  "37178": 11.81,
  "37179": 10.18,
  "37180": 3.28,
  "37181": 2.24,
  "37183": 3.28,
  "37184": 7.88,
  "37185": 12.36,
  "37186": -12.42,
  "37187": 3.28,
  "37188": 6.5,
  "37189": 10.64,
  "37190": -14.2,
  "37191": 5,
  "37201": 10.64,
  "37202": 10.64,
  "37203": 10.64,
  "37204": 12.23,
  "37205": 19.13,
  "37206": 10.64,
  "37207": 10.64,
  "37208": 10.12,
  "37209": 10.64,
  "37210": 10.64,
  "37211": 10.64,
  "37212": 12.23,
  "37213": 10.64,
  "37214": 10.64,
  "37215": 21.43,
  "37216": 10.64,
  "37217": 10.64,
  "37218": 10.64,
  "37219": 10.64,
  "37220": 19.13,
  "37221": 10.18,
  "37222": 10.64,
  "37224": 10.64,
  "37227": 10.64,
  "37228": 10.12,
  "37229": 10.64,
  "37230": 10.64,
  "37238": 10.64,
  "37244": 10.64,
  "37301": -12.11,
  "37302": 12.57,
  "37303": 1.78,
  "37304": -0.98,
  "37305": -12.11,
  "37306": -10.18,
  "37307": -10.73,
  "37308": 4.08,
  "37309": 1.78,
  "37310": 4.08,
  "37311": 4.08,
  "37312": 4.08,
  "37313": -12.11,
  "37314": -10.18,
  "37315": 7.51,
  "37316": -10.18,
  "37317": -10.18,
  "37318": -10.73,
  "37320": 4.08,
  "37321": -0.98,
  "37322": -0.98,
  "37323": 4.08,
  "37324": -10.18,
  "37325": -10.73,
  "37326": -10.73,
  "37327": -16.16,
  "37328": 3.22,
  "37329": 1.78,
  "37330": -9.14,
  "37331": 1.78,
  "37332": -1.53,
  "37333": -10.73,
  "37334": 3.22,
  "37335": 3.22,
  "37336": 4.08,
  "37337": -3.28,
  "37338": -0.98,
  "37339": -12.11,
  "37340": 21.47,
  "37341": 5.92,
  "37342": -2.7,
  "37343": 5.92,
  "37345": -9.66,
  "37347": 22.02,
  "37348": 3.22,
  "37349": -2.7,
  "37350": 16.71,
  "37351": 5.37,
  "37352": 3.74,
  "37353": 4.08,
  "37354": -10.18,
  "37355": -2.7,
  "37356": -11.56,
  "37357": -7.3,
  "37359": 3.22,
  "37360": -2.7,
  "37361": -10.18,
  "37362": -10.18,
  "37363": 7.51,
  "37364": 4.08,
  "37365": -16.71,
  "37366": -12.11,
  "37367": -10.64,
  "37369": -10.73,
  "37370": 1.78,
  "37371": 1.78,
  "37373": -0.98,
  "37374": 21.47,
  "37375": -10.18,
  "37376": -10.73,
  "37377": 14.41,
  "37378": -7.3,
  "37379": 5.92,
  "37380": 22.02,
  "37381": -0.98,
  "37382": -7.3,
  "37384": 5.92,
  "37385": -10.18,
  "37387": -12.11,
  "37388": -2.7,
  "37389": -9.14,
  "37391": -10.73,
  "37394": -7.3,
  "37396": 5.92,
  "37397": 21.47,
  "37398": -9.66,
  "37401": 5.37,
  "37402": 5.92,
  "37403": 5.37,
  "37404": 5.37,
  "37405": 5.92,
  "37406": 5.37,
  "37407": 5.37,
  "37408": 5.37,
  "37409": 5.37,
  "37410": 5.37,
  "37411": 5.92,
  "37412": 5.92,
  "37414": 5.92,
  "37415": 5.92,
  "37416": 5.92,
  "37419": 5.92,
  "37421": 7.51,
  "37422": 14.41,
  "37424": 7.51,
  "37450": 5.92,
  "37601": -6.9,
  "37602": -6.9,
  "37604": -6.9,
  "37605": -6.9,
  "37614": -6.9,
  "37615": 1.59,
  "37616": -5.52,
  "37617": 9.26,
  "37618": 0.25,
  "37620": 0.25,
  "37621": 0.25,
  "37625": 0.25,
  "37640": -6.9,
  "37641": -5.52,
  "37642": 14.78,
  "37643": -6.9,
  "37644": -6.9,
  "37645": 14.78,
  "37650": -2.76,
  "37656": 0.52,
  "37657": -3.28,
  "37658": -7.42,
  "37659": -6.9,
  "37660": 9.26,
  "37662": 9.26,
  "37663": 9.81,
  "37664": 9.26,
  "37665": 1.32,
  "37680": 5.77,
  "37681": -6.9,
  "37682": -6.9,
  "37683": 5.25,
  "37684": -6.9,
  "37686": 1.84,
  "37687": -3.28,
  "37688": 5.77,
  "37690": -6.9,
  "37691": 5.77,
  "37692": -2.76,
  "37694": -6.9,
  "37701": -4.29,
  "37705": -7.51,
  "37707": 13.19,
  "37708": -7.51,
  "37709": -7.51,
  "37710": 2.61,
  "37711": 0.98,
  "37713": -15.7,
  "37714": -11.56,
  "37715": -12.63,
  "37716": 3.16,
  "37717": 3.16,
  "37719": 3.16,
  "37721": -7.51,
  "37722": -16.25,
  "37723": -3.28,
  "37724": 13.19,
  "37725": 0.77,
  "37726": -16.62,
  "37727": -15.18,
  "37729": -11.56,
  "37730": -12.63,
  "37731": 6.84,
  "37732": -12.48,
  "37733": -17.17,
  "37737": -4.29,
  "37738": 9.26,
  "37742": -4.91,
  "37743": -5.52,
  "37744": -5.52,
  "37745": -5.52,
  "37748": -6.5,
  "37752": 13.19,
  "37753": -15.18,
  "37754": 4.91,
  "37755": -12.48,
  "37756": -13.03,
  "37757": -11.56,
  "37760": -0.15,
  "37762": -12.11,
  "37763": -6.5,
  "37764": 0.77,
  "37765": 5.83,
  "37766": -11.56,
  "37769": 3.16,
  "37770": -3.28,
  "37771": -4.91,
  "37772": -4.91,
  "37773": 13.19,
  "37774": -4.91,
  "37777": -3.74,
  "37778": -7.51,
  "37779": -7.51,
  "37801": -4.29,
  "37802": -4.29,
  "37803": -4.29,
  "37804": -4.29,
  "37806": -7.51,
  "37807": 6.5,
  "37809": -6.04,
  "37810": -6.96,
  "37811": -6.96,
  "37813": -7.51,
  "37814": -7.51,
  "37815": -7.51,
  "37816": -7.51,
  "37818": -6.04,
  "37819": -12.11,
  "37820": -0.15,
  "37821": -16.25,
  "37822": -16.25,
  "37824": 13.19,
  "37825": 13.19,
  "37826": 1.78,
  "37828": 11.65,
  "37829": -3.28,
  "37830": 3.16,
  "37831": 3.16,
  "37840": 3.16,
  "37841": -12.48,
  "37843": -15.18,
  "37845": 11.65,
  "37846": -6.5,
  "37847": -12.11,
  "37848": -7.51,
  "37849": 4.91,
  "37851": -12.63,
  "37852": -12.48,
  "37853": -4.29,
  "37854": -3.28,
  "37857": 14.78,
  "37860": 0.98,
  "37861": -0.15,
  "37862": 0.77,
  "37863": 2.36,
  "37864": 2.36,
  "37865": 0.77,
  "37866": -7.51,
  "37867": 13.19,
  "37868": 2.36,
  "37869": 6.38,
  "37870": 13.19,
  "37871": 4.91,
  "37872": -12.48,
  "37873": 7.88,
  "37874": -10.18,
  "37876": 0.77,
  "37877": -7.51,
  "37878": -4.29,
  "37879": 13.19,
  "37880": -15.7,
  "37881": 5.83,
  "37882": -2.7,
  "37885": -10.18,
  "37886": -4.29,
  "37887": 3.16,
  "37888": -0.15,
  "37890": -7.51,
  "37891": 0.98,
  "37892": -12.48,
  "37901": 4.91,
  "37902": 13.4,
  "37909": 5.46,
  "37912": 4.91,
  "37914": 4.91,
  "37915": 4.91,
  "37916": 4.91,
  "37917": 4.91,
  "37918": 4.91,
  "37919": 13.4,
  "37920": 4.91,
  "37921": 4.91,
  "37922": 13.95,
  "37923": 13.4,
  "37924": 4.91,
  "37927": 4.91,
  "37928": 4.91,
  "37929": 13.4,
  "37930": 13.4,
  "37931": 7.05,
  "37932": 13.95,
  "37933": 13.95,
  "37934": 13.95,
  "37938": 6.5,
  "37939": 13.4,
  "37940": 4.91,
  "37950": 5.46,
  "38001": -13.4,
  "38002": 10.64,
  "38004": 9.05,
  "38006": -13.4,
  "38007": -2.91,
  "38008": -8.8,
  "38010": 22.6,
  "38011": 9.05,
  "38012": 0.4,
  "38014": 10.64,
  "38015": 9.05,
  "38016": 17.08,
  "38017": 17.08,
  "38018": 17.08,
  "38019": 9.05,
  "38021": -13.95,
  "38023": 9.05,
  "38024": -2.36,
  "38025": -2.36,
  "38027": 17.08,
  "38028": 22.6,
  "38029": 8.59,
  "38030": -5.58,
  "38034": -13.95,
  "38036": 9.05,
  "38037": -6.13,
  "38039": -9.35,
  "38040": -6.13,
  "38041": -6.65,
  "38042": -9.35,
  "38044": -9.35,
  "38045": 22.6,
  "38046": 14.11,
  "38047": -2.36,
  "38048": 22.6,
  "38049": 9.05,
  "38050": -13.95,
  "38052": -8.8,
  "38053": 9.05,
  "38054": 9.05,
  "38057": 14.11,
  "38058": 9.05,
  "38059": -2.36,
  "38060": 14.11,
  "38061": -11.65,
  "38063": -5.58,
  "38066": 14.11,
  "38067": -8.8,
  "38068": 22.6,
  "38069": -0.15,
  "38070": -2.36,
  "38071": 9.05,
  "38075": -9.35,
  "38076": 22.6,
  "38077": -2.91,
  "38079": -1.53,
  "38080": -2.91,
  "38083": 9.05,
  "38088": 17.08,
  "38101": 8.07,
  "38103": 17.08,
  "38104": 8.59,
  "38105": 8.07,
  "38106": 8.07,
  "38107": 8.59,
  "38108": 8.07,
  "38109": 8.59,
  "38111": 8.59,
  "38112": 8.59,
  "38113": 8.59,
  "38114": 8.07,
  "38115": 8.59,
  "38116": 8.59,
  "38117": 8.59,
  "38118": 8.59,
  "38119": 10.18,
  "38120": 17.08,
  "38122": 8.59,
  "38124": 8.59,
  "38125": 8.59,
  "38126": 8.07,
  "38127": 8.59,
  "38128": 8.59,
  "38130": 8.59,
  "38131": 8.59,
  "38132": 8.07,
  "38133": 8.59,
  "38134": 8.59,
  "38135": 8.59,
  "38137": 17.08,
  "38138": 8.59,
  "38139": 17.08,
  "38141": 8.59,
  "38157": 17.08,
  "38167": 8.59,
  "38168": 8.59,
  "38173": 17.08,
  "38174": 8.59,
  "38175": 8.59,
  "38177": 8.59,
  "38181": 8.59,
  "38182": 8.59,
  "38183": 17.08,
  "38184": 8.59,
  "38186": 8.59,
  "38187": 10.18,
  "38190": 8.59,
  "38201": -6.04,
  "38220": -5.21,
  "38221": -10.73,
  "38222": -12.48,
  "38223": -12.48,
  "38224": -12.48,
  "38225": -18.92,
  "38226": -19.47,
  "38229": -19.47,
  "38230": -19.47,
  "38231": -12.48,
  "38232": -1.53,
  "38233": -0.98,
  "38235": -6.59,
  "38236": -13.03,
  "38237": -17.88,
  "38240": -1.53,
  "38241": -18.92,
  "38242": -12.48,
  "38251": -13.55,
  "38253": -0.98,
  "38254": -1.53,
  "38255": -19.47,
  "38256": -13.03,
  "38257": -0.98,
  "38258": -6.59,
  "38259": -0.98,
  "38260": -0.98,
  "38261": -0.98,
  "38271": -0.98,
  "38281": -0.98,
  "38301": 12.82,
  "38302": 12.82,
  "38303": 12.82,
  "38305": 20.76,
  "38308": 12.82,
  "38310": -11.56,
  "38311": -5.12,
  "38313": 12.82,
  "38314": 12.82,
  "38315": -11.65,
  "38316": -5.21,
  "38317": -10.73,
  "38318": -6.59,
  "38320": -10.18,
  "38321": -6.59,
  "38324": -6.59,
  "38326": -12.11,
  "38327": -12.11,
  "38328": -5.12,
  "38329": -5.67,
  "38330": -5.21,
  "38331": -13.95,
  "38332": -3.37,
  "38333": -10.73,
  "38334": -8.8,
  "38336": -13.4,
  "38337": -13.4,
  "38338": -4.66,
  "38339": -11.65,
  "38340": -8.8,
  "38341": -10.73,
  "38342": -10.73,
  "38343": -4.66,
  "38344": -6.04,
  "38345": -2.82,
  "38346": -5.21,
  "38347": -7.76,
  "38348": -6.59,
  "38351": -2.82,
  "38352": 20.76,
  "38355": 20.76,
  "38356": 12.82,
  "38357": -11.65,
  "38358": -4.66,
  "38359": -9.35,
  "38361": -12.11,
  "38362": 20.76,
  "38363": -5.67,
  "38365": -11.56,
  "38366": -8.8,
  "38367": -11.1,
  "38368": -3.37,
  "38369": -5.21,
  "38370": -12.11,
  "38371": -3.37,
  "38372": -12.11,
  "38374": -5.12,
  "38375": -11.65,
  "38376": -11.56,
  "38377": 12.82,
  "38378": 13.86,
  "38379": -11.65,
  "38380": -5.67,
  "38381": -8.8,
  "38382": -4.66,
  "38387": -6.04,
  "38388": -2.82,
  "38389": -5.21,
  "38390": -6.59,
  "38391": 12.27,
  "38392": -0.15,
  "38393": -11.1,
  "38401": -1.78,
  "38402": -1.78,
  "38425": -18.09,
  "38449": -8.28,
  "38450": -18.09,
  "38451": -1.23,
  "38452": -18.09,
  "38453": -8.28,
  "38454": -2.76,
  "38455": -8.28,
  "38456": -8.89,
  "38457": -8.89,
  "38459": -8.28,
  "38460": -9.35,
  "38461": -11.9,
  "38462": -13.49,
  "38463": 1.23,
  "38464": -8.34,
  "38468": -8.34,
  "38469": -8.89,
  "38471": -18.61,
  "38472": -7.76,
  "38473": -9.35,
  "38474": -1.78,
  "38475": -12.11,
  "38476": -2.24,
  "38477": -8.28,
  "38478": -8.28,
  "38481": 1.23,
  "38482": -1.78,
  "38483": -13.49,
  "38485": -18.09,
  "38486": -8.89,
  "38487": -11.9,
  "38488": 3.22,
  "38501": -5.92,
  "38502": -5.92,
  "38503": -5.92,
  "38504": -17.17,
  "38506": -5.92,
  "38541": -7.42,
  "38542": -7.97,
  "38543": -7.97,
  "38544": -5.92,
  "38545": -5.92,
  "38547": -5,
  "38548": -5,
  "38549": -7.42,
  "38550": -7.3,
  "38551": -6.38,
  "38552": -5,
  "38553": -16.62,
  "38554": -7.97,
  "38555": -3.28,
  "38556": -16.62,
  "38557": 5.21,
  "38558": -3.28,
  "38559": -12.36,
  "38560": -5,
  "38562": -5.92,
  "38563": -5,
  "38564": -5,
  "38565": -16.62,
  "38567": -5,
  "38568": -6.38,
  "38569": -11.69,
  "38570": -7.42,
  "38571": 5.21,
  "38572": 5.21,
  "38573": -7.42,
  "38574": -6.96,
  "38575": -6.38,
  "38577": -16.62,
  "38578": -3.28,
  "38579": -12.36,
  "38580": -7.42,
  "38581": -7.3,
  "38582": -13.28,
  "38583": -12.36,
  "38585": -11.19,
  "38587": -12.36,
  "38588": -5,
  "38589": -17.17,
  "38601": 9.05,
  "38602": -1.53,
  "38603": -6.19,
  "38606": -3.43,
  "38609": -2.05,
  "38610": -6.19,
  "38611": 9.05,
  "38614": -2.57,
  "38617": -2.57,
  "38618": -1.53,
  "38619": -2.05,
  "38620": -3.43,
  "38621": -3.43,
  "38622": -3.43,
  "38623": -3.43,
  "38625": -5.67,
  "38626": 10.83,
  "38627": -1.13,
  "38628": -3.95,
  "38629": -5.67,
  "38630": -2.57,
  "38631": -2.57,
  "38632": 2.61,
  "38633": -5.67,
  "38634": 9.05,
  "38635": 9.05,
  "38637": 2.61,
  "38638": -1.53,
  "38639": -2.57,
  "38641": 10.06,
  "38642": 9.05,
  "38643": -2.05,
  "38644": -2.05,
  "38645": -2.57,
  "38646": -2.05,
  "38647": 21.01,
  "38649": 9.05,
  "38650": -5.67,
  "38651": 2.61,
  "38652": -5.67,
  "38654": 2.61,
  "38655": -0.61,
  "38658": -3.43,
  "38659": 8.53,
  "38661": 9.05,
  "38663": -5.67,
  "38664": 10.31,
  "38665": 11.35,
  "38666": -3.43,
  "38668": -1.53,
  "38669": -2.57,
  "38670": -3.43,
  "38671": 2.61,
  "38672": 2.61,
  "38673": -1.13,
  "38674": -5.67,
  "38675": -0.61,
  "38676": 10.83,
  "38677": -0.61,
  "38679": 9.05,
  "38680": 10.06,
  "38683": -5.67,
  "38685": 8.53,
  "38701": -3.89,
  "38702": -4.41,
  "38703": -4.41,
  "38704": -4.41,
  "38720": -2.57,
  "38721": -23.73,
  "38722": -4.41,
  "38723": -3.89,
  "38725": -6.71,
  "38726": -7.26,
  "38730": 1.78,
  "38731": -23.73,
  "38732": -5.12,
  "38733": -7.26,
  "38736": 6.23,
  "38737": -6.71,
  "38738": -7.26,
  "38739": -2.57,
  "38740": -5.12,
  "38744": -23.73,
  "38745": -23.21,
  "38746": -6.71,
  "38748": -4.41,
  "38749": 6.23,
  "38751": 6.23,
  "38753": -15.39,
  "38754": -15.39,
  "38756": -3.89,
  "38759": -6.71,
  "38760": -4.41,
  "38761": 5.71,
  "38762": -6.71,
  "38764": -7.26,
  "38765": -23.73,
  "38767": -2.57,
  "38768": -2.57,
  "38769": -6.71,
  "38771": 5.71,
  "38772": -4.41,
  "38773": 5.71,
  "38774": -6.71,
  "38776": -3.89,
  "38778": 5.71,
  "38780": -3.89,
  "38781": -6.71,
  "38782": -4.41,
  "38801": 4.66,
  "38802": -2.24,
  "38803": -2.24,
  "38804": -2.24,
  "38820": -3.83,
  "38821": 3.53,
  "38824": -5.21,
  "38825": 3.53,
  "38826": 4.66,
  "38827": -8.43,
  "38828": -3.83,
  "38829": -5.21,
  "38833": -8.43,
  "38834": -0.15,
  "38835": -0.15,
  "38838": -8.43,
  "38839": -1.13,
  "38841": -3.83,
  "38843": -6.59,
  "38844": -9.26,
  "38846": -0.15,
  "38847": -8.43,
  "38848": 4.6,
  "38849": -3.83,
  "38850": -5.52,
  "38851": -5.52,
  "38852": -8.43,
  "38855": -6.59,
  "38856": -5.21,
  "38857": -3.83,
  "38858": 3.53,
  "38859": -5.73,
  "38860": -6.59,
  "38862": -3.83,
  "38863": -3.83,
  "38864": -1.13,
  "38865": -0.15,
  "38866": -2.24,
  "38868": -3.83,
  "38869": -3.83,
  "38870": 3.53,
  "38871": -0.61,
  "38873": -8.43,
  "38874": -0.61,
  "38875": -5.52,
  "38876": -6.59,
  "38877": -5.52,
  "38878": -1.13,
  "38879": -3.83,
  "38880": -5.21,
  "38901": -2.91,
  "38902": -2.91,
  "38913": -1.13,
  "38914": -1.13,
  "38915": -1.13,
  "38916": -1.13,
  "38917": -1.59,
  "38920": -3.43,
  "38921": -3.43,
  "38922": 6.69,
  "38923": -2.11,
  "38924": -0.73,
  "38925": -4.81,
  "38926": -2.91,
  "38927": -3.43,
  "38928": -3.43,
  "38929": -2.91,
  "38930": 4.39,
  "38935": 4.39,
  "38940": -3.43,
  "38941": 4.39,
  "38943": -1.59,
  "38944": 3.87,
  "38945": 4.39,
  "38946": 3.87,
  "38947": -1.59,
  "38948": 6.69,
  "38949": -0.61,
  "38950": 4.39,
  "38951": -1.13,
  "38952": 3.87,
  "38953": -2.91,
  "38954": 3.87,
  "38955": -1.13,
  "38957": -2.57,
  "38958": -3.43,
  "38959": 3.87,
  "38960": -2.91,
  "38961": 6.69,
  "38962": -3.43,
  "38963": -2.57,
  "38964": -2.57,
  "38965": 6.69,
  "38966": -2.05,
  "38967": -4.81,
  "39038": -15.39,
  "39039": -2.97,
  "39040": -2.97,
  "39041": 3.93,
  "39042": 13.34,
  "39043": 13.34,
  "39044": -3.43,
  "39045": 7.55,
  "39046": 8.07,
  "39047": 13.34,
  "39051": 3.93,
  "39054": -23.73,
  "39056": 12.42,
  "39057": -5.73,
  "39059": -0.21,
  "39060": 3.93,
  "39061": -23.73,
  "39062": -3.95,
  "39063": -0.73,
  "39066": -2.51,
  "39067": 3.93,
  "39069": -6.71,
  "39071": 8.07,
  "39072": 8.07,
  "39073": 4.85,
  "39074": -0.73,
  "39077": -0.21,
  "39078": -0.73,
  "39079": -0.73,
  "39080": -0.73,
  "39081": -6.71,
  "39082": -3.43,
  "39083": -0.21,
  "39086": -0.73,
  "39087": -0.73,
  "39088": -23.21,
  "39090": 3.93,
  "39092": -0.73,
  "39094": -0.73,
  "39095": -0.73,
  "39096": -6.71,
  "39097": -15.91,
  "39098": -0.21,
  "39107": 3.41,
  "39108": -14.53,
  "39109": 5.77,
  "39110": 16.56,
  "39111": -3.43,
  "39113": -23.73,
  "39114": -3.43,
  "39115": -15.39,
  "39116": -10.33,
  "39117": -0.21,
  "39119": -7.17,
  "39120": -6.19,
  "39121": -6.19,
  "39122": -6.19,
  "39130": 16.56,
  "39140": -3.95,
  "39144": -0.73,
  "39145": 4.85,
  "39146": -0.73,
  "39148": -3.43,
  "39149": -3.95,
  "39150": -3.03,
  "39151": 5.06,
  "39152": -0.21,
  "39153": -10.33,
  "39154": 12.42,
  "39156": -2.51,
  "39157": 16.56,
  "39158": 16.56,
  "39159": -23.73,
  "39160": 3.41,
  "39161": 8.07,
  "39162": -2.97,
  "39163": 8.07,
  "39165": -6.19,
  "39166": -15.39,
  "39167": 4.85,
  "39168": -10.33,
  "39169": -0.73,
  "39170": 12.42,
  "39171": 7.55,
  "39173": -2.97,
  "39174": 3.41,
  "39175": -0.21,
  "39176": -4.81,
  "39177": -23.21,
  "39179": 8.07,
  "39180": -2.51,
  "39181": -2.51,
  "39182": -2.51,
  "39183": -2.51,
  "39189": -0.21,
  "39190": -6.19,
  "39191": -0.21,
  "39192": 3.41,
  "39193": 4.85,
  "39194": -2.97,
  "39201": 3.41,
  "39202": 12.42,
  "39203": 3.41,
  "39204": 3.93,
  "39205": 12.42,
  "39206": 3.93,
  "39207": 3.41,
  "39208": 4.85,
  "39209": 3.93,
  "39211": 13.34,
  "39212": 3.93,
  "39213": 3.93,
  "39215": 3.41,
  "39216": 12.42,
  "39218": 3.93,
  "39225": 3.41,
  "39232": 3.41,
  "39236": 13.34,
  "39269": 3.41,
  "39272": 3.93,
  "39282": 3.93,
  "39283": 3.93,
  "39284": 3.93,
  "39286": 3.93,
  "39288": 12.42,
  "39289": 12.42,
  "39296": 12.42,
  "39298": 3.41,
  "39301": -3.89,
  "39302": -4.41,
  "39303": 4.6,
  "39304": -3.89,
  "39305": 4.6,
  "39307": -4.41,
  "39320": 4.6,
  "39322": -1.19,
  "39323": -6.25,
  "39324": -1.19,
  "39325": -3.89,
  "39326": 0.92,
  "39327": -5.73,
  "39328": 0.92,
  "39330": 3.41,
  "39332": -5.73,
  "39335": -2.3,
  "39336": -6.25,
  "39337": 5.77,
  "39338": 1.11,
  "39339": -7.82,
  "39341": -4.6,
  "39342": 4.6,
  "39345": -5.73,
  "39346": -9.41,
  "39347": 3.93,
  "39348": 1.11,
  "39350": 5.77,
  "39352": 0.92,
  "39354": 0.92,
  "39355": 3.41,
  "39356": 1.63,
  "39358": 0.92,
  "39359": -0.21,
  "39360": 3.41,
  "39361": -5.12,
  "39362": -1.19,
  "39363": 3.41,
  "39364": -2.3,
  "39365": 5.77,
  "39366": 1.11,
  "39367": -1.19,
  "39401": 2.55,
  "39402": 11.04,
  "39403": 2.55,
  "39404": 11.04,
  "39421": 11.23,
  "39422": 1.11,
  "39423": -8.09,
  "39425": -7.57,
  "39426": -0.98,
  "39427": 11.23,
  "39428": -7.17,
  "39429": 9.45,
  "39436": 5.77,
  "39437": 5.77,
  "39439": 1.11,
  "39440": 5.77,
  "39441": 5.25,
  "39442": 5.25,
  "39443": 5.25,
  "39451": 7.15,
  "39452": 7.67,
  "39455": -1.59,
  "39456": -8.09,
  "39457": -0.98,
  "39459": 5.77,
  "39460": 1.11,
  "39461": -8.09,
  "39462": -8.09,
  "39463": -0.98,
  "39464": 5.77,
  "39465": 2.55,
  "39466": -0.98,
  "39470": -2.05,
  "39474": 11.23,
  "39475": 6.9,
  "39476": -8.09,
  "39477": 5.25,
  "39478": 8.93,
  "39479": -6.65,
  "39480": 5.77,
  "39481": 1.11,
  "39482": -1.59,
  "39483": 8.93,
  "39501": 2.55,
  "39502": 2.55,
  "39503": 3.07,
  "39505": 3.07,
  "39506": 3.62,
  "39507": 3.62,
  "39520": 5.83,
  "39521": 5.83,
  "39525": 14.32,
  "39530": 3.62,
  "39531": 4.14,
  "39532": 3.62,
  "39533": 3.62,
  "39534": 3.62,
  "39535": 4.14,
  "39540": 3.62,
  "39552": 2.49,
  "39553": 3.01,
  "39555": 2.49,
  "39556": 5.83,
  "39558": 5.83,
  "39560": 3.07,
  "39561": -4.29,
  "39562": 2.49,
  "39563": 2.49,
  "39564": 4.08,
  "39565": 4.08,
  "39566": 4.6,
  "39567": 2.49,
  "39568": 3.01,
  "39569": 3.01,
  "39571": 5.83,
  "39572": 5.83,
  "39573": -4.29,
  "39574": 3.07,
  "39576": 5.83,
  "39577": -4.81,
  "39581": 2.49,
  "39601": -2.51,
  "39602": -2.51,
  "39603": -2.51,
  "39629": -2.51,
  "39630": -9.47,
  "39631": -4.2,
  "39632": -2.3,
  "39633": -7.88,
  "39635": -2.3,
  "39638": -7.88,
  "39641": 1.17,
  "39643": 8.93,
  "39645": -7.88,
  "39647": -2.51,
  "39648": -2.3,
  "39649": -4.41,
  "39652": -2.82,
  "39653": -7.88,
  "39654": 1.17,
  "39656": 11.75,
  "39657": -2.3,
  "39661": -5.12,
  "39662": 1.17,
  "39663": 0.65,
  "39664": -7.88,
  "39665": 0.65,
  "39666": -3.89,
  "39667": -3.89,
  "39668": -3.03,
  "39669": -4.2,
  "39701": 10.12,
  "39702": 10.12,
  "39703": 10.12,
  "39704": 10.12,
  "39705": 10.12,
  "39730": 4.6,
  "39735": -14.01,
  "39736": -2.3,
  "39737": -5.27,
  "39739": -4.6,
  "39740": 10.12,
  "39741": -5.52,
  "39743": -4.6,
  "39744": -5.27,
  "39745": -14.01,
  "39746": 4.6,
  "39747": -5.33,
  "39750": -3.68,
  "39751": -3.68,
  "39752": -3.68,
  "39753": 10.12,
  "39754": -5.52,
  "39755": -2.3,
  "39756": 4.6,
  "39759": -2.3,
  "39760": -2.3,
  "39762": -2.3,
  "39766": 10.12,
  "39767": -4.81,
  "39769": -2.3,
  "39771": -5.27,
  "39772": -14.01,
  "39773": -5.52,
  "39776": -5.52,
  "39813": -1.38,
  "39815": -4.14,
  "39817": -6.59,
  "39818": -6.59,
  "39819": -6.59,
  "39823": -7.11,
  "39824": -8.49,
  "39825": -7.11,
  "39826": -12.11,
  "39827": -4.14,
  "39828": -4.14,
  "39829": -4.14,
  "39832": -7.11,
  "39834": -4.14,
  "39836": -7.97,
  "39837": -7.11,
  "39840": -8.49,
  "39841": -7.11,
  "39842": -12.11,
  "39845": -7.11,
  "39846": -8.49,
  "39851": -7.97,
  "39852": -6.59,
  "39854": -13.03,
  "39859": -7.11,
  "39861": -7.11,
  "39862": -1.38,
  "39866": -1.38,
  "39867": -7.97,
  "39870": -7.11,
  "39877": -8.49,
  "39885": -1.38,
  "39886": -8.49,
  "39897": -4.14,
  "40003": -5.46,
  "40004": -1.9,
  "40006": -3.28,
  "40007": -11.65,
  "40008": -9.81,
  "40009": -10.06,
  "40010": 7.97,
  "40011": -11.65,
  "40012": -9.81,
  "40013": -1.9,
  "40014": 7.97,
  "40018": 7.97,
  "40019": -11.65,
  "40020": -9.26,
  "40022": -0.77,
  "40023": -0.77,
  "40025": 7.97,
  "40026": 7.97,
  "40027": 7.97,
  "40031": -0.52,
  "40033": -8.68,
  "40036": -3.22,
  "40037": -10.27,
  "40040": -0.86,
  "40041": 3.83,
  "40045": -8.8,
  "40046": -9.26,
  "40047": -0.98,
  "40048": -1.9,
  "40049": -10.27,
  "40050": -11.1,
  "40051": -6.59,
  "40052": -6.59,
  "40055": -3.28,
  "40056": -0.52,
  "40057": -11.65,
  "40058": -11.1,
  "40059": 7.97,
  "40060": -10.27,
  "40061": -0.86,
  "40062": -10.27,
  "40063": -8.68,
  "40065": -4.66,
  "40066": -4.66,
  "40067": -4.66,
  "40068": -11.1,
  "40069": -0.86,
  "40070": -11.1,
  "40071": -9.26,
  "40075": -11.65,
  "40076": -6.84,
  "40077": -0.52,
  "40078": -0.86,
  "40104": -6.5,
  "40107": -2.45,
  "40108": -7.05,
  "40109": -0.98,
  "40110": -0.98,
  "40111": -0.21,
  "40115": -11.19,
  "40117": -6.5,
  "40118": 1.69,
  "40119": -11.19,
  "40121": -7.05,
  "40129": -0.98,
  "40140": -11.19,
  "40142": -6.5,
  "40143": -11.19,
  "40144": -11.19,
  "40145": -11.19,
  "40146": -11.19,
  "40150": -1.53,
  "40152": -11.19,
  "40153": -11.19,
  "40155": -7.05,
  "40157": -6.5,
  "40159": -1.99,
  "40160": -1.99,
  "40161": -10.64,
  "40162": -1.44,
  "40165": -0.98,
  "40170": -11.19,
  "40171": -11.19,
  "40175": -1.99,
  "40176": -10.64,
  "40177": -7.05,
  "40178": -11.19,
  "40201": 1.69,
  "40202": 2.24,
  "40203": 1.69,
  "40204": 2.24,
  "40205": 2.24,
  "40206": 2.24,
  "40207": 3.83,
  "40208": 1.69,
  "40209": 1.69,
  "40210": 1.69,
  "40211": 1.69,
  "40212": -0.52,
  "40213": 1.69,
  "40214": 2.24,
  "40215": 1.69,
  "40216": 2.24,
  "40217": 2.24,
  "40218": 2.24,
  "40219": 2.24,
  "40220": 2.24,
  "40221": 1.69,
  "40222": 10.73,
  "40223": 2.24,
  "40224": 2.24,
  "40228": 2.24,
  "40229": -0.98,
  "40231": 1.69,
  "40232": 1.69,
  "40233": 10.73,
  "40241": 7.97,
  "40242": 10.73,
  "40243": 2.24,
  "40245": 7.97,
  "40250": 2.24,
  "40251": 1.69,
  "40252": 10.73,
  "40253": 2.24,
  "40255": 2.24,
  "40256": 2.24,
  "40257": 2.24,
  "40258": 2.24,
  "40259": 2.24,
  "40261": 2.24,
  "40268": 2.24,
  "40269": 2.24,
  "40270": 2.24,
  "40272": 2.24,
  "40285": 1.69,
  "40290": 1.69,
  "40291": 2.24,
  "40295": 2.24,
  "40298": 2.24,
  "40299": 2.24,
  "40310": -3.16,
  "40311": 0.52,
  "40312": -17.88,
  "40313": -7.36,
  "40316": -7.36,
  "40317": -8.95,
  "40319": -7.36,
  "40322": -7.36,
  "40324": -1.32,
  "40328": -5.92,
  "40330": -3.16,
  "40334": -6.84,
  "40336": -18.4,
  "40337": -6.84,
  "40339": -5,
  "40340": -5,
  "40342": -6.84,
  "40346": -7.36,
  "40347": -4.33,
  "40348": 0.52,
  "40350": -6.84,
  "40351": -8.95,
  "40353": -6.84,
  "40355": -2.15,
  "40356": -5,
  "40357": 0.52,
  "40358": -7.36,
  "40359": -2.7,
  "40360": -6.84,
  "40361": 0.52,
  "40362": 0.52,
  "40363": -10.06,
  "40366": -6.84,
  "40370": -1.32,
  "40371": -7.36,
  "40372": -6.84,
  "40374": -6.84,
  "40376": -6.44,
  "40379": -1.32,
  "40380": -17.88,
  "40383": -4.33,
  "40385": -17.88,
  "40387": -6.84,
  "40390": -5,
  "40391": -5.46,
  "40392": -5.46,
  "40402": -16.56,
  "40403": -5,
  "40405": -5,
  "40409": -10.98,
  "40410": -5,
  "40419": -10.98,
  "40422": -5.92,
  "40423": -5.92,
  "40434": -16.56,
  "40437": -10.98,
  "40440": -5.92,
  "40442": -11.5,
  "40444": -5,
  "40445": -16.56,
  "40447": -16.56,
  "40448": -10.98,
  "40452": -5.92,
  "40456": -16.56,
  "40460": -16.56,
  "40461": -5,
  "40464": -6.44,
  "40468": -5.92,
  "40472": -18.4,
  "40473": -16.56,
  "40475": -5,
  "40476": -5,
  "40481": -16.56,
  "40484": -10.98,
  "40486": -16.56,
  "40488": -16.56,
  "40489": -10.98,
  "40492": -16.56,
  "40495": -17.88,
  "40502": 13.15,
  "40503": 6.25,
  "40504": 4.66,
  "40505": 4.66,
  "40507": 13.15,
  "40508": 4.66,
  "40509": 13.15,
  "40510": 13.15,
  "40511": 4.66,
  "40512": 4.66,
  "40513": 13.15,
  "40514": 13.15,
  "40515": 13.15,
  "40516": 13.15,
  "40517": 4.66,
  "40522": 13.15,
  "40523": 4.66,
  "40524": 6.25,
  "40533": 4.66,
  "40544": 4.66,
  "40555": 13.15,
  "40574": 4.66,
  "40575": 4.66,
  "40576": 4.66,
  "40577": 4.66,
  "40578": 4.66,
  "40579": 4.66,
  "40580": 4.66,
  "40581": 4.66,
  "40582": 4.66,
  "40583": 4.66,
  "40588": 13.15,
  "40591": 13.15,
  "40601": -5.46,
  "40602": -5.46,
  "40603": -5.46,
  "40604": -5.46,
  "40701": -11.1,
  "40702": -11.1,
  "40724": 5.58,
  "40729": 5.06,
  "40730": -11.65,
  "40734": -2.91,
  "40737": 4.54,
  "40740": 4.54,
  "40741": 5.58,
  "40742": 5.58,
  "40743": 5.58,
  "40744": 5.58,
  "40745": 5.58,
  "40755": 5.58,
  "40759": -11.65,
  "40763": -11.65,
  "40769": -11.65,
  "40771": -11.1,
  "40801": -20.85,
  "40803": -20.85,
  "40806": -20.3,
  "40807": -17.54,
  "40808": -20.85,
  "40810": -20.85,
  "40813": -4.29,
  "40815": -20.85,
  "40816": -20.85,
  "40818": -20.3,
  "40819": -20.85,
  "40820": -20.85,
  "40823": -20.85,
  "40824": -20.85,
  "40826": -18.09,
  "40827": -20.85,
  "40828": -20.85,
  "40829": -20.3,
  "40830": -20.85,
  "40831": -20.3,
  "40840": -20.85,
  "40843": -20.85,
  "40844": -11.19,
  "40845": -4.29,
  "40847": -20.85,
  "40849": -20.85,
  "40854": -20.3,
  "40855": -18.09,
  "40856": -4.29,
  "40858": -20.85,
  "40862": -18.09,
  "40863": -4.29,
  "40865": -20.3,
  "40868": -11.19,
  "40870": -20.85,
  "40873": -20.3,
  "40874": -20.85,
  "40902": -4.81,
  "40903": -2.91,
  "40906": -2.91,
  "40913": -20.3,
  "40914": -14.26,
  "40915": -2.91,
  "40921": -4.29,
  "40923": -2.91,
  "40927": -20.3,
  "40930": -3.43,
  "40931": -14.26,
  "40932": -14.26,
  "40935": -3.43,
  "40939": -4.29,
  "40940": -4.81,
  "40941": -14.26,
  "40943": -2.91,
  "40944": -14.26,
  "40946": -2.91,
  "40949": -2.91,
  "40951": -14.26,
  "40953": -3.43,
  "40955": -2.91,
  "40958": -4.29,
  "40962": -14.26,
  "40964": -4.29,
  "40965": -4.29,
  "40972": -14.26,
  "40977": -4.29,
  "40979": -15.33,
  "40981": -11.19,
  "40982": -3.43,
  "40983": -14.26,
  "40988": -4.29,
  "40995": -2.91,
  "40997": -2.91,
  "41001": 3.22,
  "41002": -14.32,
  "41003": 4.2,
  "41004": -14.32,
  "41005": 1.84,
  "41006": -14.32,
  "41007": -1.9,
  "41008": -3.28,
  "41010": -2.7,
  "41011": 2.7,
  "41012": 2.7,
  "41014": 2.7,
  "41015": 3.22,
  "41016": 2.7,
  "41017": 3.22,
  "41018": 2.7,
  "41022": 1.32,
  "41030": 1.32,
  "41031": 4.2,
  "41033": 2.7,
  "41034": -1.44,
  "41035": -3.74,
  "41037": -0.4,
  "41039": -0.4,
  "41040": -14.32,
  "41041": -0.4,
  "41042": 1.32,
  "41043": -14.32,
  "41044": -14.32,
  "41045": -3.28,
  "41046": -3.74,
  "41048": 1.84,
  "41049": -7.36,
  "41051": 3.22,
  "41052": -3.74,
  "41053": 3.22,
  "41054": -3.74,
  "41055": -0.4,
  "41056": -1.44,
  "41059": 2.7,
  "41061": -14.32,
  "41062": -1.44,
  "41063": 3.22,
  "41064": -13.28,
  "41065": -3.43,
  "41071": 2.7,
  "41072": 2.7,
  "41073": 5.92,
  "41074": 5.92,
  "41075": 2.7,
  "41076": 3.22,
  "41080": 1.84,
  "41081": -3.43,
  "41083": -3.74,
  "41085": 2.7,
  "41086": -3.74,
  "41091": 9.81,
  "41092": 1.32,
  "41093": -3.43,
  "41094": 1.84,
  "41095": 1.32,
  "41096": -1.44,
  "41097": -3.74,
  "41098": -11.1,
  "41101": -2.05,
  "41102": -2.05,
  "41105": -2.05,
  "41121": -2.05,
  "41124": -9.01,
  "41128": -12.23,
  "41129": -2.05,
  "41132": -2.57,
  "41135": -12.23,
  "41139": -2.05,
  "41141": -3.95,
  "41142": -12.23,
  "41143": -11.71,
  "41144": -2.05,
  "41146": -12.23,
  "41149": -12.23,
  "41159": -9.01,
  "41160": -9.01,
  "41164": -12.23,
  "41166": -3.95,
  "41168": -2.57,
  "41169": -2.05,
  "41171": -12.23,
  "41173": -12.23,
  "41174": -3.95,
  "41175": -3.43,
  "41179": -3.95,
  "41180": -9.01,
  "41181": -12.23,
  "41183": -2.05,
  "41189": -3.43,
  "41201": -14.53,
  "41203": -14.53,
  "41204": -14.53,
  "41214": -14.53,
  "41216": -14.01,
  "41219": -14.53,
  "41222": -14.53,
  "41224": -14.01,
  "41226": -14.53,
  "41230": -8.49,
  "41231": -14.01,
  "41232": -14.53,
  "41234": -14.01,
  "41238": -14.53,
  "41240": -14.01,
  "41250": -14.01,
  "41254": -14.53,
  "41255": -14.53,
  "41256": -14.01,
  "41257": -14.01,
  "41260": -14.01,
  "41262": -14.53,
  "41263": -14.01,
  "41264": -14.53,
  "41265": -14.01,
  "41267": -14.53,
  "41268": -14.01,
  "41271": -14.53,
  "41274": -14.53,
  "41301": -6.44,
  "41307": -8.28,
  "41310": -10.39,
  "41311": -6.44,
  "41313": -6.44,
  "41314": -6.44,
  "41317": -9.35,
  "41332": -10.39,
  "41333": -6.44,
  "41338": -6.44,
  "41339": -8.28,
  "41347": -6.44,
  "41348": -9.35,
  "41351": -14.26,
  "41352": -10.39,
  "41360": -6.44,
  "41362": -6.44,
  "41364": -6.44,
  "41365": -5.92,
  "41366": -10.39,
  "41367": -11.19,
  "41368": -6.44,
  "41385": -8.28,
  "41386": -16.56,
  "41390": -8.28,
  "41397": -6.44,
  "41408": -10.39,
  "41413": -12.23,
  "41421": -12.23,
  "41425": -6.84,
  "41426": -14.53,
  "41451": -14.53,
  "41459": -14.53,
  "41464": -10.85,
  "41465": -14.53,
  "41472": -14.53,
  "41477": -14.53,
  "41501": -14.01,
  "41502": -14.01,
  "41503": -14.01,
  "41512": -4.35,
  "41513": -14.01,
  "41514": -5.52,
  "41517": -18.09,
  "41519": -14.01,
  "41520": -12.94,
  "41522": -14.01,
  "41524": -14.01,
  "41526": -14.01,
  "41527": -14.01,
  "41528": -12.42,
  "41531": -14.01,
  "41534": -4.35,
  "41535": -14.01,
  "41537": -18.09,
  "41538": -12.94,
  "41539": -14.01,
  "41540": -14.01,
  "41542": -4.35,
  "41543": -14.53,
  "41544": -14.01,
  "41547": -12.42,
  "41548": -14.01,
  "41549": -12.94,
  "41553": -14.01,
  "41554": -14.01,
  "41555": -14.53,
  "41557": -14.01,
  "41558": -14.01,
  "41559": -14.01,
  "41560": -12.94,
  "41561": -14.01,
  "41562": -14.01,
  "41563": -4.87,
  "41564": -14.53,
  "41566": -14.01,
  "41567": -14.01,
  "41568": -11.71,
  "41571": -14.53,
  "41572": -9.81,
  "41601": -10.85,
  "41602": -14.01,
  "41603": -1.84,
  "41604": -9.81,
  "41605": -10.33,
  "41606": -18.09,
  "41607": -8.74,
  "41612": -18.09,
  "41615": -10.33,
  "41616": -10.85,
  "41619": -9.81,
  "41621": -10.85,
  "41622": -10.33,
  "41630": -9.81,
  "41631": -9.81,
  "41632": -10.85,
  "41635": -10.85,
  "41636": -9.81,
  "41640": -10.33,
  "41642": -10.33,
  "41643": -9.81,
  "41645": -10.33,
  "41647": -9.81,
  "41649": -10.85,
  "41650": -18.09,
  "41651": -9.81,
  "41653": -10.33,
  "41655": -10.85,
  "41659": -10.33,
  "41660": -9.81,
  "41663": -10.33,
  "41666": -9.81,
  "41667": -18.09,
  "41669": -18.09,
  "41701": -10.64,
  "41702": -11.19,
  "41712": -17.54,
  "41713": -11.19,
  "41714": -11.19,
  "41719": -11.19,
  "41721": -8.28,
  "41722": -10.64,
  "41723": -11.19,
  "41725": -17.54,
  "41727": -10.64,
  "41729": -10.64,
  "41731": -11.19,
  "41735": -20.85,
  "41736": -10.64,
  "41739": -17.54,
  "41740": -18.09,
  "41743": -17.54,
  "41745": -10.64,
  "41746": -11.19,
  "41747": -17.54,
  "41749": -11.19,
  "41751": -10.64,
  "41754": -10.64,
  "41759": -18.09,
  "41760": -11.19,
  "41762": -11.19,
  "41763": -20.85,
  "41764": -11.19,
  "41766": -11.19,
  "41772": -18.09,
  "41773": -10.64,
  "41774": -10.64,
  "41775": -11.19,
  "41776": -11.19,
  "41777": -11.19,
  "41778": -11.19,
  "41804": -18.09,
  "41810": -18.09,
  "41812": -18.09,
  "41815": -18.09,
  "41817": -18.09,
  "41819": -20.85,
  "41821": -18.09,
  "41822": -17.54,
  "41824": -17.54,
  "41825": -18.09,
  "41826": -17.54,
  "41828": -18.09,
  "41831": -17.54,
  "41832": -18.09,
  "41833": -18.09,
  "41834": -18.09,
  "41835": -18.09,
  "41836": -18.09,
  "41837": -18.09,
  "41838": -18.09,
  "41839": -17.54,
  "41840": -18.09,
  "41843": -18.09,
  "41844": -18.09,
  "41845": -17.54,
  "41847": -18.09,
  "41848": -18.09,
  "41849": -18.09,
  "41855": -18.09,
  "41858": -18.09,
  "41859": -17.54,
  "41861": -18.09,
  "41862": -18.09,
  "42001": 4.14,
  "42002": 4.14,
  "42003": -4.35,
  "42020": -13.49,
  "42021": -6.13,
  "42022": -13.55,
  "42023": -6.65,
  "42024": -13.55,
  "42025": -6.13,
  "42027": -3.83,
  "42028": -7.57,
  "42029": -6.65,
  "42031": -14.87,
  "42032": -6.13,
  "42033": -14.01,
  "42035": -6.65,
  "42036": -14.01,
  "42037": 5.37,
  "42038": -7.05,
  "42039": -6.65,
  "42040": -11.71,
  "42041": -14.87,
  "42044": 1.84,
  "42045": -7.57,
  "42047": 4.85,
  "42048": -6.65,
  "42049": -14.01,
  "42050": -14.87,
  "42051": -11.71,
  "42053": -13.55,
  "42054": -3.22,
  "42055": -7.05,
  "42056": -13.55,
  "42058": -4.35,
  "42060": -13.55,
  "42061": -6.65,
  "42063": -11.71,
  "42064": -14.01,
  "42066": -11.71,
  "42069": -3.83,
  "42070": -6.65,
  "42071": -13.49,
  "42076": -14.01,
  "42078": -7.57,
  "42079": -11.71,
  "42081": 4.85,
  "42082": -6.65,
  "42083": 5.37,
  "42084": -14.53,
  "42085": -14.87,
  "42086": -4.35,
  "42087": -13.55,
  "42088": -11.19,
  "42101": -1.99,
  "42102": -0.4,
  "42103": -0.4,
  "42104": -0.4,
  "42120": -10.58,
  "42122": -0.4,
  "42123": -10.58,
  "42124": 39.1,
  "42127": -11.19,
  "42128": -0.4,
  "42129": -11.65,
  "42130": 39.1,
  "42131": -9.6,
  "42133": -10.58,
  "42134": -6.38,
  "42135": -6.38,
  "42140": 42.32,
  "42141": -9.6,
  "42142": -9.6,
  "42151": 42.84,
  "42152": -11.19,
  "42153": -10.58,
  "42154": -11.19,
  "42156": -10.58,
  "42157": -9.6,
  "42159": -0.4,
  "42160": -11.19,
  "42163": -11.19,
  "42164": -10.58,
  "42166": 39.1,
  "42167": 42.84,
  "42170": -6.9,
  "42171": -10.52,
  "42201": -10.73,
  "42202": -1.99,
  "42204": -5.67,
  "42206": -13.49,
  "42207": -12.11,
  "42210": -12.11,
  "42211": -17.63,
  "42214": -11.19,
  "42215": -18.15,
  "42216": -6.19,
  "42217": -2.51,
  "42219": -10.73,
  "42220": -6.19,
  "42221": -1.99,
  "42223": 5,
  "42232": 5.98,
  "42234": -5.67,
  "42236": -0.92,
  "42240": -1.99,
  "42241": -1.99,
  "42252": -12.11,
  "42254": -2.51,
  "42256": -14.01,
  "42259": -12.11,
  "42261": -10.73,
  "42262": 4.45,
  "42265": -5.67,
  "42266": -1.99,
  "42273": -10.73,
  "42274": -1.99,
  "42275": -12.11,
  "42276": -14.01,
  "42280": -6.19,
  "42283": -13.49,
  "42285": -12.63,
  "42286": -5.12,
  "42287": -10.73,
  "42288": -10.73,
  "42301": -7.51,
  "42302": -7.51,
  "42303": -7.51,
  "42304": -7.51,
  "42320": -9.81,
  "42321": 14.51,
  "42322": -10.27,
  "42323": 14.51,
  "42324": 14.51,
  "42325": 15.03,
  "42326": 14.51,
  "42327": -10.27,
  "42328": -10.33,
  "42330": 15.03,
  "42332": 14.51,
  "42333": -10.33,
  "42334": -7.51,
  "42337": 14.51,
  "42338": -9.81,
  "42339": 14.51,
  "42343": -11.71,
  "42344": 14.51,
  "42345": 14.51,
  "42347": -9.81,
  "42348": -5.92,
  "42349": -10.33,
  "42350": -10.79,
  "42351": -7.51,
  "42352": -10.79,
  "42354": -10.33,
  "42355": -7.51,
  "42356": -10.27,
  "42361": -9.81,
  "42364": 0.31,
  "42366": -5.92,
  "42367": 14.51,
  "42368": 0.31,
  "42369": -10.33,
  "42370": 0.31,
  "42371": -10.79,
  "42372": -10.27,
  "42374": 15.03,
  "42375": -7.51,
  "42376": -10.27,
  "42377": -7.51,
  "42378": 0.31,
  "42402": -5.27,
  "42403": -14.53,
  "42404": -0.67,
  "42406": -5.27,
  "42408": 0.25,
  "42409": -0.67,
  "42410": 0.25,
  "42411": -17.23,
  "42413": 8.74,
  "42419": -3.68,
  "42420": -3.68,
  "42431": 0.25,
  "42436": -0.67,
  "42437": -9.41,
  "42440": 0.25,
  "42441": 0.25,
  "42442": 0.25,
  "42444": -0.67,
  "42445": -17.23,
  "42450": -1.19,
  "42451": -5.79,
  "42452": 3.22,
  "42453": 0.25,
  "42455": -0.67,
  "42456": -0.67,
  "42457": -5.27,
  "42458": -5.27,
  "42459": -9.41,
  "42460": -14.53,
  "42461": -5.27,
  "42462": -5.27,
  "42463": -1.19,
  "42464": 0.25,
  "42501": -10.06,
  "42502": -10.06,
  "42503": -10.06,
  "42516": -10.06,
  "42518": -11.1,
  "42519": -11.65,
  "42528": -10.58,
  "42533": -10.06,
  "42539": -10.58,
  "42541": -10.58,
  "42544": -10.06,
  "42553": -10.06,
  "42558": -11.65,
  "42564": -10.06,
  "42565": -10.06,
  "42566": -10.58,
  "42567": -10.58,
  "42602": -13.03,
  "42603": -13.03,
  "42629": -11.1,
  "42631": -12.48,
  "42633": -17.17,
  "42634": -11.65,
  "42635": -13.03,
  "42638": -13.03,
  "42642": -10.06,
  "42647": -17.17,
  "42649": -13.03,
  "42653": -13.03,
  "42701": -1.44,
  "42702": -1.44,
  "42712": -12.11,
  "42713": -6.59,
  "42715": -10.58,
  "42716": -6.59,
  "42717": -12.48,
  "42718": -10.27,
  "42719": -10.27,
  "42720": -10.06,
  "42721": -12.11,
  "42722": -6.59,
  "42724": -1.99,
  "42726": -12.11,
  "42728": -10.06,
  "42729": -12.11,
  "42731": 42.32,
  "42732": -1.99,
  "42733": -10.06,
  "42740": -1.44,
  "42741": -10.06,
  "42742": -11.1,
  "42743": -11.65,
  "42746": -11.19,
  "42748": -6.59,
  "42749": -11.19,
  "42753": -10.06,
  "42754": -12.11,
  "42755": -12.11,
  "42757": -6.59,
  "42758": -10.27,
  "42759": 42.32,
  "42762": -12.11,
  "42764": -6.59,
  "42765": -12.11,
  "42776": -6.59,
  "42782": -6.59,
  "42784": -6.59,
  "42788": -1.99,
  "43001": 16.25,
  "43002": 10.06,
  "43003": 10.52,
  "43004": 10.58,
  "43005": -1.07,
  "43006": -2.05,
  "43007": 11.75,
  "43008": 7.21,
  "43009": -7.11,
  "43010": -7.63,
  "43011": -0.52,
  "43013": 7.76,
  "43014": -1.59,
  "43015": 11.04,
  "43016": 19.53,
  "43017": 19.07,
  "43018": 1.78,
  "43019": -1.07,
  "43021": 19.53,
  "43022": -0.52,
  "43023": 16.25,
  "43025": 7.76,
  "43026": 10.58,
  "43027": -0.52,
  "43028": -0.52,
  "43029": 20.24,
  "43030": 7.76,
  "43031": 9.35,
  "43032": 10.52,
  "43033": 7.76,
  "43035": 19.53,
  "43036": 12.82,
  "43037": -0.52,
  "43040": 13.34,
  "43044": -7.11,
  "43045": 11.75,
  "43046": 3.37,
  "43047": -7.11,
  "43048": -0.52,
  "43050": -0.52,
  "43054": 19.07,
  "43055": 7.76,
  "43056": 7.76,
  "43058": 7.76,
  "43060": 11.75,
  "43061": 13.34,
  "43062": 9.35,
  "43064": 13.34,
  "43065": 19.53,
  "43066": 11.04,
  "43067": 13.34,
  "43068": 10.58,
  "43070": -7.63,
  "43071": 7.76,
  "43072": -7.11,
  "43073": 10.58,
  "43074": 11.04,
  "43076": 7.76,
  "43077": 12.82,
  "43078": -7.11,
  "43080": -0.52,
  "43081": 10.58,
  "43082": 10.58,
  "43083": -7.11,
  "43084": 11.75,
  "43085": 10.58,
  "43086": 10.58,
  "43101": -11.96,
  "43102": 3.89,
  "43103": -2.09,
  "43105": 10.79,
  "43106": 7.55,
  "43107": 22.08,
  "43109": 10.06,
  "43110": 2.3,
  "43111": -12.48,
  "43112": 10.79,
  "43113": -3.68,
  "43115": -3.68,
  "43116": -4.2,
  "43117": -3.68,
  "43119": 10.58,
  "43123": 10.58,
  "43125": 10.58,
  "43126": -2.36,
  "43127": -12.48,
  "43128": 7.55,
  "43130": 2.3,
  "43135": -11.96,
  "43136": 2.3,
  "43137": 10.06,
  "43138": -11.96,
  "43140": -3.43,
  "43142": 7.55,
  "43143": 9.14,
  "43144": -7.42,
  "43145": 9.14,
  "43146": -3.68,
  "43147": 2.3,
  "43148": 2.3,
  "43149": -11.96,
  "43150": 22.08,
  "43151": 7.55,
  "43152": -11.5,
  "43153": 8.07,
  "43154": 4.81,
  "43155": -11.96,
  "43156": -3.68,
  "43157": 2.3,
  "43158": -11.96,
  "43160": 7.55,
  "43162": -2.36,
  "43163": 22.08,
  "43164": -4.2,
  "43194": 10.06,
  "43201": 10.06,
  "43202": 10.58,
  "43203": 10.06,
  "43204": 10.06,
  "43205": 10.06,
  "43206": 10.06,
  "43207": 10.06,
  "43209": 10.58,
  "43210": 10.58,
  "43211": 10.06,
  "43212": 10.58,
  "43213": 10.06,
  "43214": 10.58,
  "43215": 10.58,
  "43216": 10.06,
  "43217": 10.06,
  "43218": 10.58,
  "43219": 10.06,
  "43220": 10.58,
  "43221": 10.58,
  "43222": 10.06,
  "43223": 10.06,
  "43224": 10.06,
  "43226": 10.58,
  "43227": 10.06,
  "43228": 10.06,
  "43229": 10.06,
  "43230": 10.58,
  "43231": 10.58,
  "43232": 10.06,
  "43234": 10.58,
  "43235": 10.58,
  "43236": 10.06,
  "43240": 11.04,
  "43301": -2.05,
  "43302": -2.05,
  "43306": -2.05,
  "43310": -3.95,
  "43311": -3.43,
  "43314": -2.05,
  "43315": -9.81,
  "43316": 15.24,
  "43317": -10.33,
  "43318": -3.95,
  "43319": 11.75,
  "43320": -9.81,
  "43321": -10.33,
  "43322": -2.05,
  "43323": 13.13,
  "43324": -3.43,
  "43325": 0.25,
  "43326": -14.99,
  "43330": 12.61,
  "43331": -3.95,
  "43332": -2.57,
  "43333": -3.95,
  "43334": -9.81,
  "43335": -2.05,
  "43336": 11.75,
  "43337": -1.53,
  "43338": -9.81,
  "43340": -14.99,
  "43341": -2.05,
  "43342": -0.98,
  "43343": -3.95,
  "43344": -3.95,
  "43345": -14.99,
  "43346": -3.95,
  "43347": -3.95,
  "43348": -3.95,
  "43349": 6.5,
  "43350": -10.33,
  "43351": 13.65,
  "43356": -0.46,
  "43357": -7.11,
  "43358": -3.95,
  "43359": 12.61,
  "43360": -3.95,
  "43402": 16.83,
  "43406": 8.34,
  "43407": 1.44,
  "43408": -4.35,
  "43410": 1.44,
  "43412": -4.35,
  "43413": 8.34,
  "43414": 8.89,
  "43416": -0.67,
  "43420": 1.44,
  "43430": 6.23,
  "43431": 1.44,
  "43432": -4.35,
  "43433": -4.35,
  "43434": 2.95,
  "43435": 1.99,
  "43436": 4.66,
  "43437": 8.34,
  "43438": -5.58,
  "43439": -4.35,
  "43440": -6.13,
  "43441": 8.89,
  "43442": 1.99,
  "43443": 8.89,
  "43445": -4.35,
  "43446": 4.66,
  "43447": 3.47,
  "43449": -4.35,
  "43450": 8.89,
  "43451": 8.89,
  "43452": -4.35,
  "43456": 4.66,
  "43457": 8.34,
  "43458": -4.35,
  "43460": 3.47,
  "43462": 8.34,
  "43463": 8.89,
  "43464": 1.44,
  "43465": 3.47,
  "43466": 8.34,
  "43467": 8.34,
  "43468": 3.47,
  "43469": 8.89,
  "43501": 1.57,
  "43502": 13.95,
  "43504": 3.47,
  "43505": 2.09,
  "43506": 2.09,
  "43510": 3.74,
  "43511": 4.29,
  "43512": -8.68,
  "43515": 11.29,
  "43516": 3.74,
  "43517": 2.09,
  "43518": 2.09,
  "43519": 4.2,
  "43520": -10.79,
  "43521": 11.29,
  "43522": 8.89,
  "43523": 3.74,
  "43524": 3.74,
  "43525": 8.89,
  "43526": -10.79,
  "43527": 3.74,
  "43528": 3.47,
  "43529": 6.96,
  "43530": -8.68,
  "43531": 1.57,
  "43532": 3.74,
  "43533": 11.29,
  "43534": 3.74,
  "43535": 3.74,
  "43536": -10.79,
  "43537": 3.47,
  "43540": 11.29,
  "43541": 3.74,
  "43542": 3.99,
  "43543": 2.09,
  "43545": 3.74,
  "43547": 4.29,
  "43548": 3.74,
  "43549": -10.79,
  "43550": 3.74,
  "43551": 3.99,
  "43552": 3.99,
  "43553": 13.4,
  "43554": 2.09,
  "43555": 3.74,
  "43556": -10.79,
  "43557": 4.2,
  "43558": 11.29,
  "43560": 5.06,
  "43565": 8.34,
  "43566": 16.83,
  "43567": 13.95,
  "43569": 8.34,
  "43570": 4.2,
  "43571": 16.83,
  "43601": 2.95,
  "43603": 2.95,
  "43604": 2.95,
  "43605": 2.95,
  "43606": 3.47,
  "43607": 3.47,
  "43608": 2.95,
  "43609": 3.47,
  "43610": 3.47,
  "43611": 3.47,
  "43612": 3.47,
  "43613": 3.47,
  "43614": 3.47,
  "43615": 3.47,
  "43616": 3.47,
  "43617": 11.96,
  "43618": 3.47,
  "43619": 3.47,
  "43620": 3.47,
  "43623": 3.47,
  "43635": 3.47,
  "43697": 2.95,
  "43699": 3.47,
  "43701": -3.74,
  "43702": -3.74,
  "43711": -17.23,
  "43713": -0.67,
  "43716": -0.67,
  "43717": -17.23,
  "43718": -0.67,
  "43719": -0.67,
  "43720": -3.74,
  "43721": 7.76,
  "43722": 11.29,
  "43723": 11.81,
  "43724": -16.71,
  "43725": 11.81,
  "43727": -3.74,
  "43728": -18.09,
  "43730": 21.56,
  "43731": 21.56,
  "43732": -16.71,
  "43733": 11.29,
  "43734": -3.74,
  "43735": 21.01,
  "43736": 11.29,
  "43738": 21.01,
  "43739": 7.76,
  "43740": -3.74,
  "43746": -3.74,
  "43747": -0.67,
  "43748": 22.08,
  "43749": 11.81,
  "43750": 11.81,
  "43752": -16.71,
  "43754": -16.71,
  "43755": 11.29,
  "43756": -18.09,
  "43757": -0.67,
  "43758": -18.09,
  "43759": -0.67,
  "43760": 21.56,
  "43761": 21.56,
  "43762": 12.36,
  "43764": 22.08,
  "43766": 21.56,
  "43767": -3.74,
  "43768": 11.29,
  "43771": -4.29,
  "43772": 11.29,
  "43773": 11.29,
  "43777": 21.01,
  "43778": 19.78,
  "43779": -16.71,
  "43780": 11.81,
  "43782": 21.56,
  "43783": 22.08,
  "43786": -16.71,
  "43787": -18.09,
  "43788": -17.23,
  "43789": -17.23,
  "43791": 21.01,
  "43793": -16.71,
  "43802": -4.29,
  "43803": -5.21,
  "43804": -1.53,
  "43805": -6.96,
  "43811": -6.96,
  "43812": -6.96,
  "43821": -3.74,
  "43822": -3.74,
  "43824": -7.51,
  "43828": -6.96,
  "43830": -3.74,
  "43832": -5.21,
  "43836": -7.51,
  "43837": -5.21,
  "43840": -5.21,
  "43842": -7.51,
  "43843": -1.07,
  "43844": -6.96,
  "43845": -7.51,
  "43901": -0.27,
  "43902": -0.67,
  "43903": -3.89,
  "43905": -1.19,
  "43906": -5.73,
  "43907": 0.25,
  "43908": -4.41,
  "43909": -1.19,
  "43910": 0.25,
  "43912": -6.25,
  "43913": -0.27,
  "43914": -6.19,
  "43915": -6.19,
  "43916": -6.25,
  "43917": -6.25,
  "43920": -6.65,
  "43925": 0.25,
  "43926": -6.65,
  "43927": 7.82,
  "43928": -1.19,
  "43930": -5.73,
  "43931": -0.15,
  "43932": -6.65,
  "43933": -0.67,
  "43934": -5.73,
  "43935": -5.73,
  "43937": -1.19,
  "43938": 0.25,
  "43939": -6.25,
  "43940": -0.67,
  "43941": -0.27,
  "43942": -0.21,
  "43943": -5.73,
  "43944": 0.25,
  "43945": -5.73,
  "43946": -0.15,
  "43947": -0.21,
  "43948": -0.27,
  "43950": 7.82,
  "43951": -1.19,
  "43952": 0.25,
  "43953": 0.25,
  "43961": -7.17,
  "43962": -5.73,
  "43963": -5.73,
  "43964": -6.65,
  "43967": -1.19,
  "43968": -6.65,
  "43970": 0.25,
  "43971": -5.73,
  "43972": -0.67,
  "43973": 0.25,
  "43974": -1.19,
  "43976": 0.25,
  "43977": -0.27,
  "43981": -0.27,
  "43983": 0.25,
  "43984": 0.25,
  "43985": -0.27,
  "43986": 0.25,
  "43988": 0.25,
  "44001": -4.75,
  "44003": -8.09,
  "44004": -7.57,
  "44005": -7.57,
  "44010": -7.57,
  "44011": 4.29,
  "44012": -4.2,
  "44017": 3.99,
  "44021": 3.68,
  "44022": 3.68,
  "44023": 5.79,
  "44024": -4.81,
  "44026": -4.81,
  "44028": -4.2,
  "44030": -7.57,
  "44032": -8.09,
  "44033": 3.68,
  "44035": -4.75,
  "44036": -4.75,
  "44039": -4.2,
  "44040": 5.98,
  "44041": -8.09,
  "44044": -4.2,
  "44045": 0.71,
  "44046": 3.68,
  "44047": -7.57,
  "44048": -7.57,
  "44049": -4.75,
  "44050": -4.2,
  "44052": -4.75,
  "44053": -4.75,
  "44054": -4.75,
  "44055": -4.75,
  "44056": 5.58,
  "44057": 0.19,
  "44060": 0.71,
  "44061": 0.71,
  "44062": -4.81,
  "44064": -3.22,
  "44065": -4.81,
  "44067": 3.47,
  "44068": -7.57,
  "44070": -4.2,
  "44072": -4.81,
  "44074": -4.2,
  "44076": -8.09,
  "44077": 0.71,
  "44080": -5.33,
  "44081": 0.71,
  "44082": -7.57,
  "44084": -7.57,
  "44085": -7.57,
  "44086": 0.71,
  "44087": 0.98,
  "44088": 0.19,
  "44089": -4.75,
  "44090": -4.2,
  "44092": 0.71,
  "44093": -8.09,
  "44094": 0.71,
  "44095": 0.19,
  "44096": 0.71,
  "44097": 0.19,
  "44099": -5.33,
  "44101": 2.95,
  "44102": 2.95,
  "44103": 2.95,
  "44104": 2.95,
  "44105": 2.95,
  "44106": 2.95,
  "44107": 3.47,
  "44108": 2.95,
  "44109": 2.95,
  "44110": 2.95,
  "44111": 2.95,
  "44112": 2.95,
  "44113": 2.95,
  "44114": 2.95,
  "44115": 2.95,
  "44116": 3.47,
  "44117": 2.95,
  "44118": 3.47,
  "44119": 2.95,
  "44120": 2.95,
  "44121": 2.95,
  "44122": 3.47,
  "44123": 2.95,
  "44124": 2.95,
  "44125": 2.95,
  "44126": 3.47,
  "44127": 2.95,
  "44128": 2.95,
  "44129": 2.95,
  "44130": 3.47,
  "44131": 3.47,
  "44132": 0.19,
  "44133": 3.47,
  "44134": 3.47,
  "44135": 2.95,
  "44136": 3.47,
  "44137": 2.95,
  "44138": -4.2,
  "44139": 3.47,
  "44140": -4.2,
  "44141": 3.47,
  "44142": 3.47,
  "44143": 3.47,
  "44144": 2.95,
  "44145": 4.29,
  "44146": 2.95,
  "44147": 3.47,
  "44149": 3.47,
  "44181": 2.95,
  "44199": 2.95,
  "44201": 0.98,
  "44202": 0.98,
  "44203": 1.17,
  "44210": 9.66,
  "44211": 0.98,
  "44212": 3.16,
  "44214": -2.51,
  "44215": 2.09,
  "44216": 1.17,
  "44217": 2.09,
  "44221": 1.17,
  "44222": 1.17,
  "44223": 1.17,
  "44224": 3.28,
  "44230": 1.17,
  "44231": -1.13,
  "44232": 3.01,
  "44233": 10.58,
  "44234": -2.7,
  "44235": 3.16,
  "44236": 11.77,
  "44240": 0.98,
  "44241": 0.98,
  "44243": 0.98,
  "44250": 1.17,
  "44251": 2.61,
  "44253": 3.16,
  "44254": 2.61,
  "44255": 0.98,
  "44256": 2.61,
  "44258": 3.16,
  "44260": 3.28,
  "44262": 3.28,
  "44264": 1.17,
  "44265": 3.28,
  "44266": 0.46,
  "44270": 1.17,
  "44272": 0.98,
  "44273": 2.61,
  "44274": 2.09,
  "44275": 3.16,
  "44276": -2.51,
  "44278": 1.17,
  "44280": 3.16,
  "44281": 2.09,
  "44282": 2.09,
  "44285": -1.13,
  "44286": 9.66,
  "44287": -2.51,
  "44288": -1.65,
  "44301": 1.17,
  "44302": 1.17,
  "44303": 1.17,
  "44304": 1.17,
  "44305": 1.17,
  "44306": 1.17,
  "44307": 0.65,
  "44308": 1.17,
  "44309": 1.17,
  "44310": 1.17,
  "44311": 0.65,
  "44312": 1.17,
  "44313": 9.66,
  "44314": 1.17,
  "44319": 1.17,
  "44320": 1.17,
  "44321": 1.69,
  "44322": 1.17,
  "44333": 9.66,
  "44334": 1.17,
  "44372": 9.66,
  "44401": 2.55,
  "44402": -4.35,
  "44403": -4.87,
  "44404": -6.71,
  "44405": 1.48,
  "44406": 10.52,
  "44408": -6.25,
  "44410": -4.35,
  "44411": 0.46,
  "44412": -1.13,
  "44413": -6.25,
  "44415": -6.25,
  "44416": 2.55,
  "44417": -4.35,
  "44418": 3.62,
  "44420": -4.87,
  "44422": -6.25,
  "44423": -6.25,
  "44424": 3.62,
  "44425": 2.03,
  "44427": -5.73,
  "44428": -4.87,
  "44429": -1.65,
  "44430": -4.87,
  "44431": -6.25,
  "44432": -6.25,
  "44436": 2.03,
  "44437": -4.87,
  "44438": -4.87,
  "44439": -4.81,
  "44440": -4.87,
  "44441": -6.25,
  "44442": 2.03,
  "44443": 2.03,
  "44444": -4.87,
  "44445": -6.25,
  "44446": -4.87,
  "44449": -1.13,
  "44450": -4.87,
  "44451": 2.55,
  "44452": 2.03,
  "44453": -6.71,
  "44454": 2.03,
  "44455": -6.25,
  "44460": -6.25,
  "44470": -4.35,
  "44471": 1.48,
  "44473": -4.87,
  "44481": -4.87,
  "44482": -4.87,
  "44483": -4.87,
  "44484": -4.87,
  "44485": -4.87,
  "44490": -6.25,
  "44491": -4.35,
  "44492": -6.25,
  "44493": -6.25,
  "44501": 1.48,
  "44502": 1.48,
  "44503": 1.48,
  "44504": 1.48,
  "44505": 1.48,
  "44506": 1.48,
  "44507": 1.48,
  "44509": 1.48,
  "44510": 1.48,
  "44511": 2.03,
  "44512": 2.03,
  "44513": 2.03,
  "44514": 2.03,
  "44515": 2.03,
  "44601": 2.49,
  "44606": -1.99,
  "44607": -5.73,
  "44608": -5.21,
  "44609": -6.25,
  "44610": -0.98,
  "44611": -1.53,
  "44612": -4.66,
  "44613": 3.53,
  "44614": 4.08,
  "44615": -3.89,
  "44617": -0.98,
  "44618": -1.44,
  "44619": 2.24,
  "44620": -3.89,
  "44621": -6.25,
  "44622": -5.21,
  "44624": -5.21,
  "44625": -4.41,
  "44626": 3.01,
  "44627": -0.98,
  "44628": -1.53,
  "44629": -5.21,
  "44630": 3.01,
  "44631": -3.89,
  "44632": 4.08,
  "44633": -0.98,
  "44634": -3.89,
  "44636": -1.99,
  "44637": -2.05,
  "44638": -2.05,
  "44639": -0.27,
  "44640": 0.46,
  "44641": 3.01,
  "44643": -4.41,
  "44644": -3.89,
  "44645": -1.44,
  "44646": 4.08,
  "44647": 3.53,
  "44648": 3.53,
  "44650": 2.49,
  "44651": 4.6,
  "44652": 3.01,
  "44653": -6.25,
  "44654": -0.98,
  "44656": 2.49,
  "44657": -4.41,
  "44659": -1.99,
  "44660": -0.98,
  "44661": -2.05,
  "44662": 3.53,
  "44663": -5.21,
  "44665": -3.89,
  "44666": 4.08,
  "44667": -1.99,
  "44669": 3.01,
  "44670": 2.49,
  "44671": 2.49,
  "44672": -6.25,
  "44675": -4.41,
  "44676": -1.53,
  "44677": -1.44,
  "44678": -6.25,
  "44679": 0.25,
  "44680": -5.21,
  "44681": -4.66,
  "44682": -5.21,
  "44683": -6.25,
  "44685": 3.01,
  "44687": -0.98,
  "44688": -4.41,
  "44689": -5.21,
  "44690": 7.51,
  "44691": -1.44,
  "44693": 0.25,
  "44695": -0.27,
  "44697": 2.24,
  "44699": 0.25,
  "44701": 2.49,
  "44702": 2.49,
  "44703": 2.49,
  "44704": 2.49,
  "44705": 2.49,
  "44706": 2.49,
  "44707": 2.49,
  "44708": 3.01,
  "44709": 3.01,
  "44710": 2.49,
  "44711": 3.01,
  "44714": 2.49,
  "44718": 10.98,
  "44720": 10.98,
  "44721": 3.01,
  "44730": 3.01,
  "44735": 10.98,
  "44802": 7.51,
  "44804": 6.96,
  "44805": 2.15,
  "44807": 9.97,
  "44809": 1.99,
  "44811": 9.97,
  "44813": -1.99,
  "44814": -6.13,
  "44815": 1.44,
  "44816": -4.75,
  "44817": 6.96,
  "44818": -0.15,
  "44820": 0.25,
  "44822": -1.07,
  "44824": -6.13,
  "44825": 0.25,
  "44826": 9.97,
  "44827": 0.25,
  "44828": 9.45,
  "44830": 1.44,
  "44833": 0.25,
  "44836": 1.44,
  "44837": 9.97,
  "44838": 1.63,
  "44839": -6.13,
  "44840": 3.74,
  "44841": 1.44,
  "44842": 2.15,
  "44843": 6.5,
  "44844": 15.24,
  "44845": 13.13,
  "44846": -5.58,
  "44847": 9.97,
  "44848": 2.15,
  "44849": 13.13,
  "44850": 9.97,
  "44851": 9.97,
  "44853": 1.99,
  "44854": 0.25,
  "44855": 9.97,
  "44856": 0.25,
  "44857": 9.97,
  "44859": 10.64,
  "44860": 13.13,
  "44861": 1.44,
  "44862": -2.51,
  "44864": 2.15,
  "44865": 9.97,
  "44866": 3.74,
  "44867": -0.15,
  "44870": -6.13,
  "44871": -6.13,
  "44874": 1.63,
  "44875": -1.99,
  "44878": -1.99,
  "44880": 2.15,
  "44881": 0.25,
  "44882": 13.13,
  "44883": 1.44,
  "44887": 0.25,
  "44889": 10.52,
  "44890": 9.97,
  "44901": 6.5,
  "44902": -2.51,
  "44903": -1.99,
  "44904": 6.5,
  "44905": -2.51,
  "44906": -2.51,
  "44907": -1.99,
  "45001": 5.92,
  "45002": 6.44,
  "45003": -10.27,
  "45004": 4.08,
  "45005": 5.37,
  "45011": 4.08,
  "45012": 4.08,
  "45013": 3.53,
  "45014": 3.53,
  "45015": 3.53,
  "45018": 4.08,
  "45030": 5.37,
  "45032": -5.21,
  "45033": 5.92,
  "45034": 14.41,
  "45036": 5.92,
  "45039": 5.92,
  "45040": 7.51,
  "45041": 5.92,
  "45042": 4.08,
  "45044": 3.53,
  "45050": 5.92,
  "45051": 5.92,
  "45052": 6.44,
  "45053": 12.02,
  "45054": 5.92,
  "45055": 3.53,
  "45056": 4.08,
  "45061": 13.86,
  "45062": 3.53,
  "45063": 12.02,
  "45064": 4.08,
  "45065": 5.37,
  "45066": 14.41,
  "45067": 4.08,
  "45068": 5.92,
  "45069": 12.02,
  "45070": 3.53,
  "45071": 12.02,
  "45101": -10.18,
  "45102": -1.38,
  "45103": -1.38,
  "45105": -2.51,
  "45106": -1.9,
  "45107": -5.21,
  "45110": -5.21,
  "45111": 5.92,
  "45112": -6.96,
  "45113": -4.66,
  "45114": -5.21,
  "45115": -10.18,
  "45118": -1.9,
  "45119": -6.96,
  "45120": -6.96,
  "45121": -6.96,
  "45122": -1.9,
  "45123": -6.25,
  "45130": -6.96,
  "45131": -6.96,
  "45132": -4.66,
  "45133": -5.21,
  "45135": -4.66,
  "45138": 9.14,
  "45140": 6.44,
  "45142": -5.21,
  "45144": -2.51,
  "45145": -1.9,
  "45146": -5.21,
  "45147": 5.92,
  "45148": -5.21,
  "45150": -1.38,
  "45152": 5.92,
  "45153": -1.9,
  "45154": -6.96,
  "45155": -6.96,
  "45156": -1.9,
  "45157": -1.38,
  "45158": -1.9,
  "45159": -4.66,
  "45160": -1.9,
  "45162": 5.92,
  "45164": -4.66,
  "45166": 9.14,
  "45167": -6.96,
  "45168": -6.96,
  "45169": 9.14,
  "45171": -6.96,
  "45172": -5.73,
  "45174": 6.59,
  "45176": -1.9,
  "45177": -4.14,
  "45201": 14.41,
  "45202": 14.41,
  "45203": 6.44,
  "45204": 5.92,
  "45205": 5.92,
  "45206": 5.92,
  "45207": 5.92,
  "45208": 14.41,
  "45209": 6.44,
  "45211": 5.92,
  "45212": 5.92,
  "45213": 5.92,
  "45214": 5.92,
  "45215": 5.92,
  "45216": 5.92,
  "45217": 5.92,
  "45218": 5.92,
  "45219": 5.92,
  "45220": 7.51,
  "45222": 5.92,
  "45223": 5.92,
  "45224": 5.92,
  "45225": 5.92,
  "45226": 14.41,
  "45227": 5.92,
  "45228": 6.44,
  "45229": 5.92,
  "45230": 6.44,
  "45231": 5.92,
  "45232": 5.92,
  "45233": 7.51,
  "45234": 7.51,
  "45235": 7.51,
  "45236": 6.44,
  "45237": 5.92,
  "45238": 5.92,
  "45239": 5.92,
  "45240": 5.37,
  "45241": 7.51,
  "45242": 14.41,
  "45243": 14.41,
  "45244": -1.38,
  "45245": -1.38,
  "45246": 5.37,
  "45247": 6.44,
  "45248": 6.44,
  "45249": 14.41,
  "45250": 5.92,
  "45251": 5.92,
  "45252": 13.86,
  "45253": 5.92,
  "45254": 14.41,
  "45255": -1.38,
  "45258": 5.92,
  "45262": 5.92,
  "45275": 5.92,
  "45280": 5.92,
  "45301": 0,
  "45302": 5,
  "45303": 2.03,
  "45304": 2.03,
  "45305": 0,
  "45306": 2.03,
  "45307": -4.66,
  "45308": 2.03,
  "45309": 4.85,
  "45310": -7.17,
  "45311": -10.27,
  "45312": 7.82,
  "45314": 6.9,
  "45315": 4.85,
  "45316": -6.25,
  "45317": -7.11,
  "45318": -0.67,
  "45319": -4.14,
  "45320": -10.27,
  "45321": -11.31,
  "45322": 4.85,
  "45323": -4.14,
  "45324": -0.52,
  "45325": 5.92,
  "45326": -0.67,
  "45327": 5.92,
  "45328": 2.03,
  "45330": -10.27,
  "45331": 2.03,
  "45332": 2.03,
  "45333": 3.93,
  "45334": 3.41,
  "45335": 0,
  "45336": 2.03,
  "45337": -0.67,
  "45338": -10.79,
  "45339": -0.67,
  "45340": 5,
  "45341": -4.66,
  "45342": 4.85,
  "45343": 4.85,
  "45344": -4.66,
  "45345": 4.33,
  "45346": 2.03,
  "45347": -11.31,
  "45348": -7.17,
  "45349": -6.25,
  "45350": -7.17,
  "45351": -7.17,
  "45352": 2.03,
  "45353": 3.41,
  "45354": -1.19,
  "45356": 0.4,
  "45358": 2.03,
  "45359": -0.67,
  "45360": 3.41,
  "45361": -0.67,
  "45362": 2.03,
  "45363": 3.93,
  "45365": 3.93,
  "45368": -5.73,
  "45369": -5.73,
  "45370": 13.34,
  "45371": 0.92,
  "45372": -5.73,
  "45373": 0.92,
  "45377": 4.85,
  "45378": -11.31,
  "45380": 2.55,
  "45381": -10.27,
  "45382": -11.31,
  "45383": -0.67,
  "45384": 8.49,
  "45385": -0.52,
  "45387": 8.49,
  "45388": 11.9,
  "45389": -1.19,
  "45390": 2.03,
  "45400": 4.33,
  "45401": 4.33,
  "45402": 4.85,
  "45403": 4.33,
  "45404": 4.33,
  "45405": 4.33,
  "45406": 4.33,
  "45408": 4.33,
  "45409": 4.85,
  "45410": 4.33,
  "45413": 4.33,
  "45414": 4.33,
  "45415": 4.85,
  "45416": 4.33,
  "45417": 4.33,
  "45418": 4.33,
  "45419": 4.85,
  "45420": 4.33,
  "45422": 4.85,
  "45423": 4.85,
  "45424": 5.92,
  "45426": 4.33,
  "45427": 4.33,
  "45428": 4.33,
  "45429": 4.85,
  "45430": -1.59,
  "45431": 4.33,
  "45432": 4.33,
  "45433": 0,
  "45434": 1.07,
  "45435": 4.33,
  "45437": 4.33,
  "45439": 4.33,
  "45440": 4.85,
  "45441": 13.34,
  "45449": 4.33,
  "45458": 13.34,
  "45459": 13.34,
  "45469": 4.85,
  "45475": 13.34,
  "45479": 4.85,
  "45490": 4.85,
  "45501": -5.73,
  "45502": -5.73,
  "45503": -6.25,
  "45504": -5.73,
  "45505": -6.25,
  "45506": -6.25,
  "45601": -4.6,
  "45612": -4.6,
  "45613": 0.25,
  "45614": -14.93,
  "45616": -11.25,
  "45617": -4.6,
  "45618": -11.25,
  "45619": -0.67,
  "45620": -12.63,
  "45621": -1.9,
  "45622": -12.02,
  "45623": -14.93,
  "45624": -4.66,
  "45628": -4.6,
  "45629": -7.57,
  "45630": -8.09,
  "45631": -14.93,
  "45633": -11.96,
  "45634": -12.02,
  "45636": -7.57,
  "45638": -4.81,
  "45640": -1.38,
  "45642": 0.25,
  "45643": -14.93,
  "45644": -4.6,
  "45645": -4.81,
  "45646": -0.27,
  "45647": -4.6,
  "45648": -7.57,
  "45650": -11.77,
  "45651": -11.5,
  "45652": -7.57,
  "45653": -5.98,
  "45654": -12.02,
  "45656": -2.97,
  "45657": -11.25,
  "45658": -14.93,
  "45659": -5.33,
  "45660": -11.25,
  "45661": 0.25,
  "45662": -7.57,
  "45663": -7.57,
  "45669": 7.82,
  "45671": 0.25,
  "45672": -12.02,
  "45673": -5.12,
  "45674": -6.44,
  "45675": -4.81,
  "45677": -7.57,
  "45678": -4.81,
  "45679": -10.18,
  "45680": -2.05,
  "45681": -4.6,
  "45682": -7.57,
  "45683": 0.25,
  "45684": -11.77,
  "45685": -6.44,
  "45686": -15.45,
  "45687": -7.57,
  "45688": -5.33,
  "45690": 1.84,
  "45692": -1.9,
  "45693": -11.25,
  "45694": -5.98,
  "45695": -12.02,
  "45696": -4.81,
  "45697": -6.96,
  "45698": -12.02,
  "45701": -0.52,
  "45710": -0.52,
  "45711": -8.49,
  "45712": 2.7,
  "45713": -19.13,
  "45714": -8.49,
  "45715": -18.09,
  "45716": -7.42,
  "45717": -7.42,
  "45719": -9.01,
  "45720": -13.15,
  "45721": -18.09,
  "45723": -12.63,
  "45724": -19.13,
  "45727": -17.23,
  "45729": 2.7,
  "45732": -7.42,
  "45734": -17.23,
  "45735": -8.49,
  "45739": -12.63,
  "45740": -9.01,
  "45741": -13.15,
  "45742": -8.49,
  "45743": -13.15,
  "45744": -4.75,
  "45745": -15.12,
  "45746": -17.23,
  "45750": -3.16,
  "45760": -13.15,
  "45761": -9.01,
  "45764": -7.42,
  "45766": -7.42,
  "45767": -5.27,
  "45768": -4.75,
  "45769": -13.15,
  "45770": -12.69,
  "45771": -13.15,
  "45772": -13.15,
  "45773": -3.16,
  "45775": -13.15,
  "45776": -12.63,
  "45777": -8.49,
  "45778": -8.49,
  "45779": -13.15,
  "45780": -0.52,
  "45782": -9.01,
  "45783": -13.15,
  "45784": 2.7,
  "45786": -4.75,
  "45787": 3.74,
  "45788": -4.75,
  "45789": -5.27,
  "45801": -3.03,
  "45802": -3.03,
  "45804": -3.58,
  "45805": -3.03,
  "45806": -3.03,
  "45807": -3.03,
  "45808": -3.58,
  "45809": -3.03,
  "45810": -14.99,
  "45812": -14.99,
  "45813": -11.71,
  "45814": 4.33,
  "45815": -1.78,
  "45816": 4.33,
  "45817": -2.51,
  "45819": 2.03,
  "45820": -3.03,
  "45821": -11.71,
  "45822": -7.17,
  "45826": 1.32,
  "45827": -4.41,
  "45828": -7.17,
  "45830": -4.41,
  "45831": -4.41,
  "45832": -8.03,
  "45833": -8.55,
  "45835": -14.99,
  "45836": -14.99,
  "45837": -4.96,
  "45838": -8.55,
  "45839": 7.51,
  "45840": 7.51,
  "45841": 4.33,
  "45843": -14.99,
  "45844": -4.41,
  "45845": 11.9,
  "45846": 1.32,
  "45848": -4.41,
  "45849": -12.23,
  "45850": -3.03,
  "45851": -11.71,
  "45853": -4.41,
  "45854": -3.03,
  "45855": -12.23,
  "45856": -1.78,
  "45858": 6.96,
  "45859": -15.54,
  "45860": 1.32,
  "45861": -12.78,
  "45862": -7.17,
  "45863": -8.55,
  "45864": 3.74,
  "45865": 11.9,
  "45866": -7.17,
  "45867": 4.33,
  "45868": 4.33,
  "45869": 3.62,
  "45870": -3.95,
  "45871": 2.03,
  "45872": 6.96,
  "45873": -12.78,
  "45874": -8.55,
  "45875": -4.41,
  "45876": -4.41,
  "45877": -4.41,
  "45879": -11.71,
  "45880": -11.71,
  "45881": 4.33,
  "45882": -7.17,
  "45883": -5.58,
  "45884": 2.03,
  "45885": 2.03,
  "45886": -8.55,
  "45887": 2.03,
  "45888": 2.03,
  "45889": 15.45,
  "45890": 6.96,
  "45891": -8.55,
  "45893": -3.03,
  "45894": -8.55,
  "45895": 2.03,
  "45896": -3.03,
  "45897": -15.54,
  "45898": -9.01,
  "45899": -9.01,
  "46001": -2.57,
  "46011": -2.05,
  "46012": -2.57,
  "46013": -2.57,
  "46014": -2.57,
  "46015": -2.57,
  "46016": -2.57,
  "46017": -2.57,
  "46018": -2.57,
  "46030": -4.35,
  "46031": -4.35,
  "46032": 15.33,
  "46033": 15.33,
  "46034": 5.77,
  "46035": 1.23,
  "46036": -4.87,
  "46037": 7.36,
  "46038": 7.36,
  "46039": 1.23,
  "46040": -4.35,
  "46041": 1.78,
  "46044": -2.57,
  "46045": 4.66,
  "46047": -4.35,
  "46048": -4.87,
  "46049": -3.83,
  "46050": 1.23,
  "46051": -2.57,
  "46052": 3.16,
  "46055": -2.76,
  "46056": -7.17,
  "46057": 1.23,
  "46058": 1.78,
  "46060": 13.74,
  "46061": 13.74,
  "46062": 13.74,
  "46063": -2.57,
  "46064": 5.92,
  "46065": -5.58,
  "46067": -6.13,
  "46068": -3.83,
  "46069": 6.84,
  "46070": -9.47,
  "46071": 3.16,
  "46072": -3.83,
  "46074": 7.36,
  "46075": 3.68,
  "46076": -3.83,
  "46077": 11.65,
  "46082": 15.33,
  "46102": 3.16,
  "46103": 0.86,
  "46104": -7.42,
  "46105": -6.5,
  "46106": 1.78,
  "46107": 6.38,
  "46110": 1.38,
  "46111": 1.32,
  "46112": 1.38,
  "46113": 1.32,
  "46115": -8.49,
  "46117": -4.35,
  "46118": 0.86,
  "46120": -5.46,
  "46121": -5.98,
  "46122": 1.38,
  "46123": 1.38,
  "46124": -0.98,
  "46125": 2.36,
  "46126": 0.86,
  "46127": -8.49,
  "46128": -6.5,
  "46129": -2.76,
  "46130": -2.76,
  "46131": 1.78,
  "46133": -20.51,
  "46135": 0.4,
  "46140": -2.76,
  "46142": 2.3,
  "46143": 2.3,
  "46144": -7.42,
  "46146": -7.42,
  "46147": 3.16,
  "46148": -7.17,
  "46149": 0.86,
  "46150": -7.42,
  "46151": 3.95,
  "46154": -2.76,
  "46155": -9.01,
  "46156": -7.42,
  "46157": 1.32,
  "46158": 1.32,
  "46160": -10.77,
  "46161": 0.86,
  "46162": 1.78,
  "46163": -2.76,
  "46164": -10.77,
  "46165": 0.86,
  "46166": 2.36,
  "46167": 1.38,
  "46168": 1.38,
  "46170": 0.4,
  "46171": -6.96,
  "46172": -6.5,
  "46173": -9.01,
  "46175": -11.77,
  "46176": 0.86,
  "46180": -6.5,
  "46181": 11.31,
  "46182": 0.86,
  "46183": 1.32,
  "46184": 1.78,
  "46186": 3.62,
  "46201": 6.38,
  "46202": 6.38,
  "46203": 6.38,
  "46204": 6.9,
  "46205": 6.38,
  "46206": 6.38,
  "46207": 6.38,
  "46208": 6.38,
  "46214": 6.38,
  "46216": 6.9,
  "46217": 6.38,
  "46218": 6.38,
  "46219": 6.38,
  "46220": 6.9,
  "46221": 6.38,
  "46222": 6.38,
  "46224": 6.38,
  "46225": 6.38,
  "46226": 6.38,
  "46227": 6.38,
  "46228": 6.9,
  "46229": 6.38,
  "46230": 6.9,
  "46231": 0.86,
  "46234": 0.86,
  "46235": 6.9,
  "46236": -2.76,
  "46237": 6.38,
  "46239": 6.9,
  "46240": 6.9,
  "46241": 6.38,
  "46242": 6.38,
  "46244": 6.9,
  "46247": 6.38,
  "46250": 7.36,
  "46251": 6.38,
  "46253": 6.38,
  "46254": 6.38,
  "46256": 7.36,
  "46259": 2.3,
  "46260": 6.9,
  "46268": 6.9,
  "46278": 6.9,
  "46280": 7.36,
  "46282": 6.9,
  "46290": 17.63,
  "46301": 6.38,
  "46302": 6.17,
  "46303": 6.63,
  "46304": 6.17,
  "46307": 6.63,
  "46308": 6.63,
  "46310": -3.49,
  "46311": 7.67,
  "46312": 7.15,
  "46319": 6.63,
  "46320": 7.15,
  "46321": 7.67,
  "46322": 7.67,
  "46323": 7.15,
  "46324": 7.15,
  "46325": 7.15,
  "46327": 7.15,
  "46340": -11.25,
  "46341": 6.17,
  "46342": 6.63,
  "46345": -2.11,
  "46346": -2.11,
  "46347": 6.17,
  "46348": -11.77,
  "46349": -4.75,
  "46350": -1.59,
  "46352": -1.59,
  "46355": 6.17,
  "46356": 6.63,
  "46360": -2.11,
  "46361": -2.11,
  "46365": -1.59,
  "46366": -11.77,
  "46368": 6.17,
  "46371": -1.59,
  "46372": -2.45,
  "46373": 8.22,
  "46374": -11.77,
  "46375": 6.63,
  "46376": -5.27,
  "46377": -3.49,
  "46379": -4.75,
  "46380": -11.77,
  "46381": -2.45,
  "46382": -1.59,
  "46383": 6.17,
  "46384": 6.17,
  "46385": 6.17,
  "46390": 6.17,
  "46391": -2.11,
  "46392": -3.49,
  "46393": 6.17,
  "46394": 7.15,
  "46401": 6.63,
  "46402": 6.08,
  "46403": 6.63,
  "46404": 6.08,
  "46405": 6.08,
  "46406": 6.08,
  "46407": 6.08,
  "46408": 6.08,
  "46409": 6.08,
  "46410": 6.63,
  "46411": 6.63,
  "46501": -7.63,
  "46502": -7.97,
  "46504": -6.04,
  "46506": -7.11,
  "46507": -0.61,
  "46508": -7.42,
  "46510": -7.42,
  "46511": -7.63,
  "46513": -7.63,
  "46514": -1.13,
  "46515": -1.13,
  "46516": -1.13,
  "46517": -1.13,
  "46524": -6.04,
  "46526": -0.06,
  "46527": -0.06,
  "46528": -0.06,
  "46530": 7.76,
  "46531": -11.77,
  "46532": -11.77,
  "46534": -11.77,
  "46536": -0.21,
  "46537": -7.63,
  "46538": -6.9,
  "46539": -7.42,
  "46540": 8.43,
  "46542": -7.42,
  "46543": 1.53,
  "46544": -0.73,
  "46545": -0.73,
  "46546": -0.73,
  "46550": -0.06,
  "46552": -0.21,
  "46553": -0.06,
  "46554": -0.21,
  "46555": -7.42,
  "46556": -0.73,
  "46561": -0.21,
  "46562": -7.42,
  "46563": -7.63,
  "46565": 2.91,
  "46567": -6.9,
  "46570": -6.04,
  "46571": -3.99,
  "46572": -7.63,
  "46573": -0.61,
  "46574": -7.63,
  "46580": -7.42,
  "46581": -7.42,
  "46582": -7.42,
  "46590": -7.42,
  "46595": -0.73,
  "46601": -0.73,
  "46613": -0.73,
  "46614": -0.21,
  "46615": -0.73,
  "46616": -0.73,
  "46617": -0.73,
  "46619": -0.73,
  "46624": -0.73,
  "46628": -0.73,
  "46634": -0.73,
  "46635": -0.21,
  "46637": -0.21,
  "46660": -0.21,
  "46680": -0.21,
  "46701": -7.57,
  "46702": -1.13,
  "46703": -8.03,
  "46704": 11.04,
  "46705": -8.03,
  "46706": -5.73,
  "46710": -7.57,
  "46711": -8.49,
  "46713": -1.13,
  "46714": -7.57,
  "46721": -5.73,
  "46723": -0.21,
  "46725": -0.21,
  "46730": -5.73,
  "46731": -5.98,
  "46732": -6.5,
  "46733": -8.49,
  "46737": -8.03,
  "46738": -5.73,
  "46740": -8.49,
  "46741": 2.55,
  "46742": -8.03,
  "46743": -5.73,
  "46745": 2.55,
  "46746": -5.58,
  "46747": -8.03,
  "46748": 2.55,
  "46750": -1.13,
  "46755": -7.57,
  "46759": -8.09,
  "46760": -6.5,
  "46761": -5.58,
  "46763": -5.73,
  "46764": -0.21,
  "46765": 11.04,
  "46766": -7.57,
  "46767": -6.5,
  "46769": -8.49,
  "46770": -1.13,
  "46771": -5.58,
  "46772": -8.49,
  "46773": 2.55,
  "46774": 2.55,
  "46776": -6.96,
  "46777": -7.57,
  "46778": -8.09,
  "46779": -8.03,
  "46780": -8.49,
  "46781": -7.57,
  "46782": -8.49,
  "46783": -1.13,
  "46784": -6.5,
  "46785": -5.73,
  "46786": -5.06,
  "46787": -0.21,
  "46788": 2.76,
  "46789": -8.03,
  "46791": -7.57,
  "46792": -1.13,
  "46793": -5.73,
  "46794": -6.5,
  "46795": -5.06,
  "46796": -7.57,
  "46797": 2.55,
  "46798": 2.55,
  "46799": -1.13,
  "46801": 2.03,
  "46802": 2.03,
  "46803": 2.03,
  "46804": 3.07,
  "46805": 2.03,
  "46806": 2.03,
  "46807": 2.03,
  "46808": 2.03,
  "46809": 2.55,
  "46814": 2.55,
  "46815": 2.55,
  "46816": 2.55,
  "46818": 2.55,
  "46819": 2.55,
  "46825": 2.55,
  "46835": 2.55,
  "46845": 11.04,
  "46850": 2.03,
  "46851": 2.03,
  "46852": 2.03,
  "46853": 2.03,
  "46854": 2.55,
  "46855": 2.03,
  "46856": 2.03,
  "46857": 2.03,
  "46858": 2.03,
  "46859": 2.03,
  "46860": 2.03,
  "46861": 2.03,
  "46862": 2.03,
  "46863": 2.03,
  "46864": 2.03,
  "46865": 2.03,
  "46866": 2.03,
  "46867": 2.03,
  "46868": 2.03,
  "46869": 2.03,
  "46885": 2.55,
  "46895": 2.03,
  "46896": 2.55,
  "46898": -0.21,
  "46899": 2.55,
  "46901": 3.07,
  "46902": 3.07,
  "46903": 3.07,
  "46904": 0.31,
  "46910": -3.28,
  "46911": -2.05,
  "46912": -3.28,
  "46913": -4.54,
  "46914": -1.53,
  "46915": -6.13,
  "46916": -6.65,
  "46917": -6.65,
  "46919": -8.95,
  "46920": -6.13,
  "46921": -1.53,
  "46922": -11.77,
  "46923": -5.58,
  "46926": -1.53,
  "46928": -9.47,
  "46929": -6.13,
  "46930": -10.02,
  "46931": -4.35,
  "46932": 3.07,
  "46933": -9.47,
  "46935": -3.83,
  "46936": 11.56,
  "46937": -3.83,
  "46938": -9.47,
  "46939": -3.83,
  "46940": -8.43,
  "46941": -8.03,
  "46942": -12.11,
  "46943": -8.03,
  "46945": -11.77,
  "46946": -8.55,
  "46947": -0.21,
  "46950": -0.21,
  "46951": -3.83,
  "46952": -8.43,
  "46953": -8.95,
  "46957": -2.2,
  "46958": -1.53,
  "46959": 2.55,
  "46960": -11.77,
  "46961": -2.05,
  "46962": -8.03,
  "46965": 3.07,
  "46967": 0.31,
  "46968": -11.77,
  "46970": -2.05,
  "46971": -1.53,
  "46974": -7.51,
  "46975": -3.28,
  "46977": -5.58,
  "46978": 0.31,
  "46979": 4.66,
  "46980": -8.03,
  "46982": -6.96,
  "46984": -8.43,
  "46985": -18.15,
  "46986": -8.43,
  "46987": -8.95,
  "46988": -0.21,
  "46989": -1.65,
  "46990": -8.03,
  "46991": -9.47,
  "46992": -7.51,
  "46994": 0.31,
  "46995": 4.66,
  "46996": -17.63,
  "46998": -0.21,
  "47001": -11.56,
  "47003": -3.37,
  "47006": -9.72,
  "47010": -3.37,
  "47011": -11.56,
  "47012": -10.73,
  "47016": -10.73,
  "47017": -11.56,
  "47018": -11.56,
  "47019": -3.07,
  "47020": -11.56,
  "47021": -9.72,
  "47022": -9.14,
  "47023": -9.72,
  "47024": -10.73,
  "47025": 6.44,
  "47030": -10.73,
  "47031": -9.72,
  "47032": -9.72,
  "47033": -9.72,
  "47034": -10.27,
  "47035": -10.73,
  "47036": -10.18,
  "47037": -10.27,
  "47038": -11.56,
  "47039": -9.72,
  "47040": -11.56,
  "47041": -9.72,
  "47042": -9.72,
  "47043": -11.56,
  "47060": -10.18,
  "47102": -12.48,
  "47104": -8.8,
  "47106": 0,
  "47107": -8.8,
  "47108": -8.8,
  "47110": -12.48,
  "47111": -5.58,
  "47112": -11.96,
  "47114": -12.48,
  "47115": -14.78,
  "47116": -14.78,
  "47117": -12.48,
  "47118": -14.78,
  "47119": 7.97,
  "47120": -8.8,
  "47122": 7.97,
  "47123": -14.78,
  "47124": 7.97,
  "47125": -14.78,
  "47126": -11.96,
  "47129": -0.52,
  "47130": -5.58,
  "47131": -5.58,
  "47135": -6.5,
  "47136": -10.89,
  "47137": -14.78,
  "47138": -12.48,
  "47139": -12.48,
  "47140": -14.78,
  "47141": -5.06,
  "47142": -12.48,
  "47143": -5.06,
  "47145": -14.78,
  "47146": 7.97,
  "47147": -8.8,
  "47150": -0.52,
  "47151": -0.52,
  "47160": -12.48,
  "47161": -12.48,
  "47162": -8.8,
  "47163": -5.06,
  "47164": -8.8,
  "47165": 7.97,
  "47166": -12.48,
  "47167": -8.8,
  "47170": -12.48,
  "47172": -5.06,
  "47174": -15.33,
  "47175": -14.78,
  "47177": -11.96,
  "47201": 0.06,
  "47202": 0.06,
  "47203": 1.65,
  "47220": -1.32,
  "47223": -1.9,
  "47224": -11.56,
  "47225": -10.18,
  "47226": -0.46,
  "47227": -1.9,
  "47228": -1.32,
  "47229": -12.48,
  "47230": -12.48,
  "47231": -8.8,
  "47232": 0.06,
  "47234": -7.88,
  "47235": -1.32,
  "47236": 0.06,
  "47240": -7.88,
  "47243": -8.8,
  "47244": -0.98,
  "47245": -0.86,
  "47246": -0.98,
  "47247": -0.46,
  "47249": -5.92,
  "47250": -8.8,
  "47260": -1.84,
  "47261": -7.88,
  "47263": -8.43,
  "47264": -5.92,
  "47265": -0.86,
  "47270": -12.48,
  "47272": -7.88,
  "47273": -0.86,
  "47274": -1.32,
  "47280": 0.06,
  "47281": -1.32,
  "47282": -1.9,
  "47283": -6.84,
  "47302": -7.72,
  "47303": -7.17,
  "47304": -7.17,
  "47305": -7.72,
  "47307": -7.72,
  "47308": -7.72,
  "47320": -7.17,
  "47322": -8.49,
  "47324": -11.19,
  "47325": -19.47,
  "47326": -13.15,
  "47327": -12.23,
  "47330": -12.23,
  "47331": -19.47,
  "47334": -2.57,
  "47335": -12.23,
  "47336": -1.65,
  "47337": -7.17,
  "47338": -1.65,
  "47339": -12.23,
  "47340": 6.17,
  "47341": -12.23,
  "47342": -7.17,
  "47344": -7.17,
  "47345": -12.23,
  "47346": -12.23,
  "47348": -1.65,
  "47351": -7.17,
  "47352": -7.17,
  "47353": -3.37,
  "47354": -7.17,
  "47355": 6.17,
  "47356": -6.65,
  "47357": -20.51,
  "47358": -12.23,
  "47359": -1.65,
  "47360": -7.17,
  "47361": -7.17,
  "47362": -7.17,
  "47366": -7.17,
  "47367": 1.32,
  "47368": -7.17,
  "47369": -13.7,
  "47370": -12.23,
  "47371": -13.15,
  "47373": -13.15,
  "47374": -11.19,
  "47375": -11.19,
  "47380": 5.62,
  "47381": -13.7,
  "47382": 5.62,
  "47383": -7.17,
  "47384": -6.65,
  "47385": -7.17,
  "47386": 1.32,
  "47387": -7.17,
  "47388": -7.17,
  "47390": 6.17,
  "47392": -12.78,
  "47393": -12.23,
  "47394": 6.17,
  "47396": 1.32,
  "47401": 8.09,
  "47402": 8.09,
  "47403": -0.4,
  "47404": -0.4,
  "47405": 8.09,
  "47406": 8.09,
  "47407": 8.09,
  "47408": 8.09,
  "47420": -5.92,
  "47421": -5.92,
  "47424": -9.14,
  "47426": 8.09,
  "47427": -11.77,
  "47429": -0.4,
  "47430": -6.44,
  "47431": -10.98,
  "47432": -4.14,
  "47433": -11.5,
  "47434": -5.92,
  "47435": -10.77,
  "47436": -5.92,
  "47437": -6.44,
  "47438": 2.95,
  "47439": -9.14,
  "47441": -11.77,
  "47443": -9.66,
  "47445": -11.77,
  "47446": -6.44,
  "47448": -3.87,
  "47449": -9.66,
  "47451": -6.44,
  "47452": -4.14,
  "47453": -9.14,
  "47454": -4.66,
  "47455": -11.77,
  "47456": -10.98,
  "47457": -9.14,
  "47458": 8.09,
  "47459": -0.4,
  "47460": -10.98,
  "47462": -5.92,
  "47463": -0.4,
  "47464": -11.5,
  "47465": -9.66,
  "47467": -5.92,
  "47468": -10.77,
  "47469": -4.14,
  "47470": -6.44,
  "47471": -9.66,
  "47501": -3.16,
  "47512": -3.95,
  "47513": -1.07,
  "47514": -3.83,
  "47515": -3.83,
  "47516": -3.95,
  "47519": -9.14,
  "47520": -3.83,
  "47521": 7.42,
  "47522": -9.66,
  "47523": -11.65,
  "47524": -0.73,
  "47525": -3.83,
  "47527": 0.52,
  "47528": -5.79,
  "47529": -3.68,
  "47531": -3.83,
  "47532": 0.52,
  "47535": -3.95,
  "47536": -4.35,
  "47537": 0.52,
  "47541": -1.59,
  "47542": -1.07,
  "47545": -1.07,
  "47546": 6.9,
  "47547": 6.9,
  "47550": -3.16,
  "47551": -3.83,
  "47552": -11.65,
  "47553": -9.66,
  "47556": -4.35,
  "47557": -3.43,
  "47558": -3.16,
  "47561": -3.95,
  "47562": -9.14,
  "47564": 2.55,
  "47567": 2.55,
  "47568": -3.68,
  "47573": -3.95,
  "47574": -4.35,
  "47575": 7.42,
  "47576": -15.33,
  "47577": 0.52,
  "47578": -9.66,
  "47579": -3.16,
  "47580": -1.07,
  "47581": -9.66,
  "47584": 2.55,
  "47585": 2.03,
  "47586": -3.83,
  "47588": -3.83,
  "47590": 2.55,
  "47591": -3.43,
  "47596": -3.68,
  "47597": -3.43,
  "47598": 2.55,
  "47601": -1.13,
  "47610": -1.13,
  "47611": -11.65,
  "47612": -0.21,
  "47613": -1.13,
  "47614": -12.17,
  "47615": -11.65,
  "47616": -6.65,
  "47617": -0.61,
  "47618": 5.52,
  "47619": -1.13,
  "47620": 1.84,
  "47629": 7.36,
  "47630": 7.36,
  "47631": -6.65,
  "47633": -6.65,
  "47634": -0.61,
  "47635": -7.51,
  "47637": -12.17,
  "47638": 1.84,
  "47639": 8.28,
  "47640": -0.73,
  "47647": -0.21,
  "47648": -0.21,
  "47649": -0.21,
  "47654": -0.73,
  "47660": 2.55,
  "47665": -0.21,
  "47666": -0.73,
  "47670": -0.21,
  "47683": -0.73,
  "47701": 5.52,
  "47702": -3.49,
  "47703": -3.49,
  "47704": -3.49,
  "47705": -3.49,
  "47706": -3.49,
  "47708": 5.52,
  "47710": -2.97,
  "47711": -2.97,
  "47712": -2.97,
  "47713": -3.49,
  "47714": -2.97,
  "47715": 5.52,
  "47716": 5.52,
  "47719": -2.97,
  "47720": -1.38,
  "47724": -2.97,
  "47725": -3.49,
  "47728": -2.97,
  "47730": 5.52,
  "47731": 5.52,
  "47732": 5.52,
  "47733": 5.52,
  "47734": 5.52,
  "47735": 5.52,
  "47736": -3.49,
  "47737": 5.52,
  "47801": 0.1,
  "47802": 1.17,
  "47803": 0.65,
  "47804": 0.65,
  "47805": 0.65,
  "47807": 0.1,
  "47808": 0.65,
  "47830": 2.09,
  "47831": 1.57,
  "47832": -11.77,
  "47833": -15.45,
  "47834": -15.45,
  "47836": -11.77,
  "47837": -15.45,
  "47838": 2.95,
  "47840": -13.86,
  "47841": -15.45,
  "47842": 1.57,
  "47845": 2.95,
  "47846": -13.86,
  "47847": 1.57,
  "47848": 2.95,
  "47849": 4.54,
  "47850": 2.95,
  "47851": 0.65,
  "47852": 2.95,
  "47853": -15.45,
  "47854": 1.57,
  "47855": 2.4,
  "47857": -15.45,
  "47858": 11.44,
  "47859": -11.77,
  "47860": 2.09,
  "47861": 2.95,
  "47862": 1.57,
  "47863": 0.65,
  "47865": 2.95,
  "47866": 2.95,
  "47868": -13.09,
  "47869": 1.17,
  "47870": 1.17,
  "47871": 1.17,
  "47872": 1.57,
  "47874": -11.77,
  "47875": 1.57,
  "47876": 0.65,
  "47878": -15.45,
  "47879": 2.95,
  "47880": 0.65,
  "47881": -15.45,
  "47882": 2.95,
  "47884": 1.57,
  "47885": 0.1,
  "47901": -1.44,
  "47902": -1.99,
  "47903": -1.99,
  "47904": -1.99,
  "47905": -1.44,
  "47906": 7.05,
  "47907": -1.44,
  "47909": -1.44,
  "47916": 1.23,
  "47917": -9.35,
  "47918": -7.51,
  "47920": 7.05,
  "47921": -9.35,
  "47922": -5.27,
  "47923": -11.56,
  "47924": -1.99,
  "47925": -12.11,
  "47926": -12.11,
  "47928": 1.57,
  "47929": -11.56,
  "47930": 1.78,
  "47932": -3.83,
  "47933": 1.78,
  "47940": 1.78,
  "47941": -1.44,
  "47942": -9.35,
  "47943": 6.04,
  "47944": -9.35,
  "47946": -17.63,
  "47948": -9.35,
  "47949": -3.83,
  "47950": -12.11,
  "47951": -5.27,
  "47952": -4.87,
  "47954": 1.78,
  "47955": 1.78,
  "47957": -18.67,
  "47958": -3.83,
  "47959": -12.11,
  "47960": -11.56,
  "47962": -8.8,
  "47963": -5.27,
  "47964": -5.27,
  "47965": 1.23,
  "47966": 1.02,
  "47967": 1.78,
  "47968": 1.78,
  "47969": -3.83,
  "47970": -8.8,
  "47971": -9.35,
  "47974": -2.76,
  "47975": -8.8,
  "47977": -8.8,
  "47978": -2.45,
  "47980": -12.11,
  "47981": 7.05,
  "47982": -4.2,
  "47983": -1.99,
  "47984": -9.35,
  "47986": -9.35,
  "47987": -3.83,
  "47988": 1.23,
  "47989": -11.77,
  "47990": 1.23,
  "47991": -7.51,
  "47992": -1.44,
  "47993": -7.51,
  "47994": -3.83,
  "47995": -11.56,
  "47996": 7.05,
  "47997": -11.56,
  "48001": 4.08,
  "48002": 12.57,
  "48003": 1.63,
  "48004": 3.53,
  "48005": 3.01,
  "48006": 4.08,
  "48007": 9.45,
  "48009": 13.34,
  "48012": 13.34,
  "48014": 2.7,
  "48015": 4.79,
  "48017": 8.93,
  "48021": 4.79,
  "48022": 4.08,
  "48023": 3.53,
  "48025": 11.04,
  "48026": 4.79,
  "48027": 4.08,
  "48028": 5.31,
  "48030": 8.01,
  "48032": 4.08,
  "48033": 8.93,
  "48034": 8.93,
  "48035": 4.79,
  "48036": 4.79,
  "48037": 8.93,
  "48038": 5.31,
  "48039": 4.08,
  "48040": 4.08,
  "48041": 4.08,
  "48042": 5.31,
  "48043": 4.79,
  "48044": 5.31,
  "48045": 5.31,
  "48046": 4.79,
  "48047": 5.31,
  "48048": 5.83,
  "48049": 4.08,
  "48050": 5.31,
  "48051": 5.31,
  "48054": 12.57,
  "48059": 4.08,
  "48060": 4.08,
  "48061": 4.08,
  "48062": 4.08,
  "48063": 4.08,
  "48064": 4.08,
  "48065": 5.31,
  "48066": 4.79,
  "48067": 8.01,
  "48068": 8.01,
  "48069": 16.5,
  "48070": 17.42,
  "48071": 4.79,
  "48072": 8.93,
  "48073": 9.45,
  "48074": 4.08,
  "48075": 8.53,
  "48076": 9.45,
  "48079": 4.08,
  "48080": 4.79,
  "48081": 4.79,
  "48082": 4.79,
  "48083": 5.31,
  "48084": 9.45,
  "48085": 9.45,
  "48086": 8.93,
  "48088": 4.79,
  "48089": 4.79,
  "48090": 4.79,
  "48091": 4.79,
  "48092": 4.79,
  "48093": 4.79,
  "48094": 5.31,
  "48095": 5.31,
  "48096": 5.31,
  "48097": -5.12,
  "48098": 9.45,
  "48099": 5.31,
  "48101": 10.64,
  "48103": 5.73,
  "48104": 5.73,
  "48105": 13.7,
  "48106": 5.21,
  "48107": 5.73,
  "48108": 5.21,
  "48109": 13.7,
  "48110": 2.09,
  "48111": 5.21,
  "48112": 5.21,
  "48113": 5.73,
  "48114": 8.95,
  "48115": 5.21,
  "48116": 8.95,
  "48117": 4.2,
  "48118": 5.73,
  "48120": 10.64,
  "48121": 10.64,
  "48122": 10.64,
  "48123": 10.64,
  "48124": 10.64,
  "48125": 10.64,
  "48126": 10.64,
  "48127": 10.64,
  "48128": 10.64,
  "48130": 6.8,
  "48131": 2.09,
  "48133": 2.09,
  "48134": 4.2,
  "48135": 10.64,
  "48136": 10.64,
  "48137": 8.43,
  "48138": 19.13,
  "48139": 8.43,
  "48140": 3.68,
  "48141": 10.64,
  "48143": 8.95,
  "48144": 3.99,
  "48145": 2.61,
  "48146": 10.64,
  "48150": 10.64,
  "48151": 11.19,
  "48152": 11.19,
  "48153": 10.64,
  "48154": 11.19,
  "48157": 2.09,
  "48158": 5.21,
  "48159": 4.75,
  "48160": 5.21,
  "48161": 2.09,
  "48162": 4.2,
  "48164": 4.75,
  "48165": 8.43,
  "48166": 4.2,
  "48167": 20.05,
  "48168": 20.05,
  "48169": 8.95,
  "48170": 12.23,
  "48173": 4.2,
  "48174": 10.64,
  "48175": 20.05,
  "48176": 5.73,
  "48177": 3.99,
  "48178": 8.95,
  "48179": 4.2,
  "48180": 10.64,
  "48182": 3.99,
  "48183": 10.64,
  "48184": 10.64,
  "48185": 10.64,
  "48186": 10.64,
  "48187": 11.19,
  "48188": 11.19,
  "48189": 8.43,
  "48190": 5.21,
  "48191": 5.21,
  "48192": 10.64,
  "48193": 10.64,
  "48195": 10.64,
  "48197": 5.21,
  "48198": 5.21,
  "48201": 8.01,
  "48202": 8.01,
  "48203": 8.01,
  "48204": 8.01,
  "48205": 4.79,
  "48206": 8.01,
  "48207": 8.01,
  "48208": 8.01,
  "48209": 10.12,
  "48210": 8.01,
  "48211": 8.01,
  "48212": 8.01,
  "48213": 8.01,
  "48214": 8.01,
  "48215": 8.01,
  "48216": 8.01,
  "48217": 10.64,
  "48218": 8.01,
  "48219": 10.64,
  "48220": 8.01,
  "48221": 8.01,
  "48223": 10.64,
  "48224": 4.79,
  "48225": 4.79,
  "48226": 8.01,
  "48227": 8.01,
  "48228": 10.64,
  "48229": 10.64,
  "48230": 13.28,
  "48231": 8.01,
  "48232": 8.01,
  "48233": 8.01,
  "48234": 8.01,
  "48235": 8.01,
  "48236": 13.28,
  "48237": 8.01,
  "48238": 8.01,
  "48239": 10.64,
  "48240": 10.64,
  "48242": 10.64,
  "48243": 8.01,
  "48244": 8.01,
  "48301": 20.24,
  "48302": 20.24,
  "48303": 20.24,
  "48304": 20.24,
  "48306": 20.24,
  "48307": 5.31,
  "48308": 5.31,
  "48309": 9.45,
  "48310": 5.31,
  "48311": 5.31,
  "48312": 5.31,
  "48313": 5.31,
  "48314": 5.31,
  "48315": 5.31,
  "48316": 5.31,
  "48317": 5.31,
  "48318": 5.31,
  "48320": 9.45,
  "48321": 8.93,
  "48322": 9.45,
  "48323": 11.04,
  "48324": 9.45,
  "48325": 9.45,
  "48326": 8.93,
  "48327": 9.45,
  "48328": 8.93,
  "48329": 9.45,
  "48330": 9.45,
  "48331": 9.45,
  "48332": 9.45,
  "48333": 9.45,
  "48334": 9.45,
  "48335": 9.45,
  "48336": 11.56,
  "48340": 8.93,
  "48341": 8.93,
  "48342": 8.93,
  "48343": 8.93,
  "48346": 9.45,
  "48347": 9.45,
  "48348": 9.45,
  "48350": 9.45,
  "48353": 5.77,
  "48356": 9.45,
  "48357": 5.25,
  "48359": 9.45,
  "48360": 9.45,
  "48361": 9.45,
  "48362": 9.45,
  "48363": 9.45,
  "48366": 1.63,
  "48367": 1.63,
  "48370": 9.45,
  "48371": 9.45,
  "48374": 20.24,
  "48375": 9.45,
  "48376": 9.45,
  "48377": 9.45,
  "48380": 5.77,
  "48381": 5.77,
  "48382": 9.45,
  "48383": 9.45,
  "48386": 9.45,
  "48387": 9.45,
  "48390": 9.45,
  "48391": 9.45,
  "48393": 9.45,
  "48401": -5.12,
  "48410": -5.67,
  "48411": 10.52,
  "48412": 1.11,
  "48413": -5.73,
  "48414": -8.09,
  "48415": 5.25,
  "48416": -5.12,
  "48417": 5.25,
  "48418": -8.09,
  "48419": -5.12,
  "48420": 2.03,
  "48421": 1.11,
  "48422": -5.12,
  "48423": 2.03,
  "48426": -6.19,
  "48427": -5.67,
  "48428": 1.63,
  "48429": -8.09,
  "48430": 10.52,
  "48432": -5.73,
  "48433": 2.03,
  "48434": -5.67,
  "48435": 1.11,
  "48436": -8.09,
  "48437": 2.03,
  "48438": 10.52,
  "48439": 2.03,
  "48440": 0.56,
  "48441": -5.21,
  "48442": 2.03,
  "48444": 1.11,
  "48445": -5.73,
  "48446": 1.11,
  "48449": -8.64,
  "48450": -5.12,
  "48451": 3.62,
  "48453": -5.12,
  "48454": -5.12,
  "48455": 1.63,
  "48456": -5.67,
  "48457": 4.7,
  "48458": 1.48,
  "48460": -8.09,
  "48461": 1.11,
  "48462": 2.55,
  "48463": 2.03,
  "48464": 1.11,
  "48465": -5.67,
  "48466": -5.12,
  "48467": -5.73,
  "48468": -5.73,
  "48469": -5.12,
  "48470": -5.21,
  "48471": -5.67,
  "48472": -5.67,
  "48473": 2.03,
  "48475": -5.73,
  "48476": -8.64,
  "48480": 2.03,
  "48501": 2.03,
  "48502": 1.48,
  "48503": 1.48,
  "48504": 1.48,
  "48505": 1.48,
  "48506": 1.48,
  "48507": 1.48,
  "48509": 2.03,
  "48519": 1.48,
  "48529": 1.48,
  "48531": 1.48,
  "48532": 2.03,
  "48601": 4.7,
  "48602": 4.7,
  "48603": 5.25,
  "48604": 4.7,
  "48605": 5.25,
  "48606": 4.7,
  "48607": 4.7,
  "48608": 5.25,
  "48609": 5.25,
  "48610": -6.9,
  "48611": -3.16,
  "48612": -5,
  "48613": -5.52,
  "48614": -10.39,
  "48615": -8.28,
  "48616": 5.25,
  "48617": -7.76,
  "48618": -1.38,
  "48619": -10.98,
  "48620": -0.86,
  "48621": -10.98,
  "48622": -7.76,
  "48623": 7.88,
  "48624": -5,
  "48625": -8.28,
  "48626": 5.25,
  "48627": -2.24,
  "48628": -0.86,
  "48629": -2.24,
  "48630": -2.76,
  "48631": -5.27,
  "48632": -8.28,
  "48633": -7.76,
  "48634": -5.27,
  "48635": -6.38,
  "48636": -11.5,
  "48637": -7.76,
  "48638": 5.25,
  "48640": -0.86,
  "48641": -0.86,
  "48642": -0.86,
  "48647": -11.5,
  "48649": -8.09,
  "48650": -5.27,
  "48651": -2.24,
  "48652": -5,
  "48653": -2.24,
  "48654": -6.38,
  "48655": 5.25,
  "48656": -2.76,
  "48657": -0.86,
  "48658": -2.11,
  "48659": 0,
  "48661": -6.38,
  "48662": -8.28,
  "48701": -7.17,
  "48703": -1.59,
  "48705": -17.23,
  "48706": -5.27,
  "48707": -5.27,
  "48708": -5.79,
  "48720": -6.25,
  "48721": -8.74,
  "48722": 5.25,
  "48723": -6.65,
  "48724": 4.7,
  "48725": -5.73,
  "48726": -6.65,
  "48727": -7.17,
  "48728": -17.23,
  "48729": -6.65,
  "48730": 2.55,
  "48731": -6.25,
  "48732": -5.27,
  "48733": -7.17,
  "48734": 13.74,
  "48735": -6.25,
  "48736": -7.17,
  "48737": -17.75,
  "48738": -8.74,
  "48739": 2.55,
  "48740": -17.23,
  "48741": -7.17,
  "48742": -17.23,
  "48743": -8.49,
  "48744": -7.17,
  "48745": -17.23,
  "48746": -7.17,
  "48747": -5.27,
  "48748": 2.55,
  "48749": -2.11,
  "48750": 2.55,
  "48754": -6.25,
  "48755": -5.73,
  "48756": -6.9,
  "48757": -6.65,
  "48758": -6.65,
  "48759": -7.17,
  "48760": -7.17,
  "48761": -8.49,
  "48762": -17.23,
  "48763": 2.55,
  "48764": 2.55,
  "48765": -2.11,
  "48766": -2.11,
  "48767": -6.65,
  "48768": -7.72,
  "48769": -7.72,
  "48770": -2.11,
  "48801": -7.76,
  "48804": 2.36,
  "48805": 16.46,
  "48806": -7.21,
  "48807": -7.76,
  "48808": 4.75,
  "48809": 1.69,
  "48811": -9.87,
  "48812": -4.08,
  "48813": -2.05,
  "48815": 2.24,
  "48816": -8.09,
  "48817": -8.09,
  "48818": -4.08,
  "48819": 7.97,
  "48820": 10.58,
  "48821": -2.05,
  "48822": 4.75,
  "48823": 7.97,
  "48824": 5.31,
  "48825": 7.97,
  "48826": 7.97,
  "48827": -2.05,
  "48829": -4.08,
  "48830": -8.28,
  "48831": 4.75,
  "48832": -7.76,
  "48833": -7.21,
  "48834": 1.69,
  "48835": 2.09,
  "48836": 8.43,
  "48837": -2.05,
  "48838": -5.67,
  "48840": 7.97,
  "48841": -8.09,
  "48842": 5.31,
  "48843": 8.43,
  "48844": 8.43,
  "48845": 1.17,
  "48846": 1.69,
  "48847": -7.76,
  "48848": 4.75,
  "48849": 2.24,
  "48850": -5.67,
  "48851": 1.17,
  "48852": -5.67,
  "48853": 4.2,
  "48854": 5.31,
  "48855": 8.43,
  "48856": -7.76,
  "48857": -4.91,
  "48858": 2.36,
  "48860": 1.17,
  "48861": -2.05,
  "48862": -7.76,
  "48863": 8.43,
  "48864": 16.46,
  "48865": 1.69,
  "48866": 4.75,
  "48867": -4.91,
  "48870": 1.69,
  "48871": -7.21,
  "48872": -4.91,
  "48873": 1.17,
  "48874": -7.76,
  "48875": 1.17,
  "48876": -2.05,
  "48877": -8.28,
  "48878": 2.36,
  "48879": 4.75,
  "48880": -8.28,
  "48881": 2.24,
  "48882": -4.91,
  "48883": 2.36,
  "48884": -5.67,
  "48885": -5.67,
  "48886": -5.67,
  "48887": 1.69,
  "48888": -5.67,
  "48889": -8.28,
  "48890": -2.05,
  "48891": -4.6,
  "48892": 7.97,
  "48893": 2.36,
  "48894": 2.09,
  "48895": 7.97,
  "48896": 1.84,
  "48897": -7.11,
  "48901": 5.31,
  "48906": 4.79,
  "48908": 5.31,
  "48909": 5.31,
  "48910": 4.79,
  "48911": 5.31,
  "48912": 4.79,
  "48915": 4.79,
  "48917": 5.31,
  "48924": 4.79,
  "48933": 5.31,
  "49001": 3.53,
  "49002": 3.53,
  "49003": 12.02,
  "49004": 3.53,
  "49005": 3.01,
  "49006": 3.53,
  "49007": 3.53,
  "49008": 3.53,
  "49009": 12.02,
  "49010": 0,
  "49011": -9.47,
  "49012": 11.5,
  "49013": -8.18,
  "49014": 2.95,
  "49015": 3.47,
  "49016": 2.95,
  "49017": 2.95,
  "49018": 2.95,
  "49019": 3.53,
  "49020": 2.95,
  "49021": 3.47,
  "49022": -2.2,
  "49023": -1.65,
  "49024": 3.53,
  "49026": -6.59,
  "49027": -8.18,
  "49028": -9.47,
  "49029": 3.47,
  "49030": 2.09,
  "49031": -6.65,
  "49032": 2.09,
  "49033": 11.96,
  "49034": 3.01,
  "49035": -7.11,
  "49036": -8.95,
  "49037": 3.47,
  "49038": -7.63,
  "49039": -7.63,
  "49040": 1.57,
  "49041": 3.01,
  "49042": 2.09,
  "49043": -8.18,
  "49045": -8.18,
  "49046": -7.11,
  "49047": -7.72,
  "49048": 3.01,
  "49050": -7.11,
  "49051": 3.47,
  "49052": 3.01,
  "49053": 3.53,
  "49055": -6.59,
  "49056": -7.11,
  "49057": -8.18,
  "49058": -7.11,
  "49060": 1.38,
  "49061": -6.65,
  "49062": -6.59,
  "49063": -7.11,
  "49064": -7.63,
  "49065": -6.59,
  "49066": 2.09,
  "49067": -6.13,
  "49068": 3.47,
  "49070": -1.07,
  "49071": 3.53,
  "49072": 2.09,
  "49073": -7.11,
  "49074": 3.01,
  "49075": 2.09,
  "49076": -2.05,
  "49077": 12.02,
  "49078": -1.07,
  "49079": -6.59,
  "49080": 3.53,
  "49081": 3.53,
  "49082": -8.95,
  "49083": 12.02,
  "49084": -7.63,
  "49085": -1.65,
  "49087": 3.53,
  "49088": 3.53,
  "49089": -9.47,
  "49090": -7.63,
  "49091": 3.16,
  "49092": -9.47,
  "49093": 2.09,
  "49094": -9.47,
  "49095": -6.65,
  "49096": -2.05,
  "49097": 3.53,
  "49098": -8.18,
  "49099": 3.16,
  "49101": -1.65,
  "49102": -1.65,
  "49103": -1.65,
  "49106": -1.65,
  "49107": -1.65,
  "49111": -1.65,
  "49112": -6.65,
  "49113": -1.65,
  "49115": 6.84,
  "49116": 9.14,
  "49117": 6.38,
  "49119": -1.65,
  "49120": -0.73,
  "49125": -1.65,
  "49126": -2.2,
  "49127": -1.65,
  "49128": -1.13,
  "49129": -1.65,
  "49130": 7.36,
  "49201": 0.71,
  "49202": 0.19,
  "49203": 0.19,
  "49204": 0.71,
  "49220": -7.11,
  "49221": -7.11,
  "49224": 2.95,
  "49227": -13.55,
  "49228": -7.11,
  "49229": -4.45,
  "49230": 0.71,
  "49232": -13.55,
  "49233": 9.2,
  "49234": 9.2,
  "49235": -7.11,
  "49236": -4.45,
  "49237": 0.71,
  "49238": -7.11,
  "49239": -13.55,
  "49240": 9.2,
  "49241": 0.71,
  "49242": -14.07,
  "49245": 2.95,
  "49246": 0.71,
  "49247": -13.55,
  "49248": -7.11,
  "49249": 0.71,
  "49250": -14.07,
  "49251": 5.31,
  "49252": -14.07,
  "49253": -7.11,
  "49254": 0.71,
  "49255": -14.07,
  "49256": 11.29,
  "49257": 0.71,
  "49258": -14.07,
  "49259": 0.71,
  "49261": 0.71,
  "49262": -14.07,
  "49263": 0.19,
  "49264": 5.31,
  "49265": 1.38,
  "49266": -13.55,
  "49267": 3.47,
  "49268": -7.11,
  "49269": 0.71,
  "49270": 2.61,
  "49271": -14.07,
  "49272": 0.71,
  "49274": -14.07,
  "49276": 3.47,
  "49277": 0.71,
  "49279": -7.11,
  "49281": 9.2,
  "49282": 0.71,
  "49283": 0.71,
  "49284": -2.57,
  "49285": 5.77,
  "49286": -4.45,
  "49287": -5.52,
  "49288": -14.07,
  "49289": -7.11,
  "49301": 16.25,
  "49302": 16.25,
  "49303": -9.47,
  "49304": -14.07,
  "49305": -4.14,
  "49306": 7.76,
  "49307": -6.25,
  "49309": -14.07,
  "49310": 2.36,
  "49311": -0.52,
  "49312": -9.47,
  "49314": 0,
  "49315": 7.76,
  "49316": 9.35,
  "49317": 7.76,
  "49318": 7.76,
  "49319": 7.76,
  "49320": -5.21,
  "49321": 7.76,
  "49322": -5.67,
  "49323": 0,
  "49325": -6.04,
  "49326": -5.12,
  "49327": -9.47,
  "49328": 0,
  "49329": -5.67,
  "49330": 7.76,
  "49331": 7.76,
  "49332": -5.21,
  "49333": -6.04,
  "49335": -0.52,
  "49336": -5.21,
  "49337": -9.47,
  "49338": -6.25,
  "49339": -5.12,
  "49340": 2.36,
  "49341": 7.76,
  "49342": -5.21,
  "49343": -5.12,
  "49344": -6.59,
  "49345": 7.76,
  "49346": -4.66,
  "49347": -5.67,
  "49348": -0.52,
  "49349": -9.47,
  "49401": 5,
  "49402": -14.07,
  "49403": 7.76,
  "49404": 5,
  "49405": -7.63,
  "49406": 0.52,
  "49408": 0,
  "49409": 13.28,
  "49410": -7.63,
  "49411": -7.63,
  "49412": -9.47,
  "49415": 5.31,
  "49416": 0,
  "49417": 11.9,
  "49418": 7.76,
  "49419": 0.52,
  "49420": -9.93,
  "49421": -9.93,
  "49422": 5.52,
  "49423": 5.52,
  "49424": 6.04,
  "49425": 4.79,
  "49426": 5,
  "49427": 5,
  "49428": 5,
  "49429": 5,
  "49430": 5,
  "49431": -7.63,
  "49434": 16.83,
  "49435": 7.76,
  "49436": -9.41,
  "49437": 5.31,
  "49440": 4.79,
  "49441": 4.79,
  "49442": 4.79,
  "49443": 4.79,
  "49444": 4.79,
  "49445": 5.31,
  "49446": -9.93,
  "49448": 11.9,
  "49449": -9.41,
  "49450": 0,
  "49451": 5.31,
  "49452": -9.93,
  "49453": 0.52,
  "49454": -7.63,
  "49455": -9.93,
  "49456": 13.28,
  "49457": 5.31,
  "49458": -7.63,
  "49459": -9.93,
  "49460": 5.52,
  "49461": 6.38,
  "49463": 6.38,
  "49464": 6.04,
  "49468": 7.76,
  "49501": 7.21,
  "49503": 7.21,
  "49504": 7.21,
  "49505": 7.76,
  "49506": 7.76,
  "49507": 7.21,
  "49508": 7.76,
  "49509": 7.21,
  "49510": 7.76,
  "49512": 7.76,
  "49514": 7.21,
  "49515": 7.21,
  "49516": 16.25,
  "49518": 7.76,
  "49519": 7.21,
  "49523": 7.21,
  "49525": 7.76,
  "49528": 7.76,
  "49534": 7.76,
  "49544": 7.76,
  "49546": 16.25,
  "49548": 7.21,
  "49588": 7.21,
  "49599": 7.21,
  "49601": -9.14,
  "49610": 7.63,
  "49611": -9.2,
  "49612": -8.68,
  "49613": -11.25,
  "49614": -11.25,
  "49615": -8.68,
  "49616": -6.71,
  "49617": -4.6,
  "49618": -11.77,
  "49619": -11.77,
  "49620": -2.97,
  "49621": -7.36,
  "49622": -8.68,
  "49623": -14.07,
  "49625": -11.77,
  "49626": -11.77,
  "49627": -8.68,
  "49628": -5.12,
  "49629": -0.19,
  "49630": -4.6,
  "49631": 6.9,
  "49632": -4.14,
  "49633": 12.02,
  "49634": -11.77,
  "49635": -4.6,
  "49636": 0.61,
  "49637": -2.97,
  "49638": -11.77,
  "49639": 4.79,
  "49640": -4.6,
  "49642": -14.07,
  "49643": -6.19,
  "49644": -11.77,
  "49645": -11.77,
  "49646": 12.02,
  "49648": -0.19,
  "49649": -0.86,
  "49650": 1.78,
  "49651": -3.62,
  "49653": 0.61,
  "49654": 0.61,
  "49655": 7.42,
  "49656": -14.07,
  "49657": -3.62,
  "49659": -9.2,
  "49660": -11.77,
  "49663": -9.14,
  "49664": -7.36,
  "49665": 6.9,
  "49666": -0.86,
  "49667": -4.14,
  "49668": -11.77,
  "49670": 1.65,
  "49673": -0.19,
  "49674": 1.65,
  "49675": -11.25,
  "49676": 12.02,
  "49677": 4.79,
  "49679": 6.9,
  "49680": 11.5,
  "49682": 1.65,
  "49683": -6.71,
  "49684": -0.86,
  "49685": -2.97,
  "49686": -0.86,
  "49688": 7.42,
  "49689": -11.77,
  "49690": 7.63,
  "49696": -0.86,
  "49701": -10.52,
  "49705": 4.6,
  "49706": -2.7,
  "49707": -11.71,
  "49709": -10.98,
  "49710": 7.36,
  "49711": -2.7,
  "49712": -5,
  "49713": -5,
  "49715": 7.88,
  "49716": -2.7,
  "49717": -2.7,
  "49718": -2.7,
  "49719": 7.88,
  "49720": -5,
  "49721": 5.12,
  "49722": -2.7,
  "49723": 5.79,
  "49724": 7.88,
  "49725": 7.88,
  "49726": 7.88,
  "49727": -5,
  "49728": -6.96,
  "49729": -5,
  "49730": -9.2,
  "49733": -14.72,
  "49734": -1.78,
  "49735": -1.78,
  "49736": 7.88,
  "49737": 5.79,
  "49738": -14.2,
  "49740": 5.79,
  "49743": -15.58,
  "49744": -11.71,
  "49745": 7.88,
  "49746": -11.71,
  "49747": -17.23,
  "49748": -6.96,
  "49749": 5.12,
  "49751": -1.78,
  "49752": -5.92,
  "49753": -11.71,
  "49755": -2.7,
  "49756": -10.98,
  "49757": -2.03,
  "49759": -15.58,
  "49760": -10.52,
  "49761": 5.12,
  "49762": -11.56,
  "49764": 5.79,
  "49765": -16.1,
  "49766": -11.71,
  "49768": -6.96,
  "49769": -2.7,
  "49770": -2.7,
  "49774": 7.88,
  "49775": 13.61,
  "49776": -17.69,
  "49777": -3.22,
  "49779": -16.1,
  "49780": -11.04,
  "49781": -10.52,
  "49782": -11.04,
  "49783": 7.36,
  "49788": 7.36,
  "49790": -5.92,
  "49791": 4.6,
  "49792": 4.6,
  "49793": -10.52,
  "49795": -1.78,
  "49796": -5,
  "49797": -14.72,
  "49799": 4.6,
  "49801": 4.08,
  "49802": 4.08,
  "49805": -13.95,
  "49806": -5.52,
  "49807": -7.42,
  "49808": -6.5,
  "49812": -7.42,
  "49814": -7.05,
  "49815": 3.53,
  "49816": -6.04,
  "49817": -12.02,
  "49818": -2.82,
  "49819": 4.08,
  "49820": -12.02,
  "49821": -7.42,
  "49822": -6.04,
  "49825": -5.52,
  "49826": -6.04,
  "49827": -6.96,
  "49829": -2.82,
  "49831": 4.08,
  "49833": -6.5,
  "49834": 4.08,
  "49835": -2.82,
  "49836": -12.02,
  "49837": -2.82,
  "49838": -12.02,
  "49839": -6.96,
  "49840": -12.02,
  "49841": -6.5,
  "49845": -7.42,
  "49847": -7.42,
  "49848": -7.42,
  "49849": -6.5,
  "49852": 4.08,
  "49853": -6.96,
  "49854": -12.02,
  "49855": -6.5,
  "49858": -9.26,
  "49861": 9.51,
  "49862": -6.04,
  "49863": -7.42,
  "49864": -2.82,
  "49865": -6.5,
  "49866": -6.5,
  "49868": -6.96,
  "49870": 4.08,
  "49871": -6.5,
  "49872": -2.82,
  "49873": 4.08,
  "49874": -7.42,
  "49876": 4.08,
  "49877": 4.08,
  "49878": -2.82,
  "49879": -7.05,
  "49880": -2.82,
  "49881": 4.08,
  "49883": -6.96,
  "49884": -6.04,
  "49885": -6.5,
  "49886": -7.42,
  "49887": -7.42,
  "49891": -6.04,
  "49892": 4.08,
  "49893": -7.42,
  "49894": -2.82,
  "49895": -6.04,
  "49896": -7.42,
  "49901": -13.95,
  "49902": -14.87,
  "49903": -14.87,
  "49905": -6.13,
  "49908": 10.06,
  "49910": -19.47,
  "49911": -11.77,
  "49912": -19.47,
  "49913": -6.13,
  "49915": -14.87,
  "49916": -5.58,
  "49917": -13.95,
  "49918": -13.4,
  "49919": 9.51,
  "49920": -14.32,
  "49921": -6.13,
  "49922": -5.58,
  "49925": -19.47,
  "49927": -14.87,
  "49929": -19.47,
  "49930": -5.58,
  "49931": -5.58,
  "49934": -6.13,
  "49935": -14.87,
  "49938": -11.31,
  "49942": -13.95,
  "49945": -6.13,
  "49946": 10.06,
  "49947": -10.73,
  "49948": -19.47,
  "49950": -13.95,
  "49952": -18.92,
  "49953": -20.51,
  "49955": -6.13,
  "49958": -5.58,
  "49959": -11.77,
  "49960": -19.47,
  "49961": -14.87,
  "49962": 10.06,
  "49963": -6.13,
  "49964": -14.87,
  "49965": -6.13,
  "49967": -19.47,
  "49968": -11.77,
  "49969": -5.58,
  "49970": 9.51,
  "49971": -20.51,
  "50001": -1.99,
  "50002": 0.31,
  "50003": -5.67,
  "50005": -8.28,
  "50006": -5.52,
  "50007": 12.48,
  "50008": -15.85,
  "50009": 3.99,
  "50010": 8.8,
  "50014": 8.8,
  "50020": 1.17,
  "50021": 12.48,
  "50022": 1.17,
  "50023": 12.48,
  "50025": -11.71,
  "50026": -0.21,
  "50027": -6.44,
  "50028": 3.07,
  "50029": -0.21,
  "50031": -2.45,
  "50032": 3.47,
  "50033": -9.41,
  "50034": -9.66,
  "50035": 3.99,
  "50036": -2.45,
  "50037": -2.45,
  "50038": -6.19,
  "50039": -5.67,
  "50040": -2.97,
  "50041": 2.7,
  "50042": -11.71,
  "50043": -5.52,
  "50044": -7.97,
  "50046": 0.31,
  "50047": -1.99,
  "50048": 0.31,
  "50049": -11.19,
  "50050": -11.25,
  "50051": -8.28,
  "50052": -15.85,
  "50054": 3.07,
  "50055": 0.31,
  "50056": 0.31,
  "50057": -2.45,
  "50058": -4.29,
  "50059": -11.25,
  "50060": -11.71,
  "50061": 12.48,
  "50062": -2.45,
  "50063": -5.67,
  "50064": -11.25,
  "50065": -15.85,
  "50066": -5.67,
  "50067": -15.85,
  "50068": -11.19,
  "50069": -5.67,
  "50070": -8.89,
  "50071": -11.1,
  "50072": -8.89,
  "50073": 3.99,
  "50074": -8.43,
  "50075": -10.73,
  "50076": -11.71,
  "50078": -9.87,
  "50099": -2.45,
  "50101": -10.58,
  "50102": -7.11,
  "50103": -15.85,
  "50104": -9.2,
  "50105": 0.31,
  "50106": -9.35,
  "50107": -11.25,
  "50108": -15.85,
  "50109": 2.82,
  "50110": -11.71,
  "50111": 3.99,
  "50112": 6.29,
  "50115": 0.31,
  "50116": -8.49,
  "50117": -11.71,
  "50118": -1.99,
  "50119": -2.97,
  "50120": -9.35,
  "50122": -5.52,
  "50123": -11.71,
  "50124": 0.31,
  "50125": -1.99,
  "50126": -5.52,
  "50127": 3.07,
  "50128": -10.73,
  "50129": -10.73,
  "50130": -10.73,
  "50131": 12.48,
  "50132": -11.25,
  "50133": -15.85,
  "50134": 0.31,
  "50135": 3.07,
  "50136": -9.2,
  "50137": 3.07,
  "50138": -2.45,
  "50139": -11.19,
  "50140": -15.33,
  "50141": -9.35,
  "50142": -8.28,
  "50143": -7.51,
  "50144": -15.85,
  "50145": -1.99,
  "50146": 0.31,
  "50147": -15.85,
  "50148": -8.28,
  "50149": -8.95,
  "50150": -8.49,
  "50151": -11.19,
  "50152": -2.45,
  "50153": 6.29,
  "50154": 0.31,
  "50155": -9.41,
  "50156": -2.45,
  "50157": 7.88,
  "50158": -8.28,
  "50160": -1.99,
  "50161": 0.31,
  "50162": -9.35,
  "50163": -2.45,
  "50164": 0.31,
  "50165": -11.71,
  "50166": -1.99,
  "50167": -5.67,
  "50168": 3.07,
  "50169": 3.99,
  "50170": 3.07,
  "50171": 7.88,
  "50173": -5.98,
  "50174": -18.55,
  "50201": 0.31,
  "50206": -5.52,
  "50207": -7.51,
  "50208": 3.07,
  "50210": -18.55,
  "50211": -1.99,
  "50212": -2.45,
  "50213": -18.55,
  "50214": -2.45,
  "50216": 0.31,
  "50217": -11.25,
  "50218": -9.41,
  "50219": -0.86,
  "50220": -5.67,
  "50222": -8.89,
  "50223": -2.97,
  "50225": -2.45,
  "50226": 3.99,
  "50227": 2.7,
  "50228": 3.07,
  "50229": -1.99,
  "50230": -6.59,
  "50231": -11.25,
  "50232": 3.07,
  "50233": -5.67,
  "50234": -9.35,
  "50235": -11.25,
  "50236": 0.31,
  "50237": 12.48,
  "50238": -11.19,
  "50239": -9.35,
  "50240": -2.51,
  "50241": -2.51,
  "50242": 6.29,
  "50243": 0.31,
  "50244": 0.31,
  "50246": -10.73,
  "50247": -9.35,
  "50248": 0.31,
  "50249": -10.73,
  "50250": 0.31,
  "50251": 3.07,
  "50252": -1.99,
  "50254": -8.43,
  "50255": -9.2,
  "50256": -2.45,
  "50257": -18.55,
  "50258": -8.28,
  "50259": -8.28,
  "50261": -8.89,
  "50262": -15.85,
  "50263": 2.82,
  "50264": -19.07,
  "50265": 12.48,
  "50266": 12.48,
  "50268": -9.2,
  "50269": -8.28,
  "50271": -9.66,
  "50272": -11.71,
  "50273": -8.89,
  "50274": 1.17,
  "50275": -18.55,
  "50276": -5.67,
  "50277": 0.31,
  "50278": 0.31,
  "50301": 3.47,
  "50302": 3.47,
  "50303": 3.47,
  "50304": 3.47,
  "50305": 3.47,
  "50306": 3.47,
  "50307": 3.99,
  "50308": 3.99,
  "50309": 3.99,
  "50310": 3.99,
  "50311": 3.99,
  "50312": 3.99,
  "50313": 3.99,
  "50314": 3.47,
  "50315": 3.99,
  "50316": 3.99,
  "50317": 3.99,
  "50318": 3.99,
  "50319": 3.99,
  "50320": 3.99,
  "50321": 12.48,
  "50322": 12.48,
  "50323": 12.48,
  "50324": 3.99,
  "50325": 12.48,
  "50327": 3.99,
  "50333": 3.99,
  "50340": 3.99,
  "50393": 3.99,
  "50394": 3.99,
  "50395": 3.47,
  "50401": 2.3,
  "50402": 2.3,
  "50420": 3.22,
  "50421": -10.58,
  "50423": -5.98,
  "50424": -5.98,
  "50426": -2.3,
  "50427": 3.22,
  "50428": 10.79,
  "50430": -6.5,
  "50431": 2.7,
  "50432": -6.5,
  "50433": 3.22,
  "50434": -9.66,
  "50435": -2.76,
  "50436": -5.98,
  "50438": -5.98,
  "50439": -6.5,
  "50440": -9.66,
  "50441": 3.22,
  "50444": -9.66,
  "50446": -9.66,
  "50447": -5.98,
  "50448": -9.66,
  "50449": 3.89,
  "50450": -5.98,
  "50451": 9.2,
  "50452": 3.22,
  "50453": -5.98,
  "50454": -2.3,
  "50455": -2.3,
  "50456": -9.66,
  "50457": -6.5,
  "50458": -2.76,
  "50459": -9.66,
  "50460": 6.19,
  "50461": -2.3,
  "50464": -9.66,
  "50465": -8.74,
  "50466": -7.36,
  "50467": -9.66,
  "50468": -2.76,
  "50469": 2.3,
  "50470": -11.1,
  "50471": -2.76,
  "50472": -2.3,
  "50473": -5.98,
  "50475": 3.22,
  "50476": -2.3,
  "50477": 2.3,
  "50478": -5.98,
  "50479": 2.3,
  "50480": 9.2,
  "50481": -2.3,
  "50482": 3.89,
  "50483": 9.2,
  "50484": -5.98,
  "50501": -0.15,
  "50510": -0.67,
  "50511": 9.2,
  "50514": -7.82,
  "50515": -8.09,
  "50516": -4.29,
  "50517": 9.2,
  "50518": -0.15,
  "50519": -4.81,
  "50520": -4.81,
  "50521": -0.15,
  "50522": 9.2,
  "50523": -0.15,
  "50524": -0.15,
  "50525": -10.58,
  "50527": -7.57,
  "50528": -7.57,
  "50529": -4.29,
  "50530": -0.15,
  "50531": -8.34,
  "50532": -0.15,
  "50533": -10.58,
  "50535": -10.33,
  "50536": -7.57,
  "50538": -9.41,
  "50539": 8.68,
  "50540": -4.41,
  "50541": -3.89,
  "50542": -10.58,
  "50543": -0.15,
  "50544": -0.15,
  "50545": -3.22,
  "50546": -4.41,
  "50548": -4.29,
  "50551": -9.41,
  "50552": -9.41,
  "50554": -3.89,
  "50556": 9.2,
  "50557": -0.15,
  "50558": -3.22,
  "50559": 8.68,
  "50560": -3.74,
  "50561": -9.41,
  "50562": -8.09,
  "50563": -8.89,
  "50565": -1.19,
  "50566": -0.15,
  "50567": -10.33,
  "50568": -0.67,
  "50569": -0.67,
  "50570": -4.81,
  "50571": -3.89,
  "50573": -4.41,
  "50574": -3.89,
  "50575": -9.41,
  "50576": -1.19,
  "50577": -3.74,
  "50578": 8.68,
  "50579": -8.89,
  "50581": -4.41,
  "50582": -4.29,
  "50583": -10.33,
  "50585": -0.67,
  "50586": -9.41,
  "50588": -0.67,
  "50590": 9.2,
  "50591": -4.81,
  "50592": -1.19,
  "50593": -4.41,
  "50594": -0.15,
  "50595": -10.73,
  "50597": -7.57,
  "50598": 9.2,
  "50599": -11.65,
  "50601": -5.52,
  "50602": -6.9,
  "50603": -9.66,
  "50604": -6.9,
  "50605": 2.7,
  "50606": -3.03,
  "50607": -9.47,
  "50608": -6.9,
  "50609": 5.06,
  "50611": -6.9,
  "50612": 6.38,
  "50613": 8.49,
  "50616": -2.76,
  "50619": -6.9,
  "50620": -2.76,
  "50621": 5.06,
  "50622": 1.13,
  "50623": -1.59,
  "50624": 13.55,
  "50625": -6.9,
  "50626": -1.59,
  "50627": -5.52,
  "50628": -7.36,
  "50629": -8.95,
  "50630": -9.66,
  "50631": -7.36,
  "50632": -5.98,
  "50633": 3.22,
  "50634": -1.59,
  "50635": -5.98,
  "50636": -6.9,
  "50638": 5.06,
  "50641": -9.47,
  "50642": 5.06,
  "50643": 6.38,
  "50644": -9.47,
  "50645": -9.66,
  "50647": 1.13,
  "50648": -8.95,
  "50649": -6.9,
  "50650": -9.47,
  "50651": -1.59,
  "50652": 4.54,
  "50653": -2.76,
  "50654": -8.03,
  "50655": -3.03,
  "50657": 5.06,
  "50658": -9.66,
  "50659": -9.66,
  "50660": -6.9,
  "50661": -9.66,
  "50662": -3.03,
  "50664": -3.03,
  "50665": -6.9,
  "50666": -7.36,
  "50667": -1.59,
  "50668": -8.95,
  "50669": 5.06,
  "50670": -5.31,
  "50671": -9.47,
  "50672": -5.52,
  "50673": -6.9,
  "50674": -9.47,
  "50675": -8.09,
  "50676": -7.36,
  "50677": 1.13,
  "50680": 5.06,
  "50681": -3.03,
  "50682": -9.47,
  "50701": -1.59,
  "50702": -2.11,
  "50703": -2.11,
  "50704": -1.59,
  "50706": -2.11,
  "50707": -2.11,
  "50801": -8.43,
  "50830": -8.43,
  "50831": -8.43,
  "50833": -17.75,
  "50835": -17.23,
  "50836": -17.75,
  "50837": -0.21,
  "50839": -11.71,
  "50840": -17.23,
  "50841": -17.23,
  "50842": -8.43,
  "50843": 1.17,
  "50845": -8.95,
  "50846": -0.21,
  "50847": -11.71,
  "50848": -17.23,
  "50849": 0.31,
  "50851": -17.23,
  "50853": 1.17,
  "50854": -15.85,
  "50857": -11.71,
  "50858": -0.21,
  "50859": -8.95,
  "50860": -17.23,
  "50861": -8.95,
  "50862": -17.23,
  "50863": -8.95,
  "50864": -11.71,
  "51001": -7.57,
  "51002": -0.67,
  "51003": 12.67,
  "51004": -1.59,
  "51005": -6.19,
  "51006": -2.05,
  "51007": 6.9,
  "51008": -7.57,
  "51009": -6.19,
  "51010": -8.95,
  "51011": 12.67,
  "51012": -6.19,
  "51014": -6.19,
  "51015": 6.9,
  "51016": -2.05,
  "51018": -2.05,
  "51019": -2.05,
  "51020": -2.05,
  "51022": -10.79,
  "51023": 12.67,
  "51024": 0.92,
  "51025": -2.05,
  "51026": -1.59,
  "51027": 12.67,
  "51028": -7.57,
  "51029": -6.19,
  "51030": 6.9,
  "51031": -5.98,
  "51033": -1.19,
  "51034": -8.95,
  "51035": -6.19,
  "51036": 12.67,
  "51037": -6.19,
  "51038": -7.57,
  "51039": 0,
  "51040": -8.95,
  "51041": 21.16,
  "51044": -8.95,
  "51045": -7.57,
  "51046": -10.79,
  "51047": -8.49,
  "51048": -6.19,
  "51049": -6.19,
  "51050": -7.57,
  "51051": -9.47,
  "51052": 0,
  "51053": -10.33,
  "51054": 6.9,
  "51055": -1.59,
  "51056": -8.95,
  "51058": -11.31,
  "51060": -8.95,
  "51061": -6.19,
  "51062": 0.92,
  "51063": -8.95,
  "51101": -2.11,
  "51102": 6.9,
  "51103": -1.59,
  "51104": 6.9,
  "51105": -1.59,
  "51106": -1.59,
  "51108": -1.59,
  "51109": -1.59,
  "51111": -1.59,
  "51201": -9.2,
  "51230": -5.52,
  "51231": -10.79,
  "51232": -13.4,
  "51234": 14.26,
  "51235": -5.52,
  "51237": -6.04,
  "51238": -10.79,
  "51239": 14.26,
  "51240": -0.92,
  "51241": -4.45,
  "51242": -5.52,
  "51243": -13.4,
  "51244": 14.26,
  "51245": -10.79,
  "51246": -5.52,
  "51247": 14.26,
  "51248": -9.2,
  "51249": -12.88,
  "51250": 21.16,
  "51301": -8.49,
  "51331": 0.92,
  "51333": -8.49,
  "51334": -7.82,
  "51338": -8.49,
  "51340": -8.49,
  "51341": -9.01,
  "51342": -9.41,
  "51343": -9.01,
  "51345": -13.4,
  "51346": -10.79,
  "51347": 0.92,
  "51350": -13.4,
  "51351": 1.99,
  "51354": -13.4,
  "51355": 9.41,
  "51357": -8.49,
  "51358": -7.57,
  "51360": 9.41,
  "51363": 0.4,
  "51364": 0.4,
  "51365": -9.41,
  "51366": -8.49,
  "51401": -4.29,
  "51430": -4.29,
  "51431": -2.05,
  "51432": -4.81,
  "51433": -10.33,
  "51436": -4.81,
  "51439": 5.31,
  "51440": -4.81,
  "51441": 5.31,
  "51442": 5.83,
  "51443": -4.29,
  "51444": -4.81,
  "51445": -2.05,
  "51446": -14.01,
  "51447": -14.01,
  "51448": 5.31,
  "51449": -8.89,
  "51450": -10.33,
  "51451": -4.81,
  "51452": -4.81,
  "51453": -9.41,
  "51454": 5.31,
  "51455": -4.81,
  "51458": -10.33,
  "51459": -11.25,
  "51460": 5.31,
  "51461": 5.31,
  "51462": -11.25,
  "51463": -4.29,
  "51465": 5.31,
  "51466": -10.33,
  "51467": -4.81,
  "51501": 0.71,
  "51502": 0.71,
  "51503": 9.2,
  "51510": 0.71,
  "51520": 5.31,
  "51521": -13.49,
  "51523": -8.95,
  "51525": 1.23,
  "51526": 9.2,
  "51527": -14.01,
  "51528": 5.31,
  "51529": -9.41,
  "51530": -13.49,
  "51531": -11.19,
  "51532": -11.71,
  "51533": -11.71,
  "51534": 16.56,
  "51535": 1.17,
  "51536": 1.23,
  "51537": -13.49,
  "51540": 8.07,
  "51541": 8.07,
  "51542": 9.2,
  "51543": -11.71,
  "51544": 1.17,
  "51545": -8.89,
  "51546": -8.89,
  "51548": 9.2,
  "51549": 8.59,
  "51550": -8.89,
  "51551": 8.59,
  "51552": 1.17,
  "51553": 2.3,
  "51554": 16.56,
  "51555": -8.89,
  "51556": -8.34,
  "51557": -8.34,
  "51558": -8.95,
  "51559": 1.23,
  "51560": 1.23,
  "51561": 8.59,
  "51562": -14.01,
  "51563": -8.89,
  "51564": -8.34,
  "51565": -13.49,
  "51566": -11.71,
  "51570": -13.49,
  "51571": 8.59,
  "51572": -8.95,
  "51573": -11.71,
  "51575": 1.23,
  "51576": 9.2,
  "51577": 1.69,
  "51578": -14.01,
  "51579": -8.89,
  "51591": -11.71,
  "51593": -13.49,
  "51601": -16.77,
  "51630": -16.77,
  "51631": -16.77,
  "51632": -16.77,
  "51636": -16.77,
  "51637": -16.77,
  "51638": -16.77,
  "51639": -15.85,
  "51640": -15.85,
  "51645": -15.33,
  "51646": -17.23,
  "51647": -16.77,
  "51648": -15.33,
  "51649": -15.85,
  "51650": -15.85,
  "51651": -16.77,
  "51652": -15.85,
  "51653": 8.59,
  "51654": -15.85,
  "51656": -16.77,
  "52001": 2.15,
  "52002": 10.64,
  "52003": 2.7,
  "52004": 2.15,
  "52030": -6.59,
  "52031": -6.04,
  "52032": 2.7,
  "52033": -1.44,
  "52035": -0.15,
  "52036": -7.51,
  "52037": -7.51,
  "52038": -8.03,
  "52039": 10.64,
  "52040": -6.96,
  "52041": -7.51,
  "52042": -0.15,
  "52043": -0.15,
  "52044": -0.15,
  "52045": 2.15,
  "52046": 2.7,
  "52047": -0.15,
  "52048": -0.15,
  "52049": -0.15,
  "52050": -7.51,
  "52052": -0.15,
  "52053": 2.7,
  "52054": 2.7,
  "52056": 2.15,
  "52057": -6.96,
  "52060": -6.59,
  "52064": -6.59,
  "52065": -6.96,
  "52066": 2.15,
  "52068": 10.64,
  "52069": -6.59,
  "52070": -7.51,
  "52071": -6.59,
  "52072": -0.15,
  "52073": 2.7,
  "52074": -6.04,
  "52075": -6.59,
  "52076": -0.15,
  "52077": -1.19,
  "52078": -6.96,
  "52079": 1.9,
  "52101": -1.07,
  "52132": -2.11,
  "52133": -1.07,
  "52134": -7.36,
  "52135": -3.03,
  "52136": -7.36,
  "52140": -10.79,
  "52141": -3.03,
  "52142": -3.03,
  "52144": -2.11,
  "52146": -13.49,
  "52147": -3.03,
  "52149": -1.07,
  "52151": -10.27,
  "52154": -9.66,
  "52155": -7.36,
  "52156": -10.27,
  "52157": -0.15,
  "52158": -0.15,
  "52159": -10.27,
  "52160": -10.79,
  "52161": -2.11,
  "52162": -10.27,
  "52163": -7.36,
  "52164": -3.03,
  "52165": -1.07,
  "52166": -2.11,
  "52168": -2.11,
  "52169": -3.03,
  "52170": -10.27,
  "52171": -11.77,
  "52172": -10.27,
  "52175": -3.03,
  "52201": -5.92,
  "52202": 0.86,
  "52203": 0.4,
  "52205": -1.44,
  "52206": -4.66,
  "52207": -6.59,
  "52208": -5.21,
  "52209": -4.66,
  "52210": -9.47,
  "52211": 6.84,
  "52212": -1.99,
  "52213": 0.86,
  "52214": 0.86,
  "52215": -7.05,
  "52216": -6.84,
  "52217": -8.09,
  "52218": -6.96,
  "52219": -1.99,
  "52220": 0.4,
  "52221": 6.84,
  "52222": 7.88,
  "52223": -6.96,
  "52224": -7.57,
  "52225": -8.09,
  "52227": 0.86,
  "52228": 0.86,
  "52229": -6.25,
  "52231": -8.68,
  "52232": 6.84,
  "52233": 0.86,
  "52235": -5.92,
  "52236": 9.93,
  "52237": -6.96,
  "52240": 7.63,
  "52241": 7.63,
  "52242": 7.63,
  "52244": 7.63,
  "52245": 7.63,
  "52246": 7.63,
  "52247": -4.33,
  "52248": -8.68,
  "52249": -4.66,
  "52251": -0.15,
  "52252": -1.44,
  "52253": -7.88,
  "52254": -7.11,
  "52255": -8.95,
  "52257": -4.66,
  "52301": 0.4,
  "52302": 0.86,
  "52305": -1.44,
  "52306": -6.84,
  "52307": 0.4,
  "52308": 0.92,
  "52309": -6.59,
  "52310": -1.44,
  "52312": -1.99,
  "52313": -6.25,
  "52314": 0.86,
  "52315": -4.66,
  "52316": 1.44,
  "52317": -0.86,
  "52318": -4.66,
  "52319": 7.63,
  "52320": -1.44,
  "52321": -1.99,
  "52322": 7.63,
  "52323": -2.51,
  "52324": 0.86,
  "52325": 1.44,
  "52326": -8.43,
  "52327": -5.92,
  "52328": 9.35,
  "52329": -7.88,
  "52330": -6.96,
  "52332": -4.66,
  "52333": 7.63,
  "52334": 0.4,
  "52335": -8.68,
  "52336": 0.86,
  "52337": -6.84,
  "52338": 6.59,
  "52339": -8.09,
  "52340": 7.63,
  "52341": 2.45,
  "52342": -8.09,
  "52344": -7.88,
  "52345": -4.66,
  "52346": -4.66,
  "52347": 0.4,
  "52348": -8.09,
  "52349": -4.66,
  "52350": 0.86,
  "52351": -4.66,
  "52352": -7.88,
  "52353": -5.92,
  "52354": -4.66,
  "52355": -8.68,
  "52356": -5.92,
  "52358": -0.86,
  "52359": -6.44,
  "52361": 1.44,
  "52362": -1.99,
  "52401": 0.31,
  "52402": 0.86,
  "52403": 0.86,
  "52404": 0.86,
  "52405": 0.86,
  "52406": 0.86,
  "52407": 0.31,
  "52408": 0.86,
  "52409": 0.86,
  "52410": 0.86,
  "52411": 9.35,
  "52501": -1.78,
  "52530": -1.78,
  "52531": -7.97,
  "52533": -6.84,
  "52534": -8.03,
  "52535": -14.2,
  "52536": -3.37,
  "52537": -6.84,
  "52540": -6.84,
  "52542": -14.72,
  "52543": -5.92,
  "52544": -12.17,
  "52548": -2.3,
  "52549": -12.17,
  "52550": -9.2,
  "52551": -14.72,
  "52552": -6.84,
  "52553": -7.51,
  "52554": -2.3,
  "52555": -11.65,
  "52556": -6.84,
  "52560": -6.84,
  "52561": -5.92,
  "52562": -8.68,
  "52563": -8.68,
  "52565": -14.2,
  "52566": -2.3,
  "52567": -6.84,
  "52568": -8.68,
  "52569": -7.97,
  "52570": -14.72,
  "52571": -11.65,
  "52572": -12.17,
  "52573": -14.72,
  "52574": -12.17,
  "52576": -8.68,
  "52577": -7.51,
  "52580": -6.84,
  "52581": -11.65,
  "52583": -12.17,
  "52584": -7.36,
  "52585": -6.84,
  "52586": -8.68,
  "52588": -14.2,
  "52590": -12.17,
  "52591": -8.68,
  "52593": -11.65,
  "52594": -11.65,
  "52595": -7.51,
  "52601": -4.35,
  "52619": 0.52,
  "52620": -14.72,
  "52621": -5.92,
  "52623": -2.24,
  "52624": 0.52,
  "52625": 0.52,
  "52626": -14.2,
  "52627": 0.52,
  "52630": -14.2,
  "52631": -8.22,
  "52632": -0.21,
  "52635": -8.22,
  "52637": -3.83,
  "52638": -4.35,
  "52639": 0.52,
  "52640": -13.28,
  "52641": -8.22,
  "52642": -8.22,
  "52644": -8.22,
  "52645": -8.22,
  "52646": -15.39,
  "52647": -8.22,
  "52648": -8.22,
  "52649": -8.22,
  "52650": 4.14,
  "52651": -14.72,
  "52652": -8.22,
  "52653": -14.87,
  "52654": -8.22,
  "52655": -3.83,
  "52656": 0.52,
  "52657": -8.22,
  "52658": -3.83,
  "52659": -13.28,
  "52660": -2.76,
  "52701": -8.03,
  "52720": -5.92,
  "52721": -8.43,
  "52722": 8.8,
  "52726": 9.26,
  "52727": -7.51,
  "52728": 7.67,
  "52729": -7.51,
  "52730": -8.03,
  "52731": -7.51,
  "52732": -8.03,
  "52733": -8.03,
  "52737": -13.28,
  "52738": -13.28,
  "52739": -13.28,
  "52742": -7.51,
  "52745": 7.67,
  "52746": 7.67,
  "52747": -7.51,
  "52748": 9.26,
  "52749": 2.57,
  "52750": -7.51,
  "52751": -8.03,
  "52752": -13.28,
  "52753": 8.8,
  "52754": -13.28,
  "52755": -0.86,
  "52756": -5.92,
  "52757": -7.51,
  "52758": -8.03,
  "52759": 9.26,
  "52760": -5.92,
  "52761": -7.51,
  "52765": 0.06,
  "52766": -5.92,
  "52767": 0.31,
  "52768": 8.22,
  "52769": 7.67,
  "52771": -8.03,
  "52772": -6.84,
  "52773": 7.67,
  "52774": -8.03,
  "52776": -5.92,
  "52777": -8.95,
  "52778": -7.51,
  "52801": 7.15,
  "52802": 7.15,
  "52803": 7.67,
  "52804": 7.15,
  "52805": 7.67,
  "52806": 7.67,
  "52807": 16.16,
  "52808": 7.15,
  "52809": 7.15,
  "53001": -1.53,
  "53002": 0.06,
  "53003": 7.42,
  "53004": -0.98,
  "53005": 5.83,
  "53006": 18,
  "53007": 5.83,
  "53008": 5.83,
  "53010": 10.06,
  "53011": -1.53,
  "53012": -1.53,
  "53013": -0.98,
  "53014": -0.92,
  "53015": -2.91,
  "53016": 7.42,
  "53017": 0.61,
  "53018": 19.13,
  "53019": 9.51,
  "53020": -0.98,
  "53021": 0.06,
  "53022": -1.53,
  "53023": -1.53,
  "53024": -1.53,
  "53026": -1.53,
  "53027": 0.06,
  "53029": 11.19,
  "53031": -1.53,
  "53032": 7.42,
  "53033": 0.61,
  "53034": 7.42,
  "53035": 7.42,
  "53036": 1.9,
  "53037": -1.53,
  "53038": 1.9,
  "53039": 7.42,
  "53040": -0.98,
  "53042": -1.53,
  "53044": -0.98,
  "53045": 11.19,
  "53046": 10.64,
  "53047": 1.9,
  "53048": 9.51,
  "53049": 10.06,
  "53050": 5.83,
  "53051": 9.05,
  "53052": 9.05,
  "53056": 11.19,
  "53057": 9.51,
  "53058": 19.68,
  "53059": 7.42,
  "53060": 0.06,
  "53061": -1.99,
  "53063": -2.91,
  "53064": 11.19,
  "53065": 10.06,
  "53066": 11.19,
  "53069": 19.13,
  "53070": -1.53,
  "53072": 11.19,
  "53073": -1.53,
  "53074": -1.53,
  "53075": -0.98,
  "53076": 0.61,
  "53078": 0.06,
  "53079": 9.51,
  "53080": -1.53,
  "53081": -1.53,
  "53082": -0.98,
  "53083": -1.53,
  "53085": -1.53,
  "53086": 0.61,
  "53088": -1.44,
  "53089": 11.19,
  "53090": -1.53,
  "53091": 0.06,
  "53092": 6.96,
  "53093": -1.53,
  "53094": 1.9,
  "53095": -1.53,
  "53097": 6.96,
  "53098": 7.42,
  "53099": 7.42,
  "53101": -1.78,
  "53102": -2.3,
  "53103": 11.19,
  "53104": -1.78,
  "53105": -3.68,
  "53108": 2.61,
  "53109": -2.3,
  "53110": 5.83,
  "53114": -4.2,
  "53115": -4.2,
  "53118": 11.19,
  "53119": 11.19,
  "53120": -3.16,
  "53121": -2.09,
  "53122": 14.32,
  "53125": 3.22,
  "53126": 11.1,
  "53127": 11.19,
  "53128": -3.68,
  "53129": 5.83,
  "53130": 5.83,
  "53132": 5.83,
  "53137": 1.9,
  "53138": 4.2,
  "53139": 4.2,
  "53140": -2.3,
  "53141": -2.3,
  "53142": -2.3,
  "53143": -2.3,
  "53144": -2.3,
  "53146": 10.64,
  "53147": -3.68,
  "53148": -3.16,
  "53149": 11.19,
  "53150": 11.19,
  "53151": 7.97,
  "53152": -2.3,
  "53153": 10.64,
  "53154": 2.61,
  "53156": 1.9,
  "53157": -3.68,
  "53158": -2.3,
  "53159": -3.68,
  "53167": 4.2,
  "53168": -2.3,
  "53170": -2.3,
  "53171": -2.3,
  "53172": 5.83,
  "53176": -3.16,
  "53177": 2.61,
  "53178": 1.9,
  "53179": -2.3,
  "53181": -1.78,
  "53182": 2.61,
  "53183": 11.19,
  "53184": -5.27,
  "53185": 4.2,
  "53186": 10.64,
  "53187": 10.64,
  "53188": 10.64,
  "53189": 10.64,
  "53190": 1.38,
  "53191": 3.22,
  "53192": -2.3,
  "53194": -1.78,
  "53195": -5.27,
  "53199": -2.3,
  "53201": 14.32,
  "53202": 5.83,
  "53203": 14.32,
  "53204": 5.31,
  "53205": 5.31,
  "53206": 5.31,
  "53207": 5.83,
  "53208": 5.31,
  "53209": 5.31,
  "53210": 5.31,
  "53211": 5.83,
  "53212": 5.31,
  "53213": 5.83,
  "53214": 5.31,
  "53215": 5.31,
  "53216": 5.31,
  "53217": 5.83,
  "53218": 5.31,
  "53219": 5.83,
  "53220": 5.83,
  "53221": 5.83,
  "53222": 5.83,
  "53223": 5.31,
  "53224": 5.83,
  "53225": 5.31,
  "53226": 5.83,
  "53227": 5.83,
  "53228": 5.83,
  "53233": 5.31,
  "53234": 5.83,
  "53235": 5.83,
  "53237": 5.83,
  "53244": 5.83,
  "53401": 2.61,
  "53402": 2.61,
  "53403": 2.61,
  "53404": 2.09,
  "53405": 2.61,
  "53406": 2.61,
  "53408": 2.61,
  "53501": -0.73,
  "53502": -6.5,
  "53503": -5.46,
  "53504": -1.78,
  "53505": 1.38,
  "53506": -7.76,
  "53507": -4.91,
  "53508": -4.91,
  "53510": -3.37,
  "53511": -0.73,
  "53512": -0.73,
  "53515": 6.59,
  "53516": -1.78,
  "53517": -4.91,
  "53518": -9.35,
  "53520": -7.57,
  "53521": -4.91,
  "53522": -7.57,
  "53523": 2.45,
  "53525": -0.21,
  "53526": -7.05,
  "53527": 6.59,
  "53528": 6.59,
  "53529": 6.59,
  "53530": -3.37,
  "53531": 6.59,
  "53532": 6.59,
  "53533": -5.46,
  "53534": 0.86,
  "53535": -7.05,
  "53536": 1.38,
  "53537": 0.86,
  "53538": 1.38,
  "53540": -7.76,
  "53541": -3.37,
  "53542": 0.86,
  "53543": -7.05,
  "53544": -5.46,
  "53545": 0.86,
  "53546": 0.86,
  "53547": 0.86,
  "53548": 0.86,
  "53549": 1.38,
  "53550": -7.57,
  "53551": 1.9,
  "53553": -7.05,
  "53554": -7.51,
  "53555": 0.61,
  "53556": -7.76,
  "53557": 7.42,
  "53558": 6.59,
  "53559": 2.45,
  "53560": 1.99,
  "53561": 1.99,
  "53562": 14.53,
  "53563": 1.38,
  "53565": -6.5,
  "53566": -7.57,
  "53569": -7.51,
  "53570": -5.46,
  "53571": 0.06,
  "53572": 6.59,
  "53573": -9.35,
  "53574": -5.46,
  "53575": 6.59,
  "53576": 0.86,
  "53577": 1.44,
  "53578": 1.99,
  "53579": 7.42,
  "53580": -7.51,
  "53581": -9.35,
  "53582": -5.46,
  "53583": 1.44,
  "53584": -7.76,
  "53585": -5.27,
  "53586": -3.37,
  "53587": -3.37,
  "53588": -5.46,
  "53589": 6.59,
  "53590": 6.59,
  "53593": 14.53,
  "53594": 1.9,
  "53597": 14.53,
  "53598": 6.59,
  "53599": -1.78,
  "53701": 6.59,
  "53703": 6.59,
  "53704": 6.04,
  "53705": 14.53,
  "53706": 6.04,
  "53707": 6.04,
  "53708": 6.04,
  "53711": 6.59,
  "53713": 6.04,
  "53714": 6.04,
  "53715": 6.04,
  "53716": 6.04,
  "53717": 14.53,
  "53718": 6.04,
  "53719": 6.59,
  "53725": 6.04,
  "53726": 6.04,
  "53744": 6.04,
  "53801": -0.15,
  "53802": -7.51,
  "53803": -3.37,
  "53804": -7.51,
  "53805": -13.49,
  "53806": -7.51,
  "53807": -2.82,
  "53808": 2.15,
  "53809": -7.51,
  "53810": -0.15,
  "53811": 2.15,
  "53812": 2.15,
  "53813": -7.51,
  "53816": -7.51,
  "53817": -7.51,
  "53818": -6.96,
  "53820": -7.51,
  "53821": -13.49,
  "53824": 2.15,
  "53825": -7.51,
  "53826": -13.49,
  "53827": -13.49,
  "53901": 0.06,
  "53910": -11.44,
  "53911": 0.06,
  "53913": 1.44,
  "53916": 7.42,
  "53919": -3.83,
  "53920": -14.66,
  "53922": 14.32,
  "53923": 0.06,
  "53924": -9.35,
  "53925": 0.06,
  "53926": -3.83,
  "53927": -13.03,
  "53928": 0.06,
  "53929": -9.35,
  "53930": -14.66,
  "53931": -4.35,
  "53932": 0.06,
  "53933": 5.83,
  "53934": -13.03,
  "53935": -2.24,
  "53936": -11.44,
  "53937": -7.76,
  "53939": -3.83,
  "53940": 1.44,
  "53941": 1.44,
  "53942": -9.35,
  "53943": 1.44,
  "53944": -7.76,
  "53946": -3.83,
  "53947": -4.35,
  "53948": -9.35,
  "53949": -16.25,
  "53950": -9.35,
  "53951": 1.44,
  "53952": -14.66,
  "53953": -14.66,
  "53954": 0.06,
  "53955": 0.61,
  "53956": 0.06,
  "53959": 1.44,
  "53960": 0.06,
  "53961": 1.44,
  "53962": -9.35,
  "53963": 9.51,
  "53964": -11.44,
  "53965": 1.44,
  "53968": -9.35,
  "53969": 0.06,
  "54001": -7.82,
  "54002": -0.92,
  "54003": -0.4,
  "54004": -5.58,
  "54005": -8.34,
  "54006": -7.82,
  "54007": -0.92,
  "54009": -7.82,
  "54010": -0.92,
  "54011": -0.92,
  "54013": -1.44,
  "54014": -0.92,
  "54015": -0.92,
  "54016": 4.66,
  "54017": -0.92,
  "54020": -7.82,
  "54021": -0.4,
  "54022": -0.4,
  "54023": -0.92,
  "54024": -7.82,
  "54025": -0.92,
  "54026": -0.92,
  "54027": 14.87,
  "54028": 7.05,
  "54082": 4.66,
  "54101": -9.66,
  "54102": -9.26,
  "54103": -15.7,
  "54104": -9.26,
  "54106": 10.58,
  "54107": -0.98,
  "54110": -1.44,
  "54111": -10.18,
  "54112": -10.18,
  "54113": 10.58,
  "54114": -9.26,
  "54115": 2.76,
  "54119": -9.26,
  "54120": -15.7,
  "54121": -15.7,
  "54123": -1.44,
  "54124": -10.18,
  "54125": -16.25,
  "54126": 2.76,
  "54127": -10.18,
  "54128": -0.98,
  "54129": -0.92,
  "54130": 10.58,
  "54131": 10.58,
  "54135": -0.98,
  "54136": 10.06,
  "54137": -9.66,
  "54138": -9.66,
  "54139": -10.18,
  "54140": 10.58,
  "54141": 3.83,
  "54143": 3.16,
  "54149": -10.18,
  "54150": -1.53,
  "54151": -9.26,
  "54152": 10.06,
  "54153": -10.18,
  "54154": -10.18,
  "54155": 2.76,
  "54156": -9.26,
  "54157": -9.26,
  "54159": -9.26,
  "54160": -1.44,
  "54161": -10.18,
  "54162": 2.76,
  "54165": 10.58,
  "54166": -0.98,
  "54169": 7.57,
  "54170": 10.58,
  "54171": 2.76,
  "54173": 3.83,
  "54174": -10.18,
  "54175": -15.7,
  "54177": -9.26,
  "54180": 10.58,
  "54182": -0.98,
  "54201": 5.46,
  "54202": 11.65,
  "54204": 5.98,
  "54205": 5.98,
  "54207": -2.36,
  "54208": 2.76,
  "54209": 11.65,
  "54210": 11.65,
  "54211": 11.65,
  "54212": 11.65,
  "54213": 5.46,
  "54214": -2.36,
  "54215": -2.36,
  "54216": 5.46,
  "54217": 5.98,
  "54220": -2.91,
  "54221": -2.91,
  "54226": 5.46,
  "54227": -1.84,
  "54228": -2.36,
  "54229": 5.98,
  "54230": -1.84,
  "54232": -2.91,
  "54234": 11.65,
  "54235": 3.68,
  "54240": 5.46,
  "54241": -2.91,
  "54245": -2.91,
  "54246": 3.68,
  "54247": -2.36,
  "54301": 2.76,
  "54302": 2.24,
  "54303": 2.24,
  "54304": 2.76,
  "54305": 2.76,
  "54306": 2.24,
  "54307": 2.76,
  "54308": 2.76,
  "54311": 2.76,
  "54313": 2.76,
  "54324": 2.76,
  "54401": -0.06,
  "54402": -0.61,
  "54403": -0.06,
  "54405": 5,
  "54406": -4.66,
  "54407": -4.66,
  "54408": -8.8,
  "54409": -8.8,
  "54410": -4.66,
  "54411": -0.06,
  "54412": -4.66,
  "54413": -5.21,
  "54414": -8.8,
  "54415": -4.66,
  "54416": -0.98,
  "54417": -0.61,
  "54418": -8.8,
  "54420": 5,
  "54421": 5,
  "54422": 5,
  "54423": -3.07,
  "54424": -8.8,
  "54425": 5,
  "54426": -0.06,
  "54427": -0.98,
  "54428": -8.8,
  "54429": -0.98,
  "54430": -8.8,
  "54432": -0.98,
  "54433": 4.45,
  "54434": -12.57,
  "54435": -4.66,
  "54436": 5,
  "54437": 5,
  "54439": 4.45,
  "54440": -0.06,
  "54441": -4.66,
  "54442": -4.66,
  "54443": -4.66,
  "54446": 5,
  "54447": 4.45,
  "54448": -0.06,
  "54449": -4.66,
  "54450": -8.8,
  "54451": 5,
  "54452": -4.66,
  "54454": -4.66,
  "54455": -0.06,
  "54456": 4.45,
  "54457": -4.66,
  "54458": -4.66,
  "54459": -7.42,
  "54460": 5,
  "54462": -8.8,
  "54463": -8.8,
  "54464": -8.8,
  "54465": -8.8,
  "54466": -4.66,
  "54467": -4.66,
  "54469": -4.66,
  "54470": 5,
  "54471": 1.53,
  "54473": -4.66,
  "54474": -0.06,
  "54475": -4.66,
  "54476": -0.06,
  "54479": 5,
  "54480": 5,
  "54481": -4.66,
  "54482": -4.66,
  "54484": -0.06,
  "54485": -8.8,
  "54486": -0.98,
  "54487": -4.66,
  "54488": 5,
  "54489": -4.66,
  "54490": 5,
  "54491": -8.8,
  "54493": 5,
  "54494": -4.66,
  "54495": -4.66,
  "54498": 5,
  "54499": -0.98,
  "54501": -4.66,
  "54511": -15.7,
  "54512": -3.99,
  "54513": -7.42,
  "54514": -9.72,
  "54515": -7.97,
  "54517": -6.65,
  "54519": -3.99,
  "54520": -15.7,
  "54521": -5.58,
  "54524": -7.42,
  "54525": -11.31,
  "54526": -12.57,
  "54527": -7.17,
  "54529": -4.66,
  "54530": -7.97,
  "54531": 3.83,
  "54532": -4.66,
  "54534": -11.31,
  "54536": -11.31,
  "54537": -7.42,
  "54538": 2.91,
  "54539": -4.66,
  "54540": 2.91,
  "54541": -15.7,
  "54542": -15.7,
  "54543": -4.66,
  "54545": 2.91,
  "54546": -7.17,
  "54547": -9.72,
  "54548": 2.91,
  "54550": -11.31,
  "54552": -7.42,
  "54554": -5.58,
  "54555": -7.42,
  "54556": -7.42,
  "54557": 2.91,
  "54558": 2.91,
  "54559": -7.17,
  "54560": -5.58,
  "54561": -3.99,
  "54562": 3.83,
  "54563": -12.57,
  "54564": -7.42,
  "54565": -11.31,
  "54566": -15.7,
  "54568": -5.58,
  "54601": -0.61,
  "54602": -0.61,
  "54603": -0.61,
  "54610": -13.4,
  "54611": 12.27,
  "54612": -9.81,
  "54613": -12.48,
  "54614": -0.61,
  "54615": 12.27,
  "54616": -9.81,
  "54618": -9.35,
  "54619": -11.19,
  "54620": -4.29,
  "54621": -11.19,
  "54622": -12.88,
  "54623": -0.61,
  "54624": -13.49,
  "54625": -9.81,
  "54626": -13.49,
  "54627": -9.81,
  "54628": -13.49,
  "54629": -13.95,
  "54630": -9.81,
  "54631": -13.49,
  "54632": -11.19,
  "54634": -9.35,
  "54635": 12.82,
  "54636": 7.88,
  "54637": -9.87,
  "54638": -4.29,
  "54639": -11.19,
  "54640": -14.01,
  "54641": -4.29,
  "54642": 12.27,
  "54643": 12.27,
  "54644": -0.61,
  "54645": -14.01,
  "54646": -9.35,
  "54648": -4.29,
  "54649": -9.35,
  "54650": 7.88,
  "54651": -4.29,
  "54652": -11.71,
  "54653": -0.61,
  "54654": -14.01,
  "54655": -11.71,
  "54656": -4.29,
  "54657": -13.49,
  "54658": 7.88,
  "54659": -10.33,
  "54660": -4.29,
  "54661": -0.61,
  "54662": -4.29,
  "54664": -11.71,
  "54665": -11.19,
  "54666": -4.29,
  "54667": -11.19,
  "54669": 0.98,
  "54670": -4.29,
  "54701": 6.59,
  "54702": -1.9,
  "54703": -1.9,
  "54720": -1.9,
  "54721": 3.16,
  "54722": -1.9,
  "54723": -0.4,
  "54724": -0.98,
  "54725": 6.38,
  "54726": -0.98,
  "54727": -0.98,
  "54728": -5.58,
  "54729": -0.98,
  "54730": 6.38,
  "54731": -12.57,
  "54732": -1.53,
  "54733": -6.13,
  "54734": 6.38,
  "54735": 3.16,
  "54736": 3.16,
  "54737": 3.16,
  "54738": -0.31,
  "54739": 7.97,
  "54740": 3.16,
  "54741": 12.27,
  "54742": -1.9,
  "54743": -13.4,
  "54745": -12.02,
  "54746": 12.27,
  "54747": -9.81,
  "54748": -0.98,
  "54749": 6.38,
  "54750": -0.4,
  "54751": 6.38,
  "54754": 12.27,
  "54755": -13.4,
  "54756": 2.61,
  "54757": -0.98,
  "54758": -9.26,
  "54759": 3.68,
  "54760": -9.26,
  "54761": 3.16,
  "54762": -5.58,
  "54763": 5.83,
  "54764": -13.4,
  "54765": 5.83,
  "54766": -12.57,
  "54767": -1.44,
  "54768": -1.53,
  "54769": 12.17,
  "54770": -9.26,
  "54771": 4.45,
  "54772": 6.38,
  "54773": -9.81,
  "54801": -10.85,
  "54805": -6.13,
  "54806": 6.63,
  "54810": -7.82,
  "54812": -5.58,
  "54813": -5.58,
  "54814": 7.15,
  "54816": 7.15,
  "54817": -5.58,
  "54818": -5.58,
  "54819": -12.57,
  "54820": 7.15,
  "54821": -6.65,
  "54822": -5.58,
  "54824": -7.82,
  "54826": -8.34,
  "54827": 7.15,
  "54828": -12.63,
  "54829": -5.58,
  "54830": -10.33,
  "54832": 7.15,
  "54834": -11.56,
  "54835": -12.11,
  "54836": 1.17,
  "54837": -8.74,
  "54838": 1.17,
  "54839": 6.63,
  "54840": -8.74,
  "54841": -6.13,
  "54842": 1.17,
  "54843": -12.63,
  "54844": 7.15,
  "54845": -10.85,
  "54846": -7.17,
  "54847": 7.15,
  "54848": -12.57,
  "54849": 1.17,
  "54850": 15.64,
  "54853": -7.82,
  "54854": 0.65,
  "54855": -7.17,
  "54856": 7.15,
  "54857": -5.58,
  "54858": -7.82,
  "54859": -14.93,
  "54861": -7.17,
  "54862": -12.11,
  "54864": 1.17,
  "54865": 6.63,
  "54867": -12.11,
  "54868": -5.58,
  "54870": -6.13,
  "54871": -10.85,
  "54872": -10.33,
  "54873": 1.17,
  "54874": 1.17,
  "54875": -14.93,
  "54876": -12.63,
  "54880": 0.65,
  "54888": -14.93,
  "54889": -8.34,
  "54890": -14.93,
  "54891": 7.15,
  "54893": -10.33,
  "54895": -12.57,
  "54896": -11.56,
  "54901": 7.67,
  "54902": 16.16,
  "54903": 7.67,
  "54904": 16.16,
  "54909": -13.49,
  "54911": 10.06,
  "54912": 10.58,
  "54913": 10.58,
  "54914": 10.58,
  "54915": 10.06,
  "54921": -4.66,
  "54922": -10.18,
  "54923": -3.83,
  "54926": -0.98,
  "54927": 7.67,
  "54928": -0.98,
  "54929": -0.98,
  "54930": -13.03,
  "54931": 10.58,
  "54932": 10.06,
  "54933": -0.98,
  "54934": 7.67,
  "54935": 9.51,
  "54936": 9.51,
  "54937": 9.51,
  "54940": -9.66,
  "54941": -3.28,
  "54942": 18.55,
  "54943": -13.03,
  "54944": 10.58,
  "54945": -10.18,
  "54946": -10.18,
  "54947": 10.33,
  "54948": -0.98,
  "54949": -10.18,
  "54950": -0.98,
  "54952": 10.06,
  "54956": 8.74,
  "54957": 8.74,
  "54960": -13.49,
  "54961": -10.18,
  "54962": -10.18,
  "54963": 7.67,
  "54964": 8.22,
  "54965": -13.49,
  "54966": -13.49,
  "54967": -13.49,
  "54968": -3.83,
  "54969": -9.66,
  "54970": -13.49,
  "54971": -3.83,
  "54974": 9.51,
  "54976": -13.49,
  "54977": -9.66,
  "54978": -0.98,
  "54979": 9.51,
  "54980": 7.67,
  "54981": -10.18,
  "54982": -13.49,
  "54983": -10.18,
  "54984": -13.49,
  "54985": 7.67,
  "54986": 8.22,
  "55001": 13.15,
  "55002": 5.58,
  "55003": 4.14,
  "55005": -6.84,
  "55006": -7.88,
  "55007": -10.33,
  "55008": -6.84,
  "55009": 6.96,
  "55010": 26.68,
  "55011": 6.96,
  "55012": 5.58,
  "55013": 5.58,
  "55014": 6.44,
  "55016": 27.2,
  "55017": -7.88,
  "55018": -0.4,
  "55019": -0.4,
  "55020": 9.72,
  "55021": -0.4,
  "55024": 27.2,
  "55025": 5.58,
  "55026": -8.22,
  "55027": 6.96,
  "55029": -6.84,
  "55030": 8.22,
  "55031": 27.2,
  "55032": 5.06,
  "55033": 27.2,
  "55036": 8.74,
  "55037": -10.33,
  "55038": 4.66,
  "55040": -6.84,
  "55041": -8.22,
  "55042": 13.15,
  "55043": 4.66,
  "55044": 27.2,
  "55045": 5.58,
  "55046": -0.4,
  "55047": 13.15,
  "55049": 0.98,
  "55051": 8.22,
  "55052": -0.4,
  "55053": 7.57,
  "55054": 9.72,
  "55055": 26.68,
  "55056": 5.06,
  "55057": -0.4,
  "55060": 0.98,
  "55063": 8.74,
  "55065": 27.2,
  "55066": 6.96,
  "55067": 8.74,
  "55068": 27.2,
  "55069": 5.06,
  "55070": -6.84,
  "55071": 26.68,
  "55072": -10.33,
  "55073": 7.17,
  "55074": 5.58,
  "55075": 9.66,
  "55076": 26.68,
  "55077": 27.2,
  "55078": 5.58,
  "55079": 5.58,
  "55080": -7.36,
  "55082": 4.66,
  "55083": 4.66,
  "55084": 5.06,
  "55085": 26.68,
  "55087": -0.92,
  "55088": 9.72,
  "55089": 6.96,
  "55090": 4.14,
  "55092": 5.58,
  "55101": 9.66,
  "55102": 9.66,
  "55103": 9.66,
  "55104": 9.66,
  "55105": 10.18,
  "55106": 9.66,
  "55107": 9.66,
  "55108": 10.18,
  "55109": 9.66,
  "55110": 4.66,
  "55111": 9.66,
  "55112": 10.18,
  "55113": 10.18,
  "55114": 10.18,
  "55115": 13.15,
  "55116": 10.18,
  "55117": 9.66,
  "55118": 10.18,
  "55119": 9.66,
  "55120": 28.79,
  "55121": 27.2,
  "55122": 27.2,
  "55123": 28.79,
  "55124": 27.2,
  "55125": 13.15,
  "55126": 10.18,
  "55127": 10.18,
  "55128": 4.14,
  "55129": 13.15,
  "55130": 9.66,
  "55150": 9.66,
  "55164": 9.66,
  "55165": 9.66,
  "55166": 9.66,
  "55172": 9.66,
  "55175": 9.66,
  "55301": 4.66,
  "55302": 5.21,
  "55303": 6.96,
  "55304": 6.96,
  "55305": 13.4,
  "55306": 27.2,
  "55307": -4.6,
  "55308": 8.89,
  "55309": 8.89,
  "55310": -4.66,
  "55311": 13.4,
  "55312": 2.36,
  "55313": 12.11,
  "55314": -4.66,
  "55315": 9.72,
  "55316": 6.96,
  "55317": 7.63,
  "55318": 6.04,
  "55319": 8.89,
  "55320": 1.99,
  "55321": 3.62,
  "55322": 6.04,
  "55323": 14.99,
  "55324": -2.82,
  "55325": -2.82,
  "55327": 6.96,
  "55328": 4.66,
  "55329": -2.82,
  "55330": 1.44,
  "55331": 14.53,
  "55332": -4.66,
  "55333": -5.21,
  "55334": -4.6,
  "55335": -4.6,
  "55336": 2.36,
  "55337": 27.2,
  "55338": -4.08,
  "55339": 6.04,
  "55340": 21.89,
  "55341": 4.66,
  "55342": -4.66,
  "55343": 13.4,
  "55344": 13.4,
  "55345": 13.4,
  "55346": 13.4,
  "55347": 18.21,
  "55348": 6.04,
  "55349": 3.62,
  "55350": 1.32,
  "55352": 9.72,
  "55353": -2.82,
  "55354": 2.36,
  "55355": -2.82,
  "55356": 14.99,
  "55357": 13.15,
  "55358": 4.14,
  "55359": 6.04,
  "55360": 6.04,
  "55361": 6.04,
  "55362": 8.89,
  "55363": 4.66,
  "55364": 6.04,
  "55365": 8.89,
  "55366": -4.6,
  "55367": 6.04,
  "55368": 6.04,
  "55369": 6.96,
  "55370": 2.36,
  "55371": 0.4,
  "55372": 9.72,
  "55373": 4.66,
  "55374": 6.96,
  "55375": 6.04,
  "55376": 4.66,
  "55377": 8.89,
  "55378": 9.72,
  "55379": 9.72,
  "55380": 1.99,
  "55381": 1.32,
  "55382": 4.14,
  "55383": 6.04,
  "55384": 6.04,
  "55385": 1.32,
  "55386": 6.04,
  "55387": 6.04,
  "55388": 6.04,
  "55389": -2.82,
  "55390": 12.11,
  "55391": 24.19,
  "55392": 24.19,
  "55393": 6.04,
  "55394": 6.04,
  "55395": 2.36,
  "55396": -4.6,
  "55397": 6.04,
  "55398": 8.89,
  "55399": 6.04,
  "55401": 13.4,
  "55402": 13.4,
  "55403": 14.99,
  "55404": 13.4,
  "55405": 13.4,
  "55406": 10.18,
  "55407": 13.4,
  "55408": 13.4,
  "55409": 13.4,
  "55410": 13.4,
  "55411": 12.88,
  "55412": 12.88,
  "55413": 13.4,
  "55414": 10.18,
  "55415": 13.4,
  "55416": 13.4,
  "55417": 13.4,
  "55418": 13.4,
  "55419": 13.4,
  "55420": 27.2,
  "55421": 13.4,
  "55422": 13.4,
  "55423": 13.4,
  "55424": 21.89,
  "55425": 27.2,
  "55426": 13.4,
  "55427": 13.4,
  "55428": 13.4,
  "55429": 13.4,
  "55430": 13.4,
  "55431": 13.4,
  "55432": 6.96,
  "55433": 6.96,
  "55434": 6.96,
  "55435": 13.4,
  "55436": 21.89,
  "55437": 13.4,
  "55438": 13.4,
  "55439": 24.19,
  "55440": 13.4,
  "55441": 13.4,
  "55442": 14.99,
  "55443": 13.4,
  "55444": 6.96,
  "55445": 6.96,
  "55446": 21.89,
  "55447": 13.4,
  "55448": 6.96,
  "55449": 6.96,
  "55450": 13.4,
  "55454": 13.4,
  "55455": 13.4,
  "55458": 13.4,
  "55459": 13.4,
  "55460": 13.4,
  "55470": 13.4,
  "55473": 13.4,
  "55480": 13.4,
  "55550": 6.04,
  "55551": 6.04,
  "55552": 6.04,
  "55553": 6.04,
  "55554": 6.04,
  "55555": 6.04,
  "55556": 6.04,
  "55557": 6.04,
  "55559": 6.04,
  "55560": 6.04,
  "55561": 8.89,
  "55562": 6.04,
  "55563": 8.89,
  "55564": 6.04,
  "55565": 8.89,
  "55566": 6.04,
  "55567": 6.04,
  "55568": 6.04,
  "55569": 6.96,
  "55570": 6.04,
  "55571": 6.04,
  "55572": 6.04,
  "55573": 6.04,
  "55574": 6.04,
  "55575": 3.62,
  "55576": 6.04,
  "55577": 6.04,
  "55578": 6.04,
  "55579": 6.04,
  "55580": 8.89,
  "55581": 8.89,
  "55582": 8.89,
  "55583": 6.04,
  "55584": 8.89,
  "55585": 8.89,
  "55586": 8.89,
  "55587": 8.89,
  "55588": 8.89,
  "55589": 8.89,
  "55590": 8.89,
  "55591": 8.89,
  "55592": 6.04,
  "55593": 6.04,
  "55594": 6.04,
  "55595": 13.15,
  "55596": 13.15,
  "55597": 13.15,
  "55598": 13.15,
  "55599": 13.15,
  "55601": 1.69,
  "55602": 1.69,
  "55603": -14.87,
  "55604": -14.32,
  "55605": -14.87,
  "55606": -14.32,
  "55607": 1.69,
  "55609": 10.18,
  "55612": -5.83,
  "55613": -6.38,
  "55614": -14.87,
  "55615": -6.38,
  "55616": 2.24,
  "55701": 12.36,
  "55702": 12.36,
  "55703": 1.69,
  "55704": -10.85,
  "55705": 1.69,
  "55706": 1.69,
  "55707": 11.29,
  "55708": 1.69,
  "55709": 0.77,
  "55710": 2.24,
  "55711": 12.36,
  "55712": -10.33,
  "55713": 1.69,
  "55716": 0.77,
  "55717": 2.24,
  "55718": 11.29,
  "55719": 1.69,
  "55720": 12.36,
  "55721": 1.32,
  "55722": 0.77,
  "55723": 2.24,
  "55724": 2.24,
  "55725": 2.82,
  "55726": 12.36,
  "55730": 1.32,
  "55731": 2.24,
  "55732": 1.69,
  "55733": 12.36,
  "55734": 1.69,
  "55735": -10.33,
  "55736": 11.81,
  "55738": 1.69,
  "55741": 1.69,
  "55742": 0.77,
  "55744": 1.32,
  "55746": 1.69,
  "55747": 1.69,
  "55748": -11.19,
  "55749": 11.29,
  "55750": 1.69,
  "55751": 1.69,
  "55752": -11.19,
  "55753": 0.77,
  "55756": -10.33,
  "55757": 10.77,
  "55758": 1.69,
  "55760": -10.64,
  "55763": 1.69,
  "55764": 0.77,
  "55765": 1.69,
  "55766": 2.24,
  "55767": 11.29,
  "55768": 1.69,
  "55769": 0.77,
  "55771": -5.67,
  "55772": -5.67,
  "55775": 1.32,
  "55777": 1.69,
  "55779": 12.36,
  "55780": 11.81,
  "55781": 9.81,
  "55782": 1.69,
  "55783": -10.33,
  "55784": 1.32,
  "55785": -11.19,
  "55786": 0.77,
  "55787": -11.19,
  "55790": 3.28,
  "55791": 12.36,
  "55792": 1.69,
  "55793": 0.77,
  "55795": -10.85,
  "55796": 1.69,
  "55797": 11.29,
  "55798": 12.36,
  "55801": 2.24,
  "55802": 11.81,
  "55803": 2.24,
  "55804": 12.36,
  "55805": 11.81,
  "55806": 11.81,
  "55807": 11.81,
  "55808": 0.65,
  "55810": 12.36,
  "55811": 12.36,
  "55812": 12.36,
  "55814": 12.36,
  "55815": 11.81,
  "55816": 11.81,
  "55901": 2.36,
  "55902": 10.33,
  "55903": 10.33,
  "55904": 1.84,
  "55906": 3.43,
  "55909": 1.84,
  "55910": -6.38,
  "55912": 1.84,
  "55917": 0.46,
  "55918": 1.84,
  "55919": -3.83,
  "55920": 4.81,
  "55921": -3.83,
  "55922": -8.49,
  "55923": -6.38,
  "55924": 3.22,
  "55925": -0.61,
  "55926": 1.84,
  "55927": 3.22,
  "55929": 2.36,
  "55931": -3.83,
  "55932": -8.22,
  "55933": 1.84,
  "55934": 2.36,
  "55935": -6.38,
  "55936": 1.84,
  "55939": -6.9,
  "55940": 3.74,
  "55941": -3.83,
  "55942": -7.97,
  "55943": -3.83,
  "55944": 3.74,
  "55945": -8.22,
  "55946": -0.4,
  "55947": 7.88,
  "55949": -6.9,
  "55950": 1.84,
  "55951": 1.84,
  "55952": -6.38,
  "55953": 1.84,
  "55954": -8.49,
  "55955": 3.74,
  "55956": 6.96,
  "55957": -8.22,
  "55959": 0.52,
  "55960": 10.33,
  "55961": 1.84,
  "55962": -7.97,
  "55963": 4.81,
  "55964": -8.74,
  "55965": -6.9,
  "55967": 2.36,
  "55968": -8.74,
  "55969": -6.38,
  "55970": 1.84,
  "55971": -7.97,
  "55972": -6.38,
  "55973": 2.36,
  "55974": -4.35,
  "55975": -6.9,
  "55976": 2.36,
  "55977": 1.84,
  "55979": -6.38,
  "55981": -8.74,
  "55982": 1.84,
  "55983": 6.96,
  "55985": 3.22,
  "55987": -7.97,
  "55988": -7.97,
  "55990": -6.9,
  "55991": -8.22,
  "55992": 6.96,
  "56001": 2.82,
  "56002": 2.82,
  "56003": 2.82,
  "56006": 2.82,
  "56007": 0,
  "56009": 0,
  "56010": 2.3,
  "56011": 9.72,
  "56013": -8.74,
  "56014": -8.74,
  "56016": 0,
  "56017": 0.98,
  "56019": -0.92,
  "56020": 0,
  "56021": -4.08,
  "56022": -4.6,
  "56023": -8.74,
  "56024": 2.82,
  "56025": -8.74,
  "56026": 0.46,
  "56027": -8.74,
  "56028": 0.98,
  "56029": 0,
  "56030": -0.4,
  "56031": -4.14,
  "56032": 0,
  "56033": -8.74,
  "56034": 2.82,
  "56035": 0,
  "56036": 0,
  "56037": 2.82,
  "56039": -4.14,
  "56041": -0.92,
  "56042": 0,
  "56043": 0,
  "56044": -4.08,
  "56045": 0,
  "56046": 0.46,
  "56047": -8.74,
  "56048": -4.6,
  "56050": -4.08,
  "56051": -8.74,
  "56052": 0.98,
  "56054": -4.6,
  "56055": 2.82,
  "56056": -4.6,
  "56057": 0.98,
  "56058": 0.98,
  "56060": -4.6,
  "56062": -4.6,
  "56063": 0.98,
  "56065": 2.3,
  "56068": -8.74,
  "56069": 0.98,
  "56071": 9.72,
  "56072": -4.6,
  "56073": -0.4,
  "56074": -4.08,
  "56075": -4.14,
  "56078": -4.6,
  "56080": 2.82,
  "56081": -4.6,
  "56082": -4.08,
  "56083": -7.36,
  "56084": -0.4,
  "56085": -0.92,
  "56087": -0.92,
  "56088": -4.14,
  "56089": 0,
  "56090": 2.3,
  "56091": -4.6,
  "56093": -4.6,
  "56096": 0.98,
  "56097": -8.74,
  "56098": -8.74,
  "56101": -3.22,
  "56110": -5.98,
  "56111": -8.8,
  "56113": -7.88,
  "56114": -12.94,
  "56115": -1.44,
  "56116": -9.66,
  "56117": -6.5,
  "56118": -3.22,
  "56119": -5.98,
  "56120": -5.12,
  "56121": -4.66,
  "56122": -12.42,
  "56123": -3.74,
  "56125": -3.74,
  "56127": -4.66,
  "56128": -1.38,
  "56129": -10.18,
  "56131": -12.42,
  "56132": -0.92,
  "56134": -9.66,
  "56136": -7.88,
  "56137": -8.8,
  "56138": -9.66,
  "56139": -1.9,
  "56140": -1.9,
  "56141": -12.94,
  "56142": -7.88,
  "56143": -8.28,
  "56144": -1.9,
  "56145": -3.74,
  "56146": -10.18,
  "56147": -9.66,
  "56149": -7.88,
  "56150": -8.28,
  "56151": -12.94,
  "56152": -7.88,
  "56153": -10.18,
  "56155": -6.5,
  "56156": -9.66,
  "56157": -0.92,
  "56158": -9.66,
  "56159": -3.74,
  "56160": -5.12,
  "56161": -8.8,
  "56162": -4.6,
  "56164": -1.38,
  "56165": -5.98,
  "56166": -7.88,
  "56167": -8.28,
  "56168": -5.98,
  "56169": -0.92,
  "56170": -1.9,
  "56171": -4.14,
  "56172": -12.42,
  "56173": -9.66,
  "56174": -3.74,
  "56175": -1.44,
  "56176": -4.66,
  "56177": -1.9,
  "56178": -7.36,
  "56180": -7.88,
  "56181": -4.66,
  "56183": -3.74,
  "56185": -6.5,
  "56186": -1.9,
  "56187": -5.98,
  "56201": 0.86,
  "56207": 27.08,
  "56208": -7.05,
  "56209": 0.86,
  "56210": 37.57,
  "56211": -7.97,
  "56212": -11.65,
  "56214": 3.62,
  "56215": -6.5,
  "56216": 0.86,
  "56218": 4.14,
  "56219": -7.97,
  "56220": -9.72,
  "56221": 27.08,
  "56222": 20.64,
  "56223": 3.62,
  "56224": -8.43,
  "56225": 37.57,
  "56226": -6.5,
  "56227": 37.57,
  "56228": -2.82,
  "56229": 5.21,
  "56230": -4.66,
  "56231": -6.5,
  "56232": -11.1,
  "56235": 27.08,
  "56236": -7.97,
  "56237": -7.88,
  "56239": -0.92,
  "56240": 37.57,
  "56241": 3.62,
  "56243": -2.82,
  "56244": 27.08,
  "56245": 3.62,
  "56248": -7.51,
  "56249": -6.5,
  "56251": 0.86,
  "56252": 0.86,
  "56253": 0.86,
  "56255": -7.88,
  "56256": -11.65,
  "56257": -11.1,
  "56258": 7.05,
  "56260": 20.64,
  "56262": -7.05,
  "56263": -0.92,
  "56264": 4.14,
  "56265": 20.64,
  "56266": -7.88,
  "56267": 27.08,
  "56270": -4.66,
  "56271": -6.5,
  "56273": 0.86,
  "56274": -7.51,
  "56276": 37.57,
  "56277": -4.66,
  "56278": 37.57,
  "56279": 0.86,
  "56280": -7.36,
  "56281": 0.86,
  "56282": 0.86,
  "56283": -7.88,
  "56284": 0.86,
  "56285": 20.09,
  "56287": -8.43,
  "56288": 9.35,
  "56289": 0.86,
  "56291": 4.14,
  "56292": -7.88,
  "56293": -7.36,
  "56294": -7.88,
  "56295": 20.09,
  "56296": -7.97,
  "56297": 3.07,
  "56301": 5.92,
  "56302": 5.92,
  "56303": 5.92,
  "56304": 5.92,
  "56307": 7.3,
  "56308": 3.62,
  "56309": -6.96,
  "56310": 7.3,
  "56311": -6.96,
  "56312": 0.86,
  "56313": -6.13,
  "56314": -4.66,
  "56315": 3.62,
  "56316": -5.12,
  "56317": -4.66,
  "56318": -11.1,
  "56319": 3.62,
  "56320": 7.3,
  "56321": 7.3,
  "56323": 26.53,
  "56324": -6.96,
  "56325": 7.3,
  "56326": 3.62,
  "56327": 3.62,
  "56328": -5.21,
  "56329": 5.92,
  "56330": -5.58,
  "56331": 7.3,
  "56332": 3.62,
  "56333": 5.92,
  "56334": -5.12,
  "56335": 7.3,
  "56336": -11.1,
  "56338": -5.58,
  "56339": -6.96,
  "56340": 7.3,
  "56341": 3.62,
  "56342": 8.22,
  "56343": 3.62,
  "56344": -4.66,
  "56345": -4.66,
  "56347": -11.1,
  "56349": -5.12,
  "56350": -10.33,
  "56352": 7.3,
  "56353": -5.58,
  "56354": 3.62,
  "56355": 3.62,
  "56356": 6.75,
  "56357": 5.92,
  "56358": 8.22,
  "56359": -5.58,
  "56360": 3.62,
  "56361": 3.62,
  "56362": 7.3,
  "56363": -5.58,
  "56364": -4.66,
  "56367": 5.92,
  "56368": 7.3,
  "56369": 7.3,
  "56371": 7.3,
  "56373": -4.66,
  "56374": 7.3,
  "56375": 5.92,
  "56376": 7.3,
  "56377": 5.92,
  "56378": -11.1,
  "56379": 5.92,
  "56381": -5.12,
  "56382": -4.66,
  "56384": -4.66,
  "56385": -5.12,
  "56386": -5.58,
  "56387": 5.92,
  "56388": 5.92,
  "56389": 3.62,
  "56397": 5.92,
  "56398": 5.92,
  "56401": 0.4,
  "56425": 0.4,
  "56430": 0.4,
  "56431": -10.64,
  "56433": -12.48,
  "56434": -9.72,
  "56435": -8.34,
  "56436": -3.99,
  "56437": -11.1,
  "56438": -11.1,
  "56440": -11.1,
  "56441": 0.4,
  "56442": 8.89,
  "56443": -11.1,
  "56444": 0.4,
  "56446": -11.1,
  "56447": 0.4,
  "56448": -7.82,
  "56449": -4.66,
  "56450": 0.4,
  "56452": 0.15,
  "56453": -11.1,
  "56455": 0.4,
  "56456": 0.4,
  "56458": -12.48,
  "56459": 8.89,
  "56461": -12.48,
  "56464": -9.72,
  "56465": 0.92,
  "56466": -9.72,
  "56467": -3.99,
  "56468": 8.89,
  "56469": -10.64,
  "56470": -12.48,
  "56472": 0.92,
  "56473": 0.4,
  "56474": -8.34,
  "56475": -4.66,
  "56477": -9.72,
  "56478": -9.72,
  "56479": -9.72,
  "56481": -9.72,
  "56482": -9.72,
  "56484": 0.15,
  "56501": 4.08,
  "56502": 4.08,
  "56510": -17.63,
  "56511": 4.08,
  "56514": -3.28,
  "56515": -5.37,
  "56516": -15.33,
  "56517": 10.58,
  "56518": -9.72,
  "56519": -17.08,
  "56520": -12.48,
  "56521": 4.08,
  "56522": -12.48,
  "56523": 10.58,
  "56524": -6.96,
  "56525": -3.28,
  "56527": -9.72,
  "56528": -6.96,
  "56529": -3.28,
  "56531": -6.96,
  "56533": -13.03,
  "56534": -6.96,
  "56535": 10.58,
  "56536": -3.28,
  "56537": -6.96,
  "56538": -6.96,
  "56540": 10.58,
  "56541": -17.63,
  "56542": 2.3,
  "56543": -13.03,
  "56544": 4.08,
  "56545": -17.63,
  "56546": -16.56,
  "56547": -3.28,
  "56548": -17.08,
  "56549": -3.28,
  "56550": -17.08,
  "56551": -9.72,
  "56552": -3.83,
  "56553": -12.48,
  "56554": 4.08,
  "56556": 2.3,
  "56557": 1.78,
  "56560": -3.28,
  "56561": -3.28,
  "56562": -3.28,
  "56563": -3.28,
  "56565": -7.51,
  "56566": 1.23,
  "56567": -9.72,
  "56568": -17.08,
  "56569": 4.08,
  "56570": 4.08,
  "56571": -5.37,
  "56572": -6.96,
  "56573": -6.96,
  "56574": -17.08,
  "56575": 4.08,
  "56576": -5.37,
  "56577": 4.08,
  "56578": 4.08,
  "56579": -13.03,
  "56580": -3.28,
  "56581": -17.08,
  "56583": -7.97,
  "56584": -17.63,
  "56585": -17.08,
  "56586": -6.96,
  "56587": -6.96,
  "56588": -5.37,
  "56589": 4.08,
  "56590": -7.51,
  "56591": 4.08,
  "56592": 2.3,
  "56593": 4.08,
  "56594": -12.48,
  "56601": -1.9,
  "56619": -1.9,
  "56621": 1.78,
  "56623": -4.6,
  "56626": -8.89,
  "56627": -5.67,
  "56628": 0.77,
  "56629": -4.6,
  "56630": -1.38,
  "56631": 1.32,
  "56633": -1.9,
  "56634": -1.38,
  "56636": 0.77,
  "56637": 1.32,
  "56639": 1.32,
  "56641": -8.89,
  "56644": 2.3,
  "56646": 1.78,
  "56647": 7.11,
  "56649": -5.67,
  "56650": -1.38,
  "56651": 1.23,
  "56652": -1.38,
  "56653": -5.67,
  "56654": -5.67,
  "56655": -8.34,
  "56657": 0.77,
  "56658": -5.67,
  "56659": 0.77,
  "56660": -2.45,
  "56661": -2.45,
  "56662": -0.4,
  "56663": -2.45,
  "56666": -1.9,
  "56667": -1.38,
  "56668": -5.67,
  "56669": -5.12,
  "56670": -1.38,
  "56671": -1.38,
  "56672": -8.34,
  "56673": -13.34,
  "56676": 1.78,
  "56678": 1.78,
  "56679": -5.67,
  "56680": 0.77,
  "56681": -2.45,
  "56682": -13.34,
  "56683": 7.11,
  "56684": 1.78,
  "56685": -1.38,
  "56686": -13.86,
  "56687": -1.9,
  "56688": 0.77,
  "56701": -8.28,
  "56710": 0.46,
  "56711": -4.85,
  "56713": 5.46,
  "56714": -13.34,
  "56715": -8.8,
  "56716": 10.58,
  "56720": -13.86,
  "56721": 8.95,
  "56722": 8.95,
  "56723": 19.07,
  "56724": -13.34,
  "56725": -8.28,
  "56726": -13.34,
  "56727": -8.28,
  "56728": -13.34,
  "56729": -13.86,
  "56731": -13.86,
  "56732": 5.46,
  "56733": -13.86,
  "56734": -13.86,
  "56735": -13.86,
  "56736": 19.07,
  "56737": 5.98,
  "56738": 5.98,
  "56740": -13.86,
  "56741": -4.85,
  "56742": -8.8,
  "56744": -0.06,
  "56748": -8.8,
  "56750": 10.58,
  "56751": -11.75,
  "56754": -8.28,
  "56755": -13.86,
  "56756": -13.34,
  "56757": 5.46,
  "56758": 5.46,
  "56759": -13.34,
  "56760": 5.46,
  "56761": -13.34,
  "56762": 5.98,
  "56763": -13.34,
  "57001": 2.55,
  "57002": 0.46,
  "57003": 11.65,
  "57004": -8.28,
  "57005": 12.17,
  "57006": 1.53,
  "57010": 2.55,
  "57012": -6.44,
  "57013": -0.92,
  "57014": -8.28,
  "57015": -9.66,
  "57016": -2.76,
  "57017": -1.38,
  "57018": -2.76,
  "57020": 11.65,
  "57021": -9.66,
  "57022": 6.59,
  "57024": -1.9,
  "57025": 2.55,
  "57026": 0.46,
  "57027": 7.57,
  "57028": -1.38,
  "57029": -4.6,
  "57030": 11.65,
  "57031": -9.87,
  "57032": 7.57,
  "57033": 11.65,
  "57034": -1.44,
  "57035": -2.76,
  "57036": -9.66,
  "57037": -6.5,
  "57038": 2.55,
  "57039": -0.92,
  "57040": -6.5,
  "57041": -2.76,
  "57042": -2.76,
  "57043": -10.18,
  "57045": -5.12,
  "57046": -5.98,
  "57047": -6.96,
  "57048": -6.44,
  "57049": 6.9,
  "57050": -2.76,
  "57051": -10.64,
  "57052": -5.12,
  "57053": -9.66,
  "57054": -2.76,
  "57055": 12.17,
  "57057": -3.28,
  "57058": -6.44,
  "57059": -8.34,
  "57061": -0.06,
  "57062": -7.82,
  "57063": -7.82,
  "57064": 7.05,
  "57065": -1.38,
  "57066": -8.34,
  "57067": -6.5,
  "57068": 4.75,
  "57069": -9.87,
  "57070": -9.66,
  "57071": 0.46,
  "57072": -5.98,
  "57073": -8.8,
  "57075": -2.76,
  "57076": -14.72,
  "57077": 0.15,
  "57078": -5.98,
  "57101": 3.68,
  "57103": 11.65,
  "57104": 3.68,
  "57105": 11.65,
  "57106": 12.17,
  "57107": 3.16,
  "57108": 12.17,
  "57109": 11.65,
  "57110": 12.17,
  "57117": 3.68,
  "57118": 3.68,
  "57201": -4.6,
  "57212": -10.12,
  "57213": -9.2,
  "57214": -1.44,
  "57216": 38.12,
  "57217": -9.72,
  "57218": -9.72,
  "57219": -9.72,
  "57220": 0.46,
  "57221": -10.64,
  "57223": -0.92,
  "57224": -16.16,
  "57225": -9.72,
  "57226": -9.72,
  "57227": 38.12,
  "57231": -10.64,
  "57232": -12.48,
  "57233": -10.64,
  "57234": -1.44,
  "57235": -4.6,
  "57236": -9.72,
  "57237": -9.72,
  "57238": -9.2,
  "57239": -9.72,
  "57241": -0.92,
  "57242": -0.92,
  "57243": -5.12,
  "57245": -4.6,
  "57246": -3.74,
  "57247": -12.48,
  "57248": -1.44,
  "57249": -10.64,
  "57251": -4.29,
  "57252": -3.74,
  "57255": -16.71,
  "57256": -5.12,
  "57257": -16.71,
  "57258": -9.72,
  "57259": -3.74,
  "57260": -7.42,
  "57261": -9.72,
  "57262": -16.71,
  "57263": -5.12,
  "57264": -3.74,
  "57265": -3.74,
  "57266": -16.71,
  "57268": -9.72,
  "57269": -5.12,
  "57270": -12.48,
  "57271": -9.72,
  "57272": -5.12,
  "57273": -9.72,
  "57274": -9.72,
  "57276": 0.46,
  "57278": -9.72,
  "57279": -4.29,
  "57301": -2.76,
  "57311": -7.36,
  "57312": -1.9,
  "57313": -3.28,
  "57314": -7.42,
  "57315": -8.34,
  "57317": -11.56,
  "57319": -6.96,
  "57321": -15.24,
  "57322": -9.72,
  "57323": -15.24,
  "57324": -1.9,
  "57325": -17.02,
  "57328": -3.28,
  "57329": -8.34,
  "57330": -3.28,
  "57331": -2.76,
  "57332": -7.88,
  "57334": -2.76,
  "57335": -7.88,
  "57337": -15.24,
  "57339": -23.52,
  "57340": -7.36,
  "57341": -17.54,
  "57342": -7.88,
  "57344": -3.28,
  "57345": -5.58,
  "57346": -5.58,
  "57348": -1.9,
  "57349": -15.24,
  "57350": -1.38,
  "57353": -10.64,
  "57354": -5.12,
  "57355": -17.54,
  "57356": -7.88,
  "57358": -7.42,
  "57359": -7.42,
  "57361": -7.88,
  "57362": -7.42,
  "57363": -3.28,
  "57364": -3.28,
  "57365": -17.02,
  "57366": -4.6,
  "57367": -6.29,
  "57368": -19.38,
  "57369": -11.04,
  "57370": -17.54,
  "57371": -5.58,
  "57373": -7.42,
  "57374": -7.36,
  "57375": -19.38,
  "57376": -5.12,
  "57379": -1.9,
  "57380": -7.88,
  "57381": -7.42,
  "57382": -19.38,
  "57383": -19.38,
  "57384": -1.9,
  "57385": -7.42,
  "57386": -1.9,
  "57401": -2.36,
  "57402": -2.36,
  "57420": -17.54,
  "57421": -12.48,
  "57422": -9.72,
  "57424": -10.64,
  "57426": -2.36,
  "57427": -1.84,
  "57428": -18.09,
  "57429": -10.64,
  "57430": -12.48,
  "57432": -2.36,
  "57433": -2.36,
  "57434": -10.64,
  "57435": -4.75,
  "57436": -10.64,
  "57437": -18.55,
  "57438": -4.2,
  "57439": -2.36,
  "57440": -10.64,
  "57441": 7.3,
  "57442": -17.54,
  "57445": -2.36,
  "57446": 7.3,
  "57448": -18.55,
  "57449": 7.3,
  "57450": -17.54,
  "57451": -4.2,
  "57452": -18.09,
  "57454": -12.48,
  "57455": -18.09,
  "57456": -2.36,
  "57457": -18.55,
  "57460": -2.36,
  "57461": -10.64,
  "57465": -10.64,
  "57466": -4.75,
  "57467": -7.42,
  "57468": -10.27,
  "57469": -10.64,
  "57470": -10.64,
  "57471": -4.75,
  "57472": -17.54,
  "57473": -4.2,
  "57474": -2.36,
  "57475": -4.2,
  "57476": -10.64,
  "57477": -10.64,
  "57479": -2.36,
  "57481": -2.36,
  "57501": -4.2,
  "57520": -4.75,
  "57521": -18.09,
  "57522": -4.75,
  "57523": -11.56,
  "57528": -12.02,
  "57529": -12.02,
  "57531": -4.75,
  "57532": -4.75,
  "57533": -11.56,
  "57534": -23.52,
  "57536": -5.58,
  "57537": -4.75,
  "57538": -11.56,
  "57540": -5.58,
  "57541": -12.02,
  "57543": -18.09,
  "57544": -23.52,
  "57547": -18.09,
  "57548": -23.52,
  "57551": -18.09,
  "57552": -17.17,
  "57553": -17.17,
  "57555": -12.57,
  "57559": -4.75,
  "57560": -18.09,
  "57562": -17.17,
  "57563": -12.57,
  "57564": -4.2,
  "57566": -18.09,
  "57567": -17.17,
  "57568": -24.07,
  "57569": -23.52,
  "57570": -12.57,
  "57571": -11.56,
  "57572": -18.61,
  "57574": -18.09,
  "57576": -24.07,
  "57577": -18.09,
  "57579": -18.09,
  "57580": -12.02,
  "57584": -12.57,
  "57585": -12.57,
  "57601": -17.54,
  "57620": -11.19,
  "57621": -18.09,
  "57622": -6.13,
  "57623": -11.19,
  "57625": -4.75,
  "57626": -11.19,
  "57630": -18.09,
  "57631": -17.54,
  "57632": -18.09,
  "57633": -11.19,
  "57634": -11.19,
  "57636": -17.17,
  "57638": 1.69,
  "57639": -18.09,
  "57640": -10.64,
  "57641": 7.67,
  "57642": -18.09,
  "57644": -11.19,
  "57645": 7.67,
  "57646": -18.09,
  "57648": -18.09,
  "57649": -11.19,
  "57650": -10.27,
  "57651": -10.27,
  "57652": -17.54,
  "57656": -18.09,
  "57657": -18.09,
  "57658": -18.09,
  "57659": -18.09,
  "57660": 7.67,
  "57661": -17.54,
  "57701": -3.83,
  "57702": -3.28,
  "57703": -3.83,
  "57706": -3.83,
  "57709": -3.28,
  "57714": -18.09,
  "57716": -21.77,
  "57717": -13.95,
  "57718": -3.83,
  "57719": -3.83,
  "57720": -10.27,
  "57722": -8.43,
  "57724": -10.27,
  "57725": -3.28,
  "57730": -13.4,
  "57732": -7.51,
  "57735": -8.43,
  "57737": 2.36,
  "57738": -13.95,
  "57741": -7.51,
  "57744": -3.28,
  "57745": -6.96,
  "57747": -8.43,
  "57748": 4.66,
  "57750": -18.09,
  "57751": -13.4,
  "57752": -21.77,
  "57754": -7.51,
  "57755": -1.78,
  "57756": -21.77,
  "57758": -6.13,
  "57759": -6.96,
  "57760": -13.95,
  "57761": -3.83,
  "57762": -13.95,
  "57763": -8.43,
  "57764": -21.77,
  "57766": -8.43,
  "57767": -18.09,
  "57769": -3.28,
  "57770": -21.77,
  "57772": -21.77,
  "57773": -13.95,
  "57775": -18.09,
  "57776": -10.27,
  "57779": -8.03,
  "57780": -21.77,
  "57782": -8.43,
  "57783": -6.96,
  "57785": -7.51,
  "57787": -6.13,
  "57788": -13.95,
  "57790": -18.09,
  "57791": -18.09,
  "57792": 4.66,
  "57793": -7.51,
  "57794": -21.77,
  "58001": -13.03,
  "58002": 3.22,
  "58004": 2.7,
  "58005": 3.22,
  "58006": 2.7,
  "58007": 3.22,
  "58008": -5.12,
  "58009": -0.52,
  "58011": 2.7,
  "58012": 3.22,
  "58013": -2.36,
  "58015": -3.28,
  "58016": 1.78,
  "58017": -2.91,
  "58018": -4.6,
  "58021": 4.29,
  "58027": 0.86,
  "58029": 2.7,
  "58030": -5.67,
  "58031": 0.86,
  "58032": -2.36,
  "58033": 0.86,
  "58035": -0.52,
  "58036": 3.22,
  "58038": -0.52,
  "58040": -2.36,
  "58041": -5.67,
  "58042": 11.19,
  "58043": -2.36,
  "58045": 0,
  "58046": 1.78,
  "58047": 11.19,
  "58048": -0.52,
  "58049": -6.04,
  "58051": 3.22,
  "58052": 2.7,
  "58053": -5.12,
  "58054": 0.86,
  "58056": 1.78,
  "58057": 0.86,
  "58058": -5.67,
  "58059": 3.22,
  "58060": -2.36,
  "58061": -5.12,
  "58062": 0.86,
  "58063": -6.04,
  "58064": 1.78,
  "58065": 1.78,
  "58067": -2.36,
  "58068": 0.86,
  "58069": -2.36,
  "58071": -6.04,
  "58072": -6.04,
  "58074": -12.48,
  "58075": -12.48,
  "58077": -4.6,
  "58078": 11.19,
  "58079": 3.22,
  "58081": -5.12,
  "58102": 4.29,
  "58103": 4.29,
  "58104": 11.19,
  "58105": 4.29,
  "58106": 4.29,
  "58107": 11.19,
  "58108": 4.29,
  "58109": 11.19,
  "58201": 8.95,
  "58202": 2.05,
  "58203": 2.05,
  "58204": -0.06,
  "58205": 0.46,
  "58206": 8.95,
  "58208": 8.95,
  "58210": -3.28,
  "58212": -9.26,
  "58214": 0.46,
  "58216": 2.24,
  "58218": 0,
  "58219": -0.52,
  "58220": 2.76,
  "58222": 2.76,
  "58223": 0,
  "58224": -3.28,
  "58225": 2.76,
  "58227": -3.28,
  "58228": -0.06,
  "58229": -7.42,
  "58230": 1.78,
  "58231": -3.28,
  "58233": -3.28,
  "58235": 0.46,
  "58236": 11.25,
  "58237": -2.76,
  "58238": 2.76,
  "58239": -7.42,
  "58240": 2.3,
  "58241": 2.76,
  "58243": -3.28,
  "58244": -3.28,
  "58249": -6.9,
  "58250": -3.28,
  "58251": 0.46,
  "58254": -9.26,
  "58255": -6.9,
  "58256": 0.46,
  "58257": 0,
  "58258": 0.46,
  "58259": -9.26,
  "58260": -7.42,
  "58261": -2.76,
  "58262": 2.24,
  "58265": 2.24,
  "58266": -8.74,
  "58267": 0.46,
  "58269": -7.42,
  "58270": -2.76,
  "58271": 2.76,
  "58272": -9.26,
  "58273": -3.28,
  "58274": 0,
  "58275": 0,
  "58276": 2.24,
  "58277": 1.78,
  "58278": 8.95,
  "58281": -7.42,
  "58282": 2.24,
  "58301": -8.74,
  "58310": -13.4,
  "58311": -7.42,
  "58313": -7.51,
  "58316": -13.4,
  "58317": -13.4,
  "58318": -9.26,
  "58321": -9.26,
  "58323": -7.42,
  "58324": -8.74,
  "58325": 8.28,
  "58327": -8.74,
  "58329": -13.4,
  "58330": -9.26,
  "58331": -7.42,
  "58332": -7.51,
  "58335": -17.08,
  "58338": -7.42,
  "58339": -13.4,
  "58341": -15.7,
  "58343": -7.51,
  "58344": -8.74,
  "58345": -9.26,
  "58346": 7.76,
  "58348": 7.21,
  "58351": 7.76,
  "58352": -7.42,
  "58353": -13.4,
  "58355": -7.42,
  "58356": -17.08,
  "58357": 7.76,
  "58361": -9.26,
  "58362": -9.26,
  "58363": -13.4,
  "58365": -13.4,
  "58366": -13.4,
  "58367": -12.88,
  "58368": -6.96,
  "58369": -12.88,
  "58370": -17.08,
  "58372": -7.42,
  "58374": -17.08,
  "58377": -9.26,
  "58379": -17.08,
  "58380": -9.26,
  "58381": -17.08,
  "58382": -9.26,
  "58384": -13.95,
  "58385": -7.51,
  "58386": -7.51,
  "58401": -0.98,
  "58402": -0.98,
  "58413": 6.75,
  "58415": -13.86,
  "58416": -9.26,
  "58418": -16.25,
  "58420": -0.98,
  "58421": -3.74,
  "58422": -15.7,
  "58423": -16.25,
  "58424": -0.98,
  "58425": 1.78,
  "58426": -3.74,
  "58428": -12.94,
  "58429": -6.04,
  "58430": -15.7,
  "58431": -14.41,
  "58433": -13.86,
  "58436": 7.3,
  "58438": -16.25,
  "58439": 8.89,
  "58440": -14.41,
  "58441": 7.3,
  "58442": -1.53,
  "58443": -3.74,
  "58444": -16.25,
  "58445": -3.74,
  "58448": 1.78,
  "58451": -16.25,
  "58452": -9.26,
  "58454": -14.41,
  "58455": -3.74,
  "58456": -14.41,
  "58458": -13.86,
  "58460": -14.41,
  "58461": -6.04,
  "58463": -4.75,
  "58464": -3.74,
  "58466": -6.04,
  "58467": -0.98,
  "58472": -13.86,
  "58474": 7.3,
  "58475": -13.49,
  "58476": -0.98,
  "58477": 0.4,
  "58478": -13.49,
  "58479": -6.04,
  "58480": -6.04,
  "58481": -6.04,
  "58482": -12.94,
  "58483": -13.49,
  "58484": -3.74,
  "58486": -16.25,
  "58487": -13.49,
  "58488": -13.49,
  "58490": 0.86,
  "58492": -0.98,
  "58494": -0.15,
  "58495": -13.86,
  "58496": -0.98,
  "58497": -0.98,
  "58501": 8.89,
  "58502": 8.89,
  "58503": 8.89,
  "58504": 8.89,
  "58505": 8.89,
  "58506": 8.89,
  "58507": 8.89,
  "58520": -0.61,
  "58521": 8.89,
  "58523": 18.55,
  "58524": 0.4,
  "58528": 0.4,
  "58529": -0.61,
  "58530": 0.4,
  "58531": -4.2,
  "58532": -12.94,
  "58533": 7.67,
  "58535": -0.06,
  "58538": 8.22,
  "58540": -4.2,
  "58541": 16.41,
  "58542": -0.15,
  "58544": -0.15,
  "58545": 16.96,
  "58549": 0.4,
  "58552": 0.4,
  "58554": 8.89,
  "58558": 8.89,
  "58559": -4.2,
  "58560": 0.4,
  "58561": -12.94,
  "58562": 7.67,
  "58563": -0.06,
  "58564": 8.22,
  "58565": -4.2,
  "58566": 8.43,
  "58568": 8.22,
  "58569": 8.22,
  "58570": 0.4,
  "58571": 16.96,
  "58572": 0.4,
  "58573": 0.4,
  "58575": -4.2,
  "58576": -4.2,
  "58577": 4.29,
  "58579": 0.4,
  "58580": 16.41,
  "58581": 6.75,
  "58601": 18.55,
  "58602": 18.55,
  "58620": 7.21,
  "58621": 7.76,
  "58622": 7.76,
  "58623": 2.24,
  "58625": 16.41,
  "58626": 9.51,
  "58627": 7.76,
  "58630": 11.65,
  "58631": 8.22,
  "58632": 7.76,
  "58634": 7.76,
  "58636": 16.41,
  "58638": 9.51,
  "58639": 2.24,
  "58640": 7.76,
  "58641": 18.55,
  "58642": 11.65,
  "58643": 2.24,
  "58644": 16.41,
  "58645": 7.76,
  "58646": 1.69,
  "58647": 10.06,
  "58649": 1.69,
  "58650": 1.69,
  "58651": 2.24,
  "58652": 10.06,
  "58653": 2.24,
  "58654": 7.21,
  "58655": 10.06,
  "58656": 10.06,
  "58701": 7.51,
  "58702": 7.51,
  "58703": 7.51,
  "58704": 7.51,
  "58705": 7.51,
  "58710": -7.51,
  "58711": -9.81,
  "58712": -9.26,
  "58713": -9.81,
  "58716": -2.61,
  "58718": -0.98,
  "58721": -17.17,
  "58722": 7.51,
  "58723": -4.75,
  "58725": -1.53,
  "58727": -17.17,
  "58730": -16.62,
  "58731": -9.26,
  "58733": -0.98,
  "58734": -1.99,
  "58735": -4.2,
  "58736": -9.81,
  "58737": -17.17,
  "58740": -0.98,
  "58741": -9.26,
  "58744": -9.81,
  "58746": -16.62,
  "58748": -9.26,
  "58750": -0.98,
  "58752": -17.17,
  "58755": -17.17,
  "58756": -0.98,
  "58757": 14.2,
  "58758": -15.7,
  "58759": -4.2,
  "58760": -9.81,
  "58761": -9.26,
  "58762": -9.26,
  "58763": -1.44,
  "58765": -17.17,
  "58768": -0.77,
  "58769": -1.44,
  "58770": -1.44,
  "58771": -1.99,
  "58772": -17.17,
  "58773": -16.62,
  "58775": -4.2,
  "58776": -1.44,
  "58778": -2.61,
  "58779": -4.2,
  "58781": -0.98,
  "58782": -16.62,
  "58783": -9.81,
  "58784": -1.44,
  "58785": 7.51,
  "58787": -17.17,
  "58788": -9.81,
  "58789": -9.81,
  "58790": -9.26,
  "58792": -9.26,
  "58793": -9.81,
  "58794": 16.04,
  "58795": 15.49,
  "58801": 16.04,
  "58802": 16.04,
  "58830": 15.49,
  "58831": 14.2,
  "58833": 15.49,
  "58835": 14.2,
  "58838": 14.2,
  "58843": 16.04,
  "58844": 15.49,
  "58845": 15.49,
  "58847": 14.2,
  "58849": 16.04,
  "58852": 16.04,
  "58853": 16.04,
  "58854": 14.2,
  "58856": 16.04,
  "59001": -5.98,
  "59002": 3.22,
  "59003": -6.5,
  "59006": 3.22,
  "59007": -11.96,
  "59008": -11.96,
  "59010": -6.5,
  "59011": -12.88,
  "59012": -6.5,
  "59013": -11.96,
  "59014": -11.96,
  "59015": 3.22,
  "59016": -6.5,
  "59018": -4.6,
  "59019": -5.98,
  "59020": -11.96,
  "59022": -6.5,
  "59024": -5.98,
  "59025": -6.5,
  "59026": -11.96,
  "59027": 4.6,
  "59028": -5.98,
  "59029": -11.96,
  "59030": -4.6,
  "59031": -5.98,
  "59032": -2.82,
  "59033": -13.4,
  "59034": -5.98,
  "59035": -5.98,
  "59036": 2.76,
  "59037": 3.22,
  "59038": -6.5,
  "59039": -14.97,
  "59041": -11.96,
  "59043": -6.5,
  "59044": 3.22,
  "59046": 3.22,
  "59047": -4.6,
  "59050": -5.98,
  "59052": -2.09,
  "59053": 2.24,
  "59054": -17.08,
  "59055": -12.88,
  "59057": 3.22,
  "59058": 7.57,
  "59059": -16.56,
  "59061": -5.98,
  "59062": -6.5,
  "59063": -5.98,
  "59064": 3.22,
  "59065": -4.6,
  "59066": -11.96,
  "59067": -6.5,
  "59068": -11.96,
  "59069": -5.98,
  "59070": -11.96,
  "59071": -11.96,
  "59072": -16.56,
  "59073": -16.56,
  "59074": 2.76,
  "59075": -5.98,
  "59076": -6.5,
  "59077": 5.27,
  "59078": 2.76,
  "59079": 3.22,
  "59081": -11.96,
  "59082": -2.09,
  "59083": -14.97,
  "59084": -2.82,
  "59085": 2.24,
  "59086": -4.6,
  "59087": 7.57,
  "59088": 3.22,
  "59089": -5.98,
  "59101": 3.22,
  "59102": 3.22,
  "59103": 3.22,
  "59104": 3.22,
  "59105": 3.22,
  "59106": 3.22,
  "59107": 3.22,
  "59108": 3.22,
  "59201": -16.1,
  "59211": 16.04,
  "59212": -6.59,
  "59213": -14.11,
  "59214": -16.62,
  "59215": -16.62,
  "59217": -6.04,
  "59218": -6.04,
  "59219": 15.49,
  "59221": -6.04,
  "59222": -22.6,
  "59223": -10.12,
  "59225": -10.64,
  "59226": -6.59,
  "59230": -10.12,
  "59231": -10.64,
  "59240": -10.64,
  "59241": -10.64,
  "59242": -14.11,
  "59243": -6.04,
  "59244": -10.64,
  "59247": -23.15,
  "59248": -10.64,
  "59250": -10.64,
  "59252": -22.6,
  "59253": -22.6,
  "59254": -22.6,
  "59255": -6.04,
  "59256": -22.6,
  "59257": -23.15,
  "59258": -22.6,
  "59259": -6.59,
  "59260": -22.6,
  "59261": -6.96,
  "59262": -6.04,
  "59263": -22.6,
  "59270": -6.04,
  "59273": -10.64,
  "59274": -16.62,
  "59275": 15.49,
  "59276": -23.15,
  "59301": -2.3,
  "59311": -13.4,
  "59312": -2.3,
  "59313": 6.29,
  "59314": -7.05,
  "59315": -12.02,
  "59316": -9.72,
  "59317": -5.98,
  "59318": -3.22,
  "59319": -13.4,
  "59322": -3.22,
  "59323": -5.98,
  "59324": 6.29,
  "59326": -15.24,
  "59327": -2.3,
  "59330": -12.02,
  "59332": -9.72,
  "59333": -2.3,
  "59336": 7.36,
  "59337": -3.74,
  "59338": -2.3,
  "59339": -12.02,
  "59341": -15.24,
  "59343": -2.3,
  "59344": 6.29,
  "59345": -2.3,
  "59347": -2.3,
  "59349": -15.24,
  "59351": -2.3,
  "59353": -12.02,
  "59354": 6.84,
  "59401": 8.68,
  "59402": 8.68,
  "59403": 9.2,
  "59404": 9.2,
  "59405": 9.2,
  "59406": 9.2,
  "59410": -13.4,
  "59411": -4.2,
  "59412": 8.68,
  "59414": 8.68,
  "59416": -13.4,
  "59417": -6.96,
  "59418": 2.24,
  "59419": -4.91,
  "59420": -6.5,
  "59421": 9.2,
  "59422": -13.4,
  "59424": 6.59,
  "59425": -6.96,
  "59427": -6.96,
  "59430": -1.9,
  "59432": -6.96,
  "59433": -13.4,
  "59434": -6.44,
  "59435": -6.96,
  "59436": -12.88,
  "59440": 8.68,
  "59441": -2.3,
  "59442": -6.5,
  "59443": -12.88,
  "59444": -6.96,
  "59446": -6.5,
  "59447": -1.9,
  "59448": -6.96,
  "59450": -5.98,
  "59451": -2.82,
  "59452": -1.9,
  "59453": 2.24,
  "59454": -6.96,
  "59456": -6.96,
  "59457": -2.82,
  "59460": -6.5,
  "59461": 1.78,
  "59462": -1.9,
  "59463": -1.38,
  "59464": -2.82,
  "59465": -1.38,
  "59466": -6.96,
  "59467": -6.96,
  "59468": 9.2,
  "59469": -1.9,
  "59471": -2.82,
  "59472": 8.68,
  "59474": -6.96,
  "59477": -13.4,
  "59479": -1.9,
  "59480": 8.68,
  "59482": -6.96,
  "59483": 9.2,
  "59484": -6.96,
  "59485": 9.2,
  "59486": -6.96,
  "59487": 9.2,
  "59489": -2.82,
  "59501": 1.78,
  "59520": -6.5,
  "59521": 1.78,
  "59522": 1.78,
  "59523": -13.86,
  "59524": -6.96,
  "59525": 1.78,
  "59526": -13.86,
  "59527": -13.86,
  "59528": 1.78,
  "59529": -13.86,
  "59530": 1.78,
  "59531": 1.78,
  "59532": 1.78,
  "59535": -13.34,
  "59537": -6.96,
  "59538": -6.96,
  "59540": 1.78,
  "59542": -13.86,
  "59544": -6.96,
  "59545": 1.78,
  "59546": -13.86,
  "59547": -13.86,
  "59601": 0.92,
  "59602": 0.92,
  "59604": 0.92,
  "59620": 0.92,
  "59624": 0.92,
  "59626": 0.92,
  "59631": -7.76,
  "59632": -8.8,
  "59633": 0.92,
  "59634": 8.89,
  "59635": 0.92,
  "59636": 0.92,
  "59638": -8.28,
  "59639": -13.19,
  "59640": 0.92,
  "59641": -7.36,
  "59642": -7.36,
  "59643": -7.36,
  "59644": -7.88,
  "59645": -7.88,
  "59647": -7.88,
  "59648": 0.92,
  "59701": -1.32,
  "59702": -1.32,
  "59703": -1.32,
  "59710": 0.98,
  "59711": -1.78,
  "59713": 1.44,
  "59714": 4.6,
  "59715": 4.6,
  "59716": 4.6,
  "59717": 4.6,
  "59718": 4.6,
  "59719": 4.6,
  "59720": -0.06,
  "59721": -7.21,
  "59722": -1.78,
  "59724": -10.27,
  "59725": -8.68,
  "59727": -0.77,
  "59728": 1.44,
  "59729": 1.53,
  "59730": 6.19,
  "59731": -13.74,
  "59732": -1.32,
  "59733": -12.15,
  "59735": 0.46,
  "59736": -8.68,
  "59739": -10.27,
  "59740": 8.43,
  "59741": 12.57,
  "59743": -1.32,
  "59745": 8.43,
  "59746": -0.19,
  "59747": -0.06,
  "59748": -1.32,
  "59749": 0.98,
  "59750": -1.32,
  "59751": -1.32,
  "59752": 4.6,
  "59754": 0.98,
  "59755": 0.98,
  "59756": -1.78,
  "59758": -13.4,
  "59759": -7.76,
  "59760": 4.6,
  "59761": -8.68,
  "59762": -1.78,
  "59771": 4.6,
  "59772": 4.6,
  "59801": 1.99,
  "59802": 1.99,
  "59803": 1.99,
  "59804": 1.99,
  "59806": 1.44,
  "59807": 1.99,
  "59808": 1.99,
  "59820": 1.99,
  "59821": 1.44,
  "59823": 1.99,
  "59824": -12.27,
  "59825": 1.44,
  "59826": -12.27,
  "59827": -7.67,
  "59828": -7.67,
  "59829": -8.22,
  "59830": -7.76,
  "59831": -12.82,
  "59832": -13.74,
  "59833": 1.99,
  "59834": 1.99,
  "59835": -7.67,
  "59837": -13.74,
  "59840": -7.67,
  "59841": -8.22,
  "59842": -7.76,
  "59843": -13.19,
  "59844": -8.74,
  "59845": -7.76,
  "59846": -5.83,
  "59847": 1.99,
  "59848": -7.76,
  "59851": 1.44,
  "59853": -8.74,
  "59854": 1.99,
  "59855": -12.82,
  "59856": -7.76,
  "59858": -13.74,
  "59859": -7.76,
  "59860": -12.27,
  "59863": -12.82,
  "59864": -12.82,
  "59865": -12.82,
  "59866": -6.38,
  "59867": -7.76,
  "59868": 1.44,
  "59870": -7.67,
  "59871": -7.67,
  "59872": -6.38,
  "59873": -7.76,
  "59874": -8.28,
  "59875": -7.67,
  "59901": -3.16,
  "59903": -3.16,
  "59904": -3.16,
  "59910": -12.27,
  "59911": -12.27,
  "59912": -3.16,
  "59913": -3.16,
  "59914": -4.33,
  "59915": -12.27,
  "59916": -2.61,
  "59917": -8.74,
  "59918": -8.22,
  "59919": -3.16,
  "59920": -2.61,
  "59921": -2.61,
  "59922": -2.61,
  "59923": -9.26,
  "59925": -2.61,
  "59926": -3.16,
  "59927": -3.16,
  "59928": -2.61,
  "59929": -12.82,
  "59930": -8.74,
  "59931": -4.33,
  "59932": -2.61,
  "59933": -8.22,
  "59934": -8.22,
  "59935": -9.26,
  "59936": -2.61,
  "59937": -2.61,
  "60001": 7.88,
  "60002": -1.78,
  "60004": 13.09,
  "60005": 15.85,
  "60006": 12.57,
  "60007": 14.78,
  "60008": 14.78,
  "60009": 14.78,
  "60010": 23.36,
  "60011": 7.88,
  "60012": 8.43,
  "60013": 8.43,
  "60014": 7.88,
  "60015": 13.8,
  "60016": 23.15,
  "60017": 23.15,
  "60018": 23.15,
  "60020": 7.36,
  "60021": 7.88,
  "60022": 23.88,
  "60025": 23.67,
  "60026": 23.67,
  "60029": 27.56,
  "60030": 11.5,
  "60031": 11.5,
  "60033": -0.61,
  "60034": 7.88,
  "60035": 14.32,
  "60037": 22.29,
  "60039": 7.88,
  "60040": 11.5,
  "60041": 11.5,
  "60042": 7.88,
  "60043": 34.46,
  "60044": 13.8,
  "60045": 22.29,
  "60046": 11.5,
  "60047": 13.8,
  "60048": 11.5,
  "60050": 7.36,
  "60051": 7.36,
  "60053": 23.67,
  "60056": 15.85,
  "60060": 11.5,
  "60061": 11.5,
  "60062": 15.39,
  "60064": 10.98,
  "60065": 22.29,
  "60067": 12.57,
  "60068": 23.15,
  "60069": 14.32,
  "60070": 12.57,
  "60071": 15.85,
  "60072": 7.36,
  "60073": 11.5,
  "60074": 11.5,
  "60075": 11.5,
  "60076": 23.67,
  "60077": 23.15,
  "60078": 12.57,
  "60079": 10.98,
  "60081": 7.36,
  "60082": 15.39,
  "60083": 11.5,
  "60084": 11.5,
  "60085": 10.98,
  "60087": 11.5,
  "60088": 10.98,
  "60089": 11.5,
  "60090": 12.57,
  "60091": 25.97,
  "60092": 12.57,
  "60093": 34.46,
  "60094": 15.33,
  "60095": 14.78,
  "60096": -1.78,
  "60097": 7.88,
  "60098": 7.88,
  "60099": 11.5,
  "60101": 14.78,
  "60102": 7.88,
  "60103": 11.56,
  "60104": 22.6,
  "60106": 15.33,
  "60107": 11.56,
  "60108": 15.33,
  "60109": 12.11,
  "60110": 7.88,
  "60111": 10.85,
  "60112": 9.81,
  "60113": 9.26,
  "60115": 9.81,
  "60118": 12.11,
  "60119": 12.11,
  "60120": 11.56,
  "60121": 11.56,
  "60123": 11.56,
  "60124": 11.56,
  "60126": 15.33,
  "60129": 9.81,
  "60130": 23.15,
  "60131": 23.15,
  "60133": 11.56,
  "60134": 12.11,
  "60135": 9.81,
  "60136": 12.11,
  "60137": 15.33,
  "60138": 15.33,
  "60139": 14.78,
  "60140": 12.11,
  "60141": 22.6,
  "60142": 8.43,
  "60143": 15.33,
  "60144": 12.11,
  "60145": 9.47,
  "60146": 1.53,
  "60147": 12.11,
  "60148": 14.78,
  "60150": 9.81,
  "60151": 18.3,
  "60152": 0.98,
  "60153": 22.6,
  "60154": 23.15,
  "60155": 22.6,
  "60156": 7.88,
  "60157": 15.33,
  "60159": 14.78,
  "60160": 23.15,
  "60161": 23.15,
  "60162": 23.15,
  "60163": 23.15,
  "60164": 23.15,
  "60165": 23.15,
  "60168": 14.78,
  "60169": 14.78,
  "60170": 11.56,
  "60171": 23.15,
  "60172": 14.78,
  "60173": 14.78,
  "60174": 12.11,
  "60175": 22.35,
  "60176": 23.15,
  "60177": 11.56,
  "60178": 9.81,
  "60180": 8.43,
  "60181": 15.33,
  "60183": 22.35,
  "60184": 22.9,
  "60185": 11.56,
  "60186": 11.56,
  "60187": 15.33,
  "60188": 14.78,
  "60189": 15.33,
  "60190": 15.33,
  "60191": 15.33,
  "60192": 15.33,
  "60193": 14.78,
  "60194": 14.78,
  "60195": 15.33,
  "60197": 14.78,
  "60199": 14.78,
  "60201": 23.67,
  "60202": 23.15,
  "60203": 23.67,
  "60204": 23.67,
  "60301": 23.15,
  "60302": 23.15,
  "60303": 23.15,
  "60304": 23.15,
  "60305": 33.94,
  "60401": 7.88,
  "60402": 23.15,
  "60403": 23.15,
  "60404": 10.64,
  "60406": 20.49,
  "60407": 23.31,
  "60408": 24.38,
  "60409": 7.15,
  "60410": 10.64,
  "60411": 7.15,
  "60412": 7.15,
  "60415": 22.6,
  "60416": 24.38,
  "60417": 8.74,
  "60419": 7.15,
  "60420": 1.69,
  "60421": 10.64,
  "60422": 15.64,
  "60423": 10.64,
  "60424": 23.31,
  "60425": 7.67,
  "60426": 7.15,
  "60428": 7.15,
  "60429": 7.15,
  "60430": 7.67,
  "60431": 10.64,
  "60432": 10.12,
  "60433": 10.12,
  "60434": 10.12,
  "60435": 10.12,
  "60436": 10.12,
  "60437": 24.38,
  "60438": 7.67,
  "60439": 14.78,
  "60440": 14.78,
  "60441": 10.64,
  "60442": 10.64,
  "60443": 9.05,
  "60444": 24.38,
  "60445": 21.01,
  "60446": 10.64,
  "60447": 24.9,
  "60448": 10.64,
  "60449": 10.64,
  "60450": 24.9,
  "60451": 10.64,
  "60452": 9.05,
  "60453": 23.15,
  "60454": 23.15,
  "60455": 23.15,
  "60456": 22.6,
  "60457": 23.15,
  "60458": 23.15,
  "60459": 23.15,
  "60460": 1.69,
  "60461": 16.16,
  "60462": 10.64,
  "60463": 23.15,
  "60464": 23.15,
  "60465": 23.15,
  "60466": 7.15,
  "60467": 19.13,
  "60468": 7.88,
  "60469": 20.49,
  "60470": 9.66,
  "60471": 9.05,
  "60472": 20.49,
  "60473": 7.67,
  "60474": 23.31,
  "60475": 7.15,
  "60476": 7.15,
  "60477": 10.64,
  "60478": 8.53,
  "60479": 24.9,
  "60480": 23.15,
  "60481": 24.38,
  "60482": 23.15,
  "60484": 7.15,
  "60487": 10.64,
  "60490": 14.78,
  "60491": 10.64,
  "60499": 23.15,
  "60501": 22.6,
  "60502": 14.78,
  "60503": 14.78,
  "60504": 14.78,
  "60505": 1.9,
  "60506": 1.9,
  "60507": 11.56,
  "60510": 12.11,
  "60511": 1.9,
  "60512": 1.9,
  "60513": 23.15,
  "60514": 15.33,
  "60515": 14.78,
  "60516": 15.33,
  "60517": 14.78,
  "60518": 10.18,
  "60519": 14.78,
  "60520": 17.75,
  "60521": 15.33,
  "60522": 26.12,
  "60523": 15.33,
  "60525": 23.15,
  "60526": 23.15,
  "60527": 26.12,
  "60530": 9.81,
  "60531": 2.45,
  "60532": 14.78,
  "60534": 23.15,
  "60536": 1.9,
  "60537": 1.9,
  "60538": 1.9,
  "60539": 11.56,
  "60540": 16.37,
  "60541": 1.9,
  "60542": 11.56,
  "60543": 1.9,
  "60544": 10.64,
  "60545": 1.9,
  "60546": 23.15,
  "60548": 1.9,
  "60549": 10.18,
  "60550": 9.81,
  "60551": 1.9,
  "60552": 3.49,
  "60553": 9.81,
  "60554": 1.9,
  "60555": 14.78,
  "60556": 9.81,
  "60557": 10.18,
  "60558": 33.94,
  "60559": 15.33,
  "60560": 1.9,
  "60561": 16.37,
  "60563": 14.78,
  "60564": 23.27,
  "60565": 16.37,
  "60566": 16.37,
  "60567": 14.78,
  "60585": 10.64,
  "60586": 10.64,
  "60598": 14.78,
  "60599": 1.9,
  "60601": 23.15,
  "60602": 23.15,
  "60603": 23.15,
  "60604": 23.15,
  "60605": 23.15,
  "60606": 23.15,
  "60607": 23.15,
  "60608": 23.15,
  "60609": 22.6,
  "60610": 23.15,
  "60611": 23.15,
  "60612": 23.15,
  "60613": 23.67,
  "60614": 33.94,
  "60615": 23.15,
  "60616": 23.15,
  "60617": 20.49,
  "60618": 23.67,
  "60619": 22.6,
  "60620": 22.6,
  "60621": 22.6,
  "60622": 23.15,
  "60623": 22.6,
  "60624": 22.6,
  "60625": 23.67,
  "60626": 23.15,
  "60628": 20.49,
  "60629": 22.6,
  "60630": 23.15,
  "60631": 23.67,
  "60632": 23.15,
  "60633": 7.15,
  "60634": 23.15,
  "60636": 22.6,
  "60637": 22.6,
  "60638": 23.15,
  "60639": 23.15,
  "60640": 23.15,
  "60641": 23.15,
  "60642": 23.15,
  "60643": 22.6,
  "60644": 22.6,
  "60645": 23.15,
  "60646": 23.67,
  "60647": 23.15,
  "60649": 22.6,
  "60651": 22.6,
  "60652": 22.6,
  "60653": 23.15,
  "60654": 23.15,
  "60655": 23.15,
  "60656": 23.15,
  "60657": 24.74,
  "60659": 23.67,
  "60660": 23.15,
  "60661": 23.15,
  "60664": 23.15,
  "60666": 23.15,
  "60680": 23.15,
  "60681": 23.15,
  "60690": 23.15,
  "60691": 23.15,
  "60699": 23.15,
  "60701": 23.67,
  "60706": 23.67,
  "60707": 23.15,
  "60712": 23.67,
  "60714": 23.67,
  "60803": 23.15,
  "60804": 22.6,
  "60805": 23.15,
  "60827": 20.49,
  "60901": -0.61,
  "60910": -1.13,
  "60911": 4.45,
  "60912": -1.13,
  "60913": 7.88,
  "60914": -0.61,
  "60915": -0.61,
  "60917": -0.61,
  "60918": -1.84,
  "60919": 1.69,
  "60920": 1.17,
  "60921": -3.43,
  "60922": -0.61,
  "60924": 5.52,
  "60926": 3.93,
  "60927": 4.45,
  "60928": 4.45,
  "60929": 1.17,
  "60930": 4.45,
  "60931": 3.93,
  "60932": -3.68,
  "60933": -2.91,
  "60934": 1.69,
  "60935": 23.31,
  "60936": -2.91,
  "60938": 3.93,
  "60939": 3.93,
  "60940": 7.88,
  "60941": -0.61,
  "60942": -4.2,
  "60944": -0.61,
  "60945": 3.93,
  "60946": 1.69,
  "60948": 6.65,
  "60949": -2.36,
  "60950": -0.61,
  "60951": 4.45,
  "60952": -2.91,
  "60953": 3.93,
  "60954": -0.61,
  "60955": 4.45,
  "60956": 4.45,
  "60957": -1.84,
  "60958": 7.88,
  "60959": -3.43,
  "60960": -2.36,
  "60961": 23.31,
  "60962": -2.91,
  "60963": -4.2,
  "60964": -0.61,
  "60966": 3.93,
  "60967": 3.93,
  "60968": -3.43,
  "60969": -0.61,
  "60970": 3.93,
  "60973": 3.93,
  "60974": 3.93,
  "61001": 8.34,
  "61006": -8.22,
  "61007": 17.79,
  "61008": -0.61,
  "61010": 2.82,
  "61011": 7.88,
  "61012": -1.13,
  "61013": 17.27,
  "61014": -12.63,
  "61015": 1.23,
  "61016": -0.61,
  "61018": 17.79,
  "61019": 17.27,
  "61020": 1.23,
  "61021": -9.81,
  "61024": 4.85,
  "61025": 2.7,
  "61027": 17.79,
  "61028": 0.4,
  "61030": 1.23,
  "61031": -8.22,
  "61032": 17.27,
  "61036": 8.34,
  "61037": -2.45,
  "61038": 7.88,
  "61039": 17.79,
  "61041": -0.15,
  "61042": -8.22,
  "61043": 1.23,
  "61044": 17.79,
  "61046": -12.11,
  "61047": 1.23,
  "61048": 17.79,
  "61049": 1.23,
  "61050": 17.27,
  "61051": -12.63,
  "61052": 5.37,
  "61053": -12.11,
  "61054": 1.23,
  "61057": -8.22,
  "61059": -0.15,
  "61060": 17.27,
  "61061": 1.23,
  "61062": 17.79,
  "61063": 5.37,
  "61064": 1.23,
  "61065": -0.61,
  "61067": 17.79,
  "61068": 2.82,
  "61070": 17.79,
  "61071": -2.45,
  "61072": 4.85,
  "61073": 4.85,
  "61074": -12.11,
  "61075": 0.4,
  "61077": 9.72,
  "61078": -12.11,
  "61079": 4.85,
  "61080": -0.21,
  "61081": -2.97,
  "61084": 1.23,
  "61085": -0.15,
  "61087": -0.15,
  "61088": 5.37,
  "61089": 16.75,
  "61091": -9.81,
  "61101": 4.85,
  "61102": 4.85,
  "61103": 4.85,
  "61104": 4.85,
  "61105": 4.85,
  "61106": 4.85,
  "61107": 5.37,
  "61108": 5.37,
  "61109": 5.37,
  "61110": 4.85,
  "61111": 5.37,
  "61112": -0.61,
  "61114": 5.37,
  "61115": 5.37,
  "61125": 5.37,
  "61126": 5.37,
  "61130": 5.37,
  "61131": 5.37,
  "61132": 5.37,
  "61201": 0.31,
  "61204": 0.31,
  "61230": -2.45,
  "61231": -14.41,
  "61232": 0.31,
  "61233": 2.15,
  "61234": 2.15,
  "61235": 2.15,
  "61236": 0.31,
  "61237": -6.44,
  "61238": 2.15,
  "61239": 0.31,
  "61240": 8.8,
  "61241": 0.31,
  "61242": 0.86,
  "61243": -1.9,
  "61244": 0.31,
  "61250": -2.45,
  "61251": -2.45,
  "61252": -2.45,
  "61254": 10.64,
  "61256": 0.86,
  "61257": 2.7,
  "61258": -2.45,
  "61259": -6.44,
  "61260": -14.93,
  "61261": -2.45,
  "61262": 3.74,
  "61263": -14.93,
  "61264": 0.31,
  "61265": 0.31,
  "61266": 0.31,
  "61270": -1.9,
  "61272": -14.93,
  "61273": 1.9,
  "61274": 2.7,
  "61275": 8.8,
  "61276": -14.93,
  "61277": -2.45,
  "61278": 8.8,
  "61279": -13.34,
  "61281": 0.86,
  "61282": 0.31,
  "61283": -2.45,
  "61284": 8.28,
  "61285": -12.11,
  "61301": 10.18,
  "61310": -8.22,
  "61311": 3.28,
  "61312": 4.2,
  "61313": 3.28,
  "61314": 2.61,
  "61315": 2.09,
  "61316": 8.59,
  "61317": 4.2,
  "61318": -8.22,
  "61319": 3.28,
  "61320": 10.18,
  "61321": -5.92,
  "61322": 2.09,
  "61323": 2.61,
  "61324": -8.22,
  "61325": 9.66,
  "61326": 2.61,
  "61327": 2.61,
  "61328": 4.2,
  "61329": 4.2,
  "61330": 4.2,
  "61331": -8.22,
  "61332": 8.59,
  "61333": 3.28,
  "61334": -7.51,
  "61335": -7.51,
  "61336": -7.51,
  "61337": 4.2,
  "61338": 2.61,
  "61340": 2.61,
  "61341": 9.66,
  "61342": 10.18,
  "61344": 2.15,
  "61345": 10.89,
  "61346": 2.61,
  "61348": 10.18,
  "61349": 4.2,
  "61350": 10.18,
  "61353": 9.81,
  "61354": 10.18,
  "61356": 2.61,
  "61358": -6.44,
  "61359": 4.2,
  "61360": 24.38,
  "61361": 2.61,
  "61362": 2.61,
  "61363": 8.59,
  "61364": 10.18,
  "61367": -8.22,
  "61368": 2.61,
  "61369": -7.51,
  "61370": 8.59,
  "61371": 10.18,
  "61372": 10.18,
  "61373": 10.73,
  "61374": 4.2,
  "61375": -7.51,
  "61376": 2.61,
  "61377": -7.51,
  "61378": -8.22,
  "61379": 2.61,
  "61401": -7.51,
  "61402": -7.51,
  "61410": -8.03,
  "61411": -4.35,
  "61412": -14.93,
  "61413": 2.15,
  "61414": -7.51,
  "61415": -8.43,
  "61416": 35.21,
  "61417": -14.41,
  "61418": -18.15,
  "61419": 2.15,
  "61420": 35.73,
  "61421": 10.89,
  "61422": 35.73,
  "61423": -14.41,
  "61424": 10.89,
  "61425": -18.15,
  "61426": 10.37,
  "61427": -8.43,
  "61428": -7.51,
  "61430": -7.51,
  "61431": -8.43,
  "61432": -8.43,
  "61433": -8.43,
  "61434": 2.15,
  "61435": -14.41,
  "61436": -7.51,
  "61437": -18.15,
  "61438": 35.73,
  "61439": -7.51,
  "61440": 35.73,
  "61441": -8.43,
  "61442": -14.93,
  "61443": 10.89,
  "61447": -14.93,
  "61448": -7.51,
  "61449": 10.89,
  "61450": -0.21,
  "61451": 10.89,
  "61452": -3.83,
  "61453": -14.93,
  "61454": -18.15,
  "61455": 35.73,
  "61458": -7.51,
  "61459": -8.43,
  "61460": -18.15,
  "61462": -14.93,
  "61465": -14.41,
  "61466": -7.51,
  "61467": -7.51,
  "61468": 2.15,
  "61469": -18.15,
  "61470": 35.21,
  "61471": -18.15,
  "61472": -6.96,
  "61473": -14.93,
  "61474": -8.03,
  "61475": 35.73,
  "61476": -14.93,
  "61477": -8.43,
  "61478": -14.93,
  "61479": 10.89,
  "61480": -18.15,
  "61482": 35.73,
  "61483": 10.89,
  "61484": -4.35,
  "61485": -8.03,
  "61486": -14.93,
  "61488": -7.51,
  "61489": -7.51,
  "61490": 2.15,
  "61491": 10.89,
  "61501": -4.35,
  "61516": 3.74,
  "61517": 12.02,
  "61519": -8.95,
  "61520": 10.43,
  "61523": 10.43,
  "61524": -8.43,
  "61525": 18.92,
  "61526": 18.92,
  "61528": 18.92,
  "61529": 10.43,
  "61530": 2.15,
  "61531": -8.43,
  "61532": -9.35,
  "61533": 10.43,
  "61534": 1.69,
  "61535": 10.18,
  "61536": 10.43,
  "61537": -7.51,
  "61539": 1.69,
  "61540": -7.51,
  "61541": -8.03,
  "61542": -9.87,
  "61543": -9.87,
  "61544": -8.43,
  "61545": 2.15,
  "61546": -9.35,
  "61547": 18.92,
  "61548": 10.64,
  "61550": 10.18,
  "61552": 10.43,
  "61553": -8.43,
  "61554": 1.69,
  "61555": 1.69,
  "61559": 10.89,
  "61560": -5.92,
  "61561": 2.15,
  "61562": 10.43,
  "61563": -8.95,
  "61564": 1.69,
  "61565": -7.51,
  "61567": -9.87,
  "61568": 10.18,
  "61569": 10.43,
  "61570": -7.51,
  "61571": 1.69,
  "61572": -7.51,
  "61601": 10.43,
  "61602": 10.43,
  "61603": 9.91,
  "61604": 10.43,
  "61605": 9.91,
  "61606": 10.43,
  "61607": 10.43,
  "61610": 1.69,
  "61611": 10.43,
  "61612": 10.43,
  "61614": 10.43,
  "61615": 12.02,
  "61616": 10.43,
  "61650": 10.18,
  "61651": 10.43,
  "61652": 10.43,
  "61653": 10.43,
  "61654": 10.43,
  "61655": 10.43,
  "61656": 10.43,
  "61701": 0.92,
  "61702": 3.03,
  "61704": 9.41,
  "61705": 9.41,
  "61720": -1.32,
  "61721": -12.42,
  "61722": 0.92,
  "61723": -12.42,
  "61724": 0.77,
  "61725": 5.33,
  "61726": 3.28,
  "61727": -3.89,
  "61728": 1.44,
  "61729": 5.33,
  "61730": 1.44,
  "61731": -1.32,
  "61732": 1.44,
  "61733": 1.69,
  "61734": 1.69,
  "61735": -2.3,
  "61736": 1.44,
  "61737": 0.92,
  "61738": 3.74,
  "61739": 3.28,
  "61740": 3.28,
  "61741": 3.28,
  "61742": 5.33,
  "61743": 2.76,
  "61744": 1.44,
  "61745": -1.78,
  "61747": 1.69,
  "61748": 3.03,
  "61749": -4.41,
  "61750": -4.41,
  "61751": -12.42,
  "61752": 1.44,
  "61753": 1.44,
  "61754": -2.3,
  "61755": 10.18,
  "61756": -4.41,
  "61758": 9.93,
  "61759": 2.76,
  "61760": 3.74,
  "61761": 1.44,
  "61764": 3.28,
  "61769": 1.17,
  "61770": -1.84,
  "61771": 3.74,
  "61772": 0.92,
  "61773": -1.84,
  "61774": 0.92,
  "61775": -1.32,
  "61776": 1.44,
  "61777": -2.3,
  "61778": -2.3,
  "61801": 3.43,
  "61802": 1.84,
  "61803": 3.43,
  "61810": 3.16,
  "61811": -4.2,
  "61812": -4.2,
  "61813": -9.93,
  "61814": -4.2,
  "61815": 0.77,
  "61816": 3.68,
  "61817": -3.68,
  "61818": -9.93,
  "61820": 0.77,
  "61821": 1.32,
  "61822": 9.81,
  "61824": 0.77,
  "61825": 0.77,
  "61826": 9.81,
  "61830": -9.41,
  "61831": -3.68,
  "61832": -4.2,
  "61833": -4.2,
  "61834": -4.2,
  "61839": -8.89,
  "61840": 1.32,
  "61841": -4.2,
  "61842": -2.82,
  "61843": 1.32,
  "61844": -4.2,
  "61845": -2.36,
  "61846": -4.2,
  "61847": 1.84,
  "61848": -4.2,
  "61849": 1.84,
  "61850": -4.2,
  "61851": -8.89,
  "61852": 3.16,
  "61853": 1.32,
  "61854": -8.34,
  "61855": -9.93,
  "61856": -8.34,
  "61857": -4.2,
  "61858": -4.2,
  "61859": 1.84,
  "61862": 1.84,
  "61863": 2.61,
  "61864": 10.33,
  "61865": -4.2,
  "61866": 1.84,
  "61870": 1.57,
  "61871": 1.84,
  "61872": -8.89,
  "61873": 10.33,
  "61874": 9.81,
  "61875": 1.32,
  "61876": -9.26,
  "61877": 2.91,
  "61878": 1.84,
  "61880": 1.32,
  "61882": -4.41,
  "61883": -4.2,
  "61884": -6.75,
  "61910": 2.61,
  "61911": 1.57,
  "61912": -4.87,
  "61913": 2.61,
  "61914": 1.57,
  "61917": -10.85,
  "61919": 3.68,
  "61920": 3.16,
  "61924": -10.85,
  "61925": -0.27,
  "61928": 1.57,
  "61929": 1.57,
  "61930": 3.16,
  "61931": -3.83,
  "61932": -9.26,
  "61933": -10.85,
  "61936": 1.57,
  "61937": 1.57,
  "61938": -4.87,
  "61940": -9.26,
  "61941": 3.16,
  "61942": 3.16,
  "61943": 3.16,
  "61944": -10.85,
  "61949": -10.85,
  "61951": 2.09,
  "61953": 3.16,
  "61955": -10.85,
  "61956": 3.16,
  "61957": -16.37,
  "62001": 3.01,
  "62002": 2.49,
  "62006": 0.46,
  "62009": -9.47,
  "62010": 2.49,
  "62011": -13.03,
  "62012": -9.01,
  "62013": 2.3,
  "62014": -9.47,
  "62015": -3.03,
  "62016": -15.45,
  "62017": -3.03,
  "62018": 2.49,
  "62019": -10.85,
  "62021": 10.98,
  "62022": -8.49,
  "62023": -9.47,
  "62024": 2.49,
  "62025": 3.01,
  "62027": 0.46,
  "62028": -8.49,
  "62030": -9.56,
  "62031": 0.46,
  "62032": -3.03,
  "62033": -9.47,
  "62034": 4.08,
  "62035": -8.49,
  "62036": 2.3,
  "62037": -6.9,
  "62040": 2.49,
  "62044": -15.45,
  "62045": 0.46,
  "62046": 2.49,
  "62047": 0.46,
  "62048": 2.49,
  "62049": -3.03,
  "62050": -16,
  "62051": -1.99,
  "62052": -9.01,
  "62053": 0.46,
  "62054": -9.01,
  "62056": -3.03,
  "62058": 2.49,
  "62059": 1.48,
  "62060": 2.49,
  "62061": 2.49,
  "62062": 2.49,
  "62063": -9.01,
  "62065": 0.46,
  "62067": 2.49,
  "62069": -9.47,
  "62070": 0.46,
  "62071": 1.48,
  "62074": -10.85,
  "62075": -1.99,
  "62076": -6.71,
  "62077": -11.4,
  "62078": -16,
  "62079": -0.52,
  "62080": -14.07,
  "62081": -15.45,
  "62082": -15.45,
  "62083": -6.71,
  "62084": 2.49,
  "62085": -9.47,
  "62086": -10.85,
  "62087": 2.49,
  "62088": -9.47,
  "62089": -3.03,
  "62090": 1.94,
  "62091": -3.03,
  "62092": -15.45,
  "62093": -9.47,
  "62094": -2.51,
  "62095": 2.49,
  "62097": 3.01,
  "62098": -15.45,
  "62201": 1.48,
  "62202": 1.48,
  "62203": 2.03,
  "62204": 1.48,
  "62205": 2.03,
  "62206": 2.03,
  "62207": 1.48,
  "62208": 3.07,
  "62214": -7.51,
  "62215": -0.15,
  "62216": -0.15,
  "62217": -5.27,
  "62218": 0.92,
  "62219": -0.67,
  "62220": 3.07,
  "62221": 3.07,
  "62222": 3.07,
  "62223": 3.07,
  "62225": 2.55,
  "62226": 3.07,
  "62230": 0.92,
  "62231": -0.15,
  "62232": 2.03,
  "62233": -5.27,
  "62234": 2.49,
  "62236": 7.3,
  "62237": -5.27,
  "62238": -5.27,
  "62239": 2.03,
  "62240": 8.93,
  "62241": -5.27,
  "62242": -5.27,
  "62243": 11.04,
  "62244": 7.82,
  "62245": 0.92,
  "62246": -10.85,
  "62247": -13.55,
  "62248": -0.15,
  "62249": -1.84,
  "62250": -0.67,
  "62252": -0.15,
  "62253": -10.33,
  "62254": 4.14,
  "62255": -5.27,
  "62256": 7.82,
  "62257": -5.27,
  "62258": 3.07,
  "62259": -5.27,
  "62260": 11.04,
  "62261": -5.27,
  "62262": -10.85,
  "62263": -8.03,
  "62264": -0.15,
  "62265": -0.67,
  "62266": -0.67,
  "62268": -7.51,
  "62269": 11.04,
  "62271": -7.51,
  "62272": -5.27,
  "62273": -10.33,
  "62274": -8.49,
  "62275": -10.33,
  "62277": -4.75,
  "62278": 0.92,
  "62279": -4.75,
  "62280": -5.27,
  "62281": 11.5,
  "62282": -5.27,
  "62284": -9.81,
  "62285": 11.04,
  "62286": -5.27,
  "62288": -4.75,
  "62289": 2.55,
  "62292": -5.27,
  "62293": 7.82,
  "62294": 3.01,
  "62295": 7.82,
  "62297": -5.27,
  "62298": 7.82,
  "62301": -0.92,
  "62305": -0.92,
  "62306": -0.92,
  "62311": -0.21,
  "62312": -14.26,
  "62313": 0.31,
  "62314": -15.85,
  "62316": 0.31,
  "62319": -3.83,
  "62320": -1.99,
  "62321": 0.31,
  "62323": -15.39,
  "62324": -15.39,
  "62325": -1.99,
  "62326": 35.73,
  "62329": -0.21,
  "62330": -0.21,
  "62334": -0.21,
  "62336": -0.21,
  "62338": -1.99,
  "62339": -1.99,
  "62340": -15.33,
  "62341": -0.21,
  "62343": 0,
  "62344": -4.35,
  "62345": -14.26,
  "62346": -14.87,
  "62347": -1.99,
  "62348": -1.99,
  "62349": -1.99,
  "62351": -1.99,
  "62352": 12.15,
  "62353": -14.87,
  "62354": 0.31,
  "62355": -14.26,
  "62356": -14.26,
  "62357": -15.33,
  "62358": -0.21,
  "62359": -1.99,
  "62360": -0.92,
  "62361": 12.15,
  "62362": -15.39,
  "62363": -14.26,
  "62365": -0.92,
  "62366": -14.26,
  "62367": 35.21,
  "62370": -14.26,
  "62373": -0.21,
  "62374": 35.73,
  "62375": -15.39,
  "62376": -0.92,
  "62378": -14.87,
  "62379": -0.21,
  "62380": -0.21,
  "62401": -1.13,
  "62410": 31.47,
  "62411": -1.65,
  "62413": -3.95,
  "62414": -1.65,
  "62417": -16.37,
  "62418": -14.07,
  "62419": -15.85,
  "62420": -5.79,
  "62421": -16.37,
  "62422": -16.92,
  "62423": 9.14,
  "62424": -5.33,
  "62425": -16.37,
  "62426": -2.2,
  "62427": -3.95,
  "62428": -5.33,
  "62431": -16.37,
  "62432": -5.33,
  "62433": -3.95,
  "62434": -12.69,
  "62435": -4.87,
  "62436": -5.33,
  "62438": -16.37,
  "62439": -3.95,
  "62440": -4.87,
  "62441": -5.79,
  "62442": -5.79,
  "62443": -1.65,
  "62444": -16.37,
  "62445": -1.65,
  "62446": -13.61,
  "62447": -4.87,
  "62448": -5.33,
  "62449": -3.95,
  "62450": -15.85,
  "62451": -3.95,
  "62452": -15.85,
  "62454": -3.95,
  "62458": -14.07,
  "62459": -5.33,
  "62460": 31.47,
  "62461": -1.13,
  "62462": -0.06,
  "62463": -16.37,
  "62464": -3.95,
  "62465": -16.37,
  "62466": -16.37,
  "62467": 6.84,
  "62468": -4.87,
  "62469": -4.35,
  "62471": -13.55,
  "62473": -1.65,
  "62474": -5.79,
  "62475": -16.37,
  "62476": 31.47,
  "62477": -5.79,
  "62478": -4.5,
  "62479": -5.33,
  "62480": -5.33,
  "62481": -5.33,
  "62501": -0.27,
  "62510": -6.71,
  "62512": -14.53,
  "62513": -0.27,
  "62514": -0.27,
  "62515": -1.07,
  "62517": -6.19,
  "62518": -14.53,
  "62519": -13.49,
  "62520": 7.42,
  "62521": -0.27,
  "62522": -0.27,
  "62523": -0.27,
  "62524": 8.22,
  "62525": -0.27,
  "62526": -0.27,
  "62530": -1.07,
  "62531": -5.67,
  "62532": -0.82,
  "62533": -1.99,
  "62534": -16.37,
  "62535": 8.22,
  "62536": 7.42,
  "62537": -0.27,
  "62538": -1.99,
  "62539": -0.27,
  "62540": -5.67,
  "62541": -13.49,
  "62543": -0.27,
  "62544": -0.27,
  "62545": -1.07,
  "62546": -5.67,
  "62547": -0.27,
  "62548": -14.53,
  "62549": 0.25,
  "62550": -6.71,
  "62551": -0.27,
  "62553": -16.37,
  "62554": 0.25,
  "62555": -6.71,
  "62556": -5.67,
  "62557": -6.71,
  "62558": -1.07,
  "62560": -1.99,
  "62561": -1.07,
  "62563": 7.42,
  "62565": -16.37,
  "62567": -6.71,
  "62568": -5.67,
  "62570": -5.67,
  "62571": -16.37,
  "62572": -2.51,
  "62573": 0.25,
  "62601": -4.29,
  "62610": 12.67,
  "62611": -8.43,
  "62612": -8.43,
  "62613": -1.07,
  "62615": -1.07,
  "62617": -8.43,
  "62618": -8.43,
  "62621": 13.19,
  "62622": -8.43,
  "62624": -4.35,
  "62625": -1.07,
  "62626": -9.47,
  "62627": -8.43,
  "62628": 13.19,
  "62629": 7.42,
  "62630": -9.47,
  "62631": -4.29,
  "62633": -9.35,
  "62634": -13.49,
  "62635": -13.49,
  "62638": -4.29,
  "62639": -3.83,
  "62640": -8.43,
  "62642": -12.11,
  "62643": -13.49,
  "62644": -9.35,
  "62649": -9.47,
  "62650": -4.29,
  "62651": -4.29,
  "62655": -9.35,
  "62656": -13.49,
  "62659": -10.52,
  "62660": -8.43,
  "62661": -1.07,
  "62662": -1.07,
  "62663": 13.19,
  "62664": -9.35,
  "62665": 13.19,
  "62666": -13.49,
  "62667": -8.43,
  "62668": -4.29,
  "62670": -0.52,
  "62671": -13.49,
  "62672": -8.43,
  "62673": -12.11,
  "62674": -8.43,
  "62675": -10.52,
  "62677": -12.11,
  "62681": -3.83,
  "62682": -13.49,
  "62683": -8.43,
  "62684": 7.42,
  "62685": -9.47,
  "62688": -12.11,
  "62689": -1.07,
  "62690": -1.07,
  "62691": -8.43,
  "62692": -4.29,
  "62693": -1.07,
  "62694": 12.67,
  "62695": -4.29,
  "62701": -1.07,
  "62702": -1.07,
  "62703": -1.07,
  "62704": -0.52,
  "62705": -1.07,
  "62707": -1.07,
  "62708": -1.07,
  "62711": -1.07,
  "62712": -1.07,
  "62791": -1.07,
  "62794": -1.07,
  "62801": -2.51,
  "62803": -8.03,
  "62805": -15.85,
  "62806": 31.99,
  "62807": -2.51,
  "62808": -8.03,
  "62809": -13.61,
  "62810": -7.11,
  "62811": 31.47,
  "62812": -11.25,
  "62814": -7.63,
  "62815": 31.47,
  "62816": -7.11,
  "62817": -16.37,
  "62818": 31.47,
  "62819": -11.25,
  "62820": -13.61,
  "62821": -7.17,
  "62822": -11.25,
  "62823": -13.61,
  "62824": -12.69,
  "62825": -11.25,
  "62827": -7.17,
  "62828": -16.37,
  "62829": -15.85,
  "62830": -7.11,
  "62831": -8.03,
  "62832": -8.49,
  "62833": -13.09,
  "62834": -21.83,
  "62835": -16.37,
  "62836": -11.25,
  "62837": -13.61,
  "62838": -14.07,
  "62839": -12.17,
  "62840": -11.25,
  "62841": -6.65,
  "62842": -13.61,
  "62843": -13.61,
  "62844": 31.47,
  "62846": -7.11,
  "62848": -8.03,
  "62849": -2.51,
  "62850": -13.09,
  "62851": -13.09,
  "62852": 31.47,
  "62853": -2.51,
  "62854": -2.51,
  "62855": 31.47,
  "62856": -11.25,
  "62857": -14.07,
  "62858": -12.69,
  "62859": -16.37,
  "62860": -15.85,
  "62861": -7.17,
  "62862": -7.17,
  "62863": 31.47,
  "62864": -7.11,
  "62865": -11.25,
  "62866": -7.11,
  "62867": -21.83,
  "62868": -15.85,
  "62869": -21.83,
  "62870": -2.51,
  "62871": -21.83,
  "62872": -7.11,
  "62874": -11.25,
  "62875": -2.51,
  "62876": -8.03,
  "62877": -8.03,
  "62878": -12.69,
  "62879": -12.69,
  "62880": -13.55,
  "62881": -2.51,
  "62882": -2.51,
  "62883": -8.49,
  "62884": -11.25,
  "62885": -13.55,
  "62886": -13.61,
  "62887": -16.37,
  "62888": -8.49,
  "62889": -7.11,
  "62890": -11.25,
  "62891": -11.25,
  "62892": -2.51,
  "62893": -2.51,
  "62894": -7.11,
  "62895": -13.61,
  "62896": -11.25,
  "62897": -11.25,
  "62898": -6.59,
  "62899": -12.17,
  "62901": -4.75,
  "62902": -4.75,
  "62903": -4.75,
  "62905": -14.01,
  "62906": -14.01,
  "62907": -5.27,
  "62908": -14.99,
  "62909": -7.57,
  "62910": -4.35,
  "62912": -7.57,
  "62914": -13.55,
  "62915": -6.65,
  "62916": -8.49,
  "62917": -3.89,
  "62918": -6.65,
  "62919": -14.01,
  "62920": -14.01,
  "62921": -6.65,
  "62922": -7.57,
  "62923": -14.01,
  "62924": -5.27,
  "62926": -14.01,
  "62927": -8.49,
  "62928": -7.57,
  "62930": -3.89,
  "62931": -14.01,
  "62932": -5.27,
  "62933": -6.13,
  "62934": -21.83,
  "62935": -3.89,
  "62938": -14.47,
  "62939": -7.57,
  "62940": -5.27,
  "62941": -14.47,
  "62942": -5.27,
  "62943": -14.47,
  "62946": -3.89,
  "62947": -7.57,
  "62948": -6.65,
  "62949": -5.27,
  "62950": -5.27,
  "62951": -6.65,
  "62952": -14.01,
  "62953": -14.47,
  "62954": -21.83,
  "62955": -14.53,
  "62956": -14.99,
  "62957": -14.01,
  "62958": -13.49,
  "62959": -6.65,
  "62960": -14.47,
  "62961": -14.01,
  "62962": -13.55,
  "62963": -13.55,
  "62964": -13.55,
  "62965": -3.89,
  "62966": -5.27,
  "62967": -7.57,
  "62969": -14.01,
  "62970": -13.55,
  "62971": -5.27,
  "62972": -7.57,
  "62973": -14.53,
  "62974": -6.65,
  "62975": -5.27,
  "62976": -13.55,
  "62977": -3.89,
  "62979": -21.83,
  "62982": -14.53,
  "62983": -11.25,
  "62984": -22.35,
  "62985": -7.57,
  "62987": -3.89,
  "62988": -14.01,
  "62990": -14.01,
  "62992": -14.53,
  "62993": -14.01,
  "62994": -5.27,
  "62995": -7.57,
  "62996": -13.55,
  "62997": -5.27,
  "62998": -14.01,
  "62999": -11.25,
  "63001": -0.4,
  "63005": 13.61,
  "63006": 18.15,
  "63010": -3.03,
  "63011": 10.18,
  "63012": -3.03,
  "63013": -6.38,
  "63014": -5,
  "63015": -0.4,
  "63016": -3.03,
  "63017": 18.15,
  "63019": -3.03,
  "63020": -3.03,
  "63021": 10.18,
  "63022": 10.18,
  "63023": -3.03,
  "63024": 10.18,
  "63025": -0.4,
  "63026": 7.55,
  "63028": -3.03,
  "63030": -19.13,
  "63031": 9.66,
  "63032": 9.66,
  "63033": 8.07,
  "63034": 16.04,
  "63036": -4.29,
  "63037": -13.8,
  "63038": 11.31,
  "63039": -6.9,
  "63040": 18.15,
  "63041": -3.03,
  "63042": 9.66,
  "63043": 10.18,
  "63044": 10.18,
  "63045": 10.18,
  "63047": -3.03,
  "63048": -3.03,
  "63049": -3.03,
  "63050": -3.03,
  "63051": -3.03,
  "63052": -3.03,
  "63053": -3.03,
  "63055": -6.38,
  "63056": -6.38,
  "63057": -3.03,
  "63060": -3.03,
  "63061": -3.03,
  "63065": -3.03,
  "63066": -3.03,
  "63068": -6.38,
  "63069": -6.38,
  "63070": -3.03,
  "63071": -19.68,
  "63072": -6.38,
  "63073": -6.38,
  "63074": 9.66,
  "63077": -6.9,
  "63079": -9.66,
  "63080": -9.66,
  "63084": -6.38,
  "63087": -4.29,
  "63088": 7.55,
  "63089": -6.38,
  "63090": -6.38,
  "63091": -13.8,
  "63101": 8.93,
  "63102": 8.93,
  "63103": 8.38,
  "63104": 8.93,
  "63105": 16.04,
  "63106": 8.38,
  "63107": 8.38,
  "63108": 8.93,
  "63109": 8.93,
  "63110": 8.93,
  "63111": 8.38,
  "63112": 8.93,
  "63113": 8.38,
  "63114": 7.55,
  "63115": 8.38,
  "63116": 8.93,
  "63117": 7.55,
  "63118": 8.38,
  "63119": 7.55,
  "63120": 8.38,
  "63121": 7,
  "63122": 7.55,
  "63123": 8.93,
  "63124": 18.34,
  "63125": 8.93,
  "63126": 7.55,
  "63127": 7.55,
  "63128": 7.55,
  "63129": 8.93,
  "63130": 7.55,
  "63131": 16.04,
  "63132": 7.55,
  "63133": 7,
  "63134": 7,
  "63135": 7.55,
  "63136": 8.93,
  "63137": 8.93,
  "63138": 2.49,
  "63139": 8.93,
  "63140": 7,
  "63141": 18.67,
  "63143": 7,
  "63144": 7.55,
  "63145": 7,
  "63146": 10.18,
  "63147": 8.38,
  "63151": 8.93,
  "63155": 8.38,
  "63156": 8.93,
  "63157": 8.93,
  "63158": 8.93,
  "63163": 8.38,
  "63166": 8.38,
  "63169": 8.93,
  "63177": 8.38,
  "63178": 8.38,
  "63179": 8.38,
  "63188": 8.93,
  "63301": 2.82,
  "63302": 2.82,
  "63303": 2.82,
  "63304": 2.82,
  "63330": 0,
  "63332": -6.38,
  "63333": -1.84,
  "63334": -4.14,
  "63336": -4.14,
  "63338": 2.82,
  "63339": -4.14,
  "63341": 10.79,
  "63342": -6.38,
  "63343": 0,
  "63344": -3.62,
  "63345": -9.66,
  "63346": 2.82,
  "63347": 0,
  "63348": -5,
  "63349": 0,
  "63350": -1.84,
  "63351": -1.84,
  "63352": -9.66,
  "63353": -4.14,
  "63357": -5,
  "63359": -1.84,
  "63361": -1.84,
  "63362": 0,
  "63363": -1.84,
  "63365": 10.79,
  "63366": 2.82,
  "63367": 2.82,
  "63368": 2.82,
  "63369": 0,
  "63370": 0.52,
  "63373": -8.49,
  "63376": 2.82,
  "63377": 0.52,
  "63378": -5,
  "63379": 0.52,
  "63381": -1.84,
  "63382": -5.52,
  "63383": -5,
  "63384": -1.84,
  "63385": 2.82,
  "63386": 2.49,
  "63387": 0,
  "63388": -0.86,
  "63389": 0.52,
  "63390": -5,
  "63401": 0,
  "63430": -16.56,
  "63431": -7.76,
  "63432": -8.22,
  "63433": -4.14,
  "63434": -8.28,
  "63435": -8.28,
  "63436": -5.52,
  "63437": -8.28,
  "63438": -8.28,
  "63439": -8.28,
  "63440": -8.28,
  "63441": -5.52,
  "63442": -8.22,
  "63443": -17.94,
  "63445": -16.04,
  "63446": -25.3,
  "63447": -8.28,
  "63448": -8.28,
  "63450": -6.69,
  "63451": -8.28,
  "63452": -8.28,
  "63453": -16.04,
  "63454": -8.28,
  "63456": -5.52,
  "63457": -7.76,
  "63458": -25.3,
  "63459": -5.52,
  "63460": -25.3,
  "63461": 0.52,
  "63462": -5.52,
  "63463": 0,
  "63464": -25.3,
  "63465": -16.56,
  "63466": -16.56,
  "63467": -5.52,
  "63468": -8.28,
  "63469": -8.28,
  "63471": 0,
  "63472": -16.56,
  "63473": -16.56,
  "63474": -16.56,
  "63501": -7.76,
  "63530": -16.1,
  "63531": -25.3,
  "63532": -16.1,
  "63533": -8.28,
  "63534": -16.1,
  "63535": -8.43,
  "63536": -8.74,
  "63537": -25.3,
  "63538": -16.1,
  "63539": -16.1,
  "63540": -8.28,
  "63541": -8.43,
  "63543": -8.74,
  "63544": -8.28,
  "63545": -20.24,
  "63546": -8.28,
  "63547": -25.3,
  "63548": -6.84,
  "63549": -8.28,
  "63551": -12.17,
  "63552": -16.1,
  "63555": -8.22,
  "63556": -20.24,
  "63557": -7.36,
  "63558": -16.1,
  "63559": -8.28,
  "63560": -21.83,
  "63561": -9.87,
  "63563": -8.74,
  "63565": -21.83,
  "63566": -7.36,
  "63567": -9.87,
  "63601": -4.81,
  "63620": -21.37,
  "63621": -21.37,
  "63622": -19.13,
  "63623": -22.44,
  "63624": -4.81,
  "63625": -21.89,
  "63626": -19.68,
  "63627": -0.46,
  "63628": -4.29,
  "63629": -19.22,
  "63630": -19.68,
  "63631": -19.13,
  "63632": -15.39,
  "63633": -22.44,
  "63636": -23.21,
  "63637": -4.81,
  "63638": -14.78,
  "63640": -4.29,
  "63645": -15.39,
  "63648": -5.88,
  "63650": -21.37,
  "63651": -4.29,
  "63653": -4.81,
  "63654": -21.37,
  "63655": -15.39,
  "63656": -4.81,
  "63660": -19.68,
  "63662": -7.57,
  "63663": -21.37,
  "63664": -19.68,
  "63665": -21.37,
  "63666": -14.78,
  "63670": -1.53,
  "63673": -1.53,
  "63674": -19.68,
  "63675": -21.37,
  "63701": 3.68,
  "63702": 3.68,
  "63703": -4.81,
  "63730": -6.5,
  "63732": -5.67,
  "63735": -5.21,
  "63736": -5.73,
  "63737": -5.67,
  "63738": -2.91,
  "63739": 3.68,
  "63740": -5.73,
  "63742": -5.73,
  "63743": -6.19,
  "63744": -5.73,
  "63745": -5.73,
  "63746": -5.67,
  "63747": -5.67,
  "63748": -5.67,
  "63750": -7.05,
  "63751": -7.57,
  "63752": 3.68,
  "63755": 3.68,
  "63758": -5.21,
  "63760": -7.05,
  "63763": 6.13,
  "63764": -7.57,
  "63766": 0.92,
  "63767": -4.66,
  "63769": -4.29,
  "63770": -6.19,
  "63771": -5.73,
  "63774": -5.73,
  "63775": -5.67,
  "63776": -5.67,
  "63779": 3.68,
  "63780": -4.29,
  "63781": -7.05,
  "63782": -6.5,
  "63783": -6.19,
  "63784": -4.66,
  "63785": -7.57,
  "63787": -6.5,
  "63801": -3.07,
  "63820": -5.21,
  "63821": -0.61,
  "63822": -2.36,
  "63823": -5.21,
  "63824": -5.21,
  "63825": -2.36,
  "63826": -2.91,
  "63827": -10.18,
  "63828": -12.57,
  "63829": -0.06,
  "63830": -2.91,
  "63833": -12.02,
  "63834": -5.21,
  "63837": -10.73,
  "63839": 8.22,
  "63840": -2.36,
  "63841": -2.36,
  "63845": -12.57,
  "63846": -2.36,
  "63847": -10.73,
  "63848": -10.18,
  "63849": -10.18,
  "63850": -2.91,
  "63851": -10.18,
  "63852": -10.18,
  "63853": 8.22,
  "63855": 8.22,
  "63857": -10.18,
  "63860": -12.57,
  "63862": -12.02,
  "63863": -12.02,
  "63866": -12.57,
  "63867": -12.57,
  "63868": -2.91,
  "63869": -12.57,
  "63870": -12.02,
  "63873": -12.02,
  "63874": -12.57,
  "63875": -10.18,
  "63876": -10.18,
  "63877": -10.18,
  "63878": -12.57,
  "63879": -10.18,
  "63880": -10.18,
  "63881": -12.57,
  "63882": -5.21,
  "63901": -5.58,
  "63902": -5.58,
  "63931": -19.84,
  "63932": -5.58,
  "63933": -10.18,
  "63934": -23.21,
  "63935": -19.84,
  "63936": -2.36,
  "63937": -14.78,
  "63938": -17.08,
  "63939": -19.84,
  "63940": -5.58,
  "63941": -14.78,
  "63942": -19.84,
  "63943": -14.78,
  "63944": -22.14,
  "63945": -5.58,
  "63950": -23.21,
  "63951": -22.14,
  "63952": -22.69,
  "63953": -19.84,
  "63954": -6.13,
  "63955": -19.84,
  "63956": -13.65,
  "63957": -22.14,
  "63960": -2.36,
  "63961": -5.58,
  "63962": -5.58,
  "63963": -22.69,
  "63964": -23.21,
  "63965": -14.78,
  "63966": -22.14,
  "63967": -22.14,
  "64001": -12.11,
  "64011": -12.11,
  "64012": -0.86,
  "64013": 8.68,
  "64014": 8.68,
  "64015": 8.68,
  "64016": 8.13,
  "64017": -10.27,
  "64018": 7.21,
  "64019": -10.27,
  "64020": -12.11,
  "64021": -12.11,
  "64022": -12.11,
  "64024": -10.27,
  "64028": 7.21,
  "64029": 8.68,
  "64030": 8.13,
  "64034": -1.9,
  "64035": -10.27,
  "64036": -10.27,
  "64037": -12.11,
  "64040": -10.27,
  "64048": 2.24,
  "64050": 8.13,
  "64051": 8.13,
  "64052": 8.13,
  "64053": 8.13,
  "64054": 8.13,
  "64055": 8.13,
  "64056": 8.13,
  "64057": 8.68,
  "64058": 4.45,
  "64060": 5,
  "64061": -1.9,
  "64062": -9.72,
  "64063": 8.68,
  "64064": 16.62,
  "64066": -10.27,
  "64067": -12.11,
  "64068": 5,
  "64069": 5,
  "64070": -1.9,
  "64071": -12.11,
  "64072": 4.45,
  "64073": -10.27,
  "64074": -11.56,
  "64075": 8.68,
  "64076": -11.56,
  "64077": -10.27,
  "64078": -0.31,
  "64079": 7.21,
  "64080": -1.9,
  "64081": 8.68,
  "64082": 6.04,
  "64083": -1.9,
  "64084": -10.27,
  "64085": -10.27,
  "64086": 8.68,
  "64088": -9.72,
  "64089": 7.21,
  "64090": -2.45,
  "64092": 6.17,
  "64093": -10.27,
  "64096": 2.15,
  "64097": -12.11,
  "64098": 7.21,
  "64101": 8.68,
  "64102": 8.68,
  "64105": 8.13,
  "64106": 8.13,
  "64108": 8.13,
  "64109": 8.13,
  "64110": 8.13,
  "64111": 8.13,
  "64112": 16.62,
  "64113": 16.62,
  "64114": 8.68,
  "64116": 5,
  "64117": 4.45,
  "64118": 3.41,
  "64119": 5,
  "64120": 8.13,
  "64121": 8.13,
  "64123": 8.13,
  "64124": 8.13,
  "64125": 8.13,
  "64126": 8.13,
  "64127": 8.13,
  "64128": 8.13,
  "64129": 8.13,
  "64130": 8.13,
  "64131": 8.13,
  "64132": 8.13,
  "64133": 8.13,
  "64134": 8.13,
  "64136": 8.68,
  "64137": 8.13,
  "64138": 8.13,
  "64139": 16.62,
  "64141": 8.13,
  "64145": 8.43,
  "64146": 8.68,
  "64147": 16.92,
  "64148": 8.13,
  "64149": 16.62,
  "64150": 3.87,
  "64151": 3.87,
  "64152": 6.17,
  "64153": 8.8,
  "64154": 6.17,
  "64155": 3.41,
  "64156": 4.45,
  "64157": 5,
  "64158": 12.94,
  "64161": 4.45,
  "64163": 7.21,
  "64164": 6.17,
  "64165": 3.41,
  "64166": 12.94,
  "64167": 12.94,
  "64168": 3.87,
  "64171": 8.13,
  "64172": 8.13,
  "64179": 8.13,
  "64188": 8.13,
  "64190": 6.17,
  "64191": 8.13,
  "64192": 8.13,
  "64195": 8.8,
  "64196": 8.68,
  "64199": 8.68,
  "64401": 19.78,
  "64402": -12.63,
  "64420": -13.15,
  "64421": -7.57,
  "64422": -7.57,
  "64423": -3.68,
  "64424": -20.45,
  "64426": -20.97,
  "64427": -8.09,
  "64428": -12.69,
  "64429": 1.17,
  "64430": -7.57,
  "64431": -12.17,
  "64432": -12.17,
  "64433": -12.69,
  "64434": -12.17,
  "64436": 0.92,
  "64437": -14.53,
  "64438": -13.15,
  "64439": 19.78,
  "64440": 11.29,
  "64441": -12.63,
  "64442": -20.97,
  "64443": 19.78,
  "64444": 7.21,
  "64445": -12.69,
  "64446": -14.53,
  "64448": 19.78,
  "64449": -8.09,
  "64451": -14.53,
  "64453": -13.15,
  "64454": 9.66,
  "64455": -14.01,
  "64456": -13.15,
  "64457": -13.15,
  "64458": -11.96,
  "64459": -7.57,
  "64461": -12.69,
  "64463": -12.63,
  "64465": 9.66,
  "64466": -14.53,
  "64467": -20.97,
  "64468": -3.68,
  "64469": -7.57,
  "64470": -14.01,
  "64471": -20.97,
  "64473": -14.01,
  "64474": 1.17,
  "64475": -12.69,
  "64476": -12.17,
  "64477": 9.66,
  "64479": -12.17,
  "64480": -7.57,
  "64481": -20.97,
  "64482": -15.85,
  "64483": -7.57,
  "64484": -7.05,
  "64485": -5.98,
  "64486": -12.69,
  "64487": -12.69,
  "64489": -13.15,
  "64490": -7.57,
  "64491": -14.53,
  "64492": 1.69,
  "64493": 1.17,
  "64494": -7.57,
  "64496": -15.85,
  "64497": -7.57,
  "64498": -16.77,
  "64499": -13.15,
  "64501": 11.29,
  "64502": 11.29,
  "64503": 11.29,
  "64504": 11.29,
  "64505": 11.29,
  "64506": 19.78,
  "64507": 11.29,
  "64508": 19.78,
  "64601": -10.33,
  "64620": -2.05,
  "64622": 2.15,
  "64623": 3.22,
  "64624": 33.89,
  "64625": 32.85,
  "64628": -7.36,
  "64630": -20.24,
  "64631": -7.36,
  "64632": -12.69,
  "64633": 2.15,
  "64635": -10.85,
  "64636": -2.57,
  "64637": 33.89,
  "64638": -9.81,
  "64639": 3.22,
  "64640": -2.05,
  "64641": -13.61,
  "64642": -13.61,
  "64643": 3.22,
  "64644": 33.37,
  "64645": -21.83,
  "64646": -22.35,
  "64647": -2.57,
  "64648": -2.05,
  "64649": 33.37,
  "64650": 33.37,
  "64651": -7.36,
  "64652": -13.61,
  "64653": -7.36,
  "64654": -2.05,
  "64655": -12.17,
  "64656": -10.85,
  "64657": -13.15,
  "64658": -15.64,
  "64659": -7.36,
  "64660": -15.64,
  "64661": -12.17,
  "64664": -10.85,
  "64667": -12.17,
  "64668": 2.15,
  "64670": -2.05,
  "64671": 33.89,
  "64672": -12.17,
  "64673": -12.69,
  "64674": -7.36,
  "64676": -15.64,
  "64679": -13.61,
  "64680": 2.15,
  "64681": -7.36,
  "64682": 2.15,
  "64683": -13.61,
  "64686": -10.85,
  "64688": -10.85,
  "64689": -2.57,
  "64701": -0.31,
  "64720": -9.14,
  "64722": -9.14,
  "64723": -9.14,
  "64724": -9.14,
  "64725": -0.86,
  "64726": -2.91,
  "64728": -9.87,
  "64730": -9.14,
  "64733": -10.27,
  "64734": -0.31,
  "64735": -2.91,
  "64738": -8.03,
  "64739": -1.32,
  "64740": -2.91,
  "64741": -1.38,
  "64742": -0.86,
  "64743": -2.45,
  "64744": -8.03,
  "64745": -9.14,
  "64746": -0.86,
  "64747": -0.31,
  "64748": -14.47,
  "64750": -9.87,
  "64752": -9.14,
  "64755": -14.47,
  "64756": -8.03,
  "64759": -14.47,
  "64761": -10.27,
  "64762": -14.47,
  "64763": -3.43,
  "64765": -9.14,
  "64766": -8.03,
  "64767": -9.87,
  "64769": -14.47,
  "64770": -1.32,
  "64771": -9.87,
  "64772": -9.87,
  "64776": -16.77,
  "64778": -8.28,
  "64779": -9.14,
  "64780": -9.14,
  "64781": -8.03,
  "64783": -9.87,
  "64784": -14.47,
  "64788": -1.32,
  "64790": -9.87,
  "64801": 0.71,
  "64802": 2.3,
  "64803": 2.3,
  "64804": 2.3,
  "64830": 0.71,
  "64831": -12.48,
  "64832": 0.71,
  "64833": 0.71,
  "64834": 2.3,
  "64835": 0.71,
  "64836": 0.71,
  "64840": -6.19,
  "64841": 0.71,
  "64842": -6.19,
  "64843": -13.55,
  "64844": -6.19,
  "64847": -13.03,
  "64848": -8.49,
  "64849": 0.19,
  "64850": -6.19,
  "64853": -6.19,
  "64854": -12.48,
  "64855": 1.23,
  "64856": -12.48,
  "64857": 0.71,
  "64858": -6.19,
  "64859": 0.71,
  "64861": -12.48,
  "64862": 0.71,
  "64863": -12.48,
  "64864": 2.3,
  "64865": -6.19,
  "64866": -6.19,
  "64867": -13.55,
  "64868": -12.48,
  "64869": 0.71,
  "64870": 1.23,
  "64873": 0,
  "64874": -13.4,
  "65001": -7.82,
  "65010": 6.65,
  "65011": -9.66,
  "65013": -7.82,
  "65014": -13.8,
  "65016": -7.3,
  "65017": -11.5,
  "65018": -2.7,
  "65020": 7.67,
  "65023": 0.06,
  "65024": -7.82,
  "65025": -3.22,
  "65026": -11.5,
  "65032": -10.98,
  "65034": -3.22,
  "65035": -7.3,
  "65036": -13.8,
  "65037": -9.14,
  "65038": -9.14,
  "65039": 8.03,
  "65040": -10.98,
  "65041": -13.28,
  "65042": -2.7,
  "65043": 0.06,
  "65046": -3.22,
  "65047": -10.98,
  "65048": -7.82,
  "65049": 17.23,
  "65050": -2.7,
  "65051": -7.3,
  "65052": 9.26,
  "65053": 8.03,
  "65054": -7.3,
  "65055": -2.7,
  "65058": -10.98,
  "65059": -0.86,
  "65061": -5.31,
  "65062": -5.31,
  "65063": -0.86,
  "65064": -10.98,
  "65065": 17.23,
  "65066": -13.8,
  "65067": -1.38,
  "65068": -3.22,
  "65069": -1.32,
  "65072": -1.17,
  "65074": -2.7,
  "65075": -10.98,
  "65076": -2.7,
  "65077": -1.38,
  "65078": -9.66,
  "65079": 17.23,
  "65080": -0.86,
  "65081": -3.22,
  "65082": -11.5,
  "65083": -11.5,
  "65084": -9.66,
  "65085": -7.3,
  "65101": 0.06,
  "65102": 0.06,
  "65109": 0.06,
  "65110": 0.06,
  "65201": -1.32,
  "65202": -1.32,
  "65203": 6.65,
  "65205": -1.32,
  "65230": -13.8,
  "65231": -0.86,
  "65232": -9.66,
  "65233": -8.22,
  "65236": -15.64,
  "65237": -8.74,
  "65239": -7.82,
  "65240": -1.32,
  "65243": -7.82,
  "65244": -7.82,
  "65246": -15.64,
  "65247": -7.82,
  "65248": -13.8,
  "65250": -13.8,
  "65251": -0.86,
  "65254": -13.8,
  "65255": -1.32,
  "65256": -13.28,
  "65257": -7.82,
  "65258": -17.94,
  "65259": -7.82,
  "65260": -7.82,
  "65261": -15.64,
  "65262": 7.11,
  "65263": -17.94,
  "65264": -9.66,
  "65265": -9.66,
  "65270": -7.82,
  "65274": -13.8,
  "65275": -17.94,
  "65276": -8.74,
  "65278": -7.82,
  "65279": -1.32,
  "65280": -9.66,
  "65281": -15.64,
  "65282": -9.14,
  "65283": -17.42,
  "65284": -1.32,
  "65285": -9.14,
  "65286": -15.64,
  "65287": -1.32,
  "65301": -4.6,
  "65302": -4.6,
  "65305": -10.27,
  "65320": -10.12,
  "65321": -11.19,
  "65322": -8.74,
  "65323": -2.91,
  "65324": 17.23,
  "65325": -10.58,
  "65326": -10.58,
  "65327": -12.11,
  "65329": -4.08,
  "65330": -10.12,
  "65332": -4.6,
  "65333": -4.6,
  "65334": -4.08,
  "65335": -10.58,
  "65336": -10.27,
  "65337": -4.6,
  "65338": -10.58,
  "65339": -10.12,
  "65340": -10.12,
  "65344": -10.12,
  "65345": -10.58,
  "65347": -10.12,
  "65348": -8.74,
  "65349": -10.12,
  "65350": -4.6,
  "65351": -10.12,
  "65354": -8.74,
  "65355": -12.17,
  "65360": -2.91,
  "65401": -7.3,
  "65402": -7.3,
  "65436": -9.41,
  "65438": -8.34,
  "65439": -19.22,
  "65440": -19.22,
  "65441": -9.66,
  "65443": -13.34,
  "65444": -15.85,
  "65446": -12.32,
  "65449": -9.14,
  "65452": -13.34,
  "65453": -9.66,
  "65456": -12.32,
  "65457": -13.34,
  "65459": -13.34,
  "65461": -9.41,
  "65462": -9.41,
  "65463": -4.81,
  "65464": -6.84,
  "65466": -8.34,
  "65468": -15.33,
  "65470": -4.29,
  "65473": -14.41,
  "65479": -15.33,
  "65483": -15.33,
  "65484": -15.85,
  "65486": -11.5,
  "65501": -17.63,
  "65529": -7.82,
  "65532": -7.3,
  "65534": -14.93,
  "65535": -9.66,
  "65536": -4.29,
  "65541": -18.15,
  "65542": -15.85,
  "65543": -13.55,
  "65546": -8.34,
  "65548": -18.15,
  "65550": -7.82,
  "65552": -15.33,
  "65555": -15.85,
  "65556": -14.93,
  "65557": -15.85,
  "65559": -7.82,
  "65560": -16.56,
  "65564": -15.85,
  "65565": -9.66,
  "65566": -19.22,
  "65567": -14.93,
  "65570": -15.85,
  "65571": -9.41,
  "65580": -7.82,
  "65582": -7.82,
  "65583": -14.41,
  "65584": -14.41,
  "65586": -9.66,
  "65588": -8.34,
  "65589": -15.33,
  "65590": -18.61,
  "65591": 7.67,
  "65601": -13.49,
  "65603": -14.47,
  "65604": -3.37,
  "65605": -8.49,
  "65606": -14.32,
  "65607": -7.51,
  "65608": -15.85,
  "65609": -19.99,
  "65610": -7.97,
  "65611": -11.04,
  "65612": -3.37,
  "65613": -13.49,
  "65614": -12.57,
  "65615": -12.57,
  "65616": -12.57,
  "65617": -13.49,
  "65618": -19.47,
  "65619": -3.37,
  "65620": -7.97,
  "65622": -18.09,
  "65623": -13.4,
  "65624": -12.11,
  "65625": -13.4,
  "65626": -19.99,
  "65627": -13.09,
  "65629": -7.97,
  "65630": -4.08,
  "65631": -7.97,
  "65632": -4.81,
  "65633": -12.11,
  "65634": -16.25,
  "65635": -13.95,
  "65636": -12.11,
  "65637": -17.63,
  "65638": -15.33,
  "65640": -14.01,
  "65641": -13.4,
  "65644": -18.09,
  "65645": -13.49,
  "65646": -13.95,
  "65647": -13.4,
  "65648": -3.37,
  "65649": -14.01,
  "65650": -16.25,
  "65652": 0.52,
  "65653": -10.98,
  "65654": -8.49,
  "65655": -19.99,
  "65656": -12.11,
  "65657": -13.09,
  "65658": -11.56,
  "65660": -13.03,
  "65661": -13.95,
  "65662": -4.29,
  "65663": -13.49,
  "65664": -7.97,
  "65666": -19.99,
  "65667": -13.03,
  "65668": -16.77,
  "65669": -7.97,
  "65672": -12.57,
  "65673": -12.57,
  "65674": -14.01,
  "65675": -12.63,
  "65676": -19.47,
  "65679": -12.57,
  "65680": -13.09,
  "65681": -11.04,
  "65682": -14.47,
  "65685": -18.61,
  "65686": -3.62,
  "65688": -14.32,
  "65689": -15.85,
  "65690": -14.32,
  "65692": -14.32,
  "65701": -15.85,
  "65702": -15.85,
  "65704": -13.55,
  "65705": -7.97,
  "65706": -12.11,
  "65707": -8.49,
  "65708": -6.9,
  "65710": -13.49,
  "65711": -13.03,
  "65712": -7.97,
  "65713": -12.63,
  "65714": -6.38,
  "65715": -19.99,
  "65717": -13.55,
  "65720": -7.97,
  "65721": -7.97,
  "65722": -4.81,
  "65723": -8.49,
  "65724": -16.77,
  "65725": -13.49,
  "65726": -12.57,
  "65727": -16.77,
  "65728": -8.49,
  "65729": -19.47,
  "65730": -13.03,
  "65731": -10.98,
  "65732": -16.25,
  "65733": -13.09,
  "65734": -13.4,
  "65735": -16.77,
  "65737": -12.11,
  "65738": -3.37,
  "65739": -4.08,
  "65740": -13.09,
  "65741": -19.47,
  "65742": 0.52,
  "65744": -12.57,
  "65745": -13.4,
  "65746": -12.11,
  "65747": -11.56,
  "65752": -14.47,
  "65753": -7.97,
  "65754": -6.38,
  "65755": -15.33,
  "65756": -8.49,
  "65757": -12.11,
  "65759": -13.09,
  "65760": -19.47,
  "65761": -19.99,
  "65762": -19.47,
  "65764": -18.61,
  "65765": 5.12,
  "65766": -19.99,
  "65767": -16.77,
  "65768": -15.33,
  "65769": -7.97,
  "65770": -13.49,
  "65771": -12.57,
  "65772": -13.4,
  "65773": -19.47,
  "65774": -16.77,
  "65775": -18.15,
  "65776": -17.63,
  "65777": -18.15,
  "65778": -14.32,
  "65779": -16.77,
  "65781": -3.37,
  "65783": -18.61,
  "65784": -19.99,
  "65785": -7.51,
  "65786": 7.15,
  "65787": 7.67,
  "65788": -17.08,
  "65789": -18.15,
  "65790": -17.63,
  "65791": -14.32,
  "65793": -18.15,
  "65801": 5.12,
  "65802": -3.89,
  "65803": -3.37,
  "65804": -1.78,
  "65805": -3.37,
  "65806": -3.89,
  "65807": -3.37,
  "65808": -1.78,
  "65809": 5.12,
  "65810": 5.12,
  "65814": -3.89,
  "65817": -3.37,
  "66002": -7.57,
  "66006": 0.52,
  "66007": -5.67,
  "66008": -2.51,
  "66010": -5,
  "66012": 3.87,
  "66013": 8.43,
  "66014": -5,
  "66015": -15.18,
  "66016": -7.05,
  "66017": -2.51,
  "66018": 8.43,
  "66019": 7.88,
  "66020": -5.67,
  "66021": -0.86,
  "66023": -7.57,
  "66024": 10.77,
  "66025": 0.52,
  "66026": -0.31,
  "66027": -5.67,
  "66030": 8.43,
  "66031": 8.43,
  "66032": -15.18,
  "66033": -14.66,
  "66035": -3.03,
  "66036": -0.31,
  "66039": -14.66,
  "66040": -5,
  "66041": -7.57,
  "66042": 5.12,
  "66043": -5.67,
  "66044": 0.52,
  "66046": 0.52,
  "66047": 9.01,
  "66048": -5.67,
  "66049": 9.01,
  "66050": 0.52,
  "66051": 8.43,
  "66052": 0.52,
  "66053": -0.31,
  "66054": 1.23,
  "66056": -5,
  "66058": -7.57,
  "66060": -7.57,
  "66061": 8.43,
  "66062": 8.43,
  "66063": 8.43,
  "66064": -0.86,
  "66066": 2.82,
  "66067": 4.6,
  "66070": 0.71,
  "66071": -0.31,
  "66072": -5,
  "66073": 2.3,
  "66075": -5,
  "66076": 4.6,
  "66077": -7.57,
  "66078": 4.6,
  "66079": 5.12,
  "66080": 4.6,
  "66083": -0.31,
  "66085": 8.43,
  "66086": -4.08,
  "66087": -2.51,
  "66088": 0.71,
  "66090": 11.29,
  "66091": -15.18,
  "66092": 5.12,
  "66093": -7.36,
  "66094": -14.53,
  "66095": 4.6,
  "66097": 1.23,
  "66101": 3.32,
  "66102": 3.32,
  "66103": 4.91,
  "66104": 3.32,
  "66105": 3.32,
  "66106": 3.87,
  "66109": 3.87,
  "66110": 3.32,
  "66111": 3.87,
  "66112": 3.87,
  "66113": 3.32,
  "66115": 3.32,
  "66117": 3.32,
  "66118": 3.32,
  "66119": 3.32,
  "66201": 8.43,
  "66202": 3.87,
  "66203": 3.87,
  "66204": 5.25,
  "66205": 5.46,
  "66206": 14.78,
  "66207": 14.78,
  "66208": 5.46,
  "66209": 16.37,
  "66210": 8.43,
  "66211": 19.22,
  "66212": 8.43,
  "66213": 9.47,
  "66214": 5.25,
  "66215": 8.43,
  "66216": 5.25,
  "66217": 13.74,
  "66218": 8.43,
  "66219": 8.43,
  "66220": 16.92,
  "66221": 19.22,
  "66222": 3.87,
  "66223": 8.43,
  "66224": 16.92,
  "66225": 9.47,
  "66226": 8.43,
  "66227": 8.43,
  "66250": 8.43,
  "66282": 8.43,
  "66283": 8.43,
  "66285": 3.87,
  "66286": 8.43,
  "66401": -13.55,
  "66402": -2.05,
  "66403": -13.61,
  "66404": -11.77,
  "66406": -12.02,
  "66407": -4.87,
  "66408": -11.77,
  "66409": 5.92,
  "66411": -13.61,
  "66412": -11.5,
  "66413": -16.83,
  "66414": -16.31,
  "66415": -11.77,
  "66416": -12.23,
  "66417": -11.77,
  "66418": -12.23,
  "66419": -11.71,
  "66420": -2.05,
  "66422": -4.87,
  "66423": -14.07,
  "66424": -20.45,
  "66425": -20.97,
  "66426": -4.87,
  "66427": -13.61,
  "66428": -11.77,
  "66429": -2.05,
  "66431": -14.07,
  "66432": -12.23,
  "66434": -20.45,
  "66436": -11.71,
  "66438": -12.02,
  "66439": -20.97,
  "66440": -11.71,
  "66441": -7.17,
  "66442": -6.65,
  "66449": -4.41,
  "66451": -16.83,
  "66501": -14.07,
  "66502": -3.89,
  "66503": 4.08,
  "66505": -3.89,
  "66506": -3.89,
  "66507": -13.55,
  "66508": -11.5,
  "66509": -11.71,
  "66510": -16.83,
  "66512": 0.71,
  "66514": -5.58,
  "66515": -20.97,
  "66516": -12.23,
  "66517": -7.17,
  "66518": -11.5,
  "66520": -4.41,
  "66521": -4.87,
  "66522": -11.77,
  "66523": -16.31,
  "66524": -14.2,
  "66526": -13.55,
  "66527": -20.97,
  "66528": -14.72,
  "66531": -4.41,
  "66532": -20.97,
  "66533": -2.05,
  "66534": -11.25,
  "66535": -4.87,
  "66536": -4.35,
  "66537": -16.83,
  "66538": -11.25,
  "66539": 5.92,
  "66540": -11.71,
  "66541": -12.02,
  "66542": 5.92,
  "66543": -16.31,
  "66544": -13.61,
  "66546": 5.92,
  "66547": -4.35,
  "66548": -13.61,
  "66549": -4.87,
  "66550": -11.77,
  "66552": -12.23,
  "66554": -4.41,
  "66601": -2.57,
  "66603": -2.57,
  "66604": -2.57,
  "66605": -2.57,
  "66606": -2.57,
  "66607": -2.57,
  "66608": -2.57,
  "66609": -2.57,
  "66610": 5.92,
  "66611": -2.05,
  "66612": -2.57,
  "66614": -2.05,
  "66615": 5.92,
  "66616": -2.57,
  "66617": -2.05,
  "66618": 5.92,
  "66619": -2.57,
  "66621": -2.57,
  "66647": -2.57,
  "66667": -2.57,
  "66675": -2.57,
  "66683": -2.57,
  "66701": -8.49,
  "66710": 3.01,
  "66711": -12.69,
  "66712": -12.17,
  "66713": 19.57,
  "66714": 2.49,
  "66716": -14.07,
  "66717": 3.01,
  "66720": -14.01,
  "66724": -12.17,
  "66725": 19.57,
  "66728": 19.57,
  "66732": -13.55,
  "66733": -14.01,
  "66734": -12.17,
  "66735": -12.17,
  "66736": 3.01,
  "66738": -6.38,
  "66739": 19.57,
  "66740": -14.01,
  "66741": 0,
  "66742": -11.96,
  "66743": -12.17,
  "66746": -8.49,
  "66748": -13.55,
  "66749": -11.96,
  "66751": -11.44,
  "66753": -12.17,
  "66754": -6.38,
  "66755": -11.44,
  "66756": -12.17,
  "66757": 3.01,
  "66758": -11.96,
  "66759": 3.01,
  "66760": -3.68,
  "66761": -11.96,
  "66762": -12.17,
  "66763": -12.17,
  "66767": -5,
  "66769": -8.49,
  "66770": 19.57,
  "66771": -14.01,
  "66772": -13.55,
  "66773": 19.57,
  "66775": -14.53,
  "66776": -14.01,
  "66777": -8.95,
  "66778": 19.05,
  "66779": -8.49,
  "66780": -14.01,
  "66781": 19.57,
  "66782": 19.05,
  "66783": -11.96,
  "66801": -8.09,
  "66830": -8.09,
  "66833": -8.09,
  "66834": -18.21,
  "66835": -8.09,
  "66838": -17.69,
  "66839": -9.47,
  "66840": -2.51,
  "66842": -23.67,
  "66843": -23.67,
  "66845": -23.67,
  "66846": -18.21,
  "66849": -18.21,
  "66850": -23.67,
  "66851": -8.03,
  "66852": -9.47,
  "66853": -8.95,
  "66854": -9.47,
  "66855": -9.47,
  "66856": -8.95,
  "66857": -7.36,
  "66858": -8.03,
  "66859": -8.03,
  "66860": -9.47,
  "66861": -8.03,
  "66862": -23.67,
  "66863": -8.95,
  "66864": -8.09,
  "66865": -7.57,
  "66866": -8.03,
  "66868": -8.09,
  "66869": -24.19,
  "66870": -8.95,
  "66871": -7.36,
  "66872": -18.21,
  "66873": -17.69,
  "66901": -12.88,
  "66930": -12.94,
  "66932": -17.54,
  "66933": -17.75,
  "66935": -12.42,
  "66936": -17.54,
  "66937": -16.16,
  "66938": -13.4,
  "66939": -12.94,
  "66940": -12.94,
  "66941": -17.54,
  "66942": -12.94,
  "66943": -16.16,
  "66944": -16.16,
  "66945": -15.64,
  "66946": -16.16,
  "66948": -13.4,
  "66949": -13.86,
  "66951": -17.08,
  "66952": -17.54,
  "66953": -16.16,
  "66955": -5.12,
  "66956": -13.86,
  "66958": -16.16,
  "66959": -12.94,
  "66960": -12.94,
  "66961": -13.4,
  "66962": -16.16,
  "66963": -13.86,
  "66964": -12.94,
  "66966": -12.94,
  "66967": -11.5,
  "66968": -16.16,
  "66970": -16.16,
  "67001": 4.14,
  "67002": 5.98,
  "67003": -8.09,
  "67004": -7.57,
  "67005": 1.17,
  "67008": 1.17,
  "67009": -7.57,
  "67010": -1.99,
  "67012": -2.51,
  "67013": -13.03,
  "67016": 3.01,
  "67017": -1.99,
  "67018": -8.09,
  "67019": 1.17,
  "67020": 3.53,
  "67021": -6.65,
  "67022": -13.55,
  "67023": 1.17,
  "67024": 1.17,
  "67025": -8.89,
  "67026": -2.76,
  "67028": -6.65,
  "67029": -11.77,
  "67030": 4.14,
  "67031": -13.55,
  "67035": -9.41,
  "67036": -7.57,
  "67037": 4.14,
  "67038": 1.17,
  "67039": -1.99,
  "67041": 3.53,
  "67042": -2.51,
  "67045": -8.95,
  "67047": -8.95,
  "67049": -7.05,
  "67050": -2.76,
  "67051": 1.17,
  "67052": 4.14,
  "67053": 3.01,
  "67054": -0.21,
  "67055": 4.14,
  "67056": 3.53,
  "67057": -14.99,
  "67058": -7.57,
  "67059": -6.65,
  "67060": -3.83,
  "67061": -15.54,
  "67062": 4.6,
  "67063": -7.51,
  "67065": -14.47,
  "67066": -6.65,
  "67067": -4.35,
  "67068": -9.41,
  "67070": -14.99,
  "67071": -14.47,
  "67072": -2.51,
  "67073": -8.03,
  "67074": -2.51,
  "67101": -3.83,
  "67102": 1.69,
  "67103": -13.03,
  "67104": -14.99,
  "67105": -13.55,
  "67106": -0.92,
  "67107": 3.53,
  "67108": -3.83,
  "67109": -0.21,
  "67110": -3.83,
  "67111": -9.41,
  "67112": -14.47,
  "67114": 3.53,
  "67117": 3.01,
  "67118": -8.89,
  "67119": 1.17,
  "67120": -11.96,
  "67122": -8.95,
  "67123": -2.51,
  "67124": -6.65,
  "67127": -11.77,
  "67131": 1.17,
  "67132": -2.51,
  "67133": -2.76,
  "67134": -6.65,
  "67135": 3.53,
  "67137": -8.95,
  "67138": -14.99,
  "67140": -13.55,
  "67142": -9.41,
  "67143": -7.72,
  "67144": -2.51,
  "67146": 1.69,
  "67147": -2.76,
  "67149": -3.83,
  "67150": -8.64,
  "67151": 3.01,
  "67152": -13.55,
  "67154": 3.53,
  "67155": -7.17,
  "67156": 1.17,
  "67159": -9.41,
  "67201": -4.35,
  "67202": -4.35,
  "67203": -4.35,
  "67204": -3.83,
  "67205": 4.14,
  "67206": 4.14,
  "67207": -3.83,
  "67208": -3.83,
  "67209": -2.76,
  "67210": -3.83,
  "67211": -4.35,
  "67212": -2.76,
  "67213": -4.35,
  "67214": -4.35,
  "67215": -3.83,
  "67216": -4.35,
  "67217": -4.35,
  "67218": -4.35,
  "67219": -4.35,
  "67220": -2.76,
  "67221": -3.83,
  "67223": 4.14,
  "67226": 4.14,
  "67227": -3.83,
  "67228": 4.14,
  "67230": 4.14,
  "67232": 4.14,
  "67235": 4.14,
  "67275": -2.76,
  "67276": -2.76,
  "67277": -2.76,
  "67278": -4.35,
  "67301": -2.51,
  "67330": -11.25,
  "67332": -11.25,
  "67333": -1.99,
  "67334": -8.89,
  "67335": -2.51,
  "67336": -11.25,
  "67337": -2.51,
  "67340": -1.99,
  "67341": -11.25,
  "67342": -11.25,
  "67344": -1.99,
  "67345": 3.01,
  "67346": 1.17,
  "67347": -1.99,
  "67349": -8.95,
  "67351": -2.51,
  "67352": 3.01,
  "67353": 3.01,
  "67354": -11.77,
  "67355": -1.99,
  "67356": -11.25,
  "67357": -11.25,
  "67360": -8.89,
  "67361": -1.99,
  "67363": -2.51,
  "67364": -1.99,
  "67401": -2.45,
  "67402": -2.45,
  "67410": -9.93,
  "67416": -2.45,
  "67417": -14.99,
  "67418": 14.05,
  "67420": -13.34,
  "67422": -19.01,
  "67423": 14.05,
  "67425": -2.97,
  "67427": 10.37,
  "67428": -1.99,
  "67430": -13.34,
  "67431": -9.93,
  "67432": -15.91,
  "67436": -20.05,
  "67437": -12.02,
  "67438": -8.03,
  "67439": -18.61,
  "67441": -9.93,
  "67442": -2.97,
  "67443": -1.99,
  "67444": 10.37,
  "67445": -14.99,
  "67446": -13.86,
  "67447": -15.91,
  "67448": -2.45,
  "67449": -18.21,
  "67450": -18.61,
  "67451": -9.41,
  "67452": 14.05,
  "67454": -18.61,
  "67455": 14.05,
  "67456": -1.99,
  "67457": 10.37,
  "67458": -15.91,
  "67459": -18.61,
  "67460": -1.99,
  "67464": -18.61,
  "67466": -14.99,
  "67467": -19.53,
  "67468": -15.91,
  "67470": -2.45,
  "67473": -13.09,
  "67474": -12.02,
  "67475": -8.03,
  "67476": -1.99,
  "67478": -13.86,
  "67480": -2.45,
  "67481": 14.05,
  "67482": -9.93,
  "67483": -8.03,
  "67484": -19.53,
  "67485": -13.09,
  "67487": -15.91,
  "67490": -18.61,
  "67491": -2.51,
  "67492": -9.93,
  "67501": -8.95,
  "67502": -8.43,
  "67504": -8.95,
  "67505": -8.95,
  "67510": -8.95,
  "67511": -6.19,
  "67512": 10.37,
  "67513": -10.79,
  "67514": -8.95,
  "67515": -11.25,
  "67516": -11.25,
  "67518": -11.25,
  "67519": -0.21,
  "67520": -10.79,
  "67521": -11.25,
  "67522": -8.43,
  "67523": -0.21,
  "67524": 10.37,
  "67525": -6.19,
  "67526": -6.19,
  "67529": -0.21,
  "67530": -6.19,
  "67543": -8.43,
  "67544": -6.19,
  "67545": -6.19,
  "67546": -1.99,
  "67547": -0.21,
  "67548": -10.79,
  "67550": -0.21,
  "67552": -0.21,
  "67553": -10.79,
  "67554": 10.37,
  "67556": -10.79,
  "67557": -0.21,
  "67559": -10.79,
  "67560": -11.25,
  "67561": -8.95,
  "67563": -0.21,
  "67564": -6.19,
  "67565": -10.79,
  "67566": -8.95,
  "67567": -6.19,
  "67568": -8.95,
  "67570": -8.95,
  "67572": -11.25,
  "67573": 10.37,
  "67574": -0.21,
  "67575": -10.79,
  "67576": -6.65,
  "67578": -6.65,
  "67579": 10.37,
  "67581": -8.95,
  "67583": -6.65,
  "67584": -11.25,
  "67585": -8.43,
  "67601": -7.51,
  "67621": -17.08,
  "67622": -13.4,
  "67623": -13.09,
  "67625": -19.99,
  "67626": -12.17,
  "67627": -8.03,
  "67628": -11.5,
  "67629": -13.4,
  "67631": -19.99,
  "67632": -19.99,
  "67634": -12.17,
  "67635": -14.47,
  "67637": -19.99,
  "67638": -12.02,
  "67639": -17.08,
  "67640": -12.17,
  "67642": -19.99,
  "67643": -13.4,
  "67644": -17.08,
  "67645": -13.4,
  "67646": -17.08,
  "67647": -20.24,
  "67648": -12.17,
  "67649": -12.17,
  "67650": -14.47,
  "67651": -13.09,
  "67653": -13.4,
  "67654": -12.88,
  "67656": -19.99,
  "67657": -19.99,
  "67658": -12.17,
  "67659": -19.99,
  "67660": -10.27,
  "67661": -16.56,
  "67663": -8.03,
  "67664": -17.08,
  "67665": -12.17,
  "67667": -10.79,
  "67669": -18.15,
  "67671": -8.03,
  "67672": -19.99,
  "67673": -12.17,
  "67674": -8.03,
  "67675": -13.09,
  "67701": 2.82,
  "67730": 3.74,
  "67731": -17.88,
  "67732": 2.82,
  "67733": -12.36,
  "67734": 2.82,
  "67735": -12.36,
  "67736": -13.09,
  "67737": -13.09,
  "67738": -13.09,
  "67739": 3.74,
  "67740": -14.47,
  "67741": -12.36,
  "67743": 2.82,
  "67744": 3.74,
  "67745": 3.74,
  "67747": 1.23,
  "67748": 1.78,
  "67749": -11.04,
  "67751": -13.09,
  "67752": -13.09,
  "67753": 0.71,
  "67756": -17.33,
  "67757": 0.71,
  "67758": -13.95,
  "67761": -13.95,
  "67762": -13.95,
  "67764": 1.23,
  "67801": -8.03,
  "67831": -11.77,
  "67834": -8.55,
  "67835": 3.99,
  "67836": -18.09,
  "67837": -10.33,
  "67838": -6.13,
  "67839": -13.55,
  "67840": -11.77,
  "67841": 2.95,
  "67842": -8.55,
  "67843": -8.03,
  "67844": -9.93,
  "67846": -6.13,
  "67849": -0.21,
  "67850": -13.55,
  "67851": -5.58,
  "67853": 3.47,
  "67854": -8.03,
  "67855": -12.11,
  "67857": -12.11,
  "67859": -9.41,
  "67860": -5.58,
  "67861": -13.03,
  "67862": -11.56,
  "67863": -12.48,
  "67864": -9.93,
  "67865": -8.55,
  "67867": 11.44,
  "67868": -6.65,
  "67869": -8.89,
  "67870": -9.81,
  "67871": -12.48,
  "67876": -8.03,
  "67877": -9.81,
  "67878": -17.54,
  "67879": -17.54,
  "67880": -12.11,
  "67882": -7.51,
  "67901": -9.81,
  "67905": -9.81,
  "67950": -12.11,
  "67951": -12.11,
  "67952": -12.11,
  "67953": -12.63,
  "67954": -12.11,
  "68001": -5.12,
  "68002": -0.52,
  "68003": -5.12,
  "68004": -13.09,
  "68005": -1.07,
  "68007": 1.32,
  "68008": -0.52,
  "68009": -0.52,
  "68010": 1.84,
  "68014": -4.6,
  "68015": -4.2,
  "68016": -8.8,
  "68017": -4.6,
  "68018": -5.12,
  "68019": -16.62,
  "68020": -18.21,
  "68022": 1.84,
  "68023": 1.07,
  "68025": -4.2,
  "68026": -4.2,
  "68028": -0.52,
  "68029": -0.52,
  "68030": 0.25,
  "68031": -4.2,
  "68033": -4.6,
  "68034": -0.52,
  "68036": -3.68,
  "68037": -8.8,
  "68038": -17.69,
  "68039": -13.09,
  "68040": -4.6,
  "68041": -5.12,
  "68042": -4.6,
  "68044": -4.2,
  "68045": -17.69,
  "68046": -0.52,
  "68047": 4.39,
  "68048": -9.35,
  "68050": -4.6,
  "68055": 3.87,
  "68056": -0.52,
  "68057": -4.2,
  "68058": -8.8,
  "68059": -0.52,
  "68061": -16.62,
  "68062": 4.39,
  "68063": -17.17,
  "68064": -0.52,
  "68065": -4.6,
  "68066": -4.6,
  "68067": 4.39,
  "68068": -0.52,
  "68069": 1.84,
  "68070": -4.6,
  "68071": 3.87,
  "68072": -4.2,
  "68073": -5.12,
  "68101": 8.74,
  "68102": 8.74,
  "68103": 8.74,
  "68104": 1.32,
  "68105": 1.32,
  "68106": 1.32,
  "68107": -0.52,
  "68108": 0.25,
  "68109": 0.25,
  "68110": 0.25,
  "68111": 0.77,
  "68112": 1.32,
  "68113": -1.07,
  "68114": 1.32,
  "68116": 9.81,
  "68117": 1.32,
  "68118": 9.81,
  "68119": 0.25,
  "68120": 1.84,
  "68122": 1.32,
  "68123": -0.52,
  "68124": 1.32,
  "68127": 1.32,
  "68128": -0.52,
  "68130": 1.84,
  "68131": 1.32,
  "68132": 1.32,
  "68133": 7.97,
  "68134": 1.32,
  "68135": 9.81,
  "68136": 7.97,
  "68137": 1.32,
  "68138": -0.52,
  "68139": 1.32,
  "68142": 0.77,
  "68144": 1.32,
  "68145": 8.74,
  "68147": -0.52,
  "68152": 1.32,
  "68154": 1.84,
  "68155": 1.32,
  "68157": -0.52,
  "68164": 1.32,
  "68301": -12.88,
  "68303": -11.1,
  "68304": -8.28,
  "68305": -9.2,
  "68307": -4.6,
  "68309": -11.1,
  "68310": -10.58,
  "68313": -5.52,
  "68314": -5.52,
  "68315": -11.1,
  "68316": -3.22,
  "68317": -2.3,
  "68318": -10.58,
  "68319": -3.22,
  "68320": -9.2,
  "68321": -9.2,
  "68322": -10.58,
  "68323": -13.4,
  "68324": -12.88,
  "68325": -11.1,
  "68326": -10.58,
  "68327": -11.1,
  "68328": -12.88,
  "68329": -12.88,
  "68330": -5.52,
  "68331": -10.58,
  "68332": -12.88,
  "68333": -12.88,
  "68335": -11.1,
  "68336": 6.19,
  "68337": -14.07,
  "68338": -5.12,
  "68339": 6.19,
  "68340": -11.1,
  "68341": -12.88,
  "68342": -4.6,
  "68343": -12.88,
  "68344": -12.88,
  "68345": -12.48,
  "68346": -4.6,
  "68347": -2.3,
  "68348": -12.88,
  "68349": -8.28,
  "68350": -5.12,
  "68351": 8.28,
  "68352": -4.6,
  "68354": 8.28,
  "68355": -14.07,
  "68357": -10.58,
  "68358": 6.19,
  "68359": -12.88,
  "68360": -5.52,
  "68361": 8.28,
  "68362": -10.58,
  "68364": -5.52,
  "68365": 7.76,
  "68366": -2.3,
  "68367": -11.04,
  "68368": -12.88,
  "68370": -10.58,
  "68371": -3.22,
  "68372": -2.3,
  "68375": -10.58,
  "68376": -12.48,
  "68377": -4.6,
  "68378": -9.2,
  "68379": -9.2,
  "68380": -13.4,
  "68381": -10.58,
  "68382": -5.12,
  "68401": -3.22,
  "68402": 6.19,
  "68403": -8.8,
  "68404": 6.19,
  "68405": -5.52,
  "68406": 8.28,
  "68407": -8.28,
  "68409": -9.35,
  "68410": -5.67,
  "68413": -8.8,
  "68414": -11.31,
  "68415": -10.58,
  "68416": 7.76,
  "68417": -5.12,
  "68418": -4.6,
  "68419": -2.3,
  "68420": -13.4,
  "68421": -10.79,
  "68422": -10.58,
  "68423": 2.97,
  "68424": -4.6,
  "68428": 6.19,
  "68429": -10.58,
  "68430": 6.19,
  "68431": -14.53,
  "68433": -14.07,
  "68434": -5.52,
  "68436": 8.28,
  "68437": -14.07,
  "68438": 6.19,
  "68439": -5.52,
  "68440": -5.12,
  "68441": -12.88,
  "68442": -14.07,
  "68443": -12.88,
  "68444": 8.28,
  "68445": -12.88,
  "68446": -4.6,
  "68447": -13.4,
  "68448": -5.12,
  "68450": -12.88,
  "68452": -3.74,
  "68453": 7.76,
  "68454": -4.6,
  "68455": -1.38,
  "68456": -5.52,
  "68457": -14.07,
  "68458": -11.1,
  "68460": -3.22,
  "68461": 6.19,
  "68462": -2.3,
  "68463": -8.8,
  "68464": -12.88,
  "68465": -12.88,
  "68466": -10.58,
  "68467": -3.22,
  "68501": -2.3,
  "68502": -2.3,
  "68503": -2.3,
  "68504": -2.3,
  "68505": -2.3,
  "68506": -0.71,
  "68507": -2.3,
  "68508": -2.3,
  "68509": -2.3,
  "68510": -2.3,
  "68512": 6.19,
  "68514": 6.19,
  "68516": 6.19,
  "68517": 6.19,
  "68520": 6.19,
  "68521": -2.3,
  "68522": -2.3,
  "68523": 6.19,
  "68524": -2.3,
  "68526": 6.19,
  "68527": 6.19,
  "68528": -2.3,
  "68529": -2.3,
  "68531": -2.3,
  "68532": 6.19,
  "68542": -2.3,
  "68583": -2.3,
  "68588": -2.3,
  "68601": -1.38,
  "68602": -1.38,
  "68620": -5.06,
  "68621": -4.2,
  "68622": -13.09,
  "68623": -12.48,
  "68624": -1.38,
  "68626": -4.6,
  "68627": -5.58,
  "68628": 2.3,
  "68629": -2.45,
  "68631": -1.38,
  "68632": -1.38,
  "68633": -12.02,
  "68634": -1.38,
  "68635": -5.52,
  "68636": 4.39,
  "68637": -12.02,
  "68638": -11.96,
  "68640": -11.96,
  "68641": -12.02,
  "68642": -1.38,
  "68643": -1.38,
  "68644": -5.06,
  "68647": -1.38,
  "68648": -4.2,
  "68649": -4.2,
  "68651": -11.04,
  "68652": -6.65,
  "68653": -1.38,
  "68654": -11.56,
  "68655": -5.06,
  "68658": -11.04,
  "68659": -3.68,
  "68660": -5.58,
  "68661": -1.38,
  "68662": -11.04,
  "68663": -11.04,
  "68664": -12.57,
  "68665": -11.5,
  "68666": -11.04,
  "68667": -11.04,
  "68669": -5.52,
  "68701": -3.89,
  "68702": -3.89,
  "68710": 0.25,
  "68711": -8.49,
  "68713": -8.49,
  "68714": -17.08,
  "68715": -3.89,
  "68716": -13.09,
  "68717": -5.27,
  "68718": -17.23,
  "68719": -12.94,
  "68720": 4.39,
  "68722": -12.94,
  "68723": -15.85,
  "68724": -17.23,
  "68725": -8.49,
  "68726": 4.39,
  "68727": -5.27,
  "68728": -15.85,
  "68729": -17.23,
  "68730": -5.27,
  "68731": 0.25,
  "68732": -15.85,
  "68733": 4.39,
  "68734": -8.49,
  "68735": 4.39,
  "68736": -5.27,
  "68738": -3.89,
  "68739": -5.27,
  "68740": -15.85,
  "68741": 0.25,
  "68742": -9.01,
  "68743": 1.84,
  "68745": -5.27,
  "68746": -12.94,
  "68747": -7.11,
  "68748": -3.89,
  "68749": -7.11,
  "68751": -5.27,
  "68752": -3.89,
  "68753": -11.04,
  "68755": -11.56,
  "68756": 4.39,
  "68757": -5.27,
  "68758": -6.65,
  "68759": -17.08,
  "68760": -16.16,
  "68761": 3.87,
  "68763": -8.49,
  "68764": 4.39,
  "68765": -7.11,
  "68766": -8.49,
  "68767": -7.11,
  "68768": -15.85,
  "68769": -7.11,
  "68770": 0.25,
  "68771": -7.11,
  "68773": 3.87,
  "68774": -5.27,
  "68776": 0.25,
  "68777": -12.94,
  "68778": -17.08,
  "68779": -3.89,
  "68780": -6.9,
  "68781": 4.39,
  "68783": -17.23,
  "68784": -15.85,
  "68785": 0.25,
  "68786": -7.11,
  "68787": -15.85,
  "68788": -13.09,
  "68789": -17.75,
  "68790": -15.85,
  "68791": -13.09,
  "68792": -5.79,
  "68801": -8.28,
  "68802": -8.28,
  "68803": -8.28,
  "68810": -8.28,
  "68812": -5.06,
  "68813": -17.94,
  "68814": -14.32,
  "68815": -13.8,
  "68816": 2.3,
  "68817": -14.32,
  "68818": -4.14,
  "68820": -8.28,
  "68821": -18.67,
  "68822": -13.8,
  "68823": -17.94,
  "68824": -8.28,
  "68825": -5.52,
  "68826": 2.3,
  "68827": 2.3,
  "68828": -14.32,
  "68831": -8.28,
  "68832": -8.28,
  "68833": -17.08,
  "68834": -6.04,
  "68835": -11.5,
  "68836": -6.9,
  "68837": -13.8,
  "68838": -8.28,
  "68840": -5.06,
  "68841": -4.14,
  "68842": -11.5,
  "68843": -4.14,
  "68844": -5.06,
  "68845": -3.47,
  "68846": 2.3,
  "68847": -5.06,
  "68848": -5.06,
  "68850": -5.52,
  "68852": -5.58,
  "68853": -13.8,
  "68854": 2.3,
  "68855": -5.58,
  "68856": -14.32,
  "68858": -5.06,
  "68859": -12.02,
  "68860": -6.04,
  "68861": -5.58,
  "68862": -13.8,
  "68863": -5.52,
  "68864": 2.3,
  "68865": -4.14,
  "68866": -5.06,
  "68869": -5.06,
  "68870": -5.06,
  "68871": -5.06,
  "68872": -8.28,
  "68873": -11.5,
  "68874": -18.46,
  "68875": -12.02,
  "68876": -5.06,
  "68878": -6.04,
  "68879": -18.46,
  "68881": -13.8,
  "68882": -12.02,
  "68883": -8.28,
  "68901": 4.14,
  "68902": 4.14,
  "68920": -20.24,
  "68922": -5.98,
  "68923": -6.9,
  "68924": -18.86,
  "68925": 4.14,
  "68926": -6.5,
  "68927": -6.9,
  "68928": -17.54,
  "68929": -20.76,
  "68930": -17.02,
  "68932": -17.54,
  "68933": -3.22,
  "68934": -3.74,
  "68935": -3.22,
  "68936": -6.5,
  "68937": -5.52,
  "68938": -3.22,
  "68939": -20.76,
  "68940": -6.9,
  "68941": 4.14,
  "68942": -17.54,
  "68943": -16.16,
  "68944": -3.74,
  "68945": -18.86,
  "68946": -5.98,
  "68947": -18.86,
  "68948": -6.5,
  "68949": -6.9,
  "68950": 4.14,
  "68952": -17.54,
  "68954": -3.22,
  "68955": 4.14,
  "68956": 4.14,
  "68957": -17.54,
  "68958": -6.9,
  "68959": -18.86,
  "68960": -20.76,
  "68961": -16.16,
  "68964": -16.16,
  "68966": -20.76,
  "68967": -20.24,
  "68969": -6.9,
  "68970": -17.54,
  "68971": -20.24,
  "68972": -17.54,
  "68973": 4.14,
  "68974": -16.16,
  "68975": -3.22,
  "68976": -5.52,
  "68977": -20.76,
  "68978": -16.16,
  "68979": -3.22,
  "68980": -3.74,
  "68981": -19.38,
  "68982": -6.9,
  "69001": -11.04,
  "69020": -11.04,
  "69021": -20.64,
  "69022": -5.98,
  "69023": -4.54,
  "69024": -15.58,
  "69025": -11.04,
  "69026": -11.56,
  "69027": -20.09,
  "69028": -5.52,
  "69029": -5.52,
  "69030": -20.64,
  "69032": -15.58,
  "69033": -3.99,
  "69034": -11.04,
  "69036": -11.56,
  "69037": -20.09,
  "69038": -5.98,
  "69039": -11.04,
  "69040": -15.58,
  "69041": -20.64,
  "69042": -11.04,
  "69043": -15.58,
  "69044": -15.58,
  "69045": -15.58,
  "69046": -6.5,
  "69101": -5.98,
  "69103": -5.98,
  "69120": -5.98,
  "69121": -13.8,
  "69122": -18.4,
  "69123": -5.98,
  "69125": -21.22,
  "69127": -18.4,
  "69128": -17.48,
  "69129": -12.42,
  "69130": -5.52,
  "69131": -12.42,
  "69132": -4.91,
  "69133": -18,
  "69134": -4.54,
  "69135": -18.15,
  "69138": -5.52,
  "69140": -3.99,
  "69141": -12.42,
  "69142": -16.56,
  "69143": -5.98,
  "69144": -18.4,
  "69145": -17.48,
  "69146": -18.4,
  "69147": -18.4,
  "69148": -20.7,
  "69149": -12.42,
  "69150": -4.54,
  "69151": -5.98,
  "69152": -14.87,
  "69153": -18.4,
  "69154": -12.42,
  "69155": -18.4,
  "69156": -12.42,
  "69157": -16.56,
  "69161": -7.97,
  "69162": -12.42,
  "69163": -5.98,
  "69165": -5.98,
  "69166": -17.63,
  "69167": -5.98,
  "69168": -4.54,
  "69169": -3.99,
  "69170": -4.91,
  "69171": -5.52,
  "69201": -7.97,
  "69210": -17.08,
  "69211": -7.97,
  "69212": -7.97,
  "69214": -17.08,
  "69216": -7.97,
  "69217": -17.08,
  "69218": -18.09,
  "69219": -7.97,
  "69220": -17.63,
  "69221": -17.63,
  "69301": -0.46,
  "69331": -20.7,
  "69333": -14.32,
  "69334": -20.7,
  "69335": -1.53,
  "69336": -20.7,
  "69337": -13.49,
  "69339": -13.49,
  "69340": -1.53,
  "69341": -1.84,
  "69343": -13.49,
  "69345": -1.84,
  "69346": -13.49,
  "69347": -13.49,
  "69348": -1.53,
  "69350": -14.87,
  "69351": -1.53,
  "69352": -1.84,
  "69353": -1.84,
  "69354": -12.94,
  "69355": -1.84,
  "69356": -1.84,
  "69357": -1.84,
  "69358": -1.84,
  "69360": -13.49,
  "69361": -1.84,
  "69363": -1.84,
  "69365": -21.77,
  "69366": -14.87,
  "69367": -13.49,
  "70001": 8.28,
  "70002": 16.25,
  "70003": 8.28,
  "70004": 9.35,
  "70005": 16.25,
  "70006": 9.35,
  "70009": 16.25,
  "70010": 16.25,
  "70011": 16.25,
  "70030": 18.71,
  "70031": 19.78,
  "70032": 9.14,
  "70033": 8.28,
  "70036": 7.76,
  "70037": 6.9,
  "70038": 27.08,
  "70039": 19.26,
  "70040": 6.9,
  "70041": 27.08,
  "70043": 6.38,
  "70044": 6.38,
  "70047": 19.78,
  "70049": 19.26,
  "70050": 27.08,
  "70051": 2.55,
  "70052": 3.07,
  "70053": 9.14,
  "70054": 9.14,
  "70055": 16.25,
  "70056": 9.14,
  "70057": 19.26,
  "70058": 7.76,
  "70059": 9.14,
  "70062": 7.76,
  "70063": 7.76,
  "70064": 8.28,
  "70065": 8.28,
  "70067": 7.76,
  "70068": 19.26,
  "70069": 19.26,
  "70070": 19.78,
  "70071": 3.07,
  "70072": 7.76,
  "70073": 7.76,
  "70075": 6.38,
  "70076": 2.55,
  "70078": 19.78,
  "70079": 19.26,
  "70080": 19.26,
  "70081": 27.08,
  "70082": 27.08,
  "70083": 27.08,
  "70084": 3.62,
  "70085": 6.38,
  "70086": 2.55,
  "70087": 19.26,
  "70090": 3.07,
  "70091": 27.08,
  "70092": 6.38,
  "70093": 6.9,
  "70094": 9.35,
  "70096": 7.76,
  "70097": 6.9,
  "70112": 9.66,
  "70113": 9.14,
  "70114": 9.14,
  "70115": 9.35,
  "70116": 9.14,
  "70117": 9.14,
  "70118": 8.28,
  "70119": 9.14,
  "70121": 7.76,
  "70122": 9.14,
  "70123": 9.35,
  "70124": 17.63,
  "70125": 8.28,
  "70126": 9.14,
  "70127": 9.14,
  "70128": 9.14,
  "70129": 6.38,
  "70130": 17.63,
  "70131": 9.66,
  "70139": 9.66,
  "70140": 9.66,
  "70141": 7.76,
  "70145": 9.14,
  "70146": 9.14,
  "70149": 9.14,
  "70150": 9.14,
  "70151": 9.14,
  "70152": 9.14,
  "70153": 9.14,
  "70156": 9.14,
  "70157": 9.14,
  "70158": 9.14,
  "70160": 9.14,
  "70161": 9.14,
  "70163": 9.66,
  "70170": 9.66,
  "70172": 9.66,
  "70174": 9.14,
  "70175": 9.35,
  "70176": 17.63,
  "70177": 9.14,
  "70178": 8.28,
  "70179": 9.14,
  "70181": 9.14,
  "70182": 9.14,
  "70183": 9.35,
  "70184": 17.63,
  "70185": 8.28,
  "70186": 9.14,
  "70187": 9.14,
  "70189": 6.38,
  "70190": 17.63,
  "70301": 3.07,
  "70302": 3.07,
  "70339": 5.52,
  "70340": 2.15,
  "70341": 5,
  "70342": 2.15,
  "70343": 3.07,
  "70344": 8.99,
  "70345": 3.07,
  "70346": 12.42,
  "70352": 9.51,
  "70353": 8.99,
  "70354": 3.07,
  "70355": 3.07,
  "70356": 9.51,
  "70357": 3.07,
  "70358": 26.53,
  "70359": 9.51,
  "70360": 18,
  "70361": 18,
  "70363": 9.51,
  "70364": 9.51,
  "70371": 18.71,
  "70372": 4.45,
  "70373": 2.55,
  "70374": 3.07,
  "70375": 3.07,
  "70377": 3.07,
  "70380": 2.15,
  "70381": 2.15,
  "70390": 4.45,
  "70391": 5,
  "70392": 2.15,
  "70393": 5.52,
  "70394": 3.07,
  "70395": 9.51,
  "70397": 9.51,
  "70401": 4.14,
  "70403": 4.14,
  "70404": 4.14,
  "70420": 7.3,
  "70421": 3.62,
  "70422": 4.14,
  "70426": -3.03,
  "70427": -1.99,
  "70429": -1.99,
  "70431": 7.3,
  "70433": 7.3,
  "70434": 7.3,
  "70435": 7.3,
  "70436": 3.62,
  "70437": 3.62,
  "70438": -1.44,
  "70441": 8.22,
  "70442": 3.62,
  "70443": 4.14,
  "70444": 4.14,
  "70445": 7.3,
  "70446": 4.14,
  "70447": 7.3,
  "70448": 8.89,
  "70449": 12.42,
  "70450": -1.44,
  "70451": 4.14,
  "70452": 7.3,
  "70453": 5.06,
  "70454": 3.62,
  "70455": 3.62,
  "70456": 3.62,
  "70457": 7.3,
  "70458": 7.3,
  "70459": 7.3,
  "70460": 7.3,
  "70461": 7.3,
  "70462": 5.06,
  "70463": 7.3,
  "70464": 6.75,
  "70465": 3.62,
  "70466": 4.14,
  "70467": -3.03,
  "70469": 7.3,
  "70470": 15.79,
  "70471": 15.79,
  "70500": 6.44,
  "70501": 6.44,
  "70502": 6.44,
  "70503": 14.93,
  "70505": 8.03,
  "70506": 8.03,
  "70507": 6.96,
  "70508": 14.93,
  "70509": 6.44,
  "70510": 0.46,
  "70511": 0.46,
  "70512": 0.46,
  "70513": 6.44,
  "70514": 3.22,
  "70515": -3.68,
  "70516": 11.56,
  "70517": 0.46,
  "70518": 8.03,
  "70519": 8.03,
  "70520": 6.96,
  "70521": 0.46,
  "70522": 3.22,
  "70523": 3.22,
  "70524": -4.6,
  "70525": 0.46,
  "70526": 11.04,
  "70527": 11.04,
  "70528": 6.44,
  "70529": 6.44,
  "70531": 11.04,
  "70532": -9.41,
  "70533": 0.98,
  "70534": 11.04,
  "70535": -4.6,
  "70537": -3.68,
  "70538": 3.22,
  "70540": 3.22,
  "70541": 0.46,
  "70542": 0.46,
  "70543": 11.04,
  "70544": 6.44,
  "70546": -4.75,
  "70548": 0.46,
  "70549": -5.27,
  "70550": 0.46,
  "70551": 0.46,
  "70552": 6.44,
  "70554": -4.6,
  "70555": 6.96,
  "70556": -3.68,
  "70558": 6.96,
  "70559": 11.04,
  "70560": 6.44,
  "70562": 6.44,
  "70563": 6.44,
  "70569": 6.44,
  "70570": 0.46,
  "70571": 0.46,
  "70575": 0.46,
  "70576": -6.19,
  "70577": 0.46,
  "70578": 11.04,
  "70580": -4.6,
  "70581": -4.75,
  "70582": 0.46,
  "70583": 6.44,
  "70584": 0.98,
  "70585": -4.6,
  "70586": -4.6,
  "70589": 0.46,
  "70591": -4.75,
  "70592": 14.93,
  "70593": 6.44,
  "70595": 6.44,
  "70596": 6.44,
  "70598": 14.93,
  "70601": -2.45,
  "70602": -2.45,
  "70605": -2.45,
  "70606": 6.04,
  "70607": -2.45,
  "70611": 6.04,
  "70612": -2.45,
  "70615": -2.97,
  "70616": -2.45,
  "70629": -2.45,
  "70630": -0.15,
  "70631": -0.67,
  "70632": -0.67,
  "70633": -2.45,
  "70634": -10.73,
  "70637": -15.79,
  "70638": -16.31,
  "70639": -4.35,
  "70640": -12.17,
  "70643": -0.15,
  "70644": -16.31,
  "70645": -0.67,
  "70646": -12.17,
  "70647": -11.65,
  "70648": -15.79,
  "70650": -12.17,
  "70651": -16.31,
  "70652": -11.25,
  "70653": -11.25,
  "70654": -16.31,
  "70655": -16.31,
  "70656": -16.31,
  "70657": -2.97,
  "70658": -2.97,
  "70659": -11.25,
  "70660": -11.25,
  "70661": -2.97,
  "70662": -16.31,
  "70663": -2.45,
  "70664": -2.45,
  "70665": -2.45,
  "70668": -2.97,
  "70669": -2.45,
  "70704": 16.56,
  "70706": 5.06,
  "70707": 12.42,
  "70710": 13.8,
  "70711": 4.14,
  "70712": 7.82,
  "70714": 16.56,
  "70715": -3.74,
  "70718": 12.42,
  "70719": 11.04,
  "70721": 11.9,
  "70722": 5.06,
  "70723": 3.62,
  "70725": 12.42,
  "70726": 5.06,
  "70727": 5.06,
  "70728": 12.42,
  "70729": -3.74,
  "70730": 8.74,
  "70732": -3.22,
  "70733": 12.42,
  "70734": 11.9,
  "70736": -3.74,
  "70737": 12.42,
  "70738": 12.42,
  "70739": 16.56,
  "70740": 10.52,
  "70743": 2.55,
  "70744": 5.06,
  "70747": 7.3,
  "70748": 8.74,
  "70749": -3.22,
  "70750": -3.22,
  "70752": -3.74,
  "70753": 7.3,
  "70754": 5.06,
  "70755": -3.22,
  "70756": -3.22,
  "70757": -3.22,
  "70759": -3.22,
  "70760": -3.22,
  "70761": 8.22,
  "70762": 5.27,
  "70763": 3.07,
  "70764": 13.8,
  "70765": 13.8,
  "70767": 11.04,
  "70769": 12.42,
  "70770": 16.56,
  "70772": 10.52,
  "70773": -3.22,
  "70774": 12.42,
  "70775": 7.82,
  "70776": 12.42,
  "70777": 16.56,
  "70778": 12.42,
  "70780": 13.8,
  "70782": 7.82,
  "70783": -3.22,
  "70784": 7.82,
  "70785": 5.06,
  "70786": 5.06,
  "70787": 7.3,
  "70788": 13.8,
  "70789": 8.22,
  "70791": 16.56,
  "70792": 2.55,
  "70801": 25.05,
  "70802": 16.04,
  "70804": 16.04,
  "70805": 16.04,
  "70806": 16.56,
  "70807": 16.04,
  "70808": 25.05,
  "70809": 18.15,
  "70810": 25.05,
  "70811": 16.56,
  "70812": 16.56,
  "70814": 16.56,
  "70815": 16.56,
  "70816": 16.56,
  "70817": 25.05,
  "70818": 16.56,
  "70819": 16.56,
  "70820": 19.53,
  "70821": 16.56,
  "70825": 16.56,
  "70826": 18.15,
  "70827": 16.56,
  "70831": 25.05,
  "70835": 16.56,
  "70836": 25.05,
  "70837": 16.04,
  "70873": 16.56,
  "70874": 16.56,
  "70879": 25.05,
  "70884": 25.05,
  "70892": 16.04,
  "70893": 25.05,
  "70894": 25.05,
  "70895": 16.56,
  "70896": 25.05,
  "70898": 25.05,
  "71001": -11.65,
  "71002": -7.97,
  "71003": 9.05,
  "71004": -5.67,
  "71006": 1.44,
  "71007": 2.3,
  "71008": -11.65,
  "71009": -6.19,
  "71016": -11.65,
  "71018": -7.97,
  "71019": -7.97,
  "71021": -7.97,
  "71023": -7.97,
  "71024": -11.65,
  "71027": -5.67,
  "71028": -12.17,
  "71029": -7.05,
  "71030": -5.67,
  "71031": -9.47,
  "71032": -5.67,
  "71033": -4.6,
  "71034": -7.97,
  "71037": 1.44,
  "71038": 9.05,
  "71039": -11.65,
  "71040": 9.05,
  "71043": -7.57,
  "71044": 1.11,
  "71045": -11.65,
  "71046": -5.67,
  "71047": -5.67,
  "71048": 9.05,
  "71049": -6.19,
  "71050": -5.67,
  "71051": -7.97,
  "71052": -6.19,
  "71055": -7.97,
  "71058": -7.97,
  "71060": -5.67,
  "71061": -6.19,
  "71063": -8.49,
  "71064": -7.05,
  "71065": -14.93,
  "71066": -14.93,
  "71067": 1.44,
  "71068": -7.97,
  "71069": -9.47,
  "71070": -12.17,
  "71071": -7.97,
  "71072": -7.97,
  "71073": -7.97,
  "71075": -7.97,
  "71078": -5.67,
  "71079": 9.05,
  "71080": -12.17,
  "71082": -5.67,
  "71101": -6.19,
  "71102": -6.19,
  "71103": -6.19,
  "71104": -5.67,
  "71105": 2.82,
  "71106": 2.3,
  "71107": -6.19,
  "71108": -6.19,
  "71109": -6.19,
  "71110": 1.44,
  "71111": 1.44,
  "71112": -5.46,
  "71113": -5.46,
  "71115": 2.82,
  "71118": -4.6,
  "71119": -4.6,
  "71120": -6.19,
  "71129": -5.67,
  "71130": -6.19,
  "71133": -6.19,
  "71134": -5.67,
  "71135": 2.82,
  "71136": 2.3,
  "71137": -5.67,
  "71138": -4.6,
  "71148": -6.19,
  "71149": -6.19,
  "71150": -6.19,
  "71161": -6.19,
  "71162": -6.19,
  "71163": -6.19,
  "71164": -6.19,
  "71165": -6.19,
  "71166": -6.19,
  "71171": -6.19,
  "71172": 1.44,
  "71201": 2.82,
  "71202": -6.19,
  "71203": 2.82,
  "71207": 2.82,
  "71210": 2.82,
  "71211": -5.67,
  "71213": 2.82,
  "71217": 2.82,
  "71218": -8.43,
  "71219": -8.43,
  "71220": -6.59,
  "71221": -6.59,
  "71222": -8.43,
  "71223": -7.11,
  "71225": 2.82,
  "71226": -15.85,
  "71227": -11.65,
  "71229": -7.11,
  "71230": -21.37,
  "71232": -8.43,
  "71233": -24.59,
  "71234": -8.43,
  "71235": -11.65,
  "71237": -11.25,
  "71238": -13.74,
  "71240": -5.67,
  "71241": -8.43,
  "71242": -11.25,
  "71243": -21.37,
  "71245": -3.16,
  "71247": -15.85,
  "71249": -21.37,
  "71250": -11.25,
  "71251": -15.33,
  "71253": -11.25,
  "71254": -19.53,
  "71256": -8.95,
  "71259": -8.43,
  "71260": -8.95,
  "71261": -7.11,
  "71263": -11.25,
  "71264": -8.43,
  "71266": -11.25,
  "71268": -15.33,
  "71269": -8.43,
  "71270": -3.16,
  "71273": -3.16,
  "71275": -11.65,
  "71276": -19.53,
  "71277": -8.43,
  "71279": -8.43,
  "71280": 2.82,
  "71281": 2.82,
  "71282": -24.59,
  "71284": -24.59,
  "71286": -19.53,
  "71291": 2.82,
  "71292": -5.67,
  "71294": 2.82,
  "71295": -21.37,
  "71301": -3.43,
  "71302": -3.43,
  "71303": 5.06,
  "71306": -3.43,
  "71307": -3.43,
  "71309": -3.43,
  "71315": -3.43,
  "71316": -6.9,
  "71320": -8.49,
  "71322": -8.49,
  "71323": -3.43,
  "71324": -21.37,
  "71325": -8.49,
  "71326": -11.25,
  "71327": -8.49,
  "71328": -1.84,
  "71329": -8.49,
  "71330": -8.49,
  "71331": -8.49,
  "71333": -9.01,
  "71334": -11.25,
  "71336": -21.37,
  "71339": -8.49,
  "71340": -8.95,
  "71341": -8.49,
  "71342": -19.07,
  "71343": -9.47,
  "71345": -6.44,
  "71346": -3.43,
  "71348": -3.43,
  "71350": -8.49,
  "71351": -8.49,
  "71353": -10.12,
  "71354": -11.25,
  "71355": -9.01,
  "71356": -8.49,
  "71357": -24.07,
  "71358": -6.44,
  "71360": -3.43,
  "71361": -3.43,
  "71362": -8.49,
  "71363": -19.07,
  "71365": -3.43,
  "71366": -20.85,
  "71367": -13.09,
  "71368": -21.37,
  "71369": -8.49,
  "71371": -19.07,
  "71373": -11.25,
  "71375": -11.25,
  "71377": -9.47,
  "71378": -21.37,
  "71401": -9.47,
  "71403": -4.35,
  "71404": -8.95,
  "71405": -3.43,
  "71406": -14.93,
  "71407": -5.27,
  "71409": -3.43,
  "71410": -9.47,
  "71411": -14.41,
  "71414": -14.93,
  "71415": -13.09,
  "71416": -15.45,
  "71417": -5.27,
  "71418": -12.57,
  "71419": -14.93,
  "71422": -8.95,
  "71423": -5.27,
  "71424": -3.43,
  "71425": -8.43,
  "71426": -15.45,
  "71427": -5.79,
  "71428": -6.44,
  "71429": -15.45,
  "71430": -3.43,
  "71431": -3.43,
  "71432": -19.59,
  "71433": -3.43,
  "71434": -15.45,
  "71435": -8.43,
  "71438": -3.43,
  "71439": -4.35,
  "71440": -8.95,
  "71441": -8.43,
  "71443": -4.35,
  "71446": -4.35,
  "71447": -5.27,
  "71448": -3.43,
  "71449": -15.45,
  "71450": -14.93,
  "71452": -14.93,
  "71454": -14.93,
  "71455": -5.79,
  "71456": -14.93,
  "71457": -13.34,
  "71458": -13.34,
  "71459": -11.25,
  "71460": -14.93,
  "71461": -4.35,
  "71462": -14.93,
  "71463": -16.31,
  "71465": -19.07,
  "71466": -3.43,
  "71467": -5.27,
  "71468": -14.93,
  "71469": -14.93,
  "71471": -14.93,
  "71472": -3.43,
  "71473": -8.95,
  "71474": -4.35,
  "71475": -4.35,
  "71477": -3.43,
  "71479": -19.59,
  "71480": -19.59,
  "71483": -8.95,
  "71485": 5.06,
  "71486": -14.93,
  "71496": -4.35,
  "71601": -11.77,
  "71602": -11.77,
  "71603": -11.77,
  "71611": -11.77,
  "71612": -11.77,
  "71613": -11.77,
  "71630": -16.46,
  "71631": -19.59,
  "71635": -5.67,
  "71638": -12.69,
  "71639": -15.91,
  "71640": -11.25,
  "71642": -7.26,
  "71643": -12.32,
  "71644": -11.77,
  "71646": -5.67,
  "71647": -19.59,
  "71651": -19.07,
  "71652": -15.54,
  "71653": -15.91,
  "71654": -15.91,
  "71655": -12.69,
  "71656": -12.69,
  "71657": -12.69,
  "71658": -6.19,
  "71659": -11.77,
  "71660": -19.59,
  "71661": -6.19,
  "71662": -15.91,
  "71663": -6.19,
  "71665": -11.77,
  "71666": -16.46,
  "71667": -11.77,
  "71670": -16.46,
  "71671": -19.59,
  "71674": -7.42,
  "71675": -12.69,
  "71676": -6.19,
  "71677": -16.46,
  "71678": -11.77,
  "71701": -12.23,
  "71711": -12.23,
  "71720": -12.23,
  "71721": 7.09,
  "71722": -12.23,
  "71724": -1.13,
  "71725": -15.54,
  "71726": -12.23,
  "71728": 7.09,
  "71730": -0.61,
  "71731": -0.61,
  "71740": -14.87,
  "71742": -14.99,
  "71743": 7.09,
  "71744": -12.23,
  "71745": -12.78,
  "71747": -8.95,
  "71748": -14.99,
  "71749": -1.13,
  "71750": -1.13,
  "71751": -12.23,
  "71752": -15.91,
  "71753": -15.39,
  "71754": -15.39,
  "71758": -12.23,
  "71759": -1.13,
  "71762": -0.61,
  "71763": -14.99,
  "71764": -15.91,
  "71765": -1.13,
  "71766": -12.23,
  "71768": -0.61,
  "71770": -15.91,
  "71772": 7.09,
  "71801": -14.47,
  "71802": -14.47,
  "71820": -6.5,
  "71822": -14.47,
  "71823": -14.99,
  "71825": -14.99,
  "71826": 1.11,
  "71827": 1.11,
  "71828": -15.91,
  "71831": -14.99,
  "71832": -10.79,
  "71833": -7.42,
  "71834": -9.47,
  "71835": -14.99,
  "71836": -14.99,
  "71837": -8.95,
  "71838": -14.99,
  "71839": 1.11,
  "71840": -0.98,
  "71841": -11.31,
  "71842": -10.79,
  "71845": 1.11,
  "71846": -11.31,
  "71847": -14.99,
  "71851": -15.91,
  "71852": -7.42,
  "71853": -9.47,
  "71854": -0.98,
  "71855": -14.99,
  "71857": -14.99,
  "71858": -15.91,
  "71859": -14.99,
  "71860": 1.11,
  "71861": 1.11,
  "71862": -14.99,
  "71864": -15.91,
  "71865": -14.99,
  "71866": -10.79,
  "71901": -10.18,
  "71902": -10.18,
  "71903": -10.18,
  "71909": -8.59,
  "71910": -8.59,
  "71913": -10.18,
  "71914": -10.18,
  "71920": -25.11,
  "71921": -25.11,
  "71922": 7.09,
  "71923": 15.58,
  "71929": 8.68,
  "71932": -14.87,
  "71933": -18.92,
  "71935": -19.99,
  "71937": -15.39,
  "71940": -24.59,
  "71941": -18.46,
  "71942": -18.46,
  "71943": -24.59,
  "71944": -11.31,
  "71945": -14.87,
  "71949": -10.18,
  "71950": -24.59,
  "71951": -10.18,
  "71952": -16.62,
  "71953": -14.87,
  "71956": -10.18,
  "71957": -19.47,
  "71958": -25.11,
  "71959": -15.91,
  "71960": -19.99,
  "71961": -19.47,
  "71962": 7.09,
  "71964": -10.18,
  "71965": -19.47,
  "71966": -19.47,
  "71968": -10.18,
  "71969": -19.99,
  "71970": -19.99,
  "71971": -15.91,
  "71972": -15.39,
  "71973": -15.91,
  "72001": -13.34,
  "72002": -6.96,
  "72003": -5.33,
  "72004": -12.32,
  "72005": -6.13,
  "72006": -14.53,
  "72007": -3.68,
  "72010": -11.71,
  "72011": -6.96,
  "72012": -11.71,
  "72013": -15.58,
  "72014": -6.13,
  "72015": -6.96,
  "72016": 1.44,
  "72017": -11.25,
  "72018": -6.96,
  "72019": -6.96,
  "72020": -3.99,
  "72021": -19.53,
  "72022": -6.44,
  "72023": 3.22,
  "72024": -5.27,
  "72025": -12.82,
  "72026": 3.16,
  "72027": -4.54,
  "72028": -15.58,
  "72029": -20.05,
  "72030": -4.54,
  "72031": -15.58,
  "72032": -4.08,
  "72033": -4.08,
  "72034": -4.08,
  "72036": -14.53,
  "72037": -5.79,
  "72038": 3.16,
  "72039": -4.08,
  "72040": -11.25,
  "72041": -11.25,
  "72042": -5.33,
  "72043": -5.58,
  "72044": -11.44,
  "72045": -6.19,
  "72046": -4.75,
  "72047": -4.6,
  "72048": -5.33,
  "72051": -17.94,
  "72052": -12.23,
  "72053": -0.67,
  "72055": -5.33,
  "72057": -1.19,
  "72058": -4.08,
  "72059": -14.53,
  "72060": -11.71,
  "72061": -4.08,
  "72063": -4.54,
  "72064": -11.25,
  "72065": 0.4,
  "72066": -5.27,
  "72067": -11.44,
  "72068": -12.23,
  "72069": -20.05,
  "72070": -13.34,
  "72072": -6.34,
  "72073": -5.33,
  "72074": -14.53,
  "72075": -5.58,
  "72076": -0.67,
  "72078": -0.67,
  "72079": -1.19,
  "72080": -4.54,
  "72081": -11.71,
  "72082": -12.23,
  "72083": -4.75,
  "72084": -1.19,
  "72085": -11.71,
  "72086": -5.27,
  "72087": -6.96,
  "72088": -15.58,
  "72089": -6.44,
  "72101": -13.49,
  "72102": -11.71,
  "72103": 0.4,
  "72104": -18.46,
  "72105": -18.46,
  "72106": -4.08,
  "72107": -4.6,
  "72108": -19.53,
  "72110": -5.06,
  "72111": -6.19,
  "72112": -5.58,
  "72113": 0.92,
  "72114": -0.15,
  "72115": -0.15,
  "72116": 8.34,
  "72117": -0.15,
  "72118": -0.15,
  "72119": -0.15,
  "72120": -0.15,
  "72121": -11.71,
  "72122": -6.96,
  "72123": -13.49,
  "72124": 8.34,
  "72125": -13.34,
  "72126": -12.82,
  "72127": -5.06,
  "72128": 0.4,
  "72129": 0.4,
  "72130": -11.44,
  "72131": -11.44,
  "72132": -1.19,
  "72133": -12.32,
  "72134": -19.53,
  "72135": 1.44,
  "72136": -11.71,
  "72137": -11.44,
  "72139": -11.71,
  "72140": -5.33,
  "72141": -16.1,
  "72142": -4.75,
  "72143": -10.12,
  "72145": -10.12,
  "72150": -1.19,
  "72152": -11.77,
  "72153": -15.58,
  "72156": -5.06,
  "72157": -4.54,
  "72158": -6.96,
  "72160": -12.32,
  "72164": 0.4,
  "72165": -3.99,
  "72166": -15.91,
  "72167": -6.96,
  "72168": -12.32,
  "72169": -13.49,
  "72170": -5.33,
  "72173": -4.08,
  "72175": -12.32,
  "72176": -5.27,
  "72178": -12.23,
  "72179": -11.44,
  "72180": 0.4,
  "72181": -4.6,
  "72182": -12.32,
  "72183": 0.4,
  "72190": 8.34,
  "72201": -0.67,
  "72202": 0.4,
  "72203": 0.4,
  "72204": 0.4,
  "72205": 0.92,
  "72206": 0.4,
  "72207": 1.99,
  "72209": 0.4,
  "72210": 0.4,
  "72211": 0.92,
  "72212": 8.89,
  "72214": -0.15,
  "72215": 0.92,
  "72216": -0.15,
  "72217": 1.99,
  "72219": 0.4,
  "72221": 8.89,
  "72222": 0.4,
  "72223": -0.67,
  "72225": 0.92,
  "72227": 1.99,
  "72231": -0.67,
  "72260": -0.67,
  "72295": -0.67,
  "72301": -8.95,
  "72303": -8.95,
  "72310": 8.22,
  "72311": -20.05,
  "72312": -17.75,
  "72313": 6.63,
  "72315": 8.22,
  "72316": 8.22,
  "72319": 8.22,
  "72320": -3.03,
  "72321": 16.71,
  "72322": -2.51,
  "72324": -16.62,
  "72325": -8.95,
  "72326": -2.51,
  "72327": -8.95,
  "72328": -17.75,
  "72329": 7.15,
  "72330": 6.63,
  "72331": -9.47,
  "72332": -9.47,
  "72333": -17.75,
  "72335": -2.51,
  "72336": -2.51,
  "72338": 6.63,
  "72339": -9.47,
  "72340": -3.03,
  "72341": -3.03,
  "72342": -17.75,
  "72346": -9.47,
  "72347": -16.62,
  "72348": -3.03,
  "72350": 6.63,
  "72351": 8.22,
  "72352": -3.03,
  "72353": -17.75,
  "72354": -4.66,
  "72355": -3.03,
  "72358": 8.22,
  "72359": -3.03,
  "72360": -3.03,
  "72364": -0.98,
  "72365": -4.66,
  "72366": -17.75,
  "72367": -17.75,
  "72368": -3.03,
  "72369": -17.75,
  "72370": 8.22,
  "72372": -3.03,
  "72373": -18.21,
  "72374": -17.75,
  "72376": -9.47,
  "72377": -4.66,
  "72379": -15.91,
  "72383": -17.75,
  "72384": -9.47,
  "72386": -6.25,
  "72387": -17.69,
  "72389": -17.75,
  "72390": -17.75,
  "72391": 6.63,
  "72392": -20.05,
  "72394": -3.03,
  "72395": 7.15,
  "72396": -17.69,
  "72401": 3.83,
  "72402": 3.83,
  "72403": 3.83,
  "72404": 3.83,
  "72410": 4.08,
  "72411": -4.66,
  "72412": -0.61,
  "72413": -20.3,
  "72414": -4.66,
  "72415": 4.08,
  "72416": -4.66,
  "72417": -4.66,
  "72419": 8.22,
  "72421": 3.53,
  "72422": -17.08,
  "72424": -20.85,
  "72425": -0.06,
  "72426": 8.22,
  "72427": 3.53,
  "72428": 7.67,
  "72429": -5.58,
  "72430": -17.63,
  "72431": -6.13,
  "72432": -4.66,
  "72433": 4.08,
  "72434": 4.08,
  "72435": -17.63,
  "72436": -0.06,
  "72437": -4.66,
  "72438": 8.22,
  "72439": 1.53,
  "72440": 4.08,
  "72441": -17.63,
  "72442": 8.22,
  "72443": -0.06,
  "72444": -20.3,
  "72445": 4.08,
  "72447": -0.06,
  "72449": -20.85,
  "72450": -0.06,
  "72451": -0.06,
  "72453": -0.61,
  "72454": -17.08,
  "72455": -20.3,
  "72456": -17.08,
  "72457": 4.08,
  "72458": 4.08,
  "72459": -13.4,
  "72460": -20.3,
  "72461": -17.08,
  "72462": -20.85,
  "72464": -17.08,
  "72465": -4.66,
  "72466": 4.08,
  "72467": 3.83,
  "72469": 4.08,
  "72470": -17.08,
  "72471": -5.58,
  "72472": -4.66,
  "72473": -5.58,
  "72474": 1.53,
  "72475": -5.58,
  "72476": 4.08,
  "72478": -20.3,
  "72479": -4.66,
  "72482": -13.4,
  "72501": -5.12,
  "72503": -5.12,
  "72512": -13.4,
  "72513": -13.4,
  "72515": -5.37,
  "72517": -18.46,
  "72519": -5.37,
  "72520": -13.4,
  "72521": -5.12,
  "72522": -5.12,
  "72523": -4.6,
  "72524": -5.58,
  "72525": -13.4,
  "72526": -5.12,
  "72527": -5.12,
  "72528": -12.82,
  "72529": -13.4,
  "72530": -11.44,
  "72531": -5.37,
  "72532": -13.4,
  "72533": -17.42,
  "72534": -4.6,
  "72536": -13.4,
  "72537": -14.41,
  "72538": -14.93,
  "72539": -4.91,
  "72540": -17.94,
  "72542": -13.4,
  "72543": -11.44,
  "72544": -14.41,
  "72546": -11.44,
  "72550": -4.08,
  "72553": -5.67,
  "72554": -13.4,
  "72555": -4.08,
  "72556": -18.46,
  "72560": -17.42,
  "72561": -5.12,
  "72562": -5.12,
  "72564": -5.58,
  "72565": -13.4,
  "72566": -12.82,
  "72567": -17.94,
  "72568": -6.19,
  "72569": -13.4,
  "72571": -5.12,
  "72572": 4.08,
  "72573": -13.4,
  "72575": -5.12,
  "72576": -13.4,
  "72577": -11.81,
  "72578": -12.27,
  "72579": -5.12,
  "72581": -11.44,
  "72583": -12.27,
  "72584": -13.4,
  "72585": -5.37,
  "72587": -13.4,
  "72601": -18.92,
  "72602": -18.92,
  "72611": -11.56,
  "72613": -11.56,
  "72615": -18.92,
  "72616": -11.56,
  "72617": -17.94,
  "72619": -14.41,
  "72623": -14.41,
  "72624": -19.47,
  "72626": -14.41,
  "72628": -18.4,
  "72629": -16.1,
  "72630": -13.09,
  "72631": -9.97,
  "72632": -3.07,
  "72633": -19.47,
  "72634": -14.41,
  "72635": -14.93,
  "72636": -18.4,
  "72638": -11.56,
  "72639": -17.94,
  "72640": -18.92,
  "72641": -18.4,
  "72642": -14.41,
  "72644": -13.09,
  "72645": -16.1,
  "72648": -19.47,
  "72650": -16.1,
  "72651": -14.93,
  "72653": -14.41,
  "72654": -14.41,
  "72655": -18.4,
  "72657": -17.94,
  "72658": -12.82,
  "72659": -12.82,
  "72660": -11.56,
  "72661": -19.99,
  "72662": -11.56,
  "72663": -17.94,
  "72666": -18.4,
  "72668": -19.47,
  "72669": -19.47,
  "72670": -19.47,
  "72672": -14.41,
  "72675": -18.4,
  "72677": -14.41,
  "72679": -16.1,
  "72680": -17.94,
  "72682": -19.47,
  "72683": -18.92,
  "72685": -19.47,
  "72686": -16.1,
  "72687": -14.41,
  "72701": 5.27,
  "72702": 5.27,
  "72703": 5.27,
  "72704": -2.7,
  "72711": -4.66,
  "72712": -4.14,
  "72714": -4.14,
  "72715": 3.83,
  "72717": -3.22,
  "72718": -4.14,
  "72719": -4.66,
  "72721": -1.63,
  "72722": -4.66,
  "72727": -10.12,
  "72728": -2.15,
  "72729": 2.76,
  "72730": -3.22,
  "72732": -4.66,
  "72733": -4.66,
  "72734": -4.66,
  "72735": -10.64,
  "72736": -4.66,
  "72737": 5.27,
  "72738": -10.64,
  "72739": 3.83,
  "72740": -10.64,
  "72741": 5.27,
  "72742": -10.12,
  "72744": -3.22,
  "72745": -4.66,
  "72747": -4.66,
  "72749": -3.22,
  "72751": -4.66,
  "72752": -10.12,
  "72753": -3.22,
  "72756": -4.66,
  "72757": -4.14,
  "72758": -4.14,
  "72760": -10.12,
  "72761": -4.66,
  "72762": -2.15,
  "72764": -3.74,
  "72765": -3.74,
  "72766": -3.74,
  "72768": -4.66,
  "72769": -3.22,
  "72770": -2.15,
  "72773": -10.12,
  "72774": -3.22,
  "72776": -10.12,
  "72801": -2.24,
  "72802": -2.24,
  "72811": -2.24,
  "72812": -2.24,
  "72820": -13.95,
  "72821": -13.95,
  "72823": -2.76,
  "72824": -10.06,
  "72826": -12.17,
  "72827": -12.17,
  "72828": -10.58,
  "72829": -2.24,
  "72830": -18.55,
  "72832": -18.55,
  "72833": -10.06,
  "72834": -2.24,
  "72835": -18.55,
  "72837": -2.24,
  "72838": -11.71,
  "72839": -17.48,
  "72840": -18.55,
  "72841": -11.19,
  "72842": -12.17,
  "72843": -2.24,
  "72845": -16.96,
  "72846": -17.48,
  "72847": -2.24,
  "72851": -18.55,
  "72852": -18,
  "72853": -2.76,
  "72854": -17.48,
  "72855": -11.65,
  "72856": -18.4,
  "72857": -2.76,
  "72858": -2.24,
  "72860": -10.58,
  "72863": -18.55,
  "72865": -10.06,
  "72901": -10.27,
  "72902": -10.27,
  "72903": -1.78,
  "72904": -10.27,
  "72906": -1.78,
  "72908": -1.78,
  "72913": -10.27,
  "72914": -10.27,
  "72916": -1.78,
  "72917": -1.78,
  "72918": -1.78,
  "72921": 10.18,
  "72923": -10.27,
  "72926": -11.19,
  "72927": -11.65,
  "72928": -11.65,
  "72930": -13.95,
  "72932": 1.69,
  "72933": -13.95,
  "72934": 1.69,
  "72935": 10.18,
  "72936": -1.78,
  "72937": -10.27,
  "72938": -10.27,
  "72940": -10.27,
  "72941": -8.68,
  "72943": -11.65,
  "72944": -11.19,
  "72945": -10.79,
  "72946": 1.69,
  "72947": -13.95,
  "72948": 1.69,
  "72949": -13.95,
  "72950": -11.71,
  "72951": -11.65,
  "72952": 1.69,
  "72955": 1.69,
  "72956": 1.69,
  "72957": 1.69,
  "72958": -11.71,
  "72959": -3.22,
  "73001": -5.27,
  "73002": -6.5,
  "73003": -0.98,
  "73004": -5.98,
  "73005": -5.27,
  "73006": -5.27,
  "73007": -1.53,
  "73008": -1.53,
  "73009": -5.27,
  "73010": -6.9,
  "73011": -6.5,
  "73012": -0.98,
  "73013": -0.98,
  "73014": -7.51,
  "73015": -5.27,
  "73016": -8.89,
  "73017": -7.57,
  "73018": -5.98,
  "73020": -1.53,
  "73021": -8.89,
  "73022": -7.51,
  "73023": -5.98,
  "73024": -9.41,
  "73025": -0.98,
  "73026": -4.14,
  "73027": -8.89,
  "73028": -9.93,
  "73029": -5.27,
  "73030": -6.9,
  "73031": -6.9,
  "73032": -9.56,
  "73033": -5.27,
  "73034": 6.96,
  "73036": -7.51,
  "73038": -5.27,
  "73039": -3.22,
  "73040": -13.95,
  "73041": -9.41,
  "73042": -5.27,
  "73043": -14.47,
  "73044": -8.89,
  "73045": 5.92,
  "73047": -4.75,
  "73048": -10.27,
  "73049": -1.53,
  "73050": -8.89,
  "73051": -6.9,
  "73052": -7.42,
  "73053": -4.75,
  "73054": 0.31,
  "73055": -1.53,
  "73056": -11.31,
  "73057": -3.74,
  "73058": -8.89,
  "73059": -7.51,
  "73061": -12.69,
  "73062": -5.27,
  "73063": -9.41,
  "73064": -7.51,
  "73065": -4.14,
  "73066": -1.53,
  "73067": -7.05,
  "73068": -4.14,
  "73069": -4.14,
  "73070": -4.14,
  "73071": -4.14,
  "73072": 4.35,
  "73073": -9.41,
  "73074": -3.22,
  "73075": -3.22,
  "73077": -12.69,
  "73078": -6.96,
  "73079": -7.05,
  "73080": -6.9,
  "73082": -7.57,
  "73083": 6.96,
  "73084": -1.53,
  "73085": -7.51,
  "73086": -6.9,
  "73089": -7.05,
  "73090": -7.51,
  "73092": -6.5,
  "73093": -6.9,
  "73094": -5.27,
  "73095": -6.9,
  "73096": -9.2,
  "73097": -1.53,
  "73098": -3.74,
  "73099": -7.51,
  "73101": -1.53,
  "73102": -1.53,
  "73103": -1.53,
  "73104": -1.53,
  "73105": -1.53,
  "73106": -1.53,
  "73107": -1.53,
  "73108": -2.05,
  "73109": -1.53,
  "73110": -1.53,
  "73111": -1.53,
  "73112": -1.53,
  "73113": -1.53,
  "73114": -1.53,
  "73115": -1.53,
  "73116": -0.98,
  "73117": -1.53,
  "73118": -1.53,
  "73119": -1.53,
  "73120": -1.53,
  "73121": -1.53,
  "73122": -1.53,
  "73123": -1.53,
  "73124": -1.53,
  "73125": -1.53,
  "73126": -1.53,
  "73127": -1.53,
  "73128": -1.53,
  "73129": -2.05,
  "73130": -1.53,
  "73131": 6.96,
  "73132": -1.53,
  "73134": 6.96,
  "73135": -1.53,
  "73136": 6.96,
  "73137": -1.53,
  "73139": -1.53,
  "73140": -1.53,
  "73141": -1.53,
  "73142": -0.98,
  "73143": -1.53,
  "73144": -1.53,
  "73145": -1.53,
  "73146": -1.53,
  "73147": -1.53,
  "73148": -2.05,
  "73149": -1.53,
  "73150": -0.98,
  "73151": 6.96,
  "73152": -1.53,
  "73153": -0.46,
  "73154": -1.53,
  "73155": -1.53,
  "73156": -1.53,
  "73157": -1.53,
  "73159": -1.53,
  "73160": -1.53,
  "73162": -0.98,
  "73163": -1.53,
  "73164": -1.53,
  "73165": 4.35,
  "73167": -1.53,
  "73169": -1.53,
  "73170": -1.53,
  "73172": -1.53,
  "73173": 6.96,
  "73178": -0.98,
  "73179": -1.53,
  "73189": -1.53,
  "73195": -1.53,
  "73401": -10.39,
  "73402": -10.39,
  "73403": -10.39,
  "73425": -2.05,
  "73430": -14.47,
  "73432": -9.93,
  "73433": -3.74,
  "73434": -3.22,
  "73435": -9.87,
  "73436": -9.56,
  "73437": -9.87,
  "73438": -9.87,
  "73439": -8.09,
  "73440": -8.09,
  "73441": -13.4,
  "73442": -14.93,
  "73443": -10.39,
  "73444": -3.74,
  "73446": -8.09,
  "73447": -10.48,
  "73448": -14.99,
  "73449": -13.61,
  "73450": -10.48,
  "73453": -13.4,
  "73455": -10.48,
  "73456": -15.45,
  "73458": -10.39,
  "73459": -14.99,
  "73460": -9.93,
  "73461": -10.48,
  "73463": -10.39,
  "73481": -9.87,
  "73487": -3.74,
  "73488": 3.68,
  "73491": -2.05,
  "73501": -10.27,
  "73502": -10.27,
  "73503": -2.3,
  "73505": -9.2,
  "73506": -9.2,
  "73507": -10.27,
  "73520": -14.93,
  "73521": -15.33,
  "73522": -15.33,
  "73523": -15.33,
  "73526": -15.33,
  "73527": -10.27,
  "73528": -19.47,
  "73529": -2.05,
  "73530": -16.37,
  "73531": -19.99,
  "73532": -15.33,
  "73533": -1.53,
  "73534": -1.53,
  "73537": -15.85,
  "73538": -10.27,
  "73539": -15.85,
  "73540": -10.27,
  "73541": -10.27,
  "73542": -15.85,
  "73543": -10.27,
  "73544": -15.85,
  "73546": -20.51,
  "73547": -23.21,
  "73548": -19.99,
  "73549": -15.33,
  "73550": -23.21,
  "73551": -19.99,
  "73552": -10.27,
  "73553": -11.5,
  "73554": -23.21,
  "73555": -15.85,
  "73556": -15.85,
  "73557": -2.3,
  "73558": -10.27,
  "73559": -15.85,
  "73560": -15.85,
  "73561": -15.45,
  "73562": -20.51,
  "73564": -15.85,
  "73565": -15.45,
  "73566": -15.85,
  "73567": -10.79,
  "73568": -19.99,
  "73569": -15.45,
  "73570": -15.85,
  "73571": -23.21,
  "73572": -19.47,
  "73573": -15.45,
  "73601": -10.27,
  "73620": -10.79,
  "73622": -9.41,
  "73624": -9.41,
  "73625": -10.79,
  "73626": -8.89,
  "73627": -1.59,
  "73628": -15.33,
  "73632": -9.41,
  "73638": -16.37,
  "73639": -11.31,
  "73641": -9.41,
  "73642": -15.33,
  "73644": -1.07,
  "73645": -1.59,
  "73646": -14.99,
  "73647": -9.41,
  "73648": -1.07,
  "73650": -15.85,
  "73651": -9.41,
  "73654": -16.37,
  "73655": -23.21,
  "73658": -14.99,
  "73659": -15.91,
  "73660": -15.33,
  "73661": -9.41,
  "73662": -1.59,
  "73663": -15.91,
  "73664": -9.41,
  "73666": -1.59,
  "73667": -15.91,
  "73668": -1.59,
  "73669": -11.31,
  "73673": -23.21,
  "73701": -11.31,
  "73702": -11.31,
  "73703": -2.82,
  "73705": -11.31,
  "73706": -2.82,
  "73716": -9.01,
  "73717": -20.05,
  "73718": -9.01,
  "73719": -0.82,
  "73720": -2.82,
  "73722": -0.27,
  "73724": -14.99,
  "73726": -0.27,
  "73727": -11.31,
  "73728": -0.27,
  "73729": -9.01,
  "73730": -11.31,
  "73731": -20.08,
  "73733": -11.31,
  "73734": -2.11,
  "73735": -10.79,
  "73736": -11.31,
  "73737": -9.01,
  "73738": -11.31,
  "73739": -0.27,
  "73741": -0.27,
  "73742": -2.11,
  "73743": -11.31,
  "73744": -14.99,
  "73746": -20.05,
  "73747": -9.01,
  "73749": -0.27,
  "73750": -1.07,
  "73753": -10.79,
  "73754": -11.31,
  "73755": -9.01,
  "73756": -2.11,
  "73757": -4.2,
  "73758": -4.5,
  "73759": -3.95,
  "73760": -8.49,
  "73761": -3.95,
  "73762": -7.51,
  "73763": -14.99,
  "73764": -14.99,
  "73766": -3.95,
  "73768": -9.01,
  "73770": -14.99,
  "73771": -3.95,
  "73772": -14.99,
  "73773": -11.31,
  "73801": -2.51,
  "73802": -2.51,
  "73832": -24.19,
  "73834": -11.77,
  "73835": -15.91,
  "73838": -15.91,
  "73840": -24.19,
  "73841": -3.03,
  "73842": -20.05,
  "73843": -24.19,
  "73844": -11.77,
  "73848": -11.77,
  "73851": -11.25,
  "73852": -3.03,
  "73853": -15.91,
  "73855": -11.77,
  "73857": -3.03,
  "73858": -24.19,
  "73859": -15.91,
  "73860": -20.05,
  "73901": -4.75,
  "73931": -6.13,
  "73932": -6.13,
  "73933": -20.45,
  "73937": -20.45,
  "73938": -6.65,
  "73939": -12.57,
  "73942": -4.75,
  "73944": -8.49,
  "73945": -4.75,
  "73946": -19.93,
  "73947": -20.45,
  "73949": -12.57,
  "73950": -6.13,
  "73951": -6.65,
  "74001": -8.43,
  "74002": -8.43,
  "74003": -8.89,
  "74005": -8.89,
  "74006": -8.34,
  "74008": -1.23,
  "74010": -5.12,
  "74011": -1.23,
  "74012": -1.78,
  "74013": -1.78,
  "74014": 9.35,
  "74015": -6.5,
  "74016": -6.5,
  "74017": -6.5,
  "74018": -6.5,
  "74019": -6.5,
  "74020": -12.94,
  "74021": -6.5,
  "74022": -8.89,
  "74023": -5.33,
  "74026": -0.73,
  "74027": -17.17,
  "74028": -6.71,
  "74029": -8.89,
  "74030": -5.67,
  "74031": -6.5,
  "74032": -3.74,
  "74033": -2.82,
  "74034": -13.49,
  "74035": -8.43,
  "74036": 0.86,
  "74037": -1.23,
  "74038": -13.49,
  "74039": -5.12,
  "74041": -5.12,
  "74042": -17.17,
  "74043": -1.23,
  "74044": -5.12,
  "74045": -13.49,
  "74046": -6.71,
  "74047": -7.88,
  "74048": -17.17,
  "74050": -3.37,
  "74051": -8.89,
  "74052": -13.49,
  "74053": -6.5,
  "74054": -13.49,
  "74055": 1.99,
  "74056": -8.43,
  "74058": -13.49,
  "74059": -4.29,
  "74060": -13.49,
  "74061": -8.34,
  "74062": -5.33,
  "74063": -2.82,
  "74066": -5.12,
  "74067": -5.12,
  "74068": -5.67,
  "74070": -2.82,
  "74071": -5.67,
  "74072": -17.69,
  "74073": -2.82,
  "74074": 3.16,
  "74075": 3.16,
  "74076": 3.16,
  "74079": -0.73,
  "74080": -6.5,
  "74081": -13.49,
  "74082": -8.34,
  "74083": -17.17,
  "74084": -8.43,
  "74085": -13.49,
  "74101": -2.82,
  "74102": 1.99,
  "74103": 5.67,
  "74104": -2.82,
  "74105": -1.23,
  "74106": -3.37,
  "74107": -2.82,
  "74108": -2.82,
  "74110": -3.37,
  "74112": -2.82,
  "74114": -2.82,
  "74115": -3.37,
  "74116": -2.82,
  "74117": -2.82,
  "74119": -2.82,
  "74120": 5.67,
  "74121": 5.67,
  "74126": -3.37,
  "74127": -2.82,
  "74128": -2.82,
  "74129": -2.82,
  "74130": -3.37,
  "74131": -3.37,
  "74132": -1.23,
  "74133": 5.67,
  "74134": -2.82,
  "74135": 5.67,
  "74136": 5.67,
  "74137": 5.67,
  "74145": -2.82,
  "74146": -2.82,
  "74147": -2.82,
  "74148": -3.37,
  "74149": -2.82,
  "74150": -2.82,
  "74152": -2.82,
  "74153": 5.67,
  "74155": -2.82,
  "74156": -3.37,
  "74157": -3.37,
  "74158": -3.37,
  "74159": -2.82,
  "74169": -2.82,
  "74170": 5.67,
  "74172": 5.67,
  "74301": -14.01,
  "74330": 1.32,
  "74331": -5.06,
  "74332": -14.01,
  "74333": -14.01,
  "74335": -16.37,
  "74337": 1.32,
  "74338": -6.13,
  "74339": -15.85,
  "74340": -5.58,
  "74342": -5.58,
  "74343": -15.85,
  "74344": 1.84,
  "74345": 1.84,
  "74346": -5.58,
  "74347": -6.13,
  "74349": -6.65,
  "74350": -5.58,
  "74352": 0.77,
  "74354": -15.85,
  "74355": -15.85,
  "74358": -16.37,
  "74359": -6.13,
  "74360": -16.37,
  "74361": 1.32,
  "74362": 1.32,
  "74363": -15.85,
  "74364": 1.84,
  "74365": 0.77,
  "74366": 1.32,
  "74367": -5.58,
  "74368": -6.13,
  "74369": -14.01,
  "74370": -15.85,
  "74401": -4.75,
  "74402": -4.75,
  "74403": -4.2,
  "74421": -7.88,
  "74422": -8.43,
  "74423": -4.75,
  "74425": -18.55,
  "74426": -18.55,
  "74427": -14.87,
  "74428": -18.55,
  "74429": 0.86,
  "74430": 0.31,
  "74431": -8.43,
  "74432": -18,
  "74434": -4.2,
  "74435": -4.75,
  "74436": 0.31,
  "74437": -8.43,
  "74438": -18.55,
  "74439": -4.75,
  "74440": -8.95,
  "74441": -14.32,
  "74442": -0.73,
  "74444": -14.32,
  "74445": -7.88,
  "74446": -4.75,
  "74447": -8.43,
  "74450": -4.2,
  "74451": -13.28,
  "74452": -14.32,
  "74454": 0.31,
  "74455": -8.95,
  "74456": -8.43,
  "74457": -16.1,
  "74458": 0.31,
  "74459": -18.55,
  "74460": -8.43,
  "74461": -18.55,
  "74462": -8.43,
  "74463": -4.75,
  "74464": -13.8,
  "74465": -13.8,
  "74467": 0.86,
  "74468": -4.75,
  "74469": -5.27,
  "74470": -8.95,
  "74471": -14.87,
  "74472": -8.95,
  "74477": 0.86,
  "74501": -0.73,
  "74502": -0.73,
  "74521": -8.49,
  "74522": -0.73,
  "74523": -2.57,
  "74525": -16.37,
  "74528": -0.73,
  "74529": 0.31,
  "74530": -10.48,
  "74531": -9.01,
  "74533": -16.37,
  "74534": -6.71,
  "74535": -6.71,
  "74536": -14.01,
  "74538": -7.26,
  "74540": -14.53,
  "74542": -16.37,
  "74543": -15.08,
  "74545": -7.97,
  "74546": 0.31,
  "74547": 0.31,
  "74549": -14.01,
  "74552": -8.43,
  "74553": -0.73,
  "74554": -0.73,
  "74555": -16.37,
  "74556": -7.26,
  "74557": -14.53,
  "74558": -14.01,
  "74559": -7.97,
  "74560": -1.28,
  "74561": -8.95,
  "74562": -14.53,
  "74563": -7.97,
  "74565": -0.73,
  "74567": -14.53,
  "74569": -16.37,
  "74570": -12.23,
  "74571": -7.97,
  "74572": -7.26,
  "74574": -7.97,
  "74576": -6.71,
  "74577": -14.93,
  "74578": -7.97,
  "74601": -5.79,
  "74602": -5.79,
  "74604": 2.7,
  "74630": -12.69,
  "74631": -5.79,
  "74632": -5.79,
  "74633": -8.43,
  "74636": -3.95,
  "74637": -8.43,
  "74640": -3.95,
  "74641": -5.27,
  "74643": -3.95,
  "74644": -12.69,
  "74646": 2.7,
  "74647": -5.27,
  "74650": -13.49,
  "74651": -12.69,
  "74652": -8.43,
  "74653": -5.79,
  "74701": -13.61,
  "74702": -13.61,
  "74720": -13.61,
  "74721": -13.61,
  "74722": -13.49,
  "74723": -13.61,
  "74724": 2.55,
  "74726": -13.61,
  "74727": -2.57,
  "74728": 2.55,
  "74729": -13.61,
  "74730": -13.61,
  "74731": -8.64,
  "74733": -13.61,
  "74734": 2.03,
  "74735": -2.57,
  "74736": 2.03,
  "74737": 2.03,
  "74738": -3.12,
  "74740": 2.03,
  "74741": -13.61,
  "74743": -2.57,
  "74745": 2.55,
  "74747": -14.16,
  "74748": -10.48,
  "74750": 2.03,
  "74752": -13.49,
  "74753": -6.5,
  "74754": 2.03,
  "74755": 2.55,
  "74756": -2.57,
  "74759": -3.12,
  "74760": -2.57,
  "74761": -2.57,
  "74764": 2.55,
  "74766": 2.03,
  "74801": -11.31,
  "74802": -11.31,
  "74804": -2.82,
  "74818": -9.93,
  "74820": -9.01,
  "74821": -9.01,
  "74824": -0.73,
  "74825": -9.01,
  "74826": -11.31,
  "74827": -12.23,
  "74829": -11.31,
  "74830": -10.48,
  "74831": -3.74,
  "74832": -0.73,
  "74833": -11.31,
  "74834": 0.86,
  "74836": -10.48,
  "74837": -11.31,
  "74839": -11.86,
  "74840": -11.31,
  "74842": -9.01,
  "74843": -7.42,
  "74844": -9.56,
  "74845": -20.14,
  "74848": -12.23,
  "74849": -9.93,
  "74850": -12.23,
  "74851": -11.31,
  "74852": -11.31,
  "74854": -10.48,
  "74855": -0.73,
  "74856": -10.48,
  "74857": 2.24,
  "74859": -11.31,
  "74860": -11.31,
  "74864": -0.73,
  "74865": -9.01,
  "74866": -10.48,
  "74867": -9.56,
  "74868": -9.93,
  "74869": -0.73,
  "74871": -9.01,
  "74872": -9.01,
  "74873": -11.31,
  "74875": -0.73,
  "74878": -11.31,
  "74880": -11.86,
  "74881": -0.73,
  "74883": -12.23,
  "74884": -10.48,
  "74901": -10.27,
  "74902": -10.27,
  "74930": -14.41,
  "74931": -13.95,
  "74932": -14.41,
  "74935": -14.93,
  "74936": -13.95,
  "74937": -14.93,
  "74939": -14.93,
  "74940": -14.41,
  "74941": -8.95,
  "74942": -7.97,
  "74943": -8.95,
  "74944": -8.95,
  "74945": -14.47,
  "74946": -10.79,
  "74947": -14.93,
  "74948": -13.95,
  "74949": -14.93,
  "74951": -14.93,
  "74953": -14.41,
  "74954": -10.27,
  "74955": -13.95,
  "74956": -14.41,
  "74957": -15.39,
  "74959": -10.27,
  "74960": -16.1,
  "74962": -13.95,
  "74963": -15.39,
  "74964": -16.1,
  "74965": -16.1,
  "74966": -14.41,
  "75001": 8.74,
  "75002": 10.06,
  "75006": 8.74,
  "75007": 5.06,
  "75009": 10.58,
  "75010": 5.06,
  "75011": 8.74,
  "75013": 10.58,
  "75014": 8.22,
  "75015": 8.74,
  "75016": 8.74,
  "75017": 8.22,
  "75019": 5.06,
  "75020": -4.41,
  "75021": -4.41,
  "75022": 13.55,
  "75023": 10.58,
  "75024": 10.58,
  "75025": 10.58,
  "75026": 10.58,
  "75027": 13.55,
  "75028": 5.58,
  "75029": 5.06,
  "75030": 6.38,
  "75032": 6.9,
  "75034": 12.17,
  "75035": 10.58,
  "75038": 8.74,
  "75039": 19.53,
  "75040": 6.38,
  "75041": 8.22,
  "75042": 8.22,
  "75043": 6.38,
  "75044": 10.06,
  "75045": 8.22,
  "75046": 6.38,
  "75047": 8.22,
  "75048": 6.38,
  "75049": 6.38,
  "75050": 8.22,
  "75051": 8.22,
  "75052": 9.2,
  "75053": 8.22,
  "75054": 8.22,
  "75056": 5.06,
  "75057": 5.06,
  "75058": -3.89,
  "75060": 8.22,
  "75061": 8.22,
  "75062": 8.22,
  "75063": 8.74,
  "75065": 5.06,
  "75067": 5.58,
  "75068": 5.06,
  "75069": 10.06,
  "75070": 12.17,
  "75071": 10.06,
  "75074": 10.06,
  "75075": 10.58,
  "75076": -2.82,
  "75077": 5.06,
  "75078": 10.58,
  "75080": 8.22,
  "75081": 8.22,
  "75082": 10.58,
  "75083": 8.22,
  "75085": 8.22,
  "75086": 10.06,
  "75087": 6.9,
  "75088": 6.38,
  "75089": 6.38,
  "75090": -4.41,
  "75091": -4.41,
  "75092": -3.89,
  "75093": 14.47,
  "75094": 10.58,
  "75097": 10.58,
  "75098": 6.38,
  "75101": -0.98,
  "75102": -7.17,
  "75103": -6.96,
  "75104": -0.46,
  "75105": -5.58,
  "75106": -0.46,
  "75109": -5.58,
  "75110": -5.58,
  "75114": -0.06,
  "75115": 8.22,
  "75116": 8.22,
  "75117": -6.96,
  "75118": -0.06,
  "75119": -0.98,
  "75120": -0.98,
  "75121": -6.19,
  "75123": 8.22,
  "75124": -7.88,
  "75125": -0.98,
  "75126": 6.38,
  "75127": -7.51,
  "75132": 6.38,
  "75134": 8.22,
  "75135": -5.12,
  "75137": 8.74,
  "75138": 8.22,
  "75140": -7.51,
  "75141": 8.22,
  "75142": -0.06,
  "75143": -7.88,
  "75144": -6.13,
  "75146": -0.98,
  "75147": -8.43,
  "75148": -8.43,
  "75149": 8.22,
  "75150": 8.22,
  "75151": -5.58,
  "75152": -0.98,
  "75153": -5.58,
  "75154": -0.98,
  "75155": -5.58,
  "75156": -8.43,
  "75157": -0.06,
  "75158": -0.06,
  "75159": -0.06,
  "75160": -0.06,
  "75161": -0.06,
  "75163": -7.88,
  "75164": 6.38,
  "75165": -0.46,
  "75166": 6.38,
  "75167": -0.46,
  "75168": -0.98,
  "75169": -6.96,
  "75172": 8.22,
  "75173": 6.38,
  "75180": 8.22,
  "75181": 8.22,
  "75182": 6.9,
  "75185": 8.22,
  "75187": 8.22,
  "75189": 6.38,
  "75201": 19.01,
  "75202": 8.74,
  "75203": 8.22,
  "75204": 8.74,
  "75205": 19.01,
  "75206": 8.22,
  "75207": 8.22,
  "75208": 8.22,
  "75209": 8.74,
  "75210": 8.22,
  "75211": 8.22,
  "75212": 8.22,
  "75214": 8.74,
  "75215": 8.22,
  "75216": 8.22,
  "75217": 8.22,
  "75218": 8.22,
  "75219": 8.74,
  "75220": 8.22,
  "75221": 8.22,
  "75222": 8.22,
  "75223": 8.22,
  "75224": 8.22,
  "75225": 19.01,
  "75226": 19.01,
  "75227": 8.22,
  "75228": 8.22,
  "75229": 8.74,
  "75230": 16.71,
  "75231": 8.74,
  "75232": 8.22,
  "75233": 8.22,
  "75234": 8.22,
  "75235": 8.22,
  "75236": 8.22,
  "75237": 8.22,
  "75238": 8.74,
  "75240": 8.74,
  "75241": 8.22,
  "75242": 8.74,
  "75243": 8.22,
  "75244": 8.74,
  "75245": 8.74,
  "75246": 8.22,
  "75247": 8.22,
  "75248": 8.74,
  "75249": 8.74,
  "75250": 19.01,
  "75251": 8.74,
  "75252": 10.58,
  "75253": 8.22,
  "75254": 8.74,
  "75258": 8.74,
  "75260": 8.22,
  "75261": 8.74,
  "75262": 8.22,
  "75263": 8.22,
  "75264": 8.22,
  "75265": 8.22,
  "75266": 8.22,
  "75267": 8.22,
  "75270": 8.74,
  "75287": 8.74,
  "75313": 19.01,
  "75315": 8.22,
  "75334": 8.22,
  "75336": 8.22,
  "75339": 8.22,
  "75340": 8.22,
  "75342": 8.22,
  "75343": 8.22,
  "75344": 8.22,
  "75354": 8.22,
  "75355": 8.74,
  "75356": 8.22,
  "75357": 8.22,
  "75359": 8.74,
  "75360": 8.74,
  "75367": 16.71,
  "75370": 8.74,
  "75371": 8.22,
  "75372": 8.22,
  "75374": 8.22,
  "75376": 8.22,
  "75378": 8.74,
  "75379": 10.58,
  "75380": 8.74,
  "75381": 8.74,
  "75382": 8.74,
  "75398": 8.22,
  "75401": -6.71,
  "75402": -5.12,
  "75403": -6.71,
  "75404": -6.71,
  "75407": 10.06,
  "75409": 8.99,
  "75410": -7.42,
  "75411": 5,
  "75412": -7.17,
  "75413": -10.85,
  "75414": -3.89,
  "75415": -10.85,
  "75416": -3.49,
  "75417": -7.17,
  "75418": -10.85,
  "75420": -6.13,
  "75421": -3.49,
  "75422": -6.19,
  "75423": -6.19,
  "75424": 8.99,
  "75425": -1.9,
  "75426": -7.17,
  "75428": -6.19,
  "75429": -6.19,
  "75431": -6.13,
  "75432": -7.17,
  "75433": -6.65,
  "75434": -3.49,
  "75435": -3.49,
  "75436": -7.17,
  "75437": -6.13,
  "75438": -10.85,
  "75439": -10.85,
  "75440": -7.42,
  "75441": -3.49,
  "75442": -6.19,
  "75443": -9.26,
  "75444": -7.42,
  "75446": -10.85,
  "75447": -9.26,
  "75448": -7.17,
  "75449": -10.85,
  "75450": 5,
  "75451": 4.45,
  "75452": -10.33,
  "75453": -7.42,
  "75454": 8.99,
  "75455": -2.45,
  "75456": -2.45,
  "75457": -15.79,
  "75458": -6.19,
  "75459": -3.89,
  "75460": -3.49,
  "75461": -3.49,
  "75462": 5,
  "75468": -3.49,
  "75469": -10.85,
  "75470": -4.04,
  "75471": -15.79,
  "75472": -7.97,
  "75473": 5,
  "75474": -5.12,
  "75475": -10.85,
  "75476": -9.26,
  "75477": -4.04,
  "75478": -16.31,
  "75479": -10.85,
  "75480": -7.3,
  "75481": -6.13,
  "75482": -5.58,
  "75483": -5.58,
  "75485": 8.99,
  "75486": -1.9,
  "75487": -2.97,
  "75488": -10.85,
  "75489": -3.89,
  "75490": -10.33,
  "75491": -10.33,
  "75492": -9.26,
  "75493": -16.31,
  "75494": -2.45,
  "75495": 4.6,
  "75496": -10.85,
  "75497": -1.9,
  "75501": -7.57,
  "75503": 0.4,
  "75504": -8.09,
  "75505": -8.09,
  "75550": -7.17,
  "75551": -11.25,
  "75554": -7.17,
  "75555": -11.77,
  "75556": -11.25,
  "75558": 5,
  "75559": -7.57,
  "75560": -11.77,
  "75561": -8.09,
  "75562": -11.77,
  "75563": -11.77,
  "75564": -6.71,
  "75565": -12.32,
  "75566": -11.77,
  "75567": -8.09,
  "75568": 19.11,
  "75569": -8.09,
  "75570": -7.57,
  "75571": 19.11,
  "75572": -11.77,
  "75573": -8.09,
  "75574": -7.57,
  "75601": -7.05,
  "75602": -7.57,
  "75603": -7.57,
  "75604": -7.05,
  "75605": 1.44,
  "75606": -7.05,
  "75607": 1.44,
  "75608": -7.05,
  "75615": -7.57,
  "75630": -6.71,
  "75631": -4.41,
  "75633": -4.41,
  "75636": 19.11,
  "75637": -13.09,
  "75638": 19.11,
  "75639": -4.41,
  "75640": -4.29,
  "75641": -7.57,
  "75642": -4.41,
  "75643": -4.41,
  "75644": -4.29,
  "75645": -4.29,
  "75647": -7.05,
  "75650": -5.67,
  "75651": -6.71,
  "75652": -4.75,
  "75653": -4.75,
  "75654": -4.75,
  "75656": 19.11,
  "75657": -6.71,
  "75658": -12.57,
  "75659": -6.71,
  "75660": 1.44,
  "75661": -6.71,
  "75662": -7.05,
  "75663": -7.05,
  "75666": -7.05,
  "75667": -12.57,
  "75668": 19.11,
  "75669": -13.09,
  "75670": -6.71,
  "75671": -6.71,
  "75672": -6.71,
  "75680": -4.75,
  "75681": -13.09,
  "75682": -12.57,
  "75683": -4.81,
  "75684": -12.57,
  "75685": -6.71,
  "75686": 4.45,
  "75687": -12.57,
  "75688": 1.78,
  "75689": -12.57,
  "75691": -3.37,
  "75692": -6.71,
  "75693": 1.44,
  "75694": -6.71,
  "75701": -6.04,
  "75702": -6.59,
  "75703": 1.9,
  "75704": -6.59,
  "75705": -6.59,
  "75706": -6.59,
  "75707": -5,
  "75708": -6.59,
  "75709": -6.04,
  "75710": -6.59,
  "75711": -6.59,
  "75712": -6.04,
  "75713": -6.04,
  "75750": -6.59,
  "75751": -7.88,
  "75752": -7.88,
  "75754": -7.51,
  "75755": -4.29,
  "75756": -6.59,
  "75757": 1.9,
  "75758": -6.59,
  "75759": -4.75,
  "75760": -7.05,
  "75762": 1.9,
  "75763": -6.13,
  "75764": -4.75,
  "75765": -2.45,
  "75766": -4.75,
  "75770": -8.43,
  "75771": 1.9,
  "75772": -4.75,
  "75773": -1.9,
  "75778": -8.43,
  "75779": -6.13,
  "75780": -4.75,
  "75782": -6.13,
  "75783": -1.9,
  "75784": -4.75,
  "75785": -4.75,
  "75788": -4.75,
  "75789": -4.75,
  "75790": -6.96,
  "75791": 1.9,
  "75792": -6.59,
  "75801": -6.13,
  "75802": -6.13,
  "75803": -6.13,
  "75831": -2.05,
  "75832": -6.13,
  "75833": -2.05,
  "75834": -7.11,
  "75835": -7.57,
  "75838": -10.39,
  "75839": -6.13,
  "75840": -9.35,
  "75844": -7.05,
  "75845": -9.87,
  "75846": -1.53,
  "75847": -7.05,
  "75848": -10.94,
  "75849": -7.05,
  "75850": -2.05,
  "75851": -7.57,
  "75852": -12.88,
  "75853": -6.13,
  "75855": -5.58,
  "75856": -7.57,
  "75858": -7.05,
  "75859": -1.9,
  "75860": -10.39,
  "75861": -6.13,
  "75862": -9.87,
  "75865": -9.87,
  "75901": -6.59,
  "75902": -6.59,
  "75903": -6.59,
  "75904": -6.59,
  "75915": -6.59,
  "75925": -4.75,
  "75926": -7.11,
  "75928": -9.87,
  "75929": -18.61,
  "75930": -18.61,
  "75931": -19.13,
  "75932": -18.09,
  "75933": -10.39,
  "75934": -2.05,
  "75935": -8.49,
  "75936": -7.17,
  "75937": -8.09,
  "75938": -7.17,
  "75939": -2.05,
  "75941": -7.11,
  "75942": -7.17,
  "75943": -6.5,
  "75944": -7.63,
  "75946": -7.05,
  "75948": -18.61,
  "75949": -7.11,
  "75951": -9.87,
  "75954": -8.49,
  "75956": -10.39,
  "75958": -5.46,
  "75959": -18.61,
  "75960": -2.05,
  "75961": -5.46,
  "75963": -5.46,
  "75964": -7.05,
  "75965": -5.46,
  "75966": -9.87,
  "75968": -19.13,
  "75969": -6.59,
  "75972": -8.49,
  "75973": -8.49,
  "75974": -9.01,
  "75975": -9.01,
  "75976": -7.05,
  "75977": -18.61,
  "75978": -7.05,
  "75979": -7.17,
  "75980": -7.63,
  "76001": 9.2,
  "76002": 9.2,
  "76003": 9.2,
  "76004": 8.68,
  "76005": 8.68,
  "76006": 17.69,
  "76007": 8.68,
  "76008": 8.74,
  "76009": -3.28,
  "76010": 8.68,
  "76011": 8.68,
  "76012": 10.79,
  "76013": 9.2,
  "76014": 8.68,
  "76015": 9.2,
  "76016": 9.2,
  "76017": 9.2,
  "76018": 9.2,
  "76020": 0.25,
  "76021": 9.2,
  "76022": 9.2,
  "76023": -3.83,
  "76028": -3.83,
  "76031": -4.35,
  "76033": -4.35,
  "76034": 9.2,
  "76035": -0.67,
  "76036": -4.35,
  "76039": 8.68,
  "76040": 8.68,
  "76041": -0.98,
  "76043": 3.53,
  "76044": -3.83,
  "76048": -0.67,
  "76049": -0.15,
  "76050": -2.76,
  "76051": 5.06,
  "76052": 16.1,
  "76053": 9.2,
  "76054": 17.69,
  "76055": 2.7,
  "76058": -4.35,
  "76059": -4.35,
  "76060": 9.2,
  "76061": -2.76,
  "76063": 9.2,
  "76064": -0.46,
  "76065": -0.46,
  "76066": 0.25,
  "76067": -14.01,
  "76068": -14.01,
  "76070": 3.53,
  "76071": -4.35,
  "76073": -3.83,
  "76077": 3.53,
  "76078": -2.76,
  "76082": 0.25,
  "76084": -3.28,
  "76085": 0.77,
  "76086": 0.77,
  "76087": 0.77,
  "76088": 0.77,
  "76092": 15.85,
  "76093": -4.35,
  "76094": 9.2,
  "76095": 9.2,
  "76096": 9.2,
  "76097": -3.83,
  "76098": 0.25,
  "76099": 5.06,
  "76101": 7.61,
  "76102": 7.61,
  "76103": 7.61,
  "76104": 7.61,
  "76105": 7.61,
  "76106": 7.61,
  "76107": 7.61,
  "76108": 7.61,
  "76109": 16.1,
  "76110": 7.61,
  "76111": 7.61,
  "76112": 8.68,
  "76113": 7.61,
  "76114": 7.61,
  "76115": 7.61,
  "76116": 8.13,
  "76117": 7.61,
  "76118": 8.13,
  "76119": 7.61,
  "76120": 9.2,
  "76121": 8.13,
  "76123": 8.13,
  "76124": 8.68,
  "76126": 8.13,
  "76127": 7.61,
  "76131": 8.13,
  "76132": 16.1,
  "76133": 7.61,
  "76134": 7.61,
  "76135": 7.61,
  "76136": 8.13,
  "76137": 8.13,
  "76140": 7.61,
  "76147": 7.61,
  "76148": 7.61,
  "76150": 7.61,
  "76155": 8.68,
  "76161": 7.61,
  "76162": 7.61,
  "76163": 7.61,
  "76164": 7.61,
  "76177": 16.1,
  "76179": 8.13,
  "76180": 8.13,
  "76181": 8.13,
  "76182": 9.2,
  "76185": 8.13,
  "76201": 5.06,
  "76202": 5.06,
  "76203": 5.06,
  "76204": 5.06,
  "76205": 5.06,
  "76206": 5.06,
  "76207": 5.06,
  "76208": 5.06,
  "76209": 5.06,
  "76210": 5.06,
  "76225": -2.76,
  "76226": 13.55,
  "76227": 5.06,
  "76228": -9.87,
  "76230": -6.19,
  "76233": -3.89,
  "76234": -2.76,
  "76238": -7.36,
  "76239": -4.6,
  "76240": -7.36,
  "76241": -7.36,
  "76244": 16.1,
  "76245": -4.41,
  "76246": -2.76,
  "76247": 5.06,
  "76248": 16.1,
  "76249": 5.06,
  "76250": -7.36,
  "76251": -4.6,
  "76252": -7.36,
  "76253": -7.88,
  "76255": -6.19,
  "76258": 5.06,
  "76259": 5.06,
  "76261": -10.39,
  "76262": 5.58,
  "76263": -7.36,
  "76264": -3.89,
  "76265": -4.6,
  "76266": 5.06,
  "76267": -2.76,
  "76268": -4.41,
  "76270": -4.6,
  "76271": -8.95,
  "76272": -7.36,
  "76273": -8.95,
  "76301": -6.25,
  "76302": -4.66,
  "76305": -5.73,
  "76306": -5.73,
  "76307": -6.25,
  "76308": 2.76,
  "76309": -5.73,
  "76310": 2.24,
  "76311": -5.73,
  "76351": -12.69,
  "76352": -10.39,
  "76354": -5.73,
  "76357": -10.39,
  "76360": -6.25,
  "76363": -16.83,
  "76364": -6.25,
  "76365": -10.39,
  "76366": -12.69,
  "76367": -5.73,
  "76369": -12.17,
  "76370": 53.55,
  "76371": -11.77,
  "76372": 53.55,
  "76373": -5.73,
  "76374": 53.55,
  "76377": -10.39,
  "76379": -12.17,
  "76380": -16.83,
  "76384": -16.83,
  "76385": -16.83,
  "76388": -11.77,
  "76389": -11.1,
  "76401": -6.19,
  "76424": -12.23,
  "76426": -2.76,
  "76427": -5.33,
  "76429": -11.71,
  "76430": -12.23,
  "76431": -2.76,
  "76432": -9.41,
  "76433": -6.19,
  "76435": -7.63,
  "76436": -8.95,
  "76437": -7.63,
  "76439": 0.25,
  "76442": -18.61,
  "76443": 16.75,
  "76444": -18.61,
  "76445": -7.11,
  "76446": -6.19,
  "76448": -7.11,
  "76449": -14.01,
  "76450": 54.07,
  "76452": -18.09,
  "76453": -14.01,
  "76454": -7.63,
  "76455": -18.61,
  "76457": -9.47,
  "76458": -5.33,
  "76459": -5.33,
  "76460": 55.14,
  "76461": -6.19,
  "76462": -0.67,
  "76463": -14.01,
  "76464": 16.75,
  "76465": -6.19,
  "76466": -7.63,
  "76467": -6.19,
  "76468": -18.61,
  "76469": 17.27,
  "76470": -7.63,
  "76471": -7.63,
  "76472": -14.01,
  "76474": -18.61,
  "76475": -14.01,
  "76476": -0.67,
  "76481": 54.07,
  "76483": -16.83,
  "76484": -13.49,
  "76485": 0.77,
  "76486": -4.81,
  "76487": 0.25,
  "76490": 0.25,
  "76491": -12.23,
  "76501": 2.15,
  "76502": 10.64,
  "76503": 10.64,
  "76504": 2.15,
  "76505": 2.15,
  "76511": 2.15,
  "76513": 3.74,
  "76518": -2.51,
  "76519": -2.51,
  "76520": -2.51,
  "76522": -9.35,
  "76523": -2.51,
  "76524": -4.87,
  "76525": -8.95,
  "76526": -10.39,
  "76527": 3.07,
  "76528": -9.87,
  "76530": 3.07,
  "76531": 0.06,
  "76533": 2.15,
  "76534": 2.15,
  "76537": 3.07,
  "76538": -8.43,
  "76539": -10.27,
  "76540": 1.63,
  "76541": 1.63,
  "76542": 2.15,
  "76543": 2.15,
  "76544": -9.35,
  "76547": 1.63,
  "76548": 1.63,
  "76549": 1.63,
  "76550": -10.27,
  "76554": 2.15,
  "76556": -2.51,
  "76557": 2.15,
  "76558": -10.39,
  "76559": 1.63,
  "76561": -10.39,
  "76564": 3.74,
  "76565": 0.06,
  "76566": -9.35,
  "76567": -1.99,
  "76569": -1.99,
  "76570": -7.11,
  "76571": 10.64,
  "76573": 3.07,
  "76574": 4.66,
  "76577": -1.99,
  "76578": -0.4,
  "76579": 3.74,
  "76621": 1.11,
  "76622": 1.11,
  "76623": -0.98,
  "76624": -4.87,
  "76626": -7.17,
  "76627": 1.11,
  "76628": 1.11,
  "76629": -7.57,
  "76630": -4.87,
  "76631": 1.11,
  "76632": -7.63,
  "76633": 3.62,
  "76634": 5.25,
  "76635": -17.84,
  "76636": 3.22,
  "76637": 5.25,
  "76638": 3.62,
  "76639": -7.17,
  "76640": -4.87,
  "76641": -7.17,
  "76642": -17.29,
  "76643": 3.62,
  "76644": 1.11,
  "76645": 1.11,
  "76648": 1.11,
  "76649": 5.25,
  "76650": 1.11,
  "76651": -0.98,
  "76652": 2.49,
  "76653": -17.29,
  "76654": -4.87,
  "76655": 3.62,
  "76656": -1.99,
  "76657": -4.87,
  "76660": 1.11,
  "76661": -7.63,
  "76664": -17.29,
  "76665": 5.25,
  "76666": 1.11,
  "76667": -17.29,
  "76670": 1.11,
  "76671": 5.25,
  "76673": -4.87,
  "76676": 1.11,
  "76678": -17.29,
  "76679": -7.17,
  "76680": -8.18,
  "76681": -7.17,
  "76682": -7.63,
  "76684": -4.87,
  "76685": -7.63,
  "76686": -17.29,
  "76687": -17.29,
  "76689": 5.25,
  "76690": 1.94,
  "76691": 1.11,
  "76692": 1.11,
  "76693": -17.29,
  "76701": -5.42,
  "76702": -5.42,
  "76703": -5.42,
  "76704": -5.42,
  "76705": -5.42,
  "76706": -4.87,
  "76707": -5.42,
  "76708": -4.87,
  "76710": -3.28,
  "76711": -5.42,
  "76712": 3.62,
  "76714": -3.28,
  "76715": -4.87,
  "76716": -4.87,
  "76798": -4.87,
  "76801": -9.41,
  "76802": -9.41,
  "76803": -9.41,
  "76804": -8.34,
  "76820": -2.24,
  "76821": 42.05,
  "76823": -9.93,
  "76824": -16.31,
  "76825": -11.5,
  "76827": -8.34,
  "76828": -7.17,
  "76831": -2.24,
  "76832": -15.79,
  "76834": -7.17,
  "76836": -11.5,
  "76837": -11.31,
  "76841": -11.31,
  "76842": -10.73,
  "76844": -17.69,
  "76845": 1.32,
  "76848": -11.31,
  "76849": 1.17,
  "76852": -11.5,
  "76853": -10.79,
  "76854": 0.65,
  "76855": -2.57,
  "76856": -11.25,
  "76857": -9.93,
  "76858": -20.51,
  "76859": -11.31,
  "76861": -2.05,
  "76862": -19.99,
  "76864": -17.17,
  "76865": 42.05,
  "76866": 42.57,
  "76869": -2.24,
  "76870": -17.69,
  "76871": -16.31,
  "76872": -19.99,
  "76873": -6.65,
  "76874": 0.65,
  "76875": 42.57,
  "76877": -16.31,
  "76878": -6.65,
  "76880": -17.69,
  "76882": -7.17,
  "76883": 0.65,
  "76884": -7.17,
  "76885": -15.79,
  "76886": 5.92,
  "76887": -2.76,
  "76888": -7.17,
  "76890": -9.41,
  "76901": -2.57,
  "76902": -2.57,
  "76903": -2.57,
  "76904": -2.57,
  "76905": -2.57,
  "76906": -2.57,
  "76908": 5.92,
  "76930": -7.17,
  "76932": 2.09,
  "76933": 7.09,
  "76934": -2.57,
  "76935": -2.05,
  "76936": -9.01,
  "76937": -2.57,
  "76939": 5.92,
  "76940": -2.57,
  "76941": -2.05,
  "76943": -7.17,
  "76945": 7.09,
  "76949": 7.09,
  "76950": -9.01,
  "76951": 7.09,
  "76953": 7.61,
  "76955": -2.05,
  "76957": 5.92,
  "76958": 7.61,
  "77001": 7.67,
  "77002": 8.22,
  "77003": 7.67,
  "77004": 8.22,
  "77005": 19.01,
  "77006": 16.71,
  "77007": 8.22,
  "77008": 8.22,
  "77009": 8.22,
  "77010": 8.22,
  "77011": 7.67,
  "77012": 7.67,
  "77013": 8.22,
  "77014": 8.22,
  "77015": 8.22,
  "77016": 7.67,
  "77017": 8.22,
  "77018": 8.22,
  "77019": 19.01,
  "77020": 7.67,
  "77021": 8.22,
  "77022": 8.22,
  "77023": 8.22,
  "77024": 19.01,
  "77025": 8.22,
  "77026": 7.67,
  "77027": 19.01,
  "77028": 7.67,
  "77029": 8.22,
  "77030": 19.01,
  "77031": 11.44,
  "77032": 8.22,
  "77033": 7.67,
  "77034": 8.22,
  "77035": 8.22,
  "77036": 8.22,
  "77037": 8.22,
  "77038": 8.22,
  "77039": 8.22,
  "77040": 8.22,
  "77041": 8.22,
  "77042": 8.22,
  "77043": 8.22,
  "77044": 8.22,
  "77045": 8.22,
  "77046": 16.71,
  "77047": 8.22,
  "77048": 8.22,
  "77049": 8.22,
  "77050": 8.22,
  "77051": 7.67,
  "77052": 8.22,
  "77053": 11.44,
  "77054": 8.22,
  "77055": 8.22,
  "77056": 19.01,
  "77057": 8.22,
  "77058": 9.6,
  "77059": 10.12,
  "77060": 8.22,
  "77061": 8.22,
  "77062": 1.63,
  "77063": 8.22,
  "77064": 8.22,
  "77065": 8.22,
  "77066": 8.22,
  "77067": 8.22,
  "77068": 8.22,
  "77069": 8.22,
  "77070": 8.22,
  "77071": 11.44,
  "77072": 11.44,
  "77073": 8.22,
  "77074": 8.22,
  "77075": 8.22,
  "77076": 8.22,
  "77077": 11.44,
  "77078": 8.22,
  "77079": 16.71,
  "77080": 8.22,
  "77081": 8.22,
  "77082": 11.44,
  "77083": 11.44,
  "77084": 11.44,
  "77085": 11.44,
  "77086": 8.22,
  "77087": 8.22,
  "77088": 8.22,
  "77089": 8.22,
  "77090": 8.22,
  "77091": 8.22,
  "77092": 8.22,
  "77093": 7.67,
  "77094": 13.03,
  "77095": 8.22,
  "77096": 8.22,
  "77097": 8.22,
  "77098": 16.71,
  "77099": 11.44,
  "77201": 8.22,
  "77202": 8.22,
  "77203": 8.22,
  "77205": 8.22,
  "77206": 8.22,
  "77207": 8.22,
  "77208": 8.22,
  "77210": 8.22,
  "77213": 8.22,
  "77215": 8.22,
  "77217": 8.22,
  "77218": 11.44,
  "77219": 19.01,
  "77220": 7.67,
  "77221": 8.22,
  "77222": 8.22,
  "77223": 8.22,
  "77224": 19.01,
  "77225": 19.01,
  "77226": 7.67,
  "77227": 19.01,
  "77228": 8.22,
  "77229": 7.67,
  "77230": 8.22,
  "77231": 8.22,
  "77233": 7.67,
  "77234": 8.22,
  "77235": 8.22,
  "77236": 8.22,
  "77237": 8.22,
  "77238": 8.22,
  "77240": 8.22,
  "77241": 8.22,
  "77242": 8.22,
  "77243": 8.22,
  "77244": 16.71,
  "77245": 8.22,
  "77246": 8.22,
  "77247": 8.22,
  "77248": 8.22,
  "77249": 8.22,
  "77250": 8.22,
  "77251": 8.22,
  "77252": 8.22,
  "77253": 8.22,
  "77254": 16.71,
  "77255": 8.22,
  "77256": 19.01,
  "77257": 8.22,
  "77258": 9.6,
  "77259": 1.63,
  "77260": 8.22,
  "77261": 8.22,
  "77262": 8.22,
  "77263": 8.22,
  "77265": 19.01,
  "77266": 16.71,
  "77267": 8.22,
  "77268": 8.22,
  "77269": 8.22,
  "77270": 8.22,
  "77271": 11.44,
  "77272": 11.44,
  "77273": 8.22,
  "77274": 8.22,
  "77275": 8.22,
  "77276": 8.22,
  "77277": 19.01,
  "77278": 8.22,
  "77279": 19.01,
  "77280": 8.22,
  "77282": 11.44,
  "77284": 8.22,
  "77285": 8.22,
  "77286": 8.22,
  "77287": 8.22,
  "77288": 8.22,
  "77289": 10.12,
  "77290": 8.22,
  "77291": 8.22,
  "77292": 8.22,
  "77293": 7.67,
  "77294": 8.22,
  "77296": 8.22,
  "77301": 3.47,
  "77302": 3.47,
  "77303": 3.47,
  "77304": 3.99,
  "77305": 3.47,
  "77306": 3.47,
  "77315": 8.22,
  "77316": 3.47,
  "77318": 3.99,
  "77320": -2.51,
  "77325": 8.22,
  "77326": -2.57,
  "77327": -12.63,
  "77328": -12.63,
  "77331": -12.63,
  "77332": -2.57,
  "77333": -5.27,
  "77334": -2.51,
  "77335": -2.57,
  "77336": 3.47,
  "77337": 3.99,
  "77338": 8.22,
  "77339": 8.22,
  "77340": -2.51,
  "77342": -2.51,
  "77345": 6.13,
  "77346": 8.22,
  "77347": 8.22,
  "77350": -2.05,
  "77351": -2.57,
  "77353": 2.55,
  "77354": 3.47,
  "77355": 2.55,
  "77356": 11.96,
  "77357": 3.47,
  "77358": -2.51,
  "77359": -2.51,
  "77360": -2.05,
  "77362": 3.47,
  "77363": -5.27,
  "77364": -12.63,
  "77365": 3.47,
  "77367": -2.51,
  "77368": 3.47,
  "77369": -2.57,
  "77371": -12.63,
  "77372": 3.47,
  "77373": 3.47,
  "77374": 2.95,
  "77375": 3.99,
  "77376": 2.95,
  "77377": 3.99,
  "77378": 3.47,
  "77379": 4.54,
  "77380": 3.99,
  "77381": 11.96,
  "77382": 11.96,
  "77383": 3.47,
  "77384": 11.96,
  "77385": 3.47,
  "77386": 3.99,
  "77387": 3.47,
  "77388": 3.99,
  "77389": 4.54,
  "77391": 4.54,
  "77393": 11.96,
  "77396": 8.22,
  "77401": 16.71,
  "77402": 8.22,
  "77404": 2.95,
  "77406": 11.44,
  "77407": 11.44,
  "77410": 3.62,
  "77411": 11.44,
  "77412": 8.34,
  "77413": 13.03,
  "77414": 3.99,
  "77415": 2.95,
  "77417": 11.44,
  "77418": 7.42,
  "77419": 3.47,
  "77420": -9.72,
  "77422": 3.87,
  "77423": 3.62,
  "77426": 7.42,
  "77428": 3.99,
  "77429": 3.62,
  "77430": 5.46,
  "77431": 4.91,
  "77432": -10.79,
  "77433": 3.62,
  "77434": 6.75,
  "77435": -9.72,
  "77436": -10.27,
  "77437": -10.27,
  "77440": 3.99,
  "77441": 13.03,
  "77442": 6.75,
  "77443": -10.27,
  "77444": 11.44,
  "77445": 4.66,
  "77446": 2.55,
  "77447": 2.55,
  "77448": -9.72,
  "77449": 11.44,
  "77450": 11.44,
  "77451": -10.27,
  "77452": 7.42,
  "77453": -9.72,
  "77454": 7.3,
  "77455": -3.83,
  "77456": 3.47,
  "77457": 3.47,
  "77458": 3.47,
  "77459": 11.44,
  "77460": 6.75,
  "77461": 11.44,
  "77463": 3.87,
  "77464": 11.44,
  "77465": 3.47,
  "77466": 3.62,
  "77467": -2.3,
  "77468": -9.72,
  "77469": 11.44,
  "77470": 6.23,
  "77471": 11.44,
  "77473": 6.38,
  "77474": 6.38,
  "77475": 6.23,
  "77476": 6.38,
  "77477": 11.44,
  "77478": 11.44,
  "77479": 13.03,
  "77480": 3.87,
  "77481": 11.44,
  "77482": 4.54,
  "77483": 3.47,
  "77484": 2.55,
  "77485": 6.38,
  "77486": 5.46,
  "77487": 11.44,
  "77488": -9.72,
  "77489": 11.44,
  "77491": 11.44,
  "77492": 11.44,
  "77493": 11.44,
  "77494": 11.44,
  "77496": 11.44,
  "77497": 11.44,
  "77498": 11.44,
  "77501": 7.15,
  "77502": 8.22,
  "77503": 7.15,
  "77504": 8.22,
  "77505": 7.15,
  "77506": 7.67,
  "77507": 1.63,
  "77508": 7.15,
  "77510": 1.63,
  "77511": 3.87,
  "77512": 3.87,
  "77514": 3.41,
  "77515": 3.87,
  "77516": 3.87,
  "77517": 1.11,
  "77518": 1.11,
  "77519": 2.95,
  "77520": 3.41,
  "77521": 3.93,
  "77522": 3.41,
  "77523": 3.41,
  "77530": 6.63,
  "77531": 3.87,
  "77532": 7.15,
  "77533": 2.95,
  "77534": 3.87,
  "77535": 3.47,
  "77536": 7.15,
  "77538": 3.41,
  "77539": 1.11,
  "77541": 4.91,
  "77542": 4.91,
  "77545": 11.44,
  "77546": 9.6,
  "77547": 7.67,
  "77549": 9.6,
  "77550": 2.15,
  "77551": 2.7,
  "77552": 2.7,
  "77553": 10.64,
  "77554": 10.64,
  "77560": 3.41,
  "77561": 2.95,
  "77562": 7.15,
  "77563": 1.11,
  "77564": 2.95,
  "77565": 9.6,
  "77566": 4.39,
  "77568": 1.11,
  "77571": 1.63,
  "77572": 1.63,
  "77573": 2.7,
  "77574": 2.7,
  "77575": 2.95,
  "77577": 3.87,
  "77578": 5.46,
  "77580": 3.41,
  "77581": 8.22,
  "77582": 2.95,
  "77583": 5.46,
  "77584": 8.22,
  "77585": 3.41,
  "77586": 3.22,
  "77587": 8.22,
  "77588": 8.22,
  "77590": 1.11,
  "77591": 1.11,
  "77592": 1.11,
  "77597": 3.41,
  "77598": 1.11,
  "77611": -0.27,
  "77612": 3.41,
  "77613": 5.31,
  "77614": -10.39,
  "77615": 3.41,
  "77616": -10.39,
  "77617": 4.45,
  "77619": 4.79,
  "77622": 5.31,
  "77623": 4.45,
  "77624": -6.65,
  "77625": 3.93,
  "77626": 0.25,
  "77627": 4.79,
  "77629": 5.31,
  "77630": -0.27,
  "77631": -0.27,
  "77632": 0.25,
  "77639": -0.27,
  "77640": 4.24,
  "77641": 4.24,
  "77642": 4.24,
  "77643": 4.24,
  "77650": 2.15,
  "77651": 6.38,
  "77655": 4.24,
  "77656": 3.93,
  "77657": 5,
  "77659": 5,
  "77660": -10.39,
  "77661": 3.93,
  "77662": 0.25,
  "77663": 12.42,
  "77664": -6.65,
  "77665": 3.93,
  "77670": 0.25,
  "77701": 4.79,
  "77702": 13.8,
  "77703": 4.79,
  "77704": 4.79,
  "77705": 4.79,
  "77706": 13.8,
  "77707": 5.31,
  "77708": 5.31,
  "77709": 5.31,
  "77710": 4.79,
  "77713": 5.31,
  "77720": 5.31,
  "77725": 4.79,
  "77726": 13.8,
  "77801": 1.44,
  "77802": 3.74,
  "77803": -5.27,
  "77805": 3.74,
  "77806": -5.27,
  "77807": -7.05,
  "77808": -5.27,
  "77830": -3.16,
  "77831": -12.36,
  "77833": -0.4,
  "77834": -0.4,
  "77835": -0.4,
  "77836": -1.07,
  "77837": -7.57,
  "77838": -1.07,
  "77840": -3.16,
  "77841": 5.33,
  "77842": -3.16,
  "77844": -3.16,
  "77845": 5.33,
  "77850": -1.53,
  "77852": -1.07,
  "77853": 9.72,
  "77855": -1.53,
  "77856": -7.05,
  "77857": -7.57,
  "77859": -7.57,
  "77861": -12.36,
  "77862": 3.74,
  "77863": 0,
  "77864": -14.47,
  "77865": -2.05,
  "77866": -3.68,
  "77867": -5.27,
  "77868": -3.16,
  "77870": -7.05,
  "77871": -12.36,
  "77872": -13.95,
  "77873": -5.27,
  "77875": -3.16,
  "77876": -3.16,
  "77878": 0.52,
  "77879": 0,
  "77880": -0.4,
  "77881": 5.33,
  "77882": 1.44,
  "77901": -1.53,
  "77902": -2.05,
  "77903": -2.05,
  "77904": -2.76,
  "77905": -0.15,
  "77950": -2.51,
  "77951": -4.35,
  "77954": -0.67,
  "77957": -4.35,
  "77960": -2.05,
  "77961": -4.35,
  "77962": -4.35,
  "77963": -2.05,
  "77964": 3.07,
  "77967": 2.55,
  "77968": -3.83,
  "77969": -4.35,
  "77970": -4.35,
  "77971": -4.35,
  "77973": -0.15,
  "77974": -0.15,
  "77975": 2.55,
  "77976": -2.76,
  "77977": -4.35,
  "77978": -2.51,
  "77979": -2.51,
  "77982": -2.51,
  "77983": -2.51,
  "77984": 3.07,
  "77986": 3.07,
  "77987": 2.55,
  "77988": -4.35,
  "77989": -0.67,
  "77990": -2.51,
  "77991": -4.35,
  "77993": -2.05,
  "77994": -0.67,
  "77995": 2.55,
  "78001": -0.61,
  "78002": 1.63,
  "78003": -12.63,
  "78004": 5.67,
  "78005": 1.63,
  "78006": 11.5,
  "78007": -0.61,
  "78008": -0.27,
  "78009": -1.59,
  "78010": -6.65,
  "78011": -0.27,
  "78012": -0.27,
  "78013": 3.01,
  "78014": 0.71,
  "78015": 3.53,
  "78016": -1.59,
  "78017": 0.19,
  "78019": -11.25,
  "78021": 0.19,
  "78022": -0.61,
  "78023": 2.15,
  "78024": -6.65,
  "78025": -6.65,
  "78026": 0.25,
  "78027": 5.67,
  "78028": -6.65,
  "78029": -6.65,
  "78039": -1.59,
  "78040": -10.73,
  "78041": -2.76,
  "78042": -10.73,
  "78043": -10.73,
  "78044": -10.73,
  "78045": -2.76,
  "78046": -10.73,
  "78050": 0.25,
  "78052": -1.59,
  "78054": 1.63,
  "78055": -6.65,
  "78056": -12.63,
  "78057": 1.63,
  "78058": -6.65,
  "78059": -1.59,
  "78060": -1.13,
  "78061": 0.71,
  "78062": -0.27,
  "78063": -12.63,
  "78064": 0.25,
  "78065": 1.63,
  "78066": -1.59,
  "78067": -12.11,
  "78069": 1.63,
  "78070": -1.44,
  "78071": -0.61,
  "78072": -0.61,
  "78073": 1.63,
  "78074": 3.53,
  "78075": -1.13,
  "78076": -12.11,
  "78101": -7.11,
  "78102": 1.23,
  "78104": 1.23,
  "78107": 0.71,
  "78108": -1.44,
  "78109": 1.63,
  "78111": 6.75,
  "78112": -7.11,
  "78113": 6.23,
  "78114": -7.11,
  "78115": -1.9,
  "78116": 6.75,
  "78117": 6.23,
  "78118": 6.23,
  "78119": 6.23,
  "78121": -6.04,
  "78122": -13.49,
  "78123": -1.9,
  "78124": -1.9,
  "78125": 0.71,
  "78130": -1.44,
  "78131": -1.44,
  "78132": -1.44,
  "78133": -1.44,
  "78140": -13.49,
  "78141": 6.23,
  "78142": 0.71,
  "78143": -6.59,
  "78144": 5.71,
  "78145": 6.75,
  "78146": 0.71,
  "78147": -7.11,
  "78148": 1.63,
  "78150": 1.63,
  "78151": 6.23,
  "78152": -2.97,
  "78154": -1.44,
  "78155": -2.45,
  "78156": -2.45,
  "78159": -13.49,
  "78160": -6.59,
  "78161": -6.59,
  "78162": 0.71,
  "78163": 5.98,
  "78164": -0.67,
  "78201": 1.63,
  "78202": 1.63,
  "78203": 1.63,
  "78204": 1.63,
  "78205": 3.22,
  "78206": 3.22,
  "78207": 1.11,
  "78208": 1.63,
  "78209": 2.15,
  "78210": 1.63,
  "78211": 1.63,
  "78212": 1.63,
  "78213": 1.63,
  "78214": 1.63,
  "78215": 1.63,
  "78216": 1.63,
  "78217": 1.63,
  "78218": 1.63,
  "78219": 1.63,
  "78220": 1.63,
  "78221": 1.63,
  "78222": 1.63,
  "78223": 1.63,
  "78224": 1.63,
  "78225": 1.63,
  "78226": 1.63,
  "78227": 1.63,
  "78228": 1.63,
  "78229": 1.63,
  "78230": 1.63,
  "78231": 1.63,
  "78232": 1.63,
  "78233": 1.63,
  "78234": 1.63,
  "78235": 1.63,
  "78236": 1.63,
  "78237": 1.63,
  "78238": 1.63,
  "78239": 1.63,
  "78240": 1.63,
  "78241": 1.63,
  "78242": 1.63,
  "78243": 1.63,
  "78244": 1.63,
  "78245": 1.63,
  "78246": 1.63,
  "78247": 1.63,
  "78248": 10.12,
  "78249": 1.63,
  "78250": 1.63,
  "78251": 1.63,
  "78252": 1.63,
  "78253": 1.63,
  "78254": 3.22,
  "78255": 11.5,
  "78256": 10.12,
  "78257": 12.42,
  "78258": 10.12,
  "78259": 2.15,
  "78260": -1.99,
  "78261": 5.98,
  "78262": 1.63,
  "78263": 1.63,
  "78264": 1.63,
  "78265": 1.63,
  "78266": 7.05,
  "78268": 1.63,
  "78269": 1.63,
  "78270": 1.63,
  "78278": 1.63,
  "78279": 1.63,
  "78280": 1.63,
  "78283": 1.63,
  "78284": 1.63,
  "78285": 1.11,
  "78286": 1.63,
  "78291": 3.22,
  "78292": 3.22,
  "78293": 3.22,
  "78294": 3.22,
  "78295": 3.22,
  "78296": 3.22,
  "78297": 3.22,
  "78298": 1.63,
  "78299": 3.22,
  "78330": -14.01,
  "78332": -14.01,
  "78333": -14.01,
  "78335": -11.25,
  "78336": -11.25,
  "78338": -7.88,
  "78339": -1.13,
  "78340": -11.25,
  "78341": -14.01,
  "78342": -14.01,
  "78343": -15.85,
  "78344": -11.25,
  "78347": 12.48,
  "78349": -14.01,
  "78350": -0.61,
  "78351": -15.85,
  "78352": -0.61,
  "78353": -11.77,
  "78355": -15.85,
  "78357": -14.01,
  "78358": -11.25,
  "78359": -1.13,
  "78360": -12.63,
  "78361": -12.63,
  "78362": -10.73,
  "78363": -15.33,
  "78364": -15.33,
  "78368": 0.71,
  "78369": -11.25,
  "78370": -0.61,
  "78371": -11.25,
  "78372": -13.49,
  "78373": -2.76,
  "78374": 7.36,
  "78375": -15.85,
  "78376": -13.49,
  "78377": -11.71,
  "78379": -15.85,
  "78380": 3.47,
  "78381": -10.73,
  "78382": -10.73,
  "78383": -0.61,
  "78384": -14.01,
  "78385": -15.85,
  "78387": -1.13,
  "78389": 0.71,
  "78390": -1.13,
  "78391": 1.23,
  "78393": -11.71,
  "78401": 3.47,
  "78402": 3.99,
  "78403": 3.47,
  "78404": 3.99,
  "78405": 3.47,
  "78406": 3.47,
  "78407": 3.47,
  "78408": 3.47,
  "78409": 3.47,
  "78410": 3.99,
  "78411": 3.99,
  "78412": 3.99,
  "78413": 12.48,
  "78414": 11.96,
  "78415": 3.99,
  "78416": 3.47,
  "78417": 3.47,
  "78418": 3.99,
  "78419": 3.99,
  "78426": 3.99,
  "78427": 3.47,
  "78460": 3.99,
  "78463": 3.99,
  "78465": 3.47,
  "78466": 3.99,
  "78467": 3.47,
  "78468": 3.99,
  "78469": 3.47,
  "78470": 3.47,
  "78471": 3.47,
  "78472": 12.48,
  "78473": 3.47,
  "78474": 3.47,
  "78475": 3.47,
  "78476": 3.47,
  "78477": 3.47,
  "78478": 3.47,
  "78480": 3.47,
  "78501": -10.73,
  "78502": -10.73,
  "78503": -11.25,
  "78504": -2.76,
  "78505": -10.73,
  "78516": -11.25,
  "78520": -11.77,
  "78521": -12.32,
  "78522": -11.77,
  "78523": -11.77,
  "78526": -12.32,
  "78535": -3.28,
  "78536": -3.89,
  "78537": -11.77,
  "78538": -12.32,
  "78539": -11.77,
  "78540": -11.77,
  "78541": -11.77,
  "78542": -11.77,
  "78543": -11.77,
  "78545": -4.41,
  "78547": -4.96,
  "78548": -4.96,
  "78549": -12.32,
  "78550": -3.28,
  "78551": -10.18,
  "78552": -10.18,
  "78553": -3.28,
  "78557": -10.73,
  "78558": -12.32,
  "78559": -11.77,
  "78560": -11.77,
  "78561": -11.77,
  "78562": -12.32,
  "78563": -11.77,
  "78564": -12.11,
  "78565": -11.77,
  "78566": -11.77,
  "78567": -12.32,
  "78568": -11.77,
  "78569": -11.77,
  "78570": -11.77,
  "78572": -11.25,
  "78573": -11.25,
  "78574": -11.25,
  "78575": -11.77,
  "78576": -11.77,
  "78577": -11.25,
  "78578": -11.77,
  "78579": -11.77,
  "78580": -11.77,
  "78582": -4.41,
  "78583": -11.77,
  "78584": -4.96,
  "78585": -4.41,
  "78586": -3.28,
  "78588": -3.89,
  "78589": -11.25,
  "78590": -11.77,
  "78591": -3.89,
  "78592": -11.77,
  "78593": -11.77,
  "78594": -11.77,
  "78595": -4.41,
  "78596": -11.77,
  "78597": -3.28,
  "78598": -11.77,
  "78599": -11.77,
  "78602": 18,
  "78604": -11.9,
  "78605": -2.91,
  "78606": 0.86,
  "78607": -8.89,
  "78608": -10.27,
  "78609": -8.89,
  "78610": -1.07,
  "78611": -2.91,
  "78612": 18,
  "78613": 4.66,
  "78614": -12.94,
  "78615": -0.4,
  "78616": -0.15,
  "78617": 12.02,
  "78618": -10.73,
  "78619": -1.07,
  "78620": 2.45,
  "78621": 18,
  "78622": -0.67,
  "78623": -1.99,
  "78624": -5.58,
  "78626": 4.66,
  "78627": 4.66,
  "78628": 4.66,
  "78629": -14.01,
  "78630": 4.66,
  "78631": -6.65,
  "78632": -0.15,
  "78633": 3.07,
  "78634": 4.66,
  "78635": 0.31,
  "78636": 1.9,
  "78638": -0.67,
  "78639": -7.3,
  "78640": -1.07,
  "78641": 4.66,
  "78642": 4.66,
  "78643": -8.89,
  "78644": -0.67,
  "78645": 12.02,
  "78646": 4.66,
  "78648": -0.67,
  "78650": 18,
  "78651": 12.02,
  "78652": 0.52,
  "78653": 12.02,
  "78654": -1.32,
  "78655": -0.15,
  "78656": -0.15,
  "78657": -1.32,
  "78658": -11.9,
  "78659": 9.72,
  "78660": 4.66,
  "78661": -0.67,
  "78662": 18,
  "78663": 1.9,
  "78664": 4.66,
  "78665": 4.66,
  "78666": -1.07,
  "78667": -1.07,
  "78669": 12.02,
  "78670": -0.67,
  "78671": 0.86,
  "78672": -8.89,
  "78673": 3.07,
  "78674": 4.66,
  "78675": -4.54,
  "78676": 7.42,
  "78677": -12.94,
  "78680": 4.66,
  "78681": 4.66,
  "78683": 4.66,
  "78691": 4.66,
  "78701": 12.57,
  "78702": 12.02,
  "78703": 22.81,
  "78704": 12.02,
  "78705": 12.02,
  "78708": 12.02,
  "78709": 12.57,
  "78710": 12.02,
  "78711": 12.57,
  "78712": 12.02,
  "78713": 12.02,
  "78714": 12.57,
  "78715": 12.02,
  "78716": 20.51,
  "78717": 5.21,
  "78718": 12.02,
  "78719": 12.02,
  "78720": 12.57,
  "78721": 12.02,
  "78722": 12.02,
  "78723": 12.02,
  "78724": 12.02,
  "78725": 12.02,
  "78726": 13.61,
  "78727": 12.02,
  "78728": 4.66,
  "78729": 12.02,
  "78730": 22.81,
  "78731": 20.51,
  "78732": 12.57,
  "78733": 20.51,
  "78734": 12.57,
  "78735": 12.57,
  "78736": 12.02,
  "78737": 12.02,
  "78738": 22.81,
  "78739": 12.57,
  "78741": 12.02,
  "78742": 12.02,
  "78744": 12.02,
  "78745": 12.02,
  "78746": 22.81,
  "78747": 12.02,
  "78748": 12.02,
  "78749": 12.02,
  "78750": 12.57,
  "78751": 12.02,
  "78752": 12.02,
  "78753": 12.02,
  "78754": 12.02,
  "78755": 20.51,
  "78756": 12.57,
  "78757": 12.02,
  "78758": 12.02,
  "78759": 12.57,
  "78760": 12.02,
  "78761": 12.02,
  "78762": 12.02,
  "78763": 22.81,
  "78764": 4.66,
  "78765": 12.02,
  "78766": 12.02,
  "78767": 12.57,
  "78768": 12.57,
  "78769": 12.57,
  "78799": 12.57,
  "78801": -14.47,
  "78802": -14.47,
  "78827": -1.13,
  "78828": -22.29,
  "78829": 0.19,
  "78830": -1.13,
  "78832": -14.47,
  "78833": -22.29,
  "78834": -1.13,
  "78836": -1.13,
  "78837": -14.99,
  "78838": -14.47,
  "78839": -1.13,
  "78840": -14.47,
  "78841": -14.47,
  "78842": -14.47,
  "78843": -14.47,
  "78850": -1.59,
  "78851": -5.79,
  "78852": -14.41,
  "78853": -14.41,
  "78860": -14.93,
  "78861": -1.59,
  "78870": -14.47,
  "78871": -14.99,
  "78872": -14.99,
  "78873": -22.29,
  "78877": -14.41,
  "78879": -22.29,
  "78880": -22.81,
  "78881": -14.47,
  "78883": -12.63,
  "78884": -12.63,
  "78885": -22.29,
  "78886": -1.59,
  "78931": 7.42,
  "78932": -0.4,
  "78933": 7.42,
  "78934": 8.34,
  "78935": 8.34,
  "78938": 11.1,
  "78940": 11.1,
  "78941": 8.99,
  "78942": 9.72,
  "78943": 8.34,
  "78944": -0.4,
  "78945": 11.1,
  "78946": 9.72,
  "78947": 9.72,
  "78948": 8.13,
  "78949": 11.1,
  "78950": 7.42,
  "78951": 9.51,
  "78952": 11.1,
  "78953": 16.41,
  "78954": 0.15,
  "78956": 9.51,
  "78957": 18,
  "78959": -14.01,
  "78960": 10.27,
  "78961": 0.15,
  "78962": 6.75,
  "78963": 11.1,
  "79001": 1.23,
  "79002": -8.49,
  "79003": -14.01,
  "79005": -8.49,
  "79007": -0.21,
  "79008": -0.21,
  "79009": -16.31,
  "79010": 1.23,
  "79011": -14.01,
  "79012": 6.04,
  "79013": -2.97,
  "79014": -13.49,
  "79015": -2.45,
  "79018": -0.15,
  "79019": -2.91,
  "79021": -7.11,
  "79022": -3.37,
  "79024": -8.49,
  "79025": 2.82,
  "79027": -17.17,
  "79029": -2.45,
  "79031": -7.57,
  "79032": -7.11,
  "79033": -8.49,
  "79034": -8.49,
  "79035": 1.23,
  "79036": -0.21,
  "79039": 3.07,
  "79040": -4.75,
  "79041": -7.11,
  "79042": -17.63,
  "79043": -17.69,
  "79044": -0.15,
  "79045": 0.71,
  "79046": -14.01,
  "79051": -4.08,
  "79052": -18.15,
  "79053": -16.31,
  "79054": -8.49,
  "79056": -14.01,
  "79057": -8.49,
  "79058": 0.71,
  "79059": -8.49,
  "79061": -13.49,
  "79062": -0.21,
  "79063": -17.17,
  "79064": -7.57,
  "79065": -8.49,
  "79066": -8.49,
  "79068": 3.07,
  "79070": -8.49,
  "79072": -7.11,
  "79073": -7.11,
  "79077": 0.25,
  "79078": -0.21,
  "79079": -14.01,
  "79080": -0.21,
  "79081": -5.27,
  "79082": -7.57,
  "79083": -0.21,
  "79084": -13.09,
  "79085": 0.71,
  "79086": -2.97,
  "79087": -3.89,
  "79088": -18.15,
  "79091": -2.45,
  "79092": 1.23,
  "79093": -8.49,
  "79094": -17.63,
  "79095": 0.25,
  "79096": -14.01,
  "79097": 3.07,
  "79098": -2.45,
  "79101": -5.73,
  "79102": -5.21,
  "79103": -5.21,
  "79104": -5.73,
  "79105": -2.45,
  "79106": -5.21,
  "79107": -5.73,
  "79108": -5.21,
  "79109": -3.62,
  "79110": -2.45,
  "79111": -5.21,
  "79114": -3.62,
  "79116": -5.21,
  "79117": -5.73,
  "79118": -2.45,
  "79119": 6.04,
  "79120": -5.73,
  "79121": 3.28,
  "79124": 3.28,
  "79159": 6.04,
  "79189": -5.21,
  "79201": 0.25,
  "79220": -0.21,
  "79221": -17.23,
  "79223": -0.73,
  "79225": -0.27,
  "79226": -16.31,
  "79227": -0.73,
  "79229": -0.21,
  "79230": 0.25,
  "79231": -17.23,
  "79233": -17.23,
  "79234": -17.23,
  "79235": -17.23,
  "79236": -0.21,
  "79237": -16.31,
  "79239": -16.31,
  "79240": -16.31,
  "79241": -17.23,
  "79243": -17.23,
  "79244": -17.23,
  "79245": -16.31,
  "79247": -16.83,
  "79248": -0.73,
  "79250": -7.11,
  "79251": -16.31,
  "79252": -0.27,
  "79255": -17.23,
  "79256": -17.23,
  "79257": -17.23,
  "79258": -17.23,
  "79259": 0.25,
  "79261": -17.23,
  "79311": -7.11,
  "79312": -7.57,
  "79313": -6.65,
  "79314": -6.65,
  "79316": -17.23,
  "79320": -16.31,
  "79322": -17.23,
  "79323": 4.85,
  "79324": -16.31,
  "79325": -16.31,
  "79326": -7.05,
  "79329": -2.45,
  "79330": -2.97,
  "79331": -7.11,
  "79336": -6.65,
  "79338": -6.65,
  "79339": -7.57,
  "79342": -17.23,
  "79343": -2.97,
  "79344": -16.31,
  "79345": -17.23,
  "79346": -6.65,
  "79347": -16.31,
  "79350": -2.97,
  "79351": -7.11,
  "79353": -6.13,
  "79355": 4.85,
  "79356": -2.97,
  "79357": -2.97,
  "79358": -6.65,
  "79359": -3.43,
  "79360": -3.43,
  "79363": -2.45,
  "79364": -2.97,
  "79366": -2.45,
  "79367": -6.65,
  "79369": -7.57,
  "79370": -11.71,
  "79371": -7.57,
  "79372": -6.65,
  "79373": -2.97,
  "79376": 4.85,
  "79377": -7.11,
  "79378": -17.23,
  "79379": -6.65,
  "79380": -6.65,
  "79381": -2.97,
  "79382": -2.97,
  "79383": -2.97,
  "79401": -2.97,
  "79402": -2.97,
  "79403": -2.97,
  "79404": -2.97,
  "79405": -2.97,
  "79406": -2.45,
  "79407": -2.45,
  "79408": -2.97,
  "79409": -2.97,
  "79410": -2.45,
  "79411": -2.97,
  "79412": -2.97,
  "79413": -2.45,
  "79414": -2.45,
  "79415": -2.97,
  "79416": -2.45,
  "79423": -2.45,
  "79424": -2.45,
  "79452": -2.97,
  "79453": -2.97,
  "79464": -2.45,
  "79490": -2.97,
  "79493": -2.45,
  "79499": -2.97,
  "79501": 2.49,
  "79502": -12.23,
  "79503": 2.49,
  "79504": 17.27,
  "79505": -11.77,
  "79506": 7.09,
  "79508": 1.78,
  "79510": 17.27,
  "79511": -1.59,
  "79512": -3.95,
  "79516": -3.43,
  "79517": -3.43,
  "79518": -12.23,
  "79519": -7.17,
  "79520": 2.49,
  "79521": -11.77,
  "79525": 3.01,
  "79526": -3.43,
  "79527": -2.91,
  "79528": -12.23,
  "79529": -11.77,
  "79530": -6.71,
  "79532": 1.57,
  "79533": 2.49,
  "79534": 2.49,
  "79535": 2.09,
  "79536": -6.71,
  "79537": 2.09,
  "79538": -7.17,
  "79539": -11.77,
  "79540": -12.23,
  "79541": -6.19,
  "79543": 1.57,
  "79544": -11.77,
  "79545": 1.57,
  "79546": -12.23,
  "79547": -11.77,
  "79548": -11.77,
  "79549": -3.95,
  "79550": -3.95,
  "79553": 2.49,
  "79556": 1.57,
  "79560": 2.49,
  "79561": 1.57,
  "79562": 1.78,
  "79563": -6.71,
  "79565": -1.59,
  "79566": 42.05,
  "79567": 42.05,
  "79601": -6.19,
  "79602": -6.19,
  "79603": -6.71,
  "79604": -6.71,
  "79605": -6.19,
  "79606": 1.78,
  "79607": -6.71,
  "79608": -6.19,
  "79701": 7.15,
  "79702": 7.15,
  "79703": 7.67,
  "79704": 7.67,
  "79705": 16.16,
  "79706": 7.15,
  "79707": 16.16,
  "79708": 16.16,
  "79710": 16.16,
  "79711": 7.15,
  "79712": 7.67,
  "79713": -6.59,
  "79714": 9.85,
  "79718": 15.28,
  "79719": 15.28,
  "79720": -6.59,
  "79721": -7.11,
  "79730": 8.84,
  "79731": 4.79,
  "79733": -1.59,
  "79734": -12.69,
  "79735": 13.99,
  "79738": -7.11,
  "79739": -1.07,
  "79740": 13.44,
  "79741": 4.33,
  "79742": 8.84,
  "79743": 4.24,
  "79744": 1.57,
  "79745": 9.39,
  "79748": -1.99,
  "79749": -1.99,
  "79752": 1.57,
  "79754": 15.28,
  "79755": 1.57,
  "79756": 9.39,
  "79758": 4.33,
  "79759": 3.78,
  "79760": 4.33,
  "79761": 4.33,
  "79762": 4.33,
  "79763": 4.33,
  "79764": 4.33,
  "79765": 4.33,
  "79766": 4.33,
  "79768": 4.33,
  "79769": 4.33,
  "79770": 15.28,
  "79772": 15.28,
  "79776": 4.33,
  "79777": 8.84,
  "79778": 1.57,
  "79780": 15.28,
  "79781": -7.17,
  "79782": -1.99,
  "79783": 6.5,
  "79785": 15.28,
  "79786": 15.28,
  "79788": 8.84,
  "79789": 9.39,
  "79821": -10.33,
  "79830": 2.95,
  "79831": 2.95,
  "79834": 2.95,
  "79835": -10.33,
  "79836": -10.33,
  "79837": -10.33,
  "79838": -10.33,
  "79839": -10.33,
  "79842": 2.95,
  "79843": -12.69,
  "79845": -13.24,
  "79846": -12.69,
  "79847": -10.33,
  "79848": -6.34,
  "79849": -10.33,
  "79851": -10.33,
  "79852": 2.95,
  "79853": -10.33,
  "79854": -12.17,
  "79855": 16.35,
  "79901": -10.33,
  "79902": -9.81,
  "79903": -10.33,
  "79904": -10.33,
  "79905": -10.33,
  "79906": -10.33,
  "79907": -10.33,
  "79908": -10.33,
  "79910": -10.33,
  "79911": -1.84,
  "79912": -1.84,
  "79913": -1.84,
  "79914": -9.81,
  "79915": -10.33,
  "79916": -10.33,
  "79917": -10.33,
  "79918": -10.33,
  "79920": -10.33,
  "79922": -1.84,
  "79923": -10.33,
  "79924": -9.81,
  "79925": -9.81,
  "79926": -10.33,
  "79927": -10.33,
  "79928": -10.33,
  "79929": -10.33,
  "79930": -10.33,
  "79931": -10.33,
  "79932": -9.81,
  "79934": -9.81,
  "79935": -9.81,
  "79936": -9.81,
  "79937": -9.81,
  "79938": -10.33,
  "79940": -10.33,
  "79941": -10.33,
  "79942": -10.33,
  "79943": -10.33,
  "79944": -10.33,
  "79945": -10.33,
  "79946": -10.33,
  "79947": -10.33,
  "79948": -10.33,
  "79949": -10.33,
  "79950": -10.33,
  "79951": -10.33,
  "79952": -10.33,
  "79953": -10.33,
  "79954": -10.33,
  "79955": -10.33,
  "79990": -10.33,
  "79995": -10.33,
  "79996": -10.33,
  "79997": -10.33,
  "79998": -10.33,
  "79999": -10.33,
  "80001": 6.13,
  "80002": 6.13,
  "80003": 6.13,
  "80004": 6.13,
  "80005": 6.65,
  "80006": 6.13,
  "80007": 8.95,
  "80010": 11.65,
  "80011": 9.35,
  "80012": 9.35,
  "80013": 9.35,
  "80014": 9.35,
  "80015": 9.87,
  "80016": 20.14,
  "80017": 9.35,
  "80018": 9.35,
  "80019": 7.51,
  "80020": 8.03,
  "80021": 6.65,
  "80022": 7.51,
  "80023": 8.03,
  "80024": 7.51,
  "80025": 6.19,
  "80026": 3.89,
  "80027": 3.89,
  "80030": 11.65,
  "80031": 7.51,
  "80033": 6.13,
  "80034": 6.13,
  "80035": 7.51,
  "80036": 7.51,
  "80037": 7.51,
  "80038": 8.03,
  "80040": 9.35,
  "80041": 9.35,
  "80042": 9.35,
  "80044": 9.35,
  "80045": 11.65,
  "80046": 9.87,
  "80047": 9.35,
  "80101": -1.23,
  "80102": 9.35,
  "80103": -1.23,
  "80104": 9.41,
  "80105": -1.23,
  "80106": 9.56,
  "80107": 9.41,
  "80108": 9.41,
  "80109": 9.41,
  "80110": 11.65,
  "80111": 20.14,
  "80112": 9.87,
  "80113": 11.65,
  "80116": 19.68,
  "80117": -0.71,
  "80118": 19.68,
  "80120": 11.65,
  "80121": 9.87,
  "80122": 9.87,
  "80123": 6.13,
  "80124": 12.78,
  "80125": 9.41,
  "80126": 9.41,
  "80127": 6.65,
  "80128": 6.65,
  "80129": 9.41,
  "80130": 12.78,
  "80131": 9.41,
  "80132": 9.56,
  "80133": 1.07,
  "80134": 9.41,
  "80135": 8.89,
  "80136": 9.35,
  "80137": 9.87,
  "80138": 9.41,
  "80150": 11.65,
  "80151": 11.65,
  "80155": 9.87,
  "80160": 11.65,
  "80161": 9.87,
  "80162": 6.65,
  "80163": 9.41,
  "80201": 6.13,
  "80202": 15.54,
  "80203": 11.65,
  "80204": 11.65,
  "80205": 11.65,
  "80206": 15.54,
  "80207": 11.65,
  "80209": 15.54,
  "80210": 12.17,
  "80211": 11.65,
  "80212": 11.65,
  "80214": 6.13,
  "80215": 6.65,
  "80216": 11.65,
  "80217": 15.54,
  "80218": 12.17,
  "80219": 11.65,
  "80220": 12.17,
  "80221": 11.65,
  "80222": 11.65,
  "80223": 11.65,
  "80224": 11.65,
  "80225": 6.13,
  "80226": 6.13,
  "80227": 6.13,
  "80228": 6.65,
  "80229": 7.51,
  "80230": 12.17,
  "80231": 9.35,
  "80232": 6.13,
  "80233": 7.51,
  "80234": 7.51,
  "80235": 6.13,
  "80236": 11.65,
  "80237": 9.87,
  "80238": 11.65,
  "80239": 7.51,
  "80241": 8.03,
  "80246": 11.65,
  "80247": 9.35,
  "80248": 15.54,
  "80249": 7.51,
  "80250": 12.17,
  "80260": 7.51,
  "80264": 11.65,
  "80265": 15.54,
  "80266": 15.54,
  "80290": 15.54,
  "80293": 15.54,
  "80294": 15.54,
  "80295": 15.54,
  "80299": 15.54,
  "80301": 3.89,
  "80302": 6.19,
  "80303": 6.19,
  "80304": 6.19,
  "80305": 6.19,
  "80306": 6.19,
  "80307": 6.19,
  "80308": -2.09,
  "80401": 6.65,
  "80402": 6.65,
  "80403": 8.95,
  "80420": -5.37,
  "80421": 0.15,
  "80422": -2.09,
  "80423": 5.21,
  "80424": 9.41,
  "80425": 8.89,
  "80426": 5.73,
  "80427": -2.09,
  "80428": 2.66,
  "80429": -5.37,
  "80430": 1.07,
  "80432": -0.31,
  "80433": 6.65,
  "80434": 1.07,
  "80435": 7.11,
  "80436": 0.15,
  "80437": 16.92,
  "80438": 0.15,
  "80439": 16.92,
  "80440": -0.31,
  "80442": -1.17,
  "80443": 9.41,
  "80444": 0.67,
  "80446": -1.17,
  "80447": -1.17,
  "80448": 0.15,
  "80449": -0.31,
  "80451": -1.69,
  "80452": 0.67,
  "80453": 6.65,
  "80454": 6.65,
  "80455": 3.89,
  "80456": -0.31,
  "80457": 6.13,
  "80459": -1.69,
  "80461": -5.37,
  "80463": 16.52,
  "80465": 6.65,
  "80466": -2.09,
  "80467": 1.07,
  "80468": -1.17,
  "80469": 1.07,
  "80470": 0.67,
  "80471": -2.09,
  "80473": -1.17,
  "80474": -2.09,
  "80475": 0.15,
  "80476": 0.15,
  "80477": 3.89,
  "80478": -1.17,
  "80479": 12.38,
  "80480": -1.69,
  "80481": 3.89,
  "80482": 0.21,
  "80483": 1.07,
  "80487": 3.89,
  "80488": 3.89,
  "80497": 7.11,
  "80498": -1.69,
  "80501": 3.37,
  "80502": 6.19,
  "80503": 3.89,
  "80504": 7.78,
  "80510": 3.89,
  "80511": 3.58,
  "80512": 1.99,
  "80513": 3.89,
  "80514": 3.37,
  "80515": 1.99,
  "80516": 3.89,
  "80517": 3.58,
  "80520": 3.37,
  "80521": 1.99,
  "80522": 1.99,
  "80524": 1.99,
  "80525": 1.99,
  "80526": 1.99,
  "80527": 1.99,
  "80528": 1.99,
  "80530": 3.37,
  "80532": 10.48,
  "80533": 3.89,
  "80534": 3.89,
  "80535": 1.99,
  "80536": 2.51,
  "80537": 1.99,
  "80538": 1.99,
  "80539": 1.99,
  "80540": 3.89,
  "80541": 10.48,
  "80542": 3.37,
  "80543": 4.04,
  "80544": 3.89,
  "80545": 1.99,
  "80546": 10.94,
  "80547": 1.99,
  "80549": 1.99,
  "80550": 10.94,
  "80601": 7.51,
  "80602": 8.03,
  "80603": 16,
  "80610": 2.45,
  "80611": 10.94,
  "80612": -0.92,
  "80614": 8.03,
  "80615": 10.94,
  "80620": 2.45,
  "80621": 7.51,
  "80622": 10.94,
  "80623": 2.45,
  "80624": 10.94,
  "80631": 2.45,
  "80632": 2.45,
  "80633": 2.45,
  "80634": 4.04,
  "80640": 8.03,
  "80642": 16,
  "80643": 10.94,
  "80644": 4.04,
  "80645": 4.04,
  "80646": 10.94,
  "80648": 2.45,
  "80649": 0.15,
  "80650": 2.45,
  "80651": 10.94,
  "80652": 0.15,
  "80653": 0.15,
  "80654": 0.15,
  "80701": 0.15,
  "80705": 0.15,
  "80720": 0.15,
  "80721": -13.65,
  "80722": -6.75,
  "80723": 0.15,
  "80726": -7.82,
  "80727": -3.16,
  "80728": -6.75,
  "80729": -0.92,
  "80731": -13.65,
  "80732": -0.92,
  "80733": 0.15,
  "80734": -13.65,
  "80735": -1.02,
  "80736": -6.75,
  "80737": -15.64,
  "80740": 0.15,
  "80741": -6.75,
  "80742": 0.15,
  "80743": -2.61,
  "80744": -15.12,
  "80745": -6.75,
  "80746": -13.65,
  "80747": -7.82,
  "80749": -15.12,
  "80750": 0.15,
  "80751": -6.75,
  "80754": -6.75,
  "80755": -3.16,
  "80757": 0.15,
  "80758": -2.61,
  "80759": -2.61,
  "80801": 0.15,
  "80802": -12.48,
  "80804": -11.44,
  "80805": -11.44,
  "80807": -11.44,
  "80808": -1.23,
  "80809": -10.43,
  "80810": -12.48,
  "80812": -10.89,
  "80813": -10.43,
  "80814": -10.43,
  "80815": -11.44,
  "80816": -10.43,
  "80817": 1.07,
  "80818": -1.78,
  "80819": -10.43,
  "80820": -1.69,
  "80821": -1.78,
  "80822": -10.89,
  "80823": 24.32,
  "80824": -10.89,
  "80825": -12.48,
  "80827": -0.31,
  "80828": -1.78,
  "80829": 1.07,
  "80830": -1.23,
  "80831": 1.07,
  "80832": -1.23,
  "80833": -1.23,
  "80834": -11.44,
  "80835": -1.23,
  "80836": -11.44,
  "80840": 9.56,
  "80841": 1.07,
  "80860": -10.98,
  "80861": -11.44,
  "80862": -10.89,
  "80863": -10.43,
  "80864": 1.07,
  "80866": -10.43,
  "80901": 1.07,
  "80902": 1.07,
  "80903": 1.07,
  "80904": 1.07,
  "80905": 1.07,
  "80906": 1.07,
  "80907": 1.07,
  "80908": 9.56,
  "80909": 1.07,
  "80910": 1.07,
  "80911": 1.07,
  "80912": 9.56,
  "80913": 1.07,
  "80914": 1.07,
  "80915": 1.07,
  "80916": 1.07,
  "80917": 1.07,
  "80918": 1.07,
  "80919": 1.07,
  "80920": 1.07,
  "80921": 9.56,
  "80922": 1.07,
  "80923": 1.07,
  "80924": 1.07,
  "80925": 1.07,
  "80926": 1.07,
  "80927": 1.07,
  "80928": 1.07,
  "80929": 1.07,
  "80930": 1.07,
  "80931": 1.07,
  "80932": 1.07,
  "80933": -10.43,
  "80934": 1.07,
  "80935": 1.07,
  "80936": 1.07,
  "80937": 1.07,
  "80938": 1.07,
  "80939": 1.07,
  "80949": 1.07,
  "80951": 1.07,
  "80960": 1.07,
  "80962": 1.07,
  "80970": 1.07,
  "81001": -3.28,
  "81002": -3.28,
  "81003": -3.28,
  "81004": -3.28,
  "81005": -3.28,
  "81006": -1.69,
  "81007": 5.21,
  "81008": -3.28,
  "81019": -5.37,
  "81020": -16.16,
  "81021": 24.32,
  "81022": -3.28,
  "81023": 5.21,
  "81024": -7.67,
  "81025": -3.28,
  "81027": -16.16,
  "81029": -13.49,
  "81030": -3.83,
  "81033": 23.77,
  "81036": -18.09,
  "81038": -3.28,
  "81039": 24.32,
  "81040": -13.86,
  "81041": -18.09,
  "81043": -18.09,
  "81044": -18.09,
  "81045": 24.32,
  "81046": -16.16,
  "81047": -18.09,
  "81049": -16.16,
  "81050": -3.28,
  "81052": -17.54,
  "81054": -3.28,
  "81055": -5.37,
  "81057": -17.54,
  "81058": 24.32,
  "81059": -16.16,
  "81062": 24.32,
  "81063": 24.32,
  "81064": -13.49,
  "81067": -3.28,
  "81069": -5.37,
  "81071": -18.09,
  "81073": -13.49,
  "81076": 24.32,
  "81077": -3.28,
  "81081": -16.16,
  "81082": -16.16,
  "81084": -12.94,
  "81087": -13.49,
  "81089": -13.86,
  "81090": -13.49,
  "81091": -13.86,
  "81092": -17.54,
  "81101": -8.34,
  "81120": -11.81,
  "81121": -4.39,
  "81122": -2.7,
  "81123": -8.89,
  "81124": -13.95,
  "81125": -16.16,
  "81126": -8.34,
  "81127": 6.4,
  "81128": -3.32,
  "81129": -11.81,
  "81130": -18.8,
  "81131": -11.1,
  "81132": -16.16,
  "81133": -8.34,
  "81135": -16.16,
  "81136": -8.34,
  "81137": -1.63,
  "81138": -13.4,
  "81140": -13.4,
  "81141": -11.81,
  "81143": -15.79,
  "81144": -16.16,
  "81146": -8.34,
  "81147": -4.39,
  "81148": -11.81,
  "81149": -15.24,
  "81151": -13.95,
  "81152": -13.4,
  "81154": -7.67,
  "81155": -13.65,
  "81157": -4.39,
  "81201": -1.69,
  "81210": 9.56,
  "81211": -1.69,
  "81212": -7.21,
  "81215": -7.21,
  "81220": 4.66,
  "81221": -8.8,
  "81222": -9.51,
  "81223": -7.21,
  "81224": 0.52,
  "81225": -1.78,
  "81226": -8.8,
  "81227": -1.69,
  "81228": -5.37,
  "81230": -1.69,
  "81232": -7.21,
  "81233": -1.69,
  "81235": -18.8,
  "81236": -1.69,
  "81237": -1.69,
  "81239": -1.69,
  "81240": -7.21,
  "81241": -1.69,
  "81242": -1.69,
  "81243": 0.52,
  "81244": -8.8,
  "81247": -2.24,
  "81248": -1.69,
  "81251": -5.37,
  "81252": -2.61,
  "81253": -2.61,
  "81301": -2.7,
  "81302": -2.7,
  "81303": -2.7,
  "81320": -5.46,
  "81321": -13.28,
  "81323": -13.28,
  "81324": -5.46,
  "81325": -5.46,
  "81326": -2.7,
  "81327": -13.28,
  "81328": -13.28,
  "81329": -2.7,
  "81330": -13.28,
  "81331": -13.28,
  "81332": 4.66,
  "81334": -13.8,
  "81335": -13.28,
  "81401": -5.92,
  "81402": -5.92,
  "81403": -5.92,
  "81410": -7.3,
  "81411": 4.66,
  "81413": -7.3,
  "81414": -7.3,
  "81415": -7.3,
  "81416": -7.3,
  "81418": -7.3,
  "81419": -7.3,
  "81420": -7.3,
  "81422": 4.66,
  "81423": 4.66,
  "81424": 4.66,
  "81425": -5.92,
  "81426": 6.96,
  "81427": 4.66,
  "81428": -7.3,
  "81429": 4.66,
  "81430": 15.45,
  "81431": 4.66,
  "81432": 4.66,
  "81433": -18.8,
  "81434": 12.42,
  "81435": 15.45,
  "81501": -3.62,
  "81502": -3.62,
  "81503": -3.62,
  "81504": -3.62,
  "81505": -3.62,
  "81506": -3.62,
  "81507": -3.62,
  "81520": -3.62,
  "81521": -3.62,
  "81522": -3.62,
  "81523": -3.62,
  "81524": -3.62,
  "81525": -3.62,
  "81526": -3.62,
  "81527": -3.62,
  "81601": 0.52,
  "81602": 0.52,
  "81610": 4.14,
  "81611": 23.73,
  "81612": 23.73,
  "81615": 23.73,
  "81620": 8.03,
  "81621": 16.83,
  "81623": 15.24,
  "81624": 0.52,
  "81625": -5.46,
  "81626": -5.46,
  "81630": -3.62,
  "81631": 8.03,
  "81632": 8.03,
  "81633": -5.46,
  "81635": 0.52,
  "81636": 0.52,
  "81637": 4.66,
  "81638": 2.82,
  "81639": 1.07,
  "81640": -5.46,
  "81641": 4.66,
  "81642": 24.8,
  "81643": -3.62,
  "81645": 9.41,
  "81646": -7.3,
  "81647": 0.52,
  "81648": 4.66,
  "81649": 9.41,
  "81650": 0.52,
  "81652": 0.52,
  "81653": -5.46,
  "81654": 23.73,
  "81655": 9.62,
  "81656": 12.94,
  "81657": 9.41,
  "81658": 8.03,
  "82001": -0.4,
  "82003": -0.4,
  "82005": -0.4,
  "82007": -0.92,
  "82009": -0.4,
  "82050": -0.92,
  "82051": -5,
  "82052": -5.52,
  "82053": -0.92,
  "82054": -0.4,
  "82055": -5,
  "82058": -6.59,
  "82059": -0.92,
  "82060": 7.57,
  "82061": -5,
  "82063": -3.93,
  "82070": -5,
  "82071": -5,
  "82072": -3.93,
  "82073": -5,
  "82081": -0.4,
  "82082": -0.92,
  "82083": -5.52,
  "82084": -5,
  "82190": 13.49,
  "82201": -9.2,
  "82210": -9.2,
  "82212": -12.42,
  "82213": -10.27,
  "82214": -9.2,
  "82215": -9.2,
  "82217": -12.42,
  "82218": -12.42,
  "82219": -12.42,
  "82221": -11.9,
  "82222": 12.27,
  "82223": -1.63,
  "82224": 14.41,
  "82225": -13.49,
  "82227": 12.27,
  "82229": 14.41,
  "82240": -12.42,
  "82242": -13.49,
  "82243": -1.63,
  "82244": -1.63,
  "82301": 2.15,
  "82310": -9.72,
  "82321": -4.91,
  "82322": 2.15,
  "82323": -4.91,
  "82324": 2.7,
  "82325": 4.29,
  "82327": 2.15,
  "82329": -5.52,
  "82331": 4.29,
  "82332": -4.91,
  "82334": 2.15,
  "82335": 2.7,
  "82336": -0.61,
  "82401": -5.12,
  "82410": -0.46,
  "82411": -0.46,
  "82412": -9.66,
  "82414": -9.66,
  "82420": -0.46,
  "82421": -9.66,
  "82422": -0.46,
  "82423": -12.48,
  "82426": -0.46,
  "82428": -4.6,
  "82430": -13.03,
  "82431": -0.46,
  "82432": -0.46,
  "82433": -9.66,
  "82434": -0.46,
  "82435": -9.66,
  "82440": -9.66,
  "82441": -0.46,
  "82442": -5.12,
  "82443": -12.48,
  "82450": -9.66,
  "82501": -9.72,
  "82510": -10.27,
  "82512": -9.72,
  "82513": 2.7,
  "82514": -10.27,
  "82515": -10.27,
  "82516": -9.72,
  "82520": -9.72,
  "82523": -9.72,
  "82524": -9.72,
  "82601": 3.16,
  "82602": 2.61,
  "82604": 2.61,
  "82605": 3.16,
  "82609": 3.16,
  "82615": 2.15,
  "82620": 3.16,
  "82630": -13.03,
  "82633": -10.27,
  "82635": 2.61,
  "82636": 3.16,
  "82637": 12.82,
  "82638": -13.03,
  "82639": -8.34,
  "82640": -8.89,
  "82642": -13.03,
  "82643": 2.61,
  "82644": 2.61,
  "82646": 3.16,
  "82648": 3.16,
  "82649": -10.27,
  "82701": -13.95,
  "82710": 5.12,
  "82711": -3.37,
  "82712": -5.92,
  "82714": 7.42,
  "82715": -3.37,
  "82716": 1.32,
  "82717": 1.32,
  "82718": 1.32,
  "82720": -3.37,
  "82721": -3.37,
  "82723": -3.37,
  "82725": 1.32,
  "82727": 1.32,
  "82729": -2.82,
  "82730": -3.37,
  "82731": -3.37,
  "82732": 1.32,
  "82801": -4.6,
  "82831": -5.12,
  "82832": -3.01,
  "82833": -3.01,
  "82834": -8.34,
  "82835": -4.6,
  "82836": -4.6,
  "82837": 5.67,
  "82838": -4.6,
  "82839": -4.6,
  "82840": -8.34,
  "82842": -4.6,
  "82844": 6.19,
  "82845": -4.6,
  "82901": 0.46,
  "82902": 0.46,
  "82922": 2.7,
  "82923": -6.04,
  "82925": -6.04,
  "82929": -7.88,
  "82930": -7.36,
  "82931": -7.36,
  "82932": 0.46,
  "82933": -7.36,
  "82934": -7.88,
  "82935": 0.46,
  "82936": -6.84,
  "82937": -7.36,
  "82938": -6.84,
  "82939": -7.36,
  "82941": -6.04,
  "82942": -0.61,
  "82943": -0.06,
  "82944": -7.36,
  "82945": -0.61,
  "83001": 6.59,
  "83002": 6.59,
  "83011": 13.49,
  "83012": 13.49,
  "83013": 13.49,
  "83014": 13.49,
  "83025": 13.49,
  "83101": -6.96,
  "83110": -15.7,
  "83111": -2.45,
  "83112": -1.9,
  "83113": -6.59,
  "83114": -6.44,
  "83115": -6.04,
  "83116": -6.96,
  "83118": -1.9,
  "83119": -15.7,
  "83120": -1.9,
  "83121": -6.96,
  "83122": -2.45,
  "83123": -6.96,
  "83124": -7.88,
  "83126": -6.96,
  "83127": -1.9,
  "83128": -1.9,
  "83201": -10.64,
  "83202": -10.64,
  "83203": -10.64,
  "83204": -10.64,
  "83205": -11.19,
  "83206": -10.64,
  "83210": -12.11,
  "83211": -12.11,
  "83212": -10.64,
  "83213": 8.13,
  "83214": -11.19,
  "83215": 8.13,
  "83217": -2.45,
  "83218": -10.27,
  "83220": -16.25,
  "83221": -10.27,
  "83223": -16.25,
  "83226": -17.42,
  "83227": -17.42,
  "83228": -8.34,
  "83229": 3.03,
  "83230": -2.45,
  "83232": -8.34,
  "83233": -16.25,
  "83234": -16.71,
  "83235": -7.76,
  "83236": -10.27,
  "83237": -7.82,
  "83238": -16.25,
  "83239": -16.25,
  "83241": -2.45,
  "83243": -16.71,
  "83244": 8.13,
  "83245": -10.64,
  "83246": -1.9,
  "83250": -10.64,
  "83251": -19.01,
  "83252": -16.16,
  "83253": -19.01,
  "83254": -16.25,
  "83255": 8.13,
  "83256": -10.27,
  "83261": -16.25,
  "83262": -9.72,
  "83263": -8.34,
  "83271": -12.11,
  "83272": -15.18,
  "83274": -7.05,
  "83276": -2.45,
  "83277": -10.27,
  "83278": -16.87,
  "83281": -8.34,
  "83283": -8.34,
  "83285": -2.45,
  "83286": -7.82,
  "83287": -15.18,
  "83301": -10.18,
  "83302": -9.14,
  "83303": -10.18,
  "83311": -8.34,
  "83312": -8.89,
  "83313": -5.12,
  "83314": -8.22,
  "83316": -9.14,
  "83318": -8.89,
  "83320": -5.12,
  "83321": -9.14,
  "83322": -5,
  "83323": -0.15,
  "83324": -4.29,
  "83325": -7.97,
  "83327": -5,
  "83328": -9.14,
  "83330": -8.22,
  "83332": -8.22,
  "83333": -3.53,
  "83334": -7.97,
  "83335": -7.97,
  "83336": -0.15,
  "83337": -5,
  "83338": -7.42,
  "83340": 6.71,
  "83341": -10.18,
  "83342": -8.89,
  "83343": -0.15,
  "83344": -7.97,
  "83346": -8.89,
  "83347": -0.15,
  "83348": 5.67,
  "83349": -4.29,
  "83350": -0.15,
  "83352": -4.29,
  "83353": -3.53,
  "83354": -3.53,
  "83355": -8.22,
  "83401": -7.05,
  "83402": -6.5,
  "83403": -6.5,
  "83404": -6.5,
  "83405": -6.5,
  "83406": -6.5,
  "83414": 13.49,
  "83420": -13.95,
  "83421": -13.95,
  "83422": -3.28,
  "83423": -10.27,
  "83424": -3.28,
  "83425": -10.27,
  "83427": -7.05,
  "83428": -3.28,
  "83429": -13.4,
  "83431": -10.27,
  "83433": -13.95,
  "83434": -10.27,
  "83435": -10.27,
  "83436": -11.56,
  "83438": -13.95,
  "83440": -11.56,
  "83442": -11.56,
  "83443": -7.05,
  "83444": -10.27,
  "83445": -13.95,
  "83446": -13.95,
  "83448": -11.56,
  "83449": -3.28,
  "83450": -10.27,
  "83451": -12.11,
  "83452": -3.28,
  "83454": -7.05,
  "83455": -3.28,
  "83462": -7.21,
  "83463": -7.76,
  "83464": -9.35,
  "83465": 0.73,
  "83466": -7.21,
  "83467": -7.76,
  "83468": -7.21,
  "83469": 3.03,
  "83501": -4.6,
  "83520": -14.32,
  "83522": -13.8,
  "83523": -14.32,
  "83524": -4.6,
  "83525": -13.74,
  "83526": -13.8,
  "83530": -13.74,
  "83531": -13.74,
  "83533": -13.8,
  "83535": -4.6,
  "83536": -13.28,
  "83537": -11.5,
  "83539": -13.74,
  "83540": -4.6,
  "83541": -4.6,
  "83542": -13.74,
  "83543": -14.32,
  "83544": -13.8,
  "83545": -13.8,
  "83546": -10.52,
  "83547": -10.52,
  "83548": -14.32,
  "83549": -10.52,
  "83552": -13.74,
  "83553": -10.52,
  "83554": -13.74,
  "83555": -13.8,
  "83601": -5.52,
  "83602": -10.98,
  "83604": -7.76,
  "83605": -7.36,
  "83606": -7.36,
  "83607": -7.88,
  "83610": -12.48,
  "83611": -7.3,
  "83612": -10.52,
  "83615": -7.3,
  "83616": 3.37,
  "83617": -11.04,
  "83619": -2.82,
  "83622": -10.98,
  "83623": -9.6,
  "83624": -7.76,
  "83626": -7.88,
  "83627": -9.6,
  "83628": -7.88,
  "83629": -10.52,
  "83630": -7.88,
  "83631": -10.98,
  "83632": -11.44,
  "83633": -8.22,
  "83634": 2.3,
  "83635": -6.75,
  "83636": -11.04,
  "83637": -10.98,
  "83638": -6.75,
  "83639": -7.88,
  "83641": -7.36,
  "83642": 2.82,
  "83643": -10.52,
  "83644": -7.36,
  "83645": -11.96,
  "83646": 2.82,
  "83647": -9.6,
  "83648": -9.6,
  "83650": -8.28,
  "83651": -7.88,
  "83652": -7.36,
  "83653": -7.88,
  "83654": -10.52,
  "83655": -2.82,
  "83656": -7.88,
  "83657": -10.52,
  "83660": -2.82,
  "83661": -2.82,
  "83666": -11.5,
  "83669": -7.36,
  "83670": -10.52,
  "83671": -11.04,
  "83672": -12.48,
  "83676": -7.88,
  "83677": -7.82,
  "83680": 2.82,
  "83686": -7.36,
  "83687": -7.88,
  "83701": 2.82,
  "83702": 2.82,
  "83703": 2.82,
  "83704": 2.82,
  "83705": 2.82,
  "83706": 2.82,
  "83707": 2.82,
  "83708": 2.82,
  "83709": 2.82,
  "83711": 2.82,
  "83712": 3.37,
  "83713": 2.82,
  "83714": 2.82,
  "83715": 2.82,
  "83716": 3.37,
  "83717": 2.82,
  "83719": 2.82,
  "83799": 2.82,
  "83801": -5.52,
  "83802": -2.36,
  "83803": -5.52,
  "83804": -5.52,
  "83805": -8.28,
  "83806": -12.02,
  "83808": -2.36,
  "83809": -8.74,
  "83810": -5.52,
  "83811": -8.74,
  "83812": -15.24,
  "83813": -8.74,
  "83814": -5.52,
  "83815": -5.52,
  "83816": -5.52,
  "83821": -0.25,
  "83822": -8.74,
  "83823": -11.5,
  "83824": -15.24,
  "83825": -0.25,
  "83826": -8.28,
  "83827": -11.56,
  "83830": -15.24,
  "83832": -4.6,
  "83833": 2.97,
  "83834": -11.5,
  "83835": -5.52,
  "83836": -0.25,
  "83837": -2.36,
  "83839": -2.36,
  "83840": -9.26,
  "83841": -8.74,
  "83842": -6.23,
  "83843": -11.5,
  "83845": -8.28,
  "83846": -2.36,
  "83847": -8.28,
  "83848": -8.28,
  "83849": -2.36,
  "83850": -2.36,
  "83851": -14.72,
  "83852": -9.26,
  "83853": -8.28,
  "83854": -5.52,
  "83855": -11.5,
  "83856": -8.74,
  "83857": -11.5,
  "83858": -5.52,
  "83860": -0.25,
  "83861": -14.72,
  "83864": -9.26,
  "83865": -8.74,
  "83866": -14.72,
  "83867": -2.36,
  "83868": -2.36,
  "83869": -5.52,
  "83870": -15.24,
  "83871": -11.5,
  "83872": -11.5,
  "83873": -2.36,
  "83874": -2.36,
  "83876": -3.93,
  "83877": -5.52,
  "84001": -6.29,
  "84002": -4.7,
  "84003": 0.21,
  "84004": 14.16,
  "84005": -2.61,
  "84006": 3.37,
  "84007": -6.29,
  "84008": -3.16,
  "84010": -2.15,
  "84011": -2.15,
  "84013": -2.61,
  "84014": -2.15,
  "84015": -1.78,
  "84016": -1.78,
  "84017": -0.77,
  "84018": -8.28,
  "84020": 3.89,
  "84021": -6.84,
  "84022": -8.13,
  "84023": -2.61,
  "84024": -0.77,
  "84025": -2.7,
  "84026": -3.16,
  "84027": -0.31,
  "84028": -13.34,
  "84029": 3.37,
  "84031": -6.29,
  "84032": -0.31,
  "84033": -7.21,
  "84034": -8.68,
  "84035": -3.16,
  "84036": -0.77,
  "84037": -2.7,
  "84038": -13.34,
  "84039": -3.16,
  "84040": -2.7,
  "84041": -2.7,
  "84042": -2.09,
  "84043": -0.31,
  "84044": 3.37,
  "84045": -2.61,
  "84046": -3.16,
  "84047": 3.37,
  "84049": 0.21,
  "84050": -7.76,
  "84051": -6.29,
  "84052": -6.29,
  "84053": -6.29,
  "84054": -2.15,
  "84055": -0.25,
  "84056": -1.78,
  "84057": -2.61,
  "84058": -2.61,
  "84059": -2.61,
  "84060": 10.48,
  "84061": -0.25,
  "84062": -2.61,
  "84063": -3.68,
  "84064": -13.86,
  "84065": 3.89,
  "84066": -6.29,
  "84067": -1.78,
  "84068": 10.02,
  "84069": -8.13,
  "84070": 3.37,
  "84071": -8.13,
  "84072": -6.29,
  "84073": -6.84,
  "84074": 3.37,
  "84075": -2.7,
  "84076": -3.16,
  "84078": -3.16,
  "84079": -3.16,
  "84080": -9.97,
  "84081": 3.37,
  "84082": -0.31,
  "84083": -9.2,
  "84084": 3.37,
  "84085": -3.16,
  "84086": -13.34,
  "84087": -2.15,
  "84088": 3.37,
  "84089": -1.78,
  "84090": 3.37,
  "84091": 3.37,
  "84092": 3.89,
  "84093": 3.37,
  "84094": 3.37,
  "84095": 3.89,
  "84096": 3.89,
  "84097": -2.61,
  "84098": 10.02,
  "84101": 2.82,
  "84102": 3.37,
  "84103": 3.89,
  "84104": 3.37,
  "84105": 3.37,
  "84106": 3.37,
  "84107": 3.37,
  "84108": 3.89,
  "84109": 3.37,
  "84110": 2.82,
  "84111": 3.37,
  "84112": 3.37,
  "84113": 3.37,
  "84114": 3.89,
  "84115": 3.37,
  "84116": 3.37,
  "84117": 3.37,
  "84118": 3.37,
  "84119": 3.37,
  "84120": 3.37,
  "84121": 3.37,
  "84122": 3.37,
  "84123": 3.37,
  "84124": 3.37,
  "84125": 3.37,
  "84126": 3.37,
  "84127": 3.37,
  "84128": 3.37,
  "84130": 3.37,
  "84131": 3.37,
  "84133": 3.89,
  "84138": 3.37,
  "84144": 2.82,
  "84145": 2.82,
  "84147": 3.37,
  "84151": 3.37,
  "84152": 3.37,
  "84157": 3.37,
  "84158": 3.89,
  "84165": 3.37,
  "84170": 3.37,
  "84171": 3.37,
  "84180": 2.82,
  "84301": -8.28,
  "84302": -2.3,
  "84304": -8.28,
  "84305": -8.28,
  "84306": 2.51,
  "84307": -2.3,
  "84308": -8.28,
  "84309": -8.28,
  "84310": -0.71,
  "84311": -8.28,
  "84312": -8.28,
  "84313": -1.78,
  "84314": -8.28,
  "84315": -1.78,
  "84316": -2.3,
  "84317": -0.71,
  "84318": -8.28,
  "84319": -8.28,
  "84320": -8.28,
  "84321": -8.28,
  "84323": -8.28,
  "84324": -2.3,
  "84325": -7.76,
  "84326": -8.28,
  "84327": -8.28,
  "84328": -7.76,
  "84329": -2.82,
  "84330": -8.28,
  "84331": -8.28,
  "84332": -8.28,
  "84333": -8.28,
  "84334": -8.28,
  "84335": -8.28,
  "84336": -2.3,
  "84337": -2.3,
  "84338": -8.28,
  "84339": -8.28,
  "84340": -2.3,
  "84341": -8.28,
  "84401": -2.3,
  "84402": -2.3,
  "84403": -2.3,
  "84404": -2.3,
  "84405": -2.3,
  "84409": -2.3,
  "84412": -2.3,
  "84414": -2.3,
  "84415": -2.3,
  "84501": -7.3,
  "84510": -14.72,
  "84511": -14.2,
  "84512": -14.72,
  "84513": -6.75,
  "84515": -10.58,
  "84516": -6.75,
  "84518": -6.75,
  "84520": -6.84,
  "84521": -6.75,
  "84522": -7.3,
  "84523": -6.75,
  "84525": -7.82,
  "84526": -6.84,
  "84528": -7.3,
  "84529": -6.84,
  "84530": -10.06,
  "84531": -14.72,
  "84532": -10.06,
  "84533": -7.76,
  "84534": -14.72,
  "84535": -14.2,
  "84536": -13.65,
  "84537": -6.75,
  "84539": -6.84,
  "84540": -10.58,
  "84542": -6.29,
  "84601": -2.61,
  "84602": -2.61,
  "84603": -2.61,
  "84604": 5.88,
  "84605": -2.61,
  "84606": -2.61,
  "84620": -16.41,
  "84621": -10.43,
  "84622": -10.43,
  "84623": -10.43,
  "84624": -3.99,
  "84626": -2.61,
  "84627": -10.43,
  "84628": -2.61,
  "84629": -10.43,
  "84630": -10.43,
  "84631": -16.41,
  "84632": -10.43,
  "84633": -2.61,
  "84634": -10.43,
  "84635": -4.54,
  "84636": -16.96,
  "84637": -3.99,
  "84638": -9.97,
  "84639": -10.43,
  "84640": -9.97,
  "84642": -10.43,
  "84643": -10.43,
  "84644": -3.99,
  "84645": -1.02,
  "84646": -10.43,
  "84647": -10.43,
  "84648": -9.97,
  "84649": -9.97,
  "84651": -1.02,
  "84652": -10.43,
  "84653": 5.88,
  "84654": -16.41,
  "84655": -1.02,
  "84656": -10.43,
  "84657": -16.41,
  "84660": -1.02,
  "84662": -10.43,
  "84663": 5.88,
  "84664": 5.88,
  "84665": -10.43,
  "84667": -10.43,
  "84701": -16.41,
  "84710": -14.11,
  "84711": -16.41,
  "84712": -7.21,
  "84713": -10.89,
  "84714": -8.22,
  "84715": -7.21,
  "84716": -7.76,
  "84718": -7.21,
  "84719": -7.67,
  "84720": -7.67,
  "84721": -7.67,
  "84722": -8.59,
  "84723": -7.21,
  "84724": -16.41,
  "84725": -9.14,
  "84726": -7.21,
  "84728": -4.54,
  "84729": -14.11,
  "84730": -16.41,
  "84731": -10.89,
  "84732": -7.76,
  "84733": -8.59,
  "84734": -7.76,
  "84735": -14.11,
  "84736": -7.21,
  "84737": -9.14,
  "84738": -8.59,
  "84739": -16.41,
  "84740": -7.76,
  "84741": -14.11,
  "84742": -8.59,
  "84743": -7.76,
  "84744": -16.41,
  "84745": -9.14,
  "84746": -8.59,
  "84747": -7.21,
  "84749": -7.21,
  "84750": -16.41,
  "84751": -11.44,
  "84752": -10.89,
  "84753": -8.22,
  "84754": -16.41,
  "84755": -14.66,
  "84756": -8.22,
  "84757": -8.59,
  "84758": -14.66,
  "84759": -7.21,
  "84760": -7.67,
  "84761": -7.67,
  "84762": -14.11,
  "84763": -8.59,
  "84764": -7.21,
  "84765": -8.59,
  "84766": -16.41,
  "84767": -8.59,
  "84770": -8.59,
  "84771": -8.59,
  "84772": -8.22,
  "84773": 1.28,
  "84774": -8.59,
  "84775": 1.28,
  "84776": -7.21,
  "84779": -8.59,
  "84780": -8.59,
  "84781": -8.59,
  "84782": -8.59,
  "84783": -8.59,
  "84784": -8.59,
  "84790": -8.59,
  "84791": -8.59,
  "85001": 5.52,
  "85002": 5.52,
  "85003": 14.01,
  "85004": 5.52,
  "85005": 5.52,
  "85006": 5.52,
  "85007": 5.52,
  "85008": 5.52,
  "85009": 5.52,
  "85010": 5.52,
  "85011": 5.52,
  "85012": 5.52,
  "85013": 5.52,
  "85014": 5.52,
  "85015": 5.52,
  "85016": 6.04,
  "85017": 5.52,
  "85018": 14.01,
  "85019": 5.52,
  "85020": 6.04,
  "85021": 5.52,
  "85022": 6.04,
  "85023": 5.52,
  "85024": 6.04,
  "85025": 5.52,
  "85026": 5.52,
  "85027": 7.11,
  "85028": 14.01,
  "85029": 5.52,
  "85030": 14.01,
  "85031": 5.52,
  "85032": 6.59,
  "85033": 5.52,
  "85034": 6.04,
  "85035": 5.52,
  "85036": 5.52,
  "85037": 5.52,
  "85038": 5.52,
  "85039": 5.52,
  "85040": 6.04,
  "85041": 5.52,
  "85042": 6.04,
  "85043": 5.52,
  "85044": 6.59,
  "85045": 14.53,
  "85046": 6.59,
  "85048": 7.63,
  "85050": 6.59,
  "85051": 5.52,
  "85053": 5.52,
  "85054": 7.11,
  "85055": 5.52,
  "85060": 14.01,
  "85061": 5.52,
  "85062": 5.52,
  "85063": 5.52,
  "85064": 6.04,
  "85065": 6.04,
  "85066": 6.04,
  "85067": 5.52,
  "85068": 6.04,
  "85069": 5.52,
  "85070": 7.63,
  "85071": 5.52,
  "85072": 5.52,
  "85073": 5.52,
  "85074": 5.52,
  "85075": 5.52,
  "85076": 6.59,
  "85078": 6.59,
  "85079": 5.52,
  "85080": 5.52,
  "85082": 5.52,
  "85083": 5.52,
  "85085": 7.11,
  "85086": 7.11,
  "85087": 6.59,
  "85117": -0.86,
  "85118": -0.86,
  "85119": -0.86,
  "85120": -0.86,
  "85121": -0.86,
  "85122": -0.86,
  "85123": -0.86,
  "85127": -0.86,
  "85128": -0.86,
  "85130": -1.38,
  "85131": -1.38,
  "85132": -1.38,
  "85135": -1.9,
  "85137": -1.38,
  "85138": -0.86,
  "85139": -0.86,
  "85140": -0.86,
  "85141": -1.9,
  "85142": -0.86,
  "85143": -0.86,
  "85145": -1.9,
  "85147": -1.38,
  "85172": -0.86,
  "85173": -8.74,
  "85178": -0.86,
  "85190": -0.86,
  "85191": -0.86,
  "85192": -0.86,
  "85193": -13.8,
  "85194": -1.38,
  "85201": 6.04,
  "85202": 6.04,
  "85203": 6.04,
  "85204": 6.04,
  "85205": 6.04,
  "85206": 6.04,
  "85207": 6.04,
  "85208": 6.04,
  "85209": 6.04,
  "85210": 6.04,
  "85211": 6.04,
  "85212": 6.04,
  "85213": 6.04,
  "85214": 6.04,
  "85215": 6.04,
  "85216": 6.04,
  "85217": -0.86,
  "85218": -0.86,
  "85219": -0.86,
  "85220": 5.52,
  "85221": -0.86,
  "85222": -1.38,
  "85223": -1.38,
  "85224": 6.59,
  "85225": 6.04,
  "85226": 6.59,
  "85227": -0.86,
  "85228": -1.38,
  "85230": -1.38,
  "85231": -1.38,
  "85232": -1.38,
  "85233": 6.04,
  "85234": 6.04,
  "85235": -1.9,
  "85236": 6.04,
  "85237": -1.38,
  "85238": -0.86,
  "85239": 6.04,
  "85240": -0.86,
  "85241": -1.9,
  "85242": -0.86,
  "85243": -0.86,
  "85244": 6.04,
  "85245": -1.9,
  "85246": 6.59,
  "85247": -1.38,
  "85248": 6.59,
  "85249": 6.04,
  "85250": 6.59,
  "85251": 6.59,
  "85252": 6.59,
  "85253": 17.9,
  "85254": 7.11,
  "85255": 9.41,
  "85256": 5.52,
  "85257": 6.04,
  "85258": 7.11,
  "85259": 9.41,
  "85260": 7.11,
  "85261": 6.59,
  "85262": 11,
  "85263": 9.41,
  "85264": 6.59,
  "85266": 6.59,
  "85267": 7.11,
  "85268": 7.11,
  "85269": 7.11,
  "85271": 6.04,
  "85272": -0.86,
  "85273": -8.74,
  "85274": 6.04,
  "85275": 6.04,
  "85277": 6.04,
  "85278": 5.52,
  "85280": 6.04,
  "85281": 6.04,
  "85282": 6.04,
  "85283": 6.59,
  "85284": 14.53,
  "85285": 6.04,
  "85286": 6.59,
  "85290": 9.41,
  "85291": -1.38,
  "85292": -1.9,
  "85293": -0.86,
  "85294": -1.38,
  "85295": 6.04,
  "85296": 6.04,
  "85297": 6.04,
  "85298": 6.04,
  "85299": 6.04,
  "85301": 5.52,
  "85302": 5.52,
  "85303": 5.52,
  "85304": 5.52,
  "85305": 5.52,
  "85306": 5.52,
  "85307": 5.52,
  "85308": 6.04,
  "85309": 7.11,
  "85310": 7.11,
  "85311": 5.52,
  "85312": 5.52,
  "85318": 6.04,
  "85320": 6.9,
  "85321": -0.86,
  "85322": 5.52,
  "85323": 6.04,
  "85324": -5.37,
  "85325": 5.83,
  "85326": 5.52,
  "85327": 7.11,
  "85328": 5.31,
  "85329": 5.52,
  "85331": 7.11,
  "85332": -6.44,
  "85333": -12.63,
  "85334": 5.31,
  "85335": 5.52,
  "85336": -12.11,
  "85337": 5.52,
  "85338": 7.11,
  "85339": 6.04,
  "85340": 7.11,
  "85341": -0.86,
  "85342": 5.52,
  "85343": 5.52,
  "85344": 5.83,
  "85345": 5.52,
  "85346": 5.31,
  "85347": -12.11,
  "85348": 6.9,
  "85349": -12.11,
  "85350": -12.11,
  "85351": 5.52,
  "85352": -12.11,
  "85353": 5.52,
  "85354": 5.52,
  "85355": 14.01,
  "85356": -12.11,
  "85357": 6.9,
  "85358": 6.04,
  "85359": 5.31,
  "85360": -6.29,
  "85361": 5.52,
  "85362": -6.44,
  "85363": 5.52,
  "85364": -12.11,
  "85365": -12.11,
  "85366": -12.11,
  "85367": -12.11,
  "85369": -12.11,
  "85371": 5.83,
  "85372": 5.52,
  "85373": 6.04,
  "85374": 6.04,
  "85375": 6.04,
  "85376": 6.04,
  "85377": 11,
  "85378": 6.04,
  "85379": 5.52,
  "85380": 6.04,
  "85381": 6.04,
  "85382": 5.52,
  "85383": 6.04,
  "85385": 5.52,
  "85387": 6.04,
  "85388": 5.52,
  "85390": 6.04,
  "85392": 5.52,
  "85395": 7.11,
  "85396": 7.11,
  "85501": -8.74,
  "85502": -8.74,
  "85530": -9.72,
  "85531": -9.2,
  "85532": -8.74,
  "85533": -2.36,
  "85534": -2.36,
  "85535": -9.72,
  "85536": -9.2,
  "85539": -8.74,
  "85540": -2.36,
  "85541": -7.67,
  "85542": -8.74,
  "85543": -9.72,
  "85544": -6.08,
  "85545": -8.74,
  "85546": -9.72,
  "85547": -7.67,
  "85548": -9.72,
  "85550": -8.74,
  "85551": -9.72,
  "85552": -9.72,
  "85553": -7.67,
  "85554": -7.67,
  "85601": -7.42,
  "85602": -6.96,
  "85603": -6.96,
  "85605": -9.72,
  "85606": -6.96,
  "85607": -6.96,
  "85608": -6.96,
  "85609": -6.96,
  "85610": -6.96,
  "85611": -6.9,
  "85613": -6.96,
  "85614": -3.68,
  "85615": -6.44,
  "85616": -6.96,
  "85617": -6.96,
  "85618": -4.2,
  "85619": 7.11,
  "85620": -6.96,
  "85621": -7.42,
  "85622": -3.68,
  "85623": -3.68,
  "85624": -6.9,
  "85625": -6.96,
  "85626": -6.96,
  "85627": -4.85,
  "85628": -7.42,
  "85629": -3.68,
  "85630": -6.96,
  "85631": -4.2,
  "85632": -6.96,
  "85633": -6.9,
  "85634": -4.2,
  "85635": -6.96,
  "85636": -6.44,
  "85637": 1.59,
  "85638": -6.96,
  "85639": -4.2,
  "85640": -7.42,
  "85641": -3.68,
  "85643": -9.72,
  "85644": -9.72,
  "85645": -7.42,
  "85646": -6.9,
  "85648": -6.9,
  "85650": -6.44,
  "85652": -3.68,
  "85653": -3.68,
  "85654": -3.68,
  "85655": -6.96,
  "85658": -3.68,
  "85662": -7.42,
  "85670": -6.96,
  "85671": -6.96,
  "85701": -3.68,
  "85702": -3.68,
  "85703": -4.2,
  "85704": -3.68,
  "85705": -4.2,
  "85706": -4.2,
  "85707": -4.2,
  "85708": -4.2,
  "85710": -3.68,
  "85711": -3.68,
  "85712": -3.68,
  "85713": -3.68,
  "85714": -4.2,
  "85715": 4.81,
  "85716": -3.68,
  "85717": -3.68,
  "85718": 4.81,
  "85719": -3.68,
  "85720": -4.2,
  "85722": -3.68,
  "85725": -4.2,
  "85726": -3.68,
  "85728": 4.81,
  "85730": -3.68,
  "85731": -3.68,
  "85732": -3.68,
  "85733": -3.68,
  "85734": -4.2,
  "85735": -7.42,
  "85736": -6.9,
  "85737": -2.61,
  "85738": -3.68,
  "85739": 4.81,
  "85740": -3.68,
  "85741": -3.68,
  "85742": -3.68,
  "85743": -3.68,
  "85745": -3.68,
  "85746": -3.68,
  "85747": -3.68,
  "85748": -3.68,
  "85749": 4.81,
  "85750": 4.81,
  "85751": -3.68,
  "85752": -3.68,
  "85754": -3.68,
  "85755": -2.61,
  "85756": -3.68,
  "85757": -3.68,
  "85901": -7.67,
  "85902": -7.67,
  "85911": -8.74,
  "85912": -7.67,
  "85920": -1.32,
  "85922": -1.32,
  "85923": -7.67,
  "85924": -9.05,
  "85925": -1.84,
  "85926": -8.74,
  "85927": -1.84,
  "85928": -7.67,
  "85929": -8.22,
  "85930": -1.84,
  "85931": -3.78,
  "85932": -1.32,
  "85933": -7.67,
  "85934": -7.67,
  "85935": -8.22,
  "85936": -12.27,
  "85937": -9.05,
  "85938": -1.84,
  "85939": -9.05,
  "85940": -7.67,
  "85941": -8.74,
  "85942": -9.05,
  "86001": -4.7,
  "86002": -6.29,
  "86003": -6.29,
  "86004": -6.29,
  "86015": -4.7,
  "86016": -6.84,
  "86017": -5.37,
  "86018": -6.29,
  "86020": -6.84,
  "86021": -0.86,
  "86022": -6.29,
  "86023": -6.29,
  "86024": -5.37,
  "86025": -9.05,
  "86028": -9.05,
  "86029": -9.05,
  "86030": -9.05,
  "86031": -9.05,
  "86032": -9.05,
  "86033": -12.27,
  "86034": -9.05,
  "86035": -6.29,
  "86036": -6.29,
  "86038": -5.37,
  "86039": -9.05,
  "86040": -6.29,
  "86042": -9.05,
  "86043": -9.05,
  "86044": -6.29,
  "86045": -6.29,
  "86046": -6.29,
  "86047": -9.05,
  "86052": -6.29,
  "86053": -6.29,
  "86054": -6.29,
  "86301": -5.37,
  "86302": -5.37,
  "86303": 3.12,
  "86304": -5.37,
  "86305": 3.12,
  "86312": -5.37,
  "86313": 3.12,
  "86314": -5.37,
  "86315": 3.12,
  "86320": -5.37,
  "86321": -6.44,
  "86322": -5.37,
  "86323": -5.37,
  "86324": -5.37,
  "86325": -5.37,
  "86326": -5.37,
  "86327": -5.37,
  "86329": -5.37,
  "86330": -5.37,
  "86331": -5.37,
  "86332": -6.44,
  "86333": -5.37,
  "86334": -5.37,
  "86335": -5.37,
  "86336": 3.12,
  "86337": -6.29,
  "86338": 3.12,
  "86339": 3.12,
  "86340": 3.12,
  "86341": 3.12,
  "86342": -5.37,
  "86343": -6.44,
  "86351": 3.12,
  "86401": -6.84,
  "86402": -6.84,
  "86403": 5.83,
  "86404": 7.42,
  "86405": 5.83,
  "86406": 7.42,
  "86409": -6.84,
  "86411": -6.84,
  "86412": -6.84,
  "86413": -6.84,
  "86426": -6.84,
  "86427": -6.84,
  "86429": -6.29,
  "86430": -6.84,
  "86431": -6.84,
  "86432": -0.86,
  "86433": -6.84,
  "86434": -6.84,
  "86435": -6.29,
  "86436": -6.84,
  "86437": -6.84,
  "86438": -6.84,
  "86439": -6.29,
  "86440": -6.84,
  "86441": -6.84,
  "86442": -6.84,
  "86443": -6.84,
  "86444": -6.84,
  "86445": -6.84,
  "86446": -6.84,
  "86502": -12.27,
  "86503": -12.27,
  "86504": -12.82,
  "86505": -12.82,
  "86506": -12.27,
  "86507": -12.82,
  "86508": -12.82,
  "86510": -9.05,
  "86511": -12.82,
  "86512": -12.27,
  "86514": -13.8,
  "86515": -12.82,
  "86520": -12.27,
  "86535": -12.27,
  "86538": -12.82,
  "86540": -12.82,
  "86544": -13.8,
  "86545": -12.82,
  "86547": -12.27,
  "86556": -12.82,
  "87001": 0.15,
  "87002": 1.44,
  "87004": -0.4,
  "87005": -8.68,
  "87006": 1.44,
  "87007": -8.68,
  "87008": 8.09,
  "87009": -9.14,
  "87010": -6.69,
  "87011": -15.58,
  "87012": 0.15,
  "87013": 2.36,
  "87014": -8.68,
  "87015": 0.15,
  "87016": -9.14,
  "87017": 0.15,
  "87018": 0.15,
  "87020": -8.68,
  "87021": -8.68,
  "87022": 1.44,
  "87023": 1.44,
  "87024": 2.36,
  "87025": 2.36,
  "87026": 1.44,
  "87027": 0.15,
  "87028": -13.74,
  "87029": 0.15,
  "87031": 1.44,
  "87032": -9.14,
  "87034": -8.68,
  "87035": -9.14,
  "87036": -9.14,
  "87037": 2.36,
  "87038": -8.68,
  "87040": 1.44,
  "87041": 17.69,
  "87042": 1.99,
  "87043": 8.09,
  "87044": 3.43,
  "87045": -8.68,
  "87046": 0.15,
  "87047": 0.15,
  "87048": 8.09,
  "87049": -8.68,
  "87051": -8.68,
  "87052": -7.21,
  "87053": 2.36,
  "87056": -6.69,
  "87059": 1.19,
  "87060": 9.93,
  "87061": -9.14,
  "87062": 1.44,
  "87063": -9.14,
  "87064": 17.17,
  "87068": 1.44,
  "87070": -9.14,
  "87072": 17.17,
  "87083": 17.69,
  "87101": 0.15,
  "87102": -0.4,
  "87103": 8.09,
  "87104": 0.15,
  "87105": 0.15,
  "87106": 0.15,
  "87107": 0.15,
  "87108": 0.15,
  "87109": 0.15,
  "87110": 0.15,
  "87111": 1.19,
  "87112": 0.15,
  "87113": 0.15,
  "87114": 0.15,
  "87115": 0.15,
  "87116": 0.15,
  "87119": 0.15,
  "87120": 0.15,
  "87121": -0.4,
  "87122": 8.09,
  "87123": 0.15,
  "87124": 0.15,
  "87125": -0.4,
  "87144": 8.09,
  "87153": 0.15,
  "87154": 1.19,
  "87174": 0.15,
  "87176": 1.19,
  "87181": 0.15,
  "87184": 0.15,
  "87185": 0.15,
  "87187": 0.15,
  "87190": 0.15,
  "87191": 1.19,
  "87192": 0.15,
  "87193": 0.15,
  "87194": 0.15,
  "87195": -0.4,
  "87196": 0.15,
  "87197": 0.15,
  "87198": -0.4,
  "87199": 0.15,
  "87301": -10.52,
  "87305": -10.52,
  "87310": -10.52,
  "87311": -10.52,
  "87312": -9.97,
  "87313": -10.52,
  "87315": -8.68,
  "87316": -10.52,
  "87317": -10.52,
  "87319": -10.52,
  "87320": -10.52,
  "87321": -8.68,
  "87322": -10.52,
  "87323": -10.52,
  "87325": -10.52,
  "87326": -10.52,
  "87327": -10.52,
  "87328": -10.52,
  "87347": -10.52,
  "87357": -8.68,
  "87364": 2.36,
  "87365": -10.52,
  "87375": -10.52,
  "87401": 3.43,
  "87402": 3.43,
  "87410": 2.91,
  "87412": 2.91,
  "87413": 2.91,
  "87415": 3.43,
  "87416": 2.36,
  "87417": 2.36,
  "87418": 3.43,
  "87419": 2.91,
  "87420": 2.36,
  "87421": 2.36,
  "87455": 2.36,
  "87461": 2.36,
  "87499": 3.43,
  "87501": -6.69,
  "87502": -6.69,
  "87504": -6.69,
  "87505": -6.69,
  "87506": -6.69,
  "87507": -6.69,
  "87508": -6.69,
  "87510": 17.17,
  "87511": 17.17,
  "87512": -6.29,
  "87513": -5.77,
  "87514": -5.77,
  "87515": 0.15,
  "87516": 17.17,
  "87517": -6.29,
  "87518": 0.15,
  "87519": -5.77,
  "87520": 0.15,
  "87521": -6.29,
  "87522": 17.69,
  "87523": 17.17,
  "87524": -6.29,
  "87525": -5.77,
  "87527": -5.77,
  "87528": 0.15,
  "87529": -5.77,
  "87530": 0.15,
  "87531": 17.17,
  "87532": 17.69,
  "87533": 17.69,
  "87535": -7.21,
  "87537": 17.69,
  "87538": -3.99,
  "87539": -5.77,
  "87540": -5.62,
  "87543": -6.29,
  "87544": 17.69,
  "87548": 17.17,
  "87549": -5.77,
  "87551": 0.15,
  "87552": -6.69,
  "87553": -6.29,
  "87554": -6.29,
  "87556": -6.29,
  "87557": -5.77,
  "87558": -6.29,
  "87560": -3.99,
  "87562": -7.21,
  "87564": -5.77,
  "87565": -3.99,
  "87566": 17.17,
  "87567": 17.69,
  "87569": -3.99,
  "87571": -5.77,
  "87573": -5.62,
  "87574": -6.69,
  "87575": 0.15,
  "87576": -5.77,
  "87577": -6.29,
  "87578": 17.17,
  "87579": -6.29,
  "87580": -5.77,
  "87581": -6.29,
  "87582": 17.17,
  "87583": -3.99,
  "87592": -6.69,
  "87594": -6.69,
  "87701": -3.99,
  "87710": -5.77,
  "87711": -3.99,
  "87712": -3.99,
  "87713": -5.77,
  "87714": -15.49,
  "87715": -6.29,
  "87718": -6.29,
  "87722": -3.99,
  "87723": -6.29,
  "87724": -3.99,
  "87728": -15.49,
  "87729": -15.49,
  "87730": -18.71,
  "87731": -3.47,
  "87732": -6.29,
  "87733": -18.71,
  "87734": -3.99,
  "87735": -3.99,
  "87736": -3.47,
  "87740": -17.08,
  "87742": -3.47,
  "87743": -18.71,
  "87745": -3.99,
  "87746": -18.71,
  "87747": -15.49,
  "87749": -15.49,
  "87750": 7.32,
  "87752": -15.49,
  "87753": -3.99,
  "87801": -13.74,
  "87820": -12.73,
  "87821": -13.28,
  "87823": -13.74,
  "87824": -14.32,
  "87825": -13.74,
  "87827": -13.28,
  "87828": -13.74,
  "87829": -13.28,
  "87830": -14.32,
  "87831": -13.74,
  "87832": -13.74,
  "87901": -5.21,
  "87930": -5.21,
  "87931": -4.66,
  "87933": -5.21,
  "87935": -4.66,
  "87936": -5.21,
  "87937": -5.21,
  "87939": -4.66,
  "87940": -5.21,
  "87941": -5.21,
  "87942": -5.21,
  "87943": -4.66,
  "88001": -8.89,
  "88002": -8.34,
  "88003": -8.89,
  "88004": -8.34,
  "88005": -8.34,
  "88006": -8.89,
  "88007": -8.34,
  "88008": -9.81,
  "88009": -13.95,
  "88011": -8.34,
  "88012": -8.34,
  "88013": -8.89,
  "88020": -13.95,
  "88021": -10.33,
  "88022": -13.95,
  "88023": -13.95,
  "88024": -8.89,
  "88025": -2.36,
  "88026": -13.95,
  "88027": -8.89,
  "88028": -2.36,
  "88029": 2.61,
  "88030": 2.61,
  "88031": 2.61,
  "88032": -8.34,
  "88033": 0.15,
  "88034": -13.4,
  "88036": -13.95,
  "88038": -13.4,
  "88039": -14.32,
  "88040": 2.61,
  "88041": -13.4,
  "88042": -5.21,
  "88043": -13.95,
  "88044": -8.89,
  "88045": -13.95,
  "88046": -8.34,
  "88047": -8.34,
  "88048": -8.89,
  "88049": -13.4,
  "88051": 6.65,
  "88052": -8.89,
  "88053": -13.4,
  "88054": -5.21,
  "88055": -2.36,
  "88056": -6.96,
  "88058": -8.89,
  "88061": -13.4,
  "88062": -13.4,
  "88063": -10.33,
  "88065": -13.4,
  "88072": -8.34,
  "88081": -10.33,
  "88101": -12.11,
  "88102": -12.11,
  "88103": -12.11,
  "88112": -12.11,
  "88113": -15.79,
  "88114": -21.83,
  "88115": -21.31,
  "88116": -21.31,
  "88118": -21.31,
  "88119": -15.03,
  "88120": -16.25,
  "88121": -16.25,
  "88122": -21.83,
  "88123": -21.31,
  "88124": -12.63,
  "88125": -21.31,
  "88126": -20.24,
  "88130": -21.83,
  "88132": -21.31,
  "88133": -12.63,
  "88134": -21.83,
  "88135": -12.11,
  "88136": -3.72,
  "88201": -7.97,
  "88202": -7.97,
  "88203": -7.97,
  "88210": 1.57,
  "88211": 1.57,
  "88213": 2.3,
  "88220": 1.57,
  "88221": 1.57,
  "88230": -8.49,
  "88231": -1.19,
  "88232": -9.01,
  "88240": -1.19,
  "88241": -1.19,
  "88242": -1.19,
  "88250": 2.61,
  "88252": -1.19,
  "88253": -7.97,
  "88254": 2.09,
  "88255": 1.57,
  "88256": 1.57,
  "88260": -1.19,
  "88262": -0.67,
  "88263": 1.57,
  "88264": 1.57,
  "88265": -1.19,
  "88267": 4.85,
  "88268": 12.36,
  "88301": -15.58,
  "88310": -9.35,
  "88311": -9.35,
  "88312": -16.62,
  "88314": -9.35,
  "88316": -16.62,
  "88317": -8.8,
  "88318": -15.58,
  "88321": -9.14,
  "88323": -16.62,
  "88324": -16.62,
  "88325": -9.35,
  "88330": -9.35,
  "88336": -16.62,
  "88337": -8.8,
  "88338": -16.62,
  "88339": -8.8,
  "88340": -16.62,
  "88341": -16.62,
  "88342": -8.34,
  "88343": -7.97,
  "88344": -8.8,
  "88345": -16.62,
  "88346": -16.62,
  "88347": -8.8,
  "88348": -16.62,
  "88349": -8.8,
  "88350": -8.8,
  "88351": -16.62,
  "88352": -9.35,
  "88353": -15.03,
  "88354": -8.8,
  "88355": -16.62,
  "88401": -16.25,
  "88410": -0.15,
  "88411": -16.77,
  "88414": -17.63,
  "88415": -3.37,
  "88416": -14.11,
  "88417": -15.03,
  "88418": -17.63,
  "88419": -17.63,
  "88421": -3.99,
  "88422": -18.71,
  "88424": -16.16,
  "88426": -16.25,
  "88427": -16.25,
  "88430": -0.67,
  "88431": -13.59,
  "88433": -16.25,
  "88434": -16.25,
  "88435": -15.03,
  "88436": -3.37,
  "88439": 7.32,
  "88510": -10.33,
  "88511": -10.33,
  "88512": -10.33,
  "88513": -10.33,
  "88514": -10.33,
  "88515": -10.33,
  "88516": -10.33,
  "88517": -10.33,
  "88518": -10.33,
  "88519": -10.33,
  "88520": -10.33,
  "88521": -10.33,
  "88523": -10.33,
  "88524": -10.33,
  "88525": -10.33,
  "88526": -10.33,
  "88527": -10.33,
  "88528": -10.33,
  "88529": -10.33,
  "88530": -10.33,
  "88531": -10.33,
  "88532": -10.33,
  "88533": -10.33,
  "88534": -10.33,
  "88535": -10.33,
  "88536": -10.33,
  "88538": -10.33,
  "88539": -10.33,
  "88540": -10.33,
  "88541": -10.33,
  "88542": -10.33,
  "88543": -10.33,
  "88544": -10.33,
  "88545": -9.81,
  "88546": -9.81,
  "88547": -9.81,
  "88548": -9.81,
  "88549": -9.81,
  "88550": -10.33,
  "88553": -9.81,
  "88554": -9.81,
  "88555": -9.81,
  "88556": -9.81,
  "88557": -9.81,
  "88558": -9.81,
  "88559": -9.81,
  "88560": -9.81,
  "88561": -9.81,
  "88562": -9.81,
  "88563": -9.81,
  "88565": -9.81,
  "88566": -9.81,
  "88567": -9.81,
  "88568": -9.81,
  "88569": -9.81,
  "88570": -9.81,
  "88571": -9.81,
  "88572": -9.81,
  "88573": -9.81,
  "88574": -9.81,
  "88575": -9.81,
  "88576": -9.81,
  "88577": -9.81,
  "88578": -9.81,
  "88579": -9.81,
  "88580": -9.81,
  "88581": -9.81,
  "88582": -9.81,
  "88583": -9.81,
  "88584": -9.81,
  "88585": -9.81,
  "88586": -9.81,
  "88587": -10.33,
  "88588": -10.33,
  "88589": -10.33,
  "88590": -10.33,
  "88595": -10.33,
  "89001": -0.86,
  "89002": 3.37,
  "89003": -10.52,
  "89004": 3.37,
  "89005": 3.37,
  "89006": 3.37,
  "89007": 3.37,
  "89008": -0.86,
  "89009": 3.37,
  "89010": -5.12,
  "89011": 14.16,
  "89012": 3.37,
  "89013": -4.6,
  "89014": 3.37,
  "89015": 3.37,
  "89016": 14.16,
  "89017": -0.86,
  "89018": 2.82,
  "89019": 2.82,
  "89020": 2.82,
  "89021": 3.37,
  "89022": -10.52,
  "89023": 2.82,
  "89024": 3.37,
  "89025": 2.82,
  "89027": 3.37,
  "89028": 3.37,
  "89029": 3.37,
  "89030": 2.82,
  "89031": 3.37,
  "89032": 3.37,
  "89033": 3.37,
  "89034": -0.86,
  "89036": 2.82,
  "89037": 2.82,
  "89039": 2.82,
  "89040": 2.82,
  "89041": 2.82,
  "89042": -0.86,
  "89043": -0.86,
  "89044": 3.37,
  "89045": -10.52,
  "89046": 2.82,
  "89047": -5.12,
  "89048": 2.82,
  "89049": -10.52,
  "89052": 3.37,
  "89053": 3.37,
  "89054": 3.37,
  "89060": 2.82,
  "89061": 2.82,
  "89067": 2.82,
  "89074": 3.37,
  "89077": 3.37,
  "89081": 3.37,
  "89084": 3.37,
  "89085": 3.37,
  "89086": 3.37,
  "89087": 3.37,
  "89101": 2.82,
  "89102": 3.37,
  "89103": 2.82,
  "89104": 2.82,
  "89105": 3.37,
  "89106": 2.82,
  "89107": 3.37,
  "89108": 3.37,
  "89109": 3.37,
  "89110": 2.82,
  "89111": 3.37,
  "89112": 2.82,
  "89113": 3.37,
  "89114": 3.37,
  "89115": 2.82,
  "89116": 2.82,
  "89117": 3.37,
  "89118": 3.37,
  "89119": 3.37,
  "89120": 3.37,
  "89121": 2.82,
  "89122": 2.82,
  "89123": 3.37,
  "89124": 3.37,
  "89125": 2.82,
  "89126": 3.37,
  "89127": 2.82,
  "89128": 3.37,
  "89129": 3.37,
  "89130": 3.37,
  "89131": 3.37,
  "89132": 3.37,
  "89133": 3.37,
  "89134": 3.37,
  "89135": 3.37,
  "89136": 2.82,
  "89137": 3.37,
  "89138": 3.37,
  "89139": 3.37,
  "89140": 3.37,
  "89141": 3.37,
  "89142": 3.37,
  "89143": 3.37,
  "89144": 3.37,
  "89145": 3.37,
  "89146": 3.37,
  "89147": 3.37,
  "89148": 7.26,
  "89149": 3.37,
  "89154": 3.37,
  "89156": 3.37,
  "89157": 2.82,
  "89160": 2.82,
  "89161": 2.82,
  "89162": 2.82,
  "89165": 3.37,
  "89166": 3.37,
  "89169": 3.37,
  "89170": 3.37,
  "89173": 2.82,
  "89178": 7.26,
  "89179": 3.37,
  "89180": 2.82,
  "89183": 2.82,
  "89185": 2.82,
  "89191": 2.82,
  "89193": 3.37,
  "89199": 2.82,
  "89301": -4.54,
  "89310": -0.86,
  "89311": 4.5,
  "89314": -10.52,
  "89315": -4.54,
  "89316": -0.83,
  "89317": -0.86,
  "89318": -4.54,
  "89319": -4.54,
  "89402": 12.32,
  "89403": 23.61,
  "89404": -0.92,
  "89405": 4.2,
  "89406": 1.99,
  "89407": 1.99,
  "89408": 1.99,
  "89409": -10.98,
  "89410": 3.37,
  "89411": 14.16,
  "89412": 4.2,
  "89413": 12.32,
  "89414": 0.15,
  "89415": -10.98,
  "89418": -0.4,
  "89419": 1.99,
  "89420": -10.43,
  "89421": -1.44,
  "89422": -10.98,
  "89423": 3.37,
  "89424": 4.75,
  "89425": -0.92,
  "89426": 0.15,
  "89427": -10.98,
  "89428": 23.61,
  "89429": -0.77,
  "89430": 3.37,
  "89431": 4.75,
  "89432": 4.75,
  "89433": 4.75,
  "89434": 4.75,
  "89435": 4.75,
  "89436": 4.75,
  "89438": 0.15,
  "89439": 4.75,
  "89440": 23.61,
  "89441": 23.61,
  "89442": 4.75,
  "89444": 3.37,
  "89445": 0.15,
  "89446": 0.15,
  "89447": -0.77,
  "89448": 7.26,
  "89449": 3.37,
  "89450": 12.32,
  "89451": 12.32,
  "89452": 12.32,
  "89460": 3.37,
  "89501": 4.75,
  "89502": 23.61,
  "89503": 4.75,
  "89504": 4.75,
  "89505": 4.75,
  "89506": 4.75,
  "89507": 4.75,
  "89508": 4.75,
  "89509": 4.75,
  "89510": 4.75,
  "89511": 23.61,
  "89512": 4.75,
  "89513": 4.75,
  "89515": 23.61,
  "89519": 23.61,
  "89520": 23.61,
  "89521": 23.61,
  "89523": 4.75,
  "89533": 4.75,
  "89570": 23.61,
  "89701": 1.53,
  "89702": 1.53,
  "89703": 1.53,
  "89704": 1.53,
  "89705": 1.53,
  "89706": 1.53,
  "89721": 3.37,
  "89801": 4.66,
  "89802": 4.66,
  "89803": 4.66,
  "89815": 4.66,
  "89820": -0.86,
  "89821": -0.86,
  "89822": 3.62,
  "89823": 4.14,
  "89824": 4.14,
  "89825": 1.65,
  "89826": 1.65,
  "89828": 4.66,
  "89830": 4.14,
  "89831": 3.62,
  "89832": 3.62,
  "89833": 4.14,
  "89834": 3.62,
  "89835": 4.14,
  "89883": 4.14,
  "90001": 7.51,
  "90002": 7.51,
  "90003": 7.51,
  "90004": 10.33,
  "90005": 10.33,
  "90006": 7.51,
  "90007": 8.03,
  "90008": 10.33,
  "90009": 10.33,
  "90010": 10.33,
  "90011": 7.51,
  "90012": 7.51,
  "90013": 7.51,
  "90014": 7.51,
  "90015": 7.51,
  "90016": 7.51,
  "90017": 10.33,
  "90018": 7.51,
  "90019": 10.33,
  "90020": 8.03,
  "90021": 10.33,
  "90022": 8.03,
  "90023": 8.03,
  "90024": 11.92,
  "90025": 10.33,
  "90026": 8.03,
  "90027": 10.33,
  "90028": 8.03,
  "90029": 8.03,
  "90030": 7.51,
  "90031": 7.51,
  "90032": 7.51,
  "90033": 7.51,
  "90034": 10.33,
  "90035": 10.33,
  "90036": 10.33,
  "90037": 7.51,
  "90038": 8.03,
  "90039": 10.33,
  "90040": 8.03,
  "90041": 8.03,
  "90042": 7.51,
  "90043": 7.51,
  "90044": 7.51,
  "90045": 10.33,
  "90046": 10.33,
  "90047": 7.51,
  "90048": 10.33,
  "90049": 18.82,
  "90050": 7.51,
  "90051": 7.51,
  "90052": 7.51,
  "90053": 7.51,
  "90054": 7.51,
  "90055": 7.51,
  "90056": 10.33,
  "90057": 7.51,
  "90058": 7.51,
  "90059": 7.51,
  "90060": 10.33,
  "90061": 7.51,
  "90062": 7.51,
  "90063": 7.51,
  "90064": 10.33,
  "90065": 8.03,
  "90066": 10.33,
  "90067": 10.33,
  "90068": 10.33,
  "90069": 10.33,
  "90070": 10.33,
  "90071": 10.33,
  "90072": 8.03,
  "90073": 10.33,
  "90075": 8.03,
  "90076": 10.33,
  "90077": 18.82,
  "90078": 8.03,
  "90079": 7.51,
  "90080": 10.33,
  "90081": 10.33,
  "90082": 7.51,
  "90083": 10.33,
  "90086": 7.51,
  "90087": 7.51,
  "90091": 8.03,
  "90093": 8.03,
  "90094": 10.33,
  "90099": 7.51,
  "90101": 8.03,
  "90201": 7.51,
  "90202": 7.51,
  "90209": 11.92,
  "90210": 18.82,
  "90211": 11.92,
  "90212": 18.82,
  "90213": 18.82,
  "90220": 7.51,
  "90221": 7.51,
  "90222": 7.51,
  "90223": 7.51,
  "90224": 8.03,
  "90230": 10.33,
  "90231": 10.33,
  "90232": 10.33,
  "90233": 10.33,
  "90239": 8.03,
  "90240": 8.03,
  "90241": 8.03,
  "90242": 8.03,
  "90245": 10.33,
  "90247": 7.51,
  "90248": 7.51,
  "90249": 8.03,
  "90250": 8.03,
  "90251": 8.03,
  "90254": 11.92,
  "90255": 7.51,
  "90260": 8.03,
  "90261": 8.03,
  "90262": 7.51,
  "90263": 13.76,
  "90264": 13.76,
  "90265": 13.76,
  "90266": 18.82,
  "90267": 11.92,
  "90270": 7.51,
  "90272": 18.82,
  "90274": 18.82,
  "90275": 18.82,
  "90277": 10.33,
  "90278": 10.33,
  "90280": 7.51,
  "90290": 10.33,
  "90291": 10.33,
  "90292": 10.33,
  "90293": 10.33,
  "90294": 10.33,
  "90295": 10.33,
  "90296": 10.33,
  "90301": 7.51,
  "90302": 7.51,
  "90303": 7.51,
  "90304": 7.51,
  "90305": 8.03,
  "90306": 7.51,
  "90307": 7.51,
  "90308": 7.51,
  "90309": 7.51,
  "90310": 7.51,
  "90311": 7.51,
  "90312": 7.51,
  "90401": 10.33,
  "90402": 18.82,
  "90403": 10.33,
  "90404": 10.33,
  "90405": 10.33,
  "90406": 10.33,
  "90407": 10.33,
  "90408": 10.33,
  "90409": 10.33,
  "90410": 10.33,
  "90411": 10.33,
  "90501": 10.33,
  "90502": 8.03,
  "90503": 10.33,
  "90504": 10.33,
  "90505": 10.33,
  "90506": 10.33,
  "90507": 10.33,
  "90508": 10.33,
  "90509": 10.33,
  "90510": 10.33,
  "90601": 8.03,
  "90602": 8.03,
  "90603": 12.17,
  "90604": 11.65,
  "90605": 7.51,
  "90606": 8.03,
  "90607": 8.03,
  "90608": 8.03,
  "90609": 8.03,
  "90610": 8.03,
  "90620": 12.17,
  "90621": 11.65,
  "90622": 12.17,
  "90623": 14.47,
  "90624": 12.17,
  "90630": 14.47,
  "90631": 12.17,
  "90632": 12.17,
  "90633": 12.17,
  "90637": 12.17,
  "90638": 12.17,
  "90640": 8.03,
  "90650": 7.51,
  "90651": 7.51,
  "90652": 8.03,
  "90660": 8.03,
  "90661": 8.03,
  "90662": 8.03,
  "90670": 8.03,
  "90671": 8.03,
  "90680": 11.65,
  "90701": 12.17,
  "90702": 12.17,
  "90703": 14.47,
  "90704": 14.47,
  "90706": 8.03,
  "90707": 8.03,
  "90710": 8.03,
  "90711": 8.03,
  "90712": 8.03,
  "90713": 12.17,
  "90714": 8.03,
  "90715": 12.17,
  "90716": 8.03,
  "90717": 10.33,
  "90720": 14.47,
  "90721": 14.47,
  "90723": 7.51,
  "90731": 14.47,
  "90732": 10.33,
  "90733": 14.47,
  "90734": 10.33,
  "90740": 11.65,
  "90742": 22.96,
  "90743": 22.96,
  "90744": 7.51,
  "90745": 8.03,
  "90746": 8.03,
  "90748": 7.51,
  "90749": 8.03,
  "90755": 11.65,
  "90801": 11.65,
  "90802": 11.65,
  "90803": 14.47,
  "90804": 14.47,
  "90805": 7.51,
  "90806": 12.17,
  "90807": 8.03,
  "90808": 14.47,
  "90809": 14.47,
  "90810": 7.51,
  "90813": 11.65,
  "90814": 14.47,
  "90815": 14.47,
  "90822": 7.51,
  "90831": 11.65,
  "90832": 11.65,
  "90833": 11.65,
  "90834": 11.65,
  "90835": 11.65,
  "90853": 14.47,
  "91001": 10.33,
  "91003": 10.33,
  "91006": 10.33,
  "91007": 10.33,
  "91008": 8.03,
  "91009": 8.03,
  "91010": 8.03,
  "91011": 18.82,
  "91012": 18.82,
  "91016": 8.03,
  "91017": 8.03,
  "91020": 10.33,
  "91021": 10.33,
  "91023": 10.33,
  "91024": 11.92,
  "91025": 11.92,
  "91030": 11.92,
  "91031": 11.92,
  "91040": 8.03,
  "91041": 8.03,
  "91042": 8.03,
  "91043": 8.03,
  "91046": 10.33,
  "91066": 10.33,
  "91077": 10.33,
  "91101": 8.03,
  "91102": 8.03,
  "91103": 8.03,
  "91104": 10.33,
  "91105": 18.82,
  "91106": 10.33,
  "91107": 10.33,
  "91108": 18.82,
  "91109": 8.03,
  "91114": 10.33,
  "91115": 18.82,
  "91116": 10.33,
  "91117": 10.33,
  "91118": 10.33,
  "91201": 10.33,
  "91202": 10.33,
  "91203": 8.03,
  "91204": 8.03,
  "91205": 8.03,
  "91206": 10.33,
  "91207": 18.82,
  "91208": 11.92,
  "91209": 8.03,
  "91210": 8.03,
  "91214": 10.33,
  "91221": 10.33,
  "91222": 8.03,
  "91224": 10.33,
  "91225": 8.03,
  "91226": 10.33,
  "91301": 5.27,
  "91302": 6.86,
  "91303": 7.51,
  "91304": 8.03,
  "91305": 7.51,
  "91306": 8.03,
  "91307": 5.27,
  "91308": 7.51,
  "91309": 8.03,
  "91310": 2.97,
  "91311": 10.33,
  "91313": 10.33,
  "91316": 10.33,
  "91319": 2.97,
  "91320": 2.97,
  "91321": 8.03,
  "91322": 8.03,
  "91324": 10.33,
  "91325": 10.33,
  "91326": 10.33,
  "91327": 10.33,
  "91328": 7.51,
  "91331": 7.51,
  "91333": 7.51,
  "91334": 7.51,
  "91335": 7.51,
  "91337": 7.51,
  "91340": 7.51,
  "91341": 7.51,
  "91342": 7.51,
  "91343": 8.03,
  "91344": 10.33,
  "91345": 7.51,
  "91346": 7.51,
  "91350": 14.93,
  "91351": 8.03,
  "91352": 7.51,
  "91353": 7.51,
  "91354": 5.27,
  "91355": 10.33,
  "91356": 10.33,
  "91357": 10.33,
  "91358": 5.27,
  "91359": 5.27,
  "91360": 5.27,
  "91361": 13.76,
  "91362": 5.27,
  "91364": 10.33,
  "91365": 10.33,
  "91367": 10.33,
  "91372": 6.86,
  "91376": 5.27,
  "91377": 5.27,
  "91380": 14.93,
  "91381": 5.27,
  "91382": 8.03,
  "91383": 8.03,
  "91384": 2.97,
  "91385": 10.33,
  "91386": 8.03,
  "91387": 8.03,
  "91390": 14.93,
  "91392": 7.51,
  "91393": 8.03,
  "91394": 10.33,
  "91395": 7.51,
  "91396": 8.03,
  "91401": 10.33,
  "91402": 7.51,
  "91403": 10.33,
  "91404": 10.33,
  "91405": 7.51,
  "91406": 7.51,
  "91407": 7.51,
  "91408": 10.33,
  "91409": 7.51,
  "91410": 7.51,
  "91411": 8.03,
  "91412": 7.51,
  "91413": 10.33,
  "91416": 10.33,
  "91423": 10.33,
  "91426": 10.33,
  "91436": 8.03,
  "91501": 10.33,
  "91502": 8.03,
  "91503": 8.03,
  "91504": 10.33,
  "91505": 8.03,
  "91506": 10.33,
  "91507": 8.03,
  "91508": 10.33,
  "91510": 8.03,
  "91601": 8.03,
  "91602": 10.33,
  "91603": 8.03,
  "91604": 10.33,
  "91605": 7.51,
  "91606": 7.51,
  "91607": 10.33,
  "91608": 10.33,
  "91609": 7.51,
  "91610": 10.33,
  "91614": 10.33,
  "91615": 7.51,
  "91616": 7.51,
  "91617": 10.33,
  "91618": 10.33,
  "91701": 19.07,
  "91702": 7.51,
  "91706": 7.51,
  "91708": 11.65,
  "91709": 11.65,
  "91710": 11.65,
  "91711": 14.47,
  "91714": 7.51,
  "91715": 8.03,
  "91716": 8.03,
  "91722": 8.03,
  "91723": 8.03,
  "91724": 8.03,
  "91729": 11.65,
  "91730": 11.65,
  "91731": 7.51,
  "91732": 7.51,
  "91733": 7.51,
  "91734": 7.51,
  "91737": 19.07,
  "91739": 10.58,
  "91740": 8.03,
  "91741": 10.33,
  "91743": 11.65,
  "91744": 7.51,
  "91745": 8.03,
  "91746": 7.51,
  "91747": 7.51,
  "91748": 12.17,
  "91749": 7.51,
  "91750": 8.03,
  "91752": 11.65,
  "91754": 8.03,
  "91755": 8.03,
  "91758": 11.65,
  "91759": 17.23,
  "91761": 11.65,
  "91762": 11.65,
  "91763": 11.65,
  "91764": 11.65,
  "91765": 14.47,
  "91766": 11.65,
  "91767": 11.65,
  "91768": 11.65,
  "91769": 11.65,
  "91770": 8.03,
  "91773": 8.03,
  "91775": 10.33,
  "91776": 8.03,
  "91778": 8.03,
  "91780": 8.03,
  "91784": 22.44,
  "91785": 11.65,
  "91786": 11.65,
  "91788": 14.47,
  "91789": 14.47,
  "91790": 8.03,
  "91791": 8.03,
  "91792": 7.51,
  "91793": 8.03,
  "91801": 8.03,
  "91802": 8.03,
  "91803": 8.03,
  "91804": 8.03,
  "91896": 8.03,
  "91899": 8.03,
  "91901": 8.95,
  "91902": 9.47,
  "91903": 8.95,
  "91905": 6.13,
  "91906": 6.13,
  "91908": 9.47,
  "91909": 6.65,
  "91910": 6.65,
  "91911": 6.65,
  "91912": 6.65,
  "91913": 6.65,
  "91914": 6.65,
  "91915": 6.65,
  "91916": 6.13,
  "91917": 6.65,
  "91921": 6.65,
  "91931": 6.13,
  "91932": 6.65,
  "91933": 6.65,
  "91934": -2.15,
  "91935": 8.95,
  "91941": 8.95,
  "91942": 6.65,
  "91943": 6.65,
  "91944": 8.95,
  "91945": 6.13,
  "91946": 6.13,
  "91947": 6.65,
  "91948": 6.13,
  "91950": 6.65,
  "91951": 6.65,
  "91962": 8.95,
  "91963": 6.65,
  "91976": 8.95,
  "91977": 6.13,
  "91978": 6.13,
  "91979": 6.13,
  "91980": 6.65,
  "92003": 8.95,
  "92004": -1.63,
  "92007": 8.95,
  "92008": 6.65,
  "92009": 8.95,
  "92010": 8.95,
  "92011": 6.65,
  "92013": 6.65,
  "92014": 17.44,
  "92018": 6.65,
  "92019": 8.95,
  "92020": 6.65,
  "92021": 6.65,
  "92022": 6.13,
  "92023": 8.95,
  "92024": 8.95,
  "92025": 6.13,
  "92026": 6.13,
  "92027": 6.13,
  "92028": 6.65,
  "92029": 8.95,
  "92030": 6.13,
  "92033": 6.13,
  "92036": 6.13,
  "92037": 17.44,
  "92038": 17.44,
  "92039": 17.44,
  "92040": 6.65,
  "92046": 6.13,
  "92049": 6.13,
  "92051": 6.13,
  "92052": 6.13,
  "92054": 6.13,
  "92055": 6.13,
  "92056": 6.13,
  "92057": 6.13,
  "92058": 6.13,
  "92059": 6.13,
  "92060": 6.13,
  "92061": 6.13,
  "92064": 6.65,
  "92065": 6.65,
  "92066": 6.13,
  "92067": 17.44,
  "92068": 6.13,
  "92069": 6.13,
  "92070": 6.13,
  "92071": 6.65,
  "92072": 6.65,
  "92074": 6.65,
  "92075": 8.95,
  "92078": 6.13,
  "92079": 6.13,
  "92081": 6.13,
  "92082": 6.65,
  "92083": 6.13,
  "92084": 6.13,
  "92085": 6.13,
  "92086": 0.61,
  "92088": 6.65,
  "92091": 8.95,
  "92101": 8.95,
  "92102": 6.65,
  "92103": 8.95,
  "92104": 6.65,
  "92105": 6.13,
  "92106": 10.54,
  "92107": 9.47,
  "92108": 6.13,
  "92109": 8.95,
  "92110": 8.95,
  "92111": 6.65,
  "92112": 8.95,
  "92113": 6.13,
  "92114": 6.65,
  "92115": 6.65,
  "92116": 6.65,
  "92117": 6.65,
  "92118": 17.44,
  "92119": 6.65,
  "92120": 8.95,
  "92121": 8.95,
  "92122": 8.95,
  "92123": 6.65,
  "92124": 8.95,
  "92126": 6.65,
  "92127": 6.65,
  "92128": 6.65,
  "92129": 8.95,
  "92130": 17.44,
  "92131": 8.95,
  "92135": 17.44,
  "92137": 8.95,
  "92138": 8.95,
  "92139": 6.65,
  "92142": 8.95,
  "92143": 6.65,
  "92149": 6.65,
  "92150": 6.65,
  "92153": 6.65,
  "92154": 6.65,
  "92159": 6.65,
  "92160": 8.95,
  "92162": 6.65,
  "92163": 8.95,
  "92164": 6.65,
  "92165": 6.13,
  "92166": 10.54,
  "92167": 9.47,
  "92168": 6.13,
  "92169": 8.95,
  "92170": 6.13,
  "92171": 6.65,
  "92172": 8.95,
  "92173": 6.65,
  "92174": 6.65,
  "92175": 6.65,
  "92176": 6.65,
  "92177": 6.65,
  "92178": 17.44,
  "92179": 6.65,
  "92186": 8.95,
  "92190": 8.95,
  "92191": 8.95,
  "92192": 8.95,
  "92193": 6.65,
  "92194": 6.65,
  "92195": 6.13,
  "92196": 6.65,
  "92197": 6.65,
  "92198": 6.65,
  "92199": 6.65,
  "92201": 1.13,
  "92202": 1.13,
  "92203": 0.61,
  "92210": 11.92,
  "92211": 1.13,
  "92220": -2.05,
  "92222": -12.63,
  "92223": -1.53,
  "92225": 5.83,
  "92226": 5.83,
  "92227": -4.29,
  "92230": 0.06,
  "92231": -2.7,
  "92232": -2.7,
  "92233": -4.29,
  "92234": 0.61,
  "92235": 0.61,
  "92236": 0.61,
  "92239": -2.15,
  "92240": 0.06,
  "92241": 0.06,
  "92242": 5.83,
  "92243": -4.29,
  "92244": -4.29,
  "92247": 1.13,
  "92248": 1.13,
  "92249": -4.29,
  "92250": -4.29,
  "92251": 4.2,
  "92252": 0.06,
  "92253": 1.13,
  "92254": 0.61,
  "92255": 1.13,
  "92256": 0.06,
  "92257": -2.15,
  "92258": 0.06,
  "92259": -2.15,
  "92260": 1.13,
  "92261": 1.13,
  "92262": 0.61,
  "92263": 0.61,
  "92264": 2.2,
  "92266": 5.31,
  "92267": 5.83,
  "92268": 4.29,
  "92270": 2.2,
  "92273": -4.29,
  "92274": 0.61,
  "92275": 0.61,
  "92276": 0.61,
  "92277": 0.61,
  "92278": 0.61,
  "92280": 5.83,
  "92281": -4.29,
  "92282": 0.61,
  "92283": -12.63,
  "92284": 0.61,
  "92285": 3.74,
  "92286": 0.61,
  "92292": 2.2,
  "92301": 3.22,
  "92304": 4.29,
  "92305": 3.22,
  "92307": 3.22,
  "92308": 2.7,
  "92309": 2.82,
  "92310": 2.7,
  "92311": 2.7,
  "92312": 2.7,
  "92313": 3.22,
  "92314": 2.7,
  "92315": 3.22,
  "92316": 3.22,
  "92317": 11.71,
  "92318": 2.7,
  "92320": -2.05,
  "92321": 3.22,
  "92322": 3.22,
  "92323": 3.37,
  "92324": 3.22,
  "92325": 3.22,
  "92326": 11.71,
  "92327": 2.7,
  "92328": 0.4,
  "92329": 3.22,
  "92331": 3.22,
  "92332": 2.82,
  "92333": 4.81,
  "92334": 3.22,
  "92335": 3.22,
  "92336": 3.22,
  "92337": 11.65,
  "92338": 4.29,
  "92339": -0.46,
  "92340": 2.7,
  "92341": 3.22,
  "92342": 2.7,
  "92344": 2.7,
  "92345": 2.7,
  "92346": 3.22,
  "92347": 3.22,
  "92352": 11.71,
  "92354": 3.22,
  "92356": 2.7,
  "92358": 3.22,
  "92359": 3.22,
  "92363": 2.82,
  "92364": 2.82,
  "92365": 2.7,
  "92366": 2.82,
  "92368": 2.7,
  "92369": 3.22,
  "92371": 2.7,
  "92372": 3.22,
  "92373": 3.22,
  "92374": 3.22,
  "92375": 3.22,
  "92376": 3.22,
  "92377": 3.22,
  "92378": 3.22,
  "92382": 3.22,
  "92384": 14.16,
  "92385": 3.22,
  "92386": 3.22,
  "92389": 2.82,
  "92391": 3.22,
  "92392": 3.22,
  "92393": 3.22,
  "92394": 2.7,
  "92395": 3.22,
  "92397": 3.22,
  "92398": 2.7,
  "92399": -0.46,
  "92401": 2.7,
  "92402": 3.22,
  "92403": 2.7,
  "92404": 2.7,
  "92405": 2.7,
  "92406": 2.7,
  "92407": 3.22,
  "92408": 2.7,
  "92410": 2.7,
  "92411": 2.7,
  "92412": 2.7,
  "92413": 2.7,
  "92423": 2.7,
  "92427": 3.22,
  "92501": 11.65,
  "92502": 11.65,
  "92503": 11.65,
  "92504": 11.65,
  "92505": 11.65,
  "92506": 12.17,
  "92507": 0.61,
  "92508": 1.13,
  "92509": 11.65,
  "92513": 11.65,
  "92514": 11.65,
  "92515": 11.65,
  "92516": 12.17,
  "92517": 11.65,
  "92518": 1.13,
  "92519": 11.65,
  "92530": 11.65,
  "92531": 11.65,
  "92532": 1.13,
  "92536": 0.61,
  "92539": 0.61,
  "92543": -2.05,
  "92544": -2.05,
  "92545": -2.05,
  "92546": -2.05,
  "92548": -2.05,
  "92549": 9.1,
  "92551": 0.61,
  "92552": 0.61,
  "92553": 0.61,
  "92554": 0.61,
  "92555": 0.61,
  "92556": 0.61,
  "92557": 0.61,
  "92561": 1.13,
  "92562": 1.13,
  "92563": 0.61,
  "92564": 0.61,
  "92567": -1.53,
  "92570": 0.61,
  "92571": 0.61,
  "92572": 0.61,
  "92581": -2.05,
  "92582": -2.05,
  "92583": -2.05,
  "92584": 0.61,
  "92585": -1.53,
  "92586": -2.05,
  "92587": 1.13,
  "92589": 1.13,
  "92590": 11.92,
  "92591": 1.13,
  "92592": 1.13,
  "92593": 1.13,
  "92595": 0.61,
  "92596": 6.44,
  "92602": 14.47,
  "92603": 14.47,
  "92604": 14.47,
  "92605": 14.47,
  "92606": 14.47,
  "92607": 14.47,
  "92609": 14.47,
  "92610": 14.47,
  "92612": 14.47,
  "92614": 14.47,
  "92615": 14.47,
  "92616": 14.47,
  "92617": 14.47,
  "92618": 14.47,
  "92619": 11.65,
  "92620": 14.47,
  "92623": 14.47,
  "92624": 14.47,
  "92625": 22.96,
  "92626": 14.47,
  "92627": 14.47,
  "92628": 14.47,
  "92629": 14.47,
  "92630": 14.47,
  "92637": 11.65,
  "92646": 14.47,
  "92647": 14.47,
  "92648": 16.06,
  "92649": 14.47,
  "92650": 14.47,
  "92651": 16.06,
  "92652": 16.06,
  "92653": 11.65,
  "92654": 11.65,
  "92655": 11.65,
  "92656": 13.95,
  "92657": 22.96,
  "92658": 14.47,
  "92659": 22.96,
  "92660": 14.47,
  "92661": 22.96,
  "92662": 22.96,
  "92663": 22.96,
  "92672": 14.47,
  "92673": 14.47,
  "92674": 14.47,
  "92675": 14.47,
  "92676": 14.47,
  "92677": 14.47,
  "92678": 14.47,
  "92679": 14.47,
  "92683": 12.17,
  "92684": 12.17,
  "92685": 12.17,
  "92688": 13.95,
  "92690": 14.47,
  "92691": 14.47,
  "92692": 14.47,
  "92693": 14.47,
  "92694": 14.47,
  "92701": 11.65,
  "92702": 11.65,
  "92703": 11.65,
  "92704": 11.65,
  "92705": 14.47,
  "92706": 12.17,
  "92707": 11.65,
  "92708": 14.47,
  "92711": 16.06,
  "92712": 11.65,
  "92728": 11.65,
  "92735": 11.65,
  "92780": 14.47,
  "92781": 14.47,
  "92782": 14.47,
  "92799": 11.65,
  "92801": 11.65,
  "92802": 11.65,
  "92803": 11.65,
  "92804": 12.17,
  "92805": 11.65,
  "92806": 12.17,
  "92807": 14.47,
  "92808": 14.47,
  "92809": 11.65,
  "92811": 14.47,
  "92812": 11.65,
  "92814": 12.17,
  "92815": 11.65,
  "92816": 12.17,
  "92817": 14.47,
  "92821": 14.47,
  "92822": 14.47,
  "92823": 14.47,
  "92825": 11.65,
  "92831": 14.47,
  "92832": 11.65,
  "92833": 12.17,
  "92834": 14.47,
  "92835": 14.47,
  "92836": 14.47,
  "92837": 12.17,
  "92838": 14.47,
  "92840": 11.65,
  "92841": 12.17,
  "92842": 11.65,
  "92843": 11.65,
  "92844": 11.65,
  "92845": 14.47,
  "92846": 14.47,
  "92856": 14.47,
  "92857": 12.17,
  "92859": 14.47,
  "92860": 13.24,
  "92861": 22.96,
  "92862": 14.47,
  "92863": 14.47,
  "92864": 14.47,
  "92865": 12.17,
  "92866": 14.47,
  "92867": 14.47,
  "92868": 11.65,
  "92869": 14.47,
  "92870": 14.47,
  "92871": 14.47,
  "92877": 12.17,
  "92878": 11.65,
  "92879": 11.65,
  "92880": 12.17,
  "92881": 13.24,
  "92882": 12.17,
  "92883": 12.17,
  "92885": 14.47,
  "92886": 14.47,
  "92887": 22.96,
  "92899": 12.17,
  "93001": 2.45,
  "93002": 2.45,
  "93003": 2.97,
  "93004": 2.97,
  "93005": 2.97,
  "93006": 2.45,
  "93007": 2.97,
  "93010": 2.97,
  "93011": 2.97,
  "93012": 2.97,
  "93013": 5.27,
  "93014": 5.27,
  "93015": 2.45,
  "93016": 2.45,
  "93020": 2.97,
  "93021": 2.97,
  "93022": 2.45,
  "93023": 2.97,
  "93024": 2.97,
  "93030": 2.45,
  "93031": 2.45,
  "93032": 2.45,
  "93033": 2.45,
  "93034": 2.45,
  "93035": 2.97,
  "93036": 2.45,
  "93040": 2.45,
  "93041": 2.45,
  "93044": 2.45,
  "93060": 2.45,
  "93061": 2.45,
  "93062": 5.27,
  "93063": 2.97,
  "93065": 5.27,
  "93066": 13.76,
  "93067": 4.35,
  "93094": 5.27,
  "93101": 4.35,
  "93102": 4.35,
  "93103": 4.87,
  "93105": 4.35,
  "93107": 4.35,
  "93108": 12.84,
  "93109": 4.35,
  "93110": 4.35,
  "93111": 4.35,
  "93116": 4.35,
  "93117": 4.35,
  "93118": 4.35,
  "93120": 4.35,
  "93121": 4.35,
  "93130": 4.35,
  "93140": 4.87,
  "93150": 12.84,
  "93160": 4.35,
  "93190": 4.35,
  "93201": -4.2,
  "93202": -3.68,
  "93203": 0.92,
  "93204": -2.61,
  "93205": 0.92,
  "93206": 0.92,
  "93207": -6.04,
  "93208": -5.52,
  "93210": -2.61,
  "93212": -3.68,
  "93215": -5.52,
  "93216": -5.52,
  "93218": -5.52,
  "93219": -6.04,
  "93220": 0.92,
  "93221": -5,
  "93222": 1.9,
  "93223": -5.52,
  "93224": 0.46,
  "93225": 1.9,
  "93226": 0.92,
  "93227": -5,
  "93230": -3.16,
  "93232": -3.68,
  "93234": -3.68,
  "93235": -5.52,
  "93237": -5,
  "93238": 0.92,
  "93239": -4.2,
  "93240": 0.92,
  "93241": 0.92,
  "93242": 1.9,
  "93243": 0.92,
  "93244": -5,
  "93245": 4.81,
  "93247": -5.52,
  "93249": -2.61,
  "93250": -5.52,
  "93251": 3.68,
  "93252": 0.92,
  "93254": 1.53,
  "93255": 0.92,
  "93256": -5.52,
  "93257": -5.52,
  "93258": -6.04,
  "93260": 0.92,
  "93261": -6.04,
  "93262": -5,
  "93263": 0.92,
  "93265": 2.97,
  "93266": -4.2,
  "93267": -6.04,
  "93268": 0.92,
  "93270": -5.52,
  "93271": -5,
  "93272": -5.52,
  "93274": -5.52,
  "93275": -5.52,
  "93276": 0.92,
  "93277": -5,
  "93278": -5,
  "93279": -5,
  "93280": 0.92,
  "93282": -4.2,
  "93283": 0.92,
  "93285": 0.4,
  "93286": -5,
  "93287": 9.41,
  "93290": -5,
  "93291": -5,
  "93292": -5,
  "93301": 1.44,
  "93302": 1.44,
  "93303": 0.92,
  "93304": 0.92,
  "93305": 0.92,
  "93306": 0.92,
  "93307": 0.92,
  "93308": 0.92,
  "93309": 1.44,
  "93311": 1.44,
  "93312": 2.51,
  "93313": 1.44,
  "93314": 2.51,
  "93380": 0.92,
  "93383": 1.44,
  "93384": 1.44,
  "93385": 0.92,
  "93386": 0.92,
  "93387": 0.92,
  "93388": 1.44,
  "93389": 1.44,
  "93390": 0.92,
  "93401": 5.27,
  "93402": 4.75,
  "93403": 5.27,
  "93405": 5.27,
  "93406": 5.27,
  "93407": 5.27,
  "93410": 5.27,
  "93412": 4.75,
  "93420": 5.27,
  "93421": 5.27,
  "93422": 4.75,
  "93423": 4.75,
  "93424": 7.57,
  "93426": 5.27,
  "93427": 1.53,
  "93428": 15.54,
  "93429": 0.98,
  "93430": 7.57,
  "93432": 4.75,
  "93433": 4.75,
  "93434": 4.2,
  "93435": 15.54,
  "93436": 0.98,
  "93437": 0.98,
  "93438": 0.98,
  "93440": 1.53,
  "93441": 3.83,
  "93442": 5.27,
  "93443": 5.27,
  "93444": 6.34,
  "93445": 4.75,
  "93446": 5.27,
  "93447": 5.27,
  "93448": 5.27,
  "93449": 5.27,
  "93450": 4.75,
  "93451": 5.27,
  "93452": 7.57,
  "93453": 4.75,
  "93454": 1.53,
  "93455": 1.53,
  "93456": 4.75,
  "93457": 1.53,
  "93458": 4.75,
  "93460": 3.83,
  "93461": 4.75,
  "93463": 3.83,
  "93464": 3.83,
  "93465": 5.27,
  "93475": 4.75,
  "93483": 4.75,
  "93501": 0.92,
  "93502": 0.92,
  "93504": 0.92,
  "93505": 0.92,
  "93510": 14.93,
  "93512": -4.6,
  "93513": -0.86,
  "93514": -4.08,
  "93515": -4.08,
  "93516": 3.22,
  "93517": -4.08,
  "93518": 1.44,
  "93519": 0.92,
  "93522": 0.92,
  "93523": 0.4,
  "93526": -1.38,
  "93527": 0.4,
  "93528": 0.4,
  "93529": -3.01,
  "93530": -1.9,
  "93531": 9.41,
  "93532": 6.44,
  "93534": 6.44,
  "93535": 6.44,
  "93536": 6.44,
  "93539": 6.44,
  "93541": -4.6,
  "93542": 0.4,
  "93543": 6.44,
  "93544": 6.44,
  "93545": -1.38,
  "93546": 3.89,
  "93549": -1.9,
  "93550": 6.44,
  "93551": 6.44,
  "93552": 6.44,
  "93553": 6.44,
  "93554": 0.4,
  "93555": 0.92,
  "93556": 0.92,
  "93558": 0.4,
  "93560": 0.92,
  "93561": 1.44,
  "93562": -1.9,
  "93563": 6.44,
  "93581": 1.44,
  "93584": 6.44,
  "93586": 6.44,
  "93590": 6.44,
  "93591": 6.44,
  "93592": -1.9,
  "93596": 3.22,
  "93601": -4.6,
  "93602": -3.22,
  "93603": -5,
  "93604": -3.22,
  "93605": -3.22,
  "93606": 0.86,
  "93607": 1.38,
  "93608": 0.86,
  "93609": 1.38,
  "93610": -3.74,
  "93611": 1.38,
  "93612": 1.38,
  "93613": 1.38,
  "93614": -3.22,
  "93615": -5,
  "93616": 0.86,
  "93618": -5,
  "93619": 1.38,
  "93620": -6.44,
  "93621": -5,
  "93622": -6.96,
  "93623": 6.19,
  "93624": 1.38,
  "93625": 1.38,
  "93626": -3.22,
  "93627": 12.17,
  "93628": -5.52,
  "93630": 0.86,
  "93631": 1.9,
  "93633": -5,
  "93634": -4.6,
  "93635": -5.92,
  "93636": -3.74,
  "93637": -3.74,
  "93638": -3.74,
  "93639": -3.22,
  "93640": 0.86,
  "93641": -5.52,
  "93642": -4.6,
  "93643": -3.22,
  "93644": -4.6,
  "93645": -1.63,
  "93646": -5.52,
  "93647": -5,
  "93648": 0.86,
  "93649": -3.22,
  "93650": 0.86,
  "93651": -3.22,
  "93652": 1.38,
  "93653": -3.22,
  "93654": 1.9,
  "93656": 1.38,
  "93657": 1.38,
  "93660": 1.38,
  "93661": -6.44,
  "93662": 1.38,
  "93664": 5.27,
  "93665": -6.44,
  "93666": -5.52,
  "93667": -3.22,
  "93668": 0.86,
  "93669": -3.22,
  "93670": -5,
  "93673": -5.52,
  "93675": -5.52,
  "93701": 0.86,
  "93702": 0.86,
  "93703": 0.86,
  "93704": 1.38,
  "93705": 0.86,
  "93706": 0.86,
  "93707": 0.86,
  "93708": 0.86,
  "93709": 0.86,
  "93710": 1.38,
  "93711": 1.38,
  "93712": 0.86,
  "93714": 0.86,
  "93715": 0.86,
  "93716": 0.86,
  "93717": 0.86,
  "93718": 0.86,
  "93720": 1.38,
  "93721": 0.86,
  "93722": 1.38,
  "93723": 1.38,
  "93725": 0.86,
  "93726": 1.38,
  "93727": 1.38,
  "93728": 0.86,
  "93729": 1.38,
  "93730": 1.38,
  "93744": 0.86,
  "93745": 0.86,
  "93747": 1.38,
  "93755": 1.38,
  "93771": 0.86,
  "93772": 0.86,
  "93773": 0.86,
  "93774": 0.86,
  "93775": 0.86,
  "93776": 0.86,
  "93777": 0.86,
  "93778": 0.86,
  "93779": 0.86,
  "93790": 0.86,
  "93791": 0.86,
  "93792": 0.86,
  "93793": 0.86,
  "93794": 0.86,
  "93901": 1.99,
  "93902": 1.99,
  "93905": 1.99,
  "93906": 1.99,
  "93907": 3.89,
  "93908": 13.3,
  "93912": 3.89,
  "93915": 1.99,
  "93920": 5.33,
  "93921": 4.81,
  "93922": 4.81,
  "93923": 4.81,
  "93924": 4.81,
  "93925": 4.81,
  "93926": 1.99,
  "93927": 1.99,
  "93928": 2.51,
  "93930": 1.99,
  "93932": 2.51,
  "93933": 1.99,
  "93940": 4.81,
  "93942": 4.81,
  "93943": 2.51,
  "93944": 2.51,
  "93950": 4.81,
  "93953": 4.81,
  "93954": 1.99,
  "93955": 2.51,
  "93960": 1.99,
  "93962": 1.99,
  "94002": 19.99,
  "94005": 27.35,
  "94010": 28.48,
  "94011": 28.48,
  "94014": 27.35,
  "94015": 27.35,
  "94016": 27.35,
  "94017": 27.35,
  "94018": 19.99,
  "94019": 19.99,
  "94020": 31.03,
  "94021": 19.99,
  "94022": 32.62,
  "94023": 32.62,
  "94024": 39.52,
  "94025": 19.99,
  "94026": 19.99,
  "94027": 21.58,
  "94028": 21.58,
  "94030": 19.99,
  "94035": 31.03,
  "94037": 19.99,
  "94038": 19.99,
  "94039": 31.03,
  "94040": 31.03,
  "94041": 31.03,
  "94042": 31.03,
  "94043": 31.03,
  "94044": 19.99,
  "94060": 19.99,
  "94061": 19.99,
  "94062": 19.99,
  "94063": 19.99,
  "94064": 19.99,
  "94065": 19.99,
  "94066": 19.99,
  "94070": 19.99,
  "94074": 20.51,
  "94080": 27.35,
  "94083": 27.35,
  "94085": 31.03,
  "94086": 31.03,
  "94087": 31.03,
  "94088": 31.03,
  "94089": 28.21,
  "94101": 27.35,
  "94102": 27.35,
  "94103": 27.35,
  "94104": 27.35,
  "94105": 27.35,
  "94107": 27.35,
  "94108": 27.35,
  "94109": 27.35,
  "94110": 27.35,
  "94111": 27.35,
  "94112": 27.35,
  "94114": 27.35,
  "94115": 27.87,
  "94116": 27.35,
  "94117": 27.35,
  "94118": 27.35,
  "94119": 27.35,
  "94120": 27.35,
  "94121": 27.35,
  "94122": 27.35,
  "94123": 35.84,
  "94124": 26.83,
  "94125": 26.83,
  "94126": 27.35,
  "94127": 27.35,
  "94128": 19.99,
  "94129": 35.84,
  "94130": 27.35,
  "94131": 27.35,
  "94132": 27.35,
  "94133": 27.87,
  "94134": 27.35,
  "94140": 27.35,
  "94141": 27.35,
  "94142": 27.35,
  "94146": 27.35,
  "94147": 35.84,
  "94158": 27.35,
  "94159": 27.35,
  "94164": 27.35,
  "94172": 27.35,
  "94188": 26.83,
  "94203": 7.42,
  "94204": 7.42,
  "94205": 7.42,
  "94206": 7.42,
  "94207": 7.42,
  "94208": 7.42,
  "94209": 7.42,
  "94211": 7.42,
  "94229": 7.42,
  "94230": 7.42,
  "94232": 7.97,
  "94234": 7.42,
  "94235": 7.42,
  "94236": 7.42,
  "94237": 7.42,
  "94239": 7.97,
  "94240": 7.42,
  "94244": 7.42,
  "94245": 7.42,
  "94246": 7.42,
  "94247": 7.42,
  "94248": 7.42,
  "94249": 7.97,
  "94250": 7.42,
  "94252": 7.42,
  "94254": 7.42,
  "94256": 7.42,
  "94257": 7.42,
  "94258": 7.42,
  "94259": 7.97,
  "94261": 7.42,
  "94262": 7.42,
  "94263": 7.42,
  "94267": 7.42,
  "94268": 7.42,
  "94269": 7.97,
  "94271": 7.42,
  "94273": 7.42,
  "94274": 7.42,
  "94277": 7.42,
  "94278": 7.97,
  "94279": 7.42,
  "94280": 7.42,
  "94282": 7.42,
  "94283": 7.42,
  "94284": 7.97,
  "94285": 7.97,
  "94286": 7.97,
  "94287": 7.42,
  "94288": 7.42,
  "94289": 7.42,
  "94290": 7.97,
  "94291": 7.97,
  "94293": 7.97,
  "94294": 7.97,
  "94295": 7.42,
  "94296": 7.42,
  "94297": 7.97,
  "94298": 7.42,
  "94301": 21.58,
  "94302": 21.58,
  "94303": 19.99,
  "94304": 21.58,
  "94305": 19.99,
  "94306": 19.99,
  "94309": 19.99,
  "94401": 21.58,
  "94402": 19.99,
  "94403": 19.99,
  "94404": 19.99,
  "94501": 19.99,
  "94502": 21.58,
  "94503": 14.87,
  "94505": 15.45,
  "94506": 28.48,
  "94507": 24.34,
  "94508": 14.47,
  "94509": 13.55,
  "94510": 13.55,
  "94511": 4.66,
  "94512": 25.66,
  "94513": 20.97,
  "94514": 15.45,
  "94515": 7.57,
  "94516": 19.99,
  "94517": 15.85,
  "94518": 13.55,
  "94519": 13.03,
  "94520": 13.03,
  "94521": 13.55,
  "94522": 13.03,
  "94523": 15.85,
  "94524": 13.03,
  "94525": 13.03,
  "94526": 19.99,
  "94527": 13.03,
  "94528": 19.99,
  "94530": 27.35,
  "94531": 13.55,
  "94533": 14.87,
  "94534": 14.87,
  "94535": 14.87,
  "94536": 19.99,
  "94537": 19.99,
  "94538": 19.99,
  "94539": 31.03,
  "94540": 17.69,
  "94541": 17.69,
  "94542": 19.99,
  "94543": 17.69,
  "94544": 17.69,
  "94545": 17.69,
  "94546": 19.99,
  "94547": 13.55,
  "94548": 12.48,
  "94549": 17.44,
  "94550": 19.47,
  "94551": 19.47,
  "94552": 19.99,
  "94553": 13.03,
  "94555": 19.99,
  "94556": 15.85,
  "94557": 17.69,
  "94558": 12.17,
  "94559": 11.65,
  "94560": 19.99,
  "94561": 12.48,
  "94562": 12.17,
  "94563": 24.34,
  "94564": 13.03,
  "94565": 13.03,
  "94566": 19.99,
  "94567": 11.65,
  "94568": 19.99,
  "94569": 14.62,
  "94570": 13.55,
  "94571": 14.87,
  "94572": 13.03,
  "94573": 16.06,
  "94574": 16.06,
  "94575": 15.85,
  "94576": 16.06,
  "94577": 17.69,
  "94578": 17.17,
  "94579": 17.69,
  "94580": 17.69,
  "94581": 11.65,
  "94582": 19.99,
  "94583": 19.99,
  "94585": 14.87,
  "94586": 19.99,
  "94587": 19.99,
  "94588": 19.99,
  "94589": 14.87,
  "94590": 14.87,
  "94591": 14.87,
  "94592": 16.46,
  "94595": 15.85,
  "94596": 15.85,
  "94597": 15.85,
  "94598": 15.85,
  "94599": 12.17,
  "94601": 17.17,
  "94602": 19.99,
  "94603": 17.17,
  "94604": 24.53,
  "94605": 17.17,
  "94606": 17.17,
  "94607": 24.53,
  "94608": 25.05,
  "94609": 25.05,
  "94610": 19.99,
  "94611": 19.99,
  "94612": 24.53,
  "94613": 19.99,
  "94614": 17.17,
  "94615": 24.53,
  "94617": 17.17,
  "94618": 19.99,
  "94619": 19.99,
  "94620": 17.17,
  "94621": 17.17,
  "94623": 24.53,
  "94624": 17.17,
  "94661": 19.99,
  "94662": 25.05,
  "94701": 27.35,
  "94702": 25.05,
  "94703": 27.35,
  "94704": 15.85,
  "94705": 17.44,
  "94706": 27.35,
  "94707": 15.85,
  "94708": 15.85,
  "94709": 15.85,
  "94710": 25.05,
  "94712": 15.85,
  "94801": 11.19,
  "94802": 11.19,
  "94803": 13.55,
  "94804": 24.53,
  "94805": 25.05,
  "94806": 11.19,
  "94807": 24.53,
  "94808": 24.53,
  "94820": 13.55,
  "94850": 11.19,
  "94901": 14.01,
  "94903": 14.01,
  "94904": 14.53,
  "94912": 14.01,
  "94913": 14.01,
  "94914": 14.53,
  "94915": 14.01,
  "94920": 22.5,
  "94922": 9.87,
  "94923": 9.87,
  "94924": 14.01,
  "94925": 14.01,
  "94927": 7.57,
  "94928": 7.57,
  "94929": 9.87,
  "94930": 14.01,
  "94931": 7.05,
  "94933": 14.01,
  "94937": 14.01,
  "94938": 13.49,
  "94939": 14.01,
  "94940": 18.36,
  "94941": 14.01,
  "94942": 14.01,
  "94945": 14.01,
  "94946": 22.5,
  "94947": 14.01,
  "94948": 14.01,
  "94949": 14.01,
  "94950": 14.01,
  "94951": 9.87,
  "94952": 9.35,
  "94953": 7.05,
  "94954": 7.05,
  "94955": 7.05,
  "94956": 14.01,
  "94957": 14.53,
  "94960": 14.01,
  "94963": 14.01,
  "94964": 22.5,
  "94965": 27.35,
  "94966": 27.35,
  "94970": 22.5,
  "94971": 9.35,
  "94972": 18.36,
  "94973": 14.01,
  "94974": 14.53,
  "94975": 9.87,
  "94976": 14.01,
  "94977": 14.01,
  "94978": 14.01,
  "94979": 14.01,
  "94999": 9.87,
  "95001": 3.89,
  "95002": 28.73,
  "95003": 3.89,
  "95004": 3.89,
  "95005": 3.89,
  "95006": 3.89,
  "95007": 3.89,
  "95008": 31.03,
  "95009": 31.03,
  "95010": 3.89,
  "95011": 31.03,
  "95012": 1.07,
  "95013": 31.03,
  "95014": 31.55,
  "95015": 31.55,
  "95017": 3.89,
  "95018": 3.89,
  "95019": 1.07,
  "95020": 3.89,
  "95021": 3.89,
  "95023": 5.67,
  "95024": 5.67,
  "95026": 31.03,
  "95030": 31.03,
  "95031": 31.03,
  "95032": 32.62,
  "95033": 32.62,
  "95035": 31.03,
  "95036": 32.62,
  "95037": 31.03,
  "95038": 4.41,
  "95039": 1.07,
  "95041": 1.07,
  "95042": 31.55,
  "95043": 6.19,
  "95044": 31.03,
  "95045": 6.19,
  "95046": 4.41,
  "95050": 31.03,
  "95051": 31.03,
  "95052": 31.03,
  "95054": 31.03,
  "95055": 31.03,
  "95056": 31.03,
  "95060": 3.89,
  "95061": 4.41,
  "95062": 3.89,
  "95063": 3.89,
  "95064": 3.89,
  "95065": 4.41,
  "95066": 3.89,
  "95067": 4.41,
  "95070": 39.52,
  "95071": 39.52,
  "95073": 3.89,
  "95075": 5.67,
  "95076": 1.07,
  "95077": 1.59,
  "95101": 31.03,
  "95103": 31.03,
  "95106": 39.52,
  "95108": 39.52,
  "95109": 39.52,
  "95110": 31.03,
  "95111": 30.51,
  "95112": 31.03,
  "95113": 39.52,
  "95115": 31.03,
  "95116": 30.51,
  "95117": 31.03,
  "95118": 31.03,
  "95119": 31.03,
  "95120": 31.55,
  "95121": 31.03,
  "95122": 31.03,
  "95123": 31.03,
  "95124": 31.03,
  "95125": 31.03,
  "95126": 31.03,
  "95127": 31.03,
  "95128": 31.03,
  "95129": 31.55,
  "95130": 31.03,
  "95131": 31.03,
  "95132": 31.03,
  "95133": 31.03,
  "95134": 28.21,
  "95135": 31.03,
  "95136": 31.03,
  "95138": 31.03,
  "95139": 31.03,
  "95140": 31.03,
  "95141": 31.03,
  "95148": 31.03,
  "95150": 31.03,
  "95151": 31.03,
  "95152": 31.03,
  "95153": 31.03,
  "95154": 31.03,
  "95155": 31.03,
  "95156": 30.51,
  "95157": 31.03,
  "95158": 31.03,
  "95159": 31.03,
  "95160": 31.55,
  "95161": 31.03,
  "95164": 28.21,
  "95170": 31.55,
  "95172": 39.52,
  "95173": 39.52,
  "95201": 4.66,
  "95202": 4.66,
  "95203": 4.14,
  "95204": 4.66,
  "95205": 4.66,
  "95206": 4.66,
  "95207": 4.66,
  "95208": 4.66,
  "95209": 4.66,
  "95210": 4.66,
  "95212": 4.66,
  "95213": 4.66,
  "95215": 4.66,
  "95219": 4.66,
  "95220": 5.21,
  "95221": 6.5,
  "95222": 7.05,
  "95223": 6.5,
  "95224": 6.5,
  "95225": 6.5,
  "95226": -6.75,
  "95227": 16,
  "95228": 7.05,
  "95229": 8.09,
  "95230": 1.53,
  "95231": 4.66,
  "95232": -7.3,
  "95233": 8.09,
  "95234": 4.66,
  "95236": 5.21,
  "95237": 5.21,
  "95240": 4.66,
  "95241": 5.21,
  "95242": 5.21,
  "95245": 7.05,
  "95246": 7.05,
  "95247": 8.09,
  "95248": 7.05,
  "95249": 6.5,
  "95250": 7.05,
  "95251": 7.05,
  "95252": 7.05,
  "95253": 4.66,
  "95254": -6.75,
  "95255": -7.3,
  "95257": -7.3,
  "95258": 5.21,
  "95267": 4.66,
  "95269": 4.66,
  "95301": -6.44,
  "95303": 2.57,
  "95304": 4.66,
  "95305": 1.38,
  "95306": -4.08,
  "95307": 0.98,
  "95309": 1.9,
  "95310": 1.9,
  "95311": -4.6,
  "95312": -6.44,
  "95313": 2.57,
  "95314": 2.45,
  "95315": -5.92,
  "95316": 0.98,
  "95317": -6.44,
  "95318": -4.6,
  "95319": 0.98,
  "95320": 1.53,
  "95321": 2.97,
  "95322": -5.92,
  "95323": 1.53,
  "95324": 0.98,
  "95325": -4.6,
  "95326": 0.98,
  "95327": 1.9,
  "95328": 0.98,
  "95329": 2.45,
  "95330": 4.66,
  "95333": -3.22,
  "95334": -5.92,
  "95335": 1.9,
  "95336": 4.66,
  "95337": 4.66,
  "95338": -4.08,
  "95340": -6.44,
  "95341": -6.44,
  "95343": -6.44,
  "95344": -6.44,
  "95345": -4.08,
  "95346": 1.9,
  "95347": 1.38,
  "95348": -6.44,
  "95350": 0.98,
  "95351": 0.98,
  "95352": 0.98,
  "95353": 0.98,
  "95354": 0.98,
  "95355": 0.98,
  "95356": 0.98,
  "95357": 0.98,
  "95358": 0.98,
  "95360": -5.92,
  "95361": 0.98,
  "95363": 0.98,
  "95364": 2.45,
  "95365": -6.44,
  "95366": 1.53,
  "95367": 0.98,
  "95368": 0.98,
  "95369": -6.44,
  "95370": 1.9,
  "95372": 1.9,
  "95373": 1.9,
  "95374": -5.37,
  "95375": 1.9,
  "95376": 4.66,
  "95377": 4.66,
  "95378": 15.45,
  "95379": 1.9,
  "95380": 0.98,
  "95381": 0.98,
  "95382": 1.53,
  "95383": 2.45,
  "95385": 0.98,
  "95386": 0.98,
  "95387": 0.98,
  "95388": -6.44,
  "95389": 3.89,
  "95391": 15.45,
  "95401": 7.57,
  "95402": 7.57,
  "95403": 7.57,
  "95404": 9.87,
  "95405": 7.57,
  "95406": 7.57,
  "95407": 7.57,
  "95409": 7.57,
  "95410": -2.09,
  "95412": 7.57,
  "95415": -2.61,
  "95416": 13.95,
  "95417": -3.16,
  "95418": -2.61,
  "95419": 7.05,
  "95420": -2.09,
  "95421": 7.57,
  "95422": -3.07,
  "95423": -3.07,
  "95424": -3.07,
  "95425": -2.55,
  "95426": -3.07,
  "95427": -2.09,
  "95428": -3.16,
  "95429": -2.61,
  "95430": 9.87,
  "95431": 14.47,
  "95432": 8.7,
  "95433": 13.95,
  "95435": -3.07,
  "95436": 7.57,
  "95437": -2.61,
  "95439": 7.57,
  "95441": 9.87,
  "95442": 14.47,
  "95443": -3.07,
  "95444": 7.05,
  "95445": -2.09,
  "95446": 7.57,
  "95448": 9.87,
  "95449": -3.07,
  "95450": 9.87,
  "95451": -3.07,
  "95452": 9.87,
  "95453": -3.07,
  "95454": -3.16,
  "95456": -2.09,
  "95457": -3.07,
  "95458": -3.07,
  "95459": -2.09,
  "95460": 0.21,
  "95461": -3.07,
  "95462": 7.05,
  "95463": -2.09,
  "95464": -3.07,
  "95465": 9.87,
  "95466": 0.21,
  "95467": -3.07,
  "95468": -2.09,
  "95469": -2.61,
  "95470": -2.09,
  "95471": 7.05,
  "95472": 9.87,
  "95473": 9.87,
  "95476": 13.95,
  "95480": 18.36,
  "95481": -2.61,
  "95482": -2.61,
  "95485": -3.07,
  "95486": 7.05,
  "95487": 13.95,
  "95488": 7.63,
  "95490": -2.61,
  "95492": 7.57,
  "95493": -3.07,
  "95494": -2.55,
  "95497": 9.87,
  "95501": 3.28,
  "95502": 3.28,
  "95503": 3.28,
  "95511": 6.5,
  "95514": 3.83,
  "95518": 3.28,
  "95519": 3.28,
  "95521": 3.28,
  "95524": 3.83,
  "95525": 3.28,
  "95526": 6.5,
  "95527": 6.5,
  "95528": 3.28,
  "95531": -10.52,
  "95534": 3.28,
  "95536": 3.83,
  "95537": 3.28,
  "95538": -10.52,
  "95540": 3.28,
  "95542": 3.28,
  "95543": -9.97,
  "95545": 3.28,
  "95546": 3.28,
  "95547": 3.28,
  "95548": -10.52,
  "95549": 3.83,
  "95550": 14.07,
  "95551": 3.28,
  "95552": 6.5,
  "95553": 3.28,
  "95554": 3.28,
  "95555": -9.97,
  "95556": -9.97,
  "95558": 3.28,
  "95559": 3.28,
  "95560": 3.28,
  "95562": 3.28,
  "95563": 3.28,
  "95564": 3.28,
  "95565": 3.28,
  "95567": -10.52,
  "95568": -9.45,
  "95569": 3.28,
  "95570": 3.83,
  "95571": 3.28,
  "95573": 3.28,
  "95585": -3.16,
  "95587": -3.68,
  "95589": 3.83,
  "95595": 6.5,
  "95601": -6.75,
  "95602": 14.99,
  "95603": 7.05,
  "95604": 7.05,
  "95605": 7.42,
  "95606": 11.19,
  "95607": 11.19,
  "95608": 7.42,
  "95609": 7.42,
  "95610": 7.42,
  "95611": 7.42,
  "95612": 7.97,
  "95613": 6.5,
  "95614": 7.05,
  "95615": 7.97,
  "95616": 11.71,
  "95617": 11.71,
  "95618": 11.71,
  "95619": 3.74,
  "95620": 11.19,
  "95621": 7.42,
  "95623": 3.74,
  "95624": 9.01,
  "95625": 14.87,
  "95626": 7.42,
  "95627": 10.64,
  "95628": 7.97,
  "95629": -6.75,
  "95630": 7.97,
  "95631": 6.5,
  "95632": 7.97,
  "95633": 6.5,
  "95634": 6.5,
  "95635": 6.5,
  "95636": 3.74,
  "95637": -3.47,
  "95638": 7.97,
  "95639": 7.42,
  "95640": -6.75,
  "95641": 4.66,
  "95642": -6.75,
  "95644": -6.75,
  "95645": 11.19,
  "95646": 3.37,
  "95648": 6.5,
  "95650": 7.05,
  "95651": 6.5,
  "95652": 7.42,
  "95653": 10.64,
  "95654": -6.75,
  "95655": 7.42,
  "95656": -7.3,
  "95658": 14.99,
  "95659": 0.15,
  "95660": 7.42,
  "95661": 7.97,
  "95662": 7.42,
  "95663": 8.09,
  "95664": 7.05,
  "95665": -6.75,
  "95666": -7.3,
  "95667": 3.74,
  "95668": 0.15,
  "95669": -6.75,
  "95670": 7.42,
  "95672": 7.05,
  "95673": 7.42,
  "95674": -0.4,
  "95675": -7.3,
  "95676": -0.4,
  "95677": 7.42,
  "95678": 7.42,
  "95679": 11.19,
  "95680": 7.42,
  "95681": 2.36,
  "95682": -6.75,
  "95683": 7.97,
  "95684": 3.74,
  "95685": -6.75,
  "95686": 4.66,
  "95687": 14.87,
  "95688": 15.39,
  "95689": -6.75,
  "95690": 7.42,
  "95691": 7.42,
  "95692": 2.36,
  "95693": 9.01,
  "95694": 11.19,
  "95695": 11.19,
  "95696": 14.87,
  "95697": 11.19,
  "95698": 11.19,
  "95699": -6.75,
  "95701": 0.06,
  "95703": 8.09,
  "95709": 3.74,
  "95712": 0.06,
  "95713": 6.5,
  "95714": 1.65,
  "95715": 1.65,
  "95717": 0.06,
  "95720": 4.29,
  "95721": 3.37,
  "95722": 14.99,
  "95724": 0.61,
  "95726": 3.74,
  "95728": 0.61,
  "95735": 6.59,
  "95736": 5.98,
  "95741": 7.42,
  "95742": 7.42,
  "95746": 18.21,
  "95747": 7.97,
  "95757": 7.42,
  "95758": 7.42,
  "95759": 7.42,
  "95762": 15.91,
  "95763": 7.97,
  "95765": 7.97,
  "95776": 11.19,
  "95798": 7.42,
  "95799": 7.42,
  "95811": 7.42,
  "95812": 7.42,
  "95813": 7.42,
  "95814": 7.42,
  "95815": 7.42,
  "95816": 7.97,
  "95817": 7.42,
  "95818": 7.97,
  "95819": 7.97,
  "95820": 7.42,
  "95821": 7.42,
  "95822": 7.42,
  "95823": 7.42,
  "95824": 7.42,
  "95825": 7.42,
  "95826": 7.42,
  "95827": 7.42,
  "95828": 7.42,
  "95829": 7.42,
  "95830": 15.91,
  "95831": 7.42,
  "95832": 7.42,
  "95833": 7.42,
  "95834": 7.42,
  "95835": 7.97,
  "95836": 7.97,
  "95837": 21.98,
  "95838": 7.42,
  "95841": 7.42,
  "95842": 7.42,
  "95843": 7.42,
  "95851": 7.42,
  "95852": 7.42,
  "95853": 7.42,
  "95860": 7.42,
  "95864": 7.97,
  "95865": 7.42,
  "95866": 7.42,
  "95899": 7.42,
  "95901": 1.84,
  "95903": 1.84,
  "95910": 0.61,
  "95912": -4.54,
  "95913": -6.75,
  "95914": 2.36,
  "95915": -5.06,
  "95916": 2.82,
  "95917": 2.3,
  "95918": 2.36,
  "95919": 2.36,
  "95920": -3.99,
  "95922": 0.06,
  "95923": -5.06,
  "95924": 0.06,
  "95925": 2.36,
  "95926": 3.37,
  "95927": 3.37,
  "95928": 3.37,
  "95930": 2.82,
  "95932": -4.54,
  "95934": -4.54,
  "95935": 2.36,
  "95936": 0.06,
  "95937": -4.54,
  "95938": 11.86,
  "95939": -7.3,
  "95940": 2.82,
  "95941": 2.82,
  "95942": 11.31,
  "95943": -6.75,
  "95944": 0.06,
  "95945": 0.06,
  "95946": 3.95,
  "95947": -5.06,
  "95948": 2.36,
  "95949": 6.5,
  "95950": -0.4,
  "95951": -7.3,
  "95953": -0.92,
  "95954": 2.82,
  "95955": -5.06,
  "95956": -4.54,
  "95957": -0.92,
  "95958": 2.82,
  "95959": 1.65,
  "95960": 0.06,
  "95961": -0.92,
  "95962": 2.36,
  "95963": -6.75,
  "95965": 2.3,
  "95966": 2.82,
  "95967": 2.82,
  "95968": 2.3,
  "95969": 2.82,
  "95970": -2.4,
  "95971": -4.54,
  "95972": 2.36,
  "95973": 3.37,
  "95974": 2.82,
  "95975": 2.36,
  "95977": 2.36,
  "95978": 2.3,
  "95979": -4.54,
  "95980": 2.3,
  "95981": 2.82,
  "95982": -0.4,
  "95983": -4.54,
  "95984": -5.06,
  "95986": -0.46,
  "95987": -4.54,
  "95988": -6.75,
  "95991": -0.92,
  "95992": -0.92,
  "95993": -0.4,
  "96001": 1.44,
  "96002": 1.44,
  "96003": 1.44,
  "96006": -4.08,
  "96007": 1.44,
  "96008": 1.44,
  "96009": -4.6,
  "96010": 6.5,
  "96011": 1.44,
  "96013": 1.44,
  "96014": -4.54,
  "96015": -4.6,
  "96016": 1.44,
  "96017": 1.44,
  "96019": 1.44,
  "96020": -4.54,
  "96021": 14.78,
  "96022": 14.78,
  "96023": -3.99,
  "96024": 6.5,
  "96025": -4.54,
  "96027": -3.47,
  "96028": 1.44,
  "96029": -6.75,
  "96031": 6.5,
  "96032": -3.47,
  "96033": 6.5,
  "96034": -3.99,
  "96035": 14.78,
  "96037": -3.47,
  "96038": -3.47,
  "96039": -9.97,
  "96040": 1.44,
  "96041": 6.5,
  "96044": -3.99,
  "96046": 6.5,
  "96047": 6.5,
  "96048": 6.5,
  "96049": 1.44,
  "96050": -3.47,
  "96051": 1.44,
  "96052": 6.5,
  "96054": -4.6,
  "96055": 15.33,
  "96056": -4.08,
  "96057": -4.54,
  "96058": -3.99,
  "96059": 1.44,
  "96061": -2.95,
  "96062": 1.99,
  "96063": 14.78,
  "96064": -3.99,
  "96065": 1.44,
  "96067": -4.54,
  "96068": -4.08,
  "96069": 1.44,
  "96070": 1.44,
  "96071": 1.44,
  "96073": 1.44,
  "96074": -7.3,
  "96075": 14.26,
  "96076": 6.5,
  "96078": 14.78,
  "96079": 1.44,
  "96080": 14.78,
  "96084": 1.44,
  "96085": -3.47,
  "96086": -9.45,
  "96087": 1.44,
  "96088": 1.44,
  "96089": 1.44,
  "96090": 14.78,
  "96091": 6.5,
  "96092": 15.33,
  "96093": 6.5,
  "96094": -3.47,
  "96095": 6.5,
  "96096": 1.44,
  "96097": -3.47,
  "96099": 1.44,
  "96101": -4.6,
  "96103": -3.99,
  "96104": -4.08,
  "96105": 4.75,
  "96106": -3.99,
  "96107": 3.37,
  "96108": -1.42,
  "96109": 4.75,
  "96110": -3.53,
  "96111": 1.53,
  "96112": -3.53,
  "96113": -4.54,
  "96114": -3.99,
  "96115": -3.53,
  "96116": -3.53,
  "96117": -3.99,
  "96118": 4.75,
  "96119": -4.6,
  "96120": 3.37,
  "96121": -3.99,
  "96122": -3.99,
  "96123": -3.53,
  "96124": -3.99,
  "96125": 0.61,
  "96126": 0.61,
  "96127": -4.54,
  "96128": -3.99,
  "96129": -3.99,
  "96130": -4.54,
  "96132": -4.6,
  "96133": 3.37,
  "96134": -3.53,
  "96135": 4.75,
  "96136": -4.54,
  "96137": -4.54,
  "96140": 3.83,
  "96141": 5.42,
  "96142": 1.53,
  "96143": 1.53,
  "96145": 5.42,
  "96146": 5.42,
  "96148": 1.53,
  "96150": 3.37,
  "96151": 3.37,
  "96152": 3.37,
  "96154": 3.37,
  "96155": 1.53,
  "96156": 3.37,
  "96157": 3.37,
  "96158": 3.37,
  "96160": 1.53,
  "96161": 1.53,
  "96162": 0.61,
  "96701": 22.82,
  "96703": 11.69,
  "96704": 10.4,
  "96705": 12.24,
  "96706": 20.52,
  "96707": 20.52,
  "96708": 19.14,
  "96709": 20.52,
  "96710": 12.7,
  "96712": 20.52,
  "96713": 19.14,
  "96714": 14.54,
  "96715": 12.24,
  "96716": 12.24,
  "96717": 20.52,
  "96718": 9.85,
  "96719": 10.4,
  "96720": 9.85,
  "96721": 9.85,
  "96722": 14.54,
  "96725": 10.4,
  "96726": 10.4,
  "96727": 9.85,
  "96728": 12.7,
  "96729": 16.29,
  "96730": 22.82,
  "96731": 20.52,
  "96732": 16.84,
  "96733": 16.84,
  "96734": 22.82,
  "96737": 9.85,
  "96738": 10.4,
  "96739": 10.4,
  "96740": 10.4,
  "96741": 14.54,
  "96742": 16.29,
  "96743": 10.4,
  "96744": 22.82,
  "96745": 10.4,
  "96746": 12.24,
  "96747": 11.69,
  "96748": 16.29,
  "96749": 9.85,
  "96750": 10.4,
  "96751": 11.69,
  "96752": 12.24,
  "96753": 16.84,
  "96754": 12.24,
  "96755": 10.4,
  "96756": 14.54,
  "96757": 16.29,
  "96759": 19.97,
  "96760": 9.85,
  "96761": 28.94,
  "96762": 22.82,
  "96763": 16.29,
  "96764": 9.85,
  "96765": 14.54,
  "96766": 12.24,
  "96767": 28.94,
  "96768": 19.14,
  "96769": 23.03,
  "96770": 16.84,
  "96771": 9.85,
  "96772": 9.85,
  "96773": 10.4,
  "96774": 9.85,
  "96776": 9.85,
  "96777": 9.85,
  "96778": 9.85,
  "96779": 16.84,
  "96780": 10.4,
  "96781": 12.7,
  "96782": 22.82,
  "96783": 9.85,
  "96784": 20.73,
  "96785": 9.85,
  "96786": 20.52,
  "96788": 19.14,
  "96789": 22.82,
  "96790": 20.73,
  "96791": 20.52,
  "96792": 19.97,
  "96793": 16.84,
  "96795": 20.52,
  "96796": 23.03,
  "96797": 20.52,
  "96801": 22.82,
  "96802": 20.52,
  "96803": 20.52,
  "96804": 20.52,
  "96805": 20.52,
  "96806": 20.52,
  "96807": 20.52,
  "96808": 20.52,
  "96809": 20.52,
  "96810": 20.52,
  "96811": 22.82,
  "96812": 20.52,
  "96813": 20.52,
  "96814": 20.52,
  "96815": 20.52,
  "96816": 24.41,
  "96817": 22.82,
  "96818": 20.52,
  "96819": 22.82,
  "96820": 22.82,
  "96821": 31.31,
  "96822": 22.82,
  "96823": 20.52,
  "96824": 31.31,
  "96825": 22.82,
  "96826": 20.52,
  "96827": 20.52,
  "96828": 20.52,
  "96830": 20.52,
  "96836": 20.52,
  "96837": 20.52,
  "96838": 22.82,
  "96839": 22.82,
  "96850": 20.52,
  "96853": 20.52,
  "96854": 20.52,
  "96857": 20.52,
  "96858": 22.82,
  "96859": 22.82,
  "96860": 20.52,
  "96861": 22.82,
  "96863": 22.82,
  "96898": 20.52,
  "97001": -4.45,
  "97002": 4.29,
  "97004": 4.81,
  "97005": 7.97,
  "97006": 7.97,
  "97007": 7.97,
  "97008": 7.97,
  "97009": 4.81,
  "97010": 16.71,
  "97011": 4.29,
  "97013": 4.29,
  "97014": -4.08,
  "97015": 4.29,
  "97016": -1.78,
  "97017": 4.81,
  "97018": -1.23,
  "97019": 16.71,
  "97020": 3.74,
  "97021": 0.52,
  "97022": 4.81,
  "97023": 4.29,
  "97024": 16.71,
  "97026": 0.15,
  "97027": 4.29,
  "97028": -1.94,
  "97029": 7.82,
  "97030": 16.71,
  "97031": -3.53,
  "97032": -0.4,
  "97033": 7.82,
  "97034": 27.5,
  "97035": 17.23,
  "97036": 27.5,
  "97037": 1.07,
  "97038": 4.29,
  "97039": 7.82,
  "97040": -3.53,
  "97041": -3.53,
  "97042": 4.81,
  "97044": -3.53,
  "97045": 4.29,
  "97048": -1.23,
  "97049": -3.53,
  "97050": 7.3,
  "97051": -1.23,
  "97053": -1.23,
  "97054": -1.23,
  "97055": 4.29,
  "97056": -1.23,
  "97057": -4.45,
  "97058": 0.52,
  "97060": 16.71,
  "97062": 8.49,
  "97063": 1.07,
  "97064": -1.23,
  "97065": 7.82,
  "97067": -3.53,
  "97068": 5.88,
  "97070": 4.81,
  "97071": -0.4,
  "97075": 7.97,
  "97076": 7.97,
  "97080": 16.71,
  "97086": 4.29,
  "97089": 4.81,
  "97101": -0.31,
  "97102": 3.58,
  "97103": -5.46,
  "97106": 8.49,
  "97107": -5.46,
  "97108": -4.91,
  "97109": 8.49,
  "97110": 3.58,
  "97111": -0.31,
  "97112": -3.32,
  "97113": 7.97,
  "97114": -0.31,
  "97115": -0.31,
  "97116": 7.97,
  "97117": 8.49,
  "97118": -5.46,
  "97119": 8.49,
  "97121": -4.91,
  "97122": -5.46,
  "97123": 7.97,
  "97124": 7.97,
  "97125": 8.49,
  "97127": -0.86,
  "97128": -0.31,
  "97130": -4.39,
  "97131": -4.91,
  "97132": 7.97,
  "97133": 9.56,
  "97134": 5.88,
  "97135": -3.32,
  "97136": -4.91,
  "97137": -0.31,
  "97138": -4.91,
  "97140": 8.49,
  "97141": -5.46,
  "97143": 5.88,
  "97144": -1.23,
  "97145": 5.88,
  "97146": -5.46,
  "97147": -4.91,
  "97148": 8.18,
  "97149": -0.1,
  "97201": 27.5,
  "97202": 16.71,
  "97203": 16.71,
  "97204": 18.3,
  "97205": 17.23,
  "97206": 16.71,
  "97207": 17.23,
  "97208": 16.71,
  "97209": 17.23,
  "97210": 27.5,
  "97211": 16.71,
  "97212": 17.23,
  "97213": 16.71,
  "97214": 16.71,
  "97215": 16.71,
  "97216": 16.71,
  "97217": 16.71,
  "97218": 16.71,
  "97219": 17.23,
  "97220": 16.71,
  "97221": 18.3,
  "97222": 16.71,
  "97223": 7.97,
  "97224": 7.97,
  "97225": 8.49,
  "97227": 16.71,
  "97228": 17.23,
  "97229": 9.56,
  "97230": 16.71,
  "97231": 16.46,
  "97232": 17.23,
  "97233": 16.71,
  "97236": 16.71,
  "97238": 16.71,
  "97239": 27.5,
  "97240": 16.71,
  "97242": 16.71,
  "97258": 18.3,
  "97266": 16.71,
  "97267": 16.71,
  "97268": 16.71,
  "97269": 16.71,
  "97280": 17.23,
  "97281": 7.97,
  "97282": 16.71,
  "97283": 17.23,
  "97286": 16.71,
  "97290": 16.71,
  "97291": 27.5,
  "97292": 16.71,
  "97293": 16.71,
  "97294": 16.71,
  "97296": 9.56,
  "97298": 8.49,
  "97299": 17.23,
  "97301": -0.4,
  "97302": 0.15,
  "97303": -0.4,
  "97304": 0.15,
  "97305": -0.4,
  "97306": 0.15,
  "97307": -0.4,
  "97308": -0.4,
  "97309": -0.4,
  "97317": -0.4,
  "97321": -1.69,
  "97322": -1.69,
  "97324": -1.69,
  "97325": -0.4,
  "97326": -1.17,
  "97327": 1.99,
  "97329": 1.44,
  "97330": -1.17,
  "97331": -1.69,
  "97333": -1.69,
  "97335": 1.99,
  "97336": 1.99,
  "97338": -3.99,
  "97339": -1.69,
  "97341": -8.07,
  "97342": 1.44,
  "97343": -8.59,
  "97344": -4.54,
  "97345": 1.44,
  "97346": 1.44,
  "97347": -3.99,
  "97348": -1.69,
  "97350": 1.44,
  "97351": -4.54,
  "97352": 0.15,
  "97355": 1.99,
  "97357": -8.59,
  "97358": 0.15,
  "97360": 1.44,
  "97361": -3.99,
  "97362": -0.4,
  "97364": -8.07,
  "97365": -8.59,
  "97366": -8.59,
  "97367": -8.59,
  "97368": -9.14,
  "97369": -8.07,
  "97370": -1.69,
  "97371": -3.99,
  "97373": -0.4,
  "97374": 1.99,
  "97375": 0.15,
  "97376": -8.59,
  "97377": 6.8,
  "97378": -3.99,
  "97380": -8.59,
  "97381": 0.15,
  "97383": 0.15,
  "97384": 0.15,
  "97385": 0.15,
  "97386": 1.44,
  "97388": -8.07,
  "97389": -1.69,
  "97390": -0.1,
  "97391": -8.59,
  "97392": 0.15,
  "97394": -8.59,
  "97396": -0.86,
  "97401": -1.23,
  "97402": -1.23,
  "97403": 0.36,
  "97404": -1.23,
  "97405": -1.23,
  "97406": 1.74,
  "97407": -2.61,
  "97408": -1.23,
  "97409": -1.23,
  "97410": -9.97,
  "97411": -2.61,
  "97412": -1.69,
  "97413": 1.44,
  "97414": -3.16,
  "97415": -6.75,
  "97416": -7.21,
  "97417": -7.76,
  "97419": 7.26,
  "97420": -3.16,
  "97423": -2.61,
  "97424": -1.78,
  "97425": 2.36,
  "97426": -1.78,
  "97427": -2.3,
  "97429": -7.76,
  "97430": -1.69,
  "97431": -1.78,
  "97432": -7.76,
  "97434": -1.78,
  "97435": -1.23,
  "97436": -7.21,
  "97437": 0.36,
  "97438": -1.78,
  "97439": -8.59,
  "97440": -1.23,
  "97441": -3.16,
  "97442": -10.52,
  "97443": -7.76,
  "97444": -6.75,
  "97446": -1.23,
  "97447": -7.76,
  "97448": -1.23,
  "97449": -3.16,
  "97450": -1.57,
  "97451": -1.23,
  "97452": -1.78,
  "97453": -1.23,
  "97454": -1.78,
  "97455": -1.78,
  "97456": -1.69,
  "97457": -7.76,
  "97458": -2.61,
  "97459": -2.61,
  "97461": 7.26,
  "97462": -7.21,
  "97463": -2.3,
  "97464": -6.75,
  "97465": -7.3,
  "97466": -3.16,
  "97467": -3.16,
  "97469": -7.76,
  "97470": -7.21,
  "97471": -7.21,
  "97473": -2.61,
  "97476": -7.3,
  "97477": -1.78,
  "97478": -1.78,
  "97479": -7.76,
  "97480": -1.23,
  "97481": -7.76,
  "97482": -1.78,
  "97484": -4.08,
  "97486": -7.21,
  "97487": -1.23,
  "97488": 1.44,
  "97489": -1.78,
  "97490": -1.23,
  "97491": -6.75,
  "97492": -2.3,
  "97493": -2.61,
  "97494": -7.21,
  "97495": -7.21,
  "97496": -7.76,
  "97497": -10.52,
  "97498": -8.07,
  "97499": -7.76,
  "97501": -4.08,
  "97502": -3.53,
  "97503": -4.08,
  "97504": -2.49,
  "97520": 5.48,
  "97522": -4.08,
  "97523": -10.52,
  "97524": -3.53,
  "97525": -3.53,
  "97526": -9.97,
  "97527": -9.97,
  "97528": -9.97,
  "97530": 4.96,
  "97531": -10.52,
  "97532": -9.97,
  "97533": -9.97,
  "97534": -10.52,
  "97535": -4.08,
  "97536": -4.08,
  "97537": -9.97,
  "97538": -10.52,
  "97539": -3.53,
  "97540": -3.01,
  "97541": -3.53,
  "97543": -9.97,
  "97544": -9.97,
  "97601": -7.67,
  "97602": -7.67,
  "97603": -7.67,
  "97604": -7.15,
  "97620": -8.53,
  "97621": -7.67,
  "97622": -7.67,
  "97623": -7.15,
  "97624": -7.67,
  "97625": -7.67,
  "97626": -7.15,
  "97627": -7.15,
  "97630": -9.05,
  "97632": -7.15,
  "97633": -7.67,
  "97634": -7.15,
  "97635": -9.05,
  "97636": -9.05,
  "97637": -8.53,
  "97638": -9.05,
  "97639": -7.67,
  "97640": -8.53,
  "97641": -9.05,
  "97701": 2.36,
  "97702": 2.36,
  "97707": 2.36,
  "97708": 2.36,
  "97709": 2.36,
  "97710": -10.12,
  "97711": -4.45,
  "97712": 2.76,
  "97720": -8.8,
  "97721": -0.77,
  "97722": -0.77,
  "97730": 3.49,
  "97731": -8.22,
  "97732": -9.26,
  "97733": 1.84,
  "97734": -5.52,
  "97735": -9.6,
  "97736": -2.15,
  "97737": 1.84,
  "97738": -8.8,
  "97739": 1.84,
  "97741": -5,
  "97750": 3.28,
  "97751": 3.28,
  "97752": 14.07,
  "97753": 2.36,
  "97754": 2.76,
  "97756": 2.36,
  "97758": 2.24,
  "97759": -5,
  "97760": -5,
  "97761": -4.45,
  "97801": -1.32,
  "97810": -2.36,
  "97812": 15.7,
  "97813": -2.36,
  "97814": -12.48,
  "97817": -8.8,
  "97818": 20.7,
  "97819": -12.48,
  "97820": -8.28,
  "97823": 15.18,
  "97824": 0.15,
  "97825": -7.76,
  "97826": -1.84,
  "97827": -8.34,
  "97828": -5.83,
  "97830": 15.18,
  "97833": -11.44,
  "97834": -11.96,
  "97835": -1.84,
  "97836": 20.7,
  "97837": -11.96,
  "97838": -1.32,
  "97839": 21.22,
  "97840": -11.56,
  "97841": -8.34,
  "97842": 1.07,
  "97843": 21.22,
  "97844": 4.6,
  "97845": -8.28,
  "97846": -5.83,
  "97848": -8.28,
  "97850": -7.3,
  "97856": -8.28,
  "97857": -6.9,
  "97859": -1.84,
  "97861": 15.7,
  "97862": -6.96,
  "97864": -7.76,
  "97865": -8.28,
  "97867": -7.82,
  "97868": -1.84,
  "97869": -8.8,
  "97870": -12.48,
  "97873": -8.8,
  "97874": 15.7,
  "97875": -1.84,
  "97876": 0.15,
  "97877": -11.44,
  "97880": -1.84,
  "97882": 4.6,
  "97883": -7.82,
  "97884": -11.96,
  "97885": -7.42,
  "97886": -2.36,
  "97901": -8.74,
  "97902": -9.26,
  "97903": -12.48,
  "97904": -8.8,
  "97905": -12.48,
  "97906": -9.26,
  "97907": -12.48,
  "97908": -11.96,
  "97909": -12.48,
  "97910": -9.26,
  "97911": -8.74,
  "97913": -2.82,
  "97914": -2.82,
  "97917": -8.74,
  "97918": -2.82,
  "97920": 1.53,
  "98001": 5.21,
  "98002": 6.8,
  "98003": 5.21,
  "98004": 15.39,
  "98005": 15.39,
  "98006": 15.39,
  "98007": 13.09,
  "98008": 13.09,
  "98009": 15.39,
  "98010": 13.09,
  "98011": 13.09,
  "98012": 3.89,
  "98013": 23.36,
  "98014": 13.09,
  "98015": 15.39,
  "98019": 13.09,
  "98020": 6.19,
  "98021": 3.89,
  "98022": 5.21,
  "98023": 5.21,
  "98024": 13.09,
  "98025": 13.09,
  "98026": 3.89,
  "98027": 15.39,
  "98028": 15.39,
  "98029": 15.39,
  "98030": 13.09,
  "98031": 13.09,
  "98032": 12.57,
  "98033": 15.39,
  "98034": 13.09,
  "98035": 13.09,
  "98036": 3.37,
  "98037": 3.37,
  "98038": 13.09,
  "98039": 23.88,
  "98040": 23.88,
  "98041": 13.09,
  "98042": 13.09,
  "98043": 3.37,
  "98045": 13.09,
  "98046": 3.37,
  "98047": 5.21,
  "98050": 13.09,
  "98051": 13.09,
  "98052": 13.09,
  "98053": 15.39,
  "98054": 5.21,
  "98055": 12.57,
  "98056": 13.09,
  "98057": 12.57,
  "98058": 13.09,
  "98059": 13.09,
  "98061": 10.85,
  "98062": 13.09,
  "98063": 5.21,
  "98064": 12.57,
  "98065": 13.09,
  "98068": 2.05,
  "98070": 23.36,
  "98071": 6.8,
  "98072": 6.19,
  "98073": 13.09,
  "98074": 15.39,
  "98075": 15.39,
  "98077": 6.19,
  "98082": 3.89,
  "98083": 15.39,
  "98087": 3.37,
  "98089": 12.57,
  "98092": 6.8,
  "98093": 5.21,
  "98101": 15.39,
  "98102": 15.39,
  "98103": 15.39,
  "98104": 23.88,
  "98105": 16.98,
  "98106": 12.57,
  "98107": 15.39,
  "98108": 12.57,
  "98109": 15.39,
  "98110": 10.85,
  "98111": 15.39,
  "98112": 23.88,
  "98113": 15.39,
  "98114": 13.09,
  "98115": 15.39,
  "98116": 15.39,
  "98117": 15.39,
  "98118": 13.09,
  "98119": 16.98,
  "98121": 15.39,
  "98122": 15.39,
  "98124": 13.09,
  "98125": 13.09,
  "98126": 13.09,
  "98127": 23.88,
  "98131": 12.57,
  "98132": 12.57,
  "98133": 13.09,
  "98134": 13.09,
  "98136": 15.39,
  "98138": 12.57,
  "98139": 5.02,
  "98141": 15.39,
  "98144": 13.09,
  "98145": 16.98,
  "98146": 13.09,
  "98148": 12.57,
  "98154": 15.39,
  "98155": 13.09,
  "98158": 12.57,
  "98160": 3.43,
  "98161": 15.39,
  "98164": 15.39,
  "98165": 13.09,
  "98166": 13.09,
  "98168": 12.57,
  "98171": 23.88,
  "98174": 23.88,
  "98175": 13.09,
  "98177": 3.43,
  "98178": 12.57,
  "98188": 12.57,
  "98194": 23.88,
  "98198": 12.57,
  "98199": 5.02,
  "98201": 3.37,
  "98203": 3.37,
  "98204": 3.37,
  "98205": 3.37,
  "98206": 3.37,
  "98208": 3.37,
  "98213": 3.37,
  "98220": 6.59,
  "98221": -7.67,
  "98222": 3.12,
  "98223": 3.37,
  "98224": 3.37,
  "98225": 6.59,
  "98226": 6.59,
  "98227": 6.59,
  "98228": 6.59,
  "98229": 6.59,
  "98230": 6.59,
  "98231": 6.59,
  "98232": 7.97,
  "98233": 7.97,
  "98235": 7.42,
  "98236": 3.89,
  "98237": 7.97,
  "98238": 8.49,
  "98239": -4.91,
  "98240": 6.59,
  "98241": 3.37,
  "98243": 3.12,
  "98244": 6.59,
  "98245": -7.67,
  "98247": 6.59,
  "98248": 6.59,
  "98249": -4.91,
  "98250": -5.37,
  "98251": 3.37,
  "98252": 3.37,
  "98253": -4.39,
  "98255": 7.97,
  "98256": 3.37,
  "98257": 7.97,
  "98258": 3.37,
  "98259": -4.91,
  "98260": -4.39,
  "98261": -7.67,
  "98262": 6.59,
  "98263": 7.97,
  "98264": 6.59,
  "98266": 6.59,
  "98267": 7.97,
  "98270": 3.37,
  "98271": 3.37,
  "98272": 3.37,
  "98273": 7.97,
  "98274": 7.97,
  "98275": 4.96,
  "98276": 6.59,
  "98277": -4.91,
  "98279": -5.37,
  "98280": 3.12,
  "98281": -7.67,
  "98282": -4.39,
  "98283": 7.97,
  "98284": 7.97,
  "98286": 3.12,
  "98287": -4.91,
  "98288": 12.57,
  "98290": 3.89,
  "98291": 3.89,
  "98292": -4.91,
  "98293": 3.37,
  "98294": 3.37,
  "98295": 6.59,
  "98296": 4.96,
  "98297": -7.67,
  "98303": 5.21,
  "98304": -5.83,
  "98305": -5,
  "98310": 0.06,
  "98311": 0.06,
  "98312": 0.06,
  "98315": 10.85,
  "98320": 0.06,
  "98321": 5.21,
  "98322": 0.06,
  "98323": 5.21,
  "98324": -5,
  "98325": -4.91,
  "98326": -5,
  "98327": 12.78,
  "98328": 5.21,
  "98329": 0.06,
  "98330": -5.83,
  "98331": -5,
  "98332": 5.21,
  "98333": 16,
  "98335": 6.8,
  "98336": -5.83,
  "98337": 0.06,
  "98338": 5.21,
  "98339": -4.91,
  "98340": -4.91,
  "98342": 0.61,
  "98343": -5,
  "98344": 5.21,
  "98345": 10.85,
  "98346": 0.61,
  "98348": 5.21,
  "98349": -13.19,
  "98350": -5,
  "98351": -13.19,
  "98353": 0.61,
  "98354": 5.21,
  "98355": -5.83,
  "98356": -5.83,
  "98357": -5,
  "98358": 3.58,
  "98359": 0.06,
  "98360": 5.21,
  "98361": 5.06,
  "98362": -5,
  "98363": -5,
  "98364": 11.4,
  "98365": -4.39,
  "98366": 0.06,
  "98367": 0.06,
  "98368": -4.91,
  "98370": 0.61,
  "98371": 5.21,
  "98372": 5.21,
  "98373": 5.21,
  "98374": 5.21,
  "98375": 5.21,
  "98376": -5,
  "98377": -6.38,
  "98378": 0.06,
  "98380": 0.06,
  "98381": -4.45,
  "98382": -5,
  "98383": 0.06,
  "98384": 0.61,
  "98385": 5.21,
  "98386": 0.61,
  "98387": 5.21,
  "98388": 5.21,
  "98390": 5.21,
  "98391": 5.21,
  "98392": 0.06,
  "98393": 0.06,
  "98394": -13.19,
  "98395": 0.06,
  "98396": 5.21,
  "98397": -5.83,
  "98398": -5.83,
  "98401": 5.21,
  "98402": 5.21,
  "98403": 13.7,
  "98404": 4.66,
  "98405": 4.66,
  "98406": 5.21,
  "98407": 5.21,
  "98408": 4.66,
  "98409": 4.66,
  "98411": 4.66,
  "98412": 5.21,
  "98413": 4.66,
  "98415": 5.21,
  "98417": 4.66,
  "98418": 4.66,
  "98419": 4.66,
  "98421": 4.66,
  "98422": 5.21,
  "98424": 5.21,
  "98433": 4.66,
  "98438": 5.21,
  "98439": 4.66,
  "98442": 5.21,
  "98443": 5.21,
  "98444": 5.21,
  "98445": 5.21,
  "98446": 5.21,
  "98448": 5.21,
  "98464": 5.21,
  "98465": 5.21,
  "98466": 5.21,
  "98467": 5.21,
  "98490": 5.21,
  "98492": 4.66,
  "98496": 5.21,
  "98497": 5.21,
  "98498": 5.21,
  "98499": 5.21,
  "98501": 5.88,
  "98502": 12.78,
  "98503": 4.29,
  "98506": 4.29,
  "98507": 5.88,
  "98508": 5.88,
  "98509": 4.29,
  "98511": 5.88,
  "98512": 4.29,
  "98513": 4.29,
  "98516": 5.88,
  "98520": -0.86,
  "98522": -12.36,
  "98524": -13.19,
  "98526": -0.86,
  "98527": -11.9,
  "98528": -13.74,
  "98530": 3.74,
  "98531": -5.83,
  "98532": -5.83,
  "98533": -5.83,
  "98535": -0.86,
  "98536": -0.86,
  "98537": -0.86,
  "98538": -11.81,
  "98539": -12.36,
  "98540": 4.29,
  "98541": -0.31,
  "98542": -5.83,
  "98544": -5.83,
  "98546": -4.7,
  "98547": -11.9,
  "98548": -13.74,
  "98550": -0.86,
  "98552": -0.31,
  "98554": -11.9,
  "98555": -13.74,
  "98556": 4.29,
  "98557": -13.19,
  "98558": 4.29,
  "98559": -0.31,
  "98560": -13.19,
  "98561": -11.9,
  "98562": -0.31,
  "98563": -0.31,
  "98564": -5.83,
  "98565": -6.38,
  "98566": -0.86,
  "98568": 4.29,
  "98569": -0.31,
  "98570": -5.83,
  "98571": -0.86,
  "98572": -12.36,
  "98575": -0.31,
  "98576": 4.29,
  "98577": -11.9,
  "98579": 4.29,
  "98580": 5.21,
  "98581": -12.36,
  "98582": -5.83,
  "98583": -0.31,
  "98584": -13.19,
  "98585": -5.83,
  "98586": -11.9,
  "98587": -0.86,
  "98588": -13.74,
  "98589": 4.29,
  "98590": -11.35,
  "98591": -5.83,
  "98592": -4.7,
  "98593": 4.29,
  "98595": -0.31,
  "98596": -5.83,
  "98597": 4.29,
  "98601": 2.45,
  "98602": -13.34,
  "98603": 4.29,
  "98604": 2.45,
  "98605": 5.58,
  "98606": 10.94,
  "98607": 2.45,
  "98609": 4.29,
  "98610": 5.58,
  "98611": 3.74,
  "98612": -11.81,
  "98613": -13.34,
  "98614": -11.35,
  "98616": 5.58,
  "98617": -12.82,
  "98619": -13.34,
  "98620": -13.34,
  "98621": -11.81,
  "98622": 2.45,
  "98623": 6.13,
  "98624": -11.35,
  "98625": 4.29,
  "98626": 3.74,
  "98628": -13.34,
  "98629": 2.45,
  "98631": -11.35,
  "98632": 3.74,
  "98635": -13.34,
  "98637": -11.35,
  "98638": -11.35,
  "98639": 5.58,
  "98640": -2.86,
  "98641": -2.86,
  "98642": 4.04,
  "98643": -11.81,
  "98644": -11.35,
  "98645": 4.29,
  "98647": -12.36,
  "98648": 5.58,
  "98649": 4.29,
  "98650": 6.13,
  "98651": 6.13,
  "98660": 1.9,
  "98661": 1.9,
  "98662": 2.45,
  "98663": 1.9,
  "98664": 2.45,
  "98665": 2.45,
  "98666": 2.45,
  "98668": 2.45,
  "98670": -13.34,
  "98671": 2.45,
  "98672": 6.13,
  "98673": -13.86,
  "98674": 4.29,
  "98675": 2.45,
  "98682": 2.45,
  "98683": 2.45,
  "98684": 2.45,
  "98685": 2.45,
  "98686": 2.45,
  "98687": 2.45,
  "98801": 0,
  "98802": 0,
  "98807": 0,
  "98811": 0,
  "98812": -12.88,
  "98813": -6.96,
  "98814": -11.81,
  "98815": 1.59,
  "98816": 2.05,
  "98817": -6.44,
  "98819": -11.81,
  "98821": -0.52,
  "98822": 0,
  "98823": 1.38,
  "98824": 1.38,
  "98826": 8.49,
  "98827": -12.36,
  "98828": 0,
  "98829": -12.88,
  "98830": -6.44,
  "98831": -4.85,
  "98832": 1.9,
  "98833": -11.81,
  "98834": -5.37,
  "98836": 0,
  "98837": 2.45,
  "98840": -12.88,
  "98841": -12.88,
  "98843": -6.44,
  "98844": -15.64,
  "98845": -6.44,
  "98846": -12.88,
  "98847": 8.49,
  "98848": 1.38,
  "98849": -12.88,
  "98850": -6.44,
  "98851": 1.38,
  "98852": -11.81,
  "98853": 1.9,
  "98855": -12.88,
  "98856": -11.81,
  "98857": -8.22,
  "98858": -6.44,
  "98859": -15.64,
  "98860": 1.9,
  "98862": -11.81,
  "98901": -8.28,
  "98902": -8.28,
  "98903": -8.28,
  "98904": -8.28,
  "98907": -8.28,
  "98908": -7.76,
  "98909": -8.28,
  "98920": -8.28,
  "98921": -8.28,
  "98922": 2.05,
  "98923": -8.28,
  "98925": 1.53,
  "98926": 0.46,
  "98929": -8.28,
  "98930": 5.12,
  "98932": -8.28,
  "98933": -8.28,
  "98934": 0.46,
  "98935": 5.12,
  "98936": -8.28,
  "98937": -8.28,
  "98938": -8.28,
  "98939": -8.28,
  "98940": 0.46,
  "98941": 0.46,
  "98942": -7.76,
  "98943": 0.46,
  "98944": -8.28,
  "98946": 0.46,
  "98947": -8.28,
  "98948": -8.28,
  "98950": 9.87,
  "98951": -8.28,
  "98952": -8.28,
  "98953": -8.28,
  "99001": -1.9,
  "99003": 0.21,
  "99004": -1.38,
  "99005": 7.11,
  "99006": -1.38,
  "99008": -2.76,
  "99009": -1.38,
  "99011": -1.9,
  "99012": -1.38,
  "99013": -1.38,
  "99014": -1.9,
  "99016": -1.38,
  "99017": -1.44,
  "99018": -0.92,
  "99019": 7.11,
  "99020": -1.9,
  "99021": -1.38,
  "99022": -1.9,
  "99023": 7.11,
  "99025": -1.38,
  "99026": 7.11,
  "99027": -1.38,
  "99029": -1.38,
  "99030": -1.38,
  "99031": -1.38,
  "99032": -3.28,
  "99033": -1.44,
  "99034": -1.38,
  "99036": 7.11,
  "99037": 7.11,
  "99039": -0.92,
  "99040": -3.28,
  "99101": -10.58,
  "99102": -0.92,
  "99103": -3.28,
  "99104": -1.44,
  "99105": -9.26,
  "99107": -10.58,
  "99109": -10.58,
  "99110": -1.38,
  "99111": -0.92,
  "99113": -0.46,
  "99114": -10.58,
  "99115": -6.44,
  "99116": -2.76,
  "99117": -3.28,
  "99118": -15.64,
  "99119": -8.28,
  "99121": -15.64,
  "99122": -2.76,
  "99123": -3.28,
  "99124": -3.28,
  "99125": -1.44,
  "99126": -11.1,
  "99128": -1.44,
  "99129": -2.76,
  "99130": -0.92,
  "99131": -10.58,
  "99133": -3.28,
  "99134": -3.28,
  "99135": 0.86,
  "99136": -1.44,
  "99137": -10.58,
  "99138": -15.64,
  "99139": -8.28,
  "99140": -16.16,
  "99141": -11.1,
  "99143": -1.44,
  "99144": -3.28,
  "99146": -15.64,
  "99147": -3.28,
  "99148": -10.58,
  "99149": -1.44,
  "99150": -16.16,
  "99151": -11.1,
  "99152": -8.28,
  "99153": -8.28,
  "99154": -3.28,
  "99155": -12.88,
  "99156": -8.28,
  "99157": -11.1,
  "99158": -0.92,
  "99159": -3.28,
  "99160": -16.16,
  "99161": -0.92,
  "99163": 0.67,
  "99166": -15.64,
  "99167": -10.58,
  "99169": -8.74,
  "99170": -0.92,
  "99171": -0.92,
  "99173": -10.58,
  "99174": -0.92,
  "99176": -1.44,
  "99179": -0.46,
  "99180": -8.28,
  "99181": -10.58,
  "99185": -3.28,
  "99201": -1.9,
  "99202": -1.38,
  "99203": -1.38,
  "99204": -1.38,
  "99205": -1.38,
  "99206": -1.38,
  "99207": -1.9,
  "99208": -1.38,
  "99209": -1.38,
  "99210": -1.38,
  "99211": -1.38,
  "99212": -1.38,
  "99213": -1.38,
  "99214": -1.38,
  "99215": -1.38,
  "99216": -1.38,
  "99217": -1.9,
  "99218": 0.21,
  "99219": -1.38,
  "99220": -1.38,
  "99223": 7.11,
  "99224": -1.9,
  "99228": 7.11,
  "99301": -6.04,
  "99302": -6.04,
  "99320": 5.67,
  "99321": 2.97,
  "99322": -13.34,
  "99323": 5.12,
  "99324": -6.96,
  "99326": -6.04,
  "99328": 16.04,
  "99329": -6.96,
  "99330": -6.04,
  "99333": -9.26,
  "99335": -9.26,
  "99336": 5.12,
  "99337": 5.12,
  "99338": 5.12,
  "99341": -9.26,
  "99343": -5,
  "99344": -8.22,
  "99345": 5.12,
  "99346": 5.12,
  "99347": 16.04,
  "99348": 16.04,
  "99349": -8.28,
  "99350": 5.67,
  "99352": 13.61,
  "99353": 13.61,
  "99354": 13.61,
  "99356": -13.34,
  "99357": 1.38,
  "99359": 15.49,
  "99360": -6.96,
  "99361": 16.04,
  "99362": -6.96,
  "99363": -6.96,
  "99371": -9.26,
  "99401": -0.98,
  "99402": -0.46,
  "99403": -0.46,
  "99501": 22.73,
  "99502": 22.73,
  "99503": 22.73,
  "99504": 22.73,
  "99505": 22.73,
  "99506": 22.73,
  "99507": 22.73,
  "99508": 22.73,
  "99509": 22.73,
  "99510": 22.73,
  "99511": 24.32,
  "99513": 22.73,
  "99514": 22.73,
  "99515": 24.32,
  "99516": 31.22,
  "99517": 22.73,
  "99518": 22.73,
  "99519": 22.73,
  "99520": 22.73,
  "99521": 22.73,
  "99522": 22.73,
  "99523": 22.73,
  "99524": 22.73,
  "99529": 22.73,
  "99530": 22.73,
  "99540": 24.32,
  "99545": -7.17,
  "99546": 18.13,
  "99547": 18.13,
  "99548": 17.21,
  "99549": 17.21,
  "99550": 13.07,
  "99551": -7.17,
  "99552": -7.17,
  "99553": 18.13,
  "99554": -7.69,
  "99555": 17.21,
  "99556": 4.79,
  "99557": -7.17,
  "99558": -7.69,
  "99559": -7.17,
  "99561": 1.32,
  "99563": -7.17,
  "99564": 17.21,
  "99565": 17.21,
  "99566": 19.97,
  "99567": 24.32,
  "99568": 4.79,
  "99569": 17.21,
  "99571": 17.21,
  "99572": 13.28,
  "99573": 19.97,
  "99574": 22.21,
  "99575": -7.17,
  "99576": -7.17,
  "99577": 24.32,
  "99578": -7.69,
  "99579": 17.21,
  "99580": 17.21,
  "99581": -7.17,
  "99583": 25.7,
  "99585": -7.17,
  "99586": 24.11,
  "99587": 31.22,
  "99588": 19.97,
  "99589": -7.69,
  "99590": -7.69,
  "99591": 18.13,
  "99599": 22.73,
  "99602": -7.69,
  "99603": 4.79,
  "99604": -7.17,
  "99605": 22.73,
  "99606": 17.21,
  "99607": -7.17,
  "99608": 21.56,
  "99609": -7.17,
  "99610": 4.79,
  "99611": 4.79,
  "99612": 17.21,
  "99613": 17.21,
  "99614": -7.69,
  "99615": 14.66,
  "99619": 14.66,
  "99620": -7.69,
  "99621": -7.17,
  "99622": -7.69,
  "99624": 13.07,
  "99625": 18.8,
  "99626": -7.17,
  "99627": -0.730000000000001,
  "99628": 17.21,
  "99629": 18.59,
  "99630": -7.17,
  "99631": 22.73,
  "99632": -7.17,
  "99633": 17.21,
  "99634": -7.17,
  "99635": 4.79,
  "99636": 17.21,
  "99637": -7.17,
  "99638": 18.13,
  "99639": 4.79,
  "99640": 17.21,
  "99641": -7.69,
  "99643": 13.07,
  "99644": 13.07,
  "99645": 18.59,
  "99647": 17.21,
  "99648": 17.21,
  "99649": 17.21,
  "99650": -7.69,
  "99651": -7.17,
  "99652": 18.59,
  "99653": 28,
  "99654": 18.59,
  "99655": -7.69,
  "99656": -7.17,
  "99657": -7.17,
  "99658": -7.17,
  "99659": -7.17,
  "99660": 18.13,
  "99661": 17.21,
  "99662": -7.69,
  "99663": 4.79,
  "99664": 4.79,
  "99665": -7.17,
  "99666": -7.69,
  "99667": 27.08,
  "99668": -7.17,
  "99669": 4.79,
  "99670": 17.21,
  "99671": -7.17,
  "99672": 4.79,
  "99674": 18.59,
  "99675": -0.730000000000001,
  "99676": 18.59,
  "99677": 19.97,
  "99678": -7.17,
  "99679": -7.69,
  "99680": -7.69,
  "99681": -7.17,
  "99682": 22.21,
  "99683": 31.22,
  "99684": 19.05,
  "99685": 19.72,
  "99686": 19.97,
  "99687": 18.59,
  "99688": 31.22,
  "99689": 0.189999999999999,
  "99690": -7.17,
  "99691": -0.730000000000001,
  "99692": 26.62,
  "99693": 22.21,
  "99694": 18.59,
  "99695": 22.73,
  "99697": 13.07,
  "99701": 24.11,
  "99702": 24.11,
  "99703": 24.11,
  "99704": 16.29,
  "99705": 24.11,
  "99706": 24.11,
  "99707": 24.11,
  "99708": 24.11,
  "99709": 24.11,
  "99710": 24.11,
  "99711": 24.11,
  "99712": 24.11,
  "99714": 24.11,
  "99716": 24.11,
  "99720": -0.730000000000001,
  "99721": 39.29,
  "99722": 24.11,
  "99723": 39.29,
  "99724": 24.11,
  "99725": 24.11,
  "99726": -0.730000000000001,
  "99727": 19.05,
  "99729": 16.29,
  "99730": 24.11,
  "99731": 24.11,
  "99732": 24.11,
  "99733": 24.11,
  "99734": 39.29,
  "99736": 18.53,
  "99737": 24.11,
  "99738": 24.11,
  "99739": 19.05,
  "99740": 24.11,
  "99741": -1.25,
  "99742": 19.05,
  "99743": -0.730000000000001,
  "99744": 16.29,
  "99745": -1.25,
  "99746": -0.730000000000001,
  "99747": 39.29,
  "99748": 18.53,
  "99749": 19.05,
  "99750": 19.05,
  "99751": 19.05,
  "99752": 19.05,
  "99753": 18.53,
  "99754": 18.53,
  "99755": -0.730000000000001,
  "99756": -0.730000000000001,
  "99757": -0.730000000000001,
  "99758": 24.11,
  "99759": 19.05,
  "99760": 16.29,
  "99761": 19.05,
  "99762": 19.05,
  "99763": 19.05,
  "99764": 24.11,
  "99765": 18.53,
  "99766": 19.05,
  "99767": -0.730000000000001,
  "99768": -0.730000000000001,
  "99769": -7.17,
  "99770": 19.05,
  "99771": 19.05,
  "99772": 19.05,
  "99773": 19.05,
  "99774": 23.59,
  "99775": 24.11,
  "99776": 23.59,
  "99777": -0.730000000000001,
  "99778": 18.53,
  "99780": 24.11,
  "99781": 24.11,
  "99782": 39.29,
  "99783": 19.05,
  "99784": 19.05,
  "99785": 18.53,
  "99786": 19.05,
  "99788": 24.11,
  "99789": 39.29,
  "99790": 24.11,
  "99791": 39.29,
  "99801": 17.42,
  "99802": 17.42,
  "99803": 17.42,
  "99811": 17.42,
  "99820": 18.59,
  "99821": 17.42,
  "99824": 17.42,
  "99825": 8.93,
  "99826": 8.93,
  "99827": 4.33,
  "99829": 8.93,
  "99830": 18.59,
  "99832": 8.93,
  "99833": 20.18,
  "99835": 27.08,
  "99836": 20.18,
  "99840": 4.33,
  "99841": 8.93,
  "99850": 17.42,
  "99901": 8.89,
  "99903": 8.89,
  "99918": 8.89,
  "99919": 8.89,
  "99921": 8.89,
  "99922": 8.89,
  "99923": 8.34,
  "99925": 8.34,
  "99926": 8.89,
  "99927": 18.59,
  "99928": 8.89,
  "99929": 8.89,
  "99950": 8.89
};

// src/craftsman/costDataset/2026.1/historicalCostIndex.ts
var CRAFTSMAN_2026_HISTORICAL_COST_INDEX = {
  "1959": 13.18,
  "1960": 12.99,
  "1961": 12.75,
  "1962": 12.6,
  "1963": 12.36,
  "1964": 11.93,
  "1965": 11.68,
  "1966": 11.17,
  "1967": 10.62,
  "1968": 10.05,
  "1969": 9.67,
  "1970": 9.2,
  "1971": 7.92,
  "1972": 7.94,
  "1973": 7.33,
  "1974": 6.85,
  "1975": 6.44,
  "1976": 6.2,
  "1977": 5.76,
  "1978": 5.29,
  "1979": 4.85,
  "1980": 4.35,
  "1981": 4.15,
  "1982": 4.01,
  "1983": 3.83,
  "1984": 3.54,
  "1985": 3.43,
  "1986": 3.38,
  "1987": 3.32,
  "1988": 3.28,
  "1989": 3.22,
  "1990": 2.99,
  "1991": 2.83,
  "1992": 2.82,
  "1993": 2.78,
  "1994": 2.67,
  "1995": 2.51,
  "1996": 2.46,
  "1997": 2.4,
  "1998": 2.3,
  "1999": 2.28,
  "2000": 2.2,
  "2001": 2.11,
  "2002": 2.09,
  "2003": 2.07,
  "2004": 2.02,
  "2005": 1.81,
  "2006": 1.62,
  "2007": 1.5,
  "2008": 1.44,
  "2009": 1.44,
  "2010": 1.43,
  "2011": 1.45,
  "2012": 1.4,
  "2013": 1.33,
  "2014": 1.31,
  "2015": 1.3,
  "2016": 1.31,
  "2017": 1.32,
  "2018": 1.2,
  "2019": 1.15,
  "2020": 1.17,
  "2021": 1.16,
  "2022": 1.07,
  "2023": 0.98,
  "2024": 1.06,
  "2025": 1.01
};

// src/craftsman/costDataset/2026.1/index.ts
var CRAFTSMAN_COST_DATASET_2026 = {
  version: "2026.1",
  zipMultiplier: CRAFTSMAN_ZIP_MODIFIER_2026,
  costData: {
    singleFamily: {
      sixCorners: {
        variable: [
          411.22,
          400.75,
          390.28,
          379.81,
          369.34,
          358.88,
          337.39,
          315.91,
          294.43,
          272.95,
          251.46,
          238.32,
          225.17,
          212.03,
          198.88,
          185.74,
          181.2,
          176.66,
          172.12,
          167.58,
          163.04,
          158.45,
          153.86,
          149.26,
          144.67,
          140.08,
          136.38,
          132.68,
          128.98,
          125.28,
          121.57,
          119.26,
          116.95,
          114.64,
          112.32,
          110.01,
          107.93,
          105.85,
          103.77,
          101.69,
          99.61,
          97.11,
          94.61,
          92.11,
          89.62,
          87.12,
          85.64,
          84.16,
          82.69,
          81.21,
          79.73
        ],
        fixed: [
          161189,
          156342,
          151496,
          146649,
          141802,
          136955,
          127494,
          118034,
          108574,
          99113,
          89653,
          83645,
          77638,
          71630,
          65622,
          59615,
          57591,
          55566,
          53542,
          51518,
          49494,
          47781,
          46068,
          44355,
          42642,
          40929,
          39555,
          38181,
          36807,
          35433,
          34059,
          33269,
          32478,
          31687,
          30897,
          30106,
          29421,
          28736,
          28051,
          27366,
          26681,
          25464,
          24246,
          23029,
          21811,
          20594,
          19851,
          19109,
          18366,
          17624,
          16881
        ]
      }
    },
    multiFamily: {
      twoOrThreeUnits: {
        variable: [
          180.9,
          176.46,
          172.02,
          167.58,
          163.14,
          158.7,
          154.72,
          150.75,
          146.77,
          142.79,
          138.81,
          136.46,
          134.11,
          131.75,
          129.4,
          127.05,
          124.87,
          122.7,
          120.53,
          118.36,
          116.18,
          114.4,
          112.62,
          110.83,
          109.05,
          107.27,
          105.62,
          103.97,
          102.33,
          100.68,
          99.03,
          97.52,
          96.01,
          94.5,
          92.98,
          91.47,
          90.06,
          88.65,
          87.24,
          85.83,
          84.42
        ],
        fixed: [
          18152,
          17645,
          17138,
          16630,
          16123,
          15616,
          15208,
          14800,
          14392,
          13985,
          13577,
          13322,
          13067,
          12812,
          12557,
          12303,
          12097,
          11891,
          11686,
          11480,
          11275,
          11112,
          10949,
          10786,
          10623,
          10460,
          10320,
          10179,
          10038,
          9898,
          9757,
          9604,
          9452,
          9299,
          9146,
          8993,
          8869,
          8745,
          8622,
          8498,
          8374
        ]
      },
      fourToNineUnits: {
        variable: [],
        fixed: []
      }
    },
    manufactured: {
      variable: [
        145.69,
        143.67,
        141.64,
        139.62,
        137.59,
        135.57,
        132.56,
        129.56,
        126.56,
        123.55,
        120.55,
        118,
        115.46,
        112.91,
        110.36,
        107.82,
        105.13,
        102.45,
        99.76,
        97.08,
        94.39,
        92.85,
        91.31,
        89.76,
        88.22,
        86.67,
        85.15,
        83.62,
        82.1,
        80.58,
        79.05,
        77.82,
        76.58,
        75.35,
        74.12,
        72.88,
        71.78,
        70.68,
        69.58,
        68.48,
        67.38
      ],
      fixed: [
        12924,
        12934,
        12944,
        12953,
        12963,
        12972,
        13458,
        13943,
        14428,
        14914,
        15399,
        15660,
        15922,
        16183,
        16445,
        16706,
        17215,
        17724,
        18233,
        18742,
        19251,
        19172,
        19093,
        19015,
        18936,
        18857,
        18744,
        18631,
        18518,
        18406,
        18293,
        18199,
        18104,
        18010,
        17915,
        17821,
        17624,
        17427,
        17230,
        17034,
        16837
      ]
    },
    bathrooms: {
      halfBaths: [
        9846,
        9654,
        9462,
        9269,
        9077,
        8885,
        8693,
        8501,
        8308,
        8116,
        7924,
        7802,
        7680,
        7557,
        7435,
        7313,
        7191,
        7069,
        6946,
        6824,
        6702,
        6590,
        6478,
        6367,
        6255,
        6143,
        6031,
        5919,
        5808,
        5696,
        5584,
        5498,
        5412,
        5327,
        5241,
        5155,
        5069,
        4983,
        4898,
        4812,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726,
        4726
      ],
      fullBaths: [
        18187,
        17940,
        17694,
        17447,
        17200,
        16954,
        16707,
        16460,
        16213,
        15967,
        15720,
        15551,
        15383,
        15214,
        15046,
        14877,
        14708,
        14540,
        14371,
        14203,
        14034,
        13780,
        13527,
        13273,
        13020,
        12766,
        12512,
        12259,
        12005,
        11752,
        11498,
        11333,
        11167,
        11002,
        10836,
        10671,
        10506,
        10340,
        10175,
        10009,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844,
        9844
      ]
    },
    basement: {
      totalArea: {
        variable: [
          54,
          53.36,
          52.72,
          52.08,
          51.44,
          50.8,
          50.16,
          49.52,
          48.88,
          48.24,
          47.6,
          46.96,
          46.32,
          45.68,
          45.04,
          44.4,
          43.76,
          43.12,
          42.48,
          41.84,
          41.2,
          40.56,
          39.92,
          39.28,
          38.64,
          38,
          37.36,
          36.72,
          36.08,
          35.44,
          34.8,
          34.16,
          33.52,
          32.88,
          32.24,
          31.6,
          30.96,
          30.32,
          29.68,
          29.04,
          28.4,
          27.76,
          27.12,
          26.48,
          25.84,
          25.2,
          24.56,
          23.92,
          23.28,
          22.64,
          22
        ]
      },
      finishedArea: {
        variable: [
          121.1,
          117.97,
          114.85,
          111.72,
          108.6,
          105.48,
          99.06,
          92.65,
          86.24,
          79.83,
          73.42,
          69.5,
          65.57,
          61.65,
          57.73,
          53.8,
          52.45,
          51.09,
          49.74,
          48.38,
          47.03,
          45.66,
          44.29,
          42.92,
          41.55,
          40.18,
          39.07,
          37.97,
          36.86,
          35.76,
          34.66,
          33.96,
          33.27,
          32.58,
          31.89,
          31.2,
          30.58,
          29.96,
          29.34,
          28.72,
          28.1,
          27.35,
          26.61,
          25.86,
          25.12,
          24.37,
          23.93,
          23.49,
          23.05,
          22.61,
          22.17
        ]
      }
    },
    attic: {
      variable: [
        135.25,
        131.76,
        128.28,
        124.79,
        121.3,
        117.81,
        110.65,
        103.49,
        96.32,
        89.16,
        82,
        77.62,
        73.24,
        68.86,
        64.48,
        60.09,
        58.58,
        57.07,
        55.55,
        54.04,
        52.53,
        51,
        49.47,
        47.94,
        46.41,
        44.88,
        43.64,
        42.41,
        41.17,
        39.94,
        38.71,
        37.94,
        37.16,
        36.39,
        35.62,
        34.85,
        34.16,
        33.47,
        32.77,
        32.08,
        31.39,
        30.55,
        29.72,
        28.89,
        28.05,
        27.22,
        26.73,
        26.24,
        25.74,
        25.25,
        24.76
      ]
    },
    garage: {
      attached: {
        variable: [
          123.97,
          120.82,
          117.68,
          114.53,
          111.38,
          108.24,
          102.93,
          97.62,
          92.32,
          87.01,
          81.71,
          78.8,
          75.9,
          73,
          70.09,
          67.19,
          64.86,
          62.53,
          60.2,
          57.87,
          55.54,
          53.82,
          52.11,
          50.4,
          48.68,
          46.97,
          45.92,
          44.86,
          43.81,
          42.76,
          41.71,
          40.97,
          40.23,
          39.5,
          38.76,
          38.02,
          37.29,
          36.55,
          35.82,
          35.08,
          34.35,
          33.7,
          33.05,
          32.4,
          31.75,
          31.1,
          30.46,
          29.82,
          29.18,
          28.54,
          27.9
        ],
        fixed: [
          17306,
          16825,
          16344,
          15862,
          15381,
          14899,
          14154,
          13408,
          12662,
          11917,
          11171,
          10661,
          10150,
          9640,
          9129,
          8618,
          8378,
          8138,
          7898,
          7658,
          7418,
          7204,
          6990,
          6775,
          6561,
          6347,
          6185,
          6023,
          5861,
          5699,
          5537,
          5505,
          5473,
          5441,
          5409,
          5377,
          5343,
          5309,
          5275,
          5241,
          5207,
          5074,
          4942,
          4809,
          4676,
          4543,
          4418,
          4293,
          4168,
          4042,
          3917
        ]
      },
      detached: {
        variable: [
          126.84,
          123.51,
          120.18,
          116.85,
          113.52,
          110.19,
          104.74,
          99.29,
          93.84,
          88.39,
          82.94,
          79.77,
          76.6,
          73.43,
          70.26,
          67.09,
          64.83,
          62.57,
          60.3,
          58.04,
          55.78,
          54.56,
          53.35,
          52.14,
          50.93,
          49.72,
          48.54,
          47.36,
          46.18,
          45,
          43.82,
          43.19,
          42.57,
          41.94,
          41.31,
          40.69,
          39.74,
          38.78,
          37.83,
          36.88,
          35.93,
          35,
          34.07,
          33.15,
          32.22,
          31.29,
          30.58,
          29.88,
          29.17,
          28.47,
          27.76
        ],
        fixed: [
          21473,
          20855,
          20238,
          19621,
          19004,
          18387,
          17437,
          16487,
          15537,
          14587,
          13637,
          13108,
          12578,
          12049,
          11520,
          10990,
          10605,
          10219,
          9834,
          9448,
          9062,
          8848,
          8634,
          8419,
          8205,
          7991,
          7804,
          7617,
          7430,
          7243,
          7056,
          6934,
          6812,
          6690,
          6568,
          6447,
          6440,
          6433,
          6426,
          6419,
          6413,
          6184,
          5956,
          5728,
          5499,
          5271,
          5120,
          4969,
          4818,
          4667,
          4516
        ]
      }
    },
    carport: {
      variable: [
        126.84,
        123.51,
        120.18,
        116.85,
        113.52,
        110.19,
        104.74,
        99.29,
        93.84,
        88.39,
        82.94,
        79.77,
        76.6,
        73.43,
        70.26,
        67.09,
        64.83,
        62.57,
        60.3,
        58.04,
        55.78,
        54.56,
        53.35,
        52.14,
        50.93,
        49.72,
        48.54,
        47.36,
        46.18,
        45,
        43.82,
        43.19,
        42.57,
        41.94,
        41.31,
        40.69,
        39.74,
        38.78,
        37.83,
        36.88,
        35.93,
        35,
        34.07,
        33.15,
        32.22,
        31.29,
        30.58,
        29.88,
        29.17,
        28.47,
        27.76
      ]
    },
    pool: {
      fixed: [39444, 24654, 18490],
      variable240To480: [99.3, 62.07, 46.55],
      variableOver480: [69.51, 43.45, 32.58]
    },
    spa: {
      fixed: [20709, 12943, 9708],
      variableOver70: [52.14, 32.58, 24.44]
    },
    shed: {
      variable: [26.4, 20.67, 13.69],
      fixed: [1334, 1095, 806]
    },
    workshop: {
      variable: [33.69, 27.18, 21.56],
      fixed: [23546, 17817, 13903]
    },
    barn: {
      variable: [36.9, 27.7, 18.48],
      fixed: [37532, 25039, 12613]
    },
    patio: {
      uncovered: {
        variable: [
          40.01,
          39.39,
          38.76,
          38.14,
          37.51,
          36.89,
          36.26,
          35.64,
          35.01,
          34.39,
          33.76,
          33.14,
          32.51,
          31.89,
          31.27,
          30.64,
          30.02,
          29.39,
          28.77,
          28.14,
          27.52,
          26.89,
          26.27,
          25.64,
          25.02,
          24.4,
          23.77,
          23.15,
          22.52,
          21.9,
          21.27,
          20.65,
          20.02,
          19.4,
          18.77,
          18.15,
          17.52,
          16.9,
          16.28,
          15.65,
          15.03,
          14.4,
          13.78,
          13.15,
          12.53,
          11.9,
          11.28,
          10.65,
          10.03,
          9.4,
          8.78
        ]
      },
      covered: {
        variable: [
          61.51,
          60.66,
          59.81,
          58.96,
          58.11,
          57.26,
          56.41,
          55.56,
          54.71,
          53.85,
          53,
          52.15,
          51.3,
          50.45,
          49.6,
          48.75,
          47.9,
          47.05,
          46.2,
          45.35,
          44.5,
          43.65,
          42.8,
          41.95,
          41.1,
          40.25,
          39.39,
          38.54,
          37.69,
          36.84,
          35.99,
          35.14,
          34.29,
          33.44,
          32.59,
          31.74,
          30.89,
          30.04,
          29.19,
          28.34,
          27.49,
          26.64,
          25.78,
          24.93,
          24.08,
          23.23,
          22.38,
          21.53,
          20.68,
          19.83,
          18.98
        ]
      },
      screen: {
        variable: [
          124,
          122.94,
          121.88,
          120.82,
          119.76,
          118.7,
          117.64,
          116.58,
          115.52,
          114.46,
          113.4,
          112.34,
          111.28,
          110.22,
          109.16,
          108.1,
          107.04,
          105.98,
          104.92,
          103.86,
          102.8,
          101.74,
          100.68,
          99.62,
          98.56,
          97.5,
          96.44,
          95.38,
          94.32,
          93.26,
          92.2,
          91.14,
          90.08,
          89.02,
          87.96,
          86.9,
          85.84,
          84.78,
          83.72,
          82.66,
          81.6,
          80.54,
          79.48,
          78.42,
          77.36,
          76.3,
          75.24,
          74.18,
          73.12,
          72.06,
          71
        ]
      }
    },
    deck: {
      uncovered: {
        variable: [
          44.75,
          44.39,
          44.02,
          43.66,
          43.3,
          42.93,
          42.57,
          42.2,
          41.84,
          41.48,
          41.11,
          40.75,
          40.39,
          40.02,
          39.66,
          39.3,
          38.93,
          38.57,
          38.21,
          37.84,
          37.48,
          37.11,
          36.75,
          36.39,
          36.02,
          35.66,
          35.3,
          34.93,
          34.57,
          34.21,
          33.84,
          33.48,
          33.11,
          32.75,
          32.39,
          32.02,
          31.66,
          31.3,
          30.93,
          30.57,
          30.21,
          29.84,
          29.48,
          29.12,
          28.75,
          28.39,
          28.02,
          27.66,
          27.3,
          26.93,
          26.57
        ]
      },
      covered: {
        variable: [
          66.25,
          65.66,
          65.07,
          64.48,
          63.89,
          63.3,
          62.71,
          62.12,
          61.53,
          60.94,
          60.35,
          59.76,
          59.17,
          58.59,
          58,
          57.41,
          56.82,
          56.23,
          55.64,
          55.05,
          54.46,
          53.87,
          53.28,
          52.69,
          52.1,
          51.51,
          50.92,
          50.33,
          49.74,
          49.15,
          48.56,
          47.97,
          47.38,
          46.79,
          46.2,
          45.61,
          45.02,
          44.43,
          43.85,
          43.26,
          42.67,
          42.08,
          41.49,
          40.9,
          40.31,
          39.72,
          39.13,
          38.54,
          37.95,
          37.36,
          36.77
        ]
      },
      screen: {
        variable: [
          124,
          122.94,
          121.88,
          120.82,
          119.76,
          118.7,
          117.64,
          116.58,
          115.52,
          114.46,
          113.4,
          112.34,
          111.28,
          110.22,
          109.16,
          108.1,
          107.04,
          105.98,
          104.92,
          103.86,
          102.8,
          101.74,
          100.68,
          99.62,
          98.56,
          97.5,
          96.44,
          95.38,
          94.32,
          93.26,
          92.2,
          91.14,
          90.08,
          89.02,
          87.96,
          86.9,
          85.84,
          84.78,
          83.72,
          82.66,
          81.6,
          80.54,
          79.48,
          78.42,
          77.36,
          76.3,
          75.24,
          74.18,
          73.12,
          72.06,
          71
        ]
      }
    },
    porch: {
      uncovered: {
        variable: [
          44.75,
          44.39,
          44.02,
          43.66,
          43.3,
          42.93,
          42.57,
          42.2,
          41.84,
          41.48,
          41.11,
          40.75,
          40.39,
          40.02,
          39.66,
          39.3,
          38.93,
          38.57,
          38.21,
          37.84,
          37.48,
          37.11,
          36.75,
          36.39,
          36.02,
          35.66,
          35.3,
          34.93,
          34.57,
          34.21,
          33.84,
          33.48,
          33.11,
          32.75,
          32.39,
          32.02,
          31.66,
          31.3,
          30.93,
          30.57,
          30.21,
          29.84,
          29.48,
          29.12,
          28.75,
          28.39,
          28.02,
          27.66,
          27.3,
          26.93,
          26.57
        ]
      },
      covered: {
        variable: [
          66.25,
          65.66,
          65.07,
          64.48,
          63.89,
          63.3,
          62.71,
          62.12,
          61.53,
          60.94,
          60.35,
          59.76,
          59.17,
          58.59,
          58,
          57.41,
          56.82,
          56.23,
          55.64,
          55.05,
          54.46,
          53.87,
          53.28,
          52.69,
          52.1,
          51.51,
          50.92,
          50.33,
          49.74,
          49.15,
          48.56,
          47.97,
          47.38,
          46.79,
          46.2,
          45.61,
          45.02,
          44.43,
          43.85,
          43.26,
          42.67,
          42.08,
          41.49,
          40.9,
          40.31,
          39.72,
          39.13,
          38.54,
          37.95,
          37.36,
          36.77
        ]
      },
      screen: {
        variable: [
          124,
          122.94,
          121.88,
          120.82,
          119.76,
          118.7,
          117.64,
          116.58,
          115.52,
          114.46,
          113.4,
          112.34,
          111.28,
          110.22,
          109.16,
          108.1,
          107.04,
          105.98,
          104.92,
          103.86,
          102.8,
          101.74,
          100.68,
          99.62,
          98.56,
          97.5,
          96.44,
          95.38,
          94.32,
          93.26,
          92.2,
          91.14,
          90.08,
          89.02,
          87.96,
          86.9,
          85.84,
          84.78,
          83.72,
          82.66,
          81.6,
          80.54,
          79.48,
          78.42,
          77.36,
          76.3,
          75.24,
          74.18,
          73.12,
          72.06,
          71
        ]
      }
    },
    fireplace: {
      freestanding: 2498,
      zeroClearance: 3320,
      masonry: 12815
    },
    manufacturedBaths: {
      halfBaths: [1795],
      fullBaths: [3375]
    },
    foundation: {
      slab: {
        variable: 17.64
      }
    },
    // Heating is already included in dwelling costs
    // We leave them as 0 to avoid including them twice in cost calculations
    heating: 0,
    heatingAndCooling: 0
  },
  historicalIndex: CRAFTSMAN_2026_HISTORICAL_COST_INDEX
};

// src/craftsman/costDataset/index.ts
var CraftsmanCostDatasets = [
  CRAFTSMAN_COST_DATASET_2024,
  CRAFTSMAN_COST_DATASET_2025,
  CRAFTSMAN_COST_DATASET_2026
];
var getCraftsmanCostDataset = (version) => {
  const costDataset = CraftsmanCostDatasets.find((dataset) => dataset.version === version);
  if ((0, import_shared_utils61.isUndefined)(costDataset)) {
    throw new Error(`Craftsman Cost Dataset with version ${version} was not found`);
  }
  return costDataset;
};
var getCraftsmanHistoricalCostIndex = (version, effectiveYearString) => {
  const costDataset = getCraftsmanCostDataset(version);
  const historicalIndices = costDataset.historicalIndex;
  const applicableIndex = historicalIndices[effectiveYearString];
  if ((0, import_shared_utils61.isUndefined)(applicableIndex) && effectiveYearString <= "2024") {
    throw new Error(`Historical index for ${effectiveYearString} was not found`);
  }
  return applicableIndex ?? 1;
};

// src/craftsman/calculator/utils.ts
var import_shared_utils62 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice20 } from "@aloft/shared-objects";
var STEP_SIZE = 0.1;
var getVariableAndFixedCosts = (cost, quality, stepSize = 0.1) => {
  const index = Math.round((quality - 1) / stepSize);
  const variable = AloftPrice20.fromDollarLike(cost.variable[index]);
  const fixed = AloftPrice20.fromDollarLike(cost.fixed[index]);
  if ((0, import_shared_utils62.isUndefined)(variable) || (0, import_shared_utils62.isUndefined)(fixed)) {
    throw new Error(`Variable and fixed costs for the given quality of ${quality} was not found`);
  }
  return {
    variable,
    fixed
  };
};
var calculateIndexByQualityAndPropertyType = (quality, costs, propertyType) => {
  let index;
  switch (propertyType) {
    case "singleFamilyResidence":
      index = Math.round((quality - 1) / STEP_SIZE);
      break;
    case "multiFamily":
      index = quality >= 4 ? costs.length - 1 : 10 * quality + 10;
      break;
    case "manufacturedHome":
      index = quality >= 3 ? costs.length - 1 : 10 * quality + 20;
      break;
    default:
      throw new Error(`Property type of ${propertyType} is not yet supported`);
  }
  return index;
};
var getVariableAndFixedCostsByPropertyType = (cost, quality, propertyType) => {
  const index = calculateIndexByQualityAndPropertyType(quality, cost.variable, propertyType);
  const variable = AloftPrice20.fromDollarLike(cost.variable[index]);
  const fixed = AloftPrice20.fromDollarLike(cost.fixed[index]);
  if ((0, import_shared_utils62.isUndefined)(variable) || (0, import_shared_utils62.isUndefined)(fixed)) {
    throw new Error(`Variable and fixed costs for the given quality of ${quality} was not found`);
  }
  return {
    variable,
    fixed
  };
};
var getVariableCostsByPropertyType = (cost, quality, propertyType) => {
  const index = calculateIndexByQualityAndPropertyType(quality, cost.variable, propertyType);
  const variable = AloftPrice20.fromDollarLike(cost.variable[index]);
  if ((0, import_shared_utils62.isUndefined)(variable)) {
    throw new Error(`Variable and fixed costs for the given quality of ${quality} was not found`);
  }
  return {
    variable
  };
};
var getBathroomCostsByPropertyType = (cost, quality, propertyType) => {
  let costPerFullBath;
  let costPerHalfBath;
  if (propertyType === "manufacturedHome") {
    costPerFullBath = AloftPrice20.fromDollarLike(cost.fullBaths[0]);
    costPerHalfBath = AloftPrice20.fromDollarLike(cost.halfBaths[0]);
  } else {
    const index = calculateIndexByQualityAndPropertyType(quality, cost.fullBaths, propertyType);
    costPerFullBath = AloftPrice20.fromDollarLike(cost.fullBaths[index]);
    costPerHalfBath = AloftPrice20.fromDollarLike(cost.halfBaths[index]);
  }
  if ((0, import_shared_utils62.isUndefined)(costPerFullBath) || (0, import_shared_utils62.isUndefined)(costPerHalfBath)) {
    throw new Error(`Variable and fixed costs for the given quality of ${quality} was not found`);
  }
  return {
    costPerFullBath,
    costPerHalfBath
  };
};
var getZipMultiplier = (costData, zipCode) => {
  const filteredZip = zipCode.match(/[0-9]{5}/)?.[0];
  if ((0, import_shared_utils62.isUndefined)(filteredZip)) {
    throw new Error(`Zip Code (${zipCode}) is not in a valid format.`);
  }
  const modificationFactor = costData.zipMultiplier[filteredZip];
  if ((0, import_shared_utils62.isUndefined)(modificationFactor)) {
    console.warn(`Zip Code (${zipCode}) multiplier for cost data not found`);
    return 1;
  }
  const multiplier = modificationFactor / 100 + 1;
  return multiplier;
};
var adjustPrice = (price, multipliers, round) => roundIfNecessary(
  multipliers.reduce((acc, multiplier) => acc.mul(multiplier), price),
  round
);
var getTotalVariable = (variable, units, round) => roundIfNecessary(variable.mul(units), round);
var getFixedAndVariableCost = ({
  variableCosts = [],
  fixed,
  multipliers,
  roundVariable = false
}) => {
  const adjustedVariableCosts = variableCosts?.map(
    ({ variable }) => adjustPrice(variable ?? AloftPrice20.zero, multipliers, roundVariable)
  );
  const adjustedFixed = adjustPrice(fixed ?? AloftPrice20.zero, multipliers, true);
  const variableCost = adjustedVariableCosts.reduce(
    (acc, curr, i) => acc.add(getTotalVariable(curr, variableCosts[i]?.units ?? 0, true)),
    AloftPrice20.zero
  );
  return { adjustedFixed, adjustedVariableCosts, variableCost };
};
var getTotalCost = ({
  adjustedFixed,
  variableCost
}) => roundIfNecessary(adjustedFixed.add(variableCost), true);
var calculateCosts = ({
  variableCosts = [],
  fixed,
  costMultiplier = 1,
  zipMultiplier = 1,
  historicalIndex = 1,
  roundVariable = false
}) => {
  const requiredMultiplier = 1 / historicalIndex;
  const { adjustedFixed, adjustedVariableCosts, variableCost } = getFixedAndVariableCost({
    variableCosts,
    fixed,
    multipliers: [requiredMultiplier, zipMultiplier, costMultiplier],
    roundVariable
  });
  const totalCost = getTotalCost({ adjustedFixed, variableCost });
  const costOnlyRes = getFixedAndVariableCost({
    variableCosts,
    fixed,
    multipliers: [requiredMultiplier, costMultiplier],
    roundVariable
  });
  const costOnly = getTotalCost({
    adjustedFixed: costOnlyRes.adjustedFixed,
    variableCost: costOnlyRes.variableCost
  });
  const zipOnlyRes = getFixedAndVariableCost({
    variableCosts,
    fixed,
    multipliers: [requiredMultiplier, zipMultiplier],
    roundVariable
  });
  const zipOnly = getTotalCost({
    adjustedFixed: zipOnlyRes.adjustedFixed,
    variableCost: zipOnlyRes.variableCost
  });
  const noneRes = getFixedAndVariableCost({
    variableCosts,
    fixed,
    multipliers: [requiredMultiplier],
    roundVariable
  });
  const none = getTotalCost({
    adjustedFixed: noneRes.adjustedFixed,
    variableCost: noneRes.variableCost
  });
  const result = {
    totalCost,
    multiplierBreakdown: {
      costOnly,
      zipOnly,
      none
    }
  };
  if ((0, import_shared_utils62.isDefined)(fixed)) {
    result.fixed = adjustedFixed;
  }
  if ((0, import_shared_utils62.isDefined)(variableCosts) && variableCosts.length === 1) {
    result.variable = adjustedVariableCosts[0];
  }
  return result;
};
var roundIfNecessary = (price, shouldRound) => shouldRound ? price.roundToDollarLike() : price;
var sumTotalCosts = (costs) => {
  const totalCost = costs.reduce((acc, cost) => acc.add(cost.totalCost), AloftPrice20.zero).roundToDollarLike();
  return {
    totalCost,
    multiplierBreakdown: {
      costOnly: costs.reduce((acc, cost) => acc.add(cost.multiplierBreakdown.costOnly), AloftPrice20.zero).roundToDollarLike(),
      zipOnly: costs.reduce((acc, cost) => acc.add(cost.multiplierBreakdown.zipOnly), AloftPrice20.zero).roundToDollarLike(),
      none: costs.reduce((acc, cost) => acc.add(cost.multiplierBreakdown.none), AloftPrice20.zero).roundToDollarLike()
    }
  };
};

// src/craftsman/calculator/1.0/consts.ts
import { AloftArea as AloftArea19 } from "@aloft/shared-objects";
var ZERO = 0;
var ADD_STRUCT_DEFAULT_SQFT = AloftArea19.fromNumber(400, "sqft");
var TYPICAL_POOL_SIZE_SQFT = AloftArea19.fromNumber(400, "sqft");
var TYPICAL_SHED_SIZE_SQFT = AloftArea19.fromNumber(100, "sqft");
var TYPICAL_SPA_SIZE_SQFT = AloftArea19.fromNumber(64, "sqft");

// src/craftsman/calculator/1.0/index.ts
var CraftsmanReplacementCostCalcV1 = {
  version: "1.0",
  constants: {
    ADD_STRUCT_DEFAULT_SQFT,
    TYPICAL_POOL_SIZE_SQFT,
    TYPICAL_SHED_SIZE_SQFT,
    TYPICAL_SPA_SIZE_SQFT
  },
  getSFRCost({ costDataset, costMultiplier, effectiveYear }) {
    return (props) => getSFRCost(costDataset, costMultiplier, effectiveYear, props);
  },
  getManufacturedCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ sqft, quality }) => {
      const costData = costDataset.costData.manufactured;
      const { variable, fixed } = getVariableAndFixedCosts(costData, quality);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          fixed,
          costMultiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  // This is unfinished, do not use until the cost of additional bathrooms is handled properly.
  getMultiFamilyCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ avgUnitSqft, quality, units, zipCode }) => {
      const costData = costDataset.costData.multiFamily.twoOrThreeUnits;
      const { variable, fixed } = getVariableAndFixedCosts(costData, quality);
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const totalUnitSqft = avgUnitSqft.mul(units);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: totalUnitSqft.getUnitAmount("sqft") }],
          fixed: fixed.mul(units),
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  // NOTE: getBathroomsCost should not be used for getting the replacement cost of a bathroom
  // it should be used only for determining the bathroom adjustment
  getFullBathroomsCost(settings) {
    return (props) => getFullBathroomsCost(settings, props);
  },
  getHalfBathroomsCost(settings) {
    return (props) => getHalfBathroomsCost(settings, props);
  },
  getGarageCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ quality, sqft, zipCode, propertyType, garageType = "detached" }) => {
      let costData;
      switch (garageType) {
        case "detached":
          costData = costDataset.costData.garage.detached;
          break;
        case "attached":
          costData = costDataset.costData.garage.attached;
          break;
        default:
          throw new Error(`Garage type of ${garageType} are not yet supported`);
      }
      const { variable, fixed } = getVariableAndFixedCostsByPropertyType(
        costData,
        quality,
        propertyType
      );
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const sqftVal = sqft.getUnitAmount("sqft");
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqftVal }],
          fixed: sqftVal > 0 ? fixed : AloftPrice21.zero,
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  getCarportCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ sqft, quality, propertyType, zipCode }) => {
      const carportCostData = costDataset.costData.carport;
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const { variable } = getVariableCostsByPropertyType(carportCostData, quality, propertyType);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  getHeatingAndCoolingCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ sqft, hasCooling = false }) => {
      const costPerSqft = hasCooling ? AloftPrice21.fromDollarLike(costDataset.costData.heatingAndCooling) : AloftPrice21.fromDollarLike(costDataset.costData.heating);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable: costPerSqft, units: sqft.getUnitAmount("sqft") }],
          costMultiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  getTotalBasementAreaCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ totalArea, quality, propertyType, zipCode }) => {
      const totalAreaCostData = costDataset.costData.basement.totalArea;
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const { variable } = getVariableCostsByPropertyType(totalAreaCostData, quality, propertyType);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: totalArea.getUnitAmount("sqft") }],
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  getFinishedBasementAreaCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ finishedArea, quality, propertyType, zipCode }) => {
      const finishedAreaCostData = costDataset.costData.basement.finishedArea;
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const { variable } = getVariableCostsByPropertyType(
        finishedAreaCostData,
        quality,
        propertyType
      );
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: finishedArea.getUnitAmount("sqft") }],
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  getShedCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ hasFeature, sqft = TYPICAL_SHED_SIZE_SQFT, quality, zipCode }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const costData = costDataset.costData.shed;
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const { variable, fixed } = getVariableAndFixedCosts(costData, quality, 1);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          fixed,
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  getWorkshopCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({
      hasFeature,
      sqft = ADD_STRUCT_DEFAULT_SQFT,
      quality,
      zipCode
    }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const costData = costDataset.costData.workshop;
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const { variable, fixed } = getVariableAndFixedCosts(costData, quality, 1);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          fixed,
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  getBarnCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ hasFeature, sqft = ADD_STRUCT_DEFAULT_SQFT, quality, zipCode }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const costData = costDataset.costData.barn;
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const { variable, fixed } = getVariableAndFixedCosts(costData, quality, 1);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          fixed,
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  },
  getPoolCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ hasFeature, sqft = TYPICAL_POOL_SIZE_SQFT, quality, zipCode }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const { fixed, variable240To480, variableOver480 } = costDataset.costData.pool;
      const fixedCost = fixed[quality - 1];
      const variable240To480Cost = variable240To480[quality - 1];
      const variableOver480Cost = variableOver480[quality - 1];
      if ((0, import_shared_utils63.isUndefined)(fixedCost) || (0, import_shared_utils63.isUndefined)(variable240To480Cost) || (0, import_shared_utils63.isUndefined)(variableOver480Cost)) {
        throw new Error(`Pool cost data for the given quality of ${quality} was not found`);
      }
      const fixedPrice = AloftPrice21.fromDollarLike(fixedCost);
      const variable240To480Price = AloftPrice21.fromDollarLike(variable240To480Cost);
      const variableOver480Price = AloftPrice21.fromDollarLike(variableOver480Cost);
      const sqftOver480 = sqft.gt(AloftArea20.fromNumber(480, "sqft")) ? sqft.sub(AloftArea20.fromNumber(480, "sqft")) : AloftArea20.zero;
      const sqftBetween240To480 = sqft.gt(AloftArea20.fromNumber(240, "sqft")) ? sqft.sub(AloftArea20.fromNumber(240, "sqft")).sub(sqftOver480) : AloftArea20.zero;
      const over480Cost = {
        variable: variableOver480Price,
        units: sqftOver480.getUnitAmount("sqft")
      };
      const between240And480Cost = {
        variable: variable240To480Price,
        units: sqftBetween240To480.getUnitAmount("sqft")
      };
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return calculateCosts({
        variableCosts: [over480Cost, between240And480Cost],
        fixed: fixedPrice,
        zipMultiplier: multiplier,
        costMultiplier,
        historicalIndex
      });
    };
  },
  getSpaCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ hasFeature, sqft = TYPICAL_SPA_SIZE_SQFT, quality, zipCode }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const { fixed, variableOver70 } = costDataset.costData.spa;
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const fixedCost = fixed[quality - 1];
      const variableOver70Cost = variableOver70[quality - 1];
      if ((0, import_shared_utils63.isUndefined)(fixedCost) || (0, import_shared_utils63.isUndefined)(variableOver70Cost)) {
        throw new Error(`Spa cost data for the given quality of ${quality} was not found`);
      }
      const sqftOver70 = sqft.gt(AloftArea20.fromNumber(70, "sqft")) ? sqft.sub(AloftArea20.fromNumber(70, "sqft")) : AloftArea20.zero;
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return calculateCosts({
        variableCosts: [
          {
            variable: AloftPrice21.fromDollarLike(variableOver70Cost),
            units: sqftOver70.getUnitAmount("sqft")
          }
        ],
        fixed: AloftPrice21.fromDollarLike(fixedCost),
        costMultiplier,
        zipMultiplier: multiplier,
        historicalIndex
      });
    };
  },
  getPorchCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({
      hasFeature,
      type,
      sqft = ADD_STRUCT_DEFAULT_SQFT,
      quality,
      propertyType,
      zipCode
    }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality) || (0, import_shared_utils63.isUndefined)(type) || (0, import_shared_utils63.isUndefined)(propertyType)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const multiplier = getZipMultiplier(costDataset, zipCode);
      if (type === "screen") {
        return _calculateScreenedCost(
          { costDataset, costMultiplier, effectiveYear },
          { quality, struct: "porch", sqft, propertyType },
          multiplier
        );
      }
      const { variable } = getVariableCostsByPropertyType(
        costDataset.costData.porch[type],
        quality,
        propertyType
      );
      if ((0, import_shared_utils63.isUndefined)(variable)) {
        throw new Error(`Porch Cost data for the given quality of ${quality} was not found`);
      }
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        })
      };
    };
  },
  getPatioCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({
      hasFeature,
      type,
      sqft = ADD_STRUCT_DEFAULT_SQFT,
      propertyType,
      quality,
      zipCode
    }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality) || (0, import_shared_utils63.isUndefined)(type) || (0, import_shared_utils63.isUndefined)(propertyType)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const multiplier = getZipMultiplier(costDataset, zipCode);
      if (type === "screen") {
        return _calculateScreenedCost(
          { costDataset, costMultiplier, effectiveYear },
          {
            quality,
            struct: "patio",
            sqft,
            propertyType
          },
          multiplier
        );
      }
      const { variable } = getVariableCostsByPropertyType(
        costDataset.costData.patio[type],
        quality,
        propertyType
      );
      if ((0, import_shared_utils63.isUndefined)(variable)) {
        throw new Error(`Patio Cost data for the given quality of ${quality} was not found`);
      }
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        })
      };
    };
  },
  getDeckCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({
      hasFeature,
      type,
      sqft = ADD_STRUCT_DEFAULT_SQFT,
      quality,
      propertyType,
      zipCode
    }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality) || (0, import_shared_utils63.isUndefined)(type) || (0, import_shared_utils63.isUndefined)(propertyType)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const multiplier = getZipMultiplier(costDataset, zipCode);
      if (type === "screen") {
        return _calculateScreenedCost(
          { costDataset, costMultiplier, effectiveYear },
          { quality, struct: "deck", sqft, propertyType },
          multiplier
        );
      }
      const { variable } = getVariableCostsByPropertyType(
        costDataset.costData.deck[type],
        quality,
        propertyType
      );
      if ((0, import_shared_utils63.isUndefined)(variable)) {
        throw new Error(`Deck Cost data for the given quality of ${quality}  was not found`);
      }
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        })
      };
    };
  },
  getAtticCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({
      hasFeature,
      sqft = ADD_STRUCT_DEFAULT_SQFT,
      propertyType,
      quality,
      zipCode
    }) => {
      if (!hasFeature || (0, import_shared_utils63.isUndefined)(quality)) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      const multiplier = getZipMultiplier(costDataset, zipCode);
      const { variable } = getVariableCostsByPropertyType(
        costDataset.costData.attic,
        quality,
        propertyType
      );
      if ((0, import_shared_utils63.isUndefined)(variable)) {
        throw new Error(`Attic Cost data for the given quality of ${quality}  was not found`);
      }
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable, units: sqft.getUnitAmount("sqft") }],
          costMultiplier,
          zipMultiplier: multiplier,
          historicalIndex
        })
      };
    };
  },
  getADUCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({
      quality,
      sqft,
      zipCode,
      corners = DEFAULT_CORNERS,
      fullBaths = ZERO,
      halfBaths = ZERO
    }) => {
      const propertyType = "singleFamilyResidence";
      return sumTotalCosts([
        getSFRCost(costDataset, costMultiplier, effectiveYear, {
          quality,
          sqft,
          zipCode,
          corners
        }),
        getFullBathroomsCost(
          { costDataset, costMultiplier, effectiveYear },
          { fullBaths, quality, propertyType, zipCode }
        ),
        getHalfBathroomsCost(
          { costDataset, costMultiplier, effectiveYear },
          { halfBaths, quality, propertyType, zipCode }
        )
      ]);
    };
  },
  getFireplaceCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ type, count, zipCode }) => {
      if (count === 0) {
        return {
          totalCost: AloftPrice21.zero,
          multiplierBreakdown: {
            costOnly: AloftPrice21.zero,
            zipOnly: AloftPrice21.zero,
            none: AloftPrice21.zero
          }
        };
      }
      let fireplaceCostData;
      switch (type) {
        case "freestanding":
          fireplaceCostData = costDataset.costData.fireplace.freestanding;
          break;
        case "zeroClearance":
          fireplaceCostData = costDataset.costData.fireplace.zeroClearance;
          break;
        case "masonry":
          fireplaceCostData = costDataset.costData.fireplace.masonry;
          break;
      }
      const fireplaceCost = AloftPrice21.fromDollarLike(fireplaceCostData);
      const zipMultiplier = getZipMultiplier(costDataset, zipCode);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      return {
        ...calculateCosts({
          variableCosts: [{ variable: fireplaceCost, units: count }],
          costMultiplier,
          zipMultiplier,
          roundVariable: true,
          historicalIndex
        }),
        unit: "unit"
      };
    };
  },
  getFoundationCost({ costDataset, costMultiplier, effectiveYear }) {
    return ({ foundationType, sqft, zipCode }) => {
      const costData = costDataset.costData.foundation;
      const zipMultiplier = getZipMultiplier(costDataset, zipCode);
      const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
      const units = foundationType === "slab" ? sqft.getUnitAmount("sqft") : 0;
      const variable = AloftPrice21.fromDollarLike(costData.slab.variable);
      return {
        ...calculateCosts({
          variableCosts: [
            {
              variable,
              units
            }
          ],
          costMultiplier,
          zipMultiplier,
          historicalIndex
        }),
        unit: "sqft"
      };
    };
  }
};
function getSFRCost(costDataset, costMultiplier, effectiveYear, { quality, zipCode, sqft, corners = DEFAULT_CORNERS }) {
  let costData;
  switch (corners) {
    case DEFAULT_CORNERS:
      costData = costDataset.costData.singleFamily.sixCorners;
      break;
    default:
      throw new Error(`SFR with ${corners} corners not yet supported`);
  }
  const { variable, fixed } = getVariableAndFixedCosts(costData, quality, 0.1);
  const zipMultiplier = getZipMultiplier(costDataset, zipCode);
  const units = sqft.getUnitAmount("sqft");
  const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
  return {
    ...calculateCosts({
      variableCosts: [{ variable, units }],
      fixed,
      costMultiplier,
      zipMultiplier,
      historicalIndex
    }),
    unit: "sqft"
  };
}
function getFullBathroomsCost({ costDataset, costMultiplier, effectiveYear }, { fullBaths: units, quality, propertyType, zipCode }) {
  const isManufacturedHome = propertyType === "manufacturedHome";
  const bathroomCosts = isManufacturedHome ? costDataset.costData.manufacturedBaths : costDataset.costData.bathrooms;
  const zipMultiplier = isManufacturedHome ? 1 : getZipMultiplier(costDataset, zipCode);
  const { costPerFullBath: variable } = getBathroomCostsByPropertyType(
    bathroomCosts,
    quality,
    propertyType
  );
  const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
  return {
    ...calculateCosts({
      variableCosts: [{ variable, units }],
      costMultiplier,
      zipMultiplier,
      roundVariable: true,
      historicalIndex
    }),
    unit: "unit"
  };
}
function getHalfBathroomsCost({ costDataset, costMultiplier, effectiveYear }, { halfBaths: units, quality, propertyType, zipCode }) {
  const isManufacturedHome = propertyType === "manufacturedHome";
  const bathroomCosts = isManufacturedHome ? costDataset.costData.manufacturedBaths : costDataset.costData.bathrooms;
  const zipMultiplier = isManufacturedHome ? 1 : getZipMultiplier(costDataset, zipCode);
  const { costPerHalfBath: variable } = getBathroomCostsByPropertyType(
    bathroomCosts,
    quality,
    propertyType
  );
  const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
  return {
    ...calculateCosts({
      variableCosts: [{ variable, units }],
      costMultiplier,
      zipMultiplier,
      roundVariable: true,
      historicalIndex
    }),
    unit: "unit"
  };
}
function _calculateScreenedCost({ costDataset, costMultiplier, effectiveYear }, {
  quality,
  struct,
  sqft,
  propertyType
}, multiplier) {
  const { variable } = getVariableCostsByPropertyType(
    costDataset.costData[struct].screen,
    quality,
    propertyType
  );
  const { variable: coveredStructVariable } = getVariableCostsByPropertyType(
    costDataset.costData[struct].covered,
    quality,
    propertyType
  );
  if ((0, import_shared_utils63.isUndefined)(variable) || (0, import_shared_utils63.isUndefined)(coveredStructVariable)) {
    throw new Error(`Screen ${struct} Cost data for the given quality of ${quality} was not found`);
  }
  const screenCostFor3Sides = {
    variable: variable.mul(3),
    units: Math.sqrt(sqft.getUnitAmount("sqft"))
  };
  const coveredStructCost = {
    variable: coveredStructVariable,
    units: sqft.getUnitAmount("sqft")
  };
  const historicalIndex = getCraftsmanHistoricalCostIndex(costDataset.version, effectiveYear);
  return calculateCosts({
    variableCosts: [screenCostFor3Sides, coveredStructCost],
    costMultiplier,
    zipMultiplier: multiplier,
    historicalIndex
  });
}

// src/craftsman/calculator/types.ts
import { z as z91 } from "zod";
var schCraftsmanReplacementCostCalcVersion = z91.literal("1.0");
var _schCraftsmanManufacturedQualityClasses = schFiveTierQualityScale.multipleOf(0.1);
var _schCraftsmanThreeTierQualityClasses = schThreeTierQualityScale.multipleOf(0.1);

// src/craftsman/calculator/index.ts
var CraftsmanCalculators = [CraftsmanReplacementCostCalcV1];
function getCraftsmanReplacementCostCalc(version) {
  const calculator = CraftsmanCalculators.find((c) => c.version === version);
  if ((0, import_shared_utils64.isUndefined)(calculator)) {
    throw new Error(`Craftsman Cost Calculator with version ${version} was not found`);
  }
  return calculator;
}

// src/craftsman/getDatasetForOrder.ts
var DATASET_LOOKUP = {
  "2024": "2024.1",
  "2025": "2025.1",
  "2026": "2026.1"
};
var getMostRecentDataset = () => {
  const keys = Object.keys(DATASET_LOOKUP);
  const lastKey = keys.sort()[keys.length - 1];
  return DATASET_LOOKUP[lastKey];
};
var getDatasetForOrder = ({
  effectiveDate,
  creationDate
}) => {
  const effectiveYear = effectiveDate.getYear().toString();
  const creationYear = creationDate.getYear().toString();
  if (effectiveYear > creationYear) {
    const effectiveYearDataset = DATASET_LOOKUP[effectiveYear];
    if (effectiveYearDataset)
      return effectiveYearDataset;
  }
  const creationYearDataset = DATASET_LOOKUP[creationYear];
  if (creationYearDataset)
    return creationYearDataset;
  return getMostRecentDataset();
};

// src/craftsman/index.ts
var DATASET_TO_CALC_VERSION_MAP = {
  "2024.1": ["1.0"],
  "2025.1": ["1.0"],
  "2026.1": ["1.0"]
};
var ADJUSTMENT_VERSION_TO_COST_VERSION_MAP = {
  "1.0": [
    { datasetVersion: "2024.1", calculatorVersion: "1.0" },
    { datasetVersion: "2025.1", calculatorVersion: "1.0" },
    { datasetVersion: "2026.1", calculatorVersion: "1.0" }
  ]
};
var getCraftsmanCost = ({
  calculatorVersion,
  datasetVersion,
  costMultiplier,
  effectiveYear
}) => {
  const matchingCalculatorVersions = DATASET_TO_CALC_VERSION_MAP[datasetVersion];
  if (!matchingCalculatorVersions.includes(calculatorVersion)) {
    throw new Error(
      `Craftsman dataset version (${datasetVersion}) and calculator version (${calculatorVersion}) are not compatible`
    );
  }
  const dataset = getCraftsmanCostDataset(datasetVersion);
  const rawCalculator = getCraftsmanReplacementCostCalc(calculatorVersion);
  const calculator = Object.fromEntries(
    Object.entries(rawCalculator).map(([key, value]) => {
      if (typeof value === "function") {
        return [
          key,
          value({
            costDataset: dataset,
            costMultiplier: (0, import_shared_utils65.isDefined)(costMultiplier) ? costMultiplier : 1,
            effectiveYear: (0, import_shared_utils65.isDefined)(effectiveYear) ? effectiveYear : AloftDate14.schema.parse(AloftDate14.today()).getYear().toString()
          })
        ];
      }
      return [key, value];
    })
  );
  return calculator;
};
var getCraftsmanAdjustment = ({
  adjustmentVersion,
  datasetVersion,
  calculatorVersion,
  costMultiplier,
  effectiveYear
}) => {
  const matchingAdjustmentVersions = ADJUSTMENT_VERSION_TO_COST_VERSION_MAP[adjustmentVersion];
  if (!matchingAdjustmentVersions.some(
    (versions) => versions.datasetVersion === datasetVersion && versions.calculatorVersion === calculatorVersion
  )) {
    throw new Error(
      `Craftsman Adjustment version (${adjustmentVersion}) and cost versions (${datasetVersion}, ${calculatorVersion}) are not compatible`
    );
  }
  const costCalculator = getCraftsmanCost({
    datasetVersion,
    calculatorVersion,
    costMultiplier,
    effectiveYear
  });
  const internalAdjustmentCalculator = getCraftsmanAdjustmentCalcInternal(adjustmentVersion);
  const adjustmentCalculator = Object.fromEntries(
    Object.entries(internalAdjustmentCalculator).map(([key, value]) => {
      if (typeof value === "function") {
        return [key, value(costCalculator)];
      }
      return [key, value];
    })
  );
  return adjustmentCalculator;
};

// src/api/v2/orders/index.ts
var schOrderVersion = z92.union([z92.literal(1), z92.literal(2)]);
var schInspectionData = z92.object({
  hasInspection: z92.boolean().optional(),
  reportId: z92.string().nullable().optional()
});
var schRevisionType = z92.enum(["rov", "revision"]);
var schRevisionData = z92.object({
  originalOrderId: z92.string(),
  comparables: z92.array(
    z92.object({
      address: z92.string(),
      dataSource: z92.string(),
      dateOfSale: z92.string(),
      justification: z92.string()
    })
  ).optional().nullable(),
  requesterName: z92.string(),
  requesterEmail: z92.string(),
  requesterPhone: z92.string(),
  requestDescription: z92.string(),
  revisionType: schRevisionType,
  requestedAt: schAloftTime,
  revisionRequestId: z92.string(),
  inspectionId: z92.string()
});
var schOrderOptions = z92.object({
  costToCure: z92.boolean().optional(),
  arv: z92.boolean().optional()
});
var schOrderInput = z92.object({
  address: schAddressForm.optional(),
  // deprecated
  effectiveDate: schAloftDate,
  orderNumber: z92.string().optional(),
  propertyType: schPropertyTypes,
  // deprecated
  isCraftsman: z92.boolean().optional(),
  // deprecated
  version: schOrderVersion.default(1),
  craftsmanAdjustmentVersion: schCraftsmanAdjustmentsCalcVersion.default("1.0"),
  craftsmanCalculatorVersion: schCraftsmanReplacementCostCalcVersion.default("1.0"),
  craftsmanDatasetVersion: schCraftsmanCostDatasetVersion.default("2024.1"),
  costMultiplier: z92.number().optional(),
  licenseState: z92.string().optional(),
  licenseNumber: z92.string().optional(),
  licenseExpiration: schAloftDate.optional(),
  licenseType: z92.string().optional(),
  inspectionData: schInspectionData.optional(),
  revisionData: schRevisionData.optional(),
  previousRevisionsData: z92.array(schRevisionData).optional(),
  revisionRequestId: z92.string().optional(),
  inspectionId: z92.string().optional(),
  options: schOrderOptions.optional(),
  appraisifyName: z92.string().optional(),
  appraisifyAddress: z92.string().optional(),
  isMock: z92.boolean().optional()
});
var APPRAISIFY_ADDRESS = "9450 SW Gemini Dr, Suite 34868 Beaverton, Oregon 97008-7105 USA";
var APPRAISIFY_NAME = "Appraisify, inc";
var schAutofillType = z92.enum(["listingID", "publicRecord", "none"]);
var schTkv2PostOrderInput = schOrderInput.extend({
  // Autofill fields: publicRecord/none requires nothing besides this autofillType
  autofillType: schAutofillType.optional(),
  // MLS autofill fields
  mls: schMLSID.optional(),
  listingID: z92.string().optional(),
  supplementWithPublicRecord: z92.boolean().optional(),
  address: schAddressForm,
  appraisalType: z92.string().optional(),
  clientName: z92.string().optional(),
  dueDate: schAloftDate.optional(),
  inspectionDate: schAloftDate.optional(),
  appraiserInstructions: z92.string().optional(),
  intendedUsers: z92.string().optional(),
  intendedUse: z92.string().optional(),
  inspectorType: z92.string().optional(),
  borrowerName: z92.string().optional(),
  inspectifyOrder: z92.boolean().optional(),
  mock: z92.boolean().optional()
});
var schToolkitOrder = z92.object({
  id: schToolkitOrderID,
  subjectAddress: schAddress.optional(),
  // deprecated
  ownerID: schToolkitAccountID.optional(),
  createdAt: schAloftTime.optional(),
  modifiedAt: schAloftTime.optional(),
  isArchived: z92.boolean().optional(),
  isDeleted: z92.boolean().optional(),
  isMock: z92.boolean().optional(),
  isTraining: z92.boolean().optional(),
  isCompleted: z92.boolean().optional(),
  requiresPrefill: z92.boolean().optional(),
  isInspectifyOrder: z92.boolean().optional(),
  input: schOrderInput,
  appraisalType: z92.string().optional(),
  clientName: z92.string().optional(),
  appraiserFee: schAloftPrice.optional(),
  dueDate: schAloftDate.optional(),
  inspectionDate: schAloftDate.optional(),
  appraiserInstructions: z92.string().optional(),
  intendedUsers: z92.string().optional(),
  intendedUse: z92.string().optional(),
  inspectorType: z92.string().optional(),
  borrowerName: z92.string().optional(),
  signedAt: schAloftTime.optional(),
  appraisifyFee: schAloftPrice.optional(),
  isRevision: z92.boolean().optional(),
  originalOrderId: z92.string().nullable().optional()
});
var schCreateOrderResponse = schToolkitOrder.extend({
  warnings: z92.array(z92.string()).optional()
});
var schCreateAllTrainingOrdersResponse = z92.array(z92.string());
var schTkv2OrderListResponse = z92.object({
  results: z92.array(schToolkitOrder),
  pagination: schPagination
});
var schCreateOrderRequestBody = z92.object({
  input: schTkv2PostOrderInput,
  subject: schXMLPropertyResult.optional()
});
var schRevisionDataRequestBody = z92.object({
  originalOrderId: z92.string(),
  comparables: z92.array(
    z92.object({
      address: z92.string(),
      dataSource: z92.string(),
      dateOfSale: z92.string(),
      justification: z92.string()
    })
  ).optional().nullable(),
  requesterName: z92.string(),
  requesterEmail: z92.string(),
  requesterPhone: z92.string(),
  requestDescription: z92.string(),
  revisionType: schRevisionType,
  requestedAt: z92.string(),
  revisionRequestId: z92.string()
});
var schCreateRevisionRequestBody = z92.object({
  revisionData: schRevisionDataRequestBody,
  appraiserFee: z92.string().nullable(),
  appraisifyFee: z92.string().nullable(),
  dueDate: z92.string(),
  inspectionId: z92.string()
});
var schCreateInspectifyOrderRequestBody = z92.object({
  address: schAddressForm,
  effectiveDate: z92.string(),
  orderNumber: z92.string(),
  propertyType: z92.enum([
    schPropertyTypes.Values.singleFamilyResidence,
    schPropertyTypes.Values.multiFamily,
    schPropertyTypes.Values.manufacturedHome
  ]),
  appraisalType: z92.string(),
  clientName: z92.string().nullable(),
  appraiserFee: z92.string().nullable(),
  appraisifyFee: z92.string().nullable(),
  dueDate: z92.string(),
  inspectionDate: z92.string().nullable(),
  appraiserInstructions: z92.string().nullable(),
  intendedUsers: z92.string().nullable(),
  intendedUse: z92.string().nullable(),
  inspectorType: z92.string(),
  borrowerName: z92.string().nullable(),
  licenseState: z92.string(),
  licenseNumber: z92.string(),
  licenseExpiration: z92.string(),
  licenseType: z92.string(),
  inspectionData: schInspectionData,
  inspectionId: z92.string().optional(),
  options: schOrderOptions.optional(),
  appraisifyAddress: z92.string().optional(),
  appraisifyName: z92.string().optional(),
  mock: z92.boolean().optional()
});
var schRescheduleTkv2OrderRequestBody = z92.object({
  dueDate: z92.string()
});
var schTkv2OrderPutRequestBody = z92.object({
  input: schOrderInput,
  isArchived: z92.boolean().optional(),
  isDeleted: z92.boolean().optional(),
  isTraining: z92.boolean().optional(),
  requiresPrefill: z92.boolean().optional(),
  intendedUsers: z92.string().optional(),
  intendedUse: z92.string().optional()
});
var schTrainingAddress = z92.enum(["1571BradfordTrace", "2665Dearborn", "6106Lakeshore"]);
var schCreateTrainingOrderRequestBody = z92.object({
  trainingAddress: schTrainingAddress
});
var schCreateAllTrainingOrdersRequestBody = z92.object({
  archived: z92.boolean().default(false)
});
var schPrefillOrderRequestBody = z92.object({
  orderID: schToolkitOrderID
});
var TKV2_ORDERS_API = {
  GET: {
    REQUEST: {
      QUERY_PARAMS: z92.object({
        limit: z92.number().optional(),
        next: z92.string().optional()
      })
    },
    RESPONSE: schTkv2OrderListResponse
  }
};
var TKV2_ORDER_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z92.object({
        orderID: schToolkitOrderID
      })
    },
    RESPONSE: schToolkitOrder
  },
  POST: {
    REQUEST: {
      BODY: schCreateOrderRequestBody
    },
    RESPONSE: schCreateOrderResponse
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z92.object({ orderID: schToolkitOrderID }),
      BODY: schTkv2OrderPutRequestBody
    },
    RESPONSE: schToolkitOrder
  }
};
var TRAINING_ORDER_API = {
  POST: {
    REQUEST: {
      BODY: schCreateTrainingOrderRequestBody
    },
    RESPONSE: schCreateOrderResponse
  }
};
var INSPECTIFY_ORDER_API = {
  POST: {
    REQUEST: {
      BODY: schCreateInspectifyOrderRequestBody
    },
    RESPONSE: schCreateOrderResponse
  }
};
var REVISION_API = {
  POST: {
    REQUEST: {
      BODY: schCreateRevisionRequestBody
    },
    RESPONSE: schCreateOrderResponse
  }
};
var TRAINING_ORDERS_API = {
  PUT: {
    REQUEST: {
      BODY: schCreateAllTrainingOrdersRequestBody
    },
    RESPONSE: schCreateAllTrainingOrdersResponse
  }
};
var PREFILL_ORDER_API = {
  POST: {
    REQUEST: {
      BODY: z92.object({
        orderID: schToolkitOrderID
      })
    },
    RESPONSE: schToolkitOrder
  }
};
var COMPLETE_TKV2_ORDERS_API = {
  PUT: {
    REQUEST: {
      PATH_PARAMS: z92.object({
        orderID: schToolkitOrderID
      })
    },
    RESPONSE: z92.string()
  }
};
var RESCHEDULE_TKV2_ORDER_API = {
  POST: {
    REQUEST: {
      PATH_PARAMS: z92.object({ orderID: schToolkitOrderID }),
      BODY: schRescheduleTkv2OrderRequestBody
    },
    RESPONSE: schToolkitOrder
  }
};
var CANCEL_TKV2_ORDER_API = {
  POST: {
    REQUEST: {
      PATH_PARAMS: z92.object({ orderID: schToolkitOrderID })
    },
    RESPONSE: schToolkitOrder
  }
};

// src/api/v2/pairedCost/index.ts
import { z as z93 } from "zod";
var saveAsDefaultQueryParam = { saveAsDefault: z93.string().optional() };
var TKV2_PAIRED_COST_RUN_COST_API = {
  POST: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam)
    },
    RESPONSE: z93.object({ changed: z93.number() })
  }
};
var TKV2_ORDER_REPLACEMENT_COST_SETTINGS_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam)
    },
    RESPONSE: schTkv2ReplacementCostSettings
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam),
      QUERY_PARAMS: z93.object(saveAsDefaultQueryParam),
      BODY: schTkv2ReplacementCostSettings
    },
    RESPONSE: schTkv2ReplacementCostSettings
  }
};
var TKV2_ORDER_PAIRED_COST_SETTINGS_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam)
    },
    RESPONSE: schTkv2PairedCostSettings
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam),
      QUERY_PARAMS: z93.object(saveAsDefaultQueryParam),
      BODY: schTkv2PairedCostSettings
    },
    RESPONSE: schTkv2PairedCostSettings
  }
};
var TKV2_ORDER_DEPRECIATION_SETTINGS_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam)
    },
    RESPONSE: schTkv2DepreciationSettings
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam),
      QUERY_PARAMS: z93.object(saveAsDefaultQueryParam),
      BODY: schTkv2DepreciationSettings
    },
    RESPONSE: schTkv2DepreciationSettings
  }
};
var ORDER_DEPRECIATION_SETTINGS_V2_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam)
    },
    RESPONSE: schDepreciationSettingsV2
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z93.object(orderIDPathParam),
      QUERY_PARAMS: z93.object(saveAsDefaultQueryParam),
      BODY: schDepreciationSettingsV2
    },
    RESPONSE: schDepreciationSettingsV2
  }
};

// src/api/v2/publicRecord/index.ts
import { z as z95 } from "zod";

// src/api/v2/publicRecord/types.ts
import { z as z94 } from "zod";
var schTkv2PublicRecord = z94.object({
  ParcelNumberRaw: z94.string().nullable(),
  PropertyAddressFull: z94.string().nullable(),
  PropertyAddressCity: z94.string().nullable(),
  PropertyAddressState: z94.string().nullable(),
  PropertyAddressZIP: z94.string().nullable(),
  SitusCounty: z94.string().nullable(),
  NeighborhoodCode: z94.string().nullable(),
  MinorCivilDivisionName: z94.string().nullable(),
  LegalDescription: z94.string().nullable(),
  PropertyUseGroup: z94.string().nullable(),
  YearBuilt: z94.number().nullable(),
  EffectiveYearBuilt: z94.number().nullable(),
  PartyOwner1NameFull: z94.string().nullable(),
  AssessorLastSaleAmount: schAloftPrice.nullable(),
  AssessorPriorSaleDate: schAloftDate.nullable(),
  AreaBuilding: schAloftArea.nullable(),
  AreaGross: schAloftArea.nullable(),
  AreaLotSF: schAloftArea.nullable(),
  RoomsAtticFlag: z94.boolean().nullable(),
  RoomsAtticArea: schAloftArea.nullable(),
  RoomsBasementArea: schAloftArea.nullable(),
  RoomsBasementAreaFinished: schAloftArea.nullable(),
  ParkingSpaceCount: z94.number().nullable(),
  DrivewayArea: schAloftArea.nullable(),
  PorchArea: schAloftArea.nullable(),
  PatioArea: schAloftArea.nullable(),
  DeckArea: schAloftArea.nullable(),
  PoolArea: schAloftArea.nullable(),
  BuildingsCount: z94.number().nullable(),
  PartyOwner2NameFull: z94.string().nullable(),
  PartyOwner3NameFull: z94.string().nullable(),
  PartyOwner4NameFull: z94.string().nullable(),
  ContactOwnerMailAddressFull: z94.string().nullable(),
  ContactOwnerMailAddressCity: z94.string().nullable(),
  ContactOwnerMailAddressState: z94.string().nullable(),
  ContactOwnerMailAddressZIP: z94.string().nullable(),
  CompanyFlag: z94.boolean().nullable(),
  TaxYearAssessed: z94.number().nullable(),
  TaxAssessedValueImprovements: schAloftPrice.nullable(),
  TaxAssessedValueLand: schAloftPrice.nullable(),
  TaxAssessedValueTotal: schAloftPrice.nullable(),
  TaxMarketValueYear: z94.number().nullable(),
  TaxMarketValueImprovements: schAloftPrice.nullable(),
  TaxMarketValueLand: schAloftPrice.nullable(),
  TaxMarketValueTotal: schAloftPrice.nullable(),
  TaxFiscalYear: z94.number().nullable(),
  TaxRateArea: z94.string().nullable(),
  TaxBilledAmount: schAloftPrice.nullable(),
  AssessorLastSaleDate: schAloftDate.nullable(),
  LastOwnershipTransferDocumentNumber: z94.string().nullable(),
  AssessorPriorSaleAmount: schAloftPrice.nullable(),
  RoomsCount: z94.number().nullable(),
  BathCount: z94.number().nullable(),
  BathPartialCount: z94.number().nullable(),
  BedroomsCount: z94.number().nullable(),
  StoriesCount: z94.number().nullable(),
  UnitsCount: z94.number().nullable(),
  StructureStyle: z94.string().nullable(),
  Exterior1Code: z94.string().nullable(),
  RoofMaterial: z94.string().nullable(),
  ViewDescription: z94.string().nullable(),
  ParkingGarage: z94.string().nullable(),
  ParkingGarageArea: schAloftArea.nullable(),
  ParkingCarport: z94.boolean().nullable(),
  ParkingCarportArea: schAloftArea.nullable(),
  HVACCoolingDetail: z94.string().nullable(),
  HVACHeatingDetail: z94.string().nullable(),
  HVACHeatingFuel: z94.string().nullable(),
  UtilitiesSewageUsage: z94.string().nullable(),
  UtilitiesWaterSource: z94.string().nullable(),
  Construction: z94.string().nullable(),
  Foundation: z94.string().nullable(),
  PlumbingFixturesCount: z94.number().nullable(),
  FlooringMaterialPrimary: z94.string().nullable(),
  GuestHouseArea: schAloftArea.nullable(),
  ShedArea: schAloftArea.nullable(),
  Zoning: z94.string().nullable()
});

// src/api/v2/publicRecord/index.ts
var TKV2_PUBLIC_RECORD_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z95.object(orderIDPathParam),
      QUERY_PARAMS: schFilledAddress
    },
    RESPONSE: z95.object({
      listing: schTkv2PublicRecord,
      source: schPublicRecordSource
    })
  }
};
var TKV2_PUBLIC_RECORDS_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z95.object(orderIDPathParam),
      QUERY_PARAMS: z95.object({
        addresses: z95.string()
      })
    },
    RESPONSE: z95.array(
      z95.object({
        listing: schTkv2PublicRecord,
        source: schPublicRecordSource,
        address: schFilledAddress
      })
    )
  }
};

// src/api/v2/studies/index.ts
import { z as z101 } from "zod";

// src/costData/schemasV2.ts
import { z as z96 } from "zod";
var schPropertyCostDataDocumentV2 = z96.object({
  // Not included in DwellingCost response. Manually entered by appraiser.
  additionalFeaturesCost: schAloftPrice.optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: schAloftPrice.optional(),
  runCost: z96.object({
    input: schCostDataInput,
    output: schCostDataOutput
  }).optional()
});
var schStudyCostDataResults = z96.record(z96.string(), schPropertyCostDataDocumentV2);
var schStudyCostDataResponseV2 = z96.object({
  results: schStudyCostDataResults.optional(),
  // indicates that the run cost data is stale
  isRunCostStale: z96.boolean().optional()
});
var schMarketAdjustmentDocument = z96.object({
  dateOfSaleAndListToSale: schAloftPrice,
  financialConcessions: schAloftPrice,
  saleType: schAloftPrice
});
var schStudyMarketAdjustmentAttachment = z96.object({
  results: z96.record(z96.string(), schMarketAdjustmentDocument)
});
var schTkv2PairedCostStudyScratch = z96.object({
  results: schStudyCostDataResults
});
var schTkv2PairedCostStudyContent = z96.object({
  type: z96.literal("pairedCost"),
  input: z96.object({}),
  scratch: schTkv2PairedCostStudyScratch.nullable(),
  output: z96.object({}).nullable()
});

// src/api/v2/studies/pairedSales.ts
import { z as z100 } from "zod";

// src/studies/v2/types.ts
import { z as z99 } from "zod";

// src/studies/types.ts
import { z as z98 } from "zod";

// src/studies/v2/analysisFeature.ts
import { z as z97 } from "zod";
var schPairedSalesCustomAnalysisFeature = z97.object({
  t: z97.literal("custom"),
  name: z97.string()
});
var schPairedSalesAnalysisFeature = schAdjustTermKey.or(
  schPairedSalesCustomAnalysisFeature
);
var schStudiesPairAdjustmentsKey = z97.union([schAdjustTermKey, z97.literal("custom")]);

// src/studies/types.ts
var schGeoCoordinate = z98.tuple([z98.number(), z98.number()]);
var schGeoCoordinates = z98.array(schGeoCoordinate);
var schSavedMatchProperty = z98.object({
  coords: schGeoCoordinate,
  propertyType: z98.string(),
  propertySubType: z98.string(),
  marketingCommentary: z98.string(),
  address: z98.string(),
  zipCode: z98.string(),
  view: z98.string(),
  designStyle: z98.string(),
  heatingCooling: z98.string(),
  hasBasement: z98.boolean(),
  hasAttachment: z98.boolean(),
  bedrooms: z98.number(),
  bathrooms: z98.number(),
  halfBathrooms: z98.number(),
  threeQuarterBathrooms: z98.number(),
  totalBathrooms: z98.number(),
  stories: z98.number(),
  attachedGarageParkingSpacesCount: z98.number(),
  glaSqFt: z98.number(),
  basementSqFt: z98.number(),
  siteSizeSqFt: z98.number(),
  yearBuilt: z98.number(),
  contractDate: z98.number(),
  saleDate: z98.number(),
  salePrice: z98.number(),
  partitionKey: z98.string()
}).partial();
var schSavedMatchCriteriaItem = z98.discriminatedUnion("t", [
  z98.object({ t: z98.literal("any"), value: z98.never().optional() }),
  z98.object({ t: z98.literal("equal"), value: z98.never().optional() }),
  z98.object({ t: z98.literal("less"), value: schDynamicScalar }),
  z98.object({ t: z98.literal("greater"), value: schDynamicScalar }),
  z98.object({ t: z98.literal("withinUnit"), value: schDynamicScalar }),
  z98.object({ t: z98.literal("withinPercent"), value: schDynamicScalar })
]);
var schSavedMatchedCriteria = z98.record(schSavedMatchProperty.keyof(), schSavedMatchCriteriaItem);
var schSavedDifferenceCriteriaItem = z98.object({
  t: z98.enum(["any", "includeKeyword", "omitKeyword", "address", "equal"]),
  key: schSavedMatchProperty.keyof().optional(),
  value: z98.union([z98.string(), z98.number()]).optional()
});
var schSavedDifferenceCriteria = z98.object({
  p1: schSavedDifferenceCriteriaItem,
  p2: schSavedDifferenceCriteriaItem
});
var schSavedPairCriteria = z98.object({
  version: z98.literal(1),
  matchCriteria: schSavedMatchedCriteria,
  differenceCriteria: schSavedDifferenceCriteria
});
var schRadiusGeoSearch = z98.object({
  t: z98.literal("radius"),
  coord: schGeoCoordinate,
  radiusInMeters: z98.number()
});
var schPolygonGeoSearch = z98.object({
  t: z98.literal("polygon"),
  coords: z98.array(schGeoCoordinate)
});
var schGeoSearch = z98.discriminatedUnion("t", [schRadiusGeoSearch, schPolygonGeoSearch]);
var schStudiesSearch = z98.object({
  filters: schGeoListingsFilters,
  pairCriteria: schSavedPairCriteria,
  geoSearch: schGeoSearch
});
var schReconciledValue = z98.union([schAloftPrice, z98.number()]);
var schPair = z98.object({
  p1: schToolkitProperty,
  p2: schToolkitProperty,
  adjustments: z98.record(schStudiesPairAdjustmentsKey, schAloftPrice),
  additionalFeature1Title: z98.string().optional(),
  additionalFeature2Title: z98.string().optional(),
  additionalFeature3Title: z98.string().optional()
});
var schSelectedPairs = z98.array(schPair);
var schToolkitStudyBodyV1 = z98.object({
  search: schStudiesSearch,
  notes: z98.string(),
  reconciledValue: schReconciledValue,
  selectedPairs: schSelectedPairs
});
var schToolkitStudyV1 = z98.object({
  version: z98.literal(1),
  id: schToolkitStudyID,
  createdBy: schToolkitAccountID,
  createdAt: schAloftTime,
  modifiedAt: schAloftTime,
  analysisFeature: schPairedSalesAnalysisFeature,
  // TODO: Check if this is the correct set
  propertyType: schPropertyTypes,
  mlsID: z98.string(),
  body: schToolkitStudyBodyV1
  // Add isArchived?
});
var _schToolkitStudyV1Request = schToolkitStudyV1.omit({
  id: true,
  createdAt: true,
  modifiedAt: true
});

// src/studies/v2/types.ts
var schPairedSalesInput = z99.object({
  analysisFeature: schPairedSalesAnalysisFeature,
  propertyType: schPropertyTypes,
  mlsID: z99.string()
});
var schPairedSalesBody = z99.object({
  search: schStudiesSearch,
  notes: z99.string(),
  reconciledValue: schReconciledValue,
  selectedPairs: schSelectedPairs
});
var schPairedSalesOutput = z99.object({});
var schPairedSalesUpdateRequest = z99.object({
  body: schPairedSalesBody.optional(),
  addToExport: z99.boolean().optional(),
  isDeleted: z99.boolean().optional()
});
var schPairedSalesStudy = z99.object({
  id: schToolkitStudyID,
  ownerID: schToolkitAccountID,
  createdAt: schAloftTime,
  modifiedAt: schAloftTime,
  input: schPairedSalesInput,
  body: schPairedSalesBody,
  // TODO: Make this optional when we support in-progress paired Sales
  isExported: z99.boolean()
});
var schPairedSalesCreateRequest = schPairedSalesStudy.pick({
  input: true,
  body: true
});
var schPairedSalesListResponse = z99.object({
  results: z99.array(schPairedSalesStudy).optional(),
  _pagination: schPagination.optional()
});

// src/api/v2/studies/pairedSales.ts
var schReqQueryParams = z100.object({
  limit: z100.number().optional(),
  next: z100.string().optional(),
  orderID: schToolkitOrderID.optional()
});
var schResQueryParams = z100.object({
  orderID: schToolkitOrderID.optional()
});
var PAIRED_SALES_API = {
  GET: {
    REQUEST: {
      QUERY_PARAMS: schReqQueryParams
    },
    RESPONSE: schPairedSalesListResponse
  },
  POST: {
    REQUEST: {
      BODY: schPairedSalesCreateRequest,
      QUERY_PARAMS: schResQueryParams
    },
    RESPONSE: schPairedSalesStudy
  }
};
var PAIRED_SALES_SINGLE_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z100.object({
        studyID: schToolkitStudyID
      }),
      QUERY_PARAMS: z100.object({
        orderID: schToolkitOrderID.optional()
      })
    },
    RESPONSE: schPairedSalesStudy
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z100.object({
        studyID: schToolkitStudyID
      }),
      QUERY_PARAMS: z100.object({
        orderID: schToolkitOrderID.optional()
      }),
      BODY: schPairedSalesUpdateRequest
    },
    RESPONSE: schPairedSalesStudy
  }
};

// src/api/v2/studies/index.ts
var schTkv2StudyInput = z101.unknown();
var schTkv2StudyScratch = z101.unknown();
var schTkv2StudyOutput = z101.unknown();
var schTkv2StudyType = z101.enum(["pairedCost", "pairedSales"]);
var schTkv2OrderStudyMetadata = z101.unknown();
var schTkv2OrderStudyEdge = z101.object({
  orderID: schToolkitOrderID,
  studyID: schToolkitStudyID,
  isActive: z101.boolean(),
  body: schTkv2OrderStudyMetadata
});
var schTkv2OrderStudyEdgeGetRequest = schTkv2OrderStudyEdge.pick({
  orderID: true,
  studyID: true
});
var schTkv2OrderStudyEdgeListRequest = schTkv2OrderStudyEdge.pick({
  orderID: true
});
var schTkv2Study = z101.object({
  id: schToolkitStudyID,
  ownerID: schToolkitAccountID,
  createdAt: schAloftTime,
  modifiedAt: schAloftTime,
  type: schTkv2StudyType,
  input: schTkv2StudyInput,
  scratch: schTkv2StudyScratch.optional(),
  output: schTkv2StudyOutput.optional()
});
var schTkv2PairedSalesStudyContent = z101.object({
  type: z101.literal("pairedSales"),
  input: z101.unknown(),
  scratch: z101.unknown(),
  output: z101.unknown()
});
var schTkv2StudyContent = z101.discriminatedUnion("type", [
  schTkv2PairedCostStudyContent,
  schTkv2PairedSalesStudyContent
]);
var schTkv2StudyListResponse = z101.object({
  results: z101.array(schTkv2Study)
});
var schTkv2StudyGetRequest = z101.object({
  orderID: schToolkitOrderID,
  studyID: schToolkitStudyID
});
var schTkv2StudyPostRequestBody = z101.object({
  input: schTkv2StudyInput.optional(),
  type: schTkv2StudyType
});
var schTkv2StudyPutRequestBody = z101.object({
  id: schToolkitStudyID,
  ownerID: schToolkitAccountID,
  input: schTkv2StudyInput.optional(),
  scratch: schTkv2StudyScratch.optional(),
  output: schTkv2StudyOutput.optional()
});
var TKV2_STUDIES_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z101.object({
        orderID: schToolkitOrderID
      })
    },
    RESPONSE: schTkv2StudyListResponse
  }
};
var TKV2_STUDY_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z101.object({
        orderID: schToolkitOrderID,
        studyID: schToolkitStudyID
      })
    },
    RESPONSE: z101.union([schTkv2Study, z101.object({ message: z101.string() })])
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: z101.object({
        orderID: schToolkitOrderID
      }),
      BODY: schTkv2StudyPostRequestBody
    },
    RESPONSE: z101.union([schTkv2Study, z101.object({ message: z101.string() })])
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z101.object({
        orderID: schToolkitOrderID,
        studyID: schToolkitStudyID
      }),
      BODY: schTkv2StudyPutRequestBody
    },
    RESPONSE: z101.union([schTkv2Study, z101.object({ message: z101.string() })])
  }
};

// src/api/v2/studyAttachments/index.ts
import { z as z102 } from "zod";
var schTkv2StudyAttachmentType = z102.enum(["subject"]);
var schTkv2StudyAttachmentInfo = z102.object({
  id: z102.string(),
  studyID: z102.string(),
  type: schTkv2StudyAttachmentType
});
var schTkv2StudyAttachmentBody = z102.object({
  type: z102.literal("subject"),
  body: z102.unknown()
});
var schTkv2StudyAttachment = z102.intersection(
  schTkv2StudyAttachmentInfo,
  schTkv2StudyAttachmentBody
);

// src/api/v2/autofill/index.ts
import { z as z103 } from "zod";
var schAutofillPropertyDataRequest = z103.object({
  address: schFilledAddress,
  effectiveYear: z103.number(),
  xmlProperty: schXMLPropertyResult.optional(),
  propertyType: schMainPropertyType.optional(),
  orderID: z103.string()
});
var schAutofillPropertyDataResponse = z103.object({
  status: z103.literal("success"),
  result: schPropertyData
});
var AUTOFILL_PROPERTY_DATA_API = {
  POST: {
    REQUEST: {
      BODY: schAutofillPropertyDataRequest
    },
    RESPONSE: schAutofillPropertyDataResponse
  }
};
var ORCHESTRATE_AUTOFILL_PROPERTY_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z103.object({
        ...orderIDPathParam,
        propertyId: z103.string()
      }),
      QUERY_PARAMS: z103.object({
        sources: z103.array(schSourceType).optional(),
        includeBackupListingData: z103.boolean().optional().default(true)
      })
    },
    RESPONSE: schSubjectData.or(schPropertyDataWithOptionalReadonly).optional()
  }
};

// src/api/v2/qaAttempts/api.ts
import { z as z104 } from "zod";
var schFiles = z104.object({
  reportPDF: schBlobRef,
  loePDF: schBlobRef.optional(),
  purchaseContractPDF: schBlobRef.optional(),
  orderDetailsPDF: schBlobRef.optional()
});
var _schQAFileType = schFiles.keyof();
var schStartedAttempt = z104.object({
  id: z104.string(),
  orderID: schToolkitOrderID,
  status: z104.enum(["in-progress", "error", "success"]),
  results: z104.array(z104.string()).nullable(),
  files: schFiles,
  createdAt: z104.coerce.date()
});
var schIdleAttempt = z104.object({ status: z104.literal("idle") });
var schAttempt = schStartedAttempt.or(schIdleAttempt);
var QA_ATTEMPTS = {
  GET: {
    REQUEST: { PATH_PARAMS: z104.object({ orderID: schToolkitOrderID }) },
    RESPONSE: schAttempt
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: z104.object({ orderID: schToolkitOrderID }),
      BODY: z104.object({
        files: z104.object({
          reportPDF: schBlobRef,
          loePDF: schBlobRef.optional(),
          purchaseContractPDF: schBlobRef.optional(),
          orderDetailsPDF: schBlobRef.optional()
        })
      })
    },
    RESPONSE: schStartedAttempt
  }
};

// src/api/v2/admin/index.ts
import { z as z105 } from "zod";
var ADMIN_ACCOUNTS_API = {
  GET: {
    REQUEST: {
      QUERY_PARAMS: z105.object({
        limit: z105.number().optional(),
        offset: z105.number().optional(),
        email: z105.string().optional(),
        name: z105.string().optional()
      })
    },
    RESPONSE: z105.object({
      results: z105.array(schBackendAccount),
      resultsCount: z105.number(),
      totalResultsCount: z105.number()
    })
  }
};

// src/api/v2/marketConditions/index.ts
import { z as z106 } from "zod";
var MARKET_AGGREGATE_DATA_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z106.object({
        orderID: schToolkitOrderID
      }),
      QUERY_PARAMS: z106.object({
        geoType: schAbodeAggregateGeoType,
        geoId: z106.string()
      })
    },
    RESPONSE: schAbodeAggregateMarketConditions
  }
};

// src/api/stripe/index.ts
var STRIPE_API = {
  GET: {
    REQUEST: {},
    RESPONSE: schSubscriptionResponse
  }
};
var STRIPE_SESSION_API = {
  POST: {
    REQUEST: {},
    RESPONSE: schCreateStripeCustomerSessionResponse
  }
};
var STRIPE_SUBSCRIPTION_API = {
  POST: {
    REQUEST: {
      BODY: schCreateStripeSubscriptionRequest
    },
    RESPONSE: schCreateStripeSubscriptionResponse
  }
};
var STRIPE_BILLING_ADDRESS_API = {
  PATCH: {
    REQUEST: {
      BODY: schUpdateStripeBillingAddressRequest
    },
    RESPONSE: schUpdateStripeBillingAddressResponse
  }
};
var STRIPE_SALES_TAX_API = {
  POST: {
    REQUEST: {
      BODY: schCalculateStripeSalesTaxRequest
    },
    RESPONSE: schCalculateStripeSalesTaxResponse
  }
};
var STRIPE_PRICING_BREAKDOWN_API = {
  POST: {
    REQUEST: {
      BODY: schCalculateStripePricingBreakdownRequest
    },
    RESPONSE: schCalculateStripePricingBreakdownResponse
  }
};
var STRIPE_VALIDATE_PROMOTION_CODE_API = {
  POST: {
    REQUEST: {
      BODY: schValidatePromotionCodeRequest
    },
    RESPONSE: schValidatePromotionCodeResponse
  }
};

// src/autofill/utils/editablePropertyDataFromAllSources.ts
import { AloftPrice as AloftPrice26 } from "@aloft/shared-objects";

// src/autofill/utils/aduFromSources.ts
var import_shared_utils66 = __toESM(require_lib(), 1);

// src/autofill/utils/getTokens.ts
function getTokens(line) {
  if (line.includes(";")) {
    return line.split(";").map((x) => x.trim());
  } else if (line.includes(",")) {
    return line.split(",").map((x) => x.trim());
  } else if (line.includes("/")) {
    return line.split("/").map((x) => x.trim());
  }
  return [line.trim()];
}

// src/autofill/utils/matchesByLabelAndYes.ts
function matchesByLabelAndYes(regex, ...lines) {
  return lines.some((line) => line?.label.match(regex) && line?.value.match(/yes/i));
}

// src/autofill/utils/matchesByVal.ts
var noPrefix = /^no\s/i;
function matchesByVal({ pattern, antiPattern: antiPattern2 = noPrefix }, ...values) {
  return values.some((value) => !value?.match(antiPattern2) && value?.match(pattern));
}

// src/autofill/utils/attemptStructureExtract.ts
function attemptStructureExtract(xml2, patternParams, makeDefault) {
  if (xml2.additionalFeature1?.value) {
    const tokens = getTokens(xml2.additionalFeature1.value);
    if (tokens.some((token) => matchesByVal(patternParams, token))) {
      return makeDefault();
    }
  }
  if (xml2.additionalFeature2?.value) {
    const tokens = getTokens(xml2.additionalFeature2.value);
    if (tokens.some((token) => matchesByVal(patternParams, token))) {
      return makeDefault();
    }
  }
  if (xml2.additionalFeature3?.value) {
    const tokens = getTokens(xml2.additionalFeature3.value);
    if (tokens.some((token) => matchesByVal(patternParams, token))) {
      return makeDefault();
    }
  }
  if (matchesByLabelAndYes(
    patternParams.pattern,
    xml2.additionalFeature1,
    xml2.additionalFeature2,
    xml2.additionalFeature3
  )) {
    return makeDefault();
  }
  return void 0;
}

// src/autofill/utils/errorHandlingWrapper.ts
var errorHandlingWrapper = (valueFromSources, valueType, logError = (e, vType) => console.error(e, `Failed to get value: ${vType}`)) => (sources2) => {
  try {
    return valueFromSources(sources2);
  } catch (e) {
    logError(e, valueType);
    return void 0;
  }
};

// src/autofill/utils/aduFromSources.ts
var DEFAULT_SIZE = DEFAULT_ADU_SIZE_SQFT.toJSON();
var DEFAULT_QUALITY = DEFAULT_ADU_QUALITY;
var aduPattern = /adu|dadu|guest\shouse|gsths|casita/i;
var makeDefaultAdu = () => ({
  hasFeature: true,
  quality: DEFAULT_QUALITY,
  fullBaths: DEFAULT_ADU_FULL_BATHS,
  halfBaths: DEFAULT_ADU_HALF_BATHS,
  area: DEFAULT_SIZE
});
var _aduFromSources = ({ xml: xml2 }) => {
  if ((0, import_shared_utils66.isDefined)(xml2)) {
    const maybeAdu = attemptStructureExtract(xml2, { pattern: aduPattern }, makeDefaultAdu);
    if (maybeAdu) {
      const source = schSourceType.enum.xml;
      return {
        data: maybeAdu,
        source: {
          area: { source },
          fullBaths: { source },
          halfBaths: { source },
          quality: { source }
        }
      };
    }
  }
  return void 0;
};
var aduFromSources = errorHandlingWrapper(_aduFromSources, "adu");

// src/autofill/utils/ageFromSources.ts
var import_shared_utils67 = __toESM(require_lib(), 1);
var _ageFromSources = (effectiveYear) => ({ xml: xml2, mls, publicRecord, zillow }) => {
  if (xml2 && (0, import_shared_utils67.isDefined)(xml2?.age))
    return { data: xml2.age, source: schSourceType.enum.xml };
  if (mls?.listing.YearBuilt) {
    const {
      source,
      listing: { YearBuilt }
    } = mls;
    const age = schPositiveInt.safeParse(effectiveYear - YearBuilt);
    if (age.success) {
      return { data: age.data, source };
    }
    console.warn(`Invalid age based on MLS year built: ${YearBuilt}`);
  }
  if (publicRecord?.listing.YearBuilt) {
    const {
      source,
      listing: { YearBuilt }
    } = publicRecord;
    const age = schPositiveInt.safeParse(effectiveYear - YearBuilt);
    if (age.success) {
      return { data: age.data, source };
    }
    console.warn(`Invalid age based on Public Record year built: ${YearBuilt}`);
  }
  if (zillow?.yearBuilt) {
    const age = schPositiveInt.safeParse(effectiveYear - zillow.yearBuilt);
    if (age.success) {
      return { data: age.data, source: schSourceType.enum.zillow };
    }
    console.warn(`Invalid age based on Zillow year built: ${zillow.yearBuilt}`);
  }
  return void 0;
};
var ageFromSources = (effectiveYear) => errorHandlingWrapper(_ageFromSources(effectiveYear), "age");

// src/autofill/utils/getXmlMainStructureQualityOrDefault.ts
function getXmlMainStructureQualityOrDefault(xml2) {
  if (xml2?.quality === void 0) {
    return DEFAULT_CRAFTSMAN_QUALITY;
  }
  const maybeQuality = schPositiveInt.safeParse(xml2.quality);
  return maybeQuality.success ? maybeQuality.data : DEFAULT_CRAFTSMAN_QUALITY;
}

// src/autofill/utils/atticFromSources.ts
var DEFAULT_SIZE2 = DEFAULT_ATTIC_SIZE_SQFT.toJSON();
var atticPattern = /attic/i;
function makeDefaultAttic(area, quality) {
  return { hasFeature: true, area, quality };
}
var _atticFromSources = ({
  xml: xml2,
  publicRecord
}) => {
  const quality = getXmlMainStructureQualityOrDefault(xml2);
  if (xml2) {
    const maybeAttic = attemptStructureExtract(
      xml2,
      { pattern: atticPattern },
      () => makeDefaultAttic(DEFAULT_SIZE2, quality)
    );
    if (maybeAttic) {
      const source = schSourceType.enum.xml;
      return { data: maybeAttic, source: { area: { source }, quality: { source } } };
    }
  }
  if (publicRecord) {
    const {
      source,
      listing: { RoomsAtticArea, RoomsAtticFlag }
    } = publicRecord;
    if (RoomsAtticFlag) {
      const atticArea = RoomsAtticArea ? RoomsAtticArea.toJSON() : DEFAULT_SIZE2;
      return {
        data: makeDefaultAttic(atticArea, quality),
        source: { area: { source }, quality: { source } }
      };
    }
  }
  return void 0;
};
var atticFromSources = errorHandlingWrapper(_atticFromSources, "attic");

// src/autofill/utils/barnFromSources.ts
var DEFAULT_SIZE3 = DEFAULT_BARN_SIZE_SQFT.toJSON();
var DEFAULT_QUALITY2 = DEFAULT_BARN_QUALITY;
var barnPattern = /barn|brn|stable/i;
var makeDefaultBarn = () => ({
  hasFeature: true,
  quality: DEFAULT_QUALITY2,
  area: DEFAULT_SIZE3
});
var _barnFromSources = ({ xml: xml2 }) => {
  if (xml2) {
    const maybeBarn = attemptStructureExtract(xml2, { pattern: barnPattern }, makeDefaultBarn);
    if (maybeBarn) {
      const source = schSourceType.enum.xml;
      return {
        data: maybeBarn,
        source: {
          area: { source },
          quality: { source }
        }
      };
    }
  }
  return void 0;
};
var barnFromSources = errorHandlingWrapper(_barnFromSources, "barn");

// src/autofill/utils/basementFromSources.ts
import { AloftArea as AloftArea21 } from "@aloft/shared-objects";
var _basementFromSources = ({
  xml: xml2,
  mls,
  publicRecord,
  zillow
}) => {
  if (xml2) {
    if (xml2.basement) {
      const { totalArea, finishedArea } = xml2.basement;
      if ([totalArea, finishedArea].some((area) => area?.unitAmount && area.unitAmount > 0)) {
        const source2 = schSourceType.enum.xml;
        return {
          data: { ...xml2.basement, hasFeature: true },
          source: {
            finishedArea: { source: source2 },
            fullBaths: { source: source2 },
            halfBaths: { source: source2 },
            totalArea: { source: source2 }
          }
        };
      }
    }
    return void 0;
  }
  if (publicRecord) {
    const {
      source: publicRecordSource2,
      listing: { RoomsBasementArea, RoomsBasementAreaFinished }
    } = publicRecord;
    if (RoomsBasementArea) {
      if (RoomsBasementArea.gt(AloftArea21.zero)) {
        return {
          data: {
            hasFeature: true,
            totalArea: RoomsBasementArea.toJSON(),
            finishedArea: RoomsBasementAreaFinished?.toJSON()
          },
          source: {
            finishedArea: { source: publicRecordSource2 },
            fullBaths: { source: publicRecordSource2 },
            halfBaths: { source: publicRecordSource2 },
            totalArea: { source: publicRecordSource2 }
          }
        };
      }
    }
  }
  let hasBasement = false;
  let source;
  if (zillow?.resoFacts?.basementYN) {
    hasBasement = true;
    source = schSourceType.enum.zillow;
  } else if (mls?.listing.BasementYN) {
    hasBasement = true;
    source = mls.source;
  }
  if (hasBasement && source) {
    return {
      data: {
        hasFeature: true,
        totalArea: DEFAULT_BASEMENT_TOTAL_SIZE_SQFT.toJSON(),
        finishedArea: DEFAULT_BASEMENT_FINISHED_SIZE_SQFT.toJSON(),
        fullBaths: DEFAULT_BASEMENT_FULL_BATHS,
        halfBaths: DEFAULT_BASEMENT_HALF_BATHS
      },
      source: {
        finishedArea: { source },
        fullBaths: { source },
        halfBaths: { source },
        totalArea: { source }
      }
    };
  }
  return void 0;
};
var basementFromSources = errorHandlingWrapper(_basementFromSources, "basement");

// src/autofill/utils/carportFromSources.ts
var import_shared_utils68 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea22 } from "@aloft/shared-objects";

// src/autofill/utils/parkingFieldsFromSources.ts
var parkingFieldsFromSpaces = (source, rawSpaces, quality, publicRecordArea) => {
  if (rawSpaces === void 0) {
    return {
      data: {
        hasFeature: true,
        area: publicRecordArea,
        quality,
        spaces: void 0
      },
      source: {
        area: { source },
        quality: quality ? { source } : void 0,
        spaces: void 0
      }
    };
  }
  const spaces = schPositiveInt.parse(Math.floor(rawSpaces));
  const area = publicRecordArea ?? DEFAULT_SPACE_SIZE_SQFT.mul(spaces).toJSON();
  return {
    data: { hasFeature: true, area, quality, spaces },
    source: {
      area: { source },
      quality: quality ? { source } : void 0,
      spaces: { source }
    }
  };
};

// src/autofill/utils/carportFromSources.ts
var _carportFromSources = ({
  xml: xml2,
  publicRecord,
  zillow
}) => {
  const area = publicRecord?.listing.ParkingCarportArea?.gt(AloftArea22.zero) ? publicRecord.listing.ParkingCarportArea.toJSON() : void 0;
  const quality = getXmlMainStructureQualityOrDefault(xml2);
  if (xml2) {
    if ((0, import_shared_utils68.isDefined)(xml2.carportSpaces)) {
      return parkingFieldsFromSpaces(schSourceType.enum.xml, xml2.carportSpaces, quality, area);
    }
    return void 0;
  }
  const carportCapacity = zillow?.resoFacts?.carportParkingCapacity;
  if (typeof carportCapacity === "number" && carportCapacity > 0) {
    return parkingFieldsFromSpaces(schSourceType.enum.zillow, carportCapacity, quality, area);
  }
  if (publicRecord && area) {
    return parkingFieldsFromSpaces(publicRecord.source, void 0, quality, area);
  }
  return void 0;
};
var carportFromSources = errorHandlingWrapper(_carportFromSources, "carport");

// src/autofill/utils/concessionsFromSources.ts
import { AloftPrice as AloftPrice22 } from "@aloft/shared-objects";
var _concessionsFromSources = ({ xml: xml2, mls }) => {
  if (xml2) {
    if (xml2.concessions)
      return { data: xml2.concessions, source: schSourceType.enum.xml };
    return void 0;
  }
  if (mls?.listing.ConcessionsAmount) {
    return {
      data: fnma_exports.financialConcessionsSyntax.encode({
        financialConcessionAmount: AloftPrice22.fromDollarLike(mls.listing.ConcessionsAmount)
      }),
      source: mls.source
    };
  }
  return void 0;
};
var concessionsFromSources = errorHandlingWrapper(_concessionsFromSources, "concessions");

// src/autofill/utils/contractMonthFromSources.ts
var import_shared_utils69 = __toESM(require_lib(), 1);
import { AloftDate as AloftDate15 } from "@aloft/shared-objects";

// src/autofill/utils/getZillowPriceHistory.ts
function getZillowPriceHistory(ph) {
  const priceHistory = ph && Array.isArray(ph) ? ph : [];
  return priceHistory;
}

// src/autofill/utils/contractMonthFromSources.ts
var _contractMonthFromSources = ({ xml: xml2, mls, zillow }) => {
  if (xml2) {
    if (xml2.contractDate)
      return { data: xml2.contractDate, source: schSourceType.enum.xml };
    return void 0;
  }
  if (mls) {
    const mlsContractDate = (0, import_shared_utils69.orUndefined)(getC1ContractDate)(mls.listing);
    if (mlsContractDate) {
      return { data: fnma_exports.aloftDateToIsoMonth(mlsContractDate), source: mls.source };
    }
  }
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowContractDate = priceHistory.find(
    ({ event, postingIsRental }) => !postingIsRental && event === "Pending sale"
  )?.date;
  if (zillowContractDate) {
    return {
      data: fnma_exports.aloftDateToIsoMonth(AloftDate15.fromIsoString(zillowContractDate)),
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var contractMonthFromSources = errorHandlingWrapper(
  _contractMonthFromSources,
  "contactMonth"
);

// src/autofill/utils/coordinatesFromSources.ts
var _coordinatesFromSources = ({ xml: xml2, mls, zillow, radar }) => {
  if (radar?.lat && radar?.lng) {
    return {
      data: { latitude: radar.lat, longitude: radar.lng },
      source: schSourceType.enum.radar
    };
  }
  if (xml2?.latitude && xml2.longitude) {
    return {
      data: { latitude: xml2.latitude, longitude: xml2.longitude },
      source: schSourceType.enum.xml
    };
  }
  if (mls?.listing.Latitude && mls.listing.Longitude) {
    return {
      data: { latitude: mls.listing.Latitude, longitude: mls.listing.Longitude },
      source: mls.source
    };
  }
  if (zillow?.latitude && zillow.longitude) {
    return {
      data: { latitude: zillow.latitude, longitude: zillow.longitude },
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var coordinatesFromSources = errorHandlingWrapper(_coordinatesFromSources, "coordinates");

// src/autofill/utils/deckFromSources.ts
var uncoveredPattern = /deck|dk|dck|decking|decks|wddeck|wood\sdeck|odeck|dcks|dec/i;
var coveredPattern = /cvdeck|covdeck|cov\.deck|cvdck|covdeck/i;
var screenPattern = /sunrm|sunroom/i;
function buildDefaultDeck(type, quality) {
  return {
    type,
    hasFeature: true,
    area: DEFAULT_DECK_SIZE_SQFT.toJSON(),
    quality
  };
}
var _internalFn = ({ xml: xml2 }) => {
  const quality = getXmlMainStructureQualityOrDefault(xml2);
  if (xml2?.porchPatioDeck) {
    const tokens = getTokens(xml2.porchPatioDeck);
    const source = schSourceType.enum.xml;
    const sourceObj = {
      area: { source },
      quality: { source },
      type: { source }
    };
    for (const token of tokens) {
      if (matchesByVal({ pattern: screenPattern }, token)) {
        return { data: buildDefaultDeck("screen", quality), source: sourceObj };
      }
      if (matchesByVal({ pattern: coveredPattern }, token)) {
        return { data: buildDefaultDeck("covered", quality), source: sourceObj };
      }
      if (matchesByVal({ pattern: uncoveredPattern }, token)) {
        return { data: buildDefaultDeck("uncovered", quality), source: sourceObj };
      }
    }
  }
  return void 0;
};
var deckFromSources = errorHandlingWrapper(_internalFn, "deck");

// src/autofill/utils/domFromSources.ts
var _domFromSources = ({
  xml: xml2,
  mls,
  zillow
}) => {
  const xmlDaysOnMarket = xml2?.daysOnMarket;
  if (xml2 && typeof xmlDaysOnMarket === "number" && xmlDaysOnMarket >= 0) {
    return { data: xmlDaysOnMarket, source: schSourceType.enum.xml };
  }
  const mlsDaysOnMarket = mls?.listing.CumulativeDaysOnMarket;
  if (mls && typeof mlsDaysOnMarket === "number" && mlsDaysOnMarket >= 0) {
    return { data: mlsDaysOnMarket, source: mls.source };
  }
  if (zillow?.resoFacts?.cumulativeDaysOnMarket) {
    const re = /^\d+/;
    const match = zillow.resoFacts.cumulativeDaysOnMarket.match(re);
    const int = match ? parseInt(match[0], 10) : void 0;
    if (match) {
      const cdom = schPositiveInt.safeParse(int);
      if (cdom.success)
        return { data: cdom.data, source: schSourceType.enum.zillow };
      console.error(
        "cumulativeDaysOnMarket could not be parsed",
        zillow.resoFacts.cumulativeDaysOnMarket
      );
    }
  }
  return void 0;
};
var domFromSources = errorHandlingWrapper(_domFromSources, "dom");

// src/autofill/utils/effectiveAgeFromSources.ts
var import_shared_utils70 = __toESM(require_lib(), 1);
var USE_ACTUAL_AGE_CUTOFF_YEARS = schPositiveInt.parse(20);
var _effectiveAgeFromSources = (effectiveYear) => (sources2) => {
  const age = ageFromSources(effectiveYear)(sources2);
  if ((0, import_shared_utils70.isUndefined)(age) || (0, import_shared_utils70.isUndefined)(age?.data)) {
    return { data: DEFAULT_EFFECTIVE_AGE, source: schSourceType.enum.none };
  }
  if (age.data < USE_ACTUAL_AGE_CUTOFF_YEARS)
    return age;
  return { data: USE_ACTUAL_AGE_CUTOFF_YEARS, source: age.source };
};
var effectiveAgeFromSources = (effectiveYear) => errorHandlingWrapper(_effectiveAgeFromSources(effectiveYear), "effectiveAge");

// src/autofill/utils/featureGridDataSourcesFromSources.ts
var _featureGridDataSourcesFromSources = ({ mls, publicRecord }) => {
  const featureGridDataSources = [];
  const { MLSName, ListingId } = mls?.listing ?? {};
  if (MLSName && ListingId) {
    featureGridDataSources.push(`${MLSName.toLocaleUpperCase()} #${ListingId.toString()}`);
  }
  const { SitusCounty } = publicRecord?.listing ?? {};
  if (SitusCounty) {
    featureGridDataSources.push(`${SitusCounty} County`);
  } else {
    const { ParcelNumberRaw } = publicRecord?.listing ?? {};
    if (ParcelNumberRaw) {
      featureGridDataSources.push(`APN: ${ParcelNumberRaw}`);
    }
  }
  if (featureGridDataSources.length > 0) {
    return {
      data: featureGridDataSources.join(", "),
      source: schSourceType.enum.custom
    };
  }
  return void 0;
};
var featureGridDataSourcesFromSources = errorHandlingWrapper(
  _featureGridDataSourcesFromSources,
  "featureGridDataSources"
);

// src/autofill/utils/fireplaceFromSources.ts
var fireplacePattern = /fp|fireplace|fireplaces/i;
var makeDefaultFireplace = () => ({
  hasFeature: true,
  count: DEFAULT_FIREPLACE_COUNT,
  type: DEFAULT_FIREPLACE_TYPE
});
var _fireplaceFromSources = ({ xml: xml2 }) => {
  if (xml2) {
    const maybeFireplace = attemptStructureExtract(
      xml2,
      { pattern: fireplacePattern },
      makeDefaultFireplace
    );
    if (maybeFireplace) {
      const source = schSourceType.enum.xml;
      return { data: maybeFireplace, source: { count: { source }, type: { source } } };
    }
  }
  return void 0;
};
var fireplaceFromSources = errorHandlingWrapper(_fireplaceFromSources, "fireplace");

// src/autofill/utils/fullBathsFromSources.ts
var import_shared_utils71 = __toESM(require_lib(), 1);
var _fullBathsFromSources = ({ xml: xml2, mls, publicRecord, zillow }) => {
  if (xml2 && (0, import_shared_utils71.isDefined)(xml2?.fullBaths)) {
    return { data: xml2.fullBaths, source: schSourceType.enum.xml };
  }
  if (mls) {
    const BathroomsFull = mls.listing.BathroomsFull;
    const BathroomsThreeQuarter = mls.listing.BathroomsThreeQuarter;
    let parsedFullBaths;
    let parsedThreeQuarterBaths;
    if (typeof BathroomsFull === "number" && BathroomsFull >= 0) {
      parsedFullBaths = schPositiveInt.parse(BathroomsFull);
    }
    if (typeof BathroomsThreeQuarter === "number" && BathroomsThreeQuarter >= 0) {
      parsedThreeQuarterBaths = schPositiveInt.parse(BathroomsThreeQuarter);
    }
    if ((0, import_shared_utils71.isDefined)(parsedFullBaths) || (0, import_shared_utils71.isDefined)(parsedThreeQuarterBaths)) {
      return {
        data: schPositiveInt.parse((parsedFullBaths ?? 0) + (parsedThreeQuarterBaths ?? 0)),
        source: mls.source
      };
    }
  }
  const BathCount = publicRecord?.listing.BathCount;
  if (publicRecord && typeof BathCount === "number" && BathCount >= 0) {
    return {
      data: schPositiveInt.parse(Math.floor(BathCount)),
      source: publicRecord.source
    };
  }
  const zillowBaths = zillow?.resoFacts?.bathroomsFull;
  if (typeof zillowBaths === "number" && zillowBaths >= 0) {
    return {
      data: schPositiveInt.parse(zillowBaths),
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var fullBathsFromSources = errorHandlingWrapper(_fullBathsFromSources, "fullBaths");

// src/autofill/utils/garageFromSources.ts
var import_shared_utils72 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea23 } from "@aloft/shared-objects";
var getGarageFromSources = (source, rawSpaces, quality, publicRecordArea, type) => {
  const parkingFields = (0, import_shared_utils72.expected)(
    parkingFieldsFromSpaces(source, rawSpaces, quality, publicRecordArea)
  );
  return {
    data: {
      ...parkingFields.data,
      type: type ?? "attached"
    },
    source: {
      ...parkingFields.source,
      type: { source: type ? schSourceType.enum.abode_mls : schSourceType.enum.none }
    }
  };
};
var _garageFromSources = ({
  xml: xml2,
  mls,
  publicRecord,
  zillow
}) => {
  let garageType = mls?.listing.HasAttachedGarage !== void 0 ? mls?.listing.HasAttachedGarage ? "attached" : "detached" : void 0;
  const area = publicRecord?.listing.ParkingGarageArea?.gt(AloftArea23.zero) ? publicRecord.listing.ParkingGarageArea.toJSON() : void 0;
  const quality = getXmlMainStructureQualityOrDefault(xml2);
  if (xml2) {
    if ((0, import_shared_utils72.isDefined)(xml2.garageSpaces)) {
      return getGarageFromSources(schSourceType.enum.xml, xml2.garageSpaces, quality, area, garageType);
    }
    return void 0;
  }
  const mlsGarage = mls?.listing.GarageSpaces;
  if (mls && typeof mlsGarage === "number" && mlsGarage > 0) {
    return getGarageFromSources(mls.source, mlsGarage, quality, area, garageType);
  }
  if (zillow?.resoFacts) {
    const zillowGarage = zillow.resoFacts.garageParkingCapacity;
    const zillowGarageType = zillow.resoFacts.hasAttachedGarage === false ? "detached" : "attached";
    if (typeof zillowGarage === "number" && zillowGarage > 0) {
      return getGarageFromSources(
        schSourceType.enum.zillow,
        zillowGarage,
        quality,
        area,
        zillowGarageType
      );
    }
  }
  if (publicRecord && area) {
    return getGarageFromSources(publicRecord.source, void 0, quality, area);
  }
  return void 0;
};
var garageFromSources = errorHandlingWrapper(_garageFromSources, "garage");

// src/autofill/utils/glaFromSources.ts
import { AloftArea as AloftArea24 } from "@aloft/shared-objects";
var _glaFromSources = ({
  xml: xml2,
  mls,
  publicRecord,
  zillow
}) => {
  if (xml2?.gla)
    return { data: xml2.gla, source: schSourceType.enum.xml };
  if (mls?.listing.LivingArea) {
    return {
      data: AloftArea24.fromNumber(mls.listing.LivingArea, "sqft").toJSON(),
      source: mls.source
    };
  }
  if (publicRecord?.listing.AreaBuilding) {
    return { data: publicRecord.listing.AreaBuilding.toJSON(), source: publicRecord.source };
  }
  if (zillow?.livingAreaUnits === "sqft" && zillow.livingAreaValue) {
    return {
      data: AloftArea24.fromNumber(zillow.livingAreaValue, "sqft").toJSON(),
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var glaFromSources = errorHandlingWrapper(_glaFromSources, "gla");

// src/autofill/utils/halfBathsFromSources.ts
var import_shared_utils73 = __toESM(require_lib(), 1);
var _halfBathsFromSources = ({ xml: xml2, mls, publicRecord, zillow }) => {
  if (xml2 && (0, import_shared_utils73.isDefined)(xml2?.halfBaths)) {
    return { data: xml2.halfBaths, source: schSourceType.enum.xml };
  }
  const BathroomsHalf = mls?.listing.BathroomsHalf;
  if (mls && typeof BathroomsHalf === "number" && BathroomsHalf >= 0) {
    return { data: schPositiveInt.parse(BathroomsHalf), source: mls.source };
  }
  const BathPartialCount = publicRecord?.listing.BathPartialCount;
  if (publicRecord && typeof BathPartialCount === "number" && BathPartialCount >= 0) {
    return {
      data: schPositiveInt.parse(Math.floor(BathPartialCount)),
      source: publicRecord.source
    };
  }
  const zillowBathsHalf = zillow?.resoFacts?.bathroomsHalf;
  if (typeof zillowBathsHalf === "number" && zillowBathsHalf >= 0) {
    return {
      data: schPositiveInt.parse(zillowBathsHalf),
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var halfBathsFromSources = errorHandlingWrapper(_halfBathsFromSources, "halfBaths");

// src/autofill/utils/hoaFeeAmountFromSources.ts
import { AloftPrice as AloftPrice23 } from "@aloft/shared-objects";
var _hoaFeeAmountFromSources = ({ mls }) => {
  if (mls?.listing?.AssociationFee) {
    return {
      data: AloftPrice23.fromDollarLike(mls.listing.AssociationFee).toJSON(),
      source: mls?.source
    };
  }
  return void 0;
};
var hoaFeeAmountFromSources = errorHandlingWrapper(
  _hoaFeeAmountFromSources,
  "hoaFeeAmount"
);

// src/autofill/utils/hoaFeeFrequencyFromSources.ts
var _hoaFeeFrequencyFromSources = ({ mls }) => {
  const parsedFrequency = schHoaFeeFrequency.safeParse(mls?.listing.AssociationFeeFrequency);
  if (parsedFrequency.success && mls) {
    return {
      data: parsedFrequency.data,
      source: mls?.source
    };
  }
  return void 0;
};
var hoaFeeFrequencyFromSources = errorHandlingWrapper(
  _hoaFeeFrequencyFromSources,
  "hoaFeeFrequency"
);

// src/autofill/utils/hoaFromSources.ts
var _hoaFromSources = ({ mls }) => {
  if (mls?.listing?.AssociationName) {
    return {
      data: mls.listing?.AssociationName,
      source: mls?.source
    };
  }
  return void 0;
};
var hoaFromSources = errorHandlingWrapper(_hoaFromSources, "hoa");

// src/autofill/utils/legalDescriptionFromSources.ts
var _legalDescriptionFromSources = ({ mls, publicRecord }) => {
  if (publicRecord?.listing?.LegalDescription) {
    return {
      data: publicRecord.listing.LegalDescription,
      source: publicRecord?.source
    };
  }
  if (mls?.listing?.TaxLegalDescription) {
    return {
      data: mls.listing.TaxLegalDescription,
      source: mls?.source
    };
  }
  return void 0;
};
var legalDescriptionFromSources = errorHandlingWrapper(_legalDescriptionFromSources, "legalDescription");

// src/autofill/utils/listing/bedroomsFromSources.ts
var internalFn = ({
  zillow,
  mls,
  publicRecord
}) => {
  const mlsBedrooms = mls?.listing.BedroomsTotal;
  if (mls && typeof mlsBedrooms === "number" && mlsBedrooms >= 0) {
    return { data: mlsBedrooms, source: mls.source };
  }
  const publicRecordBedrooms = publicRecord?.listing.BedroomsCount;
  if (publicRecord && typeof publicRecordBedrooms === "number" && publicRecordBedrooms >= 0) {
    return { data: publicRecordBedrooms, source: publicRecord.source };
  }
  const zillowBedrooms = zillow?.bedrooms;
  if (typeof zillowBedrooms === "number" && zillowBedrooms >= 0) {
    return { data: zillowBedrooms, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var bedroomsFromSources = errorHandlingWrapper(internalFn, "bedrooms");

// src/autofill/utils/getZilllowAttributeSource.ts
var import_shared_utils74 = __toESM(require_lib(), 1);
function getZillowAttributeSource(ph) {
  return ph.find(
    (history) => history.attributeSource?.infoString2 === history.source && (0, import_shared_utils74.isDefined)(history.attributeSource?.infoString1)
  )?.attributeSource ?? void 0;
}

// src/autofill/utils/mlsFromSources.ts
var _mlsFromSources = (defaultMLS) => ({ xml: xml2, mls, zillow }) => {
  if (xml2?.mls)
    return { data: xml2.mls, source: schSourceType.enum.xml };
  if (mls) {
    const {
      source,
      listing: { MLSName, OriginatingSystemName: OriginatingSystemName2 }
    } = mls;
    if (OriginatingSystemName2) {
      return { data: mlsInfoByConstellation1ID(OriginatingSystemName2)?.mlsid, source };
    }
    if (MLSName) {
      const mlsID = mlsInfoByAbodeName(MLSName)?.mlsid;
      if (mlsID)
        return { data: mlsID, source };
    }
  }
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowMLS = getZillowAttributeSource(priceHistory)?.infoString2;
  if (zillowMLS) {
    const zillowMLSID = mlsInfoByShortName(zillowMLS)?.mlsid;
    if (zillowMLSID)
      return { data: zillowMLSID, source: schSourceType.enum.zillow };
  }
  if (defaultMLS)
    return { data: defaultMLS, source: schSourceType.enum.custom };
  return void 0;
};
var mlsFromSources = (defaultMLS) => errorHandlingWrapper(_mlsFromSources(defaultMLS), "mls");

// src/autofill/utils/mlsListingIDFromSources.ts
var _mlsListingIDFromSources = ({ xml: xml2, mls, zillow }) => {
  if (xml2?.mlsListingID)
    return { data: xml2.mlsListingID, source: schSourceType.enum.xml };
  if (mls?.listing.ListingId)
    return { data: mls.listing.ListingId, source: mls.source };
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowListingID = getZillowAttributeSource(priceHistory)?.infoString1;
  if (zillowListingID)
    return { data: zillowListingID, source: schSourceType.enum.zillow };
  return void 0;
};
var mlsListingIDFromSources = errorHandlingWrapper(
  _mlsListingIDFromSources,
  "mlsListingID"
);

// src/autofill/utils/numberOfUnitsFromSources.ts
var DEFAULT_NUMBER_OF_UNITS = 2;
var _schNumberOfUnits = schPositiveInt.optional();
var _numberOfUnitsFromSources = ({ xml: xml2, publicRecord }) => {
  if (xml2?.numberOfUnits)
    return { data: xml2.numberOfUnits, source: schSourceType.enum.xml };
  if (publicRecord?.listing.UnitsCount) {
    return {
      data: schPositiveInt.parse(publicRecord?.listing.UnitsCount),
      source: publicRecord.source
    };
  }
  return { data: DEFAULT_NUMBER_OF_UNITS, source: schSourceType.enum.custom };
};
var numberOfUnitsFromSources = errorHandlingWrapper(
  _numberOfUnitsFromSources,
  "numberOfUnits"
);

// src/autofill/utils/originalListPriceFromSources.ts
import { AloftPrice as AloftPrice24 } from "@aloft/shared-objects";
var _originalListPriceFromSources = ({ mls, zillow }) => {
  if (mls?.listing.OriginalListPrice) {
    return {
      data: AloftPrice24.fromDollarLike(mls.listing.OriginalListPrice).toJSON(),
      source: mls.source
    };
  }
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowLastSalePrice = priceHistory.find(
    (event) => !event.postingIsRental && event.event === "Listed for sale" && event.price !== null
  )?.price;
  if (zillowLastSalePrice) {
    return {
      data: AloftPrice24.fromDollarLike(zillowLastSalePrice).toJSON(),
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var originalListPriceFromSources = errorHandlingWrapper(
  _originalListPriceFromSources,
  "dom"
);

// src/autofill/utils/parcelNumberFromSources.ts
var _parcelNumberFromSources = ({ publicRecord }) => {
  if (publicRecord?.listing.ParcelNumberRaw) {
    return {
      data: publicRecord.listing.ParcelNumberRaw,
      source: publicRecord.source
    };
  }
  return void 0;
};
var parcelNumberFromSources = errorHandlingWrapper(_parcelNumberFromSources, "parcelNumber");

// src/autofill/utils/poolFromSources.ts
var DEFAULT_SIZE4 = DEFAULT_POOL_AREA_SIZE_SQFT.toJSON();
var DEFAULT_QUALITY3 = DEFAULT_POOL_QUALITY;
var poolPattern = /pool|in\sground\spool|stdpool|inground\spool|in\-ground\spool/i;
var antiPattern = /no\spool|nopool|n\/a|none/i;
function makeDefaultPool() {
  return {
    hasFeature: true,
    quality: DEFAULT_QUALITY3,
    area: DEFAULT_SIZE4
  };
}
var _poolFromSources = ({ xml: xml2, mls, publicRecord, zillow }) => {
  if (xml2) {
    const maybePool = attemptStructureExtract(
      xml2,
      { pattern: poolPattern, antiPattern },
      makeDefaultPool
    );
    if (maybePool) {
      const source = schSourceType.enum.xml;
      return { data: maybePool, source: { area: { source }, quality: { source } } };
    }
  }
  if (publicRecord?.listing.PoolArea) {
    const { source } = publicRecord;
    return {
      data: {
        quality: DEFAULT_QUALITY3,
        hasFeature: true,
        area: publicRecord.listing.PoolArea.toJSON()
      },
      source: { area: { source }, quality: { source } }
    };
  }
  if (mls?.listing.PoolPrivateYN) {
    const { source } = mls;
    return {
      data: {
        quality: DEFAULT_QUALITY3,
        hasFeature: true,
        area: DEFAULT_SIZE4
      },
      source: { area: { source }, quality: { source } }
    };
  }
  if (zillow?.resoFacts?.hasPrivatePool) {
    const source = schSourceType.enum.zillow;
    return {
      data: {
        quality: DEFAULT_QUALITY3,
        hasFeature: true,
        area: DEFAULT_SIZE4
      },
      source: { area: { source }, quality: { source } }
    };
  }
  return void 0;
};
var poolFromSources = errorHandlingWrapper(_poolFromSources, "pool");

// src/autofill/utils/priceFromSources.ts
import { AloftPrice as AloftPrice25 } from "@aloft/shared-objects";
var _priceFromSources = ({
  xml: xml2,
  zillow,
  publicRecord,
  mls
}) => {
  if (xml2) {
    if (xml2.price)
      return { data: xml2.price, source: schSourceType.enum.xml };
    return void 0;
  }
  if (mls) {
    const {
      source,
      listing: { ClosePrice, ListPrice }
    } = mls;
    if (ClosePrice)
      return { data: AloftPrice25.fromDollarLike(ClosePrice).toJSON(), source };
    if (ListPrice)
      return { data: AloftPrice25.fromDollarLike(ListPrice).toJSON(), source };
  }
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowLastEventPrice = priceHistory.find((event) => !event.postingIsRental)?.price;
  if (zillowLastEventPrice) {
    return {
      data: AloftPrice25.fromDollarLike(zillowLastEventPrice).toJSON(),
      source: schSourceType.enum.zillow
    };
  }
  if (publicRecord) {
    const {
      source,
      listing: { AssessorLastSaleAmount }
    } = publicRecord;
    if (AssessorLastSaleAmount && AssessorLastSaleAmount.unitAmount > 0) {
      return { data: AssessorLastSaleAmount.toJSON(), source };
    }
  }
  return void 0;
};
var priceFromSources = errorHandlingWrapper(_priceFromSources, "price");

// src/autofill/utils/saleMonthFromSources.ts
var import_shared_utils75 = __toESM(require_lib(), 1);
import { AloftDate as AloftDate16 } from "@aloft/shared-objects";
var _saleMonthFromSources = ({
  xml: xml2,
  mls,
  zillow
}) => {
  if (xml2) {
    if (xml2.saleDate)
      return { data: xml2.saleDate, source: schSourceType.enum.xml };
    return void 0;
  }
  if (mls) {
    const mlsSaleDate = (0, import_shared_utils75.orUndefined)(getC1MonthFromDateString)(mls.listing.CloseDate);
    if (mlsSaleDate)
      return { data: mlsSaleDate, source: mls.source };
  }
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowSaleDate = priceHistory.find(
    (event) => !event.postingIsRental && event.event === "Sold"
  )?.date;
  if (zillowSaleDate) {
    return {
      data: fnma_exports.aloftDateToIsoMonth(AloftDate16.fromIsoString(zillowSaleDate)),
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var saleMonthFromSources = errorHandlingWrapper(_saleMonthFromSources, "saleMonth");

// src/autofill/utils/shedFromSources.ts
var DEFAULT_SIZE5 = DEFAULT_SHED_SIZE_SQFT.toJSON();
var DEFAULT_QUALITY4 = DEFAULT_SHED_QUALITY;
var shedPattern = /shed|shd|storage\sshed|sheds|storage\sshed|stor|stg|storagebldng|outbldg|outbuilding/i;
var makeDefaultShed = () => ({
  hasFeature: true,
  quality: DEFAULT_QUALITY4,
  area: DEFAULT_SIZE5
});
var _shedFromSources = ({ xml: xml2 }) => {
  if (xml2) {
    const maybeShed = attemptStructureExtract(xml2, { pattern: shedPattern }, makeDefaultShed);
    if (maybeShed) {
      const source = schSourceType.enum.xml;
      return { data: maybeShed, source: { area: { source }, quality: { source } } };
    }
  }
  return void 0;
};
var shedFromSources = errorHandlingWrapper(_shedFromSources, "shed");

// src/autofill/utils/siteAreaFromSources.ts
import { AloftArea as AloftArea25 } from "@aloft/shared-objects";
var ZILLOW_SITE_SIZE_SQFT_REGEX = /(\d{1,3}(,\d{3})*(\.\d+)?)(?=\s*sqft)/;
var ZILLOW_SITE_SIZE_ACRES_REGEX = /(\d{1,3}(,\d{3})*(\.\d+)?)(?=\s*acres)/;
var _siteAreaFromSources = ({
  xml: xml2,
  mls,
  publicRecord,
  zillow
}) => {
  if (xml2?.siteArea) {
    return { data: xml2.siteArea, source: schSourceType.enum.xml };
  }
  if (mls?.listing.LotSizeSquareFeet || mls?.listing.LotSizeAcres) {
    return { data: getListingLotSizeSqft(mls.listing)?.toJSON(), source: mls.source };
  }
  if (publicRecord?.listing.AreaLotSF) {
    return { data: publicRecord.listing.AreaLotSF.toJSON(), source: publicRecord.source };
  }
  if (zillow?.resoFacts?.lotSize) {
    const rawString = zillow.resoFacts.lotSize.toLowerCase();
    const matchSqft = rawString.match(ZILLOW_SITE_SIZE_SQFT_REGEX);
    if (matchSqft) {
      return {
        data: AloftArea25.fromString(matchSqft[0], "sqft").toJSON(),
        source: schSourceType.enum.zillow
      };
    }
    const matchAcres = rawString.match(ZILLOW_SITE_SIZE_ACRES_REGEX);
    if (matchAcres) {
      return {
        data: AloftArea25.fromString(matchAcres[0], "acre").toUnit("sqft").toJSON(),
        source: schSourceType.enum.zillow
      };
    }
  }
  return { data: AloftArea25.zero.toJSON(), source: schSourceType.enum.none };
};
var siteAreaFromSources = errorHandlingWrapper(_siteAreaFromSources, "siteArea");

// src/autofill/utils/spaFromSources.ts
var import_shared_utils76 = __toESM(require_lib(), 1);
var DEFAULT_SIZE6 = DEFAULT_SPA_SIZE_SQFT.toJSON();
var DEFAULT_QUALITY5 = DEFAULT_SPA_QUALITY;
var spaPattern = /spa/i;
function makeDefaultSpa() {
  return {
    quality: DEFAULT_QUALITY5,
    area: DEFAULT_SIZE6,
    hasFeature: true
  };
}
var _spaFromSources = ({ xml: xml2, mls, zillow }) => {
  if ((0, import_shared_utils76.isDefined)(xml2)) {
    const maybeSpa = attemptStructureExtract(xml2, { pattern: spaPattern }, makeDefaultSpa);
    const source = schSourceType.enum.xml;
    if (maybeSpa)
      return { data: maybeSpa, source: { area: { source }, quality: { source } } };
  }
  if (mls?.listing.SpaYN) {
    const { source } = mls;
    return { data: makeDefaultSpa(), source: { area: { source }, quality: { source } } };
  }
  if (zillow?.resoFacts?.hasSpa) {
    const source = schSourceType.enum.zillow;
    return { data: makeDefaultSpa(), source: { area: { source }, quality: { source } } };
  }
  return void 0;
};
var spaFromSources = errorHandlingWrapper(_spaFromSources, "spa");

// src/autofill/utils/getZillowStatus.ts
function getZillowStatus(homeStatus) {
  if (homeStatus === "FOR_SALE") {
    return "Active";
  } else if (homeStatus === "SOLD" || homeStatus === "RECENTLY_SOLD" || homeStatus === "OTHER") {
    return "SettledSale";
  }
  return void 0;
}

// src/autofill/utils/statusFromSources.ts
var _statusFromSources = ({
  xml: xml2,
  zillow,
  mls
}) => {
  if (xml2?.status)
    return { data: xml2.status, source: schSourceType.enum.xml };
  if (mls?.listing.StandardStatus) {
    return {
      data: listingStatusToUADStatus(mls.listing.StandardStatus),
      source: mls.source
    };
  }
  if (zillow?.homeStatus) {
    return { data: getZillowStatus(zillow.homeStatus), source: schSourceType.enum.zillow };
  }
  return void 0;
};
var statusFromSources = errorHandlingWrapper(_statusFromSources, "status");

// src/autofill/utils/termsOfSaleFromSources.ts
var import_shared_utils77 = __toESM(require_lib(), 1);
var _termsOfSaleFromSources = ({ xml: xml2, mls }) => {
  if (xml2?.termsOfSale)
    return { data: xml2.termsOfSale, source: schSourceType.enum.xml };
  if ((0, import_shared_utils77.isDefined)(mls)) {
    const mlsStatus = (0, import_shared_utils77.orUndefined)(toUADListingStatus)(mls.listing.StandardStatus);
    if (mlsStatus) {
      if (mlsStatus === "Active") {
        return { data: "Listing", source: mls.source };
      }
      if (mls.listing.ListingTerms?.includes("Conventional")) {
        return { data: "ArmLth", source: mls.source };
      }
    }
  }
  return void 0;
};
var termsOfSaleFromSources = errorHandlingWrapper(_termsOfSaleFromSources, "termsOfSale");

// src/autofill/utils/workshopFromSources.ts
var import_shared_utils78 = __toESM(require_lib(), 1);
var DEFAULT_SIZE7 = DEFAULT_WORKSHOP_SIZE_SQFT.toJSON();
var DEFAULT_QUALITY6 = DEFAULT_WORKSHOP_QUALITY;
var workshopPattern = /workshop|shop|shp|wrkshp|wrksp|lrgshop|smwrkshp|wksp/i;
var makeDefaultWorkshop = () => ({
  hasFeature: true,
  quality: DEFAULT_QUALITY6,
  area: DEFAULT_SIZE7
});
var _workshopFromSources = ({ xml: xml2 }) => {
  if ((0, import_shared_utils78.isDefined)(xml2)) {
    const maybeWorkshop = attemptStructureExtract(
      xml2,
      { pattern: workshopPattern },
      makeDefaultWorkshop
    );
    if (maybeWorkshop) {
      const source = schSourceType.enum.xml;
      return { data: maybeWorkshop, source: { area: { source }, quality: { source } } };
    }
  }
  return void 0;
};
var workshopFromSources = errorHandlingWrapper(_workshopFromSources, "workshop");

// src/autofill/utils/zoningFromSources.ts
var _zoningFromSources = ({ publicRecord }) => {
  if (publicRecord?.listing.Zoning) {
    return {
      data: publicRecord.listing.Zoning,
      source: publicRecord.source
    };
  }
  return void 0;
};
var zoningFromSources = errorHandlingWrapper(_zoningFromSources, "zoning");

// src/autofill/utils/editablePropertyDataFromAllSources.ts
function editablePropertyDataFromAllSources({
  address,
  effectiveYear,
  propertyType,
  defaultMLS,
  sources: sources2
}) {
  const uadQuality = sources2.xml?.quality;
  const status = statusFromSources(sources2);
  const price = priceFromSources(sources2);
  const contractDate = contractMonthFromSources(sources2);
  const saleDate = saleMonthFromSources(sources2);
  const mls = mlsFromSources(defaultMLS)(sources2);
  const mlsListingID = mlsListingIDFromSources(sources2);
  const concessions = concessionsFromSources(sources2);
  const termsOfSale = termsOfSaleFromSources(sources2);
  const daysOnMarket = domFromSources(sources2);
  const originalListPrice = originalListPriceFromSources(sources2);
  const coordinates = coordinatesFromSources(sources2);
  const propertyTypeValue = propertyType ?? "singleFamilyResidence";
  const gla = glaFromSources(sources2);
  const numberOfUnits = propertyType === "multiFamily" ? numberOfUnitsFromSources(sources2) : void 0;
  const foundation = sources2.xml?.foundation;
  const bedrooms = bedroomsFromSources(sources2);
  const fullBaths = fullBathsFromSources(sources2);
  const halfBaths = halfBathsFromSources(sources2);
  const effectiveAge = effectiveAgeFromSources(effectiveYear)(sources2);
  const age = ageFromSources(effectiveYear)(sources2);
  const basement = basementFromSources(sources2);
  const attic = atticFromSources(sources2);
  const garage = garageFromSources(sources2);
  const carport = carportFromSources(sources2);
  const shed = shedFromSources(sources2);
  const workshop = workshopFromSources(sources2);
  const barn = barnFromSources(sources2);
  const pool = poolFromSources(sources2);
  const spa = spaFromSources(sources2);
  const adu = aduFromSources(sources2);
  const deck = deckFromSources(sources2);
  const fireplace = fireplaceFromSources(sources2);
  const area = siteAreaFromSources(sources2);
  const location = sources2.xml?.location;
  const view = sources2.xml?.view;
  const zoning = zoningFromSources(sources2);
  const parcelNumber = parcelNumberFromSources(sources2);
  const hoa = hoaFromSources(sources2);
  const hoaFeeAmount = hoaFeeAmountFromSources(sources2);
  const hoaFeeFrequency = hoaFeeFrequencyFromSources(sources2);
  const legalDescription = legalDescriptionFromSources(sources2);
  const featureGridDataSources = featureGridDataSourcesFromSources(sources2);
  const editableData = {
    transaction: {
      status: status?.data,
      price: price?.data,
      contractDate: contractDate?.data,
      saleDate: saleDate?.data,
      mls: mls?.data,
      mlsListingID: mlsListingID?.data,
      concessions: concessions?.data,
      termsOfSale: termsOfSale?.data,
      daysOnMarket: daysOnMarket?.data,
      originalListPrice: originalListPrice?.data
    },
    propertyIdentification: {
      address,
      coordinates: coordinates?.data,
      zoning: zoning?.data,
      zoningCompliance: void 0,
      parcelNumber: parcelNumber?.data,
      hoa: hoa?.data,
      hoaFeeAmount: hoaFeeAmount?.data,
      hoaFeeFrequency: hoaFeeFrequency?.data,
      legalDescription: legalDescription?.data,
      pud: false
    },
    improvements: {
      propertyType: propertyTypeValue,
      corners: DEFAULT_CORNERS,
      gla: gla?.data,
      numberOfUnits: numberOfUnits?.data,
      foundation: foundation ?? "pierAndBeam",
      bedrooms: bedrooms?.data,
      fullBaths: fullBaths?.data,
      halfBaths: halfBaths?.data,
      heatingAndCooling: void 0,
      effectiveAge: effectiveAge?.data,
      age: age?.data,
      uadQuality,
      craftsmanQuality: uadQuality,
      uadCondition: sources2.xml?.condition,
      basement: basement?.data,
      attic: attic?.data,
      garage: garage?.data?.type === "attached" ? garage?.data : void 0,
      detachedGarage: garage?.data?.type === "detached" ? garage?.data : void 0,
      carport: carport?.data,
      shed: shed?.data,
      workshop: workshop?.data,
      barn: barn?.data,
      pool: pool?.data,
      spa: spa?.data,
      adu: adu?.data,
      porch: void 0,
      patio: void 0,
      deck: deck?.data,
      fireplace: fireplace?.data,
      manualCost: void 0,
      featureGridDataSources: featureGridDataSources?.data,
      totalEconomicLife: void 0,
      externalDepreciation: void 0,
      functionalDepreciation: void 0
    },
    site: {
      area: area?.data,
      location,
      view
    },
    manualAdjustments: {
      termsOfSale: AloftPrice26.zero.toJSON(),
      concessions: AloftPrice26.zero.toJSON()
    }
  };
  const editableDataSelectedSources = {
    transaction: {
      status: { source: status?.source ?? schSourceType.enum.none },
      price: { source: price?.source ?? schSourceType.enum.none },
      contractDate: { source: contractDate?.source ?? schSourceType.enum.none },
      saleDate: { source: saleDate?.source ?? schSourceType.enum.none },
      mls: { source: mls?.source ?? schSourceType.enum.none },
      mlsListingID: { source: mlsListingID?.source ?? schSourceType.enum.none },
      concessions: { source: concessions?.source ?? schSourceType.enum.none },
      termsOfSale: { source: termsOfSale?.source ?? schSourceType.enum.none },
      daysOnMarket: { source: daysOnMarket?.source ?? schSourceType.enum.none },
      originalListPrice: { source: originalListPrice?.source ?? schSourceType.enum.none }
    },
    propertyIdentification: {
      address: {
        AddressLineText: { source: schSourceType.enum.custom },
        CityName: { source: schSourceType.enum.custom },
        PostalCode: { source: schSourceType.enum.custom },
        StateCode: { source: schSourceType.enum.custom },
        unitNumber: { source: schSourceType.enum.custom },
        CountyName: { source: schSourceType.enum.custom }
      },
      coordinates: {
        latitude: { source: coordinates?.source ?? schSourceType.enum.none },
        longitude: { source: coordinates?.source ?? schSourceType.enum.none }
      },
      zoning: { source: zoning?.source ?? schSourceType.enum.none },
      zoningCompliance: { source: schSourceType.enum.custom },
      parcelNumber: { source: parcelNumber?.source ?? schSourceType.enum.none },
      pud: { source: schSourceType.enum.custom },
      hoa: { source: hoa?.source ?? schSourceType.enum.none },
      hoaFeeAmount: { source: hoaFeeAmount?.source ?? schSourceType.enum.none },
      hoaFeeFrequency: { source: hoaFeeFrequency?.source ?? schSourceType.enum.none },
      legalDescription: { source: legalDescription?.source ?? schSourceType.enum.none }
    },
    improvements: {
      propertyType: { source: schSourceType.enum.custom },
      corners: { source: schSourceType.enum.custom },
      gla: { source: gla?.source ?? schSourceType.enum.none },
      numberOfUnits: { source: numberOfUnits?.source ?? schSourceType.enum.none },
      foundation: { source: foundation ? schSourceType.enum.xml : schSourceType.enum.none },
      bedrooms: { source: bedrooms?.source ?? schSourceType.enum.none },
      fullBaths: { source: fullBaths?.source ?? schSourceType.enum.none },
      halfBaths: { source: halfBaths?.source ?? schSourceType.enum.none },
      heatingAndCooling: { source: schSourceType.enum.none },
      effectiveAge: { source: effectiveAge?.source ?? schSourceType.enum.none },
      age: { source: age?.source ?? schSourceType.enum.none },
      uadQuality: { source: uadQuality ? schSourceType.enum.xml : schSourceType.enum.custom },
      craftsmanQuality: {
        source: uadQuality ? schSourceType.enum.xml : schSourceType.enum.custom
      },
      uadCondition: {
        source: sources2.xml?.condition ? schSourceType.enum.xml : schSourceType.enum.none
      },
      basement: basement?.source,
      attic: attic?.source,
      garage: garage?.data?.type !== "detached" ? garage?.source : void 0,
      detachedGarage: garage?.data?.type === "detached" ? garage?.source : void 0,
      carport: carport?.source,
      shed: shed?.source,
      workshop: workshop?.source,
      barn: barn?.source,
      pool: pool?.source,
      spa: spa?.source,
      adu: adu?.source,
      porch: void 0,
      patio: void 0,
      deck: deck?.source,
      fireplace: fireplace?.source,
      manualCost: { source: schSourceType.enum.none },
      featureGridDataSources: { source: featureGridDataSources?.source ?? schSourceType.enum.none },
      totalEconomicLife: { source: schSourceType.enum.none },
      externalDepreciation: { source: schSourceType.enum.none },
      functionalDepreciation: { source: schSourceType.enum.none }
    },
    site: {
      area: { source: area?.source ?? schSourceType.enum.none },
      location: { source: location ? schSourceType.enum.xml : schSourceType.enum.none },
      view: { source: view ? schSourceType.enum.xml : schSourceType.enum.none }
    },
    manualAdjustments: {
      termsOfSale: { source: schSourceType.enum.none },
      concessions: { source: schSourceType.enum.none }
    }
  };
  return { editableData, editableDataSelectedSources };
}

// src/autofill/utils/listing/backupListingDataFromAllSources.ts
var import_shared_utils83 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea26 } from "@aloft/shared-objects";

// src/autofill/utils/listing/isPopulatedList.ts
function isPopulatedList(maybeList) {
  return Array.isArray(maybeList) && maybeList.length > 0;
}

// src/autofill/utils/listing/appliancesFromSources.ts
var internalFn2 = ({ zillow, mls }) => {
  if (mls?.listing.Appliances)
    return { data: mls.listing.Appliances, source: mls.source };
  if (isPopulatedList(zillow?.resoFacts?.appliances)) {
    return { data: zillow?.resoFacts?.appliances, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var appliancesFromSources = errorHandlingWrapper(internalFn2, "appliances");

// src/autofill/utils/listing/associationFeeFromSources.ts
var import_shared_utils79 = __toESM(require_lib(), 1);
var ZILLOW_ASSOCIATION_FEE_REGEX = /\$(\d+(?:\.\d{1,2})?)\s+(monthly|yearly)/;
var internalFn3 = ({ zillow, mls }) => {
  if (mls?.listing.AssociationFee) {
    return {
      data: {
        fee: mls.listing.AssociationFee,
        frequency: mls.listing.AssociationFeeFrequency
      },
      source: mls.source
    };
  }
  if (zillow?.resoFacts?.associationFee) {
    const match = zillow.resoFacts.associationFee.match(ZILLOW_ASSOCIATION_FEE_REGEX);
    if (match) {
      return {
        data: {
          fee: +(0, import_shared_utils79.expected)(match[1]),
          frequency: match[2]
        },
        source: schSourceType.enum.zillow
      };
    }
  }
  return {
    data: {
      fee: void 0,
      frequency: void 0
    },
    source: schSourceType.enum.none
  };
};
var associationFeeFromSources = errorHandlingWrapper(internalFn3, "associationFee");

// src/autofill/utils/listing/associationNameFromSources.ts
var internalFn4 = ({ zillow, mls }) => {
  if (mls?.listing.AssociationName) {
    return { data: mls.listing.AssociationName, source: mls.source };
  }
  if (zillow?.resoFacts?.associationName) {
    return { data: zillow.resoFacts.associationName, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var associationNameFromSources = errorHandlingWrapper(internalFn4, "associationName");

// src/autofill/utils/listing/associationYNFromSources.ts
import _5 from "lodash";
var internalFn5 = ({ zillow, mls }) => {
  if (mls?.listing.AssociationYN)
    return { data: mls.listing.AssociationYN, source: mls.source };
  if (!_5.isNil(zillow?.resoFacts?.hasAssociation)) {
    return { data: zillow?.resoFacts?.hasAssociation, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var associationYNFromSources = errorHandlingWrapper(internalFn5, "associationYN");

// src/autofill/utils/listing/basementDescriptionFromSources.ts
var internalFn6 = ({ zillow, mls }) => {
  if (mls?.listing.Basement)
    return { data: mls.listing.Basement, source: mls.source };
  if (zillow?.resoFacts?.basement) {
    return { data: [zillow.resoFacts.basement], source: schSourceType.enum.zillow };
  }
  return void 0;
};
var basementDescriptionFromSources = errorHandlingWrapper(
  internalFn6,
  "basementDescription"
);

// src/autofill/utils/listing/cdomFromSources.ts
var import_shared_utils80 = __toESM(require_lib(), 1);
var ZILLOW_REGEX = /(\d+)\s+days/;
var internalFn7 = ({
  zillow,
  mls
}) => {
  if (mls?.listing?.CumulativeDaysOnMarket) {
    return { data: mls.listing.CumulativeDaysOnMarket, source: mls.source };
  }
  if (zillow?.resoFacts?.cumulativeDaysOnMarket) {
    const foundStatus = getZillowStatus(zillow.homeStatus ?? null);
    if ((0, import_shared_utils80.isUndefined)(foundStatus))
      return void 0;
    const match = zillow?.resoFacts?.cumulativeDaysOnMarket.match(ZILLOW_REGEX);
    if (match) {
      return { data: +(0, import_shared_utils80.expected)(match[1]), source: schSourceType.enum.zillow };
    }
  }
  return void 0;
};
var cdomFromSources = errorHandlingWrapper(internalFn7, "cdom");

// src/autofill/utils/listing/closeDateFromSources.ts
var _internalFn2 = ({ zillow, mls }) => {
  if (mls?.listing.CloseDate)
    return { data: mls.listing.CloseDate, source: mls.source };
  const foundStatus = getZillowStatus(zillow?.homeStatus ?? null);
  if (foundStatus === "Active" || foundStatus === void 0)
    return void 0;
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowCloseDate = priceHistory.find(
    (event) => !event.postingIsRental && event.event === "Sold"
  )?.date;
  if (zillowCloseDate)
    return { data: zillowCloseDate, source: schSourceType.enum.zillow };
  return void 0;
};
var closeDateFromSources = errorHandlingWrapper(_internalFn2, "closeDate");

// src/autofill/utils/listing/closePriceFromSources.ts
var _closePriceFromSources = ({ zillow, mls }) => {
  if (mls?.listing.ClosePrice)
    return { data: mls.listing.ClosePrice, source: mls.source };
  const foundStatus = getZillowStatus(zillow?.homeStatus ?? null);
  if (foundStatus === void 0 || foundStatus === "Active")
    return void 0;
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowLastSoldPrice = priceHistory.find(
    (event) => event.event === "Sold" && event.price !== null
  )?.price;
  if (zillowLastSoldPrice) {
    return { data: zillowLastSoldPrice, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var closePriceFromSources = errorHandlingWrapper(_closePriceFromSources, "closePrice");

// src/autofill/utils/listing/contractDateFromSources.ts
var import_shared_utils81 = __toESM(require_lib(), 1);
var _internalFn3 = ({
  zillow
}) => {
  const foundStatus = getZillowStatus(zillow?.homeStatus ?? null);
  if ((0, import_shared_utils81.isUndefined)(foundStatus) || foundStatus === "Active")
    return void 0;
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowContractDate = priceHistory.find(
    (event) => !event.postingIsRental && event.event === "Pending sale"
  )?.date;
  if (zillowContractDate)
    return { data: zillowContractDate, source: schSourceType.enum.zillow };
  return void 0;
};
var contractDateFromSources = errorHandlingWrapper(_internalFn3, "contactDate");

// src/autofill/utils/listing/coolingFromSources.ts
var internalFn8 = ({ zillow, mls }) => {
  if (mls?.listing.Cooling)
    return { data: mls.listing.Cooling, source: mls.source };
  if (isPopulatedList(zillow?.resoFacts?.cooling)) {
    return { data: zillow?.resoFacts?.cooling, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var coolingFromSources = errorHandlingWrapper(internalFn8, "cooling");

// src/autofill/utils/listing/countyOrParishFromSources.ts
var internalFn9 = ({ zillow, mls }) => {
  if (mls?.listing.CountyOrParish) {
    return { data: mls.listing.CountyOrParish, source: mls.source };
  }
  if (zillow?.county) {
    return { data: zillow.county, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var countyOrParishFromSources = errorHandlingWrapper(internalFn9, "county");

// src/autofill/utils/listing/domFromSources.ts
var internalFn10 = ({
  mls
}) => {
  if (mls?.listing?.DaysOnMarket) {
    return { data: mls.listing.DaysOnMarket, source: mls.source };
  }
  return void 0;
};
var domFromSources2 = errorHandlingWrapper(internalFn10, "dom");

// src/autofill/utils/listing/elementarySchoolFromSources.ts
var internalFn11 = ({ zillow, mls }) => {
  if (mls?.listing.ElementarySchool) {
    return { data: mls.listing.ElementarySchool, source: mls.source };
  }
  if (zillow?.resoFacts?.elementarySchool) {
    return { data: zillow.resoFacts.elementarySchool, source: schSourceType.enum.zillow };
  }
  if (zillow?.resoFacts?.elementarySchoolDistrict) {
    return {
      data: zillow.resoFacts.elementarySchoolDistrict,
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var elementarySchoolFromSources = errorHandlingWrapper(internalFn11, "elementarySchool");

// src/autofill/utils/listing/exteriorFeaturesFromSources.ts
var internalFn12 = ({ zillow, mls }) => {
  if (mls?.listing.ExteriorFeatures) {
    return { data: mls.listing.ExteriorFeatures, source: mls.source };
  }
  if (isPopulatedList(zillow?.resoFacts?.exteriorFeatures)) {
    return { data: zillow?.resoFacts?.exteriorFeatures, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var exteriorFeaturesFromSources = errorHandlingWrapper(internalFn12, "exteriorFeatures");

// src/autofill/utils/listing/fireplaceCountFromSources.ts
var internalFn13 = ({ zillow, mls }) => {
  const mlsFireplaces = mls?.listing.FireplacesTotal;
  if (mls && typeof mlsFireplaces === "number" && mlsFireplaces >= 0) {
    return { data: mlsFireplaces, source: mls.source };
  }
  const zillowFireplaces = zillow?.resoFacts?.fireplaces;
  if (typeof zillowFireplaces === "number" && zillowFireplaces >= 0) {
    return { data: zillowFireplaces, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var fireplaceCountFromSources = errorHandlingWrapper(internalFn13, "fireplaceCount");

// src/autofill/utils/listing/fireplaceDescriptionFromSources.ts
var internalFn14 = ({ zillow, mls }) => {
  if (mls?.listing.FireplaceFeatures) {
    return { data: mls.listing.FireplaceFeatures, source: mls.source };
  }
  if (isPopulatedList(zillow?.resoFacts?.fireplaceFeatures)) {
    return { data: zillow?.resoFacts?.fireplaceFeatures, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var fireplaceDescriptionFromSources = errorHandlingWrapper(
  internalFn14,
  "fireplaceDescription"
);

// src/autofill/utils/listing/flooringFromSources.ts
var internalFn15 = ({ zillow, mls }) => {
  if (mls?.listing.Flooring)
    return { data: mls.listing.Flooring, source: mls.source };
  if (isPopulatedList(zillow?.resoFacts?.flooring)) {
    return { data: zillow?.resoFacts?.flooring, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var flooringFromSources = errorHandlingWrapper(internalFn15, "flooring");

// src/autofill/utils/listing/garageYNFromSources.ts
import _6 from "lodash";
var internalFn16 = ({ zillow, mls }) => {
  if (mls?.listing.GarageYN)
    return { data: mls.listing.GarageYN, source: mls.source };
  if (!_6.isNil(zillow?.resoFacts?.hasGarage)) {
    return { data: zillow?.resoFacts?.hasGarage, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var garageYNFromSources = errorHandlingWrapper(internalFn16, "garageYN");

// src/autofill/utils/listing/heatingFromSources.ts
var internalFn17 = ({ zillow, mls }) => {
  if (mls?.listing.Heating)
    return { data: mls.listing.Heating, source: mls.source };
  if (isPopulatedList(zillow?.resoFacts?.heating)) {
    return { data: zillow?.resoFacts?.heating, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var heatingFromSources = errorHandlingWrapper(internalFn17, "heating");

// src/autofill/utils/listing/highSchoolFromSources.ts
var internalFn18 = ({ zillow, mls }) => {
  if (mls?.listing.HighSchool)
    return { data: mls.listing.HighSchool, source: mls.source };
  if (zillow?.resoFacts?.highSchool) {
    return { data: zillow.resoFacts.highSchool, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var highSchoolFromSources = errorHandlingWrapper(internalFn18, "highSchool");

// src/autofill/utils/listing/interiorFeaturesFromSources.ts
var internalFn19 = ({ zillow, mls }) => {
  if (mls?.listing.InteriorFeatures) {
    return { data: mls.listing.InteriorFeatures, source: mls.source };
  }
  if (isPopulatedList(zillow?.resoFacts?.interiorFeatures)) {
    return { data: zillow?.resoFacts?.interiorFeatures, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var interiorFeaturesFromSources = errorHandlingWrapper(internalFn19, "interiorFeatures");

// src/autofill/utils/listing/listAgentFromSources.ts
var internalFn20 = ({ zillow, mls }) => {
  if (mls?.listing.ListAgentFullName) {
    return {
      data: {
        name: mls.listing.ListAgentFullName,
        phone: mls.listing.ListAgentPhone
      },
      source: mls.source
    };
  }
  return {
    data: {
      name: zillow?.attributionInfo?.agentName ?? void 0,
      phone: zillow?.attributionInfo?.agentPhoneNumber ?? void 0
    },
    source: schSourceType.enum.zillow
  };
};
var listAgentFromSources = errorHandlingWrapper(internalFn20, "agent");

// src/autofill/utils/listing/listPriceFromSources.ts
var _listPriceFromSources = ({ zillow, mls }) => {
  if (mls?.listing.ListPrice)
    return { data: mls.listing.ListPrice, source: mls.source };
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowListPrice = priceHistory.find(
    (event) => (event.event === "Listed for sale" || event.event === "Price change") && !event.postingIsRental && event.price !== null
  )?.price;
  if (zillowListPrice)
    return { data: zillowListPrice, source: schSourceType.enum.zillow };
  return void 0;
};
var listPriceFromSources = errorHandlingWrapper(_listPriceFromSources, "listPrice");

// src/autofill/utils/listing/listingPropertyTypeFromSources.ts
var internalFn21 = ({ zillow, mls }) => {
  if (mls?.listing.PropertyType)
    return { data: mls.listing.PropertyType, source: mls.source };
  if (zillow?.propertyTypeDimension) {
    return { data: zillow.propertyTypeDimension, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var listingPropertyTypeFromSources = errorHandlingWrapper(
  internalFn21,
  "listingPropertyType"
);

// src/autofill/utils/listing/lotFeaturesFromSources.ts
var internalFn22 = ({ zillow, mls }) => {
  if (mls?.listing.LotFeatures)
    return { data: mls.listing.LotFeatures, source: mls.source };
  if (isPopulatedList(zillow?.resoFacts?.lotFeatures)) {
    return { data: zillow?.resoFacts?.lotFeatures, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var lotFeaturesFromSources = errorHandlingWrapper(internalFn22, "lotFeatures");

// src/autofill/utils/listing/mediaFromSources.ts
var _mediaFromSources = ({ mls }) => {
  if (mls?.listing.Media?.length && mls?.listing.Media.length > 1) {
    return { data: mls.listing.Media, source: mls.source };
  }
  return void 0;
};
var mediaFromSources = errorHandlingWrapper(_mediaFromSources, "media");

// src/autofill/utils/listing/middleOrJuniorSchoolFromSources.ts
var internalFn23 = ({ zillow, mls }) => {
  if (mls?.listing.MiddleOrJuniorSchool) {
    return { data: mls.listing.MiddleOrJuniorSchool, source: mls.source };
  }
  if (zillow?.resoFacts?.middleOrJuniorSchool) {
    return { data: zillow.resoFacts.middleOrJuniorSchool, source: schSourceType.enum.zillow };
  }
  if (zillow?.resoFacts?.middleOrJuniorSchoolDistrict) {
    return {
      data: zillow.resoFacts.middleOrJuniorSchoolDistrict,
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var middleOrJuniorSchoolFromSources = errorHandlingWrapper(internalFn23, "middleSchool");

// src/autofill/utils/listing/mlsNameFromSources.ts
var internalFn24 = ({ zillow, mls }) => {
  if (mls?.listing.MLSName)
    return { data: mls.listing.MLSName, source: mls.source };
  if (zillow?.attributionInfo?.mlsName) {
    return { data: zillow.attributionInfo.mlsName, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var mlsNameFromSources = errorHandlingWrapper(internalFn24, "mlsName");

// src/autofill/utils/listing/mlsOUIDFromSources.ts
var internalFn25 = ({ mls }) => {
  if (mls?.listing.MLSOUID)
    return { data: mls.listing.MLSOUID, source: mls.source };
  return void 0;
};
var mlsOUIDFromSources = errorHandlingWrapper(internalFn25, "mlsOUID");

// src/autofill/utils/listing/mlsStatusFromSources.ts
var import_shared_utils82 = __toESM(require_lib(), 1);
var UAD_STATUS_TO_LISTING_STATUS = {
  Active: "Active",
  Contract: "Under Contract",
  Expired: "Expired",
  Withdrawn: "Withdrawn",
  SettledSale: "Sold"
};
var internalFn26 = (sources2) => {
  const uadStatus = statusFromSources(sources2);
  if ((0, import_shared_utils82.isUndefined)(uadStatus) || (0, import_shared_utils82.isUndefined)(uadStatus.data))
    return void 0;
  return { data: UAD_STATUS_TO_LISTING_STATUS[uadStatus.data], source: uadStatus.source };
};
var mlsStatusFromSources = errorHandlingWrapper(internalFn26, "mlsStatus");

// src/autofill/utils/listing/modificationTimestampFromSources.ts
var internalFn27 = ({ zillow, mls }) => {
  if (mls?.listing.ModificationTimestamp) {
    return { data: mls.listing.ModificationTimestamp, source: mls.source };
  }
  if (zillow?.attributionInfo?.lastUpdated) {
    return { data: zillow.attributionInfo.lastUpdated, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var modificationTimestampFromSources = errorHandlingWrapper(
  internalFn27,
  "modificationTimestamp"
);

// src/autofill/utils/listing/neighborhoodNameFromSources.ts
var internalFn28 = ({ zillow, mls }) => {
  if (mls?.listing.NeighborhoodName) {
    return { data: mls.listing.NeighborhoodName, source: mls.source };
  }
  if (zillow?.address?.neighborhood) {
    return { data: zillow.address.neighborhood, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var neighborhoodNameFromSources = errorHandlingWrapper(internalFn28, "neighborhood");

// src/autofill/utils/listing/newConstructionYNFromSources.ts
import _7 from "lodash";
var internalFn29 = ({ zillow, mls }) => {
  if (mls?.listing.NewConstructionYN) {
    return { data: mls.listing.NewConstructionYN, source: mls.source };
  }
  if (!_7.isNil(zillow?.resoFacts?.isNewConstruction)) {
    return { data: zillow?.resoFacts?.isNewConstruction, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var newConstructionYNFromSources = errorHandlingWrapper(internalFn29, "newConstruction");

// src/autofill/utils/listing/originalListPriceFromSources.ts
var _originalListPriceFromSources2 = ({
  zillow
}) => {
  const foundStatus = getZillowStatus(zillow?.homeStatus ?? null);
  if (foundStatus === void 0)
    return void 0;
  const priceHistory = getZillowPriceHistory(zillow?.priceHistory);
  const zillowListPrice = priceHistory.find(
    (event) => event.event === "Listed for sale" && !event.postingIsRental && event.price !== null
  )?.price;
  if (zillowListPrice)
    return { data: zillowListPrice, source: schSourceType.enum.zillow };
  return void 0;
};
var originalListPriceFromSources2 = errorHandlingWrapper(
  _originalListPriceFromSources2,
  "originalListPrice"
);

// src/autofill/utils/listing/parcelNumberFromSources.ts
var internalFn30 = ({ zillow, mls }) => {
  if (mls?.listing.ParcelNumber)
    return { data: mls.listing.ParcelNumber, source: mls.source };
  if (zillow?.resoFacts?.parcelNumber) {
    return { data: zillow.resoFacts.parcelNumber, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var parcelNumberFromSources2 = errorHandlingWrapper(internalFn30, "parcelNumber");

// src/autofill/utils/listing/parkingFeaturesFromSources.ts
var internalFn31 = ({ zillow, mls }) => {
  if (mls?.listing.ParkingFeatures) {
    return { data: mls.listing.ParkingFeatures, source: mls.source };
  }
  if (zillow?.resoFacts?.parkingFeatures && isPopulatedList(zillow?.resoFacts?.parkingFeatures)) {
    return { data: zillow.resoFacts.parkingFeatures, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var parkingFeaturesFromSources = errorHandlingWrapper(internalFn31, "parkingFeatures");

// src/autofill/utils/listing/parkingTotalFromSources.ts
import _8 from "lodash";
var internalFn32 = ({ zillow, mls }) => {
  if (mls?.listing.ParkingTotal)
    return { data: mls.listing.ParkingTotal, source: mls.source };
  if (!_8.isNil(zillow?.resoFacts?.parkingCapacity)) {
    return { data: zillow?.resoFacts?.parkingCapacity, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var parkingTotalFromSources = errorHandlingWrapper(internalFn32, "parkingTotal");

// src/autofill/utils/listing/patioAndPorchFeaturesFromSources.ts
var internalFn33 = ({ zillow, mls }) => {
  if (mls?.listing.PatioAndPorchFeatures) {
    return { data: mls.listing.PatioAndPorchFeatures, source: mls.source };
  }
  if (isPopulatedList(zillow?.resoFacts?.patioAndPorchFeatures)) {
    return {
      data: zillow?.resoFacts?.patioAndPorchFeatures,
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var patioAndPorchFeaturesFromSources = errorHandlingWrapper(
  internalFn33,
  "patioAndPorchFeatures"
);

// src/autofill/utils/listing/poolFeaturesFromSources.ts
var internalFn34 = ({ zillow, mls }) => {
  if (mls?.listing.PoolFeatures)
    return { data: mls.listing.PoolFeatures, source: mls.source };
  if (isPopulatedList(zillow?.resoFacts?.poolFeatures)) {
    return { data: zillow?.resoFacts?.poolFeatures, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var poolFeaturesFromSources = errorHandlingWrapper(internalFn34, "poolFeatures");

// src/autofill/utils/listing/propertySubTypeFromSources.ts
var internalFn35 = ({ zillow, mls }) => {
  if (mls?.listing.PropertySubType) {
    return { data: mls.listing.PropertySubType, source: mls.source };
  }
  if (isPopulatedList(zillow?.resoFacts?.propertySubType)) {
    return {
      data: zillow?.resoFacts?.propertySubType?.[0],
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var propertySubTypeFromSources = errorHandlingWrapper(internalFn35, "propertySubtype");

// src/autofill/utils/listing/publicRemarksFromSources.ts
var internalFn36 = ({ zillow, mls }) => {
  if (mls?.listing.PublicRemarks)
    return { data: mls.listing.PublicRemarks, source: mls.source };
  if (zillow?.description) {
    return { data: zillow.description, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var publicRemarksFromSources = errorHandlingWrapper(internalFn36, "publicRemarks");

// src/autofill/utils/listing/roofDescriptionFromSources.ts
var internalFn37 = ({ zillow, mls }) => {
  if (mls?.listing.Roof)
    return { data: mls.listing.Roof, source: mls.source };
  if (zillow?.resoFacts?.roofType) {
    return { data: [zillow.resoFacts.roofType], source: schSourceType.enum.zillow };
  }
  return void 0;
};
var roofDescriptionFromSources = errorHandlingWrapper(internalFn37, "roof");

// src/autofill/utils/listing/schoolDistrictFromSources.ts
var internalFn38 = ({ zillow, mls }) => {
  if (mls?.listing.SchoolDistrict) {
    return { data: mls.listing.SchoolDistrict, source: mls.source };
  }
  if (zillow?.resoFacts?.highSchoolDistrict) {
    return { data: zillow.resoFacts.highSchoolDistrict, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var schoolDistrictFromSources = errorHandlingWrapper(internalFn38, "schoolDistrict");

// src/autofill/utils/listing/sewerFromSources.ts
var internalFn39 = ({ zillow, mls }) => {
  if (mls?.listing.Sewer)
    return { data: mls.listing.Sewer, source: mls.source };
  if (isPopulatedList(zillow?.resoFacts?.sewer)) {
    return { data: zillow?.resoFacts?.sewer, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var sewerFromSources = errorHandlingWrapper(internalFn39, "sewer");

// src/autofill/utils/listing/storiesTotalFromSources.ts
var internalFn40 = ({ zillow, mls }) => {
  if (mls?.listing.StoriesTotal)
    return { data: mls.listing.StoriesTotal, source: mls.source };
  if (zillow?.resoFacts?.stories) {
    return { data: zillow.resoFacts.stories, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var storiesTotalFromSources = errorHandlingWrapper(internalFn40, "stories");

// src/autofill/utils/listing/structureTypeFromSources.ts
var internalFn41 = ({ zillow, mls }) => {
  if (mls?.listing.StructureType)
    return { data: mls.listing.StructureType, source: mls.source };
  if (zillow?.resoFacts?.structureType) {
    return { data: [zillow.resoFacts.structureType], source: schSourceType.enum.zillow };
  }
  return void 0;
};
var structureTypeFromSources = errorHandlingWrapper(internalFn41, "structureType");

// src/autofill/utils/listing/styleFromSources.ts
var internalFn42 = ({ zillow, mls }) => {
  if (mls?.listing.ArchitecturalStyle) {
    return { data: mls.listing.ArchitecturalStyle, source: mls.source };
  }
  if (zillow?.resoFacts?.architecturalStyle) {
    return { data: [zillow.resoFacts.architecturalStyle], source: schSourceType.enum.zillow };
  }
  return void 0;
};
var styleFromSources = errorHandlingWrapper(internalFn42, "style");

// src/autofill/utils/listing/subdivisionNameFromSources.ts
var internalFn43 = ({ zillow, mls }) => {
  if (mls?.listing.SubdivisionName) {
    return { data: mls.listing.SubdivisionName, source: mls.source };
  }
  if (zillow?.resoFacts?.subdivisionName) {
    return { data: zillow.resoFacts.subdivisionName, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var subdivisionNameFromSources = errorHandlingWrapper(internalFn43, "subdivision");

// src/autofill/utils/listing/taxAnnualAmountFromSources.ts
var internalFn44 = ({ zillow, mls }) => {
  if (mls?.listing.TaxAnnualAmount) {
    return { data: mls.listing.TaxAnnualAmount, source: mls.source };
  }
  if (zillow?.resoFacts?.taxAnnualAmount) {
    return { data: zillow.resoFacts.taxAnnualAmount, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var taxAnnualAmountFromSources = errorHandlingWrapper(internalFn44, "taxAnnualAmount");

// src/autofill/utils/listing/threeQuarterBathsFromSources.ts
var internalFn45 = ({ zillow, mls }) => {
  const mlsThreeQuarterBaths = mls?.listing.BathroomsThreeQuarter;
  if (mls && typeof mlsThreeQuarterBaths === "number" && mlsThreeQuarterBaths >= 0) {
    return { data: mlsThreeQuarterBaths, source: mls.source };
  }
  const zillowThreeQuarterBaths = zillow?.resoFacts?.bathroomsThreeQuarter;
  if (typeof zillowThreeQuarterBaths === "number" && zillowThreeQuarterBaths >= 0) {
    return { data: zillowThreeQuarterBaths, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var threeQuarterBathsFromSources = errorHandlingWrapper(
  internalFn45,
  "bathroomsThreeQuarter"
);

// src/autofill/utils/listing/toolkitListingIdFromSources.ts
var internalFn46 = ({ mls }) => {
  if (mls?.listing.ToolkitListingID)
    return { data: mls.listing.ToolkitListingID, source: mls.source };
  return void 0;
};
var toolkitListingIdFromSources = errorHandlingWrapper(internalFn46, "toolkitListingId");

// src/autofill/utils/listing/topographyFromSources.ts
var internalFn47 = ({ zillow, mls }) => {
  if (mls?.listing.Topography)
    return { data: mls.listing.Topography, source: mls.source };
  if (zillow?.resoFacts?.topography) {
    return { data: zillow.resoFacts.topography, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var topographyFromSources = errorHandlingWrapper(internalFn47, "topography");

// src/autofill/utils/listing/totalBathroomsFromSources.ts
var internalFn48 = ({ zillow, mls }) => {
  const mlsBathrooms = mls?.listing.BathroomsTotalInteger;
  if (mls && typeof mlsBathrooms === "number" && mlsBathrooms >= 0) {
    return { data: mlsBathrooms, source: mls.source };
  }
  const zillowBathrooms = zillow?.bathrooms;
  if (typeof zillowBathrooms === "number" && zillowBathrooms >= 0) {
    return { data: zillowBathrooms, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var totalBathroomsFromSources = errorHandlingWrapper(internalFn48, "bathrooms");

// src/autofill/utils/listing/unparsedAddressFromSources.ts
var internalFn49 = ({ zillow, mls }) => {
  if (mls?.listing.UnparsedAddress) {
    return { data: mls.listing.UnparsedAddress, source: mls.source };
  }
  if (zillow?.address?.streetAddress) {
    return { data: zillow.address.streetAddress, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var unparsedAddressFromSources = errorHandlingWrapper(internalFn49, "unparsedAddress");

// src/autofill/utils/listing/viewFromSources.ts
var internalFn50 = ({ zillow, mls }) => {
  if (mls?.listing.View) {
    return { data: mls.listing.View, source: mls.source };
  }
  if (isPopulatedList(zillow?.resoFacts?.view)) {
    return { data: zillow?.resoFacts?.view, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var viewFromSources = errorHandlingWrapper(internalFn50, "view");

// src/autofill/utils/listing/waterFrontFeaturesFromSources.ts
var internalFn51 = ({ zillow, mls }) => {
  if (mls?.listing.WaterFrontFeatures) {
    return { data: mls.listing.WaterFrontFeatures, source: mls.source };
  }
  if (isPopulatedList(zillow?.resoFacts?.waterfrontFeatures)) {
    return {
      data: zillow?.resoFacts?.waterfrontFeatures.join(", "),
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var waterFrontFeaturesFromSources = errorHandlingWrapper(internalFn51, "waterFrontFeatures");

// src/autofill/utils/listing/waterFrontYNFromSources.ts
var internalFn52 = ({ zillow, mls }) => {
  if (mls?.listing.WaterFrontYN)
    return { data: mls.listing.WaterFrontYN, source: mls.source };
  if (zillow?.resoFacts?.frontageLength) {
    return {
      data: zillow.resoFacts?.frontageLength.toLowerCase().includes("waterfront"),
      source: schSourceType.enum.zillow
    };
  }
  return void 0;
};
var waterFrontYNFromSources = errorHandlingWrapper(internalFn52, "waterfrontYN");

// src/autofill/utils/listing/waterSourceFromSources.ts
var internalFn53 = ({ zillow, mls }) => {
  if (mls?.listing.WaterSource)
    return { data: mls.listing.WaterSource, source: mls.source };
  if (isPopulatedList(zillow?.resoFacts?.waterSource)) {
    return { data: zillow?.resoFacts?.waterSource, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var waterSourceFromSources = errorHandlingWrapper(internalFn53, "waterSource");

// src/autofill/utils/listing/yearBuiltFromSources.ts
var internalFn54 = ({ zillow, mls }) => {
  if (mls?.listing.YearBuilt)
    return { data: mls.listing.YearBuilt, source: mls.source };
  if (zillow?.yearBuilt) {
    return { data: zillow.yearBuilt, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var yearBuiltFromSources = errorHandlingWrapper(internalFn54, "yearBuilt");

// src/autofill/utils/listing/poolPrivateYNFromSources.ts
import _9 from "lodash";
var internalFn55 = ({ zillow, mls }) => {
  if (mls?.listing.PoolPrivateYN !== void 0)
    return { data: mls.listing.PoolPrivateYN, source: mls.source };
  if (!_9.isNil(zillow?.resoFacts?.hasPrivatePool)) {
    return { data: zillow?.resoFacts?.hasPrivatePool, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var poolPrivateYNFromSources = errorHandlingWrapper(internalFn55, "poolPrivateYN");

// src/autofill/utils/listing/basementYNFromSources.ts
import _10 from "lodash";
var internalFn56 = ({ zillow, mls }) => {
  if (mls?.listing.BasementYN !== void 0)
    return { data: mls.listing.BasementYN, source: mls.source };
  if (!_10.isNil(zillow?.resoFacts?.basementYN)) {
    return { data: zillow?.resoFacts?.basementYN, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var basementYNFromSources = errorHandlingWrapper(internalFn56, "basementYN");

// src/autofill/utils/listing/specialListingConditionsFromSources.ts
import _11 from "lodash";
var internalFn57 = ({ zillow, mls }) => {
  if (mls?.listing.SpecialListingConditions !== void 0)
    return { data: mls.listing.SpecialListingConditions, source: mls.source };
  if (!_11.isNil(zillow?.resoFacts?.specialListingConditions)) {
    return { data: [zillow?.resoFacts?.specialListingConditions], source: schSourceType.enum.zillow };
  }
  return void 0;
};
var specialListingConditionsFromSources = errorHandlingWrapper(internalFn57, "specialListingConditions");

// src/autofill/utils/listing/countyFIPSFromSources.ts
var internalFn58 = ({ zillow, mls }) => {
  if (mls?.listing?.CountyOrParishFIPS) {
    return { data: mls.listing.CountyOrParishFIPS, source: mls.source };
  }
  if (zillow?.countyFIPS) {
    return { data: zillow.countyFIPS, source: schSourceType.enum.zillow };
  }
  return void 0;
};
var countyOrParishFIPSFromSources = errorHandlingWrapper(internalFn58, "countyFIPS");

// src/autofill/utils/listing/backupListingDataFromAllSources.ts
function backupListingDataFromAllSources({
  address,
  sources: sources2
}) {
  const media = mediaFromSources(sources2);
  const unparsedAddress = unparsedAddressFromSources(sources2);
  const closePrice = closePriceFromSources(sources2);
  const listPrice = listPriceFromSources(sources2);
  const originalListPrice = originalListPriceFromSources2(sources2);
  const mlsStatus = mlsStatusFromSources(sources2);
  const listingId = mlsListingIDFromSources(sources2);
  const livingArea = glaFromSources(sources2);
  const bedroomsTotal = bedroomsFromSources(sources2);
  const bathroomsTotalInteger = totalBathroomsFromSources(sources2);
  const yearBuilt = yearBuiltFromSources(sources2);
  const lotSizeSquareFeet = siteAreaFromSources(sources2);
  const publicRemarks = publicRemarksFromSources(sources2);
  const purchaseContractDate = contractDateFromSources(sources2);
  const closeDate = closeDateFromSources(sources2);
  const cumulativeDaysOnMarket = cdomFromSources(sources2);
  const daysOnMarket = domFromSources2(sources2);
  const propertySubType = propertySubTypeFromSources(sources2);
  const propertyType = listingPropertyTypeFromSources(sources2);
  const basement = basementDescriptionFromSources(sources2);
  const structureType = structureTypeFromSources(sources2);
  const architecturalStyle = styleFromSources(sources2);
  const storiesTotal = storiesTotalFromSources(sources2);
  const newConstructionYN = newConstructionYNFromSources(sources2);
  const roof = roofDescriptionFromSources(sources2);
  const bathroomsFull = fullBathsFromSources(sources2);
  const bathroomsHalf = halfBathsFromSources(sources2);
  const bathroomsThreeQuarter = threeQuarterBathsFromSources(sources2);
  const fireplacesTotal = fireplaceCountFromSources(sources2);
  const fireplaceFeatures = fireplaceDescriptionFromSources(sources2);
  const parkingFeatures = parkingFeaturesFromSources(sources2);
  const parkingTotal = parkingTotalFromSources(sources2);
  const garageYN = garageYNFromSources(sources2);
  const garageSpaces = garageFromSources(sources2);
  const taxAnnualAmount = taxAnnualAmountFromSources(sources2);
  const waterSource = waterSourceFromSources(sources2);
  const sewer = sewerFromSources(sources2);
  const lotFeatures = lotFeaturesFromSources(sources2);
  const topography = topographyFromSources(sources2);
  const view = viewFromSources(sources2);
  const waterFrontYN = waterFrontYNFromSources(sources2);
  const waterFrontFeatures = waterFrontFeaturesFromSources(sources2);
  const parcelNumber = parcelNumberFromSources2(sources2);
  const flooring = flooringFromSources(sources2);
  const heating = heatingFromSources(sources2);
  const cooling = coolingFromSources(sources2);
  const exteriorFeatures = exteriorFeaturesFromSources(sources2);
  const interiorFeatures = interiorFeaturesFromSources(sources2);
  const appliances = appliancesFromSources(sources2);
  const patioAndPorchFeatures = patioAndPorchFeaturesFromSources(sources2);
  const poolFeatures = poolFeaturesFromSources(sources2);
  const associationYN = associationYNFromSources(sources2);
  const associationName = associationNameFromSources(sources2);
  const associationFee = associationFeeFromSources(sources2);
  const subdivisionName = subdivisionNameFromSources(sources2);
  const neighborhoodName = neighborhoodNameFromSources(sources2);
  const countyOrParish = countyOrParishFromSources(sources2);
  const schoolDistrict = schoolDistrictFromSources(sources2);
  const elementarySchool = elementarySchoolFromSources(sources2);
  const highSchool = highSchoolFromSources(sources2);
  const middleOrJuniorSchool = middleOrJuniorSchoolFromSources(sources2);
  const listAgent = listAgentFromSources(sources2);
  const mLSName = mlsNameFromSources(sources2);
  const modificationTimestamp = modificationTimestampFromSources(sources2);
  const mLSOUID = mlsOUIDFromSources(sources2);
  const toolkitListingId = toolkitListingIdFromSources(sources2);
  const poolPrivateYN = poolPrivateYNFromSources(sources2);
  const basementYN = basementYNFromSources(sources2);
  const specialListingConditions = specialListingConditionsFromSources(sources2);
  const countyFips = countyOrParishFIPSFromSources(sources2);
  const result = {
    Media: media?.data,
    UnparsedAddress: unparsedAddress?.data,
    City: address.CityName,
    StateOrProvince: address.StateCode,
    PostalCode: address.PostalCode,
    ClosePrice: closePrice?.data,
    ListPrice: listPrice?.data,
    OriginalListPrice: originalListPrice?.data,
    MlsStatus: mlsStatus?.data,
    ListingId: listingId?.data,
    LivingArea: (0, import_shared_utils83.orUndefined)(AloftArea26.schema.parse)(livingArea?.data)?.getUnitAmount("sqft"),
    BedroomsTotal: bedroomsTotal?.data,
    BathroomsTotalInteger: bathroomsTotalInteger?.data,
    YearBuilt: yearBuilt?.data,
    LotSizeSquareFeet: (0, import_shared_utils83.orUndefined)(AloftArea26.schema.parse)(lotSizeSquareFeet?.data)?.getUnitAmount(
      "sqft"
    ),
    PublicRemarks: publicRemarks?.data,
    PurchaseContractDate: purchaseContractDate?.data,
    CloseDate: closeDate?.data,
    CumulativeDaysOnMarket: cumulativeDaysOnMarket?.data,
    DaysOnMarket: daysOnMarket?.data,
    PropertySubType: propertySubType?.data,
    PropertyType: propertyType?.data,
    Basement: basement?.data,
    StructureType: structureType?.data,
    ArchitecturalStyle: architecturalStyle?.data,
    StoriesTotal: storiesTotal?.data,
    NewConstructionYN: newConstructionYN?.data,
    Roof: roof?.data,
    BathroomsFull: bathroomsFull?.data,
    BathroomsHalf: bathroomsHalf?.data,
    BathroomsThreeQuarter: bathroomsThreeQuarter?.data,
    FireplacesTotal: fireplacesTotal?.data,
    FireplaceFeatures: fireplaceFeatures?.data,
    ParkingFeatures: parkingFeatures?.data,
    ParkingTotal: parkingTotal?.data,
    GarageYN: garageYN?.data,
    GarageSpaces: garageSpaces?.data?.spaces,
    TaxYear: void 0,
    TaxAnnualAmount: taxAnnualAmount?.data,
    WaterSource: waterSource?.data,
    Sewer: sewer?.data,
    LotFeatures: lotFeatures?.data,
    Topography: topography?.data,
    View: view?.data,
    WaterFrontYN: waterFrontYN?.data,
    WaterFrontFeatures: waterFrontFeatures?.data,
    ParcelNumber: parcelNumber?.data,
    Flooring: flooring?.data,
    Heating: heating?.data,
    Cooling: cooling?.data,
    ExteriorFeatures: exteriorFeatures?.data,
    InteriorFeatures: interiorFeatures?.data,
    Appliances: appliances?.data,
    PatioAndPorchFeatures: patioAndPorchFeatures?.data,
    PoolFeatures: poolFeatures?.data,
    AssociationYN: associationYN?.data,
    AssociationName: associationName?.data,
    AssociationFee: associationFee?.data?.fee,
    AssociationFeeFrequency: associationFee?.data?.frequency,
    SubdivisionName: subdivisionName?.data,
    NeighborhoodName: neighborhoodName?.data,
    CountyOrParish: countyOrParish?.data,
    CountyOrParishFIPS: countyFips?.data,
    Directions: void 0,
    SchoolDistrict: schoolDistrict?.data,
    ElementarySchool: elementarySchool?.data,
    HighSchool: highSchool?.data,
    MiddleOrJuniorSchool: middleOrJuniorSchool?.data,
    ListAgentFullName: listAgent?.data?.name,
    ListAgentPhone: listAgent?.data?.phone,
    ListAgentMlsID: void 0,
    ListOfficeName: void 0,
    ListOfficePhone: void 0,
    MLSName: mLSName?.data,
    ModificationTimestamp: modificationTimestamp?.data,
    MLSOUID: mLSOUID?.data,
    ToolkitListingID: toolkitListingId?.data,
    PoolPrivateYN: poolPrivateYN?.data,
    BasementYN: basementYN?.data,
    SpecialListingConditions: specialListingConditions?.data
  };
  const backupListingDataSelectedSources = {
    listing: {
      Media: { source: media?.source ?? schSourceType.enum.none },
      UnparsedAddress: { source: unparsedAddress?.source ?? schSourceType.enum.none },
      City: { source: schSourceType.enum.custom },
      StateOrProvince: { source: schSourceType.enum.custom },
      PostalCode: { source: schSourceType.enum.custom },
      ClosePrice: { source: closePrice?.source ?? schSourceType.enum.none },
      ListPrice: { source: listPrice?.source ?? schSourceType.enum.none },
      OriginalListPrice: { source: originalListPrice?.source ?? schSourceType.enum.none },
      MlsStatus: { source: mlsStatus?.source ?? schSourceType.enum.none },
      ListingId: { source: listingId?.source ?? schSourceType.enum.none },
      LivingArea: { source: livingArea?.source ?? schSourceType.enum.none },
      BedroomsTotal: { source: bedroomsTotal?.source ?? schSourceType.enum.none },
      BathroomsTotalInteger: { source: bathroomsTotalInteger?.source ?? schSourceType.enum.none },
      YearBuilt: { source: yearBuilt?.source ?? schSourceType.enum.none },
      LotSizeSquareFeet: { source: lotSizeSquareFeet?.source ?? schSourceType.enum.none },
      PublicRemarks: { source: publicRemarks?.source ?? schSourceType.enum.none },
      PurchaseContractDate: { source: purchaseContractDate?.source ?? schSourceType.enum.none },
      CloseDate: { source: closeDate?.source ?? schSourceType.enum.none },
      CumulativeDaysOnMarket: {
        source: cumulativeDaysOnMarket?.source ?? schSourceType.enum.none
      },
      DaysOnMarket: { source: daysOnMarket?.source ?? schSourceType.enum.none },
      PropertySubType: { source: propertySubType?.source ?? schSourceType.enum.none },
      PropertyType: { source: propertyType?.source ?? schSourceType.enum.none },
      Basement: { source: basement?.source ?? schSourceType.enum.none },
      StructureType: { source: structureType?.source ?? schSourceType.enum.none },
      ArchitecturalStyle: { source: architecturalStyle?.source ?? schSourceType.enum.none },
      StoriesTotal: { source: storiesTotal?.source ?? schSourceType.enum.none },
      NewConstructionYN: { source: newConstructionYN?.source ?? schSourceType.enum.none },
      Roof: { source: roof?.source ?? schSourceType.enum.none },
      BathroomsFull: { source: bathroomsFull?.source ?? schSourceType.enum.none },
      BathroomsHalf: { source: bathroomsHalf?.source ?? schSourceType.enum.none },
      BathroomsThreeQuarter: { source: bathroomsThreeQuarter?.source ?? schSourceType.enum.none },
      FireplacesTotal: { source: fireplacesTotal?.source ?? schSourceType.enum.none },
      FireplaceFeatures: { source: fireplaceFeatures?.source ?? schSourceType.enum.none },
      ParkingFeatures: { source: parkingFeatures?.source ?? schSourceType.enum.none },
      ParkingTotal: { source: parkingTotal?.source ?? schSourceType.enum.none },
      GarageYN: { source: garageYN?.source ?? schSourceType.enum.none },
      GarageSpaces: { source: garageSpaces?.source.spaces?.source ?? schSourceType.enum.none },
      TaxYear: { source: schSourceType.enum.none },
      TaxAnnualAmount: { source: taxAnnualAmount?.source ?? schSourceType.enum.none },
      WaterSource: { source: waterSource?.source ?? schSourceType.enum.none },
      Sewer: { source: sewer?.source ?? schSourceType.enum.none },
      LotFeatures: { source: lotFeatures?.source ?? schSourceType.enum.none },
      Topography: { source: topography?.source ?? schSourceType.enum.none },
      View: { source: view?.source ?? schSourceType.enum.none },
      WaterFrontYN: { source: waterFrontYN?.source ?? schSourceType.enum.none },
      WaterFrontFeatures: { source: waterFrontFeatures?.source ?? schSourceType.enum.none },
      ParcelNumber: { source: parcelNumber?.source ?? schSourceType.enum.none },
      Flooring: { source: flooring?.source ?? schSourceType.enum.none },
      Heating: { source: heating?.source ?? schSourceType.enum.none },
      Cooling: { source: cooling?.source ?? schSourceType.enum.none },
      ExteriorFeatures: { source: exteriorFeatures?.source ?? schSourceType.enum.none },
      InteriorFeatures: { source: interiorFeatures?.source ?? schSourceType.enum.none },
      Appliances: { source: appliances?.source ?? schSourceType.enum.none },
      PatioAndPorchFeatures: { source: patioAndPorchFeatures?.source ?? schSourceType.enum.none },
      PoolFeatures: { source: poolFeatures?.source ?? schSourceType.enum.none },
      AssociationYN: { source: associationYN?.source ?? schSourceType.enum.none },
      AssociationName: { source: associationName?.source ?? schSourceType.enum.none },
      AssociationFee: { source: associationFee?.source ?? schSourceType.enum.none },
      AssociationFeeFrequency: { source: associationFee?.source ?? schSourceType.enum.none },
      SubdivisionName: { source: subdivisionName?.source ?? schSourceType.enum.none },
      NeighborhoodName: { source: neighborhoodName?.source ?? schSourceType.enum.none },
      CountyOrParish: { source: countyOrParish?.source ?? schSourceType.enum.none },
      CountyOrParishFIPS: { source: countyFips?.source ?? schSourceType.enum.none },
      Directions: { source: schSourceType.enum.none },
      SchoolDistrict: { source: schoolDistrict?.source ?? schSourceType.enum.none },
      ElementarySchool: { source: elementarySchool?.source ?? schSourceType.enum.none },
      HighSchool: { source: highSchool?.source ?? schSourceType.enum.none },
      MiddleOrJuniorSchool: { source: middleOrJuniorSchool?.source ?? schSourceType.enum.none },
      ListAgentFullName: { source: listAgent?.source ?? schSourceType.enum.none },
      ListAgentPhone: { source: listAgent?.source ?? schSourceType.enum.none },
      ListAgentMlsID: { source: schSourceType.enum.none },
      ListOfficeName: { source: schSourceType.enum.none },
      ListOfficePhone: { source: schSourceType.enum.none },
      MLSName: { source: mLSName?.source ?? schSourceType.enum.none },
      MLSOUID: { source: mLSOUID?.source ?? schSourceType.enum.none },
      ModificationTimestamp: { source: modificationTimestamp?.source ?? schSourceType.enum.none },
      ToolkitListingID: { source: toolkitListingId?.source ?? schSourceType.enum.none }
    }
  };
  return {
    backupListingData: {
      version: 1,
      listing: result
    },
    backupListingDataSelectedSources
  };
}

// src/autofill/autofillProperty.ts
function autofillProperty({
  address,
  effectiveYear,
  propertyType,
  defaultMLS,
  sources: sources2,
  includeBackupListingData = true
}) {
  const { editableData, editableDataSelectedSources } = editablePropertyDataFromAllSources({
    address,
    effectiveYear,
    propertyType,
    defaultMLS,
    sources: sources2
  });
  const result = {
    $type: "PropertyData",
    version: 1,
    editableData,
    selectedSources: {
      editableData: editableDataSelectedSources
    }
  };
  if (!includeBackupListingData)
    return result;
  const { backupListingData, backupListingDataSelectedSources } = backupListingDataFromAllSources({
    address,
    effectiveYear,
    propertyType,
    sources: sources2
  });
  return {
    ...result,
    readonlyData: { backupListingData },
    selectedSources: {
      ...result.selectedSources,
      readonlyData: {
        backupListingData: backupListingDataSelectedSources
      }
    }
  };
}

// src/costData/consts.ts
import { AloftDate as AloftDate17 } from "@aloft/shared-objects";
var EMPTY_EDITABLE_COST_DATA_INPUT = {
  primaryDwelling: {},
  basement: {},
  attic: {},
  attachedOrBuiltinGarage: {},
  detachedGarage: {},
  carport: {},
  deck: {},
  coveredPatioOrGazebo: {},
  enclosedPatio: {},
  pool: {},
  adu: {},
  shed: {},
  workshop: {},
  bonusRoom: {},
  barn: {},
  manufactured: {},
  depreciation: {},
  effectiveDate: AloftDate17.today(),
  zip: "91355",
  address: ""
};
var EMPTY_COST_DATA_RESPONSE = {
  structureCosts: {},
  editableInput: EMPTY_EDITABLE_COST_DATA_INPUT
};
var MAGIC_QUOTA_EXCEEDED_STRING = "JqOtaBs1GeUQCowO";

// src/costData/index.ts
import { z as z107 } from "zod";

// src/costData/costDataResponseToDocument.ts
function costDataResponseToDocument({
  editableInput,
  additionalFeaturesCost,
  siteCost
}) {
  return {
    editableInput,
    additionalFeaturesCost,
    siteCost
  };
}

// src/costData/editableCostDataToInput.ts
var import_shared_utils84 = __toESM(require_lib(), 1);
import { AloftCount as AloftCount12 } from "@aloft/shared-objects";
function editableCostDataToInput(editable, property) {
  const editableInput = editable ?? { ...EMPTY_EDITABLE_COST_DATA_INPUT };
  return {
    ...editableInput,
    address: (0, import_shared_utils84.expected)(property?.address?.AddressLineText),
    zip: (0, import_shared_utils84.expected)(property?.address?.PostalCode),
    primaryDwelling: {
      ...editableInput.primaryDwelling,
      bedrooms: property?.aboveGradeBedroomCount?.add(property?.belowGradeBedroomCount),
      bathroomsFull: property?.aboveGradeFullBathCount?.add(
        // TODO: migrate belowGradeFullBathCount from number to AloftCount
        AloftCount12.fromNumber(
          (0, import_shared_utils84.orUndefined)((n) => Math.round(n))(property?.belowGradeFullBathCount)
        )
      ),
      bathroomsHalf: property?.aboveGradeHalfBathCount?.add(property?.belowGradeHalfBathCount),
      stories: property?.designNumberOfStories,
      gla: property?.grossLivingArea
    },
    attachedOrBuiltinGarage: {
      ...editableInput.attachedOrBuiltinGarage,
      attachedSpaceCount: property?.attachedGarageParkingSpacesCount,
      builtinSpaceCount: property?.builtInGarageParkingSpacesCount
    },
    detachedGarage: {
      ...editableInput.detachedGarage,
      spaceCount: property?.detachedGarageParkingSpacesCount
    },
    carport: {
      ...editableInput.carport,
      spaceCount: property?.carportParkingSpacesCount
    },
    basement: {
      ...editableInput.basement,
      totalSqft: property?.totalBasementArea,
      finishedSqft: property?.finishedBasementArea,
      access: property?.belowGradeExteriorAccessType
    },
    depreciation: {
      physicalDepreciation: {
        primaryDwelling: {
          effectiveAge: editableInput.depreciation.effectiveAge,
          ecoLifeYears: editableInput.depreciation.ecoLifeYears
        }
      },
      functionalObsolescence: {
        percent: editableInput.depreciation.functionalObsolescencePercent
      },
      externalDepreciation: {
        percent: editableInput.depreciation.externalDepreciationPercent
      }
    }
  };
}

// src/costData/costDataInputToEditable.ts
function costDataInputToEditable(input) {
  return {
    ...input,
    primaryDwelling: {
      quality: input.primaryDwelling.quality,
      nonStandardGLA: input.primaryDwelling.nonStandardGLA
    },
    basement: {
      quality: input.basement.quality
    },
    depreciation: {
      effectiveAge: input.depreciation.physicalDepreciation.primaryDwelling?.effectiveAge,
      ecoLifeYears: input.depreciation.physicalDepreciation.primaryDwelling?.ecoLifeYears,
      functionalObsolescencePercent: input.depreciation.functionalObsolescence.percent,
      externalDepreciationPercent: input.depreciation.externalDepreciation.percent
    }
  };
}

// src/costData/filterDwellingCostInput.ts
import _12 from "lodash";
function filterDwellingCostInput(costDataInput) {
  return _12.omit(costDataInput, ["depreciation"]);
}

// src/costData/validateCostDataDocuments.ts
var import_shared_utils85 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea27, AloftCount as AloftCount13 } from "@aloft/shared-objects";
var FIELD_TO_STRING_MAP = {
  zip: "Zip Code",
  quality: "Quality",
  gla: "GLA",
  stories: "Stories",
  bathroomsFull: "Bathrooms",
  bathroomsHalf: "1/2 Bathrooms",
  bedrooms: "Bedrooms",
  totalSqft: "Square Footage",
  attachedSpaceCount: "Spaces",
  builtinSpaceCount: "Spaces",
  finishedSqft: "Finished Square Footage",
  subpanel: "Subpanel",
  percentInteriorFinished: "Percent Finished",
  electrical: "Electrical",
  plumbingFixturesCount: "Plumbing Fixtures",
  hasExteriorWall: "Exterior Wall",
  isPoleBarn: "Pole Barn",
  sections: "Sections",
  hasAC: "Air Conditioning",
  hasClimatePkg: "Climate Package",
  foundationType: "Foundation Type",
  fireplaces: "Fireplaces",
  fireplaceType: "Fireplace Type",
  deliveryMileage: "Delivery Mileage",
  exists: "Exists",
  linearFootage: "Linear Feet of Wall",
  multiUnitCount: "No. of Multi-Family Units"
};
var KEY_TO_STRUCTURE_MAP = {
  primaryDwelling: "Primary Dwelling",
  basement: "Basement",
  attic: "Attic",
  attachedOrBuiltinGarage: "Attached Garage",
  detachedGarage: "Detached Garage",
  carport: "Carport",
  deck: "Deck",
  coveredPatioOrGazebo: "Cvd Patio / Gazebo",
  enclosedPatio: "Enclosed Patio",
  pool: "Pool",
  adu: "Guest House / ADU",
  shed: "Shed",
  workshop: "Workshop",
  bonusRoom: "Bonus Room",
  barn: "Barn",
  manufactured: "Manufactured Dwelling"
};
function validateCostDataDocuments(orderDocument, subject, comps, compOrder) {
  const errors = [];
  const subjectErrors = validatePropertyCostData(orderDocument?.subject, subject);
  if (subjectErrors.length > 0) {
    errors.push({
      propKey: "subject",
      propName: "Subject",
      missingErrors: getMissingErrors(subjectErrors)
    });
  }
  compOrder.forEach((recordID, index) => {
    const { attachmentID } = parseCompToolkitRecordID(recordID);
    const compData = orderDocument?.[attachmentID];
    const property = comps?.[recordID];
    if ((0, import_shared_utils85.isDefined)(property)) {
      const compErrors = validatePropertyCostData(compData, property);
      if (compErrors.length > 0) {
        errors.push({
          propKey: attachmentID,
          propName: `Comp ${index + 1}`,
          missingErrors: getMissingErrors(compErrors)
        });
      }
    }
  });
  return errors;
}
function validateCostDataDocumentsV2(effectiveDate, subject, comps, compSequence2) {
  const errors = [];
  if (effectiveDate === void 0) {
    return [];
  }
  const subjectErrors = validatePropertyCostDataV2(effectiveDate, subject);
  if (subjectErrors.length > 0) {
    errors.push({
      propKey: "subject",
      propName: "Subject",
      missingErrors: getMissingErrors(subjectErrors)
    });
  }
  for (const [index, compID] of (0, import_shared_utils85.enumerate)(compSequence2)) {
    const comp = (0, import_shared_utils85.expected)(comps[compID]);
    const compErrors = validatePropertyCostDataV2(effectiveDate, comp);
    if (compErrors.length > 0) {
      errors.push({
        propKey: compID,
        propName: `Comp ${index + 1}`,
        missingErrors: getMissingErrors(compErrors)
      });
    }
  }
  return errors;
}
function getMissingErrors(errors) {
  return errors.filter((error) => error.type === "missing").map((error) => {
    const { type, key, field: rawField } = error;
    let field;
    const mappedField = FIELD_TO_STRING_MAP[String(rawField)];
    if ((0, import_shared_utils85.isUndefined)(mappedField)) {
      console.error("Missing mapping for field: " + String(rawField));
      field = String(rawField);
    } else {
      field = mappedField;
    }
    let structure;
    const mappedStructure = key === "address" ? "Address" : KEY_TO_STRUCTURE_MAP[key];
    if ((0, import_shared_utils85.isUndefined)(mappedStructure)) {
      console.error("Missing structure mapping for key: " + key);
      structure = String(key);
    } else {
      structure = mappedStructure;
    }
    return {
      type,
      structure,
      field,
      errorKey: `${key}.${String(rawField)}`
      // Should get type safety through CostDataError
    };
  });
}
function validatePropertyCostData(data, property) {
  const currentInput = editableCostDataToInput(data?.editableInput, property);
  return isValidDwellingCostInput(currentInput);
}
function validatePropertyCostDataV2(effectiveDate, property) {
  const propertyType = property.getPropertyType();
  return isValidDwellingCostInput(property.getCostDataInput(effectiveDate), propertyType);
}
function isValidDwellingCostInput(dcInput, propertyType) {
  const zipErrors = hasValidZip(dcInput);
  const primaryDwellingErrors = hasValidPrimaryDwelling(dcInput, propertyType);
  const attachedOrBuiltinGarageErrors = hasValidAttachedOrBuiltinGarage(dcInput);
  const detachedGarageErrors = hasValidDetachedGarage(dcInput);
  const carportErrors = hasValidCarport(dcInput);
  const atticErrors = hasValidAttic(dcInput);
  const basementErrors = hasValidBasement(dcInput);
  const aduErrors = hasValidADU(dcInput);
  const bonusErrors = hasValidBonusRoom(dcInput);
  const shedErrors = hasValidShed(dcInput);
  const workshopErrors = hasValidWorkshop(dcInput);
  const barnErrors = hasValidBarn(dcInput);
  const manufacturedErrors = hasValidManufacturedDwelling(dcInput);
  const deckErrors = hasValidDeck(dcInput);
  const cvdPatioErrors = hasValidCvdPatio(dcInput);
  const enclosedPatioErrors = hasValidEnclosedPatio(dcInput);
  const poolErrors = hasValidPool(dcInput);
  const bonusRoomErrors = hasValidBonusRoom(dcInput);
  return [
    ...zipErrors,
    ...primaryDwellingErrors,
    ...attachedOrBuiltinGarageErrors,
    ...detachedGarageErrors,
    ...carportErrors,
    ...atticErrors,
    ...basementErrors,
    ...aduErrors,
    ...bonusErrors,
    ...shedErrors,
    ...workshopErrors,
    ...barnErrors,
    ...manufacturedErrors,
    ...deckErrors,
    ...cvdPatioErrors,
    ...enclosedPatioErrors,
    ...poolErrors,
    ...bonusRoomErrors
  ];
}
function hasZeroSqftAndNoQuality({
  quality,
  totalSqft,
  gla
}) {
  return quality === void 0 && (totalSqft?.equals(AloftArea27.zero) || gla?.equals(AloftArea27.zero));
}
function eitherUndefOrZeroBypass(v) {
  return !(0, import_shared_utils85.hasDefinedValues)(v) || hasZeroSqftAndNoQuality(v);
}
function hasValidZip(dcInput) {
  const { zip } = dcInput;
  if (zip === void 0 || zip.trim().length === 0) {
    return [
      {
        type: "missing",
        key: "address",
        field: "zip"
      }
    ];
  }
  return [];
}
function hasValidPrimaryDwelling(input, propertyType) {
  const { primaryDwelling } = input;
  if (primaryDwelling === void 0 || propertyType === "manufacturedHome") {
    return [];
  }
  if (propertyType === "multiFamily") {
    return requiresAll(input, "primaryDwelling", [
      "quality",
      "gla",
      "stories",
      "bathroomsFull",
      "bathroomsHalf",
      "multiUnitCount"
    ]);
  }
  return requiresAll(input, "primaryDwelling", [
    "quality",
    "gla",
    "stories",
    "bathroomsFull",
    "bathroomsHalf"
  ]);
}
function hasValidAttachedOrBuiltinGarage(input) {
  const { attachedOrBuiltinGarage } = input;
  if (attachedOrBuiltinGarage === void 0 || eitherUndefOrZeroBypass(attachedOrBuiltinGarage) || attachedOrBuiltinGarage.builtinSpaceCount?.value === 0 && attachedOrBuiltinGarage.attachedSpaceCount?.value === 0) {
    return [];
  }
  return requiresAll(input, "attachedOrBuiltinGarage", ["quality", "totalSqft"]);
}
function hasValidDetachedGarage(input) {
  const { detachedGarage } = input;
  if (detachedGarage === void 0 || eitherUndefOrZeroBypass(detachedGarage) || detachedGarage.spaceCount?.value === 0) {
    return [];
  }
  return requiresAll(input, "detachedGarage", ["quality", "totalSqft"]);
}
function hasValidCarport(input) {
  const { carport } = input;
  if (carport === void 0 || eitherUndefOrZeroBypass(carport) || carport.spaceCount?.value === 0) {
    return [];
  }
  return requiresAll(input, "carport", ["quality", "totalSqft"]);
}
function hasValidAttic(input) {
  const { attic } = input;
  if (attic === void 0 || eitherUndefOrZeroBypass(attic)) {
    return [];
  }
  return requiresAll(input, "attic", ["quality", "totalSqft"]);
}
function hasValidBasement(input) {
  const { basement } = input;
  if (basement === void 0 || eitherUndefOrZeroBypass(basement) || basement.totalSqft?.equals(AloftArea27.zero)) {
    return [];
  }
  return requiresAll(input, "basement", ["quality", "totalSqft", "finishedSqft"]);
}
function hasValidADU(input) {
  const { adu } = input;
  if (adu === void 0 || eitherUndefOrZeroBypass(adu)) {
    return [];
  }
  return requiresAll(input, "adu", ["quality", "gla", "stories", "bathroomsFull", "bathroomsHalf"]);
}
function hasValidShed(input) {
  const { shed } = input;
  if (shed === void 0 || eitherUndefOrZeroBypass(shed)) {
    return [];
  }
  const errors = [];
  if (shed.electrical && (0, import_shared_utils85.isUndefined)(shed.subpanel)) {
    errors.push({
      type: "missing",
      key: "shed",
      field: "subpanel"
    });
  }
  errors.push(
    ...requiresAll(input, "shed", [
      "quality",
      "totalSqft",
      "percentInteriorFinished",
      "electrical",
      "plumbingFixturesCount"
    ])
  );
  return errors;
}
function hasValidWorkshop(input) {
  const { workshop } = input;
  if (workshop === void 0 || eitherUndefOrZeroBypass(workshop)) {
    return [];
  }
  const errors = [];
  if (workshop.electrical && (0, import_shared_utils85.isUndefined)(workshop.subpanel)) {
    errors.push({
      type: "missing",
      key: "workshop",
      field: "subpanel"
    });
  }
  errors.push(
    ...requiresAll(input, "workshop", [
      "quality",
      "totalSqft",
      "percentInteriorFinished",
      "electrical",
      "plumbingFixturesCount"
    ])
  );
  return errors;
}
function hasValidBonusRoom(input) {
  const { bonusRoom } = input;
  if (bonusRoom === void 0 || eitherUndefOrZeroBypass(bonusRoom)) {
    return [];
  }
  const errors = [];
  if (bonusRoom.electrical && (0, import_shared_utils85.isUndefined)(bonusRoom.subpanel)) {
    errors.push({
      type: "missing",
      key: "bonusRoom",
      field: "subpanel"
    });
  }
  errors.push(
    ...requiresAll(input, "bonusRoom", [
      "quality",
      "totalSqft",
      "percentInteriorFinished",
      "electrical",
      "plumbingFixturesCount"
    ])
  );
  return errors;
}
function hasValidBarn(input) {
  const { barn } = input;
  if (barn === void 0 || eitherUndefOrZeroBypass(barn)) {
    return [];
  }
  const errors = [];
  if (barn.electrical && (0, import_shared_utils85.isUndefined)(barn.subpanel)) {
    errors.push({
      type: "missing",
      key: "barn",
      field: "subpanel"
    });
  }
  if (barn.isPoleBarn && (0, import_shared_utils85.isUndefined)(barn.hasExteriorWall)) {
    errors.push({
      type: "missing",
      key: "barn",
      field: "hasExteriorWall"
    });
  }
  errors.push(
    ...requiresAll(input, "barn", [
      "isPoleBarn",
      "electrical",
      "percentInteriorFinished",
      "plumbingFixturesCount",
      "quality",
      "totalSqft"
    ])
  );
  return errors;
}
function hasValidManufacturedDwelling(input) {
  const { manufactured } = input;
  if (manufactured === void 0 || eitherUndefOrZeroBypass(manufactured)) {
    return [];
  }
  const baseRequiredFields = [
    "bathroomsFull",
    "bathroomsHalf",
    "gla",
    "sections",
    "quality",
    "hasAC",
    "hasClimatePkg",
    "foundationType",
    "fireplaces",
    "deliveryMileage"
  ];
  if (manufactured.fireplaces?.gt(AloftCount13.zero)) {
    return requiresAll(input, "manufactured", [...baseRequiredFields, "fireplaceType"]);
  }
  return requiresAll(input, "manufactured", baseRequiredFields);
}
function hasValidDeck(input) {
  const { deck } = input;
  if (deck === void 0 || eitherUndefOrZeroBypass(deck)) {
    return [];
  }
  return requiresAll(input, "deck", ["quality", "totalSqft"]);
}
function hasValidCvdPatio(input) {
  const { coveredPatioOrGazebo } = input;
  if (coveredPatioOrGazebo === void 0 || eitherUndefOrZeroBypass(coveredPatioOrGazebo)) {
    return [];
  }
  return requiresAll(input, "coveredPatioOrGazebo", ["quality", "totalSqft"]);
}
function hasValidEnclosedPatio(input) {
  const { enclosedPatio } = input;
  if (enclosedPatio === void 0 || eitherUndefOrZeroBypass(enclosedPatio)) {
    return [];
  }
  return requiresAll(input, "enclosedPatio", ["quality", "totalSqft", "linearFootage"]);
}
function hasValidPool(input) {
  const { pool } = input;
  if (pool === void 0 || eitherUndefOrZeroBypass(pool)) {
    return [];
  }
  return requiresAll(input, "pool", ["totalSqft", "quality"]);
}
function requiresAll(input, inputKey, keys) {
  const value = input[inputKey];
  if (value === void 0 || !(0, import_shared_utils85.hasDefinedValues)(value)) {
    return [];
  }
  const errors = [];
  for (const key of keys) {
    const curr = value[key];
    if ((0, import_shared_utils85.isUndefined)(curr)) {
      errors.push({
        type: "missing",
        key: inputKey,
        field: key
      });
    } else if (key === "totalSqft" && AloftArea27.isAloftArea(curr) && curr.equals(AloftArea27.zero) || key === "gla" && AloftArea27.isAloftArea(curr) && curr.equals(AloftArea27.zero) || key === "stories" && curr === 0) {
      errors.push({
        type: "missing",
        key: inputKey,
        field: key
      });
    }
  }
  return errors;
}

// src/costData/index.ts
var ORDER_COST_DATA_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z107.object({ orderID: z107.string() })
    },
    RESPONSE: schOrderCostDataDocument
  }
};
var PROPERTY_COST_DATA_API = {
  GET: {
    REQUEST: {
      PATH_PARAMS: z107.object({ orderID: z107.string(), propertyAttachmentID: z107.string() })
    },
    RESPONSE: schPropertyCostDataResponse
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: z107.object({ orderID: z107.string(), propertyAttachmentID: z107.string() }),
      BODY: schPropertyCostDataDocument
    },
    RESPONSE: z107.object({})
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: z107.object({ orderID: z107.string(), propertyAttachmentID: z107.string() }),
      BODY: schCostDataInput
    },
    RESPONSE: schCostDataOutput
  }
};

// src/depreciatedCost/types.ts
import { z as z108 } from "zod";
var schSegmentType = z108.enum([
  ...schStructureType.exclude(["primaryDwelling"]).options,
  ...z108.enum(["mainDwelling", "belowGradeANSI", "manual"]).options
]);

// src/depreciatedCost/allocate/allocatePairedCostProperties.ts
var import_shared_utils86 = __toESM(require_lib(), 1);

// src/depreciatedCost/allocate/sumAddFeatureAdjustments.ts
import { AloftPrice as AloftPrice27 } from "@aloft/shared-objects";
function sumAddFeatureAdjustments(adjustments) {
  const summedAdjustment = AloftPrice27.add(
    adjustments.adu?.adjustment,
    adjustments.attic?.adjustment,
    adjustments.barn?.adjustment,
    adjustments.bonusRoom?.adjustment,
    adjustments.manual?.adjustment,
    adjustments.manufactured?.adjustment,
    adjustments.pool?.adjustment,
    adjustments.shed?.adjustment,
    adjustments.workshop?.adjustment,
    adjustments.belowGradeANSI?.adjustment
  );
  return summedAdjustment;
}

// src/depreciatedCost/allocate/allocateSFR.ts
function allocateSFR(tkProperty, comp) {
  const summedAdditionalFeatures = comp.adjustments && sumAddFeatureAdjustments(comp.adjustments);
  return {
    salesGridData: {
      ...tkProperty.getSalesCompGridData(),
      adjustments: {
        SalesConcessions: comp.adjustments?.termsOfSale?.adjustment,
        FinancingConcessions: comp.adjustments?.concessions?.adjustment,
        DateOfSale: comp.adjustments?.dateOfSale?.adjustment,
        SiteArea: comp.adjustments?.site?.adjustment,
        Quality: comp.adjustments?.quality?.adjustment,
        Condition: comp.adjustments?.condition?.adjustment,
        GrossLivingArea: comp.adjustments?.mainDwelling?.adjustment,
        RoomAboveGradeLine2: comp.adjustments?.bathAboveGrade?.adjustment,
        BasementArea: comp.adjustments?.basement?.adjustment,
        BasementFinish: comp.adjustments?.bathBelowGrade?.adjustment,
        FunctionalUtility: comp.adjustments?.functionalUtility?.adjustment,
        CarStorage: comp.adjustments?.garageCarport?.adjustment,
        PorchDeck: comp.adjustments?.porchPatioDeck?.adjustment,
        OtherFeature1: summedAdditionalFeatures
      }
    }
  };
}

// src/depreciatedCost/allocate/allocatePairedCostProperties.ts
function allocatePairedCostProperties({
  pairedCostResults,
  subject,
  comps,
  compSequence: compSequence2,
  propertyType
}) {
  const compAdjProperties = compSequence2.map(
    (compID) => [compID, (0, import_shared_utils86.expected)(pairedCostResults.comps[compID]), (0, import_shared_utils86.expected)(comps[compID])]
  ).map(([compID, comp, tkProperty]) => {
    switch (propertyType) {
      case "singleFamilyResidence":
        return [compID, allocateSFR(tkProperty, comp)];
      default:
        return [compID, allocateSFR(tkProperty, comp)];
    }
  });
  const subjSalesGridData = subject.getSalesCompGridData();
  const subjCostApproachTotals = pairedCostResults.subject?.totals?.costApproach;
  const subjImprovementTotals = pairedCostResults.subject?.totals?.improvements;
  const effectiveAge = pairedCostResults.subject?.features?.condition?.effectiveAge;
  const ecoLifeYears = pairedCostResults.subject?.features?.condition?.ecoLifeYears;
  const remainingEcoLife = effectiveAge && ecoLifeYears ? ecoLifeYears - effectiveAge : void 0;
  const sections = subject._getCostDataExtension()?.manufactured?.sections;
  return {
    subject: {
      costApproach: {
        ...subjCostApproachTotals,
        ...subjImprovementTotals,
        remainingEcoLife,
        sections
      },
      property: { salesGridData: subjSalesGridData }
    },
    comps: Object.fromEntries(compAdjProperties),
    compSequence: compSequence2
  };
}

// src/depreciatedCost/results/getPairedCostResults.ts
var import_shared_utils113 = __toESM(require_lib(), 1);

// src/depreciatedCost/results/internal/simplifiedv1/getSimplifiedAdjustmentSummaries.ts
var import_shared_utils87 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice29 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/simplifiedv1/roundAndThreshold.ts
import { AloftPrice as AloftPrice28 } from "@aloft/shared-objects";
var defaultRoundingDollars = 1e3;
var defaultThresholdDollars = 1e3;
function roundAndThreshold(price) {
  const rounded = AloftPrice28.fromDollarLike(
    Math.round(price.toDollarLike() / defaultRoundingDollars) * defaultRoundingDollars
  );
  const thresholded = Math.abs(rounded.toDollarLike()) < defaultThresholdDollars ? AloftPrice28.zero : rounded;
  return thresholded;
}

// src/depreciatedCost/results/internal/simplifiedv1/getSimplifiedAdjustmentSummaries.ts
function getSimplifiedAdjustmentSummaries(averageCosts, subject) {
  const result = {
    porchPatioDeck: getSummary(averageCosts.porchPatioDeck),
    site: `${(subject?.features.site?.siteValue?.costPerSqft ?? AloftPrice29.zero).toString()}/sqft`,
    basement: `${(averageCosts.basement?.averageCostPerSqft ?? AloftPrice29.zero).toString()}/sqft`,
    attic: getSummary(averageCosts.attic),
    pool: getSummary(averageCosts.pool),
    adu: getSummary(averageCosts.adu),
    shed: getSummary(averageCosts.shed),
    workshop: getSummary(averageCosts.workshop),
    bonusRoom: getSummary(averageCosts.bonusRoom),
    barn: getSummary(averageCosts.barn),
    manufactured: getSummary(averageCosts.manufactured),
    mainDwelling: `${(subject?.features.mainDwelling?.depreciatedCostPerSqFt ?? AloftPrice29.zero).toString()}/sqft`,
    belowGradeANSI: getSummary(averageCosts.belowGradeANSI),
    manual: void 0,
    termsOfSale: void 0,
    concessions: void 0,
    dateOfSale: void 0,
    locationView: void 0,
    quality: void 0,
    condition: void 0,
    bathAboveGrade: getBathroomSummary(subject),
    bathBelowGrade: getBathroomSummary(subject),
    fireplace: void 0,
    functionalUtility: void 0,
    externalObsolescence: void 0,
    garageCarport: `${getSummary(averageCosts.garageStall)}/stall`,
    foundation: void 0,
    units: void 0
  };
  return result;
}
function getSummary(result) {
  if ((0, import_shared_utils87.isUndefined)(result)) {
    return void 0;
  }
  const spread = result.maxCost.sub(result.minCost);
  if (spread?.gt(AloftPrice29.fromDollarLike(1e4))) {
    return `${result.minCost.toString(true)}\u2192${result.maxCost.toString(true)}`;
  }
  return `${result.averageCost.toString(true)}`;
}
function getBathroomSummary(subject) {
  const costs = subject?.features.bathAboveGrade?.costsDepreciated;
  return `${roundAndThreshold(costs?.fullBathCost ?? AloftPrice29.zero).toString(
    true
  )}/full, ${roundAndThreshold(costs?.halfBathCost ?? AloftPrice29.zero).toString(true)}/half`;
}

// src/depreciatedCost/results/internal/getAdjustmentSummaries.ts
function getAdjustmentSummaries(averageCosts, subject, version) {
  switch (version) {
    case "simplified_v1":
      return getSimplifiedAdjustmentSummaries(averageCosts, subject);
    default:
      return void 0;
  }
}

// src/depreciatedCost/results/internal/getPairedCostPropertyResultComp.ts
var import_shared_utils107 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice61 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/applyTkv2PairedCostSettings.ts
import { AloftPrice as AloftPrice31 } from "@aloft/shared-objects";

// src/tkv2PairedCost/consts.ts
import { AloftPrice as AloftPrice30 } from "@aloft/shared-objects";
var defaultTkv2PairedCostSettings = {
  rounding: {},
  roundingDefault: AloftPrice30.fromDollarLike(1e3),
  threshold: {},
  thresholdDefault: AloftPrice30.fromDollarLike(1e3)
};

// src/depreciatedCost/results/internal/applyTkv2PairedCostSettings.ts
function applyTkv2PairedCostSettings(settings, adjustments) {
  const res = { ...adjustments };
  for (const key of Object.values(schPairedCostAdjustmentType.enum)) {
    if (key === "externalObsolescence") {
      continue;
    }
    res[key] = applySettings(settings, key, res[key]);
  }
  return res;
}
function applySettings(settings, key, adj) {
  const rounding = settings.enableRounding ? (settings.rounding[key] ?? settings.roundingDefault).toDollarLike() : void 0;
  const threshold = settings.enableThreshold ? (settings.threshold[key] ?? settings.thresholdDefault).toDollarLike() : void 0;
  const adjustmentBasis = adj.adjustmentBasis ?? adj.adjustment;
  const basis = adjustmentBasis.toDollarLike();
  const rounded = rounding !== void 0 ? Math.round(basis / rounding) * rounding : basis;
  const thresholded = threshold !== void 0 && Math.abs(rounded) < threshold ? 0 : rounded;
  const adjustment = AloftPrice31.fromDollarLike(thresholded, adjustmentBasis.currency);
  return {
    ...adj,
    adjustment,
    adjustmentBasis,
    roundingUsed: AloftPrice31.fromDollarLike(rounding),
    thresholdUsed: AloftPrice31.fromDollarLike(threshold)
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getPairedCostAdjustmentsSimplified.ts
import { AloftPrice as AloftPrice45 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/adjustments/diffValues.ts
import { AloftPrice as AloftPrice33 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/utils/costToString.ts
import { AloftPrice as AloftPrice32 } from "@aloft/shared-objects";
function costToString(price, params = {
  wrapNegative: false
}) {
  const { wrapNegative } = params;
  const priceString = price.toString(true, false);
  const isNegative = price.lt(AloftPrice32.zero);
  return wrapNegative && isNegative ? `(${priceString})` : priceString;
}

// src/depreciatedCost/results/internal/adjustments/diffValues.ts
function diffValues(subjectValue, compValue) {
  const subjectDefinedValue = subjectValue?.roundToDollarLike() ?? AloftPrice33.zero;
  const compDefinedValue = compValue?.roundToDollarLike() ?? AloftPrice33.zero;
  const adjustment = subjectDefinedValue.sub(compDefinedValue).roundToDollarLike();
  const calculation = `${costToString(subjectDefinedValue)} - ${costToString(compDefinedValue, {
    wrapNegative: true
  })} = ${costToString(adjustment)}`;
  return {
    adjustment,
    calculations: [calculation]
  };
}

// src/depreciatedCost/results/internal/adjustments/getDefaultAdjustmentBreakdown.ts
function getDefaultAdjustmentBreakdown(subjectCost, compCost, description) {
  return {
    ...diffValues(subjectCost, compCost),
    description
  };
}

// src/depreciatedCost/results/internal/adjustments/getMarketAdjustmentBreakdown.ts
import { AloftPrice as AloftPrice34 } from "@aloft/shared-objects";
function getMarketAdjustmentBreakdown(marketAdjustments) {
  return {
    dateOfSale: getBreakdownFromAdjustment(marketAdjustments?.dateOfSale?.adjustmentAmount),
    concessions: getBreakdownFromAdjustment(marketAdjustments?.concessions?.adjustmentAmount),
    termsOfSale: getBreakdownFromAdjustment(marketAdjustments?.termsOfSale?.adjustmentAmount)
  };
}
function getBreakdownFromAdjustment(adjustment) {
  return {
    adjustment: adjustment ?? AloftPrice34.zero,
    calculations: [],
    description: void 0
  };
}

// src/depreciatedCost/results/internal/consts.ts
var SITE_DESCRIPTION = "Opinion of the Subject's Site Value - Extracted Site Value of Comparable as of the Effective Date = Site Adjustment";
var FUNCTIONAL_UTILITY_DESCRIPTION = "Subject's Functional Obsolescence - Comparable's Functional Obsolescence = Functional Utility Adjustment";

// src/depreciatedCost/results/internal/v2/adjustments/getBathCountAdjustmentBreakdown.ts
var import_shared_utils88 = __toESM(require_lib(), 1);
var import_pluralize = __toESM(require_pluralize(), 1);
import { AloftPrice as AloftPrice35 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/v2/consts.ts
var CONDITION_DESCRIPTION = "(Difference in physical depreciation * Dwelling Cost New) + Difference in external depreciation = Condition Adjustment";
var QUALITY_DESCRIPTION = "(Difference in cost per square foot, after adjusting for condition and baths) * Comparable\u2019s GLA = Quality Adjustment";
var MAIN_DWELLING_DESCRIPTION = "Difference in GLA * Depreciated cost per SF = GLA Adjustment";
var BASEMENT_DESCRIPTION = "The Subject's Basement Depreciated Cost - The Comparable's Basement Depreciated Cost = Basement Adjustment";
var ATTIC_DESCRIPTION = "Subject's Attic Depreciated Cost - Comparable's Attic Depreciated Cost = Attic Adjustment";
var POOL_DESCRIPTION = "Subject's Pool Depreciated Cost - Comparable's Pool Depreciated Cost = Pool Adjustment";
var ADU_DESCRIPTION = "Subject's Guest House Depreciated Cost - Comparable's Guest House Depreciated Cost = Guest House Adjustment";
var SHED_DESCRIPTION = "Subject's Shed Depreciated Cost - Comparable's Shed Depreciated Cost = Shed Adjustment";
var WORKSHOP_DESCRIPTION = "Subject's Workshop Depreciated Cost - Comparable's Workshop Depreciated Cost = Workshop Adjustment";
var BONUS_ROOM_DESCRIPTION = "Subject's Bonus Room Depreciated Cost - Comparable's Bonus Room Depreciated Cost = Bonus Room Adjustment";
var BARN_DESCRIPTION = "Subject's Barn Depreciated Cost - Comparable's Barn Depreciated Cost = Barn Adjustment";
var BELOW_GRADE_ANSI_DESCRIPTION = "Subject's Below Grade (per ANSI) Depreciated Cost - Comparable's Below Grade (per ANSI) Depreciated Cost = Below Grade (per ANSI) Adjustment";
var MANUFACTURED_DESCRIPTION = "Subject's Manufactured Dwelling Depreciated Cost - Comparable's Manufactured Dwelling Depreciated Cost = Manufactured Dwelling Adjustment";
var BATH_DESCRIPTION = "(Difference in full baths * Depreciated cost per full bath) + (Difference in half baths * Depreciated cost per half bath) = Bath Adjustment";

// src/depreciatedCost/results/internal/v2/adjustments/getBathCountAdjustmentBreakdown.ts
function getBathCountAdjustmentBreakdown({
  subject,
  comp,
  depreciatedBathroomCosts
}) {
  const subjectFullBathCost = depreciatedBathroomCosts?.fullBathCost?.mul(subject.fullBaths) ?? AloftPrice35.zero;
  const subjectHalfBathCost = depreciatedBathroomCosts?.halfBathCost?.mul(subject.halfBaths) ?? AloftPrice35.zero;
  const compFullBathCost = depreciatedBathroomCosts?.fullBathCost?.mul(comp.fullBaths) ?? AloftPrice35.zero;
  const compHalfBathCost = depreciatedBathroomCosts?.halfBathCost?.mul(comp.halfBaths) ?? AloftPrice35.zero;
  const fullBathDiff = subject.fullBaths - comp.fullBaths;
  const fullBathAdj = subjectFullBathCost.sub(compFullBathCost);
  const halfBathDiff = subject.halfBaths - comp.halfBaths;
  const halfBathAdj = subjectHalfBathCost.sub(compHalfBathCost);
  const adjustment = fullBathAdj.add(halfBathAdj);
  const fullBathCalc = !fullBathAdj.equals(AloftPrice35.zero) ? `${fullBathDiff} full ${(0, import_pluralize.default)("bath", fullBathDiff)} * ${(depreciatedBathroomCosts?.fullBathCost ?? AloftPrice35.zero).toString(true)} = ${fullBathAdj.toString(true)}` : void 0;
  const halfBathCalc = !halfBathAdj.equals(AloftPrice35.zero) ? `${halfBathDiff} half ${(0, import_pluralize.default)("bath", halfBathDiff)} * ${(depreciatedBathroomCosts?.halfBathCost ?? AloftPrice35.zero).toString(true)} = ${halfBathAdj.toString(true)}` : void 0;
  return {
    adjustment,
    description: BATH_DESCRIPTION,
    calculations: [fullBathCalc, halfBathCalc].filter(import_shared_utils88.isDefined)
  };
}

// src/depreciatedCost/results/internal/v2/adjustments/getConditionAdjustmentBreakdown.ts
import { AloftPrice as AloftPrice36 } from "@aloft/shared-objects";

// src/toPercentString.ts
var import_shared_utils89 = __toESM(require_lib(), 1);
function toPercentString(num, decimals) {
  if ((0, import_shared_utils89.isDefined)(decimals)) {
    return `${(num * 100).toFixed(decimals)}%`;
  }
  return `${Math.round(num * 100)}%`;
}

// src/depreciatedCost/results/internal/v2/adjustments/getConditionAdjustmentBreakdown.ts
function getConditionAdjustmentBreakdown({
  subject,
  comp
}) {
  const subjectDepreciationRatio = subject.physicalDepreciation?.depreciationRatio ?? 0;
  const compDepreciationRatio = comp.physicalDepreciation?.depreciationRatio ?? 0;
  const depreciationRatioDiff = +(compDepreciationRatio - subjectDepreciationRatio).toFixed(2);
  const physicalDepreciationAdjustment = comp.costNew?.mul(depreciationRatioDiff) ?? AloftPrice36.zero;
  const externalDepreciationAdjustment = subject.externalDepreciation?.sub(comp.externalDepreciation).roundToDollarLike() ?? AloftPrice36.zero;
  const adjustment = physicalDepreciationAdjustment.add(externalDepreciationAdjustment).roundToDollarLike();
  return {
    adjustment,
    params: {
      depreciationDiffPercent: depreciationRatioDiff,
      physicalDepreciationAdjustment,
      externalDepreciationAdjustment
    },
    description: CONDITION_DESCRIPTION,
    calculations: [
      `(${toPercentString(compDepreciationRatio)} - ${toPercentString(
        subjectDepreciationRatio
      )}) * ${(comp?.costNew ?? AloftPrice36.zero).toString(
        true
      )} = ${physicalDepreciationAdjustment.toString(true)}`,
      `${(subject.externalDepreciation ?? AloftPrice36.zero).toString(true)} - ${(comp.externalDepreciation ?? AloftPrice36.zero).toString(true)} = ${externalDepreciationAdjustment.toString(true)}`
    ]
  };
}

// src/depreciatedCost/results/internal/v2/adjustments/getGlaAdjustmentBreakdown.ts
import { AloftArea as AloftArea28, AloftPrice as AloftPrice37 } from "@aloft/shared-objects";
function getGlaAdjustmentBreakdown({
  subject,
  comp
}) {
  const sqftDiff = subject?.sqft?.sub(comp?.sqft ?? AloftArea28.zero) ?? AloftArea28.zero;
  const adjustment = subject?.costPerSqft?.mul(sqftDiff.toSqFt().getUnitAmount()).roundToDollarLike() ?? AloftPrice37.zero;
  return {
    adjustment,
    description: MAIN_DWELLING_DESCRIPTION,
    calculations: [
      `(${(subject?.sqft ?? AloftArea28.zero).toString()} - ${(comp?.sqft ?? AloftArea28.zero).toString()}) * ${(subject?.costPerSqft ?? AloftPrice37.zero).toString(
        true
      )} = ${adjustment.toString(true)}`
    ]
  };
}

// src/depreciatedCost/results/internal/v2/adjustments/getManualAdjustmentBreakdown.ts
function getManualAdjustmentBreakdown(subject, comp, manualCostLabel) {
  return {
    ...getDefaultAdjustmentBreakdown(
      subject,
      comp,
      `Subject's ${manualCostLabel} Depreciated Cost - Comparable's ${manualCostLabel} Depreciated Cost = ${manualCostLabel} Adjustment`
    )
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getBasementAdjustmentBreakdown.ts
var import_shared_utils90 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea29, AloftPrice as AloftPrice38 } from "@aloft/shared-objects";
function getBasementAdjustmentBreakdown({
  subject,
  comp,
  basementResult
}) {
  const subjectSqft = subject?.basement?.depreciatedCost.sqft ?? AloftArea29.zero;
  const compSqft = comp.basement?.depreciatedCost.sqft ?? AloftArea29.zero;
  const costPerSqft = basementResult?.averageCostPerSqft;
  if ((0, import_shared_utils90.isUndefined)(costPerSqft)) {
    return {
      adjustment: AloftPrice38.zero
    };
  }
  const subjectCost = costPerSqft.mul(subjectSqft.getUnitAmount("sqft"));
  const compCost = costPerSqft.mul(compSqft.getUnitAmount("sqft"));
  const adjustment = subjectCost.sub(compCost);
  return {
    adjustment,
    calculations: [
      `${subjectCost.toString(true)} - ${compCost.toString(true)} = ${adjustment.toString(true)}`
    ],
    description: "Basement adjustment calculated using the average cost/sqft of all the properties' basements"
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getGarageCarportAdjustmentBreakdown.ts
import { AloftPrice as AloftPrice39 } from "@aloft/shared-objects";
function getGarageCarportAdjustmentBreakdown({
  subjectStalls,
  compStalls,
  garageStallCostResult
}) {
  const averageStallCost = garageStallCostResult?.averageCost;
  const subjectVal = averageStallCost?.mul(subjectStalls);
  const compVal = averageStallCost?.mul(compStalls);
  const adjustment = subjectVal?.sub(compVal) ?? AloftPrice39.zero;
  return {
    adjustment,
    calculations: [
      `Max stall cost: ${garageStallCostResult?.maxCost.toString(true)}`,
      `Min stall cost: ${garageStallCostResult?.minCost.toString(true)}`,
      `Average stall cost: ${garageStallCostResult?.averageCost.toString(true)}`
    ],
    description: "Difference in garage stalls * Average stall costs"
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getLocationViewAdjustmentBreakdown.ts
import { AloftPrice as AloftPrice40 } from "@aloft/shared-objects";
function getLocationViewAdjustmentBreakdown({
  subjectSiteCost,
  siteAdjustment,
  compExtractedSiteCost
}) {
  const compAdjustedSiteCost = compExtractedSiteCost?.add(siteAdjustment);
  const adjustment = subjectSiteCost?.sub(compAdjustedSiteCost) ?? AloftPrice40.zero;
  return {
    adjustment,
    calculations: [
      `${(subjectSiteCost ?? AloftPrice40.zero).toString(true)} - ${(compAdjustedSiteCost ?? AloftPrice40.zero).toString(true)} = ${adjustment.toString(true)}`
    ],
    description: "Remaining site value after adjusting for site size."
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getPorchPatioDeckAdjustmentBreakdown.ts
import { AloftPrice as AloftPrice41 } from "@aloft/shared-objects";
function getPorchPatioDeckAdjustmentBreakdown({
  subject,
  comp,
  porchPatioDeckCostResult
}) {
  const averagePorchPatioDeckCost = porchPatioDeckCostResult?.averageCost;
  const subjectHasPorchPatioDeck = AloftPrice41.add(
    subject?.deck?.depreciatedCost.totalCost,
    subject?.enclosedPatio?.depreciatedCost.totalCost,
    subject?.coveredPatioOrGazebo?.depreciatedCost.totalCost
  ).gt(AloftPrice41.zero);
  const compHasPorchPatioDeck = AloftPrice41.add(
    comp.deck?.depreciatedCost.totalCost,
    comp.enclosedPatio?.depreciatedCost.totalCost,
    comp.coveredPatioOrGazebo?.depreciatedCost.totalCost
  ).gt(AloftPrice41.zero);
  let adjustment;
  if (subjectHasPorchPatioDeck === compHasPorchPatioDeck) {
    adjustment = AloftPrice41.zero;
  } else if (subjectHasPorchPatioDeck) {
    adjustment = averagePorchPatioDeckCost ?? AloftPrice41.zero;
  } else {
    adjustment = averagePorchPatioDeckCost?.mul(-1) ?? AloftPrice41.zero;
  }
  return {
    adjustment,
    calculations: [
      `Max porch/patio/deck cost: ${porchPatioDeckCostResult?.maxCost.toString(true)}`,
      `Min porch/patio/deck cost: ${porchPatioDeckCostResult?.minCost.toString(true)}`,
      `Average porch/patio/deck cost: ${porchPatioDeckCostResult?.averageCost.toString(true)}`
    ],
    description: "Using average cost of porch/patio/deck combo across subject and comps"
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getQualityAdjustmentBreakdown.ts
import { AloftArea as AloftArea30, AloftPrice as AloftPrice42 } from "@aloft/shared-objects";
function getQualityAdjustmentBreakdown({
  subject,
  comp
}) {
  if (subject.dcQuality === comp.dcQuality) {
    return {
      adjustment: AloftPrice42.zero
    };
  }
  const compSqftNum = comp.gla?.getUnitAmount("sqft") ?? 0;
  const compAdjCost = comp.depreciatedCost?.add(comp.physicalDepreciationAdjustment).add(comp.bathAboveGradeAdjustment).add(comp.bathBelowGradeAdjustment).add(comp.glaAdjustment) ?? AloftPrice42.zero;
  const adjustment = subject.depreciatedCost?.sub(compAdjCost) ?? AloftPrice42.zero;
  const costPerSqftDiff = compSqftNum > 0 ? adjustment.div(compSqftNum) ?? AloftPrice42.zero : AloftPrice42.zero;
  const adjustedCostPerSqft = compSqftNum > 0 ? compAdjCost.div(compSqftNum) ?? AloftPrice42.zero : AloftPrice42.zero;
  return {
    adjustment,
    params: {
      costPerSqftDiff,
      adjustedCostPerSqft
    },
    description: QUALITY_DESCRIPTION,
    calculations: [
      `${costPerSqftDiff.toString()} * ${(comp?.gla ?? AloftArea30.zero).toString()} = ${adjustment.toString(true)}`
    ]
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getSiteAdjustmentBreakdown.ts
import { AloftPrice as AloftPrice43 } from "@aloft/shared-objects";
function getSiteAdjustmentBreakdown({
  subjectCostPerSqft,
  subjectSiteCost,
  compSiteSize,
  compExtractedSiteCost
}) {
  const compSiteCost = subjectCostPerSqft.mul(compSiteSize?.getUnitAmount("sqft"));
  const adjustment = subjectSiteCost?.sub(compSiteCost) ?? AloftPrice43.zero;
  const compSiteDiff = compExtractedSiteCost?.sub(compSiteCost) ?? AloftPrice43.zero;
  return {
    adjustment,
    calculations: [
      `${(subjectSiteCost ?? AloftPrice43.zero).toString(
        true
      )} - (${subjectCostPerSqft.toString()} * ${compSiteSize?.toSqFtValueStringRounded() ?? 0}sf) = ${adjustment.toString(true)}`,
      `Extracted Site Cost: ${compExtractedSiteCost?.toString(true)}`,
      `Site cost using cost/sqft of subject: ${compSiteCost?.toString(true)}`,
      `Difference in cost: ${compSiteDiff.toString(true)}`
    ],
    description: "Site size adjustment using cost/sqft of the subject's site"
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getStructureAdjustmentBreakdown.ts
import { AloftPrice as AloftPrice44 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/adjustments/getStructureAdjustmentBreakdown.ts
function getStructureAdjustmentResult(subjectStructureTotalCost, compStructureTotalCost, description) {
  return {
    ...getDefaultAdjustmentBreakdown(
      subjectStructureTotalCost,
      compStructureTotalCost,
      description
    )
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getStructureAdjustmentBreakdown.ts
function getStructureAdjustmentBreakdown({
  subject,
  comp,
  averageCosts,
  type
}) {
  const result = averageCosts[type];
  const averageCost = result?.averageCost;
  const spread = result?.maxCost.sub(result.minCost);
  if (spread?.gt(AloftPrice44.fromDollarLike(1e4))) {
    return getStructureAdjustmentResult(
      subject?.[type]?.depreciatedCost.totalCost,
      comp[type]?.depreciatedCost.totalCost,
      "Cost spread exceeds $10,000. Using difference in depreciated cost"
    );
  }
  const subjectHasStructure = subject?.[type]?.depreciatedCost.totalCost?.gt(AloftPrice44.zero);
  const compHasStructure = comp[type]?.depreciatedCost.totalCost?.gt(AloftPrice44.zero);
  let adjustment;
  if (subjectHasStructure === compHasStructure) {
    adjustment = AloftPrice44.zero;
  } else if (subjectHasStructure) {
    adjustment = averageCost ?? AloftPrice44.zero;
  } else {
    adjustment = averageCost?.mul(-1) ?? AloftPrice44.zero;
  }
  return {
    adjustment,
    calculations: [
      `Max ${type} cost: ${result?.maxCost.toString(true)}`,
      `Min ${type} cost: ${result?.minCost.toString(true)}`,
      `Average ${type} cost: ${result?.averageCost.toString(true)}`
    ],
    description: `Using average cost of ${type} across subject and comps`
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/adjustments/getPairedCostAdjustmentsSimplified.ts
var getPairedCostAdjustmentsSimplified = ({
  subject,
  comp,
  manualCostLabel,
  averageCosts
}) => {
  const {
    segmentCosts: subjectSegmentCosts,
    depreciationCosts: subjectDepreciationCosts,
    bathCounts: subjectBathCounts
  } = subject;
  const subjectSegmentDepreciation = subject.depreciationCosts?.physical.segments;
  const {
    segmentCosts: compSegmentCosts,
    depreciationCosts: compDepreciationCosts,
    marketConditions: marketConditions2,
    bathCounts: compBathCounts
  } = comp;
  const compSegmentDepreciation = comp.depreciationCosts?.physical.segments;
  const gla = getGlaAdjustmentBreakdown({
    subject: subjectSegmentDepreciation?.mainDwelling?.depreciatedCost,
    comp: compSegmentDepreciation?.mainDwelling?.depreciatedCost
  });
  const bathAboveGrade = getBathCountAdjustmentBreakdown({
    subject: subjectBathCounts.aboveGrade,
    comp: compBathCounts.aboveGrade,
    depreciatedBathroomCosts: subject.depreciatedBathroomCosts
  });
  const bathBelowGrade = getBathCountAdjustmentBreakdown({
    subject: subjectBathCounts.belowGrade,
    comp: compBathCounts.belowGrade,
    depreciatedBathroomCosts: subject.depreciatedBathroomCosts
  });
  const condition = getConditionAdjustmentBreakdown({
    subject: {
      physicalDepreciation: subjectSegmentDepreciation?.mainDwelling,
      externalDepreciation: subjectDepreciationCosts?.external,
      costNew: subjectSegmentCosts.mainDwelling?.totalCost
    },
    comp: {
      physicalDepreciation: compSegmentDepreciation?.mainDwelling,
      externalDepreciation: compDepreciationCosts?.external,
      costNew: compSegmentCosts.mainDwelling?.totalCost
    }
  });
  const quality = getQualityAdjustmentBreakdown({
    subject: {
      depreciatedCost: subjectSegmentDepreciation?.mainDwelling?.depreciatedCost.totalCost,
      dcQuality: subjectSegmentCosts.mainDwelling?.dwellingCostQuality
    },
    comp: {
      gla: compSegmentDepreciation?.mainDwelling?.depreciatedCost.sqft,
      depreciatedCost: compSegmentDepreciation?.mainDwelling?.depreciatedCost.totalCost,
      physicalDepreciationAdjustment: condition.params?.physicalDepreciationAdjustment,
      bathAboveGradeAdjustment: bathAboveGrade.adjustment,
      bathBelowGradeAdjustment: bathBelowGrade.adjustment,
      glaAdjustment: gla.adjustment,
      dcQuality: compSegmentCosts.mainDwelling?.dwellingCostQuality
    }
  });
  const basement = getBasementAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    basementResult: averageCosts.basement
  });
  const attic = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "attic"
  });
  const functionalUtility = getDefaultAdjustmentBreakdown(
    subjectDepreciationCosts?.functional,
    compDepreciationCosts.functional,
    FUNCTIONAL_UTILITY_DESCRIPTION
  );
  const garageCarport = getGarageCarportAdjustmentBreakdown({
    subjectStalls: subject.garageStallCount,
    compStalls: comp.garageStallCount,
    garageStallCostResult: averageCosts.garageStall
  });
  const porchPatioDeck = getPorchPatioDeckAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    porchPatioDeckCostResult: averageCosts.porchPatioDeck
  });
  const { dateOfSale: dateOfSale2, concessions, termsOfSale } = getMarketAdjustmentBreakdown(marketConditions2);
  const manual = getManualAdjustmentBreakdown(
    subjectSegmentCosts.manual?.totalCost,
    compSegmentCosts.manual?.totalCost,
    manualCostLabel
  );
  const pool = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "pool"
  });
  const adu = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "adu"
  });
  const shed = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "shed"
  });
  const workshop = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "workshop"
  });
  const bonusRoom = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "bonusRoom"
  });
  const barn = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "barn"
  });
  const belowGradeANSI = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "belowGradeANSI"
  });
  const manufactured = getStructureAdjustmentBreakdown({
    subject: subjectSegmentDepreciation,
    comp: compSegmentDepreciation,
    averageCosts,
    type: "manufactured"
  });
  const site = getSiteAdjustmentBreakdown({
    subjectCostPerSqft: subject.siteCostPerSqft,
    subjectSiteCost: subject.siteCost,
    compSiteSize: comp.siteSize,
    compExtractedSiteCost: comp.siteTotals.marketAdjusted.siteValue.totalCost
  });
  const locationView = getLocationViewAdjustmentBreakdown({
    subjectSiteCost: subject.siteCost,
    compExtractedSiteCost: comp.siteTotals.marketAdjusted.siteValue.totalCost,
    siteAdjustment: site.adjustment
  });
  const adjustments = {
    dateOfSale: dateOfSale2,
    concessions,
    termsOfSale,
    functionalUtility,
    externalObsolescence: {
      adjustment: AloftPrice45.zero
    },
    mainDwelling: gla,
    bathAboveGrade,
    bathBelowGrade,
    quality,
    condition,
    garageCarport,
    basement,
    manual,
    adu,
    attic,
    fireplace: { adjustment: AloftPrice45.zero },
    barn,
    bonusRoom,
    porchPatioDeck,
    pool,
    shed,
    workshop,
    manufactured,
    belowGradeANSI,
    site,
    locationView,
    foundation: { adjustment: AloftPrice45.zero },
    units: { adjustment: AloftPrice45.zero }
  };
  return Object.fromEntries(
    Object.entries(adjustments).map(([key, adj]) => [
      key,
      { ...adj, adjustment: roundAndThreshold(adj.adjustment) }
    ])
  );
};

// src/depreciatedCost/results/internal/v1/adjustments/getPairedCostAdjustmentsV1.ts
import { AloftPrice as AloftPrice51 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/adjustments/getGarageCarportAdjustmentBreakdown.ts
var import_shared_utils91 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice46 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/v1/consts.ts
var CONDITION_DESCRIPTION2 = "The Subject's Physical Depreciation or External Obsolescence - The Comparable's Physical Depreciation or External Obsolescence = Condition Adjustment";
var QUALITY_DESCRIPTION2 = "(Subject's Price per SF - Comparable Price per SF) x The SF of the Property with the Superior Quality = Quality Adjustment";
var MAIN_DWELLING_DESCRIPTION2 = "Subject's Main Dwelling Cost - (Comparable's Main Dwelling Cost + Quality Adjustment) = Main Dwelling Adjustment";
var BASEMENT_DESCRIPTION2 = "The Subject's Basement Cost - The Comparable's Basement Cost = Basement Adjustment";
var GARAGE_CARPORT_DESCRIPTION = "Subject's Garage or Carport Cost - Comparable's Garage or Carport Cost = Garage/Carport Adjustment";
var PORCH_PATIO_DECK_DESCRIPTION = "Subject's Porch, Patio or Deck Cost - Comparable's Porch, Patio or Deck Cost = Porch/Patio/Deck Adjustment";
var ATTIC_DESCRIPTION2 = "Subject's Attic Cost - Comparable's Attic Cost = Attic Adjustment";
var POOL_DESCRIPTION2 = "Subject's Pool Cost - Comparable's Pool Cost = Pool Adjustment";
var ADU_DESCRIPTION2 = "Subject's Guest House Cost - Comparable's Guest House Cost = Guest House Adjustment";
var SHED_DESCRIPTION2 = "Subject's Shed Cost - Comparable's Shed Cost = Shed Adjustment";
var WORKSHOP_DESCRIPTION2 = "Subject's Workshop Cost - Comparable's Workshop Cost = Workshop Adjustment";
var BONUS_ROOM_DESCRIPTION2 = "Subject's Bonus Room Cost - Comparable's Bonus Room Cost = Bonus Room Adjustment";
var BARN_DESCRIPTION2 = "Subject's Barn Cost - Comparable's Barn Cost = Barn Adjustment";
var BELOW_GRADE_ANSI_DESCRIPTION2 = "Subject's Below Grade (per ANSI) Cost - Comparable's Below Grade (per ANSI) Cost = Below Grade (per ANSI) Adjustment";
var MANUFACTURED_DESCRIPTION2 = "Subject's Manufactured Dwelling Cost - Comparable's Manufactured Dwelling Cost = Manufactured Dwelling Adjustment";

// src/depreciatedCost/results/internal/adjustments/getGarageCarportAdjustmentBreakdown.ts
function getGarageCarportAdjustmentBreakdown2({
  subject,
  comp
}) {
  const subjectGarageValue = AloftPrice46.addWithNulls(
    subject.attachedOrBuiltinGarage?.totalCost,
    subject.detachedGarage?.totalCost
  ) ?? AloftPrice46.zero;
  const subjectCarportValue = subject.carport?.totalCost ?? AloftPrice46.zero;
  const subjectTotalValue = AloftPrice46.add(
    ...[
      subject.attachedOrBuiltinGarage?.totalCost,
      subject.detachedGarage?.totalCost,
      subject.carport?.totalCost
    ].filter(import_shared_utils91.isDefined)
  );
  const compGarageValue = AloftPrice46.addWithNulls(
    comp.attachedOrBuiltinGarage?.totalCost,
    comp.detachedGarage?.totalCost
  ) ?? AloftPrice46.zero;
  const compCarportValue = comp.carport?.totalCost ?? AloftPrice46.zero;
  const compTotalValue = AloftPrice46.add(
    ...[
      comp.attachedOrBuiltinGarage?.totalCost,
      comp.detachedGarage?.totalCost,
      comp.carport?.totalCost
    ].filter(import_shared_utils91.isDefined)
  );
  const hasGarageCosts = subjectGarageValue.add(compGarageValue).gt(AloftPrice46.zero);
  const hasCarportCosts = subjectCarportValue.add(compCarportValue).gt(AloftPrice46.zero);
  return {
    adjustment: subjectTotalValue.sub(compTotalValue).roundToDollarLike(),
    calculations: [
      hasGarageCosts ? `Garage: ${costToString(subjectGarageValue)} - ${costToString(
        compGarageValue
      )} = ${costToString(subjectGarageValue.sub(compGarageValue))}` : void 0,
      hasCarportCosts ? `Carport: ${costToString(subjectCarportValue)} - ${costToString(
        compCarportValue
      )} = ${costToString(subjectCarportValue.sub(compCarportValue))}` : void 0
    ].filter(import_shared_utils91.isDefined),
    description: GARAGE_CARPORT_DESCRIPTION
  };
}

// src/depreciatedCost/results/internal/adjustments/getPorchPatioDeckAdjustmentBreakdown.ts
var import_shared_utils92 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice47 } from "@aloft/shared-objects";
function getPorchPatioDeckAdjustmentBreakdown2({
  subject,
  comp
}) {
  const subjectTotal = AloftPrice47.add(
    ...[
      subject.deck?.totalCost,
      subject.coveredPatioOrGazebo?.totalCost,
      subject.enclosedPatio?.totalCost
    ].filter(import_shared_utils92.isDefined)
  );
  const compTotal = AloftPrice47.add(
    ...[
      comp.deck?.totalCost,
      comp.coveredPatioOrGazebo?.totalCost,
      comp.enclosedPatio?.totalCost
    ].filter(import_shared_utils92.isDefined)
  );
  return {
    adjustment: subjectTotal.sub(compTotal).roundToDollarLike(),
    calculations: [
      getStructureCalculation("deck", subject, comp),
      getStructureCalculation("coveredPatioOrGazebo", subject, comp),
      getStructureCalculation("enclosedPatio", subject, comp)
    ].filter(import_shared_utils92.isDefined),
    description: PORCH_PATIO_DECK_DESCRIPTION
  };
}
var titles = {
  deck: "Deck",
  coveredPatioOrGazebo: "Cvd Patio / Gazebo",
  enclosedPatio: "Enclosed Patio"
};
function getStructureCalculation(structure, subjectStructures, compStructures) {
  const title = titles[structure];
  return [subjectStructures[structure], compStructures[structure]].some(import_shared_utils92.isDefined) ? `${title}: ${structureToCostString(
    subjectStructures[structure]
  )} - ${structureToCostString(compStructures[structure])} = ${costToString(
    (subjectStructures[structure]?.totalCost ?? AloftPrice47.zero).sub(
      compStructures[structure]?.totalCost
    ) ?? AloftPrice47.zero
  )}` : void 0;
}
function structureToCostString(costPerSqft) {
  return costToString(costPerSqft?.totalCost ?? AloftPrice47.zero);
}

// src/depreciatedCost/results/internal/v1/adjustments/getConditionAdjustmentBreakdown.ts
var import_shared_utils93 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice48 } from "@aloft/shared-objects";
function getConditionAdjustmentBreakdown2({
  subjectDepreciation,
  compDepreciation
}) {
  const physicalObsValue = diffValues(
    subjectDepreciation.physicalObs,
    compDepreciation.physicalObs
  );
  const externalObsValue = diffValues(
    subjectDepreciation.externalObs,
    compDepreciation.externalObs
  );
  const physicalObsEq = [subjectDepreciation.physicalObs, compDepreciation.physicalObs].some(
    (obs) => (0, import_shared_utils93.isDefined)(obs) && !obs.equals(AloftPrice48.zero)
  ) ? `Physical Depreciation: ${(0, import_shared_utils93.expected)(physicalObsValue.calculations[0])}` : void 0;
  const externalObsEq = [subjectDepreciation.externalObs, compDepreciation.externalObs].some(
    (obs) => (0, import_shared_utils93.isDefined)(obs) && !obs.equals(AloftPrice48.zero)
  ) ? `External Obsolescence: ${(0, import_shared_utils93.expected)(externalObsValue.calculations[0])}` : void 0;
  return {
    adjustment: AloftPrice48.addWithNulls(physicalObsValue.adjustment, externalObsValue.adjustment) ?? AloftPrice48.zero,
    calculations: [physicalObsEq, externalObsEq].filter(import_shared_utils93.isDefined),
    description: CONDITION_DESCRIPTION2,
    params: {
      depreciationDiffPercent: void 0,
      physicalDepreciationAdjustment: void 0,
      externalDepreciationAdjustment: void 0
    }
  };
}

// src/depreciatedCost/results/internal/v1/adjustments/getMainDwellingAdjustmentBreakdown.ts
import { AloftPrice as AloftPrice49 } from "@aloft/shared-objects";
function getMainDwellingAdjustmentBreakdown({
  subjectDwelling,
  compDwelling,
  qualityAdjustment
}) {
  const { adjustment } = diffValues(
    subjectDwelling?.totalCost,
    AloftPrice49.addWithNulls(compDwelling?.totalCost, qualityAdjustment) ?? void 0
  );
  return {
    adjustment,
    description: MAIN_DWELLING_DESCRIPTION2,
    calculations: [
      `${(subjectDwelling?.totalCost ?? AloftPrice49.zero).toString(true)} - (${(compDwelling?.totalCost ?? AloftPrice49.zero).toString(true)} + ${(qualityAdjustment ?? AloftPrice49.zero).toString(
        true
      )}) = ${adjustment.toString(true)}`
    ]
  };
}

// src/depreciatedCost/results/internal/v1/adjustments/getManualAdjustmentBreakdown.ts
function getManualAdjustmentBreakdown2(subject, comp, manualCostLabel) {
  return {
    ...getDefaultAdjustmentBreakdown(
      subject,
      comp,
      `Subject's ${manualCostLabel} - Comparable's ${manualCostLabel} = ${manualCostLabel} Adjustment"`
    )
  };
}

// src/depreciatedCost/results/internal/v1/adjustments/getQualityAdjustmentBreakdown.ts
var import_shared_utils94 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea32, AloftPrice as AloftPrice50 } from "@aloft/shared-objects";

// src/dwellingCost/compareDwellingCostQuality.ts
var compareDwellingCostQuality = (a, b) => {
  return parseFloat(a) - parseFloat(b);
};

// src/depreciatedCost/results/internal/v1/adjustments/getQualityAdjustmentBreakdown.ts
function getQualityAdjustmentBreakdown2({
  subjectDwelling,
  compDwelling
}) {
  const subjectQuality = subjectDwelling.quality;
  const compQuality = compDwelling.quality;
  const noop2 = {
    ...diffValues(AloftPrice50.zero, AloftPrice50.zero),
    description: QUALITY_DESCRIPTION2
  };
  if ((0, import_shared_utils94.isUndefined)(compQuality) || (0, import_shared_utils94.isUndefined)(subjectQuality)) {
    return noop2;
  }
  const subjectToCompQualComparison = compareDwellingCostQuality(subjectQuality, compQuality);
  if (subjectToCompQualComparison === 0) {
    return noop2;
  }
  const higherQualDwellingSqft = subjectToCompQualComparison > 0 ? subjectDwelling.costPerSqftResult?.sqft : compDwelling.costPerSqftResult?.sqft;
  const pricePerSqftDiff = subjectDwelling.costPerSqftResult?.costPerSqft?.sub(
    compDwelling.costPerSqftResult?.costPerSqft
  );
  const price = pricePerSqftDiff?.mul(
    (higherQualDwellingSqft ?? AloftArea32.zero)?.toSqFt()?.unitAmount
  );
  const adjustment = price?.roundToDollarLike();
  const calculation = `(${subjectDwelling.costPerSqftResult?.costPerSqft ?? AloftPrice50.zero} - ${compDwelling.costPerSqftResult?.costPerSqft ?? AloftPrice50.zero}) * ${(higherQualDwellingSqft ?? AloftArea32.zero).toString()} = ${costToString(
    adjustment ?? AloftPrice50.zero
  )}`;
  return adjustment ? {
    adjustment,
    description: QUALITY_DESCRIPTION2,
    calculations: [calculation],
    params: {
      costPerSqftDiff: void 0,
      adjustedCostPerSqft: void 0
    }
  } : noop2;
}

// src/depreciatedCost/results/internal/v1/adjustments/getPairedCostAdjustmentsV1.ts
var getPairedCostAdjustmentsV1 = ({
  comp,
  subject,
  manualCostLabel
}) => {
  const { segmentCosts: subjectSegmentCosts, depreciationCosts: subjectDepreciationCosts } = subject;
  const {
    segmentCosts: compSegmentCosts,
    depreciationCosts: compDepreciationCosts,
    marketConditions: marketConditions2,
    siteTotals
  } = comp;
  const site = getDefaultAdjustmentBreakdown(
    subject.siteCost,
    siteTotals.marketAdjusted?.siteValue.totalCost,
    SITE_DESCRIPTION
  );
  const quality = getQualityAdjustmentBreakdown2({
    subjectDwelling: {
      quality: subject.mainDwellingQuality,
      costPerSqftResult: subjectSegmentCosts.mainDwelling
    },
    compDwelling: {
      quality: comp.mainDwellingQuality,
      costPerSqftResult: compSegmentCosts.mainDwelling
    }
  });
  const condition = getConditionAdjustmentBreakdown2({
    subjectDepreciation: {
      physicalObs: subjectDepreciationCosts?.physical?.total,
      externalObs: subjectDepreciationCosts?.external
    },
    compDepreciation: {
      physicalObs: compDepreciationCosts?.physical.total,
      externalObs: compDepreciationCosts.external
    }
  });
  const mainDwelling = getMainDwellingAdjustmentBreakdown({
    subjectDwelling: subjectSegmentCosts.mainDwelling,
    compDwelling: compSegmentCosts.mainDwelling,
    qualityAdjustment: quality.adjustment
  });
  const basement = getStructureAdjustmentResult(
    subjectSegmentCosts.basement?.totalCost,
    compSegmentCosts.basement?.totalCost,
    BASEMENT_DESCRIPTION2
  );
  const attic = getStructureAdjustmentResult(
    subjectSegmentCosts.attic?.totalCost,
    compSegmentCosts.attic?.totalCost,
    ATTIC_DESCRIPTION2
  );
  const functionalUtility = getDefaultAdjustmentBreakdown(
    subjectDepreciationCosts?.functional,
    compDepreciationCosts.functional,
    FUNCTIONAL_UTILITY_DESCRIPTION
  );
  const garageCarport = getGarageCarportAdjustmentBreakdown2({
    subject: {
      ...subjectSegmentCosts
    },
    comp: {
      ...compSegmentCosts
    }
  });
  const porchPatioDeck = getPorchPatioDeckAdjustmentBreakdown2({
    subject: {
      ...subjectSegmentCosts
    },
    comp: {
      ...compSegmentCosts
    }
  });
  const { dateOfSale: dateOfSale2, concessions, termsOfSale } = getMarketAdjustmentBreakdown(marketConditions2);
  const manual = getManualAdjustmentBreakdown2(
    subjectSegmentCosts.manual?.totalCost,
    compSegmentCosts.manual?.totalCost,
    manualCostLabel
  );
  const pool = getStructureAdjustmentResult(
    subjectSegmentCosts.pool?.totalCost,
    compSegmentCosts.pool?.totalCost,
    POOL_DESCRIPTION2
  );
  const adu = getStructureAdjustmentResult(
    subjectSegmentCosts.adu?.totalCost,
    compSegmentCosts.adu?.totalCost,
    ADU_DESCRIPTION2
  );
  const shed = getStructureAdjustmentResult(
    subjectSegmentCosts.shed?.totalCost,
    compSegmentCosts.shed?.totalCost,
    SHED_DESCRIPTION2
  );
  const workshop = getStructureAdjustmentResult(
    subjectSegmentCosts.workshop?.totalCost,
    compSegmentCosts.workshop?.totalCost,
    WORKSHOP_DESCRIPTION2
  );
  const bonusRoom = getStructureAdjustmentResult(
    subjectSegmentCosts.bonusRoom?.totalCost,
    compSegmentCosts.bonusRoom?.totalCost,
    BONUS_ROOM_DESCRIPTION2
  );
  const barn = getStructureAdjustmentResult(
    subjectSegmentCosts.barn?.totalCost,
    compSegmentCosts.barn?.totalCost,
    BARN_DESCRIPTION2
  );
  const belowGradeANSI = getStructureAdjustmentResult(
    subjectSegmentCosts.belowGradeANSI?.totalCost,
    compSegmentCosts.belowGradeANSI?.totalCost,
    BELOW_GRADE_ANSI_DESCRIPTION2
  );
  const manufactured = getStructureAdjustmentResult(
    subjectSegmentCosts.manufactured?.totalCost,
    compSegmentCosts.manufactured?.totalCost,
    MANUFACTURED_DESCRIPTION2
  );
  const adjustments = {
    dateOfSale: dateOfSale2,
    concessions,
    termsOfSale,
    functionalUtility,
    externalObsolescence: {
      adjustment: AloftPrice51.zero
    },
    quality,
    condition,
    mainDwelling,
    garageCarport,
    basement,
    manual,
    adu,
    attic,
    fireplace: {
      adjustment: AloftPrice51.zero,
      adjustmentBasis: void 0,
      calculations: void 0,
      description: void 0,
      roundingUsed: void 0,
      thresholdUsed: void 0
    },
    barn,
    bonusRoom,
    porchPatioDeck,
    pool,
    shed,
    workshop,
    manufactured,
    belowGradeANSI,
    site,
    bathAboveGrade: {
      adjustment: AloftPrice51.zero,
      adjustmentBasis: void 0,
      calculations: void 0,
      description: void 0,
      roundingUsed: void 0,
      thresholdUsed: void 0
    },
    bathBelowGrade: {
      adjustment: AloftPrice51.zero,
      adjustmentBasis: void 0,
      calculations: void 0,
      description: void 0,
      roundingUsed: void 0,
      thresholdUsed: void 0
    },
    locationView: {
      adjustment: AloftPrice51.zero
    },
    foundation: {
      adjustment: AloftPrice51.zero
    },
    units: {
      adjustment: AloftPrice51.zero
    }
  };
  return adjustments;
};

// src/depreciatedCost/results/internal/v2/adjustments/getPairedCostAdjustmentsV2.ts
import { AloftPrice as AloftPrice53 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/v2/adjustments/getQualityAdjustmentBreakdown.ts
import { AloftArea as AloftArea33, AloftPrice as AloftPrice52 } from "@aloft/shared-objects";
function getQualityAdjustmentBreakdown3({
  subject,
  comp
}) {
  const compSqftNum = comp.gla?.getUnitAmount("sqft") ?? 0;
  const compAdjCost = comp.depreciatedCost?.add(comp.physicalDepreciationAdjustment).add(comp.bathAboveGradeAdjustment).add(comp.bathBelowGradeAdjustment).add(comp.glaAdjustment) ?? AloftPrice52.zero;
  const adjustment = subject.depreciatedCost?.sub(compAdjCost) ?? AloftPrice52.zero;
  const costPerSqftDiff = compSqftNum > 0 ? adjustment.div(compSqftNum) ?? AloftPrice52.zero : AloftPrice52.zero;
  const adjustedCostPerSqft = compSqftNum > 0 ? compAdjCost.div(compSqftNum) ?? AloftPrice52.zero : AloftPrice52.zero;
  return {
    adjustment,
    params: {
      costPerSqftDiff,
      adjustedCostPerSqft
    },
    description: QUALITY_DESCRIPTION,
    calculations: [
      `${costPerSqftDiff.toString()} * ${(comp?.gla ?? AloftArea33.zero).toString()} = ${adjustment.toString(true)}`
    ]
  };
}

// src/depreciatedCost/results/internal/v2/adjustments/getPairedCostAdjustmentsV2.ts
var getPairedCostAdjustmentsV2 = ({
  subject,
  comp,
  manualCostLabel
}) => {
  const {
    segmentCosts: subjectSegmentCosts,
    depreciationCosts: subjectDepreciationCosts,
    bathCounts: subjectBathCounts
  } = subject;
  const subjectSegmentDepreciation = subject.depreciationCosts?.physical.segments;
  const {
    segmentCosts: compSegmentCosts,
    depreciationCosts: compDepreciationCosts,
    marketConditions: marketConditions2,
    siteTotals,
    bathCounts: compBathCounts
  } = comp;
  const compSegmentDepreciation = comp.depreciationCosts?.physical.segments;
  const gla = getGlaAdjustmentBreakdown({
    subject: subjectSegmentDepreciation?.mainDwelling?.depreciatedCost,
    comp: compSegmentDepreciation?.mainDwelling?.depreciatedCost
  });
  const bathAboveGrade = getBathCountAdjustmentBreakdown({
    subject: subjectBathCounts.aboveGrade,
    comp: compBathCounts.aboveGrade,
    depreciatedBathroomCosts: subject.depreciatedBathroomCosts
  });
  const bathBelowGrade = getBathCountAdjustmentBreakdown({
    subject: subjectBathCounts.belowGrade,
    comp: compBathCounts.belowGrade,
    depreciatedBathroomCosts: subject.depreciatedBathroomCosts
  });
  const condition = getConditionAdjustmentBreakdown({
    subject: {
      physicalDepreciation: subjectSegmentDepreciation?.mainDwelling,
      externalDepreciation: subjectDepreciationCosts?.external,
      costNew: subjectSegmentCosts.mainDwelling?.totalCost
    },
    comp: {
      physicalDepreciation: compSegmentDepreciation?.mainDwelling,
      externalDepreciation: compDepreciationCosts?.external,
      costNew: compSegmentCosts.mainDwelling?.totalCost
    }
  });
  const quality = getQualityAdjustmentBreakdown3({
    subject: {
      depreciatedCost: subjectSegmentDepreciation?.mainDwelling?.depreciatedCost.totalCost
    },
    comp: {
      gla: compSegmentDepreciation?.mainDwelling?.depreciatedCost.sqft,
      depreciatedCost: compSegmentDepreciation?.mainDwelling?.depreciatedCost.totalCost,
      physicalDepreciationAdjustment: condition.params?.physicalDepreciationAdjustment,
      bathAboveGradeAdjustment: bathAboveGrade.adjustment,
      bathBelowGradeAdjustment: bathBelowGrade.adjustment,
      glaAdjustment: gla.adjustment
    }
  });
  const basement = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.basement?.depreciatedCost.totalCost,
    compSegmentDepreciation?.basement?.depreciatedCost.totalCost,
    BASEMENT_DESCRIPTION
  );
  const attic = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.attic?.depreciatedCost.totalCost,
    compSegmentDepreciation?.attic?.depreciatedCost.totalCost,
    ATTIC_DESCRIPTION
  );
  const functionalUtility = getDefaultAdjustmentBreakdown(
    subjectDepreciationCosts?.functional,
    compDepreciationCosts.functional,
    FUNCTIONAL_UTILITY_DESCRIPTION
  );
  const garageCarport = getGarageCarportAdjustmentBreakdown2({
    subject: {
      attachedOrBuiltinGarage: subjectSegmentDepreciation?.attachedOrBuiltinGarage?.depreciatedCost,
      detachedGarage: subjectSegmentDepreciation?.detachedGarage?.depreciatedCost,
      carport: subjectSegmentDepreciation?.carport?.depreciatedCost
    },
    comp: {
      attachedOrBuiltinGarage: compSegmentDepreciation?.attachedOrBuiltinGarage?.depreciatedCost,
      detachedGarage: compSegmentDepreciation?.detachedGarage?.depreciatedCost,
      carport: compSegmentDepreciation?.carport?.depreciatedCost
    }
  });
  const porchPatioDeck = getPorchPatioDeckAdjustmentBreakdown2({
    subject: {
      deck: subjectSegmentDepreciation?.deck?.depreciatedCost,
      coveredPatioOrGazebo: subjectSegmentDepreciation?.coveredPatioOrGazebo?.depreciatedCost,
      enclosedPatio: subjectSegmentDepreciation?.enclosedPatio?.depreciatedCost
    },
    comp: {
      deck: compSegmentDepreciation?.deck?.depreciatedCost,
      coveredPatioOrGazebo: compSegmentDepreciation?.coveredPatioOrGazebo?.depreciatedCost,
      enclosedPatio: compSegmentDepreciation?.enclosedPatio?.depreciatedCost
    }
  });
  const { dateOfSale: dateOfSale2, concessions, termsOfSale } = getMarketAdjustmentBreakdown(marketConditions2);
  const manual = getManualAdjustmentBreakdown(
    subjectSegmentCosts.manual?.totalCost,
    compSegmentCosts.manual?.totalCost,
    manualCostLabel
  );
  const pool = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.pool?.depreciatedCost.totalCost,
    compSegmentDepreciation?.pool?.depreciatedCost.totalCost,
    POOL_DESCRIPTION
  );
  const adu = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.adu?.depreciatedCost.totalCost,
    compSegmentDepreciation?.adu?.depreciatedCost.totalCost,
    ADU_DESCRIPTION
  );
  const shed = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.shed?.depreciatedCost.totalCost,
    compSegmentDepreciation?.shed?.depreciatedCost.totalCost,
    SHED_DESCRIPTION
  );
  const workshop = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.workshop?.depreciatedCost.totalCost,
    compSegmentDepreciation?.workshop?.depreciatedCost.totalCost,
    WORKSHOP_DESCRIPTION
  );
  const bonusRoom = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.bonusRoom?.depreciatedCost.totalCost,
    compSegmentDepreciation?.bonusRoom?.depreciatedCost.totalCost,
    BONUS_ROOM_DESCRIPTION
  );
  const barn = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.barn?.depreciatedCost.totalCost,
    compSegmentDepreciation?.barn?.depreciatedCost.totalCost,
    BARN_DESCRIPTION
  );
  const belowGradeANSI = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.belowGradeANSI?.depreciatedCost.totalCost,
    compSegmentDepreciation?.belowGradeANSI?.depreciatedCost.totalCost,
    BELOW_GRADE_ANSI_DESCRIPTION
  );
  const manufactured = getStructureAdjustmentResult(
    subjectSegmentDepreciation?.manufactured?.depreciatedCost.totalCost,
    compSegmentDepreciation?.manufactured?.depreciatedCost.totalCost,
    MANUFACTURED_DESCRIPTION
  );
  const site = getDefaultAdjustmentBreakdown(
    subject.siteCost,
    siteTotals.marketAdjusted?.siteValue.totalCost,
    SITE_DESCRIPTION
  );
  const adjustments = {
    dateOfSale: dateOfSale2,
    concessions,
    termsOfSale,
    functionalUtility,
    externalObsolescence: {
      adjustment: AloftPrice53.zero
    },
    mainDwelling: gla,
    bathAboveGrade,
    bathBelowGrade,
    quality,
    condition,
    garageCarport,
    basement,
    manual,
    adu,
    attic,
    fireplace: {
      adjustment: AloftPrice53.zero
    },
    barn,
    bonusRoom,
    porchPatioDeck,
    pool,
    shed,
    workshop,
    manufactured,
    belowGradeANSI,
    site,
    locationView: {
      adjustment: AloftPrice53.zero
    },
    foundation: {
      adjustment: AloftPrice53.zero
    },
    units: {
      adjustment: AloftPrice53.zero
    }
  };
  return adjustments;
};

// src/depreciatedCost/results/internal/adjustments/getPairedCostAdjustments.ts
function getPairedCostAdjustments(params) {
  const adjustments = getAdjustments(params);
  return applyTkv2PairedCostSettings(params.pairedCostSettings, adjustments);
}
function getAdjustments({ version, ...rest }) {
  switch (version) {
    case "legacy":
      return getPairedCostAdjustmentsV1(rest);
    case "april_2024":
      return getPairedCostAdjustmentsV2(rest);
    case "simplified_v1":
      return getPairedCostAdjustmentsSimplified(rest);
    default:
      throw new Error("Adjustment type not implemented");
  }
}

// src/depreciatedCost/results/internal/depreciation/getDepreciationCosts.ts
var import_shared_utils95 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice54 } from "@aloft/shared-objects";

// src/keepFinite.ts
function keepFinite(x) {
  return Number.isFinite(x) ? x : void 0;
}

// src/depreciatedCost/utils/segmentToStructure.ts
function segmentToStructure(segmentType, propertyType) {
  switch (segmentType) {
    case "mainDwelling":
    case "belowGradeANSI":
      if (propertyType === "manufacturedHome") {
        return "manufactured";
      }
      return "primaryDwelling";
    case "manufactured":
      if (propertyType === "manufacturedHome") {
        return void 0;
      }
      return "manufactured";
    case "manual":
      return void 0;
    default:
      return segmentType;
  }
}

// src/depreciatedCost/results/internal/depreciation/getDepreciationCosts.ts
function getDepreciationCosts(props) {
  const { settings, segmentCosts, depreciation, propertyType } = props;
  function depreciate(key) {
    const use = settings.depreciateImprovementsSeparately ? segmentToStructure(key, propertyType) : "primaryDwelling";
    if ((0, import_shared_utils95.isUndefined)(use)) {
      return void 0;
    }
    const defaultEcoLife = settings.defaultEconomicLifePerImprovement[use] ?? 60;
    const field = depreciation.physicalDepreciation[use];
    const segment = segmentCosts[key];
    if (segment === void 0) {
      return void 0;
    }
    const cost = segment.totalCost;
    if (cost === void 0) {
      return void 0;
    }
    let result;
    switch (settings.physicalDepreciationMode) {
      case "ageLifeMethod": {
        const ratio = keepFinite((field?.effectiveAge ?? 0) / (field?.ecoLifeYears ?? defaultEcoLife)) ?? 0;
        result = cost.mul(-ratio);
        break;
      }
      case "percent": {
        const ratio = (field?.percent ?? 0) / 100;
        result = cost.mul(-ratio);
        break;
      }
      case "lumpSum": {
        result = field?.lumpSum?.mul(-1) ?? AloftPrice54.zero;
        break;
      }
    }
    const depreciationCost = result.roundToDollarLike();
    const depreciatedCost = cost.add(depreciationCost);
    const sqft = segment.sqft;
    return {
      depreciation: depreciationCost,
      depreciationRatio: +(depreciationCost.ratio(cost) * -1).toFixed(2),
      effectiveAge: settings.physicalDepreciationMode === "ageLifeMethod" ? field?.effectiveAge : void 0,
      ecoLifeYears: settings.physicalDepreciationMode === "ageLifeMethod" ? field?.ecoLifeYears : void 0,
      depreciatedCost: {
        totalCost: depreciatedCost,
        sqft,
        costPerSqft: sqft === void 0 || sqft.getUnitAmount("sqft") === 0 ? void 0 : depreciatedCost.div(sqft.getUnitAmount("sqft")),
        dwellingCostQuality: segment.dwellingCostQuality
      }
    };
  }
  const segments = {
    mainDwelling: depreciate("mainDwelling"),
    basement: depreciate("basement"),
    attic: depreciate("attic"),
    attachedOrBuiltinGarage: depreciate("attachedOrBuiltinGarage"),
    detachedGarage: depreciate("detachedGarage"),
    carport: depreciate("carport"),
    deck: depreciate("deck"),
    coveredPatioOrGazebo: depreciate("coveredPatioOrGazebo"),
    enclosedPatio: depreciate("enclosedPatio"),
    pool: depreciate("pool"),
    adu: depreciate("adu"),
    shed: depreciate("shed"),
    workshop: depreciate("workshop"),
    bonusRoom: depreciate("bonusRoom"),
    barn: depreciate("barn"),
    manufactured: depreciate("manufactured"),
    belowGradeANSI: depreciate("belowGradeANSI"),
    manual: void 0
  };
  const allSegmentDepreciation = Object.values(segments).filter(import_shared_utils95.isDefined).map((depr) => depr.depreciation);
  const totalCostNew = AloftPrice54.add(
    ...Object.values(segmentCosts).map((cost) => cost?.totalCost)
  );
  const physObsCost = AloftPrice54.addWithNulls(...allSegmentDepreciation);
  const functionalObsolescence = settings.functionalObsolescenceMode === "lumpSum" ? depreciation.functionalObsolescence.lumpSum?.mul(-1) ?? AloftPrice54.zero : totalCostNew?.mul(-(depreciation.functionalObsolescence.percent ?? 0) / 100)?.roundToDollarLike();
  const externalObsolescence = settings.externalObsolescenceMode === "lumpSum" ? depreciation.externalDepreciation.lumpSum?.mul(-1) ?? AloftPrice54.zero : totalCostNew?.mul(-(depreciation.externalDepreciation.percent ?? 0) / 100)?.roundToDollarLike();
  const totalDepreciation = AloftPrice54.add(
    physObsCost,
    functionalObsolescence,
    externalObsolescence
  );
  const depreciatedCostOfImprovements = totalCostNew?.add(totalDepreciation);
  return {
    total: totalDepreciation,
    physical: {
      total: physObsCost ?? AloftPrice54.zero,
      segments
    },
    functional: functionalObsolescence,
    external: externalObsolescence,
    depreciatedCostOfImprovements
  };
}

// src/depreciatedCost/results/internal/features/getBathFeature.ts
function getBathFeature({
  bathCounts,
  depreciatedBathroomCosts,
  type
}) {
  const fullBathCount = bathCounts?.fullBaths ?? schPositiveInt.parse(0);
  const halfBathCount = bathCounts?.halfBaths ?? schPositiveInt.parse(0);
  if (type === "below_grade" && fullBathCount === 0 && halfBathCount === 0) {
    return void 0;
  }
  return {
    text: `${fullBathCount}.${halfBathCount}`,
    costsDepreciated: depreciatedBathroomCosts,
    counts: { fullBaths: fullBathCount, halfBaths: halfBathCount }
  };
}

// src/depreciatedCost/results/internal/features/getFunctionalUtilityFeature.ts
function getFunctionalUtilityFeature(property, depreciationCosts) {
  return {
    text: property?.getGridField("FunctionalUtility") ?? "",
    amount: depreciationCosts?.functional
  };
}

// src/depreciatedCost/results/internal/features/getGarageCarportFeature.ts
var import_shared_utils96 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea34, AloftPrice as AloftPrice55 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/features/getSegmentFeatures.ts
function getSegmentFeatures(segmentCostType, segmentCosts, depreciatedSegmentCosts) {
  const segmentCost = segmentCosts?.[segmentCostType];
  const depreciatedSegmentCost = depreciatedSegmentCosts?.[segmentCostType];
  return {
    dcQuality: segmentCost?.dwellingCostQuality,
    sqft: segmentCost?.sqft,
    costNew: segmentCost?.totalCost,
    depreciation: depreciatedSegmentCost?.depreciation,
    depreciatedCost: depreciatedSegmentCost?.depreciatedCost.totalCost,
    depreciationRatio: depreciatedSegmentCost?.depreciationRatio
  };
}

// src/depreciatedCost/results/internal/features/getGarageCarportFeature.ts
function getGarageCarportFeature({
  carStorageAnnotation,
  segmentCosts,
  depreciatedSegmentCosts
}) {
  const sqft = (segmentCosts?.attachedOrBuiltinGarage?.sqft || AloftArea34.zero).add(
    segmentCosts?.detachedGarage?.sqft ?? AloftArea34.zero,
    segmentCosts?.carport?.sqft ?? AloftArea34.zero
  ).toString();
  const attachedOrBuiltinGarage = getSegmentFeatures(
    "attachedOrBuiltinGarage",
    segmentCosts,
    depreciatedSegmentCosts
  );
  const detachedGarage = getSegmentFeatures(
    "detachedGarage",
    segmentCosts,
    depreciatedSegmentCosts
  );
  const carport = getSegmentFeatures("carport", segmentCosts, depreciatedSegmentCosts);
  const totalDepreciatedCost = [attachedOrBuiltinGarage, detachedGarage, carport].filter(import_shared_utils96.isDefined).reduce((acc, val) => {
    return acc.add(val.depreciatedCost);
  }, AloftPrice55.zero);
  return {
    text: carStorageAnnotation ?? "",
    attachedOrBuiltinGarage,
    detachedGarage,
    carport,
    sqft,
    totalDepreciatedCost
  };
}

// src/depreciatedCost/results/internal/features/getPorchPatioDeckFeature.ts
var import_shared_utils97 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea35, AloftPrice as AloftPrice56 } from "@aloft/shared-objects";
function getPorchPatioDeckFeature({
  porchPatioDeckAnnotation,
  segmentCosts,
  depreciatedSegmentCosts
}) {
  const sqft = (segmentCosts?.coveredPatioOrGazebo?.sqft || AloftArea35.zero).add(
    segmentCosts?.enclosedPatio?.sqft ?? AloftArea35.zero,
    segmentCosts?.deck?.sqft ?? AloftArea35.zero
  ).toString();
  const deck = getSegmentFeatures("deck", segmentCosts, depreciatedSegmentCosts);
  const coveredPatioOrGazebo = getSegmentFeatures(
    "coveredPatioOrGazebo",
    segmentCosts,
    depreciatedSegmentCosts
  );
  const enclosedPatio = getSegmentFeatures("enclosedPatio", segmentCosts, depreciatedSegmentCosts);
  const totalDepreciatedCost = [deck, coveredPatioOrGazebo, enclosedPatio].filter(import_shared_utils97.isDefined).reduce((acc, val) => {
    return acc.add(val.depreciatedCost);
  }, AloftPrice56.zero);
  return {
    text: porchPatioDeckAnnotation ?? "",
    deck,
    coveredPatioOrGazebo,
    enclosedPatio,
    sqft,
    totalDepreciatedCost
  };
}

// src/depreciatedCost/results/internal/features/textToFeature.ts
var import_shared_utils98 = __toESM(require_lib(), 1);
function textToFeature(text) {
  return (0, import_shared_utils98.isDefined)(text) ? {
    text
  } : void 0;
}

// src/depreciatedCost/results/internal/features/updated/getBasementFeatureUpdated.ts
var import_shared_utils99 = __toESM(require_lib(), 1);
import { AloftArea as AloftArea36 } from "@aloft/shared-objects";
function getBasementFeatureUpdated({
  finishedSqft,
  segmentCosts,
  depreciatedSegmentCosts
}) {
  const features = getSegmentFeatures("basement", segmentCosts, depreciatedSegmentCosts);
  const text = getText(features, finishedSqft);
  return {
    ...features,
    finishedSqft,
    text,
    costPerSqft: segmentCosts?.basement?.costPerSqft?.toString()
  };
}
function getText(features, finishedSqft) {
  return [
    `${(features.sqft ?? AloftArea36.zero).toSqFtValueStringRounded()}sf;${(finishedSqft ?? AloftArea36.zero).toSqFtValueStringRounded()}sf`,
    features.dcQuality ? `QL${features.dcQuality}` : void 0
  ].filter(import_shared_utils99.isDefined).join(" | ");
}

// src/depreciatedCost/results/internal/features/updated/getConditionFeatureUpdated.ts
var import_shared_utils100 = __toESM(require_lib(), 1);
function getConditionFeatureUpdated({
  actualAge,
  depreciationDiffPercent,
  depreciation,
  costNew,
  uadCondition
}) {
  const ageCondition = `${actualAge ?? ""} / ${uadCondition ?? ""}`;
  return {
    text: getText2(uadCondition, depreciation),
    ageCondition,
    effectiveAge: depreciation?.effectiveAge,
    ecoLifeYears: depreciation?.ecoLifeYears,
    percentDepreciation: depreciation?.depreciationRatio,
    depreciationDiffPercent,
    costNew
  };
}
function getText2(uadCondition, depreciation) {
  const { effectiveAge, depreciationRatio } = depreciation ?? {};
  let depreciationString;
  if ((0, import_shared_utils100.isDefined)(effectiveAge)) {
    depreciationString = `E${effectiveAge}`;
  } else {
    depreciationString = `${toPercentString(depreciationRatio ?? 0)} depr`;
  }
  return `${uadCondition} | ${depreciationString}`;
}

// src/depreciatedCost/results/internal/features/updated/getMainDwellingFeatureUpdated.ts
function getMainDwellingFeatureUpdated(property, mainDwellingCost, depreciatedMainDwellingCost) {
  const propertyType = property.getPropertyType();
  const costData = property.getEditableCostData();
  const units = costData.primaryDwelling.multiUnitCount;
  return {
    text: property.getGridField("GrossLivingArea") ?? "",
    sqft: mainDwellingCost?.sqft?.toString(),
    bathrooms: property.getGridField("TotalBathroomCount"),
    sections: propertyType === "manufacturedHome" ? costData.manufactured.sections?.toString() : void 0,
    foundationType: (
      //TODO: Get the mapping for shortened string
      propertyType === "manufacturedHome" ? costData.manufactured.foundationType : void 0
    ),
    stories: property.getStructuredData("designStyle")?.stories?.toString(),
    costPerSqft: mainDwellingCost?.costPerSqft?.toString(),
    units: units?.toString(),
    propertyType: getPropertyTypeString(propertyType, units),
    depreciatedCostPerSqFt: depreciatedMainDwellingCost?.depreciatedCost.costPerSqft
  };
}
function getPropertyTypeString(propertyType, units) {
  switch (propertyType) {
    case "multiFamily":
      return `${units ?? "Unk"} Unit Multi-Family`;
    case "manufacturedHome":
      return "Manufactured";
    case "singleFamilyResidence":
    default:
      return "Site Built";
  }
}

// src/depreciatedCost/results/internal/features/updated/getQualityFeatureUpdated.ts
var import_shared_utils101 = __toESM(require_lib(), 1);
function getQualityFeatureUpdated(params) {
  const { uadQuality, dwellingCostQuality } = params;
  const text = [uadQuality, dwellingCostQuality ? `QL${dwellingCostQuality}` : void 0].filter(import_shared_utils101.isDefined).join(" | ");
  return {
    text,
    ...params
  };
}

// src/depreciatedCost/results/internal/features/updated/getSegmentAdjustmentFeatureUpdated.ts
var import_shared_utils102 = __toESM(require_lib(), 1);
function getSegmentAdjustmentFeatureUpdated(segmentCostType, segmentCosts, depreciatedSegmentCosts) {
  const features = getSegmentFeatures(segmentCostType, segmentCosts, depreciatedSegmentCosts);
  const text = [
    `${features.sqft?.getUnitAmount("sqft").toFixed(0) ?? 0}sf`,
    features.dcQuality ? `QL${features.dcQuality}` : void 0,
    toPercentString(features.depreciationRatio ?? 0)
  ].filter(import_shared_utils102.isDefined).join(" | ");
  return {
    text,
    ...features
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/features/getSiteFeature.ts
function getSiteFeature(property, siteValueAsOfEffDate, depreciatedCostOfImprovements) {
  const size = property?.getGridField("SiteArea") ?? "";
  const location = property?.getGridField("Location") ?? "";
  const view = property?.getGridField("View") ?? "";
  const text = size;
  return {
    size,
    location,
    view,
    text,
    salePrice: property?.getStructuredData("salePrice"),
    marketAdjustment: siteValueAsOfEffDate.marketAdjustment,
    depreciatedCostOfImprovements,
    siteValue: siteValueAsOfEffDate.siteValue,
    siteToValueRatio: siteValueAsOfEffDate.siteToValueRatio
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/features/getTkv2PairedCostFeaturesSimplified.ts
function getTkv2PairedCostFeaturesSimplified({
  property,
  segmentCosts,
  depreciationCosts,
  effectiveDate,
  adjustments,
  siteValueAsOfEffDate,
  depreciatedBathroomCosts
}) {
  const costData = property?.getCostDataInput(effectiveDate);
  const depreciatedSegmentCosts = depreciationCosts?.physical.segments;
  const getSegmentFeature = (type) => getSegmentAdjustmentFeatureUpdated(type, segmentCosts, depreciatedSegmentCosts);
  return {
    dateOfSale: textToFeature(property?.getGridField("DateOfSale")),
    concessions: textToFeature(property?.getGridField("FinancingConcessions")),
    termsOfSale: textToFeature(property?.getGridField("SalesConcessions")),
    functionalUtility: getFunctionalUtilityFeature(property, depreciationCosts),
    externalObsolescence: void 0,
    quality: getQualityFeatureUpdated({
      costNew: segmentCosts?.mainDwelling?.totalCost,
      uadQuality: property?.getGridField("Quality"),
      dwellingCostQuality: segmentCosts?.mainDwelling?.dwellingCostQuality,
      costPerSqftDiff: adjustments?.quality.params?.costPerSqftDiff,
      adjustedCostPerSqft: adjustments?.quality.params?.adjustedCostPerSqft,
      gla: property?.getStructuredData("gla")
    }),
    condition: getConditionFeatureUpdated({
      actualAge: property?.getGridField("Age"),
      depreciationDiffPercent: adjustments?.condition.params?.depreciationDiffPercent,
      depreciation: depreciatedSegmentCosts?.mainDwelling,
      costNew: segmentCosts?.mainDwelling?.totalCost,
      uadCondition: property?.getGridField("Condition")
    }),
    mainDwelling: getMainDwellingFeatureUpdated(
      property,
      segmentCosts?.mainDwelling,
      depreciatedSegmentCosts?.mainDwelling
    ),
    bathAboveGrade: getBathFeature({
      bathCounts: property.getBathroomCounts().aboveGrade,
      depreciatedBathroomCosts,
      type: "above_grade"
    }),
    bathBelowGrade: getBathFeature({
      bathCounts: property.getBathroomCounts().belowGrade,
      depreciatedBathroomCosts,
      type: "below_grade"
    }),
    garageCarport: getGarageCarportFeature({
      carStorageAnnotation: property?.getGridField("CarStorage"),
      segmentCosts,
      depreciatedSegmentCosts
    }),
    basement: getBasementFeatureUpdated({
      finishedSqft: costData?.basement?.finishedSqft,
      segmentCosts,
      depreciatedSegmentCosts
    }),
    manual: textToFeature(costData?.manualCost?.feature),
    adu: getSegmentFeature("adu"),
    attic: getSegmentFeature("attic"),
    fireplace: void 0,
    barn: getSegmentFeature("barn"),
    bonusRoom: getSegmentFeature("bonusRoom"),
    porchPatioDeck: getPorchPatioDeckFeature({
      porchPatioDeckAnnotation: property?.getGridField("PorchDeck"),
      segmentCosts,
      depreciatedSegmentCosts
    }),
    pool: getSegmentFeature("pool"),
    shed: getSegmentFeature("shed"),
    workshop: getSegmentFeature("workshop"),
    manufactured: getSegmentFeature("manufactured"),
    belowGradeANSI: getSegmentFeature("belowGradeANSI"),
    site: getSiteFeature(
      property,
      siteValueAsOfEffDate,
      depreciationCosts?.depreciatedCostOfImprovements
    ),
    locationView: getSiteFeature(
      property,
      siteValueAsOfEffDate,
      depreciationCosts?.depreciatedCostOfImprovements
    ),
    foundation: void 0,
    units: void 0
  };
}

// src/depreciatedCost/results/internal/features/getSiteFeature.ts
function getSiteFeature2(property, siteValueAsOfEffDate, depreciatedCostOfImprovements) {
  const size = property?.getGridField("SiteArea") ?? "";
  const location = property?.getGridField("Location") ?? "";
  const view = property?.getGridField("View") ?? "";
  const text = [size, location, view].join("; ");
  return {
    size,
    location,
    view,
    text,
    salePrice: property?.getStructuredData("salePrice"),
    marketAdjustment: siteValueAsOfEffDate.marketAdjustment,
    depreciatedCostOfImprovements,
    siteValue: siteValueAsOfEffDate.siteValue,
    siteToValueRatio: siteValueAsOfEffDate.siteToValueRatio
  };
}

// src/depreciatedCost/results/internal/features/legacy/getBasementFeatureLegacy.ts
function getBasementFeatureLegacy({
  finishedSqft,
  segmentCosts,
  depreciatedSegmentCosts
}) {
  const features = getSegmentFeatures("basement", segmentCosts, depreciatedSegmentCosts);
  const text = segmentCosts?.basement?.sqft?.toString() ?? "";
  return {
    ...features,
    finishedSqft,
    text,
    costPerSqft: segmentCosts?.basement?.costPerSqft?.toString()
  };
}

// src/depreciatedCost/results/internal/features/legacy/getConditionFeatureLegacy.ts
function getConditionFeatureLegacy({
  actualAge,
  depreciationDiffPercent,
  depreciation,
  costNew,
  uadCondition
}) {
  const ageCondition = `${actualAge ?? ""} / ${uadCondition ?? ""}`;
  return {
    text: uadCondition ?? "",
    ageCondition,
    effectiveAge: depreciation?.effectiveAge,
    ecoLifeYears: depreciation?.ecoLifeYears,
    percentDepreciation: depreciation?.depreciationRatio,
    depreciationDiffPercent,
    costNew
  };
}

// src/depreciatedCost/results/internal/features/legacy/getMainDwellingFeatureLegacy.ts
function getMainDwellingFeatureLegacy(property, mainDwellingCost, propertyTypeSet, depreciatedMainDwellingCost) {
  const propertyType = property.getPropertyType();
  const costData = property.getEditableCostData();
  const units = costData.primaryDwelling.multiUnitCount;
  return {
    text: getMainDwellingFeatureText(property, propertyTypeSet, units),
    sqft: mainDwellingCost?.sqft?.toString(),
    bathrooms: property.getGridField("TotalBathroomCount"),
    sections: propertyType === "manufacturedHome" ? costData.manufactured.sections?.toString() : void 0,
    foundationType: (
      //TODO: Get the mapping for shortened string
      propertyType === "manufacturedHome" ? costData.manufactured.foundationType : void 0
    ),
    stories: property.getStructuredData("designStyle")?.stories?.toString(),
    costPerSqft: mainDwellingCost?.costPerSqft?.toString(),
    units: units?.toString(),
    propertyType: getPropertyTypeString2(propertyType, units),
    depreciatedCostPerSqFt: depreciatedMainDwellingCost?.depreciatedCost.costPerSqft
  };
}
function getMainDwellingFeatureText(property, propertyTypeSet, units) {
  if (propertyTypeSet.size > 1) {
    return `${property.getStructuredData("gla") ?? "GLA Unk"}; ${property.getGridField("TotalBathroomCount") ?? "Unk "}ba; ${getPropertyTypeString2(property.getPropertyType(), units)}`;
  }
  if (propertyTypeSet.has("manufacturedHome")) {
    return `${property.getStructuredData("gla") ?? "GLA Unk"}; ${property.getGridField("TotalBathroomCount") ?? "Unk "}ba; ${property.getReplacementCostFields().manufactured?.sections ?? "Sections Unk"}; ${property.getReplacementCostFields().manufactured?.foundationType ?? "Foundation Unk;"}`;
  }
  if (propertyTypeSet.has("multiFamily")) {
    return `${property.getStructuredData("gla") ?? "GLA Unk"}; ${property.getGridField("TotalBathroomCount") ?? "Unk "}ba; ${property.getStructuredData("designStyle")?.stories ?? "Unk "}stry; ${property.getEditableCostData().primaryDwelling.multiUnitCount ?? "Unk "} units`;
  }
  if (propertyTypeSet.has("singleFamilyResidence") || propertyTypeSet.size === 0) {
    return `${property.getStructuredData("gla") ?? "GLA Unk"}; ${property.getGridField("TotalBathroomCount") ?? "Unk "}ba; ${property.getGridField("DesignStyle") ?? "DesignStyle Unk;"}`;
  }
  throw new Error(`Unsupported property type - ${propertyTypeSet.values().next().value}`);
}
function getPropertyTypeString2(propertyType, units) {
  switch (propertyType) {
    case "multiFamily":
      return `${units ?? "Unk"} Unit Multi-Family`;
    case "manufacturedHome":
      return "Manufactured";
    case "singleFamilyResidence":
    default:
      return "Site Built";
  }
}

// src/depreciatedCost/results/internal/features/legacy/getQualityFeatureLegacy.ts
function getQualityFeatureLegacy(params) {
  const { uadQuality, dwellingCostQuality } = params;
  const text = `${uadQuality ?? ""}; ${dwellingCostQuality ? `QL${dwellingCostQuality}` : ""}`;
  return {
    text,
    ...params
  };
}

// src/depreciatedCost/results/internal/features/legacy/getSegmentAdjustmentFeatureLegacy.ts
function getSegmentAdjustmentFeatureLegacy(segmentCostType, segmentCosts, depreciatedSegmentCosts) {
  const features = getSegmentFeatures(segmentCostType, segmentCosts, depreciatedSegmentCosts);
  const text = segmentCosts?.[segmentCostType]?.sqft?.toString() ?? "";
  return {
    text,
    ...features
  };
}

// src/depreciatedCost/results/internal/v1/features/getTkv2PairedCostFeaturesV1.ts
function getTkv2PairedCostFeaturesV1({
  property,
  segmentCosts,
  depreciationCosts,
  effectiveDate,
  adjustments,
  siteValueAsOfEffDate,
  propertyTypeSet,
  depreciatedBathroomCosts
}) {
  const costData = property?.getCostDataInput(effectiveDate);
  const depreciatedSegmentCosts = depreciationCosts?.physical.segments;
  const getSegmentFeature = (type) => getSegmentAdjustmentFeatureLegacy(type, segmentCosts, depreciatedSegmentCosts);
  return {
    dateOfSale: textToFeature(property?.getGridField("DateOfSale")),
    concessions: textToFeature(property?.getGridField("FinancingConcessions")),
    termsOfSale: textToFeature(property?.getGridField("SalesConcessions")),
    functionalUtility: getFunctionalUtilityFeature(property, depreciationCosts),
    externalObsolescence: void 0,
    quality: getQualityFeatureLegacy({
      costNew: segmentCosts?.mainDwelling?.totalCost,
      uadQuality: property?.getGridField("Quality"),
      dwellingCostQuality: segmentCosts?.mainDwelling?.dwellingCostQuality,
      costPerSqftDiff: adjustments?.quality.params?.costPerSqftDiff,
      adjustedCostPerSqft: adjustments?.quality.params?.adjustedCostPerSqft,
      gla: property?.getStructuredData("gla")
    }),
    condition: getConditionFeatureLegacy({
      actualAge: property?.getGridField("Age"),
      depreciationDiffPercent: adjustments?.condition.params?.depreciationDiffPercent,
      depreciation: depreciatedSegmentCosts?.mainDwelling,
      costNew: segmentCosts?.mainDwelling?.totalCost,
      uadCondition: property?.getGridField("Condition")
    }),
    mainDwelling: getMainDwellingFeatureLegacy(
      property,
      segmentCosts?.mainDwelling,
      propertyTypeSet,
      depreciatedSegmentCosts?.mainDwelling
    ),
    bathAboveGrade: getBathFeature({
      bathCounts: property.getBathroomCounts().aboveGrade,
      depreciatedBathroomCosts,
      type: "above_grade"
    }),
    bathBelowGrade: getBathFeature({
      bathCounts: property.getBathroomCounts().belowGrade,
      depreciatedBathroomCosts,
      type: "below_grade"
    }),
    garageCarport: getGarageCarportFeature({
      carStorageAnnotation: property?.getGridField("CarStorage"),
      segmentCosts,
      depreciatedSegmentCosts
    }),
    basement: getBasementFeatureLegacy({
      finishedSqft: costData?.basement?.finishedSqft,
      segmentCosts,
      depreciatedSegmentCosts
    }),
    manual: textToFeature(costData?.manualCost?.feature),
    adu: getSegmentFeature("adu"),
    attic: getSegmentFeature("attic"),
    fireplace: void 0,
    barn: getSegmentFeature("barn"),
    bonusRoom: getSegmentFeature("bonusRoom"),
    porchPatioDeck: getPorchPatioDeckFeature({
      porchPatioDeckAnnotation: property?.getGridField("PorchDeck"),
      segmentCosts,
      depreciatedSegmentCosts
    }),
    pool: getSegmentFeature("pool"),
    shed: getSegmentFeature("shed"),
    workshop: getSegmentFeature("workshop"),
    manufactured: getSegmentFeature("manufactured"),
    belowGradeANSI: getSegmentFeature("belowGradeANSI"),
    site: getSiteFeature2(
      property,
      siteValueAsOfEffDate,
      depreciationCosts?.depreciatedCostOfImprovements
    ),
    locationView: getSiteFeature2(
      property,
      siteValueAsOfEffDate,
      depreciationCosts?.depreciatedCostOfImprovements
    ),
    foundation: void 0,
    units: void 0
  };
}

// src/depreciatedCost/results/internal/v2/features/getTkv2PairedCostFeaturesV2.ts
function getTkv2PairedCostFeaturesV2({
  property,
  segmentCosts,
  depreciationCosts,
  effectiveDate,
  adjustments,
  siteValueAsOfEffDate,
  depreciatedBathroomCosts
}) {
  const costData = property?.getCostDataInput(effectiveDate);
  const depreciatedSegmentCosts = depreciationCosts?.physical.segments;
  const getSegmentFeature = (type) => getSegmentAdjustmentFeatureUpdated(type, segmentCosts, depreciatedSegmentCosts);
  return {
    dateOfSale: textToFeature(property?.getGridField("DateOfSale")),
    concessions: textToFeature(property?.getGridField("FinancingConcessions")),
    termsOfSale: textToFeature(property?.getGridField("SalesConcessions")),
    functionalUtility: getFunctionalUtilityFeature(property, depreciationCosts),
    externalObsolescence: void 0,
    quality: getQualityFeatureUpdated({
      costNew: segmentCosts?.mainDwelling?.totalCost,
      uadQuality: property?.getGridField("Quality"),
      dwellingCostQuality: segmentCosts?.mainDwelling?.dwellingCostQuality,
      costPerSqftDiff: adjustments?.quality.params?.costPerSqftDiff,
      adjustedCostPerSqft: adjustments?.quality.params?.adjustedCostPerSqft,
      gla: property?.getStructuredData("gla")
    }),
    condition: getConditionFeatureUpdated({
      actualAge: property?.getGridField("Age"),
      depreciationDiffPercent: adjustments?.condition.params?.depreciationDiffPercent,
      depreciation: depreciatedSegmentCosts?.mainDwelling,
      costNew: segmentCosts?.mainDwelling?.totalCost,
      uadCondition: property?.getGridField("Condition")
    }),
    mainDwelling: getMainDwellingFeatureUpdated(
      property,
      segmentCosts?.mainDwelling,
      depreciatedSegmentCosts?.mainDwelling
    ),
    bathAboveGrade: getBathFeature({
      bathCounts: property.getBathroomCounts().aboveGrade,
      depreciatedBathroomCosts,
      type: "above_grade"
    }),
    bathBelowGrade: getBathFeature({
      bathCounts: property.getBathroomCounts().belowGrade,
      depreciatedBathroomCosts,
      type: "below_grade"
    }),
    garageCarport: getGarageCarportFeature({
      carStorageAnnotation: property?.getGridField("CarStorage"),
      segmentCosts,
      depreciatedSegmentCosts
    }),
    basement: getBasementFeatureUpdated({
      finishedSqft: costData?.basement?.finishedSqft,
      segmentCosts,
      depreciatedSegmentCosts
    }),
    manual: textToFeature(costData?.manualCost?.feature),
    adu: getSegmentFeature("adu"),
    attic: getSegmentFeature("attic"),
    barn: getSegmentFeature("barn"),
    bonusRoom: getSegmentFeature("bonusRoom"),
    porchPatioDeck: getPorchPatioDeckFeature({
      porchPatioDeckAnnotation: property?.getGridField("PorchDeck"),
      segmentCosts,
      depreciatedSegmentCosts
    }),
    pool: getSegmentFeature("pool"),
    shed: getSegmentFeature("shed"),
    workshop: getSegmentFeature("workshop"),
    manufactured: getSegmentFeature("manufactured"),
    belowGradeANSI: getSegmentFeature("belowGradeANSI"),
    site: getSiteFeature2(
      property,
      siteValueAsOfEffDate,
      depreciationCosts?.depreciatedCostOfImprovements
    ),
    locationView: getSiteFeature2(
      property,
      siteValueAsOfEffDate,
      depreciationCosts?.depreciatedCostOfImprovements
    ),
    fireplace: void 0,
    foundation: void 0,
    units: void 0
  };
}

// src/depreciatedCost/results/internal/features/getTkv2PairedCostFeatures.ts
function getTkv2PairedCostFeatures(params) {
  const { version } = params;
  switch (version) {
    case "legacy":
      return getTkv2PairedCostFeaturesV1(params);
    case "april_2024":
      return getTkv2PairedCostFeaturesV2(params);
    case "simplified_v1":
      return getTkv2PairedCostFeaturesSimplified(params);
    default:
      throw new Error(`Features not implemented for version=${version}`);
  }
}

// src/depreciatedCost/results/internal/getDepreciatedBathroomCosts.ts
var import_shared_utils103 = __toESM(require_lib(), 1);
function getDepreciatedBathroomCosts(bathCostsNew, depreciationRatio) {
  if ((0, import_shared_utils103.isUndefined)(bathCostsNew)) {
    return void 0;
  }
  return {
    fullBathCost: bathCostsNew.fullBathCost?.sub(bathCostsNew.fullBathCost.mul(depreciationRatio)),
    halfBathCost: bathCostsNew.halfBathCost?.sub(bathCostsNew.halfBathCost.mul(depreciationRatio))
  };
}

// src/depreciatedCost/results/internal/getSiteValAsOfEffectiveDate.ts
import { AloftArea as AloftArea37, AloftPrice as AloftPrice57 } from "@aloft/shared-objects";
function getSiteValAsOfEffectiveDate({
  unadjustedTotalCost,
  unadjustedSiteCost,
  marketAdjustment,
  siteArea
}) {
  const marketAdjustedSiteCost = unadjustedSiteCost.add(marketAdjustment);
  const marketAdjustedTotalCost = unadjustedTotalCost.add(marketAdjustment);
  const sqft = siteArea?.gt(AloftArea37.zero) ? siteArea.toSqFt() : AloftArea37.zero;
  return {
    siteValue: {
      totalCost: marketAdjustedSiteCost,
      sqft,
      costPerSqft: sqft.gt(AloftArea37.zero) ? marketAdjustedSiteCost.div(sqft.getUnitAmount("sqft")) : AloftPrice57.zero
    },
    siteToValueRatio: marketAdjustedTotalCost.gt(AloftPrice57.zero) ? marketAdjustedSiteCost.ratio(marketAdjustedTotalCost) : 0,
    marketAdjustment
  };
}

// src/depreciatedCost/results/internal/getTkv2PairedCostTotalsComp.ts
var import_shared_utils104 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice60 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/getCostApproach.ts
import { AloftArea as AloftArea39, AloftPrice as AloftPrice59 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/segmentToCostPerSqft.ts
import { AloftArea as AloftArea38, AloftPrice as AloftPrice58 } from "@aloft/shared-objects";
function segmentToCostPerSqft(segmentCost) {
  return {
    totalCost: segmentCost?.totalCost ?? AloftPrice58.zero,
    sqft: segmentCost?.sqft ?? AloftArea38.zero,
    costPerSqft: segmentCost?.costPerSqft ?? AloftPrice58.zero
  };
}

// src/depreciatedCost/results/internal/getCostApproach.ts
var ADD_STRUCTURE_SEGMENTS = [
  "adu",
  "attic",
  "barn",
  "belowGradeANSI",
  "bonusRoom",
  "coveredPatioOrGazebo",
  "deck",
  "enclosedPatio",
  "manual",
  "manufactured",
  "pool",
  "shed",
  "workshop"
];
function getCostApproach({
  siteValue,
  indicatedValue,
  segmentCosts,
  depreciation,
  effectiveDate,
  dwellingCostQuality
}) {
  return {
    site: siteValue,
    dwelling: segmentToCostPerSqft(segmentCosts.mainDwelling),
    basement: segmentToCostPerSqft(segmentCosts.basement),
    additionalStructures: getAdditionalStructuresCost(segmentCosts),
    garageCarport: getGarageCarportCost(segmentCosts),
    depreciation: getDepreciation(depreciation),
    indicatedValue,
    source: {
      name: "DwellingCost",
      effectiveDate
    },
    dwellingCostQuality
  };
}
function getAdditionalStructuresCost(segmentCosts) {
  return addSegments(
    ...Object.entries(segmentCosts).filter(([type, _cost]) => ADD_STRUCTURE_SEGMENTS.includes(type)).map(([_type, cost]) => cost)
  );
}
function getGarageCarportCost(segmentCosts) {
  return addSegments(
    segmentCosts.attachedOrBuiltinGarage,
    segmentCosts.detachedGarage,
    segmentCosts.carport
  );
}
function addSegments(...segmentCosts) {
  const costPerSqfts = segmentCosts.map(segmentToCostPerSqft);
  const totalCost = costPerSqfts.map((result) => result.totalCost).reduce((cost, acc) => acc.add(cost), AloftPrice59.zero);
  const sqft = costPerSqfts.map((result) => result.sqft).reduce((cost, acc) => acc.add(cost), AloftArea39.zero);
  const sqftNum = sqft.toSqFt().getUnitAmount();
  return {
    totalCost,
    sqft,
    costPerSqft: sqftNum > 0 ? totalCost.div(sqft.toSqFt().getUnitAmount()) : AloftPrice59.zero
  };
}
function getDepreciation(depreciation) {
  return {
    physical: depreciation?.physical.total,
    functional: depreciation?.functional,
    external: depreciation?.external,
    total: depreciation?.total ?? AloftPrice59.zero
  };
}

// src/depreciatedCost/results/internal/getTkv2PairedCostTotalsComp.ts
var IMPROVEMENT_ADJUSTMENT_TYPES = [
  "adu",
  "attic",
  "barn",
  "basement",
  "belowGradeANSI",
  "bonusRoom",
  "garageCarport",
  "mainDwelling",
  "manual",
  "manufactured",
  "pool",
  "porchPatioDeck",
  "shed",
  "workshop",
  "quality"
];
var IMPROVEMENT_DEPRECIATION_ADJUSTMENT_TYPES = [
  "condition",
  "functionalUtility"
];
function getTkv2PairedCostTotalsComp({
  adjustments,
  segmentCosts,
  depreciationCosts,
  siteTotals,
  salePrice,
  effectiveDate
}) {
  const netAdjustment = Object.values(adjustments).reduce(
    (net, curr) => net.add(curr.adjustment),
    AloftPrice60.zero
  );
  const grossAdjustment = Object.values(adjustments).reduce(
    (net, curr) => net.add(curr.adjustment.abs()),
    AloftPrice60.zero
  );
  const marketAdjustment = getMarketAdjustment(adjustments);
  const improvements = getImprovementsTotal(
    adjustments,
    segmentCosts,
    depreciationCosts.depreciatedCostOfImprovements
  );
  const indicatedValue = salePrice?.add(marketAdjustment) ?? AloftPrice60.zero;
  const adjustedSalePrice = salePrice?.add(netAdjustment) ?? AloftPrice60.zero;
  return {
    netAdjustment,
    netAdjustmentPercentage: (0, import_shared_utils104.isDefined)(salePrice) ? netAdjustment.ratio(salePrice) : 0,
    grossAdjustmentPercentage: (0, import_shared_utils104.isDefined)(salePrice) ? grossAdjustment.ratio(salePrice) : 0,
    adjustedSalePrice,
    marketAdjustment,
    improvements: {
      ...improvements,
      depreciated: {
        ...improvements.depreciated,
        improvementsToValueRatio: 1 - siteTotals.marketAdjusted.siteToValueRatio
      }
    },
    site: siteTotals,
    costApproach: getCostApproach({
      siteValue: siteTotals.marketAdjusted.siteValue.totalCost,
      indicatedValue,
      segmentCosts,
      depreciation: depreciationCosts,
      effectiveDate,
      dwellingCostQuality: segmentCosts.mainDwelling?.dwellingCostQuality
    })
  };
}
function getImprovementsTotal(adjustments, segmentCosts, depreciatedCost) {
  const newCost = AloftPrice60.add(...Object.values(segmentCosts).map((cost) => cost?.totalCost));
  const newAdjustment = getTotalAdjustment(adjustments, IMPROVEMENT_ADJUSTMENT_TYPES);
  const depreciationAdjustment = getTotalAdjustment(
    adjustments,
    IMPROVEMENT_DEPRECIATION_ADJUSTMENT_TYPES
  );
  return {
    new: {
      cost: newCost,
      netAdjustment: newAdjustment
    },
    depreciated: {
      cost: depreciatedCost ?? AloftPrice60.zero,
      netAdjustment: newAdjustment.add(depreciationAdjustment)
    }
  };
}
function getTotalAdjustment(adjustments, types) {
  const netAdjustment = Object.entries(adjustments).filter(([type, _adj]) => types.includes(type)).map(([_type, adj]) => adj.adjustment).reduce((total, curr) => total.add(curr), AloftPrice60.zero);
  return netAdjustment;
}
function getMarketAdjustment(adjustments) {
  return AloftPrice60.add(
    adjustments.dateOfSale.adjustmentBasis,
    adjustments.concessions.adjustmentBasis,
    adjustments.termsOfSale.adjustmentBasis
  );
}

// src/depreciatedCost/results/internal/getTkv2SegmentCosts.ts
var import_shared_utils106 = __toESM(require_lib(), 1);

// src/depreciatedCost/results/internal/getTkv2SegmentCost.ts
var import_shared_utils105 = __toESM(require_lib(), 1);
function getTkv2SegmentCost(property, segment) {
  const input = property.getEditableCostData();
  switch (segment) {
    case "mainDwelling":
      return getMainDwellingSegmentCost(property);
    case "basement":
      return getBasementSegmentCost(property);
    case "manual":
      return input.manualCost?.cost ? {
        totalCost: input.manualCost?.cost,
        sqft: void 0,
        costPerSqft: void 0,
        dwellingCostQuality: void 0
      } : void 0;
    case "manufactured":
      return getManufacturedSegmentCost(property);
    case "adu":
      return getAduSegmentCost(property);
    case "belowGradeANSI":
      return getBelowGradeANSISegmentCost(property);
    default:
      return getStructureSegmentCost(property, segment);
  }
}
function getSegmentCost(sqft, costPerSqft, dwellingCostQuality) {
  if ((0, import_shared_utils105.isUndefined)(sqft) || (0, import_shared_utils105.isUndefined)(costPerSqft)) {
    return void 0;
  }
  return {
    sqft,
    costPerSqft,
    totalCost: costPerSqft.mul(sqft.getUnitAmount("sqft")).roundToDollarLike(),
    dwellingCostQuality
  };
}
function getMainDwellingSegmentCost(property) {
  const propertyType = property.getPropertyType();
  const sqft = property.getStructuredData("gla");
  const structureType = propertyType === "manufacturedHome" ? "manufactured" : "primaryDwelling";
  const costPerSqft = property.getCostPerSqft(structureType);
  const dwellingCostQuality = property.getDwellingCostQuality(structureType);
  return getSegmentCost(sqft, costPerSqft, dwellingCostQuality);
}
function getBasementSegmentCost(property) {
  const sqft = property.getStructuredData("basementLine1")?.total;
  const costPerSqft = property.getCostPerSqft("basement");
  const dwellingCostQuality = property.getDwellingCostQuality("basement");
  return getSegmentCost(sqft, costPerSqft, dwellingCostQuality);
}
function getAduSegmentCost(property) {
  return getSegmentCost(
    property.getEditableCostData().adu.gla,
    property.getCostPerSqft("adu"),
    property.getDwellingCostQuality("adu")
  );
}
function getBelowGradeANSISegmentCost(property) {
  return getSegmentCost(
    property.getEditableCostData().primaryDwelling.nonStandardGLA,
    property.getCostPerSqft("primaryDwelling"),
    property.getDwellingCostQuality("primaryDwelling")
  );
}
function getManufacturedSegmentCost(property) {
  const propertyType = property.getPropertyType();
  if (propertyType === "manufacturedHome") {
    return void 0;
  }
  return getSegmentCost(
    property.getEditableCostData().manufactured.gla,
    property.getCostPerSqft("manufactured"),
    property.getDwellingCostQuality("manufactured")
  );
}
function getStructureSegmentCost(property, structureType) {
  return getSegmentCost(
    property.getEditableCostData()[structureType].totalSqft,
    property.getCostPerSqft(structureType),
    property.getDwellingCostQuality(structureType)
  );
}

// src/depreciatedCost/results/internal/getTkv2SegmentCosts.ts
var segmentCostTypes = [
  "adu",
  "attachedOrBuiltinGarage",
  "attic",
  "barn",
  "basement",
  "belowGradeANSI",
  "bonusRoom",
  "carport",
  "coveredPatioOrGazebo",
  "deck",
  "detachedGarage",
  "enclosedPatio",
  "mainDwelling",
  "manual",
  "manufactured",
  "pool",
  "shed",
  "workshop"
];
function getTkv2SegmentCosts(property) {
  if ((0, import_shared_utils106.isUndefined)(property)) {
    return void 0;
  }
  return Object.fromEntries(
    segmentCostTypes.map((type) => [type, getTkv2SegmentCost(property, type)])
  );
}

// src/depreciatedCost/results/internal/getPairedCostPropertyResultComp.ts
function getPairedCostPropertyResultComp({
  subject,
  comp,
  marketConditions: marketConditions2,
  effectiveDate,
  depreciationSettings,
  pairedCostSettings,
  propertyTypeSet,
  manualCostLabel,
  version,
  averageCosts
}) {
  const segmentCosts = getTkv2SegmentCosts(comp);
  if ((0, import_shared_utils107.isUndefined)(segmentCosts)) {
    return void 0;
  }
  const depreciationCosts = getDepreciationCosts({
    settings: depreciationSettings,
    propertyType: comp.getPropertyType(),
    segmentCosts,
    depreciation: comp.getEditableCostData().depreciation
  });
  const salePrice = comp.getStructuredData("salePrice") ?? AloftPrice61.zero;
  const unadjustedSiteCost = salePrice.sub(depreciationCosts.depreciatedCostOfImprovements);
  const marketAdjustment = getTotalMarketAdjustment(marketConditions2);
  const siteTotals = {
    unadjusted: {
      cost: unadjustedSiteCost
    },
    marketAdjusted: getSiteValAsOfEffectiveDate({
      unadjustedTotalCost: salePrice,
      unadjustedSiteCost,
      marketAdjustment,
      siteArea: comp.getStructuredData("siteArea")
    })
  };
  const subjectValues = getSubjectValues(subject, depreciationSettings);
  if ((0, import_shared_utils107.isUndefined)(subjectValues)) {
    return void 0;
  }
  const adjustments = getPairedCostAdjustments({
    subject: subjectValues,
    comp: {
      segmentCosts,
      depreciationCosts,
      mainDwellingQuality: comp.getEditableCostData().primaryDwelling.quality,
      marketConditions: marketConditions2,
      siteTotals,
      siteSize: comp.getStructuredData("siteArea"),
      bathCounts: comp.getBathroomCounts(),
      garageStallCount: comp.getGarageStallCount()
    },
    pairedCostSettings,
    manualCostLabel,
    version,
    averageCosts
  });
  const features = getTkv2PairedCostFeatures({
    property: comp,
    segmentCosts,
    depreciationCosts,
    effectiveDate,
    adjustments,
    siteValueAsOfEffDate: siteTotals.marketAdjusted,
    propertyTypeSet,
    depreciatedBathroomCosts: subjectValues.depreciatedBathroomCosts,
    version
  });
  const totals = getTkv2PairedCostTotalsComp({
    adjustments,
    segmentCosts,
    depreciationCosts,
    siteTotals,
    salePrice,
    effectiveDate
  });
  return {
    features,
    segmentCosts,
    depreciationCosts,
    adjustments,
    totals
  };
}
function getTotalMarketAdjustment(marketConditions2) {
  return Object.values(marketConditions2 ?? {}).reduce(
    (acc, adj) => acc.add(adj?.adjustmentAmount),
    AloftPrice61.zero
  );
}
function getSubjectValues(subject, depreciationSettings) {
  const segmentCosts = getTkv2SegmentCosts(subject);
  if ((0, import_shared_utils107.isUndefined)(segmentCosts)) {
    return void 0;
  }
  const depreciationCosts = getDepreciationCosts({
    settings: depreciationSettings,
    propertyType: subject.getPropertyType(),
    segmentCosts,
    depreciation: subject.getEditableCostData().depreciation
  });
  const siteCost = subject._getCostDataExtension()?.siteCost;
  const siteSizeSqft = subject.getStructuredData("siteArea")?.getUnitAmount("sqft") ?? 0;
  const siteCostPerSqft = siteSizeSqft === 0 ? AloftPrice61.zero : siteCost?.div(siteSizeSqft) ?? AloftPrice61.zero;
  if ((0, import_shared_utils107.isUndefined)(segmentCosts)) {
    return void 0;
  }
  return {
    segmentCosts,
    siteCost,
    siteCostPerSqft,
    mainDwellingQuality: subject.getEditableCostData().primaryDwelling.quality,
    depreciationCosts,
    bathCounts: subject.getBathroomCounts(),
    depreciatedBathroomCosts: getDepreciatedBathroomCosts(
      subject.getBathroomCosts(),
      depreciationCosts.physical.segments.mainDwelling?.depreciationRatio
    ),
    garageStallCount: subject.getGarageStallCount()
  };
}

// src/depreciatedCost/results/internal/getPairedCostPropertyResultSubject.ts
var import_shared_utils108 = __toESM(require_lib(), 1);

// src/depreciatedCost/results/internal/getTkv2PairedCostTotalsSubject.ts
import { AloftPrice as AloftPrice63 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/getImprovementCostNew.ts
import { AloftPrice as AloftPrice62 } from "@aloft/shared-objects";
function getImprovementCostNew(segmentCosts) {
  return AloftPrice62.add(...Object.values(segmentCosts).map((cost) => cost?.totalCost));
}

// src/depreciatedCost/results/internal/getTkv2PairedCostTotalsSubject.ts
function getTkv2PairedCostTotalsSubject({
  segmentCosts,
  siteValueAsOfEffDate,
  depreciationCosts,
  siteArea,
  effectiveDate
}) {
  const newCost = getImprovementCostNew(segmentCosts);
  const depreciatedCost = depreciationCosts?.depreciatedCostOfImprovements ?? AloftPrice63.zero;
  const indicatedValue = getIndicatedValueForSubject(
    depreciatedCost,
    siteValueAsOfEffDate ?? AloftPrice63.zero
  );
  const site = getSiteValAsOfEffectiveDate({
    unadjustedTotalCost: indicatedValue,
    unadjustedSiteCost: siteValueAsOfEffDate ?? AloftPrice63.zero,
    marketAdjustment: void 0,
    siteArea
  });
  return {
    netAdjustment: void 0,
    netAdjustmentPercentage: void 0,
    grossAdjustmentPercentage: void 0,
    adjustedSalePrice: void 0,
    marketAdjustment: void 0,
    improvements: {
      new: {
        cost: newCost,
        netAdjustment: void 0
      },
      depreciated: {
        cost: depreciatedCost,
        improvementsToValueRatio: 1 - site.siteToValueRatio,
        netAdjustment: void 0
      }
    },
    site: {
      unadjusted: {
        cost: void 0
      },
      marketAdjusted: site
    },
    costApproach: getCostApproach({
      siteValue: siteValueAsOfEffDate ?? AloftPrice63.zero,
      indicatedValue,
      segmentCosts,
      depreciation: depreciationCosts,
      effectiveDate,
      dwellingCostQuality: segmentCosts.mainDwelling?.dwellingCostQuality
    })
  };
}
function getIndicatedValueForSubject(depreciatedCostOfImprovements, siteValueAsOfEffDate) {
  return depreciatedCostOfImprovements.add(siteValueAsOfEffDate);
}

// src/depreciatedCost/results/internal/getPairedCostPropertyResultSubject.ts
function getPairedCostPropertyResultSubject({
  depreciationSettings,
  subject,
  effectiveDate,
  propertyTypeSet,
  version
}) {
  const segmentCosts = getTkv2SegmentCosts(subject);
  if ((0, import_shared_utils108.isUndefined)(segmentCosts)) {
    return void 0;
  }
  const depreciationCosts = getDepreciationCosts({
    settings: depreciationSettings,
    propertyType: subject.getPropertyType(),
    segmentCosts,
    depreciation: subject.getEditableCostData().depreciation
  });
  const totals = getTkv2PairedCostTotalsSubject({
    segmentCosts,
    siteValueAsOfEffDate: subject._getCostDataExtension()?.siteCost,
    depreciationCosts,
    siteArea: subject.getStructuredData("siteArea"),
    effectiveDate
  });
  return {
    features: getTkv2PairedCostFeatures({
      property: subject,
      effectiveDate,
      segmentCosts,
      depreciationCosts,
      adjustments: void 0,
      siteValueAsOfEffDate: totals.site.marketAdjusted,
      propertyTypeSet,
      depreciatedBathroomCosts: getDepreciatedBathroomCosts(
        subject.getBathroomCosts(),
        depreciationCosts.physical.segments.mainDwelling?.depreciationRatio
      ),
      version
    }),
    segmentCosts,
    depreciationCosts,
    adjustments: void 0,
    totals
  };
}

// src/depreciatedCost/results/internal/getTkv2PairedCostAdjustmentLabels.ts
function getTkv2PairedCostAdjustmentLabels(subjectProperty, propertyTypeSet, version) {
  return {
    dateOfSale: "Date of Sale",
    concessions: "Financial Concessions",
    termsOfSale: "Terms of Sale",
    functionalUtility: "Functional Utility",
    externalObsolescence: "External Obsolescence",
    quality: "Quality",
    condition: "Condition",
    mainDwelling: getMainDwellingLabel(propertyTypeSet, version),
    bathAboveGrade: "Bath Count (Above Grade)",
    bathBelowGrade: "Bath Count (Below Grade)",
    garageCarport: "Garage / Carport",
    basement: "Basement",
    manual: subjectProperty.getEditableCostData().manualCost?.label ?? "Additional Features",
    adu: "Guest House",
    attic: "Attic",
    fireplace: "Fireplace",
    barn: "Barn",
    bonusRoom: "Bonus Room",
    porchPatioDeck: "Porch/Patio/Deck",
    pool: "Pool",
    shed: "Shed",
    workshop: "Workshop",
    manufactured: "Mfd. Dwelling",
    belowGradeANSI: "Below Grade (per ANSI)",
    site: version === "simplified_v1" ? "Site size" : "Site size, Location & View",
    locationView: "Location & View",
    foundation: "Foundation",
    units: "Number of Units"
  };
}
function getMainDwellingLabel(propertyTypeSet, version) {
  const isLegacy = version === "legacy";
  if (propertyTypeSet.size > 1) {
    return isLegacy ? "Square Feet, Baths & Property Type" : "Square Feet";
  }
  if (propertyTypeSet.has("manufacturedHome")) {
    return isLegacy ? "GLA, Baths, Sections & Foundation" : "GLA";
  }
  if (propertyTypeSet.has("multiFamily")) {
    return isLegacy ? "GBA, Baths, Stories & No. of Units" : "GBA";
  }
  return isLegacy ? "GLA, Baths & Stories" : "GLA";
}

// src/depreciatedCost/results/internal/getTkv2PairedCostSegmentLabels.ts
function getTkv2PairedCostSegmentLabels(subjectProperty) {
  return {
    basement: "Basement",
    attic: "Attic",
    attachedOrBuiltinGarage: "Attached Garage",
    detachedGarage: "Detached Garage",
    carport: "Carport",
    deck: "Deck",
    coveredPatioOrGazebo: "Cvd Patio / Gazebo",
    enclosedPatio: "Enclosed Patio",
    pool: "Pool",
    adu: "Guest House / ADU",
    shed: "Shed",
    workshop: "Workshop",
    bonusRoom: "Bonus Room",
    barn: "Barn",
    manufactured: "Mfd. Dwelling",
    mainDwelling: "Dwelling",
    // TODO: update based on mix of property types
    belowGradeANSI: "Below Grade (per ANSI)",
    manual: subjectProperty.getEditableCostData().manualCost?.label ?? "Additional Feature"
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/averages/getAverageCosts.ts
var import_shared_utils112 = __toESM(require_lib(), 1);

// src/depreciatedCost/results/internal/simplifiedv1/averages/internal/getAverageCostsBasement.ts
var import_shared_utils110 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice65 } from "@aloft/shared-objects";

// src/depreciatedCost/results/internal/simplifiedv1/averages/internal/getAverageCostResult.ts
var import_shared_utils109 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice64 } from "@aloft/shared-objects";
function getAverageCostResult(costs) {
  const nonZeroCosts = costs.filter(import_shared_utils109.isDefined).filter((price) => price.gt(AloftPrice64.zero));
  if (nonZeroCosts.length === 0) {
    return void 0;
  }
  const minCost = (0, import_shared_utils109.expected)(
    nonZeroCosts.reduce((acc, cost) => {
      if ((0, import_shared_utils109.isUndefined)(acc)) {
        return cost;
      }
      if (cost.le(acc)) {
        return cost;
      }
      return acc;
    }, void 0)
  );
  const maxCost = (0, import_shared_utils109.expected)(
    nonZeroCosts.reduce((acc, cost) => {
      if ((0, import_shared_utils109.isUndefined)(acc)) {
        return cost;
      }
      if (cost.gt(acc)) {
        return cost;
      }
      return acc;
    }, void 0)
  );
  const averageCost = AloftPrice64.add(...nonZeroCosts).div(nonZeroCosts.length);
  return {
    minCost: roundAndThreshold(minCost),
    maxCost: roundAndThreshold(maxCost),
    averageCost: roundAndThreshold(averageCost)
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/averages/internal/getAverageSegmentCosts.ts
function getAverageSegmentCosts(properties, segmentType) {
  return getAverageCostResult(
    properties.map((prop) => prop.costs[segmentType]?.depreciatedCost.totalCost)
  );
}

// src/depreciatedCost/results/internal/simplifiedv1/averages/internal/getAverageCostsBasement.ts
function getAverageCostsBasement(properties) {
  const result = getAverageSegmentCosts(properties, "basement");
  if ((0, import_shared_utils110.isUndefined)(result)) {
    return void 0;
  }
  const propsWithBasements = properties.filter(
    (prop) => prop.costs.basement?.depreciatedCost.totalCost.gt(AloftPrice65.zero)
  );
  const averageCostPerSqft = propsWithBasements.length > 0 ? AloftPrice65.add(
    ...propsWithBasements.map((prop) => prop.costs.basement?.depreciatedCost.costPerSqft)
  ).div(propsWithBasements.length) : void 0;
  return { ...result, averageCostPerSqft };
}

// src/depreciatedCost/results/internal/simplifiedv1/averages/internal/getAverageCostsGarageStall.ts
var import_shared_utils111 = __toESM(require_lib(), 1);
import { AloftPrice as AloftPrice66 } from "@aloft/shared-objects";
function getAverageCostsGarageStall(properties) {
  return getAverageCostResult(
    properties.map((propertyData) => {
      const { prop, costs } = propertyData;
      const carStorage = prop.getStructuredData("carStorage");
      if ((0, import_shared_utils111.isUndefined)(carStorage)) {
        return void 0;
      }
      const stallCount = prop.getGarageStallCount();
      if (stallCount === 0) {
        return void 0;
      }
      const totalCost = AloftPrice66.add(
        costs.attachedOrBuiltinGarage?.depreciatedCost.totalCost,
        costs.detachedGarage?.depreciatedCost.totalCost,
        costs.carport?.depreciatedCost.totalCost
      );
      const costPerStall = totalCost.div(stallCount);
      return costPerStall;
    })
  );
}

// src/depreciatedCost/results/internal/simplifiedv1/averages/internal/getAverageCostsPorchPatioDeck.ts
import { AloftPrice as AloftPrice67 } from "@aloft/shared-objects";
function getAverageCostsPorchPatioDeck(properties) {
  return getAverageCostResult(
    properties.map((prop) => {
      const { costs } = prop;
      return AloftPrice67.add(
        costs.deck?.depreciatedCost.totalCost,
        costs.coveredPatioOrGazebo?.depreciatedCost.totalCost,
        costs.enclosedPatio?.depreciatedCost.totalCost
      );
    })
  );
}

// src/depreciatedCost/results/internal/simplifiedv1/averages/internal/getAverageSiteValue.ts
import { AloftPrice as AloftPrice68 } from "@aloft/shared-objects";
function getAverageSiteValue(subject) {
  const siteCost = subject._getCostDataExtension()?.siteCost ?? AloftPrice68.zero;
  const siteSize = subject.getStructuredData("siteArea")?.getUnitAmount("sqft") ?? 0;
  const siteCostPerSqft = siteSize > 0 ? siteCost?.div(siteSize) : AloftPrice68.zero;
  return {
    averageCost: siteCostPerSqft,
    minCost: siteCostPerSqft,
    maxCost: siteCostPerSqft
  };
}

// src/depreciatedCost/results/internal/simplifiedv1/averages/getAverageCosts.ts
function getAverageCosts(subject, comps, depreciationSettings) {
  const properties = [subject, ...Object.values(comps)].map((prop) => getPropertyData(prop, depreciationSettings)).filter(import_shared_utils112.isDefined);
  return {
    site: getAverageSiteValue(subject),
    garageStall: getAverageCostsGarageStall(properties),
    porchPatioDeck: getAverageCostsPorchPatioDeck(properties),
    basement: getAverageCostsBasement(properties),
    attic: getAverageSegmentCosts(properties, "attic"),
    pool: getAverageSegmentCosts(properties, "pool"),
    adu: getAverageSegmentCosts(properties, "adu"),
    shed: getAverageSegmentCosts(properties, "shed"),
    workshop: getAverageSegmentCosts(properties, "workshop"),
    bonusRoom: getAverageSegmentCosts(properties, "bonusRoom"),
    barn: getAverageSegmentCosts(properties, "barn"),
    manufactured: getAverageSegmentCosts(properties, "manufactured"),
    belowGradeANSI: getAverageSegmentCosts(properties, "belowGradeANSI")
  };
}
function getPropertyData(prop, depreciationSettings) {
  const segmentCosts = getTkv2SegmentCosts(prop);
  if ((0, import_shared_utils112.isUndefined)(segmentCosts)) {
    return void 0;
  }
  const depreciationCosts = getDepreciationCosts({
    settings: depreciationSettings,
    propertyType: prop.getPropertyType(),
    segmentCosts,
    depreciation: prop.getEditableCostData().depreciation
  });
  return { prop, costs: depreciationCosts.physical.segments };
}

// src/depreciatedCost/results/getPairedCostResults.ts
function getPairedCostResults({
  subject,
  comps,
  compsMC,
  compSeq,
  effectiveDate,
  depreciationSettings,
  pairedCostSettings,
  version
}) {
  const propertyTypeSet = getPropertyTypeSet(subject, comps, compSeq);
  const segmentLabels = getTkv2PairedCostSegmentLabels(subject);
  const averageCosts = getAverageCosts(subject, comps, depreciationSettings);
  const compResults = Object.fromEntries(
    compSeq.map((compID) => {
      const comp = comps[compID];
      if ((0, import_shared_utils113.isUndefined)(comp)) {
        return void 0;
      }
      return [
        compID,
        getPairedCostPropertyResultComp({
          subject,
          comp,
          marketConditions: compsMC[compID],
          effectiveDate,
          depreciationSettings,
          pairedCostSettings,
          propertyTypeSet,
          manualCostLabel: segmentLabels.manual,
          version,
          averageCosts
        })
      ];
    }).filter(import_shared_utils113.isDefined)
  );
  const subjectResult = getPairedCostPropertyResultSubject({
    subject,
    effectiveDate,
    depreciationSettings,
    propertyTypeSet,
    version
  });
  return {
    depreciationSettingsUsed: depreciationSettings,
    subject: subjectResult,
    comps: compResults,
    adjustmentLabels: getTkv2PairedCostAdjustmentLabels(subject, propertyTypeSet, version),
    segmentLabels,
    adjustmentSummaries: getAdjustmentSummaries(averageCosts, subjectResult, version)
  };
}

// src/depreciationSettingsV2/consts.ts
var defaultDepreciationSettingsV2 = {
  depreciateSeparately: false,
  enableFunctionalDepreciation: false,
  enableExternalDepreciation: false
};

// src/dwellingCost/dwellingCostEnums.ts
var dwellingCostEnums = {
  DwellingQualityRatingCode: {
    values: [
      "1",
      "1.5",
      "2",
      "2.5",
      "3",
      "3.5",
      "4",
      "4.5",
      "5",
      "5.5",
      "6",
      "6.5",
      "7",
      "7.5",
      "8"
    ],
    allowOther: false
  },
  BasementQualityRatingCode: {
    values: ["1", "2", "3", "4", "5", "6", "7", "8"],
    allowOther: false
  },
  AtticQualityRatingCode: {
    values: ["1", "2", "3", "4", "5", "6", "7", "8"],
    allowOther: false
  },
  GarageQualityRatingCode: {
    values: ["1", "2", "3", "4", "5", "6", "7", "8"],
    allowOther: false
  },
  DeckOrPatioQualityRatingCode: {
    values: ["1", "2", "3", "4"],
    allowOther: false
  },
  AduQualityRatingCode: {
    values: ["1", "2", "3", "4", "5", "6", "7", "8"],
    allowOther: false
  },
  ShedQualityRatingCode: {
    values: ["1", "2", "3", "4", "5"],
    allowOther: false
  },
  WorkshopQualityRatingCode: {
    values: ["1", "2", "3", "4", "5"],
    allowOther: false
  },
  BonusRoomQualityRatingCode: {
    values: ["1", "2", "3", "4", "5"],
    allowOther: false
  },
  BarnQualityRatingCode: {
    values: ["1", "2", "3", "4", "5"],
    allowOther: false
  },
  ManufacturedQualityRatingCode: {
    values: ["1", "2", "3", "4", "5", "6"],
    allowOther: false
  },
  ManufacturedFoundationType: {
    values: ["Permanent or Concrete", "Non-Permanent"],
    allowOther: false
  },
  ManufacturedFireplaceType: {
    values: ["Built-In", "Freestanding"],
    allowOther: false
  },
  PoolQualityRatingCode: {
    values: ["1", "2", "3", "4", "5", "6"],
    allowOther: false
  }
};

// src/featureDecisions/decisions.ts
var Decisions = (0, import_enum.AloftEnum)()({
  shouldAllowTrialWithoutPayment(client) {
    return client.isEnabled("TRIAL_WITHOUT_PAYMENT");
  },
  shouldShowOffshoreQCBeta(client) {
    return client.isEnabled("OFFSHORE_QC_BETA");
  },
  shouldShowRecommendedCompsFiltering(client) {
    return client.isEnabled("RECOMMENDED_COMPS_FILTERING");
  },
  shouldShowFeatureGrid(client) {
    return client.isEnabled("SHOW_SALES_COMPARISON_GRID");
  },
  shouldShowAdjustmentsGrid(client) {
    return client.isEnabled("SHOW_ADJUSTMENTS_GRID");
  },
  shouldShowOrderDetails(client) {
    return client.isEnabled("SHOW_ORDER_DETAILS");
  },
  shouldShowCommentaryBeta(client) {
    return client.isEnabled("SHOW_COMMENTARY_BETA");
  },
  shouldShowSiteValueAdjuster(client) {
    return client.isEnabled("SHOW_SITE_VALUE_ADJUSTER");
  },
  shouldShowCreateInspectifyOrderModal(client) {
    return client.isEnabled("CREATE_INSPECTIFY_ORDER_MODAL");
  }
});

// src/featureDecisions/types.ts
function isDecisionKey(x) {
  return Decisions._keys.includes(x);
}

// src/featureDecisions/index.ts
function createFeatureDecisions(client) {
  const res = {};
  for (const key of Decisions._keys) {
    const getDecision = () => Decisions[key](client);
    res[key] = getDecision;
  }
  return res;
}

// src/featureFlagService/index.ts
var featureFlags = {
  TRIAL_WITHOUT_PAYMENT: "subscription_trial_without_payment",
  OFFSHORE_QC_BETA: "offshore_quality_control_beta",
  RECOMMENDED_COMPS_FILTERING: "recommended_comps_filtering",
  SHOW_SALES_COMPARISON_GRID: "show_sales_comparison_grid",
  SHOW_ADJUSTMENTS_GRID: "show_adjustments_grid",
  SHOW_ORDER_DETAILS: "show_order_details",
  SHOW_COMMENTARY_BETA: "show_commentary_beta",
  SHOW_SITE_VALUE_ADJUSTER: "show_site_value_adjuster",
  CREATE_INSPECTIFY_ORDER_MODAL: "create_inspectify_order_modal"
};
var featureFlagFallbacks = {
  TRIAL_WITHOUT_PAYMENT: false,
  OFFSHORE_QC_BETA: false,
  RECOMMENDED_COMPS_FILTERING: false,
  SHOW_SALES_COMPARISON_GRID: false,
  SHOW_ADJUSTMENTS_GRID: false,
  SHOW_COMMENTARY_BETA: false,
  SHOW_ORDER_DETAILS: false,
  SHOW_SITE_VALUE_ADJUSTER: false,
  CREATE_INSPECTIFY_ORDER_MODAL: false
};
var FeatureFlagClient = class {
};
var FeatureFlagClientImpl = class {
  _getUserID;
  _instance;
  _log;
  userAttributes;
  constructor(client, getUserID, log, environment) {
    this._instance = client;
    this._getUserID = getUserID;
    this._log = log;
    this.userAttributes = {
      isBeta: environment === "beta",
      isLocal: environment === "local",
      isProd: environment === "prod"
    };
  }
  isValidInstance() {
    const instance = this._instance;
    return typeof instance.isValidInstance === "function" ? instance.isValidInstance() : false;
  }
  isNull() {
    return false;
  }
  isEnabled(flagKey) {
    const fallback = featureFlagFallbacks[flagKey];
    const userId = this._getUserID();
    if (!userId) {
      this._log.error(
        `userID not available from getUserID. Cannot determine feature eligibility, defaulting to ${fallback}`
      );
      return fallback;
    }
    if (!this.isValidInstance()) {
      return fallback;
    }
    const flag = this.getFlagID(flagKey);
    if (flag === void 0)
      return false;
    return this._instance.isFeatureEnabled(flag, userId, {
      ...this.userAttributes,
      userId
    });
  }
  getFlagID(flagKey) {
    const flagID = featureFlags[flagKey];
    if (!flagID) {
      this._log.error(
        `flag with key ${flagKey} was not found. did you forget to update featureFlags map?`
      );
      return void 0;
    }
    return flagID;
  }
};
var FeatureFlagClientNullImpl = class {
  _log;
  constructor(log) {
    this._log = log;
  }
  warnAboutNullness() {
    this._log.error("no feature flag service available. this is a noop");
  }
  getFlagID() {
    this.warnAboutNullness();
    return void 0;
  }
  isEnabled(flag) {
    this.warnAboutNullness();
    return featureFlagFallbacks[flag];
  }
  isNull() {
    this.warnAboutNullness();
    return true;
  }
};

// src/filterType.ts
function filterType(pred, value) {
  return pred(value) ? value : void 0;
}

// src/format.ts
import { AloftPrice as AloftPrice69 } from "@aloft/shared-objects";
var format = {
  percent: (x, fractionDigits = 1) => {
    return typeof x === "number" ? (x * 100).toFixed(fractionDigits) + "%" : void 0;
  },
  priceRounded: (x) => {
    return AloftPrice69.isAloftPrice(x) ? x.toString(true) : x?.toString();
  }
};

// src/guid.ts
var HEX_CHARSET = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F"
];
var ALPHA_CHARSET = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
];
var guid = (length = 8) => `${new Array(2).fill(0).map(() => ALPHA_CHARSET[Math.floor(Math.random() * 26)]).join("")}-${new Array(length).fill(0).map(() => HEX_CHARSET[Math.floor(Math.random() * 16)]).join("")}`;

// src/isTrainingModeEnabled.ts
function isTrainingModeEnabled({ email }) {
  return /^training\d{2}@aloft\.us$/.test(email);
}

// src/logging/constants.ts
var REQUEST_ID_HEADER = "x-request-id";
var REQUEST_SESSION_ID_HEADER = "x-session-id";

// src/marketAdjustments/makeCustomMonthlyPriceTrends.ts
function makeCustomMonthlyPriceTrends({
  effectiveDate,
  analysisPeriod: passedAnalysisPeriod,
  initialValue
}) {
  const analysisPeriod = schAnalysisPeriod.parse(passedAnalysisPeriod);
  const trends = [];
  for (let i = analysisPeriod - 1; i >= 0; i--) {
    const month = effectiveDate.subtractMonths(i);
    const monthAsISOMonth = fnma_exports.aloftDateToIsoMonth(month);
    const value = typeof initialValue === "function" ? initialValue(monthAsISOMonth) : initialValue;
    trends.push({
      month: monthAsISOMonth,
      value
    });
  }
  return trends;
}

// src/math/assertAllFinite.ts
function assertAllFinite(numbers) {
  if (!numbers.every(Number.isFinite)) {
    throw new Error("please filter or convert NaNs and infinities before calling");
  }
}

// src/math/mean.ts
function mean(data, dfl = NaN) {
  const res = [...data];
  assertAllFinite(res);
  const numbersCount = res.length;
  if (!numbersCount) {
    return dfl;
  }
  const sum = res.reduce((acc, current) => acc + current, 0);
  return sum / numbersCount;
}

// src/math/median.ts
var import_shared_utils114 = __toESM(require_lib(), 1);
function median(data, dfl = NaN) {
  const res = [...data];
  assertAllFinite(res);
  if (res.length === 0) {
    return dfl;
  }
  res.sort((a, b) => a - b);
  const middle = Math.floor(res.length / 2);
  if (res.length % 2 === 0) {
    return ((0, import_shared_utils114.expected)(res[middle - 1]) + (0, import_shared_utils114.expected)(res[middle])) / 2;
  } else {
    return (0, import_shared_utils114.expected)(res[middle]);
  }
}

// src/math/roundTo.ts
function roundTo(x, to) {
  return Math.round(x / to) * to;
}

// src/mlsAttribution.ts
var MLSAttributionMap = {
  CRMLS: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information from California Regional Multiple Listing Service, Inc. as of ${dateStr} and/or other sources. All data, including all measurements and calculations of area, is obtained from various sources and has not been, and will not be, verified by broker or MLS. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000093.png"
  },
  TriangleMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Listings marked with an icon are provided courtesy of the Triangle MLS, Inc. of North Carolina, Internet Data Exchange Database. Information Not Guaranteed. Copyright ${yearStr} Triangle MLS, Inc. of North Carolina. All rights reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000389.gif"
  },
  CanopyMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Listings courtesy of Canopy MLS as distributed by MLS GRID. Based on information submitted to the MLS GRID. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information. Listing information is provided for consumers' personal, non-commercial use, solely to identify prospective properties for potential purchase; all other use is strictly prohibited and may violate relevant federal and state law. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} MLS GRID. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000391.jpg"
  },
  REColorado: {
    disclaimer: function() {
      const brokerage = `Dierk Herberman (Kentwood)`;
      return `The content relating to real estate for sale in this Web site comes in part from the Internet Data eXchange (\u201CIDX\u201D) program of METROLIST, INC., DBA RECOLORADO\xAE Real estate listings held by brokers other than ${brokerage} are marked with the IDX Logo. This information is being provided for the consumers\u2019 personal, non-commercial use and may not be used for any other purpose. All information subject to change and should be independently verified.

            This publication is designed to provide information with regard to the subject matter covered. It is displayed with the understanding that the publisher and authors are not engaged in rendering real estate, legal, accounting, tax, or other professional services and that the publisher and authors are not offering such advice in this publication. If real estate, legal, or other expert assistance is required, the services of a competent, professional person should be sought.

            The information contained in this publication is subject to change without notice. METROLIST, INC., DBA RECOLORADO MAKES NO WARRANTY OF ANY KIND WITH REGARD TO THIS MATERIAL, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. METROLIST, INC., DBA RECOLORADO SHALL NOT BE LIABLE FOR ERRORS CONTAINED HEREIN OR FOR ANY DAMAGES IN CONNECTION WITH THE FURNISHING, PERFORMANCE, OR USE OF THIS MATERIAL.

            PUBLISHER'S NOTICE:
            All real estate advertised herein is subject to the Federal Fair Housing Act and the Colorado Fair Housing Act, which Acts make it illegal to make or publish any advertisement that indicates any preference, limitation, or discrimination based on race, color, religion, sex, handicap, familial status, or national origin.

            METROLIST, INC., DBA RECOLORADO will not knowingly accept any advertising for real estate that is in violation of the law. All persons are hereby informed that all dwellings advertised are available on an equal opportunity basis.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000116.png"
  },
  SanAntonio: {
    disclaimer: function(listingData) {
      const brokerage = `Brian Travis Johnson (BHHS Don Johnson, REALTORS)`;
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the Internet Data exchange (IDX) program of the San Antonio Board of REALTORS\xAE. IDX information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Real estate listings held by brokerage firms other than ${brokerage}, are indicated by detailed information about them such as the name of the listing firms. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} San Antonio Board of REALTORS\xAE. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000616.png"
  },
  MLSOK: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Copyright \xA9 ${yearStr} MLSOK, Inc. We do not attempt to verify the currency, completeness, accuracy or authenticity of the data contained herein. Information is subject to verification by all parties and is subject to transcription and transmission errors. All information is provided "as is". The listing information provided is for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective purchasers. This data is copyrighted and may not be transmitted, retransmitted, copied, framed, repurposed, or altered in any way for any other site, individual and/or purpose without the express written permission of MLSOK, Inc. Copyright \xA9 ${yearStr} MLSOK, Inc. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000519.jpg"
  },
  CentralTexas: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Information is provided exclusively for consumers personal, non - commerical use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Copyright ${yearStr}, Central Texas Board of REALTORS`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000610.png"
  },
  GeorgiaMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this web site comes in part from the Broker Reciprocity Program of GAMLS. All real estate listings are marked with the GAMLS Broker Reciprocity thumbnail logo and detailed information about them includes the name of the listing brokers. The broker providing these data believes them to be correct, but advises interested parties to confirm them before relying on them in a purchase decision. Copyright \xA9 ${yearStr} GAMLS. All rights reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000188.png"
  },
  NABOR: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The source of this real property information is the copyrighted and proprietary database compilation of the M.L.S. of Naples, Inc. Copyright ${yearStr} M.L.S. of Naples, Inc. All rights reserved. The accuracy of this information is not warranted or guaranteed. This information should be independently verified if any person intends to engage in a transaction in reliance upon it.

            The listing broker\u2019s offer of compensation is made only to participants of the MLS where the listing is filed.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000822.gif"
  },
  SWMRIC: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Information is deemed reliable but not guaranteed. Copyright ${yearStr} MichRIC, LLC. All rights reserved.`;
    },
    logoURL: "http://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000329.png"
  },
  Realtracs: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information submitted to the MLS GRID as of ${dateStr}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000574.jpg"
  },
  GSREIN: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Information contained on this site is believed to be reliable; yet, users of this web site are responsible for checking the accuracy, completeness, currency, or suitability of all information. Neither the New Orleans Metropolitan Association of REALTORS\xAE, Inc. nor the Gulf South Real Estate Information Network, Inc. makes any representation, guarantees, or warranties as to the accuracy, completeness, currency, or suitability of the information provided. They specifically disclaim any and all liability for all claims or damages that may result from providing information to be used on the web site, or the information which it contains, including any web sites maintained by third parties, which may be linked to this web site. The information being provided is for the consumer\u2019s personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties which consumers may be interested in purchasing. The user of this site is granted permission to copy a reasonable and limited number of copies to be used in satisfying the purposes identified in the preceding sentence. By using this site, you signify your agreement with and acceptance of these terms and conditions. If you do not accept this policy, you may not use this site in any way. Your continued use of this site, and/or its affiliates\u2019 sites, following the posting of changes to these terms will mean you accept those changes, regardless of whether you are provided with additional notice of such changes. Copyright ${yearStr} New Orleans Metropolitan Association of REALTORS\xAE, Inc. All rights reserved. The sharing of MLS database, or any portion thereof, with any unauthorized third party is strictly prohibited.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000302.jpg"
  },
  REBNY: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Listing information for certain New York City properties provided courtesy of the Real Estate Board of New York\u2019s Residential Listing Service (the "RLS"). The information contained in this listing has not been verified by the RLS and should be verified by the consumer. The listing information provided here is for the consumer\u2019s personal, non-commercial use. Retransmission, redistribution or copying of this listing information is strictly prohibited except in connection with a consumer's consideration of the purchase and/or sale of an individual property. This listing information is not verified for authenticity or accuracy and is not guaranteed and may not reflect all real estate activity in the market. \xA9${yearStr} The Real Estate Board of New York, Inc., all rights reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/T00000046.png"
  },
  RealMLS: {
    disclaimer: function(listingData) {
      const brokerage = `Ann King (BHHS Florida Network Realty)`;
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the Internet Data Exchange (IDX) program of the Northeast Florida Multiple Listing Service, Inc. Real estate listings held by brokerage firms other than ${brokerage} are marked with the listing broker's name and detailed information about such listings includes the name of the listing brokers.

            Data provided is deemed reliable but is not guaranteed. The data relating to real estate for sale on this website comes in part from the Northeast Florida Multiple Listing Service, Inc. The information being provided is for consumers personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} Northeast Florida Multiple Listing Service, Inc. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000141.png"
  },
  IRMLS: {
    disclaimer: function(listingData) {
      const brokerage = `Craig West (BHHS Indiana)`;
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the Internet Data exchange (IDX) program of the Indiana Regional MLS LLC\xAE. IDX information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Real estate listings held by brokerage firms other than ${brokerage}, are indicated by detailed information about them such as the name of the listing firms. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} Indiana Regional MLS LLC\xAE. All Rights Reserved.`;
    },
    logoURL: "http://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000256.png"
  },
  MLSTechnology: {
    disclaimer: function() {
      return "IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed.";
    },
    logoURL: "http://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000521.png"
  },
  Knoxville: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed. Copyright ${yearStr} Knoxville Area Association of REALTORS.`;
    },
    logoURL: void 0
  },
  MRED: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information submitted to the MLS GRID as of ${dateStr}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000243.png"
  },
  BrightMLS: {
    disclaimer: function(listingData) {
      const brokerage = `John Nicolas D'Ambrosia (Long & Foster)`;
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website appears in part through the BRIGHT Internet Data Exchange program, a voluntary cooperative exchange of property listing data between licensed real estate brokerage firms in which ${brokerage} participates, and is provided by BRIGHT through a licensing agreement. The information provided by this website is for the personal, non-commercial use of consumers and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Some properties which appear for sale on this website may no longer be available because they are under contract, have closed or are no longer being offered for sale. Information Deemed Reliable But Not Guaranteed. Copyright \xA9 ${yearStr} Bright MLS. All rights reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000309.jpg"
  },
  NorthCarolinaRegional: {
    disclaimer: function(listingData) {
      const brokerage = `John Nicolas D'Ambrosia (Long & Foster)`;
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate on this website comes in part from the Internet Data Exchange program of North Carolina Regional MLS LLC. All information is deemed reliable but not guaranteed and should be independently verified. All properties are subject to prior sale, change, or withdrawal. Neither listing broker(s) nor ${brokerage} shall be responsible for any typographical errors, misinformation, or misprints, and shall be held totally harmless from any damages arising from reliance upon these data. Copyright \xA9 ${yearStr} North Carolina Regional MLS LLC. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000722.png"
  },
  Austin: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information submitted to the MLS GRID as of ${dateStr}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000589.png"
  },
  Metrolist: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this site comes in part from the Broker Reciprocity/IDX program of MetroList Services, Inc. Information provided is thought to be reliable but is not guaranteed to be accurate; you are advised to verify facts that are important to you. No warranties, expressed or implied, are provided for the data herein, or for their use or interpretation by the user. MetroList Services does not create, control or review the property data displayed herein and take no responsibility for the content of such records. Federal law prohibits discrimination on the basis of race, color, religion, sex, handicap, familial status or national origin in the sale, rental or financing of housing. The information being provided is for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. All measurements and all calculations of area (i.e., Sq Ft and Acreage) are approximate. Broker has represented to MetroList that Broker has a valid listing signed by seller authorizing placement in the MLS. Above information is provided by Seller and/or other sources and has not been verified by Broker. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} MetroList Services, Inc.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000091.png"
  },
  MLSUnited: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Information is deemed to be reliable but not guaranteed. Copyright \xA9 ${yearStr} MLS United, LLC.`;
    },
    logoURL: "http://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000070.png"
  },
  FMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Listings on this website come from the FMLS IDX Compilation and may be held by brokerage firms other than the owner of this website. The listing brokerage is identified in any listing details. Information is deemed reliable but is not guaranteed. If you believe any FMLS listing contains material that infringes your copyrighted work, please (https://www.fmls.com/dmca.htm) to review our DMCA policy and learn how to submit a takedown request. \xA9 ${yearStr} FMLS.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000175.png"
  },
  HeartlandMLS: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information submitted to the MLS GRID as of ${dateStr}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000270.gif"
  },
  GardenStateMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data displayed relating to real estate for sale comes in part from the IDX Program of Garden State Multiple Listing Service, L.L.C. Real estate listings held by other brokerage firms are marked as IDX Listing. This information is being provided for Consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties Consumers may be interested in purchasing. Notice: The dissemination of listings displayed herein does not constitute the consent required by N.J.A.C. 11:5.6.1 (n) for the advertisement of listings exclusively for sale by another broker. Any such consent must be obtained in writing from the listing broker. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} Garden State Multiple Listing Service, L.L.C. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000449.png"
  },
  NTREIS: {
    disclaimer: function() {
      return `The data relating to real estate for sale on this web site comes in part from the Broker Reciprocity Program of the NTREIS Multiple Listing Service. Real estate listings held by brokerage firms other than this broker are marked with the Broker Reciprocity logo and detailed information about them includes the name of the listing brokers.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000594.jpg"
  },
  MIBOR: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information submitted to the MLS GRID as of ${dateStr}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000255.png"
  },
  PalmBeachFL: {
    disclaimer: function() {
      return `IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000158.png"
  },
  PortlandOR: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this web site comes in part from the INTERNET DATA EXCHANGE Program of the Greater Las Vegas Association of REALTORS\xAE MLS. Real estate listings held by brokerage firms other than this site owner are marked with the IDX logo. Information is deemed reliable but not guaranteed. Copyright ${yearStr} of the Greater Las Vegas Association of REALTORS\xAE MLS. All rights reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000531.png"
  },
  MARIS: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information submitted to the MLS GRID as of ${dateStr}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "http://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000360.png"
  },
  NorthStarMLS: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information submitted to the MLS GRID as of ${dateStr}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "http://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000345.png"
  },
  NorthwestMLS: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information submitted to the MLS GRID as of ${dateStr}. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000650.jpg"
  },
  WestPenn: {
    disclaimer: function(listingData) {
      const brokerage = `Tom Hosack (BHHS Preferred Realty)`;
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `West Penn MLS, Inc. All information deemed reliable but not guaranteed. All properties are subject to prior sale, change or withdrawal. Neither listing broker(s) or information provider(s) shall be responsible for any typographical errors, misinformation, misprints and shall be held totally harmless. Listing(s) information is provided for consumer's personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. The data relating to real estate for sale on this website comes in part from the Internet Data Exchange program of the Multiple Listing Service. Real estate listings held by brokerage firms other than ${brokerage} may be marked with the Internet Data Exchange logo and detailed information about those properties will include the name of the listing broker(s) when required by the MLS. Copyright \xA9${yearStr} All rights reserved. Last Updated: ${dateStr}`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000549.png"
  },
  SmartMLS: {
    disclaimer: function() {
      return `IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed.

             The listing broker\u2019s offer of compensation is made only to participants of the MLS where the listing is filed.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000127.png"
  },
  CLAW: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The multiple listings information is provided by The MLS/CLAW from a copyrighted compilation of listings. The compilation of listings and each individual listing are \xA9 ${yearStr} The MLS/CLAW. All Rights Reserved. The information provided is for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. All properties are subject to prior sale or withdrawal. All information provided is deemed reliable but is not guaranteed accurate, and should be independently verified.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000071.png"
  },
  Beaches: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `All listings featuring the BMLS logo are provided by Beaches MLS, Inc. This information is not verified for authenticity or accuracy and is not guaranteed. Copyright ${yearStr} Beaches Multiple Listing Service, Inc. Information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing.

            The listing broker's offer of compensation is made to participants of BeachesMLS, where the listing is filed, as well as participants of MLSs participating in MLSAdvantage or a data share with BeachesMLS.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000170.png"
  },
  UtahRealEstate: {
    disclaimer: function(listingData) {
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Based on information from the Wasatch Front Regional Multiple Listing Service, Inc. as of ${dateStr}. All data, including all measurements and calculations of area, is obtained from various sources and has not been, and will not be, verified by broker or the MLS. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000628.jpg"
  },
  Realcomp: {
    disclaimer: function(listingData) {
      const brokerage = `Sabra Sanzotta (BHHS The Loft Warehouse)`;
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `IDX provided courtesy of Realcomp II Ltd. via ${brokerage} and Realcomp MLS, \xA9${yearStr} Realcomp II Ltd. Shareholders

            The accuracy of all information, regardless of source, is not guaranteed or warranted. All information should be independently verified. Any use of search facilities of data on the site, other than by a consumer looking to purchase real estate, is prohibited.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000316.png"
  },
  BridgeMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      const dateStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).toLocaleString("en-us") : "";
      return `Bay East \xA9${yearStr}. CCAR \xA9${yearStr}. bridgeMLS \xA9${yearStr}. Information Deemed Reliable But Not Guaranteed. This information is being provided by the Bay East MLS, or CCAR MLS, or bridgeMLS. The listings presented here may or may not be listed by the Broker/Agent operating this website. This information is intended for the personal use of consumers and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Data last updated at ${dateStr}.

            IDX information is provided exclusively for consumers\u2019 personal, non-commercial use and that it may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information deemed reliable but not guaranteed to be accurate. Listing information updated daily.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000057.jpg"
  },
  NEREN: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Copyright ${yearStr} New England Real Estate Network, Inc. All rights reserved.

             This information is deemed reliable, but not guaranteed.

             The data relating to real estate displayed on this web site comes in part from the IDX Program of NEREN. The information being provided is for consumers\u2019 personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000445.jpg"
  },
  StellarMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Listings courtesy of Stellar MLS as distributed by MLS GRID. Based on information submitted to the MLS GRID. All data is obtained from various sources and may not have been verified by broker or MLS GRID. Supplied Open House Information is subject to change without notice. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information. Listing information is provided for consumers? personal, non-commercial use, solely to identify prospective properties for potential purchase; all other use is strictly prohibited and may violate relevant federal and state law. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} MLS GRID. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000146.jpg"
  },
  Houston: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `Copyright ${yearStr}, Houston REALTORS\xAE Information Service, Inc. The information provided is exclusively for consumers\u2019 personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000599.jpg"
  },
  MLSNow: {
    disclaimer: function() {
      return "The data relating to real estate for sale on this website comes in part from the Internet Data Exchange program of MLS Now. Real estate listings are marked with the Internet Data Exchange logo and detailed information about them includes the name of the listing broker(s). Information Deemed Reliable But Not Guaranteed.";
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000830.png"
  },
  OneKey: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the Internet Data exchange of OneKey MLS. IDX information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} OneKey MLS. All Rights Reserved`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000489.png"
  },
  LasVegas: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the INTERNET DATA EXCHANGE Program of the Greater Las Vegas Association of REALTORS\xAE MLS. Real estate listings held by brokerage firms other than this site owner are marked with the IDX logo. information being provided is for the consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Any use of search facilities of data on the site, other than by a consumer looking to purchase real estate, is prohibited. GLVAR deems information reliable but not guaranteed. Copyright \xA9 ${yearStr} of the Greater Las Vegas Association of REALTORS\xAE MLS. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000466.png"
  },
  ARMLS: {
    disclaimer: function() {
      return "All information should be verified by the recipient and none is guaranteed as accurate by ARMLS.";
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000048.gif"
  },
  ArizonaRegional: {
    disclaimer: function() {
      return "All information should be verified by the recipient and none is guaranteed as accurate by ARMLS.";
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000048.gif"
  },
  SEF: {
    disclaimer: function() {
      return `Information deemed reliable but not guaranteed. Information is provided, in part, by Greater Miami MLS. This information being provided is for consumer's personal, non-commercial use and may not be used for any other purpose other than to identify prospective properties consumers may be interested in purchasing.

            This information being provided is for consumer's personal, non-commercial use and may not be used for any other purpose other than to identify prospective properties consumers may be interested in purchasing.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000151.jpg"
  },
  MLSPIN: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The property listing data and information, or the Images, set forth herein were provided to MLS Property Information Network, Inc. from third party sources, including sellers, lessors, landlords and public records, and were compiled by MLS Property Information Network, Inc. The property listing data and information, and the Images, are for the personal, non-commercial use of consumers having a good faith interest in purchasing, leasing or renting listed properties of the type displayed to them and may not be used for any purpose other than to identify prospective properties which such consumers may have a good faith interest in purchasing, leasing or renting. MLS Property Information Network, Inc. and its subscribers disclaim any and all representations and warranties as to the accuracy of the property listing data and information, or as to the accuracy of any of the Images, set forth herein. Copyright \xA9 ${yearStr} MLS Property Information Network, Inc. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000306.png"
  },
  MonmouthOceanMLS: {
    disclaimer: function() {
      return `IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000452.png"
  },
  BrevardMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the Internet Data exchange program of Brevard MLS. IDX information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} Brevard MLS. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000150.png"
  },
  RMLSA: {
    disclaimer: function(listingData) {
      return "IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed.";
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000852.png"
  },
  WyomingMLS: {
    disclaimer: function(listingData) {
      return "";
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000679.png"
  },
  CincyMLS: {
    disclaimer: function(listingData) {
      const brokerage = "Charlie Dean (Huff Realty)";
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the Broker Reciprocity programs of the MLS of Greater Cincinnati, Inc.. Those listings held by brokerage firms other than ${brokerage} are marked with the Broker Reciprocity logo and house icon. The properties displayed may not be all of the properties available through Broker Reciprocity. IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed. ${brokerage} does not display the entire Cincinnati MLS Broker Reciprocity\u2122 database on this web site. The listings of some real estate brokerage firms have been excluded. Copyright ${yearStr}, MLS of Greater Cincinnati, Inc. All rights reserved`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000494.png"
  },
  FGCMLS: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The information is being provided by Southwest Florida Multiple Listing Service. Information deemed reliable but not guaranteed. Information is provided for consumers' personal, non-commercial use, and may not be used for any purpose other than the identification of potential properties for purchase. Copyright ${yearStr} Southwest Florida Multiple Listing Service. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000130.png"
  },
  DesMoines: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the Internet Data Exchange of the Des Moines Area Association of REALTORS\xAE. IDX information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} Des Moines Area Association of REALTORS\xAE. All Rights Reserved.`;
    },
    logoURL: "http://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000204.png"
  },
  TriadMLS: {
    disclaimer: function(listingData) {
      return `IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable but not guaranteed. Properties marked with the Triad MLS, Inc. icon are provided courtesy of the Triad MLS, Inc.\u2019s, Internet Data Exchange Database.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000400.gif"
  },
  CentralPanhandle: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      return `The data relating to real estate for sale on this website comes in part from the Internet Data exchange program of Central Panhandle Association of REALTORS\xAE. IDX information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} Central Panhandle Association of REALTORS\xAE. All Rights Reserved.
            `;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000159.png"
  },
  EmeraldCoast: {
    disclaimer: function(listingData) {
      return `IDX information is provided exclusively for consumers' personal, non-commercial use, that it may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000138.png"
  },
  LexingtonKY: {
    disclaimer: function(listingData) {
      const yearStr = listingData.LastSyncDate ? new Date(listingData.LastSyncDate).getFullYear() : (/* @__PURE__ */ new Date()).getFullYear();
      const brokerage = `"William ""Sha""Fister (Rector Hayden Realtors)"`;
      return `The data relating to real estate for sale on this website comes in part from the Internet Data Exchange (IDX) Program of Bluegrass REALTORS\xAE. IDX information is provided exclusively for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Real estate listings held by IDX brokerage firms other than ${brokerage}, are marked with the IDX logo or the IDX thumbnail logo and detailed information about them includes the name of the listing IDX brokers. Information deemed reliable but not guaranteed. Copyright \xA9 ${yearStr} Bluegrass REALTORS\xAE. All Rights Reserved.`;
    },
    logoURL: "https://dm.constellationws.com/sitedata/constellationws/Documents/Public/IDX/Logo/M00000288.JPG"
  }
};

// src/qa/getQAFileTypeLabel.ts
var import_shared_utils115 = __toESM(require_lib(), 1);
var getQAFileTypeLabel = (0, import_shared_utils115.makeLookup)({
  cases: [
    ["reportPDF", "Report PDF"],
    ["orderDetailsPDF", "Order Details PDF"],
    ["loePDF", "Letter of Engagement PDF"],
    ["purchaseContractPDF", "Purchase Contract PDF"]
  ]
});

// src/randomUUID.ts
var import_shared_utils116 = __toESM(require_lib(), 1);
var fallbackRandomUUID = () => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => {
    return (parseInt(c) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> parseInt(c) / 4).toString(16);
  });
};
var randomUUID = () => (0, import_shared_utils116.isDefined)(crypto.randomUUID) ? crypto.randomUUID() : fallbackRandomUUID();

// src/propertyGrid/consts.ts
var PROPERTY_GRID_SUBJECT_PROPERTY = "subject";

// src/navigation/consts.ts
var FEEDBACK_URL = "mailto:support@appraisify.com";
var HELP_CENTER_URL = "https://knowledge.inspectify.com/toolkit";
var PRIVACY_POLICY_URL = "https://www.inspectify.com/company/privacy-policy";
var TERMS_OF_USE_URL = "https://www.inspectify.com/company/terms-of-use";
var ROUTE_ITEM_LABELS = {
  details: "Order",
  features: "Features",
  market: "Market",
  analysis: "Analysis",
  adjustments: "Adjustments",
  "adjustments-grid": "Sales Comparison",
  commentary: "Commentary",
  "appraisify-commentary": "Commentary",
  "craftsman-cost-approach": "Cost Approach",
  "paired-cost": "Depreciated Cost",
  reconciliation: "Reconciliation",
  studies: "Paired Sales"
};

// src/tkv2DepreciationAndSite/consts.ts
var defaultTkv2DepreciationSettings = {
  physicalDepreciationMode: "ageLifeMethod",
  depreciateImprovementsSeparately: false,
  defaultEconomicLifePerImprovement: {},
  functionalObsolescenceMode: "percent",
  externalObsolescenceMode: "percent"
};

// src/tkv2OrderFeatures/defaults.ts
var import_shared_utils117 = __toESM(require_lib(), 1);
var convertManufacturedQualityToSixTier = (quality, propertyType) => {
  if (propertyType !== "manufacturedHome")
    return quality;
  switch (quality) {
    case 1:
      return 4;
    case 2:
      return 5;
    default:
      return 6;
  }
};
var getDefaultStringifiedFeature = (feature, improvements) => {
  const propertyType = improvements?.propertyType;
  const dwellingQuality = improvements?.craftsmanQuality;
  const convertedQuality = (0, import_shared_utils117.orUndefined)(
    (n) => convertManufacturedQualityToSixTier(n, propertyType)
  )(dwellingQuality);
  const roundedQuality = (0, import_shared_utils117.orUndefined)((n) => Math.round(n).toString())(convertedQuality);
  const defaultAtticQuality = propertyType === "manufacturedHome" ? DEFAULT_ATTIC_QUALITY_MANUFACTURED : DEFAULT_ATTIC_QUALITY;
  const defaultParkingQuality = propertyType === "manufacturedHome" ? DEFAULT_PARKING_QUALITY_MANUFACTURED : DEFAULT_PARKING_QUALITY;
  switch (feature) {
    case "adu":
      return {
        hasFeature: true,
        area: DEFAULT_ADU_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: dwellingQuality?.toString() ?? DEFAULT_ADU_QUALITY.toString(),
        fullBaths: DEFAULT_ADU_FULL_BATHS.toString(),
        halfBaths: DEFAULT_ADU_HALF_BATHS.toString()
      };
    case "attic":
      return {
        hasFeature: true,
        area: DEFAULT_ATTIC_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: roundedQuality ?? defaultAtticQuality.toString()
      };
    case "barn":
      return {
        hasFeature: true,
        area: DEFAULT_BARN_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: DEFAULT_BARN_QUALITY.toString()
      };
    case "basement":
      return {
        hasFeature: true,
        finishedArea: DEFAULT_BASEMENT_FINISHED_SIZE_SQFT.toSqFtValueStringRounded(),
        totalArea: DEFAULT_BASEMENT_TOTAL_SIZE_SQFT.toSqFtValueStringRounded(),
        fullBaths: DEFAULT_BASEMENT_FULL_BATHS.toString(),
        halfBaths: DEFAULT_BASEMENT_HALF_BATHS.toString()
      };
    case "carport":
      return {
        hasFeature: true,
        area: DEFAULT_CARPORT_SIZE_SQFT.toSqFtValueStringRounded(),
        spaces: DEFAULT_CARPORT_SPACES.toString(),
        quality: roundedQuality ?? defaultParkingQuality.toString()
      };
    case "deck":
      return {
        hasFeature: true,
        type: DEFAULT_DECK_TYPE,
        area: DEFAULT_DECK_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: roundedQuality ?? DEFAULT_PORCH_PATIO_DECK_QUALITY.toString()
      };
    case "fireplace":
      return {
        hasFeature: true,
        type: DEFAULT_FIREPLACE_TYPE,
        count: DEFAULT_FIREPLACE_COUNT.toString()
      };
    case "garage":
      return {
        type: "attached",
        hasFeature: true,
        area: DEFAULT_GARAGE_SIZE_SQFT.toSqFtValueStringRounded(),
        spaces: DEFAULT_CARPORT_SPACES.toString(),
        quality: roundedQuality ?? defaultParkingQuality.toString()
      };
    case "detachedGarage":
      return {
        type: "detached",
        hasFeature: true,
        area: DEFAULT_GARAGE_SIZE_SQFT.toSqFtValueStringRounded(),
        spaces: DEFAULT_CARPORT_SPACES.toString(),
        quality: roundedQuality ?? defaultParkingQuality.toString()
      };
    case "patio":
      return {
        hasFeature: true,
        type: DEFAULT_PATIO_TYPE,
        area: DEFAULT_PATIO_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: roundedQuality ?? DEFAULT_PORCH_PATIO_DECK_QUALITY.toString()
      };
    case "pool":
      return {
        hasFeature: true,
        area: DEFAULT_POOL_AREA_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: DEFAULT_POOL_QUALITY.toString()
      };
    case "porch":
      return {
        hasFeature: true,
        type: DEFAULT_PORCH_TYPE,
        area: DEFAULT_PORCH_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: roundedQuality ?? DEFAULT_PORCH_TYPE.toString()
      };
    case "shed":
      return {
        hasFeature: true,
        area: DEFAULT_SHED_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: DEFAULT_SHED_QUALITY.toString()
      };
    case "spa":
      return {
        hasFeature: true,
        area: DEFAULT_SPA_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: DEFAULT_SPA_QUALITY.toString()
      };
    case "workshop":
      return {
        hasFeature: true,
        area: DEFAULT_WORKSHOP_SIZE_SQFT.toSqFtValueStringRounded(),
        quality: DEFAULT_WORKSHOP_QUALITY.toString()
      };
    case "manualCost":
    default:
      throw new Error(`Feature ${feature} does not have a default value`);
  }
};

// src/tkv2ReplacementCost/consts.ts
import { AloftArea as AloftArea41 } from "@aloft/shared-objects";
var defaultTkv2ReplacementCostSettings = {
  copyPrimaryDwellingQualityToOthers: true,
  uadQualityMapping: {
    q1: 8,
    q2: 7,
    q3: 6,
    q4: 5,
    q5: 3,
    q6: 2
  },
  garageCarportAreaPerStall: AloftArea41.fromNumber(220, "sqft")
};

// src/order/utils/formatAppraisalType.ts
var formatAppraisalType = (appraisalType) => {
  switch (appraisalType) {
    case "hybrid_appraisal":
      return "Hybrid Appraisal";
    case "desktop_appraisal":
      return "Desktop Appraisal";
    case "appraisal":
      return "Appraisal";
    case void 0:
      return "External";
    default:
      return appraisalType;
  }
};

// src/order/utils/formatRevisionType.ts
var formatRevisionType = (revisionType) => {
  switch (revisionType) {
    case "rov":
      return "ROV";
    case "revision":
      return "Revision";
    default:
      return revisionType;
  }
};
var formatLongRevisionType = (revisionType) => {
  switch (revisionType) {
    case "rov":
      return "Reconsideration of Value";
    case "revision":
      return "Revision";
    default:
      return revisionType;
  }
};
var export_AloftEnum = import_enum.AloftEnum;
var export_AloftEnumKeys = import_enum.AloftEnumKeys;
var export_applyIfNonEmptyString = import_shared_utils118.applyIfNonEmptyString;
var export_checkLength = import_shared_utils118.checkLength;
var export_checkMinLength = import_shared_utils118.checkMinLength;
var export_clamp = import_shared_utils118.clamp;
var export_enumerate = import_shared_utils118.enumerate;
var export_expected = import_shared_utils118.expected;
var export_hasDefinedValues = import_shared_utils118.hasDefinedValues;
var export_isArray = import_is4.isArray;
var export_isBoolean = import_is4.isBoolean;
var export_isDefined = import_shared_utils118.isDefined;
var export_isFunction = import_is4.isFunction;
var export_isNonEmptyString = import_shared_utils118.isNonEmptyString;
var export_isNull = import_is4.isNull;
var export_isNumber = import_is4.isNumber;
var export_isObject = import_is4.isObject;
var export_isString = import_is4.isString;
var export_isSymbol = import_is4.isSymbol;
var export_isUndefined = import_is4.isUndefined;
var export_linJitter = import_shared_utils118.linJitter;
var export_makeLookup = import_shared_utils118.makeLookup;
var export_noop = import_shared_utils118.noop;
var export_orUndefined = import_shared_utils118.orUndefined;
var export_populated = import_shared_utils118.populated;
var export_toPunctuatedPhoneFormat = import_shared_utils118.toPunctuatedPhoneFormat;
var export_toTitleCase = import_shared_utils118.toTitleCase;
var export_unreachable = import_shared_utils118.unreachable;
export {
  ACCOUNT_API,
  ADMIN_ACCOUNTS_API,
  ALERT_SECTION_LABELS,
  APPRAISIFY_ADDRESS,
  APPRAISIFY_NAME,
  AUTOFILL_PROPERTY_DATA_API,
  AdjustFeatures,
  AdjustTerms,
  AloftArea42 as AloftArea,
  AloftCount14 as AloftCount,
  AloftDate23 as AloftDate,
  export_AloftEnum as AloftEnum,
  export_AloftEnumKeys as AloftEnumKeys,
  AloftObject,
  AloftPrice70 as AloftPrice,
  AloftTime8 as AloftTime,
  AloftToolkitAccount_exports as AloftToolkitAccount,
  AloftToolkitBlob_exports as AloftToolkitBlob,
  AssertionError,
  BLOB_API,
  BLOB_METADATA_API,
  CANCEL_TKV2_ORDER_API,
  COMPLETE_TKV2_ORDERS_API,
  CONSTELLATION_ONE_KEYS,
  CraftsmanAdjustmentsCalcV1,
  DEFAULT_ADU_FULL_BATHS,
  DEFAULT_ADU_HALF_BATHS,
  DEFAULT_ADU_QUALITY,
  DEFAULT_ADU_SIZE_SQFT,
  DEFAULT_ATTIC_QUALITY,
  DEFAULT_ATTIC_QUALITY_MANUFACTURED,
  DEFAULT_ATTIC_SIZE_SQFT,
  DEFAULT_BARN_QUALITY,
  DEFAULT_BARN_SIZE_SQFT,
  DEFAULT_BASEMENT_FINISHED_SIZE_SQFT,
  DEFAULT_BASEMENT_FULL_BATHS,
  DEFAULT_BASEMENT_HALF_BATHS,
  DEFAULT_BASEMENT_TOTAL_SIZE_SQFT,
  DEFAULT_CARPORT_SIZE_SQFT,
  DEFAULT_CARPORT_SPACES,
  DEFAULT_CORNERS,
  DEFAULT_CRAFTSMAN_QUALITY,
  DEFAULT_CRAFTSMAN_QUALITY_MANUFACTURED,
  DEFAULT_CRAFTSMAN_QUALITY_MFR,
  DEFAULT_DECK_SIZE_SQFT,
  DEFAULT_DECK_TYPE,
  DEFAULT_ECONOMIC_LIFE,
  DEFAULT_ECONOMIC_LIFE_MANUFACTURED,
  DEFAULT_EFFECTIVE_AGE,
  DEFAULT_FIREPLACE_COUNT,
  DEFAULT_FIREPLACE_TYPE,
  DEFAULT_GARAGE_SIZE_SQFT,
  DEFAULT_GARAGE_SPACES,
  DEFAULT_MLS_SOURCE,
  DEFAULT_PARKING_QUALITY,
  DEFAULT_PARKING_QUALITY_MANUFACTURED,
  DEFAULT_PATIO_SIZE_SQFT,
  DEFAULT_PATIO_TYPE,
  DEFAULT_POOL_AREA_SIZE_SQFT,
  DEFAULT_POOL_QUALITY,
  DEFAULT_PORCH_PATIO_DECK_QUALITY,
  DEFAULT_PORCH_SIZE_SQFT,
  DEFAULT_PORCH_TYPE,
  DEFAULT_PUBLIC_RECORD_SOURCE,
  DEFAULT_SHED_QUALITY,
  DEFAULT_SHED_SIZE_SQFT,
  DEFAULT_SPACE_SIZE_SQFT,
  DEFAULT_SPA_QUALITY,
  DEFAULT_SPA_SIZE_SQFT,
  DEFAULT_WORKSHOP_QUALITY,
  DEFAULT_WORKSHOP_SIZE_SQFT,
  Decisions,
  EMPTY_COST_DATA_RESPONSE,
  EMPTY_EDITABLE_COST_DATA_INPUT,
  FEEDBACK_URL,
  FeatureFlagClient,
  FeatureFlagClientImpl,
  FeatureFlagClientNullImpl,
  FormType,
  HELP_CENTER_URL,
  IMAGE_ANALYSIS_API,
  INSPECTIFY_ORDER_API,
  LISTINGS_API,
  LISTINGS_POLYGON_API,
  LISTINGS_RADIUS_API,
  LISTING_BY_ADDRESS_API,
  ListingStatusOptions,
  ListingStatuses,
  MAGIC_QUOTA_EXCEEDED_STRING,
  MARKET_AGGREGATE_DATA_API,
  MCKISSOCK_TRIAL_PERIOD_DAYS,
  MLS,
  MLSAttributionMap,
  ORCHESTRATE_AUTOFILL_PROPERTY_API,
  ORDER_ATTACHMENT_CLONING_IGNORE_TYPES,
  ORDER_COST_DATA_API,
  ORDER_DEPRECIATION_SETTINGS_V2_API,
  ORDER_FEATURES,
  PAIRED_SALES_API,
  PAIRED_SALES_SINGLE_API,
  PREFILL_ORDER_API,
  PRIVACY_POLICY_URL,
  PROPERTY_COST_DATA_API,
  PROPERTY_GRID_SUBJECT_PROPERTY,
  PROPERTY_IMAGE_ANALYSIS_API,
  QA_ATTEMPTS,
  REQUEST_ID_HEADER,
  REQUEST_SESSION_ID_HEADER,
  RESCHEDULE_TKV2_ORDER_API,
  REVISION_API,
  ROUTE_ITEM_LABELS,
  STRIPE_API,
  STRIPE_BILLING_ADDRESS_API,
  STRIPE_PRICING_BREAKDOWN_API,
  STRIPE_SALES_TAX_API,
  STRIPE_SESSION_API,
  STRIPE_SUBSCRIPTION_API,
  STRIPE_VALIDATE_PROMOTION_CODE_API,
  SyntaxDecodeError,
  SyntaxEncodeError,
  SyntaxError,
  TERMS_OF_USE_URL,
  api_exports2 as TKV2_GEOCODING_API,
  TKV2_MLS_API,
  TKV2_ORDERS_API,
  TKV2_ORDER_API,
  api_exports as TKV2_ORDER_ATTACHMENT_API,
  TKV2_ORDER_DEPRECIATION_SETTINGS_API,
  TKV2_ORDER_PAIRED_COST_SETTINGS_API,
  TKV2_ORDER_REPLACEMENT_COST_SETTINGS_API,
  TKV2_PAIRED_COST_RUN_COST_API,
  TKV2_PUBLIC_RECORDS_API,
  TKV2_PUBLIC_RECORD_API,
  TKV2_STUDIES_API,
  TKV2_STUDY_API,
  TRAINING_ORDERS_API,
  TRAINING_ORDER_API,
  TRIAL_PERIOD_DAYS,
  Tkv2Property,
  ToolkitPropertyEnums,
  ToolkitPropertyRowMap,
  toolkitSchemas_exports as ToolkitSchemas,
  UNIQUE_ORDER_ATTACHMENT_TYPES,
  _schSubjectData,
  accountBodySchemaByVersion,
  addressToMultilineAddress,
  addressToString,
  adjustRateToString,
  adjustTermToFeature,
  allocatePairedCostProperties,
  export_applyIfNonEmptyString as applyIfNonEmptyString,
  assert,
  assertAllFinite,
  autofillProperty,
  blobIDToHash,
  export_checkLength as checkLength,
  export_checkMinLength as checkMinLength,
  export_clamp as clamp,
  combinedManualAdjustmentTypes,
  compareDwellingCostQuality,
  costDataInputToEditable,
  costDataResponseToDocument,
  createFeatureDecisions,
  defaultDepreciationSettingsV2,
  defaultEcoLifeFields,
  defaultTkv2DepreciationSettings,
  defaultTkv2PairedCostSettings,
  defaultTkv2ReplacementCostSettings,
  dropNaN,
  dwellingCostEnums,
  dynamicScalarToString,
  editableArvDataFromAllSources,
  editableCostDataToInput,
  editablePropertyDataFromAllSources,
  export_enumerate as enumerate,
  estimatedDemandSupplyOptions,
  estimatedExposureTimeOptions,
  expectToolkitListingID,
  expectToolkitRecordID,
  export_expected as expected,
  featureFlags,
  filterDwellingCostInput,
  filterType,
  format,
  formatAppraisalType,
  formatLongRevisionType,
  formatPropertyType,
  formatRevisionType,
  formatShortenedPropertyType,
  formatToolkitListingID,
  formatToolkitRecordID,
  ftuxMaxDictionary,
  ftuxMinDictionary,
  getAbbreviatedCarportGarage,
  getBathsString,
  getC1ContractDate,
  getC1FullBathroomCount,
  getC1HalfBathroomCount,
  getC1ListDate,
  getC1MonthFromDateString,
  getCraftsmanAdjustment,
  getCraftsmanAdjustmentCalcInternal,
  getCraftsmanCost,
  getCraftsmanCostDataset,
  getCraftsmanHistoricalCostIndex,
  getCraftsmanReplacementCostCalc,
  getDatasetForOrder,
  getDefaultCraftsmanQuality,
  getDefaultStringifiedFeature,
  getDisplayValueFunc,
  getFoundationDisplay,
  getListingLotSizeSqft,
  getLotAreaInSqft,
  getMLSNameBySource,
  getPairedCostResults,
  getPropertyTypeSet,
  getQAFileTypeLabel,
  getSiteDisplay,
  getStructuredData,
  getTermsOfSaleDisplay,
  getToolkitListingID,
  getToolkitPropertyFieldDisplay,
  getUADStatus,
  getZillowPriceHistory,
  getZipMultiplier,
  guid,
  export_hasDefinedValues as hasDefinedValues,
  hashToBlobID,
  identifyToolkitProperty,
  initialFTUXDictionary,
  isAdjustValue,
  export_isArray as isArray,
  isBlobID,
  export_isBoolean as isBoolean,
  isDateOfSaleMethod,
  isDecisionKey,
  export_isDefined as isDefined,
  isDynamicScalar,
  export_isFunction as isFunction,
  isListToSaleMethod,
  isMLSID,
  isMLSOUID,
  isMcKissockOfferType,
  export_isNonEmptyString as isNonEmptyString,
  export_isNull as isNull,
  export_isNumber as isNumber,
  export_isObject as isObject,
  isOrderAttachmentInstance,
  isOrderAttachmentType,
  export_isString as isString,
  export_isSymbol as isSymbol,
  isToolkitListingID,
  isToolkitRecordID,
  isTrainingModeEnabled,
  export_isUndefined as isUndefined,
  keepFinite,
  lens,
  export_linJitter as linJitter,
  listingStatusToUADStatus,
  mainPropertyTypeList,
  makeCustomMonthlyPriceTrends,
  export_makeLookup as makeLookup,
  manualAdjustmentKeys,
  mapValues,
  marketConditionsCommentaryFilterTypes,
  mean,
  median,
  mlsInfoByAbodeName,
  mlsInfoByConstellation1ID,
  mlsInfoByMLSID,
  mlsInfoByOUID,
  mlsInfoByShortName,
  mlsOUIDByAbodeMLSName,
  mlsOUIDByMLSID,
  nonDismissableAlertTypes,
  export_noop as noop,
  normalizeToStateAbbr,
  numberToScalar,
  export_orUndefined as orUndefined,
  orderIDPathParam,
  parseBlobID,
  parseCompToolkitRecordID,
  parseToolkitListingID,
  parseToolkitRecordID,
  export_populated as populated,
  propertyDataToSubjectData,
  propertyHasCustomManualAdjustments,
  randomUUID,
  recommendedCompsPropertyTypesList,
  roundTo,
  scalarNumberLens,
  scalarToNumber,
  schAbodeAggregateGeoType,
  schAbodeAggregateMarketConditions,
  schAccount,
  schAccountCreateRequest,
  schAccountEmail,
  schAccountGetResponse,
  schAccountPatchRequest,
  schAccountUpdateRequest,
  schActiveSubscription,
  schActiveTrial,
  schAdditionalFeature,
  schAdditionalFeatureType,
  schAddress,
  schAddressForm,
  schAdjDocAcrossTheBoard,
  schAdjDocAcrossTheBoardFormula,
  schAdjDocAnalysis,
  schAdjDocAnalysisFormula,
  schAdjDocAnalysisFormulaGrouped,
  schAdjDocAnalysisFormulaPaired,
  schAdjDocAnalysisFormulaPolynomial,
  schAdjDocAnalysisKey,
  schAdjDocCompTerm,
  schAdjDocCompTermFormula,
  schAdjDocComparable,
  schAdjDocGroupSpec,
  schAdjustFeatureOptions,
  schAdjustPairedSchema,
  schAdjustPolynomialSchema,
  schAdjustRate,
  schAdjustResult,
  schAdjustResultAbsolute,
  schAdjustResultPercent,
  schAdjustSchema,
  schAdjustTermKey,
  schAdjustValue,
  schAdjustmentsDocument,
  schAdu,
  schAduSelectedSources,
  schAlert,
  schAlertDeprecated,
  schAlertSection,
  schAlertStatus,
  schAlertType,
  schAlertsCommentary,
  schAllCompDataResponse,
  schAloftArea,
  schAloftCount,
  schAloftDate,
  schAloftPrice,
  schAloftTime,
  schAnalysisPeriod,
  schAppraiserLicense,
  schAttic,
  schAtticSelectedSources,
  schAutofillType,
  schBackendAccount,
  schBackupListingData,
  schBackupListingSelectedSources,
  schBasementFields,
  schBasementFieldsSelectedSources,
  schBasicStructure,
  schBathroomCosts,
  schBlobID,
  schCDAdu,
  schCDAttachedBuiltinGarage,
  schCDAttic,
  schCDBarn,
  schCDBasement,
  schCDBonusRoom,
  schCDCarport,
  schCDDetachedGarage,
  schCDDwelling,
  schCDEnclosedPatio,
  schCDFireplaceTypeEnum,
  schCDFoundationTypeEnum,
  schCDManufactured,
  schCDPool,
  schCDPrimaryDwelling,
  schCDShed,
  schCDWorkshop,
  schCalculateStripePricingBreakdownRequest,
  schCalculateStripePricingBreakdownResponse,
  schCalculateStripeSalesTaxRequest,
  schCalculateStripeSalesTaxResponse,
  schCombinedManualAdjustmentType,
  schCommentary,
  schCommentaryV2,
  schCompType,
  schComplexStructure,
  schCompsListingsSearchCriteria,
  schConstellationOneListing,
  schConvertTrialRequest,
  schCorners,
  schCostBackrefs,
  schCostDataInput,
  schCostDataOutput,
  schCoveredPatioOrGazebo,
  schCraftsmanAdjustmentsCalcVersion,
  schCraftsmanQuality,
  schCraftsmanReplacementCostCalcVersion,
  schCraftsmanSFRQualityClasses,
  schCreateAllTrainingOrdersResponse,
  schCreateCompDataRequest,
  schCreateOrderResponse,
  schCreateRevisionRequestBody,
  schCreateStripeCustomerSessionResponse,
  schCreateStripeSubscriptionRequest,
  schCreateStripeSubscriptionResponse,
  schDatasetSource,
  schDateOfSaleMethod,
  schDeck,
  schDepreciatedCostCommentary,
  schDepreciation,
  schDepreciationField,
  schDepreciationSettingsV2,
  schDepreciationSettingsV2JSON,
  schDwellingCostInput,
  schEditableArvDataSelectedSources,
  schEditableArvSubjectData,
  schEditableCDBasement,
  schEditableCDPrimaryDwelling,
  schEditableCostDataInputV1,
  schEditableCostDataInputV2,
  schEditableDataSelectedSources,
  schEditableManualCost,
  schEditablePropertyData,
  schEditableSubjectData,
  schEmptyString,
  schEstimatedDemandSupply,
  schEstimatedExposureTime,
  schFTUXes,
  schFilledAddress,
  schFilledAddressSelectedSources,
  schFinancingType,
  schFireplace,
  schFireplaceSelectedSources,
  schFireplaceTypes,
  schFiveTierQuality,
  schFiveTierQualityScale,
  schFormNumber,
  schFormNumberStringOnly,
  schGarage,
  schGarageSelectedSources,
  schGarageTypes,
  schGeoCoordinate,
  schGeoCoordinates,
  schGeoListings,
  schGeoListingsFilters,
  schGeoSearch,
  schGetCompsResponse,
  schHasFeatureAndArea,
  schHasFeatureAreaAndQuality,
  schHasFeatureAreaAndQualitySelectedSources,
  schHeatingAndCoolingType,
  schHoaFeeFrequency,
  schImageAnalysisListing,
  schImageAnalysisQuery,
  schImageAnalysisResultContent,
  schImprovementFeatures,
  schImprovements,
  schImprovementsSelectedSources,
  schInactiveSubscription,
  schInspectionData,
  schLatitudeLongitude,
  schLatitudeLongitudeSelectedSources,
  schListToSaleAdjustmentMethods,
  schListToSaleMethod,
  schListingByAddress,
  schListingSource,
  schListingsById,
  schListingsFiltersMatchCriteria,
  schListingsResult,
  schListingsSearchCriteria,
  schLookbackCutoffIsoString,
  schMLSApiResponse,
  schMLSID,
  schMLSOUID,
  schMLSSource,
  schMainPropertyType,
  schManualAdjustments,
  schManualAdjustmentsKey,
  schManualAdjustmentsSelectedSources,
  schManufacturedCraftsmanQuality,
  schManufacturedHomeFeatures,
  schManufacturedHomeFoundation,
  schManufacturedHomeFoundationDisplay,
  schMarketAdjustmentDocument,
  schMarketAdjustments,
  schMarketConditionsAdjustments,
  schMarketConditionsCachedState,
  schMarketConditionsCommentaryFilterType,
  schMarketConditionsV2Commentary,
  schMarketTrends,
  schMarketTrendsSeriesResult,
  schMatchCriteria,
  schMcKissockAccountData,
  schMcKissockOfferType,
  schMlsTxs,
  schMonthlyAbodeAggregate,
  schMultiFamilyCraftsmanQuality,
  schMultiFamilyFeatures,
  schNavigationAnchor,
  schOrderCostDataAttachment,
  schOrderCostDataDocument,
  schOrderFeature,
  schOrderFeatures,
  schOrderInput,
  schOrderOptions,
  schOrderRouteItem,
  schOrderVersion,
  schOtherSource,
  schPagination,
  schPair,
  schPairedCostAdjustmentType,
  schPairedCostRouteItem,
  schPairedCostRouteItemWithQuery,
  schPairedCostSettingsJSON,
  schPairedSalesAnalysisFeature,
  schPairedSalesBody,
  schPairedSalesCreateRequest,
  schPairedSalesCustomAnalysisFeature,
  schPairedSalesInput,
  schPairedSalesListResponse,
  schPairedSalesOutput,
  schPairedSalesStudy,
  schPairedSalesUpdateRequest,
  schParkingFields,
  schParkingFieldsSelectedSources,
  schPorchPatioDeck,
  schPorchPatioDeckSelectedSources,
  schPorchPatioDeckSubtypes,
  schPositiveInt,
  schPostCompsBody,
  schPostCompsResponse,
  schPostXMLAttachmentBody,
  schPostXMLAttachmentResponse,
  schPriceHistory,
  schPriorSales,
  schPriorSalesCommentary,
  schPriorSalesEntities,
  schPropertyCostDataDocument,
  schPropertyCostDataDocumentV2,
  schPropertyCostDataResponse,
  schPropertyData,
  schPropertyDataWithOptionalReadonly,
  schPropertyDetailsAdvanced,
  schPropertyIdentification,
  schPropertyIdentificationSelectedSources,
  schPropertyInterest,
  schPropertyTypes,
  schPublicRecordSource,
  schQueryParams,
  schRESOListingSelectedSources,
  schRESOMedia,
  schReadOnlyData,
  schReadonlyDataSelectedSources,
  schRecommendedCompsFilters,
  schRecommendedCompsPropertyTypes,
  schRecommendedCompsStatistics,
  schReconciledValue,
  schReconciliation,
  schReconciliationCommentary,
  schReportSoftware,
  schRevisionData,
  schRevisionDataRequestBody,
  schRevisionType,
  schRouteItem,
  schSalesCompGridData,
  schSalesCompGridEncoding,
  schSavedMatchCriteriaItem,
  schSavedPairCriteria,
  schSegmentType,
  schSelectedPairs,
  schSelectedSource,
  schSelectedSources,
  schSingleFamilyCraftsmanQuality,
  schSingleFamilyResidenceFeatures,
  schSite,
  schSiteExtractionCommentary,
  schSiteInfluence,
  schSiteRating,
  schSiteSelectedSources,
  schSiteView,
  schSixTierQuality,
  schSixTierQualityScale,
  schSourceType,
  schStateCode,
  schStructureCostData,
  schStructureInput,
  schStructureType,
  schStructuredProperty,
  schStructuredPropertyFields,
  schStudiesPairAdjustmentsKey,
  schStudiesSearch,
  schStudyCostDataResponseV2,
  schStudyCostDataResults,
  schStudyMarketAdjustmentAttachment,
  schSubjectData,
  schSubscriptionResponse,
  schTermsOfSale,
  schThreeTierQuality,
  schThreeTierQualityScale,
  schTkV2PriorSales,
  schTkv2DepreciationKey,
  schTkv2DepreciationSettings,
  schTkv2OrderAttachment,
  schTkv2OrderAttachmentInstance,
  schTkv2OrderListResponse,
  schTkv2OrderPutRequestBody,
  schTkv2OrderStudyEdge,
  schTkv2OrderStudyEdgeGetRequest,
  schTkv2OrderStudyEdgeListRequest,
  schTkv2OrderStudyMetadata,
  schTkv2PairedCostSettings,
  schTkv2PairedCostStudyContent,
  schTkv2PairedCostStudyScratch,
  schTkv2PostOrderInput,
  schTkv2Property,
  schTkv2PublicRecord,
  schTkv2ReplacementCostSettings,
  schTkv2Study,
  schTkv2StudyAttachment,
  schTkv2StudyAttachmentBody,
  schTkv2StudyAttachmentInfo,
  schTkv2StudyAttachmentType,
  schTkv2StudyContent,
  schTkv2StudyGetRequest,
  schTkv2StudyInput,
  schTkv2StudyListResponse,
  schTkv2StudyOutput,
  schTkv2StudyPostRequestBody,
  schTkv2StudyPutRequestBody,
  schTkv2StudyScratch,
  schTkv2StudyType,
  schTkv2Version,
  schToolkitAccountID,
  schToolkitListingID2 as schToolkitListingID,
  schToolkitOrder,
  schToolkitOrderID,
  schToolkitProperty,
  schToolkitPropertyEnum,
  schToolkitProperty_,
  schToolkitRecordID2 as schToolkitRecordID,
  schToolkitStudyID,
  schToolkitStudyV1,
  schTransaction,
  schTransactionSelectedSources,
  schUSPhoneNumber,
  schUad2022Adjustments,
  schUad2022Annotations,
  schUniqueOrderAttachmentType,
  schUpdateStripeBillingAddressRequest,
  schUpdateStripeBillingAddressResponse,
  schUserDefinedRoles,
  schUserType,
  schValidatePromotionCodeRequest,
  schValidatePromotionCodeResponse,
  schXMLPropertyResult,
  schZillowListing,
  schZillowPropertySearchResponse,
  schZillowSearchResponse,
  schZipCode,
  schZoningCompliance,
  segmentToStructure,
  stringToAddress,
  fnma_exports as syntaxFNMA,
  termsOfSaleOptions,
  tkv2OrderAttachmentSchemas,
  toPercentString,
  export_toPunctuatedPhoneFormat as toPunctuatedPhoneFormat,
  export_toTitleCase as toTitleCase,
  toUADListingStatus,
  toolkitPropertyRunnerFactory,
  export_unreachable as unreachable,
  userDefinedRoleToLabel,
  validateCostDataDocuments,
  validateCostDataDocumentsV2,
  zodLaunder
};
//# sourceMappingURL=index.js.map
